
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb6bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb6bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8S27K", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $675503a822348589$export$ffb0004e005737fa, (v) => $675503a822348589$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $675503a822348589$export$34b9dba7ce09269b, (v) => $675503a822348589$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $675503a822348589$export$25062201e9e25d76, (v) => $675503a822348589$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $675503a822348589$export$ffb0004e005737fa;
var $675503a822348589$export$34b9dba7ce09269b;
var $675503a822348589$export$25062201e9e25d76;
"use strict";
var $675503a822348589$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $675503a822348589$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $675503a822348589$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $675503a822348589$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$675503a822348589$export$ffb0004e005737fa = $675503a822348589$var$REACT_FRAGMENT_TYPE;
$675503a822348589$export$34b9dba7ce09269b = $675503a822348589$var$jsxProd;
$675503a822348589$export$25062201e9e25d76 = $675503a822348589$var$jsxProd;

});

parcelRegister("dhyFm", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $9ab7c0d6abf66295$export$9c16c1426311996d, (v) => $9ab7c0d6abf66295$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $9ab7c0d6abf66295$export$dca3b0875bd9a954, (v) => $9ab7c0d6abf66295$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $9ab7c0d6abf66295$export$16fa2f45be04daa8, (v) => $9ab7c0d6abf66295$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $9ab7c0d6abf66295$export$ffb0004e005737fa, (v) => $9ab7c0d6abf66295$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $9ab7c0d6abf66295$export$e2c29f18771995cb, (v) => $9ab7c0d6abf66295$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $9ab7c0d6abf66295$export$221d75b3f55bb0bd, (v) => $9ab7c0d6abf66295$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $9ab7c0d6abf66295$export$5f8d39834fd61797, (v) => $9ab7c0d6abf66295$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9ab7c0d6abf66295$export$74bf444e3cd11ea5, (v) => $9ab7c0d6abf66295$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $9ab7c0d6abf66295$export$8cdaa4703948c5e9, (v) => $9ab7c0d6abf66295$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $9ab7c0d6abf66295$export$1ced07cd6b1985ce, (v) => $9ab7c0d6abf66295$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $9ab7c0d6abf66295$export$abd8e32b826d7ea7, (v) => $9ab7c0d6abf66295$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $9ab7c0d6abf66295$export$87c99536b1b8cdd8, (v) => $9ab7c0d6abf66295$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $9ab7c0d6abf66295$export$69a3209f1a06c04d, (v) => $9ab7c0d6abf66295$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $9ab7c0d6abf66295$export$8c538325882c7eec, (v) => $9ab7c0d6abf66295$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $9ab7c0d6abf66295$export$e530037191fcd5d7, (v) => $9ab7c0d6abf66295$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $9ab7c0d6abf66295$export$fd42f52fd3ae1109, (v) => $9ab7c0d6abf66295$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $9ab7c0d6abf66295$export$c8a8987d4410bf2d, (v) => $9ab7c0d6abf66295$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $9ab7c0d6abf66295$export$7d1e3a5e95ceca43, (v) => $9ab7c0d6abf66295$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $9ab7c0d6abf66295$export$257a8862b851cb5b, (v) => $9ab7c0d6abf66295$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $9ab7c0d6abf66295$export$a8257692ac88316c, (v) => $9ab7c0d6abf66295$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $9ab7c0d6abf66295$export$488013bae63b21da, (v) => $9ab7c0d6abf66295$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $9ab7c0d6abf66295$export$7c73462e0d25e514, (v) => $9ab7c0d6abf66295$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $9ab7c0d6abf66295$export$7568632d0d33d16d, (v) => $9ab7c0d6abf66295$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8, (v) => $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $9ab7c0d6abf66295$export$1f96ae73734a86cc, (v) => $9ab7c0d6abf66295$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $9ab7c0d6abf66295$export$9a47ced3238df325, (v) => $9ab7c0d6abf66295$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $9ab7c0d6abf66295$export$35808ee640e87ca7, (v) => $9ab7c0d6abf66295$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $9ab7c0d6abf66295$export$fae74005e78b1a27, (v) => $9ab7c0d6abf66295$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e, (v) => $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $9ab7c0d6abf66295$export$6a7bc4e911dc01cf, (v) => $9ab7c0d6abf66295$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $9ab7c0d6abf66295$export$6d9c69b0de29b591, (v) => $9ab7c0d6abf66295$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $9ab7c0d6abf66295$export$7f54fc3180508a52, (v) => $9ab7c0d6abf66295$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $9ab7c0d6abf66295$export$f680877a34711e37, (v) => $9ab7c0d6abf66295$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $9ab7c0d6abf66295$export$d5a552a76deda3c2, (v) => $9ab7c0d6abf66295$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $9ab7c0d6abf66295$export$aaabe4eda9ed9969, (v) => $9ab7c0d6abf66295$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $9ab7c0d6abf66295$export$e5c5a5f917a5871c, (v) => $9ab7c0d6abf66295$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $9ab7c0d6abf66295$export$1538c33de8887b59, (v) => $9ab7c0d6abf66295$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $9ab7c0d6abf66295$export$fca7f784ae7a249a, (v) => $9ab7c0d6abf66295$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $9ab7c0d6abf66295$export$13e3392192263954, (v) => $9ab7c0d6abf66295$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $9ab7c0d6abf66295$export$b8f5890fc79d6aca, (v) => $9ab7c0d6abf66295$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $9ab7c0d6abf66295$export$60241385465d0a34, (v) => $9ab7c0d6abf66295$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $9ab7c0d6abf66295$export$306c0aa65ff9ec16, (v) => $9ab7c0d6abf66295$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $9ab7c0d6abf66295$export$7b286972b8d8ccbf, (v) => $9ab7c0d6abf66295$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $9ab7c0d6abf66295$export$83d89fbfd8236492, (v) => $9ab7c0d6abf66295$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9ab7c0d6abf66295$export$9c16c1426311996d;
var $9ab7c0d6abf66295$export$dca3b0875bd9a954;
var $9ab7c0d6abf66295$export$16fa2f45be04daa8;
var $9ab7c0d6abf66295$export$ffb0004e005737fa;
var $9ab7c0d6abf66295$export$e2c29f18771995cb;
var $9ab7c0d6abf66295$export$221d75b3f55bb0bd;
var $9ab7c0d6abf66295$export$5f8d39834fd61797;
var $9ab7c0d6abf66295$export$74bf444e3cd11ea5;
var $9ab7c0d6abf66295$export$8cdaa4703948c5e9;
var $9ab7c0d6abf66295$export$1ced07cd6b1985ce;
var $9ab7c0d6abf66295$export$abd8e32b826d7ea7;
var $9ab7c0d6abf66295$export$87c99536b1b8cdd8;
var $9ab7c0d6abf66295$export$69a3209f1a06c04d;
var $9ab7c0d6abf66295$export$8c538325882c7eec;
var $9ab7c0d6abf66295$export$e530037191fcd5d7;
var $9ab7c0d6abf66295$export$fd42f52fd3ae1109;
var $9ab7c0d6abf66295$export$c8a8987d4410bf2d;
var $9ab7c0d6abf66295$export$7d1e3a5e95ceca43;
var $9ab7c0d6abf66295$export$257a8862b851cb5b;
var $9ab7c0d6abf66295$export$a8257692ac88316c;
var $9ab7c0d6abf66295$export$488013bae63b21da;
var $9ab7c0d6abf66295$export$7c73462e0d25e514;
var $9ab7c0d6abf66295$export$7568632d0d33d16d;
var $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8;
var $9ab7c0d6abf66295$export$1f96ae73734a86cc;
var $9ab7c0d6abf66295$export$9a47ced3238df325;
var $9ab7c0d6abf66295$export$35808ee640e87ca7;
var $9ab7c0d6abf66295$export$fae74005e78b1a27;
var $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e;
var $9ab7c0d6abf66295$export$6a7bc4e911dc01cf;
var $9ab7c0d6abf66295$export$6d9c69b0de29b591;
var $9ab7c0d6abf66295$export$7f54fc3180508a52;
var $9ab7c0d6abf66295$export$f680877a34711e37;
var $9ab7c0d6abf66295$export$d5a552a76deda3c2;
var $9ab7c0d6abf66295$export$aaabe4eda9ed9969;
var $9ab7c0d6abf66295$export$e5c5a5f917a5871c;
var $9ab7c0d6abf66295$export$1538c33de8887b59;
var $9ab7c0d6abf66295$export$fca7f784ae7a249a;
var $9ab7c0d6abf66295$export$13e3392192263954;
var $9ab7c0d6abf66295$export$b8f5890fc79d6aca;
var $9ab7c0d6abf66295$export$60241385465d0a34;
var $9ab7c0d6abf66295$export$306c0aa65ff9ec16;
var $9ab7c0d6abf66295$export$7b286972b8d8ccbf;
var $9ab7c0d6abf66295$export$83d89fbfd8236492;
"use strict";
var $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9ab7c0d6abf66295$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $9ab7c0d6abf66295$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $9ab7c0d6abf66295$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $9ab7c0d6abf66295$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $9ab7c0d6abf66295$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $9ab7c0d6abf66295$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $9ab7c0d6abf66295$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $9ab7c0d6abf66295$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $9ab7c0d6abf66295$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $9ab7c0d6abf66295$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $9ab7c0d6abf66295$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $9ab7c0d6abf66295$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $9ab7c0d6abf66295$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $9ab7c0d6abf66295$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9ab7c0d6abf66295$var$assign = Object.assign, $9ab7c0d6abf66295$var$emptyObject = {};
function $9ab7c0d6abf66295$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9ab7c0d6abf66295$var$emptyObject;
    this.updater = updater || $9ab7c0d6abf66295$var$ReactNoopUpdateQueue;
}
$9ab7c0d6abf66295$var$Component.prototype.isReactComponent = {};
$9ab7c0d6abf66295$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$9ab7c0d6abf66295$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $9ab7c0d6abf66295$var$ComponentDummy() {}
$9ab7c0d6abf66295$var$ComponentDummy.prototype = $9ab7c0d6abf66295$var$Component.prototype;
function $9ab7c0d6abf66295$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9ab7c0d6abf66295$var$emptyObject;
    this.updater = updater || $9ab7c0d6abf66295$var$ReactNoopUpdateQueue;
}
var $9ab7c0d6abf66295$var$pureComponentPrototype = $9ab7c0d6abf66295$var$PureComponent.prototype = new $9ab7c0d6abf66295$var$ComponentDummy();
$9ab7c0d6abf66295$var$pureComponentPrototype.constructor = $9ab7c0d6abf66295$var$PureComponent;
$9ab7c0d6abf66295$var$assign($9ab7c0d6abf66295$var$pureComponentPrototype, $9ab7c0d6abf66295$var$Component.prototype);
$9ab7c0d6abf66295$var$pureComponentPrototype.isPureReactComponent = !0;
var $9ab7c0d6abf66295$var$isArrayImpl = Array.isArray;
function $9ab7c0d6abf66295$var$noop() {}
var $9ab7c0d6abf66295$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $9ab7c0d6abf66295$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9ab7c0d6abf66295$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $9ab7c0d6abf66295$var$cloneAndReplaceKey(oldElement, newKey) {
    return $9ab7c0d6abf66295$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $9ab7c0d6abf66295$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE;
}
function $9ab7c0d6abf66295$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex = /\/+/g;
function $9ab7c0d6abf66295$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $9ab7c0d6abf66295$var$escape("" + element.key) : index.toString(36);
}
function $9ab7c0d6abf66295$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($9ab7c0d6abf66295$var$noop, $9ab7c0d6abf66295$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $9ab7c0d6abf66295$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE:
                case $9ab7c0d6abf66295$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $9ab7c0d6abf66295$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $9ab7c0d6abf66295$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $9ab7c0d6abf66295$var$getElementKey(children, 0) : nameSoFar, $9ab7c0d6abf66295$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $9ab7c0d6abf66295$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($9ab7c0d6abf66295$var$isValidElement(callback) && (callback = $9ab7c0d6abf66295$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($9ab7c0d6abf66295$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $9ab7c0d6abf66295$var$getElementKey(nameSoFar, i), invokeCallback += $9ab7c0d6abf66295$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $9ab7c0d6abf66295$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $9ab7c0d6abf66295$var$getElementKey(nameSoFar, i++), invokeCallback += $9ab7c0d6abf66295$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $9ab7c0d6abf66295$var$mapIntoArray($9ab7c0d6abf66295$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $9ab7c0d6abf66295$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $9ab7c0d6abf66295$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $9ab7c0d6abf66295$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $9ab7c0d6abf66295$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $9ab7c0d6abf66295$var$startTransition(scope) {
    var prevTransition = $9ab7c0d6abf66295$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $9ab7c0d6abf66295$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $9ab7c0d6abf66295$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($9ab7c0d6abf66295$var$noop, $9ab7c0d6abf66295$var$reportGlobalError);
    } catch (error) {
        $9ab7c0d6abf66295$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $9ab7c0d6abf66295$var$ReactSharedInternals.T = prevTransition;
    }
}
function $9ab7c0d6abf66295$var$addTransitionType(type) {
    var transition = $9ab7c0d6abf66295$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $9ab7c0d6abf66295$var$startTransition($9ab7c0d6abf66295$var$addTransitionType.bind(null, type));
}
var $9ab7c0d6abf66295$var$Children = {
    map: $9ab7c0d6abf66295$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $9ab7c0d6abf66295$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $9ab7c0d6abf66295$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $9ab7c0d6abf66295$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$9ab7c0d6abf66295$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$9ab7c0d6abf66295$export$9c16c1426311996d = $9ab7c0d6abf66295$var$REACT_ACTIVITY_TYPE;
$9ab7c0d6abf66295$export$dca3b0875bd9a954 = $9ab7c0d6abf66295$var$Children;
$9ab7c0d6abf66295$export$16fa2f45be04daa8 = $9ab7c0d6abf66295$var$Component;
$9ab7c0d6abf66295$export$ffb0004e005737fa = $9ab7c0d6abf66295$var$REACT_FRAGMENT_TYPE;
$9ab7c0d6abf66295$export$e2c29f18771995cb = $9ab7c0d6abf66295$var$REACT_PROFILER_TYPE;
$9ab7c0d6abf66295$export$221d75b3f55bb0bd = $9ab7c0d6abf66295$var$PureComponent;
$9ab7c0d6abf66295$export$5f8d39834fd61797 = $9ab7c0d6abf66295$var$REACT_STRICT_MODE_TYPE;
$9ab7c0d6abf66295$export$74bf444e3cd11ea5 = $9ab7c0d6abf66295$var$REACT_SUSPENSE_TYPE;
$9ab7c0d6abf66295$export$8cdaa4703948c5e9 = $9ab7c0d6abf66295$var$REACT_VIEW_TRANSITION_TYPE;
$9ab7c0d6abf66295$export$1ced07cd6b1985ce = $9ab7c0d6abf66295$var$ReactSharedInternals;
$9ab7c0d6abf66295$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$9ab7c0d6abf66295$export$87c99536b1b8cdd8 = $9ab7c0d6abf66295$var$addTransitionType;
$9ab7c0d6abf66295$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$9ab7c0d6abf66295$export$8c538325882c7eec = function() {
    return null;
};
$9ab7c0d6abf66295$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $9ab7c0d6abf66295$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$9ab7c0d6abf66295$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $9ab7c0d6abf66295$var$ReactElement(element.type, key, props);
};
$9ab7c0d6abf66295$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $9ab7c0d6abf66295$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $9ab7c0d6abf66295$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$9ab7c0d6abf66295$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$9ab7c0d6abf66295$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $9ab7c0d6abf66295$var$ReactElement(type, key, props);
};
$9ab7c0d6abf66295$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9ab7c0d6abf66295$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$9ab7c0d6abf66295$export$a8257692ac88316c = $9ab7c0d6abf66295$var$isValidElement;
$9ab7c0d6abf66295$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $9ab7c0d6abf66295$var$lazyInitializer
    };
};
$9ab7c0d6abf66295$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$9ab7c0d6abf66295$export$7568632d0d33d16d = $9ab7c0d6abf66295$var$startTransition;
$9ab7c0d6abf66295$export$f93f40ac0ca7e3a8 = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useCacheRefresh();
};
$9ab7c0d6abf66295$export$1f96ae73734a86cc = function(usable) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.use(usable);
};
$9ab7c0d6abf66295$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$9ab7c0d6abf66295$export$35808ee640e87ca7 = function(callback, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$9ab7c0d6abf66295$export$fae74005e78b1a27 = function(Context) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useContext(Context);
};
$9ab7c0d6abf66295$export$dc8fbce3eb94dc1e = function() {};
$9ab7c0d6abf66295$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$9ab7c0d6abf66295$export$6d9c69b0de29b591 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useEffect(create, deps);
};
$9ab7c0d6abf66295$export$7f54fc3180508a52 = function(callback) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$9ab7c0d6abf66295$export$f680877a34711e37 = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useId();
};
$9ab7c0d6abf66295$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$9ab7c0d6abf66295$export$aaabe4eda9ed9969 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$9ab7c0d6abf66295$export$e5c5a5f917a5871c = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$9ab7c0d6abf66295$export$1538c33de8887b59 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useMemo(create, deps);
};
$9ab7c0d6abf66295$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$9ab7c0d6abf66295$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$9ab7c0d6abf66295$export$b8f5890fc79d6aca = function(initialValue) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useRef(initialValue);
};
$9ab7c0d6abf66295$export$60241385465d0a34 = function(initialState) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useState(initialState);
};
$9ab7c0d6abf66295$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$9ab7c0d6abf66295$export$7b286972b8d8ccbf = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useTransition();
};
$9ab7c0d6abf66295$export$83d89fbfd8236492 = "19.3.1";

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("eVkyY", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $add656f78f0d744b$export$69ce8ef3fe5cead0, (v) => $add656f78f0d744b$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $add656f78f0d744b$export$3f2684e5d7cb1006, (v) => $add656f78f0d744b$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $add656f78f0d744b$export$d39a5bbd09211389, (v) => $add656f78f0d744b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $add656f78f0d744b$export$cd75ccfd720a3cd4, (v) => $add656f78f0d744b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $add656f78f0d744b$export$a0816fa17a9e79be, (v) => $add656f78f0d744b$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $add656f78f0d744b$export$7292efcadded39f3, (v) => $add656f78f0d744b$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $add656f78f0d744b$export$da407abadb9b8f86, (v) => $add656f78f0d744b$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $add656f78f0d744b$export$314cfea32580671c, (v) => $add656f78f0d744b$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $add656f78f0d744b$export$513ccb98c53b8039, (v) => $add656f78f0d744b$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $add656f78f0d744b$export$dbca993bc2d264a, (v) => $add656f78f0d744b$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $add656f78f0d744b$export$4797a8006f0655d0, (v) => $add656f78f0d744b$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $add656f78f0d744b$export$c78a37762a8d58e1, (v) => $add656f78f0d744b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $add656f78f0d744b$export$606f11b2eb45ecc6, (v) => $add656f78f0d744b$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $add656f78f0d744b$export$f7e8a0bf92324b1e, (v) => $add656f78f0d744b$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $add656f78f0d744b$export$83d89fbfd8236492, (v) => $add656f78f0d744b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $add656f78f0d744b$export$69ce8ef3fe5cead0;
var $add656f78f0d744b$export$3f2684e5d7cb1006;
var $add656f78f0d744b$export$d39a5bbd09211389;
var $add656f78f0d744b$export$cd75ccfd720a3cd4;
var $add656f78f0d744b$export$a0816fa17a9e79be;
var $add656f78f0d744b$export$7292efcadded39f3;
var $add656f78f0d744b$export$da407abadb9b8f86;
var $add656f78f0d744b$export$314cfea32580671c;
var $add656f78f0d744b$export$513ccb98c53b8039;
var $add656f78f0d744b$export$dbca993bc2d264a;
var $add656f78f0d744b$export$4797a8006f0655d0;
var $add656f78f0d744b$export$c78a37762a8d58e1;
var $add656f78f0d744b$export$606f11b2eb45ecc6;
var $add656f78f0d744b$export$f7e8a0bf92324b1e;
var $add656f78f0d744b$export$83d89fbfd8236492;
"use strict";

var $5E6i4 = parcelRequire("5E6i4");
function $add656f78f0d744b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $add656f78f0d744b$var$noop() {}
var $add656f78f0d744b$var$Internals = {
    d: {
        f: $add656f78f0d744b$var$noop,
        r: function() {
            throw Error($add656f78f0d744b$var$formatProdErrorMessage(522));
        },
        D: $add656f78f0d744b$var$noop,
        C: $add656f78f0d744b$var$noop,
        L: $add656f78f0d744b$var$noop,
        m: $add656f78f0d744b$var$noop,
        X: $add656f78f0d744b$var$noop,
        S: $add656f78f0d744b$var$noop,
        M: $add656f78f0d744b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $add656f78f0d744b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $add656f78f0d744b$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $add656f78f0d744b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $add656f78f0d744b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY ? $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $add656f78f0d744b$var$ReactSharedInternals = $5E6i4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $add656f78f0d744b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$add656f78f0d744b$export$69ce8ef3fe5cead0 = $add656f78f0d744b$var$Internals;
$add656f78f0d744b$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $add656f78f0d744b$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$add656f78f0d744b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($add656f78f0d744b$var$formatProdErrorMessage(299));
    return $add656f78f0d744b$var$createPortal$1(children, container, null, key);
};
$add656f78f0d744b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $add656f78f0d744b$var$ReactSharedInternals.T, previousUpdatePriority = $add656f78f0d744b$var$Internals.p;
    try {
        if ($add656f78f0d744b$var$ReactSharedInternals.T = null, $add656f78f0d744b$var$Internals.p = 2, fn) return fn();
    } finally{
        $add656f78f0d744b$var$ReactSharedInternals.T = previousTransition, $add656f78f0d744b$var$Internals.p = previousUpdatePriority, $add656f78f0d744b$var$Internals.d.f();
    }
};
$add656f78f0d744b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $add656f78f0d744b$var$Internals.d.C(href, options));
};
$add656f78f0d744b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $add656f78f0d744b$var$Internals.d.D(href);
};
$add656f78f0d744b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $add656f78f0d744b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $add656f78f0d744b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$add656f78f0d744b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $add656f78f0d744b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $add656f78f0d744b$var$Internals.d.M(href);
    }
};
$add656f78f0d744b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $add656f78f0d744b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$add656f78f0d744b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $add656f78f0d744b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $add656f78f0d744b$var$Internals.d.m(href);
    }
};
$add656f78f0d744b$export$4797a8006f0655d0 = function(form) {
    $add656f78f0d744b$var$Internals.d.r(form);
};
$add656f78f0d744b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$add656f78f0d744b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $add656f78f0d744b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$add656f78f0d744b$export$f7e8a0bf92324b1e = function() {
    return $add656f78f0d744b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$add656f78f0d744b$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("5E6i4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dhyFm"));

});


parcelRegister("03XiP", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $00be48392311af6a$export$882461b6382ed46c, (v) => $00be48392311af6a$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $00be48392311af6a$export$757ceba2d55c277e, (v) => $00be48392311af6a$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $00be48392311af6a$export$83d89fbfd8236492, (v) => $00be48392311af6a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $00be48392311af6a$export$882461b6382ed46c;
var $00be48392311af6a$export$757ceba2d55c277e;
var $00be48392311af6a$export$83d89fbfd8236492;
"use strict";

var $6XCI2 = parcelRequire("6XCI2");

var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
function $00be48392311af6a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $00be48392311af6a$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $00be48392311af6a$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $00be48392311af6a$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $00be48392311af6a$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $00be48392311af6a$var$assertIsMounted(fiber) {
    if ($00be48392311af6a$var$getNearestMountedFiber(fiber) !== fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
}
function $00be48392311af6a$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $00be48392311af6a$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $00be48392311af6a$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $00be48392311af6a$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($00be48392311af6a$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($00be48392311af6a$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $00be48392311af6a$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $00be48392311af6a$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $00be48392311af6a$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $00be48392311af6a$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(559));
    }
}
var $00be48392311af6a$var$searchTarget = null, $00be48392311af6a$var$searchBoundary = null;
function $00be48392311af6a$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($00be48392311af6a$var$searchTarget = child, !0) : !1;
}
function $00be48392311af6a$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($00be48392311af6a$var$searchBoundary = child, !1) : child === target ? (null !== $00be48392311af6a$var$searchBoundary && ($00be48392311af6a$var$searchTarget = child), !0) : !1;
}
function $00be48392311af6a$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $00be48392311af6a$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $00be48392311af6a$var$assign = Object.assign, $00be48392311af6a$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $00be48392311af6a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $00be48392311af6a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $00be48392311af6a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $00be48392311af6a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $00be48392311af6a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $00be48392311af6a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $00be48392311af6a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $00be48392311af6a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $00be48392311af6a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $00be48392311af6a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $00be48392311af6a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $00be48392311af6a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $00be48392311af6a$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $00be48392311af6a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $00be48392311af6a$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $00be48392311af6a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $00be48392311af6a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $00be48392311af6a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $00be48392311af6a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $00be48392311af6a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $00be48392311af6a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $00be48392311af6a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $00be48392311af6a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $00be48392311af6a$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $00be48392311af6a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $00be48392311af6a$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $00be48392311af6a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $00be48392311af6a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $00be48392311af6a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $00be48392311af6a$var$getComponentNameFromType(type.type) || "Memo";
        case $00be48392311af6a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $00be48392311af6a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $00be48392311af6a$var$isArrayImpl = Array.isArray, $00be48392311af6a$var$ReactSharedInternals = $5E6i4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00be48392311af6a$var$ReactDOMSharedInternals = $ibUU1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00be48392311af6a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $00be48392311af6a$var$valueStack = [], $00be48392311af6a$var$index = -1;
function $00be48392311af6a$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $00be48392311af6a$var$pop(cursor) {
    0 > $00be48392311af6a$var$index || (cursor.current = $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index], $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index] = null, $00be48392311af6a$var$index--);
}
function $00be48392311af6a$var$push(cursor, value) {
    $00be48392311af6a$var$index++;
    $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index] = cursor.current;
    cursor.current = value;
}
var $00be48392311af6a$var$contextStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$contextFiberStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$rootInstanceStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$hostTransitionProviderCursor = $00be48392311af6a$var$createCursor(null);
function $00be48392311af6a$var$pushHostContainer(fiber, nextRootInstance) {
    $00be48392311af6a$var$push($00be48392311af6a$var$rootInstanceStackCursor, nextRootInstance);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextFiberStackCursor, fiber);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $00be48392311af6a$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $00be48392311af6a$var$getOwnHostContext(nextRootInstance), fiber = $00be48392311af6a$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, fiber);
}
function $00be48392311af6a$var$popHostContainer() {
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextFiberStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$rootInstanceStackCursor);
}
function $00be48392311af6a$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($00be48392311af6a$var$HostTransitionContext._currentValue = stateHook.memoizedState, $00be48392311af6a$var$push($00be48392311af6a$var$hostTransitionProviderCursor, fiber));
    stateHook = $00be48392311af6a$var$contextStackCursor.current;
    var JSCompiler_inline_result = $00be48392311af6a$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($00be48392311af6a$var$push($00be48392311af6a$var$contextFiberStackCursor, fiber), $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, JSCompiler_inline_result));
}
function $00be48392311af6a$var$popHostContext(fiber) {
    $00be48392311af6a$var$contextFiberStackCursor.current === fiber && ($00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor), $00be48392311af6a$var$pop($00be48392311af6a$var$contextFiberStackCursor));
    $00be48392311af6a$var$hostTransitionProviderCursor.current === fiber && ($00be48392311af6a$var$pop($00be48392311af6a$var$hostTransitionProviderCursor), $00be48392311af6a$var$HostTransitionContext._currentValue = $00be48392311af6a$var$sharedNotPendingObject);
}
var $00be48392311af6a$var$prefix, $00be48392311af6a$var$suffix;
function $00be48392311af6a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $00be48392311af6a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $00be48392311af6a$var$prefix = match && match[1] || "";
        $00be48392311af6a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $00be48392311af6a$var$prefix + name + $00be48392311af6a$var$suffix;
}
var $00be48392311af6a$var$reentry = !1;
function $00be48392311af6a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $00be48392311af6a$var$reentry) return "";
    $00be48392311af6a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $00be48392311af6a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $00be48392311af6a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $00be48392311af6a$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $00be48392311af6a$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $00be48392311af6a$var$describeBuiltInComponentFrame("Suspense Fallback") : $00be48392311af6a$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $00be48392311af6a$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $00be48392311af6a$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $00be48392311af6a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $00be48392311af6a$var$scheduleCallback$3 = $6XCI2.unstable_scheduleCallback, $00be48392311af6a$var$cancelCallback$1 = $6XCI2.unstable_cancelCallback, $00be48392311af6a$var$shouldYield = $6XCI2.unstable_shouldYield, $00be48392311af6a$var$requestPaint = $6XCI2.unstable_requestPaint, $00be48392311af6a$var$now = $6XCI2.unstable_now, $00be48392311af6a$var$getCurrentPriorityLevel = $6XCI2.unstable_getCurrentPriorityLevel, $00be48392311af6a$var$ImmediatePriority = $6XCI2.unstable_ImmediatePriority, $00be48392311af6a$var$UserBlockingPriority = $6XCI2.unstable_UserBlockingPriority, $00be48392311af6a$var$NormalPriority$1 = $6XCI2.unstable_NormalPriority, $00be48392311af6a$var$LowPriority = $6XCI2.unstable_LowPriority, $00be48392311af6a$var$IdlePriority = $6XCI2.unstable_IdlePriority, $00be48392311af6a$var$log$1 = $6XCI2.log, $00be48392311af6a$var$unstable_setDisableYieldValue = $6XCI2.unstable_setDisableYieldValue, $00be48392311af6a$var$rendererID = null, $00be48392311af6a$var$injectedHook = null;
function $00be48392311af6a$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $00be48392311af6a$var$log$1 && $00be48392311af6a$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.setStrictMode) try {
        $00be48392311af6a$var$injectedHook.setStrictMode($00be48392311af6a$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $00be48392311af6a$var$clz32 = Math.clz32 ? Math.clz32 : $00be48392311af6a$var$clz32Fallback, $00be48392311af6a$var$log = Math.log, $00be48392311af6a$var$LN2 = Math.LN2;
function $00be48392311af6a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($00be48392311af6a$var$log(x) / $00be48392311af6a$var$LN2 | 0) | 0;
}
var $00be48392311af6a$var$nextTransitionUpdateLane = 256, $00be48392311af6a$var$nextTransitionDeferredLane = 262144, $00be48392311af6a$var$nextRetryLane = 4194304;
function $00be48392311af6a$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $00be48392311af6a$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $00be48392311af6a$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $00be48392311af6a$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $00be48392311af6a$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $00be48392311af6a$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $00be48392311af6a$var$claimNextRetryLane() {
    var lane = $00be48392311af6a$var$nextRetryLane;
    $00be48392311af6a$var$nextRetryLane <<= 1;
    0 === ($00be48392311af6a$var$nextRetryLane & 62914560) && ($00be48392311af6a$var$nextRetryLane = 4194304);
    return lane;
}
function $00be48392311af6a$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $00be48392311af6a$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $00be48392311af6a$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $00be48392311af6a$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $00be48392311af6a$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $00be48392311af6a$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $00be48392311af6a$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $00be48392311af6a$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $00be48392311af6a$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $00be48392311af6a$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $00be48392311af6a$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $00be48392311af6a$var$resolveUpdatePriority() {
    var updatePriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $00be48392311af6a$var$getEventPriority(updatePriority.type);
}
function $00be48392311af6a$var$runWithPriority(priority, fn) {
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        return $00be48392311af6a$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $00be48392311af6a$var$randomKey = Math.random().toString(36).slice(2), $00be48392311af6a$var$internalInstanceKey = "__reactFiber$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalPropsKey = "__reactProps$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalContainerInstanceKey = "__reactContainer$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlersKey = "__reactEvents$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlerListenersKey = "__reactListeners$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlesSetKey = "__reactHandles$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalRootNodeResourcesKey = "__reactResources$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalHoistableMarker = "__reactMarker$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalLoadPendingKey = "__reactLoad$" + $00be48392311af6a$var$randomKey;
function $00be48392311af6a$var$detachDeletedInstance(node) {
    delete node[$00be48392311af6a$var$internalInstanceKey];
    delete node[$00be48392311af6a$var$internalPropsKey];
    delete node[$00be48392311af6a$var$internalEventHandlerListenersKey];
    delete node[$00be48392311af6a$var$internalEventHandlesSetKey];
}
function $00be48392311af6a$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$00be48392311af6a$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$00be48392311af6a$var$internalContainerInstanceKey] || parentNode[$00be48392311af6a$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $00be48392311af6a$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$00be48392311af6a$var$internalInstanceKey]) return parentNode;
                targetNode = $00be48392311af6a$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $00be48392311af6a$var$getInstanceFromNode(node) {
    if (node = node[$00be48392311af6a$var$internalInstanceKey] || node[$00be48392311af6a$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $00be48392311af6a$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($00be48392311af6a$var$formatProdErrorMessage(33));
}
function $00be48392311af6a$var$getResourcesFromRoot(root) {
    var resources = root[$00be48392311af6a$var$internalRootNodeResourcesKey];
    resources || (resources = root[$00be48392311af6a$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $00be48392311af6a$var$markNodeAsHoistable(node) {
    node[$00be48392311af6a$var$internalHoistableMarker] = !0;
}
function $00be48392311af6a$var$clearPendingLoadOnNode(node) {
    node[$00be48392311af6a$var$internalLoadPendingKey] = void 0;
}
var $00be48392311af6a$var$allNativeEvents = new Set(), $00be48392311af6a$var$registrationNameDependencies = {};
function $00be48392311af6a$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $00be48392311af6a$var$registerDirectEvent(registrationName, dependencies);
    $00be48392311af6a$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $00be48392311af6a$var$registerDirectEvent(registrationName, dependencies) {
    $00be48392311af6a$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$00be48392311af6a$var$allNativeEvents.add(dependencies[registrationName]);
}
var $00be48392311af6a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $00be48392311af6a$var$illegalAttributeNameCache = {}, $00be48392311af6a$var$validatedAttributeNameCache = {};
function $00be48392311af6a$var$isAttributeNameSafe(attributeName) {
    if ($00be48392311af6a$var$hasOwnProperty.call($00be48392311af6a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($00be48392311af6a$var$hasOwnProperty.call($00be48392311af6a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($00be48392311af6a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $00be48392311af6a$var$validatedAttributeNameCache[attributeName] = !0;
    $00be48392311af6a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $00be48392311af6a$var$viewTransitionMutationContext = !1;
function $00be48392311af6a$var$pushMutationContext() {
    var prev = $00be48392311af6a$var$viewTransitionMutationContext;
    $00be48392311af6a$var$viewTransitionMutationContext = !1;
    return prev;
}
function $00be48392311af6a$var$setValueForAttribute(node, name, value) {
    if ($00be48392311af6a$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $00be48392311af6a$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $00be48392311af6a$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $00be48392311af6a$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $00be48392311af6a$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $00be48392311af6a$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $00be48392311af6a$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $00be48392311af6a$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $00be48392311af6a$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $00be48392311af6a$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $00be48392311af6a$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $00be48392311af6a$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $00be48392311af6a$var$getToStringValue(value);
        } else element.value !== "" + $00be48392311af6a$var$getToStringValue(value) && (element.value = "" + $00be48392311af6a$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(element.value)) : $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(value)) : null != defaultValue ? $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $00be48392311af6a$var$getToStringValue(name) : element.removeAttribute("name");
}
function $00be48392311af6a$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $00be48392311af6a$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $00be48392311af6a$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $00be48392311af6a$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $00be48392311af6a$var$track(element);
}
function $00be48392311af6a$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $00be48392311af6a$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $00be48392311af6a$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $00be48392311af6a$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $00be48392311af6a$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $00be48392311af6a$var$getToStringValue(defaultValue) : "";
}
function $00be48392311af6a$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($00be48392311af6a$var$formatProdErrorMessage(92));
            if ($00be48392311af6a$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($00be48392311af6a$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $00be48392311af6a$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $00be48392311af6a$var$track(element);
}
function $00be48392311af6a$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $00be48392311af6a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $00be48392311af6a$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $00be48392311af6a$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $00be48392311af6a$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($00be48392311af6a$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $00be48392311af6a$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($00be48392311af6a$var$setValueForStyle(node, styleName$16, styleName), $00be48392311af6a$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $00be48392311af6a$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $00be48392311af6a$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $00be48392311af6a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $00be48392311af6a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $00be48392311af6a$var$sanitizeURL(url) {
    return $00be48392311af6a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $00be48392311af6a$var$noop$1() {}
var $00be48392311af6a$var$currentReplayingEvent = null;
function $00be48392311af6a$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $00be48392311af6a$var$restoreTarget = null, $00be48392311af6a$var$restoreQueue = null;
function $00be48392311af6a$var$restoreStateOfTarget(target) {
    var internalInstance = $00be48392311af6a$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$00be48392311af6a$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $00be48392311af6a$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$00be48392311af6a$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($00be48392311af6a$var$formatProdErrorMessage(90));
                            $00be48392311af6a$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $00be48392311af6a$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $00be48392311af6a$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $00be48392311af6a$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $00be48392311af6a$var$isInsideEventHandler = !1;
function $00be48392311af6a$var$batchedUpdates$1(fn, a, b) {
    if ($00be48392311af6a$var$isInsideEventHandler) return fn(a, b);
    $00be48392311af6a$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($00be48392311af6a$var$isInsideEventHandler = !1, null !== $00be48392311af6a$var$restoreTarget || null !== $00be48392311af6a$var$restoreQueue) {
            if ($00be48392311af6a$var$flushSyncWork$1(), $00be48392311af6a$var$restoreTarget && (a = $00be48392311af6a$var$restoreTarget, fn = $00be48392311af6a$var$restoreQueue, $00be48392311af6a$var$restoreQueue = $00be48392311af6a$var$restoreTarget = null, $00be48392311af6a$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$00be48392311af6a$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $00be48392311af6a$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$00be48392311af6a$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $00be48392311af6a$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $00be48392311af6a$var$passiveBrowserEventsSupported = !1;
if ($00be48392311af6a$var$canUseDOM) try {
    var $00be48392311af6a$var$options = {};
    Object.defineProperty($00be48392311af6a$var$options, "passive", {
        get: function() {
            $00be48392311af6a$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $00be48392311af6a$var$options, $00be48392311af6a$var$options);
    window.removeEventListener("test", $00be48392311af6a$var$options, $00be48392311af6a$var$options);
} catch (e) {
    $00be48392311af6a$var$passiveBrowserEventsSupported = !1;
}
var $00be48392311af6a$var$root = null, $00be48392311af6a$var$startText = null, $00be48392311af6a$var$fallbackText = null;
function $00be48392311af6a$var$getData() {
    if ($00be48392311af6a$var$fallbackText) return $00be48392311af6a$var$fallbackText;
    var start, startValue = $00be48392311af6a$var$startText, startLength = startValue.length, end, endValue = "value" in $00be48392311af6a$var$root ? $00be48392311af6a$var$root.value : $00be48392311af6a$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $00be48392311af6a$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $00be48392311af6a$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $00be48392311af6a$var$functionThatReturnsTrue() {
    return !0;
}
function $00be48392311af6a$var$functionThatReturnsFalse() {
    return !1;
}
function $00be48392311af6a$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $00be48392311af6a$var$functionThatReturnsTrue : $00be48392311af6a$var$functionThatReturnsFalse;
        this.isPropagationStopped = $00be48392311af6a$var$functionThatReturnsFalse;
        return this;
    }
    $00be48392311af6a$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $00be48392311af6a$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $00be48392311af6a$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $00be48392311af6a$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $00be48392311af6a$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $00be48392311af6a$var$SyntheticEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$EventInterface), $00be48392311af6a$var$UIEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    view: 0,
    detail: 0
}), $00be48392311af6a$var$SyntheticUIEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$UIEventInterface), $00be48392311af6a$var$lastMovementX, $00be48392311af6a$var$lastMovementY, $00be48392311af6a$var$lastMouseEvent, $00be48392311af6a$var$MouseEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $00be48392311af6a$var$lastMouseEvent && ($00be48392311af6a$var$lastMouseEvent && "mousemove" === event.type ? ($00be48392311af6a$var$lastMovementX = event.screenX - $00be48392311af6a$var$lastMouseEvent.screenX, $00be48392311af6a$var$lastMovementY = event.screenY - $00be48392311af6a$var$lastMouseEvent.screenY) : $00be48392311af6a$var$lastMovementY = $00be48392311af6a$var$lastMovementX = 0, $00be48392311af6a$var$lastMouseEvent = event);
        return $00be48392311af6a$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $00be48392311af6a$var$lastMovementY;
    }
}), $00be48392311af6a$var$SyntheticMouseEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$MouseEventInterface), $00be48392311af6a$var$DragEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    dataTransfer: 0
}), $00be48392311af6a$var$SyntheticDragEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$DragEventInterface), $00be48392311af6a$var$FocusEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    relatedTarget: 0
}), $00be48392311af6a$var$SyntheticFocusEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$FocusEventInterface), $00be48392311af6a$var$AnimationEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00be48392311af6a$var$SyntheticAnimationEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$AnimationEventInterface), $00be48392311af6a$var$ClipboardEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $00be48392311af6a$var$SyntheticClipboardEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$ClipboardEventInterface), $00be48392311af6a$var$CompositionEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    data: 0
}), $00be48392311af6a$var$SyntheticCompositionEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$CompositionEventInterface), $00be48392311af6a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $00be48392311af6a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $00be48392311af6a$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $00be48392311af6a$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $00be48392311af6a$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $00be48392311af6a$var$getEventModifierState() {
    return $00be48392311af6a$var$modifierStateGetter;
}
var $00be48392311af6a$var$KeyboardEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $00be48392311af6a$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $00be48392311af6a$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $00be48392311af6a$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $00be48392311af6a$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $00be48392311af6a$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $00be48392311af6a$var$SyntheticKeyboardEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$KeyboardEventInterface), $00be48392311af6a$var$PointerEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $00be48392311af6a$var$SyntheticPointerEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$PointerEventInterface), $00be48392311af6a$var$SubmitEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    submitter: 0
}), $00be48392311af6a$var$SyntheticSubmitEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$SubmitEventInterface), $00be48392311af6a$var$TouchEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState
}), $00be48392311af6a$var$SyntheticTouchEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$TouchEventInterface), $00be48392311af6a$var$TransitionEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00be48392311af6a$var$SyntheticTransitionEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$TransitionEventInterface), $00be48392311af6a$var$WheelEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $00be48392311af6a$var$SyntheticWheelEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$WheelEventInterface), $00be48392311af6a$var$ToggleEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $00be48392311af6a$var$SyntheticToggleEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$ToggleEventInterface), $00be48392311af6a$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $00be48392311af6a$var$canUseCompositionEvent = $00be48392311af6a$var$canUseDOM && "CompositionEvent" in window, $00be48392311af6a$var$documentMode = null;
$00be48392311af6a$var$canUseDOM && "documentMode" in document && ($00be48392311af6a$var$documentMode = document.documentMode);
var $00be48392311af6a$var$canUseTextInputEvent = $00be48392311af6a$var$canUseDOM && "TextEvent" in window && !$00be48392311af6a$var$documentMode, $00be48392311af6a$var$useFallbackCompositionData = $00be48392311af6a$var$canUseDOM && (!$00be48392311af6a$var$canUseCompositionEvent || $00be48392311af6a$var$documentMode && 8 < $00be48392311af6a$var$documentMode && 11 >= $00be48392311af6a$var$documentMode), $00be48392311af6a$var$SPACEBAR_CHAR = String.fromCharCode(32), $00be48392311af6a$var$hasSpaceKeypress = !1;
function $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $00be48392311af6a$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $00be48392311af6a$var$isComposing = !1;
function $00be48392311af6a$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $00be48392311af6a$var$hasSpaceKeypress = !0;
            return $00be48392311af6a$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $00be48392311af6a$var$SPACEBAR_CHAR && $00be48392311af6a$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $00be48392311af6a$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($00be48392311af6a$var$isComposing) return "compositionend" === domEventName || !$00be48392311af6a$var$canUseCompositionEvent && $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $00be48392311af6a$var$getData(), $00be48392311af6a$var$fallbackText = $00be48392311af6a$var$startText = $00be48392311af6a$var$root = null, $00be48392311af6a$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $00be48392311af6a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $00be48392311af6a$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $00be48392311af6a$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$00be48392311af6a$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $00be48392311af6a$var$restoreTarget ? $00be48392311af6a$var$restoreQueue ? $00be48392311af6a$var$restoreQueue.push(target) : $00be48392311af6a$var$restoreQueue = [
        target
    ] : $00be48392311af6a$var$restoreTarget = target;
    inst = $00be48392311af6a$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $00be48392311af6a$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $00be48392311af6a$var$activeElement$1 = null, $00be48392311af6a$var$activeElementInst$1 = null;
function $00be48392311af6a$var$runEventInBatch(dispatchQueue) {
    $00be48392311af6a$var$processDispatchQueue(dispatchQueue, 0);
}
function $00be48392311af6a$var$getInstIfValueChanged(targetInst) {
    var targetNode = $00be48392311af6a$var$getNodeFromInstance(targetInst);
    if ($00be48392311af6a$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $00be48392311af6a$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $00be48392311af6a$var$isInputEventSupported = !1;
if ($00be48392311af6a$var$canUseDOM) {
    var $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318;
    if ($00be48392311af6a$var$canUseDOM) {
        var $00be48392311af6a$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$00be48392311af6a$var$isSupported$jscomp$inline_474) {
            var $00be48392311af6a$var$element$jscomp$inline_475 = document.createElement("div");
            $00be48392311af6a$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $00be48392311af6a$var$isSupported$jscomp$inline_474 = "function" === typeof $00be48392311af6a$var$element$jscomp$inline_475.oninput;
        }
        $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 = $00be48392311af6a$var$isSupported$jscomp$inline_474;
    } else $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 = !1;
    $00be48392311af6a$var$isInputEventSupported = $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $00be48392311af6a$var$stopWatchingForValueChange() {
    $00be48392311af6a$var$activeElement$1 && ($00be48392311af6a$var$activeElement$1.detachEvent("onpropertychange", $00be48392311af6a$var$handlePropertyChange), $00be48392311af6a$var$activeElementInst$1 = $00be48392311af6a$var$activeElement$1 = null);
}
function $00be48392311af6a$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $00be48392311af6a$var$getInstIfValueChanged($00be48392311af6a$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, $00be48392311af6a$var$activeElementInst$1, nativeEvent, $00be48392311af6a$var$getEventTarget(nativeEvent));
        $00be48392311af6a$var$batchedUpdates$1($00be48392311af6a$var$runEventInBatch, dispatchQueue);
    }
}
function $00be48392311af6a$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($00be48392311af6a$var$stopWatchingForValueChange(), $00be48392311af6a$var$activeElement$1 = target, $00be48392311af6a$var$activeElementInst$1 = targetInst, $00be48392311af6a$var$activeElement$1.attachEvent("onpropertychange", $00be48392311af6a$var$handlePropertyChange)) : "focusout" === domEventName && $00be48392311af6a$var$stopWatchingForValueChange();
}
function $00be48392311af6a$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged($00be48392311af6a$var$activeElementInst$1);
}
function $00be48392311af6a$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged(targetInst);
}
function $00be48392311af6a$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged(targetInst);
}
function $00be48392311af6a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $00be48392311af6a$var$objectIs = "function" === typeof Object.is ? Object.is : $00be48392311af6a$var$is;
function $00be48392311af6a$var$shallowEqual(objA, objB) {
    if ($00be48392311af6a$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$00be48392311af6a$var$hasOwnProperty.call(objB, currentKey) || !$00be48392311af6a$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $00be48392311af6a$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $00be48392311af6a$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $00be48392311af6a$var$getNodeForCharacterOffset(root, offset) {
    var node = $00be48392311af6a$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $00be48392311af6a$var$getLeafNode(node);
    }
}
function $00be48392311af6a$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $00be48392311af6a$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $00be48392311af6a$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $00be48392311af6a$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $00be48392311af6a$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $00be48392311af6a$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $00be48392311af6a$var$skipSelectionChangeEvent = $00be48392311af6a$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $00be48392311af6a$var$activeElement = null, $00be48392311af6a$var$activeElementInst = null, $00be48392311af6a$var$lastSelection = null, $00be48392311af6a$var$mouseDown = !1;
function $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $00be48392311af6a$var$mouseDown || null == $00be48392311af6a$var$activeElement || $00be48392311af6a$var$activeElement !== $00be48392311af6a$var$getActiveElement(doc) || (doc = $00be48392311af6a$var$activeElement, "selectionStart" in doc && $00be48392311af6a$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $00be48392311af6a$var$lastSelection && $00be48392311af6a$var$shallowEqual($00be48392311af6a$var$lastSelection, doc) || ($00be48392311af6a$var$lastSelection = doc, doc = $00be48392311af6a$var$accumulateTwoPhaseListeners($00be48392311af6a$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $00be48392311af6a$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $00be48392311af6a$var$activeElement)));
}
function $00be48392311af6a$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $00be48392311af6a$var$vendorPrefixes = {
    animationend: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionEnd")
}, $00be48392311af6a$var$prefixedEventNames = {}, $00be48392311af6a$var$style = {};
$00be48392311af6a$var$canUseDOM && ($00be48392311af6a$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $00be48392311af6a$var$vendorPrefixes.animationend.animation, delete $00be48392311af6a$var$vendorPrefixes.animationiteration.animation, delete $00be48392311af6a$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $00be48392311af6a$var$vendorPrefixes.transitionend.transition);
function $00be48392311af6a$var$getVendorPrefixedEventName(eventName) {
    if ($00be48392311af6a$var$prefixedEventNames[eventName]) return $00be48392311af6a$var$prefixedEventNames[eventName];
    if (!$00be48392311af6a$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $00be48392311af6a$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $00be48392311af6a$var$style) return $00be48392311af6a$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $00be48392311af6a$var$ANIMATION_END = $00be48392311af6a$var$getVendorPrefixedEventName("animationend"), $00be48392311af6a$var$ANIMATION_ITERATION = $00be48392311af6a$var$getVendorPrefixedEventName("animationiteration"), $00be48392311af6a$var$ANIMATION_START = $00be48392311af6a$var$getVendorPrefixedEventName("animationstart"), $00be48392311af6a$var$TRANSITION_RUN = $00be48392311af6a$var$getVendorPrefixedEventName("transitionrun"), $00be48392311af6a$var$TRANSITION_START = $00be48392311af6a$var$getVendorPrefixedEventName("transitionstart"), $00be48392311af6a$var$TRANSITION_CANCEL = $00be48392311af6a$var$getVendorPrefixedEventName("transitioncancel"), $00be48392311af6a$var$TRANSITION_END = $00be48392311af6a$var$getVendorPrefixedEventName("transitionend"), $00be48392311af6a$var$topLevelEventsToReactNames = new Map(), $00be48392311af6a$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$00be48392311af6a$var$simpleEventPluginEvents.push("scrollEnd");
function $00be48392311af6a$var$registerSimpleEvent(domEventName, reactName) {
    $00be48392311af6a$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $00be48392311af6a$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $00be48392311af6a$var$globalClientIdCounter$1 = 0;
function $00be48392311af6a$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $00be48392311af6a$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $00be48392311af6a$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $00be48392311af6a$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $00be48392311af6a$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $00be48392311af6a$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $00be48392311af6a$var$getClassNameByType(defaultClass);
    eventClass = $00be48392311af6a$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $00be48392311af6a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $00be48392311af6a$var$concurrentQueues = [], $00be48392311af6a$var$concurrentQueuesIndex = 0, $00be48392311af6a$var$concurrentlyUpdatedLanes = 0;
function $00be48392311af6a$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $00be48392311af6a$var$concurrentQueuesIndex, i = $00be48392311af6a$var$concurrentlyUpdatedLanes = $00be48392311af6a$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var queue = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var update = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var lane = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = fiber;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = queue;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = update;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = lane;
    $00be48392311af6a$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $00be48392311af6a$var$enqueueUpdate$1(fiber, null, null, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $00be48392311af6a$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $00be48392311af6a$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $00be48392311af6a$var$nestedUpdateCount) throw $00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null, Error($00be48392311af6a$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $00be48392311af6a$var$emptyContextObject = {};
function $00be48392311af6a$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $00be48392311af6a$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $00be48392311af6a$var$FiberNode(tag, pendingProps, key, mode);
}
function $00be48392311af6a$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $00be48392311af6a$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $00be48392311af6a$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $00be48392311af6a$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $00be48392311af6a$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $00be48392311af6a$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $00be48392311af6a$var$isHostHoistableType(type, pendingProps, $00be48392311af6a$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $00be48392311af6a$var$REACT_ACTIVITY_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_FRAGMENT_TYPE:
            return $00be48392311af6a$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $00be48392311af6a$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $00be48392311af6a$var$REACT_PROFILER_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $00be48392311af6a$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_SUSPENSE_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_LEGACY_HIDDEN_TYPE:
        case $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $00be48392311af6a$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $00be48392311af6a$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $00be48392311af6a$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $00be48392311af6a$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $00be48392311af6a$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($00be48392311af6a$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $00be48392311af6a$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $00be48392311af6a$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $00be48392311af6a$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $00be48392311af6a$var$createFiberFromText(content, mode, lanes) {
    content = $00be48392311af6a$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $00be48392311af6a$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $00be48392311af6a$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $00be48392311af6a$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $00be48392311af6a$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $00be48392311af6a$var$CapturedStacks = new WeakMap();
function $00be48392311af6a$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $00be48392311af6a$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $00be48392311af6a$var$getStackByFiberInDevAndProd(source)
        };
        $00be48392311af6a$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $00be48392311af6a$var$getStackByFiberInDevAndProd(source)
    };
}
var $00be48392311af6a$var$forkStack = [], $00be48392311af6a$var$forkStackIndex = 0, $00be48392311af6a$var$treeForkProvider = null, $00be48392311af6a$var$treeForkCount = 0, $00be48392311af6a$var$idStack = [], $00be48392311af6a$var$idStackIndex = 0, $00be48392311af6a$var$treeContextProvider = null, $00be48392311af6a$var$treeContextId = 1, $00be48392311af6a$var$treeContextOverflow = "";
function $00be48392311af6a$var$pushTreeFork(workInProgress, totalChildren) {
    $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex++] = $00be48392311af6a$var$treeForkCount;
    $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex++] = $00be48392311af6a$var$treeForkProvider;
    $00be48392311af6a$var$treeForkProvider = workInProgress;
    $00be48392311af6a$var$treeForkCount = totalChildren;
}
function $00be48392311af6a$var$pushTreeId(workInProgress, totalChildren, index) {
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextId;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextOverflow;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextProvider;
    $00be48392311af6a$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $00be48392311af6a$var$treeContextId;
    workInProgress = $00be48392311af6a$var$treeContextOverflow;
    var baseLength = 32 - $00be48392311af6a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $00be48392311af6a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $00be48392311af6a$var$treeContextId = 1 << 32 - $00be48392311af6a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $00be48392311af6a$var$treeContextOverflow = length + workInProgress;
    } else $00be48392311af6a$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $00be48392311af6a$var$treeContextOverflow = workInProgress;
}
function $00be48392311af6a$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($00be48392311af6a$var$pushTreeFork(workInProgress, 1), $00be48392311af6a$var$pushTreeId(workInProgress, 1, 0));
}
function $00be48392311af6a$var$popTreeContext(workInProgress) {
    for(; workInProgress === $00be48392311af6a$var$treeForkProvider;)$00be48392311af6a$var$treeForkProvider = $00be48392311af6a$var$forkStack[--$00be48392311af6a$var$forkStackIndex], $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex] = null, $00be48392311af6a$var$treeForkCount = $00be48392311af6a$var$forkStack[--$00be48392311af6a$var$forkStackIndex], $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex] = null;
    for(; workInProgress === $00be48392311af6a$var$treeContextProvider;)$00be48392311af6a$var$treeContextProvider = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null, $00be48392311af6a$var$treeContextOverflow = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null, $00be48392311af6a$var$treeContextId = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null;
}
function $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextId;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextOverflow;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextProvider;
    $00be48392311af6a$var$treeContextId = suspendedContext.id;
    $00be48392311af6a$var$treeContextOverflow = suspendedContext.overflow;
    $00be48392311af6a$var$treeContextProvider = workInProgress;
}
var $00be48392311af6a$var$hydrationParentFiber = null, $00be48392311af6a$var$nextHydratableInstance = null, $00be48392311af6a$var$isHydrating = !1, $00be48392311af6a$var$hydrationErrors = null, $00be48392311af6a$var$rootOrSingletonContext = !1, $00be48392311af6a$var$HydrationMismatchException = Error($00be48392311af6a$var$formatProdErrorMessage(519));
function $00be48392311af6a$var$throwOnHydrationMismatch(fiber) {
    var error = Error($00be48392311af6a$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(error, fiber));
    throw $00be48392311af6a$var$HydrationMismatchException;
}
function $00be48392311af6a$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$00be48392311af6a$var$internalInstanceKey] = fiber;
    instance[$00be48392311af6a$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $00be48392311af6a$var$listenToNonDelegatedEvent("cancel", instance);
            $00be48392311af6a$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $00be48392311af6a$var$mediaEventTypes.length; type++)$00be48392311af6a$var$listenToNonDelegatedEvent($00be48392311af6a$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", instance);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance);
            $00be48392311af6a$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance), $00be48392311af6a$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $00be48392311af6a$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", instance), $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $00be48392311af6a$var$noop$1), instance = !0) : instance = !1;
    instance || $00be48392311af6a$var$throwOnHydrationMismatch(fiber, !0);
}
function $00be48392311af6a$var$popToNextHostParent(fiber) {
    for($00be48392311af6a$var$hydrationParentFiber = fiber.return; $00be48392311af6a$var$hydrationParentFiber;)switch($00be48392311af6a$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $00be48392311af6a$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $00be48392311af6a$var$rootOrSingletonContext = !0;
            return;
        default:
            $00be48392311af6a$var$hydrationParentFiber = $00be48392311af6a$var$hydrationParentFiber.return;
    }
}
function $00be48392311af6a$var$popHydrationState(fiber) {
    if (fiber !== $00be48392311af6a$var$hydrationParentFiber) return !1;
    if (!$00be48392311af6a$var$isHydrating) return $00be48392311af6a$var$popToNextHostParent(fiber), $00be48392311af6a$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $00be48392311af6a$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $00be48392311af6a$var$nextHydratableInstance && $00be48392311af6a$var$throwOnHydrationMismatch(fiber);
    $00be48392311af6a$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $00be48392311af6a$var$nextHydratableInstance, $00be48392311af6a$var$isSingletonScope(fiber.type) ? (fiber = $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton, $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = null, $00be48392311af6a$var$nextHydratableInstance = fiber) : $00be48392311af6a$var$nextHydratableInstance = tag) : $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$hydrationParentFiber ? $00be48392311af6a$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $00be48392311af6a$var$resetHydrationState() {
    $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$hydrationParentFiber = null;
    $00be48392311af6a$var$isHydrating = !1;
}
function $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $00be48392311af6a$var$hydrationErrors;
    null !== queuedErrors && (null === $00be48392311af6a$var$workInProgressRootRecoverableErrors ? $00be48392311af6a$var$workInProgressRootRecoverableErrors = queuedErrors : $00be48392311af6a$var$workInProgressRootRecoverableErrors.push.apply($00be48392311af6a$var$workInProgressRootRecoverableErrors, queuedErrors), $00be48392311af6a$var$hydrationErrors = null);
    return queuedErrors;
}
function $00be48392311af6a$var$queueHydrationError(error) {
    null === $00be48392311af6a$var$hydrationErrors ? $00be48392311af6a$var$hydrationErrors = [
        error
    ] : $00be48392311af6a$var$hydrationErrors.push(error);
}
var $00be48392311af6a$var$valueCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$currentlyRenderingFiber$1 = null, $00be48392311af6a$var$lastContextDependency = null;
function $00be48392311af6a$var$pushProvider(providerFiber, context, nextValue) {
    $00be48392311af6a$var$push($00be48392311af6a$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $00be48392311af6a$var$popProvider(context) {
    context._currentValue = $00be48392311af6a$var$valueCursor.current;
    $00be48392311af6a$var$pop($00be48392311af6a$var$valueCursor);
}
function $00be48392311af6a$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $00be48392311af6a$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $00be48392311af6a$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $00be48392311af6a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $00be48392311af6a$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $00be48392311af6a$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($00be48392311af6a$var$HostTransitionContext) : current = [
                $00be48392311af6a$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $00be48392311af6a$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $00be48392311af6a$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$00be48392311af6a$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $00be48392311af6a$var$prepareToReadContext(workInProgress) {
    $00be48392311af6a$var$currentlyRenderingFiber$1 = workInProgress;
    $00be48392311af6a$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $00be48392311af6a$var$readContext(context) {
    return $00be48392311af6a$var$readContextForConsumer($00be48392311af6a$var$currentlyRenderingFiber$1, context);
}
function $00be48392311af6a$var$readContextDuringReconciliation(consumer, context) {
    null === $00be48392311af6a$var$currentlyRenderingFiber$1 && $00be48392311af6a$var$prepareToReadContext(consumer);
    return $00be48392311af6a$var$readContextForConsumer(consumer, context);
}
function $00be48392311af6a$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $00be48392311af6a$var$lastContextDependency) {
        if (null === consumer) throw Error($00be48392311af6a$var$formatProdErrorMessage(308));
        $00be48392311af6a$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$lastContextDependency.next = context;
    return value;
}
var $00be48392311af6a$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $00be48392311af6a$var$scheduleCallback$2 = $6XCI2.unstable_scheduleCallback, $00be48392311af6a$var$NormalPriority = $6XCI2.unstable_NormalPriority, $00be48392311af6a$var$CacheContext = {
    $$typeof: $00be48392311af6a$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $00be48392311af6a$var$createCache() {
    return {
        controller: new $00be48392311af6a$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $00be48392311af6a$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $00be48392311af6a$var$scheduleCallback$2($00be48392311af6a$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $00be48392311af6a$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $00be48392311af6a$var$entangledTransitionTypes = null;
function $00be48392311af6a$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $00be48392311af6a$var$currentEntangledListeners = null, $00be48392311af6a$var$currentEntangledPendingCount = 0, $00be48392311af6a$var$currentEntangledLane = 0, $00be48392311af6a$var$currentEntangledActionThenable = null;
function $00be48392311af6a$var$entangleAsyncAction(transition, thenable) {
    if (null === $00be48392311af6a$var$currentEntangledListeners) {
        var entangledListeners = $00be48392311af6a$var$currentEntangledListeners = [];
        $00be48392311af6a$var$currentEntangledPendingCount = 0;
        $00be48392311af6a$var$currentEntangledLane = $00be48392311af6a$var$requestTransitionLane();
        $00be48392311af6a$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $00be48392311af6a$var$currentEntangledPendingCount++;
    thenable.then($00be48392311af6a$var$pingEngtangledActionScope, $00be48392311af6a$var$pingEngtangledActionScope);
    return thenable;
}
function $00be48392311af6a$var$pingEngtangledActionScope() {
    if (0 === --$00be48392311af6a$var$currentEntangledPendingCount && ($00be48392311af6a$var$entangledTransitionTypes = null, null !== $00be48392311af6a$var$currentEntangledListeners)) {
        null !== $00be48392311af6a$var$currentEntangledActionThenable && ($00be48392311af6a$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $00be48392311af6a$var$currentEntangledListeners;
        $00be48392311af6a$var$currentEntangledListeners = null;
        $00be48392311af6a$var$currentEntangledLane = 0;
        $00be48392311af6a$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $00be48392311af6a$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $00be48392311af6a$var$prevOnStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
$00be48392311af6a$var$ReactSharedInternals.S = function(transition, returnValue) {
    $00be48392311af6a$var$globalMostRecentTransitionTime = $00be48392311af6a$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $00be48392311af6a$var$entangleAsyncAction(transition, returnValue);
    if (null !== $00be48392311af6a$var$entangledTransitionTypes) for(var root$28 = $00be48392311af6a$var$firstScheduledRoot; null !== root$28;)$00be48392311af6a$var$queueTransitionTypes(root$28, $00be48392311af6a$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $00be48392311af6a$var$firstScheduledRoot; null !== root$29;)$00be48392311af6a$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $00be48392311af6a$var$currentEntangledLane) {
            root$29 = $00be48392311af6a$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $00be48392311af6a$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $00be48392311af6a$var$prevOnStartTransitionFinish && $00be48392311af6a$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $00be48392311af6a$var$resumedCache = $00be48392311af6a$var$createCursor(null);
function $00be48392311af6a$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $00be48392311af6a$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $00be48392311af6a$var$workInProgressRoot.pooledCache;
}
function $00be48392311af6a$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $00be48392311af6a$var$push($00be48392311af6a$var$resumedCache, $00be48392311af6a$var$resumedCache.current) : $00be48392311af6a$var$push($00be48392311af6a$var$resumedCache, prevCachePool.pool);
}
function $00be48392311af6a$var$getSuspendedCache() {
    var cacheFromPool = $00be48392311af6a$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $00be48392311af6a$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $00be48392311af6a$var$SuspenseException = Error($00be48392311af6a$var$formatProdErrorMessage(460)), $00be48392311af6a$var$SuspenseyCommitException = Error($00be48392311af6a$var$formatProdErrorMessage(474)), $00be48392311af6a$var$SuspenseActionException = Error($00be48392311af6a$var$formatProdErrorMessage(542)), $00be48392311af6a$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $00be48392311af6a$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $00be48392311af6a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($00be48392311af6a$var$noop$1, $00be48392311af6a$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($00be48392311af6a$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($00be48392311af6a$var$noop$1, $00be48392311af6a$var$noop$1);
            else {
                thenableState = $00be48392311af6a$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($00be48392311af6a$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $00be48392311af6a$var$suspendedThenable = thenable;
            throw $00be48392311af6a$var$SuspenseException;
    }
}
function $00be48392311af6a$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $00be48392311af6a$var$suspendedThenable = x, $00be48392311af6a$var$SuspenseException;
        throw x;
    }
}
var $00be48392311af6a$var$suspendedThenable = null;
function $00be48392311af6a$var$getSuspendedThenable() {
    if (null === $00be48392311af6a$var$suspendedThenable) throw Error($00be48392311af6a$var$formatProdErrorMessage(459));
    var thenable = $00be48392311af6a$var$suspendedThenable;
    $00be48392311af6a$var$suspendedThenable = null;
    return thenable;
}
function $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $00be48392311af6a$var$SuspenseException || rejectedReason === $00be48392311af6a$var$SuspenseActionException) throw Error($00be48392311af6a$var$formatProdErrorMessage(483));
}
var $00be48392311af6a$var$thenableState$1 = null, $00be48392311af6a$var$thenableIndexCounter$1 = 0;
function $00be48392311af6a$var$unwrapThenable(thenable) {
    var index = $00be48392311af6a$var$thenableIndexCounter$1;
    $00be48392311af6a$var$thenableIndexCounter$1 += 1;
    null === $00be48392311af6a$var$thenableState$1 && ($00be48392311af6a$var$thenableState$1 = []);
    return $00be48392311af6a$var$trackUsedThenable($00be48392311af6a$var$thenableState$1, thenable, index);
}
function $00be48392311af6a$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $00be48392311af6a$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($00be48392311af6a$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($00be48392311af6a$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $00be48392311af6a$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $00be48392311af6a$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $00be48392311af6a$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $00be48392311af6a$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $00be48392311af6a$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $00be48392311af6a$var$REACT_LAZY_TYPE && $00be48392311af6a$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $00be48392311af6a$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $00be48392311af6a$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $00be48392311af6a$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $00be48392311af6a$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $00be48392311af6a$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $00be48392311af6a$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return lanes = $00be48392311af6a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return newChild = $00be48392311af6a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return newChild = $00be48392311af6a$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($00be48392311af6a$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $00be48392311af6a$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $00be48392311af6a$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $00be48392311af6a$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $00be48392311af6a$var$REACT_LAZY_TYPE && $00be48392311af6a$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $00be48392311af6a$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $00be48392311af6a$var$REACT_FRAGMENT_TYPE ? (lanes = $00be48392311af6a$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $00be48392311af6a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $00be48392311af6a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($00be48392311af6a$var$getIteratorFn(newChild)) {
                key = $00be48392311af6a$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($00be48392311af6a$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $00be48392311af6a$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $00be48392311af6a$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $00be48392311af6a$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $00be48392311af6a$var$SuspenseException || x === $00be48392311af6a$var$SuspenseActionException) throw x;
            var fiber = $00be48392311af6a$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $00be48392311af6a$var$reconcileChildFibers = $00be48392311af6a$var$createChildReconciler(!0), $00be48392311af6a$var$mountChildFibers = $00be48392311af6a$var$createChildReconciler(!1), $00be48392311af6a$var$hasForceUpdate = !1;
function $00be48392311af6a$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $00be48392311af6a$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $00be48392311af6a$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($00be48392311af6a$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
        $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $00be48392311af6a$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $00be48392311af6a$var$markRootEntangled(root, lane);
    }
}
function $00be48392311af6a$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $00be48392311af6a$var$didReadFromEntangledAsyncAction = !1;
function $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($00be48392311af6a$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $00be48392311af6a$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $00be48392311af6a$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $00be48392311af6a$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $00be48392311af6a$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($00be48392311af6a$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $00be48392311af6a$var$currentEntangledLane && ($00be48392311af6a$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $00be48392311af6a$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $00be48392311af6a$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $00be48392311af6a$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $00be48392311af6a$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($00be48392311af6a$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $00be48392311af6a$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$00be48392311af6a$var$callCallback(callbacks[updateQueue], context);
}
var $00be48392311af6a$var$currentTreeHiddenStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$prevEntangledRenderLanesCursor = $00be48392311af6a$var$createCursor(0);
function $00be48392311af6a$var$pushHiddenContext(fiber, context) {
    fiber = $00be48392311af6a$var$entangledRenderLanes;
    $00be48392311af6a$var$push($00be48392311af6a$var$prevEntangledRenderLanesCursor, fiber);
    $00be48392311af6a$var$push($00be48392311af6a$var$currentTreeHiddenStackCursor, context);
    $00be48392311af6a$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $00be48392311af6a$var$reuseHiddenContextOnStack() {
    $00be48392311af6a$var$push($00be48392311af6a$var$prevEntangledRenderLanesCursor, $00be48392311af6a$var$entangledRenderLanes);
    $00be48392311af6a$var$push($00be48392311af6a$var$currentTreeHiddenStackCursor, $00be48392311af6a$var$currentTreeHiddenStackCursor.current);
}
function $00be48392311af6a$var$popHiddenContext() {
    $00be48392311af6a$var$entangledRenderLanes = $00be48392311af6a$var$prevEntangledRenderLanesCursor.current;
    $00be48392311af6a$var$pop($00be48392311af6a$var$currentTreeHiddenStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$prevEntangledRenderLanesCursor);
}
var $00be48392311af6a$var$suspenseHandlerStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$shellBoundary = null;
function $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current & 1);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, handler);
    null === $00be48392311af6a$var$shellBoundary && (null === current || null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current ? $00be48392311af6a$var$shellBoundary = handler : null !== current.memoizedState && ($00be48392311af6a$var$shellBoundary = handler));
}
function $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, fiber);
    null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = fiber);
}
function $00be48392311af6a$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current), $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, fiber), null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = fiber)) : $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
}
function $00be48392311af6a$var$reuseSuspenseHandlerOnStack() {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, $00be48392311af6a$var$suspenseHandlerStackCursor.current);
}
function $00be48392311af6a$var$popSuspenseHandler(fiber) {
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseHandlerStackCursor);
    $00be48392311af6a$var$shellBoundary === fiber && ($00be48392311af6a$var$shellBoundary = null);
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseStackCursor);
}
var $00be48392311af6a$var$suspenseStackCursor = $00be48392311af6a$var$createCursor(0);
function $00be48392311af6a$var$pushSuspenseListContext(fiber, newContext) {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, $00be48392311af6a$var$suspenseHandlerStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, newContext);
}
function $00be48392311af6a$var$popSuspenseListContext(fiber) {
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseHandlerStackCursor);
    $00be48392311af6a$var$shellBoundary === fiber && ($00be48392311af6a$var$shellBoundary = null);
}
function $00be48392311af6a$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $00be48392311af6a$var$isSuspenseInstancePending(state) || $00be48392311af6a$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $00be48392311af6a$var$renderLanes = 0, $00be48392311af6a$var$currentlyRenderingFiber = null, $00be48392311af6a$var$currentHook = null, $00be48392311af6a$var$workInProgressHook = null, $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1, $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $00be48392311af6a$var$localIdCounter = 0, $00be48392311af6a$var$thenableIndexCounter = 0, $00be48392311af6a$var$thenableState = null, $00be48392311af6a$var$globalClientIdCounter = 0;
function $00be48392311af6a$var$throwInvalidHookError() {
    throw Error($00be48392311af6a$var$formatProdErrorMessage(321));
}
function $00be48392311af6a$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$00be48392311af6a$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $00be48392311af6a$var$renderLanes = nextRenderLanes;
    $00be48392311af6a$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $00be48392311af6a$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $00be48392311af6a$var$HooksDispatcherOnMount : $00be48392311af6a$var$HooksDispatcherOnUpdate;
    $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $00be48392311af6a$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $00be48392311af6a$var$finishRenderingHooks(current) {
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $00be48392311af6a$var$currentHook && null !== $00be48392311af6a$var$currentHook.next;
    $00be48392311af6a$var$renderLanes = 0;
    $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1;
    $00be48392311af6a$var$thenableIndexCounter = 0;
    $00be48392311af6a$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($00be48392311af6a$var$formatProdErrorMessage(300));
    null === current || $00be48392311af6a$var$didReceiveUpdate || (current = current.dependencies, null !== current && $00be48392311af6a$var$checkIfContextChanged(current) && ($00be48392311af6a$var$didReceiveUpdate = !0));
}
function $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $00be48392311af6a$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass && ($00be48392311af6a$var$thenableState = null);
        $00be48392311af6a$var$thenableIndexCounter = 0;
        $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($00be48392311af6a$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $00be48392311af6a$var$TransitionAwareHostComponent() {
    var dispatcher = $00be48392311af6a$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $00be48392311af6a$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $00be48392311af6a$var$currentHook ? $00be48392311af6a$var$currentHook.memoizedState : null) !== dispatcher && ($00be48392311af6a$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $00be48392311af6a$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $00be48392311af6a$var$localIdCounter;
    $00be48392311af6a$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $00be48392311af6a$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $00be48392311af6a$var$resetHooksOnUnwind(workInProgress) {
    if ($00be48392311af6a$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1;
    }
    $00be48392311af6a$var$renderLanes = 0;
    $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $00be48392311af6a$var$thenableIndexCounter = $00be48392311af6a$var$localIdCounter = 0;
    $00be48392311af6a$var$thenableState = null;
}
function $00be48392311af6a$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState = $00be48392311af6a$var$workInProgressHook = hook : $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$workInProgressHook.next = hook;
    return $00be48392311af6a$var$workInProgressHook;
}
function $00be48392311af6a$var$updateWorkInProgressHook() {
    if (null === $00be48392311af6a$var$currentHook) {
        var nextCurrentHook = $00be48392311af6a$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $00be48392311af6a$var$currentHook.next;
    var nextWorkInProgressHook = null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState : $00be48392311af6a$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $00be48392311af6a$var$workInProgressHook = nextWorkInProgressHook, $00be48392311af6a$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $00be48392311af6a$var$currentlyRenderingFiber.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(467));
            throw Error($00be48392311af6a$var$formatProdErrorMessage(310));
        }
        $00be48392311af6a$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $00be48392311af6a$var$currentHook.memoizedState,
            baseState: $00be48392311af6a$var$currentHook.baseState,
            baseQueue: $00be48392311af6a$var$currentHook.baseQueue,
            queue: $00be48392311af6a$var$currentHook.queue,
            next: null
        };
        null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState = $00be48392311af6a$var$workInProgressHook = nextCurrentHook : $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$workInProgressHook.next = nextCurrentHook;
    }
    return $00be48392311af6a$var$workInProgressHook;
}
function $00be48392311af6a$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $00be48392311af6a$var$useThenable(thenable) {
    var index = $00be48392311af6a$var$thenableIndexCounter;
    $00be48392311af6a$var$thenableIndexCounter += 1;
    null === $00be48392311af6a$var$thenableState && ($00be48392311af6a$var$thenableState = []);
    thenable = $00be48392311af6a$var$trackUsedThenable($00be48392311af6a$var$thenableState, thenable, index);
    index = $00be48392311af6a$var$currentlyRenderingFiber;
    null === (null === $00be48392311af6a$var$workInProgressHook ? index.memoizedState : $00be48392311af6a$var$workInProgressHook.next) && (index = index.alternate, $00be48392311af6a$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $00be48392311af6a$var$HooksDispatcherOnMount : $00be48392311af6a$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $00be48392311af6a$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $00be48392311af6a$var$useThenable(usable);
        if (usable.$$typeof === $00be48392311af6a$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return $00be48392311af6a$var$readContext(usable);
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(438, String(usable)));
}
function $00be48392311af6a$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $00be48392311af6a$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $00be48392311af6a$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $00be48392311af6a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $00be48392311af6a$var$updateReducer(reducer) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    return $00be48392311af6a$var$updateReducerImpl(hook, $00be48392311af6a$var$currentHook, reducer);
}
function $00be48392311af6a$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($00be48392311af6a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($00be48392311af6a$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($00be48392311af6a$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $00be48392311af6a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($00be48392311af6a$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $00be48392311af6a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $00be48392311af6a$var$currentlyRenderingFiber.lanes |= revertLane, $00be48392311af6a$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $00be48392311af6a$var$currentlyRenderingFiber.lanes |= updateLane, $00be48392311af6a$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$00be48392311af6a$var$objectIs(pendingQueue, hook.memoizedState) && ($00be48392311af6a$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $00be48392311af6a$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $00be48392311af6a$var$rerenderReducer(reducer) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($00be48392311af6a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $00be48392311af6a$var$objectIs(newState, hook.memoizedState) || ($00be48392311af6a$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $00be48392311af6a$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $00be48392311af6a$var$currentlyRenderingFiber, hook = $00be48392311af6a$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $00be48392311af6a$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($00be48392311af6a$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$00be48392311af6a$var$objectIs(($00be48392311af6a$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $00be48392311af6a$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $00be48392311af6a$var$updateEffect($00be48392311af6a$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $00be48392311af6a$var$workInProgressHook && 0 !== ($00be48392311af6a$var$workInProgressHook.memoizedState.tag & 1);
    $00be48392311af6a$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $00be48392311af6a$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $00be48392311af6a$var$workInProgressRoot) throw Error($00be48392311af6a$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($00be48392311af6a$var$renderLanes & 127) || $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $00be48392311af6a$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $00be48392311af6a$var$checkIfSnapshotChanged(inst) && $00be48392311af6a$var$forceStoreRerender(fiber);
}
function $00be48392311af6a$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $00be48392311af6a$var$checkIfSnapshotChanged(inst) && $00be48392311af6a$var$forceStoreRerender(fiber);
    });
}
function $00be48392311af6a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$00be48392311af6a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $00be48392311af6a$var$forceStoreRerender(fiber) {
    var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $00be48392311af6a$var$mountStateImpl(initialState) {
    var hook = $00be48392311af6a$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $00be48392311af6a$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $00be48392311af6a$var$updateReducerImpl(hook, $00be48392311af6a$var$currentHook, "function" === typeof reducer ? reducer : $00be48392311af6a$var$basicStateReducer);
}
function $00be48392311af6a$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) throw Error($00be48392311af6a$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $00be48392311af6a$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $00be48392311af6a$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $00be48392311af6a$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $00be48392311af6a$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $00be48392311af6a$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $00be48392311af6a$var$onActionError(actionQueue, node, error$70);
    }
}
function $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $00be48392311af6a$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $00be48392311af6a$var$onActionError(actionQueue, node, error);
    }) : $00be48392311af6a$var$onActionSuccess(actionQueue, node, returnValue);
}
function $00be48392311af6a$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $00be48392311af6a$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $00be48392311af6a$var$runActionStateAction(actionQueue, nextState)));
}
function $00be48392311af6a$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $00be48392311af6a$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $00be48392311af6a$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $00be48392311af6a$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $00be48392311af6a$var$mountActionState(action, initialStateProp) {
    if ($00be48392311af6a$var$isHydrating) {
        var ssrFormState = $00be48392311af6a$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $00be48392311af6a$var$currentlyRenderingFiber;
                if ($00be48392311af6a$var$isHydrating) {
                    if ($00be48392311af6a$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $00be48392311af6a$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $00be48392311af6a$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $00be48392311af6a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $00be48392311af6a$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $00be48392311af6a$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00be48392311af6a$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $00be48392311af6a$var$dispatchSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $00be48392311af6a$var$mountStateImpl(!1);
    inRootOrSingleton = $00be48392311af6a$var$dispatchOptimisticSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $00be48392311af6a$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $00be48392311af6a$var$dispatchActionState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $00be48392311af6a$var$updateActionState(action) {
    var stateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    return $00be48392311af6a$var$updateActionStateImpl(stateHook, $00be48392311af6a$var$currentHook, action);
}
function $00be48392311af6a$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $00be48392311af6a$var$updateReducerImpl(stateHook, currentStateHook, $00be48392311af6a$var$actionStateReducer)[0];
    stateHook = $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $00be48392311af6a$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $00be48392311af6a$var$SuspenseException) throw $00be48392311af6a$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($00be48392311af6a$var$currentlyRenderingFiber.flags |= 2048, $00be48392311af6a$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $00be48392311af6a$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $00be48392311af6a$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $00be48392311af6a$var$rerenderActionState(action) {
    var stateHook = $00be48392311af6a$var$updateWorkInProgressHook(), currentStateHook = $00be48392311af6a$var$currentHook;
    if (null !== currentStateHook) return $00be48392311af6a$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $00be48392311af6a$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $00be48392311af6a$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $00be48392311af6a$var$updateRef() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00be48392311af6a$var$mountWorkInProgressHook();
    $00be48392311af6a$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $00be48392311af6a$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $00be48392311af6a$var$currentHook && null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, $00be48392311af6a$var$currentHook.memoizedState.deps) ? hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($00be48392311af6a$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $00be48392311af6a$var$mountEffect(create, deps) {
    $00be48392311af6a$var$mountEffectImpl(8390656, 8, create, deps);
}
function $00be48392311af6a$var$updateEffect(create, deps) {
    $00be48392311af6a$var$updateEffectImpl(2048, 8, create, deps);
}
function $00be48392311af6a$var$useEffectEventImpl(payload) {
    $00be48392311af6a$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $00be48392311af6a$var$updateEvent(callback) {
    var ref = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
    $00be48392311af6a$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($00be48392311af6a$var$executionContext & 2)) throw Error($00be48392311af6a$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $00be48392311af6a$var$updateInsertionEffect(create, deps) {
    return $00be48392311af6a$var$updateEffectImpl(4, 2, create, deps);
}
function $00be48392311af6a$var$updateLayoutEffect(create, deps) {
    return $00be48392311af6a$var$updateEffectImpl(4, 4, create, deps);
}
function $00be48392311af6a$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $00be48392311af6a$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $00be48392311af6a$var$updateEffectImpl(4, 4, $00be48392311af6a$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $00be48392311af6a$var$mountDebugValue() {}
function $00be48392311af6a$var$updateCallback(callback, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $00be48392311af6a$var$updateMemo(nextCreate, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($00be48392311af6a$var$renderLanes & 1073741824) && 0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $00be48392311af6a$var$requestDeferredLane();
    $00be48392311af6a$var$currentlyRenderingFiber.lanes |= hook;
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $00be48392311af6a$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($00be48392311af6a$var$objectIs(value, prevValue)) return value;
    if (null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current) return hook = $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue), $00be48392311af6a$var$objectIs(hook, prevValue) || ($00be48392311af6a$var$didReceiveUpdate = !0), hook;
    if (0 === ($00be48392311af6a$var$renderLanes & 106) || 0 !== ($00be48392311af6a$var$renderLanes & 1073741824) && 0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 261930)) return $00be48392311af6a$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $00be48392311af6a$var$requestDeferredLane();
    $00be48392311af6a$var$currentlyRenderingFiber.lanes |= hook;
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $00be48392311af6a$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    $00be48392311af6a$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $00be48392311af6a$var$ReactSharedInternals.T = currentTransition;
    $00be48392311af6a$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $00be48392311af6a$var$chainThenableValue(returnValue, finishedState);
            $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $00be48392311af6a$var$requestUpdateLane(fiber));
        } else $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, finishedState, $00be48392311af6a$var$requestUpdateLane(fiber));
    } catch (error) {
        $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $00be48392311af6a$var$requestUpdateLane());
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$noop() {}
function $00be48392311af6a$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($00be48392311af6a$var$formatProdErrorMessage(476));
    var queue = $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber).queue;
    $00be48392311af6a$var$startTransition(formFiber, queue, pendingState, $00be48392311af6a$var$sharedNotPendingObject, null === action ? $00be48392311af6a$var$noop : function() {
        $00be48392311af6a$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $00be48392311af6a$var$sharedNotPendingObject,
        baseState: $00be48392311af6a$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
            lastRenderedState: $00be48392311af6a$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $00be48392311af6a$var$requestFormReset$1(formFiber) {
    var stateHook = $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $00be48392311af6a$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $00be48392311af6a$var$requestUpdateLane());
}
function $00be48392311af6a$var$useHostTransitionStatus() {
    return $00be48392311af6a$var$readContext($00be48392311af6a$var$HostTransitionContext);
}
function $00be48392311af6a$var$updateId() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$updateRefresh() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $00be48392311af6a$var$requestUpdateLane();
                fiber = $00be48392311af6a$var$createUpdate(lane);
                var root$73 = $00be48392311af6a$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($00be48392311af6a$var$scheduleUpdateOnFiber(root$73, provider, lane), $00be48392311af6a$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $00be48392311af6a$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $00be48392311af6a$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $00be48392311af6a$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $00be48392311af6a$var$isRenderPhaseUpdate(fiber) ? $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, action) : (action = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($00be48392311af6a$var$scheduleUpdateOnFiber(action, fiber, lane), $00be48392311af6a$var$entangleTransitionUpdate(action, queue, lane)));
}
function $00be48392311af6a$var$dispatchSetState(fiber, queue, action) {
    var lane = $00be48392311af6a$var$requestUpdateLane();
    $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($00be48392311af6a$var$objectIs(eagerState, currentState)) return $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, 0), null === $00be48392311af6a$var$workInProgressRoot && $00be48392311af6a$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $00be48392311af6a$var$scheduleUpdateOnFiber(action, fiber, lane), $00be48392311af6a$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $00be48392311af6a$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $00be48392311af6a$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($00be48392311af6a$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $00be48392311af6a$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $00be48392311af6a$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $00be48392311af6a$var$currentlyRenderingFiber || null !== alternate && alternate === $00be48392311af6a$var$currentlyRenderingFiber;
}
function $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, update) {
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $00be48392311af6a$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $00be48392311af6a$var$markRootEntangled(root, lane);
    }
}
var $00be48392311af6a$var$ContextOnlyDispatcher = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$throwInvalidHookError,
    useContext: $00be48392311af6a$var$throwInvalidHookError,
    useEffect: $00be48392311af6a$var$throwInvalidHookError,
    useImperativeHandle: $00be48392311af6a$var$throwInvalidHookError,
    useLayoutEffect: $00be48392311af6a$var$throwInvalidHookError,
    useInsertionEffect: $00be48392311af6a$var$throwInvalidHookError,
    useMemo: $00be48392311af6a$var$throwInvalidHookError,
    useReducer: $00be48392311af6a$var$throwInvalidHookError,
    useRef: $00be48392311af6a$var$throwInvalidHookError,
    useState: $00be48392311af6a$var$throwInvalidHookError,
    useDebugValue: $00be48392311af6a$var$throwInvalidHookError,
    useDeferredValue: $00be48392311af6a$var$throwInvalidHookError,
    useTransition: $00be48392311af6a$var$throwInvalidHookError,
    useSyncExternalStore: $00be48392311af6a$var$throwInvalidHookError,
    useId: $00be48392311af6a$var$throwInvalidHookError,
    useHostTransitionStatus: $00be48392311af6a$var$throwInvalidHookError,
    useFormState: $00be48392311af6a$var$throwInvalidHookError,
    useActionState: $00be48392311af6a$var$throwInvalidHookError,
    useOptimistic: $00be48392311af6a$var$throwInvalidHookError,
    useMemoCache: $00be48392311af6a$var$throwInvalidHookError,
    useCacheRefresh: $00be48392311af6a$var$throwInvalidHookError,
    useEffectEvent: $00be48392311af6a$var$throwInvalidHookError
}, $00be48392311af6a$var$HooksDispatcherOnMount = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: function(callback, deps) {
        $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $00be48392311af6a$var$mountEffectImpl(4194308, 4, $00be48392311af6a$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $00be48392311af6a$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $00be48392311af6a$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $00be48392311af6a$var$dispatchReducerAction.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $00be48392311af6a$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $00be48392311af6a$var$dispatchSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        return $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $00be48392311af6a$var$mountStateImpl(!1);
        stateHook = $00be48392311af6a$var$startTransition.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $00be48392311af6a$var$currentlyRenderingFiber, hook = $00be48392311af6a$var$mountWorkInProgressHook();
        if ($00be48392311af6a$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($00be48392311af6a$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $00be48392311af6a$var$workInProgressRoot) throw Error($00be48392311af6a$var$formatProdErrorMessage(349));
            0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 127) || $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $00be48392311af6a$var$mountEffect($00be48392311af6a$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $00be48392311af6a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $00be48392311af6a$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook(), identifierPrefix = $00be48392311af6a$var$workInProgressRoot.identifierPrefix;
        if ($00be48392311af6a$var$isHydrating) {
            var JSCompiler_inline_result = $00be48392311af6a$var$treeContextOverflow;
            var idWithLeadingBit = $00be48392311af6a$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $00be48392311af6a$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $00be48392311af6a$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $00be48392311af6a$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$mountActionState,
    useActionState: $00be48392311af6a$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $00be48392311af6a$var$dispatchOptimisticSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: function() {
        return $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = $00be48392311af6a$var$refreshCache.bind(null, $00be48392311af6a$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($00be48392311af6a$var$executionContext & 2)) throw Error($00be48392311af6a$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $00be48392311af6a$var$HooksDispatcherOnUpdate = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$updateCallback,
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$updateEffect,
    useImperativeHandle: $00be48392311af6a$var$updateImperativeHandle,
    useInsertionEffect: $00be48392311af6a$var$updateInsertionEffect,
    useLayoutEffect: $00be48392311af6a$var$updateLayoutEffect,
    useMemo: $00be48392311af6a$var$updateMemo,
    useReducer: $00be48392311af6a$var$updateReducer,
    useRef: $00be48392311af6a$var$updateRef,
    useState: function() {
        return $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer);
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return $00be48392311af6a$var$updateDeferredValueImpl(hook, $00be48392311af6a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer)[0], start = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00be48392311af6a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00be48392311af6a$var$updateSyncExternalStore,
    useId: $00be48392311af6a$var$updateId,
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$updateActionState,
    useActionState: $00be48392311af6a$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return $00be48392311af6a$var$updateOptimisticImpl(hook, $00be48392311af6a$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: $00be48392311af6a$var$updateRefresh,
    useEffectEvent: $00be48392311af6a$var$updateEvent
}, $00be48392311af6a$var$HooksDispatcherOnRerender = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$updateCallback,
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$updateEffect,
    useImperativeHandle: $00be48392311af6a$var$updateImperativeHandle,
    useInsertionEffect: $00be48392311af6a$var$updateInsertionEffect,
    useLayoutEffect: $00be48392311af6a$var$updateLayoutEffect,
    useMemo: $00be48392311af6a$var$updateMemo,
    useReducer: $00be48392311af6a$var$rerenderReducer,
    useRef: $00be48392311af6a$var$updateRef,
    useState: function() {
        return $00be48392311af6a$var$rerenderReducer($00be48392311af6a$var$basicStateReducer);
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return null === $00be48392311af6a$var$currentHook ? $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue) : $00be48392311af6a$var$updateDeferredValueImpl(hook, $00be48392311af6a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00be48392311af6a$var$rerenderReducer($00be48392311af6a$var$basicStateReducer)[0], start = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00be48392311af6a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00be48392311af6a$var$updateSyncExternalStore,
    useId: $00be48392311af6a$var$updateId,
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$rerenderActionState,
    useActionState: $00be48392311af6a$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        if (null !== $00be48392311af6a$var$currentHook) return $00be48392311af6a$var$updateOptimisticImpl(hook, $00be48392311af6a$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: $00be48392311af6a$var$updateRefresh,
    useEffectEvent: $00be48392311af6a$var$updateEvent
};
function $00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $00be48392311af6a$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $00be48392311af6a$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00be48392311af6a$var$scheduleUpdateOnFiber(payload, inst, lane), $00be48392311af6a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00be48392311af6a$var$scheduleUpdateOnFiber(payload, inst, lane), $00be48392311af6a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($00be48392311af6a$var$scheduleUpdateOnFiber(callback, inst, lane), $00be48392311af6a$var$entangleTransitions(callback, inst, lane));
    }
};
function $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$00be48392311af6a$var$shallowEqual(oldProps, newProps) || !$00be48392311af6a$var$shallowEqual(oldState, newState) : !0;
}
function $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $00be48392311af6a$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $00be48392311af6a$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $00be48392311af6a$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $00be48392311af6a$var$defaultOnUncaughtError(error) {
    $00be48392311af6a$var$reportGlobalError(error);
}
function $00be48392311af6a$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $00be48392311af6a$var$defaultOnRecoverableError(error) {
    $00be48392311af6a$var$reportGlobalError(error);
}
function $00be48392311af6a$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $00be48392311af6a$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $00be48392311af6a$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $00be48392311af6a$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $00be48392311af6a$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $00be48392311af6a$var$createClassErrorUpdate(lane) {
    lane = $00be48392311af6a$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $00be48392311af6a$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $00be48392311af6a$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $00be48392311af6a$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed ? $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $00be48392311af6a$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $00be48392311af6a$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $00be48392311af6a$var$shellBoundary ? $00be48392311af6a$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $00be48392311af6a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $00be48392311af6a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($00be48392311af6a$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes);
        $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($00be48392311af6a$var$isHydrating) return returnFiber = $00be48392311af6a$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $00be48392311af6a$var$HydrationMismatchException && (root = Error($00be48392311af6a$var$formatProdErrorMessage(422), {
        cause: value
    }), $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $00be48392311af6a$var$HydrationMismatchException && (returnFiber = Error($00be48392311af6a$var$formatProdErrorMessage(423), {
        cause: value
    }), $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $00be48392311af6a$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $00be48392311af6a$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $00be48392311af6a$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($00be48392311af6a$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $00be48392311af6a$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $00be48392311af6a$var$workInProgressRootConcurrentErrors ? $00be48392311af6a$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $00be48392311af6a$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $00be48392311af6a$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $00be48392311af6a$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $00be48392311af6a$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed || !$00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $00be48392311af6a$var$createClassErrorUpdate(rootRenderLanes), $00be48392311af6a$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $00be48392311af6a$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $00be48392311af6a$var$SelectiveHydrationException = Error($00be48392311af6a$var$formatProdErrorMessage(461)), $00be48392311af6a$var$didReceiveUpdate = !1;
function $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $00be48392311af6a$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $00be48392311af6a$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    nextProps = $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && key && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$00be48392311af6a$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $00be48392311af6a$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $00be48392311af6a$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $00be48392311af6a$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($00be48392311af6a$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($00be48392311af6a$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($00be48392311af6a$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $00be48392311af6a$var$pushHiddenContext(workInProgress, prevState) : $00be48392311af6a$var$reuseHiddenContextOnStack(), $00be48392311af6a$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($00be48392311af6a$var$pushTransition(workInProgress, prevState.cachePool), $00be48392311af6a$var$pushHiddenContext(workInProgress, prevState), $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null), $00be48392311af6a$var$reuseHiddenContextOnStack(), $00be48392311af6a$var$reuseSuspenseHandlerOnStack());
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $00be48392311af6a$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $00be48392311af6a$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null);
    $00be48392311af6a$var$reuseHiddenContextOnStack();
    $00be48392311af6a$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00be48392311af6a$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $00be48392311af6a$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($00be48392311af6a$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $00be48392311af6a$var$bailoutOffscreenComponent(null, current);
            $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $00be48392311af6a$var$nextHydratableInstance) ? (current = $00be48392311af6a$var$canHydrateHydrationBoundary(current, $00be48392311af6a$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00be48392311af6a$var$treeContextProvider ? {
                    id: $00be48392311af6a$var$treeContextId,
                    overflow: $00be48392311af6a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00be48392311af6a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($00be48392311af6a$var$formatProdErrorMessage(558));
        } else if ($00be48392311af6a$var$didReceiveUpdate || $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $00be48392311af6a$var$didReceiveUpdate || didSuspend) {
            if (null === $00be48392311af6a$var$currentTreeHiddenStackCursor.current) {
                nextProps = $00be48392311af6a$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $00be48392311af6a$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $00be48392311af6a$var$enqueueConcurrentRenderForLane(current, dehydrated), $00be48392311af6a$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $00be48392311af6a$var$SelectiveHydrationException;
                $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(dehydrated.nextSibling), $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$isHydrating = !0, $00be48392311af6a$var$hydrationErrors = null, $00be48392311af6a$var$rootOrSingletonContext = !1, null !== current && $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $00be48392311af6a$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $00be48392311af6a$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($00be48392311af6a$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    Component = $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && nextProps && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $00be48392311af6a$var$finishRenderingHooks(current);
    Component = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && Component && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $00be48392311af6a$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $00be48392311af6a$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $00be48392311af6a$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $00be48392311af6a$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $00be48392311af6a$var$readContext(contextType) : $00be48392311af6a$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $00be48392311af6a$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $00be48392311af6a$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $00be48392311af6a$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $00be48392311af6a$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $00be48392311af6a$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $00be48392311af6a$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $00be48392311af6a$var$hasForceUpdate || $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $00be48392311af6a$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $00be48392311af6a$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $00be48392311af6a$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $00be48392311af6a$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $00be48392311af6a$var$hasForceUpdate || null !== current && null !== current.dependencies && $00be48392311af6a$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $00be48392311af6a$var$hasForceUpdate || $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $00be48392311af6a$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $00be48392311af6a$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $00be48392311af6a$var$resetHydrationState();
    workInProgress.flags |= 256;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $00be48392311af6a$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $00be48392311af6a$var$getSuspendedCache()
    };
}
function $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $00be48392311af6a$var$workInProgressDeferredLane);
    return current;
}
function $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($00be48392311af6a$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($00be48392311af6a$var$isHydrating) {
            showFallback ? $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
            (current = $00be48392311af6a$var$nextHydratableInstance) ? (current = $00be48392311af6a$var$canHydrateHydrationBoundary(current, $00be48392311af6a$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00be48392311af6a$var$treeContextProvider ? {
                    id: $00be48392311af6a$var$treeContextId,
                    overflow: $00be48392311af6a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00be48392311af6a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            $00be48392311af6a$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $00be48392311af6a$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER, $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps);
        $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $00be48392311af6a$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $00be48392311af6a$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $00be48392311af6a$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $00be48392311af6a$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $00be48392311af6a$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $00be48392311af6a$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER, $00be48392311af6a$var$bailoutOffscreenComponent(current.child, nextProps);
    $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $00be48392311af6a$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $00be48392311af6a$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $00be48392311af6a$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $00be48392311af6a$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $00be48392311af6a$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER;
        return $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps);
    }
    $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($00be48392311af6a$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($00be48392311af6a$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $00be48392311af6a$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $00be48392311af6a$var$didReceiveUpdate || $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($00be48392311af6a$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current) return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $00be48392311af6a$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $00be48392311af6a$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $00be48392311af6a$var$enqueueConcurrentRenderForLane(current, nextProps), $00be48392311af6a$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $00be48392311af6a$var$SelectiveHydrationException;
        $00be48392311af6a$var$isSuspenseInstancePending(suspenseInstance) || $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
        return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($00be48392311af6a$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(suspenseInstance.nextSibling);
    $00be48392311af6a$var$hydrationParentFiber = workInProgress;
    $00be48392311af6a$var$isHydrating = !0;
    $00be48392311af6a$var$hydrationErrors = null;
    $00be48392311af6a$var$rootOrSingletonContext = !1;
    null !== current && $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $00be48392311af6a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $00be48392311af6a$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $00be48392311af6a$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $00be48392311af6a$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $00be48392311af6a$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $00be48392311af6a$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $00be48392311af6a$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($00be48392311af6a$var$reverseChildren(current), $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $00be48392311af6a$var$reverseChildren(current)) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $00be48392311af6a$var$isHydrating ? $00be48392311af6a$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $00be48392311af6a$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $00be48392311af6a$var$reverseChildren(workInProgress));
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $00be48392311af6a$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $00be48392311af6a$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $00be48392311af6a$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $00be48392311af6a$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($00be48392311af6a$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $00be48392311af6a$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $00be48392311af6a$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $00be48392311af6a$var$checkIfContextChanged(current) ? !0 : !1;
}
function $00be48392311af6a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, current.memoizedState.cache);
            $00be48392311af6a$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $00be48392311af6a$var$pushHostContext(workInProgress);
            break;
        case 4:
            $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $00be48392311af6a$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $00be48392311af6a$var$pushSuspenseListContext(workInProgress, $00be48392311af6a$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, current.memoizedState.cache);
    }
    return $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $00be48392311af6a$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $00be48392311af6a$var$didReceiveUpdate = !0;
        else {
            if (!$00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $00be48392311af6a$var$didReceiveUpdate = !1, $00be48392311af6a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $00be48392311af6a$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $00be48392311af6a$var$didReceiveUpdate = !1, $00be48392311af6a$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $00be48392311af6a$var$pushTreeId(workInProgress, $00be48392311af6a$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $00be48392311af6a$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $00be48392311af6a$var$shouldConstruct(current) ? (props = $00be48392311af6a$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $00be48392311af6a$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $00be48392311af6a$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $00be48392311af6a$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $00be48392311af6a$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $00be48392311af6a$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $00be48392311af6a$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $00be48392311af6a$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $00be48392311af6a$var$getComponentNameFromType(current) || current;
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $00be48392311af6a$var$resolveClassComponentProps(props, workInProgress.pendingProps), $00be48392311af6a$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress);
                $00be48392311af6a$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props);
                props !== prevState.cache && $00be48392311af6a$var$propagateContextChanges(workInProgress, [
                    $00be48392311af6a$var$CacheContext
                ], renderLanes, !0);
                $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $00be48392311af6a$var$createCapturedValueAtFiber(Error($00be48392311af6a$var$formatProdErrorMessage(424)), workInProgress);
                        $00be48392311af6a$var$queueHydrationError($$typeof);
                        workInProgress = $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(current.firstChild);
                        $00be48392311af6a$var$hydrationParentFiber = workInProgress;
                        $00be48392311af6a$var$isHydrating = !0;
                        $00be48392311af6a$var$hydrationErrors = null;
                        $00be48392311af6a$var$rootOrSingletonContext = !0;
                        renderLanes = $00be48392311af6a$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $00be48392311af6a$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $00be48392311af6a$var$markRef(current, workInProgress), null === current ? (renderLanes = $00be48392311af6a$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $00be48392311af6a$var$isHydrating || (workInProgress.stateNode = $00be48392311af6a$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $00be48392311af6a$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $00be48392311af6a$var$pushHostContext(workInProgress), null === current && $00be48392311af6a$var$isHydrating && (props = workInProgress.stateNode = $00be48392311af6a$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootInstanceStackCursor.current), $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$rootOrSingletonContext = !0, $$typeof = $00be48392311af6a$var$nextHydratableInstance, $00be48392311af6a$var$isSingletonScope(workInProgress.type) ? ($00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(props.firstChild)) : $00be48392311af6a$var$nextHydratableInstance = $$typeof), $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $00be48392311af6a$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $00be48392311af6a$var$isHydrating) {
                if ($$typeof = props = $00be48392311af6a$var$nextHydratableInstance) props = $00be48392311af6a$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(props.firstChild), $00be48392311af6a$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            }
            $00be48392311af6a$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $00be48392311af6a$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $00be48392311af6a$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $00be48392311af6a$var$renderWithHooks(current, workInProgress, $00be48392311af6a$var$TransitionAwareHostComponent, null, null, renderLanes), $00be48392311af6a$var$HostTransitionContext._currentValue = $$typeof);
            $00be48392311af6a$var$markRef(current, workInProgress);
            $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $00be48392311af6a$var$isHydrating) {
                if (current = renderLanes = $00be48392311af6a$var$nextHydratableInstance) renderLanes = $00be48392311af6a$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $00be48392311af6a$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $00be48392311af6a$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $00be48392311af6a$var$markRef(current, workInProgress), $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $00be48392311af6a$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $00be48392311af6a$var$prepareToReadContext(workInProgress), $$typeof = $00be48392311af6a$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $00be48392311af6a$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $00be48392311af6a$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $00be48392311af6a$var$prepareToReadContext(workInProgress), props = $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext), null === current ? ($$typeof = $00be48392311af6a$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $00be48392311af6a$var$workInProgressRoot, prevState = $00be48392311af6a$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $00be48392311af6a$var$initializeUpdateQueue(workInProgress), $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($00be48392311af6a$var$cloneUpdateQueue(current, workInProgress), $00be48392311af6a$var$processUpdateQueue(workInProgress, null, null, renderLanes), $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props)) : (props = prevState.cache, $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props), props !== $$typeof.cache && $00be48392311af6a$var$propagateContextChanges(workInProgress, [
                $00be48392311af6a$var$CacheContext
            ], renderLanes, !0))), $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $00be48392311af6a$var$markRef(current, workInProgress), $00be48392311af6a$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00be48392311af6a$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $00be48392311af6a$var$maySuspendCommit(type, newProps) : $00be48392311af6a$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($00be48392311af6a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $00be48392311af6a$var$suspendedThenable = $00be48392311af6a$var$noopSuspenseyCommitThenable, $00be48392311af6a$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$00be48392311af6a$var$preloadResource(resource)) {
        if ($00be48392311af6a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $00be48392311af6a$var$suspendedThenable = $00be48392311af6a$var$noopSuspenseyCommitThenable, $00be48392311af6a$var$SuspenseyCommitException;
    }
}
function $00be48392311af6a$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $00be48392311af6a$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $00be48392311af6a$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $00be48392311af6a$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$00be48392311af6a$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $00be48392311af6a$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $00be48392311af6a$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $00be48392311af6a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 1:
            return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
            $00be48392311af6a$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $00be48392311af6a$var$popHydrationState(workInProgress) ? $00be48392311af6a$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable());
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($00be48392311af6a$var$markUpdate(workInProgress), null !== nextResource ? ($00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($00be48392311af6a$var$markUpdate(workInProgress), $00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00be48392311af6a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $00be48392311af6a$var$markUpdate(workInProgress), $00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $00be48392311af6a$var$popHostContext(workInProgress);
            renderLanes = $00be48392311af6a$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $00be48392311af6a$var$contextStackCursor.current;
                $00be48392311af6a$var$popHydrationState(workInProgress) ? $00be48392311af6a$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $00be48392311af6a$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $00be48392311af6a$var$markUpdate(workInProgress));
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $00be48392311af6a$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $00be48392311af6a$var$contextStackCursor.current;
                if ($00be48392311af6a$var$popHydrationState(workInProgress)) $00be48392311af6a$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $00be48392311af6a$var$getOwnerDocumentFromRootContainer($00be48392311af6a$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    nextResource[$00be48392311af6a$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($00be48392311af6a$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $00be48392311af6a$var$markUpdate(workInProgress);
                }
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                current = $00be48392311af6a$var$rootInstanceStackCursor.current;
                if ($00be48392311af6a$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $00be48392311af6a$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $00be48392311af6a$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$00be48392311af6a$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $00be48392311af6a$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($00be48392311af6a$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($00be48392311af6a$var$formatProdErrorMessage(557));
                        current[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    } else $00be48392311af6a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $00be48392311af6a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($00be48392311af6a$var$formatProdErrorMessage(558));
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $00be48392311af6a$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
                        type[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    } else $00be48392311af6a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $00be48392311af6a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $00be48392311af6a$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $00be48392311af6a$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $00be48392311af6a$var$popHostContainer(), null === current && $00be48392311af6a$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 10:
            return $00be48392311af6a$var$popProvider(workInProgress.type), $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 19:
            $00be48392311af6a$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $00be48392311af6a$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $00be48392311af6a$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $00be48392311af6a$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$00be48392311af6a$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $00be48392311af6a$var$pushSuspenseListContext(workInProgress, $00be48392311af6a$var$suspenseStackCursor.current & 1 | 2);
                            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $00be48392311af6a$var$now() > $00be48392311af6a$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $00be48392311af6a$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $00be48392311af6a$var$scheduleRetryEffect(workInProgress, current), $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$00be48392311af6a$var$isHydrating) return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
                    } else 2 * $00be48392311af6a$var$now() - newProps.renderingStartTime > $00be48392311af6a$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $00be48392311af6a$var$now();
                current.sibling = null;
                nextResource = $00be48392311af6a$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $00be48392311af6a$var$isHydrating ? $00be48392311af6a$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, workInProgress), $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, renderLanes), null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = workInProgress));
                $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $00be48392311af6a$var$popSuspenseHandler(workInProgress), $00be48392311af6a$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($00be48392311af6a$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $00be48392311af6a$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $00be48392311af6a$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $00be48392311af6a$var$bubbleProperties(workInProgress), null;
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00be48392311af6a$var$unwindWork(current, workInProgress) {
    $00be48392311af6a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), $00be48392311af6a$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $00be48392311af6a$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(340));
                $00be48392311af6a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $00be48392311af6a$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(340));
                $00be48392311af6a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $00be48392311af6a$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $00be48392311af6a$var$popHostContainer(), null;
        case 10:
            return $00be48392311af6a$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $00be48392311af6a$var$popSuspenseHandler(workInProgress), $00be48392311af6a$var$popHiddenContext(), null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $00be48392311af6a$var$unwindInterruptedWork(current, interruptedWork) {
    $00be48392311af6a$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
            $00be48392311af6a$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $00be48392311af6a$var$popHostContext(interruptedWork);
            break;
        case 4:
            $00be48392311af6a$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $00be48392311af6a$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $00be48392311af6a$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            $00be48392311af6a$var$popHiddenContext();
            null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache);
            break;
        case 24:
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
    }
}
function $00be48392311af6a$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $00be48392311af6a$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $00be48392311af6a$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00be48392311af6a$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $00be48392311af6a$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00be48392311af6a$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $00be48392311af6a$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $00be48392311af6a$var$FragmentInstance(current);
                        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $00be48392311af6a$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00be48392311af6a$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $00be48392311af6a$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$00be48392311af6a$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $00be48392311af6a$var$isFragmentInstanceParent(parent) && $00be48392311af6a$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $00be48392311af6a$var$isFragmentInstanceParent(parent) && $00be48392311af6a$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $00be48392311af6a$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $00be48392311af6a$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $00be48392311af6a$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$00be48392311af6a$var$internalPropsKey] = newProps;
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $00be48392311af6a$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $00be48392311af6a$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $00be48392311af6a$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $00be48392311af6a$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $00be48392311af6a$var$noop$1)), $00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $00be48392311af6a$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $00be48392311af6a$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $00be48392311af6a$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $00be48392311af6a$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $00be48392311af6a$var$setInitialProperties(singleton, type, props);
        singleton[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
        singleton[$00be48392311af6a$var$internalPropsKey] = props;
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $00be48392311af6a$var$shouldStartViewTransition = !1, $00be48392311af6a$var$appearingViewTransitions = null;
function $00be48392311af6a$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $00be48392311af6a$var$shouldStartViewTransition = !0;
}
var $00be48392311af6a$var$viewTransitionCancelableChildren = null;
function $00be48392311af6a$var$pushViewTransitionCancelableScope() {
    var prevChildren = $00be48392311af6a$var$viewTransitionCancelableChildren;
    $00be48392311af6a$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
function $00be48392311af6a$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
    return $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $00be48392311af6a$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $00be48392311af6a$var$measureInstance(instance).view && (inViewport = !0);
            $00be48392311af6a$var$shouldStartViewTransition = !0;
            $00be48392311af6a$var$applyViewTransitionName(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? name : name + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, className);
            $00be48392311af6a$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $00be48392311af6a$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $00be48392311af6a$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $00be48392311af6a$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $00be48392311af6a$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($00be48392311af6a$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($00be48392311af6a$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($00be48392311af6a$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $00be48392311af6a$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $00be48392311af6a$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, state), className = $00be48392311af6a$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $00be48392311af6a$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($00be48392311af6a$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $00be48392311af6a$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $00be48392311af6a$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$00be48392311af6a$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $00be48392311af6a$var$commitAppearingPairViewTransitions(placement);
}
function $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $00be48392311af6a$var$appearingViewTransitions && 0 !== $00be48392311af6a$var$appearingViewTransitions.size) {
        var pairs = $00be48392311af6a$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($00be48392311af6a$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $00be48392311af6a$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $00be48392311af6a$var$appearingViewTransitions ? $00be48392311af6a$var$appearingViewTransitions.get(name) : void 0, className = $00be48392311af6a$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($00be48392311af6a$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $00be48392311af6a$var$appearingViewTransitions.delete(name), $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onExit) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $00be48392311af6a$var$appearingViewTransitions && $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$00be48392311af6a$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $00be48392311af6a$var$appearingViewTransitions && $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
}
function $00be48392311af6a$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, changedParent.stateNode);
            props = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $00be48392311af6a$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $00be48392311af6a$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $00be48392311af6a$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $00be48392311af6a$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $00be48392311af6a$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $00be48392311af6a$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $00be48392311af6a$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$00be48392311af6a$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $00be48392311af6a$var$restorePairedViewTransitions(fiber);
}
function $00be48392311af6a$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $00be48392311af6a$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $00be48392311af6a$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$00be48392311af6a$var$viewTransitionHostInstanceIdx], nextMeasurement = $00be48392311af6a$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $00be48392311af6a$var$applyViewTransitionName(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $00be48392311af6a$var$viewTransitionCancelableChildren && ($00be48392311af6a$var$viewTransitionCancelableChildren = []), $00be48392311af6a$var$viewTransitionCancelableChildren.push(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $00be48392311af6a$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $00be48392311af6a$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $00be48392311af6a$var$getViewTransitionName(props, state), className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($00be48392311af6a$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
            name = $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $00be48392311af6a$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $00be48392311af6a$var$offscreenSubtreeIsHidden = !1, $00be48392311af6a$var$offscreenSubtreeWasHidden = !1, $00be48392311af6a$var$offscreenDirectParentIsHidden = !1, $00be48392311af6a$var$needsFormReset = !1, $00be48392311af6a$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $00be48392311af6a$var$nextEffect = null, $00be48392311af6a$var$viewTransitionContextChanged = !1, $00be48392311af6a$var$inUpdateViewTransition = !1, $00be48392311af6a$var$rootViewTransitionAffected = !1, $00be48392311af6a$var$rootViewTransitionNameCanceled = !1;
function $00be48392311af6a$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $00be48392311af6a$var$eventsEnabled = $00be48392311af6a$var$_enabled;
    root = $00be48392311af6a$var$getActiveElementDeep(root);
    if ($00be48392311af6a$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $00be48392311af6a$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $00be48392311af6a$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $00be48392311af6a$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $00be48392311af6a$var$nextEffect;){
        root = $00be48392311af6a$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $00be48392311af6a$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $00be48392311af6a$var$trackEnterViewTransitions(root), $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $00be48392311af6a$var$commitExitViewTransitions(JSCompiler_temp);
                    $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $00be48392311af6a$var$trackEnterViewTransitions(root);
                    $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $00be48392311af6a$var$nextEffect = JSCompiler_temp) : (committedLanes && $00be48392311af6a$var$commitNestedViewTransitions(root), $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $00be48392311af6a$var$appearingViewTransitions = null;
}
function $00be48392311af6a$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $00be48392311af6a$var$nextEffect;){
        var fiber = $00be48392311af6a$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $00be48392311af6a$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $00be48392311af6a$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $00be48392311af6a$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $00be48392311af6a$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $00be48392311af6a$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($00be48392311af6a$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $00be48392311af6a$var$nextEffect = current;
            break;
        }
        $00be48392311af6a$var$nextEffect = fiber.return;
    }
}
function $00be48392311af6a$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $00be48392311af6a$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $00be48392311af6a$var$commitClassCallbacks(finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $00be48392311af6a$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $00be48392311af6a$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $00be48392311af6a$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $00be48392311af6a$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $00be48392311af6a$var$offscreenSubtreeWasHidden;
                current = $00be48392311af6a$var$offscreenSubtreeIsHidden;
                prevProps = $00be48392311af6a$var$offscreenSubtreeWasHidden;
                $00be48392311af6a$var$offscreenSubtreeIsHidden = flags;
                ($00be48392311af6a$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $00be48392311af6a$var$offscreenSubtreeIsHidden = current;
                $00be48392311af6a$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $00be48392311af6a$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $00be48392311af6a$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $00be48392311af6a$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $00be48392311af6a$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $00be48392311af6a$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $00be48392311af6a$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $00be48392311af6a$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $00be48392311af6a$var$hostParent = null, $00be48392311af6a$var$hostParentIsContainer = !1;
function $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$00be48392311af6a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $00be48392311af6a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onCommitFiberUnmount) try {
        $00be48392311af6a$var$injectedHook.onCommitFiberUnmount($00be48392311af6a$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$00be48392311af6a$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $00be48392311af6a$var$hostParent, prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$isSingletonScope(deletedFiber.type) && ($00be48392311af6a$var$hostParent = deletedFiber.stateNode, $00be48392311af6a$var$hostParentIsContainer = !1);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $00be48392311af6a$var$hostParent;
            prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$hostParent = null;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $00be48392311af6a$var$hostParent) {
                if ($00be48392311af6a$var$hostParentIsContainer) try {
                    (9 === $00be48392311af6a$var$hostParent.nodeType ? $00be48392311af6a$var$hostParent.body : "HTML" === $00be48392311af6a$var$hostParent.nodeName ? $00be48392311af6a$var$hostParent.ownerDocument.body : $00be48392311af6a$var$hostParent).removeChild(deletedFiber.stateNode), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $00be48392311af6a$var$hostParent.removeChild(deletedFiber.stateNode), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $00be48392311af6a$var$hostParent && ($00be48392311af6a$var$hostParentIsContainer ? (finishedRoot = $00be48392311af6a$var$hostParent, $00be48392311af6a$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $00be48392311af6a$var$retryIfBlockedOn(finishedRoot)) : $00be48392311af6a$var$clearHydrationBoundary($00be48392311af6a$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $00be48392311af6a$var$hostParent;
            prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$hostParent = deletedFiber.stateNode.containerInfo;
            $00be48392311af6a$var$hostParentIsContainer = !0;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $00be48392311af6a$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || ($00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $00be48392311af6a$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $00be48392311af6a$var$offscreenSubtreeWasHidden = (prevHostParent = $00be48392311af6a$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $00be48392311af6a$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $00be48392311af6a$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $00be48392311af6a$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $00be48392311af6a$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $00be48392311af6a$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $00be48392311af6a$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $00be48392311af6a$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($00be48392311af6a$var$isSingletonScope(parent.type)) {
                        $00be48392311af6a$var$hostParent = parent.stateNode;
                        $00be48392311af6a$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $00be48392311af6a$var$hostParent = parent.stateNode;
                    $00be48392311af6a$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $00be48392311af6a$var$hostParent = parent.stateNode.containerInfo;
                    $00be48392311af6a$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $00be48392311af6a$var$hostParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(160));
        $00be48392311af6a$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $00be48392311af6a$var$hostParent = null;
        $00be48392311af6a$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $00be48392311af6a$var$currentHoistableRoot = null;
function $00be48392311af6a$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($00be48392311af6a$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $00be48392311af6a$var$commitHookEffectListMount(3, finishedWork), $00be48392311af6a$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            flags & 64 && $00be48392311af6a$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($00be48392311af6a$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $00be48392311af6a$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$00be48392311af6a$var$internalHoistableMarker] || current[$00be48392311af6a$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            current[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
                                            $00be48392311af6a$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $00be48392311af6a$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $00be48392311af6a$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($00be48392311af6a$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
                                    $00be48392311af6a$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $00be48392311af6a$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $00be48392311af6a$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $00be48392311af6a$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $00be48392311af6a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $00be48392311af6a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = !1;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$offscreenDirectParentIsHidden = ii;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $00be48392311af6a$var$setTextContent(root, ""), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $00be48392311af6a$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($00be48392311af6a$var$needsFormReset = !0);
            break;
        case 6:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $00be48392311af6a$var$viewTransitionMutationContext = !1;
            $00be48392311af6a$var$tagCaches = null;
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(root.containerInfo);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$currentHoistableRoot = ii;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $00be48392311af6a$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $00be48392311af6a$var$needsFormReset && ($00be48392311af6a$var$needsFormReset = !1, $00be48392311af6a$var$recursivelyResetForms(finishedWork));
            $00be48392311af6a$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = $00be48392311af6a$var$offscreenSubtreeIsHidden;
            current = $00be48392311af6a$var$pushMutationContext();
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            $00be48392311af6a$var$currentHoistableRoot = ii;
            $00be48392311af6a$var$viewTransitionMutationContext && $00be48392311af6a$var$inUpdateViewTransition && ($00be48392311af6a$var$rootViewTransitionAffected = !0);
            $00be48392311af6a$var$viewTransitionMutationContext = current;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($00be48392311af6a$var$globalMostRecentFallbackTime = $00be48392311af6a$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $00be48392311af6a$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $00be48392311af6a$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $00be48392311af6a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $00be48392311af6a$var$offscreenSubtreeWasHidden, lanes = $00be48392311af6a$var$offscreenSubtreeIsHidden, current = $00be48392311af6a$var$offscreenSubtreeWasHidden, $00be48392311af6a$var$offscreenSubtreeIsHidden = ii || $00be48392311af6a$var$offscreenSubtreeIsHidden, $00be48392311af6a$var$offscreenSubtreeWasHidden = root, $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $00be48392311af6a$var$offscreenSubtreeIsHidden = lanes, $00be48392311af6a$var$offscreenSubtreeWasHidden = current), !ii && $00be48392311af6a$var$offscreenDirectParentIsHidden || $00be48392311af6a$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            flags = $00be48392311af6a$var$pushMutationContext();
            ii = $00be48392311af6a$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $00be48392311af6a$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $00be48392311af6a$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $00be48392311af6a$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $00be48392311af6a$var$inUpdateViewTransition = ii;
            $00be48392311af6a$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
    }
}
function $00be48392311af6a$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($00be48392311af6a$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($00be48392311af6a$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($00be48392311af6a$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $00be48392311af6a$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $00be48392311af6a$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $00be48392311af6a$var$_enabled = !0, fiber.reset(), $00be48392311af6a$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $00be48392311af6a$var$measureNestedViewTransitions(parentFiber, !1);
}
function $00be48392311af6a$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $00be48392311af6a$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $00be48392311af6a$var$rootViewTransitionNameCanceled = $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$pushViewTransitionCancelableScope();
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$00be48392311af6a$var$viewTransitionContextChanged && !$00be48392311af6a$var$rootViewTransitionAffected) {
                finishedWork = $00be48392311af6a$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $00be48392311af6a$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $00be48392311af6a$var$rootViewTransitionNameCanceled = !0;
            }
            $00be48392311af6a$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $00be48392311af6a$var$viewTransitionContextChanged;
            $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $00be48392311af6a$var$viewTransitionContextChanged && ($00be48392311af6a$var$rootViewTransitionAffected = !0);
            $00be48392311af6a$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $00be48392311af6a$var$commitEnterViewTransitions(finishedWork, !1) : $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $00be48392311af6a$var$viewTransitionContextChanged;
            oldName = $00be48392311af6a$var$pushViewTransitionCancelableScope();
            $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $00be48392311af6a$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $00be48392311af6a$var$getViewTransitionName(props, state);
            state = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, state);
            var className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0, root = $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $00be48392311af6a$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($00be48392311af6a$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $00be48392311af6a$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $00be48392311af6a$var$viewTransitionCancelableChildren), $00be48392311af6a$var$viewTransitionCancelableChildren = oldName);
            $00be48392311af6a$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $00be48392311af6a$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $00be48392311af6a$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $00be48392311af6a$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $00be48392311af6a$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$00be48392311af6a$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $00be48392311af6a$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $00be48392311af6a$var$commitClassCallbacks(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable($00be48392311af6a$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $00be48392311af6a$var$releaseCache(previousCache));
}
function $00be48392311af6a$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $00be48392311af6a$var$releaseCache(current));
}
function $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $00be48392311af6a$var$restoreNestedViewTransitions(parentFiber);
}
function $00be48392311af6a$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00be48392311af6a$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $00be48392311af6a$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $00be48392311af6a$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($00be48392311af6a$var$restoreViewTransitionOnHostInstances(flags.child, !0), $00be48392311af6a$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $00be48392311af6a$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $00be48392311af6a$var$suspenseyCommitFlag = 8192;
function $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $00be48392311af6a$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $00be48392311af6a$var$suspendResource(suspendedState, $00be48392311af6a$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $00be48392311af6a$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $00be48392311af6a$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $00be48392311af6a$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $00be48392311af6a$var$suspenseyCommitFlag, $00be48392311af6a$var$suspenseyCommitFlag = 16777216, $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $00be48392311af6a$var$suspenseyCommitFlag = previousHoistableRoot) : $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $00be48392311af6a$var$appearingViewTransitions && ($00be48392311af6a$var$appearingViewTransitions = new Map());
                $00be48392311af6a$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $00be48392311af6a$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00be48392311af6a$var$nextEffect = childToDelete;
            $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00be48392311af6a$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $00be48392311af6a$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00be48392311af6a$var$nextEffect = childToDelete;
            $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00be48392311af6a$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $00be48392311af6a$var$nextEffect;){
        var fiber = $00be48392311af6a$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $00be48392311af6a$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $00be48392311af6a$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $00be48392311af6a$var$nextEffect;){
            cache = $00be48392311af6a$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $00be48392311af6a$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $00be48392311af6a$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $00be48392311af6a$var$nextEffect = sibling;
                break a;
            }
            $00be48392311af6a$var$nextEffect = returnFiber;
        }
    }
}
var $00be48392311af6a$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext).controller.signal;
    }
}, $00be48392311af6a$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $00be48392311af6a$var$executionContext = 0, $00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgress = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0, $00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = !1, $00be48392311af6a$var$workInProgressRootIsPrerendering = !1, $00be48392311af6a$var$workInProgressRootDidAttachPingListener = !1, $00be48392311af6a$var$entangledRenderLanes = 0, $00be48392311af6a$var$workInProgressRootExitStatus = 0, $00be48392311af6a$var$workInProgressRootSkippedLanes = 0, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes = 0, $00be48392311af6a$var$workInProgressRootPingedLanes = 0, $00be48392311af6a$var$workInProgressDeferredLane = 0, $00be48392311af6a$var$workInProgressSuspendedRetryLanes = 0, $00be48392311af6a$var$workInProgressRootConcurrentErrors = null, $00be48392311af6a$var$workInProgressRootRecoverableErrors = null, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $00be48392311af6a$var$globalMostRecentFallbackTime = 0, $00be48392311af6a$var$globalMostRecentTransitionTime = 0, $00be48392311af6a$var$workInProgressRootRenderTargetTime = Infinity, $00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = null, $00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$pendingEffectsRoot = null, $00be48392311af6a$var$pendingFinishedWork = null, $00be48392311af6a$var$pendingEffectsLanes = 0, $00be48392311af6a$var$pendingEffectsRemainingLanes = 0, $00be48392311af6a$var$pendingPassiveTransitions = null, $00be48392311af6a$var$pendingRecoverableErrors = null, $00be48392311af6a$var$pendingViewTransition = null, $00be48392311af6a$var$pendingViewTransitionEvents = null, $00be48392311af6a$var$pendingTransitionTypes = null, $00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null;
function $00be48392311af6a$var$requestUpdateLane() {
    return 0 !== ($00be48392311af6a$var$executionContext & 2) && 0 !== $00be48392311af6a$var$workInProgressRootRenderLanes ? $00be48392311af6a$var$workInProgressRootRenderLanes & -$00be48392311af6a$var$workInProgressRootRenderLanes : null !== $00be48392311af6a$var$ReactSharedInternals.T ? $00be48392311af6a$var$requestTransitionLane() : $00be48392311af6a$var$resolveUpdatePriority();
}
function $00be48392311af6a$var$requestDeferredLane() {
    if (0 === $00be48392311af6a$var$workInProgressDeferredLane) {
        if (0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912) || $00be48392311af6a$var$isHydrating) {
            var lane = $00be48392311af6a$var$nextTransitionDeferredLane;
            $00be48392311af6a$var$nextTransitionDeferredLane <<= 1;
            0 === ($00be48392311af6a$var$nextTransitionDeferredLane & 3932160) && ($00be48392311af6a$var$nextTransitionDeferredLane = 262144);
            $00be48392311af6a$var$workInProgressDeferredLane = lane;
        } else $00be48392311af6a$var$workInProgressDeferredLane = 536870912;
    }
    lane = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $00be48392311af6a$var$workInProgressDeferredLane;
}
function $00be48392311af6a$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $00be48392311af6a$var$createViewTransitionInstance($00be48392311af6a$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $00be48392311af6a$var$pendingViewTransitionEvents && ($00be48392311af6a$var$pendingViewTransitionEvents = []);
        $00be48392311af6a$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $00be48392311af6a$var$workInProgressRoot && (2 === $00be48392311af6a$var$workInProgressSuspendedReason || 9 === $00be48392311af6a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $00be48392311af6a$var$prepareFreshStack(root, 0), $00be48392311af6a$var$markRootSuspended(root, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1);
    $00be48392311af6a$var$markRootUpdated$1(root, lane);
    if (0 === ($00be48392311af6a$var$executionContext & 2) || root !== $00be48392311af6a$var$workInProgressRoot) root === $00be48392311af6a$var$workInProgressRoot && (0 === ($00be48392311af6a$var$executionContext & 2) && ($00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $00be48392311af6a$var$workInProgressRootExitStatus && $00be48392311af6a$var$markRootSuspended(root, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1)), $00be48392311af6a$var$ensureRootIsScheduled(root);
}
function $00be48392311af6a$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $00be48392311af6a$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $00be48392311af6a$var$renderRootConcurrent(root$jscomp$0, lanes) : $00be48392311af6a$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $00be48392311af6a$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $00be48392311af6a$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$00be48392311af6a$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $00be48392311af6a$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $00be48392311af6a$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($00be48392311af6a$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $00be48392311af6a$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($00be48392311af6a$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $00be48392311af6a$var$workInProgressRootRecoverableErrors;
                            $00be48392311af6a$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $00be48392311af6a$var$workInProgressRootRecoverableErrors ? $00be48392311af6a$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $00be48392311af6a$var$workInProgressRootRecoverableErrors.push.apply($00be48392311af6a$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $00be48392311af6a$var$prepareFreshStack(root$jscomp$0, 0);
                $00be48392311af6a$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $00be48392311af6a$var$markRootSuspended(shouldTimeSlice, lanes, $00be48392311af6a$var$workInProgressDeferredLane, !$00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $00be48392311af6a$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $00be48392311af6a$var$globalMostRecentFallbackTime + 300 - $00be48392311af6a$var$now(), 10 < exitStatus)) {
                    $00be48392311af6a$var$markRootSuspended(shouldTimeSlice, lanes, $00be48392311af6a$var$workInProgressDeferredLane, !$00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $00be48392311af6a$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $00be48392311af6a$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $00be48392311af6a$var$scheduleTimeout($00be48392311af6a$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $00be48392311af6a$var$workInProgressRootRecoverableErrors, $00be48392311af6a$var$workInProgressTransitions, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00be48392311af6a$var$workInProgressDeferredLane, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $00be48392311af6a$var$completeRootWhenReady(shouldTimeSlice, forceSync, $00be48392311af6a$var$workInProgressRootRecoverableErrors, $00be48392311af6a$var$workInProgressTransitions, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00be48392311af6a$var$workInProgressDeferredLane, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $00be48392311af6a$var$ensureRootIsScheduled(root$jscomp$0);
}
function $00be48392311af6a$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $00be48392311af6a$var$noop$1
        }, $00be48392311af6a$var$appearingViewTransitions = null, $00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $00be48392311af6a$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $00be48392311af6a$var$globalMostRecentFallbackTime - $00be48392311af6a$var$now() : (lanes & 4194048) === lanes ? $00be48392311af6a$var$globalMostRecentTransitionTime - $00be48392311af6a$var$now() : 0, subtreeFlags = $00be48392311af6a$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $00be48392311af6a$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($00be48392311af6a$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $00be48392311af6a$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $00be48392311af6a$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $00be48392311af6a$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$00be48392311af6a$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $00be48392311af6a$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $00be48392311af6a$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$00be48392311af6a$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $00be48392311af6a$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $00be48392311af6a$var$flushSyncWork$1() {
    return 0 === ($00be48392311af6a$var$executionContext & 6) ? ($00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $00be48392311af6a$var$resetWorkInProgressStack() {
    if (null !== $00be48392311af6a$var$workInProgress) {
        if (0 === $00be48392311af6a$var$workInProgressSuspendedReason) var interruptedWork = $00be48392311af6a$var$workInProgress.return;
        else interruptedWork = $00be48392311af6a$var$workInProgress, $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null, $00be48392311af6a$var$resetHooksOnUnwind(interruptedWork), $00be48392311af6a$var$thenableState$1 = null, $00be48392311af6a$var$thenableIndexCounter$1 = 0, interruptedWork = $00be48392311af6a$var$workInProgress;
        for(; null !== interruptedWork;)$00be48392311af6a$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $00be48392311af6a$var$workInProgress = null;
    }
}
function $00be48392311af6a$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $00be48392311af6a$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $00be48392311af6a$var$pendingEffectsLanes = 0;
    $00be48392311af6a$var$resetWorkInProgressStack();
    $00be48392311af6a$var$workInProgressRoot = root;
    $00be48392311af6a$var$workInProgress = timeoutHandle = $00be48392311af6a$var$createWorkInProgress(root.current, null);
    $00be48392311af6a$var$workInProgressRootRenderLanes = lanes;
    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
    $00be48392311af6a$var$workInProgressThrownValue = null;
    $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $00be48392311af6a$var$workInProgressRootIsPrerendering = $00be48392311af6a$var$checkIfRootIsPrerendering(root, lanes);
    $00be48392311af6a$var$workInProgressRootDidAttachPingListener = !1;
    $00be48392311af6a$var$workInProgressSuspendedRetryLanes = $00be48392311af6a$var$workInProgressDeferredLane = $00be48392311af6a$var$workInProgressRootPingedLanes = $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes = $00be48392311af6a$var$workInProgressRootSkippedLanes = $00be48392311af6a$var$workInProgressRootExitStatus = 0;
    $00be48392311af6a$var$workInProgressRootRecoverableErrors = $00be48392311af6a$var$workInProgressRootConcurrentErrors = null;
    $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $00be48392311af6a$var$entangledRenderLanes = $00be48392311af6a$var$getEntangledLanes(root, lanes);
    $00be48392311af6a$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $00be48392311af6a$var$handleThrow(root, thrownValue) {
    $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    thrownValue === $00be48392311af6a$var$SuspenseException || thrownValue === $00be48392311af6a$var$SuspenseActionException ? (thrownValue = $00be48392311af6a$var$getSuspendedThenable(), $00be48392311af6a$var$workInProgressSuspendedReason = 3) : thrownValue === $00be48392311af6a$var$SuspenseyCommitException ? (thrownValue = $00be48392311af6a$var$getSuspendedThenable(), $00be48392311af6a$var$workInProgressSuspendedReason = 4) : $00be48392311af6a$var$workInProgressSuspendedReason = thrownValue === $00be48392311af6a$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $00be48392311af6a$var$workInProgressThrownValue = thrownValue;
    null === $00be48392311af6a$var$workInProgress && ($00be48392311af6a$var$workInProgressRootExitStatus = 1, $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $00be48392311af6a$var$shouldRemainOnPreviousScreen() {
    var handler = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($00be48392311af6a$var$workInProgressRootRenderLanes & 4194048) === $00be48392311af6a$var$workInProgressRootRenderLanes ? null === $00be48392311af6a$var$shellBoundary ? !0 : !1 : ($00be48392311af6a$var$workInProgressRootRenderLanes & 62914560) === $00be48392311af6a$var$workInProgressRootRenderLanes || 0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912) ? handler === $00be48392311af6a$var$shellBoundary : !1;
}
function $00be48392311af6a$var$pushDispatcher() {
    var prevDispatcher = $00be48392311af6a$var$ReactSharedInternals.H;
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $00be48392311af6a$var$ContextOnlyDispatcher : prevDispatcher;
}
function $00be48392311af6a$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $00be48392311af6a$var$ReactSharedInternals.A;
    $00be48392311af6a$var$ReactSharedInternals.A = $00be48392311af6a$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $00be48392311af6a$var$renderDidSuspendDelayIfPossible() {
    $00be48392311af6a$var$workInProgressRootExitStatus = 4;
    $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings || ($00be48392311af6a$var$workInProgressRootRenderLanes & 4194048) !== $00be48392311af6a$var$workInProgressRootRenderLanes && null !== $00be48392311af6a$var$suspenseHandlerStackCursor.current || ($00be48392311af6a$var$workInProgressRootIsPrerendering = !0);
    0 === ($00be48392311af6a$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $00be48392311af6a$var$workInProgressRoot || $00be48392311af6a$var$markRootSuspended($00be48392311af6a$var$workInProgressRoot, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1);
}
function $00be48392311af6a$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $00be48392311af6a$var$executionContext;
    $00be48392311af6a$var$executionContext |= 2;
    var prevDispatcher = $00be48392311af6a$var$pushDispatcher(), prevAsyncDispatcher = $00be48392311af6a$var$pushAsyncDispatcher();
    if ($00be48392311af6a$var$workInProgressRoot !== root || $00be48392311af6a$var$workInProgressRootRenderLanes !== lanes) $00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $00be48392311af6a$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $00be48392311af6a$var$workInProgressSuspendedReason && null !== $00be48392311af6a$var$workInProgress) {
            var unitOfWork = $00be48392311af6a$var$workInProgress, thrownValue = $00be48392311af6a$var$workInProgressThrownValue;
            switch($00be48392311af6a$var$workInProgressSuspendedReason){
                case 8:
                    $00be48392311af6a$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $00be48392311af6a$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $00be48392311af6a$var$workInProgressSuspendedReason;
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $00be48392311af6a$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $00be48392311af6a$var$workInProgressSuspendedReason, $00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $00be48392311af6a$var$workLoopSync();
        exitStatus = $00be48392311af6a$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $00be48392311af6a$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$executionContext = prevExecutionContext;
    $00be48392311af6a$var$ReactSharedInternals.H = prevDispatcher;
    $00be48392311af6a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $00be48392311af6a$var$workInProgress && ($00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0, $00be48392311af6a$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $00be48392311af6a$var$workLoopSync() {
    for(; null !== $00be48392311af6a$var$workInProgress;)$00be48392311af6a$var$performUnitOfWork($00be48392311af6a$var$workInProgress);
}
function $00be48392311af6a$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $00be48392311af6a$var$executionContext;
    $00be48392311af6a$var$executionContext |= 2;
    var prevDispatcher = $00be48392311af6a$var$pushDispatcher(), prevAsyncDispatcher = $00be48392311af6a$var$pushAsyncDispatcher();
    $00be48392311af6a$var$workInProgressRoot !== root || $00be48392311af6a$var$workInProgressRootRenderLanes !== lanes ? ($00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$workInProgressRootRenderTargetTime = $00be48392311af6a$var$now() + 500, $00be48392311af6a$var$prepareFreshStack(root, lanes)) : $00be48392311af6a$var$workInProgressRootIsPrerendering = $00be48392311af6a$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $00be48392311af6a$var$workInProgressSuspendedReason && null !== $00be48392311af6a$var$workInProgress) {
            lanes = $00be48392311af6a$var$workInProgress;
            var thrownValue = $00be48392311af6a$var$workInProgressThrownValue;
            b: switch($00be48392311af6a$var$workInProgressSuspendedReason){
                case 1:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($00be48392311af6a$var$isThenableResolved(thrownValue)) {
                        $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                        $00be48392311af6a$var$workInProgressThrownValue = null;
                        $00be48392311af6a$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $00be48392311af6a$var$workInProgressSuspendedReason && 9 !== $00be48392311af6a$var$workInProgressSuspendedReason || $00be48392311af6a$var$workInProgressRoot !== root || ($00be48392311af6a$var$workInProgressSuspendedReason = 7);
                        $00be48392311af6a$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $00be48392311af6a$var$isThenableResolved(thrownValue) ? ($00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$replaySuspendedUnitOfWork(lanes)) : ($00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($00be48392311af6a$var$workInProgress.tag){
                        case 26:
                            resource = $00be48392311af6a$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $00be48392311af6a$var$workInProgress;
                            if (resource ? $00be48392311af6a$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                                $00be48392311af6a$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $00be48392311af6a$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($00be48392311af6a$var$workInProgress = returnFiber, $00be48392311af6a$var$completeUnitOfWork(returnFiber)) : $00be48392311af6a$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $00be48392311af6a$var$resetWorkInProgressStack();
                    $00be48392311af6a$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(462));
            }
        }
        $00be48392311af6a$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $00be48392311af6a$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$ReactSharedInternals.H = prevDispatcher;
    $00be48392311af6a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $00be48392311af6a$var$executionContext = prevExecutionContext;
    if (null !== $00be48392311af6a$var$workInProgress) return 0;
    $00be48392311af6a$var$workInProgressRoot = null;
    $00be48392311af6a$var$workInProgressRootRenderLanes = 0;
    $00be48392311af6a$var$finishQueueingConcurrentUpdates();
    return $00be48392311af6a$var$workInProgressRootExitStatus;
}
function $00be48392311af6a$var$workLoopConcurrentByScheduler() {
    for(; null !== $00be48392311af6a$var$workInProgress && !$00be48392311af6a$var$shouldYield();)$00be48392311af6a$var$performUnitOfWork($00be48392311af6a$var$workInProgress);
}
function $00be48392311af6a$var$performUnitOfWork(unitOfWork) {
    var next = $00be48392311af6a$var$beginWork(unitOfWork.alternate, unitOfWork, $00be48392311af6a$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00be48392311af6a$var$completeUnitOfWork(unitOfWork) : $00be48392311af6a$var$workInProgress = next;
}
function $00be48392311af6a$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $00be48392311af6a$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $00be48392311af6a$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $00be48392311af6a$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $00be48392311af6a$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $00be48392311af6a$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $00be48392311af6a$var$hydrationParentFiber && ($00be48392311af6a$var$isHydrating ? ($00be48392311af6a$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($00be48392311af6a$var$nextHydratableInstance = fiber.stateNode)) : ($00be48392311af6a$var$popToNextHostParent(fiber), $00be48392311af6a$var$isHydrating = !0));
        default:
            $00be48392311af6a$var$unwindInterruptedWork(current, next), next = $00be48392311af6a$var$workInProgress = $00be48392311af6a$var$resetWorkInProgress(next, $00be48392311af6a$var$entangledRenderLanes), next = $00be48392311af6a$var$beginWork(current, next, $00be48392311af6a$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00be48392311af6a$var$completeUnitOfWork(unitOfWork) : $00be48392311af6a$var$workInProgress = next;
}
function $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$resetHooksOnUnwind(unitOfWork);
    $00be48392311af6a$var$thenableState$1 = null;
    $00be48392311af6a$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($00be48392311af6a$var$throwException(root, returnFiber, unitOfWork, thrownValue, $00be48392311af6a$var$workInProgressRootRenderLanes)) {
            $00be48392311af6a$var$workInProgressRootExitStatus = 1;
            $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current));
            $00be48392311af6a$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $00be48392311af6a$var$workInProgress = returnFiber, error;
        $00be48392311af6a$var$workInProgressRootExitStatus = 1;
        $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current));
        $00be48392311af6a$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($00be48392311af6a$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($00be48392311af6a$var$workInProgressRootIsPrerendering || 0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $00be48392311af6a$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $00be48392311af6a$var$unwindUnitOfWork(unitOfWork, root);
    } else $00be48392311af6a$var$completeUnitOfWork(unitOfWork);
}
function $00be48392311af6a$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $00be48392311af6a$var$unwindUnitOfWork(completedWork, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $00be48392311af6a$var$completeWork(completedWork.alternate, completedWork, $00be48392311af6a$var$entangledRenderLanes);
        if (null !== next) {
            $00be48392311af6a$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $00be48392311af6a$var$workInProgress = completedWork;
            return;
        }
        $00be48392311af6a$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 5);
}
function $00be48392311af6a$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $00be48392311af6a$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $00be48392311af6a$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $00be48392311af6a$var$workInProgress = unitOfWork;
            return;
        }
        $00be48392311af6a$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $00be48392311af6a$var$workInProgressRootExitStatus = 6;
    $00be48392311af6a$var$workInProgress = null;
}
function $00be48392311af6a$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $00be48392311af6a$var$flushPendingEffects();
    while (0 !== $00be48392311af6a$var$pendingEffectsStatus);
    if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($00be48392311af6a$var$formatProdErrorMessage(177));
        root === $00be48392311af6a$var$workInProgressRoot && ($00be48392311af6a$var$workInProgress = $00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0);
        $00be48392311af6a$var$pendingFinishedWork = finishedWork;
        $00be48392311af6a$var$pendingEffectsRoot = root;
        $00be48392311af6a$var$pendingEffectsLanes = lanes;
        $00be48392311af6a$var$pendingPassiveTransitions = transitions;
        $00be48392311af6a$var$pendingRecoverableErrors = recoverableErrors;
        $00be48392311af6a$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $00be48392311af6a$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $00be48392311af6a$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $00be48392311af6a$var$concurrentlyUpdatedLanes;
    $00be48392311af6a$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $00be48392311af6a$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($00be48392311af6a$var$pendingTransitionTypes = $00be48392311af6a$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($00be48392311af6a$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $00be48392311af6a$var$scheduleCallback$1($00be48392311af6a$var$NormalPriority$1, function() {
        $00be48392311af6a$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $00be48392311af6a$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $00be48392311af6a$var$ReactSharedInternals.T;
        $00be48392311af6a$var$ReactSharedInternals.T = null;
        updatedLanes = $00be48392311af6a$var$ReactDOMSharedInternals.p;
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $00be48392311af6a$var$executionContext;
        $00be48392311af6a$var$executionContext |= 4;
        try {
            $00be48392311af6a$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $00be48392311af6a$var$executionContext = suspendedRetryLanes, $00be48392311af6a$var$ReactDOMSharedInternals.p = updatedLanes, $00be48392311af6a$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $00be48392311af6a$var$pendingEffectsStatus = 1;
    $00be48392311af6a$var$shouldStartViewTransition ? $00be48392311af6a$var$pendingViewTransition = $00be48392311af6a$var$startViewTransition(suspendedState, root.containerInfo, $00be48392311af6a$var$pendingTransitionTypes, $00be48392311af6a$var$flushMutationEffects, $00be48392311af6a$var$flushLayoutEffects, $00be48392311af6a$var$flushAfterMutationEffects, $00be48392311af6a$var$flushSpawnedWork, $00be48392311af6a$var$flushPassiveEffects, $00be48392311af6a$var$reportViewTransitionError, null, null) : ($00be48392311af6a$var$flushMutationEffects(), $00be48392311af6a$var$flushLayoutEffects(), $00be48392311af6a$var$flushSpawnedWork());
}
function $00be48392311af6a$var$reportViewTransitionError(error) {
    if (0 !== $00be48392311af6a$var$pendingEffectsStatus) {
        var onRecoverableError = $00be48392311af6a$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $00be48392311af6a$var$flushAfterMutationEffects() {
    3 === $00be48392311af6a$var$pendingEffectsStatus && ($00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$commitAfterMutationEffectsOnFiber($00be48392311af6a$var$pendingFinishedWork, $00be48392311af6a$var$pendingEffectsRoot), $00be48392311af6a$var$pendingEffectsStatus = 4);
}
function $00be48392311af6a$var$flushMutationEffects() {
    if (1 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, lanes = $00be48392311af6a$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $00be48392311af6a$var$ReactSharedInternals.T;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00be48392311af6a$var$executionContext;
            $00be48392311af6a$var$executionContext |= 4;
            try {
                $00be48392311af6a$var$inUpdateViewTransition = $00be48392311af6a$var$rootViewTransitionAffected = !1;
                $00be48392311af6a$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $00be48392311af6a$var$selectionInformation;
                var curFocusedElem = $00be48392311af6a$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $00be48392311af6a$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $00be48392311af6a$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $00be48392311af6a$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $00be48392311af6a$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $00be48392311af6a$var$_enabled = !!$00be48392311af6a$var$eventsEnabled;
                $00be48392311af6a$var$selectionInformation = $00be48392311af6a$var$eventsEnabled = null;
            } finally{
                $00be48392311af6a$var$executionContext = prevExecutionContext, $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $00be48392311af6a$var$pendingEffectsStatus = 2;
    }
}
function $00be48392311af6a$var$flushLayoutEffects() {
    if (2 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $00be48392311af6a$var$ReactSharedInternals.T;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00be48392311af6a$var$executionContext;
            $00be48392311af6a$var$executionContext |= 4;
            try {
                $00be48392311af6a$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $00be48392311af6a$var$executionContext = prevExecutionContext, $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $00be48392311af6a$var$pendingEffectsStatus = 3;
    }
}
function $00be48392311af6a$var$flushSpawnedWork() {
    if (4 === $00be48392311af6a$var$pendingEffectsStatus || 3 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var committedViewTransition = $00be48392311af6a$var$pendingViewTransition;
        $00be48392311af6a$var$pendingViewTransition = null;
        $00be48392311af6a$var$requestPaint();
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, lanes = $00be48392311af6a$var$pendingEffectsLanes, recoverableErrors = $00be48392311af6a$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $00be48392311af6a$var$pendingEffectsStatus = 5 : ($00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$pendingFinishedWork = $00be48392311af6a$var$pendingEffectsRoot = null, $00be48392311af6a$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $00be48392311af6a$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onCommitFiberRoot) try {
            $00be48392311af6a$var$injectedHook.onCommitFiberRoot($00be48392311af6a$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $00be48392311af6a$var$ReactSharedInternals.T;
            passiveSubtreeMask = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $00be48392311af6a$var$ReactSharedInternals.T = finishedWork, $00be48392311af6a$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $00be48392311af6a$var$pendingViewTransitionEvents;
        onRecoverableError = $00be48392311af6a$var$pendingTransitionTypes;
        $00be48392311af6a$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($00be48392311af6a$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($00be48392311af6a$var$pendingEffectsLanes & 3) && $00be48392311af6a$var$flushPendingEffects();
        $00be48392311af6a$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $00be48392311af6a$var$rootWithNestedUpdates ? $00be48392311af6a$var$nestedUpdateCount++ : ($00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = root) : ($00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null);
        $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $00be48392311af6a$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $00be48392311af6a$var$releaseCache(remainingLanes)));
}
function $00be48392311af6a$var$flushPendingEffects() {
    null !== $00be48392311af6a$var$pendingViewTransition && ($00be48392311af6a$var$pendingViewTransition.skipTransition(), $00be48392311af6a$var$pendingViewTransition = null);
    $00be48392311af6a$var$flushMutationEffects();
    $00be48392311af6a$var$flushLayoutEffects();
    $00be48392311af6a$var$flushSpawnedWork();
    return $00be48392311af6a$var$flushPassiveEffects();
}
function $00be48392311af6a$var$flushPassiveEffects() {
    if (5 !== $00be48392311af6a$var$pendingEffectsStatus) return !1;
    var root = $00be48392311af6a$var$pendingEffectsRoot, remainingLanes = $00be48392311af6a$var$pendingEffectsRemainingLanes;
    $00be48392311af6a$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $00be48392311af6a$var$lanesToEventPriority($00be48392311af6a$var$pendingEffectsLanes), prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $00be48392311af6a$var$ReactSharedInternals.T = null;
        renderPriority = $00be48392311af6a$var$pendingPassiveTransitions;
        $00be48392311af6a$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $00be48392311af6a$var$pendingEffectsRoot, lanes = $00be48392311af6a$var$pendingEffectsLanes;
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        $00be48392311af6a$var$pendingFinishedWork = $00be48392311af6a$var$pendingEffectsRoot = null;
        $00be48392311af6a$var$pendingEffectsLanes = 0;
        if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(331));
        var prevExecutionContext = $00be48392311af6a$var$executionContext;
        $00be48392311af6a$var$executionContext |= 4;
        $00be48392311af6a$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $00be48392311af6a$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $00be48392311af6a$var$executionContext = prevExecutionContext;
        $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onPostCommitFiberRoot) try {
            $00be48392311af6a$var$injectedHook.onPostCommitFiberRoot($00be48392311af6a$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition, $00be48392311af6a$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $00be48392311af6a$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $00be48392311af6a$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $00be48392311af6a$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($00be48392311af6a$var$markRootUpdated$1(rootFiber, 2), $00be48392311af6a$var$ensureRootIsScheduled(rootFiber));
}
function $00be48392311af6a$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed || !$00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $00be48392311af6a$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $00be48392311af6a$var$createClassErrorUpdate(2);
                instance = $00be48392311af6a$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($00be48392311af6a$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $00be48392311af6a$var$markRootUpdated$1(instance, 2), $00be48392311af6a$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $00be48392311af6a$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $00be48392311af6a$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($00be48392311af6a$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $00be48392311af6a$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $00be48392311af6a$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $00be48392311af6a$var$workInProgressRoot === root && ($00be48392311af6a$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $00be48392311af6a$var$workInProgressRootExitStatus || 3 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootRenderLanes & 62914560) === $00be48392311af6a$var$workInProgressRootRenderLanes && 300 > $00be48392311af6a$var$now() - $00be48392311af6a$var$globalMostRecentFallbackTime ? 0 === ($00be48392311af6a$var$executionContext & 2) ? $00be48392311af6a$var$prepareFreshStack(root, 0) : $00be48392311af6a$var$workInProgressRootPingedLanes |= pingedLanes : $00be48392311af6a$var$workInProgressRootPingedLanes |= pingedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes === $00be48392311af6a$var$workInProgressRootRenderLanes && ($00be48392311af6a$var$workInProgressSuspendedRetryLanes = 0));
    $00be48392311af6a$var$ensureRootIsScheduled(root);
}
function $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $00be48392311af6a$var$claimNextRetryLane());
    boundaryFiber = $00be48392311af6a$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($00be48392311af6a$var$markRootUpdated$1(boundaryFiber, retryLane), $00be48392311af6a$var$ensureRootIsScheduled(boundaryFiber));
}
function $00be48392311af6a$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00be48392311af6a$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00be48392311af6a$var$scheduleCallback$1(priorityLevel, callback) {
    return $00be48392311af6a$var$scheduleCallback$3(priorityLevel, callback);
}
var $00be48392311af6a$var$firstScheduledRoot = null, $00be48392311af6a$var$lastScheduledRoot = null, $00be48392311af6a$var$didScheduleMicrotask = !1, $00be48392311af6a$var$mightHavePendingSyncWork = !1, $00be48392311af6a$var$isFlushingWork = !1, $00be48392311af6a$var$currentEventTransitionLane = 0;
function $00be48392311af6a$var$ensureRootIsScheduled(root) {
    root !== $00be48392311af6a$var$lastScheduledRoot && null === root.next && (null === $00be48392311af6a$var$lastScheduledRoot ? $00be48392311af6a$var$firstScheduledRoot = $00be48392311af6a$var$lastScheduledRoot = root : $00be48392311af6a$var$lastScheduledRoot = $00be48392311af6a$var$lastScheduledRoot.next = root);
    $00be48392311af6a$var$mightHavePendingSyncWork = !0;
    $00be48392311af6a$var$didScheduleMicrotask || ($00be48392311af6a$var$didScheduleMicrotask = !0, $00be48392311af6a$var$scheduleImmediateRootScheduleTask());
}
function $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$00be48392311af6a$var$isFlushingWork && $00be48392311af6a$var$mightHavePendingSyncWork) {
        $00be48392311af6a$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $00be48392311af6a$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $00be48392311af6a$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $00be48392311af6a$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $00be48392311af6a$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $00be48392311af6a$var$getNextLanes(root$190, root$190 === $00be48392311af6a$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $00be48392311af6a$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $00be48392311af6a$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $00be48392311af6a$var$isFlushingWork = !1;
    }
}
function $00be48392311af6a$var$processRootScheduleInImmediateTask() {
    $00be48392311af6a$var$processRootScheduleInMicrotask();
}
function $00be48392311af6a$var$processRootScheduleInMicrotask() {
    $00be48392311af6a$var$mightHavePendingSyncWork = $00be48392311af6a$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $00be48392311af6a$var$currentEventTransitionLane && $00be48392311af6a$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $00be48392311af6a$var$currentEventTransitionLane);
    for(var currentTime = $00be48392311af6a$var$now(), prev = null, root = $00be48392311af6a$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $00be48392311af6a$var$firstScheduledRoot = next : prev.next = next, null === next && ($00be48392311af6a$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $00be48392311af6a$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $00be48392311af6a$var$pendingEffectsStatus && 5 !== $00be48392311af6a$var$pendingEffectsStatus || $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $00be48392311af6a$var$currentEventTransitionLane && ($00be48392311af6a$var$currentEventTransitionLane = 0);
}
function $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $00be48392311af6a$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $00be48392311af6a$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $00be48392311af6a$var$workInProgressRoot;
    suspendedLanes = $00be48392311af6a$var$workInProgressRootRenderLanes;
    suspendedLanes = $00be48392311af6a$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $00be48392311af6a$var$workInProgressSuspendedReason || 9 === $00be48392311af6a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $00be48392311af6a$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes);
        switch($00be48392311af6a$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $00be48392311af6a$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $00be48392311af6a$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $00be48392311af6a$var$IdlePriority;
                break;
            default:
                suspendedLanes = $00be48392311af6a$var$NormalPriority$1;
        }
        pingedLanes = $00be48392311af6a$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $00be48392311af6a$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $00be48392311af6a$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $00be48392311af6a$var$pendingEffectsStatus && 5 !== $00be48392311af6a$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($00be48392311af6a$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $00be48392311af6a$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $00be48392311af6a$var$getNextLanes(root, root === $00be48392311af6a$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $00be48392311af6a$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, $00be48392311af6a$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $00be48392311af6a$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $00be48392311af6a$var$performSyncWorkOnRoot(root, lanes) {
    if ($00be48392311af6a$var$flushPendingEffects()) return null;
    $00be48392311af6a$var$performWorkOnRoot(root, lanes, !0);
}
function $00be48392311af6a$var$scheduleImmediateRootScheduleTask() {
    $00be48392311af6a$var$scheduleMicrotask(function() {
        0 !== ($00be48392311af6a$var$executionContext & 6) ? $00be48392311af6a$var$scheduleCallback$3($00be48392311af6a$var$ImmediatePriority, $00be48392311af6a$var$processRootScheduleInImmediateTask) : $00be48392311af6a$var$processRootScheduleInMicrotask();
    });
}
function $00be48392311af6a$var$requestTransitionLane() {
    if (0 === $00be48392311af6a$var$currentEventTransitionLane) {
        var actionScopeLane = $00be48392311af6a$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $00be48392311af6a$var$nextTransitionUpdateLane, $00be48392311af6a$var$nextTransitionUpdateLane <<= 1, 0 === ($00be48392311af6a$var$nextTransitionUpdateLane & 261888) && ($00be48392311af6a$var$nextTransitionUpdateLane = 256));
        $00be48392311af6a$var$currentEventTransitionLane = actionScopeLane;
    }
    return $00be48392311af6a$var$currentEventTransitionLane;
}
function $00be48392311af6a$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $00be48392311af6a$var$sanitizeURL(actionProp);
}
function $00be48392311af6a$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $00be48392311af6a$var$coerceFormActionProp((nativeEventTarget[$00be48392311af6a$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$00be48392311af6a$var$internalPropsKey] || null) ? $00be48392311af6a$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $00be48392311af6a$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $00be48392311af6a$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $00be48392311af6a$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $00be48392311af6a$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $00be48392311af6a$var$i$jscomp$inline_1667 = 0; $00be48392311af6a$var$i$jscomp$inline_1667 < $00be48392311af6a$var$simpleEventPluginEvents.length; $00be48392311af6a$var$i$jscomp$inline_1667++){
    var $00be48392311af6a$var$eventName$jscomp$inline_1668 = $00be48392311af6a$var$simpleEventPluginEvents[$00be48392311af6a$var$i$jscomp$inline_1667], $00be48392311af6a$var$domEventName$jscomp$inline_1669 = $00be48392311af6a$var$eventName$jscomp$inline_1668.toLowerCase(), $00be48392311af6a$var$capitalizedEvent$jscomp$inline_1670 = $00be48392311af6a$var$eventName$jscomp$inline_1668[0].toUpperCase() + $00be48392311af6a$var$eventName$jscomp$inline_1668.slice(1);
    $00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$domEventName$jscomp$inline_1669, "on" + $00be48392311af6a$var$capitalizedEvent$jscomp$inline_1670);
}
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_END, "onAnimationEnd");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_ITERATION, "onAnimationIteration");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_START, "onAnimationStart");
$00be48392311af6a$var$registerSimpleEvent("dblclick", "onDoubleClick");
$00be48392311af6a$var$registerSimpleEvent("focusin", "onFocus");
$00be48392311af6a$var$registerSimpleEvent("focusout", "onBlur");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_RUN, "onTransitionRun");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_START, "onTransitionStart");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_CANCEL, "onTransitionCancel");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_END, "onTransitionEnd");
$00be48392311af6a$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$00be48392311af6a$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$00be48392311af6a$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$00be48392311af6a$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$00be48392311af6a$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $00be48392311af6a$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $00be48392311af6a$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($00be48392311af6a$var$mediaEventTypes));
function $00be48392311af6a$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00be48392311af6a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00be48392311af6a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $00be48392311af6a$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$00be48392311af6a$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$00be48392311af6a$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($00be48392311af6a$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $00be48392311af6a$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $00be48392311af6a$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $00be48392311af6a$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $00be48392311af6a$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$00be48392311af6a$var$listeningMarker]) {
        rootContainerElement[$00be48392311af6a$var$listeningMarker] = !0;
        $00be48392311af6a$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($00be48392311af6a$var$nonDelegatedEvents.has(domEventName) || $00be48392311af6a$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $00be48392311af6a$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$00be48392311af6a$var$listeningMarker] || (ownerDocument[$00be48392311af6a$var$listeningMarker] = !0, $00be48392311af6a$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $00be48392311af6a$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($00be48392311af6a$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $00be48392311af6a$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $00be48392311af6a$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $00be48392311af6a$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$00be48392311af6a$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $00be48392311af6a$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $00be48392311af6a$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $00be48392311af6a$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $00be48392311af6a$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $00be48392311af6a$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $00be48392311af6a$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticTouchEvent;
                        break;
                    case $00be48392311af6a$var$ANIMATION_END:
                    case $00be48392311af6a$var$ANIMATION_ITERATION:
                    case $00be48392311af6a$var$ANIMATION_START:
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticAnimationEvent;
                        break;
                    case $00be48392311af6a$var$TRANSITION_END:
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $00be48392311af6a$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($00be48392311af6a$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $00be48392311af6a$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($00be48392311af6a$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$00be48392311af6a$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $00be48392311af6a$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $00be48392311af6a$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $00be48392311af6a$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $00be48392311af6a$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $00be48392311af6a$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $00be48392311af6a$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $00be48392311af6a$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $00be48392311af6a$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $00be48392311af6a$var$getParent) : null;
                        null !== reactName && $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $00be48392311af6a$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $00be48392311af6a$var$getTargetInstForChangeEvent;
                else if ($00be48392311af6a$var$isTextInputElement(reactName)) {
                    if ($00be48392311af6a$var$isInputEventSupported) getTargetInstFunc = $00be48392311af6a$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $00be48392311af6a$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $00be48392311af6a$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $00be48392311af6a$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $00be48392311af6a$var$getTargetInstForChangeEvent) : getTargetInstFunc = $00be48392311af6a$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $00be48392311af6a$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($00be48392311af6a$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $00be48392311af6a$var$activeElement = handleEventFunc, $00be48392311af6a$var$activeElementInst = targetInst, $00be48392311af6a$var$lastSelection = null;
                    break;
                case "focusout":
                    $00be48392311af6a$var$lastSelection = $00be48392311af6a$var$activeElementInst = $00be48392311af6a$var$activeElement = null;
                    break;
                case "mousedown":
                    $00be48392311af6a$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $00be48392311af6a$var$mouseDown = !1;
                    $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($00be48392311af6a$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($00be48392311af6a$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $00be48392311af6a$var$isComposing ? $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($00be48392311af6a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($00be48392311af6a$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $00be48392311af6a$var$isComposing && (fallbackData = $00be48392311af6a$var$getData()) : ($00be48392311af6a$var$root = nativeEventTarget, $00be48392311af6a$var$startText = "value" in $00be48392311af6a$var$root ? $00be48392311af6a$var$root.value : $00be48392311af6a$var$root.textContent, $00be48392311af6a$var$isComposing = !0)), handleEventFunc = $00be48392311af6a$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $00be48392311af6a$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $00be48392311af6a$var$canUseTextInputEvent ? $00be48392311af6a$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $00be48392311af6a$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $00be48392311af6a$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $00be48392311af6a$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $00be48392311af6a$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $00be48392311af6a$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $00be48392311af6a$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $00be48392311af6a$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $00be48392311af6a$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($00be48392311af6a$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $00be48392311af6a$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($00be48392311af6a$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $00be48392311af6a$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $00be48392311af6a$var$getListener(target, registrationName), null != stateNode && listeners.unshift($00be48392311af6a$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $00be48392311af6a$var$getListener(target, registrationName), null != stateNode && listeners.push($00be48392311af6a$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $00be48392311af6a$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $00be48392311af6a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($00be48392311af6a$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($00be48392311af6a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $00be48392311af6a$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(clientText);
    return $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $00be48392311af6a$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $00be48392311af6a$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $00be48392311af6a$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $00be48392311af6a$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $00be48392311af6a$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $00be48392311af6a$var$setProp(domElement, tag, "name", props.name, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($00be48392311af6a$var$setProp(domElement, tag, "encType", props.encType, props, null), $00be48392311af6a$var$setProp(domElement, tag, "method", props.method, props, null), $00be48392311af6a$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $00be48392311af6a$var$noop$1);
            return;
        case "onScroll":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00be48392311af6a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00be48392311af6a$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            $00be48392311af6a$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $00be48392311af6a$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $00be48392311af6a$var$aliases.get(key) || key, $00be48392311af6a$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $00be48392311af6a$var$viewTransitionMutationContext = !0;
}
function $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $00be48392311af6a$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00be48392311af6a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00be48392311af6a$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $00be48392311af6a$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $00be48392311af6a$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $00be48392311af6a$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$00be48392311af6a$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$00be48392311af6a$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $00be48392311af6a$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $00be48392311af6a$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $00be48392311af6a$var$viewTransitionMutationContext = !0;
}
function $00be48392311af6a$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                    default:
                        $00be48392311af6a$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $00be48392311af6a$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $00be48392311af6a$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $00be48392311af6a$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $00be48392311af6a$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $00be48392311af6a$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $00be48392311af6a$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($00be48392311af6a$var$formatProdErrorMessage(91));
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $00be48392311af6a$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("cancel", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $00be48392311af6a$var$mediaEventTypes.length; hasSrc++)$00be48392311af6a$var$listenToNonDelegatedEvent($00be48392311af6a$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement), $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($00be48392311af6a$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $00be48392311af6a$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $00be48392311af6a$var$emptyProps = {};
function $00be48392311af6a$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $00be48392311af6a$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $00be48392311af6a$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $00be48392311af6a$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $00be48392311af6a$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $00be48392311af6a$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $00be48392311af6a$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $00be48392311af6a$var$updateOptions(domElement, !!lastProps, tag, !0) : $00be48392311af6a$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($00be48392311af6a$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $00be48392311af6a$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $00be48392311af6a$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $00be48392311af6a$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($00be48392311af6a$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $00be48392311af6a$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $00be48392311af6a$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $00be48392311af6a$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $00be48392311af6a$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $00be48392311af6a$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $00be48392311af6a$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $00be48392311af6a$var$eventsEnabled = null, $00be48392311af6a$var$selectionInformation = null;
function $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $00be48392311af6a$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $00be48392311af6a$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $00be48392311af6a$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$00be48392311af6a$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$00be48392311af6a$var$internalPropsKey] = props;
    $00be48392311af6a$var$setInitialProperties(rootContainerInstance, type, props);
    $00be48392311af6a$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $00be48392311af6a$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $00be48392311af6a$var$currentPopstateTransitionEvent = null;
function $00be48392311af6a$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $00be48392311af6a$var$currentPopstateTransitionEvent) return !1;
        $00be48392311af6a$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $00be48392311af6a$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $00be48392311af6a$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $00be48392311af6a$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $00be48392311af6a$var$localPromise = "function" === typeof Promise ? Promise : void 0, $00be48392311af6a$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $00be48392311af6a$var$scheduleTimeout, $00be48392311af6a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $00be48392311af6a$var$localPromise ? function(callback) {
    return $00be48392311af6a$var$localPromise.resolve(null).then(callback).catch($00be48392311af6a$var$handleErrorInNextTick);
} : $00be48392311af6a$var$scheduleTimeout;
function $00be48392311af6a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $00be48392311af6a$var$isSingletonScope(type) {
    return "head" === type;
}
function $00be48392311af6a$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $00be48392311af6a$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $00be48392311af6a$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $00be48392311af6a$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$00be48392311af6a$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $00be48392311af6a$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $00be48392311af6a$var$retryIfBlockedOn(hydrationInstance);
}
function $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $00be48392311af6a$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $00be48392311af6a$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $00be48392311af6a$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $00be48392311af6a$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $00be48392311af6a$var$createMeasurement(rect, computedStyle, instance);
}
function $00be48392311af6a$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $00be48392311af6a$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $00be48392311af6a$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $00be48392311af6a$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $00be48392311af6a$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($00be48392311af6a$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $00be48392311af6a$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $00be48392311af6a$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($00be48392311af6a$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $00be48392311af6a$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $00be48392311af6a$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $00be48392311af6a$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $00be48392311af6a$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $00be48392311af6a$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $00be48392311af6a$var$ViewTransitionPseudoElement("old", name),
        new: new $00be48392311af6a$var$ViewTransitionPseudoElement("new", name)
    };
}
function $00be48392311af6a$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$00be48392311af6a$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $00be48392311af6a$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $00be48392311af6a$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $00be48392311af6a$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $00be48392311af6a$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $00be48392311af6a$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $00be48392311af6a$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $00be48392311af6a$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $00be48392311af6a$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $00be48392311af6a$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $00be48392311af6a$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $00be48392311af6a$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $00be48392311af6a$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $00be48392311af6a$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$00be48392311af6a$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$00be48392311af6a$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $00be48392311af6a$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $00be48392311af6a$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $00be48392311af6a$var$getInstanceFromHostFiber(fiber);
    return $00be48392311af6a$var$setFocusIfFocusable(fiber, focusOptions);
}
$00be48392311af6a$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$00be48392311af6a$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $00be48392311af6a$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $00be48392311af6a$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$observeChild, observer, void 0, void 0);
};
function $00be48392311af6a$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $00be48392311af6a$var$pendingIntersectionUnobserves.length; i++){
            var pending = $00be48392311af6a$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $00be48392311af6a$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $00be48392311af6a$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $00be48392311af6a$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $00be48392311af6a$var$pendingIntersectionUnobserves = [], $00be48392311af6a$var$intersectionUnobserveScheduled = !1;
function $00be48392311af6a$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $00be48392311af6a$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $00be48392311af6a$var$intersectionUnobserveScheduled || ($00be48392311af6a$var$intersectionUnobserveScheduled = !0, $00be48392311af6a$var$requestPostPaintCallback(function() {
        $00be48392311af6a$var$intersectionUnobserveScheduled = !1;
        var pending = $00be48392311af6a$var$pendingIntersectionUnobserves;
        $00be48392311af6a$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$00be48392311af6a$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $00be48392311af6a$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $00be48392311af6a$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$00be48392311af6a$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($00be48392311af6a$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $00be48392311af6a$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(children[0]);
    result = $00be48392311af6a$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $00be48392311af6a$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $00be48392311af6a$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $00be48392311af6a$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $00be48392311af6a$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $00be48392311af6a$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $00be48392311af6a$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $00be48392311af6a$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $00be48392311af6a$var$searchTarget, $00be48392311af6a$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $00be48392311af6a$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $00be48392311af6a$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $00be48392311af6a$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $00be48392311af6a$var$searchTarget, $00be48392311af6a$var$searchBoundary = $00be48392311af6a$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $00be48392311af6a$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$00be48392311af6a$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($00be48392311af6a$var$formatProdErrorMessage(566));
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $00be48392311af6a$var$getInstanceFromHostFiber(hostSiblings);
            $00be48392311af6a$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $00be48392311af6a$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $00be48392311af6a$var$getInstanceFromHostFiber(child), $00be48392311af6a$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $00be48392311af6a$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $00be48392311af6a$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    $00be48392311af6a$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $00be48392311af6a$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $00be48392311af6a$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $00be48392311af6a$var$pendingIntersectionUnobserves.length; i++){
            var pending = $00be48392311af6a$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $00be48392311af6a$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $00be48392311af6a$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $00be48392311af6a$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $00be48392311af6a$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $00be48392311af6a$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $00be48392311af6a$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $00be48392311af6a$var$clearContainerSparingly(node);
                $00be48392311af6a$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $00be48392311af6a$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$00be48392311af6a$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $00be48392311af6a$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00be48392311af6a$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00be48392311af6a$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $00be48392311af6a$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $00be48392311af6a$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $00be48392311af6a$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = null;
function $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $00be48392311af6a$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $00be48392311af6a$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $00be48392311af6a$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $00be48392311af6a$var$requestPostPaintCallback(callback) {
    $00be48392311af6a$var$localRequestAnimationFrame(function() {
        $00be48392311af6a$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $00be48392311af6a$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(451));
    }
}
function $00be48392311af6a$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $00be48392311af6a$var$setProp(instance, type, propKey, null, $00be48392311af6a$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $00be48392311af6a$var$noop$1 && (instance.onclick = null);
    $00be48392311af6a$var$detachDeletedInstance(instance);
}
function $00be48392311af6a$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $00be48392311af6a$var$detachDeletedInstance(instance);
}
var $00be48392311af6a$var$preloadPropsMap = new Map(), $00be48392311af6a$var$preconnectsSet = new Set();
function $00be48392311af6a$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $00be48392311af6a$var$previousDispatcher = $00be48392311af6a$var$ReactDOMSharedInternals.d;
$00be48392311af6a$var$ReactDOMSharedInternals.d = {
    f: $00be48392311af6a$var$flushSyncWork,
    r: $00be48392311af6a$var$requestFormReset,
    D: $00be48392311af6a$var$prefetchDNS,
    C: $00be48392311af6a$var$preconnect,
    L: $00be48392311af6a$var$preload,
    m: $00be48392311af6a$var$preloadModule,
    X: $00be48392311af6a$var$preinitScript,
    S: $00be48392311af6a$var$preinitStyle,
    M: $00be48392311af6a$var$preinitModuleScript
};
function $00be48392311af6a$var$flushSyncWork() {
    var previousWasRendering = $00be48392311af6a$var$previousDispatcher.f(), wasRendering = $00be48392311af6a$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $00be48392311af6a$var$requestFormReset(form) {
    var formInst = $00be48392311af6a$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $00be48392311af6a$var$requestFormReset$1(formInst) : $00be48392311af6a$var$previousDispatcher.r(form);
}
var $00be48392311af6a$var$globalDocument = "undefined" === typeof document ? null : document;
function $00be48392311af6a$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $00be48392311af6a$var$preconnectsSet.has(limitedEscapedHref) || ($00be48392311af6a$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $00be48392311af6a$var$setInitialProperties(href, "link", rel), $00be48392311af6a$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $00be48392311af6a$var$prefetchDNS(href) {
    $00be48392311af6a$var$previousDispatcher.D(href);
    $00be48392311af6a$var$preconnectAs("dns-prefetch", href, null);
}
function $00be48392311af6a$var$preconnect(href, crossOrigin) {
    $00be48392311af6a$var$previousDispatcher.C(href, crossOrigin);
    $00be48392311af6a$var$preconnectAs("preconnect", href, crossOrigin);
}
function $00be48392311af6a$var$preload(href, as, options) {
    $00be48392311af6a$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $00be48392311af6a$var$getStyleKey(href);
                break;
            case "script":
                key = $00be48392311af6a$var$getScriptKey(href);
        }
        if (!($00be48392311af6a$var$preloadPropsMap.has(key) || (href = $00be48392311af6a$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $00be48392311af6a$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $00be48392311af6a$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$00be48392311af6a$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $00be48392311af6a$var$clearPendingLoadOnNode(instance);
            });
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $00be48392311af6a$var$preloadModule(href, options) {
    $00be48392311af6a$var$previousDispatcher.m(href, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $00be48392311af6a$var$getScriptKey(href);
        }
        if (!$00be48392311af6a$var$preloadPropsMap.has(key) && (href = $00be48392311af6a$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $00be48392311af6a$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $00be48392311af6a$var$setInitialProperties(as, "link", href);
            $00be48392311af6a$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $00be48392311af6a$var$preinitStyle(href, precedence, options) {
    $00be48392311af6a$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $00be48392311af6a$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $00be48392311af6a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $00be48392311af6a$var$markNodeAsHoistable(link);
                $00be48392311af6a$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $00be48392311af6a$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $00be48392311af6a$var$preinitScript(src, options) {
    $00be48392311af6a$var$previousDispatcher.X(src, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00be48392311af6a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key)), resource || (src = $00be48392311af6a$var$assign({
            src: src,
            async: !0
        }, options), (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00be48392311af6a$var$markNodeAsHoistable(resource), $00be48392311af6a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00be48392311af6a$var$preinitModuleScript(src, options) {
    $00be48392311af6a$var$previousDispatcher.M(src, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00be48392311af6a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key)), resource || (src = $00be48392311af6a$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00be48392311af6a$var$markNodeAsHoistable(resource), $00be48392311af6a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00be48392311af6a$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $00be48392311af6a$var$rootInstanceStackCursor.current) ? $00be48392311af6a$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($00be48392311af6a$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $00be48392311af6a$var$getStyleKey(pendingProps.href), currentProps = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $00be48392311af6a$var$getStyleKey(pendingProps.href);
                var styles$268 = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $00be48392311af6a$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $00be48392311af6a$var$preloadPropsMap.set(type, styles$268)), $00be48392311af6a$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($00be48392311af6a$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($00be48392311af6a$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $00be48392311af6a$var$getScriptKey(pendingProps), currentProps = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(444, type));
    }
}
function $00be48392311af6a$var$getStyleKey(href) {
    return 'href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $00be48392311af6a$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $00be48392311af6a$var$stylesheetPropsFromRawProps(rawProps) {
    return $00be48392311af6a$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $00be48392311af6a$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$00be48392311af6a$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$00be48392311af6a$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $00be48392311af6a$var$clearPendingLoadOnNode.bind(null, key), $00be48392311af6a$var$setInitialProperties(key, "link", preloadProps), $00be48392311af6a$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $00be48392311af6a$var$getScriptKey(src) {
    return '[src="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $00be48392311af6a$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $00be48392311af6a$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $00be48392311af6a$var$markNodeAsHoistable(instance), instance;
            var styleProps = $00be48392311af6a$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            $00be48392311af6a$var$setInitialProperties(instance, "style", styleProps);
            $00be48392311af6a$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $00be48392311af6a$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $00be48392311af6a$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $00be48392311af6a$var$stylesheetPropsFromRawProps(props);
            (styleProps = $00be48392311af6a$var$preloadPropsMap.get(styleProps)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $00be48392311af6a$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00be48392311af6a$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $00be48392311af6a$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $00be48392311af6a$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $00be48392311af6a$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $00be48392311af6a$var$preloadPropsMap.get(instance$274)) instance = $00be48392311af6a$var$assign({}, props), $00be48392311af6a$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $00be48392311af6a$var$markNodeAsHoistable(styleProps);
            $00be48392311af6a$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $00be48392311af6a$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $00be48392311af6a$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $00be48392311af6a$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $00be48392311af6a$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $00be48392311af6a$var$tagCaches = null;
function $00be48392311af6a$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $00be48392311af6a$var$tagCaches) {
        var cache = new Map();
        var caches = $00be48392311af6a$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $00be48392311af6a$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$00be48392311af6a$var$internalHoistableMarker] || node[$00be48392311af6a$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $00be48392311af6a$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $00be48392311af6a$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $00be48392311af6a$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $00be48392311af6a$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $00be48392311af6a$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $00be48392311af6a$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $00be48392311af6a$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $00be48392311af6a$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $00be48392311af6a$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $00be48392311af6a$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $00be48392311af6a$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $00be48392311af6a$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $00be48392311af6a$var$stylesheetPropsFromRawProps(props);
            (key = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00be48392311af6a$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $00be48392311af6a$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $00be48392311af6a$var$estimatedBytesWithinLimit = 0;
function $00be48392311af6a$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $00be48392311af6a$var$estimatedBytesWithinLimit && ($00be48392311af6a$var$estimatedBytesWithinLimit = 62500 * $00be48392311af6a$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $00be48392311af6a$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $00be48392311af6a$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $00be48392311af6a$var$onUnsuspend() {
    this.count--;
    $00be48392311af6a$var$checkIfFullyUnsuspended(this);
}
function $00be48392311af6a$var$onUnsuspendImg() {
    this.imgCount--;
    $00be48392311af6a$var$checkIfFullyUnsuspended(this);
}
var $00be48392311af6a$var$precedencesByRoot = null;
function $00be48392311af6a$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $00be48392311af6a$var$precedencesByRoot = new Map(), resources.forEach($00be48392311af6a$var$insertStylesheetIntoRoot, state), $00be48392311af6a$var$precedencesByRoot = null, $00be48392311af6a$var$onUnsuspend.call(state));
}
function $00be48392311af6a$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $00be48392311af6a$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $00be48392311af6a$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $00be48392311af6a$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $00be48392311af6a$var$HostTransitionContext = {
    $$typeof: $00be48392311af6a$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $00be48392311af6a$var$sharedNotPendingObject,
    _currentValue2: $00be48392311af6a$var$sharedNotPendingObject,
    _threadCount: 0
};
function $00be48392311af6a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $00be48392311af6a$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $00be48392311af6a$var$createLaneMap(0);
    this.hiddenUpdates = $00be48392311af6a$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $00be48392311af6a$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $00be48392311af6a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $00be48392311af6a$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $00be48392311af6a$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $00be48392311af6a$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $00be48392311af6a$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $00be48392311af6a$var$emptyContextObject;
    parentComponent = $00be48392311af6a$var$emptyContextObject;
    return parentComponent;
}
function $00be48392311af6a$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $00be48392311af6a$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $00be48392311af6a$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $00be48392311af6a$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($00be48392311af6a$var$scheduleUpdateOnFiber(element, rootFiber, lane), $00be48392311af6a$var$entangleTransitions(element, rootFiber, lane));
}
function $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane);
}
function $00be48392311af6a$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $00be48392311af6a$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $00be48392311af6a$var$requestUpdateLane();
        lane = $00be48392311af6a$var$getBumpedLaneForHydrationByLane(lane);
        var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, lane);
        $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $00be48392311af6a$var$_enabled = !0;
function $00be48392311af6a$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T;
    $00be48392311af6a$var$ReactSharedInternals.T = null;
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 2, $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T;
    $00be48392311af6a$var$ReactSharedInternals.T = null;
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 8, $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($00be48392311af6a$var$_enabled) {
        var blockedOn = $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00be48392311af6a$var$return_targetInst, targetContainer), $00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($00be48392311af6a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $00be48392311af6a$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $00be48392311af6a$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $00be48392311af6a$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $00be48392311af6a$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $00be48392311af6a$var$ensureRootIsScheduled(fiber);
                                0 === ($00be48392311af6a$var$executionContext & 6) && ($00be48392311af6a$var$workInProgressRootRenderTargetTime = $00be48392311af6a$var$now() + 500, $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 2), $00be48392311af6a$var$flushSyncWork$1(), $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00be48392311af6a$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $00be48392311af6a$var$getEventTarget(nativeEvent);
    return $00be48392311af6a$var$findInstanceBlockingTarget(nativeEvent);
}
var $00be48392311af6a$var$return_targetInst = null;
function $00be48392311af6a$var$findInstanceBlockingTarget(targetNode) {
    $00be48392311af6a$var$return_targetInst = null;
    targetNode = $00be48392311af6a$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $00be48392311af6a$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $00be48392311af6a$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $00be48392311af6a$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $00be48392311af6a$var$return_targetInst = targetNode;
    return null;
}
function $00be48392311af6a$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($00be48392311af6a$var$getCurrentPriorityLevel()){
                case $00be48392311af6a$var$ImmediatePriority:
                    return 2;
                case $00be48392311af6a$var$UserBlockingPriority:
                    return 8;
                case $00be48392311af6a$var$NormalPriority$1:
                case $00be48392311af6a$var$LowPriority:
                    return 32;
                case $00be48392311af6a$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $00be48392311af6a$var$hasScheduledReplayAttempt = !1, $00be48392311af6a$var$queuedFocus = null, $00be48392311af6a$var$queuedDrag = null, $00be48392311af6a$var$queuedMouse = null, $00be48392311af6a$var$queuedPointers = new Map(), $00be48392311af6a$var$queuedPointerCaptures = new Map(), $00be48392311af6a$var$queuedExplicitHydrationTargets = [], $00be48392311af6a$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $00be48392311af6a$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $00be48392311af6a$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $00be48392311af6a$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $00be48392311af6a$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $00be48392311af6a$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $00be48392311af6a$var$getInstanceFromNode(blockedOn), null !== blockedOn && $00be48392311af6a$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $00be48392311af6a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $00be48392311af6a$var$queuedFocus = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $00be48392311af6a$var$queuedDrag = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $00be48392311af6a$var$queuedMouse = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $00be48392311af6a$var$queuedPointers.set(pointerId, $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $00be48392311af6a$var$queuedPointerCaptures.set(pointerId, $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $00be48392311af6a$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $00be48392311af6a$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $00be48392311af6a$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $00be48392311af6a$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00be48392311af6a$var$runWithPriority(queuedTarget.priority, function() {
                        $00be48392311af6a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $00be48392311af6a$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00be48392311af6a$var$runWithPriority(queuedTarget.priority, function() {
                        $00be48392311af6a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $00be48392311af6a$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $00be48392311af6a$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $00be48392311af6a$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $00be48392311af6a$var$currentReplayingEvent = null;
        } else return targetContainers = $00be48392311af6a$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $00be48392311af6a$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $00be48392311af6a$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $00be48392311af6a$var$replayUnblockedEvents() {
    $00be48392311af6a$var$hasScheduledReplayAttempt = !1;
    null !== $00be48392311af6a$var$queuedFocus && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedFocus) && ($00be48392311af6a$var$queuedFocus = null);
    null !== $00be48392311af6a$var$queuedDrag && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedDrag) && ($00be48392311af6a$var$queuedDrag = null);
    null !== $00be48392311af6a$var$queuedMouse && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedMouse) && ($00be48392311af6a$var$queuedMouse = null);
    $00be48392311af6a$var$queuedPointers.forEach($00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap);
    $00be48392311af6a$var$queuedPointerCaptures.forEach($00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap);
}
function $00be48392311af6a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $00be48392311af6a$var$hasScheduledReplayAttempt || ($00be48392311af6a$var$hasScheduledReplayAttempt = !0, $6XCI2.unstable_scheduleCallback($6XCI2.unstable_NormalPriority, $00be48392311af6a$var$replayUnblockedEvents)));
}
var $00be48392311af6a$var$lastScheduledReplayQueue = null;
function $00be48392311af6a$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $00be48392311af6a$var$lastScheduledReplayQueue !== formReplayingQueue && ($00be48392311af6a$var$lastScheduledReplayQueue = formReplayingQueue, $6XCI2.unstable_scheduleCallback($6XCI2.unstable_NormalPriority, function() {
        $00be48392311af6a$var$lastScheduledReplayQueue === formReplayingQueue && ($00be48392311af6a$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $00be48392311af6a$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $00be48392311af6a$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $00be48392311af6a$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $00be48392311af6a$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $00be48392311af6a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $00be48392311af6a$var$queuedFocus && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedFocus, unblocked);
    null !== $00be48392311af6a$var$queuedDrag && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedDrag, unblocked);
    null !== $00be48392311af6a$var$queuedMouse && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedMouse, unblocked);
    $00be48392311af6a$var$queuedPointers.forEach(unblock);
    $00be48392311af6a$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $00be48392311af6a$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $00be48392311af6a$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $00be48392311af6a$var$queuedExplicitHydrationTargets.length && (i = $00be48392311af6a$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$00be48392311af6a$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $00be48392311af6a$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$00be48392311af6a$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $00be48392311af6a$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$00be48392311af6a$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $00be48392311af6a$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $00be48392311af6a$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $00be48392311af6a$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $00be48392311af6a$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.render = $00be48392311af6a$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($00be48392311af6a$var$formatProdErrorMessage(409));
    var current = root.current, lane = $00be48392311af6a$var$requestUpdateLane();
    $00be48392311af6a$var$updateContainerImpl(current, lane, children, root, null, null);
};
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.unmount = $00be48392311af6a$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $00be48392311af6a$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $00be48392311af6a$var$flushSyncWork$1();
        container[$00be48392311af6a$var$internalContainerInstanceKey] = null;
    }
};
function $00be48392311af6a$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $00be48392311af6a$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $00be48392311af6a$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $00be48392311af6a$var$queuedExplicitHydrationTargets[i].priority; i++);
        $00be48392311af6a$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $00be48392311af6a$var$attemptExplicitHydrationTarget(target);
    }
};
var $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $5E6i4.version;
if ("19.3.1" !== $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($00be48392311af6a$var$formatProdErrorMessage(527, $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$00be48392311af6a$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($00be48392311af6a$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $00be48392311af6a$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $00be48392311af6a$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $00be48392311af6a$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $00be48392311af6a$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $00be48392311af6a$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$00be48392311af6a$var$hook$jscomp$inline_2587.isDisabled && $00be48392311af6a$var$hook$jscomp$inline_2587.supportsFiber) try {
        $00be48392311af6a$var$rendererID = $00be48392311af6a$var$hook$jscomp$inline_2587.inject($00be48392311af6a$var$internals$jscomp$inline_2586), $00be48392311af6a$var$injectedHook = $00be48392311af6a$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$00be48392311af6a$export$882461b6382ed46c = function(container, options) {
    if (!$00be48392311af6a$var$isValidContainer(container)) throw Error($00be48392311af6a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00be48392311af6a$var$defaultOnUncaughtError, onCaughtError = $00be48392311af6a$var$defaultOnCaughtError, onRecoverableError = $00be48392311af6a$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $00be48392311af6a$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $00be48392311af6a$var$defaultOnDefaultTransitionIndicator);
    container[$00be48392311af6a$var$internalContainerInstanceKey] = options.current;
    $00be48392311af6a$var$listenToAllSupportedEvents(container);
    return new $00be48392311af6a$var$ReactDOMRoot(options);
};
$00be48392311af6a$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$00be48392311af6a$var$isValidContainer(container)) throw Error($00be48392311af6a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00be48392311af6a$var$defaultOnUncaughtError, onCaughtError = $00be48392311af6a$var$defaultOnCaughtError, onRecoverableError = $00be48392311af6a$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $00be48392311af6a$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $00be48392311af6a$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $00be48392311af6a$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $00be48392311af6a$var$requestUpdateLane();
    isStrictMode = $00be48392311af6a$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $00be48392311af6a$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $00be48392311af6a$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $00be48392311af6a$var$markRootUpdated$1(initialChildren, options);
    $00be48392311af6a$var$ensureRootIsScheduled(initialChildren);
    container[$00be48392311af6a$var$internalContainerInstanceKey] = initialChildren.current;
    $00be48392311af6a$var$listenToAllSupportedEvents(container);
    return new $00be48392311af6a$var$ReactDOMHydrationRoot(initialChildren);
};
$00be48392311af6a$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("6XCI2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Y10g"));

});
parcelRegister("4Y10g", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $39dd8b439010a789$export$c4744153514ff05d, (v) => $39dd8b439010a789$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $39dd8b439010a789$export$3e506c1ccc9cc1a7, (v) => $39dd8b439010a789$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $39dd8b439010a789$export$e26fe2ed2fa76875, (v) => $39dd8b439010a789$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $39dd8b439010a789$export$502329bbf4b505b1, (v) => $39dd8b439010a789$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $39dd8b439010a789$export$6e3807111c4874c4, (v) => $39dd8b439010a789$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $39dd8b439010a789$export$c27134553091fb3a, (v) => $39dd8b439010a789$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $39dd8b439010a789$export$33ee1acdc04fd2a2, (v) => $39dd8b439010a789$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $39dd8b439010a789$export$b00a404bbd5edef2, (v) => $39dd8b439010a789$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $39dd8b439010a789$export$d66a1c1c77bd778b, (v) => $39dd8b439010a789$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $39dd8b439010a789$export$d3dfb8e4810cb555, (v) => $39dd8b439010a789$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $39dd8b439010a789$export$72fdf0e06517287b, (v) => $39dd8b439010a789$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $39dd8b439010a789$export$816d2913ae6b83b1, (v) => $39dd8b439010a789$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $39dd8b439010a789$export$61bcfe829111a1d0, (v) => $39dd8b439010a789$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $39dd8b439010a789$export$7ee8c9beb337bc3f, (v) => $39dd8b439010a789$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $39dd8b439010a789$export$b5836b71941fa3ed, (v) => $39dd8b439010a789$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $39dd8b439010a789$export$cf845f2c119da08a, (v) => $39dd8b439010a789$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39dd8b439010a789$export$c4744153514ff05d;
var $39dd8b439010a789$export$3e506c1ccc9cc1a7;
var $39dd8b439010a789$export$e26fe2ed2fa76875;
var $39dd8b439010a789$export$502329bbf4b505b1;
var $39dd8b439010a789$export$6e3807111c4874c4;
var $39dd8b439010a789$export$c27134553091fb3a;
var $39dd8b439010a789$export$33ee1acdc04fd2a2;
var $39dd8b439010a789$export$b00a404bbd5edef2;
var $39dd8b439010a789$export$d66a1c1c77bd778b;
var $39dd8b439010a789$export$d3dfb8e4810cb555;
var $39dd8b439010a789$export$72fdf0e06517287b;
var $39dd8b439010a789$export$816d2913ae6b83b1;
var $39dd8b439010a789$export$61bcfe829111a1d0;
var $39dd8b439010a789$export$7ee8c9beb337bc3f;
var $39dd8b439010a789$export$b5836b71941fa3ed;
var $39dd8b439010a789$export$cf845f2c119da08a;
"use strict";
function $39dd8b439010a789$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $39dd8b439010a789$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $39dd8b439010a789$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $39dd8b439010a789$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $39dd8b439010a789$var$compare(left, last)) rightIndex < length && 0 > $39dd8b439010a789$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $39dd8b439010a789$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $39dd8b439010a789$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$39dd8b439010a789$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $39dd8b439010a789$var$localPerformance = performance;
    $39dd8b439010a789$export$c4744153514ff05d = function() {
        return $39dd8b439010a789$var$localPerformance.now();
    };
} else {
    var $39dd8b439010a789$var$localDate = Date, $39dd8b439010a789$var$initialTime = $39dd8b439010a789$var$localDate.now();
    $39dd8b439010a789$export$c4744153514ff05d = function() {
        return $39dd8b439010a789$var$localDate.now() - $39dd8b439010a789$var$initialTime;
    };
}
var $39dd8b439010a789$var$taskQueue = [], $39dd8b439010a789$var$timerQueue = [], $39dd8b439010a789$var$taskIdCounter = 1, $39dd8b439010a789$var$currentTask = null, $39dd8b439010a789$var$currentPriorityLevel = 3, $39dd8b439010a789$var$isPerformingWork = !1, $39dd8b439010a789$var$isHostCallbackScheduled = !1, $39dd8b439010a789$var$isHostTimeoutScheduled = !1, $39dd8b439010a789$var$needsPaint = !1, $39dd8b439010a789$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $39dd8b439010a789$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $39dd8b439010a789$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $39dd8b439010a789$var$advanceTimers(currentTime) {
    for(var timer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue); null !== timer;){
        if (null === timer.callback) $39dd8b439010a789$var$pop($39dd8b439010a789$var$timerQueue);
        else if (timer.startTime <= currentTime) $39dd8b439010a789$var$pop($39dd8b439010a789$var$timerQueue), timer.sortIndex = timer.expirationTime, $39dd8b439010a789$var$push($39dd8b439010a789$var$taskQueue, timer);
        else break;
        timer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
    }
}
function $39dd8b439010a789$var$handleTimeout(currentTime) {
    $39dd8b439010a789$var$isHostTimeoutScheduled = !1;
    $39dd8b439010a789$var$advanceTimers(currentTime);
    if (!$39dd8b439010a789$var$isHostCallbackScheduled) {
        if (null !== $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue)) $39dd8b439010a789$var$isHostCallbackScheduled = !0, $39dd8b439010a789$var$isMessageLoopRunning || ($39dd8b439010a789$var$isMessageLoopRunning = !0, $39dd8b439010a789$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
            null !== firstTimer && $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $39dd8b439010a789$var$isMessageLoopRunning = !1, $39dd8b439010a789$var$taskTimeoutID = -1, $39dd8b439010a789$var$frameInterval = 5, $39dd8b439010a789$var$startTime = -1;
function $39dd8b439010a789$var$shouldYieldToHost() {
    return $39dd8b439010a789$var$needsPaint ? !0 : $39dd8b439010a789$export$c4744153514ff05d() - $39dd8b439010a789$var$startTime < $39dd8b439010a789$var$frameInterval ? !1 : !0;
}
function $39dd8b439010a789$var$performWorkUntilDeadline() {
    $39dd8b439010a789$var$needsPaint = !1;
    if ($39dd8b439010a789$var$isMessageLoopRunning) {
        var currentTime = $39dd8b439010a789$export$c4744153514ff05d();
        $39dd8b439010a789$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $39dd8b439010a789$var$isHostCallbackScheduled = !1;
                $39dd8b439010a789$var$isHostTimeoutScheduled && ($39dd8b439010a789$var$isHostTimeoutScheduled = !1, $39dd8b439010a789$var$localClearTimeout($39dd8b439010a789$var$taskTimeoutID), $39dd8b439010a789$var$taskTimeoutID = -1);
                $39dd8b439010a789$var$isPerformingWork = !0;
                var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
                try {
                    b: {
                        $39dd8b439010a789$var$advanceTimers(currentTime);
                        for($39dd8b439010a789$var$currentTask = $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue); null !== $39dd8b439010a789$var$currentTask && !($39dd8b439010a789$var$currentTask.expirationTime > currentTime && $39dd8b439010a789$var$shouldYieldToHost());){
                            var callback = $39dd8b439010a789$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $39dd8b439010a789$var$currentTask.callback = null;
                                $39dd8b439010a789$var$currentPriorityLevel = $39dd8b439010a789$var$currentTask.priorityLevel;
                                var continuationCallback = callback($39dd8b439010a789$var$currentTask.expirationTime <= currentTime);
                                currentTime = $39dd8b439010a789$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $39dd8b439010a789$var$currentTask.callback = continuationCallback;
                                    $39dd8b439010a789$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $39dd8b439010a789$var$currentTask === $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue) && $39dd8b439010a789$var$pop($39dd8b439010a789$var$taskQueue);
                                $39dd8b439010a789$var$advanceTimers(currentTime);
                            } else $39dd8b439010a789$var$pop($39dd8b439010a789$var$taskQueue);
                            $39dd8b439010a789$var$currentTask = $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue);
                        }
                        if (null !== $39dd8b439010a789$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
                            null !== firstTimer && $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $39dd8b439010a789$var$currentTask = null, $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel, $39dd8b439010a789$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $39dd8b439010a789$var$schedulePerformWorkUntilDeadline() : $39dd8b439010a789$var$isMessageLoopRunning = !1;
        }
    }
}
var $39dd8b439010a789$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $39dd8b439010a789$var$localSetImmediate) $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
    $39dd8b439010a789$var$localSetImmediate($39dd8b439010a789$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $39dd8b439010a789$var$channel = new MessageChannel(), $39dd8b439010a789$var$port = $39dd8b439010a789$var$channel.port2;
    $39dd8b439010a789$var$channel.port1.onmessage = $39dd8b439010a789$var$performWorkUntilDeadline;
    $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
        $39dd8b439010a789$var$port.postMessage(null);
    };
} else $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
    $39dd8b439010a789$var$localSetTimeout($39dd8b439010a789$var$performWorkUntilDeadline, 0);
};
function $39dd8b439010a789$var$requestHostTimeout(callback, ms) {
    $39dd8b439010a789$var$taskTimeoutID = $39dd8b439010a789$var$localSetTimeout(function() {
        callback($39dd8b439010a789$export$c4744153514ff05d());
    }, ms);
}
$39dd8b439010a789$export$3e506c1ccc9cc1a7 = 5;
$39dd8b439010a789$export$e26fe2ed2fa76875 = 1;
$39dd8b439010a789$export$502329bbf4b505b1 = 4;
$39dd8b439010a789$export$6e3807111c4874c4 = 3;
$39dd8b439010a789$export$c27134553091fb3a = null;
$39dd8b439010a789$export$33ee1acdc04fd2a2 = 2;
$39dd8b439010a789$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$39dd8b439010a789$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $39dd8b439010a789$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$39dd8b439010a789$export$d3dfb8e4810cb555 = function() {
    return $39dd8b439010a789$var$currentPriorityLevel;
};
$39dd8b439010a789$export$72fdf0e06517287b = function(eventHandler) {
    switch($39dd8b439010a789$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    $39dd8b439010a789$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$39dd8b439010a789$export$816d2913ae6b83b1 = function() {
    $39dd8b439010a789$var$needsPaint = !0;
};
$39dd8b439010a789$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    $39dd8b439010a789$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$39dd8b439010a789$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $39dd8b439010a789$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $39dd8b439010a789$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $39dd8b439010a789$var$push($39dd8b439010a789$var$timerQueue, priorityLevel), null === $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue) && priorityLevel === $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue) && ($39dd8b439010a789$var$isHostTimeoutScheduled ? ($39dd8b439010a789$var$localClearTimeout($39dd8b439010a789$var$taskTimeoutID), $39dd8b439010a789$var$taskTimeoutID = -1) : $39dd8b439010a789$var$isHostTimeoutScheduled = !0, $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $39dd8b439010a789$var$push($39dd8b439010a789$var$taskQueue, priorityLevel), $39dd8b439010a789$var$isHostCallbackScheduled || $39dd8b439010a789$var$isPerformingWork || ($39dd8b439010a789$var$isHostCallbackScheduled = !0, $39dd8b439010a789$var$isMessageLoopRunning || ($39dd8b439010a789$var$isMessageLoopRunning = !0, $39dd8b439010a789$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$39dd8b439010a789$export$b5836b71941fa3ed = $39dd8b439010a789$var$shouldYieldToHost;
$39dd8b439010a789$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
        $39dd8b439010a789$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ibUU1", function(module, exports) {
'use strict';
function $d3e564c2a700df75$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d3e564c2a700df75$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d3e564c2a700df75$var$checkDCE();

module.exports = (parcelRequire("eVkyY"));

});


parcelRegister("dYe7D", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("kZfGu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f475abb6f53e25dc$export$2e2bcd8739ae039);

var $5E6i4 = parcelRequire("5E6i4");

var $8471g = parcelRequire("8471g");

var $62bxO = parcelRequire("62bxO");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f475abb6f53e25dc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f475abb6f53e25dc$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f475abb6f53e25dc$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $f475abb6f53e25dc$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $f475abb6f53e25dc$var$ClientEditorCore {
    constructor(_a){
        var { tools: tools } = _a, config = $f475abb6f53e25dc$var$__rest(_a, [
            "tools"
        ]);
        const extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $62bxO.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $8471g.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    get dangerouslyLowLevelInstance() {
        return this._editorJS;
    }
    clear() {
        return $f475abb6f53e25dc$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.clear();
        });
    }
    save() {
        return $f475abb6f53e25dc$var$__awaiter(this, void 0, void 0, function*() {
            return this._editorJS.save();
        });
    }
    destroy() {
        return $f475abb6f53e25dc$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.isReady;
            yield this._editorJS.destroy();
        });
    }
    render(data) {
        return $f475abb6f53e25dc$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.render(data);
        });
    }
}
function $f475abb6f53e25dc$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useCallback((config)=>new $f475abb6f53e25dc$var$ClientEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($f475abb6f53e25dc$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("8471g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad05913a095033e$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $2ad05913a095033e$var$Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $2ad05913a095033e$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $2ad05913a095033e$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function() {
                return n[o];
            }
        });
    }), t1;
}
function $2ad05913a095033e$var$ot() {}
Object.assign($2ad05913a095033e$var$ot, {
    default: $2ad05913a095033e$var$ot,
    register: $2ad05913a095033e$var$ot,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $2ad05913a095033e$var$Vn = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $2ad05913a095033e$var$Lo = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($2ad05913a095033e$var$Lo || {});
const $2ad05913a095033e$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $2ad05913a095033e$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $2ad05913a095033e$var$Ie(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($2ad05913a095033e$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const a = "Editor.js 2.31.7", l = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(l, i), e = `%c${a}%c ${e}`) : e = `( ${a} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$2ad05913a095033e$var$Ie.logLevel = "VERBOSE";
function $2ad05913a095033e$var$Zn(n) {
    $2ad05913a095033e$var$Ie.logLevel = n;
}
const $2ad05913a095033e$var$S = $2ad05913a095033e$var$Ie.bind(window, !1), $2ad05913a095033e$var$X = $2ad05913a095033e$var$Ie.bind(window, !0);
function $2ad05913a095033e$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $2ad05913a095033e$var$A(n) {
    return $2ad05913a095033e$var$le(n) === "function" || $2ad05913a095033e$var$le(n) === "asyncfunction";
}
function $2ad05913a095033e$var$D(n) {
    return $2ad05913a095033e$var$le(n) === "object";
}
function $2ad05913a095033e$var$te(n) {
    return $2ad05913a095033e$var$le(n) === "string";
}
function $2ad05913a095033e$var$Gn(n) {
    return $2ad05913a095033e$var$le(n) === "boolean";
}
function $2ad05913a095033e$var$yo(n) {
    return $2ad05913a095033e$var$le(n) === "number";
}
function $2ad05913a095033e$var$wo(n) {
    return $2ad05913a095033e$var$le(n) === "undefined";
}
function $2ad05913a095033e$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $2ad05913a095033e$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $2ad05913a095033e$var$Qn(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($2ad05913a095033e$var$wo(i.data) ? {} : i.data);
        } catch  {
            r($2ad05913a095033e$var$wo(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $2ad05913a095033e$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $2ad05913a095033e$var$Fe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $2ad05913a095033e$var$Jn(n) {
    return n.name.split(".").pop();
}
function $2ad05913a095033e$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $2ad05913a095033e$var$Eo(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $2ad05913a095033e$var$dt(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $2ad05913a095033e$var$ti() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $2ad05913a095033e$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $2ad05913a095033e$var$ut(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($2ad05913a095033e$var$D(n) && $2ad05913a095033e$var$D(t1)) for(const o in t1)$2ad05913a095033e$var$D(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $2ad05913a095033e$var$ut(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $2ad05913a095033e$var$ut(n, ...e);
}
function $2ad05913a095033e$var$vt(n) {
    const e = $2ad05913a095033e$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $2ad05913a095033e$var$oi(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $2ad05913a095033e$var$ni() {
    return $2ad05913a095033e$var$Vn(10);
}
function $2ad05913a095033e$var$ii(n) {
    window.open(n, "_blank");
}
function $2ad05913a095033e$var$si(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $2ad05913a095033e$var$ht(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $2ad05913a095033e$var$X(o, "warn");
}
function $2ad05913a095033e$var$me(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
const $2ad05913a095033e$var$Ro = 650;
function $2ad05913a095033e$var$be() {
    return window.matchMedia(`(max-width: ${$2ad05913a095033e$var$Ro}px)`).matches;
}
const $2ad05913a095033e$var$pt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $2ad05913a095033e$var$ri(n, e) {
    const t1 = Array.isArray(n) || $2ad05913a095033e$var$D(n), o = Array.isArray(e) || $2ad05913a095033e$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $2ad05913a095033e$var$u {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $2ad05913a095033e$var$No(e.querySelectorAll($2ad05913a095033e$var$u.allInputsSelector)).reduce((t1, o)=>$2ad05913a095033e$var$u.isNativeInput(o) || $2ad05913a095033e$var$u.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$2ad05913a095033e$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($2ad05913a095033e$var$u.isSingleTag(s) && !$2ad05913a095033e$var$u.isNativeInput(s) && !$2ad05913a095033e$var$u.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $2ad05913a095033e$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $2ad05913a095033e$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($2ad05913a095033e$var$u.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $2ad05913a095033e$var$u.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $2ad05913a095033e$var$u.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $2ad05913a095033e$var$u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $2ad05913a095033e$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$2ad05913a095033e$var$u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $2ad05913a095033e$var$u.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$2ad05913a095033e$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $2ad05913a095033e$var$te(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Returns the closest ancestor anchor (A tag) of the given element (including itself)
   * 
   * @param element - element to check
   * @returns {HTMLAnchorElement | null}
   */ static getClosestAnchor(e) {
        return e.closest("a");
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
    /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ static getNodeByOffset(e, t1) {
        let o = 0, i = null;
        const s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
        let r = s.nextNode();
        for(; r;){
            const c = r.textContent, d = c === null ? 0 : c.length;
            if (i = r, o + d >= t1) break;
            o += d, r = s.nextNode();
        }
        if (!i) return {
            node: null,
            offset: 0
        };
        const a = i.textContent;
        if (a === null || a.length === 0) return {
            node: null,
            offset: 0
        };
        const l = Math.min(t1 - o, a.length);
        return {
            node: i,
            offset: l
        };
    }
}
function $2ad05913a095033e$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $2ad05913a095033e$var$li(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $2ad05913a095033e$var$Do(n) {
    n.dataset.empty = $2ad05913a095033e$var$u.isEmpty(n) ? "true" : "false";
}
const $2ad05913a095033e$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $2ad05913a095033e$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $2ad05913a095033e$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $2ad05913a095033e$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $2ad05913a095033e$var$Fo = {
    ui: $2ad05913a095033e$var$ci,
    toolNames: $2ad05913a095033e$var$di,
    tools: $2ad05913a095033e$var$ui,
    blockTunes: $2ad05913a095033e$var$hi
}, $2ad05913a095033e$var$jo = class he {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        he.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = he.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], he.currentDictionary);
    }
};
$2ad05913a095033e$var$jo.currentDictionary = $2ad05913a095033e$var$Fo;
let $2ad05913a095033e$var$z = $2ad05913a095033e$var$jo;
class $2ad05913a095033e$var$Ho extends Error {
}
class $2ad05913a095033e$var$Oe {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $2ad05913a095033e$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $2ad05913a095033e$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $2ad05913a095033e$var$_e {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $2ad05913a095033e$var$si("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, a)=>{
            const l = this.allListeners.indexOf(s[a]);
            l > -1 && (this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $2ad05913a095033e$var$E {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $2ad05913a095033e$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $2ad05913a095033e$var$E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $2ad05913a095033e$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $2ad05913a095033e$var$u.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($2ad05913a095033e$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$2ad05913a095033e$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$2ad05913a095033e$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$2ad05913a095033e$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $2ad05913a095033e$var$S("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $2ad05913a095033e$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $2ad05913a095033e$var$u.isNativeInput(e) ? $2ad05913a095033e$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $2ad05913a095033e$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $2ad05913a095033e$var$b.range;
        if (e === null) return;
        const t1 = $2ad05913a095033e$var$u.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $2ad05913a095033e$var$u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $2ad05913a095033e$var$u.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (document.execCommand(this.commandBackground, !1, "transparent"), this.isFakeBackgroundEnabled = !1);
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $2ad05913a095033e$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((a)=>{
            let l = o;
            for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $2ad05913a095033e$var$pi(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((l)=>l === e) || Array.from(s).some((l)=>l === e)));
}
const $2ad05913a095033e$var$ft = "redactor dom changed", $2ad05913a095033e$var$$o = "block changed", $2ad05913a095033e$var$zo = "fake cursor is about to be toggled", $2ad05913a095033e$var$Uo = "fake cursor have been set", $2ad05913a095033e$var$Te = "editor mobile layout toggled";
function $2ad05913a095033e$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $2ad05913a095033e$var$A(t1) || $2ad05913a095033e$var$te(t1);
}
function $2ad05913a095033e$var$He(n, e) {
    return $2ad05913a095033e$var$gt(n.tool, e);
}
function $2ad05913a095033e$var$Wo(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $2ad05913a095033e$var$ri(e[t1], o));
}
async function $2ad05913a095033e$var$Yo(n, e) {
    const o = (await n.save()).data, i = e.find((s)=>s.name === n.name);
    return i !== void 0 && !$2ad05913a095033e$var$gt(i, "export") ? [] : e.reduce((s, r)=>{
        if (!$2ad05913a095033e$var$gt(r, "import") || r.toolbox === void 0) return s;
        const a = r.toolbox.filter((l)=>{
            if ($2ad05913a095033e$var$V(l) || l.icon === void 0) return !1;
            if (l.data !== void 0) {
                if ($2ad05913a095033e$var$Wo(l.data, o)) return !1;
            } else if (r.name === n.name) return !1;
            return !0;
        });
        return s.push({
            ...r,
            toolbox: a
        }), s;
    }, []);
}
function $2ad05913a095033e$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $2ad05913a095033e$var$He(e, "export") && $2ad05913a095033e$var$He(n, "import") : !1;
}
function $2ad05913a095033e$var$fi(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $2ad05913a095033e$var$A(t1) ? t1(n) : $2ad05913a095033e$var$te(t1) ? n[t1] : (t1 !== void 0 && $2ad05913a095033e$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $2ad05913a095033e$var$Bo(n, e, t1) {
    const o = e == null ? void 0 : e.import;
    return $2ad05913a095033e$var$A(o) ? o(n, t1) : $2ad05913a095033e$var$te(o) ? {
        [o]: n
    } : (o !== void 0 && $2ad05913a095033e$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $2ad05913a095033e$var$_ = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($2ad05913a095033e$var$_ || {}), $2ad05913a095033e$var$ee = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($2ad05913a095033e$var$ee || {});
class $2ad05913a095033e$var$R extends $2ad05913a095033e$var$Oe {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $2ad05913a095033e$var$ni(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.handleSelectChange = (a)=>{
            const l = a.target;
            $2ad05913a095033e$var$u.isElement(l) && l.tagName === "SELECT" && this.holder.contains(l) && this.didMutated();
        }, this.didMutated = (a)=>{
            const l = a === void 0, c = a instanceof InputEvent;
            !l && !c && this.detectToolRootChange(a);
            let d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: v } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    v
                ].some((T)=>($2ad05913a095033e$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null));
            })), d && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $2ad05913a095033e$var$J(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), this.holder.addEventListener("change", this.handleSelectChange), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $2ad05913a095033e$var$u.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$2ad05913a095033e$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $2ad05913a095033e$var$A(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $2ad05913a095033e$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($2ad05913a095033e$var$R.CSS.selected, e);
        const t1 = e === !0 && $2ad05913a095033e$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $2ad05913a095033e$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($2ad05913a095033e$var$zo, {
            state: e
        }), t1 ? $2ad05913a095033e$var$b.addFakeCursor() : $2ad05913a095033e$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($2ad05913a095033e$var$Uo, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($2ad05913a095033e$var$R.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($2ad05913a095033e$var$R.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($2ad05913a095033e$var$R.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($2ad05913a095033e$var$R.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($2ad05913a095033e$var$A(this.toolInstance[e])) {
            e === "appendCallback" && $2ad05913a095033e$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $2ad05913a095033e$var$S(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($2ad05913a095033e$var$A(r.save)) try {
                t1[s] = r.save();
            } catch (a) {
                $2ad05913a095033e$var$S(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", a);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $2ad05913a095033e$var$S(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $2ad05913a095033e$var$u.isElement(o) ? e.push({
            type: $2ad05913a095033e$var$_.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $2ad05913a095033e$var$u.isElement(s) ? t1.push({
                type: $2ad05913a095033e$var$_.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $2ad05913a095033e$var$u.isNativeInput(document.activeElement) || !$2ad05913a095033e$var$b.anchorNode ? document.activeElement : $2ad05913a095033e$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.holder.removeEventListener("change", this.handleSelectChange), this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $2ad05913a095033e$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$2ad05913a095033e$var$Wo(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $2ad05913a095033e$var$fi(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$R.CSS.wrapper), t1 = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$R.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($2ad05913a095033e$var$A(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $2ad05913a095033e$var$S(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $2ad05913a095033e$var$u.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $2ad05913a095033e$var$u.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$2ad05913a095033e$var$pi(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($2ad05913a095033e$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($2ad05913a095033e$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($2ad05913a095033e$var$Do);
    }
}
class $2ad05913a095033e$var$gi extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, a)=>{
            const l = this.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $2ad05913a095033e$var$J(l);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $2ad05913a095033e$var$R({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $2ad05913a095033e$var$J(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
            if (!l) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && d) {
                const g = await i.convert(r, t1, o);
                return new $2ad05913a095033e$var$J(g);
            } else {
                const g = [
                    c ? !1 : $2ad05913a095033e$var$je(r.name),
                    d ? !1 : $2ad05913a095033e$var$je(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $2ad05913a095033e$var$J(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $2ad05913a095033e$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $2ad05913a095033e$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $2ad05913a095033e$var$J(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($2ad05913a095033e$var$X("There is no block with id `" + e + "`", "warn"), null) : new $2ad05913a095033e$var$J(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $2ad05913a095033e$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $2ad05913a095033e$var$J(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $2ad05913a095033e$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $2ad05913a095033e$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ async renderFromHTML(e) {
        return await this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $2ad05913a095033e$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $2ad05913a095033e$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $2ad05913a095033e$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $2ad05913a095033e$var$bi extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $2ad05913a095033e$var$mi(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $2ad05913a095033e$var$vi extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $2ad05913a095033e$var$kt extends $2ad05913a095033e$var$E {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $2ad05913a095033e$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$2ad05913a095033e$var$z.t($2ad05913a095033e$var$kt.getNamespace(e, t1), o)
        });
    }
}
class $2ad05913a095033e$var$ki extends $2ad05913a095033e$var$E {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $2ad05913a095033e$var$yi extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $2ad05913a095033e$var$wi extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $2ad05913a095033e$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    d
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch  {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if (typeof k.insertAt != "object" || !k.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function(k, m) {
                    return H[k] = m, H.filter(Boolean).join(`
`);
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($2ad05913a095033e$var$Ko);
var $2ad05913a095033e$var$Ei = $2ad05913a095033e$var$Ko.exports;
const $2ad05913a095033e$var$xi = /* @__PURE__ */ $2ad05913a095033e$var$Ke($2ad05913a095033e$var$Ei);
class $2ad05913a095033e$var$Bi {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $2ad05913a095033e$var$xi.show(e);
    }
}
class $2ad05913a095033e$var$Ci extends $2ad05913a095033e$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $2ad05913a095033e$var$Bi();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $2ad05913a095033e$var$Ti extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $2ad05913a095033e$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($2ad05913a095033e$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return typeof p[v];
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($2ad05913a095033e$var$Xo);
var $2ad05913a095033e$var$Si = $2ad05913a095033e$var$Xo.exports;
const $2ad05913a095033e$var$Ii = /* @__PURE__ */ $2ad05913a095033e$var$Ke($2ad05913a095033e$var$Si);
function $2ad05913a095033e$var$yt(n, e) {
    return n.map((t1)=>{
        const o = $2ad05913a095033e$var$A(e) ? e(t1.tool) : e;
        return $2ad05913a095033e$var$V(o) || (t1.data = $2ad05913a095033e$var$wt(t1.data, o)), t1;
    });
}
function $2ad05913a095033e$var$Z(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $2ad05913a095033e$var$Ii(t1).clean(n);
}
function $2ad05913a095033e$var$wt(n, e) {
    return Array.isArray(n) ? $2ad05913a095033e$var$Oi(n, e) : $2ad05913a095033e$var$D(n) ? $2ad05913a095033e$var$_i(n, e) : $2ad05913a095033e$var$te(n) ? $2ad05913a095033e$var$Mi(n, e) : n;
}
function $2ad05913a095033e$var$Oi(n, e) {
    return n.map((t1)=>$2ad05913a095033e$var$wt(t1, e));
}
function $2ad05913a095033e$var$_i(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $2ad05913a095033e$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $2ad05913a095033e$var$wt(i, s);
    }
    return t1;
}
function $2ad05913a095033e$var$Mi(n, e) {
    return $2ad05913a095033e$var$D(e) ? $2ad05913a095033e$var$Z(n, e) : e === !1 ? $2ad05913a095033e$var$Z(n, {}) : n;
}
function $2ad05913a095033e$var$Ai(n) {
    return $2ad05913a095033e$var$D(n) || $2ad05913a095033e$var$Gn(n) || $2ad05913a095033e$var$A(n);
}
class $2ad05913a095033e$var$Li extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $2ad05913a095033e$var$Z(e, t1);
    }
}
class $2ad05913a095033e$var$Pi extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($2ad05913a095033e$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $2ad05913a095033e$var$Ni extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.selectionUtils = new $2ad05913a095033e$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $2ad05913a095033e$var$Ri extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $2ad05913a095033e$var$Di extends $2ad05913a095033e$var$E {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $2ad05913a095033e$var$Fi extends $2ad05913a095033e$var$E {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $2ad05913a095033e$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $2ad05913a095033e$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $2ad05913a095033e$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(a, l, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const d = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                        else {
                            if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof l + " given.");
                            this.nodes.content.appendChild(l);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), d.placement){
                            case "top":
                                this.placeTop(a, d);
                                break;
                            case "left":
                                this.placeLeft(a, d);
                                break;
                            case "right":
                                this.placeRight(a, d);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(a, d);
                        }
                        d && d.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(a = !1) {
                        if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(a, l, c) {
                        a.addEventListener("mouseenter", ()=>{
                            this.show(a, l, c);
                        }), a.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const a = "codex-tooltips-style";
                        if (document.getElementById(a)) return;
                        const l = i(2), c = this.make("style", null, {
                            textContent: l.toString(),
                            id: a
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                        this.applyPlacement("bottom", d, h);
                    }
                    placeTop(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", d, h);
                    }
                    placeLeft(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", d, h);
                    }
                    placeRight(a, l) {
                        const c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", d, h);
                    }
                    applyPlacement(a, l, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(a, l = null, c = {}) {
                        const d = document.createElement(a);
                        Array.isArray(l) ? d.classList.add(...l) : l && d.classList.add(l);
                        for(const h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                        return d;
                    }
                    append(a, l) {
                        Array.isArray(l) ? l.forEach((c)=>a.appendChild(c)) : a.appendChild(l);
                    }
                    prepend(a, l) {
                        Array.isArray(l) ? (l = l.reverse()).forEach((c)=>a.prepend(c)) : a.prepend(l);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($2ad05913a095033e$var$Vo);
var $2ad05913a095033e$var$ji = $2ad05913a095033e$var$Vo.exports;
const $2ad05913a095033e$var$Hi = /* @__PURE__ */ $2ad05913a095033e$var$Ke($2ad05913a095033e$var$ji);
let $2ad05913a095033e$var$U = null;
function $2ad05913a095033e$var$Et() {
    $2ad05913a095033e$var$U || ($2ad05913a095033e$var$U = new $2ad05913a095033e$var$Hi());
}
function $2ad05913a095033e$var$$i(n, e, t1) {
    $2ad05913a095033e$var$Et(), $2ad05913a095033e$var$U == null || $2ad05913a095033e$var$U.show(n, e, t1);
}
function $2ad05913a095033e$var$$e(n = !1) {
    $2ad05913a095033e$var$Et(), $2ad05913a095033e$var$U == null || $2ad05913a095033e$var$U.hide(n);
}
function $2ad05913a095033e$var$ze(n, e, t1) {
    $2ad05913a095033e$var$Et(), $2ad05913a095033e$var$U == null || $2ad05913a095033e$var$U.onHover(n, e, t1);
}
function $2ad05913a095033e$var$zi() {
    $2ad05913a095033e$var$U == null || $2ad05913a095033e$var$U.destroy(), $2ad05913a095033e$var$U = null;
}
class $2ad05913a095033e$var$Ui extends $2ad05913a095033e$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $2ad05913a095033e$var$$i(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $2ad05913a095033e$var$$e();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $2ad05913a095033e$var$ze(e, t1, o);
    }
}
class $2ad05913a095033e$var$Wi extends $2ad05913a095033e$var$E {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $2ad05913a095033e$var$qo(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($2ad05913a095033e$var$D(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((a)=>$2ad05913a095033e$var$te(a)) ? t1[o] = s : t1[o] = $2ad05913a095033e$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $2ad05913a095033e$var$K = $2ad05913a095033e$var$qo($2ad05913a095033e$var$Fo);
function $2ad05913a095033e$var$Yi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $2ad05913a095033e$var$Zo = class Ee {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $2ad05913a095033e$var$u.canSetCaret(this.items[t1]) && $2ad05913a095033e$var$Fe(()=>$2ad05913a095033e$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$2ad05913a095033e$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $2ad05913a095033e$var$ke = $2ad05913a095033e$var$Zo;
class $2ad05913a095033e$var$ce {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (!(!this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch($2ad05913a095033e$var$ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $2ad05913a095033e$var$y.TAB:
                    this.handleTabPress(t1);
                    break;
                case $2ad05913a095033e$var$y.LEFT:
                case $2ad05913a095033e$var$y.UP:
                    this.flipLeft();
                    break;
                case $2ad05913a095033e$var$y.RIGHT:
                case $2ad05913a095033e$var$y.DOWN:
                    this.flipRight();
                    break;
                case $2ad05913a095033e$var$y.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $2ad05913a095033e$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $2ad05913a095033e$var$ce.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $2ad05913a095033e$var$y.TAB,
            $2ad05913a095033e$var$y.LEFT,
            $2ad05913a095033e$var$y.RIGHT,
            $2ad05913a095033e$var$y.ENTER,
            $2ad05913a095033e$var$y.UP,
            $2ad05913a095033e$var$y.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $2ad05913a095033e$var$ke.directions.LEFT : $2ad05913a095033e$var$ke.directions.RIGHT){
            case $2ad05913a095033e$var$ke.directions.RIGHT:
                this.flipRight();
                break;
            case $2ad05913a095033e$var$ke.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $2ad05913a095033e$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $2ad05913a095033e$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $2ad05913a095033e$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $2ad05913a095033e$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $2ad05913a095033e$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $2ad05913a095033e$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $2ad05913a095033e$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $2ad05913a095033e$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $2ad05913a095033e$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $2ad05913a095033e$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $2ad05913a095033e$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $2ad05913a095033e$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $2ad05913a095033e$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $2ad05913a095033e$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $2ad05913a095033e$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $2ad05913a095033e$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $2ad05913a095033e$var$ss = "__", $2ad05913a095033e$var$rs = "--";
function $2ad05913a095033e$var$ne(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($2ad05913a095033e$var$ss),
            t1
        ].filter((i)=>!!i).join($2ad05913a095033e$var$rs);
}
const $2ad05913a095033e$var$ye = $2ad05913a095033e$var$ne("ce-hint"), $2ad05913a095033e$var$we = {
    root: $2ad05913a095033e$var$ye(),
    alignedStart: $2ad05913a095033e$var$ye(null, "align-left"),
    alignedCenter: $2ad05913a095033e$var$ye(null, "align-center"),
    title: $2ad05913a095033e$var$ye("title"),
    description: $2ad05913a095033e$var$ye("description")
};
class $2ad05913a095033e$var$as {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $2ad05913a095033e$var$u.make("div", [
                $2ad05913a095033e$var$we.root,
                e.alignment === "center" ? $2ad05913a095033e$var$we.alignedCenter : $2ad05913a095033e$var$we.alignedStart
            ]),
            title: $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $2ad05913a095033e$var$xt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $2ad05913a095033e$var$$e();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $2ad05913a095033e$var$as(t1);
        $2ad05913a095033e$var$ze(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $2ad05913a095033e$var$Y = $2ad05913a095033e$var$ne("ce-popover-item"), $2ad05913a095033e$var$L = {
    container: $2ad05913a095033e$var$Y(),
    active: $2ad05913a095033e$var$Y(null, "active"),
    disabled: $2ad05913a095033e$var$Y(null, "disabled"),
    focused: $2ad05913a095033e$var$Y(null, "focused"),
    hidden: $2ad05913a095033e$var$Y(null, "hidden"),
    confirmationState: $2ad05913a095033e$var$Y(null, "confirmation"),
    noHover: $2ad05913a095033e$var$Y(null, "no-hover"),
    noFocus: $2ad05913a095033e$var$Y(null, "no-focus"),
    title: $2ad05913a095033e$var$Y("title"),
    secondaryTitle: $2ad05913a095033e$var$Y("secondary-title"),
    icon: $2ad05913a095033e$var$Y("icon"),
    iconTool: $2ad05913a095033e$var$Y("icon", "tool"),
    iconChevronRight: $2ad05913a095033e$var$Y("icon", "chevron-right"),
    wobbleAnimation: $2ad05913a095033e$var$ne("wobble")()
};
class $2ad05913a095033e$var$re extends $2ad05913a095033e$var$xt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($2ad05913a095033e$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($2ad05913a095033e$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($2ad05913a095033e$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($2ad05913a095033e$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($2ad05913a095033e$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($2ad05913a095033e$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $2ad05913a095033e$var$u.make(o, $2ad05913a095033e$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$L.icon,
            $2ad05913a095033e$var$L.iconTool
        ], {
            innerHTML: e.icon || $2ad05913a095033e$var$Qi
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$L.icon,
            $2ad05913a095033e$var$L.iconChevronRight
        ], {
            innerHTML: $2ad05913a095033e$var$qi
        })), this.isActive && i.classList.add($2ad05913a095033e$var$L.active), e.isDisabled && i.classList.add($2ad05913a095033e$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($2ad05913a095033e$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($2ad05913a095033e$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($2ad05913a095033e$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($2ad05913a095033e$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($2ad05913a095033e$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($2ad05913a095033e$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $2ad05913a095033e$var$nt = $2ad05913a095033e$var$ne("ce-popover-item-separator"), $2ad05913a095033e$var$it = {
    container: $2ad05913a095033e$var$nt(),
    line: $2ad05913a095033e$var$nt("line"),
    hidden: $2ad05913a095033e$var$nt(null, "hidden")
};
class $2ad05913a095033e$var$Qo extends $2ad05913a095033e$var$xt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$it.container),
            line: $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$it.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($2ad05913a095033e$var$it.hidden, e);
    }
}
var $2ad05913a095033e$var$G = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($2ad05913a095033e$var$G || {});
const $2ad05913a095033e$var$$ = $2ad05913a095033e$var$ne("ce-popover"), $2ad05913a095033e$var$P = {
    popover: $2ad05913a095033e$var$$(),
    popoverContainer: $2ad05913a095033e$var$$("container"),
    popoverOpenTop: $2ad05913a095033e$var$$(null, "open-top"),
    popoverOpenLeft: $2ad05913a095033e$var$$(null, "open-left"),
    popoverOpened: $2ad05913a095033e$var$$(null, "opened"),
    search: $2ad05913a095033e$var$$("search"),
    nothingFoundMessage: $2ad05913a095033e$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $2ad05913a095033e$var$$("nothing-found-message", "displayed"),
    items: $2ad05913a095033e$var$$("items"),
    overlay: $2ad05913a095033e$var$$("overlay"),
    overlayHidden: $2ad05913a095033e$var$$("overlay", "hidden"),
    popoverNested: $2ad05913a095033e$var$$(null, "nested"),
    getPopoverNestedClass: (n)=>$2ad05913a095033e$var$$(null, `nested-level-${n.toString()}`),
    popoverInline: $2ad05913a095033e$var$$(null, "inline"),
    popoverHeader: $2ad05913a095033e$var$$("header")
};
var $2ad05913a095033e$var$fe = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($2ad05913a095033e$var$fe || {});
const $2ad05913a095033e$var$To = $2ad05913a095033e$var$ne("ce-popover-item-html"), $2ad05913a095033e$var$So = {
    root: $2ad05913a095033e$var$To(),
    hidden: $2ad05913a095033e$var$To(null, "hidden")
};
class $2ad05913a095033e$var$Se extends $2ad05913a095033e$var$xt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$So.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($2ad05913a095033e$var$So.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$2ad05913a095033e$var$u.allInputsSelector}`);
        return Array.from(e);
    }
}
class $2ad05913a095033e$var$Jo extends $2ad05913a095033e$var$Oe {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $2ad05913a095033e$var$_e(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$P.popoverContainer
        ]), this.nodes.nothingFoundMessage = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$P.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$P.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$P.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $2ad05913a095033e$var$re);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($2ad05913a095033e$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($2ad05913a095033e$var$P.popoverOpened), this.nodes.popover.classList.remove($2ad05913a095033e$var$P.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($2ad05913a095033e$var$G.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $2ad05913a095033e$var$_.Separator:
                    return new $2ad05913a095033e$var$Qo();
                case $2ad05913a095033e$var$_.Html:
                    return new $2ad05913a095033e$var$Se(t1, this.itemsRenderParams[$2ad05913a095033e$var$_.Html]);
                default:
                    return new $2ad05913a095033e$var$re(t1, this.itemsRenderParams[$2ad05913a095033e$var$_.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $2ad05913a095033e$var$re || t1 instanceof $2ad05913a095033e$var$Se).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($2ad05913a095033e$var$G.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $2ad05913a095033e$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $2ad05913a095033e$var$Ue = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($2ad05913a095033e$var$Ue || {});
const $2ad05913a095033e$var$st = $2ad05913a095033e$var$ne("cdx-search-field"), $2ad05913a095033e$var$rt = {
    wrapper: $2ad05913a095033e$var$st(),
    icon: $2ad05913a095033e$var$st("icon"),
    input: $2ad05913a095033e$var$st("input")
};
class $2ad05913a095033e$var$ls extends $2ad05913a095033e$var$Oe {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $2ad05913a095033e$var$_e(), this.items = e, this.wrapper = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$rt.wrapper);
        const o = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$rt.icon, {
            innerHTML: $2ad05913a095033e$var$os
        });
        this.input = $2ad05913a095033e$var$u.make("input", $2ad05913a095033e$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($2ad05913a095033e$var$Ue.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($2ad05913a095033e$var$Ue.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $2ad05913a095033e$var$cs = Object.defineProperty, $2ad05913a095033e$var$ds = Object.getOwnPropertyDescriptor, $2ad05913a095033e$var$us = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $2ad05913a095033e$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $2ad05913a095033e$var$cs(e, t1, i), i;
};
const $2ad05913a095033e$var$en = class tn extends $2ad05913a095033e$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var a;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((l)=>{
                let c = !1;
                l instanceof $2ad05913a095033e$var$re ? c = !o.items.includes(l) : (l instanceof $2ad05913a095033e$var$Qo || l instanceof $2ad05913a095033e$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((l)=>l.getElement());
            (a = this.flipper) != null && a.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($2ad05913a095033e$var$P.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $2ad05913a095033e$var$ce({
            items: this.flippableElements,
            focusedItemClass: $2ad05913a095033e$var$L.focused,
            allowedKeys: [
                $2ad05913a095033e$var$y.TAB,
                $2ad05913a095033e$var$y.UP,
                $2ad05913a095033e$var$y.DOWN,
                $2ad05913a095033e$var$y.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($2ad05913a095033e$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($2ad05913a095033e$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($2ad05913a095033e$var$P.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($2ad05913a095033e$var$fe.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($2ad05913a095033e$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new tn({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($2ad05913a095033e$var$G.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($2ad05913a095033e$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($2ad05913a095033e$var$P.popoverOpened), (i = t1.querySelector("." + $2ad05913a095033e$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $2ad05913a095033e$var$P.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $2ad05913a095033e$var$re) return t1.getElement();
            if (t1 instanceof $2ad05913a095033e$var$Se) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $2ad05913a095033e$var$ls({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($2ad05913a095033e$var$Ue.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($2ad05913a095033e$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($2ad05913a095033e$var$P.nothingFoundMessageDisplayed, e);
    }
};
$2ad05913a095033e$var$us([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$en.prototype, "size", 1);
let $2ad05913a095033e$var$Bt = $2ad05913a095033e$var$en;
class $2ad05913a095033e$var$hs extends $2ad05913a095033e$var$Bt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$2ad05913a095033e$var$be();
        super({
            ...e,
            class: $2ad05913a095033e$var$P.popoverInline
        }, {
            [$2ad05913a095033e$var$_.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$2ad05913a095033e$var$_.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $2ad05913a095033e$var$re) && !(o instanceof $2ad05913a095033e$var$Se) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($2ad05913a095033e$var$fe.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($2ad05913a095033e$var$fe.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($2ad05913a095033e$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $2ad05913a095033e$var$on = class xe {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $2ad05913a095033e$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $2ad05913a095033e$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$2ad05913a095033e$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $2ad05913a095033e$var$ps = $2ad05913a095033e$var$on;
const $2ad05913a095033e$var$at = $2ad05913a095033e$var$ne("ce-popover-header"), $2ad05913a095033e$var$lt = {
    root: $2ad05913a095033e$var$at(),
    text: $2ad05913a095033e$var$at("text"),
    backButton: $2ad05913a095033e$var$at("back-button")
};
class $2ad05913a095033e$var$fs {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $2ad05913a095033e$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $2ad05913a095033e$var$u.make("div", [
                $2ad05913a095033e$var$lt.root
            ]),
            backButton: $2ad05913a095033e$var$u.make("button", [
                $2ad05913a095033e$var$lt.backButton
            ]),
            text: $2ad05913a095033e$var$u.make("div", [
                $2ad05913a095033e$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $2ad05913a095033e$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $2ad05913a095033e$var$gs {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $2ad05913a095033e$var$nn extends $2ad05913a095033e$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$2ad05913a095033e$var$_.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$2ad05913a095033e$var$_.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $2ad05913a095033e$var$ps(), this.history = new $2ad05913a095033e$var$gs(), this.isHidden = !0, this.nodes.overlay = $2ad05913a095033e$var$u.make("div", [
            $2ad05913a095033e$var$P.overlay,
            $2ad05913a095033e$var$P.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($2ad05913a095033e$var$P.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($2ad05913a095033e$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $2ad05913a095033e$var$fs({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $2ad05913a095033e$var$ms extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.opened = !1, this.hasMobileLayoutToggleListener = !1, this.selection = new $2ad05913a095033e$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $2ad05913a095033e$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($2ad05913a095033e$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $2ad05913a095033e$var$u.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($2ad05913a095033e$var$Te, this.close), this.hasMobileLayoutToggleListener = !0;
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.hasMobileLayoutToggleListener && (this.eventsDispatcher.off($2ad05913a095033e$var$Te, this.close), this.hasMobileLayoutToggleListener = !1);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $2ad05913a095033e$var$be() ? $2ad05913a095033e$var$nn : $2ad05913a095033e$var$Bt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Nothing found"),
                search: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($2ad05913a095033e$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $2ad05913a095033e$var$_.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), a = (await $2ad05913a095033e$var$Yo(e, s)).reduce((l, c)=>(c.toolbox.forEach((d)=>{
                l.push({
                    icon: d.icon,
                    title: $2ad05913a095033e$var$z.t($2ad05913a095033e$var$K.toolNames, d.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, d.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), l), []);
        return a.length > 0 && (i.push({
            icon: $2ad05913a095033e$var$Go,
            name: "convert-to",
            title: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: a
            }
        }), i.push({
            type: $2ad05913a095033e$var$_.Separator
        })), i.push(...t1), i.map((l)=>this.resolveTuneAliases(l));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $2ad05913a095033e$var$_.Separator || e.type === $2ad05913a095033e$var$_.Html) return e;
        const t1 = $2ad05913a095033e$var$Yi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $2ad05913a095033e$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($2ad05913a095033e$var$sn);
var $2ad05913a095033e$var$bs = $2ad05913a095033e$var$sn.exports;
const $2ad05913a095033e$var$vs = /* @__PURE__ */ $2ad05913a095033e$var$Ke($2ad05913a095033e$var$bs);
class $2ad05913a095033e$var$ks {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $2ad05913a095033e$var$vs({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const s = this.registeredShortcuts.get(e).filter((r)=>r !== o);
        if (s.length === 0) {
            this.registeredShortcuts.delete(e);
            return;
        }
        this.registeredShortcuts.set(e, s);
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $2ad05913a095033e$var$ge = new $2ad05913a095033e$var$ks();
var $2ad05913a095033e$var$ys = Object.defineProperty, $2ad05913a095033e$var$ws = Object.getOwnPropertyDescriptor, $2ad05913a095033e$var$rn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $2ad05913a095033e$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $2ad05913a095033e$var$ys(e, t1, i), i;
}, $2ad05913a095033e$var$Le = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($2ad05913a095033e$var$Le || {});
const $2ad05913a095033e$var$Ct = class an extends $2ad05913a095033e$var$Oe {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $2ad05913a095033e$var$_e(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $2ad05913a095033e$var$u.make("div", an.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($2ad05913a095033e$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($2ad05913a095033e$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($2ad05913a095033e$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $2ad05913a095033e$var$be() ? $2ad05913a095033e$var$nn : $2ad05913a095033e$var$Bt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($2ad05913a095033e$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($2ad05913a095033e$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o, i = !0)=>({
                icon: t1.icon,
                title: $2ad05913a095033e$var$z.t($2ad05913a095033e$var$K.toolNames, t1.title || $2ad05913a095033e$var$je(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut && i ? $2ad05913a095033e$var$vt(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i, s)=>{
                t1.push(e(i, o, s === 0));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $2ad05913a095033e$var$ge.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $2ad05913a095033e$var$ge.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const l = await this.api.blocks.composeBlockData(e);
            r = Object.assign(l, t1);
        }
        const a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        a.call($2ad05913a095033e$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: a
        }), this.api.toolbar.close();
    }
};
$2ad05913a095033e$var$rn([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$Ct.prototype, "toolsToBeDisplayed", 1);
$2ad05913a095033e$var$rn([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
let $2ad05913a095033e$var$Es = $2ad05913a095033e$var$Ct;
const $2ad05913a095033e$var$ln = "block hovered";
async function $2ad05913a095033e$var$xs(n, e) {
    const t1 = navigator.keyboard;
    if (!t1) return e;
    try {
        return (await t1.getLayoutMap()).get(n) || e;
    } catch (o) {
        return console.error(o), e;
    }
}
class $2ad05913a095033e$var$Bs extends $2ad05913a095033e$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $2ad05913a095033e$var$S("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $2ad05913a095033e$var$S("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $2ad05913a095033e$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || d) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $2ad05913a095033e$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $2ad05913a095033e$var$u.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $2ad05913a095033e$var$u.make("div", this.CSS[s]);
        }), $2ad05913a095033e$var$u.append(this.nodes.wrapper, this.nodes.content), $2ad05913a095033e$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $2ad05913a095033e$var$u.make("div", this.CSS.plusButton, {
            innerHTML: $2ad05913a095033e$var$ts
        }), $2ad05913a095033e$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $2ad05913a095033e$var$$e(!0), this.plusButtonClicked();
        }, !1);
        const e = $2ad05913a095033e$var$u.make("div");
        e.appendChild(document.createTextNode($2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($2ad05913a095033e$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $2ad05913a095033e$var$ze(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $2ad05913a095033e$var$u.make("span", this.CSS.settingsToggler, {
            innerHTML: $2ad05913a095033e$var$es
        }), $2ad05913a095033e$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $2ad05913a095033e$var$u.make("div"), o = $2ad05913a095033e$var$u.text($2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $2ad05913a095033e$var$xs("Slash", "/");
        t1.appendChild(o), t1.appendChild($2ad05913a095033e$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: $2ad05913a095033e$var$vt(`CMD + ${i}`)
        })), $2ad05913a095033e$var$ze(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $2ad05913a095033e$var$u.append(this.nodes.actions, this.makeToolbox()), $2ad05913a095033e$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $2ad05913a095033e$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $2ad05913a095033e$var$Es({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Filter"),
                nothingFound: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($2ad05913a095033e$var$Le.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($2ad05913a095033e$var$Le.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($2ad05913a095033e$var$Le.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $2ad05913a095033e$var$$e(!0);
        }, !0), $2ad05913a095033e$var$be() || this.eventsDispatcher.on($2ad05913a095033e$var$ln, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $2ad05913a095033e$var$ae = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($2ad05913a095033e$var$ae || {}), $2ad05913a095033e$var$Pe = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($2ad05913a095033e$var$Pe || {}), $2ad05913a095033e$var$cn = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($2ad05913a095033e$var$cn || {}), $2ad05913a095033e$var$pe = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($2ad05913a095033e$var$pe || {}), $2ad05913a095033e$var$We = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n))($2ad05913a095033e$var$We || {}), $2ad05913a095033e$var$mt = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($2ad05913a095033e$var$mt || {});
class $2ad05913a095033e$var$Tt {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: a }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($2ad05913a095033e$var$A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($2ad05913a095033e$var$A(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $2ad05913a095033e$var$ae.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $2ad05913a095033e$var$ae.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $2ad05913a095033e$var$ae.Tune;
    }
}
class $2ad05913a095033e$var$Cs extends $2ad05913a095033e$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $2ad05913a095033e$var$be() ? 20 : 6, this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        if (this.opened) {
            for (const [o, i] of this.tools){
                const s = this.getToolShortcut(o.name);
                s !== void 0 && $2ad05913a095033e$var$ge.remove(this.Editor.UI.nodes.redactor, s), $2ad05913a095033e$var$A(i.clear) && i.clear();
            }
            this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
        }
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $2ad05913a095033e$var$u.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $2ad05913a095033e$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
        const e = await this.getPopoverItems();
        this.popover = new $2ad05913a095033e$var$hs({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Nothing found"),
                search: $2ad05913a095033e$var$z.ui($2ad05913a095033e$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $2ad05913a095033e$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $2ad05913a095033e$var$b.get(), o = $2ad05913a095033e$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $2ad05913a095033e$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
        const s = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return !s || this.getTools().some((c)=>s.tool.inlineTools.has(c.name)) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ getTools() {
        const e = this.Editor.BlockManager.currentBlock;
        return e ? Array.from(e.tool.inlineTools.values()).filter((o)=>!(this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0)) : [];
    }
    /**
   * Constructs tools instances and saves them to this.tools
   */ createToolsInstances() {
        this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach((t1)=>{
            const o = t1.create();
            this.tools.set(t1, o);
        });
    }
    /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ async getPopoverItems() {
        const e = [];
        let t1 = 0;
        for (const [o, i] of this.tools){
            const s = await i.render(), r = this.getToolShortcut(o.name);
            if (r !== void 0) try {
                this.enableShortcuts(o.name, r);
            } catch  {}
            const a = r !== void 0 ? $2ad05913a095033e$var$vt(r) : void 0, l = $2ad05913a095033e$var$z.t($2ad05913a095033e$var$K.toolNames, o.title || $2ad05913a095033e$var$je(o.name));
            [
                s
            ].flat().forEach((c)=>{
                var h, p;
                const d = {
                    name: o.name,
                    onActivate: ()=>{
                        this.toolClicked(i);
                    },
                    hint: {
                        title: l,
                        description: a
                    }
                };
                if ($2ad05913a095033e$var$u.isElement(c)) {
                    const g = {
                        ...d,
                        element: c,
                        type: $2ad05913a095033e$var$_.Html
                    };
                    if ($2ad05913a095033e$var$A(i.renderActions)) {
                        const f = i.renderActions();
                        g.children = {
                            isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $2ad05913a095033e$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $2ad05913a095033e$var$_.Html,
                                    element: f
                                }
                            ]
                        };
                    } else (p = i.checkState) == null || p.call(i, $2ad05913a095033e$var$b.get());
                    e.push(g);
                } else if (c.type === $2ad05913a095033e$var$_.Html) e.push({
                    ...d,
                    ...c,
                    type: $2ad05913a095033e$var$_.Html
                });
                else if (c.type === $2ad05913a095033e$var$_.Separator) e.push({
                    type: $2ad05913a095033e$var$_.Separator
                });
                else {
                    const g = {
                        ...d,
                        ...c,
                        type: $2ad05913a095033e$var$_.Default
                    };
                    "children" in g && t1 !== 0 && e.push({
                        type: $2ad05913a095033e$var$_.Separator
                    }), e.push(g), "children" in g && t1 < this.tools.size - 1 && e.push({
                        type: $2ad05913a095033e$var$_.Separator
                    });
                }
            }), t1++;
        }
        return e;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$2ad05913a095033e$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $2ad05913a095033e$var$ge.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $2ad05913a095033e$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.tools) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $2ad05913a095033e$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $2ad05913a095033e$var$dn() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $2ad05913a095033e$var$un(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const a = r.textContent || "";
    return $2ad05913a095033e$var$ai(a);
}
function $2ad05913a095033e$var$Ne(n) {
    const e = $2ad05913a095033e$var$u.getDeepestNode(n);
    if (e === null || $2ad05913a095033e$var$u.isEmpty(n)) return !0;
    if ($2ad05913a095033e$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($2ad05913a095033e$var$u.isEmpty(n)) return !0;
    const [t1, o] = $2ad05913a095033e$var$dn();
    return t1 === null ? !1 : $2ad05913a095033e$var$un(n, t1, o, "left");
}
function $2ad05913a095033e$var$Re(n) {
    const e = $2ad05913a095033e$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($2ad05913a095033e$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $2ad05913a095033e$var$dn();
    return t1 === null ? !1 : $2ad05913a095033e$var$un(n, t1, o, "right");
}
var $2ad05913a095033e$var$hn = {}, $2ad05913a095033e$var$St = {}, $2ad05913a095033e$var$Xe = {}, $2ad05913a095033e$var$de = {}, $2ad05913a095033e$var$It = {}, $2ad05913a095033e$var$Ot = {};
Object.defineProperty($2ad05913a095033e$var$Ot, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Ot.allInputsSelector = $2ad05913a095033e$var$Ts;
function $2ad05913a095033e$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $2ad05913a095033e$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
})($2ad05913a095033e$var$It);
var $2ad05913a095033e$var$ue = {}, $2ad05913a095033e$var$_t = {};
Object.defineProperty($2ad05913a095033e$var$_t, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$_t.isNativeInput = $2ad05913a095033e$var$Ss;
function $2ad05913a095033e$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $2ad05913a095033e$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return e.isNativeInput;
        }
    });
})($2ad05913a095033e$var$ue);
var $2ad05913a095033e$var$pn = {}, $2ad05913a095033e$var$Mt = {};
Object.defineProperty($2ad05913a095033e$var$Mt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Mt.append = $2ad05913a095033e$var$Is;
function $2ad05913a095033e$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $2ad05913a095033e$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return e.append;
        }
    });
})($2ad05913a095033e$var$pn);
var $2ad05913a095033e$var$At = {}, $2ad05913a095033e$var$Lt = {};
Object.defineProperty($2ad05913a095033e$var$Lt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Lt.blockElements = $2ad05913a095033e$var$Os;
function $2ad05913a095033e$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $2ad05913a095033e$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return e.blockElements;
        }
    });
})($2ad05913a095033e$var$At);
var $2ad05913a095033e$var$fn = {}, $2ad05913a095033e$var$Pt = {};
Object.defineProperty($2ad05913a095033e$var$Pt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Pt.calculateBaseline = $2ad05913a095033e$var$_s;
function $2ad05913a095033e$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $2ad05913a095033e$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return e.calculateBaseline;
        }
    });
})($2ad05913a095033e$var$fn);
var $2ad05913a095033e$var$gn = {}, $2ad05913a095033e$var$Nt = {}, $2ad05913a095033e$var$Rt = {}, $2ad05913a095033e$var$Dt = {};
Object.defineProperty($2ad05913a095033e$var$Dt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Dt.isContentEditable = $2ad05913a095033e$var$Ms;
function $2ad05913a095033e$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $2ad05913a095033e$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return e.isContentEditable;
        }
    });
})($2ad05913a095033e$var$Rt);
Object.defineProperty($2ad05913a095033e$var$Nt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Nt.canSetCaret = $2ad05913a095033e$var$Ps;
var $2ad05913a095033e$var$As = $2ad05913a095033e$var$ue, $2ad05913a095033e$var$Ls = $2ad05913a095033e$var$Rt;
function $2ad05913a095033e$var$Ps(n) {
    var e = !0;
    if ((0, $2ad05913a095033e$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $2ad05913a095033e$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $2ad05913a095033e$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return e.canSetCaret;
        }
    });
})($2ad05913a095033e$var$gn);
var $2ad05913a095033e$var$Ve = {}, $2ad05913a095033e$var$Ft = {};
function $2ad05913a095033e$var$Ns(n, e, t1) {
    const o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $2ad05913a095033e$var$mn() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e !== void 0 && (n[e] = !0), n;
}
function $2ad05913a095033e$var$jt(n) {
    return n != null && n !== "" && (typeof n != "object" || Object.keys(n).length > 0);
}
function $2ad05913a095033e$var$Rs(n) {
    return !$2ad05913a095033e$var$jt(n);
}
const $2ad05913a095033e$var$Ds = ()=>typeof window < "u" && window.navigator !== null && $2ad05913a095033e$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $2ad05913a095033e$var$Fs(n) {
    const e = $2ad05913a095033e$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $2ad05913a095033e$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $2ad05913a095033e$var$Hs(n) {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    const t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $2ad05913a095033e$var$$s(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $2ad05913a095033e$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $2ad05913a095033e$var$zs(n) {
    return $2ad05913a095033e$var$oe(n) === "boolean";
}
function $2ad05913a095033e$var$bn(n) {
    return $2ad05913a095033e$var$oe(n) === "function" || $2ad05913a095033e$var$oe(n) === "asyncfunction";
}
function $2ad05913a095033e$var$Us(n) {
    return $2ad05913a095033e$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $2ad05913a095033e$var$Ws(n) {
    return $2ad05913a095033e$var$oe(n) === "number";
}
function $2ad05913a095033e$var$De(n) {
    return $2ad05913a095033e$var$oe(n) === "object";
}
function $2ad05913a095033e$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $2ad05913a095033e$var$Ks(n) {
    return $2ad05913a095033e$var$oe(n) === "string";
}
function $2ad05913a095033e$var$Xs(n) {
    return $2ad05913a095033e$var$oe(n) === "undefined";
}
function $2ad05913a095033e$var$bt(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($2ad05913a095033e$var$De(n) && $2ad05913a095033e$var$De(t1)) for(const o in t1)$2ad05913a095033e$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, {
        [o]: {}
    }), $2ad05913a095033e$var$bt(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $2ad05913a095033e$var$bt(n, ...e);
}
function $2ad05913a095033e$var$Vs(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && console.warn(o);
}
function $2ad05913a095033e$var$qs(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $2ad05913a095033e$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
const $2ad05913a095033e$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $2ad05913a095033e$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
let $2ad05913a095033e$var$Js = class {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
};
function $2ad05913a095033e$var$er(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
const $2ad05913a095033e$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $2ad05913a095033e$var$Js,
    beautifyShortcut: $2ad05913a095033e$var$Fs,
    cacheable: $2ad05913a095033e$var$Ns,
    capitalize: $2ad05913a095033e$var$js,
    copyTextToClipboard: $2ad05913a095033e$var$Hs,
    debounce: $2ad05913a095033e$var$$s,
    deepMerge: $2ad05913a095033e$var$bt,
    deprecationAssert: $2ad05913a095033e$var$Vs,
    getUserOS: $2ad05913a095033e$var$mn,
    getValidUrl: $2ad05913a095033e$var$qs,
    isBoolean: $2ad05913a095033e$var$zs,
    isClass: $2ad05913a095033e$var$Us,
    isEmpty: $2ad05913a095033e$var$Rs,
    isFunction: $2ad05913a095033e$var$bn,
    isIosDevice: $2ad05913a095033e$var$Ds,
    isNumber: $2ad05913a095033e$var$Ws,
    isObject: $2ad05913a095033e$var$De,
    isPrintableKey: $2ad05913a095033e$var$Zs,
    isPromise: $2ad05913a095033e$var$Ys,
    isString: $2ad05913a095033e$var$Ks,
    isUndefined: $2ad05913a095033e$var$Xs,
    keyCodes: $2ad05913a095033e$var$Gs,
    mouseButtons: $2ad05913a095033e$var$Qs,
    notEmpty: $2ad05913a095033e$var$jt,
    throttle: $2ad05913a095033e$var$er,
    typeOf: $2ad05913a095033e$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $2ad05913a095033e$var$Ht = /* @__PURE__ */ $2ad05913a095033e$var$Xn($2ad05913a095033e$var$tr);
Object.defineProperty($2ad05913a095033e$var$Ft, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Ft.containsOnlyInlineElements = $2ad05913a095033e$var$ir;
var $2ad05913a095033e$var$or = $2ad05913a095033e$var$Ht, $2ad05913a095033e$var$nr = $2ad05913a095033e$var$At;
function $2ad05913a095033e$var$ir(n) {
    var e;
    (0, $2ad05913a095033e$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function(o) {
        return !(0, $2ad05913a095033e$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $2ad05913a095033e$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return e.containsOnlyInlineElements;
        }
    });
})($2ad05913a095033e$var$Ve);
var $2ad05913a095033e$var$vn = {}, $2ad05913a095033e$var$$t = {}, $2ad05913a095033e$var$qe = {}, $2ad05913a095033e$var$zt = {};
Object.defineProperty($2ad05913a095033e$var$zt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$zt.make = $2ad05913a095033e$var$sr;
function $2ad05913a095033e$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $2ad05913a095033e$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return e.make;
        }
    });
})($2ad05913a095033e$var$qe);
Object.defineProperty($2ad05913a095033e$var$$t, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$$t.fragmentToString = $2ad05913a095033e$var$ar;
var $2ad05913a095033e$var$rr = $2ad05913a095033e$var$qe;
function $2ad05913a095033e$var$ar(n) {
    var e = (0, $2ad05913a095033e$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $2ad05913a095033e$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return e.fragmentToString;
        }
    });
})($2ad05913a095033e$var$vn);
var $2ad05913a095033e$var$kn = {}, $2ad05913a095033e$var$Ut = {};
Object.defineProperty($2ad05913a095033e$var$Ut, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Ut.getContentLength = $2ad05913a095033e$var$cr;
var $2ad05913a095033e$var$lr = $2ad05913a095033e$var$ue;
function $2ad05913a095033e$var$cr(n) {
    var e, t1;
    return (0, $2ad05913a095033e$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $2ad05913a095033e$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return e.getContentLength;
        }
    });
})($2ad05913a095033e$var$kn);
var $2ad05913a095033e$var$Wt = {}, $2ad05913a095033e$var$Yt = {}, $2ad05913a095033e$var$Io = $2ad05913a095033e$var$Ce && $2ad05913a095033e$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($2ad05913a095033e$var$Yt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Yt.getDeepestBlockElements = $2ad05913a095033e$var$yn;
var $2ad05913a095033e$var$dr = $2ad05913a095033e$var$Ve;
function $2ad05913a095033e$var$yn(n) {
    return (0, $2ad05913a095033e$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $2ad05913a095033e$var$Io($2ad05913a095033e$var$Io([], e, !0), $2ad05913a095033e$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $2ad05913a095033e$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return e.getDeepestBlockElements;
        }
    });
})($2ad05913a095033e$var$Wt);
var $2ad05913a095033e$var$wn = {}, $2ad05913a095033e$var$Kt = {}, $2ad05913a095033e$var$Ze = {}, $2ad05913a095033e$var$Xt = {};
Object.defineProperty($2ad05913a095033e$var$Xt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Xt.isLineBreakTag = $2ad05913a095033e$var$ur;
function $2ad05913a095033e$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $2ad05913a095033e$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return e.isLineBreakTag;
        }
    });
})($2ad05913a095033e$var$Ze);
var $2ad05913a095033e$var$Ge = {}, $2ad05913a095033e$var$Vt = {};
Object.defineProperty($2ad05913a095033e$var$Vt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Vt.isSingleTag = $2ad05913a095033e$var$hr;
function $2ad05913a095033e$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $2ad05913a095033e$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return e.isSingleTag;
        }
    });
})($2ad05913a095033e$var$Ge);
Object.defineProperty($2ad05913a095033e$var$Kt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Kt.getDeepestNode = $2ad05913a095033e$var$En;
var $2ad05913a095033e$var$pr = $2ad05913a095033e$var$ue, $2ad05913a095033e$var$fr = $2ad05913a095033e$var$Ze, $2ad05913a095033e$var$gr = $2ad05913a095033e$var$Ge;
function $2ad05913a095033e$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $2ad05913a095033e$var$gr.isSingleTag)(i) && !(0, $2ad05913a095033e$var$pr.isNativeInput)(i) && !(0, $2ad05913a095033e$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $2ad05913a095033e$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $2ad05913a095033e$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return e.getDeepestNode;
        }
    });
})($2ad05913a095033e$var$wn);
var $2ad05913a095033e$var$xn = {}, $2ad05913a095033e$var$qt = {}, $2ad05913a095033e$var$Me = $2ad05913a095033e$var$Ce && $2ad05913a095033e$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($2ad05913a095033e$var$qt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$qt.findAllInputs = $2ad05913a095033e$var$yr;
var $2ad05913a095033e$var$mr = $2ad05913a095033e$var$Ve, $2ad05913a095033e$var$br = $2ad05913a095033e$var$Wt, $2ad05913a095033e$var$vr = $2ad05913a095033e$var$It, $2ad05913a095033e$var$kr = $2ad05913a095033e$var$ue;
function $2ad05913a095033e$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $2ad05913a095033e$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $2ad05913a095033e$var$kr.isNativeInput)(t1) || (0, $2ad05913a095033e$var$mr.containsOnlyInlineElements)(t1) ? $2ad05913a095033e$var$Me($2ad05913a095033e$var$Me([], e, !0), [
            t1
        ], !1) : $2ad05913a095033e$var$Me($2ad05913a095033e$var$Me([], e, !0), (0, $2ad05913a095033e$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $2ad05913a095033e$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return e.findAllInputs;
        }
    });
})($2ad05913a095033e$var$xn);
var $2ad05913a095033e$var$Bn = {}, $2ad05913a095033e$var$Zt = {};
Object.defineProperty($2ad05913a095033e$var$Zt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Zt.isCollapsedWhitespaces = $2ad05913a095033e$var$wr;
function $2ad05913a095033e$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $2ad05913a095033e$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return e.isCollapsedWhitespaces;
        }
    });
})($2ad05913a095033e$var$Bn);
var $2ad05913a095033e$var$Gt = {}, $2ad05913a095033e$var$Qt = {};
Object.defineProperty($2ad05913a095033e$var$Qt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Qt.isElement = $2ad05913a095033e$var$xr;
var $2ad05913a095033e$var$Er = $2ad05913a095033e$var$Ht;
function $2ad05913a095033e$var$xr(n) {
    return (0, $2ad05913a095033e$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $2ad05913a095033e$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return e.isElement;
        }
    });
})($2ad05913a095033e$var$Gt);
var $2ad05913a095033e$var$Cn = {}, $2ad05913a095033e$var$Jt = {}, $2ad05913a095033e$var$eo = {}, $2ad05913a095033e$var$to = {};
Object.defineProperty($2ad05913a095033e$var$to, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$to.isLeaf = $2ad05913a095033e$var$Br;
function $2ad05913a095033e$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $2ad05913a095033e$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return e.isLeaf;
        }
    });
})($2ad05913a095033e$var$eo);
var $2ad05913a095033e$var$oo = {}, $2ad05913a095033e$var$no = {};
Object.defineProperty($2ad05913a095033e$var$no, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$no.isNodeEmpty = $2ad05913a095033e$var$Or;
var $2ad05913a095033e$var$Cr = $2ad05913a095033e$var$Ze, $2ad05913a095033e$var$Tr = $2ad05913a095033e$var$Gt, $2ad05913a095033e$var$Sr = $2ad05913a095033e$var$ue, $2ad05913a095033e$var$Ir = $2ad05913a095033e$var$Ge;
function $2ad05913a095033e$var$Or(n, e) {
    var t1 = "";
    return (0, $2ad05913a095033e$var$Ir.isSingleTag)(n) && !(0, $2ad05913a095033e$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $2ad05913a095033e$var$Tr.isElement)(n) && (0, $2ad05913a095033e$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $2ad05913a095033e$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return e.isNodeEmpty;
        }
    });
})($2ad05913a095033e$var$oo);
Object.defineProperty($2ad05913a095033e$var$Jt, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Jt.isEmpty = $2ad05913a095033e$var$Ar;
var $2ad05913a095033e$var$_r = $2ad05913a095033e$var$eo, $2ad05913a095033e$var$Mr = $2ad05913a095033e$var$oo;
function $2ad05913a095033e$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $2ad05913a095033e$var$_r.isLeaf)(n) && !(0, $2ad05913a095033e$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $2ad05913a095033e$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return e.isEmpty;
        }
    });
})($2ad05913a095033e$var$Cn);
var $2ad05913a095033e$var$Tn = {}, $2ad05913a095033e$var$io = {};
Object.defineProperty($2ad05913a095033e$var$io, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$io.isFragment = $2ad05913a095033e$var$Pr;
var $2ad05913a095033e$var$Lr = $2ad05913a095033e$var$Ht;
function $2ad05913a095033e$var$Pr(n) {
    return (0, $2ad05913a095033e$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $2ad05913a095033e$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return e.isFragment;
        }
    });
})($2ad05913a095033e$var$Tn);
var $2ad05913a095033e$var$Sn = {}, $2ad05913a095033e$var$so = {};
Object.defineProperty($2ad05913a095033e$var$so, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$so.isHTMLString = $2ad05913a095033e$var$Rr;
var $2ad05913a095033e$var$Nr = $2ad05913a095033e$var$qe;
function $2ad05913a095033e$var$Rr(n) {
    var e = (0, $2ad05913a095033e$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $2ad05913a095033e$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return e.isHTMLString;
        }
    });
})($2ad05913a095033e$var$Sn);
var $2ad05913a095033e$var$In = {}, $2ad05913a095033e$var$ro = {};
Object.defineProperty($2ad05913a095033e$var$ro, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$ro.offset = $2ad05913a095033e$var$Dr;
function $2ad05913a095033e$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $2ad05913a095033e$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return e.offset;
        }
    });
})($2ad05913a095033e$var$In);
var $2ad05913a095033e$var$On = {}, $2ad05913a095033e$var$ao = {};
Object.defineProperty($2ad05913a095033e$var$ao, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$ao.prepend = $2ad05913a095033e$var$Fr;
function $2ad05913a095033e$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $2ad05913a095033e$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return e.prepend;
        }
    });
})($2ad05913a095033e$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $2ad05913a095033e$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
    var t1 = $2ad05913a095033e$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t1.isNativeInput;
        }
    });
    var o = $2ad05913a095033e$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return o.append;
        }
    });
    var i = $2ad05913a095033e$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var s = $2ad05913a095033e$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return s.calculateBaseline;
        }
    });
    var r = $2ad05913a095033e$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return r.canSetCaret;
        }
    });
    var a = $2ad05913a095033e$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $2ad05913a095033e$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return l.fragmentToString;
        }
    });
    var c = $2ad05913a095033e$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return c.getContentLength;
        }
    });
    var d = $2ad05913a095033e$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $2ad05913a095033e$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return h.getDeepestNode;
        }
    });
    var p = $2ad05913a095033e$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return p.findAllInputs;
        }
    });
    var g = $2ad05913a095033e$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $2ad05913a095033e$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return f.isContentEditable;
        }
    });
    var v = $2ad05913a095033e$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return v.isElement;
        }
    });
    var O = $2ad05913a095033e$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return O.isEmpty;
        }
    });
    var T = $2ad05913a095033e$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return T.isFragment;
        }
    });
    var M = $2ad05913a095033e$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return M.isHTMLString;
        }
    });
    var q = $2ad05913a095033e$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return q.isLeaf;
        }
    });
    var F = $2ad05913a095033e$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return F.isNodeEmpty;
        }
    });
    var H = $2ad05913a095033e$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return H.isLineBreakTag;
        }
    });
    var Q = $2ad05913a095033e$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Q.isSingleTag;
        }
    });
    var ie = $2ad05913a095033e$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return ie.make;
        }
    });
    var k = $2ad05913a095033e$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return k.offset;
        }
    });
    var m = $2ad05913a095033e$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return m.prepend;
        }
    });
})($2ad05913a095033e$var$de);
var $2ad05913a095033e$var$Qe = {};
Object.defineProperty($2ad05913a095033e$var$Qe, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Qe.getContenteditableSlice = $2ad05913a095033e$var$Hr;
var $2ad05913a095033e$var$jr = $2ad05913a095033e$var$de;
function $2ad05913a095033e$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $2ad05913a095033e$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($2ad05913a095033e$var$Xe, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Xe.checkContenteditableSliceForEmptiness = $2ad05913a095033e$var$Ur;
var $2ad05913a095033e$var$$r = $2ad05913a095033e$var$de, $2ad05913a095033e$var$zr = $2ad05913a095033e$var$Qe;
function $2ad05913a095033e$var$Ur(n, e, t1, o) {
    var i = (0, $2ad05913a095033e$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $2ad05913a095033e$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $2ad05913a095033e$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($2ad05913a095033e$var$St);
var $2ad05913a095033e$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $2ad05913a095033e$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return e.getContenteditableSlice;
        }
    });
})($2ad05913a095033e$var$_n);
var $2ad05913a095033e$var$Mn = {}, $2ad05913a095033e$var$lo = {};
Object.defineProperty($2ad05913a095033e$var$lo, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$lo.focus = $2ad05913a095033e$var$Yr;
var $2ad05913a095033e$var$Wr = $2ad05913a095033e$var$de;
function $2ad05913a095033e$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $2ad05913a095033e$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $2ad05913a095033e$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return e.focus;
        }
    });
})($2ad05913a095033e$var$Mn);
var $2ad05913a095033e$var$co = {}, $2ad05913a095033e$var$Je = {};
Object.defineProperty($2ad05913a095033e$var$Je, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$Je.getCaretNodeAndOffset = $2ad05913a095033e$var$Kr;
function $2ad05913a095033e$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $2ad05913a095033e$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return e.getCaretNodeAndOffset;
        }
    });
})($2ad05913a095033e$var$co);
var $2ad05913a095033e$var$An = {}, $2ad05913a095033e$var$et = {};
Object.defineProperty($2ad05913a095033e$var$et, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$et.getRange = $2ad05913a095033e$var$Xr;
function $2ad05913a095033e$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $2ad05913a095033e$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return e.getRange;
        }
    });
})($2ad05913a095033e$var$An);
var $2ad05913a095033e$var$Ln = {}, $2ad05913a095033e$var$uo = {};
Object.defineProperty($2ad05913a095033e$var$uo, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$uo.isCaretAtEndOfInput = $2ad05913a095033e$var$Zr;
var $2ad05913a095033e$var$Oo = $2ad05913a095033e$var$de, $2ad05913a095033e$var$Vr = $2ad05913a095033e$var$co, $2ad05913a095033e$var$qr = $2ad05913a095033e$var$St;
function $2ad05913a095033e$var$Zr(n) {
    var e = (0, $2ad05913a095033e$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $2ad05913a095033e$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $2ad05913a095033e$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $2ad05913a095033e$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $2ad05913a095033e$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtEndOfInput;
        }
    });
})($2ad05913a095033e$var$Ln);
var $2ad05913a095033e$var$Pn = {}, $2ad05913a095033e$var$ho = {};
Object.defineProperty($2ad05913a095033e$var$ho, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$ho.isCaretAtStartOfInput = $2ad05913a095033e$var$Jr;
var $2ad05913a095033e$var$Ae = $2ad05913a095033e$var$de, $2ad05913a095033e$var$Gr = $2ad05913a095033e$var$Je, $2ad05913a095033e$var$Qr = $2ad05913a095033e$var$Xe;
function $2ad05913a095033e$var$Jr(n) {
    var e = (0, $2ad05913a095033e$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $2ad05913a095033e$var$Ae.isEmpty)(n)) return !0;
    if ((0, $2ad05913a095033e$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $2ad05913a095033e$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $2ad05913a095033e$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $2ad05913a095033e$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $2ad05913a095033e$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtStartOfInput;
        }
    });
})($2ad05913a095033e$var$Pn);
var $2ad05913a095033e$var$Nn = {}, $2ad05913a095033e$var$po = {};
Object.defineProperty($2ad05913a095033e$var$po, "__esModule", {
    value: !0
});
$2ad05913a095033e$var$po.save = $2ad05913a095033e$var$oa;
var $2ad05913a095033e$var$ea = $2ad05913a095033e$var$de, $2ad05913a095033e$var$ta = $2ad05913a095033e$var$et;
function $2ad05913a095033e$var$oa() {
    var n = (0, $2ad05913a095033e$var$ta.getRange)(), e = (0, $2ad05913a095033e$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $2ad05913a095033e$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return e.save;
        }
    });
})($2ad05913a095033e$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $2ad05913a095033e$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $2ad05913a095033e$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $2ad05913a095033e$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return o.focus;
        }
    });
    var i = $2ad05913a095033e$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $2ad05913a095033e$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return s.getRange;
        }
    });
    var r = $2ad05913a095033e$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $2ad05913a095033e$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $2ad05913a095033e$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return l.save;
        }
    });
})($2ad05913a095033e$var$hn);
class $2ad05913a095033e$var$na extends $2ad05913a095033e$var$E {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $2ad05913a095033e$var$y.BACKSPACE:
                this.backspace(e);
                break;
            case $2ad05913a095033e$var$y.DELETE:
                this.delete(e);
                break;
            case $2ad05913a095033e$var$y.ENTER:
                this.enter(e);
                break;
            case $2ad05913a095033e$var$y.DOWN:
            case $2ad05913a095033e$var$y.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $2ad05913a095033e$var$y.UP:
            case $2ad05913a095033e$var$y.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $2ad05913a095033e$var$y.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $2ad05913a095033e$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$2ad05913a095033e$var$pt) return;
        let s = i;
        i.currentInput !== void 0 && $2ad05913a095033e$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $2ad05913a095033e$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$2ad05913a095033e$var$b.isCollapsed || !i.currentInput || !$2ad05913a095033e$var$Ne(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const l = t1.currentBlock;
            o.setToBlock(l, o.positions.END);
            return;
        }
        $2ad05913a095033e$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$2ad05913a095033e$var$b.isCollapsed || !$2ad05913a095033e$var$Re(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $2ad05913a095033e$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Toolbar: i } = this.Editor;
        e.lastInput !== void 0 && ($2ad05913a095033e$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(()=>{
            i.close();
        }));
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $2ad05913a095033e$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $2ad05913a095033e$var$y.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $2ad05913a095033e$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $2ad05913a095033e$var$y.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $2ad05913a095033e$var$y.DOWN || e.keyCode === $2ad05913a095033e$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $2ad05913a095033e$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($2ad05913a095033e$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $2ad05913a095033e$var$y.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $2ad05913a095033e$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $2ad05913a095033e$var$y.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $2ad05913a095033e$var$y.UP || e.keyCode === $2ad05913a095033e$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $2ad05913a095033e$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $2ad05913a095033e$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $2ad05913a095033e$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $2ad05913a095033e$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $2ad05913a095033e$var$y.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $2ad05913a095033e$var$ct {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $2ad05913a095033e$var$No(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $2ad05913a095033e$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const a = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($2ad05913a095033e$var$ee.MOVED, a);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($2ad05913a095033e$var$ee.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($2ad05913a095033e$var$ee.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($2ad05913a095033e$var$ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($2ad05913a095033e$var$ee.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($2ad05913a095033e$var$ee.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $2ad05913a095033e$var$_o = "block-removed", $2ad05913a095033e$var$Mo = "block-added", $2ad05913a095033e$var$ia = "block-moved", $2ad05913a095033e$var$Ao = "block-changed";
class $2ad05913a095033e$var$sa {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $2ad05913a095033e$var$ra extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $2ad05913a095033e$var$ct(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $2ad05913a095033e$var$ct.set,
            get: $2ad05913a095033e$var$ct.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $2ad05913a095033e$var$R({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(a);
        }, {
            timeout: 2e3
        }), a;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: a = {} } = {}) {
        let l = i;
        l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: a
        });
        return r && this.blockDidMutated($2ad05913a095033e$var$_o, this.getBlockByIndex(l), {
            index: l
        }), this._blocks.insert(l, c, r), this.blockDidMutated($2ad05913a095033e$var$Mo, c, {
            index: l
        }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($2ad05913a095033e$var$Ao, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($2ad05913a095033e$var$ee.ON_PASTE, t1);
            });
        } catch (s) {
            $2ad05913a095033e$var$S(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($2ad05913a095033e$var$Mo, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($2ad05913a095033e$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $2ad05913a095033e$var$yt([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $2ad05913a095033e$var$He(t1, "export") && $2ad05913a095033e$var$He(e, "import")) {
            const i = await t1.exportDataAsString(), s = $2ad05913a095033e$var$Z(i, e.tool.sanitizeConfig);
            o = $2ad05913a095033e$var$Bo(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            this._blocks.remove(i), e.destroy(), this.blockDidMutated($2ad05913a095033e$var$_o, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $2ad05913a095033e$var$u.make("div");
        t1.appendChild(e);
        const o = {
            text: $2ad05913a095033e$var$u.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $2ad05913a095033e$var$u.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$2ad05913a095033e$var$R.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $2ad05913a095033e$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$2ad05913a095033e$var$R.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $2ad05913a095033e$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$2ad05913a095033e$var$R.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $2ad05913a095033e$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $2ad05913a095033e$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($2ad05913a095033e$var$ia, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), a = $2ad05913a095033e$var$Z(r, s.sanitizeConfig);
        let l = $2ad05913a095033e$var$Bo(a, s.conversionConfig, s.settings);
        return o && (l = Object.assign(l, o)), this.replace(e, s.name, l);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $2ad05913a095033e$var$sa();
        [
            ...this.blocks
        ].forEach((i)=>{
            t1.add(async ()=>{
                await this.removeBlock(i, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($2ad05913a095033e$var$Ao, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $2ad05913a095033e$var$J(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($2ad05913a095033e$var$$o, {
            event: i
        }), t1;
    }
}
class $2ad05913a095033e$var$aa extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $2ad05913a095033e$var$b(), $2ad05913a095033e$var$ge.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $2ad05913a095033e$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, a = r && $2ad05913a095033e$var$Po(e.keyCode);
        if (this.anyBlockSelected && r && a && !$2ad05913a095033e$var$b.isSelectionExists) {
            const l = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $2ad05913a095033e$var$Fe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $2ad05913a095033e$var$u.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $2ad05913a095033e$var$Z(s.holder.innerHTML, this.sanitizerConfig), a = $2ad05913a095033e$var$u.make("p");
            a.innerHTML = r, t1.appendChild(a);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $2ad05913a095033e$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $2ad05913a095033e$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $2ad05913a095033e$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $2ad05913a095033e$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $2ad05913a095033e$var$Ye extends $2ad05913a095033e$var$E {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        let a, l = o;
        if (t1 === this.positions.START) a = $2ad05913a095033e$var$u.getDeepestNode(r, !1), l = 0;
        else if (t1 === this.positions.END) a = $2ad05913a095033e$var$u.getDeepestNode(r, !0), l = $2ad05913a095033e$var$u.getContentLength(a);
        else {
            const { node: d, offset: h } = $2ad05913a095033e$var$u.getNodeByOffset(r, o);
            d ? (a = d, l = h) : (a = $2ad05913a095033e$var$u.getDeepestNode(r, !1), l = 0);
        }
        this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $2ad05913a095033e$var$u.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $2ad05913a095033e$var$u.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $2ad05913a095033e$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $2ad05913a095033e$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($2ad05913a095033e$var$u.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                    return s.textContent = a, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, a = r !== void 0 ? $2ad05913a095033e$var$Re(r) : void 0;
        let l = i;
        const c = e || a || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (l === null) {
            if (o.tool.isDefault || !c) return !1;
            l = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $2ad05913a095033e$var$Ne(s) : void 0, a = e || r || !t1.focusable;
        return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($2ad05913a095033e$var$Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$2ad05913a095033e$var$Ye.CSS.shadowCaret}`);
        if (!t1) return;
        new $2ad05913a095033e$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $2ad05913a095033e$var$b.get(), s = $2ad05913a095033e$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
}
class $2ad05913a095033e$var$la extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $2ad05913a095033e$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $2ad05913a095033e$var$qn.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $2ad05913a095033e$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $2ad05913a095033e$var$y.DOWN:
            case $2ad05913a095033e$var$y.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $2ad05913a095033e$var$y.UP:
            case $2ad05913a095033e$var$y.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $2ad05913a095033e$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
        for(let l = Math.min(s, r); l <= Math.max(s, r); l++){
            const c = o.blocks[l];
            c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
        }
    }
}
class $2ad05913a095033e$var$ca extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $2ad05913a095033e$var$b.isAtEditor && !$2ad05913a095033e$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $2ad05913a095033e$var$b.isAtEditor && !$2ad05913a095033e$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $2ad05913a095033e$var$da = 180, $2ad05913a095033e$var$ua = 400;
class $2ad05913a095033e$var$ha extends $2ad05913a095033e$var$E {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $2ad05913a095033e$var$ua, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($2ad05913a095033e$var$$o, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($2ad05913a095033e$var$zo, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($2ad05913a095033e$var$Uo, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$2ad05913a095033e$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($2ad05913a095033e$var$ft, {
            mutations: e
        });
    }
}
const $2ad05913a095033e$var$Rn = class Dn extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$2ad05913a095033e$var$A(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $2ad05913a095033e$var$S(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$2ad05913a095033e$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
        let l = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $2ad05913a095033e$var$Z(l, d);
        !h.trim() || h.trim() === a || !$2ad05913a095033e$var$u.isHTMLString(h) ? await this.processText(a) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (l, c)=>this.insertBlock(l, c === 0 && a)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $2ad05913a095033e$var$te(e) ? [
            e
        ] : $2ad05913a095033e$var$D(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $2ad05913a095033e$var$S(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const a = $2ad05913a095033e$var$D(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: a
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($2ad05913a095033e$var$S(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($2ad05913a095033e$var$S(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$2ad05913a095033e$var$ei(s) ? !0 : ($2ad05913a095033e$var$S(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $2ad05913a095033e$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $2ad05913a095033e$var$S(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $2ad05913a095033e$var$u.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, a)=>{
            t1.paste(r.type, r.event, a === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $2ad05913a095033e$var$Jn(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: a, extensions: l }])=>{
            const [c, d] = e.type.split("/"), h = l.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = a.find((g)=>{
                const [f, v] = g.split("/");
                return f === c && (v === d || v === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $2ad05913a095033e$var$u.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, a = t1.defaultTool, l = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $2ad05913a095033e$var$u.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, l = !0, this.toolsTags[r.tagName] && (a = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = a.pasteConfig || {
                tags: []
            }, d = c.reduce((g, f)=>(this.collectTagNames(f).forEach((O)=>{
                    const T = $2ad05913a095033e$var$D(f) ? f[O] : null;
                    g[O.toLowerCase()] = T || {};
                }), g), {}), h = Object.assign({}, d, a.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $2ad05913a095033e$var$Z(r.outerHTML, h);
                r = $2ad05913a095033e$var$u.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $2ad05913a095033e$var$Z(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: l,
                tool: a.name,
                event: p
            };
        }).filter((s)=>{
            const r = $2ad05913a095033e$var$u.isEmpty(s.content), a = $2ad05913a095033e$var$u.isSingleTag(s.content);
            return !r || a;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $2ad05913a095033e$var$u.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$2ad05913a095033e$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $2ad05913a095033e$var$Z(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $2ad05913a095033e$var$yt(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: a }, l)=>{
            let c = !1;
            l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const d = t1.insert({
                tool: r,
                data: a,
                replace: c
            });
            o.setToBlock(d, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $2ad05913a095033e$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !a.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$2ad05913a095033e$var$u.blockElements.includes(p.toLowerCase()));
        if (!c && !l && !d) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (l && !d || c && !h && !d) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($2ad05913a095033e$var$u.isEmpty(r) && !$2ad05913a095033e$var$u.isSingleTag(r)) return s;
            const a = s[s.length - 1];
            let l = new DocumentFragment();
            switch(a && $2ad05913a095033e$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, l), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return l.appendChild(r), [
                        ...s,
                        l
                    ];
                default:
                    return [
                        ...s,
                        l
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$2ad05913a095033e$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $2ad05913a095033e$var$pa = $2ad05913a095033e$var$Rn;
class $2ad05913a095033e$var$fa extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $2ad05913a095033e$var$Ho(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $2ad05913a095033e$var$Be extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$2ad05913a095033e$var$R.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some((l)=>!!o.closest(l));
        !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $2ad05913a095033e$var$dt((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $2ad05913a095033e$var$dt((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($2ad05913a095033e$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$Be.CSS.overlay, {}), i = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$Be.CSS.overlayContainer, {}), s = $2ad05913a095033e$var$u.make("div", $2ad05913a095033e$var$Be.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $2ad05913a095033e$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $2ad05913a095033e$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
        return {
            index: r,
            leftPos: c,
            rightPos: d
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let l = r;
        o > 1 && (l = a ? i : s);
        const c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let v = this.stackOfSelected[o - 1] + 1 || e;
            for(v; v <= e; v++)this.addBlockInSelection(v);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let v = this.stackOfSelected[o - 1] - 1; v >= e; v--)this.addBlockInSelection(v);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $2ad05913a095033e$var$ga extends $2ad05913a095033e$var$E {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: a, tunes: l, id: c })=>{
                    o.available.has(r) === !1 && ($2ad05913a095033e$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), a = this.composeStubDataForTool(r, a, c), r = o.stubTool);
                    let d;
                    try {
                        d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    } catch (h) {
                        $2ad05913a095033e$var$S(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: a,
                            error: h
                        }), a = this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    }
                    return d;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $2ad05913a095033e$var$ma extends $2ad05913a095033e$var$E {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((a)=>{
                i.push(this.getSavedData(a));
            });
            const s = await Promise.all(i), r = await $2ad05913a095033e$var$yt(s, (a)=>t1.blockTools.get(a).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $2ad05913a095033e$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: a })=>{
            if (!a) {
                $2ad05913a095033e$var$S(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const l = {
                id: o,
                type: i,
                data: s,
                ...!$2ad05913a095033e$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(l);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.31.7"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $2ad05913a095033e$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $2ad05913a095033e$var$va(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $2ad05913a095033e$var$fo {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $2ad05913a095033e$var$fo.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $2ad05913a095033e$var$va(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $2ad05913a095033e$var$ba,
            title: "Text"
        };
    }
}
class $2ad05913a095033e$var$go {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $2ad05913a095033e$var$Ki,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$2ad05913a095033e$var$go.isInline = !0;
$2ad05913a095033e$var$go.title = "Bold";
class $2ad05913a095033e$var$mo {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $2ad05913a095033e$var$Ji, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$2ad05913a095033e$var$mo.isInline = !0;
$2ad05913a095033e$var$mo.title = "Italic";
class $2ad05913a095033e$var$bo {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $2ad05913a095033e$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $2ad05913a095033e$var$Co, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.inputOpened ? (this.closeActions(!1), this.checkState()) : (this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close());
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $2ad05913a095033e$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.defaultValue = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $2ad05913a095033e$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $2ad05913a095033e$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $2ad05913a095033e$var$S("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$2ad05913a095033e$var$bo.isInline = !0;
$2ad05913a095033e$var$bo.title = "Link";
class $2ad05913a095033e$var$Fn {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $2ad05913a095033e$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $2ad05913a095033e$var$Yo(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, d)=>{
            var h;
            return (h = d.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $2ad05913a095033e$var$z.t($2ad05913a095033e$var$K.toolNames, p.title),
                    name: d.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, d.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), a = r !== void 0 ? r.icon : $2ad05913a095033e$var$Go, l = !$2ad05913a095033e$var$be();
        return {
            icon: a,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: l,
                items: s,
                onOpen: ()=>{
                    l && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    l && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$2ad05913a095033e$var$Fn.isInline = !0;
class $2ad05913a095033e$var$jn {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $2ad05913a095033e$var$u.make("div", this.CSS.wrapper), t1 = $2ad05913a095033e$var$is, o = $2ad05913a095033e$var$u.make("div", this.CSS.info), i = $2ad05913a095033e$var$u.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $2ad05913a095033e$var$u.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$2ad05913a095033e$var$jn.isReadOnlySupported = !0;
class $2ad05913a095033e$var$ka extends $2ad05913a095033e$var$Tt {
    constructor(){
        super(...arguments), this.type = $2ad05913a095033e$var$ae.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$2ad05913a095033e$var$We.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ get isReadOnlySupported() {
        return this.constructable[$2ad05913a095033e$var$We.IsReadOnlySupported] ?? !1;
    }
}
class $2ad05913a095033e$var$ya extends $2ad05913a095033e$var$Tt {
    constructor(){
        super(...arguments), this.type = $2ad05913a095033e$var$ae.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $2ad05913a095033e$var$j extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $2ad05913a095033e$var$j(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $2ad05913a095033e$var$j(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $2ad05913a095033e$var$j(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $2ad05913a095033e$var$j(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $2ad05913a095033e$var$j(e);
    }
}
var $2ad05913a095033e$var$wa = Object.defineProperty, $2ad05913a095033e$var$Ea = Object.getOwnPropertyDescriptor, $2ad05913a095033e$var$Hn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $2ad05913a095033e$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $2ad05913a095033e$var$wa(e, t1, i), i;
};
class $2ad05913a095033e$var$vo extends $2ad05913a095033e$var$Tt {
    constructor(){
        super(...arguments), this.type = $2ad05913a095033e$var$ae.Block, this.inlineTools = new $2ad05913a095033e$var$j(), this.tunes = new $2ad05913a095033e$var$j();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$2ad05913a095033e$var$pe.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$2ad05913a095033e$var$pe.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$2ad05913a095033e$var$pe.Toolbox], t1 = this.config[$2ad05913a095033e$var$Pe.Toolbox];
        if (!$2ad05913a095033e$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$2ad05913a095033e$var$pe.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$2ad05913a095033e$var$Pe.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$2ad05913a095033e$var$Pe.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$2ad05913a095033e$var$pe.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($2ad05913a095033e$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $2ad05913a095033e$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$2ad05913a095033e$var$Hn([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$vo.prototype, "sanitizeConfig", 1);
$2ad05913a095033e$var$Hn([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$vo.prototype, "baseSanitizeConfig", 1);
class $2ad05913a095033e$var$xa {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$2ad05913a095033e$var$mt.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$2ad05913a095033e$var$We.IsInline]:
                return $2ad05913a095033e$var$ka;
            case e[$2ad05913a095033e$var$mt.IsTune]:
                return $2ad05913a095033e$var$ya;
            default:
                return $2ad05913a095033e$var$vo;
        }
    }
}
class $2ad05913a095033e$var$$n {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $2ad05913a095033e$var$Xi,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$2ad05913a095033e$var$$n.isTune = !0;
class $2ad05913a095033e$var$zn {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $2ad05913a095033e$var$Gi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$2ad05913a095033e$var$zn.isTune = !0;
class $2ad05913a095033e$var$Un {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $2ad05913a095033e$var$Zi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
        let l;
        a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$2ad05913a095033e$var$Un.isTune = !0;
var $2ad05913a095033e$var$Ba = Object.defineProperty, $2ad05913a095033e$var$Ca = Object.getOwnPropertyDescriptor, $2ad05913a095033e$var$Ta = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $2ad05913a095033e$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $2ad05913a095033e$var$Ba(e, t1, i), i;
};
class $2ad05913a095033e$var$Wn extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $2ad05913a095033e$var$j(), this.toolsUnavailable = new $2ad05913a095033e$var$j();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $2ad05913a095033e$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $2ad05913a095033e$var$xa(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $2ad05913a095033e$var$Qn(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $2ad05913a095033e$var$A(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $2ad05913a095033e$var$Fn,
                isInternal: !0
            },
            link: {
                class: $2ad05913a095033e$var$bo,
                isInternal: !0
            },
            bold: {
                class: $2ad05913a095033e$var$go,
                isInternal: !0
            },
            italic: {
                class: $2ad05913a095033e$var$mo,
                isInternal: !0
            },
            paragraph: {
                class: $2ad05913a095033e$var$fo,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $2ad05913a095033e$var$jn,
                isInternal: !0
            },
            moveUp: {
                class: $2ad05913a095033e$var$Un,
                isInternal: !0
            },
            delete: {
                class: $2ad05913a095033e$var$zn,
                isInternal: !0
            },
            moveDown: {
                class: $2ad05913a095033e$var$$n,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $2ad05913a095033e$var$S(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $2ad05913a095033e$var$A(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $2ad05913a095033e$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $2ad05913a095033e$var$j(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $2ad05913a095033e$var$j(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $2ad05913a095033e$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $2ad05913a095033e$var$j(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $2ad05913a095033e$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$2ad05913a095033e$var$A(t1) && !$2ad05913a095033e$var$A(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$2ad05913a095033e$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$2ad05913a095033e$var$Ta([
    $2ad05913a095033e$var$me
], $2ad05913a095033e$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $2ad05913a095033e$var$Sa = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $2ad05913a095033e$var$Ia extends $2ad05913a095033e$var$E {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = null, this.resizeDebouncer = $2ad05913a095033e$var$Eo(()=>{
            this.windowResize();
        }, 200), this.selectionChangeDebounced = $2ad05913a095033e$var$Eo(()=>{
            this.selectionChanged();
        }, $2ad05913a095033e$var$da), this.documentTouchedListener = (e)=>{
            this.documentTouched(e);
        };
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache !== null) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$2ad05913a095033e$var$R.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(()=>{
            this.bindReadOnlySensitiveListeners();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $2ad05913a095033e$var$ce).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $2ad05913a095033e$var$Ro;
        e !== this.isMobile && this.eventsDispatcher.emit($2ad05913a095033e$var$Te, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $2ad05913a095033e$var$u.getHolder(this.config.holder), this.nodes.wrapper = $2ad05913a095033e$var$u.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $2ad05913a095033e$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($2ad05913a095033e$var$u.get(e)) return;
        const t1 = $2ad05913a095033e$var$u.make("style", null, {
            id: e,
            textContent: $2ad05913a095033e$var$Sa.toString()
        });
        this.config.style && !$2ad05913a095033e$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $2ad05913a095033e$var$u.prepend(document.head, t1);
    }
    /**
   * Adds listeners that should work both in read-only and read-write modes
   */ bindReadOnlyInsensitiveListeners() {
        this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        });
    }
    /**
   * Removes listeners that should work both in read-only and read-write modes
   */ unbindReadOnlyInsensitiveListeners() {
        this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
   * Adds listeners that should work only in read-only mode
   */ bindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (e)=>{
            this.redactorClicked(e);
        }, !1), this.readOnlyMutableListeners.on(document, "keydown", (e)=>{
            this.documentKeydown(e);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (e)=>{
            this.documentClicked(e);
        }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $2ad05913a095033e$var$dt((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($2ad05913a095033e$var$ln, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events that should work only in read-only mode
   */ unbindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $2ad05913a095033e$var$y.ENTER:
                this.enterPressed(e);
                break;
            case $2ad05913a095033e$var$y.BACKSPACE:
            case $2ad05913a095033e$var$y.DELETE:
                this.backspacePressed(e);
                break;
            case $2ad05913a095033e$var$y.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$2ad05913a095033e$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$2ad05913a095033e$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var a, l;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $2ad05913a095033e$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$2ad05913a095033e$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey, i = $2ad05913a095033e$var$u.getClosestAnchor(t1);
        if (i && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const s = i.getAttribute("href"), r = $2ad05913a095033e$var$oi(s);
            $2ad05913a095033e$var$ii(r);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $2ad05913a095033e$var$u.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: a, Caret: l, Toolbar: c } = this.Editor;
            (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $2ad05913a095033e$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $2ad05913a095033e$var$b.get().removeAllRanges(), !o) {
            $2ad05913a095033e$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        const i = o.closest(`.${$2ad05913a095033e$var$R.CSS.content}`);
        (i === null || i.closest(`.${$2ad05913a095033e$var$b.CSS.editorWrapper}`) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $2ad05913a095033e$var$Do(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $2ad05913a095033e$var$Oa = {
    // API Modules
    BlocksAPI: $2ad05913a095033e$var$gi,
    CaretAPI: $2ad05913a095033e$var$bi,
    EventsAPI: $2ad05913a095033e$var$vi,
    I18nAPI: $2ad05913a095033e$var$kt,
    API: $2ad05913a095033e$var$ki,
    InlineToolbarAPI: $2ad05913a095033e$var$yi,
    ListenersAPI: $2ad05913a095033e$var$wi,
    NotifierAPI: $2ad05913a095033e$var$Ci,
    ReadOnlyAPI: $2ad05913a095033e$var$Ti,
    SanitizerAPI: $2ad05913a095033e$var$Li,
    SaverAPI: $2ad05913a095033e$var$Pi,
    SelectionAPI: $2ad05913a095033e$var$Ni,
    ToolsAPI: $2ad05913a095033e$var$Ri,
    StylesAPI: $2ad05913a095033e$var$Di,
    ToolbarAPI: $2ad05913a095033e$var$Fi,
    TooltipAPI: $2ad05913a095033e$var$Ui,
    UiAPI: $2ad05913a095033e$var$Wi,
    // Toolbar Modules
    BlockSettings: $2ad05913a095033e$var$ms,
    Toolbar: $2ad05913a095033e$var$Bs,
    InlineToolbar: $2ad05913a095033e$var$Cs,
    // Modules
    BlockEvents: $2ad05913a095033e$var$na,
    BlockManager: $2ad05913a095033e$var$ra,
    BlockSelection: $2ad05913a095033e$var$aa,
    Caret: $2ad05913a095033e$var$Ye,
    CrossBlockSelection: $2ad05913a095033e$var$la,
    DragNDrop: $2ad05913a095033e$var$ca,
    ModificationsObserver: $2ad05913a095033e$var$ha,
    Paste: $2ad05913a095033e$var$pa,
    ReadOnly: $2ad05913a095033e$var$fa,
    RectangleSelection: $2ad05913a095033e$var$Be,
    Renderer: $2ad05913a095033e$var$ga,
    Saver: $2ad05913a095033e$var$ma,
    Tools: $2ad05913a095033e$var$Wn,
    UI: $2ad05913a095033e$var$Ia
};
class $2ad05913a095033e$var$_a {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $2ad05913a095033e$var$Oe();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: a } = this.moduleInstances;
            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $2ad05913a095033e$var$S(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $2ad05913a095033e$var$D(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $2ad05913a095033e$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $2ad05913a095033e$var$Lo.VERBOSE), $2ad05913a095033e$var$Zn(this.config.logLevel), $2ad05913a095033e$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($2ad05913a095033e$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $2ad05913a095033e$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($2ad05913a095033e$var$te(t1) && !$2ad05913a095033e$var$u.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $2ad05913a095033e$var$D(t1) && !$2ad05913a095033e$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $2ad05913a095033e$var$Ho) throw new Error(i.message);
                    $2ad05913a095033e$var$S(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($2ad05913a095033e$var$Oa).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $2ad05913a095033e$var$S("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $2ad05913a095033e$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.31.7";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $2ad05913a095033e$var$D(e) && $2ad05913a095033e$var$A(e.onReady) && (t1 = e.onReady);
        const o = new $2ad05913a095033e$var$_a(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $2ad05913a095033e$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $2ad05913a095033e$var$zi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([a, l])=>{
                this[l] = e.moduleInstances.API.methods[s][a];
            });
        });
    }
}

});

parcelRegister("62bxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $892a05942d3d6c0a$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
const $892a05942d3d6c0a$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $892a05942d3d6c0a$var$l(r) {
    const t = document.createElement("div");
    t.innerHTML = r.trim();
    const e = document.createDocumentFragment();
    return e.append(...Array.from(t.childNodes)), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $892a05942d3d6c0a$export$2e2bcd8739ae039 {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: i, readOnly: s }){
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : $892a05942d3d6c0a$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER, this._data = t ?? {}, this._element = null, this._preserveBlank = e.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(t) {
        if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
        const { textContent: e } = this._element;
        e === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const t = document.createElement("DIV");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(t) {
        if (!this._element) return;
        this._data.text += t.text;
        const e = $892a05942d3d6c0a$var$l(t.text);
        this._element.appendChild(e), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(t) {
        return !(t.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(t) {
        return {
            text: t.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = {
            text: t.detail.data.innerHTML
        };
        this._data = e, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $892a05942d3d6c0a$var$a,
            title: "Text"
        };
    }
}

});


parcelRegister("eHX5R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab52eb996048377b$export$2e2bcd8739ae039);

var $5E6i4 = parcelRequire("5E6i4");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ab52eb996048377b$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ab52eb996048377b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ab52eb996048377b$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $ab52eb996048377b$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $ab52eb996048377b$var$ServerEditorCore {
    constructor({ data: data }){
        if (data) this._memoizedData = data;
    }
    get dangerouslyLowLevelInstance() {
        return null;
    }
    clear() {
        return $ab52eb996048377b$var$__awaiter(this, void 0, void 0, function*() {});
    }
    save() {
        return $ab52eb996048377b$var$__awaiter(this, void 0, void 0, function*() {
            return this._memoizedData;
        });
    }
    destroy() {
        return $ab52eb996048377b$var$__awaiter(this, void 0, void 0, function*() {});
    }
    render() {
        return $ab52eb996048377b$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
function $ab52eb996048377b$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useCallback((config)=>new $ab52eb996048377b$var$ServerEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($ab52eb996048377b$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $8dff54558831dec9$export$e4cf37d7f6fb9e0a, (v) => $8dff54558831dec9$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $8dff54558831dec9$export$599f31c3813fae4d, (v) => $8dff54558831dec9$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("i143t", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $d1db7736deae183e$require$Buffer = $cbQCu.Buffer;
"use strict";
/**
 * This module defines nodes used to define types and validations for objects and interfaces.
 */ // tslint:disable:no-shadowed-variable prefer-for-of
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basicTypes = exports.BasicType = exports.TParamList = exports.TParam = exports.param = exports.TFunc = exports.func = exports.TProp = exports.TOptional = exports.opt = exports.TIface = exports.iface = exports.TEnumLiteral = exports.enumlit = exports.TEnumType = exports.enumtype = exports.TIntersection = exports.intersection = exports.TUnion = exports.union = exports.TTuple = exports.tuple = exports.TArray = exports.array = exports.TLiteral = exports.lit = exports.TName = exports.name = exports.TType = void 0;

var $d3AJN = parcelRequire("d3AJN");
/** Node that represents a type. */ var TType = /** @class */ function() {
    function TType() {}
    return TType;
}();
exports.TType = TType;
/** Parses a type spec into a TType node. */ function parseSpec(typeSpec) {
    return typeof typeSpec === "string" ? name(typeSpec) : typeSpec;
}
function getNamedType(suite, name) {
    var ttype = suite[name];
    if (!ttype) throw new Error("Unknown type " + name);
    return ttype;
}
/**
 * Defines a type name, either built-in, or defined in this suite. It can typically be included in
 * the specs as just a plain string.
 */ function name(value) {
    return new TName(value);
}
exports.name = name;
var TName = /** @class */ function(_super) {
    __extends(TName, _super);
    function TName(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this._failMsg = "is not a " + name;
        return _this;
    }
    TName.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var ttype = getNamedType(suite, this.name);
        var checker = ttype.getChecker(suite, strict, allowedProps);
        if (ttype instanceof BasicType || ttype instanceof TName) return checker;
        // For complex types, add an additional "is not a <Type>" message on failure.
        return function(value, ctx) {
            return checker(value, ctx) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TName;
}(TType);
exports.TName = TName;
/**
 * Defines a literal value, e.g. lit('hello') or lit(123).
 */ function lit(value) {
    return new TLiteral(value);
}
exports.lit = lit;
var TLiteral = /** @class */ function(_super) {
    __extends(TLiteral, _super);
    function TLiteral(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.name = JSON.stringify(value);
        _this._failMsg = "is not " + _this.name;
        return _this;
    }
    TLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return value === _this.value ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TLiteral;
}(TType);
exports.TLiteral = TLiteral;
/**
 * Defines an array type, e.g. array('number').
 */ function array(typeSpec) {
    return new TArray(parseSpec(typeSpec));
}
exports.array = array;
var TArray = /** @class */ function(_super) {
    __extends(TArray, _super);
    function TArray(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TArray.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < value.length; i++){
                var ok = itemChecker(value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
    };
    return TArray;
}(TType);
exports.TArray = TArray;
/**
 * Defines a tuple type, e.g. tuple('string', 'number').
 */ function tuple() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TTuple(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.tuple = tuple;
var TTuple = /** @class */ function(_super) {
    __extends(TTuple, _super);
    function TTuple(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TTuple.prototype.getChecker = function(suite, strict) {
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TTuple;
}(TType);
exports.TTuple = TTuple;
/**
 * Defines a union type, e.g. union('number', 'null').
 */ function union() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TUnion(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.union = union;
var TUnion = /** @class */ function(_super) {
    __extends(TUnion, _super);
    function TUnion(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        var names = ttypes.map(function(t) {
            return t instanceof TName || t instanceof TLiteral ? t.name : null;
        }).filter(function(n) {
            return n;
        });
        var otherTypes = ttypes.length - names.length;
        if (names.length) {
            if (otherTypes > 0) names.push(otherTypes + " more");
            _this._failMsg = "is none of " + names.join(", ");
        } else _this._failMsg = "is none of " + otherTypes + " types";
        return _this;
    }
    TUnion.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        return function(value, ctx) {
            var ur = ctx.unionResolver();
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value, ur.createContext());
                if (ok) return true;
            }
            ctx.resolveUnion(ur);
            return ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TUnion;
}(TType);
exports.TUnion = TUnion;
/**
 * Defines an intersection type, e.g. intersection('number', 'null').
 */ function intersection() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TIntersection(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.intersection = intersection;
var TIntersection = /** @class */ function(_super) {
    __extends(TIntersection, _super);
    function TIntersection(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TIntersection.prototype.getChecker = function(suite, strict) {
        var allowedProps = new Set();
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict, allowedProps);
        });
        return function(value, ctx) {
            var ok = itemCheckers.every(function(checker) {
                return checker(value, ctx);
            });
            if (ok) return true;
            return ctx.fail(null, null, 0);
        };
    };
    return TIntersection;
}(TType);
exports.TIntersection = TIntersection;
/**
 * Defines an enum type, e.g. enum({'A': 1, 'B': 2}).
 */ function enumtype(values) {
    return new TEnumType(values);
}
exports.enumtype = enumtype;
var TEnumType = /** @class */ function(_super) {
    __extends(TEnumType, _super);
    function TEnumType(members) {
        var _this = _super.call(this) || this;
        _this.members = members;
        _this.validValues = new Set();
        _this._failMsg = "is not a valid enum value";
        _this.validValues = new Set(Object.keys(members).map(function(name) {
            return members[name];
        }));
        return _this;
    }
    TEnumType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validValues.has(value) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TEnumType;
}(TType);
exports.TEnumType = TEnumType;
/**
 * Defines a literal enum value, such as Direction.Up, specified as enumlit("Direction", "Up").
 */ function enumlit(name, prop) {
    return new TEnumLiteral(name, prop);
}
exports.enumlit = enumlit;
var TEnumLiteral = /** @class */ function(_super) {
    __extends(TEnumLiteral, _super);
    function TEnumLiteral(enumName, prop) {
        var _this = _super.call(this) || this;
        _this.enumName = enumName;
        _this.prop = prop;
        _this._failMsg = "is not " + enumName + "." + prop;
        return _this;
    }
    TEnumLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var ttype = getNamedType(suite, this.enumName);
        if (!(ttype instanceof TEnumType)) throw new Error("Type " + this.enumName + " used in enumlit is not an enum type");
        var val = ttype.members[this.prop];
        if (!ttype.members.hasOwnProperty(this.prop)) throw new Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
        return function(value, ctx) {
            return value === val ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TEnumLiteral;
}(TType);
exports.TEnumLiteral = TEnumLiteral;
function makeIfaceProps(props) {
    return Object.keys(props).map(function(name) {
        return makeIfaceProp(name, props[name]);
    });
}
function makeIfaceProp(name, prop) {
    return prop instanceof TOptional ? new TProp(name, prop.ttype, true) : new TProp(name, parseSpec(prop), false);
}
/**
 * Defines an interface. The first argument is an array of interfaces that it extends, and the
 * second is an array of properties.
 */ function iface(bases, props) {
    return new TIface(bases, makeIfaceProps(props));
}
exports.iface = iface;
var TIface = /** @class */ function(_super) {
    __extends(TIface, _super);
    function TIface(bases, props) {
        var _this = _super.call(this) || this;
        _this.bases = bases;
        _this.props = props;
        _this.propSet = new Set(props.map(function(p) {
            return p.name;
        }));
        return _this;
    }
    TIface.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var baseCheckers = this.bases.map(function(b) {
            return getNamedType(suite, b).getChecker(suite, strict);
        });
        var propCheckers = this.props.map(function(prop) {
            return prop.ttype.getChecker(suite, strict);
        });
        var testCtx = new $d3AJN.NoopContext();
        // Consider a prop required if it's not optional AND does not allow for undefined as a value.
        var isPropRequired = this.props.map(function(prop, i) {
            return !prop.isOpt && !propCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (typeof value !== "object" || value === null) return ctx.fail(null, "is not an object", 0);
            for(var i = 0; i < baseCheckers.length; i++){
                if (!baseCheckers[i](value, ctx)) return false;
            }
            for(var i = 0; i < propCheckers.length; i++){
                var name_1 = _this.props[i].name;
                var v = value[name_1];
                if (v === undefined) {
                    if (isPropRequired[i]) return ctx.fail(name_1, "is missing", 1);
                } else {
                    var ok = propCheckers[i](v, ctx);
                    if (!ok) return ctx.fail(name_1, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        var propSet = this.propSet;
        if (allowedProps) {
            this.propSet.forEach(function(prop) {
                return allowedProps.add(prop);
            });
            propSet = allowedProps;
        }
        // In strict mode, check also for unknown enumerable properties.
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            for(var prop in value){
                if (!propSet.has(prop)) return ctx.fail(prop, "is extraneous", 2);
            }
            return true;
        };
    };
    return TIface;
}(TType);
exports.TIface = TIface;
/**
 * Defines an optional property on an interface.
 */ function opt(typeSpec) {
    return new TOptional(parseSpec(typeSpec));
}
exports.opt = opt;
var TOptional = /** @class */ function(_super) {
    __extends(TOptional, _super);
    function TOptional(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TOptional.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            return value === undefined || itemChecker(value, ctx);
        };
    };
    return TOptional;
}(TType);
exports.TOptional = TOptional;
/**
 * Defines a property in an interface.
 */ var TProp = /** @class */ function() {
    function TProp(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TProp;
}();
exports.TProp = TProp;
/**
 * Defines a function. The first argument declares the function's return type, the rest declare
 * its parameters.
 */ function func(resultSpec) {
    var params = [];
    for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
    return new TFunc(new TParamList(params), parseSpec(resultSpec));
}
exports.func = func;
var TFunc = /** @class */ function(_super) {
    __extends(TFunc, _super);
    function TFunc(paramList, result) {
        var _this = _super.call(this) || this;
        _this.paramList = paramList;
        _this.result = result;
        return _this;
    }
    TFunc.prototype.getChecker = function(suite, strict) {
        return function(value, ctx) {
            return typeof value === "function" ? true : ctx.fail(null, "is not a function", 0);
        };
    };
    return TFunc;
}(TType);
exports.TFunc = TFunc;
/**
 * Defines a function parameter.
 */ function param(name, typeSpec, isOpt) {
    return new TParam(name, parseSpec(typeSpec), Boolean(isOpt));
}
exports.param = param;
var TParam = /** @class */ function() {
    function TParam(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TParam;
}();
exports.TParam = TParam;
/**
 * Defines a function parameter list.
 */ var TParamList = /** @class */ function(_super) {
    __extends(TParamList, _super);
    function TParamList(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    TParamList.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.params.map(function(t) {
            return t.ttype.getChecker(suite, strict);
        });
        var testCtx = new $d3AJN.NoopContext();
        var isParamRequired = this.params.map(function(param, i) {
            return !param.isOpt && !itemCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var p = _this.params[i];
                if (value[i] === undefined) {
                    if (isParamRequired[i]) return ctx.fail(p.name, "is missing", 1);
                } else {
                    var ok = itemCheckers[i](value[i], ctx);
                    if (!ok) return ctx.fail(p.name, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TParamList;
}(TType);
exports.TParamList = TParamList;
/**
 * Single TType implementation for all basic built-in types.
 */ var BasicType = /** @class */ function(_super) {
    __extends(BasicType, _super);
    function BasicType(validator, message) {
        var _this = _super.call(this) || this;
        _this.validator = validator;
        _this.message = message;
        return _this;
    }
    BasicType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validator(value) ? true : ctx.fail(null, _this.message, 0);
        };
    };
    return BasicType;
}(TType);
exports.BasicType = BasicType;
/**
 * Defines the suite of basic types.
 */ exports.basicTypes = {
    any: new BasicType(function(v) {
        return true;
    }, "is invalid"),
    number: new BasicType(function(v) {
        return typeof v === "number";
    }, "is not a number"),
    object: new BasicType(function(v) {
        return typeof v === "object" && v;
    }, "is not an object"),
    boolean: new BasicType(function(v) {
        return typeof v === "boolean";
    }, "is not a boolean"),
    string: new BasicType(function(v) {
        return typeof v === "string";
    }, "is not a string"),
    symbol: new BasicType(function(v) {
        return typeof v === "symbol";
    }, "is not a symbol"),
    void: new BasicType(function(v) {
        return v == null;
    }, "is not void"),
    undefined: new BasicType(function(v) {
        return v === undefined;
    }, "is not undefined"),
    null: new BasicType(function(v) {
        return v === null;
    }, "is not null"),
    never: new BasicType(function(v) {
        return false;
    }, "is unexpected"),
    Date: new BasicType(getIsNativeChecker("[object Date]"), "is not a Date"),
    RegExp: new BasicType(getIsNativeChecker("[object RegExp]"), "is not a RegExp")
};
// This approach for checking native object types mirrors that of lodash. Its advantage over
// `isinstance` is that it can still return true for native objects created in different JS
// execution environments.
var nativeToString = Object.prototype.toString;
function getIsNativeChecker(tag) {
    return function(v) {
        return typeof v === "object" && v && nativeToString.call(v) === tag;
    };
}
if (typeof $d1db7736deae183e$require$Buffer !== "undefined") exports.basicTypes.Buffer = new BasicType(function(v) {
    return $d1db7736deae183e$require$Buffer.isBuffer(v);
}, "is not a Buffer");
var _loop_1 = function(array_1) {
    exports.basicTypes[array_1.name] = new BasicType(function(v) {
        return v instanceof array_1;
    }, "is not a " + array_1.name);
};
// Support typed arrays of various flavors
for(var _i = 0, _a = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    ArrayBuffer
]; _i < _a.length; _i++){
    var array_1 = _a[_i];
    _loop_1(array_1);
}

});
parcelRegister("d3AJN", function(module, exports) {
"use strict";
var $98180d8587d5f612$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailContext = module.exports.NoopContext = module.exports.VError = void 0;
/**
 * Error thrown by validation. Besides an informative message, it includes the path to the
 * property which triggered the failure.
 */ var $98180d8587d5f612$var$VError = /** @class */ function(_super) {
    $98180d8587d5f612$var$__extends(VError, _super);
    function VError(path, message) {
        var _this = _super.call(this, message) || this;
        _this.path = path;
        // See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work for info about this workaround.
        Object.setPrototypeOf(_this, VError.prototype);
        return _this;
    }
    return VError;
}(Error);
module.exports.VError = $98180d8587d5f612$var$VError;
/**
 * Fast implementation of IContext used for first-pass validation. If that fails, we can validate
 * using DetailContext to collect error messages. That's faster for the common case when messages
 * normally pass validation.
 */ var $98180d8587d5f612$var$NoopContext = /** @class */ function() {
    function NoopContext() {}
    NoopContext.prototype.fail = function(relPath, message, score) {
        return false;
    };
    NoopContext.prototype.unionResolver = function() {
        return this;
    };
    NoopContext.prototype.createContext = function() {
        return this;
    };
    NoopContext.prototype.resolveUnion = function(ur) {};
    return NoopContext;
}();
module.exports.NoopContext = $98180d8587d5f612$var$NoopContext;
/**
 * Complete implementation of IContext that collects meaningfull errors.
 */ var $98180d8587d5f612$var$DetailContext = /** @class */ function() {
    function DetailContext() {
        // Stack of property names and associated messages for reporting helpful error messages.
        this._propNames = [
            ""
        ];
        this._messages = [
            null
        ];
        // Score is used to choose the best union member whose DetailContext to use for reporting.
        // Higher score means better match (or rather less severe mismatch).
        this._score = 0;
    }
    DetailContext.prototype.fail = function(relPath, message, score) {
        this._propNames.push(relPath);
        this._messages.push(message);
        this._score += score;
        return false;
    };
    DetailContext.prototype.unionResolver = function() {
        return new $98180d8587d5f612$var$DetailUnionResolver();
    };
    DetailContext.prototype.resolveUnion = function(unionResolver) {
        var _a, _b;
        var u = unionResolver;
        var best = null;
        for(var _i = 0, _c = u.contexts; _i < _c.length; _i++){
            var ctx = _c[_i];
            if (!best || ctx._score >= best._score) best = ctx;
        }
        if (best && best._score > 0) {
            (_a = this._propNames).push.apply(_a, best._propNames);
            (_b = this._messages).push.apply(_b, best._messages);
        }
    };
    DetailContext.prototype.getError = function(path) {
        var msgParts = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var m = this._messages[i];
            if (m) msgParts.push(path + " " + m);
        }
        return new $98180d8587d5f612$var$VError(path, msgParts.join("; "));
    };
    DetailContext.prototype.getErrorDetail = function(path) {
        var details = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var message = this._messages[i];
            if (message) details.push({
                path: path,
                message: message
            });
        }
        var detail = null;
        for(var i = details.length - 1; i >= 0; i--){
            if (detail) details[i].nested = [
                detail
            ];
            detail = details[i];
        }
        return detail;
    };
    return DetailContext;
}();
module.exports.DetailContext = $98180d8587d5f612$var$DetailContext;
var $98180d8587d5f612$var$DetailUnionResolver = /** @class */ function() {
    function DetailUnionResolver() {
        this.contexts = [];
    }
    DetailUnionResolver.prototype.createContext = function() {
        var ctx = new $98180d8587d5f612$var$DetailContext();
        this.contexts.push(ctx);
        return ctx;
    };
    return DetailUnionResolver;
}();

});


parcelRegister("80eeU", function(module, exports) {

$parcel$export(module.exports, "getDefaults", () => $5d395e7a24988106$export$212bb2fc580a90a8);
$parcel$export(module.exports, "defaults", () => $5d395e7a24988106$export$ebe90cb607ad99e);
$parcel$export(module.exports, "Tokenizer", () => $5d395e7a24988106$export$55e8b082af4aa63e);
$parcel$export(module.exports, "Lexer", () => $5d395e7a24988106$export$6168dc8908a6c652);
$parcel$export(module.exports, "Renderer", () => $5d395e7a24988106$export$88530751e3977073);
$parcel$export(module.exports, "TextRenderer", () => $5d395e7a24988106$export$75ebcd2c8ed5b901);
$parcel$export(module.exports, "Parser", () => $5d395e7a24988106$export$7acfa6ed01010e37);
$parcel$export(module.exports, "Hooks", () => $5d395e7a24988106$export$5fbefe39e79899a6);
$parcel$export(module.exports, "Marked", () => $5d395e7a24988106$export$164128c95a350e30);
$parcel$export(module.exports, "marked", () => $5d395e7a24988106$export$db8f131360c543a5);
$parcel$export(module.exports, "use", () => $5d395e7a24988106$export$1f96ae73734a86cc);
$parcel$export(module.exports, "options", () => $5d395e7a24988106$export$41c562ebe57d11e2);
$parcel$export(module.exports, "setOptions", () => $5d395e7a24988106$export$add91eafeaeab287);
$parcel$export(module.exports, "walkTokens", () => $5d395e7a24988106$export$3eedd5437d43cb76);
$parcel$export(module.exports, "parseInline", () => $5d395e7a24988106$export$c7679c2b5e355e6f);
$parcel$export(module.exports, "parse", () => $5d395e7a24988106$export$98e6a39c04603d36);
$parcel$export(module.exports, "parser", () => $5d395e7a24988106$export$8f49e4af10703ce3);
$parcel$export(module.exports, "lexer", () => $5d395e7a24988106$export$43feed32102720d2);
/**
 * marked v18.1.1 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ function $5d395e7a24988106$export$212bb2fc580a90a8() {
    return {
        async: !1,
        breaks: !1,
        extensions: null,
        gfm: !0,
        hooks: null,
        pedantic: !1,
        renderer: null,
        silent: !1,
        tokenizer: null,
        walkTokens: null
    };
}
var $5d395e7a24988106$export$ebe90cb607ad99e = $5d395e7a24988106$export$212bb2fc580a90a8();
function $5d395e7a24988106$var$V(a) {
    $5d395e7a24988106$export$ebe90cb607ad99e = a;
}
var $5d395e7a24988106$var$M = {
    exec: ()=>null
};
function $5d395e7a24988106$var$D(a) {
    let e = [];
    return (t)=>{
        let n = Math.max(0, Math.min(3, t - 1)), i = e[n];
        return i || (i = a(n), e[n] = i), i;
    };
}
function $5d395e7a24988106$var$h(a, e = "") {
    let t = typeof a == "string" ? a : a.source, n = {
        replace: (i, r)=>{
            let o = typeof r == "string" ? r : r.source;
            return o = o.replace($5d395e7a24988106$var$x.caret, "$1"), t = t.replace(i, o), n;
        },
        getRegex: ()=>new RegExp(t, e)
    };
    return n;
}
var $5d395e7a24988106$var$ze = ((a = "")=>{
    try {
        return new RegExp("(?<=1)(?<!1)" + a), true;
    } catch  {
        return !1;
    }
})(), $5d395e7a24988106$var$x = {
    codeRemoveIndent: /^(?: {0,3}\t| {1,4})/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    endingSpaceTabChar: /[ \t]$/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    leadingSpaceTab: /^[ \t]+/,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] +\S/,
    listReplaceTask: /^\[[ xX]\] +/,
    listTaskCheckbox: /\[[ xX]\]/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    numericCharacterReference: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));/,
    numericCharacterReferenceOrAmpersand: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (a)=>new RegExp(`^( {0,3}${a})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
    hrRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}((?:-[ 	]*){3,}|(?:_[ 	]*){3,}|(?:\\*[ 	]*){3,})(?:\\n+|$)`)),
    fencesBeginRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}(?:\`\`\`|~~~)`)),
    headingBeginRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}#`)),
    htmlBeginRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}(?:</?(?:${$5d395e7a24988106$var$Q})(?: +|$|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)`, "i")),
    blockquoteBeginRegex: $5d395e7a24988106$var$D((a)=>new RegExp(`^ {0,${a}}>`))
}, $5d395e7a24988106$var$Ee = /^(?:[ \t]*(?:\n|$))+/, $5d395e7a24988106$var$Me = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, $5d395e7a24988106$var$Ce = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, $5d395e7a24988106$var$N = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, $5d395e7a24988106$var$Ie = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, $5d395e7a24988106$var$Y = / {0,3}(?:[*+-]|\d{1,9}[.)])/, $5d395e7a24988106$var$fe = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |fences|blockquote|heading|hr|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, $5d395e7a24988106$var$me = $5d395e7a24988106$var$h($5d395e7a24988106$var$fe).replace(/bull/g, $5d395e7a24988106$var$Y).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), $5d395e7a24988106$var$Be = $5d395e7a24988106$var$h($5d395e7a24988106$var$fe).replace(/bull/g, $5d395e7a24988106$var$Y).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), $5d395e7a24988106$var$ee = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table|[ \t]+\n)[^\n]+)*)/, $5d395e7a24988106$var$De = /^[^\n]+/, $5d395e7a24988106$var$te = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, $5d395e7a24988106$var$qe = $5d395e7a24988106$var$h(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $5d395e7a24988106$var$te).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), $5d395e7a24988106$var$Ze = $5d395e7a24988106$var$h(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, $5d395e7a24988106$var$Y).getRegex(), $5d395e7a24988106$var$Q = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", $5d395e7a24988106$var$ne = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, $5d395e7a24988106$var$ve = $5d395e7a24988106$var$h("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n*|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>[^\\n]*\\n*|$)|<![A-Z][\\s\\S]*?(?:>[^\\n]*\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>[^\\n]*\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!(?:script|pre|style|textarea)(?![a-z0-9-]))([a-z][a-z0-9-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</[a-z][a-z0-9-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $5d395e7a24988106$var$ne).replace("tag", $5d395e7a24988106$var$Q).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), $5d395e7a24988106$var$xe = (a)=>$5d395e7a24988106$var$h($5d395e7a24988106$var$ee).replace("hr", $5d395e7a24988106$var$N).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", a).replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", $5d395e7a24988106$var$Q).getRegex(), $5d395e7a24988106$var$He = $5d395e7a24988106$var$xe(/ {0,3}(?:[*+-]|1[.)])[ \t]+[^ \t\n]/), $5d395e7a24988106$var$Ge = $5d395e7a24988106$var$xe(/ {0,3}(?:[*+-]|\d{1,9}[.)])(?:[ \t]|\n|$)/), $5d395e7a24988106$var$Ne = $5d395e7a24988106$var$h(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $5d395e7a24988106$var$Ge).getRegex(), $5d395e7a24988106$var$re = {
    blockquote: $5d395e7a24988106$var$Ne,
    code: $5d395e7a24988106$var$Me,
    def: $5d395e7a24988106$var$qe,
    fences: $5d395e7a24988106$var$Ce,
    heading: $5d395e7a24988106$var$Ie,
    hr: $5d395e7a24988106$var$N,
    html: $5d395e7a24988106$var$ve,
    lheading: $5d395e7a24988106$var$me,
    list: $5d395e7a24988106$var$Ze,
    newline: $5d395e7a24988106$var$Ee,
    paragraph: $5d395e7a24988106$var$He,
    table: $5d395e7a24988106$var$M,
    text: $5d395e7a24988106$var$De
}, $5d395e7a24988106$var$de = $5d395e7a24988106$var$h("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $5d395e7a24988106$var$N).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", $5d395e7a24988106$var$Q).getRegex(), $5d395e7a24988106$var$Qe = {
    ...$5d395e7a24988106$var$re,
    lheading: $5d395e7a24988106$var$Be,
    table: $5d395e7a24988106$var$de,
    paragraph: $5d395e7a24988106$var$h($5d395e7a24988106$var$ee).replace("hr", $5d395e7a24988106$var$N).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $5d395e7a24988106$var$de).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", $5d395e7a24988106$var$Q).getRegex()
}, $5d395e7a24988106$var$je = {
    ...$5d395e7a24988106$var$re,
    html: $5d395e7a24988106$var$h(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $5d395e7a24988106$var$ne).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $5d395e7a24988106$var$M,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $5d395e7a24988106$var$h($5d395e7a24988106$var$ee).replace("hr", $5d395e7a24988106$var$N).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", $5d395e7a24988106$var$me).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, $5d395e7a24988106$var$Fe = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, $5d395e7a24988106$var$Ue = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, $5d395e7a24988106$var$be = /^( {2,}|\\)\n(?!\s*$)[ \t]*/, $5d395e7a24988106$var$Ke = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, $5d395e7a24988106$var$S = /[\p{P}\p{S}]/u, $5d395e7a24988106$var$q = /[\s\p{P}\p{S}]/u, $5d395e7a24988106$var$j = /[^\s\p{P}\p{S}]/u, $5d395e7a24988106$var$Xe = $5d395e7a24988106$var$h(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $5d395e7a24988106$var$q).getRegex(), $5d395e7a24988106$var$We = /[\p{Pi}\p{Ps}"']/u, $5d395e7a24988106$var$Re = /(?!~)[\p{P}\p{S}]/u, $5d395e7a24988106$var$Ve = /(?!~)[\s\p{P}\p{S}]/u, $5d395e7a24988106$var$Je = /(?:[^\s\p{P}\p{S}]|~)/u, $5d395e7a24988106$var$Ye = $5d395e7a24988106$var$h(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", $5d395e7a24988106$var$ze ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), $5d395e7a24988106$var$Te = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, $5d395e7a24988106$var$et = $5d395e7a24988106$var$h($5d395e7a24988106$var$Te, "u").replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$tt = $5d395e7a24988106$var$h($5d395e7a24988106$var$Te, "u").replace(/punct/g, $5d395e7a24988106$var$Re).getRegex(), $5d395e7a24988106$var$nt = /^(?:\*+(?:((?!\*)(?!openQuote)punct)|([^\s*]))?)|^_+(?:((?!_)(?!openQuote)punct)|([^\s_]))?/, $5d395e7a24988106$var$rt = $5d395e7a24988106$var$h($5d395e7a24988106$var$nt, "u").replace(/openQuote/g, $5d395e7a24988106$var$We).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$Oe = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", $5d395e7a24988106$var$st = $5d395e7a24988106$var$h($5d395e7a24988106$var$Oe, "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$j).replace(/punctSpace/g, $5d395e7a24988106$var$q).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$it = $5d395e7a24988106$var$h($5d395e7a24988106$var$Oe, "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$Je).replace(/punctSpace/g, $5d395e7a24988106$var$Ve).replace(/punct/g, $5d395e7a24988106$var$Re).getRegex(), $5d395e7a24988106$var$ot = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)[\\s](\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|(?:(?!\\*)punct|notPunctSpace)(\\*+)(?!\\*)(?=notPunctSpace)", $5d395e7a24988106$var$at = $5d395e7a24988106$var$h($5d395e7a24988106$var$ot, "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$j).replace(/punctSpace/g, $5d395e7a24988106$var$q).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$lt = $5d395e7a24988106$var$h("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$j).replace(/punctSpace/g, $5d395e7a24988106$var$q).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$ut = "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)[\\s](_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)|(?:(?!_)punct|notPunctSpace)(_+)(?!_)(?=notPunctSpace)", $5d395e7a24988106$var$pt = $5d395e7a24988106$var$h($5d395e7a24988106$var$ut, "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$j).replace(/punctSpace/g, $5d395e7a24988106$var$q).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$ct = $5d395e7a24988106$var$h(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$ht = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", $5d395e7a24988106$var$dt = $5d395e7a24988106$var$h($5d395e7a24988106$var$ht, "gu").replace(/notPunctSpace/g, $5d395e7a24988106$var$j).replace(/punctSpace/g, $5d395e7a24988106$var$q).replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$kt = $5d395e7a24988106$var$h(/\\(punct)/, "gu").replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$gt = $5d395e7a24988106$var$h(/(`+)(?:[^`]|[^`][\s\S]*?[^`])\1(?!`)|`+|\\(punct)/, "gu").replace(/punct/g, $5d395e7a24988106$var$S).getRegex(), $5d395e7a24988106$var$ft = $5d395e7a24988106$var$h(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), $5d395e7a24988106$var$mt = $5d395e7a24988106$var$h($5d395e7a24988106$var$ne).replace("(?:-->|$)", "-->").getRegex(), $5d395e7a24988106$var$xt = $5d395e7a24988106$var$h("^comment|^</[a-zA-Z][a-zA-Z0-9-]*\\s*>|^<[a-zA-Z][a-zA-Z0-9-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $5d395e7a24988106$var$mt).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), $5d395e7a24988106$var$we = /\[(?:\\[\s\S]|[^\[\]\\])*\]/, $5d395e7a24988106$var$K = $5d395e7a24988106$var$h(/(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/).replace("brackets", $5d395e7a24988106$var$we).getRegex(), $5d395e7a24988106$var$bt = $5d395e7a24988106$var$h(/^!?\[(label)\]\([ \t\n]*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?[ \t\n]*\)/).replace("label", $5d395e7a24988106$var$K).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]+|(?=\))/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), $5d395e7a24988106$var$Rt = $5d395e7a24988106$var$h(/^!?\[(label)\]\[(ref)\]/).replace("label", $5d395e7a24988106$var$K).replace("ref", $5d395e7a24988106$var$te).getRegex(), $5d395e7a24988106$var$Tt = $5d395e7a24988106$var$h(/^!?\[(ref)\](?:\[\])?/).replace("ref", $5d395e7a24988106$var$te).getRegex(), $5d395e7a24988106$var$ke = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\]){1,999}/, $5d395e7a24988106$var$Ot = $5d395e7a24988106$var$h(/(?:[^\[\]\\`]*(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\]))){0,999}?[^\[\]\\`]*?/).replace("brackets", $5d395e7a24988106$var$we).getRegex(), $5d395e7a24988106$var$wt = $5d395e7a24988106$var$h("reflink|nolink(?!\\()", "g").replace("reflink", $5d395e7a24988106$var$h(/^!?\[(label)\]\[(ref)\]/).replace("label", $5d395e7a24988106$var$Ot).replace("ref", $5d395e7a24988106$var$ke).getRegex()).replace("nolink", $5d395e7a24988106$var$h(/^!?\[(ref)\](?:\[\])?/).replace("ref", $5d395e7a24988106$var$ke).getRegex()).getRegex(), $5d395e7a24988106$var$ge = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, $5d395e7a24988106$var$Pt = /[A-Za-z0-9._+-]+@[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/, $5d395e7a24988106$var$yt = $5d395e7a24988106$var$h(/(?:mailto:email|xmpp:email(?:\/[A-Za-z0-9@.]+)?)/).replace(/email/g, $5d395e7a24988106$var$Pt).getRegex(), $5d395e7a24988106$var$se = {
    _backpedal: $5d395e7a24988106$var$M,
    anyPunctuation: $5d395e7a24988106$var$kt,
    anyPunctuationOutsideCode: $5d395e7a24988106$var$gt,
    autolink: $5d395e7a24988106$var$ft,
    blockSkip: $5d395e7a24988106$var$Ye,
    br: $5d395e7a24988106$var$be,
    code: $5d395e7a24988106$var$Ue,
    del: $5d395e7a24988106$var$M,
    delLDelim: $5d395e7a24988106$var$M,
    delRDelim: $5d395e7a24988106$var$M,
    emStrongLDelim: $5d395e7a24988106$var$et,
    emStrongRDelimAst: $5d395e7a24988106$var$st,
    emStrongRDelimUnd: $5d395e7a24988106$var$lt,
    escape: $5d395e7a24988106$var$Fe,
    link: $5d395e7a24988106$var$bt,
    nolink: $5d395e7a24988106$var$Tt,
    punctuation: $5d395e7a24988106$var$Xe,
    reflink: $5d395e7a24988106$var$Rt,
    reflinkSearch: $5d395e7a24988106$var$wt,
    tag: $5d395e7a24988106$var$xt,
    text: $5d395e7a24988106$var$Ke,
    url: $5d395e7a24988106$var$M
}, $5d395e7a24988106$var$St = {
    ...$5d395e7a24988106$var$se,
    emStrongLDelim: $5d395e7a24988106$var$rt,
    emStrongRDelimAst: $5d395e7a24988106$var$at,
    emStrongRDelimUnd: $5d395e7a24988106$var$pt,
    link: $5d395e7a24988106$var$h(/^!?\[(label)\]\((.*?)\)/).replace("label", $5d395e7a24988106$var$K).getRegex(),
    reflink: $5d395e7a24988106$var$h(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $5d395e7a24988106$var$K).getRegex()
}, $5d395e7a24988106$var$J = {
    ...$5d395e7a24988106$var$se,
    emStrongRDelimAst: $5d395e7a24988106$var$it,
    emStrongLDelim: $5d395e7a24988106$var$tt,
    delLDelim: $5d395e7a24988106$var$ct,
    delRDelim: $5d395e7a24988106$var$dt,
    url: $5d395e7a24988106$var$h(/^emailProtocol|^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("emailProtocol", $5d395e7a24988106$var$yt).replace("protocol", $5d395e7a24988106$var$ge).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
    text: $5d395e7a24988106$var$h(/^(?:[^a-zA-Z0-9](?=emailProtocol)|(`+|~+|[^`~])(?:(?=[`~])|(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9](?=emailProtocol)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))))/).replace("protocol", $5d395e7a24988106$var$ge).replace(/emailProtocol/g, /(?:mailto|xmpp):/).getRegex()
}, $5d395e7a24988106$var$_t = {
    ...$5d395e7a24988106$var$J,
    br: $5d395e7a24988106$var$h($5d395e7a24988106$var$be).replace("{2,}", "*").getRegex(),
    text: $5d395e7a24988106$var$h($5d395e7a24988106$var$J.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, $5d395e7a24988106$var$F = {
    normal: $5d395e7a24988106$var$re,
    gfm: $5d395e7a24988106$var$Qe,
    pedantic: $5d395e7a24988106$var$je
}, $5d395e7a24988106$var$Z = {
    normal: $5d395e7a24988106$var$se,
    gfm: $5d395e7a24988106$var$J,
    breaks: $5d395e7a24988106$var$_t,
    pedantic: $5d395e7a24988106$var$St
};
var $5d395e7a24988106$var$$t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
}, $5d395e7a24988106$var$Pe = (a)=>$5d395e7a24988106$var$$t[a];
function $5d395e7a24988106$var$w(a, e) {
    if (e) {
        if ($5d395e7a24988106$var$x.escapeTest.test(a)) return a.replace($5d395e7a24988106$var$x.escapeReplace, $5d395e7a24988106$var$Pe);
    } else if ($5d395e7a24988106$var$x.escapeTestNoEncode.test(a)) return a.replace($5d395e7a24988106$var$x.escapeReplaceNoEncode, $5d395e7a24988106$var$Pe);
    return a;
}
function $5d395e7a24988106$var$ye(a) {
    return $5d395e7a24988106$var$x.numericCharacterReference.test(a) ? a.replace($5d395e7a24988106$var$x.numericCharacterReferenceOrAmpersand, (e, t, n)=>{
        if (t === void 0 && n === void 0) return "&amp;";
        let i = t === void 0 ? Number.parseInt(n, 16) : Number.parseInt(t, 10);
        return i === 0 || i > 1114111 || i >= 55296 && i <= 57343 ? "\uFFFD" : i === 38 ? "&amp;" : String.fromCodePoint(i);
    }) : a;
}
function $5d395e7a24988106$var$ie(a) {
    try {
        a = encodeURI(a).replace($5d395e7a24988106$var$x.percentDecode, "%");
    } catch  {
        return null;
    }
    return a;
}
function $5d395e7a24988106$var$oe(a, e) {
    let t = a.replace($5d395e7a24988106$var$x.findPipe, (r, o, s)=>{
        let l = !1, u = o;
        for(; --u >= 0 && s[u] === "\\";)l = !l;
        return l ? "|" : " |";
    }), n = t.split($5d395e7a24988106$var$x.splitPipe), i = 0;
    if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
        if (n.length > e) n.splice(e);
        else for(; n.length < e;)n.push("");
    }
    for(; i < n.length; i++)n[i] = n[i].trim().replace($5d395e7a24988106$var$x.slashPipe, "|");
    return n;
}
function $5d395e7a24988106$var$A(a, e, t) {
    let n = a.length;
    if (n === 0) return "";
    let i = 0;
    for(; i < n;){
        let r = a.charAt(n - i - 1);
        if (r === e && !t) i++;
        else if (r !== e && t) i++;
        else break;
    }
    return a.slice(0, n - i);
}
function $5d395e7a24988106$var$ae(a) {
    let e = a.split(`
`), t = e.length - 1;
    for(; t >= 0 && $5d395e7a24988106$var$x.blankLine.test(e[t]);)t--;
    return e.length - t <= 2 ? a : e.slice(0, t + 1).join(`
`);
}
function $5d395e7a24988106$var$v(a) {
    return a.trim().toLowerCase().toUpperCase().toLowerCase();
}
function $5d395e7a24988106$var$le(a, e) {
    if (a.indexOf(e[0]) === -1 && a.indexOf(e[1]) === -1) return -1;
    let t = 0;
    for(let n = 0; n < a.length; n++)if (a[n] === "\\") n++;
    else if (a[n] === e[0]) t++;
    else if (a[n] === e[1] && (t--, t < 0)) return n;
    return t > 0 ? -2 : -1;
}
function $5d395e7a24988106$var$X(a, e = 0) {
    let t = e, n = "";
    for (let i of a)if (i === "	") {
        let r = 4 - t % 4;
        n += " ".repeat(r), t += r;
    } else n += i, t++;
    return n;
}
function $5d395e7a24988106$var$Se(a, e, t, n, i) {
    let r = e.href, o = e.title || null, s = a[1].replace(i.other.outputLinkReplace, "$1"), l = a[0].charAt(0) === "!", u = n.state.inLink, c = n.state.linkEmitted, p = n.state.inRawBlock;
    n.state.inLink = !0, n.state.linkEmitted = !1;
    let d = n.inlineTokens(s), g = n.state.linkEmitted;
    if (n.state.linkEmitted = c, n.state.inLink = u, !l) {
        if (g) {
            n.state.inRawBlock = p;
            return;
        }
        n.state.linkEmitted = !0;
    }
    return {
        type: l ? "image" : "link",
        raw: t,
        href: r,
        title: o,
        text: s,
        tokens: d
    };
}
function $5d395e7a24988106$var$Lt(a, e, t) {
    let n = a.match(t.other.indentCodeCompensation);
    if (n === null) return e;
    let i = n[1];
    return e.split(`
`).map((r)=>{
        let o = r.match(t.other.beginningSpace);
        if (o === null) return r;
        let [s] = o;
        return r.slice(Math.min(s.length, i.length));
    }).join(`
`);
}
function $5d395e7a24988106$var$_e(a, e, t, n) {
    if (!e.includes("<")) return !1;
    for(let i = 0; i < e.length; i++){
        if (e[i] === "\\") {
            i++;
            continue;
        }
        if (e[i] === "`") {
            let s = n.inline.code.exec(e.slice(i));
            if (s) {
                i += s[0].length - 1;
                continue;
            }
        }
        if (e[i] !== "<") continue;
        let r = a.slice(t + i), o = n.inline.tag.exec(r) || n.inline.autolink.exec(r);
        if (o) {
            if (o[0].length > e.length - i) return !0;
            i += o[0].length - 1;
        }
    }
    return !1;
}
var $5d395e7a24988106$export$55e8b082af4aa63e = class {
    options;
    rules;
    lexer;
    constructor(e){
        this.options = e || $5d395e7a24988106$export$ebe90cb607ad99e;
    }
    space(e) {
        let t = this.rules.block.newline.exec(e);
        if (t && t[0].length > 0) return {
            type: "space",
            raw: t[0]
        };
    }
    code(e) {
        let t = this.rules.block.code.exec(e);
        if (t) {
            let n = this.options.pedantic ? t[0] : $5d395e7a24988106$var$ae(t[0]), i = n.replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: n,
                codeBlockStyle: "indented",
                text: i
            };
        }
    }
    fences(e) {
        let t = this.rules.block.fences.exec(e);
        if (t) {
            let n = t[0], i = $5d395e7a24988106$var$Lt(n, t[3] || "", this.rules);
            return {
                type: "code",
                raw: n,
                lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                text: i
            };
        }
    }
    heading(e) {
        let t = this.rules.block.heading.exec(e);
        if (t) {
            let n = t[2].trim();
            if (this.rules.other.endingHash.test(n)) {
                let i = $5d395e7a24988106$var$A(n, "#");
                (this.options.pedantic || !i || this.rules.other.endingSpaceTabChar.test(i)) && (n = i.trim());
            }
            return {
                type: "heading",
                raw: $5d395e7a24988106$var$A(t[0], `
`),
                depth: t[1].length,
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    hr(e) {
        let t = this.rules.block.hr.exec(e);
        if (t) return {
            type: "hr",
            raw: $5d395e7a24988106$var$A(t[0], `
`)
        };
    }
    blockquote(e) {
        let t = this.rules.block.blockquote.exec(e);
        if (t) {
            let n = $5d395e7a24988106$var$A(t[0], `
`).split(`
`), i = "", r = "", o = [];
            for(; n.length > 0;){
                let s = !1, l = [], u;
                for(u = 0; u < n.length; u++)if (this.rules.other.blockquoteStart.test(n[u])) l.push(n[u]), s = !0;
                else if (!s) l.push(n[u]);
                else break;
                n = n.slice(u);
                let c = l.join(`
`), p = c.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                i = i ? `${i}
${c}` : c, r = r ? `${r}
${p}` : p;
                let d = this.lexer.state.top;
                if (this.lexer.state.top = !0, this.lexer.blockTokens(p, o, !0), this.lexer.state.top = d, n.length === 0) break;
                let g = o.at(-1);
                if (g?.type === "code" || g?.type === "heading" || g?.type === "hr" || g?.type === "html") break;
                if (g?.type === "blockquote") {
                    let k = g, P = n.join(`
`), R = k.raw + `
` + P.replace(this.rules.other.blockquoteSetextReplace2, ""), m = this.blockquote(R);
                    o[o.length - 1] = m;
                    let E = R.substring(m.raw.length).replace(/^\n/, ""), b = E ? E.split(`
`).length : 0, H = b ? n.slice(0, -b) : n;
                    H.length > 0 && (i = `${i}
${H.join(`
`)}`), r = r.substring(0, r.length - k.text.length) + m.text;
                    break;
                } else if (g?.type === "list") {
                    let k = g, P = k.raw + `
` + n.join(`
`), R = this.list(P);
                    o[o.length - 1] = R, i = i.substring(0, i.length - g.raw.length) + R.raw, r = r.substring(0, r.length - k.raw.length) + R.raw, n = P.substring(o.at(-1).raw.length).split(`
`);
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: i,
                tokens: o,
                text: r
            };
        }
    }
    list(e) {
        let t = this.rules.block.list.exec(e);
        if (t) {
            let n = e, i = ()=>n.length - e.length, r = t[1].trim(), o = r.length > 1, s = {
                type: "list",
                raw: "",
                ordered: o,
                start: o ? +r.slice(0, -1) : "",
                loose: !1,
                items: []
            };
            r = o ? `\\d{1,9}\\${r.slice(-1)}` : `\\${r}`, this.options.pedantic && (r = o ? r : "[*+-]");
            let l = this.rules.other.listItemRegex(r), u = !1;
            for(; e;){
                let p = !1, d = "";
                if (!(t = l.exec(e)) || this.rules.block.hr.test(e)) break;
                let g = i();
                e = e.substring(t[0].length);
                let k = t[2].split(`
`, 1)[0], P = t[1].length, R = this.options.pedantic ? $5d395e7a24988106$var$X(k, P) : k.replace(this.rules.other.leadingSpaceTab, (W)=>$5d395e7a24988106$var$X(W, P)), m = e.split(`
`, 1)[0], E = !R.trim(), b = 0;
                if (this.options.pedantic ? (b = 2, d = R.trimStart()) : E ? b = P + 1 : (b = R.search(this.rules.other.nonSpaceChar), b = b > 4 ? 1 : b, d = R.slice(b), b += P), E && this.rules.other.blankLine.test(m) && (e = e.substring(m.length + 1), p = !0), !p) {
                    let W = this.rules.other.nextBulletRegex(b), ue = this.rules.other.hrRegex(b), pe = this.rules.other.fencesBeginRegex(b), ce = this.rules.other.headingBeginRegex(b), $e = this.rules.other.htmlBeginRegex(b), Le = this.rules.other.blockquoteBeginRegex(b);
                    for(; e;){
                        let he = e.split(`
`, 1)[0], G;
                        if (m = he, this.options.pedantic ? (m = m.replace(this.rules.other.listReplaceNesting, "  "), G = m) : G = m.replace(this.rules.other.leadingSpaceTab, (Ae)=>$5d395e7a24988106$var$X(Ae)), pe.test(m) || ce.test(m) || $e.test(m) || Le.test(m) || W.test(m) || ue.test(m)) break;
                        if (G.search(this.rules.other.nonSpaceChar) >= b || !m.trim()) d += `
` + G.slice(b);
                        else {
                            if (E || R.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || pe.test(R) || ce.test(R) || ue.test(R)) break;
                            d += `
` + m;
                        }
                        E = !m.trim(), e = e.substring(he.length + 1), R = G.slice(b);
                    }
                }
                let H = n.slice(g, i());
                s.loose || (u ? s.loose = !0 : this.rules.other.doubleBlankLine.test(H) && (u = !0)), s.items.push({
                    type: "list_item",
                    raw: H,
                    task: !!this.options.gfm && this.rules.other.listIsTask.test(d),
                    loose: !1,
                    text: d,
                    tokens: []
                });
            }
            let c = s.items.at(-1);
            if (c) c.raw = c.raw.trimEnd(), c.text = c.text.trimEnd();
            else return;
            s.raw = n.slice(0, i()).trimEnd();
            for (let p of s.items)if (this.lexer.state.top = !1, p.tokens = this.lexer.blockTokens(p.text, []), !s.loose) {
                let d = p.tokens.filter((k)=>k.type === "space"), g = d.length > 0 && d.some((k)=>this.rules.other.anyLine.test(k.raw));
                s.loose = g;
            }
            for (let p of s.items){
                let d = p.tokens[0];
                if (p.task && (d?.type === "text" || d?.type === "paragraph")) {
                    p.text = p.text.replace(this.rules.other.listReplaceTask, ""), d.raw = d.raw.replace(this.rules.other.listReplaceTask, ""), d.text = d.text.replace(this.rules.other.listReplaceTask, "");
                    for(let k = this.lexer.inlineQueue.length - 1; k >= 0; k--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[k].src)) {
                        this.lexer.inlineQueue[k].src = this.lexer.inlineQueue[k].src.replace(this.rules.other.listReplaceTask, "");
                        break;
                    }
                    let g = this.rules.other.listTaskCheckbox.exec(p.raw);
                    if (g) {
                        let k = {
                            type: "checkbox",
                            raw: g[0] + " ",
                            checked: g[0] !== "[ ]"
                        };
                        p.checked = k.checked, s.loose ? p.tokens[0] && [
                            "paragraph",
                            "text"
                        ].includes(p.tokens[0].type) && "tokens" in p.tokens[0] && p.tokens[0].tokens ? (p.tokens[0].raw = k.raw + p.tokens[0].raw, p.tokens[0].text = k.raw + p.tokens[0].text, p.tokens[0].tokens.unshift(k)) : p.tokens.unshift({
                            type: "paragraph",
                            raw: k.raw,
                            text: k.raw,
                            tokens: [
                                k
                            ]
                        }) : p.tokens.unshift(k);
                    }
                } else p.task && (p.task = !1);
            }
            if (s.loose) for (let p of s.items){
                p.loose = !0;
                for (let d of p.tokens)d.type === "text" && (d.type = "paragraph");
            }
            return s;
        }
    }
    html(e) {
        let t = this.rules.block.html.exec(e);
        if (t) {
            let n = $5d395e7a24988106$var$ae(t[0]);
            return {
                type: "html",
                block: !0,
                raw: n,
                pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                text: n
            };
        }
    }
    def(e) {
        let t = this.rules.block.def.exec(e);
        if (t) {
            if (!this.rules.other.startAngleBracket.test(t[2]) && $5d395e7a24988106$var$le(t[2], "()") !== -1) return;
            let n = $5d395e7a24988106$var$v(t[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
            return {
                type: "def",
                tag: n,
                raw: $5d395e7a24988106$var$A(t[0], `
`),
                href: i,
                title: r
            };
        }
    }
    table(e) {
        let t = this.rules.block.table.exec(e);
        if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
        let n = $5d395e7a24988106$var$oe(t[1]), i = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), r = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], o = {
            type: "table",
            raw: $5d395e7a24988106$var$A(t[0], `
`),
            header: [],
            align: [],
            rows: []
        };
        if (n.length === i.length) {
            for (let s of i)this.rules.other.tableAlignRight.test(s) ? o.align.push("right") : this.rules.other.tableAlignCenter.test(s) ? o.align.push("center") : this.rules.other.tableAlignLeft.test(s) ? o.align.push("left") : o.align.push(null);
            for(let s = 0; s < n.length; s++)o.header.push({
                text: n[s],
                tokens: this.lexer.inline(n[s]),
                header: !0,
                align: o.align[s]
            });
            for (let s of r)o.rows.push($5d395e7a24988106$var$oe(s, o.header.length).map((l, u)=>({
                    text: l,
                    tokens: this.lexer.inline(l),
                    header: !1,
                    align: o.align[u]
                })));
            return o;
        }
    }
    lheading(e) {
        let t = this.rules.block.lheading.exec(e);
        if (t) {
            let n = t[1].trim();
            return {
                type: "heading",
                raw: $5d395e7a24988106$var$A(t[0], `
`),
                depth: t[2].charAt(0) === "=" ? 1 : 2,
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    paragraph(e) {
        let t = this.rules.block.paragraph.exec(e);
        if (t) {
            let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
            return {
                type: "paragraph",
                raw: t[0],
                text: n,
                tokens: this.lexer.inline(n)
            };
        }
    }
    text(e) {
        let t = this.rules.block.text.exec(e);
        if (t) return {
            type: "text",
            raw: t[0],
            text: t[0],
            tokens: this.lexer.inline(t[0])
        };
    }
    escape(e) {
        let t = this.rules.inline.escape.exec(e);
        if (t) return {
            type: "escape",
            raw: t[0],
            text: t[1]
        };
    }
    tag(e) {
        let t = this.rules.inline.tag.exec(e);
        if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
            type: "html",
            raw: t[0],
            inLink: this.lexer.state.inLink,
            inRawBlock: this.lexer.state.inRawBlock,
            block: !1,
            text: t[0]
        };
    }
    link(e) {
        if (this.lexer.state.linkParenPossible === !1) return;
        let t = this.rules.inline.link.exec(e);
        if (t) {
            let n = t[0].charAt(0) === "!" ? 2 : 1;
            if (!this.options.pedantic && $5d395e7a24988106$var$_e(e, t[1], n, this.rules)) return;
            let i = t[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(i)) {
                if (!this.rules.other.endAngleBracket.test(i)) return;
                let s = $5d395e7a24988106$var$A(i.slice(0, -1), "\\");
                if ((i.length - s.length) % 2 === 0) return;
            } else {
                let s = $5d395e7a24988106$var$le(t[2], "()");
                if (s === -2) return;
                if (s > -1) {
                    let u = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                    t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, u).trim(), t[3] = "";
                }
            }
            let r = t[2], o = "";
            if (this.options.pedantic) {
                let s = this.rules.other.pedanticHrefTitle.exec(r);
                s && (r = s[1], o = s[3]);
            } else o = t[3] ? t[3].slice(1, -1) : "";
            return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(i) ? r = r.slice(1) : r = r.slice(1, -1)), $5d395e7a24988106$var$Se(t, {
                href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                title: o && o.replace(this.rules.inline.anyPunctuation, "$1")
            }, t[0], this.lexer, this.rules);
        }
    }
    reflink(e, t) {
        let n;
        if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
            let i = n[0].charAt(0) === "!" ? 2 : 1;
            if (!this.options.pedantic && $5d395e7a24988106$var$_e(e, n[1], i, this.rules)) return;
            let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), o = t[$5d395e7a24988106$var$v(r)];
            if (!o) {
                let s = n[0].charAt(0);
                return {
                    type: "text",
                    raw: s,
                    text: s
                };
            }
            return $5d395e7a24988106$var$Se(n, o, n[0], this.lexer, this.rules);
        }
    }
    emStrong(e, t, n = "") {
        let i = this.rules.inline.emStrongLDelim.exec(e);
        if (!i || !i[1] && !i[2] && !i[3] && !i[4] || i[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
        if (!(i[1] || i[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
            let o = [
                ...i[0]
            ].length - 1, s, l, u = o, c = 0, p = i[0][0], d = n === p, g = p === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            for(g.lastIndex = 0, t = t.slice(-1 * e.length + o); (i = g.exec(t)) !== null;){
                if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s) continue;
                if (l = [
                    ...s
                ].length, i[3] || i[4]) {
                    u += l;
                    continue;
                } else if (i[5] || i[6]) {
                    if (o % 3 && !((o + l) % 3)) {
                        c += l;
                        continue;
                    }
                    if (d) break;
                }
                if (u -= l, u > 0) continue;
                l = Math.min(l, l + u + c);
                let k = [
                    ...i[0]
                ][0].length, P = e.slice(0, o + i.index + k + l);
                if (Math.min(o, l) % 2) {
                    let m = P.slice(1, -1);
                    return {
                        type: "em",
                        raw: P,
                        text: m,
                        tokens: this.lexer.inlineTokens(m)
                    };
                }
                let R = P.slice(2, -2);
                return {
                    type: "strong",
                    raw: P,
                    text: R,
                    tokens: this.lexer.inlineTokens(R)
                };
            }
        }
    }
    codespan(e) {
        let t = this.rules.inline.code.exec(e);
        if (t) {
            let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), i = this.rules.other.nonSpaceChar.test(n), r = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
            return i && r && (n = n.substring(1, n.length - 1)), {
                type: "codespan",
                raw: t[0],
                text: n
            };
        }
    }
    br(e) {
        let t = this.rules.inline.br.exec(e);
        if (t) return {
            type: "br",
            raw: t[0]
        };
    }
    del(e, t, n = "") {
        let i = this.rules.inline.delLDelim.exec(e);
        if (!i) return;
        if (!(i[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
            let o = [
                ...i[0]
            ].length - 1, s, l, u = o, c = this.rules.inline.delRDelim;
            for(c.lastIndex = 0, t = t.slice(-1 * e.length + o); (i = c.exec(t)) !== null;){
                if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s || (l = [
                    ...s
                ].length, l !== o)) continue;
                if (i[3] || i[4]) {
                    u += l;
                    continue;
                }
                if (u -= l, u > 0) continue;
                l = Math.min(l, l + u);
                let p = [
                    ...i[0]
                ][0].length, d = e.slice(0, o + i.index + p + l), g = d.slice(o, -o);
                return {
                    type: "del",
                    raw: d,
                    text: g,
                    tokens: this.lexer.inlineTokens(g)
                };
            }
        }
    }
    autolink(e) {
        let t = this.rules.inline.autolink.exec(e);
        if (t) {
            let n, i;
            return t[2] === "@" ? (n = t[1], i = "mailto:" + n) : (n = t[1], i = n), {
                type: "link",
                raw: t[0],
                text: n,
                href: i,
                autolink: !0,
                tokens: [
                    {
                        type: "text",
                        raw: n,
                        text: n
                    }
                ]
            };
        }
    }
    url(e) {
        let t;
        if (t = this.rules.inline.url.exec(e)) {
            let n, i;
            if (t[2] === "@") n = t[0], i = "mailto:" + n;
            else {
                let r;
                do r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                while (r !== t[0]);
                n = t[0], t[1] === "www." ? i = "http://" + t[0] : i = t[0];
            }
            return {
                type: "link",
                raw: t[0],
                text: n,
                href: i,
                autolink: !0,
                tokens: [
                    {
                        type: "text",
                        raw: n,
                        text: n
                    }
                ]
            };
        }
    }
    inlineText(e) {
        let t = this.rules.inline.text.exec(e);
        if (t) {
            let n = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: t[0],
                text: n ? t[0] : $5d395e7a24988106$var$ye(t[0]),
                escaped: n
            };
        }
    }
};
var $5d395e7a24988106$export$6168dc8908a6c652 = class a {
    tokens;
    options;
    state;
    inlineQueue;
    tokenizer;
    constructor(e){
        this.tokens = [], this.tokens.links = Object.create(null), this.options = e || $5d395e7a24988106$export$ebe90cb607ad99e, this.options.tokenizer = this.options.tokenizer || new $5d395e7a24988106$export$55e8b082af4aa63e, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
            inLink: !1,
            inRawBlock: !1,
            linkEmitted: !1,
            linkParenPossible: !0,
            top: !0
        };
        let t = {
            other: $5d395e7a24988106$var$x,
            block: $5d395e7a24988106$var$F.normal,
            inline: $5d395e7a24988106$var$Z.normal
        };
        this.options.pedantic ? (t.block = $5d395e7a24988106$var$F.pedantic, t.inline = $5d395e7a24988106$var$Z.pedantic) : this.options.gfm && (t.block = $5d395e7a24988106$var$F.gfm, this.options.breaks ? t.inline = $5d395e7a24988106$var$Z.breaks : t.inline = $5d395e7a24988106$var$Z.gfm), this.tokenizer.rules = t;
    }
    static get rules() {
        return {
            block: $5d395e7a24988106$var$F,
            inline: $5d395e7a24988106$var$Z
        };
    }
    static lex(e, t) {
        return new a(t).lex(e);
    }
    static lexInline(e, t) {
        return new a(t).inlineTokens(e);
    }
    lex(e) {
        e = e.replace($5d395e7a24988106$var$x.carriageReturn, `
`), this.blockTokens(e, this.tokens);
        for(let t = 0; t < this.inlineQueue.length; t++){
            let n = this.inlineQueue[t];
            this.inlineTokens(n.src, n.tokens);
        }
        return this.inlineQueue = [], this.tokens;
    }
    blockTokens(e, t = [], n = !1) {
        this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace($5d395e7a24988106$var$x.tabCharGlobal, "    ").replace($5d395e7a24988106$var$x.spaceLine, ""));
        let i = 1 / 0;
        for(; e;){
            if (e.length < i) i = e.length;
            else {
                this.infiniteLoopError(e.charCodeAt(0));
                break;
            }
            let r;
            if (this.options.extensions?.block?.some((s)=>(r = s.call({
                    lexer: this
                }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
            if (r = this.tokenizer.space(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                continue;
            }
            if (r = this.tokenizer.code(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                continue;
            }
            if (r = this.tokenizer.fences(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.heading(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.hr(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.blockquote(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.list(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.html(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.def(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                    href: r.href,
                    title: r.title
                }, t.push(r));
                continue;
            }
            if (r = this.tokenizer.table(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            if (r = this.tokenizer.lheading(e)) {
                e = e.substring(r.raw.length), t.push(r);
                continue;
            }
            let o = e;
            if (this.options.extensions?.startBlock) {
                let s = 1 / 0, l = e.slice(1), u;
                this.options.extensions.startBlock.forEach((c)=>{
                    u = c.call({
                        lexer: this
                    }, l), typeof u == "number" && u >= 0 && (s = Math.min(s, u));
                }), s < 1 / 0 && s >= 0 && (o = e.substring(0, s + 1));
            }
            if (this.state.top && (r = this.tokenizer.paragraph(o))) {
                let s = t.at(-1);
                n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = o.length !== e.length, e = e.substring(r.raw.length);
                continue;
            }
            if (r = this.tokenizer.text(e)) {
                e = e.substring(r.raw.length);
                let s = t.at(-1);
                s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                continue;
            }
            if (e) {
                this.infiniteLoopError(e.charCodeAt(0));
                break;
            }
        }
        return this.state.top = !0, t;
    }
    inline(e, t = []) {
        return this.inlineQueue.push({
            src: e,
            tokens: t
        }), t;
    }
    linkInText(e) {
        if (!e.includes("[")) return !1;
        let t = this.tokenizer.rules.inline.link;
        for (let n of e.matchAll(this.tokenizer.rules.inline.blockSkip))if (t.test(n[0]) && e.charAt(n.index - 1) !== "!") return !0;
        for (let n of e.matchAll(this.tokenizer.rules.inline.reflinkSearch)){
            let i = n[0], r = i.lastIndexOf("[");
            if (!(i.charAt(0) === "!" || !Object.hasOwn(this.tokens.links, $5d395e7a24988106$var$v(i.slice(r + 1, -1)))) && !(r > 1 && this.linkInText(i.slice(1, r - 1)))) return !0;
        }
        return !1;
    }
    inlineTokens(e, t = []) {
        this.tokenizer.lexer = this;
        let n = this.state.linkParenPossible;
        this.state.linkParenPossible = n && e.includes(")");
        try {
            return this.#e(e, t);
        } finally{
            this.state.linkParenPossible = n;
        }
    }
    #e(e, t) {
        let n = e;
        if (this.tokens.links && e.includes("[")) {
            let s = this.tokenizer.rules.inline.reflinkSearch, l = (u)=>{
                let c = u.lastIndexOf("[");
                if (!Object.hasOwn(this.tokens.links, $5d395e7a24988106$var$v(u.slice(c + 1, -1)))) return u;
                if (c > 1 && u.charAt(0) !== "!") {
                    let p = u.slice(1, c - 1);
                    if (this.linkInText(p)) return "[" + p.replace(s, l) + "][" + "a".repeat(u.length - c - 2) + "]";
                }
                return "[" + "a".repeat(u.length - 2) + "]";
            };
            n = n.replace(s, l);
        }
        n = n.replace(this.tokenizer.rules.inline.anyPunctuationOutsideCode, (s, l, u)=>u ? "+".repeat(s.length) : l ? l + s.slice(l.length, -l.length).replace(/`/g, "+") + l : s), n = n.replace(this.tokenizer.rules.inline.blockSkip, (s, l, u)=>{
            let c = u ? u.length : 0;
            return s.slice(0, c) + "[" + "a".repeat(s.length - c - 2) + "]";
        }), n = this.options.hooks?.emStrongMask?.call({
            lexer: this
        }, n) ?? n;
        let i = !1, r = "", o = 1 / 0;
        for(; e;){
            if (e.length < o) o = e.length;
            else {
                this.infiniteLoopError(e.charCodeAt(0));
                break;
            }
            i || (r = ""), i = !1;
            let s;
            if (this.options.extensions?.inline?.some((u)=>(s = u.call({
                    lexer: this
                }, e, t)) ? (e = e.substring(s.raw.length), t.push(s), !0) : !1)) continue;
            if (s = this.tokenizer.escape(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.tag(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.link(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.reflink(e, this.tokens.links)) {
                e = e.substring(s.raw.length);
                let u = t.at(-1);
                s.type === "text" && u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : t.push(s);
                continue;
            }
            if (s = this.tokenizer.emStrong(e, n, r)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.codespan(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.br(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.del(e, n, r)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (s = this.tokenizer.autolink(e)) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            if (!this.state.inLink && (s = this.tokenizer.url(e))) {
                e = e.substring(s.raw.length), t.push(s);
                continue;
            }
            let l = e;
            if (this.options.extensions?.startInline) {
                let u = 1 / 0, c = e.slice(1), p;
                this.options.extensions.startInline.forEach((d)=>{
                    p = d.call({
                        lexer: this
                    }, c), typeof p == "number" && p >= 0 && (u = Math.min(u, p));
                }), u < 1 / 0 && u >= 0 && (l = e.substring(0, u + 1));
            }
            if (s = this.tokenizer.inlineText(l)) {
                e = e.substring(s.raw.length), s.raw.slice(-1) !== "_" && (r = s.raw.slice(-1)), i = !0;
                let u = t.at(-1);
                u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : t.push(s);
                continue;
            }
            if (e) {
                this.infiniteLoopError(e.charCodeAt(0));
                break;
            }
        }
        return t;
    }
    infiniteLoopError(e) {
        let t = "Infinite loop on byte: " + e;
        if (this.options.silent) console.error(t);
        else throw new Error(t);
    }
};
var $5d395e7a24988106$export$88530751e3977073 = class {
    options;
    parser;
    constructor(e){
        this.options = e || $5d395e7a24988106$export$ebe90cb607ad99e;
    }
    space(e) {
        return "";
    }
    code({ text: e, lang: t, escaped: n }) {
        let i = (t || "").match($5d395e7a24988106$var$x.notSpaceStart)?.[0], r = e ? e.replace($5d395e7a24988106$var$x.endingNewline, "") + `
` : "";
        return i ? '<pre><code class="language-' + $5d395e7a24988106$var$w(i) + '">' + (n ? r : $5d395e7a24988106$var$w(r, !0)) + `</code></pre>
` : "<pre><code>" + (n ? r : $5d395e7a24988106$var$w(r, !0)) + `</code></pre>
`;
    }
    blockquote({ tokens: e }) {
        return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
    }
    html({ text: e }) {
        return e;
    }
    def(e) {
        return "";
    }
    heading({ tokens: e, depth: t }) {
        return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
    }
    hr(e) {
        return `<hr>
`;
    }
    list(e) {
        let t = e.ordered, n = e.start, i = "";
        for(let s = 0; s < e.items.length; s++){
            let l = e.items[s];
            i += this.listitem(l);
        }
        let r = t ? "ol" : "ul", o = t && n !== 1 ? ' start="' + n + '"' : "";
        return "<" + r + o + `>
` + i + "</" + r + `>
`;
    }
    listitem(e) {
        return `<li>${this.parser.parse(e.tokens)}</li>
`;
    }
    checkbox({ checked: e }) {
        return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
    }
    paragraph({ tokens: e }) {
        return `<p>${this.parser.parseInline(e)}</p>
`;
    }
    table(e) {
        let t = "", n = "";
        for(let r = 0; r < e.header.length; r++)n += this.tablecell(e.header[r]);
        t += this.tablerow({
            text: n
        });
        let i = "";
        for(let r = 0; r < e.rows.length; r++){
            let o = e.rows[r];
            n = "";
            for(let s = 0; s < o.length; s++)n += this.tablecell(o[s]);
            i += this.tablerow({
                text: n
            });
        }
        return i && (i = `<tbody>${i}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + i + `</table>
`;
    }
    tablerow({ text: e }) {
        return `<tr>
${e}</tr>
`;
    }
    tablecell(e) {
        let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
        return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
    }
    strong({ tokens: e }) {
        return `<strong>${this.parser.parseInline(e)}</strong>`;
    }
    em({ tokens: e }) {
        return `<em>${this.parser.parseInline(e)}</em>`;
    }
    codespan({ text: e }) {
        return `<code>${$5d395e7a24988106$var$w(e, !0)}</code>`;
    }
    br(e) {
        return "<br>";
    }
    del({ tokens: e }) {
        return `<del>${this.parser.parseInline(e)}</del>`;
    }
    link({ href: e, title: t, text: n, tokens: i, autolink: r }) {
        let o = r ? $5d395e7a24988106$var$w(n, !0) : this.parser.parseInline(i), s = $5d395e7a24988106$var$ie(e);
        if (s === null) return o;
        e = $5d395e7a24988106$var$w(s, r);
        let l = '<a href="' + e + '"';
        return t && (l += ' title="' + $5d395e7a24988106$var$w(t) + '"'), l += ">" + o + "</a>", l;
    }
    image({ href: e, title: t, text: n, tokens: i }) {
        i && (n = this.parser.parseInline(i, this.parser.textRenderer));
        let r = $5d395e7a24988106$var$ie(e);
        if (r === null) return $5d395e7a24988106$var$w(n);
        e = r;
        let o = `<img src="${$5d395e7a24988106$var$w(e)}" alt="${$5d395e7a24988106$var$w(n)}"`;
        return t && (o += ` title="${$5d395e7a24988106$var$w(t)}"`), o += ">", o;
    }
    text(e) {
        return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : $5d395e7a24988106$var$w(e.text);
    }
};
var $5d395e7a24988106$export$75ebcd2c8ed5b901 = class {
    strong({ text: e }) {
        return e;
    }
    em({ text: e }) {
        return e;
    }
    codespan({ text: e }) {
        return e;
    }
    del({ text: e }) {
        return e;
    }
    html({ text: e }) {
        return e;
    }
    text({ text: e }) {
        return e;
    }
    link({ text: e }) {
        return "" + e;
    }
    image({ text: e }) {
        return "" + e;
    }
    br() {
        return "";
    }
    checkbox({ raw: e }) {
        return e;
    }
};
var $5d395e7a24988106$export$7acfa6ed01010e37 = class a {
    options;
    renderer;
    textRenderer;
    constructor(e){
        this.options = e || $5d395e7a24988106$export$ebe90cb607ad99e, this.options.renderer = this.options.renderer || new $5d395e7a24988106$export$88530751e3977073, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new $5d395e7a24988106$export$75ebcd2c8ed5b901;
    }
    static parse(e, t) {
        return new a(t).parse(e);
    }
    static parseInline(e, t) {
        return new a(t).parseInline(e);
    }
    parse(e) {
        this.renderer.parser = this;
        let t = "";
        for(let n = 0; n < e.length; n++){
            let i = e[n];
            if (this.options.extensions?.renderers?.[i.type]) {
                let o = i, s = this.options.extensions.renderers[o.type].call({
                    parser: this
                }, o);
                if (s !== !1 || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "checkbox",
                    "html",
                    "def",
                    "paragraph",
                    "text"
                ].includes(o.type)) {
                    t += s || "";
                    continue;
                }
            }
            let r = i;
            switch(r.type){
                case "space":
                    t += this.renderer.space(r);
                    break;
                case "hr":
                    t += this.renderer.hr(r);
                    break;
                case "heading":
                    t += this.renderer.heading(r);
                    break;
                case "code":
                    t += this.renderer.code(r);
                    break;
                case "table":
                    t += this.renderer.table(r);
                    break;
                case "blockquote":
                    t += this.renderer.blockquote(r);
                    break;
                case "list":
                    t += this.renderer.list(r);
                    break;
                case "checkbox":
                    t += this.renderer.checkbox(r);
                    break;
                case "html":
                    t += this.renderer.html(r);
                    break;
                case "def":
                    t += this.renderer.def(r);
                    break;
                case "paragraph":
                    t += this.renderer.paragraph(r);
                    break;
                case "text":
                    t += this.renderer.text(r);
                    break;
                default:
                    {
                        let o = 'Token with "' + r.type + '" type was not found.';
                        if (this.options.silent) return console.error(o), "";
                        throw new Error(o);
                    }
            }
        }
        return t;
    }
    parseInline(e, t = this.renderer) {
        this.renderer.parser = this;
        let n = "";
        for(let i = 0; i < e.length; i++){
            let r = e[i];
            if (this.options.extensions?.renderers?.[r.type]) {
                let s = this.options.extensions.renderers[r.type].call({
                    parser: this
                }, r);
                if (s !== !1 || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "checkbox",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(r.type)) {
                    n += s || "";
                    continue;
                }
            }
            let o = r;
            switch(o.type){
                case "escape":
                    n += t.text(o);
                    break;
                case "html":
                    n += t.html(o);
                    break;
                case "link":
                    n += t.link(o);
                    break;
                case "image":
                    n += t.image(o);
                    break;
                case "checkbox":
                    n += t.checkbox(o);
                    break;
                case "strong":
                    n += t.strong(o);
                    break;
                case "em":
                    n += t.em(o);
                    break;
                case "codespan":
                    n += t.codespan(o);
                    break;
                case "br":
                    n += t.br(o);
                    break;
                case "del":
                    n += t.del(o);
                    break;
                case "text":
                    n += t.text(o);
                    break;
                default:
                    {
                        let s = 'Token with "' + o.type + '" type was not found.';
                        if (this.options.silent) return console.error(s), "";
                        throw new Error(s);
                    }
            }
        }
        return n;
    }
};
var $5d395e7a24988106$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(e){
        this.options = e || $5d395e7a24988106$export$ebe90cb607ad99e;
    }
    static passThroughHooks = new Set([
        "preprocess",
        "postprocess",
        "processAllTokens",
        "emStrongMask"
    ]);
    static passThroughHooksRespectAsync = new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    preprocess(e) {
        return e;
    }
    postprocess(e) {
        return e;
    }
    processAllTokens(e) {
        return e;
    }
    emStrongMask(e) {
        return e;
    }
    provideLexer(e = this.block) {
        return e ? $5d395e7a24988106$export$6168dc8908a6c652.lex : $5d395e7a24988106$export$6168dc8908a6c652.lexInline;
    }
    provideParser(e = this.block) {
        return e ? $5d395e7a24988106$export$7acfa6ed01010e37.parse : $5d395e7a24988106$export$7acfa6ed01010e37.parseInline;
    }
};
function $5d395e7a24988106$var$C(a, e) {
    if (Array.isArray(e)) for(let t = 0; t < e.length; t++)a.push(e[t]);
    else a.push(e);
}
var $5d395e7a24988106$export$164128c95a350e30 = class {
    defaults = $5d395e7a24988106$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(!0);
    parseInline = this.parseMarkdown(!1);
    Parser = $5d395e7a24988106$export$7acfa6ed01010e37;
    Renderer = $5d395e7a24988106$export$88530751e3977073;
    TextRenderer = $5d395e7a24988106$export$75ebcd2c8ed5b901;
    Lexer = $5d395e7a24988106$export$6168dc8908a6c652;
    Tokenizer = $5d395e7a24988106$export$55e8b082af4aa63e;
    Hooks = $5d395e7a24988106$export$5fbefe39e79899a6;
    constructor(...e){
        this.use(...e);
    }
    walkTokens(e, t) {
        let n = [];
        for (let i of e)switch($5d395e7a24988106$var$C(n, t.call(this, i)), i.type){
            case "table":
                {
                    let r = i;
                    for (let o of r.header)$5d395e7a24988106$var$C(n, this.walkTokens(o.tokens, t));
                    for (let o of r.rows)for (let s of o)$5d395e7a24988106$var$C(n, this.walkTokens(s.tokens, t));
                    break;
                }
            case "list":
                {
                    let r = i;
                    $5d395e7a24988106$var$C(n, this.walkTokens(r.items, t));
                    break;
                }
            default:
                {
                    let r = i;
                    this.defaults.extensions?.childTokens?.[r.type] ? this.defaults.extensions.childTokens[r.type].forEach((o)=>{
                        let s = r[o].flat(1 / 0);
                        $5d395e7a24988106$var$C(n, this.walkTokens(s, t));
                    }) : r.tokens && $5d395e7a24988106$var$C(n, this.walkTokens(r.tokens, t));
                }
        }
        return n;
    }
    use(...e) {
        let t = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        return e.forEach((n)=>{
            let i = {
                ...n
            };
            if (i.async = this.defaults.async || i.async || !1, n.extensions && (n.extensions.forEach((r)=>{
                if (!r.name) throw new Error("extension name required");
                if ("renderer" in r) {
                    let o = t.renderers[r.name];
                    o ? t.renderers[r.name] = function(...s) {
                        let l = r.renderer.apply(this, s);
                        return l === !1 && (l = o.apply(this, s)), l;
                    } : t.renderers[r.name] = r.renderer;
                }
                if ("tokenizer" in r) {
                    if (!r.level || r.level !== "block" && r.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                    let o = t[r.level];
                    o ? o.unshift(r.tokenizer) : t[r.level] = [
                        r.tokenizer
                    ], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [
                        r.start
                    ] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [
                        r.start
                    ]));
                }
                "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
            }), i.extensions = t), n.renderer) {
                let r = this.defaults.renderer || new $5d395e7a24988106$export$88530751e3977073(this.defaults);
                for(let o in n.renderer){
                    if (!(o in r)) throw new Error(`renderer '${o}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(o)) continue;
                    let s = o, l = n.renderer[s], u = r[s];
                    r[s] = (...c)=>{
                        let p = l.apply(r, c);
                        return p === !1 && (p = u.apply(r, c)), p || "";
                    };
                }
                i.renderer = r;
            }
            if (n.tokenizer) {
                let r = this.defaults.tokenizer || new $5d395e7a24988106$export$55e8b082af4aa63e(this.defaults);
                for(let o in n.tokenizer){
                    if (!(o in r)) throw new Error(`tokenizer '${o}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(o)) continue;
                    let s = o, l = n.tokenizer[s], u = r[s];
                    r[s] = (...c)=>{
                        let p = l.apply(r, c);
                        return p === !1 && (p = u.apply(r, c)), p;
                    };
                }
                i.tokenizer = r;
            }
            if (n.hooks) {
                let r = this.defaults.hooks || new $5d395e7a24988106$export$5fbefe39e79899a6;
                for(let o in n.hooks){
                    if (!(o in r)) throw new Error(`hook '${o}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(o)) continue;
                    let s = o, l = n.hooks[s], u = r[s];
                    $5d395e7a24988106$export$5fbefe39e79899a6.passThroughHooks.has(o) ? r[s] = (c)=>{
                        if (this.defaults.async && $5d395e7a24988106$export$5fbefe39e79899a6.passThroughHooksRespectAsync.has(o)) return (async ()=>{
                            let d = await l.call(r, c);
                            return u.call(r, d);
                        })();
                        let p = l.call(r, c);
                        return u.call(r, p);
                    } : r[s] = (...c)=>{
                        if (this.defaults.async) return (async ()=>{
                            let d = await l.apply(r, c);
                            return d === !1 && (d = await u.apply(r, c)), d;
                        })();
                        let p = l.apply(r, c);
                        return p === !1 && (p = u.apply(r, c)), p;
                    };
                }
                i.hooks = r;
            }
            if (n.walkTokens) {
                let r = this.defaults.walkTokens, o = n.walkTokens;
                i.walkTokens = function(s) {
                    let l = [];
                    return l.push(o.call(this, s)), r && $5d395e7a24988106$var$C(l, r.call(this, s)), l;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...i
            };
        }), this;
    }
    setOptions(e) {
        return this.defaults = {
            ...this.defaults,
            ...e
        }, this;
    }
    lexer(e, t) {
        return $5d395e7a24988106$export$6168dc8908a6c652.lex(e, t ?? this.defaults);
    }
    parser(e, t) {
        return $5d395e7a24988106$export$7acfa6ed01010e37.parse(e, t ?? this.defaults);
    }
    parseMarkdown(e) {
        return (n, i)=>{
            let r = {
                ...i
            }, o = {
                ...this.defaults,
                ...r
            }, s = this.onError(!!o.silent, !!o.async);
            if (this.defaults.async === !0 && r.async === !1) return s(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof n > "u" || n === null) return s(new Error("marked(): input parameter is undefined or null"));
            if (typeof n != "string") return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
            if (o.hooks && (o.hooks.options = o, o.hooks.block = e), o.async) return (async ()=>{
                let l = o.hooks ? await o.hooks.preprocess(n) : n, c = await (o.hooks ? await o.hooks.provideLexer(e) : e ? $5d395e7a24988106$export$6168dc8908a6c652.lex : $5d395e7a24988106$export$6168dc8908a6c652.lexInline)(l, o), p = o.hooks ? await o.hooks.processAllTokens(c) : c;
                o.walkTokens && await Promise.all(this.walkTokens(p, o.walkTokens));
                let g = await (o.hooks ? await o.hooks.provideParser(e) : e ? $5d395e7a24988106$export$7acfa6ed01010e37.parse : $5d395e7a24988106$export$7acfa6ed01010e37.parseInline)(p, o);
                return o.hooks ? await o.hooks.postprocess(g) : g;
            })().catch(s);
            try {
                o.hooks && (n = o.hooks.preprocess(n));
                let u = (o.hooks ? o.hooks.provideLexer(e) : e ? $5d395e7a24988106$export$6168dc8908a6c652.lex : $5d395e7a24988106$export$6168dc8908a6c652.lexInline)(n, o);
                o.hooks && (u = o.hooks.processAllTokens(u)), o.walkTokens && this.walkTokens(u, o.walkTokens);
                let p = (o.hooks ? o.hooks.provideParser(e) : e ? $5d395e7a24988106$export$7acfa6ed01010e37.parse : $5d395e7a24988106$export$7acfa6ed01010e37.parseInline)(u, o);
                return o.hooks && (p = o.hooks.postprocess(p)), p;
            } catch (l) {
                return s(l);
            }
        };
    }
    onError(e, t) {
        return (n)=>{
            if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                let i = "<p>An error occurred:</p><pre>" + $5d395e7a24988106$var$w(n.message + "", !0) + "</pre>";
                return t ? Promise.resolve(i) : i;
            }
            if (t) return Promise.reject(n);
            throw n;
        };
    }
};
var $5d395e7a24988106$var$I = new $5d395e7a24988106$export$164128c95a350e30;
function $5d395e7a24988106$export$db8f131360c543a5(a, e) {
    return $5d395e7a24988106$var$I.parse(a, e);
}
$5d395e7a24988106$export$db8f131360c543a5.options = $5d395e7a24988106$export$db8f131360c543a5.setOptions = function(a) {
    return $5d395e7a24988106$var$I.setOptions(a), $5d395e7a24988106$export$db8f131360c543a5.defaults = $5d395e7a24988106$var$I.defaults, $5d395e7a24988106$var$V($5d395e7a24988106$export$db8f131360c543a5.defaults), $5d395e7a24988106$export$db8f131360c543a5;
};
$5d395e7a24988106$export$db8f131360c543a5.getDefaults = $5d395e7a24988106$export$212bb2fc580a90a8;
$5d395e7a24988106$export$db8f131360c543a5.defaults = $5d395e7a24988106$export$ebe90cb607ad99e;
function $5d395e7a24988106$export$1f96ae73734a86cc(...a) {
    return $5d395e7a24988106$var$I.use(...a), $5d395e7a24988106$export$db8f131360c543a5.defaults = $5d395e7a24988106$var$I.defaults, $5d395e7a24988106$var$V($5d395e7a24988106$export$db8f131360c543a5.defaults), $5d395e7a24988106$export$db8f131360c543a5;
}
$5d395e7a24988106$export$db8f131360c543a5.use = $5d395e7a24988106$export$1f96ae73734a86cc;
$5d395e7a24988106$export$db8f131360c543a5.walkTokens = function(a, e) {
    return $5d395e7a24988106$var$I.walkTokens(a, e);
};
$5d395e7a24988106$export$db8f131360c543a5.parseInline = $5d395e7a24988106$var$I.parseInline;
$5d395e7a24988106$export$db8f131360c543a5.Parser = $5d395e7a24988106$export$7acfa6ed01010e37;
$5d395e7a24988106$export$db8f131360c543a5.parser = $5d395e7a24988106$export$7acfa6ed01010e37.parse;
$5d395e7a24988106$export$db8f131360c543a5.Renderer = $5d395e7a24988106$export$88530751e3977073;
$5d395e7a24988106$export$db8f131360c543a5.TextRenderer = $5d395e7a24988106$export$75ebcd2c8ed5b901;
$5d395e7a24988106$export$db8f131360c543a5.Lexer = $5d395e7a24988106$export$6168dc8908a6c652;
$5d395e7a24988106$export$db8f131360c543a5.lexer = $5d395e7a24988106$export$6168dc8908a6c652.lex;
$5d395e7a24988106$export$db8f131360c543a5.Tokenizer = $5d395e7a24988106$export$55e8b082af4aa63e;
$5d395e7a24988106$export$db8f131360c543a5.Hooks = $5d395e7a24988106$export$5fbefe39e79899a6;
$5d395e7a24988106$export$db8f131360c543a5.parse = $5d395e7a24988106$export$db8f131360c543a5;
var $5d395e7a24988106$export$41c562ebe57d11e2 = $5d395e7a24988106$export$db8f131360c543a5.options, $5d395e7a24988106$export$add91eafeaeab287 = $5d395e7a24988106$export$db8f131360c543a5.setOptions, $5d395e7a24988106$export$3eedd5437d43cb76 = $5d395e7a24988106$export$db8f131360c543a5.walkTokens, $5d395e7a24988106$export$c7679c2b5e355e6f = $5d395e7a24988106$export$db8f131360c543a5.parseInline, $5d395e7a24988106$export$98e6a39c04603d36 = $5d395e7a24988106$export$db8f131360c543a5, $5d395e7a24988106$export$8f49e4af10703ce3 = $5d395e7a24988106$export$7acfa6ed01010e37.parse, $5d395e7a24988106$export$43feed32102720d2 = $5d395e7a24988106$export$6168dc8908a6c652.lex;

});

parcelRegister("5pSp9", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("6LgkD", function(module, exports) {
module.exports = import("aEty7").then(()=>parcelRequire('76ati'));

});

parcelRegister("bZCt6", function(module, exports) {
module.exports = import("bLxQU").then(()=>parcelRequire('5GFY4'));

});

parcelRegister("lHXxJ", function(module, exports) {
module.exports = import("7t2IH").then(()=>parcelRequire('e4PyM'));

});

parcelRegister("5KOBY", function(module, exports) {
module.exports = import("kl5oe").then(()=>parcelRequire('aqfuP'));

});

parcelRegister("1mxZi", function(module, exports) {
module.exports = import("fs0Ne").then(()=>parcelRequire('25sUT'));

});

parcelRegister("fZf7A", function(module, exports) {
module.exports = import("aIQpU").then(()=>parcelRequire('698gR'));

});

parcelRegister("27am3", function(module, exports) {
module.exports = import("3lrIW").then(()=>parcelRequire('iWEbW'));

});

parcelRegister("fSdtI", function(module, exports) {
module.exports = import("736uD").then(()=>parcelRequire('lV5sx'));

});

parcelRegister("1aVIr", function(module, exports) {
module.exports = import("dLjHD").then(()=>parcelRequire('8KWMF'));

});

parcelRegister("eoxIj", function(module, exports) {
module.exports = Promise.all([
    import("dLjHD"),
    import("736uD"),
    import("cOhTk")
]).then(()=>parcelRequire('22DGa'));

});

parcelRegister("kPG1T", function(module, exports) {
module.exports = import("13jPH").then(()=>parcelRequire('16CWy'));

});

parcelRegister("ggJbU", function(module, exports) {
module.exports = import("drpS3").then(()=>parcelRequire('czA5i'));

});

parcelRegister("lUBjZ", function(module, exports) {
module.exports = Promise.all([
    import("drpS3"),
    import("49AWw")
]).then(()=>parcelRequire('3h3Qy'));

});

parcelRegister("7GJ9R", function(module, exports) {
module.exports = import("eYfw5").then(()=>parcelRequire('5vGUl'));

});

parcelRegister("9rfGV", function(module, exports) {
module.exports = import("dSMb5").then(()=>parcelRequire('3MAJq'));

});

parcelRegister("gU4Jz", function(module, exports) {
module.exports = import("bAhm7").then(()=>parcelRequire('aW8Am'));

});

parcelRegister("dJFlq", function(module, exports) {
module.exports = import("cvS2S").then(()=>parcelRequire('lhmyd'));

});

parcelRegister("faMUO", function(module, exports) {
module.exports = import("b9fYs").then(()=>parcelRequire('fWxdk'));

});

parcelRegister("k5KdR", function(module, exports) {
module.exports = import("gB1Hl").then(()=>parcelRequire('6L8Im'));

});

parcelRegister("gGh8i", function(module, exports) {
module.exports = import("6aLlQ").then(()=>parcelRequire('lMcj5'));

});

parcelRegister("86sS8", function(module, exports) {
module.exports = import("eHVhg").then(()=>parcelRequire('g05YZ'));

});

parcelRegister("4pxUv", function(module, exports) {
module.exports = import("2hBIA").then(()=>parcelRequire('l3cQz'));

});

parcelRegister("a3NRb", function(module, exports) {
module.exports = import("9nPRE").then(()=>parcelRequire('aJsz4'));

});

parcelRegister("gX9Gg", function(module, exports) {
module.exports = import("61vgH").then(()=>parcelRequire('8aRER'));

});

parcelRegister("gGH96", function(module, exports) {
module.exports = import("8wSXt").then(()=>parcelRequire('expth'));

});

parcelRegister("gSh04", function(module, exports) {
module.exports = import("k8cR8").then(()=>parcelRequire('7vinc'));

});

parcelRegister("2GI8M", function(module, exports) {
module.exports = import("cFhkH").then(()=>parcelRequire('3z5WV'));

});

parcelRegister("1HfaU", function(module, exports) {
module.exports = import("efkRE").then(()=>parcelRequire('eu4PO'));

});

parcelRegister("5wufp", function(module, exports) {
module.exports = import("4VYiW").then(()=>parcelRequire('3c1ET'));

});

parcelRegister("3f3Fs", function(module, exports) {
module.exports = import("3ALOT").then(()=>parcelRequire('b4Ki1'));

});

parcelRegister("29sXE", function(module, exports) {
module.exports = import("eAghq").then(()=>parcelRequire('21EEr'));

});

parcelRegister("3V2WW", function(module, exports) {
module.exports = import("ehoi2").then(()=>parcelRequire('99tz1'));

});

parcelRegister("1kJOq", function(module, exports) {
module.exports = import("eGz7g").then(()=>parcelRequire('klOl7'));

});

parcelRegister("1drU8", function(module, exports) {
module.exports = import("ghtV3").then(()=>parcelRequire('baCT3'));

});

parcelRegister("i1SYL", function(module, exports) {
module.exports = import("mEpVp").then(()=>parcelRequire('GdRkT'));

});

parcelRegister("cNjDK", function(module, exports) {
module.exports = import("idCHS").then(()=>parcelRequire('gSbBj'));

});

parcelRegister("fqdNs", function(module, exports) {
module.exports = import("bh36F").then(()=>parcelRequire('kOdyN'));

});

parcelRegister("kJT6J", function(module, exports) {
module.exports = import("bl9nc").then(()=>parcelRequire('kxz3T'));

});

parcelRegister("10vJ2", function(module, exports) {
module.exports = import("eX8EV").then(()=>parcelRequire('8JHhk'));

});

parcelRegister("iSFNP", function(module, exports) {
module.exports = Promise.all([
    import("eX8EV"),
    import("bma7r")
]).then(()=>parcelRequire('aERtp'));

});

parcelRegister("3kaXr", function(module, exports) {
module.exports = import("diKyo").then(()=>parcelRequire('hx0zW'));

});

parcelRegister("lKRac", function(module, exports) {
module.exports = import("hbWEP").then(()=>parcelRequire('hb0VK'));

});

parcelRegister("ahzN6", function(module, exports) {
module.exports = import("7LtE1").then(()=>parcelRequire('7MYc8'));

});

parcelRegister("hjqbQ", function(module, exports) {
module.exports = import("glTHP").then(()=>parcelRequire('lIRMX'));

});

parcelRegister("b6Ce0", function(module, exports) {
module.exports = import("jhh5f").then(()=>parcelRequire('2WQ2e'));

});

parcelRegister("27l2R", function(module, exports) {
module.exports = import("3Nq9W").then(()=>parcelRequire('8o0WQ'));

});

parcelRegister("6hkJi", function(module, exports) {
module.exports = import("2vp4N").then(()=>parcelRequire('aoKo0'));

});

parcelRegister("dvGEE", function(module, exports) {
module.exports = import("2AB5n").then(()=>parcelRequire('lphvI'));

});

parcelRegister("8BmCl", function(module, exports) {
module.exports = import("dyfVm").then(()=>parcelRequire('b85rZ'));

});

parcelRegister("clodf", function(module, exports) {
module.exports = import("9PZak").then(()=>parcelRequire('6deFJ'));

});

parcelRegister("gCdMZ", function(module, exports) {
module.exports = import("4QYSs").then(()=>parcelRequire('jputT'));

});

parcelRegister("lFLGV", function(module, exports) {
module.exports = Promise.all([
    import("4QYSs"),
    import("dGdpQ")
]).then(()=>parcelRequire('bw2PM'));

});

parcelRegister("7UMUW", function(module, exports) {
module.exports = import("59Sz3").then(()=>parcelRequire('5n723'));

});

parcelRegister("42ptu", function(module, exports) {
module.exports = import("1XSvU").then(()=>parcelRequire('lNqV5'));

});

parcelRegister("cVHBX", function(module, exports) {
module.exports = import("igZXA").then(()=>parcelRequire('4aqU8'));

});

parcelRegister("9shZB", function(module, exports) {
module.exports = Promise.all([
    import("igZXA"),
    import("6fmcy")
]).then(()=>parcelRequire('k77wd'));

});

parcelRegister("ey1aZ", function(module, exports) {
/*!

JSZip v3.10.2 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $cbQCu = parcelRequire("cbQCu");
var $a97527382a103176$require$Buffer = $cbQCu.Buffer;

var $4Jj9n = parcelRequire("4Jj9n");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.2", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $a97527382a103176$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($a97527382a103176$require$Buffer.from && $a97527382a103176$require$Buffer.from !== Uint8Array.from) return $a97527382a103176$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $a97527382a103176$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($a97527382a103176$require$Buffer.alloc) return $a97527382a103176$require$Buffer.alloc(e);
                        var t = new $a97527382a103176$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $a97527382a103176$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $a97527382a103176$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $a97527382a103176$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    if ("string" == typeof e) return "string";
                    var t = Object.prototype.toString.call(e);
                    return "[object Array]" === t ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && "[object Uint8Array]" === t ? "uint8array" : o.arraybuffer && "[object ArrayBuffer]" === t ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) ? void 0 !== Blob.prototype.arrayBuffer ? n.arrayBuffer() : "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : u.Promise.reject(new Error(r + " is a Blob, but we have no way of reading it.")) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4Jj9n.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hIrjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b96e3143353309b2$export$2e2bcd8739ae039);
/*! @license DOMPurify 3.4.17 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.17/LICENSE */ function $b96e3143353309b2$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
function $b96e3143353309b2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b96e3143353309b2$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $b96e3143353309b2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b96e3143353309b2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ function $b96e3143353309b2$var$_slicedToArray(r, e) {
    return $b96e3143353309b2$var$_arrayWithHoles(r) || $b96e3143353309b2$var$_iterableToArrayLimit(r, e) || $b96e3143353309b2$var$_unsupportedIterableToArray(r, e) || $b96e3143353309b2$var$_nonIterableRest();
}
function $b96e3143353309b2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b96e3143353309b2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b96e3143353309b2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b96e3143353309b2$var$AsyncGenerator(e) {
    var t, n;
    function resume(t, n) {
        try {
            var r = e[t](n), o = r.value, u = o instanceof $b96e3143353309b2$var$_OverloadYield;
            Promise.resolve(u ? o.v : o).then(function(n) {
                if (u) {
                    var i = "return" === t && o.k ? t : "next";
                    if (!o.k || n.done) return resume(i, n);
                    n = e[i](n).value;
                }
                settle(!!r.done, n);
            }, function(e) {
                resume("throw", e);
            });
        } catch (e) {
            settle(2, e);
        }
    }
    function settle(e, r) {
        2 === e ? t.reject(r) : t.resolve({
            value: r,
            done: e
        }), (t = t.next) ? resume(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, r) {
        return new Promise(function(o, u) {
            var i = {
                key: e,
                arg: r,
                resolve: o,
                reject: u,
                next: null
            };
            n ? n = n.next = i : (t = n = i, resume(e, r));
        });
    }, "function" != typeof e.return && (this.return = void 0);
}
$b96e3143353309b2$var$AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $b96e3143353309b2$var$AsyncGenerator.prototype.next = function(e) {
    return this._invoke("next", e);
}, $b96e3143353309b2$var$AsyncGenerator.prototype.throw = function(e) {
    return this._invoke("throw", e);
}, $b96e3143353309b2$var$AsyncGenerator.prototype.return = function(e) {
    return this._invoke("return", e);
};
const $b96e3143353309b2$var$entries = Object.entries;
const $b96e3143353309b2$var$setPrototypeOf = Object.setPrototypeOf;
const $b96e3143353309b2$var$isFrozen = Object.isFrozen;
const $b96e3143353309b2$var$getPrototypeOf = Object.getPrototypeOf;
const $b96e3143353309b2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let $b96e3143353309b2$var$freeze = Object.freeze;
let $b96e3143353309b2$var$seal = Object.seal;
let $b96e3143353309b2$var$create = Object.create;
let $b96e3143353309b2$var$_ref = typeof Reflect !== "undefined" && Reflect;
let $b96e3143353309b2$var$apply = $b96e3143353309b2$var$_ref.apply;
let $b96e3143353309b2$var$construct = $b96e3143353309b2$var$_ref.construct;
if (!$b96e3143353309b2$var$freeze) $b96e3143353309b2$var$freeze = function freeze(x) {
    return x;
};
if (!$b96e3143353309b2$var$seal) $b96e3143353309b2$var$seal = function seal(x) {
    return x;
};
if (!$b96e3143353309b2$var$apply) $b96e3143353309b2$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$b96e3143353309b2$var$construct) $b96e3143353309b2$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $b96e3143353309b2$var$arrayForEach = $b96e3143353309b2$var$unapply(Array.prototype.forEach);
Array.prototype.indexOf;
const $b96e3143353309b2$var$arrayLastIndexOf = $b96e3143353309b2$var$unapply(Array.prototype.lastIndexOf);
const $b96e3143353309b2$var$arrayPop = $b96e3143353309b2$var$unapply(Array.prototype.pop);
const $b96e3143353309b2$var$arrayPush = $b96e3143353309b2$var$unapply(Array.prototype.push);
const $b96e3143353309b2$var$arraySlice = $b96e3143353309b2$var$unapply(Array.prototype.slice);
const $b96e3143353309b2$var$arraySplice = $b96e3143353309b2$var$unapply(Array.prototype.splice);
const $b96e3143353309b2$var$arrayIsArray = Array.isArray;
const $b96e3143353309b2$var$setCreate = $b96e3143353309b2$var$unconstruct(Set);
const $b96e3143353309b2$var$setAdd = $b96e3143353309b2$var$unapply(Set.prototype.add);
const $b96e3143353309b2$var$setHas = $b96e3143353309b2$var$unapply(Set.prototype.has);
const $b96e3143353309b2$var$stringToLowerCase = $b96e3143353309b2$var$unapply(String.prototype.toLowerCase);
const $b96e3143353309b2$var$stringToString = $b96e3143353309b2$var$unapply(String.prototype.toString);
const $b96e3143353309b2$var$stringMatch = $b96e3143353309b2$var$unapply(String.prototype.match);
const $b96e3143353309b2$var$stringReplace = $b96e3143353309b2$var$unapply(String.prototype.replace);
const $b96e3143353309b2$var$stringIndexOf = $b96e3143353309b2$var$unapply(String.prototype.indexOf);
const $b96e3143353309b2$var$stringTrim = $b96e3143353309b2$var$unapply(String.prototype.trim);
const $b96e3143353309b2$var$numberToString = $b96e3143353309b2$var$unapply(Number.prototype.toString);
const $b96e3143353309b2$var$booleanToString = $b96e3143353309b2$var$unapply(Boolean.prototype.toString);
const $b96e3143353309b2$var$bigintToString = typeof BigInt === "undefined" ? null : $b96e3143353309b2$var$unapply(BigInt.prototype.toString);
const $b96e3143353309b2$var$symbolToString = typeof Symbol === "undefined" ? null : $b96e3143353309b2$var$unapply(Symbol.prototype.toString);
const $b96e3143353309b2$var$objectHasOwnProperty = $b96e3143353309b2$var$unapply(Object.prototype.hasOwnProperty);
const $b96e3143353309b2$var$objectToString = $b96e3143353309b2$var$unapply(Object.prototype.toString);
const $b96e3143353309b2$var$regExpTest = $b96e3143353309b2$var$unapply(RegExp.prototype.test);
const $b96e3143353309b2$var$typeErrorCreate = $b96e3143353309b2$var$unconstruct(TypeError);
/**
* Creates a new function that calls the given function with a specified thisArg and arguments.
*
* @param func - The function to be wrapped and called.
* @returns A new function that calls the given function with a specified thisArg and arguments.
*/ function $b96e3143353309b2$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $b96e3143353309b2$var$apply(func, thisArg, args);
    };
}
/**
* Creates a new function that constructs an instance of the given constructor function with the provided arguments.
*
* @param func - The constructor function to be wrapped and called.
* @returns A new function that constructs an instance of the given constructor function with the provided arguments.
*/ function $b96e3143353309b2$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $b96e3143353309b2$var$construct(Func, args);
    };
}
/**
* Add properties to a lookup table
*
* @param set - The set to which elements will be added.
* @param array - The array containing elements to be added to the set.
* @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
* @returns The modified set with added elements.
*/ function $b96e3143353309b2$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b96e3143353309b2$var$stringToLowerCase;
    if ($b96e3143353309b2$var$setPrototypeOf) $b96e3143353309b2$var$setPrototypeOf(set, null);
    if (!$b96e3143353309b2$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === "string") {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                if (!$b96e3143353309b2$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
* Clean up an array to harden against CSPP
*
* @param array - The array to be cleaned.
* @returns The cleaned version of the array
*/ function $b96e3143353309b2$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++)if (!$b96e3143353309b2$var$objectHasOwnProperty(array, index)) array[index] = null;
    return array;
}
/**
* Shallow clone an object
*
* @param object - The object to be cloned.
* @returns A new object that copies the original.
*/ function $b96e3143353309b2$var$clone(object) {
    const newObject = $b96e3143353309b2$var$create(null);
    for (const _ref2 of $b96e3143353309b2$var$entries(object)){
        var _ref3 = $b96e3143353309b2$var$_slicedToArray(_ref2, 2);
        const property = _ref3[0];
        const value = _ref3[1];
        if ($b96e3143353309b2$var$objectHasOwnProperty(object, property)) {
            if ($b96e3143353309b2$var$arrayIsArray(value)) newObject[property] = $b96e3143353309b2$var$cleanArray(value);
            else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = $b96e3143353309b2$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
* Convert non-node values into strings without depending on direct property access.
*
* @param value - The value to stringify.
* @returns A string representation of the provided value.
*/ function $b96e3143353309b2$var$stringifyValue(value) {
    switch(typeof value){
        case "string":
            return value;
        case "number":
            return $b96e3143353309b2$var$numberToString(value);
        case "boolean":
            return $b96e3143353309b2$var$booleanToString(value);
        case "bigint":
            return $b96e3143353309b2$var$bigintToString ? $b96e3143353309b2$var$bigintToString(value) : "0";
        case "symbol":
            return $b96e3143353309b2$var$symbolToString ? $b96e3143353309b2$var$symbolToString(value) : "Symbol()";
        case "undefined":
            return $b96e3143353309b2$var$objectToString(value);
        case "function":
        case "object":
            {
                if (value === null) return $b96e3143353309b2$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $b96e3143353309b2$var$lookupGetter(valueAsRecord, "toString");
                if (typeof valueToString === "function") {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === "string" ? stringified : $b96e3143353309b2$var$objectToString(stringified);
                }
                return $b96e3143353309b2$var$objectToString(value);
            }
        default:
            return $b96e3143353309b2$var$objectToString(value);
    }
}
/**
* This method automatically checks if the prop is function or getter and behaves accordingly.
*
* @param object - The object to look up the getter function in its prototype chain.
* @param prop - The property name for which to find the getter function.
* @returns The getter function found in the prototype chain or a fallback function.
*/ function $b96e3143353309b2$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $b96e3143353309b2$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $b96e3143353309b2$var$unapply(desc.get);
            if (typeof desc.value === "function") return $b96e3143353309b2$var$unapply(desc.value);
        }
        object = $b96e3143353309b2$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
/**
* Like lookupGetter, but for accessor properties only, and returns null
* instead of a null-returning fallback when no getter exists on the chain.
* Lets a caller fall back to a direct property read in environments that
* lack the getter, where a fallback returning null would be indistinguishable
* from a legitimate null value (e.g. namespaceURI of a no-namespace element).
*
* @param object - The object (usually a prototype) to start the lookup at.
* @param prop - The accessor property name.
* @returns The unapplied getter, or null if none was found.
*/ function $b96e3143353309b2$var$lookupAccessor(object, prop) {
    while(object !== null){
        const desc = $b96e3143353309b2$var$getOwnPropertyDescriptor(object, prop);
        if (desc) return desc.get ? $b96e3143353309b2$var$unapply(desc.get) : null;
        object = $b96e3143353309b2$var$getPrototypeOf(object);
    }
    return null;
}
function $b96e3143353309b2$var$isRegex(value) {
    try {
        $b96e3143353309b2$var$regExpTest(value, "");
        return true;
    } catch (_unused) {
        return false;
    }
}
const $b96e3143353309b2$var$html$1 = $b96e3143353309b2$var$freeze([
    "a",
    "abbr",
    "acronym",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "decorator",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "element",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meter",
    "nav",
    "nobr",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
]);
const $b96e3143353309b2$var$svg$1 = $b96e3143353309b2$var$freeze([
    "svg",
    "a",
    "altglyph",
    "altglyphdef",
    "altglyphitem",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "circle",
    "clippath",
    "defs",
    "desc",
    "ellipse",
    "enterkeyhint",
    "exportparts",
    "filter",
    "font",
    "g",
    "glyph",
    "glyphref",
    "hkern",
    "image",
    "inputmode",
    "line",
    "lineargradient",
    "marker",
    "mask",
    "metadata",
    "mpath",
    "part",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialgradient",
    "rect",
    "stop",
    "style",
    "switch",
    "symbol",
    "text",
    "textpath",
    "title",
    "tref",
    "tspan",
    "view",
    "vkern"
]);
const $b96e3143353309b2$var$svgFilters = $b96e3143353309b2$var$freeze([
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence"
]);
const $b96e3143353309b2$var$svgDisallowed = $b96e3143353309b2$var$freeze([
    "animate",
    "color-profile",
    "cursor",
    "discard",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignobject",
    "hatch",
    "hatchpath",
    "mesh",
    "meshgradient",
    "meshpatch",
    "meshrow",
    "missing-glyph",
    "script",
    "set",
    "solidcolor",
    "unknown",
    "use"
]);
const $b96e3143353309b2$var$mathMl$1 = $b96e3143353309b2$var$freeze([
    "math",
    "menclose",
    "merror",
    "mfenced",
    "mfrac",
    "mglyph",
    "mi",
    "mlabeledtr",
    "mmultiscripts",
    "mn",
    "mo",
    "mover",
    "mpadded",
    "mphantom",
    "mroot",
    "mrow",
    "ms",
    "mspace",
    "msqrt",
    "mstyle",
    "msub",
    "msup",
    "msubsup",
    "mtable",
    "mtd",
    "mtext",
    "mtr",
    "munder",
    "munderover",
    "mprescripts"
]);
const $b96e3143353309b2$var$mathMlDisallowed = $b96e3143353309b2$var$freeze([
    "maction",
    "maligngroup",
    "malignmark",
    "mlongdiv",
    "mscarries",
    "mscarry",
    "msgroup",
    "mstack",
    "msline",
    "msrow",
    "semantics",
    "annotation",
    "annotation-xml",
    "mprescripts",
    "none"
]);
const $b96e3143353309b2$var$text = $b96e3143353309b2$var$freeze([
    "#text"
]);
const $b96e3143353309b2$var$html = $b96e3143353309b2$var$freeze([
    "accept",
    "action",
    "align",
    "alt",
    "autocapitalize",
    "autocomplete",
    "autopictureinpicture",
    "autoplay",
    "background",
    "bgcolor",
    "border",
    "capture",
    "cellpadding",
    "cellspacing",
    "checked",
    "cite",
    "class",
    "clear",
    "color",
    "cols",
    "colspan",
    "command",
    "commandfor",
    "controls",
    "controlslist",
    "coords",
    "crossorigin",
    "datetime",
    "decoding",
    "default",
    "dir",
    "disabled",
    "disablepictureinpicture",
    "disableremoteplayback",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "exportparts",
    "face",
    "for",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "id",
    "inert",
    "inputmode",
    "integrity",
    "ismap",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "loop",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "multiple",
    "muted",
    "name",
    "nonce",
    "noshade",
    "novalidate",
    "nowrap",
    "open",
    "optimum",
    "part",
    "pattern",
    "placeholder",
    "playsinline",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "pubdate",
    "radiogroup",
    "readonly",
    "rel",
    "required",
    "rev",
    "reversed",
    "role",
    "rows",
    "rowspan",
    "spellcheck",
    "scope",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "srclang",
    "start",
    "src",
    "srcset",
    "step",
    "style",
    "summary",
    "tabindex",
    "title",
    "translate",
    "type",
    "usemap",
    "valign",
    "value",
    "width",
    "wrap",
    "xmlns"
]);
const $b96e3143353309b2$var$svg = $b96e3143353309b2$var$freeze([
    "accent-height",
    "accumulate",
    "additive",
    "alignment-baseline",
    "amplitude",
    "ascent",
    "attributename",
    "attributetype",
    "azimuth",
    "basefrequency",
    "baseline-shift",
    "begin",
    "bias",
    "by",
    "class",
    "clip",
    "clippathunits",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "cx",
    "cy",
    "d",
    "dx",
    "dy",
    "diffuseconstant",
    "direction",
    "display",
    "divisor",
    "dominant-baseline",
    "dur",
    "edgemode",
    "elevation",
    "end",
    "exponent",
    "fill",
    "fill-opacity",
    "fill-rule",
    "filter",
    "filterunits",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyph-name",
    "glyphref",
    "gradientunits",
    "gradienttransform",
    "height",
    "href",
    "id",
    "image-rendering",
    "in",
    "in2",
    "intercept",
    "k",
    "k1",
    "k2",
    "k3",
    "k4",
    "kerning",
    "keypoints",
    "keysplines",
    "keytimes",
    "lang",
    "lengthadjust",
    "letter-spacing",
    "kernelmatrix",
    "kernelunitlength",
    "lighting-color",
    "local",
    "marker-end",
    "marker-mid",
    "marker-start",
    "markerheight",
    "markerunits",
    "markerwidth",
    "maskcontentunits",
    "maskunits",
    "max",
    "mask",
    "mask-type",
    "media",
    "method",
    "mode",
    "min",
    "name",
    "numoctaves",
    "offset",
    "operator",
    "opacity",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "paint-order",
    "path",
    "pathlength",
    "patterncontentunits",
    "patterntransform",
    "patternunits",
    "pointer-events",
    "points",
    "preservealpha",
    "preserveaspectratio",
    "primitiveunits",
    "r",
    "rx",
    "ry",
    "radius",
    "refx",
    "refy",
    "repeatcount",
    "repeatdur",
    "restart",
    "result",
    "rotate",
    "scale",
    "seed",
    "shape-rendering",
    "slope",
    "specularconstant",
    "specularexponent",
    "spreadmethod",
    "startoffset",
    "stddeviation",
    "stitchtiles",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke",
    "stroke-width",
    "style",
    "surfacescale",
    "systemlanguage",
    "tabindex",
    "tablevalues",
    "targetx",
    "targety",
    "transform",
    "transform-origin",
    "text-anchor",
    "text-decoration",
    "text-orientation",
    "text-rendering",
    "textlength",
    "type",
    "u1",
    "u2",
    "unicode",
    "values",
    "vector-effect",
    "viewbox",
    "visibility",
    "version",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "width",
    "word-spacing",
    "wrap",
    "writing-mode",
    "xchannelselector",
    "ychannelselector",
    "x",
    "x1",
    "x2",
    "xmlns",
    "y",
    "y1",
    "y2",
    "z",
    "zoomandpan"
]);
const $b96e3143353309b2$var$mathMl = $b96e3143353309b2$var$freeze([
    "accent",
    "accentunder",
    "align",
    "bevelled",
    "close",
    "columnalign",
    "columnlines",
    "columnspacing",
    "columnspan",
    "denomalign",
    "depth",
    "dir",
    "display",
    "displaystyle",
    "encoding",
    "fence",
    "frame",
    "height",
    "href",
    "id",
    "largeop",
    "length",
    "linethickness",
    "lquote",
    "lspace",
    "mathbackground",
    "mathcolor",
    "mathsize",
    "mathvariant",
    "maxsize",
    "minsize",
    "movablelimits",
    "notation",
    "numalign",
    "open",
    "rowalign",
    "rowlines",
    "rowspacing",
    "rowspan",
    "rspace",
    "rquote",
    "scriptlevel",
    "scriptminsize",
    "scriptsizemultiplier",
    "selection",
    "separator",
    "separators",
    "stretchy",
    "subscriptshift",
    "supscriptshift",
    "symmetric",
    "voffset",
    "width",
    "xmlns"
]);
const $b96e3143353309b2$var$xml = $b96e3143353309b2$var$freeze([
    "xlink:href",
    "xml:id",
    "xlink:title",
    "xml:space",
    "xmlns:xlink"
]);
const $b96e3143353309b2$var$MUSTACHE_EXPR = $b96e3143353309b2$var$seal(/{{[\w\W]*|^[\w\W]*}}/g);
const $b96e3143353309b2$var$ERB_EXPR = $b96e3143353309b2$var$seal(/<%[\w\W]*|^[\w\W]*%>/g);
const $b96e3143353309b2$var$TMPLIT_EXPR = $b96e3143353309b2$var$seal(/\${[\w\W]*/g);
const $b96e3143353309b2$var$DATA_ATTR = $b96e3143353309b2$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
const $b96e3143353309b2$var$ARIA_ATTR = $b96e3143353309b2$var$seal(/^aria-[\-\w]+$/);
const $b96e3143353309b2$var$IS_ALLOWED_URI = $b96e3143353309b2$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
const $b96e3143353309b2$var$IS_SCRIPT_OR_DATA = $b96e3143353309b2$var$seal(/^(?:\w+script|data):/i);
const $b96e3143353309b2$var$ATTR_WHITESPACE = $b96e3143353309b2$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
const $b96e3143353309b2$var$DOCTYPE_NAME = $b96e3143353309b2$var$seal(/^html$/i);
const $b96e3143353309b2$var$CUSTOM_ELEMENT = $b96e3143353309b2$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
const $b96e3143353309b2$var$ELEMENT_MARKUP_PROBE = $b96e3143353309b2$var$seal(/<[/\w!]/g);
const $b96e3143353309b2$var$COMMENT_MARKUP_PROBE = $b96e3143353309b2$var$seal(/<[/\w]/g);
const $b96e3143353309b2$var$FALLBACK_TAG_CLOSE = $b96e3143353309b2$var$seal(/<\/no(script|embed|frames)/i);
const $b96e3143353309b2$var$SELF_CLOSING_TAG = $b96e3143353309b2$var$seal(/\/>/i);
const $b96e3143353309b2$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    entityNode: 6,
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12
};
const $b96e3143353309b2$var$LITERAL_TEXT_ELEMENTS = $b96e3143353309b2$var$freeze($b96e3143353309b2$var$addToSet({}, [
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]));
const $b96e3143353309b2$var$getGlobal = function getGlobal() {
    return typeof window === "undefined" ? null : window;
};
/**
* Creates a no-op policy for internal use only.
* Don't export this function outside this module!
* @param trustedTypes The policy factory.
* @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
* @return The policy created (or null, if Trusted Types
* are not supported or creating the policy failed).
*/ const $b96e3143353309b2$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
    let suffix = null;
    const ATTR_NAME = "data-tt-policy-suffix";
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = "dompurify" + (suffix ? "#" + suffix : "");
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        console.warn("TrustedTypes policy " + policyName + " could not be created.");
        return null;
    }
};
const $b96e3143353309b2$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
/**
* Resolve a set-valued configuration option: a fresh set built from
* cfg[key] when it is an own array property (seeded with a clone of
* options.base when given, case-normalized via options.transform),
* the fallback set otherwise.
*
* @param cfg the cloned, prototype-free configuration object
* @param key the configuration property to read
* @param fallback the set to use when the option is absent or not an array
* @param options transform and optional base set to merge into
* @returns the resolved set
*/ const $b96e3143353309b2$var$_resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
    return $b96e3143353309b2$var$objectHasOwnProperty(cfg, key) && $b96e3143353309b2$var$arrayIsArray(cfg[key]) ? $b96e3143353309b2$var$addToSet(options.base ? $b96e3143353309b2$var$clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
/**
* Resolve an object-valued configuration option: a prototype-free clone
* of cfg[key] when it is an own, truthy object property, else a fresh
* fallback built by makeFallback (fresh on every parse, so a previous
* parse can never leak state into the next one).
*
* @param cfg the cloned, prototype-free configuration object
* @param key the configuration property to read
* @param makeFallback builds the fallback value when the option is absent
* @returns the resolved object
*/ const $b96e3143353309b2$var$_resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
    const value = $b96e3143353309b2$var$objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
    return value && typeof value === "object" ? $b96e3143353309b2$var$clone(value) : makeFallback();
};
function $b96e3143353309b2$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $b96e3143353309b2$var$getGlobal();
    const DOMPurify = (root)=>$b96e3143353309b2$var$createDOMPurify(root);
    DOMPurify.version = "3.4.17";
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $b96e3143353309b2$var$NODE_TYPE.document || !window1.Element) {
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let document = window1.document;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    window1.DocumentFragment;
    const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter;
    window1.NamedNodeMap === void 0 && (window1.NamedNodeMap || window1.MozNamedAttrMap);
    window1.HTMLFormElement;
    const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "cloneNode");
    const remove = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "remove");
    const removeAttributeNode = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "removeAttributeNode");
    const getNextSibling = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "nextSibling");
    const getChildNodes = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "childNodes");
    const getParentNode = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "parentNode");
    const getShadowRoot = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "shadowRoot");
    const getAttributes = $b96e3143353309b2$var$lookupGetter(ElementPrototype, "attributes");
    const getNodeType = Node && Node.prototype ? $b96e3143353309b2$var$lookupGetter(Node.prototype, "nodeType") : null;
    const getNodeName = Node && Node.prototype ? $b96e3143353309b2$var$lookupGetter(Node.prototype, "nodeName") : null;
    const getOwnerDocument = Node && Node.prototype ? $b96e3143353309b2$var$lookupGetter(Node.prototype, "ownerDocument") : null;
    const _readNodeType = function _readNodeType(node) {
        return getNodeType ? getNodeType(node) : node.nodeType;
    };
    const _readNodeName = function _readNodeName(node) {
        return getNodeName ? getNodeName(node) : node.nodeName;
    };
    const getNamespaceURI = $b96e3143353309b2$var$lookupAccessor(ElementPrototype, "namespaceURI");
    const _readNamespaceURI = function _readNamespaceURI(element) {
        return getNamespaceURI ? getNamespaceURI(element) : element.namespaceURI;
    };
    if (typeof HTMLTemplateElement === "function") {
        const template = document.createElement("template");
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = "";
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
        if (IN_TRUSTED_TYPES_POLICY > 0) throw $b96e3143353309b2$var$typeErrorCreate("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
    };
    const _createTrustedHTML = function _createTrustedHTML(html) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createHTML(html);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createScriptURL(scriptUrl);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
        if (!defaultTrustedTypesPolicyResolved) {
            defaultTrustedTypesPolicy = $b96e3143353309b2$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            defaultTrustedTypesPolicyResolved = true;
        }
        return defaultTrustedTypesPolicy;
    };
    const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = $b96e3143353309b2$var$_createHooksMap();
    /**
	* Expose whether this browser supports running the full DOMPurify.
	*/ DOMPurify.isSupported = typeof $b96e3143353309b2$var$entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
    const MUSTACHE_EXPR$1 = $b96e3143353309b2$var$MUSTACHE_EXPR, ERB_EXPR$1 = $b96e3143353309b2$var$ERB_EXPR, TMPLIT_EXPR$1 = $b96e3143353309b2$var$TMPLIT_EXPR, DATA_ATTR$1 = $b96e3143353309b2$var$DATA_ATTR, ARIA_ATTR$1 = $b96e3143353309b2$var$ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = $b96e3143353309b2$var$IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = $b96e3143353309b2$var$ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = $b96e3143353309b2$var$CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = $b96e3143353309b2$var$IS_ALLOWED_URI;
    /**
	* We consider the elements and attributes below to be safe. Ideally
	* don't add any new ones but feel free to remove unwanted ones.
	*/ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $b96e3143353309b2$var$addToSet({}, [
        ...$b96e3143353309b2$var$html$1,
        ...$b96e3143353309b2$var$svg$1,
        ...$b96e3143353309b2$var$svgFilters,
        ...$b96e3143353309b2$var$mathMl$1,
        ...$b96e3143353309b2$var$text
    ]);
    let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $b96e3143353309b2$var$addToSet({}, [
        ...$b96e3143353309b2$var$html,
        ...$b96e3143353309b2$var$svg,
        ...$b96e3143353309b2$var$mathMl,
        ...$b96e3143353309b2$var$xml
    ]);
    let CUSTOM_ELEMENT_HANDLING = Object.seal($b96e3143353309b2$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    let FORBID_TAGS = null;
    let FORBID_ATTR = null;
    const EXTRA_ELEMENT_HANDLING = Object.seal($b96e3143353309b2$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    let ALLOW_ARIA_ATTR = true;
    let ALLOW_DATA_ATTR = true;
    let ALLOW_UNKNOWN_PROTOCOLS = false;
    let ALLOW_SELF_CLOSE_IN_ATTR = true;
    let SAFE_FOR_TEMPLATES = false;
    let SAFE_FOR_XML = true;
    let WHOLE_DOCUMENT = false;
    let SET_CONFIG = false;
    let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    let FORCE_BODY = false;
    let RETURN_DOM = false;
    let RETURN_DOM_FRAGMENT = false;
    let RETURN_TRUSTED_TYPE = false;
    let SANITIZE_DOM = true;
    let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
    let KEEP_CONTENT = true;
    let IN_PLACE = false;
    let IN_PLACE_VISITED = null;
    let USE_PROFILES = {};
    let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $b96e3143353309b2$var$addToSet({}, [
        "annotation-xml",
        "audio",
        "colgroup",
        "desc",
        "foreignobject",
        "head",
        "iframe",
        "math",
        "mi",
        "mn",
        "mo",
        "ms",
        "mtext",
        "noembed",
        "noframes",
        "noscript",
        "plaintext",
        "script",
        "selectedcontent",
        "style",
        "svg",
        "template",
        "thead",
        "title",
        "video",
        "xmp"
    ]);
    let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $b96e3143353309b2$var$addToSet({}, [
        "audio",
        "video",
        "img",
        "source",
        "image",
        "track"
    ]);
    let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $b96e3143353309b2$var$addToSet({}, [
        "alt",
        "class",
        "for",
        "id",
        "label",
        "name",
        "pattern",
        "placeholder",
        "role",
        "summary",
        "title",
        "value",
        "style",
        "xmlns"
    ]);
    const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $b96e3143353309b2$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $b96e3143353309b2$var$stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = $b96e3143353309b2$var$freeze([
        "mi",
        "mo",
        "mn",
        "ms",
        "mtext"
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = $b96e3143353309b2$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = $b96e3143353309b2$var$freeze([
        "annotation-xml"
    ]);
    let HTML_INTEGRATION_POINTS = $b96e3143353309b2$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    const COMMON_SVG_AND_HTML_ELEMENTS = $b96e3143353309b2$var$addToSet({}, [
        "title",
        "style",
        "font",
        "a",
        "script"
    ]);
    let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        "application/xhtml+xml",
        "text/html"
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
    let transformCaseFunc = null;
    let CONFIG = null;
    const formElement = document.createElement("form");
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
	* _parseConfig
	*
	* @param cfg optional config literal
	*/ const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        if (!cfg || typeof cfg !== "object") cfg = {};
        cfg = $b96e3143353309b2$var$clone(cfg);
        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? $b96e3143353309b2$var$stringToString : $b96e3143353309b2$var$stringToLowerCase;
        ALLOWED_TAGS = $b96e3143353309b2$var$_resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, {
            transform: transformCaseFunc
        });
        ALLOWED_ATTR = $b96e3143353309b2$var$_resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, {
            transform: transformCaseFunc
        });
        ALLOWED_NAMESPACES = $b96e3143353309b2$var$_resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, {
            transform: $b96e3143353309b2$var$stringToString
        });
        URI_SAFE_ATTRIBUTES = $b96e3143353309b2$var$_resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
            transform: transformCaseFunc,
            base: DEFAULT_URI_SAFE_ATTRIBUTES
        });
        DATA_URI_TAGS = $b96e3143353309b2$var$_resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
            transform: transformCaseFunc,
            base: DEFAULT_DATA_URI_TAGS
        });
        FORBID_CONTENTS = $b96e3143353309b2$var$_resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, {
            transform: transformCaseFunc
        });
        FORBID_TAGS = $b96e3143353309b2$var$_resolveSetOption(cfg, "FORBID_TAGS", $b96e3143353309b2$var$clone({}), {
            transform: transformCaseFunc
        });
        FORBID_ATTR = $b96e3143353309b2$var$_resolveSetOption(cfg, "FORBID_ATTR", $b96e3143353309b2$var$clone({}), {
            transform: transformCaseFunc
        });
        USE_PROFILES = $b96e3143353309b2$var$objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? $b96e3143353309b2$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
        RETURN_DOM = cfg.RETURN_DOM || false;
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
        FORCE_BODY = cfg.FORCE_BODY || false;
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
        IN_PLACE = cfg.IN_PLACE || false;
        IS_ALLOWED_URI$1 = $b96e3143353309b2$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $b96e3143353309b2$var$IS_ALLOWED_URI;
        NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
        MATHML_TEXT_INTEGRATION_POINTS = $b96e3143353309b2$var$_resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", ()=>$b96e3143353309b2$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
        HTML_INTEGRATION_POINTS = $b96e3143353309b2$var$_resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", ()=>$b96e3143353309b2$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
        const customElementHandling = $b96e3143353309b2$var$_resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", ()=>$b96e3143353309b2$var$create(null));
        CUSTOM_ELEMENT_HANDLING = $b96e3143353309b2$var$create(null);
        if ($b96e3143353309b2$var$objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
        if ($b96e3143353309b2$var$objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
        if ($b96e3143353309b2$var$objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
        $b96e3143353309b2$var$seal(CUSTOM_ELEMENT_HANDLING);
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        if (USE_PROFILES) {
            ALLOWED_TAGS = $b96e3143353309b2$var$addToSet({}, $b96e3143353309b2$var$text);
            ALLOWED_ATTR = $b96e3143353309b2$var$create(null);
            if (USE_PROFILES.html === true) {
                $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, $b96e3143353309b2$var$html$1);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, $b96e3143353309b2$var$svg$1);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$svg);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, $b96e3143353309b2$var$svgFilters);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$svg);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, $b96e3143353309b2$var$mathMl$1);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$mathMl);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, $b96e3143353309b2$var$xml);
            }
        }
        EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        if ($b96e3143353309b2$var$objectHasOwnProperty(cfg, "ADD_TAGS")) {
            if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($b96e3143353309b2$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $b96e3143353309b2$var$clone(ALLOWED_TAGS);
                $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($b96e3143353309b2$var$objectHasOwnProperty(cfg, "ADD_ATTR")) {
            if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($b96e3143353309b2$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $b96e3143353309b2$var$clone(ALLOWED_ATTR);
                $b96e3143353309b2$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($b96e3143353309b2$var$objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && $b96e3143353309b2$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $b96e3143353309b2$var$clone(FORBID_CONTENTS);
            $b96e3143353309b2$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
        if (WHOLE_DOCUMENT) $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, [
            "html",
            "head",
            "body"
        ]);
        if (ALLOWED_TAGS.table) {
            $b96e3143353309b2$var$addToSet(ALLOWED_TAGS, [
                "tbody"
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw $b96e3143353309b2$var$typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw $b96e3143353309b2$var$typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
            const previousTrustedTypesPolicy = trustedTypesPolicy;
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            try {
                emptyHTML = _createTrustedHTML("");
            } catch (error) {
                trustedTypesPolicy = previousTrustedTypesPolicy;
                throw error;
            }
        } else if (cfg.TRUSTED_TYPES_POLICY === null) {
            trustedTypesPolicy = void 0;
            emptyHTML = "";
        } else {
            if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
            if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
        }
        if ($b96e3143353309b2$var$freeze) $b96e3143353309b2$var$freeze(cfg);
        CONFIG = cfg;
    };
    const ALL_SVG_TAGS = $b96e3143353309b2$var$addToSet({}, [
        ...$b96e3143353309b2$var$svg$1,
        ...$b96e3143353309b2$var$svgFilters,
        ...$b96e3143353309b2$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $b96e3143353309b2$var$addToSet({}, [
        ...$b96e3143353309b2$var$mathMl$1,
        ...$b96e3143353309b2$var$mathMlDisallowed
    ]);
    /**
	* Namespace rules for an element in the SVG namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
        if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        return Boolean(ALL_SVG_TAGS[tagName]);
    };
    /**
	* Namespace rules for an element in the MathML namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
        if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
        return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    /**
	* Namespace rules for an element in the HTML namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    /**
	* @param element a DOM element whose namespace is being checked
	* @returns Return false if the element has a
	*  namespace that a spec-compliant parser would never
	*  return. Return true otherwise.
	*/ const _checkValidNamespace = function _checkValidNamespace(element) {
        const elementNamespace = _readNamespaceURI(element);
        const tagName = $b96e3143353309b2$var$stringToLowerCase(_readNodeName(element));
        const parentNode = getParentNode(element);
        let parent;
        let parentTagName;
        if (parentNode && _readNodeType(parentNode) === $b96e3143353309b2$var$NODE_TYPE.element) {
            parent = {
                namespaceURI: _readNamespaceURI(parentNode)
            };
            parentTagName = $b96e3143353309b2$var$stringToLowerCase(_readNodeName(parentNode));
        } else {
            parent = {
                namespaceURI: NAMESPACE
            };
            parentTagName = "template";
        }
        if (!ALLOWED_NAMESPACES[elementNamespace]) return false;
        if (elementNamespace === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
        if (elementNamespace === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
        if (elementNamespace === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
        if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[elementNamespace]) return true;
        return false;
    };
    /**
	* _forceRemove
	*
	* @param node a DOM node
	*/ const _forceRemove = function _forceRemove(node) {
        $b96e3143353309b2$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            getParentNode(node).removeChild(node);
        } catch (_) {
            remove(node);
            if (!getParentNode(node)) throw $b96e3143353309b2$var$typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
        }
    };
    /**
	* _stripAttributeNode
	*
	* Remove a single Attr node case/namespace-exactly on an attribute-teardown
	* path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
	* HTML element in an HTML document and so silently misses a case-preserved
	* handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
	* _removeAttribute() was fixed for, which a name-based call would reintroduce
	* on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
	* record into DOMPurify.removed: the neutralize passes intentionally do not
	* book-keep. A clobbered/detached node falls back to best-effort name-based
	* removal.
	*
	* @param element the element to strip the attribute from
	* @param attribute the Attr node to remove
	* @param name the attribute's name, for the fallback path
	*/ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
        try {
            removeAttributeNode(element, attribute);
        } catch (_) {
            try {
                element.removeAttribute(name);
            } catch (_) {}
        }
    };
    /**
	* Fail-closed teardown of an in-place root: strip every disallowed attribute
	* in the subtree first, so nothing armed is left behind, then remove all
	* children and the root's own attributes.
	*
	* @param root the in-place root to empty
	*/ const _neutralizeRoot = function _neutralizeRoot(root) {
        _neutralizeSubtree(root);
        const childNodes = getChildNodes(root);
        if (childNodes) $b96e3143353309b2$var$arrayForEach($b96e3143353309b2$var$arraySlice(childNodes), (child)=>{
            try {
                remove(child);
            } catch (_) {}
        });
        const attributes = _readNodeType(root) === $b96e3143353309b2$var$NODE_TYPE.element ? getAttributes(root) : null;
        if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name === "string") _stripAttributeNode(root, attribute, name);
        }
    };
    /**
	* Removes an attribute, preferably as its exact Attr node: name-based
	* removal lowercases the name in HTML documents and misses case-preserved
	* names, e.g. from imported XHTML.
	*
	* @param name an Attribute name
	* @param element a DOM node
	* @param attr the exact Attr node to remove, when the caller has it
	*/ const _removeAttribute = function _removeAttribute(name, element, attr) {
        if (!attr) try {
            attr = element.getAttributeNode(name);
        } catch (_) {
            attr = null;
        }
        $b96e3143353309b2$var$arrayPush(DOMPurify.removed, {
            attribute: attr || null,
            from: element
        });
        try {
            if (attr) removeAttributeNode(element, attr);
            else element.removeAttribute(name);
        } catch (_) {
            try {
                element.removeAttribute(name);
            } catch (_) {}
        }
        if (name === "is") {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, "");
            } catch (_) {}
        }
    };
    /**
	* Removes every attribute the configuration does not allow. Used to
	* neutralize nodes discarded from an in-place tree.
	*
	* @param element the element to strip
	*/ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
        const attributes = getAttributes(element);
        if (!attributes) return;
        for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
            _stripAttributeNode(element, attribute, name);
        }
    };
    /**
	* Iterative depth-first walk, so deep trees cannot overflow the call stack,
	* reading through the cached getters, so clobbering cannot hide children.
	* When `visit` returns false, the node's children are skipped. With
	* `intoShadow`, open shadow roots are walked after their host's children.
	*
	* @param root where to start
	* @param visit called for every node
	* @param intoShadow whether to enter open shadow roots
	*/ const _walkTree = function _walkTree(root, visit) {
        let intoShadow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            if (visit(node) === false) continue;
            if (intoShadow && _readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.element) {
                const shadowRoot = getShadowRoot(node);
                if (_isDocumentFragment(shadowRoot)) stack.push(shadowRoot);
            }
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
	* Strips disallowed attributes from every element of a discarded subtree,
	* so a handler that is already queued (a loading image) cannot fire.
	*
	* @param root the root of a removed subtree
	*/ const _neutralizeSubtree = function _neutralizeSubtree(root) {
        _walkTree(root, (node)=>{
            if (_readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.element) _stripDisallowedAttributes(node);
        });
    };
    /**
	* All nodes under `root`, root first, including open shadow roots. Template
	* content is not entered, it is inert.
	*
	* @param root the in-place root
	* @return the nodes
	*/ const _collectLiveNodes = function _collectLiveNodes(root) {
        const nodes = [];
        _walkTree(root, (node)=>{
            nodes.push(node);
        }, true);
        return nodes;
    };
    /**
	* Strips disallowed attributes from every element that was under the
	* in-place root when the call started and no longer is, whatever removed
	* or moved it.
	*
	* @param root the in-place root
	* @param before the root's nodes, collected before the walk
	*/ const _neutralizeEscapedElements = function _neutralizeEscapedElements(root, before) {
        const reachable = $b96e3143353309b2$var$setCreate();
        $b96e3143353309b2$var$arrayForEach(_collectLiveNodes(root), (node)=>{
            if (_readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.element) $b96e3143353309b2$var$setAdd(reachable, node);
        });
        $b96e3143353309b2$var$arrayForEach(before, (node)=>{
            if (_readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.element && !$b96e3143353309b2$var$setHas(reachable, node)) _stripDisallowedAttributes(node);
        });
    };
    /**
	* Neutralizes everything that left the in-place tree during the call: what
	* DOMPurify removed, and what hooks or custom elements removed or moved out.
	*
	* @param root the in-place root
	* @param before the root's nodes, collected before the walk
	* @return true if the root itself was removed
	*/ const _neutralizeDiscarded = function _neutralizeDiscarded(root, before) {
        let rootRemoved = false;
        $b96e3143353309b2$var$arrayForEach(DOMPurify.removed, (entry)=>{
            if (entry.element) {
                rootRemoved = rootRemoved || entry.element === root;
                _neutralizeSubtree(entry.element);
            }
        });
        _neutralizeEscapedElements(root, before);
        return rootRemoved;
    };
    const MAX_UNVISITED_ROUNDS = 8;
    /**
	* The walk only moves forward, so a node moved to a position it already
	* passed is never visited. Give every original node that is still in the
	* tree but unvisited the normal treatment, hooks included. Nodes created
	* during the call are left alone. Fails closed if the tree keeps changing.
	*
	* @param root the in-place root
	* @param before the root's nodes, collected before the walk
	*/ const _sanitizeUnvisitedNodes = function _sanitizeUnvisitedNodes(root, before) {
        const visited = IN_PLACE_VISITED;
        let original = null;
        const getOriginal = ()=>{
            if (!original) {
                original = $b96e3143353309b2$var$setCreate();
                $b96e3143353309b2$var$arrayForEach(before, (beforeNode)=>{
                    $b96e3143353309b2$var$setAdd(original, beforeNode);
                });
            }
            return original;
        };
        for(let round = 0;; round++){
            const live = _collectLiveNodes(root);
            const containers = [
                root
            ];
            let pending = false;
            $b96e3143353309b2$var$arrayForEach(live, (node)=>{
                if (_readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.documentFragment) $b96e3143353309b2$var$arrayPush(containers, node);
                else if (!pending && !$b96e3143353309b2$var$setHas(visited, node)) pending = $b96e3143353309b2$var$setHas(getOriginal(), node);
            });
            if (!pending) return;
            if (round >= MAX_UNVISITED_ROUNDS) throw $b96e3143353309b2$var$typeErrorCreate("the tree kept changing during in-place sanitization; refusing to return it");
            $b96e3143353309b2$var$arrayForEach(containers, (container, index)=>{
                _sanitizeUnvisitedIn(container, index > 0, root, getOriginal());
            });
        }
    };
    /**
	* One _sanitizeUnvisitedNodes pass over the root or an open shadow root.
	*
	* @param container the root or an open shadow root
	* @param inShadow whether container is a shadow root
	* @param root the in-place root
	* @param original the root's nodes collected before the walk, as a set
	*/ const _sanitizeUnvisitedIn = function _sanitizeUnvisitedIn(container, inShadow, root, original) {
        const iterator = _createNodeIterator(container);
        let node;
        while(node = iterator.nextNode()){
            if (!$b96e3143353309b2$var$setHas(original, node) || $b96e3143353309b2$var$setHas(IN_PLACE_VISITED, node)) continue;
            if (inShadow) _executeHooks(hooks.uponSanitizeShadowNode, node, null);
            _sanitizeElements(node, root);
            _sanitizeAttributes(node, root);
            if (_isDocumentFragment(node.content)) _sanitizeShadowDOM2(node.content);
        }
    };
    /**
	* Records that _sanitizeElements processed `node`. No-op outside IN_PLACE.
	*
	* @param node the node being processed
	*/ const _markVisited = function _markVisited(node) {
        if (IN_PLACE_VISITED) $b96e3143353309b2$var$setAdd(IN_PLACE_VISITED, node);
    };
    /**
	* Patch-linkage attributes (declarative partial updates): `patchsrc`
	* always, `for` everywhere except on <label> and <output>. Gated on
	* SAFE_FOR_XML. Shared by the IN_PLACE pre-pass and _isValidAttribute.
	*
	* @param lcName the transformCaseFunc'd attribute name
	* @param lcTag the transformCaseFunc'd tag name of the carrying element
	* @return true if the attribute is patch linkage and must be dropped
	*/ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
        if (!SAFE_FOR_XML) return false;
        if (lcName === "patchsrc") return true;
        return lcName === "for" && lcTag !== "label" && lcTag !== "output";
    };
    /**
	* IN_PLACE pre-pass: sever all patch linkage before the walk, so no patch
	* can fire mid-walk into a part of the tree the walker already passed.
	* Removes range markers (processing instructions, comments with markup)
	* and strips linkage attributes. It cannot undo a patch that already fired.
	*
	* TODO: if the shipped feature can patch through `for` on <label>/<output>,
	* drop that pair here too (see test/declarative-patch-probe.html).
	*
	* @param root the in-place root to sweep
	*/ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
        if (!SAFE_FOR_XML) return;
        _walkTree(root, (node)=>{
            const nodeType = _readNodeType(node);
            if (nodeType === $b96e3143353309b2$var$NODE_TYPE.processingInstruction || nodeType === $b96e3143353309b2$var$NODE_TYPE.comment && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$COMMENT_MARKUP_PROBE, node.data)) {
                try {
                    remove(node);
                } catch (_) {}
                return false;
            }
            if (nodeType === $b96e3143353309b2$var$NODE_TYPE.element) {
                const element = node;
                const lcTag = transformCaseFunc(_readNodeName(node));
                try {
                    if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
                    if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
                } catch (_) {}
            }
            return true;
        });
    };
    /**
	* _initDocument
	*
	* @param dirty - a string of dirty markup
	* @return a DOM, filled with the dirty markup
	*/ const _initDocument = function _initDocument(dirty) {
        let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
        else {
            const matches = $b96e3143353309b2$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + dirty + "</body></html>";
        const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
        if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, "template", null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {}
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
	* Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
	*
	* @param root The root element or node to start traversing on.
	* @return The created NodeIterator
	*/ const _createNodeIterator = function _createNodeIterator(root) {
        const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
        return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
	* Replace template expression syntax (mustache, ERB, template
	* literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
	* sites. Order matters: mustache, then ERB, then template literal.
	*
	* @param value the string to scrub
	* @returns the scrubbed string
	*/ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
        value = $b96e3143353309b2$var$stringReplace(value, MUSTACHE_EXPR$1, " ");
        value = $b96e3143353309b2$var$stringReplace(value, ERB_EXPR$1, " ");
        value = $b96e3143353309b2$var$stringReplace(value, TMPLIT_EXPR$1, " ");
        return value;
    };
    /**
	* Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
	* character data of an element subtree. Used as the final safety net for
	* SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
	* which only form after text-node normalization (e.g. fragments split across
	* stripped elements) cannot survive into a template-evaluating framework.
	*
	* Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
	* in place rather than round-tripping through innerHTML. This preserves
	* descendant node references (important for IN_PLACE callers), avoids a
	* serialize/reparse cycle, and reads literal character data — which means
	* `<%...%>` in text content matches the ERB regex against its real bytes
	* instead of the HTML-entity-escaped form innerHTML would produce.
	*
	* Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
	* attributes is performed during the per-node `_sanitizeAttributes` pass.
	*
	* @param node The root element whose character data should be scrubbed.
	*/ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
        var _node$querySelectorAl;
        _scrubOwnCharacterData(node);
        const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
        if (templates) $b96e3143353309b2$var$arrayForEach(templates, (tmpl)=>{
            if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
        });
    };
    /**
	* _scrubOwnCharacterData
	*
	* Non-recursive core of _scrubTemplateExpressions: normalize `node` and
	* strip template expressions from its own character data only. Does not
	* enter <template>.content or attached shadow roots (NodeIterator never
	* does). Used by _sanitizeShadowDOM, where every nested template content
	* and shadow root is already walked - and therefore scrubbed - by its own
	* recursive _sanitizeShadowDOM call; recursing here as well would rescrub
	* each nested fragment once per ancestor, which is quadratic in nesting
	* depth.
	*
	* @param node The root whose own character data should be scrubbed.
	*/ const _scrubOwnCharacterData = function _scrubOwnCharacterData(node) {
        node.normalize();
        const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
        const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
        let currentNode = walker.nextNode();
        while(currentNode){
            currentNode.data = _stripTemplateExpressions(currentNode.data);
            currentNode = walker.nextNode();
        }
    };
    /**
	* _isClobbered
	*
	* Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
	* interface with [LegacyOverrideBuiltIns]; a descendant element with a
	* `name` attribute matching a prototype property shadows that property
	* on direct reads. We use this check at the IN_PLACE entry-point and
	* during attribute sanitization to refuse clobbered forms.
	*
	* @param element element to check for clobbering attacks
	* @return true if clobbered, false if safe
	*/ const _isClobbered = function _isClobbered(element) {
        const realTagName = getNodeName ? getNodeName(element) : null;
        if (typeof realTagName !== "string") return false;
        if (transformCaseFunc(realTagName) !== "form") return false;
        return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
    };
    /**
	* Checks whether the given value is a DocumentFragment from any realm.
	*
	* The realm-independent replacement reads `nodeType` through the cached
	* Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
	* constant (11). nodeType is a numeric value resolved from the node's
	* internal slot, identical across realms for the same kind of node.
	*
	* @param value object to check
	* @return true if value is a DocumentFragment-shaped node from any realm
	*/ const _isDocumentFragment = function _isDocumentFragment(value) {
        if (!getNodeType || typeof value !== "object" || value === null) return false;
        try {
            return getNodeType(value) === $b96e3143353309b2$var$NODE_TYPE.documentFragment;
        } catch (_) {
            return false;
        }
    };
    /**
	* Checks whether the given object is a DOM node, including nodes that
	* originate from a different window/realm (e.g. an iframe's
	* contentDocument). The previous `value instanceof Node` check was
	* realm-bound: nodes from a different window failed it, causing
	* sanitize() to silently stringify them and reset IN_PLACE to false,
	* returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
	*
	* @param value object to check whether it's a DOM node
	* @return true if value is a DOM node from any realm
	*/ const _isNode = function _isNode(value) {
        if (!getNodeType || typeof value !== "object" || value === null) return false;
        try {
            return typeof getNodeType(value) === "number";
        } catch (_) {
            return false;
        }
    };
    function _executeHooks(hooks, currentNode, data) {
        if (hooks.length === 0) return;
        $b96e3143353309b2$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
	* Structural-threat checks that condemn a node regardless of the
	* allowlists: mXSS via namespace confusion, risky CSS construction,
	* processing instructions, markup-bearing comments. Pure predicate;
	* the caller removes. Check order is load-bearing.
	*
	* @param currentNode the node to inspect
	* @param tagName the node's transformCaseFunc'd tag name
	* @return true if the node must be removed
	*/ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
        if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$ELEMENT_MARKUP_PROBE, currentNode.textContent) && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
        if (SAFE_FOR_XML && $b96e3143353309b2$var$LITERAL_TEXT_ELEMENTS[tagName] && _readNodeType(currentNode) === $b96e3143353309b2$var$NODE_TYPE.element && _readNamespaceURI(currentNode) === HTML_NAMESPACE && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$ELEMENT_MARKUP_PROBE, currentNode.textContent))) return true;
        if (currentNode.nodeType === $b96e3143353309b2$var$NODE_TYPE.processingInstruction) return true;
        if (SAFE_FOR_XML && currentNode.nodeType === $b96e3143353309b2$var$NODE_TYPE.comment && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$COMMENT_MARKUP_PROBE, currentNode.data)) return true;
        return false;
    };
    /**
	* Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
	* function, per the validation in _parseConfig) against a name.
	* Additional arguments are forwarded to predicate functions - the
	* attributeNameCheck predicate receives the tag name as its second
	* argument. A null/absent check never matches.
	*
	* @param check the configured tagNameCheck / attributeNameCheck value
	* @param name the name to test
	* @param args extra arguments forwarded to a predicate function
	* @return true if the check matches the name
	*/ const _matchesNameCheck = function _matchesNameCheck(check, name) {
        if (check instanceof RegExp) return $b96e3143353309b2$var$regExpTest(check, name);
        if (check instanceof Function) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return Boolean(check(name, ...args));
        }
        return false;
    };
    /**
	* Handle a node whose tag is forbidden or not allowlisted: keep
	* allowed custom elements (false return exits _sanitizeElements
	* early - the namespace and fallback-tag removal checks are
	* intentionally skipped for kept custom elements), else hoist
	* content per KEEP_CONTENT and remove.
	*
	* A kept custom element is the ONLY case in which this function
	* returns false, so the caller uses that return value to run the
	* afterSanitizeElements hook on the kept element and keep the
	* element-hook lifecycle consistent with normal allowlisted
	* elements (GHSA-c2j3-45gr-mqc4).
	*
	* @param currentNode the disallowed node
	* @param tagName the node's transformCaseFunc'd tag name
	* @return true if the node was removed, false if kept
	*/ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
        if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && !FORBID_CONTENTS[$b96e3143353309b2$var$stringToLowerCase(tagName)]) {
            const parentNode = getParentNode(currentNode);
            const childNodes = getChildNodes(currentNode);
            if (childNodes && parentNode) {
                const childCount = childNodes.length;
                for(let i = childCount - 1; i >= 0; --i){
                    const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                    parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                }
            }
        }
        _forceRemove(currentNode);
        return true;
    };
    /**
	* Fork a hook-mutable allowlist off its shared binding the first time a
	* (possibly lazily-installed) uponSanitize* hook is about to see it, so the
	* hook cannot widen the per-instance default or the setConfig binding by
	* reference and leak past the call. Returns the set unchanged once it is
	* already call-local, so repeated calls across elements are idempotent.
	*
	* @param hookList the uponSanitize* hook array for this event
	* @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
	* @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
	* @param setConfigSet the captured setConfig() binding, or null
	* @return a call-local clone if a hook is present and set is still shared,
	*   else set unchanged
	*/ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
        if (hookList.length === 0) return set;
        return set === defaultSet || set === setConfigSet ? $b96e3143353309b2$var$clone(set) : set;
    };
    /**
	* A hook may have detached the node it was called for. If so, treat it as
	* removed and stop processing it; the walk root is exempt. On the IN_PLACE
	* path the detached subtree is neutralized right away.
	*
	* @param currentNode the node a hook may have detached
	* @param root the current walk root
	* @return true if the node was detached
	*/ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
        if (currentNode === root || getParentNode(currentNode) !== null) return false;
        if (IN_PLACE) _neutralizeSubtree(currentNode);
        return true;
    };
    /**
	* _sanitizeElements
	*
	* @protect nodeName
	* @protect textContent
	* @protect removeChild
	* @param currentNode to check for permission to exist
	* @return true if node was killed, false if left alive
	*/ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
        _markVisited(currentNode);
        _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        if (_handleHookDetachedNode(currentNode, root)) return true;
        if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        const tagName = transformCaseFunc(_readNodeName(currentNode));
        ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
        _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        if (_handleHookDetachedNode(currentNode, root)) return true;
        if (_isUnsafeNode(currentNode, tagName)) {
            _forceRemove(currentNode);
            return true;
        }
        if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
            if (removed === false) {
                _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                if (_handleHookDetachedNode(currentNode, root)) return true;
            }
            return removed;
        }
        if (_readNodeType(currentNode) === $b96e3143353309b2$var$NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $b96e3143353309b2$var$NODE_TYPE.text) {
            const content = _stripTemplateExpressions(currentNode.textContent);
            if (currentNode.textContent !== content) {
                $b96e3143353309b2$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return _handleHookDetachedNode(currentNode, root);
    };
    /**
	* _isValidAttribute
	*
	* @param lcTag Lowercase tag name of containing element.
	* @param lcName Lowercase attribute name.
	* @param value Attribute value.
	* @return Returns true if `value` is valid, otherwise false.
	*/ const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        if (FORBID_ATTR[lcName]) return false;
        if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
        if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
        const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
        if (ALLOW_DATA_ATTR && $b96e3143353309b2$var$regExpTest(DATA_ATTR$1, lcName)) return true;
        if (ALLOW_ARIA_ATTR && $b96e3143353309b2$var$regExpTest(ARIA_ATTR$1, lcName)) return true;
        if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
        if (URI_SAFE_ATTRIBUTES[lcName]) return true;
        if ($b96e3143353309b2$var$regExpTest(IS_ALLOWED_URI$1, $b96e3143353309b2$var$stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
        if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && $b96e3143353309b2$var$stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
        if (ALLOW_UNKNOWN_PROTOCOLS && !$b96e3143353309b2$var$regExpTest(IS_SCRIPT_OR_DATA$1, $b96e3143353309b2$var$stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
        return !value;
    };
    const RESERVED_CUSTOM_ELEMENT_NAMES = $b96e3143353309b2$var$addToSet({}, [
        "annotation-xml",
        "color-profile",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "missing-glyph"
    ]);
    /**
	* _isBasicCustomElement
	* checks if at least one dash is included in tagName, and it's not the first char
	* for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
	*
	* @param tagName name of the tag of the node to sanitize
	* @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
	*/ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$b96e3143353309b2$var$stringToLowerCase(tagName)] && $b96e3143353309b2$var$regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    /**
	* Wrap an attribute value in the matching Trusted Types object when
	* the active policy requires it. Namespaced attributes pass through
	* unchanged (no TT support yet, see
	* https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
	*
	* @param lcTag lowercase tag name of the containing element
	* @param lcName lowercase attribute name
	* @param namespaceURI the attribute's namespace, if any
	* @param value the attribute value to wrap
	* @return the value, wrapped when Trusted Types demand it
	*/ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
        if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
            case "TrustedHTML":
                return _createTrustedHTML(value);
            case "TrustedScriptURL":
                return _createTrustedScriptURL(value);
        }
        return value;
    };
    /**
	* Write a modified attribute value back onto the element. On
	* success, re-probe for clobbering introduced by the new value and
	* remove the element when found; otherwise, when this writeback is the
	* recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
	* removal entry that path recorded so it does not show as removed. On
	* failure, remove the attribute instead.
	*
	* Returns true only on a clean write (the value was set and the new value
	* introduced no clobbering). The caller uses that, together with its own
	* knowledge of whether this attribute pushed a DOMPurify.removed record, to
	* decide whether to pop that record. The pop must happen ONLY for the
	* named-prop remove-and-recreate; popping on any other value change (trim,
	* template scrubbing, Trusted Types) would consume an unrelated _forceRemove
	* subtree-cleanup record and let that detached subtree keep a live event
	* handler through the IN_PLACE neutralization pass (SO-001).
	*
	* @param currentNode the element carrying the attribute
	* @param name the attribute name as present on the element
	* @param namespaceURI the attribute's namespace, if any
	* @param value the new attribute value
	* @return true if the value was written without introducing clobbering
	*/ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
        try {
            if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
            else currentNode.setAttribute(name, value);
            if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return false;
            }
            return true;
        } catch (_) {
            _removeAttribute(name, currentNode);
            return false;
        }
    };
    /**
	* _isUnsafeAttributeValue
	*
	* Value-based attribute checks that the attribute walk applies before any
	* hook can force-keep an attribute, shared with the public
	* isValidAttribute() so that it never approves a value sanitize() would
	* strip.
	*
	* @param name the attribute name as found on the node (case preserved)
	* @param value the attribute value
	* @returns true if the attribute must be removed because of its value
	*/ const _isUnsafeAttributeValue = function _isUnsafeAttributeValue(name, value) {
        if (SAFE_FOR_XML && $b96e3143353309b2$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) return true;
        return $b96e3143353309b2$var$stringToLowerCase(name) === "attributename" && $b96e3143353309b2$var$stringMatch(value, "href") !== null;
    };
    /**
	* _sanitizeAttributes
	*
	* @protect attributes
	* @protect nodeName
	* @protect removeAttribute
	* @protect setAttribute
	*
	* @param currentNode to sanitize
	* @param root the current walk root
	*/ const _sanitizeAttributes = function _sanitizeAttributes(currentNode, root) {
        _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        if (_handleHookDetachedNode(currentNode, root)) return;
        const attributes = currentNode.attributes;
        if (!attributes || _isClobbered(currentNode)) return;
        ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
        const hookEvent = {
            attrName: "",
            attrValue: "",
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: void 0
        };
        let l = attributes.length;
        const lcTag = transformCaseFunc(currentNode.nodeName);
        while(l--){
            const attr = attributes[l];
            const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === "value" ? initValue : $b96e3143353309b2$var$stringTrim(initValue);
            let recreatedNamedProp = false;
            hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = void 0;
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && $b96e3143353309b2$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                _removeAttribute(name, currentNode, attr);
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
                recreatedNamedProp = true;
            }
            if (_isUnsafeAttributeValue(name, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            if (hookEvent.forceKeepAttr) continue;
            if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            if (!ALLOW_SELF_CLOSE_IN_ATTR && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$SELF_CLOSING_TAG, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
            if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode, attr);
                continue;
            }
            value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
            if (value !== initValue) {
                if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) $b96e3143353309b2$var$arrayPop(DOMPurify.removed);
            }
        }
        _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        _handleHookDetachedNode(currentNode, root);
    };
    /**
	* _sanitizeShadowDOM
	*
	* @param fragment to iterate over recursively
	*/ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            _sanitizeElements(shadowNode, fragment);
            _sanitizeAttributes(shadowNode, fragment);
            if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
            if (_readNodeType(shadowNode) === $b96e3143353309b2$var$NODE_TYPE.element) {
                const innerSr = getShadowRoot(shadowNode);
                if (_isDocumentFragment(innerSr)) {
                    _sanitizeAttachedShadowRoots(innerSr);
                    _sanitizeShadowDOM2(innerSr);
                }
            }
        }
        if (SAFE_FOR_TEMPLATES) _scrubOwnCharacterData(fragment);
        _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    /**
	* Sanitizes every attached shadow root under `root`, since the node
	* iterator does not enter shadow trees. Needed for IN_PLACE input and for
	* DOM input whose clonable shadow roots were copied by importNode().
	*
	* @param root the subtree root to walk for attached shadow roots
	*/ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
        const stack = [
            {
                node: root,
                shadow: null
            }
        ];
        while(stack.length > 0){
            const item = stack.pop();
            if (item.shadow) {
                _sanitizeShadowDOM2(item.shadow);
                continue;
            }
            const node = item.node;
            const isElement = _readNodeType(node) === $b96e3143353309b2$var$NODE_TYPE.element;
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                node: childNodes[i],
                shadow: null
            });
            if (isElement) {
                const rootName = getNodeName ? getNodeName(node) : null;
                if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
                    const content = node.content;
                    if (_isDocumentFragment(content)) stack.push({
                        node: content,
                        shadow: null
                    });
                }
            }
            if (isElement) {
                const sr = getShadowRoot(node);
                if (_isDocumentFragment(sr)) stack.push({
                    node: null,
                    shadow: sr
                }, {
                    node: sr,
                    shadow: null
                });
            }
        }
    };
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = "<!-->";
        if (typeof dirty !== "string" && !_isNode(dirty)) {
            dirty = $b96e3143353309b2$var$stringifyValue(dirty);
            if (typeof dirty !== "string") throw $b96e3143353309b2$var$typeErrorCreate("dirty is not a string, aborting");
        }
        if (!DOMPurify.isSupported) return dirty;
        if (SET_CONFIG) {
            ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
            ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
        } else _parseConfig(cfg);
        if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = $b96e3143353309b2$var$clone(ALLOWED_TAGS);
        if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = $b96e3143353309b2$var$clone(ALLOWED_ATTR);
        DOMPurify.removed = [];
        const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
        let inPlaceNodes = [];
        const outerVisited = IN_PLACE_VISITED;
        if (inPlace) {
            _neutralizePatchLinkage(dirty);
            const nn = _readNodeName(dirty);
            if (typeof nn === "string") {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    _neutralizeRoot(dirty);
                    throw $b96e3143353309b2$var$typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            }
            if (_isClobbered(dirty)) {
                _neutralizeRoot(dirty);
                throw $b96e3143353309b2$var$typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
            }
            inPlaceNodes = _collectLiveNodes(dirty);
            IN_PLACE_VISITED = $b96e3143353309b2$var$setCreate();
        } else if (_isNode(dirty)) {
            body = _initDocument("<!---->");
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $b96e3143353309b2$var$NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
            else if (importedNode.nodeName === "HTML") body = importedNode;
            else body.appendChild(importedNode);
            _sanitizeAttachedShadowRoots(body);
        } else {
            if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
            body = _initDocument(dirty);
            if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
        }
        if (body && FORCE_BODY) _forceRemove(body.firstChild);
        const walkRoot = inPlace ? dirty : body;
        try {
            if (inPlace) _sanitizeAttachedShadowRoots(dirty);
            const nodeIterator = _createNodeIterator(walkRoot);
            while(currentNode = nodeIterator.nextNode()){
                _sanitizeElements(currentNode, walkRoot);
                _sanitizeAttributes(currentNode, walkRoot);
                if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
            if (inPlace) _sanitizeUnvisitedNodes(dirty, inPlaceNodes);
        } catch (error) {
            if (inPlace) {
                _neutralizeRoot(dirty);
                _neutralizeDiscarded(dirty, inPlaceNodes);
            }
            throw error;
        } finally{
            IN_PLACE_VISITED = outerVisited;
        }
        if (inPlace) {
            if (_neutralizeDiscarded(dirty, inPlaceNodes)) throw $b96e3143353309b2$var$typeErrorCreate("a node selected for removal could not be safely returned; refusing to sanitize in place");
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
            return dirty;
        }
        if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
        if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
        SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
        SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
        SET_CONFIG_ALLOWED_TAGS = null;
        SET_CONFIG_ALLOWED_ATTR = null;
        trustedTypesPolicy = defaultTrustedTypesPolicy;
        emptyHTML = "";
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        if (typeof value === "string" && (_isUnsafeAttributeValue(attr, value) || !ALLOW_SELF_CLOSE_IN_ATTR && $b96e3143353309b2$var$regExpTest($b96e3143353309b2$var$SELF_CLOSING_TAG, value))) return false;
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== "function") return;
        if (!$b96e3143353309b2$var$objectHasOwnProperty(hooks, entryPoint)) return;
        $b96e3143353309b2$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (!$b96e3143353309b2$var$objectHasOwnProperty(hooks, entryPoint)) return;
        if (hookFunction !== void 0) {
            const index = $b96e3143353309b2$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? void 0 : $b96e3143353309b2$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $b96e3143353309b2$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        if (!$b96e3143353309b2$var$objectHasOwnProperty(hooks, entryPoint)) return;
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $b96e3143353309b2$var$_createHooksMap();
    };
    return DOMPurify;
}
var $b96e3143353309b2$export$2e2bcd8739ae039 = $b96e3143353309b2$var$createDOMPurify();

});

parcelRegister("j06ta", function(module, exports) {
module.exports = import("irZAw").then(()=>parcelRequire('69ox0'));

});

parcelRegister("cLHzi", function(module, exports) {
module.exports = Promise.all([
    import("4Jc44"),
    import("4mF61")
]).then(()=>parcelRequire('dbRai'));

});

parcelRegister("l9uiP", function(module, exports) {
module.exports = import("5luej").then(()=>parcelRequire('8inpJ'));

});

parcelRegister("gTsRe", function(module, exports) {
module.exports = import("asrlS").then(()=>parcelRequire('94m7c'));

});

parcelRegister("ePrGd", function(module, exports) {
module.exports = import("kWHmF").then(()=>parcelRequire('gTDut'));

});

parcelRegister("aCW7J", function(module, exports) {
module.exports = import("cdDJD").then(()=>parcelRequire('2RuD0'));

});

parcelRegister("agZ0j", function(module, exports) {
module.exports = import("idvja").then(()=>parcelRequire('1FEHk'));

});

parcelRegister("dD4c8", function(module, exports) {
module.exports = import("8LTee").then(()=>parcelRequire('2yAWK'));

});

parcelRegister("61iX9", function(module, exports) {
module.exports = import("abPLb").then(()=>parcelRequire('jdvH9'));

});

parcelRegister("fQ845", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("i0FHO")
]).then(()=>parcelRequire('iqJgp'));

});

parcelRegister("ll1ry", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("6o2xJ")
]).then(()=>parcelRequire('kjXfR'));

});

parcelRegister("W1Aa1", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("6VJQH")
]).then(()=>parcelRequire('aH2C2'));

});

parcelRegister("cYIdJ", function(module, exports) {
module.exports = Promise.all([
    import("7SdTR"),
    import("abPLb"),
    import("bSEQQ")
]).then(()=>parcelRequire('idULm'));

});

parcelRegister("drQpR", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("14lDV")
]).then(()=>parcelRequire('bVrxQ'));

});

parcelRegister("hEPWJ", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("eotXh")
]).then(()=>parcelRequire('6pDCo'));

});

parcelRegister("bcf6M", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("5WNEX")
]).then(()=>parcelRequire('e1OJU'));

});

parcelRegister("vuJtl", function(module, exports) {
module.exports = Promise.all([
    import("7SdTR"),
    import("abPLb"),
    import("3FFKf")
]).then(()=>parcelRequire('3hTtR'));

});

parcelRegister("5FBLW", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("3rqzk")
]).then(()=>parcelRequire('7opKV'));

});

parcelRegister("jeNGx", function(module, exports) {
module.exports = Promise.all([
    import("7SdTR"),
    import("abPLb"),
    import("4YKfL")
]).then(()=>parcelRequire('cdsuA'));

});

parcelRegister("4mqV1", function(module, exports) {
module.exports = Promise.all([
    import("abPLb"),
    import("8NShl")
]).then(()=>parcelRequire('77Ccd'));

});

parcelRegister("fZm3J", function(module, exports) {
module.exports = import("4KuJB").then(()=>parcelRequire('cio8e'));

});

parcelRegister("cNA8S", function(module, exports) {
module.exports = import("e1RDG").then(()=>parcelRequire('fnm1w'));

});

parcelRegister("7qfKa", function(module, exports) {
module.exports = Promise.all([
    import("4Jc44"),
    import("dumUG")
]).then(()=>parcelRequire('1Q0vK'));

});

parcelRegister("lolWM", function(module, exports) {
module.exports = import("5Suus").then(()=>parcelRequire('iRkKG'));

});

parcelRegister("6irRh", function(module, exports) {
module.exports = Promise.all([
    import("egOBY"),
    import("d9GXk")
]).then(()=>parcelRequire('2eS3Z'));

});

parcelRegister("TrGCL", function(module, exports) {
module.exports = import("gzsIv").then(()=>parcelRequire('jqoJW'));

});

parcelRegister("eYgAi", function(module, exports) {

$parcel$export(module.exports, "HTTPClient", () => $cbd22d3323bef9ca$export$45cf759b359d3d24);

var $ioo0E = parcelRequire("ioo0E");

var $90MBA = parcelRequire("90MBA");
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eef213ff4197108b$exports = {};
$parcel$export($eef213ff4197108b$exports, "Stack", function() {
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
});
const { push: $eef213ff4197108b$var$push } = Array.prototype;
class $eef213ff4197108b$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $0fe1f1400993ba8a$exports = {};
$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $0fe1f1400993ba8a$export$4125cfe7e08e2040;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
});
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function() {
    return $0fe1f1400993ba8a$export$b725a69477e4d33f;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function() {
    return $0fe1f1400993ba8a$export$3b629cd0ff482602;
});
$parcel$export($0fe1f1400993ba8a$exports, "FILE_TYPE_MAGIC_NUMBER_SIZE", function() {
    return $0fe1f1400993ba8a$export$153cac11fce574d;
});
$parcel$export($0fe1f1400993ba8a$exports, "defaultHTTPRuntime", function() {
    return $0fe1f1400993ba8a$export$80e06a8ed038dcf8;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPToolkit", function() {
    return $0fe1f1400993ba8a$export$7370b3fc922cf1e6;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $0fe1f1400993ba8a$export$bda27a3e49197b9;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $0fe1f1400993ba8a$export$ba14d9a5a581e827;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $0fe1f1400993ba8a$export$b7b86d31099674dc;
});
$parcel$export($0fe1f1400993ba8a$exports, "rawRequest", function() {
    return $0fe1f1400993ba8a$export$3052fa16c23a17ef;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestHead", function() {
    return $0fe1f1400993ba8a$export$199f266664335871;
});
$parcel$export($0fe1f1400993ba8a$exports, "request", function() {
    return $0fe1f1400993ba8a$export$b5fe3f66a567bec0;
});
var $22de11b45b0eeb97$exports = {};
$parcel$export($22de11b45b0eeb97$exports, "FileMethod", function() {
    return $22de11b45b0eeb97$export$226b21d2db5eaf9f;
});
$parcel$export($22de11b45b0eeb97$exports, "defaultDataRuntime", function() {
    return $22de11b45b0eeb97$export$f7195e83247c5fe1;
});
$parcel$export($22de11b45b0eeb97$exports, "DataToolkit", function() {
    return $22de11b45b0eeb97$export$bc241bb96b6158a8;
});
$parcel$export($22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $22de11b45b0eeb97$export$5e6a03ce7b01784;
});
$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function() {
    return $22de11b45b0eeb97$export$b6a9369736b19f4d;
});
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function() {
    return $22de11b45b0eeb97$export$2c28ab2e118e73f1;
});
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function() {
    return $22de11b45b0eeb97$export$a0beee2e55fb5dd1;
});
$parcel$export($22de11b45b0eeb97$exports, "serialize", function() {
    return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb;
});
$parcel$export($22de11b45b0eeb97$exports, "takeBytes", function() {
    return $22de11b45b0eeb97$export$45c4469e58b7b0ca;
});
$parcel$export($22de11b45b0eeb97$exports, "readBytes", function() {
    return $22de11b45b0eeb97$export$f9f241124ee3198e;
});
$parcel$export($22de11b45b0eeb97$exports, "makeStream", function() {
    return $22de11b45b0eeb97$export$4b366c43f3cabead;
});
$parcel$export($22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $22de11b45b0eeb97$export$f8162fcba31fa547;
});
$parcel$export($22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $22de11b45b0eeb97$export$cebfdbc318a33abe;
});
$parcel$export($22de11b45b0eeb97$exports, "readAs", function() {
    return $22de11b45b0eeb97$export$e209cbb66c5b18c;
});
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $22de11b45b0eeb97$export$8fb536984ec8b4d7;
});
var $22de11b45b0eeb97$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
const $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
const $22de11b45b0eeb97$export$f7195e83247c5fe1 = {
    DOMParser: globalThis.DOMParser,
    Node: globalThis.Node,
    Document: globalThis.Document,
    HTMLElement: globalThis.HTMLElement,
    SVGElement: globalThis.SVGElement,
    FormData: globalThis.FormData,
    URLSearchParams: globalThis.URLSearchParams,
    Blob: globalThis.Blob,
    FileReader: globalThis.FileReader,
    Event: globalThis.Event,
    ProgressEvent: globalThis.ProgressEvent,
    ReadableStream: (0, $ioo0E.ReadableStream)
};
class $22de11b45b0eeb97$export$bc241bb96b6158a8 {
    constructor(runtime = $22de11b45b0eeb97$export$f7195e83247c5fe1){
        this.runtime = runtime;
        this.polyfillProgressEvent = ()=>globalThis.ProgressEvent ||= class ProgressEvent extends this.runtime.Event {
                constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
                    super(type, meta);
                    this.lengthComputable = lengthComputable;
                    this.total = total;
                    this.loaded = loaded;
                }
            };
        this.parseDocument = async (text, contentType = '')=>{
            const { DOMParser: DOMParser } = this.runtime;
            const [type] = contentType?.split(';') || [];
            return new DOMParser().parseFromString(text, type || 'text/html');
        };
        this.makeFormData = (data)=>{
            const { FormData: FormData } = this.runtime;
            const formData = new FormData();
            for (const [key, value] of Object.entries(data)){
                const list = typeof value !== 'string' && (0, $90MBA.likeArray)(value) ? value : [
                    value
                ];
                for (const item of Array.from(list))if (item != null) {
                    if (typeof item === 'object') formData.append(key, item, item.name);
                    else formData.append(key, item);
                }
            }
            return formData;
        };
        this.serializeNode = (root)=>{
            const { URLSearchParams: URLSearchParams, FormData: FormData, Document: Document, HTMLElement: HTMLElement, SVGElement: SVGElement } = this.runtime;
            var contentType;
            if (!(root instanceof HTMLFormElement)) return {
                contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
                data: (0, $90MBA.stringifyDOM)(root)
            };
            if (root.querySelector('input[type="file"][name]')) return {
                contentType: 'multipart/form-data',
                data: new FormData(root)
            };
            const data = (0, $90MBA.formToJSON)(root);
            switch(contentType = root.enctype){
                case 'text/plain':
                    return {
                        contentType: contentType,
                        data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join('\n')
                    };
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                default:
                    return {
                        contentType: 'application/json',
                        data: JSON.stringify(data)
                    };
            }
        };
        this.serialize = (data, contentType)=>{
            const { Node: Node, URLSearchParams: URLSearchParams, FormData: FormData, Blob: Blob, ReadableStream: ReadableStream } = this.runtime;
            const [type] = contentType?.split(';') || [];
            switch(type){
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                case 'multipart/form-data':
                    return {
                        data: this.makeFormData(data)
                    };
                case 'application/json':
                    return {
                        contentType: contentType,
                        data: JSON.stringify(data)
                    };
                case 'text/html':
                case 'application/xml':
                case 'image/svg':
                    return {
                        contentType: contentType,
                        data: (0, $90MBA.stringifyDOM)(data)
                    };
            }
            if (type) return {
                data: data,
                contentType: contentType
            };
            try {
                if (data instanceof URLSearchParams) return {
                    contentType: 'application/x-www-form-urlencoded',
                    data: data
                };
            } catch  {}
            try {
                if (data instanceof FormData) return {
                    data: data
                };
            } catch  {}
            try {
                if (data instanceof Node) return this.serializeNode(data);
            } catch  {}
            try {
                if ((0, $90MBA.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
                    contentType: 'application/octet-stream',
                    data: data
                };
            } catch  {}
            try {
                return {
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                };
            } catch  {}
            throw new Error('Unserialized Object needs a specific Content-Type');
        };
        this.readBytes = async (stream, limit = Infinity)=>{
            const { Blob: Blob } = this.runtime;
            const chunks = await Array.fromAsync(this.takeBytes(stream, limit));
            return new Blob(chunks).arrayBuffer();
        };
        this.makeStream = (...chunks)=>{
            const { Blob: Blob } = this.runtime;
            return new Blob(chunks).stream();
        };
        this.streamFromProgress = (target)=>(0, $90MBA.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
                const handleProgress = ({ loaded: loaded, total: total })=>{
                    next({
                        loaded: loaded,
                        total: total
                    });
                    if (loaded >= total) complete();
                };
                target.addEventListener('progress', handleProgress);
                target.addEventListener('error', error);
                return ()=>{
                    target.removeEventListener('progress', handleProgress);
                    target.removeEventListener('error', error);
                };
            });
        this.emitStreamProgress = (stream, total, eventTarget)=>{
            const { ProgressEvent: ProgressEvent } = this.runtime;
            return async function*() {
                var loaded = 0;
                for await (const chunk of stream){
                    yield chunk;
                    loaded += chunk.byteLength;
                    const event = new ProgressEvent('progress', {
                        lengthComputable: isNaN(total),
                        loaded: loaded,
                        total: total
                    });
                    eventTarget.dispatchEvent(event);
                }
            }();
        };
        this.readAs = (file, method, encoding)=>{
            const { FileReader: FileReader } = this.runtime;
            const reader = new FileReader();
            const result = new Promise((resolve, reject)=>{
                reader.onerror = reject;
                reader.onload = ()=>resolve(reader.result);
                reader[$22de11b45b0eeb97$export$226b21d2db5eaf9f[method]](file, encoding);
            });
            return {
                progress: this.streamFromProgress(reader),
                result: result
            };
        };
        this./**
     * @param  raw - Binary data
     *
     * @return  Base64 encoded data
     */ encodeBase64 = async (raw)=>{
            const { Blob: Blob } = this.runtime;
            if (raw instanceof Blob) {
                const text = await this.readAs(raw, 'dataURL').result;
                return ($22de11b45b0eeb97$var$DataURI.exec(text) || '')[4];
            }
            const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+('0x' + p1)));
            return btoa(text);
        };
        if (runtime.Event) this.runtime.ProgressEvent = this.polyfillProgressEvent();
    }
    async *takeBytes(stream, limit = Infinity) {
        let total = 0;
        for await (const chunk of stream){
            const remaining = limit - total;
            if (chunk.byteLength > remaining) {
                yield chunk.slice(0, remaining);
                break;
            }
            yield new Uint8Array(chunk);
            total += chunk.byteLength;
            if (total >= limit) break;
        }
    }
}
const { polyfillProgressEvent: $22de11b45b0eeb97$export$5e6a03ce7b01784, parseDocument: $22de11b45b0eeb97$export$b6a9369736b19f4d, makeFormData: $22de11b45b0eeb97$export$2c28ab2e118e73f1, serializeNode: $22de11b45b0eeb97$export$a0beee2e55fb5dd1, serialize: $22de11b45b0eeb97$export$dfdc1655ccc5b9cb, takeBytes: $22de11b45b0eeb97$export$45c4469e58b7b0ca, readBytes: $22de11b45b0eeb97$export$f9f241124ee3198e, makeStream: $22de11b45b0eeb97$export$4b366c43f3cabead, streamFromProgress: $22de11b45b0eeb97$export$f8162fcba31fa547, emitStreamProgress: $22de11b45b0eeb97$export$cebfdbc318a33abe, readAs: $22de11b45b0eeb97$export$e209cbb66c5b18c, encodeBase64: $22de11b45b0eeb97$export$8fb536984ec8b4d7 } = new $22de11b45b0eeb97$export$bc241bb96b6158a8();
var $0fe1f1400993ba8a$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
class $0fe1f1400993ba8a$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message), this.request = request, this.response = response;
    }
}
const $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $0fe1f1400993ba8a$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $90MBA.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return this.parseDocument(raw, contentType);
    } catch  {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
const $0fe1f1400993ba8a$export$153cac11fce574d = 4100;
const $0fe1f1400993ba8a$export$80e06a8ed038dcf8 = {
    ...$22de11b45b0eeb97$export$f7195e83247c5fe1,
    EventTarget: globalThis.EventTarget,
    XMLHttpRequest: globalThis.XMLHttpRequest,
    Headers: globalThis.Headers,
    fetch: globalThis.fetch
};
class $0fe1f1400993ba8a$export$7370b3fc922cf1e6 extends $22de11b45b0eeb97$export$bc241bb96b6158a8 {
    constructor(runtime = $0fe1f1400993ba8a$export$80e06a8ed038dcf8){
        super(runtime), this.runtime = runtime, this.requestXHR = ({ method: method = 'GET', path: path, headers: headers = {}, body: body, signal: signal, ...rest })=>{
            const { XMLHttpRequest: XMLHttpRequest, Headers: Headers, Blob: Blob, ReadableStream: ReadableStream } = this.runtime;
            const request = new XMLHttpRequest();
            const header = new Headers(headers);
            const bodyPromise = body instanceof ReadableStream ? Array.fromAsync(body).then((parts)=>new Blob(parts)) : Promise.resolve(body);
            const abort = ()=>request.abort();
            signal?.addEventListener('abort', abort);
            const response = new Promise((resolve, reject)=>{
                request.onreadystatechange = ()=>{
                    const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
                    if (readyState !== 4 || !status && !signal?.aborted) return;
                    resolve({
                        status: status,
                        statusText: statusText,
                        headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                        body: responseType && responseType !== 'text' ? request.response : request.responseText
                    });
                };
                request.onerror = request.ontimeout = reject;
                const [MIMEType] = header.get('Accept')?.split(',') || [
                    rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
                ];
                if (MIMEType) request.overrideMimeType(MIMEType);
                request.open(method, path + '');
                for (const [key, value] of header)request.setRequestHeader(key, value);
                Object.assign(request, rest);
                bodyPromise.then((body)=>request.send(body));
            }).then(({ body: body, ...meta })=>{
                signal?.throwIfAborted();
                const contentType = request.getResponseHeader('Content-Type') || '';
                if (typeof body === 'string' && !contentType.includes('text')) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
                return {
                    ...meta,
                    body: body
                };
            });
            response.finally(()=>signal?.removeEventListener('abort', abort));
            return {
                response: response,
                upload: this.streamFromProgress(request.upload),
                download: this.streamFromProgress(request)
            };
        }, this.requestFetch = ({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType })=>{
            const { EventTarget: EventTarget, Headers: Headers, ReadableStream: ReadableStream, fetch: fetch } = this.runtime;
            const signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
            headers = responseType === 'text' ? {
                ...headers,
                Accept: 'text/plain'
            } : responseType === 'json' ? {
                ...headers,
                Accept: 'application/json'
            } : responseType === 'document' ? {
                ...headers,
                Accept: 'text/html, application/xhtml+xml, application/xml'
            } : responseType === 'arraybuffer' || responseType === 'blob' ? {
                ...headers,
                Accept: 'application/octet-stream'
            } : headers;
            const isStream = body instanceof ReadableStream;
            var upload;
            if (isStream) {
                const uploadProgress = new EventTarget();
                body = ReadableStream.from(this.emitStreamProgress(body, +headers['Content-Length'], uploadProgress));
                upload = this.streamFromProgress(uploadProgress);
            }
            const downloadProgress = new EventTarget();
            const response = fetch(path + '', {
                method: method,
                headers: headers,
                credentials: withCredentials ? 'include' : 'omit',
                body: body,
                signal: signals[0] && AbortSignal.any(signals),
                // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
                duplex: isStream ? 'half' : undefined
            }).then((response)=>this.parseResponse(response, responseType, downloadProgress));
            const download = this.streamFromProgress(downloadProgress);
            return {
                response: response,
                upload: upload,
                download: download
            };
        }, this.parseResponse = async ({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress)=>{
            const { ReadableStream: ReadableStream } = this.runtime;
            const contentType = headers.get('Content-Type') || '';
            const header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50([
                ...headers
            ].map(([key, value])=>`${key}: ${value}`).join('\n'));
            if (status === 204 || !body) return {
                status: status,
                statusText: statusText,
                headers: header,
                body: undefined
            };
            const stream = ReadableStream.from(this.emitStreamProgress(ReadableStream.from(body), +headers.get('Content-Length'), downloadProgress));
            const rBody = await this.parseFetchBody(stream, contentType, responseType);
            return {
                status: status,
                statusText: statusText,
                headers: header,
                body: rBody
            };
        }, this.parseFetchBody = async (stream, contentType, responseType)=>{
            const { Blob: Blob } = this.runtime;
            const blob = new Blob(await Array.fromAsync(stream), {
                type: contentType
            });
            if (responseType === 'blob') return blob;
            if (responseType === 'arraybuffer') return blob.arrayBuffer();
            const text = await blob.text();
            if (responseType === 'text') return text;
            return $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType);
        }, this.rawRequest = typeof this.runtime.XMLHttpRequest === 'function' ? this.requestXHR : this.requestFetch, this./**
     * Sends a `HEAD` request, falling back to simulation when the server does
     * not support `HEAD`. Tries, in order:
     * 1. A standard `HEAD` request via `fetch()`.
     * 2. A `Range` GET to retrieve the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes (magic-number file header).
     * 3. A plain `GET` that reads the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes then cancels the body stream.
     */ requestHead = async ({ path: path, headers: headers, withCredentials: withCredentials, timeout: timeout, signal: signal })=>{
            const { Headers: Headers, fetch: fetch } = this.runtime;
            const normalizedHeaders = !headers ? {} : headers instanceof Headers ? Object.fromEntries(headers) : Array.isArray(headers) ? Object.fromEntries(headers) : headers;
            const signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            const fetchOptions = {
                credentials: withCredentials ? 'include' : 'omit',
                signal: signals[1] ? AbortSignal.any(signals) : signals[0]
            };
            const toHeaders = (raw)=>$0fe1f1400993ba8a$export$eea2c1c5e1a37e50([
                    ...raw
                ].map(([k, v])=>`${k}: ${v}`).join('\n'));
            // Tier 1: fetch() HEAD
            try {
                const response = await fetch(path + '', {
                    method: 'HEAD',
                    ...fetchOptions,
                    headers: normalizedHeaders
                });
                if (response.ok) return {
                    headers: toHeaders(response.headers)
                };
            } catch  {
            // HEAD not supported; fall through to simulation tiers
            }
            // Tier 2: Range GET – read magic-number bytes only
            try {
                const response = await fetch(path + '', {
                    ...fetchOptions,
                    headers: {
                        ...normalizedHeaders,
                        Range: `bytes=0-${$0fe1f1400993ba8a$export$153cac11fce574d - 1}`
                    }
                });
                if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
                return {
                    headers: toHeaders(response.headers),
                    body: await response.arrayBuffer()
                };
            } catch  {
            // Server does not support Range requests; fall back to plain GET
            }
            // Tier 3: plain GET – read magic-number bytes then cancel the body stream
            const response = await fetch(path, {
                ...fetchOptions,
                headers: normalizedHeaders
            });
            const body = await this.readBytes((0, $ioo0E.ReadableStream).from(response.body), $0fe1f1400993ba8a$export$153cac11fce574d);
            return {
                headers: toHeaders(response.headers),
                body: body
            };
        }, this./**
     * Sends a {@link Request}, with automatic HEAD-simulation fallback for
     * servers that do not support the `HEAD` method.
     */ request = (option)=>{
            if (option.method !== 'HEAD') return this.rawRequest(option);
            const response = this.requestHead(option).then(({ headers: headers, body: body })=>({
                    status: 204,
                    statusText: 'No Content',
                    headers: headers,
                    body: body
                }));
            return {
                response: response,
                download: async function*() {}()
            };
        };
    }
}
const { requestXHR: $0fe1f1400993ba8a$export$4f2a8c8c11a6373a, requestFetch: $0fe1f1400993ba8a$export$bda27a3e49197b9, parseResponse: $0fe1f1400993ba8a$export$ba14d9a5a581e827, parseFetchBody: $0fe1f1400993ba8a$export$b7b86d31099674dc, rawRequest: $0fe1f1400993ba8a$export$3052fa16c23a17ef, requestHead: $0fe1f1400993ba8a$export$199f266664335871, request: $0fe1f1400993ba8a$export$b5fe3f66a567bec0 } = new $0fe1f1400993ba8a$export$7370b3fc922cf1e6();
var $cbd22d3323bef9ca$exports = {};
$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
});
const { splice: $cbd22d3323bef9ca$var$splice } = Array.prototype;
class $cbd22d3323bef9ca$export$45cf759b359d3d24 extends $eef213ff4197108b$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $0fe1f1400993ba8a$export$b5fe3f66a567bec0, ...options } = {}){
        super(), this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = 'GET', headers: headers = {}, body: body } = request;
            if (method in $0fe1f1400993ba8a$export$4125cfe7e08e2040 && body && typeof body === 'object') {
                const { contentType: contentType, data: data } = $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(body, headers['Content-Type']);
                if (contentType) headers['Content-Type'] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $0fe1f1400993ba8a$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path, this.baseURI) + '';
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: 'HEAD',
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: 'GET',
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: 'POST',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: 'PUT',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: 'PATCH',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: 'DELETE',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        const { 'Content-Length': length } = await this.head(path, headers, options);
        const total = +length;
        if (end === Infinity) end = total;
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}

});
parcelRegister("ioo0E", function(module, exports) {

$parcel$export(module.exports, "ReadableStream", () => $08f2fc293f605c8f$export$5d3e1e5268af5f76);
/**
 * @license
 * web-streams-polyfill v4.3.0
 * Copyright 2026 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $08f2fc293f605c8f$var$e() {}
function $08f2fc293f605c8f$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $08f2fc293f605c8f$var$r = $08f2fc293f605c8f$var$e;
function $08f2fc293f605c8f$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $08f2fc293f605c8f$var$n = Promise, $08f2fc293f605c8f$var$i = Promise.resolve.bind($08f2fc293f605c8f$var$n), $08f2fc293f605c8f$var$a = Promise.prototype.then, $08f2fc293f605c8f$var$s = Promise.reject.bind($08f2fc293f605c8f$var$n), $08f2fc293f605c8f$var$l = $08f2fc293f605c8f$var$i;
function $08f2fc293f605c8f$var$u(e) {
    return new $08f2fc293f605c8f$var$n(e);
}
function $08f2fc293f605c8f$var$c(e) {
    return $08f2fc293f605c8f$var$u((t)=>t(e));
}
function $08f2fc293f605c8f$var$d(e) {
    return $08f2fc293f605c8f$var$s(e);
}
function $08f2fc293f605c8f$var$f(e, t, r) {
    return $08f2fc293f605c8f$var$a.call(e, t, r);
}
function $08f2fc293f605c8f$var$h(e, t, o) {
    $08f2fc293f605c8f$var$f($08f2fc293f605c8f$var$f(e, t, o), void 0, $08f2fc293f605c8f$var$r);
}
function $08f2fc293f605c8f$var$b(e, t) {
    $08f2fc293f605c8f$var$h(e, t);
}
function $08f2fc293f605c8f$var$_(e, t) {
    $08f2fc293f605c8f$var$h(e, void 0, t);
}
function $08f2fc293f605c8f$var$m(e, t, r) {
    return $08f2fc293f605c8f$var$f(e, t, r);
}
function $08f2fc293f605c8f$var$p(e) {
    $08f2fc293f605c8f$var$f(e, void 0, $08f2fc293f605c8f$var$r);
}
let $08f2fc293f605c8f$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $08f2fc293f605c8f$var$y = queueMicrotask;
    else {
        const e = $08f2fc293f605c8f$var$c(void 0);
        $08f2fc293f605c8f$var$y = (t)=>$08f2fc293f605c8f$var$f(e, t);
    }
    return $08f2fc293f605c8f$var$y(e);
};
function $08f2fc293f605c8f$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $08f2fc293f605c8f$var$g(e, t, r) {
    try {
        return $08f2fc293f605c8f$var$c($08f2fc293f605c8f$var$S(e, t, r));
    } catch (e) {
        return $08f2fc293f605c8f$var$d(e);
    }
}
class $08f2fc293f605c8f$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, i = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, i;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $08f2fc293f605c8f$var$w = Symbol("[[AbortSteps]]"), $08f2fc293f605c8f$var$R = Symbol("[[ErrorSteps]]"), $08f2fc293f605c8f$var$T = Symbol("[[CancelSteps]]"), $08f2fc293f605c8f$var$P = Symbol("[[PullSteps]]"), $08f2fc293f605c8f$var$C = Symbol("[[CanPullSyncSteps]]"), $08f2fc293f605c8f$var$q = Symbol("[[ReleaseSteps]]");
function $08f2fc293f605c8f$var$E(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $08f2fc293f605c8f$var$j(e) : "closed" === t._state ? function(e) {
        $08f2fc293f605c8f$var$j(e), $08f2fc293f605c8f$var$z(e);
    }(e) : $08f2fc293f605c8f$var$k(e, t._storedError);
}
function $08f2fc293f605c8f$var$W(e, t) {
    return $08f2fc293f605c8f$var$Mr(e._ownerReadableStream, t);
}
function $08f2fc293f605c8f$var$O(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $08f2fc293f605c8f$var$A(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $08f2fc293f605c8f$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$08f2fc293f605c8f$var$q](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $08f2fc293f605c8f$var$B(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $08f2fc293f605c8f$var$j(e) {
    e._closedPromise = $08f2fc293f605c8f$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $08f2fc293f605c8f$var$k(e, t) {
    $08f2fc293f605c8f$var$j(e), $08f2fc293f605c8f$var$A(e, t);
}
function $08f2fc293f605c8f$var$A(e, t) {
    void 0 !== e._closedPromise_reject && ($08f2fc293f605c8f$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $08f2fc293f605c8f$var$z(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $08f2fc293f605c8f$var$D = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $08f2fc293f605c8f$var$F = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $08f2fc293f605c8f$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $08f2fc293f605c8f$var$I(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $08f2fc293f605c8f$var$$(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $08f2fc293f605c8f$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $08f2fc293f605c8f$var$Y(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $08f2fc293f605c8f$var$x(e) {
    return Number(e);
}
function $08f2fc293f605c8f$var$Q(e) {
    return 0 === e ? 0 : e;
}
function $08f2fc293f605c8f$var$N(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $08f2fc293f605c8f$var$Q(o), !$08f2fc293f605c8f$var$D(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $08f2fc293f605c8f$var$Q($08f2fc293f605c8f$var$F(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $08f2fc293f605c8f$var$D(o) && 0 !== o ? o : 0;
}
function $08f2fc293f605c8f$var$H(e, t) {
    if (!$08f2fc293f605c8f$var$Ir(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $08f2fc293f605c8f$var$V(e) {
    return new $08f2fc293f605c8f$export$a890bf36e2af9168(e);
}
function $08f2fc293f605c8f$var$U(e, t) {
    e._reader._readRequests.push(t);
}
function $08f2fc293f605c8f$var$G(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $08f2fc293f605c8f$var$X(e) {
    return e._reader._readRequests.length;
}
function $08f2fc293f605c8f$var$J(e) {
    const t = e._reader;
    return void 0 !== t && !!$08f2fc293f605c8f$var$ee(t);
}
class $08f2fc293f605c8f$export$a890bf36e2af9168 {
    constructor(e){
        if ($08f2fc293f605c8f$var$M(e, 1, "ReadableStreamDefaultReader"), $08f2fc293f605c8f$var$H(e, "First parameter"), $08f2fc293f605c8f$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $08f2fc293f605c8f$var$E(this, e), this._readRequests = new $08f2fc293f605c8f$var$v;
    }
    get closed() {
        return $08f2fc293f605c8f$var$ee(this) ? this._closedPromise : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$ne("closed"));
    }
    cancel(e) {
        return $08f2fc293f605c8f$var$ee(this) ? void 0 === this._ownerReadableStream ? $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$B("cancel")) : $08f2fc293f605c8f$var$W(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$ne("cancel"));
    }
    read() {
        if (!$08f2fc293f605c8f$var$ee(this)) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$ne("read"));
        if (void 0 === this._ownerReadableStream) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$B("read from"));
        const e = $08f2fc293f605c8f$var$re(this) ? new $08f2fc293f605c8f$var$Z : new $08f2fc293f605c8f$var$K;
        return $08f2fc293f605c8f$var$te(this, e), e._promise;
    }
    releaseLock() {
        if (!$08f2fc293f605c8f$var$ee(this)) throw $08f2fc293f605c8f$var$ne("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $08f2fc293f605c8f$var$O(e);
            const t = new TypeError("Reader was released");
            $08f2fc293f605c8f$var$oe(e, t);
        }(this);
    }
}
Object.defineProperties($08f2fc293f605c8f$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a890bf36e2af9168.prototype.cancel, "cancel"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a890bf36e2af9168.prototype.read, "read"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
class $08f2fc293f605c8f$var$K {
    constructor(){
        this._promise = $08f2fc293f605c8f$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._resolvePromise({
            value: e,
            done: !1
        });
    }
    _closeSteps() {
        this._resolvePromise({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $08f2fc293f605c8f$var$Z {
    constructor(){
        this._promise = void 0;
    }
    _chunkSteps(e) {
        this._promise = $08f2fc293f605c8f$var$l({
            value: e,
            done: !1
        });
    }
    _closeSteps() {
        this._promise = $08f2fc293f605c8f$var$l({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        this._promise = $08f2fc293f605c8f$var$d(e);
    }
}
function $08f2fc293f605c8f$var$ee(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $08f2fc293f605c8f$export$a890bf36e2af9168;
}
function $08f2fc293f605c8f$var$te(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$08f2fc293f605c8f$var$P](t);
}
function $08f2fc293f605c8f$var$re(e) {
    const t = e._ownerReadableStream;
    return "closed" === t._state || "errored" === t._state || t._readableStreamController[$08f2fc293f605c8f$var$C]();
}
function $08f2fc293f605c8f$var$oe(e, t) {
    const r = e._readRequests;
    e._readRequests = new $08f2fc293f605c8f$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $08f2fc293f605c8f$var$ne(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $08f2fc293f605c8f$var$ie, $08f2fc293f605c8f$var$ae, $08f2fc293f605c8f$var$se;
function $08f2fc293f605c8f$var$le(e) {
    return e.slice();
}
function $08f2fc293f605c8f$var$ue(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
let $08f2fc293f605c8f$var$ce = (e)=>($08f2fc293f605c8f$var$ce = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $08f2fc293f605c8f$var$ce(e)), $08f2fc293f605c8f$var$de = (e)=>($08f2fc293f605c8f$var$de = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $08f2fc293f605c8f$var$de(e));
function $08f2fc293f605c8f$var$fe(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $08f2fc293f605c8f$var$ue(n, 0, e, t, o), n;
}
function $08f2fc293f605c8f$var$he(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $08f2fc293f605c8f$var$be(e) {
    try {
        const t = e.done, r = e.value;
        return $08f2fc293f605c8f$var$f($08f2fc293f605c8f$var$l(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $08f2fc293f605c8f$var$d(e);
    }
}
const $08f2fc293f605c8f$var$_e = null !== ($08f2fc293f605c8f$var$se = null !== ($08f2fc293f605c8f$var$ie = Symbol.asyncIterator) && void 0 !== $08f2fc293f605c8f$var$ie ? $08f2fc293f605c8f$var$ie : null === ($08f2fc293f605c8f$var$ae = Symbol.for) || void 0 === $08f2fc293f605c8f$var$ae ? void 0 : $08f2fc293f605c8f$var$ae.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $08f2fc293f605c8f$var$se ? $08f2fc293f605c8f$var$se : "@@asyncIterator";
function $08f2fc293f605c8f$var$me(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $08f2fc293f605c8f$var$he(e, $08f2fc293f605c8f$var$_e))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $08f2fc293f605c8f$var$pe(e);
                        } catch (e) {
                            return $08f2fc293f605c8f$var$d(e);
                        }
                        return $08f2fc293f605c8f$var$be(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $08f2fc293f605c8f$var$he(e.iterator, "return");
                            if (void 0 === t) return $08f2fc293f605c8f$var$c({
                                done: !0,
                                value: r
                            });
                            o = $08f2fc293f605c8f$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $08f2fc293f605c8f$var$d(e);
                        }
                        return $08f2fc293f605c8f$var$t(o) ? $08f2fc293f605c8f$var$be(o) : $08f2fc293f605c8f$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($08f2fc293f605c8f$var$me(e, "sync", $08f2fc293f605c8f$var$he(e, Symbol.iterator)));
        } else o = $08f2fc293f605c8f$var$he(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $08f2fc293f605c8f$var$S(o, e, []);
    if (!$08f2fc293f605c8f$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $08f2fc293f605c8f$var$pe(e) {
    const r = $08f2fc293f605c8f$var$S(e.nextMethod, e.iterator, []);
    if (!$08f2fc293f605c8f$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $08f2fc293f605c8f$var$ye {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $08f2fc293f605c8f$var$m(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise = this._ongoingPromise ? $08f2fc293f605c8f$var$m(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader, t = new $08f2fc293f605c8f$var$Se(this);
        return $08f2fc293f605c8f$var$te(e, t), t._promise;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $08f2fc293f605c8f$var$W(t, e);
            return $08f2fc293f605c8f$var$O(t), $08f2fc293f605c8f$var$m(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $08f2fc293f605c8f$var$O(t), $08f2fc293f605c8f$var$c({
            value: e,
            done: !0
        });
    }
}
class $08f2fc293f605c8f$var$Se {
    constructor(e){
        this._iterator = e, this._promise = $08f2fc293f605c8f$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._iterator._ongoingPromise = void 0, $08f2fc293f605c8f$var$y(()=>this._resolvePromise({
                value: e,
                done: !1
            }));
    }
    _closeSteps() {
        const e = this._iterator;
        e._ongoingPromise = void 0, e._isFinished = !0, $08f2fc293f605c8f$var$O(e._reader), this._resolvePromise({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        const t = this._iterator;
        t._ongoingPromise = void 0, t._isFinished = !0, $08f2fc293f605c8f$var$O(t._reader), this._rejectPromise(e);
    }
}
const $08f2fc293f605c8f$var$ge = {
    next () {
        return $08f2fc293f605c8f$var$ve(this) ? this._asyncIteratorImpl.next() : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$we("next"));
    },
    return (e) {
        return $08f2fc293f605c8f$var$ve(this) ? this._asyncIteratorImpl.return(e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$we("return"));
    },
    [$08f2fc293f605c8f$var$_e] () {
        return this;
    }
};
function $08f2fc293f605c8f$var$ve(e) {
    if (!$08f2fc293f605c8f$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $08f2fc293f605c8f$var$ye;
    } catch (e) {
        return !1;
    }
}
function $08f2fc293f605c8f$var$we(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($08f2fc293f605c8f$var$ge, $08f2fc293f605c8f$var$_e, {
    enumerable: !1
});
const $08f2fc293f605c8f$var$Re = Number.isNaN || function(e) {
    return e != e;
};
function $08f2fc293f605c8f$var$Te(e) {
    const t = $08f2fc293f605c8f$var$fe(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $08f2fc293f605c8f$var$Pe(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $08f2fc293f605c8f$var$Ce(e, t, r) {
    if ("number" != typeof (o = r) || $08f2fc293f605c8f$var$Re(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $08f2fc293f605c8f$var$qe(e) {
    e._queue = new $08f2fc293f605c8f$var$v, e._queueTotalSize = 0;
}
function $08f2fc293f605c8f$var$Ee(e) {
    return e === DataView;
}
function $08f2fc293f605c8f$var$We(e) {
    return $08f2fc293f605c8f$var$Ee(e) ? 1 : e.BYTES_PER_ELEMENT;
}
class $08f2fc293f605c8f$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$08f2fc293f605c8f$var$Be(this)) throw $08f2fc293f605c8f$var$ot("view");
        return this._view;
    }
    respond(e) {
        if (!$08f2fc293f605c8f$var$Be(this)) throw $08f2fc293f605c8f$var$ot("respond");
        if ($08f2fc293f605c8f$var$M(e, 1, "respond"), e = $08f2fc293f605c8f$var$N(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($08f2fc293f605c8f$var$de(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $08f2fc293f605c8f$var$et(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$08f2fc293f605c8f$var$Be(this)) throw $08f2fc293f605c8f$var$ot("respondWithNewView");
        if ($08f2fc293f605c8f$var$M(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($08f2fc293f605c8f$var$de(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $08f2fc293f605c8f$var$tt(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($08f2fc293f605c8f$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$fbcf11583158d2c.prototype.respond, "respond"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $08f2fc293f605c8f$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$08f2fc293f605c8f$var$Oe(this)) throw $08f2fc293f605c8f$var$nt("byobRequest");
        return $08f2fc293f605c8f$var$Ke(this);
    }
    get desiredSize() {
        if (!$08f2fc293f605c8f$var$Oe(this)) throw $08f2fc293f605c8f$var$nt("desiredSize");
        return $08f2fc293f605c8f$var$Ze(this);
    }
    close() {
        if (!$08f2fc293f605c8f$var$Oe(this)) throw $08f2fc293f605c8f$var$nt("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $08f2fc293f605c8f$var$Ue(this);
    }
    enqueue(e) {
        if (!$08f2fc293f605c8f$var$Oe(this)) throw $08f2fc293f605c8f$var$nt("enqueue");
        if ($08f2fc293f605c8f$var$M(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $08f2fc293f605c8f$var$Ge(this, e);
    }
    error(e) {
        if (!$08f2fc293f605c8f$var$Oe(this)) throw $08f2fc293f605c8f$var$nt("error");
        $08f2fc293f605c8f$var$Xe(this, e);
    }
    [$08f2fc293f605c8f$var$T](e) {
        $08f2fc293f605c8f$var$ke(this), $08f2fc293f605c8f$var$qe(this);
        const t = this._cancelAlgorithm(e);
        return $08f2fc293f605c8f$var$Ve(this), t;
    }
    [$08f2fc293f605c8f$var$P](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $08f2fc293f605c8f$var$Je(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $08f2fc293f605c8f$var$U(t, e), $08f2fc293f605c8f$var$je(this);
    }
    [$08f2fc293f605c8f$var$C]() {
        return this._queueTotalSize > 0;
    }
    [$08f2fc293f605c8f$var$q]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $08f2fc293f605c8f$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $08f2fc293f605c8f$var$Oe(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $08f2fc293f605c8f$export$2047cf34091e94ac;
}
function $08f2fc293f605c8f$var$Be(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $08f2fc293f605c8f$export$fbcf11583158d2c;
}
function $08f2fc293f605c8f$var$je(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($08f2fc293f605c8f$var$J(t) && $08f2fc293f605c8f$var$X(t) > 0) return !0;
        if ($08f2fc293f605c8f$var$ut(t) && $08f2fc293f605c8f$var$lt(t) > 0) return !0;
        const r = $08f2fc293f605c8f$var$Ze(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $08f2fc293f605c8f$var$h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $08f2fc293f605c8f$var$je(e)), null), (t)=>($08f2fc293f605c8f$var$Xe(e, t), null));
}
function $08f2fc293f605c8f$var$ke(e) {
    $08f2fc293f605c8f$var$xe(e), e._pendingPullIntos = new $08f2fc293f605c8f$var$v;
}
function $08f2fc293f605c8f$var$Ae(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $08f2fc293f605c8f$var$De(t);
    "default" === t.readerType ? $08f2fc293f605c8f$var$G(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $08f2fc293f605c8f$var$ze(e, t) {
    for(let r = 0; r < t.length; ++r)$08f2fc293f605c8f$var$Ae(e, t[r]);
}
function $08f2fc293f605c8f$var$De(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $08f2fc293f605c8f$var$Fe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $08f2fc293f605c8f$var$Le(e, t, r, o) {
    let n;
    try {
        n = $08f2fc293f605c8f$var$fe(t, r, r + o);
    } catch (t) {
        throw $08f2fc293f605c8f$var$Xe(e, t), t;
    }
    $08f2fc293f605c8f$var$Fe(e, n, 0, o);
}
function $08f2fc293f605c8f$var$Ie(e, t) {
    t.bytesFilled > 0 && $08f2fc293f605c8f$var$Le(e, t.buffer, t.byteOffset, t.bytesFilled), $08f2fc293f605c8f$var$He(e);
}
function $08f2fc293f605c8f$var$$e(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, i = !1;
    const a = o - o % t.elementSize;
    a >= t.minimumFill && (n = a - t.bytesFilled, i = !0);
    const s = e._queue;
    for(; n > 0;){
        const r = s.peek(), o = Math.min(n, r.byteLength), i = t.byteOffset + t.bytesFilled;
        $08f2fc293f605c8f$var$ue(t.buffer, i, r.buffer, r.byteOffset, o), r.byteLength === o ? s.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $08f2fc293f605c8f$var$Me(e, o, t), n -= o;
    }
    return i;
}
function $08f2fc293f605c8f$var$Me(e, t, r) {
    r.bytesFilled += t;
}
function $08f2fc293f605c8f$var$Ye(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($08f2fc293f605c8f$var$Ve(e), $08f2fc293f605c8f$var$Yr(e._controlledReadableByteStream)) : $08f2fc293f605c8f$var$je(e);
}
function $08f2fc293f605c8f$var$xe(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $08f2fc293f605c8f$var$Qe(e) {
    const t = [];
    for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
        const r = e._pendingPullIntos.peek();
        $08f2fc293f605c8f$var$$e(e, r) && ($08f2fc293f605c8f$var$He(e), t.push(r));
    }
    return t;
}
function $08f2fc293f605c8f$var$Ne(e, t) {
    const r = e._pendingPullIntos.peek();
    $08f2fc293f605c8f$var$xe(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $08f2fc293f605c8f$var$He(e);
        const r = e._controlledReadableByteStream;
        if ($08f2fc293f605c8f$var$ut(r)) {
            const t = [];
            for(; t.length < $08f2fc293f605c8f$var$lt(r);)t.push($08f2fc293f605c8f$var$He(e));
            $08f2fc293f605c8f$var$ze(r, t);
        }
    }(e, r) : function(e, t, r) {
        if ($08f2fc293f605c8f$var$Me(0, t, r), "none" === r.readerType) {
            $08f2fc293f605c8f$var$Ie(e, r);
            const t = $08f2fc293f605c8f$var$Qe(e);
            return void $08f2fc293f605c8f$var$ze(e._controlledReadableByteStream, t);
        }
        if (r.bytesFilled < r.minimumFill) return;
        $08f2fc293f605c8f$var$He(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $08f2fc293f605c8f$var$Le(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o;
        const n = $08f2fc293f605c8f$var$Qe(e);
        $08f2fc293f605c8f$var$Ae(e._controlledReadableByteStream, r), $08f2fc293f605c8f$var$ze(e._controlledReadableByteStream, n);
    }(e, t, r), $08f2fc293f605c8f$var$je(e);
}
function $08f2fc293f605c8f$var$He(e) {
    return e._pendingPullIntos.shift();
}
function $08f2fc293f605c8f$var$Ve(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $08f2fc293f605c8f$var$Ue(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize !== 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $08f2fc293f605c8f$var$Xe(e, t), t;
                }
            }
            $08f2fc293f605c8f$var$Ve(e), $08f2fc293f605c8f$var$Yr(t);
        }
    }
}
function $08f2fc293f605c8f$var$Ge(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: i } = t;
    if ($08f2fc293f605c8f$var$de(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const a = $08f2fc293f605c8f$var$ce(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($08f2fc293f605c8f$var$de(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $08f2fc293f605c8f$var$xe(e), t.buffer = $08f2fc293f605c8f$var$ce(t.buffer), "none" === t.readerType && $08f2fc293f605c8f$var$Ie(e, t);
    }
    if ($08f2fc293f605c8f$var$J(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $08f2fc293f605c8f$var$Je(e, t._readRequests.shift());
            }
        }(e), 0 === $08f2fc293f605c8f$var$X(r)) $08f2fc293f605c8f$var$Fe(e, a, n, i);
        else {
            e._pendingPullIntos.length > 0 && $08f2fc293f605c8f$var$He(e);
            $08f2fc293f605c8f$var$G(r, new Uint8Array(a, n, i), !1);
        }
    } else if ($08f2fc293f605c8f$var$ut(r)) {
        $08f2fc293f605c8f$var$Fe(e, a, n, i);
        $08f2fc293f605c8f$var$ze(r, $08f2fc293f605c8f$var$Qe(e));
    } else $08f2fc293f605c8f$var$Fe(e, a, n, i);
    $08f2fc293f605c8f$var$je(e);
}
function $08f2fc293f605c8f$var$Xe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($08f2fc293f605c8f$var$ke(e), $08f2fc293f605c8f$var$qe(e), $08f2fc293f605c8f$var$Ve(e), $08f2fc293f605c8f$var$xr(r, t));
}
function $08f2fc293f605c8f$var$Je(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $08f2fc293f605c8f$var$Ye(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $08f2fc293f605c8f$var$Ke(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($08f2fc293f605c8f$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $08f2fc293f605c8f$var$Ze(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $08f2fc293f605c8f$var$et(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $08f2fc293f605c8f$var$ce(r.buffer), $08f2fc293f605c8f$var$Ne(e, t);
}
function $08f2fc293f605c8f$var$tt(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $08f2fc293f605c8f$var$ce(t.buffer), $08f2fc293f605c8f$var$Ne(e, o);
}
function $08f2fc293f605c8f$var$rt(e, t, r, o, n, i, a) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $08f2fc293f605c8f$var$qe(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = a, t._pendingPullIntos = new $08f2fc293f605c8f$var$v, e._readableStreamController = t;
    $08f2fc293f605c8f$var$h($08f2fc293f605c8f$var$c(r()), ()=>(t._started = !0, $08f2fc293f605c8f$var$je(t), null), (e)=>($08f2fc293f605c8f$var$Xe(t, e), null));
}
function $08f2fc293f605c8f$var$ot(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $08f2fc293f605c8f$var$nt(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $08f2fc293f605c8f$var$it(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $08f2fc293f605c8f$var$at(e) {
    return new $08f2fc293f605c8f$export$20068a30393fcc28(e);
}
function $08f2fc293f605c8f$var$st(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $08f2fc293f605c8f$var$lt(e) {
    return e._reader._readIntoRequests.length;
}
function $08f2fc293f605c8f$var$ut(e) {
    const t = e._reader;
    return void 0 !== t && !!$08f2fc293f605c8f$var$ft(t);
}
Object.defineProperties($08f2fc293f605c8f$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$2047cf34091e94ac.prototype.close, "close"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $08f2fc293f605c8f$export$20068a30393fcc28 {
    constructor(e){
        if ($08f2fc293f605c8f$var$M(e, 1, "ReadableStreamBYOBReader"), $08f2fc293f605c8f$var$H(e, "First parameter"), $08f2fc293f605c8f$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$08f2fc293f605c8f$var$Oe(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $08f2fc293f605c8f$var$E(this, e), this._readIntoRequests = new $08f2fc293f605c8f$var$v;
    }
    get closed() {
        return $08f2fc293f605c8f$var$ft(this) ? this._closedPromise : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$_t("closed"));
    }
    cancel(e) {
        return $08f2fc293f605c8f$var$ft(this) ? void 0 === this._ownerReadableStream ? $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$B("cancel")) : $08f2fc293f605c8f$var$W(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$_t("cancel"));
    }
    read(e, t = {}) {
        if (!$08f2fc293f605c8f$var$ft(this)) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$_t("read"));
        if (!ArrayBuffer.isView(e)) return $08f2fc293f605c8f$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $08f2fc293f605c8f$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $08f2fc293f605c8f$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($08f2fc293f605c8f$var$de(e.buffer)) return $08f2fc293f605c8f$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $08f2fc293f605c8f$var$L(e, t), {
                    min: $08f2fc293f605c8f$var$N(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $08f2fc293f605c8f$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $08f2fc293f605c8f$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $08f2fc293f605c8f$var$Ee(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $08f2fc293f605c8f$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $08f2fc293f605c8f$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$B("read from"));
        const n = function(e, t, r) {
            const o = e._ownerReadableStream;
            return "errored" === o._state || function(e, t, r) {
                const o = e._controlledReadableByteStream, n = $08f2fc293f605c8f$var$We(t.constructor), { byteLength: i } = t, a = r * n;
                return !(e._pendingPullIntos.length > 0) && ("closed" === o._state || e._queueTotalSize >= a);
            }(o._readableStreamController, t, r);
        }(this, e, o) ? new $08f2fc293f605c8f$var$dt : new $08f2fc293f605c8f$var$ct;
        return $08f2fc293f605c8f$var$ht(this, e, o, n), n._promise;
    }
    releaseLock() {
        if (!$08f2fc293f605c8f$var$ft(this)) throw $08f2fc293f605c8f$var$_t("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $08f2fc293f605c8f$var$O(e);
            const t = new TypeError("Reader was released");
            $08f2fc293f605c8f$var$bt(e, t);
        }(this);
    }
}
Object.defineProperties($08f2fc293f605c8f$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$20068a30393fcc28.prototype.cancel, "cancel"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$20068a30393fcc28.prototype.read, "read"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
class $08f2fc293f605c8f$var$ct {
    constructor(){
        this._promise = $08f2fc293f605c8f$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._resolvePromise({
            value: e,
            done: !1
        });
    }
    _closeSteps(e) {
        this._resolvePromise({
            value: e,
            done: !0
        });
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $08f2fc293f605c8f$var$dt {
    constructor(){
        this._promise = void 0;
    }
    _chunkSteps(e) {
        this._promise = $08f2fc293f605c8f$var$l({
            value: e,
            done: !1
        });
    }
    _closeSteps(e) {
        this._promise = $08f2fc293f605c8f$var$l({
            value: e,
            done: !0
        });
    }
    _errorSteps(e) {
        this._promise = $08f2fc293f605c8f$var$d(e);
    }
}
function $08f2fc293f605c8f$var$ft(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $08f2fc293f605c8f$export$20068a30393fcc28;
}
function $08f2fc293f605c8f$var$ht(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : function(e, t, r, o) {
        const n = e._controlledReadableByteStream, i = t.constructor, a = $08f2fc293f605c8f$var$We(i), { byteOffset: s, byteLength: l } = t, u = r * a;
        let c;
        try {
            c = $08f2fc293f605c8f$var$ce(t.buffer);
        } catch (e) {
            return void o._errorSteps(e);
        }
        const d = {
            buffer: c,
            bufferByteLength: c.byteLength,
            byteOffset: s,
            byteLength: l,
            bytesFilled: 0,
            minimumFill: u,
            elementSize: a,
            viewConstructor: i,
            readerType: "byob"
        };
        if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $08f2fc293f605c8f$var$st(n, o);
        if ("closed" === n._state) {
            const e = new i(d.buffer, d.byteOffset, 0);
            return void o._closeSteps(e);
        }
        if (e._queueTotalSize > 0) {
            if ($08f2fc293f605c8f$var$$e(e, d)) {
                const t = $08f2fc293f605c8f$var$De(d);
                return $08f2fc293f605c8f$var$Ye(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $08f2fc293f605c8f$var$Xe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $08f2fc293f605c8f$var$st(n, o), $08f2fc293f605c8f$var$je(e);
    }(n._readableStreamController, t, r, o);
}
function $08f2fc293f605c8f$var$bt(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $08f2fc293f605c8f$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $08f2fc293f605c8f$var$_t(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $08f2fc293f605c8f$var$mt(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($08f2fc293f605c8f$var$Re(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $08f2fc293f605c8f$var$pt(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $08f2fc293f605c8f$var$yt(e, t) {
    $08f2fc293f605c8f$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $08f2fc293f605c8f$var$x(r),
        size: void 0 === o ? void 0 : $08f2fc293f605c8f$var$St(o, `${t} has member 'size' that`)
    };
}
function $08f2fc293f605c8f$var$St(e, t) {
    return $08f2fc293f605c8f$var$I(e, t), (t)=>$08f2fc293f605c8f$var$x(e(t));
}
function $08f2fc293f605c8f$var$gt(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$g(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$vt(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), ()=>$08f2fc293f605c8f$var$g(e, t, []);
}
function $08f2fc293f605c8f$var$wt(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$S(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$Rt(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r, o)=>$08f2fc293f605c8f$var$g(e, t, [
            r,
            o
        ]);
}
function $08f2fc293f605c8f$var$Tt(e, t) {
    if (!$08f2fc293f605c8f$var$qt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
class $08f2fc293f605c8f$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $08f2fc293f605c8f$var$$(e, "First parameter");
        const r = $08f2fc293f605c8f$var$yt(t, "Second parameter"), o = function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, i = null == e ? void 0 : e.type, a = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $08f2fc293f605c8f$var$gt(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $08f2fc293f605c8f$var$vt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $08f2fc293f605c8f$var$wt(n, e, `${t} has member 'start' that`),
                write: void 0 === a ? void 0 : $08f2fc293f605c8f$var$Rt(a, e, `${t} has member 'write' that`),
                type: i
            };
        }(e, "First parameter");
        $08f2fc293f605c8f$var$Ct(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $08f2fc293f605c8f$var$pt(r);
        !function(e, t, r, o) {
            const n = Object.create($08f2fc293f605c8f$export$9e6890cb9a51c7c2.prototype);
            let i, a, s, l;
            i = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            a = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$08f2fc293f605c8f$var$c(void 0);
            s = void 0 !== t.close ? ()=>t.close() : ()=>$08f2fc293f605c8f$var$c(void 0);
            l = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$08f2fc293f605c8f$var$c(void 0);
            $08f2fc293f605c8f$var$Nt(e, n, i, a, s, l, r, o);
        }(this, o, $08f2fc293f605c8f$var$mt(r, 1), n);
    }
    get locked() {
        if (!$08f2fc293f605c8f$var$qt(this)) throw $08f2fc293f605c8f$var$Kt("locked");
        return $08f2fc293f605c8f$var$Et(this);
    }
    abort(e) {
        return $08f2fc293f605c8f$var$qt(this) ? $08f2fc293f605c8f$var$Et(this) ? $08f2fc293f605c8f$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $08f2fc293f605c8f$var$Wt(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$Kt("abort"));
    }
    close() {
        return $08f2fc293f605c8f$var$qt(this) ? $08f2fc293f605c8f$var$Et(this) ? $08f2fc293f605c8f$var$d(new TypeError("Cannot close a stream that already has a writer")) : $08f2fc293f605c8f$var$At(this) ? $08f2fc293f605c8f$var$d(new TypeError("Cannot close an already-closing stream")) : $08f2fc293f605c8f$var$Ot(this) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$Kt("close"));
    }
    getWriter() {
        if (!$08f2fc293f605c8f$var$qt(this)) throw $08f2fc293f605c8f$var$Kt("getWriter");
        return $08f2fc293f605c8f$var$Pt(this);
    }
}
function $08f2fc293f605c8f$var$Pt(e) {
    return new $08f2fc293f605c8f$export$9295348f005d6054(e);
}
function $08f2fc293f605c8f$var$Ct(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $08f2fc293f605c8f$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $08f2fc293f605c8f$var$qt(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $08f2fc293f605c8f$export$826849241f7970f8;
}
function $08f2fc293f605c8f$var$Et(e) {
    return void 0 !== e._writer;
}
function $08f2fc293f605c8f$var$Wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $08f2fc293f605c8f$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $08f2fc293f605c8f$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const i = $08f2fc293f605c8f$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = i, n || $08f2fc293f605c8f$var$jt(e, t), i;
}
function $08f2fc293f605c8f$var$Ot(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $08f2fc293f605c8f$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $08f2fc293f605c8f$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $08f2fc293f605c8f$var$cr(o), $08f2fc293f605c8f$var$Ce(n = e._writableStreamController, $08f2fc293f605c8f$var$xt, 0), $08f2fc293f605c8f$var$Ut(n), r;
}
function $08f2fc293f605c8f$var$Bt(e, t) {
    "writable" !== e._state ? $08f2fc293f605c8f$var$kt(e) : $08f2fc293f605c8f$var$jt(e, t);
}
function $08f2fc293f605c8f$var$jt(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $08f2fc293f605c8f$var$$t(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $08f2fc293f605c8f$var$kt(e);
}
function $08f2fc293f605c8f$var$kt(e) {
    e._state = "errored", e._writableStreamController[$08f2fc293f605c8f$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $08f2fc293f605c8f$var$v, void 0 === e._pendingAbortRequest) return void $08f2fc293f605c8f$var$zt(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $08f2fc293f605c8f$var$zt(e);
    $08f2fc293f605c8f$var$h(e._writableStreamController[$08f2fc293f605c8f$var$w](r._reason), ()=>(r._resolve(), $08f2fc293f605c8f$var$zt(e), null), (t)=>(r._reject(t), $08f2fc293f605c8f$var$zt(e), null));
}
function $08f2fc293f605c8f$var$At(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $08f2fc293f605c8f$var$zt(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $08f2fc293f605c8f$var$nr(t, e._storedError);
}
function $08f2fc293f605c8f$var$Dt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $08f2fc293f605c8f$var$ar(e);
    }(r) : $08f2fc293f605c8f$var$cr(r)), e._backpressure = t;
}
Object.defineProperties($08f2fc293f605c8f$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$826849241f7970f8.prototype.abort, "abort"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$826849241f7970f8.prototype.close, "close"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $08f2fc293f605c8f$export$9295348f005d6054 {
    constructor(e){
        if ($08f2fc293f605c8f$var$M(e, 1, "WritableStreamDefaultWriter"), $08f2fc293f605c8f$var$Tt(e, "First parameter"), $08f2fc293f605c8f$var$Et(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$08f2fc293f605c8f$var$At(e) && e._backpressure ? $08f2fc293f605c8f$var$ar(this) : $08f2fc293f605c8f$var$lr(this), $08f2fc293f605c8f$var$rr(this);
        else if ("erroring" === t) $08f2fc293f605c8f$var$sr(this, e._storedError), $08f2fc293f605c8f$var$rr(this);
        else if ("closed" === t) $08f2fc293f605c8f$var$lr(this), $08f2fc293f605c8f$var$rr(r = this), $08f2fc293f605c8f$var$ir(r);
        else {
            const t = e._storedError;
            $08f2fc293f605c8f$var$sr(this, t), $08f2fc293f605c8f$var$or(this, t);
        }
        var r;
    }
    get closed() {
        return $08f2fc293f605c8f$var$Ft(this) ? this._closedPromise : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$er("closed"));
    }
    get desiredSize() {
        if (!$08f2fc293f605c8f$var$Ft(this)) throw $08f2fc293f605c8f$var$er("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $08f2fc293f605c8f$var$tr("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $08f2fc293f605c8f$var$Vt(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $08f2fc293f605c8f$var$Ft(this) ? this._readyPromise : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$er("ready"));
    }
    abort(e) {
        return $08f2fc293f605c8f$var$Ft(this) ? void 0 === this._ownerWritableStream ? $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$tr("abort")) : function(e, t) {
            return $08f2fc293f605c8f$var$Wt(e._ownerWritableStream, t);
        }(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$er("abort"));
    }
    close() {
        if (!$08f2fc293f605c8f$var$Ft(this)) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$er("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$tr("close")) : $08f2fc293f605c8f$var$At(e) ? $08f2fc293f605c8f$var$d(new TypeError("Cannot close an already-closing stream")) : $08f2fc293f605c8f$var$Lt(this);
    }
    releaseLock() {
        if (!$08f2fc293f605c8f$var$Ft(this)) throw $08f2fc293f605c8f$var$er("releaseLock");
        void 0 !== this._ownerWritableStream && $08f2fc293f605c8f$var$Mt(this);
    }
    write(e) {
        return $08f2fc293f605c8f$var$Ft(this) ? void 0 === this._ownerWritableStream ? $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$tr("write to")) : $08f2fc293f605c8f$var$Yt(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$er("write"));
    }
}
function $08f2fc293f605c8f$var$Ft(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $08f2fc293f605c8f$export$9295348f005d6054;
}
function $08f2fc293f605c8f$var$Lt(e) {
    return $08f2fc293f605c8f$var$Ot(e._ownerWritableStream);
}
function $08f2fc293f605c8f$var$It(e, t) {
    "pending" === e._closedPromiseState ? $08f2fc293f605c8f$var$nr(e, t) : function(e, t) {
        $08f2fc293f605c8f$var$or(e, t);
    }(e, t);
}
function $08f2fc293f605c8f$var$$t(e, t) {
    "pending" === e._readyPromiseState ? $08f2fc293f605c8f$var$ur(e, t) : function(e, t) {
        $08f2fc293f605c8f$var$sr(e, t);
    }(e, t);
}
function $08f2fc293f605c8f$var$Mt(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $08f2fc293f605c8f$var$$t(e, r), $08f2fc293f605c8f$var$It(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $08f2fc293f605c8f$var$Yt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        if (void 0 === e._strategySizeAlgorithm) return 1;
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $08f2fc293f605c8f$var$Gt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$tr("write to"));
    const i = r._state;
    if ("errored" === i) return $08f2fc293f605c8f$var$d(r._storedError);
    if ($08f2fc293f605c8f$var$At(r) || "closed" === i) return $08f2fc293f605c8f$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === i) return $08f2fc293f605c8f$var$d(r._storedError);
    const a = function(e) {
        return $08f2fc293f605c8f$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $08f2fc293f605c8f$var$Ce(e, t, r);
        } catch (t) {
            return void $08f2fc293f605c8f$var$Gt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$08f2fc293f605c8f$var$At(o) && "writable" === o._state) $08f2fc293f605c8f$var$Dt(o, $08f2fc293f605c8f$var$Xt(e));
        $08f2fc293f605c8f$var$Ut(e);
    }(o, t, n), a;
}
Object.defineProperties($08f2fc293f605c8f$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$9295348f005d6054.prototype.abort, "abort"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$9295348f005d6054.prototype.close, "close"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $08f2fc293f605c8f$var$xt = {};
class $08f2fc293f605c8f$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$08f2fc293f605c8f$var$Qt(this)) throw $08f2fc293f605c8f$var$Zt("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$08f2fc293f605c8f$var$Qt(this)) throw $08f2fc293f605c8f$var$Zt("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$08f2fc293f605c8f$var$Qt(this)) throw $08f2fc293f605c8f$var$Zt("error");
        "writable" === this._controlledWritableStream._state && $08f2fc293f605c8f$var$Jt(this, e);
    }
    [$08f2fc293f605c8f$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $08f2fc293f605c8f$var$Ht(this), t;
    }
    [$08f2fc293f605c8f$var$R]() {
        $08f2fc293f605c8f$var$qe(this);
    }
}
function $08f2fc293f605c8f$var$Qt(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $08f2fc293f605c8f$export$9e6890cb9a51c7c2;
}
function $08f2fc293f605c8f$var$Nt(e, t, r, o, n, i, a, s) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $08f2fc293f605c8f$var$qe(t), t._abortReason = void 0, t._abortController = function() {
        if ("function" == typeof AbortController) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = s, t._strategyHWM = a, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = i;
    const l = $08f2fc293f605c8f$var$Xt(t);
    $08f2fc293f605c8f$var$Dt(e, l);
    $08f2fc293f605c8f$var$h($08f2fc293f605c8f$var$c(r()), ()=>(t._started = !0, $08f2fc293f605c8f$var$Ut(t), null), (r)=>(t._started = !0, $08f2fc293f605c8f$var$Bt(e, r), null));
}
function $08f2fc293f605c8f$var$Ht(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $08f2fc293f605c8f$var$Vt(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $08f2fc293f605c8f$var$Ut(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $08f2fc293f605c8f$var$kt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $08f2fc293f605c8f$var$xt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $08f2fc293f605c8f$var$Pe(e);
        const r = e._closeAlgorithm();
        $08f2fc293f605c8f$var$Ht(e), $08f2fc293f605c8f$var$h(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $08f2fc293f605c8f$var$ir(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $08f2fc293f605c8f$var$Bt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $08f2fc293f605c8f$var$h(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($08f2fc293f605c8f$var$Pe(e), !$08f2fc293f605c8f$var$At(r) && "writable" === t) {
                const t = $08f2fc293f605c8f$var$Xt(e);
                $08f2fc293f605c8f$var$Dt(r, t);
            }
            return $08f2fc293f605c8f$var$Ut(e), null;
        }, (t)=>("writable" === r._state && $08f2fc293f605c8f$var$Ht(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $08f2fc293f605c8f$var$Bt(e, t);
            }(r, t), null));
    }(e, r);
}
function $08f2fc293f605c8f$var$Gt(e, t) {
    "writable" === e._controlledWritableStream._state && $08f2fc293f605c8f$var$Jt(e, t);
}
function $08f2fc293f605c8f$var$Xt(e) {
    return $08f2fc293f605c8f$var$Vt(e) <= 0;
}
function $08f2fc293f605c8f$var$Jt(e, t) {
    const r = e._controlledWritableStream;
    $08f2fc293f605c8f$var$Ht(e), $08f2fc293f605c8f$var$jt(r, t);
}
function $08f2fc293f605c8f$var$Kt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $08f2fc293f605c8f$var$Zt(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $08f2fc293f605c8f$var$er(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $08f2fc293f605c8f$var$tr(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $08f2fc293f605c8f$var$rr(e) {
    e._closedPromise = $08f2fc293f605c8f$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $08f2fc293f605c8f$var$or(e, t) {
    $08f2fc293f605c8f$var$rr(e), $08f2fc293f605c8f$var$nr(e, t);
}
function $08f2fc293f605c8f$var$nr(e, t) {
    void 0 !== e._closedPromise_reject && ($08f2fc293f605c8f$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $08f2fc293f605c8f$var$ir(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $08f2fc293f605c8f$var$ar(e) {
    e._readyPromise = $08f2fc293f605c8f$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $08f2fc293f605c8f$var$sr(e, t) {
    $08f2fc293f605c8f$var$ar(e), $08f2fc293f605c8f$var$ur(e, t);
}
function $08f2fc293f605c8f$var$lr(e) {
    $08f2fc293f605c8f$var$ar(e), $08f2fc293f605c8f$var$cr(e);
}
function $08f2fc293f605c8f$var$ur(e, t) {
    void 0 !== e._readyPromise_reject && ($08f2fc293f605c8f$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $08f2fc293f605c8f$var$cr(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($08f2fc293f605c8f$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $08f2fc293f605c8f$var$dr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $08f2fc293f605c8f$var$fr = function() {
    const e = null == $08f2fc293f605c8f$var$dr ? void 0 : $08f2fc293f605c8f$var$dr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $08f2fc293f605c8f$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $08f2fc293f605c8f$var$hr(e, t, r, o, n, i) {
    const a = $08f2fc293f605c8f$var$V(e), s = $08f2fc293f605c8f$var$Pt(t);
    e._disturbed = !0;
    const l = new $08f2fc293f605c8f$var$br(s), _ = new $08f2fc293f605c8f$var$mr(l);
    return $08f2fc293f605c8f$var$u((m, y)=>{
        let S;
        if (void 0 !== i) {
            if (S = ()=>{
                const r = void 0 !== i.reason ? i.reason : new $08f2fc293f605c8f$var$fr("Aborted", "AbortError"), a = [];
                o || a.push(()=>"writable" === t._state ? $08f2fc293f605c8f$var$Wt(t, r) : $08f2fc293f605c8f$var$c(void 0)), n || a.push(()=>"readable" === e._state ? $08f2fc293f605c8f$var$Mr(e, r) : $08f2fc293f605c8f$var$c(void 0)), T(()=>Promise.all(a.map((e)=>e())), !0, r);
            }, i.aborted) return void S();
            i.addEventListener("abort", S);
        }
        function g() {
            for(; !l._shuttingDown && !t._backpressure && "writable" === t._state && !$08f2fc293f605c8f$var$At(t) && "readable" === e._state && $08f2fc293f605c8f$var$re(a);)$08f2fc293f605c8f$var$te(a, _);
            if (l._shuttingDown) return $08f2fc293f605c8f$var$c(!0);
            if (t._backpressure) return $08f2fc293f605c8f$var$f(s._readyPromise, g);
            const r = new $08f2fc293f605c8f$var$_r(l);
            return $08f2fc293f605c8f$var$te(a, r), r._promise;
        }
        var v, w, R;
        if ($08f2fc293f605c8f$var$pr(e, a._closedPromise, (e)=>(o ? P(!0, e) : T(()=>$08f2fc293f605c8f$var$Wt(t, e), !0, e), null)), $08f2fc293f605c8f$var$pr(t, s._closedPromise, (t)=>(n ? P(!0, t) : T(()=>$08f2fc293f605c8f$var$Mr(e, t), !0, t), null)), v = e, w = a._closedPromise, R = ()=>(r ? P() : T(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $08f2fc293f605c8f$var$At(t) || "closed" === r ? $08f2fc293f605c8f$var$c(void 0) : "errored" === r ? $08f2fc293f605c8f$var$d(t._storedError) : $08f2fc293f605c8f$var$Lt(e);
                })(s)), null), "closed" === v._state ? R() : $08f2fc293f605c8f$var$b(w, R), $08f2fc293f605c8f$var$At(t) || "closed" === t._state) {
            const t = new TypeError("the destination writable stream closed before all data could be piped to it");
            n ? P(!0, t) : T(()=>$08f2fc293f605c8f$var$Mr(e, t), !0, t);
        }
        function T(e, r, o) {
            function n() {
                return $08f2fc293f605c8f$var$h(e(), ()=>C(r, o), (e)=>C(!0, e)), null;
            }
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $08f2fc293f605c8f$var$At(t) ? n() : $08f2fc293f605c8f$var$b(l._waitForWritesToFinish(), n));
        }
        function P(e, r) {
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $08f2fc293f605c8f$var$At(t) ? C(e, r) : $08f2fc293f605c8f$var$b(l._waitForWritesToFinish(), ()=>C(e, r)));
        }
        function C(e, t) {
            return $08f2fc293f605c8f$var$Mt(s), $08f2fc293f605c8f$var$O(a), void 0 !== i && i.removeEventListener("abort", S), e ? y(t) : m(void 0), null;
        }
        $08f2fc293f605c8f$var$p($08f2fc293f605c8f$var$u((e, t)=>{
            !function r(o) {
                o ? e() : $08f2fc293f605c8f$var$f(g(), r, t);
            }(!1);
        }));
    });
}
class $08f2fc293f605c8f$var$br {
    constructor(e){
        this._writer = e, this._shuttingDown = !1, this._currentWrite = $08f2fc293f605c8f$var$c(void 0);
    }
    _waitForWritesToFinish() {
        const e = this._currentWrite;
        return $08f2fc293f605c8f$var$f(this._currentWrite, ()=>e !== this._currentWrite ? this._waitForWritesToFinish() : void 0);
    }
}
class $08f2fc293f605c8f$var$_r {
    constructor(e){
        this._state = e, this._promise = $08f2fc293f605c8f$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(t) {
        this._state._currentWrite = $08f2fc293f605c8f$var$f($08f2fc293f605c8f$var$Yt(this._state._writer, t), void 0, $08f2fc293f605c8f$var$e), this._resolvePromise(!1);
    }
    _closeSteps() {
        this._resolvePromise(!0);
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $08f2fc293f605c8f$var$mr {
    constructor(e){
        this._state = e;
    }
    _chunkSteps(t) {
        this._state._currentWrite = $08f2fc293f605c8f$var$f($08f2fc293f605c8f$var$Yt(this._state._writer, t), void 0, $08f2fc293f605c8f$var$e);
    }
    _closeSteps() {}
    _errorSteps(e) {}
}
function $08f2fc293f605c8f$var$pr(e, t, r) {
    "errored" === e._state ? r(e._storedError) : $08f2fc293f605c8f$var$_(t, r);
}
class $08f2fc293f605c8f$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$08f2fc293f605c8f$var$yr(this)) throw $08f2fc293f605c8f$var$Er("desiredSize");
        return $08f2fc293f605c8f$var$Pr(this);
    }
    close() {
        if (!$08f2fc293f605c8f$var$yr(this)) throw $08f2fc293f605c8f$var$Er("close");
        if (!$08f2fc293f605c8f$var$Cr(this)) throw new TypeError("The stream is not in a state that permits close");
        $08f2fc293f605c8f$var$wr(this);
    }
    enqueue(e) {
        if (!$08f2fc293f605c8f$var$yr(this)) throw $08f2fc293f605c8f$var$Er("enqueue");
        if (!$08f2fc293f605c8f$var$Cr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $08f2fc293f605c8f$var$Rr(this, e);
    }
    error(e) {
        if (!$08f2fc293f605c8f$var$yr(this)) throw $08f2fc293f605c8f$var$Er("error");
        $08f2fc293f605c8f$var$Tr(this, e);
    }
    [$08f2fc293f605c8f$var$T](e) {
        $08f2fc293f605c8f$var$qe(this);
        const t = this._cancelAlgorithm(e);
        return $08f2fc293f605c8f$var$vr(this), t;
    }
    [$08f2fc293f605c8f$var$P](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $08f2fc293f605c8f$var$Pe(this);
            this._closeRequested && 0 === this._queue.length ? ($08f2fc293f605c8f$var$vr(this), $08f2fc293f605c8f$var$Yr(t)) : $08f2fc293f605c8f$var$Sr(this), e._chunkSteps(r);
        } else $08f2fc293f605c8f$var$U(t, e), $08f2fc293f605c8f$var$Sr(this);
    }
    [$08f2fc293f605c8f$var$C]() {
        return this._queue.length > 0;
    }
    [$08f2fc293f605c8f$var$q]() {}
}
function $08f2fc293f605c8f$var$yr(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $08f2fc293f605c8f$export$b0bb6d0989d67700;
}
function $08f2fc293f605c8f$var$Sr(e) {
    if (!$08f2fc293f605c8f$var$gr(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $08f2fc293f605c8f$var$h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $08f2fc293f605c8f$var$Sr(e)), null), (t)=>($08f2fc293f605c8f$var$Tr(e, t), null));
}
function $08f2fc293f605c8f$var$gr(e) {
    const t = e._controlledReadableStream;
    if (!$08f2fc293f605c8f$var$Cr(e)) return !1;
    if (!e._started) return !1;
    if ($08f2fc293f605c8f$var$$r(t) && $08f2fc293f605c8f$var$X(t) > 0) return !0;
    return $08f2fc293f605c8f$var$Pr(e) > 0;
}
function $08f2fc293f605c8f$var$vr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $08f2fc293f605c8f$var$wr(e) {
    if (!$08f2fc293f605c8f$var$Cr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($08f2fc293f605c8f$var$vr(e), $08f2fc293f605c8f$var$Yr(t));
}
function $08f2fc293f605c8f$var$Rr(e, t) {
    if (!$08f2fc293f605c8f$var$Cr(e)) return;
    const r = e._controlledReadableStream;
    if ($08f2fc293f605c8f$var$$r(r) && $08f2fc293f605c8f$var$X(r) > 0) $08f2fc293f605c8f$var$G(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $08f2fc293f605c8f$var$Tr(e, t), t;
        }
        try {
            $08f2fc293f605c8f$var$Ce(e, t, r);
        } catch (t) {
            throw $08f2fc293f605c8f$var$Tr(e, t), t;
        }
    }
    $08f2fc293f605c8f$var$Sr(e);
}
function $08f2fc293f605c8f$var$Tr(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($08f2fc293f605c8f$var$qe(e), $08f2fc293f605c8f$var$vr(e), $08f2fc293f605c8f$var$xr(r, t));
}
function $08f2fc293f605c8f$var$Pr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $08f2fc293f605c8f$var$Cr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $08f2fc293f605c8f$var$qr(e, t, r, o, n, i, a) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $08f2fc293f605c8f$var$qe(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = a, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $08f2fc293f605c8f$var$h($08f2fc293f605c8f$var$c(r()), ()=>(t._started = !0, $08f2fc293f605c8f$var$Sr(t), null), (e)=>($08f2fc293f605c8f$var$Tr(t, e), null));
}
function $08f2fc293f605c8f$var$Er(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $08f2fc293f605c8f$var$Wr(e, t) {
    return $08f2fc293f605c8f$var$Oe(e._readableStreamController) ? function(e) {
        let t, r, o, n, i, a = $08f2fc293f605c8f$var$V(e), s = !1, l = !1, d = !1, f = !1, h = !1;
        const b = $08f2fc293f605c8f$var$u((e)=>{
            i = e;
        });
        function m(e) {
            $08f2fc293f605c8f$var$_(e._closedPromise, (t)=>(e !== a || ($08f2fc293f605c8f$var$Xe(o._readableStreamController, t), $08f2fc293f605c8f$var$Xe(n._readableStreamController, t), f && h || i(void 0)), null));
        }
        function p() {
            $08f2fc293f605c8f$var$ft(a) && ($08f2fc293f605c8f$var$O(a), a = $08f2fc293f605c8f$var$V(e), m(a));
            $08f2fc293f605c8f$var$te(a, {
                _chunkSteps: (t)=>{
                    $08f2fc293f605c8f$var$y(()=>{
                        l = !1, d = !1;
                        const r = t;
                        let a = t;
                        if (!f && !h) try {
                            a = $08f2fc293f605c8f$var$Te(t);
                        } catch (t) {
                            return $08f2fc293f605c8f$var$Xe(o._readableStreamController, t), $08f2fc293f605c8f$var$Xe(n._readableStreamController, t), void i($08f2fc293f605c8f$var$Mr(e, t));
                        }
                        f || $08f2fc293f605c8f$var$Ge(o._readableStreamController, r), h || $08f2fc293f605c8f$var$Ge(n._readableStreamController, a), s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $08f2fc293f605c8f$var$Ue(o._readableStreamController), h || $08f2fc293f605c8f$var$Ue(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $08f2fc293f605c8f$var$et(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $08f2fc293f605c8f$var$et(n._readableStreamController, 0), f && h || i(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            });
        }
        function S(t, r) {
            $08f2fc293f605c8f$var$ee(a) && ($08f2fc293f605c8f$var$O(a), a = $08f2fc293f605c8f$var$at(e), m(a));
            const u = r ? n : o, c = r ? o : n;
            $08f2fc293f605c8f$var$ht(a, t, 1, {
                _chunkSteps: (t)=>{
                    $08f2fc293f605c8f$var$y(()=>{
                        l = !1, d = !1;
                        const o = r ? h : f;
                        if (r ? f : h) o || $08f2fc293f605c8f$var$tt(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $08f2fc293f605c8f$var$Te(t);
                            } catch (t) {
                                return $08f2fc293f605c8f$var$Xe(u._readableStreamController, t), $08f2fc293f605c8f$var$Xe(c._readableStreamController, t), void i($08f2fc293f605c8f$var$Mr(e, t));
                            }
                            o || $08f2fc293f605c8f$var$tt(u._readableStreamController, t), $08f2fc293f605c8f$var$Ge(c._readableStreamController, r);
                        }
                        s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    s = !1;
                    const t = r ? h : f, o = r ? f : h;
                    t || $08f2fc293f605c8f$var$Ue(u._readableStreamController), o || $08f2fc293f605c8f$var$Ue(c._readableStreamController), void 0 !== e && (t || $08f2fc293f605c8f$var$tt(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $08f2fc293f605c8f$var$et(c._readableStreamController, 0)), t && o || i(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            });
        }
        function g() {
            if (s) return l = !0, $08f2fc293f605c8f$var$c(void 0);
            s = !0;
            const e = $08f2fc293f605c8f$var$Ke(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $08f2fc293f605c8f$var$c(void 0);
        }
        function v() {
            if (s) return d = !0, $08f2fc293f605c8f$var$c(void 0);
            s = !0;
            const e = $08f2fc293f605c8f$var$Ke(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $08f2fc293f605c8f$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, h) {
                const o = $08f2fc293f605c8f$var$le([
                    t,
                    r
                ]), n = $08f2fc293f605c8f$var$Mr(e, o);
                i(n);
            }
            return b;
        }
        function R(o) {
            if (h = !0, r = o, f) {
                const o = $08f2fc293f605c8f$var$le([
                    t,
                    r
                ]), n = $08f2fc293f605c8f$var$Mr(e, o);
                i(n);
            }
            return b;
        }
        function T() {}
        return o = $08f2fc293f605c8f$var$Fr(T, g, w), n = $08f2fc293f605c8f$var$Fr(T, v, R), m(a), [
            o,
            n
        ];
    }(e) : function(e) {
        const t = $08f2fc293f605c8f$var$V(e);
        let r, o, n, i, a, s = !1, l = !1, d = !1, f = !1;
        const h = $08f2fc293f605c8f$var$u((e)=>{
            a = e;
        });
        function b() {
            if (s) return l = !0, $08f2fc293f605c8f$var$c(void 0);
            s = !0;
            return $08f2fc293f605c8f$var$te(t, {
                _chunkSteps: (e)=>{
                    $08f2fc293f605c8f$var$y(()=>{
                        l = !1;
                        const t = e, r = e;
                        d || $08f2fc293f605c8f$var$Rr(n._readableStreamController, t), f || $08f2fc293f605c8f$var$Rr(i._readableStreamController, r), s = !1, l && b();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, d || $08f2fc293f605c8f$var$wr(n._readableStreamController), f || $08f2fc293f605c8f$var$wr(i._readableStreamController), d && f || a(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $08f2fc293f605c8f$var$c(void 0);
        }
        function m(t) {
            if (d = !0, r = t, f) {
                const t = $08f2fc293f605c8f$var$le([
                    r,
                    o
                ]), n = $08f2fc293f605c8f$var$Mr(e, t);
                a(n);
            }
            return h;
        }
        function p(t) {
            if (f = !0, o = t, d) {
                const t = $08f2fc293f605c8f$var$le([
                    r,
                    o
                ]), n = $08f2fc293f605c8f$var$Mr(e, t);
                a(n);
            }
            return h;
        }
        function S() {}
        return n = $08f2fc293f605c8f$var$Dr(S, b, m), i = $08f2fc293f605c8f$var$Dr(S, b, p), $08f2fc293f605c8f$var$_(t._closedPromise, (e)=>($08f2fc293f605c8f$var$Tr(n._readableStreamController, e), $08f2fc293f605c8f$var$Tr(i._readableStreamController, e), d && f || a(void 0), null)), [
            n,
            i
        ];
    }(e);
}
function $08f2fc293f605c8f$var$Or(r) {
    var o;
    return $08f2fc293f605c8f$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $08f2fc293f605c8f$var$d(e);
            }
            return $08f2fc293f605c8f$var$m(e, (e)=>{
                if (!$08f2fc293f605c8f$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $08f2fc293f605c8f$var$wr(o._readableStreamController);
                else {
                    const t = e.value;
                    $08f2fc293f605c8f$var$Rr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            try {
                return $08f2fc293f605c8f$var$c(r.cancel(e));
            } catch (e) {
                return $08f2fc293f605c8f$var$d(e);
            }
        }
        return o = $08f2fc293f605c8f$var$Dr($08f2fc293f605c8f$var$e, n, i, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $08f2fc293f605c8f$var$me(r, "async");
        function i() {
            let e;
            try {
                e = $08f2fc293f605c8f$var$pe(n);
            } catch (e) {
                return $08f2fc293f605c8f$var$d(e);
            }
            return $08f2fc293f605c8f$var$m($08f2fc293f605c8f$var$c(e), (e)=>{
                if (!$08f2fc293f605c8f$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $08f2fc293f605c8f$var$wr(o._readableStreamController);
                else {
                    const t = e.value;
                    $08f2fc293f605c8f$var$Rr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            const r = n.iterator;
            let o;
            try {
                o = $08f2fc293f605c8f$var$he(r, "return");
            } catch (e) {
                return $08f2fc293f605c8f$var$d(e);
            }
            if (void 0 === o) return $08f2fc293f605c8f$var$c(void 0);
            return $08f2fc293f605c8f$var$m($08f2fc293f605c8f$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$08f2fc293f605c8f$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $08f2fc293f605c8f$var$Dr($08f2fc293f605c8f$var$e, i, a, 0), o;
    }(r);
}
function $08f2fc293f605c8f$var$Br(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$g(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$jr(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$g(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$kr(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$S(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$Ar(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $08f2fc293f605c8f$var$zr(e, t) {
    $08f2fc293f605c8f$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, i = null == e ? void 0 : e.signal;
    return void 0 !== i && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(i, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: i
    };
}
Object.defineProperties($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype.close, "close"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $08f2fc293f605c8f$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $08f2fc293f605c8f$var$$(e, "First parameter");
        const r = $08f2fc293f605c8f$var$yt(t, "Second parameter"), o = function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, i = null == r ? void 0 : r.pull, a = null == r ? void 0 : r.start, s = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $08f2fc293f605c8f$var$N(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $08f2fc293f605c8f$var$Br(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === i ? void 0 : $08f2fc293f605c8f$var$jr(i, r, `${t} has member 'pull' that`),
                start: void 0 === a ? void 0 : $08f2fc293f605c8f$var$kr(a, r, `${t} has member 'start' that`),
                type: void 0 === s ? void 0 : $08f2fc293f605c8f$var$Ar(s, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($08f2fc293f605c8f$var$Lr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($08f2fc293f605c8f$export$2047cf34091e94ac.prototype);
                let n, i, a;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$08f2fc293f605c8f$var$c(void 0), a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$08f2fc293f605c8f$var$c(void 0);
                const s = t.autoAllocateChunkSize;
                if (0 === s) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $08f2fc293f605c8f$var$rt(e, o, n, i, a, r, s);
            }(this, o, $08f2fc293f605c8f$var$mt(r, 0));
        } else {
            const e = $08f2fc293f605c8f$var$pt(r);
            !function(e, t, r, o) {
                const n = Object.create($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype);
                let i, a, s;
                i = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$08f2fc293f605c8f$var$c(void 0), s = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$08f2fc293f605c8f$var$c(void 0), $08f2fc293f605c8f$var$qr(e, n, i, a, s, r, o);
            }(this, o, $08f2fc293f605c8f$var$mt(r, 1), e);
        }
    }
    get locked() {
        if (!$08f2fc293f605c8f$var$Ir(this)) throw $08f2fc293f605c8f$var$Qr("locked");
        return $08f2fc293f605c8f$var$$r(this);
    }
    cancel(e) {
        return $08f2fc293f605c8f$var$Ir(this) ? $08f2fc293f605c8f$var$$r(this) ? $08f2fc293f605c8f$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $08f2fc293f605c8f$var$Mr(this, e) : $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$Qr("cancel"));
    }
    getReader(e) {
        if (!$08f2fc293f605c8f$var$Ir(this)) throw $08f2fc293f605c8f$var$Qr("getReader");
        return void 0 === function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $08f2fc293f605c8f$var$it(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $08f2fc293f605c8f$var$V(this) : $08f2fc293f605c8f$var$at(this);
    }
    pipeThrough(e, t = {}) {
        if (!$08f2fc293f605c8f$var$Ir(this)) throw $08f2fc293f605c8f$var$Qr("pipeThrough");
        $08f2fc293f605c8f$var$M(e, 1, "pipeThrough");
        const r = function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $08f2fc293f605c8f$var$Y(r, "readable", "ReadableWritablePair"), $08f2fc293f605c8f$var$H(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $08f2fc293f605c8f$var$Y(o, "writable", "ReadableWritablePair"), $08f2fc293f605c8f$var$Tt(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $08f2fc293f605c8f$var$zr(t, "Second parameter");
        if ($08f2fc293f605c8f$var$$r(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($08f2fc293f605c8f$var$Et(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $08f2fc293f605c8f$var$p($08f2fc293f605c8f$var$hr(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$08f2fc293f605c8f$var$Ir(this)) return $08f2fc293f605c8f$var$d($08f2fc293f605c8f$var$Qr("pipeTo"));
        if (void 0 === e) return $08f2fc293f605c8f$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$08f2fc293f605c8f$var$qt(e)) return $08f2fc293f605c8f$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $08f2fc293f605c8f$var$zr(t, "Second parameter");
        } catch (e) {
            return $08f2fc293f605c8f$var$d(e);
        }
        return $08f2fc293f605c8f$var$$r(this) ? $08f2fc293f605c8f$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $08f2fc293f605c8f$var$Et(e) ? $08f2fc293f605c8f$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $08f2fc293f605c8f$var$hr(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$08f2fc293f605c8f$var$Ir(this)) throw $08f2fc293f605c8f$var$Qr("tee");
        return $08f2fc293f605c8f$var$le($08f2fc293f605c8f$var$Wr(this));
    }
    values(e) {
        if (!$08f2fc293f605c8f$var$Ir(this)) throw $08f2fc293f605c8f$var$Qr("values");
        return function(e, t) {
            const r = $08f2fc293f605c8f$var$V(e), o = new $08f2fc293f605c8f$var$ye(r, t), n = Object.create($08f2fc293f605c8f$var$ge);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$08f2fc293f605c8f$var$_e](e) {
        return this.values(e);
    }
    static from(e) {
        return $08f2fc293f605c8f$var$Or(e);
    }
}
function $08f2fc293f605c8f$var$Dr(e, t, r, o = 1, n = ()=>1) {
    const i = Object.create($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype);
    $08f2fc293f605c8f$var$Lr(i);
    return $08f2fc293f605c8f$var$qr(i, Object.create($08f2fc293f605c8f$export$b0bb6d0989d67700.prototype), e, t, r, o, n), i;
}
function $08f2fc293f605c8f$var$Fr(e, t, r) {
    const o = Object.create($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype);
    $08f2fc293f605c8f$var$Lr(o);
    return $08f2fc293f605c8f$var$rt(o, Object.create($08f2fc293f605c8f$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $08f2fc293f605c8f$var$Lr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $08f2fc293f605c8f$var$Ir(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $08f2fc293f605c8f$export$5d3e1e5268af5f76;
}
function $08f2fc293f605c8f$var$$r(e) {
    return void 0 !== e._reader;
}
function $08f2fc293f605c8f$var$Mr(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $08f2fc293f605c8f$var$c(void 0);
    if ("errored" === t._state) return $08f2fc293f605c8f$var$d(t._storedError);
    $08f2fc293f605c8f$var$Yr(t);
    const o = t._reader;
    if (void 0 !== o && $08f2fc293f605c8f$var$ft(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $08f2fc293f605c8f$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $08f2fc293f605c8f$var$m(t._readableStreamController[$08f2fc293f605c8f$var$T](r), $08f2fc293f605c8f$var$e);
}
function $08f2fc293f605c8f$var$Yr(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($08f2fc293f605c8f$var$z(t), $08f2fc293f605c8f$var$ee(t))) {
        const e = t._readRequests;
        t._readRequests = new $08f2fc293f605c8f$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $08f2fc293f605c8f$var$xr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($08f2fc293f605c8f$var$A(r, t), $08f2fc293f605c8f$var$ee(r) ? $08f2fc293f605c8f$var$oe(r, t) : $08f2fc293f605c8f$var$bt(r, t));
}
function $08f2fc293f605c8f$var$Qr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $08f2fc293f605c8f$var$Nr(e, t) {
    $08f2fc293f605c8f$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $08f2fc293f605c8f$var$Y(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $08f2fc293f605c8f$var$x(r)
    };
}
Object.defineProperties($08f2fc293f605c8f$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.from, "from"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.tee, "tee"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype, $08f2fc293f605c8f$var$_e, {
    value: $08f2fc293f605c8f$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $08f2fc293f605c8f$var$Hr = (e)=>e.byteLength;
$08f2fc293f605c8f$var$o($08f2fc293f605c8f$var$Hr, "size");
class $08f2fc293f605c8f$export$d386b5f37d154119 {
    constructor(e){
        $08f2fc293f605c8f$var$M(e, 1, "ByteLengthQueuingStrategy"), e = $08f2fc293f605c8f$var$Nr(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$08f2fc293f605c8f$var$Ur(this)) throw $08f2fc293f605c8f$var$Vr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$08f2fc293f605c8f$var$Ur(this)) throw $08f2fc293f605c8f$var$Vr("size");
        return $08f2fc293f605c8f$var$Hr;
    }
}
function $08f2fc293f605c8f$var$Vr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $08f2fc293f605c8f$var$Ur(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $08f2fc293f605c8f$export$d386b5f37d154119;
}
Object.defineProperties($08f2fc293f605c8f$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $08f2fc293f605c8f$var$Gr = ()=>1;
$08f2fc293f605c8f$var$o($08f2fc293f605c8f$var$Gr, "size");
class $08f2fc293f605c8f$export$9ebfec18c2dfc625 {
    constructor(e){
        $08f2fc293f605c8f$var$M(e, 1, "CountQueuingStrategy"), e = $08f2fc293f605c8f$var$Nr(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$08f2fc293f605c8f$var$Jr(this)) throw $08f2fc293f605c8f$var$Xr("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$08f2fc293f605c8f$var$Jr(this)) throw $08f2fc293f605c8f$var$Xr("size");
        return $08f2fc293f605c8f$var$Gr;
    }
}
function $08f2fc293f605c8f$var$Xr(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $08f2fc293f605c8f$var$Jr(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $08f2fc293f605c8f$export$9ebfec18c2dfc625;
}
function $08f2fc293f605c8f$var$Kr(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$g(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$Zr(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$S(e, t, [
            r
        ]);
}
function $08f2fc293f605c8f$var$eo(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r, o)=>$08f2fc293f605c8f$var$g(e, t, [
            r,
            o
        ]);
}
function $08f2fc293f605c8f$var$to(e, t, r) {
    return $08f2fc293f605c8f$var$I(e, r), (r)=>$08f2fc293f605c8f$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($08f2fc293f605c8f$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $08f2fc293f605c8f$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $08f2fc293f605c8f$var$yt(t, "Second parameter"), n = $08f2fc293f605c8f$var$yt(r, "Third parameter"), i = function(e, t) {
            $08f2fc293f605c8f$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, i = null == e ? void 0 : e.start, a = null == e ? void 0 : e.transform, s = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $08f2fc293f605c8f$var$to(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $08f2fc293f605c8f$var$Kr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === i ? void 0 : $08f2fc293f605c8f$var$Zr(i, e, `${t} has member 'start' that`),
                transform: void 0 === a ? void 0 : $08f2fc293f605c8f$var$eo(a, e, `${t} has member 'transform' that`),
                writableType: s
            };
        }(e, "First parameter");
        if (void 0 !== i.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== i.writableType) throw new RangeError("Invalid writableType specified");
        const a = $08f2fc293f605c8f$var$mt(n, 0), s = $08f2fc293f605c8f$var$pt(n), l = $08f2fc293f605c8f$var$mt(o, 1), f = $08f2fc293f605c8f$var$pt(o);
        let b;
        !function(e, t, r, o, n, i) {
            function a() {
                return t;
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $08f2fc293f605c8f$var$m(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $08f2fc293f605c8f$var$co(r, t);
                    });
                    return $08f2fc293f605c8f$var$co(r, t);
                }(e, t);
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $08f2fc293f605c8f$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $08f2fc293f605c8f$var$lo(r), $08f2fc293f605c8f$var$h(n, ()=>("errored" === o._state ? $08f2fc293f605c8f$var$bo(r, o._storedError) : ($08f2fc293f605c8f$var$Tr(o._readableStreamController, t), $08f2fc293f605c8f$var$ho(r)), null), (e)=>($08f2fc293f605c8f$var$Tr(o._readableStreamController, e), $08f2fc293f605c8f$var$bo(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $08f2fc293f605c8f$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $08f2fc293f605c8f$var$lo(t), $08f2fc293f605c8f$var$h(o, ()=>("errored" === r._state ? $08f2fc293f605c8f$var$bo(t, r._storedError) : ($08f2fc293f605c8f$var$wr(r._readableStreamController), $08f2fc293f605c8f$var$ho(t)), null), (e)=>($08f2fc293f605c8f$var$Tr(r._readableStreamController, e), $08f2fc293f605c8f$var$bo(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $08f2fc293f605c8f$var$ao(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $08f2fc293f605c8f$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $08f2fc293f605c8f$var$lo(r), $08f2fc293f605c8f$var$h(n, ()=>("errored" === o._state ? $08f2fc293f605c8f$var$bo(r, o._storedError) : ($08f2fc293f605c8f$var$Gt(o._writableStreamController, t), $08f2fc293f605c8f$var$io(e), $08f2fc293f605c8f$var$ho(r)), null), (t)=>($08f2fc293f605c8f$var$Gt(o._writableStreamController, t), $08f2fc293f605c8f$var$io(e), $08f2fc293f605c8f$var$bo(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, i = ()=>1) {
                const a = Object.create($08f2fc293f605c8f$export$826849241f7970f8.prototype);
                return $08f2fc293f605c8f$var$Ct(a), $08f2fc293f605c8f$var$Nt(a, Object.create($08f2fc293f605c8f$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, i), a;
            }(a, s, c, l, r, o), e._readable = $08f2fc293f605c8f$var$Dr(a, d, f, n, i), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $08f2fc293f605c8f$var$ao(e, !0), e._transformStreamController = void 0;
        }(this, $08f2fc293f605c8f$var$u((e)=>{
            b = e;
        }), l, f, a, s), function(e, t) {
            const r = Object.create($08f2fc293f605c8f$export$a55559184460222.prototype);
            let o, n, i;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $08f2fc293f605c8f$var$uo(r, e), $08f2fc293f605c8f$var$c(void 0);
                } catch (e) {
                    return $08f2fc293f605c8f$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$08f2fc293f605c8f$var$c(void 0);
            i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$08f2fc293f605c8f$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, i);
        }(this, i), void 0 !== i.start ? b(i.start(this._transformStreamController)) : b(void 0);
    }
    get readable() {
        if (!$08f2fc293f605c8f$var$ro(this)) throw $08f2fc293f605c8f$var$_o("readable");
        return this._readable;
    }
    get writable() {
        if (!$08f2fc293f605c8f$var$ro(this)) throw $08f2fc293f605c8f$var$_o("writable");
        return this._writable;
    }
}
function $08f2fc293f605c8f$var$ro(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $08f2fc293f605c8f$export$d102341634899398;
}
function $08f2fc293f605c8f$var$oo(e, t) {
    $08f2fc293f605c8f$var$Tr(e._readable._readableStreamController, t), $08f2fc293f605c8f$var$no(e, t);
}
function $08f2fc293f605c8f$var$no(e, t) {
    $08f2fc293f605c8f$var$lo(e._transformStreamController), $08f2fc293f605c8f$var$Gt(e._writable._writableStreamController, t), $08f2fc293f605c8f$var$io(e);
}
function $08f2fc293f605c8f$var$io(e) {
    e._backpressure && $08f2fc293f605c8f$var$ao(e, !1);
}
function $08f2fc293f605c8f$var$ao(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $08f2fc293f605c8f$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($08f2fc293f605c8f$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $08f2fc293f605c8f$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$08f2fc293f605c8f$var$so(this)) throw $08f2fc293f605c8f$var$fo("desiredSize");
        return $08f2fc293f605c8f$var$Pr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$08f2fc293f605c8f$var$so(this)) throw $08f2fc293f605c8f$var$fo("enqueue");
        $08f2fc293f605c8f$var$uo(this, e);
    }
    error(e) {
        if (!$08f2fc293f605c8f$var$so(this)) throw $08f2fc293f605c8f$var$fo("error");
        var t;
        t = e, $08f2fc293f605c8f$var$oo(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$08f2fc293f605c8f$var$so(this)) throw $08f2fc293f605c8f$var$fo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $08f2fc293f605c8f$var$wr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $08f2fc293f605c8f$var$no(t, r);
        }(this);
    }
}
function $08f2fc293f605c8f$var$so(e) {
    return !!$08f2fc293f605c8f$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $08f2fc293f605c8f$export$a55559184460222;
}
function $08f2fc293f605c8f$var$lo(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $08f2fc293f605c8f$var$uo(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$08f2fc293f605c8f$var$Cr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $08f2fc293f605c8f$var$Rr(o, t);
    } catch (e) {
        throw $08f2fc293f605c8f$var$no(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$08f2fc293f605c8f$var$gr(e);
    }(o);
    n !== r._backpressure && $08f2fc293f605c8f$var$ao(r, !0);
}
function $08f2fc293f605c8f$var$co(e, t) {
    return $08f2fc293f605c8f$var$m(e._transformAlgorithm(t), void 0, (t)=>{
        throw $08f2fc293f605c8f$var$oo(e._controlledTransformStream, t), t;
    });
}
function $08f2fc293f605c8f$var$fo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $08f2fc293f605c8f$var$ho(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $08f2fc293f605c8f$var$bo(e, t) {
    void 0 !== e._finishPromise_reject && ($08f2fc293f605c8f$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $08f2fc293f605c8f$var$_o(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($08f2fc293f605c8f$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a55559184460222.prototype.enqueue, "enqueue"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a55559184460222.prototype.error, "error"), $08f2fc293f605c8f$var$o($08f2fc293f605c8f$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($08f2fc293f605c8f$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});

parcelRegister("90MBA", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $87be5417a164885c$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "uniqueID", () => $87be5417a164885c$export$89912e019eef22aa);
$parcel$export(module.exports, "encodeBase64", () => $87be5417a164885c$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "groupBy", () => $87be5417a164885c$export$3f063810d7bf01bd);
$parcel$export(module.exports, "likeArray", () => $87be5417a164885c$export$b5a4d6f439a5044d);
$parcel$export(module.exports, "isTypedArray", () => $87be5417a164885c$export$b119cc7e1840e59c);
$parcel$export(module.exports, "makeArray", () => $87be5417a164885c$export$7b85fd78dd236198);
$parcel$export(module.exports, "splitArray", () => $87be5417a164885c$export$697c3df919c0e61a);
$parcel$export(module.exports, "countBy", () => $87be5417a164885c$export$1d012a0dff3dab06);
$parcel$export(module.exports, "createAsyncIterator", () => $87be5417a164885c$export$86c18c6347f4a8c4);
$parcel$export(module.exports, "sum", () => $87be5417a164885c$export$8a63f25cc62965f1);
$parcel$export(module.exports, "averageOf", () => $87be5417a164885c$export$e1f36757ecda301d);
$parcel$export(module.exports, "Second", () => $87be5417a164885c$export$c489aa6f7fd82b1a);
$parcel$export(module.exports, "Day", () => $87be5417a164885c$export$7a9a31a911eb9a20);
$parcel$export(module.exports, "Timestamp", () => $87be5417a164885c$export$d9bcbd5e1ff81430);
$parcel$export(module.exports, "diffTime", () => $87be5417a164885c$export$506c8e8f8c8edda);
$parcel$export(module.exports, "formatDate", () => $87be5417a164885c$export$3ae94a2503e890a1);
$parcel$export(module.exports, "changeMonth", () => $87be5417a164885c$export$62ad822b3a5fd9a0);
$parcel$export(module.exports, "parseJSON", () => $87be5417a164885c$export$27924e57e9afff7f);
$parcel$export(module.exports, "fileNameOf", () => $87be5417a164885c$export$e778bfb34d38d439);
$parcel$export(module.exports, "fileMetaOf", () => $87be5417a164885c$export$3378b9b5741af658);
$parcel$export(module.exports, "parseURLData", () => $87be5417a164885c$export$eb9b2aadbe449a20);
$parcel$export(module.exports, "buildURLData", () => $87be5417a164885c$export$13397a83aa5915d6);
$parcel$export(module.exports, "blobOf", () => $87be5417a164885c$export$fd89523fba250fa4);
$parcel$export(module.exports, "parseCookie", () => $87be5417a164885c$export$d0eaf3e94be578f6);
$parcel$export(module.exports, "setCookie", () => $87be5417a164885c$export$110700823644f4a6);
$parcel$export(module.exports, "parseDOM", () => $87be5417a164885c$export$d66b332881d9723f);
$parcel$export(module.exports, "stringifyDOM", () => $87be5417a164885c$export$b0709844452f8b6b);
$parcel$export(module.exports, "walkDOM", () => $87be5417a164885c$export$5118471ee5d5453b);
$parcel$export(module.exports, "getVisibleText", () => $87be5417a164885c$export$be4650432daa84fd);
$parcel$export(module.exports, "insertToCursor", () => $87be5417a164885c$export$28d9d24a8cd0ffc2);
$parcel$export(module.exports, "scrollTo", () => $87be5417a164885c$export$3f99968195accfaf);
$parcel$export(module.exports, "formToJSON", () => $87be5417a164885c$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "sleep", () => $87be5417a164885c$export$e772c8ff12451969);

var $j6tXj = parcelRequire("j6tXj");
function $87be5417a164885c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $87be5417a164885c$var$$9b05bcda60cc529c$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $87be5417a164885c$export$61cc6ed0f143570b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $87be5417a164885c$export$dd1bc94b04021eeb;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $87be5417a164885c$export$a09f818797e212c4;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $87be5417a164885c$export$170f4e08cad8229d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $87be5417a164885c$export$2a489b3f92f4996a;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $87be5417a164885c$export$67a6ce548ae77071;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $87be5417a164885c$export$a48f0734ac7c2329;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $87be5417a164885c$export$3f34ca2fef821bbd;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $87be5417a164885c$export$86f54f62aa7a7514;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $87be5417a164885c$export$89912e019eef22aa;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $87be5417a164885c$export$8fb536984ec8b4d7;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "toBase64", function() {
    return $87be5417a164885c$export$37cc283d8fbd3462;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $87be5417a164885c$export$94fdf11bafc8de6b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $87be5417a164885c$export$1c8ba402144543e5;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $87be5417a164885c$export$2ddabb89308e1a22;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $87be5417a164885c$export$14527669107aa301;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $87be5417a164885c$export$3f063810d7bf01bd;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $87be5417a164885c$export$b5a4d6f439a5044d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $87be5417a164885c$export$b119cc7e1840e59c;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $87be5417a164885c$export$7b85fd78dd236198;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $87be5417a164885c$export$697c3df919c0e61a;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $87be5417a164885c$export$1d012a0dff3dab06;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $87be5417a164885c$export$e6b5ff3168b5942b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $87be5417a164885c$export$9cd59f9826255e47;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $87be5417a164885c$export$fbc9cd6af26fa64f;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $87be5417a164885c$export$69a3209f1a06c04d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $87be5417a164885c$export$86c18c6347f4a8c4;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $87be5417a164885c$export$dce9414bed0662c;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $87be5417a164885c$export$271f7c16f175f804;
});
var $87be5417a164885c$var$$6a9944941b4c1893$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "sum", function() {
    return $87be5417a164885c$export$8a63f25cc62965f1;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $87be5417a164885c$export$e1f36757ecda301d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $87be5417a164885c$export$8e694e1eafd55acb;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $87be5417a164885c$export$57d7c52a66287430;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $87be5417a164885c$export$2b4693832ca3ce16;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $87be5417a164885c$export$5b784e078da1ce6;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $87be5417a164885c$export$17ec9c9f4f23588c;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $87be5417a164885c$export$595dbf49c602a1f;
});
function $87be5417a164885c$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $87be5417a164885c$export$e1f36757ecda301d(...data) {
    return $87be5417a164885c$export$8a63f25cc62965f1(...data) / data.length;
}
function $87be5417a164885c$export$8e694e1eafd55acb(data, sample = false) {
    const average = $87be5417a164885c$export$e1f36757ecda301d(...data);
    const summary = $87be5417a164885c$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $87be5417a164885c$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($87be5417a164885c$export$8e694e1eafd55acb(data, sample));
}
function $87be5417a164885c$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($87be5417a164885c$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $87be5417a164885c$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $87be5417a164885c$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $87be5417a164885c$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $87be5417a164885c$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $87be5417a164885c$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $87be5417a164885c$export$dd1bc94b04021eeb = (value)=>$87be5417a164885c$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $87be5417a164885c$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $87be5417a164885c$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $87be5417a164885c$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $87be5417a164885c$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $87be5417a164885c$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $87be5417a164885c$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $87be5417a164885c$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $87be5417a164885c$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $87be5417a164885c$export$8fb536984ec8b4d7 = (input)=>new TextEncoder().encode(input).toBase64();
async function $87be5417a164885c$export$37cc283d8fbd3462(input) {
    if (typeof input === 'string') return $87be5417a164885c$export$8fb536984ec8b4d7(input);
    if (input instanceof Blob) input = await input.arrayBuffer();
    return new Uint8Array(input).toBase64();
}
const $87be5417a164885c$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.fromBase64(input));
const $87be5417a164885c$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $87be5417a164885c$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $87be5417a164885c$export$14527669107aa301(oldList, newList) {
    const oldSet = new Set(oldList), newSet = new Set(newList);
    const map = {};
    for (const item of oldSet.difference(newSet))map[item] = -1;
    for (const item of oldSet.intersection(newSet))map[item] = 0;
    for (const item of newSet.difference(oldSet))map[item] = 1;
    return {
        map: map,
        group: $87be5417a164885c$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $87be5417a164885c$export$b5a4d6f439a5044d(data) {
    if ($87be5417a164885c$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $87be5417a164885c$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $87be5417a164885c$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($87be5417a164885c$export$61cc6ed0f143570b(data)) return Array();
    if ($87be5417a164885c$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $87be5417a164885c$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $87be5417a164885c$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $87be5417a164885c$export$1d012a0dff3dab06(list, iteratee) {
    const group = $87be5417a164885c$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $87be5417a164885c$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $87be5417a164885c$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $87be5417a164885c$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $87be5417a164885c$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $87be5417a164885c$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $87be5417a164885c$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $87be5417a164885c$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $87be5417a164885c$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $87be5417a164885c$export$271f7c16f175f804 extends $87be5417a164885c$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $87be5417a164885c$var$$f872d8bba1c0f79f$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $87be5417a164885c$export$c489aa6f7fd82b1a;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $87be5417a164885c$export$cbd942915f33be50;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $87be5417a164885c$export$9b886f8493244014;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $87be5417a164885c$export$e99cbb807a5bb10d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $87be5417a164885c$export$7a9a31a911eb9a20;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $87be5417a164885c$export$fca4f8121099df57;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $87be5417a164885c$export$6ce2f08d515512;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $87be5417a164885c$export$951c8378cdfec6e6;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $87be5417a164885c$export$1a4097b876a13bf7;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $87be5417a164885c$export$d9bcbd5e1ff81430;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $87be5417a164885c$export$506c8e8f8c8edda;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $87be5417a164885c$export$3ae94a2503e890a1;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $87be5417a164885c$export$7e1c707225b48c34;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $87be5417a164885c$export$62ad822b3a5fd9a0;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $87be5417a164885c$export$9e85258502147ffb;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $87be5417a164885c$export$3c1f2e5bc03748e2;
});
const $87be5417a164885c$export$c489aa6f7fd82b1a = 1000;
const $87be5417a164885c$export$cbd942915f33be50 = $87be5417a164885c$export$c489aa6f7fd82b1a * 60;
const $87be5417a164885c$export$9b886f8493244014 = $87be5417a164885c$export$cbd942915f33be50 * 15;
const $87be5417a164885c$export$e99cbb807a5bb10d = $87be5417a164885c$export$9b886f8493244014 * 4;
const $87be5417a164885c$export$7a9a31a911eb9a20 = $87be5417a164885c$export$e99cbb807a5bb10d * 24;
const $87be5417a164885c$export$fca4f8121099df57 = $87be5417a164885c$export$7a9a31a911eb9a20 * 7;
const $87be5417a164885c$export$6ce2f08d515512 = $87be5417a164885c$export$7a9a31a911eb9a20 * 365;
const $87be5417a164885c$export$951c8378cdfec6e6 = $87be5417a164885c$export$6ce2f08d515512 / 12;
const $87be5417a164885c$export$1a4097b876a13bf7 = $87be5417a164885c$export$951c8378cdfec6e6 * 3;
class $87be5417a164885c$export$d9bcbd5e1ff81430 extends $87be5417a164885c$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $87be5417a164885c$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $87be5417a164885c$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $87be5417a164885c$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $87be5417a164885c$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $87be5417a164885c$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $87be5417a164885c$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $87be5417a164885c$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $87be5417a164885c$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $87be5417a164885c$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $87be5417a164885c$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(time);
    const localDate = new Date(+date - date.getTimezoneOffset() * $87be5417a164885c$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = localDate.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $87be5417a164885c$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $87be5417a164885c$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $87be5417a164885c$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $87be5417a164885c$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $87be5417a164885c$export$9e85258502147ffb = (date, unit, delta)=>unit === $87be5417a164885c$export$6ce2f08d515512 ? $87be5417a164885c$export$7e1c707225b48c34(date, delta) : unit === $87be5417a164885c$export$951c8378cdfec6e6 ? $87be5417a164885c$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $87be5417a164885c$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $87be5417a164885c$export$6ce2f08d515512,
    7: $87be5417a164885c$export$951c8378cdfec6e6,
    10: $87be5417a164885c$export$7a9a31a911eb9a20,
    13: $87be5417a164885c$export$e99cbb807a5bb10d,
    16: $87be5417a164885c$export$cbd942915f33be50,
    19: $87be5417a164885c$export$c489aa6f7fd82b1a
};
function $87be5417a164885c$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $87be5417a164885c$export$9e85258502147ffb(startedAt, $87be5417a164885c$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $87be5417a164885c$var$$ba0e5dc395660a7c$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $87be5417a164885c$export$27924e57e9afff7f;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $87be5417a164885c$export$7ea17d45ecdcf634;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $87be5417a164885c$export$bf304e455230454a;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $87be5417a164885c$export$bb8626e4916f587b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $87be5417a164885c$export$88182f6768071c72;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $87be5417a164885c$export$2427785258f88523;
});
function $87be5417a164885c$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $87be5417a164885c$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $87be5417a164885c$export$7ea17d45ecdcf634(raw) {
    const parsed = $87be5417a164885c$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $87be5417a164885c$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $87be5417a164885c$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $87be5417a164885c$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $87be5417a164885c$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($87be5417a164885c$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $87be5417a164885c$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$87be5417a164885c$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$87be5417a164885c$export$1c8ba402144543e5(row, data[0]));
}
const $87be5417a164885c$export$88182f6768071c72 = async (raw)=>Array.fromAsync($87be5417a164885c$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $87be5417a164885c$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $87be5417a164885c$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($87be5417a164885c$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $87be5417a164885c$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $87be5417a164885c$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $87be5417a164885c$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $87be5417a164885c$export$1c8ba402144543e5(row, headerRow) : row;
}
var $87be5417a164885c$var$$083124ac4b1a50a0$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $87be5417a164885c$export$71e6483fc2b024eb;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "fileNameOf", function() {
    return $87be5417a164885c$export$e778bfb34d38d439;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "fileMetaOf", function() {
    return $87be5417a164885c$export$3378b9b5741af658;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $87be5417a164885c$export$eb9b2aadbe449a20;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $87be5417a164885c$export$13397a83aa5915d6;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $87be5417a164885c$export$fd89523fba250fa4;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $87be5417a164885c$export$504fbde693c1771c;
});
const $87be5417a164885c$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
const $87be5417a164885c$export$e778bfb34d38d439 = (URI)=>decodeURIComponent(URI?.toString().split(/[?#]/)[0].split('/').pop() || '');
function $87be5417a164885c$export$3378b9b5741af658(fileOrURI) {
    if (fileOrURI instanceof MediaStream) return {
        name: '',
        type: 'stream',
        category: 'stream',
        extension: ''
    };
    const path = typeof fileOrURI === 'string' ? fileOrURI : URL.createObjectURL(fileOrURI);
    const { protocol: protocol, pathname: pathname } = new URL(path || '', 'http://localhost');
    const name = fileOrURI instanceof File ? fileOrURI.name : path && ![
        'data:',
        'blob:'
    ].includes(protocol) ? $87be5417a164885c$export$e778bfb34d38d439(pathname) : '';
    const type = fileOrURI instanceof Blob ? fileOrURI.type : (protocol === 'data:' ? pathname.split(',')[0] : name && (0, $j6tXj.default).getType(name)) || '';
    const [category] = type?.split(/\W+/) || [];
    const extension = name?.includes('.') ? name.split('.').at(-1) : type && (0, $j6tXj.default).getExtension(type);
    if (typeof fileOrURI !== 'string') URL.revokeObjectURL(path);
    return {
        name: name,
        type: type,
        category: category,
        extension: extension
    };
}
function $87be5417a164885c$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($87be5417a164885c$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $87be5417a164885c$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $87be5417a164885c$export$b5a4d6f439a5044d(value) ? $87be5417a164885c$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $87be5417a164885c$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$87be5417a164885c$export$dd1bc94b04021eeb(value) && [
            key,
            $87be5417a164885c$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $87be5417a164885c$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $87be5417a164885c$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $87be5417a164885c$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $87be5417a164885c$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    return new Blob([
        base64 ? Uint8Array.fromBase64(data) : data
    ], {
        type: type
    });
}
var $87be5417a164885c$var$$d677628cc2ac1e37$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $87be5417a164885c$export$d0eaf3e94be578f6;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $87be5417a164885c$export$110700823644f4a6;
});
const $87be5417a164885c$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $87be5417a164885c$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $87be5417a164885c$var$$50872bf213056663$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $87be5417a164885c$export$1b9ac4d3de3ffd2e;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$50872bf213056663$exports, "makeSHA", function() {
    return $87be5417a164885c$export$d51f3b55e8d1aa73;
});
const $87be5417a164885c$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $87be5417a164885c$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $87be5417a164885c$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-expect-error — msCrypto is a non-standard API
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    // @ts-expect-error — webkitSubtle is a non-standard API
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $87be5417a164885c$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return new Uint8Array(buffer).toHex();
}
var $87be5417a164885c$var$$93a3089d2937b23f$exports = {};
var $87be5417a164885c$var$$3e0a089cc13f69ad$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $87be5417a164885c$export$f5a4056b78c72efa;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $87be5417a164885c$export$2ee022bbbc550b25;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $87be5417a164885c$export$a549dd5cef7f8327;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $87be5417a164885c$export$8eece510bcb9c62c;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $87be5417a164885c$export$b8a1af58c024fefd;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $87be5417a164885c$export$a2cf0d4bb6e06de4;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $87be5417a164885c$export$d66b332881d9723f;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $87be5417a164885c$export$b0709844452f8b6b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $87be5417a164885c$export$5118471ee5d5453b;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $87be5417a164885c$export$6e196edbcc00e5bc;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $87be5417a164885c$export$be4650432daa84fd;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $87be5417a164885c$export$578e38b4a3e0b255;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $87be5417a164885c$export$7cd14c57bbb84350;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $87be5417a164885c$export$5100419dfae0456d;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $87be5417a164885c$export$28d9d24a8cd0ffc2;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $87be5417a164885c$export$3f99968195accfaf;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $87be5417a164885c$export$eafdbaa868ea9975;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $87be5417a164885c$export$36a0c1ca2ae264fa;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $87be5417a164885c$export$86d7c59254d6a2c9;
});
const $87be5417a164885c$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $87be5417a164885c$var$$3e0a089cc13f69ad$var$templateMap = {};
function $87be5417a164885c$export$2ee022bbbc550b25(tagName) {
    if ($87be5417a164885c$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $87be5417a164885c$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $87be5417a164885c$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $87be5417a164885c$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $87be5417a164885c$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $87be5417a164885c$export$8eece510bcb9c62c = (Class)=>$87be5417a164885c$export$170f4e08cad8229d(Class, HTMLElement);
const $87be5417a164885c$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $87be5417a164885c$export$b8a1af58c024fefd(Class) {
    const name = $87be5417a164885c$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $87be5417a164885c$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $87be5417a164885c$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $87be5417a164885c$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $87be5417a164885c$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $87be5417a164885c$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $87be5417a164885c$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($87be5417a164885c$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $87be5417a164885c$export$5118471ee5d5453b(node, type);
}
function $87be5417a164885c$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $87be5417a164885c$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $87be5417a164885c$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement?.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement?.getBoundingClientRect() ?? {};
        if (width && height) text += nodeValue?.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $87be5417a164885c$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $87be5417a164885c$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $87be5417a164885c$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$87be5417a164885c$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$87be5417a164885c$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $87be5417a164885c$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $87be5417a164885c$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $87be5417a164885c$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $87be5417a164885c$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $87be5417a164885c$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $87be5417a164885c$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $87be5417a164885c$export$7ea17d45ecdcf634(defaultValue);
                else if ($87be5417a164885c$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$87be5417a164885c$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $87be5417a164885c$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $87be5417a164885c$export$7ea17d45ecdcf634(value);
        }
        const record = data;
        if (name in data) record[name] = [].concat(record[name], parsedValue);
        else record[name] = !(parsedValue instanceof Array) || !$87be5417a164885c$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $87be5417a164885c$var$$bb23e0c794fefbef$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $87be5417a164885c$export$e772c8ff12451969;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $87be5417a164885c$export$57207d71b8c929c8;
});
function $87be5417a164885c$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $87be5417a164885c$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $87be5417a164885c$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $87be5417a164885c$var$$19ed8aeb7905a045$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $87be5417a164885c$export$10b1921597150314;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $87be5417a164885c$export$3e2b244719956741;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $87be5417a164885c$export$1d1d2ed6b55cf67f;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $87be5417a164885c$export$2155c0b5a4b77fb8;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $87be5417a164885c$export$9d97473344489dfc;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $87be5417a164885c$export$d635d04af3887bbe;
});
function $87be5417a164885c$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $87be5417a164885c$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $87be5417a164885c$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $87be5417a164885c$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $87be5417a164885c$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $87be5417a164885c$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $87be5417a164885c$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $87be5417a164885c$var$$7a08303ce13c49c5$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $87be5417a164885c$export$1b88f6b6d432a52a;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $87be5417a164885c$export$b70f6380221b1350;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $87be5417a164885c$export$75d6cbe4503e149;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $87be5417a164885c$export$b2618d51188815c2;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $87be5417a164885c$export$490814474ddbb428;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $87be5417a164885c$export$3ea201dffb50dfef;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $87be5417a164885c$export$d1012c7198c6b460;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $87be5417a164885c$export$a35a418b7b17958e;
});
class $87be5417a164885c$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - (from.z ?? 0), 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = (to.z ?? 0) - (from.z ?? 0);
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $87be5417a164885c$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $87be5417a164885c$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $87be5417a164885c$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $87be5417a164885c$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $87be5417a164885c$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $87be5417a164885c$export$75d6cbe4503e149(type, element)))
    ]);
}
function $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $87be5417a164885c$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $87be5417a164885c$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $87be5417a164885c$export$490814474ddbb428(element, className, display = 'block') {
    return $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $87be5417a164885c$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $87be5417a164885c$export$d1012c7198c6b460(element, className, remove) {
    return $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $87be5417a164885c$export$a35a418b7b17958e(element, className, remove) {
    return $87be5417a164885c$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $87be5417a164885c$var$$69bd9f0117925302$exports = {};
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$69bd9f0117925302$exports, "describe", function() {
    return $87be5417a164885c$export$cd5450f3a47e3789;
});
$87be5417a164885c$var$$parcel$export($87be5417a164885c$var$$69bd9f0117925302$exports, "it", function() {
    return $87be5417a164885c$export$3486a10f30cf1ee4;
});
async function $87be5417a164885c$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $87be5417a164885c$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$87be5417a164885c$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});
parcelRegister("j6tXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $de85d07330e094f9$export$2e2bcd8739ae039);

var $bfnCW = parcelRequire("bfnCW");

var $j9XcA = parcelRequire("j9XcA");

var $dPBRu = parcelRequire("dPBRu");
var $de85d07330e094f9$export$2e2bcd8739ae039 = new (0, $dPBRu.default)((0, $j9XcA.default), (0, $bfnCW.default))._freeze();

});
parcelRegister("bfnCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $83036c48076f3f32$export$2e2bcd8739ae039);
const $83036c48076f3f32$var$types = {
    'application/prs.cww': [
        'cww'
    ],
    'application/prs.xsf+xml': [
        'xsf'
    ],
    'application/vnd.1000minds.decision-model+xml': [
        '1km'
    ],
    'application/vnd.3gpp.pic-bw-large': [
        'plb'
    ],
    'application/vnd.3gpp.pic-bw-small': [
        'psb'
    ],
    'application/vnd.3gpp.pic-bw-var': [
        'pvb'
    ],
    'application/vnd.3gpp2.tcap': [
        'tcap'
    ],
    'application/vnd.3m.post-it-notes': [
        'pwn'
    ],
    'application/vnd.accpac.simply.aso': [
        'aso'
    ],
    'application/vnd.accpac.simply.imp': [
        'imp'
    ],
    'application/vnd.acucobol': [
        'acu'
    ],
    'application/vnd.acucorp': [
        'atc',
        'acutc'
    ],
    'application/vnd.adobe.air-application-installer-package+zip': [
        'air'
    ],
    'application/vnd.adobe.formscentral.fcdt': [
        'fcdt'
    ],
    'application/vnd.adobe.fxp': [
        'fxp',
        'fxpl'
    ],
    'application/vnd.adobe.xdp+xml': [
        'xdp'
    ],
    'application/vnd.adobe.xfdf': [
        '*xfdf'
    ],
    'application/vnd.age': [
        'age'
    ],
    'application/vnd.ahead.space': [
        'ahead'
    ],
    'application/vnd.airzip.filesecure.azf': [
        'azf'
    ],
    'application/vnd.airzip.filesecure.azs': [
        'azs'
    ],
    'application/vnd.amazon.ebook': [
        'azw'
    ],
    'application/vnd.americandynamics.acc': [
        'acc'
    ],
    'application/vnd.amiga.ami': [
        'ami'
    ],
    'application/vnd.android.package-archive': [
        'apk'
    ],
    'application/vnd.anser-web-certificate-issue-initiation': [
        'cii'
    ],
    'application/vnd.anser-web-funds-transfer-initiation': [
        'fti'
    ],
    'application/vnd.antix.game-component': [
        'atx'
    ],
    'application/vnd.apple.installer+xml': [
        'mpkg'
    ],
    'application/vnd.apple.keynote': [
        'key'
    ],
    'application/vnd.apple.mpegurl': [
        'm3u8'
    ],
    'application/vnd.apple.numbers': [
        'numbers'
    ],
    'application/vnd.apple.pages': [
        'pages'
    ],
    'application/vnd.apple.pkpass': [
        'pkpass'
    ],
    'application/vnd.aristanetworks.swi': [
        'swi'
    ],
    'application/vnd.astraea-software.iota': [
        'iota'
    ],
    'application/vnd.audiograph': [
        'aep'
    ],
    'application/vnd.autodesk.fbx': [
        'fbx'
    ],
    'application/vnd.balsamiq.bmml+xml': [
        'bmml'
    ],
    'application/vnd.blueice.multipass': [
        'mpm'
    ],
    'application/vnd.bmi': [
        'bmi'
    ],
    'application/vnd.businessobjects': [
        'rep'
    ],
    'application/vnd.chemdraw+xml': [
        'cdxml'
    ],
    'application/vnd.chipnuts.karaoke-mmd': [
        'mmd'
    ],
    'application/vnd.cinderella': [
        'cdy'
    ],
    'application/vnd.citationstyles.style+xml': [
        'csl'
    ],
    'application/vnd.claymore': [
        'cla'
    ],
    'application/vnd.cloanto.rp9': [
        'rp9'
    ],
    'application/vnd.clonk.c4group': [
        'c4g',
        'c4d',
        'c4f',
        'c4p',
        'c4u'
    ],
    'application/vnd.cluetrust.cartomobile-config': [
        'c11amc'
    ],
    'application/vnd.cluetrust.cartomobile-config-pkg': [
        'c11amz'
    ],
    'application/vnd.commonspace': [
        'csp'
    ],
    'application/vnd.contact.cmsg': [
        'cdbcmsg'
    ],
    'application/vnd.cosmocaller': [
        'cmc'
    ],
    'application/vnd.crick.clicker': [
        'clkx'
    ],
    'application/vnd.crick.clicker.keyboard': [
        'clkk'
    ],
    'application/vnd.crick.clicker.palette': [
        'clkp'
    ],
    'application/vnd.crick.clicker.template': [
        'clkt'
    ],
    'application/vnd.crick.clicker.wordbank': [
        'clkw'
    ],
    'application/vnd.criticaltools.wbs+xml': [
        'wbs'
    ],
    'application/vnd.ctc-posml': [
        'pml'
    ],
    'application/vnd.cups-ppd': [
        'ppd'
    ],
    'application/vnd.curl.car': [
        'car'
    ],
    'application/vnd.curl.pcurl': [
        'pcurl'
    ],
    'application/vnd.dart': [
        'dart'
    ],
    'application/vnd.data-vision.rdz': [
        'rdz'
    ],
    'application/vnd.dbf': [
        'dbf'
    ],
    'application/vnd.dcmp+xml': [
        'dcmp'
    ],
    'application/vnd.dece.data': [
        'uvf',
        'uvvf',
        'uvd',
        'uvvd'
    ],
    'application/vnd.dece.ttml+xml': [
        'uvt',
        'uvvt'
    ],
    'application/vnd.dece.unspecified': [
        'uvx',
        'uvvx'
    ],
    'application/vnd.dece.zip': [
        'uvz',
        'uvvz'
    ],
    'application/vnd.denovo.fcselayout-link': [
        'fe_launch'
    ],
    'application/vnd.dna': [
        'dna'
    ],
    'application/vnd.dolby.mlp': [
        'mlp'
    ],
    'application/vnd.dpgraph': [
        'dpg'
    ],
    'application/vnd.dreamfactory': [
        'dfac'
    ],
    'application/vnd.ds-keypoint': [
        'kpxx'
    ],
    'application/vnd.dvb.ait': [
        'ait'
    ],
    'application/vnd.dvb.service': [
        'svc'
    ],
    'application/vnd.dynageo': [
        'geo'
    ],
    'application/vnd.ecowin.chart': [
        'mag'
    ],
    'application/vnd.enliven': [
        'nml'
    ],
    'application/vnd.epson.esf': [
        'esf'
    ],
    'application/vnd.epson.msf': [
        'msf'
    ],
    'application/vnd.epson.quickanime': [
        'qam'
    ],
    'application/vnd.epson.salt': [
        'slt'
    ],
    'application/vnd.epson.ssf': [
        'ssf'
    ],
    'application/vnd.eszigno3+xml': [
        'es3',
        'et3'
    ],
    'application/vnd.ezpix-album': [
        'ez2'
    ],
    'application/vnd.ezpix-package': [
        'ez3'
    ],
    'application/vnd.fdf': [
        '*fdf'
    ],
    'application/vnd.fdsn.mseed': [
        'mseed'
    ],
    'application/vnd.fdsn.seed': [
        'seed',
        'dataless'
    ],
    'application/vnd.flographit': [
        'gph'
    ],
    'application/vnd.fluxtime.clip': [
        'ftc'
    ],
    'application/vnd.framemaker': [
        'fm',
        'frame',
        'maker',
        'book'
    ],
    'application/vnd.frogans.fnc': [
        'fnc'
    ],
    'application/vnd.frogans.ltf': [
        'ltf'
    ],
    'application/vnd.fsc.weblaunch': [
        'fsc'
    ],
    'application/vnd.fujitsu.oasys': [
        'oas'
    ],
    'application/vnd.fujitsu.oasys2': [
        'oa2'
    ],
    'application/vnd.fujitsu.oasys3': [
        'oa3'
    ],
    'application/vnd.fujitsu.oasysgp': [
        'fg5'
    ],
    'application/vnd.fujitsu.oasysprs': [
        'bh2'
    ],
    'application/vnd.fujixerox.ddd': [
        'ddd'
    ],
    'application/vnd.fujixerox.docuworks': [
        'xdw'
    ],
    'application/vnd.fujixerox.docuworks.binder': [
        'xbd'
    ],
    'application/vnd.fuzzysheet': [
        'fzs'
    ],
    'application/vnd.genomatix.tuxedo': [
        'txd'
    ],
    'application/vnd.geogebra.file': [
        'ggb'
    ],
    'application/vnd.geogebra.slides': [
        'ggs'
    ],
    'application/vnd.geogebra.tool': [
        'ggt'
    ],
    'application/vnd.geometry-explorer': [
        'gex',
        'gre'
    ],
    'application/vnd.geonext': [
        'gxt'
    ],
    'application/vnd.geoplan': [
        'g2w'
    ],
    'application/vnd.geospace': [
        'g3w'
    ],
    'application/vnd.gmx': [
        'gmx'
    ],
    'application/vnd.google-apps.document': [
        'gdoc'
    ],
    'application/vnd.google-apps.drawing': [
        'gdraw'
    ],
    'application/vnd.google-apps.form': [
        'gform'
    ],
    'application/vnd.google-apps.jam': [
        'gjam'
    ],
    'application/vnd.google-apps.map': [
        'gmap'
    ],
    'application/vnd.google-apps.presentation': [
        'gslides'
    ],
    'application/vnd.google-apps.script': [
        'gscript'
    ],
    'application/vnd.google-apps.site': [
        'gsite'
    ],
    'application/vnd.google-apps.spreadsheet': [
        'gsheet'
    ],
    'application/vnd.google-earth.kml+xml': [
        'kml'
    ],
    'application/vnd.google-earth.kmz': [
        'kmz'
    ],
    'application/vnd.gov.sk.xmldatacontainer+xml': [
        'xdcf'
    ],
    'application/vnd.grafeq': [
        'gqf',
        'gqs'
    ],
    'application/vnd.groove-account': [
        'gac'
    ],
    'application/vnd.groove-help': [
        'ghf'
    ],
    'application/vnd.groove-identity-message': [
        'gim'
    ],
    'application/vnd.groove-injector': [
        'grv'
    ],
    'application/vnd.groove-tool-message': [
        'gtm'
    ],
    'application/vnd.groove-tool-template': [
        'tpl'
    ],
    'application/vnd.groove-vcard': [
        'vcg'
    ],
    'application/vnd.hal+xml': [
        'hal'
    ],
    'application/vnd.handheld-entertainment+xml': [
        'zmm'
    ],
    'application/vnd.hbci': [
        'hbci'
    ],
    'application/vnd.hhe.lesson-player': [
        'les'
    ],
    'application/vnd.hp-hpgl': [
        'hpgl'
    ],
    'application/vnd.hp-hpid': [
        'hpid'
    ],
    'application/vnd.hp-hps': [
        'hps'
    ],
    'application/vnd.hp-jlyt': [
        'jlt'
    ],
    'application/vnd.hp-pcl': [
        'pcl'
    ],
    'application/vnd.hp-pclxl': [
        'pclxl'
    ],
    'application/vnd.hydrostatix.sof-data': [
        'sfd-hdstx'
    ],
    'application/vnd.ibm.minipay': [
        'mpy'
    ],
    'application/vnd.ibm.modcap': [
        'afp',
        'listafp',
        'list3820'
    ],
    'application/vnd.ibm.rights-management': [
        'irm'
    ],
    'application/vnd.ibm.secure-container': [
        'sc'
    ],
    'application/vnd.iccprofile': [
        'icc',
        'icm'
    ],
    'application/vnd.igloader': [
        'igl'
    ],
    'application/vnd.immervision-ivp': [
        'ivp'
    ],
    'application/vnd.immervision-ivu': [
        'ivu'
    ],
    'application/vnd.insors.igm': [
        'igm'
    ],
    'application/vnd.intercon.formnet': [
        'xpw',
        'xpx'
    ],
    'application/vnd.intergeo': [
        'i2g'
    ],
    'application/vnd.intu.qbo': [
        'qbo'
    ],
    'application/vnd.intu.qfx': [
        'qfx'
    ],
    'application/vnd.ipunplugged.rcprofile': [
        'rcprofile'
    ],
    'application/vnd.irepository.package+xml': [
        'irp'
    ],
    'application/vnd.is-xpr': [
        'xpr'
    ],
    'application/vnd.isac.fcs': [
        'fcs'
    ],
    'application/vnd.jam': [
        'jam'
    ],
    'application/vnd.jcp.javame.midlet-rms': [
        'rms'
    ],
    'application/vnd.jisp': [
        'jisp'
    ],
    'application/vnd.joost.joda-archive': [
        'joda'
    ],
    'application/vnd.kahootz': [
        'ktz',
        'ktr'
    ],
    'application/vnd.kde.karbon': [
        'karbon'
    ],
    'application/vnd.kde.kchart': [
        'chrt'
    ],
    'application/vnd.kde.kformula': [
        'kfo'
    ],
    'application/vnd.kde.kivio': [
        'flw'
    ],
    'application/vnd.kde.kontour': [
        'kon'
    ],
    'application/vnd.kde.kpresenter': [
        'kpr',
        'kpt'
    ],
    'application/vnd.kde.kspread': [
        'ksp'
    ],
    'application/vnd.kde.kword': [
        'kwd',
        'kwt'
    ],
    'application/vnd.kenameaapp': [
        'htke'
    ],
    'application/vnd.kidspiration': [
        'kia'
    ],
    'application/vnd.kinar': [
        'kne',
        'knp'
    ],
    'application/vnd.koan': [
        'skp',
        'skd',
        'skt',
        'skm'
    ],
    'application/vnd.kodak-descriptor': [
        'sse'
    ],
    'application/vnd.las.las+xml': [
        'lasxml'
    ],
    'application/vnd.llamagraphics.life-balance.desktop': [
        'lbd'
    ],
    'application/vnd.llamagraphics.life-balance.exchange+xml': [
        'lbe'
    ],
    'application/vnd.lotus-1-2-3': [
        '123'
    ],
    'application/vnd.lotus-approach': [
        'apr'
    ],
    'application/vnd.lotus-freelance': [
        'pre'
    ],
    'application/vnd.lotus-notes': [
        'nsf'
    ],
    'application/vnd.lotus-organizer': [
        'org'
    ],
    'application/vnd.lotus-screencam': [
        'scm'
    ],
    'application/vnd.lotus-wordpro': [
        'lwp'
    ],
    'application/vnd.macports.portpkg': [
        'portpkg'
    ],
    'application/vnd.mapbox-vector-tile': [
        'mvt'
    ],
    'application/vnd.mcd': [
        'mcd'
    ],
    'application/vnd.medcalcdata': [
        'mc1'
    ],
    'application/vnd.mediastation.cdkey': [
        'cdkey'
    ],
    'application/vnd.mfer': [
        'mwf'
    ],
    'application/vnd.mfmp': [
        'mfm'
    ],
    'application/vnd.micrografx.flo': [
        'flo'
    ],
    'application/vnd.micrografx.igx': [
        'igx'
    ],
    'application/vnd.mif': [
        'mif'
    ],
    'application/vnd.mobius.daf': [
        'daf'
    ],
    'application/vnd.mobius.dis': [
        'dis'
    ],
    'application/vnd.mobius.mbk': [
        'mbk'
    ],
    'application/vnd.mobius.mqy': [
        'mqy'
    ],
    'application/vnd.mobius.msl': [
        'msl'
    ],
    'application/vnd.mobius.plc': [
        'plc'
    ],
    'application/vnd.mobius.txf': [
        'txf'
    ],
    'application/vnd.mophun.application': [
        'mpn'
    ],
    'application/vnd.mophun.certificate': [
        'mpc'
    ],
    'application/vnd.mozilla.xul+xml': [
        'xul'
    ],
    'application/vnd.ms-artgalry': [
        'cil'
    ],
    'application/vnd.ms-cab-compressed': [
        'cab'
    ],
    'application/vnd.ms-excel': [
        'xls',
        'xlm',
        'xla',
        'xlc',
        'xlt',
        'xlw'
    ],
    'application/vnd.ms-excel.addin.macroenabled.12': [
        'xlam'
    ],
    'application/vnd.ms-excel.sheet.binary.macroenabled.12': [
        'xlsb'
    ],
    'application/vnd.ms-excel.sheet.macroenabled.12': [
        'xlsm'
    ],
    'application/vnd.ms-excel.template.macroenabled.12': [
        'xltm'
    ],
    'application/vnd.ms-fontobject': [
        'eot'
    ],
    'application/vnd.ms-htmlhelp': [
        'chm'
    ],
    'application/vnd.ms-ims': [
        'ims'
    ],
    'application/vnd.ms-lrm': [
        'lrm'
    ],
    'application/vnd.ms-officetheme': [
        'thmx'
    ],
    'application/vnd.ms-outlook': [
        'msg'
    ],
    'application/vnd.ms-pki.seccat': [
        'cat'
    ],
    'application/vnd.ms-pki.stl': [
        '*stl'
    ],
    'application/vnd.ms-powerpoint': [
        'ppt',
        'pps',
        'pot'
    ],
    'application/vnd.ms-powerpoint.addin.macroenabled.12': [
        'ppam'
    ],
    'application/vnd.ms-powerpoint.presentation.macroenabled.12': [
        'pptm'
    ],
    'application/vnd.ms-powerpoint.slide.macroenabled.12': [
        'sldm'
    ],
    'application/vnd.ms-powerpoint.slideshow.macroenabled.12': [
        'ppsm'
    ],
    'application/vnd.ms-powerpoint.template.macroenabled.12': [
        'potm'
    ],
    'application/vnd.ms-project': [
        '*mpp',
        'mpt'
    ],
    'application/vnd.ms-visio.viewer': [
        'vdx'
    ],
    'application/vnd.ms-word.document.macroenabled.12': [
        'docm'
    ],
    'application/vnd.ms-word.template.macroenabled.12': [
        'dotm'
    ],
    'application/vnd.ms-works': [
        'wps',
        'wks',
        'wcm',
        'wdb'
    ],
    'application/vnd.ms-wpl': [
        'wpl'
    ],
    'application/vnd.ms-xpsdocument': [
        'xps'
    ],
    'application/vnd.mseq': [
        'mseq'
    ],
    'application/vnd.musician': [
        'mus'
    ],
    'application/vnd.muvee.style': [
        'msty'
    ],
    'application/vnd.mynfc': [
        'taglet'
    ],
    'application/vnd.nato.bindingdataobject+xml': [
        'bdo'
    ],
    'application/vnd.neurolanguage.nlu': [
        'nlu'
    ],
    'application/vnd.nitf': [
        'ntf',
        'nitf'
    ],
    'application/vnd.noblenet-directory': [
        'nnd'
    ],
    'application/vnd.noblenet-sealer': [
        'nns'
    ],
    'application/vnd.noblenet-web': [
        'nnw'
    ],
    'application/vnd.nokia.n-gage.ac+xml': [
        '*ac'
    ],
    'application/vnd.nokia.n-gage.data': [
        'ngdat'
    ],
    'application/vnd.nokia.n-gage.symbian.install': [
        'n-gage'
    ],
    'application/vnd.nokia.radio-preset': [
        'rpst'
    ],
    'application/vnd.nokia.radio-presets': [
        'rpss'
    ],
    'application/vnd.novadigm.edm': [
        'edm'
    ],
    'application/vnd.novadigm.edx': [
        'edx'
    ],
    'application/vnd.novadigm.ext': [
        'ext'
    ],
    'application/vnd.oasis.opendocument.chart': [
        'odc'
    ],
    'application/vnd.oasis.opendocument.chart-template': [
        'otc'
    ],
    'application/vnd.oasis.opendocument.database': [
        'odb'
    ],
    'application/vnd.oasis.opendocument.formula': [
        'odf'
    ],
    'application/vnd.oasis.opendocument.formula-template': [
        'odft'
    ],
    'application/vnd.oasis.opendocument.graphics': [
        'odg'
    ],
    'application/vnd.oasis.opendocument.graphics-template': [
        'otg'
    ],
    'application/vnd.oasis.opendocument.image': [
        'odi'
    ],
    'application/vnd.oasis.opendocument.image-template': [
        'oti'
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'odp'
    ],
    'application/vnd.oasis.opendocument.presentation-template': [
        'otp'
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'ods'
    ],
    'application/vnd.oasis.opendocument.spreadsheet-template': [
        'ots'
    ],
    'application/vnd.oasis.opendocument.text': [
        'odt'
    ],
    'application/vnd.oasis.opendocument.text-master': [
        'odm'
    ],
    'application/vnd.oasis.opendocument.text-template': [
        'ott'
    ],
    'application/vnd.oasis.opendocument.text-web': [
        'oth'
    ],
    'application/vnd.olpc-sugar': [
        'xo'
    ],
    'application/vnd.oma.dd2+xml': [
        'dd2'
    ],
    'application/vnd.openblox.game+xml': [
        'obgx'
    ],
    'application/vnd.openofficeorg.extension': [
        'oxt'
    ],
    'application/vnd.openstreetmap.data+xml': [
        'osm'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'pptx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slide': [
        'sldx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        'ppsx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        'potx'
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'xlsx'
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        'xltx'
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'docx'
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        'dotx'
    ],
    'application/vnd.osgeo.mapguide.package': [
        'mgp'
    ],
    'application/vnd.osgi.dp': [
        'dp'
    ],
    'application/vnd.osgi.subsystem': [
        'esa'
    ],
    'application/vnd.palm': [
        'pdb',
        'pqa',
        'oprc'
    ],
    'application/vnd.pawaafile': [
        'paw'
    ],
    'application/vnd.pg.format': [
        'str'
    ],
    'application/vnd.pg.osasli': [
        'ei6'
    ],
    'application/vnd.picsel': [
        'efif'
    ],
    'application/vnd.pmi.widget': [
        'wg'
    ],
    'application/vnd.pocketlearn': [
        'plf'
    ],
    'application/vnd.powerbuilder6': [
        'pbd'
    ],
    'application/vnd.previewsystems.box': [
        'box'
    ],
    'application/vnd.procrate.brushset': [
        'brushset'
    ],
    'application/vnd.procreate.brush': [
        'brush'
    ],
    'application/vnd.procreate.dream': [
        'drm'
    ],
    'application/vnd.proteus.magazine': [
        'mgz'
    ],
    'application/vnd.publishare-delta-tree': [
        'qps'
    ],
    'application/vnd.pvi.ptid1': [
        'ptid'
    ],
    'application/vnd.pwg-xhtml-print+xml': [
        'xhtm'
    ],
    'application/vnd.quark.quarkxpress': [
        'qxd',
        'qxt',
        'qwd',
        'qwt',
        'qxl',
        'qxb'
    ],
    'application/vnd.rar': [
        'rar'
    ],
    'application/vnd.realvnc.bed': [
        'bed'
    ],
    'application/vnd.recordare.musicxml': [
        'mxl'
    ],
    'application/vnd.recordare.musicxml+xml': [
        'musicxml'
    ],
    'application/vnd.rig.cryptonote': [
        'cryptonote'
    ],
    'application/vnd.rim.cod': [
        'cod'
    ],
    'application/vnd.rn-realmedia': [
        'rm'
    ],
    'application/vnd.rn-realmedia-vbr': [
        'rmvb'
    ],
    'application/vnd.route66.link66+xml': [
        'link66'
    ],
    'application/vnd.sailingtracker.track': [
        'st'
    ],
    'application/vnd.seemail': [
        'see'
    ],
    'application/vnd.sema': [
        'sema'
    ],
    'application/vnd.semd': [
        'semd'
    ],
    'application/vnd.semf': [
        'semf'
    ],
    'application/vnd.shana.informed.formdata': [
        'ifm'
    ],
    'application/vnd.shana.informed.formtemplate': [
        'itp'
    ],
    'application/vnd.shana.informed.interchange': [
        'iif'
    ],
    'application/vnd.shana.informed.package': [
        'ipk'
    ],
    'application/vnd.simtech-mindmapper': [
        'twd',
        'twds'
    ],
    'application/vnd.smaf': [
        'mmf'
    ],
    'application/vnd.smart.teacher': [
        'teacher'
    ],
    'application/vnd.software602.filler.form+xml': [
        'fo'
    ],
    'application/vnd.solent.sdkm+xml': [
        'sdkm',
        'sdkd'
    ],
    'application/vnd.spotfire.dxp': [
        'dxp'
    ],
    'application/vnd.spotfire.sfs': [
        'sfs'
    ],
    'application/vnd.stardivision.calc': [
        'sdc'
    ],
    'application/vnd.stardivision.draw': [
        'sda'
    ],
    'application/vnd.stardivision.impress': [
        'sdd'
    ],
    'application/vnd.stardivision.math': [
        'smf'
    ],
    'application/vnd.stardivision.writer': [
        'sdw',
        'vor'
    ],
    'application/vnd.stardivision.writer-global': [
        'sgl'
    ],
    'application/vnd.stepmania.package': [
        'smzip'
    ],
    'application/vnd.stepmania.stepchart': [
        'sm'
    ],
    'application/vnd.sun.wadl+xml': [
        'wadl'
    ],
    'application/vnd.sun.xml.calc': [
        'sxc'
    ],
    'application/vnd.sun.xml.calc.template': [
        'stc'
    ],
    'application/vnd.sun.xml.draw': [
        'sxd'
    ],
    'application/vnd.sun.xml.draw.template': [
        'std'
    ],
    'application/vnd.sun.xml.impress': [
        'sxi'
    ],
    'application/vnd.sun.xml.impress.template': [
        'sti'
    ],
    'application/vnd.sun.xml.math': [
        'sxm'
    ],
    'application/vnd.sun.xml.writer': [
        'sxw'
    ],
    'application/vnd.sun.xml.writer.global': [
        'sxg'
    ],
    'application/vnd.sun.xml.writer.template': [
        'stw'
    ],
    'application/vnd.sus-calendar': [
        'sus',
        'susp'
    ],
    'application/vnd.svd': [
        'svd'
    ],
    'application/vnd.symbian.install': [
        'sis',
        'sisx'
    ],
    'application/vnd.syncml+xml': [
        'xsm'
    ],
    'application/vnd.syncml.dm+wbxml': [
        'bdm'
    ],
    'application/vnd.syncml.dm+xml': [
        'xdm'
    ],
    'application/vnd.syncml.dmddf+xml': [
        'ddf'
    ],
    'application/vnd.tao.intent-module-archive': [
        'tao'
    ],
    'application/vnd.tcpdump.pcap': [
        'pcap',
        'cap',
        'dmp'
    ],
    'application/vnd.tmobile-livetv': [
        'tmo'
    ],
    'application/vnd.trid.tpt': [
        'tpt'
    ],
    'application/vnd.triscape.mxs': [
        'mxs'
    ],
    'application/vnd.trueapp': [
        'tra'
    ],
    'application/vnd.ufdl': [
        'ufd',
        'ufdl'
    ],
    'application/vnd.uiq.theme': [
        'utz'
    ],
    'application/vnd.umajin': [
        'umj'
    ],
    'application/vnd.unity': [
        'unityweb'
    ],
    'application/vnd.uoml+xml': [
        'uoml',
        'uo'
    ],
    'application/vnd.vcx': [
        'vcx'
    ],
    'application/vnd.visio': [
        'vsd',
        'vst',
        'vss',
        'vsw',
        'vsdx',
        'vtx'
    ],
    'application/vnd.visionary': [
        'vis'
    ],
    'application/vnd.vsf': [
        'vsf'
    ],
    'application/vnd.wap.wbxml': [
        'wbxml'
    ],
    'application/vnd.wap.wmlc': [
        'wmlc'
    ],
    'application/vnd.wap.wmlscriptc': [
        'wmlsc'
    ],
    'application/vnd.webturbo': [
        'wtb'
    ],
    'application/vnd.wolfram.player': [
        'nbp'
    ],
    'application/vnd.wordperfect': [
        'wpd'
    ],
    'application/vnd.wqd': [
        'wqd'
    ],
    'application/vnd.wt.stf': [
        'stf'
    ],
    'application/vnd.xara': [
        'xar'
    ],
    'application/vnd.xfdl': [
        'xfdl'
    ],
    'application/vnd.yamaha.hv-dic': [
        'hvd'
    ],
    'application/vnd.yamaha.hv-script': [
        'hvs'
    ],
    'application/vnd.yamaha.hv-voice': [
        'hvp'
    ],
    'application/vnd.yamaha.openscoreformat': [
        'osf'
    ],
    'application/vnd.yamaha.openscoreformat.osfpvg+xml': [
        'osfpvg'
    ],
    'application/vnd.yamaha.smaf-audio': [
        'saf'
    ],
    'application/vnd.yamaha.smaf-phrase': [
        'spf'
    ],
    'application/vnd.yellowriver-custom-menu': [
        'cmp'
    ],
    'application/vnd.zul': [
        'zir',
        'zirz'
    ],
    'application/vnd.zzazz.deck+xml': [
        'zaz'
    ],
    'application/x-7z-compressed': [
        '7z'
    ],
    'application/x-abiword': [
        'abw'
    ],
    'application/x-ace-compressed': [
        'ace'
    ],
    'application/x-apple-diskimage': [
        '*dmg'
    ],
    'application/x-arj': [
        'arj'
    ],
    'application/x-authorware-bin': [
        'aab',
        'x32',
        'u32',
        'vox'
    ],
    'application/x-authorware-map': [
        'aam'
    ],
    'application/x-authorware-seg': [
        'aas'
    ],
    'application/x-bcpio': [
        'bcpio'
    ],
    'application/x-bdoc': [
        '*bdoc'
    ],
    'application/x-bittorrent': [
        'torrent'
    ],
    'application/x-blender': [
        'blend'
    ],
    'application/x-blorb': [
        'blb',
        'blorb'
    ],
    'application/x-bzip': [
        'bz'
    ],
    'application/x-bzip2': [
        'bz2',
        'boz'
    ],
    'application/x-cbr': [
        'cbr',
        'cba',
        'cbt',
        'cbz',
        'cb7'
    ],
    'application/x-cdlink': [
        'vcd'
    ],
    'application/x-cfs-compressed': [
        'cfs'
    ],
    'application/x-chat': [
        'chat'
    ],
    'application/x-chess-pgn': [
        'pgn'
    ],
    'application/x-chrome-extension': [
        'crx'
    ],
    'application/x-cocoa': [
        'cco'
    ],
    'application/x-compressed': [
        '*rar'
    ],
    'application/x-conference': [
        'nsc'
    ],
    'application/x-cpio': [
        'cpio'
    ],
    'application/x-csh': [
        'csh'
    ],
    'application/x-debian-package': [
        '*deb',
        'udeb'
    ],
    'application/x-dgc-compressed': [
        'dgc'
    ],
    'application/x-director': [
        'dir',
        'dcr',
        'dxr',
        'cst',
        'cct',
        'cxt',
        'w3d',
        'fgd',
        'swa'
    ],
    'application/x-doom': [
        'wad'
    ],
    'application/x-dtbncx+xml': [
        'ncx'
    ],
    'application/x-dtbook+xml': [
        'dtb'
    ],
    'application/x-dtbresource+xml': [
        'res'
    ],
    'application/x-dvi': [
        'dvi'
    ],
    'application/x-envoy': [
        'evy'
    ],
    'application/x-eva': [
        'eva'
    ],
    'application/x-font-bdf': [
        'bdf'
    ],
    'application/x-font-ghostscript': [
        'gsf'
    ],
    'application/x-font-linux-psf': [
        'psf'
    ],
    'application/x-font-pcf': [
        'pcf'
    ],
    'application/x-font-snf': [
        'snf'
    ],
    'application/x-font-type1': [
        'pfa',
        'pfb',
        'pfm',
        'afm'
    ],
    'application/x-freearc': [
        'arc'
    ],
    'application/x-futuresplash': [
        'spl'
    ],
    'application/x-gca-compressed': [
        'gca'
    ],
    'application/x-glulx': [
        'ulx'
    ],
    'application/x-gnumeric': [
        'gnumeric'
    ],
    'application/x-gramps-xml': [
        'gramps'
    ],
    'application/x-gtar': [
        'gtar'
    ],
    'application/x-hdf': [
        'hdf'
    ],
    'application/x-httpd-php': [
        'php'
    ],
    'application/x-install-instructions': [
        'install'
    ],
    'application/x-ipynb+json': [
        'ipynb'
    ],
    'application/x-iso9660-image': [
        '*iso'
    ],
    'application/x-iwork-keynote-sffkey': [
        '*key'
    ],
    'application/x-iwork-numbers-sffnumbers': [
        '*numbers'
    ],
    'application/x-iwork-pages-sffpages': [
        '*pages'
    ],
    'application/x-java-archive-diff': [
        'jardiff'
    ],
    'application/x-java-jnlp-file': [
        'jnlp'
    ],
    'application/x-keepass2': [
        'kdbx'
    ],
    'application/x-latex': [
        'latex'
    ],
    'application/x-lua-bytecode': [
        'luac'
    ],
    'application/x-lzh-compressed': [
        'lzh',
        'lha'
    ],
    'application/x-makeself': [
        'run'
    ],
    'application/x-mie': [
        'mie'
    ],
    'application/x-mobipocket-ebook': [
        '*prc',
        'mobi'
    ],
    'application/x-ms-application': [
        'application'
    ],
    'application/x-ms-shortcut': [
        'lnk'
    ],
    'application/x-ms-wmd': [
        'wmd'
    ],
    'application/x-ms-wmz': [
        'wmz'
    ],
    'application/x-ms-xbap': [
        'xbap'
    ],
    'application/x-msaccess': [
        'mdb'
    ],
    'application/x-msbinder': [
        'obd'
    ],
    'application/x-mscardfile': [
        'crd'
    ],
    'application/x-msclip': [
        'clp'
    ],
    'application/x-msdos-program': [
        '*exe'
    ],
    'application/x-msdownload': [
        '*exe',
        '*dll',
        'com',
        'bat',
        '*msi'
    ],
    'application/x-msmediaview': [
        'mvb',
        'm13',
        'm14'
    ],
    'application/x-msmetafile': [
        '*wmf',
        '*wmz',
        '*emf',
        'emz'
    ],
    'application/x-msmoney': [
        'mny'
    ],
    'application/x-mspublisher': [
        'pub'
    ],
    'application/x-msschedule': [
        'scd'
    ],
    'application/x-msterminal': [
        'trm'
    ],
    'application/x-mswrite': [
        'wri'
    ],
    'application/x-netcdf': [
        'nc',
        'cdf'
    ],
    'application/x-ns-proxy-autoconfig': [
        'pac'
    ],
    'application/x-nzb': [
        'nzb'
    ],
    'application/x-perl': [
        'pl',
        'pm'
    ],
    'application/x-pilot': [
        '*prc',
        '*pdb'
    ],
    'application/x-pkcs12': [
        'p12',
        'pfx'
    ],
    'application/x-pkcs7-certificates': [
        'p7b',
        'spc'
    ],
    'application/x-pkcs7-certreqresp': [
        'p7r'
    ],
    'application/x-rar-compressed': [
        '*rar'
    ],
    'application/x-redhat-package-manager': [
        'rpm'
    ],
    'application/x-research-info-systems': [
        'ris'
    ],
    'application/x-sea': [
        'sea'
    ],
    'application/x-sh': [
        'sh'
    ],
    'application/x-shar': [
        'shar'
    ],
    'application/x-shockwave-flash': [
        'swf'
    ],
    'application/x-silverlight-app': [
        'xap'
    ],
    'application/x-sql': [
        '*sql'
    ],
    'application/x-stuffit': [
        'sit'
    ],
    'application/x-stuffitx': [
        'sitx'
    ],
    'application/x-subrip': [
        'srt'
    ],
    'application/x-sv4cpio': [
        'sv4cpio'
    ],
    'application/x-sv4crc': [
        'sv4crc'
    ],
    'application/x-t3vm-image': [
        't3'
    ],
    'application/x-tads': [
        'gam'
    ],
    'application/x-tar': [
        'tar'
    ],
    'application/x-tcl': [
        'tcl',
        'tk'
    ],
    'application/x-tex': [
        'tex'
    ],
    'application/x-tex-tfm': [
        'tfm'
    ],
    'application/x-texinfo': [
        'texinfo',
        'texi'
    ],
    'application/x-tgif': [
        '*obj'
    ],
    'application/x-ustar': [
        'ustar'
    ],
    'application/x-virtualbox-hdd': [
        'hdd'
    ],
    'application/x-virtualbox-ova': [
        'ova'
    ],
    'application/x-virtualbox-ovf': [
        'ovf'
    ],
    'application/x-virtualbox-vbox': [
        'vbox'
    ],
    'application/x-virtualbox-vbox-extpack': [
        'vbox-extpack'
    ],
    'application/x-virtualbox-vdi': [
        'vdi'
    ],
    'application/x-virtualbox-vhd': [
        'vhd'
    ],
    'application/x-virtualbox-vmdk': [
        'vmdk'
    ],
    'application/x-wais-source': [
        'src'
    ],
    'application/x-web-app-manifest+json': [
        'webapp'
    ],
    'application/x-x509-ca-cert': [
        'der',
        'crt',
        'pem'
    ],
    'application/x-xfig': [
        'fig'
    ],
    'application/x-xliff+xml': [
        '*xlf'
    ],
    'application/x-xpinstall': [
        'xpi'
    ],
    'application/x-xz': [
        'xz'
    ],
    'application/x-zip-compressed': [
        '*zip'
    ],
    'application/x-zmachine': [
        'z1',
        'z2',
        'z3',
        'z4',
        'z5',
        'z6',
        'z7',
        'z8'
    ],
    'audio/vnd.dece.audio': [
        'uva',
        'uvva'
    ],
    'audio/vnd.digital-winds': [
        'eol'
    ],
    'audio/vnd.dra': [
        'dra'
    ],
    'audio/vnd.dts': [
        'dts'
    ],
    'audio/vnd.dts.hd': [
        'dtshd'
    ],
    'audio/vnd.lucent.voice': [
        'lvp'
    ],
    'audio/vnd.ms-playready.media.pya': [
        'pya'
    ],
    'audio/vnd.nuera.ecelp4800': [
        'ecelp4800'
    ],
    'audio/vnd.nuera.ecelp7470': [
        'ecelp7470'
    ],
    'audio/vnd.nuera.ecelp9600': [
        'ecelp9600'
    ],
    'audio/vnd.rip': [
        'rip'
    ],
    'audio/x-aac': [
        '*aac'
    ],
    'audio/x-aiff': [
        'aif',
        'aiff',
        'aifc'
    ],
    'audio/x-caf': [
        'caf'
    ],
    'audio/x-flac': [
        'flac'
    ],
    'audio/x-m4a': [
        '*m4a'
    ],
    'audio/x-matroska': [
        'mka'
    ],
    'audio/x-mpegurl': [
        'm3u'
    ],
    'audio/x-ms-wax': [
        'wax'
    ],
    'audio/x-ms-wma': [
        'wma'
    ],
    'audio/x-pn-realaudio': [
        'ram',
        'ra'
    ],
    'audio/x-pn-realaudio-plugin': [
        'rmp'
    ],
    'audio/x-realaudio': [
        '*ra'
    ],
    'audio/x-wav': [
        '*wav'
    ],
    'chemical/x-cdx': [
        'cdx'
    ],
    'chemical/x-cif': [
        'cif'
    ],
    'chemical/x-cmdf': [
        'cmdf'
    ],
    'chemical/x-cml': [
        'cml'
    ],
    'chemical/x-csml': [
        'csml'
    ],
    'chemical/x-xyz': [
        'xyz'
    ],
    'image/prs.btif': [
        'btif',
        'btf'
    ],
    'image/prs.pti': [
        'pti'
    ],
    'image/vnd.adobe.photoshop': [
        'psd'
    ],
    'image/vnd.airzip.accelerator.azv': [
        'azv'
    ],
    'image/vnd.blockfact.facti': [
        'facti'
    ],
    'image/vnd.dece.graphic': [
        'uvi',
        'uvvi',
        'uvg',
        'uvvg'
    ],
    'image/vnd.djvu': [
        'djvu',
        'djv'
    ],
    'image/vnd.dvb.subtitle': [
        '*sub'
    ],
    'image/vnd.dwg': [
        'dwg'
    ],
    'image/vnd.dxf': [
        'dxf'
    ],
    'image/vnd.fastbidsheet': [
        'fbs'
    ],
    'image/vnd.fpx': [
        'fpx'
    ],
    'image/vnd.fst': [
        'fst'
    ],
    'image/vnd.fujixerox.edmics-mmr': [
        'mmr'
    ],
    'image/vnd.fujixerox.edmics-rlc': [
        'rlc'
    ],
    'image/vnd.microsoft.icon': [
        'ico'
    ],
    'image/vnd.ms-dds': [
        'dds'
    ],
    'image/vnd.ms-modi': [
        'mdi'
    ],
    'image/vnd.ms-photo': [
        'wdp'
    ],
    'image/vnd.net-fpx': [
        'npx'
    ],
    'image/vnd.pco.b16': [
        'b16'
    ],
    'image/vnd.tencent.tap': [
        'tap'
    ],
    'image/vnd.valve.source.texture': [
        'vtf'
    ],
    'image/vnd.wap.wbmp': [
        'wbmp'
    ],
    'image/vnd.xiff': [
        'xif'
    ],
    'image/vnd.zbrush.pcx': [
        'pcx'
    ],
    'image/x-3ds': [
        '3ds'
    ],
    'image/x-adobe-dng': [
        'dng'
    ],
    'image/x-cmu-raster': [
        'ras'
    ],
    'image/x-cmx': [
        'cmx'
    ],
    'image/x-freehand': [
        'fh',
        'fhc',
        'fh4',
        'fh5',
        'fh7'
    ],
    'image/x-icon': [
        '*ico'
    ],
    'image/x-jng': [
        'jng'
    ],
    'image/x-mrsid-image': [
        'sid'
    ],
    'image/x-ms-bmp': [
        '*bmp'
    ],
    'image/x-pcx': [
        '*pcx'
    ],
    'image/x-pict': [
        'pic',
        'pct'
    ],
    'image/x-portable-anymap': [
        'pnm'
    ],
    'image/x-portable-bitmap': [
        'pbm'
    ],
    'image/x-portable-graymap': [
        'pgm'
    ],
    'image/x-portable-pixmap': [
        'ppm'
    ],
    'image/x-rgb': [
        'rgb'
    ],
    'image/x-tga': [
        'tga'
    ],
    'image/x-xbitmap': [
        'xbm'
    ],
    'image/x-xpixmap': [
        'xpm'
    ],
    'image/x-xwindowdump': [
        'xwd'
    ],
    'message/vnd.wfa.wsc': [
        'wsc'
    ],
    'model/vnd.bary': [
        'bary'
    ],
    'model/vnd.cld': [
        'cld'
    ],
    'model/vnd.collada+xml': [
        'dae'
    ],
    'model/vnd.dwf': [
        'dwf'
    ],
    'model/vnd.gdl': [
        'gdl'
    ],
    'model/vnd.gtw': [
        'gtw'
    ],
    'model/vnd.mts': [
        '*mts'
    ],
    'model/vnd.opengex': [
        'ogex'
    ],
    'model/vnd.parasolid.transmit.binary': [
        'x_b'
    ],
    'model/vnd.parasolid.transmit.text': [
        'x_t'
    ],
    'model/vnd.pytha.pyox': [
        'pyo',
        'pyox'
    ],
    'model/vnd.sap.vds': [
        'vds'
    ],
    'model/vnd.usda': [
        'usda'
    ],
    'model/vnd.usdz+zip': [
        'usdz'
    ],
    'model/vnd.valve.source.compiled-map': [
        'bsp'
    ],
    'model/vnd.vtu': [
        'vtu'
    ],
    'text/prs.lines.tag': [
        'dsc'
    ],
    'text/vnd.curl': [
        'curl'
    ],
    'text/vnd.curl.dcurl': [
        'dcurl'
    ],
    'text/vnd.curl.mcurl': [
        'mcurl'
    ],
    'text/vnd.curl.scurl': [
        'scurl'
    ],
    'text/vnd.dvb.subtitle': [
        'sub'
    ],
    'text/vnd.familysearch.gedcom': [
        'ged'
    ],
    'text/vnd.fly': [
        'fly'
    ],
    'text/vnd.fmi.flexstor': [
        'flx'
    ],
    'text/vnd.graphviz': [
        'gv'
    ],
    'text/vnd.in3d.3dml': [
        '3dml'
    ],
    'text/vnd.in3d.spot': [
        'spot'
    ],
    'text/vnd.sun.j2me.app-descriptor': [
        'jad'
    ],
    'text/vnd.wap.wml': [
        'wml'
    ],
    'text/vnd.wap.wmlscript': [
        'wmls'
    ],
    'text/x-asm': [
        's',
        'asm'
    ],
    'text/x-c': [
        'c',
        'cc',
        'cxx',
        'cpp',
        'h',
        'hh',
        'dic'
    ],
    'text/x-component': [
        'htc'
    ],
    'text/x-fortran': [
        'f',
        'for',
        'f77',
        'f90'
    ],
    'text/x-handlebars-template': [
        'hbs'
    ],
    'text/x-java-source': [
        'java'
    ],
    'text/x-lua': [
        'lua'
    ],
    'text/x-markdown': [
        'mkd'
    ],
    'text/x-nfo': [
        'nfo'
    ],
    'text/x-opml': [
        'opml'
    ],
    'text/x-org': [
        '*org'
    ],
    'text/x-pascal': [
        'p',
        'pas'
    ],
    'text/x-processing': [
        'pde'
    ],
    'text/x-sass': [
        'sass'
    ],
    'text/x-scss': [
        'scss'
    ],
    'text/x-setext': [
        'etx'
    ],
    'text/x-sfv': [
        'sfv'
    ],
    'text/x-suse-ymp': [
        'ymp'
    ],
    'text/x-uuencode': [
        'uu'
    ],
    'text/x-vcalendar': [
        'vcs'
    ],
    'text/x-vcard': [
        'vcf'
    ],
    'video/vnd.dece.hd': [
        'uvh',
        'uvvh'
    ],
    'video/vnd.dece.mobile': [
        'uvm',
        'uvvm'
    ],
    'video/vnd.dece.pd': [
        'uvp',
        'uvvp'
    ],
    'video/vnd.dece.sd': [
        'uvs',
        'uvvs'
    ],
    'video/vnd.dece.video': [
        'uvv',
        'uvvv'
    ],
    'video/vnd.dvb.file': [
        'dvb'
    ],
    'video/vnd.fvt': [
        'fvt'
    ],
    'video/vnd.mpegurl': [
        'mxu',
        'm4u'
    ],
    'video/vnd.ms-playready.media.pyv': [
        'pyv'
    ],
    'video/vnd.uvvu.mp4': [
        'uvu',
        'uvvu'
    ],
    'video/vnd.vivo': [
        'viv'
    ],
    'video/x-f4v': [
        'f4v'
    ],
    'video/x-fli': [
        'fli'
    ],
    'video/x-flv': [
        'flv'
    ],
    'video/x-m4v': [
        'm4v'
    ],
    'video/x-matroska': [
        'mkv',
        'mk3d',
        'mks'
    ],
    'video/x-mng': [
        'mng'
    ],
    'video/x-ms-asf': [
        'asf',
        'asx'
    ],
    'video/x-ms-vob': [
        'vob'
    ],
    'video/x-ms-wm': [
        'wm'
    ],
    'video/x-ms-wmv': [
        'wmv'
    ],
    'video/x-ms-wmx': [
        'wmx'
    ],
    'video/x-ms-wvx': [
        'wvx'
    ],
    'video/x-msvideo': [
        'avi'
    ],
    'video/x-sgi-movie': [
        'movie'
    ],
    'video/x-smv': [
        'smv'
    ],
    'x-conference/x-cooltalk': [
        'ice'
    ]
};
Object.freeze($83036c48076f3f32$var$types);
var $83036c48076f3f32$export$2e2bcd8739ae039 = $83036c48076f3f32$var$types;

});

parcelRegister("j9XcA", function(module, exports) {

$parcel$export(module.exports, "default", () => $df2cc7dd68f985c2$export$2e2bcd8739ae039);
const $df2cc7dd68f985c2$var$types = {
    'application/andrew-inset': [
        'ez'
    ],
    'application/appinstaller': [
        'appinstaller'
    ],
    'application/applixware': [
        'aw'
    ],
    'application/appx': [
        'appx'
    ],
    'application/appxbundle': [
        'appxbundle'
    ],
    'application/atom+xml': [
        'atom'
    ],
    'application/atomcat+xml': [
        'atomcat'
    ],
    'application/atomdeleted+xml': [
        'atomdeleted'
    ],
    'application/atomsvc+xml': [
        'atomsvc'
    ],
    'application/atsc-dwd+xml': [
        'dwd'
    ],
    'application/atsc-held+xml': [
        'held'
    ],
    'application/atsc-rsat+xml': [
        'rsat'
    ],
    'application/automationml-aml+xml': [
        'aml'
    ],
    'application/automationml-amlx+zip': [
        'amlx'
    ],
    'application/bdoc': [
        'bdoc'
    ],
    'application/calendar+xml': [
        'xcs'
    ],
    'application/ccxml+xml': [
        'ccxml'
    ],
    'application/cdfx+xml': [
        'cdfx'
    ],
    'application/cdmi-capability': [
        'cdmia'
    ],
    'application/cdmi-container': [
        'cdmic'
    ],
    'application/cdmi-domain': [
        'cdmid'
    ],
    'application/cdmi-object': [
        'cdmio'
    ],
    'application/cdmi-queue': [
        'cdmiq'
    ],
    'application/cpl+xml': [
        'cpl'
    ],
    'application/cu-seeme': [
        'cu'
    ],
    'application/cwl': [
        'cwl'
    ],
    'application/dash+xml': [
        'mpd'
    ],
    'application/dash-patch+xml': [
        'mpp'
    ],
    'application/davmount+xml': [
        'davmount'
    ],
    'application/dicom': [
        'dcm'
    ],
    'application/docbook+xml': [
        'dbk'
    ],
    'application/dssc+der': [
        'dssc'
    ],
    'application/dssc+xml': [
        'xdssc'
    ],
    'application/ecmascript': [
        'ecma'
    ],
    'application/emma+xml': [
        'emma'
    ],
    'application/emotionml+xml': [
        'emotionml'
    ],
    'application/epub+zip': [
        'epub'
    ],
    'application/exi': [
        'exi'
    ],
    'application/express': [
        'exp'
    ],
    'application/fdf': [
        'fdf'
    ],
    'application/fdt+xml': [
        'fdt'
    ],
    'application/font-tdpfr': [
        'pfr'
    ],
    'application/geo+json': [
        'geojson'
    ],
    'application/gml+xml': [
        'gml'
    ],
    'application/gpx+xml': [
        'gpx'
    ],
    'application/gxf': [
        'gxf'
    ],
    'application/gzip': [
        'gz'
    ],
    'application/hjson': [
        'hjson'
    ],
    'application/hyperstudio': [
        'stk'
    ],
    'application/inkml+xml': [
        'ink',
        'inkml'
    ],
    'application/ipfix': [
        'ipfix'
    ],
    'application/its+xml': [
        'its'
    ],
    'application/java-archive': [
        'jar',
        'war',
        'ear'
    ],
    'application/java-serialized-object': [
        'ser'
    ],
    'application/java-vm': [
        'class'
    ],
    'application/javascript': [
        '*js'
    ],
    'application/json': [
        'json',
        'map'
    ],
    'application/json5': [
        'json5'
    ],
    'application/jsonml+json': [
        'jsonml'
    ],
    'application/ld+json': [
        'jsonld'
    ],
    'application/lgr+xml': [
        'lgr'
    ],
    'application/lost+xml': [
        'lostxml'
    ],
    'application/mac-binhex40': [
        'hqx'
    ],
    'application/mac-compactpro': [
        'cpt'
    ],
    'application/mads+xml': [
        'mads'
    ],
    'application/manifest+json': [
        'webmanifest'
    ],
    'application/marc': [
        'mrc'
    ],
    'application/marcxml+xml': [
        'mrcx'
    ],
    'application/mathematica': [
        'ma',
        'nb',
        'mb'
    ],
    'application/mathml+xml': [
        'mathml'
    ],
    'application/mbox': [
        'mbox'
    ],
    'application/media-policy-dataset+xml': [
        'mpf'
    ],
    'application/mediaservercontrol+xml': [
        'mscml'
    ],
    'application/metalink+xml': [
        'metalink'
    ],
    'application/metalink4+xml': [
        'meta4'
    ],
    'application/mets+xml': [
        'mets'
    ],
    'application/mmt-aei+xml': [
        'maei'
    ],
    'application/mmt-usd+xml': [
        'musd'
    ],
    'application/mods+xml': [
        'mods'
    ],
    'application/mp21': [
        'm21',
        'mp21'
    ],
    'application/mp4': [
        '*mp4',
        '*mpg4',
        'mp4s',
        'm4p'
    ],
    'application/msix': [
        'msix'
    ],
    'application/msixbundle': [
        'msixbundle'
    ],
    'application/msword': [
        'doc',
        'dot'
    ],
    'application/mxf': [
        'mxf'
    ],
    'application/n-quads': [
        'nq'
    ],
    'application/n-triples': [
        'nt'
    ],
    'application/node': [
        'cjs'
    ],
    'application/octet-stream': [
        'bin',
        'dms',
        'lrf',
        'mar',
        'so',
        'dist',
        'distz',
        'pkg',
        'bpk',
        'dump',
        'elc',
        'deploy',
        'exe',
        'dll',
        'deb',
        'dmg',
        'iso',
        'img',
        'msi',
        'msp',
        'msm',
        'buffer'
    ],
    'application/oda': [
        'oda'
    ],
    'application/oebps-package+xml': [
        'opf'
    ],
    'application/ogg': [
        'ogx'
    ],
    'application/omdoc+xml': [
        'omdoc'
    ],
    'application/onenote': [
        'onetoc',
        'onetoc2',
        'onetmp',
        'onepkg',
        'one',
        'onea'
    ],
    'application/oxps': [
        'oxps'
    ],
    'application/p2p-overlay+xml': [
        'relo'
    ],
    'application/patch-ops-error+xml': [
        'xer'
    ],
    'application/pdf': [
        'pdf'
    ],
    'application/pgp-encrypted': [
        'pgp'
    ],
    'application/pgp-keys': [
        'asc'
    ],
    'application/pgp-signature': [
        'sig',
        '*asc'
    ],
    'application/pics-rules': [
        'prf'
    ],
    'application/pkcs10': [
        'p10'
    ],
    'application/pkcs7-mime': [
        'p7m',
        'p7c'
    ],
    'application/pkcs7-signature': [
        'p7s'
    ],
    'application/pkcs8': [
        'p8'
    ],
    'application/pkix-attr-cert': [
        'ac'
    ],
    'application/pkix-cert': [
        'cer'
    ],
    'application/pkix-crl': [
        'crl'
    ],
    'application/pkix-pkipath': [
        'pkipath'
    ],
    'application/pkixcmp': [
        'pki'
    ],
    'application/pls+xml': [
        'pls'
    ],
    'application/postscript': [
        'ai',
        'eps',
        'ps'
    ],
    'application/provenance+xml': [
        'provx'
    ],
    'application/pskc+xml': [
        'pskcxml'
    ],
    'application/raml+yaml': [
        'raml'
    ],
    'application/rdf+xml': [
        'rdf',
        'owl'
    ],
    'application/reginfo+xml': [
        'rif'
    ],
    'application/relax-ng-compact-syntax': [
        'rnc'
    ],
    'application/resource-lists+xml': [
        'rl'
    ],
    'application/resource-lists-diff+xml': [
        'rld'
    ],
    'application/rls-services+xml': [
        'rs'
    ],
    'application/route-apd+xml': [
        'rapd'
    ],
    'application/route-s-tsid+xml': [
        'sls'
    ],
    'application/route-usd+xml': [
        'rusd'
    ],
    'application/rpki-ghostbusters': [
        'gbr'
    ],
    'application/rpki-manifest': [
        'mft'
    ],
    'application/rpki-roa': [
        'roa'
    ],
    'application/rsd+xml': [
        'rsd'
    ],
    'application/rss+xml': [
        'rss'
    ],
    'application/rtf': [
        'rtf'
    ],
    'application/sbml+xml': [
        'sbml'
    ],
    'application/scvp-cv-request': [
        'scq'
    ],
    'application/scvp-cv-response': [
        'scs'
    ],
    'application/scvp-vp-request': [
        'spq'
    ],
    'application/scvp-vp-response': [
        'spp'
    ],
    'application/sdp': [
        'sdp'
    ],
    'application/senml+xml': [
        'senmlx'
    ],
    'application/sensml+xml': [
        'sensmlx'
    ],
    'application/set-payment-initiation': [
        'setpay'
    ],
    'application/set-registration-initiation': [
        'setreg'
    ],
    'application/shf+xml': [
        'shf'
    ],
    'application/sieve': [
        'siv',
        'sieve'
    ],
    'application/smil+xml': [
        'smi',
        'smil'
    ],
    'application/sparql-query': [
        'rq'
    ],
    'application/sparql-results+xml': [
        'srx'
    ],
    'application/sql': [
        'sql'
    ],
    'application/srgs': [
        'gram'
    ],
    'application/srgs+xml': [
        'grxml'
    ],
    'application/sru+xml': [
        'sru'
    ],
    'application/ssdl+xml': [
        'ssdl'
    ],
    'application/ssml+xml': [
        'ssml'
    ],
    'application/swid+xml': [
        'swidtag'
    ],
    'application/tei+xml': [
        'tei',
        'teicorpus'
    ],
    'application/thraud+xml': [
        'tfi'
    ],
    'application/timestamped-data': [
        'tsd'
    ],
    'application/toml': [
        'toml'
    ],
    'application/trig': [
        'trig'
    ],
    'application/ttml+xml': [
        'ttml'
    ],
    'application/ubjson': [
        'ubj'
    ],
    'application/urc-ressheet+xml': [
        'rsheet'
    ],
    'application/urc-targetdesc+xml': [
        'td'
    ],
    'application/voicexml+xml': [
        'vxml'
    ],
    'application/wasm': [
        'wasm'
    ],
    'application/watcherinfo+xml': [
        'wif'
    ],
    'application/widget': [
        'wgt'
    ],
    'application/winhlp': [
        'hlp'
    ],
    'application/wsdl+xml': [
        'wsdl'
    ],
    'application/wspolicy+xml': [
        'wspolicy'
    ],
    'application/xaml+xml': [
        'xaml'
    ],
    'application/xcap-att+xml': [
        'xav'
    ],
    'application/xcap-caps+xml': [
        'xca'
    ],
    'application/xcap-diff+xml': [
        'xdf'
    ],
    'application/xcap-el+xml': [
        'xel'
    ],
    'application/xcap-ns+xml': [
        'xns'
    ],
    'application/xenc+xml': [
        'xenc'
    ],
    'application/xfdf': [
        'xfdf'
    ],
    'application/xhtml+xml': [
        'xhtml',
        'xht'
    ],
    'application/xliff+xml': [
        'xlf'
    ],
    'application/xml': [
        'xml',
        'xsl',
        'xsd',
        'rng'
    ],
    'application/xml-dtd': [
        'dtd'
    ],
    'application/xop+xml': [
        'xop'
    ],
    'application/xproc+xml': [
        'xpl'
    ],
    'application/xslt+xml': [
        '*xsl',
        'xslt'
    ],
    'application/xspf+xml': [
        'xspf'
    ],
    'application/xv+xml': [
        'mxml',
        'xhvml',
        'xvml',
        'xvm'
    ],
    'application/yang': [
        'yang'
    ],
    'application/yin+xml': [
        'yin'
    ],
    'application/zip': [
        'zip'
    ],
    'application/zip+dotlottie': [
        'lottie'
    ],
    'audio/3gpp': [
        '*3gpp'
    ],
    'audio/aac': [
        'adts',
        'aac'
    ],
    'audio/adpcm': [
        'adp'
    ],
    'audio/amr': [
        'amr'
    ],
    'audio/basic': [
        'au',
        'snd'
    ],
    'audio/midi': [
        'mid',
        'midi',
        'kar',
        'rmi'
    ],
    'audio/mobile-xmf': [
        'mxmf'
    ],
    'audio/mp3': [
        '*mp3'
    ],
    'audio/mp4': [
        'm4a',
        'mp4a',
        'm4b'
    ],
    'audio/mpeg': [
        'mpga',
        'mp2',
        'mp2a',
        'mp3',
        'm2a',
        'm3a'
    ],
    'audio/ogg': [
        'oga',
        'ogg',
        'spx',
        'opus'
    ],
    'audio/s3m': [
        's3m'
    ],
    'audio/silk': [
        'sil'
    ],
    'audio/wav': [
        'wav'
    ],
    'audio/wave': [
        '*wav'
    ],
    'audio/webm': [
        'weba'
    ],
    'audio/xm': [
        'xm'
    ],
    'font/collection': [
        'ttc'
    ],
    'font/otf': [
        'otf'
    ],
    'font/ttf': [
        'ttf'
    ],
    'font/woff': [
        'woff'
    ],
    'font/woff2': [
        'woff2'
    ],
    'image/aces': [
        'exr'
    ],
    'image/apng': [
        'apng'
    ],
    'image/avci': [
        'avci'
    ],
    'image/avcs': [
        'avcs'
    ],
    'image/avif': [
        'avif'
    ],
    'image/bmp': [
        'bmp',
        'dib'
    ],
    'image/cgm': [
        'cgm'
    ],
    'image/dicom-rle': [
        'drle'
    ],
    'image/dpx': [
        'dpx'
    ],
    'image/emf': [
        'emf'
    ],
    'image/fits': [
        'fits'
    ],
    'image/g3fax': [
        'g3'
    ],
    'image/gif': [
        'gif'
    ],
    'image/heic': [
        'heic'
    ],
    'image/heic-sequence': [
        'heics'
    ],
    'image/heif': [
        'heif'
    ],
    'image/heif-sequence': [
        'heifs'
    ],
    'image/hej2k': [
        'hej2'
    ],
    'image/ief': [
        'ief'
    ],
    'image/jaii': [
        'jaii'
    ],
    'image/jais': [
        'jais'
    ],
    'image/jls': [
        'jls'
    ],
    'image/jp2': [
        'jp2',
        'jpg2'
    ],
    'image/jpeg': [
        'jpg',
        'jpeg',
        'jpe'
    ],
    'image/jph': [
        'jph'
    ],
    'image/jphc': [
        'jhc'
    ],
    'image/jpm': [
        'jpm',
        'jpgm'
    ],
    'image/jpx': [
        'jpx',
        'jpf'
    ],
    'image/jxl': [
        'jxl'
    ],
    'image/jxr': [
        'jxr'
    ],
    'image/jxra': [
        'jxra'
    ],
    'image/jxrs': [
        'jxrs'
    ],
    'image/jxs': [
        'jxs'
    ],
    'image/jxsc': [
        'jxsc'
    ],
    'image/jxsi': [
        'jxsi'
    ],
    'image/jxss': [
        'jxss'
    ],
    'image/ktx': [
        'ktx'
    ],
    'image/ktx2': [
        'ktx2'
    ],
    'image/pjpeg': [
        'jfif'
    ],
    'image/png': [
        'png'
    ],
    'image/sgi': [
        'sgi'
    ],
    'image/svg+xml': [
        'svg',
        'svgz'
    ],
    'image/t38': [
        't38'
    ],
    'image/tiff': [
        'tif',
        'tiff'
    ],
    'image/tiff-fx': [
        'tfx'
    ],
    'image/webp': [
        'webp'
    ],
    'image/wmf': [
        'wmf'
    ],
    'message/disposition-notification': [
        'disposition-notification'
    ],
    'message/global': [
        'u8msg'
    ],
    'message/global-delivery-status': [
        'u8dsn'
    ],
    'message/global-disposition-notification': [
        'u8mdn'
    ],
    'message/global-headers': [
        'u8hdr'
    ],
    'message/rfc822': [
        'eml',
        'mime',
        'mht',
        'mhtml'
    ],
    'model/3mf': [
        '3mf'
    ],
    'model/gltf+json': [
        'gltf'
    ],
    'model/gltf-binary': [
        'glb'
    ],
    'model/iges': [
        'igs',
        'iges'
    ],
    'model/jt': [
        'jt'
    ],
    'model/mesh': [
        'msh',
        'mesh',
        'silo'
    ],
    'model/mtl': [
        'mtl'
    ],
    'model/obj': [
        'obj'
    ],
    'model/prc': [
        'prc'
    ],
    'model/step': [
        'step',
        'stp',
        'stpnc',
        'p21',
        '210'
    ],
    'model/step+xml': [
        'stpx'
    ],
    'model/step+zip': [
        'stpz'
    ],
    'model/step-xml+zip': [
        'stpxz'
    ],
    'model/stl': [
        'stl'
    ],
    'model/u3d': [
        'u3d'
    ],
    'model/vrml': [
        'wrl',
        'vrml'
    ],
    'model/x3d+binary': [
        '*x3db',
        'x3dbz'
    ],
    'model/x3d+fastinfoset': [
        'x3db'
    ],
    'model/x3d+vrml': [
        '*x3dv',
        'x3dvz'
    ],
    'model/x3d+xml': [
        'x3d',
        'x3dz'
    ],
    'model/x3d-vrml': [
        'x3dv'
    ],
    'text/cache-manifest': [
        'appcache',
        'manifest'
    ],
    'text/calendar': [
        'ics',
        'ifb'
    ],
    'text/coffeescript': [
        'coffee',
        'litcoffee'
    ],
    'text/css': [
        'css'
    ],
    'text/csv': [
        'csv'
    ],
    'text/html': [
        'html',
        'htm',
        'shtml'
    ],
    'text/jade': [
        'jade'
    ],
    'text/javascript': [
        'js',
        'mjs'
    ],
    'text/jsx': [
        'jsx'
    ],
    'text/less': [
        'less'
    ],
    'text/markdown': [
        'md',
        'markdown'
    ],
    'text/mathml': [
        'mml'
    ],
    'text/mdx': [
        'mdx'
    ],
    'text/n3': [
        'n3'
    ],
    'text/plain': [
        'txt',
        'text',
        'conf',
        'def',
        'list',
        'log',
        'in',
        'ini'
    ],
    'text/richtext': [
        'rtx'
    ],
    'text/rtf': [
        '*rtf'
    ],
    'text/sgml': [
        'sgml',
        'sgm'
    ],
    'text/shex': [
        'shex'
    ],
    'text/slim': [
        'slim',
        'slm'
    ],
    'text/spdx': [
        'spdx'
    ],
    'text/stylus': [
        'stylus',
        'styl'
    ],
    'text/tab-separated-values': [
        'tsv'
    ],
    'text/troff': [
        't',
        'tr',
        'roff',
        'man',
        'me',
        'ms'
    ],
    'text/turtle': [
        'ttl'
    ],
    'text/uri-list': [
        'uri',
        'uris',
        'urls'
    ],
    'text/vcard': [
        'vcard'
    ],
    'text/vtt': [
        'vtt'
    ],
    'text/wgsl': [
        'wgsl'
    ],
    'text/xml': [
        '*xml'
    ],
    'text/yaml': [
        'yaml',
        'yml'
    ],
    'video/3gpp': [
        '3gp',
        '3gpp'
    ],
    'video/3gpp2': [
        '3g2'
    ],
    'video/h261': [
        'h261'
    ],
    'video/h263': [
        'h263'
    ],
    'video/h264': [
        'h264'
    ],
    'video/iso.segment': [
        'm4s'
    ],
    'video/jpeg': [
        'jpgv'
    ],
    'video/jpm': [
        '*jpm',
        '*jpgm'
    ],
    'video/mj2': [
        'mj2',
        'mjp2'
    ],
    'video/mp2t': [
        'ts',
        'm2t',
        'm2ts',
        'mts'
    ],
    'video/mp4': [
        'mp4',
        'mp4v',
        'mpg4'
    ],
    'video/mpeg': [
        'mpeg',
        'mpg',
        'mpe',
        'm1v',
        'm2v'
    ],
    'video/ogg': [
        'ogv'
    ],
    'video/quicktime': [
        'qt',
        'mov'
    ],
    'video/webm': [
        'webm'
    ]
};
Object.freeze($df2cc7dd68f985c2$var$types);
var $df2cc7dd68f985c2$export$2e2bcd8739ae039 = $df2cc7dd68f985c2$var$types;

});

parcelRegister("dPBRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a11d68560c44f6c0$export$2e2bcd8739ae039);
var $a11d68560c44f6c0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a11d68560c44f6c0$var$_Mime_extensionToType, $a11d68560c44f6c0$var$_Mime_typeToExtension, $a11d68560c44f6c0$var$_Mime_typeToExtensions;
class $a11d68560c44f6c0$var$Mime {
    constructor(...args){
        $a11d68560c44f6c0$var$_Mime_extensionToType.set(this, new Map());
        $a11d68560c44f6c0$var$_Mime_typeToExtension.set(this, new Map());
        $a11d68560c44f6c0$var$_Mime_typeToExtensions.set(this, new Map());
        for (const arg of args)this.define(arg);
    }
    define(typeMap, force = false) {
        for (let [type, extensions] of Object.entries(typeMap)){
            type = type.toLowerCase();
            extensions = extensions.map((ext)=>ext.toLowerCase());
            if (!$a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtensions, "f").has(type)) $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtensions, "f").set(type, new Set());
            const allExtensions = $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtensions, "f").get(type);
            let first = true;
            for (let extension of extensions){
                const starred = extension.startsWith('*');
                extension = starred ? extension.slice(1) : extension;
                allExtensions?.add(extension);
                if (first) $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtension, "f").set(type, extension);
                first = false;
                if (starred) continue;
                const currentType = $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_extensionToType, "f").get(extension);
                if (currentType && currentType != type && !force) throw new Error(`"${type} -> ${extension}" conflicts with "${currentType} -> ${extension}". Pass \`force=true\` to override this definition.`);
                $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_extensionToType, "f").set(extension, type);
            }
        }
        return this;
    }
    getType(path) {
        if (typeof path !== 'string') return null;
        const last = path.replace(/^.*[/\\]/s, '').toLowerCase();
        const ext = last.replace(/^.*\./s, '').toLowerCase();
        const hasPath = last.length < path.length;
        const hasDot = ext.length < last.length - 1;
        if (!hasDot && hasPath) return null;
        return $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_extensionToType, "f").get(ext) ?? null;
    }
    getExtension(type) {
        if (typeof type !== 'string') return null;
        type = type?.split?.(';')[0];
        return (type && $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtension, "f").get(type.trim().toLowerCase())) ?? null;
    }
    getAllExtensions(type) {
        if (typeof type !== 'string') return null;
        type = type.split(';')[0].trim().toLowerCase();
        return $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtensions, "f").get(type) ?? null;
    }
    _freeze() {
        this.define = ()=>{
            throw new Error('define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances');
        };
        Object.freeze(this);
        for (const extensions of $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtensions, "f").values())Object.freeze(extensions);
        return this;
    }
    _getTestState() {
        return {
            types: $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_extensionToType, "f"),
            extensions: $a11d68560c44f6c0$var$__classPrivateFieldGet(this, $a11d68560c44f6c0$var$_Mime_typeToExtension, "f")
        };
    }
}
$a11d68560c44f6c0$var$_Mime_extensionToType = new WeakMap(), $a11d68560c44f6c0$var$_Mime_typeToExtension = new WeakMap(), $a11d68560c44f6c0$var$_Mime_typeToExtensions = new WeakMap();
var $a11d68560c44f6c0$export$2e2bcd8739ae039 = $a11d68560c44f6c0$var$Mime;

});




var $90cae257cc958273$exports = {};
'use strict';

$90cae257cc958273$exports = (parcelRequire("8S27K"));


const $7c1ccfb859bb0dff$var$__MOBX_DEV__ = false;
const $7c1ccfb859bb0dff$var$niceErrors = {
    0: `Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'`,
    1 (annotationType, key) {
        return `Cannot apply '${annotationType}' to '${key.toString()}': Field not found.`;
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: `Invalid annotation`,
    13: `Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    14: "Intercept handlers should return nothing or a change object",
    15: `Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    16: `Modification exception: the internal structure of an observable array was changed.`,
    19 (other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20 (other) {
        return "Cannot initialize map from " + other;
    },
    21 (dataStructure) {
        return `Cannot convert to map from '${dataStructure}'`;
    },
    23: "It is not possible to get index atoms from arrays",
    24 (thing) {
        return "Cannot obtain administration from " + thing;
    },
    25 (property, name) {
        return `the entry '${property}' does not exist in the observable map '${name}'`;
    },
    26: "please specify a property",
    27 (property, name) {
        return `no observable property '${property.toString()}' found on the observable object '${name}'`;
    },
    28 (thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32 (name, derivation) {
        return `Cycle detected in computation ${name}: ${derivation}`;
    },
    33 (name) {
        return `The setter of computed value '${name}' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?`;
    },
    34 (name) {
        return `[ComputedValue '${name}'] It is not possible to assign a new value to a computed value.`;
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37 (method) {
        return `[mobx] \`observableArray.${method}()\` mutates the array in-place, which is not allowed inside a derivation. Use \`array.slice().${method}()\` instead`;
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects",
    40 (length) {
        return "Out of range: " + length;
    },
    41 (other) {
        return "Cannot initialize set from " + other;
    },
    42 (key) {
        return `Invalid index: '${key}'`;
    },
    43 (annotationType, name, kind) {
        return `Cannot apply '${annotationType}' to '${name}' (kind: ${kind}):` + `\n'${annotationType}' can only be used on properties with a function value.`;
    },
    44 (annotationType) {
        return `'${annotationType}' can only be used with 'makeObservable'`;
    }
};
const $7c1ccfb859bb0dff$var$errors = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? $7c1ccfb859bb0dff$var$niceErrors : {};
function $7c1ccfb859bb0dff$var$die(error, ...args) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        let e = typeof error === "string" ? error : $7c1ccfb859bb0dff$var$errors[error];
        if (typeof e === "function") e = e.apply(null, args);
        throw new Error(`[MobX] ${e}`);
    }
    throw new Error(`[MobX] minified error nr: ${error}${args.length ? " " + args.map(String).join(",") : ""}. See mobx.js.org/errors`);
}
// We shorten anything used > 5 times
const $7c1ccfb859bb0dff$var$assign = Object.assign;
const $7c1ccfb859bb0dff$var$getDescriptor = Object.getOwnPropertyDescriptor;
const $7c1ccfb859bb0dff$var$defineProperty = Object.defineProperty;
const $7c1ccfb859bb0dff$var$objectPrototype = Object.prototype;
const $7c1ccfb859bb0dff$var$EMPTY_ARRAY = [];
Object.freeze($7c1ccfb859bb0dff$var$EMPTY_ARRAY);
const $7c1ccfb859bb0dff$var$EMPTY_OBJECT = {};
Object.freeze($7c1ccfb859bb0dff$var$EMPTY_OBJECT);
const $7c1ccfb859bb0dff$var$plainObjectString = /*#__PURE__*/ Object.toString();
function $7c1ccfb859bb0dff$var$getNextId() {
    return ++$7c1ccfb859bb0dff$var$globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function $7c1ccfb859bb0dff$var$once(func) {
    let invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
const $7c1ccfb859bb0dff$var$noop = ()=>{};
function $7c1ccfb859bb0dff$var$isFunction(fn) {
    return typeof fn === "function";
}
function $7c1ccfb859bb0dff$var$isStringish(value) {
    const t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function $7c1ccfb859bb0dff$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $7c1ccfb859bb0dff$var$isPlainObject(value) {
    if (!$7c1ccfb859bb0dff$var$isObject(value)) return false;
    const proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    const protoConstructor = $7c1ccfb859bb0dff$var$hasProp(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === $7c1ccfb859bb0dff$var$plainObjectString;
}
// https://stackoverflow.com/a/37865170
function $7c1ccfb859bb0dff$var$isGenerator(obj) {
    const constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function $7c1ccfb859bb0dff$var$addHiddenProp(object, propName, value) {
    $7c1ccfb859bb0dff$var$defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function $7c1ccfb859bb0dff$var$addHiddenFinalProp(object, propName, value) {
    $7c1ccfb859bb0dff$var$defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function $7c1ccfb859bb0dff$var$createInstanceofPredicate(name, theClass) {
    const propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return $7c1ccfb859bb0dff$var$isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function $7c1ccfb859bb0dff$var$isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function $7c1ccfb859bb0dff$var$isPlainES6Map(thing) {
    const mapProto = Object.getPrototypeOf(thing);
    const objectProto = Object.getPrototypeOf(mapProto);
    const nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function $7c1ccfb859bb0dff$var$isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
/**
 * Returns the following: own enumerable keys and symbols.
 */ function $7c1ccfb859bb0dff$var$getPlainObjectKeys(object) {
    const keys = Object.keys(object);
    const symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [
        ...keys,
        ...symbols.filter((s)=>$7c1ccfb859bb0dff$var$objectPrototype.propertyIsEnumerable.call(object, s))
    ];
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
const $7c1ccfb859bb0dff$var$ownKeys = Reflect.ownKeys;
function $7c1ccfb859bb0dff$var$stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function $7c1ccfb859bb0dff$var$toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function $7c1ccfb859bb0dff$var$hasProp(target, prop) {
    return $7c1ccfb859bb0dff$var$objectPrototype.hasOwnProperty.call(target, prop);
}
const $7c1ccfb859bb0dff$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors;
function $7c1ccfb859bb0dff$var$getFlag(flags, mask) {
    return !!(flags & mask);
}
function $7c1ccfb859bb0dff$var$setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function $7c1ccfb859bb0dff$var$assert20223DecoratorType(context, types) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !types.includes(context.kind)) $7c1ccfb859bb0dff$var$die(`The decorator applied to '${String(context.name)}' cannot be used on a ${context.kind} element`);
}
const $7c1ccfb859bb0dff$export$f246528900dd4467 = /*#__PURE__*/ Symbol("mobx administration");
class $7c1ccfb859bb0dff$var$Atom {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ constructor(name_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "Atom@" + $7c1ccfb859bb0dff$var$getNextId() : "Atom"){
        this.name_ = void 0;
        this.flags_ = 0;
        // Allocated lazily on first observer to save memory.
        this.observers_ = null;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    get isBeingObserved() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 4 /* AtomFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 4 /* AtomFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ reportObserved() {
        return $7c1ccfb859bb0dff$var$reportObserved(this);
    }
    /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ reportChanged() {
        $7c1ccfb859bb0dff$var$startBatch();
        $7c1ccfb859bb0dff$var$propagateChanged(this);
        $7c1ccfb859bb0dff$var$endBatch();
    }
    toString() {
        return this.name_;
    }
}
const $7c1ccfb859bb0dff$var$isAtom = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("Atom", $7c1ccfb859bb0dff$var$Atom);
function $7c1ccfb859bb0dff$export$2e17fe64ec9a826e(name, onBecomeObservedHandler = $7c1ccfb859bb0dff$var$noop, onBecomeUnobservedHandler = $7c1ccfb859bb0dff$var$noop) {
    const atom = new $7c1ccfb859bb0dff$var$Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== $7c1ccfb859bb0dff$var$noop) atom.onBOL = new Set([
        onBecomeObservedHandler
    ]);
    if (onBecomeUnobservedHandler !== $7c1ccfb859bb0dff$var$noop) atom.onBUOL = new Set([
        onBecomeUnobservedHandler
    ]);
    return atom;
}
function $7c1ccfb859bb0dff$export$3de73ed166baf608(a, b) {
    return a === b;
}
function $7c1ccfb859bb0dff$export$8a67fbe40c3dd8c1(a, b) {
    return $7c1ccfb859bb0dff$var$deepEqual(a, b);
}
function $7c1ccfb859bb0dff$export$202cfbbbce69d3c4(a, b) {
    return $7c1ccfb859bb0dff$var$deepEqual(a, b, 1);
}
const $7c1ccfb859bb0dff$export$700812e5ccfdbb1d = Object.is;
function $7c1ccfb859bb0dff$var$deepEnhancer(v, _, name) {
    // primitives can never be made observable; skip the type checks below
    if (v === null || typeof v !== "object" && typeof v !== "function") return v;
    // it is an observable already, done
    if ($7c1ccfb859bb0dff$export$5cd057a6046189f9(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.array(v, {
        name: name
    });
    if ($7c1ccfb859bb0dff$var$isPlainObject(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name
    });
    if ($7c1ccfb859bb0dff$var$isES6Map(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.map(v, {
        name: name
    });
    if ($7c1ccfb859bb0dff$var$isES6Set(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.set(v, {
        name: name
    });
    if (typeof v === "function" && !$7c1ccfb859bb0dff$export$b956e38827fca970(v) && !$7c1ccfb859bb0dff$export$8c23365ce94ba925(v)) {
        if ($7c1ccfb859bb0dff$var$isGenerator(v)) return $7c1ccfb859bb0dff$export$ccc7b0636abaffc3(v);
        else return $7c1ccfb859bb0dff$export$b8aa795084cbf86b(name, v);
    }
    return v;
}
function $7c1ccfb859bb0dff$var$shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(v) || $7c1ccfb859bb0dff$export$f5afceff386badf9(v) || $7c1ccfb859bb0dff$export$27a7faddcfd44960(v) || $7c1ccfb859bb0dff$export$da6b063694cb52c1(v)) return v;
    if (Array.isArray(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.array(v, {
        name: name,
        deep: false
    });
    if ($7c1ccfb859bb0dff$var$isPlainObject(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name,
        deep: false
    });
    if ($7c1ccfb859bb0dff$var$isES6Map(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.map(v, {
        name: name,
        deep: false
    });
    if ($7c1ccfb859bb0dff$var$isES6Set(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.set(v, {
        name: name,
        deep: false
    });
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function $7c1ccfb859bb0dff$var$referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function $7c1ccfb859bb0dff$var$refStructEnhancer(v, oldValue) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$export$5cd057a6046189f9(v)) $7c1ccfb859bb0dff$var$die(`observable.struct should not be used with observable values`);
    if ($7c1ccfb859bb0dff$var$deepEqual(v, oldValue)) return oldValue;
    return v;
}
const $7c1ccfb859bb0dff$var$OVERRIDE = "override";
const $7c1ccfb859bb0dff$export$a46fbcd73382caa5 = {
    annotationType_: $7c1ccfb859bb0dff$var$OVERRIDE,
    make_: $7c1ccfb859bb0dff$var$make_$6,
    extend_: $7c1ccfb859bb0dff$var$extend_$5
};
function $7c1ccfb859bb0dff$var$isOverride(annotation) {
    return annotation.annotationType_ === $7c1ccfb859bb0dff$var$OVERRIDE;
}
function $7c1ccfb859bb0dff$var$make_$6(adm, key) {
    // Must not be plain object
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && adm.isPlainObject_) $7c1ccfb859bb0dff$var$die(`Cannot apply '${this.annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${this.annotationType_}' cannot be used on plain objects.`);
    // Must override something
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$hasProp(adm.appliedAnnotations_, key)) $7c1ccfb859bb0dff$var$die(`'${adm.name_}.${key.toString()}' is annotated with '${this.annotationType_}', ` + `but no such annotated member was found on prototype.`);
    return 0 /* MakeResult.Cancel */ ;
}
function $7c1ccfb859bb0dff$var$extend_$5(adm, key, descriptor, proxyTrap) {
    $7c1ccfb859bb0dff$var$die(44, this.annotationType_);
}
function $7c1ccfb859bb0dff$var$createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $7c1ccfb859bb0dff$var$make_$5,
        extend_: $7c1ccfb859bb0dff$var$extend_$4
    };
}
function $7c1ccfb859bb0dff$var$make_$5(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if ($7c1ccfb859bb0dff$export$b956e38827fca970(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const actionDescriptor = $7c1ccfb859bb0dff$var$createActionDescriptor(adm, this, key, descriptor, false);
    $7c1ccfb859bb0dff$var$defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $7c1ccfb859bb0dff$var$extend_$4(adm, key, descriptor, proxyTrap) {
    const actionDescriptor = $7c1ccfb859bb0dff$var$createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function $7c1ccfb859bb0dff$var$decorateAction20223_(annotation, mthd, context) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$assert20223DecoratorType(context, [
        "method",
        "field"
    ]);
    const { kind: kind, name: name, addInitializer: addInitializer } = context;
    const ann = annotation;
    const _createAction = (m)=>{
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return $7c1ccfb859bb0dff$var$createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        let mthd = initMthd;
        if (!$7c1ccfb859bb0dff$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _ann$options_4;
        if (!$7c1ccfb859bb0dff$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_4 = ann.options_) != null && _ann$options_4.bound) addInitializer(function() {
            const self = this;
            const bound = self[name].bind(self);
            bound.isMobxAction = true;
            self[name] = bound;
        });
        return mthd;
    }
    $7c1ccfb859bb0dff$var$die(43, ann.annotationType_, String(name), kind);
}
function $7c1ccfb859bb0dff$var$assertActionDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isFunction(value)) $7c1ccfb859bb0dff$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on properties with a function value.`);
}
function $7c1ccfb859bb0dff$var$createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $7c1ccfb859bb0dff$var$globalState.safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    $7c1ccfb859bb0dff$var$assertActionDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: $7c1ccfb859bb0dff$var$createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $7c1ccfb859bb0dff$var$createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $7c1ccfb859bb0dff$var$make_$4,
        extend_: $7c1ccfb859bb0dff$var$extend_$3
    };
}
function $7c1ccfb859bb0dff$var$make_$4(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!$7c1ccfb859bb0dff$var$hasProp(adm.target_, key) || !$7c1ccfb859bb0dff$export$8c23365ce94ba925(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if ($7c1ccfb859bb0dff$export$8c23365ce94ba925(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const flowDescriptor = $7c1ccfb859bb0dff$var$createFlowDescriptor(adm, this, key, descriptor, false, false);
    $7c1ccfb859bb0dff$var$defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $7c1ccfb859bb0dff$var$extend_$3(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    const flowDescriptor = $7c1ccfb859bb0dff$var$createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function $7c1ccfb859bb0dff$var$decorateFlow20223_(annotation, mthd, context) {
    var _annotation$options_;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$assert20223DecoratorType(context, [
        "method"
    ]);
    const { name: name, addInitializer: addInitializer } = context;
    if (!$7c1ccfb859bb0dff$export$8c23365ce94ba925(mthd)) mthd = $7c1ccfb859bb0dff$export$ccc7b0636abaffc3(mthd);
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) addInitializer(function() {
        const self = this;
        const bound = self[name].bind(self);
        bound.isMobXFlow = true;
        self[name] = bound;
    });
    return mthd;
}
function $7c1ccfb859bb0dff$var$assertFlowDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isFunction(value)) $7c1ccfb859bb0dff$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on properties with a generator function value.`);
}
function $7c1ccfb859bb0dff$var$createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $7c1ccfb859bb0dff$var$globalState.safeDescriptors) {
    $7c1ccfb859bb0dff$var$assertFlowDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!$7c1ccfb859bb0dff$export$8c23365ce94ba925(value)) value = $7c1ccfb859bb0dff$export$ccc7b0636abaffc3(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $7c1ccfb859bb0dff$var$createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $7c1ccfb859bb0dff$var$make_$3,
        extend_: $7c1ccfb859bb0dff$var$extend_$2
    };
}
function $7c1ccfb859bb0dff$var$make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $7c1ccfb859bb0dff$var$extend_$2(adm, key, descriptor, proxyTrap) {
    $7c1ccfb859bb0dff$var$assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, $7c1ccfb859bb0dff$var$assign({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function $7c1ccfb859bb0dff$var$decorateComputed20223_(annotation, get, context) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$assert20223DecoratorType(context, [
        "getter"
    ]);
    const ann = annotation;
    const { name: key, addInitializer: addInitializer } = context;
    let computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        const options = $7c1ccfb859bb0dff$var$assign({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${adm.name_}.${key.toString()}` : `ObservableObject.${key.toString()}`);
        return new $7c1ccfb859bb0dff$var$ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        const adm = $7c1ccfb859bb0dff$var$asObservableObject(this)[$7c1ccfb859bb0dff$export$f246528900dd4467];
        const target = this;
        const observable = adm.values_.get(key);
        if (observable instanceof $7c1ccfb859bb0dff$var$ComputedValue && observable.derivation !== get) adm.values_.delete(key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, ()=>createComputedValue(target, adm));
    });
    return function() {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        const observable = adm.values_.get(key);
        if (observable instanceof $7c1ccfb859bb0dff$var$ComputedValue && observable.derivation !== get) {
            var _computedValues;
            let computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function $7c1ccfb859bb0dff$var$assertComputedDescriptor(adm, { annotationType_: annotationType_ }, key, { get: get }) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !get) $7c1ccfb859bb0dff$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on getter(+setter) properties.`);
}
function $7c1ccfb859bb0dff$var$createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $7c1ccfb859bb0dff$var$make_$2,
        extend_: $7c1ccfb859bb0dff$var$extend_$1
    };
}
function $7c1ccfb859bb0dff$var$make_$2(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $7c1ccfb859bb0dff$var$extend_$1(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    $7c1ccfb859bb0dff$var$assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer_) != null ? _this$options_$enhanc : $7c1ccfb859bb0dff$var$deepEnhancer, proxyTrap);
}
function $7c1ccfb859bb0dff$var$decorateObservable20223_(annotation, desc, context) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (context.kind === "field") throw $7c1ccfb859bb0dff$var$die(`Please use \`@observable accessor ${String(context.name)}\` instead of \`@observable ${String(context.name)}\``);
        $7c1ccfb859bb0dff$var$assert20223DecoratorType(context, [
            "accessor"
        ]);
    }
    const ann = annotation;
    const { kind: kind, name: name } = context;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        const adm = $7c1ccfb859bb0dff$var$asObservableObject(target)[$7c1ccfb859bb0dff$export$f246528900dd4467];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, ()=>{
            var _ann$options_$enhance, _ann$options_;
            return new $7c1ccfb859bb0dff$var$ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer_) != null ? _ann$options_$enhance : $7c1ccfb859bb0dff$var$deepEnhancer, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${adm.name_}.${name.toString()}` : `ObservableObject.${name.toString()}`, false);
        });
        return adm;
    }
    return {
        get () {
            var _this$$mobx;
            const adm = (_this$$mobx = this[$7c1ccfb859bb0dff$export$f246528900dd4467]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set (value) {
            var _this$$mobx2;
            const adm = (_this$$mobx2 = this[$7c1ccfb859bb0dff$export$f246528900dd4467]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init (value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function $7c1ccfb859bb0dff$var$assertObservableDescriptor(adm, { annotationType_: annotationType_ }, key, descriptor) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !("value" in descriptor)) $7c1ccfb859bb0dff$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' cannot be used on getter/setter properties`);
}
const $7c1ccfb859bb0dff$var$AUTO = "true";
const $7c1ccfb859bb0dff$var$autoAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createAutoAnnotation();
function $7c1ccfb859bb0dff$var$createAutoAnnotation(options) {
    return {
        annotationType_: $7c1ccfb859bb0dff$var$AUTO,
        options_: options,
        make_: $7c1ccfb859bb0dff$var$make_$1,
        extend_: $7c1ccfb859bb0dff$var$extend_
    };
}
// The auto annotation only depends on `deep` and `autoBind`, so share one instance per combination
// instead of allocating one for every object created with options
const $7c1ccfb859bb0dff$var$autoAnnotations = [
    $7c1ccfb859bb0dff$var$autoAnnotation
];
function $7c1ccfb859bb0dff$var$getAutoAnnotation(options) {
    var _autoAnnotations$idx;
    const deep = options.deep !== false;
    const autoBind = !!options.autoBind;
    const idx = (deep ? 0 : 1) | (autoBind ? 2 : 0);
    return (_autoAnnotations$idx = $7c1ccfb859bb0dff$var$autoAnnotations[idx]) != null ? _autoAnnotations$idx : $7c1ccfb859bb0dff$var$autoAnnotations[idx] = $7c1ccfb859bb0dff$var$createAutoAnnotation({
        deep: deep,
        autoBind: autoBind
    });
}
function $7c1ccfb859bb0dff$var$make_$1(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return $7c1ccfb859bb0dff$export$2983e091f1a1e8e2.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        const set = $7c1ccfb859bb0dff$export$b956e38827fca970(descriptor.set) ? descriptor.set // See #4553
         : $7c1ccfb859bb0dff$var$createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: $7c1ccfb859bb0dff$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        $7c1ccfb859bb0dff$var$defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if ($7c1ccfb859bb0dff$var$isGenerator(descriptor.value)) {
            var _this$options_;
            const flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? $7c1ccfb859bb0dff$export$d41c06fa934cc67e : $7c1ccfb859bb0dff$export$ccc7b0636abaffc3;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        const actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? $7c1ccfb859bb0dff$export$4dd0b06162f181e : $7c1ccfb859bb0dff$export$b8aa795084cbf86b;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    let observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? $7c1ccfb859bb0dff$export$431518ad42ffb7bd : $7c1ccfb859bb0dff$export$5ab46cbf6120b33a;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function $7c1ccfb859bb0dff$var$extend_(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return $7c1ccfb859bb0dff$export$2983e091f1a1e8e2.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: $7c1ccfb859bb0dff$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: $7c1ccfb859bb0dff$var$createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    let observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? $7c1ccfb859bb0dff$export$431518ad42ffb7bd : $7c1ccfb859bb0dff$export$5ab46cbf6120b33a;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function $7c1ccfb859bb0dff$var$createDecoratorAnnotation(annotation, decorate) {
    return $7c1ccfb859bb0dff$var$assign(function decoratorAnnotation(value, context) {
        if (context && typeof context.kind === "string") return decorate(annotation, value, context);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$die(`Invalid arguments for \`${annotation.annotationType_}\``);
        return undefined;
    }, annotation);
}
const $7c1ccfb859bb0dff$var$OBSERVABLE = "observable";
const $7c1ccfb859bb0dff$var$OBSERVABLE_REF = "observable.ref";
const $7c1ccfb859bb0dff$var$OBSERVABLE_SHALLOW = "observable.shallow";
const $7c1ccfb859bb0dff$var$OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
const $7c1ccfb859bb0dff$var$defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze($7c1ccfb859bb0dff$var$defaultCreateObservableOptions);
function $7c1ccfb859bb0dff$var$asCreateObservableOptions(thing) {
    return thing || $7c1ccfb859bb0dff$var$defaultCreateObservableOptions;
}
const $7c1ccfb859bb0dff$var$observableAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableAnnotation($7c1ccfb859bb0dff$var$OBSERVABLE);
const $7c1ccfb859bb0dff$var$observableRefAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableAnnotation($7c1ccfb859bb0dff$var$OBSERVABLE_REF, {
    enhancer_: $7c1ccfb859bb0dff$var$referenceEnhancer
});
const $7c1ccfb859bb0dff$var$observableShallowAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableAnnotation($7c1ccfb859bb0dff$var$OBSERVABLE_SHALLOW, {
    enhancer_: $7c1ccfb859bb0dff$var$shallowEnhancer
});
const $7c1ccfb859bb0dff$var$observableStructAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableAnnotation($7c1ccfb859bb0dff$var$OBSERVABLE_STRUCT, {
    enhancer_: $7c1ccfb859bb0dff$var$refStructEnhancer
});
function $7c1ccfb859bb0dff$var$createObservableDecoratorAnnotation(annotation) {
    return $7c1ccfb859bb0dff$var$createDecoratorAnnotation(annotation, $7c1ccfb859bb0dff$var$decorateObservable20223_);
}
function $7c1ccfb859bb0dff$var$getEnhancerFromOptions(options) {
    return options.deep === true ? $7c1ccfb859bb0dff$var$deepEnhancer : options.deep === false ? $7c1ccfb859bb0dff$var$referenceEnhancer : $7c1ccfb859bb0dff$var$getEnhancerFromAnnotation(options.defaultDecorator);
}
function $7c1ccfb859bb0dff$var$getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : $7c1ccfb859bb0dff$var$getAutoAnnotation(options) : undefined;
}
function $7c1ccfb859bb0dff$var$getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? $7c1ccfb859bb0dff$var$deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer_) != null ? _annotation$options_$ : $7c1ccfb859bb0dff$var$deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function $7c1ccfb859bb0dff$var$createObservable(v, arg2, arg3) {
    if (arg2 && typeof arg2.kind === "string") return $7c1ccfb859bb0dff$var$decorateObservable20223_($7c1ccfb859bb0dff$var$observableAnnotation, v, arg2);
    // already observable - ignore
    if ($7c1ccfb859bb0dff$export$5cd057a6046189f9(v)) return v;
    // plain object
    if ($7c1ccfb859bb0dff$var$isPlainObject(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.array(v, arg2);
    // Map
    if ($7c1ccfb859bb0dff$var$isES6Map(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.map(v, arg2);
    // Set
    if ($7c1ccfb859bb0dff$var$isES6Set(v)) return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return $7c1ccfb859bb0dff$export$5ab46cbf6120b33a.box(v, arg2);
}
const $7c1ccfb859bb0dff$var$observableFactories = {
    box (value, options) {
        const o = $7c1ccfb859bb0dff$var$asCreateObservableOptions(options);
        return new $7c1ccfb859bb0dff$var$ObservableValue(value, $7c1ccfb859bb0dff$var$getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array (initialValues, options) {
        const o = $7c1ccfb859bb0dff$var$asCreateObservableOptions(options);
        return $7c1ccfb859bb0dff$var$createObservableArray(initialValues, $7c1ccfb859bb0dff$var$getEnhancerFromOptions(o), o.name);
    },
    map (initialValues, options) {
        const o = $7c1ccfb859bb0dff$var$asCreateObservableOptions(options);
        return new $7c1ccfb859bb0dff$export$db1c0901f08fc6fd(initialValues, $7c1ccfb859bb0dff$var$getEnhancerFromOptions(o), o.name);
    },
    set (initialValues, options) {
        const o = $7c1ccfb859bb0dff$var$asCreateObservableOptions(options);
        return new $7c1ccfb859bb0dff$export$2235f602a7a77c81(initialValues, $7c1ccfb859bb0dff$var$getEnhancerFromOptions(o), o.name);
    },
    object (props, annotations, options) {
        return $7c1ccfb859bb0dff$var$initObservable(()=>$7c1ccfb859bb0dff$export$59d8134e963031bd($7c1ccfb859bb0dff$var$asDynamicObservableObject({}, options), props, annotations));
    }
};
const $7c1ccfb859bb0dff$export$431518ad42ffb7bd = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableDecoratorAnnotation($7c1ccfb859bb0dff$var$observableRefAnnotation);
const $7c1ccfb859bb0dff$export$d618cc4ca9414c13 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableDecoratorAnnotation($7c1ccfb859bb0dff$var$observableShallowAnnotation);
const $7c1ccfb859bb0dff$export$36408c859af67d57 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableDecoratorAnnotation($7c1ccfb859bb0dff$var$observableAnnotation);
const $7c1ccfb859bb0dff$export$716593212ba381a0 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createObservableDecoratorAnnotation($7c1ccfb859bb0dff$var$observableStructAnnotation);
// eslint-disable-next-line
var $7c1ccfb859bb0dff$export$5ab46cbf6120b33a = /*#__PURE__*/ $7c1ccfb859bb0dff$var$assign($7c1ccfb859bb0dff$var$createObservable, $7c1ccfb859bb0dff$var$observableAnnotation, $7c1ccfb859bb0dff$var$observableFactories);
const $7c1ccfb859bb0dff$var$COMPUTED = "computed";
const $7c1ccfb859bb0dff$var$COMPUTED_STRUCT = "computed.struct";
function $7c1ccfb859bb0dff$var$createComputedDecoratorAnnotation(annotation) {
    return $7c1ccfb859bb0dff$var$createDecoratorAnnotation(annotation, $7c1ccfb859bb0dff$var$decorateComputed20223_);
}
const $7c1ccfb859bb0dff$var$computedAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createComputedAnnotation($7c1ccfb859bb0dff$var$COMPUTED);
const $7c1ccfb859bb0dff$var$computedStructAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createComputedAnnotation($7c1ccfb859bb0dff$var$COMPUTED_STRUCT, {
    equals: $7c1ccfb859bb0dff$export$8a67fbe40c3dd8c1
});
const $7c1ccfb859bb0dff$export$356bab705a4abec5 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createComputedDecoratorAnnotation($7c1ccfb859bb0dff$var$computedStructAnnotation);
const $7c1ccfb859bb0dff$export$2983e091f1a1e8e2 = function computed(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $7c1ccfb859bb0dff$var$decorateComputed20223_($7c1ccfb859bb0dff$var$computedAnnotation, arg1, arg2);
    if ($7c1ccfb859bb0dff$var$isPlainObject(arg1)) // computed annotation with options
    return $7c1ccfb859bb0dff$var$createComputedDecoratorAnnotation($7c1ccfb859bb0dff$var$createComputedAnnotation($7c1ccfb859bb0dff$var$COMPUTED, arg1));
    // computed(expr, options?)
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (!$7c1ccfb859bb0dff$var$isFunction(arg1)) $7c1ccfb859bb0dff$var$die("First argument to `computed` should be an expression.");
        if ($7c1ccfb859bb0dff$var$isFunction(arg2)) $7c1ccfb859bb0dff$var$die("A setter as second argument is no longer supported, use `{ set: fn }` option instead");
    }
    const opts = $7c1ccfb859bb0dff$var$isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new $7c1ccfb859bb0dff$var$ComputedValue(opts);
};
$7c1ccfb859bb0dff$var$assign($7c1ccfb859bb0dff$export$2983e091f1a1e8e2, $7c1ccfb859bb0dff$var$computedAnnotation);
var $7c1ccfb859bb0dff$var$_getDescriptor$config, $7c1ccfb859bb0dff$var$_getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
let $7c1ccfb859bb0dff$var$currentActionId = 0;
let $7c1ccfb859bb0dff$var$nextActionId = 1;
const $7c1ccfb859bb0dff$var$isFunctionNameConfigurable = ($7c1ccfb859bb0dff$var$_getDescriptor$config = ($7c1ccfb859bb0dff$var$_getDescriptor = /*#__PURE__*/ $7c1ccfb859bb0dff$var$getDescriptor(()=>{}, "name")) == null ? void 0 : $7c1ccfb859bb0dff$var$_getDescriptor.configurable) != null ? $7c1ccfb859bb0dff$var$_getDescriptor$config : false;
// we can safely recycle this object
const $7c1ccfb859bb0dff$var$tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function $7c1ccfb859bb0dff$var$createAction(actionName, fn, autoAction = false, ref) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (!$7c1ccfb859bb0dff$var$isFunction(fn)) $7c1ccfb859bb0dff$var$die("`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName) $7c1ccfb859bb0dff$var$die(`actions should have valid names, got: '${actionName}'`);
    }
    function res() {
        return $7c1ccfb859bb0dff$var$executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = ()=>fn.toString();
    if ($7c1ccfb859bb0dff$var$isFunctionNameConfigurable) {
        $7c1ccfb859bb0dff$var$tmpNameDescriptor.value = actionName;
        $7c1ccfb859bb0dff$var$defineProperty(res, "name", $7c1ccfb859bb0dff$var$tmpNameDescriptor);
    }
    return res;
}
function $7c1ccfb859bb0dff$var$executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    const runInfo = $7c1ccfb859bb0dff$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        $7c1ccfb859bb0dff$export$9d569d1d4d631c2d(runInfo);
    }
}
function $7c1ccfb859bb0dff$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    const notifySpy_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled() && !!actionName;
    let startTime_ = 0;
    if (notifySpy_) {
        startTime_ = Date.now();
        const flattenedArgs = args ? Array.from(args) : $7c1ccfb859bb0dff$var$EMPTY_ARRAY;
        $7c1ccfb859bb0dff$var$spyReportStart({
            type: $7c1ccfb859bb0dff$var$ACTION,
            name: actionName,
            object: scope,
            arguments: flattenedArgs
        });
    }
    const prevDerivation_ = $7c1ccfb859bb0dff$var$globalState.trackingDerivation;
    const runAsAction = !canRunAsDerivation || !prevDerivation_;
    $7c1ccfb859bb0dff$var$startBatch();
    let prevAllowStateChanges_ = $7c1ccfb859bb0dff$var$globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        $7c1ccfb859bb0dff$var$untrackedStart();
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) prevAllowStateChanges_ = $7c1ccfb859bb0dff$var$allowStateChangesStart(true);
    }
    const prevAllowStateReads_ = $7c1ccfb859bb0dff$var$globalState.allowStateReads;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$export$84c93b6404d77e6f(true);
    const runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: $7c1ccfb859bb0dff$var$nextActionId++,
        parentActionId_: $7c1ccfb859bb0dff$var$currentActionId
    };
    $7c1ccfb859bb0dff$var$currentActionId = runInfo.actionId_;
    return runInfo;
}
function $7c1ccfb859bb0dff$export$9d569d1d4d631c2d(runInfo) {
    if ($7c1ccfb859bb0dff$var$currentActionId !== runInfo.actionId_) $7c1ccfb859bb0dff$var$die(30);
    $7c1ccfb859bb0dff$var$currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) $7c1ccfb859bb0dff$var$globalState.suppressReactionErrors = true;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        $7c1ccfb859bb0dff$var$allowStateChangesEnd(runInfo.prevAllowStateChanges_);
        $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(runInfo.prevAllowStateReads_);
    }
    $7c1ccfb859bb0dff$var$endBatch();
    if (runInfo.runAsAction_) $7c1ccfb859bb0dff$var$untrackedEnd(runInfo.prevDerivation_);
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && runInfo.notifySpy_) $7c1ccfb859bb0dff$var$spyReportEnd({
        time: Date.now() - runInfo.startTime_
    });
    $7c1ccfb859bb0dff$var$globalState.suppressReactionErrors = false;
}
function $7c1ccfb859bb0dff$export$e510c5d1ea4358b1(allowStateChanges, func) {
    const prev = $7c1ccfb859bb0dff$var$allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        $7c1ccfb859bb0dff$var$allowStateChangesEnd(prev);
    }
}
function $7c1ccfb859bb0dff$var$allowStateChangesStart(allowStateChanges) {
    const prev = $7c1ccfb859bb0dff$var$globalState.allowStateChanges;
    $7c1ccfb859bb0dff$var$globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function $7c1ccfb859bb0dff$var$allowStateChangesEnd(prev) {
    $7c1ccfb859bb0dff$var$globalState.allowStateChanges = prev;
}
const $7c1ccfb859bb0dff$var$CREATE = "create";
class $7c1ccfb859bb0dff$var$ObservableValue extends $7c1ccfb859bb0dff$var$Atom {
    constructor(value, enhancer_, name_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ObservableValue@" + $7c1ccfb859bb0dff$var$getNextId() : "ObservableValue", notifySpy = true, equals_ = $7c1ccfb859bb0dff$export$700812e5ccfdbb1d){
        super(name_);
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this.equals_ = void 0;
        this.hasUnreportedChange_ = false;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.value_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        this.equals_ = equals_;
        this.value_ = enhancer_(value, undefined, name_);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy && $7c1ccfb859bb0dff$var$isSpyEnabled()) // only notify spy if this is a stand-alone observable
        $7c1ccfb859bb0dff$var$spyReport({
            type: $7c1ccfb859bb0dff$var$CREATE,
            object: this,
            observableKind: "value",
            debugObjectName: this.name_,
            newValue: this.value_
        });
    }
    dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    set(newValue) {
        const oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== $7c1ccfb859bb0dff$var$globalState.UNCHANGED) {
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart({
                type: $7c1ccfb859bb0dff$var$UPDATE,
                object: this,
                observableKind: "value",
                debugObjectName: this.name_,
                newValue: newValue,
                oldValue: oldValue
            });
            this.setNewValue_(newValue);
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
        }
    }
    prepareNewValue_(newValue) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this);
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                object: this,
                type: $7c1ccfb859bb0dff$var$UPDATE,
                newValue: newValue
            });
            if (!change) return $7c1ccfb859bb0dff$var$globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer_(newValue, this.value_, this.name_);
        return this.equals_(this.value_, newValue) ? $7c1ccfb859bb0dff$var$globalState.UNCHANGED : newValue;
    }
    setNewValue_(newValue) {
        const oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if ($7c1ccfb859bb0dff$var$hasListeners(this)) $7c1ccfb859bb0dff$var$notifyListeners(this, {
            type: $7c1ccfb859bb0dff$var$UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    }
    get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    }
    raw() {
        // used by MST ot get undehanced value
        return this.value_;
    }
    toJSON() {
        return this.get();
    }
    toString() {
        return `${this.name_}[${this.value_}]`;
    }
    valueOf() {
        return $7c1ccfb859bb0dff$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $7c1ccfb859bb0dff$export$fafbc00dbefd1aef = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ObservableValue", $7c1ccfb859bb0dff$var$ObservableValue);
class $7c1ccfb859bb0dff$var$ComputedValue {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function used to determine if a newly produced
   * value differs from the previous value. Structural comparison can be convenient if you always
   * produce a new aggregated object and don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ constructor(options){
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        // Lazily allocated on first observer - see Atom.observers_.
        this.observers_ = null;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
        this.unboundDepsCount_ = 0;
        this.value_ = new $7c1ccfb859bb0dff$var$CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) $7c1ccfb859bb0dff$var$die(31);
        this.derivation = options.get;
        this.name_ = options.name || ($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ComputedValue@" + $7c1ccfb859bb0dff$var$getNextId() : "ComputedValue");
        if (options.set) this.setter_ = $7c1ccfb859bb0dff$var$createAction($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? this.name_ + "-setter" : "ComputedValue-setter", options.set);
        this.equals_ = options.equals || $7c1ccfb859bb0dff$export$700812e5ccfdbb1d;
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    onBecomeStale_() {
        $7c1ccfb859bb0dff$var$propagateMaybeChanged(this);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    // to check for cycles
    get isComputing() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ );
    }
    set isComputing(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ , newValue);
    }
    get isRunningSetter() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ );
    }
    set isRunningSetter(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ , newValue);
    }
    get isBeingObserved() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ , newValue === 1 ? true : false);
    }
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ get() {
        if (this.isComputing) $7c1ccfb859bb0dff$var$die(32, this.name_, this.derivation);
        if ($7c1ccfb859bb0dff$var$globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        (!this.observers_ || this.observers_.size === 0) && !this.keepAlive_) {
            if ($7c1ccfb859bb0dff$var$shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                $7c1ccfb859bb0dff$var$startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                $7c1ccfb859bb0dff$var$endBatch();
            }
        } else {
            const wasBeingObserved = this.isBeingObserved;
            $7c1ccfb859bb0dff$var$reportObserved(this);
            if ($7c1ccfb859bb0dff$var$shouldCompute(this)) {
                let prevTrackingContext = $7c1ccfb859bb0dff$var$globalState.trackingContext;
                if (!prevTrackingContext && (this.keepAlive_ || this.isBeingObserved)) // An observed or keep-alive computed can be recomputed by an untracked
                // read, for example from inside an action. Its dependencies are still
                // transitively observed and must fire their lifecycle hooks
                $7c1ccfb859bb0dff$var$globalState.trackingContext = this;
                if (this.trackAndCompute()) $7c1ccfb859bb0dff$var$propagateChangeConfirmed(this);
                $7c1ccfb859bb0dff$var$globalState.trackingContext = prevTrackingContext;
            } else if (!wasBeingObserved && this.isBeingObserved) // We just became observed while serving a cached value, so the getter
            // won't run and won't re-report our dependencies. Cascade to them. #4547
            this.observing_.forEach($7c1ccfb859bb0dff$var$markObserved);
        }
        const result = this.value_;
        if ($7c1ccfb859bb0dff$var$isCaughtException(result)) throw result.cause;
        return result;
    }
    set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) $7c1ccfb859bb0dff$var$die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else $7c1ccfb859bb0dff$var$die(34, this.name_);
    }
    trackAndCompute() {
        // N.B: unminified as it is used by MST
        const oldValue = this.value_;
        const wasSuspended = /* see #1208 */ this.dependenciesState_ === -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        const newValue = this.computeValue_(true);
        const changed = wasSuspended || $7c1ccfb859bb0dff$var$isCaughtException(oldValue) || $7c1ccfb859bb0dff$var$isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) {
            this.value_ = newValue;
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled()) $7c1ccfb859bb0dff$var$spyReport({
                observableKind: "computed",
                debugObjectName: this.name_,
                object: this.scope_,
                type: "update",
                oldValue: oldValue,
                newValue: newValue
            });
        }
        return changed;
    }
    computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        const prev = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? $7c1ccfb859bb0dff$var$allowStateChangesStart(false) : false;
        let res;
        if (track) res = $7c1ccfb859bb0dff$var$trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if ($7c1ccfb859bb0dff$var$globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new $7c1ccfb859bb0dff$var$CaughtException(e);
            }
        }
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    }
    suspend_() {
        if (!this.keepAlive_) {
            $7c1ccfb859bb0dff$var$clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    }
    warnAboutUntrackedRead_() {
        if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
        if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : $7c1ccfb859bb0dff$var$globalState.computedRequiresReaction) console.warn(`[mobx] Computed value '${this.name_}' is being read outside a reactive context. Doing a full recompute.`);
    }
    toString() {
        return `${this.name_}[${this.derivation.toString()}]`;
    }
    valueOf() {
        return $7c1ccfb859bb0dff$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $7c1ccfb859bb0dff$var$isComputedValue = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ComputedValue", $7c1ccfb859bb0dff$var$ComputedValue);
class $7c1ccfb859bb0dff$var$CaughtException {
    constructor(cause){
        this.cause = void 0;
        this.cause = cause;
    // Empty
    }
}
function $7c1ccfb859bb0dff$var$isCaughtException(e) {
    return e instanceof $7c1ccfb859bb0dff$var$CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function $7c1ccfb859bb0dff$var$shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case 0 /* IDerivationState_.UP_TO_DATE_ */ :
            return false;
        case -1 /* IDerivationState_.NOT_TRACKING_ */ :
        case 2 /* IDerivationState_.STALE_ */ :
            return true;
        case 1 /* IDerivationState_.POSSIBLY_STALE_ */ :
            {
                // state propagation can occur outside of action/reactive context #2195
                const prevAllowStateReads = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? $7c1ccfb859bb0dff$export$84c93b6404d77e6f(true) : true;
                const prevUntracked = $7c1ccfb859bb0dff$var$untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
                const obs = derivation.observing_, l = obs.length;
                for(let i = 0; i < l; i++){
                    const obj = obs[i];
                    if ($7c1ccfb859bb0dff$var$isComputedValue(obj)) {
                        if ($7c1ccfb859bb0dff$var$globalState.disableErrorBoundaries) obj.get();
                        else try {
                            obj.get();
                        } catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            $7c1ccfb859bb0dff$var$untrackedEnd(prevUntracked);
                            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(prevAllowStateReads);
                            return true;
                        }
                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                        // and `derivation` is an observer of `obj`
                        // invariantShouldCompute(derivation)
                        if (derivation.dependenciesState_ === 2 /* IDerivationState_.STALE_ */ ) {
                            $7c1ccfb859bb0dff$var$untrackedEnd(prevUntracked);
                            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(prevAllowStateReads);
                            return true;
                        }
                    }
                }
                $7c1ccfb859bb0dff$var$changeDependenciesStateTo0(derivation);
                $7c1ccfb859bb0dff$var$untrackedEnd(prevUntracked);
                if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(prevAllowStateReads);
                return false;
            }
    }
}
function $7c1ccfb859bb0dff$export$34c53f8cb85e26c1() {
    return $7c1ccfb859bb0dff$var$globalState.trackingDerivation !== null; // filter out actions inside computations
}
function $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(atom) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
    const hasObservers = !!atom.observers_ && atom.observers_.size > 0;
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!$7c1ccfb859bb0dff$var$globalState.allowStateChanges && (hasObservers || $7c1ccfb859bb0dff$var$globalState.enforceActions === "always")) console.warn("[MobX] " + ($7c1ccfb859bb0dff$var$globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
}
function $7c1ccfb859bb0dff$var$checkIfStateReadsAreAllowed(observable) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$globalState.allowStateReads && $7c1ccfb859bb0dff$var$globalState.observableRequiresReaction) console.warn(`[mobx] Observable '${observable.name_}' being read outside a reactive context.`);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function $7c1ccfb859bb0dff$var$trackDerivedFunction(derivation, f, context) {
    const prevAllowStateReads = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? $7c1ccfb859bb0dff$export$84c93b6404d77e6f(true) : true;
    $7c1ccfb859bb0dff$var$changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++$7c1ccfb859bb0dff$var$globalState.runId;
    const prevTracking = $7c1ccfb859bb0dff$var$globalState.trackingDerivation;
    $7c1ccfb859bb0dff$var$globalState.trackingDerivation = derivation;
    $7c1ccfb859bb0dff$var$globalState.inBatch++;
    let result;
    if ($7c1ccfb859bb0dff$var$globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new $7c1ccfb859bb0dff$var$CaughtException(e);
    }
    $7c1ccfb859bb0dff$var$globalState.inBatch--;
    $7c1ccfb859bb0dff$var$globalState.trackingDerivation = prevTracking;
    $7c1ccfb859bb0dff$var$bindDependencies(derivation);
    $7c1ccfb859bb0dff$var$warnAboutDerivationWithoutDependencies(derivation);
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(prevAllowStateReads);
    return result;
}
function $7c1ccfb859bb0dff$var$warnAboutDerivationWithoutDependencies(derivation) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
    if (derivation.observing_.length !== 0) return;
    if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : $7c1ccfb859bb0dff$var$globalState.reactionRequiresObservable) console.warn(`[mobx] Derivation '${derivation.name_}' is created/updated without reading any observable value.`);
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function $7c1ccfb859bb0dff$var$bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    const prevObserving = derivation.observing_;
    const observing = derivation.observing_ = derivation.newObserving_;
    let lowestNewObservingDerivationState = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    let i0 = 0, l = derivation.unboundDepsCount_;
    for(let i = 0; i < l; i++){
        const dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        const dep = prevObserving[l];
        if (dep.diffValue === 0) $7c1ccfb859bb0dff$var$removeObserver(dep, derivation);
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        const dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            $7c1ccfb859bb0dff$var$addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function $7c1ccfb859bb0dff$var$clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    const obs = derivation.observing_;
    derivation.observing_ = [];
    let i = obs.length;
    while(i--)$7c1ccfb859bb0dff$var$removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
}
function $7c1ccfb859bb0dff$export$8c437e4d572e2f99(action) {
    const prev = $7c1ccfb859bb0dff$var$untrackedStart();
    try {
        return action();
    } finally{
        $7c1ccfb859bb0dff$var$untrackedEnd(prev);
    }
}
function $7c1ccfb859bb0dff$var$untrackedStart() {
    const prev = $7c1ccfb859bb0dff$var$globalState.trackingDerivation;
    $7c1ccfb859bb0dff$var$globalState.trackingDerivation = null;
    return prev;
}
function $7c1ccfb859bb0dff$var$untrackedEnd(prev) {
    $7c1ccfb859bb0dff$var$globalState.trackingDerivation = prev;
}
function $7c1ccfb859bb0dff$export$84c93b6404d77e6f(allowStateReads) {
    const prev = $7c1ccfb859bb0dff$var$globalState.allowStateReads;
    $7c1ccfb859bb0dff$var$globalState.allowStateReads = allowStateReads;
    return prev;
}
function $7c1ccfb859bb0dff$export$c7b7fb1b2b410642(prev) {
    $7c1ccfb859bb0dff$var$globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function $7c1ccfb859bb0dff$var$changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    derivation.dependenciesState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    const obs = derivation.observing_;
    let i = obs.length;
    while(i--)obs[i].lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
}
const $7c1ccfb859bb0dff$var$MOBX_GLOBALS_VERSION = 7;
/**
 * These values will persist if global state is reset
 */ const $7c1ccfb859bb0dff$var$persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
class $7c1ccfb859bb0dff$var$MobXGlobals {
    constructor(){
        /**
     * MobXGlobals version.
     * MobX compatiblity with other versions loaded in memory as long as this version matches.
     * It indicates that the global state still stores similar information
     *
     * N.B: this version is unrelated to the package version of MobX, and is only the version of the
     * internal state storage of MobX, and can be the same across many different package versions
     */ this.version = $7c1ccfb859bb0dff$var$MOBX_GLOBALS_VERSION;
        /**
     * globally unique token to signal unchanged
     */ this.UNCHANGED = {};
        /**
     * Currently running derivation
     */ this.trackingDerivation = null;
        /**
     * Currently running reaction. This determines if we currently have a reactive context.
     * (Tracking derivation is also set for temporal tracking of computed values inside actions,
     * but trackingReaction can only be set by a form of Reaction)
     */ this.trackingContext = null;
        /**
     * Each time a derivation is tracked, it is assigned a unique run-id
     */ this.runId = 0;
        /**
     * 'guid' for general purpose. Will be persisted amongst resets.
     */ this.mobxGuid = 0;
        /**
     * Are we in a batch block? (and how many of them)
     */ this.inBatch = 0;
        /**
     * Observables that don't have observers anymore, and are about to be
     * suspended, unless somebody else accesses it in the same batch
     *
     * @type {IObservable[]}
     */ this.pendingUnobservations = [];
        /**
     * List of scheduled, not yet executed, reactions.
     */ this.pendingReactions = [];
        /**
     * Are we currently processing reactions?
     */ this.isRunningReactions = false;
        /**
     * Are we currently draining pendingUnobservations in endBatch?
     * An onBecomeUnobserved handler can dispose a Reaction, which calls
     * startBatch/endBatch again; this guards against re-entering the same
     * drain loop recursively (see endBatch in observable.ts).
     */ this.isRunningUnobservations = false;
        /**
     * Is it allowed to change observables at this point?
     * In general, MobX doesn't allow that when running computations and React.render.
     * To ensure that those functions stay pure.
     */ this.allowStateChanges = false;
        /**
     * Is it allowed to read observables at this point?
     * Used to hold the state needed for `observableRequiresReaction`
     */ this.allowStateReads = true;
        /**
     * If strict mode is enabled, state changes are by default not allowed
     */ this.enforceActions = true;
        /**
     * Spy callbacks
     */ this.spyListeners = [];
        /**
     * Globally attached error handlers that react specifically to errors in reactions
     */ this.globalReactionErrorHandlers = [];
        /**
     * Warn if computed values are accessed outside a reactive context
     */ this.computedRequiresReaction = false;
        /**
     * (Experimental)
     * Warn if you try to create to derivation / reactive context without accessing any observable.
     */ this.reactionRequiresObservable = false;
        /**
     * (Experimental)
     * Warn if observables are accessed outside a reactive context
     */ this.observableRequiresReaction = false;
        /*
     * Don't catch and rethrow exceptions. This is useful for inspecting the state of
     * the stack when an exception occurs while debugging.
     */ this.disableErrorBoundaries = false;
        /*
     * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
     * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
     */ this.suppressReactionErrors = false;
        /**
     * False forces all object's descriptors to
     * writable: true
     * configurable: true
     */ this.safeDescriptors = true;
    }
}
let $7c1ccfb859bb0dff$var$canMergeGlobalState = true;
let $7c1ccfb859bb0dff$var$isolateCalled = false;
let $7c1ccfb859bb0dff$var$globalState = /*#__PURE__*/ function() {
    let global = globalThis;
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) $7c1ccfb859bb0dff$var$canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== $7c1ccfb859bb0dff$var$MOBX_GLOBALS_VERSION) $7c1ccfb859bb0dff$var$canMergeGlobalState = false;
    if (!$7c1ccfb859bb0dff$var$canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(()=>{
            if (!$7c1ccfb859bb0dff$var$isolateCalled) $7c1ccfb859bb0dff$var$die(35);
        }, 1);
        return new $7c1ccfb859bb0dff$var$MobXGlobals();
    } else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global.__mobxGlobals;
    } else {
        global.__mobxInstanceCount = 1;
        return global.__mobxGlobals = /*#__PURE__*/ new $7c1ccfb859bb0dff$var$MobXGlobals();
    }
}();
function $7c1ccfb859bb0dff$var$isolateGlobalState() {
    if ($7c1ccfb859bb0dff$var$globalState.pendingReactions.length || $7c1ccfb859bb0dff$var$globalState.inBatch || $7c1ccfb859bb0dff$var$globalState.isRunningReactions) $7c1ccfb859bb0dff$var$die(36);
    $7c1ccfb859bb0dff$var$isolateCalled = true;
    if ($7c1ccfb859bb0dff$var$canMergeGlobalState) {
        let global = globalThis;
        if (--global.__mobxInstanceCount === 0) global.__mobxGlobals = undefined;
        $7c1ccfb859bb0dff$var$globalState = new $7c1ccfb859bb0dff$var$MobXGlobals();
    }
}
function $7c1ccfb859bb0dff$export$c78907783e606401() {
    return $7c1ccfb859bb0dff$var$globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function $7c1ccfb859bb0dff$export$5c18e491c80b9ab4() {
    const defaultGlobals = new $7c1ccfb859bb0dff$var$MobXGlobals();
    for(let key in defaultGlobals)if ($7c1ccfb859bb0dff$var$persistentKeys.indexOf(key) === -1) $7c1ccfb859bb0dff$var$globalState[key] = defaultGlobals[key];
    $7c1ccfb859bb0dff$var$globalState.allowStateChanges = !$7c1ccfb859bb0dff$var$globalState.enforceActions;
}
function $7c1ccfb859bb0dff$var$hasObservers(observable) {
    return !!observable.observers_ && observable.observers_.size > 0;
}
function $7c1ccfb859bb0dff$var$getObservers(observable) {
    var _observable$observers;
    return (_observable$observers = observable.observers_) != null ? _observable$observers : new Set();
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function $7c1ccfb859bb0dff$var$addObserver(observable, node) {
    var _observable$observers2;
    ((_observable$observers2 = observable.observers_) != null ? _observable$observers2 : observable.observers_ = new Set()).add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function $7c1ccfb859bb0dff$var$removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    const observers = observable.observers_;
    if (!observers) return;
    observers.delete(node);
    if (observers.size === 0) // deleting last observer
    $7c1ccfb859bb0dff$var$queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function $7c1ccfb859bb0dff$var$queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        $7c1ccfb859bb0dff$var$globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function $7c1ccfb859bb0dff$var$startBatch() {
    $7c1ccfb859bb0dff$var$globalState.inBatch++;
}
function $7c1ccfb859bb0dff$var$endBatch() {
    if (--$7c1ccfb859bb0dff$var$globalState.inBatch === 0) {
        $7c1ccfb859bb0dff$var$runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        // Guard against re-entering this loop: an onBUO handler can dispose a Reaction,
        // which calls startBatch/endBatch again while we're still iterating. Bail out of
        // the nested call instead of recursing; the outer loop re-reads list.length on
        // every iteration, so it picks up anything the nested dispose() pushes onto the
        // same pendingUnobservations array.
        if (!$7c1ccfb859bb0dff$var$globalState.isRunningUnobservations && $7c1ccfb859bb0dff$var$globalState.pendingUnobservations.length > 0) $7c1ccfb859bb0dff$var$runPendingUnobservations();
    }
}
// Only called when there is something to unobserve, so the common endBatch() skips the
// try/finally and the pendingUnobservations reallocation entirely
function $7c1ccfb859bb0dff$var$runPendingUnobservations() {
    $7c1ccfb859bb0dff$var$globalState.isRunningUnobservations = true;
    try {
        const list = $7c1ccfb859bb0dff$var$globalState.pendingUnobservations;
        for(let i = 0; i < list.length; i++){
            const observable = list[i];
            observable.isPendingUnobservation = false;
            if (!observable.observers_ || observable.observers_.size === 0) {
                // release the empty Set so unobserved atoms don't keep paying for it
                observable.observers_ = null;
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof $7c1ccfb859bb0dff$var$ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        $7c1ccfb859bb0dff$var$globalState.pendingUnobservations = [];
    } finally{
        // Always release the guard, even if an onBUO handler (user code) threw,
        // otherwise every future endBatch() would see isRunningUnobservations
        // stuck true and silently stop draining pendingUnobservations forever.
        $7c1ccfb859bb0dff$var$globalState.isRunningUnobservations = false;
    }
}
/**
 * Marks an observable as observed, cascading into the dependencies of a ComputedValue.
 * Unobservation already cascades (`suspend_` -> `clearObserving`), observation normally
 * only does so by accident: a newly observed computed usually recomputes and re-reports
 * its dependencies. When it serves a cached value instead nothing re-reports them, so the
 * transition has to be propagated by hand. See #4547.
 */ function $7c1ccfb859bb0dff$var$markObserved(observable) {
    var _observable$observing;
    if (observable.isBeingObserved) return;
    observable.isBeingObserved = true;
    observable.onBO();
    // No queueForUnobservation here: the observer links already exist, so the regular
    // suspend_ -> clearObserving -> removeObserver teardown still delivers the onBUO.
    (_observable$observing = observable.observing_) == null || _observable$observing.forEach($7c1ccfb859bb0dff$var$markObserved);
}
function $7c1ccfb859bb0dff$var$reportObserved(observable) {
    $7c1ccfb859bb0dff$var$checkIfStateReadsAreAllowed(observable);
    const derivation = $7c1ccfb859bb0dff$var$globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && $7c1ccfb859bb0dff$var$globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if ((!observable.observers_ || observable.observers_.size === 0) && $7c1ccfb859bb0dff$var$globalState.inBatch > 0) $7c1ccfb859bb0dff$var$queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function $7c1ccfb859bb0dff$var$propagateChanged(observable) {
    var _observable$observers3;
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    (_observable$observers3 = observable.observers_) == null || _observable$observers3.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) d.onBecomeStale_();
        d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function $7c1ccfb859bb0dff$var$propagateChangeConfirmed(observable) {
    var _observable$observers4;
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    (_observable$observers4 = observable.observers_) == null || _observable$observers4.forEach((d)=>{
        if (d.dependenciesState_ === 1 /* IDerivationState_.POSSIBLY_STALE_ */ ) d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
        else if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */  // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function $7c1ccfb859bb0dff$var$propagateMaybeChanged(observable) {
    var _observable$observers5;
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    observable.lowestObserverState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
    (_observable$observers5 = observable.observers_) == null || _observable$observers5.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
            d.dependenciesState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
class $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb {
    constructor(name_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "Reaction@" + $7c1ccfb859bb0dff$var$getNextId() : "Reaction", onInvalidate_, errorHandler_, requiresObservable_){
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.removeAbortListener_ = undefined;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    get isDisposed() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ );
    }
    set isDisposed(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ , newValue);
    }
    get isScheduled() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ );
    }
    set isScheduled(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ , newValue);
    }
    get isTrackPending() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ );
    }
    set isTrackPending(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ , newValue);
    }
    get isRunning() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 8 /* ReactionFlags.isRunning */ );
    }
    set isRunning(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 8 /* ReactionFlags.isRunning */ , newValue);
    }
    get diffValue() {
        return $7c1ccfb859bb0dff$var$getFlag(this.flags_, 16 /* ReactionFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $7c1ccfb859bb0dff$var$setFlag(this.flags_, 16 /* ReactionFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBecomeStale_() {
        this.schedule_();
    }
    schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            $7c1ccfb859bb0dff$var$globalState.pendingReactions.push(this);
            $7c1ccfb859bb0dff$var$runReactions();
        }
    }
    /**
   * internal, use schedule() if you intend to kick off a reaction
   */ runReaction_() {
        if (!this.isDisposed) {
            $7c1ccfb859bb0dff$var$startBatch();
            this.isScheduled = false;
            const prev = $7c1ccfb859bb0dff$var$globalState.trackingContext;
            $7c1ccfb859bb0dff$var$globalState.trackingContext = this;
            if ($7c1ccfb859bb0dff$var$shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && this.isTrackPending && $7c1ccfb859bb0dff$var$isSpyEnabled()) // onInvalidate didn't trigger track right away..
                    $7c1ccfb859bb0dff$var$spyReport({
                        name: this.name_,
                        type: "scheduled-reaction"
                    });
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            $7c1ccfb859bb0dff$var$globalState.trackingContext = prev;
            $7c1ccfb859bb0dff$var$endBatch();
        }
    }
    track(fn) {
        if (this.isDisposed) return;
        $7c1ccfb859bb0dff$var$startBatch();
        const notify = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
        let startTime;
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notify) {
            startTime = Date.now();
            $7c1ccfb859bb0dff$var$spyReportStart({
                name: this.name_,
                type: "reaction"
            });
        }
        this.isRunning = true;
        const prevReaction = $7c1ccfb859bb0dff$var$globalState.trackingContext; // reactions could create reactions...
        $7c1ccfb859bb0dff$var$globalState.trackingContext = this;
        const result = $7c1ccfb859bb0dff$var$trackDerivedFunction(this, fn, undefined);
        $7c1ccfb859bb0dff$var$globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        $7c1ccfb859bb0dff$var$clearObserving(this);
        if ($7c1ccfb859bb0dff$var$isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notify) $7c1ccfb859bb0dff$var$spyReportEnd({
            time: Date.now() - startTime
        });
        $7c1ccfb859bb0dff$var$endBatch();
    }
    reportExceptionInDerivation_(error) {
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if ($7c1ccfb859bb0dff$var$globalState.disableErrorBoundaries) throw error;
        const message = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '${this}'` : `[mobx] uncaught error in '${this}'`;
        if (!$7c1ccfb859bb0dff$var$globalState.suppressReactionErrors) console.error(message, error);
        else if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) console.warn(`[mobx] (error in reaction '${this.name_}' suppressed, fix error of causing action below)`);
         // prettier-ignore
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled()) $7c1ccfb859bb0dff$var$spyReport({
            type: "error",
            name: this.name_,
            message: message,
            error: "" + error
        });
        $7c1ccfb859bb0dff$var$globalState.globalReactionErrorHandlers.forEach((f)=>f(error, this));
    }
    dispose() {
        if (!this.isDisposed) {
            var _this$removeAbortList;
            this.isDisposed = true;
            // also covers self-disposal (`r.dispose()`, `when`), which bypasses the disposer
            (_this$removeAbortList = this.removeAbortListener_) == null || _this$removeAbortList.call(this);
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                $7c1ccfb859bb0dff$var$startBatch();
                $7c1ccfb859bb0dff$var$clearObserving(this);
                $7c1ccfb859bb0dff$var$endBatch();
            }
        }
    }
    getDisposer_(abortSignal) {
        const dispose = ()=>this.dispose();
        if (abortSignal != null && abortSignal.addEventListener && !this.isDisposed) {
            abortSignal.addEventListener("abort", dispose);
            this.removeAbortListener_ = ()=>abortSignal.removeEventListener == null ? void 0 : abortSignal.removeEventListener("abort", dispose);
        }
        dispose[$7c1ccfb859bb0dff$export$f246528900dd4467] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    }
    toString() {
        return `Reaction[${this.name_}]`;
    }
}
function $7c1ccfb859bb0dff$export$d7203a53b5e117e4(handler) {
    $7c1ccfb859bb0dff$var$globalState.globalReactionErrorHandlers.push(handler);
    return ()=>{
        const idx = $7c1ccfb859bb0dff$var$globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) $7c1ccfb859bb0dff$var$globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ const $7c1ccfb859bb0dff$var$MAX_REACTION_ITERATIONS = 100;
let $7c1ccfb859bb0dff$var$reactionScheduler = (f)=>f();
function $7c1ccfb859bb0dff$var$runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if ($7c1ccfb859bb0dff$var$globalState.inBatch > 0 || $7c1ccfb859bb0dff$var$globalState.isRunningReactions) return;
    $7c1ccfb859bb0dff$var$reactionScheduler($7c1ccfb859bb0dff$var$runReactionsHelper);
}
function $7c1ccfb859bb0dff$var$runReactionsHelper() {
    $7c1ccfb859bb0dff$var$globalState.isRunningReactions = true;
    const allReactions = $7c1ccfb859bb0dff$var$globalState.pendingReactions;
    let iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === $7c1ccfb859bb0dff$var$MAX_REACTION_ITERATIONS) {
            console.error($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `Reaction doesn't converge to a stable state after ${$7c1ccfb859bb0dff$var$MAX_REACTION_ITERATIONS} iterations.` + ` Probably there is a cycle in the reactive function: ${allReactions[0]}` : `[mobx] cycle in reaction: ${allReactions[0]}`);
            allReactions.splice(0); // clear reactions
        }
        let remainingReactions = allReactions.splice(0);
        for(let i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    $7c1ccfb859bb0dff$var$globalState.isRunningReactions = false;
}
const $7c1ccfb859bb0dff$var$isReaction = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("Reaction", $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb);
function $7c1ccfb859bb0dff$var$setReactionScheduler(fn) {
    const baseScheduler = $7c1ccfb859bb0dff$var$reactionScheduler;
    $7c1ccfb859bb0dff$var$reactionScheduler = (f)=>fn(()=>baseScheduler(f));
}
function $7c1ccfb859bb0dff$var$isSpyEnabled() {
    return $7c1ccfb859bb0dff$var$__MOBX_DEV__ && !!$7c1ccfb859bb0dff$var$globalState.spyListeners.length;
}
function $7c1ccfb859bb0dff$var$spyReport(event) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
     // dead code elimination can do the rest
    if (!$7c1ccfb859bb0dff$var$globalState.spyListeners.length) return;
    const listeners = $7c1ccfb859bb0dff$var$globalState.spyListeners;
    for(let i = 0, l = listeners.length; i < l; i++)listeners[i](event);
}
function $7c1ccfb859bb0dff$var$spyReportStart(event) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
    const change = $7c1ccfb859bb0dff$var$assign({}, event, {
        spyReportStart: true
    });
    $7c1ccfb859bb0dff$var$spyReport(change);
}
const $7c1ccfb859bb0dff$var$END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function $7c1ccfb859bb0dff$var$spyReportEnd(change) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) return;
    if (change) $7c1ccfb859bb0dff$var$spyReport($7c1ccfb859bb0dff$var$assign({}, change, {
        type: "report-end",
        spyReportEnd: true
    }));
    else $7c1ccfb859bb0dff$var$spyReport($7c1ccfb859bb0dff$var$END_EVENT);
}
function $7c1ccfb859bb0dff$export$fcc0cd19e9fb2b4c(listener) {
    if (!$7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        console.warn(`[mobx.spy] Is a no-op in production builds`);
        return function() {};
    } else {
        $7c1ccfb859bb0dff$var$globalState.spyListeners.push(listener);
        return $7c1ccfb859bb0dff$var$once(()=>{
            $7c1ccfb859bb0dff$var$globalState.spyListeners = $7c1ccfb859bb0dff$var$globalState.spyListeners.filter((l)=>l !== listener);
        });
    }
}
const $7c1ccfb859bb0dff$var$ACTION = "action";
const $7c1ccfb859bb0dff$var$ACTION_BOUND = "action.bound";
const $7c1ccfb859bb0dff$var$AUTOACTION = "autoAction";
const $7c1ccfb859bb0dff$var$AUTOACTION_BOUND = "autoAction.bound";
const $7c1ccfb859bb0dff$var$DEFAULT_ACTION_NAME = "<unnamed action>";
const $7c1ccfb859bb0dff$var$actionAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionAnnotation($7c1ccfb859bb0dff$var$ACTION);
const $7c1ccfb859bb0dff$var$actionBoundAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionAnnotation($7c1ccfb859bb0dff$var$ACTION_BOUND, {
    bound: true
});
const $7c1ccfb859bb0dff$var$autoActionAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionAnnotation($7c1ccfb859bb0dff$var$AUTOACTION, {
    autoAction: true
});
const $7c1ccfb859bb0dff$var$autoActionBoundAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionAnnotation($7c1ccfb859bb0dff$var$AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function $7c1ccfb859bb0dff$var$createActionDecoratorAnnotation(annotation) {
    return $7c1ccfb859bb0dff$var$createDecoratorAnnotation(annotation, $7c1ccfb859bb0dff$var$decorateAction20223_);
}
function $7c1ccfb859bb0dff$var$createActionFactory(autoAction) {
    const res = function action(arg1, arg2) {
        if (arg2 && typeof arg2.kind === "string") return $7c1ccfb859bb0dff$var$decorateAction20223_(autoAction ? $7c1ccfb859bb0dff$var$autoActionAnnotation : $7c1ccfb859bb0dff$var$actionAnnotation, arg1, arg2);
        // action(fn() {})
        if ($7c1ccfb859bb0dff$var$isFunction(arg1)) return $7c1ccfb859bb0dff$var$createAction(arg1.name || $7c1ccfb859bb0dff$var$DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if ($7c1ccfb859bb0dff$var$isFunction(arg2)) return $7c1ccfb859bb0dff$var$createAction(arg1, arg2, autoAction);
        // action("name") annotation
        if ($7c1ccfb859bb0dff$var$isStringish(arg1)) return $7c1ccfb859bb0dff$var$createActionDecoratorAnnotation($7c1ccfb859bb0dff$var$createActionAnnotation(autoAction ? $7c1ccfb859bb0dff$var$AUTOACTION : $7c1ccfb859bb0dff$var$ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$die("Invalid arguments for `action`");
    };
    return res;
}
const $7c1ccfb859bb0dff$export$31eb53bd5b582a97 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionFactory(false);
$7c1ccfb859bb0dff$var$assign($7c1ccfb859bb0dff$export$31eb53bd5b582a97, $7c1ccfb859bb0dff$var$actionAnnotation);
const $7c1ccfb859bb0dff$export$b8aa795084cbf86b = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionFactory(true);
$7c1ccfb859bb0dff$var$assign($7c1ccfb859bb0dff$export$b8aa795084cbf86b, $7c1ccfb859bb0dff$var$autoActionAnnotation);
const $7c1ccfb859bb0dff$export$3720eced4297d10c = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionDecoratorAnnotation($7c1ccfb859bb0dff$var$actionBoundAnnotation);
const $7c1ccfb859bb0dff$export$4dd0b06162f181e = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createActionDecoratorAnnotation($7c1ccfb859bb0dff$var$autoActionBoundAnnotation);
function $7c1ccfb859bb0dff$export$832370e58be26204(fn) {
    return $7c1ccfb859bb0dff$var$executeAction(fn.name || $7c1ccfb859bb0dff$var$DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function $7c1ccfb859bb0dff$export$b956e38827fca970(thing) {
    return $7c1ccfb859bb0dff$var$isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function $7c1ccfb859bb0dff$export$4abd31caebb0bb24(view, opts = $7c1ccfb859bb0dff$var$EMPTY_OBJECT) {
    var _opts$name, _opts$signal;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (!$7c1ccfb859bb0dff$var$isFunction(view)) $7c1ccfb859bb0dff$var$die("Autorun expects a function as first argument");
        if ($7c1ccfb859bb0dff$export$b956e38827fca970(view)) $7c1ccfb859bb0dff$var$die("Autorun does not accept actions since actions are untrackable");
    }
    const name = (_opts$name = opts == null ? void 0 : opts.name) != null ? _opts$name : $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? view.name || "Autorun@" + $7c1ccfb859bb0dff$var$getNextId() : "Autorun";
    const runSync = !opts.scheduler && !opts.delay;
    let reaction;
    if (runSync) // normal autorun
    reaction = new $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        const scheduler = $7c1ccfb859bb0dff$var$createSchedulerFromOptions(opts);
        // debounced autorun
        let isScheduled = false;
        reaction = new $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb(name, ()=>{
            if (!isScheduled) {
                isScheduled = true;
                scheduler(()=>{
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!(opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_(opts == null ? void 0 : opts.signal);
}
const $7c1ccfb859bb0dff$var$run = (f)=>f();
function $7c1ccfb859bb0dff$var$createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? (f)=>setTimeout(f, opts.delay) : $7c1ccfb859bb0dff$var$run;
}
function $7c1ccfb859bb0dff$export$7203b476385689ae(expression, effect, opts = $7c1ccfb859bb0dff$var$EMPTY_OBJECT) {
    var _opts$name2, _opts$signal2;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (!$7c1ccfb859bb0dff$var$isFunction(expression) || !$7c1ccfb859bb0dff$var$isFunction(effect)) $7c1ccfb859bb0dff$var$die("First and second argument to reaction should be functions");
        if (!$7c1ccfb859bb0dff$var$isPlainObject(opts)) $7c1ccfb859bb0dff$var$die("Third argument of reactions should be an object");
    }
    const name = (_opts$name2 = opts.name) != null ? _opts$name2 : $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "Reaction@" + $7c1ccfb859bb0dff$var$getNextId() : "Reaction";
    const effectAction = $7c1ccfb859bb0dff$export$31eb53bd5b582a97(name, opts.onError ? $7c1ccfb859bb0dff$var$wrapErrorHandler(opts.onError, effect) : effect);
    const runSync = !opts.scheduler && !opts.delay;
    const scheduler = $7c1ccfb859bb0dff$var$createSchedulerFromOptions(opts);
    let firstTime = true;
    let isScheduled = false;
    let value;
    const equals = opts.equals || $7c1ccfb859bb0dff$export$700812e5ccfdbb1d;
    const r = new $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb(name, ()=>{
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        let changed = false;
        const oldValue = value;
        r.track(()=>{
            const nextValue = $7c1ccfb859bb0dff$export$e510c5d1ea4358b1(false, ()=>expression(r));
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!(opts != null && (_opts$signal2 = opts.signal) != null && _opts$signal2.aborted)) r.schedule_();
    return r.getDisposer_(opts == null ? void 0 : opts.signal);
}
function $7c1ccfb859bb0dff$var$wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
const $7c1ccfb859bb0dff$var$ON_BECOME_OBSERVED = "onBO";
const $7c1ccfb859bb0dff$var$ON_BECOME_UNOBSERVED = "onBUO";
function $7c1ccfb859bb0dff$export$24d7f9cdf0de2679(thing, arg2, arg3) {
    return $7c1ccfb859bb0dff$var$interceptHook($7c1ccfb859bb0dff$var$ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function $7c1ccfb859bb0dff$export$f8586f6f22b9cba9(thing, arg2, arg3) {
    return $7c1ccfb859bb0dff$var$interceptHook($7c1ccfb859bb0dff$var$ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function $7c1ccfb859bb0dff$var$interceptHook(hook, thing, arg2, arg3) {
    const atom = typeof arg3 === "function" ? $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, arg2) : $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing);
    const cb = $7c1ccfb859bb0dff$var$isFunction(arg3) ? arg3 : arg2;
    const listenersKey = `${hook}L`;
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        const hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
const $7c1ccfb859bb0dff$var$ALWAYS = "always";
const $7c1ccfb859bb0dff$var$OBSERVED = "observed";
function $7c1ccfb859bb0dff$export$8d21e34596265fa2(options) {
    if (options.isolateGlobalState === true) $7c1ccfb859bb0dff$var$isolateGlobalState();
    const { enforceActions: enforceActions } = options;
    if (enforceActions !== undefined) {
        const ea = enforceActions === $7c1ccfb859bb0dff$var$ALWAYS ? $7c1ccfb859bb0dff$var$ALWAYS : enforceActions === $7c1ccfb859bb0dff$var$OBSERVED;
        $7c1ccfb859bb0dff$var$globalState.enforceActions = ea;
        $7c1ccfb859bb0dff$var$globalState.allowStateChanges = ea === true || ea === $7c1ccfb859bb0dff$var$ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach((key)=>{
        if (key in options) $7c1ccfb859bb0dff$var$globalState[key] = !!options[key];
    });
    $7c1ccfb859bb0dff$var$globalState.allowStateReads = !$7c1ccfb859bb0dff$var$globalState.observableRequiresReaction;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$globalState.disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
    if (options.reactionScheduler) $7c1ccfb859bb0dff$var$setReactionScheduler(options.reactionScheduler);
}
function $7c1ccfb859bb0dff$export$59d8134e963031bd(target, properties, annotations, options) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (arguments.length > 4) $7c1ccfb859bb0dff$var$die("'extendObservable' expected 2-4 arguments");
        if (typeof target !== "object") $7c1ccfb859bb0dff$var$die("'extendObservable' expects an object as first argument");
        if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(target)) $7c1ccfb859bb0dff$var$die("'extendObservable' should not be used on maps, use map.merge instead");
        if (!$7c1ccfb859bb0dff$var$isPlainObject(properties)) $7c1ccfb859bb0dff$var$die(`'extendObservable' only accepts plain objects as second argument`);
        if ($7c1ccfb859bb0dff$export$5cd057a6046189f9(properties) || $7c1ccfb859bb0dff$export$5cd057a6046189f9(annotations)) $7c1ccfb859bb0dff$var$die(`Extending an object with another observable (object) is not supported`);
    }
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    const descriptors = $7c1ccfb859bb0dff$var$getOwnPropertyDescriptors(properties);
    $7c1ccfb859bb0dff$var$initObservable(()=>{
        const adm = $7c1ccfb859bb0dff$var$asObservableObject(target, options)[$7c1ccfb859bb0dff$export$f246528900dd4467];
        $7c1ccfb859bb0dff$var$ownKeys(descriptors).forEach((key)=>{
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : $7c1ccfb859bb0dff$var$hasProp(annotations, key) ? annotations[key] : true);
        });
    });
    return target;
}
function $7c1ccfb859bb0dff$export$23fbf90e5d80a5ee(thing, property) {
    return $7c1ccfb859bb0dff$var$nodeToDependencyTree($7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property));
}
function $7c1ccfb859bb0dff$var$nodeToDependencyTree(node) {
    const result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = $7c1ccfb859bb0dff$var$unique(node.observing_).map($7c1ccfb859bb0dff$var$nodeToDependencyTree);
    return result;
}
function $7c1ccfb859bb0dff$export$3b1621dddf5aeacd(thing, property) {
    return $7c1ccfb859bb0dff$var$nodeToObserverTree($7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property));
}
function $7c1ccfb859bb0dff$var$nodeToObserverTree(node) {
    const result = {
        name: node.name_
    };
    if ($7c1ccfb859bb0dff$var$hasObservers(node)) result.observers = Array.from($7c1ccfb859bb0dff$var$getObservers(node), $7c1ccfb859bb0dff$var$nodeToObserverTree);
    return result;
}
function $7c1ccfb859bb0dff$var$unique(list) {
    return Array.from(new Set(list));
}
let $7c1ccfb859bb0dff$var$generatorId = 0;
class $7c1ccfb859bb0dff$export$134218f44485f691 extends Error {
    constructor(){
        super("FLOW_CANCELLED");
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = "FlowCancellationError";
    }
    toString() {
        return `Error: ${this.message}`;
    }
}
function $7c1ccfb859bb0dff$export$e01c2a57c655302d(error) {
    return error instanceof $7c1ccfb859bb0dff$export$134218f44485f691;
}
function $7c1ccfb859bb0dff$var$createFlowDecoratorAnnotation(annotation) {
    return $7c1ccfb859bb0dff$var$createDecoratorAnnotation(annotation, $7c1ccfb859bb0dff$var$decorateFlow20223_);
}
const $7c1ccfb859bb0dff$var$flowAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createFlowAnnotation("flow");
const $7c1ccfb859bb0dff$var$flowBoundAnnotation = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createFlowAnnotation("flow.bound", {
    bound: true
});
const $7c1ccfb859bb0dff$export$ccc7b0636abaffc3 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$assign(function flow(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $7c1ccfb859bb0dff$var$decorateFlow20223_($7c1ccfb859bb0dff$var$flowAnnotation, arg1, arg2);
    // flow(fn)
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && arguments.length !== 1) $7c1ccfb859bb0dff$var$die(`Flow expects single argument with generator function`);
    const generator = arg1;
    const name = generator.name || ($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "<unnamed flow>" : "flow");
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    const res = function res() {
        const ctx = this;
        const args = arguments;
        const runId = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? ++$7c1ccfb859bb0dff$var$generatorId : 0;
        const gen = $7c1ccfb859bb0dff$export$31eb53bd5b582a97($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - init` : name, generator).apply(ctx, args);
        let rejector;
        let pendingPromise = undefined;
        const promise = new Promise(function(resolve, reject) {
            let stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $7c1ccfb859bb0dff$export$31eb53bd5b582a97($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - yield ${stepId++}` : name, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $7c1ccfb859bb0dff$export$31eb53bd5b582a97($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - yield ${stepId++}` : name, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if ($7c1ccfb859bb0dff$var$isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        const cancelActionName = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - cancel` : name;
        promise.cancel = $7c1ccfb859bb0dff$export$31eb53bd5b582a97(cancelActionName, function() {
            try {
                if (pendingPromise) $7c1ccfb859bb0dff$var$cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                const res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                const yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then($7c1ccfb859bb0dff$var$noop, $7c1ccfb859bb0dff$var$noop);
                $7c1ccfb859bb0dff$var$cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new $7c1ccfb859bb0dff$export$134218f44485f691());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, $7c1ccfb859bb0dff$var$flowAnnotation);
const $7c1ccfb859bb0dff$export$d41c06fa934cc67e = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createFlowDecoratorAnnotation($7c1ccfb859bb0dff$var$flowBoundAnnotation);
function $7c1ccfb859bb0dff$var$cancelPromise(promise) {
    if ($7c1ccfb859bb0dff$var$isFunction(promise.cancel)) promise.cancel();
}
function $7c1ccfb859bb0dff$export$b1b0dfc8def25964(result) {
    return result; // just tricking TypeScript :)
}
function $7c1ccfb859bb0dff$export$8c23365ce94ba925(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function $7c1ccfb859bb0dff$export$bf4da824ef9b40d0(thing, propOrHandler, handler) {
    let target;
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(thing) || $7c1ccfb859bb0dff$export$f5afceff386badf9(thing) || $7c1ccfb859bb0dff$export$fafbc00dbefd1aef(thing)) target = $7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing);
    else if ($7c1ccfb859bb0dff$export$31960fb081a18155(thing)) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isStringish(propOrHandler)) return $7c1ccfb859bb0dff$var$die(`InterceptReads can only be used with a specific property, not with an object in general`);
        target = $7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing, propOrHandler);
    } else if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) return $7c1ccfb859bb0dff$var$die(`Expected observable map, object or array as first array`);
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && target.dehancer !== undefined) return $7c1ccfb859bb0dff$var$die(`An intercept reader was already established`);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return ()=>{
        target.dehancer = undefined;
    };
}
function $7c1ccfb859bb0dff$export$ab0f802c05dd969b(thing, propOrHandler, handler) {
    if ($7c1ccfb859bb0dff$var$isFunction(handler)) return $7c1ccfb859bb0dff$var$interceptProperty(thing, propOrHandler, handler);
    else return $7c1ccfb859bb0dff$var$interceptInterceptable(thing, propOrHandler);
}
function $7c1ccfb859bb0dff$var$interceptInterceptable(thing, handler) {
    return $7c1ccfb859bb0dff$var$registerInterceptor($7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing), handler);
}
function $7c1ccfb859bb0dff$var$interceptProperty(thing, property, handler) {
    return $7c1ccfb859bb0dff$var$registerInterceptor($7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing, property), handler);
}
function $7c1ccfb859bb0dff$var$_isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return $7c1ccfb859bb0dff$var$isComputedValue(value);
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(value) === false) return false;
    const adm = value[$7c1ccfb859bb0dff$export$f246528900dd4467];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    const atom = $7c1ccfb859bb0dff$export$25fc416d10fa1afa(value, property);
    return $7c1ccfb859bb0dff$var$isComputedValue(atom);
}
function $7c1ccfb859bb0dff$export$21bb8b7af2417cc3(value) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && arguments.length > 1) return $7c1ccfb859bb0dff$var$die(`isComputed expects only 1 argument. Use isComputedProp to inspect the observability of a property`);
    return $7c1ccfb859bb0dff$var$_isComputed(value);
}
function $7c1ccfb859bb0dff$export$3cf701ab9f66d86a(value, propName) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isStringish(propName)) return $7c1ccfb859bb0dff$var$die(`isComputed expected a property name as second argument`);
    return $7c1ccfb859bb0dff$var$_isComputed(value, propName);
}
function $7c1ccfb859bb0dff$var$_isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && ($7c1ccfb859bb0dff$export$27a7faddcfd44960(value) || $7c1ccfb859bb0dff$export$f5afceff386badf9(value))) return $7c1ccfb859bb0dff$var$die("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if ($7c1ccfb859bb0dff$export$31960fb081a18155(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            const adm = value[$7c1ccfb859bb0dff$export$f246528900dd4467];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return $7c1ccfb859bb0dff$export$31960fb081a18155(value) || !!value[$7c1ccfb859bb0dff$export$f246528900dd4467] || $7c1ccfb859bb0dff$var$isAtom(value) || $7c1ccfb859bb0dff$var$isReaction(value) || $7c1ccfb859bb0dff$var$isComputedValue(value);
}
function $7c1ccfb859bb0dff$export$5cd057a6046189f9(value) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && arguments.length !== 1) $7c1ccfb859bb0dff$var$die(`isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property`);
    return $7c1ccfb859bb0dff$var$_isObservable(value);
}
function $7c1ccfb859bb0dff$export$7ad7acc949ba3cc7(value, propName) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isStringish(propName)) return $7c1ccfb859bb0dff$var$die(`expected a property name as second argument`);
    return $7c1ccfb859bb0dff$var$_isObservable(value, propName);
}
function $7c1ccfb859bb0dff$export$ed97f33186d4b816(obj) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return obj[$7c1ccfb859bb0dff$export$f246528900dd4467].keys_();
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj) || $7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) return Array.from(obj.keys());
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) return obj.map((_, index)=>index);
    $7c1ccfb859bb0dff$var$die(5);
}
function $7c1ccfb859bb0dff$export$68c286be0e7e55b7(obj) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return $7c1ccfb859bb0dff$export$ed97f33186d4b816(obj).map((key)=>obj[key]);
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) return $7c1ccfb859bb0dff$export$ed97f33186d4b816(obj).map((key)=>obj.get(key));
    if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) return Array.from(obj.values());
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) return obj.slice();
    $7c1ccfb859bb0dff$var$die(6);
}
function $7c1ccfb859bb0dff$export$3e9f948b41964866(obj) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return $7c1ccfb859bb0dff$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj[key]
        ]);
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) return $7c1ccfb859bb0dff$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj.get(key)
        ]);
    if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) return Array.from(obj.entries());
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) return obj.map((key, index)=>[
            index,
            key
        ]);
    $7c1ccfb859bb0dff$var$die(7);
}
function $7c1ccfb859bb0dff$export$adaa4cf7ef1b65be(obj, key, value) {
    if (arguments.length === 2 && !$7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) {
        $7c1ccfb859bb0dff$var$startBatch();
        const values = key;
        try {
            for(let _key in values)$7c1ccfb859bb0dff$export$adaa4cf7ef1b65be(obj, _key, values[_key]);
        } finally{
            $7c1ccfb859bb0dff$var$endBatch();
        }
        return;
    }
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) obj[$7c1ccfb859bb0dff$export$f246528900dd4467].set_(key, value);
    else if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) obj.set(key, value);
    else if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) obj.add(key);
    else if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) $7c1ccfb859bb0dff$var$die(42, key);
        $7c1ccfb859bb0dff$var$startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        $7c1ccfb859bb0dff$var$endBatch();
    } else $7c1ccfb859bb0dff$var$die(8);
}
function $7c1ccfb859bb0dff$export$cd7f480d6b8286c3(obj, key) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) obj[$7c1ccfb859bb0dff$export$f246528900dd4467].delete_(key);
    else if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) obj.delete(key);
    else if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) obj.delete(key);
    else if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else $7c1ccfb859bb0dff$var$die(9);
}
function $7c1ccfb859bb0dff$export$a4f4bb6b1453fff5(obj, key) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return obj[$7c1ccfb859bb0dff$export$f246528900dd4467].has_(key);
    else if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) return obj.has(key);
    else if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(obj)) return obj.has(key);
    else if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) return key >= 0 && key < obj.length;
    $7c1ccfb859bb0dff$var$die(10);
}
function $7c1ccfb859bb0dff$export$3988ae62b71be9a3(obj, key) {
    if (!$7c1ccfb859bb0dff$export$a4f4bb6b1453fff5(obj, key)) return undefined;
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return obj[$7c1ccfb859bb0dff$export$f246528900dd4467].get_(key);
    else if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(obj)) return obj.get(key);
    else if ($7c1ccfb859bb0dff$export$f5afceff386badf9(obj)) return obj[key];
    $7c1ccfb859bb0dff$var$die(11);
}
function $7c1ccfb859bb0dff$export$fdab3c20aae16ddf(obj, key, descriptor) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return obj[$7c1ccfb859bb0dff$export$f246528900dd4467].defineProperty_(key, descriptor);
    $7c1ccfb859bb0dff$var$die(39);
}
function $7c1ccfb859bb0dff$export$6aa2094d45f88f20(obj) {
    if ($7c1ccfb859bb0dff$export$31960fb081a18155(obj)) return obj[$7c1ccfb859bb0dff$export$f246528900dd4467].ownKeys_();
    $7c1ccfb859bb0dff$var$die(38);
}
function $7c1ccfb859bb0dff$export$d1203567a167490e(thing, propOrCb, cbOrFire, fireImmediately) {
    if ($7c1ccfb859bb0dff$var$isFunction(cbOrFire)) return $7c1ccfb859bb0dff$var$observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return $7c1ccfb859bb0dff$var$observeObservable(thing, propOrCb, cbOrFire);
}
function $7c1ccfb859bb0dff$var$observeObservable(thing, listener, fireImmediately) {
    const adm = $7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing);
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(thing)) {
        if (fireImmediately) listener({
            observableKind: "array",
            object: adm.proxy_,
            debugObjectName: adm.atom_.name_,
            type: "splice",
            index: 0,
            added: adm.values_.slice(),
            addedCount: adm.values_.length,
            removed: [],
            removedCount: 0
        });
    } else if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(thing)) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && fireImmediately === true) $7c1ccfb859bb0dff$var$die("`observe` doesn't support fireImmediately=true in combination with maps.");
    } else if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(thing)) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && fireImmediately === true) $7c1ccfb859bb0dff$var$die("`observe` doesn't support fireImmediately=true in combination with sets.");
    } else if ($7c1ccfb859bb0dff$export$31960fb081a18155(thing)) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && fireImmediately === true) $7c1ccfb859bb0dff$var$die("`observe` doesn't support the fire immediately property for observable objects.");
    } else return $7c1ccfb859bb0dff$var$observeValue(adm, listener, fireImmediately);
    return $7c1ccfb859bb0dff$var$registerListener(adm, listener);
}
function $7c1ccfb859bb0dff$var$observeObservableProperty(thing, property, listener, fireImmediately) {
    return $7c1ccfb859bb0dff$var$observeValue($7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing, property), listener, fireImmediately);
}
function $7c1ccfb859bb0dff$var$observeValue(adm, listener, fireImmediately) {
    if ($7c1ccfb859bb0dff$var$isComputedValue(adm)) {
        let firstTime = true;
        let prevValue = undefined;
        return $7c1ccfb859bb0dff$export$4abd31caebb0bb24(()=>{
            const newValue = adm.get();
            if (!firstTime || fireImmediately) {
                const prevU = $7c1ccfb859bb0dff$var$untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: adm.name_,
                    type: $7c1ccfb859bb0dff$var$UPDATE,
                    object: adm,
                    newValue: newValue,
                    oldValue: prevValue
                });
                $7c1ccfb859bb0dff$var$untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    }
    if (fireImmediately) listener({
        observableKind: "value",
        debugObjectName: adm.name_,
        object: adm,
        type: $7c1ccfb859bb0dff$var$UPDATE,
        newValue: adm.value_,
        oldValue: undefined
    });
    return $7c1ccfb859bb0dff$var$registerListener(adm, listener);
}
function $7c1ccfb859bb0dff$var$cache(map, key, value) {
    map.set(key, value);
    return value;
}
function $7c1ccfb859bb0dff$var$toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !$7c1ccfb859bb0dff$export$5cd057a6046189f9(source)) return source;
    if ($7c1ccfb859bb0dff$export$fafbc00dbefd1aef(source) || $7c1ccfb859bb0dff$var$isComputedValue(source)) return $7c1ccfb859bb0dff$var$toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(source)) {
        const res = $7c1ccfb859bb0dff$var$cache(__alreadySeen, source, new Array(source.length));
        source.forEach((value, idx)=>{
            res[idx] = $7c1ccfb859bb0dff$var$toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(source)) {
        const res = $7c1ccfb859bb0dff$var$cache(__alreadySeen, source, new Set());
        source.forEach((value)=>{
            res.add($7c1ccfb859bb0dff$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    }
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(source)) {
        const res = $7c1ccfb859bb0dff$var$cache(__alreadySeen, source, new Map());
        source.forEach((value, key)=>{
            res.set(key, $7c1ccfb859bb0dff$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    } else {
        // must be observable object
        const res = $7c1ccfb859bb0dff$var$cache(__alreadySeen, source, {});
        $7c1ccfb859bb0dff$export$6aa2094d45f88f20(source).forEach((key)=>{
            if ($7c1ccfb859bb0dff$var$objectPrototype.propertyIsEnumerable.call(source, key)) res[key] = $7c1ccfb859bb0dff$var$toJSHelper(source[key], __alreadySeen);
        });
        $7c1ccfb859bb0dff$var$copyObservableAccessors(source, res, __alreadySeen);
        return res;
    }
}
/**
 * Copies `@observable accessor` fields, which are defined on the prototype, so they are neither own nor enumerable.
 * Their values live in the administration: in `values_` once read, and in `lazyObservableKeys_` until then.
 * Computed values and private accessors are left out.
 * Kept here instead of on the administration, so it is tree shaken away when `toJS` is not used.
 */ function $7c1ccfb859bb0dff$var$copyObservableAccessors(source, res, __alreadySeen) {
    const adm = source[$7c1ccfb859bb0dff$export$f246528900dd4467];
    if (adm.lazyObservableKeys_ === undefined) // No `@observable accessor` field ever registered (it becomes `null`, not `undefined`, once all were read)
    return;
    const target = adm.target_;
    // Own keys were already copied by `toJSHelper`, and `in` leaves out private `#field` keys
    for (const [key, value] of adm.values_)if (!$7c1ccfb859bb0dff$var$hasProp(target, key) && !(value instanceof $7c1ccfb859bb0dff$var$ComputedValue) && key in target) res[key] = $7c1ccfb859bb0dff$var$toJSHelper(source[key], __alreadySeen);
    // Fields that were never read have no entry in `values_` yet, reading them creates it
    if (adm.lazyObservableKeys_) {
        for (const key of adm.lazyObservableKeys_.keys())if (!adm.values_.has(key) && !$7c1ccfb859bb0dff$var$hasProp(target, key) && key in target) res[key] = $7c1ccfb859bb0dff$var$toJSHelper(source[key], __alreadySeen);
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored, except for `@observable accessor` fields.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function $7c1ccfb859bb0dff$export$f08965dd1304d490(source, options) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && options) $7c1ccfb859bb0dff$var$die("toJS no longer supports options");
    return $7c1ccfb859bb0dff$var$toJSHelper(source, new Map());
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(action, thisArg) {
    $7c1ccfb859bb0dff$var$startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        $7c1ccfb859bb0dff$var$endBatch();
    }
}
function $7c1ccfb859bb0dff$export$a55877ca9db47377(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return $7c1ccfb859bb0dff$var$whenPromise(predicate, arg1);
    return $7c1ccfb859bb0dff$var$_when(predicate, arg1, arg2 || {});
}
function $7c1ccfb859bb0dff$var$_when(predicate, effect, opts) {
    let timeoutHandle;
    if (typeof opts.timeout === "number") {
        const error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(()=>{
            if (!disposer[$7c1ccfb859bb0dff$export$f246528900dd4467].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? opts.name || "When@" + $7c1ccfb859bb0dff$var$getNextId() : "When";
    const effectAction = $7c1ccfb859bb0dff$var$createAction($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? opts.name + "-effect" : "When-effect", effect);
    // eslint-disable-next-line
    var disposer = $7c1ccfb859bb0dff$export$4abd31caebb0bb24((r)=>{
        // predicate should not change state
        let cond = $7c1ccfb859bb0dff$export$e510c5d1ea4358b1(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function $7c1ccfb859bb0dff$var$whenPromise(predicate, opts) {
    var _opts$signal;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && opts && opts.onError) return $7c1ccfb859bb0dff$var$die(`the options 'onError' and 'promise' cannot be combined`);
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return $7c1ccfb859bb0dff$var$assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: ()=>null
    });
    let cancel;
    let abort;
    const res = new Promise((resolve, reject)=>{
        var _opts$signal2;
        let disposer = $7c1ccfb859bb0dff$var$_when(predicate, resolve, $7c1ccfb859bb0dff$var$assign({}, opts, {
            onError: reject
        }));
        cancel = ()=>{
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = ()=>{
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    }).finally(()=>{
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function $7c1ccfb859bb0dff$var$getAdm(target) {
    return target[$7c1ccfb859bb0dff$export$f246528900dd4467];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
const $7c1ccfb859bb0dff$var$objectProxyTraps = {
    has (target, name) {
        return $7c1ccfb859bb0dff$var$getAdm(target).has_(name);
    },
    get (target, name) {
        return $7c1ccfb859bb0dff$var$getAdm(target).get_(name);
    },
    set (target, name, value) {
        var _getAdm$set_;
        if (!$7c1ccfb859bb0dff$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = $7c1ccfb859bb0dff$var$getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty (target, name) {
        var _getAdm$delete_;
        if (!$7c1ccfb859bb0dff$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = $7c1ccfb859bb0dff$var$getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty (target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = $7c1ccfb859bb0dff$var$getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys (target) {
        return $7c1ccfb859bb0dff$var$getAdm(target).ownKeys_();
    },
    preventExtensions (target) {
        $7c1ccfb859bb0dff$var$die(13);
    }
};
function $7c1ccfb859bb0dff$var$asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    target = $7c1ccfb859bb0dff$var$asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$7c1ccfb859bb0dff$export$f246528900dd4467]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, $7c1ccfb859bb0dff$var$objectProxyTraps);
}
function $7c1ccfb859bb0dff$var$hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function $7c1ccfb859bb0dff$var$registerInterceptor(interceptable, handler) {
    let interceptors = interceptable.interceptors_;
    if (interceptors) interceptors.push(handler);
    else // Allocate at the exact size: pushing onto an empty array over-allocates its backing store
    interceptors = interceptable.interceptors_ = [
        handler
    ];
    return $7c1ccfb859bb0dff$var$once(()=>{
        const idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function $7c1ccfb859bb0dff$var$interceptChange(interceptable, change) {
    const prevU = $7c1ccfb859bb0dff$var$untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        const interceptors = [
            ...interceptable.interceptors_ || []
        ];
        for(let i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) $7c1ccfb859bb0dff$var$die(14);
            if (!change) break;
        }
        return change;
    } finally{
        $7c1ccfb859bb0dff$var$untrackedEnd(prevU);
    }
}
function $7c1ccfb859bb0dff$var$hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function $7c1ccfb859bb0dff$var$registerListener(listenable, handler) {
    let listeners = listenable.changeListeners_;
    if (listeners) listeners.push(handler);
    else // Allocate at the exact size: pushing onto an empty array over-allocates its backing store
    listeners = listenable.changeListeners_ = [
        handler
    ];
    return $7c1ccfb859bb0dff$var$once(()=>{
        const idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function $7c1ccfb859bb0dff$var$notifyListeners(listenable, change) {
    const prevU = $7c1ccfb859bb0dff$var$untrackedStart();
    let listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(let i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    $7c1ccfb859bb0dff$var$untrackedEnd(prevU);
}
function $7c1ccfb859bb0dff$export$885e6ca7a4dc4b3e(target, annotations, options) {
    $7c1ccfb859bb0dff$var$initObservable(()=>{
        const adm = $7c1ccfb859bb0dff$var$asObservableObject(target, options)[$7c1ccfb859bb0dff$export$f246528900dd4467];
        // Annotate
        $7c1ccfb859bb0dff$var$ownKeys(annotations).forEach((key)=>$7c1ccfb859bb0dff$var$make_(adm, key, annotations[key]));
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
const $7c1ccfb859bb0dff$var$keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function $7c1ccfb859bb0dff$export$1cfaca5abb185fe7(target, overrides, options) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
        if (!$7c1ccfb859bb0dff$var$isPlainObject(target) && !$7c1ccfb859bb0dff$var$isPlainObject(Object.getPrototypeOf(target))) $7c1ccfb859bb0dff$var$die(`'makeAutoObservable' can only be used for classes that don't have a superclass`);
        if ($7c1ccfb859bb0dff$export$31960fb081a18155(target)) $7c1ccfb859bb0dff$var$die(`makeAutoObservable can only be used on objects not already made observable`);
    }
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if ($7c1ccfb859bb0dff$var$isPlainObject(target)) return $7c1ccfb859bb0dff$export$59d8134e963031bd(target, target, overrides, options);
    $7c1ccfb859bb0dff$var$initObservable(()=>{
        const adm = $7c1ccfb859bb0dff$var$asObservableObject(target, options)[$7c1ccfb859bb0dff$export$f246528900dd4467];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[$7c1ccfb859bb0dff$var$keysSymbol]) {
            const proto = Object.getPrototypeOf(target);
            const keys = new Set([
                ...$7c1ccfb859bb0dff$var$ownKeys(target),
                ...$7c1ccfb859bb0dff$var$ownKeys(proto)
            ]);
            keys.delete("constructor");
            keys.delete($7c1ccfb859bb0dff$export$f246528900dd4467);
            $7c1ccfb859bb0dff$var$addHiddenProp(proto, $7c1ccfb859bb0dff$var$keysSymbol, keys);
        }
        target[$7c1ccfb859bb0dff$var$keysSymbol].forEach((key)=>$7c1ccfb859bb0dff$var$make_(adm, key, // must pass "undefined" for { key: undefined }
            !overrides ? true : $7c1ccfb859bb0dff$var$hasProp(overrides, key) ? overrides[key] : true));
    });
    return target;
}
function $7c1ccfb859bb0dff$var$make_(adm, key, annotation) {
    if (annotation === true) annotation = adm.defaultAnnotation_;
    if (annotation === false) return;
    $7c1ccfb859bb0dff$var$assertAnnotable(adm, annotation, key);
    if (!(key in adm.target_)) $7c1ccfb859bb0dff$var$die(1, annotation.annotationType_, `${adm.name_}.${key.toString()}`);
    let source = adm.target_;
    while(source && source !== $7c1ccfb859bb0dff$var$objectPrototype){
        const descriptor = $7c1ccfb859bb0dff$var$getDescriptor(source, key);
        if (descriptor) {
            const outcome = annotation.make_(adm, key, descriptor, source);
            if (outcome === 0 /* MakeResult.Cancel */ ) return;
            if (outcome === 1 /* MakeResult.Break */ ) break;
        }
        source = Object.getPrototypeOf(source);
    }
    $7c1ccfb859bb0dff$var$recordAnnotationApplied(adm, annotation, key);
}
const $7c1ccfb859bb0dff$var$SPLICE = "splice";
const $7c1ccfb859bb0dff$var$UPDATE = "update";
const $7c1ccfb859bb0dff$var$MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
const $7c1ccfb859bb0dff$var$arrayTraps = {
    get (target, name) {
        const adm = target[$7c1ccfb859bb0dff$export$f246528900dd4467];
        if (name === $7c1ccfb859bb0dff$export$f246528900dd4467) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if ($7c1ccfb859bb0dff$var$hasProp($7c1ccfb859bb0dff$var$arrayExtensions, name)) return $7c1ccfb859bb0dff$var$arrayExtensions[name];
        return target[name];
    },
    set (target, name, value) {
        const adm = target[$7c1ccfb859bb0dff$export$f246528900dd4467];
        if (name === "length") adm.setArrayLength_(value);
        else if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions () {
        $7c1ccfb859bb0dff$var$die(15);
    }
};
class $7c1ccfb859bb0dff$var$ObservableArrayAdministration {
    constructor(name = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ObservableArray@" + $7c1ccfb859bb0dff$var$getNextId() : "ObservableArray", enhancer, owned_){
        this.owned_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.atom_ = new $7c1ccfb859bb0dff$var$Atom(name);
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? name + "[..]" : "ObservableArray[..]");
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    }
    getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    }
    setArrayLength_(newLength) {
        if (!Number.isInteger(newLength) || newLength < 0) $7c1ccfb859bb0dff$var$die(40, newLength);
        let currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            const newItems = Array.from({
                length: newLength - currentLength
            });
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    }
    updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) $7c1ccfb859bb0dff$var$die(16);
        this.lastKnownLength_ += delta;
    }
    spliceWithArray_(index, deleteCount, newItems) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.atom_);
        const length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = $7c1ccfb859bb0dff$var$EMPTY_ARRAY;
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                object: this.proxy_,
                type: $7c1ccfb859bb0dff$var$SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return $7c1ccfb859bb0dff$var$EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map((v)=>this.enhancer_(v, undefined));
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
            const lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        const res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    }
    spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < $7c1ccfb859bb0dff$var$MAX_SPLICE_SIZE) return this.values_.splice(index, deleteCount, ...newItems);
        else {
            // The items removed by the splice
            const res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            let oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(let i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(let i = 0; i < oldItems.length; i++)this.values_[index + newItems.length + i] = oldItems[i];
            return res;
        }
    }
    notifyArrayChildUpdate_(index, newValue, oldValue) {
        const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && !this.owned_ && $7c1ccfb859bb0dff$var$isSpyEnabled();
        const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: $7c1ccfb859bb0dff$var$UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
        this.atom_.reportChanged();
        if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
    }
    notifyArraySplice_(index, added, removed) {
        const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && !this.owned_ && $7c1ccfb859bb0dff$var$isSpyEnabled();
        const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: $7c1ccfb859bb0dff$var$SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
    }
    get_(index) {
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    }
    set_(index, newValue) {
        const values = this.values_;
        if (index < values.length) {
            // update at index in range
            $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.atom_);
            const oldValue = values[index];
            if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
                const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                    type: $7c1ccfb859bb0dff$var$UPDATE,
                    object: this.proxy_,
                    index: // since "this" is the real array we need to pass its proxy
                    index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            const changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            const newItems = Array.from({
                length: index + 1 - values.length
            });
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    }
}
function $7c1ccfb859bb0dff$var$createObservableArray(initialValues, enhancer, name = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ObservableArray@" + $7c1ccfb859bb0dff$var$getNextId() : "ObservableArray", owned = false) {
    return $7c1ccfb859bb0dff$var$initObservable(()=>{
        const adm = new $7c1ccfb859bb0dff$var$ObservableArrayAdministration(name, enhancer, owned);
        $7c1ccfb859bb0dff$var$addHiddenFinalProp(adm.values_, $7c1ccfb859bb0dff$export$f246528900dd4467, adm);
        const proxy = new Proxy(adm.values_, $7c1ccfb859bb0dff$var$arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var $7c1ccfb859bb0dff$var$arrayExtensions = {
    clear () {
        return this.splice(0);
    },
    replace (newItems) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON () {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice (index, deleteCount, ...newItems) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray (index, deleteCount, newItems) {
        return this[$7c1ccfb859bb0dff$export$f246528900dd4467].spliceWithArray_(index, deleteCount, newItems);
    },
    push (...items) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop () {
        return this.splice(Math.max(this[$7c1ccfb859bb0dff$export$f246528900dd4467].values_.length - 1, 0), 1)[0];
    },
    shift () {
        return this.splice(0, 1)[0];
    },
    unshift (...items) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if ($7c1ccfb859bb0dff$var$globalState.trackingDerivation) $7c1ccfb859bb0dff$var$die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort () {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if ($7c1ccfb859bb0dff$var$globalState.trackingDerivation) $7c1ccfb859bb0dff$var$die(37, "sort");
        const copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove (value) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        const idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ $7c1ccfb859bb0dff$var$addArrayExtension("at", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("concat", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("flat", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("includes", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("indexOf", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("join", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("lastIndexOf", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("slice", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("toString", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("toLocaleString", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("toSorted", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("toSpliced", $7c1ccfb859bb0dff$var$simpleFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("with", $7c1ccfb859bb0dff$var$simpleFunc);
// map
$7c1ccfb859bb0dff$var$addArrayExtension("every", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("filter", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("find", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("findIndex", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("findLast", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("findLastIndex", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("flatMap", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("forEach", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("map", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("some", $7c1ccfb859bb0dff$var$mapLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("toReversed", $7c1ccfb859bb0dff$var$mapLikeFunc);
// reduce
$7c1ccfb859bb0dff$var$addArrayExtension("reduce", $7c1ccfb859bb0dff$var$reduceLikeFunc);
$7c1ccfb859bb0dff$var$addArrayExtension("reduceRight", $7c1ccfb859bb0dff$var$reduceLikeFunc);
function $7c1ccfb859bb0dff$var$addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") $7c1ccfb859bb0dff$var$arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function $7c1ccfb859bb0dff$var$simpleFunc(funcName) {
    return function() {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function $7c1ccfb859bb0dff$var$mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName]((element, index)=>{
            return callback.call(thisArg, element, index, this);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function $7c1ccfb859bb0dff$var$reduceLikeFunc(funcName) {
    return function() {
        const adm = this[$7c1ccfb859bb0dff$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        const callback = arguments[0];
        arguments[0] = (accumulator, currentValue, index)=>{
            return callback(accumulator, currentValue, index, this);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
const $7c1ccfb859bb0dff$var$isObservableArrayAdministration = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ObservableArrayAdministration", $7c1ccfb859bb0dff$var$ObservableArrayAdministration);
function $7c1ccfb859bb0dff$export$f5afceff386badf9(thing) {
    return $7c1ccfb859bb0dff$var$isObject(thing) && $7c1ccfb859bb0dff$var$isObservableArrayAdministration(thing[$7c1ccfb859bb0dff$export$f246528900dd4467]);
}
const $7c1ccfb859bb0dff$var$ObservableMapMarker = {};
const $7c1ccfb859bb0dff$var$ADD = "add";
const $7c1ccfb859bb0dff$var$DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
class $7c1ccfb859bb0dff$export$db1c0901f08fc6fd {
    constructor(initialData, enhancer_ = $7c1ccfb859bb0dff$var$deepEnhancer, name_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ObservableMap@" + $7c1ccfb859bb0dff$var$getNextId() : "ObservableMap"){
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$7c1ccfb859bb0dff$export$f246528900dd4467] = $7c1ccfb859bb0dff$var$ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        $7c1ccfb859bb0dff$var$initObservable(()=>{
            this.keysAtom_ = $7c1ccfb859bb0dff$export$2e17fe64ec9a826e($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.keys()` : "ObservableMap.keys()");
            this.data_ = new Map();
            this.hasMap_ = new Map();
            if (initialData) this.merge(initialData);
        });
    }
    has_(key) {
        return this.data_.has(key);
    }
    has(key) {
        if (!$7c1ccfb859bb0dff$var$globalState.trackingDerivation) return this.has_(key);
        let entry = this.hasMap_.get(key);
        if (!entry) {
            const newEntry = entry = new $7c1ccfb859bb0dff$var$ObservableValue(this.has_(key), $7c1ccfb859bb0dff$var$referenceEnhancer, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.${$7c1ccfb859bb0dff$var$stringifyKey(key)}?` : "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            newEntry.onBUOL = new Set([
                ()=>this.hasMap_.delete(key)
            ]);
        }
        return entry.get();
    }
    set(key, value) {
        const hasKey = this.has_(key);
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                type: hasKey ? $7c1ccfb859bb0dff$var$UPDATE : $7c1ccfb859bb0dff$var$ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    }
    delete(key) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                type: $7c1ccfb859bb0dff$var$DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $7c1ccfb859bb0dff$var$DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
             // TODO fix type
            $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
                var _this$hasMap_$get;
                this.keysAtom_.reportChanged();
                (_this$hasMap_$get = this.hasMap_.get(key)) == null || _this$hasMap_$get.setNewValue_(false);
                const observable = this.data_.get(key);
                observable.setNewValue_(undefined);
                this.data_.delete(key);
            });
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
            return true;
        }
        return false;
    }
    updateValue_(key, newValue) {
        const observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== $7c1ccfb859bb0dff$var$globalState.UNCHANGED) {
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $7c1ccfb859bb0dff$var$UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
             // TODO fix type
            observable.setNewValue_(newValue);
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
        }
    }
    addValue_(key, newValue) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            var _this$hasMap_$get2;
            const observable = new $7c1ccfb859bb0dff$var$ObservableValue(newValue, this.enhancer_, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.${$7c1ccfb859bb0dff$var$stringifyKey(key)}` : "ObservableMap.key", false);
            this.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this$hasMap_$get2 = this.hasMap_.get(key)) == null || _this$hasMap_$get2.setNewValue_(true);
            this.keysAtom_.reportChanged();
        });
        const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
        const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: $7c1ccfb859bb0dff$var$ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
         // TODO fix type
        if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
    }
    get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    }
    getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    }
    getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    }
    values() {
        const self = this;
        const keys = this.keys();
        return $7c1ccfb859bb0dff$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    }
    entries() {
        const self = this;
        const keys = this.keys();
        return $7c1ccfb859bb0dff$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self.get(value)
                    ]
                };
            }
        });
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    forEach(callback, thisArg) {
        for (const [key, value] of this)callback.call(thisArg, value, key, this);
    }
    /** Merge another object into this object, returns this. */ merge(other) {
        if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(other)) other = new Map(other);
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            if ($7c1ccfb859bb0dff$var$isPlainObject(other)) $7c1ccfb859bb0dff$var$getPlainObjectKeys(other).forEach((key)=>this.set(key, other[key]));
            else if (Array.isArray(other)) other.forEach(([key, value])=>this.set(key, value));
            else if ($7c1ccfb859bb0dff$var$isES6Map(other)) {
                if (!$7c1ccfb859bb0dff$var$isPlainES6Map(other)) $7c1ccfb859bb0dff$var$die(19, other);
                other.forEach((value, key)=>this.set(key, value));
            } else if (other !== null && other !== undefined) $7c1ccfb859bb0dff$var$die(20, other);
        });
        return this;
    }
    clear() {
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            $7c1ccfb859bb0dff$export$8c437e4d572e2f99(()=>{
                for (const key of this.keys())this.delete(key);
            });
        });
    }
    replace(values) {
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            // Convert to map so we can do quick key lookups
            const replacementMap = $7c1ccfb859bb0dff$var$convertToMap(values);
            const orderedData = new Map();
            // Used for optimization
            let keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for (const key of this.data_.keys())// Concurrently iterating/deleting keys
            // iterator should handle this correctly
            if (!replacementMap.has(key)) {
                const deleted = this.delete(key);
                // Was the key removed?
                if (deleted) // _keysAtom.reportChanged() was already called
                keysReportChangedCalled = true;
                else {
                    // Delete prevented by interceptor
                    const value = this.data_.get(key);
                    orderedData.set(key, value);
                }
            }
            // Merge entries
            for (const [key, value] of replacementMap.entries()){
                // We will want to know whether a new key is added
                const keyExisted = this.data_.has(key);
                // Add or update value
                this.set(key, value);
                // The addition could have been prevent by interceptor
                if (this.data_.has(key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    const _value = this.data_.get(key);
                    orderedData.set(key, _value);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (this.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                this.keysAtom_.reportChanged();
                else {
                    const iter1 = this.data_.keys();
                    const iter2 = orderedData.keys();
                    let next1 = iter1.next();
                    let next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            this.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            this.data_ = orderedData;
        });
        return this;
    }
    get size() {
        this.keysAtom_.reportObserved();
        return this.data_.size;
    }
    toString() {
        return "[object ObservableMap]";
    }
    toJSON() {
        return Array.from(this);
    }
    get [Symbol.toStringTag]() {
        return "Map";
    }
}
// eslint-disable-next-line
var $7c1ccfb859bb0dff$export$27a7faddcfd44960 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ObservableMap", $7c1ccfb859bb0dff$export$db1c0901f08fc6fd);
function $7c1ccfb859bb0dff$var$makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return $7c1ccfb859bb0dff$var$makeIterable(iterator);
}
function $7c1ccfb859bb0dff$var$convertToMap(dataStructure) {
    if ($7c1ccfb859bb0dff$var$isES6Map(dataStructure) || $7c1ccfb859bb0dff$export$27a7faddcfd44960(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if ($7c1ccfb859bb0dff$var$isPlainObject(dataStructure)) {
        const map = new Map();
        for(const key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return $7c1ccfb859bb0dff$var$die(21, dataStructure);
}
const $7c1ccfb859bb0dff$var$ObservableSetMarker = {};
class $7c1ccfb859bb0dff$export$2235f602a7a77c81 {
    constructor(initialData, enhancer = $7c1ccfb859bb0dff$var$deepEnhancer, name_ = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? "ObservableSet@" + $7c1ccfb859bb0dff$var$getNextId() : "ObservableSet"){
        this.name_ = void 0;
        this[$7c1ccfb859bb0dff$export$f246528900dd4467] = $7c1ccfb859bb0dff$var$ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, name_);
        $7c1ccfb859bb0dff$var$initObservable(()=>{
            this.atom_ = $7c1ccfb859bb0dff$export$2e17fe64ec9a826e(this.name_);
            if (initialData) this.replace(initialData);
        });
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    clear() {
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            $7c1ccfb859bb0dff$export$8c437e4d572e2f99(()=>{
                for (const value of this.data_.values())this.delete(value);
            });
        });
    }
    forEach(callbackFn, thisArg) {
        for (const value of this)callbackFn.call(thisArg, value, value, this);
    }
    get size() {
        this.atom_.reportObserved();
        return this.data_.size;
    }
    add(value) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                type: $7c1ccfb859bb0dff$var$ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
                value = this.enhancer_(value, undefined); // report the stored value, like map and array
                this.data_.add(value);
                this.atom_.reportChanged();
            });
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $7c1ccfb859bb0dff$var$ADD,
                object: this,
                newValue: value
            } : null;
            if (notifySpy && $7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$spyReportStart(change);
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if (notifySpy && $7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$spyReportEnd();
        }
        return this;
    }
    delete(value) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                type: $7c1ccfb859bb0dff$var$DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $7c1ccfb859bb0dff$var$DELETE,
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && $7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$spyReportStart(change);
            $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
                this.atom_.reportChanged();
                this.data_.delete(value);
            });
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if (notifySpy && $7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$spyReportEnd();
            return true;
        }
        return false;
    }
    has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    }
    entries() {
        const values = this.values();
        return $7c1ccfb859bb0dff$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    keys() {
        return this.values();
    }
    values() {
        this.atom_.reportObserved();
        const self = this;
        const values = this.data_.values();
        return $7c1ccfb859bb0dff$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: self.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    intersection(otherSet) {
        return new Set(this).intersection(otherSet);
    }
    union(otherSet) {
        return new Set(this).union(otherSet);
    }
    difference(otherSet) {
        return new Set(this).difference(otherSet);
    }
    symmetricDifference(otherSet) {
        return new Set(this).symmetricDifference(otherSet);
    }
    isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    }
    isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    }
    isDisjointFrom(otherSet) {
        return new Set(this).isDisjointFrom(otherSet);
    }
    replace(other) {
        if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(other)) other = new Set(other);
        if (Array.isArray(other) || $7c1ccfb859bb0dff$var$isES6Set(other)) // Only emit `delete`/`add` events (and `reportChanged`) for values that
        // actually change, instead of clearing and re-adding everything. `add` and
        // `delete` are already no-ops for values that are respectively already
        // present or already absent, so we just need to avoid deleting values that
        // are part of the replacement. See #3761.
        $7c1ccfb859bb0dff$export$2d62d2646dd2fb3c(()=>{
            // Collect the desired values for quick lookup. `other` is already a Set
            // here when it was passed (or snapshotted from an observable set) as one,
            // so reuse it rather than allocating another; arrays are wrapped (which
            // also dedupes them).
            const replacementValues = $7c1ccfb859bb0dff$var$isES6Set(other) ? other : new Set(other);
            // Short-circuit the trivial cases: an empty replacement is just a clear,
            // and replacing into an empty set only needs the adds.
            if (replacementValues.size === 0) {
                this.clear();
                return;
            }
            if (this.data_.size === 0) {
                replacementValues.forEach((value)=>this.add(value));
                return;
            }
            // Delete values that are not part of the replacement.
            for (const value of this.data_.values())if (!replacementValues.has(this.dehanceValue_(value))) this.delete(value);
            // Add new values; values that are already present are a no-op.
            replacementValues.forEach((value)=>this.add(value));
        });
        else if (other !== null && other !== undefined) $7c1ccfb859bb0dff$var$die(41, other);
        return this;
    }
    toJSON() {
        return Array.from(this);
    }
    toString() {
        return "[object ObservableSet]";
    }
    [Symbol.iterator]() {
        return this.values();
    }
    get [Symbol.toStringTag]() {
        return "Set";
    }
}
// eslint-disable-next-line
var $7c1ccfb859bb0dff$export$da6b063694cb52c1 = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ObservableSet", $7c1ccfb859bb0dff$export$2235f602a7a77c81);
function $7c1ccfb859bb0dff$var$makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return $7c1ccfb859bb0dff$var$makeIterable(iterator);
}
const $7c1ccfb859bb0dff$var$descriptorCache = /*#__PURE__*/ Object.create(null);
const $7c1ccfb859bb0dff$var$REMOVE = "remove";
class $7c1ccfb859bb0dff$var$ObservableObjectAdministration {
    constructor(target_, values_ = new Map(), name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_ = $7c1ccfb859bb0dff$var$autoAnnotation){
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        // `null` once all fields were read, so `toJS` can tell objects with `@observable accessor` fields apart
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new $7c1ccfb859bb0dff$var$Atom($7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.keys` : "ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = $7c1ccfb859bb0dff$var$isPlainObject(this.target_);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isAnnotation(this.defaultAnnotation_)) $7c1ccfb859bb0dff$var$die(`defaultAnnotation must be valid annotation`);
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) // Prepare structure for tracking which fields were already annotated
        this.appliedAnnotations_ = {};
    }
    getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        const observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    }
    materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        const factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_.delete(key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        const computed = factory();
        this.values_.set(key, computed);
        return computed;
    }
    materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        const factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_.delete(key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = null;
        const observable = factory();
        this.values_.set(key, observable);
        return observable;
    }
    setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        const observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof $7c1ccfb859bb0dff$var$ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                type: $7c1ccfb859bb0dff$var$UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== $7c1ccfb859bb0dff$var$globalState.UNCHANGED) {
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const change = notify || notifySpy ? {
                type: $7c1ccfb859bb0dff$var$UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
            observable.setNewValue_(newValue);
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
        }
        return true;
    }
    get_(key) {
        if ($7c1ccfb859bb0dff$var$globalState.trackingDerivation && !$7c1ccfb859bb0dff$var$hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    }
    /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ set_(key, value, proxyTrap = false) {
        // Don't use .has(key) - we care about own
        if ($7c1ccfb859bb0dff$var$hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    }
    // Trap for "in"
    has_(key) {
        if (!$7c1ccfb859bb0dff$var$globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        let entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new $7c1ccfb859bb0dff$var$ObservableValue(key in this.target_, $7c1ccfb859bb0dff$var$referenceEnhancer, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.${$7c1ccfb859bb0dff$var$stringifyKey(key)}?` : "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
            entry.onBUOL = new Set([
                ()=>{
                    var _this$pendingKeys_;
                    return (_this$pendingKeys_ = this.pendingKeys_) == null ? void 0 : _this$pendingKeys_.delete(key);
                }
            ]);
        }
        return entry.get();
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ extend_(key, descriptor, annotation, proxyTrap = false) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        $7c1ccfb859bb0dff$var$assertAnnotable(this, annotation, key);
        const outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) $7c1ccfb859bb0dff$var$recordAnnotationApplied(this, annotation, key);
        return outcome;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ defineProperty_(key, descriptor, proxyTrap = false) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $7c1ccfb859bb0dff$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
                const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $7c1ccfb859bb0dff$var$ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                const { newValue: newValue } = change;
                if (descriptor.value !== newValue) descriptor = $7c1ccfb859bb0dff$var$assign({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $7c1ccfb859bb0dff$var$defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            $7c1ccfb859bb0dff$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineObservableProperty_(key, value, enhancer, proxyTrap = false) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $7c1ccfb859bb0dff$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
                const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $7c1ccfb859bb0dff$var$ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            const cachedDescriptor = $7c1ccfb859bb0dff$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $7c1ccfb859bb0dff$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $7c1ccfb859bb0dff$var$defineProperty(this.target_, key, descriptor);
            const observable = new $7c1ccfb859bb0dff$var$ObservableValue(value, enhancer, $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.${key.toString()}` : "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            $7c1ccfb859bb0dff$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineComputedProperty_(key, options, proxyTrap = false) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $7c1ccfb859bb0dff$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
                const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $7c1ccfb859bb0dff$var$ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${this.name_}.${key.toString()}` : "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            const cachedDescriptor = $7c1ccfb859bb0dff$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $7c1ccfb859bb0dff$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $7c1ccfb859bb0dff$var$defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new $7c1ccfb859bb0dff$var$ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            $7c1ccfb859bb0dff$var$endBatch();
        }
        return true;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ delete_(key, proxyTrap = false) {
        $7c1ccfb859bb0dff$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!$7c1ccfb859bb0dff$var$hasProp(this.target_, key)) return true;
        // Intercept
        if ($7c1ccfb859bb0dff$var$hasInterceptors(this)) {
            const change = $7c1ccfb859bb0dff$var$interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: $7c1ccfb859bb0dff$var$REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_2;
            $7c1ccfb859bb0dff$var$startBatch();
            const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
            const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
            const observable = this.values_.get(key);
            // Value needed for spies/listeners
            let value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = $7c1ccfb859bb0dff$var$getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Allow re-annotating this field
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) delete this.appliedAnnotations_[key];
            // Clear observable
            if (observable) {
                this.values_.delete(key);
                // for computed, value is undefined
                if (observable instanceof $7c1ccfb859bb0dff$var$ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                $7c1ccfb859bb0dff$var$propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                const change = {
                    type: $7c1ccfb859bb0dff$var$REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
                if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
                if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
            }
        } finally{
            $7c1ccfb859bb0dff$var$endBatch();
        }
        return true;
    }
    notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_3;
        const notify = $7c1ccfb859bb0dff$var$hasListeners(this);
        const notifySpy = $7c1ccfb859bb0dff$var$__MOBX_DEV__ && $7c1ccfb859bb0dff$var$isSpyEnabled();
        if (notify || notifySpy) {
            const change = notify || notifySpy ? {
                type: $7c1ccfb859bb0dff$var$ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportStart(change);
            if (notify) $7c1ccfb859bb0dff$var$notifyListeners(this, change);
            if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && notifySpy) $7c1ccfb859bb0dff$var$spyReportEnd();
        }
        (_this$pendingKeys_3 = this.pendingKeys_) == null || (_this$pendingKeys_3 = _this$pendingKeys_3.get(key)) == null || _this$pendingKeys_3.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    }
    ownKeys_() {
        this.keysAtom_.reportObserved();
        return $7c1ccfb859bb0dff$var$ownKeys(this.target_);
    }
    keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    }
}
function $7c1ccfb859bb0dff$var$asObservableObject(target, options) {
    var _options$name;
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && options && $7c1ccfb859bb0dff$export$31960fb081a18155(target)) $7c1ccfb859bb0dff$var$die(`Options can't be provided for already observable objects.`);
    if ($7c1ccfb859bb0dff$var$hasProp(target, $7c1ccfb859bb0dff$export$f246528900dd4467)) {
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !($7c1ccfb859bb0dff$export$71ff639cb8b2a36e(target) instanceof $7c1ccfb859bb0dff$var$ObservableObjectAdministration)) $7c1ccfb859bb0dff$var$die(`Cannot convert '${$7c1ccfb859bb0dff$export$c48237bbccf30144(target)}' into observable object:` + `\nThe target is already observable of different type.` + `\nExtending builtins is not supported.`);
        return target;
    }
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !Object.isExtensible(target)) $7c1ccfb859bb0dff$var$die("Cannot make the designated object observable; it is not extensible");
    const name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? `${$7c1ccfb859bb0dff$var$isPlainObject(target) ? "ObservableObject" : target.constructor.name}@${$7c1ccfb859bb0dff$var$getNextId()}` : "ObservableObject";
    const adm = new $7c1ccfb859bb0dff$var$ObservableObjectAdministration(target, new Map(), String(name), $7c1ccfb859bb0dff$var$getAnnotationFromOptions(options));
    $7c1ccfb859bb0dff$var$addHiddenProp(target, $7c1ccfb859bb0dff$export$f246528900dd4467, adm);
    return target;
}
const $7c1ccfb859bb0dff$var$isObservableObjectAdministration = /*#__PURE__*/ $7c1ccfb859bb0dff$var$createInstanceofPredicate("ObservableObjectAdministration", $7c1ccfb859bb0dff$var$ObservableObjectAdministration);
function $7c1ccfb859bb0dff$var$getCachedObservablePropDescriptor(key) {
    return $7c1ccfb859bb0dff$var$descriptorCache[key] || ($7c1ccfb859bb0dff$var$descriptorCache[key] = {
        get () {
            return this[$7c1ccfb859bb0dff$export$f246528900dd4467].getObservablePropValue_(key);
        },
        set (value) {
            return this[$7c1ccfb859bb0dff$export$f246528900dd4467].setObservablePropValue_(key, value);
        }
    });
}
function $7c1ccfb859bb0dff$export$31960fb081a18155(thing) {
    if ($7c1ccfb859bb0dff$var$isObject(thing)) return $7c1ccfb859bb0dff$var$isObservableObjectAdministration(thing[$7c1ccfb859bb0dff$export$f246528900dd4467]);
    return false;
}
function $7c1ccfb859bb0dff$var$recordAnnotationApplied(adm, annotation, key) {
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) adm.appliedAnnotations_[key] = annotation;
}
function $7c1ccfb859bb0dff$var$assertAnnotable(adm, annotation, key) {
    // Valid annotation
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isAnnotation(annotation)) $7c1ccfb859bb0dff$var$die(`Cannot annotate '${adm.name_}.${key.toString()}': Invalid annotation.`);
    /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__MOBX_DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */ // Not annotated
    if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && !$7c1ccfb859bb0dff$var$isOverride(annotation) && $7c1ccfb859bb0dff$var$hasProp(adm.appliedAnnotations_, key)) {
        const fieldName = `${adm.name_}.${key.toString()}`;
        const currentAnnotationType = adm.appliedAnnotations_[key].annotationType_;
        const requestedAnnotationType = annotation.annotationType_;
        $7c1ccfb859bb0dff$var$die(`Cannot apply '${requestedAnnotationType}' to '${fieldName}':` + `\nThe field is already annotated with '${currentAnnotationType}'.` + `\nRe-annotating fields is not allowed.` + `\nUse 'override' annotation for methods overridden by subclass.`);
    }
}
function $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        // objects first: on a proxied object, the set/map checks would subscribe to missing keys
        const adm = thing[$7c1ccfb859bb0dff$export$f246528900dd4467];
        if ($7c1ccfb859bb0dff$var$isObservableObjectAdministration(adm)) {
            var _ref, _adm$values_$get;
            if (!property) return $7c1ccfb859bb0dff$var$die(26);
            const observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!observable) $7c1ccfb859bb0dff$var$die(27, property, $7c1ccfb859bb0dff$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($7c1ccfb859bb0dff$var$isObservableArrayAdministration(adm)) {
            if (property !== undefined) $7c1ccfb859bb0dff$var$die(23);
            return adm.atom_;
        }
        if ($7c1ccfb859bb0dff$export$da6b063694cb52c1(thing)) return thing.atom_;
        if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(thing)) {
            if (property === undefined) return thing.keysAtom_;
            const observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) $7c1ccfb859bb0dff$var$die(25, property, $7c1ccfb859bb0dff$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($7c1ccfb859bb0dff$export$31960fb081a18155(thing)) return $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property);
        if ($7c1ccfb859bb0dff$var$isAtom(thing) || $7c1ccfb859bb0dff$var$isComputedValue(thing) || $7c1ccfb859bb0dff$var$isReaction(thing)) return thing;
    } else if ($7c1ccfb859bb0dff$var$isFunction(thing)) {
        if ($7c1ccfb859bb0dff$var$isReaction(thing[$7c1ccfb859bb0dff$export$f246528900dd4467])) // disposer function
        return thing[$7c1ccfb859bb0dff$export$f246528900dd4467];
    }
    $7c1ccfb859bb0dff$var$die(28);
}
function $7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing, property) {
    if (!thing) $7c1ccfb859bb0dff$var$die(29);
    if (property !== undefined) return $7c1ccfb859bb0dff$export$71ff639cb8b2a36e($7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property));
    if ($7c1ccfb859bb0dff$var$isAtom(thing) || $7c1ccfb859bb0dff$var$isComputedValue(thing) || $7c1ccfb859bb0dff$var$isReaction(thing)) return thing;
    if ($7c1ccfb859bb0dff$export$27a7faddcfd44960(thing) || $7c1ccfb859bb0dff$export$da6b063694cb52c1(thing)) return thing;
    if (thing[$7c1ccfb859bb0dff$export$f246528900dd4467]) return thing[$7c1ccfb859bb0dff$export$f246528900dd4467];
    $7c1ccfb859bb0dff$var$die(24, thing);
}
function $7c1ccfb859bb0dff$export$c48237bbccf30144(thing, property) {
    let named;
    if (property !== undefined) named = $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing, property);
    else if ($7c1ccfb859bb0dff$export$b956e38827fca970(thing)) return thing.name;
    else if ($7c1ccfb859bb0dff$export$31960fb081a18155(thing) || $7c1ccfb859bb0dff$export$27a7faddcfd44960(thing) || $7c1ccfb859bb0dff$export$da6b063694cb52c1(thing)) named = $7c1ccfb859bb0dff$export$71ff639cb8b2a36e(thing);
    else // valid for arrays as well
    named = $7c1ccfb859bb0dff$export$25fc416d10fa1afa(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function $7c1ccfb859bb0dff$var$initObservable(cb) {
    const derivation = $7c1ccfb859bb0dff$var$untrackedStart();
    const allowStateChanges = $7c1ccfb859bb0dff$var$__MOBX_DEV__ ? $7c1ccfb859bb0dff$var$allowStateChangesStart(true) : true;
    $7c1ccfb859bb0dff$var$startBatch();
    try {
        return cb();
    } finally{
        $7c1ccfb859bb0dff$var$endBatch();
        if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) $7c1ccfb859bb0dff$var$allowStateChangesEnd(allowStateChanges);
        $7c1ccfb859bb0dff$var$untrackedEnd(derivation);
    }
}
const $7c1ccfb859bb0dff$var$toString = $7c1ccfb859bb0dff$var$objectPrototype.toString;
function $7c1ccfb859bb0dff$var$deepEqual(a, b, depth = -1) {
    return $7c1ccfb859bb0dff$var$eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function $7c1ccfb859bb0dff$var$eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    const type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    const className = $7c1ccfb859bb0dff$var$toString.call(a);
    if (className !== $7c1ccfb859bb0dff$var$toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = $7c1ccfb859bb0dff$var$unwrap(a);
    b = $7c1ccfb859bb0dff$var$unwrap(b);
    const areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        const aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !($7c1ccfb859bb0dff$var$isFunction(aCtor) && aCtor instanceof aCtor && $7c1ccfb859bb0dff$var$isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    let length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$7c1ccfb859bb0dff$var$eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        const keys = Object.keys(a);
        const _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(let i = 0; i < _length; i++){
            // Deep compare each member
            const key = keys[i];
            if (!($7c1ccfb859bb0dff$var$hasProp(b, key) && $7c1ccfb859bb0dff$var$eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $7c1ccfb859bb0dff$var$unwrap(a) {
    if ($7c1ccfb859bb0dff$export$f5afceff386badf9(a)) return a.slice();
    if ($7c1ccfb859bb0dff$var$isES6Map(a) || $7c1ccfb859bb0dff$export$27a7faddcfd44960(a)) return Array.from(a.entries());
    if ($7c1ccfb859bb0dff$var$isES6Set(a) || $7c1ccfb859bb0dff$export$da6b063694cb52c1(a)) return Array.from(a.entries());
    return a;
}
var $7c1ccfb859bb0dff$var$_globalThis$Iterator;
// safely get iterator prototype if available
const $7c1ccfb859bb0dff$var$maybeIteratorPrototype = (($7c1ccfb859bb0dff$var$_globalThis$Iterator = globalThis.Iterator) == null ? void 0 : $7c1ccfb859bb0dff$var$_globalThis$Iterator.prototype) || {};
function $7c1ccfb859bb0dff$var$makeIterable(iterator) {
    iterator[Symbol.iterator] = $7c1ccfb859bb0dff$var$getSelf;
    return $7c1ccfb859bb0dff$var$assign(Object.create($7c1ccfb859bb0dff$var$maybeIteratorPrototype), iterator);
}
function $7c1ccfb859bb0dff$var$getSelf() {
    return this;
}
function $7c1ccfb859bb0dff$var$isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && $7c1ccfb859bb0dff$var$isFunction(thing.make_) && $7c1ccfb859bb0dff$var$isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ if ($7c1ccfb859bb0dff$var$__MOBX_DEV__) {
    const g = globalThis;
    [
        "Symbol",
        "Map",
        "Set",
        "Proxy"
    ].forEach((m)=>{
        if (typeof g[m] === "undefined") $7c1ccfb859bb0dff$var$die(`MobX requires global '${m}' to be available or polyfilled`);
    });
}
if ($7c1ccfb859bb0dff$var$__MOBX_DEV__ && typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: $7c1ccfb859bb0dff$export$fcc0cd19e9fb2b4c,
    extras: {
        getDebugName: $7c1ccfb859bb0dff$export$c48237bbccf30144
    },
    $mobx: $7c1ccfb859bb0dff$export$f246528900dd4467
});




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $d49aa9d43f3479e9$var$__MOBX_DEV__ = false;
var $d49aa9d43f3479e9$var$_getGlobalState2;
if (!(0, $5E6i4.useState) || !(0, $5E6i4.useSyncExternalStore)) throw new Error("mobx-react-lite requires React 18 or later");
if (!(((0, $7c1ccfb859bb0dff$export$c78907783e606401) == null || ($d49aa9d43f3479e9$var$_getGlobalState2 = (0, $7c1ccfb859bb0dff$export$c78907783e606401)()) == null ? void 0 : $d49aa9d43f3479e9$var$_getGlobalState2.version) >= 7)) throw new Error("mobx-react-lite requires mobx at least version 7 to be available");
const $d49aa9d43f3479e9$var$REGISTRY_FINALIZE_AFTER = 10000;
const $d49aa9d43f3479e9$var$REGISTRY_SWEEP_INTERVAL = 10000;
class $d49aa9d43f3479e9$var$TimerBasedFinalizationRegistry {
    constructor(finalize){
        this.finalize = void 0;
        this.registrations = new Map();
        this.sweepTimeout = void 0;
        this.sweep = (maxAge = $d49aa9d43f3479e9$var$REGISTRY_FINALIZE_AFTER)=>{
            // cancel timeout so we can force sweep anytime
            clearTimeout(this.sweepTimeout);
            this.sweepTimeout = undefined;
            const now = Date.now();
            this.registrations.forEach((registration, token)=>{
                if (now - registration.registeredAt >= maxAge) {
                    this.registrations.delete(token);
                    this.finalize(registration.value);
                }
            });
            if (this.registrations.size > 0) this.scheduleSweep();
        };
        this.finalizeAllImmediately = ()=>{
            this.sweep(0);
        };
        this.finalize = finalize;
    }
    // Token is actually required with this impl
    register(target, value, token) {
        this.registrations.set(token, {
            value: value,
            registeredAt: Date.now()
        });
        this.scheduleSweep();
    }
    unregister(token) {
        this.registrations.delete(token);
        if (this.registrations.size === 0) {
            clearTimeout(this.sweepTimeout);
            this.sweepTimeout = undefined;
        }
    }
    scheduleSweep() {
        if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $d49aa9d43f3479e9$var$REGISTRY_SWEEP_INTERVAL);
    }
}
// Native finalization can run early, but cannot collect a target retained by its
// reaction's dependencies (for example, a computed capturing a React state setter).
// Keep the timer as a backstop even when native finalization is available.
class $d49aa9d43f3479e9$var$FinalizationRegistryWithTimer {
    constructor(finalize){
        this.finalize = void 0;
        this.finalizeRegistration = (registration)=>{
            var _this$native;
            // Remove both registrations before disposal, which can invoke user callbacks.
            (_this$native = this.native) == null || _this$native.unregister(registration.token);
            this.timer.unregister(registration.token);
            this.finalize(registration.value);
        };
        this.tokens = new WeakMap();
        this.staged = new Map();
        this.flushScheduled = false;
        this.native = typeof FinalizationRegistry !== "undefined" ? new FinalizationRegistry(this.finalizeRegistration) : undefined;
        this.timer = new $d49aa9d43f3479e9$var$TimerBasedFinalizationRegistry(this.finalizeRegistration);
        this.finalizeAllImmediately = ()=>{
            this.flushRegistrations();
            this.timer.finalizeAllImmediately();
        };
        this.flushRegistrations = ()=>{
            this.flushScheduled = false;
            this.staged.forEach(({ target: target, value: value }, token)=>{
                var _this$native2;
                // Use a separate token so a target used as its unregister token is not retained by the timer.
                const registration = {
                    value: value,
                    token: {}
                };
                this.tokens.set(token, registration.token);
                (_this$native2 = this.native) == null || _this$native2.register(target, registration, registration.token);
                this.timer.register(target, registration, registration.token);
            });
            this.staged.clear();
        };
        this.finalize = finalize;
    }
    register(target, value, token = target) {
        this.unregister(token);
        // Stage registrations so synchronous subscriptions avoid native and timer work.
        this.staged.set(token, {
            target: target,
            value: value
        });
        if (!this.flushScheduled) {
            this.flushScheduled = true;
            Promise.resolve().then(this.flushRegistrations);
        }
    }
    unregister(token) {
        if (this.staged.delete(token)) return;
        const internalToken = this.tokens.get(token);
        if (internalToken) {
            var _this$native3;
            this.tokens.delete(token);
            (_this$native3 = this.native) == null || _this$native3.unregister(internalToken);
            this.timer.unregister(internalToken);
        }
    }
}
const $d49aa9d43f3479e9$var$UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? $d49aa9d43f3479e9$var$FinalizationRegistryWithTimer : $d49aa9d43f3479e9$var$TimerBasedFinalizationRegistry;
const $d49aa9d43f3479e9$export$e709e546a713a22e = /*#__PURE__*/ new $d49aa9d43f3479e9$var$UniversalFinalizationRegistry((adm)=>{
    const reaction = adm.reaction;
    adm.reaction = null;
    reaction == null || reaction.dispose();
});
let $d49aa9d43f3479e9$var$globalIsUsingStaticRendering = false;
function $d49aa9d43f3479e9$export$5d52eaa7c0f24c9e(enable) {
    $d49aa9d43f3479e9$var$globalIsUsingStaticRendering = enable;
}
function $d49aa9d43f3479e9$export$55979271896d643e() {
    return $d49aa9d43f3479e9$var$globalIsUsingStaticRendering;
}
function $d49aa9d43f3479e9$var$createReaction(adm) {
    adm.reaction = new (0, $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb)(`observer${adm.name}`, ()=>{
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        adm.onStoreChange == null || adm.onStoreChange();
    });
}
// This must stay a module-level factory and must NOT be inlined into `useObserver`:
// all closures created during the same function invocation share one context object.
// If `subscribe`/`getSnapshot` were created inside `useObserver`, that shared context
// would also hold the `reaction.track` callback's captures (`render`, `renderResult`),
// and since `useSyncExternalStore` holds `subscribe` for as long as the component is
// mounted, every observer would retain its first render's element tree, fibers and DOM.
// Module scope also makes it impossible for these closures to capture `admRef`,
// which would prevent its collection and break leaked-reaction disposal via the
// FinalizationRegistry (see the comment on `ObserverAdministration`).
function $d49aa9d43f3479e9$var$createObserverAdministration(baseComponentName) {
    const adm = {
        reaction: null,
        onStoreChange: null,
        stateVersion: Symbol(),
        name: baseComponentName,
        subscribe (onStoreChange) {
            $d49aa9d43f3479e9$export$e709e546a713a22e.unregister(adm);
            adm.onStoreChange = onStoreChange;
            if (!adm.reaction) {
                // We've lost our reaction and therefore all subscriptions, occurs when:
                // 1. Timer based finalization registry disposed reaction before component mounted.
                // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                // We have to recreate reaction and schedule re-render to recreate subscriptions,
                // even if state did not change.
                $d49aa9d43f3479e9$var$createReaction(adm);
                // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                // So we make sure that is not the case
                adm.stateVersion = Symbol();
            }
            return ()=>{
                var _adm$reaction;
                adm.onStoreChange = null;
                (_adm$reaction = adm.reaction) == null || _adm$reaction.dispose();
                adm.reaction = null;
            };
        },
        getSnapshot () {
            return adm.stateVersion;
        }
    };
    return adm;
}
function $d49aa9d43f3479e9$var$useObserver(render, baseComponentName = "observed") {
    if ($d49aa9d43f3479e9$export$55979271896d643e()) return render();
    const admRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = $d49aa9d43f3479e9$var$createObserverAdministration(baseComponentName);
    const adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $d49aa9d43f3479e9$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        $d49aa9d43f3479e9$export$e709e546a713a22e.register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useDebugValue(adm.reaction, (0, $7c1ccfb859bb0dff$export$23fbf90e5d80a5ee));
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useSyncExternalStore(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    let renderResult;
    let exception;
    adm.reaction.track(()=>{
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}
var $d49aa9d43f3479e9$var$_Object$getOwnPropert, $d49aa9d43f3479e9$var$_Object$getOwnPropert2;
const $d49aa9d43f3479e9$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
const $d49aa9d43f3479e9$var$isFunctionNameConfigurable = ($d49aa9d43f3479e9$var$_Object$getOwnPropert = ($d49aa9d43f3479e9$var$_Object$getOwnPropert2 = /*#__PURE__*/ Object.getOwnPropertyDescriptor(()=>{}, "name")) == null ? void 0 : $d49aa9d43f3479e9$var$_Object$getOwnPropert2.configurable) != null ? $d49aa9d43f3479e9$var$_Object$getOwnPropert : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
const $d49aa9d43f3479e9$var$ReactForwardRefSymbol = $d49aa9d43f3479e9$var$hasSymbol ? /*#__PURE__*/ Symbol.for("react.forward_ref") : typeof (0, $5E6i4.forwardRef) === "function" && (0, $5E6i4.forwardRef)((props)=>null)["$$typeof"];
const $d49aa9d43f3479e9$var$ReactMemoSymbol = $d49aa9d43f3479e9$var$hasSymbol ? /*#__PURE__*/ Symbol.for("react.memo") : typeof (0, $5E6i4.memo) === "function" && (0, $5E6i4.memo)((props)=>null)["$$typeof"];
// n.b. base case is not used for actual typings or exported in the typing files
function $d49aa9d43f3479e9$export$b6ae1bc530f4c149(baseComponent) {
    if ($d49aa9d43f3479e9$var$ReactMemoSymbol && baseComponent["$$typeof"] === $d49aa9d43f3479e9$var$ReactMemoSymbol) throw new Error(`[mobx-react-lite] You are trying to use \`observer\` on a function component wrapped in either another \`observer\` or \`React.memo\`. The observer already applies 'React.memo' for you.`);
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ($d49aa9d43f3479e9$export$55979271896d643e()) return baseComponent;
    let useForwardRef = false;
    let render = baseComponent;
    const baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($d49aa9d43f3479e9$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $d49aa9d43f3479e9$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error(`[mobx-react-lite] \`render\` property of ForwardRef was not a function`);
    }
    let observerComponent = (props, ref)=>{
        return $d49aa9d43f3479e9$var$useObserver(()=>render(props, ref), baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($d49aa9d43f3479e9$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $5E6i4.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $5E6i4.memo)(observerComponent);
    $d49aa9d43f3479e9$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
const $d49aa9d43f3479e9$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $d49aa9d43f3479e9$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach((key)=>{
        if (!$d49aa9d43f3479e9$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
function $d49aa9d43f3479e9$export$c1cbdee04e18ea8b({ children: children, render: render }) {
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    const component = children || render;
    if (typeof component !== "function") return null;
    return $d49aa9d43f3479e9$var$useObserver(component);
}
$d49aa9d43f3479e9$export$c1cbdee04e18ea8b.displayName = "Observer";
function $d49aa9d43f3479e9$export$aa207039f277c5f(initializer, annotations) {
    return (0, $5E6i4.useState)(()=>(0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)(initializer(), annotations, {
            autoBind: true
        }))[0];
}
const $d49aa9d43f3479e9$export$469d51fb8d268227 = $d49aa9d43f3479e9$export$e709e546a713a22e.finalizeAllImmediately;


const $ec7f1f2561223481$var$__MOBX_DEV__ = false;
function $ec7f1f2561223481$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($ec7f1f2561223481$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$ec7f1f2561223481$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $ec7f1f2561223481$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ const $ec7f1f2561223481$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
const $ec7f1f2561223481$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $ec7f1f2561223481$var$getMixins(target, methodName) {
    const mixins = target[$ec7f1f2561223481$var$mobxMixins] = target[$ec7f1f2561223481$var$mobxMixins] || {};
    const methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $ec7f1f2561223481$var$wrapper(realMethod, mixins, ...args) {
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        let retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach((mx)=>{
            mx.apply(this, args);
        });
    }
}
function $ec7f1f2561223481$var$wrapFunction(realMethod, mixins) {
    const fn = function fn(...args) {
        $ec7f1f2561223481$var$wrapper.call(this, realMethod, mixins, ...args);
    };
    return fn;
}
function $ec7f1f2561223481$var$patch(target, methodName, mixinMethod) {
    const mixins = $ec7f1f2561223481$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    const oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$ec7f1f2561223481$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    const originalMethod = target[methodName];
    const newDefinition = $ec7f1f2561223481$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $ec7f1f2561223481$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    let wrappedFunc = $ec7f1f2561223481$var$wrapFunction(originalMethod, mixins);
    return {
        // @ts-ignore
        [$ec7f1f2561223481$var$mobxPatchedDefinition]: true,
        get: function() {
            return wrappedFunc;
        },
        set: function(value) {
            if (this === target) wrappedFunc = $ec7f1f2561223481$var$wrapFunction(value, mixins);
            else {
                // when it is an instance of the prototype/a child prototype patch that particular case again separately
                // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
                // e.g. the method for super might not be the same as the method for the prototype which might be not the same
                // as the method for the instance
                const newDefinition = $ec7f1f2561223481$var$createDefinition(this, methodName, enumerable, mixins, value);
                Object.defineProperty(this, methodName, newDefinition);
            }
        },
        configurable: true,
        enumerable: enumerable
    };
}
const $ec7f1f2561223481$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
const $ec7f1f2561223481$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
let $ec7f1f2561223481$var$observablePropDescriptors;
if ($ec7f1f2561223481$var$__MOBX_DEV__) $ec7f1f2561223481$var$observablePropDescriptors = {
    props: /*#__PURE__*/ $ec7f1f2561223481$var$createObservablePropDescriptor("props"),
    state: /*#__PURE__*/ $ec7f1f2561223481$var$createObservablePropDescriptor("state"),
    context: /*#__PURE__*/ $ec7f1f2561223481$var$createObservablePropDescriptor("context")
};
function $ec7f1f2561223481$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$ec7f1f2561223481$var$administrationSymbol]) != null ? _component$administra : component[$ec7f1f2561223481$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $ec7f1f2561223481$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $ec7f1f2561223481$var$makeClassComponentObserver(componentClass) {
    const { prototype: prototype } = componentClass;
    if (componentClass[$ec7f1f2561223481$var$isMobXReactObserverSymbol]) {
        const displayName = $ec7f1f2561223481$var$getDisplayName(componentClass);
        throw new Error(`The provided component class (${displayName}) has already been declared as an observer component.`);
    } else componentClass[$ec7f1f2561223481$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $5E6i4.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $ec7f1f2561223481$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $ec7f1f2561223481$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    if ($ec7f1f2561223481$var$__MOBX_DEV__) Object.defineProperties(prototype, $ec7f1f2561223481$var$observablePropDescriptors);
    const originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        const displayName = $ec7f1f2561223481$var$getDisplayName(componentClass);
        throw new Error(`[mobx-react] class component (${displayName}) is missing \`render\` method.` + `\n\`observer\` requires \`render\` being a function defined on prototype.` + `\n\`render = () => {}\` or \`render = function() {}\` is not supported.`);
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $d49aa9d43f3479e9$export$55979271896d643e)() ? originalRender : $ec7f1f2561223481$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    const originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        if ($ec7f1f2561223481$var$__MOBX_DEV__ && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
            const displayName = $ec7f1f2561223481$var$getDisplayName(componentClass);
            throw new Error(`[mobx-react] \`observer(${displayName}).componentDidMount\` must be defined on prototype.` + `\n\`componentDidMount = () => {}\` or \`componentDidMount = function() {}\` is not supported.`);
        }
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        const admin = $ec7f1f2561223481$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $d49aa9d43f3479e9$export$e709e546a713a22e).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = ()=>this.forceUpdate();
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $ec7f1f2561223481$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $d49aa9d43f3479e9$export$55979271896d643e)()) return;
        const admin = $ec7f1f2561223481$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $ec7f1f2561223481$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $ec7f1f2561223481$var$createReactiveRender(originalRender) {
    const boundOriginalRender = originalRender.bind(this);
    const admin = $ec7f1f2561223481$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $ec7f1f2561223481$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $d49aa9d43f3479e9$export$e709e546a713a22e).register(this, admin, this);
        }
        let error = undefined;
        let renderResult = undefined;
        admin.reaction.track(()=>{
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $7c1ccfb859bb0dff$export$e510c5d1ea4358b1)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $ec7f1f2561223481$var$createReaction(admin) {
    return new (0, $7c1ccfb859bb0dff$export$d2ae4167a30cf6bb)(`${admin.name}.render()`, ()=>{
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $ec7f1f2561223481$var$observerSCU(nextProps, nextState) {
    if ((0, $d49aa9d43f3479e9$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$ec7f1f2561223481$var$shallowEqual(this.props, nextProps);
}
function $ec7f1f2561223481$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get () {
            const admin = $ec7f1f2561223481$var$getAdministration(this);
            const derivation = (0, $7c1ccfb859bb0dff$export$c78907783e606401)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error(`[mobx-react] Cannot read "${admin.name}.${key}" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
            return admin[key];
        },
        set (value) {
            $ec7f1f2561223481$var$getAdministration(this)[key] = value;
        }
    };
}
function $ec7f1f2561223481$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (Object.prototype.isPrototypeOf.call($5E6i4.Component, component) || Object.prototype.isPrototypeOf.call($5E6i4.PureComponent, component)) // Class component
    return $ec7f1f2561223481$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $d49aa9d43f3479e9$export$b6ae1bc530f4c149)(component);
}
if (!(0, $5E6i4.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)) throw new Error("mobx-react requires mobx to be available");



var $5E6i4 = parcelRequire("5E6i4");
var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

const $33be28a2f2a0a79b$var$_excluded = [
    "as",
    "disabled"
];
function $33be28a2f2a0a79b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $33be28a2f2a0a79b$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $33be28a2f2a0a79b$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $33be28a2f2a0a79b$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $33be28a2f2a0a79b$var$Button = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $33be28a2f2a0a79b$var$_objectWithoutPropertiesLoose(_ref, $33be28a2f2a0a79b$var$_excluded);
    const [buttonProps, { tagName: Component }] = $33be28a2f2a0a79b$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$33be28a2f2a0a79b$var$Button.displayName = 'Button';
var $33be28a2f2a0a79b$export$2e2bcd8739ae039 = $33be28a2f2a0a79b$var$Button;



var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $78821005c47d14e8$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $78821005c47d14e8$export$ff817e17bad2e091 = 'xs';
const $78821005c47d14e8$var$ThemeContext = /*#__PURE__*/ $5E6i4.createContext({
    prefixes: {},
    breakpoints: $78821005c47d14e8$export$666ad80b5007f835,
    minBreakpoint: $78821005c47d14e8$export$ff817e17bad2e091
});
const { Consumer: $78821005c47d14e8$export$b631efc24e9d5e2f, Provider: $78821005c47d14e8$var$Provider } = $78821005c47d14e8$var$ThemeContext;
function $78821005c47d14e8$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $78821005c47d14e8$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $78821005c47d14e8$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $5E6i4.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($78821005c47d14e8$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $78821005c47d14e8$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $5E6i4.useContext)($78821005c47d14e8$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $78821005c47d14e8$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $5E6i4.useContext)($78821005c47d14e8$var$ThemeContext);
    return breakpoints;
}
function $78821005c47d14e8$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $5E6i4.useContext)($78821005c47d14e8$var$ThemeContext);
    return minBreakpoint;
}
function $78821005c47d14e8$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $5E6i4.useContext)($78821005c47d14e8$var$ThemeContext);
    return dir === 'rtl';
}
function $78821005c47d14e8$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $5E6i4.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $78821005c47d14e8$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $78821005c47d14e8$export$2e2bcd8739ae039 = $78821005c47d14e8$var$ThemeProvider;



"use client";
const $2c5bfbee0161ddfe$var$Button = /*#__PURE__*/ $5E6i4.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $33be28a2f2a0a79b$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$2c5bfbee0161ddfe$var$Button.displayName = 'Button';
var $2c5bfbee0161ddfe$export$2e2bcd8739ae039 = $2c5bfbee0161ddfe$var$Button;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
function $22c47d6847a3139f$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $78821005c47d14e8$export$8970c8db816a5863)();
    const minBreakpoint = (0, $78821005c47d14e8$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $22c47d6847a3139f$var$Col = /*#__PURE__*/ $5E6i4.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $22c47d6847a3139f$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$22c47d6847a3139f$var$Col.displayName = 'Col';
var $22c47d6847a3139f$export$2e2bcd8739ae039 = $22c47d6847a3139f$var$Col;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;



var $5E6i4 = parcelRequire("5E6i4");
function $d0d6c9b969929211$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $bd3cfbd7cb3737e3$export$2e2bcd8739ae039(t, e) {
    return $bd3cfbd7cb3737e3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $bd3cfbd7cb3737e3$export$2e2bcd8739ae039(t, e);
}


function $89ad6a6097d619bd$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $bd3cfbd7cb3737e3$export$2e2bcd8739ae039)(t, o);
}




var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
var $771bb4243b080e34$export$2e2bcd8739ae039 = {
    disabled: false
};




var $5E6i4 = parcelRequire("5E6i4");
var $1c3a35c4b17091a9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(null);


var $06d87154b9017c35$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $c0cf3feaee946af3$export$bb38bb9a1161268 = 'unmounted';
var $c0cf3feaee946af3$export$84cbff306f539230 = 'exited';
var $c0cf3feaee946af3$export$df38205c966be359 = 'entering';
var $c0cf3feaee946af3$export$78e9e6e3e014d60a = 'entered';
var $c0cf3feaee946af3$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $c0cf3feaee946af3$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $89ad6a6097d619bd$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c0cf3feaee946af3$export$84cbff306f539230;
                _this.appearStatus = $c0cf3feaee946af3$export$df38205c966be359;
            } else initialStatus = $c0cf3feaee946af3$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c0cf3feaee946af3$export$bb38bb9a1161268;
        else initialStatus = $c0cf3feaee946af3$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c0cf3feaee946af3$export$bb38bb9a1161268) return {
            status: $c0cf3feaee946af3$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c0cf3feaee946af3$export$df38205c966be359 && status !== $c0cf3feaee946af3$export$78e9e6e3e014d60a) nextStatus = $c0cf3feaee946af3$export$df38205c966be359;
            } else if (status === $c0cf3feaee946af3$export$df38205c966be359 || status === $c0cf3feaee946af3$export$78e9e6e3e014d60a) nextStatus = $c0cf3feaee946af3$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $c0cf3feaee946af3$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $06d87154b9017c35$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $c0cf3feaee946af3$export$84cbff306f539230) this.setState({
            status: $c0cf3feaee946af3$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $771bb4243b080e34$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c0cf3feaee946af3$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $c0cf3feaee946af3$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $c0cf3feaee946af3$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $771bb4243b080e34$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c0cf3feaee946af3$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $c0cf3feaee946af3$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c0cf3feaee946af3$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c0cf3feaee946af3$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $d0d6c9b969929211$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $1c3a35c4b17091a9$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Component);
$c0cf3feaee946af3$var$Transition.contextType = (0, $1c3a35c4b17091a9$export$2e2bcd8739ae039);
$c0cf3feaee946af3$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $c0cf3feaee946af3$var$noop() {}
$c0cf3feaee946af3$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c0cf3feaee946af3$var$noop,
    onEntering: $c0cf3feaee946af3$var$noop,
    onEntered: $c0cf3feaee946af3$var$noop,
    onExit: $c0cf3feaee946af3$var$noop,
    onExiting: $c0cf3feaee946af3$var$noop,
    onExited: $c0cf3feaee946af3$var$noop
};
$c0cf3feaee946af3$var$Transition.UNMOUNTED = $c0cf3feaee946af3$export$bb38bb9a1161268;
$c0cf3feaee946af3$var$Transition.EXITED = $c0cf3feaee946af3$export$84cbff306f539230;
$c0cf3feaee946af3$var$Transition.ENTERING = $c0cf3feaee946af3$export$df38205c966be359;
$c0cf3feaee946af3$var$Transition.ENTERED = $c0cf3feaee946af3$export$78e9e6e3e014d60a;
$c0cf3feaee946af3$var$Transition.EXITING = $c0cf3feaee946af3$export$4aacc83d4d59139f;
var $c0cf3feaee946af3$export$2e2bcd8739ae039 = $c0cf3feaee946af3$var$Transition;



var $5E6i4 = parcelRequire("5E6i4");
function $ac36aa99f6f4d073$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $ac36aa99f6f4d073$export$13e065f3a74cfe36() {
    const parts = $5E6i4.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $ac36aa99f6f4d073$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $ac36aa99f6f4d073$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $4b60c77e32e76eef$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $4b60c77e32e76eef$export$2e2bcd8739ae039(element, handler) {
    const duration = $4b60c77e32e76eef$var$parseDuration(element, 'transitionDuration');
    const delay = $4b60c77e32e76eef$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $3744e0a637c57624$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $3744e0a637c57624$export$2e2bcd8739ae039 = $3744e0a637c57624$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $0136b2943aee1f51$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $1a92d947f5cf0eee$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $1a92d947f5cf0eee$export$c9058316764c140e(refA, refB) {
    const a = $1a92d947f5cf0eee$var$toFnRef(refA);
    const b = $1a92d947f5cf0eee$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $1a92d947f5cf0eee$var$useMergedRefs(refA, refB) {
    return (0, $5E6i4.useMemo)(()=>$1a92d947f5cf0eee$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $1a92d947f5cf0eee$export$2e2bcd8739ae039 = $1a92d947f5cf0eee$var$useMergedRefs;



var $ibUU1 = parcelRequire("ibUU1");
function $62beabb915112802$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $1d8bd1b0bbed024b$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $5E6i4.useRef)(null);
    const mergedRef = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $62beabb915112802$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $5E6i4.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $5E6i4.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $5E6i4.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $5E6i4.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $5E6i4.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $5E6i4.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $5E6i4.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c0cf3feaee946af3$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$1d8bd1b0bbed024b$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $1d8bd1b0bbed024b$export$2e2bcd8739ae039 = $1d8bd1b0bbed024b$var$TransitionWrapper;



const $ed96abbe88710bc8$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $ed96abbe88710bc8$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $ed96abbe88710bc8$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $ed96abbe88710bc8$var$collapseStyles = {
    [(0, $c0cf3feaee946af3$export$84cbff306f539230)]: 'collapse',
    [(0, $c0cf3feaee946af3$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $c0cf3feaee946af3$export$df38205c966be359)]: 'collapsing',
    [(0, $c0cf3feaee946af3$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $ed96abbe88710bc8$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $ed96abbe88710bc8$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $5E6i4.useMemo)(()=>(0, $3744e0a637c57624$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $5E6i4.useMemo)(()=>(0, $3744e0a637c57624$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $5E6i4.useMemo)(()=>(0, $3744e0a637c57624$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $5E6i4.useMemo)(()=>(0, $3744e0a637c57624$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $0136b2943aee1f51$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $5E6i4.useMemo)(()=>(0, $3744e0a637c57624$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1d8bd1b0bbed024b$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $4b60c77e32e76eef$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, $ed96abbe88710bc8$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$ed96abbe88710bc8$var$Collapse.displayName = 'Collapse';
var $ed96abbe88710bc8$export$2e2bcd8739ae039 = $ed96abbe88710bc8$var$Collapse;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $4b6b7ad0160000bf$var$Container = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$4b6b7ad0160000bf$var$Container.displayName = 'Container';
var $4b6b7ad0160000bf$export$2e2bcd8739ae039 = $4b6b7ad0160000bf$var$Container;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $b822ff2b087e0e91$var$Row = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $78821005c47d14e8$export$8970c8db816a5863)();
    const minBreakpoint = (0, $78821005c47d14e8$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$b822ff2b087e0e91$var$Row.displayName = 'Row';
var $b822ff2b087e0e91$export$2e2bcd8739ae039 = $b822ff2b087e0e91$var$Row;


var $3b51c8a0c5045117$exports = {};
'use strict';
function $3b51c8a0c5045117$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3b51c8a0c5045117$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3b51c8a0c5045117$var$checkDCE();

$3b51c8a0c5045117$exports = (parcelRequire("03XiP"));


function $1d8e073d1256147c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $f0029d1e20ae5566$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $1d8e073d1256147c$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $3c08d542df5be0af$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $36dd8b42e2966ea6$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $3c08d542df5be0af$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}





function $cc97c864ff2b6306$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc97c864ff2b6306$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $cc97c864ff2b6306$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $5E6i4 = parcelRequire("5E6i4");
const $f98228064dbed514$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"JavaScript\",\"name\":\"javascript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.array.literal.js\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.js\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.js\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.js\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.js\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.documentation.js\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"},\"2\":{\"name\":\"storage.type.internaldeclaration.js\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.js\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.js\"},\"2\":{\"name\":\"entity.name.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.js\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.js\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.js\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"name\":\"meta.parameter.object-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"name\":\"meta.paramter.array-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.js\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.js\"},\"2\":{\"name\":\"entity.name.tag.directive.js\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.js\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.js\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.enum.js\"},\"5\":{\"name\":\"entity.name.type.enum.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.js\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.as.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"},\"4\":{\"name\":\"entity.name.type.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"},\"3\":{\"name\":\"keyword.operator.assignment.js\"},\"4\":{\"name\":\"keyword.control.default.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.js\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.js\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.js\"},\"2\":{\"name\":\"keyword.generator.asterisk.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.js\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.js\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.js\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.js\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.js\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.js\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.js\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"3\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.js\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.js\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.js\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.js\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.js\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.js variable.object.property.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.js\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.js\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.js punctuation.accessor.optional.js\"},{\"match\":\"!\",\"name\":\"meta.function-call.js keyword.operator.definiteassignment.js\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.js\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.async.js\"},\"4\":{\"name\":\"storage.type.function.js\"},\"5\":{\"name\":\"keyword.generator.asterisk.js\"},\"6\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.function.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"},\"4\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.js entity.name.function.js\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.js\"}},\"name\":\"meta.parameters.js\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"entity.name.function.js\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.js\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.js\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.js\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"},\"7\":{\"name\":\"keyword.control.require.js\"},\"8\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.import-equals.external.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.js\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.js\"},\"2\":{\"name\":\"keyword.control.assert.js\"},\"3\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.js\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.js\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"keyword.control.default.js\"},\"3\":{\"name\":\"constant.language.import-export-all.js\"},\"4\":{\"name\":\"variable.other.readwrite.js\"},\"5\":{\"name\":\"string.quoted.alias.js\"},\"12\":{\"name\":\"keyword.control.as.js\"},\"13\":{\"name\":\"keyword.control.default.js\"},\"14\":{\"name\":\"variable.other.readwrite.alias.js\"},\"15\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.js\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"variable.other.readwrite.alias.js\"},\"3\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.js\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"meta.brace.square.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.declaration.js\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"meta.brace.square.js\"},\"4\":{\"name\":\"entity.name.type.js\"},\"5\":{\"name\":\"keyword.operator.expression.in.js\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.type.modifier.js\"},\"3\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.mappedtype.declaration.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.interface.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.js\"},\"3\":{\"name\":\"punctuation.definition.entity.js\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.js\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.js\"}},\"contentName\":\"meta.embedded.expression.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"3\":{\"name\":\"entity.name.tag.namespace.js\"},\"4\":{\"name\":\"punctuation.separator.namespace.js\"},\"5\":{\"name\":\"entity.name.tag.js\"},\"6\":{\"name\":\"support.class.component.js\"},\"7\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.js\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.js\"},\"2\":{\"name\":\"punctuation.separator.namespace.js\"},\"3\":{\"name\":\"entity.other.attribute-name.js\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.js\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.without-attributes.js\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"keyword.operator.new.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.property.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.js entity.name.function.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.js\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.js\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.js\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.js\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"2\":{\"name\":\"storage.type.numeric.bigint.js\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"4\":{\"name\":\"storage.type.numeric.bigint.js\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"6\":{\"name\":\"storage.type.numeric.bigint.js\"},\"7\":{\"name\":\"storage.type.numeric.bigint.js\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"9\":{\"name\":\"storage.type.numeric.bigint.js\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"11\":{\"name\":\"storage.type.numeric.bigint.js\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"13\":{\"name\":\"storage.type.numeric.bigint.js\"},\"14\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.js\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.js\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.js\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.js\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.object.property.js\"},\"4\":{\"name\":\"variable.other.object.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.js\"},\"2\":{\"name\":\"variable.other.object.js\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"constant.numeric.decimal.js\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"entity.name.function.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.js punctuation.separator.key-value.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.js meta.return.type.arrow.js keyword.operator.type.annotation.js\"}},\"contentName\":\"meta.arrow.js meta.return.type.arrow.js\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.js\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.js\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.js\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.js\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.js\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.js\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.js\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.importmeta.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.target.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"support.variable.property.js\"},\"4\":{\"name\":\"support.constant.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.js\"},\"2\":{\"name\":\"support.type.object.module.js\"},\"3\":{\"name\":\"punctuation.accessor.js\"},\"4\":{\"name\":\"punctuation.accessor.optional.js\"},\"5\":{\"name\":\"support.type.object.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"switch-statement.expr.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"switch-expression.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"},\"2\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"contentName\":\"meta.block.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.js\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.js\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.type.js\"},\"4\":{\"name\":\"entity.name.type.alias.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"},\"2\":{\"name\":\"keyword.control.intrinsic.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.js\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.js storage.modifier.js\"},\"2\":{\"name\":\"meta.type.constructor.js keyword.control.new.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.control.new.js\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.js\"},\"2\":{\"name\":\"entity.name.type.js\"},\"3\":{\"name\":\"keyword.operator.expression.extends.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.js\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.js\"},\"2\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.js\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.object.type.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.js\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.js\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.js\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.type.paren.cover.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"},\"4\":{\"name\":\"keyword.operator.expression.is.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.js\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.js\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.type.tuple.js\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.js\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.js\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.js\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js entity.name.function.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.js\",\"aliases\":[\"js\",\"cjs\",\"mjs\"]}"));
var $f98228064dbed514$export$2e2bcd8739ae039 = [
    $f98228064dbed514$var$lang
];


const $7ed64a6063dfcb66$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"JSX\",\"name\":\"jsx\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.objectliteral.js.jsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"name\":\"meta.array.literal.js.jsx\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.js.jsx\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.js.jsx\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.js.jsx\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.js.jsx\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.class.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js.jsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.type.class.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js.jsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"name\":\"comment.block.documentation.js.jsx\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"2\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"name\":\"comment.block.js.jsx\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js.jsx\"},\"2\":{\"name\":\"comment.line.double-slash.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"contentName\":\"comment.line.double-slash.js.jsx\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.js.jsx\"},\"2\":{\"name\":\"entity.name.label.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.js.jsx\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.js.jsx\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.js.jsx\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.block.js.jsx\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.js.jsx\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"name\":\"meta.parameter.object-binding-pattern.js.jsx\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"name\":\"meta.paramter.array-binding-pattern.js.jsx\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"meta.definition.variable.js.jsx variable.other.readwrite.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.js.jsx\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.directive.js.jsx\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.js.jsx\"}},\"name\":\"meta.tag.js.jsx\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.js.jsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js.jsx\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.js.jsx\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.js.jsx\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.enum.js.jsx\"},\"5\":{\"name\":\"entity.name.type.enum.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.js.jsx\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.as.js.jsx\"},\"3\":{\"name\":\"storage.type.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.type.module.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.type.js.jsx\"},\"3\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"4\":{\"name\":\"keyword.control.default.js.jsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.js.jsx\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.type.js.jsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.js.jsx\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.js.jsx\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.js.jsx\"},\"2\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.js.jsx\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"keyword.control.satisfies.js.jsx\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.js.jsx\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.js.jsx\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.js.jsx\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.js.jsx\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.js.jsx\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.js.jsx\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"3\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.js.jsx\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.js.jsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js.jsx\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.js.jsx\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.js.jsx\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.js.jsx\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.js.jsx\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.js.jsx entity.name.function.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.js.jsx variable.object.property.js.jsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js.jsx\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.js.jsx\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.js.jsx\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.js.jsx\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.js.jsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.js.jsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.js.jsx punctuation.accessor.optional.js.jsx\"},{\"match\":\"!\",\"name\":\"meta.function-call.js.jsx keyword.operator.definiteassignment.js.jsx\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.js.jsx\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.async.js.jsx\"},\"4\":{\"name\":\"storage.type.function.js.jsx\"},\"5\":{\"name\":\"keyword.generator.asterisk.js.jsx\"},\"6\":{\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.js.jsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.function.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"},\"4\":{\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.js.jsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.js.jsx\"}},\"name\":\"meta.parameters.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.constant.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.js.jsx\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.js.jsx\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.js.jsx\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"6\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"7\":{\"name\":\"keyword.control.require.js.jsx\"},\"8\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"meta.import-equals.external.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"6\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.js.jsx\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.js.jsx\"},\"2\":{\"name\":\"keyword.control.assert.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.js.jsx\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.js.jsx\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.block.js.jsx\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js.jsx\"},\"2\":{\"name\":\"keyword.control.default.js.jsx\"},\"3\":{\"name\":\"constant.language.import-export-all.js.jsx\"},\"4\":{\"name\":\"variable.other.readwrite.js.jsx\"},\"5\":{\"name\":\"string.quoted.alias.js.jsx\"},\"12\":{\"name\":\"keyword.control.as.js.jsx\"},\"13\":{\"name\":\"keyword.control.default.js.jsx\"},\"14\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"15\":{\"name\":\"string.quoted.alias.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.js.jsx\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js.jsx\"},\"2\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"3\":{\"name\":\"string.quoted.alias.js.jsx\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.js.jsx\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"meta.brace.square.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"name\":\"meta.indexer.declaration.js.jsx\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"meta.brace.square.js.jsx\"},\"4\":{\"name\":\"entity.name.type.js.jsx\"},\"5\":{\"name\":\"keyword.operator.expression.in.js.jsx\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"},\"2\":{\"name\":\"keyword.operator.type.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"name\":\"meta.indexer.mappedtype.declaration.js.jsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.js.jsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.interface.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.entity.js.jsx\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.js.jsx\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.js.jsx\"}},\"contentName\":\"meta.embedded.expression.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js.jsx\"}},\"name\":\"string.quoted.double.js.jsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js.jsx\"}},\"name\":\"string.quoted.single.js.jsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"3\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"4\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"5\":{\"name\":\"entity.name.tag.js.jsx\"},\"6\":{\"name\":\"support.class.component.js.jsx\"},\"7\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"name\":\"meta.tag.js.jsx\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"contentName\":\"meta.jsx.children.js.jsx\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.js.jsx\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"3\":{\"name\":\"entity.other.attribute-name.js.jsx\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.js.jsx\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"contentName\":\"meta.jsx.children.js.jsx\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"name\":\"meta.tag.without-attributes.js.jsx\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"keyword.operator.new.js.jsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"storage.type.property.js.jsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.js.jsx entity.name.function.js.jsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js.jsx\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.namespace.js.jsx\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.js.jsx\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.js.jsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.js.jsx\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.js.jsx\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"2\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"4\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"6\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"7\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"9\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"11\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"13\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"14\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.js.jsx\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.js.jsx\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.js.jsx\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.constant.object.property.js.jsx\"},\"4\":{\"name\":\"variable.other.object.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.js.jsx\"},\"2\":{\"name\":\"variable.other.object.js.jsx\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.objectliteral.js.jsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.property.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.property.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"},\"1\":{\"name\":\"constant.numeric.decimal.js.jsx\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"},\"1\":{\"name\":\"entity.name.function.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js.jsx\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js.jsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"keyword.control.satisfies.js.jsx\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx punctuation.separator.key-value.js.jsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.js.jsx meta.return.type.arrow.js.jsx keyword.operator.type.annotation.js.jsx\"}},\"contentName\":\"meta.arrow.js.jsx meta.return.type.arrow.js.jsx\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.js.jsx\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.js.jsx\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.js.jsx\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"invalid.illegal.newline.js.jsx\"}},\"name\":\"string.quoted.double.js.jsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"invalid.illegal.newline.js.jsx\"}},\"name\":\"string.quoted.single.js.jsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.js.jsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.js.jsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.js.jsx\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js.jsx\"},\"2\":{\"name\":\"comment.line.double-slash.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"contentName\":\"comment.line.double-slash.js.jsx\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.js.jsx\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.js.jsx\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.js.jsx\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"support.variable.property.importmeta.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"support.variable.property.target.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"support.variable.property.js.jsx\"},\"4\":{\"name\":\"support.constant.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.js.jsx\"},\"2\":{\"name\":\"support.type.object.module.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.js.jsx\"},\"4\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"5\":{\"name\":\"support.type.object.module.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"switch-statement.expr.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"switch-expression.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js.jsx\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.js.jsx punctuation.definition.section.case-statement.js.jsx\"},\"2\":{\"name\":\"meta.block.js.jsx punctuation.definition.block.js.jsx\"}},\"contentName\":\"meta.block.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.js.jsx punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.js.jsx punctuation.definition.section.case-statement.js.jsx\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"},\"2\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.begin.js.jsx\"}},\"contentName\":\"string.template.js.jsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.end.js.jsx\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.js.jsx\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js.jsx\"}},\"contentName\":\"meta.embedded.line.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js.jsx\"}},\"name\":\"meta.template.expression.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"},\"2\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.begin.js.jsx\"}},\"contentName\":\"string.template.js.jsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.end.js.jsx\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js.jsx\"}},\"contentName\":\"meta.embedded.line.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js.jsx\"}},\"name\":\"meta.template.expression.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.js.jsx\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.type.js.jsx\"},\"4\":{\"name\":\"entity.name.type.alias.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"2\":{\"name\":\"keyword.control.intrinsic.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.js.jsx\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.js.jsx\"}},\"name\":\"meta.type.parameters.js.jsx\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.js.jsx\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.js.jsx storage.modifier.js.jsx\"},\"2\":{\"name\":\"meta.type.constructor.js.jsx keyword.control.new.js.jsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.control.new.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.js.jsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.js.jsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.js.jsx\"},\"2\":{\"name\":\"entity.name.type.js.jsx\"},\"3\":{\"name\":\"keyword.operator.expression.extends.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.js.jsx\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.begin.js.jsx\"}},\"contentName\":\"meta.type.parameters.js.jsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.end.js.jsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.js.jsx\"},\"2\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.begin.js.jsx\"}},\"contentName\":\"meta.type.parameters.js.jsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.end.js.jsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.js.jsx\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.object.type.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.js.jsx\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.js.jsx\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.js.jsx\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.js.jsx\"}},\"name\":\"meta.type.parameters.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.js.jsx\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"meta.type.paren.cover.js.jsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"},\"4\":{\"name\":\"keyword.operator.expression.is.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.js.jsx\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.js.jsx\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"name\":\"meta.type.tuple.js.jsx\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.js.jsx\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.js.jsx\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx entity.name.function.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.readwrite.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.js.jsx\"}"));
var $7ed64a6063dfcb66$export$2e2bcd8739ae039 = [
    $7ed64a6063dfcb66$var$lang
];


const $f83a782ddbd2339a$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"TSX\",\"name\":\"tsx\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.objectliteral.tsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"name\":\"meta.array.literal.tsx\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.tsx\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.tsx\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.tsx\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.tsx\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.class.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.tsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.type.class.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.tsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"name\":\"comment.block.documentation.tsx\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"},\"2\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"name\":\"comment.block.tsx\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.tsx\"},\"2\":{\"name\":\"comment.line.double-slash.tsx\"},\"3\":{\"name\":\"punctuation.definition.comment.tsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"contentName\":\"comment.line.double-slash.tsx\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.tsx\"},\"2\":{\"name\":\"entity.name.label.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.tsx\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.tsx\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.tsx\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.block.tsx\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.tsx\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"name\":\"meta.parameter.object-binding-pattern.tsx\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"name\":\"meta.paramter.array-binding-pattern.tsx\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"meta.definition.variable.tsx variable.other.readwrite.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.tsx\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.tsx\"},\"2\":{\"name\":\"entity.name.tag.directive.tsx\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.tsx\"}},\"name\":\"meta.tag.tsx\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.tsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.tsx\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.tsx\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.tsx\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.enum.tsx\"},\"5\":{\"name\":\"entity.name.type.enum.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.tsx\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.as.tsx\"},\"3\":{\"name\":\"storage.type.namespace.tsx\"},\"4\":{\"name\":\"entity.name.type.module.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.type.tsx\"},\"3\":{\"name\":\"keyword.operator.assignment.tsx\"},\"4\":{\"name\":\"keyword.control.default.tsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.tsx\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.type.tsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.tsx\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.tsx\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.tsx\"},\"2\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.tsx\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"keyword.control.satisfies.tsx\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.tsx\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.tsx\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.tsx\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.tsx\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.tsx\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.tsx\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"3\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.tsx\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.tsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.tsx\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.tsx\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.tsx\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.tsx\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.tsx\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.tsx entity.name.function.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.tsx variable.object.property.tsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.tsx\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.tsx\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.tsx\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.tsx\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.tsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.tsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.tsx punctuation.accessor.optional.tsx\"},{\"match\":\"!\",\"name\":\"meta.function-call.tsx keyword.operator.definiteassignment.tsx\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tsx\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.async.tsx\"},\"4\":{\"name\":\"storage.type.function.tsx\"},\"5\":{\"name\":\"keyword.generator.asterisk.tsx\"},\"6\":{\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.tsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.function.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"},\"4\":{\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.tsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.tsx\"}},\"name\":\"meta.parameters.tsx\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.constant.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.tsx\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.tsx\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.tsx\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"6\":{\"name\":\"keyword.operator.assignment.tsx\"},\"7\":{\"name\":\"keyword.control.require.tsx\"},\"8\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"meta.import-equals.external.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"6\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.tsx\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.tsx\"},\"2\":{\"name\":\"keyword.control.assert.tsx\"},\"3\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.tsx\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.tsx\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.block.tsx\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.tsx\"},\"2\":{\"name\":\"keyword.control.default.tsx\"},\"3\":{\"name\":\"constant.language.import-export-all.tsx\"},\"4\":{\"name\":\"variable.other.readwrite.tsx\"},\"5\":{\"name\":\"string.quoted.alias.tsx\"},\"12\":{\"name\":\"keyword.control.as.tsx\"},\"13\":{\"name\":\"keyword.control.default.tsx\"},\"14\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"15\":{\"name\":\"string.quoted.alias.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.tsx\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.tsx\"},\"2\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"3\":{\"name\":\"string.quoted.alias.tsx\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.tsx\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"meta.brace.square.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"}},\"name\":\"meta.indexer.declaration.tsx\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"meta.brace.square.tsx\"},\"4\":{\"name\":\"entity.name.type.tsx\"},\"5\":{\"name\":\"keyword.operator.expression.in.tsx\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"},\"2\":{\"name\":\"keyword.operator.type.modifier.tsx\"},\"3\":{\"name\":\"keyword.operator.optional.tsx\"}},\"name\":\"meta.indexer.mappedtype.declaration.tsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.tsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.interface.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.tsx\"},\"3\":{\"name\":\"punctuation.definition.entity.tsx\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.tsx\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.tsx\"}},\"contentName\":\"meta.embedded.expression.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.tsx\"}},\"name\":\"string.quoted.double.tsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.tsx\"}},\"name\":\"string.quoted.single.tsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.tsx\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"3\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"4\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"5\":{\"name\":\"entity.name.tag.tsx\"},\"6\":{\"name\":\"support.class.component.tsx\"},\"7\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"name\":\"meta.tag.tsx\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"contentName\":\"meta.jsx.children.tsx\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.tsx\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.tsx\"},\"2\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"3\":{\"name\":\"entity.other.attribute-name.tsx\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.tsx\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"contentName\":\"meta.jsx.children.tsx\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"name\":\"meta.tag.without-attributes.tsx\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"punctuation.separator.label.tsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"punctuation.separator.label.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"keyword.operator.new.tsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"storage.type.property.tsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.tsx entity.name.function.tsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.tsx\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.namespace.tsx\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.tsx\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.tsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.tsx\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.tsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.tsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.tsx\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.tsx\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"2\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"4\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"6\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"7\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"9\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"11\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"13\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"14\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.tsx\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.tsx\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.tsx\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.tsx\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.constant.object.property.tsx\"},\"4\":{\"name\":\"variable.other.object.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.tsx\"},\"2\":{\"name\":\"variable.other.object.tsx\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.objectliteral.tsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.property.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.property.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"},\"1\":{\"name\":\"constant.numeric.decimal.tsx\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"},\"1\":{\"name\":\"entity.name.function.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.tsx\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.tsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"keyword.control.satisfies.tsx\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx punctuation.separator.key-value.tsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.tsx meta.return.type.arrow.tsx keyword.operator.type.annotation.tsx\"}},\"contentName\":\"meta.arrow.tsx meta.return.type.arrow.tsx\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.tsx\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.tsx\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.tsx\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"invalid.illegal.newline.tsx\"}},\"name\":\"string.quoted.double.tsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"invalid.illegal.newline.tsx\"}},\"name\":\"string.quoted.single.tsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.tsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.tsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.tsx\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.tsx\"},\"2\":{\"name\":\"comment.line.double-slash.tsx\"},\"3\":{\"name\":\"punctuation.definition.comment.tsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"contentName\":\"comment.line.double-slash.tsx\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.tsx\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.tsx\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.tsx\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"support.variable.property.importmeta.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"support.variable.property.target.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"support.variable.property.tsx\"},\"4\":{\"name\":\"support.constant.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.tsx\"},\"2\":{\"name\":\"support.type.object.module.tsx\"},\"3\":{\"name\":\"punctuation.accessor.tsx\"},\"4\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"5\":{\"name\":\"support.type.object.module.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"switch-statement.expr.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"switch-expression.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.tsx\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.tsx punctuation.definition.section.case-statement.tsx\"},\"2\":{\"name\":\"meta.block.tsx punctuation.definition.block.tsx\"}},\"contentName\":\"meta.block.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.tsx punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.tsx punctuation.definition.section.case-statement.tsx\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"},\"2\":{\"name\":\"string.template.tsx punctuation.definition.string.template.begin.tsx\"}},\"contentName\":\"string.template.tsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.tsx punctuation.definition.string.template.end.tsx\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.tsx\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.tsx\"}},\"contentName\":\"meta.embedded.line.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.tsx\"}},\"name\":\"meta.template.expression.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"},\"2\":{\"name\":\"string.template.tsx punctuation.definition.string.template.begin.tsx\"}},\"contentName\":\"string.template.tsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.tsx punctuation.definition.string.template.end.tsx\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.tsx\"}},\"contentName\":\"meta.embedded.line.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.tsx\"}},\"name\":\"meta.template.expression.tsx\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.tsx\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.type.tsx\"},\"4\":{\"name\":\"entity.name.type.alias.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"},\"2\":{\"name\":\"keyword.control.intrinsic.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.tsx\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.tsx\"}},\"name\":\"meta.type.parameters.tsx\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.tsx\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.tsx storage.modifier.tsx\"},\"2\":{\"name\":\"meta.type.constructor.tsx keyword.control.new.tsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.control.new.tsx\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.tsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.tsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.tsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.tsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.tsx\"},\"2\":{\"name\":\"entity.name.type.tsx\"},\"3\":{\"name\":\"keyword.operator.expression.extends.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.tsx\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.begin.tsx\"}},\"contentName\":\"meta.type.parameters.tsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.end.tsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.tsx\"},\"2\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.begin.tsx\"}},\"contentName\":\"meta.type.parameters.tsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.end.tsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.tsx\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.object.type.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.tsx\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.tsx\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.tsx\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.tsx\"}},\"name\":\"meta.type.parameters.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.tsx\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"meta.type.paren.cover.tsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"},\"4\":{\"name\":\"keyword.operator.expression.is.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.tsx\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.tsx\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"name\":\"meta.type.tuple.tsx\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.tsx\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"},\"3\":{\"name\":\"punctuation.separator.label.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.tsx\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.tsx\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx entity.name.function.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx entity.name.function.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.readwrite.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.tsx\"}"));
var $f83a782ddbd2339a$export$2e2bcd8739ae039 = [
    $f83a782ddbd2339a$var$lang
];


const $f73e95e28dd02331$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"TypeScript\",\"name\":\"typescript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.array.literal.ts\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.ts\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.ts\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.ts\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.ts\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.angle.ts\"}},\"match\":\"\\\\s*(<)\\\\s*(const)\\\\s*(>)\",\"name\":\"cast.expr.ts\"},{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=^return|[^$._[:alnum:]]return|^throw|[^$._[:alnum:]]throw|^yield|[^$._[:alnum:]]yield|^await|[^$._[:alnum:]]await|^default|[^$._[:alnum:]]default|[\\\\&(*,:=>?^|]|[^$_[:alnum:]](?:\\\\+\\\\+|--)|[^+]\\\\+|[^-]-)\\\\s*(<)(?!<?=)(?!\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?<=^)\\\\s*(<)(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.documentation.ts\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"},\"2\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.ts\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.ts\"},\"2\":{\"name\":\"entity.name.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.ts\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.ts\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.ts\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"name\":\"meta.parameter.object-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"name\":\"meta.paramter.array-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.ts\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.ts\"},\"2\":{\"name\":\"entity.name.tag.directive.ts\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.ts\"}},\"name\":\"meta.tag.ts\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.ts\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.ts\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.enum.ts\"},\"5\":{\"name\":\"entity.name.type.enum.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.ts\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.as.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"},\"4\":{\"name\":\"entity.name.type.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"},\"3\":{\"name\":\"keyword.operator.assignment.ts\"},\"4\":{\"name\":\"keyword.control.default.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.ts\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.ts\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"},\"2\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.ts\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.ts\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.ts\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.ts\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.ts\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.ts\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.ts\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"3\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.ts\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.ts\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.ts\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.ts\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.ts\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.ts variable.object.property.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.ts\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.ts\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.ts punctuation.accessor.optional.ts\"},{\"match\":\"!\",\"name\":\"meta.function-call.ts keyword.operator.definiteassignment.ts\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.ts\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.async.ts\"},\"4\":{\"name\":\"storage.type.function.ts\"},\"5\":{\"name\":\"keyword.generator.asterisk.ts\"},\"6\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.function.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"},\"4\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.ts entity.name.function.ts\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.ts\"}},\"name\":\"meta.parameters.ts\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.ts\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.ts\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.ts\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"},\"7\":{\"name\":\"keyword.control.require.ts\"},\"8\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.import-equals.external.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.ts\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.ts\"},\"2\":{\"name\":\"keyword.control.assert.ts\"},\"3\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.ts\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.ts\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"keyword.control.default.ts\"},\"3\":{\"name\":\"constant.language.import-export-all.ts\"},\"4\":{\"name\":\"variable.other.readwrite.ts\"},\"5\":{\"name\":\"string.quoted.alias.ts\"},\"12\":{\"name\":\"keyword.control.as.ts\"},\"13\":{\"name\":\"keyword.control.default.ts\"},\"14\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"15\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.ts\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"3\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.ts\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"meta.brace.square.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.declaration.ts\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.square.ts\"},\"4\":{\"name\":\"entity.name.type.ts\"},\"5\":{\"name\":\"keyword.operator.expression.in.ts\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"3\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.mappedtype.declaration.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.interface.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"keyword.operator.new.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.property.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.ts entity.name.function.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.ts\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.ts\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.ts\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.ts\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"2\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"4\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"6\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"7\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"9\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"11\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"13\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"14\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.ts\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.ts\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.ts\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.ts\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.object.property.ts\"},\"4\":{\"name\":\"variable.other.object.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.ts\"},\"2\":{\"name\":\"variable.other.object.ts\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"constant.numeric.decimal.ts\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.ts punctuation.separator.key-value.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.ts meta.return.type.arrow.ts keyword.operator.type.annotation.ts\"}},\"contentName\":\"meta.arrow.ts meta.return.type.arrow.ts\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.ts\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.ts\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.ts\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.double.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.single.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.ts\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.ts\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.ts\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.importmeta.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.target.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"support.variable.property.ts\"},\"4\":{\"name\":\"support.constant.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.ts\"},\"2\":{\"name\":\"support.type.object.module.ts\"},\"3\":{\"name\":\"punctuation.accessor.ts\"},\"4\":{\"name\":\"punctuation.accessor.optional.ts\"},\"5\":{\"name\":\"support.type.object.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"switch-statement.expr.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"switch-expression.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"},\"2\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"contentName\":\"meta.block.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.ts\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.ts\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.type.ts\"},\"4\":{\"name\":\"entity.name.type.alias.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"},\"2\":{\"name\":\"keyword.control.intrinsic.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.ts\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.ts storage.modifier.ts\"},\"2\":{\"name\":\"meta.type.constructor.ts keyword.control.new.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.control.new.ts\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.ts\"},\"2\":{\"name\":\"entity.name.type.ts\"},\"3\":{\"name\":\"keyword.operator.expression.extends.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.ts\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.ts\"},\"2\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.ts\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.object.type.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.ts\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.ts\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.type.paren.cover.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"},\"4\":{\"name\":\"keyword.operator.expression.is.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.ts\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.ts\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.type.tuple.ts\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.ts\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.ts\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.ts\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts entity.name.function.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.ts\",\"aliases\":[\"ts\",\"cts\",\"mts\"]}"));
var $f73e95e28dd02331$export$2e2bcd8739ae039 = [
    $f73e95e28dd02331$var$lang
];


/* Theme: github-light */ var $11093f5bebcb9f10$export$2e2bcd8739ae039 = Object.freeze(JSON.parse("{\"colors\":{\"activityBar.activeBorder\":\"#f9826c\",\"activityBar.background\":\"#fff\",\"activityBar.border\":\"#e1e4e8\",\"activityBar.foreground\":\"#2f363d\",\"activityBar.inactiveForeground\":\"#959da5\",\"activityBarBadge.background\":\"#2188ff\",\"activityBarBadge.foreground\":\"#fff\",\"badge.background\":\"#dbedff\",\"badge.foreground\":\"#005cc5\",\"breadcrumb.activeSelectionForeground\":\"#586069\",\"breadcrumb.focusForeground\":\"#2f363d\",\"breadcrumb.foreground\":\"#6a737d\",\"breadcrumbPicker.background\":\"#fafbfc\",\"button.background\":\"#159739\",\"button.foreground\":\"#fff\",\"button.hoverBackground\":\"#138934\",\"button.secondaryBackground\":\"#e1e4e8\",\"button.secondaryForeground\":\"#1b1f23\",\"button.secondaryHoverBackground\":\"#d1d5da\",\"checkbox.background\":\"#fafbfc\",\"checkbox.border\":\"#d1d5da\",\"debugToolBar.background\":\"#fff\",\"descriptionForeground\":\"#6a737d\",\"diffEditor.insertedTextBackground\":\"#34d05822\",\"diffEditor.removedTextBackground\":\"#d73a4922\",\"dropdown.background\":\"#fafbfc\",\"dropdown.border\":\"#e1e4e8\",\"dropdown.foreground\":\"#2f363d\",\"dropdown.listBackground\":\"#fff\",\"editor.background\":\"#fff\",\"editor.findMatchBackground\":\"#ffdf5d\",\"editor.findMatchHighlightBackground\":\"#ffdf5d66\",\"editor.focusedStackFrameHighlightBackground\":\"#28a74525\",\"editor.foldBackground\":\"#d1d5da11\",\"editor.foreground\":\"#24292e\",\"editor.inactiveSelectionBackground\":\"#0366d611\",\"editor.lineHighlightBackground\":\"#f6f8fa\",\"editor.linkedEditingBackground\":\"#0366d611\",\"editor.selectionBackground\":\"#0366d625\",\"editor.selectionHighlightBackground\":\"#34d05840\",\"editor.selectionHighlightBorder\":\"#34d05800\",\"editor.stackFrameHighlightBackground\":\"#ffd33d33\",\"editor.wordHighlightBackground\":\"#34d05800\",\"editor.wordHighlightBorder\":\"#24943e99\",\"editor.wordHighlightStrongBackground\":\"#34d05800\",\"editor.wordHighlightStrongBorder\":\"#24943e50\",\"editorBracketHighlight.foreground1\":\"#005cc5\",\"editorBracketHighlight.foreground2\":\"#e36209\",\"editorBracketHighlight.foreground3\":\"#5a32a3\",\"editorBracketHighlight.foreground4\":\"#005cc5\",\"editorBracketHighlight.foreground5\":\"#e36209\",\"editorBracketHighlight.foreground6\":\"#5a32a3\",\"editorBracketMatch.background\":\"#34d05840\",\"editorBracketMatch.border\":\"#34d05800\",\"editorCursor.foreground\":\"#044289\",\"editorError.foreground\":\"#cb2431\",\"editorGroup.border\":\"#e1e4e8\",\"editorGroupHeader.tabsBackground\":\"#f6f8fa\",\"editorGroupHeader.tabsBorder\":\"#e1e4e8\",\"editorGutter.addedBackground\":\"#28a745\",\"editorGutter.deletedBackground\":\"#d73a49\",\"editorGutter.modifiedBackground\":\"#2188ff\",\"editorIndentGuide.activeBackground\":\"#d7dbe0\",\"editorIndentGuide.background\":\"#eff2f6\",\"editorLineNumber.activeForeground\":\"#24292e\",\"editorLineNumber.foreground\":\"#1b1f234d\",\"editorOverviewRuler.border\":\"#fff\",\"editorWarning.foreground\":\"#f9c513\",\"editorWhitespace.foreground\":\"#d1d5da\",\"editorWidget.background\":\"#f6f8fa\",\"errorForeground\":\"#cb2431\",\"focusBorder\":\"#2188ff\",\"foreground\":\"#444d56\",\"gitDecoration.addedResourceForeground\":\"#28a745\",\"gitDecoration.conflictingResourceForeground\":\"#e36209\",\"gitDecoration.deletedResourceForeground\":\"#d73a49\",\"gitDecoration.ignoredResourceForeground\":\"#959da5\",\"gitDecoration.modifiedResourceForeground\":\"#005cc5\",\"gitDecoration.submoduleResourceForeground\":\"#959da5\",\"gitDecoration.untrackedResourceForeground\":\"#28a745\",\"input.background\":\"#fafbfc\",\"input.border\":\"#e1e4e8\",\"input.foreground\":\"#2f363d\",\"input.placeholderForeground\":\"#959da5\",\"list.activeSelectionBackground\":\"#e2e5e9\",\"list.activeSelectionForeground\":\"#2f363d\",\"list.focusBackground\":\"#cce5ff\",\"list.hoverBackground\":\"#ebf0f4\",\"list.hoverForeground\":\"#2f363d\",\"list.inactiveFocusBackground\":\"#dbedff\",\"list.inactiveSelectionBackground\":\"#e8eaed\",\"list.inactiveSelectionForeground\":\"#2f363d\",\"notificationCenterHeader.background\":\"#e1e4e8\",\"notificationCenterHeader.foreground\":\"#6a737d\",\"notifications.background\":\"#fafbfc\",\"notifications.border\":\"#e1e4e8\",\"notifications.foreground\":\"#2f363d\",\"notificationsErrorIcon.foreground\":\"#d73a49\",\"notificationsInfoIcon.foreground\":\"#005cc5\",\"notificationsWarningIcon.foreground\":\"#e36209\",\"panel.background\":\"#f6f8fa\",\"panel.border\":\"#e1e4e8\",\"panelInput.border\":\"#e1e4e8\",\"panelTitle.activeBorder\":\"#f9826c\",\"panelTitle.activeForeground\":\"#2f363d\",\"panelTitle.inactiveForeground\":\"#6a737d\",\"pickerGroup.border\":\"#e1e4e8\",\"pickerGroup.foreground\":\"#2f363d\",\"progressBar.background\":\"#2188ff\",\"quickInput.background\":\"#fafbfc\",\"quickInput.foreground\":\"#2f363d\",\"scrollbar.shadow\":\"#6a737d33\",\"scrollbarSlider.activeBackground\":\"#959da588\",\"scrollbarSlider.background\":\"#959da533\",\"scrollbarSlider.hoverBackground\":\"#959da544\",\"settings.headerForeground\":\"#2f363d\",\"settings.modifiedItemIndicator\":\"#2188ff\",\"sideBar.background\":\"#f6f8fa\",\"sideBar.border\":\"#e1e4e8\",\"sideBar.foreground\":\"#586069\",\"sideBarSectionHeader.background\":\"#f6f8fa\",\"sideBarSectionHeader.border\":\"#e1e4e8\",\"sideBarSectionHeader.foreground\":\"#2f363d\",\"sideBarTitle.foreground\":\"#2f363d\",\"statusBar.background\":\"#fff\",\"statusBar.border\":\"#e1e4e8\",\"statusBar.debuggingBackground\":\"#f9826c\",\"statusBar.debuggingForeground\":\"#fff\",\"statusBar.foreground\":\"#586069\",\"statusBar.noFolderBackground\":\"#fff\",\"statusBarItem.prominentBackground\":\"#e8eaed\",\"statusBarItem.remoteBackground\":\"#fff\",\"statusBarItem.remoteForeground\":\"#586069\",\"tab.activeBackground\":\"#fff\",\"tab.activeBorder\":\"#fff\",\"tab.activeBorderTop\":\"#f9826c\",\"tab.activeForeground\":\"#2f363d\",\"tab.border\":\"#e1e4e8\",\"tab.hoverBackground\":\"#fff\",\"tab.inactiveBackground\":\"#f6f8fa\",\"tab.inactiveForeground\":\"#6a737d\",\"tab.unfocusedActiveBorder\":\"#fff\",\"tab.unfocusedActiveBorderTop\":\"#e1e4e8\",\"tab.unfocusedHoverBackground\":\"#fff\",\"terminal.ansiBlack\":\"#24292e\",\"terminal.ansiBlue\":\"#0366d6\",\"terminal.ansiBrightBlack\":\"#959da5\",\"terminal.ansiBrightBlue\":\"#005cc5\",\"terminal.ansiBrightCyan\":\"#3192aa\",\"terminal.ansiBrightGreen\":\"#22863a\",\"terminal.ansiBrightMagenta\":\"#5a32a3\",\"terminal.ansiBrightRed\":\"#cb2431\",\"terminal.ansiBrightWhite\":\"#d1d5da\",\"terminal.ansiBrightYellow\":\"#b08800\",\"terminal.ansiCyan\":\"#1b7c83\",\"terminal.ansiGreen\":\"#28a745\",\"terminal.ansiMagenta\":\"#5a32a3\",\"terminal.ansiRed\":\"#d73a49\",\"terminal.ansiWhite\":\"#6a737d\",\"terminal.ansiYellow\":\"#dbab09\",\"terminal.foreground\":\"#586069\",\"terminal.tab.activeBorder\":\"#f9826c\",\"terminalCursor.background\":\"#d1d5da\",\"terminalCursor.foreground\":\"#005cc5\",\"textBlockQuote.background\":\"#fafbfc\",\"textBlockQuote.border\":\"#e1e4e8\",\"textCodeBlock.background\":\"#f6f8fa\",\"textLink.activeForeground\":\"#005cc5\",\"textLink.foreground\":\"#0366d6\",\"textPreformat.foreground\":\"#586069\",\"textSeparator.foreground\":\"#d1d5da\",\"titleBar.activeBackground\":\"#fff\",\"titleBar.activeForeground\":\"#2f363d\",\"titleBar.border\":\"#e1e4e8\",\"titleBar.inactiveBackground\":\"#f6f8fa\",\"titleBar.inactiveForeground\":\"#6a737d\",\"tree.indentGuidesStroke\":\"#e1e4e8\",\"welcomePage.buttonBackground\":\"#f6f8fa\",\"welcomePage.buttonHoverBackground\":\"#e1e4e8\"},\"displayName\":\"GitHub Light\",\"name\":\"github-light\",\"semanticHighlighting\":true,\"tokenColors\":[{\"scope\":[\"comment\",\"punctuation.definition.comment\",\"string.comment\"],\"settings\":{\"foreground\":\"#6a737d\"}},{\"scope\":[\"constant\",\"entity.name.constant\",\"variable.other.constant\",\"variable.other.enummember\",\"variable.language\"],\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"entity\",\"entity.name\"],\"settings\":{\"foreground\":\"#6f42c1\"}},{\"scope\":\"variable.parameter.function\",\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":\"entity.name.tag\",\"settings\":{\"foreground\":\"#22863a\"}},{\"scope\":\"keyword\",\"settings\":{\"foreground\":\"#d73a49\"}},{\"scope\":[\"storage\",\"storage.type\"],\"settings\":{\"foreground\":\"#d73a49\"}},{\"scope\":[\"storage.modifier.package\",\"storage.modifier.import\",\"storage.type.java\"],\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":[\"string\",\"punctuation.definition.string\",\"string punctuation.section.embedded source\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":\"support\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.property-name\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"variable\",\"settings\":{\"foreground\":\"#e36209\"}},{\"scope\":\"variable.other\",\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":\"invalid.broken\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.deprecated\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.illegal\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.unimplemented\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"carriage-return\",\"settings\":{\"background\":\"#d73a49\",\"content\":\"^M\",\"fontStyle\":\"italic underline\",\"foreground\":\"#fafbfc\"}},{\"scope\":\"message.error\",\"settings\":{\"foreground\":\"#b31d28\"}},{\"scope\":\"string variable\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"source.regexp\",\"string.regexp\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":[\"string.regexp.character-class\",\"string.regexp constant.character.escape\",\"string.regexp source.ruby.embedded\",\"string.regexp string.regexp.arbitrary-repitition\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":\"string.regexp constant.character.escape\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#22863a\"}},{\"scope\":\"support.constant\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"support.variable\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.module-reference\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"punctuation.definition.list.begin.markdown\",\"settings\":{\"foreground\":\"#e36209\"}},{\"scope\":[\"markup.heading\",\"markup.heading entity.name\"],\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#005cc5\"}},{\"scope\":\"markup.quote\",\"settings\":{\"foreground\":\"#22863a\"}},{\"scope\":\"markup.italic\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#24292e\"}},{\"scope\":\"markup.bold\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#24292e\"}},{\"scope\":[\"markup.underline\"],\"settings\":{\"fontStyle\":\"underline\"}},{\"scope\":[\"markup.strikethrough\"],\"settings\":{\"fontStyle\":\"strikethrough\"}},{\"scope\":\"markup.inline.raw\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"markup.deleted\",\"meta.diff.header.from-file\",\"punctuation.definition.deleted\"],\"settings\":{\"background\":\"#ffeef0\",\"foreground\":\"#b31d28\"}},{\"scope\":[\"markup.inserted\",\"meta.diff.header.to-file\",\"punctuation.definition.inserted\"],\"settings\":{\"background\":\"#f0fff4\",\"foreground\":\"#22863a\"}},{\"scope\":[\"markup.changed\",\"punctuation.definition.changed\"],\"settings\":{\"background\":\"#ffebda\",\"foreground\":\"#e36209\"}},{\"scope\":[\"markup.ignored\",\"markup.untracked\"],\"settings\":{\"background\":\"#005cc5\",\"foreground\":\"#f6f8fa\"}},{\"scope\":\"meta.diff.range\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#6f42c1\"}},{\"scope\":\"meta.diff.header\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.separator\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.output\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"brackethighlighter.tag\",\"brackethighlighter.curly\",\"brackethighlighter.round\",\"brackethighlighter.square\",\"brackethighlighter.angle\",\"brackethighlighter.quote\"],\"settings\":{\"foreground\":\"#586069\"}},{\"scope\":\"brackethighlighter.unmatched\",\"settings\":{\"foreground\":\"#b31d28\"}},{\"scope\":[\"constant.other.reference.link\",\"string.other.link\"],\"settings\":{\"fontStyle\":\"underline\",\"foreground\":\"#032f62\"}}],\"type\":\"light\"}"));


//#region src/error.ts
var $4730dfad1a6b90a4$export$5003b41ce90ff8c9 = class extends Error {
    constructor(message){
        super(message);
        this.name = "ShikiError";
    }
};



// src/utils.ts
function $b5e49ecb88b9a024$var$clone(something) {
    return $b5e49ecb88b9a024$var$doClone(something);
}
function $b5e49ecb88b9a024$var$doClone(something) {
    if (Array.isArray(something)) return $b5e49ecb88b9a024$var$cloneArray(something);
    if (something instanceof RegExp) return something;
    if (typeof something === "object") return $b5e49ecb88b9a024$var$cloneObj(something);
    return something;
}
function $b5e49ecb88b9a024$var$cloneArray(arr) {
    let r = [];
    for(let i = 0, len = arr.length; i < len; i++)r[i] = $b5e49ecb88b9a024$var$doClone(arr[i]);
    return r;
}
function $b5e49ecb88b9a024$var$cloneObj(obj) {
    let r = {};
    for(let key in obj)r[key] = $b5e49ecb88b9a024$var$doClone(obj[key]);
    return r;
}
function $b5e49ecb88b9a024$var$mergeObjects(target, ...sources) {
    sources.forEach((source)=>{
        for(let key in source)target[key] = source[key];
    });
    return target;
}
function $b5e49ecb88b9a024$var$basename(path) {
    const idx = ~path.lastIndexOf("/") || ~path.lastIndexOf("\\");
    if (idx === 0) return path;
    else if (~idx === path.length - 1) return $b5e49ecb88b9a024$var$basename(path.substring(0, path.length - 1));
    else return path.substr(~idx + 1);
}
var $b5e49ecb88b9a024$var$CAPTURING_REGEX_SOURCE = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g;
var $b5e49ecb88b9a024$var$RegexSource = class {
    static hasCaptures(regexSource) {
        if (regexSource === null) return false;
        $b5e49ecb88b9a024$var$CAPTURING_REGEX_SOURCE.lastIndex = 0;
        return $b5e49ecb88b9a024$var$CAPTURING_REGEX_SOURCE.test(regexSource);
    }
    static replaceCaptures(regexSource, captureSource, captureIndices) {
        return regexSource.replace($b5e49ecb88b9a024$var$CAPTURING_REGEX_SOURCE, (match, index, commandIndex, command)=>{
            let capture = captureIndices[parseInt(index || commandIndex, 10)];
            if (capture) {
                let result = captureSource.substring(capture.start, capture.end);
                while(result[0] === ".")result = result.substring(1);
                switch(command){
                    case "downcase":
                        return result.toLowerCase();
                    case "upcase":
                        return result.toUpperCase();
                    default:
                        return result;
                }
            } else return match;
        });
    }
};
function $b5e49ecb88b9a024$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $b5e49ecb88b9a024$var$strArrCmp(a, b) {
    if (a === null && b === null) return 0;
    if (!a) return -1;
    if (!b) return 1;
    let len1 = a.length;
    let len2 = b.length;
    if (len1 === len2) {
        for(let i = 0; i < len1; i++){
            let res = $b5e49ecb88b9a024$var$strcmp(a[i], b[i]);
            if (res !== 0) return res;
        }
        return 0;
    }
    return len1 - len2;
}
function $b5e49ecb88b9a024$var$isValidHexColor(hex) {
    if (/^#[0-9a-f]{6}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{8}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{3}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{4}$/i.test(hex)) return true;
    return false;
}
function $b5e49ecb88b9a024$var$escapeRegExpCharacters(value) {
    return value.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var $b5e49ecb88b9a024$var$CachedFn = class {
    constructor(fn){
        this.fn = fn;
    }
    fn;
    cache = /* @__PURE__ */ new Map();
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const value = this.fn(key);
        this.cache.set(key, value);
        return value;
    }
};
// src/theme.ts
var $b5e49ecb88b9a024$export$14faa19a0f3bbeb2 = class {
    constructor(_colorMap, _defaults, _root){
        this._colorMap = _colorMap;
        this._defaults = _defaults;
        this._root = _root;
    }
    _colorMap;
    _defaults;
    _root;
    static createFromRawTheme(source, colorMap) {
        return this.createFromParsedTheme($b5e49ecb88b9a024$var$parseTheme(source), colorMap);
    }
    static createFromParsedTheme(source, colorMap) {
        return $b5e49ecb88b9a024$var$resolveParsedThemeRules(source, colorMap);
    }
    _cachedMatchRoot = new $b5e49ecb88b9a024$var$CachedFn((scopeName)=>this._root.match(scopeName));
    getColorMap() {
        return this._colorMap.getColorMap();
    }
    getDefaults() {
        return this._defaults;
    }
    match(scopePath) {
        if (scopePath === null) return this._defaults;
        const scopeName = scopePath.scopeName;
        const matchingTrieElements = this._cachedMatchRoot.get(scopeName);
        const effectiveRule = matchingTrieElements.find((v)=>$b5e49ecb88b9a024$var$_scopePathMatchesParentScopes(scopePath.parent, v.parentScopes));
        if (!effectiveRule) return null;
        return new $b5e49ecb88b9a024$var$StyleAttributes(effectiveRule.fontStyle, effectiveRule.foreground, effectiveRule.background);
    }
};
var $b5e49ecb88b9a024$var$ScopeStack = class _ScopeStack {
    constructor(parent, scopeName){
        this.parent = parent;
        this.scopeName = scopeName;
    }
    parent;
    scopeName;
    static push(path, scopeNames) {
        for (const name of scopeNames)path = new _ScopeStack(path, name);
        return path;
    }
    static from(...segments) {
        let result = null;
        for(let i = 0; i < segments.length; i++)result = new _ScopeStack(result, segments[i]);
        return result;
    }
    push(scopeName) {
        return new _ScopeStack(this, scopeName);
    }
    getSegments() {
        let item = this;
        const result = [];
        while(item){
            result.push(item.scopeName);
            item = item.parent;
        }
        result.reverse();
        return result;
    }
    toString() {
        return this.getSegments().join(" ");
    }
    extends(other) {
        if (this === other) return true;
        if (this.parent === null) return false;
        return this.parent.extends(other);
    }
    getExtensionIfDefined(base) {
        const result = [];
        let item = this;
        while(item && item !== base){
            result.push(item.scopeName);
            item = item.parent;
        }
        return item === base ? result.reverse() : void 0;
    }
};
function $b5e49ecb88b9a024$var$_scopePathMatchesParentScopes(scopePath, parentScopes) {
    if (parentScopes.length === 0) return true;
    for(let index = 0; index < parentScopes.length; index++){
        let scopePattern = parentScopes[index];
        let scopeMustMatch = false;
        if (scopePattern === ">") {
            if (index === parentScopes.length - 1) return false;
            scopePattern = parentScopes[++index];
            scopeMustMatch = true;
        }
        while(scopePath){
            if ($b5e49ecb88b9a024$var$_matchesScope(scopePath.scopeName, scopePattern)) break;
            if (scopeMustMatch) return false;
            scopePath = scopePath.parent;
        }
        if (!scopePath) return false;
        scopePath = scopePath.parent;
    }
    return true;
}
function $b5e49ecb88b9a024$var$_matchesScope(scopeName, scopePattern) {
    return scopePattern === scopeName || scopeName.startsWith(scopePattern) && scopeName[scopePattern.length] === ".";
}
var $b5e49ecb88b9a024$var$StyleAttributes = class {
    constructor(fontStyle, foregroundId, backgroundId){
        this.fontStyle = fontStyle;
        this.foregroundId = foregroundId;
        this.backgroundId = backgroundId;
    }
    fontStyle;
    foregroundId;
    backgroundId;
};
function $b5e49ecb88b9a024$var$parseTheme(source) {
    if (!source) return [];
    if (!source.settings || !Array.isArray(source.settings)) return [];
    let settings = source.settings;
    let result = [], resultLen = 0;
    for(let i = 0, len = settings.length; i < len; i++){
        let entry = settings[i];
        if (!entry.settings) continue;
        let scopes;
        if (typeof entry.scope === "string") {
            let _scope = entry.scope;
            _scope = _scope.replace(/^[,]+/, "");
            _scope = _scope.replace(/[,]+$/, "");
            scopes = _scope.split(",");
        } else if (Array.isArray(entry.scope)) scopes = entry.scope;
        else scopes = [
            ""
        ];
        let fontStyle = -1 /* NotSet */ ;
        if (typeof entry.settings.fontStyle === "string") {
            fontStyle = 0 /* None */ ;
            let segments = entry.settings.fontStyle.split(" ");
            for(let j = 0, lenJ = segments.length; j < lenJ; j++){
                let segment = segments[j];
                switch(segment){
                    case "italic":
                        fontStyle = fontStyle | 1 /* Italic */ ;
                        break;
                    case "bold":
                        fontStyle = fontStyle | 2 /* Bold */ ;
                        break;
                    case "underline":
                        fontStyle = fontStyle | 4 /* Underline */ ;
                        break;
                    case "strikethrough":
                        fontStyle = fontStyle | 8 /* Strikethrough */ ;
                        break;
                }
            }
        }
        let foreground = null;
        if (typeof entry.settings.foreground === "string" && $b5e49ecb88b9a024$var$isValidHexColor(entry.settings.foreground)) foreground = entry.settings.foreground;
        let background = null;
        if (typeof entry.settings.background === "string" && $b5e49ecb88b9a024$var$isValidHexColor(entry.settings.background)) background = entry.settings.background;
        for(let j = 0, lenJ = scopes.length; j < lenJ; j++){
            let _scope = scopes[j].trim();
            let segments = _scope.split(" ");
            let scope = segments[segments.length - 1];
            let parentScopes = null;
            if (segments.length > 1) {
                parentScopes = segments.slice(0, segments.length - 1);
                parentScopes.reverse();
            }
            result[resultLen++] = new $b5e49ecb88b9a024$var$ParsedThemeRule(scope, parentScopes, i, fontStyle, foreground, background);
        }
    }
    return result;
}
var $b5e49ecb88b9a024$var$ParsedThemeRule = class {
    constructor(scope, parentScopes, index, fontStyle, foreground, background){
        this.scope = scope;
        this.parentScopes = parentScopes;
        this.index = index;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
    scope;
    parentScopes;
    index;
    fontStyle;
    foreground;
    background;
};
var $b5e49ecb88b9a024$export$23b468d4ca3f8c96 = /* @__PURE__ */ ((FontStyle2)=>{
    FontStyle2[FontStyle2["NotSet"] = -1] = "NotSet";
    FontStyle2[FontStyle2["None"] = 0] = "None";
    FontStyle2[FontStyle2["Italic"] = 1] = "Italic";
    FontStyle2[FontStyle2["Bold"] = 2] = "Bold";
    FontStyle2[FontStyle2["Underline"] = 4] = "Underline";
    FontStyle2[FontStyle2["Strikethrough"] = 8] = "Strikethrough";
    return FontStyle2;
})($b5e49ecb88b9a024$export$23b468d4ca3f8c96 || {});
function $b5e49ecb88b9a024$var$resolveParsedThemeRules(parsedThemeRules, _colorMap) {
    parsedThemeRules.sort((a, b)=>{
        let r = $b5e49ecb88b9a024$var$strcmp(a.scope, b.scope);
        if (r !== 0) return r;
        r = $b5e49ecb88b9a024$var$strArrCmp(a.parentScopes, b.parentScopes);
        if (r !== 0) return r;
        return a.index - b.index;
    });
    let defaultFontStyle = 0 /* None */ ;
    let defaultForeground = "#000000";
    let defaultBackground = "#ffffff";
    while(parsedThemeRules.length >= 1 && parsedThemeRules[0].scope === ""){
        let incomingDefaults = parsedThemeRules.shift();
        if (incomingDefaults.fontStyle !== -1 /* NotSet */ ) defaultFontStyle = incomingDefaults.fontStyle;
        if (incomingDefaults.foreground !== null) defaultForeground = incomingDefaults.foreground;
        if (incomingDefaults.background !== null) defaultBackground = incomingDefaults.background;
    }
    let colorMap = new $b5e49ecb88b9a024$var$ColorMap(_colorMap);
    let defaults = new $b5e49ecb88b9a024$var$StyleAttributes(defaultFontStyle, colorMap.getId(defaultForeground), colorMap.getId(defaultBackground));
    let root = new $b5e49ecb88b9a024$var$ThemeTrieElement(new $b5e49ecb88b9a024$var$ThemeTrieElementRule(0, null, -1 /* NotSet */ , 0, 0), []);
    for(let i = 0, len = parsedThemeRules.length; i < len; i++){
        let rule = parsedThemeRules[i];
        root.insert(0, rule.scope, rule.parentScopes, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
    }
    return new $b5e49ecb88b9a024$export$14faa19a0f3bbeb2(colorMap, defaults, root);
}
var $b5e49ecb88b9a024$var$ColorMap = class {
    _isFrozen;
    _lastColorId;
    _id2color;
    _color2id;
    constructor(_colorMap){
        this._lastColorId = 0;
        this._id2color = [];
        this._color2id = /* @__PURE__ */ Object.create(null);
        if (Array.isArray(_colorMap)) {
            this._isFrozen = true;
            for(let i = 0, len = _colorMap.length; i < len; i++){
                this._color2id[_colorMap[i]] = i;
                this._id2color[i] = _colorMap[i];
            }
        } else this._isFrozen = false;
    }
    getId(color) {
        if (color === null) return 0;
        color = color.toUpperCase();
        let value = this._color2id[color];
        if (value) return value;
        if (this._isFrozen) throw new Error(`Missing color in color map - ${color}`);
        value = ++this._lastColorId;
        this._color2id[color] = value;
        this._id2color[value] = color;
        return value;
    }
    getColorMap() {
        return this._id2color.slice(0);
    }
};
var $b5e49ecb88b9a024$var$emptyParentScopes = Object.freeze([]);
var $b5e49ecb88b9a024$var$ThemeTrieElementRule = class _ThemeTrieElementRule {
    scopeDepth;
    parentScopes;
    fontStyle;
    foreground;
    background;
    constructor(scopeDepth, parentScopes, fontStyle, foreground, background){
        this.scopeDepth = scopeDepth;
        this.parentScopes = parentScopes || $b5e49ecb88b9a024$var$emptyParentScopes;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
    clone() {
        return new _ThemeTrieElementRule(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
    }
    static cloneArr(arr) {
        let r = [];
        for(let i = 0, len = arr.length; i < len; i++)r[i] = arr[i].clone();
        return r;
    }
    acceptOverwrite(scopeDepth, fontStyle, foreground, background) {
        if (this.scopeDepth > scopeDepth) console.log("how did this happen?");
        else this.scopeDepth = scopeDepth;
        if (fontStyle !== -1 /* NotSet */ ) this.fontStyle = fontStyle;
        if (foreground !== 0) this.foreground = foreground;
        if (background !== 0) this.background = background;
    }
};
var $b5e49ecb88b9a024$var$ThemeTrieElement = class _ThemeTrieElement {
    constructor(_mainRule, rulesWithParentScopes = [], _children = {}){
        this._mainRule = _mainRule;
        this._children = _children;
        this._rulesWithParentScopes = rulesWithParentScopes;
    }
    _mainRule;
    _children;
    _rulesWithParentScopes;
    static _cmpBySpecificity(a, b) {
        if (a.scopeDepth !== b.scopeDepth) return b.scopeDepth - a.scopeDepth;
        let aParentIndex = 0;
        let bParentIndex = 0;
        while(true){
            if (a.parentScopes[aParentIndex] === ">") aParentIndex++;
            if (b.parentScopes[bParentIndex] === ">") bParentIndex++;
            if (aParentIndex >= a.parentScopes.length || bParentIndex >= b.parentScopes.length) break;
            const parentScopeLengthDiff = b.parentScopes[bParentIndex].length - a.parentScopes[aParentIndex].length;
            if (parentScopeLengthDiff !== 0) return parentScopeLengthDiff;
            aParentIndex++;
            bParentIndex++;
        }
        return b.parentScopes.length - a.parentScopes.length;
    }
    match(scope) {
        if (scope !== "") {
            let dotIndex = scope.indexOf(".");
            let head;
            let tail;
            if (dotIndex === -1) {
                head = scope;
                tail = "";
            } else {
                head = scope.substring(0, dotIndex);
                tail = scope.substring(dotIndex + 1);
            }
            if (this._children.hasOwnProperty(head)) return this._children[head].match(tail);
        }
        const rules = this._rulesWithParentScopes.concat(this._mainRule);
        rules.sort(_ThemeTrieElement._cmpBySpecificity);
        return rules;
    }
    insert(scopeDepth, scope, parentScopes, fontStyle, foreground, background) {
        if (scope === "") {
            this._doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background);
            return;
        }
        let dotIndex = scope.indexOf(".");
        let head;
        let tail;
        if (dotIndex === -1) {
            head = scope;
            tail = "";
        } else {
            head = scope.substring(0, dotIndex);
            tail = scope.substring(dotIndex + 1);
        }
        let child;
        if (this._children.hasOwnProperty(head)) child = this._children[head];
        else {
            child = new _ThemeTrieElement(this._mainRule.clone(), $b5e49ecb88b9a024$var$ThemeTrieElementRule.cloneArr(this._rulesWithParentScopes));
            this._children[head] = child;
        }
        child.insert(scopeDepth + 1, tail, parentScopes, fontStyle, foreground, background);
    }
    _doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background) {
        if (parentScopes === null) {
            this._mainRule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
            return;
        }
        for(let i = 0, len = this._rulesWithParentScopes.length; i < len; i++){
            let rule = this._rulesWithParentScopes[i];
            if ($b5e49ecb88b9a024$var$strArrCmp(rule.parentScopes, parentScopes) === 0) {
                rule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
                return;
            }
        }
        if (fontStyle === -1 /* NotSet */ ) fontStyle = this._mainRule.fontStyle;
        if (foreground === 0) foreground = this._mainRule.foreground;
        if (background === 0) background = this._mainRule.background;
        this._rulesWithParentScopes.push(new $b5e49ecb88b9a024$var$ThemeTrieElementRule(scopeDepth, parentScopes, fontStyle, foreground, background));
    }
};
// src/encodedTokenAttributes.ts
var $b5e49ecb88b9a024$export$90e5db14803ea047 = class _EncodedTokenMetadata {
    static toBinaryStr(encodedTokenAttributes) {
        return encodedTokenAttributes.toString(2).padStart(32, "0");
    }
    static print(encodedTokenAttributes) {
        const languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        const tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        const fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        const foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        const background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        console.log({
            languageId: languageId,
            tokenType: tokenType,
            fontStyle: fontStyle,
            foreground: foreground,
            background: background
        });
    }
    static getLanguageId(encodedTokenAttributes) {
        return (encodedTokenAttributes & 255 /* LANGUAGEID_MASK */ ) >>> 0 /* LANGUAGEID_OFFSET */ ;
    }
    static getTokenType(encodedTokenAttributes) {
        return (encodedTokenAttributes & 768 /* TOKEN_TYPE_MASK */ ) >>> 8 /* TOKEN_TYPE_OFFSET */ ;
    }
    static containsBalancedBrackets(encodedTokenAttributes) {
        return (encodedTokenAttributes & 1024 /* BALANCED_BRACKETS_MASK */ ) !== 0;
    }
    static getFontStyle(encodedTokenAttributes) {
        return (encodedTokenAttributes & 30720 /* FONT_STYLE_MASK */ ) >>> 11 /* FONT_STYLE_OFFSET */ ;
    }
    static getForeground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 16744448 /* FOREGROUND_MASK */ ) >>> 15 /* FOREGROUND_OFFSET */ ;
    }
    static getBackground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 4278190080 /* BACKGROUND_MASK */ ) >>> 24 /* BACKGROUND_OFFSET */ ;
    }
    /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */ static set(encodedTokenAttributes, languageId, tokenType, containsBalancedBrackets, fontStyle, foreground, background) {
        let _languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        let _tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        let _containsBalancedBracketsBit = _EncodedTokenMetadata.containsBalancedBrackets(encodedTokenAttributes) ? 1 : 0;
        let _fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        let _foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        let _background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        if (languageId !== 0) _languageId = languageId;
        if (tokenType !== 8 /* NotSet */ ) _tokenType = $b5e49ecb88b9a024$var$fromOptionalTokenType(tokenType);
        if (containsBalancedBrackets !== null) _containsBalancedBracketsBit = containsBalancedBrackets ? 1 : 0;
        if (fontStyle !== -1 /* NotSet */ ) _fontStyle = fontStyle;
        if (foreground !== 0) _foreground = foreground;
        if (background !== 0) _background = background;
        return (_languageId << 0 /* LANGUAGEID_OFFSET */  | _tokenType << 8 /* TOKEN_TYPE_OFFSET */  | _containsBalancedBracketsBit << 10 /* BALANCED_BRACKETS_OFFSET */  | _fontStyle << 11 /* FONT_STYLE_OFFSET */  | _foreground << 15 /* FOREGROUND_OFFSET */  | _background << 24 /* BACKGROUND_OFFSET */ ) >>> 0;
    }
};
function $b5e49ecb88b9a024$var$toOptionalTokenType(standardType) {
    return standardType;
}
function $b5e49ecb88b9a024$var$fromOptionalTokenType(standardType) {
    return standardType;
}
// src/matcher.ts
function $b5e49ecb88b9a024$var$createMatchers(selector, matchesName) {
    const results = [];
    const tokenizer = $b5e49ecb88b9a024$var$newTokenizer(selector);
    let token = tokenizer.next();
    while(token !== null){
        let priority = 0;
        if (token.length === 2 && token.charAt(1) === ":") {
            switch(token.charAt(0)){
                case "R":
                    priority = 1;
                    break;
                case "L":
                    priority = -1;
                    break;
                default:
                    console.log(`Unknown priority ${token} in scope selector`);
            }
            token = tokenizer.next();
        }
        let matcher = parseConjunction();
        results.push({
            matcher: matcher,
            priority: priority
        });
        if (token !== ",") break;
        token = tokenizer.next();
    }
    return results;
    function parseOperand() {
        if (token === "-") {
            token = tokenizer.next();
            const expressionToNegate = parseOperand();
            return (matcherInput)=>!!expressionToNegate && !expressionToNegate(matcherInput);
        }
        if (token === "(") {
            token = tokenizer.next();
            const expressionInParents = parseInnerExpression();
            if (token === ")") token = tokenizer.next();
            return expressionInParents;
        }
        if ($b5e49ecb88b9a024$var$isIdentifier(token)) {
            const identifiers = [];
            do {
                identifiers.push(token);
                token = tokenizer.next();
            }while ($b5e49ecb88b9a024$var$isIdentifier(token));
            return (matcherInput)=>matchesName(identifiers, matcherInput);
        }
        return null;
    }
    function parseConjunction() {
        const matchers = [];
        let matcher = parseOperand();
        while(matcher){
            matchers.push(matcher);
            matcher = parseOperand();
        }
        return (matcherInput)=>matchers.every((matcher2)=>matcher2(matcherInput));
    }
    function parseInnerExpression() {
        const matchers = [];
        let matcher = parseConjunction();
        while(matcher){
            matchers.push(matcher);
            if (token === "|" || token === ",") do token = tokenizer.next();
            while (token === "|" || token === ",");
            else break;
            matcher = parseConjunction();
        }
        return (matcherInput)=>matchers.some((matcher2)=>matcher2(matcherInput));
    }
}
function $b5e49ecb88b9a024$var$isIdentifier(token) {
    return !!token && !!token.match(/[\w\.:]+/);
}
function $b5e49ecb88b9a024$var$newTokenizer(input) {
    let regex = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g;
    let match = regex.exec(input);
    return {
        next: ()=>{
            if (!match) return null;
            const res = match[0];
            match = regex.exec(input);
            return res;
        }
    };
}
// src/onigLib.ts
var $b5e49ecb88b9a024$export$94e52bf7f3697178 = /* @__PURE__ */ ((FindOption2)=>{
    FindOption2[FindOption2["None"] = 0] = "None";
    FindOption2[FindOption2["NotBeginString"] = 1] = "NotBeginString";
    FindOption2[FindOption2["NotEndString"] = 2] = "NotEndString";
    FindOption2[FindOption2["NotBeginPosition"] = 4] = "NotBeginPosition";
    FindOption2[FindOption2["DebugCall"] = 8] = "DebugCall";
    return FindOption2;
})($b5e49ecb88b9a024$export$94e52bf7f3697178 || {});
function $b5e49ecb88b9a024$export$2b6cad23a17023a7(str) {
    if (typeof str.dispose === "function") str.dispose();
}
// src/grammar/grammarDependencies.ts
var $b5e49ecb88b9a024$var$TopLevelRuleReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    scopeName;
    toKey() {
        return this.scopeName;
    }
};
var $b5e49ecb88b9a024$var$TopLevelRepositoryRuleReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    scopeName;
    ruleName;
    toKey() {
        return `${this.scopeName}#${this.ruleName}`;
    }
};
var $b5e49ecb88b9a024$var$ExternalReferenceCollector = class {
    _references = [];
    _seenReferenceKeys = /* @__PURE__ */ new Set();
    get references() {
        return this._references;
    }
    visitedRule = /* @__PURE__ */ new Set();
    add(reference) {
        const key = reference.toKey();
        if (this._seenReferenceKeys.has(key)) return;
        this._seenReferenceKeys.add(key);
        this._references.push(reference);
    }
};
var $b5e49ecb88b9a024$var$ScopeDependencyProcessor = class {
    constructor(repo, initialScopeName){
        this.repo = repo;
        this.initialScopeName = initialScopeName;
        this.seenFullScopeRequests.add(this.initialScopeName);
        this.Q = [
            new $b5e49ecb88b9a024$var$TopLevelRuleReference(this.initialScopeName)
        ];
    }
    repo;
    initialScopeName;
    seenFullScopeRequests = /* @__PURE__ */ new Set();
    seenPartialScopeRequests = /* @__PURE__ */ new Set();
    Q;
    processQueue() {
        const q = this.Q;
        this.Q = [];
        const deps = new $b5e49ecb88b9a024$var$ExternalReferenceCollector();
        for (const dep of q)$b5e49ecb88b9a024$var$collectReferencesOfReference(dep, this.initialScopeName, this.repo, deps);
        for (const dep of deps.references)if (dep instanceof $b5e49ecb88b9a024$var$TopLevelRuleReference) {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            this.seenFullScopeRequests.add(dep.scopeName);
            this.Q.push(dep);
        } else {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            if (this.seenPartialScopeRequests.has(dep.toKey())) continue;
            this.seenPartialScopeRequests.add(dep.toKey());
            this.Q.push(dep);
        }
    }
};
function $b5e49ecb88b9a024$var$collectReferencesOfReference(reference, baseGrammarScopeName, repo, result) {
    const selfGrammar = repo.lookup(reference.scopeName);
    if (!selfGrammar) {
        if (reference.scopeName === baseGrammarScopeName) throw new Error(`No grammar provided for <${baseGrammarScopeName}>`);
        return;
    }
    const baseGrammar = repo.lookup(baseGrammarScopeName);
    if (reference instanceof $b5e49ecb88b9a024$var$TopLevelRuleReference) $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRule({
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar
    }, result);
    else $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar,
        repository: selfGrammar.repository
    }, result);
    const injections = repo.injections(reference.scopeName);
    if (injections) for (const injection of injections)result.add(new $b5e49ecb88b9a024$var$TopLevelRuleReference(injection));
}
function $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRepositoryRule(ruleName, context, result) {
    if (context.repository && context.repository[ruleName]) {
        const rule = context.repository[ruleName];
        $b5e49ecb88b9a024$var$collectExternalReferencesInRules([
            rule
        ], context, result);
    }
}
function $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRule(context, result) {
    if (context.selfGrammar.patterns && Array.isArray(context.selfGrammar.patterns)) $b5e49ecb88b9a024$var$collectExternalReferencesInRules(context.selfGrammar.patterns, {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
    if (context.selfGrammar.injections) $b5e49ecb88b9a024$var$collectExternalReferencesInRules(Object.values(context.selfGrammar.injections), {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
}
function $b5e49ecb88b9a024$var$collectExternalReferencesInRules(rules, context, result) {
    for (const rule of rules){
        if (result.visitedRule.has(rule)) continue;
        result.visitedRule.add(rule);
        const patternRepository = rule.repository ? $b5e49ecb88b9a024$var$mergeObjects({}, context.repository, rule.repository) : context.repository;
        if (Array.isArray(rule.patterns)) $b5e49ecb88b9a024$var$collectExternalReferencesInRules(rule.patterns, {
            ...context,
            repository: patternRepository
        }, result);
        const include = rule.include;
        if (!include) continue;
        const reference = $b5e49ecb88b9a024$var$parseInclude(include);
        switch(reference.kind){
            case 0 /* Base */ :
                $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRule({
                    ...context,
                    selfGrammar: context.baseGrammar
                }, result);
                break;
            case 1 /* Self */ :
                $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRule(context, result);
                break;
            case 2 /* RelativeReference */ :
                $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
                    ...context,
                    repository: patternRepository
                }, result);
                break;
            case 3 /* TopLevelReference */ :
            case 4 /* TopLevelRepositoryReference */ :
                const selfGrammar = reference.scopeName === context.selfGrammar.scopeName ? context.selfGrammar : reference.scopeName === context.baseGrammar.scopeName ? context.baseGrammar : void 0;
                if (selfGrammar) {
                    const newContext = {
                        baseGrammar: context.baseGrammar,
                        selfGrammar: selfGrammar,
                        repository: patternRepository
                    };
                    if (reference.kind === 4 /* TopLevelRepositoryReference */ ) $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, newContext, result);
                    else $b5e49ecb88b9a024$var$collectExternalReferencesInTopLevelRule(newContext, result);
                } else if (reference.kind === 4 /* TopLevelRepositoryReference */ ) result.add(new $b5e49ecb88b9a024$var$TopLevelRepositoryRuleReference(reference.scopeName, reference.ruleName));
                else result.add(new $b5e49ecb88b9a024$var$TopLevelRuleReference(reference.scopeName));
                break;
        }
    }
}
var $b5e49ecb88b9a024$var$BaseReference = class {
    kind = 0 /* Base */ ;
};
var $b5e49ecb88b9a024$var$SelfReference = class {
    kind = 1 /* Self */ ;
};
var $b5e49ecb88b9a024$var$RelativeReference = class {
    constructor(ruleName){
        this.ruleName = ruleName;
    }
    ruleName;
    kind = 2 /* RelativeReference */ ;
};
var $b5e49ecb88b9a024$var$TopLevelReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    scopeName;
    kind = 3 /* TopLevelReference */ ;
};
var $b5e49ecb88b9a024$var$TopLevelRepositoryReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    scopeName;
    ruleName;
    kind = 4 /* TopLevelRepositoryReference */ ;
};
function $b5e49ecb88b9a024$var$parseInclude(include) {
    if (include === "$base") return new $b5e49ecb88b9a024$var$BaseReference();
    else if (include === "$self") return new $b5e49ecb88b9a024$var$SelfReference();
    const indexOfSharp = include.indexOf("#");
    if (indexOfSharp === -1) return new $b5e49ecb88b9a024$var$TopLevelReference(include);
    else if (indexOfSharp === 0) return new $b5e49ecb88b9a024$var$RelativeReference(include.substring(1));
    else {
        const scopeName = include.substring(0, indexOfSharp);
        const ruleName = include.substring(indexOfSharp + 1);
        return new $b5e49ecb88b9a024$var$TopLevelRepositoryReference(scopeName, ruleName);
    }
}
// src/rule.ts
var $b5e49ecb88b9a024$var$HAS_BACK_REFERENCES = /\\(\d+)/;
var $b5e49ecb88b9a024$var$BACK_REFERENCING_END = /\\(\d+)/g;
var $b5e49ecb88b9a024$var$endRuleId = -1;
var $b5e49ecb88b9a024$var$whileRuleId = -2;
function $b5e49ecb88b9a024$var$ruleIdFromNumber(id) {
    return id;
}
function $b5e49ecb88b9a024$var$ruleIdToNumber(id) {
    return id;
}
var $b5e49ecb88b9a024$var$Rule = class {
    $location;
    id;
    _nameIsCapturing;
    _name;
    _contentNameIsCapturing;
    _contentName;
    constructor($location, id, name, contentName){
        this.$location = $location;
        this.id = id;
        this._name = name || null;
        this._nameIsCapturing = $b5e49ecb88b9a024$var$RegexSource.hasCaptures(this._name);
        this._contentName = contentName || null;
        this._contentNameIsCapturing = $b5e49ecb88b9a024$var$RegexSource.hasCaptures(this._contentName);
    }
    get debugName() {
        const location = this.$location ? `${$b5e49ecb88b9a024$var$basename(this.$location.filename)}:${this.$location.line}` : "unknown";
        return `${this.constructor.name}#${this.id} @ ${location}`;
    }
    getName(lineText, captureIndices) {
        if (!this._nameIsCapturing || this._name === null || lineText === null || captureIndices === null) return this._name;
        return $b5e49ecb88b9a024$var$RegexSource.replaceCaptures(this._name, lineText, captureIndices);
    }
    getContentName(lineText, captureIndices) {
        if (!this._contentNameIsCapturing || this._contentName === null) return this._contentName;
        return $b5e49ecb88b9a024$var$RegexSource.replaceCaptures(this._contentName, lineText, captureIndices);
    }
};
var $b5e49ecb88b9a024$var$CaptureRule = class extends $b5e49ecb88b9a024$var$Rule {
    retokenizeCapturedWithRuleId;
    constructor($location, id, name, contentName, retokenizeCapturedWithRuleId){
        super($location, id, name, contentName);
        this.retokenizeCapturedWithRuleId = retokenizeCapturedWithRuleId;
    }
    dispose() {}
    collectPatterns(grammar, out) {
        throw new Error("Not supported!");
    }
    compile(grammar, endRegexSource) {
        throw new Error("Not supported!");
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        throw new Error("Not supported!");
    }
};
var $b5e49ecb88b9a024$var$MatchRule = class extends $b5e49ecb88b9a024$var$Rule {
    _match;
    captures;
    _cachedCompiledPatterns;
    constructor($location, id, name, match, captures){
        super($location, id, name, null);
        this._match = new $b5e49ecb88b9a024$var$RegExpSource(match, this.id);
        this.captures = captures;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugMatchRegExp() {
        return `${this._match.source}`;
    }
    collectPatterns(grammar, out) {
        out.push(this._match);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $b5e49ecb88b9a024$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $b5e49ecb88b9a024$var$IncludeOnlyRule = class extends $b5e49ecb88b9a024$var$Rule {
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, patterns){
        super($location, id, name, contentName);
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    collectPatterns(grammar, out) {
        for (const pattern of this.patterns){
            const rule = grammar.getRule(pattern);
            rule.collectPatterns(grammar, out);
        }
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $b5e49ecb88b9a024$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $b5e49ecb88b9a024$var$BeginEndRule = class extends $b5e49ecb88b9a024$var$Rule {
    _begin;
    beginCaptures;
    _end;
    endHasBackReferences;
    endCaptures;
    applyEndPatternLast;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, end, endCaptures, applyEndPatternLast, patterns){
        super($location, id, name, contentName);
        this._begin = new $b5e49ecb88b9a024$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this._end = new $b5e49ecb88b9a024$var$RegExpSource(end ? end : "\uFFFF", -1);
        this.endHasBackReferences = this._end.hasBackReferences;
        this.endCaptures = endCaptures;
        this.applyEndPatternLast = applyEndPatternLast || false;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugEndRegExp() {
        return `${this._end.source}`;
    }
    getEndWithResolvedBackReferences(lineText, captureIndices) {
        return this._end.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $b5e49ecb88b9a024$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end);
            else this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
        }
        if (this._end.hasBackReferences) {
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, endRegexSource);
            else this._cachedCompiledPatterns.setSource(0, endRegexSource);
        }
        return this._cachedCompiledPatterns;
    }
};
var $b5e49ecb88b9a024$var$BeginWhileRule = class extends $b5e49ecb88b9a024$var$Rule {
    _begin;
    beginCaptures;
    whileCaptures;
    _while;
    whileHasBackReferences;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    _cachedCompiledWhilePatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, _while, whileCaptures, patterns){
        super($location, id, name, contentName);
        this._begin = new $b5e49ecb88b9a024$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this.whileCaptures = whileCaptures;
        this._while = new $b5e49ecb88b9a024$var$RegExpSource(_while, $b5e49ecb88b9a024$var$whileRuleId);
        this.whileHasBackReferences = this._while.hasBackReferences;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
        this._cachedCompiledWhilePatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
        if (this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns.dispose();
            this._cachedCompiledWhilePatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugWhileRegExp() {
        return `${this._while.source}`;
    }
    getWhileWithResolvedBackReferences(lineText, captureIndices) {
        return this._while.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $b5e49ecb88b9a024$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
        }
        return this._cachedCompiledPatterns;
    }
    compileWhile(grammar, endRegexSource) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compile(grammar);
    }
    compileWhileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledWhilePatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns = new $b5e49ecb88b9a024$var$RegExpSourceList();
            this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while);
        }
        if (this._while.hasBackReferences) this._cachedCompiledWhilePatterns.setSource(0, endRegexSource ? endRegexSource : "\uFFFF");
        return this._cachedCompiledWhilePatterns;
    }
};
var $b5e49ecb88b9a024$var$RuleFactory = class _RuleFactory {
    static createCaptureRule(helper, $location, name, contentName, retokenizeCapturedWithRuleId) {
        return helper.registerRule((id)=>{
            return new $b5e49ecb88b9a024$var$CaptureRule($location, id, name, contentName, retokenizeCapturedWithRuleId);
        });
    }
    static getCompiledRuleId(desc, helper, repository) {
        if (!desc.id) helper.registerRule((id)=>{
            desc.id = id;
            if (desc.match) return new $b5e49ecb88b9a024$var$MatchRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.match, _RuleFactory._compileCaptures(desc.captures, helper, repository));
            if (typeof desc.begin === "undefined") {
                if (desc.repository) repository = $b5e49ecb88b9a024$var$mergeObjects({}, repository, desc.repository);
                let patterns = desc.patterns;
                if (typeof patterns === "undefined" && desc.include) patterns = [
                    {
                        include: desc.include
                    }
                ];
                return new $b5e49ecb88b9a024$var$IncludeOnlyRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, _RuleFactory._compilePatterns(patterns, helper, repository));
            }
            if (desc.while) return new $b5e49ecb88b9a024$var$BeginWhileRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.while, _RuleFactory._compileCaptures(desc.whileCaptures || desc.captures, helper, repository), _RuleFactory._compilePatterns(desc.patterns, helper, repository));
            return new $b5e49ecb88b9a024$var$BeginEndRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.end, _RuleFactory._compileCaptures(desc.endCaptures || desc.captures, helper, repository), desc.applyEndPatternLast, _RuleFactory._compilePatterns(desc.patterns, helper, repository));
        });
        return desc.id;
    }
    static _compileCaptures(captures, helper, repository) {
        let r = [];
        if (captures) {
            let maximumCaptureId = 0;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                if (numericCaptureId > maximumCaptureId) maximumCaptureId = numericCaptureId;
            }
            for(let i = 0; i <= maximumCaptureId; i++)r[i] = null;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                let retokenizeCapturedWithRuleId = 0;
                if (captures[captureId].patterns) retokenizeCapturedWithRuleId = _RuleFactory.getCompiledRuleId(captures[captureId], helper, repository);
                r[numericCaptureId] = _RuleFactory.createCaptureRule(helper, captures[captureId].$vscodeTextmateLocation, captures[captureId].name, captures[captureId].contentName, retokenizeCapturedWithRuleId);
            }
        }
        return r;
    }
    static _compilePatterns(patterns, helper, repository) {
        let r = [];
        if (patterns) for(let i = 0, len = patterns.length; i < len; i++){
            const pattern = patterns[i];
            let ruleId = -1;
            if (pattern.include) {
                const reference = $b5e49ecb88b9a024$var$parseInclude(pattern.include);
                switch(reference.kind){
                    case 0 /* Base */ :
                    case 1 /* Self */ :
                        ruleId = _RuleFactory.getCompiledRuleId(repository[pattern.include], helper, repository);
                        break;
                    case 2 /* RelativeReference */ :
                        let localIncludedRule = repository[reference.ruleName];
                        if (localIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(localIncludedRule, helper, repository);
                        break;
                    case 3 /* TopLevelReference */ :
                    case 4 /* TopLevelRepositoryReference */ :
                        const externalGrammarName = reference.scopeName;
                        const externalGrammarInclude = reference.kind === 4 /* TopLevelRepositoryReference */  ? reference.ruleName : null;
                        const externalGrammar = helper.getExternalGrammar(externalGrammarName, repository);
                        if (externalGrammar) {
                            if (externalGrammarInclude) {
                                let externalIncludedRule = externalGrammar.repository[externalGrammarInclude];
                                if (externalIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(externalIncludedRule, helper, externalGrammar.repository);
                            } else ruleId = _RuleFactory.getCompiledRuleId(externalGrammar.repository.$self, helper, externalGrammar.repository);
                        } else ;
                        break;
                }
            } else ruleId = _RuleFactory.getCompiledRuleId(pattern, helper, repository);
            if (ruleId !== -1) {
                const rule = helper.getRule(ruleId);
                let skipRule = false;
                if (rule instanceof $b5e49ecb88b9a024$var$IncludeOnlyRule || rule instanceof $b5e49ecb88b9a024$var$BeginEndRule || rule instanceof $b5e49ecb88b9a024$var$BeginWhileRule) {
                    if (rule.hasMissingPatterns && rule.patterns.length === 0) skipRule = true;
                }
                if (skipRule) continue;
                r.push(ruleId);
            }
        }
        return {
            patterns: r,
            hasMissingPatterns: (patterns ? patterns.length : 0) !== r.length
        };
    }
};
var $b5e49ecb88b9a024$var$RegExpSource = class _RegExpSource {
    source;
    ruleId;
    hasAnchor;
    hasBackReferences;
    _anchorCache;
    constructor(regExpSource, ruleId){
        if (regExpSource && typeof regExpSource === "string") {
            const len = regExpSource.length;
            let lastPushedPos = 0;
            let output = [];
            let hasAnchor = false;
            for(let pos = 0; pos < len; pos++){
                const ch = regExpSource.charAt(pos);
                if (ch === "\\") {
                    if (pos + 1 < len) {
                        const nextCh = regExpSource.charAt(pos + 1);
                        if (nextCh === "z") {
                            output.push(regExpSource.substring(lastPushedPos, pos));
                            output.push("$(?!\\n)(?<!\\n)");
                            lastPushedPos = pos + 2;
                        } else if (nextCh === "A" || nextCh === "G") hasAnchor = true;
                        pos++;
                    }
                }
            }
            this.hasAnchor = hasAnchor;
            if (lastPushedPos === 0) this.source = regExpSource;
            else {
                output.push(regExpSource.substring(lastPushedPos, len));
                this.source = output.join("");
            }
        } else {
            this.hasAnchor = false;
            this.source = regExpSource;
        }
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
        else this._anchorCache = null;
        this.ruleId = ruleId;
        if (typeof this.source === "string") this.hasBackReferences = $b5e49ecb88b9a024$var$HAS_BACK_REFERENCES.test(this.source);
        else this.hasBackReferences = false;
    }
    clone() {
        return new _RegExpSource(this.source, this.ruleId);
    }
    setSource(newSource) {
        if (this.source === newSource) return;
        this.source = newSource;
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
    }
    resolveBackReferences(lineText, captureIndices) {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let capturedValues = captureIndices.map((capture)=>{
            return lineText.substring(capture.start, capture.end);
        });
        $b5e49ecb88b9a024$var$BACK_REFERENCING_END.lastIndex = 0;
        return this.source.replace($b5e49ecb88b9a024$var$BACK_REFERENCING_END, (match, g1)=>{
            return $b5e49ecb88b9a024$var$escapeRegExpCharacters(capturedValues[parseInt(g1, 10)] || "");
        });
    }
    _buildAnchorCache() {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let A0_G0_result = [];
        let A0_G1_result = [];
        let A1_G0_result = [];
        let A1_G1_result = [];
        let pos, len, ch, nextCh;
        for(pos = 0, len = this.source.length; pos < len; pos++){
            ch = this.source.charAt(pos);
            A0_G0_result[pos] = ch;
            A0_G1_result[pos] = ch;
            A1_G0_result[pos] = ch;
            A1_G1_result[pos] = ch;
            if (ch === "\\") {
                if (pos + 1 < len) {
                    nextCh = this.source.charAt(pos + 1);
                    if (nextCh === "A") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "\uFFFF";
                        A1_G0_result[pos + 1] = "A";
                        A1_G1_result[pos + 1] = "A";
                    } else if (nextCh === "G") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "G";
                        A1_G0_result[pos + 1] = "\uFFFF";
                        A1_G1_result[pos + 1] = "G";
                    } else {
                        A0_G0_result[pos + 1] = nextCh;
                        A0_G1_result[pos + 1] = nextCh;
                        A1_G0_result[pos + 1] = nextCh;
                        A1_G1_result[pos + 1] = nextCh;
                    }
                    pos++;
                }
            }
        }
        return {
            A0_G0: A0_G0_result.join(""),
            A0_G1: A0_G1_result.join(""),
            A1_G0: A1_G0_result.join(""),
            A1_G1: A1_G1_result.join("")
        };
    }
    resolveAnchors(allowA, allowG) {
        if (!this.hasAnchor || !this._anchorCache || typeof this.source !== "string") return this.source;
        if (allowA) {
            if (allowG) return this._anchorCache.A1_G1;
            else return this._anchorCache.A1_G0;
        } else {
            if (allowG) return this._anchorCache.A0_G1;
            else return this._anchorCache.A0_G0;
        }
    }
};
var $b5e49ecb88b9a024$var$RegExpSourceList = class {
    _items;
    _hasAnchors;
    _cached;
    _anchorCache;
    constructor(){
        this._items = [];
        this._hasAnchors = false;
        this._cached = null;
        this._anchorCache = {
            A0_G0: null,
            A0_G1: null,
            A1_G0: null,
            A1_G1: null
        };
    }
    dispose() {
        this._disposeCaches();
    }
    _disposeCaches() {
        if (this._cached) {
            this._cached.dispose();
            this._cached = null;
        }
        if (this._anchorCache.A0_G0) {
            this._anchorCache.A0_G0.dispose();
            this._anchorCache.A0_G0 = null;
        }
        if (this._anchorCache.A0_G1) {
            this._anchorCache.A0_G1.dispose();
            this._anchorCache.A0_G1 = null;
        }
        if (this._anchorCache.A1_G0) {
            this._anchorCache.A1_G0.dispose();
            this._anchorCache.A1_G0 = null;
        }
        if (this._anchorCache.A1_G1) {
            this._anchorCache.A1_G1.dispose();
            this._anchorCache.A1_G1 = null;
        }
    }
    push(item) {
        this._items.push(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    unshift(item) {
        this._items.unshift(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    length() {
        return this._items.length;
    }
    setSource(index, newSource) {
        if (this._items[index].source !== newSource) {
            this._disposeCaches();
            this._items[index].setSource(newSource);
        }
    }
    compile(onigLib) {
        if (!this._cached) {
            let regExps = this._items.map((e)=>e.source);
            this._cached = new $b5e49ecb88b9a024$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
        }
        return this._cached;
    }
    compileAG(onigLib, allowA, allowG) {
        if (!this._hasAnchors) return this.compile(onigLib);
        else {
            if (allowA) {
                if (allowG) {
                    if (!this._anchorCache.A1_G1) this._anchorCache.A1_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G1;
                } else {
                    if (!this._anchorCache.A1_G0) this._anchorCache.A1_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G0;
                }
            } else if (allowG) {
                if (!this._anchorCache.A0_G1) this._anchorCache.A0_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G1;
            } else {
                if (!this._anchorCache.A0_G0) this._anchorCache.A0_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G0;
            }
        }
    }
    _resolveAnchors(onigLib, allowA, allowG) {
        let regExps = this._items.map((e)=>e.resolveAnchors(allowA, allowG));
        return new $b5e49ecb88b9a024$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
    }
};
var $b5e49ecb88b9a024$var$CompiledRule = class {
    constructor(onigLib, regExps, rules){
        this.regExps = regExps;
        this.rules = rules;
        this.scanner = onigLib.createOnigScanner(regExps);
    }
    regExps;
    rules;
    scanner;
    dispose() {
        if (typeof this.scanner.dispose === "function") this.scanner.dispose();
    }
    toString() {
        const r = [];
        for(let i = 0, len = this.rules.length; i < len; i++)r.push("   - " + this.rules[i] + ": " + this.regExps[i]);
        return r.join("\n");
    }
    findNextMatchSync(string, startPosition, options) {
        const result = this.scanner.findNextMatchSync(string, startPosition, options);
        if (!result) return null;
        return {
            ruleId: this.rules[result.index],
            captureIndices: result.captureIndices
        };
    }
};
// src/grammar/basicScopesAttributeProvider.ts
var $b5e49ecb88b9a024$var$BasicScopeAttributes = class {
    constructor(languageId, tokenType){
        this.languageId = languageId;
        this.tokenType = tokenType;
    }
    languageId;
    tokenType;
};
var $b5e49ecb88b9a024$var$BasicScopeAttributesProvider = class _BasicScopeAttributesProvider {
    _defaultAttributes;
    _embeddedLanguagesMatcher;
    constructor(initialLanguageId, embeddedLanguages){
        this._defaultAttributes = new $b5e49ecb88b9a024$var$BasicScopeAttributes(initialLanguageId, 8 /* NotSet */ );
        this._embeddedLanguagesMatcher = new $b5e49ecb88b9a024$var$ScopeMatcher(Object.entries(embeddedLanguages || {}));
    }
    getDefaultAttributes() {
        return this._defaultAttributes;
    }
    getBasicScopeAttributes(scopeName) {
        if (scopeName === null) return _BasicScopeAttributesProvider._NULL_SCOPE_METADATA;
        return this._getBasicScopeAttributes.get(scopeName);
    }
    static _NULL_SCOPE_METADATA = new $b5e49ecb88b9a024$var$BasicScopeAttributes(0, 0);
    _getBasicScopeAttributes = new $b5e49ecb88b9a024$var$CachedFn((scopeName)=>{
        const languageId = this._scopeToLanguage(scopeName);
        const standardTokenType = this._toStandardTokenType(scopeName);
        return new $b5e49ecb88b9a024$var$BasicScopeAttributes(languageId, standardTokenType);
    });
    /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */ _scopeToLanguage(scope) {
        return this._embeddedLanguagesMatcher.match(scope) || 0;
    }
    _toStandardTokenType(scopeName) {
        const m = scopeName.match(_BasicScopeAttributesProvider.STANDARD_TOKEN_TYPE_REGEXP);
        if (!m) return 8 /* NotSet */ ;
        switch(m[1]){
            case "comment":
                return 1 /* Comment */ ;
            case "string":
                return 2 /* String */ ;
            case "regex":
                return 3 /* RegEx */ ;
            case "meta.embedded":
                return 0 /* Other */ ;
        }
        throw new Error("Unexpected match for standard token type!");
    }
    static STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|meta\.embedded)\b/;
};
var $b5e49ecb88b9a024$var$ScopeMatcher = class {
    values;
    scopesRegExp;
    constructor(values){
        if (values.length === 0) {
            this.values = null;
            this.scopesRegExp = null;
        } else {
            this.values = new Map(values);
            const escapedScopes = values.map(([scopeName, value])=>$b5e49ecb88b9a024$var$escapeRegExpCharacters(scopeName));
            escapedScopes.sort();
            escapedScopes.reverse();
            this.scopesRegExp = new RegExp(`^((${escapedScopes.join(")|(")}))($|\\.)`, "");
        }
    }
    match(scope) {
        if (!this.scopesRegExp) return void 0;
        const m = scope.match(this.scopesRegExp);
        if (!m) return void 0;
        return this.values.get(m[1]);
    }
};
// src/debug.ts
var $b5e49ecb88b9a024$var$DebugFlags = {
    InDebugMode: false
};
var $b5e49ecb88b9a024$var$UseOnigurumaFindOptions = false;
// src/grammar/tokenizeString.ts
var $b5e49ecb88b9a024$var$TokenizeStringResult = class {
    constructor(stack, stoppedEarly){
        this.stack = stack;
        this.stoppedEarly = stoppedEarly;
    }
    stack;
    stoppedEarly;
};
function $b5e49ecb88b9a024$var$_tokenizeString(grammar, lineText, isFirstLine, linePos, stack, lineTokens, checkWhileConditions, timeLimit) {
    const lineLength = lineText.content.length;
    let STOP = false;
    let anchorPosition = -1;
    if (checkWhileConditions) {
        const whileCheckResult = $b5e49ecb88b9a024$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens);
        stack = whileCheckResult.stack;
        linePos = whileCheckResult.linePos;
        isFirstLine = whileCheckResult.isFirstLine;
        anchorPosition = whileCheckResult.anchorPosition;
    }
    const startTime = Date.now();
    while(!STOP){
        if (timeLimit !== 0) {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime > timeLimit) return new $b5e49ecb88b9a024$var$TokenizeStringResult(stack, true);
        }
        scanNext();
    }
    return new $b5e49ecb88b9a024$var$TokenizeStringResult(stack, false);
    function scanNext() {
        const r = $b5e49ecb88b9a024$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
        if (!r) {
            lineTokens.produce(stack, lineLength);
            STOP = true;
            return;
        }
        const captureIndices = r.captureIndices;
        const matchedRuleId = r.matchedRuleId;
        const hasAdvanced = captureIndices && captureIndices.length > 0 ? captureIndices[0].end > linePos : false;
        if (matchedRuleId === $b5e49ecb88b9a024$var$endRuleId) {
            const poppedRule = stack.getRule(grammar);
            lineTokens.produce(stack, captureIndices[0].start);
            stack = stack.withContentNameScopesList(stack.nameScopesList);
            $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, poppedRule.endCaptures, captureIndices);
            lineTokens.produce(stack, captureIndices[0].end);
            const popped = stack;
            stack = stack.parent;
            anchorPosition = popped.getAnchorPos();
            if (!hasAdvanced && popped.getEnterPos() === linePos) {
                stack = popped;
                lineTokens.produce(stack, lineLength);
                STOP = true;
                return;
            }
        } else {
            const _rule = grammar.getRule(matchedRuleId);
            lineTokens.produce(stack, captureIndices[0].start);
            const beforePush = stack;
            const scopeName = _rule.getName(lineText.content, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            stack = stack.push(matchedRuleId, linePos, anchorPosition, captureIndices[0].end === lineLength, null, nameScopesList, nameScopesList);
            if (_rule instanceof $b5e49ecb88b9a024$var$BeginEndRule) {
                const pushedRule = _rule;
                $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.endHasBackReferences) stack = stack.withEndRule(pushedRule.getEndWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else if (_rule instanceof $b5e49ecb88b9a024$var$BeginWhileRule) {
                const pushedRule = _rule;
                $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.whileHasBackReferences) stack = stack.withEndRule(pushedRule.getWhileWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else {
                const matchingRule = _rule;
                $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, matchingRule.captures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                stack = stack.pop();
                if (!hasAdvanced) {
                    stack = stack.safePop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            }
        }
        if (captureIndices[0].end > linePos) {
            linePos = captureIndices[0].end;
            isFirstLine = false;
        }
    }
}
function $b5e49ecb88b9a024$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens) {
    let anchorPosition = stack.beginRuleCapturedEOL ? 0 : -1;
    const whileRules = [];
    for(let node = stack; node; node = node.pop()){
        const nodeRule = node.getRule(grammar);
        if (nodeRule instanceof $b5e49ecb88b9a024$var$BeginWhileRule) whileRules.push({
            rule: nodeRule,
            stack: node
        });
    }
    for(let whileRule = whileRules.pop(); whileRule; whileRule = whileRules.pop()){
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $b5e49ecb88b9a024$var$prepareRuleWhileSearch(whileRule.rule, grammar, whileRule.stack.endRule, isFirstLine, linePos === anchorPosition);
        const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (r) {
            const matchedRuleId = r.ruleId;
            if (matchedRuleId !== $b5e49ecb88b9a024$var$whileRuleId) {
                stack = whileRule.stack.pop();
                break;
            }
            if (r.captureIndices && r.captureIndices.length) {
                lineTokens.produce(whileRule.stack, r.captureIndices[0].start);
                $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, whileRule.stack, lineTokens, whileRule.rule.whileCaptures, r.captureIndices);
                lineTokens.produce(whileRule.stack, r.captureIndices[0].end);
                anchorPosition = r.captureIndices[0].end;
                if (r.captureIndices[0].end > linePos) {
                    linePos = r.captureIndices[0].end;
                    isFirstLine = false;
                }
            }
        } else {
            stack = whileRule.stack.pop();
            break;
        }
    }
    return {
        stack: stack,
        linePos: linePos,
        anchorPosition: anchorPosition,
        isFirstLine: isFirstLine
    };
}
function $b5e49ecb88b9a024$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const matchResult = $b5e49ecb88b9a024$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    const injections = grammar.getInjections();
    if (injections.length === 0) return matchResult;
    const injectionResult = $b5e49ecb88b9a024$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    if (!injectionResult) return matchResult;
    if (!matchResult) return injectionResult;
    const matchResultScore = matchResult.captureIndices[0].start;
    const injectionResultScore = injectionResult.captureIndices[0].start;
    if (injectionResultScore < matchResultScore || injectionResult.priorityMatch && injectionResultScore === matchResultScore) return injectionResult;
    return matchResult;
}
function $b5e49ecb88b9a024$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const rule = stack.getRule(grammar);
    const { ruleScanner: ruleScanner, findOptions: findOptions } = $b5e49ecb88b9a024$var$prepareRuleSearch(rule, grammar, stack.endRule, isFirstLine, linePos === anchorPosition);
    const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
    if (r) return {
        captureIndices: r.captureIndices,
        matchedRuleId: r.ruleId
    };
    return null;
}
function $b5e49ecb88b9a024$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    let bestMatchRating = Number.MAX_VALUE;
    let bestMatchCaptureIndices = null;
    let bestMatchRuleId;
    let bestMatchResultPriority = 0;
    const scopes = stack.contentNameScopesList.getScopeNames();
    for(let i = 0, len = injections.length; i < len; i++){
        const injection = injections[i];
        if (!injection.matcher(scopes)) continue;
        const rule = grammar.getRule(injection.ruleId);
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $b5e49ecb88b9a024$var$prepareRuleSearch(rule, grammar, null, isFirstLine, linePos === anchorPosition);
        const matchResult = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (!matchResult) continue;
        const matchRating = matchResult.captureIndices[0].start;
        if (matchRating >= bestMatchRating) continue;
        bestMatchRating = matchRating;
        bestMatchCaptureIndices = matchResult.captureIndices;
        bestMatchRuleId = matchResult.ruleId;
        bestMatchResultPriority = injection.priority;
        if (bestMatchRating === linePos) break;
    }
    if (bestMatchCaptureIndices) return {
        priorityMatch: bestMatchResultPriority === -1,
        captureIndices: bestMatchCaptureIndices,
        matchedRuleId: bestMatchRuleId
    };
    return null;
}
function $b5e49ecb88b9a024$var$prepareRuleSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($b5e49ecb88b9a024$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compile(grammar, endRegexSource);
        const findOptions = $b5e49ecb88b9a024$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $b5e49ecb88b9a024$var$prepareRuleWhileSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($b5e49ecb88b9a024$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compileWhile(grammar, endRegexSource);
        const findOptions = $b5e49ecb88b9a024$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileWhileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $b5e49ecb88b9a024$var$getFindOptions(allowA, allowG) {
    let options = 0 /* None */ ;
    if (!allowA) options |= 1 /* NotBeginString */ ;
    if (!allowG) options |= 4 /* NotBeginPosition */ ;
    return options;
}
function $b5e49ecb88b9a024$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, captures, captureIndices) {
    if (captures.length === 0) return;
    const lineTextContent = lineText.content;
    const len = Math.min(captures.length, captureIndices.length);
    const localStack = [];
    const maxEnd = captureIndices[0].end;
    for(let i = 0; i < len; i++){
        const captureRule = captures[i];
        if (captureRule === null) continue;
        const captureIndex = captureIndices[i];
        if (captureIndex.length === 0) continue;
        if (captureIndex.start > maxEnd) break;
        while(localStack.length > 0 && localStack[localStack.length - 1].endPos <= captureIndex.start){
            lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
            localStack.pop();
        }
        if (localStack.length > 0) lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, captureIndex.start);
        else lineTokens.produce(stack, captureIndex.start);
        if (captureRule.retokenizeCapturedWithRuleId) {
            const scopeName = captureRule.getName(lineTextContent, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            const contentName = captureRule.getContentName(lineTextContent, captureIndices);
            const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
            const stackClone = stack.push(captureRule.retokenizeCapturedWithRuleId, captureIndex.start, -1, false, null, nameScopesList, contentNameScopesList);
            const onigSubStr = grammar.createOnigString(lineTextContent.substring(0, captureIndex.end));
            $b5e49ecb88b9a024$var$_tokenizeString(grammar, onigSubStr, isFirstLine && captureIndex.start === 0, captureIndex.start, stackClone, lineTokens, false, /* no time limit */ 0);
            $b5e49ecb88b9a024$export$2b6cad23a17023a7(onigSubStr);
            continue;
        }
        const captureRuleScopeName = captureRule.getName(lineTextContent, captureIndices);
        if (captureRuleScopeName !== null) {
            const base = localStack.length > 0 ? localStack[localStack.length - 1].scopes : stack.contentNameScopesList;
            const captureRuleScopesList = base.pushAttributed(captureRuleScopeName, grammar);
            localStack.push(new $b5e49ecb88b9a024$var$LocalStackElement(captureRuleScopesList, captureIndex.end));
        }
    }
    while(localStack.length > 0){
        lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
        localStack.pop();
    }
}
var $b5e49ecb88b9a024$var$LocalStackElement = class {
    scopes;
    endPos;
    constructor(scopes, endPos){
        this.scopes = scopes;
        this.endPos = endPos;
    }
};
// src/grammar/grammar.ts
function $b5e49ecb88b9a024$var$createGrammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib) {
    return new $b5e49ecb88b9a024$var$Grammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib);
}
function $b5e49ecb88b9a024$var$collectInjections(result, selector, rule, ruleFactoryHelper, grammar) {
    const matchers = $b5e49ecb88b9a024$var$createMatchers(selector, $b5e49ecb88b9a024$var$nameMatcher);
    const ruleId = $b5e49ecb88b9a024$var$RuleFactory.getCompiledRuleId(rule, ruleFactoryHelper, grammar.repository);
    for (const matcher of matchers)result.push({
        debugSelector: selector,
        matcher: matcher.matcher,
        ruleId: ruleId,
        grammar: grammar,
        priority: matcher.priority
    });
}
function $b5e49ecb88b9a024$var$nameMatcher(identifers, scopes) {
    if (scopes.length < identifers.length) return false;
    let lastIndex = 0;
    return identifers.every((identifier)=>{
        for(let i = lastIndex; i < scopes.length; i++)if ($b5e49ecb88b9a024$var$scopesAreMatching(scopes[i], identifier)) {
            lastIndex = i + 1;
            return true;
        }
        return false;
    });
}
function $b5e49ecb88b9a024$var$scopesAreMatching(thisScopeName, scopeName) {
    if (!thisScopeName) return false;
    if (thisScopeName === scopeName) return true;
    const len = scopeName.length;
    return thisScopeName.length > len && thisScopeName.substr(0, len) === scopeName && thisScopeName[len] === ".";
}
var $b5e49ecb88b9a024$var$Grammar = class {
    constructor(_rootScopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, _onigLib){
        this._rootScopeName = _rootScopeName;
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._onigLib = _onigLib;
        this._basicScopeAttributesProvider = new $b5e49ecb88b9a024$var$BasicScopeAttributesProvider(initialLanguage, embeddedLanguages);
        this._rootId = -1;
        this._lastRuleId = 0;
        this._ruleId2desc = [
            null
        ];
        this._includedGrammars = {};
        this._grammarRepository = grammarRepository;
        this._grammar = $b5e49ecb88b9a024$var$initGrammar(grammar, null);
        this._injections = null;
        this._tokenTypeMatchers = [];
        if (tokenTypes) for (const selector of Object.keys(tokenTypes)){
            const matchers = $b5e49ecb88b9a024$var$createMatchers(selector, $b5e49ecb88b9a024$var$nameMatcher);
            for (const matcher of matchers)this._tokenTypeMatchers.push({
                matcher: matcher.matcher,
                type: tokenTypes[selector]
            });
        }
    }
    _rootScopeName;
    balancedBracketSelectors;
    _onigLib;
    _rootId;
    _lastRuleId;
    _ruleId2desc;
    _includedGrammars;
    _grammarRepository;
    _grammar;
    _injections;
    _basicScopeAttributesProvider;
    _tokenTypeMatchers;
    get themeProvider() {
        return this._grammarRepository;
    }
    dispose() {
        for (const rule of this._ruleId2desc)if (rule) rule.dispose();
    }
    createOnigScanner(sources) {
        return this._onigLib.createOnigScanner(sources);
    }
    createOnigString(sources) {
        return this._onigLib.createOnigString(sources);
    }
    getMetadataForScope(scope) {
        return this._basicScopeAttributesProvider.getBasicScopeAttributes(scope);
    }
    _collectInjections() {
        const grammarRepository = {
            lookup: (scopeName2)=>{
                if (scopeName2 === this._rootScopeName) return this._grammar;
                return this.getExternalGrammar(scopeName2);
            },
            injections: (scopeName2)=>{
                return this._grammarRepository.injections(scopeName2);
            }
        };
        const result = [];
        const scopeName = this._rootScopeName;
        const grammar = grammarRepository.lookup(scopeName);
        if (grammar) {
            const rawInjections = grammar.injections;
            if (rawInjections) for(let expression in rawInjections)$b5e49ecb88b9a024$var$collectInjections(result, expression, rawInjections[expression], this, grammar);
            const injectionScopeNames = this._grammarRepository.injections(scopeName);
            if (injectionScopeNames) injectionScopeNames.forEach((injectionScopeName)=>{
                const injectionGrammar = this.getExternalGrammar(injectionScopeName);
                if (injectionGrammar) {
                    const selector = injectionGrammar.injectionSelector;
                    if (selector) $b5e49ecb88b9a024$var$collectInjections(result, selector, injectionGrammar, this, injectionGrammar);
                }
            });
        }
        result.sort((i1, i2)=>i1.priority - i2.priority);
        return result;
    }
    getInjections() {
        if (this._injections === null) this._injections = this._collectInjections();
        return this._injections;
    }
    registerRule(factory) {
        const id = ++this._lastRuleId;
        const result = factory($b5e49ecb88b9a024$var$ruleIdFromNumber(id));
        this._ruleId2desc[id] = result;
        return result;
    }
    getRule(ruleId) {
        return this._ruleId2desc[$b5e49ecb88b9a024$var$ruleIdToNumber(ruleId)];
    }
    getExternalGrammar(scopeName, repository) {
        if (this._includedGrammars[scopeName]) return this._includedGrammars[scopeName];
        else if (this._grammarRepository) {
            const rawIncludedGrammar = this._grammarRepository.lookup(scopeName);
            if (rawIncludedGrammar) {
                this._includedGrammars[scopeName] = $b5e49ecb88b9a024$var$initGrammar(rawIncludedGrammar, repository && repository.$base);
                return this._includedGrammars[scopeName];
            }
        }
        return void 0;
    }
    tokenizeLine(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, false, timeLimit);
        return {
            tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    tokenizeLine2(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, true, timeLimit);
        return {
            tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    _tokenize(lineText, prevState, emitBinaryTokens, timeLimit) {
        if (this._rootId === -1) {
            this._rootId = $b5e49ecb88b9a024$var$RuleFactory.getCompiledRuleId(this._grammar.repository.$self, this, this._grammar.repository);
            this.getInjections();
        }
        let isFirstLine;
        if (!prevState || prevState === $b5e49ecb88b9a024$var$StateStackImpl.NULL) {
            isFirstLine = true;
            const rawDefaultMetadata = this._basicScopeAttributesProvider.getDefaultAttributes();
            const defaultStyle = this.themeProvider.getDefaults();
            const defaultMetadata = $b5e49ecb88b9a024$export$90e5db14803ea047.set(0, rawDefaultMetadata.languageId, rawDefaultMetadata.tokenType, null, defaultStyle.fontStyle, defaultStyle.foregroundId, defaultStyle.backgroundId);
            const rootScopeName = this.getRule(this._rootId).getName(null, null);
            let scopeList;
            if (rootScopeName) scopeList = $b5e49ecb88b9a024$var$AttributedScopeStack.createRootAndLookUpScopeName(rootScopeName, defaultMetadata, this);
            else scopeList = $b5e49ecb88b9a024$var$AttributedScopeStack.createRoot("unknown", defaultMetadata);
            prevState = new $b5e49ecb88b9a024$var$StateStackImpl(null, this._rootId, -1, -1, false, null, scopeList, scopeList);
        } else {
            isFirstLine = false;
            prevState.reset();
        }
        lineText = lineText + "\n";
        const onigLineText = this.createOnigString(lineText);
        const lineLength = onigLineText.content.length;
        const lineTokens = new $b5e49ecb88b9a024$var$LineTokens(emitBinaryTokens, lineText, this._tokenTypeMatchers, this.balancedBracketSelectors);
        const r = $b5e49ecb88b9a024$var$_tokenizeString(this, onigLineText, isFirstLine, 0, prevState, lineTokens, true, timeLimit);
        $b5e49ecb88b9a024$export$2b6cad23a17023a7(onigLineText);
        return {
            lineLength: lineLength,
            lineTokens: lineTokens,
            ruleStack: r.stack,
            stoppedEarly: r.stoppedEarly
        };
    }
};
function $b5e49ecb88b9a024$var$initGrammar(grammar, base) {
    grammar = $b5e49ecb88b9a024$var$clone(grammar);
    grammar.repository = grammar.repository || {};
    grammar.repository.$self = {
        $vscodeTextmateLocation: grammar.$vscodeTextmateLocation,
        patterns: grammar.patterns,
        name: grammar.scopeName
    };
    grammar.repository.$base = base || grammar.repository.$self;
    return grammar;
}
var $b5e49ecb88b9a024$var$AttributedScopeStack = class _AttributedScopeStack {
    /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, scopePath, tokenAttributes){
        this.parent = parent;
        this.scopePath = scopePath;
        this.tokenAttributes = tokenAttributes;
    }
    parent;
    scopePath;
    tokenAttributes;
    static fromExtension(namesScopeList, contentNameScopesList) {
        let current = namesScopeList;
        let scopeNames = namesScopeList?.scopePath ?? null;
        for (const frame of contentNameScopesList){
            scopeNames = $b5e49ecb88b9a024$var$ScopeStack.push(scopeNames, frame.scopeNames);
            current = new _AttributedScopeStack(current, scopeNames, frame.encodedTokenAttributes);
        }
        return current;
    }
    static createRoot(scopeName, tokenAttributes) {
        return new _AttributedScopeStack(null, new $b5e49ecb88b9a024$var$ScopeStack(null, scopeName), tokenAttributes);
    }
    static createRootAndLookUpScopeName(scopeName, tokenAttributes, grammar) {
        const rawRootMetadata = grammar.getMetadataForScope(scopeName);
        const scopePath = new $b5e49ecb88b9a024$var$ScopeStack(null, scopeName);
        const rootStyle = grammar.themeProvider.themeMatch(scopePath);
        const resolvedTokenAttributes = _AttributedScopeStack.mergeAttributes(tokenAttributes, rawRootMetadata, rootStyle);
        return new _AttributedScopeStack(null, scopePath, resolvedTokenAttributes);
    }
    get scopeName() {
        return this.scopePath.scopeName;
    }
    toString() {
        return this.getScopeNames().join(" ");
    }
    equals(other) {
        return _AttributedScopeStack.equals(this, other);
    }
    static equals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.scopeName !== b.scopeName || a.tokenAttributes !== b.tokenAttributes) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    static mergeAttributes(existingTokenAttributes, basicScopeAttributes, styleAttributes) {
        let fontStyle = -1 /* NotSet */ ;
        let foreground = 0;
        let background = 0;
        if (styleAttributes !== null) {
            fontStyle = styleAttributes.fontStyle;
            foreground = styleAttributes.foregroundId;
            background = styleAttributes.backgroundId;
        }
        return $b5e49ecb88b9a024$export$90e5db14803ea047.set(existingTokenAttributes, basicScopeAttributes.languageId, basicScopeAttributes.tokenType, null, fontStyle, foreground, background);
    }
    pushAttributed(scopePath, grammar) {
        if (scopePath === null) return this;
        if (scopePath.indexOf(" ") === -1) return _AttributedScopeStack._pushAttributed(this, scopePath, grammar);
        const scopes = scopePath.split(/ /g);
        let result = this;
        for (const scope of scopes)result = _AttributedScopeStack._pushAttributed(result, scope, grammar);
        return result;
    }
    static _pushAttributed(target, scopeName, grammar) {
        const rawMetadata = grammar.getMetadataForScope(scopeName);
        const newPath = target.scopePath.push(scopeName);
        const scopeThemeMatchResult = grammar.themeProvider.themeMatch(newPath);
        const metadata = _AttributedScopeStack.mergeAttributes(target.tokenAttributes, rawMetadata, scopeThemeMatchResult);
        return new _AttributedScopeStack(target, newPath, metadata);
    }
    getScopeNames() {
        return this.scopePath.getSegments();
    }
    getExtensionIfDefined(base) {
        const result = [];
        let self = this;
        while(self && self !== base){
            result.push({
                encodedTokenAttributes: self.tokenAttributes,
                scopeNames: self.scopePath.getExtensionIfDefined(self.parent?.scopePath ?? null)
            });
            self = self.parent;
        }
        return self === base ? result.reverse() : void 0;
    }
};
var $b5e49ecb88b9a024$var$StateStackImpl = class _StateStackImpl {
    /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList){
        this.parent = parent;
        this.ruleId = ruleId;
        this.beginRuleCapturedEOL = beginRuleCapturedEOL;
        this.endRule = endRule;
        this.nameScopesList = nameScopesList;
        this.contentNameScopesList = contentNameScopesList;
        this.depth = this.parent ? this.parent.depth + 1 : 1;
        this._enterPos = enterPos;
        this._anchorPos = anchorPos;
    }
    parent;
    ruleId;
    beginRuleCapturedEOL;
    endRule;
    nameScopesList;
    contentNameScopesList;
    _stackElementBrand = void 0;
    // TODO remove me
    static NULL = new _StateStackImpl(null, 0, 0, 0, false, null, null, null);
    /**
   * The position on the current line where this state was pushed.
   * This is relevant only while tokenizing a line, to detect endless loops.
   * Its value is meaningless across lines.
   */ _enterPos;
    /**
   * The captured anchor position when this stack element was pushed.
   * This is relevant only while tokenizing a line, to restore the anchor position when popping.
   * Its value is meaningless across lines.
   */ _anchorPos;
    /**
   * The depth of the stack.
   */ depth;
    equals(other) {
        if (other === null) return false;
        return _StateStackImpl._equals(this, other);
    }
    static _equals(a, b) {
        if (a === b) return true;
        if (!this._structuralEquals(a, b)) return false;
        return $b5e49ecb88b9a024$var$AttributedScopeStack.equals(a.contentNameScopesList, b.contentNameScopesList);
    }
    /**
   * A structural equals check. Does not take into account `scopes`.
   */ static _structuralEquals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.depth !== b.depth || a.ruleId !== b.ruleId || a.endRule !== b.endRule) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    clone() {
        return this;
    }
    static _reset(el) {
        while(el){
            el._enterPos = -1;
            el._anchorPos = -1;
            el = el.parent;
        }
    }
    reset() {
        _StateStackImpl._reset(this);
    }
    pop() {
        return this.parent;
    }
    safePop() {
        if (this.parent) return this.parent;
        return this;
    }
    push(ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList) {
        return new _StateStackImpl(this, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList);
    }
    getEnterPos() {
        return this._enterPos;
    }
    getAnchorPos() {
        return this._anchorPos;
    }
    getRule(grammar) {
        return grammar.getRule(this.ruleId);
    }
    toString() {
        const r = [];
        this._writeString(r, 0);
        return "[" + r.join(",") + "]";
    }
    _writeString(res, outIndex) {
        if (this.parent) outIndex = this.parent._writeString(res, outIndex);
        res[outIndex++] = `(${this.ruleId}, ${this.nameScopesList?.toString()}, ${this.contentNameScopesList?.toString()})`;
        return outIndex;
    }
    withContentNameScopesList(contentNameScopeStack) {
        if (this.contentNameScopesList === contentNameScopeStack) return this;
        return this.parent.push(this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, this.endRule, this.nameScopesList, contentNameScopeStack);
    }
    withEndRule(endRule) {
        if (this.endRule === endRule) return this;
        return new _StateStackImpl(this.parent, this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, endRule, this.nameScopesList, this.contentNameScopesList);
    }
    // Used to warn of endless loops
    hasSameRuleAs(other) {
        let el = this;
        while(el && el._enterPos === other._enterPos){
            if (el.ruleId === other.ruleId) return true;
            el = el.parent;
        }
        return false;
    }
    toStateStackFrame() {
        return {
            ruleId: $b5e49ecb88b9a024$var$ruleIdToNumber(this.ruleId),
            beginRuleCapturedEOL: this.beginRuleCapturedEOL,
            endRule: this.endRule,
            nameScopesList: this.nameScopesList?.getExtensionIfDefined(this.parent?.nameScopesList ?? null) ?? [],
            contentNameScopesList: this.contentNameScopesList?.getExtensionIfDefined(this.nameScopesList) ?? []
        };
    }
    static pushFrame(self, frame) {
        const namesScopeList = $b5e49ecb88b9a024$var$AttributedScopeStack.fromExtension(self?.nameScopesList ?? null, frame.nameScopesList);
        return new _StateStackImpl(self, $b5e49ecb88b9a024$var$ruleIdFromNumber(frame.ruleId), frame.enterPos ?? -1, frame.anchorPos ?? -1, frame.beginRuleCapturedEOL, frame.endRule, namesScopeList, $b5e49ecb88b9a024$var$AttributedScopeStack.fromExtension(namesScopeList, frame.contentNameScopesList));
    }
};
var $b5e49ecb88b9a024$var$BalancedBracketSelectors = class {
    balancedBracketScopes;
    unbalancedBracketScopes;
    allowAny = false;
    constructor(balancedBracketScopes, unbalancedBracketScopes){
        this.balancedBracketScopes = balancedBracketScopes.flatMap((selector)=>{
            if (selector === "*") {
                this.allowAny = true;
                return [];
            }
            return $b5e49ecb88b9a024$var$createMatchers(selector, $b5e49ecb88b9a024$var$nameMatcher).map((m)=>m.matcher);
        });
        this.unbalancedBracketScopes = unbalancedBracketScopes.flatMap((selector)=>$b5e49ecb88b9a024$var$createMatchers(selector, $b5e49ecb88b9a024$var$nameMatcher).map((m)=>m.matcher));
    }
    get matchesAlways() {
        return this.allowAny && this.unbalancedBracketScopes.length === 0;
    }
    get matchesNever() {
        return this.balancedBracketScopes.length === 0 && !this.allowAny;
    }
    match(scopes) {
        for (const excluder of this.unbalancedBracketScopes){
            if (excluder(scopes)) return false;
        }
        for (const includer of this.balancedBracketScopes){
            if (includer(scopes)) return true;
        }
        return this.allowAny;
    }
};
var $b5e49ecb88b9a024$var$LineTokens = class {
    constructor(emitBinaryTokens, lineText, tokenTypeOverrides, balancedBracketSelectors){
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._emitBinaryTokens = emitBinaryTokens;
        this._tokenTypeOverrides = tokenTypeOverrides;
        this._lineText = null;
        this._tokens = [];
        this._binaryTokens = [];
        this._lastTokenEndIndex = 0;
    }
    balancedBracketSelectors;
    _emitBinaryTokens;
    /**
   * defined only if `false`.
   */ _lineText;
    /**
   * used only if `_emitBinaryTokens` is false.
   */ _tokens;
    /**
   * used only if `_emitBinaryTokens` is true.
   */ _binaryTokens;
    _lastTokenEndIndex;
    _tokenTypeOverrides;
    produce(stack, endIndex) {
        this.produceFromScopes(stack.contentNameScopesList, endIndex);
    }
    produceFromScopes(scopesList, endIndex) {
        if (this._lastTokenEndIndex >= endIndex) return;
        if (this._emitBinaryTokens) {
            let metadata = scopesList?.tokenAttributes ?? 0;
            let containsBalancedBrackets = false;
            if (this.balancedBracketSelectors?.matchesAlways) containsBalancedBrackets = true;
            if (this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
                const scopes2 = scopesList?.getScopeNames() ?? [];
                for (const tokenType of this._tokenTypeOverrides)if (tokenType.matcher(scopes2)) metadata = $b5e49ecb88b9a024$export$90e5db14803ea047.set(metadata, 0, $b5e49ecb88b9a024$var$toOptionalTokenType(tokenType.type), null, -1 /* NotSet */ , 0, 0);
                if (this.balancedBracketSelectors) containsBalancedBrackets = this.balancedBracketSelectors.match(scopes2);
            }
            if (containsBalancedBrackets) metadata = $b5e49ecb88b9a024$export$90e5db14803ea047.set(metadata, 0, 8 /* NotSet */ , containsBalancedBrackets, -1 /* NotSet */ , 0, 0);
            if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === metadata) {
                this._lastTokenEndIndex = endIndex;
                return;
            }
            this._binaryTokens.push(this._lastTokenEndIndex);
            this._binaryTokens.push(metadata);
            this._lastTokenEndIndex = endIndex;
            return;
        }
        const scopes = scopesList?.getScopeNames() ?? [];
        this._tokens.push({
            startIndex: this._lastTokenEndIndex,
            endIndex: endIndex,
            scopes: // value: lineText.substring(lastTokenEndIndex, endIndex),
            scopes
        });
        this._lastTokenEndIndex = endIndex;
    }
    getResult(stack, lineLength) {
        if (this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === lineLength - 1) this._tokens.pop();
        if (this._tokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._tokens[this._tokens.length - 1].startIndex = 0;
        }
        return this._tokens;
    }
    getBinaryResult(stack, lineLength) {
        if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === lineLength - 1) {
            this._binaryTokens.pop();
            this._binaryTokens.pop();
        }
        if (this._binaryTokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._binaryTokens[this._binaryTokens.length - 2] = 0;
        }
        const result = new Uint32Array(this._binaryTokens.length);
        for(let i = 0, len = this._binaryTokens.length; i < len; i++)result[i] = this._binaryTokens[i];
        return result;
    }
};
// src/registry.ts
var $b5e49ecb88b9a024$var$SyncRegistry = class {
    constructor(theme, _onigLib){
        this._onigLib = _onigLib;
        this._theme = theme;
    }
    _onigLib;
    _grammars = /* @__PURE__ */ new Map();
    _rawGrammars = /* @__PURE__ */ new Map();
    _injectionGrammars = /* @__PURE__ */ new Map();
    _theme;
    dispose() {
        for (const grammar of this._grammars.values())grammar.dispose();
    }
    setTheme(theme) {
        this._theme = theme;
    }
    getColorMap() {
        return this._theme.getColorMap();
    }
    /**
   * Add `grammar` to registry and return a list of referenced scope names
   */ addGrammar(grammar, injectionScopeNames) {
        this._rawGrammars.set(grammar.scopeName, grammar);
        if (injectionScopeNames) this._injectionGrammars.set(grammar.scopeName, injectionScopeNames);
    }
    /**
   * Lookup a raw grammar.
   */ lookup(scopeName) {
        return this._rawGrammars.get(scopeName);
    }
    /**
   * Returns the injections for the given grammar
   */ injections(targetScope) {
        return this._injectionGrammars.get(targetScope);
    }
    /**
   * Get the default theme settings
   */ getDefaults() {
        return this._theme.getDefaults();
    }
    /**
   * Match a scope in the theme.
   */ themeMatch(scopePath) {
        return this._theme.match(scopePath);
    }
    /**
   * Lookup a grammar.
   */ grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        if (!this._grammars.has(scopeName)) {
            let rawGrammar = this._rawGrammars.get(scopeName);
            if (!rawGrammar) return null;
            this._grammars.set(scopeName, $b5e49ecb88b9a024$var$createGrammar(scopeName, rawGrammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, this, this._onigLib));
        }
        return this._grammars.get(scopeName);
    }
};
// src/index.ts
var $b5e49ecb88b9a024$export$4d9facee29974f3 = class {
    _options;
    _syncRegistry;
    _ensureGrammarCache;
    constructor(options){
        this._options = options;
        this._syncRegistry = new $b5e49ecb88b9a024$var$SyncRegistry($b5e49ecb88b9a024$export$14faa19a0f3bbeb2.createFromRawTheme(options.theme, options.colorMap), options.onigLib);
        this._ensureGrammarCache = /* @__PURE__ */ new Map();
    }
    dispose() {
        this._syncRegistry.dispose();
    }
    /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */ setTheme(theme, colorMap) {
        this._syncRegistry.setTheme($b5e49ecb88b9a024$export$14faa19a0f3bbeb2.createFromRawTheme(theme, colorMap));
    }
    /**
   * Returns a lookup array for color ids.
   */ getColorMap() {
        return this._syncRegistry.getColorMap();
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithEmbeddedLanguages(initialScopeName, initialLanguage, embeddedLanguages) {
        return this.loadGrammarWithConfiguration(initialScopeName, initialLanguage, {
            embeddedLanguages: embeddedLanguages
        });
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithConfiguration(initialScopeName, initialLanguage, configuration) {
        return this._loadGrammar(initialScopeName, initialLanguage, configuration.embeddedLanguages, configuration.tokenTypes, new $b5e49ecb88b9a024$var$BalancedBracketSelectors(configuration.balancedBracketSelectors || [], configuration.unbalancedBracketSelectors || []));
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */ loadGrammar(initialScopeName) {
        return this._loadGrammar(initialScopeName, 0, null, null, null);
    }
    _loadGrammar(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        const dependencyProcessor = new $b5e49ecb88b9a024$var$ScopeDependencyProcessor(this._syncRegistry, initialScopeName);
        while(dependencyProcessor.Q.length > 0){
            dependencyProcessor.Q.map((request)=>this._loadSingleGrammar(request.scopeName));
            dependencyProcessor.processQueue();
        }
        return this._grammarForScopeName(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
    _loadSingleGrammar(scopeName) {
        if (!this._ensureGrammarCache.has(scopeName)) {
            this._doLoadSingleGrammar(scopeName);
            this._ensureGrammarCache.set(scopeName, true);
        }
    }
    _doLoadSingleGrammar(scopeName) {
        const grammar = this._options.loadGrammar(scopeName);
        if (grammar) {
            const injections = typeof this._options.getInjections === "function" ? this._options.getInjections(scopeName) : void 0;
            this._syncRegistry.addGrammar(grammar, injections);
        }
    }
    /**
   * Adds a rawGrammar.
   */ addGrammar(rawGrammar, injections = [], initialLanguage = 0, embeddedLanguages = null) {
        this._syncRegistry.addGrammar(rawGrammar, injections);
        return this._grammarForScopeName(rawGrammar.scopeName, initialLanguage, embeddedLanguages);
    }
    /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */ _grammarForScopeName(scopeName, initialLanguage = 0, embeddedLanguages = null, tokenTypes = null, balancedBracketSelectors = null) {
        return this._syncRegistry.grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
};
var $b5e49ecb88b9a024$export$17227441e89ee693 = $b5e49ecb88b9a024$var$StateStackImpl.NULL;


//#region src/utils/colors.ts
function $ef3f42056ac626ab$export$2f5d8722891c6610(theme, options) {
    const replacements = typeof theme === "string" ? {} : {
        ...theme.colorReplacements
    };
    const themeName = typeof theme === "string" ? theme : theme.name;
    for (const [key, value] of Object.entries(options?.colorReplacements || {}))if (typeof value === "string") replacements[key] = value;
    else if (key === themeName) Object.assign(replacements, value);
    return replacements;
}
function $ef3f42056ac626ab$export$ef30c5cede3b6b4a(color, replacements) {
    if (!color) return color;
    return replacements?.[color?.toLowerCase()] || color;
}
//#endregion
//#region src/utils/general.ts
function $ef3f42056ac626ab$export$45b10814cc054894(x) {
    return Array.isArray(x) ? x : [
        x
    ];
}
/**
* Normalize a getter to a promise.
*/ async function $ef3f42056ac626ab$export$4643bb4b0bbd3390(p) {
    return Promise.resolve(typeof p === "function" ? p() : p).then((r)=>r.default || r);
}
/**
* Check if the language is plaintext that is ignored by Shiki.
*
* Hard-coded plain text languages: `plaintext`, `txt`, `text`, `plain`.
*/ function $ef3f42056ac626ab$export$f98db15a0683bb96(lang) {
    return !lang || [
        "plaintext",
        "txt",
        "text",
        "plain"
    ].includes(lang);
}
/**
* Check if the language is specially handled or bypassed by Shiki.
*
* Hard-coded languages: `ansi` and plaintexts like `plaintext`, `txt`, `text`, `plain`.
*/ function $ef3f42056ac626ab$export$5c3e2a1e13c5c906(lang) {
    return lang === "ansi" || $ef3f42056ac626ab$export$f98db15a0683bb96(lang);
}
/**
* Check if the theme is specially handled or bypassed by Shiki.
*
* Hard-coded themes: `none`.
*/ function $ef3f42056ac626ab$export$3e6bc683d2a50c25(theme) {
    return theme === "none";
}
/**
* Check if the theme is specially handled or bypassed by Shiki.
*
* Hard-coded themes: `none`.
*/ function $ef3f42056ac626ab$export$cd4537af2d43769e(theme) {
    return $ef3f42056ac626ab$export$3e6bc683d2a50c25(theme);
}
//#endregion
//#region src/utils/strings.ts
/**
* Split a string into lines, each line preserves the line ending.
*
* @param code - The code string to split into lines
* @param preserveEnding - Whether to preserve line endings in the result
* @returns Array of tuples containing [line content, offset index]
*
* @example
* ```ts
* splitLines('hello\nworld', false)
* // => [['hello', 0], ['world', 6]]
*
* splitLines('hello\nworld', true)
* // => [['hello\n', 0], ['world', 6]]
* ```
*/ const $ef3f42056ac626ab$var$RE_NEWLINE = /(\r?\n)/g;
function $ef3f42056ac626ab$export$88c07fe39db9eaa1(code, preserveEnding = false) {
    if (code.length === 0) return [
        [
            "",
            0
        ]
    ];
    const parts = code.split($ef3f42056ac626ab$var$RE_NEWLINE);
    let index = 0;
    const lines = [];
    for(let i = 0; i < parts.length; i += 2){
        const line = preserveEnding ? parts[i] + (parts[i + 1] || "") : parts[i];
        lines.push([
            line,
            index
        ]);
        index += parts[i].length;
        index += parts[i + 1]?.length || 0;
    }
    return lines;
}
//#endregion
//#region src/textmate/normalize-theme.ts
/**
* https://github.com/microsoft/vscode/blob/f7f05dee53fb33fe023db2e06e30a89d3094488f/src/vs/platform/theme/common/colorRegistry.ts#L258-L268
*/ const $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_FG = {
    light: "#333333",
    dark: "#bbbbbb"
};
const $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_BG = {
    light: "#fffffe",
    dark: "#1e1e1e"
};
const $ef3f42056ac626ab$var$RESOLVED_KEY = "__shiki_resolved";
/**
* Normalize a textmate theme to shiki theme
*/ function $ef3f42056ac626ab$export$7cb37fb596e67020(rawTheme) {
    if (rawTheme?.[$ef3f42056ac626ab$var$RESOLVED_KEY]) return rawTheme;
    const theme = {
        ...rawTheme
    };
    if (theme.tokenColors && !theme.settings) {
        theme.settings = theme.tokenColors;
        delete theme.tokenColors;
    }
    theme.type ||= "dark";
    theme.colorReplacements = {
        ...theme.colorReplacements
    };
    theme.settings ||= [];
    let { bg: bg, fg: fg } = theme;
    if (!bg || !fg) {
        /**
		* First try:
		* Theme might contain a global `tokenColor` without `name` or `scope`
		* Used as default value for foreground/background
		*/ const globalSetting = theme.settings ? theme.settings.find((s)=>!s.name && !s.scope) : void 0;
        if (globalSetting?.settings?.foreground) fg = globalSetting.settings.foreground;
        if (globalSetting?.settings?.background) bg = globalSetting.settings.background;
        /**
		* Second try:
		* If there's no global `tokenColor` without `name` or `scope`
		* Use `editor.foreground` and `editor.background`
		*/ if (!fg && theme?.colors?.["editor.foreground"]) fg = theme.colors["editor.foreground"];
        if (!bg && theme?.colors?.["editor.background"]) bg = theme.colors["editor.background"];
        /**
		* Last try:
		* If there's no fg/bg color specified in theme, use default
		*/ if (!fg) fg = theme.type === "light" ? $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_FG.light : $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_FG.dark;
        if (!bg) bg = theme.type === "light" ? $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_BG.light : $ef3f42056ac626ab$var$VSCODE_FALLBACK_EDITOR_BG.dark;
        theme.fg = fg;
        theme.bg = bg;
    }
    if (!(theme.settings[0] && theme.settings[0].settings && !theme.settings[0].scope)) theme.settings.unshift({
        settings: {
            foreground: theme.fg,
            background: theme.bg
        }
    });
    let replacementCount = 0;
    const replacementMap = /* @__PURE__ */ new Map();
    function getReplacementColor(value) {
        if (replacementMap.has(value)) return replacementMap.get(value);
        replacementCount += 1;
        const hex = `#${replacementCount.toString(16).padStart(8, "0").toLowerCase()}`;
        if (theme.colorReplacements?.[`#${hex}`]) return getReplacementColor(value);
        replacementMap.set(value, hex);
        return hex;
    }
    theme.settings = theme.settings.map((setting)=>{
        const replaceFg = setting.settings?.foreground && !setting.settings.foreground.startsWith("#");
        const replaceBg = setting.settings?.background && !setting.settings.background.startsWith("#");
        if (!replaceFg && !replaceBg) return setting;
        const clone = {
            ...setting,
            settings: {
                ...setting.settings
            }
        };
        if (replaceFg) {
            const replacement = getReplacementColor(setting.settings.foreground);
            theme.colorReplacements[replacement] = setting.settings.foreground;
            clone.settings.foreground = replacement;
        }
        if (replaceBg) {
            const replacement = getReplacementColor(setting.settings.background);
            theme.colorReplacements[replacement] = setting.settings.background;
            clone.settings.background = replacement;
        }
        return clone;
    });
    for (const key of Object.keys(theme.colors || {}))if (key === "editor.foreground" || key === "editor.background" || key.startsWith("terminal.ansi")) {
        if (!theme.colors[key]?.startsWith("#")) {
            const replacement = getReplacementColor(theme.colors[key]);
            theme.colorReplacements[replacement] = theme.colors[key];
            theme.colors[key] = replacement;
        }
    }
    Object.defineProperty(theme, $ef3f42056ac626ab$var$RESOLVED_KEY, {
        enumerable: false,
        writable: false,
        value: true
    });
    return theme;
}
//#endregion
//#region src/textmate/getters-resolve.ts
/**
* Resolve
*/ async function $ef3f42056ac626ab$export$dfde3265a92833f6(langs) {
    return [
        ...new Set((await Promise.all(langs.filter((l)=>!$ef3f42056ac626ab$export$5c3e2a1e13c5c906(l)).map(async (lang)=>await $ef3f42056ac626ab$export$4643bb4b0bbd3390(lang).then((r)=>Array.isArray(r) ? r : [
                    r
                ])))).flat())
    ];
}
async function $ef3f42056ac626ab$export$94455fe17f38f5a8(themes) {
    return (await Promise.all(themes.map(async (theme)=>$ef3f42056ac626ab$export$cd4537af2d43769e(theme) ? null : $ef3f42056ac626ab$export$7cb37fb596e67020(await $ef3f42056ac626ab$export$4643bb4b0bbd3390(theme))))).filter((i)=>!!i);
}
//#endregion
//#region src/utils/alias.ts
function $ef3f42056ac626ab$export$bdd8de43c0c06bf(name, alias) {
    if (!alias) return name;
    if (alias[name]) {
        const resolved = /* @__PURE__ */ new Set([
            name
        ]);
        while(alias[name]){
            name = alias[name];
            if (resolved.has(name)) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Circular alias \`${[
                ...resolved
            ].join(" -> ")} -> ${name}\``);
            resolved.add(name);
        }
    }
    return name;
}
//#endregion
//#region src/textmate/registry.ts
var $ef3f42056ac626ab$export$4d9facee29974f3 = class extends (0, $b5e49ecb88b9a024$export$4d9facee29974f3) {
    _resolver;
    _themes;
    _langs;
    _alias;
    _resolvedThemes = /* @__PURE__ */ new Map();
    _resolvedGrammars = /* @__PURE__ */ new Map();
    _langMap = /* @__PURE__ */ new Map();
    _langGraph = /* @__PURE__ */ new Map();
    _textmateThemeCache = /* @__PURE__ */ new WeakMap();
    _loadedThemesCache = null;
    _loadedLanguagesCache = null;
    constructor(_resolver, _themes, _langs, _alias = {}){
        super(_resolver);
        this._resolver = _resolver;
        this._themes = _themes;
        this._langs = _langs;
        this._alias = _alias;
        this._themes.map((t)=>this.loadTheme(t));
        this.loadLanguages(this._langs);
    }
    getTheme(theme) {
        if (typeof theme === "string") return this._resolvedThemes.get(theme);
        else return this.loadTheme(theme);
    }
    loadTheme(theme) {
        const _theme = $ef3f42056ac626ab$export$7cb37fb596e67020(theme);
        if (_theme.name) {
            this._resolvedThemes.set(_theme.name, _theme);
            this._loadedThemesCache = null;
        }
        return _theme;
    }
    getLoadedThemes() {
        if (!this._loadedThemesCache) this._loadedThemesCache = [
            ...this._resolvedThemes.keys()
        ];
        return this._loadedThemesCache;
    }
    setTheme(theme) {
        let textmateTheme = this._textmateThemeCache.get(theme);
        if (!textmateTheme) {
            textmateTheme = (0, $b5e49ecb88b9a024$export$14faa19a0f3bbeb2).createFromRawTheme(theme);
            this._textmateThemeCache.set(theme, textmateTheme);
        }
        this._syncRegistry.setTheme(textmateTheme);
    }
    getGrammar(name) {
        name = $ef3f42056ac626ab$export$bdd8de43c0c06bf(name, this._alias);
        return this._resolvedGrammars.get(name);
    }
    loadLanguage(lang) {
        if (this.getGrammar(lang.name)) return;
        const embeddedLazilyBy = new Set([
            ...this._langMap.values()
        ].filter((i)=>i.embeddedLangsLazy?.includes(lang.name)));
        this._resolver.addLanguage(lang);
        const grammarConfig = {
            balancedBracketSelectors: lang.balancedBracketSelectors || [
                "*"
            ],
            unbalancedBracketSelectors: lang.unbalancedBracketSelectors || []
        };
        this._syncRegistry._rawGrammars.set(lang.scopeName, lang);
        const g = this.loadGrammarWithConfiguration(lang.scopeName, 1, grammarConfig);
        g.name = lang.name;
        this._resolvedGrammars.set(lang.name, g);
        if (lang.aliases) lang.aliases.forEach((alias)=>{
            this._alias[alias] = lang.name;
        });
        this._loadedLanguagesCache = null;
        if (embeddedLazilyBy.size) for (const e of embeddedLazilyBy){
            this._syncRegistry?._grammars?.get(e.scopeName)?.dispose();
            this._resolvedGrammars.delete(e.name);
            this._loadedLanguagesCache = null;
            this._syncRegistry?._injectionGrammars?.delete(e.scopeName);
            this._syncRegistry?._grammars?.delete(e.scopeName);
            this.loadLanguage(this._langMap.get(e.name));
        }
    }
    dispose() {
        super.dispose();
        this._resolvedThemes.clear();
        this._resolvedGrammars.clear();
        this._langMap.clear();
        this._langGraph.clear();
        this._loadedThemesCache = null;
    }
    loadLanguages(langs) {
        for (const lang of langs)this.resolveEmbeddedLanguages(lang);
        const langsGraphArray = [
            ...this._langGraph.entries()
        ];
        const missingLangs = langsGraphArray.filter(([_, lang])=>!lang);
        if (missingLangs.length) {
            const dependents = langsGraphArray.filter(([_, lang])=>{
                if (!lang) return false;
                return (lang.embeddedLanguages || lang.embeddedLangs)?.some((l)=>missingLangs.map(([name])=>name).includes(l));
            }).filter((lang)=>!missingLangs.includes(lang));
            throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Missing languages ${missingLangs.map(([name])=>`\`${name}\``).join(", ")}, required by ${dependents.map(([name])=>`\`${name}\``).join(", ")}`);
        }
        for (const [_, lang] of langsGraphArray)this._resolver.addLanguage(lang);
        for (const [_, lang] of langsGraphArray)this.loadLanguage(lang);
    }
    getLoadedLanguages() {
        if (!this._loadedLanguagesCache) this._loadedLanguagesCache = [
            .../* @__PURE__ */ new Set([
                ...this._resolvedGrammars.keys(),
                ...Object.keys(this._alias)
            ])
        ];
        return this._loadedLanguagesCache;
    }
    resolveEmbeddedLanguages(lang) {
        this._langMap.set(lang.name, lang);
        this._langGraph.set(lang.name, lang);
        const embedded = lang.embeddedLanguages ?? lang.embeddedLangs;
        if (embedded) for (const embeddedLang of embedded)this._langGraph.set(embeddedLang, this._langMap.get(embeddedLang));
    }
};
//#endregion
//#region src/textmate/resolver.ts
var $ef3f42056ac626ab$export$8b4c839865b08288 = class {
    _langs = /* @__PURE__ */ new Map();
    _scopeToLang = /* @__PURE__ */ new Map();
    _injections = /* @__PURE__ */ new Map();
    _onigLib;
    constructor(engine, langs){
        this._onigLib = {
            createOnigScanner: (patterns)=>engine.createScanner(patterns),
            createOnigString: (s)=>engine.createString(s)
        };
        langs.forEach((i)=>this.addLanguage(i));
    }
    get onigLib() {
        return this._onigLib;
    }
    getLangRegistration(langIdOrAlias) {
        return this._langs.get(langIdOrAlias);
    }
    loadGrammar(scopeName) {
        return this._scopeToLang.get(scopeName);
    }
    addLanguage(l) {
        this._langs.set(l.name, l);
        if (l.aliases) l.aliases.forEach((a)=>{
            this._langs.set(a, l);
        });
        this._scopeToLang.set(l.scopeName, l);
        if (l.injectTo) l.injectTo.forEach((i)=>{
            if (!this._injections.get(i)) this._injections.set(i, []);
            if (!this._injections.get(i).includes(l.scopeName)) this._injections.get(i).push(l.scopeName);
        });
    }
    getInjections(scopeName) {
        const scopeParts = scopeName.split(".");
        let injections = [];
        for(let i = 1; i <= scopeParts.length; i++){
            const subScopeName = scopeParts.slice(0, i).join(".");
            injections = [
                ...injections,
                ...this._injections.get(subScopeName) || []
            ];
        }
        return injections;
    }
};
//#endregion
//#region src/constructors/primitive.ts
let $ef3f42056ac626ab$var$instancesCount = 0;
/**
* Get the minimal shiki primitive instance.
*
* Requires to provide the engine and all themes and languages upfront.
*/ function $ef3f42056ac626ab$export$993d8e1d5e5fb61b(options) {
    $ef3f42056ac626ab$var$instancesCount += 1;
    if (options.warnings !== false && $ef3f42056ac626ab$var$instancesCount >= 10 && $ef3f42056ac626ab$var$instancesCount % 10 === 0) console.warn(`[Shiki] ${$ef3f42056ac626ab$var$instancesCount} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
    let isDisposed = false;
    if (!options.engine) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("`engine` option is required for synchronous mode");
    const langs = (options.langs || []).flat(1);
    const themes = (options.themes || []).flat(1).map($ef3f42056ac626ab$export$7cb37fb596e67020);
    const _registry = new $ef3f42056ac626ab$export$4d9facee29974f3(new $ef3f42056ac626ab$export$8b4c839865b08288(options.engine, langs), themes, langs, options.langAlias);
    let _lastTheme;
    function resolveLangAlias$1(name) {
        return $ef3f42056ac626ab$export$bdd8de43c0c06bf(name, options.langAlias);
    }
    function getLanguage(name) {
        ensureNotDisposed();
        const _lang = _registry.getGrammar(typeof name === "string" ? name : name.name);
        if (!_lang) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Language \`${name}\` not found, you may need to load it first`);
        return _lang;
    }
    function getTheme(name) {
        if (name === "none") return {
            bg: "",
            fg: "",
            name: "none",
            settings: [],
            type: "dark"
        };
        ensureNotDisposed();
        const _theme = _registry.getTheme(name);
        if (!_theme) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Theme \`${name}\` not found, you may need to load it first`);
        return _theme;
    }
    function setTheme(name) {
        ensureNotDisposed();
        const theme = getTheme(name);
        if (_lastTheme !== name) {
            _registry.setTheme(theme);
            _lastTheme = name;
        }
        return {
            theme: theme,
            colorMap: _registry.getColorMap()
        };
    }
    function getLoadedThemes() {
        ensureNotDisposed();
        return _registry.getLoadedThemes();
    }
    function getLoadedLanguages() {
        ensureNotDisposed();
        return _registry.getLoadedLanguages();
    }
    function loadLanguageSync(...langs) {
        ensureNotDisposed();
        _registry.loadLanguages(langs.flat(1));
    }
    async function loadLanguage(...langs) {
        return loadLanguageSync(await $ef3f42056ac626ab$export$dfde3265a92833f6(langs));
    }
    function loadThemeSync(...themes) {
        ensureNotDisposed();
        for (const theme of themes.flat(1))_registry.loadTheme(theme);
    }
    async function loadTheme(...themes) {
        ensureNotDisposed();
        return loadThemeSync(await $ef3f42056ac626ab$export$94455fe17f38f5a8(themes));
    }
    function ensureNotDisposed() {
        if (isDisposed) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("Shiki instance has been disposed");
    }
    function dispose() {
        if (isDisposed) return;
        isDisposed = true;
        _registry.dispose();
        $ef3f42056ac626ab$var$instancesCount -= 1;
    }
    return {
        setTheme: setTheme,
        getTheme: getTheme,
        getLanguage: getLanguage,
        getLoadedThemes: getLoadedThemes,
        getLoadedLanguages: getLoadedLanguages,
        resolveLangAlias: resolveLangAlias$1,
        loadLanguage: loadLanguage,
        loadLanguageSync: loadLanguageSync,
        loadTheme: loadTheme,
        loadThemeSync: loadThemeSync,
        dispose: dispose,
        [Symbol.dispose]: dispose
    };
}
/**
* @deprecated Use `createShikiPrimitive` instead.
*/ const $ef3f42056ac626ab$export$b748e45347fc3413 = $ef3f42056ac626ab$export$993d8e1d5e5fb61b;
//#endregion
//#region src/constructors/async.ts
/**
* Get the minimal shiki primitive instance.
*/ async function $ef3f42056ac626ab$export$7118aaae6ff863ad(options) {
    if (!options.engine) console.warn("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
    const [themes, langs, engine] = await Promise.all([
        $ef3f42056ac626ab$export$94455fe17f38f5a8(options.themes || []),
        $ef3f42056ac626ab$export$dfde3265a92833f6(options.langs || []),
        options.engine
    ]);
    return $ef3f42056ac626ab$export$993d8e1d5e5fb61b({
        ...options,
        themes: themes,
        langs: langs,
        engine: engine
    });
}
/**
* @deprecated Use `createShikiPrimitiveAsync` instead.
*/ const $ef3f42056ac626ab$export$e584c153725e36c2 = $ef3f42056ac626ab$export$7118aaae6ff863ad;
//#endregion
//#region src/textmate/grammar-state.ts
const $ef3f42056ac626ab$var$_grammarStateMap = /* @__PURE__ */ new WeakMap();
function $ef3f42056ac626ab$export$85116f33c2060a4b(keys, state) {
    $ef3f42056ac626ab$var$_grammarStateMap.set(keys, state);
}
function $ef3f42056ac626ab$export$47937e5383997945(keys) {
    return $ef3f42056ac626ab$var$_grammarStateMap.get(keys);
}
/**
* GrammarState is a special reference object that holds the state of a grammar.
*
* It's used to highlight code snippets that are part of the target language.
*/ var $ef3f42056ac626ab$export$6828086307020659 = class GrammarState {
    /**
	* Theme to Stack mapping
	*/ _stacks = {};
    lang;
    get themes() {
        return Object.keys(this._stacks);
    }
    get theme() {
        return this.themes[0];
    }
    get _stack() {
        return this._stacks[this.theme];
    }
    /**
	* Static method to create a initial grammar state.
	*/ static initial(lang, themes) {
        return new GrammarState(Object.fromEntries($ef3f42056ac626ab$export$45b10814cc054894(themes).map((theme)=>[
                theme,
                (0, $b5e49ecb88b9a024$export$17227441e89ee693)
            ])), lang);
    }
    constructor(...args){
        if (args.length === 2) {
            const [stacksMap, lang] = args;
            this.lang = lang;
            this._stacks = stacksMap;
        } else {
            const [stack, lang, theme] = args;
            this.lang = lang;
            this._stacks = {
                [theme]: stack
            };
        }
    }
    /**
	* Get the internal stack object.
	* @internal
	*/ getInternalStack(theme = this.theme) {
        return this._stacks[theme];
    }
    getScopes(theme = this.theme) {
        return $ef3f42056ac626ab$var$getScopes(this._stacks[theme]);
    }
    toJSON() {
        return {
            lang: this.lang,
            theme: this.theme,
            themes: this.themes,
            scopes: this.getScopes()
        };
    }
};
function $ef3f42056ac626ab$var$getScopes(stack) {
    const scopes = [];
    const visited = /* @__PURE__ */ new Set();
    function pushScope(stack) {
        if (visited.has(stack)) return;
        visited.add(stack);
        const name = stack?.nameScopesList?.scopeName;
        if (name) scopes.push(name);
        if (stack.parent) pushScope(stack.parent);
    }
    pushScope(stack);
    return scopes;
}
function $ef3f42056ac626ab$export$5d3db558cc5e415b(state, theme) {
    if (!(state instanceof $ef3f42056ac626ab$export$6828086307020659)) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("Invalid grammar state");
    return state.getInternalStack(theme);
}
//#endregion
//#region src/highlight/code-to-tokens-base.ts
const $ef3f42056ac626ab$var$RE_COMMA = /,/;
const $ef3f42056ac626ab$var$RE_SPACE = / /;
/**
* Code to tokens, with a simple theme.
*/ function $ef3f42056ac626ab$export$9fcc555cdbb165d8(primitive, code, options = {}) {
    const { theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if ($ef3f42056ac626ab$export$f98db15a0683bb96(primitive.resolveLangAlias(options.lang || "text")) || $ef3f42056ac626ab$export$3e6bc683d2a50c25(themeName)) return $ef3f42056ac626ab$export$88c07fe39db9eaa1(code).map((line)=>[
            {
                content: line[0],
                offset: line[1]
            }
        ]);
    const { theme: theme, colorMap: colorMap } = primitive.setTheme(themeName);
    const _grammar = primitive.getLanguage(options.lang || "text");
    if (options.grammarState) {
        if (options.grammarState.lang !== _grammar.name) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Grammar state language "${options.grammarState.lang}" does not match highlight language "${_grammar.name}"`);
        if (!options.grammarState.themes.includes(theme.name)) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Grammar state themes "${options.grammarState.themes}" do not contain highlight theme "${theme.name}"`);
    }
    return $ef3f42056ac626ab$export$54c7d59470f3dc59(code, _grammar, theme, colorMap, options);
}
function $ef3f42056ac626ab$export$e79a48b8b5fd83c5(...args) {
    if (args.length === 2) return $ef3f42056ac626ab$export$47937e5383997945(args[1]);
    const [primitive, code, options = {}] = args;
    const { lang: lang = "text", theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if ($ef3f42056ac626ab$export$f98db15a0683bb96(lang) || $ef3f42056ac626ab$export$3e6bc683d2a50c25(themeName)) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("Plain language does not have grammar state");
    if (lang === "ansi") throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("ANSI language does not have grammar state");
    const { theme: theme, colorMap: colorMap } = primitive.setTheme(themeName);
    const _grammar = primitive.getLanguage(lang);
    return new $ef3f42056ac626ab$export$6828086307020659($ef3f42056ac626ab$var$_tokenizeWithTheme(code, _grammar, theme, colorMap, options).stateStack, _grammar.name, theme.name);
}
function $ef3f42056ac626ab$export$54c7d59470f3dc59(code, grammar, theme, colorMap, options) {
    const result = $ef3f42056ac626ab$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options);
    const grammarState = new $ef3f42056ac626ab$export$6828086307020659(result.stateStack, grammar.name, theme.name);
    $ef3f42056ac626ab$export$85116f33c2060a4b(result.tokens, grammarState);
    return result.tokens;
}
function $ef3f42056ac626ab$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options) {
    const colorReplacements = $ef3f42056ac626ab$export$2f5d8722891c6610(theme, options);
    const { tokenizeMaxLineLength: tokenizeMaxLineLength = 0, tokenizeTimeLimit: tokenizeTimeLimit = 500, includeExplanation: includeExplanation = false } = options;
    const lines = $ef3f42056ac626ab$export$88c07fe39db9eaa1(code);
    let stateStack = options.grammarState ? $ef3f42056ac626ab$export$5d3db558cc5e415b(options.grammarState, theme.name) ?? (0, $b5e49ecb88b9a024$export$17227441e89ee693) : options.grammarContextCode != null ? $ef3f42056ac626ab$var$_tokenizeWithTheme(options.grammarContextCode, grammar, theme, colorMap, {
        ...options,
        grammarState: void 0,
        grammarContextCode: void 0
    }).stateStack : (0, $b5e49ecb88b9a024$export$17227441e89ee693);
    let actual = [];
    const final = [];
    for(let i = 0, len = lines.length; i < len; i++){
        const [line, lineOffset] = lines[i];
        if (line === "") {
            actual = [];
            final.push([]);
            continue;
        }
        if (tokenizeMaxLineLength > 0 && line.length >= tokenizeMaxLineLength) {
            actual = [];
            final.push([
                {
                    content: line,
                    offset: lineOffset,
                    color: "",
                    fontStyle: 0
                }
            ]);
            continue;
        }
        let resultWithScopes;
        let tokensWithScopes;
        let tokensWithScopesIndex;
        if (includeExplanation && includeExplanation !== "tokenType") {
            resultWithScopes = grammar.tokenizeLine(line, stateStack, tokenizeTimeLimit);
            tokensWithScopes = resultWithScopes.tokens;
            tokensWithScopesIndex = 0;
        }
        const result = grammar.tokenizeLine2(line, stateStack, tokenizeTimeLimit);
        const tokensLength = result.tokens.length / 2;
        for(let j = 0; j < tokensLength; j++){
            const startIndex = result.tokens[2 * j];
            const nextStartIndex = j + 1 < tokensLength ? result.tokens[2 * j + 2] : line.length;
            if (startIndex === nextStartIndex) continue;
            const metadata = result.tokens[2 * j + 1];
            const color = $ef3f42056ac626ab$export$ef30c5cede3b6b4a(colorMap[(0, $b5e49ecb88b9a024$export$90e5db14803ea047).getForeground(metadata)], colorReplacements);
            const fontStyle = (0, $b5e49ecb88b9a024$export$90e5db14803ea047).getFontStyle(metadata);
            const token = {
                content: line.substring(startIndex, nextStartIndex),
                offset: lineOffset + startIndex,
                color: color,
                fontStyle: fontStyle
            };
            if (includeExplanation === "tokenType") token.type = (0, $b5e49ecb88b9a024$export$90e5db14803ea047).getTokenType(metadata);
            else if (includeExplanation) {
                const themeSettingsSelectors = [];
                if (includeExplanation !== "scopeName") for (const setting of theme.settings){
                    let selectors;
                    switch(typeof setting.scope){
                        case "string":
                            selectors = setting.scope.split($ef3f42056ac626ab$var$RE_COMMA).map((scope)=>scope.trim());
                            break;
                        case "object":
                            selectors = setting.scope;
                            break;
                        default:
                            continue;
                    }
                    themeSettingsSelectors.push({
                        settings: setting,
                        selectors: selectors.map((selector)=>selector.split($ef3f42056ac626ab$var$RE_SPACE))
                    });
                }
                token.explanation = [];
                let offset = 0;
                while(startIndex + offset < nextStartIndex){
                    const tokenWithScopes = tokensWithScopes[tokensWithScopesIndex];
                    const tokenWithScopesText = line.substring(tokenWithScopes.startIndex, tokenWithScopes.endIndex);
                    offset += tokenWithScopesText.length;
                    token.explanation.push({
                        content: tokenWithScopesText,
                        scopes: includeExplanation === "scopeName" ? $ef3f42056ac626ab$var$explainThemeScopesNameOnly(tokenWithScopes.scopes) : $ef3f42056ac626ab$var$explainThemeScopesFull(themeSettingsSelectors, tokenWithScopes.scopes)
                    });
                    tokensWithScopesIndex += 1;
                }
            }
            actual.push(token);
        }
        final.push(actual);
        actual = [];
        stateStack = result.ruleStack;
    }
    return {
        tokens: final,
        stateStack: stateStack
    };
}
function $ef3f42056ac626ab$var$explainThemeScopesNameOnly(scopes) {
    return scopes.map((scope)=>({
            scopeName: scope
        }));
}
function $ef3f42056ac626ab$var$explainThemeScopesFull(themeSelectors, scopes) {
    const result = [];
    for(let i = 0, len = scopes.length; i < len; i++){
        const scope = scopes[i];
        result[i] = {
            scopeName: scope,
            themeMatches: $ef3f42056ac626ab$var$explainThemeScope(themeSelectors, scope, scopes.slice(0, i))
        };
    }
    return result;
}
function $ef3f42056ac626ab$var$matchesOne(selector, scope) {
    return selector === scope || scope.substring(0, selector.length) === selector && scope[selector.length] === ".";
}
function $ef3f42056ac626ab$var$matches(selectors, scope, parentScopes) {
    if (!$ef3f42056ac626ab$var$matchesOne(selectors.at(-1), scope)) return false;
    let selectorParentIndex = selectors.length - 2;
    let parentIndex = parentScopes.length - 1;
    while(selectorParentIndex >= 0 && parentIndex >= 0){
        if ($ef3f42056ac626ab$var$matchesOne(selectors[selectorParentIndex], parentScopes[parentIndex])) selectorParentIndex -= 1;
        parentIndex -= 1;
    }
    if (selectorParentIndex === -1) return true;
    return false;
}
function $ef3f42056ac626ab$var$explainThemeScope(themeSettingsSelectors, scope, parentScopes) {
    const result = [];
    for (const { selectors: selectors, settings: settings } of themeSettingsSelectors)for (const selectorPieces of selectors)if ($ef3f42056ac626ab$var$matches(selectorPieces, scope, parentScopes)) {
        result.push(settings);
        break;
    }
    return result;
}
//#endregion
//#region src/highlight/code-to-tokens-themes.ts
/**
* Get tokens with multiple themes
*/ function $ef3f42056ac626ab$export$99552db3190ba9d3(primitive, code, options, codeToTokensBaseFn = $ef3f42056ac626ab$export$9fcc555cdbb165d8) {
    const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
            color: i[0],
            theme: i[1]
        }));
    const themedTokens = themes.map((t)=>{
        const tokens = codeToTokensBaseFn(primitive, code, {
            ...options,
            theme: t.theme
        });
        return {
            tokens: tokens,
            state: $ef3f42056ac626ab$export$47937e5383997945(tokens),
            theme: typeof t.theme === "string" ? t.theme : t.theme.name
        };
    });
    const tokens = $ef3f42056ac626ab$export$cbd2f44183624b07(...themedTokens.map((i)=>i.tokens));
    const mergedTokens = tokens[0].map((line, lineIdx)=>line.map((_token, tokenIdx)=>{
            const mergedToken = {
                content: _token.content,
                variants: {},
                offset: _token.offset
            };
            if ("includeExplanation" in options && options.includeExplanation) mergedToken.explanation = _token.explanation;
            tokens.forEach((t, themeIdx)=>{
                const { content: _, explanation: __, offset: ___, ...styles } = t[lineIdx][tokenIdx];
                mergedToken.variants[themes[themeIdx].color] = styles;
            });
            return mergedToken;
        }));
    const mergedGrammarState = themedTokens[0].state ? new $ef3f42056ac626ab$export$6828086307020659(Object.fromEntries(themedTokens.map((s)=>[
            s.theme,
            s.state?.getInternalStack(s.theme)
        ])), themedTokens[0].state.lang) : void 0;
    if (mergedGrammarState) $ef3f42056ac626ab$export$85116f33c2060a4b(mergedTokens, mergedGrammarState);
    return mergedTokens;
}
/**
* Break tokens from multiple themes into same tokenization.
*
* For example, given two themes that tokenize `console.log("hello")` as:
*
* - `console . log (" hello ")` (6 tokens)
* - `console .log ( "hello" )` (5 tokens)
*
* This function will return:
*
* - `console . log ( " hello " )` (8 tokens)
* - `console . log ( " hello " )` (8 tokens)
*/ function $ef3f42056ac626ab$export$cbd2f44183624b07(...themes) {
    const outThemes = themes.map(()=>[]);
    const count = themes.length;
    for(let i = 0; i < themes[0].length; i++){
        const lines = themes.map((t)=>t[i]);
        const outLines = outThemes.map(()=>[]);
        outThemes.forEach((t, i)=>t.push(outLines[i]));
        const indexes = lines.map(()=>0);
        const current = lines.map((l)=>l[0]);
        while(current.every((t)=>t)){
            const minLength = Math.min(...current.map((t)=>t.content.length));
            for(let n = 0; n < count; n++){
                const token = current[n];
                if (token.content.length === minLength) {
                    outLines[n].push(token);
                    indexes[n] += 1;
                    current[n] = lines[n][indexes[n]];
                } else {
                    outLines[n].push({
                        ...token,
                        content: token.content.slice(0, minLength)
                    });
                    current[n] = {
                        ...token,
                        content: token.content.slice(minLength),
                        offset: token.offset + minLength
                    };
                }
            }
        }
    }
    return outThemes;
}



/**
 * @import {Nodes, Parents, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 * @import {Options as StringifyEntitiesOptions} from 'stringify-entities'
 */ /**
 * @typedef {Omit<StringifyEntitiesOptions, 'attribute' | 'escapeOnly' | 'subset'>} CharacterReferences
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [allowDangerousCharacters=false]
 *   Do not encode some characters which cause XSS vulnerabilities in older
 *   browsers (default: `false`).
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Allow `raw` nodes and insert them as raw HTML (default: `false`).
 *
 *   When `false`, `Raw` nodes are encoded.
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowParseErrors=false]
 *   Do not encode characters which cause parse errors (even though they work),
 *   to save bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [bogusComments=false]
 *   Use “bogus comments” instead of comments to save byes: `<?charlie>`
 *   instead of `<!--charlie-->` (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {CharacterReferences | null | undefined} [characterReferences]
 *   Configure how to serialize character references (optional).
 * @property {boolean | null | undefined} [closeEmptyElements=false]
 *   Close SVG elements without any content with slash (`/`) on the opening tag
 *   instead of an end tag: `<circle />` instead of `<circle></circle>`
 *   (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the HTML space.
 * @property {boolean | null | undefined} [closeSelfClosing=false]
 *   Close self-closing nodes with an extra slash (`/`): `<img />` instead of
 *   `<img>` (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [collapseEmptyAttributes=false]
 *   Collapse empty attributes: get `class` instead of `class=""` (default:
 *   `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: boolean attributes (such as `hidden`) are always collapsed.
 * @property {boolean | null | undefined} [omitOptionalTags=false]
 *   Omit optional opening and closing tags (default: `false`).
 *
 *   For example, in `<ol><li>one</li><li>two</li></ol>`, both `</li>` closing
 *   tags can be omitted.
 *   The first because it’s followed by another `li`, the last because it’s
 *   followed by nothing.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [preferUnquoted=false]
 *   Leave attributes unquoted if that results in less bytes (default: `false`).
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {Quote | null | undefined} [quote='"']
 *   Preferred quote to use (default: `'"'`).
 * @property {Space | null | undefined} [space='html']
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it (default: `'html'`).
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use [`xast`][xast] if you need to support SVG as XML.
 * @property {boolean | null | undefined} [tightAttributes=false]
 *   Join attributes together, without whitespace, if possible: get
 *   `class="a b"title="c d"` instead of `class="a b" title="c d"` to save
 *   bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightCommaSeparatedLists=false]
 *   Join known comma-separated attribute values with just a comma (`,`),
 *   instead of padding them on the right as well (`,␠`, where `␠` represents a
 *   space) (default: `false`).
 * @property {boolean | null | undefined} [tightDoctype=false]
 *   Drop unneeded spaces in doctypes: `<!doctypehtml>` instead of
 *   `<!doctype html>` to save bytes (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 *
 *   > 👉 **Note**: only used if `closeSelfClosing: true` or
 *   > `closeEmptyElements: true`.
 * @property {boolean | null | undefined} [upperDoctype=false]
 *   Use a `<!DOCTYPE…` instead of `<!doctype…` (default: `false`).
 *
 *   Useless except for XHTML.
 * @property {ReadonlyArray<string> | null | undefined} [voids]
 *   Tag names of elements to serialize without closing tag (default: `html-void-elements`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: It’s highly unlikely that you want to pass this, because
 *   > hast is not for XML, and HTML will not add more void elements.
 *
 * @typedef {'"' | "'"} Quote
 *   HTML quotes for attribute values.
 *
 * @typedef {Omit<Required<{[key in keyof Options]: Exclude<Options[key], null | undefined>}>, 'space' | 'quote'>} Settings
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Parents | undefined) => string} all
 *   Serialize the children of a parent node.
 * @property {Quote} alternative
 *   Alternative quote.
 * @property {(node: Nodes, index: number | undefined, parent: Parents | undefined) => string} one
 *   Serialize one node.
 * @property {Quote} quote
 *   Preferred quote.
 * @property {Schema} schema
 *   Current schema.
 * @property {Settings} settings
 *   User configuration.
 */ /**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $aa609dabe8f29803$export$762508062d068de = [
    'area',
    'base',
    'basefont',
    'bgsound',
    'br',
    'col',
    'command',
    'embed',
    'frame',
    'hr',
    'image',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];


// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $5b6f5f4bade80e38$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.normal = {};
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.property = {};
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.space = undefined;


function $61ded5fe6f037163$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $5b6f5f4bade80e38$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ /**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $ba2c06c56b858c9f$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


/**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $931174b915b83d11$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$931174b915b83d11$export$c4868e4a24d48fad.prototype.attribute = '';
$931174b915b83d11$export$c4868e4a24d48fad.prototype.booleanish = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.boolean = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.defined = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.number = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.property = '';
$931174b915b83d11$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.space = undefined;


var $f295bb9197e9852c$exports = {};

$parcel$export($f295bb9197e9852c$exports, "boolean", () => $f295bb9197e9852c$export$4a21f16c33752377);
$parcel$export($f295bb9197e9852c$exports, "booleanish", () => $f295bb9197e9852c$export$55e9e1fbc638dc8f);
$parcel$export($f295bb9197e9852c$exports, "overloadedBoolean", () => $f295bb9197e9852c$export$242ac3d3042558aa);
$parcel$export($f295bb9197e9852c$exports, "number", () => $f295bb9197e9852c$export$98e628dec113755e);
$parcel$export($f295bb9197e9852c$exports, "spaceSeparated", () => $f295bb9197e9852c$export$ab8645c862eb5a3e);
$parcel$export($f295bb9197e9852c$exports, "commaSeparated", () => $f295bb9197e9852c$export$9c8d678629b3d3);
$parcel$export($f295bb9197e9852c$exports, "commaOrSpaceSeparated", () => $f295bb9197e9852c$export$2ad25cfebf36cacd);
let $f295bb9197e9852c$var$powers = 0;
const $f295bb9197e9852c$export$4a21f16c33752377 = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$55e9e1fbc638dc8f = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$242ac3d3042558aa = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$98e628dec113755e = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$ab8645c862eb5a3e = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$9c8d678629b3d3 = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$2ad25cfebf36cacd = $f295bb9197e9852c$var$increment();
function $f295bb9197e9852c$var$increment() {
    return 2 ** ++$f295bb9197e9852c$var$powers;
}


const $fde6eb78b575b4e1$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($f295bb9197e9852c$exports);
class $fde6eb78b575b4e1$export$ea6b9f0064e88c9b extends (0, $931174b915b83d11$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $fde6eb78b575b4e1$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $fde6eb78b575b4e1$var$checks.length){
            const check = $fde6eb78b575b4e1$var$checks[index];
            $fde6eb78b575b4e1$var$mark(this, $fde6eb78b575b4e1$var$checks[index], (mask & $f295bb9197e9852c$exports[check]) === $f295bb9197e9852c$exports[check]);
        }
    }
}
$fde6eb78b575b4e1$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $fde6eb78b575b4e1$var$mark(values, key, value) {
    if (value) values[key] = value;
}



function $bd8fc82c7dbd2264$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $fde6eb78b575b4e1$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $ba2c06c56b858c9f$export$a3295358bff77e)(property)] = property;
        normals[(0, $ba2c06c56b858c9f$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $5b6f5f4bade80e38$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $a7a872812b997c09$export$4d2d26490572750a = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaColIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaColSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaControls: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaPressed: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaRowIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaRowSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaSelected: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueMin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueNow: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $e47247141b1c434c$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $a8641c7a75429d5d$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $e47247141b1c434c$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $cb6d793047917c76$export$c0bb0b647f701bb5 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        acceptCharset: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        accessKey: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        allowUserMedia: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        alpha: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        autoFocus: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        autoPlay: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        blocking: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        cite: null,
        className: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $f295bb9197e9852c$export$98e628dec113755e),
        colSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        controls: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        controlsList: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        coords: (0, $f295bb9197e9852c$export$98e628dec113755e) | (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        defer: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        download: (0, $f295bb9197e9852c$export$242ac3d3042558aa),
        draggable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        height: (0, $f295bb9197e9852c$export$98e628dec113755e),
        hidden: (0, $f295bb9197e9852c$export$242ac3d3042558aa),
        high: (0, $f295bb9197e9852c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        itemRef: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        itemScope: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        itemType: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        low: (0, $f295bb9197e9852c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        multiple: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        muted: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noValidate: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        optimum: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        required: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        reversed: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        rows: (0, $f295bb9197e9852c$export$98e628dec113755e),
        rowSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        sandbox: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        seamless: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        selected: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootClonable: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shape: null,
        size: (0, $f295bb9197e9852c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $f295bb9197e9852c$export$98e628dec113755e),
        spellCheck: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $f295bb9197e9852c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        width: (0, $f295bb9197e9852c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $f295bb9197e9852c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        declare: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $f295bb9197e9852c$export$98e628dec113755e),
        leftMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        marginWidth: (0, $f295bb9197e9852c$export$98e628dec113755e),
        noResize: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noHref: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noShade: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noWrap: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $f295bb9197e9852c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        disablePictureInPicture: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        exportParts: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        part: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $f295bb9197e9852c$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $a8641c7a75429d5d$export$32b9e4cec9c208e1)
});





const $e49bd033a0fe3be1$export$7ed1367e7fa1ad68 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        accentHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        amplitude: (0, $f295bb9197e9852c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $f295bb9197e9852c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $f295bb9197e9852c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        className: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        diffuseConstant: (0, $f295bb9197e9852c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $f295bb9197e9852c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $f295bb9197e9852c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $f295bb9197e9852c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        g2: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        glyphName: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $f295bb9197e9852c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        horizOriginX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        horizOriginY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k1: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k2: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k3: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k4: (0, $f295bb9197e9852c$export$98e628dec113755e),
        kernelMatrix: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $f295bb9197e9852c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $f295bb9197e9852c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        overlineThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pointsAtY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pointsAtZ: (0, $f295bb9197e9852c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        rev: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $f295bb9197e9852c$export$98e628dec113755e),
        specularExponent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strikethroughThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strokeOpacity: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $f295bb9197e9852c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        tabIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        targetY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        underlineThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $f295bb9197e9852c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vMathematical: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vIdeographic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vertOriginX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vertOriginY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $e47247141b1c434c$export$5b10b3bc32d7efbc)
});



const $ec16e1a70aace7f3$export$2bd1230ec7600845 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $d7385802919f055d$export$e20c24a128671213 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $a8641c7a75429d5d$export$32b9e4cec9c208e1)
});



const $77e09804dbfc627e$export$f2913fe8983302e = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});



/**
 * @import {Schema} from 'property-information'
 */ 


const $bf985dcc478ecc33$var$cap = /[A-Z]/g;
const $bf985dcc478ecc33$var$dash = /-[a-z]/g;
const $bf985dcc478ecc33$var$valid = /^data[-\w.:]+$/i;
function $bf985dcc478ecc33$export$71aa6c912b956294(schema, value) {
    const normal = (0, $ba2c06c56b858c9f$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $931174b915b83d11$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $bf985dcc478ecc33$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($bf985dcc478ecc33$var$dash, $bf985dcc478ecc33$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$bf985dcc478ecc33$var$dash.test(rest)) {
                let dashes = rest.replace($bf985dcc478ecc33$var$cap, $bf985dcc478ecc33$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $fde6eb78b575b4e1$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $bf985dcc478ecc33$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $bf985dcc478ecc33$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}



const $4a602dd2fd780674$export$c0bb0b647f701bb5 = (0, $61ded5fe6f037163$export$4950aa0f605343fb)([
    (0, $a7a872812b997c09$export$4d2d26490572750a),
    (0, $cb6d793047917c76$export$c0bb0b647f701bb5),
    (0, $ec16e1a70aace7f3$export$2bd1230ec7600845),
    (0, $d7385802919f055d$export$e20c24a128671213),
    (0, $77e09804dbfc627e$export$f2913fe8983302e)
], 'html');
const $4a602dd2fd780674$export$7ed1367e7fa1ad68 = (0, $61ded5fe6f037163$export$4950aa0f605343fb)([
    (0, $a7a872812b997c09$export$4d2d26490572750a),
    (0, $e49bd033a0fe3be1$export$7ed1367e7fa1ad68),
    (0, $ec16e1a70aace7f3$export$2bd1230ec7600845),
    (0, $d7385802919f055d$export$e20c24a128671213),
    (0, $77e09804dbfc627e$export$f2913fe8983302e)
], 'svg');


/**
 * @import {Nodes, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $d8755cce0f2ae50e$var$own = {}.hasOwnProperty;
function $d8755cce0f2ae50e$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $d8755cce0f2ae50e$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $d8755cce0f2ae50e$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Comment, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $be83e113c792aa3e$var$defaultSubsetRegex = /["&'<>`]/g;
const $be83e113c792aa3e$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $be83e113c792aa3e$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $be83e113c792aa3e$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $be83e113c792aa3e$var$subsetToRegexCache = new WeakMap();
function $be83e113c792aa3e$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $be83e113c792aa3e$var$charactersToExpressionCached(options.subset) : $be83e113c792aa3e$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($be83e113c792aa3e$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($be83e113c792aa3e$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $be83e113c792aa3e$var$charactersToExpressionCached(subset) {
    let cached = $be83e113c792aa3e$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $be83e113c792aa3e$var$charactersToExpression(subset);
        $be83e113c792aa3e$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $be83e113c792aa3e$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($be83e113c792aa3e$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $df81b310ceb23cda$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $df81b310ceb23cda$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$df81b310ceb23cda$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $05dab367b75fcb8f$var$decimalRegex = /\d/;
function $05dab367b75fcb8f$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$05dab367b75fcb8f$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


/**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $de999355bf6886a7$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $31f92da27c931dcb$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $4539a3a1194c77d4$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $2509c2fe35eb8a8e$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $2509c2fe35eb8a8e$var$characters = {};
/** @type {string} */ let $2509c2fe35eb8a8e$var$key;
for($2509c2fe35eb8a8e$var$key in 0, $31f92da27c931dcb$export$40952e41c47e8e55)if ($2509c2fe35eb8a8e$var$own.call((0, $31f92da27c931dcb$export$40952e41c47e8e55), $2509c2fe35eb8a8e$var$key)) $2509c2fe35eb8a8e$var$characters[(0, $31f92da27c931dcb$export$40952e41c47e8e55)[$2509c2fe35eb8a8e$var$key]] = $2509c2fe35eb8a8e$var$key;
const $2509c2fe35eb8a8e$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $2509c2fe35eb8a8e$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($2509c2fe35eb8a8e$var$own.call($2509c2fe35eb8a8e$var$characters, character)) {
        const name = $2509c2fe35eb8a8e$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $de999355bf6886a7$export$9545335bdecb4b8c).includes(name) && !(0, $4539a3a1194c77d4$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $2509c2fe35eb8a8e$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $c8f16a60635b4c95$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $df81b310ceb23cda$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $2509c2fe35eb8a8e$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $05dab367b75fcb8f$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $4a5926d13de942f8$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $51ed71ac0e17212a$export$aca9de459d63ca2e(value, options) {
    return (0, $be83e113c792aa3e$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $c8f16a60635b4c95$export$f53904683bee23d7)
    }, options));
}
function $51ed71ac0e17212a$export$a2577b9dadf100a3(value, options) {
    return (0, $be83e113c792aa3e$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $4a5926d13de942f8$export$83cfa611e0071208)
    }, options));
}


const $e81367c0d9e28649$var$htmlCommentRegex = /^>|^->|<!--|-->|--!>|<!-$/g;
// Declare arrays as variables so it can be cached by `stringifyEntities`
const $e81367c0d9e28649$var$bogusCommentEntitySubset = [
    '>'
];
const $e81367c0d9e28649$var$commentEntitySubset = [
    '<',
    '>'
];
function $e81367c0d9e28649$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? '<?' + (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $e81367c0d9e28649$var$bogusCommentEntitySubset
    })) + '>' : '<!--' + node.value.replace($e81367c0d9e28649$var$htmlCommentRegex, encode) + '-->';
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)($0, Object.assign({}, state.settings.characterReferences, {
            subset: $e81367c0d9e28649$var$commentEntitySubset
        }));
    }
}


/**
 * @import {Doctype, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a doctype.
 *
 * @param {Doctype} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $892d0aa686fc15c4$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return '<!' + (state.settings.upperDoctype ? 'DOCTYPE' : 'doctype') + (state.settings.tightDoctype ? '' : ' ') + 'html>';
}


/**
 * @import {Element, Parents, Properties} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $0a2ba9e7c068e553$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $7ae77a5ec40be267$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $7ae77a5ec40be267$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $71c7202b4e4c47aa$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $71c7202b4e4c47aa$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}



/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $fd7a7f8b3a6986d8$var$re = /[ \t\n\f\r]/g;
function $fd7a7f8b3a6986d8$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $fd7a7f8b3a6986d8$var$empty(thing.value) : false : $fd7a7f8b3a6986d8$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $fd7a7f8b3a6986d8$var$empty(value) {
    return value.replace($fd7a7f8b3a6986d8$var$re, '') === '';
}


/**
 * @import {Parents, RootContent} from 'hast'
 */ 
const $4028a14ad7e5b42e$export$a0f7cf204d8f22ba = $4028a14ad7e5b42e$var$siblings(1);
const $4028a14ad7e5b42e$export$b103c35f55382246 = $4028a14ad7e5b42e$var$siblings(-1);
/** @type {Array<RootContent>} */ const $4028a14ad7e5b42e$var$emptyChildren = [];
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $4028a14ad7e5b42e$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @template {Parents} Parent
   *   Parent type.
   * @param {Parent | undefined} parent
   *   Parent.
   * @param {number | undefined} index
   *   Index of child in `parent`.
   * @param {boolean | undefined} [includeWhitespace=false]
   *   Whether to include whitespace (default: `false`).
   * @returns {Parent extends {children: Array<infer Child>} ? Child | undefined : never}
   *   Child of parent.
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : $4028a14ad7e5b42e$var$emptyChildren;
        let offset = (index || 0) + increment;
        let next = siblings[offset];
        if (!includeWhitespace) while(next && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(next)){
            offset += increment;
            next = siblings[offset];
        }
        // @ts-expect-error: it’s a correct child.
        return next;
    }
}


/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @callback OmitHandle
 *   Check if a tag can be omitted.
 * @param {Element} element
 *   Element to check.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether to omit a tag.
 *
 */ const $f4eb25417ae3fbc0$var$own = {}.hasOwnProperty;
function $f4eb25417ae3fbc0$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $f4eb25417ae3fbc0$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}


const $feba5139081efb7b$export$4e69df80cd44263b = (0, $f4eb25417ae3fbc0$export$67d072dabf9c1c63)({
    body: $feba5139081efb7b$var$body,
    caption: $feba5139081efb7b$var$headOrColgroupOrCaption,
    colgroup: $feba5139081efb7b$var$headOrColgroupOrCaption,
    dd: $feba5139081efb7b$var$dd,
    dt: $feba5139081efb7b$var$dt,
    head: $feba5139081efb7b$var$headOrColgroupOrCaption,
    html: $feba5139081efb7b$var$html,
    li: $feba5139081efb7b$var$li,
    optgroup: $feba5139081efb7b$var$optgroup,
    option: $feba5139081efb7b$var$option,
    p: $feba5139081efb7b$var$p,
    rp: $feba5139081efb7b$var$rubyElement,
    rt: $feba5139081efb7b$var$rubyElement,
    tbody: $feba5139081efb7b$var$tbody,
    td: $feba5139081efb7b$var$cells,
    tfoot: $feba5139081efb7b$var$tfoot,
    th: $feba5139081efb7b$var$cells,
    thead: $feba5139081efb7b$var$thead,
    tr: $feba5139081efb7b$var$tr
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index, true);
    return !next || next.type !== 'comment' && !(next.type === 'text' && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$html(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$body(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$p(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return next ? next.type === 'element' && (next.tagName === 'address' || next.tagName === 'article' || next.tagName === 'aside' || next.tagName === 'blockquote' || next.tagName === 'details' || next.tagName === 'div' || next.tagName === 'dl' || next.tagName === 'fieldset' || next.tagName === 'figcaption' || next.tagName === 'figure' || next.tagName === 'footer' || next.tagName === 'form' || next.tagName === 'h1' || next.tagName === 'h2' || next.tagName === 'h3' || next.tagName === 'h4' || next.tagName === 'h5' || next.tagName === 'h6' || next.tagName === 'header' || next.tagName === 'hgroup' || next.tagName === 'hr' || next.tagName === 'main' || next.tagName === 'menu' || next.tagName === 'nav' || next.tagName === 'ol' || next.tagName === 'p' || next.tagName === 'pre' || next.tagName === 'section' || next.tagName === 'table' || next.tagName === 'ul') : !parent || // Confusing parent.
    !(parent.type === 'element' && (parent.tagName === 'a' || parent.tagName === 'audio' || parent.tagName === 'del' || parent.tagName === 'ins' || parent.tagName === 'map' || parent.tagName === 'noscript' || parent.tagName === 'video'));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$li(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'li';
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$dt(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd'));
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$dd(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd');
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$rubyElement(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'rp' || next.tagName === 'rt');
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$optgroup(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'optgroup';
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$option(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'option' || next.tagName === 'optgroup');
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$thead(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot'));
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tbody(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot');
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tfoot(_, index, parent) {
    return !(0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tr(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'tr';
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$cells(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'td' || next.tagName === 'th');
}


/**
 * @import {Element, Parents} from 'hast'
 */ 



const $bd647600c029e7d0$export$47fa9d71658d4a69 = (0, $f4eb25417ae3fbc0$export$67d072dabf9c1c63)({
    body: $bd647600c029e7d0$var$body,
    colgroup: $bd647600c029e7d0$var$colgroup,
    head: $bd647600c029e7d0$var$head,
    html: $bd647600c029e7d0$var$html,
    tbody: $bd647600c029e7d0$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$html(node) {
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1);
    return !head || head.type !== 'comment';
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$head(node) {
    /** @type {Set<string>} */ const seen = new Set();
    // Whether `srcdoc` or not,
    // make sure the content model at least doesn’t have too many `base`s/`title`s.
    for (const child of node.children)if (child.type === 'element' && (child.tagName === 'base' || child.tagName === 'title')) {
        if (seen.has(child.tagName)) return false;
        seen.add(child.tagName);
    }
    // “May be omitted if the element is empty,
    // or if the first thing inside the head element is an element.”
    const child = node.children[0];
    return !child || child.type === 'element';
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$body(node) {
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1, true);
    return !head || head.type !== 'comment' && !(head.type === 'text' && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(head.value.charAt(0))) && !(head.type === 'element' && (head.tagName === 'meta' || head.tagName === 'link' || head.tagName === 'script' || head.tagName === 'style' || head.tagName === 'template'));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$colgroup(node, index, parent) {
    const previous = (0, $4028a14ad7e5b42e$export$b103c35f55382246)(parent, index);
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === 'element' && previous.tagName === 'colgroup' && (0, $feba5139081efb7b$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'col');
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$tbody(node, index, parent) {
    const previous = (0, $4028a14ad7e5b42e$export$b103c35f55382246)(parent, index);
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === 'element' && (previous.tagName === 'thead' || previous.tagName === 'tbody') && (0, $feba5139081efb7b$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'tr');
}


/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'double' | 'name' | 'single' | 'unquoted', Array<[Array<string>, Array<string>]>>}
 */ const $82a2b91dde661e6d$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            '\t\n\f\r &/=>'.split(''),
            '\t\n\f\r "&\'/=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'/<=>'.split(''),
            '\0\t\n\f\r "&\'/<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            '\t\n\f\r &>'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'<=>`'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(''),
            '"&\'`'.split('')
        ],
        [
            "\0&'".split(''),
            '\0"&\'`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(''),
            '"&\'`'.split('')
        ],
        [
            '\0"&'.split(''),
            '\0"&\'`'.split('')
        ]
    ]
};
function $82a2b91dde661e6d$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === 'svg' ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === 'svg' ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === 'html' && node.tagName === 'svg') state.schema = (0, $4a602dd2fd780674$export$7ed1367e7fa1ad68);
    const attributes = $82a2b91dde661e6d$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === 'html' && node.tagName === 'template' ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    // Note: `menuitem` has since been removed from the HTML spec, and so is no
    // longer void.
    if (content) selfClosing = false;
    if (attributes || !omit || !(0, $bd647600c029e7d0$export$47fa9d71658d4a69)(node, index, parent)) {
        parts.push('<', node.tagName, attributes ? ' ' + attributes : '');
        if (selfClosing && (schema.space === 'svg' || state.settings.closeSelfClosing)) {
            last = attributes.charAt(attributes.length - 1);
            if (!state.settings.tightSelfClosing || last === '/' || last && last !== '"' && last !== "'") parts.push(' ');
            parts.push('/');
        }
        parts.push('>');
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $feba5139081efb7b$export$4e69df80cd44263b)(node, index, parent))) parts.push('</' + node.tagName + '>');
    return parts.join('');
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} properties
 * @returns {string}
 */ function $82a2b91dde661e6d$var$serializeAttributes(state, properties) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (properties) {
        for(key in properties)if (properties[key] !== null && properties[key] !== undefined) {
            const value = $82a2b91dde661e6d$var$serializeAttribute(state, key, properties[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : undefined;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += ' ';
    }
    return values.join('');
}
/**
 * @param {State} state
 * @param {string} key
 * @param {Properties[keyof Properties]} value
 * @returns {string}
 */ function $82a2b91dde661e6d$var$serializeAttribute(state, key, value) {
    const info = (0, $bf985dcc478ecc33$export$71aa6c912b956294)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === 'html' ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === '')) value = true;
    else if ((info.boolean || info.overloadedBoolean) && (typeof value !== 'string' || value === info.attribute || value === '')) value = Boolean(value);
    if (value === null || value === undefined || value === false || typeof value === 'number' && Number.isNaN(value)) return '';
    const name = (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $82a2b91dde661e6d$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $7ae77a5ec40be267$export$fac44ee5b035f737) : (0, $71c7202b4e4c47aa$export$fac44ee5b035f737))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
        attribute: true,
        subset: $82a2b91dde661e6d$var$constants.unquoted[x][y]
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $0a2ba9e7c068e553$export$fa42eaa97a352e23)(value, quote) > (0, $0a2ba9e7c068e553$export$fa42eaa97a352e23)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $82a2b91dde661e6d$var$constants.single : $82a2b91dde661e6d$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? '=' + result : result);
}


/**
 * @import {Parents} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ /**
 * @import {Parents, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ 
// Declare array as variable so it can be cached by `stringifyEntities`
const $50b699f262121f17$var$textEntitySubset = [
    '<',
    '&'
];
function $50b699f262121f17$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === 'element' && (parent.tagName === 'script' || parent.tagName === 'style') ? node.value : (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $50b699f262121f17$var$textEntitySubset
    }));
}


function $775880d0a9609b89$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $50b699f262121f17$export$6f093cfa640b7166)(node, index, parent, state);
}


/**
 * @import {Parents, Root} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $e9951500f110139c$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}



const $f16bb97f0156693a$export$8f34ce051745d39e = (0, $d8755cce0f2ae50e$export$d6a12bfbbedf6185)('type', {
    invalid: $f16bb97f0156693a$var$invalid,
    unknown: $f16bb97f0156693a$var$unknown,
    handlers: {
        comment: $e81367c0d9e28649$export$4a34f930e789283c,
        doctype: $892d0aa686fc15c4$export$3c172dfa1c27da99,
        element: $82a2b91dde661e6d$export$8454457683f90105,
        raw: $775880d0a9609b89$export$1776c186c69df29e,
        root: $e9951500f110139c$export$e8e78c978b129247,
        text: $50b699f262121f17$export$6f093cfa640b7166
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $f16bb97f0156693a$var$invalid(node) {
    throw new Error('Expected node, not `' + node + '`');
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node_
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $f16bb97f0156693a$var$unknown(node_) {
    // `type` is guaranteed by runtime JS.
    const node = /** @type {Nodes} */ node_;
    throw new Error('Cannot compile unknown node `' + node.type + '`');
}


/** @type {Options} */ const $3ac6c8c7f8865417$var$emptyOptions = {};
/** @type {CharacterReferences} */ const $3ac6c8c7f8865417$var$emptyCharacterReferences = {};
/** @type {Array<never>} */ const $3ac6c8c7f8865417$var$emptyChildren = [];
function $3ac6c8c7f8865417$export$a10125c086a4df16(tree, options) {
    const options_ = options || $3ac6c8c7f8865417$var$emptyOptions;
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Invalid quote `' + quote + '`, expected `\'` or `"`');
    /** @type {State} */ const state = {
        one: $3ac6c8c7f8865417$var$one,
        all: $3ac6c8c7f8865417$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $aa609dabe8f29803$export$762508062d068de),
            characterReferences: options_.characterReferences || $3ac6c8c7f8865417$var$emptyCharacterReferences,
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === 'svg' ? (0, $4a602dd2fd780674$export$7ed1367e7fa1ad68) : (0, $4a602dd2fd780674$export$c0bb0b647f701bb5),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: 'root',
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $3ac6c8c7f8865417$var$one(node, index, parent) {
    return (0, $f16bb97f0156693a$export$8f34ce051745d39e)(node, index, parent, this);
}
function $3ac6c8c7f8865417$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || $3ac6c8c7f8865417$var$emptyChildren;
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join('');
}


//#region src/utils/hast.ts
const $affc016a43a42f97$var$RE_WHITESPACE = /\s+/g;
/**
* Utility to append class to a hast node
*
* If the `property.class` is a string, it will be splitted by space and converted to an array.
*/ function $affc016a43a42f97$export$12efa744f94fc0a9(node, className) {
    if (!className) return node;
    node.properties ||= {};
    node.properties.class ||= [];
    if (typeof node.properties.class === "string") node.properties.class = node.properties.class.split($affc016a43a42f97$var$RE_WHITESPACE);
    if (!Array.isArray(node.properties.class)) node.properties.class = [];
    const targets = Array.isArray(className) ? className : className.split($affc016a43a42f97$var$RE_WHITESPACE);
    for (const c of targets)if (c && !node.properties.class.includes(c)) node.properties.class.push(c);
    return node;
}
//#endregion
//#region src/utils/strings.ts
const $affc016a43a42f97$var$RE_LANG_ATTR = /:?lang=["']([^"']+)["']/g;
const $affc016a43a42f97$var$RE_CODE_FENCE = /(?:```|~~~)([\w-]+)/g;
const $affc016a43a42f97$var$RE_LATEX_BEGIN = /\\begin\{([\w-]+)\}/g;
const $affc016a43a42f97$var$RE_SCRIPT_LANG = /<script\s+(?:type|lang)=["']([^"']+)["']/gi;
const $affc016a43a42f97$var$RE_FRONTMATTER = /^\s*---\r?\n[\s\S]*?\r?\n---(?:\r?\n|\s*$)/;
/**
* Creates a converter between index and position in a code block.
*
* Overflow/underflow are unchecked.
*/ function $affc016a43a42f97$export$a1eb53fafbd3302c(code) {
    const lines = (0, $ef3f42056ac626ab$export$88c07fe39db9eaa1)(code, true).map(([line])=>line);
    function indexToPos(index) {
        if (index === code.length) return {
            line: lines.length - 1,
            character: lines.at(-1).length
        };
        let character = index;
        let line = 0;
        for (const lineText of lines){
            if (character < lineText.length) break;
            character -= lineText.length;
            line++;
        }
        return {
            line: line,
            character: character
        };
    }
    function posToIndex(line, character) {
        let index = 0;
        for(let i = 0; i < line; i++)index += lines[i].length;
        index += character;
        return index;
    }
    return {
        lines: lines,
        indexToPos: indexToPos,
        posToIndex: posToIndex
    };
}
/**
* Guess embedded languages from given code and highlighter.
*
* When highlighter is provided, only bundled languages will be included.
*
* @param code - The code string to analyze
* @param _lang - The primary language of the code (currently unused)
* @param highlighter - Optional highlighter instance to validate languages
* @returns Array of detected language identifiers
*
* @example
* ```ts
* // Detects 'javascript' from Vue SFC
* guessEmbeddedLanguages('<script lang="javascript">')
*
* // Detects 'python' from markdown code block
* guessEmbeddedLanguages('```python\nprint("hi")\n```')
* ```
*/ function $affc016a43a42f97$export$5f773a1df8c6e1aa(code, _lang, highlighter) {
    const langs = /* @__PURE__ */ new Set();
    for (const match of code.matchAll($affc016a43a42f97$var$RE_LANG_ATTR)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($affc016a43a42f97$var$RE_CODE_FENCE)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($affc016a43a42f97$var$RE_LATEX_BEGIN)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($affc016a43a42f97$var$RE_SCRIPT_LANG)){
        const fullType = match[1].toLowerCase().trim();
        const lang = fullType.includes("/") ? fullType.split("/").pop() : fullType;
        if (lang) langs.add(lang);
    }
    if ($affc016a43a42f97$var$RE_FRONTMATTER.test(code)) langs.add("yaml");
    if (!highlighter) return [
        ...langs
    ];
    const bundle = highlighter.getBundledLanguages();
    return [
        ...langs
    ].filter((l)=>l && bundle[l]);
}
const $affc016a43a42f97$var$COLOR_KEYS = [
    "color",
    "background-color"
];
//#endregion
//#region src/utils/tokens.ts
/**
* Split a token into multiple tokens by given offsets.
*
* The offsets are relative to the token, and should be sorted.
*/ function $affc016a43a42f97$export$b3cd5664f2c9e388(token, offsets) {
    let lastOffset = 0;
    const tokens = [];
    for (const offset of offsets){
        if (offset > lastOffset) tokens.push({
            ...token,
            content: token.content.slice(lastOffset, offset),
            offset: token.offset + lastOffset
        });
        lastOffset = offset;
    }
    if (lastOffset < token.content.length) tokens.push({
        ...token,
        content: token.content.slice(lastOffset),
        offset: token.offset + lastOffset
    });
    return tokens;
}
function $affc016a43a42f97$var$findFirstBreakpointAfter(breakpoints, offset) {
    let start = 0;
    let end = breakpoints.length;
    while(start < end){
        const middle = start + (end - start >> 1);
        if (breakpoints[middle] <= offset) start = middle + 1;
        else end = middle;
    }
    return start;
}
/**
* Split 2D tokens array by given breakpoints.
*/ function $affc016a43a42f97$export$d3e0fdeef870cacb(tokens, breakpoints) {
    const sorted = [
        ...breakpoints instanceof Set ? breakpoints : new Set(breakpoints)
    ].sort((a, b)=>a - b);
    if (!sorted.length) return tokens;
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            const tokenEnd = token.offset + token.content.length;
            const start = $affc016a43a42f97$var$findFirstBreakpointAfter(sorted, token.offset);
            let end = start;
            while(end < sorted.length && sorted[end] < tokenEnd)end++;
            if (start === end) return token;
            const breakpointsInToken = sorted.slice(start, end);
            for(let index = 0; index < breakpointsInToken.length; index++)breakpointsInToken[index] -= token.offset;
            return $affc016a43a42f97$export$b3cd5664f2c9e388(token, breakpointsInToken);
        });
    });
}
function $affc016a43a42f97$export$5a4c68029315ecd7(merged, variantsOrder, cssVariablePrefix, defaultColor, colorsRendering = "css-vars") {
    const token = {
        content: merged.content,
        explanation: merged.explanation,
        offset: merged.offset
    };
    const styles = variantsOrder.map((t)=>$affc016a43a42f97$export$94ffab218337d127(merged.variants[t]));
    const styleKeys = new Set(styles.flatMap((t)=>Object.keys(t)));
    const mergedStyles = {};
    const varKey = (idx, key)=>{
        const keyName = key === "color" ? "" : key === "background-color" ? "-bg" : `-${key}`;
        return cssVariablePrefix + variantsOrder[idx] + (key === "color" ? "" : keyName);
    };
    styles.forEach((cur, idx)=>{
        for (const key of styleKeys){
            const value = cur[key] || "inherit";
            if (idx === 0 && defaultColor && $affc016a43a42f97$var$COLOR_KEYS.includes(key)) {
                if (defaultColor === "light-dark()" && styles.length > 1) {
                    const lightIndex = variantsOrder.findIndex((t)=>t === "light");
                    const darkIndex = variantsOrder.findIndex((t)=>t === "dark");
                    if (lightIndex === -1 || darkIndex === -1) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("When using `defaultColor: \"light-dark()\"`, you must provide both `light` and `dark` themes");
                    const lightValue = styles[lightIndex][key] || "inherit";
                    const darkValue = styles[darkIndex][key] || "inherit";
                    mergedStyles[key] = `light-dark(${lightValue}, ${darkValue})`;
                    if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
                } else mergedStyles[key] = value;
            } else if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
        }
    });
    token.htmlStyle = mergedStyles;
    return token;
}
function $affc016a43a42f97$export$94ffab218337d127(token) {
    const styles = {};
    if (token.color) styles.color = token.color;
    if (token.bgColor) styles["background-color"] = token.bgColor;
    if (token.fontStyle) {
        if (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Italic) styles["font-style"] = "italic";
        if (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Bold) styles["font-weight"] = "bold";
        const decorations = [];
        if (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Underline) decorations.push("underline");
        if (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Strikethrough) decorations.push("line-through");
        if (decorations.length) styles["text-decoration"] = decorations.join(" ");
    }
    return styles;
}
function $affc016a43a42f97$export$10559b52119e8d5f(token) {
    if (typeof token === "string") return token;
    return Object.entries(token).map(([key, value])=>`${key}:${value}`).join(";");
}
//#endregion
//#region src/transformer-decorations.ts
/**
* A built-in transformer to add decorations to the highlighted code.
*/ function $affc016a43a42f97$export$b094ad6c92e029a8() {
    const map = /* @__PURE__ */ new WeakMap();
    function getContext(shiki) {
        if (!map.has(shiki.meta)) {
            const converter = $affc016a43a42f97$export$a1eb53fafbd3302c(shiki.source);
            function normalizePosition(p) {
                if (typeof p === "number") {
                    if (p < 0 || p > shiki.source.length) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Invalid decoration offset: ${p}. Code length: ${shiki.source.length}`);
                    return {
                        ...converter.indexToPos(p),
                        offset: p
                    };
                } else {
                    const line = converter.lines[p.line];
                    if (line === void 0) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Lines length: ${converter.lines.length}`);
                    let character = p.character;
                    if (character < 0) character = line.length + character;
                    if (character < 0 || character > line.length) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Line ${p.line} length: ${line.length}`);
                    return {
                        ...p,
                        character: character,
                        offset: converter.posToIndex(p.line, character)
                    };
                }
            }
            const decorations = (shiki.options.decorations || []).map((d)=>({
                    ...d,
                    start: normalizePosition(d.start),
                    end: normalizePosition(d.end)
                }));
            $affc016a43a42f97$var$verifyIntersections(decorations);
            map.set(shiki.meta, {
                decorations: decorations,
                converter: converter,
                source: shiki.source
            });
        }
        return map.get(shiki.meta);
    }
    return {
        name: "shiki:decorations",
        tokens (tokens) {
            if (!this.options.decorations?.length) return;
            return $affc016a43a42f97$export$d3e0fdeef870cacb(tokens, getContext(this).decorations.flatMap((d)=>[
                    d.start.offset,
                    d.end.offset
                ]));
        },
        code (codeEl) {
            if (!this.options.decorations?.length) return;
            const ctx = getContext(this);
            const lines = [
                ...codeEl.children
            ].filter((i)=>i.type === "element" && i.tagName === "span");
            if (lines.length !== ctx.converter.lines.length) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Number of lines in code element (${lines.length}) does not match the number of lines in the source (${ctx.converter.lines.length}). Failed to apply decorations.`);
            function applyLineSection(line, start, end, decoration) {
                const lineEl = lines[line];
                let text = "";
                let startIndex = -1;
                let endIndex = -1;
                if (start === 0) startIndex = 0;
                if (end === 0) endIndex = 0;
                if (end === Number.POSITIVE_INFINITY) endIndex = lineEl.children.length;
                if (startIndex === -1 || endIndex === -1) for(let i = 0; i < lineEl.children.length; i++){
                    text += $affc016a43a42f97$var$stringify(lineEl.children[i]);
                    if (startIndex === -1 && text.length === start) startIndex = i + 1;
                    if (endIndex === -1 && text.length === end) endIndex = i + 1;
                }
                if (startIndex === -1) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Failed to find start index for decoration ${JSON.stringify(decoration.start)}`);
                if (endIndex === -1) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Failed to find end index for decoration ${JSON.stringify(decoration.end)}`);
                const children = lineEl.children.slice(startIndex, endIndex);
                if (!decoration.alwaysWrap && children.length === lineEl.children.length) applyDecoration(lineEl, decoration, "line");
                else if (!decoration.alwaysWrap && children.length === 1 && children[0].type === "element") applyDecoration(children[0], decoration, "token");
                else {
                    const wrapper = {
                        type: "element",
                        tagName: "span",
                        properties: {},
                        children: children
                    };
                    applyDecoration(wrapper, decoration, "wrapper");
                    lineEl.children.splice(startIndex, children.length, wrapper);
                }
            }
            function applyLine(line, decoration) {
                lines[line] = applyDecoration(lines[line], decoration, "line");
            }
            function applyDecoration(el, decoration, type) {
                const properties = decoration.properties || {};
                const transform = decoration.transform || ((i)=>i);
                el.tagName = decoration.tagName || "span";
                el.properties = {
                    ...el.properties,
                    ...properties,
                    class: el.properties.class
                };
                if (decoration.properties?.class) $affc016a43a42f97$export$12efa744f94fc0a9(el, decoration.properties.class);
                el = transform(el, type) || el;
                return el;
            }
            const lineApplies = [];
            const sorted = ctx.decorations.sort((a, b)=>b.start.offset - a.start.offset || a.end.offset - b.end.offset);
            for (const decoration of sorted){
                const { start: start, end: end } = decoration;
                if (start.line === end.line) applyLineSection(start.line, start.character, end.character, decoration);
                else if (start.line < end.line) {
                    applyLineSection(start.line, start.character, Number.POSITIVE_INFINITY, decoration);
                    for(let i = start.line + 1; i < end.line; i++)lineApplies.unshift(()=>applyLine(i, decoration));
                    applyLineSection(end.line, 0, end.character, decoration);
                }
            }
            lineApplies.forEach((i)=>i());
        }
    };
}
function $affc016a43a42f97$var$verifyIntersections(items) {
    for(let i = 0; i < items.length; i++){
        const foo = items[i];
        if (foo.start.offset > foo.end.offset) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Invalid decoration range: ${JSON.stringify(foo.start)} - ${JSON.stringify(foo.end)}`);
        for(let j = i + 1; j < items.length; j++){
            const bar = items[j];
            const isFooHasBarStart = foo.start.offset <= bar.start.offset && bar.start.offset < foo.end.offset;
            const isFooHasBarEnd = foo.start.offset < bar.end.offset && bar.end.offset <= foo.end.offset;
            const isBarHasFooStart = bar.start.offset <= foo.start.offset && foo.start.offset < bar.end.offset;
            const isBarHasFooEnd = bar.start.offset < foo.end.offset && foo.end.offset <= bar.end.offset;
            if (isFooHasBarStart || isFooHasBarEnd || isBarHasFooStart || isBarHasFooEnd) {
                if (isFooHasBarStart && isFooHasBarEnd) continue;
                if (isBarHasFooStart && isBarHasFooEnd) continue;
                if (isBarHasFooStart && foo.start.offset === foo.end.offset) continue;
                if (isFooHasBarEnd && bar.start.offset === bar.end.offset) continue;
                throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Decorations ${JSON.stringify(foo.start)} and ${JSON.stringify(bar.start)} intersect.`);
            }
        }
    }
}
function $affc016a43a42f97$var$stringify(el) {
    if (el.type === "text") return el.value;
    if (el.type === "element") return el.children.map($affc016a43a42f97$var$stringify).join("");
    return "";
}
//#endregion
//#region src/highlight/_get-transformers.ts
const $affc016a43a42f97$var$builtInTransformers = [
    /* @__PURE__ */ $affc016a43a42f97$export$b094ad6c92e029a8()
];
function $affc016a43a42f97$var$getTransformers(options) {
    const transformers = $affc016a43a42f97$var$sortTransformersByEnforcement(options.transformers || []);
    return [
        ...transformers.pre,
        ...transformers.normal,
        ...transformers.post,
        ...$affc016a43a42f97$var$builtInTransformers
    ];
}
function $affc016a43a42f97$var$sortTransformersByEnforcement(transformers) {
    const pre = [];
    const post = [];
    const normal = [];
    for (const transformer of transformers)switch(transformer.enforce){
        case "pre":
            pre.push(transformer);
            break;
        case "post":
            post.push(transformer);
            break;
        default:
            normal.push(transformer);
    }
    return {
        pre: pre,
        post: post,
        normal: normal
    };
}
//#endregion
//#region ../../node_modules/.pnpm/ansi-sequence-parser@1.1.3/node_modules/ansi-sequence-parser/dist/index.js
var $affc016a43a42f97$var$namedColors = [
    "black",
    "red",
    "green",
    "yellow",
    "blue",
    "magenta",
    "cyan",
    "white",
    "brightBlack",
    "brightRed",
    "brightGreen",
    "brightYellow",
    "brightBlue",
    "brightMagenta",
    "brightCyan",
    "brightWhite"
];
var $affc016a43a42f97$var$decorations = {
    1: "bold",
    2: "dim",
    3: "italic",
    4: "underline",
    7: "reverse",
    8: "hidden",
    9: "strikethrough"
};
function $affc016a43a42f97$var$findSequence(value, position) {
    const nextEscape = value.indexOf("\x1B", position);
    if (nextEscape !== -1) {
        if (value[nextEscape + 1] === "[") {
            const nextClose = value.indexOf("m", nextEscape);
            if (nextClose !== -1) return {
                sequence: value.substring(nextEscape + 2, nextClose).split(";"),
                startPosition: nextEscape,
                position: nextClose + 1
            };
        }
    }
    return {
        position: value.length
    };
}
function $affc016a43a42f97$var$parseColor(sequence) {
    const colorMode = sequence.shift();
    if (colorMode === "2") {
        const rgb = sequence.splice(0, 3).map((x)=>Number.parseInt(x));
        if (rgb.length !== 3 || rgb.some((x)=>Number.isNaN(x))) return;
        return {
            type: "rgb",
            rgb: rgb
        };
    } else if (colorMode === "5") {
        const index = sequence.shift();
        if (index) return {
            type: "table",
            index: Number(index)
        };
    }
}
function $affc016a43a42f97$var$parseSequence(sequence) {
    const commands = [];
    while(sequence.length > 0){
        const code = sequence.shift();
        if (!code) continue;
        const codeInt = Number.parseInt(code);
        if (Number.isNaN(codeInt)) continue;
        if (codeInt === 0) commands.push({
            type: "resetAll"
        });
        else if (codeInt <= 9) {
            if ($affc016a43a42f97$var$decorations[codeInt]) commands.push({
                type: "setDecoration",
                value: $affc016a43a42f97$var$decorations[codeInt]
            });
        } else if (codeInt <= 29) {
            const decoration = $affc016a43a42f97$var$decorations[codeInt - 20];
            if (decoration) {
                commands.push({
                    type: "resetDecoration",
                    value: decoration
                });
                if (decoration === "dim") commands.push({
                    type: "resetDecoration",
                    value: "bold"
                });
            }
        } else if (codeInt <= 37) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $affc016a43a42f97$var$namedColors[codeInt - 30]
            }
        });
        else if (codeInt === 38) {
            const color = $affc016a43a42f97$var$parseColor(sequence);
            if (color) commands.push({
                type: "setForegroundColor",
                value: color
            });
        } else if (codeInt === 39) commands.push({
            type: "resetForegroundColor"
        });
        else if (codeInt <= 47) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $affc016a43a42f97$var$namedColors[codeInt - 40]
            }
        });
        else if (codeInt === 48) {
            const color = $affc016a43a42f97$var$parseColor(sequence);
            if (color) commands.push({
                type: "setBackgroundColor",
                value: color
            });
        } else if (codeInt === 49) commands.push({
            type: "resetBackgroundColor"
        });
        else if (codeInt === 53) commands.push({
            type: "setDecoration",
            value: "overline"
        });
        else if (codeInt === 55) commands.push({
            type: "resetDecoration",
            value: "overline"
        });
        else if (codeInt >= 90 && codeInt <= 97) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $affc016a43a42f97$var$namedColors[codeInt - 90 + 8]
            }
        });
        else if (codeInt >= 100 && codeInt <= 107) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $affc016a43a42f97$var$namedColors[codeInt - 100 + 8]
            }
        });
    }
    return commands;
}
function $affc016a43a42f97$var$createAnsiSequenceParser() {
    let foreground = null;
    let background = null;
    let decorations2 = /* @__PURE__ */ new Set();
    return {
        parse (value) {
            const tokens = [];
            let position = 0;
            do {
                const findResult = $affc016a43a42f97$var$findSequence(value, position);
                const text = findResult.sequence ? value.substring(position, findResult.startPosition) : value.substring(position);
                if (text.length > 0) tokens.push({
                    value: text,
                    foreground: foreground,
                    background: background,
                    decorations: new Set(decorations2)
                });
                if (findResult.sequence) {
                    const commands = $affc016a43a42f97$var$parseSequence(findResult.sequence);
                    for (const styleToken of commands)if (styleToken.type === "resetAll") {
                        foreground = null;
                        background = null;
                        decorations2.clear();
                    } else if (styleToken.type === "resetForegroundColor") foreground = null;
                    else if (styleToken.type === "resetBackgroundColor") background = null;
                    else if (styleToken.type === "resetDecoration") decorations2.delete(styleToken.value);
                    for (const styleToken of commands)if (styleToken.type === "setForegroundColor") foreground = styleToken.value;
                    else if (styleToken.type === "setBackgroundColor") background = styleToken.value;
                    else if (styleToken.type === "setDecoration") decorations2.add(styleToken.value);
                }
                position = findResult.position;
            }while (position < value.length);
            return tokens;
        }
    };
}
var $affc016a43a42f97$var$defaultNamedColorsMap = {
    black: "#000000",
    red: "#bb0000",
    green: "#00bb00",
    yellow: "#bbbb00",
    blue: "#0000bb",
    magenta: "#ff00ff",
    cyan: "#00bbbb",
    white: "#eeeeee",
    brightBlack: "#555555",
    brightRed: "#ff5555",
    brightGreen: "#00ff00",
    brightYellow: "#ffff55",
    brightBlue: "#5555ff",
    brightMagenta: "#ff55ff",
    brightCyan: "#55ffff",
    brightWhite: "#ffffff"
};
function $affc016a43a42f97$var$createColorPalette(namedColorsMap = $affc016a43a42f97$var$defaultNamedColorsMap) {
    function namedColor(name) {
        return namedColorsMap[name];
    }
    function rgbColor(rgb) {
        return `#${rgb.map((x)=>Math.max(0, Math.min(x, 255)).toString(16).padStart(2, "0")).join("")}`;
    }
    let colorTable;
    function getColorTable() {
        if (colorTable) return colorTable;
        colorTable = [];
        for(let i = 0; i < $affc016a43a42f97$var$namedColors.length; i++)colorTable.push(namedColor($affc016a43a42f97$var$namedColors[i]));
        let levels = [
            0,
            95,
            135,
            175,
            215,
            255
        ];
        for(let r = 0; r < 6; r++)for(let g = 0; g < 6; g++)for(let b = 0; b < 6; b++)colorTable.push(rgbColor([
            levels[r],
            levels[g],
            levels[b]
        ]));
        let level = 8;
        for(let i = 0; i < 24; i++, level += 10)colorTable.push(rgbColor([
            level,
            level,
            level
        ]));
        return colorTable;
    }
    function tableColor(index) {
        return getColorTable()[index];
    }
    function value(color) {
        switch(color.type){
            case "named":
                return namedColor(color.name);
            case "rgb":
                return rgbColor(color.rgb);
            case "table":
                return tableColor(color.index);
        }
    }
    return {
        value: value
    };
}
//#endregion
//#region src/highlight/code-to-tokens-ansi.ts
const $affc016a43a42f97$var$RE_HEX_COLOR = /#([0-9a-f]{3,8})/i;
const $affc016a43a42f97$var$RE_CSS_VAR_ANSI = /var\((--[\w-]+-ansi-[\w-]+)\)/;
/**
* Default ANSI palette (VSCode compatible fallbacks)
* Used when the theme does not define terminal.ansi* colors.
*/ const $affc016a43a42f97$var$defaultAnsiColors = {
    black: "#000000",
    red: "#cd3131",
    green: "#0DBC79",
    yellow: "#E5E510",
    blue: "#2472C8",
    magenta: "#BC3FBC",
    cyan: "#11A8CD",
    white: "#E5E5E5",
    brightBlack: "#666666",
    brightRed: "#F14C4C",
    brightGreen: "#23D18B",
    brightYellow: "#F5F543",
    brightBlue: "#3B8EEA",
    brightMagenta: "#D670D6",
    brightCyan: "#29B8DB",
    brightWhite: "#FFFFFF"
};
function $affc016a43a42f97$export$1e0554f7c12b87ed(theme, fileContents, options) {
    const colorReplacements = (0, $ef3f42056ac626ab$export$2f5d8722891c6610)(theme, options);
    const lines = (0, $ef3f42056ac626ab$export$88c07fe39db9eaa1)(fileContents);
    const colorPalette = $affc016a43a42f97$var$createColorPalette(Object.fromEntries($affc016a43a42f97$var$namedColors.map((name)=>{
        const key = `terminal.ansi${name[0].toUpperCase()}${name.substring(1)}`;
        return [
            name,
            theme.colors?.[key] || $affc016a43a42f97$var$defaultAnsiColors[name]
        ];
    })));
    const parser = $affc016a43a42f97$var$createAnsiSequenceParser();
    return lines.map((line)=>parser.parse(line[0]).map((token)=>{
            let color;
            let bgColor;
            if (token.decorations.has("reverse")) {
                color = token.background ? colorPalette.value(token.background) : theme.bg;
                bgColor = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
            } else {
                color = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
                bgColor = token.background ? colorPalette.value(token.background) : void 0;
            }
            color = (0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(color, colorReplacements);
            bgColor = (0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(bgColor, colorReplacements);
            if (token.decorations.has("dim")) color = $affc016a43a42f97$var$dimColor(color);
            let fontStyle = (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).None;
            if (token.decorations.has("bold")) fontStyle |= (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Bold;
            if (token.decorations.has("italic")) fontStyle |= (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Italic;
            if (token.decorations.has("underline")) fontStyle |= (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Underline;
            if (token.decorations.has("strikethrough")) fontStyle |= (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Strikethrough;
            return {
                content: token.value,
                offset: line[1],
                color: color,
                bgColor: bgColor,
                fontStyle: fontStyle
            };
        }));
}
/**
* Adds 50% alpha to a hex color string or the "-dim" postfix to a CSS variable
*/ function $affc016a43a42f97$var$dimColor(color) {
    const hexMatch = color.match($affc016a43a42f97$var$RE_HEX_COLOR);
    if (hexMatch) {
        const hex = hexMatch[1];
        if (hex.length === 8) {
            const alpha = Math.round(Number.parseInt(hex.slice(6, 8), 16) / 2).toString(16).padStart(2, "0");
            return `#${hex.slice(0, 6)}${alpha}`;
        } else if (hex.length === 6) return `#${hex}80`;
        else if (hex.length === 4) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            const a = hex[3];
            return `#${r}${r}${g}${g}${b}${b}${Math.round(Number.parseInt(`${a}${a}`, 16) / 2).toString(16).padStart(2, "0")}`;
        } else if (hex.length === 3) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            return `#${r}${r}${g}${g}${b}${b}80`;
        }
    }
    const cssVarMatch = color.match($affc016a43a42f97$var$RE_CSS_VAR_ANSI);
    if (cssVarMatch) return `var(${cssVarMatch[1]}-dim)`;
    return color;
}
//#endregion
//#region src/highlight/code-to-tokens-base.ts
/**
* Code to tokens, with a simple theme.
* This wraps the tokenizer's implementation to add ANSI support.
*/ function $affc016a43a42f97$export$9fcc555cdbb165d8(primitive, code, options = {}) {
    const lang = primitive.resolveLangAlias(options.lang || "text");
    const { theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if (!(0, $ef3f42056ac626ab$export$f98db15a0683bb96)(lang) && !(0, $ef3f42056ac626ab$export$3e6bc683d2a50c25)(themeName) && lang === "ansi") {
        const { theme: theme } = primitive.setTheme(themeName);
        return $affc016a43a42f97$export$1e0554f7c12b87ed(theme, code, options);
    }
    return (0, $ef3f42056ac626ab$export$9fcc555cdbb165d8)(primitive, code, options);
}
//#endregion
//#region src/highlight/code-to-tokens.ts
/**
* High-level code-to-tokens API.
*
* It will use `codeToTokensWithThemes` or `codeToTokensBase` based on the options.
*/ function $affc016a43a42f97$export$93965dfc9a82f052(primitive, code, options) {
    let bg;
    let fg;
    let tokens;
    let themeName;
    let rootStyle;
    let grammarState;
    if ("themes" in options) {
        const { defaultColor: defaultColor = "light", cssVariablePrefix: cssVariablePrefix = "--shiki-", colorsRendering: colorsRendering = "css-vars" } = options;
        const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
                color: i[0],
                theme: i[1]
            })).sort((a, b)=>a.color === defaultColor ? -1 : b.color === defaultColor ? 1 : 0);
        if (themes.length === 0) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("`themes` option must not be empty");
        const themeTokens = (0, $ef3f42056ac626ab$export$99552db3190ba9d3)(primitive, code, options, $affc016a43a42f97$export$9fcc555cdbb165d8);
        grammarState = (0, $ef3f42056ac626ab$export$47937e5383997945)(themeTokens);
        if (defaultColor && "light-dark()" !== defaultColor && !themes.some((t)=>t.color === defaultColor)) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`\`themes\` option must contain the defaultColor key \`${defaultColor}\``);
        const themeRegs = themes.map((t)=>primitive.getTheme(t.theme));
        const themesOrder = themes.map((t)=>t.color);
        tokens = themeTokens.map((line)=>line.map((token)=>$affc016a43a42f97$export$5a4c68029315ecd7(token, themesOrder, cssVariablePrefix, defaultColor, colorsRendering)));
        if (grammarState) (0, $ef3f42056ac626ab$export$85116f33c2060a4b)(tokens, grammarState);
        const themeColorReplacements = themes.map((t)=>(0, $ef3f42056ac626ab$export$2f5d8722891c6610)(t.theme, options));
        fg = $affc016a43a42f97$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "fg", colorsRendering);
        bg = $affc016a43a42f97$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "bg", colorsRendering);
        themeName = `shiki-themes ${themeRegs.map((t)=>t.name).join(" ")}`;
        rootStyle = defaultColor ? void 0 : [
            fg,
            bg
        ].join(";");
    } else if ("theme" in options) {
        const colorReplacements = (0, $ef3f42056ac626ab$export$2f5d8722891c6610)(options.theme, options);
        tokens = $affc016a43a42f97$export$9fcc555cdbb165d8(primitive, code, options);
        const _theme = primitive.getTheme(options.theme);
        bg = (0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(_theme.bg, colorReplacements);
        fg = (0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(_theme.fg, colorReplacements);
        themeName = _theme.name;
        grammarState = (0, $ef3f42056ac626ab$export$47937e5383997945)(tokens);
    } else throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("Invalid options, either `theme` or `themes` must be provided");
    return {
        tokens: tokens,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: rootStyle,
        grammarState: grammarState
    };
}
function $affc016a43a42f97$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, property, colorsRendering) {
    return themes.map((t, idx)=>{
        const value = (0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(themeRegs[idx][property], themeColorReplacements[idx]) || "inherit";
        const cssVar = `${cssVariablePrefix + t.color}${property === "bg" ? "-bg" : ""}:${value}`;
        if (idx === 0 && defaultColor) {
            if (defaultColor === "light-dark()" && themes.length > 1) {
                const lightIndex = themes.findIndex((t)=>t.color === "light");
                const darkIndex = themes.findIndex((t)=>t.color === "dark");
                if (lightIndex === -1 || darkIndex === -1) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)("When using `defaultColor: \"light-dark()\"`, you must provide both `light` and `dark` themes");
                return `light-dark(${(0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(themeRegs[lightIndex][property], themeColorReplacements[lightIndex]) || "inherit"}, ${(0, $ef3f42056ac626ab$export$ef30c5cede3b6b4a)(themeRegs[darkIndex][property], themeColorReplacements[darkIndex]) || "inherit"});${cssVar}`;
            }
            return value;
        }
        if (colorsRendering === "css-vars") return cssVar;
        return null;
    }).filter((i)=>!!i).join(";");
}
//#endregion
//#region src/highlight/code-to-hast.ts
const $affc016a43a42f97$var$RE_WHITESPACE_ONLY = /^\s+$/;
const $affc016a43a42f97$var$RE_LEADING_TRAILING_WHITESPACE = /^(\s*)(.*?)(\s*)$/;
function $affc016a43a42f97$export$9b49c0a3202a858c(primitive, code, options, transformerContext = {
    meta: {},
    options: options,
    codeToHast: (_code, _options)=>$affc016a43a42f97$export$9b49c0a3202a858c(primitive, _code, _options),
    codeToTokens: (_code, _options)=>$affc016a43a42f97$export$93965dfc9a82f052(primitive, _code, _options)
}) {
    let input = code;
    for (const transformer of $affc016a43a42f97$var$getTransformers(options))input = transformer.preprocess?.call(transformerContext, input, options) || input;
    let { tokens: tokens, fg: fg, bg: bg, themeName: themeName, rootStyle: rootStyle, grammarState: grammarState } = $affc016a43a42f97$export$93965dfc9a82f052(primitive, input, options);
    const { mergeWhitespaces: mergeWhitespaces = true, mergeSameStyleTokens: mergeSameStyleTokens = false } = options;
    if (mergeWhitespaces === true) tokens = $affc016a43a42f97$var$mergeWhitespaceTokens(tokens);
    else if (mergeWhitespaces === "never") tokens = $affc016a43a42f97$var$splitWhitespaceTokens(tokens);
    if (mergeSameStyleTokens) tokens = $affc016a43a42f97$var$mergeAdjacentStyledTokens(tokens);
    const contextSource = {
        ...transformerContext,
        get source () {
            return input;
        }
    };
    for (const transformer of $affc016a43a42f97$var$getTransformers(options))tokens = transformer.tokens?.call(contextSource, tokens) || tokens;
    return $affc016a43a42f97$export$ac3d0a92e97ad33e(tokens, {
        ...options,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: options.rootStyle === false ? false : options.rootStyle ?? rootStyle
    }, contextSource, grammarState);
}
function $affc016a43a42f97$export$ac3d0a92e97ad33e(tokens, options, transformerContext, grammarState = (0, $ef3f42056ac626ab$export$47937e5383997945)(tokens)) {
    const transformers = $affc016a43a42f97$var$getTransformers(options);
    const lines = [];
    const root = {
        type: "root",
        children: []
    };
    const { structure: structure = "classic", tabindex: tabindex = "0" } = options;
    const properties = {
        class: `shiki ${options.themeName || ""}`
    };
    if (options.rootStyle !== false) {
        if (options.rootStyle != null) properties.style = options.rootStyle;
        else properties.style = `background-color:${options.bg};color:${options.fg}`;
    }
    if (tabindex !== false && tabindex != null) properties.tabindex = tabindex.toString();
    for (const [key, value] of Object.entries(options.meta || {}))if (!key.startsWith("_")) properties[key] = value;
    let preNode = {
        type: "element",
        tagName: "pre",
        properties: properties,
        children: [],
        data: options.data
    };
    let codeNode = {
        type: "element",
        tagName: "code",
        properties: {},
        children: lines
    };
    const lineNodes = [];
    const context = {
        ...transformerContext,
        structure: structure,
        addClassToHast: $affc016a43a42f97$export$12efa744f94fc0a9,
        get source () {
            return transformerContext.source;
        },
        get tokens () {
            return tokens;
        },
        get options () {
            return options;
        },
        get root () {
            return root;
        },
        get pre () {
            return preNode;
        },
        get code () {
            return codeNode;
        },
        get lines () {
            return lineNodes;
        }
    };
    tokens.forEach((line, idx)=>{
        if (idx) {
            if (structure === "inline") root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            else if (structure === "classic") lines.push({
                type: "text",
                value: "\n"
            });
        }
        let lineNode = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        let col = 0;
        for (const token of line){
            let tokenNode = {
                type: "element",
                tagName: "span",
                properties: {
                    ...token.htmlAttrs
                },
                children: [
                    {
                        type: "text",
                        value: token.content
                    }
                ]
            };
            const style = $affc016a43a42f97$export$10559b52119e8d5f(token.htmlStyle || $affc016a43a42f97$export$94ffab218337d127(token));
            if (style) tokenNode.properties.style = style;
            for (const transformer of transformers)tokenNode = transformer?.span?.call(context, tokenNode, idx + 1, col, lineNode, token) || tokenNode;
            if (structure === "inline") root.children.push(tokenNode);
            else if (structure === "classic") lineNode.children.push(tokenNode);
            col += token.content.length;
        }
        if (structure === "classic") {
            for (const transformer of transformers)lineNode = transformer?.line?.call(context, lineNode, idx + 1) || lineNode;
            lineNodes.push(lineNode);
            lines.push(lineNode);
        } else if (structure === "inline") lineNodes.push(lineNode);
    });
    if (structure === "classic") {
        for (const transformer of transformers)codeNode = transformer?.code?.call(context, codeNode) || codeNode;
        preNode.children.push(codeNode);
        for (const transformer of transformers)preNode = transformer?.pre?.call(context, preNode) || preNode;
        root.children.push(preNode);
    } else if (structure === "inline") {
        const syntheticLines = [];
        let currentLine = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        for (const child of root.children)if (child.type === "element" && child.tagName === "br") {
            syntheticLines.push(currentLine);
            currentLine = {
                type: "element",
                tagName: "span",
                properties: {
                    class: "line"
                },
                children: []
            };
        } else if (child.type === "element" || child.type === "text") currentLine.children.push(child);
        syntheticLines.push(currentLine);
        let transformedCode = {
            type: "element",
            tagName: "code",
            properties: {},
            children: syntheticLines
        };
        for (const transformer of transformers)transformedCode = transformer?.code?.call(context, transformedCode) || transformedCode;
        root.children = [];
        for(let i = 0; i < transformedCode.children.length; i++){
            if (i > 0) root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            const line = transformedCode.children[i];
            if (line.type === "element") root.children.push(...line.children);
        }
    }
    let result = root;
    for (const transformer of transformers)result = transformer?.root?.call(context, result) || result;
    if (grammarState) (0, $ef3f42056ac626ab$export$85116f33c2060a4b)(result, grammarState);
    return result;
}
function $affc016a43a42f97$var$mergeWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        let carryOnContent = "";
        let firstOffset;
        line.forEach((token, idx)=>{
            const couldMerge = !(token.fontStyle && (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Strikethrough));
            if (couldMerge && $affc016a43a42f97$var$RE_WHITESPACE_ONLY.test(token.content) && line[idx + 1]) {
                if (firstOffset === void 0) firstOffset = token.offset;
                carryOnContent += token.content;
            } else if (carryOnContent) {
                if (couldMerge) newLine.push({
                    ...token,
                    offset: firstOffset,
                    content: carryOnContent + token.content
                });
                else newLine.push({
                    content: carryOnContent,
                    offset: firstOffset
                }, token);
                firstOffset = void 0;
                carryOnContent = "";
            } else newLine.push(token);
        });
        return newLine;
    });
}
function $affc016a43a42f97$var$splitWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            if ($affc016a43a42f97$var$RE_WHITESPACE_ONLY.test(token.content)) return token;
            const match = token.content.match($affc016a43a42f97$var$RE_LEADING_TRAILING_WHITESPACE);
            if (!match) return token;
            const [, leading, content, trailing] = match;
            if (!leading && !trailing) return token;
            const expanded = [
                {
                    ...token,
                    offset: token.offset + leading.length,
                    content: content
                }
            ];
            if (leading) expanded.unshift({
                content: leading,
                offset: token.offset
            });
            if (trailing) expanded.push({
                content: trailing,
                offset: token.offset + leading.length + content.length
            });
            return expanded;
        });
    });
}
function $affc016a43a42f97$var$mergeAdjacentStyledTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        for (const token of line){
            if (newLine.length === 0) {
                newLine.push({
                    ...token
                });
                continue;
            }
            const prevToken = newLine.at(-1);
            const prevStyle = $affc016a43a42f97$export$10559b52119e8d5f(prevToken.htmlStyle || $affc016a43a42f97$export$94ffab218337d127(prevToken));
            const currentStyle = $affc016a43a42f97$export$10559b52119e8d5f(token.htmlStyle || $affc016a43a42f97$export$94ffab218337d127(token));
            const isPrevDecorated = prevToken.fontStyle && (prevToken.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Underline || prevToken.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Strikethrough);
            const isDecorated = token.fontStyle && (token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $b5e49ecb88b9a024$export$23b468d4ca3f8c96).Strikethrough);
            if (!isPrevDecorated && !isDecorated && prevStyle === currentStyle) prevToken.content += token.content;
            else newLine.push({
                ...token
            });
        }
        return newLine;
    });
}
//#endregion
//#region src/highlight/code-to-html.ts
const $affc016a43a42f97$export$4f3973dc2959ebf3 = (0, $3ac6c8c7f8865417$export$a10125c086a4df16);
/**
* Get highlighted code in HTML.
*/ function $affc016a43a42f97$export$74ba11990fba86b4(primitive, code, options) {
    const context = {
        meta: {},
        options: options,
        codeToHast: (_code, _options)=>$affc016a43a42f97$export$9b49c0a3202a858c(primitive, _code, _options),
        codeToTokens: (_code, _options)=>$affc016a43a42f97$export$93965dfc9a82f052(primitive, _code, _options)
    };
    let result = $affc016a43a42f97$export$4f3973dc2959ebf3($affc016a43a42f97$export$9b49c0a3202a858c(primitive, code, options, context));
    for (const transformer of $affc016a43a42f97$var$getTransformers(options))result = transformer.postprocess?.call(context, result, options) || result;
    return result;
}
//#endregion
//#region src/constructors/highlighter.ts
/**
* Create a Shiki core highlighter instance, with no languages or themes bundled.
* Wasm and each language and theme must be loaded manually.
*
* @see http://shiki.style/guide/bundles#fine-grained-bundle
*/ async function $affc016a43a42f97$export$731e59ef5bc9b980(options) {
    const primitive = await (0, $ef3f42056ac626ab$export$7118aaae6ff863ad)(options);
    return {
        getLastGrammarState: (...args)=>(0, $ef3f42056ac626ab$export$e79a48b8b5fd83c5)(primitive, ...args),
        codeToTokensBase: (code, options)=>$affc016a43a42f97$export$9fcc555cdbb165d8(primitive, code, options),
        codeToTokensWithThemes: (code, options)=>(0, $ef3f42056ac626ab$export$99552db3190ba9d3)(primitive, code, options),
        codeToTokens: (code, options)=>$affc016a43a42f97$export$93965dfc9a82f052(primitive, code, options),
        codeToHast: (code, options)=>$affc016a43a42f97$export$9b49c0a3202a858c(primitive, code, options),
        codeToHtml: (code, options)=>$affc016a43a42f97$export$74ba11990fba86b4(primitive, code, options),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...primitive,
        getInternalContext: ()=>primitive
    };
}
/**
* Create a Shiki core highlighter instance, with no languages or themes bundled.
* Wasm and each language and theme must be loaded manually.
*
* Synchronous version of `createHighlighterCore`, which requires to provide the engine and all themes and languages upfront.
*
* @see http://shiki.style/guide/bundles#fine-grained-bundle
*/ function $affc016a43a42f97$export$f38e8c16be9dd57d(options) {
    const internal = (0, $ef3f42056ac626ab$export$993d8e1d5e5fb61b)(options);
    return {
        getLastGrammarState: (...args)=>(0, $ef3f42056ac626ab$export$e79a48b8b5fd83c5)(internal, ...args),
        codeToTokensBase: (code, options)=>$affc016a43a42f97$export$9fcc555cdbb165d8(internal, code, options),
        codeToTokensWithThemes: (code, options)=>(0, $ef3f42056ac626ab$export$99552db3190ba9d3)(internal, code, options),
        codeToTokens: (code, options)=>$affc016a43a42f97$export$93965dfc9a82f052(internal, code, options),
        codeToHast: (code, options)=>$affc016a43a42f97$export$9b49c0a3202a858c(internal, code, options),
        codeToHtml: (code, options)=>$affc016a43a42f97$export$74ba11990fba86b4(internal, code, options),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...internal,
        getInternalContext: ()=>internal
    };
}
function $affc016a43a42f97$export$708f4903c06f244f(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighterCore(options) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: options.themes || [],
                langs: options.langs || []
            });
            return _shiki;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighterCore;
}
const $affc016a43a42f97$export$ebfcaa8c37a8db2c = /* @__PURE__ */ $affc016a43a42f97$export$708f4903c06f244f($affc016a43a42f97$export$731e59ef5bc9b980);
//#endregion
//#region src/constructors/bundle-factory.ts
function $affc016a43a42f97$export$8ca362031a26944a(options) {
    const bundledLanguages = options.langs;
    const bundledThemes = options.themes;
    const engine = options.engine;
    async function createHighlighter(options) {
        function resolveLang(lang) {
            if (typeof lang === "string") {
                lang = options.langAlias?.[lang] || lang;
                if ((0, $ef3f42056ac626ab$export$5c3e2a1e13c5c906)(lang)) return [];
                const bundle = bundledLanguages[lang];
                if (!bundle) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Language \`${lang}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return lang;
        }
        function resolveTheme(theme) {
            if ((0, $ef3f42056ac626ab$export$cd4537af2d43769e)(theme)) return "none";
            if (typeof theme === "string") {
                const bundle = bundledThemes[theme];
                if (!bundle) throw new (0, $4730dfad1a6b90a4$export$5003b41ce90ff8c9)(`Theme \`${theme}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return theme;
        }
        const _themes = (options.themes ?? []).map((i)=>resolveTheme(i));
        const langs = (options.langs ?? []).map((i)=>resolveLang(i));
        const core = await $affc016a43a42f97$export$731e59ef5bc9b980({
            engine: options.engine ?? engine(),
            ...options,
            themes: _themes,
            langs: langs
        });
        return {
            ...core,
            loadLanguage (...langs) {
                return core.loadLanguage(...langs.map(resolveLang));
            },
            loadTheme (...themes) {
                return core.loadTheme(...themes.map(resolveTheme));
            },
            getBundledLanguages () {
                return bundledLanguages;
            },
            getBundledThemes () {
                return bundledThemes;
            }
        };
    }
    return createHighlighter;
}
function $affc016a43a42f97$export$c08cf9c73e9e5934(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighter(options = {}) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: [],
                langs: []
            });
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighter;
}
function $affc016a43a42f97$export$3706d1cd2b0dba33(createHighlighter, config) {
    const getSingletonHighlighter = $affc016a43a42f97$export$c08cf9c73e9e5934(createHighlighter);
    async function get(code, options) {
        const shiki = await getSingletonHighlighter({
            langs: [
                options.lang
            ],
            themes: "theme" in options ? [
                options.theme
            ] : Object.values(options.themes)
        });
        const langs = await config?.guessEmbeddedLanguages?.(code, options.lang, shiki);
        if (langs) await shiki.loadLanguage(...langs);
        return shiki;
    }
    return {
        getSingletonHighlighter (options) {
            return getSingletonHighlighter(options);
        },
        async codeToHtml (code, options) {
            return (await get(code, options)).codeToHtml(code, options);
        },
        async codeToHast (code, options) {
            return (await get(code, options)).codeToHast(code, options);
        },
        async codeToTokens (code, options) {
            return (await get(code, options)).codeToTokens(code, options);
        },
        async codeToTokensBase (code, options) {
            return (await get(code, options)).codeToTokensBase(code, options);
        },
        async codeToTokensWithThemes (code, options) {
            return (await get(code, options)).codeToTokensWithThemes(code, options);
        },
        async getLastGrammarState (code, options) {
            return (await getSingletonHighlighter({
                langs: [
                    options.lang
                ],
                themes: [
                    options.theme
                ]
            })).getLastGrammarState(code, options);
        }
    };
}
//#endregion
//#region src/theme-css-variables.ts
/**
* A factory function to create a css-variable-based theme
*
* @see https://shiki.style/guide/theme-colors#css-variables-theme
*/ function $affc016a43a42f97$export$73f45de8f69a7c80(options = {}) {
    const { name: name = "css-variables", variablePrefix: variablePrefix = "--shiki-", fontStyle: fontStyle = true } = options;
    const variable = (name)=>{
        if (options.variableDefaults?.[name]) return `var(${variablePrefix}${name}, ${options.variableDefaults[name]})`;
        return `var(${variablePrefix}${name})`;
    };
    const theme = {
        name: name,
        type: "dark",
        colors: {
            "editor.foreground": variable("foreground"),
            "editor.background": variable("background"),
            "terminal.ansiBlack": variable("ansi-black"),
            "terminal.ansiRed": variable("ansi-red"),
            "terminal.ansiGreen": variable("ansi-green"),
            "terminal.ansiYellow": variable("ansi-yellow"),
            "terminal.ansiBlue": variable("ansi-blue"),
            "terminal.ansiMagenta": variable("ansi-magenta"),
            "terminal.ansiCyan": variable("ansi-cyan"),
            "terminal.ansiWhite": variable("ansi-white"),
            "terminal.ansiBrightBlack": variable("ansi-bright-black"),
            "terminal.ansiBrightRed": variable("ansi-bright-red"),
            "terminal.ansiBrightGreen": variable("ansi-bright-green"),
            "terminal.ansiBrightYellow": variable("ansi-bright-yellow"),
            "terminal.ansiBrightBlue": variable("ansi-bright-blue"),
            "terminal.ansiBrightMagenta": variable("ansi-bright-magenta"),
            "terminal.ansiBrightCyan": variable("ansi-bright-cyan"),
            "terminal.ansiBrightWhite": variable("ansi-bright-white")
        },
        tokenColors: [
            {
                scope: [
                    "keyword.operator.accessor",
                    "meta.group.braces.round.function.arguments",
                    "meta.template.expression",
                    "markup.fenced_code meta.embedded.block"
                ],
                settings: {
                    foreground: variable("foreground")
                }
            },
            {
                scope: "emphasis",
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: [
                    "strong",
                    "markup.heading.markdown",
                    "markup.bold.markdown"
                ],
                settings: {
                    fontStyle: "bold"
                }
            },
            {
                scope: [
                    "markup.italic.markdown"
                ],
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: "meta.link.inline.markdown",
                settings: {
                    fontStyle: "underline",
                    foreground: variable("token-link")
                }
            },
            {
                scope: [
                    "string",
                    "markup.fenced_code",
                    "markup.inline"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                scope: [
                    "comment",
                    "string.quoted.docstring.multi"
                ],
                settings: {
                    foreground: variable("token-comment")
                }
            },
            {
                scope: [
                    "constant.numeric",
                    "constant.language",
                    "constant.other.placeholder",
                    "constant.character.format.placeholder",
                    "variable.language.this",
                    "variable.other.object",
                    "variable.other.class",
                    "variable.other.constant",
                    "meta.property-name",
                    "meta.property-value",
                    "support"
                ],
                settings: {
                    foreground: variable("token-constant")
                }
            },
            {
                scope: [
                    "keyword",
                    "storage.modifier",
                    "storage.type",
                    "storage.control.clojure",
                    "entity.name.function.clojure",
                    "entity.name.tag.yaml",
                    "support.function.node",
                    "support.type.property-name.json",
                    "punctuation.separator.key-value",
                    "punctuation.definition.template-expression"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                scope: "variable.parameter.function",
                settings: {
                    foreground: variable("token-parameter")
                }
            },
            {
                scope: [
                    "support.function",
                    "entity.name.type",
                    "entity.other.inherited-class",
                    "meta.function-call",
                    "meta.instance.constructor",
                    "entity.other.attribute-name",
                    "entity.name.function",
                    "constant.keyword.clojure"
                ],
                settings: {
                    foreground: variable("token-function")
                }
            },
            {
                scope: [
                    "entity.name.tag",
                    "string.quoted",
                    "string.regexp",
                    "string.interpolated",
                    "string.template",
                    "string.unquoted.plain.out.yaml",
                    "keyword.other.template"
                ],
                settings: {
                    foreground: variable("token-string-expression")
                }
            },
            {
                scope: [
                    "punctuation.definition.arguments",
                    "punctuation.definition.dict",
                    "punctuation.separator",
                    "meta.function-call.arguments"
                ],
                settings: {
                    foreground: variable("token-punctuation")
                }
            },
            {
                scope: [
                    "markup.underline.link",
                    "punctuation.definition.metadata.markdown"
                ],
                settings: {
                    foreground: variable("token-link")
                }
            },
            {
                scope: [
                    "beginning.punctuation.definition.list.markdown"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                scope: [
                    "punctuation.definition.string.begin.markdown",
                    "punctuation.definition.string.end.markdown",
                    "string.other.link.title.markdown",
                    "string.other.link.description.markdown"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                scope: [
                    "markup.inserted",
                    "meta.diff.header.to-file",
                    "punctuation.definition.inserted"
                ],
                settings: {
                    foreground: variable("token-inserted")
                }
            },
            {
                scope: [
                    "markup.deleted",
                    "meta.diff.header.from-file",
                    "punctuation.definition.deleted"
                ],
                settings: {
                    foreground: variable("token-deleted")
                }
            },
            {
                scope: [
                    "markup.changed",
                    "punctuation.definition.changed"
                ],
                settings: {
                    foreground: variable("token-changed")
                }
            }
        ]
    };
    if (!fontStyle) theme.tokenColors = theme.tokenColors?.map((tokenColor)=>{
        if (tokenColor.settings?.fontStyle) delete tokenColor.settings.fontStyle;
        return tokenColor;
    });
    return theme;
}


//#region src/scanner.ts
const $ff959011b904cb5e$var$MAX = 4294967295;
function $ff959011b904cb5e$var$isSearchCacheable(regexp) {
    return !regexp.sticky && !regexp.rawOptions?.strategy;
}
function $ff959011b904cb5e$var$toResult(index, indices) {
    return {
        index: index,
        captureIndices: indices.map((indice)=>{
            if (indice == null) return {
                start: $ff959011b904cb5e$var$MAX,
                end: $ff959011b904cb5e$var$MAX,
                length: 0
            };
            return {
                start: indice[0],
                end: indice[1],
                length: indice[1] - indice[0]
            };
        })
    };
}
var $ff959011b904cb5e$export$7ccc53e8f1e7dfc5 = class {
    patterns;
    options;
    regexps;
    /**
	* Last search of each regexp on the current string, reused the way `vscode-oniguruma` does.
	* `null` for regexps whose searches can't be reused.
	*/ lastSearches;
    constructor(patterns, options = {}){
        this.patterns = patterns;
        this.options = options;
        const { forgiving: forgiving = false, cache: cache, regexConstructor: regexConstructor } = options;
        if (!regexConstructor) throw new Error("Option `regexConstructor` is not provided");
        this.regexps = patterns.map((p)=>{
            if (typeof p !== "string") return p;
            const cached = cache?.get(p);
            if (cached) {
                if (cached instanceof RegExp) return cached;
                if (forgiving) return null;
                throw cached;
            }
            try {
                const regex = regexConstructor(p);
                cache?.set(p, regex);
                return regex;
            } catch (e) {
                cache?.set(p, e);
                if (forgiving) return null;
                throw e;
            }
        });
        this.lastSearches = this.regexps.map((regexp)=>regexp && $ff959011b904cb5e$var$isSearchCacheable(regexp) ? {
                strId: 0,
                searchedFrom: 0,
                matchIndex: -1,
                indices: null
            } : null);
    }
    findNextMatchSync(string, startPosition, _options) {
        const str = typeof string === "string" ? string : string.content;
        const strId = typeof string === "string" ? 0 : string.id || 0;
        let bestIndex = -1;
        let bestMatchIndex = 0;
        let bestIndices = null;
        for(let i = 0; i < this.regexps.length; i++){
            const regexp = this.regexps[i];
            if (!regexp) continue;
            try {
                const last = strId ? this.lastSearches[i] : null;
                let matchIndex;
                let indices;
                if (last && last.strId === strId && last.searchedFrom <= startPosition && (last.matchIndex === -1 || last.matchIndex >= startPosition)) {
                    matchIndex = last.matchIndex;
                    indices = last.indices;
                } else {
                    regexp.lastIndex = startPosition;
                    const match = regexp.exec(str);
                    matchIndex = match ? match.index : -1;
                    indices = match ? match.indices : null;
                    if (last) {
                        last.strId = strId;
                        last.searchedFrom = startPosition;
                        last.matchIndex = matchIndex;
                        last.indices = indices;
                    }
                }
                if (matchIndex === -1) continue;
                if (matchIndex === startPosition) return $ff959011b904cb5e$var$toResult(i, indices);
                if (bestIndex === -1 || matchIndex < bestMatchIndex) {
                    bestIndex = i;
                    bestMatchIndex = matchIndex;
                    bestIndices = indices;
                }
            } catch (e) {
                if (this.options.forgiving) continue;
                throw e;
            }
        }
        return bestIndex === -1 ? null : $ff959011b904cb5e$var$toResult(bestIndex, bestIndices);
    }
};
//#endregion
//#region src/string.ts
let $ff959011b904cb5e$var$lastStringId = 0;
function $ff959011b904cb5e$export$625550452a3fa3ec(content) {
    return {
        content: content,
        id: ++$ff959011b904cb5e$var$lastStringId
    };
}


// src/utils.js
"use strict";
function $aaf1636a16b777ee$export$3226cf1d9b7b4bea(e) {
    if ([
        ...e
    ].length !== 1) throw new Error(`Expected "${e}" to be a single code point`);
    return e.codePointAt(0);
}
function $aaf1636a16b777ee$export$c4ed59b257196722(e, t, n) {
    return e.has(t) || e.set(t, n), e.get(t);
}
const $aaf1636a16b777ee$export$7b650c03beb4e566 = new Set([
    "alnum",
    "alpha",
    "ascii",
    "blank",
    "cntrl",
    "digit",
    "graph",
    "lower",
    "print",
    "punct",
    "space",
    "upper",
    "word",
    "xdigit"
]), $aaf1636a16b777ee$export$43caf9889c228507 = String.raw;
function $aaf1636a16b777ee$export$3b765e00c48ca2ba(e, t) {
    if (e == null) throw new Error(t ?? "Value expected");
    return e;
}


"use strict";
const $fbb0773712f256a7$var$m = (0, $aaf1636a16b777ee$export$43caf9889c228507)`\[\^?`, $fbb0773712f256a7$var$b = `c.? | C(?:-.?)?|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`[pP]\{(?:\^?[-\x20_]*[A-Za-z][-\x20\w]*\})?`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`x[89A-Fa-f]\p{AHex}(?:\\x[89A-Fa-f]\p{AHex})*`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`u(?:\p{AHex}{4})? | x\{[^\}]*\}? | x\p{AHex}{0,2}`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`o\{[^\}]*\}?`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`\d{1,3}`}`, $fbb0773712f256a7$var$y = /[?*+][?+]?|\{(?:\d+(?:,\d*)?|,\d+)\}\??/, $fbb0773712f256a7$var$C = new RegExp((0, $aaf1636a16b777ee$export$43caf9889c228507)`
  \\ (?:
    ${$fbb0773712f256a7$var$b}
    | [gk]<[^>]*>?
    | [gk]'[^']*'?
    | .
  )
  | \( (?:
    \? (?:
      [:=!>({]
      | <[=!]
      | <[^>]*>
      | '[^']*'
      | ~\|?
      | #(?:[^)\\]|\\.?)*
      | [^:)]*[:)]
    )?
    | \*[^\)]*\)?
  )?
  | (?:${$fbb0773712f256a7$var$y.source})+
  | ${$fbb0773712f256a7$var$m}
  | .
`.replace(/\s+/g, ""), "gsu"), $fbb0773712f256a7$var$T = new RegExp((0, $aaf1636a16b777ee$export$43caf9889c228507)`
  \\ (?:
    ${$fbb0773712f256a7$var$b}
    | .
  )
  | \[:(?:\^?\p{Alpha}+|\^):\]
  | ${$fbb0773712f256a7$var$m}
  | &&
  | .
`.replace(/\s+/g, ""), "gsu");
function $fbb0773712f256a7$export$660b2ee2d4fb4eff(e, n = {}) {
    const t = {
        flags: "",
        ...n,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...n.rules
        }
    };
    if (typeof e != "string") throw new Error("String expected as pattern");
    const o = $fbb0773712f256a7$var$Y(t.flags), s = [
        o.extended
    ], a = {
        captureGroup: t.rules.captureGroup,
        getCurrentModX () {
            return s.at(-1);
        },
        numOpenGroups: 0,
        popModX () {
            s.pop();
        },
        pushModX (u) {
            s.push(u);
        },
        replaceCurrentModX (u) {
            s[s.length - 1] = u;
        },
        singleline: t.rules.singleline
    };
    let r = [], i;
    for($fbb0773712f256a7$var$C.lastIndex = 0; i = $fbb0773712f256a7$var$C.exec(e);){
        const u = $fbb0773712f256a7$var$F(a, e, i[0], $fbb0773712f256a7$var$C.lastIndex);
        u.tokens ? r.push(...u.tokens) : u.token && r.push(u.token), u.lastIndex !== void 0 && ($fbb0773712f256a7$var$C.lastIndex = u.lastIndex);
    }
    const l = [];
    let c = 0;
    r.filter((u)=>u.type === "GroupOpen").forEach((u)=>{
        u.kind === "capturing" ? u.number = ++c : u.raw === "(" && l.push(u);
    }), c || l.forEach((u, S)=>{
        u.kind = "capturing", u.number = S + 1;
    });
    const g = c || l.length;
    return {
        tokens: r.map((u)=>u.type === "EscapedNumber" ? $fbb0773712f256a7$var$ee(u, g) : u).flat(),
        flags: o
    };
}
function $fbb0773712f256a7$var$F(e, n, t, o) {
    const [s, a] = t;
    if (t === "[" || t === "[^") {
        const r = $fbb0773712f256a7$var$K(n, t, o);
        return {
            tokens: r.tokens,
            lastIndex: r.lastIndex
        };
    }
    if (s === "\\") {
        if ("AbBGyYzZ".includes(a)) return {
            token: $fbb0773712f256a7$var$w(t, t)
        };
        if (/^\\g[<']/.test(t)) {
            if (!/^\\g(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $fbb0773712f256a7$var$R(t)
            };
        }
        if (/^\\k[<']/.test(t)) {
            if (!/^\\k(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $fbb0773712f256a7$var$A(t)
            };
        }
        if (a === "K") return {
            token: $fbb0773712f256a7$var$I("keep", t)
        };
        if (a === "N" || a === "R") return {
            token: $fbb0773712f256a7$var$k("newline", t, {
                negate: a === "N"
            })
        };
        if (a === "O") return {
            token: $fbb0773712f256a7$var$k("any", t)
        };
        if (a === "X") return {
            token: $fbb0773712f256a7$var$k("text_segment", t)
        };
        const r = $fbb0773712f256a7$var$x(t, {
            inCharClass: !1
        });
        return Array.isArray(r) ? {
            tokens: r
        } : {
            token: r
        };
    }
    if (s === "(") {
        if (a === "*") return {
            token: $fbb0773712f256a7$var$j(t)
        };
        if (t === "(?{") throw new Error(`Unsupported callout "${t}"`);
        if (t.startsWith("(?#")) {
            if (n[o] !== ")") throw new Error('Unclosed comment group "(?#"');
            return {
                lastIndex: o + 1
            };
        }
        if (/^\(\?[-imx]+[:)]$/.test(t)) return {
            token: $fbb0773712f256a7$var$L(t, e)
        };
        if (e.pushModX(e.getCurrentModX()), e.numOpenGroups++, t === "(" && !e.captureGroup || t === "(?:") return {
            token: $fbb0773712f256a7$var$f("group", t)
        };
        if (t === "(?>") return {
            token: $fbb0773712f256a7$var$f("atomic", t)
        };
        if (t === "(?=" || t === "(?!" || t === "(?<=" || t === "(?<!") return {
            token: $fbb0773712f256a7$var$f(t[2] === "<" ? "lookbehind" : "lookahead", t, {
                negate: t.endsWith("!")
            })
        };
        if (t === "(" && e.captureGroup || t.startsWith("(?<") && t.endsWith(">") || t.startsWith("(?'") && t.endsWith("'")) return {
            token: $fbb0773712f256a7$var$f("capturing", t, {
                ...t !== "(" && {
                    name: t.slice(3, -1)
                }
            })
        };
        if (t.startsWith("(?~")) {
            if (t === "(?~|") throw new Error(`Unsupported absence function kind "${t}"`);
            return {
                token: $fbb0773712f256a7$var$f("absence_repeater", t)
            };
        }
        throw t === "(?(" ? new Error(`Unsupported conditional "${t}"`) : new Error(`Invalid or unsupported group option "${t}"`);
    }
    if (t === ")") {
        if (e.popModX(), e.numOpenGroups--, e.numOpenGroups < 0) throw new Error('Unmatched ")"');
        return {
            token: $fbb0773712f256a7$var$Q(t)
        };
    }
    if (e.getCurrentModX()) {
        if (t === "#") {
            const r = n.indexOf(`
`, o);
            return {
                lastIndex: r === -1 ? n.length : r
            };
        }
        if (/^\s$/.test(t)) {
            const r = /\s+/y;
            return r.lastIndex = o, {
                lastIndex: r.exec(n) ? r.lastIndex : o
            };
        }
    }
    if (t === ".") return {
        token: $fbb0773712f256a7$var$k("dot", t)
    };
    if (t === "^" || t === "$") {
        const r = e.singleline ? ({
            "^": (0, $aaf1636a16b777ee$export$43caf9889c228507)`\A`,
            $: (0, $aaf1636a16b777ee$export$43caf9889c228507)`\Z`
        })[t] : t;
        return {
            token: $fbb0773712f256a7$var$w(r, t)
        };
    }
    return t === "|" ? {
        token: $fbb0773712f256a7$var$P(t)
    } : $fbb0773712f256a7$var$y.test(t) ? {
        tokens: $fbb0773712f256a7$var$te(t)
    } : {
        token: $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(t), t)
    };
}
function $fbb0773712f256a7$var$K(e, n, t) {
    const o = [
        $fbb0773712f256a7$var$E(n[1] === "^", n)
    ];
    let s = 1, a;
    for($fbb0773712f256a7$var$T.lastIndex = t; a = $fbb0773712f256a7$var$T.exec(e);){
        const r = a[0];
        if (r[0] === "[" && r[1] !== ":") s++, o.push($fbb0773712f256a7$var$E(r[1] === "^", r));
        else if (r === "]") {
            if (o.at(-1).type === "CharacterClassOpen") o.push($fbb0773712f256a7$var$d(93, r));
            else if (s--, o.push($fbb0773712f256a7$var$z(r)), !s) break;
        } else {
            const i = $fbb0773712f256a7$var$X(r);
            Array.isArray(i) ? o.push(...i) : o.push(i);
        }
    }
    return {
        tokens: o,
        lastIndex: $fbb0773712f256a7$var$T.lastIndex || e.length
    };
}
function $fbb0773712f256a7$var$X(e) {
    if (e[0] === "\\") return $fbb0773712f256a7$var$x(e, {
        inCharClass: !0
    });
    if (e[0] === "[") {
        const n = /\[:(?<negate>\^?)(?<name>[a-z]+):\]/.exec(e);
        if (!n || !(0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(n.groups.name)) throw new Error(`Invalid POSIX class "${e}"`);
        return $fbb0773712f256a7$var$k("posix", e, {
            value: n.groups.name,
            negate: !!n.groups.negate
        });
    }
    return e === "-" ? $fbb0773712f256a7$var$U(e) : e === "&&" ? $fbb0773712f256a7$var$H(e) : $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(e), e);
}
function $fbb0773712f256a7$var$x(e, { inCharClass: n }) {
    const t = e[1];
    if (t === "c" || t === "C") return $fbb0773712f256a7$var$Z(e);
    if ("dDhHsSwW".includes(t)) return $fbb0773712f256a7$var$q(e);
    if (e.startsWith((0, $aaf1636a16b777ee$export$43caf9889c228507)`\o{`)) throw new Error(`Incomplete, invalid, or unsupported octal code point "${e}"`);
    if (/^\\[pP]\{/.test(e)) {
        if (e.length === 3) throw new Error(`Incomplete or invalid Unicode property "${e}"`);
        return $fbb0773712f256a7$var$V(e);
    }
    if (/^\\x[89A-Fa-f]\p{AHex}/u.test(e)) try {
        const o = e.split(/\\x/).slice(1).map((i)=>parseInt(i, 16)), s = new TextDecoder("utf-8", {
            ignoreBOM: !0,
            fatal: !0
        }).decode(new Uint8Array(o)), a = new TextEncoder;
        return [
            ...s
        ].map((i)=>{
            const l = [
                ...a.encode(i)
            ].map((c)=>`\\x${c.toString(16)}`).join("");
            return $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(i), l);
        });
    } catch  {
        throw new Error(`Multibyte code "${e}" incomplete or invalid in Oniguruma`);
    }
    if (t === "u" || t === "x") return $fbb0773712f256a7$var$d($fbb0773712f256a7$var$J(e), e);
    if ($fbb0773712f256a7$var$$.has(t)) return $fbb0773712f256a7$var$d($fbb0773712f256a7$var$$.get(t), e);
    if (/\d/.test(t)) return $fbb0773712f256a7$var$W(n, e);
    if (e === "\\") throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Incomplete escape "\"`);
    if (t === "M") throw new Error(`Unsupported meta "${e}"`);
    if ([
        ...e
    ].length === 2) return $fbb0773712f256a7$var$d(e.codePointAt(1), e);
    throw new Error(`Unexpected escape "${e}"`);
}
function $fbb0773712f256a7$var$P(e) {
    return {
        type: "Alternator",
        raw: e
    };
}
function $fbb0773712f256a7$var$w(e, n) {
    return {
        type: "Assertion",
        kind: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$A(e) {
    return {
        type: "Backreference",
        raw: e
    };
}
function $fbb0773712f256a7$var$d(e, n) {
    return {
        type: "Character",
        value: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$z(e) {
    return {
        type: "CharacterClassClose",
        raw: e
    };
}
function $fbb0773712f256a7$var$U(e) {
    return {
        type: "CharacterClassHyphen",
        raw: e
    };
}
function $fbb0773712f256a7$var$H(e) {
    return {
        type: "CharacterClassIntersector",
        raw: e
    };
}
function $fbb0773712f256a7$var$E(e, n) {
    return {
        type: "CharacterClassOpen",
        negate: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$k(e, n, t = {}) {
    return {
        type: "CharacterSet",
        kind: e,
        ...t,
        raw: n
    };
}
function $fbb0773712f256a7$var$I(e, n, t = {}) {
    return e === "keep" ? {
        type: "Directive",
        kind: e,
        raw: n
    } : {
        type: "Directive",
        kind: e,
        flags: (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(t.flags),
        raw: n
    };
}
function $fbb0773712f256a7$var$W(e, n) {
    return {
        type: "EscapedNumber",
        inCharClass: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$Q(e) {
    return {
        type: "GroupClose",
        raw: e
    };
}
function $fbb0773712f256a7$var$f(e, n, t = {}) {
    return {
        type: "GroupOpen",
        kind: e,
        ...t,
        raw: n
    };
}
function $fbb0773712f256a7$var$D(e, n, t, o) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: n,
        arguments: t,
        raw: o
    };
}
function $fbb0773712f256a7$var$_(e, n, t, o) {
    return {
        type: "Quantifier",
        kind: e,
        min: n,
        max: t,
        raw: o
    };
}
function $fbb0773712f256a7$var$R(e) {
    return {
        type: "Subroutine",
        raw: e
    };
}
const $fbb0773712f256a7$var$B = new Set([
    "COUNT",
    "CMP",
    "ERROR",
    "FAIL",
    "MAX",
    "MISMATCH",
    "SKIP",
    "TOTAL_COUNT"
]), $fbb0773712f256a7$var$$ = new Map([
    [
        "a",
        7
    ],
    [
        "b",
        8
    ],
    [
        "e",
        27
    ],
    [
        "f",
        12
    ],
    [
        "n",
        10
    ],
    [
        "r",
        13
    ],
    [
        "t",
        9
    ],
    [
        "v",
        11
    ]
]);
function $fbb0773712f256a7$var$Z(e) {
    const n = e[1] === "c" ? e[2] : e[3];
    if (!n || !/[A-Za-z]/.test(n)) throw new Error(`Unsupported control character "${e}"`);
    return $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(n.toUpperCase()) - 64, e);
}
function $fbb0773712f256a7$var$L(e, n) {
    let { on: t, off: o } = /^\(\?(?<on>[imx]*)(?:-(?<off>[-imx]*))?/.exec(e).groups;
    o ??= "";
    const s = (n.getCurrentModX() || t.includes("x")) && !o.includes("x"), a = $fbb0773712f256a7$var$v(t), r = $fbb0773712f256a7$var$v(o), i = {};
    if (a && (i.enable = a), r && (i.disable = r), e.endsWith(")")) return n.replaceCurrentModX(s), $fbb0773712f256a7$var$I("flags", e, {
        flags: i
    });
    if (e.endsWith(":")) return n.pushModX(s), n.numOpenGroups++, $fbb0773712f256a7$var$f("group", e, {
        ...(a || r) && {
            flags: i
        }
    });
    throw new Error(`Unexpected flag modifier "${e}"`);
}
function $fbb0773712f256a7$var$j(e) {
    const n = /\(\*(?<name>[A-Za-z_]\w*)?(?:\[(?<tag>(?:[A-Za-z_]\w*)?)\])?(?:\{(?<args>[^}]*)\})?\)/.exec(e);
    if (!n) throw new Error(`Incomplete or invalid named callout "${e}"`);
    const { name: t, tag: o, args: s } = n.groups;
    if (!t) throw new Error(`Invalid named callout "${e}"`);
    if (o === "") throw new Error(`Named callout tag with empty value not allowed "${e}"`);
    const a = s ? s.split(",").filter((g)=>g !== "").map((g)=>/^[+-]?\d+$/.test(g) ? +g : g) : [], [r, i, l] = a, c = $fbb0773712f256a7$var$B.has(t) ? t.toLowerCase() : "custom";
    switch(c){
        case "fail":
        case "mismatch":
        case "skip":
            if (a.length > 0) throw new Error(`Named callout arguments not allowed "${a}"`);
            break;
        case "error":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (typeof r == "string") throw new Error(`Named callout argument must be a number "${r}"`);
            break;
        case "max":
            if (!a.length || a.length > 2) throw new Error(`Named callout must have one or two arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (a.length === 2 && (typeof i == "number" || !/^[<>X]$/.test(i))) throw new Error(`Named callout optional argument two must be '<', '>', or 'X' "${i}"`);
            break;
        case "count":
        case "total_count":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (a.length === 1 && (typeof r == "number" || !/^[<>X]$/.test(r))) throw new Error(`Named callout optional argument must be '<', '>', or 'X' "${r}"`);
            break;
        case "cmp":
            if (a.length !== 3) throw new Error(`Named callout must have three arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (typeof i == "number" || !/^(?:[<>!=]=|[<>])$/.test(i)) throw new Error(`Named callout argument two must be '==', '!=', '>', '<', '>=', or '<=' "${i}"`);
            if (typeof l == "string" && !/^[A-Za-z_]\w*$/.test(l)) throw new Error(`Named callout argument three must be a tag or number "${l}"`);
            break;
        case "custom":
            throw new Error(`Undefined callout name "${t}"`);
        default:
            throw new Error(`Unexpected named callout kind "${c}"`);
    }
    return $fbb0773712f256a7$var$D(c, o ?? null, s?.split(",") ?? null, e);
}
function $fbb0773712f256a7$var$O(e) {
    let n = null, t, o;
    if (e[0] === "{") {
        const { minStr: s, maxStr: a } = /^\{(?<minStr>\d*)(?:,(?<maxStr>\d*))?/.exec(e).groups, r = 1e5;
        if (+s > r || a && +a > r) throw new Error("Quantifier value unsupported in Oniguruma");
        if (t = +s, o = a === void 0 ? +s : a === "" ? 1 / 0 : +a, t > o && (n = "possessive", [t, o] = [
            o,
            t
        ]), e.endsWith("?")) {
            if (n === "possessive") throw new Error('Unsupported possessive interval quantifier chain with "?"');
            n = "lazy";
        } else n || (n = "greedy");
    } else t = e[0] === "+" ? 1 : 0, o = e[0] === "?" ? 1 : 1 / 0, n = e[1] === "+" ? "possessive" : e[1] === "?" ? "lazy" : "greedy";
    return $fbb0773712f256a7$var$_(n, t, o, e);
}
function $fbb0773712f256a7$var$q(e) {
    const n = e[1].toLowerCase();
    return $fbb0773712f256a7$var$k({
        d: "digit",
        h: "hex",
        s: "space",
        w: "word"
    }[n], e, {
        negate: e[1] !== n
    });
}
function $fbb0773712f256a7$var$V(e) {
    const { p: n, neg: t, value: o } = /^\\(?<p>[pP])\{(?<neg>\^?)(?<value>[^}]+)/.exec(e).groups;
    return $fbb0773712f256a7$var$k("property", e, {
        value: o,
        negate: n === "P" && !t || n === "p" && !!t
    });
}
function $fbb0773712f256a7$var$v(e) {
    const n = {};
    return e.includes("i") && (n.ignoreCase = !0), e.includes("m") && (n.dotAll = !0), e.includes("x") && (n.extended = !0), Object.keys(n).length ? n : null;
}
function $fbb0773712f256a7$var$Y(e) {
    const n = {
        ignoreCase: !1,
        dotAll: !1,
        extended: !1,
        digitIsAscii: !1,
        posixIsAscii: !1,
        spaceIsAscii: !1,
        wordIsAscii: !1,
        textSegmentMode: null
    };
    for(let t = 0; t < e.length; t++){
        const o = e[t];
        if (!"imxDPSWy".includes(o)) throw new Error(`Invalid flag "${o}"`);
        if (o === "y") {
            if (!/^y{[gw]}/.test(e.slice(t))) throw new Error('Invalid or unspecified flag "y" mode');
            n.textSegmentMode = e[t + 2] === "g" ? "grapheme" : "word", t += 3;
            continue;
        }
        n[({
            i: "ignoreCase",
            m: "dotAll",
            x: "extended",
            D: "digitIsAscii",
            P: "posixIsAscii",
            S: "spaceIsAscii",
            W: "wordIsAscii"
        })[o]] = !0;
    }
    return n;
}
function $fbb0773712f256a7$var$J(e) {
    if (/^(?:\\u(?!\p{AHex}{4})|\\x(?!\p{AHex}{1,2}|\{\p{AHex}{1,8}\}))/u.test(e)) throw new Error(`Incomplete or invalid escape "${e}"`);
    const n = e[2] === "{" ? /^\\x\{\s*(?<hex>\p{AHex}+)/u.exec(e).groups.hex : e.slice(2);
    return parseInt(n, 16);
}
function $fbb0773712f256a7$var$ee(e, n) {
    const { raw: t, inCharClass: o } = e, s = t.slice(1);
    if (!o && (s !== "0" && s.length === 1 || s[0] !== "0" && +s <= n)) return [
        $fbb0773712f256a7$var$A(t)
    ];
    const a = [], r = s.match(/^[0-7]+|\d/g);
    for(let i = 0; i < r.length; i++){
        const l = r[i];
        let c;
        if (i === 0 && l !== "8" && l !== "9") {
            if (c = parseInt(l, 8), c > 127) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Octal encoded byte above 177 unsupported "${t}"`);
        } else c = (0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(l);
        a.push($fbb0773712f256a7$var$d(c, (i === 0 ? "\\" : "") + l));
    }
    return a;
}
function $fbb0773712f256a7$var$te(e) {
    const n = [], t = new RegExp($fbb0773712f256a7$var$y, "gy");
    let o;
    for(; o = t.exec(e);){
        const s = o[0];
        if (s[0] === "{") {
            const a = /^\{(?<min>\d+),(?<max>\d+)\}\??$/.exec(s);
            if (a) {
                const { min: r, max: i } = a.groups;
                if (+r > +i && s.endsWith("?")) {
                    t.lastIndex--, n.push($fbb0773712f256a7$var$O(s.slice(0, -1)));
                    continue;
                }
            }
        }
        n.push($fbb0773712f256a7$var$O(s));
    }
    return n;
}



"use strict";
function $afa8d6abbb644392$export$dcb3ae0c3f199df3(e, t) {
    if (!Array.isArray(e.body)) throw new Error("Expected node with body array");
    if (e.body.length !== 1) return !1;
    const r = e.body[0];
    return !t || Object.keys(t).every((n)=>t[n] === r[n]);
}
function $afa8d6abbb644392$export$bce313fa0917d31c(e) {
    return !(!$afa8d6abbb644392$var$i.has(e.type) || e.type === "AbsenceFunction" && e.kind !== "repeater");
}
const $afa8d6abbb644392$var$i = new Set([
    "AbsenceFunction",
    "CapturingGroup",
    "Group",
    "LookaroundAssertion",
    "Regex"
]);
function $afa8d6abbb644392$export$ba95449642bd2f29(e) {
    return $afa8d6abbb644392$var$y.has(e.type);
}
const $afa8d6abbb644392$var$y = new Set([
    "AbsenceFunction",
    "Backreference",
    "CapturingGroup",
    "Character",
    "CharacterClass",
    "CharacterSet",
    "Group",
    "Quantifier",
    "Subroutine"
]);


"use strict";
function $81a53fa315512537$export$98e6a39c04603d36(e, r = {}) {
    const n = {
        flags: "",
        normalizeUnknownPropertyNames: !1,
        skipBackrefValidation: !1,
        skipLookbehindValidation: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...r.rules
        }
    }, o = (0, $fbb0773712f256a7$export$660b2ee2d4fb4eff)(e, {
        flags: n.flags,
        rules: {
            captureGroup: n.rules.captureGroup,
            singleline: n.rules.singleline
        }
    }), i = (p, N)=>{
        const u = o.tokens[t.nextIndex];
        switch(t.parent = p, t.nextIndex++, u.type){
            case "Alternator":
                return $81a53fa315512537$export$4506b1bb0cf5d8dd();
            case "Assertion":
                return $81a53fa315512537$var$W(u);
            case "Backreference":
                return $81a53fa315512537$var$X(u, t);
            case "Character":
                return $81a53fa315512537$export$4d63783c2be0a38c(u.value, {
                    useLastValid: !!N.isCheckingRangeEnd
                });
            case "CharacterClassHyphen":
                return $81a53fa315512537$var$ee(u, t, N);
            case "CharacterClassOpen":
                return $81a53fa315512537$var$re(u, t, N);
            case "CharacterSet":
                return $81a53fa315512537$var$ne(u, t);
            case "Directive":
                return $81a53fa315512537$export$5b526547d047f0c5(u.kind, {
                    flags: u.flags
                });
            case "GroupOpen":
                return $81a53fa315512537$var$te(u, t, N);
            case "NamedCallout":
                return $81a53fa315512537$export$c55dc041d92a68d5(u.kind, u.tag, u.arguments);
            case "Quantifier":
                return $81a53fa315512537$var$oe(u, t);
            case "Subroutine":
                return $81a53fa315512537$var$ae(u, t);
            default:
                throw new Error(`Unexpected token type "${u.type}"`);
        }
    }, t = {
        capturingGroups: [],
        hasNumberedRef: !1,
        namedGroupsByName: new Map,
        nextIndex: 0,
        normalizeUnknownPropertyNames: n.normalizeUnknownPropertyNames,
        parent: null,
        skipBackrefValidation: n.skipBackrefValidation,
        skipLookbehindValidation: n.skipLookbehindValidation,
        skipPropertyNameValidation: n.skipPropertyNameValidation,
        subroutines: [],
        tokens: o.tokens,
        unicodePropertyMap: n.unicodePropertyMap,
        walk: i
    }, d = $81a53fa315512537$export$98d2929ccc6bd916($81a53fa315512537$export$bf8c332f00a76460(o.flags));
    let s = d.body[0];
    for(; t.nextIndex < o.tokens.length;){
        const p = i(s, {});
        p.type === "Alternative" ? (d.body.push(p), s = p) : s.body.push(p);
    }
    const { capturingGroups: a, hasNumberedRef: l, namedGroupsByName: c, subroutines: f } = t;
    if (l && c.size && !n.rules.captureGroup) throw new Error("Numbered backref/subroutine not allowed when using named capture");
    for (const { ref: p } of f)if (typeof p == "number") {
        if (p > a.length) throw new Error("Subroutine uses a group number that's not defined");
        p && (a[p - 1].isSubroutined = !0);
    } else if (c.has(p)) {
        if (c.get(p).length > 1) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Subroutine uses a duplicate group name "\g<${p}>"`);
        c.get(p)[0].isSubroutined = !0;
    } else throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Subroutine uses a group name that's not defined "\g<${p}>"`);
    return d;
}
function $81a53fa315512537$var$W({ kind: e }) {
    return $81a53fa315512537$export$987f29926deb46c2((0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)({
        "^": "line_start",
        $: "line_end",
        "\\A": "string_start",
        "\\b": "word_boundary",
        "\\B": "word_boundary",
        "\\G": "search_start",
        "\\y": "text_segment_boundary",
        "\\Y": "text_segment_boundary",
        "\\z": "string_end",
        "\\Z": "string_end_newline"
    }[e], `Unexpected assertion kind "${e}"`), {
        negate: e === (0, $aaf1636a16b777ee$export$43caf9889c228507)`\B` || e === (0, $aaf1636a16b777ee$export$43caf9889c228507)`\Y`
    });
}
function $81a53fa315512537$var$X({ raw: e }, r) {
    const n = /^\\k[<']/.test(e), o = n ? e.slice(3, -1) : e.slice(1), i = (t, d = !1)=>{
        const s = r.capturingGroups.length;
        let a = !1;
        if (t > s) {
            if (r.skipBackrefValidation) a = !0;
            else throw new Error(`Not enough capturing groups defined to the left "${e}"`);
        }
        return r.hasNumberedRef = !0, $81a53fa315512537$export$19ee8a21aa784111(d ? s + 1 - t : t, {
            orphan: a
        });
    };
    if (n) {
        const t = /^(?<sign>-?)0*(?<num>[1-9]\d*)$/.exec(o);
        if (t) return i(+t.groups.num, !!t.groups.sign);
        if (/[-+]/.test(o)) throw new Error(`Invalid backref name "${e}"`);
        if (!r.namedGroupsByName.has(o)) throw new Error(`Group name not defined to the left "${e}"`);
        return $81a53fa315512537$export$19ee8a21aa784111(o);
    }
    return i(+o);
}
function $81a53fa315512537$var$ee(e, r, n) {
    const { tokens: o, walk: i } = r, t = r.parent, d = t.body.at(-1), s = o[r.nextIndex];
    if (!n.isCheckingRangeEnd && d && d.type !== "CharacterClass" && d.type !== "CharacterClassRange" && s && s.type !== "CharacterClassOpen" && s.type !== "CharacterClassClose" && s.type !== "CharacterClassIntersector") {
        const a = i(t, {
            ...n,
            isCheckingRangeEnd: !0
        });
        if (d.type === "Character" && a.type === "Character") return t.body.pop(), $81a53fa315512537$export$4249e19df10db8da(d, a);
        throw new Error("Invalid character class range");
    }
    return $81a53fa315512537$export$4d63783c2be0a38c((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)("-"));
}
function $81a53fa315512537$var$re({ negate: e }, r, n) {
    const { tokens: o, walk: i } = r, t = [
        $81a53fa315512537$export$9e021a2c1a31ab55()
    ], d = o[r.nextIndex];
    let s = $81a53fa315512537$var$z(d);
    for(; s.type !== "CharacterClassClose";){
        if (s.type === "CharacterClassIntersector") t.push($81a53fa315512537$export$9e021a2c1a31ab55()), r.nextIndex++;
        else {
            const l = t.at(-1);
            l.body.push(i(l, n));
        }
        s = $81a53fa315512537$var$z(o[r.nextIndex], d);
    }
    const a = $81a53fa315512537$export$9e021a2c1a31ab55({
        negate: e
    });
    return t.length === 1 ? a.body = t[0].body : (a.kind = "intersection", a.body = t.map((l)=>l.body.length === 1 ? l.body[0] : l)), r.nextIndex++, a;
}
function $81a53fa315512537$var$ne({ kind: e, negate: r, value: n }, o) {
    const { normalizeUnknownPropertyNames: i, skipPropertyNameValidation: t, unicodePropertyMap: d } = o;
    if (e === "property") {
        const s = $81a53fa315512537$export$74643d1fe038be1a(n);
        if ((0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(s) && !d?.has(s)) e = "posix", n = s;
        else return $81a53fa315512537$export$3968c6d753b95879(n, {
            negate: r,
            normalizeUnknownPropertyNames: i,
            skipPropertyNameValidation: t,
            unicodePropertyMap: d
        });
    }
    return e === "posix" ? $81a53fa315512537$export$7a84b53e0fed4c59(n, {
        negate: r
    }) : $81a53fa315512537$export$247758b45a713079(e, {
        negate: r
    });
}
function $81a53fa315512537$var$te(e, r, n) {
    const { tokens: o, capturingGroups: i, namedGroupsByName: t, skipLookbehindValidation: d, walk: s } = r, a = $81a53fa315512537$var$ie(e), l = a.type === "AbsenceFunction", c = $81a53fa315512537$var$$(a), f = c && a.negate;
    if (a.type === "CapturingGroup" && (i.push(a), a.name && (0, $aaf1636a16b777ee$export$c4ed59b257196722)(t, a.name, []).push(a)), l && n.isInAbsenceFunction) throw new Error("Nested absence function not supported by Oniguruma");
    let p = $81a53fa315512537$var$D(o[r.nextIndex]);
    for(; p.type !== "GroupClose";){
        if (p.type === "Alternator") a.body.push($81a53fa315512537$export$4506b1bb0cf5d8dd()), r.nextIndex++;
        else {
            const N = a.body.at(-1), u = s(N, {
                ...n,
                isInAbsenceFunction: n.isInAbsenceFunction || l,
                isInLookbehind: n.isInLookbehind || c,
                isInNegLookbehind: n.isInNegLookbehind || f
            });
            if (N.body.push(u), (c || n.isInLookbehind) && !d) {
                const v = "Lookbehind includes a pattern not allowed by Oniguruma";
                if (f || n.isInNegLookbehind) {
                    if ($81a53fa315512537$var$M(u) || u.type === "CapturingGroup") throw new Error(v);
                } else if ($81a53fa315512537$var$M(u) || $81a53fa315512537$var$$(u) && u.negate) throw new Error(v);
            }
        }
        p = $81a53fa315512537$var$D(o[r.nextIndex]);
    }
    return r.nextIndex++, a;
}
function $81a53fa315512537$var$oe({ kind: e, min: r, max: n }, o) {
    const i = o.parent, t = i.body.at(-1);
    if (!t || !(0, $afa8d6abbb644392$export$ba95449642bd2f29)(t)) throw new Error("Quantifier requires a repeatable token");
    const d = $81a53fa315512537$export$169ce51b0f523e68(e, r, n, t);
    return i.body.pop(), d;
}
function $81a53fa315512537$var$ae({ raw: e }, r) {
    const { capturingGroups: n, subroutines: o } = r;
    let i = e.slice(3, -1);
    const t = /^(?<sign>[-+]?)0*(?<num>[1-9]\d*)$/.exec(i);
    if (t) {
        const s = +t.groups.num, a = n.length;
        if (r.hasNumberedRef = !0, i = ({
            "": s,
            "+": a + s,
            "-": a + 1 - s
        })[t.groups.sign], i < 1) throw new Error("Invalid subroutine number");
    } else i === "0" && (i = 0);
    const d = $81a53fa315512537$export$3b50b5d6d0004cab(i);
    return o.push(d), d;
}
function $81a53fa315512537$export$1f057c6c5c67512c(e, r) {
    if (e !== "repeater") throw new Error(`Unexpected absence function kind "${e}"`);
    return {
        type: "AbsenceFunction",
        kind: e,
        body: $81a53fa315512537$var$h(r?.body)
    };
}
function $81a53fa315512537$export$4506b1bb0cf5d8dd(e) {
    return {
        type: "Alternative",
        body: $81a53fa315512537$var$V(e?.body)
    };
}
function $81a53fa315512537$export$987f29926deb46c2(e, r) {
    const n = {
        type: "Assertion",
        kind: e
    };
    return (e === "word_boundary" || e === "text_segment_boundary") && (n.negate = !!r?.negate), n;
}
function $81a53fa315512537$export$19ee8a21aa784111(e, r) {
    const n = !!r?.orphan;
    return {
        type: "Backreference",
        ref: e,
        ...n && {
            orphan: n
        }
    };
}
function $81a53fa315512537$export$e8bb25176ecaca85(e, r) {
    const n = {
        name: void 0,
        isSubroutined: !1,
        ...r
    };
    if (n.name !== void 0 && !$81a53fa315512537$var$se(n.name)) throw new Error(`Group name "${n.name}" invalid in Oniguruma`);
    return {
        type: "CapturingGroup",
        number: e,
        ...n.name && {
            name: n.name
        },
        ...n.isSubroutined && {
            isSubroutined: n.isSubroutined
        },
        body: $81a53fa315512537$var$h(r?.body)
    };
}
function $81a53fa315512537$export$4d63783c2be0a38c(e, r) {
    const n = {
        useLastValid: !1,
        ...r
    };
    if (e > 1114111) {
        const o = e.toString(16);
        if (n.useLastValid) e = 1114111;
        else throw e > 1310719 ? new Error(`Invalid code point out of range "\\x{${o}}"`) : new Error(`Invalid code point out of range in JS "\\x{${o}}"`);
    }
    return {
        type: "Character",
        value: e
    };
}
function $81a53fa315512537$export$9e021a2c1a31ab55(e) {
    const r = {
        kind: "union",
        negate: !1,
        ...e
    };
    return {
        type: "CharacterClass",
        kind: r.kind,
        negate: r.negate,
        body: $81a53fa315512537$var$V(e?.body)
    };
}
function $81a53fa315512537$export$4249e19df10db8da(e, r) {
    if (r.value < e.value) throw new Error("Character class range out of order");
    return {
        type: "CharacterClassRange",
        min: e,
        max: r
    };
}
function $81a53fa315512537$export$247758b45a713079(e, r) {
    const n = !!r?.negate, o = {
        type: "CharacterSet",
        kind: e
    };
    return (e === "digit" || e === "hex" || e === "newline" || e === "space" || e === "word") && (o.negate = n), (e === "text_segment" || e === "newline" && !n) && (o.variableLength = !0), o;
}
function $81a53fa315512537$export$5b526547d047f0c5(e, r = {}) {
    if (e === "keep") return {
        type: "Directive",
        kind: e
    };
    if (e === "flags") return {
        type: "Directive",
        kind: e,
        flags: (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(r.flags)
    };
    throw new Error(`Unexpected directive kind "${e}"`);
}
function $81a53fa315512537$export$bf8c332f00a76460(e) {
    return {
        type: "Flags",
        ...e
    };
}
function $81a53fa315512537$export$856f728536d122cb(e) {
    const r = e?.atomic, n = e?.flags;
    if (r && n) throw new Error("Atomic group cannot have flags");
    return {
        type: "Group",
        ...r && {
            atomic: r
        },
        ...n && {
            flags: n
        },
        body: $81a53fa315512537$var$h(e?.body)
    };
}
function $81a53fa315512537$export$a1c731c64d750557(e) {
    const r = {
        behind: !1,
        negate: !1,
        ...e
    };
    return {
        type: "LookaroundAssertion",
        kind: r.behind ? "lookbehind" : "lookahead",
        negate: r.negate,
        body: $81a53fa315512537$var$h(e?.body)
    };
}
function $81a53fa315512537$export$c55dc041d92a68d5(e, r, n) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: r,
        arguments: n
    };
}
function $81a53fa315512537$export$7a84b53e0fed4c59(e, r) {
    const n = !!r?.negate;
    if (!(0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(e)) throw new Error(`Invalid POSIX class "${e}"`);
    return {
        type: "CharacterSet",
        kind: "posix",
        value: e,
        negate: n
    };
}
function $81a53fa315512537$export$169ce51b0f523e68(e, r, n, o) {
    if (r > n) throw new Error("Invalid reversed quantifier range");
    return {
        type: "Quantifier",
        kind: e,
        min: r,
        max: n,
        body: o
    };
}
function $81a53fa315512537$export$98d2929ccc6bd916(e, r) {
    return {
        type: "Regex",
        body: $81a53fa315512537$var$h(r?.body),
        flags: e
    };
}
function $81a53fa315512537$export$3b50b5d6d0004cab(e) {
    return {
        type: "Subroutine",
        ref: e
    };
}
function $81a53fa315512537$export$3968c6d753b95879(e, r) {
    const n = {
        negate: !1,
        normalizeUnknownPropertyNames: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r
    };
    let o = n.unicodePropertyMap?.get($81a53fa315512537$export$74643d1fe038be1a(e));
    if (!o) {
        if (n.normalizeUnknownPropertyNames) o = $81a53fa315512537$var$de(e);
        else if (n.unicodePropertyMap && !n.skipPropertyNameValidation) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Invalid Unicode property "\p{${e}}"`);
    }
    return {
        type: "CharacterSet",
        kind: "property",
        value: o ?? e,
        negate: n.negate
    };
}
function $81a53fa315512537$var$ie({ flags: e, kind: r, name: n, negate: o, number: i }) {
    switch(r){
        case "absence_repeater":
            return $81a53fa315512537$export$1f057c6c5c67512c("repeater");
        case "atomic":
            return $81a53fa315512537$export$856f728536d122cb({
                atomic: !0
            });
        case "capturing":
            return $81a53fa315512537$export$e8bb25176ecaca85(i, {
                name: n
            });
        case "group":
            return $81a53fa315512537$export$856f728536d122cb({
                flags: e
            });
        case "lookahead":
        case "lookbehind":
            return $81a53fa315512537$export$a1c731c64d750557({
                behind: r === "lookbehind",
                negate: o
            });
        default:
            throw new Error(`Unexpected group kind "${r}"`);
    }
}
function $81a53fa315512537$var$h(e) {
    if (e === void 0) e = [
        $81a53fa315512537$export$4506b1bb0cf5d8dd()
    ];
    else if (!Array.isArray(e) || !e.length || !e.every((r)=>r.type === "Alternative")) throw new Error("Invalid body; expected array of one or more Alternative nodes");
    return e;
}
function $81a53fa315512537$var$V(e) {
    if (e === void 0) e = [];
    else if (!Array.isArray(e) || !e.every((r)=>!!r.type)) throw new Error("Invalid body; expected array of nodes");
    return e;
}
function $81a53fa315512537$var$M(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookahead";
}
function $81a53fa315512537$var$$(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookbehind";
}
function $81a53fa315512537$var$se(e) {
    return /^[\p{Alpha}\p{Pc}][^)]*$/u.test(e);
}
function $81a53fa315512537$var$de(e) {
    return e.trim().replace(/[- _]+/g, "_").replace(/[A-Z][a-z]+(?=[A-Z])/g, "$&_").replace(/[A-Za-z]+/g, (r)=>r[0].toUpperCase() + r.slice(1).toLowerCase());
}
function $81a53fa315512537$export$74643d1fe038be1a(e) {
    return e.replace(/[- _]+/g, "").toLowerCase();
}
function $81a53fa315512537$var$z(e, r) {
    const n = r;
    return (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(e, `Unclosed character class${n?.type === "Character" && n.value === 93 && n.raw === "]" ? ' (started with "]")' : ""}`);
}
function $81a53fa315512537$var$D(e) {
    return (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(e, "Unclosed group");
}



"use strict";
function $ad81d75b55705a46$export$df3f009e3d155b20(a, v, N = null) {
    function b(e, s) {
        for(let t = 0; t < e.length; t++){
            const r = n(e[t], s, t, e);
            t = Math.max(-1, t + r);
        }
    }
    function n(e, s = null, t = null, r = null) {
        let i = 0, c = !1;
        const d = {
            node: e,
            parent: s,
            key: t,
            container: r,
            root: a,
            remove () {
                $ad81d75b55705a46$var$x(r).splice(Math.max(0, $ad81d75b55705a46$var$l(t) + i), 1), i--, c = !0;
            },
            removeAllNextSiblings () {
                return $ad81d75b55705a46$var$x(r).splice($ad81d75b55705a46$var$l(t) + 1);
            },
            removeAllPrevSiblings () {
                const o = $ad81d75b55705a46$var$l(t) + i;
                return i -= o, $ad81d75b55705a46$var$x(r).splice(0, Math.max(0, o));
            },
            replaceWith (o, m = {}) {
                const y = !!m.traverse;
                r ? r[Math.max(0, $ad81d75b55705a46$var$l(t) + i)] = o : (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(s, "Can't replace root node")[t] = o, y && n(o, s, t, r), c = !0;
            },
            replaceWithMultiple (o, m = {}) {
                const y = !!m.traverse;
                if ($ad81d75b55705a46$var$x(r).splice(Math.max(0, $ad81d75b55705a46$var$l(t) + i), 1, ...o), i += o.length - 1, y) {
                    let g = 0;
                    for(let p = 0; p < o.length; p++)g += n(o[p], s, $ad81d75b55705a46$var$l(t) + p + g, r);
                }
                c = !0;
            },
            skip () {
                c = !0;
            }
        }, { type: f } = e, u = v["*"], h = v[f], R = typeof u == "function" ? u : u?.enter, P = typeof h == "function" ? h : h?.enter;
        if (R?.(d, N), P?.(d, N), !c) switch(f){
            case "AbsenceFunction":
            case "Alternative":
            case "CapturingGroup":
            case "CharacterClass":
            case "Group":
            case "LookaroundAssertion":
                b(e.body, e);
                break;
            case "Assertion":
            case "Backreference":
            case "Character":
            case "CharacterSet":
            case "Directive":
            case "Flags":
            case "NamedCallout":
            case "Subroutine":
                break;
            case "CharacterClassRange":
                n(e.min, e, "min"), n(e.max, e, "max");
                break;
            case "Quantifier":
                n(e.body, e, "body");
                break;
            case "Regex":
                b(e.body, e), n(e.flags, e, "flags");
                break;
            default:
                throw new Error(`Unexpected node type "${f}"`);
        }
        return h?.exit?.(d, N), u?.exit?.(d, N), i;
    }
    return n(a), a;
}
function $ad81d75b55705a46$var$x(a) {
    if (!Array.isArray(a)) throw new Error("Container expected");
    return a;
}
function $ad81d75b55705a46$var$l(a) {
    if (typeof a != "number") throw new Error("Numeric key expected");
    return a;
}


// Separating some utils for improved tree shaking of the `./internals` export
const $2a8494b0b0ef7575$export$aad7db1ad7d1ebf6 = String.raw`\(\?(?:[:=!>A-Za-z\-]|<[=!]|\(DEFINE\))`;
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $2a8494b0b0ef7575$export$36c21f3893d5d884(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {string} str
@param {number} pos
@param {string} oldValue
@param {string} newValue
@returns {string}
*/ function $2a8494b0b0ef7575$export$77102e08492d3f08(str, pos, oldValue, newValue) {
    return str.slice(0, pos) + newValue + str.slice(pos + oldValue.length);
}


// Constant properties for tracking regex syntax context
const $894c91b37ef60176$export$841858b892ce1f4c = Object.freeze({
    DEFAULT: 'DEFAULT',
    CHAR_CLASS: 'CHAR_CLASS'
});
function $894c91b37ef60176$export$cc028768286a8626(expression, needle, replacement, context) {
    const re = new RegExp(String.raw`${needle}|(?<$skip>\[\^?|\\?.)`, 'gsu');
    const negated = [
        false
    ];
    let numCharClassesOpen = 0;
    let result = '';
    for (const match of expression.matchAll(re)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) {
            if (replacement instanceof Function) result += replacement(match, {
                context: numCharClassesOpen ? $894c91b37ef60176$export$841858b892ce1f4c.CHAR_CLASS : $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT,
                negated: negated[negated.length - 1]
            });
            else result += replacement;
            continue;
        }
        if (m[0] === '[') {
            numCharClassesOpen++;
            negated.push(m[1] === '^');
        } else if (m === ']' && numCharClassesOpen) {
            numCharClassesOpen--;
            negated.pop();
        }
        result += m;
    }
    return result;
}
function $894c91b37ef60176$export$7bfdeaa3faf4ba53(expression, needle, callback, context) {
    // Do this the easy way
    $894c91b37ef60176$export$cc028768286a8626(expression, needle, callback, context);
}
function $894c91b37ef60176$export$e12e3c9be364c7a2(expression, needle, pos = 0, context) {
    // Quick partial test; avoid the loop if not needed
    if (!new RegExp(needle, 'su').test(expression)) return null;
    const re = new RegExp(`${needle}|(?<$skip>\\\\?.)`, 'gsu');
    re.lastIndex = pos;
    let numCharClassesOpen = 0;
    let match;
    while(match = re.exec(expression)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) return match;
        if (m === '[') numCharClassesOpen++;
        else if (m === ']' && numCharClassesOpen) numCharClassesOpen--;
        // Avoid an infinite loop on zero-length matches
        if (re.lastIndex == match.index) re.lastIndex++;
    }
    return null;
}
function $894c91b37ef60176$export$4d52bbdae9cd6e0c(expression, needle, context) {
    // Do this the easy way
    return !!$894c91b37ef60176$export$e12e3c9be364c7a2(expression, needle, 0, context);
}
function $894c91b37ef60176$export$6eaa51400fdf7c32(expression, contentsStartPos) {
    const token = /\\?./gsu;
    token.lastIndex = contentsStartPos;
    let contentsEndPos = expression.length;
    let numCharClassesOpen = 0;
    // Starting search within an open group, after the group's opening
    let numGroupsOpen = 1;
    let match;
    while(match = token.exec(expression)){
        const [m] = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (m === '(') numGroupsOpen++;
            else if (m === ')') {
                numGroupsOpen--;
                if (!numGroupsOpen) {
                    contentsEndPos = match.index;
                    break;
                }
            }
        } else if (m === ']') numCharClassesOpen--;
    }
    return expression.slice(contentsStartPos, contentsEndPos);
}


/**
@import {PluginData, PluginResult} from './regex.js';
*/ const $e7b0758e094fae76$var$atomicPluginToken = new RegExp(String.raw`(?<noncapturingStart>${(0, $2a8494b0b0ef7575$export$aad7db1ad7d1ebf6)})|(?<capturingStart>\((?:\?<[^>]+>)?)|\\?.`, 'gsu');
/**
Apply transformations for atomic groups: `(?>…)`.
@param {string} expression
@param {PluginData} [data]
@returns {Required<PluginResult>}
*/ function $e7b0758e094fae76$export$a573bc8e40d39511(expression, data) {
    const hiddenCaptures = data?.hiddenCaptures ?? [];
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    if (!/\(\?>/.test(expression)) return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    const aGDelim = '(?>';
    const emulatedAGDelim = '(?:(?=(';
    const captureNumMap = [
        0
    ];
    const addedHiddenCaptures = [];
    let numCapturesBeforeAG = 0;
    let numAGs = 0;
    let aGPos = NaN;
    let hasProcessedAG;
    do {
        hasProcessedAG = false;
        let numCharClassesOpen = 0;
        let numGroupsOpenInAG = 0;
        let inAG = false;
        let match;
        $e7b0758e094fae76$var$atomicPluginToken.lastIndex = Number.isNaN(aGPos) ? 0 : aGPos + emulatedAGDelim.length;
        while(match = $e7b0758e094fae76$var$atomicPluginToken.exec(expression)){
            const { 0: m, index: index, groups: { capturingStart: capturingStart, noncapturingStart: noncapturingStart } } = match;
            if (m === '[') numCharClassesOpen++;
            else if (!numCharClassesOpen) {
                if (m === aGDelim && !inAG) {
                    aGPos = index;
                    inAG = true;
                } else if (inAG && noncapturingStart) numGroupsOpenInAG++;
                else if (capturingStart) {
                    if (inAG) numGroupsOpenInAG++;
                    else {
                        numCapturesBeforeAG++;
                        captureNumMap.push(numCapturesBeforeAG + numAGs);
                    }
                } else if (m === ')' && inAG) {
                    if (!numGroupsOpenInAG) {
                        numAGs++;
                        const addedCaptureNum = numCapturesBeforeAG + numAGs;
                        // Replace `expression` and use `<$$N>` as a temporary wrapper for the backref so it
                        // can avoid backref renumbering afterward. Wrap the whole substitution (including the
                        // lookahead and following backref) in a noncapturing group to handle following
                        // quantifiers and literal digits
                        expression = `${expression.slice(0, aGPos)}${emulatedAGDelim}${expression.slice(aGPos + aGDelim.length, index)}))<$$${addedCaptureNum}>)${expression.slice(index + 1)}`;
                        hasProcessedAG = true;
                        addedHiddenCaptures.push(addedCaptureNum);
                        (0, $2a8494b0b0ef7575$export$36c21f3893d5d884)(hiddenCaptures, addedCaptureNum);
                        if (captureTransfers.size) {
                            const newCaptureTransfers = new Map();
                            captureTransfers.forEach((from, to)=>{
                                newCaptureTransfers.set(to >= addedCaptureNum ? to + 1 : to, from.map((f)=>f >= addedCaptureNum ? f + 1 : f));
                            });
                            captureTransfers = newCaptureTransfers;
                        }
                        break;
                    }
                    numGroupsOpenInAG--;
                }
            } else if (m === ']') numCharClassesOpen--;
        }
    // Start over from the beginning of the atomic group's contents, in case the processed group
    // contains additional atomic groups
    }while (hasProcessedAG);
    hiddenCaptures.push(...addedHiddenCaptures);
    // Second pass to adjust numbered backrefs
    expression = (0, $894c91b37ef60176$export$cc028768286a8626)(expression, String.raw`\\(?<backrefNum>[1-9]\d*)|<\$\$(?<wrappedBackrefNum>\d+)>`, ({ 0: m, groups: { backrefNum: backrefNum, wrappedBackrefNum: wrappedBackrefNum } })=>{
        if (backrefNum) {
            const bNum = +backrefNum;
            if (bNum > captureNumMap.length - 1) throw new Error(`Backref "${m}" greater than number of captures`);
            return `\\${captureNumMap[bNum]}`;
        }
        return `\\${wrappedBackrefNum}`;
    }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
const $e7b0758e094fae76$var$baseQuantifier = String.raw`(?:[?*+]|\{\d+(?:,\d*)?\})`;
// Complete tokenizer for base syntax; doesn't (need to) know about character-class-only syntax
const $e7b0758e094fae76$var$possessivePluginToken = new RegExp(String.raw`
\\(?: \d+
  | c[A-Za-z]
  | [gk]<[^>]+>
  | [pPu]\{[^\}]+\}
  | u[A-Fa-f\d]{4}
  | x[A-Fa-f\d]{2}
  )
| \((?: \? (?: [:=!>]
  | <(?:[=!]|[^>]+>)
  | [A-Za-z\-]+:
  | \(DEFINE\)
  ))?
| (?<qBase>${$e7b0758e094fae76$var$baseQuantifier})(?<qMod>[?+]?)(?<invalidQ>[?*+\{]?)
| \\?.
`.replace(/\s+/g, ''), 'gsu');
/**
Transform posessive quantifiers into atomic groups. The posessessive quantifiers are:
`?+`, `*+`, `++`, `{N}+`, `{N,}+`, `{N,N}+`.
This follows Java, PCRE, Perl, and Python.
Possessive quantifiers in Oniguruma and Onigmo are only: `?+`, `*+`, `++`.
@param {string} expression
@returns {PluginResult}
*/ function $e7b0758e094fae76$export$777a2fba7d8a1541(expression) {
    if (!new RegExp(`${$e7b0758e094fae76$var$baseQuantifier}\\+`).test(expression)) return {
        pattern: expression
    };
    const openGroupIndices = [];
    let lastGroupIndex = null;
    let lastCharClassIndex = null;
    let lastToken = '';
    let numCharClassesOpen = 0;
    let match;
    $e7b0758e094fae76$var$possessivePluginToken.lastIndex = 0;
    while(match = $e7b0758e094fae76$var$possessivePluginToken.exec(expression)){
        const { 0: m, index: index, groups: { qBase: qBase, qMod: qMod, invalidQ: invalidQ } } = match;
        if (m === '[') {
            if (!numCharClassesOpen) lastCharClassIndex = index;
            numCharClassesOpen++;
        } else if (m === ']') {
            if (numCharClassesOpen) numCharClassesOpen--;
            else lastCharClassIndex = null;
        } else if (!numCharClassesOpen) {
            if (qMod === '+' && lastToken && !lastToken.startsWith('(')) {
                // Invalid following quantifier would become valid via the wrapping group
                if (invalidQ) throw new Error(`Invalid quantifier "${m}"`);
                let charsAdded = -1; // -1 for removed trailing `+`
                // Possessivizing fixed repetition quantifiers like `{2}` does't change their behavior, so
                // avoid doing so (convert them to greedy)
                if (/^\{\d+\}$/.test(qBase)) expression = (0, $2a8494b0b0ef7575$export$77102e08492d3f08)(expression, index + qBase.length, qMod, '');
                else {
                    if (lastToken === ')' || lastToken === ']') {
                        const nodeIndex = lastToken === ')' ? lastGroupIndex : lastCharClassIndex;
                        // Unmatched `)` would break out of the wrapping group and mess with handling.
                        // Unmatched `]` wouldn't be a problem, but it's unnecessary to have dedicated support
                        // for unescaped `]++` since this won't work with flag u or v anyway
                        if (nodeIndex === null) throw new Error(`Invalid unmatched "${lastToken}"`);
                        expression = `${expression.slice(0, nodeIndex)}(?>${expression.slice(nodeIndex, index)}${qBase})${expression.slice(index + m.length)}`;
                    } else expression = `${expression.slice(0, index - lastToken.length)}(?>${lastToken}${qBase})${expression.slice(index + m.length)}`;
                    charsAdded += 4; // `(?>)`
                }
                $e7b0758e094fae76$var$possessivePluginToken.lastIndex += charsAdded;
            } else if (m[0] === '(') openGroupIndices.push(index);
            else if (m === ')') lastGroupIndex = openGroupIndices.length ? openGroupIndices.pop() : null;
        }
        lastToken = m;
    }
    return {
        pattern: expression
    };
}


/**
Works the same as JavaScript's native `RegExp` constructor in all contexts, but automatically
adjusts subpattern matches and indices (with flag `d`) to account for captures added as part of
emulating extended syntax.
*/ class $5fd7d2ae13cd21b1$export$7c3361faba0d4671 extends RegExp {
    // Avoid `#private` to allow for subclassing
    /**
  @private
  @type {Map<number, {
    hidden: true;
  }>}
  */ _captureMap;
    /**
  @overload
  @param {string} expression
  @param {string} [flags]
  @param {{
    hiddenCaptures?: Array<number>;
  }} [options]
  */ /**
  @overload
  @param {RegExpSubclass} expression
  @param {string} [flags]
  */ constructor(expression, flags, options){
        // Argument `options` isn't provided when regexes are copied via `new RegExpSubclass(regexp)`,
        // including as part of the internal handling of string methods `matchAll` and `split`
        if (expression instanceof RegExp) {
            if (options) throw new Error('Cannot provide options when copying a regexp');
            super(expression, flags);
            if (expression instanceof $5fd7d2ae13cd21b1$export$7c3361faba0d4671) this._captureMap = expression._captureMap;
            else this._captureMap = new Map();
        } else {
            super(expression, flags);
            const hiddenCaptures = options?.hiddenCaptures ?? [];
            this._captureMap = $5fd7d2ae13cd21b1$var$createCaptureMap(hiddenCaptures);
        }
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray | null}
  */ exec(str) {
        const match = super.exec(str);
        if (!match || !this._captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        // Empty all but the first value of the array while preserving its other properties
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        for(let i = 1; i < matchCopy.length; i++)if (!this._captureMap.get(i)?.hidden) {
            match.push(matchCopy[i]);
            if (this.hasIndices) match.indices.push(indicesCopy[i]);
        }
        return match;
    }
}
/**
Build the capturing group map, with hidden captures marked to indicate their submatches shouldn't
appear in match results.
@param {Array<number>} hiddenCaptures
@returns {Map<number, {
  hidden: true;
}>}
*/ function $5fd7d2ae13cd21b1$var$createCaptureMap(hiddenCaptures) {
    const captureMap = new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    return captureMap;
}





const $f998c33fe6f5a8d0$var$r = String.raw;
const $f998c33fe6f5a8d0$var$gRToken = $f998c33fe6f5a8d0$var$r`\\g<(?<gRNameOrNum>[^>&]+)&R=(?<gRDepth>[^>]+)>`;
const $f998c33fe6f5a8d0$var$recursiveToken = $f998c33fe6f5a8d0$var$r`\(\?R=(?<rDepth>[^\)]+)\)|${$f998c33fe6f5a8d0$var$gRToken}`;
const $f998c33fe6f5a8d0$var$namedCaptureDelim = $f998c33fe6f5a8d0$var$r`\(\?<(?![=!])(?<captureName>[^>]+)>`;
const $f998c33fe6f5a8d0$var$captureDelim = $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|(?<unnamed>\()(?!\?)`;
const $f998c33fe6f5a8d0$var$token = new RegExp($f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|${$f998c33fe6f5a8d0$var$recursiveToken}|\(\?|\\?.`, 'gsu');
const $f998c33fe6f5a8d0$var$overlappingRecursionMsg = 'Cannot use multiple overlapping recursions';
/**
@param {string} pattern
@param {{
  flags?: string;
  captureTransfers?: Map<number, Array<number>>;
  hiddenCaptures?: Array<number>;
  mode?: 'plugin' | 'external';
}} [data]
@returns {{
  pattern: string;
  captureTransfers: Map<number, Array<number>>;
  hiddenCaptures: Array<number>;
}}
*/ function $f998c33fe6f5a8d0$export$74c5cab0f9a94551(pattern, data) {
    const { hiddenCaptures: hiddenCaptures, mode: mode } = {
        hiddenCaptures: [],
        mode: 'plugin',
        ...data
    };
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    // Keep the initial fail-check (which avoids unneeded processing) as fast as possible by testing
    // without the accuracy improvement of using `hasUnescaped` with `Context.DEFAULT`
    if (!new RegExp($f998c33fe6f5a8d0$var$recursiveToken, 'su').test(pattern)) return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    if (mode === 'plugin' && (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(pattern, $f998c33fe6f5a8d0$var$r`\(\?\(DEFINE\)`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error('DEFINE groups cannot be used with recursion');
    const addedHiddenCaptures = [];
    const hasNumberedBackref = (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(pattern, $f998c33fe6f5a8d0$var$r`\\[1-9]`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    const groupContentsStartPos = new Map();
    const openGroups = [];
    let hasRecursed = false;
    let numCharClassesOpen = 0;
    let numCapturesPassed = 0;
    let match;
    $f998c33fe6f5a8d0$var$token.lastIndex = 0;
    while(match = $f998c33fe6f5a8d0$var$token.exec(pattern)){
        const { 0: m, groups: { captureName: captureName, rDepth: rDepth, gRNameOrNum: gRNameOrNum, gRDepth: gRDepth } } = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            // `(?R=N)`
            if (rDepth) {
                $f998c33fe6f5a8d0$var$assertMaxInBounds(rDepth);
                if (hasRecursed) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                if (hasNumberedBackref) // Could add support for numbered backrefs with extra effort, but it's probably not worth
                // it. To trigger this error, the regex must include recursion and one of the following:
                // - An interpolated regex that contains a numbered backref (since other numbered
                //   backrefs are prevented by implicit flag n).
                // - A numbered backref, when flag n is explicitly disabled.
                // Note that Regex+'s extended syntax (atomic groups and sometimes subroutines) can also
                // add numbered backrefs, but those work fine because external plugins like this one run
                // *before* the transformation of built-in syntax extensions
                throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with global recursion`);
                const left = pattern.slice(0, match.index);
                const right = pattern.slice($f998c33fe6f5a8d0$var$token.lastIndex);
                if ((0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(right, $f998c33fe6f5a8d0$var$recursiveToken, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                const reps = +rDepth - 1;
                pattern = $f998c33fe6f5a8d0$var$makeRecursive(left, right, reps, false, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, left, reps, addedHiddenCaptures.length, 0, numCapturesPassed);
                break;
            // `\g<name&R=N>`, `\g<number&R=N>`
            } else if (gRNameOrNum) {
                $f998c33fe6f5a8d0$var$assertMaxInBounds(gRDepth);
                let isWithinReffedGroup = false;
                for (const g of openGroups)if (g.name === gRNameOrNum || g.num === +gRNameOrNum) {
                    isWithinReffedGroup = true;
                    if (g.hasRecursedWithin) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                    break;
                }
                if (!isWithinReffedGroup) throw new Error($f998c33fe6f5a8d0$var$r`Recursive \g cannot be used outside the referenced group "${mode === 'external' ? gRNameOrNum : $f998c33fe6f5a8d0$var$r`\g<${gRNameOrNum}&R=${gRDepth}>`}"`);
                const startPos = groupContentsStartPos.get(gRNameOrNum);
                const groupContents = (0, $894c91b37ef60176$export$6eaa51400fdf7c32)(pattern, startPos);
                if (hasNumberedBackref && (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(groupContents, $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|\((?!\?)`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with recursion of capturing groups`);
                const groupContentsLeft = pattern.slice(startPos, match.index);
                const groupContentsRight = groupContents.slice(groupContentsLeft.length + m.length);
                const numAddedHiddenCapturesPreExpansion = addedHiddenCaptures.length;
                const reps = +gRDepth - 1;
                const expansion = $f998c33fe6f5a8d0$var$makeRecursive(groupContentsLeft, groupContentsRight, reps, true, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, groupContentsLeft, reps, addedHiddenCaptures.length - numAddedHiddenCapturesPreExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed);
                const pre = pattern.slice(0, startPos);
                const post = pattern.slice(startPos + groupContents.length);
                // Modify the string we're looping over
                pattern = `${pre}${expansion}${post}`;
                // Step forward for the next loop iteration
                $f998c33fe6f5a8d0$var$token.lastIndex += expansion.length - m.length - groupContentsLeft.length - groupContentsRight.length;
                openGroups.forEach((g)=>g.hasRecursedWithin = true);
                hasRecursed = true;
            } else if (captureName) {
                numCapturesPassed++;
                groupContentsStartPos.set(String(numCapturesPassed), $f998c33fe6f5a8d0$var$token.lastIndex);
                groupContentsStartPos.set(captureName, $f998c33fe6f5a8d0$var$token.lastIndex);
                openGroups.push({
                    num: numCapturesPassed,
                    name: captureName
                });
            } else if (m[0] === '(') {
                const isUnnamedCapture = m === '(';
                if (isUnnamedCapture) {
                    numCapturesPassed++;
                    groupContentsStartPos.set(String(numCapturesPassed), $f998c33fe6f5a8d0$var$token.lastIndex);
                }
                openGroups.push(isUnnamedCapture ? {
                    num: numCapturesPassed
                } : {});
            } else if (m === ')') openGroups.pop();
        } else if (m === ']') numCharClassesOpen--;
    }
    hiddenCaptures.push(...addedHiddenCaptures);
    return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
/**
@param {string} max
*/ function $f998c33fe6f5a8d0$var$assertMaxInBounds(max) {
    const errMsg = `Max depth must be integer between 2 and 100; used ${max}`;
    if (!/^[1-9]\d*$/.test(max)) throw new Error(errMsg);
    max = +max;
    if (max < 2 || max > 100) throw new Error(errMsg);
}
/**
@param {string} left
@param {string} right
@param {number} reps
@param {boolean} isSubpattern
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $f998c33fe6f5a8d0$var$makeRecursive(left, right, reps, isSubpattern, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const namesInRecursed = new Set();
    // Can skip this work if not needed
    if (isSubpattern) (0, $894c91b37ef60176$export$7bfdeaa3faf4ba53)(left + right, $f998c33fe6f5a8d0$var$namedCaptureDelim, ({ groups: { captureName: captureName } })=>{
        namesInRecursed.add(captureName);
    }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    const rest = [
        reps,
        isSubpattern ? namesInRecursed : null,
        hiddenCaptures,
        addedHiddenCaptures,
        numCapturesPassed
    ];
    // Depth 2: 'left(?:left(?:)right)right'
    // Depth 3: 'left(?:left(?:left(?:)right)right)right'
    // Empty group in the middle separates tokens and absorbs a following quantifier if present
    return `${left}${$f998c33fe6f5a8d0$var$repeatWithDepth(`(?:${left}`, 'forward', ...rest)}(?:)${$f998c33fe6f5a8d0$var$repeatWithDepth(`${right})`, 'backward', ...rest)}${right}`;
}
/**
@param {string} pattern
@param {'forward' | 'backward'} direction
@param {number} reps
@param {Set<string> | null} namesInRecursed
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $f998c33fe6f5a8d0$var$repeatWithDepth(pattern, direction, reps, namesInRecursed, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const startNum = 2;
    const getDepthNum = (i)=>direction === 'forward' ? i + startNum : reps - i + startNum - 1;
    let result = '';
    for(let i = 0; i < reps; i++){
        const depthNum = getDepthNum(i);
        result += (0, $894c91b37ef60176$export$cc028768286a8626)(pattern, $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$captureDelim}|\\k<(?<backref>[^>]+)>`, ({ 0: m, groups: { captureName: captureName, unnamed: unnamed, backref: backref } })=>{
            if (backref && namesInRecursed && !namesInRecursed.has(backref)) // Don't alter backrefs to groups outside the recursed subpattern
            return m;
            const suffix = `_$${depthNum}`;
            if (unnamed || captureName) {
                const addedCaptureNum = numCapturesPassed + addedHiddenCaptures.length + 1;
                addedHiddenCaptures.push(addedCaptureNum);
                $f998c33fe6f5a8d0$var$incrementIfAtLeast(hiddenCaptures, addedCaptureNum);
                return unnamed ? m : `(?<${captureName}${suffix}>`;
            }
            return $f998c33fe6f5a8d0$var$r`\k<${backref}${suffix}>`;
        }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    }
    return result;
}
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $f998c33fe6f5a8d0$var$incrementIfAtLeast(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {Map<number, Array<number>>} captureTransfers
@param {string} left
@param {number} reps
@param {number} numCapturesAddedInExpansion
@param {number} numAddedHiddenCapturesPreExpansion
@param {number} numCapturesPassed
@returns {Map<number, Array<number>>}
*/ function $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, left, reps, numCapturesAddedInExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed) {
    if (captureTransfers.size && numCapturesAddedInExpansion) {
        let numCapturesInLeft = 0;
        (0, $894c91b37ef60176$export$7bfdeaa3faf4ba53)(left, $f998c33fe6f5a8d0$var$captureDelim, ()=>numCapturesInLeft++, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
        // Is 0 for global recursion
        const recursionDelimCaptureNum = numCapturesPassed - numCapturesInLeft + numAddedHiddenCapturesPreExpansion;
        const newCaptureTransfers = new Map();
        captureTransfers.forEach((from, to)=>{
            const numCapturesInRight = (numCapturesAddedInExpansion - numCapturesInLeft * reps) / reps;
            const numCapturesAddedInLeft = numCapturesInLeft * reps;
            const newTo = to > recursionDelimCaptureNum + numCapturesInLeft ? to + numCapturesAddedInExpansion : to;
            const newFrom = [];
            for (const f of from){
                // Before the recursed subpattern
                if (f <= recursionDelimCaptureNum) newFrom.push(f);
                else if (f > recursionDelimCaptureNum + numCapturesInLeft + numCapturesInRight) newFrom.push(f + numCapturesAddedInExpansion);
                else if (f <= recursionDelimCaptureNum + numCapturesInLeft) for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesInLeft * i);
                else for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesAddedInLeft + numCapturesInRight * i);
            }
            newCaptureTransfers.set(newTo, newFrom);
        });
        return newCaptureTransfers;
    }
    return captureTransfers;
}


var $c0ef9b2f1330c5f8$var$cp = String.fromCodePoint;
var $c0ef9b2f1330c5f8$var$r = String.raw;
var $c0ef9b2f1330c5f8$var$envFlags = {};
var $c0ef9b2f1330c5f8$var$globalRegExp = globalThis.RegExp;
$c0ef9b2f1330c5f8$var$envFlags.flagGroups = (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp("(?i:)");
    } catch  {
        return false;
    }
    return true;
})();
$c0ef9b2f1330c5f8$var$envFlags.unicodeSets = (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp("[[]]", "v");
    } catch  {
        return false;
    }
    return true;
})();
$c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange = $c0ef9b2f1330c5f8$var$envFlags.unicodeSets ? (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp($c0ef9b2f1330c5f8$var$r`[\d\-a]`, "v");
    } catch  {
        return true;
    }
    return false;
})() : false;
$c0ef9b2f1330c5f8$var$envFlags.bugNestedClassIgnoresNegation = $c0ef9b2f1330c5f8$var$envFlags.unicodeSets && new $c0ef9b2f1330c5f8$var$globalRegExp("[[^a]]", "v").test("a");
function $c0ef9b2f1330c5f8$var$getNewCurrentFlags(current, { enable: enable, disable: disable }) {
    return {
        dotAll: !disable?.dotAll && !!(enable?.dotAll || current.dotAll),
        ignoreCase: !disable?.ignoreCase && !!(enable?.ignoreCase || current.ignoreCase)
    };
}
function $c0ef9b2f1330c5f8$var$getOrInsert(map, key, defaultValue) {
    if (!map.has(key)) map.set(key, defaultValue);
    return map.get(key);
}
function $c0ef9b2f1330c5f8$var$isMinTarget(target, min) {
    return $c0ef9b2f1330c5f8$var$EsVersion[target] >= $c0ef9b2f1330c5f8$var$EsVersion[min];
}
function $c0ef9b2f1330c5f8$var$throwIfNullish(value, msg) {
    if (value == null) throw new Error(msg ?? "Value expected");
    return value;
}
// src/options.js
var $c0ef9b2f1330c5f8$var$EsVersion = {
    ES2025: 2025,
    ES2024: 2024,
    ES2018: 2018
};
var $c0ef9b2f1330c5f8$var$Target = /** @type {const} */ {
    auto: "auto",
    ES2025: "ES2025",
    ES2024: "ES2024",
    ES2018: "ES2018"
};
function $c0ef9b2f1330c5f8$var$getOptions(options = {}) {
    if (({}).toString.call(options) !== "[object Object]") throw new Error("Unexpected options");
    if (options.target !== void 0 && !$c0ef9b2f1330c5f8$var$Target[options.target]) throw new Error(`Unexpected target "${options.target}"`);
    const opts = {
        // Sets the level of emulation rigor/strictness.
        accuracy: "default",
        // Disables advanced emulation that relies on returning a `RegExp` subclass, resulting in
        // certain patterns not being emulatable.
        avoidSubclass: false,
        // Oniguruma flags; a string with `i`, `m`, `x`, `D`, `S`, `W`, `y{g}` in any order (all
        // optional). Oniguruma's `m` is equivalent to JavaScript's `s` (`dotAll`).
        flags: "",
        // Include JavaScript flag `g` (`global`) in the result.
        global: false,
        // Include JavaScript flag `d` (`hasIndices`) in the result.
        hasIndices: false,
        // Delay regex construction until first use if the transpiled pattern is at least this length.
        lazyCompileLength: Infinity,
        // JavaScript version used for generated regexes. Using `auto` detects the best value based on
        // your environment. Later targets allow faster processing, simpler generated source, and
        // support for additional features.
        target: "auto",
        // Disables minifications that simplify the pattern without changing the meaning.
        verbose: false,
        ...options,
        // Advanced options that override standard behavior, error checking, and flags when enabled.
        rules: {
            // Useful with TextMate grammars that merge backreferences across patterns.
            allowOrphanBackrefs: false,
            // Use ASCII `\b` and `\B`, which increases search performance of generated regexes.
            asciiWordBoundaries: false,
            // Allow unnamed captures and numbered calls (backreferences and subroutines) when using
            // named capture. This is Oniguruma option `ONIG_OPTION_CAPTURE_GROUP`; on by default in
            // `vscode-oniguruma`.
            captureGroup: false,
            // Change the recursion depth limit from Oniguruma's `20` to an integer `2`–`20`.
            recursionLimit: 20,
            // `^` as `\A`; `$` as`\Z`. Improves search performance of generated regexes without changing
            // the meaning if searching line by line. This is Oniguruma option `ONIG_OPTION_SINGLELINE`.
            singleline: false,
            ...options.rules
        }
    };
    if (opts.target === "auto") opts.target = $c0ef9b2f1330c5f8$var$envFlags.flagGroups ? "ES2025" : $c0ef9b2f1330c5f8$var$envFlags.unicodeSets ? "ES2024" : "ES2018";
    return opts;
}
var $c0ef9b2f1330c5f8$var$asciiSpaceChar = "[	-\r ]";
var $c0ef9b2f1330c5f8$var$CharsWithoutIgnoreCaseExpansion = /* @__PURE__ */ new Set([
    $c0ef9b2f1330c5f8$var$cp(304),
    // İ
    $c0ef9b2f1330c5f8$var$cp(305)
]);
var $c0ef9b2f1330c5f8$var$defaultWordChar = $c0ef9b2f1330c5f8$var$r`[\p{L}\p{M}\p{N}\p{Pc}]`;
function $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char) {
    if ($c0ef9b2f1330c5f8$var$CharsWithoutIgnoreCaseExpansion.has(char)) return [
        char
    ];
    const set = /* @__PURE__ */ new Set();
    const lower = char.toLowerCase();
    const upper = lower.toUpperCase();
    const title = $c0ef9b2f1330c5f8$var$LowerToTitleCaseMap.get(lower);
    const altLower = $c0ef9b2f1330c5f8$var$LowerToAlternativeLowerCaseMap.get(lower);
    const altUpper = $c0ef9b2f1330c5f8$var$LowerToAlternativeUpperCaseMap.get(lower);
    if ([
        ...upper
    ].length === 1) set.add(upper);
    altUpper && set.add(altUpper);
    title && set.add(title);
    set.add(lower);
    altLower && set.add(altLower);
    return [
        ...set
    ];
}
var $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap = /* @__PURE__ */ new Map(`C Other
Cc Control cntrl
Cf Format
Cn Unassigned
Co Private_Use
Cs Surrogate
L Letter
LC Cased_Letter
Ll Lowercase_Letter
Lm Modifier_Letter
Lo Other_Letter
Lt Titlecase_Letter
Lu Uppercase_Letter
M Mark Combining_Mark
Mc Spacing_Mark
Me Enclosing_Mark
Mn Nonspacing_Mark
N Number
Nd Decimal_Number digit
Nl Letter_Number
No Other_Number
P Punctuation punct
Pc Connector_Punctuation
Pd Dash_Punctuation
Pe Close_Punctuation
Pf Final_Punctuation
Pi Initial_Punctuation
Po Other_Punctuation
Ps Open_Punctuation
S Symbol
Sc Currency_Symbol
Sk Modifier_Symbol
Sm Math_Symbol
So Other_Symbol
Z Separator
Zl Line_Separator
Zp Paragraph_Separator
Zs Space_Separator
ASCII
ASCII_Hex_Digit AHex
Alphabetic Alpha
Any
Assigned
Bidi_Control Bidi_C
Bidi_Mirrored Bidi_M
Case_Ignorable CI
Cased
Changes_When_Casefolded CWCF
Changes_When_Casemapped CWCM
Changes_When_Lowercased CWL
Changes_When_NFKC_Casefolded CWKCF
Changes_When_Titlecased CWT
Changes_When_Uppercased CWU
Dash
Default_Ignorable_Code_Point DI
Deprecated Dep
Diacritic Dia
Emoji
Emoji_Component EComp
Emoji_Modifier EMod
Emoji_Modifier_Base EBase
Emoji_Presentation EPres
Extended_Pictographic ExtPict
Extender Ext
Grapheme_Base Gr_Base
Grapheme_Extend Gr_Ext
Hex_Digit Hex
IDS_Binary_Operator IDSB
IDS_Trinary_Operator IDST
ID_Continue IDC
ID_Start IDS
Ideographic Ideo
Join_Control Join_C
Logical_Order_Exception LOE
Lowercase Lower
Math
Noncharacter_Code_Point NChar
Pattern_Syntax Pat_Syn
Pattern_White_Space Pat_WS
Quotation_Mark QMark
Radical
Regional_Indicator RI
Sentence_Terminal STerm
Soft_Dotted SD
Terminal_Punctuation Term
Unified_Ideograph UIdeo
Uppercase Upper
Variation_Selector VS
White_Space space
XID_Continue XIDC
XID_Start XIDS`.split(/\s/).map((p)=>[
        (0, $81a53fa315512537$export$74643d1fe038be1a)(p),
        p
    ]));
var $c0ef9b2f1330c5f8$var$LowerToAlternativeLowerCaseMap = /* @__PURE__ */ new Map([
    [
        "s",
        $c0ef9b2f1330c5f8$var$cp(383)
    ],
    // s, ſ
    [
        $c0ef9b2f1330c5f8$var$cp(383),
        "s"
    ]
]);
var $c0ef9b2f1330c5f8$var$LowerToAlternativeUpperCaseMap = /* @__PURE__ */ new Map([
    [
        $c0ef9b2f1330c5f8$var$cp(223),
        $c0ef9b2f1330c5f8$var$cp(7838)
    ],
    // ß, ẞ
    [
        $c0ef9b2f1330c5f8$var$cp(107),
        $c0ef9b2f1330c5f8$var$cp(8490)
    ],
    // k, K (Kelvin)
    [
        $c0ef9b2f1330c5f8$var$cp(229),
        $c0ef9b2f1330c5f8$var$cp(8491)
    ],
    // å, Å (Angstrom)
    [
        $c0ef9b2f1330c5f8$var$cp(969),
        $c0ef9b2f1330c5f8$var$cp(8486)
    ]
]);
var $c0ef9b2f1330c5f8$var$LowerToTitleCaseMap = new Map([
    $c0ef9b2f1330c5f8$var$titleEntry(453),
    $c0ef9b2f1330c5f8$var$titleEntry(456),
    $c0ef9b2f1330c5f8$var$titleEntry(459),
    $c0ef9b2f1330c5f8$var$titleEntry(498),
    ...$c0ef9b2f1330c5f8$var$titleRange(8072, 8079),
    ...$c0ef9b2f1330c5f8$var$titleRange(8088, 8095),
    ...$c0ef9b2f1330c5f8$var$titleRange(8104, 8111),
    $c0ef9b2f1330c5f8$var$titleEntry(8124),
    $c0ef9b2f1330c5f8$var$titleEntry(8140),
    $c0ef9b2f1330c5f8$var$titleEntry(8188)
]);
var $c0ef9b2f1330c5f8$var$PosixClassMap = /* @__PURE__ */ new Map([
    [
        "alnum",
        $c0ef9b2f1330c5f8$var$r`[\p{Alpha}\p{Nd}]`
    ],
    [
        "alpha",
        $c0ef9b2f1330c5f8$var$r`\p{Alpha}`
    ],
    [
        "ascii",
        $c0ef9b2f1330c5f8$var$r`\p{ASCII}`
    ],
    [
        "blank",
        $c0ef9b2f1330c5f8$var$r`[\p{Zs}\t]`
    ],
    [
        "cntrl",
        $c0ef9b2f1330c5f8$var$r`\p{Cc}`
    ],
    [
        "digit",
        $c0ef9b2f1330c5f8$var$r`\p{Nd}`
    ],
    [
        "graph",
        $c0ef9b2f1330c5f8$var$r`[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]`
    ],
    [
        "lower",
        $c0ef9b2f1330c5f8$var$r`\p{Lower}`
    ],
    [
        "print",
        $c0ef9b2f1330c5f8$var$r`[[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]\p{Zs}]`
    ],
    [
        "punct",
        $c0ef9b2f1330c5f8$var$r`[\p{P}\p{S}]`
    ],
    // Updated value from Onig 6.9.9; changed from Unicode `\p{punct}`
    [
        "space",
        $c0ef9b2f1330c5f8$var$r`\p{space}`
    ],
    [
        "upper",
        $c0ef9b2f1330c5f8$var$r`\p{Upper}`
    ],
    [
        "word",
        $c0ef9b2f1330c5f8$var$r`[\p{Alpha}\p{M}\p{Nd}\p{Pc}]`
    ],
    [
        "xdigit",
        $c0ef9b2f1330c5f8$var$r`\p{AHex}`
    ]
]);
function $c0ef9b2f1330c5f8$var$range(start, end) {
    const range2 = [];
    for(let i = start; i <= end; i++)range2.push(i);
    return range2;
}
function $c0ef9b2f1330c5f8$var$titleEntry(codePoint) {
    const char = $c0ef9b2f1330c5f8$var$cp(codePoint);
    return [
        char.toLowerCase(),
        char
    ];
}
function $c0ef9b2f1330c5f8$var$titleRange(start, end) {
    return $c0ef9b2f1330c5f8$var$range(start, end).map((codePoint)=>$c0ef9b2f1330c5f8$var$titleEntry(codePoint));
}
var $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase = /* @__PURE__ */ new Set([
    "Lower",
    "Lowercase",
    "Upper",
    "Uppercase",
    "Ll",
    "Lowercase_Letter",
    "Lt",
    "Titlecase_Letter",
    "Lu",
    "Uppercase_Letter"
]);
function $c0ef9b2f1330c5f8$var$transform(ast, options) {
    const opts = {
        // A couple edge cases exist where options `accuracy` and `bestEffortTarget` are used:
        // - `CharacterSet` kind `text_segment` (`\X`): An exact representation would require heavy
        //   Unicode data; a best-effort approximation requires knowing the target.
        // - `CharacterSet` kind `posix` with values `graph` and `print`: Their complex Unicode
        //   representations would be hard to change to ASCII versions after the fact in the generator
        //   based on `target`/`accuracy`, so produce the appropriate structure here.
        accuracy: "default",
        asciiWordBoundaries: false,
        avoidSubclass: false,
        bestEffortTarget: "ES2025",
        ...options
    };
    $c0ef9b2f1330c5f8$var$addParentProperties(ast);
    const firstPassState = {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        flagDirectivesByAlt: /* @__PURE__ */ new Map(),
        jsGroupNameMap: /* @__PURE__ */ new Map(),
        minTargetEs2024: $c0ef9b2f1330c5f8$var$isMinTarget(opts.bestEffortTarget, "ES2024"),
        passedLookbehind: false,
        strategy: null,
        // Subroutines can appear before the groups they ref, so collect reffed nodes for a second pass 
        subroutineRefMap: /* @__PURE__ */ new Map(),
        supportedGNodes: /* @__PURE__ */ new Set(),
        digitIsAscii: ast.flags.digitIsAscii,
        spaceIsAscii: ast.flags.spaceIsAscii,
        wordIsAscii: ast.flags.wordIsAscii
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$FirstPassVisitor, firstPassState);
    const globalFlags = {
        dotAll: ast.flags.dotAll,
        ignoreCase: ast.flags.ignoreCase
    };
    const secondPassState = {
        currentFlags: globalFlags,
        prevFlags: null,
        globalFlags: globalFlags,
        groupOriginByCopy: /* @__PURE__ */ new Map(),
        groupsByName: /* @__PURE__ */ new Map(),
        multiplexCapturesToLeftByRef: /* @__PURE__ */ new Map(),
        openRefs: /* @__PURE__ */ new Map(),
        reffedNodesByReferencer: /* @__PURE__ */ new Map(),
        subroutineRefMap: firstPassState.subroutineRefMap
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$SecondPassVisitor, secondPassState);
    const thirdPassState = {
        groupsByName: secondPassState.groupsByName,
        highestOrphanBackref: 0,
        numCapturesToLeft: 0,
        reffedNodesByReferencer: secondPassState.reffedNodesByReferencer
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$ThirdPassVisitor, thirdPassState);
    ast._originMap = secondPassState.groupOriginByCopy;
    ast._strategy = firstPassState.strategy;
    return ast;
}
var $c0ef9b2f1330c5f8$var$FirstPassVisitor = {
    AbsenceFunction ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { body: body, kind: kind } = node;
        if (kind === "repeater") {
            const innerGroup = (0, $81a53fa315512537$export$856f728536d122cb)();
            innerGroup.body[0].body.push(// Insert own alts as `body`
            (0, $81a53fa315512537$export$a1c731c64d750557)({
                negate: true,
                body: body
            }), (0, $81a53fa315512537$export$3968c6d753b95879)("Any"));
            const outerGroup = (0, $81a53fa315512537$export$856f728536d122cb)();
            outerGroup.body[0].body.push((0, $81a53fa315512537$export$169ce51b0f523e68)("greedy", 0, Infinity, innerGroup));
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(outerGroup, parent), {
                traverse: true
            });
        } else throw new Error(`Unsupported absence function "(?~|"`);
    },
    Alternative: {
        enter ({ node: node, parent: parent, key: key }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            const flagDirectives = node.body.filter((el)=>el.kind === "flags");
            for(let i = key + 1; i < parent.body.length; i++){
                const forwardSiblingAlt = parent.body[i];
                $c0ef9b2f1330c5f8$var$getOrInsert(flagDirectivesByAlt, forwardSiblingAlt, []).push(...flagDirectives);
            }
        },
        exit ({ node: node }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            if (flagDirectivesByAlt.get(node)?.length) {
                const flags = $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes(flagDirectivesByAlt.get(node));
                if (flags) {
                    const flagGroup = (0, $81a53fa315512537$export$856f728536d122cb)({
                        flags: flags
                    });
                    flagGroup.body[0].body = node.body;
                    node.body = [
                        $c0ef9b2f1330c5f8$var$setParentDeep(flagGroup, node)
                    ];
                }
            }
        }
    },
    Assertion ({ node: node, parent: parent, key: key, container: container, root: root, remove: remove, replaceWith: replaceWith }, state) {
        const { kind: kind, negate: negate } = node;
        const { asciiWordBoundaries: asciiWordBoundaries, avoidSubclass: avoidSubclass, supportedGNodes: supportedGNodes, wordIsAscii: wordIsAscii } = state;
        if (kind === "text_segment_boundary") throw new Error(`Unsupported text segment boundary "\\${negate ? "Y" : "y"}"`);
        else if (kind === "line_end") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            body: [
                (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $81a53fa315512537$export$987f29926deb46c2)("string_end")
                    ]
                }),
                (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $81a53fa315512537$export$4d63783c2be0a38c)(10)
                    ]
                })
            ]
        }), parent));
        else if (kind === "line_start") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$r`(?<=\A|\n(?!\z))`, {
            skipLookbehindValidation: true
        }), parent));
        else if (kind === "search_start") {
            if (supportedGNodes.has(node)) {
                root.flags.sticky = true;
                remove();
            } else {
                const prev = container[key - 1];
                if (prev && $c0ef9b2f1330c5f8$var$isAlwaysNonZeroLength(prev)) replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
                    negate: true
                }), parent));
                else if (avoidSubclass) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\G" in a way that requires a subclass`);
                else {
                    replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$987f29926deb46c2)("string_start"), parent));
                    state.strategy = "clip_search";
                }
            }
        } else if (kind === "string_end" || kind === "string_start") ;
        else if (kind === "string_end_newline") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$r`(?=\n?\z)`), parent));
        else if (kind === "word_boundary") {
            if (!wordIsAscii && !asciiWordBoundaries) {
                const b = `(?:(?<=${$c0ef9b2f1330c5f8$var$defaultWordChar})(?!${$c0ef9b2f1330c5f8$var$defaultWordChar})|(?<!${$c0ef9b2f1330c5f8$var$defaultWordChar})(?=${$c0ef9b2f1330c5f8$var$defaultWordChar}))`;
                const B = `(?:(?<=${$c0ef9b2f1330c5f8$var$defaultWordChar})(?=${$c0ef9b2f1330c5f8$var$defaultWordChar})|(?<!${$c0ef9b2f1330c5f8$var$defaultWordChar})(?!${$c0ef9b2f1330c5f8$var$defaultWordChar}))`;
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(negate ? B : b), parent));
            }
        } else throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    Backreference ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(ref)) {
            ref = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    },
    CapturingGroup ({ node: node }, { jsGroupNameMap: jsGroupNameMap, subroutineRefMap: subroutineRefMap }) {
        let { name: name } = node;
        if (name && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(name)) {
            name = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(name, jsGroupNameMap);
            node.name = name;
        }
        subroutineRefMap.set(node.number, node);
        if (name) subroutineRefMap.set(name, node);
    },
    CharacterClassRange ({ node: node, parent: parent, replaceWith: replaceWith }) {
        if (parent.kind === "intersection") {
            const cc = (0, $81a53fa315512537$export$9e021a2c1a31ab55)({
                body: [
                    node
                ]
            });
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(cc, parent), {
                traverse: true
            });
        }
    },
    CharacterSet ({ node: node, parent: parent, replaceWith: replaceWith }, { accuracy: accuracy, minTargetEs2024: minTargetEs2024, digitIsAscii: digitIsAscii, spaceIsAscii: spaceIsAscii, wordIsAscii: wordIsAscii }) {
        const { kind: kind, negate: negate, value: value } = node;
        if (digitIsAscii && (kind === "digit" || value === "digit")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$247758b45a713079)("digit", {
                negate: negate
            }), parent));
            return;
        }
        if (spaceIsAscii && (kind === "space" || value === "space")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$asciiSpaceChar), negate), parent));
            return;
        }
        if (wordIsAscii && (kind === "word" || value === "word")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$247758b45a713079)("word", {
                negate: negate
            }), parent));
            return;
        }
        if (kind === "any") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("Any"), parent));
        else if (kind === "digit") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("Nd", {
            negate: negate
        }), parent));
        else if (kind === "dot") ;
        else if (kind === "text_segment") {
            if (accuracy === "strict") throw new Error($c0ef9b2f1330c5f8$var$r`Use of "\X" requires non-strict accuracy`);
            const eBase = "\\p{Emoji}(?:\\p{EMod}|\\uFE0F\\u20E3?|[\\x{E0020}-\\x{E007E}]+\\x{E007F})?";
            const emoji = $c0ef9b2f1330c5f8$var$r`\p{RI}{2}|${eBase}(?:\u200D${eBase})*`;
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(// Close approximation of an extended grapheme cluster; see <unicode.org/reports/tr29/>
            $c0ef9b2f1330c5f8$var$r`(?>\r\n|${minTargetEs2024 ? $c0ef9b2f1330c5f8$var$r`\p{RGI_Emoji}` : emoji}|\P{M}\p{M}*)`, // Allow JS property `RGI_Emoji` through
            {
                skipPropertyNameValidation: true
            }), parent));
        } else if (kind === "hex") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("AHex", {
            negate: negate
        }), parent));
        else if (kind === "newline") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(negate ? "[^\n]" : "(?>\r\n?|[\n\v\f\x85\u2028\u2029])"), parent));
        else if (kind === "posix") {
            if (!minTargetEs2024 && (value === "graph" || value === "print")) {
                if (accuracy === "strict") throw new Error(`POSIX class "${value}" requires min target ES2024 or non-strict accuracy`);
                let ascii = {
                    graph: "!-~",
                    print: " -~"
                }[value];
                if (negate) ascii = `\0-${$c0ef9b2f1330c5f8$var$cp(ascii.codePointAt(0) - 1)}${$c0ef9b2f1330c5f8$var$cp(ascii.codePointAt(2) + 1)}-\u{10FFFF}`;
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(`[${ascii}]`), parent));
            } else replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$PosixClassMap.get(value)), negate), parent));
        } else if (kind === "property") {
            if (!$c0ef9b2f1330c5f8$var$JsUnicodePropertyMap.has((0, $81a53fa315512537$export$74643d1fe038be1a)(value))) node.key = "sc";
        } else if (kind === "space") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("space", {
            negate: negate
        }), parent));
        else if (kind === "word") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$defaultWordChar), negate), parent));
        else throw new Error(`Unexpected character set kind "${kind}"`);
    },
    Directive ({ node: node, parent: parent, root: root, remove: remove, replaceWith: replaceWith, removeAllPrevSiblings: removeAllPrevSiblings, removeAllNextSiblings: removeAllNextSiblings }) {
        const { kind: kind, flags: flags } = node;
        if (kind === "flags") {
            if (!flags.enable && !flags.disable) remove();
            else {
                const flagGroup = (0, $81a53fa315512537$export$856f728536d122cb)({
                    flags: flags
                });
                flagGroup.body[0].body = removeAllNextSiblings();
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(flagGroup, parent), {
                    traverse: true
                });
            }
        } else if (kind === "keep") {
            const firstAlt = root.body[0];
            const hasWrapperGroup = root.body.length === 1 && // Not emulatable if within a `CapturingGroup`
            (0, $afa8d6abbb644392$export$dcb3ae0c3f199df3)(firstAlt, {
                type: "Group"
            }) && firstAlt.body[0].body.length === 1;
            const topLevel = hasWrapperGroup ? firstAlt.body[0] : root;
            if (parent.parent !== topLevel || topLevel.body.length > 1) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\K" in a way that's unsupported`);
            const lookbehind = (0, $81a53fa315512537$export$a1c731c64d750557)({
                behind: true
            });
            lookbehind.body[0].body = removeAllPrevSiblings();
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(lookbehind, parent));
        } else throw new Error(`Unexpected directive kind "${kind}"`);
    },
    Flags ({ node: node, parent: parent }) {
        if (node.posixIsAscii) throw new Error('Unsupported flag "P"');
        if (node.textSegmentMode === "word") throw new Error('Unsupported flag "y{w}"');
        [
            "digitIsAscii",
            // Flag D
            "extended",
            // Flag x
            "posixIsAscii",
            // Flag P
            "spaceIsAscii",
            // Flag S
            "wordIsAscii",
            // Flag W
            "textSegmentMode"
        ].forEach((f)=>delete node[f]);
        Object.assign(node, {
            // JS flag g; no Onig equiv
            global: false,
            // JS flag d; no Onig equiv
            hasIndices: false,
            // JS flag m; no Onig equiv but its behavior is always on in Onig. Onig's only line break
            // char is line feed, unlike JS, so this flag isn't used since it would produce inaccurate
            // results (also allows `^` and `$` to be used in the generator for string start and end)
            multiline: false,
            // JS flag y; no Onig equiv, but used for `\G` emulation
            sticky: node.sticky ?? false
        });
        parent.options = {
            disable: {
                // Onig uses different rules for flag x than Regex+, so disable the implicit flag
                x: true,
                // Onig has no flag to control "named capture only" mode but contextually applies its
                // behavior when named capturing is used, so disable Regex+'s implicit flag for it
                n: true
            },
            force: {
                // Always add flag v because we're generating an AST that relies on it (it enables JS
                // support for Onig features nested classes, intersection, Unicode properties, etc.).
                // However, the generator might disable flag v based on its `target` option
                v: true
            }
        };
    },
    Group ({ node: node }) {
        if (!node.flags) return;
        const { enable: enable, disable: disable } = node.flags;
        enable?.extended && delete enable.extended;
        disable?.extended && delete disable.extended;
        enable?.dotAll && disable?.dotAll && delete enable.dotAll;
        enable?.ignoreCase && disable?.ignoreCase && delete enable.ignoreCase;
        enable && !Object.keys(enable).length && delete node.flags.enable;
        disable && !Object.keys(disable).length && delete node.flags.disable;
        !node.flags.enable && !node.flags.disable && delete node.flags;
    },
    LookaroundAssertion ({ node: node }, state) {
        const { kind: kind } = node;
        if (kind === "lookbehind") state.passedLookbehind = true;
    },
    NamedCallout ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { kind: kind } = node;
        if (kind === "fail") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else throw new Error(`Unsupported named callout "(*${kind.toUpperCase()}"`);
    },
    Quantifier ({ node: node }) {
        if (node.body.type === "Quantifier") {
            const group = (0, $81a53fa315512537$export$856f728536d122cb)();
            group.body[0].body.push(node.body);
            node.body = $c0ef9b2f1330c5f8$var$setParentDeep(group, node);
        }
    },
    Regex: {
        enter ({ node: node }, { supportedGNodes: supportedGNodes }) {
            const leadingGs = [];
            let hasAltWithLeadG = false;
            let hasAltWithoutLeadG = false;
            for (const alt of node.body)if (alt.body.length === 1 && alt.body[0].kind === "search_start") alt.body.pop();
            else {
                const leadingG = $c0ef9b2f1330c5f8$var$getLeadingG(alt.body);
                if (leadingG) {
                    hasAltWithLeadG = true;
                    Array.isArray(leadingG) ? leadingGs.push(...leadingG) : leadingGs.push(leadingG);
                } else hasAltWithoutLeadG = true;
            }
            if (hasAltWithLeadG && !hasAltWithoutLeadG) leadingGs.forEach((g)=>supportedGNodes.add(g));
        },
        exit (_, { accuracy: accuracy, passedLookbehind: passedLookbehind, strategy: strategy }) {
            if (accuracy === "strict" && passedLookbehind && strategy) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\G" in a way that requires non-strict accuracy`);
        }
    },
    Subroutine ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(ref)) {
            ref = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    }
};
var $c0ef9b2f1330c5f8$var$SecondPassVisitor = {
    Backreference ({ node: node }, { multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, reffedNodesByReferencer: reffedNodesByReferencer }) {
        const { orphan: orphan, ref: ref } = node;
        if (!orphan) reffedNodesByReferencer.set(node, [
            ...multiplexCapturesToLeftByRef.get(ref).map(({ node: node2 })=>node2)
        ]);
    },
    CapturingGroup: {
        enter ({ node: node, parent: parent, replaceWith: replaceWith, skip: skip }, { groupOriginByCopy: groupOriginByCopy, groupsByName: groupsByName, multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, openRefs: openRefs, reffedNodesByReferencer: reffedNodesByReferencer }) {
            const origin = groupOriginByCopy.get(node);
            if (origin && openRefs.has(node.number)) {
                const recursion2 = $c0ef9b2f1330c5f8$var$setParent($c0ef9b2f1330c5f8$var$createRecursion(node.number), parent);
                reffedNodesByReferencer.set(recursion2, openRefs.get(node.number));
                replaceWith(recursion2);
                return;
            }
            openRefs.set(node.number, node);
            multiplexCapturesToLeftByRef.set(node.number, []);
            if (node.name) $c0ef9b2f1330c5f8$var$getOrInsert(multiplexCapturesToLeftByRef, node.name, []);
            const multiplexNodes = multiplexCapturesToLeftByRef.get(node.name ?? node.number);
            for(let i = 0; i < multiplexNodes.length; i++){
                const multiplex = multiplexNodes[i];
                if (// This group is from subroutine expansion, and there's a multiplex value from either the
                // origin node or a prior subroutine expansion group with the same origin
                origin === multiplex.node || origin && origin === multiplex.origin || // This group is not from subroutine expansion, and it comes after a subroutine expansion
                // group that refers to this group
                node === multiplex.origin) {
                    multiplexNodes.splice(i, 1);
                    break;
                }
            }
            multiplexCapturesToLeftByRef.get(node.number).push({
                node: node,
                origin: origin
            });
            if (node.name) multiplexCapturesToLeftByRef.get(node.name).push({
                node: node,
                origin: origin
            });
            if (node.name) {
                const groupsWithSameName = $c0ef9b2f1330c5f8$var$getOrInsert(groupsByName, node.name, /* @__PURE__ */ new Map());
                let hasDuplicateNameToRemove = false;
                if (origin) hasDuplicateNameToRemove = true;
                else {
                    for (const groupInfo of groupsWithSameName.values())if (!groupInfo.hasDuplicateNameToRemove) {
                        hasDuplicateNameToRemove = true;
                        break;
                    }
                }
                groupsByName.get(node.name).set(node, {
                    node: node,
                    hasDuplicateNameToRemove: hasDuplicateNameToRemove
                });
            }
        },
        exit ({ node: node }, { openRefs: openRefs }) {
            if (openRefs.get(node.number) === node) openRefs.delete(node.number);
        }
    },
    Group: {
        enter ({ node: node }, state) {
            state.prevFlags = state.currentFlags;
            if (node.flags) state.currentFlags = $c0ef9b2f1330c5f8$var$getNewCurrentFlags(state.currentFlags, node.flags);
        },
        exit (_, state) {
            state.currentFlags = state.prevFlags;
        }
    },
    Subroutine ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        const { isRecursive: isRecursive, ref: ref } = node;
        if (isRecursive) {
            let reffed = parent;
            while(reffed = reffed.parent){
                if (reffed.type === "CapturingGroup" && (reffed.name === ref || reffed.number === ref)) break;
            }
            state.reffedNodesByReferencer.set(node, reffed);
            return;
        }
        const reffedGroupNode = state.subroutineRefMap.get(ref);
        const isGlobalRecursion = ref === 0;
        const expandedSubroutine = isGlobalRecursion ? $c0ef9b2f1330c5f8$var$createRecursion(0) : // The reffed group might itself contain subroutines, which are expanded during sub-traversal
        $c0ef9b2f1330c5f8$var$cloneCapturingGroup(reffedGroupNode, state.groupOriginByCopy, null);
        let replacement = expandedSubroutine;
        if (!isGlobalRecursion) {
            const reffedGroupFlagMods = $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes($c0ef9b2f1330c5f8$var$getAllParents(reffedGroupNode, (p)=>p.type === "Group" && !!p.flags));
            const reffedGroupFlags = reffedGroupFlagMods ? $c0ef9b2f1330c5f8$var$getNewCurrentFlags(state.globalFlags, reffedGroupFlagMods) : state.globalFlags;
            if (!$c0ef9b2f1330c5f8$var$areFlagsEqual(reffedGroupFlags, state.currentFlags)) {
                replacement = (0, $81a53fa315512537$export$856f728536d122cb)({
                    flags: $c0ef9b2f1330c5f8$var$getFlagModsFromFlags(reffedGroupFlags)
                });
                replacement.body[0].body.push(expandedSubroutine);
            }
        }
        replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(replacement, parent), {
            traverse: !isGlobalRecursion
        });
    }
};
var $c0ef9b2f1330c5f8$var$ThirdPassVisitor = {
    Backreference ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        if (node.orphan) {
            state.highestOrphanBackref = Math.max(state.highestOrphanBackref, node.ref);
            return;
        }
        const reffedNodes = state.reffedNodesByReferencer.get(node);
        const participants = reffedNodes.filter((reffed)=>$c0ef9b2f1330c5f8$var$canParticipateWithNode(reffed, node));
        if (!participants.length) replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else if (participants.length > 1) {
            const group = (0, $81a53fa315512537$export$856f728536d122cb)({
                atomic: true,
                body: participants.reverse().map((reffed)=>(0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                        body: [
                            (0, $81a53fa315512537$export$19ee8a21aa784111)(reffed.number)
                        ]
                    }))
            });
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(group, parent));
        } else node.ref = participants[0].number;
    },
    CapturingGroup ({ node: node }, state) {
        node.number = ++state.numCapturesToLeft;
        if (node.name) {
            if (state.groupsByName.get(node.name).get(node).hasDuplicateNameToRemove) delete node.name;
        }
    },
    Regex: {
        exit ({ node: node }, state) {
            const numCapsNeeded = Math.max(state.highestOrphanBackref - state.numCapturesToLeft, 0);
            for(let i = 0; i < numCapsNeeded; i++){
                const emptyCapture = (0, $81a53fa315512537$export$e8bb25176ecaca85)();
                node.body.at(-1).body.push(emptyCapture);
            }
        }
    },
    Subroutine ({ node: node }, state) {
        if (!node.isRecursive || node.ref === 0) return;
        node.ref = state.reffedNodesByReferencer.get(node).number;
    }
};
function $c0ef9b2f1330c5f8$var$addParentProperties(root) {
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(root, {
        "*" ({ node: node, parent: parent }) {
            node.parent = parent;
        }
    });
}
function $c0ef9b2f1330c5f8$var$areFlagsEqual(a, b) {
    return a.dotAll === b.dotAll && a.ignoreCase === b.ignoreCase;
}
function $c0ef9b2f1330c5f8$var$canParticipateWithNode(capture, node) {
    let rightmostPoint = node;
    do {
        if (rightmostPoint.type === "Regex") return false;
        if (rightmostPoint.type === "Alternative") continue;
        if (rightmostPoint === capture) return false;
        const kidsOfParent = $c0ef9b2f1330c5f8$var$getKids(rightmostPoint.parent);
        for (const kid of kidsOfParent){
            if (kid === rightmostPoint) break;
            if (kid === capture || $c0ef9b2f1330c5f8$var$isAncestorOf(kid, capture)) return true;
        }
    }while (rightmostPoint = rightmostPoint.parent);
    throw new Error("Unexpected path");
}
function $c0ef9b2f1330c5f8$var$cloneCapturingGroup(obj, originMap, up, up2) {
    const store = Array.isArray(obj) ? [] : {};
    for (const [key, value] of Object.entries(obj)){
        if (key === "parent") store.parent = Array.isArray(up) ? up2 : up;
        else if (value && typeof value === "object") store[key] = $c0ef9b2f1330c5f8$var$cloneCapturingGroup(value, originMap, store, up);
        else {
            if (key === "type" && value === "CapturingGroup") originMap.set(store, originMap.get(obj) ?? obj);
            store[key] = value;
        }
    }
    return store;
}
function $c0ef9b2f1330c5f8$var$createRecursion(ref) {
    const node = (0, $81a53fa315512537$export$3b50b5d6d0004cab)(ref);
    node.isRecursive = true;
    return node;
}
function $c0ef9b2f1330c5f8$var$getAllParents(node, filterFn) {
    const results = [];
    while(node = node.parent)if (!filterFn || filterFn(node)) results.push(node);
    return results;
}
function $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(name, map) {
    if (map.has(name)) return map.get(name);
    const jsName = `$${map.size}_${name.replace(/^[^$_\p{IDS}]|[^$\u200C\u200D\p{IDC}]/ug, "_")}`;
    map.set(name, jsName);
    return jsName;
}
function $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes(flagNodes) {
    const flagProps = [
        "dotAll",
        "ignoreCase"
    ];
    const combinedFlags = {
        enable: {},
        disable: {}
    };
    flagNodes.forEach(({ flags: flags })=>{
        flagProps.forEach((prop)=>{
            if (flags.enable?.[prop]) {
                delete combinedFlags.disable[prop];
                combinedFlags.enable[prop] = true;
            }
            if (flags.disable?.[prop]) combinedFlags.disable[prop] = true;
        });
    });
    if (!Object.keys(combinedFlags.enable).length) delete combinedFlags.enable;
    if (!Object.keys(combinedFlags.disable).length) delete combinedFlags.disable;
    if (combinedFlags.enable || combinedFlags.disable) return combinedFlags;
    return null;
}
function $c0ef9b2f1330c5f8$var$getFlagModsFromFlags({ dotAll: dotAll, ignoreCase: ignoreCase }) {
    const mods = {};
    if (dotAll || ignoreCase) {
        mods.enable = {};
        dotAll && (mods.enable.dotAll = true);
        ignoreCase && (mods.enable.ignoreCase = true);
    }
    if (!dotAll || !ignoreCase) {
        mods.disable = {};
        !dotAll && (mods.disable.dotAll = true);
        !ignoreCase && (mods.disable.ignoreCase = true);
    }
    return mods;
}
function $c0ef9b2f1330c5f8$var$getKids(node) {
    if (!node) throw new Error("Node expected");
    const { body: body } = node;
    return Array.isArray(body) ? body : body ? [
        body
    ] : null;
}
function $c0ef9b2f1330c5f8$var$getLeadingG(els) {
    const firstToConsider = els.find((el)=>el.kind === "search_start" || $c0ef9b2f1330c5f8$var$isLoneGLookaround(el, {
            negate: false
        }) || !$c0ef9b2f1330c5f8$var$isAlwaysZeroLength(el));
    if (!firstToConsider) return null;
    if (firstToConsider.kind === "search_start") return firstToConsider;
    if (firstToConsider.type === "LookaroundAssertion") return firstToConsider.body[0].body[0];
    if (firstToConsider.type === "CapturingGroup" || firstToConsider.type === "Group") {
        const gNodesForGroup = [];
        for (const alt of firstToConsider.body){
            const leadingG = $c0ef9b2f1330c5f8$var$getLeadingG(alt.body);
            if (!leadingG) return null;
            Array.isArray(leadingG) ? gNodesForGroup.push(...leadingG) : gNodesForGroup.push(leadingG);
        }
        return gNodesForGroup;
    }
    return null;
}
function $c0ef9b2f1330c5f8$var$isAncestorOf(node, descendant) {
    const kids = $c0ef9b2f1330c5f8$var$getKids(node) ?? [];
    for (const kid of kids){
        if (kid === descendant || $c0ef9b2f1330c5f8$var$isAncestorOf(kid, descendant)) return true;
    }
    return false;
}
function $c0ef9b2f1330c5f8$var$isAlwaysZeroLength({ type: type }) {
    return type === "Assertion" || type === "Directive" || type === "LookaroundAssertion";
}
function $c0ef9b2f1330c5f8$var$isAlwaysNonZeroLength(node) {
    const types = [
        "Character",
        "CharacterClass",
        "CharacterSet"
    ];
    return types.includes(node.type) || node.type === "Quantifier" && node.min && types.includes(node.body.type);
}
function $c0ef9b2f1330c5f8$var$isLoneGLookaround(node, options) {
    const opts = {
        negate: null,
        ...options
    };
    return node.type === "LookaroundAssertion" && (opts.negate === null || node.negate === opts.negate) && node.body.length === 1 && (0, $afa8d6abbb644392$export$dcb3ae0c3f199df3)(node.body[0], {
        type: "Assertion",
        kind: "search_start"
    });
}
function $c0ef9b2f1330c5f8$var$isValidJsGroupName(name) {
    return /^[$_\p{IDS}][$\u200C\u200D\p{IDC}]*$/u.test(name);
}
function $c0ef9b2f1330c5f8$var$parseFragment(pattern, options) {
    const ast = (0, $81a53fa315512537$export$98e6a39c04603d36)(pattern, {
        ...options,
        // Providing a custom set of Unicode property names avoids converting some JS Unicode
        // properties (ex: `\p{Alpha}`) to Onig POSIX classes
        unicodePropertyMap: $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap
    });
    const alts = ast.body;
    if (alts.length > 1 || alts[0].body.length > 1) return (0, $81a53fa315512537$export$856f728536d122cb)({
        body: alts
    });
    return alts[0].body[0];
}
function $c0ef9b2f1330c5f8$var$setNegate(node, negate) {
    node.negate = negate;
    return node;
}
function $c0ef9b2f1330c5f8$var$setParent(node, parent) {
    node.parent = parent;
    return node;
}
function $c0ef9b2f1330c5f8$var$setParentDeep(node, parent) {
    $c0ef9b2f1330c5f8$var$addParentProperties(node);
    node.parent = parent;
    return node;
}
function $c0ef9b2f1330c5f8$var$generate(ast, options) {
    const opts = $c0ef9b2f1330c5f8$var$getOptions(options);
    const minTargetEs2024 = $c0ef9b2f1330c5f8$var$isMinTarget(opts.target, "ES2024");
    const minTargetEs2025 = $c0ef9b2f1330c5f8$var$isMinTarget(opts.target, "ES2025");
    const recursionLimit = opts.rules.recursionLimit;
    if (!Number.isInteger(recursionLimit) || recursionLimit < 2 || recursionLimit > 20) throw new Error("Invalid recursionLimit; use 2-20");
    let hasCaseInsensitiveNode = null;
    let hasCaseSensitiveNode = null;
    if (!minTargetEs2025) {
        const iStack = [
            ast.flags.ignoreCase
        ];
        (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$FlagModifierVisitor, {
            getCurrentModI: ()=>iStack.at(-1),
            popModI () {
                iStack.pop();
            },
            pushModI (isIOn) {
                iStack.push(isIOn);
            },
            setHasCasedChar () {
                if (iStack.at(-1)) hasCaseInsensitiveNode = true;
                else hasCaseSensitiveNode = true;
            }
        });
    }
    const appliedGlobalFlags = {
        dotAll: ast.flags.dotAll,
        // - Turn global flag i on if a case insensitive node was used and no case sensitive nodes were
        //   used (to avoid unnecessary node expansion).
        // - Turn global flag i off if a case sensitive node was used (since case sensitivity can't be
        //   forced without the use of ES2025 flag groups)
        ignoreCase: !!((ast.flags.ignoreCase || hasCaseInsensitiveNode) && !hasCaseSensitiveNode)
    };
    let lastNode = ast;
    const state = {
        accuracy: opts.accuracy,
        appliedGlobalFlags: appliedGlobalFlags,
        captureMap: /* @__PURE__ */ new Map(),
        currentFlags: {
            dotAll: ast.flags.dotAll,
            ignoreCase: ast.flags.ignoreCase
        },
        inCharClass: false,
        lastNode: lastNode,
        originMap: ast._originMap,
        recursionLimit: recursionLimit,
        useAppliedIgnoreCase: !!(!minTargetEs2025 && hasCaseInsensitiveNode && hasCaseSensitiveNode),
        useFlagMods: minTargetEs2025,
        useFlagV: minTargetEs2024,
        verbose: opts.verbose
    };
    function gen(node) {
        state.lastNode = lastNode;
        lastNode = node;
        const fn = $c0ef9b2f1330c5f8$var$throwIfNullish($c0ef9b2f1330c5f8$var$generator[node.type], `Unexpected node type "${node.type}"`);
        return fn(node, state, gen);
    }
    const result = {
        pattern: ast.body.map(gen).join("|"),
        // Could reset `lastNode` at this point via `lastNode = ast`, but it isn't needed by flags
        flags: gen(ast.flags),
        options: {
            ...ast.options
        }
    };
    if (!minTargetEs2024) {
        delete result.options.force.v;
        result.options.disable.v = true;
        result.options.unicodeSetsPlugin = null;
    }
    result._captureTransfers = /* @__PURE__ */ new Map();
    result._hiddenCaptures = [];
    state.captureMap.forEach((value, key)=>{
        if (value.hidden) result._hiddenCaptures.push(key);
        if (value.transferTo) $c0ef9b2f1330c5f8$var$getOrInsert(result._captureTransfers, value.transferTo, []).push(key);
    });
    return result;
}
var $c0ef9b2f1330c5f8$var$FlagModifierVisitor = {
    "*": {
        enter ({ node: node }, state) {
            if ($c0ef9b2f1330c5f8$var$isAnyGroup(node)) {
                const currentModI = state.getCurrentModI();
                state.pushModI(node.flags ? $c0ef9b2f1330c5f8$var$getNewCurrentFlags({
                    ignoreCase: currentModI
                }, node.flags).ignoreCase : currentModI);
            }
        },
        exit ({ node: node }, state) {
            if ($c0ef9b2f1330c5f8$var$isAnyGroup(node)) state.popModI();
        }
    },
    Backreference (_, state) {
        state.setHasCasedChar();
    },
    Character ({ node: node }, state) {
        if ($c0ef9b2f1330c5f8$var$charHasCase($c0ef9b2f1330c5f8$var$cp(node.value))) state.setHasCasedChar();
    },
    CharacterClassRange ({ node: node, skip: skip }, state) {
        skip();
        if ($c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node, {
            firstOnly: true
        }).length) state.setHasCasedChar();
    },
    CharacterSet ({ node: node }, state) {
        if (node.kind === "property" && $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase.has(node.value)) state.setHasCasedChar();
    }
};
var $c0ef9b2f1330c5f8$var$generator = {
    /**
  @param {AlternativeNode} node
  */ Alternative ({ body: body }, _, gen) {
        return body.map(gen).join("");
    },
    /**
  @param {AssertionNode} node
  */ Assertion ({ kind: kind, negate: negate }) {
        if (kind === "string_end") return "$";
        if (kind === "string_start") return "^";
        if (kind === "word_boundary") return negate ? $c0ef9b2f1330c5f8$var$r`\B` : $c0ef9b2f1330c5f8$var$r`\b`;
        throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    /**
  @param {BackreferenceNode} node
  */ Backreference ({ ref: ref }, state) {
        if (typeof ref !== "number") throw new Error("Unexpected named backref in transformed AST");
        if (!state.useFlagMods && state.accuracy === "strict" && state.currentFlags.ignoreCase && !state.captureMap.get(ref).ignoreCase) throw new Error("Use of case-insensitive backref to case-sensitive group requires target ES2025 or non-strict accuracy");
        return "\\" + ref;
    },
    /**
  @param {CapturingGroupNode} node
  */ CapturingGroup (node, state, gen) {
        const { body: body, name: name, number: number } = node;
        const data = {
            ignoreCase: state.currentFlags.ignoreCase
        };
        const origin = state.originMap.get(node);
        if (origin) {
            data.hidden = true;
            if (number > origin.number) data.transferTo = origin.number;
        }
        state.captureMap.set(number, data);
        return `(${name ? `?<${name}>` : ""}${body.map(gen).join("|")})`;
    },
    /**
  @param {CharacterNode} node
  */ Character ({ value: value }, state) {
        const char = $c0ef9b2f1330c5f8$var$cp(value);
        const escaped = $c0ef9b2f1330c5f8$var$getCharEscape(value, {
            escDigit: state.lastNode.type === "Backreference",
            inCharClass: state.inCharClass,
            useFlagV: state.useFlagV
        });
        if (escaped !== char) return escaped;
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $c0ef9b2f1330c5f8$var$charHasCase(char)) {
            const cases = $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char);
            return state.inCharClass ? cases.join("") : cases.length > 1 ? `[${cases.join("")}]` : cases[0];
        }
        return char;
    },
    /**
  @param {CharacterClassNode} node
  */ CharacterClass (node, state, gen) {
        const { kind: kind, negate: negate, parent: parent } = node;
        let { body: body } = node;
        if (kind === "intersection" && !state.useFlagV) throw new Error("Use of character class intersection requires min target ES2024");
        if ($c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV && body.some($c0ef9b2f1330c5f8$var$isLiteralHyphen)) body = [
            (0, $81a53fa315512537$export$4d63783c2be0a38c)(45),
            ...body.filter((kid)=>!$c0ef9b2f1330c5f8$var$isLiteralHyphen(kid))
        ];
        const genClass = ()=>`[${negate ? "^" : ""}${body.map(gen).join(kind === "intersection" ? "&&" : "")}]`;
        if (!state.inCharClass) {
            if (// Already established `kind !== 'intersection'` if `!state.useFlagV`; don't check again
            (!state.useFlagV || $c0ef9b2f1330c5f8$var$envFlags.bugNestedClassIgnoresNegation) && !negate) {
                const negatedChildClasses = body.filter((kid)=>kid.type === "CharacterClass" && kid.kind === "union" && kid.negate);
                if (negatedChildClasses.length) {
                    const group = (0, $81a53fa315512537$export$856f728536d122cb)();
                    const groupFirstAlt = group.body[0];
                    group.parent = parent;
                    groupFirstAlt.parent = group;
                    body = body.filter((kid)=>!negatedChildClasses.includes(kid));
                    node.body = body;
                    if (body.length) {
                        node.parent = groupFirstAlt;
                        groupFirstAlt.body.push(node);
                    } else group.body.pop();
                    negatedChildClasses.forEach((cc)=>{
                        const newAlt = (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                            body: [
                                cc
                            ]
                        });
                        cc.parent = newAlt;
                        newAlt.parent = group;
                        group.body.push(newAlt);
                    });
                    return gen(group);
                }
            }
            state.inCharClass = true;
            const result = genClass();
            state.inCharClass = false;
            return result;
        }
        const firstEl = body[0];
        if (// Already established that the parent is a char class via `inCharClass`; don't check again
        kind === "union" && !negate && firstEl && // Allows many nested classes to work with `target` ES2018 which doesn't support nesting
        ((!state.useFlagV || !state.verbose) && parent.kind === "union" && !($c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV) || !state.verbose && parent.kind === "intersection" && // JS doesn't allow intersection with union or ranges
        body.length === 1 && firstEl.type !== "CharacterClassRange")) return body.map(gen).join("");
        if (!state.useFlagV && parent.type === "CharacterClass") throw new Error("Uses nested character class in a way that requires min target ES2024");
        return genClass();
    },
    /**
  @param {CharacterClassRangeNode} node
  */ CharacterClassRange (node, state) {
        const min = node.min.value;
        const max = node.max.value;
        const escOpts = {
            escDigit: false,
            inCharClass: true,
            useFlagV: state.useFlagV
        };
        const minStr = $c0ef9b2f1330c5f8$var$getCharEscape(min, escOpts);
        const maxStr = $c0ef9b2f1330c5f8$var$getCharEscape(max, escOpts);
        const extraChars = /* @__PURE__ */ new Set();
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase) {
            const charsOutsideRange = $c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node);
            const ranges = $c0ef9b2f1330c5f8$var$getCodePointRangesFromChars(charsOutsideRange);
            ranges.forEach((value)=>{
                extraChars.add(Array.isArray(value) ? `${$c0ef9b2f1330c5f8$var$getCharEscape(value[0], escOpts)}-${$c0ef9b2f1330c5f8$var$getCharEscape(value[1], escOpts)}` : $c0ef9b2f1330c5f8$var$getCharEscape(value, escOpts));
            });
        }
        return `${minStr}-${maxStr}${[
            ...extraChars
        ].join("")}`;
    },
    /**
  @param {CharacterSetNode} node
  */ CharacterSet ({ kind: kind, negate: negate, value: value, key: key }, state) {
        if (kind === "dot") return state.currentFlags.dotAll ? state.appliedGlobalFlags.dotAll || state.useFlagMods ? "." : "[^]" : // Onig's only line break char is line feed, unlike JS
        $c0ef9b2f1330c5f8$var$r`[^\n]`;
        if (kind === "digit") return negate ? $c0ef9b2f1330c5f8$var$r`\D` : $c0ef9b2f1330c5f8$var$r`\d`;
        if (kind === "property") {
            if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase.has(value)) throw new Error(`Unicode property "${value}" can't be case-insensitive when other chars have specific case`);
            return `${negate ? $c0ef9b2f1330c5f8$var$r`\P` : $c0ef9b2f1330c5f8$var$r`\p`}{${key ? `${key}=` : ""}${value}}`;
        }
        if (kind === "word") return negate ? $c0ef9b2f1330c5f8$var$r`\W` : $c0ef9b2f1330c5f8$var$r`\w`;
        throw new Error(`Unexpected character set kind "${kind}"`);
    },
    /**
  @param {FlagsNode} node
  */ Flags (node, state) {
        return(// The transformer should never turn on the properties for flags d, g, m since Onig doesn't
        // have equivs. Flag m is never used since Onig uses different line break chars than JS
        // (node.hasIndices ? 'd' : '') +
        // (node.global ? 'g' : '') +
        // (node.multiline ? 'm' : '') +
        (state.appliedGlobalFlags.ignoreCase ? "i" : "") + (node.dotAll ? "s" : "") + (node.sticky ? "y" : ""));
    },
    /**
  @param {GroupNode} node
  */ Group ({ atomic: atomic2, body: body, flags: flags, parent: parent }, state, gen) {
        const currentFlags = state.currentFlags;
        if (flags) state.currentFlags = $c0ef9b2f1330c5f8$var$getNewCurrentFlags(currentFlags, flags);
        const contents = body.map(gen).join("|");
        const result = !state.verbose && body.length === 1 && // Single alt
        parent.type !== "Quantifier" && !atomic2 && (!state.useFlagMods || !flags) ? contents : `(?${$c0ef9b2f1330c5f8$var$getGroupPrefix(atomic2, flags, state.useFlagMods)}${contents})`;
        state.currentFlags = currentFlags;
        return result;
    },
    /**
  @param {LookaroundAssertionNode} node
  */ LookaroundAssertion ({ body: body, kind: kind, negate: negate }, _, gen) {
        const prefix = `${kind === "lookahead" ? "" : "<"}${negate ? "!" : "="}`;
        return `(?${prefix}${body.map(gen).join("|")})`;
    },
    /**
  @param {QuantifierNode} node
  */ Quantifier (node, _, gen) {
        return gen(node.body) + $c0ef9b2f1330c5f8$var$getQuantifierStr(node);
    },
    /**
  @param {SubroutineNode & {isRecursive: true}} node
  */ Subroutine ({ isRecursive: isRecursive, ref: ref }, state) {
        if (!isRecursive) throw new Error("Unexpected non-recursive subroutine in transformed AST");
        const limit = state.recursionLimit;
        return ref === 0 ? `(?R=${limit})` : $c0ef9b2f1330c5f8$var$r`\g<${ref}&R=${limit}>`;
    }
};
var $c0ef9b2f1330c5f8$var$BaseEscapeChars = /* @__PURE__ */ new Set([
    "$",
    "(",
    ")",
    "*",
    "+",
    ".",
    "?",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}"
]);
var $c0ef9b2f1330c5f8$var$CharClassEscapeChars = /* @__PURE__ */ new Set([
    "-",
    "\\",
    "]",
    "^",
    // Literal `[` doesn't require escaping with flag u, but this can help work around regex source
    // linters and regex syntax processors that expect unescaped `[` to create a nested class
    "["
]);
var $c0ef9b2f1330c5f8$var$CharClassEscapeCharsFlagV = /* @__PURE__ */ new Set([
    "(",
    ")",
    "-",
    "/",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}",
    // Double punctuators; also includes already-listed `-` and `^`
    "!",
    "#",
    "$",
    "%",
    "&",
    "*",
    "+",
    ",",
    ".",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "`",
    "~"
]);
var $c0ef9b2f1330c5f8$var$CharCodeEscapeMap = /* @__PURE__ */ new Map([
    [
        9,
        $c0ef9b2f1330c5f8$var$r`\t`
    ],
    // horizontal tab
    [
        10,
        $c0ef9b2f1330c5f8$var$r`\n`
    ],
    // line feed
    [
        11,
        $c0ef9b2f1330c5f8$var$r`\v`
    ],
    // vertical tab
    [
        12,
        $c0ef9b2f1330c5f8$var$r`\f`
    ],
    // form feed
    [
        13,
        $c0ef9b2f1330c5f8$var$r`\r`
    ],
    // carriage return
    [
        8232,
        $c0ef9b2f1330c5f8$var$r`\u2028`
    ],
    // line separator
    [
        8233,
        $c0ef9b2f1330c5f8$var$r`\u2029`
    ],
    // paragraph separator
    [
        65279,
        $c0ef9b2f1330c5f8$var$r`\uFEFF`
    ]
]);
var $c0ef9b2f1330c5f8$var$casedRe = /^\p{Cased}$/u;
function $c0ef9b2f1330c5f8$var$charHasCase(char) {
    return $c0ef9b2f1330c5f8$var$casedRe.test(char);
}
function $c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node, options) {
    const firstOnly = !!options?.firstOnly;
    const min = node.min.value;
    const max = node.max.value;
    const found = [];
    if (min < 65 && (max === 65535 || max >= 131071) || min === 65536 && max >= 131071) return found;
    for(let i = min; i <= max; i++){
        const char = $c0ef9b2f1330c5f8$var$cp(i);
        if (!$c0ef9b2f1330c5f8$var$charHasCase(char)) continue;
        const charsOutsideRange = $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char).filter((caseOfChar)=>{
            const num = caseOfChar.codePointAt(0);
            return num < min || num > max;
        });
        if (charsOutsideRange.length) {
            found.push(...charsOutsideRange);
            if (firstOnly) break;
        }
    }
    return found;
}
function $c0ef9b2f1330c5f8$var$getCharEscape(codePoint, { escDigit: escDigit, inCharClass: inCharClass, useFlagV: useFlagV }) {
    if ($c0ef9b2f1330c5f8$var$CharCodeEscapeMap.has(codePoint)) return $c0ef9b2f1330c5f8$var$CharCodeEscapeMap.get(codePoint);
    if (// Control chars, etc.; condition modeled on the Chrome developer console's display for strings
    codePoint < 32 || codePoint > 126 && codePoint < 160 || // Unicode planes 4-16; unassigned, special purpose, and private use area
    codePoint > 262143 || // Avoid corrupting a preceding backref by immediately following it with a literal digit
    escDigit && $c0ef9b2f1330c5f8$var$isDigitCharCode(codePoint)) return codePoint > 255 ? `\\u{${codePoint.toString(16).toUpperCase()}}` : `\\x${codePoint.toString(16).toUpperCase().padStart(2, "0")}`;
    const escapeChars = inCharClass ? useFlagV ? $c0ef9b2f1330c5f8$var$CharClassEscapeCharsFlagV : $c0ef9b2f1330c5f8$var$CharClassEscapeChars : $c0ef9b2f1330c5f8$var$BaseEscapeChars;
    const char = $c0ef9b2f1330c5f8$var$cp(codePoint);
    return (escapeChars.has(char) ? "\\" : "") + char;
}
function $c0ef9b2f1330c5f8$var$getCodePointRangesFromChars(chars) {
    const codePoints = chars.map((char)=>char.codePointAt(0)).sort((a, b)=>a - b);
    const values = [];
    let start = null;
    for(let i = 0; i < codePoints.length; i++){
        if (codePoints[i + 1] === codePoints[i] + 1) start ??= codePoints[i];
        else if (start === null) values.push(codePoints[i]);
        else {
            values.push([
                start,
                codePoints[i]
            ]);
            start = null;
        }
    }
    return values;
}
function $c0ef9b2f1330c5f8$var$getGroupPrefix(atomic2, flagMods, useFlagMods) {
    if (atomic2) return ">";
    let mods = "";
    if (flagMods && useFlagMods) {
        const { enable: enable, disable: disable } = flagMods;
        mods = (enable?.ignoreCase ? "i" : "") + (enable?.dotAll ? "s" : "") + (disable ? "-" : "") + (disable?.ignoreCase ? "i" : "") + (disable?.dotAll ? "s" : "");
    }
    return `${mods}:`;
}
function $c0ef9b2f1330c5f8$var$getQuantifierStr({ kind: kind, max: max, min: min }) {
    let base;
    if (!min && max === 1) base = "?";
    else if (!min && max === Infinity) base = "*";
    else if (min === 1 && max === Infinity) base = "+";
    else if (min === max) base = `{${min}}`;
    else base = `{${min},${max === Infinity ? "" : max}}`;
    return base + ({
        greedy: "",
        lazy: "?",
        possessive: "+"
    })[kind];
}
function $c0ef9b2f1330c5f8$var$isAnyGroup({ type: type }) {
    return type === "CapturingGroup" || type === "Group" || type === "LookaroundAssertion";
}
function $c0ef9b2f1330c5f8$var$isDigitCharCode(value) {
    return value > 47 && value < 58;
}
function $c0ef9b2f1330c5f8$var$isLiteralHyphen({ type: type, value: value }) {
    return type === "Character" && value === 45;
}
// src/subclass.js
var $c0ef9b2f1330c5f8$export$121cb31e8b3a6ab5 = class _EmulatedRegExp extends RegExp {
    /**
  @type {Map<number, {
    hidden?: true;
    transferTo?: number;
  }>}
  */ #captureMap = /* @__PURE__ */ new Map();
    /**
  @type {RegExp | EmulatedRegExp | null}
  */ #compiled = null;
    /**
  @type {string}
  */ #pattern;
    /**
  @type {Map<number, string>?}
  */ #nameMap = null;
    /**
  @type {string?}
  */ #strategy = null;
    /**
  Can be used to serialize the instance.
  @type {EmulatedRegExpOptions}
  */ rawOptions = {};
    // Override the getter with one that works with lazy-compiled regexes
    get source() {
        return this.#pattern || "(?:)";
    }
    /**
  @overload
  @param {string} pattern
  @param {string} [flags]
  @param {EmulatedRegExpOptions} [options]
  */ /**
  @overload
  @param {EmulatedRegExp} pattern
  @param {string} [flags]
  */ constructor(pattern, flags, options){
        const lazyCompile = !!options?.lazyCompile;
        if (pattern instanceof RegExp) {
            if (options) throw new Error("Cannot provide options when copying a regexp");
            const re = pattern;
            super(re, flags);
            this.#pattern = re.source;
            if (re instanceof _EmulatedRegExp) {
                this.#captureMap = re.#captureMap;
                this.#nameMap = re.#nameMap;
                this.#strategy = re.#strategy;
                this.rawOptions = re.rawOptions;
            }
        } else {
            const opts = {
                hiddenCaptures: [],
                strategy: null,
                transfers: [],
                ...options
            };
            super(lazyCompile ? "" : pattern, flags);
            this.#pattern = pattern;
            this.#captureMap = $c0ef9b2f1330c5f8$var$createCaptureMap(opts.hiddenCaptures, opts.transfers);
            this.#strategy = opts.strategy;
            this.rawOptions = options ?? {};
        }
        if (!lazyCompile) this.#compiled = this;
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray?}
  */ exec(str) {
        if (!this.#compiled) {
            const { lazyCompile: lazyCompile, ...rest } = this.rawOptions;
            this.#compiled = new _EmulatedRegExp(this.#pattern, this.flags, rest);
        }
        const useLastIndex = this.global || this.sticky;
        const pos = this.lastIndex;
        if (this.#strategy === "clip_search" && useLastIndex && pos) {
            this.lastIndex = 0;
            const match = this.#execCore(str.slice(pos));
            if (match) {
                $c0ef9b2f1330c5f8$var$adjustMatchDetailsForOffset(match, pos, str, this.hasIndices);
                this.lastIndex += pos;
            }
            return match;
        }
        return this.#execCore(str);
    }
    /**
  Adds support for hidden and transfer captures.
  @param {string} str
  @returns
  */ #execCore(str) {
        this.#compiled.lastIndex = this.lastIndex;
        const match = super.exec.call(this.#compiled, str);
        this.lastIndex = this.#compiled.lastIndex;
        if (!match || !this.#captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        const mappedNums = [
            0
        ];
        for(let i = 1; i < matchCopy.length; i++){
            const { hidden: hidden, transferTo: transferTo } = this.#captureMap.get(i) ?? {};
            if (hidden) mappedNums.push(null);
            else {
                mappedNums.push(match.length);
                match.push(matchCopy[i]);
                if (this.hasIndices) match.indices.push(indicesCopy[i]);
            }
            if (transferTo && matchCopy[i] !== void 0) {
                const to = mappedNums[transferTo];
                if (!to) throw new Error(`Invalid capture transfer to "${to}"`);
                match[to] = matchCopy[i];
                if (this.hasIndices) match.indices[to] = indicesCopy[i];
                if (match.groups) {
                    if (!this.#nameMap) this.#nameMap = $c0ef9b2f1330c5f8$var$createNameMap(this.source);
                    const name = this.#nameMap.get(transferTo);
                    if (name) {
                        match.groups[name] = matchCopy[i];
                        if (this.hasIndices) match.indices.groups[name] = indicesCopy[i];
                    }
                }
            }
        }
        return match;
    }
};
function $c0ef9b2f1330c5f8$var$adjustMatchDetailsForOffset(match, offset, input, hasIndices) {
    match.index += offset;
    match.input = input;
    if (hasIndices) {
        const indices = match.indices;
        for(let i = 0; i < indices.length; i++){
            const arr = indices[i];
            if (arr) indices[i] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        }
        const groupIndices = indices.groups;
        if (groupIndices) Object.keys(groupIndices).forEach((key)=>{
            const arr = groupIndices[key];
            if (arr) groupIndices[key] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        });
    }
}
function $c0ef9b2f1330c5f8$var$createCaptureMap(hiddenCaptures, transfers) {
    const captureMap = /* @__PURE__ */ new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    for (const [to, from] of transfers)for (const num of from)$c0ef9b2f1330c5f8$var$getOrInsert(captureMap, num, {}).transferTo = to;
    return captureMap;
}
function $c0ef9b2f1330c5f8$var$createNameMap(pattern) {
    const re = /(?<capture>\((?:\?<(?![=!])(?<name>[^>]+)>|(?!\?)))|\\?./gsu;
    const map = /* @__PURE__ */ new Map();
    let numCharClassesOpen = 0;
    let numCaptures = 0;
    let match;
    while(match = re.exec(pattern)){
        const { 0: m, groups: { capture: capture, name: name } } = match;
        if (m === "[") numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (capture) {
                numCaptures++;
                if (name) map.set(numCaptures, name);
            }
        } else if (m === "]") numCharClassesOpen--;
    }
    return map;
}
function $c0ef9b2f1330c5f8$export$238374f1b270e387(pattern, options) {
    const d = $c0ef9b2f1330c5f8$export$7a4833dc970906e0(pattern, options);
    if (d.options) return new $c0ef9b2f1330c5f8$export$121cb31e8b3a6ab5(d.pattern, d.flags, d.options);
    return new RegExp(d.pattern, d.flags);
}
function $c0ef9b2f1330c5f8$export$7a4833dc970906e0(pattern, options) {
    const opts = $c0ef9b2f1330c5f8$var$getOptions(options);
    const onigurumaAst = (0, $81a53fa315512537$export$98e6a39c04603d36)(pattern, {
        flags: opts.flags,
        normalizeUnknownPropertyNames: true,
        rules: {
            captureGroup: opts.rules.captureGroup,
            singleline: opts.rules.singleline
        },
        skipBackrefValidation: opts.rules.allowOrphanBackrefs,
        unicodePropertyMap: $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap
    });
    const regexPlusAst = $c0ef9b2f1330c5f8$var$transform(onigurumaAst, {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.rules.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        bestEffortTarget: opts.target
    });
    const generated = $c0ef9b2f1330c5f8$var$generate(regexPlusAst, opts);
    const recursionResult = (0, $f998c33fe6f5a8d0$export$74c5cab0f9a94551)(generated.pattern, {
        captureTransfers: generated._captureTransfers,
        hiddenCaptures: generated._hiddenCaptures,
        mode: "external"
    });
    const possessiveResult = (0, $e7b0758e094fae76$export$777a2fba7d8a1541)(recursionResult.pattern);
    const atomicResult = (0, $e7b0758e094fae76$export$a573bc8e40d39511)(possessiveResult.pattern, {
        captureTransfers: recursionResult.captureTransfers,
        hiddenCaptures: recursionResult.hiddenCaptures
    });
    const details = {
        pattern: atomicResult.pattern,
        flags: `${opts.hasIndices ? "d" : ""}${opts.global ? "g" : ""}${generated.flags}${generated.options.disable.v ? "u" : "v"}`
    };
    if (opts.avoidSubclass) {
        if (opts.lazyCompileLength !== Infinity) throw new Error("Lazy compilation requires subclass");
    } else {
        const hiddenCaptures = atomicResult.hiddenCaptures.sort((a, b)=>a - b);
        const transfers = Array.from(atomicResult.captureTransfers);
        const strategy = regexPlusAst._strategy;
        const lazyCompile = details.pattern.length >= opts.lazyCompileLength;
        if (hiddenCaptures.length || transfers.length || strategy || lazyCompile) details.options = {
            ...hiddenCaptures.length && {
                hiddenCaptures: hiddenCaptures
            },
            ...transfers.length && {
                transfers: transfers
            },
            ...strategy && {
                strategy: strategy
            },
            ...lazyCompile && {
                lazyCompile: lazyCompile
            }
        };
    }
    return details;
}


//#region src/engine-compile.ts
/**
* The default regex constructor for the JavaScript RegExp engine.
*/ function $2cfe98e607de8b65$export$70b386be05242d0f(pattern, options) {
    return (0, $c0ef9b2f1330c5f8$export$238374f1b270e387)(pattern, {
        global: true,
        hasIndices: true,
        lazyCompileLength: 3e3,
        rules: {
            allowOrphanBackrefs: true,
            asciiWordBoundaries: true,
            captureGroup: true,
            recursionLimit: 5,
            singleline: true
        },
        ...options
    });
}
/**
* Use the modern JavaScript RegExp engine to implement the OnigScanner.
*
* As Oniguruma supports some features that can't be emulated using native JavaScript regexes, some
* patterns are not supported. Errors will be thrown when parsing TextMate grammars with
* unsupported patterns, and when the grammar includes patterns that use invalid Oniguruma syntax.
* Set `forgiving` to `true` to ignore these errors and skip any unsupported or invalid patterns.
*/ function $2cfe98e607de8b65$export$d1f38b498ee0de14(options = {}) {
    const _options = {
        target: "auto",
        cache: /* @__PURE__ */ new Map(),
        ...options
    };
    _options.regexConstructor ||= (pattern)=>$2cfe98e607de8b65$export$70b386be05242d0f(pattern, {
            target: _options.target
        });
    return {
        createScanner (patterns) {
            return new (0, $ff959011b904cb5e$export$7ccc53e8f1e7dfc5)(patterns, _options);
        },
        createString: (0, $ff959011b904cb5e$export$625550452a3fa3ec)
    };
}


/* @minVersion 7.20.0 */ /**
  Enums are used in this file, but not assigned to vars to avoid non-hoistable values

  CONSTRUCTOR = 0;
  PUBLIC = 1;
  PRIVATE = 2;

  FIELD = 0;
  ACCESSOR = 1;
  METHOD = 2;
  GETTER = 3;
  SETTER = 4;

  STATIC = 5;

  CLASS = 10; // only used in assertValidReturnValue
*/ function $ad1cfc6cb1ef08cb$export$71511d61b312f219(targetClass, memberDecs, classDecs, parentClass) {
    function createAddInitializerMethod(initializers, decoratorFinishedRef) {
        return function addInitializer(initializer) {
            assertNotFinished(decoratorFinishedRef, "addInitializer");
            assertCallable(initializer, "An initializer");
            initializers.push(initializer);
        };
    }
    function memberDec(dec, name, desc, initializers, kind, isStatic, isPrivate, metadata, value) {
        var kindStr;
        switch(kind){
            case 1 /* ACCESSOR */ :
                kindStr = "accessor";
                break;
            case 2 /* METHOD */ :
                kindStr = "method";
                break;
            case 3 /* GETTER */ :
                kindStr = "getter";
                break;
            case 4 /* SETTER */ :
                kindStr = "setter";
                break;
            default:
                kindStr = "field";
        }
        var ctx = {
            kind: kindStr,
            name: isPrivate ? "#" + name : name,
            static: isStatic,
            private: isPrivate,
            metadata: metadata
        };
        var decoratorFinishedRef = {
            v: false
        };
        ctx.addInitializer = createAddInitializerMethod(initializers, decoratorFinishedRef);
        var get, set;
        if (kind === 0 /* FIELD */ ) {
            if (isPrivate) {
                get = desc.get;
                set = desc.set;
            } else {
                get = function() {
                    return this[name];
                };
                set = function(v) {
                    this[name] = v;
                };
            }
        } else if (kind === 2 /* METHOD */ ) get = function() {
            return desc.value;
        };
        else {
            // replace with values that will go through the final getter and setter
            if (kind === 1 /* ACCESSOR */  || kind === 3 /* GETTER */ ) get = function() {
                return desc.get.call(this);
            };
            if (kind === 1 /* ACCESSOR */  || kind === 4 /* SETTER */ ) set = function(v) {
                desc.set.call(this, v);
            };
        }
        if (get) {
            var originalGet = get;
            get = function(target) {
                if (arguments.length === 0) target = this;
                return originalGet.call(target);
            };
        }
        if (set) {
            var originalSet = set;
            set = function(target, value) {
                if (arguments.length === 1) {
                    value = target;
                    target = this;
                }
                return originalSet.call(target, value);
            };
        }
        if (isPrivate) ctx.access = get && set ? {
            get: get,
            set: set
        } : get ? {
            get: get
        } : {
            set: set
        };
        else {
            var has = function(target) {
                return name in target;
            };
            ctx.access = get && set ? {
                has: has,
                get: get,
                set: set
            } : get ? {
                has: has,
                get: get
            } : {
                has: has,
                set: set
            };
        }
        var newValue = dec(value, ctx);
        decoratorFinishedRef.v = true;
        return newValue;
    }
    function assertNotFinished(decoratorFinishedRef, fnName) {
        if (decoratorFinishedRef.v) throw new Error("attempted to call " + fnName + " after decoration was finished");
    }
    function assertCallable(fn, hint) {
        if (typeof fn !== "function") throw new TypeError(hint + " must be a function");
    }
    function assertValidReturnValue(kind, value) {
        var type = typeof value;
        if (kind === 1 /* ACCESSOR */ ) {
            if (type !== "object" || value === null) throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
            if (value.get !== undefined) assertCallable(value.get, "accessor.get");
            if (value.set !== undefined) assertCallable(value.set, "accessor.set");
            if (value.init !== undefined) assertCallable(value.init, "accessor.init");
        } else if (type !== "function") {
            var hint;
            if (kind === 0 /* FIELD */ ) hint = "field";
            else if (kind === 10 /* CLASS */ ) hint = "class";
            else hint = "method";
            throw new TypeError(hint + " decorators must return a function or void 0");
        }
    }
    function applyMemberDec(ret, base, decInfo, name, kind, isStatic, isPrivate, initializers, metadata) {
        var decs = decInfo[0];
        var desc, init, value;
        if (isPrivate) {
            if (kind === 0 /* FIELD */  || kind === 1 /* ACCESSOR */ ) desc = {
                get: decInfo[3],
                set: decInfo[4]
            };
            else if (kind === 3 /* GETTER */ ) desc = {
                get: decInfo[3]
            };
            else if (kind === 4 /* SETTER */ ) desc = {
                set: decInfo[3]
            };
            else desc = {
                value: decInfo[3]
            };
        } else if (kind !== 0 /* FIELD */ ) desc = Object.getOwnPropertyDescriptor(base, name);
        if (kind === 1 /* ACCESSOR */ ) value = {
            get: desc.get,
            set: desc.set
        };
        else if (kind === 2 /* METHOD */ ) value = desc.value;
        else if (kind === 3 /* GETTER */ ) value = desc.get;
        else if (kind === 4 /* SETTER */ ) value = desc.set;
        var newValue, get, set;
        if (typeof decs === "function") {
            newValue = memberDec(decs, name, desc, initializers, kind, isStatic, isPrivate, metadata, value);
            if (newValue !== void 0) {
                assertValidReturnValue(kind, newValue);
                if (kind === 0 /* FIELD */ ) init = newValue;
                else if (kind === 1 /* ACCESSOR */ ) {
                    init = newValue.init;
                    get = newValue.get || value.get;
                    set = newValue.set || value.set;
                    value = {
                        get: get,
                        set: set
                    };
                } else value = newValue;
            }
        } else for(var i = decs.length - 1; i >= 0; i--){
            var dec = decs[i];
            newValue = memberDec(dec, name, desc, initializers, kind, isStatic, isPrivate, metadata, value);
            if (newValue !== void 0) {
                assertValidReturnValue(kind, newValue);
                var newInit;
                if (kind === 0 /* FIELD */ ) newInit = newValue;
                else if (kind === 1 /* ACCESSOR */ ) {
                    newInit = newValue.init;
                    get = newValue.get || value.get;
                    set = newValue.set || value.set;
                    value = {
                        get: get,
                        set: set
                    };
                } else value = newValue;
                if (newInit !== void 0) {
                    if (init === void 0) init = newInit;
                    else if (typeof init === "function") init = [
                        init,
                        newInit
                    ];
                    else init.push(newInit);
                }
            }
        }
        if (kind === 0 /* FIELD */  || kind === 1 /* ACCESSOR */ ) {
            if (init === void 0) // If the initializer was void 0, sub in a dummy initializer
            init = function(instance, init) {
                return init;
            };
            else if (typeof init !== "function") {
                var ownInitializers = init;
                init = function(instance, init) {
                    var value = init;
                    for(var i = 0; i < ownInitializers.length; i++)value = ownInitializers[i].call(instance, value);
                    return value;
                };
            } else {
                var originalInitializer = init;
                init = function(instance, init) {
                    return originalInitializer.call(instance, init);
                };
            }
            ret.push(init);
        }
        if (kind !== 0 /* FIELD */ ) {
            if (kind === 1 /* ACCESSOR */ ) {
                desc.get = value.get;
                desc.set = value.set;
            } else if (kind === 2 /* METHOD */ ) desc.value = value;
            else if (kind === 3 /* GETTER */ ) desc.get = value;
            else if (kind === 4 /* SETTER */ ) desc.set = value;
            if (isPrivate) {
                if (kind === 1 /* ACCESSOR */ ) {
                    ret.push(function(instance, args) {
                        return value.get.call(instance, args);
                    });
                    ret.push(function(instance, args) {
                        return value.set.call(instance, args);
                    });
                } else if (kind === 2 /* METHOD */ ) ret.push(value);
                else ret.push(function(instance, args) {
                    return value.call(instance, args);
                });
            } else Object.defineProperty(base, name, desc);
        }
    }
    function applyMemberDecs(Class, decInfos, metadata) {
        var ret = [];
        var protoInitializers;
        var staticInitializers;
        var existingProtoNonFields = new Map();
        var existingStaticNonFields = new Map();
        for(var i = 0; i < decInfos.length; i++){
            var decInfo = decInfos[i];
            // skip computed property names
            if (!Array.isArray(decInfo)) continue;
            var kind = decInfo[1];
            var name = decInfo[2];
            var isPrivate = decInfo.length > 3;
            var isStatic = kind >= 5; /* STATIC */ 
            var base;
            var initializers;
            if (isStatic) {
                base = Class;
                kind = kind - 5 /* STATIC */ ;
                // initialize staticInitializers when we see a non-field static member
                staticInitializers = staticInitializers || [];
                initializers = staticInitializers;
            } else {
                base = Class.prototype;
                // initialize protoInitializers when we see a non-field member
                protoInitializers = protoInitializers || [];
                initializers = protoInitializers;
            }
            if (kind !== 0 /* FIELD */  && !isPrivate) {
                var existingNonFields = isStatic ? existingStaticNonFields : existingProtoNonFields;
                var existingKind = existingNonFields.get(name) || 0;
                if (existingKind === true || existingKind === 3 /* GETTER */  && kind !== 4 || existingKind === 4 /* SETTER */  && kind !== 3) throw new Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + name);
                else if (!existingKind && kind > 2 /* METHOD */ ) existingNonFields.set(name, kind);
                else existingNonFields.set(name, true);
            }
            applyMemberDec(ret, base, decInfo, name, kind, isStatic, isPrivate, initializers, metadata);
        }
        pushInitializers(ret, protoInitializers);
        pushInitializers(ret, staticInitializers);
        return ret;
    }
    function pushInitializers(ret, initializers) {
        if (initializers) ret.push(function(instance) {
            for(var i = 0; i < initializers.length; i++)initializers[i].call(instance);
            return instance;
        });
    }
    function applyClassDecs(targetClass, classDecs, metadata) {
        if (classDecs.length > 0) {
            var initializers = [];
            var newClass = targetClass;
            var name = targetClass.name;
            for(var i = classDecs.length - 1; i >= 0; i--){
                var decoratorFinishedRef = {
                    v: false
                };
                var nextNewClass = classDecs[i](newClass, {
                    kind: "class",
                    name: name,
                    addInitializer: createAddInitializerMethod(initializers, decoratorFinishedRef),
                    metadata: metadata
                });
                decoratorFinishedRef.v = true;
                if (nextNewClass !== undefined) {
                    assertValidReturnValue(10, /* CLASS */ nextNewClass);
                    newClass = nextNewClass;
                }
            }
            return [
                defineMetadata(newClass, metadata),
                function() {
                    for(var i = 0; i < initializers.length; i++)initializers[i].call(newClass);
                }
            ];
        }
    // The transformer will not emit assignment when there are no class decorators,
    // so we don't have to return an empty array here.
    }
    function defineMetadata(Class, metadata) {
        return Object.defineProperty(Class, Symbol.metadata || Symbol.for("Symbol.metadata"), {
            configurable: true,
            enumerable: true,
            value: metadata
        });
    }
    /**
    Basic usage:

    applyDecs(
      Class,
      [
        // member decorators
        [
          dec,                // dec or array of decs
          0,                  // kind of value being decorated
          'prop',             // name of public prop on class containing the value being decorated,
          '#p',               // the name of the private property (if is private, void 0 otherwise),
        ]
      ],
      [
        // class decorators
        dec1, dec2
      ]
    )
    ```

    Fully transpiled example:

    ```js
    @dec
    class Class {
      @dec
      a = 123;

      @dec
      #a = 123;

      @dec
      @dec2
      accessor b = 123;

      @dec
      accessor #b = 123;

      @dec
      c() { console.log('c'); }

      @dec
      #c() { console.log('privC'); }

      @dec
      get d() { console.log('d'); }

      @dec
      get #d() { console.log('privD'); }

      @dec
      set e(v) { console.log('e'); }

      @dec
      set #e(v) { console.log('privE'); }
    }


    // becomes
    let initializeInstance;
    let initializeClass;

    let initA;
    let initPrivA;

    let initB;
    let initPrivB, getPrivB, setPrivB;

    let privC;
    let privD;
    let privE;

    let Class;
    class _Class {
      static {
        let ret = applyDecs(
          this,
          [
            [dec, 0, 'a'],
            [dec, 0, 'a', (i) => i.#a, (i, v) => i.#a = v],
            [[dec, dec2], 1, 'b'],
            [dec, 1, 'b', (i) => i.#privBData, (i, v) => i.#privBData = v],
            [dec, 2, 'c'],
            [dec, 2, 'c', () => console.log('privC')],
            [dec, 3, 'd'],
            [dec, 3, 'd', () => console.log('privD')],
            [dec, 4, 'e'],
            [dec, 4, 'e', () => console.log('privE')],
          ],
          [
            dec
          ]
        )

        initA = ret[0];

        initPrivA = ret[1];

        initB = ret[2];

        initPrivB = ret[3];
        getPrivB = ret[4];
        setPrivB = ret[5];

        privC = ret[6];

        privD = ret[7];

        privE = ret[8];

        initializeInstance = ret[9];

        Class = ret[10]

        initializeClass = ret[11];
      }

      a = (initializeInstance(this), initA(this, 123));

      #a = initPrivA(this, 123);

      #bData = initB(this, 123);
      get b() { return this.#bData }
      set b(v) { this.#bData = v }

      #privBData = initPrivB(this, 123);
      get #b() { return getPrivB(this); }
      set #b(v) { setPrivB(this, v); }

      c() { console.log('c'); }

      #c(...args) { return privC(this, ...args) }

      get d() { console.log('d'); }

      get #d() { return privD(this); }

      set e(v) { console.log('e'); }

      set #e(v) { privE(this, v); }
    }

    initializeClass(Class);
   */ $ad1cfc6cb1ef08cb$export$71511d61b312f219 = function(targetClass, memberDecs, classDecs, parentClass) {
        if (parentClass !== void 0) var parentMetadata = parentClass[Symbol.metadata || Symbol.for("Symbol.metadata")];
        var metadata = Object.create(parentMetadata === void 0 ? null : parentMetadata);
        var e = applyMemberDecs(targetClass, memberDecs, metadata);
        if (!classDecs.length) defineMetadata(targetClass, metadata);
        return {
            e: e,
            // Lazily apply class decorations so that member init locals can be properly bound.
            get c () {
                return applyClassDecs(targetClass, classDecs, metadata);
            }
        };
    };
    return $ad1cfc6cb1ef08cb$export$71511d61b312f219(targetClass, memberDecs, classDecs, parentClass);
}


function $0a5bf7f91ed78f6c$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $1e332cd184ae8bcd$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $2e8770fb1746bee3$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $1e332cd184ae8bcd$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $0a5bf7f91ed78f6c$export$71511d61b312f219)(receiver, descriptor);
}


function $bc994fd788862511$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $da1508c8a4f4d8c0$export$71511d61b312f219(obj, privateMap, value) {
    (0, $bc994fd788862511$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $057aef4c996a46e4$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $3ef3985b24825cc1$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $1e332cd184ae8bcd$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $057aef4c996a46e4$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $47926a612454f4f1$export$71511d61b312f219(x) {
    return x;
}





var $dYe7D = parcelRequire("dYe7D");


var $5E6i4 = parcelRequire("5E6i4");

var $90MBA = parcelRequire("90MBA");
function $85705ec7803c1445$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $85705ec7803c1445$var$$c8e09632ab7a900a$exports = {};
$85705ec7803c1445$var$$parcel$export($85705ec7803c1445$var$$c8e09632ab7a900a$exports, "isEqualProps", function() {
    return $85705ec7803c1445$export$7112c88e033533b8;
});
$85705ec7803c1445$var$$parcel$export($85705ec7803c1445$var$$c8e09632ab7a900a$exports, "reaction", function() {
    return $85705ec7803c1445$export$7203b476385689ae;
});
$85705ec7803c1445$var$$parcel$export($85705ec7803c1445$var$$c8e09632ab7a900a$exports, "ObservedComponent", function() {
    return $85705ec7803c1445$export$bf180ef329d1efd8;
});
var $85705ec7803c1445$var$$c8e09632ab7a900a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $85705ec7803c1445$var$$c8e09632ab7a900a$var$ref = (0, $7c1ccfb859bb0dff$export$431518ad42ffb7bd) || Reflect.get((0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a), 'ref', (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a));
const $85705ec7803c1445$export$7112c88e033533b8 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($dYe7D)))(a, b, (a, b, key)=>[
            '_owner',
            '$$typeof'
        ].includes(key) || undefined);
const $85705ec7803c1445$var$$c8e09632ab7a900a$var$reactionMap = new WeakMap();
const $85705ec7803c1445$export$7203b476385689ae = (expression)=>(effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $85705ec7803c1445$var$$c8e09632ab7a900a$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$reactionMap.set(this, reactions);
        });
/**
 * @see {@link https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations}
 * @see {@link https://github.com/idea2app/MobX-React-helper?tab=readme-ov-file#observable-props-state--context}
 */ let $85705ec7803c1445$export$bf180ef329d1efd8 = (()=>{
    var _a, _ObservedComponent_disposers, _ObservedComponent_observedProps_accessor_storage, _ObservedComponent_observedState_accessor_storage, _ObservedComponent_observedContext_accessor_storage;
    let _classSuper = (0, $5E6i4.Component);
    let _observedProps_decorators;
    let _observedProps_initializers = [];
    let _observedProps_extraInitializers = [];
    let _observedState_decorators;
    let _observedState_initializers = [];
    let _observedState_extraInitializers = [];
    let _observedContext_decorators;
    let _observedContext_initializers = [];
    let _observedContext_extraInitializers = [];
    return _a = class ObservedComponent extends _classSuper {
        constructor(){
            super(...arguments);
            _ObservedComponent_observedProps_accessor_storage.set(this, $85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedProps_initializers, this.props));
            _ObservedComponent_observedState_accessor_storage.set(this, ($85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedProps_extraInitializers), $85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedState_initializers, this.state)));
            _ObservedComponent_observedContext_accessor_storage.set(this, ($85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedState_extraInitializers), $85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedContext_initializers, this.context)));
            _ObservedComponent_disposers.set(this, $85705ec7803c1445$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedContext_extraInitializers));
        }
        get observedProps() {
            return $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedProps_accessor_storage, "f");
        }
        set observedProps(value) {
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedProps_accessor_storage, value, "f");
        }
        get observedState() {
            return $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedState_accessor_storage, "f");
        }
        set observedState(value) {
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedState_accessor_storage, value, "f");
        }
        get observedContext() {
            return $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedContext_accessor_storage, "f");
        }
        set observedContext(value) {
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedContext_accessor_storage, value, "f");
        }
        componentDidMount() {
            var _b;
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_disposers, (_b = $85705ec7803c1445$var$$c8e09632ab7a900a$var$reactionMap.get(this)) === null || _b === void 0 ? void 0 : _b.map(({ expression: expression, effect: effect })=>(0, $7c1ccfb859bb0dff$export$7203b476385689ae)((reaction)=>expression(this, reaction), effect.bind(this))), "f");
        }
        componentWillUnmount() {
            var _b;
            (_b = $85705ec7803c1445$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_disposers, "f")) === null || _b === void 0 || _b.forEach((disposer)=>disposer());
        }
        componentDidUpdate(prevProps, prevState, snapshot) {
            var _b;
            if (!$85705ec7803c1445$export$7112c88e033533b8(prevProps, this.props)) this.observedProps = Object.assign({}, this.props);
            if (!$85705ec7803c1445$export$7112c88e033533b8(prevState, this.state)) this.observedState = Object.assign({}, this.state);
            if (this.observedContext !== this.context) this.observedContext = this.context;
            (_b = super.componentDidUpdate) === null || _b === void 0 || _b.call(this, prevProps, prevState, snapshot);
        }
    }, _ObservedComponent_disposers = new WeakMap(), _ObservedComponent_observedProps_accessor_storage = new WeakMap(), _ObservedComponent_observedState_accessor_storage = new WeakMap(), _ObservedComponent_observedContext_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _observedProps_decorators = [
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$ref
        ];
        _observedState_decorators = [
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$ref
        ];
        _observedContext_decorators = [
            $85705ec7803c1445$var$$c8e09632ab7a900a$var$ref
        ];
        $85705ec7803c1445$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedProps_decorators, {
            kind: "accessor",
            name: "observedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedProps" in obj,
                get: (obj)=>obj.observedProps,
                set: (obj, value)=>{
                    obj.observedProps = value;
                }
            },
            metadata: _metadata
        }, _observedProps_initializers, _observedProps_extraInitializers);
        $85705ec7803c1445$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedState_decorators, {
            kind: "accessor",
            name: "observedState",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedState" in obj,
                get: (obj)=>obj.observedState,
                set: (obj, value)=>{
                    obj.observedState = value;
                }
            },
            metadata: _metadata
        }, _observedState_initializers, _observedState_extraInitializers);
        $85705ec7803c1445$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedContext_decorators, {
            kind: "accessor",
            name: "observedContext",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedContext" in obj,
                get: (obj)=>obj.observedContext,
                set: (obj, value)=>{
                    obj.observedContext = value;
                }
            },
            metadata: _metadata
        }, _observedContext_initializers, _observedContext_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $85705ec7803c1445$var$$329ff9b0b89f7d62$exports = {};
$85705ec7803c1445$var$$parcel$export($85705ec7803c1445$var$$329ff9b0b89f7d62$exports, "FormComponent", function() {
    return $85705ec7803c1445$export$cec7cafc710f5d68;
});
var $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
/**
 * @see {@link https://github.com/idea2app/MobX-React-helper?tab=readme-ov-file#abstract-form-component}
 */ let $85705ec7803c1445$export$cec7cafc710f5d68 = (()=>{
    var _a, _FormComponent_defaultValueDisposer, _FormComponent_changeEventDisposer, _FormComponent_useDefault, _FormComponent_innerValue_accessor_storage;
    let _classSuper = $85705ec7803c1445$export$bf180ef329d1efd8;
    let _instanceExtraInitializers = [];
    let _innerValue_decorators;
    let _innerValue_initializers = [];
    let _innerValue_extraInitializers = [];
    let _get_value_decorators;
    return _a = class FormComponent extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "ref", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($85705ec7803c1445$var$$329ff9b0b89f7d62$var$__runInitializers(this, _instanceExtraInitializers), (0, $5E6i4.createRef)())
            });
            _FormComponent_innerValue_accessor_storage.set(this, $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__runInitializers(this, _innerValue_initializers, this.props.defaultValue));
            _FormComponent_defaultValueDisposer.set(this, $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__runInitializers(this, _innerValue_extraInitializers));
            _FormComponent_changeEventDisposer.set(this, void 0);
            _FormComponent_useDefault.set(this, (value)=>{
                if (!(0, $90MBA.isEmpty)(value) && (0, $90MBA.isEmpty)(this.innerValue)) this.innerValue = value;
            });
            Object.defineProperty(this, "emitValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (value)=>{
                    var _b, _c;
                    return (_c = (_b = this.observedProps).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, value && typeof value === 'object' ? (0, $7c1ccfb859bb0dff$export$f08965dd1304d490)(value) : value);
                }
            });
            Object.defineProperty(this, "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>this.innerValue = this.props.defaultValue
            });
        }
        get innerValue() {
            return $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_innerValue_accessor_storage, "f");
        }
        set innerValue(value) {
            $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_innerValue_accessor_storage, value, "f");
        }
        get value() {
            var _b;
            return (_b = this.observedProps.value) !== null && _b !== void 0 ? _b : this.innerValue;
        }
        componentDidMount() {
            var _b, _c;
            $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_defaultValueDisposer, (0, $7c1ccfb859bb0dff$export$7203b476385689ae)(()=>this.observedProps.defaultValue, $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_useDefault, "f")), "f");
            $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_changeEventDisposer, (0, $7c1ccfb859bb0dff$export$7203b476385689ae)(()=>this.innerValue, this.emitValue), "f");
            (_c = (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.form) === null || _c === void 0 || _c.addEventListener('reset', this.reset);
        }
        componentWillUnmount() {
            var _b, _c, _d, _e;
            (_b = $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_defaultValueDisposer, "f")) === null || _b === void 0 || _b.call(this);
            $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_defaultValueDisposer, undefined, "f");
            (_c = $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_changeEventDisposer, "f")) === null || _c === void 0 || _c.call(this);
            $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_changeEventDisposer, undefined, "f");
            (_e = (_d = this.ref.current) === null || _d === void 0 ? void 0 : _d.form) === null || _e === void 0 || _e.removeEventListener('reset', this.reset);
        }
    }, _FormComponent_defaultValueDisposer = new WeakMap(), _FormComponent_changeEventDisposer = new WeakMap(), _FormComponent_useDefault = new WeakMap(), _FormComponent_innerValue_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _innerValue_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_value_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__esDecorate(_a, null, _innerValue_decorators, {
            kind: "accessor",
            name: "innerValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"innerValue" in obj,
                get: (obj)=>obj.innerValue,
                set: (obj, value)=>{
                    obj.innerValue = value;
                }
            },
            metadata: _metadata
        }, _innerValue_initializers, _innerValue_extraInitializers);
        $85705ec7803c1445$var$$329ff9b0b89f7d62$var$__esDecorate(_a, null, _get_value_decorators, {
            kind: "getter",
            name: "value",
            static: false,
            private: false,
            access: {
                has: (obj)=>"value" in obj,
                get: (obj)=>obj.value
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();



var $90MBA = parcelRequire("90MBA");
function $7db8a787aa9e39e9$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $7db8a787aa9e39e9$export$c7e91f8aec23ae14;
});
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $7db8a787aa9e39e9$export$51ca94569b882c51;
});
class $7db8a787aa9e39e9$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $7db8a787aa9e39e9$export$51ca94569b882c51 = ()=>new $7db8a787aa9e39e9$export$c7e91f8aec23ae14();
var $7db8a787aa9e39e9$var$$e3640f413e0c36e7$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $7db8a787aa9e39e9$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, 'observable', Symbol('observable'));
class $7db8a787aa9e39e9$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $7db8a787aa9e39e9$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $7db8a787aa9e39e9$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) {
                    queue[queue.length - 1].reject(reason);
                    done = true;
                }
                if (canceler) canceler();
            },
            complete () {
                if (!done) {
                    queue[queue.length - 1].resolve();
                    done = true;
                }
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug instanceof Error || typeof bug === 'string' ? bug : new Error(bug + ''));
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error instanceof Error || typeof error === 'string' ? error : new Error(error + ''));
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === 'function') target.on(name, next).on('error', error);
            else {
                target.addEventListener(name, next);
                target.addEventListener('error', error);
            }
            return ()=>{
                if (typeof target.off === 'function') target.off(name, next).off('error', error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener('error', error);
                }
            };
        });
    }
}
var $7db8a787aa9e39e9$var$$603f33a01a36ab56$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $7db8a787aa9e39e9$export$d16acf4b6e75743d;
});
function $7db8a787aa9e39e9$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $7db8a787aa9e39e9$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $7db8a787aa9e39e9$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


function $25a6c985cf60a3ea$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $25a6c985cf60a3ea$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $25a6c985cf60a3ea$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $25a6c985cf60a3ea$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function $9e9a01d9395d29c7$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        const Component = (parcelRequire("kZfGu"));
        return Component.default || Component;
    } else {
        const Component = (parcelRequire("eHX5R"));
        return Component.default || Component;
    }
}


var $70d150f8dfa3d626$exports = {};
"use strict";
var $70d150f8dfa3d626$var$e = {
    code: ({ data: e })=>`<pre><code>${e.code}</code></pre>`,
    embed: ({ data: e })=>{
        const t = e.service;
        return "vimeo" === t ? `<iframe src="${e.embed}" height="${e.height}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>` : "youtube" === t ? `<iframe width="${e.width}" height="${e.height}" src="${e.embed}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: ({ data: e })=>`<h${e.level}>${e.text}</h${e.level}>`,
    image: ({ data: e })=>{
        const t = e.caption ? e.caption : "Image";
        return `<img src="${e?.file?.url || e?.url}" alt="${t}" />`;
    },
    list: ({ data: e })=>{
        const t = "unordered" === e.style ? "ul" : "ol", r = (e, t)=>{
            const o = e.map((e)=>{
                if (!e.content && !e.items) return `<li>${e}</li>`;
                let o = "";
                return e.items?.length && (o = r(e.items, t)), e.content ? `<li>${e.content}${o}</li>` : void 0;
            });
            return `<${t}>${o.join("")}</${t}>`;
        };
        return r(e.items, t);
    },
    paragraph: ({ data: e })=>{
        const t = e.alignment || e.align;
        return t ? `<p style="text-align:${t}"> ${e.text} </p>` : `<p>${e.text}</p>`;
    },
    quote: ({ data: e })=>`<blockquote>${e.text}</blockquote> - ${e.caption}`,
    delimiter: ({ data: e })=>"<br/>"
};
$70d150f8dfa3d626$exports = (t = {}, r = {
    strict: !1
})=>{
    const o = {
        ...$70d150f8dfa3d626$var$e,
        ...t
    };
    return {
        parse: (e)=>(({ blocks: e }, t, r)=>e.reduce((e, o)=>{
                    if (o.type in t) return e + t[o.type](o);
                    const i = `[editorjs-html]: Parser function for ${o.type} does not exist`;
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, ""))(e, o, r),
        parseBlock: (e)=>((e, t, r)=>{
                if (e.type in t) return t[e.type](e);
                const o = `[editorjs-html]: Parser function for ${e.type} does not exist`;
                if (r.strict) throw new Error(o);
                console.error(o);
            })(e, o, r)
    };
};



var $5E6i4 = parcelRequire("5E6i4");
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;


var $d5bb3ba30412c929$var$__create = Object.create;
var $d5bb3ba30412c929$var$__defProp = Object.defineProperty;
var $d5bb3ba30412c929$var$__defProps = Object.defineProperties;
var $d5bb3ba30412c929$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d5bb3ba30412c929$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d5bb3ba30412c929$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d5bb3ba30412c929$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d5bb3ba30412c929$var$__getProtoOf = Object.getPrototypeOf;
var $d5bb3ba30412c929$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d5bb3ba30412c929$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d5bb3ba30412c929$var$__defNormalProp = (obj, key, value)=>key in obj ? $d5bb3ba30412c929$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d5bb3ba30412c929$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d5bb3ba30412c929$var$__hasOwnProp.call(b, prop)) $d5bb3ba30412c929$var$__defNormalProp(a, prop, b[prop]);
    if ($d5bb3ba30412c929$var$__getOwnPropSymbols) {
        for (var prop of $d5bb3ba30412c929$var$__getOwnPropSymbols(b))if ($d5bb3ba30412c929$var$__propIsEnum.call(b, prop)) $d5bb3ba30412c929$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d5bb3ba30412c929$var$__spreadProps = (a, b)=>$d5bb3ba30412c929$var$__defProps(a, $d5bb3ba30412c929$var$__getOwnPropDescs(b));
var $d5bb3ba30412c929$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d5bb3ba30412c929$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d5bb3ba30412c929$var$__getOwnPropSymbols) {
        for (var prop of $d5bb3ba30412c929$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d5bb3ba30412c929$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d5bb3ba30412c929$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$d5bb3ba30412c929$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $d5bb3ba30412c929$var$__export = (target, all)=>{
    for(var name in all)$d5bb3ba30412c929$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d5bb3ba30412c929$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d5bb3ba30412c929$var$__getOwnPropNames(from))if (!$d5bb3ba30412c929$var$__hasOwnProp.call(to, key) && key !== except) $d5bb3ba30412c929$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d5bb3ba30412c929$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d5bb3ba30412c929$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $d5bb3ba30412c929$var$__create($d5bb3ba30412c929$var$__getProtoOf(mod)) : {}, $d5bb3ba30412c929$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $d5bb3ba30412c929$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $d5bb3ba30412c929$var$require_prism = $d5bb3ba30412c929$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js" (exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $d5bb3ba30412c929$export$dc7257ffb0972f87 = $d5bb3ba30412c929$var$__toESM($d5bb3ba30412c929$var$require_prism());
$d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.entity, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup, $d5bb3ba30412c929$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function(e, n) {
        $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.html = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.mathml = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.svg = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.xml = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("markup", {}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.ssml = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.xml, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.atom = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.xml, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.rss = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup && ($d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.js = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.javascript, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.actionscript = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup && $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.n4js = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.n4jsd = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($d5bb3ba30412c929$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c.char,
            comment: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.c.boolean, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.objectivec = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.objectivec["class-name"], $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.objc = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.objectivec, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.reason = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.go = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($d5bb3ba30412c929$export$dc7257ffb0972f87), $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.python, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.py = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.python, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.json = {
    property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
}, $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.webmanifest = $d5bb3ba30412c929$export$dc7257ffb0972f87.languages.json;
// src/themes/index.ts
var $d5bb3ba30412c929$export$d9a33280f07116d9 = {};
$d5bb3ba30412c929$var$__export($d5bb3ba30412c929$export$d9a33280f07116d9, {
    dracula: ()=>$d5bb3ba30412c929$var$dracula_default,
    duotoneDark: ()=>$d5bb3ba30412c929$var$duotoneDark_default,
    duotoneLight: ()=>$d5bb3ba30412c929$var$duotoneLight_default,
    github: ()=>$d5bb3ba30412c929$var$github_default,
    gruvboxMaterialDark: ()=>$d5bb3ba30412c929$var$gruvboxMaterialDark_default,
    gruvboxMaterialLight: ()=>$d5bb3ba30412c929$var$gruvboxMaterialLight_default,
    jettwaveDark: ()=>$d5bb3ba30412c929$var$jettwaveDark_default,
    jettwaveLight: ()=>$d5bb3ba30412c929$var$jettwaveLight_default,
    nightOwl: ()=>$d5bb3ba30412c929$var$nightOwl_default,
    nightOwlLight: ()=>$d5bb3ba30412c929$var$nightOwlLight_default,
    oceanicNext: ()=>$d5bb3ba30412c929$var$oceanicNext_default,
    okaidia: ()=>$d5bb3ba30412c929$var$okaidia_default,
    oneDark: ()=>$d5bb3ba30412c929$var$oneDark_default,
    oneLight: ()=>$d5bb3ba30412c929$var$oneLight_default,
    palenight: ()=>$d5bb3ba30412c929$var$palenight_default,
    shadesOfPurple: ()=>$d5bb3ba30412c929$var$shadesOfPurple_default,
    synthwave84: ()=>$d5bb3ba30412c929$var$synthwave84_default,
    ultramin: ()=>$d5bb3ba30412c929$var$ultramin_default,
    vsDark: ()=>$d5bb3ba30412c929$var$vsDark_default,
    vsLight: ()=>$d5bb3ba30412c929$var$vsLight_default
});
// src/themes/dracula.ts
var $d5bb3ba30412c929$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$dracula_default = $d5bb3ba30412c929$var$theme;
// src/themes/duotoneDark.ts
var $d5bb3ba30412c929$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$duotoneDark_default = $d5bb3ba30412c929$var$theme2;
// src/themes/duotoneLight.ts
var $d5bb3ba30412c929$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$duotoneLight_default = $d5bb3ba30412c929$var$theme3;
// src/themes/github.ts
var $d5bb3ba30412c929$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$github_default = $d5bb3ba30412c929$var$theme4;
// src/themes/nightOwl.ts
var $d5bb3ba30412c929$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$nightOwl_default = $d5bb3ba30412c929$var$theme5;
// src/themes/nightOwlLight.ts
var $d5bb3ba30412c929$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$nightOwlLight_default = $d5bb3ba30412c929$var$theme6;
// src/themes/oceanicNext.ts
var $d5bb3ba30412c929$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $d5bb3ba30412c929$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $d5bb3ba30412c929$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $d5bb3ba30412c929$var$oceanicNext_default = $d5bb3ba30412c929$var$theme7;
// src/themes/okaidia.ts
var $d5bb3ba30412c929$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$okaidia_default = $d5bb3ba30412c929$var$theme8;
// src/themes/palenight.ts
var $d5bb3ba30412c929$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$palenight_default = $d5bb3ba30412c929$var$theme9;
// src/themes/shadesOfPurple.ts
var $d5bb3ba30412c929$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$shadesOfPurple_default = $d5bb3ba30412c929$var$theme10;
// src/themes/synthwave84.ts
var $d5bb3ba30412c929$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$synthwave84_default = $d5bb3ba30412c929$var$theme11;
// src/themes/ultramin.ts
var $d5bb3ba30412c929$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$ultramin_default = $d5bb3ba30412c929$var$theme12;
// src/themes/vsDark.ts
var $d5bb3ba30412c929$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$vsDark_default = $d5bb3ba30412c929$var$theme13;
// src/themes/vsLight.ts
var $d5bb3ba30412c929$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$vsLight_default = $d5bb3ba30412c929$var$theme14;
// src/themes/jettwaveDark.ts
var $d5bb3ba30412c929$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$jettwaveDark_default = $d5bb3ba30412c929$var$theme15;
// src/themes/jettwaveLight.ts
var $d5bb3ba30412c929$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$jettwaveLight_default = $d5bb3ba30412c929$var$theme16;
// src/themes/oneDark.ts
var $d5bb3ba30412c929$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$oneDark_default = $d5bb3ba30412c929$var$theme17;
// src/themes/oneLight.ts
var $d5bb3ba30412c929$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$oneLight_default = $d5bb3ba30412c929$var$theme18;
// src/themes/gruvboxMaterialDark.ts
var $d5bb3ba30412c929$var$theme19 = {
    plain: {
        color: "#ebdbb2",
        backgroundColor: "#292828"
    },
    styles: [
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin",
                "function"
            ],
            style: {
                color: "#d8a657"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#7daea3"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#e78a4e"
            }
        },
        {
            types: [
                "attr-name",
                "char",
                "url",
                "regex"
            ],
            style: {
                color: "#a9b665"
            }
        },
        {
            types: [
                "attr-value",
                "string"
            ],
            style: {
                color: "#89b482"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#ea6962"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#d3869b"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$gruvboxMaterialDark_default = $d5bb3ba30412c929$var$theme19;
// src/themes/gruvboxMaterialLight.ts
var $d5bb3ba30412c929$var$theme20 = {
    plain: {
        color: "#654735",
        backgroundColor: "#f9f5d7"
    },
    styles: [
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#af2528"
            }
        },
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin"
            ],
            style: {
                color: "#b4730e"
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#477a5b"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#266b79"
            }
        },
        {
            types: [
                "function",
                "attr-name",
                "char",
                "url"
            ],
            style: {
                color: "#72761e"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#b94c07"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#924f79"
            }
        }
    ]
};
var $d5bb3ba30412c929$var$gruvboxMaterialLight_default = $d5bb3ba30412c929$var$theme20;
var $d5bb3ba30412c929$var$useGetLineProps = (themeDictionary)=>(0, $5E6i4.useCallback)((_a)=>{
        var _b = _a, { className: className, style: style, line: line } = _b, rest = $d5bb3ba30412c929$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        const output = $d5bb3ba30412c929$var$__spreadProps($d5bb3ba30412c929$var$__spreadValues({}, rest), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)("token-line", className)
        });
        if (typeof themeDictionary === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if (typeof style === "object") output.style = $d5bb3ba30412c929$var$__spreadValues($d5bb3ba30412c929$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
var $d5bb3ba30412c929$var$useGetTokenProps = (themeDictionary)=>{
    const styleForToken = (0, $5E6i4.useCallback)(({ types: types, empty: empty })=>{
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return Object.assign(empty != null ? {
            display: "inline-block"
        } : {}, ...types.map((type)=>themeDictionary[type]));
    }, [
        themeDictionary
    ]);
    return (0, $5E6i4.useCallback)((_a)=>{
        var _b = _a, { token: token, className: className, style: style } = _b, rest = $d5bb3ba30412c929$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        const output = $d5bb3ba30412c929$var$__spreadProps($d5bb3ba30412c929$var$__spreadValues({}, rest), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)("token", ...token.types, className),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $d5bb3ba30412c929$var$__spreadValues($d5bb3ba30412c929$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $d5bb3ba30412c929$var$newlineRe = /\r\n|\r|\n/;
var $d5bb3ba30412c929$var$normalizeEmptyLines = (line)=>{
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $d5bb3ba30412c929$var$appendTypes = (types, add)=>{
    const typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $d5bb3ba30412c929$var$normalizeTokens = (tokens)=>{
    const typeArrStack = [
        []
    ];
    const tokenArrStack = [
        tokens
    ];
    const tokenArrIndexStack = [
        0
    ];
    const tokenArrSizeStack = [
        tokens.length
    ];
    let i = 0;
    let stackIndex = 0;
    let currentLine = [];
    const acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            let content;
            let types = typeArrStack[stackIndex];
            const tokenArr = tokenArrStack[stackIndex];
            const token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $d5bb3ba30412c929$var$appendTypes(types, token.type);
                if (token.alias) types = $d5bb3ba30412c929$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            const splitByNewlines = content.split($d5bb3ba30412c929$var$newlineRe);
            const newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(let i2 = 1; i2 < newlineCount; i2++){
                $d5bb3ba30412c929$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $d5bb3ba30412c929$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $d5bb3ba30412c929$export$2dc420fd853fdcc4 = $d5bb3ba30412c929$var$normalizeTokens;
var $d5bb3ba30412c929$export$7b94e077f7691ca1 = ({ prism: prism, code: code, grammar: grammar, language: language })=>{
    return (0, $5E6i4.useMemo)(()=>{
        if (grammar == null) return $d5bb3ba30412c929$export$2dc420fd853fdcc4([
            code
        ]);
        const prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prism.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prism.tokenize(code, grammar);
        prism.hooks.run("after-tokenize", prismConfig);
        return $d5bb3ba30412c929$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language,
        // prism is a stable import
        prism
    ]);
};
// src/utils/themeToDict.ts
var $d5bb3ba30412c929$var$themeToDict = (theme21, language)=>{
    const { plain: plain } = theme21;
    const themeDict = theme21.styles.reduce((acc, themeEntry)=>{
        const { languages: languages2, style: style } = themeEntry;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach((type)=>{
            const accStyle = $d5bb3ba30412c929$var$__spreadValues($d5bb3ba30412c929$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $d5bb3ba30412c929$var$__spreadProps($d5bb3ba30412c929$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $d5bb3ba30412c929$var$themeToDict_default = $d5bb3ba30412c929$var$themeToDict;
// src/components/highlight.ts
var $d5bb3ba30412c929$var$Highlight = ({ children: children, language: _language, code: code, theme: theme21, prism: prism })=>{
    const language = _language.toLowerCase();
    const themeDictionary = $d5bb3ba30412c929$var$themeToDict_default(theme21, language);
    const getLineProps = $d5bb3ba30412c929$var$useGetLineProps(themeDictionary);
    const getTokenProps = $d5bb3ba30412c929$var$useGetTokenProps(themeDictionary);
    const grammar = prism.languages[language];
    const tokens = $d5bb3ba30412c929$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: `prism-code language-${language}`,
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $d5bb3ba30412c929$export$39dbc3f558091353 = (props)=>(0, $5E6i4.createElement)($d5bb3ba30412c929$var$Highlight, $d5bb3ba30412c929$var$__spreadProps($d5bb3ba30412c929$var$__spreadValues({}, props), {
        prism: props.prism || $d5bb3ba30412c929$export$dc7257ffb0972f87,
        theme: props.theme || $d5bb3ba30412c929$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
var $a0496693ce2fddad$var$m = {
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
};
function $a0496693ce2fddad$var$p(c) {
    var a = window.getSelection();
    a.empty();
    a.addRange(c);
}
function $a0496693ce2fddad$var$q(c) {
    return (c.metaKey || c.ctrlKey) && !c.altKey && "KeyZ" === c.code;
}
function $a0496693ce2fddad$var$r(c) {
    c = [
        c.firstChild
    ];
    for(var b, a = ""; b = c.pop();)b.nodeType === Node.TEXT_NODE ? a += b.textContent : b.nodeType === Node.ELEMENT_NODE && "BR" === b.nodeName && (a += "\n"), b.nextSibling && c.push(b.nextSibling), b.firstChild && c.push(b.firstChild);
    "\n" !== a[a.length - 1] && (a += "\n");
    return a;
}
function $a0496693ce2fddad$var$w(c) {
    var a = window.getSelection().getRangeAt(0), b = a.collapsed ? 0 : a.toString().length, f = document.createRange();
    f.setStart(c, 0);
    f.setEnd(a.startContainer, a.startOffset);
    return {
        position: c = (f = f.toString()).length,
        extent: b,
        content: f = (f = f.split("\n"))[a = f.length - 1],
        line: a
    };
}
function $a0496693ce2fddad$var$C(c, a, b) {
    0 >= a && (a = 0);
    if (!b || 0 > b) b = a;
    var f = document.createRange();
    c = [
        c.firstChild
    ];
    for(var d, l = 0, g = a; d = c[c.length - 1];){
        if (d.nodeType === Node.TEXT_NODE) {
            if (l + d.textContent.length >= g) {
                var h = g - l;
                if (g === a) {
                    if (g = f, h < d.textContent.length ? g.setStart(d, h) : g.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    h < (b = d).textContent.length ? a.setEnd(b, h) : a.setEndAfter(b);
                    break;
                }
            }
            l += d.textContent.length;
        } else if (d.nodeType === Node.ELEMENT_NODE && "BR" === d.nodeName) {
            if (l + 1 >= g) {
                if (g === a) {
                    if (h = f, 0 < d.textContent.length ? h.setStart(d, 0) : h.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    0 < (b = d).textContent.length ? a.setEnd(b, 0) : a.setEndAfter(b);
                    break;
                }
            }
            l++;
        }
        c.pop();
        d.nextSibling && c.push(d.nextSibling);
        d.firstChild && c.push(d.firstChild);
    }
    return f;
}
function $a0496693ce2fddad$export$52a148af2bad544(c, a, b) {
    function f(k) {
        var b = c.current;
        if (b) {
            var a = $a0496693ce2fddad$var$w(b);
            b = $a0496693ce2fddad$var$r(b);
            a.position += k.length - b.length;
            e.position = a;
            e.onChange(k, a);
        }
    }
    function l(k, b) {
        var e = c.current;
        if (e) {
            var a = window.getSelection().getRangeAt(0);
            a.deleteContents();
            a.collapse();
            var d = b || 0;
            (a = $a0496693ce2fddad$var$C(e, b = (a = $a0496693ce2fddad$var$w(e)).position + (0 > d ? d : 0), a.position + (0 < d ? d : 0))).deleteContents();
            k && a.insertNode(document.createTextNode(k));
            $a0496693ce2fddad$var$p($a0496693ce2fddad$var$C(e, b + k.length));
        }
    }
    function d(b) {
        var a = c.current;
        if (a) {
            a.focus();
            var e = 0;
            if ("number" == typeof b) e = b;
            else {
                var k = $a0496693ce2fddad$var$r(a).split("\n").slice(0, b.row);
                b.row && (e += k.join("\n").length + 1);
                e += b.column;
            }
            $a0496693ce2fddad$var$p($a0496693ce2fddad$var$C(a, e));
        }
    }
    function g() {
        var b = c.current;
        return {
            text: $a0496693ce2fddad$var$r(b),
            position: b = $a0496693ce2fddad$var$w(b)
        };
    }
    function h() {
        e.observer.disconnect();
    }
    b || (b = {});
    var D = (0, $5E6i4.useState)([])[1], e = (0, $5E6i4.useState)(function() {
        var e = {
            observer: null,
            disconnected: !1,
            onChange: a,
            queue: [],
            history: [],
            historyAt: -1,
            position: null
        };
        "undefined" != typeof MutationObserver && (e.observer = new MutationObserver(function b(b) {
            var a;
            (a = e.queue).push.apply(a, b);
        }));
        return e;
    })[0], n = (0, $5E6i4.useMemo)(function() {
        return {
            update: f,
            insert: l,
            move: d,
            getState: g
        };
    }, []);
    if ("object" != typeof navigator) return n;
    (0, $5E6i4.useLayoutEffect)(function() {
        e.onChange = a;
        if (c.current && !b.disabled) {
            e.disconnected = !1;
            e.observer.observe(c.current, $a0496693ce2fddad$var$m);
            if (e.position) {
                var k = e.position, d = k.position;
                $a0496693ce2fddad$var$p($a0496693ce2fddad$var$C(c.current, d, d + k.extent));
            }
            return h;
        }
    });
    (0, $5E6i4.useLayoutEffect)(function() {
        if (!c.current || b.disabled) e.history.length = 0, e.historyAt = -1;
        else {
            var a = c.current;
            if (e.position) {
                a.focus();
                var d = e.position, f = d.position;
                $a0496693ce2fddad$var$p($a0496693ce2fddad$var$C(a, f, f + d.extent));
            }
            var g = a.style.whiteSpace, h = a.contentEditable, l = !0;
            try {
                a.contentEditable = "plaintext-only";
            } catch (u) {
                a.contentEditable = "true", l = !1;
            }
            "pre" !== g && (a.style.whiteSpace = "pre-wrap");
            b.indentation && (a.style.tabSize = a.style.MozTabSize = "" + b.indentation);
            d = "" + " ".repeat(b.indentation || 0);
            var x, E = new RegExp("^(?:" + d + ")"), F = new RegExp("^(?:" + d + ")*(" + d + ")$"), t = function(b) {
                if (c.current && e.position) {
                    var u = $a0496693ce2fddad$var$r(a), d = $a0496693ce2fddad$var$w(a), f = (new Date).valueOf(), g = e.history[e.historyAt];
                    !b && 500 > f - x || g && g[1] === u ? x = f : (b = ++e.historyAt, e.history[b] = [
                        d,
                        u
                    ], e.history.splice(b + 1), 500 < b && (e.historyAt--, e.history.shift()));
                }
            }, v = function() {
                var b;
                (b = e.queue).push.apply(b, e.observer.takeRecords());
                b = $a0496693ce2fddad$var$w(a);
                if (e.queue.length) {
                    e.observer.disconnect();
                    e.disconnected = !0;
                    var d = $a0496693ce2fddad$var$r(a);
                    e.position = b;
                    for(var c, f; c = e.queue.pop();){
                        null !== c.oldValue && (c.target.textContent = c.oldValue);
                        for(f = c.removedNodes.length - 1; 0 <= f; f--)c.target.insertBefore(c.removedNodes[f], c.nextSibling);
                        for(f = c.addedNodes.length - 1; 0 <= f; f--)c.addedNodes[f].parentNode && c.target.removeChild(c.addedNodes[f]);
                    }
                    e.onChange(d, b);
                }
            }, y = function(c) {
                if (!c.defaultPrevented && c.target === a) {
                    if (e.disconnected) return c.preventDefault(), D([]);
                    if ($a0496693ce2fddad$var$q(c)) c.preventDefault(), c.shiftKey ? (c = ++e.historyAt, (c = e.history[c]) || (e.historyAt = e.history.length - 1)) : (c = --e.historyAt, (c = e.history[c]) || (e.historyAt = 0)), c && (e.observer.disconnect(), e.disconnected = !0, e.position = c[0], e.onChange(c[1], c[0]));
                    else {
                        t();
                        if ("Enter" === c.key) {
                            c.preventDefault();
                            var d = $a0496693ce2fddad$var$w(a), f = /\S/g.exec(d.content);
                            d = "\n" + d.content.slice(0, f ? f.index : d.content.length);
                            n.insert(d);
                        } else if ((!l || b.indentation) && "Backspace" === c.key) c.preventDefault(), window.getSelection().getRangeAt(0).collapsed ? (d = $a0496693ce2fddad$var$w(a), d = F.exec(d.content), n.insert("", d ? -d[1].length : -1)) : n.insert("", 0);
                        else if (b.indentation && "Tab" === c.key) {
                            c.preventDefault();
                            f = (d = $a0496693ce2fddad$var$w(a)).position - d.content.length;
                            var g = $a0496693ce2fddad$var$r(a);
                            d = c.shiftKey ? g.slice(0, f) + d.content.replace(E, "") + g.slice(f + d.content.length) : g.slice(0, f) + (b.indentation ? " ".repeat(b.indentation) : "\t") + g.slice(f);
                            n.update(d);
                        }
                        c.repeat && v();
                    }
                }
            }, z = function(b) {
                b.defaultPrevented || b.isComposing || ($a0496693ce2fddad$var$q(b) || t(), v(), a.focus());
            }, A = function(b) {
                e.position = window.getSelection().rangeCount && b.target === a ? $a0496693ce2fddad$var$w(a) : null;
            }, B = function(a) {
                a.preventDefault();
                t(!0);
                n.insert(a.clipboardData.getData("text/plain"));
                t(!0);
                v();
            };
            document.addEventListener("selectstart", A);
            window.addEventListener("keydown", y);
            a.addEventListener("paste", B);
            a.addEventListener("keyup", z);
            return function() {
                document.removeEventListener("selectstart", A);
                window.removeEventListener("keydown", y);
                a.removeEventListener("paste", B);
                a.removeEventListener("keyup", z);
                a.style.whiteSpace = g;
                a.contentEditable = h;
            };
        }
    }, [
        c.current,
        b.disabled,
        b.indentation
    ]);
    return n;
}



/* eslint max-len: 0 */ var $67eb7b9d79b9f423$export$ee633ab6cd0138cc;
(function(ContextualKeyword) {
    const NONE = 0;
    ContextualKeyword[ContextualKeyword["NONE"] = NONE] = "NONE";
    const _abstract = NONE + 1;
    ContextualKeyword[ContextualKeyword["_abstract"] = _abstract] = "_abstract";
    const _accessor = _abstract + 1;
    ContextualKeyword[ContextualKeyword["_accessor"] = _accessor] = "_accessor";
    const _as = _accessor + 1;
    ContextualKeyword[ContextualKeyword["_as"] = _as] = "_as";
    const _assert = _as + 1;
    ContextualKeyword[ContextualKeyword["_assert"] = _assert] = "_assert";
    const _asserts = _assert + 1;
    ContextualKeyword[ContextualKeyword["_asserts"] = _asserts] = "_asserts";
    const _async = _asserts + 1;
    ContextualKeyword[ContextualKeyword["_async"] = _async] = "_async";
    const _await = _async + 1;
    ContextualKeyword[ContextualKeyword["_await"] = _await] = "_await";
    const _checks = _await + 1;
    ContextualKeyword[ContextualKeyword["_checks"] = _checks] = "_checks";
    const _constructor = _checks + 1;
    ContextualKeyword[ContextualKeyword["_constructor"] = _constructor] = "_constructor";
    const _declare = _constructor + 1;
    ContextualKeyword[ContextualKeyword["_declare"] = _declare] = "_declare";
    const _enum = _declare + 1;
    ContextualKeyword[ContextualKeyword["_enum"] = _enum] = "_enum";
    const _exports = _enum + 1;
    ContextualKeyword[ContextualKeyword["_exports"] = _exports] = "_exports";
    const _from = _exports + 1;
    ContextualKeyword[ContextualKeyword["_from"] = _from] = "_from";
    const _get = _from + 1;
    ContextualKeyword[ContextualKeyword["_get"] = _get] = "_get";
    const _global = _get + 1;
    ContextualKeyword[ContextualKeyword["_global"] = _global] = "_global";
    const _implements = _global + 1;
    ContextualKeyword[ContextualKeyword["_implements"] = _implements] = "_implements";
    const _infer = _implements + 1;
    ContextualKeyword[ContextualKeyword["_infer"] = _infer] = "_infer";
    const _interface = _infer + 1;
    ContextualKeyword[ContextualKeyword["_interface"] = _interface] = "_interface";
    const _is = _interface + 1;
    ContextualKeyword[ContextualKeyword["_is"] = _is] = "_is";
    const _keyof = _is + 1;
    ContextualKeyword[ContextualKeyword["_keyof"] = _keyof] = "_keyof";
    const _mixins = _keyof + 1;
    ContextualKeyword[ContextualKeyword["_mixins"] = _mixins] = "_mixins";
    const _module = _mixins + 1;
    ContextualKeyword[ContextualKeyword["_module"] = _module] = "_module";
    const _namespace = _module + 1;
    ContextualKeyword[ContextualKeyword["_namespace"] = _namespace] = "_namespace";
    const _of = _namespace + 1;
    ContextualKeyword[ContextualKeyword["_of"] = _of] = "_of";
    const _opaque = _of + 1;
    ContextualKeyword[ContextualKeyword["_opaque"] = _opaque] = "_opaque";
    const _out = _opaque + 1;
    ContextualKeyword[ContextualKeyword["_out"] = _out] = "_out";
    const _override = _out + 1;
    ContextualKeyword[ContextualKeyword["_override"] = _override] = "_override";
    const _private = _override + 1;
    ContextualKeyword[ContextualKeyword["_private"] = _private] = "_private";
    const _protected = _private + 1;
    ContextualKeyword[ContextualKeyword["_protected"] = _protected] = "_protected";
    const _proto = _protected + 1;
    ContextualKeyword[ContextualKeyword["_proto"] = _proto] = "_proto";
    const _public = _proto + 1;
    ContextualKeyword[ContextualKeyword["_public"] = _public] = "_public";
    const _readonly = _public + 1;
    ContextualKeyword[ContextualKeyword["_readonly"] = _readonly] = "_readonly";
    const _require = _readonly + 1;
    ContextualKeyword[ContextualKeyword["_require"] = _require] = "_require";
    const _satisfies = _require + 1;
    ContextualKeyword[ContextualKeyword["_satisfies"] = _satisfies] = "_satisfies";
    const _set = _satisfies + 1;
    ContextualKeyword[ContextualKeyword["_set"] = _set] = "_set";
    const _static = _set + 1;
    ContextualKeyword[ContextualKeyword["_static"] = _static] = "_static";
    const _symbol = _static + 1;
    ContextualKeyword[ContextualKeyword["_symbol"] = _symbol] = "_symbol";
    const _type = _symbol + 1;
    ContextualKeyword[ContextualKeyword["_type"] = _type] = "_type";
    const _unique = _type + 1;
    ContextualKeyword[ContextualKeyword["_unique"] = _unique] = "_unique";
    const _using = _unique + 1;
    ContextualKeyword[ContextualKeyword["_using"] = _using] = "_using";
})($67eb7b9d79b9f423$export$ee633ab6cd0138cc || ($67eb7b9d79b9f423$export$ee633ab6cd0138cc = {}));


// Generated file, do not edit! Run "yarn generate" to re-generate this file.
/* istanbul ignore file */ /**
 * Enum of all token types, with bit fields to signify meaningful properties.
 */ var $f33b9d3e01f21be3$export$f435f793048e7a0f;
(function(TokenType) {
    // Precedence 0 means not an operator; otherwise it is a positive number up to 12.
    const PRECEDENCE_MASK = 0xf;
    TokenType[TokenType["PRECEDENCE_MASK"] = PRECEDENCE_MASK] = "PRECEDENCE_MASK";
    const IS_KEYWORD = 16;
    TokenType[TokenType["IS_KEYWORD"] = IS_KEYWORD] = "IS_KEYWORD";
    const IS_ASSIGN = 32;
    TokenType[TokenType["IS_ASSIGN"] = IS_ASSIGN] = "IS_ASSIGN";
    const IS_RIGHT_ASSOCIATIVE = 64;
    TokenType[TokenType["IS_RIGHT_ASSOCIATIVE"] = IS_RIGHT_ASSOCIATIVE] = "IS_RIGHT_ASSOCIATIVE";
    const IS_PREFIX = 128;
    TokenType[TokenType["IS_PREFIX"] = IS_PREFIX] = "IS_PREFIX";
    const IS_POSTFIX = 256;
    TokenType[TokenType["IS_POSTFIX"] = IS_POSTFIX] = "IS_POSTFIX";
    const IS_EXPRESSION_START = 512;
    TokenType[TokenType["IS_EXPRESSION_START"] = IS_EXPRESSION_START] = "IS_EXPRESSION_START";
    const num = 512;
    TokenType[TokenType["num"] = num] = "num"; // num startsExpr
    const bigint = 1536;
    TokenType[TokenType["bigint"] = bigint] = "bigint"; // bigint startsExpr
    const decimal = 2560;
    TokenType[TokenType["decimal"] = decimal] = "decimal"; // decimal startsExpr
    const regexp = 3584;
    TokenType[TokenType["regexp"] = regexp] = "regexp"; // regexp startsExpr
    const string = 4608;
    TokenType[TokenType["string"] = string] = "string"; // string startsExpr
    const name = 5632;
    TokenType[TokenType["name"] = name] = "name"; // name startsExpr
    const eof = 6144;
    TokenType[TokenType["eof"] = eof] = "eof"; // eof
    const bracketL = 7680;
    TokenType[TokenType["bracketL"] = bracketL] = "bracketL"; // [ startsExpr
    const bracketR = 8192;
    TokenType[TokenType["bracketR"] = bracketR] = "bracketR"; // ]
    const braceL = 9728;
    TokenType[TokenType["braceL"] = braceL] = "braceL"; // { startsExpr
    const braceBarL = 10752;
    TokenType[TokenType["braceBarL"] = braceBarL] = "braceBarL"; // {| startsExpr
    const braceR = 11264;
    TokenType[TokenType["braceR"] = braceR] = "braceR"; // }
    const braceBarR = 12288;
    TokenType[TokenType["braceBarR"] = braceBarR] = "braceBarR"; // |}
    const parenL = 13824;
    TokenType[TokenType["parenL"] = parenL] = "parenL"; // ( startsExpr
    const parenR = 14336;
    TokenType[TokenType["parenR"] = parenR] = "parenR"; // )
    const comma = 15360;
    TokenType[TokenType["comma"] = comma] = "comma"; // ,
    const semi = 16384;
    TokenType[TokenType["semi"] = semi] = "semi"; // ;
    const colon = 17408;
    TokenType[TokenType["colon"] = colon] = "colon"; // :
    const doubleColon = 18432;
    TokenType[TokenType["doubleColon"] = doubleColon] = "doubleColon"; // ::
    const dot = 19456;
    TokenType[TokenType["dot"] = dot] = "dot"; // .
    const question = 20480;
    TokenType[TokenType["question"] = question] = "question"; // ?
    const questionDot = 21504;
    TokenType[TokenType["questionDot"] = questionDot] = "questionDot"; // ?.
    const arrow = 22528;
    TokenType[TokenType["arrow"] = arrow] = "arrow"; // =>
    const template = 23552;
    TokenType[TokenType["template"] = template] = "template"; // template
    const ellipsis = 24576;
    TokenType[TokenType["ellipsis"] = ellipsis] = "ellipsis"; // ...
    const backQuote = 25600;
    TokenType[TokenType["backQuote"] = backQuote] = "backQuote"; // `
    const dollarBraceL = 27136;
    TokenType[TokenType["dollarBraceL"] = dollarBraceL] = "dollarBraceL"; // ${ startsExpr
    const at = 27648;
    TokenType[TokenType["at"] = at] = "at"; // @
    const hash = 29184;
    TokenType[TokenType["hash"] = hash] = "hash"; // # startsExpr
    const eq = 29728;
    TokenType[TokenType["eq"] = eq] = "eq"; // = isAssign
    const assign = 30752;
    TokenType[TokenType["assign"] = assign] = "assign"; // _= isAssign
    const preIncDec = 32640;
    TokenType[TokenType["preIncDec"] = preIncDec] = "preIncDec"; // ++/-- prefix postfix startsExpr
    const postIncDec = 33664;
    TokenType[TokenType["postIncDec"] = postIncDec] = "postIncDec"; // ++/-- prefix postfix startsExpr
    const bang = 34432;
    TokenType[TokenType["bang"] = bang] = "bang"; // ! prefix startsExpr
    const tilde = 35456;
    TokenType[TokenType["tilde"] = tilde] = "tilde"; // ~ prefix startsExpr
    const pipeline = 35841;
    TokenType[TokenType["pipeline"] = pipeline] = "pipeline"; // |> prec:1
    const nullishCoalescing = 36866;
    TokenType[TokenType["nullishCoalescing"] = nullishCoalescing] = "nullishCoalescing"; // ?? prec:2
    const logicalOR = 37890;
    TokenType[TokenType["logicalOR"] = logicalOR] = "logicalOR"; // || prec:2
    const logicalAND = 38915;
    TokenType[TokenType["logicalAND"] = logicalAND] = "logicalAND"; // && prec:3
    const bitwiseOR = 39940;
    TokenType[TokenType["bitwiseOR"] = bitwiseOR] = "bitwiseOR"; // | prec:4
    const bitwiseXOR = 40965;
    TokenType[TokenType["bitwiseXOR"] = bitwiseXOR] = "bitwiseXOR"; // ^ prec:5
    const bitwiseAND = 41990;
    TokenType[TokenType["bitwiseAND"] = bitwiseAND] = "bitwiseAND"; // & prec:6
    const equality = 43015;
    TokenType[TokenType["equality"] = equality] = "equality"; // ==/!= prec:7
    const lessThan = 44040;
    TokenType[TokenType["lessThan"] = lessThan] = "lessThan"; // < prec:8
    const greaterThan = 45064;
    TokenType[TokenType["greaterThan"] = greaterThan] = "greaterThan"; // > prec:8
    const relationalOrEqual = 46088;
    TokenType[TokenType["relationalOrEqual"] = relationalOrEqual] = "relationalOrEqual"; // <=/>= prec:8
    const bitShiftL = 47113;
    TokenType[TokenType["bitShiftL"] = bitShiftL] = "bitShiftL"; // << prec:9
    const bitShiftR = 48137;
    TokenType[TokenType["bitShiftR"] = bitShiftR] = "bitShiftR"; // >>/>>> prec:9
    const plus = 49802;
    TokenType[TokenType["plus"] = plus] = "plus"; // + prec:10 prefix startsExpr
    const minus = 50826;
    TokenType[TokenType["minus"] = minus] = "minus"; // - prec:10 prefix startsExpr
    const modulo = 51723;
    TokenType[TokenType["modulo"] = modulo] = "modulo"; // % prec:11 startsExpr
    const star = 52235;
    TokenType[TokenType["star"] = star] = "star"; // * prec:11
    const slash = 53259;
    TokenType[TokenType["slash"] = slash] = "slash"; // / prec:11
    const exponent = 54348;
    TokenType[TokenType["exponent"] = exponent] = "exponent"; // ** prec:12 rightAssociative
    const jsxName = 55296;
    TokenType[TokenType["jsxName"] = jsxName] = "jsxName"; // jsxName
    const jsxText = 56320;
    TokenType[TokenType["jsxText"] = jsxText] = "jsxText"; // jsxText
    const jsxEmptyText = 57344;
    TokenType[TokenType["jsxEmptyText"] = jsxEmptyText] = "jsxEmptyText"; // jsxEmptyText
    const jsxTagStart = 58880;
    TokenType[TokenType["jsxTagStart"] = jsxTagStart] = "jsxTagStart"; // jsxTagStart startsExpr
    const jsxTagEnd = 59392;
    TokenType[TokenType["jsxTagEnd"] = jsxTagEnd] = "jsxTagEnd"; // jsxTagEnd
    const typeParameterStart = 60928;
    TokenType[TokenType["typeParameterStart"] = typeParameterStart] = "typeParameterStart"; // typeParameterStart startsExpr
    const nonNullAssertion = 61440;
    TokenType[TokenType["nonNullAssertion"] = nonNullAssertion] = "nonNullAssertion"; // nonNullAssertion
    const _break = 62480;
    TokenType[TokenType["_break"] = _break] = "_break"; // break keyword
    const _case = 63504;
    TokenType[TokenType["_case"] = _case] = "_case"; // case keyword
    const _catch = 64528;
    TokenType[TokenType["_catch"] = _catch] = "_catch"; // catch keyword
    const _continue = 65552;
    TokenType[TokenType["_continue"] = _continue] = "_continue"; // continue keyword
    const _debugger = 66576;
    TokenType[TokenType["_debugger"] = _debugger] = "_debugger"; // debugger keyword
    const _default = 67600;
    TokenType[TokenType["_default"] = _default] = "_default"; // default keyword
    const _do = 68624;
    TokenType[TokenType["_do"] = _do] = "_do"; // do keyword
    const _else = 69648;
    TokenType[TokenType["_else"] = _else] = "_else"; // else keyword
    const _finally = 70672;
    TokenType[TokenType["_finally"] = _finally] = "_finally"; // finally keyword
    const _for = 71696;
    TokenType[TokenType["_for"] = _for] = "_for"; // for keyword
    const _function = 73232;
    TokenType[TokenType["_function"] = _function] = "_function"; // function keyword startsExpr
    const _if = 73744;
    TokenType[TokenType["_if"] = _if] = "_if"; // if keyword
    const _return = 74768;
    TokenType[TokenType["_return"] = _return] = "_return"; // return keyword
    const _switch = 75792;
    TokenType[TokenType["_switch"] = _switch] = "_switch"; // switch keyword
    const _throw = 77456;
    TokenType[TokenType["_throw"] = _throw] = "_throw"; // throw keyword prefix startsExpr
    const _try = 77840;
    TokenType[TokenType["_try"] = _try] = "_try"; // try keyword
    const _var = 78864;
    TokenType[TokenType["_var"] = _var] = "_var"; // var keyword
    const _let = 79888;
    TokenType[TokenType["_let"] = _let] = "_let"; // let keyword
    const _const = 80912;
    TokenType[TokenType["_const"] = _const] = "_const"; // const keyword
    const _while = 81936;
    TokenType[TokenType["_while"] = _while] = "_while"; // while keyword
    const _with = 82960;
    TokenType[TokenType["_with"] = _with] = "_with"; // with keyword
    const _new = 84496;
    TokenType[TokenType["_new"] = _new] = "_new"; // new keyword startsExpr
    const _this = 85520;
    TokenType[TokenType["_this"] = _this] = "_this"; // this keyword startsExpr
    const _super = 86544;
    TokenType[TokenType["_super"] = _super] = "_super"; // super keyword startsExpr
    const _class = 87568;
    TokenType[TokenType["_class"] = _class] = "_class"; // class keyword startsExpr
    const _extends = 88080;
    TokenType[TokenType["_extends"] = _extends] = "_extends"; // extends keyword
    const _export = 89104;
    TokenType[TokenType["_export"] = _export] = "_export"; // export keyword
    const _import = 90640;
    TokenType[TokenType["_import"] = _import] = "_import"; // import keyword startsExpr
    const _yield = 91664;
    TokenType[TokenType["_yield"] = _yield] = "_yield"; // yield keyword startsExpr
    const _null = 92688;
    TokenType[TokenType["_null"] = _null] = "_null"; // null keyword startsExpr
    const _true = 93712;
    TokenType[TokenType["_true"] = _true] = "_true"; // true keyword startsExpr
    const _false = 94736;
    TokenType[TokenType["_false"] = _false] = "_false"; // false keyword startsExpr
    const _in = 95256;
    TokenType[TokenType["_in"] = _in] = "_in"; // in prec:8 keyword
    const _instanceof = 96280;
    TokenType[TokenType["_instanceof"] = _instanceof] = "_instanceof"; // instanceof prec:8 keyword
    const _typeof = 97936;
    TokenType[TokenType["_typeof"] = _typeof] = "_typeof"; // typeof keyword prefix startsExpr
    const _void = 98960;
    TokenType[TokenType["_void"] = _void] = "_void"; // void keyword prefix startsExpr
    const _delete = 99984;
    TokenType[TokenType["_delete"] = _delete] = "_delete"; // delete keyword prefix startsExpr
    const _async = 100880;
    TokenType[TokenType["_async"] = _async] = "_async"; // async keyword startsExpr
    const _get = 101904;
    TokenType[TokenType["_get"] = _get] = "_get"; // get keyword startsExpr
    const _set = 102928;
    TokenType[TokenType["_set"] = _set] = "_set"; // set keyword startsExpr
    const _declare = 103952;
    TokenType[TokenType["_declare"] = _declare] = "_declare"; // declare keyword startsExpr
    const _readonly = 104976;
    TokenType[TokenType["_readonly"] = _readonly] = "_readonly"; // readonly keyword startsExpr
    const _abstract = 106000;
    TokenType[TokenType["_abstract"] = _abstract] = "_abstract"; // abstract keyword startsExpr
    const _static = 107024;
    TokenType[TokenType["_static"] = _static] = "_static"; // static keyword startsExpr
    const _public = 107536;
    TokenType[TokenType["_public"] = _public] = "_public"; // public keyword
    const _private = 108560;
    TokenType[TokenType["_private"] = _private] = "_private"; // private keyword
    const _protected = 109584;
    TokenType[TokenType["_protected"] = _protected] = "_protected"; // protected keyword
    const _override = 110608;
    TokenType[TokenType["_override"] = _override] = "_override"; // override keyword
    const _as = 112144;
    TokenType[TokenType["_as"] = _as] = "_as"; // as keyword startsExpr
    const _enum = 113168;
    TokenType[TokenType["_enum"] = _enum] = "_enum"; // enum keyword startsExpr
    const _type = 114192;
    TokenType[TokenType["_type"] = _type] = "_type"; // type keyword startsExpr
    const _implements = 115216;
    TokenType[TokenType["_implements"] = _implements] = "_implements"; // implements keyword startsExpr
})($f33b9d3e01f21be3$export$f435f793048e7a0f || ($f33b9d3e01f21be3$export$f435f793048e7a0f = {}));
function $f33b9d3e01f21be3$export$b78065ce79336a93(tokenType) {
    switch(tokenType){
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.num:
            return "num";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bigint:
            return "bigint";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.decimal:
            return "decimal";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.regexp:
            return "regexp";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.string:
            return "string";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.name:
            return "name";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.eof:
            return "eof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bracketL:
            return "[";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bracketR:
            return "]";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceL:
            return "{";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceBarL:
            return "{|";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceR:
            return "}";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceBarR:
            return "|}";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.parenL:
            return "(";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.parenR:
            return ")";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.comma:
            return ",";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.semi:
            return ";";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.colon:
            return ":";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.doubleColon:
            return "::";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.dot:
            return ".";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.question:
            return "?";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.questionDot:
            return "?.";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.arrow:
            return "=>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.template:
            return "template";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.ellipsis:
            return "...";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.backQuote:
            return "`";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.dollarBraceL:
            return "${";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.at:
            return "@";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.hash:
            return "#";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.eq:
            return "=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.assign:
            return "_=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.preIncDec:
            return "++/--";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.postIncDec:
            return "++/--";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bang:
            return "!";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.tilde:
            return "~";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.pipeline:
            return "|>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.nullishCoalescing:
            return "??";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.logicalOR:
            return "||";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.logicalAND:
            return "&&";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseOR:
            return "|";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseXOR:
            return "^";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseAND:
            return "&";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.equality:
            return "==/!=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.lessThan:
            return "<";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.greaterThan:
            return ">";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.relationalOrEqual:
            return "<=/>=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitShiftL:
            return "<<";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitShiftR:
            return ">>/>>>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.plus:
            return "+";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.minus:
            return "-";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.modulo:
            return "%";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.star:
            return "*";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.slash:
            return "/";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.exponent:
            return "**";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxName:
            return "jsxName";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxText:
            return "jsxText";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxEmptyText:
            return "jsxEmptyText";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxTagStart:
            return "jsxTagStart";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxTagEnd:
            return "jsxTagEnd";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.typeParameterStart:
            return "typeParameterStart";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.nonNullAssertion:
            return "nonNullAssertion";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._break:
            return "break";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._case:
            return "case";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._catch:
            return "catch";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._continue:
            return "continue";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._debugger:
            return "debugger";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._default:
            return "default";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._do:
            return "do";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._else:
            return "else";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._finally:
            return "finally";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._for:
            return "for";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._function:
            return "function";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._if:
            return "if";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._return:
            return "return";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._switch:
            return "switch";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._throw:
            return "throw";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._try:
            return "try";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._var:
            return "var";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._let:
            return "let";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._const:
            return "const";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._while:
            return "while";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._with:
            return "with";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._new:
            return "new";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._this:
            return "this";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._super:
            return "super";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._class:
            return "class";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._extends:
            return "extends";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._export:
            return "export";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._import:
            return "import";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._yield:
            return "yield";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._null:
            return "null";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._true:
            return "true";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._false:
            return "false";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._in:
            return "in";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._instanceof:
            return "instanceof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._typeof:
            return "typeof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._void:
            return "void";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._delete:
            return "delete";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._async:
            return "async";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._get:
            return "get";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._set:
            return "set";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._declare:
            return "declare";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._readonly:
            return "readonly";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._abstract:
            return "abstract";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._static:
            return "static";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._public:
            return "public";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._private:
            return "private";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._protected:
            return "protected";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._override:
            return "override";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._as:
            return "as";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._enum:
            return "enum";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._type:
            return "type";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._implements:
            return "implements";
        default:
            return "";
    }
}


class $93c505350c167057$export$775b6bb06e53a214 {
    constructor(startTokenIndex, endTokenIndex, isFunctionScope){
        this.startTokenIndex = startTokenIndex;
        this.endTokenIndex = endTokenIndex;
        this.isFunctionScope = isFunctionScope;
    }
}
class $93c505350c167057$export$43b973415d9649ac {
    constructor(potentialArrowAt, noAnonFunctionType, inDisallowConditionalTypesContext, tokensLength, scopesLength, pos, type, contextualKeyword, start, end, isType, scopeDepth, error){
        this.potentialArrowAt = potentialArrowAt;
        this.noAnonFunctionType = noAnonFunctionType;
        this.inDisallowConditionalTypesContext = inDisallowConditionalTypesContext;
        this.tokensLength = tokensLength;
        this.scopesLength = scopesLength;
        this.pos = pos;
        this.type = type;
        this.contextualKeyword = contextualKeyword;
        this.start = start;
        this.end = end;
        this.isType = isType;
        this.scopeDepth = scopeDepth;
        this.error = error;
    }
}
class $93c505350c167057$export$2e2bcd8739ae039 {
    constructor(){
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init5.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init6.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init7.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init8.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init9.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init10.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init11.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init12.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init13.call(this);
    }
    // Used to signify the start of a potential arrow function
    __init() {
        this.potentialArrowAt = -1;
    }
    // Used by Flow to handle an edge case involving function type parsing.
    __init2() {
        this.noAnonFunctionType = false;
    }
    // Used by TypeScript to handle ambiguities when parsing conditional types.
    __init3() {
        this.inDisallowConditionalTypesContext = false;
    }
    // Token store.
    __init4() {
        this.tokens = [];
    }
    // Array of all observed scopes, ordered by their ending position.
    __init5() {
        this.scopes = [];
    }
    // The current position of the tokenizer in the input.
    __init6() {
        this.pos = 0;
    }
    // Information about the current token.
    __init7() {
        this.type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof;
    }
    __init8() {
        this.contextualKeyword = (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc).NONE;
    }
    __init9() {
        this.start = 0;
    }
    __init10() {
        this.end = 0;
    }
    __init11() {
        this.isType = false;
    }
    __init12() {
        this.scopeDepth = 0;
    }
    /**
   * If the parser is in an error state, then the token is always tt.eof and all functions can
   * keep executing but should be written so they don't get into an infinite loop in this situation.
   *
   * This approach, combined with the ability to snapshot and restore state, allows us to implement
   * backtracking without exceptions and without needing to explicitly propagate error states
   * everywhere.
   */ __init13() {
        this.error = null;
    }
    snapshot() {
        return new $93c505350c167057$export$43b973415d9649ac(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
    }
    restoreFromSnapshot(snapshot) {
        this.potentialArrowAt = snapshot.potentialArrowAt;
        this.noAnonFunctionType = snapshot.noAnonFunctionType;
        this.inDisallowConditionalTypesContext = snapshot.inDisallowConditionalTypesContext;
        this.tokens.length = snapshot.tokensLength;
        this.scopes.length = snapshot.scopesLength;
        this.pos = snapshot.pos;
        this.type = snapshot.type;
        this.contextualKeyword = snapshot.contextualKeyword;
        this.start = snapshot.start;
        this.end = snapshot.end;
        this.isType = snapshot.isType;
        this.scopeDepth = snapshot.scopeDepth;
        this.error = snapshot.error;
    }
}


var $bc8ae66faf70da33$export$dbe39bbf2ade60d5;
(function(charCodes) {
    const backSpace = 8;
    charCodes[charCodes["backSpace"] = backSpace] = "backSpace";
    const lineFeed = 10;
    charCodes[charCodes["lineFeed"] = lineFeed] = "lineFeed"; //  '\n'
    const tab = 9;
    charCodes[charCodes["tab"] = tab] = "tab"; //  '\t'
    const carriageReturn = 13;
    charCodes[charCodes["carriageReturn"] = carriageReturn] = "carriageReturn"; //  '\r'
    const shiftOut = 14;
    charCodes[charCodes["shiftOut"] = shiftOut] = "shiftOut";
    const space = 32;
    charCodes[charCodes["space"] = space] = "space";
    const exclamationMark = 33;
    charCodes[charCodes["exclamationMark"] = exclamationMark] = "exclamationMark"; //  '!'
    const quotationMark = 34;
    charCodes[charCodes["quotationMark"] = quotationMark] = "quotationMark"; //  '"'
    const numberSign = 35;
    charCodes[charCodes["numberSign"] = numberSign] = "numberSign"; //  '#'
    const dollarSign = 36;
    charCodes[charCodes["dollarSign"] = dollarSign] = "dollarSign"; //  '$'
    const percentSign = 37;
    charCodes[charCodes["percentSign"] = percentSign] = "percentSign"; //  '%'
    const ampersand = 38;
    charCodes[charCodes["ampersand"] = ampersand] = "ampersand"; //  '&'
    const apostrophe = 39;
    charCodes[charCodes["apostrophe"] = apostrophe] = "apostrophe"; //  '''
    const leftParenthesis = 40;
    charCodes[charCodes["leftParenthesis"] = leftParenthesis] = "leftParenthesis"; //  '('
    const rightParenthesis = 41;
    charCodes[charCodes["rightParenthesis"] = rightParenthesis] = "rightParenthesis"; //  ')'
    const asterisk = 42;
    charCodes[charCodes["asterisk"] = asterisk] = "asterisk"; //  '*'
    const plusSign = 43;
    charCodes[charCodes["plusSign"] = plusSign] = "plusSign"; //  '+'
    const comma = 44;
    charCodes[charCodes["comma"] = comma] = "comma"; //  ','
    const dash = 45;
    charCodes[charCodes["dash"] = dash] = "dash"; //  '-'
    const dot = 46;
    charCodes[charCodes["dot"] = dot] = "dot"; //  '.'
    const slash = 47;
    charCodes[charCodes["slash"] = slash] = "slash"; //  '/'
    const digit0 = 48;
    charCodes[charCodes["digit0"] = digit0] = "digit0"; //  '0'
    const digit1 = 49;
    charCodes[charCodes["digit1"] = digit1] = "digit1"; //  '1'
    const digit2 = 50;
    charCodes[charCodes["digit2"] = digit2] = "digit2"; //  '2'
    const digit3 = 51;
    charCodes[charCodes["digit3"] = digit3] = "digit3"; //  '3'
    const digit4 = 52;
    charCodes[charCodes["digit4"] = digit4] = "digit4"; //  '4'
    const digit5 = 53;
    charCodes[charCodes["digit5"] = digit5] = "digit5"; //  '5'
    const digit6 = 54;
    charCodes[charCodes["digit6"] = digit6] = "digit6"; //  '6'
    const digit7 = 55;
    charCodes[charCodes["digit7"] = digit7] = "digit7"; //  '7'
    const digit8 = 56;
    charCodes[charCodes["digit8"] = digit8] = "digit8"; //  '8'
    const digit9 = 57;
    charCodes[charCodes["digit9"] = digit9] = "digit9"; //  '9'
    const colon = 58;
    charCodes[charCodes["colon"] = colon] = "colon"; //  ':'
    const semicolon = 59;
    charCodes[charCodes["semicolon"] = semicolon] = "semicolon"; //  ';'
    const lessThan = 60;
    charCodes[charCodes["lessThan"] = lessThan] = "lessThan"; //  '<'
    const equalsTo = 61;
    charCodes[charCodes["equalsTo"] = equalsTo] = "equalsTo"; //  '='
    const greaterThan = 62;
    charCodes[charCodes["greaterThan"] = greaterThan] = "greaterThan"; //  '>'
    const questionMark = 63;
    charCodes[charCodes["questionMark"] = questionMark] = "questionMark"; //  '?'
    const atSign = 64;
    charCodes[charCodes["atSign"] = atSign] = "atSign"; //  '@'
    const uppercaseA = 65;
    charCodes[charCodes["uppercaseA"] = uppercaseA] = "uppercaseA"; //  'A'
    const uppercaseB = 66;
    charCodes[charCodes["uppercaseB"] = uppercaseB] = "uppercaseB"; //  'B'
    const uppercaseC = 67;
    charCodes[charCodes["uppercaseC"] = uppercaseC] = "uppercaseC"; //  'C'
    const uppercaseD = 68;
    charCodes[charCodes["uppercaseD"] = uppercaseD] = "uppercaseD"; //  'D'
    const uppercaseE = 69;
    charCodes[charCodes["uppercaseE"] = uppercaseE] = "uppercaseE"; //  'E'
    const uppercaseF = 70;
    charCodes[charCodes["uppercaseF"] = uppercaseF] = "uppercaseF"; //  'F'
    const uppercaseG = 71;
    charCodes[charCodes["uppercaseG"] = uppercaseG] = "uppercaseG"; //  'G'
    const uppercaseH = 72;
    charCodes[charCodes["uppercaseH"] = uppercaseH] = "uppercaseH"; //  'H'
    const uppercaseI = 73;
    charCodes[charCodes["uppercaseI"] = uppercaseI] = "uppercaseI"; //  'I'
    const uppercaseJ = 74;
    charCodes[charCodes["uppercaseJ"] = uppercaseJ] = "uppercaseJ"; //  'J'
    const uppercaseK = 75;
    charCodes[charCodes["uppercaseK"] = uppercaseK] = "uppercaseK"; //  'K'
    const uppercaseL = 76;
    charCodes[charCodes["uppercaseL"] = uppercaseL] = "uppercaseL"; //  'L'
    const uppercaseM = 77;
    charCodes[charCodes["uppercaseM"] = uppercaseM] = "uppercaseM"; //  'M'
    const uppercaseN = 78;
    charCodes[charCodes["uppercaseN"] = uppercaseN] = "uppercaseN"; //  'N'
    const uppercaseO = 79;
    charCodes[charCodes["uppercaseO"] = uppercaseO] = "uppercaseO"; //  'O'
    const uppercaseP = 80;
    charCodes[charCodes["uppercaseP"] = uppercaseP] = "uppercaseP"; //  'P'
    const uppercaseQ = 81;
    charCodes[charCodes["uppercaseQ"] = uppercaseQ] = "uppercaseQ"; //  'Q'
    const uppercaseR = 82;
    charCodes[charCodes["uppercaseR"] = uppercaseR] = "uppercaseR"; //  'R'
    const uppercaseS = 83;
    charCodes[charCodes["uppercaseS"] = uppercaseS] = "uppercaseS"; //  'S'
    const uppercaseT = 84;
    charCodes[charCodes["uppercaseT"] = uppercaseT] = "uppercaseT"; //  'T'
    const uppercaseU = 85;
    charCodes[charCodes["uppercaseU"] = uppercaseU] = "uppercaseU"; //  'U'
    const uppercaseV = 86;
    charCodes[charCodes["uppercaseV"] = uppercaseV] = "uppercaseV"; //  'V'
    const uppercaseW = 87;
    charCodes[charCodes["uppercaseW"] = uppercaseW] = "uppercaseW"; //  'W'
    const uppercaseX = 88;
    charCodes[charCodes["uppercaseX"] = uppercaseX] = "uppercaseX"; //  'X'
    const uppercaseY = 89;
    charCodes[charCodes["uppercaseY"] = uppercaseY] = "uppercaseY"; //  'Y'
    const uppercaseZ = 90;
    charCodes[charCodes["uppercaseZ"] = uppercaseZ] = "uppercaseZ"; //  'Z'
    const leftSquareBracket = 91;
    charCodes[charCodes["leftSquareBracket"] = leftSquareBracket] = "leftSquareBracket"; //  '['
    const backslash = 92;
    charCodes[charCodes["backslash"] = backslash] = "backslash"; //  '\    '
    const rightSquareBracket = 93;
    charCodes[charCodes["rightSquareBracket"] = rightSquareBracket] = "rightSquareBracket"; //  ']'
    const caret = 94;
    charCodes[charCodes["caret"] = caret] = "caret"; //  '^'
    const underscore = 95;
    charCodes[charCodes["underscore"] = underscore] = "underscore"; //  '_'
    const graveAccent = 96;
    charCodes[charCodes["graveAccent"] = graveAccent] = "graveAccent"; //  '`'
    const lowercaseA = 97;
    charCodes[charCodes["lowercaseA"] = lowercaseA] = "lowercaseA"; //  'a'
    const lowercaseB = 98;
    charCodes[charCodes["lowercaseB"] = lowercaseB] = "lowercaseB"; //  'b'
    const lowercaseC = 99;
    charCodes[charCodes["lowercaseC"] = lowercaseC] = "lowercaseC"; //  'c'
    const lowercaseD = 100;
    charCodes[charCodes["lowercaseD"] = lowercaseD] = "lowercaseD"; //  'd'
    const lowercaseE = 101;
    charCodes[charCodes["lowercaseE"] = lowercaseE] = "lowercaseE"; //  'e'
    const lowercaseF = 102;
    charCodes[charCodes["lowercaseF"] = lowercaseF] = "lowercaseF"; //  'f'
    const lowercaseG = 103;
    charCodes[charCodes["lowercaseG"] = lowercaseG] = "lowercaseG"; //  'g'
    const lowercaseH = 104;
    charCodes[charCodes["lowercaseH"] = lowercaseH] = "lowercaseH"; //  'h'
    const lowercaseI = 105;
    charCodes[charCodes["lowercaseI"] = lowercaseI] = "lowercaseI"; //  'i'
    const lowercaseJ = 106;
    charCodes[charCodes["lowercaseJ"] = lowercaseJ] = "lowercaseJ"; //  'j'
    const lowercaseK = 107;
    charCodes[charCodes["lowercaseK"] = lowercaseK] = "lowercaseK"; //  'k'
    const lowercaseL = 108;
    charCodes[charCodes["lowercaseL"] = lowercaseL] = "lowercaseL"; //  'l'
    const lowercaseM = 109;
    charCodes[charCodes["lowercaseM"] = lowercaseM] = "lowercaseM"; //  'm'
    const lowercaseN = 110;
    charCodes[charCodes["lowercaseN"] = lowercaseN] = "lowercaseN"; //  'n'
    const lowercaseO = 111;
    charCodes[charCodes["lowercaseO"] = lowercaseO] = "lowercaseO"; //  'o'
    const lowercaseP = 112;
    charCodes[charCodes["lowercaseP"] = lowercaseP] = "lowercaseP"; //  'p'
    const lowercaseQ = 113;
    charCodes[charCodes["lowercaseQ"] = lowercaseQ] = "lowercaseQ"; //  'q'
    const lowercaseR = 114;
    charCodes[charCodes["lowercaseR"] = lowercaseR] = "lowercaseR"; //  'r'
    const lowercaseS = 115;
    charCodes[charCodes["lowercaseS"] = lowercaseS] = "lowercaseS"; //  's'
    const lowercaseT = 116;
    charCodes[charCodes["lowercaseT"] = lowercaseT] = "lowercaseT"; //  't'
    const lowercaseU = 117;
    charCodes[charCodes["lowercaseU"] = lowercaseU] = "lowercaseU"; //  'u'
    const lowercaseV = 118;
    charCodes[charCodes["lowercaseV"] = lowercaseV] = "lowercaseV"; //  'v'
    const lowercaseW = 119;
    charCodes[charCodes["lowercaseW"] = lowercaseW] = "lowercaseW"; //  'w'
    const lowercaseX = 120;
    charCodes[charCodes["lowercaseX"] = lowercaseX] = "lowercaseX"; //  'x'
    const lowercaseY = 121;
    charCodes[charCodes["lowercaseY"] = lowercaseY] = "lowercaseY"; //  'y'
    const lowercaseZ = 122;
    charCodes[charCodes["lowercaseZ"] = lowercaseZ] = "lowercaseZ"; //  'z'
    const leftCurlyBrace = 123;
    charCodes[charCodes["leftCurlyBrace"] = leftCurlyBrace] = "leftCurlyBrace"; //  '{'
    const verticalBar = 124;
    charCodes[charCodes["verticalBar"] = verticalBar] = "verticalBar"; //  '|'
    const rightCurlyBrace = 125;
    charCodes[charCodes["rightCurlyBrace"] = rightCurlyBrace] = "rightCurlyBrace"; //  '}'
    const tilde = 126;
    charCodes[charCodes["tilde"] = tilde] = "tilde"; //  '~'
    const nonBreakingSpace = 160;
    charCodes[charCodes["nonBreakingSpace"] = nonBreakingSpace] = "nonBreakingSpace";
    // eslint-disable-next-line no-irregular-whitespace
    const oghamSpaceMark = 5760;
    charCodes[charCodes["oghamSpaceMark"] = oghamSpaceMark] = "oghamSpaceMark"; // ' '
    const lineSeparator = 8232;
    charCodes[charCodes["lineSeparator"] = lineSeparator] = "lineSeparator";
    const paragraphSeparator = 8233;
    charCodes[charCodes["paragraphSeparator"] = paragraphSeparator] = "paragraphSeparator";
})($bc8ae66faf70da33$export$dbe39bbf2ade60d5 || ($bc8ae66faf70da33$export$dbe39bbf2ade60d5 = {}));
function $bc8ae66faf70da33$export$727d9dbc4fbb948f(code) {
    return code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.digit0 && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.digit9 || code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.lowercaseA && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.lowercaseF || code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.uppercaseA && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.uppercaseF;
}


let $e406deb3d43fd58b$export$43bb667a94af025a;
let $e406deb3d43fd58b$export$757c2735689d2de8;
let $e406deb3d43fd58b$export$92e334f8fe49aa94;
let $e406deb3d43fd58b$export$ca000e230c0caa3e;
let $e406deb3d43fd58b$export$b7e3ae3d7c15e42e;
let $e406deb3d43fd58b$export$d854af1c30ac0f3a;
function $e406deb3d43fd58b$export$d0c215ddd78b3d24() {
    return $e406deb3d43fd58b$export$d854af1c30ac0f3a++;
}
function $e406deb3d43fd58b$export$2ca6ff5cad32970a(error) {
    if ("pos" in error) {
        const loc = $e406deb3d43fd58b$export$66bfa486b735c2f7(error.pos);
        error.message += ` (${loc.line}:${loc.column})`;
        error.loc = loc;
    }
    return error;
}
class $e406deb3d43fd58b$export$f564f979629709cc {
    constructor(line, column){
        this.line = line;
        this.column = column;
    }
}
function $e406deb3d43fd58b$export$66bfa486b735c2f7(pos) {
    let line = 1;
    let column = 1;
    for(let i = 0; i < pos; i++)if ($e406deb3d43fd58b$export$b7e3ae3d7c15e42e.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) {
        line++;
        column = 1;
    } else column++;
    return new $e406deb3d43fd58b$export$f564f979629709cc(line, column);
}
function $e406deb3d43fd58b$export$84bb9899435eeb61(inputCode, isJSXEnabledArg, isTypeScriptEnabledArg, isFlowEnabledArg) {
    $e406deb3d43fd58b$export$b7e3ae3d7c15e42e = inputCode;
    $e406deb3d43fd58b$export$ca000e230c0caa3e = new (0, $93c505350c167057$export$2e2bcd8739ae039)();
    $e406deb3d43fd58b$export$d854af1c30ac0f3a = 1;
    $e406deb3d43fd58b$export$43bb667a94af025a = isJSXEnabledArg;
    $e406deb3d43fd58b$export$757c2735689d2de8 = isTypeScriptEnabledArg;
    $e406deb3d43fd58b$export$92e334f8fe49aa94 = isFlowEnabledArg;
}






function $485552d236f25875$export$d382681f238736f1(contextualKeyword) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword;
}
function $485552d236f25875$export$d1b5391c35999eba(contextualKeyword) {
    const l = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
    return l.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && l.contextualKeyword === contextualKeyword;
}
function $485552d236f25875$export$b8f8f7fffeb6fb36(contextualKeyword) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $485552d236f25875$export$b8ead11dfed96f19(contextualKeyword) {
    if (!$485552d236f25875$export$b8f8f7fffeb6fb36(contextualKeyword)) $485552d236f25875$export$4c195bc1a97b6f7f();
}
function $485552d236f25875$export$1c0919cee6560c3() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || $485552d236f25875$export$942fa35f3a7c108c();
}
function $485552d236f25875$export$942fa35f3a7c108c() {
    const prevToken = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
    const lastTokEnd = prevToken ? prevToken.end : 0;
    for(let i = lastTokEnd; i < (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start; i++){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $485552d236f25875$export$a4f1ee8cbd9b31ba() {
    const nextStart = (0, $19e70491d10f11e8$export$1678d89ce52f4a6)();
    for(let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end; i < nextStart; i++){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $485552d236f25875$export$12d132b6e81066e4() {
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) || $485552d236f25875$export$1c0919cee6560c3();
}
function $485552d236f25875$export$62fa27d385e555f3() {
    if (!$485552d236f25875$export$12d132b6e81066e4()) $485552d236f25875$export$4c195bc1a97b6f7f('Unexpected token, expected ";"');
}
function $485552d236f25875$export$3570f33b1a1f3329(type) {
    const matched = (0, $19e70491d10f11e8$export$3106cdec37e36f77)(type);
    if (!matched) $485552d236f25875$export$4c195bc1a97b6f7f(`Unexpected token, expected "${(0, $f33b9d3e01f21be3$export$b78065ce79336a93)(type)}"`);
}
function $485552d236f25875$export$4c195bc1a97b6f7f(message = "Unexpected token", pos = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = new SyntaxError(message);
    err.pos = pos;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error = err;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length;
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
}





const $9f5f7917291107a0$export$518c7e3eadd435e0 = [
    0x0009,
    0x000b,
    0x000c,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).space,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).nonBreakingSpace,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).oghamSpaceMark,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2007,
    0x2008,
    0x2009,
    0x200a,
    0x202f,
    0x205f,
    0x3000,
    0xfeff
];
const $9f5f7917291107a0$export$4856bde7911f0623 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
const $9f5f7917291107a0$export$4347b22d2e0ca480 = new Uint8Array(65536);
for (const char of $9f5f7917291107a0$export$518c7e3eadd435e0)$9f5f7917291107a0$export$4347b22d2e0ca480[char] = 1;


function $231ac6b14e19c571$var$computeIsIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code < 128) return false;
    throw new Error("Should not be called with non-ASCII char code.");
}
const $231ac6b14e19c571$export$d19df39e3926cfef = new Uint8Array(65536);
for(let i = 0; i < 128; i++)$231ac6b14e19c571$export$d19df39e3926cfef[i] = $231ac6b14e19c571$var$computeIsIdentifierChar(i) ? 1 : 0;
for(let i = 128; i < 65536; i++)$231ac6b14e19c571$export$d19df39e3926cfef[i] = 1;
// Aside from whitespace and newlines, all characters outside the ASCII space are either
// identifier characters or invalid. Since we're not performing code validation, we can just
// treat all invalid characters as identifier characters.
for (const whitespaceChar of (0, $9f5f7917291107a0$export$518c7e3eadd435e0))$231ac6b14e19c571$export$d19df39e3926cfef[whitespaceChar] = 0;
$231ac6b14e19c571$export$d19df39e3926cfef[0x2028] = 0;
$231ac6b14e19c571$export$d19df39e3926cfef[0x2029] = 0;
const $231ac6b14e19c571$export$dc1d1d7d9fdffb8 = $231ac6b14e19c571$export$d19df39e3926cfef.slice();
for(let numChar = (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0; numChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9; numChar++)$231ac6b14e19c571$export$dc1d1d7d9fdffb8[numChar] = 0;








// Generated file, do not edit! Run "yarn generate" to re-generate this file.


const $9136c7bb1d2831a5$export$cb39af7c41e25635 = new Int32Array([
    // ""
    -1,
    27,
    783,
    918,
    1755,
    2376,
    2862,
    3483,
    -1,
    3699,
    -1,
    4617,
    4752,
    4833,
    5130,
    5508,
    5940,
    -1,
    6480,
    6939,
    7749,
    8181,
    8451,
    8613,
    -1,
    8829,
    -1,
    // "a"
    -1,
    -1,
    54,
    243,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    432,
    -1,
    -1,
    -1,
    675,
    -1,
    -1,
    -1,
    // "ab"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    81,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abs"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    108,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abst"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    135,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstr"
    -1,
    162,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstra"
    -1,
    -1,
    -1,
    189,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstrac"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    216,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstract"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ac"
    -1,
    -1,
    -1,
    270,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acc"
    -1,
    -1,
    -1,
    -1,
    -1,
    297,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acce"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    324,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acces"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    351,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "access"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    378,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accesso"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    405,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accessor"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._accessor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "as"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    459,
    -1,
    -1,
    -1,
    -1,
    -1,
    594,
    -1,
    // "ass"
    -1,
    -1,
    -1,
    -1,
    -1,
    486,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asse"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    513,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asser"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    540,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "assert"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    567,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asserts"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._asserts << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    621,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asyn"
    -1,
    -1,
    -1,
    648,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "async"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "aw"
    -1,
    702,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    729,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awai"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    756,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "await"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "b"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    810,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "br"
    -1,
    -1,
    -1,
    -1,
    -1,
    837,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "bre"
    -1,
    864,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "brea"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    891,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "break"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._break << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "c"
    -1,
    945,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1107,
    -1,
    -1,
    -1,
    1242,
    -1,
    -1,
    1350,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ca"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    972,
    1026,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cas"
    -1,
    -1,
    -1,
    -1,
    -1,
    999,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "case"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cat"
    -1,
    -1,
    -1,
    1053,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1080,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catch"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ch"
    -1,
    -1,
    -1,
    -1,
    -1,
    1134,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "che"
    -1,
    -1,
    -1,
    1161,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "chec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1188,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "check"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1215,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "checks"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._checks << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cl"
    -1,
    1269,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1296,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "clas"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1323,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "class"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "co"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1377,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "con"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1404,
    1620,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cons"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1431,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "const"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1458,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1485,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constru"
    -1,
    -1,
    -1,
    1512,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1539,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1566,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1593,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructor"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cont"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1647,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "conti"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1674,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "contin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1701,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continu"
    -1,
    -1,
    -1,
    -1,
    -1,
    1728,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continue"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._continue << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "d"
    -1,
    -1,
    -1,
    -1,
    -1,
    1782,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2349,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "de"
    -1,
    -1,
    1809,
    1971,
    -1,
    -1,
    2106,
    -1,
    -1,
    -1,
    -1,
    -1,
    2241,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "deb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1836,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1863,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debug"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1890,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugg"
    -1,
    -1,
    -1,
    -1,
    -1,
    1917,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1944,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugger"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._debugger << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1998,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decl"
    -1,
    2025,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2052,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declar"
    -1,
    -1,
    -1,
    -1,
    -1,
    2079,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declare"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "def"
    -1,
    2133,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2160,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defau"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2187,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defaul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2214,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "default"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "del"
    -1,
    -1,
    -1,
    -1,
    -1,
    2268,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dele"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2295,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delet"
    -1,
    -1,
    -1,
    -1,
    -1,
    2322,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delete"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "do"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "e"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2403,
    -1,
    2484,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2565,
    -1,
    -1,
    // "el"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2430,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "els"
    -1,
    -1,
    -1,
    -1,
    -1,
    2457,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "else"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._else << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "en"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2511,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2538,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enum"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ex"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2592,
    -1,
    -1,
    -1,
    2727,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2619,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2646,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2673,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "export"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2700,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exports"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._exports << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ext"
    -1,
    -1,
    -1,
    -1,
    -1,
    2754,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2781,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exten"
    -1,
    -1,
    -1,
    -1,
    2808,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extend"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2835,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extends"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "f"
    -1,
    2889,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2997,
    -1,
    -1,
    -1,
    -1,
    -1,
    3159,
    -1,
    -1,
    3213,
    -1,
    -1,
    3294,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2916,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fal"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2943,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fals"
    -1,
    -1,
    -1,
    -1,
    -1,
    2970,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "false"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3024,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fin"
    -1,
    3051,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fina"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3078,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "final"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3105,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "finall"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3132,
    -1,
    // "finally"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._finally << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3186,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "for"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._for << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3240,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3267,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "from"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3321,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fun"
    -1,
    -1,
    -1,
    3348,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "func"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3375,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "funct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3402,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3429,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functio"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3456,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "function"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "g"
    -1,
    -1,
    -1,
    -1,
    -1,
    3510,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3564,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3537,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "get"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "gl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3591,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glo"
    -1,
    -1,
    3618,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glob"
    -1,
    3645,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "globa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3672,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "global"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "i"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3726,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3753,
    4077,
    -1,
    -1,
    -1,
    -1,
    4590,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "if"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._if << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "im"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3780,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3807,
    -1,
    -1,
    3996,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impl"
    -1,
    -1,
    -1,
    -1,
    -1,
    3834,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imple"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3861,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implem"
    -1,
    -1,
    -1,
    -1,
    -1,
    3888,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impleme"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3915,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implemen"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3942,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implement"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3969,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implements"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4023,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4050,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "import"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "in"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4104,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4185,
    4401,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inf"
    -1,
    -1,
    -1,
    -1,
    -1,
    4131,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4158,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infer"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ins"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4212,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inst"
    -1,
    4239,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "insta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4266,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instan"
    -1,
    -1,
    -1,
    4293,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanc"
    -1,
    -1,
    -1,
    -1,
    -1,
    4320,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instance"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4347,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4374,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceof"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._instanceof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "int"
    -1,
    -1,
    -1,
    -1,
    -1,
    4428,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4455,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inter"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4482,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interf"
    -1,
    4509,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfa"
    -1,
    -1,
    -1,
    4536,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfac"
    -1,
    -1,
    -1,
    -1,
    -1,
    4563,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interface"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "is"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "k"
    -1,
    -1,
    -1,
    -1,
    -1,
    4644,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ke"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4671,
    -1,
    // "key"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4698,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4725,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyof"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._keyof << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "l"
    -1,
    -1,
    -1,
    -1,
    -1,
    4779,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "le"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4806,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "let"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "m"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4860,
    -1,
    -1,
    -1,
    -1,
    -1,
    4995,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4887,
    -1,
    -1,
    // "mix"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4914,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4941,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4968,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixins"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._mixins << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mo"
    -1,
    -1,
    -1,
    -1,
    5022,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mod"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5049,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5076,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modul"
    -1,
    -1,
    -1,
    -1,
    -1,
    5103,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "module"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "n"
    -1,
    5157,
    -1,
    -1,
    -1,
    5373,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5427,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "na"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5184,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nam"
    -1,
    -1,
    -1,
    -1,
    -1,
    5211,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "name"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5238,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "names"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5265,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namesp"
    -1,
    5292,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespa"
    -1,
    -1,
    -1,
    5319,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespac"
    -1,
    -1,
    -1,
    -1,
    -1,
    5346,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespace"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ne"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5400,
    -1,
    -1,
    -1,
    // "new"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5454,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5481,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "null"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "o"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5535,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5562,
    -1,
    -1,
    -1,
    -1,
    5697,
    5751,
    -1,
    -1,
    -1,
    -1,
    // "of"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "op"
    -1,
    5589,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5616,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5643,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    5670,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaque"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ou"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5724,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "out"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._out << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ov"
    -1,
    -1,
    -1,
    -1,
    -1,
    5778,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ove"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5805,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "over"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5832,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5859,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overri"
    -1,
    -1,
    -1,
    -1,
    5886,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overrid"
    -1,
    -1,
    -1,
    -1,
    -1,
    5913,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "override"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "p"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5967,
    -1,
    -1,
    6345,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5994,
    -1,
    -1,
    -1,
    -1,
    -1,
    6129,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pri"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6021,
    -1,
    -1,
    -1,
    -1,
    // "priv"
    -1,
    6048,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "priva"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6075,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "privat"
    -1,
    -1,
    -1,
    -1,
    -1,
    6102,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "private"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6156,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prot"
    -1,
    -1,
    -1,
    -1,
    -1,
    6183,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6318,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prote"
    -1,
    -1,
    -1,
    6210,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6237,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protect"
    -1,
    -1,
    -1,
    -1,
    -1,
    6264,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protecte"
    -1,
    -1,
    -1,
    -1,
    6291,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protected"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "proto"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._proto << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pu"
    -1,
    -1,
    6372,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pub"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6399,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6426,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publi"
    -1,
    -1,
    -1,
    6453,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "public"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "r"
    -1,
    -1,
    -1,
    -1,
    -1,
    6507,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "re"
    -1,
    6534,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6696,
    -1,
    -1,
    6831,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "rea"
    -1,
    -1,
    -1,
    -1,
    6561,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "read"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6588,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "reado"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6615,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readon"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6642,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readonl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6669,
    -1,
    // "readonly"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "req"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6723,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6750,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6777,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requir"
    -1,
    -1,
    -1,
    -1,
    -1,
    6804,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "require"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ret"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6858,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6885,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retur"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6912,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "return"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._return << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "s"
    -1,
    6966,
    -1,
    -1,
    -1,
    7182,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7236,
    7371,
    -1,
    7479,
    -1,
    7614,
    -1,
    // "sa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6993,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7020,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sati"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7047,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satis"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7074,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisf"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7101,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfi"
    -1,
    -1,
    -1,
    -1,
    -1,
    7128,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7155,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfies"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._satisfies << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "se"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7209,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "set"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "st"
    -1,
    7263,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7290,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7317,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stati"
    -1,
    -1,
    -1,
    7344,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "static"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "su"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7398,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sup"
    -1,
    -1,
    -1,
    -1,
    -1,
    7425,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "supe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7452,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "super"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sw"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7506,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7533,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swit"
    -1,
    -1,
    -1,
    7560,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7587,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switch"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._switch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7641,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sym"
    -1,
    -1,
    7668,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7695,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7722,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbol"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._symbol << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "t"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7776,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7938,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8046,
    -1,
    // "th"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7803,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7857,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7830,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "this"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7884,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7911,
    -1,
    -1,
    -1,
    // "throw"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._throw << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "tr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7965,
    -1,
    -1,
    -1,
    8019,
    -1,
    // "tru"
    -1,
    -1,
    -1,
    -1,
    -1,
    7992,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "true"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "try"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._try << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ty"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8073,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typ"
    -1,
    -1,
    -1,
    -1,
    -1,
    8100,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "type"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8127,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8154,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeof"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "u"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8208,
    -1,
    -1,
    -1,
    -1,
    8343,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "un"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8235,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uni"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8262,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8289,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    8316,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "unique"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._unique << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "us"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8370,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8397,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8424,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "using"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "v"
    -1,
    8478,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8532,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "va"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8505,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "var"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "vo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8559,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "voi"
    -1,
    -1,
    -1,
    -1,
    8586,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "void"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "w"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8640,
    8748,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wh"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8667,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8694,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whil"
    -1,
    -1,
    -1,
    -1,
    -1,
    8721,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "while"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8775,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wit"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8802,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "with"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "y"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8856,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yi"
    -1,
    -1,
    -1,
    -1,
    -1,
    8883,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8910,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yiel"
    -1,
    -1,
    -1,
    -1,
    8937,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yield"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
]);



function $8d883a7764d8b084$export$2e2bcd8739ae039() {
    let treePos = 0;
    let code = 0;
    let pos = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if (code < (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA || code > (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ) break;
        const next = (0, $9136c7bb1d2831a5$export$cb39af7c41e25635)[treePos + (code - (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA) + 1];
        if (next === -1) break;
        else {
            treePos = next;
            pos++;
        }
    }
    const keywordValue = (0, $9136c7bb1d2831a5$export$cb39af7c41e25635)[treePos];
    if (keywordValue > -1 && !(0, $231ac6b14e19c571$export$d19df39e3926cfef)[code]) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = pos;
        if (keywordValue & 1) (0, $19e70491d10f11e8$export$58122cd1933ef607)(keywordValue >>> 1);
        else (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, keywordValue >>> 1);
        return;
    }
    while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch]) pos++;
        else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) {
            // \u
            pos += 2;
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace)pos++;
                pos++;
            }
        } else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign) pos += 2;
        else break;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = pos;
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}



var $19e70491d10f11e8$export$99f888ada3c99de3;
(function(IdentifierRole) {
    const Access = 0;
    IdentifierRole[IdentifierRole["Access"] = Access] = "Access";
    const ExportAccess = Access + 1;
    IdentifierRole[IdentifierRole["ExportAccess"] = ExportAccess] = "ExportAccess";
    const TopLevelDeclaration = ExportAccess + 1;
    IdentifierRole[IdentifierRole["TopLevelDeclaration"] = TopLevelDeclaration] = "TopLevelDeclaration";
    const FunctionScopedDeclaration = TopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["FunctionScopedDeclaration"] = FunctionScopedDeclaration] = "FunctionScopedDeclaration";
    const BlockScopedDeclaration = FunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["BlockScopedDeclaration"] = BlockScopedDeclaration] = "BlockScopedDeclaration";
    const ObjectShorthandTopLevelDeclaration = BlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandTopLevelDeclaration"] = ObjectShorthandTopLevelDeclaration] = "ObjectShorthandTopLevelDeclaration";
    const ObjectShorthandFunctionScopedDeclaration = ObjectShorthandTopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandFunctionScopedDeclaration"] = ObjectShorthandFunctionScopedDeclaration] = "ObjectShorthandFunctionScopedDeclaration";
    const ObjectShorthandBlockScopedDeclaration = ObjectShorthandFunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandBlockScopedDeclaration"] = ObjectShorthandBlockScopedDeclaration] = "ObjectShorthandBlockScopedDeclaration";
    const ObjectShorthand = ObjectShorthandBlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthand"] = ObjectShorthand] = "ObjectShorthand";
    // Any identifier bound in an import statement, e.g. both A and b from
    // `import A, * as b from 'A';`
    const ImportDeclaration = ObjectShorthand + 1;
    IdentifierRole[IdentifierRole["ImportDeclaration"] = ImportDeclaration] = "ImportDeclaration";
    const ObjectKey = ImportDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectKey"] = ObjectKey] = "ObjectKey";
    // The `foo` in `import {foo as bar} from "./abc";`.
    const ImportAccess = ObjectKey + 1;
    IdentifierRole[IdentifierRole["ImportAccess"] = ImportAccess] = "ImportAccess";
})($19e70491d10f11e8$export$99f888ada3c99de3 || ($19e70491d10f11e8$export$99f888ada3c99de3 = {}));
var $19e70491d10f11e8$export$4620c92ad8b511d9;
(function(JSXRole) {
    // The element is self-closing or has a body that resolves to empty. We
    // shouldn't emit children at all in this case.
    const NoChildren = 0;
    JSXRole[JSXRole["NoChildren"] = NoChildren] = "NoChildren";
    // The element has a single explicit child, which might still be an arbitrary
    // expression like an array. We should emit that expression as the children.
    const OneChild = NoChildren + 1;
    JSXRole[JSXRole["OneChild"] = OneChild] = "OneChild";
    // The element has at least two explicitly-specified children or has spread
    // children, so child positions are assumed to be "static". We should wrap
    // these children in an array.
    const StaticChildren = OneChild + 1;
    JSXRole[JSXRole["StaticChildren"] = StaticChildren] = "StaticChildren";
    // The element has a prop named "key" after a prop spread, so we should fall
    // back to the createElement function.
    const KeyAfterPropSpread = StaticChildren + 1;
    JSXRole[JSXRole["KeyAfterPropSpread"] = KeyAfterPropSpread] = "KeyAfterPropSpread";
})($19e70491d10f11e8$export$4620c92ad8b511d9 || ($19e70491d10f11e8$export$4620c92ad8b511d9 = {}));
function $19e70491d10f11e8$export$31dc9881735f7118(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$268f8ae8b035d918(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$c08b4dec8c3c03d(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ImportDeclaration;
}
function $19e70491d10f11e8$export$6aae06a56367d123(token) {
    const role = token.identifierRole;
    // Treat top-level declarations as block scope since the distinction doesn't matter here.
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$157aa1605fc4e080(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
function $19e70491d10f11e8$export$dea1d79574e9c731(token) {
    return token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration || token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
class $19e70491d10f11e8$export$50792b0e93539fde {
    constructor(){
        this.type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
        this.contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
        this.start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
        this.end = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end;
        this.scopeDepth = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth;
        this.isType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
        this.identifierRole = null;
        this.jsxRole = null;
        this.shadowsGlobal = false;
        this.isAsyncOperation = false;
        this.contextId = null;
        this.rhsEndIndex = null;
        this.isExpression = false;
        this.numNullishCoalesceStarts = 0;
        this.numNullishCoalesceEnds = 0;
        this.isOptionalChainStart = false;
        this.isOptionalChainEnd = false;
        this.subscriptStartIndex = null;
        this.nullishStartIndex = null;
    }
}
function $19e70491d10f11e8$export$48cfd1e771a65c4f() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new $19e70491d10f11e8$export$50792b0e93539fde());
    $19e70491d10f11e8$export$be17f8ab6696df13();
}
function $19e70491d10f11e8$export$e4355ff2fab571ee() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new $19e70491d10f11e8$export$50792b0e93539fde());
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $19e70491d10f11e8$var$readTmplToken();
}
function $19e70491d10f11e8$export$f6864f1ed2347988() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign) --(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $19e70491d10f11e8$var$readRegexp();
}
function $19e70491d10f11e8$export$218282073d8f0a8b(existingTokensInType) {
    for(let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - existingTokensInType; i < (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length; i++)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
    const oldIsType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = true;
    return oldIsType;
}
function $19e70491d10f11e8$export$89977347ddb984a8(oldIsType) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = oldIsType;
}
function $19e70491d10f11e8$export$3106cdec37e36f77(type) {
    if ($19e70491d10f11e8$export$4659b591c19bdf3d(type)) {
        $19e70491d10f11e8$export$48cfd1e771a65c4f();
        return true;
    } else return false;
}
function $19e70491d10f11e8$export$cb3e65614411a57c(tokenType) {
    const oldIsType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = true;
    $19e70491d10f11e8$export$3106cdec37e36f77(tokenType);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = oldIsType;
}
function $19e70491d10f11e8$export$4659b591c19bdf3d(type) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === type;
}
function $19e70491d10f11e8$export$d2a09c60d66edd78() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $19e70491d10f11e8$export$48cfd1e771a65c4f();
    const type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return type;
}
class $19e70491d10f11e8$export$1df511c75b9e0d8b {
    constructor(type, contextualKeyword){
        this.type = type;
        this.contextualKeyword = contextualKeyword;
    }
}
function $19e70491d10f11e8$export$ef1b94c514fc060a() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $19e70491d10f11e8$export$48cfd1e771a65c4f();
    const type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return new $19e70491d10f11e8$export$1df511c75b9e0d8b(type, contextualKeyword);
}
function $19e70491d10f11e8$export$1678d89ce52f4a6() {
    return $19e70491d10f11e8$export$b8d8ba48247ea123((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$export$b8d8ba48247ea123(pos) {
    (0, $9f5f7917291107a0$export$4856bde7911f0623).lastIndex = pos;
    const skip = (0, $9f5f7917291107a0$export$4856bde7911f0623).exec((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e));
    return pos + skip[0].length;
}
function $19e70491d10f11e8$export$847169391b2516b8() {
    return (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt($19e70491d10f11e8$export$1678d89ce52f4a6());
}
function $19e70491d10f11e8$export$be17f8ab6696df13() {
    $19e70491d10f11e8$export$b240c79c2d18160();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
        const tokens = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens;
        // We normally run past the end a bit, but if we're way past the end, avoid an infinite loop.
        // Also check the token positions rather than the types since sometimes we rewrite the token
        // type to something else.
        if (tokens.length >= 2 && tokens[tokens.length - 1].start >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && tokens[tokens.length - 2].start >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
        return;
    }
    $19e70491d10f11e8$var$readToken((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos));
}
function $19e70491d10f11e8$var$readToken(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code] || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign) (0, $8d883a7764d8b084$export$2e2bcd8739ae039)();
    else $19e70491d10f11e8$export$e0ebb9fd4c2c4701(code);
}
function $19e70491d10f11e8$var$skipBlockComment() {
    while((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk || (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash){
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos > (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated comment", (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos - 2);
            return;
        }
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
}
function $19e70491d10f11e8$export$37e131e7c1112aff(startSkip) {
    let ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += startSkip);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) while(ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineSeparator && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).paragraphSeparator && ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length)ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$export$b240c79c2d18160() {
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        switch(ch){
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn:
                if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed:
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineSeparator:
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).paragraphSeparator:
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                switch((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1)){
                    case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk:
                        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
                        $19e70491d10f11e8$var$skipBlockComment();
                        break;
                    case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                        $19e70491d10f11e8$export$37e131e7c1112aff(2);
                        break;
                    default:
                        return;
                }
                break;
            default:
                if ((0, $9f5f7917291107a0$export$4347b22d2e0ca480)[ch]) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                else return;
        }
    }
}
function $19e70491d10f11e8$export$58122cd1933ef607(type, contextualKeyword = (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc).NONE) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = type;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword = contextualKeyword;
}
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
function $19e70491d10f11e8$var$readToken_dot() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && nextChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9) {
        $19e70491d10f11e8$var$readNumber(true);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 3;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
    } else {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
    }
}
function $19e70491d10f11e8$var$readToken_slash() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, 1);
}
function $19e70491d10f11e8$var$readToken_mult_modulo(code) {
    // '%*'
    let tokenType = code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo;
    let width = 1;
    let nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    // Exponentiation operator **
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk && nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk) {
        width++;
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2);
        tokenType = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).exponent;
    }
    // Match *= or %=, disallowing *=> which can be valid in flow.
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        width++;
        tokenType = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign;
    }
    $19e70491d10f11e8$var$finishOp(tokenType, width);
}
function $19e70491d10f11e8$var$readToken_pipe_amp(code) {
    // '|&'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // ||= or &&=
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
        else // || or &&
        $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).logicalOR : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).logicalAND, 2);
        return;
    }
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar) {
        // '|>'
        if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).pipeline, 2);
            return;
        } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace && (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) {
            // '|}'
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR, 2);
            return;
        }
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
        return;
    }
    $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND, 1);
}
function $19e70491d10f11e8$var$readToken_caret() {
    // '^'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseXOR, 1);
}
function $19e70491d10f11e8$var$readToken_plus_min(code) {
    // '+-'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        // Tentatively call this a prefix operator, but it might be changed to postfix later.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec, 2);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus, 1);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus, 1);
}
function $19e70491d10f11e8$var$readToken_lt() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan) {
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
            return;
        }
        // We see <<, but need to be really careful about whether to treat it as a
        // true left-shift or as two < tokens.
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType) // Within a type, << might come up in a snippet like `Array<<T>() => void>`,
        // so treat it as two < tokens. Importantly, this should only override <<
        // rather than other tokens like <= . If we treated <= as < in a type
        // context, then the snippet `a as T <= 1` would incorrectly start parsing
        // a type argument on T. We don't need to worry about `a as T << 1`
        // because TypeScript disallows that syntax.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan, 1);
        else // Outside a type, this might be a true left-shift operator, or it might
        // still be two open-type-arg tokens, such as in `f<<T>() => void>()`. We
        // look at the token while considering the `f`, so we don't yet know that
        // we're in a type context. In this case, we initially tokenize as a
        // left-shift and correct after-the-fact as necessary in
        // tsParseTypeArgumentsWithPossibleBitshift .
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL, 2);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // <=
    $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan, 1);
}
function $19e70491d10f11e8$var$readToken_gt() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType) {
        // Avoid right-shift for things like `Array<Array<string>>` and
        // greater-than-or-equal for things like `const a: Array<number>=[];`.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, 1);
        return;
    }
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        const size = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan ? 3 : 2;
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + size) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, size + 1);
            return;
        }
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftR, size);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // >=
    $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, 1);
}
function $19e70491d10f11e8$export$4d00b4f4d9d7a9b3() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos -= 1;
        $19e70491d10f11e8$var$readToken_gt();
    }
}
function $19e70491d10f11e8$var$readToken_eq_excl(code) {
    // '=!'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).equality, (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo ? 3 : 2);
        return;
    }
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo && nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        // '=>'
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
        return;
    }
    $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang, 1);
}
function $19e70491d10f11e8$var$readToken_question() {
    // '?'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    const nextChar2 = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).questionMark && // In Flow (but not TypeScript), ??string is a valid type that should be
    // tokenized as two individual ? tokens.
    !((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType)) {
        if (nextChar2 === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // '??='
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
        else // '??'
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing, 2);
    } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot && !(nextChar2 >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && nextChar2 <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9)) {
        // '.' not followed by a number
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
    } else {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    }
}
function $19e70491d10f11e8$export$e0ebb9fd4c2c4701(code) {
    switch(code){
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).numberSign:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash);
            return;
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot:
            $19e70491d10f11e8$var$readToken_dot();
            return;
        // Punctuation tokens.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftParenthesis:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightParenthesis:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).semicolon:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).comma:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftSquareBracket:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightSquareBracket:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace:
            if ((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL, 2);
            else {
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
            }
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon:
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon, 2);
            else {
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
            }
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).questionMark:
            $19e70491d10f11e8$var$readToken_question();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).graveAccent:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0:
            {
                const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
                // '0x', '0X', '0o', '0O', '0b', '0B'
                if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseX || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseX || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseO || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseO || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseB || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseB) {
                    $19e70491d10f11e8$var$readRadixNumber();
                    return;
                }
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit1:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit2:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit3:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit4:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit5:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit6:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit7:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit8:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9:
            $19e70491d10f11e8$var$readNumber(false);
            return;
        // Quotes produce strings.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe:
            $19e70491d10f11e8$var$readString(code);
            return;
        // Operators are parsed inline in tiny state machines. '=' (charCodes.equalsTo) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
            $19e70491d10f11e8$var$readToken_slash();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).percentSign:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk:
            $19e70491d10f11e8$var$readToken_mult_modulo(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).ampersand:
            $19e70491d10f11e8$var$readToken_pipe_amp(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).caret:
            $19e70491d10f11e8$var$readToken_caret();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash:
            $19e70491d10f11e8$var$readToken_plus_min(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan:
            $19e70491d10f11e8$var$readToken_lt();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan:
            $19e70491d10f11e8$var$readToken_gt();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).exclamationMark:
            $19e70491d10f11e8$var$readToken_eq_excl(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).tilde:
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).tilde, 1);
            return;
        default:
            break;
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)(`Unexpected character '${String.fromCharCode(code)}'`, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$var$finishOp(type, size) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += size;
    $19e70491d10f11e8$export$58122cd1933ef607(type);
}
function $19e70491d10f11e8$var$readRegexp() {
    const start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    let escaped = false;
    let inClass = false;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated regular expression", start);
            return;
        }
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (escaped) escaped = false;
        else {
            if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftSquareBracket) inClass = true;
            else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightSquareBracket && inClass) inClass = false;
            else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash && !inClass) break;
            escaped = code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash;
        }
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    }
    ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    // Need to use `skipWord` because '\uXXXX' sequences are allowed here (don't ask).
    $19e70491d10f11e8$export$abcfffe72e6e8184();
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).regexp);
}
/**
 * Read a decimal integer. Note that this can't be unified with the similar code
 * in readRadixNumber (which also handles hex digits) because "e" needs to be
 * the end of the integer so that we can properly handle scientific notation.
 */ function $19e70491d10f11e8$var$readInt() {
    while(true){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).underscore) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else break;
    }
}
function $19e70491d10f11e8$var$readRadixNumber() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2; // 0x
    // Walk to the end of the number, allowing hex digits.
    while(true){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseF || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).underscore) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else break;
    }
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint);
    } else $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num);
}
// Read an integer, octal integer, or floating-point number.
function $19e70491d10f11e8$var$readNumber(startsWithDot) {
    let isBigInt = false;
    let isDecimal = false;
    if (!startsWithDot) $19e70491d10f11e8$var$readInt();
    let nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$var$readInt();
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseE || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseE) {
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$var$readInt();
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        isBigInt = true;
    } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseM) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        isDecimal = true;
    }
    if (isBigInt) {
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint);
        return;
    }
    if (isDecimal) {
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal);
        return;
    }
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num);
}
function $19e70491d10f11e8$var$readString(quote) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else if (ch === quote) break;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}
// Reads template string tokens.
function $19e70491d10f11e8$var$readTmplToken() {
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated template");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).graveAccent || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dollarSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start && $19e70491d10f11e8$export$4659b591c19bdf3d((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).template)) {
                if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dollarSign) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
                    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
                    return;
                } else {
                    ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote);
                    return;
                }
            }
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).template);
            return;
        }
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
}
function $19e70491d10f11e8$export$abcfffe72e6e8184() {
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch]) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) {
            // \u
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
            }
        } else break;
    }
}





function $cdb710e84f40793b$export$2e2bcd8739ae039(tokens, index = tokens.currentIndex()) {
    let endIndex = index + 1;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) {
        // import {A}
        const name = tokens.identifierNameAtIndex(index);
        return {
            isType: false,
            leftName: name,
            rightName: name,
            endIndex: endIndex
        };
    }
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {type A}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {A as B}
    return {
        isType: false,
        leftName: tokens.identifierNameAtIndex(index),
        rightName: tokens.identifierNameAtIndex(index + 2),
        endIndex: endIndex
    };
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {type A as B}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    throw new Error(`Unexpected import/export specifier at ${index}`);
}
function $cdb710e84f40793b$var$isSpecifierEnd(tokens, index) {
    const token = tokens.tokens[index];
    return token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR || token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma;
}




// Use a Map rather than object to avoid unexpected __proto__ access.
var $a73e151b913ffd13$export$2e2bcd8739ae039 = new Map([
    [
        "quot",
        "\u0022"
    ],
    [
        "amp",
        "&"
    ],
    [
        "apos",
        "\u0027"
    ],
    [
        "lt",
        "<"
    ],
    [
        "gt",
        ">"
    ],
    [
        "nbsp",
        "\u00A0"
    ],
    [
        "iexcl",
        "\u00A1"
    ],
    [
        "cent",
        "\u00A2"
    ],
    [
        "pound",
        "\u00A3"
    ],
    [
        "curren",
        "\u00A4"
    ],
    [
        "yen",
        "\u00A5"
    ],
    [
        "brvbar",
        "\u00A6"
    ],
    [
        "sect",
        "\u00A7"
    ],
    [
        "uml",
        "\u00A8"
    ],
    [
        "copy",
        "\u00A9"
    ],
    [
        "ordf",
        "\u00AA"
    ],
    [
        "laquo",
        "\u00AB"
    ],
    [
        "not",
        "\u00AC"
    ],
    [
        "shy",
        "\u00AD"
    ],
    [
        "reg",
        "\u00AE"
    ],
    [
        "macr",
        "\u00AF"
    ],
    [
        "deg",
        "\u00B0"
    ],
    [
        "plusmn",
        "\u00B1"
    ],
    [
        "sup2",
        "\u00B2"
    ],
    [
        "sup3",
        "\u00B3"
    ],
    [
        "acute",
        "\u00B4"
    ],
    [
        "micro",
        "\u00B5"
    ],
    [
        "para",
        "\u00B6"
    ],
    [
        "middot",
        "\u00B7"
    ],
    [
        "cedil",
        "\u00B8"
    ],
    [
        "sup1",
        "\u00B9"
    ],
    [
        "ordm",
        "\u00BA"
    ],
    [
        "raquo",
        "\u00BB"
    ],
    [
        "frac14",
        "\u00BC"
    ],
    [
        "frac12",
        "\u00BD"
    ],
    [
        "frac34",
        "\u00BE"
    ],
    [
        "iquest",
        "\u00BF"
    ],
    [
        "Agrave",
        "\u00C0"
    ],
    [
        "Aacute",
        "\u00C1"
    ],
    [
        "Acirc",
        "\u00C2"
    ],
    [
        "Atilde",
        "\u00C3"
    ],
    [
        "Auml",
        "\u00C4"
    ],
    [
        "Aring",
        "\u00C5"
    ],
    [
        "AElig",
        "\u00C6"
    ],
    [
        "Ccedil",
        "\u00C7"
    ],
    [
        "Egrave",
        "\u00C8"
    ],
    [
        "Eacute",
        "\u00C9"
    ],
    [
        "Ecirc",
        "\u00CA"
    ],
    [
        "Euml",
        "\u00CB"
    ],
    [
        "Igrave",
        "\u00CC"
    ],
    [
        "Iacute",
        "\u00CD"
    ],
    [
        "Icirc",
        "\u00CE"
    ],
    [
        "Iuml",
        "\u00CF"
    ],
    [
        "ETH",
        "\u00D0"
    ],
    [
        "Ntilde",
        "\u00D1"
    ],
    [
        "Ograve",
        "\u00D2"
    ],
    [
        "Oacute",
        "\u00D3"
    ],
    [
        "Ocirc",
        "\u00D4"
    ],
    [
        "Otilde",
        "\u00D5"
    ],
    [
        "Ouml",
        "\u00D6"
    ],
    [
        "times",
        "\u00D7"
    ],
    [
        "Oslash",
        "\u00D8"
    ],
    [
        "Ugrave",
        "\u00D9"
    ],
    [
        "Uacute",
        "\u00DA"
    ],
    [
        "Ucirc",
        "\u00DB"
    ],
    [
        "Uuml",
        "\u00DC"
    ],
    [
        "Yacute",
        "\u00DD"
    ],
    [
        "THORN",
        "\u00DE"
    ],
    [
        "szlig",
        "\u00DF"
    ],
    [
        "agrave",
        "\u00E0"
    ],
    [
        "aacute",
        "\u00E1"
    ],
    [
        "acirc",
        "\u00E2"
    ],
    [
        "atilde",
        "\u00E3"
    ],
    [
        "auml",
        "\u00E4"
    ],
    [
        "aring",
        "\u00E5"
    ],
    [
        "aelig",
        "\u00E6"
    ],
    [
        "ccedil",
        "\u00E7"
    ],
    [
        "egrave",
        "\u00E8"
    ],
    [
        "eacute",
        "\u00E9"
    ],
    [
        "ecirc",
        "\u00EA"
    ],
    [
        "euml",
        "\u00EB"
    ],
    [
        "igrave",
        "\u00EC"
    ],
    [
        "iacute",
        "\u00ED"
    ],
    [
        "icirc",
        "\u00EE"
    ],
    [
        "iuml",
        "\u00EF"
    ],
    [
        "eth",
        "\u00F0"
    ],
    [
        "ntilde",
        "\u00F1"
    ],
    [
        "ograve",
        "\u00F2"
    ],
    [
        "oacute",
        "\u00F3"
    ],
    [
        "ocirc",
        "\u00F4"
    ],
    [
        "otilde",
        "\u00F5"
    ],
    [
        "ouml",
        "\u00F6"
    ],
    [
        "divide",
        "\u00F7"
    ],
    [
        "oslash",
        "\u00F8"
    ],
    [
        "ugrave",
        "\u00F9"
    ],
    [
        "uacute",
        "\u00FA"
    ],
    [
        "ucirc",
        "\u00FB"
    ],
    [
        "uuml",
        "\u00FC"
    ],
    [
        "yacute",
        "\u00FD"
    ],
    [
        "thorn",
        "\u00FE"
    ],
    [
        "yuml",
        "\u00FF"
    ],
    [
        "OElig",
        "\u0152"
    ],
    [
        "oelig",
        "\u0153"
    ],
    [
        "Scaron",
        "\u0160"
    ],
    [
        "scaron",
        "\u0161"
    ],
    [
        "Yuml",
        "\u0178"
    ],
    [
        "fnof",
        "\u0192"
    ],
    [
        "circ",
        "\u02C6"
    ],
    [
        "tilde",
        "\u02DC"
    ],
    [
        "Alpha",
        "\u0391"
    ],
    [
        "Beta",
        "\u0392"
    ],
    [
        "Gamma",
        "\u0393"
    ],
    [
        "Delta",
        "\u0394"
    ],
    [
        "Epsilon",
        "\u0395"
    ],
    [
        "Zeta",
        "\u0396"
    ],
    [
        "Eta",
        "\u0397"
    ],
    [
        "Theta",
        "\u0398"
    ],
    [
        "Iota",
        "\u0399"
    ],
    [
        "Kappa",
        "\u039A"
    ],
    [
        "Lambda",
        "\u039B"
    ],
    [
        "Mu",
        "\u039C"
    ],
    [
        "Nu",
        "\u039D"
    ],
    [
        "Xi",
        "\u039E"
    ],
    [
        "Omicron",
        "\u039F"
    ],
    [
        "Pi",
        "\u03A0"
    ],
    [
        "Rho",
        "\u03A1"
    ],
    [
        "Sigma",
        "\u03A3"
    ],
    [
        "Tau",
        "\u03A4"
    ],
    [
        "Upsilon",
        "\u03A5"
    ],
    [
        "Phi",
        "\u03A6"
    ],
    [
        "Chi",
        "\u03A7"
    ],
    [
        "Psi",
        "\u03A8"
    ],
    [
        "Omega",
        "\u03A9"
    ],
    [
        "alpha",
        "\u03B1"
    ],
    [
        "beta",
        "\u03B2"
    ],
    [
        "gamma",
        "\u03B3"
    ],
    [
        "delta",
        "\u03B4"
    ],
    [
        "epsilon",
        "\u03B5"
    ],
    [
        "zeta",
        "\u03B6"
    ],
    [
        "eta",
        "\u03B7"
    ],
    [
        "theta",
        "\u03B8"
    ],
    [
        "iota",
        "\u03B9"
    ],
    [
        "kappa",
        "\u03BA"
    ],
    [
        "lambda",
        "\u03BB"
    ],
    [
        "mu",
        "\u03BC"
    ],
    [
        "nu",
        "\u03BD"
    ],
    [
        "xi",
        "\u03BE"
    ],
    [
        "omicron",
        "\u03BF"
    ],
    [
        "pi",
        "\u03C0"
    ],
    [
        "rho",
        "\u03C1"
    ],
    [
        "sigmaf",
        "\u03C2"
    ],
    [
        "sigma",
        "\u03C3"
    ],
    [
        "tau",
        "\u03C4"
    ],
    [
        "upsilon",
        "\u03C5"
    ],
    [
        "phi",
        "\u03C6"
    ],
    [
        "chi",
        "\u03C7"
    ],
    [
        "psi",
        "\u03C8"
    ],
    [
        "omega",
        "\u03C9"
    ],
    [
        "thetasym",
        "\u03D1"
    ],
    [
        "upsih",
        "\u03D2"
    ],
    [
        "piv",
        "\u03D6"
    ],
    [
        "ensp",
        "\u2002"
    ],
    [
        "emsp",
        "\u2003"
    ],
    [
        "thinsp",
        "\u2009"
    ],
    [
        "zwnj",
        "\u200C"
    ],
    [
        "zwj",
        "\u200D"
    ],
    [
        "lrm",
        "\u200E"
    ],
    [
        "rlm",
        "\u200F"
    ],
    [
        "ndash",
        "\u2013"
    ],
    [
        "mdash",
        "\u2014"
    ],
    [
        "lsquo",
        "\u2018"
    ],
    [
        "rsquo",
        "\u2019"
    ],
    [
        "sbquo",
        "\u201A"
    ],
    [
        "ldquo",
        "\u201C"
    ],
    [
        "rdquo",
        "\u201D"
    ],
    [
        "bdquo",
        "\u201E"
    ],
    [
        "dagger",
        "\u2020"
    ],
    [
        "Dagger",
        "\u2021"
    ],
    [
        "bull",
        "\u2022"
    ],
    [
        "hellip",
        "\u2026"
    ],
    [
        "permil",
        "\u2030"
    ],
    [
        "prime",
        "\u2032"
    ],
    [
        "Prime",
        "\u2033"
    ],
    [
        "lsaquo",
        "\u2039"
    ],
    [
        "rsaquo",
        "\u203A"
    ],
    [
        "oline",
        "\u203E"
    ],
    [
        "frasl",
        "\u2044"
    ],
    [
        "euro",
        "\u20AC"
    ],
    [
        "image",
        "\u2111"
    ],
    [
        "weierp",
        "\u2118"
    ],
    [
        "real",
        "\u211C"
    ],
    [
        "trade",
        "\u2122"
    ],
    [
        "alefsym",
        "\u2135"
    ],
    [
        "larr",
        "\u2190"
    ],
    [
        "uarr",
        "\u2191"
    ],
    [
        "rarr",
        "\u2192"
    ],
    [
        "darr",
        "\u2193"
    ],
    [
        "harr",
        "\u2194"
    ],
    [
        "crarr",
        "\u21B5"
    ],
    [
        "lArr",
        "\u21D0"
    ],
    [
        "uArr",
        "\u21D1"
    ],
    [
        "rArr",
        "\u21D2"
    ],
    [
        "dArr",
        "\u21D3"
    ],
    [
        "hArr",
        "\u21D4"
    ],
    [
        "forall",
        "\u2200"
    ],
    [
        "part",
        "\u2202"
    ],
    [
        "exist",
        "\u2203"
    ],
    [
        "empty",
        "\u2205"
    ],
    [
        "nabla",
        "\u2207"
    ],
    [
        "isin",
        "\u2208"
    ],
    [
        "notin",
        "\u2209"
    ],
    [
        "ni",
        "\u220B"
    ],
    [
        "prod",
        "\u220F"
    ],
    [
        "sum",
        "\u2211"
    ],
    [
        "minus",
        "\u2212"
    ],
    [
        "lowast",
        "\u2217"
    ],
    [
        "radic",
        "\u221A"
    ],
    [
        "prop",
        "\u221D"
    ],
    [
        "infin",
        "\u221E"
    ],
    [
        "ang",
        "\u2220"
    ],
    [
        "and",
        "\u2227"
    ],
    [
        "or",
        "\u2228"
    ],
    [
        "cap",
        "\u2229"
    ],
    [
        "cup",
        "\u222A"
    ],
    [
        "int",
        "\u222B"
    ],
    [
        "there4",
        "\u2234"
    ],
    [
        "sim",
        "\u223C"
    ],
    [
        "cong",
        "\u2245"
    ],
    [
        "asymp",
        "\u2248"
    ],
    [
        "ne",
        "\u2260"
    ],
    [
        "equiv",
        "\u2261"
    ],
    [
        "le",
        "\u2264"
    ],
    [
        "ge",
        "\u2265"
    ],
    [
        "sub",
        "\u2282"
    ],
    [
        "sup",
        "\u2283"
    ],
    [
        "nsub",
        "\u2284"
    ],
    [
        "sube",
        "\u2286"
    ],
    [
        "supe",
        "\u2287"
    ],
    [
        "oplus",
        "\u2295"
    ],
    [
        "otimes",
        "\u2297"
    ],
    [
        "perp",
        "\u22A5"
    ],
    [
        "sdot",
        "\u22C5"
    ],
    [
        "lceil",
        "\u2308"
    ],
    [
        "rceil",
        "\u2309"
    ],
    [
        "lfloor",
        "\u230A"
    ],
    [
        "rfloor",
        "\u230B"
    ],
    [
        "lang",
        "\u2329"
    ],
    [
        "rang",
        "\u232A"
    ],
    [
        "loz",
        "\u25CA"
    ],
    [
        "spades",
        "\u2660"
    ],
    [
        "clubs",
        "\u2663"
    ],
    [
        "hearts",
        "\u2665"
    ],
    [
        "diams",
        "\u2666"
    ]
]);





function $e4116504922add70$export$2e2bcd8739ae039(options) {
    const [base, suffix] = $e4116504922add70$var$splitPragma(options.jsxPragma || "React.createElement");
    const [fragmentBase, fragmentSuffix] = $e4116504922add70$var$splitPragma(options.jsxFragmentPragma || "React.Fragment");
    return {
        base: base,
        suffix: suffix,
        fragmentBase: fragmentBase,
        fragmentSuffix: fragmentSuffix
    };
}
function $e4116504922add70$var$splitPragma(pragma) {
    let dotIndex = pragma.indexOf(".");
    if (dotIndex === -1) dotIndex = pragma.length;
    return [
        pragma.slice(0, dotIndex),
        pragma.slice(dotIndex)
    ];
}


class $12b925d88ed0df69$export$2e2bcd8739ae039 {
    // Return true if anything was processed, false otherwise.
    getPrefixCode() {
        return "";
    }
    getHoistedCode() {
        return "";
    }
    getSuffixCode() {
        return "";
    }
}


class $02817d809bdcb26e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    // State for calculating the line number of each JSX tag in development.
    __init() {
        this.lastLineNumber = 1;
    }
    __init2() {
        this.lastIndex = 0;
    }
    // In development, variable name holding the name of the current file.
    __init3() {
        this.filenameVarName = null;
    }
    // Mapping of claimed names for imports in the automatic transform, e,g.
    // {jsx: "_jsx"}. This determines which imports to generate in the prefix.
    __init4() {
        this.esmAutomaticImportNameResolutions = {};
    }
    // When automatically adding imports in CJS mode, we store the variable name
    // holding the imported CJS module so we can require it in the prefix.
    __init5() {
        this.cjsAutomaticModuleNameResolutions = {};
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.options = options;
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init5.call(this);
        this.jsxPragmaInfo = (0, $e4116504922add70$export$2e2bcd8739ae039)(options);
        this.isAutomaticRuntime = options.jsxRuntime === "automatic";
        this.jsxImportSource = options.jsxImportSource || "react";
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
            this.processJSXTag();
            return true;
        }
        return false;
    }
    getPrefixCode() {
        let prefix = "";
        if (this.filenameVarName) prefix += `const ${this.filenameVarName} = ${JSON.stringify(this.options.filePath || "")};`;
        if (this.isAutomaticRuntime) {
            if (this.importProcessor) // CJS mode: emit require statements for all modules that were referenced.
            for (const [path, resolvedName] of Object.entries(this.cjsAutomaticModuleNameResolutions))prefix += `var ${resolvedName} = require("${path}");`;
            else {
                // ESM mode: consolidate and emit import statements for referenced names.
                const { createElement: createElementResolution, ...otherResolutions } = this.esmAutomaticImportNameResolutions;
                if (createElementResolution) prefix += `import {createElement as ${createElementResolution}} from "${this.jsxImportSource}";`;
                const importSpecifiers = Object.entries(otherResolutions).map(([name, resolvedName])=>`${name} as ${resolvedName}`).join(", ");
                if (importSpecifiers) {
                    const importPath = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
                    prefix += `import {${importSpecifiers}} from "${importPath}";`;
                }
            }
        }
        return prefix;
    }
    processJSXTag() {
        const { jsxRole: jsxRole, start: start } = this.tokens.currentToken();
        // Calculate line number information at the very start (if in development
        // mode) so that the information is guaranteed to be queried in token order.
        const elementLocationCode = this.options.production ? null : this.getElementLocationCode(start);
        if (this.isAutomaticRuntime && jsxRole !== (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread) this.transformTagToJSXFunc(elementLocationCode, jsxRole);
        else this.transformTagToCreateElement(elementLocationCode);
    }
    getElementLocationCode(firstTokenStart) {
        const lineNumber = this.getLineNumberForIndex(firstTokenStart);
        return `lineNumber: ${lineNumber}`;
    }
    /**
   * Get the line number for this source position. This is calculated lazily and
   * must be called in increasing order by index.
   */ getLineNumberForIndex(index) {
        const code = this.tokens.code;
        while(this.lastIndex < index && this.lastIndex < code.length){
            if (code[this.lastIndex] === "\n") this.lastLineNumber++;
            this.lastIndex++;
        }
        return this.lastLineNumber;
    }
    /**
   * Convert the current JSX element to a call to jsx, jsxs, or jsxDEV. This is
   * the primary transformation for the automatic transform.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * jsxs('div', {a: 1, children: ["Hello", x]}, 2)
   */ transformTagToJSXFunc(elementLocationCode, jsxRole) {
        const isStatic = jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren;
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getJSXFuncInvocationCode(isStatic));
        let keyCode = null;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, {`);
            this.processAutomaticChildrenAndEndProps(jsxRole);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.tokens.appendCode(", {");
            keyCode = this.processProps(true);
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // Self-closing tag, no children to add, so close the props.
            this.tokens.appendCode("}");
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children.
                this.tokens.removeToken();
                this.processAutomaticChildrenAndEndProps(jsxRole);
            } else throw new Error("Expected either /> or > at the end of the tag.");
            // If a key was present, move it to its own arg. Note that moving code
            // like this will cause line numbers to get out of sync within the JSX
            // element if the key expression has a newline in it. This is unfortunate,
            // but hopefully should be rare.
            if (keyCode) this.tokens.appendCode(`, ${keyCode}`);
        }
        if (!this.options.production) {
            // If the key wasn't already added, add it now so we can correctly set
            // positional args for jsxDEV.
            if (keyCode === null) this.tokens.appendCode(", void 0");
            this.tokens.appendCode(`, ${isStatic}, ${this.getDevSource(elementLocationCode)}, this`);
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Convert the current JSX element to a createElement call. In the classic
   * runtime, this is the only case. In the automatic runtime, this is called
   * as a fallback in some situations.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * React.createElement('div', {a: 1, key: 2}, "Hello", x)
   */ transformTagToCreateElement(elementLocationCode) {
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getCreateElementInvocationCode());
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, null`);
            this.processChildren(true);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.processPropsObjectWithDevInfo(elementLocationCode);
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) ;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children and a close-tag; process the children as args.
                this.tokens.removeToken();
                this.processChildren(true);
            } else throw new Error("Expected either /> or > at the end of the tag.");
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Get the code for the relevant function for this context: jsx, jsxs,
   * or jsxDEV. The following open-paren is included as well.
   *
   * These functions are only used for the automatic runtime, so they are always
   * auto-imported, but the auto-import will be either CJS or ESM based on the
   * target module format.
   */ getJSXFuncInvocationCode(isStatic) {
        if (this.options.production) {
            if (isStatic) return this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime");
            else return this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime");
        } else return this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
    }
    /**
   * Return the code to use for the createElement function, e.g.
   * `React.createElement`, including the following open-paren.
   *
   * This is the main function to use for the classic runtime. For the
   * automatic runtime, this function is used as a fallback function to
   * preserve behavior when there is a prop spread followed by an explicit
   * key. In that automatic runtime case, the function should be automatically
   * imported.
   */ getCreateElementInvocationCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.base) || jsxPragmaInfo.base : jsxPragmaInfo.base;
            return `${resolvedPragmaBaseName}${jsxPragmaInfo.suffix}(`;
        }
    }
    /**
   * Return the code to use as the component when compiling a shorthand
   * fragment, e.g. `React.Fragment`.
   *
   * This may be called from either the classic or automatic runtime, and
   * the value should be auto-imported for the automatic runtime.
   */ getFragmentCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedFragmentPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.fragmentBase) || jsxPragmaInfo.fragmentBase : jsxPragmaInfo.fragmentBase;
            return resolvedFragmentPragmaBaseName + jsxPragmaInfo.fragmentSuffix;
        }
    }
    /**
   * Return code that invokes the given function.
   *
   * When the imports transform is enabled, use the CJSImportTransformer
   * strategy of using `.call(void 0, ...` to avoid passing a `this` value in a
   * situation that would otherwise look like a method call.
   */ claimAutoImportedFuncInvocation(funcName, importPathSuffix) {
        const funcCode = this.claimAutoImportedName(funcName, importPathSuffix);
        if (this.importProcessor) return `${funcCode}.call(void 0, `;
        else return `${funcCode}(`;
    }
    claimAutoImportedName(funcName, importPathSuffix) {
        if (this.importProcessor) {
            // CJS mode: claim a name for the module and mark it for import.
            const path = this.jsxImportSource + importPathSuffix;
            if (!this.cjsAutomaticModuleNameResolutions[path]) this.cjsAutomaticModuleNameResolutions[path] = this.importProcessor.getFreeIdentifierForPath(path);
            return `${this.cjsAutomaticModuleNameResolutions[path]}.${funcName}`;
        } else {
            // ESM mode: claim a name for this function and add it to the names that
            // should be auto-imported when the prefix is generated.
            if (!this.esmAutomaticImportNameResolutions[funcName]) this.esmAutomaticImportNameResolutions[funcName] = this.nameManager.claimFreeName(`_${funcName}`);
            return this.esmAutomaticImportNameResolutions[funcName];
        }
    }
    /**
   * Process the first part of a tag, before any props.
   */ processTagIntro() {
        // Walk forward until we see one of these patterns:
        // jsxName to start the first prop, preceded by another jsxName to end the tag name.
        // jsxName to start the first prop, preceded by greaterThan to end the type argument.
        // [open brace] to start the first prop.
        // [jsxTagEnd] to end the open-tag.
        // [slash, jsxTagEnd] to end the self-closing tag.
        let introEnd = this.tokens.currentIndex() + 1;
        while(this.tokens.tokens[introEnd].isType || !this.tokens.matches2AtIndex(introEnd - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches2AtIndex(introEnd - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && !this.tokens.matches1AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) && !this.tokens.matches2AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))introEnd++;
        if (introEnd === this.tokens.currentIndex() + 1) {
            const tagName = this.tokens.identifierName();
            if ($02817d809bdcb26e$export$b682d115586a1832(tagName)) this.tokens.replaceToken(`'${tagName}'`);
        }
        while(this.tokens.currentIndex() < introEnd)this.rootTransformer.processToken();
    }
    /**
   * Starting at the beginning of the props, add the props argument to
   * React.createElement, including the comma before it.
   */ processPropsObjectWithDevInfo(elementLocationCode) {
        const devProps = this.options.production ? "" : `__self: this, __source: ${this.getDevSource(elementLocationCode)}`;
        if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            if (devProps) this.tokens.appendCode(`, {${devProps}}`);
            else this.tokens.appendCode(`, null`);
            return;
        }
        this.tokens.appendCode(`, {`);
        this.processProps(false);
        if (devProps) this.tokens.appendCode(` ${devProps}}`);
        else this.tokens.appendCode("}");
    }
    /**
   * Transform the core part of the props, assuming that a { has already been
   * inserted before us and that a } will be inserted after us.
   *
   * If extractKeyCode is true (i.e. when using any jsx... function), any prop
   * named "key" has its code captured and returned rather than being emitted to
   * the output code. This shifts line numbers, and emitting the code later will
   * correct line numbers again. If no key is found or if extractKeyCode is
   * false, this function returns null.
   */ processProps(extractKeyCode) {
        let keyCode = null;
        while(true){
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                // This is a regular key={value} or key="value" prop.
                const propName = this.tokens.identifierName();
                if (extractKeyCode && propName === "key") {
                    if (keyCode !== null) // The props list has multiple keys. Different implementations are
                    // inconsistent about what to do here: as of this writing, Babel and
                    // swc keep the *last* key and completely remove the rest, while
                    // TypeScript uses the *first* key and leaves the others as regular
                    // props. The React team collaborated with Babel on the
                    // implementation of this behavior, so presumably the Babel behavior
                    // is the one to use.
                    // Since we won't ever be emitting the previous key code, we need to
                    // at least emit its newlines here so that the line numbers match up
                    // in the long run.
                    this.tokens.appendCode(keyCode.replace(/[^\n]/g, ""));
                    // key
                    this.tokens.removeToken();
                    // =
                    this.tokens.removeToken();
                    const snapshot = this.tokens.snapshot();
                    this.processPropValue();
                    keyCode = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot);
                    continue;
                } else {
                    this.processPropName(propName);
                    this.tokens.replaceToken(": ");
                    this.processPropValue();
                }
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName)) {
                // This is a shorthand prop like <input disabled />.
                const propName = this.tokens.identifierName();
                this.processPropName(propName);
                this.tokens.appendCode(": true");
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                // This is prop spread, like <div {...getProps()}>, which we can pass
                // through fairly directly as an object spread.
                this.tokens.replaceToken("");
                this.rootTransformer.processBalancedCode();
                this.tokens.replaceToken("");
            } else break;
            this.tokens.appendCode(",");
        }
        return keyCode;
    }
    processPropName(propName) {
        if (propName.includes("-")) this.tokens.replaceToken(`'${propName}'`);
        else this.tokens.copyToken();
    }
    processPropValue() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.tokens.replaceToken("");
            this.rootTransformer.processBalancedCode();
            this.tokens.replaceToken("");
        } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) this.processJSXTag();
        else this.processStringPropValue();
    }
    processStringPropValue() {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start + 1, token.end - 1);
        const replacementCode = $02817d809bdcb26e$var$formatJSXTextReplacement(valueCode);
        const literalCode = $02817d809bdcb26e$var$formatJSXStringValueLiteral(valueCode);
        this.tokens.replaceToken(literalCode + replacementCode);
    }
    /**
   * Starting in the middle of the props object literal, produce an additional
   * prop for the children and close the object literal.
   */ processAutomaticChildrenAndEndProps(jsxRole) {
        if (jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren) {
            this.tokens.appendCode(" children: [");
            this.processChildren(false);
            this.tokens.appendCode("]}");
        } else {
            // The parser information tells us whether we will see a real child or if
            // all remaining children (if any) will resolve to empty. If there are no
            // non-empty children, don't emit a children prop at all, but still
            // process children so that we properly transform the code into nothing.
            if (jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).OneChild) this.tokens.appendCode(" children: ");
            this.processChildren(false);
            this.tokens.appendCode("}");
        }
    }
    /**
   * Transform children into a comma-separated list, which will be either
   * arguments to createElement or array elements of a children prop.
   */ processChildren(needsInitialComma) {
        let needsComma = needsInitialComma;
        while(true){
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash)) // Closing tag, so no more children.
            return;
            let didEmitElement = false;
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                    // Empty interpolations and comment-only interpolations are allowed
                    // and don't create an extra child arg.
                    this.tokens.replaceToken("");
                    this.tokens.replaceToken("");
                } else {
                    // Interpolated expression.
                    this.tokens.replaceToken(needsComma ? ", " : "");
                    this.rootTransformer.processBalancedCode();
                    this.tokens.replaceToken("");
                    didEmitElement = true;
                }
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
                // Child JSX element
                this.tokens.appendCode(needsComma ? ", " : "");
                this.processJSXTag();
                didEmitElement = true;
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText)) didEmitElement = this.processChildTextElement(needsComma);
            else throw new Error("Unexpected token when processing JSX children.");
            if (didEmitElement) needsComma = true;
        }
    }
    /**
   * Turn a JSX text element into a string literal, or nothing at all if the JSX
   * text resolves to the empty string.
   *
   * Returns true if a string literal is emitted, false otherwise.
   */ processChildTextElement(needsComma) {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start, token.end);
        const replacementCode = $02817d809bdcb26e$var$formatJSXTextReplacement(valueCode);
        const literalCode = $02817d809bdcb26e$var$formatJSXTextLiteral(valueCode);
        if (literalCode === '""') {
            this.tokens.replaceToken(replacementCode);
            return false;
        } else {
            this.tokens.replaceToken(`${needsComma ? ", " : ""}${literalCode}${replacementCode}`);
            return true;
        }
    }
    getDevSource(elementLocationCode) {
        return `{fileName: ${this.getFilenameVarName()}, ${elementLocationCode}}`;
    }
    getFilenameVarName() {
        if (!this.filenameVarName) this.filenameVarName = this.nameManager.claimFreeName("_jsxFileName");
        return this.filenameVarName;
    }
}
function $02817d809bdcb26e$export$b682d115586a1832(s) {
    const firstChar = s.charCodeAt(0);
    return firstChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ;
}
/**
 * Turn the given jsxText string into a JS string literal. Leading and trailing
 * whitespace on lines is removed, except immediately after the open-tag and
 * before the close-tag. Empty lines are completely removed, and spaces are
 * added between lines after that.
 *
 * We use JSON.stringify to introduce escape characters as necessary, and trim
 * the start and end of each line and remove blank lines.
 */ function $02817d809bdcb26e$var$formatJSXTextLiteral(text) {
    let result = "";
    let whitespace = "";
    let isInInitialLineWhitespace = false;
    let seenNonWhitespace = false;
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === " " || c === "\t" || c === "\r") {
            if (!isInInitialLineWhitespace) whitespace += c;
        } else if (c === "\n") {
            whitespace = "";
            isInInitialLineWhitespace = true;
        } else {
            if (seenNonWhitespace && isInInitialLineWhitespace) result += " ";
            result += whitespace;
            whitespace = "";
            if (c === "&") {
                const { entity: entity, newI: newI } = $02817d809bdcb26e$var$processEntity(text, i + 1);
                i = newI - 1;
                result += entity;
            } else result += c;
            seenNonWhitespace = true;
            isInInitialLineWhitespace = false;
        }
    }
    if (!isInInitialLineWhitespace) result += whitespace;
    return JSON.stringify(result);
}
/**
 * Produce the code that should be printed after the JSX text string literal,
 * with most content removed, but all newlines preserved and all spacing at the
 * end preserved.
 */ function $02817d809bdcb26e$var$formatJSXTextReplacement(text) {
    let numNewlines = 0;
    let numSpaces = 0;
    for (const c of text){
        if (c === "\n") {
            numNewlines++;
            numSpaces = 0;
        } else if (c === " ") numSpaces++;
    }
    return "\n".repeat(numNewlines) + " ".repeat(numSpaces);
}
/**
 * Format a string in the value position of a JSX prop.
 *
 * Use the same implementation as convertAttribute from
 * babel-helper-builder-react-jsx.
 */ function $02817d809bdcb26e$var$formatJSXStringValueLiteral(text) {
    let result = "";
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === "\n") {
            if (/\s/.test(text[i + 1])) {
                result += " ";
                while(i < text.length && /\s/.test(text[i + 1]))i++;
            } else result += "\n";
        } else if (c === "&") {
            const { entity: entity, newI: newI } = $02817d809bdcb26e$var$processEntity(text, i + 1);
            result += entity;
            i = newI - 1;
        } else result += c;
    }
    return JSON.stringify(result);
}
/**
 * Starting at a &, see if there's an HTML entity (specified by name, decimal
 * char code, or hex char code) and return it if so.
 *
 * Modified from jsxReadString in babel-parser.
 */ function $02817d809bdcb26e$var$processEntity(text, indexAfterAmpersand) {
    let str = "";
    let count = 0;
    let entity;
    let i = indexAfterAmpersand;
    if (text[i] === "#") {
        let radix = 10;
        i++;
        let numStart;
        if (text[i] === "x") {
            radix = 16;
            i++;
            numStart = i;
            while(i < text.length && $02817d809bdcb26e$var$isHexDigit(text.charCodeAt(i)))i++;
        } else {
            numStart = i;
            while(i < text.length && $02817d809bdcb26e$var$isDecimalDigit(text.charCodeAt(i)))i++;
        }
        if (text[i] === ";") {
            const numStr = text.slice(numStart, i);
            if (numStr) {
                i++;
                entity = String.fromCodePoint(parseInt(numStr, radix));
            }
        }
    } else while(i < text.length && count++ < 10){
        const ch = text[i];
        i++;
        if (ch === ";") {
            entity = (0, $a73e151b913ffd13$export$2e2bcd8739ae039).get(str);
            break;
        }
        str += ch;
    }
    if (!entity) return {
        entity: "&",
        newI: indexAfterAmpersand
    };
    return {
        entity: entity,
        newI: i
    };
}
function $02817d809bdcb26e$var$isDecimalDigit(code) {
    return code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9;
}
function $02817d809bdcb26e$var$isHexDigit(code) {
    return code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseF;
}



function $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7(tokens, options) {
    const jsxPragmaInfo = (0, $e4116504922add70$export$2e2bcd8739ae039)(options);
    const nonTypeIdentifiers = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && !token.isType && (token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access || token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand || token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess) && !token.shadowsGlobal) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart) nonTypeIdentifiers.add(jsxPragmaInfo.base);
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart && i + 1 < tokens.tokens.length && tokens.tokens[i + 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) {
            nonTypeIdentifiers.add(jsxPragmaInfo.base);
            nonTypeIdentifiers.add(jsxPragmaInfo.fragmentBase);
        }
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName && token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access) {
            const identifierName = tokens.identifierNameForToken(token);
            // Lower-case single-component tag names like "div" don't count.
            if (!(0, $02817d809bdcb26e$export$b682d115586a1832)(identifierName) || tokens.tokens[i + 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        }
    }
    return nonTypeIdentifiers;
}


class $cbf8fee06b97a5bb$export$2e2bcd8739ae039 {
    __init() {
        this.nonTypeIdentifiers = new Set();
    }
    __init2() {
        this.importInfoByPath = new Map();
    }
    __init3() {
        this.importsToReplace = new Map();
    }
    __init4() {
        this.identifierReplacements = new Map();
    }
    __init5() {
        this.exportBindingsByLocalName = new Map();
    }
    constructor(nameManager, tokens, enableLegacyTypeScriptModuleInterop, options, isTypeScriptTransformEnabled, keepUnusedImports, helperManager){
        this.nameManager = nameManager;
        this.tokens = tokens;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.options = options;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.helperManager = helperManager;
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init5.call(this);
    }
    preprocessTokens() {
        for(let i = 0; i < this.tokens.tokens.length; i++){
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) && !this.tokens.matches3AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.preprocessImportAtIndex(i);
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export) && !this.tokens.matches2AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.preprocessExportAtIndex(i);
        }
        this.generateImportReplacements();
    }
    /**
   * In TypeScript, import statements that only import types should be removed.
   * This includes `import {} from 'foo';`, but not `import 'foo';`.
   */ pruneTypeOnlyImports() {
        this.nonTypeIdentifiers = (0, $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7)(this.tokens, this.options);
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            if (importInfo.hasBareImport || importInfo.hasStarExport || importInfo.exportStarNames.length > 0 || importInfo.namedExports.length > 0) continue;
            const names = [
                ...importInfo.defaultNames,
                ...importInfo.wildcardNames,
                ...importInfo.namedImports.map(({ localName: localName })=>localName)
            ];
            if (names.every((name)=>this.shouldAutomaticallyElideImportedName(name))) this.importsToReplace.set(path, "");
        }
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    generateImportReplacements() {
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            const { defaultNames: defaultNames, wildcardNames: wildcardNames, namedImports: namedImports, namedExports: namedExports, exportStarNames: exportStarNames, hasStarExport: hasStarExport } = importInfo;
            if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0 && namedExports.length === 0 && exportStarNames.length === 0 && !hasStarExport) {
                // Import is never used, so don't even assign a name.
                this.importsToReplace.set(path, `require('${path}');`);
                continue;
            }
            const primaryImportName = this.getFreeIdentifierForPath(path);
            let secondaryImportName;
            if (this.enableLegacyTypeScriptModuleInterop) secondaryImportName = primaryImportName;
            else secondaryImportName = wildcardNames.length > 0 ? wildcardNames[0] : this.getFreeIdentifierForPath(path);
            let requireCode = `var ${primaryImportName} = require('${path}');`;
            if (wildcardNames.length > 0) for (const wildcardName of wildcardNames){
                const moduleExpr = this.enableLegacyTypeScriptModuleInterop ? primaryImportName : `${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName})`;
                requireCode += ` var ${wildcardName} = ${moduleExpr};`;
            }
            else if (exportStarNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName});`;
            else if (defaultNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireDefault")}(${primaryImportName});`;
            for (const { importedName: importedName, localName: localName } of namedExports)requireCode += ` ${this.helperManager.getHelperName("createNamedExportFrom")}(${primaryImportName}, '${localName}', '${importedName}');`;
            for (const exportStarName of exportStarNames)requireCode += ` exports.${exportStarName} = ${secondaryImportName};`;
            if (hasStarExport) requireCode += ` ${this.helperManager.getHelperName("createStarExport")}(${primaryImportName});`;
            this.importsToReplace.set(path, requireCode);
            for (const defaultName of defaultNames)this.identifierReplacements.set(defaultName, `${secondaryImportName}.default`);
            for (const { importedName: importedName, localName: localName } of namedImports)this.identifierReplacements.set(localName, `${primaryImportName}.${importedName}`);
        }
    }
    getFreeIdentifierForPath(path) {
        const components = path.split("/");
        const lastComponent = components[components.length - 1];
        const baseName = lastComponent.replace(/\W/g, "");
        return this.nameManager.claimFreeName(`_${baseName}`);
    }
    preprocessImportAtIndex(index) {
        const defaultNames = [];
        const wildcardNames = [];
        const namedImports = [];
        index++;
        if ((this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof)) && !this.tokens.matches1AtIndex(index + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(index + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) // import type declaration, so no need to process anything.
        return;
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
        return;
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
            defaultNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
            if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            // * as
            index += 2;
            wildcardNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            const result = this.getNamedImports(index + 1);
            index = result.newIndex;
            for (const namedImport of result.namedImports)// Treat {default as X} as a default import to ensure usage of require interop helper
            if (namedImport.importedName === "default") defaultNames.push(namedImport.localName);
            else namedImports.push(namedImport);
        }
        if (this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) index++;
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.defaultNames.push(...defaultNames);
        importInfo.wildcardNames.push(...wildcardNames);
        importInfo.namedImports.push(...namedImports);
        if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0) importInfo.hasBareImport = true;
    }
    preprocessExportAtIndex(index) {
        if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const)) this.preprocessVarExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 2);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches3AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 3);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) this.preprocessNamedExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) this.preprocessExportStarAtIndex(index);
    }
    preprocessVarExportAtIndex(index) {
        let depth = 0;
        // Handle cases like `export let {x} = y;`, starting at the open-brace in that case.
        for(let i = index + 2;; i++){
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) depth++;
            else if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) depth--;
            else if (depth === 0 && !this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) break;
            else if (this.tokens.matches1AtIndex(1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                i = endIndex - 1;
            } else {
                const token = this.tokens.tokens[i];
                if ((0, $19e70491d10f11e8$export$31dc9881735f7118)(token)) {
                    const exportName = this.tokens.identifierNameAtIndex(i);
                    this.identifierReplacements.set(exportName, `exports.${exportName}`);
                }
            }
        }
    }
    /**
   * Walk this export statement just in case it's an export...from statement.
   * If it is, combine it into the import info for that path. Otherwise, just
   * bail out; it'll be handled later.
   */ preprocessNamedExportAtIndex(index) {
        // export {
        index += 2;
        const { newIndex: newIndex, namedImports: namedImports } = this.getNamedImports(index);
        index = newIndex;
        if (this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) index++;
        else {
            // Reinterpret "a as b" to be local/exported rather than imported/local.
            for (const { importedName: localName, localName: exportedName } of namedImports)this.addExportBinding(localName, exportedName);
            return;
        }
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.namedExports.push(...namedImports);
    }
    preprocessExportStarAtIndex(index) {
        let exportedName = null;
        if (this.tokens.matches3AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
            // export * as
            index += 3;
            exportedName = this.tokens.identifierNameAtIndex(index);
            // foo from
            index += 2;
        } else // export * from
        index += 3;
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of star export statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        if (exportedName !== null) importInfo.exportStarNames.push(exportedName);
        else importInfo.hasStarExport = true;
    }
    getNamedImports(index) {
        const namedImports = [];
        while(true){
            if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            }
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens, index);
            index = specifierInfo.endIndex;
            if (!specifierInfo.isType) namedImports.push({
                importedName: specifierInfo.leftName,
                localName: specifierInfo.rightName
            });
            if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index += 2;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.tokens[index])}`);
        }
        return {
            newIndex: index,
            namedImports: namedImports
        };
    }
    /**
   * Get a mutable import info object for this path, creating one if it doesn't
   * exist yet.
   */ getImportInfo(path) {
        const existingInfo = this.importInfoByPath.get(path);
        if (existingInfo) return existingInfo;
        const newInfo = {
            defaultNames: [],
            wildcardNames: [],
            namedImports: [],
            namedExports: [],
            hasBareImport: false,
            exportStarNames: [],
            hasStarExport: false
        };
        this.importInfoByPath.set(path, newInfo);
        return newInfo;
    }
    addExportBinding(localName, exportedName) {
        if (!this.exportBindingsByLocalName.has(localName)) this.exportBindingsByLocalName.set(localName, []);
        this.exportBindingsByLocalName.get(localName).push(exportedName);
    }
    /**
   * Return the code to use for the import for this path, or the empty string if
   * the code has already been "claimed" by a previous import.
   */ claimImportCode(importPath) {
        const result = this.importsToReplace.get(importPath);
        this.importsToReplace.set(importPath, "");
        return result || "";
    }
    getIdentifierReplacement(identifierName) {
        return this.identifierReplacements.get(identifierName) || null;
    }
    /**
   * Return a string like `exports.foo = exports.bar`.
   */ resolveExportBinding(assignedName) {
        const exportedNames = this.exportBindingsByLocalName.get(assignedName);
        if (!exportedNames || exportedNames.length === 0) return null;
        return exportedNames.map((exportedName)=>`exports.${exportedName}`).join(" = ");
    }
    /**
   * Return all imported/exported names where we might be interested in whether usages of those
   * names are shadowed.
   */ getGlobalNames() {
        return new Set([
            ...this.identifierReplacements.keys(),
            ...this.exportBindingsByLocalName.keys()
        ]);
    }
}


// src/set-array.ts
// src/vlq.ts

var $cbQCu = parcelRequire("cbQCu");
var $810b57e15a8d52ae$require$Buffer = $cbQCu.Buffer;
var $810b57e15a8d52ae$var$comma = ",".charCodeAt(0);
var $810b57e15a8d52ae$var$semicolon = ";".charCodeAt(0);
var $810b57e15a8d52ae$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $810b57e15a8d52ae$var$intToChar = new Uint8Array(64);
var $810b57e15a8d52ae$var$charToInt = new Uint8Array(128);
for(let i = 0; i < $810b57e15a8d52ae$var$chars.length; i++){
    const c = $810b57e15a8d52ae$var$chars.charCodeAt(i);
    $810b57e15a8d52ae$var$intToChar[i] = c;
    $810b57e15a8d52ae$var$charToInt[c] = i;
}
function $810b57e15a8d52ae$var$decodeInteger(reader) {
    let value = 0;
    let shift = 0;
    let integer = 0;
    do {
        const c = reader.next();
        integer = $810b57e15a8d52ae$var$charToInt[c];
        value |= (integer & 31) << shift;
        shift += 5;
    }while (integer & 32);
    return value;
}
function $810b57e15a8d52ae$var$decodeSign(num) {
    return num & 1 ? -2147483648 | -(num >>> 1) : num >>> 1;
}
function $810b57e15a8d52ae$var$encodeInteger(builder, num) {
    do {
        let clamped = num & 31;
        num >>>= 5;
        if (num > 0) clamped |= 32;
        builder.write($810b57e15a8d52ae$var$intToChar[clamped]);
    }while (num > 0);
}
function $810b57e15a8d52ae$var$encodeSign(num) {
    return num < 0 ? -num << 1 | 1 : num << 1;
}
function $810b57e15a8d52ae$var$hasMoreVlq(reader, max) {
    if (reader.pos >= max) return false;
    return reader.peek() !== $810b57e15a8d52ae$var$comma;
}
// src/strings.ts
var $810b57e15a8d52ae$var$bufLength = 16384;
var $810b57e15a8d52ae$var$td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof $810b57e15a8d52ae$require$Buffer !== "undefined" ? {
    decode (buf) {
        const out = $810b57e15a8d52ae$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
        return out.toString();
    }
} : {
    decode (buf) {
        let out = "";
        for(let i = 0; i < buf.length; i++)out += String.fromCharCode(buf[i]);
        return out;
    }
};
var $810b57e15a8d52ae$var$StringWriter = class {
    constructor(){
        this.pos = 0;
        this.out = "";
        this.buffer = new Uint8Array($810b57e15a8d52ae$var$bufLength);
    }
    write(v) {
        const { buffer: buffer } = this;
        buffer[this.pos++] = v;
        if (this.pos === $810b57e15a8d52ae$var$bufLength) {
            this.out += $810b57e15a8d52ae$var$td.decode(buffer);
            this.pos = 0;
        }
    }
    flush() {
        const { buffer: buffer, out: out, pos: pos } = this;
        return pos > 0 ? out + $810b57e15a8d52ae$var$td.decode(buffer.subarray(0, pos)) : out;
    }
};
var $810b57e15a8d52ae$var$StringReader = class {
    constructor(buffer){
        this.pos = 0;
        this.buffer = buffer;
    }
    next() {
        return this.buffer.charCodeAt(this.pos++);
    }
    peek() {
        return this.buffer.charCodeAt(this.pos);
    }
    indexOf(char) {
        const { buffer: buffer, pos: pos } = this;
        const idx = buffer.indexOf(char, pos);
        return idx === -1 ? buffer.length : idx;
    }
};
// src/scopes.ts
var $810b57e15a8d52ae$var$EMPTY = [];
function $810b57e15a8d52ae$export$b644ec5c290d956e(input) {
    const { length: length } = input;
    const reader = new $810b57e15a8d52ae$var$StringReader(input);
    const scopes = [];
    const stack = [];
    let line = 0;
    for(; reader.pos < length; reader.pos++){
        line += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
        const column = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
        if (!$810b57e15a8d52ae$var$hasMoreVlq(reader, length)) {
            const last = stack.pop();
            last[2] = line;
            last[3] = column;
            continue;
        }
        const kind = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
        const fields = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
        const hasName = fields & 1;
        const scope = hasName ? [
            line,
            column,
            0,
            0,
            kind,
            $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader))
        ] : [
            line,
            column,
            0,
            0,
            kind
        ];
        let vars = $810b57e15a8d52ae$var$EMPTY;
        if ($810b57e15a8d52ae$var$hasMoreVlq(reader, length)) {
            vars = [];
            do {
                const varsIndex = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                vars.push(varsIndex);
            }while ($810b57e15a8d52ae$var$hasMoreVlq(reader, length));
        }
        scope.vars = vars;
        scopes.push(scope);
        stack.push(scope);
    }
    return scopes;
}
function $810b57e15a8d52ae$export$b8cf1ed92d4ce741(scopes) {
    const writer = new $810b57e15a8d52ae$var$StringWriter();
    for(let i = 0; i < scopes.length;)i = $810b57e15a8d52ae$var$_encodeOriginalScopes(scopes, i, writer, [
        0
    ]);
    return writer.flush();
}
function $810b57e15a8d52ae$var$_encodeOriginalScopes(scopes, index, writer, state) {
    const scope = scopes[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, 4: kind, vars: vars } = scope;
    if (index > 0) writer.write($810b57e15a8d52ae$var$comma);
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(startLine - state[0]));
    state[0] = startLine;
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(startColumn));
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(kind));
    const fields = scope.length === 6 ? 1 : 0;
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(fields));
    if (scope.length === 6) $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(scope[5]));
    for (const v of vars)$810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(v));
    for(index++; index < scopes.length;){
        const next = scopes[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $810b57e15a8d52ae$var$_encodeOriginalScopes(scopes, index, writer, state);
    }
    writer.write($810b57e15a8d52ae$var$comma);
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(endLine - state[0]));
    state[0] = endLine;
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(endColumn));
    return index;
}
function $810b57e15a8d52ae$export$dadc7b4b4811a4cd(input) {
    const { length: length } = input;
    const reader = new $810b57e15a8d52ae$var$StringReader(input);
    const ranges = [];
    const stack = [];
    let genLine = 0;
    let definitionSourcesIndex = 0;
    let definitionScopeIndex = 0;
    let callsiteSourcesIndex = 0;
    let callsiteLine = 0;
    let callsiteColumn = 0;
    let bindingLine = 0;
    let bindingColumn = 0;
    do {
        const semi = reader.indexOf(";");
        let genColumn = 0;
        for(; reader.pos < semi; reader.pos++){
            genColumn += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
            if (!$810b57e15a8d52ae$var$hasMoreVlq(reader, semi)) {
                const last = stack.pop();
                last[2] = genLine;
                last[3] = genColumn;
                continue;
            }
            const fields = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
            const hasDefinition = fields & 1;
            const hasCallsite = fields & 2;
            const hasScope = fields & 4;
            let callsite = null;
            let bindings = $810b57e15a8d52ae$var$EMPTY;
            let range;
            if (hasDefinition) {
                const defSourcesIndex = definitionSourcesIndex + $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                definitionScopeIndex = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader)) + (definitionSourcesIndex === defSourcesIndex ? definitionScopeIndex : 0);
                definitionSourcesIndex = defSourcesIndex;
                range = [
                    genLine,
                    genColumn,
                    0,
                    0,
                    defSourcesIndex,
                    definitionScopeIndex
                ];
            } else range = [
                genLine,
                genColumn,
                0,
                0
            ];
            range.isScope = !!hasScope;
            if (hasCallsite) {
                const prevCsi = callsiteSourcesIndex;
                const prevLine = callsiteLine;
                callsiteSourcesIndex += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                const sameSource = prevCsi === callsiteSourcesIndex;
                callsiteLine = (sameSource ? callsiteLine : 0) + $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                callsiteColumn = (sameSource && prevLine === callsiteLine ? callsiteColumn : 0) + $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                callsite = [
                    callsiteSourcesIndex,
                    callsiteLine,
                    callsiteColumn
                ];
            }
            range.callsite = callsite;
            if ($810b57e15a8d52ae$var$hasMoreVlq(reader, semi)) {
                bindings = [];
                do {
                    bindingLine = genLine;
                    bindingColumn = genColumn;
                    const expressionsCount = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                    let expressionRanges;
                    if (expressionsCount < -1) {
                        expressionRanges = [
                            [
                                $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader))
                            ]
                        ];
                        for(let i = -1; i > expressionsCount; i--){
                            const prevBl = bindingLine;
                            bindingLine += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                            bindingColumn = (bindingLine === prevBl ? bindingColumn : 0) + $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                            const expression = $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                            expressionRanges.push([
                                expression,
                                bindingLine,
                                bindingColumn
                            ]);
                        }
                    } else expressionRanges = [
                        [
                            expressionsCount
                        ]
                    ];
                    bindings.push(expressionRanges);
                }while ($810b57e15a8d52ae$var$hasMoreVlq(reader, semi));
            }
            range.bindings = bindings;
            ranges.push(range);
            stack.push(range);
        }
        genLine++;
        reader.pos = semi + 1;
    }while (reader.pos < length);
    return ranges;
}
function $810b57e15a8d52ae$export$8e469a859d564769(ranges) {
    if (ranges.length === 0) return "";
    const writer = new $810b57e15a8d52ae$var$StringWriter();
    for(let i = 0; i < ranges.length;)i = $810b57e15a8d52ae$var$_encodeGeneratedRanges(ranges, i, writer, [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    return writer.flush();
}
function $810b57e15a8d52ae$var$_encodeGeneratedRanges(ranges, index, writer, state) {
    const range = ranges[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, isScope: isScope, callsite: callsite, bindings: bindings } = range;
    if (state[0] < startLine) {
        $810b57e15a8d52ae$var$catchupLine(writer, state[0], startLine);
        state[0] = startLine;
        state[1] = 0;
    } else if (index > 0) writer.write($810b57e15a8d52ae$var$comma);
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(range[1] - state[1]));
    state[1] = range[1];
    const fields = (range.length === 6 ? 1 : 0) | (callsite ? 2 : 0) | (isScope ? 4 : 0);
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(fields));
    if (range.length === 6) {
        const { 4: sourcesIndex, 5: scopesIndex } = range;
        if (sourcesIndex !== state[2]) state[3] = 0;
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(sourcesIndex - state[2]));
        state[2] = sourcesIndex;
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(scopesIndex - state[3]));
        state[3] = scopesIndex;
    }
    if (callsite) {
        const { 0: sourcesIndex, 1: callLine, 2: callColumn } = range.callsite;
        if (sourcesIndex !== state[4]) {
            state[5] = 0;
            state[6] = 0;
        } else if (callLine !== state[5]) state[6] = 0;
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(sourcesIndex - state[4]));
        state[4] = sourcesIndex;
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(callLine - state[5]));
        state[5] = callLine;
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(callColumn - state[6]));
        state[6] = callColumn;
    }
    if (bindings) for (const binding of bindings){
        if (binding.length > 1) $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(-binding.length));
        const expression = binding[0][0];
        $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(expression));
        let bindingStartLine = startLine;
        let bindingStartColumn = startColumn;
        for(let i = 1; i < binding.length; i++){
            const expRange = binding[i];
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(expRange[1] - bindingStartLine));
            bindingStartLine = expRange[1];
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(expRange[2] - bindingStartColumn));
            bindingStartColumn = expRange[2];
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(expRange[0]));
        }
    }
    for(index++; index < ranges.length;){
        const next = ranges[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $810b57e15a8d52ae$var$_encodeGeneratedRanges(ranges, index, writer, state);
    }
    if (state[0] < endLine) {
        $810b57e15a8d52ae$var$catchupLine(writer, state[0], endLine);
        state[0] = endLine;
        state[1] = 0;
    } else writer.write($810b57e15a8d52ae$var$comma);
    $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(endColumn - state[1]));
    state[1] = endColumn;
    return index;
}
function $810b57e15a8d52ae$var$catchupLine(writer, lastLine, line) {
    do writer.write($810b57e15a8d52ae$var$semicolon);
    while (++lastLine < line);
}
// src/range-mappings.ts
function $810b57e15a8d52ae$export$5742e4021f8f952f(input) {
    const { length: length } = input;
    const reader = new $810b57e15a8d52ae$var$StringReader(input);
    const rangeMappings = [];
    do {
        const semi = reader.indexOf(";");
        const indices = [];
        let index = 0;
        while(reader.pos < semi){
            index += $810b57e15a8d52ae$var$decodeInteger(reader);
            indices.push(index);
        }
        rangeMappings.push(indices);
        reader.pos = semi + 1;
    }while (reader.pos <= length);
    return rangeMappings;
}
function $810b57e15a8d52ae$export$856d7758293238ee(decoded) {
    if (decoded.length === 0) return "";
    const writer = new $810b57e15a8d52ae$var$StringWriter();
    for(let i = 0; i < decoded.length; i++){
        const indices = decoded[i];
        if (i > 0) writer.write($810b57e15a8d52ae$var$semicolon);
        let index = 0;
        for(let j = 0; j < indices.length; j++){
            const offset = indices[j];
            $810b57e15a8d52ae$var$encodeInteger(writer, offset - index);
            index = offset;
        }
    }
    return writer.flush();
}
// src/sourcemap-codec.ts
function $810b57e15a8d52ae$export$2f872c0f2117be69(mappings) {
    const { length: length } = mappings;
    const reader = new $810b57e15a8d52ae$var$StringReader(mappings);
    const decoded = [];
    let genColumn = 0;
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    do {
        const semi = reader.indexOf(";");
        const line = [];
        let sorted = true;
        let lastCol = 0;
        genColumn = 0;
        while(reader.pos < semi){
            let seg;
            genColumn += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
            if (genColumn < lastCol) sorted = false;
            lastCol = genColumn;
            if ($810b57e15a8d52ae$var$hasMoreVlq(reader, semi)) {
                sourcesIndex += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                sourceLine += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                sourceColumn += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                if ($810b57e15a8d52ae$var$hasMoreVlq(reader, semi)) {
                    namesIndex += $810b57e15a8d52ae$var$decodeSign($810b57e15a8d52ae$var$decodeInteger(reader));
                    seg = [
                        genColumn,
                        sourcesIndex,
                        sourceLine,
                        sourceColumn,
                        namesIndex
                    ];
                } else seg = [
                    genColumn,
                    sourcesIndex,
                    sourceLine,
                    sourceColumn
                ];
            } else seg = [
                genColumn
            ];
            line.push(seg);
            reader.pos++;
        }
        if (!sorted) $810b57e15a8d52ae$var$sort(line);
        decoded.push(line);
        reader.pos = semi + 1;
    }while (reader.pos <= length);
    return decoded;
}
function $810b57e15a8d52ae$var$sort(line) {
    line.sort($810b57e15a8d52ae$var$sortComparator);
}
function $810b57e15a8d52ae$var$sortComparator(a, b) {
    return a[0] - b[0];
}
function $810b57e15a8d52ae$export$c564cdbbe6da493(decoded) {
    const writer = new $810b57e15a8d52ae$var$StringWriter();
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        if (i > 0) writer.write($810b57e15a8d52ae$var$semicolon);
        if (line.length === 0) continue;
        let genColumn = 0;
        for(let j = 0; j < line.length; j++){
            const segment = line[j];
            if (j > 0) writer.write($810b57e15a8d52ae$var$comma);
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(segment[0] - genColumn));
            genColumn = segment[0];
            if (segment.length === 1) continue;
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(segment[1] - sourcesIndex));
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(segment[2] - sourceLine));
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(segment[3] - sourceColumn));
            sourcesIndex = segment[1];
            sourceLine = segment[2];
            sourceColumn = segment[3];
            if (segment.length === 4) continue;
            $810b57e15a8d52ae$var$encodeInteger(writer, $810b57e15a8d52ae$var$encodeSign(segment[4] - namesIndex));
            namesIndex = segment[4];
        }
    }
    return writer.flush();
}


// src/trace-mapping.ts

var $26d1c6a7751473b9$exports = {};
(function(global, factory) {
    $26d1c6a7751473b9$exports = factory();
})($26d1c6a7751473b9$exports, function() {
    'use strict';
    // Matches the scheme of a URL, eg "http://"
    const schemeRegex = /^[\w+.-]+:\/\//;
    /**
     * Matches the parts of a URL:
     * 1. Scheme, including ":", guaranteed.
     * 2. User/password, including "@", optional.
     * 3. Host, guaranteed.
     * 4. Port, including ":", optional.
     * 5. Path, including "/", optional.
     * 6. Query, including "?", optional.
     * 7. Hash, including "#", optional.
     */ const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
    /**
     * File URLs are weird. They dont' need the regular `//` in the scheme, they may or may not start
     * with a leading `/`, they can have a domain (but only if they don't start with a Windows drive).
     *
     * 1. Host, optional.
     * 2. Path, which may include "/", guaranteed.
     * 3. Query, including "?", optional.
     * 4. Hash, including "#", optional.
     */ const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
    function isAbsoluteUrl(input) {
        return schemeRegex.test(input);
    }
    function isSchemeRelativeUrl(input) {
        return input.startsWith('//');
    }
    function isAbsolutePath(input) {
        return input.startsWith('/');
    }
    function isFileUrl(input) {
        return input.startsWith('file:');
    }
    function isRelative(input) {
        return /^[.?#]/.test(input);
    }
    function parseAbsoluteUrl(input) {
        const match = urlRegex.exec(input);
        return makeUrl(match[1], match[2] || '', match[3], match[4] || '', match[5] || '/', match[6] || '', match[7] || '');
    }
    function parseFileUrl(input) {
        const match = fileRegex.exec(input);
        const path = match[2];
        return makeUrl('file:', '', match[1] || '', '', isAbsolutePath(path) ? path : '/' + path, match[3] || '', match[4] || '');
    }
    function makeUrl(scheme, user, host, port, path, query, hash) {
        return {
            scheme: scheme,
            user: user,
            host: host,
            port: port,
            path: path,
            query: query,
            hash: hash,
            type: 7 /* Absolute */ 
        };
    }
    function parseUrl(input) {
        if (isSchemeRelativeUrl(input)) {
            const url = parseAbsoluteUrl('http:' + input);
            url.scheme = '';
            url.type = 6 /* SchemeRelative */ ;
            return url;
        }
        if (isAbsolutePath(input)) {
            const url = parseAbsoluteUrl('http://foo.com' + input);
            url.scheme = '';
            url.host = '';
            url.type = 5 /* AbsolutePath */ ;
            return url;
        }
        if (isFileUrl(input)) return parseFileUrl(input);
        if (isAbsoluteUrl(input)) return parseAbsoluteUrl(input);
        const url = parseAbsoluteUrl('http://foo.com/' + input);
        url.scheme = '';
        url.host = '';
        url.type = input ? input.startsWith('?') ? 3 /* Query */  : input.startsWith('#') ? 2 /* Hash */  : 4 /* RelativePath */  : 1 /* Empty */ ;
        return url;
    }
    function stripPathFilename(path) {
        // If a path ends with a parent directory "..", then it's a relative path with excess parent
        // paths. It's not a file, so we can't strip it.
        if (path.endsWith('/..')) return path;
        const index = path.lastIndexOf('/');
        return path.slice(0, index + 1);
    }
    function mergePaths(url, base) {
        normalizePath(base, base.type);
        // If the path is just a "/", then it was an empty path to begin with (remember, we're a relative
        // path).
        if (url.path === '/') url.path = base.path;
        else // Resolution happens relative to the base path's directory, not the file.
        url.path = stripPathFilename(base.path) + url.path;
    }
    /**
     * The path can have empty directories "//", unneeded parents "foo/..", or current directory
     * "foo/.". We need to normalize to a standard representation.
     */ function normalizePath(url, type) {
        const rel = type <= 4 /* RelativePath */ ;
        const pieces = url.path.split('/');
        // We need to preserve the first piece always, so that we output a leading slash. The item at
        // pieces[0] is an empty string.
        let pointer = 1;
        // Positive is the number of real directories we've output, used for popping a parent directory.
        // Eg, "foo/bar/.." will have a positive 2, and we can decrement to be left with just "foo".
        let positive = 0;
        // We need to keep a trailing slash if we encounter an empty directory (eg, splitting "foo/" will
        // generate `["foo", ""]` pieces). And, if we pop a parent directory. But once we encounter a
        // real directory, we won't need to append, unless the other conditions happen again.
        let addTrailingSlash = false;
        for(let i = 1; i < pieces.length; i++){
            const piece = pieces[i];
            // An empty directory, could be a trailing slash, or just a double "//" in the path.
            if (!piece) {
                addTrailingSlash = true;
                continue;
            }
            // If we encounter a real directory, then we don't need to append anymore.
            addTrailingSlash = false;
            // A current directory, which we can always drop.
            if (piece === '.') continue;
            // A parent directory, we need to see if there are any real directories we can pop. Else, we
            // have an excess of parents, and we'll need to keep the "..".
            if (piece === '..') {
                if (positive) {
                    addTrailingSlash = true;
                    positive--;
                    pointer--;
                } else if (rel) // If we're in a relativePath, then we need to keep the excess parents. Else, in an absolute
                // URL, protocol relative URL, or an absolute path, we don't need to keep excess.
                pieces[pointer++] = piece;
                continue;
            }
            // We've encountered a real directory. Move it to the next insertion pointer, which accounts for
            // any popped or dropped directories.
            pieces[pointer++] = piece;
            positive++;
        }
        let path = '';
        for(let i = 1; i < pointer; i++)path += '/' + pieces[i];
        if (!path || addTrailingSlash && !path.endsWith('/..')) path += '/';
        url.path = path;
    }
    /**
     * Attempts to resolve `input` URL/path relative to `base`.
     */ function resolve(input, base) {
        if (!input && !base) return '';
        const url = parseUrl(input);
        let inputType = url.type;
        if (base && inputType !== 7 /* Absolute */ ) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch(inputType){
                case 1 /* Empty */ :
                    url.hash = baseUrl.hash;
                // fall through
                case 2 /* Hash */ :
                    url.query = baseUrl.query;
                // fall through
                case 3 /* Query */ :
                case 4 /* RelativePath */ :
                    mergePaths(url, baseUrl);
                // fall through
                case 5 /* AbsolutePath */ :
                    // The host, user, and port are joined, you can't copy one without the others.
                    url.user = baseUrl.user;
                    url.host = baseUrl.host;
                    url.port = baseUrl.port;
                // fall through
                case 6 /* SchemeRelative */ :
                    // The input doesn't have a schema at least, so we need to copy at least that over.
                    url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType) inputType = baseType;
        }
        normalizePath(url, inputType);
        const queryHash = url.query + url.hash;
        switch(inputType){
            // This is impossible, because of the empty checks at the start of the function.
            // case UrlType.Empty:
            case 2 /* Hash */ :
            case 3 /* Query */ :
                return queryHash;
            case 4 /* RelativePath */ :
                {
                    // The first char is always a "/", and we need it to be relative.
                    const path = url.path.slice(1);
                    if (!path) return queryHash || '.';
                    if (isRelative(base || input) && !isRelative(path)) // If base started with a leading ".", or there is no base and input started with a ".",
                    // then we need to ensure that the relative path starts with a ".". We don't know if
                    // relative starts with a "..", though, so check before prepending.
                    return './' + path + queryHash;
                    return path + queryHash;
                }
            case 5 /* AbsolutePath */ :
                return url.path + queryHash;
            default:
                return url.scheme + '//' + url.user + url.host + url.port + url.path + queryHash;
        }
    }
    return resolve;
});


// src/strip-filename.ts
function $74992569aad6589c$var$stripFilename(path) {
    if (!path) return "";
    const index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
// src/resolve.ts
function $74992569aad6589c$var$resolver(mapUrl, sourceRoot) {
    const from = $74992569aad6589c$var$stripFilename(mapUrl);
    const prefix = sourceRoot ? sourceRoot + "/" : "";
    return (source)=>(0, (/*@__PURE__*/$parcel$interopDefault($26d1c6a7751473b9$exports)))(prefix + (source || ""), from);
}
// src/sourcemap-segment.ts
var $74992569aad6589c$var$COLUMN = 0;
var $74992569aad6589c$var$SOURCES_INDEX = 1;
var $74992569aad6589c$var$SOURCE_LINE = 2;
var $74992569aad6589c$var$SOURCE_COLUMN = 3;
var $74992569aad6589c$var$NAMES_INDEX = 4;
var $74992569aad6589c$var$REV_GENERATED_LINE = 1;
var $74992569aad6589c$var$REV_GENERATED_COLUMN = 2;
// src/sort.ts
function $74992569aad6589c$var$maybeSort(mappings, owned) {
    const unsortedIndex = $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, 0);
    if (unsortedIndex === mappings.length) return mappings;
    if (!owned) mappings = mappings.slice();
    for(let i = unsortedIndex; i < mappings.length; i = $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, i + 1))mappings[i] = $74992569aad6589c$var$sortSegments(mappings[i], owned);
    return mappings;
}
function $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, start) {
    for(let i = start; i < mappings.length; i++){
        if (!$74992569aad6589c$var$isSorted(mappings[i])) return i;
    }
    return mappings.length;
}
function $74992569aad6589c$var$isSorted(line) {
    for(let j = 1; j < line.length; j++){
        if (line[j][$74992569aad6589c$var$COLUMN] < line[j - 1][$74992569aad6589c$var$COLUMN]) return false;
    }
    return true;
}
function $74992569aad6589c$var$sortSegments(line, owned) {
    if (!owned) line = line.slice();
    return line.sort($74992569aad6589c$var$sortComparator);
}
function $74992569aad6589c$var$sortComparator(a, b) {
    return a[$74992569aad6589c$var$COLUMN] - b[$74992569aad6589c$var$COLUMN];
}
// src/by-source.ts
function $74992569aad6589c$var$buildBySources(decoded, memos) {
    const sources = memos.map(()=>[]);
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            if (seg.length === 1) continue;
            const sourceIndex2 = seg[$74992569aad6589c$var$SOURCES_INDEX];
            const sourceLine = seg[$74992569aad6589c$var$SOURCE_LINE];
            const sourceColumn = seg[$74992569aad6589c$var$SOURCE_COLUMN];
            const source = sources[sourceIndex2];
            const segs = source[sourceLine] || (source[sourceLine] = []);
            segs.push([
                sourceColumn,
                i,
                seg[$74992569aad6589c$var$COLUMN]
            ]);
        }
    }
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        for(let j = 0; j < source.length; j++){
            const line = source[j];
            if (line) line.sort($74992569aad6589c$var$sortComparator);
        }
    }
    return sources;
}
// src/binary-search.ts
var $74992569aad6589c$var$found = false;
function $74992569aad6589c$var$binarySearch(haystack, needle, low, high) {
    while(low <= high){
        const mid = low + (high - low >> 1);
        const cmp = haystack[mid][$74992569aad6589c$var$COLUMN] - needle;
        if (cmp === 0) {
            $74992569aad6589c$var$found = true;
            return mid;
        }
        if (cmp < 0) low = mid + 1;
        else high = mid - 1;
    }
    $74992569aad6589c$var$found = false;
    return low - 1;
}
function $74992569aad6589c$var$upperBound(haystack, needle, index) {
    for(let i = index + 1; i < haystack.length; index = i++){
        if (haystack[i][$74992569aad6589c$var$COLUMN] !== needle) break;
    }
    return index;
}
function $74992569aad6589c$var$lowerBound(haystack, needle, index) {
    for(let i = index - 1; i >= 0; index = i--){
        if (haystack[i][$74992569aad6589c$var$COLUMN] !== needle) break;
    }
    return index;
}
function $74992569aad6589c$var$memoizedState() {
    return {
        lastKey: -1,
        lastNeedle: -1,
        lastIndex: -1
    };
}
function $74992569aad6589c$var$memoizedBinarySearch(haystack, needle, state, key) {
    const { lastKey: lastKey, lastNeedle: lastNeedle, lastIndex: lastIndex } = state;
    let low = 0;
    let high = haystack.length - 1;
    if (key === lastKey) {
        if (needle === lastNeedle) {
            $74992569aad6589c$var$found = lastIndex !== -1 && haystack[lastIndex][$74992569aad6589c$var$COLUMN] === needle;
            return lastIndex;
        }
        if (needle >= lastNeedle) low = lastIndex === -1 ? 0 : lastIndex;
        else high = lastIndex;
    }
    state.lastKey = key;
    state.lastNeedle = needle;
    return state.lastIndex = $74992569aad6589c$var$binarySearch(haystack, needle, low, high);
}
// src/types.ts
function $74992569aad6589c$var$parse(map) {
    return typeof map === "string" ? JSON.parse(map) : map;
}
// src/flatten-map.ts
var $74992569aad6589c$export$cfb1ea40164567c5 = function(map, mapUrl) {
    const parsed = $74992569aad6589c$var$parse(map);
    if (!("sections" in parsed)) return new $74992569aad6589c$export$6fc8edf86512ec85(parsed, mapUrl);
    const mappings = [];
    const sources = [];
    const sourcesContent = [];
    const names = [];
    const ignoreList = [];
    $74992569aad6589c$var$recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, ignoreList, 0, 0, Infinity, Infinity);
    const joined = {
        version: 3,
        file: parsed.file,
        names: names,
        sources: sources,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList
    };
    return $74992569aad6589c$export$20ee0c4a5619bf3d(joined);
};
function $74992569aad6589c$var$recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const { sections: sections } = input;
    for(let i = 0; i < sections.length; i++){
        const { map: map, offset: offset } = sections[i];
        let sl = stopLine;
        let sc = stopColumn;
        if (i + 1 < sections.length) {
            const nextOffset = sections[i + 1].offset;
            sl = Math.min(stopLine, lineOffset + nextOffset.line);
            if (sl === stopLine) sc = Math.min(stopColumn, columnOffset + nextOffset.column);
            else if (sl < stopLine) sc = columnOffset + nextOffset.column;
        }
        $74992569aad6589c$var$addSection(map, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
    }
}
function $74992569aad6589c$var$addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const parsed = $74992569aad6589c$var$parse(input);
    if ("sections" in parsed) return $74992569aad6589c$var$recurse(...arguments);
    const map = new $74992569aad6589c$export$6fc8edf86512ec85(parsed, mapUrl);
    const sourcesOffset = sources.length;
    const namesOffset = names.length;
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    const { resolvedSources: resolvedSources, sourcesContent: contents, ignoreList: ignores } = map;
    $74992569aad6589c$var$append(sources, resolvedSources);
    $74992569aad6589c$var$append(names, map.names);
    if (contents) $74992569aad6589c$var$append(sourcesContent, contents);
    else for(let i = 0; i < resolvedSources.length; i++)sourcesContent.push(null);
    if (ignores) for(let i = 0; i < ignores.length; i++)ignoreList.push(ignores[i] + sourcesOffset);
    for(let i = 0; i < decoded.length; i++){
        const lineI = lineOffset + i;
        if (lineI > stopLine) return;
        const out = $74992569aad6589c$var$getLine(mappings, lineI);
        const cOffset = i === 0 ? columnOffset : 0;
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const column = cOffset + seg[$74992569aad6589c$var$COLUMN];
            if (lineI === stopLine && column >= stopColumn) return;
            if (seg.length === 1) {
                out.push([
                    column
                ]);
                continue;
            }
            const sourcesIndex = sourcesOffset + seg[$74992569aad6589c$var$SOURCES_INDEX];
            const sourceLine = seg[$74992569aad6589c$var$SOURCE_LINE];
            const sourceColumn = seg[$74992569aad6589c$var$SOURCE_COLUMN];
            out.push(seg.length === 4 ? [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn
            ] : [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn,
                namesOffset + seg[$74992569aad6589c$var$NAMES_INDEX]
            ]);
        }
    }
}
function $74992569aad6589c$var$append(arr, other) {
    for(let i = 0; i < other.length; i++)arr.push(other[i]);
}
function $74992569aad6589c$var$getLine(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
// src/trace-mapping.ts
var $74992569aad6589c$var$LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
var $74992569aad6589c$var$COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
var $74992569aad6589c$export$b99fbecff261243 = -1;
var $74992569aad6589c$export$4ecd616dce182dff = 1;
var $74992569aad6589c$export$6fc8edf86512ec85 = class {
    constructor(map, mapUrl){
        const isString = typeof map === "string";
        if (!isString && map._decodedMemo) return map;
        const parsed = $74992569aad6589c$var$parse(map);
        const { version: version, file: file, names: names, sourceRoot: sourceRoot, sources: sources, sourcesContent: sourcesContent } = parsed;
        this.version = version;
        this.file = file;
        this.names = names || [];
        this.sourceRoot = sourceRoot;
        this.sources = sources;
        this.sourcesContent = sourcesContent;
        this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || void 0;
        const resolve = $74992569aad6589c$var$resolver(mapUrl, sourceRoot);
        this.resolvedSources = sources.map(resolve);
        const { mappings: mappings } = parsed;
        if (typeof mappings === "string") {
            this._encoded = mappings;
            this._decoded = void 0;
        } else if (Array.isArray(mappings)) {
            this._encoded = void 0;
            this._decoded = $74992569aad6589c$var$maybeSort(mappings, isString);
        } else if (parsed.sections) throw new Error(`TraceMap passed sectioned source map, please use FlattenMap export instead`);
        else throw new Error(`invalid source map: ${JSON.stringify(parsed)}`);
        this._decodedMemo = $74992569aad6589c$var$memoizedState();
        this._bySources = void 0;
        this._bySourceMemos = void 0;
    }
};
function $74992569aad6589c$var$cast(map) {
    return map;
}
function $74992569aad6589c$export$59408758bba4b625(map) {
    var _a, _b;
    return (_b = (_a = $74992569aad6589c$var$cast(map))._encoded) != null ? _b : _a._encoded = (0, $810b57e15a8d52ae$export$c564cdbbe6da493)($74992569aad6589c$var$cast(map)._decoded);
}
function $74992569aad6589c$export$ecd113d4f34af700(map) {
    var _a;
    return (_a = $74992569aad6589c$var$cast(map))._decoded || (_a._decoded = (0, $810b57e15a8d52ae$export$2f872c0f2117be69)($74992569aad6589c$var$cast(map)._encoded));
}
function $74992569aad6589c$export$6d863e58cd035563(map, line, column) {
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return null;
    const segments = decoded[line];
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, $74992569aad6589c$var$cast(map)._decodedMemo, line, column, $74992569aad6589c$export$4ecd616dce182dff);
    return index === -1 ? null : segments[index];
}
function $74992569aad6589c$export$56d62ac80d274c78(map, needle) {
    let { line: line, column: column, bias: bias } = needle;
    line--;
    if (line < 0) throw new Error($74992569aad6589c$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($74992569aad6589c$var$COL_GTR_EQ_ZERO);
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const segments = decoded[line];
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, $74992569aad6589c$var$cast(map)._decodedMemo, line, column, bias || $74992569aad6589c$export$4ecd616dce182dff);
    if (index === -1) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const segment = segments[index];
    if (segment.length === 1) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const { names: names, resolvedSources: resolvedSources } = map;
    return $74992569aad6589c$var$OMapping(resolvedSources[segment[$74992569aad6589c$var$SOURCES_INDEX]], segment[$74992569aad6589c$var$SOURCE_LINE] + 1, segment[$74992569aad6589c$var$SOURCE_COLUMN], segment.length === 5 ? names[segment[$74992569aad6589c$var$NAMES_INDEX]] : null);
}
function $74992569aad6589c$export$5bf80d5312a8ff17(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $74992569aad6589c$var$generatedPosition(map, source, line, column, bias || $74992569aad6589c$export$4ecd616dce182dff, false);
}
function $74992569aad6589c$export$69d37f329d319dca(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $74992569aad6589c$var$generatedPosition(map, source, line, column, bias || $74992569aad6589c$export$b99fbecff261243, true);
}
function $74992569aad6589c$export$78c99866f56beaa4(map, cb) {
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    const { names: names, resolvedSources: resolvedSources } = map;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generatedLine = i + 1;
            const generatedColumn = seg[0];
            let source = null;
            let originalLine = null;
            let originalColumn = null;
            let name = null;
            if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
            }
            if (seg.length === 5) name = names[seg[4]];
            cb({
                generatedLine: generatedLine,
                generatedColumn: generatedColumn,
                source: source,
                originalLine: originalLine,
                originalColumn: originalColumn,
                name: name
            });
        }
    }
}
function $74992569aad6589c$var$sourceIndex(map, source) {
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let index = sources.indexOf(source);
    if (index === -1) index = resolvedSources.indexOf(source);
    return index;
}
function $74992569aad6589c$export$a685fd8184719fc9(map, source) {
    const { sourcesContent: sourcesContent } = map;
    if (sourcesContent == null) return null;
    const index = $74992569aad6589c$var$sourceIndex(map, source);
    return index === -1 ? null : sourcesContent[index];
}
function $74992569aad6589c$export$ac3f691269cd6d9b(map, source) {
    const { ignoreList: ignoreList } = map;
    if (ignoreList == null) return false;
    const index = $74992569aad6589c$var$sourceIndex(map, source);
    return index === -1 ? false : ignoreList.includes(index);
}
function $74992569aad6589c$export$20ee0c4a5619bf3d(map, mapUrl) {
    const tracer = new $74992569aad6589c$export$6fc8edf86512ec85($74992569aad6589c$var$clone(map, []), mapUrl);
    $74992569aad6589c$var$cast(tracer)._decoded = map.mappings;
    return tracer;
}
function $74992569aad6589c$export$f6477d963c19e792(map) {
    return $74992569aad6589c$var$clone(map, $74992569aad6589c$export$ecd113d4f34af700(map));
}
function $74992569aad6589c$export$f859692979919a94(map) {
    return $74992569aad6589c$var$clone(map, $74992569aad6589c$export$59408758bba4b625(map));
}
function $74992569aad6589c$var$clone(map, mappings) {
    return {
        version: map.version,
        file: map.file,
        names: map.names,
        sourceRoot: map.sourceRoot,
        sources: map.sources,
        sourcesContent: map.sourcesContent,
        mappings: mappings,
        ignoreList: map.ignoreList || map.x_google_ignoreList
    };
}
function $74992569aad6589c$var$OMapping(source, line, column, name) {
    return {
        source: source,
        line: line,
        column: column,
        name: name
    };
}
function $74992569aad6589c$var$GMapping(line, column) {
    return {
        line: line,
        column: column
    };
}
function $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, bias) {
    let index = $74992569aad6589c$var$memoizedBinarySearch(segments, column, memo, line);
    if ($74992569aad6589c$var$found) index = (bias === $74992569aad6589c$export$b99fbecff261243 ? $74992569aad6589c$var$upperBound : $74992569aad6589c$var$lowerBound)(segments, column, index);
    else if (bias === $74992569aad6589c$export$b99fbecff261243) index++;
    if (index === -1 || index === segments.length) return -1;
    return index;
}
function $74992569aad6589c$var$sliceGeneratedPositions(segments, memo, line, column, bias) {
    let min = $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, $74992569aad6589c$export$4ecd616dce182dff);
    if (!$74992569aad6589c$var$found && bias === $74992569aad6589c$export$b99fbecff261243) min++;
    if (min === -1 || min === segments.length) return [];
    const matchedColumn = $74992569aad6589c$var$found ? column : segments[min][$74992569aad6589c$var$COLUMN];
    if (!$74992569aad6589c$var$found) min = $74992569aad6589c$var$lowerBound(segments, matchedColumn, min);
    const max = $74992569aad6589c$var$upperBound(segments, matchedColumn, min);
    const result = [];
    for(; min <= max; min++){
        const segment = segments[min];
        result.push($74992569aad6589c$var$GMapping(segment[$74992569aad6589c$var$REV_GENERATED_LINE] + 1, segment[$74992569aad6589c$var$REV_GENERATED_COLUMN]));
    }
    return result;
}
function $74992569aad6589c$var$generatedPosition(map, source, line, column, bias, all) {
    var _a, _b;
    line--;
    if (line < 0) throw new Error($74992569aad6589c$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($74992569aad6589c$var$COL_GTR_EQ_ZERO);
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let sourceIndex2 = sources.indexOf(source);
    if (sourceIndex2 === -1) sourceIndex2 = resolvedSources.indexOf(source);
    if (sourceIndex2 === -1) return all ? [] : $74992569aad6589c$var$GMapping(null, null);
    const bySourceMemos = (_a = $74992569aad6589c$var$cast(map))._bySourceMemos || (_a._bySourceMemos = sources.map($74992569aad6589c$var$memoizedState));
    const generated = (_b = $74992569aad6589c$var$cast(map))._bySources || (_b._bySources = $74992569aad6589c$var$buildBySources($74992569aad6589c$export$ecd113d4f34af700(map), bySourceMemos));
    const segments = generated[sourceIndex2][line];
    if (segments == null) return all ? [] : $74992569aad6589c$var$GMapping(null, null);
    const memo = bySourceMemos[sourceIndex2];
    if (all) return $74992569aad6589c$var$sliceGeneratedPositions(segments, memo, line, column, bias);
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, bias);
    if (index === -1) return $74992569aad6589c$var$GMapping(null, null);
    const segment = segments[index];
    return $74992569aad6589c$var$GMapping(segment[$74992569aad6589c$var$REV_GENERATED_LINE] + 1, segment[$74992569aad6589c$var$REV_GENERATED_COLUMN]);
}


var $73f253113ca9cfeb$var$SetArray = class {
    constructor(){
        this._indexes = {
            __proto__: null
        };
        this.array = [];
    }
};
function $73f253113ca9cfeb$var$cast(set) {
    return set;
}
function $73f253113ca9cfeb$var$get(setarr, key) {
    return $73f253113ca9cfeb$var$cast(setarr)._indexes[key];
}
function $73f253113ca9cfeb$var$put(setarr, key) {
    const index = $73f253113ca9cfeb$var$get(setarr, key);
    if (index !== void 0) return index;
    const { array: array, _indexes: indexes } = $73f253113ca9cfeb$var$cast(setarr);
    const length = array.push(key);
    return indexes[key] = length - 1;
}
function $73f253113ca9cfeb$var$remove(setarr, key) {
    const index = $73f253113ca9cfeb$var$get(setarr, key);
    if (index === void 0) return;
    const { array: array, _indexes: indexes } = $73f253113ca9cfeb$var$cast(setarr);
    for(let i = index + 1; i < array.length; i++){
        const k = array[i];
        array[i - 1] = k;
        indexes[k]--;
    }
    indexes[key] = void 0;
    array.pop();
}
// src/sourcemap-segment.ts
var $73f253113ca9cfeb$var$COLUMN = 0;
var $73f253113ca9cfeb$var$SOURCES_INDEX = 1;
var $73f253113ca9cfeb$var$SOURCE_LINE = 2;
var $73f253113ca9cfeb$var$SOURCE_COLUMN = 3;
var $73f253113ca9cfeb$var$NAMES_INDEX = 4;
// src/gen-mapping.ts
var $73f253113ca9cfeb$var$NO_NAME = -1;
var $73f253113ca9cfeb$export$92fb4a3d57ca7ec = class {
    constructor({ file: file, sourceRoot: sourceRoot } = {}){
        this._names = new $73f253113ca9cfeb$var$SetArray();
        this._sources = new $73f253113ca9cfeb$var$SetArray();
        this._sourcesContent = [];
        this._mappings = [];
        this.file = file;
        this.sourceRoot = sourceRoot;
        this._ignoreList = new $73f253113ca9cfeb$var$SetArray();
    }
};
function $73f253113ca9cfeb$var$cast2(map) {
    return map;
}
function $73f253113ca9cfeb$export$1c43f9ac826b6462(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $73f253113ca9cfeb$var$addSegmentInternal(false, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
}
function $73f253113ca9cfeb$export$2d9a54e47969bead(map, mapping) {
    return $73f253113ca9cfeb$var$addMappingInternal(false, map, mapping);
}
var $73f253113ca9cfeb$export$bffbcf5bdbbd3679 = (map, genLine, genColumn, source, sourceLine, sourceColumn, name, content)=>{
    return $73f253113ca9cfeb$var$addSegmentInternal(true, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
};
var $73f253113ca9cfeb$export$6623d26b0c62901b = (map, mapping)=>{
    return $73f253113ca9cfeb$var$addMappingInternal(true, map, mapping);
};
function $73f253113ca9cfeb$export$c6155c9e474ba16b(map, source, content) {
    const { _sources: sources, _sourcesContent: sourcesContent } = $73f253113ca9cfeb$var$cast2(map);
    const index = $73f253113ca9cfeb$var$put(sources, source);
    sourcesContent[index] = content;
}
function $73f253113ca9cfeb$export$6db5baaf5ada6795(map, source, ignore = true) {
    const { _sources: sources, _sourcesContent: sourcesContent, _ignoreList: ignoreList } = $73f253113ca9cfeb$var$cast2(map);
    const index = $73f253113ca9cfeb$var$put(sources, source);
    if (index === sourcesContent.length) sourcesContent[index] = null;
    if (ignore) $73f253113ca9cfeb$var$put(ignoreList, index);
    else $73f253113ca9cfeb$var$remove(ignoreList, index);
}
function $73f253113ca9cfeb$export$74ae13ad22f29c85(map) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names, _ignoreList: ignoreList } = $73f253113ca9cfeb$var$cast2(map);
    $73f253113ca9cfeb$var$removeEmptyFinalLines(mappings);
    return {
        version: 3,
        file: map.file || void 0,
        names: names.array,
        sourceRoot: map.sourceRoot || void 0,
        sources: sources.array,
        sourcesContent: sourcesContent,
        mappings: mappings,
        // originalScopes,
        // generatedRanges,
        ignoreList: ignoreList.array
    };
}
function $73f253113ca9cfeb$export$da8de8cfd71f671a(map) {
    const decoded = $73f253113ca9cfeb$export$74ae13ad22f29c85(map);
    return Object.assign({}, decoded, {
        // originalScopes: decoded.originalScopes.map((os) => encodeOriginalScopes(os)),
        // generatedRanges: encodeGeneratedRanges(decoded.generatedRanges as GeneratedRange[]),
        mappings: (0, $810b57e15a8d52ae$export$c564cdbbe6da493)(decoded.mappings)
    });
}
function $73f253113ca9cfeb$export$d81aa96f14f987cc(input) {
    const map = new (0, $74992569aad6589c$export$6fc8edf86512ec85)(input);
    const gen = new $73f253113ca9cfeb$export$92fb4a3d57ca7ec({
        file: map.file,
        sourceRoot: map.sourceRoot
    });
    $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._names, map.names);
    $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._sources, map.sources);
    $73f253113ca9cfeb$var$cast2(gen)._sourcesContent = map.sourcesContent || map.sources.map(()=>null);
    $73f253113ca9cfeb$var$cast2(gen)._mappings = (0, $74992569aad6589c$export$ecd113d4f34af700)(map);
    if (map.ignoreList) $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._ignoreList, map.ignoreList);
    return gen;
}
function $73f253113ca9cfeb$export$f06617c6577f8fbd(map) {
    const out = [];
    const { _mappings: mappings, _sources: sources, _names: names } = $73f253113ca9cfeb$var$cast2(map);
    for(let i = 0; i < mappings.length; i++){
        const line = mappings[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generated = {
                line: i + 1,
                column: seg[$73f253113ca9cfeb$var$COLUMN]
            };
            let source = void 0;
            let original = void 0;
            let name = void 0;
            if (seg.length !== 1) {
                source = sources.array[seg[$73f253113ca9cfeb$var$SOURCES_INDEX]];
                original = {
                    line: seg[$73f253113ca9cfeb$var$SOURCE_LINE] + 1,
                    column: seg[$73f253113ca9cfeb$var$SOURCE_COLUMN]
                };
                if (seg.length === 5) name = names.array[seg[$73f253113ca9cfeb$var$NAMES_INDEX]];
            }
            out.push({
                generated: generated,
                source: source,
                original: original,
                name: name
            });
        }
    }
    return out;
}
function $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = $73f253113ca9cfeb$var$cast2(map);
    const line = $73f253113ca9cfeb$var$getIndex(mappings, genLine);
    const index = $73f253113ca9cfeb$var$getColumnIndex(line, genColumn);
    if (!source) {
        if (skipable && $73f253113ca9cfeb$var$skipSourceless(line, index)) return;
        return $73f253113ca9cfeb$var$insert(line, index, [
            genColumn
        ]);
    }
    $73f253113ca9cfeb$var$assert(sourceLine);
    $73f253113ca9cfeb$var$assert(sourceColumn);
    const sourcesIndex = $73f253113ca9cfeb$var$put(sources, source);
    const namesIndex = name ? $73f253113ca9cfeb$var$put(names, name) : $73f253113ca9cfeb$var$NO_NAME;
    if (sourcesIndex === sourcesContent.length) sourcesContent[sourcesIndex] = content != null ? content : null;
    if (skipable && $73f253113ca9cfeb$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) return;
    return $73f253113ca9cfeb$var$insert(line, index, name ? [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn,
        namesIndex
    ] : [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn
    ]);
}
function $73f253113ca9cfeb$var$assert(_val) {}
function $73f253113ca9cfeb$var$getIndex(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
function $73f253113ca9cfeb$var$getColumnIndex(line, genColumn) {
    let index = line.length;
    for(let i = index - 1; i >= 0; index = i--){
        const current = line[i];
        if (genColumn >= current[$73f253113ca9cfeb$var$COLUMN]) break;
    }
    return index;
}
function $73f253113ca9cfeb$var$insert(array, index, value) {
    for(let i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
function $73f253113ca9cfeb$var$removeEmptyFinalLines(mappings) {
    const { length: length } = mappings;
    let len = length;
    for(let i = len - 1; i >= 0; len = i, i--){
        if (mappings[i].length > 0) break;
    }
    if (len < length) mappings.length = len;
}
function $73f253113ca9cfeb$var$putAll(setarr, array) {
    for(let i = 0; i < array.length; i++)$73f253113ca9cfeb$var$put(setarr, array[i]);
}
function $73f253113ca9cfeb$var$skipSourceless(line, index) {
    if (index === 0) return true;
    const prev = line[index - 1];
    return prev.length === 1;
}
function $73f253113ca9cfeb$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
    if (index === 0) return false;
    const prev = line[index - 1];
    if (prev.length === 1) return false;
    return sourcesIndex === prev[$73f253113ca9cfeb$var$SOURCES_INDEX] && sourceLine === prev[$73f253113ca9cfeb$var$SOURCE_LINE] && sourceColumn === prev[$73f253113ca9cfeb$var$SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[$73f253113ca9cfeb$var$NAMES_INDEX] : $73f253113ca9cfeb$var$NO_NAME);
}
function $73f253113ca9cfeb$var$addMappingInternal(skipable, map, mapping) {
    const { generated: generated, source: source, original: original, name: name, content: content } = mapping;
    if (!source) return $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, null, null, null, null, null);
    $73f253113ca9cfeb$var$assert(original);
    return $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, source, original.line - 1, original.column, name, content);
}



function $983df390ff0493b7$export$2e2bcd8739ae039({ code: generatedCode, mappings: rawMappings }, filePath, options, source, tokens) {
    const sourceColumns = $983df390ff0493b7$var$computeSourceColumns(source, tokens);
    const map = new (0, $73f253113ca9cfeb$export$92fb4a3d57ca7ec)({
        file: options.compiledFilename
    });
    let tokenIndex = 0;
    // currentMapping is the output source index for the current input token being
    // considered.
    let currentMapping = rawMappings[0];
    while(currentMapping === undefined && tokenIndex < rawMappings.length - 1){
        tokenIndex++;
        currentMapping = rawMappings[tokenIndex];
    }
    let line = 0;
    let lineStart = 0;
    if (currentMapping !== lineStart) (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
    for(let i = 0; i < generatedCode.length; i++){
        if (i === currentMapping) {
            const genColumn = currentMapping - lineStart;
            const sourceColumn = sourceColumns[tokenIndex];
            (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, genColumn, filePath, line, sourceColumn);
            while((currentMapping === i || currentMapping === undefined) && tokenIndex < rawMappings.length - 1){
                tokenIndex++;
                currentMapping = rawMappings[tokenIndex];
            }
        }
        if (generatedCode.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) {
            line++;
            lineStart = i + 1;
            if (currentMapping !== lineStart) (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
        }
    }
    const { sourceRoot: sourceRoot, sourcesContent: sourcesContent, ...sourceMap } = (0, $73f253113ca9cfeb$export$da8de8cfd71f671a)(map);
    return sourceMap;
}
/**
 * Create an array mapping each token index to the 0-based column of the start
 * position of the token.
 */ function $983df390ff0493b7$var$computeSourceColumns(code, tokens) {
    const sourceColumns = new Array(tokens.length);
    let tokenIndex = 0;
    let currentMapping = tokens[tokenIndex].start;
    let lineStart = 0;
    for(let i = 0; i < code.length; i++){
        if (i === currentMapping) {
            sourceColumns[tokenIndex] = currentMapping - lineStart;
            tokenIndex++;
            currentMapping = tokens[tokenIndex].start;
        }
        if (code.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) lineStart = i + 1;
    }
    return sourceColumns;
}


const $1425b7397a2936d9$var$HELPERS = {
    require: `
    import {createRequire as CREATE_REQUIRE_NAME} from "module";
    const require = CREATE_REQUIRE_NAME(import.meta.url);
  `,
    interopRequireWildcard: `
    function interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              newObj[key] = obj[key];
            }
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
  `,
    interopRequireDefault: `
    function interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
  `,
    createNamedExportFrom: `
    function createNamedExportFrom(obj, localName, importedName) {
      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});
    }
  `,
    // Note that TypeScript and Babel do this differently; TypeScript does a simple existence
    // check in the exports object and does a plain assignment, whereas Babel uses
    // defineProperty and builds an object of explicitly-exported names so that star exports can
    // always take lower precedence. For now, we do the easier TypeScript thing.
    createStarExport: `
    function createStarExport(obj) {
      Object.keys(obj)
        .filter((key) => key !== "default" && key !== "__esModule")
        .forEach((key) => {
          if (exports.hasOwnProperty(key)) {
            return;
          }
          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});
        });
    }
  `,
    nullishCoalesce: `
    function nullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return rhsFn();
      }
    }
  `,
    asyncNullishCoalesce: `
    async function asyncNullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return await rhsFn();
      }
    }
  `,
    optionalChain: `
    function optionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    asyncOptionalChain: `
    async function asyncOptionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = await fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = await fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    optionalChainDelete: `
    function optionalChainDelete(ops) {
      const result = OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `,
    asyncOptionalChainDelete: `
    async function asyncOptionalChainDelete(ops) {
      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `
};
class $1425b7397a2936d9$export$b203ad16abdeb845 {
    __init() {
        this.helperNames = {};
    }
    __init2() {
        this.createRequireName = null;
    }
    constructor(nameManager){
        this.nameManager = nameManager;
        $1425b7397a2936d9$export$b203ad16abdeb845.prototype.__init.call(this);
        $1425b7397a2936d9$export$b203ad16abdeb845.prototype.__init2.call(this);
    }
    getHelperName(baseName) {
        let helperName = this.helperNames[baseName];
        if (helperName) return helperName;
        helperName = this.nameManager.claimFreeName(`_${baseName}`);
        this.helperNames[baseName] = helperName;
        return helperName;
    }
    emitHelpers() {
        let resultCode = "";
        if (this.helperNames.optionalChainDelete) this.getHelperName("optionalChain");
        if (this.helperNames.asyncOptionalChainDelete) this.getHelperName("asyncOptionalChain");
        for (const [baseName, helperCodeTemplate] of Object.entries($1425b7397a2936d9$var$HELPERS)){
            const helperName = this.helperNames[baseName];
            let helperCode = helperCodeTemplate;
            if (baseName === "optionalChainDelete") helperCode = helperCode.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain);
            else if (baseName === "asyncOptionalChainDelete") helperCode = helperCode.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain);
            else if (baseName === "require") {
                if (this.createRequireName === null) this.createRequireName = this.nameManager.claimFreeName("_createRequire");
                helperCode = helperCode.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName);
            }
            if (helperName) {
                resultCode += " ";
                resultCode += helperCode.replace(baseName, helperName).replace(/\s+/g, " ").trim();
            }
        }
        return resultCode;
    }
}




function $e17888755afee10f$export$2e2bcd8739ae039(tokens, scopes, globalNames) {
    if (!$e17888755afee10f$export$c1aa0d0852b733f5(tokens, globalNames)) return;
    $e17888755afee10f$var$markShadowedGlobals(tokens, scopes, globalNames);
}
function $e17888755afee10f$export$c1aa0d0852b733f5(tokens, globalNames) {
    for (const token of tokens.tokens){
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && !token.isType && (0, $19e70491d10f11e8$export$268f8ae8b035d918)(token) && globalNames.has(tokens.identifierNameForToken(token))) return true;
    }
    return false;
}
function $e17888755afee10f$var$markShadowedGlobals(tokens, scopes, globalNames) {
    const scopeStack = [];
    let scopeIndex = scopes.length - 1;
    // Scopes were generated at completion time, so they're sorted by end index, so we can maintain a
    // good stack by going backwards through them.
    for(let i = tokens.tokens.length - 1;; i--){
        while(scopeStack.length > 0 && scopeStack[scopeStack.length - 1].startTokenIndex === i + 1)scopeStack.pop();
        while(scopeIndex >= 0 && scopes[scopeIndex].endTokenIndex === i + 1){
            scopeStack.push(scopes[scopeIndex]);
            scopeIndex--;
        }
        // Process scopes after the last iteration so we can make sure we pop all of them.
        if (i < 0) break;
        const token = tokens.tokens[i];
        const name = tokens.identifierNameForToken(token);
        if (scopeStack.length > 1 && !token.isType && token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && globalNames.has(name)) {
            if ((0, $19e70491d10f11e8$export$6aae06a56367d123)(token)) $e17888755afee10f$var$markShadowedForScope(scopeStack[scopeStack.length - 1], tokens, name);
            else if ((0, $19e70491d10f11e8$export$157aa1605fc4e080)(token)) {
                let stackIndex = scopeStack.length - 1;
                while(stackIndex > 0 && !scopeStack[stackIndex].isFunctionScope)stackIndex--;
                if (stackIndex < 0) throw new Error("Did not find parent function scope.");
                $e17888755afee10f$var$markShadowedForScope(scopeStack[stackIndex], tokens, name);
            }
        }
    }
    if (scopeStack.length > 0) throw new Error("Expected empty scope stack after processing file.");
}
function $e17888755afee10f$var$markShadowedForScope(scope, tokens, name) {
    for(let i = scope.startTokenIndex; i < scope.endTokenIndex; i++){
        const token = tokens.tokens[i];
        if ((token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && tokens.identifierNameForToken(token) === name) token.shadowsGlobal = true;
    }
}



function $9e197115f5256153$export$2e2bcd8739ae039(code, tokens) {
    const names = [];
    for (const token of tokens)if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) names.push(code.slice(token.start, token.end));
    return names;
}


class $98ad476c234688bb$export$2e2bcd8739ae039 {
    __init() {
        this.usedNames = new Set();
    }
    constructor(code, tokens){
        $98ad476c234688bb$export$2e2bcd8739ae039.prototype.__init.call(this);
        this.usedNames = new Set((0, $9e197115f5256153$export$2e2bcd8739ae039)(code, tokens));
    }
    claimFreeName(name) {
        const newName = this.findFreeName(name);
        this.usedNames.add(newName);
        return newName;
    }
    findFreeName(name) {
        if (!this.usedNames.has(name)) return name;
        let suffixNum = 2;
        while(this.usedNames.has(name + String(suffixNum)))suffixNum++;
        return name + String(suffixNum);
    }
}


var $f5315ec19a67585e$exports = {};
"use strict";
var $f5315ec19a67585e$var$__spreadArrays = $f5315ec19a67585e$exports && $f5315ec19a67585e$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($f5315ec19a67585e$exports, "__esModule", {
    value: true
});
$f5315ec19a67585e$exports.Checker = $f5315ec19a67585e$exports.createCheckers = void 0;

var $i143t = parcelRequire("i143t");

var $d3AJN = parcelRequire("d3AJN");

var $i143t = parcelRequire("i143t");
Object.defineProperty($f5315ec19a67585e$exports, "TArray", {
    enumerable: true,
    get: function() {
        return $i143t.TArray;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TEnumType", {
    enumerable: true,
    get: function() {
        return $i143t.TEnumType;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TEnumLiteral", {
    enumerable: true,
    get: function() {
        return $i143t.TEnumLiteral;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TFunc", {
    enumerable: true,
    get: function() {
        return $i143t.TFunc;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TIface", {
    enumerable: true,
    get: function() {
        return $i143t.TIface;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TLiteral", {
    enumerable: true,
    get: function() {
        return $i143t.TLiteral;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TName", {
    enumerable: true,
    get: function() {
        return $i143t.TName;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TOptional", {
    enumerable: true,
    get: function() {
        return $i143t.TOptional;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TParam", {
    enumerable: true,
    get: function() {
        return $i143t.TParam;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TParamList", {
    enumerable: true,
    get: function() {
        return $i143t.TParamList;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TProp", {
    enumerable: true,
    get: function() {
        return $i143t.TProp;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TTuple", {
    enumerable: true,
    get: function() {
        return $i143t.TTuple;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TType", {
    enumerable: true,
    get: function() {
        return $i143t.TType;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TUnion", {
    enumerable: true,
    get: function() {
        return $i143t.TUnion;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TIntersection", {
    enumerable: true,
    get: function() {
        return $i143t.TIntersection;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "array", {
    enumerable: true,
    get: function() {
        return $i143t.array;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "enumlit", {
    enumerable: true,
    get: function() {
        return $i143t.enumlit;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "enumtype", {
    enumerable: true,
    get: function() {
        return $i143t.enumtype;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "func", {
    enumerable: true,
    get: function() {
        return $i143t.func;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "iface", {
    enumerable: true,
    get: function() {
        return $i143t.iface;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "lit", {
    enumerable: true,
    get: function() {
        return $i143t.lit;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "name", {
    enumerable: true,
    get: function() {
        return $i143t.name;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "opt", {
    enumerable: true,
    get: function() {
        return $i143t.opt;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "param", {
    enumerable: true,
    get: function() {
        return $i143t.param;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "tuple", {
    enumerable: true,
    get: function() {
        return $i143t.tuple;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "union", {
    enumerable: true,
    get: function() {
        return $i143t.union;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "intersection", {
    enumerable: true,
    get: function() {
        return $i143t.intersection;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "BasicType", {
    enumerable: true,
    get: function() {
        return $i143t.BasicType;
    }
});

var $d3AJN = parcelRequire("d3AJN");
Object.defineProperty($f5315ec19a67585e$exports, "VError", {
    enumerable: true,
    get: function() {
        return $d3AJN.VError;
    }
});
/**
 * Takes one of more type suites (e.g. a module generated by `ts-interface-builder`), and combines
 * them into a suite of interface checkers. If a type is used by name, that name should be present
 * among the passed-in type suites.
 *
 * The returned object maps type names to Checker objects.
 */ function $f5315ec19a67585e$var$createCheckers() {
    var typeSuite = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSuite[_i] = arguments[_i];
    var fullSuite = Object.assign.apply(Object, $f5315ec19a67585e$var$__spreadArrays([
        {},
        $i143t.basicTypes
    ], typeSuite));
    var checkers = {};
    for(var _a = 0, typeSuite_1 = typeSuite; _a < typeSuite_1.length; _a++){
        var suite_1 = typeSuite_1[_a];
        for(var _b = 0, _c = Object.keys(suite_1); _b < _c.length; _b++){
            var name = _c[_b];
            checkers[name] = new $f5315ec19a67585e$var$Checker(fullSuite, suite_1[name]);
        }
    }
    return checkers;
}
$f5315ec19a67585e$exports.createCheckers = $f5315ec19a67585e$var$createCheckers;
/**
 * Checker implements validation of objects, and also includes accessors to validate method calls.
 * Checkers should be created using `createCheckers()`.
 */ var $f5315ec19a67585e$var$Checker = /** @class */ function() {
    // Create checkers by using `createCheckers()` function.
    function Checker(suite, ttype, _path) {
        if (_path === void 0) _path = 'value';
        this.suite = suite;
        this.ttype = ttype;
        this._path = _path;
        this.props = new Map();
        if (ttype instanceof $i143t.TIface) for(var _i = 0, _a = ttype.props; _i < _a.length; _i++){
            var p = _a[_i];
            this.props.set(p.name, p.ttype);
        }
        this.checkerPlain = this.ttype.getChecker(suite, false);
        this.checkerStrict = this.ttype.getChecker(suite, true);
    }
    /**
     * Set the path to report in errors, instead of the default "value". (E.g. if the Checker is for
     * a "person" interface, set path to "person" to report e.g. "person.name is not a string".)
     */ Checker.prototype.setReportedPath = function(path) {
        this._path = path;
    };
    /**
     * Check that the given value satisfies this checker's type, or throw Error.
     */ Checker.prototype.check = function(value) {
        return this._doCheck(this.checkerPlain, value);
    };
    /**
     * A fast check for whether or not the given value satisfies this Checker's type. This returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.test = function(value) {
        return this.checkerPlain(value, new $d3AJN.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type, or null if it does.
     */ Checker.prototype.validate = function(value) {
        return this._doValidate(this.checkerPlain, value);
    };
    /**
     * Check that the given value satisfies this checker's type strictly. This checks that objects
     * and tuples have no extra members. Note that this prevents backward compatibility, so usually
     * a plain check() is more appropriate.
     */ Checker.prototype.strictCheck = function(value) {
        return this._doCheck(this.checkerStrict, value);
    };
    /**
     * A fast strict check for whether or not the given value satisfies this Checker's type. Returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.strictTest = function(value) {
        return this.checkerStrict(value, new $d3AJN.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type strictly, or null if it does.
     */ Checker.prototype.strictValidate = function(value) {
        return this._doValidate(this.checkerStrict, value);
    };
    /**
     * If this checker is for an interface, returns a Checker for the type required for the given
     * property of this interface.
     */ Checker.prototype.getProp = function(prop) {
        var ttype = this.props.get(prop);
        if (!ttype) throw new Error("Type has no property " + prop);
        return new Checker(this.suite, ttype, this._path + "." + prop);
    };
    /**
     * If this checker is for an interface, returns a Checker for the argument-list required to call
     * the given method of this interface. E.g. if this Checker is for the interface:
     *    interface Foo {
     *      find(s: string, pos?: number): number;
     *    }
     * Then methodArgs("find").check(...) will succeed for ["foo"] and ["foo", 3], but not for [17].
     */ Checker.prototype.methodArgs = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.paramList);
    };
    /**
     * If this checker is for an interface, returns a Checker for the return value of the given
     * method of this interface.
     */ Checker.prototype.methodResult = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.result);
    };
    /**
     * If this checker is for a function, returns a Checker for its argument-list.
     */ Checker.prototype.getArgs = function() {
        if (!(this.ttype instanceof $i143t.TFunc)) throw new Error("getArgs() applied to non-function");
        return new Checker(this.suite, this.ttype.paramList);
    };
    /**
     * If this checker is for a function, returns a Checker for its result.
     */ Checker.prototype.getResult = function() {
        if (!(this.ttype instanceof $i143t.TFunc)) throw new Error("getResult() applied to non-function");
        return new Checker(this.suite, this.ttype.result);
    };
    /**
     * Return the type for which this is a checker.
     */ Checker.prototype.getType = function() {
        return this.ttype;
    };
    /**
     * Actual implementation of check() and strictCheck().
     */ Checker.prototype._doCheck = function(checkerFunc, value) {
        var noopCtx = new $d3AJN.NoopContext();
        if (!checkerFunc(value, noopCtx)) {
            var detailCtx = new $d3AJN.DetailContext();
            checkerFunc(value, detailCtx);
            throw detailCtx.getError(this._path);
        }
    };
    Checker.prototype._doValidate = function(checkerFunc, value) {
        var noopCtx = new $d3AJN.NoopContext();
        if (checkerFunc(value, noopCtx)) return null;
        var detailCtx = new $d3AJN.DetailContext();
        checkerFunc(value, detailCtx);
        return detailCtx.getErrorDetail(this._path);
    };
    Checker.prototype._getMethod = function(methodName) {
        var ttype = this.props.get(methodName);
        if (!ttype) throw new Error("Type has no property " + methodName);
        if (!(ttype instanceof $i143t.TFunc)) throw new Error("Property " + methodName + " is not a method");
        return ttype;
    };
    return Checker;
}();
$f5315ec19a67585e$exports.Checker = $f5315ec19a67585e$var$Checker;


/**
 * This module was automatically generated by `ts-interface-builder`
 */ 
const $0afa6f86b9b32f01$export$563a914cafbdc389 = $f5315ec19a67585e$exports.union($f5315ec19a67585e$exports.lit("jsx"), $f5315ec19a67585e$exports.lit("typescript"), $f5315ec19a67585e$exports.lit("flow"), $f5315ec19a67585e$exports.lit("imports"), $f5315ec19a67585e$exports.lit("react-hot-loader"), $f5315ec19a67585e$exports.lit("jest"));
const $0afa6f86b9b32f01$export$6314eb8a2e5cb73e = $f5315ec19a67585e$exports.iface([], {
    compiledFilename: "string"
});
const $0afa6f86b9b32f01$export$c019608e5b5bb4cb = $f5315ec19a67585e$exports.iface([], {
    transforms: $f5315ec19a67585e$exports.array("Transform"),
    disableESTransforms: $f5315ec19a67585e$exports.opt("boolean"),
    jsxRuntime: $f5315ec19a67585e$exports.opt($f5315ec19a67585e$exports.union($f5315ec19a67585e$exports.lit("classic"), $f5315ec19a67585e$exports.lit("automatic"), $f5315ec19a67585e$exports.lit("preserve"))),
    production: $f5315ec19a67585e$exports.opt("boolean"),
    jsxImportSource: $f5315ec19a67585e$exports.opt("string"),
    jsxPragma: $f5315ec19a67585e$exports.opt("string"),
    jsxFragmentPragma: $f5315ec19a67585e$exports.opt("string"),
    keepUnusedImports: $f5315ec19a67585e$exports.opt("boolean"),
    preserveDynamicImport: $f5315ec19a67585e$exports.opt("boolean"),
    injectCreateRequireForImportRequire: $f5315ec19a67585e$exports.opt("boolean"),
    enableLegacyTypeScriptModuleInterop: $f5315ec19a67585e$exports.opt("boolean"),
    enableLegacyBabel5ModuleInterop: $f5315ec19a67585e$exports.opt("boolean"),
    sourceMapOptions: $f5315ec19a67585e$exports.opt("SourceMapOptions"),
    filePath: $f5315ec19a67585e$exports.opt("string")
});
const $0afa6f86b9b32f01$var$exportedTypeSuite = {
    Transform: $0afa6f86b9b32f01$export$563a914cafbdc389,
    SourceMapOptions: $0afa6f86b9b32f01$export$6314eb8a2e5cb73e,
    Options: $0afa6f86b9b32f01$export$c019608e5b5bb4cb
};
var $0afa6f86b9b32f01$export$2e2bcd8739ae039 = $0afa6f86b9b32f01$var$exportedTypeSuite;


const { Options: $10bb70de42713567$var$OptionsChecker } = (0, $f5315ec19a67585e$exports.createCheckers)((0, $0afa6f86b9b32f01$export$2e2bcd8739ae039));
function $10bb70de42713567$export$1dd09873c1bdd0fc(options) {
    $10bb70de42713567$var$OptionsChecker.strictCheck(options);
}






/* eslint max-len: 0 */ 
/* eslint max-len: 0 */ 



/* eslint max-len: 0 */ // A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser





















function $90ed52daec368086$export$83bfd0877be8807a() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)(false);
}
function $90ed52daec368086$export$9504bd2748b5750c(isBlockScope) {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $90ed52daec368086$export$e1f90e6766854abd(isBlockScope);
}
function $90ed52daec368086$export$7538cb03fa894c83(isBlockScope) {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $90ed52daec368086$export$80e4117797ed03a6(isBlockScope);
}
function $90ed52daec368086$export$cba413304e86fc0d() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
}
function $90ed52daec368086$export$80e4117797ed03a6(isBlockScope) {
    let identifierRole;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).TopLevelDeclaration;
    else if (isBlockScope) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).BlockScopedDeclaration;
    else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).FunctionScopedDeclaration;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
}
function $90ed52daec368086$export$e1f90e6766854abd(isBlockScope) {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
            {
                // In TypeScript, "this" may be the name of a parameter, so allow it.
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
            $90ed52daec368086$export$7538cb03fa894c83(isBlockScope);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $90ed52daec368086$export$befa6d966a25698e((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, isBlockScope, true);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            (0, $ac0b98ed31ddbb15$export$908e61e44ae774e)(true, isBlockScope);
            return;
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
}
function $90ed52daec368086$export$befa6d966a25698e(close, isBlockScope, allowEmpty = false, allowModifiers = false, contextId = 0) {
    let first = true;
    let hasRemovedComma = false;
    const firstItemTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(close) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
            // After a "this" type in TypeScript, we need to set the following comma (if any) to also be
            // a type token so that it will be removed.
            if (!hasRemovedComma && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[firstItemTokenIndex].isType) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
                hasRemovedComma = true;
            }
        }
        if (allowEmpty && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
        else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)(close)) break;
        else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            $90ed52daec368086$export$9504bd2748b5750c(isBlockScope);
            $90ed52daec368086$var$parseAssignableListItemTypes();
            // Support rest element trailing commas allowed by TypeScript <2.9.
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $485552d236f25875$export$3570f33b1a1f3329)(close);
            break;
        } else $90ed52daec368086$var$parseAssignableListItem(allowModifiers, isBlockScope);
    }
}
function $90ed52daec368086$var$parseAssignableListItem(allowModifiers, isBlockScope) {
    if (allowModifiers) (0, $6ae90c8fc78a4682$export$77616e6d401f584a)([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope);
    $90ed52daec368086$var$parseAssignableListItemTypes();
    $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope, true);
}
function $90ed52daec368086$var$parseAssignableListItemTypes() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$a9031cdcb39989e3)();
    else if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$9b46e2c9fd90d888)();
}
function $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope, leftAlreadyParsed = false) {
    if (!leftAlreadyParsed) $90ed52daec368086$export$e1f90e6766854abd(isBlockScope);
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return;
    const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
}





function $6ae90c8fc78a4682$var$tsIsIdentifier() {
    // TODO: actually a bit more complex in TypeScript, but shouldn't matter.
    // See https://github.com/Microsoft/TypeScript/issues/15008
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $6ae90c8fc78a4682$var$isLiteralPropertyName() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || Boolean((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal);
}
function $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier() {
    // Note: TypeScript's implementation is much more complicated because
    // more things are considered modifiers there.
    // This implementation only handles modifiers not handled by babylon itself. And "static".
    // TODO: Would be nice to avoid lookahead. Want a hasLineBreakUpNext() method...
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    const canFollowModifier = ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash) || $6ae90c8fc78a4682$var$isLiteralPropertyName()) && !(0, $485552d236f25875$export$942fa35f3a7c108c)();
    if (canFollowModifier) return true;
    else {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
}
function $6ae90c8fc78a4682$export$77616e6d401f584a(allowedModifiers) {
    while(true){
        const modifier = $6ae90c8fc78a4682$export$a90a97ddca783020(allowedModifiers);
        if (modifier === null) break;
    }
}
function $6ae90c8fc78a4682$export$a90a97ddca783020(allowedModifiers) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return null;
    const modifier = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
    if (allowedModifiers.indexOf(modifier) !== -1 && $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier()) {
        switch(modifier){
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
                break;
            default:
                break;
        }
        return modifier;
    }
    return null;
}
function $6ae90c8fc78a4682$var$tsParseEntityName() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $6ae90c8fc78a4682$var$tsParseTypeReference() {
    $6ae90c8fc78a4682$var$tsParseEntityName();
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseThisTypePredicate() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$var$tsParseThisTypeNode() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $6ae90c8fc78a4682$var$tsParseTypeQuery() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) $6ae90c8fc78a4682$var$tsParseImportType();
    else $6ae90c8fc78a4682$var$tsParseEntityName();
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseImportType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $6ae90c8fc78a4682$var$tsParseEntityName();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseTypeParameter() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
    const hadIn = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
    const hadOut = (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._out);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
    if ((hadIn || hadOut) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) // The "in" or "out" keyword must have actually been the type parameter
    // name, so set it as the name.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$export$827faab4e65d5897() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeParameters();
}
function $6ae90c8fc78a4682$var$tsParseTypeParameters() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseTypeParameter();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
// Note: In TypeScript implementation we must provide `yieldContext` and `awaitContext`,
// but here it's always false, because this is only used for types.
function $6ae90c8fc78a4682$var$tsFillSignature(returnToken) {
    // Arrow fns *must* have return token (`=>`). Normal functions can omit it.
    const returnTokenRequired = returnToken === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow;
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    // Create a scope even though we're doing type parsing so we don't accidentally
    // treat params as top-level bindings.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    $6ae90c8fc78a4682$var$tsParseBindingListForSignature(false);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    if (returnTokenRequired) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)(returnToken)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
}
function $6ae90c8fc78a4682$var$tsParseBindingListForSignature(isBlockScope) {
    (0, $90ed52daec368086$export$befa6d966a25698e)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, isBlockScope);
}
function $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon() {
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsParseSignatureMember() {
    $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
}
function $6ae90c8fc78a4682$var$tsIsUnambiguouslyIndexSignature() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Skip '{'
    const isIndexSignature = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isIndexSignature;
}
function $6ae90c8fc78a4682$var$tsTryParseIndexSignature() {
    if (!((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) && $6ae90c8fc78a4682$var$tsIsUnambiguouslyIndexSignature())) return false;
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $6ae90c8fc78a4682$export$728a3256ac690042();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    return true;
}
function $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(isReadonly) {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if (!isReadonly && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan))) {
        $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    } else {
        $6ae90c8fc78a4682$export$e4623eb563192e0f();
        $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    }
}
function $6ae90c8fc78a4682$var$tsParseTypeMember() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        // call signature
        $6ae90c8fc78a4682$var$tsParseSignatureMember();
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) // constructor signature
        $6ae90c8fc78a4682$var$tsParseSignatureMember();
        else $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(false);
        return;
    }
    const readonly = !!$6ae90c8fc78a4682$export$a90a97ddca783020([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly
    ]);
    const found = $6ae90c8fc78a4682$var$tsTryParseIndexSignature();
    if (found) return;
    ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set)) && $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier();
    (0, $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3)(-1 /* Types don't need context IDs. */ );
    $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(readonly);
}
function $6ae90c8fc78a4682$var$tsParseTypeLiteral() {
    $6ae90c8fc78a4682$var$tsParseObjectTypeMembers();
}
function $6ae90c8fc78a4682$var$tsParseObjectTypeMembers() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)$6ae90c8fc78a4682$var$tsParseTypeMember();
}
function $6ae90c8fc78a4682$var$tsLookaheadIsStartOfMappedType() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const isStartOfMappedType = $6ae90c8fc78a4682$var$tsIsStartOfMappedType();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isStartOfMappedType;
}
function $6ae90c8fc78a4682$var$tsIsStartOfMappedType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) return false;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!$6ae90c8fc78a4682$var$tsIsIdentifier()) return false;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
}
function $6ae90c8fc78a4682$var$tsParseMappedTypeParameter() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$tsParseMappedType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    } else (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    $6ae90c8fc78a4682$var$tsParseMappedTypeParameter();
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    } else (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    $6ae90c8fc78a4682$var$tsTryParseType();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $6ae90c8fc78a4682$var$tsParseTupleType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        // Do not validate presence of either none or only labeled elements
        $6ae90c8fc78a4682$var$tsParseTupleElementType();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseTupleElementType() {
    // parses `...TsType[]`
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    else {
        // parses `TsType?`
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    }
    // The type we parsed above was actually a label
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) // Labeled tuple types must affix the label with `...` or `?`, so no need to handle those here
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$tsParseParenthesizedType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
function $6ae90c8fc78a4682$var$tsParseTemplateLiteralType() {
    // Finish `, read quasi
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        // Finish }, read quasi
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    }
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
var $6ae90c8fc78a4682$var$FunctionType;
(function(FunctionType) {
    const TSFunctionType = 0;
    FunctionType[FunctionType["TSFunctionType"] = TSFunctionType] = "TSFunctionType";
    const TSConstructorType = TSFunctionType + 1;
    FunctionType[FunctionType["TSConstructorType"] = TSConstructorType] = "TSConstructorType";
    const TSAbstractConstructorType = TSConstructorType + 1;
    FunctionType[FunctionType["TSAbstractConstructorType"] = TSAbstractConstructorType] = "TSAbstractConstructorType";
})($6ae90c8fc78a4682$var$FunctionType || ($6ae90c8fc78a4682$var$FunctionType = {}));
function $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType(type) {
    if (type === $6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType) (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract);
    if (type === $6ae90c8fc78a4682$var$FunctionType.TSConstructorType || type === $6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new);
    const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
    $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
}
function $6ae90c8fc78a4682$var$tsParseNonArrayType() {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            $6ae90c8fc78a4682$var$tsParseTypeReference();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
            $6ae90c8fc78a4682$var$tsParseThisTypeNode();
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) $6ae90c8fc78a4682$var$tsParseThisTypePredicate();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof:
            $6ae90c8fc78a4682$var$tsParseTypeQuery();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            $6ae90c8fc78a4682$var$tsParseImportType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            if ($6ae90c8fc78a4682$var$tsLookaheadIsStartOfMappedType()) $6ae90c8fc78a4682$var$tsParseMappedType();
            else $6ae90c8fc78a4682$var$tsParseTypeLiteral();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            $6ae90c8fc78a4682$var$tsParseTupleType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            $6ae90c8fc78a4682$var$tsParseParenthesizedType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote:
            $6ae90c8fc78a4682$var$tsParseTemplateLiteralType();
            return;
        default:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                return;
            }
            break;
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $6ae90c8fc78a4682$var$tsParseArrayTypeOrHigher() {
    $6ae90c8fc78a4682$var$tsParseNonArrayType();
    while(!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL))if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) {
        // If we hit ] immediately, this is an array type, otherwise it's an indexed access type.
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    }
}
function $6ae90c8fc78a4682$var$tsParseInferType() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer);
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) {
        // Infer type constraints introduce an ambiguity about whether the "extends"
        // is a constraint for this infer type or is another conditional type.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends);
        const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error || !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._keyof) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._unique) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer)) $6ae90c8fc78a4682$var$tsParseInferType();
    else {
        const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
        $6ae90c8fc78a4682$var$tsParseArrayTypeOrHigher();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    }
}
function $6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND);
    $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND))$6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
}
function $6ae90c8fc78a4682$var$tsParseUnionTypeOrHigher() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR);
    $6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR))$6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher();
}
function $6ae90c8fc78a4682$var$tsIsStartOfFunctionType() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return true;
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) && $6ae90c8fc78a4682$var$tsLookaheadIsUnambiguouslyStartOfFunctionType();
}
function $6ae90c8fc78a4682$var$tsSkipParameterStart() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return true;
    }
    // If this is a possible array/object destructure, walk to the matching bracket/brace.
    // The next token after will tell us definitively whether this is a function param.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        let depth = 1;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        while(depth > 0 && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) depth++;
            else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) depth--;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsLookaheadIsUnambiguouslyStartOfFunctionType() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const isUnambiguouslyStartOfFunctionType = $6ae90c8fc78a4682$var$tsIsUnambiguouslyStartOfFunctionType();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isUnambiguouslyStartOfFunctionType;
}
function $6ae90c8fc78a4682$var$tsIsUnambiguouslyStartOfFunctionType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) // ( )
    // ( ...
    return true;
    if ($6ae90c8fc78a4682$var$tsSkipParameterStart()) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // ( xxx :
        // ( xxx ,
        // ( xxx ?
        // ( xxx =
        return true;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) // ( xxx ) =>
            return true;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken) {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)(returnToken);
    const finishedReturn = $6ae90c8fc78a4682$var$tsParseTypePredicateOrAssertsPrefix();
    if (!finishedReturn) $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$var$tsTryParseTypeOrTypePredicateAnnotation() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
}
function $6ae90c8fc78a4682$export$e4623eb563192e0f() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$var$tsTryParseType() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$13a289e680c077c1();
}
/**
 * Detect a few special return syntax cases: `x is T`, `asserts x`, `asserts x is T`,
 * `asserts this is T`.
 *
 * Returns true if we parsed the return type, false if there's still a type to be parsed.
 */ function $6ae90c8fc78a4682$var$tsParseTypePredicateOrAssertsPrefix() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._asserts)) {
        // Normally this is `asserts x is T`, but at this point, it might be `asserts is T` (a user-
        // defined type guard on the `asserts` variable) or just a type called `asserts`.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is)) {
            // If we see `asserts is`, then this must be of the form `asserts is T`, since
            // `asserts is is T` isn't valid.
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else if ($6ae90c8fc78a4682$var$tsIsIdentifier() || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is)) // If we see `is`, then this is `asserts x is T`. Otherwise, it's `asserts x`.
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ($6ae90c8fc78a4682$var$tsIsIdentifier() || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
        // This is a regular identifier, which may or may not have "is" after it.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$export$728a3256ac690042() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$13a289e680c077c1() {
    $6ae90c8fc78a4682$export$817427f5f29c80bc();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext || (0, $485552d236f25875$export$942fa35f3a7c108c)() || !(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) return;
    // extends type
    const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
    $6ae90c8fc78a4682$export$817427f5f29c80bc();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    // true type
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    // false type
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$isAbstractConstructorSignature() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new;
}
function $6ae90c8fc78a4682$export$817427f5f29c80bc() {
    if ($6ae90c8fc78a4682$var$tsIsStartOfFunctionType()) {
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSFunctionType);
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new)) {
        // As in `new () => Date`
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSConstructorType);
        return;
    } else if ($6ae90c8fc78a4682$var$isAbstractConstructorSignature()) {
        // As in `abstract new () => Date`
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType);
        return;
    }
    $6ae90c8fc78a4682$var$tsParseUnionTypeOrHigher();
}
function $6ae90c8fc78a4682$export$ecfac1712a900e29() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    (0, $ac0b98ed31ddbb15$export$165911d2b803e372)();
}
function $6ae90c8fc78a4682$export$382de4b7ab7e7990() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
        }
        // Process >, but the one after needs to be parsed JSX-style.
        (0, $6da7dec74ffdbf22$export$a1b2c368381052e6)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$var$tsParseHeritageClause() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseExpressionWithTypeArguments();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseExpressionWithTypeArguments() {
    // Note: TS uses parseLeftHandSideExpressionOrHigher,
    // then has grammar errors later if it's not an EntityName.
    $6ae90c8fc78a4682$var$tsParseEntityName();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseInterfaceDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) $6ae90c8fc78a4682$var$tsParseHeritageClause();
    $6ae90c8fc78a4682$var$tsParseObjectTypeMembers();
}
function $6ae90c8fc78a4682$var$tsParseTypeAliasDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsParseEnumMember() {
    // Computed property names are grammar errors in an enum, so accept just string literal or identifier.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    }
}
function $6ae90c8fc78a4682$var$tsParseEnumDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseEnumMember();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseModuleBlock() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    (0, $8a4e0068a7ab0607$export$e5110a9b2ab486ee)(/* end */ (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
    else $6ae90c8fc78a4682$var$tsParseModuleBlock();
}
function $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) $6ae90c8fc78a4682$var$tsParseModuleBlock();
    else (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$export$bb14276cd4f56f44() {
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    $6ae90c8fc78a4682$var$tsParseModuleReference();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsIsExternalModuleReference() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL;
}
function $6ae90c8fc78a4682$var$tsParseModuleReference() {
    if ($6ae90c8fc78a4682$var$tsIsExternalModuleReference()) $6ae90c8fc78a4682$var$tsParseExternalModuleReference();
    else $6ae90c8fc78a4682$var$tsParseEntityName();
}
function $6ae90c8fc78a4682$var$tsParseExternalModuleReference() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
// Utilities
// Returns true if a statement matched.
function $6ae90c8fc78a4682$var$tsTryParseDeclare() {
    if ((0, $485552d236f25875$export$12d132b6e81066e4)()) return false;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                // We don't need to precisely get the function start here, since it's only used to mark
                // the function as a type if it's bodiless, and it's already a type here.
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, /* isStatement */ true);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $8a4e0068a7ab0607$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const:
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) && (0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                // `const enum = 0;` not allowed because "enum" is a strict mode reserved word.
                (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
                (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
                $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        // falls through
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $8a4e0068a7ab0607$export$73f0614724a3919a)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
                let matched = false;
                if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global) {
                    $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration();
                    matched = true;
                } else matched = $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ true);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return matched;
            }
        default:
            return false;
    }
}
// Note: this won't be called unless the keyword is allowed in `shouldParseExportDeclaration`.
// Returns true if it matched a declaration.
function $6ae90c8fc78a4682$var$tsTryParseExportDeclaration() {
    return $6ae90c8fc78a4682$var$tsParseDeclaration((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword, /* isBeforeToken */ true);
}
// Returns true if it matched a statement.
function $6ae90c8fc78a4682$var$tsParseExpressionStatement(contextualKeyword) {
    switch(contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
            {
                const declareTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
                const matched = $6ae90c8fc78a4682$var$tsTryParseDeclare();
                if (matched) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[declareTokenIndex].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
                    return true;
                }
                break;
            }
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global:
            // `global { }` (with no `declare`) may appear inside an ambient module declaration.
            // Would like to use tsParseAmbientExternalModuleDeclaration here, but already ran past "global".
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                $6ae90c8fc78a4682$var$tsParseModuleBlock();
                return true;
            }
            break;
        default:
            return $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ false);
    }
    return false;
}
/**
 * Common code for parsing a declaration.
 *
 * isBeforeToken indicates that the current parser state is at the contextual
 * keyword (and that it is not yet emitted) rather than reading the token after
 * it. When isBeforeToken is true, we may be preceded by an `export` token and
 * should include that token in a type context we create, e.g. to handle
 * `export interface` or `export type`. (This is a bit of a hack and should be
 * cleaned up at some point.)
 *
 * Returns true if it matched a declaration.
 */ function $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, isBeforeToken) {
    switch(contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
                (0, $8a4e0068a7ab0607$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
                $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                // `next` is true in "export" and "declare" contexts, so we want to remove that token
                // as well.
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseInterfaceDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken)) {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration();
                    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                    return true;
                } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
                    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                    return true;
                }
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseTypeAliasDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        default:
            break;
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) {
    if (isBeforeToken) {
        // Babel checks hasFollowingLineBreak here and returns false, but this
        // doesn't actually come up, e.g. `export interface` can never be on its own
        // line in valid code.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return true;
    } else return !(0, $485552d236f25875$export$12d132b6e81066e4)();
}
// Returns true if there was a generic async arrow function.
function $6ae90c8fc78a4682$var$tsTryParseGenericAsyncArrowFunction() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
    $6ae90c8fc78a4682$var$tsTryParseTypeOrTypePredicateAnnotation();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(true);
    return true;
}
/**
 * If necessary, hack the tokenizer state so that this bitshift was actually a
 * less-than token, then keep parsing. This should only be used in situations
 * where we restore from snapshot on error (which reverts this change) or
 * where bitshift would be illegal anyway (e.g. in a class "extends" clause).
 *
 * This hack is useful to handle situations like foo<<T>() => void>() where
 * there can legitimately be two open-angle-brackets in a row in TS.
 */ function $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos -= 1;
        (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    }
    $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseTypeArguments() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if (!oldIsType) {
        // If the type arguments are present in an expression context, e.g.
        // f<number>(), then the > sign should be tokenized as a non-type token.
        // In particular, f(a < b, c >= d) should parse the >= as a single token,
        // resulting in a syntax error and fallback to the non-type-args
        // interpretation. In the success case, even though the > is tokenized as a
        // non-type token, it still must be marked as a type token so that it is
        // erased.
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        (0, $19e70491d10f11e8$export$4d00b4f4d9d7a9b3)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    } else {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$export$5df75dadb7a629b6() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type:
            return true;
        default:
            break;
    }
    return false;
}
function $6ae90c8fc78a4682$export$3c36bc5140dd8c64(functionStart, funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    // The original code checked the node type to make sure this function type allows a missing
    // body, but we skip that to avoid sending around the node type. We instead just use the
    // allowExpressionBody boolean to make sure it's not an arrow function.
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && (0, $485552d236f25875$export$12d132b6e81066e4)()) {
        // Retroactively mark the function declaration as a type.
        let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
        while(i >= 0 && ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].start >= functionStart || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)){
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
            i--;
        }
        return;
    }
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(false, funcContextId);
}
function $6ae90c8fc78a4682$export$f6cd10065188a17f(startTokenIndex, noCalls, stopState) {
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nonNullAssertion;
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL)) {
        // There are number of things we are going to "maybe" parse, like type arguments on
        // tagged template expressions. If any of them fail, walk it back and continue.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        if (!noCalls && (0, $ac0b98ed31ddbb15$export$960e7b0728d0d49e)()) {
            // Almost certainly this is a generic async function `async <T>() => ...
            // But it might be a call with a type argument `async<T>();`
            const asyncArrowFn = $6ae90c8fc78a4682$var$tsTryParseGenericAsyncArrowFunction();
            if (asyncArrowFn) return;
        }
        $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
        if (!noCalls && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            // With f<T>(), the subscriptStartIndex marker is on the ( token.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote)) // Tagged template with a type argument.
        (0, $ac0b98ed31ddbb15$export$2e2dbd43b49fd373)();
        else if (// The remaining possible case is an instantiation expression, e.g.
        // Array<number> . Check for a few cases that would disqualify it and
        // cause us to bail out.
        // a<b>>c is not (a<b>)>c, but a<(b>>c)
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan || // a<b>c is (a<b)>c
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL && Boolean((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_EXPRESSION_START) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) // Bail out. We have something like a<b>c, which is not an expression with
        // type arguments but an (a < b) > c comparison.
        (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) {
        // If we see f?.<, then this must be an optional call with a type argument.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        // With f?.<T>(), the subscriptStartIndex marker is on the ?. token.
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $6ae90c8fc78a4682$var$tsParseTypeArguments();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
    }
    (0, $ac0b98ed31ddbb15$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $6ae90c8fc78a4682$export$6714566ca8db2f39() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
        // One of these cases:
        // export import A = B;
        // export import type A = require("A");
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) // Eat a `type` token, unless it's actually an identifier name.
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
        $6ae90c8fc78a4682$export$bb14276cd4f56f44();
        return true;
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        // `export = x;`
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return true;
    } else if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        // `export as namespace A;`
        // See `parseNamespaceExportDeclaration` in TypeScript's own parser
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace);
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return true;
    } else {
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            // export type {foo} from 'a';
            // export type * from 'a';'
            // export type * as ns from 'a';'
            if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        return false;
    }
}
function $6ae90c8fc78a4682$export$718ece2f88417ffd() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {type foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {foo as bar}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    // import {type foo as bar}
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $6ae90c8fc78a4682$export$7994f3b86b6c7d1e() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {type foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {foo as bar}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    // export {type foo as bar}
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $6ae90c8fc78a4682$export$95d54e02ae7a0197() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Skip "abstract"
        (0, $8a4e0068a7ab0607$export$542081d93172af)(true, true);
        return true;
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
        // Make sure "export default" are considered type tokens so the whole thing is removed.
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
        $6ae90c8fc78a4682$var$tsParseDeclaration((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface, true);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$export$bd8d07f8ee509b14() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) {
        const ahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if (ahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && ahead.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum) {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
            $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
            return true;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$export$9d02a6e20851f734(isStatic) {
    const memberStartIndexAfterStatic = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $6ae90c8fc78a4682$export$77616e6d401f584a([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    const modifiersEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const found = $6ae90c8fc78a4682$var$tsTryParseIndexSignature();
    if (found) {
        // Index signatures are type declarations, so set the modifier tokens as
        // type tokens. Most tokens could be assumed to be type tokens, but `static`
        // is ambiguous unless we set it explicitly here.
        const memberStartIndex = isStatic ? memberStartIndexAfterStatic - 1 : memberStartIndexAfterStatic;
        for(let i = memberStartIndex; i < modifiersEndIndex; i++)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$export$a642c15f5070c816(contextualKeyword) {
    const matched = $6ae90c8fc78a4682$var$tsParseExpressionStatement(contextualKeyword);
    if (!matched) (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$export$b29e6741ccf6da0a() {
    // "export declare" is equivalent to just "export".
    const isDeclare = (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare);
    if (isDeclare) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
    let matchedDeclaration = false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        if (isDeclare) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
            matchedDeclaration = $6ae90c8fc78a4682$var$tsTryParseExportDeclaration();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else matchedDeclaration = $6ae90c8fc78a4682$var$tsTryParseExportDeclaration();
    }
    if (!matchedDeclaration) {
        if (isDeclare) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
            (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
    }
}
function $6ae90c8fc78a4682$export$ea9d02c53bf69095(hasSuper) {
    if (hasSuper && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL))) $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._implements;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        $6ae90c8fc78a4682$var$tsParseHeritageClause();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$export$f7c2ce498525881a() {
    $6ae90c8fc78a4682$export$827faab4e65d5897();
}
function $6ae90c8fc78a4682$export$ba34d58430377f94() {
    $6ae90c8fc78a4682$export$827faab4e65d5897();
}
function $6ae90c8fc78a4682$export$41c8703baf1bbf07() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)()) (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$490a9bc22f3cab3f() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$export$daa24143ef798a56(noIn, isWithinParens) {
    // Note: When the JSX plugin is on, type assertions (`<T> x`) aren't valid syntax.
    if (0, $e406deb3d43fd58b$export$43bb667a94af025a) return $6ae90c8fc78a4682$export$fbbf4e3ed219417f(noIn, isWithinParens);
    else return $6ae90c8fc78a4682$export$9606be81aa771b16(noIn, isWithinParens);
}
function $6ae90c8fc78a4682$export$fbbf4e3ed219417f(noIn, isWithinParens) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    // Prefer to parse JSX if possible. But may be an arrow fn.
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    let wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Otherwise, try as type-parameterized arrow function.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    return wasArrow;
}
function $6ae90c8fc78a4682$export$9606be81aa771b16(noIn, isWithinParens) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    const wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Try parsing a type cast instead of an arrow function.
    // This will start with a type assertion (via parseMaybeUnary).
    // But don't directly call `tsParseTypeAssertion` because we want to handle any binary after it.
    return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $6ae90c8fc78a4682$export$e20067ab7c70da1d() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        // This is different from how the TS parser does it.
        // TS uses lookahead. Babylon parses it as a parenthesized expression and converts.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        if ((0, $485552d236f25875$export$1c0919cee6560c3)()) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $6ae90c8fc78a4682$export$9b46e2c9fd90d888() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$fd0439ea9a1ac1ea() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL)) $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
    (0, $8a4e0068a7ab0607$export$50c128b10ac5ea5b)();
}


/**
 * Read token with JSX contents.
 *
 * In addition to detecting jsxTagStart and also regular tokens that might be
 * part of an expression, this code detects the start and end of text ranges
 * within JSX children. In order to properly count the number of children, we
 * distinguish jsxText from jsxEmptyText, which is a text range that simplifies
 * to the empty string after JSX whitespace trimming.
 *
 * It turns out that a JSX text range will simplify to the empty string if and
 * only if both of these conditions hold:
 * - The range consists entirely of whitespace characters (only counting space,
 *   tab, \r, and \n).
 * - The range has at least one newline.
 * This can be proven by analyzing any implementation of whitespace trimming,
 * e.g. formatJSXTextLiteral in Sucrase or cleanJSXElementLiteralChild in Babel.
 */ function $6da7dec74ffdbf22$var$jsxReadToken() {
    let sawNewline = false;
    let sawNonWhitespace = false;
    while(true){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated JSX contents");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) {
                if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
                    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart);
                    return;
                }
                (0, $19e70491d10f11e8$export$e0ebb9fd4c2c4701)(ch);
                return;
            }
            if (sawNewline && !sawNonWhitespace) (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText);
            else (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText);
            return;
        }
        // This is part of JSX text.
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) sawNewline = true;
        else if (ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).space && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).tab) sawNonWhitespace = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
}
function $6da7dec74ffdbf22$var$jsxReadString(quote) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === quote) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
            break;
        }
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}
// Read a JSX identifier (valid tag or attribute name).
//
// Optimized version since JSX identifiers can't contain
// escape characters and so can be read as single slice.
// Also assumes that first character was already checked
// by isIdentifierStart in readToken.
function $6da7dec74ffdbf22$var$jsxReadWord() {
    let ch;
    do {
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos > (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
            return;
        }
        ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }while ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch] || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash);
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName);
}
// Parse next token as JSX identifier
function $6da7dec74ffdbf22$var$jsxParseIdentifier() {
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
}
// Parse namespaced identifier.
function $6da7dec74ffdbf22$var$jsxParseNamespacedName(identifierRole) {
    $6da7dec74ffdbf22$var$jsxParseIdentifier();
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        // Plain identifier, so this is an access.
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
        return;
    }
    // Process the second half of the namespaced name.
    $6da7dec74ffdbf22$var$jsxParseIdentifier();
}
// Parses element name in any form - namespaced, member
// or single identifier.
function $6da7dec74ffdbf22$var$jsxParseElementName() {
    const firstTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $6da7dec74ffdbf22$var$jsxParseNamespacedName((0, $19e70491d10f11e8$export$99f888ada3c99de3).Access);
    let hadDot = false;
    while((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
        hadDot = true;
        $6da7dec74ffdbf22$export$a1b2c368381052e6();
        $6da7dec74ffdbf22$var$jsxParseIdentifier();
    }
    // For tags like <div> with a lowercase letter and no dots, the name is
    // actually *not* an identifier access, since it's referring to a built-in
    // tag name. Remove the identifier role in this case so that it's not
    // accidentally transformed by the imports transform when preserving JSX.
    if (!hadDot) {
        const firstToken = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[firstTokenIndex];
        const firstChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(firstToken.start);
        if (firstChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ) firstToken.identifierRole = null;
    }
}
// Parses any type of JSX attribute value.
function $6da7dec74ffdbf22$var$jsxParseAttributeValue() {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart:
            $6da7dec74ffdbf22$export$7cbe8c53d909e342();
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("JSX value should be either an expression or a quoted JSX text");
    }
}
// Parse JSX spread child, after already processing the {
// Does not parse the closing }
function $6da7dec74ffdbf22$var$jsxParseSpreadChild() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
}
// Parses JSX opening tag starting after "<".
// Returns true if the tag was self-closing.
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseOpeningElement(initialTokenIndex) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // This is an open-fragment.
    return false;
    $6da7dec74ffdbf22$var$jsxParseElementName();
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$382de4b7ab7e7990)();
    let hasSeenPropSpread = false;
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            hasSeenPropSpread = true;
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
            (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
            // }
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            continue;
        }
        if (hasSeenPropSpread && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end - (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start === 3 && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseK && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseE && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseY) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread;
        $6da7dec74ffdbf22$var$jsxParseNamespacedName((0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey);
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            $6da7dec74ffdbf22$var$jsxParseAttributeValue();
        }
    }
    const isSelfClosing = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash);
    if (isSelfClosing) // /
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
    return isSelfClosing;
}
// Parses JSX closing tag starting after "</".
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseClosingElement() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // Fragment syntax, so we immediately have a tag end.
    return;
    $6da7dec74ffdbf22$var$jsxParseElementName();
}
// Parses entire JSX element, including its opening tag
// (starting after "<"), attributes, contents and closing tag.
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseElementAt() {
    const initialTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).NoChildren;
    let numExplicitChildren = 0;
    const isSelfClosing = $6da7dec74ffdbf22$var$jsxParseOpeningElement(initialTokenIndex);
    if (!isSelfClosing) {
        $6da7dec74ffdbf22$var$nextJSXExprToken();
        while(true)switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart:
                $6da7dec74ffdbf22$export$a1b2c368381052e6();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash)) {
                    $6da7dec74ffdbf22$export$a1b2c368381052e6();
                    $6da7dec74ffdbf22$var$jsxParseClosingElement();
                    // Key after prop spread takes precedence over number of children,
                    // since it means we switch to createElement, which doesn't care
                    // about number of children.
                    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole !== (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread) {
                        if (numExplicitChildren === 1) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).OneChild;
                        else if (numExplicitChildren > 1) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren;
                    }
                    return;
                }
                numExplicitChildren++;
                $6da7dec74ffdbf22$var$jsxParseElementAt();
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText:
                numExplicitChildren++;
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText:
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                    $6da7dec74ffdbf22$var$jsxParseSpreadChild();
                    $6da7dec74ffdbf22$var$nextJSXExprToken();
                    // Spread children are a mechanism to explicitly mark children as
                    // static, so count it as 2 children to satisfy the "more than one
                    // child" condition.
                    numExplicitChildren += 2;
                } else {
                    // If we see {}, this is an empty pseudo-expression that doesn't
                    // count as a child.
                    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                        numExplicitChildren++;
                        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
                    }
                    $6da7dec74ffdbf22$var$nextJSXExprToken();
                }
                break;
            // istanbul ignore next - should never happen
            default:
                (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
                return;
        }
    }
}
function $6da7dec74ffdbf22$export$7cbe8c53d909e342() {
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
    $6da7dec74ffdbf22$var$jsxParseElementAt();
}
function $6da7dec74ffdbf22$export$a1b2c368381052e6() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new (0, $19e70491d10f11e8$export$50792b0e93539fde)());
    (0, $19e70491d10f11e8$export$b240c79c2d18160)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code]) $6da7dec74ffdbf22$var$jsxReadWord();
    else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe) $6da7dec74ffdbf22$var$jsxReadString(code);
    else {
        // The following tokens are just one character each.
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        switch(code){
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
                break;
            default:
                (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        }
    }
}
function $6da7dec74ffdbf22$var$nextJSXExprToken() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new (0, $19e70491d10f11e8$export$50792b0e93539fde)());
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $6da7dec74ffdbf22$var$jsxReadToken();
}








function $fa72ea6780427093$export$a1aa0436beedb1fa(noIn) {
    // If we see ?:, this can't possibly be a valid conditional. typedParseParenItem will be called
    // later to finish off the arrow parameter. We also need to handle bare ? tokens for optional
    // parameters without type annotations, i.e. ?, and ?) .
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) {
        const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
        if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) return;
    }
    (0, $ac0b98ed31ddbb15$export$a3d1b6cb707072ce)(noIn);
}
function $fa72ea6780427093$export$72bae99899f77e0f() {
    (0, $19e70491d10f11e8$export$cb3e65614411a57c)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$728a3256ac690042)();
        else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$6c833037db1a1e96)();
    }
}













class $ac0b98ed31ddbb15$export$8cd93656cd4760 {
    constructor(stop){
        this.stop = stop;
    }
}
function $ac0b98ed31ddbb15$export$ed9c825e502c46c8(noIn = false) {
    $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma))$ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
}
function $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn = false, isWithinParens = false) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) return (0, $6ae90c8fc78a4682$export$daa24143ef798a56)(noIn, isWithinParens);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$abad2599830a7c66)(noIn, isWithinParens);
    else return $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd(noIn, isWithinParens);
}
function $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd(noIn, isWithinParens) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) {
        $ac0b98ed31ddbb15$var$parseYield();
        return false;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).potentialArrowAt = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    const wasArrow = $ac0b98ed31ddbb15$var$parseMaybeConditional(noIn);
    if (isWithinParens) $ac0b98ed31ddbb15$var$parseParenItem();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_ASSIGN) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
        return false;
    }
    return wasArrow;
}
// Parse a ternary conditional (`?:`) operator.
// Returns true if the expression was an arrow function.
function $ac0b98ed31ddbb15$var$parseMaybeConditional(noIn) {
    const wasArrow = $ac0b98ed31ddbb15$var$parseExprOps(noIn);
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseConditional(noIn);
    return false;
}
function $ac0b98ed31ddbb15$var$parseConditional(noIn) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) (0, $fa72ea6780427093$export$a1aa0436beedb1fa)(noIn);
    else $ac0b98ed31ddbb15$export$a3d1b6cb707072ce(noIn);
}
function $ac0b98ed31ddbb15$export$a3d1b6cb707072ce(noIn) {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) {
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
    }
}
// Start the precedence parser.
// Returns true if this was an arrow function
function $ac0b98ed31ddbb15$var$parseExprOps(noIn) {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $ac0b98ed31ddbb15$export$165911d2b803e372();
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, -1, noIn);
    return false;
}
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
function $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).PRECEDENCE_MASK) > minPrec && !(0, $485552d236f25875$export$942fa35f3a7c108c)() && ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as) || (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._satisfies))) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $6ae90c8fc78a4682$export$13a289e680c077c1)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        (0, $19e70491d10f11e8$export$4d00b4f4d9d7a9b3)();
        $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn);
        return;
    }
    const prec = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).PRECEDENCE_MASK;
    if (prec > 0 && (!noIn || !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in))) {
        if (prec > minPrec) {
            const op = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if (op === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].nullishStartIndex = startTokenIndex;
            const rhsStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            $ac0b98ed31ddbb15$export$165911d2b803e372();
            // Extend the right operand of this operator if possible.
            $ac0b98ed31ddbb15$var$parseExprOp(rhsStartTokenIndex, op & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_RIGHT_ASSOCIATIVE ? prec - 1 : prec, noIn);
            if (op === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].numNullishCoalesceStarts++;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].numNullishCoalesceEnds++;
            }
            // Continue with any future operator holding this expression as the left operand.
            $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn);
        }
    }
}
function $ac0b98ed31ddbb15$export$165911d2b803e372() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && !(0, $e406deb3d43fd58b$export$43bb667a94af025a) && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        (0, $6ae90c8fc78a4682$export$ecfac1712a900e29)();
        return false;
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && (0, $19e70491d10f11e8$export$847169391b2516b8)() === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace && !(0, $485552d236f25875$export$a4f1ee8cbd9b31ba)()) {
        $ac0b98ed31ddbb15$var$parseModuleExpression();
        return false;
    }
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_PREFIX) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $ac0b98ed31ddbb15$export$165911d2b803e372();
        return false;
    }
    const wasArrow = $ac0b98ed31ddbb15$export$dba7f678c228244a();
    if (wasArrow) return true;
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_POSTFIX && !(0, $485552d236f25875$export$1c0919cee6560c3)()){
        // The tokenizer calls everything a preincrement, so make it a postincrement when
        // we see it in that context.
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).postIncDec;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
    return false;
}
function $ac0b98ed31ddbb15$export$dba7f678c228244a() {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $ac0b98ed31ddbb15$export$fa61731cf32bc243();
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex);
    // If there was any optional chain operation, the start token would be marked
    // as such, so also mark the end now.
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length > startTokenIndex && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isOptionalChainEnd = true;
    return false;
}
function $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, noCalls = false) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$7c7ba3c0c5ae1f67)(startTokenIndex, noCalls);
    else $ac0b98ed31ddbb15$export$c2cc03eea353aa42(startTokenIndex, noCalls);
}
function $ac0b98ed31ddbb15$export$c2cc03eea353aa42(startTokenIndex, noCalls = false) {
    const stopState = new $ac0b98ed31ddbb15$export$8cd93656cd4760(false);
    do $ac0b98ed31ddbb15$var$parseSubscript(startTokenIndex, noCalls, stopState);
    while (!stopState.stop && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
}
function $ac0b98ed31ddbb15$var$parseSubscript(startTokenIndex, noCalls, stopState) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$f6cd10065188a17f)(startTokenIndex, noCalls, stopState);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$4eb11794b3b71235)(startTokenIndex, noCalls, stopState);
    else $ac0b98ed31ddbb15$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState);
}
function $ac0b98ed31ddbb15$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState) {
    if (!noCalls && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon)) {
        $ac0b98ed31ddbb15$var$parseNoCallExpr();
        stopState.stop = true;
        // Propagate startTokenIndex so that `a::b?.()` will keep `a` as the first token. We may want
        // to revisit this in the future when fully supporting bind syntax.
        $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, noCalls);
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        if (noCalls && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) {
            stopState.stop = true;
            return;
        }
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
            $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $ac0b98ed31ddbb15$export$970763873d9efa73();
        else $ac0b98ed31ddbb15$var$parseMaybePrivateName();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $ac0b98ed31ddbb15$var$parseMaybePrivateName();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        if ($ac0b98ed31ddbb15$export$960e7b0728d0d49e()) {
            // We see "async", but it's possible it's a usage of the name "async". Parse as if it's a
            // function call, and if we see an arrow later, backtrack and re-parse as a parameter list.
            const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
            const asyncStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $ac0b98ed31ddbb15$export$970763873d9efa73();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            if ($ac0b98ed31ddbb15$var$shouldParseAsyncArrow()) {
                // We hit an arrow, so backtrack and start again parsing function parameters.
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                stopState.stop = true;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
                $ac0b98ed31ddbb15$var$parseAsyncArrowFromCallExpression(asyncStartTokenIndex);
            }
        } else {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $ac0b98ed31ddbb15$export$970763873d9efa73();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote)) // Tagged template expression.
    $ac0b98ed31ddbb15$export$2e2dbd43b49fd373();
    else stopState.stop = true;
}
function $ac0b98ed31ddbb15$export$960e7b0728d0d49e() {
    // This was made less strict than the original version to avoid passing around nodes, but it
    // should be safe to have rare false positives here.
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$1c0919cee6560c3)();
}
function $ac0b98ed31ddbb15$export$970763873d9efa73() {
    let first = true;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) break;
        }
        $ac0b98ed31ddbb15$var$parseExprListItem(false);
    }
}
function $ac0b98ed31ddbb15$var$shouldParseAsyncArrow() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $ac0b98ed31ddbb15$var$parseAsyncArrowFromCallExpression(startTokenIndex) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$490a9bc22f3cab3f)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$6c11d14a2632a0dc)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
}
// Parse a no-call expression (like argument of `new` or `::` operators).
function $ac0b98ed31ddbb15$var$parseNoCallExpr() {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $ac0b98ed31ddbb15$export$fa61731cf32bc243();
    $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, true);
}
function $ac0b98ed31ddbb15$export$fa61731cf32bc243() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) {
        // V8 intrinsic expression. Just parse the identifier, and the function invocation is parsed
        // naturally.
        $ac0b98ed31ddbb15$export$321543c11f6250ad();
        return false;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText)) {
        $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef();
        return false;
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) && (0, $e406deb3d43fd58b$export$43bb667a94af025a)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart;
        (0, $6da7dec74ffdbf22$export$7cbe8c53d909e342)();
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return false;
    }
    const canBeArrow = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).potentialArrowAt === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign:
            (0, $19e70491d10f11e8$export$f6864f1ed2347988)();
        // Fall through.
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).regexp:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
                // import.meta
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                $ac0b98ed31ddbb15$export$321543c11f6250ad();
            }
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            {
                const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
                $ac0b98ed31ddbb15$export$321543c11f6250ad();
                if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await) {
                    $ac0b98ed31ddbb15$var$parseAwait();
                    return false;
                } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, false);
                    return false;
                } else if (canBeArrow && contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$1c0919cee6560c3)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
                    // let foo = async bar => {};
                    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    (0, $8a4e0068a7ab0607$export$4aed668c47d45036)();
                    return false;
                }
                if (canBeArrow && !(0, $485552d236f25875$export$1c0919cee6560c3)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $90ed52daec368086$export$80e4117797ed03a6)(false);
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
                    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                }
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access;
                return false;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $8a4e0068a7ab0607$export$4aed668c47d45036)();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            {
                const wasArrow = $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(canBeArrow);
                return wasArrow;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $ac0b98ed31ddbb15$var$parseExprList((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, true);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $ac0b98ed31ddbb15$export$908e61e44ae774e(false, false);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            $ac0b98ed31ddbb15$var$parseFunctionExpression();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at:
            (0, $8a4e0068a7ab0607$export$3f4d9519f687227a)();
        // Fall through.
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            (0, $8a4e0068a7ab0607$export$542081d93172af)(false);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new:
            $ac0b98ed31ddbb15$var$parseNew();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote:
            $ac0b98ed31ddbb15$export$2e2dbd43b49fd373();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $ac0b98ed31ddbb15$var$parseNoCallExpr();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash:
            {
                const code = (0, $19e70491d10f11e8$export$847169391b2516b8)();
                if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code] || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) $ac0b98ed31ddbb15$var$parseMaybePrivateName();
                else (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                // Smart pipeline topic reference.
                return false;
            }
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            return false;
    }
}
function $ac0b98ed31ddbb15$var$parseMaybePrivateName() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash);
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
}
function $ac0b98ed31ddbb15$var$parseFunctionExpression() {
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) // function.sent
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
    (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, false);
}
function $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $ac0b98ed31ddbb15$export$d5ddb48bead5eb08() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
// Returns true if this was an arrow expression.
function $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(canBeArrow) {
    // Assume this is a normal parenthesized expression, but if we see an arrow, we'll bail and
    // start over as a parameter list.
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    let first = true;
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) break;
        }
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            (0, $90ed52daec368086$export$9504bd2748b5750c)(false);
            $ac0b98ed31ddbb15$var$parseParenItem();
            break;
        } else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false, true);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    if (canBeArrow && $ac0b98ed31ddbb15$var$shouldParseArrow()) {
        const wasArrow = $ac0b98ed31ddbb15$export$92291a002e3a40fe();
        if (wasArrow) {
            // It was an arrow function this whole time, so start over and parse it as params so that we
            // get proper token annotations.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
            // Don't specify a context ID because arrow functions don't need a context ID.
            (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
            $ac0b98ed31ddbb15$export$92291a002e3a40fe();
            $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
                // Nevermind! This must have been something that looks very much like an
                // arrow function but where its "parameter list" isn't actually a valid
                // parameter list. Force non-arrow parsing.
                // See https://github.com/alangpierce/sucrase/issues/666 for an example.
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(false);
                return false;
            }
            return true;
        }
    }
    return false;
}
function $ac0b98ed31ddbb15$var$shouldParseArrow() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || !(0, $485552d236f25875$export$1c0919cee6560c3)();
}
function $ac0b98ed31ddbb15$export$92291a002e3a40fe() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) return (0, $6ae90c8fc78a4682$export$e20067ab7c70da1d)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$1ee5238ec4961bad)();
    else return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $ac0b98ed31ddbb15$var$parseParenItem() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) (0, $fa72ea6780427093$export$72bae99899f77e0f)();
}
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
function $ac0b98ed31ddbb15$var$parseNew() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
        // new.target
        $ac0b98ed31ddbb15$export$321543c11f6250ad();
        return;
    }
    $ac0b98ed31ddbb15$var$parseNewCallee();
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$3d50348827f45b9a)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $ac0b98ed31ddbb15$var$parseExprList((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
function $ac0b98ed31ddbb15$var$parseNewCallee() {
    $ac0b98ed31ddbb15$var$parseNoCallExpr();
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
}
function $ac0b98ed31ddbb15$export$2e2dbd43b49fd373() {
    // Finish `, read quasi
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
        $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
        // Finish }, read quasi
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    }
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $ac0b98ed31ddbb15$export$908e61e44ae774e(isPattern, isBlockScope) {
    // Attach a context ID to the object open and close brace and each object key.
    const contextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    let first = true;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        let isGenerator = false;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            const previousIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $90ed52daec368086$export$83bfd0877be8807a)();
            if (isPattern) {
                // Mark role when the only thing being spread over is an identifier.
                if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length === previousIndex + 2) (0, $90ed52daec368086$export$80e4117797ed03a6)(isBlockScope);
                if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
            }
            continue;
        }
        if (!isPattern) isGenerator = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        if (!isPattern && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) {
            if (isGenerator) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $ac0b98ed31ddbb15$export$321543c11f6250ad();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
            else {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    isGenerator = true;
                }
                $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(contextId);
            }
        } else $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(contextId);
        $ac0b98ed31ddbb15$var$parseObjPropValue(isPattern, isBlockScope, contextId);
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
}
function $ac0b98ed31ddbb15$var$isGetterOrSetterMethod(isPattern) {
    // We go off of the next and don't bother checking if the node key is actually "get" or "set".
    // This lets us avoid generating a node, and should only make the validation worse.
    return !isPattern && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || // get "string"() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || // get 1() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || // get ["string"]() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // get foo() {}
    !!((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) // get debugger() {}
    );
}
// Returns true if this was a method.
function $ac0b98ed31ddbb15$var$parseObjectMethod(isPattern, objectContextId) {
    // We don't need to worry about modifiers because object methods can't have optional bodies, so
    // the start will never be used.
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        if (isPattern) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    if ($ac0b98ed31ddbb15$var$isGetterOrSetterMethod(isPattern)) {
        $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(objectContextId);
        $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    return false;
}
function $ac0b98ed31ddbb15$var$parseObjectProperty(isPattern, isBlockScope) {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        if (isPattern) (0, $90ed52daec368086$export$867fe1bcec5186c9)(isBlockScope);
        else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false);
        return;
    }
    // Since there's no colon, we assume this is an object shorthand.
    // If we're in a destructuring, we've now discovered that the key was actually an assignee, so
    // we need to tag it as a declaration with the appropriate scope. Otherwise, we might need to
    // transform it on access, so mark it as a normal object shorthand.
    let identifierRole;
    if (isPattern) {
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandTopLevelDeclaration;
        else if (isBlockScope) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandBlockScopedDeclaration;
        else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandFunctionScopedDeclaration;
    } else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
    // Regardless of whether we know this to be a pattern or if we're in an ambiguous context, allow
    // parsing as if there's a default value.
    (0, $90ed52daec368086$export$867fe1bcec5186c9)(isBlockScope, true);
}
function $ac0b98ed31ddbb15$var$parseObjPropValue(isPattern, isBlockScope, objectContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$f7c2ce498525881a)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$73c225682ce16be1)();
    const wasMethod = $ac0b98ed31ddbb15$var$parseObjectMethod(isPattern, objectContextId);
    if (!wasMethod) $ac0b98ed31ddbb15$var$parseObjectProperty(isPattern, isBlockScope);
}
function $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(objectContextId) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$addd776ef798f4b2)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    } else {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal)) $ac0b98ed31ddbb15$export$fa61731cf32bc243();
        else $ac0b98ed31ddbb15$var$parseMaybePrivateName();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    }
}
function $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, isConstructor) {
    const funcContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const allowModifiers = isConstructor; // For TypeScript parameter properties
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)(allowModifiers, funcContextId);
    $ac0b98ed31ddbb15$export$85b927192bdce5b9(functionStart, funcContextId);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex) {
    $ac0b98ed31ddbb15$export$50f85c246417e18(true);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $ac0b98ed31ddbb15$export$85b927192bdce5b9(functionStart, funcContextId = 0) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$3c36bc5140dd8c64)(functionStart, funcContextId);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$8dd4098a83322b31)(funcContextId);
    else $ac0b98ed31ddbb15$export$50f85c246417e18(false, funcContextId);
}
function $ac0b98ed31ddbb15$export$50f85c246417e18(allowExpression, funcContextId = 0) {
    const isExpression = allowExpression && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if (isExpression) $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
    else (0, $8a4e0068a7ab0607$export$4aed668c47d45036)(true, funcContextId);
}
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
function $ac0b98ed31ddbb15$var$parseExprList(close, allowEmpty = false) {
    let first = true;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(close) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)(close)) break;
        }
        $ac0b98ed31ddbb15$var$parseExprListItem(allowEmpty);
    }
}
function $ac0b98ed31ddbb15$var$parseExprListItem(allowEmpty) {
    if (allowEmpty && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
        (0, $90ed52daec368086$export$83bfd0877be8807a)();
        $ac0b98ed31ddbb15$var$parseParenItem();
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) // Partial function application proposal.
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false, true);
}
function $ac0b98ed31ddbb15$export$321543c11f6250ad() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
}
// Parses await expression inside async function.
function $ac0b98ed31ddbb15$var$parseAwait() {
    $ac0b98ed31ddbb15$export$165911d2b803e372();
}
// Parses yield expression inside generator.
function $ac0b98ed31ddbb15$var$parseYield() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
    }
}
// https://github.com/tc39/proposal-js-module-blocks
function $ac0b98ed31ddbb15$var$parseModuleExpression() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    // For now, just call parseBlockBody to parse the block. In the future when we
    // implement full support, we'll want to emit scopes and possibly other
    // information.
    (0, $8a4e0068a7ab0607$export$e5110a9b2ab486ee)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}




function $406735a56f0f5eb4$var$isMaybeDefaultImport(lookahead) {
    return (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || !!(lookahead.type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD)) && lookahead.contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from;
}
function $406735a56f0f5eb4$var$flowParseTypeInitialiser(tok) {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)(tok || (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $406735a56f0f5eb4$var$flowParseType();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParsePredicate() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo);
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._checks);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    }
}
function $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) $406735a56f0f5eb4$var$flowParsePredicate();
    else {
        $406735a56f0f5eb4$var$flowParseType();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) $406735a56f0f5eb4$var$flowParsePredicate();
    }
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseDeclareClass() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseInterfaceish(/* isClass */ true);
}
function $406735a56f0f5eb4$var$flowParseDeclareFunction() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclare() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) $406735a56f0f5eb4$var$flowParseDeclareClass();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) $406735a56f0f5eb4$var$flowParseDeclareFunction();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var)) $406735a56f0f5eb4$var$flowParseDeclareVariable();
    else if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module)) {
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $406735a56f0f5eb4$var$flowParseDeclareModuleExports();
        else $406735a56f0f5eb4$var$flowParseDeclareModule();
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) $406735a56f0f5eb4$var$flowParseDeclareTypeAlias();
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque)) $406735a56f0f5eb4$var$flowParseDeclareOpaqueType();
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) $406735a56f0f5eb4$var$flowParseDeclareInterface();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)) $406735a56f0f5eb4$var$flowParseDeclareExportDeclaration();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseDeclareVariable() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclareModule() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $8a4e0068a7ab0607$export$532df1d0416e9789)();
    } else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $406735a56f0f5eb4$var$flowParseDeclareExportDeclaration() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) // declare export default class ...
        // declare export default function ...
        $406735a56f0f5eb4$var$flowParseDeclare();
        else {
            // declare export default [type];
            $406735a56f0f5eb4$var$flowParseType();
            (0, $485552d236f25875$export$62fa27d385e555f3)();
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || // declare export var ...
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || // declare export function ...
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || // declare export class ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) // declare export opaque ..
    ) $406735a56f0f5eb4$var$flowParseDeclare();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || // declare export * from ''
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || // declare export {} ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) || // declare export interface ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || // declare export type ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) // declare export opaque type ...
    ) (0, $8a4e0068a7ab0607$export$3d6d7ef9486a61c3)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseDeclareModuleExports() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._exports);
    $406735a56f0f5eb4$export$6c833037db1a1e96();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclareTypeAlias() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseTypeAlias();
}
function $406735a56f0f5eb4$var$flowParseDeclareOpaqueType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseOpaqueType(true);
}
function $406735a56f0f5eb4$var$flowParseDeclareInterface() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseInterfaceish();
}
// Interfaces
function $406735a56f0f5eb4$var$flowParseInterfaceish(isClass = false) {
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
    while (!isClass && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._mixins)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
        while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
        while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    }
    $406735a56f0f5eb4$var$flowParseObjectType(isClass, false, isClass);
}
function $406735a56f0f5eb4$var$flowParseInterfaceExtends() {
    $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(false);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
}
function $406735a56f0f5eb4$var$flowParseInterface() {
    $406735a56f0f5eb4$var$flowParseInterfaceish();
}
function $406735a56f0f5eb4$var$flowParseRestrictedIdentifier() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseTypeAlias() {
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseOpaqueType(declare) {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    // Parse the supertype
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    if (!declare) $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseTypeParameter() {
    $406735a56f0f5eb4$export$addd776ef798f4b2();
    $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$export$d1d23833c686097a() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    // istanbul ignore else: this condition is already checked at all call sites
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    do {
        $406735a56f0f5eb4$var$flowParseTypeParameter();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }while (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseType();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseInterfaceType() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
    while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    $406735a56f0f5eb4$var$flowParseObjectType(false, false, false);
}
function $406735a56f0f5eb4$var$flowParseObjectPropertyKey() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeIndexer() {
    // Note: bracketL has already been consumed
    if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) {
        $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    } else $406735a56f0f5eb4$var$flowParseType();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeInternalSlot() {
    // Note: both bracketL have already been consumed
    $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
    else {
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    }
}
function $406735a56f0f5eb4$var$flowParseObjectTypeMethodish() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeCallProperty() {
    $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
}
function $406735a56f0f5eb4$var$flowParseObjectType(allowStatic, allowExact, allowProto) {
    let endDelim;
    if (allowExact && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL)) {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL);
        endDelim = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR;
    } else {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        endDelim = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR;
    }
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)(endDelim) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (allowProto && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._proto)) {
            const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon && lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                allowStatic = false;
            }
        }
        if (allowStatic && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static)) {
            const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon && lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        $406735a56f0f5eb4$export$addd776ef798f4b2();
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) $406735a56f0f5eb4$var$flowParseObjectTypeInternalSlot();
            else $406735a56f0f5eb4$var$flowParseObjectTypeIndexer();
        } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseObjectTypeCallProperty();
        else {
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set)) {
                const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                if (lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            }
            $406735a56f0f5eb4$var$flowParseObjectTypeProperty();
        }
        $406735a56f0f5eb4$var$flowObjectTypeSemicolon();
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)(endDelim);
}
function $406735a56f0f5eb4$var$flowParseObjectTypeProperty() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
        // Explicit inexact object syntax.
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        $406735a56f0f5eb4$var$flowParseType();
    } else {
        $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // This is a method property
        $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
        else {
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
            $406735a56f0f5eb4$var$flowParseTypeInitialiser();
        }
    }
}
function $406735a56f0f5eb4$var$flowObjectTypeSemicolon() {
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) && !(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(initialIdAlreadyParsed) {
    if (!initialIdAlreadyParsed) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseGenericType() {
    $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(true);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
}
function $406735a56f0f5eb4$var$flowParseTypeofType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof);
    $406735a56f0f5eb4$var$flowParsePrimaryType();
}
function $406735a56f0f5eb4$var$flowParseTupleType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    // We allow trailing commas
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)){
        $406735a56f0f5eb4$var$flowParseType();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) break;
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
}
function $406735a56f0f5eb4$var$flowParseFunctionTypeParam() {
    const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
    if (lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    } else $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$var$flowParseFunctionTypeParams() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
}
// The parsing of types roughly parallels the parsing of expressions, and
// primary types are kind of like primary expressions...they're the
// primitives with which other types are constructed.
function $406735a56f0f5eb4$var$flowParsePrimaryType() {
    let isGroupedType = false;
    const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
                $406735a56f0f5eb4$var$flowParseInterfaceType();
                return;
            }
            (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
            $406735a56f0f5eb4$var$flowParseGenericType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $406735a56f0f5eb4$var$flowParseObjectType(false, false, false);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL:
            $406735a56f0f5eb4$var$flowParseObjectType(false, true, false);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            $406735a56f0f5eb4$var$flowParseTupleType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan:
            $406735a56f0f5eb4$export$d1d23833c686097a();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
            $406735a56f0f5eb4$var$flowParseType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            // Check to see if this is actually a grouped type
            if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    const token = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                    isGroupedType = token !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question && token !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon;
                } else isGroupedType = true;
            }
            if (isGroupedType) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = false;
                $406735a56f0f5eb4$var$flowParseType();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
                // A `,` or a `) =>` means this is an anonymous function type
                if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType || !((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                    return;
                } else // Eat a comma if there is one
                (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            }
            $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
            $406735a56f0f5eb4$var$flowParseType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return;
        default:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof) {
                $406735a56f0f5eb4$var$flowParseTypeofType();
                return;
            } else if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                return;
            }
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParsePostfixType() {
    $406735a56f0f5eb4$var$flowParsePrimaryType();
    while(!(0, $485552d236f25875$export$1c0919cee6560c3)() && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot))){
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) ;
        else {
            // Indexed access type
            $406735a56f0f5eb4$var$flowParseType();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        }
    }
}
function $406735a56f0f5eb4$var$flowParsePrefixType() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) $406735a56f0f5eb4$var$flowParsePrefixType();
    else $406735a56f0f5eb4$var$flowParsePostfixType();
}
function $406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens() {
    $406735a56f0f5eb4$var$flowParsePrefixType();
    if (!(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$var$flowParseIntersectionType() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND);
    $406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND))$406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens();
}
function $406735a56f0f5eb4$var$flowParseUnionType() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR);
    $406735a56f0f5eb4$var$flowParseIntersectionType();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR))$406735a56f0f5eb4$var$flowParseIntersectionType();
}
function $406735a56f0f5eb4$var$flowParseType() {
    $406735a56f0f5eb4$var$flowParseUnionType();
}
function $406735a56f0f5eb4$export$6c833037db1a1e96() {
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
}
function $406735a56f0f5eb4$export$addd776ef798f4b2() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    }
}
function $406735a56f0f5eb4$export$8dd4098a83322b31(funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(false, funcContextId);
}
function $406735a56f0f5eb4$export$4eb11794b3b71235(startTokenIndex, noCalls, stopState) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) {
        if (noCalls) {
            stopState.stop = true;
            return;
        }
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        return;
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    }
    (0, $ac0b98ed31ddbb15$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $406735a56f0f5eb4$export$3d50348827f45b9a() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $406735a56f0f5eb4$export$d29f5a1d65cdba9d() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseInterface();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        return true;
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
        $406735a56f0f5eb4$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $406735a56f0f5eb4$export$c6f815d203f26c4f() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
        $406735a56f0f5eb4$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $406735a56f0f5eb4$export$3b5c354482eb1586(contextualKeyword) {
    if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseDeclare();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseInterface();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseTypeAlias();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseOpaqueType(false);
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        }
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$export$74061750bc0f2203() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
}
function $406735a56f0f5eb4$export$8a047f67d2009628() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
}
function $406735a56f0f5eb4$export$64e87490a40a8a82() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            // export type { foo, bar };
            (0, $8a4e0068a7ab0607$export$909d3b50f7924101)();
            (0, $8a4e0068a7ab0607$export$49b6f13e189abea3)();
        } else // export type Foo = Bar;
        $406735a56f0f5eb4$var$flowParseTypeAlias();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        // export opaque type Foo = Bar;
        $406735a56f0f5eb4$var$flowParseOpaqueType(false);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseInterface();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
}
function $406735a56f0f5eb4$export$563bbc61583bd08() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star;
}
function $406735a56f0f5eb4$export$dc2ba80ebf42d8d6() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
        (0, $8a4e0068a7ab0607$export$18fb3cb64b956ba0)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else (0, $8a4e0068a7ab0607$export$18fb3cb64b956ba0)();
}
function $406735a56f0f5eb4$export$131557296be11580(hasSuper) {
    if (hasSuper && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._implements;
        do {
            $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        }while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $406735a56f0f5eb4$export$73c225682ce16be1() {
    // method shorthand
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        $406735a56f0f5eb4$export$d1d23833c686097a();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
}
function $406735a56f0f5eb4$export$a9031cdcb39989e3() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$export$2ca2c81ecd0ec221() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const lh = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if ($406735a56f0f5eb4$var$isMaybeDefaultImport(lh) || lh.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL || lh.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
}
function $406735a56f0f5eb4$export$217da275bf556fe8() {
    const isTypeKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof;
    if (isTypeKeyword) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as) && !(0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if (isTypeKeyword && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD)) ;
        else // `import {type as foo`
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    } else {
        if (isTypeKeyword && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || !!((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD))) // `import {type foo`
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    }
}
function $406735a56f0f5eb4$export$e3b9ccf4c3c69613() {
    // Originally this checked if the method is a getter/setter, but if it was, we'd crash soon
    // anyway, so don't try to propagate that information.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        $406735a56f0f5eb4$export$d1d23833c686097a();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $406735a56f0f5eb4$export$273b459834534d69() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
}
function $406735a56f0f5eb4$export$6c11d14a2632a0dc() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $406735a56f0f5eb4$export$6c833037db1a1e96();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
    }
}
function $406735a56f0f5eb4$export$abad2599830a7c66(noIn, isWithinParens) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        let wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
        } else return wasArrow;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        $406735a56f0f5eb4$export$d1d23833c686097a();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if (wasArrow) return true;
        (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
    return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $406735a56f0f5eb4$export$1ee5238ec4961bad() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
        if ((0, $485552d236f25875$export$1c0919cee6560c3)()) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $406735a56f0f5eb4$export$7c7ba3c0c5ae1f67(startTokenIndex, noCalls = false) {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        const wasArrow = $406735a56f0f5eb4$var$parseAsyncArrowWithTypeParameters();
        if (wasArrow && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    (0, $ac0b98ed31ddbb15$export$c2cc03eea353aa42)(startTokenIndex, noCalls);
}
// Returns true if there was an arrow function here.
function $406735a56f0f5eb4$var$parseAsyncArrowWithTypeParameters() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
    if (!(0, $ac0b98ed31ddbb15$export$92291a002e3a40fe)()) return false;
    (0, $ac0b98ed31ddbb15$export$9286d8f9fb90b029)(startTokenIndex);
    return true;
}
function $406735a56f0f5eb4$var$flowParseEnumDeclaration() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $406735a56f0f5eb4$var$flowParseEnumBody();
}
function $406735a56f0f5eb4$var$flowParseEnumBody() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    $406735a56f0f5eb4$var$flowParseEnumMembers();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $406735a56f0f5eb4$var$flowParseEnumMembers() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) break;
        $406735a56f0f5eb4$var$flowParseEnumMember();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $406735a56f0f5eb4$var$flowParseEnumMember() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // Flow enum values are always just one token (a string, number, or boolean literal).
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}












function $8a4e0068a7ab0607$export$cb09d803724ddba2() {
    $8a4e0068a7ab0607$export$e5110a9b2ab486ee((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(0, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length, true));
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth !== 0) throw new Error(`Invalid scope depth at end of file: ${(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth}`);
    return new (0, $201427b598292105$export$b6afa8811b7e644e)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes);
}
function $8a4e0068a7ab0607$export$68b986de0b252bc8(declaration) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $406735a56f0f5eb4$export$d29f5a1d65cdba9d)()) return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) $8a4e0068a7ab0607$export$3f4d9519f687227a();
    $8a4e0068a7ab0607$var$parseStatementContent(declaration);
}
function $8a4e0068a7ab0607$var$parseStatementContent(declaration) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$bd8d07f8ee509b14)()) return;
    }
    const starttype = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._break:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._continue:
            $8a4e0068a7ab0607$var$parseBreakContinueStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._debugger:
            $8a4e0068a7ab0607$var$parseDebuggerStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do:
            $8a4e0068a7ab0607$var$parseDoStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._for:
            $8a4e0068a7ab0607$var$parseForStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) break;
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $8a4e0068a7ab0607$var$parseFunctionStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $8a4e0068a7ab0607$export$542081d93172af(true);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._if:
            $8a4e0068a7ab0607$var$parseIfStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._return:
            $8a4e0068a7ab0607$var$parseReturnStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._switch:
            $8a4e0068a7ab0607$var$parseSwitchStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._throw:
            $8a4e0068a7ab0607$var$parseThrowStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._try:
            $8a4e0068a7ab0607$var$parseTryStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const:
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)(); // NOTE: falls through to _var
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var:
            $8a4e0068a7ab0607$export$73f0614724a3919a(starttype !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while:
            $8a4e0068a7ab0607$var$parseWhileStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $8a4e0068a7ab0607$export$4aed668c47d45036();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi:
            $8a4e0068a7ab0607$var$parseEmptyStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            {
                const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) break;
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if (starttype === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) $8a4e0068a7ab0607$export$532df1d0416e9789();
                else $8a4e0068a7ab0607$export$3d6d7ef9486a61c3();
                return;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) {
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                // peek ahead and see if next token is a function
                const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function);
                    $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true);
                    return;
                } else (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            } else if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using && !(0, $485552d236f25875$export$a4f1ee8cbd9b31ba)() && // Statements like `using[0]` and `using in foo` aren't actual using
            // declarations.
            (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) {
                $8a4e0068a7ab0607$export$73f0614724a3919a(true);
                return;
            } else if ($8a4e0068a7ab0607$var$startsAwaitUsing()) {
                (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await);
                $8a4e0068a7ab0607$export$73f0614724a3919a(true);
                return;
            }
        default:
            break;
    }
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    const initialTokensLength = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    let simpleName = null;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length === initialTokensLength + 1) {
        const token = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) simpleName = token.contextualKeyword;
    }
    if (simpleName == null) {
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return;
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $8a4e0068a7ab0607$var$parseLabeledStatement();
    else // This was an identifier, so we might want to handle flow/typescript-specific cases.
    $8a4e0068a7ab0607$var$parseIdentifierStatement(simpleName);
}
/**
 * Determine if we're positioned at an `await using` declaration.
 *
 * Note that this can happen either in place of a regular variable declaration
 * or in a loop body, and in both places, there are similar-looking cases where
 * we need to return false.
 *
 * Examples returning true:
 * await using foo = bar();
 * for (await using a of b) {}
 *
 * Examples returning false:
 * await using
 * await using + 1
 * await using instanceof T
 * for (await using;;) {}
 *
 * For now, we early return if we don't see `await`, then do a simple
 * backtracking-based lookahead for the `using` and identifier tokens. In the
 * future, this could be optimized with a character-based approach.
 */ function $8a4e0068a7ab0607$var$startsAwaitUsing() {
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await)) return false;
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    // await
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using) || (0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    // using
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return true;
}
function $8a4e0068a7ab0607$export$3f4d9519f687227a() {
    while((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at))$8a4e0068a7ab0607$var$parseDecorator();
}
function $8a4e0068a7ab0607$var$parseDecorator() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    } else {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        $8a4e0068a7ab0607$var$parseMaybeDecoratorArguments();
    }
}
function $8a4e0068a7ab0607$var$parseMaybeDecoratorArguments() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$fd0439ea9a1ac1ea)();
    else $8a4e0068a7ab0607$export$50c128b10ac5ea5b();
}
function $8a4e0068a7ab0607$export$50c128b10ac5ea5b() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
}
function $8a4e0068a7ab0607$var$parseBreakContinueStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseDebuggerStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseDoStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while);
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
}
function $8a4e0068a7ab0607$var$parseForStatement() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $8a4e0068a7ab0607$var$parseAmbiguousForStatement();
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
/**
 * Determine if this token is a `using` declaration (explicit resource
 * management) as part of a loop.
 * https://github.com/tc39/proposal-explicit-resource-management
 */ function $8a4e0068a7ab0607$var$isUsingInLoop() {
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using)) return false;
    // This must be `for (using of`, where `using` is the name of the loop
    // variable.
    if ((0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) return false;
    return true;
}
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
function $8a4e0068a7ab0607$var$parseAmbiguousForStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    let forAwait = false;
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await)) {
        forAwait = true;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) {
        if (forAwait) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        $8a4e0068a7ab0607$var$parseFor();
        return;
    }
    const isAwaitUsing = $8a4e0068a7ab0607$var$startsAwaitUsing();
    if (isAwaitUsing || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) || $8a4e0068a7ab0607$var$isUsingInLoop()) {
        if (isAwaitUsing) (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $8a4e0068a7ab0607$var$parseVar(true, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
            $8a4e0068a7ab0607$var$parseForIn(forAwait);
            return;
        }
        $8a4e0068a7ab0607$var$parseFor();
        return;
    }
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)(true);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
        $8a4e0068a7ab0607$var$parseForIn(forAwait);
        return;
    }
    if (forAwait) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    $8a4e0068a7ab0607$var$parseFor();
}
function $8a4e0068a7ab0607$var$parseFunctionStatement() {
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true);
}
function $8a4e0068a7ab0607$var$parseIfStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._else)) $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
function $8a4e0068a7ab0607$var$parseReturnStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (!(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseSwitchStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    // Don't bother validation; just go through any sequence of cases, defaults, and statements.
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
        const isCase = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if (isCase) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    } else $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Closing brace
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $8a4e0068a7ab0607$var$parseThrowStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseCatchClauseParam() {
    (0, $90ed52daec368086$export$e1f90e6766854abd)(true);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$e4623eb563192e0f)();
}
function $8a4e0068a7ab0607$var$parseTryStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$4aed668c47d45036();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        let catchBindingStartTokenIndex = null;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
            catchBindingStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            $8a4e0068a7ab0607$var$parseCatchClauseParam();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        }
        $8a4e0068a7ab0607$export$4aed668c47d45036();
        if (catchBindingStartTokenIndex != null) {
            // We need a special scope for the catch binding which includes the binding itself and the
            // catch block.
            const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(catchBindingStartTokenIndex, endTokenIndex, false));
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
        }
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._finally)) $8a4e0068a7ab0607$export$4aed668c47d45036();
}
function $8a4e0068a7ab0607$export$73f0614724a3919a(isBlockScope) {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$var$parseVar(false, isBlockScope);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseWhileStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
function $8a4e0068a7ab0607$var$parseEmptyStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $8a4e0068a7ab0607$var$parseLabeledStatement() {
    $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
/**
 * Parse a statement starting with an identifier of the given name. Subclasses match on the name
 * to handle statements like "declare".
 */ function $8a4e0068a7ab0607$var$parseIdentifierStatement(contextualKeyword) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$a642c15f5070c816)(contextualKeyword);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$3b5c354482eb1586)(contextualKeyword);
    else (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$export$4aed668c47d45036(isFunctionScope = false, contextId = 0) {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if (contextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    $8a4e0068a7ab0607$export$e5110a9b2ab486ee((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
    if (contextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, isFunctionScope));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $8a4e0068a7ab0607$export$e5110a9b2ab486ee(end) {
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(end) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)$8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
function $8a4e0068a7ab0607$var$parseFor() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
function $8a4e0068a7ab0607$var$parseForIn(forAwait) {
    if (forAwait) (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of);
    else (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
// Parse a list of variable declarations.
function $8a4e0068a7ab0607$var$parseVar(isFor, isBlockScope) {
    while(true){
        $8a4e0068a7ab0607$var$parseVarHead(isBlockScope);
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
            (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)(isFor);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        }
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) break;
    }
}
function $8a4e0068a7ab0607$var$parseVarHead(isBlockScope) {
    (0, $90ed52daec368086$export$e1f90e6766854abd)(isBlockScope);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$41c8703baf1bbf07)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$273b459834534d69)();
}
function $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, isStatement, optionalId = false) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (isStatement && !optionalId && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    let nameScopeStartTokenIndex = null;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        // Expression-style functions should limit their name's scope to the function body, so we make
        // a new function scope to enforce that.
        if (!isStatement) {
            nameScopeStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
        }
        (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    }
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    $8a4e0068a7ab0607$export$dd0fc1c64275f2c4();
    (0, $ac0b98ed31ddbb15$export$85b927192bdce5b9)(functionStart);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    // In addition to the block scope of the function body, we need a separate function-style scope
    // that includes the params.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    if (nameScopeStartTokenIndex !== null) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, true));
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $8a4e0068a7ab0607$export$dd0fc1c64275f2c4(allowModifiers = false, funcContextId = 0) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$ba34d58430377f94)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$e3b9ccf4c3c69613)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if (funcContextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
    (0, $90ed52daec368086$export$befa6d966a25698e)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, false, false, allowModifiers, funcContextId);
    if (funcContextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
}
function $8a4e0068a7ab0607$export$542081d93172af(isStatement, optionalId = false) {
    // Put a context ID on the class keyword, the open-brace, and the close-brace, so that later
    // code can easily navigate to meaningful points on the class.
    const contextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isExpression = !isStatement;
    // Like with functions, we declare a special "name scope" from the start of the name to the end
    // of the class, but only with expression-style classes, to represent the fact that the name is
    // available to the body of the class but not an outer declaration.
    let nameScopeStartTokenIndex = null;
    if (!isStatement) {
        nameScopeStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    }
    $8a4e0068a7ab0607$var$parseClassId(isStatement, optionalId);
    $8a4e0068a7ab0607$var$parseClassSuper();
    const openBraceIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $8a4e0068a7ab0607$var$parseClassBody(contextId);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[openBraceIndex].contextId = contextId;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    if (nameScopeStartTokenIndex !== null) {
        const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, false));
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $8a4e0068a7ab0607$var$isClassProperty() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
}
function $8a4e0068a7ab0607$var$isClassMethod() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
}
function $8a4e0068a7ab0607$var$parseClassBody(classContextId) {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) continue;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            $8a4e0068a7ab0607$var$parseDecorator();
            continue;
        }
        const memberStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
        $8a4e0068a7ab0607$var$parseClassMember(memberStart, classContextId);
    }
}
function $8a4e0068a7ab0607$var$parseClassMember(memberStart, classContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$77616e6d401f584a)([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    let isStatic = false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)(); // eats 'static'
        if ($8a4e0068a7ab0607$var$isClassMethod()) {
            $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
            return;
        } else if ($8a4e0068a7ab0607$var$isClassProperty()) {
            $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
            return;
        }
        // otherwise something static
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static;
        isStatic = true;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            // This is a static block. Mark the word "static" with the class context ID for class element
            // detection and parse as a regular block.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = classContextId;
            $8a4e0068a7ab0607$export$4aed668c47d45036();
            return;
        }
    }
    $8a4e0068a7ab0607$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId);
}
function $8a4e0068a7ab0607$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$9d02a6e20851f734)(isStatic)) return;
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        // a generator
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
        return;
    }
    // Get the identifier name so we can tell if it's actually a keyword like "async", "get", or
    // "set".
    $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
    let isConstructor = false;
    const token = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
    // We allow "constructor" as either an identifier or a string.
    if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) isConstructor = true;
    $8a4e0068a7ab0607$export$be741144f2438eed();
    if ($8a4e0068a7ab0607$var$isClassMethod()) $8a4e0068a7ab0607$var$parseClassMethod(memberStart, isConstructor);
    else if ($8a4e0068a7ab0607$var$isClassProperty()) $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    else if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async;
        // an async method
        const isGenerator = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        if (isGenerator) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        // The so-called parsed name would have been "async": get the real name.
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$export$be741144f2438eed();
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, false);
    } else if ((token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get || token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set) && !((0, $485552d236f25875$export$12d132b6e81066e4)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star))) {
        if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._get;
        else (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._set;
        // `get\n*` is an uninitialized property named 'get' followed by a generator.
        // a getter or setter
        // The so-called parsed name would have been "get/set": get the real name.
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
    } else if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._accessor && !(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    } else if ((0, $485552d236f25875$export$12d132b6e81066e4)()) // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
    $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $8a4e0068a7ab0607$var$parseClassMethod(functionStart, isConstructor) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$827faab4e65d5897)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) (0, $406735a56f0f5eb4$export$d1d23833c686097a)();
    }
    (0, $ac0b98ed31ddbb15$export$9b0b57f9abc43790)(functionStart, isConstructor);
}
function $8a4e0068a7ab0607$export$763528f37ffee534(classContextId) {
    (0, $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3)(classContextId);
}
function $8a4e0068a7ab0607$export$be741144f2438eed() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $8a4e0068a7ab0607$export$8c8d5281ed4948bc() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $19e70491d10f11e8$export$cb3e65614411a57c)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang);
        (0, $6ae90c8fc78a4682$export$e4623eb563192e0f)();
    } else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) (0, $406735a56f0f5eb4$export$6c833037db1a1e96)();
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        const equalsTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[equalsTokenIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseClassId(isStatement, optionalId = false) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (!isStatement || optionalId) && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) return;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) (0, $90ed52daec368086$export$7538cb03fa894c83)(true);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$827faab4e65d5897)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) (0, $406735a56f0f5eb4$export$d1d23833c686097a)();
    }
}
// Returns true if there was a superclass.
function $8a4e0068a7ab0607$var$parseClassSuper() {
    let hasSuper = false;
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) {
        (0, $ac0b98ed31ddbb15$export$dba7f678c228244a)();
        hasSuper = true;
    } else hasSuper = false;
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$ea9d02c53bf69095)(hasSuper);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$131557296be11580)(hasSuper);
}
function $8a4e0068a7ab0607$export$3d6d7ef9486a61c3() {
    const exportIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$6714566ca8db2f39)()) return;
    }
    // export * from '...'
    if ($8a4e0068a7ab0607$var$shouldParseExportStar()) $8a4e0068a7ab0607$var$parseExportStar();
    else if ($8a4e0068a7ab0607$var$isExportDefaultSpecifier()) {
        // export default from
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as);
            (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        } else $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe();
        $8a4e0068a7ab0607$export$49b6f13e189abea3();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) // export default ...
    $8a4e0068a7ab0607$var$parseExportDefaultExpression();
    else if ($8a4e0068a7ab0607$var$shouldParseExportDeclaration()) $8a4e0068a7ab0607$var$parseExportDeclaration();
    else {
        // export { x, y as z } [from '...']
        $8a4e0068a7ab0607$export$909d3b50f7924101();
        $8a4e0068a7ab0607$export$49b6f13e189abea3();
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[exportIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
}
function $8a4e0068a7ab0607$var$parseExportDefaultExpression() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$95d54e02ae7a0197)()) return;
    }
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $406735a56f0f5eb4$export$c6f815d203f26c4f)()) return;
    }
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true, true);
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) {
        // async function declaration
        (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async);
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function);
        $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true, true);
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) $8a4e0068a7ab0607$export$542081d93172af(true, true);
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
        $8a4e0068a7ab0607$export$3f4d9519f687227a();
        $8a4e0068a7ab0607$export$542081d93172af(true, true);
    } else {
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseExportDeclaration() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$b29e6741ccf6da0a)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$64e87490a40a8a82)();
    else $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
function $8a4e0068a7ab0607$var$isExportDefaultSpecifier() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $6ae90c8fc78a4682$export$5df75dadb7a629b6)()) return false;
    else if ((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $406735a56f0f5eb4$export$8a047f67d2009628)()) return false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async;
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return false;
    const _next = (0, $19e70491d10f11e8$export$1678d89ce52f4a6)();
    const lookahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
    const hasFrom = lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && lookahead.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from;
    if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) return true;
    // lookahead again when `export default from` is seen
    if (hasFrom) {
        const nextAfterFrom = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $19e70491d10f11e8$export$b8d8ba48247ea123)(_next + 4));
        return nextAfterFrom === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark || nextAfterFrom === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe;
    }
    return false;
}
function $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) $8a4e0068a7ab0607$export$909d3b50f7924101();
}
function $8a4e0068a7ab0607$export$49b6f13e189abea3() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
        (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
        $8a4e0068a7ab0607$var$maybeParseImportAttributes();
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$shouldParseExportStar() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$563bbc61583bd08)();
    else return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
}
function $8a4e0068a7ab0607$var$parseExportStar() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$dc2ba80ebf42d8d6)();
    else $8a4e0068a7ab0607$export$18fb3cb64b956ba0();
}
function $8a4e0068a7ab0607$export$18fb3cb64b956ba0() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) $8a4e0068a7ab0607$var$parseExportNamespace();
    else $8a4e0068a7ab0607$export$49b6f13e189abea3();
}
function $8a4e0068a7ab0607$var$parseExportNamespace() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as;
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe();
    $8a4e0068a7ab0607$export$49b6f13e189abea3();
}
function $8a4e0068a7ab0607$var$shouldParseExportDeclaration() {
    return (0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $6ae90c8fc78a4682$export$5df75dadb7a629b6)() || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $406735a56f0f5eb4$export$74061750bc0f2203)() || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at);
}
function $8a4e0068a7ab0607$export$909d3b50f7924101() {
    let first = true;
    // export { x, y as z } [from '...']
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        $8a4e0068a7ab0607$var$parseExportSpecifier();
    }
}
function $8a4e0068a7ab0607$var$parseExportSpecifier() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $6ae90c8fc78a4682$export$7994f3b86b6c7d1e)();
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
/**
 * Starting at the `module` token in an import, determine if it was truly an
 * import reflection token or just looks like one.
 *
 * Returns true for:
 * import module foo from "foo";
 * import module from from "foo";
 *
 * Returns false for:
 * import module from "foo";
 * import module, {bar} from "foo";
 */ function $8a4e0068a7ab0607$var$isImportReflection() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module);
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return true;
        } else {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    } else {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return true;
    }
}
/**
 * Eat the "module" token from the import reflection proposal.
 * https://github.com/tc39/proposal-import-reflection
 */ function $8a4e0068a7ab0607$var$parseMaybeImportReflection() {
    // isImportReflection does snapshot/restore, so only run it if we see the word
    // "module".
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && $8a4e0068a7ab0607$var$isImportReflection()) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $8a4e0068a7ab0607$export$532df1d0416e9789() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) {
        (0, $6ae90c8fc78a4682$export$bb14276cd4f56f44)();
        return;
    }
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const lookahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && lookahead.contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) {
            // One of these `import type` cases:
            // import type T = require('T');
            // import type A from 'A';
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
            if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) {
                (0, $6ae90c8fc78a4682$export$bb14276cd4f56f44)();
                return;
            }
        // If this is an `import type...from` statement, then we already ate the
        // type token, so proceed to the regular import parser.
        } else if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star || lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) // One of these `import type` cases, in which case we can eat the type token
        // and proceed as normal:
        // import type * as A from 'A';
        // import type {a} from 'A';
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
    // Otherwise, we are importing the name "type".
    }
    // import '...'
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else {
        $8a4e0068a7ab0607$var$parseMaybeImportReflection();
        $8a4e0068a7ab0607$var$parseImportSpecifiers();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from);
        (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    }
    $8a4e0068a7ab0607$var$maybeParseImportAttributes();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
// eslint-disable-next-line no-unused-vars
function $8a4e0068a7ab0607$var$shouldParseDefaultImport() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $8a4e0068a7ab0607$var$parseImportSpecifierLocal() {
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
}
// Parses a comma-separated list of module imports.
function $8a4e0068a7ab0607$var$parseImportSpecifiers() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$2ca2c81ecd0ec221)();
    let first = true;
    if ($8a4e0068a7ab0607$var$shouldParseDefaultImport()) {
        // import defaultObj, { x, y as z } from '...'
        $8a4e0068a7ab0607$var$parseImportSpecifierLocal();
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as);
        $8a4e0068a7ab0607$var$parseImportSpecifierLocal();
        return;
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            // Detect an attempt to deep destructure
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)("ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        $8a4e0068a7ab0607$var$parseImportSpecifier();
    }
}
function $8a4e0068a7ab0607$var$parseImportSpecifier() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $6ae90c8fc78a4682$export$718ece2f88417ffd)();
        return;
    }
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        (0, $406735a56f0f5eb4$export$217da275bf556fe8)();
        return;
    }
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $90ed52daec368086$export$cba413304e86fc0d)();
    }
}
/**
 * Parse import attributes like `with {type: "json"}`, or the legacy form
 * `assert {type: "json"}`.
 *
 * Import attributes technically have their own syntax, but are always parseable
 * as a plain JS object, so just do that for simplicity.
 */ function $8a4e0068a7ab0607$var$maybeParseImportAttributes() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $ac0b98ed31ddbb15$export$908e61e44ae774e)(false, false);
    }
}


function $5185ae49f7d9981e$export$f1c553d4f1a2351() {
    // If enabled, skip leading hashbang line.
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === 0 && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(0) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).numberSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).exclamationMark) (0, $19e70491d10f11e8$export$37e131e7c1112aff)(2);
    (0, $19e70491d10f11e8$export$be17f8ab6696df13)();
    return (0, $8a4e0068a7ab0607$export$cb09d803724ddba2)();
}


class $201427b598292105$export$b6afa8811b7e644e {
    constructor(tokens, scopes){
        this.tokens = tokens;
        this.scopes = scopes;
    }
}
function $201427b598292105$export$98e6a39c04603d36(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
    if (isFlowEnabled && isTypeScriptEnabled) throw new Error("Cannot combine flow and typescript plugins.");
    (0, $e406deb3d43fd58b$export$84bb9899435eeb61)(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const result = (0, $5185ae49f7d9981e$export$f1c553d4f1a2351)();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) throw (0, $e406deb3d43fd58b$export$2ca6ff5cad32970a)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
    return result;
}




function $a55849c89b8d74ae$export$2e2bcd8739ae039(tokens) {
    let index = tokens.currentIndex();
    let depth = 0;
    const startToken = tokens.currentToken();
    do {
        const token = tokens.tokens[index];
        if (token.isOptionalChainStart) depth++;
        if (token.isOptionalChainEnd) depth--;
        depth += token.numNullishCoalesceStarts;
        depth -= token.numNullishCoalesceEnds;
        if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await && token.identifierRole == null && token.scopeDepth === startToken.scopeDepth) return true;
        index += 1;
    }while (depth > 0 && index < tokens.tokens.length);
    return false;
}


class $8e1a59465c201e5d$export$2e2bcd8739ae039 {
    __init() {
        this.resultCode = "";
    }
    // Array mapping input token index to optional string index position in the
    // output code.
    __init2() {
        this.resultMappings = new Array(this.tokens.length);
    }
    __init3() {
        this.tokenIndex = 0;
    }
    constructor(code, tokens, isFlowEnabled, disableESTransforms, helperManager){
        this.code = code;
        this.tokens = tokens;
        this.isFlowEnabled = isFlowEnabled;
        this.disableESTransforms = disableESTransforms;
        this.helperManager = helperManager;
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init.call(this);
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init3.call(this);
    }
    /**
   * Snapshot the token state in a way that can be restored later, useful for
   * things like lookahead.
   *
   * resultMappings do not need to be copied since in all use cases, they will
   * be overwritten anyway after restore.
   */ snapshot() {
        return {
            resultCode: this.resultCode,
            tokenIndex: this.tokenIndex
        };
    }
    restoreToSnapshot(snapshot) {
        this.resultCode = snapshot.resultCode;
        this.tokenIndex = snapshot.tokenIndex;
    }
    /**
   * Remove and return the code generated since the snapshot, leaving the
   * current token position in-place. Unlike most TokenProcessor operations,
   * this operation can result in input/output line number mismatches because
   * the removed code may contain newlines, so this operation should be used
   * sparingly.
   */ dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot) {
        const result = this.resultCode.slice(snapshot.resultCode.length);
        this.resultCode = snapshot.resultCode;
        return result;
    }
    reset() {
        this.resultCode = "";
        this.resultMappings = new Array(this.tokens.length);
        this.tokenIndex = 0;
    }
    matchesContextualAtIndex(index, contextualKeyword) {
        return this.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens[index].contextualKeyword === contextualKeyword;
    }
    identifierNameAtIndex(index) {
        // TODO: We need to process escapes since technically you can have unicode escapes in variable
        // names.
        return this.identifierNameForToken(this.tokens[index]);
    }
    identifierNameAtRelativeIndex(relativeIndex) {
        return this.identifierNameForToken(this.tokenAtRelativeIndex(relativeIndex));
    }
    identifierName() {
        return this.identifierNameForToken(this.currentToken());
    }
    identifierNameForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    rawCodeForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    stringValueAtIndex(index) {
        return this.stringValueForToken(this.tokens[index]);
    }
    stringValue() {
        return this.stringValueForToken(this.currentToken());
    }
    stringValueForToken(token) {
        // This is used to identify when two imports are the same and to resolve TypeScript enum keys.
        // Ideally we'd process escapes within the strings, but for now we pretty much take the raw
        // code.
        return this.code.slice(token.start + 1, token.end - 1);
    }
    matches1AtIndex(index, t1) {
        return this.tokens[index].type === t1;
    }
    matches2AtIndex(index, t1, t2) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2;
    }
    matches3AtIndex(index, t1, t2, t3) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2 && this.tokens[index + 2].type === t3;
    }
    matches1(t1) {
        return this.tokens[this.tokenIndex].type === t1;
    }
    matches2(t1, t2) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2;
    }
    matches3(t1, t2, t3) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3;
    }
    matches4(t1, t2, t3, t4) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4;
    }
    matches5(t1, t2, t3, t4, t5) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4 && this.tokens[this.tokenIndex + 4].type === t5;
    }
    matchesContextual(contextualKeyword) {
        return this.matchesContextualAtIndex(this.tokenIndex, contextualKeyword);
    }
    matchesContextIdAndLabel(type, contextId) {
        return this.matches1(type) && this.currentToken().contextId === contextId;
    }
    previousWhitespaceAndComments() {
        let whitespaceAndComments = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
        if (this.isFlowEnabled) whitespaceAndComments = whitespaceAndComments.replace(/@flow/g, "");
        return whitespaceAndComments;
    }
    replaceToken(newCode) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    replaceTokenTrimmingLeftWhitespace(newCode) {
        this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, "");
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    removeInitialToken() {
        this.replaceToken("");
    }
    removeToken() {
        this.replaceTokenTrimmingLeftWhitespace("");
    }
    /**
   * Remove all code until the next }, accounting for balanced braces.
   */ removeBalancedCode() {
        let braceDepth = 0;
        while(!this.isAtEnd()){
            if (this.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) braceDepth++;
            else if (this.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            this.removeToken();
        }
    }
    copyExpectedToken(tokenType) {
        if (this.tokens[this.tokenIndex].type !== tokenType) throw new Error(`Expected token ${tokenType}`);
        this.copyToken();
    }
    copyToken() {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    copyTokenWithPrefix(prefix) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultCode += prefix;
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    appendTokenPrefix() {
        const token = this.currentToken();
        if (token.numNullishCoalesceStarts || token.isOptionalChainStart) token.isAsyncOperation = (0, $a55849c89b8d74ae$export$2e2bcd8739ae039)(this);
        if (this.disableESTransforms) return;
        if (token.numNullishCoalesceStarts) for(let i = 0; i < token.numNullishCoalesceStarts; i++){
            if (token.isAsyncOperation) {
                this.resultCode += "await ";
                this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce");
            } else this.resultCode += this.helperManager.getHelperName("nullishCoalesce");
            this.resultCode += "(";
        }
        if (token.isOptionalChainStart) {
            if (token.isAsyncOperation) this.resultCode += "await ";
            if (this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete) {
                if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete");
                else this.resultCode += this.helperManager.getHelperName("optionalChainDelete");
            } else if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChain");
            else this.resultCode += this.helperManager.getHelperName("optionalChain");
            this.resultCode += "([";
        }
    }
    appendTokenSuffix() {
        const token = this.currentToken();
        if (token.isOptionalChainEnd && !this.disableESTransforms) this.resultCode += "])";
        if (token.numNullishCoalesceEnds && !this.disableESTransforms) for(let i = 0; i < token.numNullishCoalesceEnds; i++)this.resultCode += "))";
    }
    appendCode(code) {
        this.resultCode += code;
    }
    currentToken() {
        return this.tokens[this.tokenIndex];
    }
    currentTokenCode() {
        const token = this.currentToken();
        return this.code.slice(token.start, token.end);
    }
    tokenAtRelativeIndex(relativeIndex) {
        return this.tokens[this.tokenIndex + relativeIndex];
    }
    currentIndex() {
        return this.tokenIndex;
    }
    /**
   * Move to the next token. Only suitable in preprocessing steps. When
   * generating new code, you should use copyToken or removeToken.
   */ nextToken() {
        if (this.tokenIndex === this.tokens.length) throw new Error("Unexpectedly reached end of input.");
        this.tokenIndex++;
    }
    previousToken() {
        this.tokenIndex--;
    }
    finish() {
        if (this.tokenIndex !== this.tokens.length) throw new Error("Tried to finish processing tokens before reaching the end.");
        this.resultCode += this.previousWhitespaceAndComments();
        return {
            code: this.resultCode,
            mappings: this.resultMappings
        };
    }
    isAtEnd() {
        return this.tokenIndex === this.tokens.length;
    }
}






function $e3f8f159d7f2a3fc$export$2e2bcd8739ae039(rootTransformer, tokens, nameManager, disableESTransforms) {
    const snapshot = tokens.snapshot();
    const headerInfo = $e3f8f159d7f2a3fc$var$processClassHeader(tokens);
    let constructorInitializerStatements = [];
    const instanceInitializerNames = [];
    const staticInitializerNames = [];
    let constructorInsertPos = null;
    const fields = [];
    const rangesToRemove = [];
    const classContextId = tokens.currentToken().contextId;
    if (classContextId == null) throw new Error("Expected non-null class context ID on class open-brace.");
    tokens.nextToken();
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, classContextId)){
        if (tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $e3f8f159d7f2a3fc$var$processConstructor(tokens));
        else if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) {
            if (!disableESTransforms) rangesToRemove.push({
                start: tokens.currentIndex(),
                end: tokens.currentIndex() + 1
            });
            tokens.nextToken();
        } else if (tokens.currentToken().isType) tokens.nextToken();
        else {
            // Either a method or a field. Skip to the identifier part.
            const statementStartIndex = tokens.currentIndex();
            let isStatic = false;
            let isESPrivate = false;
            let isDeclareOrAbstract = false;
            while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken())){
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static)) isStatic = true;
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash)) isESPrivate = true;
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare) || tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) isDeclareOrAbstract = true;
                tokens.nextToken();
            }
            if (isStatic && tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                // This is a static block, so don't process it in any special way.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (isESPrivate) {
                // Sucrase doesn't attempt to transpile private fields; just leave them as-is.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) {
                ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $e3f8f159d7f2a3fc$var$processConstructor(tokens));
                continue;
            }
            const nameStartIndex = tokens.currentIndex();
            $e3f8f159d7f2a3fc$var$skipFieldName(tokens);
            if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                // This is a method, so nothing to process.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            // There might be a type annotation that we need to skip.
            while(tokens.currentToken().isType)tokens.nextToken();
            if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                const equalsIndex = tokens.currentIndex();
                // This is an initializer, so we need to wrap in an initializer method.
                const valueEnd = tokens.currentToken().rhsEndIndex;
                if (valueEnd == null) throw new Error("Expected rhsEndIndex on class field assignment.");
                tokens.nextToken();
                while(tokens.currentIndex() < valueEnd)rootTransformer.processToken();
                let initializerName;
                if (isStatic) {
                    initializerName = nameManager.claimFreeName("__initStatic");
                    staticInitializerNames.push(initializerName);
                } else {
                    initializerName = nameManager.claimFreeName("__init");
                    instanceInitializerNames.push(initializerName);
                }
                // Fields start at the name, so `static x = 1;` has a field range of `x = 1;`.
                fields.push({
                    initializerName: initializerName,
                    equalsIndex: equalsIndex,
                    start: nameStartIndex,
                    end: tokens.currentIndex()
                });
            } else if (!disableESTransforms || isDeclareOrAbstract) // This is a regular field declaration, like `x;`. With the class transform enabled, we just
            // remove the line so that no output is produced. With the class transform disabled, we
            // usually want to preserve the declaration (but still strip types), but if the `declare`
            // or `abstract` keyword is specified, we should remove the line to avoid initializing the
            // value to undefined.
            rangesToRemove.push({
                start: statementStartIndex,
                end: tokens.currentIndex()
            });
        }
    }
    tokens.restoreToSnapshot(snapshot);
    if (disableESTransforms) // With ES transforms disabled, we don't want to transform regular class
    // field declarations, and we don't need to do any additional tricks to
    // reference the constructor for static init, but we still need to transform
    // TypeScript field initializers defined as constructor parameters and we
    // still need to remove `declare` fields. For now, we run the same code
    // path but omit any field information, as if the class had no field
    // declarations. In the future, when we fully drop the class fields
    // transform, we can simplify this code significantly.
    return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: [],
        staticInitializerNames: [],
        constructorInsertPos: constructorInsertPos,
        fields: [],
        rangesToRemove: rangesToRemove
    };
    else return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: instanceInitializerNames,
        staticInitializerNames: staticInitializerNames,
        constructorInsertPos: constructorInsertPos,
        fields: fields,
        rangesToRemove: rangesToRemove
    };
}
/**
 * Move the token processor to the next method/field in the class.
 *
 * To do that, we seek forward to the next start of a class name (either an open
 * bracket or an identifier, or the closing curly brace), then seek backward to
 * include any access modifiers.
 */ function $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId) {
    tokens.nextToken();
    while(tokens.currentToken().contextId !== classContextId)tokens.nextToken();
    while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.tokenAtRelativeIndex(-1)))tokens.previousToken();
}
function $e3f8f159d7f2a3fc$var$processClassHeader(tokens) {
    const classToken = tokens.currentToken();
    const contextId = classToken.contextId;
    if (contextId == null) throw new Error("Expected context ID on class token.");
    const isExpression = classToken.isExpression;
    if (isExpression == null) throw new Error("Expected isExpression on class token.");
    let className = null;
    let hasSuperclass = false;
    tokens.nextToken();
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) className = tokens.identifierName();
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, contextId)){
        // If this has a superclass, there will always be an `extends` token. If it doesn't have a
        // superclass, only type parameters and `implements` clauses can show up here, all of which
        // consist only of type tokens. A declaration like `class A<B extends C> {` should *not* count
        // as having a superclass.
        if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends) && !tokens.currentToken().isType) hasSuperclass = true;
        tokens.nextToken();
    }
    return {
        isExpression: isExpression,
        className: className,
        hasSuperclass: hasSuperclass
    };
}
/**
 * Extract useful information out of a constructor, starting at the "constructor" name.
 */ function $e3f8f159d7f2a3fc$var$processConstructor(tokens) {
    const constructorInitializerStatements = [];
    tokens.nextToken();
    const constructorContextId = tokens.currentToken().contextId;
    if (constructorContextId == null) throw new Error("Expected context ID on open-paren starting constructor params.");
    // Advance through parameters looking for access modifiers.
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, constructorContextId))if (tokens.currentToken().contextId === constructorContextId) {
        // Current token is an open paren or comma just before a param, so check
        // that param for access modifiers.
        tokens.nextToken();
        if ($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken())) {
            tokens.nextToken();
            while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken()))tokens.nextToken();
            const token = tokens.currentToken();
            if (token.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) throw new Error("Expected identifier after access modifiers in constructor arg.");
            const name = tokens.identifierNameForToken(token);
            constructorInitializerStatements.push(`this.${name} = ${name}`);
        }
    } else tokens.nextToken();
    // )
    tokens.nextToken();
    // Constructor type annotations are invalid, but skip them anyway since
    // they're easy to skip.
    while(tokens.currentToken().isType)tokens.nextToken();
    let constructorInsertPos = tokens.currentIndex();
    // Advance through body looking for a super call.
    let foundSuperCall = false;
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, constructorContextId)){
        if (!foundSuperCall && tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            tokens.nextToken();
            const superCallContextId = tokens.currentToken().contextId;
            if (superCallContextId == null) throw new Error("Expected a context ID on the super call");
            while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, superCallContextId))tokens.nextToken();
            constructorInsertPos = tokens.currentIndex();
            foundSuperCall = true;
        }
        tokens.nextToken();
    }
    // }
    tokens.nextToken();
    return {
        constructorInitializerStatements: constructorInitializerStatements,
        constructorInsertPos: constructorInsertPos
    };
}
/**
 * Determine if this is any token that can go before the name in a method/field.
 */ function $e3f8f159d7f2a3fc$var$isAccessModifier(token) {
    return [
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._get,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._set,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash
    ].includes(token.type);
}
/**
 * The next token or set of tokens is either an identifier or an expression in square brackets, for
 * a method or field name.
 */ function $e3f8f159d7f2a3fc$var$skipFieldName(tokens) {
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        const startToken = tokens.currentToken();
        const classContextId = startToken.contextId;
        if (classContextId == null) throw new Error("Expected class context ID on computed name open bracket.");
        while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, classContextId))tokens.nextToken();
        tokens.nextToken();
    } else tokens.nextToken();
}






function $f3fd7f90efbef058$export$2e2bcd8739ae039(tokens) {
    // import
    tokens.removeInitialToken();
    // name
    tokens.removeToken();
    // =
    tokens.removeToken();
    // name or require
    tokens.removeToken();
    // Handle either `import A = require('A')` or `import A = B.C.D`.
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        // (
        tokens.removeToken();
        // path string
        tokens.removeToken();
        // )
        tokens.removeToken();
    } else while(tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
        // .
        tokens.removeToken();
        // name
        tokens.removeToken();
    }
}




const $2755147e218a1b7a$export$cab8fec5d7ea8d7 = {
    typeDeclarations: new Set(),
    valueDeclarations: new Set()
};
function $2755147e218a1b7a$export$2e2bcd8739ae039(tokens) {
    const typeDeclarations = new Set();
    const valueDeclarations = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && (0, $19e70491d10f11e8$export$c08b4dec8c3c03d)(token)) {
            if (token.isType) typeDeclarations.add(tokens.identifierNameForToken(token));
            else valueDeclarations.add(tokens.identifierNameForToken(token));
        }
    }
    return {
        typeDeclarations: typeDeclarations,
        valueDeclarations: valueDeclarations
    };
}





function $b54a2e36959b8789$export$2e2bcd8739ae039(tokens) {
    let closeBraceIndex = tokens.currentIndex();
    while(!tokens.matches1AtIndex(closeBraceIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))closeBraceIndex++;
    return tokens.matchesContextualAtIndex(closeBraceIndex + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && tokens.matches1AtIndex(closeBraceIndex + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}




function $e01375f4457fb7f5$export$7e9be594554aa1b0(tokens) {
    if (tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert)) {
        // assert
        tokens.removeToken();
        // {
        tokens.removeToken();
        tokens.removeBalancedCode();
        // }
        tokens.removeToken();
    }
}



function $affb60ffa9c51f41$export$2e2bcd8739ae039(isTypeScriptTransformEnabled, keepUnusedImports, tokens, declarationInfo) {
    if (!isTypeScriptTransformEnabled || keepUnusedImports) return false;
    const exportToken = tokens.currentToken();
    if (exportToken.rhsEndIndex == null) throw new Error("Expected non-null rhsEndIndex on export token.");
    // The export must be of the form `export default a` or `export default a;`.
    const numTokens = exportToken.rhsEndIndex - tokens.currentIndex();
    if (numTokens !== 3 && !(numTokens === 4 && tokens.matches1AtIndex(exportToken.rhsEndIndex - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi))) return false;
    const identifierToken = tokens.tokenAtRelativeIndex(2);
    if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
    const exportedName = tokens.identifierNameForToken(identifierToken);
    return declarationInfo.typeDeclarations.has(exportedName) && !declarationInfo.valueDeclarations.has(exportedName);
}



class $384b44440831876e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.hadExport = false;
    }
    __init2() {
        this.hadNamedExport = false;
    }
    __init3() {
        this.hadDefaultExport = false;
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, enableLegacyTypeScriptModuleInterop, isTypeScriptTransformEnabled, isFlowTransformEnabled, preserveDynamicImport, keepUnusedImports){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.enableLegacyBabel5ModuleInterop = enableLegacyBabel5ModuleInterop;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.preserveDynamicImport = preserveDynamicImport;
        this.keepUnusedImports = keepUnusedImports;
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init.call(this);
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init3.call(this);
        this.declarationInfo = isTypeScriptTransformEnabled ? (0, $2755147e218a1b7a$export$2e2bcd8739ae039)(tokens) : (0, $2755147e218a1b7a$export$cab8fec5d7ea8d7);
    }
    getPrefixCode() {
        let prefix = "";
        if (this.hadExport) prefix += 'Object.defineProperty(exports, "__esModule", {value: true});';
        return prefix;
    }
    getSuffixCode() {
        if (this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport) return "\nmodule.exports = exports.default;\n";
        return "";
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
            this.processImport();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export) && !this.tokens.currentToken().isType) {
            this.hadExport = true;
            return this.processExport();
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).postIncDec)) {
            // Fall through to normal identifier matching if this doesn't apply.
            if (this.processPostIncDec()) return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName)) return this.processIdentifier();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processAssignment();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign)) return this.processComplexAssignment();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec)) return this.processPreIncDec();
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.importProcessor.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $f3fd7f90efbef058$export$2e2bcd8739ae039)(this.tokens);
        else // Otherwise, switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    /**
   * Transform this:
   * import foo, {bar} from 'baz';
   * into
   * var _baz = require('baz'); var _baz2 = _interopRequireDefault(_baz);
   *
   * The import code was already generated in the import preprocessing step, so
   * we just need to look it up.
   */ processImport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            if (this.preserveDynamicImport) {
                // Bail out, only making progress for this one token.
                this.tokens.copyToken();
                return;
            }
            const requireWrapper = this.enableLegacyTypeScriptModuleInterop ? "" : `${this.helperManager.getHelperName("interopRequireWildcard")}(`;
            this.tokens.replaceToken(`Promise.resolve().then(() => ${requireWrapper}require`);
            const contextId = this.tokens.currentToken().contextId;
            if (contextId == null) throw new Error("Expected context ID on dynamic import invocation.");
            this.tokens.copyToken();
            while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, contextId))this.rootTransformer.processToken();
            this.tokens.replaceToken(requireWrapper ? ")))" : "))");
            return;
        }
        const shouldElideImport = this.removeImportAndDetectIfShouldElide();
        if (shouldElideImport) this.tokens.removeToken();
        else {
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            this.tokens.appendCode(this.importProcessor.claimImportCode(path));
        }
        (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    /**
   * Erase this import (since any CJS output would be completely different), and
   * return true if this import is should be elided due to being a type-only
   * import. Such imports will not be emitted at all to avoid side effects.
   *
   * Import elision only happens with the TypeScript or Flow transforms enabled.
   *
   * TODO: This function has some awkward overlap with
   *  CJSImportProcessor.pruneTypeOnlyImports , and the two should be unified.
   *  That function handles TypeScript implicit import name elision, and removes
   *  an import if all typical imported names (without `type`) are removed due
   *  to being type-only imports. This function handles Flow import removal and
   *  properly distinguishes `import 'foo'` from `import {} from 'foo'` for TS
   *  purposes.
   *
   * The position should end at the import string.
   */ removeImportAndDetectIfShouldElide() {
        this.tokens.removeInitialToken();
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            // This is an "import type" statement, so exit early.
            this.removeRemainingImport();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            // We have a default import or namespace import, so there must be some
            // non-type import.
            this.removeRemainingImport();
            return false;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) // This is a bare import, so we should proceed with the import.
        return false;
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)){
            // Check if any named imports are of the form "foo" or "foo as bar", with
            // no leading "type".
            if (!foundNonTypeImport && this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
                this.tokens.removeToken();
                if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) foundAnyNamedImport = true;
                if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) foundNonTypeImport = true;
            }
            this.tokens.removeToken();
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    removeRemainingImport() {
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
    }
    processIdentifier() {
        const token = this.tokens.currentToken();
        if (token.shadowsGlobal) return false;
        if (token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand) return this.processObjectShorthand();
        if (token.identifierRole !== (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access) return false;
        const replacement = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(token));
        if (!replacement) return false;
        // Tolerate any number of closing parens while looking for an opening paren
        // that indicates a function call.
        let possibleOpenParenIndex = this.tokens.currentIndex() + 1;
        while(possibleOpenParenIndex < this.tokens.tokens.length && this.tokens.tokens[possibleOpenParenIndex].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)possibleOpenParenIndex++;
        // Avoid treating imported functions as methods of their `exports` object
        // by using `(0, f)` when the identifier is in a paren expression. Else
        // use `Function.prototype.call` when the identifier is a guaranteed
        // function call. When using `call`, pass undefined as the context.
        if (this.tokens.tokens[possibleOpenParenIndex].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) {
            if (this.tokens.tokenAtRelativeIndex(1).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL && this.tokens.tokenAtRelativeIndex(-1).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new) {
                this.tokens.replaceToken(`${replacement}.call(void 0, `);
                // Remove the old paren.
                this.tokens.removeToken();
                // Balance out the new paren.
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            } else // See here: http://2ality.com/2015/12/references.html
            this.tokens.replaceToken(`(0, ${replacement})`);
        } else this.tokens.replaceToken(replacement);
        return true;
    }
    processObjectShorthand() {
        const identifier = this.tokens.identifierName();
        const replacement = this.importProcessor.getIdentifierReplacement(identifier);
        if (!replacement) return false;
        this.tokens.replaceToken(`${identifier}: ${replacement}`);
        return true;
    }
    processExport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.hadNamedExport = true;
            // Let the TypeScript transform handle it.
            return false;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
            if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
                this.hadDefaultExport = true;
                // Flow export default enums need some special handling, so handle them
                // in that tranform rather than this one.
                return false;
            }
            this.processExportDefault();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.processExportBindings();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        this.hadNamedExport = true;
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const)) {
            this.processExportVar();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || // export async function
        this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            this.processExportFunction();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            this.processExportClass();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            this.processExportStar();
            return true;
        } else throw new Error("Unrecognized export syntax.");
    }
    processAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        // If the LHS is a type identifier, this must be a declaration like `let a: b = c;`,
        // with `b` as the identifier, so nothing needs to be done in that case.
        if (identifierToken.isType || identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        if (index >= 2 && [
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var,
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let,
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const
        ].includes(this.tokens.tokens[index - 2].type)) // Declarations don't need an extra assignment. This doesn't avoid the
        // assignment for comma-separated declarations, but it's still correct
        // since the assignment is just redundant.
        return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.copyToken();
        this.tokens.appendCode(` ${assignmentSnippet} =`);
        return true;
    }
    /**
   * Process something like `a += 3`, where `a` might be an exported value.
   */ processComplexAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(` = ${assignmentSnippet}`);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `++a`, where `a` might be an exported value.
   */ processPreIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        // Ignore things like ++a.b and ++a[b] and ++a().b.
        if (index + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) || this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL))) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(`${assignmentSnippet} = `);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `a++`, where `a` might be an exported value.
   * This starts at the `a`, not at the `++`.
   */ processPostIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index];
        const operatorToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 1 && this.tokens.matches1AtIndex(index - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        const operatorCode = this.tokens.rawCodeForToken(operatorToken);
        // We might also replace the identifier with something like exports.x, so
        // do that replacement here as well.
        const base = this.importProcessor.getIdentifierReplacement(identifierName) || identifierName;
        if (operatorCode === "++") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} + 1, ${base} - 1)`);
        else if (operatorCode === "--") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} - 1, ${base} + 1)`);
        else throw new Error(`Unexpected operator: ${operatorCode}`);
        this.tokens.removeToken();
        return true;
    }
    processExportDefault() {
        let exportedRuntimeValue = true;
        if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            // Named function export case: change it to a top-level function
            // declaration followed by exports statement.
            const name = this.processNamedFunction();
            this.tokens.appendCode(` exports.default = ${name};`);
        } else if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.copyDecorators();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
            const name = this.rootTransformer.processNamedClass();
            this.tokens.appendCode(` exports.default = ${name};`);
        // After this point, this is a plain "export default E" statement.
        } else if ((0, $affb60ffa9c51f41$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            exportedRuntimeValue = false;
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
        } else if (this.reactHotLoaderTransformer) {
            // We need to assign E to a variable. Change "export default E" to
            // "let _default; exports.default = _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; exports.`);
            this.tokens.copyToken();
            this.tokens.appendCode(` = ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
        } else {
            // Change "export default E" to "exports.default = E"
            this.tokens.replaceToken("exports.");
            this.tokens.copyToken();
            this.tokens.appendCode(" =");
        }
        if (exportedRuntimeValue) this.hadDefaultExport = true;
    }
    copyDecorators() {
        while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)){
            this.tokens.copyToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            } else {
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                }
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
                    this.rootTransformer.processBalancedCode();
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                }
            }
        }
    }
    /**
   * Transform a declaration like `export var`, `export let`, or `export const`.
   */ processExportVar() {
        if (this.isSimpleExportVar()) this.processSimpleExportVar();
        else this.processComplexExportVar();
    }
    /**
   * Determine if the export is of the form:
   * export var/let/const [varName] = [expr];
   * In other words, determine if function name inference might apply.
   */ isSimpleExportVar() {
        let tokenIndex = this.tokens.currentIndex();
        // export
        tokenIndex++;
        // var/let/const
        tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return false;
        tokenIndex++;
        while(tokenIndex < this.tokens.tokens.length && this.tokens.tokens[tokenIndex].isType)tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return false;
        return true;
    }
    /**
   * Transform an `export var` declaration initializing a single variable.
   *
   * For example, this:
   * export const f = () => {};
   * becomes this:
   * const f = () => {}; exports.f = f;
   *
   * The variable is unused (e.g. exports.f has the true value of the export).
   * We need to produce an assignment of this form so that the function will
   * have an inferred name of "f", which wouldn't happen in the more general
   * case below.
   */ processSimpleExportVar() {
        // export
        this.tokens.removeInitialToken();
        // var/let/const
        this.tokens.copyToken();
        const varName = this.tokens.identifierName();
        // x: number  ->  x
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq))this.rootTransformer.processToken();
        const endIndex = this.tokens.currentToken().rhsEndIndex;
        if (endIndex == null) throw new Error("Expected = token with an end index.");
        while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
        this.tokens.appendCode(`; exports.${varName} = ${varName}`);
    }
    /**
   * Transform normal declaration exports, including handling destructuring.
   * For example, this:
   * export const {x: [a = 2, b], c} = d;
   * becomes this:
   * ({x: [exports.a = 2, exports.b], c: exports.c} = d;)
   */ processComplexExportVar() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const needsParens = this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        if (needsParens) this.tokens.appendCode("(");
        let depth = 0;
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
                depth++;
                this.tokens.copyToken();
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) {
                depth--;
                this.tokens.copyToken();
            } else if (depth === 0 && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !this.tokens.currentToken().isType) break;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                // Default values might have assignments in the RHS that we want to ignore, so skip past
                // them.
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            } else {
                const token = this.tokens.currentToken();
                if ((0, $19e70491d10f11e8$export$31dc9881735f7118)(token)) {
                    const name = this.tokens.identifierName();
                    let replacement = this.importProcessor.getIdentifierReplacement(name);
                    if (replacement === null) throw new Error(`Expected a replacement for ${name} in \`export var\` syntax.`);
                    if ((0, $19e70491d10f11e8$export$dea1d79574e9c731)(token)) replacement = `${name}: ${replacement}`;
                    this.tokens.replaceToken(replacement);
                } else this.rootTransformer.processToken();
            }
        }
        if (needsParens) {
            // Seek to the end of the RHS.
            const endIndex = this.tokens.currentToken().rhsEndIndex;
            if (endIndex == null) throw new Error("Expected = token with an end index.");
            while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(")");
        }
    }
    /**
   * Transform this:
   * export function foo() {}
   * into this:
   * function foo() {} exports.foo = foo;
   */ processExportFunction() {
        this.tokens.replaceToken("");
        const name = this.processNamedFunction();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Skip past a function with a name and return that name.
   */ processNamedFunction() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) this.tokens.copyToken();
        else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            if (!this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) throw new Error("Expected async keyword in function export.");
            this.tokens.copyToken();
            this.tokens.copyToken();
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) this.tokens.copyToken();
        if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported function name.");
        const name = this.tokens.identifierName();
        this.tokens.copyToken();
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        this.rootTransformer.processPossibleTypeRange();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        return name;
    }
    /**
   * Transform this:
   * export class A {}
   * into this:
   * class A {} exports.A = A;
   */ processExportClass() {
        this.tokens.removeInitialToken();
        this.copyDecorators();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
        const name = this.rootTransformer.processNamedClass();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Transform this:
   * export {a, b as c};
   * into this:
   * exports.a = a; exports.c = b;
   *
   * OR
   *
   * Transform this:
   * export {a, b as c} from './foo';
   * into the pre-generated Object.defineProperty code from the ImportProcessor.
   *
   * For the first case, if the TypeScript transform is enabled, we need to skip
   * exports that are only defined as types.
   */ processExportBindings() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const isReExport = (0, $b54a2e36959b8789$export$2e2bcd8739ae039)(this.tokens);
        const exportStatements = [];
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
            while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
            const shouldRemoveExport = specifierInfo.isType || !isReExport && this.shouldElideExportedIdentifier(specifierInfo.leftName);
            if (!shouldRemoveExport) {
                const exportedName = specifierInfo.rightName;
                if (exportedName === "default") this.hadDefaultExport = true;
                else this.hadNamedExport = true;
                const localName = specifierInfo.leftName;
                const newLocalName = this.importProcessor.getIdentifierReplacement(localName);
                exportStatements.push(`exports.${exportedName} = ${newLocalName || localName};`);
            }
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                break;
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.currentToken())}`);
        }
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            // This is an export...from, so throw away the normal named export code
            // and use the Object.defineProperty code from ImportProcessor.
            this.tokens.removeToken();
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        } else // This is a normal named export, so use that.
        this.tokens.appendCode(exportStatements.join(" "));
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    processExportStar() {
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
        const path = this.tokens.stringValue();
        this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
        (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    shouldElideExportedIdentifier(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(name);
    }
}












class $6b5deed831f29708$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager, helperManager, reactHotLoaderTransformer, isTypeScriptTransformEnabled, isFlowTransformEnabled, keepUnusedImports, options){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.nonTypeIdentifiers = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7)(tokens, options) : new Set();
        this.declarationInfo = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $2755147e218a1b7a$export$2e2bcd8739ae039)(tokens) : (0, $2755147e218a1b7a$export$cab8fec5d7ea8d7);
        this.injectCreateRequireForImportRequire = Boolean(options.injectCreateRequireForImportRequire);
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 8 tokens long, so remove the 7 remaining tokens.
            for(let i = 0; i < 7; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 9 tokens long, so remove the 8 remaining tokens.
            for(let i = 0; i < 8; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) return this.processImport();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return this.processExportDefault();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) return this.processNamedExports();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $f3fd7f90efbef058$export$2e2bcd8739ae039)(this.tokens);
        else if (this.injectCreateRequireForImportRequire) {
            // We're using require in an environment (Node ESM) that doesn't provide
            // it as a global, so generate a helper to import it.
            // import -> const
            this.tokens.replaceToken("const");
            // Foo
            this.tokens.copyToken();
            // =
            this.tokens.copyToken();
            // require
            this.tokens.replaceToken(this.helperManager.getHelperName("require"));
        } else // Otherwise, just switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    processImport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic imports don't need to be transformed.
        return false;
        const snapshot = this.tokens.snapshot();
        const allImportsRemoved = this.removeImportTypeBindings();
        if (allImportsRemoved) {
            this.tokens.restoreToSnapshot(snapshot);
            while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
        }
        return true;
    }
    /**
   * Remove type bindings from this import, leaving the rest of the import intact.
   *
   * Return true if this import was ONLY types, and thus is eligible for removal. This will bail out
   * of the replacement operation, so we can return early here.
   */ removeImportTypeBindings() {
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import);
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) // This is an "import type" statement, so exit early.
        return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
            // This is a bare import, so we should proceed with the import.
            this.tokens.copyToken();
            return false;
        }
        // Skip the "module" token in import reflection.
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) this.tokens.copyToken();
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        let needsComma = false;
        // Handle default import.
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName())) {
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                foundNonTypeImport = true;
                this.tokens.copyToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
                    // We're in a statement like:
                    // import A, * as B from './A';
                    // or
                    // import A, {foo} from './A';
                    // where the `A` is being kept. The comma should be removed if an only
                    // if the next part of the import statement is elided, but that's hard
                    // to determine at this point in the code. Instead, always remove it
                    // and set a flag to add it back if necessary.
                    needsComma = true;
                    this.tokens.removeToken();
                }
            }
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2))) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                if (needsComma) this.tokens.appendCode(",");
                foundNonTypeImport = true;
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
            }
        } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            if (needsComma) this.tokens.appendCode(",");
            this.tokens.copyToken();
            while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
                foundAnyNamedImport = true;
                const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
                if (specifierInfo.isType || this.shouldAutomaticallyElideImportedName(specifierInfo.rightName)) {
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                    if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                } else {
                    foundNonTypeImport = true;
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                    if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                }
            }
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    processExportDefault() {
        if ((0, $affb60ffa9c51f41$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
            return true;
        }
        const alreadyHasName = this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
        if (!alreadyHasName && this.reactHotLoaderTransformer) {
            // This is a plain "export default E" statement and we need to assign E to a variable.
            // Change "export default E" to "let _default; export default _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; export`);
            this.tokens.copyToken();
            this.tokens.appendCode(` ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
            return true;
        }
        return false;
    }
    /**
   * Handle a statement with one of these forms:
   * export {a, type b};
   * export {c, type d} from 'foo';
   *
   * In both cases, any explicit type exports should be removed. In the first
   * case, we also need to handle implicit export elision for names declared as
   * types. In the second case, we must NOT do implicit named export elision,
   * but we must remove the runtime import if all exports are type exports.
   */ processNamedExports() {
        if (!this.isTypeScriptTransformEnabled) return false;
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        const isReExport = (0, $b54a2e36959b8789$export$2e2bcd8739ae039)(this.tokens);
        let foundNonTypeExport = false;
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
            if (specifierInfo.isType || !isReExport && this.shouldElideExportedName(specifierInfo.leftName)) {
                // Type export, so remove all tokens, including any comma.
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                // Non-type export, so copy all tokens, including any comma.
                foundNonTypeExport = true;
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
            }
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        if (!this.keepUnusedImports && isReExport && !foundNonTypeExport) {
            // This is a type-only re-export, so skip evaluating the other module. Technically this
            // leaves the statement as `export {}`, but that's ok since that's a no-op.
            this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        }
        return true;
    }
    /**
   * ESM elides all imports with the rule that we only elide if we see that it's
   * a type and never see it as a value. This is in contrast to CJS, which
   * elides imports that are completely unknown.
   */ shouldElideExportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(name) && !this.declarationInfo.valueDeclarations.has(name);
    }
}





class $764d21a88b0aec2e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processNamedExportEnum();
            return true;
        }
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processDefaultExportEnum();
            return true;
        }
        return false;
    }
    /**
   * Handle a declaration like:
   * export enum E ...
   *
   * With this imports transform, this becomes:
   * const E = [[enum]]; exports.E = E;
   *
   * otherwise, it becomes:
   * export const E = [[enum]];
   */ processNamedExportEnum() {
        if (this.isImportsTransformEnabled) {
            // export
            this.tokens.removeInitialToken();
            const enumName = this.tokens.identifierNameAtRelativeIndex(1);
            this.processEnum();
            this.tokens.appendCode(` exports.${enumName} = ${enumName};`);
        } else {
            this.tokens.copyToken();
            this.processEnum();
        }
    }
    /**
   * Handle a declaration like:
   * export default enum E
   *
   * With the imports transform, this becomes:
   * const E = [[enum]]; exports.default = E;
   *
   * otherwise, it becomes:
   * const E = [[enum]]; export default E;
   */ processDefaultExportEnum() {
        // export
        this.tokens.removeInitialToken();
        // default
        this.tokens.removeToken();
        const enumName = this.tokens.identifierNameAtRelativeIndex(1);
        this.processEnum();
        if (this.isImportsTransformEnabled) this.tokens.appendCode(` exports.default = ${enumName};`);
        else this.tokens.appendCode(` export default ${enumName};`);
    }
    /**
   * Transpile flow enums to invoke the "flow-enums-runtime" library.
   *
   * Currently, the transpiled code always uses `require("flow-enums-runtime")`,
   * but if future flexibility is needed, we could expose a config option for
   * this string (similar to configurable JSX). Even when targeting ESM, the
   * default behavior of babel-plugin-transform-flow-enums is to use require
   * rather than injecting an import.
   *
   * Flow enums are quite a bit simpler than TS enums and have some convenient
   * constraints:
   * - Element initializers must be either always present or always absent. That
   *   means that we can use fixed lookahead on the first element (if any) and
   *   assume that all elements are like that.
   * - The right-hand side of an element initializer must be a literal value,
   *   not a complex expression and not referencing other elements. That means
   *   we can simply copy a single token.
   *
   * Enums can be broken up into three basic cases:
   *
   * Mirrored enums:
   * enum E {A, B}
   *   ->
   * const E = require("flow-enums-runtime").Mirrored(["A", "B"]);
   *
   * Initializer enums:
   * enum E {A = 1, B = 2}
   *   ->
   * const E = require("flow-enums-runtime")({A: 1, B: 2});
   *
   * Symbol enums:
   * enum E of symbol {A, B}
   *   ->
   * const E = require("flow-enums-runtime")({A: Symbol("A"), B: Symbol("B")});
   *
   * We can statically detect which of the three cases this is by looking at the
   * "of" declaration (if any) and seeing if the first element has an initializer.
   * Since the other transform details are so similar between the three cases, we
   * use a single implementation and vary the transform within processEnumElement
   * based on case.
   */ processEnum() {
        // enum E -> const E
        this.tokens.replaceToken("const");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
        let isSymbolEnum = false;
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
            this.tokens.removeToken();
            isSymbolEnum = this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._symbol);
            this.tokens.removeToken();
        }
        const hasInitializers = this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
        this.tokens.appendCode(' = require("flow-enums-runtime")');
        const isMirrored = !isSymbolEnum && !hasInitializers;
        this.tokens.replaceTokenTrimmingLeftWhitespace(isMirrored ? ".Mirrored([" : "({");
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
            // ... is allowed at the end and has no runtime behavior.
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                this.tokens.removeToken();
                break;
            }
            this.processEnumElement(isSymbolEnum, hasInitializers);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
        }
        this.tokens.replaceToken(isMirrored ? "]);" : "});");
    }
    /**
   * Process an individual enum element, producing either an array element or an
   * object element based on what type of enum this is.
   */ processEnumElement(isSymbolEnum, hasInitializers) {
        if (isSymbolEnum) {
            // Symbol enums never have initializers and are expanded to object elements.
            // A, -> A: Symbol("A"),
            const elementName = this.tokens.identifierName();
            this.tokens.copyToken();
            this.tokens.appendCode(`: Symbol("${elementName}")`);
        } else if (hasInitializers) {
            // Initializers are expanded to object elements.
            // A = 1, -> A: 1,
            this.tokens.copyToken();
            this.tokens.replaceTokenTrimmingLeftWhitespace(":");
            this.tokens.copyToken();
        } else // Enum elements without initializers become string literal array elements.
        // A, -> "A",
        this.tokens.replaceToken(`"${this.tokens.identifierName()}"`);
    }
}




function $bc343969ef153cfd$var$_optionalChain(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $bc343969ef153cfd$var$JEST_GLOBAL_NAME = "jest";
const $bc343969ef153cfd$var$HOISTED_METHODS = [
    "mock",
    "unmock",
    "enableAutomock",
    "disableAutomock"
];
class $bc343969ef153cfd$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.hoistedFunctionNames = [];
    }
    constructor(rootTransformer, tokens, nameManager, importProcessor){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.importProcessor = importProcessor;
        $bc343969ef153cfd$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    process() {
        if (this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) && this.tokens.identifierName() === $bc343969ef153cfd$var$JEST_GLOBAL_NAME) {
            // TODO: This only works if imports transform is active, which it will be for jest.
            //       But if jest adds module support and we no longer need the import transform, this needs fixing.
            if ($bc343969ef153cfd$var$_optionalChain([
                this,
                'access',
                (_)=>_.importProcessor,
                'optionalAccess',
                (_2)=>_2.getGlobalNames,
                'call',
                (_3)=>_3(),
                'optionalAccess',
                (_4)=>_4.has,
                'call',
                (_5)=>_5($bc343969ef153cfd$var$JEST_GLOBAL_NAME)
            ])) return false;
            return this.extractHoistedCalls();
        }
        return false;
    }
    getHoistedCode() {
        if (this.hoistedFunctionNames.length > 0) // This will be placed before module interop code, but that's fine since
        // imports aren't allowed in module mock factories.
        return this.hoistedFunctionNames.map((name)=>`${name}();`).join("");
        return "";
    }
    /**
   * Extracts any methods calls on the jest-object that should be hoisted.
   *
   * According to the jest docs, https://jestjs.io/docs/en/jest-object#jestmockmodulename-factory-options,
   * mock, unmock, enableAutomock, disableAutomock, are the methods that should be hoisted.
   *
   * We do not apply the same checks of the arguments as babel-plugin-jest-hoist does.
   */ extractHoistedCalls() {
        // We're handling a chain of calls where `jest` may or may not need to be inserted for each call
        // in the chain, so remove the initial `jest` to make the loop implementation cleaner.
        this.tokens.removeToken();
        // Track some state so that multiple non-hoisted chained calls in a row keep their chaining
        // syntax.
        let followsNonHoistedJestCall = false;
        // Iterate through all chained calls on the jest object.
        while(this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)){
            const methodName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
            const shouldHoist = $bc343969ef153cfd$var$HOISTED_METHODS.includes(methodName);
            if (shouldHoist) {
                // We've matched e.g. `.mock(...)` or similar call.
                // Replace the initial `.` with `function __jestHoist(){jest.`
                const hoistedFunctionName = this.nameManager.claimFreeName("__jestHoist");
                this.hoistedFunctionNames.push(hoistedFunctionName);
                this.tokens.replaceToken(`function ${hoistedFunctionName}(){${$bc343969ef153cfd$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                this.tokens.appendCode(";}");
                followsNonHoistedJestCall = false;
            } else {
                // This is a non-hoisted method, so just transform the code as usual.
                if (followsNonHoistedJestCall) // If we didn't hoist the previous call, we can leave the code as-is to chain off of the
                // previous method call. It's important to preserve the code here because we don't know
                // for sure that the method actually returned the jest object for chaining.
                this.tokens.copyToken();
                else // If we hoisted the previous call, we know it returns the jest object back, so we insert
                // the identifier `jest` to continue the chain.
                this.tokens.replaceToken(`${$bc343969ef153cfd$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                followsNonHoistedJestCall = true;
            }
        }
        return true;
    }
}





class $53c4c3289533904f$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens){
        super();
        this.tokens = tokens;
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num)) {
            const code = this.tokens.currentTokenCode();
            if (code.includes("_")) {
                this.tokens.replaceToken(code.replace(/_/g, ""));
                return true;
            }
        }
        return false;
    }
}




class $651f878a41d91535$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.tokens.copyToken();
            this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`);
            return true;
        }
        return false;
    }
}




class $edb110213a8d1cb5$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing)) {
            const token = this.tokens.currentToken();
            if (this.tokens.tokens[token.nullishStartIndex].isAsyncOperation) this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (");
            else this.tokens.replaceTokenTrimmingLeftWhitespace(", () => (");
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete)) {
            const nextToken = this.tokens.tokenAtRelativeIndex(1);
            if (nextToken.isOptionalChainStart) {
                this.tokens.removeInitialToken();
                return true;
            }
        }
        const token = this.tokens.currentToken();
        const chainStart = token.subscriptStartIndex;
        if (chainStart != null && this.tokens.tokens[chainStart].isOptionalChainStart && // Super subscripts can't be optional (since super is never null/undefined), and the syntax
        // relies on the subscript being intact, so leave this token alone.
        this.tokens.tokenAtRelativeIndex(-1).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super) {
            const param = this.nameManager.claimFreeName("_");
            let arrowStartSnippet;
            if (chainStart > 0 && this.tokens.matches1AtIndex(chainStart - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete) && this.isLastSubscriptInChain()) // Delete operations are special: we already removed the delete keyword, and to still
            // perform a delete, we need to insert a delete in the very last part of the chain, which
            // in correct code will always be a property access.
            arrowStartSnippet = `${param} => delete ${param}`;
            else arrowStartSnippet = `${param} => ${param}`;
            if (this.tokens.tokens[chainStart].isAsyncOperation) arrowStartSnippet = `async ${arrowStartSnippet}`;
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalCall', ${arrowStartSnippet}`);
            } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}[`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'call', ${arrowStartSnippet}(`);
            } else throw new Error("Unexpected subscript operator in optional chain.");
            return true;
        }
        return false;
    }
    /**
   * Determine if the current token is the last of its chain, so that we know whether it's eligible
   * to have a delete op inserted.
   *
   * We can do this by walking forward until we determine one way or another. Each
   * isOptionalChainStart token must be paired with exactly one isOptionalChainEnd token after it in
   * a nesting way, so we can track depth and walk to the end of the chain (the point where the
   * depth goes negative) and see if any other subscript token is after us in the chain.
   */ isLastSubscriptInChain() {
        let depth = 0;
        for(let i = this.tokens.currentIndex() + 1;; i++){
            if (i >= this.tokens.tokens.length) throw new Error("Reached the end of the code while finding the end of the access chain.");
            if (this.tokens.tokens[i].isOptionalChainStart) depth++;
            else if (this.tokens.tokens[i].isOptionalChainEnd) depth--;
            if (depth < 0) return true;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[i].subscriptStartIndex != null) return false;
        }
    }
    /**
   * Determine if we are the open-paren in an expression like super.a()?.b.
   *
   * We can do this by walking backward to find the previous subscript. If that subscript was
   * preceded by a super, then we must be the subscript after it, so if this is a call expression,
   * we'll need to attach the right context.
   */ justSkippedSuper() {
        let depth = 0;
        let index = this.tokens.currentIndex() - 1;
        while(true){
            if (index < 0) throw new Error("Reached the start of the code while finding the start of the access chain.");
            if (this.tokens.tokens[index].isOptionalChainStart) depth--;
            else if (this.tokens.tokens[index].isOptionalChainEnd) depth++;
            if (depth < 0) return false;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[index].subscriptStartIndex != null) return this.tokens.tokens[index - 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super;
            index--;
        }
    }
}





class $422c837f2180b524$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, importProcessor, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.options = options;
    }
    process() {
        const startIndex = this.tokens.currentIndex();
        if (this.tokens.identifierName() === "createReactClass") {
            const newName = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
            if (newName) this.tokens.replaceToken(`(0, ${newName})`);
            else this.tokens.copyToken();
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
            const newName = this.importProcessor ? this.importProcessor.getIdentifierReplacement("React") || "React" : "React";
            if (newName) {
                this.tokens.replaceToken(newName);
                this.tokens.copyToken();
                this.tokens.copyToken();
            } else {
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.tokens.copyToken();
            }
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        return false;
    }
    /**
   * This is called with the token position at the open-paren.
   */ tryProcessCreateClassCall(startIndex) {
        const displayName = this.findDisplayName(startIndex);
        if (!displayName) return;
        if (this.classNeedsDisplayName()) {
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
            this.tokens.appendCode(`displayName: '${displayName}',`);
            this.rootTransformer.processBalancedCode();
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        }
    }
    findDisplayName(startIndex) {
        if (startIndex < 2) return null;
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // This is an assignment (or declaration) and the LHS is either an identifier or a member
        // expression ending in an identifier, so use that identifier name.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (startIndex >= 2 && this.tokens.tokens[startIndex - 2].identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey) // This is an object literal value.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return this.getDisplayNameFromFilename();
        return null;
    }
    getDisplayNameFromFilename() {
        const filePath = this.options.filePath || "unknown";
        const pathSegments = filePath.split("/");
        const filename = pathSegments[pathSegments.length - 1];
        const dotIndex = filename.lastIndexOf(".");
        const baseFilename = dotIndex === -1 ? filename : filename.slice(0, dotIndex);
        if (baseFilename === "index" && pathSegments[pathSegments.length - 2]) return pathSegments[pathSegments.length - 2];
        else return baseFilename;
    }
    /**
   * We only want to add a display name when this is a function call containing
   * one argument, which is an object literal without `displayName` as an
   * existing key.
   */ classNeedsDisplayName() {
        let index = this.tokens.currentIndex();
        if (!this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) return false;
        // The block starts on the {, and we expect any displayName key to be in
        // that context. We need to ignore other other contexts to avoid matching
        // nested displayName keys.
        const objectStartIndex = index + 1;
        const objectContextId = this.tokens.tokens[objectStartIndex].contextId;
        if (objectContextId == null) throw new Error("Expected non-null context ID on object open-brace.");
        for(; index < this.tokens.tokens.length; index++){
            const token = this.tokens.tokens[index];
            if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR && token.contextId === objectContextId) {
                index++;
                break;
            }
            if (this.tokens.identifierNameAtIndex(index) === "displayName" && this.tokens.tokens[index].identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey && token.contextId === objectContextId) // We found a displayName key, so bail out.
            return false;
        }
        if (index === this.tokens.tokens.length) throw new Error("Unexpected end of input when processing React class.");
        // If we got this far, we know we have createClass with an object with no
        // display name, so we want to proceed as long as that was the only argument.
        return this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    }
}




class $24f0573b6e9a1e84$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.extractedDefaultExportName = null;
    }
    constructor(tokens, filePath){
        super();
        this.tokens = tokens;
        this.filePath = filePath;
        $24f0573b6e9a1e84$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    setExtractedDefaultExportName(extractedDefaultExportName) {
        this.extractedDefaultExportName = extractedDefaultExportName;
    }
    getPrefixCode() {
        return `
      (function () {
        var enterModule = require('react-hot-loader').enterModule;
        enterModule && enterModule(module);
      })();`.replace(/\s+/g, " ").trim();
    }
    getSuffixCode() {
        const topLevelNames = new Set();
        for (const token of this.tokens.tokens)if (!token.isType && (0, $19e70491d10f11e8$export$c08b4dec8c3c03d)(token) && token.identifierRole !== (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration) topLevelNames.add(this.tokens.identifierNameForToken(token));
        const namesToRegister = Array.from(topLevelNames).map((name)=>({
                variableName: name,
                uniqueLocalName: name
            }));
        if (this.extractedDefaultExportName) namesToRegister.push({
            variableName: this.extractedDefaultExportName,
            uniqueLocalName: "default"
        });
        return `
;(function () {
  var reactHotLoader = require('react-hot-loader').default;
  var leaveModule = require('react-hot-loader').leaveModule;
  if (!reactHotLoader) {
    return;
  }
${namesToRegister.map(({ variableName: variableName, uniqueLocalName: uniqueLocalName })=>`  reactHotLoader.register(${variableName}, "${uniqueLocalName}", ${JSON.stringify(this.filePath || "")});`).join("\n")}
  leaveModule(module);
})();`;
    }
    process() {
        return false;
    }
}




// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar
// Hard-code a list of reserved words rather than trying to use keywords or contextual keywords
// from the parser, since currently there are various exceptions, like `package` being reserved
// but unused and various contextual keywords being reserved. Note that we assume that all code
// compiled by Sucrase is in a module, so strict mode words and await are all considered reserved
// here.
const $acf87c2056b5efeb$var$RESERVED_WORDS = new Set([
    // Reserved keywords as of ECMAScript 2015
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with",
    "yield",
    // Future reserved keywords
    "enum",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "await",
    // Literals that cannot be used as identifiers
    "false",
    "null",
    "true"
]);
function $acf87c2056b5efeb$export$2e2bcd8739ae039(name) {
    if (name.length === 0) return false;
    if (!(0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[name.charCodeAt(0)]) return false;
    for(let i = 1; i < name.length; i++){
        if (!(0, $231ac6b14e19c571$export$d19df39e3926cfef)[name.charCodeAt(i)]) return false;
    }
    return !$acf87c2056b5efeb$var$RESERVED_WORDS.has(name);
}



class $1996d8fdc2196ced$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nonNullAssertion)) {
            this.tokens.removeInitialToken();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum(true);
            return true;
        }
        return false;
    }
    processEnum(isExport = false) {
        // We might have "export const enum", so just remove all relevant tokens.
        this.tokens.removeInitialToken();
        while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum))this.tokens.removeToken();
        const enumName = this.tokens.identifierName();
        this.tokens.removeToken();
        if (isExport && !this.isImportsTransformEnabled) this.tokens.appendCode("export ");
        this.tokens.appendCode(`var ${enumName}; (function (${enumName})`);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        this.processEnumBody(enumName);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        if (isExport && this.isImportsTransformEnabled) this.tokens.appendCode(`)(${enumName} || (exports.${enumName} = ${enumName} = {}));`);
        else this.tokens.appendCode(`)(${enumName} || (${enumName} = {}));`);
    }
    /**
   * Transform an enum into equivalent JS. This has complexity in a few places:
   * - TS allows string enums, numeric enums, and a mix of the two styles within an enum.
   * - Enum keys are allowed to be referenced in later enum values.
   * - Enum keys are allowed to be strings.
   * - When enum values are omitted, they should follow an auto-increment behavior.
   */ processEnumBody(enumName) {
        // Code that can be used to reference the previous enum member, or null if this is the first
        // enum member.
        let previousValueCode = null;
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
            const { nameStringCode: nameStringCode, variableName: variableName } = this.extractEnumKeyInfo(this.tokens.currentToken());
            this.tokens.removeInitialToken();
            if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) this.processStringLiteralEnumMember(enumName, nameStringCode, variableName);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.processExplicitValueEnumMember(enumName, nameStringCode, variableName);
            else this.processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            if (variableName != null) previousValueCode = variableName;
            else previousValueCode = `${enumName}[${nameStringCode}]`;
        }
    }
    /**
   * Detect name information about this enum key, which will be used to determine which code to emit
   * and whether we should declare a variable as part of this declaration.
   *
   * Some cases to keep in mind:
   * - Enum keys can be implicitly referenced later, e.g. `X = 1, Y = X`. In Sucrase, we implement
   *   this by declaring a variable `X` so that later expressions can use it.
   * - In addition to the usual identifier key syntax, enum keys are allowed to be string literals,
   *   e.g. `"hello world" = 3,`. Template literal syntax is NOT allowed.
   * - Even if the enum key is defined as a string literal, it may still be referenced by identifier
   *   later, e.g. `"X" = 1, Y = X`. That means that we need to detect whether or not a string
   *   literal is identifier-like and emit a variable if so, even if the declaration did not use an
   *   identifier.
   * - Reserved keywords like `break` are valid enum keys, but are not valid to be referenced later
   *   and would be a syntax error if we emitted a variable, so we need to skip the variable
   *   declaration in those cases.
   *
   * The variableName return value captures these nuances: if non-null, we can and must emit a
   * variable declaration, and if null, we can't and shouldn't.
   */ extractEnumKeyInfo(nameToken) {
        if (nameToken.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) {
            const name = this.tokens.identifierNameForToken(nameToken);
            return {
                nameStringCode: `"${name}"`,
                variableName: (0, $acf87c2056b5efeb$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else if (nameToken.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) {
            const name = this.tokens.stringValueForToken(nameToken);
            return {
                nameStringCode: this.tokens.code.slice(nameToken.start, nameToken.end),
                variableName: (0, $acf87c2056b5efeb$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else throw new Error("Expected name or string at beginning of enum element.");
    }
    /**
   * Handle an enum member where the RHS is just a string literal (not omitted, not a number, and
   * not a complex expression). This is the typical form for TS string enums, and in this case, we
   * do *not* create a reverse mapping.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = "some value"
   * ->
   * const someKey = "some value"; MyEnum["someKey"] = someKey;
   *
   * Example 2:
   * "some key" = "some value"
   * ->
   * MyEnum["some key"] = "some value";
   */ processStringLiteralEnumMember(enumName, nameStringCode, variableName) {
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(`; ${enumName}[${nameStringCode}] = ${variableName};`);
        } else {
            this.tokens.appendCode(`${enumName}[${nameStringCode}]`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(";");
        }
    }
    /**
   * Handle an enum member initialized with an expression on the right-hand side (other than a
   * string literal). In these cases, we should transform the expression and emit code that sets up
   * a reverse mapping.
   *
   * The TypeScript implementation of this operation distinguishes between expressions that can be
   * "constant folded" at compile time (i.e. consist of number literals and simple math operations
   * on those numbers) and ones that are dynamic. For constant expressions, it emits the resolved
   * numeric value, and auto-incrementing is only allowed in that case. Evaluating expressions at
   * compile time would add significant complexity to Sucrase, so Sucrase instead leaves the
   * expression as-is, and will later emit something like `MyEnum["previousKey"] + 1` to implement
   * auto-incrementing.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = 1 + 1
   * ->
   * const someKey = 1 + 1; MyEnum[MyEnum["someKey"] = someKey] = "someKey";
   *
   * Example 2:
   * "some key" = 1 + 1
   * ->
   * MyEnum[MyEnum["some key"] = 1 + 1] = "some key";
   */ processExplicitValueEnumMember(enumName, nameStringCode, variableName) {
        const rhsEndIndex = this.tokens.currentToken().rhsEndIndex;
        if (rhsEndIndex == null) throw new Error("Expected rhsEndIndex on enum assign.");
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`; ${enumName}[${enumName}[${nameStringCode}] = ${variableName}] = ${nameStringCode};`);
        } else {
            this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}]`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`] = ${nameStringCode};`);
        }
    }
    /**
   * Handle an enum member with no right-hand side expression. In this case, the value is the
   * previous value plus 1, or 0 if there was no previous value. We should also always emit a
   * reverse mapping.
   *
   * Example 1:
   * someKey2
   * ->
   * const someKey2 = someKey1 + 1; MyEnum[MyEnum["someKey2"] = someKey2] = "someKey2";
   *
   * Example 2:
   * "some key 2"
   * ->
   * MyEnum[MyEnum["some key 2"] = someKey1 + 1] = "some key 2";
   */ processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode) {
        let valueCode = previousValueCode != null ? `${previousValueCode} + 1` : "0";
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName} = ${valueCode}; `);
            valueCode = variableName;
        }
        this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}] = ${valueCode}] = ${nameStringCode};`);
    }
}


class $a5e6d2638cd84d71$export$2e2bcd8739ae039 {
    __init() {
        this.transformers = [];
    }
    __init2() {
        this.generatedVariables = [];
    }
    constructor(sucraseContext, transforms, enableLegacyBabel5ModuleInterop, options){
        $a5e6d2638cd84d71$export$2e2bcd8739ae039.prototype.__init.call(this);
        $a5e6d2638cd84d71$export$2e2bcd8739ae039.prototype.__init2.call(this);
        this.nameManager = sucraseContext.nameManager;
        this.helperManager = sucraseContext.helperManager;
        const { tokenProcessor: tokenProcessor, importProcessor: importProcessor } = sucraseContext;
        this.tokens = tokenProcessor;
        this.isImportsTransformEnabled = transforms.includes("imports");
        this.isReactHotLoaderTransformEnabled = transforms.includes("react-hot-loader");
        this.disableESTransforms = Boolean(options.disableESTransforms);
        if (!options.disableESTransforms) {
            this.transformers.push(new (0, $edb110213a8d1cb5$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
            this.transformers.push(new (0, $53c4c3289533904f$export$2e2bcd8739ae039)(tokenProcessor));
            this.transformers.push(new (0, $651f878a41d91535$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
        }
        if (transforms.includes("jsx")) {
            if (options.jsxRuntime !== "preserve") this.transformers.push(new (0, $02817d809bdcb26e$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, options));
            this.transformers.push(new (0, $422c837f2180b524$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, options));
        }
        let reactHotLoaderTransformer = null;
        if (transforms.includes("react-hot-loader")) {
            if (!options.filePath) throw new Error("filePath is required when using the react-hot-loader transform.");
            reactHotLoaderTransformer = new (0, $24f0573b6e9a1e84$export$2e2bcd8739ae039)(tokenProcessor, options.filePath);
            this.transformers.push(reactHotLoaderTransformer);
        }
        // Note that we always want to enable the imports transformer, even when the import transform
        // itself isn't enabled, since we need to do type-only import pruning for both Flow and
        // TypeScript.
        if (transforms.includes("imports")) {
            if (importProcessor === null) throw new Error("Expected non-null importProcessor with imports transform enabled.");
            this.transformers.push(new (0, $384b44440831876e$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, Boolean(options.enableLegacyTypeScriptModuleInterop), transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.preserveDynamicImport), Boolean(options.keepUnusedImports)));
        } else this.transformers.push(new (0, $6b5deed831f29708$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.keepUnusedImports), options));
        if (transforms.includes("flow")) this.transformers.push(new (0, $764d21a88b0aec2e$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("typescript")) this.transformers.push(new (0, $1996d8fdc2196ced$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("jest")) this.transformers.push(new (0, $bc343969ef153cfd$export$2e2bcd8739ae039)(this, tokenProcessor, this.nameManager, importProcessor));
    }
    transform() {
        this.tokens.reset();
        this.processBalancedCode();
        const shouldAddUseStrict = this.isImportsTransformEnabled;
        // "use strict" always needs to be first, so override the normal transformer order.
        let prefix = shouldAddUseStrict ? '"use strict";' : "";
        for (const transformer of this.transformers)prefix += transformer.getPrefixCode();
        prefix += this.helperManager.emitHelpers();
        prefix += this.generatedVariables.map((v)=>` var ${v};`).join("");
        for (const transformer of this.transformers)prefix += transformer.getHoistedCode();
        let suffix = "";
        for (const transformer of this.transformers)suffix += transformer.getSuffixCode();
        const result = this.tokens.finish();
        let { code: code } = result;
        if (code.startsWith("#!")) {
            let newlineIndex = code.indexOf("\n");
            if (newlineIndex === -1) {
                newlineIndex = code.length;
                code += "\n";
            }
            return {
                code: code.slice(0, newlineIndex + 1) + prefix + code.slice(newlineIndex + 1) + suffix,
                // The hashbang line has no tokens, so shifting the tokens to account
                // for prefix can happen normally.
                mappings: this.shiftMappings(result.mappings, prefix.length)
            };
        } else return {
            code: prefix + code + suffix,
            mappings: this.shiftMappings(result.mappings, prefix.length)
        };
    }
    processBalancedCode() {
        let braceDepth = 0;
        let parenDepth = 0;
        while(!this.tokens.isAtEnd()){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL)) braceDepth++;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) parenDepth++;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) {
                if (parenDepth === 0) return;
                parenDepth--;
            }
            this.processToken();
        }
    }
    processToken() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
            this.processClass();
            return;
        }
        for (const transformer of this.transformers){
            const wasProcessed = transformer.process();
            if (wasProcessed) return;
        }
        this.tokens.copyToken();
    }
    /**
   * Skip past a class with a name and return that name.
   */ processNamedClass() {
        if (!this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported class name.");
        const name = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        this.processClass();
        return name;
    }
    processClass() {
        const classInfo = (0, $e3f8f159d7f2a3fc$export$2e2bcd8739ae039)(this, this.tokens, this.nameManager, this.disableESTransforms);
        // Both static and instance initializers need a class name to use to invoke the initializer, so
        // assign to one if necessary.
        const needsCommaExpression = (classInfo.headerInfo.isExpression || !classInfo.headerInfo.className) && classInfo.staticInitializerNames.length + classInfo.instanceInitializerNames.length > 0;
        let className = classInfo.headerInfo.className;
        if (needsCommaExpression) {
            className = this.nameManager.claimFreeName("_class");
            this.generatedVariables.push(className);
            this.tokens.appendCode(` (${className} =`);
        }
        const classToken = this.tokens.currentToken();
        const contextId = classToken.contextId;
        if (contextId == null) throw new Error("Expected class to have a context ID.");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class);
        while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, contextId))this.processToken();
        this.processClassBody(classInfo, className);
        const staticInitializerStatements = classInfo.staticInitializerNames.map((name)=>`${className}.${name}()`);
        if (needsCommaExpression) this.tokens.appendCode(`, ${staticInitializerStatements.map((s)=>`${s}, `).join("")}${className})`);
        else if (classInfo.staticInitializerNames.length > 0) this.tokens.appendCode(` ${staticInitializerStatements.map((s)=>`${s};`).join(" ")}`);
    }
    /**
   * We want to just handle class fields in all contexts, since TypeScript supports them. Later,
   * when some JS implementations support class fields, this should be made optional.
   */ processClassBody(classInfo, className) {
        const { headerInfo: headerInfo, constructorInsertPos: constructorInsertPos, constructorInitializerStatements: constructorInitializerStatements, fields: fields, instanceInitializerNames: instanceInitializerNames, rangesToRemove: rangesToRemove } = classInfo;
        let fieldIndex = 0;
        let rangeToRemoveIndex = 0;
        const classContextId = this.tokens.currentToken().contextId;
        if (classContextId == null) throw new Error("Expected non-null context ID on class.");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        if (this.isReactHotLoaderTransformEnabled) this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
        const needsConstructorInit = constructorInitializerStatements.length + instanceInitializerNames.length > 0;
        if (constructorInsertPos === null && needsConstructorInit) {
            const constructorInitializersCode = this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className);
            if (headerInfo.hasSuperclass) {
                const argsName = this.nameManager.claimFreeName("args");
                this.tokens.appendCode(`constructor(...${argsName}) { super(...${argsName}); ${constructorInitializersCode}; }`);
            } else this.tokens.appendCode(`constructor() { ${constructorInitializersCode}; }`);
        }
        while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, classContextId)){
            if (fieldIndex < fields.length && this.tokens.currentIndex() === fields[fieldIndex].start) {
                let needsCloseBrace = false;
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this`);
                else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num)) {
                    this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this[`);
                    needsCloseBrace = true;
                } else this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this.`);
                while(this.tokens.currentIndex() < fields[fieldIndex].end){
                    if (needsCloseBrace && this.tokens.currentIndex() === fields[fieldIndex].equalsIndex) this.tokens.appendCode("]");
                    this.processToken();
                }
                this.tokens.appendCode("}");
                fieldIndex++;
            } else if (rangeToRemoveIndex < rangesToRemove.length && this.tokens.currentIndex() >= rangesToRemove[rangeToRemoveIndex].start) {
                if (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end)this.tokens.removeToken();
                rangeToRemoveIndex++;
            } else if (this.tokens.currentIndex() === constructorInsertPos) {
                this.tokens.copyToken();
                if (needsConstructorInit) this.tokens.appendCode(`;${this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className)};`);
                this.processToken();
            } else this.processToken();
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
    }
    makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className) {
        return [
            ...constructorInitializerStatements,
            ...instanceInitializerNames.map((name)=>`${className}.prototype.${name}.call(this)`)
        ].join(";");
    }
    /**
   * Normally it's ok to simply remove type tokens, but we need to be more careful when dealing with
   * arrow function return types since they can confuse the parser. In that case, we want to move
   * the close-paren to the same line as the arrow.
   *
   * See https://github.com/alangpierce/sucrase/issues/391 for more details.
   */ processPossibleArrowParamEnd() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
            let nextNonTypeIndex = this.tokens.currentIndex() + 1;
            // Look ahead to see if this is an arrow function or something else.
            while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
            if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
                this.tokens.replaceTokenTrimmingLeftWhitespace(") =>");
                return true;
            }
        }
        return false;
    }
    /**
   * An async arrow function might be of the form:
   *
   * async <
   *   T
   * >() => {}
   *
   * in which case, removing the type parameters will cause a syntax error. Detect this case and
   * move the open-paren earlier.
   */ processPossibleAsyncArrowWithTypeParams() {
        if (!this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async)) return false;
        const nextToken = this.tokens.tokenAtRelativeIndex(1);
        if (nextToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan || !nextToken.isType) return false;
        let nextNonTypeIndex = this.tokens.currentIndex() + 1;
        // Look ahead to see if this is an arrow function or something else.
        while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
        if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            this.tokens.replaceToken("async (");
            this.tokens.removeInitialToken();
            while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
            this.tokens.removeToken();
            // We ate a ( token, so we need to process the tokens in between and then the ) token so that
            // we remain balanced.
            this.processBalancedCode();
            this.processToken();
            return true;
        }
        return false;
    }
    processPossibleTypeRange() {
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
            return true;
        }
        return false;
    }
    shiftMappings(mappings, prefixLength) {
        for(let i = 0; i < mappings.length; i++){
            const mapping = mappings[i];
            if (mapping !== undefined) mappings[i] = mapping + prefixLength;
        }
        return mappings;
    }
}


var $33c28e9842968610$export$1e511d4a378977f5;
var $33c28e9842968610$export$f2e513d2bc4a3b5a;
var $33c28e9842968610$export$2e2bcd8739ae039;
"use strict";
$33c28e9842968610$export$1e511d4a378977f5 = true;
$33c28e9842968610$export$f2e513d2bc4a3b5a = void 0;
var $33c28e9842968610$var$LF = '\n';
var $33c28e9842968610$var$CR = '\r';
var $33c28e9842968610$var$LinesAndColumns = /** @class */ function() {
    function LinesAndColumns(string) {
        this.string = string;
        var offsets = [
            0
        ];
        for(var offset = 0; offset < string.length;)switch(string[offset]){
            case $33c28e9842968610$var$LF:
                offset += $33c28e9842968610$var$LF.length;
                offsets.push(offset);
                break;
            case $33c28e9842968610$var$CR:
                offset += $33c28e9842968610$var$CR.length;
                if (string[offset] === $33c28e9842968610$var$LF) offset += $33c28e9842968610$var$LF.length;
                offsets.push(offset);
                break;
            default:
                offset++;
                break;
        }
        this.offsets = offsets;
    }
    LinesAndColumns.prototype.locationForIndex = function(index) {
        if (index < 0 || index > this.string.length) return null;
        var line = 0;
        var offsets = this.offsets;
        while(offsets[line + 1] <= index)line++;
        var column = index - offsets[line];
        return {
            line: line,
            column: column
        };
    };
    LinesAndColumns.prototype.indexForLocation = function(location) {
        var line = location.line, column = location.column;
        if (line < 0 || line >= this.offsets.length) return null;
        if (column < 0 || column > this.lengthOfLine(line)) return null;
        return this.offsets[line] + column;
    };
    LinesAndColumns.prototype.lengthOfLine = function(line) {
        var offset = this.offsets[line];
        var nextOffset = line === this.offsets.length - 1 ? this.string.length : this.offsets[line + 1];
        return nextOffset - offset;
    };
    return LinesAndColumns;
}();
$33c28e9842968610$export$f2e513d2bc4a3b5a = $33c28e9842968610$var$LinesAndColumns;
$33c28e9842968610$export$2e2bcd8739ae039 = $33c28e9842968610$var$LinesAndColumns;



function $9a57e5e064b612ba$export$2e2bcd8739ae039(code, tokens) {
    if (tokens.length === 0) return "";
    const tokenKeys = Object.keys(tokens[0]).filter((k)=>k !== "type" && k !== "value" && k !== "start" && k !== "end" && k !== "loc");
    const typeKeys = Object.keys(tokens[0].type).filter((k)=>k !== "label" && k !== "keyword");
    const headings = [
        "Location",
        "Label",
        "Raw",
        ...tokenKeys,
        ...typeKeys
    ];
    const lines = new (0, $33c28e9842968610$export$2e2bcd8739ae039)(code);
    const rows = [
        headings,
        ...tokens.map(getTokenComponents)
    ];
    const padding = headings.map(()=>0);
    for (const components of rows)for(let i = 0; i < components.length; i++)padding[i] = Math.max(padding[i], components[i].length);
    return rows.map((components)=>components.map((component, i)=>component.padEnd(padding[i])).join(" ")).join("\n");
    function getTokenComponents(token) {
        const raw = code.slice(token.start, token.end);
        return [
            formatRange(token.start, token.end),
            (0, $f33b9d3e01f21be3$export$b78065ce79336a93)(token.type),
            $9a57e5e064b612ba$var$truncate(String(raw), 14),
            // @ts-ignore: Intentional dynamic access by key.
            ...tokenKeys.map((key)=>formatValue(token[key], key)),
            // @ts-ignore: Intentional dynamic access by key.
            ...typeKeys.map((key)=>formatValue(token.type[key], key))
        ];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function formatValue(value, key) {
        if (value === true) return key;
        else if (value === false || value === null) return "";
        else return String(value);
    }
    function formatRange(start, end) {
        return `${formatPos(start)}-${formatPos(end)}`;
    }
    function formatPos(pos) {
        const location = lines.locationForIndex(pos);
        if (!location) return "Unknown";
        else return `${location.line + 1}:${location.column + 1}`;
    }
}
function $9a57e5e064b612ba$var$truncate(s, length) {
    if (s.length > length) return `${s.slice(0, length - 3)}...`;
    else return s;
}




function $73c2dfebe4b62df2$export$2e2bcd8739ae039(tokens) {
    const importedNames = new Set();
    for(let i = 0; i < tokens.tokens.length; i++)if (tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) && !tokens.matches3AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $73c2dfebe4b62df2$var$collectNamesForImport(tokens, i, importedNames);
    return importedNames;
}
function $73c2dfebe4b62df2$var$collectNamesForImport(tokens, index, importedNames) {
    index++;
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
    return;
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
        if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
    }
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        // * as
        index += 2;
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
    }
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
        index++;
        $73c2dfebe4b62df2$var$collectNamesForNamedImport(tokens, index, importedNames);
    }
}
function $73c2dfebe4b62df2$var$collectNamesForNamedImport(tokens, index, importedNames) {
    while(true){
        if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(tokens, index);
        index = specifierInfo.endIndex;
        if (!specifierInfo.isType) importedNames.add(specifierInfo.rightName);
        if (tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
        else throw new Error(`Unexpected token: ${JSON.stringify(tokens.tokens[index])}`);
    }
}


function $7a5ccb00366653d1$export$c506eb22e615ba4a() {
    /* istanbul ignore next */ return "3.35.1";
}
function $7a5ccb00366653d1$export$51186ad6e864892a(code, options) {
    (0, $10bb70de42713567$export$1dd09873c1bdd0fc)(options);
    try {
        const sucraseContext = $7a5ccb00366653d1$var$getSucraseContext(code, options);
        const transformer = new (0, $a5e6d2638cd84d71$export$2e2bcd8739ae039)(sucraseContext, options.transforms, Boolean(options.enableLegacyBabel5ModuleInterop), options);
        const transformerResult = transformer.transform();
        let result = {
            code: transformerResult.code
        };
        if (options.sourceMapOptions) {
            if (!options.filePath) throw new Error("filePath must be specified when generating a source map.");
            result = {
                ...result,
                sourceMap: (0, $983df390ff0493b7$export$2e2bcd8739ae039)(transformerResult, options.filePath, options.sourceMapOptions, code, sucraseContext.tokenProcessor.tokens)
            };
        }
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (options.filePath) e.message = `Error transforming ${options.filePath}: ${e.message}`;
        throw e;
    }
}
function $7a5ccb00366653d1$export$fd97d3ecabd3e6b7(code, options) {
    const tokens = $7a5ccb00366653d1$var$getSucraseContext(code, options).tokenProcessor.tokens;
    return (0, $9a57e5e064b612ba$export$2e2bcd8739ae039)(code, tokens);
}
/**
 * Call into the parser/tokenizer and do some further preprocessing:
 * - Come up with a set of used names so that we can assign new names.
 * - Preprocess all import/export statements so we know which globals we are interested in.
 * - Compute situations where any of those globals are shadowed.
 *
 * In the future, some of these preprocessing steps can be skipped based on what actual work is
 * being done.
 */ function $7a5ccb00366653d1$var$getSucraseContext(code, options) {
    const isJSXEnabled = options.transforms.includes("jsx");
    const isTypeScriptEnabled = options.transforms.includes("typescript");
    const isFlowEnabled = options.transforms.includes("flow");
    const disableESTransforms = options.disableESTransforms === true;
    const file = (0, $201427b598292105$export$98e6a39c04603d36)(code, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const tokens = file.tokens;
    const scopes = file.scopes;
    const nameManager = new (0, $98ad476c234688bb$export$2e2bcd8739ae039)(code, tokens);
    const helperManager = new (0, $1425b7397a2936d9$export$b203ad16abdeb845)(nameManager);
    const tokenProcessor = new (0, $8e1a59465c201e5d$export$2e2bcd8739ae039)(code, tokens, isFlowEnabled, disableESTransforms, helperManager);
    const enableLegacyTypeScriptModuleInterop = Boolean(options.enableLegacyTypeScriptModuleInterop);
    let importProcessor = null;
    if (options.transforms.includes("imports")) {
        importProcessor = new (0, $cbf8fee06b97a5bb$export$2e2bcd8739ae039)(nameManager, tokenProcessor, enableLegacyTypeScriptModuleInterop, options, options.transforms.includes("typescript"), Boolean(options.keepUnusedImports), helperManager);
        importProcessor.preprocessTokens();
        // We need to mark shadowed globals after processing imports so we know that the globals are,
        // but before type-only import pruning, since that relies on shadowing information.
        (0, $e17888755afee10f$export$2e2bcd8739ae039)(tokenProcessor, scopes, importProcessor.getGlobalNames());
        if (options.transforms.includes("typescript") && !options.keepUnusedImports) importProcessor.pruneTypeOnlyImports();
    } else if (options.transforms.includes("typescript") && !options.keepUnusedImports) // Shadowed global detection is needed for TS implicit elision of imported names.
    (0, $e17888755afee10f$export$2e2bcd8739ae039)(tokenProcessor, scopes, (0, $73c2dfebe4b62df2$export$2e2bcd8739ae039)(tokenProcessor));
    return {
        tokenProcessor: tokenProcessor,
        scopes: scopes,
        nameManager: nameManager,
        importProcessor: importProcessor,
        helperManager: helperManager
    };
}


var $1232e0688c6b311d$var$__defProp = Object.defineProperty;
var $1232e0688c6b311d$var$__defProps = Object.defineProperties;
var $1232e0688c6b311d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1232e0688c6b311d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1232e0688c6b311d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1232e0688c6b311d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1232e0688c6b311d$var$__defNormalProp = (obj, key, value)=>key in obj ? $1232e0688c6b311d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1232e0688c6b311d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1232e0688c6b311d$var$__hasOwnProp.call(b, prop)) $1232e0688c6b311d$var$__defNormalProp(a, prop, b[prop]);
    if ($1232e0688c6b311d$var$__getOwnPropSymbols) {
        for (var prop of $1232e0688c6b311d$var$__getOwnPropSymbols(b))if ($1232e0688c6b311d$var$__propIsEnum.call(b, prop)) $1232e0688c6b311d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1232e0688c6b311d$var$__spreadProps = (a, b)=>$1232e0688c6b311d$var$__defProps(a, $1232e0688c6b311d$var$__getOwnPropDescs(b));
var $1232e0688c6b311d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1232e0688c6b311d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1232e0688c6b311d$var$__getOwnPropSymbols) {
        for (var prop of $1232e0688c6b311d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1232e0688c6b311d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $1232e0688c6b311d$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $1232e0688c6b311d$var$CodeEditor = (props)=>{
    const { tabMode: tabMode = "indentation" } = props;
    const editorRef = (0, $5E6i4.useRef)(null);
    const [code, setCode] = (0, $5E6i4.useState)(props.code || "");
    const { theme: theme } = props;
    (0, $5E6i4.useEffect)(()=>{
        setCode(props.code);
    }, [
        props.code
    ]);
    (0, $a0496693ce2fddad$export$52a148af2bad544)(editorRef, (text)=>{
        const t = text.slice(0, -1);
        setCode(t);
        if (props.onChange) props.onChange(t);
    }, {
        disabled: props.disabled,
        indentation: tabMode === "indentation" ? 2 : void 0
    });
    return /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)("div", {
        className: props.className,
        style: props.style,
        children: /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)((0, $d5bb3ba30412c929$export$39dbc3f558091353), {
            code: code,
            theme: props.theme || (0, $d5bb3ba30412c929$export$d9a33280f07116d9).nightOwl,
            language: props.language,
            children: ({ className: _className, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps, style: _style })=>/* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)("pre", {
                    className: _className,
                    style: $1232e0688c6b311d$var$__spreadValues($1232e0688c6b311d$var$__spreadValues({
                        margin: 0,
                        outline: "none",
                        padding: 10,
                        fontFamily: "inherit"
                    }, theme && typeof theme.plain === "object" ? theme.plain : {}), _style),
                    ref: editorRef,
                    spellCheck: "false",
                    children: tokens.map((line, lineIndex)=>/* @__PURE__ */ (0, $90cae257cc958273$exports.jsxs)("span", $1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, getLineProps({
                            line: line
                        })), {
                            children: [
                                line.filter((token)=>!token.empty).map((token, tokenIndex)=>/* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)("span", $1232e0688c6b311d$var$__spreadValues({}, getTokenProps({
                                        token: token
                                    })), `token-${tokenIndex}`)),
                                "\n"
                            ]
                        }), `line-${lineIndex}`))
                })
        })
    });
};
var $1232e0688c6b311d$export$7cda8d932e2f33c0 = $1232e0688c6b311d$var$CodeEditor;
var $1232e0688c6b311d$var$LiveContext = (0, $5E6i4.createContext)({});
var $1232e0688c6b311d$export$5a6106fef69bde7b = $1232e0688c6b311d$var$LiveContext;
var $1232e0688c6b311d$var$defaultTransforms = [
    "jsx",
    "imports"
];
function $1232e0688c6b311d$var$transform(opts = {}) {
    const transforms = Array.isArray(opts.transforms) ? opts.transforms.filter(Boolean) : $1232e0688c6b311d$var$defaultTransforms;
    return (code)=>(0, $7a5ccb00366653d1$export$51186ad6e864892a)(code, {
            transforms: transforms
        }).code;
}
var $1232e0688c6b311d$var$errorBoundary = (Element, errorCallback)=>{
    return class ErrorBoundary extends (0, $5E6i4.Component) {
        componentDidCatch(error) {
            errorCallback(error);
        }
        render() {
            return typeof Element === "function" ? /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)(Element, {}) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(Element) ? Element : null;
        }
    };
};
var $1232e0688c6b311d$var$errorBoundary_default = $1232e0688c6b311d$var$errorBoundary;
// src/utils/transpile/evalCode.ts
var $1232e0688c6b311d$var$evalCode = (code, scope)=>{
    const scopeKeys = Object.keys(scope);
    const scopeValues = scopeKeys.map((key)=>scope[key]);
    return new Function(...scopeKeys, code)(...scopeValues);
};
var $1232e0688c6b311d$var$evalCode_default = $1232e0688c6b311d$var$evalCode;
// src/utils/transpile/compose.ts
function $1232e0688c6b311d$var$compose(...functions) {
    return functions.reduce((acc, currentFn)=>(...args)=>acc(currentFn(...args)));
}
// src/utils/transpile/index.ts
var $1232e0688c6b311d$var$jsxConst = 'const _jsxFileName = "";';
var $1232e0688c6b311d$var$trimCode = (code)=>code.trim().replace(/;$/, "");
var $1232e0688c6b311d$var$spliceJsxConst = (code)=>code.replace($1232e0688c6b311d$var$jsxConst, "").trim();
var $1232e0688c6b311d$var$addJsxConst = (code)=>$1232e0688c6b311d$var$jsxConst + code;
var $1232e0688c6b311d$var$wrapReturn = (code)=>`return (${code})`;
var $1232e0688c6b311d$export$129b3480f9fbae0c = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, errorCallback)=>{
    const firstPassTransforms = [
        "jsx"
    ];
    enableTypeScript && firstPassTransforms.push("typescript");
    const transformed = $1232e0688c6b311d$var$compose($1232e0688c6b311d$var$addJsxConst, $1232e0688c6b311d$var$transform({
        transforms: [
            "imports"
        ]
    }), $1232e0688c6b311d$var$spliceJsxConst, $1232e0688c6b311d$var$trimCode, $1232e0688c6b311d$var$transform({
        transforms: firstPassTransforms
    }), $1232e0688c6b311d$var$wrapReturn, $1232e0688c6b311d$var$trimCode)(code);
    return $1232e0688c6b311d$var$errorBoundary_default($1232e0688c6b311d$var$evalCode_default(transformed, $1232e0688c6b311d$var$__spreadValues({
        React: (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))
    }, scope)), errorCallback);
};
var $1232e0688c6b311d$export$f4350c01fab98156 = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, resultCallback, errorCallback)=>{
    const render = (element)=>{
        if (typeof element === "undefined") errorCallback(new SyntaxError("`render` must be called with valid JSX."));
        else resultCallback($1232e0688c6b311d$var$errorBoundary_default(element, errorCallback));
    };
    if (!/render\s*\(/.test(code)) return errorCallback(new SyntaxError("No-Inline evaluations must call `render`."));
    const transforms = [
        "jsx",
        "imports"
    ];
    enableTypeScript && transforms.splice(1, 0, "typescript");
    $1232e0688c6b311d$var$evalCode_default($1232e0688c6b311d$var$transform({
        transforms: transforms
    })(code), $1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({
        React: (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))
    }, scope), {
        render: render
    }));
};
function $1232e0688c6b311d$var$LiveProvider({ children: children, code: code = "", language: language = "tsx", theme: theme, enableTypeScript: enableTypeScript = true, disabled: disabled = false, scope: scope, transformCode: transformCode, noInline: noInline = false }) {
    const [state, setState] = (0, $5E6i4.useState)({
        error: void 0,
        element: void 0
    });
    function transpileAsync(newCode) {
        return $1232e0688c6b311d$var$__async(this, null, function*() {
            const errorCallback = (error)=>{
                setState((previousState)=>$1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, previousState), {
                        error: error.toString(),
                        element: void 0
                    }));
            };
            try {
                const transformResult = transformCode ? transformCode(newCode) : newCode;
                try {
                    const transformedCode = yield Promise.resolve(transformResult);
                    const renderElement = (element)=>setState({
                            error: void 0,
                            element: element,
                            newCode: newCode
                        });
                    if (typeof transformedCode !== "string") throw new Error("Code failed to transform");
                    const input = {
                        code: transformedCode,
                        scope: scope,
                        enableTypeScript: enableTypeScript
                    };
                    if (noInline) {
                        setState((previousState)=>$1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, previousState), {
                                error: void 0,
                                element: null
                            }));
                        $1232e0688c6b311d$export$f4350c01fab98156(input, renderElement, errorCallback);
                    } else renderElement($1232e0688c6b311d$export$129b3480f9fbae0c(input, errorCallback));
                } catch (error) {
                    return errorCallback(error);
                }
            } catch (e) {
                errorCallback(e);
                return Promise.resolve();
            }
        });
    }
    const onError = (error)=>setState({
            error: error.toString()
        });
    (0, $5E6i4.useEffect)(()=>{
        transpileAsync(code).catch(onError);
    }, [
        code,
        scope,
        noInline,
        transformCode
    ]);
    const onChange = (newCode)=>{
        transpileAsync(newCode).catch(onError);
    };
    return /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)($1232e0688c6b311d$export$5a6106fef69bde7b.Provider, {
        value: $1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, state), {
            code: code,
            language: language,
            theme: theme,
            disabled: disabled,
            onError: onError,
            onChange: onChange
        }),
        children: children
    });
}
var $1232e0688c6b311d$export$7f6f1b77ca3c3ed3 = $1232e0688c6b311d$var$LiveProvider;
function $1232e0688c6b311d$export$f8f60579bb81d0e5(props) {
    const { code: code, language: language, theme: theme, disabled: disabled, onChange: onChange } = (0, $5E6i4.useContext)($1232e0688c6b311d$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)($1232e0688c6b311d$export$7cda8d932e2f33c0, $1232e0688c6b311d$var$__spreadValues({
        theme: theme,
        code: code,
        language: language,
        disabled: disabled,
        onChange: onChange
    }, props));
}
function $1232e0688c6b311d$export$1991b613205b2adc(props) {
    const { error: error } = (0, $5E6i4.useContext)($1232e0688c6b311d$export$5a6106fef69bde7b);
    return error ? /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)("pre", $1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, props), {
        children: error
    })) : null;
}
var $1232e0688c6b311d$var$ErrorBoundary = class extends (0, $5E6i4.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(err) {
        var _a, _b;
        (_b = (_a = this.props).onError) == null || _b.call(_a, err);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
};
function $1232e0688c6b311d$var$LivePreview(_a) {
    var _b = _a, { Component: Component3 = "div" } = _b, rest = $1232e0688c6b311d$var$__objRest(_b, [
        "Component"
    ]);
    const { element: Element, onError: onError, newCode: newCode } = (0, $5E6i4.useContext)($1232e0688c6b311d$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)($1232e0688c6b311d$var$ErrorBoundary, {
        onError: onError,
        children: /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)(Component3, $1232e0688c6b311d$var$__spreadProps($1232e0688c6b311d$var$__spreadValues({}, rest), {
            children: Element ? /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)(Element, {}) : null
        }))
    }, newCode);
}
var $1232e0688c6b311d$export$ba3ca6901d2e4f5f = $1232e0688c6b311d$var$LivePreview;
function $1232e0688c6b311d$export$3039ad97e9f7b4e0(WrappedComponent) {
    const WithLive = (props)=>/* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)($1232e0688c6b311d$export$5a6106fef69bde7b.Consumer, {
            children: (live)=>/* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)(WrappedComponent, $1232e0688c6b311d$var$__spreadValues({
                    live: live
                }, props))
        });
    WithLive.displayName = "WithLive";
    return WithLive;
}




var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $73919e3c2229bbf5$var$Badge = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$73919e3c2229bbf5$var$Badge.displayName = 'Badge';
var $73919e3c2229bbf5$export$2e2bcd8739ae039 = $73919e3c2229bbf5$var$Badge;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $22e1b17c3627b424$var$CardBody = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$22e1b17c3627b424$var$CardBody.displayName = 'CardBody';
var $22e1b17c3627b424$export$2e2bcd8739ae039 = $22e1b17c3627b424$var$CardBody;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $8caf6c93e6d0aa80$var$CardFooter = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$8caf6c93e6d0aa80$var$CardFooter.displayName = 'CardFooter';
var $8caf6c93e6d0aa80$export$2e2bcd8739ae039 = $8caf6c93e6d0aa80$var$CardFooter;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $4143d8e7cbe1eedf$var$context = /*#__PURE__*/ $5E6i4.createContext(null);
$4143d8e7cbe1eedf$var$context.displayName = 'CardHeaderContext';
var $4143d8e7cbe1eedf$export$2e2bcd8739ae039 = $4143d8e7cbe1eedf$var$context;



"use client";
const $1c277d1fe2d4932d$var$CardHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $5E6i4.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4143d8e7cbe1eedf$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix)
        })
    });
});
$1c277d1fe2d4932d$var$CardHeader.displayName = 'CardHeader';
var $1c277d1fe2d4932d$export$2e2bcd8739ae039 = $1c277d1fe2d4932d$var$CardHeader;




var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $023c89af647b814a$var$CardImg = /*#__PURE__*/ $5E6i4.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$023c89af647b814a$var$CardImg.displayName = 'CardImg';
var $023c89af647b814a$export$2e2bcd8739ae039 = $023c89af647b814a$var$CardImg;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $ac6be2edd263015b$var$CardImgOverlay = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$ac6be2edd263015b$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $ac6be2edd263015b$export$2e2bcd8739ae039 = $ac6be2edd263015b$var$CardImgOverlay;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $bb8cc3cbf7259b40$var$CardLink = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$bb8cc3cbf7259b40$var$CardLink.displayName = 'CardLink';
var $bb8cc3cbf7259b40$export$2e2bcd8739ae039 = $bb8cc3cbf7259b40$var$CardLink;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


var $1dc04b355c812538$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $5E6i4.forwardRef((p, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));



"use client";
const $599c2b9d2b949717$var$DivStyledAsH6 = (0, $1dc04b355c812538$export$2e2bcd8739ae039)('h6');
const $599c2b9d2b949717$var$CardSubtitle = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $599c2b9d2b949717$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$599c2b9d2b949717$var$CardSubtitle.displayName = 'CardSubtitle';
var $599c2b9d2b949717$export$2e2bcd8739ae039 = $599c2b9d2b949717$var$CardSubtitle;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $57792f29e4316439$var$CardText = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$57792f29e4316439$var$CardText.displayName = 'CardText';
var $57792f29e4316439$export$2e2bcd8739ae039 = $57792f29e4316439$var$CardText;



var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $e378c534030d646a$var$DivStyledAsH5 = (0, $1dc04b355c812538$export$2e2bcd8739ae039)('h5');
const $e378c534030d646a$var$CardTitle = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $e378c534030d646a$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$e378c534030d646a$var$CardTitle.displayName = 'CardTitle';
var $e378c534030d646a$export$2e2bcd8739ae039 = $e378c534030d646a$var$CardTitle;



"use client";
const $717c2fb651d8cbb5$var$Card = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $22e1b17c3627b424$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$717c2fb651d8cbb5$var$Card.displayName = 'Card';
var $717c2fb651d8cbb5$export$2e2bcd8739ae039 = Object.assign($717c2fb651d8cbb5$var$Card, {
    Img: (0, $023c89af647b814a$export$2e2bcd8739ae039),
    Title: (0, $e378c534030d646a$export$2e2bcd8739ae039),
    Subtitle: (0, $599c2b9d2b949717$export$2e2bcd8739ae039),
    Body: (0, $22e1b17c3627b424$export$2e2bcd8739ae039),
    Link: (0, $bb8cc3cbf7259b40$export$2e2bcd8739ae039),
    Text: (0, $57792f29e4316439$export$2e2bcd8739ae039),
    Header: (0, $1c277d1fe2d4932d$export$2e2bcd8739ae039),
    Footer: (0, $8caf6c93e6d0aa80$export$2e2bcd8739ae039),
    ImgOverlay: (0, $ac6be2edd263015b$export$2e2bcd8739ae039)
});



var $5E6i4 = parcelRequire("5E6i4");
var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $ba9c70d791b0cdd0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ba9c70d791b0cdd0$var$_toPropertyKey(arg) {
    var key = $ba9c70d791b0cdd0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ba9c70d791b0cdd0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ba9c70d791b0cdd0$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $ba9c70d791b0cdd0$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $5E6i4.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $5E6i4.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $5E6i4.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $ba9c70d791b0cdd0$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $ba9c70d791b0cdd0$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $ba9c70d791b0cdd0$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($ba9c70d791b0cdd0$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $ba9c70d791b0cdd0$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $5E6i4 = parcelRequire("5E6i4");
function $86589b927684e763$export$2e2bcd8739ae039(value) {
    const ref = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $5E6i4 = parcelRequire("5E6i4");
function $5c7af4edabf1c24b$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $5E6i4.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $251b57e0dd3e1100$var$useCommittedRef(value) {
    const ref = (0, $5E6i4.useRef)(value);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $251b57e0dd3e1100$export$2e2bcd8739ae039 = $251b57e0dd3e1100$var$useCommittedRef;


function $3d66457f2389a961$export$2e2bcd8739ae039(fn) {
    const ref = (0, $251b57e0dd3e1100$export$2e2bcd8739ae039)(fn);
    return (0, $5E6i4.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $8e42536bf7aa17e0$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(listener);
    (0, $5E6i4.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $5E6i4 = parcelRequire("5E6i4");
const $9a7ab30501dbc7c6$var$DropdownContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $9a7ab30501dbc7c6$export$2e2bcd8739ae039 = $9a7ab30501dbc7c6$var$DropdownContext;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $17e6c6b69fc5aca9$export$2e2bcd8739ae039() {
    return (0, $5E6i4.useState)(null);
}




var $5E6i4 = parcelRequire("5E6i4");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $e1f7a97593772fdc$export$2e2bcd8739ae039() {
    const mounted = (0, $5E6i4.useRef)(true);
    const isMounted = (0, $5E6i4.useRef)(()=>mounted.current);
    (0, $5E6i4.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $f59ee1b81eb363b9$var$useSafeState(state) {
    const isMounted = (0, $e1f7a97593772fdc$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $5E6i4.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $f59ee1b81eb363b9$export$2e2bcd8739ae039 = $f59ee1b81eb363b9$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $bdc00d1abeff15d8$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


const $570579b9bf1bebbf$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $570579b9bf1bebbf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $570579b9bf1bebbf$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $570579b9bf1bebbf$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $570579b9bf1bebbf$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $570579b9bf1bebbf$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $570579b9bf1bebbf$var$EMPTY_MODIFIERS } = _ref, config = $570579b9bf1bebbf$var$_objectWithoutPropertiesLoose(_ref, $570579b9bf1bebbf$var$_excluded);
    const prevModifiers = (0, $5E6i4.useRef)(modifiers);
    const popperInstanceRef = (0, $5E6i4.useRef)();
    const update = (0, $5E6i4.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $5E6i4.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $f59ee1b81eb363b9$export$2e2bcd8739ae039)((0, $5E6i4.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $5E6i4.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $5E6i4.useMemo)(()=>{
        if (!(0, $9b8288c93dde0611$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $570579b9bf1bebbf$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $bdc00d1abeff15d8$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $570579b9bf1bebbf$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $570579b9bf1bebbf$export$2e2bcd8739ae039 = $570579b9bf1bebbf$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $5E6i4 = parcelRequire("5E6i4");

var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


const $80d12feece524665$var$noop = ()=>{};
function $80d12feece524665$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $80d12feece524665$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $80d12feece524665$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $80d12feece524665$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $80d12feece524665$var$useClickOutside(ref, onClickOutside = $80d12feece524665$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $5E6i4.useRef)(false);
    const waitingForTrigger = (0, $5E6i4.useRef)(false);
    const handleMouseCapture = (0, $5E6i4.useCallback)((e)=>{
        const currentTarget = $80d12feece524665$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $80d12feece524665$var$isModifiedEvent(e) || !$80d12feece524665$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $80d12feece524665$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $5E6i4.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)($80d12feece524665$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($80d12feece524665$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, $80d12feece524665$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $80d12feece524665$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $80d12feece524665$export$2e2bcd8739ae039 = $80d12feece524665$var$useClickOutside;


function $dd2014ecbb51d316$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $dd2014ecbb51d316$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $dd2014ecbb51d316$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $dd2014ecbb51d316$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $dd2014ecbb51d316$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $5e97139bdb3a03c6$var$_excluded = [
    "children",
    "usePopper"
];
function $5e97139bdb3a03c6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $5e97139bdb3a03c6$var$noop = ()=>{};
function $5e97139bdb3a03c6$export$133c4d08f3775d64(options = {}) {
    const context = (0, $5E6i4.useContext)((0, $9a7ab30501dbc7c6$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $17e6c6b69fc5aca9$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $5E6i4.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $570579b9bf1bebbf$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $dd2014ecbb51d316$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $5e97139bdb3a03c6$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $80d12feece524665$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $5e97139bdb3a03c6$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $5e97139bdb3a03c6$var$_objectWithoutPropertiesLoose(_ref, $5e97139bdb3a03c6$var$_excluded);
    const [props, meta] = $5e97139bdb3a03c6$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(props, meta)
    });
}
$5e97139bdb3a03c6$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $5e97139bdb3a03c6$export$2e2bcd8739ae039 = $5e97139bdb3a03c6$var$DropdownMenu;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext);
const $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(false);
// This is only used in React < 18.
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $5E6i4.useContext)($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useCounter(cur === $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $5E6i4.useState)(true);
    let value = (0, $5E6i4.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $5E6i4.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $626fefbb79cb0121$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $5E6i4.useContext)($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $5E6i4.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $5E6i4.useContext)($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext && $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useId();
    let [didSSR] = (0, $5E6i4.useState)($626fefbb79cb0121$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $626fefbb79cb0121$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))['useId'] === 'function' ? $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $626fefbb79cb0121$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4)))['useSyncExternalStore']($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$subscribe, $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$getSnapshot, $626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $5E6i4.useContext)($626fefbb79cb0121$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




const $2da28a299213dc24$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $2da28a299213dc24$var$noop = ()=>{};
function $2da28a299213dc24$export$96df6c7c5036b9a2() {
    const id = (0, $626fefbb79cb0121$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $2da28a299213dc24$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $5E6i4.useContext)((0, $9a7ab30501dbc7c6$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $5E6i4.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $2da28a299213dc24$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $2da28a299213dc24$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $2da28a299213dc24$var$DropdownToggle({ children: children }) {
    const [props, meta] = $2da28a299213dc24$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(props, meta)
    });
}
$2da28a299213dc24$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $2da28a299213dc24$export$2e2bcd8739ae039 = $2da28a299213dc24$var$DropdownToggle;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $e84edd8a6cdadf5e$var$SelectableContext = /*#__PURE__*/ $5E6i4.createContext(null);
const $e84edd8a6cdadf5e$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $e84edd8a6cdadf5e$export$2e2bcd8739ae039 = $e84edd8a6cdadf5e$var$SelectableContext;



var $5E6i4 = parcelRequire("5E6i4");
const $8a52511c50221fc6$var$NavContext = /*#__PURE__*/ $5E6i4.createContext(null);
$8a52511c50221fc6$var$NavContext.displayName = 'NavContext';
var $8a52511c50221fc6$export$2e2bcd8739ae039 = $8a52511c50221fc6$var$NavContext;



const $02e0cc2db9791bde$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $02e0cc2db9791bde$export$635202801f9383a0 = `rrUi`;
function $02e0cc2db9791bde$export$5cc3b7b83e34ade7(property) {
    return `${$02e0cc2db9791bde$export$fd7bcb7e9bef4e8a}${property}`;
}
function $02e0cc2db9791bde$export$7776c0a7cd2eb3e0(property) {
    return `${$02e0cc2db9791bde$export$635202801f9383a0}${property}`;
}



const $fe30e38f7a671751$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $fe30e38f7a671751$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $fe30e38f7a671751$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $5E6i4.useContext)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039));
    const navContext = (0, $5E6i4.useContext)((0, $8a52511c50221fc6$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $fe30e38f7a671751$var$DropdownItem = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $33be28a2f2a0a79b$export$2e2bcd8739ae039) } = _ref, props = $fe30e38f7a671751$var$_objectWithoutPropertiesLoose(_ref, $fe30e38f7a671751$var$_excluded);
    const [dropdownItemProps] = $fe30e38f7a671751$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$fe30e38f7a671751$var$DropdownItem.displayName = 'DropdownItem';
var $fe30e38f7a671751$export$2e2bcd8739ae039 = $fe30e38f7a671751$var$DropdownItem;





var $5E6i4 = parcelRequire("5E6i4");

const $7f9b3515e43aba94$var$Context = /*#__PURE__*/ (0, $5E6i4.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $7f9b3515e43aba94$export$f7d306aeb1cf5fbc = $7f9b3515e43aba94$var$Context.Provider;
function $7f9b3515e43aba94$export$2e2bcd8739ae039() {
    return (0, $5E6i4.useContext)($7f9b3515e43aba94$var$Context);
}



function $3854ae6df02661ed$var$useRefWithUpdate() {
    const forceUpdate = (0, $5c7af4edabf1c24b$export$2e2bcd8739ae039)();
    const ref = (0, $5E6i4.useRef)(null);
    const attachRef = (0, $5E6i4.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $3854ae6df02661ed$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $7f9b3515e43aba94$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $ba9c70d791b0cdd0$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $3854ae6df02661ed$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $3854ae6df02661ed$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $86589b927684e763$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $5E6i4.useRef)(null);
    const focusInDropdown = (0, $5E6i4.useRef)(false);
    const onSelectCtx = (0, $5E6i4.useContext)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039));
    const toggle = (0, $5E6i4.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $5E6i4.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $2da28a299213dc24$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $5E6i4.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $5E6i4.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $8e42536bf7aa17e0$export$2e2bcd8739ae039)((0, $5E6i4.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9a7ab30501dbc7c6$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$3854ae6df02661ed$var$Dropdown.displayName = 'Dropdown';
$3854ae6df02661ed$var$Dropdown.Menu = (0, $5e97139bdb3a03c6$export$2e2bcd8739ae039);
$3854ae6df02661ed$var$Dropdown.Toggle = (0, $2da28a299213dc24$export$2e2bcd8739ae039);
$3854ae6df02661ed$var$Dropdown.Item = (0, $fe30e38f7a671751$export$2e2bcd8739ae039);
var $3854ae6df02661ed$export$2e2bcd8739ae039 = $3854ae6df02661ed$var$Dropdown;


function $149d2f1aa8ebe3ec$export$2e2bcd8739ae039() {
    return $149d2f1aa8ebe3ec$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039.apply(null, arguments);
}




var $5E6i4 = parcelRequire("5E6i4");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $e238c8f6db3783fc$var$noop = function noop() {};
function $e238c8f6db3783fc$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $e238c8f6db3783fc$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $e238c8f6db3783fc$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$e238c8f6db3783fc$export$26cbf8c37e721e67(prop)] = $e238c8f6db3783fc$var$noop;
        var handler;
    });
    return propTypes;
}
function $e238c8f6db3783fc$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $e238c8f6db3783fc$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $e238c8f6db3783fc$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $82ed2fe1f7c20eed$var$_toPropertyKey(arg) {
    var key = $82ed2fe1f7c20eed$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $82ed2fe1f7c20eed$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $82ed2fe1f7c20eed$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $5E6i4.useRef)(propValue !== undefined);
    var _useState = (0, $5E6i4.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $5E6i4.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $82ed2fe1f7c20eed$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$e238c8f6db3783fc$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $d0d6c9b969929211$export$2e2bcd8739ae039)(_ref, [
            $e238c8f6db3783fc$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($82ed2fe1f7c20eed$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $82ed2fe1f7c20eed$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $5E6i4 = parcelRequire("5E6i4");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $0cb4da69380b62f2$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $0cb4da69380b62f2$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $e238c8f6db3783fc$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($e238c8f6db3783fc$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $89ad6a6097d619bd$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$e238c8f6db3783fc$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$e238c8f6db3783fc$export$12ae2baa35bd9b8b(props, key) && $e238c8f6db3783fc$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$e238c8f6db3783fc$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $d0d6c9b969929211$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Component, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $e238c8f6db3783fc$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(UncontrolledComponent, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $0cb4da69380b62f2$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $0cb4da69380b62f2$export$2e2bcd8739ae039(newComponent, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $697234e28794291e$var$useCommittedRef(value) {
    const ref = (0, $5E6i4.useRef)(value);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $697234e28794291e$export$2e2bcd8739ae039 = $697234e28794291e$var$useCommittedRef;


function $bb65a2def1cecb04$export$2e2bcd8739ae039(fn) {
    const ref = (0, $697234e28794291e$export$2e2bcd8739ae039)(fn);
    return (0, $5E6i4.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $9d59eff50cec2e74$var$DropdownContext = /*#__PURE__*/ $5E6i4.createContext({});
$9d59eff50cec2e74$var$DropdownContext.displayName = 'DropdownContext';
var $9d59eff50cec2e74$export$2e2bcd8739ae039 = $9d59eff50cec2e74$var$DropdownContext;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $a50704fb6351eb5a$var$DropdownDivider = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$a50704fb6351eb5a$var$DropdownDivider.displayName = 'DropdownDivider';
var $a50704fb6351eb5a$export$2e2bcd8739ae039 = $a50704fb6351eb5a$var$DropdownDivider;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $7f7849b7558cc595$var$DropdownHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$7f7849b7558cc595$var$DropdownHeader.displayName = 'DropdownHeader';
var $7f7849b7558cc595$export$2e2bcd8739ae039 = $7f7849b7558cc595$var$DropdownHeader;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");
function $e043ec0ae15a987f$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $5E6i4.useCallback)(()=>document, []);
    return (0, $8e42536bf7aa17e0$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $5E6i4 = parcelRequire("5E6i4");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $3b980e11ef063db2$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $251b57e0dd3e1100$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $251b57e0dd3e1100$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $5E6i4.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $3b980e11ef063db2$export$2e2bcd8739ae039 = $3b980e11ef063db2$var$useInterval;



var $5E6i4 = parcelRequire("5E6i4");

function $dadc452bf9915f0e$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $251b57e0dd3e1100$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $251b57e0dd3e1100$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $5E6i4.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $dadc452bf9915f0e$export$2e2bcd8739ae039 = $dadc452bf9915f0e$var$useRafInterval;



var $5E6i4 = parcelRequire("5E6i4");
function $721b0ba10a04971a$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $5E6i4.useState)(initialState);
    const updater = (0, $5E6i4.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $48947ee30dac2f67$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $721b0ba10a04971a$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $5E6i4 = parcelRequire("5E6i4");
function $73526e2831318650$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $5E6i4.useState)({
        image: null,
        error: null
    });
    (0, $5E6i4.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $d117dafa0e3754ae$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $d117dafa0e3754ae$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $d117dafa0e3754ae$export$2e2bcd8739ae039 = $d117dafa0e3754ae$var$isDOM || $d117dafa0e3754ae$var$isReactNative ? (0, $5E6i4.useLayoutEffect) : (0, $5E6i4.useEffect);


const $6c3292b08da2f5b8$var$targetMap = new WeakMap();
let $6c3292b08da2f5b8$var$resizeObserver;
function $6c3292b08da2f5b8$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $6c3292b08da2f5b8$var$resizeObserver = $6c3292b08da2f5b8$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $6c3292b08da2f5b8$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $6c3292b08da2f5b8$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $5E6i4.useState)(null);
    (0, $d117dafa0e3754ae$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $6c3292b08da2f5b8$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $6c3292b08da2f5b8$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $6c3292b08da2f5b8$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $0213f21feff22344$var$_excluded = [
    "onKeyDown"
];
function $0213f21feff22344$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0213f21feff22344$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $0213f21feff22344$var$Anchor = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $0213f21feff22344$var$_objectWithoutPropertiesLoose(_ref, $0213f21feff22344$var$_excluded);
    const [buttonProps] = (0, $33be28a2f2a0a79b$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($0213f21feff22344$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$0213f21feff22344$var$Anchor.displayName = 'Anchor';
var $0213f21feff22344$export$2e2bcd8739ae039 = $0213f21feff22344$var$Anchor;




"use client";
const $f91c6af5a888a30e$var$DropdownItem = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $0213f21feff22344$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $fe30e38f7a671751$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$f91c6af5a888a30e$var$DropdownItem.displayName = 'DropdownItem';
var $f91c6af5a888a30e$export$2e2bcd8739ae039 = $f91c6af5a888a30e$var$DropdownItem;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $857d8b525cde510d$var$DropdownItemText = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$857d8b525cde510d$var$DropdownItemText.displayName = 'DropdownItemText';
var $857d8b525cde510d$export$2e2bcd8739ae039 = $857d8b525cde510d$var$DropdownItemText;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $420ea9a229174095$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $420ea9a229174095$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $420ea9a229174095$export$2e2bcd8739ae039 = $420ea9a229174095$var$isDOM || $420ea9a229174095$var$isReactNative ? (0, $5E6i4.useLayoutEffect) : (0, $5E6i4.useEffect);






var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $264fbddeaff05727$var$context = /*#__PURE__*/ $5E6i4.createContext(null);
$264fbddeaff05727$var$context.displayName = 'InputGroupContext';
var $264fbddeaff05727$export$2e2bcd8739ae039 = $264fbddeaff05727$var$context;



var $5E6i4 = parcelRequire("5E6i4");
"use client";
// TODO: check
const $fcb4f8b397094781$var$context = /*#__PURE__*/ $5E6i4.createContext(null);
$fcb4f8b397094781$var$context.displayName = 'NavbarContext';
var $fcb4f8b397094781$export$2e2bcd8739ae039 = $fcb4f8b397094781$var$context;




parcelRequire("5E6i4");

function $eacf2254790f04da$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $7ee2a69462f2a737$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $7ee2a69462f2a737$var$DropdownMenu = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $5E6i4.useContext)((0, $fcb4f8b397094781$export$2e2bcd8739ae039));
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $5E6i4.useContext)((0, $9d59eff50cec2e74$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $5E6i4.useContext)((0, $264fbddeaff05727$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $7ee2a69462f2a737$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $5e97139bdb3a03c6$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)((0, $eacf2254790f04da$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $420ea9a229174095$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$7ee2a69462f2a737$var$DropdownMenu.displayName = 'DropdownMenu';
var $7ee2a69462f2a737$export$2e2bcd8739ae039 = $7ee2a69462f2a737$var$DropdownMenu;







var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $f634d0894cabdc0c$var$DropdownToggle = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $5E6i4.useContext)((0, $9a7ab30501dbc7c6$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $2da28a299213dc24$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)(toggleProps.ref, (0, $eacf2254790f04da$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$f634d0894cabdc0c$var$DropdownToggle.displayName = 'DropdownToggle';
var $f634d0894cabdc0c$export$2e2bcd8739ae039 = $f634d0894cabdc0c$var$DropdownToggle;






"use client";
const $a8ea7e3963a7ebe0$var$Dropdown = /*#__PURE__*/ $5E6i4.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $82ed2fe1f7c20eed$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $5E6i4.useContext)((0, $264fbddeaff05727$export$2e2bcd8739ae039));
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $78821005c47d14e8$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $7ee2a69462f2a737$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $5E6i4.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9d59eff50cec2e74$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3854ae6df02661ed$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$a8ea7e3963a7ebe0$var$Dropdown.displayName = 'Dropdown';
var $a8ea7e3963a7ebe0$export$2e2bcd8739ae039 = Object.assign($a8ea7e3963a7ebe0$var$Dropdown, {
    Toggle: (0, $f634d0894cabdc0c$export$2e2bcd8739ae039),
    Menu: (0, $7ee2a69462f2a737$export$2e2bcd8739ae039),
    Item: (0, $f91c6af5a888a30e$export$2e2bcd8739ae039),
    ItemText: (0, $857d8b525cde510d$export$2e2bcd8739ae039),
    Divider: (0, $a50704fb6351eb5a$export$2e2bcd8739ae039),
    Header: (0, $7f7849b7558cc595$export$2e2bcd8739ae039)
});



var $5E6i4 = parcelRequire("5E6i4");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();




"use client";
const $82fa4ab13bb8a9e3$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
};
const $82fa4ab13bb8a9e3$var$Image = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$82fa4ab13bb8a9e3$var$Image.displayName = 'Image';
var $82fa4ab13bb8a9e3$export$2e2bcd8739ae039 = $82fa4ab13bb8a9e3$var$Image;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $7e2dd7c845e283cd$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $7e2dd7c845e283cd$export$c9058316764c140e(refA, refB) {
    const a = $7e2dd7c845e283cd$var$toFnRef(refA);
    const b = $7e2dd7c845e283cd$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $7e2dd7c845e283cd$var$useMergedRefs(refA, refB) {
    return (0, $5E6i4.useMemo)(()=>$7e2dd7c845e283cd$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $7e2dd7c845e283cd$export$2e2bcd8739ae039 = $7e2dd7c845e283cd$var$useMergedRefs;





var $5E6i4 = parcelRequire("5E6i4");
const $092887308834f627$var$TabContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $092887308834f627$export$2e2bcd8739ae039 = $092887308834f627$var$TabContext;




var $5E6i4 = parcelRequire("5E6i4");







const $078bfcf9e1cbc848$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $078bfcf9e1cbc848$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $078bfcf9e1cbc848$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $5E6i4.useContext)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039));
    const navContext = (0, $5E6i4.useContext)((0, $8a52511c50221fc6$export$2e2bcd8739ae039));
    const tabContext = (0, $5E6i4.useContext)((0, $092887308834f627$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $078bfcf9e1cbc848$var$NavItem = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $33be28a2f2a0a79b$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $078bfcf9e1cbc848$var$_objectWithoutPropertiesLoose(_ref, $078bfcf9e1cbc848$var$_excluded);
    const [props, meta] = $078bfcf9e1cbc848$export$d7a68693710982a(Object.assign({
        key: (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$078bfcf9e1cbc848$var$NavItem.displayName = 'NavItem';
var $078bfcf9e1cbc848$export$2e2bcd8739ae039 = $078bfcf9e1cbc848$var$NavItem;



const $c16d0339a9132c32$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $c16d0339a9132c32$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c16d0339a9132c32$var$noop = ()=>{};
const $c16d0339a9132c32$var$EVENT_KEY_ATTR = (0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('event-key');
const $c16d0339a9132c32$var$Nav = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $c16d0339a9132c32$var$_objectWithoutPropertiesLoose(_ref, $c16d0339a9132c32$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $5c7af4edabf1c24b$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $5E6i4.useRef)(false);
    const parentOnSelect = (0, $5E6i4.useContext)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039));
    const tabContext = (0, $5E6i4.useContext)((0, $092887308834f627$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $5E6i4.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$c16d0339a9132c32$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $02e0cc2db9791bde$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $5E6i4.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$c16d0339a9132c32$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $7e2dd7c845e283cd$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e84edd8a6cdadf5e$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8a52511c50221fc6$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $c16d0339a9132c32$var$noop,
                getControllerId: getControllerId || $c16d0339a9132c32$var$noop
            },
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$c16d0339a9132c32$var$Nav.displayName = 'Nav';
var $c16d0339a9132c32$export$2e2bcd8739ae039 = Object.assign($c16d0339a9132c32$var$Nav, {
    Item: (0, $078bfcf9e1cbc848$export$2e2bcd8739ae039)
});






var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $e469f0bda2a6b815$var$NavItem = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$e469f0bda2a6b815$var$NavItem.displayName = 'NavItem';
var $e469f0bda2a6b815$export$2e2bcd8739ae039 = $e469f0bda2a6b815$var$NavItem;




var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $64356d9f893a0fb4$var$NavLink = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $0213f21feff22344$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $078bfcf9e1cbc848$export$d7a68693710982a)({
        key: (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$64356d9f893a0fb4$var$NavLink.displayName = 'NavLink';
var $64356d9f893a0fb4$export$2e2bcd8739ae039 = $64356d9f893a0fb4$var$NavLink;



"use client";
const $8997ca53208bd22a$var$Nav = /*#__PURE__*/ $5E6i4.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $82ed2fe1f7c20eed$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $5E6i4.useContext)((0, $fcb4f8b397094781$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $5E6i4.useContext)((0, $4143d8e7cbe1eedf$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c16d0339a9132c32$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$8997ca53208bd22a$var$Nav.displayName = 'Nav';
var $8997ca53208bd22a$export$2e2bcd8739ae039 = Object.assign($8997ca53208bd22a$var$Nav, {
    Item: (0, $e469f0bda2a6b815$export$2e2bcd8739ae039),
    Link: (0, $64356d9f893a0fb4$export$2e2bcd8739ae039)
});




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $9f868753a27b6dd6$export$2e2bcd8739ae039() {
    const mounted = (0, $5E6i4.useRef)(true);
    const isMounted = (0, $5E6i4.useRef)(()=>mounted.current);
    (0, $5E6i4.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $5E6i4 = parcelRequire("5E6i4");
function $2a2c55a611d89d6e$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $5E6i4.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $5E6i4 = parcelRequire("5E6i4");
function $e4a530e80e5cf664$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $2a2c55a611d89d6e$export$2e2bcd8739ae039)(fn);
    (0, $5E6i4.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $3edbae4955ba3eeb$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $3edbae4955ba3eeb$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $3edbae4955ba3eeb$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$3edbae4955ba3eeb$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $3edbae4955ba3eeb$var$MAX_DELAY_MS);
}
function $3edbae4955ba3eeb$export$2e2bcd8739ae039() {
    const isMounted = (0, $9f868753a27b6dd6$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $5E6i4.useRef)();
    (0, $e4a530e80e5cf664$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $5E6i4.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $3edbae4955ba3eeb$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $3edbae4955ba3eeb$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}







var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");






var $5E6i4 = parcelRequire("5E6i4");



const $977fc4ed69201a17$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $977fc4ed69201a17$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $977fc4ed69201a17$var$noop;
    (0, $80d12feece524665$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        if ((0, $ac36aa99f6f4d073$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $5E6i4.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $80d12feece524665$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $977fc4ed69201a17$export$2e2bcd8739ae039 = $977fc4ed69201a17$var$useRootClose;





var $5E6i4 = parcelRequire("5E6i4");

const $0bec21ed941556c3$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $0bec21ed941556c3$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $7f9b3515e43aba94$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $5E6i4.useState)(()=>$0bec21ed941556c3$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $0bec21ed941556c3$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $5E6i4.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $5E6i4.useEffect)(()=>{
        const nextRef = $0bec21ed941556c3$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

function $2864e8cb6991f164$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $5E6i4.useRef)(null);
    const hasEnteredRef = (0, $5E6i4.useRef)(inProp);
    const handleExited = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(onExited);
    (0, $5E6i4.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $7e2dd7c845e283cd$export$2e2bcd8739ae039)(ref, (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $5E6i4.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $2864e8cb6991f164$export$2e2bcd8739ae039 = $2864e8cb6991f164$var$NoopTransition;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");


const $cb46e915455e34ba$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $cb46e915455e34ba$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cb46e915455e34ba$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $cb46e915455e34ba$var$_objectWithoutPropertiesLoose(_ref, $cb46e915455e34ba$var$_excluded);
    const nodeRef = (0, $5E6i4.useRef)(null);
    const mergedRef = (0, $7e2dd7c845e283cd$export$2e2bcd8739ae039)(nodeRef, (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $5E6i4.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $5E6i4.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $5E6i4.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $5E6i4.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $5E6i4.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $5E6i4.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $5E6i4.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $5E6i4.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $4718907fce18e7ef$var$_excluded = [
    "component"
];
function $4718907fce18e7ef$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $4718907fce18e7ef$var$RTGTransition = /*#__PURE__*/ $5E6i4.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $4718907fce18e7ef$var$_objectWithoutPropertiesLoose(_ref, $4718907fce18e7ef$var$_excluded);
    const transitionProps = (0, $cb46e915455e34ba$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $4718907fce18e7ef$export$2e2bcd8739ae039 = $4718907fce18e7ef$var$RTGTransition;




function $314407abb5187ce9$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $5E6i4.useRef)(null);
    const isInitialRef = (0, $5E6i4.useRef)(true);
    const handleTransition = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(onTransition);
    (0, $d117dafa0e3754ae$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $d117dafa0e3754ae$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $314407abb5187ce9$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $5E6i4.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $314407abb5187ce9$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $7e2dd7c845e283cd$export$2e2bcd8739ae039)(ref, (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $5E6i4.cloneElement)(children, {
        ref: combinedRef
    });
}
function $314407abb5187ce9$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4718907fce18e7ef$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($314407abb5187ce9$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2864e8cb6991f164$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $ab2423a942577bb9$var$Overlay = /*#__PURE__*/ $5E6i4.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $17e6c6b69fc5aca9$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $17e6c6b69fc5aca9$export$2e2bcd8739ae039)();
    const mergedRef = (0, $7e2dd7c845e283cd$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $0bec21ed941556c3$export$2e2bcd8739ae039)(props.container);
    const target = (0, $0bec21ed941556c3$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $5E6i4.useState)(!props.show);
    const popper = (0, $570579b9bf1bebbf$export$2e2bcd8739ae039)(target, rootElement, (0, $dd2014ecbb51d316$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $977fc4ed69201a17$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $314407abb5187ce9$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).createPortal(child, container) : null;
});
$ab2423a942577bb9$var$Overlay.displayName = 'Overlay';
var $ab2423a942577bb9$export$2e2bcd8739ae039 = $ab2423a942577bb9$var$Overlay;






var $5E6i4 = parcelRequire("5E6i4");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $5c2cfe2ed7a3850c$var$PopoverHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$5c2cfe2ed7a3850c$var$PopoverHeader.displayName = 'PopoverHeader';
var $5c2cfe2ed7a3850c$export$2e2bcd8739ae039 = $5c2cfe2ed7a3850c$var$PopoverHeader;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $349aaa83eea938a5$var$PopoverBody = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$349aaa83eea938a5$var$PopoverBody.displayName = 'PopoverBody';
var $349aaa83eea938a5$export$2e2bcd8739ae039 = $349aaa83eea938a5$var$PopoverBody;



var $5E6i4 = parcelRequire("5E6i4");
class $11074c4a28b61007$export$34582a676b91ff07 extends $5E6i4.Component {
}
function $11074c4a28b61007$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $793d8033f93c022c$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $6d7cb74c8723debd$var$Popover = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $78821005c47d14e8$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $11074c4a28b61007$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $793d8033f93c022c$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $349aaa83eea938a5$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$6d7cb74c8723debd$var$Popover.displayName = 'Popover';
var $6d7cb74c8723debd$export$2e2bcd8739ae039 = Object.assign($6d7cb74c8723debd$var$Popover, {
    Header: (0, $5c2cfe2ed7a3850c$export$2e2bcd8739ae039),
    Body: (0, $349aaa83eea938a5$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $c07cc3333d480df1$var$Tooltip = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $78821005c47d14e8$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $11074c4a28b61007$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $793d8033f93c022c$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$c07cc3333d480df1$var$Tooltip.displayName = 'Tooltip';
var $c07cc3333d480df1$export$2e2bcd8739ae039 = Object.assign($c07cc3333d480df1$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $a78fa77b2f82b14f$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $5E6i4.useRef)(null);
    const popoverClass = (0, $78821005c47d14e8$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $78821005c47d14e8$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $5E6i4.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $6d7cb74c8723debd$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $c07cc3333d480df1$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $5E6i4 = parcelRequire("5E6i4");






const $e50dbcc016964135$var$fadeStyles = {
    [(0, $c0cf3feaee946af3$export$df38205c966be359)]: 'show',
    [(0, $c0cf3feaee946af3$export$78e9e6e3e014d60a)]: 'show'
};
const $e50dbcc016964135$var$Fade = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $5E6i4.useCallback)((node, isAppearing)=>{
        (0, $0136b2943aee1f51$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1d8bd1b0bbed024b$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $4b60c77e32e76eef$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $5E6i4.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $e50dbcc016964135$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$e50dbcc016964135$var$Fade.displayName = 'Fade';
var $e50dbcc016964135$export$2e2bcd8739ae039 = $e50dbcc016964135$var$Fade;




"use client";
function $9e1d814f3aa9e530$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $62beabb915112802$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $62beabb915112802$export$2e2bcd8739ae039)(r)));
}
const $9e1d814f3aa9e530$var$Overlay = /*#__PURE__*/ $5E6i4.forwardRef(({ children: overlay, transition: transition = (0, $e50dbcc016964135$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $5E6i4.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $5E6i4.useState)(null);
    const [ref, modifiers] = (0, $a78fa77b2f82b14f$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $e50dbcc016964135$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $420ea9a229174095$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ab2423a942577bb9$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $9e1d814f3aa9e530$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $5E6i4.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$9e1d814f3aa9e530$var$Overlay.displayName = 'Overlay';
var $9e1d814f3aa9e530$export$2e2bcd8739ae039 = $9e1d814f3aa9e530$var$Overlay;




"use client";
function $372beae9abf80481$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $372beae9abf80481$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $372beae9abf80481$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $372beae9abf80481$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $5E6i4.useRef)(null);
    const mergedRef = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)(triggerNodeRef, (0, $ac36aa99f6f4d073$export$87943f2672146d57)(children));
    const timeout = (0, $3edbae4955ba3eeb$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $5E6i4.useRef)('');
    const [show, setShow] = (0, $82ed2fe1f7c20eed$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $372beae9abf80481$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $5E6i4.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $62beabb915112802$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $5E6i4.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $5E6i4.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $5E6i4.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $5E6i4.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $5E6i4.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $5E6i4.useCallback)((...args)=>{
        $372beae9abf80481$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $5E6i4.useCallback)((...args)=>{
        $372beae9abf80481$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $5E6i4.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9e1d814f3aa9e530$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $372beae9abf80481$export$2e2bcd8739ae039 = $372beae9abf80481$var$OverlayTrigger;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $70ffb104c13cb135$var$Spinner = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$70ffb104c13cb135$var$Spinner.displayName = 'Spinner';
var $70ffb104c13cb135$export$2e2bcd8739ae039 = $70ffb104c13cb135$var$Spinner;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $e94adaa42c5c11d9$var$Table = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$e94adaa42c5c11d9$var$Table.displayName = 'Table';
var $e94adaa42c5c11d9$export$2e2bcd8739ae039 = $e94adaa42c5c11d9$var$Table;


var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");



const $98c26a93e23146b5$var$fadeStyles = {
    [(0, $c0cf3feaee946af3$export$df38205c966be359)]: 'showing',
    [(0, $c0cf3feaee946af3$export$4aacc83d4d59139f)]: 'showing show'
};
const $98c26a93e23146b5$var$ToastFade = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e50dbcc016964135$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $98c26a93e23146b5$var$fadeStyles
    }));
$98c26a93e23146b5$var$ToastFade.displayName = 'ToastFade';
var $98c26a93e23146b5$export$2e2bcd8739ae039 = $98c26a93e23146b5$var$ToastFade;




var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");


const $473e73a9cee47871$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'white'
    ])
};
const $473e73a9cee47871$var$CloseButton = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$473e73a9cee47871$var$CloseButton.displayName = 'CloseButton';
$473e73a9cee47871$var$CloseButton.propTypes = $473e73a9cee47871$var$propTypes;
var $473e73a9cee47871$export$2e2bcd8739ae039 = $473e73a9cee47871$var$CloseButton;



var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $e0de7564255070b9$var$ToastContext = /*#__PURE__*/ $5E6i4.createContext({
    onClose () {}
});
var $e0de7564255070b9$export$2e2bcd8739ae039 = $e0de7564255070b9$var$ToastContext;



"use client";
const $8a95f689ad90e5d4$var$ToastHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    const context = (0, $5E6i4.useContext)((0, $e0de7564255070b9$export$2e2bcd8739ae039));
    const handleClick = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $473e73a9cee47871$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$8a95f689ad90e5d4$var$ToastHeader.displayName = 'ToastHeader';
var $8a95f689ad90e5d4$export$2e2bcd8739ae039 = $8a95f689ad90e5d4$var$ToastHeader;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $51eac9d617749515$var$ToastBody = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$51eac9d617749515$var$ToastBody.displayName = 'ToastBody';
var $51eac9d617749515$export$2e2bcd8739ae039 = $51eac9d617749515$var$ToastBody;





"use client";
const $60cc0262860e0a32$var$Toast = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $98c26a93e23146b5$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $5E6i4.useRef)(delay);
    const onCloseRef = (0, $5E6i4.useRef)(onClose);
    (0, $5E6i4.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $3edbae4955ba3eeb$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $5E6i4.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $5E6i4.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $5E6i4.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e0de7564255070b9$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$60cc0262860e0a32$var$Toast.displayName = 'Toast';
var $60cc0262860e0a32$export$2e2bcd8739ae039 = Object.assign($60cc0262860e0a32$var$Toast, {
    Body: (0, $51eac9d617749515$export$2e2bcd8739ae039),
    Header: (0, $8a95f689ad90e5d4$export$2e2bcd8739ae039)
});



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $0e2bf089bc399e9d$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const $0e2bf089bc399e9d$var$ToastContainer = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, position && $0e2bf089bc399e9d$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$0e2bf089bc399e9d$var$ToastContainer.displayName = 'ToastContainer';
var $0e2bf089bc399e9d$export$2e2bcd8739ae039 = $0e2bf089bc399e9d$var$ToastContainer;


var $799264a770627072$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $799264a770627072$exports = factory();
})($799264a770627072$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


var $246b1ea23ab1fccc$var$Ie = (e, t)=>()=>(t || (e((t = {
            exports: {}
        }).exports, t), e = null), t.exports);
function $246b1ea23ab1fccc$export$e3607ec2d7a891c4(e) {
    return (t)=>t && new IntersectionObserver(([{ isIntersecting: t, target: n }], r)=>{
            if (!t) return;
            let i = [
                `animate__animated`,
                `animate__${e}`
            ];
            n.classList.add(...i), n.addEventListener(`animationend`, ()=>n.classList.remove(...i), {
                once: !0
            }), r.disconnect();
        }).observe(t);
}
const $246b1ea23ab1fccc$export$e2255cf6045e8d47 = (n)=>{
    let { className: i, style: o, size: s = 3 } = n, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `style`,
        `size`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`img`, (0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`object-fit-cover rounded-circle`, i),
        style: (0, $f0029d1e20ae5566$export$71511d61b312f219)({
            width: `${s}rem`,
            height: `${s}rem`
        }, o)
    }, c));
};
$246b1ea23ab1fccc$export$e2255cf6045e8d47.displayName = `Avatar`;
var $246b1ea23ab1fccc$export$707fce199b8e37aa = class extends (0, $5E6i4.PureComponent) {
    componentDidMount() {
        window.addEventListener(`click`, this.switchClick, !0);
    }
    componentWillUnmount() {
        window.removeEventListener(`click`, this.switchClick, !0);
    }
    render() {
        let n = this.props, { children: i, onInnerClick: a, onOuterClick: o } = n, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `children`,
            `onInnerClick`,
            `onOuterClick`
        ]);
        return (0, $90cae257cc958273$exports.jsx)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
            ref: this.root
        }, c), {
            children: i
        }));
    }
    constructor(...e){
        super(...e), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `root`, (0, $5E6i4.createRef)()), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `switchClick`, (e)=>{
            var t;
            let { onInnerClick: n, onOuterClick: r } = this.props;
            (t = this.root.current) != null && t.contains(e.target) ? n == null || n(e) : r == null || r(e);
        });
    }
};
/*!
* is-plain-object <https://github.com/jonschlinkert/is-plain-object>
*
* Copyright (c) 2014-2017, Jon Schlinkert.
* Released under the MIT License.
*/ function $246b1ea23ab1fccc$var$Be(e) {
    return Object.prototype.toString.call(e) === `[object Object]`;
}
function $246b1ea23ab1fccc$var$Ve(e) {
    var t, n;
    return $246b1ea23ab1fccc$var$Be(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, $246b1ea23ab1fccc$var$Be(n) !== !1 && n.hasOwnProperty(`isPrototypeOf`) !== !1));
}
var $246b1ea23ab1fccc$var$He = $246b1ea23ab1fccc$var$Ie((e)=>{
    var t = e && e.__assign || function() {
        return t = Object.assign || function(e) {
            for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n], t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
        }, t.apply(this, arguments);
    }, n = e && e.__spreadArray || function(e, t, n) {
        if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
        return e.concat(a || Array.prototype.slice.call(t));
    };
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prettyPrint = void 0;
    var r = [];
    function i(e) {
        var t = typeof e;
        return e !== null && (t === `object` || t === `function`);
    }
    function a(e) {
        return Object.prototype.toString.call(e) === `[object RegExp]`;
    }
    function o(e) {
        return Object.getOwnPropertySymbols(e).filter(function(t) {
            return Object.prototype.propertyIsEnumerable.call(e, t);
        });
    }
    function s(e, c, l) {
        l === void 0 && (l = ``);
        var u = t(t({}, {
            indent: `	`,
            singleQuotes: !0
        }), c), d = u.inlineCharacterLimit === void 0 ? {
            newLine: `
`,
            newLineOrSpace: `
`,
            pad: l,
            indent: l + u.indent
        } : {
            newLine: `@@__PRETTY_PRINT_NEW_LINE__@@`,
            newLineOrSpace: `@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@`,
            pad: `@@__PRETTY_PRINT_PAD__@@`,
            indent: `@@__PRETTY_PRINT_INDENT__@@`
        }, f = function(e) {
            if (u.inlineCharacterLimit === void 0) return e;
            var t = e.replace(new RegExp(d.newLine, `g`), ``).replace(new RegExp(d.newLineOrSpace, `g`), ` `).replace(RegExp(d.pad + `|` + d.indent, `g`), ``);
            return t.length <= u.inlineCharacterLimit ? t : e.replace(RegExp(d.newLine + `|` + d.newLineOrSpace, `g`), `
`).replace(new RegExp(d.pad, `g`), l).replace(new RegExp(d.indent, `g`), l + u.indent);
        };
        if (r.indexOf(e) !== -1) return `"[Circular]"`;
        if (e == null || typeof e == `number` || typeof e == `boolean` || typeof e == `function` || typeof e == `symbol` || a(e)) return String(e);
        if (e instanceof Date) return `new Date('${e.toISOString()}')`;
        if (Array.isArray(e)) {
            if (e.length === 0) return `[]`;
            r.push(e);
            var p = `[` + d.newLine + e.map(function(t, n) {
                var r = e.length - 1 === n ? d.newLine : `,` + d.newLineOrSpace, i = s(t, u, l + u.indent);
                return u.transform && (i = u.transform(e, n, i)), d.indent + i + r;
            }).join(``) + d.pad + `]`;
            return r.pop(), f(p);
        }
        if (i(e)) {
            var m = n(n([], Object.keys(e), !0), o(e), !0);
            if (u.filter && (m = m.filter(function(t) {
                return u.filter && u.filter(e, t);
            })), m.length === 0) return `{}`;
            r.push(e);
            var p = `{` + d.newLine + m.map(function(t, n) {
                var r = m.length - 1 === n ? d.newLine : `,` + d.newLineOrSpace, i = typeof t == `symbol`, a = !i && /^[a-z$_][a-z$_0-9]*$/i.test(t.toString()), o = i || a ? t : s(t, u), c = s(e[t], u, l + u.indent);
                return u.transform && (c = u.transform(e, t, c)), d.indent + String(o) + `: ` + c + r;
            }).join(``) + d.pad + `}`;
            return r.pop(), f(p);
        }
        return e = String(e).replace(/[\r\n]/g, function(e) {
            return e === `
` ? `\\n` : `\\r`;
        }), u.singleQuotes ? (e = e.replace(/\\?'/g, `\\'`), `'${e}'`) : (e = e.replace(/"/g, `\\"`), `"${e}"`);
    }
    e.prettyPrint = s;
}), $246b1ea23ab1fccc$var$Ue = $246b1ea23ab1fccc$var$Ie((e)=>{
    /** @license React v16.13.1
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/ var t = typeof Symbol == `function` && Symbol.for, n = t ? Symbol.for(`react.element`) : 60103, r = t ? Symbol.for(`react.portal`) : 60106, i = t ? Symbol.for(`react.fragment`) : 60107, a = t ? Symbol.for(`react.strict_mode`) : 60108, o = t ? Symbol.for(`react.profiler`) : 60114, s = t ? Symbol.for(`react.provider`) : 60109, c = t ? Symbol.for(`react.context`) : 60110, l = t ? Symbol.for(`react.async_mode`) : 60111, u = t ? Symbol.for(`react.concurrent_mode`) : 60111, d = t ? Symbol.for(`react.forward_ref`) : 60112, f = t ? Symbol.for(`react.suspense`) : 60113, p = t ? Symbol.for(`react.memo`) : 60115, m = t ? Symbol.for(`react.lazy`) : 60116;
    function h(e) {
        if (typeof e == `object` && e) {
            var t = e.$$typeof;
            switch(t){
                case n:
                    switch(e = e.type, e){
                        case l:
                        case u:
                        case i:
                        case o:
                        case a:
                        case f:
                            return e;
                        default:
                            switch(e = e && e.$$typeof, e){
                                case c:
                                case d:
                                case m:
                                case p:
                                case s:
                                    return e;
                                default:
                                    return t;
                            }
                    }
                case r:
                    return t;
            }
        }
    }
    e.ForwardRef = d, e.Memo = p, e.isContextConsumer = function(e) {
        return h(e) === c;
    }, e.isContextProvider = function(e) {
        return h(e) === s;
    }, e.isForwardRef = function(e) {
        return h(e) === d;
    }, e.isLazy = function(e) {
        return h(e) === m;
    }, e.isMemo = function(e) {
        return h(e) === p;
    }, e.isProfiler = function(e) {
        return h(e) === o;
    }, e.isStrictMode = function(e) {
        return h(e) === a;
    }, e.isSuspense = function(e) {
        return h(e) === f;
    };
}), $246b1ea23ab1fccc$var$We = $246b1ea23ab1fccc$var$Ie((e, t)=>{
    t.exports = $246b1ea23ab1fccc$var$Ue();
}), $246b1ea23ab1fccc$var$Ge = $246b1ea23ab1fccc$var$He(), $246b1ea23ab1fccc$var$M = $246b1ea23ab1fccc$var$We(), $246b1ea23ab1fccc$var$N = function(e, t) {
    return e === 0 ? `` : Array(e * t).fill(` `).join(``);
};
function $246b1ea23ab1fccc$var$Ke(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for(var n = 0, r = Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function $246b1ea23ab1fccc$var$qe(e) {
    if (Array.isArray(e)) return $246b1ea23ab1fccc$var$Ke(e);
}
function $246b1ea23ab1fccc$var$Je(e, t, n) {
    return (t = $246b1ea23ab1fccc$var$tt(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $246b1ea23ab1fccc$var$Ye(e) {
    if (typeof Symbol < `u` && e[Symbol.iterator] != null || e[`@@iterator`] != null) return Array.from(e);
}
function $246b1ea23ab1fccc$var$Xe() {
    throw TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $246b1ea23ab1fccc$var$Ze(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $246b1ea23ab1fccc$var$Qe(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] == null ? {} : arguments[t];
        t % 2 ? $246b1ea23ab1fccc$var$Ze(Object(n), !0).forEach(function(t) {
            $246b1ea23ab1fccc$var$Je(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $246b1ea23ab1fccc$var$Ze(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $246b1ea23ab1fccc$var$$e(e) {
    return $246b1ea23ab1fccc$var$qe(e) || $246b1ea23ab1fccc$var$Ye(e) || $246b1ea23ab1fccc$var$nt(e) || $246b1ea23ab1fccc$var$Xe();
}
function $246b1ea23ab1fccc$var$et(e, t) {
    if (typeof e != `object` || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
        var r = n.call(e, t || `default`);
        if (typeof r != `object`) return r;
        throw TypeError(`@@toPrimitive must return a primitive value.`);
    }
    return (t === `string` ? String : Number)(e);
}
function $246b1ea23ab1fccc$var$tt(e) {
    var t = $246b1ea23ab1fccc$var$et(e, `string`);
    return typeof t == `symbol` ? t : t + ``;
}
function $246b1ea23ab1fccc$var$P(e) {
    "@babel/helpers - typeof";
    return $246b1ea23ab1fccc$var$P = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(e) {
        return typeof e;
    } : function(e) {
        return e && typeof Symbol == `function` && e.constructor === Symbol && e !== Symbol.prototype ? `symbol` : typeof e;
    }, $246b1ea23ab1fccc$var$P(e);
}
function $246b1ea23ab1fccc$var$nt(e, t) {
    if (e) {
        if (typeof e == `string`) return $246b1ea23ab1fccc$var$Ke(e, t);
        var n = ({}).toString.call(e).slice(8, -1);
        return n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set` ? Array.from(e) : n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $246b1ea23ab1fccc$var$Ke(e, t) : void 0;
    }
}
function $246b1ea23ab1fccc$var$rt(e, t) {
    if (e === null || $246b1ea23ab1fccc$var$P(e) !== `object` || e instanceof Date || e instanceof RegExp) return e;
    if ($5E6i4.isValidElement(e)) {
        var n = $246b1ea23ab1fccc$var$Qe({}, e);
        return delete n._owner, n;
    }
    return t.add(e), Array.isArray(e) ? e.map(function(e) {
        return $246b1ea23ab1fccc$var$rt(e, t);
    }) : Object.keys(e).sort().reduce(function(n, r) {
        return n[r] = r === `current` || t.has(e[r]) ? `[Circular]` : $246b1ea23ab1fccc$var$rt(e[r], t), n;
    }, {});
}
function $246b1ea23ab1fccc$var$it(e) {
    return $246b1ea23ab1fccc$var$rt(e, new WeakSet);
}
var $246b1ea23ab1fccc$var$at = function(e) {
    return {
        type: `string`,
        value: e
    };
}, $246b1ea23ab1fccc$var$ot = function(e) {
    return {
        type: `number`,
        value: e
    };
}, $246b1ea23ab1fccc$var$st = function(e, t, n, r) {
    return {
        type: `ReactElement`,
        displayName: e,
        props: t,
        defaultProps: n,
        childrens: r
    };
}, $246b1ea23ab1fccc$var$ct = function(e, t) {
    return {
        type: `ReactFragment`,
        key: e,
        childrens: t
    };
}, $246b1ea23ab1fccc$var$lt = !!(0, $5E6i4.Fragment), $246b1ea23ab1fccc$var$ut = function(e) {
    return !e.name || e.name === `_default` ? `No Display Name` : e.name;
}, $246b1ea23ab1fccc$var$dt = function(e) {
    switch(!0){
        case !!e.displayName:
            return e.displayName;
        case e.$$typeof === $246b1ea23ab1fccc$var$M.Memo:
            return $246b1ea23ab1fccc$var$dt(e.type);
        case e.$$typeof === $246b1ea23ab1fccc$var$M.ForwardRef:
            return $246b1ea23ab1fccc$var$dt(e.render);
        default:
            return $246b1ea23ab1fccc$var$ut(e);
    }
}, $246b1ea23ab1fccc$var$ft = function(e) {
    switch(!0){
        case typeof e.type == `string`:
            return e.type;
        case typeof e.type == `function`:
            return e.type.displayName ? e.type.displayName : $246b1ea23ab1fccc$var$ut(e.type);
        case (0, $246b1ea23ab1fccc$var$M.isForwardRef)(e):
        case (0, $246b1ea23ab1fccc$var$M.isMemo)(e):
            return $246b1ea23ab1fccc$var$dt(e.type);
        case (0, $246b1ea23ab1fccc$var$M.isContextConsumer)(e):
            return `${e.type._context.displayName || `Context`}.Consumer`;
        case (0, $246b1ea23ab1fccc$var$M.isContextProvider)(e):
            return `${e.type.displayName || `Context`}.Provider`;
        case (0, $246b1ea23ab1fccc$var$M.isLazy)(e):
            return `Lazy`;
        case (0, $246b1ea23ab1fccc$var$M.isProfiler)(e):
            return `Profiler`;
        case (0, $246b1ea23ab1fccc$var$M.isStrictMode)(e):
            return `StrictMode`;
        case (0, $246b1ea23ab1fccc$var$M.isSuspense)(e):
            return `Suspense`;
        default:
            return `UnknownElementType`;
    }
}, $246b1ea23ab1fccc$var$pt = function(e, t) {
    return t !== `children`;
}, $246b1ea23ab1fccc$var$mt = function(e) {
    return e !== !0 && e !== !1 && e !== null && e !== ``;
}, $246b1ea23ab1fccc$var$ht = function(e, t) {
    var n = {};
    return Object.keys(e).filter(function(n) {
        return t(e[n], n);
    }).forEach(function(t) {
        return n[t] = e[t];
    }), n;
}, $246b1ea23ab1fccc$var$F = function(e, t) {
    var n = t.displayName, r = n === void 0 ? $246b1ea23ab1fccc$var$ft : n;
    if (typeof e == `string`) return $246b1ea23ab1fccc$var$at(e);
    if (typeof e == `number`) return $246b1ea23ab1fccc$var$ot(e);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(e)) throw Error(`react-element-to-jsx-string: Expected a React.Element, got \`${$246b1ea23ab1fccc$var$P(e)}\``);
    var i = r(e), a = $246b1ea23ab1fccc$var$ht(e.props, $246b1ea23ab1fccc$var$pt), o = e.key;
    typeof o == `string` && o.search(/^\./) && (a.key = o);
    var s = $246b1ea23ab1fccc$var$ht(e.type.defaultProps || {}, $246b1ea23ab1fccc$var$pt), c = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Children.toArray(e.props.children).filter($246b1ea23ab1fccc$var$mt).map(function(e) {
        return $246b1ea23ab1fccc$var$F(e, t);
    });
    return $246b1ea23ab1fccc$var$lt && e.type === (0, $5E6i4.Fragment) ? $246b1ea23ab1fccc$var$ct(o, c) : $246b1ea23ab1fccc$var$st(i, a, s, c);
};
function $246b1ea23ab1fccc$var$gt() {}
var $246b1ea23ab1fccc$var$_t = function(e) {
    return e.toString().split(`
`).map(function(e) {
        return e.trim();
    }).join(``);
}, $246b1ea23ab1fccc$var$vt = function(e, t) {
    var n = t.functionValue, r = n === void 0 ? $246b1ea23ab1fccc$var$_t : n;
    return !t.showFunctions && r === $246b1ea23ab1fccc$var$_t ? r($246b1ea23ab1fccc$var$gt) : r(e);
}, $246b1ea23ab1fccc$var$yt = function(e, t, n, r) {
    var i = $246b1ea23ab1fccc$var$it(e), a = (0, $246b1ea23ab1fccc$var$Ge.prettyPrint)(i, {
        transform: function(e, t, i) {
            var a = e[t];
            return a && (0, $5E6i4.isValidElement)(a) ? $246b1ea23ab1fccc$var$I($246b1ea23ab1fccc$var$F(a, r), !0, n, r) : typeof a == `function` ? $246b1ea23ab1fccc$var$vt(a, r) : i;
        }
    });
    return t ? a.replace(/\s+/g, ` `).replace(/{ /g, `{`).replace(/ }/g, `}`).replace(/\[ /g, `[`).replace(/ ]/g, `]`) : a.replace(/\t/g, $246b1ea23ab1fccc$var$N(1, r.tabStop)).replace(/\n([^$])/g, `
${$246b1ea23ab1fccc$var$N(n + 1, r.tabStop)}\$1`);
}, $246b1ea23ab1fccc$var$bt = function(e) {
    return e.replace(/"/g, `&quot;`);
}, $246b1ea23ab1fccc$var$xt = function(e, t, n, r) {
    if (typeof e == `number`) return `{${String(e)}}`;
    if (typeof e == `string`) return `"${$246b1ea23ab1fccc$var$bt(e)}"`;
    if ($246b1ea23ab1fccc$var$P(e) === `symbol`) {
        var i = e.valueOf().toString().replace(/Symbol\((.*)\)/, `$1`);
        return i ? `{Symbol('${i}')}` : `{Symbol()}`;
    }
    return typeof e == `function` ? `{${$246b1ea23ab1fccc$var$vt(e, r)}}` : (0, $5E6i4.isValidElement)(e) ? `{${$246b1ea23ab1fccc$var$I($246b1ea23ab1fccc$var$F(e, r), !0, n, r)}}` : e instanceof Date ? isNaN(e.valueOf()) ? `{new Date(NaN)}` : `{new Date("${e.toISOString()}")}` : $246b1ea23ab1fccc$var$Ve(e) || Array.isArray(e) ? `{${$246b1ea23ab1fccc$var$yt(e, t, n, r)}}` : `{${String(e)}}`;
}, $246b1ea23ab1fccc$var$St = function(e, t, n, r, i, a, o, s) {
    if (!t && !r) throw Error(`The prop "${e}" has no value and no default: could not be formatted`);
    var c = t ? n : i, l = s.useBooleanShorthandSyntax, u = s.tabStop, d = $246b1ea23ab1fccc$var$xt(c, a, o, s), f = ` `, p = `
${$246b1ea23ab1fccc$var$N(o + 1, u)}`, m = d.includes(`
`);
    return l && d === `{false}` && !r ? (f = ``, p = ``) : l && d === `{true}` ? (f += `${e}`, p += `${e}`) : (f += `${e}=${d}`, p += `${e}=${d}`), {
        attributeFormattedInline: f,
        attributeFormattedMultiline: p,
        isMultilineAttribute: m
    };
}, $246b1ea23ab1fccc$var$Ct = function(e, t) {
    var n = e.slice(0, e.length > 0 ? e.length - 1 : 0), r = e[e.length - 1];
    return r && (t.type === `string` || t.type === `number`) && (r.type === `string` || r.type === `number`) ? n.push($246b1ea23ab1fccc$var$at(String(r.value) + String(t.value))) : (r && n.push(r), n.push(t)), n;
}, $246b1ea23ab1fccc$var$wt = function(e) {
    return [
        `key`,
        `ref`
    ].includes(e);
}, $246b1ea23ab1fccc$var$Tt = function(e) {
    return function(t) {
        var n = t.includes(`key`), r = t.includes(`ref`), i = t.filter(function(e) {
            return !$246b1ea23ab1fccc$var$wt(e);
        }), a = $246b1ea23ab1fccc$var$$e(e ? i.sort() : i);
        return r && a.unshift(`ref`), n && a.unshift(`key`), a;
    };
};
function $246b1ea23ab1fccc$var$Et(e, t) {
    return Array.isArray(t) ? function(e) {
        return t.indexOf(e) === -1;
    } : function(n) {
        return t(e[n], n);
    };
}
var $246b1ea23ab1fccc$var$Dt = function(e, t, n, r, i) {
    var a = i.tabStop;
    return e.type === `string` ? t.split(`
`).map(function(e, t) {
        return t === 0 ? e : `${$246b1ea23ab1fccc$var$N(r, a)}${e}`;
    }).join(`
`) : t;
}, $246b1ea23ab1fccc$var$Ot = function(e, t, n) {
    return function(r) {
        return $246b1ea23ab1fccc$var$Dt(r, $246b1ea23ab1fccc$var$I(r, e, t, n), e, t, n);
    };
}, $246b1ea23ab1fccc$var$kt = function(e, t) {
    return function(n) {
        var r = Object.keys(e).includes(n);
        return !r || r && e[n] !== t[n];
    };
}, $246b1ea23ab1fccc$var$At = function(e, t, n, r, i) {
    return i ? $246b1ea23ab1fccc$var$N(n, r).length + t.length > i : e.length > 1;
}, $246b1ea23ab1fccc$var$jt = function(e, t, n, r, i, a, o) {
    return ($246b1ea23ab1fccc$var$At(e, t, i, a, o) || n) && !r;
}, $246b1ea23ab1fccc$var$Mt = function(e, t, n, r) {
    var i = e.type, a = e.displayName, o = a === void 0 ? `` : a, s = e.childrens, c = e.props, l = c === void 0 ? {} : c, u = e.defaultProps, d = u === void 0 ? {} : u;
    if (i !== `ReactElement`) throw Error(`The "formatReactElementNode" function could only format node of type "ReactElement". Given:  ${i}`);
    var f = r.filterProps, p = r.maxInlineAttributesLineLength, m = r.showDefaultProps, h = r.sortProps, g = r.tabStop, _ = `<${o}`, v = _, y = _, ee = !1, b = [], x = $246b1ea23ab1fccc$var$Et(l, f);
    Object.keys(l).filter(x).filter($246b1ea23ab1fccc$var$kt(d, l)).forEach(function(e) {
        return b.push(e);
    }), Object.keys(d).filter(x).filter(function() {
        return m;
    }).filter(function(e) {
        return !b.includes(e);
    }).forEach(function(e) {
        return b.push(e);
    });
    var S = $246b1ea23ab1fccc$var$Tt(h)(b);
    if (S.forEach(function(e) {
        var i = $246b1ea23ab1fccc$var$St(e, Object.keys(l).includes(e), l[e], Object.keys(d).includes(e), d[e], t, n, r), a = i.attributeFormattedInline, o = i.attributeFormattedMultiline;
        i.isMultilineAttribute && (ee = !0), v += a, y += o;
    }), y += `
${$246b1ea23ab1fccc$var$N(n, g)}`, _ = $246b1ea23ab1fccc$var$jt(S, v, ee, t, n, g, p) ? y : v, s && s.length > 0) {
        var C = n + 1;
        _ += `>`, t || (_ += `
`, _ += $246b1ea23ab1fccc$var$N(C, g)), _ += s.reduce($246b1ea23ab1fccc$var$Ct, []).map($246b1ea23ab1fccc$var$Ot(t, C, r)).join(t ? `` : `
${$246b1ea23ab1fccc$var$N(C, g)}`), t || (_ += `
`, _ += $246b1ea23ab1fccc$var$N(C - 1, g)), _ += `</${o}>`;
    } else $246b1ea23ab1fccc$var$At(S, v, n, g, p) || (_ += ` `), _ += `/>`;
    return _;
}, $246b1ea23ab1fccc$var$Nt = ``, $246b1ea23ab1fccc$var$Pt = `React.Fragment`, $246b1ea23ab1fccc$var$Ft = function(e, t, n) {
    var r = {};
    return t && (r = {
        key: t
    }), {
        type: `ReactElement`,
        displayName: e,
        props: r,
        defaultProps: {},
        childrens: n
    };
}, $246b1ea23ab1fccc$var$It = function(e) {
    return !!e.key;
}, $246b1ea23ab1fccc$var$Lt = function(e) {
    return e.childrens.length === 0;
}, $246b1ea23ab1fccc$var$Rt = function(e, t, n, r) {
    var i = e.type, a = e.key, o = e.childrens;
    if (i !== `ReactFragment`) throw Error(`The "formatReactFragmentNode" function could only format node of type "ReactFragment". Given: ${i}`);
    return $246b1ea23ab1fccc$var$Mt($246b1ea23ab1fccc$var$Ft(r.useFragmentShortSyntax ? $246b1ea23ab1fccc$var$Lt(e) || $246b1ea23ab1fccc$var$It(e) ? $246b1ea23ab1fccc$var$Pt : $246b1ea23ab1fccc$var$Nt : $246b1ea23ab1fccc$var$Pt, a, o), t, n, r);
}, $246b1ea23ab1fccc$var$zt = [
    `<`,
    `>`,
    `{`,
    `}`
], $246b1ea23ab1fccc$var$Bt = function(e) {
    return $246b1ea23ab1fccc$var$zt.some(function(t) {
        return e.includes(t);
    });
}, $246b1ea23ab1fccc$var$Vt = function(e) {
    return $246b1ea23ab1fccc$var$Bt(e) ? `{\`${e}\`}` : e;
}, $246b1ea23ab1fccc$var$Ht = function(e) {
    var t = e;
    return t.endsWith(` `) && (t = t.replace(/^(.*?)(\s+)$/, `$1{'$2'}`)), t.startsWith(` `) && (t = t.replace(/^(\s+)(.*)$/, `{'$1'}$2`)), t;
}, $246b1ea23ab1fccc$var$I = function(e, t, n, r) {
    if (e.type === `number`) return String(e.value);
    if (e.type === `string`) return e.value ? `${$246b1ea23ab1fccc$var$Ht($246b1ea23ab1fccc$var$Vt(String(e.value)))}` : ``;
    if (e.type === `ReactElement`) return $246b1ea23ab1fccc$var$Mt(e, t, n, r);
    if (e.type === `ReactFragment`) return $246b1ea23ab1fccc$var$Rt(e, t, n, r);
    throw TypeError(`Unknow format type "${e.type}"`);
}, $246b1ea23ab1fccc$var$Ut = function(e, t) {
    return $246b1ea23ab1fccc$var$I(e, !1, 0, t);
}, $246b1ea23ab1fccc$var$Wt = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.filterProps, r = n === void 0 ? [] : n, i = t.showDefaultProps, a = i === void 0 || i, o = t.showFunctions, s = o !== void 0 && o, c = t.functionValue, l = t.tabStop, u = l === void 0 ? 2 : l, d = t.useBooleanShorthandSyntax, f = d === void 0 || d, p = t.useFragmentShortSyntax, m = p === void 0 || p, h = t.sortProps, g = h === void 0 || h, _ = t.maxInlineAttributesLineLength, v = t.displayName;
    if (!e) throw Error(`react-element-to-jsx-string: Expected a ReactElement`);
    var y = {
        filterProps: r,
        showDefaultProps: a,
        showFunctions: s,
        functionValue: c,
        tabStop: u,
        useBooleanShorthandSyntax: f,
        useFragmentShortSyntax: m,
        sortProps: g,
        maxInlineAttributesLineLength: _,
        displayName: v
    };
    return $246b1ea23ab1fccc$var$Ut($246b1ea23ab1fccc$var$F(e, y), y);
};
const $246b1ea23ab1fccc$var$Gt = (0, $affc016a43a42f97$export$f38e8c16be9dd57d)({
    themes: [
        (0, $11093f5bebcb9f10$export$2e2bcd8739ae039)
    ],
    langs: [
        (0, $f98228064dbed514$export$2e2bcd8739ae039),
        (0, $7ed64a6063dfcb66$export$2e2bcd8739ae039),
        (0, $f73e95e28dd02331$export$2e2bcd8739ae039),
        (0, $f83a782ddbd2339a$export$2e2bcd8739ae039)
    ],
    engine: (0, $2cfe98e607de8b65$export$d1f38b498ee0de14)()
}), $246b1ea23ab1fccc$export$6c415d1fdae3dfdb = (i)=>{
    let { className: a = ``, language: o, children: c } = i, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(i, [
        `className`,
        `language`,
        `children`
    ]), u = typeof c == `string` ? c : $246b1ea23ab1fccc$var$Wt((0, $5E6i4.isValidElement)(c) ? c : (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: c
    })), d = $246b1ea23ab1fccc$var$Gt.codeToHtml(u, {
        lang: o,
        theme: `github-light`,
        structure: `inline`
    });
    return (0, $90cae257cc958273$exports.jsx)(`pre`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `m-0 language-${o} ${a}`
    }, l), {
        children: (0, $90cae257cc958273$exports.jsx)(`code`, {
            dangerouslySetInnerHTML: {
                __html: d
            },
            className: `language-${o}`
        })
    }));
}, $246b1ea23ab1fccc$export$50b010be9260e56b = [
    `primary`,
    `secondary`,
    `success`,
    `danger`,
    `warning`,
    `info`,
    `dark`,
    `light`
];
function $246b1ea23ab1fccc$export$b480d00b75c9ac2d(e, t = []) {
    let n = t[0] ? $246b1ea23ab1fccc$export$50b010be9260e56b.filter((e)=>!t.find((t)=>t === e)) : $246b1ea23ab1fccc$export$50b010be9260e56b;
    return n[[
        ...e
    ].reduce((e, t)=>e + t.charCodeAt(0), 0) % n.length];
}
let $246b1ea23ab1fccc$var$Yt;
var $246b1ea23ab1fccc$var$L, $246b1ea23ab1fccc$var$Xt, $246b1ea23ab1fccc$var$Zt, $246b1ea23ab1fccc$var$Qt, $246b1ea23ab1fccc$var$$t, $246b1ea23ab1fccc$var$en = (0, $85705ec7803c1445$export$7203b476385689ae)((e)=>e.observedProps.endTime), $246b1ea23ab1fccc$var$tn, $246b1ea23ab1fccc$var$nn;
let $246b1ea23ab1fccc$export$53819c0e58f98d49;
new ($246b1ea23ab1fccc$var$Yt = ($246b1ea23ab1fccc$var$L = new WeakMap, $246b1ea23ab1fccc$var$Xt = class extends ($246b1ea23ab1fccc$var$$t = (0, $85705ec7803c1445$export$bf180ef329d1efd8)) {
    get rest() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$L);
    }
    set rest(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$L, e);
    }
    get endTimestamp() {
        return +new Date(this.props.endTime || Date.now());
    }
    get timeSections() {
        let { units: e } = this.observedProps, { rest: t } = this;
        return e.reduce((n, { label: r }, i)=>{
            let a = e.slice(i).map(({ scale: e })=>e).reduce((e, t)=>e * t, 1), o = ~~(t / a);
            return t -= o * a, n.push({
                value: o,
                label: r
            }), n;
        }, []);
    }
    stop() {
        this.timer && (window.clearInterval(this.timer), this.timer = 0);
    }
    componentDidMount() {
        super.componentDidMount(), this.initTimer();
    }
    initTimer() {
        this.stop(), this.tick(), this.timer = window.setInterval(this.tick, (0, $90MBA.Second));
    }
    componentWillUnmount() {
        super.componentWillUnmount(), this.stop();
    }
    render() {
        let n = this.props, { className: a = ``, itemClassName: o = `border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center`, units: c, endTime: l, onEnd: u } = n, d = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `className`,
            `itemClassName`,
            `units`,
            `endTime`,
            `onEnd`
        ]), { timeSections: f } = this;
        return (0, $90cae257cc958273$exports.jsx)(`ol`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
            className: `list-unstyled m-0 ${a}`
        }, d), {
            children: f.map(({ value: e, label: t })=>(0, $90cae257cc958273$exports.jsxs)(`li`, {
                    className: o,
                    children: [
                        (0, $90cae257cc958273$exports.jsx)(`strong`, {
                            children: (e + ``).padStart(2, `0`)
                        }),
                        (0, $90cae257cc958273$exports.jsx)(`span`, {
                            children: t
                        })
                    ]
                }, t))
        }));
    }
    constructor(...e){
        super(...e), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$L, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$nn(this), $246b1ea23ab1fccc$var$tn(this, 0))
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `timer`, 0), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `tick`, ()=>{
            let { onEnd: e, endTime: t } = this.props, n = this.endTimestamp - Date.now();
            n > 0 ? this.rest = n : (this.rest = 0, this.stop(), e == null || e(t));
        });
    }
}, { e: [$246b1ea23ab1fccc$var$tn, $246b1ea23ab1fccc$var$nn], c: [$246b1ea23ab1fccc$export$53819c0e58f98d49, $246b1ea23ab1fccc$var$Qt] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$Xt, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `rest`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `timeSections`
    ],
    [
        $246b1ea23ab1fccc$var$en,
        2,
        `initTimer`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$$t), $246b1ea23ab1fccc$var$Xt), $246b1ea23ab1fccc$var$Zt = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$53819c0e58f98d49), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `Countdown`), $246b1ea23ab1fccc$var$Qt();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$Zt, $246b1ea23ab1fccc$var$Yt, void 0), $246b1ea23ab1fccc$var$Zt);
var $246b1ea23ab1fccc$var$an, $246b1ea23ab1fccc$var$on, $246b1ea23ab1fccc$var$sn, $246b1ea23ab1fccc$export$fba2fb7cd781b7ac = class extends Error {
    constructor(e = `Dialog closed`){
        super(e);
    }
}, $246b1ea23ab1fccc$var$ln = new WeakMap, $246b1ea23ab1fccc$var$un = new WeakMap, $246b1ea23ab1fccc$export$3ddf2d174ce01153 = class {
    get input() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$ln);
    }
    set input(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$ln, e);
    }
    get defer() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$un);
    }
    set defer(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$un, e);
    }
    open(e) {
        return e && (this.input = e), this.defer = new (0, $7db8a787aa9e39e9$export$c7e91f8aec23ae14), this.defer.promise.finally(()=>this.defer = void 0), this.defer.promise;
    }
    constructor(t){
        (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$ln, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$sn(this), $246b1ea23ab1fccc$var$an(this, {}))
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$un, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$on(this)
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `Component`, void 0), this.Component = (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)((n)=>(0, $90cae257cc958273$exports.jsx)(t, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, n, this.input), {
                defer: this.defer
            }))), this.Component.displayName = `DialogComponent`;
    }
};
({ e: [$246b1ea23ab1fccc$var$an, $246b1ea23ab1fccc$var$on, $246b1ea23ab1fccc$var$sn] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$export$3ddf2d174ce01153, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `input`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `defer`
    ]
], []));
let $246b1ea23ab1fccc$var$fn;
var $246b1ea23ab1fccc$var$R, $246b1ea23ab1fccc$var$pn, $246b1ea23ab1fccc$var$mn, $246b1ea23ab1fccc$var$hn, $246b1ea23ab1fccc$var$gn, $246b1ea23ab1fccc$var$_n, $246b1ea23ab1fccc$var$vn;
const $246b1ea23ab1fccc$var$yn = (0, $9e9a01d9395d29c7$export$da8ca15f4115b46e)();
let $246b1ea23ab1fccc$export$7cda8d932e2f33c0;
new ($246b1ea23ab1fccc$var$fn = ($246b1ea23ab1fccc$var$R = new WeakMap, $246b1ea23ab1fccc$var$pn = class extends ($246b1ea23ab1fccc$var$gn = (0, $5E6i4.Component)) {
    get innerValue() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$R);
    }
    set innerValue(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$R, e);
    }
    render() {
        let n = this.props, { name: a, required: o, children: c } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `name`,
            `required`,
            `children`
        ]), { innerValue: u } = this;
        return (0, $90cae257cc958273$exports.jsxs)(`div`, {
            className: `form-control`,
            tabIndex: -1,
            onBlur: this.save,
            children: [
                (0, $90cae257cc958273$exports.jsx)(`input`, {
                    hidden: !0,
                    name: a,
                    required: o,
                    value: JSON.stringify(u)
                }),
                (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$var$yn, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, l), {
                    onInitialize: (e)=>{
                        var t;
                        this.core = e, (t = l.onInitialize) == null || t.call(l, e);
                    }
                }))
            ]
        });
    }
    constructor(...e){
        var t;
        super(...e), t = this, (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `core`, void 0), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$R, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$vn(this), $246b1ea23ab1fccc$var$_n(this, this.props.defaultValue))
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `save`, ()=>(0, $25a6c985cf60a3ea$export$71511d61b312f219)(function*() {
                return t.core && (t.innerValue = yield t.core.save());
            })());
    }
}, { e: [$246b1ea23ab1fccc$var$_n, $246b1ea23ab1fccc$var$vn], c: [$246b1ea23ab1fccc$export$7cda8d932e2f33c0, $246b1ea23ab1fccc$var$hn] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$pn, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `innerValue`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$gn), $246b1ea23ab1fccc$var$pn), $246b1ea23ab1fccc$var$mn = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$7cda8d932e2f33c0), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `Editor`), $246b1ea23ab1fccc$var$hn();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$mn, $246b1ea23ab1fccc$var$fn, void 0), $246b1ea23ab1fccc$var$mn);
const $246b1ea23ab1fccc$export$8f49e4af10703ce3 = (0, (/*@__PURE__*/$parcel$interopDefault($70d150f8dfa3d626$exports)))({
    link: ({ data: { link: e } })=>`<a href="${e}">${e}</a>`
}), $246b1ea23ab1fccc$export$f9c5335a01b13a5a = (n)=>{
    let { data: i } = n, a = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `data`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`article`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, a), {
        dangerouslySetInnerHTML: {
            __html: $246b1ea23ab1fccc$export$8f49e4af10703ce3.parse(i)
        }
    }));
};
$246b1ea23ab1fccc$export$f9c5335a01b13a5a.displayName = `EditorHTML`;
const $246b1ea23ab1fccc$export$4eb895ecfe5a67d5 = (n)=>{
    let { className: i = ``, children: a, maxWidth: o = `100%`, duration: c, height: l } = n, u = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `children`,
        `maxWidth`,
        `duration`,
        `height`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `overflow-hidden mw-100 ${i}`
    }, u), {
        children: (0, $90cae257cc958273$exports.jsx)(`div`, {
            className: `d-inline-block align-top text-nowrap lRDfma_scrollWrap`,
            style: {
                maxWidth: o,
                animationDuration: c,
                height: l,
                lineHeight: l
            },
            children: (0, $90cae257cc958273$exports.jsx)(`div`, {
                className: `d-inline-block lRDfma_scrollItem`,
                style: {
                    animationDuration: c
                },
                children: a
            })
        })
    }));
}, $246b1ea23ab1fccc$export$e22877062eb47c32 = ({ children: e, maxWidth: t, duration: n, height: a })=>a ? (0, $90cae257cc958273$exports.jsx)(`div`, {
        className: `overflow-hidden lRDfma_scrollHeightWrap`,
        style: {
            maxWidth: t,
            "--scroll-height": a
        },
        children: (0, $90cae257cc958273$exports.jsxs)(`div`, {
            className: `d-inline-block overflow-hidden mw-100 lRDfma_scrollContainer`,
            children: [
                (0, $90cae257cc958273$exports.jsx)(`div`, {
                    className: `d-block overflow-hidden text-wrap text-break lRDfma_unScrollItem`,
                    children: e
                }),
                (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$4eb895ecfe5a67d5, {
                    duration: n,
                    children: e
                })
            ]
        })
    }) : (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$4eb895ecfe5a67d5, {
        maxWidth: t,
        duration: n,
        height: a,
        children: e
    });
$246b1ea23ab1fccc$export$4eb895ecfe5a67d5.displayName = `HorizontalMarquee`;
const $246b1ea23ab1fccc$export$f04a61298a47a40f = (n)=>{
    let { className: i, style: o, name: s, size: c } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `style`,
        `name`,
        `size`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`span`, (0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`bi-${s}`, i),
        style: (0, $f0029d1e20ae5566$export$71511d61b312f219)({
            fontSize: c && `${c}rem`
        }, o)
    }, l));
};
$246b1ea23ab1fccc$export$f04a61298a47a40f.displayName = `Icon`;
const $246b1ea23ab1fccc$export$965592ed152e8e7f = ({ scope: e, children: t })=>{
    let a = typeof t == `string` ? t : $246b1ea23ab1fccc$var$Wt((0, $5E6i4.isValidElement)(t) ? t : (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: t
    }));
    return (0, $90cae257cc958273$exports.jsxs)((0, $1232e0688c6b311d$export$7f6f1b77ca3c3ed3), {
        code: a,
        scope: e,
        language: `tsx`,
        children: [
            (0, $90cae257cc958273$exports.jsx)((0, $1232e0688c6b311d$export$ba3ca6901d2e4f5f), {
                className: `mb-3`
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $1232e0688c6b311d$export$f8f60579bb81d0e5), {}),
            (0, $90cae257cc958273$exports.jsx)((0, $1232e0688c6b311d$export$1991b613205b2adc), {
                className: `text-danger small p-2`
            })
        ]
    });
}, $246b1ea23ab1fccc$export$669f6ea7d267feaf = (n)=>{
    let { className: a = ``, children: o = `Loading...` } = n, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `children`
    ]);
    return (0, $90cae257cc958273$exports.jsxs)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ${a}`
    }, c), {
        children: [
            (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {
                animation: `border`,
                variant: `success`
            }),
            (0, $90cae257cc958273$exports.jsx)(`span`, {
                className: `ml-3 text-white`,
                children: o
            })
        ]
    }));
};
$246b1ea23ab1fccc$export$669f6ea7d267feaf.displayName = `Loading`;
const $246b1ea23ab1fccc$export$5169ff31790bf260 = (n)=>{
    let { title: a, detail: o, children: c } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `title`,
        `detail`,
        `children`
    ]);
    return (0, $90cae257cc958273$exports.jsx)((0, $372beae9abf80481$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, l), {
        overlay: o ? (0, $90cae257cc958273$exports.jsxs)((0, $6d7cb74c8723debd$export$2e2bcd8739ae039), {
            children: [
                (0, $90cae257cc958273$exports.jsx)((0, $6d7cb74c8723debd$export$2e2bcd8739ae039).Header, {
                    children: a
                }),
                (0, $90cae257cc958273$exports.jsx)((0, $6d7cb74c8723debd$export$2e2bcd8739ae039).Body, {
                    children: o
                })
            ]
        }) : (0, $90cae257cc958273$exports.jsx)((0, $c07cc3333d480df1$export$2e2bcd8739ae039), {
            children: a
        }),
        children: c
    }));
};
$246b1ea23ab1fccc$export$5169ff31790bf260.displayName = `OverlayBox`;
let $246b1ea23ab1fccc$var$Dn;
var $246b1ea23ab1fccc$var$V, $246b1ea23ab1fccc$var$On, $246b1ea23ab1fccc$var$kn, $246b1ea23ab1fccc$var$An, $246b1ea23ab1fccc$var$jn, $246b1ea23ab1fccc$var$Mn, $246b1ea23ab1fccc$var$Nn;
let $246b1ea23ab1fccc$export$d7a7c85c0f5afc4a;
new ($246b1ea23ab1fccc$var$Dn = ($246b1ea23ab1fccc$var$V = new WeakMap, $246b1ea23ab1fccc$var$On = class extends ($246b1ea23ab1fccc$var$jn = (0, $85705ec7803c1445$export$bf180ef329d1efd8)) {
    get weekFormatter() {
        var e;
        let { locale: t = (e = globalThis.navigator) == null ? void 0 : e.language } = this.observedProps;
        return new Intl.DateTimeFormat(t, {
            weekday: `long`
        });
    }
    get currentDate() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$V);
    }
    set currentDate(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$V, e);
    }
    get dateGrid() {
        let e = new Date(this.currentDate);
        e.setDate(1), e = new Date(+e - e.getDay() * (0, $90MBA.Day));
        let t = Array.from(Array(42), (t, n)=>new Date(+e + n * (0, $90MBA.Day)));
        return (0, $90MBA.splitArray)(t, 7);
    }
    changeMonth(e) {
        var t, n;
        this.currentDate = (0, $90MBA.changeMonth)(this.currentDate, e), (t = (n = this.props).onChange) == null || t.call(n, this.currentDate);
    }
    render() {
        let { weekFormatter: n, currentDate: a, dateGrid: o } = this, c = this.observedProps, { style: l, variant: u = `primary`, onChange: d, onSelect: f } = c, p = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(c, [
            `style`,
            `variant`,
            `onChange`,
            `onSelect`
        ]);
        return (0, $90cae257cc958273$exports.jsxs)((0, $e94adaa42c5c11d9$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, p), {
            style: (0, $f0029d1e20ae5566$export$71511d61b312f219)({
                tableLayout: `fixed`
            }, l),
            children: [
                (0, $90cae257cc958273$exports.jsx)(`caption`, {
                    children: (0, $90cae257cc958273$exports.jsxs)(`div`, {
                        className: `d-flex justify-content-between align-items-center`,
                        children: [
                            (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                variant: u,
                                onClick: ()=>this.changeMonth(-1),
                                children: `<`
                            }),
                            (0, $90MBA.formatDate)(a, `YYYY-MM`),
                            (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                variant: u,
                                onClick: ()=>this.changeMonth(1),
                                children: `>`
                            })
                        ]
                    })
                }),
                (0, $90cae257cc958273$exports.jsx)(`thead`, {
                    children: (0, $90cae257cc958273$exports.jsx)(`tr`, {
                        children: o[0].map((e, t, { length: i })=>(0, $90cae257cc958273$exports.jsx)(`td`, {
                                className: `bg-${u} text-white`,
                                style: {
                                    width: `calc(100% / ${i})`
                                },
                                children: n.format(e)
                            }, t))
                    })
                }),
                (0, $90cae257cc958273$exports.jsx)(`tbody`, {
                    children: o.map((e)=>(0, $90cae257cc958273$exports.jsx)(`tr`, {
                            children: e.map(this.renderDate)
                        }, e[0] + ``))
                })
            ]
        }));
    }
    constructor(...e){
        super(...e), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$V, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$Nn(this), $246b1ea23ab1fccc$var$Mn(this, new Date))
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `renderDate`, (e)=>{
            let { variant: t = `primary`, value: n, onSelect: o } = this.observedProps, s = (0, $90MBA.formatDate)(e, `YYYY-MM-DD`), c = n == null ? void 0 : n.filter(({ date: e })=>(0, $90MBA.formatDate)(e, `YYYY-MM-DD`) === s);
            return (0, $90cae257cc958273$exports.jsxs)(`td`, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                    "opacity-50": e.getMonth() !== this.currentDate.getMonth(),
                    "fw-bold": s === (0, $90MBA.formatDate)(new Date, `YYYY-MM-DD`)
                }),
                children: [
                    (0, $90cae257cc958273$exports.jsx)(`time`, {
                        className: `d-block`,
                        dateTime: e.toJSON(),
                        children: e.getDate()
                    }),
                    c == null ? void 0 : c.map((e)=>typeof e.content == `object` ? e.content : (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$5169ff31790bf260, {
                            title: e.content,
                            children: (0, $90cae257cc958273$exports.jsx)((0, $73919e3c2229bbf5$export$2e2bcd8739ae039), {
                                as: `a`,
                                className: `d-inline-block text-decoration-none w-100 text-truncate`,
                                bg: $246b1ea23ab1fccc$export$b480d00b75c9ac2d(e.content + ``, [
                                    `light`
                                ]),
                                href: e.link,
                                onClick: ()=>o == null ? void 0 : o(e),
                                children: e.content
                            })
                        }, e.date + ``))
                ]
            }, e + ``);
        });
    }
}, { e: [$246b1ea23ab1fccc$var$Mn, $246b1ea23ab1fccc$var$Nn], c: [$246b1ea23ab1fccc$export$d7a7c85c0f5afc4a, $246b1ea23ab1fccc$var$An] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$On, [
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `weekFormatter`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `currentDate`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `dateGrid`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$jn), $246b1ea23ab1fccc$var$On), $246b1ea23ab1fccc$var$kn = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$d7a7c85c0f5afc4a), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `MonthCalendar`), $246b1ea23ab1fccc$var$An();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$kn, $246b1ea23ab1fccc$var$Dn, void 0), $246b1ea23ab1fccc$var$kn);
const $246b1ea23ab1fccc$export$caa4d5435e8fb601 = ({ avatar: e, name: t })=>(0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$e2255cf6045e8d47, {
                size: 2,
                style: {
                    marginRight: `0.5rem`
                },
                src: e
            }),
            (0, $90cae257cc958273$exports.jsx)(`span`, {
                className: `align-middle`,
                children: t
            })
        ]
    });
$246b1ea23ab1fccc$export$caa4d5435e8fb601.displayName = `Nameplate`;
let $246b1ea23ab1fccc$var$In;
var $246b1ea23ab1fccc$var$H, $246b1ea23ab1fccc$var$U, $246b1ea23ab1fccc$var$Ln, $246b1ea23ab1fccc$var$Rn, $246b1ea23ab1fccc$var$zn, $246b1ea23ab1fccc$var$Bn, $246b1ea23ab1fccc$var$Vn, $246b1ea23ab1fccc$var$Hn, $246b1ea23ab1fccc$var$Un;
const $246b1ea23ab1fccc$var$Wn = Array.from([
    ,
    ,
    ,
    ,
    ,
    , 
], (e, t)=>`h${++t}`) + ``;
let $246b1ea23ab1fccc$export$f24150b9675a2c65;
new ($246b1ea23ab1fccc$var$In = ($246b1ea23ab1fccc$var$H = new WeakMap, $246b1ea23ab1fccc$var$U = new WeakMap, $246b1ea23ab1fccc$var$Ln = class extends ($246b1ea23ab1fccc$var$Bn = (0, $5E6i4.Component)) {
    get list() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$H);
    }
    set list(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$H, e);
    }
    get scrollY() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$U);
    }
    set scrollY(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$U, e);
    }
    get currentActiveId() {
        var e;
        let { list: t, scrollY: n } = this;
        return (e = t[t.findIndex(({ top: e })=>e > n) - 1]) == null ? void 0 : e.id;
    }
    componentDidMount() {
        globalThis.document && (window.addEventListener(`scroll`, this.updateScrollY), this.list = Array.from(document.querySelectorAll($246b1ea23ab1fccc$var$Wn), (e)=>{
            var t;
            (t = e).id || (t.id = (0, $90MBA.uniqueID)());
            let { id: n, tagName: r, textContent: i, offsetTop: a } = e;
            return {
                id: n,
                level: +r[1],
                text: i.trim(),
                top: a
            };
        }));
    }
    componentWillUnmount() {
        var e, t;
        (e = (t = globalThis).removeEventListener) == null || e.call(t, `scroll`, this.updateScrollY);
    }
    render() {
        let { list: n } = this, i = this.props, { style: a, variant: o = `underline` } = i, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(i, [
            `style`,
            `variant`
        ]);
        return (0, $90cae257cc958273$exports.jsx)((0, $8997ca53208bd22a$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, c), {
            variant: o,
            style: (0, $f0029d1e20ae5566$export$71511d61b312f219)({
                flexDirection: `column`
            }, a),
            children: n.map(this.renderLink)
        }));
    }
    constructor(...e){
        super(...e), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$H, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$Un(this), $246b1ea23ab1fccc$var$Vn(this, []))
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$U, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$Hn(this, 0)
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `updateScrollY`, ()=>this.scrollY = window.scrollY), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `scrollTo`, (e)=>()=>{
                var t, n;
                setTimeout(()=>(0, $90MBA.scrollTo)(`[id="${e.id}"]`)), (t = (n = this.props).onItemClick) == null || t.call(n, e);
            }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `renderLink`, ({ id: e, level: t, text: n, top: i })=>{
            let { currentActiveId: a } = this, { depth: o = 1 / 0 } = this.props;
            return t <= o && (0, $90cae257cc958273$exports.jsx)((0, $8997ca53208bd22a$export$2e2bcd8739ae039).Item, {
                style: {
                    textIndent: `${t - 1}rem`
                },
                children: (0, $90cae257cc958273$exports.jsx)((0, $8997ca53208bd22a$export$2e2bcd8739ae039).Link, {
                    href: `#${e}`,
                    active: a === e,
                    onClick: this.scrollTo({
                        id: e,
                        level: t,
                        text: n,
                        top: i
                    }),
                    children: n
                })
            }, e);
        });
    }
}, { e: [$246b1ea23ab1fccc$var$Vn, $246b1ea23ab1fccc$var$Hn, $246b1ea23ab1fccc$var$Un], c: [$246b1ea23ab1fccc$export$f24150b9675a2c65, $246b1ea23ab1fccc$var$zn] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$Ln, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `list`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `scrollY`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `currentActiveId`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$Bn), $246b1ea23ab1fccc$var$Ln), $246b1ea23ab1fccc$var$Rn = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$f24150b9675a2c65), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `PageNav`), $246b1ea23ab1fccc$var$zn();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$Rn, $246b1ea23ab1fccc$var$In, void 0), $246b1ea23ab1fccc$var$Rn);
let $246b1ea23ab1fccc$var$Kn;
var $246b1ea23ab1fccc$var$W, $246b1ea23ab1fccc$var$G, $246b1ea23ab1fccc$var$K, $246b1ea23ab1fccc$var$qn, $246b1ea23ab1fccc$var$Jn, $246b1ea23ab1fccc$var$Yn, $246b1ea23ab1fccc$var$Xn, $246b1ea23ab1fccc$var$Zn, $246b1ea23ab1fccc$var$Qn, $246b1ea23ab1fccc$var$$n, $246b1ea23ab1fccc$var$er;
let $246b1ea23ab1fccc$export$c57977d1ebb6ef1d;
new ($246b1ea23ab1fccc$var$Kn = ($246b1ea23ab1fccc$var$W = new WeakMap, $246b1ea23ab1fccc$var$G = new WeakMap, $246b1ea23ab1fccc$var$K = new WeakMap, $246b1ea23ab1fccc$var$qn = class extends ($246b1ea23ab1fccc$var$Xn = (0, $5E6i4.Component)) {
    get scrollLeft() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$W);
    }
    set scrollLeft(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$W, e);
    }
    get scrollWidth() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$G);
    }
    set scrollWidth(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$G, e);
    }
    get clientWidth() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$K);
    }
    set clientWidth(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$K, e);
    }
    get canScrollLeft() {
        return this.scrollLeft > 0;
    }
    get canScrollRight() {
        return this.scrollLeft + this.clientWidth < this.scrollWidth;
    }
    componentDidMount() {
        let e = this.updateScroll();
        e && (e.addEventListener(`scroll`, this.updateScroll), this.resizeObserver = new ResizeObserver(this.updateScroll), this.resizeObserver.observe(e));
    }
    componentWillUnmount() {
        var e, t;
        (e = this.resizeObserver) == null || e.disconnect(), (t = this.scrollerRef.current) == null || t.removeEventListener(`scroll`, this.updateScroll);
    }
    render() {
        let { canScrollLeft: n, canScrollRight: a } = this, o = this.props, { className: c = ``, children: l } = o, u = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(o, [
            `className`,
            `children`
        ]);
        return (0, $90cae257cc958273$exports.jsxs)(`div`, {
            className: `position-relative overflow-y-hidden ${c}`,
            children: [
                n && (0, $90cae257cc958273$exports.jsx)(`button`, {
                    type: `button`,
                    className: `position-absolute top-0 bottom-0 start-0 z-1 border-0 px-2 aEvBXq_scrollButtonLeft`,
                    "aria-label": `Scroll left`,
                    onClick: this.scrollBy(-1),
                    children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$f04a61298a47a40f, {
                        name: `caret-left-fill`
                    })
                }),
                (0, $90cae257cc958273$exports.jsx)(`div`, {
                    ref: this.scrollerRef,
                    className: `overflow-x-auto aEvBXq_scrollerInner`,
                    children: (0, $90cae257cc958273$exports.jsx)((0, $8997ca53208bd22a$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, u), {
                        className: `flex-nowrap`,
                        children: l
                    }))
                }),
                a && (0, $90cae257cc958273$exports.jsx)(`button`, {
                    type: `button`,
                    className: `position-absolute top-0 bottom-0 end-0 z-1 border-0 px-2 aEvBXq_scrollButtonRight`,
                    "aria-label": `Scroll right`,
                    onClick: this.scrollBy(1),
                    children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$f04a61298a47a40f, {
                        name: `caret-right-fill`
                    })
                })
            ]
        });
    }
    constructor(...e){
        super(...e), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `scrollerRef`, ($246b1ea23ab1fccc$var$er(this), (0, $5E6i4.createRef)())), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$W, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$Zn(this, 0)
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$G, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$Qn(this, 0)
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$K, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$$n(this, 0)
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `updateScroll`, ()=>{
            let e = this.scrollerRef.current;
            return e && (this.scrollLeft = e.scrollLeft, this.scrollWidth = e.scrollWidth, this.clientWidth = e.clientWidth), e;
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `resizeObserver`, void 0), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `scrollBy`, (e)=>()=>{
                let t = this.scrollerRef.current;
                t && t.scrollBy({
                    left: e * t.clientWidth * .8,
                    behavior: `smooth`
                });
            });
    }
}, { e: [$246b1ea23ab1fccc$var$Zn, $246b1ea23ab1fccc$var$Qn, $246b1ea23ab1fccc$var$$n, $246b1ea23ab1fccc$var$er], c: [$246b1ea23ab1fccc$export$c57977d1ebb6ef1d, $246b1ea23ab1fccc$var$Yn] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$qn, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `scrollLeft`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `scrollWidth`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `clientWidth`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `canScrollLeft`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2),
        3,
        `canScrollRight`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$Xn), $246b1ea23ab1fccc$var$qn), $246b1ea23ab1fccc$var$Jn = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$c57977d1ebb6ef1d), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `ScrollNav`), $246b1ea23ab1fccc$var$Yn();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$Jn, $246b1ea23ab1fccc$var$Kn, void 0), $246b1ea23ab1fccc$var$Jn);
const $246b1ea23ab1fccc$export$36d18380658d5d20 = (n)=>{
    let { value: i, children: a } = n, o = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `value`,
        `children`
    ]);
    return (0, $90cae257cc958273$exports.jsx)((0, $a8ea7e3963a7ebe0$export$2e2bcd8739ae039).Item, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, o), {
        "data-value": i,
        children: a
    }));
};
$246b1ea23ab1fccc$export$36d18380658d5d20.displayName = `Option`;
const $246b1ea23ab1fccc$export$ef9b1a59e592288f = ({ className: e, style: t, variant: n, menuVariant: o, children: s, value: c, onChange: l, valueRender: u })=>{
    let d = (0, $90MBA.makeArray)(s).flat(1 / 0).find((e)=>(0, $5E6i4.isValidElement)(e) && e.type === $246b1ea23ab1fccc$export$36d18380658d5d20 && e.props.value === c);
    return (0, $90cae257cc958273$exports.jsxs)((0, $a8ea7e3963a7ebe0$export$2e2bcd8739ae039), {
        onClick: ({ target: e })=>{
            let t = e.closest(`.dropdown-item`);
            if (!t) return;
            let { value: n } = t.dataset;
            l == null || l(n);
        },
        children: [
            (0, $90cae257cc958273$exports.jsx)((0, $a8ea7e3963a7ebe0$export$2e2bcd8739ae039).Toggle, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`w-100`, `d-flex`, `justify-content-between`, `align-items-center`, !n && `bg-white text-dark`, e),
                style: t,
                variant: n,
                children: (u == null ? void 0 : u(c)) || (0, $90cae257cc958273$exports.jsx)(`div`, {
                    className: d == null ? void 0 : d.props.className,
                    children: d == null ? void 0 : d.props.children
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $a8ea7e3963a7ebe0$export$2e2bcd8739ae039).Menu, {
                variant: o,
                children: s
            })
        ]
    });
};
$246b1ea23ab1fccc$export$ef9b1a59e592288f.displayName = `Select`;
let $246b1ea23ab1fccc$var$ir;
var $246b1ea23ab1fccc$var$q, $246b1ea23ab1fccc$var$J, $246b1ea23ab1fccc$var$ar, $246b1ea23ab1fccc$var$or, $246b1ea23ab1fccc$var$sr, $246b1ea23ab1fccc$var$cr, $246b1ea23ab1fccc$var$lr, $246b1ea23ab1fccc$var$ur, $246b1ea23ab1fccc$var$dr;
function $246b1ea23ab1fccc$export$fefa3387c33a1dfc(e, t, n) {
    return (0, $25a6c985cf60a3ea$export$71511d61b312f219)(function*() {
        let r = yield (0, (/*@__PURE__*/$parcel$interopDefault($799264a770627072$exports)))(e, {
            useCORS: !0
        });
        return new Promise((e, i)=>r.toBlob((t)=>t ? e(URL.createObjectURL(t)) : i(), t, n));
    })();
}
let $246b1ea23ab1fccc$export$e15a265ebbd5ca8c;
new ($246b1ea23ab1fccc$var$ir = ($246b1ea23ab1fccc$var$q = new WeakMap, $246b1ea23ab1fccc$var$J = new WeakMap, $246b1ea23ab1fccc$var$ar = class extends ($246b1ea23ab1fccc$var$cr = (0, $5E6i4.Component)) {
    get loading() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$q);
    }
    set loading(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$q, e);
    }
    get imageURI() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$J);
    }
    set imageURI(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$J, e);
    }
    componentDidMount() {
        var e, t;
        (e = (t = globalThis).addEventListener) == null || e.call(t, `resize`, this.generateImage);
    }
    componentWillUnmount() {
        var e, t;
        (e = (t = globalThis).removeEventListener) == null || e.call(t, `resize`, this.generateImage);
    }
    render() {
        let a = this.props, { className: o = ``, children: c } = a, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(a, [
            `className`,
            `children`
        ]), { loading: u, imageURI: d } = this;
        return (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
            children: [
                u && (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$669f6ea7d267feaf, {}),
                (0, $90cae257cc958273$exports.jsxs)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, l), {
                    ref: this.root,
                    className: `position-relative ${o}`,
                    onMouseEnter: d ? void 0 : this.generateImage,
                    onTouchStart: d ? void 0 : this.generateImage,
                    children: [
                        c,
                        d && (0, $90cae257cc958273$exports.jsx)((0, $82fa4ab13bb8a9e3$export$2e2bcd8739ae039), {
                            className: `position-absolute start-0 top-0 w-100 h-100`,
                            src: d,
                            alt: `Share Image`,
                            fluid: !0,
                            onClick: this.share
                        })
                    ]
                }))
            ]
        });
    }
    constructor(...t){
        var n;
        super(...t), n = this, (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `root`, ($246b1ea23ab1fccc$var$dr(this), (0, $5E6i4.createRef)())), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$q, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$lr(this, !1)
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$J, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$ur(this, ``)
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `generateImage`, ()=>(0, $25a6c985cf60a3ea$export$71511d61b312f219)(function*() {
                n.imageURI && (URL.revokeObjectURL(n.imageURI), n.imageURI = ``), n.loading = !0, n.imageURI = yield $246b1ea23ab1fccc$export$fefa3387c33a1dfc(n.root.current), n.loading = !1;
            })()), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `share`, (t)=>(0, $25a6c985cf60a3ea$export$71511d61b312f219)(function*() {
                var r, i;
                t.stopPropagation();
                let a = yield (0, $90MBA.blobOf)(n.imageURI), o = new File([
                    a
                ], `${n.props.title}.png`, {
                    type: a.type
                });
                yield (r = (i = navigator).share) == null ? void 0 : r.call(i, (0, $f0029d1e20ae5566$export$71511d61b312f219)({
                    files: [
                        o
                    ]
                }, n.props));
            })());
    }
}, { e: [$246b1ea23ab1fccc$var$lr, $246b1ea23ab1fccc$var$ur, $246b1ea23ab1fccc$var$dr], c: [$246b1ea23ab1fccc$export$e15a265ebbd5ca8c, $246b1ea23ab1fccc$var$sr] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$ar, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `loading`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `imageURI`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$cr), $246b1ea23ab1fccc$var$ar), $246b1ea23ab1fccc$var$or = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$e15a265ebbd5ca8c), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `ShareBox`), $246b1ea23ab1fccc$var$sr();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$or, $246b1ea23ab1fccc$var$ir, void 0), $246b1ea23ab1fccc$var$or);
const $246b1ea23ab1fccc$export$4cfabf47f4311ebb = (a)=>{
    let { animation: o, loading: c, disabled: l, children: u } = a, d = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(a, [
        `animation`,
        `loading`,
        `disabled`,
        `children`
    ]);
    return (0, $90cae257cc958273$exports.jsxs)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, d), {
        disabled: c || l,
        children: [
            c && (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {
                        as: `span`,
                        className: u ? `me-2` : ``,
                        size: `sm`,
                        animation: o,
                        role: `status`,
                        "aria-hidden": `true`
                    }),
                    !u && (0, $90cae257cc958273$exports.jsx)(`span`, {
                        className: `visually-hidden`,
                        children: `Loading...`
                    })
                ]
            }),
            u
        ]
    }));
};
$246b1ea23ab1fccc$export$4cfabf47f4311ebb.displayName = `SpinnerButton`;
const $246b1ea23ab1fccc$export$4706ba151aa92b7e = (n)=>{
    let { animation: i = `border`, variant: a = `primary`, size: o, colSpan: c } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `animation`,
        `variant`,
        `size`,
        `colSpan`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`tr`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, l), {
        children: (0, $90cae257cc958273$exports.jsx)(`td`, {
            className: `text-center p-4`,
            colSpan: c,
            children: (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {
                animation: i,
                variant: a,
                size: o
            })
        })
    }));
};
$246b1ea23ab1fccc$export$4706ba151aa92b7e.displayName = `TableSpinner`;
let $246b1ea23ab1fccc$var$gr;
var $246b1ea23ab1fccc$var$Y, $246b1ea23ab1fccc$var$X, $246b1ea23ab1fccc$var$_r, $246b1ea23ab1fccc$var$vr, $246b1ea23ab1fccc$var$yr, $246b1ea23ab1fccc$var$br, $246b1ea23ab1fccc$var$xr, $246b1ea23ab1fccc$var$Sr, $246b1ea23ab1fccc$var$Cr;
let $246b1ea23ab1fccc$export$ee6221c372f955f;
new ($246b1ea23ab1fccc$var$gr = ($246b1ea23ab1fccc$var$Y = new WeakMap, $246b1ea23ab1fccc$var$X = new WeakMap, $246b1ea23ab1fccc$var$_r = class extends ($246b1ea23ab1fccc$var$br = (0, $5E6i4.Component)) {
    get expanded() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Y);
    }
    set expanded(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Y, e);
    }
    get overflowed() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$X);
    }
    set overflowed(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$X, e);
    }
    componentDidMount() {
        this.checkOverflow(), window.addEventListener(`resize`, this.checkOverflow);
    }
    componentDidUpdate({ rows: e, children: t }) {
        !this.expanded && (t !== this.props.children || e !== this.props.rows) && this.checkOverflow();
    }
    componentWillUnmount() {
        window.removeEventListener(`resize`, this.checkOverflow);
    }
    render() {
        let n = this.props, { children: a, rows: o = 3, expandText: c = `\u{23EC}`, collapseText: l = `\u{23EB}` } = n, u = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `children`,
            `rows`,
            `expandText`,
            `collapseText`
        ]), { expanded: d, overflowed: f } = this, p = {
            overflow: `hidden`,
            display: `-webkit-box`,
            WebkitBoxOrient: `vertical`,
            WebkitLineClamp: o
        };
        return (0, $90cae257cc958273$exports.jsxs)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, u), {
            children: [
                (0, $90cae257cc958273$exports.jsx)(`p`, {
                    ref: this.contentRef,
                    style: d ? void 0 : p,
                    children: a
                }),
                (f || d) && (0, $90cae257cc958273$exports.jsx)(`button`, {
                    type: `button`,
                    className: `bg-transparent border-0 p-0`,
                    "aria-expanded": d,
                    onClick: this.toggle,
                    children: d ? l : c
                })
            ]
        }));
    }
    constructor(...e){
        super(...e), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Y, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$Cr(this), $246b1ea23ab1fccc$var$xr(this, !1))
        }), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$X, {
            writable: !0,
            value: $246b1ea23ab1fccc$var$Sr(this, !1)
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `contentRef`, (0, $5E6i4.createRef)()), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `checkOverflow`, ()=>{
            let { current: e } = this.contentRef;
            e && (this.overflowed = e.scrollHeight > e.clientHeight);
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `toggle`, ()=>{
            this.expanded = !this.expanded, this.expanded || requestAnimationFrame(this.checkOverflow);
        });
    }
}, { e: [$246b1ea23ab1fccc$var$xr, $246b1ea23ab1fccc$var$Sr, $246b1ea23ab1fccc$var$Cr], c: [$246b1ea23ab1fccc$export$ee6221c372f955f, $246b1ea23ab1fccc$var$yr] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$_r, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `expanded`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `overflowed`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$br), $246b1ea23ab1fccc$var$_r), $246b1ea23ab1fccc$var$vr = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$ee6221c372f955f), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `TextTruncate`), $246b1ea23ab1fccc$var$yr();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$vr, $246b1ea23ab1fccc$var$gr, void 0), $246b1ea23ab1fccc$var$vr);
let $246b1ea23ab1fccc$var$Tr;
var $246b1ea23ab1fccc$var$Z, $246b1ea23ab1fccc$var$Er, $246b1ea23ab1fccc$var$Dr, $246b1ea23ab1fccc$var$Or, $246b1ea23ab1fccc$var$kr, $246b1ea23ab1fccc$var$Ar = (0, $85705ec7803c1445$export$7203b476385689ae)(({ observedProps: { dateTime: e, format: t } })=>e + t), $246b1ea23ab1fccc$var$jr, $246b1ea23ab1fccc$var$Mr;
let $246b1ea23ab1fccc$export$680ea196effce5f;
new ($246b1ea23ab1fccc$var$Tr = ($246b1ea23ab1fccc$var$Z = new WeakMap, $246b1ea23ab1fccc$var$Er = class extends ($246b1ea23ab1fccc$var$kr = (0, $85705ec7803c1445$export$bf180ef329d1efd8)) {
    updateText() {
        let { dateTime: e, format: t } = this.props;
        return (0, $90MBA.formatDate)(e, t);
    }
    get timeText() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Z);
    }
    set timeText(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Z, e);
    }
    componentDidMount() {
        super.componentDidMount(), this.timeText = this.updateText();
    }
    render() {
        let n = this.props, { dateTime: i } = n, a = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `dateTime`
        ]);
        return (0, $90cae257cc958273$exports.jsx)(`time`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
            dateTime: new Date(i).toJSON()
        }, a), {
            children: this.timeText
        }));
    }
    constructor(...e){
        super(...e), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$Z, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$Mr(this), $246b1ea23ab1fccc$var$jr(this, this.updateText()))
        });
    }
}, { e: [$246b1ea23ab1fccc$var$jr, $246b1ea23ab1fccc$var$Mr], c: [$246b1ea23ab1fccc$export$680ea196effce5f, $246b1ea23ab1fccc$var$Or] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$Er, [
    [
        $246b1ea23ab1fccc$var$Ar,
        2,
        `updateText`
    ],
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `timeText`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$kr), $246b1ea23ab1fccc$var$Er), $246b1ea23ab1fccc$var$Dr = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$680ea196effce5f), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `Time`), $246b1ea23ab1fccc$var$Or();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$Dr, $246b1ea23ab1fccc$var$Tr, void 0), $246b1ea23ab1fccc$var$Dr);
const $246b1ea23ab1fccc$var$Nr = {
    ms: `millisecond(s)`,
    s: `second(s)`,
    m: `minute(s)`,
    H: `hour(s)`,
    D: `day(s)`,
    W: `week(s)`,
    M: `month(s)`,
    Y: `year(s)`
}, $246b1ea23ab1fccc$export$db3f63f9e19e5969 = (n)=>{
    let { date: r, unitWords: a = $246b1ea23ab1fccc$var$Nr, beforeWord: o = ` before`, afterWord: c = ` after` } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `date`,
        `unitWords`,
        `beforeWord`,
        `afterWord`
    ]);
    r = new Date(r);
    let { distance: u, unit: d } = (0, $90MBA.diffTime)(r);
    return (0, $90cae257cc958273$exports.jsxs)(`time`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, l), {
        dateTime: r.toJSON(),
        title: r.toLocaleString(),
        children: [
            Math.abs(u),
            ` `,
            a[d],
            u < 0 ? o : c
        ]
    }));
};
$246b1ea23ab1fccc$export$db3f63f9e19e5969.displayName = `TimeDistance`;
const $246b1ea23ab1fccc$export$e6a97ba2cae5bb94 = (n)=>{
    let { className: a, events: o, timeFormat: c } = n, l = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `events`,
        `timeFormat`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`ol`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `list-unstyled hsu__a_timeline ${a}`
    }, l), {
        children: o.map(({ title: t, summary: n, time: a, link: o, people: s })=>(0, $90cae257cc958273$exports.jsx)(`li`, {
                className: `position-relative hsu__a_timelineItem hsu__a_right`,
                children: (0, $90cae257cc958273$exports.jsx)((0, $717c2fb651d8cbb5$export$2e2bcd8739ae039), {
                    children: (0, $90cae257cc958273$exports.jsxs)((0, $717c2fb651d8cbb5$export$2e2bcd8739ae039).Body, {
                        className: `p-4 d-flex flex-column gap-3 align-items-center`,
                        children: [
                            (0, $90cae257cc958273$exports.jsx)(`h3`, {
                                className: `h5 m-0`,
                                children: (0, $90cae257cc958273$exports.jsx)(`a`, {
                                    className: `text-decoration-none stretched-link`,
                                    href: o,
                                    children: t
                                })
                            }),
                            (0, $90cae257cc958273$exports.jsxs)(`div`, {
                                className: `small text-muted d-flex gap-2`,
                                children: [
                                    `\u{23F2}\u{FE0F}`,
                                    (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$680ea196effce5f, {
                                        dateTime: a[0],
                                        format: c
                                    }),
                                    a[1] && `~`,
                                    a[1] && (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$680ea196effce5f, {
                                        dateTime: a[1],
                                        format: c
                                    })
                                ]
                            }),
                            (0, $90cae257cc958273$exports.jsx)(`ul`, {
                                className: `list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around`,
                                children: s == null ? void 0 : s.map((t)=>(0, $90cae257cc958273$exports.jsx)(`li`, {
                                        children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$caa4d5435e8fb601, (0, $f0029d1e20ae5566$export$71511d61b312f219)({}, t))
                                    }, t.name))
                            }),
                            (0, $90cae257cc958273$exports.jsx)(`p`, {
                                className: `m-0`,
                                children: n
                            })
                        ]
                    })
                })
            }, t))
    }));
};
$246b1ea23ab1fccc$export$e6a97ba2cae5bb94.displayName = `Timeline`;
var $246b1ea23ab1fccc$var$Ir, $246b1ea23ab1fccc$var$Lr;
const $246b1ea23ab1fccc$var$Rr = new Set([
    `warning`,
    `info`,
    `light`
]);
var $246b1ea23ab1fccc$var$zr = new WeakMap, $246b1ea23ab1fccc$export$8d8dc7d5f743331b = class {
    get messages() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$zr);
    }
    set messages(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$zr, e);
    }
    open(t) {
        let n = (0, $90MBA.uniqueID)(), r = Date.now(), { promise: i, resolve: a } = Promise.withResolvers();
        return this.messages = [
            ...this.messages,
            (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
                id: n
            }, t), {
                openedAt: r,
                resolve: a
            })
        ], i;
    }
    close(n) {
        let r = this.messages.find((e)=>e.id === n) || {}, { resolve: i } = r, a = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(r, [
            `resolve`
        ]);
        i == null || i((0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, a), {
            closedAt: Date.now()
        })), this.messages = this.messages.filter((e)=>e.id !== n);
    }
    constructor(e = (0, $90MBA.Timestamp)){
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `TimeScalar`, void 0), (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$zr, {
            writable: !0,
            value: void 0
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `Component`, void 0), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `renderMessage`, void 0), this.TimeScalar = e, (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$zr, ($246b1ea23ab1fccc$var$Lr(this), $246b1ea23ab1fccc$var$Ir(this, []))), this.Component = (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)(({ position: e = `top-end` })=>(0, $90cae257cc958273$exports.jsx)((0, $0e2bf089bc399e9d$export$2e2bcd8739ae039), {
                position: e,
                className: `position-fixed p-3`,
                children: this.messages.map(this.renderMessage)
            })), this.renderMessage = ({ id: e, openedAt: t, title: n, body: a, variant: o, delay: s = 3e3 })=>{
            let c = o && !$246b1ea23ab1fccc$var$Rr.has(o) ? `text-white` : void 0, l = !!n || s === 0, u = this.TimeScalar.distanceOf(Date.now(), t).toShortString();
            return (0, $90cae257cc958273$exports.jsxs)((0, $60cc0262860e0a32$export$2e2bcd8739ae039), {
                bg: o,
                delay: s,
                autohide: s !== 0,
                onClose: ()=>this.close(e),
                children: [
                    l && (0, $90cae257cc958273$exports.jsxs)((0, $60cc0262860e0a32$export$2e2bcd8739ae039).Header, {
                        children: [
                            (0, $90cae257cc958273$exports.jsx)(`strong`, {
                                className: `me-auto`,
                                children: n
                            }),
                            (0, $90cae257cc958273$exports.jsx)(`small`, {
                                children: u
                            })
                        ]
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $60cc0262860e0a32$export$2e2bcd8739ae039).Body, {
                        className: c,
                        children: a
                    })
                ]
            }, e);
        }, this.Component.displayName = `ToastComponent`;
    }
};
({ e: [$246b1ea23ab1fccc$var$Ir, $246b1ea23ab1fccc$var$Lr] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$export$8d8dc7d5f743331b, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `messages`
    ]
], []));
let $246b1ea23ab1fccc$var$Vr;
var $246b1ea23ab1fccc$var$$, $246b1ea23ab1fccc$var$Hr, $246b1ea23ab1fccc$var$Ur, $246b1ea23ab1fccc$var$Wr, $246b1ea23ab1fccc$var$Gr, $246b1ea23ab1fccc$var$Kr, $246b1ea23ab1fccc$var$qr;
let $246b1ea23ab1fccc$export$2fe61c915a9818e6;
new ($246b1ea23ab1fccc$var$Vr = ($246b1ea23ab1fccc$var$$ = new WeakMap, $246b1ea23ab1fccc$var$Hr = class extends ($246b1ea23ab1fccc$var$Gr = (0, $5E6i4.Component)) {
    get echoed() {
        return (0, $2e8770fb1746bee3$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$$);
    }
    set echoed(e) {
        (0, $3ef3985b24825cc1$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$$, e);
    }
    render() {
        let n = this.props, { className: i, text: o } = n, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `className`,
            `text`
        ]), { echoed: l } = this;
        return (0, $90cae257cc958273$exports.jsx)(`pre`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({}, c), {
            ref: this.init,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`text-wrap`, i),
            children: l + (l === o ? `` : `_`)
        }));
    }
    constructor(...e){
        var t;
        super(...e), t = this, (0, $da1508c8a4f4d8c0$export$71511d61b312f219)(this, $246b1ea23ab1fccc$var$$, {
            writable: !0,
            value: ($246b1ea23ab1fccc$var$qr(this), $246b1ea23ab1fccc$var$Kr(this, ``))
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `init`, (e)=>e && new IntersectionObserver(([{ isIntersecting: e }], n)=>(0, $25a6c985cf60a3ea$export$71511d61b312f219)(function*() {
                    if (!e) return;
                    n.disconnect();
                    let { text: r, intervals: i = 150 } = t.props;
                    for (let e of r)yield (0, $90MBA.sleep)(i / 1e3), t.echoed += e;
                })()).observe(e));
    }
}, { e: [$246b1ea23ab1fccc$var$Kr, $246b1ea23ab1fccc$var$qr], c: [$246b1ea23ab1fccc$export$2fe61c915a9818e6, $246b1ea23ab1fccc$var$Wr] } = (0, $ad1cfc6cb1ef08cb$export$71511d61b312f219)($246b1ea23ab1fccc$var$Hr, [
    [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a),
        1,
        `echoed`
    ]
], [
    (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
], $246b1ea23ab1fccc$var$Gr), $246b1ea23ab1fccc$var$Hr), $246b1ea23ab1fccc$var$Ur = class extends (0, $47926a612454f4f1$export$71511d61b312f219) {
    constructor(){
        super($246b1ea23ab1fccc$export$2fe61c915a9818e6), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `displayName`, `TypeEcho`), $246b1ea23ab1fccc$var$Wr();
    }
}, (0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$var$Ur, $246b1ea23ab1fccc$var$Vr, void 0), $246b1ea23ab1fccc$var$Ur);
const $246b1ea23ab1fccc$var$Yr = ({ email: e, website: t })=>(0, $90cae257cc958273$exports.jsxs)(`address`, {
        className: `mb-0 d-flex justify-content-around gap-2`,
        children: [
            e && (0, $90cae257cc958273$exports.jsx)(`a`, {
                rel: `noreferrer`,
                target: `_blank`,
                href: `mailto:` + e,
                children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$f04a61298a47a40f, {
                    name: `envelope`
                })
            }),
            t && (0, $90cae257cc958273$exports.jsx)(`a`, {
                rel: `noreferrer`,
                target: `_blank`,
                href: t,
                children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$export$f04a61298a47a40f, {
                    name: `globe2`
                })
            })
        ]
    }), $246b1ea23ab1fccc$var$Xr = `X5DLia_image`;
var $246b1ea23ab1fccc$export$4ed039229ec81818 = class extends (0, $5E6i4.PureComponent) {
    render() {
        let n = this.props, { className: a = ``, title: o, rank: c = [], linkOf: l } = n, u = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
            `className`,
            `title`,
            `rank`,
            `linkOf`
        ]);
        return (0, $90cae257cc958273$exports.jsxs)((0, $b822ff2b087e0e91$export$2e2bcd8739ae039), (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
            className: `X5DLia_rankBox ${a}`
        }, u), {
            children: [
                (0, $90cae257cc958273$exports.jsxs)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
                    sm: 12,
                    xs: 12,
                    lg: 7,
                    children: [
                        (0, $90cae257cc958273$exports.jsxs)(`div`, {
                            className: `shadow rounded-3 X5DLia_title`,
                            children: [
                                (0, $90cae257cc958273$exports.jsxs)(`div`, {
                                    className: `X5DLia_medal`,
                                    children: [
                                        (0, $90cae257cc958273$exports.jsx)(`i`, {
                                            className: `d-inline-block ms-1 overflow-hidden rounded-circle`
                                        }),
                                        (0, $90cae257cc958273$exports.jsx)(`i`, {
                                            className: `d-inline-block ms-1 overflow-hidden rounded-circle`
                                        }),
                                        (0, $90cae257cc958273$exports.jsx)(`i`, {
                                            className: `d-inline-block ms-1 overflow-hidden rounded-circle`
                                        })
                                    ]
                                }),
                                (0, $90cae257cc958273$exports.jsx)(`h3`, {
                                    "data-text": o,
                                    className: `position-relative m-auto mb-0 fw-bold text-center`,
                                    children: o
                                })
                            ]
                        }),
                        (0, $90cae257cc958273$exports.jsx)((0, $b822ff2b087e0e91$export$2e2bcd8739ae039), {
                            as: `ul`,
                            className: `mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled X5DLia_topUsers`,
                            children: c.slice(0, 3).map(this.renderMedal)
                        })
                    ]
                }),
                (0, $90cae257cc958273$exports.jsx)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
                    xs: 12,
                    sm: 12,
                    lg: 5,
                    children: (0, $90cae257cc958273$exports.jsx)((0, $e94adaa42c5c11d9$export$2e2bcd8739ae039), {
                        className: `my-3 pt-2 X5DLia_restUsers`,
                        responsive: !0,
                        children: (0, $90cae257cc958273$exports.jsx)(`tbody`, {
                            children: c.slice(3, 10).map(this.renderRow)
                        })
                    })
                })
            ]
        }));
    }
    constructor(...t){
        super(...t), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `renderMedal`, (t)=>{
            var n, a;
            return (0, $90cae257cc958273$exports.jsxs)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
                as: `li`,
                children: [
                    (0, $90cae257cc958273$exports.jsx)(`div`, {
                        className: `shadow-lg overflow-hidden rounded-circle m-auto ${$246b1ea23ab1fccc$var$Xr}`,
                        children: (0, $90cae257cc958273$exports.jsx)((0, $82fa4ab13bb8a9e3$export$2e2bcd8739ae039), {
                            src: t.avatar,
                            alt: t.name,
                            loading: `lazy`,
                            fluid: !0
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsxs)(`div`, {
                        className: `position-relative overflow-hidden X5DLia_topUser`,
                        children: [
                            (0, $90cae257cc958273$exports.jsxs)(`div`, {
                                className: `position-relative`,
                                children: [
                                    (0, $90cae257cc958273$exports.jsx)(`i`, {
                                        className: `d-block overflow-hidden m-auto mb-1 rounded-circle`
                                    }),
                                    (0, $90cae257cc958273$exports.jsx)(`a`, {
                                        className: `d-block mb-0 stretched-link`,
                                        href: ((n = (a = this.props).linkOf) == null ? void 0 : n.call(a, t)) || `#`,
                                        children: t.name
                                    }),
                                    (0, $90cae257cc958273$exports.jsx)(`strong`, {
                                        children: t.score
                                    })
                                ]
                            }),
                            (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$var$Yr, (0, $f0029d1e20ae5566$export$71511d61b312f219)({}, t))
                        ]
                    })
                ]
            }, t.id);
        }), (0, $1d8e073d1256147c$export$71511d61b312f219)(this, `renderRow`, (t, n, { length: a })=>{
            var o, s;
            return (0, $90cae257cc958273$exports.jsxs)(`tr`, {
                className: `position-relative`,
                children: [
                    (0, $90cae257cc958273$exports.jsx)(`td`, {
                        className: `align-middle`,
                        children: (0, $90cae257cc958273$exports.jsx)((0, $73919e3c2229bbf5$export$2e2bcd8739ae039), {
                            className: `fw-bold fst-italic`,
                            children: (n + 4 + ``).padStart((a + ``).length, `0`)
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsxs)(`td`, {
                        className: `position-relative mw-50 text-truncate X5DLia_name`,
                        children: [
                            (0, $90cae257cc958273$exports.jsx)(`div`, {
                                className: `d-inline-block overflow-hidden align-middle rounded-circle ${$246b1ea23ab1fccc$var$Xr}`,
                                children: (0, $90cae257cc958273$exports.jsx)((0, $82fa4ab13bb8a9e3$export$2e2bcd8739ae039), {
                                    src: t.avatar,
                                    alt: t.name,
                                    loading: `lazy`,
                                    fluid: !0
                                })
                            }),
                            (0, $90cae257cc958273$exports.jsx)(`a`, {
                                className: `ms-2 d-inline-block align-middle stretched-link`,
                                style: {
                                    color: `rgb(248, ${(n + 2) * 15}, ${(n + 2) * 35})`
                                },
                                href: ((o = (s = this.props).linkOf) == null ? void 0 : o.call(s, t)) || `#`,
                                children: t.name
                            })
                        ]
                    }),
                    (0, $90cae257cc958273$exports.jsx)(`td`, {
                        className: `align-middle`,
                        children: t.score
                    }),
                    (0, $90cae257cc958273$exports.jsx)(`td`, {
                        className: `align-middle`,
                        children: (0, $90cae257cc958273$exports.jsx)($246b1ea23ab1fccc$var$Yr, (0, $f0029d1e20ae5566$export$71511d61b312f219)({}, t))
                    })
                ]
            }, t.id);
        });
    }
};
(0, $1d8e073d1256147c$export$71511d61b312f219)($246b1ea23ab1fccc$export$4ed039229ec81818, `displayName`, `UserRankView`);
const $246b1ea23ab1fccc$export$125576d08e40b98f = (n)=>{
    let { className: i = ``, children: a, duration: o } = n, c = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `children`,
        `duration`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`div`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `overflow-hidden ${i}`
    }, c), {
        children: (0, $90cae257cc958273$exports.jsx)(`div`, {
            className: `d-inline-block mw-100 mh-100 QBd6SG_scrollWrap`,
            style: {
                "--duration": o
            },
            children: (0, $90cae257cc958273$exports.jsx)(`div`, {
                className: `d-inline-block QBd6SG_scrollItem`,
                children: a
            })
        })
    }));
};
$246b1ea23ab1fccc$export$125576d08e40b98f.displayName = `VerticalMarquee`;
const $246b1ea23ab1fccc$export$c0efdd35897a499c = [
    `\u{1F435}`,
    `\u{1F414}`,
    `\u{1F436}`,
    `\u{1F437}`,
    `\u{1F42D}`,
    `\u{1F42E}`,
    `\u{1F42F}`,
    `\u{1F430}`,
    `\u{1F432}`,
    `\u{1F40D}`,
    `\u{1F434}`,
    `\u{1F410}`
], $246b1ea23ab1fccc$export$1ace452aebce17cb = (e)=>{
    let t = e < 0 ? e + 1 : e;
    return $246b1ea23ab1fccc$export$c0efdd35897a499c[(t % 12 + 12) % 12];
}, $246b1ea23ab1fccc$export$de26cde43ba4c348 = (n)=>{
    let { className: a = ``, itemClassName: o = `border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center`, startYear: c, endYear: l = new Date().getFullYear(), itemOf: u } = n, d = (0, $36dd8b42e2966ea6$export$71511d61b312f219)(n, [
        `className`,
        `itemClassName`,
        `startYear`,
        `endYear`,
        `itemOf`
    ]);
    return (0, $90cae257cc958273$exports.jsx)(`ol`, (0, $cc97c864ff2b6306$export$71511d61b312f219)((0, $f0029d1e20ae5566$export$71511d61b312f219)({
        className: `list-unstyled m-0 d-flex flex-wrap justify-content-center gap-3 ${a}`
    }, d), {
        children: Array.from({
            length: l - c + 1
        }, (e, t)=>{
            let n = l - t;
            if (n === 0) return null;
            let a = $246b1ea23ab1fccc$export$1ace452aebce17cb(n), { link: s = `#`, title: c } = (u == null ? void 0 : u(n, a)) || {};
            return (0, $90cae257cc958273$exports.jsx)(`li`, {
                className: o,
                children: (0, $90cae257cc958273$exports.jsxs)(`a`, {
                    className: `d-inline-block p-3 text-decoration-none text-center`,
                    href: s,
                    children: [
                        (0, $90cae257cc958273$exports.jsx)(`div`, {
                            className: `fs-1`,
                            children: a
                        }),
                        c
                    ]
                })
            }, n);
        })
    }));
};
$246b1ea23ab1fccc$export$de26cde43ba4c348.displayName = `ZodiacBar`;








var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


const $c11b08aed775893d$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $c11b08aed775893d$var$Feedback = /*#__PURE__*/ $5E6i4.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$c11b08aed775893d$var$Feedback.displayName = 'Feedback';
$c11b08aed775893d$var$Feedback.propTypes = $c11b08aed775893d$var$propTypes;
var $c11b08aed775893d$export$2e2bcd8739ae039 = $c11b08aed775893d$var$Feedback;




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
"use client";
// TODO
const $22131b45ca9ea368$var$FormContext = /*#__PURE__*/ $5E6i4.createContext({});
var $22131b45ca9ea368$export$2e2bcd8739ae039 = $22131b45ca9ea368$var$FormContext;




"use client";
const $680fd11e70935bb8$var$FormCheckInput = /*#__PURE__*/ $5E6i4.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$680fd11e70935bb8$var$FormCheckInput.displayName = 'FormCheckInput';
var $680fd11e70935bb8$export$2e2bcd8739ae039 = $680fd11e70935bb8$var$FormCheckInput;




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $12bce75ba63c266c$var$FormCheckLabel = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$12bce75ba63c266c$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $12bce75ba63c266c$export$2e2bcd8739ae039 = $12bce75ba63c266c$var$FormCheckLabel;





var $5E6i4 = parcelRequire("5E6i4");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $eeae8d80cf6d6e67$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $5E6i4.Children.map(children, (child)=>/*#__PURE__*/ $5E6i4.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $eeae8d80cf6d6e67$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $5E6i4.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $5E6i4.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $eeae8d80cf6d6e67$export$500fd6099226ffae(children, type) {
    return $5E6i4.Children.toArray(children).some((child)=>/*#__PURE__*/ $5E6i4.isValidElement(child) && child.type === type);
}



"use client";
const $20dbd8fe71826472$var$FormCheck = /*#__PURE__*/ $5E6i4.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    const innerFormContext = (0, $5E6i4.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $eeae8d80cf6d6e67$export$500fd6099226ffae)(children, (0, $12bce75ba63c266c$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $680fd11e70935bb8$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $22131b45ca9ea368$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $12bce75ba63c266c$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c11b08aed775893d$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$20dbd8fe71826472$var$FormCheck.displayName = 'FormCheck';
var $20dbd8fe71826472$export$2e2bcd8739ae039 = Object.assign($20dbd8fe71826472$var$FormCheck, {
    Input: (0, $680fd11e70935bb8$export$2e2bcd8739ae039),
    Label: (0, $12bce75ba63c266c$export$2e2bcd8739ae039)
});




var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $46af2c171947e24a$var$FormControl = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$46af2c171947e24a$var$FormControl.displayName = 'FormControl';
var $46af2c171947e24a$export$2e2bcd8739ae039 = Object.assign($46af2c171947e24a$var$FormControl, {
    Feedback: $c11b08aed775893d$export$2e2bcd8739ae039
});



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $782e1ff8cd85cc95$var$FormFloating = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$782e1ff8cd85cc95$var$FormFloating.displayName = 'FormFloating';
var $782e1ff8cd85cc95$export$2e2bcd8739ae039 = $782e1ff8cd85cc95$var$FormFloating;



var $5E6i4 = parcelRequire("5E6i4");


const $8ebe6b6f0f288bd9$var$FormGroup = /*#__PURE__*/ $5E6i4.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $5E6i4.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $22131b45ca9ea368$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$8ebe6b6f0f288bd9$var$FormGroup.displayName = 'FormGroup';
var $8ebe6b6f0f288bd9$export$2e2bcd8739ae039 = $8ebe6b6f0f288bd9$var$FormGroup;




var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $c58a390273e5d4f1$var$FormLabel = /*#__PURE__*/ $5E6i4.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$c58a390273e5d4f1$var$FormLabel.displayName = 'FormLabel';
var $c58a390273e5d4f1$export$2e2bcd8739ae039 = $c58a390273e5d4f1$var$FormLabel;




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $17baf109a48e2aaf$var$FormRange = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$17baf109a48e2aaf$var$FormRange.displayName = 'FormRange';
var $17baf109a48e2aaf$export$2e2bcd8739ae039 = $17baf109a48e2aaf$var$FormRange;




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $8d58fabc8b67da1e$var$FormSelect = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $5E6i4.useContext)((0, $22131b45ca9ea368$export$2e2bcd8739ae039));
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$8d58fabc8b67da1e$var$FormSelect.displayName = 'FormSelect';
var $8d58fabc8b67da1e$export$2e2bcd8739ae039 = $8d58fabc8b67da1e$var$FormSelect;




var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $06dea835f8d20dfb$var$FormText = /*#__PURE__*/ $5E6i4.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$06dea835f8d20dfb$var$FormText.displayName = 'FormText';
var $06dea835f8d20dfb$export$2e2bcd8739ae039 = $06dea835f8d20dfb$var$FormText;



var $5E6i4 = parcelRequire("5E6i4");


const $f1f7b2775c893985$var$Switch = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $20dbd8fe71826472$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$f1f7b2775c893985$var$Switch.displayName = 'Switch';
var $f1f7b2775c893985$export$2e2bcd8739ae039 = Object.assign($f1f7b2775c893985$var$Switch, {
    Input: (0, $20dbd8fe71826472$export$2e2bcd8739ae039).Input,
    Label: (0, $20dbd8fe71826472$export$2e2bcd8739ae039).Label
});




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $92c94c0167730b17$var$FloatingLabel = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $8ebe6b6f0f288bd9$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$92c94c0167730b17$var$FloatingLabel.displayName = 'FloatingLabel';
var $92c94c0167730b17$export$2e2bcd8739ae039 = $92c94c0167730b17$var$FloatingLabel;



const $feacaa078f2a172d$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $feacaa078f2a172d$var$Form = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, validated && 'was-validated')
    }));
$feacaa078f2a172d$var$Form.displayName = 'Form';
$feacaa078f2a172d$var$Form.propTypes = $feacaa078f2a172d$var$propTypes;
var $feacaa078f2a172d$export$2e2bcd8739ae039 = Object.assign($feacaa078f2a172d$var$Form, {
    Group: (0, $8ebe6b6f0f288bd9$export$2e2bcd8739ae039),
    Control: (0, $46af2c171947e24a$export$2e2bcd8739ae039),
    Floating: (0, $782e1ff8cd85cc95$export$2e2bcd8739ae039),
    Check: (0, $20dbd8fe71826472$export$2e2bcd8739ae039),
    Switch: $f1f7b2775c893985$export$2e2bcd8739ae039,
    Label: (0, $c58a390273e5d4f1$export$2e2bcd8739ae039),
    Text: (0, $06dea835f8d20dfb$export$2e2bcd8739ae039),
    Range: (0, $17baf109a48e2aaf$export$2e2bcd8739ae039),
    Select: (0, $8d58fabc8b67da1e$export$2e2bcd8739ae039),
    FloatingLabel: $92c94c0167730b17$export$2e2bcd8739ae039
});



var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $cbfb550032a4f94d$var$InputGroupText = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$cbfb550032a4f94d$var$InputGroupText.displayName = 'InputGroupText';
var $cbfb550032a4f94d$export$2e2bcd8739ae039 = $cbfb550032a4f94d$var$InputGroupText;



"use client";
const $915d79f60ae535f6$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $cbfb550032a4f94d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $680fd11e70935bb8$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $915d79f60ae535f6$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $cbfb550032a4f94d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $680fd11e70935bb8$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $915d79f60ae535f6$var$InputGroup = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $5E6i4.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $264fbddeaff05727$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$915d79f60ae535f6$var$InputGroup.displayName = 'InputGroup';
var $915d79f60ae535f6$export$2e2bcd8739ae039 = Object.assign($915d79f60ae535f6$var$InputGroup, {
    Text: (0, $cbfb550032a4f94d$export$2e2bcd8739ae039),
    Radio: $915d79f60ae535f6$var$InputGroupRadio,
    Checkbox: $915d79f60ae535f6$var$InputGroupCheckbox
});



var $90MBA = parcelRequire("90MBA");



var $90MBA = parcelRequire("90MBA");
var $9784173a5043df33$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9784173a5043df33$export$50b010be9260e56b = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info'
];
const $9784173a5043df33$export$b480d00b75c9ac2d = (raw)=>$9784173a5043df33$export$50b010be9260e56b[(0, $90MBA.sum)(...Array.from(raw, (char)=>char.charCodeAt(0))) % $9784173a5043df33$export$50b010be9260e56b.length];
const $9784173a5043df33$export$ef1c4106ceccca63 = (_a)=>{
    var { className: className = '', list: list, bgResolver: bgResolver = $9784173a5043df33$export$b480d00b75c9ac2d, onCheck: onCheck, onDelete: onDelete } = _a, props = $9784173a5043df33$var$__rest(_a, [
        "className",
        "list",
        "bgResolver",
        "onCheck",
        "onDelete"
    ]);
    return (0, $90cae257cc958273$exports.jsx)("ul", Object.assign({
        className: `list-unstyled m-0 d-flex flex-wrap gap-2 ${className}`
    }, props, {
        children: list.map(({ text: text, link: link }, index)=>(0, $90cae257cc958273$exports.jsxs)((0, $73919e3c2229bbf5$export$2e2bcd8739ae039), {
                bg: bgResolver(text),
                text: "white",
                as: "li",
                className: "d-flex align-items-center gap-2",
                children: [
                    link || URL.canParse(text) ? (0, $90cae257cc958273$exports.jsx)("a", {
                        className: "text-decoration-none text-white",
                        href: link || text,
                        children: text
                    }) : onCheck ? (0, $90cae257cc958273$exports.jsx)("button", {
                        type: "button",
                        className: "bg-transparent border-0 p-0",
                        onClick: ()=>onCheck({
                                text: text,
                                link: link
                            }, index),
                        children: text
                    }) : text,
                    onDelete && (0, $90cae257cc958273$exports.jsx)((0, $473e73a9cee47871$export$2e2bcd8739ae039), {
                        onClick: ()=>onDelete({
                                text: text,
                                link: link
                            }, index)
                    })
                ]
            }, text))
    }));
};
$9784173a5043df33$export$ef1c4106ceccca63.displayName = 'BadgeBar';













var $9c19bd5bfd1a1a58$var$size;
function $9c19bd5bfd1a1a58$export$2e2bcd8739ae039(recalc) {
    if (!$9c19bd5bfd1a1a58$var$size && $9c19bd5bfd1a1a58$var$size !== 0 || recalc) {
        if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9c19bd5bfd1a1a58$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9c19bd5bfd1a1a58$var$size;
}



var $5E6i4 = parcelRequire("5E6i4");
function $f81dd44925d92532$export$2e2bcd8739ae039() {
    return (0, $5E6i4.useState)(null);
}







var $5E6i4 = parcelRequire("5E6i4");

function $7928c6e4d5223063$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");


var $5E6i4 = parcelRequire("5E6i4");
function $fb8ed261afda04ed$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $5E6i4.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $5E6i4 = parcelRequire("5E6i4");
function $52c484bd95d5f0fd$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $fb8ed261afda04ed$export$2e2bcd8739ae039)(fn);
    (0, $5E6i4.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $759c7b0b1ff80779$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $1ff5bacc6a7985b3$export$1a88c12b8b979fa0 = (0, $02e0cc2db9791bde$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $1ff5bacc6a7985b3$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $759c7b0b1ff80779$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($1ff5bacc6a7985b3$export$1a88c12b8b979fa0, '');
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($1ff5bacc6a7985b3$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $1ff5bacc6a7985b3$export$2e2bcd8739ae039 = $1ff5bacc6a7985b3$var$ModalManager;







const $15f52dbe835585ae$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $15f52dbe835585ae$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $15f52dbe835585ae$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $15f52dbe835585ae$var$getManager(window) {
    if (!$15f52dbe835585ae$var$manager) $15f52dbe835585ae$var$manager = new (0, $1ff5bacc6a7985b3$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $15f52dbe835585ae$var$manager;
}
function $15f52dbe835585ae$var$useModalManager(provided) {
    const window = (0, $7f9b3515e43aba94$export$2e2bcd8739ae039)();
    const modalManager = provided || $15f52dbe835585ae$var$getManager(window);
    const modal = (0, $5E6i4.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $5E6i4.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $5E6i4.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $15f52dbe835585ae$var$Modal = /*#__PURE__*/ (0, $5E6i4.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $15f52dbe835585ae$var$_objectWithoutPropertiesLoose(_ref, $15f52dbe835585ae$var$_excluded);
    const ownerWindow = (0, $7f9b3515e43aba94$export$2e2bcd8739ae039)();
    const container = (0, $0bec21ed941556c3$export$2e2bcd8739ae039)(containerRef);
    const modal = $15f52dbe835585ae$var$useModalManager(providedManager);
    const isMounted = (0, $e1f7a97593772fdc$export$2e2bcd8739ae039)();
    const prevShow = (0, $86589b927684e763$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $5E6i4.useState)(!show);
    const lastFocusRef = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $5E6i4.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $5E6i4.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $52c484bd95d5f0fd$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $3d66457f2389a961$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $3d66457f2389a961$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $ac36aa99f6f4d073$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $5E6i4.useRef)();
    const removeKeydownListenerRef = (0, $5E6i4.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $5E6i4.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $314407abb5187ce9$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $314407abb5187ce9$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).createPortal(/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$15f52dbe835585ae$var$Modal.displayName = 'Modal';
var $15f52dbe835585ae$export$2e2bcd8739ae039 = Object.assign($15f52dbe835585ae$var$Modal, {
    Manager: (0, $1ff5bacc6a7985b3$export$2e2bcd8739ae039)
});



function $da42d038f708cdd8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $9bb1922ade4b5d1d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9bb1922ade4b5d1d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9bb1922ade4b5d1d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9bb1922ade4b5d1d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $bdbb8e930e207d28$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $bdbb8e930e207d28$var$BootstrapModalManager extends (0, $1ff5bacc6a7985b3$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $da42d038f708cdd8$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $9bb1922ade4b5d1d$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $bdbb8e930e207d28$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $bdbb8e930e207d28$var$sharedManager;
function $bdbb8e930e207d28$export$a03641438014b436(options) {
    if (!$bdbb8e930e207d28$var$sharedManager) $bdbb8e930e207d28$var$sharedManager = new $bdbb8e930e207d28$var$BootstrapModalManager(options);
    return $bdbb8e930e207d28$var$sharedManager;
}
var $bdbb8e930e207d28$export$2e2bcd8739ae039 = $bdbb8e930e207d28$var$BootstrapModalManager;




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $60eab12012b8117f$var$ModalBody = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$60eab12012b8117f$var$ModalBody.displayName = 'ModalBody';
var $60eab12012b8117f$export$2e2bcd8739ae039 = $60eab12012b8117f$var$ModalBody;



var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $ba10a10bdaa5f2e9$var$ModalContext = /*#__PURE__*/ $5E6i4.createContext({
    onHide () {}
});
var $ba10a10bdaa5f2e9$export$2e2bcd8739ae039 = $ba10a10bdaa5f2e9$var$ModalContext;




var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $071d45ad37ac6ac2$var$ModalDialog = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$071d45ad37ac6ac2$var$ModalDialog.displayName = 'ModalDialog';
var $071d45ad37ac6ac2$export$2e2bcd8739ae039 = $071d45ad37ac6ac2$var$ModalDialog;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $b20bc0cc34c6b3ef$var$ModalFooter = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$b20bc0cc34c6b3ef$var$ModalFooter.displayName = 'ModalFooter';
var $b20bc0cc34c6b3ef$export$2e2bcd8739ae039 = $b20bc0cc34c6b3ef$var$ModalFooter;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $c1755f65f309a103$var$AbstractModalHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $5E6i4.useContext)((0, $ba10a10bdaa5f2e9$export$2e2bcd8739ae039));
    const handleClick = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $473e73a9cee47871$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$c1755f65f309a103$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $c1755f65f309a103$export$2e2bcd8739ae039 = $c1755f65f309a103$var$AbstractModalHeader;



"use client";
const $3579bc8a4221072c$var$ModalHeader = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c1755f65f309a103$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$3579bc8a4221072c$var$ModalHeader.displayName = 'ModalHeader';
var $3579bc8a4221072c$export$2e2bcd8739ae039 = $3579bc8a4221072c$var$ModalHeader;



var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $3e0330e62ffd67b4$var$DivStyledAsH4 = (0, $1dc04b355c812538$export$2e2bcd8739ae039)('h4');
const $3e0330e62ffd67b4$var$ModalTitle = /*#__PURE__*/ $5E6i4.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $3e0330e62ffd67b4$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$3e0330e62ffd67b4$var$ModalTitle.displayName = 'ModalTitle';
var $3e0330e62ffd67b4$export$2e2bcd8739ae039 = $3e0330e62ffd67b4$var$ModalTitle;




"use client";
function $96a8772939a28a36$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e50dbcc016964135$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $96a8772939a28a36$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e50dbcc016964135$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $96a8772939a28a36$var$Modal = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $071d45ad37ac6ac2$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $5E6i4.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $5E6i4.useState)(false);
    const waitingForMouseUpRef = (0, $5E6i4.useRef)(false);
    const ignoreBackdropClickRef = (0, $5E6i4.useRef)(false);
    const removeStaticModalAnimationRef = (0, $5E6i4.useRef)(null);
    const [modal, setModalRef] = (0, $f81dd44925d92532$export$2e2bcd8739ae039)();
    const mergedRef = (0, $1a92d947f5cf0eee$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $78821005c47d14e8$export$35e511eefa30ac5a)();
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $5E6i4.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $bdbb8e930e207d28$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $e4a530e80e5cf664$export$2e2bcd8739ae039)(()=>{
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $5E6i4.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ba10a10bdaa5f2e9$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $15f52dbe835585ae$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $96a8772939a28a36$var$DialogTransition : undefined,
            backdropTransition: animation ? $96a8772939a28a36$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$96a8772939a28a36$var$Modal.displayName = 'Modal';
var $96a8772939a28a36$export$2e2bcd8739ae039 = Object.assign($96a8772939a28a36$var$Modal, {
    Body: (0, $60eab12012b8117f$export$2e2bcd8739ae039),
    Header: (0, $3579bc8a4221072c$export$2e2bcd8739ae039),
    Title: (0, $3e0330e62ffd67b4$export$2e2bcd8739ae039),
    Footer: (0, $b20bc0cc34c6b3ef$export$2e2bcd8739ae039),
    Dialog: (0, $071d45ad37ac6ac2$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $90MBA = parcelRequire("90MBA");
var $a1ff59d56cac60f5$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $a1ff59d56cac60f5$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $a1ff59d56cac60f5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1ff59d56cac60f5$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $a1ff59d56cac60f5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a1ff59d56cac60f5$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a1ff59d56cac60f5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $a1ff59d56cac60f5$export$4a96334d5925dbf2 = (()=>{
    var _ImagePreview_downloading_accessor_storage, _ImagePreview_loadedPath_accessor_storage, _ImagePreview_viewing_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _loadedPath_decorators;
    let _loadedPath_initializers = [];
    let _loadedPath_extraInitializers = [];
    let _viewing_decorators;
    let _viewing_initializers = [];
    let _viewing_extraInitializers = [];
    let _init_decorators;
    var ImagePreview = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _ImagePreview_downloading_accessor_storage.set(this, ($a1ff59d56cac60f5$var$__runInitializers(this, _instanceExtraInitializers), $a1ff59d56cac60f5$var$__runInitializers(this, _downloading_initializers, false)));
            _ImagePreview_loadedPath_accessor_storage.set(this, ($a1ff59d56cac60f5$var$__runInitializers(this, _downloading_extraInitializers), $a1ff59d56cac60f5$var$__runInitializers(this, _loadedPath_initializers, '')));
            _ImagePreview_viewing_accessor_storage.set(this, ($a1ff59d56cac60f5$var$__runInitializers(this, _loadedPath_extraInitializers), $a1ff59d56cac60f5$var$__runInitializers(this, _viewing_initializers, false)));
            Object.defineProperty(this, "objectURL", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($a1ff59d56cac60f5$var$__runInitializers(this, _viewing_extraInitializers), '')
            });
        }
        get downloading() {
            return $a1ff59d56cac60f5$var$__classPrivateFieldGet(this, _ImagePreview_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $a1ff59d56cac60f5$var$__classPrivateFieldSet(this, _ImagePreview_downloading_accessor_storage, value, "f");
        }
        get loadedPath() {
            return $a1ff59d56cac60f5$var$__classPrivateFieldGet(this, _ImagePreview_loadedPath_accessor_storage, "f");
        }
        set loadedPath(value) {
            $a1ff59d56cac60f5$var$__classPrivateFieldSet(this, _ImagePreview_loadedPath_accessor_storage, value, "f");
        }
        get viewing() {
            return $a1ff59d56cac60f5$var$__classPrivateFieldGet(this, _ImagePreview_viewing_accessor_storage, "f");
        }
        set viewing(value) {
            $a1ff59d56cac60f5$var$__classPrivateFieldSet(this, _ImagePreview_viewing_accessor_storage, value, "f");
        }
        componentDidMount() {
            super.componentDidMount();
            this.init();
        }
        init() {
            const { src: src } = this.observedProps;
            if (this.objectURL) {
                URL.revokeObjectURL(this.objectURL);
                this.objectURL = '';
            }
            this.loadedPath = '';
            if (src instanceof Blob) {
                this.objectURL = URL.createObjectURL(src);
                this.load(this.objectURL);
            } else if (src) this.load(src);
        }
        componentWillUnmount() {
            if (this.objectURL) URL.revokeObjectURL(this.objectURL);
        }
        load(path) {
            return $a1ff59d56cac60f5$var$__awaiter(this, void 0, void 0, function*() {
                this.downloading = true;
                try {
                    yield new Promise((resolve, reject)=>{
                        const image = new globalThis.Image();
                        image.onload = resolve;
                        image.onerror = reject;
                        image.src = path;
                    });
                    this.loadedPath = path;
                } finally{
                    this.downloading = false;
                }
            });
        }
        render() {
            const { downloading: downloading, loadedPath: loadedPath, viewing: viewing } = this, _a = this.props, { className: className, loading: loading, src: src, fluid: fluid, rounded: rounded, roundedCircle: roundedCircle, thumbnail: thumbnail } = _a, props = $a1ff59d56cac60f5$var$__rest(_a, [
                "className",
                "loading",
                "src",
                "fluid",
                "rounded",
                "roundedCircle",
                "thumbnail"
            ]);
            return (0, $90cae257cc958273$exports.jsxs)("div", Object.assign({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('m-0', downloading && 'd-flex justify-content-center align-items-center', className)
            }, props, {
                children: [
                    downloading ? (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {}) : loadedPath && (0, $90cae257cc958273$exports.jsx)((0, $82fa4ab13bb8a9e3$export$2e2bcd8739ae039), {
                        className: "object-fit-contain",
                        loading: loading,
                        fluid: fluid,
                        rounded: rounded,
                        roundedCircle: roundedCircle,
                        thumbnail: thumbnail,
                        src: loadedPath,
                        onClick: ()=>this.viewing = true
                    }),
                    (0, $90cae257cc958273$exports.jsxs)((0, $96a8772939a28a36$export$2e2bcd8739ae039), {
                        centered: true,
                        show: viewing,
                        onHide: ()=>this.viewing = false,
                        children: [
                            (0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039).Body, {
                                className: "text-center",
                                children: (0, $90cae257cc958273$exports.jsx)((0, $82fa4ab13bb8a9e3$export$2e2bcd8739ae039), {
                                    fluid: true,
                                    src: loadedPath
                                })
                            }),
                            (0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039).Footer, {
                                className: "justify-content-center",
                                as: "a",
                                href: loadedPath,
                                target: "_blank",
                                download: (0, $90MBA.fileNameOf)(loadedPath),
                                children: loadedPath
                            })
                        ]
                    })
                ]
            }));
        }
    };
    _ImagePreview_downloading_accessor_storage = new WeakMap();
    _ImagePreview_loadedPath_accessor_storage = new WeakMap();
    _ImagePreview_viewing_accessor_storage = new WeakMap();
    $a1ff59d56cac60f5$var$__setFunctionName(_classThis, "ImagePreview");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _downloading_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _loadedPath_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _viewing_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _init_decorators = [
            (0, $85705ec7803c1445$export$7203b476385689ae)(({ observedProps: { src: src } })=>src)
        ];
        $a1ff59d56cac60f5$var$__esDecorate(_classThis, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $a1ff59d56cac60f5$var$__esDecorate(_classThis, null, _loadedPath_decorators, {
            kind: "accessor",
            name: "loadedPath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedPath" in obj,
                get: (obj)=>obj.loadedPath,
                set: (obj, value)=>{
                    obj.loadedPath = value;
                }
            },
            metadata: _metadata
        }, _loadedPath_initializers, _loadedPath_extraInitializers);
        $a1ff59d56cac60f5$var$__esDecorate(_classThis, null, _viewing_decorators, {
            kind: "accessor",
            name: "viewing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"viewing" in obj,
                get: (obj)=>obj.viewing,
                set: (obj, value)=>{
                    obj.viewing = value;
                }
            },
            metadata: _metadata
        }, _viewing_initializers, _viewing_extraInitializers);
        $a1ff59d56cac60f5$var$__esDecorate(_classThis, null, _init_decorators, {
            kind: "method",
            name: "init",
            static: false,
            private: false,
            access: {
                has: (obj)=>"init" in obj,
                get: (obj)=>obj.init
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1ff59d56cac60f5$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ImagePreview = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'ImagePreview'
    });
    (()=>{
        $a1ff59d56cac60f5$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ImagePreview = _classThis;
})();




var $90MBA = parcelRequire("90MBA");

var $c3e520f711d060ed$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c3e520f711d060ed$export$a127194569a41afb = (_a)=>{
    var { className: className = '', style: style, hidden: hidden, type: type, path: path, file: file } = _a, props = $c3e520f711d060ed$var$__rest(_a, [
        "className",
        "style",
        "hidden",
        "type",
        "path",
        "file"
    ]);
    if (!file && !path) throw new URIError('No file or path provided');
    const { name: name, category: category, extension: extension } = file instanceof EventTarget ? {
        category: type === null || type === void 0 ? void 0 : type.split('/')[0]
    } : (0, $90MBA.fileMetaOf)(file || path || '');
    return (0, $90cae257cc958273$exports.jsx)("figure", {
        className: `d-flex flex-column align-items-center justify-content-center m-0 ${className}`,
        style: style,
        hidden: hidden,
        children: category === 'image' ? (0, $90cae257cc958273$exports.jsx)((0, $a1ff59d56cac60f5$export$4a96334d5925dbf2), Object.assign({
            className: "h-100",
            fluid: true,
            loading: "lazy",
            src: file instanceof Blob ? file : path
        }, props)) : category === 'audio' ? (0, $90cae257cc958273$exports.jsx)("audio", Object.assign({
            controls: true,
            src: path,
            ref: (node)=>{
                if (node) node.srcObject = file || null;
            }
        }, props)) : category === 'video' ? (0, $90cae257cc958273$exports.jsx)("video", Object.assign({
            muted: true,
            src: path,
            ref: (node)=>{
                if (node) node.srcObject = file || null;
            },
            onMouseEnter: ({ currentTarget: currentTarget })=>currentTarget.play(),
            onMouseLeave: ({ currentTarget: currentTarget })=>currentTarget.pause()
        }, props)) : (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
            children: [
                (0, $90cae257cc958273$exports.jsx)("a", Object.assign({
                    className: "d-inline-flex justify-content-center align-items-center",
                    href: path,
                    target: "_blank",
                    download: name
                }, props, {
                    children: (0, $90cae257cc958273$exports.jsx)("i", {
                        className: `bi bi-filetype-${extension || 'file-earmark'} fs-1`
                    })
                })),
                (0, $90cae257cc958273$exports.jsx)("figcaption", {
                    className: "mw-100 text-wrap text-truncate",
                    children: name
                })
            ]
        })
    });
};
$c3e520f711d060ed$export$a127194569a41afb.displayName = 'FilePreview';








var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $75dff33a31c871e7$var$ButtonGroup = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$75dff33a31c871e7$var$ButtonGroup.displayName = 'ButtonGroup';
var $75dff33a31c871e7$export$2e2bcd8739ae039 = $75dff33a31c871e7$var$ButtonGroup;



var $90MBA = parcelRequire("90MBA");

var $fa512bfa69a3f06d$export$dff8b0850021a04b;
var $fa512bfa69a3f06d$export$f727f52c778e92d5;
$fa512bfa69a3f06d$export$dff8b0850021a04b = `h8YR4W_filePicker`;
$fa512bfa69a3f06d$export$f727f52c778e92d5 = `h8YR4W_toolbar`;


var $62eeafa9ec804a03$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $62eeafa9ec804a03$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $62eeafa9ec804a03$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62eeafa9ec804a03$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $62eeafa9ec804a03$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $62eeafa9ec804a03$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $62eeafa9ec804a03$var$blobCache = new WeakMap();
let $62eeafa9ec804a03$export$54dc470bcc5c41d1 = (()=>{
    var _FilePicker_changeFile, _FilePicker_file_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    let _instanceExtraInitializers = [];
    let _file_decorators;
    let _file_initializers = [];
    let _file_extraInitializers = [];
    let _get_fileType_decorators;
    let _get_filePath_decorators;
    let _restoreFile_decorators;
    var FilePicker = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FilePicker_file_accessor_storage.set(this, ($62eeafa9ec804a03$var$__runInitializers(this, _instanceExtraInitializers), $62eeafa9ec804a03$var$__runInitializers(this, _file_initializers, void 0)));
            _FilePicker_changeFile.set(this, ($62eeafa9ec804a03$var$__runInitializers(this, _file_extraInitializers), (data)=>{
                this.file = data;
                if (data) {
                    this.innerValue = data;
                    $62eeafa9ec804a03$var$blobCache.set(data, URL.createObjectURL(data));
                } else if (this.value) {
                    const { innerValue: innerValue } = this;
                    if (typeof innerValue === 'string' && innerValue.startsWith('blob:')) URL.revokeObjectURL(innerValue);
                    else if (innerValue instanceof File) $62eeafa9ec804a03$var$blobCache.delete(innerValue);
                    this.innerValue = '';
                }
            }));
        }
        get file() {
            return $62eeafa9ec804a03$var$__classPrivateFieldGet(this, _FilePicker_file_accessor_storage, "f");
        }
        set file(value) {
            $62eeafa9ec804a03$var$__classPrivateFieldSet(this, _FilePicker_file_accessor_storage, value, "f");
        }
        get fileType() {
            const { accept: accept } = this.observedProps, { file: file, filePath: filePath } = this;
            return (0, $90MBA.fileMetaOf)(file || filePath || '').type || accept;
        }
        get filePath() {
            const { value: value } = this;
            return typeof value === 'string' ? value : value && $62eeafa9ec804a03$var$blobCache.get(value);
        }
        restoreFile(data) {
            return $62eeafa9ec804a03$var$__awaiter(this, void 0, void 0, function*() {
                if (typeof data === 'string') try {
                    const blob = yield (0, $90MBA.blobOf)(data), name = (0, $90MBA.fileNameOf)(data);
                    const file = new File([
                        blob
                    ], name, {
                        type: blob.type
                    });
                    $62eeafa9ec804a03$var$blobCache.set(file, data);
                    return this.file = file;
                } catch (_a) {}
                if (data instanceof File) {
                    if (!$62eeafa9ec804a03$var$blobCache.has(data)) $62eeafa9ec804a03$var$blobCache.set(data, URL.createObjectURL(data));
                    return this.file = data;
                }
                return this.file = undefined;
            });
        }
        componentDidMount() {
            super.componentDidMount();
            this.restoreFile(this.value);
        }
        renderInput() {
            const { id: id, name: name, value: value, required: required, disabled: disabled, accept: accept, multiple: multiple } = this.props, { filePath: filePath } = this;
            return (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    (0, $90cae257cc958273$exports.jsx)("input", {
                        ref: this.ref,
                        className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                        type: "file",
                        name: value ? undefined : name,
                        required: !value && required,
                        id: id,
                        disabled: disabled,
                        accept: accept,
                        multiple: multiple,
                        onChange: ({ currentTarget: { files: files } })=>$62eeafa9ec804a03$var$__classPrivateFieldGet(this, _FilePicker_changeFile, "f").call(this, files === null || files === void 0 ? void 0 : files[0])
                    }),
                    filePath && (0, $90cae257cc958273$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: filePath
                    })
                ]
            });
        }
        render() {
            const { file: file, filePath: filePath, fileType: fileType } = this, { className: className = '', style: style, onView: onView } = this.props;
            return (0, $90cae257cc958273$exports.jsxs)("div", {
                className: `d-inline-block border rounded position-relative ${$fa512bfa69a3f06d$export$dff8b0850021a04b} ${className}`,
                style: Object.assign({
                    width: '10rem',
                    height: '10rem'
                }, style),
                children: [
                    filePath ? (0, $90cae257cc958273$exports.jsx)((0, $c3e520f711d060ed$export$a127194569a41afb), {
                        className: "w-100 h-100",
                        type: fileType,
                        path: filePath,
                        file: file
                    }) : (0, $90cae257cc958273$exports.jsx)("div", {
                        className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                        children: "+"
                    }),
                    this.renderInput(),
                    filePath && (0, $90cae257cc958273$exports.jsxs)((0, $75dff33a31c871e7$export$2e2bcd8739ae039), {
                        className: `position-absolute top-0 end-0 ${$fa512bfa69a3f06d$export$f727f52c778e92d5}`,
                        size: "sm",
                        children: [
                            onView && (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                onClick: ()=>onView({
                                        path: filePath,
                                        file: file
                                    }),
                                children: (0, $90cae257cc958273$exports.jsx)("i", {
                                    className: "bi bi-eye-fill"
                                })
                            }),
                            (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                onClick: ()=>$62eeafa9ec804a03$var$__classPrivateFieldGet(this, _FilePicker_changeFile, "f").call(this),
                                children: (0, $90cae257cc958273$exports.jsx)("i", {
                                    className: "bi bi-x-lg"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    };
    _FilePicker_changeFile = new WeakMap();
    _FilePicker_file_accessor_storage = new WeakMap();
    $62eeafa9ec804a03$var$__setFunctionName(_classThis, "FilePicker");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _file_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_fileType_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_filePath_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _restoreFile_decorators = [
            (0, $85705ec7803c1445$export$7203b476385689ae)(({ value: value })=>value)
        ];
        $62eeafa9ec804a03$var$__esDecorate(_classThis, null, _file_decorators, {
            kind: "accessor",
            name: "file",
            static: false,
            private: false,
            access: {
                has: (obj)=>"file" in obj,
                get: (obj)=>obj.file,
                set: (obj, value)=>{
                    obj.file = value;
                }
            },
            metadata: _metadata
        }, _file_initializers, _file_extraInitializers);
        $62eeafa9ec804a03$var$__esDecorate(_classThis, null, _get_fileType_decorators, {
            kind: "getter",
            name: "fileType",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fileType" in obj,
                get: (obj)=>obj.fileType
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $62eeafa9ec804a03$var$__esDecorate(_classThis, null, _get_filePath_decorators, {
            kind: "getter",
            name: "filePath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filePath" in obj,
                get: (obj)=>obj.filePath
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $62eeafa9ec804a03$var$__esDecorate(_classThis, null, _restoreFile_decorators, {
            kind: "method",
            name: "restoreFile",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreFile" in obj,
                get: (obj)=>obj.restoreFile
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $62eeafa9ec804a03$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FilePicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'FilePicker'
    });
    (()=>{
        $62eeafa9ec804a03$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FilePicker = _classThis;
})();








var $90MBA = parcelRequire("90MBA");
var $de456f6144383cb5$exports = {};

$parcel$export($de456f6144383cb5$exports, "promisifyRequest", () => $de456f6144383cb5$export$b327150396135fe7);
$parcel$export($de456f6144383cb5$exports, "createStore", () => $de456f6144383cb5$export$f51a9068ac82ea43);
$parcel$export($de456f6144383cb5$exports, "get", () => $de456f6144383cb5$export$3988ae62b71be9a3);
$parcel$export($de456f6144383cb5$exports, "set", () => $de456f6144383cb5$export$adaa4cf7ef1b65be);
$parcel$export($de456f6144383cb5$exports, "setMany", () => $de456f6144383cb5$export$daa0a5170277c7a8);
$parcel$export($de456f6144383cb5$exports, "getMany", () => $de456f6144383cb5$export$5df405cccea42673);
$parcel$export($de456f6144383cb5$exports, "update", () => $de456f6144383cb5$export$722fbec263ad908a);
$parcel$export($de456f6144383cb5$exports, "del", () => $de456f6144383cb5$export$1d2f21e549771e67);
$parcel$export($de456f6144383cb5$exports, "delMany", () => $de456f6144383cb5$export$c8aa84257229cac8);
$parcel$export($de456f6144383cb5$exports, "clear", () => $de456f6144383cb5$export$42ffd38884aecdac);
$parcel$export($de456f6144383cb5$exports, "keys", () => $de456f6144383cb5$export$ed97f33186d4b816);
$parcel$export($de456f6144383cb5$exports, "values", () => $de456f6144383cb5$export$68c286be0e7e55b7);
$parcel$export($de456f6144383cb5$exports, "entries", () => $de456f6144383cb5$export$3e9f948b41964866);
function $de456f6144383cb5$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $de456f6144383cb5$export$f51a9068ac82ea43(dbName, storeName) {
    let dbp;
    const getDB = ()=>{
        if (dbp) return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        dbp = $de456f6144383cb5$export$b327150396135fe7(request);
        dbp.then((db)=>{
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = ()=>dbp = undefined;
        }, ()=>{
            dbp = undefined;
        });
        return dbp;
    };
    return (txMode, callback)=>getDB().then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $de456f6144383cb5$var$defaultGetStoreFunc;
function $de456f6144383cb5$var$defaultGetStore() {
    if (!$de456f6144383cb5$var$defaultGetStoreFunc) $de456f6144383cb5$var$defaultGetStoreFunc = $de456f6144383cb5$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $de456f6144383cb5$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$3988ae62b71be9a3(key, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$de456f6144383cb5$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$adaa4cf7ef1b65be(key, value, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$daa0a5170277c7a8(entries, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$5df405cccea42673(keys, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$de456f6144383cb5$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$722fbec263ad908a(key, updater, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            const req = store.get(key);
            req.onsuccess = function() {
                try {
                    store.put(updater(req.result), key);
                    resolve($de456f6144383cb5$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
            req.onerror = ()=>reject(req.error);
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$1d2f21e549771e67(key, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$c8aa84257229cac8(keys, customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$42ffd38884aecdac(customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
    });
}
function $de456f6144383cb5$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $de456f6144383cb5$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$ed97f33186d4b816(customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $de456f6144383cb5$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $de456f6144383cb5$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$68c286be0e7e55b7(customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $de456f6144383cb5$export$b327150396135fe7(store.getAll());
        const items = [];
        return $de456f6144383cb5$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $de456f6144383cb5$export$3e9f948b41964866(customStore = $de456f6144383cb5$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $de456f6144383cb5$export$b327150396135fe7(store.getAllKeys()),
            $de456f6144383cb5$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return $de456f6144383cb5$var$eachCursor(store, (cursor)=>items.push([
                cursor.key,
                cursor.value
            ])).then(()=>items);
    });
}


function $fccfef6af501b9ae$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $fccfef6af501b9ae$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $fccfef6af501b9ae$var$$082ef78710a13331$exports = {};
var $fccfef6af501b9ae$var$$80184bab4212ab17$exports = {};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$exports = {};
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $fccfef6af501b9ae$export$e03c1c3201ee8bb7;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $fccfef6af501b9ae$export$6287f85d0f6a9342;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $fccfef6af501b9ae$export$d1e7755b007c0847;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "persist", function() {
    return $fccfef6af501b9ae$export$9a6132153fba2e0;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "restore", function() {
    return $fccfef6af501b9ae$export$db239ef39aadc7fe;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $fccfef6af501b9ae$export$b1fb4cac938035f7;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $fccfef6af501b9ae$export$8001d3a0cfa5d8fd;
});
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fccfef6af501b9ae$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === 'number' ? --value : false);
                }
            });
        };
}
function $fccfef6af501b9ae$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') return new Notification(typeof message === 'function' ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
class $fccfef6af501b9ae$export$d1e7755b007c0847 {
    constructor(meta){
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    static detectIDB() {
        return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            if (this.readyIDB) return this.readyIDB;
            const { get: get } = yield $de456f6144383cb5$exports;
            return this.readyIDB = get('ready');
        });
    }
    save(storeKey, value) {
        return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (value != null) this.value = (0, $7c1ccfb859bb0dff$export$f08965dd1304d490)((_b = yield (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)) !== null && _b !== void 0 ? _b : value);
            const { set: set } = yield $de456f6144383cb5$exports, data = {
                value: this.value,
                expireAt: this.expireIn + Date.now()
            };
            return set(`${storeKey}-${this.key}`, data);
        });
    }
    load(storeKey) {
        return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const { get: get, del: del } = yield $de456f6144383cb5$exports;
            storeKey += `-${this.key}`;
            const { value: value, expireAt: expireAt } = (_a = yield get(storeKey)) !== null && _a !== void 0 ? _a : {};
            if (expireAt && expireAt < Date.now()) {
                delete this.value;
                return del(storeKey);
            }
            this.value = value;
            return (_c = value != null ? yield (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value) : value) !== null && _c !== void 0 ? _c : value;
        });
    }
    destroy(storeKey) {
        return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            (_a = this.disposer) === null || _a === void 0 || _a.call(this);
            const { del: del } = yield $de456f6144383cb5$exports;
            return del(`${storeKey}-${this.key}`);
        });
    }
}
const $fccfef6af501b9ae$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $fccfef6af501b9ae$export$9a6132153fba2e0(_a = {}) {
    var { expireIn: expireIn = Infinity } = _a, meta = $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $fccfef6af501b9ae$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $fccfef6af501b9ae$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $fccfef6af501b9ae$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $fccfef6af501b9ae$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield $fccfef6af501b9ae$export$d1e7755b007c0847.detectIDB();
        } catch (_a) {
            return console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.');
        }
        const list = $fccfef6af501b9ae$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
        for (const item of list){
            const { key: key } = item, value = yield item.load(storeKey);
            if (value != null) {
                Reflect.set(classInstance, key, value);
                restoredData[key] = value;
            }
            item.disposer = (0, $7c1ccfb859bb0dff$export$7203b476385689ae)(()=>classInstance[key], (value)=>item.save(storeKey, value));
        }
        if ((0, $90MBA.isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $fccfef6af501b9ae$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $fccfef6af501b9ae$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
        for (const node of list)yield node.destroy(storeKey);
    });
}
function $fccfef6af501b9ae$export$8001d3a0cfa5d8fd({ storeKey: storeKey, expireIn: expireIn = Infinity } = {}) {
    return (Super, {})=>(()=>{
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            let _classSuper = Super;
            let _pageIndex_decorators;
            let _pageIndex_initializers = [];
            let _pageIndex_extraInitializers = [];
            let _pageSize_decorators;
            let _pageSize_initializers = [];
            let _pageSize_extraInitializers = [];
            let _filter_decorators;
            let _filter_initializers = [];
            let _filter_extraInitializers = [];
            let _totalCount_decorators;
            let _totalCount_initializers = [];
            let _totalCount_extraInitializers = [];
            let _pageList_decorators;
            let _pageList_initializers = [];
            let _pageList_extraInitializers = [];
            return _a = class PersistListModel extends _classSuper {
                constructor(){
                    super(...arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(this, $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(this, ($fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_extraInitializers), $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(this, ($fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_extraInitializers), $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(this, ($fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_extraInitializers), $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(this, ($fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_extraInitializers), $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_initializers, [])));
                    Object.defineProperty(this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($fccfef6af501b9ae$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_extraInitializers), globalThis.indexedDB && $fccfef6af501b9ae$export$db239ef39aadc7fe(this, typeof storeKey === 'function' ? storeKey(this) : storeKey))
                    });
                }
                get pageIndex() {
                    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                }
                set pageIndex(value) {
                    $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                }
                get pageSize() {
                    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                }
                set pageSize(value) {
                    $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                }
                get filter() {
                    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                }
                set filter(value) {
                    $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                }
                get totalCount() {
                    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                }
                set totalCount(value) {
                    $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                }
                get pageList() {
                    return $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                }
                set pageList(value) {
                    $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                }
            }, _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), (()=>{
                var _b;
                const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $fccfef6af501b9ae$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
                ];
                _pageSize_decorators = [
                    $fccfef6af501b9ae$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
                ];
                _filter_decorators = [
                    $fccfef6af501b9ae$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
                ];
                _totalCount_decorators = [
                    $fccfef6af501b9ae$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
                ];
                _pageList_decorators = [
                    $fccfef6af501b9ae$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
                ];
                $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageIndex" in obj,
                        get: (obj)=>obj.pageIndex,
                        set: (obj, value)=>{
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageSize" in obj,
                        get: (obj)=>obj.pageSize,
                        set: (obj, value)=>{
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"filter" in obj,
                        get: (obj)=>obj.filter,
                        set: (obj, value)=>{
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"totalCount" in obj,
                        get: (obj)=>obj.totalCount,
                        set: (obj, value)=>{
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $fccfef6af501b9ae$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageList" in obj,
                        get: (obj)=>obj.pageList,
                        set: (obj, value)=>{
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            })(), _a;
        })();
}
$fccfef6af501b9ae$var$$parcel$exportWildcard($fccfef6af501b9ae$var$$082ef78710a13331$exports, $fccfef6af501b9ae$var$$80184bab4212ab17$exports);
$fccfef6af501b9ae$var$$parcel$exportWildcard($fccfef6af501b9ae$var$$082ef78710a13331$exports, $fccfef6af501b9ae$var$$400caf514fe4dd82$exports);
var $fccfef6af501b9ae$var$$16892940cfb7bd51$exports = {};
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $fccfef6af501b9ae$export$d12e20a4eec10acf;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $fccfef6af501b9ae$export$673dbc4a8d0cb20a;
});
var $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $fccfef6af501b9ae$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _uploading_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _clear_decorators = [
            (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
        ];
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $fccfef6af501b9ae$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $fccfef6af501b9ae$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _clearCurrent_decorators = [
            (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
        ];
        _updateOne_decorators = [
            $fccfef6af501b9ae$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $fccfef6af501b9ae$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $fccfef6af501b9ae$export$e03c1c3201ee8bb7('uploading')
        ];
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$exports = {};
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $fccfef6af501b9ae$export$36e5777a1ba4b7c3;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $fccfef6af501b9ae$export$a143d493d941bafc;
});
$fccfef6af501b9ae$var$$parcel$export($fccfef6af501b9ae$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $fccfef6af501b9ae$export$6a4eb2e7fc9e8903;
});
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await = function(v) {
    return this instanceof $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await(v);
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $fccfef6af501b9ae$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    let _classSuper = $fccfef6af501b9ae$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            Object.defineProperty(this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers), this.getAllInStream)
            });
        }
        get pageIndex() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $7c1ccfb859bb0dff$export$f08965dd1304d490)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $90MBA.splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $90MBA.splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAllInStream() {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function* getAllInStream_1(filter = this.filter, pageSize = this.pageSize) {
                this.pageIndex = 0;
                while(!this.noMore)yield $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await((yield* $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncDelegator($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__asyncValues((yield $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize)))))));
            });
        }
        getAll(filter = this.filter, pageSize = this.pageSize) {
            return Array.fromAsync(this.getAllInStream(filter, pageSize));
        }
        countAll(keys_1) {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $90MBA.countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _pageSize_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _filter_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _totalCount_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _pageList_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _get_currentPage_decorators = [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
    ], _get_pageCount_decorators = [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
    ], _get_allItems_decorators = [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
    ], _get_noMore_decorators = [
        (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
    ], _statistic_decorators = [
        (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
    ], _clearList_decorators = [
        (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
    ], _restoreList_decorators = [
        (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
    ], _turnTo_decorators = [
        (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
    ], _getList_decorators = [
        $fccfef6af501b9ae$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), (()=>{
        var _c;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $fccfef6af501b9ae$export$e03c1c3201ee8bb7('uploading')
        ];
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $fccfef6af501b9ae$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97),
                $fccfef6af501b9ae$export$e03c1c3201ee8bb7('downloading')
            ];
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $fccfef6af501b9ae$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $90MBA.splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $fccfef6af501b9ae$export$e03c1c3201ee8bb7('downloading')
            ];
            $fccfef6af501b9ae$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}



var $39904e2d513e8a93$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $39904e2d513e8a93$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $39904e2d513e8a93$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $39904e2d513e8a93$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $39904e2d513e8a93$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $39904e2d513e8a93$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $39904e2d513e8a93$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $39904e2d513e8a93$export$424c8de2e117ab22 = (()=>{
    var _a, _FileModel_files_accessor_storage;
    let _classSuper = (0, $fccfef6af501b9ae$export$d12e20a4eec10acf);
    let _files_decorators;
    let _files_initializers = [];
    let _files_extraInitializers = [];
    return _a = class FileModel extends _classSuper {
        get files() {
            return $39904e2d513e8a93$var$__classPrivateFieldGet(this, _FileModel_files_accessor_storage, "f");
        }
        set files(value) {
            $39904e2d513e8a93$var$__classPrivateFieldSet(this, _FileModel_files_accessor_storage, value, "f");
        }
        clear() {
            super.clear();
            this.files = [];
        }
        /**
             * Override this method for Network calling,
             * then call `super.upload(fileURL)` to update `this.files` array.
             */ upload(file) {
            return $39904e2d513e8a93$var$__awaiter(this, void 0, void 0, function*() {
                if (file instanceof Blob) file = URL.createObjectURL(file);
                const { files: files } = this;
                if (!files.includes(file)) this.files = [
                    ...files,
                    file
                ];
                return file;
            });
        }
        /**
             * Override this method for Network calling,
             * then call `super.delete(fileURL)` to update `this.files` array.
             */ delete(file) {
            return $39904e2d513e8a93$var$__awaiter(this, void 0, void 0, function*() {
                const { files: files } = this;
                const index = files.indexOf(file);
                this.files = [
                    ...files.slice(0, index),
                    ...files.slice(index + 1)
                ];
            });
        }
        move(sourceIndex, targetIndex) {
            const { files: files } = this;
            const sourceFile = files[sourceIndex], targetFile = files[targetIndex];
            const frontIndex = Math.min(sourceIndex, targetIndex), backIndex = Math.max(sourceIndex, targetIndex);
            const front = files.slice(0, frontIndex), middle = files.slice(frontIndex + 1, backIndex), back = files.slice(backIndex + 1);
            this.files = sourceIndex < targetIndex ? [
                ...front,
                ...middle,
                targetFile,
                sourceFile,
                ...back
            ] : [
                ...front,
                sourceFile,
                targetFile,
                ...middle,
                ...back
            ];
        }
        constructor(){
            super(...arguments);
            _FileModel_files_accessor_storage.set(this, $39904e2d513e8a93$var$__runInitializers(this, _files_initializers, []));
            $39904e2d513e8a93$var$__runInitializers(this, _files_extraInitializers);
        }
    }, _FileModel_files_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _files_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        $39904e2d513e8a93$var$__esDecorate(_a, null, _files_decorators, {
            kind: "accessor",
            name: "files",
            static: false,
            private: false,
            access: {
                has: (obj)=>"files" in obj,
                get: (obj)=>obj.files,
                set: (obj, value)=>{
                    obj.files = value;
                }
            },
            metadata: _metadata
        }, _files_initializers, _files_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
let $39904e2d513e8a93$export$1a5cb5295a7d2749 = (()=>{
    var _FileUploader_pickIndex_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    let _instanceExtraInitializers = [];
    let _pickIndex_decorators;
    let _pickIndex_initializers = [];
    let _pickIndex_extraInitializers = [];
    let _restoreFile_decorators;
    var FileUploader = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FileUploader_pickIndex_accessor_storage.set(this, ($39904e2d513e8a93$var$__runInitializers(this, _instanceExtraInitializers), $39904e2d513e8a93$var$__runInitializers(this, _pickIndex_initializers, void 0)));
            Object.defineProperty(this, "handleDrop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($39904e2d513e8a93$var$__runInitializers(this, _pickIndex_extraInitializers), (index)=>(event)=>{
                        event.preventDefault();
                        const { props: props, pickIndex: pickIndex } = this;
                        if (!(pickIndex != null)) return;
                        props.store.move(pickIndex, index);
                        this.innerValue = props.store.files;
                    })
            });
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (oldURI = '')=>(file)=>$39904e2d513e8a93$var$__awaiter(this, void 0, void 0, function*() {
                            const { store: store } = this.props;
                            if (oldURI) yield store.delete(oldURI);
                            if (file) yield store.upload(file);
                            this.innerValue = store.files;
                        })
            });
        }
        get pickIndex() {
            return $39904e2d513e8a93$var$__classPrivateFieldGet(this, _FileUploader_pickIndex_accessor_storage, "f");
        }
        set pickIndex(value) {
            $39904e2d513e8a93$var$__classPrivateFieldSet(this, _FileUploader_pickIndex_accessor_storage, value, "f");
        }
        componentDidMount() {
            super.componentDidMount();
            const { store: store } = this.props;
            store.files = this.value || [];
        }
        restoreFile(value) {
            const { store: store } = this.props;
            store.files = value || [];
        }
        render() {
            const _a = this.props, { className: className = 'm-0', style: style, multiple: multiple, store: store, value: _, defaultValue: defaultValue, onChange: onChange } = _a, props = $39904e2d513e8a93$var$__rest(_a, [
                "className",
                "style",
                "multiple",
                "store",
                "value",
                "defaultValue",
                "onChange"
            ]);
            const { value: value } = this;
            return (0, $90cae257cc958273$exports.jsxs)("ol", {
                className: `list-inline d-flex ${className}`,
                style: style,
                onDragOver: (event)=>event.preventDefault(),
                children: [
                    value === null || value === void 0 ? void 0 : value.map((file, index)=>(0, $90cae257cc958273$exports.jsx)("li", {
                            className: "list-inline-item",
                            draggable: true,
                            onDragStart: ()=>this.pickIndex = index,
                            onDrop: this.handleDrop(index),
                            children: (0, $90cae257cc958273$exports.jsx)((0, $62eeafa9ec804a03$export$54dc470bcc5c41d1), Object.assign({}, props, {
                                value: file,
                                onChange: this.handleChange(file)
                            }))
                        }, file)),
                    (multiple || !(value === null || value === void 0 ? void 0 : value[0])) && (0, $90cae257cc958273$exports.jsx)("li", {
                        className: "list-inline-item",
                        children: (0, $90cae257cc958273$exports.jsx)((0, $62eeafa9ec804a03$export$54dc470bcc5c41d1), Object.assign({}, props, {
                            name: undefined,
                            value: "",
                            required: !(value === null || value === void 0 ? void 0 : value[0]) && props.required,
                            onChange: this.handleChange()
                        }))
                    })
                ]
            });
        }
    };
    _FileUploader_pickIndex_accessor_storage = new WeakMap();
    $39904e2d513e8a93$var$__setFunctionName(_classThis, "FileUploader");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _pickIndex_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _restoreFile_decorators = [
            (0, $85705ec7803c1445$export$7203b476385689ae)(({ value: value })=>value)
        ];
        $39904e2d513e8a93$var$__esDecorate(_classThis, null, _pickIndex_decorators, {
            kind: "accessor",
            name: "pickIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pickIndex" in obj,
                get: (obj)=>obj.pickIndex,
                set: (obj, value)=>{
                    obj.pickIndex = value;
                }
            },
            metadata: _metadata
        }, _pickIndex_initializers, _pickIndex_extraInitializers);
        $39904e2d513e8a93$var$__esDecorate(_classThis, null, _restoreFile_decorators, {
            kind: "method",
            name: "restoreFile",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreFile" in obj,
                get: (obj)=>obj.restoreFile
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $39904e2d513e8a93$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FileUploader = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'FileUploader'
    });
    (()=>{
        $39904e2d513e8a93$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FileUploader = _classThis;
})();





var $90MBA = parcelRequire("90MBA");
var $8952f8f68509b392$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8952f8f68509b392$export$56e87bf42978147a = (_a)=>{
    var { className: className, style: style, name: name, id: id = name || `form-field-${(0, $90MBA.uniqueID)()}`, label: label, placeholder: placeholder = typeof label === 'string' ? label : id, options: options, multiple: multiple, rows: rows = 0, onBlur: onBlur } = _a, controlProps = $8952f8f68509b392$var$__rest(_a, [
        "className",
        "style",
        "name",
        "id",
        "label",
        "placeholder",
        "options",
        "multiple",
        "rows",
        "onBlur"
    ]);
    return (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).FloatingLabel, {
        className: className,
        style: style,
        label: label,
        controlId: id,
        onBlur: onBlur && ((event)=>{
            if (event.target.checkValidity()) {
                event.target.classList.remove('is-invalid');
                event.currentTarget.classList.remove('is-invalid');
            } else {
                event.target.classList.add('is-invalid');
                event.currentTarget.classList.add('is-invalid');
            }
            onBlur(event);
        }),
        children: options ? (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Select, Object.assign({
            className: multiple ? 'h-auto' : '',
            name: name,
            multiple: multiple,
            htmlSize: rows
        }, controlProps, {
            children: options.map(({ value: value, text: text, label: label, disabled: disabled })=>(0, $90cae257cc958273$exports.jsx)("option", {
                    value: value,
                    label: label,
                    disabled: disabled,
                    children: text || value
                }, value))
        })) : (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control, Object.assign({
            className: rows > 1 ? 'h-auto' : '',
            name: name,
            multiple: multiple,
            rows: rows,
            placeholder: placeholder
        }, controlProps))
    });
};
$8952f8f68509b392$export$56e87bf42978147a.displayName = 'FormField';





var $cb70d0e9e34a3088$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $cb70d0e9e34a3088$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $cb70d0e9e34a3088$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $cb70d0e9e34a3088$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $cb70d0e9e34a3088$export$f5603a09670563b9 = (()=>{
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    var RangeInput = _classThis = class extends _classSuper {
        renderItem(index) {
            const { value: value = 0 } = this, { icon: icon, step: step = 1 } = this.observedProps;
            const fullValue = +step * index;
            const itemValue = Math.max(Math.min(+value - fullValue, +step), 0);
            return (0, $90cae257cc958273$exports.jsx)("li", {
                className: "text-center",
                children: typeof icon === 'function' ? icon(itemValue) : icon
            }, index);
        }
        render() {
            const _a = this.observedProps, { className: className = 'd-inline-block position-relative', icon: icon, min: min, max: max = icon ? 5 : 100, onChange: onChange } = _a, props = $cb70d0e9e34a3088$var$__rest(_a, [
                "className",
                "icon",
                "min",
                "max",
                "onChange"
            ]), { value: value = min || 0 } = this;
            return (0, $90cae257cc958273$exports.jsxs)("div", {
                className: className,
                title: value + '',
                children: [
                    (0, $90cae257cc958273$exports.jsx)("input", Object.assign({
                        min: min,
                        max: max,
                        value: value
                    }, props, {
                        className: icon ? 'opacity-0' : '',
                        style: {
                            margin: '0 -0.5rem',
                            cursor: 'pointer'
                        },
                        type: "range",
                        onChange: ({ currentTarget: { value: value } })=>this.innerValue = value
                    })),
                    (0, $90cae257cc958273$exports.jsx)("ol", {
                        className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                        children: Array.from({
                            length: +max
                        }, (_, index)=>this.renderItem(index))
                    })
                ]
            });
        }
    };
    $cb70d0e9e34a3088$var$__setFunctionName(_classThis, "RangeInput");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $cb70d0e9e34a3088$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RangeInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'RangeInput'
    });
    (()=>{
        $cb70d0e9e34a3088$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RangeInput = _classThis;
})();






var $90MBA = parcelRequire("90MBA");

var $efbee1975352f32e$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $efbee1975352f32e$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $efbee1975352f32e$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
const $efbee1975352f32e$export$82cd8db40d0f609c = [
    'text',
    'number',
    'tel',
    'email',
    'url'
];
let $efbee1975352f32e$export$76834b0602c89bd = (()=>{
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    var BadgeInput = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "handleInput", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>{
                    const input = event.currentTarget;
                    const { value: value } = input, innerValue = this.innerValue || [];
                    switch(event.key){
                        case 'Enter':
                            event.preventDefault();
                            input.value = '';
                            if (value) this.innerValue = [
                                ...innerValue,
                                value
                            ];
                            break;
                        case 'Backspace':
                            if (!value) this.innerValue = innerValue.slice(0, -1);
                    }
                }
            });
        }
        static match(type) {
            return $efbee1975352f32e$export$82cd8db40d0f609c.includes(type);
        }
        delete(index) {
            const { innerValue: innerValue = [] } = this;
            this.innerValue = [
                ...innerValue.slice(0, index),
                ...innerValue.slice(index + 1)
            ];
        }
        render() {
            const { value: value } = this, { className: className = '', style: style, type: type, name: name, required: required, placeholder: placeholder } = this.props;
            return (0, $90cae257cc958273$exports.jsxs)("div", {
                className: `form-control p-2 d-flex flex-wrap gap-2 ${className}`,
                style: style,
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $9784173a5043df33$export$ef1c4106ceccca63), {
                        list: (value || []).map((text)=>({
                                text: text
                            })),
                        onDelete: ({}, index)=>this.delete(index)
                    }),
                    (0, $90cae257cc958273$exports.jsx)("input", {
                        className: "border-0 flex-fill",
                        style: {
                            outline: 'none'
                        },
                        type: type,
                        required: (0, $90MBA.isEmpty)(value) ? required : undefined,
                        placeholder: placeholder,
                        onKeyDown: this.handleInput
                    }),
                    (0, $90cae257cc958273$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: JSON.stringify(value)
                    })
                ]
            });
        }
    };
    $efbee1975352f32e$var$__setFunctionName(_classThis, "BadgeInput");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $efbee1975352f32e$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        BadgeInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'BadgeInput'
    });
    (()=>{
        $efbee1975352f32e$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return BadgeInput = _classThis;
})();







var $90MBA = parcelRequire("90MBA");
var $f1219760c77b4e86$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f1219760c77b4e86$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f1219760c77b4e86$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $f1219760c77b4e86$export$42efeba470be9198 = (()=>{
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    var ArrayField = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "rowIds", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "insert", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index = 0)=>{
                    const { innerValue: innerValue = [] } = this, item = {};
                    this.rowIds.splice(index, 0, (0, $90MBA.uniqueID)());
                    this.innerValue = [
                        ...innerValue.slice(0, index),
                        item,
                        ...innerValue.slice(index)
                    ];
                }
            });
            Object.defineProperty(this, "remove", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index)=>{
                    var _a;
                    this.rowIds.splice(index, 1);
                    this.innerValue = (_a = this.innerValue) === null || _a === void 0 ? void 0 : _a.filter((_, i)=>i !== index);
                }
            });
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index)=>({ currentTarget: currentTarget })=>{
                        const item = (0, $90MBA.formToJSON)(currentTarget), { innerValue: innerValue = [] } = this;
                        this.innerValue = [
                            ...innerValue.slice(0, index),
                            item,
                            ...innerValue.slice(index + 1)
                        ];
                    }
            });
            Object.defineProperty(this, "handleUpdate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index)=>({ currentTarget: currentTarget })=>{
                        const item = (0, $90MBA.formToJSON)(currentTarget);
                        this.innerValue[index] = item;
                    }
            });
        }
        getRowId(index) {
            var _a;
            return (_a = this.rowIds)[index] || (_a[index] = (0, $90MBA.uniqueID)());
        }
        componentDidMount() {
            super.componentDidMount();
            if ((0, $90MBA.isEmpty)(this.value)) this.insert();
        }
        render() {
            const { className: className = '', style: style, name: name, renderItem: renderItem } = this.props, { value: value, rowIds: rowIds } = this;
            const length = (value === null || value === void 0 ? void 0 : value.length) || 0;
            if (rowIds.length > length) rowIds.length = length;
            return (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
                children: value === null || value === void 0 ? void 0 : value.map((item, index, { length: length })=>(0, $90cae257cc958273$exports.jsxs)("fieldset", {
                        className: `d-flex align-items-center my-2 gap-2 ${className}`,
                        style: style,
                        name: name,
                        onBlur: this.handleChange(index),
                        onChange: this.handleUpdate(index),
                        children: [
                            (0, $90cae257cc958273$exports.jsx)("div", {
                                className: "flex-fill",
                                children: renderItem(item, index)
                            }),
                            (0, $90cae257cc958273$exports.jsxs)((0, $75dff33a31c871e7$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                        type: "button",
                                        size: "sm",
                                        variant: "warning",
                                        onClick: ()=>this.insert(index + 1),
                                        children: "+"
                                    }),
                                    (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                        type: "button",
                                        size: "sm",
                                        variant: "danger",
                                        disabled: length < 2,
                                        onClick: ()=>this.remove(index),
                                        children: "-"
                                    })
                                ]
                            })
                        ]
                    }, this.getRowId(index)))
            });
        }
    };
    $f1219760c77b4e86$var$__setFunctionName(_classThis, "ArrayField");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $f1219760c77b4e86$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ArrayField = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'ArrayField'
    });
    (()=>{
        $f1219760c77b4e86$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ArrayField = _classThis;
})();







var $5E6i4 = parcelRequire("5E6i4");


const $e7fb5080ac3edd96$export$5f747a46dc0eb6ee = (()=>{
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
})(), $e7fb5080ac3edd96$var$t = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$c;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$h;
});
async function $e7fb5080ac3edd96$export$c1bd535e520dbbc3(...e) {
    return (await $e7fb5080ac3edd96$var$t).default(...e);
}
const $e7fb5080ac3edd96$var$r = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$y;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$b;
});
async function $e7fb5080ac3edd96$export$270aed3754275094(...e) {
    return (await $e7fb5080ac3edd96$var$r).default(...e);
}
const $e7fb5080ac3edd96$var$a = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$m;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$_;
});
async function $e7fb5080ac3edd96$export$cf414c79194c40b9(...e) {
    return (await $e7fb5080ac3edd96$var$a).default(...e);
}
const $e7fb5080ac3edd96$var$s = async (e)=>{
    const t = await e.getFile();
    return t.handle = e, t;
};
var $e7fb5080ac3edd96$export$73dd4a3df259d52 = async (e = [
    {}
])=>{
    Array.isArray(e) || (e = [
        e
    ]);
    const t = [];
    e.forEach((e, n)=>{
        t[n] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? e.mimeTypes.map((r)=>{
            t[n].accept[r] = e.extensions || [];
        }) : t[n].accept["*/*"] = e.extensions || [];
    });
    const n = await window.showOpenFilePicker({
        id: e[0].id,
        startIn: e[0].startIn,
        types: t,
        multiple: e[0].multiple || !1,
        excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
    }), r = await Promise.all(n.map($e7fb5080ac3edd96$var$s));
    return e[0].multiple ? r : r[0];
}, $e7fb5080ac3edd96$var$c = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$73dd4a3df259d52
};
function $e7fb5080ac3edd96$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $e7fb5080ac3edd96$var$u = function(e) {
        this.s = e, this.n = e.next;
    }, $e7fb5080ac3edd96$var$u.prototype = {
        s: null,
        n: null,
        next: function() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $e7fb5080ac3edd96$var$u(e);
}
const $e7fb5080ac3edd96$var$p = async (e, t, n = e.name, r)=>{
    const i = [], a = [];
    var o, s = !1, l = !1;
    try {
        for(var c, d = function(e) {
            var t, n, r, i = 2;
            for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                if (n && null != (t = e[n])) return t.call(e);
                if (r && null != (t = e[r])) return new $e7fb5080ac3edd96$var$u(t.call(e));
                n = "@@asyncIterator", r = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }(e.values()); s = !(c = await d.next()).done; s = !1){
            const o = c.value, s = `${n}/${o.name}`;
            "file" === o.kind ? a.push(o.getFile().then((t)=>(t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                    configurable: !0,
                    enumerable: !0,
                    get: ()=>s
                })))) : "directory" !== o.kind || !t || r && r(o) || i.push($e7fb5080ac3edd96$var$p(o, t, s, r));
        }
    } catch (e) {
        l = !0, o = e;
    } finally{
        try {
            s && null != d.return && await d.return();
        } finally{
            if (l) throw o;
        }
    }
    return [
        ...(await Promise.all(i)).flat(),
        ...await Promise.all(a)
    ];
};
var $e7fb5080ac3edd96$export$aeb41617a6d6e89 = async (e = {})=>{
    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
    const t = await window.showDirectoryPicker({
        id: e.id,
        startIn: e.startIn,
        mode: e.mode
    });
    return (await (await t.values()).next()).done ? [
        t
    ] : $e7fb5080ac3edd96$var$p(t, e.recursive, void 0, e.skipDirectory);
}, $e7fb5080ac3edd96$var$y = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$aeb41617a6d6e89
}, $e7fb5080ac3edd96$export$ff17ca902e7337af = async (e, t = [
    {}
], n = null, r = !1, i = null)=>{
    Array.isArray(t) || (t = [
        t
    ]), t[0].fileName = t[0].fileName || "Untitled";
    const a = [];
    let o = null;
    if (e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach((e, t)=>{
        a[t] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map((n)=>{
            a[t].accept[n] = e.extensions || [];
        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
    }), n) try {
        await n.getFile();
    } catch (e) {
        if (n = null, r) throw e;
    }
    const s = n || await window.showSaveFilePicker({
        suggestedName: t[0].fileName,
        id: t[0].id,
        startIn: t[0].startIn,
        types: a,
        excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
    });
    !n && i && i(s);
    const l = await s.createWritable();
    if ("stream" in e) {
        const t = e.stream();
        return await t.pipeTo(l), s;
    }
    return "body" in e ? (await e.body.pipeTo(l), s) : (await l.write(await e), await l.close(), s);
}, $e7fb5080ac3edd96$var$m = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$ff17ca902e7337af
}, $e7fb5080ac3edd96$export$f1c676766788056a = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file";
        const i = [
            ...e.map((e)=>e.mimeTypes || []),
            ...e.map((e)=>e.extensions || [])
        ].join();
        r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e7fb5080ac3edd96$var$h = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$f1c676766788056a
}, $e7fb5080ac3edd96$export$14ab45eaad58ab5 = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), e[0].recursive = e[0].recursive || !1, new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove();
            let n = Array.from(r.files);
            e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter((t)=>t.webkitRelativePath.split("/").every((t)=>!e[0].skipDirectory({
                        name: t,
                        kind: "directory"
                    })))) : n = n.filter((e)=>2 === e.webkitRelativePath.split("/").length), t(n);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e7fb5080ac3edd96$var$b = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$14ab45eaad58ab5
}, $e7fb5080ac3edd96$export$19f956f8dbe9df86 = async (e, t = {})=>{
    Array.isArray(t) && (t = t[0]);
    const n = document.createElement("a");
    let r = e;
    "body" in e && (r = await async function(e, t) {
        const n = e.getReader(), r = new ReadableStream({
            start: (e)=>(async function t() {
                    return n.read().then(({ done: n, value: r })=>{
                        if (!n) return e.enqueue(r), t();
                        e.close();
                    });
                })()
        }), i = new Response(r), a = await i.blob();
        return n.releaseLock(), new Blob([
            a
        ], {
            type: t
        });
    }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
    const i = ()=>{
        "function" == typeof a && a();
    }, a = t.legacySetup && t.legacySetup(i, ()=>a(), n);
    return n.addEventListener("click", ()=>{
        setTimeout(()=>URL.revokeObjectURL(n.href), 3e4), i();
    }), n.click(), null;
}, $e7fb5080ac3edd96$var$_ = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$19f956f8dbe9df86
};


function $2e0e3d0c95468c5e$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) destination[key] = source[key];
    }
    return destination;
}
function $2e0e3d0c95468c5e$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $2e0e3d0c95468c5e$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $2e0e3d0c95468c5e$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $2e0e3d0c95468c5e$var$trimNewlines(string) {
    return $2e0e3d0c95468c5e$var$trimTrailingNewlines($2e0e3d0c95468c5e$var$trimLeadingNewlines(string));
}
var $2e0e3d0c95468c5e$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $2e0e3d0c95468c5e$var$isBlock(node) {
    return $2e0e3d0c95468c5e$var$is(node, $2e0e3d0c95468c5e$var$blockElements);
}
var $2e0e3d0c95468c5e$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $2e0e3d0c95468c5e$var$isVoid(node) {
    return $2e0e3d0c95468c5e$var$is(node, $2e0e3d0c95468c5e$var$voidElements);
}
function $2e0e3d0c95468c5e$var$hasVoid(node) {
    return $2e0e3d0c95468c5e$var$has(node, $2e0e3d0c95468c5e$var$voidElements);
}
var $2e0e3d0c95468c5e$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $2e0e3d0c95468c5e$var$isMeaningfulWhenBlank(node) {
    return $2e0e3d0c95468c5e$var$is(node, $2e0e3d0c95468c5e$var$meaningfulWhenBlankElements);
}
function $2e0e3d0c95468c5e$var$hasMeaningfulWhenBlank(node) {
    return $2e0e3d0c95468c5e$var$has(node, $2e0e3d0c95468c5e$var$meaningfulWhenBlankElements);
}
function $2e0e3d0c95468c5e$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $2e0e3d0c95468c5e$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $2e0e3d0c95468c5e$var$markdownEscapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $2e0e3d0c95468c5e$var$escapeMarkdown(string) {
    return $2e0e3d0c95468c5e$var$markdownEscapes.reduce(function(accumulator, escape) {
        return accumulator.replace(escape[0], escape[1]);
    }, string);
}
var $2e0e3d0c95468c5e$var$rules = {};
$2e0e3d0c95468c5e$var$rules.paragraph = {
    filter: 'p',
    replacement: function(content) {
        return '\n\n' + content + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.lineBreak = {
    filter: 'br',
    replacement: function(content, node, options) {
        return options.br + '\n';
    }
};
$2e0e3d0c95468c5e$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $2e0e3d0c95468c5e$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $2e0e3d0c95468c5e$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function(content) {
        content = $2e0e3d0c95468c5e$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.listItem = {
    filter: 'li',
    replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $2e0e3d0c95468c5e$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$2e0e3d0c95468c5e$var$rules.indentedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.fencedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $2e0e3d0c95468c5e$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$2e0e3d0c95468c5e$var$rules.inlineLink = {
    filter: function(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node) {
        var href = $2e0e3d0c95468c5e$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $2e0e3d0c95468c5e$var$escapeLinkTitle($2e0e3d0c95468c5e$var$cleanAttribute(node.getAttribute('title')));
        var titlePart = title ? ' "' + title + '"' : '';
        return '[' + content + '](' + href + titlePart + ')';
    }
};
$2e0e3d0c95468c5e$var$rules.referenceLink = {
    filter: function(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node, options) {
        var href = $2e0e3d0c95468c5e$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $2e0e3d0c95468c5e$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + $2e0e3d0c95468c5e$var$escapeLinkTitle(title) + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$2e0e3d0c95468c5e$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$2e0e3d0c95468c5e$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$2e0e3d0c95468c5e$var$rules.code = {
    filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$2e0e3d0c95468c5e$var$rules.image = {
    filter: 'img',
    replacement: function(content, node) {
        var alt = $2e0e3d0c95468c5e$var$escapeMarkdown($2e0e3d0c95468c5e$var$cleanAttribute(node.getAttribute('alt')));
        var src = $2e0e3d0c95468c5e$var$escapeLinkDestination(node.getAttribute('src') || '');
        var title = $2e0e3d0c95468c5e$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + $2e0e3d0c95468c5e$var$escapeLinkTitle(title) + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $2e0e3d0c95468c5e$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
function $2e0e3d0c95468c5e$var$escapeLinkDestination(destination) {
    var escaped = destination.replace(/([<>()])/g, '\\$1');
    return escaped.indexOf(' ') >= 0 ? '<' + escaped + '>' : escaped;
}
function $2e0e3d0c95468c5e$var$escapeLinkTitle(title) {
    return title.replace(/"/g, '\\"');
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $2e0e3d0c95468c5e$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$2e0e3d0c95468c5e$var$Rules.prototype = {
    add: function(key, rule) {
        this.array.unshift(rule);
    },
    keep: function(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function() {
                return '';
            }
        });
    },
    forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $2e0e3d0c95468c5e$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $2e0e3d0c95468c5e$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $2e0e3d0c95468c5e$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $2e0e3d0c95468c5e$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($2e0e3d0c95468c5e$var$filterValue(rule, node, options)) return rule;
    }
    return undefined;
}
function $2e0e3d0c95468c5e$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $2e0e3d0c95468c5e$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $2e0e3d0c95468c5e$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $2e0e3d0c95468c5e$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $2e0e3d0c95468c5e$var$remove(node);
            continue;
        }
        var nextNode = $2e0e3d0c95468c5e$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $2e0e3d0c95468c5e$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $2e0e3d0c95468c5e$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $2e0e3d0c95468c5e$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $2e0e3d0c95468c5e$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $2e0e3d0c95468c5e$var$canParseHTMLNatively() {
    var Parser = $2e0e3d0c95468c5e$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $2e0e3d0c95468c5e$var$createHTMLParser() {
    var Parser = function() {};
    if ($2e0e3d0c95468c5e$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $2e0e3d0c95468c5e$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($2e0e3d0c95468c5e$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $2e0e3d0c95468c5e$var$HTMLParser = $2e0e3d0c95468c5e$var$canParseHTMLNatively() ? $2e0e3d0c95468c5e$var$root.DOMParser : $2e0e3d0c95468c5e$var$createHTMLParser();
function $2e0e3d0c95468c5e$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $2e0e3d0c95468c5e$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $2e0e3d0c95468c5e$var$collapseWhitespace({
        element: root,
        isBlock: $2e0e3d0c95468c5e$var$isBlock,
        isVoid: $2e0e3d0c95468c5e$var$isVoid,
        isPre: options.preformattedCode ? $2e0e3d0c95468c5e$var$isPreOrCode : null
    });
    return root;
}
var $2e0e3d0c95468c5e$var$_htmlParser;
function $2e0e3d0c95468c5e$var$htmlParser() {
    $2e0e3d0c95468c5e$var$_htmlParser = $2e0e3d0c95468c5e$var$_htmlParser || new $2e0e3d0c95468c5e$var$HTMLParser();
    return $2e0e3d0c95468c5e$var$_htmlParser;
}
function $2e0e3d0c95468c5e$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $2e0e3d0c95468c5e$var$Node(node, options) {
    node.isBlock = $2e0e3d0c95468c5e$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $2e0e3d0c95468c5e$var$isBlank(node);
    node.flankingWhitespace = $2e0e3d0c95468c5e$var$flankingWhitespace(node, options);
    return node;
}
function $2e0e3d0c95468c5e$var$isBlank(node) {
    return !$2e0e3d0c95468c5e$var$isVoid(node) && !$2e0e3d0c95468c5e$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$2e0e3d0c95468c5e$var$hasVoid(node) && !$2e0e3d0c95468c5e$var$hasMeaningfulWhenBlank(node);
}
function $2e0e3d0c95468c5e$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $2e0e3d0c95468c5e$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $2e0e3d0c95468c5e$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $2e0e3d0c95468c5e$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $2e0e3d0c95468c5e$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        // whole string for whitespace-only strings
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        // empty for whitespace-only strings
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $2e0e3d0c95468c5e$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$2e0e3d0c95468c5e$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $2e0e3d0c95468c5e$var$reduce = Array.prototype.reduce;
function $2e0e3d0c95468c5e$export$2e2bcd8739ae039(options) {
    if (!(this instanceof $2e0e3d0c95468c5e$export$2e2bcd8739ae039)) return new $2e0e3d0c95468c5e$export$2e2bcd8739ae039(options);
    var defaults = {
        rules: $2e0e3d0c95468c5e$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $2e0e3d0c95468c5e$var$extend({}, defaults, options);
    this.rules = new $2e0e3d0c95468c5e$var$Rules(this.options);
}
$2e0e3d0c95468c5e$export$2e2bcd8739ae039.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function(input) {
        if (!$2e0e3d0c95468c5e$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $2e0e3d0c95468c5e$var$process.call(this, new $2e0e3d0c95468c5e$var$RootNode(input, this.options));
        return $2e0e3d0c95468c5e$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function(string) {
        return $2e0e3d0c95468c5e$var$escapeMarkdown(string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $2e0e3d0c95468c5e$var$process(parentNode) {
    var self = this;
    return $2e0e3d0c95468c5e$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $2e0e3d0c95468c5e$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $2e0e3d0c95468c5e$var$replacementForNode.call(self, node);
        return $2e0e3d0c95468c5e$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $2e0e3d0c95468c5e$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $2e0e3d0c95468c5e$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $2e0e3d0c95468c5e$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $2e0e3d0c95468c5e$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $2e0e3d0c95468c5e$var$join(output, replacement) {
    var s1 = $2e0e3d0c95468c5e$var$trimTrailingNewlines(output);
    var s2 = $2e0e3d0c95468c5e$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $2e0e3d0c95468c5e$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}


var $8b5b54c590bb494d$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $8b5b54c590bb494d$export$c359330ed80b1889(turndownService) {
    turndownService.addRule('highlightedCodeBlock', {
        filter: function(node) {
            var firstChild = node.firstChild;
            return node.nodeName === 'DIV' && $8b5b54c590bb494d$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === 'PRE';
        },
        replacement: function(content, node, options) {
            var className = node.className || '';
            var language = (className.match($8b5b54c590bb494d$var$highlightRegExp) || [
                null,
                ''
            ])[1];
            return '\n\n' + options.fence + language + '\n' + node.firstChild.textContent + '\n' + options.fence + '\n\n';
        }
    });
}
function $8b5b54c590bb494d$export$19426ff118fe8be(turndownService) {
    turndownService.addRule('strikethrough', {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function(content) {
            return '~' + content + '~';
        }
    });
}
var $8b5b54c590bb494d$var$indexOf = Array.prototype.indexOf;
var $8b5b54c590bb494d$var$every = Array.prototype.every;
var $8b5b54c590bb494d$var$rules = {};
$8b5b54c590bb494d$var$rules.tableCell = {
    filter: [
        'th',
        'td'
    ],
    replacement: function(content, node) {
        return $8b5b54c590bb494d$var$cell(content, node);
    }
};
$8b5b54c590bb494d$var$rules.tableRow = {
    filter: 'tr',
    replacement: function(content, node) {
        var borderCells = '';
        var alignMap = {
            left: ':--',
            right: '--:',
            center: ':-:'
        };
        if ($8b5b54c590bb494d$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = '---';
            var align = (node.childNodes[i].getAttribute('align') || '').toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $8b5b54c590bb494d$var$cell(border, node.childNodes[i]);
        }
        return '\n' + content + (borderCells ? '\n' + borderCells : '');
    }
};
$8b5b54c590bb494d$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function(node) {
        return node.nodeName === 'TABLE' && $8b5b54c590bb494d$var$isHeadingRow(node.rows[0]);
    },
    replacement: function(content) {
        // Ensure there are no blank lines
        content = content.replace('\n\n', '\n');
        return '\n\n' + content + '\n\n';
    }
};
$8b5b54c590bb494d$var$rules.tableSection = {
    filter: [
        'thead',
        'tbody',
        'tfoot'
    ],
    replacement: function(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $8b5b54c590bb494d$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === 'THEAD' || parentNode.firstChild === tr && (parentNode.nodeName === 'TABLE' || $8b5b54c590bb494d$var$isFirstTbody(parentNode)) && $8b5b54c590bb494d$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === 'TH';
    });
}
function $8b5b54c590bb494d$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === 'TBODY' && (!previousSibling || previousSibling.nodeName === 'THEAD' && /^\s*$/i.test(previousSibling.textContent));
}
function $8b5b54c590bb494d$var$cell(content, node) {
    var index = $8b5b54c590bb494d$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
function $8b5b54c590bb494d$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === 'TABLE' && !$8b5b54c590bb494d$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $8b5b54c590bb494d$var$rules)turndownService.addRule(key, $8b5b54c590bb494d$var$rules[key]);
}
function $8b5b54c590bb494d$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule('taskListItems', {
        filter: function(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    });
}
function $8b5b54c590bb494d$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $8b5b54c590bb494d$export$c359330ed80b1889,
        $8b5b54c590bb494d$export$19426ff118fe8be,
        $8b5b54c590bb494d$export$cc4ff83fc7bd256e,
        $8b5b54c590bb494d$export$1f0c2747e2ba0b8d
    ]);
}



var $90MBA = parcelRequire("90MBA");

var $80eeU = parcelRequire("80eeU");
function $32780b0aacdc2595$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $32780b0aacdc2595$var$$57ba63c17513cbba$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$57ba63c17513cbba$exports, "getAnchorElement", function() {
    return $32780b0aacdc2595$export$ac81f1ba58a5f363;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$57ba63c17513cbba$exports, "Tool", function() {
    return $32780b0aacdc2595$export$724f6b867059ef5f;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$57ba63c17513cbba$exports, "FileTool", function() {
    return $32780b0aacdc2595$export$de3122b2484864a7;
});
function $32780b0aacdc2595$export$ac81f1ba58a5f363() {
    const { anchorNode: anchorNode } = globalThis.getSelection?.() || {};
    if (anchorNode) return anchorNode.parentElement;
}
class $32780b0aacdc2595$export$724f6b867059ef5f {
    get usable() {
        const { command: command } = this;
        return !command || !globalThis.document || document.queryCommandSupported(command) || document.queryCommandEnabled(command);
    }
    getActive() {
        const { command: command, tags: tags } = this;
        if (tags) {
            const box = $32780b0aacdc2595$export$ac81f1ba58a5f363();
            return !!box && box.matches(tags.map((tag)=>`${tag}, ${tag} *`).join(', '));
        }
        if (command) return !!globalThis.document && document.queryCommandState(command);
        return false;
    }
    get active() {
        return this.getActive();
    }
    get title() {
        const { name: name, keys: keys, usable: usable } = this;
        return `${name}${usable ? keys ? `\n(${keys.join(' + ')})` : '' : '\n(not supported)'}`;
    }
    edit(editor, ...data) {
        editor.focus();
        document.execCommand(this.command, null, ...data);
    }
    execute(editor, ...data) {
        var { inputs: inputs } = this, values = [];
        if (inputs) {
            const data = inputs.map((input)=>self.prompt(input));
            if (!data.filter(Boolean)[0]) return;
            values = data;
        }
        this.edit(editor, ...values);
    }
}
class $32780b0aacdc2595$export$de3122b2484864a7 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    async save(data) {
        return URL.createObjectURL(data);
    }
    codeOf(path) {
        return path;
    }
    async execute(editor) {
        try {
            var path = await this.save(await (0, $e7fb5080ac3edd96$export$c1bd535e520dbbc3)());
        } catch  {
            var path = self.prompt('No file uploaded, please input an URL');
        }
        if (path) this.edit(editor, this.codeOf(path));
    }
}
var $32780b0aacdc2595$var$$761e5fca3dae08eb$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "BoldTool", function() {
    return $32780b0aacdc2595$export$10056a49e3b218eb;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "ItalicTool", function() {
    return $32780b0aacdc2595$export$edf99d0f51bacb1e;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "UnderlineTool", function() {
    return $32780b0aacdc2595$export$4b6d9c17188960d2;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "StrikeThroughTool", function() {
    return $32780b0aacdc2595$export$a35bffaeae8fdda0;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "HeadingTool", function() {
    return $32780b0aacdc2595$export$85cf7848e2652151;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "H1Tool", function() {
    return $32780b0aacdc2595$export$30e8c6b428f8749f;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "H2Tool", function() {
    return $32780b0aacdc2595$export$58443375efa91029;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "H3Tool", function() {
    return $32780b0aacdc2595$export$75d24d6b8b747307;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "FontSizeDownTool", function() {
    return $32780b0aacdc2595$export$a20806c6ef6938f8;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "FontSizeUpTool", function() {
    return $32780b0aacdc2595$export$744da7e24e4a7382;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "SubscriptTool", function() {
    return $32780b0aacdc2595$export$6137518b4e998008;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "SuperscriptTool", function() {
    return $32780b0aacdc2595$export$7217f06c61ebd4fc;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$761e5fca3dae08eb$exports, "LinkTool", function() {
    return $32780b0aacdc2595$export$f6c54364b5332e66;
});
class $32780b0aacdc2595$export$10056a49e3b218eb extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Bold', this.tags = [
            'b',
            'strong'
        ], this.keys = [
            'Ctrl',
            'B'
        ], this.command = 'bold';
    }
}
class $32780b0aacdc2595$export$edf99d0f51bacb1e extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Italic', this.tags = [
            'i',
            'em'
        ], this.keys = [
            'Ctrl',
            'I'
        ], this.command = 'italic';
    }
}
class $32780b0aacdc2595$export$4b6d9c17188960d2 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Underline', this.tags = [
            'u'
        ], this.keys = [
            'Ctrl',
            'U'
        ], this.command = 'underline';
    }
}
class $32780b0aacdc2595$export$a35bffaeae8fdda0 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Strike through', this.tags = [
            's',
            'del',
            'strike'
        ], this.command = 'strikeThrough';
    }
}
class $32780b0aacdc2595$export$85cf7848e2652151 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    execute(editor) {
        this.edit(editor, this.name);
    }
    constructor(...args){
        super(...args), this.command = globalThis.document?.queryCommandSupported('heading') ? 'heading' : 'formatBlock';
    }
}
class $32780b0aacdc2595$export$30e8c6b428f8749f extends $32780b0aacdc2595$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H1', this.tags = [
            'h1'
        ];
    }
}
class $32780b0aacdc2595$export$58443375efa91029 extends $32780b0aacdc2595$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H2', this.tags = [
            'h2'
        ];
    }
}
class $32780b0aacdc2595$export$75d24d6b8b747307 extends $32780b0aacdc2595$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H3', this.tags = [
            'h3'
        ];
    }
}
class $32780b0aacdc2595$export$a20806c6ef6938f8 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size down', this.tags = [
            'small'
        ], this.command = 'decreaseFontSize';
    }
}
class $32780b0aacdc2595$export$744da7e24e4a7382 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size up', this.tags = [
            'big'
        ], this.command = 'increaseFontSize';
    }
}
class $32780b0aacdc2595$export$6137518b4e998008 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Subscript', this.tags = [
            'sub'
        ], this.command = 'subscript';
    }
}
class $32780b0aacdc2595$export$7217f06c61ebd4fc extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Superscript', this.tags = [
            'sup'
        ], this.command = 'superscript';
    }
}
class $32780b0aacdc2595$export$f6c54364b5332e66 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Link', this.tags = [
            'a'
        ], this.inputs = [
            'Path'
        ], this.command = 'createLink';
    }
}
var $32780b0aacdc2595$var$$e999eec76d3b8abe$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$e999eec76d3b8abe$exports, "ColorTool", function() {
    return $32780b0aacdc2595$export$ba9bbe5370f1bf2f;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$e999eec76d3b8abe$exports, "ForeColorTool", function() {
    return $32780b0aacdc2595$export$cab0e15cfb8489d7;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$e999eec76d3b8abe$exports, "BackColorTool", function() {
    return $32780b0aacdc2595$export$92bb6183e7459be2;
});
class $32780b0aacdc2595$export$ba9bbe5370f1bf2f extends $32780b0aacdc2595$export$724f6b867059ef5f {
    getColor() {
        const box = $32780b0aacdc2595$export$ac81f1ba58a5f363(), { colorName: colorName } = this;
        if (!box) return colorName === 'color' ? '#000000' : '#ffffff';
        const { [colorName]: color } = getComputedStyle(box);
        const [red, green, blue] = color.match(/\d+/g);
        return '#' + (+red).toString(16).padStart(2, '0') + (+green).toString(16).padStart(2, '0') + (+blue).toString(16).padStart(2, '0');
    }
    get active() {
        return !!this.getColor();
    }
    execute(editor, color) {
        this.edit(editor, color);
    }
}
class $32780b0aacdc2595$export$cab0e15cfb8489d7 extends $32780b0aacdc2595$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Fore Color', this.command = 'foreColor', this.colorName = 'color';
    }
}
class $32780b0aacdc2595$export$92bb6183e7459be2 extends $32780b0aacdc2595$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Back Color', this.command = 'backColor', this.colorName = 'backgroundColor';
    }
}
var $32780b0aacdc2595$var$$258f24df7a3cbf67$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "AlignTool", function() {
    return $32780b0aacdc2595$export$6c1211091eb3b68f;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "AlignLeftTool", function() {
    return $32780b0aacdc2595$export$42a444ebfdcfe7b9;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "AlignCenterTool", function() {
    return $32780b0aacdc2595$export$9a2e6e0294a984eb;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "AlignRightTool", function() {
    return $32780b0aacdc2595$export$22363f91860fc258;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "AlignFullTool", function() {
    return $32780b0aacdc2595$export$42827b1362fed748;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "OrderedListTool", function() {
    return $32780b0aacdc2595$export$faf4e70f09f43a15;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "UnorderedListTool", function() {
    return $32780b0aacdc2595$export$cf4030b57a3fbe37;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$258f24df7a3cbf67$exports, "HorizontalRuleTool", function() {
    return $32780b0aacdc2595$export$dce8a7d6279fc201;
});
class $32780b0aacdc2595$export$6c1211091eb3b68f extends $32780b0aacdc2595$export$724f6b867059ef5f {
    get active() {
        if (super.getActive()) return true;
        const box = $32780b0aacdc2595$export$ac81f1ba58a5f363();
        return !!box && getComputedStyle(box).textAlign === this.align;
    }
}
class $32780b0aacdc2595$export$42a444ebfdcfe7b9 extends $32780b0aacdc2595$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Left', this.command = 'justifyLeft', this.align = 'left';
    }
}
class $32780b0aacdc2595$export$9a2e6e0294a984eb extends $32780b0aacdc2595$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Center', this.command = 'justifyCenter', this.align = 'center';
    }
}
class $32780b0aacdc2595$export$22363f91860fc258 extends $32780b0aacdc2595$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Right', this.command = 'justifyRight', this.align = 'right';
    }
}
class $32780b0aacdc2595$export$42827b1362fed748 extends $32780b0aacdc2595$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Full', this.command = 'justifyFull', this.align = 'justify';
    }
}
class $32780b0aacdc2595$export$faf4e70f09f43a15 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Ordered list', this.tags = [
            'ol'
        ], this.command = 'insertOrderedList';
    }
}
class $32780b0aacdc2595$export$cf4030b57a3fbe37 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Unordered list', this.tags = [
            'ul'
        ], this.command = 'insertUnorderedList';
    }
}
class $32780b0aacdc2595$export$dce8a7d6279fc201 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Horizontal rule', this.tags = [
            'hr'
        ], this.command = 'insertHorizontalRule';
    }
}
var $32780b0aacdc2595$var$$0769f8c709024b7a$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$0769f8c709024b7a$exports, "IFrameTool", function() {
    return $32780b0aacdc2595$export$3e557574863db086;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$0769f8c709024b7a$exports, "ImageTool", function() {
    return $32780b0aacdc2595$export$982f47444a2f88da;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$0769f8c709024b7a$exports, "AudioTool", function() {
    return $32780b0aacdc2595$export$6024938f37e646f8;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$0769f8c709024b7a$exports, "VideoTool", function() {
    return $32780b0aacdc2595$export$932111b8028f79ed;
});
class $32780b0aacdc2595$export$3e557574863db086 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    execute(editor) {
        const path = self.prompt('Path');
        if (path) this.edit(editor, `<iframe style="width: 100%; height: 50vh; border: none" src="${path}"></iframe>`);
    }
    constructor(...args){
        super(...args), this.name = 'Embed Web page', this.tags = [
            'iframe'
        ], this.command = 'insertHTML';
    }
}
class $32780b0aacdc2595$export$982f47444a2f88da extends $32780b0aacdc2595$export$de3122b2484864a7 {
    codeOf(path) {
        return `<img style="max-width: 100%; height: auto" src="${path}"/>`;
    }
    constructor(...args){
        super(...args), this.name = 'Image', this.tags = [
            'img'
        ], this.command = 'insertHTML';
    }
}
class $32780b0aacdc2595$export$6024938f37e646f8 extends $32780b0aacdc2595$export$de3122b2484864a7 {
    codeOf(path) {
        return `<audio controls src="${path}"></audio>`;
    }
    constructor(...args){
        super(...args), this.name = 'Audio', this.tags = [
            'audio'
        ], this.command = 'insertHTML';
    }
}
class $32780b0aacdc2595$export$932111b8028f79ed extends $32780b0aacdc2595$export$de3122b2484864a7 {
    codeOf(path) {
        return `<video controls src="${path}"></video>`;
    }
    constructor(...args){
        super(...args), this.name = 'Video', this.tags = [
            'video'
        ], this.command = 'insertHTML';
    }
}
var $32780b0aacdc2595$var$$2c12cf671c105d76$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$2c12cf671c105d76$exports, "UndoTool", function() {
    return $32780b0aacdc2595$export$65235875731ff287;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$2c12cf671c105d76$exports, "RedoTool", function() {
    return $32780b0aacdc2595$export$b60f30d254d1e1a6;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$2c12cf671c105d76$exports, "ResetTool", function() {
    return $32780b0aacdc2595$export$6f46dc3d81fbb4bd;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$2c12cf671c105d76$exports, "ClearTool", function() {
    return $32780b0aacdc2595$export$25eb377ce1feaada;
});
class $32780b0aacdc2595$export$65235875731ff287 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Undo', this.command = 'undo';
    }
}
class $32780b0aacdc2595$export$b60f30d254d1e1a6 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Redo', this.command = 'redo';
    }
}
class $32780b0aacdc2595$export$6f46dc3d81fbb4bd extends $32780b0aacdc2595$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Reset', this.command = 'removeFormat';
    }
}
class $32780b0aacdc2595$export$25eb377ce1feaada extends $32780b0aacdc2595$export$724f6b867059ef5f {
    execute(editor) {
        editor.focus();
        document.execCommand('selectAll');
        document.execCommand('delete');
    }
    constructor(...args){
        super(...args), this.name = 'Clear';
    }
}
var $32780b0aacdc2595$var$$6e883fb0ea04260a$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$6e883fb0ea04260a$exports, "turndown", function() {
    return $32780b0aacdc2595$export$48d4d6bf65314082;
});
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$6e883fb0ea04260a$exports, "CopyMarkdownTool", function() {
    return $32780b0aacdc2595$export$4b13df0a6effdd72;
});
const $32780b0aacdc2595$var$$6e883fb0ea04260a$var$Empty_HREF = /^(#|javascript:\s*void\(0\);?\s*)$/;
const $32780b0aacdc2595$export$48d4d6bf65314082 = new (0, $2e0e3d0c95468c5e$export$2e2bcd8739ae039)({
    hr: '---',
    linkStyle: 'referenced',
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
}).use((0, $8b5b54c590bb494d$export$19426ff118fe8be)).use((0, $8b5b54c590bb494d$export$cc4ff83fc7bd256e)).use((0, $8b5b54c590bb494d$export$1f0c2747e2ba0b8d)).use((0, $8b5b54c590bb494d$export$59ffe8c4d7a4aab2)).addRule('non_url', {
    filter: (node)=>[
            'a',
            'area'
        ].includes(node.nodeName.toLowerCase()) && $32780b0aacdc2595$var$$6e883fb0ea04260a$var$Empty_HREF.test(node.getAttribute('href') || ''),
    replacement: ()=>''
}).addRule('img-srcset', {
    filter: [
        'img'
    ],
    replacement (_, { alt: alt, title: title, src: src, srcset: srcset }) {
        const [firstSet] = srcset.split(',')[0]?.split(/\s+/) || [];
        const content = [
            src || firstSet,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).addRule('source-srcset', {
    filter: [
        'picture'
    ],
    replacement (_, node) {
        const { src: src, alt: alt, title: title } = node.querySelector('img') || {};
        const sourceList = [
            ...node.querySelectorAll('source')
        ].map(({ sizes: sizes, srcset: srcset })=>{
            const size = Math.max(...sizes.split(/,|\)/).map((pixel)=>parseFloat(pixel.trim())).filter(Boolean));
            const [src] = srcset.split(',')[0]?.split(/\s+/) || [];
            return {
                size: size,
                src: src
            };
        });
        const sources = sourceList.sort(({ size: a }, { size: b })=>b - a);
        const content = [
            src || sources[0]?.src,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).remove((node)=>node.matches('style, script, aside, form, [class*="ads" i]')).keep((node)=>node.matches('kbd, iframe'));
class $32780b0aacdc2595$export$4b13df0a6effdd72 extends $32780b0aacdc2595$export$724f6b867059ef5f {
    async execute({ innerHTML: innerHTML }) {
        const markdown = $32780b0aacdc2595$export$48d4d6bf65314082.turndown(innerHTML);
        await navigator.clipboard.writeText(markdown);
        alert('Markdown copied to clipboard');
    }
    constructor(...args){
        super(...args), this.name = 'Copy Markdown';
    }
}
var $32780b0aacdc2595$var$$b738b8c7b1139833$exports = {};
$32780b0aacdc2595$var$$parcel$export($32780b0aacdc2595$var$$b738b8c7b1139833$exports, "editor", function() {
    return $32780b0aacdc2595$export$b5d042d2b680aed6;
});
const $32780b0aacdc2595$export$b5d042d2b680aed6 = (Class, {})=>class EditorTrait extends Class {
        async uploadFile(tool, data) {
            if (typeof data === 'string' && !/^(data|blob):/.test(data)) return data;
            try {
                return await tool.save(typeof data === 'string' ? await (0, $90MBA.blobOf)(data) : data);
            } catch (error) {
                console.error(error);
                if (typeof data === 'string') return data;
            }
        }
        async clearHTML(markup) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this, fragment = document.createDocumentFragment();
            fragment.append(...(0, $90MBA.parseDOM)(markup));
            for (const element of (0, $90MBA.walkDOM)(fragment, Node.ELEMENT_NODE)){
                const { style: style, dataset: dataset } = element;
                if ([
                    'nowrap',
                    'pre'
                ].includes(style.whiteSpace)) style.whiteSpace = 'normal';
                for(const key in dataset)delete dataset[key];
                if (element instanceof HTMLImageElement && imageTool) element.src = await this.uploadFile(imageTool, element.src);
                else if (element instanceof HTMLAudioElement && audioTool) element.src = await this.uploadFile(audioTool, element.src);
                else if (element instanceof HTMLVideoElement && videoTool) element.src = await this.uploadFile(videoTool, element.src);
            }
            return fragment;
        }
        async transferMedia(item) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this;
            if (item.type === 'text/html') {
                const raw = await new Promise((resolve)=>item.getAsString(resolve));
                (0, $90MBA.insertToCursor)(await this.clearHTML(raw));
            } else if (item.type.startsWith('image/') && imageTool) {
                const URI = await this.uploadFile(imageTool, item.getAsFile());
                if (URI) (0, $90MBA.insertToCursor)((0, $90MBA.parseDOM)(`<img src="${URI}" />`)[0]);
            } else if (item.type.startsWith('audio/') && audioTool) {
                const URI = await this.uploadFile(audioTool, item.getAsFile());
                if (URI) (0, $90MBA.insertToCursor)((0, $90MBA.parseDOM)(`<audio src="${URI}" />`)[0]);
            } else if (item.type.startsWith('video/') && videoTool) {
                const URI = await this.uploadFile(videoTool, item.getAsFile());
                if (URI) (0, $90MBA.insertToCursor)((0, $90MBA.parseDOM)(`<video src="${URI}" />`)[0]);
            }
        }
        constructor(...args){
            super(...args), this.handlePasteDrop = async (event)=>{
                event.preventDefault();
                const root = event.currentTarget;
                const list = event.type === 'paste' ? [
                    ...event.clipboardData.items
                ] : [
                    ...event.dataTransfer.items
                ];
                root.focus();
                const [plainText, htmlText] = list.filter(({ type: type })=>type.startsWith('text/'));
                if (!htmlText && plainText.type === 'text/plain') {
                    const raw = await new Promise((resolve)=>plainText.getAsString(resolve));
                    (0, $90MBA.insertToCursor)(await this.clearHTML((0, $80eeU.marked)(raw)));
                } else for (const item of list)await this.transferMedia(item);
                this.updateValue(root.innerHTML);
            };
        }
    };






var $5E6i4 = parcelRequire("5E6i4");
function $4502b45a00c40fa7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $4502b45a00c40fa7$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $4502b45a00c40fa7$var$$cdc0508c48dc9b5a$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$cdc0508c48dc9b5a$exports, "renderTool", function() {
    return $4502b45a00c40fa7$export$56ccecc1dac11363;
});
function $4502b45a00c40fa7$export$56ccecc1dac11363(editor) {
    const { title: title, active: active, icon: icon, usable: usable } = this;
    const Class = `btn btn-${(active ? '' : 'outline-') + 'secondary'} me-2 mb-2`;
    return (0, $90cae257cc958273$exports.jsx)("button", {
        type: "button",
        title: title,
        className: Class,
        style: {
            cursor: usable ? 'pointer' : 'not-allowed'
        },
        disabled: !usable,
        onClick: (event)=>{
            event.preventDefault();
            if (editor.current) this.execute(editor.current);
        },
        children: (0, $90cae257cc958273$exports.jsx)("i", {
            className: `bi-${icon}`
        })
    }, icon);
}
var $4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "TextTools", function() {
    return $4502b45a00c40fa7$export$e252ba763eff5cdc;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "ColorTools", function() {
    return $4502b45a00c40fa7$export$bdef6e97a10dbad4;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "LayoutTools", function() {
    return $4502b45a00c40fa7$export$145c1b37c0810d7;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "MediaTools", function() {
    return $4502b45a00c40fa7$export$999636c6e25075fb;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "ControlTools", function() {
    return $4502b45a00c40fa7$export$f35db4b82786c3a4;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "ExtraTools", function() {
    return $4502b45a00c40fa7$export$b8ecf7d74432d529;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "OriginalTools", function() {
    return $4502b45a00c40fa7$export$9ddb256264948609;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, "DefaultTools", function() {
    return $4502b45a00c40fa7$export$aa718db1466ce312;
});
var $4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "BoldTool", function() {
    return $4502b45a00c40fa7$export$10056a49e3b218eb;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "ItalicTool", function() {
    return $4502b45a00c40fa7$export$edf99d0f51bacb1e;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "UnderlineTool", function() {
    return $4502b45a00c40fa7$export$4b6d9c17188960d2;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "StrikeThroughTool", function() {
    return $4502b45a00c40fa7$export$a35bffaeae8fdda0;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "H1Tool", function() {
    return $4502b45a00c40fa7$export$30e8c6b428f8749f;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "H2Tool", function() {
    return $4502b45a00c40fa7$export$58443375efa91029;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "H3Tool", function() {
    return $4502b45a00c40fa7$export$75d24d6b8b747307;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "FontSizeDownTool", function() {
    return $4502b45a00c40fa7$export$a20806c6ef6938f8;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "FontSizeUpTool", function() {
    return $4502b45a00c40fa7$export$744da7e24e4a7382;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "SubscriptTool", function() {
    return $4502b45a00c40fa7$export$6137518b4e998008;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "SuperscriptTool", function() {
    return $4502b45a00c40fa7$export$7217f06c61ebd4fc;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports, "LinkTool", function() {
    return $4502b45a00c40fa7$export$f6c54364b5332e66;
});
class $4502b45a00c40fa7$export$10056a49e3b218eb extends (0, $32780b0aacdc2595$export$10056a49e3b218eb) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-bold'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$edf99d0f51bacb1e extends (0, $32780b0aacdc2595$export$edf99d0f51bacb1e) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-italic'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$4b6d9c17188960d2 extends (0, $32780b0aacdc2595$export$4b6d9c17188960d2) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-underline'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$a35bffaeae8fdda0 extends (0, $32780b0aacdc2595$export$a35bffaeae8fdda0) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-strikethrough'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$30e8c6b428f8749f extends (0, $32780b0aacdc2595$export$30e8c6b428f8749f) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h1'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$58443375efa91029 extends (0, $32780b0aacdc2595$export$58443375efa91029) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h2'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$75d24d6b8b747307 extends (0, $32780b0aacdc2595$export$75d24d6b8b747307) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h3'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$a20806c6ef6938f8 extends (0, $32780b0aacdc2595$export$a20806c6ef6938f8) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'sort-alpha-down'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$744da7e24e4a7382 extends (0, $32780b0aacdc2595$export$744da7e24e4a7382) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'sort-alpha-up'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$6137518b4e998008 extends (0, $32780b0aacdc2595$export$6137518b4e998008) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'box-arrow-down-right'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$7217f06c61ebd4fc extends (0, $32780b0aacdc2595$export$7217f06c61ebd4fc) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'box-arrow-up-right'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$f6c54364b5332e66 extends (0, $32780b0aacdc2595$export$f6c54364b5332e66) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'link'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
var $4502b45a00c40fa7$var$$159d45b0e11f50e4$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$159d45b0e11f50e4$exports, "ColorSelector", function() {
    return $4502b45a00c40fa7$export$9012acaf449cdfcb;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$159d45b0e11f50e4$exports, "renderColorTool", function() {
    return $4502b45a00c40fa7$export$e913fac2ab7b6f29;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$159d45b0e11f50e4$exports, "ForeColorTool", function() {
    return $4502b45a00c40fa7$export$cab0e15cfb8489d7;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$159d45b0e11f50e4$exports, "BackColorTool", function() {
    return $4502b45a00c40fa7$export$92bb6183e7459be2;
});
const $4502b45a00c40fa7$export$9012acaf449cdfcb = ({ className: className = '', title: title, type: type, value: value, onChange: onChange, icon: icon })=>(0, $90cae257cc958273$exports.jsxs)("span", {
        className: `d-inline-block align-middle position-relative ${className}`,
        title: title,
        children: [
            (0, $90cae257cc958273$exports.jsx)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: value,
                onChange: ({ target: { value: value } })=>onChange === null || onChange === void 0 ? void 0 : onChange(value)
            }),
            (0, $90cae257cc958273$exports.jsx)("button", {
                className: "btn",
                style: {
                    color: type === 'color' ? value : 'lightgray',
                    backgroundColor: type === 'color' ? 'white' : value,
                    borderColor: value
                },
                onClick: (event)=>{
                    event.preventDefault();
                    const input = event.currentTarget.previousElementSibling;
                    input.click();
                },
                children: (0, $90cae257cc958273$exports.jsx)("i", {
                    className: `bi-${icon}`,
                    style: type !== 'color' ? {
                        filter: 'invert(1)'
                    } : undefined
                })
            })
        ]
    });
function $4502b45a00c40fa7$export$e913fac2ab7b6f29(editor) {
    const { icon: icon, name: name, colorName: colorName } = this;
    return (0, $90cae257cc958273$exports.jsx)($4502b45a00c40fa7$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: name,
        icon: icon,
        type: colorName,
        value: this.getColor(),
        onChange: (color)=>editor.current && this.execute(editor.current, color)
    }, icon);
}
class $4502b45a00c40fa7$export$cab0e15cfb8489d7 extends (0, $32780b0aacdc2595$export$cab0e15cfb8489d7) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-font'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$e913fac2ab7b6f29
        });
    }
}
class $4502b45a00c40fa7$export$92bb6183e7459be2 extends (0, $32780b0aacdc2595$export$92bb6183e7459be2) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-font-fill'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$e913fac2ab7b6f29
        });
    }
}
var $4502b45a00c40fa7$var$$535edfb56a418bce$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "AlignLeftTool", function() {
    return $4502b45a00c40fa7$export$42a444ebfdcfe7b9;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "AlignCenterTool", function() {
    return $4502b45a00c40fa7$export$9a2e6e0294a984eb;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "AlignRightTool", function() {
    return $4502b45a00c40fa7$export$22363f91860fc258;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "AlignFullTool", function() {
    return $4502b45a00c40fa7$export$42827b1362fed748;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "OrderedListTool", function() {
    return $4502b45a00c40fa7$export$faf4e70f09f43a15;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "UnorderedListTool", function() {
    return $4502b45a00c40fa7$export$cf4030b57a3fbe37;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$535edfb56a418bce$exports, "HorizontalRuleTool", function() {
    return $4502b45a00c40fa7$export$dce8a7d6279fc201;
});
class $4502b45a00c40fa7$export$42a444ebfdcfe7b9 extends (0, $32780b0aacdc2595$export$42a444ebfdcfe7b9) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-left'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$9a2e6e0294a984eb extends (0, $32780b0aacdc2595$export$9a2e6e0294a984eb) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-center'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$22363f91860fc258 extends (0, $32780b0aacdc2595$export$22363f91860fc258) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-right'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$42827b1362fed748 extends (0, $32780b0aacdc2595$export$42827b1362fed748) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'justify'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$faf4e70f09f43a15 extends (0, $32780b0aacdc2595$export$faf4e70f09f43a15) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'list-ol'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$cf4030b57a3fbe37 extends (0, $32780b0aacdc2595$export$cf4030b57a3fbe37) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'list-ul'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$dce8a7d6279fc201 extends (0, $32780b0aacdc2595$export$dce8a7d6279fc201) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'reception-0'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
var $4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports, "IFrameTool", function() {
    return $4502b45a00c40fa7$export$3e557574863db086;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports, "ImageTool", function() {
    return $4502b45a00c40fa7$export$982f47444a2f88da;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports, "AudioTool", function() {
    return $4502b45a00c40fa7$export$6024938f37e646f8;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports, "VideoTool", function() {
    return $4502b45a00c40fa7$export$932111b8028f79ed;
});
class $4502b45a00c40fa7$export$3e557574863db086 extends (0, $32780b0aacdc2595$export$3e557574863db086) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'window'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$982f47444a2f88da extends (0, $32780b0aacdc2595$export$982f47444a2f88da) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'image'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$6024938f37e646f8 extends (0, $32780b0aacdc2595$export$6024938f37e646f8) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'voicemail'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$932111b8028f79ed extends (0, $32780b0aacdc2595$export$932111b8028f79ed) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'camera-video'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
var $4502b45a00c40fa7$var$$febe637794ea5d8f$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$febe637794ea5d8f$exports, "UndoTool", function() {
    return $4502b45a00c40fa7$export$65235875731ff287;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$febe637794ea5d8f$exports, "RedoTool", function() {
    return $4502b45a00c40fa7$export$b60f30d254d1e1a6;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$febe637794ea5d8f$exports, "ResetTool", function() {
    return $4502b45a00c40fa7$export$6f46dc3d81fbb4bd;
});
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$febe637794ea5d8f$exports, "ClearTool", function() {
    return $4502b45a00c40fa7$export$25eb377ce1feaada;
});
class $4502b45a00c40fa7$export$65235875731ff287 extends (0, $32780b0aacdc2595$export$65235875731ff287) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'arrow-counterclockwise'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$b60f30d254d1e1a6 extends (0, $32780b0aacdc2595$export$b60f30d254d1e1a6) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'arrow-clockwise'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$6f46dc3d81fbb4bd extends (0, $32780b0aacdc2595$export$6f46dc3d81fbb4bd) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'eraser'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
class $4502b45a00c40fa7$export$25eb377ce1feaada extends (0, $32780b0aacdc2595$export$25eb377ce1feaada) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-x'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
var $4502b45a00c40fa7$var$$c87344349145242d$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$c87344349145242d$exports, "CopyMarkdownTool", function() {
    return $4502b45a00c40fa7$export$4b13df0a6effdd72;
});
class $4502b45a00c40fa7$export$4b13df0a6effdd72 extends (0, $32780b0aacdc2595$export$4b13df0a6effdd72) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'markdown'
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $4502b45a00c40fa7$export$56ccecc1dac11363
        });
    }
}
const $4502b45a00c40fa7$export$e252ba763eff5cdc = [
    $4502b45a00c40fa7$export$10056a49e3b218eb,
    $4502b45a00c40fa7$export$edf99d0f51bacb1e,
    $4502b45a00c40fa7$export$4b6d9c17188960d2,
    $4502b45a00c40fa7$export$a35bffaeae8fdda0,
    $4502b45a00c40fa7$export$30e8c6b428f8749f,
    $4502b45a00c40fa7$export$58443375efa91029,
    $4502b45a00c40fa7$export$75d24d6b8b747307,
    $4502b45a00c40fa7$export$a20806c6ef6938f8,
    $4502b45a00c40fa7$export$744da7e24e4a7382,
    $4502b45a00c40fa7$export$6137518b4e998008,
    $4502b45a00c40fa7$export$7217f06c61ebd4fc,
    $4502b45a00c40fa7$export$f6c54364b5332e66
];
const $4502b45a00c40fa7$export$bdef6e97a10dbad4 = [
    $4502b45a00c40fa7$export$cab0e15cfb8489d7,
    $4502b45a00c40fa7$export$92bb6183e7459be2
];
const $4502b45a00c40fa7$export$145c1b37c0810d7 = [
    $4502b45a00c40fa7$export$42a444ebfdcfe7b9,
    $4502b45a00c40fa7$export$9a2e6e0294a984eb,
    $4502b45a00c40fa7$export$22363f91860fc258,
    $4502b45a00c40fa7$export$42827b1362fed748,
    $4502b45a00c40fa7$export$faf4e70f09f43a15,
    $4502b45a00c40fa7$export$cf4030b57a3fbe37,
    $4502b45a00c40fa7$export$dce8a7d6279fc201
];
const $4502b45a00c40fa7$export$999636c6e25075fb = [
    $4502b45a00c40fa7$export$3e557574863db086,
    $4502b45a00c40fa7$export$982f47444a2f88da,
    $4502b45a00c40fa7$export$6024938f37e646f8,
    $4502b45a00c40fa7$export$932111b8028f79ed
];
const $4502b45a00c40fa7$export$f35db4b82786c3a4 = [
    $4502b45a00c40fa7$export$65235875731ff287,
    $4502b45a00c40fa7$export$b60f30d254d1e1a6,
    $4502b45a00c40fa7$export$6f46dc3d81fbb4bd,
    $4502b45a00c40fa7$export$25eb377ce1feaada
];
const $4502b45a00c40fa7$export$b8ecf7d74432d529 = [
    $4502b45a00c40fa7$export$4b13df0a6effdd72
];
const $4502b45a00c40fa7$export$9ddb256264948609 = [
    ...$4502b45a00c40fa7$export$e252ba763eff5cdc,
    ...$4502b45a00c40fa7$export$bdef6e97a10dbad4,
    ...$4502b45a00c40fa7$export$145c1b37c0810d7,
    ...$4502b45a00c40fa7$export$999636c6e25075fb,
    ...$4502b45a00c40fa7$export$f35db4b82786c3a4
];
const $4502b45a00c40fa7$export$aa718db1466ce312 = [
    $4502b45a00c40fa7$export$10056a49e3b218eb,
    $4502b45a00c40fa7$export$edf99d0f51bacb1e,
    $4502b45a00c40fa7$export$4b6d9c17188960d2,
    $4502b45a00c40fa7$export$a35bffaeae8fdda0,
    $4502b45a00c40fa7$export$30e8c6b428f8749f,
    $4502b45a00c40fa7$export$58443375efa91029,
    $4502b45a00c40fa7$export$75d24d6b8b747307,
    $4502b45a00c40fa7$export$6137518b4e998008,
    $4502b45a00c40fa7$export$7217f06c61ebd4fc,
    $4502b45a00c40fa7$export$cab0e15cfb8489d7,
    $4502b45a00c40fa7$export$92bb6183e7459be2,
    $4502b45a00c40fa7$export$42a444ebfdcfe7b9,
    $4502b45a00c40fa7$export$9a2e6e0294a984eb,
    $4502b45a00c40fa7$export$22363f91860fc258,
    $4502b45a00c40fa7$export$42827b1362fed748,
    $4502b45a00c40fa7$export$faf4e70f09f43a15,
    $4502b45a00c40fa7$export$cf4030b57a3fbe37,
    $4502b45a00c40fa7$export$dce8a7d6279fc201,
    $4502b45a00c40fa7$export$982f47444a2f88da,
    $4502b45a00c40fa7$export$65235875731ff287,
    $4502b45a00c40fa7$export$b60f30d254d1e1a6,
    $4502b45a00c40fa7$export$25eb377ce1feaada
];
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$06ffa27f686e3a7a$exports);
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$159d45b0e11f50e4$exports);
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$535edfb56a418bce$exports);
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$66ddfdbe9f9ae9ac$exports);
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$febe637794ea5d8f$exports);
$4502b45a00c40fa7$var$$parcel$exportWildcard($4502b45a00c40fa7$var$$d894f2733a8d7f0d$exports, $4502b45a00c40fa7$var$$c87344349145242d$exports);
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$exports = {};
$4502b45a00c40fa7$var$$parcel$export($4502b45a00c40fa7$var$$5d82d366027a3cf0$exports, "Editor", function() {
    return $4502b45a00c40fa7$export$7cda8d932e2f33c0;
});
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $4502b45a00c40fa7$export$7cda8d932e2f33c0 = (()=>{
    var _Editor_cursorPoint_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149),
        (0, $32780b0aacdc2595$export$b5d042d2b680aed6)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    let _instanceExtraInitializers = [];
    let _cursorPoint_decorators;
    let _cursorPoint_initializers = [];
    let _cursorPoint_extraInitializers = [];
    let _get_toolList_decorators;
    let _get_imageTool_decorators;
    let _get_audioTool_decorators;
    let _get_videoTool_decorators;
    var Editor = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "box", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__runInitializers(this, _instanceExtraInitializers), (0, $5E6i4.createRef)())
            });
            _Editor_cursorPoint_accessor_storage.set(this, $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__runInitializers(this, _cursorPoint_initializers, ''));
            Object.defineProperty(this, "updateTools", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__runInitializers(this, _cursorPoint_extraInitializers), ()=>{
                    var _a;
                    if (this.box.current !== document.activeElement) return;
                    const { endContainer: endContainer } = getSelection().getRangeAt(0) || {};
                    const { x: x, y: y } = ((_a = endContainer instanceof Element ? endContainer : endContainer.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {};
                    this.cursorPoint = [
                        x,
                        y
                    ] + '';
                })
            });
            Object.defineProperty(this, "updateValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (markup)=>this.innerValue = markup.trim()
            });
        }
        get cursorPoint() {
            return $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__classPrivateFieldGet(this, _Editor_cursorPoint_accessor_storage, "f");
        }
        set cursorPoint(value) {
            $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__classPrivateFieldSet(this, _Editor_cursorPoint_accessor_storage, value, "f");
        }
        get toolList() {
            return (this.observedProps.tools || $4502b45a00c40fa7$export$aa718db1466ce312).map((ToolButton)=>new ToolButton());
        }
        get imageTool() {
            return this.toolList.find((tool)=>tool instanceof (0, $32780b0aacdc2595$export$982f47444a2f88da));
        }
        get audioTool() {
            return this.toolList.find((tool)=>tool instanceof $4502b45a00c40fa7$export$6024938f37e646f8);
        }
        get videoTool() {
            return this.toolList.find((tool)=>tool instanceof $4502b45a00c40fa7$export$932111b8028f79ed);
        }
        componentDidMount() {
            super.componentDidMount();
            const { defaultValue: defaultValue } = this.props;
            if (defaultValue != null) this.box.current.innerHTML = defaultValue;
            document.addEventListener('selectionchange', this.updateTools);
        }
        componentWillUnmount() {
            super.componentWillUnmount();
            document.removeEventListener('selectionchange', this.updateTools);
        }
        render() {
            // Don't remove unused variable `cursorPoint`, which is used for triggering updates
            const { cursorPoint: cursorPoint, toolList: toolList, innerValue: innerValue } = this, { name: name } = this.props;
            return (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    (0, $90cae257cc958273$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.8/dist/css/bootstrap.min.css"
                    }),
                    (0, $90cae257cc958273$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap-icons@1.13.1/font/bootstrap-icons.css"
                    }),
                    (0, $90cae257cc958273$exports.jsx)("header", {
                        children: toolList.map((tool)=>tool.render(this.box))
                    }),
                    (0, $90cae257cc958273$exports.jsx)("div", {
                        ref: this.box,
                        className: "form-control h-auto",
                        contentEditable: true,
                        tabIndex: 0,
                        role: "textbox",
                        "aria-multiline": "true",
                        onInput: ({ currentTarget: { innerHTML: innerHTML } })=>this.updateValue(innerHTML),
                        onPaste: this.handlePasteDrop,
                        onDrop: this.handlePasteDrop
                    }),
                    (0, $90cae257cc958273$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: innerValue
                    })
                ]
            });
        }
    };
    _Editor_cursorPoint_accessor_storage = new WeakMap();
    $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__setFunctionName(_classThis, "Editor");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _cursorPoint_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_toolList_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_imageTool_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_audioTool_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_videoTool_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(_classThis, null, _cursorPoint_decorators, {
            kind: "accessor",
            name: "cursorPoint",
            static: false,
            private: false,
            access: {
                has: (obj)=>"cursorPoint" in obj,
                get: (obj)=>obj.cursorPoint,
                set: (obj, value)=>{
                    obj.cursorPoint = value;
                }
            },
            metadata: _metadata
        }, _cursorPoint_initializers, _cursorPoint_extraInitializers);
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(_classThis, null, _get_toolList_decorators, {
            kind: "getter",
            name: "toolList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"toolList" in obj,
                get: (obj)=>obj.toolList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(_classThis, null, _get_imageTool_decorators, {
            kind: "getter",
            name: "imageTool",
            static: false,
            private: false,
            access: {
                has: (obj)=>"imageTool" in obj,
                get: (obj)=>obj.imageTool
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(_classThis, null, _get_audioTool_decorators, {
            kind: "getter",
            name: "audioTool",
            static: false,
            private: false,
            access: {
                has: (obj)=>"audioTool" in obj,
                get: (obj)=>obj.audioTool
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(_classThis, null, _get_videoTool_decorators, {
            kind: "getter",
            name: "videoTool",
            static: false,
            private: false,
            access: {
                has: (obj)=>"videoTool" in obj,
                get: (obj)=>obj.videoTool
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Editor = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Editor'
    });
    (()=>{
        $4502b45a00c40fa7$var$$5d82d366027a3cf0$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Editor = _classThis;
})();



var $90MBA = parcelRequire("90MBA");




var $f8df7fe8a4125ccd$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f8df7fe8a4125ccd$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f8df7fe8a4125ccd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f8df7fe8a4125ccd$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $f8df7fe8a4125ccd$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f8df7fe8a4125ccd$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f8df7fe8a4125ccd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $f8df7fe8a4125ccd$export$341e3470805a945e = (()=>{
    var _RestForm_form, _RestForm_validated_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _validated_decorators;
    let _validated_initializers = [];
    let _validated_extraInitializers = [];
    let _init_decorators;
    let _get_fields_decorators;
    let _get_readOnly_decorators;
    let _get_customValidation_decorators;
    let _get_fieldReady_decorators;
    var RestForm = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _RestForm_validated_accessor_storage.set(this, ($f8df7fe8a4125ccd$var$__runInitializers(this, _instanceExtraInitializers), $f8df7fe8a4125ccd$var$__runInitializers(this, _validated_initializers, false)));
            _RestForm_form.set(this, ($f8df7fe8a4125ccd$var$__runInitializers(this, _validated_extraInitializers), /*#__PURE__*/ (0, $5E6i4.createRef)()));
            Object.defineProperty(this, "handleUnload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>{
                    var _a;
                    if ((_a = $f8df7fe8a4125ccd$var$__classPrivateFieldGet(this, _RestForm_form, "f").current) === null || _a === void 0 ? void 0 : _a.checkValidity()) return;
                    event.preventDefault();
                    event.returnValue = '';
                }
            });
            Object.defineProperty(this, "handleSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>$f8df7fe8a4125ccd$var$__awaiter(this, void 0, void 0, function*() {
                        event.preventDefault();
                        event.stopPropagation();
                        const form = event.currentTarget;
                        const valid = form.checkValidity();
                        this.validated = true;
                        if (valid) {
                            const { id: id, store: store, onSubmit: onSubmit } = this.props;
                            let data = (0, $90MBA.formToJSON)(form);
                            data = (yield store === null || store === void 0 ? void 0 : store.updateOne(data, id)) || data;
                            onSubmit === null || onSubmit === void 0 || onSubmit(data);
                            store === null || store === void 0 || store.clearCurrent();
                        }
                        this.validated = false;
                    })
            });
            Object.defineProperty(this, "handleReset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ currentTarget: currentTarget })=>{
                    const { onReset: onReset, store: store } = this.props;
                    onReset === null || onReset === void 0 || onReset((0, $90MBA.formToJSON)(currentTarget));
                    store === null || store === void 0 || store.clearCurrent();
                }
            });
            Object.defineProperty(this, "renderFile", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a)=>{
                    var { key: key = '', type: type, required: required, multiple: multiple, accept: accept, uploader: uploader, onView: onView } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                        "key",
                        "type",
                        "required",
                        "multiple",
                        "accept",
                        "uploader",
                        "onView"
                    ]);
                    return ({ [key]: paths })=>{
                        const value = (Array.isArray(paths) ? paths : [
                            paths
                        ]).filter(Boolean);
                        return (0, $90cae257cc958273$exports.jsx)(RestForm.FieldBox, Object.assign({
                            name: key
                        }, meta, {
                            children: uploader ? (0, $90cae257cc958273$exports.jsx)((0, $39904e2d513e8a93$export$1a5cb5295a7d2749), {
                                store: uploader,
                                name: key.toString(),
                                required: required,
                                multiple: multiple,
                                accept: accept,
                                onView: onView,
                                defaultValue: value
                            }) : value.map((path)=>(0, $90cae257cc958273$exports.jsx)((0, $c3e520f711d060ed$export$a127194569a41afb), {
                                    type: type,
                                    path: path
                                }, path))
                        }));
                    };
                }
            });
            Object.defineProperty(this, "renderCheckGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a)=>{
                    var { key: key = '', type: type, options: options = [] } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                        "key",
                        "type",
                        "options"
                    ]);
                    return (data)=>(0, $90cae257cc958273$exports.jsx)(RestForm.FieldBox, Object.assign({
                            name: key
                        }, meta, {
                            children: (0, $90cae257cc958273$exports.jsx)("div", {
                                children: this.fieldReady && options.map(({ value: value, label: label = value })=>{
                                    var _a;
                                    return (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Check, Object.assign({
                                        id: [
                                            key,
                                            value
                                        ] + '',
                                        label: label,
                                        inline: true
                                    }, meta, {
                                        type: type,
                                        name: key.toString(),
                                        value: value,
                                        defaultChecked: (_a = data[key]) === null || _a === void 0 ? void 0 : _a.includes(value)
                                    }), value);
                                })
                            })
                        }));
                }
            });
            Object.defineProperty(this, "renderMultipleInput", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a)=>{
                    var { key: key = '', type: type } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                        "key",
                        "type"
                    ]);
                    return ({ [key]: value })=>(0, $90cae257cc958273$exports.jsx)(RestForm.FieldBox, Object.assign({
                            name: key
                        }, meta, {
                            children: this.fieldReady && (0, $90cae257cc958273$exports.jsx)((0, $efbee1975352f32e$export$76834b0602c89bd), Object.assign({}, meta, {
                                name: key.toString(),
                                defaultValue: value
                            }))
                        }));
                }
            });
            Object.defineProperty(this, "renderHTMLEditor", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a)=>{
                    var { key: key = '', contentEditable: contentEditable, tools: tools } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                        "key",
                        "contentEditable",
                        "tools"
                    ]);
                    return ({ [key]: value })=>(0, $90cae257cc958273$exports.jsx)(RestForm.FieldBox, Object.assign({
                            name: key
                        }, meta, {
                            children: this.fieldReady && (0, $90cae257cc958273$exports.jsx)((0, $4502b45a00c40fa7$export$7cda8d932e2f33c0), {
                                tools: tools,
                                name: key.toString(),
                                defaultValue: value
                            })
                        }));
                }
            });
            Object.defineProperty(this, "renderField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a, props)=>{
                    var { key: key = '', type: type, step: step, renderLabel: renderLabel, renderInput: renderInput, validMessage: validMessage, invalidMessage: invalidMessage } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                        "key",
                        "type",
                        "step",
                        "renderLabel",
                        "renderInput",
                        "validMessage",
                        "invalidMessage"
                    ]);
                    if (props === void 0) props = {};
                    const label = typeof renderLabel === 'function' ? renderLabel(key) : renderLabel || key;
                    return ({ [key]: value })=>(0, $90cae257cc958273$exports.jsxs)((0, $915d79f60ae535f6$export$2e2bcd8739ae039), {
                            hasValidation: this.customValidation,
                            children: [
                                this.fieldReady && (0, $90cae257cc958273$exports.jsx)((0, $8952f8f68509b392$export$56e87bf42978147a), Object.assign({}, props, meta, {
                                    type: type,
                                    step: step,
                                    label: label,
                                    size: this.observedProps.size,
                                    name: key.toString(),
                                    defaultValue: RestForm.dateValueOf({
                                        type: type,
                                        step: step
                                    }, value)
                                })),
                                validMessage && (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control.Feedback, {
                                    tooltip: true,
                                    type: "valid",
                                    children: validMessage
                                }),
                                invalidMessage && (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control.Feedback, {
                                    tooltip: true,
                                    type: "invalid",
                                    children: invalidMessage
                                })
                            ]
                        });
                }
            });
        }
        get validated() {
            return $f8df7fe8a4125ccd$var$__classPrivateFieldGet(this, _RestForm_validated_accessor_storage, "f");
        }
        set validated(value) {
            $f8df7fe8a4125ccd$var$__classPrivateFieldSet(this, _RestForm_validated_accessor_storage, value, "f");
        }
        componentDidMount() {
            super.componentDidMount();
            this.init();
            window.addEventListener('beforeunload', this.handleUnload);
        }
        init() {
            const { id: id, store: store } = this.props;
            if (id) return store === null || store === void 0 ? void 0 : store.getOne(id);
        }
        componentWillUnmount() {
            super.componentWillUnmount();
            window.removeEventListener('beforeunload', this.handleUnload);
        }
        get fields() {
            const { fields: fields } = this.observedProps;
            return fields.map((_a)=>{
                var { renderInput: renderInput } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                    "renderInput"
                ]);
                return Object.assign(Object.assign({}, meta), {
                    renderInput: renderInput !== null && renderInput !== void 0 ? renderInput : meta.type === 'file' ? this.renderFile(meta) : (meta.type === 'radio' || meta.type === 'checkbox') && meta.options ? this.renderCheckGroup(meta) : meta.contentEditable ? this.renderHTMLEditor(meta) : !meta.options && meta.multiple ? this.renderMultipleInput(meta) : meta.key && this.renderField(meta, meta.rows && !meta.options ? {
                        as: 'textarea'
                    } : {})
                });
            });
        }
        get readOnly() {
            return this.fields.every(({ readOnly: readOnly, disabled: disabled })=>readOnly || disabled);
        }
        get customValidation() {
            return this.fields.some(({ validMessage: validMessage, invalidMessage: invalidMessage })=>validMessage || invalidMessage);
        }
        get fieldReady() {
            const { id: id, store: store } = this.observedProps;
            return !id || !store || store.downloading < 1;
        }
        render() {
            const { fields: fields, readOnly: readOnly, customValidation: customValidation, validated: validated } = this, _a = this.props, { id: id, className: className = 'd-flex flex-column gap-3', size: size, store: store, translator: translator } = _a, props = $f8df7fe8a4125ccd$var$__rest(_a, [
                "id",
                "className",
                "size",
                "store",
                "translator"
            ]);
            const { downloading: downloading = 0, uploading: uploading = 0, currentOne: currentOne = {} } = store || {}, { t: t } = translator;
            const loading = downloading > 0 || uploading > 0;
            return (0, $90cae257cc958273$exports.jsxs)((0, $feacaa078f2a172d$export$2e2bcd8739ae039), Object.assign({
                ref: $f8df7fe8a4125ccd$var$__classPrivateFieldGet(this, _RestForm_form, "f")
            }, props, {
                className: className,
                validated: validated,
                noValidate: customValidation,
                onSubmit: this.handleSubmit,
                onReset: this.handleReset,
                children: [
                    fields.map((_a)=>{
                        var _b;
                        var { renderInput: renderInput } = _a, meta = $f8df7fe8a4125ccd$var$__rest(_a, [
                            "renderInput"
                        ]);
                        return (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                            children: renderInput === null || renderInput === void 0 ? void 0 : renderInput(currentOne, meta)
                        }, (_b = meta.key) === null || _b === void 0 ? void 0 : _b.toString());
                    }),
                    !readOnly && (0, $90cae257cc958273$exports.jsxs)("footer", {
                        className: "d-flex gap-3",
                        children: [
                            (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                className: "flex-fill",
                                size: size,
                                type: "submit",
                                disabled: loading,
                                children: t('submit')
                            }),
                            (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                className: "flex-fill",
                                size: size,
                                type: "reset",
                                variant: "danger",
                                disabled: loading,
                                children: t('cancel')
                            })
                        ]
                    })
                ]
            }));
        }
    };
    _RestForm_form = new WeakMap();
    _RestForm_validated_accessor_storage = new WeakMap();
    $f8df7fe8a4125ccd$var$__setFunctionName(_classThis, "RestForm");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _validated_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _init_decorators = [
            (0, $85705ec7803c1445$export$7203b476385689ae)(({ observedProps: { id: id } })=>id)
        ];
        _get_fields_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_readOnly_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_customValidation_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_fieldReady_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _validated_decorators, {
            kind: "accessor",
            name: "validated",
            static: false,
            private: false,
            access: {
                has: (obj)=>"validated" in obj,
                get: (obj)=>obj.validated,
                set: (obj, value)=>{
                    obj.validated = value;
                }
            },
            metadata: _metadata
        }, _validated_initializers, _validated_extraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _init_decorators, {
            kind: "method",
            name: "init",
            static: false,
            private: false,
            access: {
                has: (obj)=>"init" in obj,
                get: (obj)=>obj.init
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _get_fields_decorators, {
            kind: "getter",
            name: "fields",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fields" in obj,
                get: (obj)=>obj.fields
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _get_readOnly_decorators, {
            kind: "getter",
            name: "readOnly",
            static: false,
            private: false,
            access: {
                has: (obj)=>"readOnly" in obj,
                get: (obj)=>obj.readOnly
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _get_customValidation_decorators, {
            kind: "getter",
            name: "customValidation",
            static: false,
            private: false,
            access: {
                has: (obj)=>"customValidation" in obj,
                get: (obj)=>obj.customValidation
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(_classThis, null, _get_fieldReady_decorators, {
            kind: "getter",
            name: "fieldReady",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fieldReady" in obj,
                get: (obj)=>obj.fieldReady
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f8df7fe8a4125ccd$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RestForm = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'RestForm'
    });
    Object.defineProperty(_classThis, "dateValueOf", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ({ type: type, step: step = '60' }, raw)=>(0, $90MBA.isEmpty)(raw) ? raw : type === 'month' ? (0, $90MBA.formatDate)(raw, 'YYYY-MM') : type === 'date' ? (0, $90MBA.formatDate)(raw, 'YYYY-MM-DD') : type === 'datetime-local' ? (0, $90MBA.formatDate)(raw, `YYYY-MM-DDTHH:mm${+step < 60 ? ':ss' : ''}`) : raw
    });
    Object.defineProperty(_classThis, "FieldBox", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: (_a)=>{
            var { name: name = '', renderLabel: renderLabel, validMessage: validMessage, invalidMessage: invalidMessage, children: children } = _a, props = $f8df7fe8a4125ccd$var$__rest(_a, [
                "name",
                "renderLabel",
                "validMessage",
                "invalidMessage",
                "children"
            ]);
            return (0, $90cae257cc958273$exports.jsxs)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Group, Object.assign({}, props, {
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Label, {
                        children: typeof renderLabel === 'function' ? renderLabel(name) : renderLabel || name
                    }),
                    children,
                    validMessage && (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control.Feedback, {
                        tooltip: true,
                        type: "valid",
                        children: validMessage
                    }),
                    invalidMessage && (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control.Feedback, {
                        tooltip: true,
                        type: "invalid",
                        children: invalidMessage
                    })
                ]
            }));
        }
    });
    (()=>{
        $f8df7fe8a4125ccd$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RestForm = _classThis;
})();





var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


const $39cf42abeb4c9d8a$var$PageItem = /*#__PURE__*/ $5E6i4.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = '(current)', children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $0213f21feff22344$export$2e2bcd8739ae039), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$39cf42abeb4c9d8a$var$PageItem.displayName = 'PageItem';
var $39cf42abeb4c9d8a$export$2e2bcd8739ae039 = $39cf42abeb4c9d8a$var$PageItem;
function $39cf42abeb4c9d8a$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $5E6i4.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($39cf42abeb4c9d8a$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $39cf42abeb4c9d8a$export$b25abba66f7be210 = $39cf42abeb4c9d8a$var$createButton('First', "\xab");
const $39cf42abeb4c9d8a$export$1b265216817111b9 = $39cf42abeb4c9d8a$var$createButton('Prev', "\u2039", 'Previous');
const $39cf42abeb4c9d8a$export$1297970233533a7d = $39cf42abeb4c9d8a$var$createButton('Ellipsis', "\u2026", 'More');
const $39cf42abeb4c9d8a$export$b820fc49f2736e85 = $39cf42abeb4c9d8a$var$createButton('Next', "\u203A");
const $39cf42abeb4c9d8a$export$bed9238d8933c9a8 = $39cf42abeb4c9d8a$var$createButton('Last', "\xbb");



"use client";
const $4e3b2df7581edf4b$var$Pagination = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$4e3b2df7581edf4b$var$Pagination.displayName = 'Pagination';
var $4e3b2df7581edf4b$export$2e2bcd8739ae039 = Object.assign($4e3b2df7581edf4b$var$Pagination, {
    First: $39cf42abeb4c9d8a$export$b25abba66f7be210,
    Prev: $39cf42abeb4c9d8a$export$1b265216817111b9,
    Ellipsis: $39cf42abeb4c9d8a$export$1297970233533a7d,
    Item: (0, $39cf42abeb4c9d8a$export$2e2bcd8739ae039),
    Next: $39cf42abeb4c9d8a$export$b820fc49f2736e85,
    Last: $39cf42abeb4c9d8a$export$bed9238d8933c9a8
});



var $90MBA = parcelRequire("90MBA");
const $d427ab120c9993c6$export$57625d62e5386b09 = ({ pageSize: pageSize, pageIndex: pageIndex, pageCount: pageCount, onChange: onChange })=>{
    function propsOf(pageIndex = 1) {
        const pagination = {
            pageSize: pageSize,
            pageIndex: pageIndex
        };
        return {
            href: `?${(0, $90MBA.buildURLData)(Object.assign(Object.assign({}, (0, $90MBA.parseURLData)()), pagination))}`,
            onClick: onChange && ((event)=>{
                event.preventDefault();
                onChange(pagination);
            })
        };
    }
    return (0, $90cae257cc958273$exports.jsxs)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: onChange && ((event)=>(event.preventDefault(), event.stopPropagation())),
        children: [
            (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control, {
                type: "number",
                name: "pageSize",
                defaultValue: pageSize,
                min: 1,
                required: true,
                onChange: ({ currentTarget: input })=>input.reportValidity() && (onChange === null || onChange === void 0 ? void 0 : onChange({
                        pageSize: +input.value,
                        pageIndex: pageIndex
                    }))
            }),
            "x",
            (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control, {
                type: "number",
                name: "pageIndex",
                defaultValue: pageIndex || 1,
                min: 1,
                max: pageCount,
                required: true,
                onChange: ({ currentTarget: input })=>input.reportValidity() && (onChange === null || onChange === void 0 ? void 0 : onChange({
                        pageSize: pageSize,
                        pageIndex: +input.value
                    }))
            }),
            (0, $90cae257cc958273$exports.jsxs)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039), {
                className: "m-0",
                children: [
                    pageIndex > 1 && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Item, Object.assign({}, propsOf(1), {
                        children: "1"
                    })),
                    pageIndex > 3 && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Ellipsis, {}),
                    pageIndex > 2 && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Item, Object.assign({}, propsOf(pageIndex - 1), {
                        children: pageIndex - 1
                    })),
                    (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Item, {
                        active: true,
                        children: pageIndex
                    }),
                    pageCount - pageIndex > 1 && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Item, Object.assign({}, propsOf(pageIndex + 1), {
                        children: pageIndex + 1
                    })),
                    pageCount - pageIndex > 2 && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Ellipsis, {}),
                    pageIndex < pageCount && (0, $90cae257cc958273$exports.jsx)((0, $4e3b2df7581edf4b$export$2e2bcd8739ae039).Item, Object.assign({}, propsOf(pageCount), {
                        children: pageCount
                    }))
                ]
            })
        ]
    });
};
$d427ab120c9993c6$export$57625d62e5386b09.displayName = 'Pager';




var $5pSp9 = parcelRequire("5pSp9");





var $90MBA = parcelRequire("90MBA");








var $90MBA = parcelRequire("90MBA");

var $44fb5804d3caf3b9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $44fb5804d3caf3b9$export$28baae8ef86bbf36 = (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)((_a)=>{
    var { fields: fields, store: store, translator: translator } = _a, props = $44fb5804d3caf3b9$var$__rest(_a, [
        "fields",
        "store",
        "translator"
    ]);
    const { indexKey: indexKey, currentOne: currentOne } = store || {};
    const editing = !(0, $90MBA.isEmpty)(currentOne), ID = currentOne === null || currentOne === void 0 ? void 0 : currentOne[indexKey];
    return (0, $90cae257cc958273$exports.jsxs)((0, $96a8772939a28a36$export$2e2bcd8739ae039), {
        show: editing,
        onHide: ()=>store === null || store === void 0 ? void 0 : store.clearCurrent(),
        children: [
            (0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: ID
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039).Body, {
                children: (0, $90cae257cc958273$exports.jsx)((0, $f8df7fe8a4125ccd$export$341e3470805a945e), Object.assign({
                    id: ID,
                    fields: fields,
                    store: store,
                    translator: translator
                }, props))
            })
        ]
    });
});


var $c43edd238e7c1e1b$export$5eeb11949c905cc1;
$c43edd238e7c1e1b$export$5eeb11949c905cc1 = `SrGRNq_filterBar`;


var $c51ce0f384b28c9c$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c51ce0f384b28c9c$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c51ce0f384b28c9c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c51ce0f384b28c9c$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c51ce0f384b28c9c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c51ce0f384b28c9c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c51ce0f384b28c9c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $c51ce0f384b28c9c$export$fd90441354a7d816 = (()=>{
    var _RestTable_checkedKeys_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _init_decorators;
    let _get_fieldSize_decorators;
    let _checkedKeys_decorators;
    let _checkedKeys_initializers = [];
    let _checkedKeys_extraInitializers = [];
    let _get_checkColumn_decorators;
    let _get_operateColumn_decorators;
    let _get_columns_decorators;
    let _get_hasHeader_decorators;
    let _get_hasFooter_decorators;
    let _get_editing_decorators;
    var RestTable = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _RestTable_checkedKeys_accessor_storage.set(this, ($c51ce0f384b28c9c$var$__runInitializers(this, _instanceExtraInitializers), $c51ce0f384b28c9c$var$__runInitializers(this, _checkedKeys_initializers, [])));
            Object.defineProperty(this, "toggleCheckAll", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c51ce0f384b28c9c$var$__runInitializers(this, _checkedKeys_extraInitializers), ()=>{
                    const { store: store, onCheck: onCheck } = this.props;
                    const { indexKey: indexKey, currentPage: currentPage } = store;
                    this.checkedKeys = this.checkedKeys.length ? [] : currentPage.map(({ [indexKey]: ID })=>ID);
                    onCheck === null || onCheck === void 0 || onCheck(this.checkedKeys);
                })
            });
            Object.defineProperty(this, "renderCustomBody", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ key: key = '', type: type, multiple: multiple, options: options, accept: accept, rows: rows })=>type === 'url' ? ({ [key]: value })=>value && (0, $90cae257cc958273$exports.jsx)("a", {
                            target: "_blank",
                            href: value,
                            children: value
                        }) : type === 'email' ? ({ [key]: value })=>value && (0, $90cae257cc958273$exports.jsx)("a", {
                            href: `mailto:${value}`,
                            children: value
                        }) : type === 'tel' ? ({ [key]: value })=>value && (0, $90cae257cc958273$exports.jsx)("a", {
                            href: `tel:${value}`,
                            children: value
                        }) : type === 'file' ? ({ [key]: value })=>(Array.isArray(value) ? value : [
                            value
                        ]).map((path)=>path && (0, $90cae257cc958273$exports.jsx)((0, $c3e520f711d060ed$export$a127194569a41afb), {
                                type: accept,
                                path: path
                            }, path)) : options || multiple ? ({ [key]: value })=>value && (0, $90cae257cc958273$exports.jsx)((0, $9784173a5043df33$export$ef1c4106ceccca63), {
                            list: value.map((text)=>({
                                    text: text
                                }))
                        }) : !options && rows ? ({ [key]: value })=>(0, $90cae257cc958273$exports.jsx)("p", {
                            className: "m-0 text-truncate",
                            style: {
                                maxWidth: '20rem'
                            },
                            title: value,
                            children: value
                        }) : undefined
            });
            Object.defineProperty(this, "getList", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (0, $5pSp9.debounce)(({ pageIndex: pageIndex, pageSize: pageSize })=>{
                    const { store: store, filter: filter } = this.props;
                    if (store.downloading < 1) store.getList(filter, pageIndex, pageSize);
                })
            });
        }
        componentDidMount() {
            super.componentDidMount();
            this.init();
        }
        init() {
            const { store: store, filter: filter } = this.props;
            store.clear();
            store.getList(filter);
        }
        get fieldSize() {
            const { size: size } = this.observedProps;
            return !size ? undefined : size === 'sm' ? 'sm' : 'lg';
        }
        get checkedKeys() {
            return $c51ce0f384b28c9c$var$__classPrivateFieldGet(this, _RestTable_checkedKeys_accessor_storage, "f");
        }
        set checkedKeys(value) {
            $c51ce0f384b28c9c$var$__classPrivateFieldSet(this, _RestTable_checkedKeys_accessor_storage, value, "f");
        }
        toggleCheck(key) {
            var _a, _b;
            const { checkedKeys: checkedKeys } = this;
            const index = checkedKeys.indexOf(key);
            this.checkedKeys = index < 0 ? [
                ...checkedKeys,
                key
            ] : [
                ...checkedKeys.slice(0, index),
                ...checkedKeys.slice(index + 1)
            ];
            (_b = (_a = this.props).onCheck) === null || _b === void 0 || _b.call(_a, this.checkedKeys);
        }
        get checkColumn() {
            const { checkedKeys: checkedKeys, toggleCheckAll: toggleCheckAll } = this, { indexKey: indexKey, currentPage: currentPage } = this.observedProps.store;
            return {
                renderHead: ()=>(0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Check, {
                        type: "checkbox",
                        name: `all-${indexKey.toString()}`,
                        value: checkedKeys + '',
                        checked: !!currentPage[0] && currentPage.every(({ [indexKey]: ID })=>checkedKeys.includes(ID)),
                        // https://github.com/facebook/react/issues/1798
                        ref: (input)=>{
                            if (input) input.indeterminate = !!checkedKeys.length && checkedKeys.length < currentPage.length;
                        },
                        onChange: toggleCheckAll,
                        onKeyUp: ({ key: key })=>key === ' ' && toggleCheckAll()
                    }),
                renderBody: ({ [indexKey]: ID })=>(0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Check, {
                        type: "checkbox",
                        name: indexKey.toString(),
                        value: ID,
                        checked: checkedKeys.includes(ID),
                        onChange: ()=>this.toggleCheck(ID),
                        onKeyUp: ({ key: key })=>key === ' ' && this.toggleCheck(ID)
                    })
            };
        }
        get operateColumn() {
            const { editable: editable, deletable: deletable, columns: columns, store: store, translator: translator } = this.observedProps, { fieldSize: fieldSize } = this;
            const { t: t } = translator, readOnly = columns.every(({ readOnly: readOnly })=>readOnly), disabled = columns.every(({ disabled: disabled })=>disabled);
            return {
                renderHead: ()=>(0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {}),
                renderBody: (data)=>(0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                        children: [
                            !disabled && editable && (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                className: "text-nowrap m-1",
                                variant: readOnly ? 'primary' : 'warning',
                                size: fieldSize,
                                onClick: ()=>store.currentOne = data,
                                children: readOnly ? t('view') : t('edit')
                            }),
                            deletable && (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                className: "text-nowrap m-1",
                                variant: "danger",
                                size: fieldSize,
                                onClick: ()=>this.deleteList([
                                        data[store.indexKey]
                                    ]),
                                children: t('delete')
                            })
                        ]
                    })
            };
        }
        get columns() {
            const { editable: editable, deletable: deletable, columns: columns, onCheck: onCheck } = this.observedProps;
            return [
                onCheck && this.checkColumn,
                ...columns.map((_a)=>{
                    var { renderBody: renderBody } = _a, column = $c51ce0f384b28c9c$var$__rest(_a, [
                        "renderBody"
                    ]);
                    return Object.assign(Object.assign({}, column), {
                        renderBody: renderBody !== null && renderBody !== void 0 ? renderBody : this.renderCustomBody(column)
                    });
                }),
                (editable || deletable) && this.operateColumn
            ].filter(Boolean);
        }
        get hasHeader() {
            return this.columns.some(({ renderHead: renderHead })=>renderHead);
        }
        get hasFooter() {
            return this.columns.some(({ renderFoot: renderFoot })=>renderFoot);
        }
        get editing() {
            return !(0, $90MBA.isEmpty)(this.observedProps.store.currentOne);
        }
        renderTable() {
            const _a = this.props, { className: className, columns: _, store: store, filter: filter, filterFields: filterFields, translator: translator, editable: editable, deletable: deletable, onCheck: onCheck, onSubmit: onSubmit, onReset: onReset, responsive: responsive = true } = _a, tableProps = $c51ce0f384b28c9c$var$__rest(_a, [
                "className",
                "columns",
                "store",
                "filter",
                "filterFields",
                "translator",
                "editable",
                "deletable",
                "onCheck",
                "onSubmit",
                "onReset",
                "responsive"
            ]), { hasHeader: hasHeader, hasFooter: hasFooter, columns: columns, editing: editing } = this;
            const { indexKey: indexKey, downloading: downloading, currentPage: currentPage } = store;
            return (0, $90cae257cc958273$exports.jsxs)((0, $e94adaa42c5c11d9$export$2e2bcd8739ae039), Object.assign({}, tableProps, {
                responsive: responsive,
                children: [
                    hasHeader && (0, $90cae257cc958273$exports.jsx)("thead", {
                        children: (0, $90cae257cc958273$exports.jsx)("tr", {
                            className: "align-middle text-nowrap",
                            children: columns.map(({ key: key, renderHead: renderHead }, index)=>(key || renderHead) && (0, $90cae257cc958273$exports.jsx)("th", {
                                    children: typeof renderHead === 'function' ? renderHead(key) : renderHead || key
                                }, (key === null || key === void 0 ? void 0 : key.toString()) || index))
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)("tbody", {
                        children: !editing && downloading > 0 ? (0, $90cae257cc958273$exports.jsx)("tr", {
                            children: (0, $90cae257cc958273$exports.jsx)("td", {
                                className: "text-center p-3",
                                colSpan: columns.length,
                                children: (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {})
                            })
                        }) : currentPage.map((data)=>(0, $90cae257cc958273$exports.jsx)("tr", {
                                className: "align-middle",
                                children: columns.map(({ key: key, renderBody: renderBody }, index)=>(key || renderBody) && (0, $90cae257cc958273$exports.jsx)("td", {
                                        children: (renderBody === null || renderBody === void 0 ? void 0 : renderBody(data)) || key && data[key]
                                    }, (key === null || key === void 0 ? void 0 : key.toString()) || index))
                            }, data[indexKey]))
                    }),
                    hasFooter && (0, $90cae257cc958273$exports.jsx)("tfoot", {
                        children: (0, $90cae257cc958273$exports.jsx)("tr", {
                            className: "align-middle",
                            children: columns.map(({ key: key, renderFoot: renderFoot }, index)=>(key || renderFoot) && (0, $90cae257cc958273$exports.jsx)("td", {
                                    children: typeof renderFoot === 'function' ? renderFoot(key) : renderFoot || key
                                }, (key === null || key === void 0 ? void 0 : key.toString()) || index))
                        })
                    })
                ]
            }));
        }
        deleteList(keys) {
            return $c51ce0f384b28c9c$var$__awaiter(this, void 0, void 0, function*() {
                const { translator: translator, store: store } = this.props;
                if (confirm(translator.t('sure_to_delete_x', {
                    keys: keys
                }))) for (const key of keys)yield store.deleteOne(key);
            });
        }
        render() {
            const _a = this.props, { className: className = 'overflow-auto d-flex flex-column gap-3', striped: striped, hover: hover, editable: editable, deletable: deletable, filter: filter, filterFields: filterFields, store: store, translator: translator, onSubmit: onSubmit, onReset: onReset, onCheck: onCheck } = _a, props = $c51ce0f384b28c9c$var$__rest(_a, [
                "className",
                "striped",
                "hover",
                "editable",
                "deletable",
                "filter",
                "filterFields",
                "store",
                "translator",
                "onSubmit",
                "onReset",
                "onCheck"
            ]), { fieldSize: fieldSize } = this;
            const { t: t } = translator, { indexKey: indexKey, pageSize: pageSize, pageIndex: pageIndex, pageCount: pageCount, totalCount: totalCount } = store;
            return (0, $90cae257cc958273$exports.jsxs)("div", Object.assign({
                className: className
            }, props, {
                children: [
                    (0, $90cae257cc958273$exports.jsxs)("header", {
                        className: "sticky-top bg-white py-3 d-flex align-items-center gap-3",
                        children: [
                            filterFields && (0, $90cae257cc958273$exports.jsx)((0, $f8df7fe8a4125ccd$export$341e3470805a945e), {
                                className: `d-flex flex-wrap align-items-center gap-3 pb-3 m-0 border-bottom ${$c43edd238e7c1e1b$export$5eeb11949c905cc1}`,
                                size: fieldSize,
                                translator: translator,
                                fields: filterFields,
                                onSubmit: (filter)=>store.getList(filter, 1),
                                onReset: ()=>store.getList({}, 1)
                            }),
                            deletable && (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                variant: "danger",
                                size: fieldSize,
                                disabled: !this.checkedKeys[0],
                                onClick: ()=>this.deleteList(this.checkedKeys),
                                children: t('delete')
                            }),
                            editable && (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                                size: fieldSize,
                                onClick: ()=>store.currentOne[indexKey] = '',
                                children: t('create')
                            })
                        ]
                    }),
                    this.renderTable(),
                    (0, $90cae257cc958273$exports.jsxs)("footer", {
                        className: "d-flex justify-content-between align-items-center",
                        children: [
                            !!totalCount && (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "mx-3 fs14",
                                children: t('total_x_rows', {
                                    totalCount: totalCount
                                })
                            }),
                            (0, $90cae257cc958273$exports.jsx)((0, $d427ab120c9993c6$export$57625d62e5386b09), {
                                pageSize: pageSize,
                                pageIndex: pageIndex,
                                pageCount: pageCount,
                                onChange: this.getList
                            })
                        ]
                    }),
                    editable && (0, $90cae257cc958273$exports.jsx)((0, $44fb5804d3caf3b9$export$28baae8ef86bbf36), {
                        size: fieldSize,
                        fields: this.columns.map((_a)=>{
                            var { renderHead: renderHead } = _a, field = $c51ce0f384b28c9c$var$__rest(_a, [
                                "renderHead"
                            ]);
                            return Object.assign(Object.assign({}, field), {
                                renderLabel: renderHead
                            });
                        }),
                        store: store,
                        translator: translator,
                        onSubmit: onSubmit
                    })
                ]
            }));
        }
    };
    _RestTable_checkedKeys_accessor_storage = new WeakMap();
    $c51ce0f384b28c9c$var$__setFunctionName(_classThis, "RestTable");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _init_decorators = [
            (0, $85705ec7803c1445$export$7203b476385689ae)(({ observedProps: { filter: filter } })=>filter)
        ];
        _get_fieldSize_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _checkedKeys_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_checkColumn_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_operateColumn_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_columns_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_hasHeader_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_hasFooter_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_editing_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _init_decorators, {
            kind: "method",
            name: "init",
            static: false,
            private: false,
            access: {
                has: (obj)=>"init" in obj,
                get: (obj)=>obj.init
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_fieldSize_decorators, {
            kind: "getter",
            name: "fieldSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fieldSize" in obj,
                get: (obj)=>obj.fieldSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _checkedKeys_decorators, {
            kind: "accessor",
            name: "checkedKeys",
            static: false,
            private: false,
            access: {
                has: (obj)=>"checkedKeys" in obj,
                get: (obj)=>obj.checkedKeys,
                set: (obj, value)=>{
                    obj.checkedKeys = value;
                }
            },
            metadata: _metadata
        }, _checkedKeys_initializers, _checkedKeys_extraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_checkColumn_decorators, {
            kind: "getter",
            name: "checkColumn",
            static: false,
            private: false,
            access: {
                has: (obj)=>"checkColumn" in obj,
                get: (obj)=>obj.checkColumn
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_operateColumn_decorators, {
            kind: "getter",
            name: "operateColumn",
            static: false,
            private: false,
            access: {
                has: (obj)=>"operateColumn" in obj,
                get: (obj)=>obj.operateColumn
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: (obj)=>"columns" in obj,
                get: (obj)=>obj.columns
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_hasHeader_decorators, {
            kind: "getter",
            name: "hasHeader",
            static: false,
            private: false,
            access: {
                has: (obj)=>"hasHeader" in obj,
                get: (obj)=>obj.hasHeader
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_hasFooter_decorators, {
            kind: "getter",
            name: "hasFooter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"hasFooter" in obj,
                get: (obj)=>obj.hasFooter
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(_classThis, null, _get_editing_decorators, {
            kind: "getter",
            name: "editing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editing" in obj,
                get: (obj)=>obj.editing
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c51ce0f384b28c9c$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RestTable = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'RestTable'
    });
    (()=>{
        $c51ce0f384b28c9c$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RestTable = _classThis;
})();




var $ad0c0fbbc4113b23$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ad0c0fbbc4113b23$var$EdgeOrder = [
    'top',
    'right',
    'bottom',
    'left'
];
const $ad0c0fbbc4113b23$var$touch = (edge, onTouch)=>{
    let observer;
    return (node)=>{
        var _a;
        if (!node) return observer === null || observer === void 0 ? void 0 : observer.disconnect();
        const anchor = (_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        const { overflowX: overflowX, overflowY: overflowY } = anchor ? getComputedStyle(anchor) : {};
        const root = `${overflowX}${overflowY}`.match(/auto|scroll/) ? anchor : null;
        const edgeMargins = Array(4).fill('0px');
        edgeMargins[$ad0c0fbbc4113b23$var$EdgeOrder.indexOf(edge)] = '200px';
        observer = new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>isIntersecting && onTouch(edge), {
            root: root,
            rootMargin: edgeMargins.join(' ')
        });
        observer.observe(node);
    };
};
const $ad0c0fbbc4113b23$export$d086fcc3bc3f366f = (_a)=>{
    var { className: className, onTouch: onTouch, top: top, left: left, right: right, bottom: bottom, children: children } = _a, props = $ad0c0fbbc4113b23$var$__rest(_a, [
        "className",
        "onTouch",
        "top",
        "left",
        "right",
        "bottom",
        "children"
    ]);
    return (0, $90cae257cc958273$exports.jsxs)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('position-relative', className)
    }, props, {
        children: [
            (0, $90cae257cc958273$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $ad0c0fbbc4113b23$var$touch('top', onTouch),
                children: top
            }),
            (0, $90cae257cc958273$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $ad0c0fbbc4113b23$var$touch('left', onTouch),
                children: left
            }),
            children,
            (0, $90cae257cc958273$exports.jsx)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $ad0c0fbbc4113b23$var$touch('right', onTouch),
                children: right
            }),
            (0, $90cae257cc958273$exports.jsx)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $ad0c0fbbc4113b23$var$touch('bottom', onTouch),
                children: bottom
            })
        ]
    }));
};
$ad0c0fbbc4113b23$export$d086fcc3bc3f366f.displayName = 'ScrollBoundary';




var $5pSp9 = parcelRequire("5pSp9");




var $5E6i4 = parcelRequire("5E6i4");

var $de6695075011abaa$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $de6695075011abaa$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $de6695075011abaa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $de6695075011abaa$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $de6695075011abaa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $de6695075011abaa$export$797e591eba0ca37c = (()=>{
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $5E6i4.Component);
    var ScrollList = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "loadMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (0, $5pSp9.debounce)((edge)=>{
                    const { store: store } = this.props;
                    if (edge === 'bottom' && store.downloading < 1 && !store.noMore) store.getList();
                })
            });
        }
        componentDidMount() {
            return $de6695075011abaa$var$__awaiter(this, void 0, void 0, function*() {
                const BaseStream = (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903), { filter: filter, defaultData: defaultData } = this.props;
                const store = this.props.store;
                yield (0, $7c1ccfb859bb0dff$export$a55877ca9db47377)(()=>store.downloading < 1);
                store.clearList();
                if (defaultData) yield store.restoreList({
                    allItems: defaultData,
                    filter: filter
                });
                yield store.getList(filter, store.pageList.length + 1);
            });
        }
        componentWillUnmount() {
            this.props.store.clearList();
        }
        render() {
            const _a = this.props, { translator: translator, store: store, renderList: renderList } = _a, props = $de6695075011abaa$var$__rest(_a, [
                "translator",
                "store",
                "renderList"
            ]);
            const { t: t } = translator, { noMore: noMore, allItems: allItems } = store;
            return (0, $90cae257cc958273$exports.jsx)((0, $ad0c0fbbc4113b23$export$d086fcc3bc3f366f), Object.assign({}, props, {
                onTouch: this.loadMore,
                children: (0, $90cae257cc958273$exports.jsxs)("div", {
                    children: [
                        renderList(allItems),
                        (0, $90cae257cc958273$exports.jsx)("footer", {
                            className: "mt-2 text-center text-muted small",
                            children: noMore || !allItems.length ? t('no_more') : t('load_more')
                        })
                    ]
                })
            }));
        }
    };
    $de6695075011abaa$var$__setFunctionName(_classThis, "ScrollList");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $de6695075011abaa$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ScrollList = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'ScrollList'
    });
    (()=>{
        $de6695075011abaa$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ScrollList = _classThis;
})();




var $5pSp9 = parcelRequire("5pSp9");





var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");






"use client";
const $4bc01eb661d09d8a$var$ListGroupItem = /*#__PURE__*/ $5E6i4.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $078bfcf9e1cbc848$export$d7a68693710982a)({
        key: (0, $e84edd8a6cdadf5e$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $bb65a2def1cecb04$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$4bc01eb661d09d8a$var$ListGroupItem.displayName = 'ListGroupItem';
var $4bc01eb661d09d8a$export$2e2bcd8739ae039 = $4bc01eb661d09d8a$var$ListGroupItem;



"use client";
const $fb8882515edbd399$var$ListGroup = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $82ed2fe1f7c20eed$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $78821005c47d14e8$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c16d0339a9132c32$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$fb8882515edbd399$var$ListGroup.displayName = 'ListGroup';
var $fb8882515edbd399$export$2e2bcd8739ae039 = Object.assign($fb8882515edbd399$var$ListGroup, {
    Item: (0, $4bc01eb661d09d8a$export$2e2bcd8739ae039)
});



var $90MBA = parcelRequire("90MBA");



var $0030ca5ed517ebc4$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $0030ca5ed517ebc4$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $0030ca5ed517ebc4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0030ca5ed517ebc4$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $0030ca5ed517ebc4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0030ca5ed517ebc4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $0030ca5ed517ebc4$export$2724f2f2a56ff7fc = (()=>{
    var _SearchableInput_filter_accessor_storage, _SearchableInput_listShown_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $85705ec7803c1445$export$cec7cafc710f5d68);
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _listShown_decorators;
    let _listShown_initializers = [];
    let _listShown_extraInitializers = [];
    var SearchableInput = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _SearchableInput_filter_accessor_storage.set(this, $0030ca5ed517ebc4$var$__runInitializers(this, _filter_initializers, this.props.filter || {}));
            _SearchableInput_listShown_accessor_storage.set(this, ($0030ca5ed517ebc4$var$__runInitializers(this, _filter_extraInitializers), $0030ca5ed517ebc4$var$__runInitializers(this, _listShown_initializers, false)));
            Object.defineProperty(this, "search", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($0030ca5ed517ebc4$var$__runInitializers(this, _listShown_extraInitializers), (0, $5pSp9.debounce)((value)=>$0030ca5ed517ebc4$var$__awaiter(this, void 0, void 0, function*() {
                        const { store: store, labelKey: labelKey } = this.props;
                        value = value.trim();
                        this.filter = Object.assign(Object.assign({}, this.filter), {
                            [labelKey]: value || undefined
                        });
                        if (store.downloading < 1) {
                            if (value) {
                                if (!this.listShown) this.listShown = true;
                                else yield store.getList(this.filter, 1);
                            } else {
                                this.listShown = false;
                                store.clearList();
                            }
                        }
                    }), (0, $90MBA.Second)))
            });
            Object.defineProperty(this, "add", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (label, value)=>{
                    const selectedOptions = this.value || [];
                    if (selectedOptions.find(({ value: v })=>v === value)) return;
                    this.innerValue = [
                        ...selectedOptions,
                        {
                            label: label,
                            value: value
                        }
                    ];
                    if (!this.props.multiple) this.listShown = false;
                }
            });
            Object.defineProperty(this, "delete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index)=>this.innerValue = [
                        ...(this.value || []).slice(0, index),
                        ...(this.value || []).slice(index + 1)
                    ]
            });
            Object.defineProperty(this, "handleBlur", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ target: target, relatedTarget: relatedTarget })=>{
                    if (target.parentElement !== (relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.parentElement)) this.listShown = false;
                }
            });
            Object.defineProperty(this, "renderList", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (allItems)=>allItems[0] ? (0, $90cae257cc958273$exports.jsx)((0, $fb8882515edbd399$export$2e2bcd8739ae039), {
                        children: allItems.map((data)=>{
                            const { labelKey: labelKey, valueKey: valueKey } = this.observedProps;
                            const label = data[labelKey], value = data[valueKey];
                            return (0, $90cae257cc958273$exports.jsx)((0, $fb8882515edbd399$export$2e2bcd8739ae039).Item, {
                                as: "button",
                                type: "button",
                                action: true,
                                onClick: ()=>this.add(label, value),
                                children: label
                            }, value);
                        })
                    }) : this.observedProps.store.downloading > 0 && (0, $90cae257cc958273$exports.jsx)("div", {
                        className: "text-center my-3",
                        children: (0, $90cae257cc958273$exports.jsx)((0, $70ffb104c13cb135$export$2e2bcd8739ae039), {})
                    })
            });
        }
        get filter() {
            return $0030ca5ed517ebc4$var$__classPrivateFieldGet(this, _SearchableInput_filter_accessor_storage, "f");
        }
        set filter(value) {
            $0030ca5ed517ebc4$var$__classPrivateFieldSet(this, _SearchableInput_filter_accessor_storage, value, "f");
        }
        get listShown() {
            return $0030ca5ed517ebc4$var$__classPrivateFieldGet(this, _SearchableInput_listShown_accessor_storage, "f");
        }
        set listShown(value) {
            $0030ca5ed517ebc4$var$__classPrivateFieldSet(this, _SearchableInput_listShown_accessor_storage, value, "f");
        }
        renderOverlay() {
            const { filter: filter } = this;
            const { translator: translator, fields: fields, store: store, labelKey: labelKey, renderList: renderList = this.renderList } = this.props;
            const keyword = filter[labelKey] || '';
            const needNew = !store.allItems.some(({ [labelKey]: label })=>label === keyword);
            return (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "position-absolute start-0 z-3 overflow-auto py-1 bg-white shadow-sm",
                style: {
                    top: '100%',
                    maxHeight: '30vh'
                },
                onBlurCapture: this.handleBlur,
                children: [
                    needNew && (fields === null || fields === void 0 ? void 0 : fields[0]) && (0, $90cae257cc958273$exports.jsxs)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                        className: "w-100 sticky-top",
                        variant: "warning",
                        size: "sm",
                        type: "button",
                        onClick: ()=>store.currentOne = {
                                [labelKey]: keyword
                            },
                        children: [
                            "+ ",
                            keyword
                        ]
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $de6695075011abaa$export$797e591eba0ca37c), {
                        translator: translator,
                        store: store,
                        filter: filter,
                        renderList: renderList
                    })
                ]
            });
        }
        render() {
            const { value: value, listShown: listShown } = this, { translator: translator, fields: fields, store: store, labelKey: labelKey, valueKey: valueKey, type: type = 'search', name: name, required: required, readOnly: readOnly, disabled: disabled, placeholder: placeholder } = this.props;
            return (0, $90cae257cc958273$exports.jsxs)((0, $915d79f60ae535f6$export$2e2bcd8739ae039), {
                className: "position-relative",
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $915d79f60ae535f6$export$2e2bcd8739ae039).Text, {
                        className: "d-flex flex-wrap align-items-center gap-2",
                        children: (0, $90cae257cc958273$exports.jsx)((0, $9784173a5043df33$export$ef1c4106ceccca63), {
                            list: (value || []).map(({ label: label })=>({
                                    text: label
                                })),
                            onDelete: !readOnly && !disabled ? ({}, index)=>this.delete(index) : undefined
                        })
                    }),
                    listShown && this.renderOverlay(),
                    (fields === null || fields === void 0 ? void 0 : fields[0]) && (0, $90cae257cc958273$exports.jsx)((0, $44fb5804d3caf3b9$export$28baae8ef86bbf36), {
                        translator: translator,
                        fields: fields,
                        store: store,
                        onSubmit: ({ [labelKey]: label, [valueKey]: value })=>{
                            this.add(label, value);
                            this.listShown = false;
                        }
                    }),
                    (0, $90cae257cc958273$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: JSON.stringify(value === null || value === void 0 ? void 0 : value.map(({ value: value })=>value))
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control, {
                        type: type,
                        placeholder: placeholder,
                        required: required,
                        readOnly: readOnly,
                        disabled: disabled,
                        onChange: ({ currentTarget: { value: value } })=>this.search(value)
                    })
                ]
            });
        }
    };
    _SearchableInput_filter_accessor_storage = new WeakMap();
    _SearchableInput_listShown_accessor_storage = new WeakMap();
    $0030ca5ed517ebc4$var$__setFunctionName(_classThis, "SearchableInput");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _filter_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _listShown_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        $0030ca5ed517ebc4$var$__esDecorate(_classThis, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $0030ca5ed517ebc4$var$__esDecorate(_classThis, null, _listShown_decorators, {
            kind: "accessor",
            name: "listShown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"listShown" in obj,
                get: (obj)=>obj.listShown,
                set: (obj, value)=>{
                    obj.listShown = value;
                }
            },
            metadata: _metadata
        }, _listShown_initializers, _listShown_extraInitializers);
        $0030ca5ed517ebc4$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        SearchableInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'SearchableInput'
    });
    (()=>{
        $0030ca5ed517ebc4$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return SearchableInput = _classThis;
})();





// src/dom.ts
function $3438a2478d5b847f$var$resolveContainer(container) {
    if (typeof container !== "string") return container;
    const element = document.querySelector(container);
    if (!element) throw new Error(`File viewer container not found: ${container}`);
    return element;
}
function $3438a2478d5b847f$var$applyBoxSize(element, width, height) {
    if (width !== void 0) element.style.width = typeof width === "number" ? `${width}px` : width;
    if (height !== void 0) element.style.height = typeof height === "number" ? `${height}px` : height;
}
function $3438a2478d5b847f$var$getElementSize(element) {
    const rect = element.getBoundingClientRect();
    return {
        width: Math.max(0, Math.round(rect.width)),
        height: Math.max(0, Math.round(rect.height))
    };
}
function $3438a2478d5b847f$export$191fa6957fae12db(file) {
    if (file.url) return file.url;
    if (!file.blob) throw new Error("File source cannot be converted to an object URL.");
    return URL.createObjectURL(file.blob);
}
function $3438a2478d5b847f$export$7438c4986c08186f(url, isExternal) {
    if (!isExternal) URL.revokeObjectURL(url);
}
// src/plugins/fallback.ts
function $3438a2478d5b847f$export$23ed2e65aae2ac8a() {
    return {
        name: "fallback",
        match () {
            return true;
        },
        render (ctx) {
            ctx.options.onUnsupported?.(ctx.file);
            if (ctx.options.fallback === "custom" && ctx.options.renderFallback) return ctx.options.renderFallback(ctx);
            const url = $3438a2478d5b847f$export$191fa6957fae12db(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const panel = document.createElement("div");
            panel.className = "ofv-fallback";
            const title = document.createElement("strong");
            title.textContent = ctx.options.fallback === "download" ? ctx.options.messages.downloadTitle : ctx.options.messages.unsupportedTitle;
            const meta = $3438a2478d5b847f$var$createFallbackMeta(ctx.file, ctx.options.messages);
            const download = document.createElement("a");
            download.href = url;
            download.download = ctx.file.name;
            download.textContent = ctx.options.messages.downloadFile;
            panel.append(title, meta, download);
            ctx.viewport.classList.add("ofv-center");
            ctx.viewport.append(panel);
            if (ctx.options.fallback === "download") download.focus();
            return {
                destroy () {
                    ctx.viewport.classList.remove("ofv-center");
                    $3438a2478d5b847f$export$7438c4986c08186f(url, isExternal);
                }
            };
        }
    };
}
function $3438a2478d5b847f$var$createFallbackMeta(file, messages) {
    const meta = document.createElement("dl");
    meta.className = "ofv-fallback-meta";
    $3438a2478d5b847f$var$appendFallbackMeta(meta, messages.file, file.name || messages.unnamedFile);
    $3438a2478d5b847f$var$appendFallbackMeta(meta, messages.format, file.extension ? `.${file.extension}` : messages.unknown);
    $3438a2478d5b847f$var$appendFallbackMeta(meta, messages.mime, file.mimeType || messages.undeclared);
    $3438a2478d5b847f$var$appendFallbackMeta(meta, messages.size, file.size === void 0 ? messages.unknown : $3438a2478d5b847f$var$formatFallbackBytes(file.size));
    $3438a2478d5b847f$var$appendFallbackMeta(meta, messages.source, file.url ? messages.remoteUrl : messages.localFile);
    return meta;
}
function $3438a2478d5b847f$var$appendFallbackMeta(parent, label, value) {
    const key = document.createElement("dt");
    key.textContent = label;
    const content = document.createElement("dd");
    content.textContent = value;
    parent.append(key, content);
}
function $3438a2478d5b847f$var$formatFallbackBytes(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
// src/detect.ts
var $3438a2478d5b847f$var$extensionMimeMap = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    jfif: "image/jpeg",
    pjpe: "image/pjpeg",
    pjpeg: "image/pjpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    avif: "image/avif",
    jxl: "image/jxl",
    svg: "image/svg+xml",
    bmp: "image/bmp",
    ico: "image/x-icon",
    cur: "image/x-icon",
    tif: "image/tiff",
    tiff: "image/tiff",
    apng: "image/apng",
    heic: "image/heic",
    heif: "image/heif",
    mp4: "video/mp4",
    mpg: "video/mpeg",
    mpeg: "video/mpeg",
    mpe: "video/mpeg",
    mpv: "video/mpv",
    webm: "video/webm",
    ogg: "audio/ogg",
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/x-m4v",
    avi: "video/x-msvideo",
    mkv: "video/x-matroska",
    flv: "video/x-flv",
    wmv: "video/x-ms-wmv",
    "3gp": "video/3gpp",
    "3g2": "video/3gpp2",
    m2ts: "video/mp2t",
    m3u8: "application/vnd.apple.mpegurl",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    aif: "audio/aiff",
    aiff: "audio/aiff",
    aifc: "audio/aiff",
    aac: "audio/aac",
    m4a: "audio/mp4",
    flac: "audio/flac",
    opus: "audio/opus",
    oga: "audio/ogg",
    weba: "audio/webm",
    amr: "audio/amr",
    mid: "audio/midi",
    midi: "audio/midi",
    caf: "audio/x-caf",
    au: "audio/basic",
    snd: "audio/basic",
    wma: "audio/x-ms-wma",
    pdf: "application/pdf",
    epub: "application/epub+zip",
    xps: "application/vnd.ms-xpsdocument",
    oxps: "application/oxps",
    txt: "text/plain",
    lrc: "text/plain",
    log: "text/plain",
    env: "text/plain",
    gitignore: "text/plain",
    dockerignore: "text/plain",
    npmrc: "text/plain",
    yarnrc: "text/plain",
    pnpmrc: "text/plain",
    editorconfig: "text/plain",
    browserslistrc: "text/plain",
    prettierrc: "application/json",
    eslintrc: "application/json",
    stylelintrc: "application/json",
    conf: "text/plain",
    config: "text/plain",
    properties: "text/plain",
    lock: "text/plain",
    json: "application/json",
    jsonc: "application/json",
    json5: "application/json5",
    ipynb: "application/x-ipynb+json",
    jsonl: "application/x-ndjson",
    ndjson: "application/x-ndjson",
    xml: "application/xml",
    yaml: "text/yaml",
    yml: "text/yaml",
    csv: "text/csv",
    tsv: "text/tab-separated-values",
    md: "text/markdown",
    markdown: "text/markdown",
    mmd: "text/vnd.mermaid",
    mermaid: "text/vnd.mermaid",
    toml: "application/toml",
    ini: "text/plain",
    proto: "text/x-protobuf",
    tf: "text/x-hcl",
    tfvars: "text/x-hcl",
    hcl: "text/x-hcl",
    tex: "application/x-tex",
    latex: "application/x-tex",
    bib: "text/x-bibtex",
    gv: "text/vnd.graphviz",
    http: "message/http",
    css: "text/css",
    scss: "text/css",
    less: "text/css",
    js: "text/javascript",
    mjs: "text/javascript",
    cjs: "text/javascript",
    ts: "text/typescript",
    tsx: "text/typescript",
    jsx: "text/javascript",
    htm: "text/html",
    html: "text/html",
    vue: "text/plain",
    py: "text/x-python",
    java: "text/x-java-source",
    go: "text/x-go",
    rs: "text/rust",
    rb: "text/x-ruby",
    swift: "text/x-swift",
    kt: "text/x-kotlin",
    kts: "text/x-kotlin",
    scala: "text/x-scala",
    lua: "text/x-lua",
    r: "text/x-r",
    dart: "text/x-dart",
    svelte: "text/plain",
    astro: "text/plain",
    elm: "text/x-elm",
    ex: "text/x-elixir",
    exs: "text/x-elixir",
    clj: "text/x-clojure",
    cljs: "text/x-clojure",
    erl: "text/x-erlang",
    hrl: "text/x-erlang",
    fs: "text/x-fsharp",
    fsx: "text/x-fsharp",
    hs: "text/x-haskell",
    lhs: "text/x-haskell",
    php: "application/x-httpd-php",
    c: "text/x-c",
    cpp: "text/x-c++src",
    h: "text/x-c",
    hpp: "text/x-c++hdr",
    cs: "text/x-csharp",
    sql: "application/sql",
    sh: "application/x-sh",
    bash: "application/x-sh",
    zsh: "application/x-sh",
    fish: "application/x-sh",
    ps1: "text/plain",
    bat: "text/plain",
    cmd: "text/plain",
    dockerfile: "text/plain",
    nginxconf: "text/plain",
    gradle: "text/plain",
    graphql: "application/graphql",
    gql: "application/graphql",
    pem: "application/x-pem-file",
    crt: "application/x-x509-ca-cert",
    cer: "application/pkix-cert",
    ics: "text/calendar",
    vcf: "text/vcard",
    diff: "text/x-diff",
    patch: "text/x-diff",
    geojson: "application/geo+json",
    topojson: "application/topo+json",
    kml: "application/vnd.google-earth.kml+xml",
    kmz: "application/vnd.google-earth.kmz",
    gpx: "application/gpx+xml",
    shp: "application/octet-stream",
    drawio: "application/vnd.jgraph.mxfile",
    dio: "application/vnd.jgraph.mxfile",
    xmind: "application/vnd.xmind.workbook",
    excalidraw: "application/vnd.excalidraw+json",
    tldraw: "application/json",
    zip: "application/zip",
    rar: "application/vnd.rar",
    "7z": "application/x-7z-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
    tgz: "application/gzip",
    bz2: "application/x-bzip2",
    xz: "application/x-xz",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    docm: "application/vnd.ms-word.document.macroenabled.12",
    dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    dotm: "application/vnd.ms-word.template.macroenabled.12",
    dot: "application/msword",
    doc: "application/msword",
    rtf: "application/rtf",
    odt: "application/vnd.oasis.opendocument.text",
    fodt: "application/vnd.oasis.opendocument.text-flat-xml",
    wps: "application/vnd.ms-works",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    xls: "application/vnd.ms-excel",
    xlt: "application/vnd.ms-excel",
    xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
    xltm: "application/vnd.ms-excel.template.macroenabled.12",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    ods: "application/vnd.oasis.opendocument.spreadsheet",
    fods: "application/vnd.oasis.opendocument.spreadsheet-flat-xml",
    numbers: "application/vnd.apple.numbers",
    et: "application/vnd.ms-excel",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    pptm: "application/vnd.ms-powerpoint.presentation.macroenabled.12",
    ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    ppsm: "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
    potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
    potm: "application/vnd.ms-powerpoint.template.macroenabled.12",
    ppt: "application/vnd.ms-powerpoint",
    pps: "application/vnd.ms-powerpoint",
    odp: "application/vnd.oasis.opendocument.presentation",
    fodp: "application/vnd.oasis.opendocument.presentation-flat-xml",
    key: "application/vnd.apple.keynote",
    dps: "application/vnd.ms-powerpoint",
    eml: "message/rfc822",
    msg: "application/vnd.ms-outlook",
    mbox: "application/mbox",
    ofd: "application/ofd",
    gltf: "model/gltf+json",
    glb: "model/gltf-binary",
    stl: "model/stl",
    obj: "model/obj",
    "3ds": "model/3ds",
    fbx: "application/vnd.autodesk.fbx",
    dae: "model/vnd.collada+xml",
    ply: "application/ply",
    "3mf": "model/3mf",
    usdz: "model/vnd.usdz+zip",
    usdc: "model/vnd.usd",
    usda: "model/vnd.usd",
    usd: "model/vnd.usd",
    wrl: "model/vrml",
    vrml: "model/vrml",
    dxf: "image/vnd.dxf",
    dwg: "application/acad",
    dwf: "model/vnd.dwf",
    step: "model/step",
    stp: "model/step",
    iges: "application/iges",
    igs: "application/iges",
    ifc: "application/x-step",
    sat: "application/sat",
    sab: "application/sab",
    "x_t": "application/x-parasolid",
    "x_b": "application/x-parasolid",
    "3dm": "model/vnd.3dm",
    skp: "application/vnd.sketchup.skp",
    sldprt: "application/sldworks",
    sldasm: "application/sldworks",
    gds: "application/vnd.gds",
    gdsii: "application/x-gdsii",
    oas: "application/vnd.oasis.layout",
    oasis: "application/vnd.oasis.layout",
    ttf: "font/ttf",
    otf: "font/otf",
    woff: "font/woff",
    woff2: "font/woff2",
    eot: "application/vnd.ms-fontobject",
    psd: "image/vnd.adobe.photoshop",
    psb: "image/vnd.adobe.photoshop",
    ai: "application/postscript",
    eps: "application/postscript",
    ps: "application/postscript",
    webarchive: "application/x-webarchive",
    sqlite: "application/vnd.sqlite3",
    sqlite3: "application/vnd.sqlite3",
    db: "application/vnd.sqlite3",
    wasm: "application/wasm",
    parquet: "application/vnd.apache.parquet",
    avro: "application/avro"
};
async function $3438a2478d5b847f$export$e274b0a3e6f55538(source, fileName, mimeType) {
    if (typeof source === "string") {
        const name2 = fileName || $3438a2478d5b847f$var$getFileNameFromUrl(source) || "remote-file";
        const extension2 = $3438a2478d5b847f$var$getExtension(name2);
        return $3438a2478d5b847f$var$rememberExplicitMimeType({
            source: source,
            name: name2,
            extension: extension2,
            mimeType: mimeType || $3438a2478d5b847f$var$extensionMimeMap[extension2] || "",
            url: source
        }, mimeType);
    }
    if (source instanceof File) {
        const extension2 = $3438a2478d5b847f$var$getExtension(fileName || source.name);
        return $3438a2478d5b847f$var$rememberExplicitMimeType({
            source: source,
            name: fileName || source.name,
            extension: extension2,
            mimeType: mimeType || source.type || $3438a2478d5b847f$var$extensionMimeMap[extension2] || "",
            size: source.size,
            blob: source
        }, mimeType);
    }
    if (source instanceof Blob) {
        const name2 = fileName || "blob";
        const extension2 = $3438a2478d5b847f$var$getExtension(name2);
        return $3438a2478d5b847f$var$rememberExplicitMimeType({
            source: source,
            name: name2,
            extension: extension2,
            mimeType: mimeType || source.type || $3438a2478d5b847f$var$extensionMimeMap[extension2] || "",
            size: source.size,
            blob: source
        }, mimeType);
    }
    const name = fileName || "buffer";
    const extension = $3438a2478d5b847f$var$getExtension(name);
    const blob = new Blob([
        source
    ], {
        type: mimeType || $3438a2478d5b847f$var$extensionMimeMap[extension] || ""
    });
    return $3438a2478d5b847f$var$rememberExplicitMimeType({
        source: source,
        name: name,
        extension: extension,
        mimeType: blob.type,
        size: blob.size,
        blob: blob
    }, mimeType);
}
var $3438a2478d5b847f$var$filesWithExplicitMimeType = /* @__PURE__ */ new WeakSet();
function $3438a2478d5b847f$var$rememberExplicitMimeType(file, mimeType) {
    if (mimeType) $3438a2478d5b847f$var$filesWithExplicitMimeType.add(file);
    return file;
}
function $3438a2478d5b847f$export$f0df02582fe498a4(file) {
    return $3438a2478d5b847f$var$filesWithExplicitMimeType.has(file);
}
function $3438a2478d5b847f$var$getFileNameFromUrl(source) {
    const rawName = source.split(/[?#]/, 1)[0]?.split("/").filter(Boolean).pop() || "";
    if (!rawName) return "";
    try {
        return decodeURIComponent(rawName);
    } catch  {
        return rawName;
    }
}
function $3438a2478d5b847f$var$getExtension(name) {
    const clean = name.split("?")[0]?.split("#")[0] || "";
    const index = clean.lastIndexOf(".");
    return index >= 0 ? clean.slice(index + 1).split("!", 1)[0].toLowerCase() : "";
}
function $3438a2478d5b847f$export$a5de46ac017c9da9(file) {
    const textFileName = $3438a2478d5b847f$var$normalizeFileName(file.name);
    const textFileStem = textFileName.split(".")[0];
    return file.mimeType.startsWith("text/") || [
        "application/json",
        "application/json5",
        "application/x-ipynb+json",
        "application/xml",
        "application/yaml",
        "application/x-yaml",
        "application/sql",
        "application/x-sh",
        "application/x-httpd-php",
        "application/javascript",
        "application/x-javascript",
        "application/typescript",
        "application/x-typescript",
        "application/toml",
        "application/x-toml",
        "application/x-ndjson",
        "application/graphql",
        "application/x-pem-file",
        "application/x-x509-ca-cert",
        "application/pkix-cert",
        "application/x-tex",
        "application/lrc",
        "application/x-lrc",
        "message/http",
        "text/calendar",
        "text/vcard",
        "text/x-bibtex",
        "text/x-hcl",
        "text/x-protobuf",
        "text/vnd.graphviz"
    ].includes(file.mimeType) || [
        "txt",
        "lrc",
        "json",
        "jsonc",
        "json5",
        "ipynb",
        "jsonl",
        "ndjson",
        "xml",
        "yaml",
        "yml",
        "csv",
        "log",
        "env",
        "gitignore",
        "dockerignore",
        "npmrc",
        "yarnrc",
        "pnpmrc",
        "editorconfig",
        "browserslistrc",
        "prettierrc",
        "eslintrc",
        "stylelintrc",
        "conf",
        "config",
        "properties",
        "lock",
        "md",
        "markdown",
        "mmd",
        "mermaid",
        "js",
        "mjs",
        "cjs",
        "ts",
        "tsx",
        "jsx",
        "vue",
        "css",
        "scss",
        "less",
        "html",
        "htm",
        "toml",
        "ini",
        "proto",
        "tf",
        "tfvars",
        "hcl",
        "tex",
        "latex",
        "bib",
        "gv",
        "http",
        "java",
        "py",
        "go",
        "rs",
        "rb",
        "swift",
        "kt",
        "kts",
        "scala",
        "lua",
        "r",
        "dart",
        "svelte",
        "astro",
        "elm",
        "ex",
        "exs",
        "clj",
        "cljs",
        "erl",
        "hrl",
        "fs",
        "fsx",
        "hs",
        "lhs",
        "php",
        "c",
        "cpp",
        "h",
        "hpp",
        "cs",
        "sql",
        "sh",
        "bash",
        "zsh",
        "fish",
        "ps1",
        "bat",
        "cmd",
        "dockerfile",
        "nginxconf",
        "gradle",
        "graphql",
        "gql",
        "pem",
        "crt",
        "cer",
        "ics",
        "vcf",
        "diff",
        "patch"
    ].includes(file.extension) || [
        "dockerfile",
        "makefile",
        "rakefile",
        "gemfile",
        "procfile",
        "jenkinsfile",
        "vagrantfile",
        "brewfile",
        "podfile",
        "go.mod",
        "go.sum",
        "cargo.toml",
        "cargo.lock",
        ".gitignore",
        ".dockerignore",
        ".npmrc",
        ".yarnrc",
        ".pnpmrc",
        ".editorconfig",
        ".browserslistrc",
        ".prettierrc",
        ".eslintrc",
        ".stylelintrc"
    ].includes(textFileName) || [
        "readme",
        "changelog",
        "changes",
        "history",
        "license",
        "licence",
        "copying",
        "notice",
        "authors",
        "contributors",
        "codeowners"
    ].includes(textFileStem);
}
function $3438a2478d5b847f$var$normalizeFileName(name) {
    const baseName = name.split(/[\\/]/).pop() || name;
    return baseName.toLowerCase();
}
// src/messages.ts
var $3438a2478d5b847f$var$defaultMessages = {
    "zh-CN": {
        loading: "\u6B63\u5728\u52A0\u8F7D\u9884\u89C8...",
        unsupportedTitle: "\u5F53\u524D\u6587\u4EF6\u6682\u4E0D\u652F\u6301\u5728\u7EBF\u9884\u89C8",
        downloadTitle: "\u5F53\u524D\u6587\u4EF6\u53EF\u4E0B\u8F7D\u540E\u67E5\u770B",
        downloadFile: "\u4E0B\u8F7D\u6587\u4EF6",
        file: "\u6587\u4EF6",
        unnamedFile: "\u672A\u547D\u540D\u6587\u4EF6",
        format: "\u683C\u5F0F",
        unknown: "\u672A\u77E5",
        mime: "MIME",
        undeclared: "\u672A\u58F0\u660E",
        size: "\u5927\u5C0F",
        source: "\u6765\u6E90",
        remoteUrl: "\u8FDC\u7A0B URL",
        localFile: "\u672C\u5730/\u5185\u5B58\u6587\u4EF6",
        textPlainLanguage: "\u7EAF\u6587\u672C",
        textLineCount: "{count} \u884C",
        textWrap: "\u6362\u884C",
        textCopy: "\u590D\u5236",
        textCopied: "\u5DF2\u590D\u5236",
        textCopyFailed: "\u590D\u5236\u5931\u8D25",
        textDownload: "\u4E0B\u8F7D",
        textDownloadReady: "\u4E0B\u8F7D\u5DF2\u51C6\u5907",
        textLargeFileNotice: "\u6587\u4EF6\u8F83\u5927\uFF0C\u5F53\u524D\u5C55\u793A\u524D {size}\uFF0C\u590D\u5236\u548C\u4E0B\u8F7D\u4ECD\u4F1A\u4F7F\u7528\u5B8C\u6574\u5185\u5BB9\u3002",
        textHighlightSkipped: "\u5185\u5BB9\u8F83\u5927\uFF0C\u5DF2\u8DF3\u8FC7\u8BED\u6CD5\u9AD8\u4EAE\u4EE5\u4FDD\u6301\u6EDA\u52A8\u6D41\u7545\u3002",
        textPreviewFailedTitle: "\u6587\u672C\u9884\u89C8\u5931\u8D25",
        textPreviewFailedMessage: "\u65E0\u6CD5\u8BFB\u53D6\u8BE5\u6587\u672C\u5185\u5BB9\uFF0C\u53EF\u80FD\u662F\u8FDC\u7A0B\u6587\u4EF6\u4E0D\u53EF\u8BBF\u95EE\u6216\u54CD\u5E94\u72B6\u6001\u5F02\u5E38\u3002",
        textOpenOriginal: "\u6253\u5F00\u539F\u6587\u4EF6",
        lrcPreviewMode: "LRC \u9884\u89C8\u6A21\u5F0F",
        lrcDisplayMode: "\u5C55\u793A\u6A21\u5F0F",
        lrcAnnotatedMode: "\u7F8E\u89C2\u6A21\u5F0F",
        lrcSourceMode: "\u6E90\u7801\u6A21\u5F0F",
        lrcWordTimestamp: "\u9010\u5B57\u65F6\u95F4",
        lrcMale: "\u7537\u58F0",
        lrcFemale: "\u5973\u58F0",
        lrcDuet: "\u5408\u5531",
        lrcAuthor: "\u8BCD\u66F2",
        lrcLyricist: "\u4F5C\u8BCD",
        lrcLrcBy: "\u6B4C\u8BCD\u5236\u4F5C",
        lrcAlbum: "\u4E13\u8F91",
        lrcLength: "\u65F6\u957F",
        lrcOffset: "\u65F6\u95F4\u504F\u79FB",
        lrcTool: "\u5236\u4F5C\u5DE5\u5177",
        lrcVersion: "\u7248\u672C",
        lrcTrackInformation: "\u97F3\u4E50\u4F5C\u54C1\u4FE1\u606F",
        lrcEmpty: "\u6CA1\u6709\u53EF\u5C55\u793A\u7684\u6B4C\u8BCD\u5185\u5BB9\u3002",
        officeLegacyConversionTitle: "Office \u8F6C\u6362\u63D0\u793A",
        officeLegacyBinaryNotice: "\u5C5E\u4E8E\u65E7\u7248 Microsoft Office \u4E8C\u8FDB\u5236\u683C\u5F0F\uFF0C\u6D4F\u89C8\u5668\u5185\u65E0\u6CD5\u9AD8\u4FDD\u771F\u89E3\u6790\uFF1B\u5F53\u524D\u4EC5\u5C55\u793A\u53EF\u4FE1\u6587\u672C\u7247\u6BB5\u548C\u7ED3\u6784\u6307\u7EB9\uFF0C\u5B8C\u6574\u6392\u7248\u5EFA\u8BAE\u63A5\u5165 LibreOffice/OnlyOffice \u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A PDF/HTML\u3002",
        officeLegacyMetaFormatType: "\u683C\u5F0F\u7C7B\u578B",
        officeLegacyMetaFileStructure: "\u6587\u4EF6\u7ED3\u6784",
        officeLegacyOleDetected: "\u68C0\u6D4B\u5230 OLE Compound File \u7B7E\u540D",
        officeLegacyOleMissing: "\u672A\u68C0\u6D4B\u5230\u6807\u51C6 OLE \u7B7E\u540D\uFF0C\u6309\u539F\u59CB\u4E8C\u8FDB\u5236\u5C1D\u8BD5\u63D0\u53D6",
        officeLegacyMetaTextFragments: "\u6587\u672C\u7247\u6BB5",
        officeLegacyTextFragmentCount: "{count} \u6BB5",
        officeLegacyMetaParseStatus: "\u89E3\u6790\u72B6\u6001",
        officeLegacyReadableFragments: "\u53EF\u8BFB\u6587\u672C\u7247\u6BB5",
        officeLegacyNoText: "\u672A\u63D0\u53D6\u5230\u7A33\u5B9A\u53EF\u8BFB\u6587\u672C\u3002\u8BE5\u6587\u4EF6\u53EF\u80FD\u7ECF\u8FC7\u538B\u7F29\u3001\u52A0\u5BC6\uFF0C\u6216\u6587\u672C\u7F16\u7801\u65E0\u6CD5\u5728\u6D4F\u89C8\u5668\u7AEF\u53EF\u9760\u8BC6\u522B\uFF1B\u8BF7\u4F7F\u7528\u670D\u52A1\u7AEF LibreOffice/OnlyOffice \u8F6C\u6362\u540E\u9884\u89C8\u3002",
        officeLegacyWordParseFailed: "Word \u4E8C\u8FDB\u5236\u89E3\u6790\u5931\u8D25\uFF1A{message}",
        officeSheetParseFailed: "\u8868\u683C\u89E3\u6790\u5931\u8D25\uFF1A{message}",
        officeUnsupportedTitle: "Office \u57FA\u7840\u9884\u89C8",
        officeUnsupportedLegacyMessage: "\u8BE5\u683C\u5F0F\u5C5E\u4E8E\u8001\u4E8C\u8FDB\u5236\u6216\u4E13\u6709\u683C\u5F0F\uFF0C\u6D4F\u89C8\u5668\u5185\u65E0\u6CD5\u53EF\u9760\u89E3\u6790\uFF1B\u5EFA\u8BAE\u63A5\u5165 LibreOffice/OnlyOffice \u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A PDF/HTML \u540E\u9884\u89C8\u3002",
        officeUnsupportedGenericMessage: "\u8BE5\u683C\u5F0F\u901A\u5E38\u9700\u8981\u670D\u52A1\u7AEF\u8F6C\u6362\u6216\u4E13\u7528\u89E3\u6790\u5668\u624D\u80FD\u9AD8\u4FDD\u771F\u9884\u89C8\u3002",
        officeUnsupportedIntro: "\u5DF2\u8FDB\u5165 Office \u63D2\u4EF6\u3002{message}",
        officeUnsupportedSupportedFormats: "\u5F53\u524D\u7248\u672C\u4F18\u5148\u652F\u6301 docx\u3001rtf\u3001odt/fodt\u3001xlsx/xls/csv/ods\u3001pptx/ppsx\u3001odp/fodp \u7684\u57FA\u7840\u5185\u5BB9\u9884\u89C8\u3002",
        officeErrorWithMessage: "\u89E3\u6790\u5668\u8FD4\u56DE\uFF1A{message}",
        officeErrorWithoutMessage: "\u89E3\u6790\u5668\u672A\u8FD4\u56DE\u5177\u4F53\u9519\u8BEF\u4FE1\u606F\u3002",
        officeConvertedTitle: "Office \u9AD8\u4FDD\u771F\u8F6C\u6362\u9884\u89C8",
        officeConvertedPdfFailed: "Office \u8F6C\u6362\u540E\u7684 PDF \u65E0\u6CD5\u9884\u89C8",
        pdfEncryptedTitle: "PDF \u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u5728\u7EBF\u9884\u89C8",
        pdfEncryptedMessage: "\u8BF7\u4E0B\u8F7D\u540E\u4F7F\u7528\u5BC6\u7801\u6253\u5F00\uFF0C\u6216\u4E0A\u4F20\u89E3\u5BC6\u540E\u7684 PDF \u6587\u4EF6\u3002",
        pdfPreviewFailedTitle: "PDF \u9884\u89C8\u5931\u8D25",
        pdfCorruptedMessage: "\u8BE5 PDF \u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\u6216\u683C\u5F0F\u65E0\u6548\u3002",
        pdfCannotLoadMessage: "\u5F53\u524D\u6D4F\u89C8\u5668\u65E0\u6CD5\u52A0\u8F7D\u8BE5 PDF\u3002",
        pdfDownload: "\u4E0B\u8F7D PDF",
        pdfPageLoading: "\u9875\u9762 {page} \u52A0\u8F7D\u4E2D...",
        pdfPageEmpty: "\u8BE5\u9875\u6CA1\u6709\u68C0\u6D4B\u5230\u53EF\u663E\u793A\u7684 PDF \u517C\u5BB9\u5185\u5BB9\u3002\u82E5\u8FD9\u662F Illustrator/AI \u6587\u4EF6\uFF0C\u53EF\u80FD\u53EA\u5305\u542B\u79C1\u6709\u7F16\u8F91\u6570\u636E\uFF0C\u5EFA\u8BAE\u5BFC\u51FA\u4E3A PDF/SVG/PNG \u540E\u9884\u89C8\u3002",
        pdfPageRenderFailed: "\u65E0\u6CD5\u6E32\u67D3\u8BE5\u9875\u9762\u3002\u8BE5\u9875\u53EF\u80FD\u5305\u542B\u6D4F\u89C8\u5668 PDF \u5F15\u64CE\u6682\u4E0D\u652F\u6301\u7684\u56FE\u5F62\u3001\u5B57\u4F53\u6216\u538B\u7F29\u7279\u6027\u3002",
        pdfPreviousPage: "\u4E0A\u4E00\u9875",
        pdfNextPage: "\u4E0B\u4E00\u9875",
        pdfPageInput: "\u5F53\u524D\u9875\u7801",
        pdfPagePosition: "/ {total}",
        pdfPageLabel: "\u7B2C {page} \u9875",
        pdfSummaryPages: "\u9875\u6570",
        pdfSummaryPageSizes: "\u9875\u9762\u5C3A\u5BF8",
        pdfSummaryFit: "\u9002\u914D",
        pdfSummaryActualSize: "\u539F\u59CB\u5927\u5C0F",
        pdfSummaryFitWidth: "\u9002\u5408\u5BBD\u5EA6",
        pdfSummaryZoom: "\u7F29\u653E",
        imagePreviewFailedTitle: "\u56FE\u7247\u9884\u89C8\u5931\u8D25",
        imagePreviewFailedMessage: "\u5F53\u524D\u6D4F\u89C8\u5668\u65E0\u6CD5\u76F4\u63A5\u663E\u793A\u8BE5\u56FE\u7247\uFF0C\u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\u6216\u7F16\u7801\u6682\u4E0D\u53D7\u652F\u6301\u3002",
        imageDownload: "\u4E0B\u8F7D\u56FE\u7247",
        imageZoomOut: "\u7F29\u5C0F",
        imageZoomIn: "\u653E\u5927",
        imageRotate: "\u65CB\u8F6C\u56FE\u7247",
        imageReset: "\u91CD\u7F6E\u56FE\u7247\u89C6\u56FE"
    },
    "en-US": {
        loading: "Loading preview...",
        unsupportedTitle: "Preview is not available for this file",
        downloadTitle: "This file can be downloaded and opened locally",
        downloadFile: "Download file",
        file: "File",
        unnamedFile: "Untitled file",
        format: "Format",
        unknown: "Unknown",
        mime: "MIME",
        undeclared: "Not declared",
        size: "Size",
        source: "Source",
        remoteUrl: "Remote URL",
        localFile: "Local or in-memory file",
        textPlainLanguage: "plain text",
        textLineCount: "{count} lines",
        textWrap: "Wrap",
        textCopy: "Copy",
        textCopied: "Copied",
        textCopyFailed: "Copy failed",
        textDownload: "Download",
        textDownloadReady: "Download ready",
        textLargeFileNotice: "Large file, showing the first {size}. Copy and download still use the full content.",
        textHighlightSkipped: "Large content, syntax highlighting was skipped to keep scrolling smooth.",
        textPreviewFailedTitle: "Text preview failed",
        textPreviewFailedMessage: "Unable to read this text content. The remote file may be unreachable or returned an invalid response.",
        textOpenOriginal: "Open original file",
        lrcPreviewMode: "LRC preview mode",
        lrcDisplayMode: "Lyrics mode",
        lrcAnnotatedMode: "Annotated mode",
        lrcSourceMode: "Source mode",
        lrcWordTimestamp: "Word timestamp",
        lrcMale: "Male vocal",
        lrcFemale: "Female vocal",
        lrcDuet: "Duet",
        lrcAuthor: "Written by",
        lrcLyricist: "Lyrics by",
        lrcLrcBy: "LRC by",
        lrcAlbum: "Album",
        lrcLength: "Length",
        lrcOffset: "Timing offset",
        lrcTool: "Created with",
        lrcVersion: "Version",
        lrcTrackInformation: "Music information",
        lrcEmpty: "No lyrics to display.",
        officeLegacyConversionTitle: "Office conversion guidance",
        officeLegacyBinaryNotice: "belongs to a legacy Microsoft Office binary format that cannot be rendered with high fidelity in the browser. The preview shows trusted text fragments and structural fingerprints; use a LibreOffice/OnlyOffice server conversion to PDF/HTML for complete layout fidelity.",
        officeLegacyMetaFormatType: "Format type",
        officeLegacyMetaFileStructure: "File structure",
        officeLegacyOleDetected: "OLE Compound File signature detected",
        officeLegacyOleMissing: "No standard OLE signature detected; extracting from raw binary data",
        officeLegacyMetaTextFragments: "Text fragments",
        officeLegacyTextFragmentCount: "{count} fragments",
        officeLegacyMetaParseStatus: "Parse status",
        officeLegacyReadableFragments: "Readable text fragments",
        officeLegacyNoText: "No stable readable text was extracted. The file may be compressed, encrypted, or use text encoding that cannot be reliably recognized in the browser; use LibreOffice/OnlyOffice server conversion before previewing.",
        officeLegacyWordParseFailed: "Word binary parse failed: {message}",
        officeSheetParseFailed: "Spreadsheet parse failed: {message}",
        officeUnsupportedTitle: "Office basic preview",
        officeUnsupportedLegacyMessage: "This is a legacy binary or proprietary format that cannot be reliably parsed in the browser; convert it to PDF/HTML through LibreOffice/OnlyOffice on the server before previewing.",
        officeUnsupportedGenericMessage: "This format usually needs server-side conversion or a dedicated parser for high-fidelity preview.",
        officeUnsupportedIntro: "is handled by the Office plugin. {message}",
        officeUnsupportedSupportedFormats: "This version prioritizes basic previews for docx, rtf, odt/fodt, xlsx/xls/csv/ods, pptx/ppsx, and odp/fodp files.",
        officeErrorWithMessage: "Parser returned: {message}",
        officeErrorWithoutMessage: "Parser did not return a specific error.",
        officeConvertedTitle: "High-fidelity Office conversion preview",
        officeConvertedPdfFailed: "The converted Office PDF could not be previewed",
        pdfEncryptedTitle: "This PDF is encrypted and cannot be previewed online",
        pdfEncryptedMessage: "Download and open it with the password, or upload a decrypted PDF file.",
        pdfPreviewFailedTitle: "PDF preview failed",
        pdfCorruptedMessage: "The PDF may be corrupted or use an invalid format.",
        pdfCannotLoadMessage: "This browser could not load the PDF.",
        pdfDownload: "Download PDF",
        pdfPageLoading: "Loading page {page}...",
        pdfPageEmpty: "No displayable PDF-compatible content was detected on this page. If this is an Illustrator/AI file, export it as PDF, SVG, or PNG before previewing.",
        pdfPageRenderFailed: "This page could not be rendered. It may contain graphics, fonts, or compression features that the browser PDF engine does not support.",
        pdfPreviousPage: "Previous page",
        pdfNextPage: "Next page",
        pdfPageInput: "Current page",
        pdfPagePosition: "/ {total}",
        pdfPageLabel: "Page {page}",
        pdfSummaryPages: "Pages",
        pdfSummaryPageSizes: "Page sizes",
        pdfSummaryFit: "Fit",
        pdfSummaryActualSize: "Actual size",
        pdfSummaryFitWidth: "Fit width",
        pdfSummaryZoom: "Zoom",
        imagePreviewFailedTitle: "Image preview failed",
        imagePreviewFailedMessage: "This browser cannot display the image. The file may be corrupted or use an unsupported encoding.",
        imageDownload: "Download image",
        imageZoomOut: "Zoom out",
        imageZoomIn: "Zoom in",
        imageRotate: "Rotate image",
        imageReset: "Reset image view"
    }
};
function $3438a2478d5b847f$var$resolveMessages(options) {
    return {
        ...$3438a2478d5b847f$var$defaultMessages[options.locale || "en-US"],
        ...options.messages
    };
}
function $3438a2478d5b847f$export$40b3ce2549faa304(template, values) {
    return template.replace(/\{(\w+)\}/g, (match, key)=>String(values[key] ?? match));
}
// src/sandbox-compat.ts
var $3438a2478d5b847f$var$SAFE_SET_IMMEDIATE_FLAG = "__ofvSafeSetImmediate__";
function $3438a2478d5b847f$var$isMicroFrontendSandbox(win) {
    const flags = win;
    return Boolean(flags.__POWERED_BY_QIANKUN__ || flags.__MICRO_APP_ENVIRONMENT__ || flags.__POWERED_BY_WUJIE__ || flags.__GARFISH__);
}
function $3438a2478d5b847f$var$createScheduler(win) {
    let nextHandle = 1;
    const pending = /* @__PURE__ */ new Map();
    const MessageChannelCtor = win.MessageChannel;
    if (typeof MessageChannelCtor === "function") {
        const channel = new MessageChannelCtor();
        channel.port1.onmessage = (event)=>{
            const task = pending.get(event.data);
            if (task) {
                pending.delete(event.data);
                task();
            }
        };
        return {
            schedule (callback, args) {
                const handle = nextHandle++;
                pending.set(handle, ()=>callback(...args));
                channel.port2.postMessage(handle);
                return handle;
            },
            cancel (handle) {
                pending.delete(handle);
            }
        };
    }
    const timers = /* @__PURE__ */ new Map();
    return {
        schedule (callback, args) {
            const handle = nextHandle++;
            timers.set(handle, setTimeout(()=>{
                timers.delete(handle);
                callback(...args);
            }, 0));
            return handle;
        },
        cancel (handle) {
            const timer = timers.get(handle);
            if (timer !== void 0) {
                clearTimeout(timer);
                timers.delete(handle);
            }
        }
    };
}
function $3438a2478d5b847f$var$ensureSafeAsyncScheduling(win = typeof window === "undefined" ? void 0 : window) {
    if (!win || !$3438a2478d5b847f$var$isMicroFrontendSandbox(win)) return;
    const target = win;
    if (target.setImmediate?.[$3438a2478d5b847f$var$SAFE_SET_IMMEDIATE_FLAG]) return;
    const scheduler = $3438a2478d5b847f$var$createScheduler(win);
    const safeSetImmediate = (callback, ...args)=>scheduler.schedule(callback, args);
    safeSetImmediate[$3438a2478d5b847f$var$SAFE_SET_IMMEDIATE_FLAG] = true;
    target.setImmediate = safeSetImmediate;
    target.clearImmediate = (handle)=>scheduler.cancel(handle);
}
// src/viewer.ts
function $3438a2478d5b847f$export$a7848d518678d667(options) {
    $3438a2478d5b847f$var$ensureSafeAsyncScheduling();
    const container = $3438a2478d5b847f$var$resolveContainer(options.container);
    $3438a2478d5b847f$var$applyBoxSize(container, options.width, options.height);
    const customClassNames = $3438a2478d5b847f$var$parseClassNameTokens(options.className);
    container.classList.add("ofv-root");
    if (customClassNames.length > 0) container.classList.add(...customClassNames);
    const theme = $3438a2478d5b847f$var$applyTheme(container, options.theme || "light");
    const host = document.createElement("div");
    host.className = "ofv-host";
    const status = document.createElement("div");
    status.className = "ofv-status";
    status.setAttribute("role", "status");
    status.hidden = true;
    const statusChip = document.createElement("div");
    statusChip.className = "ofv-status-chip";
    const statusSpinner = document.createElement("span");
    statusSpinner.className = "ofv-status-spinner";
    statusSpinner.setAttribute("aria-hidden", "true");
    const statusText = document.createElement("span");
    statusText.className = "ofv-status-text";
    statusChip.append(statusSpinner, statusText);
    status.append(statusChip);
    const viewport = document.createElement("div");
    viewport.className = "ofv-viewport";
    const queue = $3438a2478d5b847f$var$normalizeQueue(options);
    let currentIndex = $3438a2478d5b847f$var$clampIndex(options.initialIndex || 0, queue.length);
    let currentInstance;
    let printPreparationPending = false;
    const goTo = async (index)=>{
        if (destroyed || queue.length === 0) return;
        currentIndex = $3438a2478d5b847f$var$clampIndex(index, queue.length);
        await renderQueueItem(currentIndex);
    };
    const toolbar = $3438a2478d5b847f$var$createToolbar(options.toolbar, viewport, {
        getLength: ()=>queue.length,
        next: ()=>goTo(currentIndex + 1),
        previous: ()=>goTo(currentIndex - 1),
        goToPage: (page)=>currentInstance?.goToPage?.(page) ?? false,
        command: (command)=>currentInstance?.command?.(command),
        print: async ()=>{
            if (printPreparationPending) return;
            printPreparationPending = true;
            const instance = currentInstance;
            try {
                await instance?.preparePrint?.();
            } catch (error) {
                console.error("Failed to prepare file preview for printing:", error);
                printPreparationPending = false;
                return;
            }
            printPreparationPending = false;
            if (destroyed || instance !== currentInstance) return;
            $3438a2478d5b847f$var$printPreview(viewport);
        }
    }, options.locale || "en-US");
    if (toolbar) host.append(toolbar.element);
    host.append(status, viewport);
    container.replaceChildren(host);
    const normalizedOptions = {
        ...options,
        fit: options.fit || "contain",
        fitWasProvided: options.fit !== void 0,
        fallback: options.fallback || "inline",
        zoom: $3438a2478d5b847f$var$normalizeInitialZoom(options.zoom),
        messages: $3438a2478d5b847f$var$resolveMessages(options)
    };
    let destroyed = false;
    let renderToken = 0;
    let renderAbortController;
    const gestureZoom = $3438a2478d5b847f$var$installGestureZoom(viewport, (command)=>!destroyed && Boolean(currentInstance?.command) && (currentInstance?.canCommand ? currentInstance.canCommand(command) : true), (command)=>currentInstance?.command?.(command));
    const setLoading = (loading)=>{
        status.hidden = !loading;
        status.classList.remove("ofv-status-error");
        statusText.textContent = loading ? normalizedOptions.messages.loading : "";
    };
    const setError = (error)=>{
        status.hidden = false;
        status.classList.add("ofv-status-error");
        statusText.textContent = typeof error === "string" ? error : error.message;
    };
    const resize = ()=>{
        if (destroyed) return;
        const size = $3438a2478d5b847f$var$getElementSize(viewport);
        currentInstance?.resize?.(size);
    };
    const resizeObserver = $3438a2478d5b847f$var$observeResize(container, resize);
    const renderFile = async (file, token = ++renderToken)=>{
        if (destroyed || token !== renderToken) return;
        $3438a2478d5b847f$var$destroyPreviewInstance(currentInstance);
        currentInstance = void 0;
        renderAbortController?.abort();
        const abortController = new AbortController();
        renderAbortController = abortController;
        viewport.replaceChildren();
        setLoading(true);
        toolbar?.update(file, currentIndex, queue.length);
        const plugins = [
            ...options.plugins || [],
            $3438a2478d5b847f$export$23ed2e65aae2ac8a()
        ];
        const plugin = await $3438a2478d5b847f$var$findPlugin(plugins, file);
        if (destroyed || token !== renderToken) return;
        try {
            const nextInstance = await plugin.render({
                host: host,
                viewport: viewport,
                file: file,
                size: $3438a2478d5b847f$var$getElementSize(viewport),
                options: normalizedOptions,
                toolbar: toolbar?.getContext(),
                signal: abortController.signal,
                setLoading: setLoading,
                setError: setError
            });
            if (destroyed || token !== renderToken) {
                $3438a2478d5b847f$var$destroyPreviewInstance(nextInstance);
                return;
            }
            if (renderAbortController === abortController) renderAbortController = void 0;
            currentInstance = nextInstance;
            if (normalizedOptions.initialPage !== void 0) nextInstance.goToPage?.(normalizedOptions.initialPage);
            setLoading(false);
            toolbar?.setCommandSupport((command)=>Boolean(nextInstance.command) && (nextInstance.canCommand ? nextInstance.canCommand(command) : true));
            options.onLoad?.(file);
            resize();
        } catch (error) {
            if (renderAbortController === abortController) renderAbortController = void 0;
            if (destroyed || token !== renderToken) return;
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            viewport.replaceChildren();
            setLoading(false);
            setError(normalizedError);
            options.onError?.(normalizedError, file);
        }
    };
    async function renderQueueItem(index) {
        const token = ++renderToken;
        renderAbortController?.abort();
        renderAbortController = void 0;
        const item = queue[index];
        const file = await $3438a2478d5b847f$export$e274b0a3e6f55538(item.file, item.fileName, item.mimeType);
        if (destroyed || token !== renderToken) return;
        await renderFile(file, token);
    }
    goTo(currentIndex);
    return {
        async reload (file) {
            if (destroyed) return;
            if (file !== void 0) {
                const currentItem = queue[currentIndex];
                queue.splice(currentIndex, 1, $3438a2478d5b847f$var$createReloadItem(file, currentItem, options));
            }
            await renderQueueItem(currentIndex);
        },
        async next () {
            await goTo(currentIndex + 1);
        },
        async previous () {
            await goTo(currentIndex - 1);
        },
        goTo: goTo,
        goToPage (page) {
            return destroyed ? false : currentInstance?.goToPage?.(page) ?? false;
        },
        getCurrentIndex () {
            return currentIndex;
        },
        resize: resize,
        destroy () {
            destroyed = true;
            renderToken += 1;
            renderAbortController?.abort();
            renderAbortController = void 0;
            resizeObserver.destroy();
            gestureZoom.destroy();
            $3438a2478d5b847f$var$destroyPreviewInstance(currentInstance);
            toolbar?.destroy();
            theme.destroy();
            container.replaceChildren();
            container.classList.remove("ofv-root");
            if (customClassNames.length > 0) container.classList.remove(...customClassNames);
        }
    };
}
function $3438a2478d5b847f$var$installGestureZoom(viewport, canCommand, command) {
    const wheelThreshold = 40;
    const pinchThreshold = 1.08;
    let accumulatedWheelDelta = 0;
    let pinchDistance;
    const onWheel = (event)=>{
        if (event.defaultPrevented || !event.ctrlKey && !event.metaKey || event.deltaY === 0) return;
        const zoomCommand = event.deltaY < 0 ? "zoom-in" : "zoom-out";
        if (!canCommand(zoomCommand)) {
            accumulatedWheelDelta = 0;
            return;
        }
        if (event.cancelable) event.preventDefault();
        const delta = event.deltaY * (event.deltaMode === 0 ? 1 : wheelThreshold);
        if (accumulatedWheelDelta !== 0 && Math.sign(accumulatedWheelDelta) !== Math.sign(delta)) accumulatedWheelDelta = 0;
        accumulatedWheelDelta += delta;
        if (Math.abs(accumulatedWheelDelta) < wheelThreshold) return;
        command(zoomCommand);
        accumulatedWheelDelta = 0;
    };
    const onTouchStart = (event)=>{
        pinchDistance = event.touches.length === 2 ? $3438a2478d5b847f$var$touchDistance(event.touches) : void 0;
    };
    const onTouchMove = (event)=>{
        if (event.defaultPrevented || event.touches.length !== 2) {
            pinchDistance = void 0;
            return;
        }
        const nextDistance = $3438a2478d5b847f$var$touchDistance(event.touches);
        if (!(nextDistance > 0)) return;
        if (!(pinchDistance && pinchDistance > 0)) {
            pinchDistance = nextDistance;
            return;
        }
        const zoomCommand = nextDistance > pinchDistance ? "zoom-in" : "zoom-out";
        if (!canCommand(zoomCommand)) return;
        if (event.cancelable) event.preventDefault();
        const ratio = nextDistance / pinchDistance;
        if (ratio < pinchThreshold && ratio > 1 / pinchThreshold) return;
        command(zoomCommand);
        pinchDistance = nextDistance;
    };
    const onTouchEnd = (event)=>{
        pinchDistance = event.touches.length === 2 ? $3438a2478d5b847f$var$touchDistance(event.touches) : void 0;
    };
    viewport.addEventListener("wheel", onWheel, {
        passive: false
    });
    viewport.addEventListener("touchstart", onTouchStart, {
        passive: true
    });
    viewport.addEventListener("touchmove", onTouchMove, {
        passive: false
    });
    viewport.addEventListener("touchend", onTouchEnd, {
        passive: true
    });
    viewport.addEventListener("touchcancel", onTouchEnd, {
        passive: true
    });
    return {
        destroy () {
            viewport.removeEventListener("wheel", onWheel);
            viewport.removeEventListener("touchstart", onTouchStart);
            viewport.removeEventListener("touchmove", onTouchMove);
            viewport.removeEventListener("touchend", onTouchEnd);
            viewport.removeEventListener("touchcancel", onTouchEnd);
        }
    };
}
function $3438a2478d5b847f$var$touchDistance(touches) {
    const first = touches.item(0);
    const second = touches.item(1);
    return first && second ? Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY) : 0;
}
function $3438a2478d5b847f$var$parseClassNameTokens(className) {
    return className?.trim().split(/\s+/).filter(Boolean) ?? [];
}
function $3438a2478d5b847f$var$destroyPreviewInstance(instance) {
    if (!instance) return;
    try {
        instance.destroy();
    } catch (error) {
        console.error("Failed to destroy file preview instance:", error);
    }
}
function $3438a2478d5b847f$var$normalizeQueue(options) {
    if (options.files && options.files.length > 0) return options.files.map((item)=>$3438a2478d5b847f$var$isPreviewItem(item) ? item : {
            file: item
        });
    if (options.file === void 0) throw new Error("File viewer requires either file or files.");
    return [
        {
            file: options.file,
            fileName: options.fileName,
            mimeType: options.mimeType
        }
    ];
}
function $3438a2478d5b847f$var$isPreviewItem(item) {
    return typeof item === "object" && item !== null && "file" in item;
}
function $3438a2478d5b847f$var$createReloadItem(file, currentItem, options) {
    if (typeof File !== "undefined" && file instanceof File) return {
        file: file
    };
    return {
        file: file,
        fileName: currentItem?.fileName || options.fileName,
        mimeType: currentItem?.mimeType || options.mimeType
    };
}
function $3438a2478d5b847f$var$clampIndex(index, length) {
    if (length <= 0) return 0;
    return Math.min(Math.max(index, 0), length - 1);
}
function $3438a2478d5b847f$var$normalizeInitialZoom(zoom) {
    return typeof zoom === "number" && Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
}
function $3438a2478d5b847f$var$applyTheme(container, theme) {
    const media = window.matchMedia?.("(prefers-color-scheme: dark)");
    const classes = [
        "ofv-theme-light",
        "ofv-theme-dark"
    ];
    const setThemeClass = ()=>{
        container.classList.remove(...classes);
        const resolvedTheme = theme === "auto" && media?.matches ? "dark" : theme === "auto" ? "light" : theme;
        container.classList.add(`ofv-theme-${resolvedTheme}`);
    };
    setThemeClass();
    if (theme === "auto") $3438a2478d5b847f$var$addMediaListener(media, setThemeClass);
    return {
        destroy () {
            if (theme === "auto") $3438a2478d5b847f$var$removeMediaListener(media, setThemeClass);
            container.classList.remove(...classes);
        }
    };
}
function $3438a2478d5b847f$var$observeResize(element, callback) {
    if (typeof ResizeObserver !== "undefined") {
        const observer = new ResizeObserver(callback);
        observer.observe(element);
        return {
            destroy () {
                observer.disconnect();
            }
        };
    }
    window.addEventListener("resize", callback);
    return {
        destroy () {
            window.removeEventListener("resize", callback);
        }
    };
}
function $3438a2478d5b847f$var$addMediaListener(media, listener) {
    if (!media) return;
    if (typeof media.addEventListener === "function") {
        media.addEventListener("change", listener);
        return;
    }
    media.addListener?.(listener);
}
function $3438a2478d5b847f$var$removeMediaListener(media, listener) {
    if (!media) return;
    if (typeof media.removeEventListener === "function") {
        media.removeEventListener("change", listener);
        return;
    }
    media.removeListener?.(listener);
}
function $3438a2478d5b847f$var$createToolbar(toolbar, viewport, queue, locale) {
    if (!toolbar) return void 0;
    const options = typeof toolbar === "boolean" ? {
        zoom: true,
        rotate: true,
        download: true,
        fullscreen: true,
        print: true,
        search: true
    } : toolbar;
    const element = document.createElement("div");
    element.className = "ofv-toolbar";
    element.setAttribute("role", "toolbar");
    element.setAttribute("aria-label", $3438a2478d5b847f$var$defaultToolbarText[locale].ariaLabel);
    let file;
    let currentIndex = 0;
    let currentLength = queue.getLength();
    let queueLabel;
    let previousButton;
    let nextButton;
    let zoomResetButton;
    let fullscreenButton;
    let currentZoom;
    const commandButtons = [];
    const customButtons = [];
    const disposers = [];
    const search = $3438a2478d5b847f$var$createSearchController(viewport);
    let searchInput;
    let searchCount;
    let canRunCommand = (_command)=>false;
    const getContext = ()=>$3438a2478d5b847f$var$createToolbarContext({
            file: file,
            index: currentIndex,
            length: currentLength,
            viewport: viewport,
            queue: queue,
            element: element,
            search: search,
            canCommand: canRunCommand,
            refreshCommandSupport: refreshCommandSupport,
            zoom: currentZoom,
            setZoom: setZoom
        });
    const addButton = (label, title, action, className, icon, iconOnly = false)=>{
        const button = document.createElement("button");
        button.type = "button";
        $3438a2478d5b847f$var$setToolbarButtonContent(button, label, icon, iconOnly);
        button.title = title;
        button.setAttribute("aria-label", title);
        if (className) button.className = className;
        button.addEventListener("click", action);
        element.append(button);
        disposers.push(()=>button.removeEventListener("click", action));
        return button;
    };
    const addCommandButton = (id, label, title, command)=>{
        const button = addButton(label, title, ()=>{
            queue.command(command);
        }, void 0, $3438a2478d5b847f$var$getToolbarIcon(options, id), id !== "zoom-reset");
        button.disabled = true;
        commandButtons.push({
            button: button,
            command: command
        });
    };
    const renderDefaultAction = (id)=>{
        if (!$3438a2478d5b847f$var$isBuiltInToolbarAction(id)) {
            const customAction = options.actions?.find((action)=>action.id === id);
            if (customAction) renderCustomAction(customAction);
            return;
        }
        if (id === "previous" && queue.getLength() > 1) {
            previousButton = addButton($3438a2478d5b847f$var$getToolbarLabel(options, locale, "previous"), $3438a2478d5b847f$var$getToolbarTitle(options, locale, "previous"), ()=>void queue.previous(), void 0, $3438a2478d5b847f$var$getToolbarIcon(options, "previous"), true);
            return;
        }
        if (id === "next" && queue.getLength() > 1) {
            nextButton = addButton($3438a2478d5b847f$var$getToolbarLabel(options, locale, "next"), $3438a2478d5b847f$var$getToolbarTitle(options, locale, "next"), ()=>void queue.next(), void 0, $3438a2478d5b847f$var$getToolbarIcon(options, "next"), true);
            return;
        }
        if (id === "queue" && queue.getLength() > 1) {
            queueLabel = document.createElement("span");
            queueLabel.className = "ofv-toolbar-queue";
            element.append(queueLabel);
            return;
        }
        if (id === "zoom-out" && options.zoom) {
            addCommandButton(id, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), "zoom-out");
            return;
        }
        if (id === "zoom-in" && options.zoom) {
            addCommandButton(id, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), "zoom-in");
            return;
        }
        if (id === "zoom-reset" && options.zoom) {
            addCommandButton(id, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), "zoom-reset");
            zoomResetButton = commandButtons[commandButtons.length - 1]?.button;
            updateZoomLabel();
            return;
        }
        if (id === "rotate-left" && options.rotate) {
            addCommandButton(id, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), "rotate-left");
            return;
        }
        if (id === "rotate-right" && options.rotate) {
            addCommandButton(id, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), "rotate-right");
            return;
        }
        if (id === "download" && options.download !== false) {
            addButton($3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), ()=>getContext().download(), void 0, $3438a2478d5b847f$var$getToolbarIcon(options, "download"), true);
            return;
        }
        if (id === "fullscreen" && options.fullscreen !== false) {
            fullscreenButton = addButton($3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), ()=>getContext().fullscreen(), void 0, $3438a2478d5b847f$var$getToolbarIcon(options, "fullscreen"), true);
            updateFullscreenButton();
            return;
        }
        if (id === "print" && options.print) {
            addButton($3438a2478d5b847f$var$getToolbarLabel(options, locale, id), $3438a2478d5b847f$var$getToolbarTitle(options, locale, id), ()=>getContext().print(), void 0, $3438a2478d5b847f$var$getToolbarIcon(options, "print"), true);
            return;
        }
        if (id === "search" && options.search !== false) {
            renderSearchControl();
            return;
        }
    };
    const renderCustomAction = (action)=>{
        const button = addButton(action.label, action.title || action.label, ()=>void action.onClick(getContext()), action.className, action.icon);
        button.dataset.ofvToolbarAction = action.id;
        customButtons.push({
            button: button,
            action: action
        });
    };
    const renderSearchControl = ()=>{
        const searchGroup = document.createElement("div");
        searchGroup.className = "ofv-toolbar-search";
        searchGroup.title = $3438a2478d5b847f$var$getToolbarTitle(options, locale, "search");
        const searchIcon = document.createElement("span");
        searchIcon.className = "ofv-toolbar-search-icon";
        searchIcon.setAttribute("aria-hidden", "true");
        searchIcon.append($3438a2478d5b847f$var$sanitizeToolbarIcon($3438a2478d5b847f$var$defaultToolbarIcons.search ?? ""));
        searchGroup.append(searchIcon);
        const nextSearchInput = document.createElement("input");
        nextSearchInput.type = "search";
        nextSearchInput.placeholder = $3438a2478d5b847f$var$getToolbarLabel(options, locale, "search");
        nextSearchInput.setAttribute("aria-label", $3438a2478d5b847f$var$getToolbarTitle(options, locale, "search"));
        const nextSearchCount = document.createElement("span");
        nextSearchCount.className = "ofv-toolbar-search-count";
        searchInput = nextSearchInput;
        searchCount = nextSearchCount;
        const runSearch = ()=>{
            const count = search.search(nextSearchInput.value);
            nextSearchCount.textContent = nextSearchInput.value ? String(count) : "";
        };
        nextSearchInput.addEventListener("input", runSearch);
        searchGroup.append(nextSearchInput, nextSearchCount);
        element.append(searchGroup);
        disposers.push(()=>nextSearchInput.removeEventListener("input", runSearch));
    };
    const renderToolbar = ()=>{
        if (options.render) {
            element.replaceChildren();
            const customElement = options.render(getContext());
            if (customElement) element.append(customElement);
            return;
        }
        const order = $3438a2478d5b847f$var$getToolbarOrder(options, queue.getLength());
        if (options.order) order.forEach(renderDefaultAction);
        else {
            const rendered = /* @__PURE__ */ new Set();
            for (const group of $3438a2478d5b847f$var$defaultToolbarGroups){
                const ids = group.filter((id)=>order.includes(id));
                if (ids.length === 0) continue;
                const before = element.childElementCount;
                for (const id of ids){
                    rendered.add(id);
                    renderDefaultAction(id);
                }
                if (before > 0 && element.childElementCount > before) {
                    const separator = document.createElement("span");
                    separator.className = "ofv-toolbar-sep";
                    separator.setAttribute("aria-hidden", "true");
                    element.insertBefore(separator, element.children[before]);
                }
            }
            order.filter((id)=>!rendered.has(id)).forEach(renderDefaultAction);
        }
        $3438a2478d5b847f$var$getImplicitCustomActions(options).forEach(renderCustomAction);
    };
    renderToolbar();
    const updateCustomButtons = ()=>{
        const context = getContext();
        for (const { button: button, action: action } of customButtons){
            button.disabled = $3438a2478d5b847f$var$evaluateToolbarFlag(action.disabled, context);
            button.hidden = $3438a2478d5b847f$var$evaluateToolbarFlag(action.hidden, context);
        }
    };
    const resetSearch = ()=>{
        search.clear();
        if (searchInput) searchInput.value = "";
        if (searchCount) searchCount.textContent = "";
    };
    function setZoom(zoom) {
        currentZoom = typeof zoom === "number" && Number.isFinite(zoom) && zoom > 0 ? zoom : void 0;
        updateZoomLabel();
        updateCustomButtons();
        refreshCustomRender();
    }
    function updateZoomLabel() {
        if (!zoomResetButton) return;
        $3438a2478d5b847f$var$setToolbarButtonContent(zoomResetButton, currentZoom === void 0 ? $3438a2478d5b847f$var$getToolbarLabel(options, locale, "zoom-reset") : $3438a2478d5b847f$var$formatToolbarZoom(currentZoom), options.icons?.["zoom-reset"]);
        zoomResetButton.classList.add("ofv-toolbar-zoom-reset");
    }
    function refreshCommandSupport() {
        commandButtons.forEach(({ button: button, command: command })=>{
            button.disabled = !canRunCommand(command);
        });
        updateCustomButtons();
        refreshCustomRender();
    }
    function isFullscreenActive() {
        return Boolean(typeof document !== "undefined" && element.parentElement && document.fullscreenElement === element.parentElement);
    }
    function updateFullscreenButton() {
        if (!fullscreenButton) return;
        const active = isFullscreenActive();
        const id = active ? "exit-fullscreen" : "fullscreen";
        const icon = active ? options.icons?.["exit-fullscreen"] ?? options.icons?.fullscreen ?? $3438a2478d5b847f$var$defaultToolbarIcons["exit-fullscreen"] : $3438a2478d5b847f$var$getToolbarIcon(options, "fullscreen");
        $3438a2478d5b847f$var$setToolbarButtonContent(fullscreenButton, $3438a2478d5b847f$var$getToolbarLabel(options, locale, id), icon, true);
        const title = $3438a2478d5b847f$var$getToolbarTitle(options, locale, id);
        fullscreenButton.title = title;
        fullscreenButton.setAttribute("aria-label", title);
        fullscreenButton.setAttribute("aria-pressed", String(active));
    }
    const handleFullscreenChange = ()=>{
        updateFullscreenButton();
        refreshCustomRender();
    };
    if (typeof document !== "undefined") {
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        disposers.push(()=>document.removeEventListener("fullscreenchange", handleFullscreenChange));
    }
    const refreshCustomRender = ()=>{
        if (!options.render) return;
        element.replaceChildren();
        const customElement = options.render(getContext());
        if (customElement) element.append(customElement);
    };
    return {
        element: element,
        update (nextFile, index, length) {
            file = nextFile;
            currentIndex = index;
            currentLength = length;
            currentZoom = void 0;
            updateZoomLabel();
            resetSearch();
            commandButtons.forEach(({ button: button })=>{
                button.disabled = true;
            });
            if (queueLabel) queueLabel.textContent = `${index + 1} / ${length}`;
            if (previousButton) previousButton.disabled = index <= 0;
            if (nextButton) nextButton.disabled = index >= length - 1;
            updateCustomButtons();
            refreshCustomRender();
        },
        setCommandSupport (isSupported) {
            canRunCommand = isSupported;
            if (!canRunCommand("zoom-in") && !canRunCommand("zoom-out") && !canRunCommand("zoom-reset")) {
                currentZoom = void 0;
                updateZoomLabel();
            }
            refreshCommandSupport();
        },
        getContext: getContext,
        setZoom: setZoom,
        destroy () {
            search.clear();
            for (const dispose of disposers)dispose();
            element.replaceChildren();
        }
    };
}
function $3438a2478d5b847f$var$createToolbarContext({ file: file, index: index, length: length, viewport: viewport, queue: queue, element: element, search: search, canCommand: canCommand, refreshCommandSupport: refreshCommandSupport, zoom: zoom, setZoom: setZoom }) {
    return {
        file: file,
        index: index,
        length: length,
        viewport: viewport,
        canPrevious: index > 0,
        canNext: index < length - 1,
        isFullscreen: Boolean(typeof document !== "undefined" && element.parentElement && document.fullscreenElement === element.parentElement),
        zoom: zoom,
        zoomLabel: zoom === void 0 ? void 0 : $3438a2478d5b847f$var$formatToolbarZoom(zoom),
        async previous () {
            await queue.previous();
        },
        async next () {
            await queue.next();
        },
        goToPage: queue.goToPage,
        command: queue.command,
        canCommand: canCommand,
        refreshCommandSupport: refreshCommandSupport,
        setZoom: setZoom,
        download () {
            if (file) $3438a2478d5b847f$var$downloadFile(file);
        },
        fullscreen () {
            const target = element.parentElement;
            if (!target) return;
            if (typeof document !== "undefined" && document.fullscreenElement === target) document.exitFullscreen?.();
            else target.requestFullscreen?.();
        },
        print () {
            queue.print();
        },
        search: search.search,
        clearSearch: search.clear
    };
}
var $3438a2478d5b847f$var$toolbarIcon = (content)=>`<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${content}</svg>`;
var $3438a2478d5b847f$var$defaultToolbarIcons = {
    previous: $3438a2478d5b847f$var$toolbarIcon('<path d="M9.8 3.8 5.6 8l4.2 4.2"/>'),
    next: $3438a2478d5b847f$var$toolbarIcon('<path d="M6.2 3.8 10.4 8l-4.2 4.2"/>'),
    "zoom-out": $3438a2478d5b847f$var$toolbarIcon('<circle cx="7.2" cy="7.2" r="4.4"/><path d="M13.5 13.5l-3.2-3.2"/><path d="M5.4 7.2h3.6"/>'),
    "zoom-in": $3438a2478d5b847f$var$toolbarIcon('<circle cx="7.2" cy="7.2" r="4.4"/><path d="M13.5 13.5l-3.2-3.2"/><path d="M5.4 7.2h3.6"/><path d="M7.2 5.4v3.6"/>'),
    "rotate-left": $3438a2478d5b847f$var$toolbarIcon('<path d="M2.2 8a5.8 5.8 0 1 0 1.7-4.1L2.2 5.6"/><path d="M2.2 2.2v3.4h3.4"/>'),
    "rotate-right": $3438a2478d5b847f$var$toolbarIcon('<path d="M13.8 8a5.8 5.8 0 1 1-1.7-4.1l1.7 1.7"/><path d="M13.8 2.2v3.4h-3.4"/>'),
    download: $3438a2478d5b847f$var$toolbarIcon('<path d="M8 2.6v6.9"/><path d="m4.9 6.6 3.1 3.1 3.1-3.1"/><path d="M2.9 11.2v1a1.3 1.3 0 0 0 1.3 1.3h7.6a1.3 1.3 0 0 0 1.3-1.3v-1"/>'),
    fullscreen: $3438a2478d5b847f$var$toolbarIcon('<path d="M6 2.9H4.2A1.3 1.3 0 0 0 2.9 4.2V6"/><path d="M10 2.9h1.8a1.3 1.3 0 0 1 1.3 1.3V6"/><path d="M6 13.1H4.2a1.3 1.3 0 0 1-1.3-1.3V10"/><path d="M10 13.1h1.8a1.3 1.3 0 0 0 1.3-1.3V10"/>'),
    "exit-fullscreen": $3438a2478d5b847f$var$toolbarIcon('<path d="M2.9 6h1.8A1.3 1.3 0 0 0 6 4.7V2.9"/><path d="M13.1 6h-1.8A1.3 1.3 0 0 1 10 4.7V2.9"/><path d="M2.9 10h1.8A1.3 1.3 0 0 1 6 11.3v1.8"/><path d="M13.1 10h-1.8a1.3 1.3 0 0 0-1.3 1.3v1.8"/>'),
    print: $3438a2478d5b847f$var$toolbarIcon('<path d="M4.7 5.8V2.9h6.6v2.9"/><path d="M4.7 11.4H3.5a1.3 1.3 0 0 1-1.3-1.3V7.2a1.4 1.4 0 0 1 1.4-1.4h8.8a1.4 1.4 0 0 1 1.4 1.4v2.9a1.3 1.3 0 0 1-1.3 1.3h-1.2"/><path d="M4.7 9.5h6.6v3.6H4.7z"/>'),
    search: $3438a2478d5b847f$var$toolbarIcon('<circle cx="7.2" cy="7.2" r="4.4"/><path d="M13.5 13.5l-3.2-3.2"/>')
};
function $3438a2478d5b847f$var$getToolbarIcon(options, id) {
    return options.icons?.[id] ?? $3438a2478d5b847f$var$defaultToolbarIcons[id];
}
var $3438a2478d5b847f$var$defaultToolbarGroups = [
    [
        "previous",
        "next",
        "queue"
    ],
    [
        "zoom-out",
        "zoom-in",
        "zoom-reset",
        "rotate-left",
        "rotate-right"
    ],
    [
        "download",
        "fullscreen",
        "print"
    ]
];
var $3438a2478d5b847f$var$defaultToolbarText = {
    "zh-CN": {
        ariaLabel: "\u6587\u4EF6\u9884\u89C8\u5DE5\u5177\u680F",
        labels: {
            previous: "\u4E0A\u4E00\u4E2A",
            next: "\u4E0B\u4E00\u4E2A",
            queue: "",
            "zoom-out": "-",
            "zoom-in": "+",
            "zoom-reset": "100%",
            "rotate-left": "\u5DE6\u65CB",
            "rotate-right": "\u65CB\u8F6C",
            download: "\u4E0B\u8F7D",
            fullscreen: "\u5168\u5C4F",
            "exit-fullscreen": "\u9000\u51FA\u5168\u5C4F",
            print: "\u6253\u5370",
            search: "\u641C\u7D22"
        },
        titles: {
            previous: "\u4E0A\u4E00\u4E2A\u6587\u4EF6",
            next: "\u4E0B\u4E00\u4E2A\u6587\u4EF6",
            queue: "\u5F53\u524D\u6587\u4EF6\u4F4D\u7F6E",
            "zoom-out": "\u7F29\u5C0F",
            "zoom-in": "\u653E\u5927",
            "zoom-reset": "\u91CD\u7F6E\u7F29\u653E",
            "rotate-left": "\u5411\u5DE6\u65CB\u8F6C",
            "rotate-right": "\u5411\u53F3\u65CB\u8F6C",
            download: "\u4E0B\u8F7D\u6587\u4EF6",
            fullscreen: "\u5168\u5C4F\u67E5\u770B\u9884\u89C8",
            "exit-fullscreen": "\u9000\u51FA\u5168\u5C4F",
            print: "\u6253\u5370\u9884\u89C8",
            search: "\u641C\u7D22\u9884\u89C8\u6587\u672C"
        }
    },
    "en-US": {
        ariaLabel: "File preview toolbar",
        labels: {
            previous: "Prev",
            next: "Next",
            queue: "",
            "zoom-out": "-",
            "zoom-in": "+",
            "zoom-reset": "100%",
            "rotate-left": "Rotate left",
            "rotate-right": "Rotate",
            download: "Download",
            fullscreen: "Fullscreen",
            "exit-fullscreen": "Exit fullscreen",
            print: "Print",
            search: "Search"
        },
        titles: {
            previous: "Previous file",
            next: "Next file",
            queue: "Current file position",
            "zoom-out": "Zoom out",
            "zoom-in": "Zoom in",
            "zoom-reset": "Reset zoom",
            "rotate-left": "Rotate left",
            "rotate-right": "Rotate right",
            download: "Download file",
            fullscreen: "Open preview fullscreen",
            "exit-fullscreen": "Exit fullscreen",
            print: "Print preview",
            search: "Search preview text"
        }
    }
};
function $3438a2478d5b847f$var$getToolbarLabel(options, locale, id) {
    return options.labels?.[id] ?? $3438a2478d5b847f$var$defaultToolbarText[locale].labels[id];
}
function $3438a2478d5b847f$var$getToolbarTitle(options, locale, id) {
    return options.titles?.[id] ?? options.labels?.[id] ?? $3438a2478d5b847f$var$defaultToolbarText[locale].titles[id];
}
function $3438a2478d5b847f$var$formatToolbarZoom(zoom) {
    return `${Math.round(zoom * 100)}%`;
}
function $3438a2478d5b847f$var$getToolbarOrder(options, queueLength) {
    if (options.order) return options.order;
    const actions = [];
    if (queueLength > 1) actions.push("previous", "next", "queue");
    if (options.zoom) actions.push("zoom-out", "zoom-in", "zoom-reset");
    if (options.rotate) actions.push("rotate-left", "rotate-right");
    if (options.download !== false) actions.push("download");
    if (options.fullscreen !== false) actions.push("fullscreen");
    if (options.print) actions.push("print");
    if (options.search !== false) actions.push("search");
    return actions;
}
function $3438a2478d5b847f$var$getImplicitCustomActions(options) {
    if (options.order || !options.actions) return [];
    return [
        ...options.actions
    ].sort((a, b)=>(a.order ?? 0) - (b.order ?? 0));
}
function $3438a2478d5b847f$var$evaluateToolbarFlag(value, context) {
    return typeof value === "function" ? value(context) : Boolean(value);
}
function $3438a2478d5b847f$var$setToolbarButtonContent(button, label, icon, iconOnly = false) {
    button.replaceChildren();
    button.classList.toggle("ofv-toolbar-icon-button", Boolean(icon) && iconOnly);
    if (!icon) {
        button.textContent = label;
        return;
    }
    const iconElement = document.createElement("span");
    iconElement.className = "ofv-toolbar-icon";
    iconElement.setAttribute("aria-hidden", "true");
    if (typeof icon === "string") iconElement.append($3438a2478d5b847f$var$sanitizeToolbarIcon(icon));
    else iconElement.append(icon.cloneNode(true));
    const labelElement = document.createElement("span");
    labelElement.className = "ofv-toolbar-label";
    labelElement.textContent = label;
    button.append(iconElement, labelElement);
}
var $3438a2478d5b847f$var$allowedToolbarIconTags = /* @__PURE__ */ new Set([
    "svg",
    "g",
    "path",
    "circle",
    "rect",
    "line",
    "polyline",
    "polygon",
    "ellipse",
    "defs",
    "title",
    "desc"
]);
var $3438a2478d5b847f$var$allowedToolbarIconAttrs = /* @__PURE__ */ new Set([
    "aria-hidden",
    "class",
    "cx",
    "cy",
    "d",
    "fill",
    "focusable",
    "height",
    "id",
    "points",
    "r",
    "rx",
    "ry",
    "stroke",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-width",
    "transform",
    "viewBox",
    "width",
    "x",
    "x1",
    "x2",
    "y",
    "y1",
    "y2"
]);
function $3438a2478d5b847f$var$sanitizeToolbarIcon(icon) {
    const template = document.createElement("template");
    template.innerHTML = icon.trim();
    const fragment = document.createDocumentFragment();
    for (const child of Array.from(template.content.childNodes)){
        const sanitized = $3438a2478d5b847f$var$sanitizeToolbarIconNode(child);
        if (sanitized) fragment.append(sanitized);
    }
    return fragment;
}
function $3438a2478d5b847f$var$sanitizeToolbarIconNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || "";
        return text.trim() ? document.createTextNode(text) : null;
    }
    if (!(node instanceof Element)) return null;
    const tagName = node.tagName.toLowerCase();
    if (!$3438a2478d5b847f$var$allowedToolbarIconTags.has(tagName)) return null;
    const sanitized = document.createElementNS("http://www.w3.org/2000/svg", tagName);
    for (const attr of Array.from(node.attributes))if ($3438a2478d5b847f$var$isSafeToolbarIconAttribute(attr.name, attr.value)) sanitized.setAttribute(attr.name, attr.value);
    for (const child of Array.from(node.childNodes)){
        const sanitizedChild = $3438a2478d5b847f$var$sanitizeToolbarIconNode(child);
        if (sanitizedChild) sanitized.append(sanitizedChild);
    }
    return sanitized;
}
function $3438a2478d5b847f$var$isSafeToolbarIconAttribute(name, value) {
    const attrName = name.toLowerCase();
    if (attrName.startsWith("on") || attrName.includes(":")) return false;
    if (!$3438a2478d5b847f$var$allowedToolbarIconAttrs.has(name) && !$3438a2478d5b847f$var$allowedToolbarIconAttrs.has(attrName) && !attrName.startsWith("data-")) return false;
    return !/^\s*(?:javascript|data:text\/html|vbscript):/i.test(value);
}
function $3438a2478d5b847f$var$isBuiltInToolbarAction(id) {
    return id in $3438a2478d5b847f$var$defaultToolbarText["en-US"].labels;
}
function $3438a2478d5b847f$var$createSearchController(root) {
    const markerClass = "ofv-search-match";
    const clear = ()=>{
        const markers = $3438a2478d5b847f$var$collectSearchRoots(root).flatMap((searchRoot)=>[
                ...searchRoot.querySelectorAll(`mark.${markerClass}`)
            ]);
        for (const marker of markers)marker.replaceWith(document.createTextNode(marker.textContent || ""));
        $3438a2478d5b847f$var$collectSearchRoots(root).forEach((searchRoot)=>searchRoot.normalize());
    };
    const search = (query)=>{
        clear();
        const normalizedQuery = query.trim();
        if (!normalizedQuery) return 0;
        const textNodes = $3438a2478d5b847f$var$collectSearchRoots(root).flatMap((searchRoot)=>$3438a2478d5b847f$var$collectSearchableTextNodes(searchRoot));
        let count = 0;
        let firstMatch;
        for (const node of textNodes){
            const text = node.nodeValue || "";
            const lowerText = text.toLowerCase();
            const lowerQuery = normalizedQuery.toLowerCase();
            let start = 0;
            let index = lowerText.indexOf(lowerQuery, start);
            if (index < 0) continue;
            const fragment = document.createDocumentFragment();
            while(index >= 0){
                if (index > start) fragment.append(document.createTextNode(text.slice(start, index)));
                const marker = document.createElement("mark");
                marker.className = markerClass;
                marker.textContent = text.slice(index, index + normalizedQuery.length);
                fragment.append(marker);
                firstMatch ||= marker;
                count += 1;
                start = index + normalizedQuery.length;
                index = lowerText.indexOf(lowerQuery, start);
            }
            if (start < text.length) fragment.append(document.createTextNode(text.slice(start)));
            node.replaceWith(fragment);
        }
        firstMatch?.scrollIntoView?.({
            block: "center",
            inline: "nearest"
        });
        return count;
    };
    return {
        search: search,
        clear: clear
    };
}
function $3438a2478d5b847f$var$collectSearchRoots(root) {
    const roots = [
        root
    ];
    for (const iframe of root.querySelectorAll("iframe"))try {
        const body = iframe.contentDocument?.body;
        if (body) roots.push(body);
    } catch  {}
    return roots;
}
function $3438a2478d5b847f$var$collectSearchableTextNodes(root) {
    const nodes = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode (node) {
            const parent = node.parentElement;
            if (!parent || !node.nodeValue?.trim()) return NodeFilter.FILTER_REJECT;
            if ([
                "SCRIPT",
                "STYLE",
                "TEXTAREA",
                "INPUT",
                "BUTTON"
            ].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
            if ($3438a2478d5b847f$var$hasHiddenSearchAncestor(parent, root)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let current = walker.nextNode();
    while(current){
        nodes.push(current);
        current = walker.nextNode();
    }
    return nodes;
}
function $3438a2478d5b847f$var$hasHiddenSearchAncestor(element, root) {
    let current = element;
    while(current){
        if (current.hidden || current.getAttribute("aria-hidden") === "true" || current.style.display === "none" || current.style.visibility === "hidden") return true;
        if (current === root) break;
        current = current.parentElement;
    }
    return false;
}
var $3438a2478d5b847f$var$PRINT_RESOURCE_WAIT_TIMEOUT_MS = 15e3;
var $3438a2478d5b847f$var$PRINT_FRAME_CLEANUP_TIMEOUT_MS = 5 * 6e4;
function $3438a2478d5b847f$var$printPreview(viewport) {
    const frame = document.createElement("iframe");
    frame.className = "ofv-print-frame";
    frame.setAttribute("aria-hidden", "true");
    document.body.append(frame);
    const clone = viewport.cloneNode(true);
    $3438a2478d5b847f$var$copyCanvasContent(viewport, clone);
    clone.classList.add("ofv-print-root", "ofv-root");
    const docxPage = viewport.querySelector(".ofv-docx-page-frame > section.ofv-docx");
    const docxPageStyle = docxPage ? getComputedStyle(docxPage) : void 0;
    const docxPageWidth = Number.parseFloat(docxPageStyle?.width || "");
    const docxPageHeight = Number.parseFloat(docxPageStyle?.height || "");
    const docxPageSizeRule = Number.isFinite(docxPageWidth) && Number.isFinite(docxPageHeight) ? `size: ${docxPageWidth}px ${docxPageHeight}px;` : "";
    const pptxViewer = clone.querySelector(".ofv-pptx-viewer") || (clone.classList.contains("ofv-pptx-viewer") ? clone : null);
    let intrinsicWidth = 960;
    let intrinsicHeight = 540;
    let hasSlides = false;
    if (pptxViewer) {
        const slides = pptxViewer.querySelectorAll("[data-slide-index]");
        if (slides.length > 0) {
            hasSlides = true;
            const firstWrapper = slides[0].firstElementChild;
            const firstSlide = firstWrapper?.firstElementChild;
            if (firstSlide) {
                intrinsicWidth = parseInt(firstSlide.style.width) || 960;
                intrinsicHeight = parseInt(firstSlide.style.height) || 540;
            }
            slides.forEach((slideEl)=>{
                const item = slideEl;
                item.style.width = "100%";
                item.style.margin = "0 0 20px 0";
                const wrapper = item.firstElementChild;
                if (wrapper) {
                    wrapper.style.width = `${intrinsicWidth}px`;
                    wrapper.style.height = `${intrinsicHeight}px`;
                    wrapper.style.boxShadow = "none";
                    wrapper.style.margin = "0 auto";
                    const slideContent = wrapper.firstElementChild;
                    if (slideContent) {
                        slideContent.style.transform = "none";
                        slideContent.style.width = `${intrinsicWidth}px`;
                        slideContent.style.height = `${intrinsicHeight}px`;
                    }
                }
            });
        }
    }
    const doc = frame.contentDocument;
    if (!doc) {
        frame.remove();
        return;
    }
    doc.open();
    doc.write(`<!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Print preview</title>
      </head>
      <body></body>
    </html>`);
    doc.close();
    Array.from(document.querySelectorAll("style, link[rel='stylesheet']")).forEach((el)=>{
        doc.head.appendChild(el.cloneNode(true));
    });
    const baseStyle = doc.createElement("style");
    baseStyle.textContent = `
    * { box-sizing: border-box; }
    html, body {
      margin: 0;
      padding: 0;
      background: #fff;
      color: #111827;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }
    body { padding: 16px; }
    img, video, canvas, svg { max-width: 100%; }
    pre {
      white-space: pre-wrap;
      word-break: break-word;
      font: 12px/1.5 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    }
    .ofv-viewport, .ofv-print-root {
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
      background: #fff !important;
      color: #111827 !important;
      border: none !important;
      box-shadow: none !important;
    }
    .ofv-pdf {
      padding: 0;
      overflow: visible;
      background: #fff;
    }
    .ofv-pdf-page {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 0 auto 16px;
      box-shadow: none;
    }
    .ofv-panel,
    .ofv-text,
    .ofv-text-block,
    .ofv-file-list {
      max-height: none;
      min-height: 0;
      overflow: visible;
    }
    .ofv-section {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  `;
    doc.head.appendChild(baseStyle);
    if (docxPage) {
        const docxStyle = doc.createElement("style");
        docxStyle.textContent = `
      @media print {
        @page {
          ${docxPageSizeRule}
          margin: 0;
        }
        html, body,
        .ofv-print-root,
        .ofv-office-docx,
        .ofv-docx-document {
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
        }
        .ofv-office-docx {
          --ofv-office-zoom: 1 !important;
        }
        .ofv-docx-document .ofv-docx-wrapper {
          display: block !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          --ofv-docx-scale: 1 !important;
        }
        .ofv-docx-page-frame {
          display: block !important;
          width: max-content !important;
          max-width: none !important;
          height: auto !important;
          margin: 0 !important;
          break-after: page;
          page-break-after: always;
        }
        .ofv-docx-page-frame:last-child {
          break-after: auto;
          page-break-after: auto;
        }
        .ofv-docx-page-frame > section.ofv-docx {
          max-width: none !important;
          margin: 0 !important;
          box-shadow: none !important;
          transform: none !important;
          break-inside: avoid;
          page-break-inside: avoid;
        }
      }
    `;
        doc.head.appendChild(docxStyle);
    }
    if (hasSlides) {
        const pptxStyle = doc.createElement("style");
        pptxStyle.textContent = `
      @media print {
        @page {
          size: ${intrinsicWidth > intrinsicHeight ? "landscape" : "portrait"};
          margin: 0;
        }
        html, body {
          background: #fff;
        }
        body {
          width: ${intrinsicWidth}px !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .ofv-print-root {
          width: ${intrinsicWidth}px !important;
          padding: 0 !important;
        }
        .ofv-pptx-viewer {
          width: ${intrinsicWidth}px !important;
          padding: 0 !important;
          background: #fff !important;
          overflow: visible !important;
        }
        .ofv-pptx-viewer > div[data-slide-index] {
          page-break-after: always;
          break-after: page;
          break-inside: avoid;
          page-break-inside: avoid;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
        }
        .ofv-pptx-viewer > div[data-slide-index]:last-child {
          page-break-after: avoid;
          break-after: avoid;
        }
      }
    `;
        doc.head.appendChild(pptxStyle);
    }
    doc.body.append(clone);
    const printWindow = frame.contentWindow;
    if (!printWindow) {
        frame.remove();
        return;
    }
    let cleanedUp = false;
    let cleanupTimer;
    const cleanup = ()=>{
        if (cleanedUp) return;
        cleanedUp = true;
        window.clearTimeout(cleanupTimer);
        printWindow.removeEventListener?.("afterprint", cleanup);
        frame.remove();
    };
    printWindow.addEventListener?.("afterprint", cleanup, {
        once: true
    });
    $3438a2478d5b847f$var$waitForPrintResources(doc).then(()=>{
        if (cleanedUp || !frame.isConnected) return;
        cleanupTimer = window.setTimeout(cleanup, $3438a2478d5b847f$var$PRINT_FRAME_CLEANUP_TIMEOUT_MS);
        try {
            printWindow.focus();
            printWindow.print();
        } catch  {
            cleanup();
        }
    });
}
async function $3438a2478d5b847f$var$waitForPrintResources(doc) {
    const pending = [];
    for (const image of Array.from(doc.images))pending.push($3438a2478d5b847f$var$waitForPrintImage(image));
    for (const stylesheet of Array.from(doc.querySelectorAll("link[rel='stylesheet']")))pending.push($3438a2478d5b847f$var$waitForPrintStylesheet(stylesheet));
    if (doc.fonts?.ready) pending.push(Promise.resolve(doc.fonts.ready).then(()=>void 0, ()=>void 0));
    await $3438a2478d5b847f$var$settlePrintResources(pending);
    doc.body.offsetHeight;
    await new Promise((resolve)=>window.setTimeout(resolve, 0));
}
function $3438a2478d5b847f$var$waitForPrintImage(image) {
    if (typeof image.decode === "function") return image.decode().then(()=>void 0, ()=>void 0);
    if (image.complete) return Promise.resolve();
    return $3438a2478d5b847f$var$waitForPrintElement(image);
}
function $3438a2478d5b847f$var$waitForPrintStylesheet(stylesheet) {
    try {
        if (stylesheet.sheet) return Promise.resolve();
    } catch  {}
    return $3438a2478d5b847f$var$waitForPrintElement(stylesheet);
}
function $3438a2478d5b847f$var$waitForPrintElement(element) {
    return new Promise((resolve)=>{
        const done = ()=>{
            element.removeEventListener("load", done);
            element.removeEventListener("error", done);
            resolve();
        };
        element.addEventListener("load", done, {
            once: true
        });
        element.addEventListener("error", done, {
            once: true
        });
    });
}
function $3438a2478d5b847f$var$settlePrintResources(pending) {
    if (pending.length === 0) return Promise.resolve();
    return new Promise((resolve)=>{
        let settled = false;
        const finish = ()=>{
            if (settled) return;
            settled = true;
            window.clearTimeout(timeout);
            resolve();
        };
        const timeout = window.setTimeout(finish, $3438a2478d5b847f$var$PRINT_RESOURCE_WAIT_TIMEOUT_MS);
        Promise.all(pending).then(finish, finish);
    });
}
function $3438a2478d5b847f$var$copyCanvasContent(sourceRoot, targetRoot) {
    const sourceCanvases = [
        ...sourceRoot.querySelectorAll("canvas")
    ];
    const targetCanvases = [
        ...targetRoot.querySelectorAll("canvas")
    ];
    sourceCanvases.forEach((sourceCanvas, index)=>{
        const targetCanvas = targetCanvases[index];
        if (!targetCanvas) return;
        const image = document.createElement("img");
        image.className = targetCanvas.className;
        image.alt = "Canvas preview page";
        try {
            image.src = sourceCanvas.toDataURL("image/png");
        } catch  {
            return;
        }
        image.width = sourceCanvas.width;
        image.height = sourceCanvas.height;
        targetCanvas.replaceWith(image);
    });
}
function $3438a2478d5b847f$var$downloadFile(file) {
    const url = $3438a2478d5b847f$export$191fa6957fae12db(file);
    const isExternal = Boolean(file.url);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name;
    link.rel = "noopener";
    link.hidden = true;
    document.body.append(link);
    link.click();
    window.setTimeout(()=>{
        link.remove();
        $3438a2478d5b847f$export$7438c4986c08186f(url, isExternal);
    }, 0);
}
async function $3438a2478d5b847f$var$findPlugin(plugins, file) {
    for (const plugin of plugins){
        if (await plugin.match(file)) return plugin;
    }
    return $3438a2478d5b847f$export$23ed2e65aae2ac8a();
}
// src/support.ts
async function $3438a2478d5b847f$export$92b5965787bbedfb(source, plugins, options = {}) {
    const file = await $3438a2478d5b847f$export$e274b0a3e6f55538(source, options.fileName, options.mimeType);
    for (const plugin of plugins){
        if (await plugin.match(file)) return plugin.name !== "fallback";
    }
    return false;
}
// src/plugins/utils.ts
async function $3438a2478d5b847f$export$1ac45368052289f3(file) {
    if (file.source instanceof ArrayBuffer) return file.source;
    if (file.blob) return file.blob.arrayBuffer();
    if (typeof file.source === "string") {
        const response = await fetch(file.source);
        if (!response.ok) throw new Error(`Failed to fetch file: ${response.status}`);
        return response.arrayBuffer();
    }
    throw new Error("Unsupported file source.");
}
async function $3438a2478d5b847f$export$177308921a610223(file) {
    const decode = (buffer)=>$3438a2478d5b847f$export$62387d23696f2b23(buffer);
    if (typeof file.source === "string") {
        const response = await fetch(file.source);
        if (!response.ok) throw new Error(`Failed to fetch text file: ${response.status}`);
        return decode(await response.arrayBuffer());
    }
    if (file.blob) return decode(await file.blob.arrayBuffer());
    if (file.source instanceof ArrayBuffer) return decode(file.source);
    return String(file.source);
}
function $3438a2478d5b847f$export$71ce2d4d67b6d9e4(className = "") {
    const panel = document.createElement("div");
    panel.className = `ofv-panel ${className}`.trim();
    return panel;
}
function $3438a2478d5b847f$export$e2c778f3bf6f56a7(root, selector, page, scroller) {
    const pages = Array.from(root.querySelectorAll(selector));
    if (pages.length === 0) return false;
    const rounded = Math.round(page);
    const pageNumber = Math.min(pages.length, Math.max(1, Number.isFinite(rounded) ? rounded : 1));
    const target = pages[pageNumber - 1];
    const targetTop = scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    const top = Math.max(0, targetTop - 16);
    if (typeof scroller.scrollTo === "function") scroller.scrollTo({
        top: top,
        behavior: "smooth"
    });
    else scroller.scrollTop = top;
    return true;
}
function $3438a2478d5b847f$export$218693075858efcb(ctx, min = 0.1, max = 8) {
    return Math.min(max, Math.max(min, ctx.options.zoom));
}
function $3438a2478d5b847f$export$f3a183bf2efcc835(title) {
    const section = document.createElement("section");
    section.className = "ofv-section";
    const heading = document.createElement("h3");
    heading.textContent = title;
    section.append(heading);
    return section;
}
function $3438a2478d5b847f$export$83ddf0c409009c3c(parent, label, value) {
    const row = document.createElement("div");
    row.className = "ofv-meta-row";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = String(value);
    row.append(key, content);
    parent.append(row);
}
function $3438a2478d5b847f$export$62387d23696f2b23(buffer) {
    return $3438a2478d5b847f$var$decodeTextBytes(new Uint8Array(buffer));
}
function $3438a2478d5b847f$var$decodeTextBytes(bytes) {
    if (bytes.length >= 3 && bytes[0] === 239 && bytes[1] === 187 && bytes[2] === 191) return new TextDecoder("utf-8").decode(bytes.subarray(3));
    if (bytes.length >= 2) {
        if (bytes[0] === 255 && bytes[1] === 254) return new TextDecoder("utf-16le").decode(bytes.subarray(2));
        if (bytes[0] === 254 && bytes[1] === 255) return new TextDecoder("utf-16be").decode(bytes.subarray(2));
    }
    try {
        return new TextDecoder("utf-8", {
            fatal: true
        }).decode(bytes);
    } catch  {
        return $3438a2478d5b847f$var$decodeWithFallback(bytes, "gb18030") || $3438a2478d5b847f$var$decodeWithFallback(bytes, "gbk") || new TextDecoder("utf-8").decode(bytes);
    }
}
function $3438a2478d5b847f$var$decodeWithFallback(bytes, encoding) {
    try {
        return new TextDecoder(encoding).decode(bytes);
    } catch  {
        return void 0;
    }
}
function $3438a2478d5b847f$export$bd0a0e50c4747011(file, mimeMap) {
    return file.extension || mimeMap[file.mimeType] || "";
}
// src/plugins/image.ts
var $3438a2478d5b847f$var$imageExtensions = /* @__PURE__ */ new Set([
    "jpg",
    "jpeg",
    "jfif",
    "pjpe",
    "pjpeg",
    "png",
    "gif",
    "webp",
    "avif",
    "jxl",
    "svg",
    "bmp",
    "ico",
    "cur",
    "tif",
    "tiff",
    "apng",
    "heic",
    "heif"
]);
var $3438a2478d5b847f$var$nonRasterImageExtensions = /* @__PURE__ */ new Set([
    "dxf"
]);
var $3438a2478d5b847f$var$nonRasterImageMimeTypes = /* @__PURE__ */ new Set([
    "image/vnd.dxf",
    "image/vnd.adobe.photoshop"
]);
var $3438a2478d5b847f$var$heicMimeTypes = /* @__PURE__ */ new Set([
    "image/heic",
    "image/heif",
    "image/heic-sequence",
    "image/heif-sequence"
]);

function $3438a2478d5b847f$export$aa676a29a960505() {
    return {
        name: "image",
        match (file) {
            if ($3438a2478d5b847f$var$nonRasterImageExtensions.has(file.extension) || $3438a2478d5b847f$var$nonRasterImageMimeTypes.has(file.mimeType)) return false;
            return file.mimeType.startsWith("image/") || $3438a2478d5b847f$var$imageExtensions.has(file.extension);
        },
        async render (ctx) {
            const ext = ctx.file.extension.toLowerCase();
            const isHeic = ext === "heic" || ext === "heif" || $3438a2478d5b847f$var$heicMimeTypes.has(ctx.file.mimeType.toLowerCase());
            const isTiff = ext === "tif" || ext === "tiff" || ctx.file.mimeType.toLowerCase() === "image/tiff";
            const sourceBytesPromise = $3438a2478d5b847f$var$readImageBytes(ctx.file);
            let url = "";
            let convertedBlob = null;
            let isExternal = Boolean(ctx.file.url);
            let tiffSource = null;
            if (isTiff) {
                ctx.setLoading(true);
                try {
                    const bytes = await sourceBytesPromise;
                    tiffSource = await $3438a2478d5b847f$var$createTiffPreview(bytes, ctx.file.name);
                } catch (err) {
                    console.error("TIFF image conversion failed:", err);
                    url = $3438a2478d5b847f$export$191fa6957fae12db(ctx.file);
                } finally{
                    ctx.setLoading(false);
                }
            } else if (isHeic) {
                ctx.setLoading(true);
                try {
                    let blob = ctx.file.blob;
                    if (!blob && typeof ctx.file.source === "string") {
                        const res = await fetch(ctx.file.source);
                        if (!res.ok) throw new Error(`Failed to fetch HEIC file: ${res.status}`);
                        blob = await res.blob();
                    }
                    if (!blob) throw new Error("HEIC file source cannot be resolved to a Blob.");
                    const heic2anyModule = await (parcelRequire("6LgkD"));
                    const heic2any = heic2anyModule.default || heic2anyModule;
                    const converted = await heic2any({
                        blob: blob,
                        toType: "image/jpeg",
                        quality: 0.8
                    });
                    convertedBlob = Array.isArray(converted) ? converted[0] : converted;
                    url = URL.createObjectURL(convertedBlob);
                    isExternal = false;
                } catch (err) {
                    console.error("HEIC image conversion failed:", err);
                    url = $3438a2478d5b847f$export$191fa6957fae12db(ctx.file);
                    isExternal = Boolean(ctx.file.url);
                } finally{
                    ctx.setLoading(false);
                }
            } else url = $3438a2478d5b847f$export$191fa6957fae12db(ctx.file);
            const wrapper = document.createElement("div");
            wrapper.className = "ofv-image-viewer";
            const showInlineControls = !ctx.options.toolbar;
            const controls = document.createElement("div");
            controls.className = "ofv-image-controls";
            const stage = document.createElement("div");
            stage.className = "ofv-image-stage";
            const infoBar = $3438a2478d5b847f$var$createImageInfoBar(await sourceBytesPromise, ext, ctx.file.mimeType, ctx.file.name);
            infoBar.hidden = true;
            infoBar.setAttribute("aria-hidden", "true");
            infoBar.style.display = "none";
            const image = document.createElement("img");
            image.className = "ofv-media ofv-image-content";
            image.alt = ctx.file.name;
            image.draggable = false;
            image.style.objectFit = $3438a2478d5b847f$var$objectFit(ctx.options.fit);
            if (url) image.src = url;
            const visual = tiffSource || image;
            if (tiffSource) {
                tiffSource.classList.add("ofv-image-content");
                if (tiffSource.classList.contains("ofv-tiff-pages")) stage.classList.add("ofv-image-stage-pages");
            }
            const visualBox = document.createElement("div");
            visualBox.className = "ofv-image-scrollbox";
            let scale = $3438a2478d5b847f$export$218693075858efcb(ctx);
            let rotation = 0;
            let offsetX = 0;
            let offsetY = 0;
            let dragging = false;
            let dragStartX = 0;
            let dragStartY = 0;
            let startOffsetX = 0;
            let startOffsetY = 0;
            let activePointerId = null;
            let previewAvailable = true;
            const zoomLabel = document.createElement("span");
            zoomLabel.className = "ofv-image-zoom";
            let measuredBase = null;
            const invalidateBaseSize = ()=>{
                measuredBase = null;
                visual.style.removeProperty("width");
                visual.style.removeProperty("height");
                visualBox.style.removeProperty("width");
                visualBox.style.removeProperty("height");
            };
            const updateScrollBox = ()=>{
                if (visual.classList.contains("ofv-tiff-pages")) {
                    visualBox.style.removeProperty("width");
                    visualBox.style.removeProperty("height");
                    return;
                }
                if (!measuredBase) {
                    visual.style.removeProperty("width");
                    visual.style.removeProperty("height");
                    visualBox.style.removeProperty("width");
                    visualBox.style.removeProperty("height");
                    const width = visual.offsetWidth || visual.getBoundingClientRect().width || visual.naturalWidth || 0;
                    const height = visual.offsetHeight || visual.getBoundingClientRect().height || visual.naturalHeight || 0;
                    if (width <= 0 || height <= 0) return;
                    measuredBase = {
                        width: width,
                        height: height
                    };
                    visual.style.width = `${width}px`;
                    visual.style.height = `${height}px`;
                }
                const sideways = Math.abs(rotation % 180) === 90;
                const boxWidth = sideways ? measuredBase.height : measuredBase.width;
                const boxHeight = sideways ? measuredBase.width : measuredBase.height;
                visualBox.style.width = `${Math.ceil(boxWidth * scale)}px`;
                visualBox.style.height = `${Math.ceil(boxHeight * scale)}px`;
            };
            const updateTransform = ()=>{
                updateScrollBox();
                visual.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale}) rotate(${rotation}deg)`;
                zoomLabel.textContent = `${Math.round(scale * 100)}%`;
                ctx.toolbar?.setZoom(previewAvailable ? scale : void 0);
            };
            const showImageFallback = ()=>{
                previewAvailable = false;
                ctx.toolbar?.setZoom(void 0);
                infoBar.hidden = false;
                infoBar.removeAttribute("aria-hidden");
                infoBar.style.removeProperty("display");
                stage.replaceChildren($3438a2478d5b847f$var$createImageFallback(ctx.file.name, url, ctx.options.messages));
                ctx.toolbar?.refreshCommandSupport();
            };
            const setScale = (nextScale)=>{
                scale = Math.min(8, Math.max(0.1, nextScale));
                updateTransform();
            };
            const reset = ()=>{
                scale = 1;
                rotation = 0;
                offsetX = 0;
                offsetY = 0;
                updateTransform();
            };
            const addButton = (label, title, action)=>{
                const button = document.createElement("button");
                button.type = "button";
                button.textContent = label;
                button.title = title;
                button.setAttribute("aria-label", title);
                button.addEventListener("click", action);
                controls.append(button);
                return ()=>button.removeEventListener("click", action);
            };
            const disposers = showInlineControls ? [
                addButton("-", ctx.options.messages.imageZoomOut, ()=>setScale(scale - 0.25)),
                addButton("+", ctx.options.messages.imageZoomIn, ()=>setScale(scale + 0.25)),
                addButton(ctx.options.messages.imageRotate, ctx.options.messages.imageRotate, ()=>{
                    rotation += 90;
                    updateTransform();
                }),
                addButton(ctx.options.messages.imageReset, ctx.options.messages.imageReset, reset)
            ] : [];
            if (showInlineControls) controls.append(zoomLabel);
            const onPointerDown = (event)=>{
                if (event.button !== 0) return;
                if (activePointerId !== null && activePointerId !== event.pointerId) finishDrag(activePointerId);
                dragging = true;
                activePointerId = event.pointerId;
                dragStartX = event.clientX;
                dragStartY = event.clientY;
                startOffsetX = offsetX;
                startOffsetY = offsetY;
                stage.classList.add("is-dragging");
                try {
                    stage.setPointerCapture(event.pointerId);
                } catch  {}
            };
            const onPointerMove = (event)=>{
                if (!dragging || event.pointerId !== activePointerId) return;
                offsetX = startOffsetX + event.clientX - dragStartX;
                offsetY = startOffsetY + event.clientY - dragStartY;
                updateTransform();
            };
            const finishDrag = (pointerId)=>{
                const captureId = pointerId ?? activePointerId;
                dragging = false;
                activePointerId = null;
                stage.classList.remove("is-dragging");
                if (captureId !== null && captureId !== void 0) try {
                    if (stage.hasPointerCapture(captureId)) stage.releasePointerCapture(captureId);
                } catch  {}
            };
            const onPointerUp = (event)=>{
                if (event.pointerId === activePointerId) finishDrag(event.pointerId);
            };
            const onLostPointerCapture = (event)=>{
                if (event.pointerId === activePointerId) finishDrag(null);
            };
            const onPointerLeave = (event)=>{
                if (event.pointerId === activePointerId && event.buttons === 0) finishDrag(event.pointerId);
            };
            const onWindowBlur = ()=>{
                finishDrag();
            };
            const onWheel = (event)=>{
                if (!event.ctrlKey && !event.metaKey) return;
                event.preventDefault();
                setScale(scale + (event.deltaY > 0 ? -0.1 : 0.1));
            };
            stage.addEventListener("pointerdown", onPointerDown);
            stage.addEventListener("pointermove", onPointerMove);
            stage.addEventListener("pointerup", onPointerUp);
            stage.addEventListener("pointercancel", onPointerUp);
            stage.addEventListener("lostpointercapture", onLostPointerCapture);
            stage.addEventListener("pointerleave", onPointerLeave);
            stage.addEventListener("wheel", onWheel, {
                passive: false
            });
            const onImageLoad = ()=>{
                invalidateBaseSize();
                updateScrollBox();
            };
            if (!tiffSource) {
                image.addEventListener("error", showImageFallback);
                image.addEventListener("load", onImageLoad);
            }
            window.addEventListener("blur", onWindowBlur);
            visualBox.append(visual);
            stage.append(visualBox);
            wrapper.append(...showInlineControls ? [
                controls,
                stage,
                infoBar
            ] : [
                stage,
                infoBar
            ]);
            ctx.viewport.append(wrapper);
            updateTransform();
            return {
                goToPage (page) {
                    return $3438a2478d5b847f$export$e2c778f3bf6f56a7(stage, ".ofv-tiff-page", page, stage);
                },
                canCommand (command) {
                    return previewAvailable && (command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left");
                },
                command (command) {
                    if (!previewAvailable) return false;
                    if (command === "zoom-in") {
                        setScale(scale + 0.25);
                        return true;
                    }
                    if (command === "zoom-out") {
                        setScale(scale - 0.25);
                        return true;
                    }
                    if (command === "zoom-reset") {
                        reset();
                        return true;
                    }
                    if (command === "rotate-right") {
                        rotation += 90;
                        updateTransform();
                        return true;
                    }
                    if (command === "rotate-left") {
                        rotation -= 90;
                        updateTransform();
                        return true;
                    }
                    return false;
                },
                resize (size) {
                    visual.style.maxWidth = `${size.width}px`;
                    if (visual.classList.contains("ofv-tiff-pages")) visual.style.removeProperty("max-height");
                    else visual.style.maxHeight = `${Math.max(0, size.height - controls.offsetHeight)}px`;
                    invalidateBaseSize();
                    updateScrollBox();
                },
                destroy () {
                    ctx.toolbar?.setZoom(void 0);
                    for (const dispose of disposers)dispose();
                    stage.removeEventListener("pointerdown", onPointerDown);
                    stage.removeEventListener("pointermove", onPointerMove);
                    stage.removeEventListener("pointerup", onPointerUp);
                    stage.removeEventListener("pointercancel", onPointerUp);
                    stage.removeEventListener("lostpointercapture", onLostPointerCapture);
                    stage.removeEventListener("pointerleave", onPointerLeave);
                    stage.removeEventListener("wheel", onWheel);
                    image.removeEventListener("error", showImageFallback);
                    image.removeEventListener("load", onImageLoad);
                    window.removeEventListener("blur", onWindowBlur);
                    finishDrag();
                    wrapper.remove();
                    if (convertedBlob) URL.revokeObjectURL(url);
                    else if (url) $3438a2478d5b847f$export$7438c4986c08186f(url, isExternal);
                }
            };
        }
    };
}

async function $3438a2478d5b847f$var$createTiffPreview(bytes, fileName) {
    if (bytes.byteLength === 0) throw new Error("\u65E0\u6CD5\u8BFB\u53D6 TIFF \u6587\u4EF6\u5185\u5BB9\u3002");
    const UTIF = await (parcelRequire("bZCt6"));
    const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
    const ifds = UTIF.decode(buffer);
    const imageIfds = ifds.filter((item)=>$3438a2478d5b847f$var$hasTiffDimensions(item));
    if (imageIfds.length === 0) throw new Error("TIFF \u6587\u4EF6\u6CA1\u6709\u53EF\u89E3\u7801\u7684\u56FE\u50CF\u76EE\u5F55\u3002");
    const pages = imageIfds.map((ifd, index)=>$3438a2478d5b847f$var$createTiffPage(UTIF, buffer, ifd, index, imageIfds.length, fileName));
    if (pages.length === 1) return pages[0].canvas;
    const container = document.createElement("div");
    container.className = "ofv-tiff-pages";
    container.setAttribute("role", "group");
    container.setAttribute("aria-label", `${fileName}\uFF0C\u5171 ${pages.length} \u9875`);
    for (const page of pages){
        const figure = document.createElement("figure");
        figure.className = "ofv-tiff-page";
        const caption = document.createElement("figcaption");
        caption.textContent = `\u7B2C ${page.index + 1} / ${pages.length} \u9875 \xB7 ${page.width} x ${page.height}px`;
        figure.append(page.canvas, caption);
        container.append(figure);
    }
    return container;
}
function $3438a2478d5b847f$var$createTiffPage(UTIF, buffer, ifd, index, total, fileName) {
    UTIF.decodeImage(buffer, ifd);
    const rgba = UTIF.toRGBA8(ifd);
    const { width: width, height: height } = $3438a2478d5b847f$var$getTiffDimensions(ifd);
    if (!width || !height || rgba.length < width * height * 4) throw new Error("TIFF \u56FE\u50CF\u50CF\u7D20\u6570\u636E\u4E0D\u5B8C\u6574\u3002");
    const canvas = document.createElement("canvas");
    canvas.className = "ofv-tiff-canvas";
    canvas.width = width;
    canvas.height = height;
    canvas.setAttribute("role", "img");
    canvas.setAttribute("aria-label", total > 1 ? `${fileName} \u7B2C ${index + 1} \u9875` : fileName);
    const context = canvas.getContext("2d");
    if (!context) throw new Error("\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301 Canvas 2D\uFF0C\u65E0\u6CD5\u5C55\u793A TIFF\u3002");
    context.putImageData(new ImageData(new Uint8ClampedArray(rgba), width, height), 0, 0);
    return {
        canvas: canvas,
        width: width,
        height: height,
        index: index
    };
}
function $3438a2478d5b847f$var$hasTiffDimensions(ifd) {
    const { width: width, height: height } = $3438a2478d5b847f$var$getTiffDimensions(ifd);
    return width > 0 && height > 0;
}
function $3438a2478d5b847f$var$getTiffDimensions(ifd) {
    return {
        width: Number(ifd.width || ifd.t256 || 0),
        height: Number(ifd.height || ifd.t257 || 0)
    };
}
function $3438a2478d5b847f$var$createImageFallback(fileName, url, messages) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = messages.imagePreviewFailedTitle;
    const meta = document.createElement("span");
    meta.textContent = messages.imagePreviewFailedMessage;
    const download = document.createElement("a");
    download.href = url;
    download.download = fileName;
    download.textContent = messages.imageDownload;
    fallback.append(title, meta, download);
    return fallback;
}
async function $3438a2478d5b847f$var$readImageBytes(file) {
    if (file.blob) return new Uint8Array(await file.blob.arrayBuffer().catch(()=>new ArrayBuffer(0)));
    const url = file.url || (typeof file.source === "string" ? file.source : "");
    if (!url) return new Uint8Array();
    try {
        const response = await fetch(url);
        if (!response.ok) return new Uint8Array();
        return new Uint8Array(await response.arrayBuffer());
    } catch  {
        return new Uint8Array();
    }
}
function $3438a2478d5b847f$var$createImageInfoBar(bytes, extension, mimeType, fileName) {
    const info = $3438a2478d5b847f$var$parseImageInfo(bytes, extension, mimeType, fileName);
    const bar = document.createElement("div");
    bar.className = "ofv-image-info";
    $3438a2478d5b847f$var$appendImageInfo(bar, "\u683C\u5F0F", info.format);
    if (info.width && info.height) $3438a2478d5b847f$var$appendImageInfo(bar, "\u5C3A\u5BF8", `${info.width} x ${info.height}px`);
    if (info.bitDepth) $3438a2478d5b847f$var$appendImageInfo(bar, "\u4F4D\u6DF1", info.bitDepth);
    if (info.color) $3438a2478d5b847f$var$appendImageInfo(bar, "\u989C\u8272", info.color);
    if (info.frames !== void 0) $3438a2478d5b847f$var$appendImageInfo(bar, "\u5E27", String(info.frames));
    if (info.count !== void 0) $3438a2478d5b847f$var$appendImageInfo(bar, "\u56FE\u50CF", String(info.count));
    if (info.note) $3438a2478d5b847f$var$appendImageInfo(bar, "\u8BF4\u660E", info.note);
    return bar;
}
function $3438a2478d5b847f$var$appendImageInfo(parent, label, value) {
    const row = document.createElement("span");
    row.className = "ofv-image-info-item";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    row.append(key, content);
    parent.append(row);
}
function $3438a2478d5b847f$var$parseImageInfo(bytes, extension, mimeType, fileName) {
    const fallbackFormat = (extension || mimeType || fileName.split(".").pop() || "image").toUpperCase();
    if (bytes.length === 0) return {
        format: fallbackFormat,
        note: "\u65E0\u6CD5\u8BFB\u53D6\u672C\u5730\u5934\u4FE1\u606F"
    };
    return $3438a2478d5b847f$var$parsePngInfo(bytes) || $3438a2478d5b847f$var$parseJpegInfo(bytes) || $3438a2478d5b847f$var$parseGifInfo(bytes) || $3438a2478d5b847f$var$parseWebpInfo(bytes) || $3438a2478d5b847f$var$parseAvifInfo(bytes) || $3438a2478d5b847f$var$parseBmpInfo(bytes) || $3438a2478d5b847f$var$parseIcoInfo(bytes) || $3438a2478d5b847f$var$parseTiffInfo(bytes) || $3438a2478d5b847f$var$parseSvgInfo(bytes) || {
        format: fallbackFormat,
        note: "\u6682\u672A\u8BC6\u522B\u56FE\u7247\u5934\u7ED3\u6784"
    };
}
function $3438a2478d5b847f$var$parsePngInfo(bytes) {
    if (bytes.length < 33 || !$3438a2478d5b847f$var$bytesMatch(bytes, 0, [
        137,
        80,
        78,
        71,
        13,
        10,
        26,
        10
    ])) return null;
    const view = $3438a2478d5b847f$var$dataView(bytes);
    const frames = $3438a2478d5b847f$var$countPngChunks(bytes, "fcTL");
    return {
        format: frames > 0 ? "APNG" : "PNG",
        width: view.getUint32(16, false),
        height: view.getUint32(20, false),
        bitDepth: `${bytes[24]} bit`,
        color: $3438a2478d5b847f$var$pngColorType(bytes[25]),
        frames: frames > 0 ? frames : void 0
    };
}
function $3438a2478d5b847f$var$parseJpegInfo(bytes) {
    if (bytes.length < 4 || bytes[0] !== 255 || bytes[1] !== 216) return null;
    let offset = 2;
    while(offset + 9 < bytes.length){
        if (bytes[offset] !== 255) {
            offset++;
            continue;
        }
        const marker = bytes[offset + 1];
        offset += 2;
        while(bytes[offset] === 255)offset++;
        if (marker === 217 || marker === 218) break;
        if (offset + 2 > bytes.length) break;
        const length = bytes[offset] << 8 | bytes[offset + 1];
        if (length < 2 || offset + length > bytes.length) break;
        if (marker >= 192 && marker <= 195 || marker >= 197 && marker <= 199 || marker >= 201 && marker <= 203 || marker >= 205 && marker <= 207) return {
            format: "JPEG",
            width: bytes[offset + 5] << 8 | bytes[offset + 6],
            height: bytes[offset + 3] << 8 | bytes[offset + 4],
            bitDepth: `${bytes[offset + 2]} bit`,
            color: `${bytes[offset + 7]} component`
        };
        offset += length;
    }
    return {
        format: "JPEG",
        note: "\u672A\u5728\u5934\u90E8\u626B\u63CF\u5230 SOF \u5C3A\u5BF8\u6BB5"
    };
}
function $3438a2478d5b847f$var$parseGifInfo(bytes) {
    const header = $3438a2478d5b847f$var$asciiAt(bytes, 0, 6);
    if (header !== "GIF87a" && header !== "GIF89a") return null;
    const packed = bytes[10] || 0;
    return {
        format: header,
        width: $3438a2478d5b847f$var$readUint16Le(bytes, 6),
        height: $3438a2478d5b847f$var$readUint16Le(bytes, 8),
        bitDepth: `${(packed & 7) + 1} bit`,
        color: packed & 128 ? "Global color table" : "No global color table",
        frames: $3438a2478d5b847f$var$countGifFrames(bytes)
    };
}
function $3438a2478d5b847f$var$parseWebpInfo(bytes) {
    if (bytes.length < 16 || $3438a2478d5b847f$var$asciiAt(bytes, 0, 4) !== "RIFF" || $3438a2478d5b847f$var$asciiAt(bytes, 8, 4) !== "WEBP") return null;
    const chunk = $3438a2478d5b847f$var$asciiAt(bytes, 12, 4);
    if (chunk === "VP8X" && bytes.length >= 30) {
        const flags = bytes[20];
        return {
            format: "WebP",
            width: 1 + $3438a2478d5b847f$var$readUint24Le(bytes, 24),
            height: 1 + $3438a2478d5b847f$var$readUint24Le(bytes, 27),
            frames: (flags & 2) !== 0 ? $3438a2478d5b847f$var$countWebpAnimationFrames(bytes) : void 0,
            color: (flags & 16) !== 0 ? "Alpha" : void 0
        };
    }
    if (chunk === "VP8 " && bytes.length >= 30) {
        const start = 20;
        if (bytes[start + 3] === 157 && bytes[start + 4] === 1 && bytes[start + 5] === 42) return {
            format: "WebP",
            width: $3438a2478d5b847f$var$readUint16Le(bytes, start + 6) & 16383,
            height: $3438a2478d5b847f$var$readUint16Le(bytes, start + 8) & 16383
        };
    }
    if (chunk === "VP8L" && bytes.length >= 25) {
        const b0 = bytes[21];
        const b1 = bytes[22];
        const b2 = bytes[23];
        const b3 = bytes[24];
        return {
            format: "WebP",
            width: 1 + ((b1 & 63) << 8 | b0),
            height: 1 + ((b3 & 15) << 10 | b2 << 2 | (b1 & 192) >> 6),
            color: "Lossless"
        };
    }
    return {
        format: "WebP",
        note: `\u672A\u77E5 ${chunk || "chunk"} \u5934`
    };
}
function $3438a2478d5b847f$var$parseAvifInfo(bytes) {
    const boxes = $3438a2478d5b847f$var$collectBmffBoxes(bytes, 0, bytes.length);
    const ftyp = boxes.find((box)=>box.type === "ftyp");
    if (!ftyp) return null;
    const majorBrand = $3438a2478d5b847f$var$asciiAt(bytes, ftyp.dataStart, 4);
    const compatibleBrands = $3438a2478d5b847f$var$asciiAt(bytes, ftyp.dataStart + 8, Math.max(0, ftyp.dataEnd - ftyp.dataStart - 8));
    if (!/\b(avif|avis|mif1|msf1|heic|heix|hevc|hevx)\b/.test(`${majorBrand} ${compatibleBrands}`)) return null;
    const ispe = $3438a2478d5b847f$var$findBmffBox(bytes, boxes, "ispe");
    return {
        format: majorBrand === "avis" || compatibleBrands.includes("avis") ? "AVIF Sequence" : majorBrand.startsWith("hei") ? "HEIF" : "AVIF",
        width: ispe && ispe.dataStart + 12 <= ispe.dataEnd ? $3438a2478d5b847f$var$readUint32Be(bytes, ispe.dataStart + 4) : void 0,
        height: ispe && ispe.dataStart + 12 <= ispe.dataEnd ? $3438a2478d5b847f$var$readUint32Be(bytes, ispe.dataStart + 8) : void 0,
        note: `brand ${majorBrand}${compatibleBrands.trim() ? ` \xB7 ${$3438a2478d5b847f$var$formatBmffBrands(compatibleBrands)}` : ""}`
    };
}
function $3438a2478d5b847f$var$collectBmffBoxes(bytes, start, end) {
    const boxes = [];
    let offset = start;
    while(offset + 8 <= end && boxes.length < 512){
        let size = $3438a2478d5b847f$var$readUint32Be(bytes, offset);
        const type = $3438a2478d5b847f$var$asciiAt(bytes, offset + 4, 4);
        let headerSize = 8;
        if (!/^[A-Za-z0-9 _-]{4}$/.test(type)) break;
        if (size === 1 && offset + 16 <= end) {
            const high = $3438a2478d5b847f$var$readUint32Be(bytes, offset + 8);
            const low = $3438a2478d5b847f$var$readUint32Be(bytes, offset + 12);
            size = high > 0 ? end - offset : low;
            headerSize = 16;
        } else if (size === 0) size = end - offset;
        if (size < headerSize || offset + size > end) break;
        boxes.push({
            type: type,
            start: offset,
            dataStart: offset + headerSize,
            dataEnd: offset + size,
            end: offset + size
        });
        offset += size;
    }
    return boxes;
}
function $3438a2478d5b847f$var$findBmffBox(bytes, boxes, type) {
    for (const box of boxes){
        if (box.type === type) return box;
        if ([
            "meta",
            "iprp",
            "ipco",
            "moov",
            "trak",
            "mdia",
            "minf",
            "stbl"
        ].includes(box.type)) {
            const childStart = box.type === "meta" ? box.dataStart + 4 : box.dataStart;
            const found = $3438a2478d5b847f$var$findBmffBox(bytes, $3438a2478d5b847f$var$collectBmffBoxes(bytes, childStart, box.dataEnd), type);
            if (found) return found;
        }
    }
    return void 0;
}
function $3438a2478d5b847f$var$formatBmffBrands(value) {
    const brands = value.match(/.{1,4}/g)?.map((brand)=>brand.trim()).filter(Boolean) || [];
    return brands.slice(0, 6).join(", ");
}
function $3438a2478d5b847f$var$parseBmpInfo(bytes) {
    if (bytes.length < 30 || $3438a2478d5b847f$var$asciiAt(bytes, 0, 2) !== "BM") return null;
    const dibSize = $3438a2478d5b847f$var$readUint32Le(bytes, 14);
    if (dibSize < 12) return {
        format: "BMP",
        note: "DIB header \u592A\u77ED"
    };
    if (dibSize === 12 && bytes.length >= 26) return {
        format: "BMP",
        width: $3438a2478d5b847f$var$readUint16Le(bytes, 18),
        height: $3438a2478d5b847f$var$readUint16Le(bytes, 20),
        bitDepth: `${$3438a2478d5b847f$var$readUint16Le(bytes, 24)} bit`
    };
    return {
        format: "BMP",
        width: $3438a2478d5b847f$var$readInt32Le(bytes, 18),
        height: Math.abs($3438a2478d5b847f$var$readInt32Le(bytes, 22)),
        bitDepth: `${$3438a2478d5b847f$var$readUint16Le(bytes, 28)} bit`
    };
}
function $3438a2478d5b847f$var$parseIcoInfo(bytes) {
    if (bytes.length < 6 || $3438a2478d5b847f$var$readUint16Le(bytes, 0) !== 0 || ![
        1,
        2
    ].includes($3438a2478d5b847f$var$readUint16Le(bytes, 2))) return null;
    const count = $3438a2478d5b847f$var$readUint16Le(bytes, 4);
    if (count < 1 || bytes.length < 6 + count * 16) return {
        format: "ICO/CUR",
        count: count
    };
    const width = bytes[6] || 256;
    const height = bytes[7] || 256;
    return {
        format: $3438a2478d5b847f$var$readUint16Le(bytes, 2) === 1 ? "ICO" : "CUR",
        width: width,
        height: height,
        bitDepth: `${$3438a2478d5b847f$var$readUint16Le(bytes, 12)} bit`,
        count: count
    };
}
function $3438a2478d5b847f$var$parseSvgInfo(bytes) {
    const text = new TextDecoder("utf-8", {
        fatal: false
    }).decode(bytes.slice(0, Math.min(bytes.length, 8192)));
    if (!/<svg[\s>]/i.test(text)) return null;
    const tag = text.match(/<svg\b[^>]*>/i)?.[0] || "";
    const width = $3438a2478d5b847f$var$numberAttribute(tag, "width");
    const height = $3438a2478d5b847f$var$numberAttribute(tag, "height");
    const viewBox = tag.match(/\bviewBox=["']([^"']+)["']/i)?.[1]?.trim();
    const viewBoxParts = viewBox?.split(/[\s,]+/).map(Number).filter(Number.isFinite);
    return {
        format: "SVG",
        width: width || (viewBoxParts?.length === 4 ? viewBoxParts[2] : void 0),
        height: height || (viewBoxParts?.length === 4 ? viewBoxParts[3] : void 0),
        note: viewBox ? `viewBox ${viewBox}` : void 0
    };
}
function $3438a2478d5b847f$var$parseTiffInfo(bytes) {
    if (bytes.length < 8) return null;
    const littleEndian = $3438a2478d5b847f$var$asciiAt(bytes, 0, 2) === "II";
    const bigEndian = $3438a2478d5b847f$var$asciiAt(bytes, 0, 2) === "MM";
    if (!littleEndian && !bigEndian) return null;
    const magic = $3438a2478d5b847f$var$readTiffUint16(bytes, 2, littleEndian);
    if (magic !== 42 && magic !== 43) return null;
    const ifdOffset = magic === 43 ? $3438a2478d5b847f$var$readTiffUint64AsNumber(bytes, 8, littleEndian) : $3438a2478d5b847f$var$readTiffUint32(bytes, 4, littleEndian);
    if (!Number.isFinite(ifdOffset) || ifdOffset + 2 > bytes.length) return {
        format: magic === 43 ? "BigTIFF" : "TIFF",
        note: "IFD \u504F\u79FB\u8D85\u51FA\u6587\u4EF6\u8303\u56F4"
    };
    const count = magic === 43 ? $3438a2478d5b847f$var$readTiffUint64AsNumber(bytes, ifdOffset, littleEndian) : $3438a2478d5b847f$var$readTiffUint16(bytes, ifdOffset, littleEndian);
    const imageCount = $3438a2478d5b847f$var$countTiffIfds(bytes, ifdOffset, magic === 43, littleEndian);
    const entrySize = magic === 43 ? 20 : 12;
    const entriesStart = ifdOffset + (magic === 43 ? 8 : 2);
    let width;
    let height;
    let bitDepth;
    let compression;
    for(let index = 0; index < Math.min(count, 256); index++){
        const offset = entriesStart + index * entrySize;
        if (offset + entrySize > bytes.length) break;
        const tag = $3438a2478d5b847f$var$readTiffUint16(bytes, offset, littleEndian);
        const type = $3438a2478d5b847f$var$readTiffUint16(bytes, offset + 2, littleEndian);
        const valueOffset = magic === 43 ? offset + 12 : offset + 8;
        const value = $3438a2478d5b847f$var$readTiffInlineValue(bytes, valueOffset, type, littleEndian);
        if (tag === 256) width = value;
        if (tag === 257) height = value;
        if (tag === 258) bitDepth = value;
        if (tag === 259) compression = value;
    }
    return {
        format: magic === 43 ? "BigTIFF" : "TIFF",
        width: width,
        height: height,
        bitDepth: bitDepth ? `${bitDepth} bit` : void 0,
        color: compression ? $3438a2478d5b847f$var$tiffCompressionName(compression) : void 0,
        count: imageCount || void 0
    };
}
function $3438a2478d5b847f$var$countTiffIfds(bytes, firstOffset, bigTiff, littleEndian) {
    const seen = /* @__PURE__ */ new Set();
    let offset = firstOffset;
    let count = 0;
    while(Number.isFinite(offset) && offset > 0 && offset < bytes.length && !seen.has(offset) && count < 512){
        seen.add(offset);
        const entryCount = bigTiff ? $3438a2478d5b847f$var$readTiffUint64AsNumber(bytes, offset, littleEndian) : $3438a2478d5b847f$var$readTiffUint16(bytes, offset, littleEndian);
        const entrySize = bigTiff ? 20 : 12;
        const nextOffsetPosition = offset + (bigTiff ? 8 : 2) + entryCount * entrySize;
        if (!Number.isFinite(entryCount) || nextOffsetPosition + (bigTiff ? 8 : 4) > bytes.length) break;
        count++;
        offset = bigTiff ? $3438a2478d5b847f$var$readTiffUint64AsNumber(bytes, nextOffsetPosition, littleEndian) : $3438a2478d5b847f$var$readTiffUint32(bytes, nextOffsetPosition, littleEndian);
    }
    return count;
}
function $3438a2478d5b847f$var$readTiffInlineValue(bytes, offset, type, littleEndian) {
    if (offset + 4 > bytes.length) return void 0;
    if (type === 3) return $3438a2478d5b847f$var$readTiffUint16(bytes, offset, littleEndian);
    if (type === 4 || type === 13) return $3438a2478d5b847f$var$readTiffUint32(bytes, offset, littleEndian);
    return $3438a2478d5b847f$var$readTiffUint16(bytes, offset, littleEndian);
}
function $3438a2478d5b847f$var$tiffCompressionName(value) {
    const names = {
        1: "Uncompressed",
        3: "CCITT Group 3",
        4: "CCITT Group 4",
        5: "LZW",
        6: "Old JPEG",
        7: "JPEG",
        8: "Deflate",
        32773: "PackBits"
    };
    return names[value] || `Compression ${value}`;
}
function $3438a2478d5b847f$var$countPngChunks(bytes, chunkType) {
    let offset = 8;
    let count = 0;
    while(offset + 12 <= bytes.length){
        const length = $3438a2478d5b847f$var$readUint32Be(bytes, offset);
        const type = $3438a2478d5b847f$var$asciiAt(bytes, offset + 4, 4);
        if (type === chunkType) count++;
        offset += 12 + length;
    }
    return count;
}
function $3438a2478d5b847f$var$countGifFrames(bytes) {
    let count = 0;
    for(let index = 13; index < bytes.length; index++)if (bytes[index] === 44) count++;
    return count || 1;
}
function $3438a2478d5b847f$var$countWebpAnimationFrames(bytes) {
    let count = 0;
    for(let offset = 12; offset + 8 <= bytes.length;){
        const type = $3438a2478d5b847f$var$asciiAt(bytes, offset, 4);
        const size = $3438a2478d5b847f$var$readUint32Le(bytes, offset + 4);
        if (type === "ANMF") count++;
        offset += 8 + size + size % 2;
    }
    return count || 1;
}
function $3438a2478d5b847f$var$pngColorType(value) {
    const colors = {
        0: "Grayscale",
        2: "Truecolor",
        3: "Indexed color",
        4: "Grayscale + alpha",
        6: "Truecolor + alpha"
    };
    return colors[value] || `Unknown (${value})`;
}
function $3438a2478d5b847f$var$numberAttribute(tag, name) {
    const value = tag.match(new RegExp(`\\b${name}=["']([0-9.]+)`, "i"))?.[1];
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : void 0;
}
function $3438a2478d5b847f$var$bytesMatch(bytes, offset, expected) {
    return expected.every((byte, index)=>bytes[offset + index] === byte);
}
function $3438a2478d5b847f$var$dataView(bytes) {
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
function $3438a2478d5b847f$var$asciiAt(bytes, offset, length) {
    if (offset < 0 || offset + length > bytes.length) return "";
    return new TextDecoder("ascii").decode(bytes.slice(offset, offset + length));
}
function $3438a2478d5b847f$var$readUint16Le(bytes, offset) {
    return $3438a2478d5b847f$var$dataView(bytes).getUint16(offset, true);
}
function $3438a2478d5b847f$var$readUint24Le(bytes, offset) {
    return bytes[offset] | bytes[offset + 1] << 8 | bytes[offset + 2] << 16;
}
function $3438a2478d5b847f$var$readUint32Le(bytes, offset) {
    return $3438a2478d5b847f$var$dataView(bytes).getUint32(offset, true);
}
function $3438a2478d5b847f$var$readUint32Be(bytes, offset) {
    return $3438a2478d5b847f$var$dataView(bytes).getUint32(offset, false);
}
function $3438a2478d5b847f$var$readInt32Le(bytes, offset) {
    return $3438a2478d5b847f$var$dataView(bytes).getInt32(offset, true);
}
function $3438a2478d5b847f$var$readTiffUint16(bytes, offset, littleEndian) {
    return $3438a2478d5b847f$var$dataView(bytes).getUint16(offset, littleEndian);
}
function $3438a2478d5b847f$var$readTiffUint32(bytes, offset, littleEndian) {
    return $3438a2478d5b847f$var$dataView(bytes).getUint32(offset, littleEndian);
}
function $3438a2478d5b847f$var$readTiffUint64AsNumber(bytes, offset, littleEndian) {
    if (offset + 8 > bytes.length) return Number.NaN;
    const view = $3438a2478d5b847f$var$dataView(bytes);
    const low = view.getUint32(offset + (littleEndian ? 0 : 4), littleEndian);
    const high = view.getUint32(offset + (littleEndian ? 4 : 0), littleEndian);
    return high * 2 ** 32 + low;
}
function $3438a2478d5b847f$var$objectFit(fit) {
    if (fit === "cover") return "cover";
    if (fit === "actual") return "none";
    if (fit === "scale-down") return "scale-down";
    return "contain";
}
// src/plugins/encrypted.ts
function $3438a2478d5b847f$export$415721fb0f336a4b(file, url, copy = {}) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback ofv-encrypted";
    const title = document.createElement("strong");
    title.textContent = copy.title || "\u6587\u4EF6\u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u5728\u7EBF\u9884\u89C8";
    const message = document.createElement("span");
    message.textContent = copy.message || "\u8BF7\u4E0B\u8F7D\u540E\u5728\u672C\u5730\u8F93\u5165\u5BC6\u7801\u6253\u5F00\uFF0C\u6216\u4E0A\u4F20\u89E3\u5BC6\u540E\u7684\u6587\u4EF6\u3002";
    const meta = document.createElement("dl");
    meta.className = "ofv-fallback-meta ofv-encrypted-meta";
    $3438a2478d5b847f$var$appendEncryptedMeta(meta, "\u6587\u4EF6", file.name || "\u672A\u547D\u540D\u6587\u4EF6");
    $3438a2478d5b847f$var$appendEncryptedMeta(meta, "\u683C\u5F0F", file.extension ? `.${file.extension}` : file.mimeType || "\u672A\u77E5");
    const download = document.createElement("a");
    download.href = url;
    download.download = file.name;
    download.textContent = copy.action || "\u4E0B\u8F7D\u6587\u4EF6";
    fallback.append(title, message, meta, download);
    return fallback;
}
function $3438a2478d5b847f$export$c0d4bb025764fd57(error) {
    const message = error instanceof Error ? error.message : String(error || "");
    const name = typeof error === "object" && error !== null && "name" in error ? String(error.name) : "";
    return /\b(password|encrypted|encrypt|protected|decrypt|permission|加密|密码|受保护)\b/i.test(`${name} ${message}`);
}
function $3438a2478d5b847f$var$appendEncryptedMeta(parent, label, value) {
    const key = document.createElement("dt");
    key.textContent = label;
    const content = document.createElement("dd");
    content.textContent = value;
    parent.append(key, content);
}
// src/plugins/page-scroll.ts
function $3438a2478d5b847f$export$449ea97f0d46522e(scroller, pages) {
    if (scroller.scrollTop <= 0) return void 0;
    const top = scroller.getBoundingClientRect().top + scroller.clientTop;
    for(let index = 0; index < pages.length; index += 1){
        const rect = pages[index].getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > top) return {
            index: index,
            fraction: (top - rect.top) / rect.height
        };
    }
    return void 0;
}
function $3438a2478d5b847f$export$c0bc1c93b9d1d8ba(scroller, pages, anchor) {
    if (!anchor) return;
    const page = pages[anchor.index];
    if (!page) return;
    const rect = page.getBoundingClientRect();
    if (rect.height <= 0) return;
    const top = scroller.getBoundingClientRect().top + scroller.clientTop;
    scroller.scrollTop = Math.max(0, scroller.scrollTop + rect.top - top + anchor.fraction * rect.height);
}
// src/plugins/pdf.ts
function $3438a2478d5b847f$var$multiplyMatrices(m1, m2) {
    return [
        m1[0] * m2[0] + m1[2] * m2[1],
        m1[1] * m2[0] + m1[3] * m2[1],
        m1[0] * m2[2] + m1[2] * m2[3],
        m1[1] * m2[2] + m1[3] * m2[3],
        m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
        m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
    ];
}
function $3438a2478d5b847f$export$902b3d19cdcfa5d5(options = {}) {
    return {
        name: "pdf",
        match (file) {
            return file.mimeType === "application/pdf" || file.extension === "pdf";
        },
        async render (ctx) {
            const normalizedOptions = $3438a2478d5b847f$var$normalizePdfOptions(options);
            const url = $3438a2478d5b847f$export$191fa6957fae12db(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            return $3438a2478d5b847f$export$b882f3782d993632({
                ...normalizedOptions,
                fileName: ctx.file.name,
                fileUrl: url,
                fileSize: ctx.file.size,
                isExternal: isExternal,
                viewport: ctx.viewport,
                size: ctx.size,
                // A scrolling PDF reader historically defaulted to fit-width. Keep
                // that behavior when the host did not choose a fit mode, while still
                // honoring explicit contain/height/cover/scale-down requests.
                fit: ctx.options.fitWasProvided ? ctx.options.fit : "width",
                zoom: ctx.options.zoom,
                toolbar: ctx.toolbar,
                messages: ctx.options.messages,
                revokeUrlOnDestroy: true
            });
        }
    };
}


async function $3438a2478d5b847f$export$b882f3782d993632(options) {
    const useLegacyCompatibility = $3438a2478d5b847f$var$shouldUseLegacyPdfCompatibility(options.compatibilityMode);
    if (useLegacyCompatibility) $3438a2478d5b847f$var$installPromiseWithResolversPolyfill();
    const pdf = options.pdfjs || (useLegacyCompatibility ? await (parcelRequire("lHXxJ")) : await (parcelRequire("5KOBY")));
    const messages = {
        ...$3438a2478d5b847f$var$defaultMessages["en-US"],
        ...options.messages
    };
    $3438a2478d5b847f$var$configurePdfWorker(pdf, options.workerSrc, options.legacyWorkerSrc, useLegacyCompatibility);
    const viewer = document.createElement("div");
    viewer.className = "ofv-pdf-viewer";
    if (options.title) {
        const title = document.createElement("strong");
        title.className = "ofv-pdf-viewer-title";
        title.textContent = options.title;
        viewer.append(title);
    }
    const summary = document.createElement("div");
    summary.className = "ofv-pdf-summary";
    summary.hidden = true;
    summary.setAttribute("aria-hidden", "true");
    summary.style.display = "none";
    const scroller = document.createElement("div");
    scroller.className = "ofv-pdf ofv-pdf-pages";
    viewer.append(summary, scroller);
    options.viewport.append(viewer);
    const showDocumentFallback = (error)=>{
        viewer.remove();
        const fileLike = {
            source: options.fileUrl,
            name: options.fileName,
            extension: options.fileName.includes(".") ? options.fileName.split(".").pop() || "pdf" : "pdf",
            mimeType: "application/pdf",
            size: options.fileSize,
            url: options.fileUrl
        };
        const fallback = $3438a2478d5b847f$export$c0d4bb025764fd57(error) ? $3438a2478d5b847f$export$415721fb0f336a4b(fileLike, options.fileUrl, {
            title: options.encryptedTitle || messages.pdfEncryptedTitle,
            message: options.encryptedMessage || messages.pdfEncryptedMessage,
            action: options.encryptedAction || messages.pdfDownload
        }) : $3438a2478d5b847f$var$createPdfFallback(options.fileName, options.fileUrl, $3438a2478d5b847f$var$normalizePdfError(error, messages), messages, options.fallbackTitle, options.webFallbackScripts);
        if (!fallback.classList.contains("ofv-pdf-web-fallback")) options.viewport.classList.add("ofv-center");
        options.viewport.append(fallback);
    };
    let documentTask;
    let doc;
    try {
        const pdfData = options.useFetchData ? await $3438a2478d5b847f$var$loadPdfData(options.fileUrl) : void 0;
        const documentOptions = {
            ...pdfData ? {
                data: pdfData
            } : {
                url: options.fileUrl
            },
            cMapUrl: options.cMapUrl ?? `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdf.version}/cmaps/`,
            cMapPacked: options.cMapPacked ?? true,
            standardFontDataUrl: options.standardFontDataUrl ?? `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdf.version}/standard_fonts/`,
            ...options.wasmUrl === void 0 ? {} : {
                wasmUrl: options.wasmUrl
            },
            useSystemFonts: options.useSystemFonts ?? true,
            disableStream: options.disableStream,
            disableAutoFetch: options.disableAutoFetch,
            disableRange: options.disableRange,
            rangeChunkSize: options.rangeChunkSize
        };
        documentTask = pdf.getDocument(documentOptions);
        doc = await documentTask.promise.catch((error)=>{
            showDocumentFallback(error);
            return void 0;
        });
    } catch (error) {
        showDocumentFallback(error);
    }
    if (!doc) return {
        canCommand () {
            return false;
        },
        command () {
            return false;
        },
        resize () {},
        destroy () {
            options.viewport.classList.remove("ofv-center");
            $3438a2478d5b847f$var$destroyPdfResource(documentTask);
            if (options.revokeUrlOnDestroy) $3438a2478d5b847f$export$7438c4986c08186f(options.fileUrl, Boolean(options.isExternal));
        }
    };
    const pdfDocument = doc;
    const pagesMeta = Array.from({
        length: pdfDocument.numPages
    }, ()=>({
            width: 612,
            height: 792,
            rotation: 0,
            resolved: false
        }));
    const pagePromises = Array(pdfDocument.numPages);
    const loadPage = (pageIdx)=>{
        const existing = pagePromises[pageIdx];
        if (existing) return existing;
        let promise;
        promise = pdfDocument.getPage(pageIdx + 1).then((page)=>{
            const baseViewport = page.getViewport({
                scale: 1
            });
            pagesMeta[pageIdx] = {
                width: baseViewport.width,
                height: baseViewport.height,
                rotation: $3438a2478d5b847f$var$getPdfPageRotation(page),
                resolved: true
            };
            return page;
        }).catch((error)=>{
            if (pagePromises[pageIdx] === promise) pagePromises[pageIdx] = void 0;
            throw error;
        });
        pagePromises[pageIdx] = promise;
        return promise;
    };
    const pageStates = [];
    let observer = null;
    let printPreparation;
    let layoutVersion = 0;
    let destroyed = false;
    let currentSize = options.size;
    let zoomFactor = $3438a2478d5b847f$export$218693075858efcb({
        options: {
            zoom: options.zoom ?? 1
        }
    }, 0.25, 4);
    let rotation = 0;
    let currentPage = 1;
    const resolveLayoutWidth = (size)=>scroller.clientWidth > 0 ? scroller.clientWidth : size.width;
    const resolveLayoutHeight = (size)=>scroller.clientHeight > 0 ? scroller.clientHeight : size.height;
    const goToPage = (page, scroll = true)=>{
        currentPage = Math.min(pdfDocument.numPages, Math.max(1, Math.round(page) || 1));
        pageNavigator.setCurrent(currentPage);
        const wrapper = pageStates[currentPage - 1]?.wrapper;
        if (!scroll || !wrapper) return true;
        renderPage(currentPage - 1, currentSize);
        const top = Math.max(0, wrapper.offsetTop - 16);
        if (typeof scroller.scrollTo === "function") scroller.scrollTo({
            top: top,
            behavior: "smooth"
        });
        else scroller.scrollTop = top;
        return true;
    };
    const pageNavigator = $3438a2478d5b847f$var$createPdfPageNavigator(pdfDocument.numPages, messages, (page)=>goToPage(page));
    viewer.insertBefore(pageNavigator.element, summary);
    const handleScrollerScroll = ()=>{
        const scrollerRect = scroller.getBoundingClientRect();
        const targetY = scrollerRect.top + Math.min(Math.max(scroller.clientHeight * 0.25, 40), 180);
        let nearestPage = currentPage;
        let nearestDistance = Number.POSITIVE_INFINITY;
        pageStates.forEach((state, index)=>{
            const distance = Math.abs(state.wrapper.getBoundingClientRect().top - targetY);
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestPage = index + 1;
            }
        });
        if (nearestPage !== currentPage) {
            currentPage = nearestPage;
            pageNavigator.setCurrent(currentPage);
        }
        if (!observer) {
            const firstPage = Math.max(0, nearestPage - 2);
            const lastPage = Math.min(pdfDocument.numPages - 1, nearestPage);
            for(let pageIdx = firstPage; pageIdx <= lastPage; pageIdx += 1)renderPage(pageIdx, currentSize);
        }
    };
    scroller.addEventListener("scroll", handleScrollerScroll, {
        passive: true
    });
    const updateSummary = ()=>{
        $3438a2478d5b847f$var$renderPdfSummary(summary, pdfDocument.numPages, pagesMeta.filter((meta)=>meta.resolved), options.fit, zoomFactor, messages);
        options.toolbar?.setZoom(zoomFactor);
    };
    const updatePageWrapperDimensions = (wrapper, meta, size)=>{
        const rotatedWidth = $3438a2478d5b847f$var$rotatedPdfWidth(meta, rotation);
        const rotatedHeight = $3438a2478d5b847f$var$rotatedPdfHeight(meta, rotation);
        const scale = $3438a2478d5b847f$var$resolvePdfPageScale(meta, options.fit, resolveLayoutWidth(size), resolveLayoutHeight(size), zoomFactor, rotation);
        wrapper.style.width = `${Math.floor(rotatedWidth * scale)}px`;
        wrapper.style.height = `${Math.floor(rotatedHeight * scale)}px`;
    };
    const invalidatePageState = (state)=>{
        state.renderVersion += 1;
        if (state.renderTask) {
            try {
                state.renderTask.cancel();
            } catch (e) {}
            state.renderTask = null;
        }
        state.canvas = null;
        state.rendered = false;
    };
    const clearPage = (pageIdx)=>{
        const state = pageStates[pageIdx];
        if (!state || !state.rendered && !state.renderPromise) return;
        invalidatePageState(state);
        if (destroyed || pageStates[pageIdx] !== state) return;
        state.wrapper.replaceChildren();
        state.wrapper.append($3438a2478d5b847f$var$createPageStatus("ofv-pdf-skeleton", $3438a2478d5b847f$export$40b3ce2549faa304(messages.pdfPageLoading, {
            page: pageIdx + 1
        })));
    };
    const renderPage = async (pageIdx, size)=>{
        const state = pageStates[pageIdx];
        if (!state || destroyed) return;
        while(state.renderPromise)await state.renderPromise;
        if (destroyed || pageStates[pageIdx] !== state || state.rendered) return;
        const renderVersion = state.renderVersion + 1;
        state.renderVersion = renderVersion;
        state.rendered = true;
        const isCurrentRender = ()=>!destroyed && pageStates[pageIdx] === state && state.renderVersion === renderVersion;
        const renderPromise = (async ()=>{
            try {
                const page = await loadPage(pageIdx);
                if (!isCurrentRender()) return;
                const meta = pagesMeta[pageIdx];
                const wrappers = pageStates.map((state2)=>state2.wrapper);
                const scrollAnchor = $3438a2478d5b847f$export$449ea97f0d46522e(scroller, wrappers);
                const previousHeight = state.wrapper.style.height;
                updatePageWrapperDimensions(state.wrapper, meta, size);
                if (scrollAnchor && pageIdx <= scrollAnchor.index && state.wrapper.style.height !== previousHeight) $3438a2478d5b847f$export$c0bc1c93b9d1d8ba(scroller, wrappers, scrollAnchor);
                updateSummary();
                const scale = $3438a2478d5b847f$var$resolvePdfPageScale(meta, options.fit, resolveLayoutWidth(size), resolveLayoutHeight(size), zoomFactor, rotation);
                const viewport = page.getViewport({
                    scale: scale,
                    rotation: $3438a2478d5b847f$var$getPdfRenderRotation(meta, rotation)
                });
                const outputScale = $3438a2478d5b847f$var$getPdfOutputScale();
                const cssWidth = Math.floor(viewport.width);
                const cssHeight = Math.floor(viewport.height);
                const canvas = document.createElement("canvas");
                canvas.className = "ofv-pdf-page";
                canvas.width = Math.floor(cssWidth * outputScale);
                canvas.height = Math.floor(cssHeight * outputScale);
                canvas.style.width = `${cssWidth}px`;
                canvas.style.height = `${cssHeight}px`;
                const context = canvas.getContext("2d");
                if (!context) throw new Error("Canvas 2D context is not available.");
                if (!isCurrentRender()) return;
                state.wrapper.replaceChildren(canvas);
                state.canvas = canvas;
                const renderTask = page.render({
                    canvasContext: context,
                    viewport: viewport,
                    transform: outputScale === 1 ? void 0 : [
                        outputScale,
                        0,
                        0,
                        outputScale,
                        0,
                        0
                    ]
                });
                state.renderTask = renderTask;
                await renderTask.promise;
                if (state.renderTask === renderTask) state.renderTask = null;
                if (!isCurrentRender()) return;
                const textContent = await page.getTextContent();
                if (!isCurrentRender()) return;
                const textLayer = document.createElement("div");
                textLayer.className = "ofv-pdf-text-layer";
                textLayer.style.width = `${cssWidth}px`;
                textLayer.style.height = `${cssHeight}px`;
                state.wrapper.appendChild(textLayer);
                for (const item of textContent.items){
                    if (!("str" in item)) continue;
                    const str = item.str;
                    if (!str.trim()) continue;
                    const tx = $3438a2478d5b847f$var$multiplyMatrices(viewport.transform, item.transform);
                    const fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
                    const span = document.createElement("span");
                    span.textContent = str;
                    span.style.fontSize = `${fontHeight}px`;
                    span.style.lineHeight = "1";
                    span.style.height = `${fontHeight}px`;
                    span.style.fontFamily = item.fontName || "sans-serif";
                    span.style.left = `${tx[4]}px`;
                    span.style.top = `${tx[5] - fontHeight}px`;
                    span.style.transformOrigin = "0% 0%";
                    textLayer.appendChild(span);
                    if (item.width) {
                        const itemWidth = item.width * scale;
                        const actualWidth = span.offsetWidth || span.getBoundingClientRect().width;
                        if (actualWidth > 0 && Math.abs(actualWidth - itemWidth) > 1) span.style.transform = `scaleX(${itemWidth / actualWidth})`;
                    }
                }
                if (textLayer.childElementCount === 0 && $3438a2478d5b847f$var$isCanvasVisuallyBlank(canvas, context)) state.wrapper.appendChild($3438a2478d5b847f$var$createPageStatus("ofv-pdf-empty", messages.pdfPageEmpty));
            } catch (err) {
                if (!isCurrentRender()) return;
                console.error(`Failed to render PDF page ${pageIdx + 1}:`, err);
                state.rendered = false;
                state.wrapper.replaceChildren($3438a2478d5b847f$var$createPageStatus("ofv-pdf-error", messages.pdfPageRenderFailed));
            }
        })();
        state.renderPromise = renderPromise;
        try {
            await renderPromise;
        } finally{
            if (state.renderPromise === renderPromise) state.renderPromise = null;
        }
    };
    const renderLayout = (size)=>{
        if (destroyed) return;
        const scrollAnchor = $3438a2478d5b847f$export$449ea97f0d46522e(scroller, pageStates.map((state)=>state.wrapper));
        const activeLayoutVersion = ++layoutVersion;
        observer?.disconnect();
        observer = null;
        pageStates.forEach(invalidatePageState);
        updateSummary();
        scroller.replaceChildren();
        pageStates.length = 0;
        if (typeof IntersectionObserver !== "undefined") observer = new IntersectionObserver((entries)=>{
            if (destroyed || layoutVersion !== activeLayoutVersion) return;
            entries.forEach((entry)=>{
                const pageIdx = parseInt(entry.target.getAttribute("data-page-index") || "0", 10);
                const state = pageStates[pageIdx];
                if (!state) return;
                if (entry.isIntersecting) {
                    if (!state.rendered) renderPage(pageIdx, size);
                } else if (!printPreparation && state.rendered && pdfDocument.numPages > 8) clearPage(pageIdx);
            });
        }, {
            root: scroller,
            rootMargin: "400px 0px 400px 0px"
        });
        for(let i = 0; i < pdfDocument.numPages; i++){
            const meta = pagesMeta[i];
            const wrapper = document.createElement("div");
            wrapper.className = "ofv-pdf-page-wrapper";
            wrapper.setAttribute("data-page-index", String(i));
            wrapper.setAttribute("aria-label", $3438a2478d5b847f$export$40b3ce2549faa304(messages.pdfPageLabel, {
                page: i + 1
            }));
            updatePageWrapperDimensions(wrapper, meta, size);
            wrapper.append($3438a2478d5b847f$var$createPageStatus("ofv-pdf-skeleton", $3438a2478d5b847f$export$40b3ce2549faa304(messages.pdfPageLoading, {
                page: i + 1
            })));
            scroller.appendChild(wrapper);
            pageStates.push({
                wrapper: wrapper,
                canvas: null,
                renderTask: null,
                renderPromise: null,
                rendered: false,
                renderVersion: 0
            });
            if (observer) observer.observe(wrapper);
        }
        $3438a2478d5b847f$export$c0bc1c93b9d1d8ba(scroller, pageStates.map((state)=>state.wrapper), scrollAnchor);
        const eagerPages = /* @__PURE__ */ new Set();
        for(let i = 0; i < Math.min(2, pdfDocument.numPages); i += 1)eagerPages.add(i);
        eagerPages.add(currentPage - 1);
        if (scrollAnchor) eagerPages.add(scrollAnchor.index);
        eagerPages.forEach((pageIdx)=>void renderPage(pageIdx, size));
        goToPage(currentPage, false);
    };
    renderLayout(options.size);
    const centerHorizontalScroll = ()=>{
        scroller.scrollLeft = Math.max(0, (scroller.scrollWidth - scroller.clientWidth) / 2);
    };
    let resizeTimer;
    return {
        goToPage (page) {
            return goToPage(page);
        },
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left";
        },
        command (command) {
            if (command === "zoom-in") {
                zoomFactor = Math.min(4, zoomFactor + 0.15);
                renderLayout(currentSize);
                centerHorizontalScroll();
                return true;
            }
            if (command === "zoom-out") {
                zoomFactor = Math.max(0.25, zoomFactor - 0.15);
                renderLayout(currentSize);
                centerHorizontalScroll();
                return true;
            }
            if (command === "zoom-reset") {
                zoomFactor = 1;
                rotation = 0;
                renderLayout(currentSize);
                centerHorizontalScroll();
                return true;
            }
            if (command === "rotate-right" || command === "rotate-left") {
                rotation = $3438a2478d5b847f$var$normalizePdfRotation(rotation + (command === "rotate-right" ? 90 : -90));
                renderLayout(currentSize);
                return true;
            }
            return false;
        },
        resize (size) {
            currentSize = size;
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(()=>{
                renderLayout(size);
            }, 120);
        },
        preparePrint () {
            if (printPreparation) return printPreparation;
            const activeObserver = observer;
            activeObserver?.disconnect();
            printPreparation = (async ()=>{
                let renderedLayoutVersion;
                do {
                    renderedLayoutVersion = layoutVersion;
                    let nextPage = 0;
                    const pageCount = pageStates.length;
                    const renderNext = async ()=>{
                        while(!destroyed && nextPage < pageCount){
                            const pageIndex = nextPage;
                            nextPage += 1;
                            await renderPage(pageIndex, currentSize);
                        }
                    };
                    const workerCount = Math.min(3, pageCount);
                    await Promise.all(Array.from({
                        length: workerCount
                    }, ()=>renderNext()));
                }while (!destroyed && renderedLayoutVersion !== layoutVersion);
            })().finally(()=>{
                if (observer === activeObserver) for (const state of pageStates)activeObserver?.observe(state.wrapper);
                printPreparation = void 0;
            });
            return printPreparation;
        },
        destroy () {
            destroyed = true;
            layoutVersion += 1;
            options.toolbar?.setZoom(void 0);
            pageNavigator.destroy();
            scroller.removeEventListener("scroll", handleScrollerScroll);
            window.clearTimeout(resizeTimer);
            observer?.disconnect();
            pageStates.forEach(invalidatePageState);
            pageStates.length = 0;
            $3438a2478d5b847f$var$destroyPdfResource(pdfDocument);
            $3438a2478d5b847f$var$destroyPdfResource(documentTask);
            if (options.revokeUrlOnDestroy) $3438a2478d5b847f$export$7438c4986c08186f(options.fileUrl, Boolean(options.isExternal));
        }
    };
}
function $3438a2478d5b847f$var$destroyPdfResource(resource) {
    if (!resource || typeof resource !== "object") return;
    const candidate = resource;
    if (typeof candidate.destroy === "function") {
        candidate.destroy();
        return;
    }
    if (typeof candidate.cleanup === "function") candidate.cleanup();
}
function $3438a2478d5b847f$var$getPdfOutputScale() {
    if (typeof window === "undefined") return 1;
    return Math.max(2, Math.min(window.devicePixelRatio || 1, 2.5));
}
function $3438a2478d5b847f$var$getPdfAvailableWidth(width) {
    if (!Number.isFinite(width) || width <= 0) return 1;
    const gutter = width < 160 ? 16 : 32;
    return Math.max(1, width - gutter);
}
function $3438a2478d5b847f$var$getPdfAvailableHeight(height) {
    if (!Number.isFinite(height) || height <= 0) return 1;
    const gutter = height < 160 ? 16 : 32;
    return Math.max(1, height - gutter);
}
function $3438a2478d5b847f$var$resolvePdfPageScale(meta, fit, layoutWidth, layoutHeight, zoomFactor, rotation) {
    const widthScale = $3438a2478d5b847f$var$getPdfAvailableWidth(layoutWidth) / $3438a2478d5b847f$var$rotatedPdfWidth(meta, rotation);
    const heightScale = $3438a2478d5b847f$var$getPdfAvailableHeight(layoutHeight) / $3438a2478d5b847f$var$rotatedPdfHeight(meta, rotation);
    let fitScale;
    switch(fit){
        case "actual":
            fitScale = 1;
            break;
        case "width":
            fitScale = widthScale;
            break;
        case "height":
            fitScale = heightScale;
            break;
        case "cover":
            fitScale = Math.max(widthScale, heightScale);
            break;
        case "scale-down":
            fitScale = Math.min(1, widthScale, heightScale);
            break;
        case "contain":
        default:
            fitScale = Math.min(widthScale, heightScale);
            break;
    }
    return Math.max(0.05, Math.min(5, fitScale * zoomFactor));
}
function $3438a2478d5b847f$var$renderPdfSummary(summary, pages, pagesMeta, fit, zoomFactor, messages) {
    summary.replaceChildren();
    $3438a2478d5b847f$var$appendPdfSummary(summary, messages.pdfSummaryPages, String(pages));
    const pageSizes = $3438a2478d5b847f$var$formatPdfPageSizes(pagesMeta);
    if (pageSizes) $3438a2478d5b847f$var$appendPdfSummary(summary, messages.pdfSummaryPageSizes, pageSizes);
    $3438a2478d5b847f$var$appendPdfSummary(summary, messages.pdfSummaryFit, fit === "actual" ? messages.pdfSummaryActualSize : messages.pdfSummaryFitWidth);
    $3438a2478d5b847f$var$appendPdfSummary(summary, messages.pdfSummaryZoom, `${Math.round(zoomFactor * 100)}%`);
}
function $3438a2478d5b847f$var$appendPdfSummary(parent, label, value) {
    const item = document.createElement("span");
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    item.append(key, content);
    parent.append(item);
}
function $3438a2478d5b847f$var$normalizePdfRotation(value) {
    return (value % 360 + 360) % 360;
}
function $3438a2478d5b847f$var$getPdfPageRotation(page) {
    const rotation = Number(page.rotate);
    return Number.isFinite(rotation) ? $3438a2478d5b847f$var$normalizePdfRotation(rotation) : 0;
}
function $3438a2478d5b847f$var$getPdfRenderRotation(meta, userRotation) {
    return $3438a2478d5b847f$var$normalizePdfRotation((meta.rotation || 0) + userRotation);
}
function $3438a2478d5b847f$var$isPdfRotatedSideways(rotation) {
    const normalized = $3438a2478d5b847f$var$normalizePdfRotation(rotation);
    return normalized === 90 || normalized === 270;
}
function $3438a2478d5b847f$var$rotatedPdfWidth(meta, rotation) {
    return $3438a2478d5b847f$var$isPdfRotatedSideways(rotation) ? meta.height : meta.width;
}
function $3438a2478d5b847f$var$rotatedPdfHeight(meta, rotation) {
    return $3438a2478d5b847f$var$isPdfRotatedSideways(rotation) ? meta.width : meta.height;
}
function $3438a2478d5b847f$var$formatPdfPageSizes(pagesMeta) {
    const counts = /* @__PURE__ */ new Map();
    for (const page of pagesMeta){
        const key = `${Math.round(page.width)} x ${Math.round(page.height)}`;
        counts.set(key, (counts.get(key) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 4).map(([size, count])=>count > 1 ? `${size} (${count})` : size).join(", ");
}
function $3438a2478d5b847f$var$normalizePdfOptions(options) {
    if ("getDocument" in options) return {
        pdfjs: options
    };
    return options;
}
async function $3438a2478d5b847f$var$loadPdfData(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to load PDF data: ${response.status} ${response.statusText}`);
    return new Uint8Array(await response.arrayBuffer());
}
function $3438a2478d5b847f$var$isCanvasVisuallyBlank(canvas, context) {
    if (canvas.width === 0 || canvas.height === 0 || typeof context.getImageData !== "function") return false;
    try {
        const sampleWidth = Math.min(canvas.width, 96);
        const sampleHeight = Math.min(canvas.height, 96);
        const stepX = Math.max(1, Math.floor(canvas.width / sampleWidth));
        const stepY = Math.max(1, Math.floor(canvas.height / sampleHeight));
        let sampled = 0;
        let nonBlank = 0;
        for(let y = 0; y < canvas.height; y += stepY)for(let x = 0; x < canvas.width; x += stepX){
            const pixel = context.getImageData(x, y, 1, 1).data;
            const red = pixel[0];
            const green = pixel[1];
            const blue = pixel[2];
            const alpha = pixel[3];
            sampled += 1;
            if (alpha > 8 && (red < 248 || green < 248 || blue < 248)) {
                nonBlank += 1;
                if (nonBlank / sampled > 2e-3) return false;
            }
        }
        return sampled > 0;
    } catch  {
        return false;
    }
}
function $3438a2478d5b847f$var$createPageStatus(className, text) {
    const status = document.createElement("div");
    status.className = className;
    status.textContent = text;
    return status;
}
function $3438a2478d5b847f$var$createPdfFallback(fileName, url, message, messages, titleText = messages.pdfPreviewFailedTitle, webFallbackScripts = "auto") {
    if ($3438a2478d5b847f$var$isEmbeddableRemoteUrl(url)) return $3438a2478d5b847f$var$createPdfWebFallback(fileName, url, webFallbackScripts);
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = titleText;
    const meta = document.createElement("span");
    meta.textContent = `${message} ${fileName}`;
    const download = document.createElement("a");
    download.href = url;
    download.download = fileName;
    download.textContent = messages.pdfDownload;
    fallback.append(title, meta, download);
    return fallback;
}
function $3438a2478d5b847f$var$createPdfWebFallback(fileName, url, webFallbackScripts) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-pdf-web-fallback";
    const iframe = document.createElement("iframe");
    iframe.className = "ofv-pdf-web-fallback-frame";
    iframe.src = url;
    iframe.title = `${fileName} HTML preview`;
    const sandboxTokens = [
        "allow-forms",
        "allow-popups",
        "allow-presentation",
        "allow-same-origin"
    ];
    if ($3438a2478d5b847f$var$shouldAllowPdfWebFallbackScripts(url, webFallbackScripts)) sandboxTokens.push("allow-scripts");
    iframe.setAttribute("sandbox", sandboxTokens.join(" "));
    fallback.append(iframe);
    return fallback;
}
function $3438a2478d5b847f$var$shouldAllowPdfWebFallbackScripts(url, policy) {
    if (policy === "always") return true;
    if (policy === "never" || typeof window === "undefined" || typeof document === "undefined") return false;
    try {
        const target = document.createElement("a");
        target.href = url;
        return target.origin !== window.location.origin;
    } catch  {
        return false;
    }
}
function $3438a2478d5b847f$var$isEmbeddableRemoteUrl(url) {
    return /^https?:\/\//i.test(url);
}
function $3438a2478d5b847f$var$normalizePdfError(error, messages) {
    const message = error instanceof Error ? error.message : String(error || "");
    const name = typeof error === "object" && error !== null && "name" in error ? String(error.name) : "";
    const lower = `${name} ${message}`.toLowerCase();
    if (lower.includes("invalid") || lower.includes("missing") || lower.includes("corrupt")) return messages.pdfCorruptedMessage;
    return messages.pdfCannotLoadMessage;
}
function $3438a2478d5b847f$var$createPdfPageNavigator(total, messages, onChange) {
    const element = document.createElement("div");
    element.className = "ofv-pdf-page-navigator";
    const previous = document.createElement("button");
    previous.type = "button";
    previous.textContent = "\u2039";
    previous.title = messages.pdfPreviousPage;
    previous.setAttribute("aria-label", messages.pdfPreviousPage);
    const input = document.createElement("input");
    input.type = "number";
    input.min = "1";
    input.max = String(total);
    input.value = "1";
    input.inputMode = "numeric";
    input.setAttribute("aria-label", messages.pdfPageInput);
    const position = document.createElement("span");
    position.textContent = $3438a2478d5b847f$export$40b3ce2549faa304(messages.pdfPagePosition, {
        total: total
    });
    const next = document.createElement("button");
    next.type = "button";
    next.textContent = "\u203A";
    next.title = messages.pdfNextPage;
    next.setAttribute("aria-label", messages.pdfNextPage);
    const commit = ()=>onChange(Number(input.value));
    const handleKeydown = (event)=>{
        if (event.key === "Enter") commit();
    };
    const handlePrevious = ()=>onChange(Number(input.value) - 1);
    const handleNext = ()=>onChange(Number(input.value) + 1);
    input.addEventListener("change", commit);
    input.addEventListener("keydown", handleKeydown);
    previous.addEventListener("click", handlePrevious);
    next.addEventListener("click", handleNext);
    element.append(previous, input, position, next);
    return {
        element: element,
        setCurrent (page) {
            input.value = String(page);
            previous.disabled = page <= 1;
            next.disabled = page >= total;
        },
        destroy () {
            input.removeEventListener("change", commit);
            input.removeEventListener("keydown", handleKeydown);
            previous.removeEventListener("click", handlePrevious);
            next.removeEventListener("click", handleNext);
        }
    };
}
function $3438a2478d5b847f$var$configurePdfWorker(pdf, workerSrc, legacyWorkerSrc, legacy = false) {
    const configuredWorkerSrc = legacy ? legacyWorkerSrc || workerSrc : workerSrc;
    if (configuredWorkerSrc) {
        pdf.GlobalWorkerOptions.workerSrc = configuredWorkerSrc;
        return;
    }
    if (!pdf.GlobalWorkerOptions.workerSrc && typeof window !== "undefined") {
        const build = legacy ? "legacy/build" : "build";
        pdf.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdf.version}/${build}/pdf.worker.mjs`;
    }
}
function $3438a2478d5b847f$var$shouldUseLegacyPdfCompatibility(mode = "auto") {
    if (mode === "legacy") return true;
    if (mode === "modern") return false;
    const promise = Promise;
    if (typeof promise.withResolvers !== "function") return true;
    if (typeof navigator === "undefined") return false;
    const userAgent = navigator.userAgent;
    const isWebKit = /AppleWebKit/i.test(userAgent);
    const isIosWebKit = /(?:iPhone|iPad|iPod)/i.test(userAgent);
    const isNonWebKitBrowser = /(?:Chrome|Chromium|CriOS|Edg|OPR|SamsungBrowser)/i.test(userAgent);
    return /(?:QIHU|360SE|360EE)/i.test(userAgent) || isWebKit && (isIosWebKit || !isNonWebKitBrowser);
}
function $3438a2478d5b847f$var$installPromiseWithResolversPolyfill() {
    const promise = Promise;
    if (typeof promise.withResolvers === "function") return;
    Object.defineProperty(promise, "withResolvers", {
        configurable: true,
        writable: true,
        value: ()=>{
            let resolve;
            let reject;
            const pending = new Promise((resolvePromise, rejectPromise)=>{
                resolve = resolvePromise;
                reject = rejectPromise;
            });
            return {
                promise: pending,
                resolve: resolve,
                reject: reject
            };
        }
    });
}



var $ey1aZ = parcelRequire("ey1aZ");

var $hIrjg = parcelRequire("hIrjg");
/*
 * @license
 * docx-preview <https://github.com/VolodymyrBaydalka/docxjs>
 * Released under Apache License 2.0  <https://github.com/VolodymyrBaydalka/docxjs/blob/master/LICENSE>
 * Copyright Volodymyr Baydalka
 */ 
var $ey1aZ = parcelRequire("ey1aZ");
var $68b4bc55b173684a$var$RelationshipTypes;
(function(RelationshipTypes) {
    RelationshipTypes["OfficeDocument"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument";
    RelationshipTypes["FontTable"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable";
    RelationshipTypes["Image"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
    RelationshipTypes["Numbering"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering";
    RelationshipTypes["Styles"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
    RelationshipTypes["StylesWithEffects"] = "http://schemas.microsoft.com/office/2007/relationships/stylesWithEffects";
    RelationshipTypes["Theme"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
    RelationshipTypes["Settings"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings";
    RelationshipTypes["WebSettings"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings";
    RelationshipTypes["Hyperlink"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink";
    RelationshipTypes["Footnotes"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes";
    RelationshipTypes["Endnotes"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes";
    RelationshipTypes["Footer"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
    RelationshipTypes["Header"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
    RelationshipTypes["ExtendedProperties"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";
    RelationshipTypes["CoreProperties"] = "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";
    RelationshipTypes["CustomProperties"] = "http://schemas.openxmlformats.org/package/2006/relationships/metadata/custom-properties";
    RelationshipTypes["Comments"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
    RelationshipTypes["CommentsExtended"] = "http://schemas.microsoft.com/office/2011/relationships/commentsExtended";
    RelationshipTypes["AltChunk"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/aFChunk";
})($68b4bc55b173684a$var$RelationshipTypes || ($68b4bc55b173684a$var$RelationshipTypes = {}));
function $68b4bc55b173684a$var$parseRelationships(root, xml) {
    return xml.elements(root).map((e)=>({
            id: xml.attr(e, "Id"),
            type: xml.attr(e, "Type"),
            target: xml.attr(e, "Target"),
            targetMode: xml.attr(e, "TargetMode")
        }));
}
function $68b4bc55b173684a$var$escapeClassName(className) {
    return className?.replace(/[ .]+/g, '-').replace(/[&]+/g, 'and').toLowerCase();
}
function $68b4bc55b173684a$var$encloseFontFamily(fontFamily) {
    return /^[^"'].*\s.*[^"']$/.test(fontFamily) ? `'${fontFamily}'` : fontFamily;
}
function $68b4bc55b173684a$var$splitPath(path) {
    let si = path.lastIndexOf('/') + 1;
    let folder = si == 0 ? "" : path.substring(0, si);
    let fileName = si == 0 ? path : path.substring(si);
    return [
        folder,
        fileName
    ];
}
function $68b4bc55b173684a$var$resolvePath(path, base) {
    try {
        const prefix = "http://docx/";
        const url = new URL(path, prefix + base).toString();
        return url.substring(prefix.length);
    } catch  {
        return `${base}${path}`;
    }
}
function $68b4bc55b173684a$var$keyBy(array, by) {
    return array.reduce((a, x)=>{
        a[by(x)] = x;
        return a;
    }, {});
}
function $68b4bc55b173684a$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = ()=>reject();
        reader.readAsDataURL(blob);
    });
}
function $68b4bc55b173684a$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $68b4bc55b173684a$var$isString(item) {
    return typeof item === 'string' || item instanceof String;
}
function $68b4bc55b173684a$var$mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if ($68b4bc55b173684a$var$isObject(target) && $68b4bc55b173684a$var$isObject(source)) {
        for(const key in source)if ($68b4bc55b173684a$var$isObject(source[key])) {
            const val = target[key] ?? (target[key] = {});
            $68b4bc55b173684a$var$mergeDeep(val, source[key]);
        } else target[key] = source[key];
    }
    return $68b4bc55b173684a$var$mergeDeep(target, ...sources);
}
function $68b4bc55b173684a$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $68b4bc55b173684a$var$clamp(val, min, max) {
    return min > val ? min : max < val ? max : val;
}
const $68b4bc55b173684a$var$ns$1 = {
    wordml: "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
};
const $68b4bc55b173684a$var$LengthUsage = {
    Dxa: {
        mul: 0.05,
        unit: "pt"
    },
    Emu: {
        mul: 1 / 12700,
        unit: "pt"
    },
    FontSize: {
        mul: 0.5,
        unit: "pt"
    },
    Border: {
        mul: 0.125,
        unit: "pt",
        min: 0.25,
        max: 12
    },
    Point: {
        mul: 1,
        unit: "pt"
    },
    Percent: {
        mul: 0.02,
        unit: "%"
    }
};
function $68b4bc55b173684a$var$convertLength(val, usage = $68b4bc55b173684a$var$LengthUsage.Dxa) {
    if (val == null || /.+(p[xt]|[%])$/.test(val)) return val;
    var num = parseInt(val) * usage.mul;
    if (usage.min && usage.max) num = $68b4bc55b173684a$var$clamp(num, usage.min, usage.max);
    return `${num.toFixed(2)}${usage.unit}`;
}
function $68b4bc55b173684a$var$convertBoolean(v, defaultValue = false) {
    switch(v){
        case "1":
            return true;
        case "0":
            return false;
        case "on":
            return true;
        case "off":
            return false;
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
}
function $68b4bc55b173684a$var$parseCommonProperty(elem, props, xml) {
    if (elem.namespaceURI != $68b4bc55b173684a$var$ns$1.wordml) return false;
    switch(elem.localName){
        case "color":
            props.color = xml.attr(elem, "val");
            break;
        case "sz":
            props.fontSize = xml.lengthAttr(elem, "val", $68b4bc55b173684a$var$LengthUsage.FontSize);
            break;
        default:
            return false;
    }
    return true;
}
function $68b4bc55b173684a$var$parseXmlString(xmlString, trimXmlDeclaration = false) {
    if (trimXmlDeclaration) xmlString = xmlString.replace(/<[?].*[?]>/, "");
    xmlString = $68b4bc55b173684a$var$removeUTF8BOM(xmlString);
    const result = new DOMParser().parseFromString(xmlString, "application/xml");
    const errorText = $68b4bc55b173684a$var$hasXmlParserError(result);
    if (errorText) throw new Error(errorText);
    return result;
}
function $68b4bc55b173684a$var$hasXmlParserError(doc) {
    return doc.getElementsByTagName("parsererror")[0]?.textContent;
}
function $68b4bc55b173684a$var$removeUTF8BOM(data) {
    return data.charCodeAt(0) === 0xFEFF ? data.substring(1) : data;
}
function $68b4bc55b173684a$var$serializeXmlString(elem) {
    return new XMLSerializer().serializeToString(elem);
}
class $68b4bc55b173684a$var$XmlParser {
    elements(elem, localName = null) {
        const result = [];
        for(let i = 0, l = elem.childNodes.length; i < l; i++){
            let c = elem.childNodes.item(i);
            if (c.nodeType == Node.ELEMENT_NODE && (localName == null || c.localName == localName)) result.push(c);
        }
        return result;
    }
    element(elem, localName) {
        for(let i = 0, l = elem.childNodes.length; i < l; i++){
            let c = elem.childNodes.item(i);
            if (c.nodeType == 1 && c.localName == localName) return c;
        }
        return null;
    }
    elementAttr(elem, localName, attrLocalName) {
        var el = this.element(elem, localName);
        return el ? this.attr(el, attrLocalName) : undefined;
    }
    attrs(elem) {
        return Array.from(elem.attributes);
    }
    attr(elem, localName) {
        for(let i = 0, l = elem.attributes.length; i < l; i++){
            let a = elem.attributes.item(i);
            if (a.localName == localName) return a.value;
        }
        return null;
    }
    intAttr(node, attrName, defaultValue = null) {
        var val = this.attr(node, attrName);
        return val ? parseInt(val) : defaultValue;
    }
    hexAttr(node, attrName, defaultValue = null) {
        var val = this.attr(node, attrName);
        return val ? parseInt(val, 16) : defaultValue;
    }
    floatAttr(node, attrName, defaultValue = null) {
        var val = this.attr(node, attrName);
        return val ? parseFloat(val) : defaultValue;
    }
    boolAttr(node, attrName, defaultValue = null) {
        return $68b4bc55b173684a$var$convertBoolean(this.attr(node, attrName), defaultValue);
    }
    lengthAttr(node, attrName, usage = $68b4bc55b173684a$var$LengthUsage.Dxa) {
        return $68b4bc55b173684a$var$convertLength(this.attr(node, attrName), usage);
    }
}
const $68b4bc55b173684a$var$globalXmlParser = new $68b4bc55b173684a$var$XmlParser();
class $68b4bc55b173684a$var$Part {
    constructor(_package, path){
        this._package = _package;
        this.path = path;
    }
    async load() {
        this.rels = await this._package.loadRelationships(this.path);
        const xmlText = await this._package.load(this.path);
        const xmlDoc = this._package.parseXmlDocument(xmlText);
        if (this._package.options.keepOrigin) this._xmlDocument = xmlDoc;
        this.parseXml(xmlDoc.firstElementChild);
    }
    save() {
        this._package.update(this.path, $68b4bc55b173684a$var$serializeXmlString(this._xmlDocument));
    }
    parseXml(root) {}
}
const $68b4bc55b173684a$var$embedFontTypeMap = {
    embedRegular: 'regular',
    embedBold: 'bold',
    embedItalic: 'italic',
    embedBoldItalic: 'boldItalic'
};
function $68b4bc55b173684a$var$parseFonts(root, xml) {
    return xml.elements(root).map((el)=>$68b4bc55b173684a$var$parseFont(el, xml));
}
function $68b4bc55b173684a$var$parseFont(elem, xml) {
    let result = {
        name: xml.attr(elem, "name"),
        embedFontRefs: []
    };
    for (let el of xml.elements(elem))switch(el.localName){
        case "family":
            result.family = xml.attr(el, "val");
            break;
        case "altName":
            result.altName = xml.attr(el, "val");
            break;
        case "embedRegular":
        case "embedBold":
        case "embedItalic":
        case "embedBoldItalic":
            result.embedFontRefs.push($68b4bc55b173684a$var$parseEmbedFontRef(el, xml));
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseEmbedFontRef(elem, xml) {
    return {
        id: xml.attr(elem, "id"),
        key: xml.attr(elem, "fontKey"),
        type: $68b4bc55b173684a$var$embedFontTypeMap[elem.localName]
    };
}
class $68b4bc55b173684a$var$FontTablePart extends $68b4bc55b173684a$var$Part {
    parseXml(root) {
        this.fonts = $68b4bc55b173684a$var$parseFonts(root, this._package.xmlParser);
    }
}
class $68b4bc55b173684a$var$OpenXmlPackage {
    constructor(_zip, options){
        this._zip = _zip;
        this.options = options;
        this.xmlParser = new $68b4bc55b173684a$var$XmlParser();
    }
    get(path) {
        const p = $68b4bc55b173684a$var$normalizePath(path);
        return this._zip.files[p] ?? this._zip.files[p.replace(/\//g, '\\')];
    }
    update(path, content) {
        this._zip.file(path, content);
    }
    static async load(input, options) {
        const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(input);
        return new $68b4bc55b173684a$var$OpenXmlPackage(zip, options);
    }
    save(type = "blob") {
        return this._zip.generateAsync({
            type: type
        });
    }
    load(path, type = "string") {
        return this.get(path)?.async(type) ?? Promise.resolve(null);
    }
    async loadRelationships(path = null) {
        let relsPath = `_rels/.rels`;
        if (path != null) {
            const [f, fn] = $68b4bc55b173684a$var$splitPath(path);
            relsPath = `${f}_rels/${fn}.rels`;
        }
        const txt = await this.load(relsPath);
        return txt ? $68b4bc55b173684a$var$parseRelationships(this.parseXmlDocument(txt).firstElementChild, this.xmlParser) : null;
    }
    parseXmlDocument(txt) {
        return $68b4bc55b173684a$var$parseXmlString(txt, this.options.trimXmlDeclaration);
    }
}
function $68b4bc55b173684a$var$normalizePath(path) {
    return path.startsWith('/') ? path.substr(1) : path;
}
class $68b4bc55b173684a$var$DocumentPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
    parseXml(root) {
        this.body = this._documentParser.parseDocumentFile(root);
    }
}
function $68b4bc55b173684a$var$parseBorder(elem, xml) {
    return {
        type: xml.attr(elem, "val"),
        color: xml.attr(elem, "color"),
        size: xml.lengthAttr(elem, "sz", $68b4bc55b173684a$var$LengthUsage.Border),
        offset: xml.lengthAttr(elem, "space", $68b4bc55b173684a$var$LengthUsage.Point),
        frame: xml.boolAttr(elem, 'frame'),
        shadow: xml.boolAttr(elem, 'shadow')
    };
}
function $68b4bc55b173684a$var$parseBorders(elem, xml) {
    var result = {};
    for (let e of xml.elements(elem))switch(e.localName){
        case "left":
            result.left = $68b4bc55b173684a$var$parseBorder(e, xml);
            break;
        case "top":
            result.top = $68b4bc55b173684a$var$parseBorder(e, xml);
            break;
        case "right":
            result.right = $68b4bc55b173684a$var$parseBorder(e, xml);
            break;
        case "bottom":
            result.bottom = $68b4bc55b173684a$var$parseBorder(e, xml);
            break;
    }
    return result;
}
var $68b4bc55b173684a$var$SectionType;
(function(SectionType) {
    SectionType["Continuous"] = "continuous";
    SectionType["NextPage"] = "nextPage";
    SectionType["NextColumn"] = "nextColumn";
    SectionType["EvenPage"] = "evenPage";
    SectionType["OddPage"] = "oddPage";
})($68b4bc55b173684a$var$SectionType || ($68b4bc55b173684a$var$SectionType = {}));
function $68b4bc55b173684a$var$parseSectionProperties(elem, xml = $68b4bc55b173684a$var$globalXmlParser) {
    var section = {};
    for (let e of xml.elements(elem))switch(e.localName){
        case "pgSz":
            section.pageSize = {
                width: xml.lengthAttr(e, "w"),
                height: xml.lengthAttr(e, "h"),
                orientation: xml.attr(e, "orient")
            };
            break;
        case "type":
            section.type = xml.attr(e, "val");
            break;
        case "pgMar":
            section.pageMargins = {
                left: xml.lengthAttr(e, "left"),
                right: xml.lengthAttr(e, "right"),
                top: xml.lengthAttr(e, "top"),
                bottom: xml.lengthAttr(e, "bottom"),
                header: xml.lengthAttr(e, "header"),
                footer: xml.lengthAttr(e, "footer"),
                gutter: xml.lengthAttr(e, "gutter")
            };
            break;
        case "cols":
            section.columns = $68b4bc55b173684a$var$parseColumns(e, xml);
            break;
        case "headerReference":
            (section.headerRefs ?? (section.headerRefs = [])).push($68b4bc55b173684a$var$parseFooterHeaderReference(e, xml));
            break;
        case "footerReference":
            (section.footerRefs ?? (section.footerRefs = [])).push($68b4bc55b173684a$var$parseFooterHeaderReference(e, xml));
            break;
        case "titlePg":
            section.titlePage = xml.boolAttr(e, "val", true);
            break;
        case "pgBorders":
            section.pageBorders = $68b4bc55b173684a$var$parseBorders(e, xml);
            break;
        case "pgNumType":
            section.pageNumber = $68b4bc55b173684a$var$parsePageNumber(e, xml);
            break;
    }
    return section;
}
function $68b4bc55b173684a$var$parseColumns(elem, xml) {
    return {
        numberOfColumns: xml.intAttr(elem, "num"),
        space: xml.lengthAttr(elem, "space"),
        separator: xml.boolAttr(elem, "sep"),
        equalWidth: xml.boolAttr(elem, "equalWidth", true),
        columns: xml.elements(elem, "col").map((e)=>({
                width: xml.lengthAttr(e, "w"),
                space: xml.lengthAttr(e, "space")
            }))
    };
}
function $68b4bc55b173684a$var$parsePageNumber(elem, xml) {
    return {
        chapSep: xml.attr(elem, "chapSep"),
        chapStyle: xml.attr(elem, "chapStyle"),
        format: xml.attr(elem, "fmt"),
        start: xml.intAttr(elem, "start")
    };
}
function $68b4bc55b173684a$var$parseFooterHeaderReference(elem, xml) {
    return {
        id: xml.attr(elem, "id"),
        type: xml.attr(elem, "type")
    };
}
function $68b4bc55b173684a$var$parseLineSpacing(elem, xml) {
    return {
        before: xml.lengthAttr(elem, "before"),
        after: xml.lengthAttr(elem, "after"),
        line: xml.intAttr(elem, "line"),
        lineRule: xml.attr(elem, "lineRule")
    };
}
function $68b4bc55b173684a$var$parseRunProperties(elem, xml) {
    let result = {};
    for (let el of xml.elements(elem))$68b4bc55b173684a$var$parseRunProperty(el, result, xml);
    return result;
}
function $68b4bc55b173684a$var$parseRunProperty(elem, props, xml) {
    if ($68b4bc55b173684a$var$parseCommonProperty(elem, props, xml)) return true;
    return false;
}
function $68b4bc55b173684a$var$parseParagraphProperties(elem, xml) {
    let result = {};
    for (let el of xml.elements(elem))$68b4bc55b173684a$var$parseParagraphProperty(el, result, xml);
    return result;
}
function $68b4bc55b173684a$var$parseParagraphProperty(elem, props, xml) {
    if (elem.namespaceURI != $68b4bc55b173684a$var$ns$1.wordml) return false;
    if ($68b4bc55b173684a$var$parseCommonProperty(elem, props, xml)) return true;
    switch(elem.localName){
        case "tabs":
            props.tabs = $68b4bc55b173684a$var$parseTabs(elem, xml);
            break;
        case "sectPr":
            props.sectionProps = $68b4bc55b173684a$var$parseSectionProperties(elem, xml);
            break;
        case "numPr":
            props.numbering = $68b4bc55b173684a$var$parseNumbering$1(elem, xml);
            break;
        case "spacing":
            props.lineSpacing = $68b4bc55b173684a$var$parseLineSpacing(elem, xml);
            return false;
        case "textAlignment":
            props.textAlignment = xml.attr(elem, "val");
            return false;
        case "keepLines":
            props.keepLines = xml.boolAttr(elem, "val", true);
            break;
        case "keepNext":
            props.keepNext = xml.boolAttr(elem, "val", true);
            break;
        case "pageBreakBefore":
            props.pageBreakBefore = xml.boolAttr(elem, "val", true);
            break;
        case "outlineLvl":
            props.outlineLevel = xml.intAttr(elem, "val");
            break;
        case "pStyle":
            props.styleName = xml.attr(elem, "val");
            break;
        case "rPr":
            props.runProps = $68b4bc55b173684a$var$parseRunProperties(elem, xml);
            break;
        default:
            return false;
    }
    return true;
}
function $68b4bc55b173684a$var$parseTabs(elem, xml) {
    return xml.elements(elem, "tab").map((e)=>({
            position: xml.lengthAttr(e, "pos"),
            leader: xml.attr(e, "leader"),
            style: xml.attr(e, "val")
        }));
}
function $68b4bc55b173684a$var$parseNumbering$1(elem, xml) {
    var result = {};
    for (let e of xml.elements(elem))switch(e.localName){
        case "numId":
            result.id = xml.attr(e, "val");
            break;
        case "ilvl":
            result.level = xml.intAttr(e, "val");
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNumberingPart(elem, xml) {
    let result = {
        numberings: [],
        abstractNumberings: [],
        bulletPictures: []
    };
    for (let e of xml.elements(elem))switch(e.localName){
        case "num":
            result.numberings.push($68b4bc55b173684a$var$parseNumbering(e, xml));
            break;
        case "abstractNum":
            result.abstractNumberings.push($68b4bc55b173684a$var$parseAbstractNumbering(e, xml));
            break;
        case "numPicBullet":
            result.bulletPictures.push($68b4bc55b173684a$var$parseNumberingBulletPicture(e, xml));
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNumbering(elem, xml) {
    let result = {
        id: xml.attr(elem, 'numId'),
        overrides: []
    };
    for (let e of xml.elements(elem))switch(e.localName){
        case "abstractNumId":
            result.abstractId = xml.attr(e, "val");
            break;
        case "lvlOverride":
            result.overrides.push($68b4bc55b173684a$var$parseNumberingLevelOverrride(e, xml));
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseAbstractNumbering(elem, xml) {
    let result = {
        id: xml.attr(elem, 'abstractNumId'),
        levels: []
    };
    for (let e of xml.elements(elem))switch(e.localName){
        case "name":
            result.name = xml.attr(e, "val");
            break;
        case "multiLevelType":
            result.multiLevelType = xml.attr(e, "val");
            break;
        case "numStyleLink":
            result.numberingStyleLink = xml.attr(e, "val");
            break;
        case "styleLink":
            result.styleLink = xml.attr(e, "val");
            break;
        case "lvl":
            result.levels.push($68b4bc55b173684a$var$parseNumberingLevel(e, xml));
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNumberingLevel(elem, xml) {
    let result = {
        level: xml.intAttr(elem, 'ilvl')
    };
    for (let e of xml.elements(elem))switch(e.localName){
        case "start":
            result.start = xml.attr(e, "val");
            break;
        case "lvlRestart":
            result.restart = xml.intAttr(e, "val");
            break;
        case "numFmt":
            result.format = xml.attr(e, "val");
            break;
        case "lvlText":
            result.text = xml.attr(e, "val");
            break;
        case "lvlJc":
            result.justification = xml.attr(e, "val");
            break;
        case "lvlPicBulletId":
            result.bulletPictureId = xml.attr(e, "val");
            break;
        case "pStyle":
            result.paragraphStyle = xml.attr(e, "val");
            break;
        case "pPr":
            result.paragraphProps = $68b4bc55b173684a$var$parseParagraphProperties(e, xml);
            break;
        case "rPr":
            result.runProps = $68b4bc55b173684a$var$parseRunProperties(e, xml);
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNumberingLevelOverrride(elem, xml) {
    let result = {
        level: xml.intAttr(elem, 'ilvl')
    };
    for (let e of xml.elements(elem))switch(e.localName){
        case "startOverride":
            result.start = xml.intAttr(e, "val");
            break;
        case "lvl":
            result.numberingLevel = $68b4bc55b173684a$var$parseNumberingLevel(e, xml);
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNumberingBulletPicture(elem, xml) {
    var pict = xml.element(elem, "pict");
    var shape = pict && xml.element(pict, "shape");
    var imagedata = shape && xml.element(shape, "imagedata");
    return imagedata ? {
        id: xml.attr(elem, "numPicBulletId"),
        referenceId: xml.attr(imagedata, "id"),
        style: xml.attr(shape, "style")
    } : null;
}
class $68b4bc55b173684a$var$NumberingPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
    parseXml(root) {
        Object.assign(this, $68b4bc55b173684a$var$parseNumberingPart(root, this._package.xmlParser));
        this.domNumberings = this._documentParser.parseNumberingFile(root);
    }
}
class $68b4bc55b173684a$var$StylesPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
    parseXml(root) {
        this.styles = this._documentParser.parseStylesFile(root);
    }
}
var $68b4bc55b173684a$var$DomType;
(function(DomType) {
    DomType["Document"] = "document";
    DomType["Paragraph"] = "paragraph";
    DomType["Run"] = "run";
    DomType["Break"] = "break";
    DomType["NoBreakHyphen"] = "noBreakHyphen";
    DomType["Table"] = "table";
    DomType["Row"] = "row";
    DomType["Cell"] = "cell";
    DomType["Hyperlink"] = "hyperlink";
    DomType["SmartTag"] = "smartTag";
    DomType["Drawing"] = "drawing";
    DomType["Image"] = "image";
    DomType["Text"] = "text";
    DomType["Tab"] = "tab";
    DomType["Symbol"] = "symbol";
    DomType["BookmarkStart"] = "bookmarkStart";
    DomType["BookmarkEnd"] = "bookmarkEnd";
    DomType["Footer"] = "footer";
    DomType["Header"] = "header";
    DomType["FootnoteReference"] = "footnoteReference";
    DomType["EndnoteReference"] = "endnoteReference";
    DomType["Footnote"] = "footnote";
    DomType["Endnote"] = "endnote";
    DomType["SimpleField"] = "simpleField";
    DomType["ComplexField"] = "complexField";
    DomType["Instruction"] = "instruction";
    DomType["VmlPicture"] = "vmlPicture";
    DomType["MmlMath"] = "mmlMath";
    DomType["MmlMathParagraph"] = "mmlMathParagraph";
    DomType["MmlFraction"] = "mmlFraction";
    DomType["MmlFunction"] = "mmlFunction";
    DomType["MmlFunctionName"] = "mmlFunctionName";
    DomType["MmlNumerator"] = "mmlNumerator";
    DomType["MmlDenominator"] = "mmlDenominator";
    DomType["MmlRadical"] = "mmlRadical";
    DomType["MmlBase"] = "mmlBase";
    DomType["MmlDegree"] = "mmlDegree";
    DomType["MmlSuperscript"] = "mmlSuperscript";
    DomType["MmlSubscript"] = "mmlSubscript";
    DomType["MmlPreSubSuper"] = "mmlPreSubSuper";
    DomType["MmlSubArgument"] = "mmlSubArgument";
    DomType["MmlSuperArgument"] = "mmlSuperArgument";
    DomType["MmlNary"] = "mmlNary";
    DomType["MmlDelimiter"] = "mmlDelimiter";
    DomType["MmlRun"] = "mmlRun";
    DomType["MmlEquationArray"] = "mmlEquationArray";
    DomType["MmlLimit"] = "mmlLimit";
    DomType["MmlLimitLower"] = "mmlLimitLower";
    DomType["MmlMatrix"] = "mmlMatrix";
    DomType["MmlMatrixRow"] = "mmlMatrixRow";
    DomType["MmlBox"] = "mmlBox";
    DomType["MmlBar"] = "mmlBar";
    DomType["MmlGroupChar"] = "mmlGroupChar";
    DomType["VmlElement"] = "vmlElement";
    DomType["Inserted"] = "inserted";
    DomType["Deleted"] = "deleted";
    DomType["DeletedText"] = "deletedText";
    DomType["Comment"] = "comment";
    DomType["CommentReference"] = "commentReference";
    DomType["CommentRangeStart"] = "commentRangeStart";
    DomType["CommentRangeEnd"] = "commentRangeEnd";
    DomType["AltChunk"] = "altChunk";
})($68b4bc55b173684a$var$DomType || ($68b4bc55b173684a$var$DomType = {}));
class $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(){
        this.children = [];
        this.cssStyle = {};
    }
}
class $68b4bc55b173684a$var$WmlHeader extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.Header;
    }
}
class $68b4bc55b173684a$var$WmlFooter extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.Footer;
    }
}
class $68b4bc55b173684a$var$BaseHeaderFooterPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
    parseXml(root) {
        this.rootElement = this.createRootElement();
        this.rootElement.children = this._documentParser.parseBodyElements(root);
    }
}
class $68b4bc55b173684a$var$HeaderPart extends $68b4bc55b173684a$var$BaseHeaderFooterPart {
    createRootElement() {
        return new $68b4bc55b173684a$var$WmlHeader();
    }
}
class $68b4bc55b173684a$var$FooterPart extends $68b4bc55b173684a$var$BaseHeaderFooterPart {
    createRootElement() {
        return new $68b4bc55b173684a$var$WmlFooter();
    }
}
function $68b4bc55b173684a$var$parseExtendedProps(root, xmlParser) {
    const result = {};
    for (let el of xmlParser.elements(root))switch(el.localName){
        case "Template":
            result.template = el.textContent;
            break;
        case "Pages":
            result.pages = $68b4bc55b173684a$var$safeParseToInt(el.textContent);
            break;
        case "Words":
            result.words = $68b4bc55b173684a$var$safeParseToInt(el.textContent);
            break;
        case "Characters":
            result.characters = $68b4bc55b173684a$var$safeParseToInt(el.textContent);
            break;
        case "Application":
            result.application = el.textContent;
            break;
        case "Lines":
            result.lines = $68b4bc55b173684a$var$safeParseToInt(el.textContent);
            break;
        case "Paragraphs":
            result.paragraphs = $68b4bc55b173684a$var$safeParseToInt(el.textContent);
            break;
        case "Company":
            result.company = el.textContent;
            break;
        case "AppVersion":
            result.appVersion = el.textContent;
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$safeParseToInt(value) {
    if (typeof value === 'undefined') return;
    return parseInt(value);
}
class $68b4bc55b173684a$var$ExtendedPropsPart extends $68b4bc55b173684a$var$Part {
    parseXml(root) {
        this.props = $68b4bc55b173684a$var$parseExtendedProps(root, this._package.xmlParser);
    }
}
function $68b4bc55b173684a$var$parseCoreProps(root, xmlParser) {
    const result = {};
    for (let el of xmlParser.elements(root))switch(el.localName){
        case "title":
            result.title = el.textContent;
            break;
        case "description":
            result.description = el.textContent;
            break;
        case "subject":
            result.subject = el.textContent;
            break;
        case "creator":
            result.creator = el.textContent;
            break;
        case "keywords":
            result.keywords = el.textContent;
            break;
        case "language":
            result.language = el.textContent;
            break;
        case "lastModifiedBy":
            result.lastModifiedBy = el.textContent;
            break;
        case "revision":
            el.textContent && (result.revision = parseInt(el.textContent));
            break;
    }
    return result;
}
class $68b4bc55b173684a$var$CorePropsPart extends $68b4bc55b173684a$var$Part {
    parseXml(root) {
        this.props = $68b4bc55b173684a$var$parseCoreProps(root, this._package.xmlParser);
    }
}
class $68b4bc55b173684a$var$DmlTheme {
}
function $68b4bc55b173684a$var$parseTheme(elem, xml) {
    var result = new $68b4bc55b173684a$var$DmlTheme();
    var themeElements = xml.element(elem, "themeElements");
    for (let el of xml.elements(themeElements))switch(el.localName){
        case "clrScheme":
            result.colorScheme = $68b4bc55b173684a$var$parseColorScheme(el, xml);
            break;
        case "fontScheme":
            result.fontScheme = $68b4bc55b173684a$var$parseFontScheme(el, xml);
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseColorScheme(elem, xml) {
    var result = {
        name: xml.attr(elem, "name"),
        colors: {}
    };
    for (let el of xml.elements(elem)){
        var srgbClr = xml.element(el, "srgbClr");
        var sysClr = xml.element(el, "sysClr");
        if (srgbClr) result.colors[el.localName] = xml.attr(srgbClr, "val");
        else if (sysClr) result.colors[el.localName] = xml.attr(sysClr, "lastClr");
    }
    return result;
}
function $68b4bc55b173684a$var$parseFontScheme(elem, xml) {
    var result = {
        name: xml.attr(elem, "name")
    };
    for (let el of xml.elements(elem))switch(el.localName){
        case "majorFont":
            result.majorFont = $68b4bc55b173684a$var$parseFontInfo(el, xml);
            break;
        case "minorFont":
            result.minorFont = $68b4bc55b173684a$var$parseFontInfo(el, xml);
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseFontInfo(elem, xml) {
    return {
        latinTypeface: xml.elementAttr(elem, "latin", "typeface"),
        eaTypeface: xml.elementAttr(elem, "ea", "typeface"),
        csTypeface: xml.elementAttr(elem, "cs", "typeface")
    };
}
class $68b4bc55b173684a$var$ThemePart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path){
        super(pkg, path);
    }
    parseXml(root) {
        this.theme = $68b4bc55b173684a$var$parseTheme(root, this._package.xmlParser);
    }
}
class $68b4bc55b173684a$var$WmlBaseNote {
}
class $68b4bc55b173684a$var$WmlFootnote extends $68b4bc55b173684a$var$WmlBaseNote {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.Footnote;
    }
}
class $68b4bc55b173684a$var$WmlEndnote extends $68b4bc55b173684a$var$WmlBaseNote {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.Endnote;
    }
}
class $68b4bc55b173684a$var$BaseNotePart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
}
class $68b4bc55b173684a$var$FootnotesPart extends $68b4bc55b173684a$var$BaseNotePart {
    constructor(pkg, path, parser){
        super(pkg, path, parser);
    }
    parseXml(root) {
        this.notes = this._documentParser.parseNotes(root, "footnote", $68b4bc55b173684a$var$WmlFootnote);
    }
}
class $68b4bc55b173684a$var$EndnotesPart extends $68b4bc55b173684a$var$BaseNotePart {
    constructor(pkg, path, parser){
        super(pkg, path, parser);
    }
    parseXml(root) {
        this.notes = this._documentParser.parseNotes(root, "endnote", $68b4bc55b173684a$var$WmlEndnote);
    }
}
function $68b4bc55b173684a$var$parseSettings(elem, xml) {
    var result = {};
    for (let el of xml.elements(elem))switch(el.localName){
        case "defaultTabStop":
            result.defaultTabStop = xml.lengthAttr(el, "val");
            break;
        case "footnotePr":
            result.footnoteProps = $68b4bc55b173684a$var$parseNoteProperties(el, xml);
            break;
        case "endnotePr":
            result.endnoteProps = $68b4bc55b173684a$var$parseNoteProperties(el, xml);
            break;
        case "autoHyphenation":
            result.autoHyphenation = xml.boolAttr(el, "val");
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseNoteProperties(elem, xml) {
    var result = {
        defaultNoteIds: []
    };
    for (let el of xml.elements(elem))switch(el.localName){
        case "numFmt":
            result.nummeringFormat = xml.attr(el, "val");
            break;
        case "footnote":
        case "endnote":
            result.defaultNoteIds.push(xml.attr(el, "id"));
            break;
    }
    return result;
}
class $68b4bc55b173684a$var$SettingsPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path){
        super(pkg, path);
    }
    parseXml(root) {
        this.settings = $68b4bc55b173684a$var$parseSettings(root, this._package.xmlParser);
    }
}
function $68b4bc55b173684a$var$parseCustomProps(root, xml) {
    return xml.elements(root, "property").map((e)=>{
        const firstChild = e.firstChild;
        return {
            formatId: xml.attr(e, "fmtid"),
            name: xml.attr(e, "name"),
            type: firstChild.nodeName,
            value: firstChild.textContent
        };
    });
}
class $68b4bc55b173684a$var$CustomPropsPart extends $68b4bc55b173684a$var$Part {
    parseXml(root) {
        this.props = $68b4bc55b173684a$var$parseCustomProps(root, this._package.xmlParser);
    }
}
class $68b4bc55b173684a$var$CommentsPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path, parser){
        super(pkg, path);
        this._documentParser = parser;
    }
    parseXml(root) {
        this.comments = this._documentParser.parseComments(root);
        this.commentMap = $68b4bc55b173684a$var$keyBy(this.comments, (x)=>x.id);
    }
}
class $68b4bc55b173684a$var$CommentsExtendedPart extends $68b4bc55b173684a$var$Part {
    constructor(pkg, path){
        super(pkg, path);
        this.comments = [];
    }
    parseXml(root) {
        const xml = this._package.xmlParser;
        for (let el of xml.elements(root, "commentEx"))this.comments.push({
            paraId: xml.attr(el, 'paraId'),
            paraIdParent: xml.attr(el, 'paraIdParent'),
            done: xml.boolAttr(el, 'done')
        });
        this.commentMap = $68b4bc55b173684a$var$keyBy(this.comments, (x)=>x.paraId);
    }
}
const $68b4bc55b173684a$var$topLevelRels = [
    {
        type: $68b4bc55b173684a$var$RelationshipTypes.OfficeDocument,
        target: "word/document.xml"
    },
    {
        type: $68b4bc55b173684a$var$RelationshipTypes.ExtendedProperties,
        target: "docProps/app.xml"
    },
    {
        type: $68b4bc55b173684a$var$RelationshipTypes.CoreProperties,
        target: "docProps/core.xml"
    },
    {
        type: $68b4bc55b173684a$var$RelationshipTypes.CustomProperties,
        target: "docProps/custom.xml"
    }
];
class $68b4bc55b173684a$var$WordDocument {
    constructor(){
        this.parts = [];
        this.partsMap = {};
    }
    static async load(blob, parser, options) {
        var d = new $68b4bc55b173684a$var$WordDocument();
        d._options = options;
        d._parser = parser;
        d._package = await $68b4bc55b173684a$var$OpenXmlPackage.load(blob, options);
        d.rels = await d._package.loadRelationships();
        await Promise.all($68b4bc55b173684a$var$topLevelRels.map((rel)=>{
            const r = d.rels.find((x)=>x.type === rel.type) ?? rel;
            return d.loadRelationshipPart(r.target, r.type);
        }));
        return d;
    }
    save(type = "blob") {
        return this._package.save(type);
    }
    async loadRelationshipPart(path, type) {
        if (this.partsMap[path]) return this.partsMap[path];
        if (!this._package.get(path)) return null;
        let part = null;
        switch(type){
            case $68b4bc55b173684a$var$RelationshipTypes.OfficeDocument:
                this.documentPart = part = new $68b4bc55b173684a$var$DocumentPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.FontTable:
                this.fontTablePart = part = new $68b4bc55b173684a$var$FontTablePart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Numbering:
                this.numberingPart = part = new $68b4bc55b173684a$var$NumberingPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Styles:
                this.stylesPart = part = new $68b4bc55b173684a$var$StylesPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Theme:
                this.themePart = part = new $68b4bc55b173684a$var$ThemePart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Footnotes:
                this.footnotesPart = part = new $68b4bc55b173684a$var$FootnotesPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Endnotes:
                this.endnotesPart = part = new $68b4bc55b173684a$var$EndnotesPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Footer:
                part = new $68b4bc55b173684a$var$FooterPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Header:
                part = new $68b4bc55b173684a$var$HeaderPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.CoreProperties:
                this.corePropsPart = part = new $68b4bc55b173684a$var$CorePropsPart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.ExtendedProperties:
                this.extendedPropsPart = part = new $68b4bc55b173684a$var$ExtendedPropsPart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.CustomProperties:
                part = new $68b4bc55b173684a$var$CustomPropsPart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Settings:
                this.settingsPart = part = new $68b4bc55b173684a$var$SettingsPart(this._package, path);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.Comments:
                this.commentsPart = part = new $68b4bc55b173684a$var$CommentsPart(this._package, path, this._parser);
                break;
            case $68b4bc55b173684a$var$RelationshipTypes.CommentsExtended:
                this.commentsExtendedPart = part = new $68b4bc55b173684a$var$CommentsExtendedPart(this._package, path);
                break;
        }
        if (part == null) return Promise.resolve(null);
        this.partsMap[path] = part;
        this.parts.push(part);
        await part.load();
        if (part.rels?.length > 0) {
            const [folder] = $68b4bc55b173684a$var$splitPath(part.path);
            await Promise.all(part.rels.map((rel)=>this.loadRelationshipPart($68b4bc55b173684a$var$resolvePath(rel.target, folder), rel.type)));
        }
        return part;
    }
    async loadDocumentImage(id, part) {
        const x = await this.loadResource(part ?? this.documentPart, id, "blob");
        return this.blobToURL(x);
    }
    async loadNumberingImage(id) {
        const x = await this.loadResource(this.numberingPart, id, "blob");
        return this.blobToURL(x);
    }
    async loadFont(id, key) {
        const x = await this.loadResource(this.fontTablePart, id, "uint8array");
        return x ? this.blobToURL(new Blob([
            $68b4bc55b173684a$var$deobfuscate(x, key)
        ])) : x;
    }
    async loadAltChunk(id, part) {
        return await this.loadResource(part ?? this.documentPart, id, "string");
    }
    blobToURL(blob) {
        if (!blob) return null;
        if (this._options.useBase64URL) return $68b4bc55b173684a$var$blobToBase64(blob);
        return URL.createObjectURL(blob);
    }
    findPartByRelId(id, basePart = null) {
        var rel = (basePart.rels ?? this.rels).find((r)=>r.id == id);
        const folder = basePart ? $68b4bc55b173684a$var$splitPath(basePart.path)[0] : '';
        return rel ? this.partsMap[$68b4bc55b173684a$var$resolvePath(rel.target, folder)] : null;
    }
    getPathById(part, id) {
        const rel = part.rels.find((x)=>x.id == id);
        const [folder] = $68b4bc55b173684a$var$splitPath(part.path);
        return rel ? $68b4bc55b173684a$var$resolvePath(rel.target, folder) : null;
    }
    loadResource(part, id, outputType) {
        const path = this.getPathById(part, id);
        return path ? this._package.load(path, outputType) : Promise.resolve(null);
    }
}
function $68b4bc55b173684a$var$deobfuscate(data, guidKey) {
    const len = 16;
    const trimmed = guidKey.replace(/{|}|-/g, "");
    const numbers = new Array(len);
    for(let i = 0; i < len; i++)numbers[len - i - 1] = parseInt(trimmed.substring(i * 2, i * 2 + 2), 16);
    for(let i = 0; i < 32; i++)data[i] = data[i] ^ numbers[i % len];
    return data;
}
function $68b4bc55b173684a$var$parseBookmarkStart(elem, xml) {
    return {
        type: $68b4bc55b173684a$var$DomType.BookmarkStart,
        id: xml.attr(elem, "id"),
        name: xml.attr(elem, "name"),
        colFirst: xml.intAttr(elem, "colFirst"),
        colLast: xml.intAttr(elem, "colLast")
    };
}
function $68b4bc55b173684a$var$parseBookmarkEnd(elem, xml) {
    return {
        type: $68b4bc55b173684a$var$DomType.BookmarkEnd,
        id: xml.attr(elem, "id")
    };
}
class $68b4bc55b173684a$var$VmlElement extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.VmlElement;
        this.attrs = {};
    }
}
function $68b4bc55b173684a$var$parseVmlElement(elem, parser) {
    var result = new $68b4bc55b173684a$var$VmlElement();
    switch(elem.localName){
        case "rect":
            result.tagName = "rect";
            Object.assign(result.attrs, {
                width: '100%',
                height: '100%'
            });
            break;
        case "oval":
            result.tagName = "ellipse";
            Object.assign(result.attrs, {
                cx: "50%",
                cy: "50%",
                rx: "50%",
                ry: "50%"
            });
            break;
        case "line":
            result.tagName = "line";
            break;
        case "shape":
            result.tagName = "g";
            break;
        case "textbox":
            result.tagName = "foreignObject";
            Object.assign(result.attrs, {
                width: '100%',
                height: '100%'
            });
            break;
        default:
            return null;
    }
    for (const at of $68b4bc55b173684a$var$globalXmlParser.attrs(elem))switch(at.localName){
        case "style":
            result.cssStyleText = at.value;
            break;
        case "fillcolor":
            result.attrs.fill = at.value;
            break;
        case "from":
            const [x1, y1] = $68b4bc55b173684a$var$parsePoint(at.value);
            Object.assign(result.attrs, {
                x1: x1,
                y1: y1
            });
            break;
        case "to":
            const [x2, y2] = $68b4bc55b173684a$var$parsePoint(at.value);
            Object.assign(result.attrs, {
                x2: x2,
                y2: y2
            });
            break;
    }
    for (const el of $68b4bc55b173684a$var$globalXmlParser.elements(elem))switch(el.localName){
        case "stroke":
            Object.assign(result.attrs, $68b4bc55b173684a$var$parseStroke(el));
            break;
        case "fill":
            Object.assign(result.attrs, $68b4bc55b173684a$var$parseFill());
            break;
        case "imagedata":
            result.tagName = "image";
            Object.assign(result.attrs, {
                width: '100%',
                height: '100%'
            });
            result.imageHref = {
                id: $68b4bc55b173684a$var$globalXmlParser.attr(el, "id"),
                title: $68b4bc55b173684a$var$globalXmlParser.attr(el, "title")
            };
            break;
        case "txbxContent":
            result.children.push(...parser.parseBodyElements(el));
            break;
        default:
            const child = $68b4bc55b173684a$var$parseVmlElement(el, parser);
            child && result.children.push(child);
            break;
    }
    return result;
}
function $68b4bc55b173684a$var$parseStroke(el) {
    return {
        'stroke': $68b4bc55b173684a$var$globalXmlParser.attr(el, "color"),
        'stroke-width': $68b4bc55b173684a$var$globalXmlParser.lengthAttr(el, "weight", $68b4bc55b173684a$var$LengthUsage.Emu) ?? '1px'
    };
}
function $68b4bc55b173684a$var$parseFill(el) {
    return {};
}
function $68b4bc55b173684a$var$parsePoint(val) {
    return val.split(",");
}
class $68b4bc55b173684a$var$WmlComment extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(){
        super(...arguments);
        this.type = $68b4bc55b173684a$var$DomType.Comment;
    }
}
class $68b4bc55b173684a$var$WmlCommentReference extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(id){
        super();
        this.id = id;
        this.type = $68b4bc55b173684a$var$DomType.CommentReference;
    }
}
class $68b4bc55b173684a$var$WmlCommentRangeStart extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(id){
        super();
        this.id = id;
        this.type = $68b4bc55b173684a$var$DomType.CommentRangeStart;
    }
}
class $68b4bc55b173684a$var$WmlCommentRangeEnd extends $68b4bc55b173684a$var$OpenXmlElementBase {
    constructor(id){
        super();
        this.id = id;
        this.type = $68b4bc55b173684a$var$DomType.CommentRangeEnd;
    }
}
var $68b4bc55b173684a$var$autos = {
    shd: "inherit",
    color: "black",
    borderColor: "black",
    highlight: "transparent"
};
const $68b4bc55b173684a$var$supportedNamespaceURIs = [];
const $68b4bc55b173684a$var$mmlTagMap = {
    "oMath": $68b4bc55b173684a$var$DomType.MmlMath,
    "oMathPara": $68b4bc55b173684a$var$DomType.MmlMathParagraph,
    "f": $68b4bc55b173684a$var$DomType.MmlFraction,
    "func": $68b4bc55b173684a$var$DomType.MmlFunction,
    "fName": $68b4bc55b173684a$var$DomType.MmlFunctionName,
    "num": $68b4bc55b173684a$var$DomType.MmlNumerator,
    "den": $68b4bc55b173684a$var$DomType.MmlDenominator,
    "rad": $68b4bc55b173684a$var$DomType.MmlRadical,
    "deg": $68b4bc55b173684a$var$DomType.MmlDegree,
    "e": $68b4bc55b173684a$var$DomType.MmlBase,
    "sSup": $68b4bc55b173684a$var$DomType.MmlSuperscript,
    "sSub": $68b4bc55b173684a$var$DomType.MmlSubscript,
    "sPre": $68b4bc55b173684a$var$DomType.MmlPreSubSuper,
    "sup": $68b4bc55b173684a$var$DomType.MmlSuperArgument,
    "sub": $68b4bc55b173684a$var$DomType.MmlSubArgument,
    "d": $68b4bc55b173684a$var$DomType.MmlDelimiter,
    "nary": $68b4bc55b173684a$var$DomType.MmlNary,
    "eqArr": $68b4bc55b173684a$var$DomType.MmlEquationArray,
    "lim": $68b4bc55b173684a$var$DomType.MmlLimit,
    "limLow": $68b4bc55b173684a$var$DomType.MmlLimitLower,
    "m": $68b4bc55b173684a$var$DomType.MmlMatrix,
    "mr": $68b4bc55b173684a$var$DomType.MmlMatrixRow,
    "box": $68b4bc55b173684a$var$DomType.MmlBox,
    "bar": $68b4bc55b173684a$var$DomType.MmlBar,
    "groupChr": $68b4bc55b173684a$var$DomType.MmlGroupChar
};
class $68b4bc55b173684a$var$DocumentParser {
    constructor(options){
        this.options = {
            ignoreWidth: false,
            debug: false,
            ...options
        };
    }
    parseNotes(xmlDoc, elemName, elemClass) {
        var result = [];
        for (let el of $68b4bc55b173684a$var$globalXmlParser.elements(xmlDoc, elemName)){
            const node = new elemClass();
            node.id = $68b4bc55b173684a$var$globalXmlParser.attr(el, "id");
            node.noteType = $68b4bc55b173684a$var$globalXmlParser.attr(el, "type");
            node.children = this.parseBodyElements(el);
            result.push(node);
        }
        return result;
    }
    parseComments(xmlDoc) {
        var result = [];
        for (let el of $68b4bc55b173684a$var$globalXmlParser.elements(xmlDoc, "comment")){
            const item = new $68b4bc55b173684a$var$WmlComment();
            item.id = $68b4bc55b173684a$var$globalXmlParser.attr(el, "id");
            item.author = $68b4bc55b173684a$var$globalXmlParser.attr(el, "author");
            item.initials = $68b4bc55b173684a$var$globalXmlParser.attr(el, "initials");
            item.date = $68b4bc55b173684a$var$globalXmlParser.attr(el, "date");
            item.children = this.parseBodyElements(el);
            result.push(item);
        }
        return result;
    }
    parseDocumentFile(xmlDoc) {
        var xbody = $68b4bc55b173684a$var$globalXmlParser.element(xmlDoc, "body");
        var background = $68b4bc55b173684a$var$globalXmlParser.element(xmlDoc, "background");
        var sectPr = $68b4bc55b173684a$var$globalXmlParser.element(xbody, "sectPr");
        return {
            type: $68b4bc55b173684a$var$DomType.Document,
            children: this.parseBodyElements(xbody),
            props: sectPr ? $68b4bc55b173684a$var$parseSectionProperties(sectPr, $68b4bc55b173684a$var$globalXmlParser) : {},
            cssStyle: background ? this.parseBackground(background) : {}
        };
    }
    parseBackground(elem) {
        var result = {};
        var color = $68b4bc55b173684a$var$xmlUtil.colorAttr(elem, "color");
        if (color) result["background-color"] = color;
        return result;
    }
    parseBodyElements(element) {
        var children = [];
        for (const elem of $68b4bc55b173684a$var$globalXmlParser.elements(element))switch(elem.localName){
            case "p":
                children.push(this.parseParagraph(elem));
                break;
            case "altChunk":
                children.push(this.parseAltChunk(elem));
                break;
            case "tbl":
                children.push(this.parseTable(elem));
                break;
            case "sdt":
                children.push(...this.parseSdt(elem, (e)=>this.parseBodyElements(e)));
                break;
        }
        return children;
    }
    parseStylesFile(xstyles) {
        var result = [];
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(xstyles))switch(n.localName){
            case "style":
                result.push(this.parseStyle(n));
                break;
            case "docDefaults":
                result.push(this.parseDefaultStyles(n));
                break;
        }
        return result;
    }
    parseDefaultStyles(node) {
        var result = {
            id: null,
            name: null,
            target: null,
            basedOn: null,
            styles: []
        };
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "rPrDefault":
                var rPr = $68b4bc55b173684a$var$globalXmlParser.element(c, "rPr");
                if (rPr) result.styles.push({
                    target: "span",
                    values: this.parseDefaultProperties(rPr, {})
                });
                break;
            case "pPrDefault":
                var pPr = $68b4bc55b173684a$var$globalXmlParser.element(c, "pPr");
                if (pPr) result.styles.push({
                    target: "p",
                    values: this.parseDefaultProperties(pPr, {})
                });
                break;
        }
        return result;
    }
    parseStyle(node) {
        var result = {
            id: $68b4bc55b173684a$var$globalXmlParser.attr(node, "styleId"),
            isDefault: $68b4bc55b173684a$var$globalXmlParser.boolAttr(node, "default"),
            name: null,
            target: null,
            basedOn: null,
            styles: [],
            linked: null
        };
        switch($68b4bc55b173684a$var$globalXmlParser.attr(node, "type")){
            case "paragraph":
                result.target = "p";
                break;
            case "table":
                result.target = "table";
                break;
            case "character":
                result.target = "span";
                break;
        }
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "basedOn":
                result.basedOn = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "name":
                result.name = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "link":
                result.linked = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "next":
                result.next = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "aliases":
                result.aliases = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val").split(",");
                break;
            case "pPr":
                result.styles.push({
                    target: "p",
                    values: this.parseDefaultProperties(n, {})
                });
                result.paragraphProps = $68b4bc55b173684a$var$parseParagraphProperties(n, $68b4bc55b173684a$var$globalXmlParser);
                break;
            case "rPr":
                result.styles.push({
                    target: "span",
                    values: this.parseDefaultProperties(n, {})
                });
                result.runProps = $68b4bc55b173684a$var$parseRunProperties(n, $68b4bc55b173684a$var$globalXmlParser);
                break;
            case "tblPr":
            case "tcPr":
                result.styles.push({
                    target: "td",
                    values: this.parseDefaultProperties(n, {})
                });
                break;
            case "tblStylePr":
                for (let s of this.parseTableStyle(n))result.styles.push(s);
                break;
            case "rsid":
            case "qFormat":
            case "hidden":
            case "semiHidden":
            case "unhideWhenUsed":
            case "autoRedefine":
            case "uiPriority":
                break;
            default:
                this.options.debug && console.warn(`DOCX: Unknown style element: ${n.localName}`);
        }
        return result;
    }
    parseTableStyle(node) {
        var result = [];
        var type = $68b4bc55b173684a$var$globalXmlParser.attr(node, "type");
        var selector = "";
        var modificator = "";
        switch(type){
            case "firstRow":
                modificator = ".first-row";
                selector = "tr.first-row td";
                break;
            case "lastRow":
                modificator = ".last-row";
                selector = "tr.last-row td";
                break;
            case "firstCol":
                modificator = ".first-col";
                selector = "td.first-col";
                break;
            case "lastCol":
                modificator = ".last-col";
                selector = "td.last-col";
                break;
            case "band1Vert":
                modificator = ":not(.no-vband)";
                selector = "td.odd-col";
                break;
            case "band2Vert":
                modificator = ":not(.no-vband)";
                selector = "td.even-col";
                break;
            case "band1Horz":
                modificator = ":not(.no-hband)";
                selector = "tr.odd-row";
                break;
            case "band2Horz":
                modificator = ":not(.no-hband)";
                selector = "tr.even-row";
                break;
            default:
                return [];
        }
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "pPr":
                result.push({
                    target: `${selector} p`,
                    mod: modificator,
                    values: this.parseDefaultProperties(n, {})
                });
                break;
            case "rPr":
                result.push({
                    target: `${selector} span`,
                    mod: modificator,
                    values: this.parseDefaultProperties(n, {})
                });
                break;
            case "tblPr":
            case "tcPr":
                result.push({
                    target: selector,
                    mod: modificator,
                    values: this.parseDefaultProperties(n, {})
                });
                break;
        }
        return result;
    }
    parseNumberingFile(node) {
        var result = [];
        var mapping = {};
        var bullets = [];
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "abstractNum":
                this.parseAbstractNumbering(n, bullets).forEach((x)=>result.push(x));
                break;
            case "numPicBullet":
                bullets.push(this.parseNumberingPicBullet(n));
                break;
            case "num":
                var numId = $68b4bc55b173684a$var$globalXmlParser.attr(n, "numId");
                var abstractNumId = $68b4bc55b173684a$var$globalXmlParser.elementAttr(n, "abstractNumId", "val");
                mapping[abstractNumId] = numId;
                break;
        }
        result.forEach((x)=>x.id = mapping[x.id]);
        return result;
    }
    parseNumberingPicBullet(elem) {
        var pict = $68b4bc55b173684a$var$globalXmlParser.element(elem, "pict");
        var shape = pict && $68b4bc55b173684a$var$globalXmlParser.element(pict, "shape");
        var imagedata = shape && $68b4bc55b173684a$var$globalXmlParser.element(shape, "imagedata");
        return imagedata ? {
            id: $68b4bc55b173684a$var$globalXmlParser.intAttr(elem, "numPicBulletId"),
            src: $68b4bc55b173684a$var$globalXmlParser.attr(imagedata, "id"),
            style: $68b4bc55b173684a$var$globalXmlParser.attr(shape, "style")
        } : null;
    }
    parseAbstractNumbering(node, bullets) {
        var result = [];
        var id = $68b4bc55b173684a$var$globalXmlParser.attr(node, "abstractNumId");
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "lvl":
                result.push(this.parseNumberingLevel(id, n, bullets));
                break;
        }
        return result;
    }
    parseNumberingLevel(id, node, bullets) {
        var result = {
            id: id,
            level: $68b4bc55b173684a$var$globalXmlParser.intAttr(node, "ilvl"),
            start: 1,
            pStyleName: undefined,
            pStyle: {},
            rStyle: {},
            suff: "tab"
        };
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "start":
                result.start = $68b4bc55b173684a$var$globalXmlParser.intAttr(n, "val");
                break;
            case "pPr":
                this.parseDefaultProperties(n, result.pStyle);
                break;
            case "rPr":
                this.parseDefaultProperties(n, result.rStyle);
                break;
            case "lvlPicBulletId":
                var bulletId = $68b4bc55b173684a$var$globalXmlParser.intAttr(n, "val");
                result.bullet = bullets.find((x)=>x?.id == bulletId);
                break;
            case "lvlText":
                result.levelText = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "pStyle":
                result.pStyleName = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "numFmt":
                result.format = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
            case "suff":
                result.suff = $68b4bc55b173684a$var$globalXmlParser.attr(n, "val");
                break;
        }
        return result;
    }
    parseSdt(node, parser) {
        const sdtContent = $68b4bc55b173684a$var$globalXmlParser.element(node, "sdtContent");
        return sdtContent ? parser(sdtContent) : [];
    }
    parseInserted(node, parentParser) {
        return {
            type: $68b4bc55b173684a$var$DomType.Inserted,
            children: parentParser(node)?.children ?? []
        };
    }
    parseDeleted(node, parentParser) {
        return {
            type: $68b4bc55b173684a$var$DomType.Deleted,
            children: parentParser(node)?.children ?? []
        };
    }
    parseAltChunk(node) {
        return {
            type: $68b4bc55b173684a$var$DomType.AltChunk,
            children: [],
            id: $68b4bc55b173684a$var$globalXmlParser.attr(node, "id")
        };
    }
    parseParagraph(node) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Paragraph,
            children: []
        };
        for (let el of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(el.localName){
            case "pPr":
                this.parseParagraphProperties(el, result);
                break;
            case "r":
                result.children.push(this.parseRun(el, result));
                break;
            case "hyperlink":
                result.children.push(this.parseHyperlink(el, result));
                break;
            case "smartTag":
                result.children.push(this.parseSmartTag(el, result));
                break;
            case "bookmarkStart":
                result.children.push($68b4bc55b173684a$var$parseBookmarkStart(el, $68b4bc55b173684a$var$globalXmlParser));
                break;
            case "bookmarkEnd":
                result.children.push($68b4bc55b173684a$var$parseBookmarkEnd(el, $68b4bc55b173684a$var$globalXmlParser));
                break;
            case "commentRangeStart":
                result.children.push(new $68b4bc55b173684a$var$WmlCommentRangeStart($68b4bc55b173684a$var$globalXmlParser.attr(el, "id")));
                break;
            case "commentRangeEnd":
                result.children.push(new $68b4bc55b173684a$var$WmlCommentRangeEnd($68b4bc55b173684a$var$globalXmlParser.attr(el, "id")));
                break;
            case "oMath":
            case "oMathPara":
                result.children.push(this.parseMathElement(el));
                break;
            case "sdt":
                result.children.push(...this.parseSdt(el, (e)=>this.parseParagraph(e).children));
                break;
            case "ins":
                result.children.push(this.parseInserted(el, (e)=>this.parseParagraph(e)));
                break;
            case "del":
                result.children.push(this.parseDeleted(el, (e)=>this.parseParagraph(e)));
                break;
        }
        return result;
    }
    parseParagraphProperties(elem, paragraph) {
        this.parseDefaultProperties(elem, paragraph.cssStyle = {}, null, (c)=>{
            if ($68b4bc55b173684a$var$parseParagraphProperty(c, paragraph, $68b4bc55b173684a$var$globalXmlParser)) return true;
            switch(c.localName){
                case "pStyle":
                    paragraph.styleName = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
                    break;
                case "cnfStyle":
                    paragraph.className = $68b4bc55b173684a$var$values.classNameOfCnfStyle(c);
                    break;
                case "framePr":
                    this.parseFrame(c, paragraph);
                    break;
                case "rPr":
                    break;
                default:
                    return false;
            }
            return true;
        });
    }
    parseFrame(node, paragraph) {
        var dropCap = $68b4bc55b173684a$var$globalXmlParser.attr(node, "dropCap");
        if (dropCap == "drop") paragraph.cssStyle["float"] = "left";
    }
    parseHyperlink(node, parent) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Hyperlink,
            parent: parent,
            children: []
        };
        result.anchor = $68b4bc55b173684a$var$globalXmlParser.attr(node, "anchor");
        result.id = $68b4bc55b173684a$var$globalXmlParser.attr(node, "id");
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "r":
                result.children.push(this.parseRun(c, result));
                break;
        }
        return result;
    }
    parseSmartTag(node, parent) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.SmartTag,
            parent: parent,
            children: []
        };
        var uri = $68b4bc55b173684a$var$globalXmlParser.attr(node, "uri");
        var element = $68b4bc55b173684a$var$globalXmlParser.attr(node, "element");
        if (uri) result.uri = uri;
        if (element) result.element = element;
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "r":
                result.children.push(this.parseRun(c, result));
                break;
        }
        return result;
    }
    parseRun(node, parent) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Run,
            parent: parent,
            children: []
        };
        for (let c of $68b4bc55b173684a$var$globalXmlParser.elements(node)){
            c = this.checkAlternateContent(c);
            switch(c.localName){
                case "t":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Text,
                        text: c.textContent
                    });
                    break;
                case "delText":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.DeletedText,
                        text: c.textContent
                    });
                    break;
                case "commentReference":
                    result.children.push(new $68b4bc55b173684a$var$WmlCommentReference($68b4bc55b173684a$var$globalXmlParser.attr(c, "id")));
                    break;
                case "fldSimple":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.SimpleField,
                        instruction: $68b4bc55b173684a$var$globalXmlParser.attr(c, "instr"),
                        lock: $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "lock", false),
                        dirty: $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "dirty", false)
                    });
                    break;
                case "instrText":
                    result.fieldRun = true;
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Instruction,
                        text: c.textContent
                    });
                    break;
                case "fldChar":
                    result.fieldRun = true;
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.ComplexField,
                        charType: $68b4bc55b173684a$var$globalXmlParser.attr(c, "fldCharType"),
                        lock: $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "lock", false),
                        dirty: $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "dirty", false)
                    });
                    break;
                case "noBreakHyphen":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.NoBreakHyphen
                    });
                    break;
                case "br":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Break,
                        break: $68b4bc55b173684a$var$globalXmlParser.attr(c, "type") || "textWrapping"
                    });
                    break;
                case "lastRenderedPageBreak":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Break,
                        break: "lastRenderedPageBreak"
                    });
                    break;
                case "sym":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Symbol,
                        font: $68b4bc55b173684a$var$encloseFontFamily($68b4bc55b173684a$var$globalXmlParser.attr(c, "font")),
                        char: $68b4bc55b173684a$var$globalXmlParser.attr(c, "char")
                    });
                    break;
                case "tab":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.Tab
                    });
                    break;
                case "footnoteReference":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.FootnoteReference,
                        id: $68b4bc55b173684a$var$globalXmlParser.attr(c, "id")
                    });
                    break;
                case "endnoteReference":
                    result.children.push({
                        type: $68b4bc55b173684a$var$DomType.EndnoteReference,
                        id: $68b4bc55b173684a$var$globalXmlParser.attr(c, "id")
                    });
                    break;
                case "drawing":
                    let d = this.parseDrawing(c);
                    if (d) result.children = [
                        d
                    ];
                    break;
                case "pict":
                    result.children.push(this.parseVmlPicture(c));
                    break;
                case "rPr":
                    this.parseRunProperties(c, result);
                    break;
            }
        }
        return result;
    }
    parseMathElement(elem) {
        const propsTag = `${elem.localName}Pr`;
        const result = {
            type: $68b4bc55b173684a$var$mmlTagMap[elem.localName],
            children: []
        };
        for (const el of $68b4bc55b173684a$var$globalXmlParser.elements(elem)){
            const childType = $68b4bc55b173684a$var$mmlTagMap[el.localName];
            if (childType) result.children.push(this.parseMathElement(el));
            else if (el.localName == "r") {
                var run = this.parseRun(el);
                run.type = $68b4bc55b173684a$var$DomType.MmlRun;
                result.children.push(run);
            } else if (el.localName == propsTag) result.props = this.parseMathProperies(el);
        }
        return result;
    }
    parseMathProperies(elem) {
        const result = {};
        for (const el of $68b4bc55b173684a$var$globalXmlParser.elements(elem))switch(el.localName){
            case "chr":
                result.char = $68b4bc55b173684a$var$globalXmlParser.attr(el, "val");
                break;
            case "vertJc":
                result.verticalJustification = $68b4bc55b173684a$var$globalXmlParser.attr(el, "val");
                break;
            case "pos":
                result.position = $68b4bc55b173684a$var$globalXmlParser.attr(el, "val");
                break;
            case "degHide":
                result.hideDegree = $68b4bc55b173684a$var$globalXmlParser.boolAttr(el, "val");
                break;
            case "begChr":
                result.beginChar = $68b4bc55b173684a$var$globalXmlParser.attr(el, "val");
                break;
            case "endChr":
                result.endChar = $68b4bc55b173684a$var$globalXmlParser.attr(el, "val");
                break;
        }
        return result;
    }
    parseRunProperties(elem, run) {
        this.parseDefaultProperties(elem, run.cssStyle = {}, null, (c)=>{
            switch(c.localName){
                case "rStyle":
                    run.styleName = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
                    break;
                case "vertAlign":
                    run.verticalAlign = $68b4bc55b173684a$var$values.valueOfVertAlign(c, true);
                    break;
                default:
                    return false;
            }
            return true;
        });
    }
    parseVmlPicture(elem) {
        const result = {
            type: $68b4bc55b173684a$var$DomType.VmlPicture,
            children: []
        };
        for (const el of $68b4bc55b173684a$var$globalXmlParser.elements(elem)){
            const child = $68b4bc55b173684a$var$parseVmlElement(el, this);
            child && result.children.push(child);
        }
        return result;
    }
    checkAlternateContent(elem) {
        if (elem.localName != 'AlternateContent') return elem;
        var choice = $68b4bc55b173684a$var$globalXmlParser.element(elem, "Choice");
        if (choice) {
            var requires = $68b4bc55b173684a$var$globalXmlParser.attr(choice, "Requires");
            var namespaceURI = elem.lookupNamespaceURI(requires);
            if ($68b4bc55b173684a$var$supportedNamespaceURIs.includes(namespaceURI)) return choice.firstElementChild;
        }
        return $68b4bc55b173684a$var$globalXmlParser.element(elem, "Fallback")?.firstElementChild;
    }
    parseDrawing(node) {
        for (var n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "inline":
            case "anchor":
                return this.parseDrawingWrapper(n);
        }
    }
    parseDrawingWrapper(node) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Drawing,
            children: [],
            cssStyle: {}
        };
        var isAnchor = node.localName == "anchor";
        let wrapType = null;
        let simplePos = $68b4bc55b173684a$var$globalXmlParser.boolAttr(node, "simplePos");
        $68b4bc55b173684a$var$globalXmlParser.boolAttr(node, "behindDoc");
        let posX = {
            relative: "page",
            align: "left",
            offset: "0"
        };
        let posY = {
            relative: "page",
            align: "top",
            offset: "0"
        };
        for (var n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "simplePos":
                if (simplePos) {
                    posX.offset = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "x", $68b4bc55b173684a$var$LengthUsage.Emu);
                    posY.offset = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "y", $68b4bc55b173684a$var$LengthUsage.Emu);
                }
                break;
            case "extent":
                result.cssStyle["width"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "cx", $68b4bc55b173684a$var$LengthUsage.Emu);
                result.cssStyle["height"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "cy", $68b4bc55b173684a$var$LengthUsage.Emu);
                break;
            case "positionH":
            case "positionV":
                if (!simplePos) {
                    let pos = n.localName == "positionH" ? posX : posY;
                    var alignNode = $68b4bc55b173684a$var$globalXmlParser.element(n, "align");
                    var offsetNode = $68b4bc55b173684a$var$globalXmlParser.element(n, "posOffset");
                    pos.relative = $68b4bc55b173684a$var$globalXmlParser.attr(n, "relativeFrom") ?? pos.relative;
                    if (alignNode) pos.align = alignNode.textContent;
                    if (offsetNode) pos.offset = $68b4bc55b173684a$var$convertLength(offsetNode.textContent, $68b4bc55b173684a$var$LengthUsage.Emu);
                }
                break;
            case "wrapTopAndBottom":
                wrapType = "wrapTopAndBottom";
                break;
            case "wrapNone":
                wrapType = "wrapNone";
                break;
            case "graphic":
                var g = this.parseGraphic(n);
                if (g) result.children.push(g);
                break;
        }
        if (wrapType == "wrapTopAndBottom") {
            result.cssStyle['display'] = 'block';
            if (posX.align) {
                result.cssStyle['text-align'] = posX.align;
                result.cssStyle['width'] = "100%";
            }
        } else if (wrapType == "wrapNone") {
            result.cssStyle['display'] = 'block';
            result.cssStyle['position'] = 'relative';
            result.cssStyle["width"] = "0px";
            result.cssStyle["height"] = "0px";
            if (posX.offset) result.cssStyle["left"] = posX.offset;
            if (posY.offset) result.cssStyle["top"] = posY.offset;
        } else if (isAnchor && (posX.align == 'left' || posX.align == 'right')) result.cssStyle["float"] = posX.align;
        return result;
    }
    parseGraphic(elem) {
        var graphicData = $68b4bc55b173684a$var$globalXmlParser.element(elem, "graphicData");
        for (let n of $68b4bc55b173684a$var$globalXmlParser.elements(graphicData))switch(n.localName){
            case "pic":
                return this.parsePicture(n);
        }
        return null;
    }
    parsePicture(elem) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Image,
            src: "",
            cssStyle: {}
        };
        var blipFill = $68b4bc55b173684a$var$globalXmlParser.element(elem, "blipFill");
        var blip = $68b4bc55b173684a$var$globalXmlParser.element(blipFill, "blip");
        var srcRect = $68b4bc55b173684a$var$globalXmlParser.element(blipFill, "srcRect");
        result.src = $68b4bc55b173684a$var$globalXmlParser.attr(blip, "embed");
        if (srcRect) result.srcRect = [
            $68b4bc55b173684a$var$globalXmlParser.intAttr(srcRect, "l", 0) / 100000,
            $68b4bc55b173684a$var$globalXmlParser.intAttr(srcRect, "t", 0) / 100000,
            $68b4bc55b173684a$var$globalXmlParser.intAttr(srcRect, "r", 0) / 100000,
            $68b4bc55b173684a$var$globalXmlParser.intAttr(srcRect, "b", 0) / 100000
        ];
        var spPr = $68b4bc55b173684a$var$globalXmlParser.element(elem, "spPr");
        var xfrm = $68b4bc55b173684a$var$globalXmlParser.element(spPr, "xfrm");
        result.cssStyle["position"] = "relative";
        if (xfrm) {
            result.rotation = $68b4bc55b173684a$var$globalXmlParser.intAttr(xfrm, "rot", 0) / 60000;
            for (var n of $68b4bc55b173684a$var$globalXmlParser.elements(xfrm))switch(n.localName){
                case "ext":
                    result.cssStyle["width"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "cx", $68b4bc55b173684a$var$LengthUsage.Emu);
                    result.cssStyle["height"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "cy", $68b4bc55b173684a$var$LengthUsage.Emu);
                    break;
                case "off":
                    result.cssStyle["left"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "x", $68b4bc55b173684a$var$LengthUsage.Emu);
                    result.cssStyle["top"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "y", $68b4bc55b173684a$var$LengthUsage.Emu);
                    break;
            }
        }
        return result;
    }
    parseTable(node) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Table,
            children: []
        };
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "tr":
                result.children.push(this.parseTableRow(c));
                break;
            case "tblGrid":
                result.columns = this.parseTableColumns(c);
                break;
            case "tblPr":
                this.parseTableProperties(c, result);
                break;
        }
        return result;
    }
    parseTableColumns(node) {
        var result = [];
        for (const n of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(n.localName){
            case "gridCol":
                result.push({
                    width: $68b4bc55b173684a$var$globalXmlParser.lengthAttr(n, "w")
                });
                break;
        }
        return result;
    }
    parseTableProperties(elem, table) {
        table.cssStyle = {};
        table.cellStyle = {};
        this.parseDefaultProperties(elem, table.cssStyle, table.cellStyle, (c)=>{
            switch(c.localName){
                case "tblStyle":
                    table.styleName = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
                    break;
                case "tblLook":
                    table.className = $68b4bc55b173684a$var$values.classNameOftblLook(c);
                    break;
                case "tblpPr":
                    this.parseTablePosition(c, table);
                    break;
                case "tblStyleColBandSize":
                    table.colBandSize = $68b4bc55b173684a$var$globalXmlParser.intAttr(c, "val");
                    break;
                case "tblStyleRowBandSize":
                    table.rowBandSize = $68b4bc55b173684a$var$globalXmlParser.intAttr(c, "val");
                    break;
                case "hidden":
                    table.cssStyle["display"] = "none";
                    break;
                default:
                    return false;
            }
            return true;
        });
        switch(table.cssStyle["text-align"]){
            case "center":
                delete table.cssStyle["text-align"];
                table.cssStyle["margin-left"] = "auto";
                table.cssStyle["margin-right"] = "auto";
                break;
            case "right":
                delete table.cssStyle["text-align"];
                table.cssStyle["margin-left"] = "auto";
                break;
        }
    }
    parseTablePosition(node, table) {
        var topFromText = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "topFromText");
        var bottomFromText = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "bottomFromText");
        var rightFromText = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "rightFromText");
        var leftFromText = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "leftFromText");
        table.cssStyle["float"] = 'left';
        table.cssStyle["margin-bottom"] = $68b4bc55b173684a$var$values.addSize(table.cssStyle["margin-bottom"], bottomFromText);
        table.cssStyle["margin-left"] = $68b4bc55b173684a$var$values.addSize(table.cssStyle["margin-left"], leftFromText);
        table.cssStyle["margin-right"] = $68b4bc55b173684a$var$values.addSize(table.cssStyle["margin-right"], rightFromText);
        table.cssStyle["margin-top"] = $68b4bc55b173684a$var$values.addSize(table.cssStyle["margin-top"], topFromText);
    }
    parseTableRow(node) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Row,
            children: []
        };
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "tc":
                result.children.push(this.parseTableCell(c));
                break;
            case "trPr":
            case "tblPrEx":
                this.parseTableRowProperties(c, result);
                break;
        }
        return result;
    }
    parseTableRowProperties(elem, row) {
        row.cssStyle = this.parseDefaultProperties(elem, {}, null, (c)=>{
            switch(c.localName){
                case "cnfStyle":
                    row.className = $68b4bc55b173684a$var$values.classNameOfCnfStyle(c);
                    break;
                case "tblHeader":
                    row.isHeader = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val");
                    break;
                case "gridBefore":
                    row.gridBefore = $68b4bc55b173684a$var$globalXmlParser.intAttr(c, "val");
                    break;
                case "gridAfter":
                    row.gridAfter = $68b4bc55b173684a$var$globalXmlParser.intAttr(c, "val");
                    break;
                default:
                    return false;
            }
            return true;
        });
    }
    parseTableCell(node) {
        var result = {
            type: $68b4bc55b173684a$var$DomType.Cell,
            children: []
        };
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "tbl":
                result.children.push(this.parseTable(c));
                break;
            case "p":
                result.children.push(this.parseParagraph(c));
                break;
            case "tcPr":
                this.parseTableCellProperties(c, result);
                break;
        }
        return result;
    }
    parseTableCellProperties(elem, cell) {
        cell.cssStyle = this.parseDefaultProperties(elem, {}, null, (c)=>{
            switch(c.localName){
                case "gridSpan":
                    cell.span = $68b4bc55b173684a$var$globalXmlParser.intAttr(c, "val", null);
                    break;
                case "vMerge":
                    cell.verticalMerge = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val") ?? "continue";
                    break;
                case "cnfStyle":
                    cell.className = $68b4bc55b173684a$var$values.classNameOfCnfStyle(c);
                    break;
                default:
                    return false;
            }
            return true;
        });
        this.parseTableCellVerticalText(elem, cell);
    }
    parseTableCellVerticalText(elem, cell) {
        const directionMap = {
            "btLr": {
                writingMode: "vertical-rl",
                transform: "rotate(180deg)"
            },
            "lrTb": {
                writingMode: "vertical-lr",
                transform: "none"
            },
            "tbRl": {
                writingMode: "vertical-rl",
                transform: "none"
            }
        };
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(elem))if (c.localName === "textDirection") {
            const direction = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
            const style = directionMap[direction] || {
                writingMode: "horizontal-tb"
            };
            cell.cssStyle["writing-mode"] = style.writingMode;
            cell.cssStyle["transform"] = style.transform;
        }
    }
    parseDefaultProperties(elem, style = null, childStyle = null, handler = null) {
        style = style || {};
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(elem)){
            if (handler?.(c)) continue;
            switch(c.localName){
                case "jc":
                    style["text-align"] = $68b4bc55b173684a$var$values.valueOfJc(c);
                    break;
                case "textAlignment":
                    style["vertical-align"] = $68b4bc55b173684a$var$values.valueOfTextAlignment(c);
                    break;
                case "color":
                    style["color"] = $68b4bc55b173684a$var$xmlUtil.colorAttr(c, "val", null, $68b4bc55b173684a$var$autos.color);
                    break;
                case "sz":
                    style["font-size"] = style["min-height"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(c, "val", $68b4bc55b173684a$var$LengthUsage.FontSize);
                    break;
                case "shd":
                    style["background-color"] = $68b4bc55b173684a$var$xmlUtil.colorAttr(c, "fill", null, $68b4bc55b173684a$var$autos.shd);
                    break;
                case "highlight":
                    style["background-color"] = $68b4bc55b173684a$var$xmlUtil.colorAttr(c, "val", null, $68b4bc55b173684a$var$autos.highlight);
                    break;
                case "vertAlign":
                    break;
                case "position":
                    style.verticalAlign = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(c, "val", $68b4bc55b173684a$var$LengthUsage.FontSize);
                    break;
                case "tcW":
                    if (this.options.ignoreWidth) break;
                case "tblW":
                    style["width"] = $68b4bc55b173684a$var$values.valueOfSize(c, "w");
                    break;
                case "trHeight":
                    this.parseTrHeight(c, style);
                    break;
                case "strike":
                    style["text-decoration"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "line-through" : "none";
                    break;
                case "b":
                    style["font-weight"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "bold" : "normal";
                    break;
                case "i":
                    style["font-style"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "italic" : "normal";
                    break;
                case "caps":
                    style["text-transform"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "uppercase" : "none";
                    break;
                case "smallCaps":
                    style["font-variant"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "small-caps" : "none";
                    break;
                case "u":
                    this.parseUnderline(c, style);
                    break;
                case "ind":
                case "tblInd":
                    this.parseIndentation(c, style);
                    break;
                case "rFonts":
                    this.parseFont(c, style);
                    break;
                case "tblBorders":
                    this.parseBorderProperties(c, childStyle || style);
                    break;
                case "tblCellSpacing":
                    style["border-spacing"] = $68b4bc55b173684a$var$values.valueOfMargin(c);
                    style["border-collapse"] = "separate";
                    break;
                case "pBdr":
                    this.parseBorderProperties(c, style);
                    break;
                case "bdr":
                    style["border"] = $68b4bc55b173684a$var$values.valueOfBorder(c);
                    break;
                case "tcBorders":
                    this.parseBorderProperties(c, style);
                    break;
                case "vanish":
                    if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true)) style["display"] = "none";
                    break;
                case "kern":
                    break;
                case "noWrap":
                    break;
                case "tblCellMar":
                case "tcMar":
                    this.parseMarginProperties(c, childStyle || style);
                    break;
                case "tblLayout":
                    style["table-layout"] = $68b4bc55b173684a$var$values.valueOfTblLayout(c);
                    break;
                case "vAlign":
                    style["vertical-align"] = $68b4bc55b173684a$var$values.valueOfTextAlignment(c);
                    break;
                case "spacing":
                    if (elem.localName == "pPr") this.parseSpacing(c, style);
                    break;
                case "wordWrap":
                    if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val")) style["overflow-wrap"] = "break-word";
                    break;
                case "suppressAutoHyphens":
                    style["hyphens"] = $68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true) ? "none" : "auto";
                    break;
                case "lang":
                    style["$lang"] = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
                    break;
                case "rtl":
                case "bidi":
                    if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "val", true)) style["direction"] = "rtl";
                    break;
                case "bCs":
                case "iCs":
                case "szCs":
                case "tabs":
                case "outlineLvl":
                case "contextualSpacing":
                case "tblStyleColBandSize":
                case "tblStyleRowBandSize":
                case "webHidden":
                case "pageBreakBefore":
                case "suppressLineNumbers":
                case "keepLines":
                case "keepNext":
                case "widowControl":
                case "bidi":
                case "rtl":
                case "noProof":
                    break;
                default:
                    if (this.options.debug) console.warn(`DOCX: Unknown document element: ${elem.localName}.${c.localName}`);
                    break;
            }
        }
        return style;
    }
    parseUnderline(node, style) {
        var val = $68b4bc55b173684a$var$globalXmlParser.attr(node, "val");
        if (val == null) return;
        switch(val){
            case "dash":
            case "dashDotDotHeavy":
            case "dashDotHeavy":
            case "dashedHeavy":
            case "dashLong":
            case "dashLongHeavy":
            case "dotDash":
            case "dotDotDash":
                style["text-decoration"] = "underline dashed";
                break;
            case "dotted":
            case "dottedHeavy":
                style["text-decoration"] = "underline dotted";
                break;
            case "double":
                style["text-decoration"] = "underline double";
                break;
            case "single":
            case "thick":
                style["text-decoration"] = "underline";
                break;
            case "wave":
            case "wavyDouble":
            case "wavyHeavy":
                style["text-decoration"] = "underline wavy";
                break;
            case "words":
                style["text-decoration"] = "underline";
                break;
            case "none":
                style["text-decoration"] = "none";
                break;
        }
        var col = $68b4bc55b173684a$var$xmlUtil.colorAttr(node, "color");
        if (col) style["text-decoration-color"] = col;
    }
    parseFont(node, style) {
        var ascii = $68b4bc55b173684a$var$globalXmlParser.attr(node, "ascii");
        var asciiTheme = $68b4bc55b173684a$var$values.themeValue(node, "asciiTheme");
        var eastAsia = $68b4bc55b173684a$var$globalXmlParser.attr(node, "eastAsia");
        var fonts = [
            ascii,
            asciiTheme,
            eastAsia
        ].filter((x)=>x).map((x)=>$68b4bc55b173684a$var$encloseFontFamily(x));
        if (fonts.length > 0) style["font-family"] = [
            ...new Set(fonts)
        ].join(', ');
    }
    parseIndentation(node, style) {
        var firstLine = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "firstLine");
        var hanging = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "hanging");
        var left = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "left");
        var start = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "start");
        var right = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "right");
        var end = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "end");
        if (firstLine) style["text-indent"] = firstLine;
        if (hanging) style["text-indent"] = `-${hanging}`;
        if (left || start) style["margin-inline-start"] = left || start;
        if (right || end) style["margin-inline-end"] = right || end;
    }
    parseSpacing(node, style) {
        var before = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "before");
        var after = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "after");
        var line = $68b4bc55b173684a$var$globalXmlParser.intAttr(node, "line", null);
        var lineRule = $68b4bc55b173684a$var$globalXmlParser.attr(node, "lineRule");
        if (before) style["margin-top"] = before;
        if (after) style["margin-bottom"] = after;
        if (line !== null) switch(lineRule){
            case "auto":
                style["line-height"] = `${(line / 240).toFixed(2)}`;
                break;
            case "atLeast":
                style["line-height"] = `calc(100% + ${line / 20}pt)`;
                break;
            default:
                style["line-height"] = style["min-height"] = `${line / 20}pt`;
                break;
        }
    }
    parseMarginProperties(node, output) {
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "left":
                output["padding-left"] = $68b4bc55b173684a$var$values.valueOfMargin(c);
                break;
            case "right":
                output["padding-right"] = $68b4bc55b173684a$var$values.valueOfMargin(c);
                break;
            case "top":
                output["padding-top"] = $68b4bc55b173684a$var$values.valueOfMargin(c);
                break;
            case "bottom":
                output["padding-bottom"] = $68b4bc55b173684a$var$values.valueOfMargin(c);
                break;
        }
    }
    parseTrHeight(node, output) {
        switch($68b4bc55b173684a$var$globalXmlParser.attr(node, "hRule")){
            case "exact":
                output["height"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "val");
                break;
            case "atLeast":
            default:
                output["height"] = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(node, "val");
                break;
        }
    }
    parseBorderProperties(node, output) {
        for (const c of $68b4bc55b173684a$var$globalXmlParser.elements(node))switch(c.localName){
            case "start":
            case "left":
                output["border-left"] = $68b4bc55b173684a$var$values.valueOfBorder(c);
                break;
            case "end":
            case "right":
                output["border-right"] = $68b4bc55b173684a$var$values.valueOfBorder(c);
                break;
            case "top":
                output["border-top"] = $68b4bc55b173684a$var$values.valueOfBorder(c);
                break;
            case "bottom":
                output["border-bottom"] = $68b4bc55b173684a$var$values.valueOfBorder(c);
                break;
        }
    }
}
const $68b4bc55b173684a$var$knownColors = [
    'black',
    'blue',
    'cyan',
    'darkBlue',
    'darkCyan',
    'darkGray',
    'darkGreen',
    'darkMagenta',
    'darkRed',
    'darkYellow',
    'green',
    'lightGray',
    'magenta',
    'none',
    'red',
    'white',
    'yellow'
];
class $68b4bc55b173684a$var$xmlUtil {
    static colorAttr(node, attrName, defValue = null, autoColor = 'black') {
        var v = $68b4bc55b173684a$var$globalXmlParser.attr(node, attrName);
        if (v) {
            if (v == "auto") return autoColor;
            else if ($68b4bc55b173684a$var$knownColors.includes(v)) return v;
            return `#${v}`;
        }
        var themeColor = $68b4bc55b173684a$var$globalXmlParser.attr(node, "themeColor");
        return themeColor ? `var(--docx-${themeColor}-color)` : defValue;
    }
}
class $68b4bc55b173684a$var$values {
    static themeValue(c, attr) {
        var val = $68b4bc55b173684a$var$globalXmlParser.attr(c, attr);
        return val ? `var(--docx-${val}-font)` : null;
    }
    static valueOfSize(c, attr) {
        var type = $68b4bc55b173684a$var$LengthUsage.Dxa;
        switch($68b4bc55b173684a$var$globalXmlParser.attr(c, "type")){
            case "dxa":
                break;
            case "pct":
                type = $68b4bc55b173684a$var$LengthUsage.Percent;
                break;
            case "auto":
                return "auto";
        }
        return $68b4bc55b173684a$var$globalXmlParser.lengthAttr(c, attr, type);
    }
    static valueOfMargin(c) {
        return $68b4bc55b173684a$var$globalXmlParser.lengthAttr(c, "w");
    }
    static valueOfBorder(c) {
        var type = $68b4bc55b173684a$var$values.parseBorderType($68b4bc55b173684a$var$globalXmlParser.attr(c, "val"));
        if (type == "none") return "none";
        var color = $68b4bc55b173684a$var$xmlUtil.colorAttr(c, "color");
        var size = $68b4bc55b173684a$var$globalXmlParser.lengthAttr(c, "sz", $68b4bc55b173684a$var$LengthUsage.Border);
        return `${size} ${type} ${color == "auto" ? $68b4bc55b173684a$var$autos.borderColor : color}`;
    }
    static parseBorderType(type) {
        switch(type){
            case "single":
                return "solid";
            case "dashDotStroked":
                return "solid";
            case "dashed":
                return "dashed";
            case "dashSmallGap":
                return "dashed";
            case "dotDash":
                return "dotted";
            case "dotDotDash":
                return "dotted";
            case "dotted":
                return "dotted";
            case "double":
                return "double";
            case "doubleWave":
                return "double";
            case "inset":
                return "inset";
            case "nil":
                return "none";
            case "none":
                return "none";
            case "outset":
                return "outset";
            case "thick":
                return "solid";
            case "thickThinLargeGap":
                return "solid";
            case "thickThinMediumGap":
                return "solid";
            case "thickThinSmallGap":
                return "solid";
            case "thinThickLargeGap":
                return "solid";
            case "thinThickMediumGap":
                return "solid";
            case "thinThickSmallGap":
                return "solid";
            case "thinThickThinLargeGap":
                return "solid";
            case "thinThickThinMediumGap":
                return "solid";
            case "thinThickThinSmallGap":
                return "solid";
            case "threeDEmboss":
                return "solid";
            case "threeDEngrave":
                return "solid";
            case "triple":
                return "double";
            case "wave":
                return "solid";
        }
        return 'solid';
    }
    static valueOfTblLayout(c) {
        var type = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
        return type == "fixed" ? "fixed" : "auto";
    }
    static classNameOfCnfStyle(c) {
        const val = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
        const classes = [
            'first-row',
            'last-row',
            'first-col',
            'last-col',
            'odd-col',
            'even-col',
            'odd-row',
            'even-row',
            'ne-cell',
            'nw-cell',
            'se-cell',
            'sw-cell'
        ];
        return classes.filter((_, i)=>val[i] == '1').join(' ');
    }
    static valueOfJc(c) {
        var type = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
        switch(type){
            case "start":
            case "left":
                return "left";
            case "center":
                return "center";
            case "end":
            case "right":
                return "right";
            case "both":
                return "justify";
        }
        return type;
    }
    static valueOfVertAlign(c, asTagName = false) {
        var type = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
        switch(type){
            case "subscript":
                return "sub";
            case "superscript":
                return asTagName ? "sup" : "super";
        }
        return asTagName ? null : type;
    }
    static valueOfTextAlignment(c) {
        var type = $68b4bc55b173684a$var$globalXmlParser.attr(c, "val");
        switch(type){
            case "auto":
            case "baseline":
                return "baseline";
            case "top":
                return "top";
            case "center":
                return "middle";
            case "bottom":
                return "bottom";
        }
        return type;
    }
    static addSize(a, b) {
        if (a == null) return b;
        if (b == null) return a;
        return `calc(${a} + ${b})`;
    }
    static classNameOftblLook(c) {
        const val = $68b4bc55b173684a$var$globalXmlParser.hexAttr(c, "val", 0);
        let className = "";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "firstRow") || val & 0x0020) className += " first-row";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "lastRow") || val & 0x0040) className += " last-row";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "firstColumn") || val & 0x0080) className += " first-col";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "lastColumn") || val & 0x0100) className += " last-col";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "noHBand") || val & 0x0200) className += " no-hband";
        if ($68b4bc55b173684a$var$globalXmlParser.boolAttr(c, "noVBand") || val & 0x0400) className += " no-vband";
        return className.trim();
    }
}
const $68b4bc55b173684a$var$defaultTab = {
    pos: 0,
    leader: "none",
    style: "left"
};
const $68b4bc55b173684a$var$maxTabs = 50;
function $68b4bc55b173684a$var$computePixelToPoint(container = document.body) {
    const temp = document.createElement("div");
    temp.style.width = '100pt';
    container.appendChild(temp);
    const result = 100 / temp.offsetWidth;
    container.removeChild(temp);
    return result;
}
function $68b4bc55b173684a$var$updateTabStop(elem, tabs, defaultTabSize, pixelToPoint = 0.75) {
    const p = elem.closest("p");
    const ebb = elem.getBoundingClientRect();
    const pbb = p.getBoundingClientRect();
    const pcs = getComputedStyle(p);
    const tabStops = tabs?.length > 0 ? tabs.map((t)=>({
            pos: $68b4bc55b173684a$var$lengthToPoint(t.position),
            leader: t.leader,
            style: t.style
        })).sort((a, b)=>a.pos - b.pos) : [
        $68b4bc55b173684a$var$defaultTab
    ];
    const lastTab = tabStops[tabStops.length - 1];
    const pWidthPt = pbb.width * pixelToPoint;
    const size = $68b4bc55b173684a$var$lengthToPoint(defaultTabSize);
    let pos = lastTab.pos + size;
    if (pos < pWidthPt) for(; pos < pWidthPt && tabStops.length < $68b4bc55b173684a$var$maxTabs; pos += size)tabStops.push({
        ...$68b4bc55b173684a$var$defaultTab,
        pos: pos
    });
    const marginLeft = parseFloat(pcs.marginLeft);
    const pOffset = pbb.left + marginLeft;
    const left = (ebb.left - pOffset) * pixelToPoint;
    const tab = tabStops.find((t)=>t.style != "clear" && t.pos > left);
    if (tab == null) return;
    let width = 1;
    if (tab.style == "right" || tab.style == "center") {
        const tabStops = Array.from(p.querySelectorAll(`.${elem.className}`));
        const nextIdx = tabStops.indexOf(elem) + 1;
        const range = document.createRange();
        range.setStart(elem, 1);
        if (nextIdx < tabStops.length) range.setEndBefore(tabStops[nextIdx]);
        else range.setEndAfter(p);
        const mul = tab.style == "center" ? 0.5 : 1;
        const nextBB = range.getBoundingClientRect();
        const offset = nextBB.left + mul * nextBB.width - (pbb.left - marginLeft);
        width = tab.pos - offset * pixelToPoint;
    } else width = tab.pos - left;
    elem.innerHTML = "&nbsp;";
    elem.style.textDecoration = "inherit";
    elem.style.wordSpacing = `${width.toFixed(0)}pt`;
    switch(tab.leader){
        case "dot":
        case "middleDot":
            elem.style.textDecoration = "underline";
            elem.style.textDecorationStyle = "dotted";
            break;
        case "hyphen":
        case "heavy":
        case "underscore":
            elem.style.textDecoration = "underline";
            break;
    }
}
function $68b4bc55b173684a$var$lengthToPoint(length) {
    return parseFloat(length);
}
const $68b4bc55b173684a$var$ns = {
    svg: "http://www.w3.org/2000/svg",
    mathML: "http://www.w3.org/1998/Math/MathML"
};
class $68b4bc55b173684a$var$HtmlRenderer {
    constructor(htmlDocument){
        this.htmlDocument = htmlDocument;
        this.className = "docx";
        this.styleMap = {};
        this.currentPart = null;
        this.tableVerticalMerges = [];
        this.currentVerticalMerge = null;
        this.tableCellPositions = [];
        this.currentCellPosition = null;
        this.footnoteMap = {};
        this.endnoteMap = {};
        this.currentEndnoteIds = [];
        this.usedHederFooterParts = [];
        this.currentTabs = [];
        this.commentMap = {};
        this.tasks = [];
        this.postRenderTasks = [];
    }
    async render(document1, bodyContainer, styleContainer = null, options) {
        this.document = document1;
        this.options = options;
        this.className = options.className;
        this.rootSelector = options.inWrapper ? `.${this.className}-wrapper` : ':root';
        this.styleMap = null;
        this.tasks = [];
        if (this.options.renderComments && globalThis.Highlight) this.commentHighlight = new Highlight();
        styleContainer = styleContainer || bodyContainer;
        $68b4bc55b173684a$var$removeAllElements(styleContainer);
        $68b4bc55b173684a$var$removeAllElements(bodyContainer);
        styleContainer.appendChild(this.createComment("docxjs library predefined styles"));
        styleContainer.appendChild(this.renderDefaultStyle());
        if (document1.themePart) {
            styleContainer.appendChild(this.createComment("docxjs document theme values"));
            this.renderTheme(document1.themePart, styleContainer);
        }
        if (document1.stylesPart != null) {
            this.styleMap = this.processStyles(document1.stylesPart.styles);
            styleContainer.appendChild(this.createComment("docxjs document styles"));
            styleContainer.appendChild(this.renderStyles(document1.stylesPart.styles));
        }
        if (document1.numberingPart) {
            this.prodessNumberings(document1.numberingPart.domNumberings);
            styleContainer.appendChild(this.createComment("docxjs document numbering styles"));
            styleContainer.appendChild(this.renderNumbering(document1.numberingPart.domNumberings, styleContainer));
        }
        if (document1.footnotesPart) this.footnoteMap = $68b4bc55b173684a$var$keyBy(document1.footnotesPart.notes, (x)=>x.id);
        if (document1.endnotesPart) this.endnoteMap = $68b4bc55b173684a$var$keyBy(document1.endnotesPart.notes, (x)=>x.id);
        if (document1.settingsPart) this.defaultTabSize = document1.settingsPart.settings?.defaultTabStop;
        if (!options.ignoreFonts && document1.fontTablePart) this.renderFontTable(document1.fontTablePart, styleContainer);
        var sectionElements = this.renderSections(document1.documentPart.body);
        if (this.options.inWrapper) bodyContainer.appendChild(this.renderWrapper(sectionElements));
        else $68b4bc55b173684a$var$appendChildren(bodyContainer, sectionElements);
        if (this.commentHighlight && options.renderComments) CSS.highlights.set(`${this.className}-comments`, this.commentHighlight);
        this.postRenderTasks.forEach((t)=>t());
        await Promise.allSettled(this.tasks);
        this.refreshTabStops();
    }
    renderTheme(themePart, styleContainer) {
        const variables = {};
        const fontScheme = themePart.theme?.fontScheme;
        if (fontScheme) {
            if (fontScheme.majorFont) variables['--docx-majorHAnsi-font'] = fontScheme.majorFont.latinTypeface;
            if (fontScheme.minorFont) variables['--docx-minorHAnsi-font'] = fontScheme.minorFont.latinTypeface;
        }
        const colorScheme = themePart.theme?.colorScheme;
        if (colorScheme) for (let [k, v] of Object.entries(colorScheme.colors))variables[`--docx-${k}-color`] = `#${v}`;
        const cssText = this.styleToString(`.${this.className}`, variables);
        styleContainer.appendChild(this.createStyleElement(cssText));
    }
    renderFontTable(fontsPart, styleContainer) {
        for (let f of fontsPart.fonts)for (let ref of f.embedFontRefs)this.tasks.push(this.document.loadFont(ref.id, ref.key).then((fontData)=>{
            const cssValues = {
                'font-family': $68b4bc55b173684a$var$encloseFontFamily(f.name),
                'src': `url(${fontData})`
            };
            if (ref.type == "bold" || ref.type == "boldItalic") cssValues['font-weight'] = 'bold';
            if (ref.type == "italic" || ref.type == "boldItalic") cssValues['font-style'] = 'italic';
            const cssText = this.styleToString("@font-face", cssValues);
            styleContainer.appendChild(this.createComment(`docxjs ${f.name} font`));
            styleContainer.appendChild(this.createStyleElement(cssText));
        }));
    }
    processStyleName(className) {
        return className ? `${this.className}_${$68b4bc55b173684a$var$escapeClassName(className)}` : this.className;
    }
    processStyles(styles) {
        const stylesMap = $68b4bc55b173684a$var$keyBy(styles.filter((x)=>x.id != null), (x)=>x.id);
        for (const style of styles.filter((x)=>x.basedOn)){
            var baseStyle = stylesMap[style.basedOn];
            if (baseStyle) {
                style.paragraphProps = $68b4bc55b173684a$var$mergeDeep(style.paragraphProps, baseStyle.paragraphProps);
                style.runProps = $68b4bc55b173684a$var$mergeDeep(style.runProps, baseStyle.runProps);
                for (const baseValues of baseStyle.styles){
                    const styleValues = style.styles.find((x)=>x.target == baseValues.target);
                    if (styleValues) this.copyStyleProperties(baseValues.values, styleValues.values);
                    else style.styles.push({
                        ...baseValues,
                        values: {
                            ...baseValues.values
                        }
                    });
                }
            } else if (this.options.debug) console.warn(`Can't find base style ${style.basedOn}`);
        }
        for (let style of styles)style.cssName = this.processStyleName(style.id);
        return stylesMap;
    }
    prodessNumberings(numberings) {
        for (let num of numberings.filter((n)=>n.pStyleName)){
            const style = this.findStyle(num.pStyleName);
            if (style?.paragraphProps?.numbering) style.paragraphProps.numbering.level = num.level;
        }
    }
    processElement(element) {
        if (element.children) for (var e of element.children){
            e.parent = element;
            if (e.type == $68b4bc55b173684a$var$DomType.Table) this.processTable(e);
            else this.processElement(e);
        }
    }
    processTable(table) {
        for (var r of table.children)for (var c of r.children){
            c.cssStyle = this.copyStyleProperties(table.cellStyle, c.cssStyle, [
                "border-left",
                "border-right",
                "border-top",
                "border-bottom",
                "padding-left",
                "padding-right",
                "padding-top",
                "padding-bottom"
            ]);
            this.processElement(c);
        }
    }
    copyStyleProperties(input, output, attrs = null) {
        if (!input) return output;
        if (output == null) output = {};
        if (attrs == null) attrs = Object.getOwnPropertyNames(input);
        for (var key of attrs)if (input.hasOwnProperty(key) && !output.hasOwnProperty(key)) output[key] = input[key];
        return output;
    }
    createPageElement(className, props) {
        var elem = this.createElement("section", {
            className: className
        });
        if (props) {
            if (props.pageMargins) {
                elem.style.paddingLeft = props.pageMargins.left;
                elem.style.paddingRight = props.pageMargins.right;
                elem.style.paddingTop = props.pageMargins.top;
                elem.style.paddingBottom = props.pageMargins.bottom;
            }
            if (props.pageSize) {
                if (!this.options.ignoreWidth) elem.style.width = props.pageSize.width;
                if (!this.options.ignoreHeight) elem.style.minHeight = props.pageSize.height;
            }
        }
        return elem;
    }
    createSectionContent(props) {
        var elem = this.createElement("article");
        if (props.columns && props.columns.numberOfColumns) {
            elem.style.columnCount = `${props.columns.numberOfColumns}`;
            elem.style.columnGap = props.columns.space;
            if (props.columns.separator) elem.style.columnRule = "1px solid black";
        }
        return elem;
    }
    renderSections(document1) {
        const result = [];
        this.processElement(document1);
        const sections = this.splitBySection(document1.children, document1.props);
        const pages = this.groupByPageBreaks(sections);
        let prevProps = null;
        for(let i = 0, l = pages.length; i < l; i++){
            this.currentFootnoteIds = [];
            const section = pages[i][0];
            let props = section.sectProps;
            const pageElement = this.createPageElement(this.className, props);
            this.renderStyleValues(document1.cssStyle, pageElement);
            this.options.renderHeaders && this.renderHeaderFooter(props.headerRefs, props, result.length, prevProps != props, pageElement);
            for (const sect of pages[i]){
                var contentElement = this.createSectionContent(sect.sectProps);
                this.renderElements(sect.elements, contentElement);
                pageElement.appendChild(contentElement);
                props = sect.sectProps;
            }
            if (this.options.renderFootnotes) this.renderNotes(this.currentFootnoteIds, this.footnoteMap, pageElement);
            if (this.options.renderEndnotes && i == l - 1) this.renderNotes(this.currentEndnoteIds, this.endnoteMap, pageElement);
            this.options.renderFooters && this.renderHeaderFooter(props.footerRefs, props, result.length, prevProps != props, pageElement);
            result.push(pageElement);
            prevProps = props;
        }
        return result;
    }
    renderHeaderFooter(refs, props, page, firstOfSection, into) {
        if (!refs) return;
        var ref = (props.titlePage && firstOfSection ? refs.find((x)=>x.type == "first") : null) ?? (page % 2 == 1 ? refs.find((x)=>x.type == "even") : null) ?? refs.find((x)=>x.type == "default");
        var part = ref && this.document.findPartByRelId(ref.id, this.document.documentPart);
        if (part) {
            this.currentPart = part;
            if (!this.usedHederFooterParts.includes(part.path)) {
                this.processElement(part.rootElement);
                this.usedHederFooterParts.push(part.path);
            }
            const [el] = this.renderElements([
                part.rootElement
            ], into);
            if (props?.pageMargins) {
                if (part.rootElement.type === $68b4bc55b173684a$var$DomType.Header) {
                    el.style.marginTop = `calc(${props.pageMargins.header} - ${props.pageMargins.top})`;
                    el.style.minHeight = `calc(${props.pageMargins.top} - ${props.pageMargins.header})`;
                } else if (part.rootElement.type === $68b4bc55b173684a$var$DomType.Footer) {
                    el.style.marginBottom = `calc(${props.pageMargins.footer} - ${props.pageMargins.bottom})`;
                    el.style.minHeight = `calc(${props.pageMargins.bottom} - ${props.pageMargins.footer})`;
                }
            }
            this.currentPart = null;
        }
    }
    isPageBreakElement(elem) {
        if (elem.type != $68b4bc55b173684a$var$DomType.Break) return false;
        if (elem.break == "lastRenderedPageBreak") return !this.options.ignoreLastRenderedPageBreak;
        return elem.break == "page";
    }
    isPageBreakSection(prev, next) {
        if (!prev) return false;
        if (!next) return false;
        return prev.pageSize?.orientation != next.pageSize?.orientation || prev.pageSize?.width != next.pageSize?.width || prev.pageSize?.height != next.pageSize?.height;
    }
    splitBySection(elements, defaultProps) {
        var current = {
            sectProps: null,
            elements: [],
            pageBreak: false
        };
        var result = [
            current
        ];
        for (let elem of elements){
            if (elem.type == $68b4bc55b173684a$var$DomType.Paragraph) {
                const s = this.findStyle(elem.styleName);
                if (s?.paragraphProps?.pageBreakBefore) {
                    current.sectProps = sectProps;
                    current.pageBreak = true;
                    current = {
                        sectProps: null,
                        elements: [],
                        pageBreak: false
                    };
                    result.push(current);
                }
            }
            current.elements.push(elem);
            if (elem.type == $68b4bc55b173684a$var$DomType.Paragraph) {
                const p = elem;
                var sectProps = p.sectionProps;
                var pBreakIndex = -1;
                var rBreakIndex = -1;
                if (this.options.breakPages && p.children) pBreakIndex = p.children.findIndex((r)=>{
                    rBreakIndex = r.children?.findIndex(this.isPageBreakElement.bind(this)) ?? -1;
                    return rBreakIndex != -1;
                });
                if (sectProps || pBreakIndex != -1) {
                    current.sectProps = sectProps;
                    current.pageBreak = pBreakIndex != -1;
                    current = {
                        sectProps: null,
                        elements: [],
                        pageBreak: false
                    };
                    result.push(current);
                }
                if (pBreakIndex != -1) {
                    let breakRun = p.children[pBreakIndex];
                    let splitRun = rBreakIndex < breakRun.children.length - 1;
                    if (pBreakIndex < p.children.length - 1 || splitRun) {
                        var children = elem.children;
                        var newParagraph = {
                            ...elem,
                            children: children.slice(pBreakIndex)
                        };
                        elem.children = children.slice(0, pBreakIndex);
                        current.elements.push(newParagraph);
                        if (splitRun) {
                            let runChildren = breakRun.children;
                            let newRun = {
                                ...breakRun,
                                children: runChildren.slice(0, rBreakIndex)
                            };
                            elem.children.push(newRun);
                            breakRun.children = runChildren.slice(rBreakIndex);
                        }
                    }
                }
            }
        }
        let currentSectProps = null;
        for(let i = result.length - 1; i >= 0; i--)if (result[i].sectProps == null) result[i].sectProps = currentSectProps ?? defaultProps;
        else currentSectProps = result[i].sectProps;
        return result;
    }
    groupByPageBreaks(sections) {
        let current = [];
        let prev;
        const result = [
            current
        ];
        for (let s of sections){
            current.push(s);
            if (this.options.ignoreLastRenderedPageBreak || s.pageBreak || this.isPageBreakSection(prev, s.sectProps)) result.push(current = []);
            prev = s.sectProps;
        }
        return result.filter((x)=>x.length > 0);
    }
    renderWrapper(children) {
        return this.createElement("div", {
            className: `${this.className}-wrapper`
        }, children);
    }
    renderDefaultStyle() {
        var c = this.className;
        var wrapperStyle = `
.${c}-wrapper { background: gray; padding: 30px; padding-bottom: 0px; display: flex; flex-flow: column; align-items: center; } 
.${c}-wrapper>section.${c} { background: white; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); margin-bottom: 30px; }`;
        if (this.options.hideWrapperOnPrint) wrapperStyle = `@media not print { ${wrapperStyle} }`;
        var styleText = `${wrapperStyle}
.${c} { color: black; hyphens: auto; text-underline-position: from-font; }
section.${c} { box-sizing: border-box; display: flex; flex-flow: column nowrap; position: relative; overflow: hidden; }
section.${c}>article { margin-bottom: auto; z-index: 1; }
section.${c}>footer { z-index: 1; }
.${c} table { border-collapse: collapse; }
.${c} table td, .${c} table th { vertical-align: top; }
.${c} p { margin: 0pt; min-height: 1em; }
.${c} span { white-space: pre-wrap; overflow-wrap: break-word; }
.${c} a { color: inherit; text-decoration: inherit; }
.${c} svg { fill: transparent; }
`;
        if (this.options.renderComments) styleText += `
.${c}-comment-ref { cursor: default; }
.${c}-comment-popover { display: none; z-index: 1000; padding: 0.5rem; background: white; position: absolute; box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.25); width: 30ch; }
.${c}-comment-ref:hover~.${c}-comment-popover { display: block; }
.${c}-comment-author,.${c}-comment-date { font-size: 0.875rem; color: #888; }
`;
        return this.createStyleElement(styleText);
    }
    renderNumbering(numberings, styleContainer) {
        var styleText = "";
        var resetCounters = [];
        for (var num of numberings){
            var selector = `p.${this.numberingClass(num.id, num.level)}`;
            var listStyleType = "none";
            if (num.bullet) {
                let valiable = `--${this.className}-${num.bullet.src}`.toLowerCase();
                styleText += this.styleToString(`${selector}:before`, {
                    "content": "' '",
                    "display": "inline-block",
                    "background": `var(${valiable})`
                }, num.bullet.style);
                this.tasks.push(this.document.loadNumberingImage(num.bullet.src).then((data)=>{
                    var text = `${this.rootSelector} { ${valiable}: url(${data}) }`;
                    styleContainer.appendChild(this.createStyleElement(text));
                }));
            } else if (num.levelText) {
                let counter = this.numberingCounter(num.id, num.level);
                const counterReset = counter + " " + (num.start - 1);
                if (num.level > 0) styleText += this.styleToString(`p.${this.numberingClass(num.id, num.level - 1)}`, {
                    "counter-set": counterReset
                });
                resetCounters.push(counterReset);
                styleText += this.styleToString(`${selector}:before`, {
                    "content": this.levelTextToContent(num.levelText, num.suff, num.id, this.numFormatToCssValue(num.format)),
                    "counter-increment": counter,
                    ...num.rStyle
                });
            } else listStyleType = this.numFormatToCssValue(num.format);
            styleText += this.styleToString(selector, {
                "display": "list-item",
                "list-style-position": "inside",
                "list-style-type": listStyleType,
                ...num.pStyle
            });
        }
        if (resetCounters.length > 0) styleText += this.styleToString(this.rootSelector, {
            "counter-reset": resetCounters.join(" ")
        });
        return this.createStyleElement(styleText);
    }
    renderStyles(styles) {
        var styleText = "";
        const stylesMap = this.styleMap;
        const defautStyles = $68b4bc55b173684a$var$keyBy(styles.filter((s)=>s.isDefault), (s)=>s.target);
        for (const style of styles){
            var subStyles = style.styles;
            if (style.linked) {
                var linkedStyle = style.linked && stylesMap[style.linked];
                if (linkedStyle) subStyles = subStyles.concat(linkedStyle.styles);
                else if (this.options.debug) console.warn(`Can't find linked style ${style.linked}`);
            }
            for (const subStyle of subStyles){
                var selector = `${style.target ?? ''}.${style.cssName}`;
                if (style.target != subStyle.target) selector += ` ${subStyle.target}`;
                if (defautStyles[style.target] == style) selector = `.${this.className} ${style.target}, ` + selector;
                styleText += this.styleToString(selector, subStyle.values);
            }
        }
        return this.createStyleElement(styleText);
    }
    renderNotes(noteIds, notesMap, into) {
        var notes = noteIds.map((id)=>notesMap[id]).filter((x)=>x);
        if (notes.length > 0) {
            var result = this.createElement("ol", null, this.renderElements(notes));
            into.appendChild(result);
        }
    }
    renderElement(elem) {
        switch(elem.type){
            case $68b4bc55b173684a$var$DomType.Paragraph:
                return this.renderParagraph(elem);
            case $68b4bc55b173684a$var$DomType.BookmarkStart:
                return this.renderBookmarkStart(elem);
            case $68b4bc55b173684a$var$DomType.BookmarkEnd:
                return null;
            case $68b4bc55b173684a$var$DomType.Run:
                return this.renderRun(elem);
            case $68b4bc55b173684a$var$DomType.Table:
                return this.renderTable(elem);
            case $68b4bc55b173684a$var$DomType.Row:
                return this.renderTableRow(elem);
            case $68b4bc55b173684a$var$DomType.Cell:
                return this.renderTableCell(elem);
            case $68b4bc55b173684a$var$DomType.Hyperlink:
                return this.renderHyperlink(elem);
            case $68b4bc55b173684a$var$DomType.SmartTag:
                return this.renderSmartTag(elem);
            case $68b4bc55b173684a$var$DomType.Drawing:
                return this.renderDrawing(elem);
            case $68b4bc55b173684a$var$DomType.Image:
                return this.renderImage(elem);
            case $68b4bc55b173684a$var$DomType.Text:
                return this.renderText(elem);
            case $68b4bc55b173684a$var$DomType.Text:
                return this.renderText(elem);
            case $68b4bc55b173684a$var$DomType.DeletedText:
                return this.renderDeletedText(elem);
            case $68b4bc55b173684a$var$DomType.Tab:
                return this.renderTab(elem);
            case $68b4bc55b173684a$var$DomType.Symbol:
                return this.renderSymbol(elem);
            case $68b4bc55b173684a$var$DomType.Break:
                return this.renderBreak(elem);
            case $68b4bc55b173684a$var$DomType.Footer:
                return this.renderContainer(elem, "footer");
            case $68b4bc55b173684a$var$DomType.Header:
                return this.renderContainer(elem, "header");
            case $68b4bc55b173684a$var$DomType.Footnote:
            case $68b4bc55b173684a$var$DomType.Endnote:
                return this.renderContainer(elem, "li");
            case $68b4bc55b173684a$var$DomType.FootnoteReference:
                return this.renderFootnoteReference(elem);
            case $68b4bc55b173684a$var$DomType.EndnoteReference:
                return this.renderEndnoteReference(elem);
            case $68b4bc55b173684a$var$DomType.NoBreakHyphen:
                return this.createElement("wbr");
            case $68b4bc55b173684a$var$DomType.VmlPicture:
                return this.renderVmlPicture(elem);
            case $68b4bc55b173684a$var$DomType.VmlElement:
                return this.renderVmlElement(elem);
            case $68b4bc55b173684a$var$DomType.MmlMath:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "math", {
                    xmlns: $68b4bc55b173684a$var$ns.mathML
                });
            case $68b4bc55b173684a$var$DomType.MmlMathParagraph:
                return this.renderContainer(elem, "span");
            case $68b4bc55b173684a$var$DomType.MmlFraction:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mfrac");
            case $68b4bc55b173684a$var$DomType.MmlBase:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, elem.parent.type == $68b4bc55b173684a$var$DomType.MmlMatrixRow ? "mtd" : "mrow");
            case $68b4bc55b173684a$var$DomType.MmlNumerator:
            case $68b4bc55b173684a$var$DomType.MmlDenominator:
            case $68b4bc55b173684a$var$DomType.MmlFunction:
            case $68b4bc55b173684a$var$DomType.MmlLimit:
            case $68b4bc55b173684a$var$DomType.MmlBox:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mrow");
            case $68b4bc55b173684a$var$DomType.MmlGroupChar:
                return this.renderMmlGroupChar(elem);
            case $68b4bc55b173684a$var$DomType.MmlLimitLower:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "munder");
            case $68b4bc55b173684a$var$DomType.MmlMatrix:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mtable");
            case $68b4bc55b173684a$var$DomType.MmlMatrixRow:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mtr");
            case $68b4bc55b173684a$var$DomType.MmlRadical:
                return this.renderMmlRadical(elem);
            case $68b4bc55b173684a$var$DomType.MmlSuperscript:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "msup");
            case $68b4bc55b173684a$var$DomType.MmlSubscript:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "msub");
            case $68b4bc55b173684a$var$DomType.MmlDegree:
            case $68b4bc55b173684a$var$DomType.MmlSuperArgument:
            case $68b4bc55b173684a$var$DomType.MmlSubArgument:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mn");
            case $68b4bc55b173684a$var$DomType.MmlFunctionName:
                return this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "ms");
            case $68b4bc55b173684a$var$DomType.MmlDelimiter:
                return this.renderMmlDelimiter(elem);
            case $68b4bc55b173684a$var$DomType.MmlRun:
                return this.renderMmlRun(elem);
            case $68b4bc55b173684a$var$DomType.MmlNary:
                return this.renderMmlNary(elem);
            case $68b4bc55b173684a$var$DomType.MmlPreSubSuper:
                return this.renderMmlPreSubSuper(elem);
            case $68b4bc55b173684a$var$DomType.MmlBar:
                return this.renderMmlBar(elem);
            case $68b4bc55b173684a$var$DomType.MmlEquationArray:
                return this.renderMllList(elem);
            case $68b4bc55b173684a$var$DomType.Inserted:
                return this.renderInserted(elem);
            case $68b4bc55b173684a$var$DomType.Deleted:
                return this.renderDeleted(elem);
            case $68b4bc55b173684a$var$DomType.CommentRangeStart:
                return this.renderCommentRangeStart(elem);
            case $68b4bc55b173684a$var$DomType.CommentRangeEnd:
                return this.renderCommentRangeEnd(elem);
            case $68b4bc55b173684a$var$DomType.CommentReference:
                return this.renderCommentReference(elem);
            case $68b4bc55b173684a$var$DomType.AltChunk:
                return this.renderAltChunk(elem);
        }
        return null;
    }
    renderElements(elems, into) {
        if (elems == null) return null;
        var result = elems.flatMap((e)=>this.renderElement(e)).filter((e)=>e != null);
        if (into) $68b4bc55b173684a$var$appendChildren(into, result);
        return result;
    }
    renderContainer(elem, tagName, props) {
        return this.createElement(tagName, props, this.renderElements(elem.children));
    }
    renderContainerNS(elem, ns, tagName, props) {
        return this.createElementNS(ns, tagName, props, this.renderElements(elem.children));
    }
    renderParagraph(elem) {
        var result = this.renderContainer(elem, "p");
        const style = this.findStyle(elem.styleName);
        elem.tabs ?? (elem.tabs = style?.paragraphProps?.tabs);
        this.renderClass(elem, result);
        this.renderStyleValues(elem.cssStyle, result);
        this.renderCommonProperties(result.style, elem);
        const numbering = elem.numbering ?? style?.paragraphProps?.numbering;
        if (numbering) result.classList.add(this.numberingClass(numbering.id, numbering.level));
        return result;
    }
    renderRunProperties(style, props) {
        this.renderCommonProperties(style, props);
    }
    renderCommonProperties(style, props) {
        if (props == null) return;
        if (props.color) style["color"] = props.color;
        if (props.fontSize) style["font-size"] = props.fontSize;
    }
    renderHyperlink(elem) {
        var result = this.renderContainer(elem, "a");
        this.renderStyleValues(elem.cssStyle, result);
        let href = '';
        if (elem.id) {
            const rel = this.document.documentPart.rels.find((it)=>it.id == elem.id && it.targetMode === "External");
            href = rel?.target ?? href;
        }
        if (elem.anchor) href += `#${elem.anchor}`;
        result.href = href;
        return result;
    }
    renderSmartTag(elem) {
        return this.renderContainer(elem, "span");
    }
    renderCommentRangeStart(commentStart) {
        if (!this.options.renderComments) return null;
        const rng = new Range();
        this.commentHighlight?.add(rng);
        const result = this.createComment(`start of comment #${commentStart.id}`);
        this.later(()=>rng.setStart(result, 0));
        this.commentMap[commentStart.id] = rng;
        return result;
    }
    renderCommentRangeEnd(commentEnd) {
        if (!this.options.renderComments) return null;
        const rng = this.commentMap[commentEnd.id];
        const result = this.createComment(`end of comment #${commentEnd.id}`);
        this.later(()=>rng?.setEnd(result, 0));
        return result;
    }
    renderCommentReference(commentRef) {
        if (!this.options.renderComments) return null;
        var comment = this.document.commentsPart?.commentMap[commentRef.id];
        if (!comment) return null;
        const frg = new DocumentFragment();
        const commentRefEl = this.createElement("span", {
            className: `${this.className}-comment-ref`
        }, [
            "\uD83D\uDCAC"
        ]);
        const commentsContainerEl = this.createElement("div", {
            className: `${this.className}-comment-popover`
        });
        this.renderCommentContent(comment, commentsContainerEl);
        frg.appendChild(this.createComment(`comment #${comment.id} by ${comment.author} on ${comment.date}`));
        frg.appendChild(commentRefEl);
        frg.appendChild(commentsContainerEl);
        return frg;
    }
    renderAltChunk(elem) {
        if (!this.options.renderAltChunks) return null;
        var result = this.createElement("iframe");
        this.tasks.push(this.document.loadAltChunk(elem.id, this.currentPart).then((x)=>{
            result.srcdoc = x;
        }));
        return result;
    }
    renderCommentContent(comment, container) {
        container.appendChild(this.createElement('div', {
            className: `${this.className}-comment-author`
        }, [
            comment.author
        ]));
        container.appendChild(this.createElement('div', {
            className: `${this.className}-comment-date`
        }, [
            new Date(comment.date).toLocaleString()
        ]));
        this.renderElements(comment.children, container);
    }
    renderDrawing(elem) {
        var result = this.renderContainer(elem, "div");
        result.style.display = "inline-block";
        result.style.position = "relative";
        result.style.textIndent = "0px";
        this.renderStyleValues(elem.cssStyle, result);
        return result;
    }
    renderImage(elem) {
        let result = this.createElement("img");
        let transform = elem.cssStyle?.transform;
        this.renderStyleValues(elem.cssStyle, result);
        if (elem.srcRect && elem.srcRect.some((x)=>x != 0)) {
            var [left, top, right, bottom] = elem.srcRect;
            transform = `scale(${1 / (1 - left - right)}, ${1 / (1 - top - bottom)})`;
            result.style['clip-path'] = `rect(${(100 * top).toFixed(2)}% ${(100 * (1 - right)).toFixed(2)}% ${(100 * (1 - bottom)).toFixed(2)}% ${(100 * left).toFixed(2)}%)`;
        }
        if (elem.rotation) transform = `rotate(${elem.rotation}deg) ${transform ?? ''}`;
        result.style.transform = transform?.trim();
        if (this.document) this.tasks.push(this.document.loadDocumentImage(elem.src, this.currentPart).then((x)=>{
            result.src = x;
        }));
        return result;
    }
    renderText(elem) {
        return this.htmlDocument.createTextNode(elem.text);
    }
    renderDeletedText(elem) {
        return this.options.renderChanges ? this.renderText(elem) : null;
    }
    renderBreak(elem) {
        if (elem.break == "textWrapping") return this.createElement("br");
        return null;
    }
    renderInserted(elem) {
        if (this.options.renderChanges) return this.renderContainer(elem, "ins");
        return this.renderElements(elem.children);
    }
    renderDeleted(elem) {
        if (this.options.renderChanges) return this.renderContainer(elem, "del");
        return null;
    }
    renderSymbol(elem) {
        var span = this.createElement("span");
        span.style.fontFamily = elem.font;
        span.innerHTML = `&#x${elem.char};`;
        return span;
    }
    renderFootnoteReference(elem) {
        var result = this.createElement("sup");
        this.currentFootnoteIds.push(elem.id);
        result.textContent = `${this.currentFootnoteIds.length}`;
        return result;
    }
    renderEndnoteReference(elem) {
        var result = this.createElement("sup");
        this.currentEndnoteIds.push(elem.id);
        result.textContent = `${this.currentEndnoteIds.length}`;
        return result;
    }
    renderTab(elem) {
        var tabSpan = this.createElement("span");
        tabSpan.innerHTML = "&emsp;";
        if (this.options.experimental) {
            tabSpan.className = this.tabStopClass();
            var stops = $68b4bc55b173684a$var$findParent(elem, $68b4bc55b173684a$var$DomType.Paragraph)?.tabs;
            this.currentTabs.push({
                stops: stops,
                span: tabSpan
            });
        }
        return tabSpan;
    }
    renderBookmarkStart(elem) {
        return this.createElement("span", {
            id: elem.name
        });
    }
    renderRun(elem) {
        if (elem.fieldRun) return null;
        const result = this.createElement("span");
        if (elem.id) result.id = elem.id;
        this.renderClass(elem, result);
        this.renderStyleValues(elem.cssStyle, result);
        if (elem.verticalAlign) {
            const wrapper = this.createElement(elem.verticalAlign);
            this.renderElements(elem.children, wrapper);
            result.appendChild(wrapper);
        } else this.renderElements(elem.children, result);
        return result;
    }
    renderTable(elem) {
        let result = this.createElement("table");
        this.tableCellPositions.push(this.currentCellPosition);
        this.tableVerticalMerges.push(this.currentVerticalMerge);
        this.currentVerticalMerge = {};
        this.currentCellPosition = {
            col: 0,
            row: 0
        };
        if (elem.columns) result.appendChild(this.renderTableColumns(elem.columns));
        this.renderClass(elem, result);
        this.renderElements(elem.children, result);
        this.renderStyleValues(elem.cssStyle, result);
        this.currentVerticalMerge = this.tableVerticalMerges.pop();
        this.currentCellPosition = this.tableCellPositions.pop();
        return result;
    }
    renderTableColumns(columns) {
        let result = this.createElement("colgroup");
        for (let col of columns){
            let colElem = this.createElement("col");
            if (col.width) colElem.style.width = col.width;
            result.appendChild(colElem);
        }
        return result;
    }
    renderTableRow(elem) {
        let result = this.createElement("tr");
        this.currentCellPosition.col = 0;
        if (elem.gridBefore) result.appendChild(this.renderTableCellPlaceholder(elem.gridBefore));
        this.renderClass(elem, result);
        this.renderElements(elem.children, result);
        this.renderStyleValues(elem.cssStyle, result);
        if (elem.gridAfter) result.appendChild(this.renderTableCellPlaceholder(elem.gridAfter));
        this.currentCellPosition.row++;
        return result;
    }
    renderTableCellPlaceholder(colSpan) {
        const result = this.createElement("td", {
            colSpan: colSpan
        });
        result.style['border'] = 'none';
        return result;
    }
    renderTableCell(elem) {
        let result = this.renderContainer(elem, "td");
        const key = this.currentCellPosition.col;
        if (elem.verticalMerge) {
            if (elem.verticalMerge == "restart") {
                this.currentVerticalMerge[key] = result;
                result.rowSpan = 1;
            } else if (this.currentVerticalMerge[key]) {
                this.currentVerticalMerge[key].rowSpan += 1;
                result.style.display = "none";
            }
        } else this.currentVerticalMerge[key] = null;
        this.renderClass(elem, result);
        this.renderStyleValues(elem.cssStyle, result);
        if (elem.span) result.colSpan = elem.span;
        this.currentCellPosition.col += result.colSpan;
        return result;
    }
    renderVmlPicture(elem) {
        return this.renderContainer(elem, "div");
    }
    renderVmlElement(elem) {
        var container = this.createSvgElement("svg");
        container.setAttribute("style", elem.cssStyleText);
        const result = this.renderVmlChildElement(elem);
        if (elem.imageHref?.id) this.tasks.push(this.document?.loadDocumentImage(elem.imageHref.id, this.currentPart).then((x)=>result.setAttribute("href", x)));
        container.appendChild(result);
        requestAnimationFrame(()=>{
            const bb = container.firstElementChild.getBBox();
            container.setAttribute("width", `${Math.ceil(bb.x + bb.width)}`);
            container.setAttribute("height", `${Math.ceil(bb.y + bb.height)}`);
        });
        return container;
    }
    renderVmlChildElement(elem) {
        const result = this.createSvgElement(elem.tagName);
        Object.entries(elem.attrs).forEach(([k, v])=>result.setAttribute(k, v));
        for (let child of elem.children)if (child.type == $68b4bc55b173684a$var$DomType.VmlElement) result.appendChild(this.renderVmlChildElement(child));
        else result.appendChild(...$68b4bc55b173684a$var$asArray(this.renderElement(child)));
        return result;
    }
    renderMmlRadical(elem) {
        const base = elem.children.find((el)=>el.type == $68b4bc55b173684a$var$DomType.MmlBase);
        if (elem.props?.hideDegree) return this.createElementNS($68b4bc55b173684a$var$ns.mathML, "msqrt", null, this.renderElements([
            base
        ]));
        const degree = elem.children.find((el)=>el.type == $68b4bc55b173684a$var$DomType.MmlDegree);
        return this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mroot", null, this.renderElements([
            base,
            degree
        ]));
    }
    renderMmlDelimiter(elem) {
        const children = [];
        children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, [
            elem.props.beginChar ?? '('
        ]));
        children.push(...this.renderElements(elem.children));
        children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, [
            elem.props.endChar ?? ')'
        ]));
        return this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mrow", null, children);
    }
    renderMmlNary(elem) {
        const children = [];
        const grouped = $68b4bc55b173684a$var$keyBy(elem.children, (x)=>x.type);
        const sup = grouped[$68b4bc55b173684a$var$DomType.MmlSuperArgument];
        const sub = grouped[$68b4bc55b173684a$var$DomType.MmlSubArgument];
        const supElem = sup ? this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, $68b4bc55b173684a$var$asArray(this.renderElement(sup))) : null;
        const subElem = sub ? this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, $68b4bc55b173684a$var$asArray(this.renderElement(sub))) : null;
        const charElem = this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, [
            elem.props?.char ?? '\u222B'
        ]);
        if (supElem || subElem) children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "munderover", null, [
            charElem,
            subElem,
            supElem
        ]));
        else if (supElem) children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mover", null, [
            charElem,
            supElem
        ]));
        else if (subElem) children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "munder", null, [
            charElem,
            subElem
        ]));
        else children.push(charElem);
        children.push(...this.renderElements(grouped[$68b4bc55b173684a$var$DomType.MmlBase].children));
        return this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mrow", null, children);
    }
    renderMmlPreSubSuper(elem) {
        const children = [];
        const grouped = $68b4bc55b173684a$var$keyBy(elem.children, (x)=>x.type);
        const sup = grouped[$68b4bc55b173684a$var$DomType.MmlSuperArgument];
        const sub = grouped[$68b4bc55b173684a$var$DomType.MmlSubArgument];
        const supElem = sup ? this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, $68b4bc55b173684a$var$asArray(this.renderElement(sup))) : null;
        const subElem = sub ? this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, $68b4bc55b173684a$var$asArray(this.renderElement(sub))) : null;
        const stubElem = this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null);
        children.push(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "msubsup", null, [
            stubElem,
            subElem,
            supElem
        ]));
        children.push(...this.renderElements(grouped[$68b4bc55b173684a$var$DomType.MmlBase].children));
        return this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mrow", null, children);
    }
    renderMmlGroupChar(elem) {
        const tagName = elem.props.verticalJustification === "bot" ? "mover" : "munder";
        const result = this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, tagName);
        if (elem.props.char) result.appendChild(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mo", null, [
            elem.props.char
        ]));
        return result;
    }
    renderMmlBar(elem) {
        const result = this.renderContainerNS(elem, $68b4bc55b173684a$var$ns.mathML, "mrow");
        switch(elem.props.position){
            case "top":
                result.style.textDecoration = "overline";
                break;
            case "bottom":
                result.style.textDecoration = "underline";
                break;
        }
        return result;
    }
    renderMmlRun(elem) {
        const result = this.createElementNS($68b4bc55b173684a$var$ns.mathML, "ms", null, this.renderElements(elem.children));
        this.renderClass(elem, result);
        this.renderStyleValues(elem.cssStyle, result);
        return result;
    }
    renderMllList(elem) {
        const result = this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mtable");
        this.renderClass(elem, result);
        this.renderStyleValues(elem.cssStyle, result);
        for (let child of this.renderElements(elem.children))result.appendChild(this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mtr", null, [
            this.createElementNS($68b4bc55b173684a$var$ns.mathML, "mtd", null, [
                child
            ])
        ]));
        return result;
    }
    renderStyleValues(style, ouput) {
        for(let k in style)if (k.startsWith("$")) ouput.setAttribute(k.slice(1), style[k]);
        else ouput.style[k] = style[k];
    }
    renderClass(input, ouput) {
        if (input.className) ouput.className = input.className;
        if (input.styleName) ouput.classList.add(this.processStyleName(input.styleName));
    }
    findStyle(styleName) {
        return styleName && this.styleMap?.[styleName];
    }
    numberingClass(id, lvl) {
        return `${this.className}-num-${id}-${lvl}`;
    }
    tabStopClass() {
        return `${this.className}-tab-stop`;
    }
    styleToString(selectors, values, cssText = null) {
        let result = `${selectors} {\r\n`;
        for(const key in values){
            if (key.startsWith('$')) continue;
            result += `  ${key}: ${values[key]};\r\n`;
        }
        if (cssText) result += cssText;
        return result + "}\r\n";
    }
    numberingCounter(id, lvl) {
        return `${this.className}-num-${id}-${lvl}`;
    }
    levelTextToContent(text, suff, id, numformat) {
        const suffMap = {
            "tab": "\\9",
            "space": "\\a0"
        };
        var result = text.replace(/%\d*/g, (s)=>{
            let lvl = parseInt(s.substring(1), 10) - 1;
            return `"counter(${this.numberingCounter(id, lvl)}, ${numformat})"`;
        });
        return `"${result}${suffMap[suff] ?? ""}"`;
    }
    numFormatToCssValue(format) {
        var mapping = {
            none: "none",
            bullet: "disc",
            decimal: "decimal",
            lowerLetter: "lower-alpha",
            upperLetter: "upper-alpha",
            lowerRoman: "lower-roman",
            upperRoman: "upper-roman",
            decimalZero: "decimal-leading-zero",
            aiueo: "katakana",
            aiueoFullWidth: "katakana",
            chineseCounting: "simp-chinese-informal",
            chineseCountingThousand: "simp-chinese-informal",
            chineseLegalSimplified: "simp-chinese-formal",
            chosung: "hangul-consonant",
            ideographDigital: "cjk-ideographic",
            ideographTraditional: "cjk-heavenly-stem",
            ideographLegalTraditional: "trad-chinese-formal",
            ideographZodiac: "cjk-earthly-branch",
            iroha: "katakana-iroha",
            irohaFullWidth: "katakana-iroha",
            japaneseCounting: "japanese-informal",
            japaneseDigitalTenThousand: "cjk-decimal",
            japaneseLegal: "japanese-formal",
            thaiNumbers: "thai",
            koreanCounting: "korean-hangul-formal",
            koreanDigital: "korean-hangul-formal",
            koreanDigital2: "korean-hanja-informal",
            hebrew1: "hebrew",
            hebrew2: "hebrew",
            hindiNumbers: "devanagari",
            ganada: "hangul",
            taiwaneseCounting: "cjk-ideographic",
            taiwaneseCountingThousand: "cjk-ideographic",
            taiwaneseDigital: "cjk-decimal"
        };
        return mapping[format] ?? format;
    }
    refreshTabStops() {
        if (!this.options.experimental) return;
        setTimeout(()=>{
            const pixelToPoint = $68b4bc55b173684a$var$computePixelToPoint();
            for (let tab of this.currentTabs)$68b4bc55b173684a$var$updateTabStop(tab.span, tab.stops, this.defaultTabSize, pixelToPoint);
        }, 500);
    }
    createElementNS(ns, tagName, props, children) {
        var result = ns ? this.htmlDocument.createElementNS(ns, tagName) : this.htmlDocument.createElement(tagName);
        Object.assign(result, props);
        children && $68b4bc55b173684a$var$appendChildren(result, children);
        return result;
    }
    createElement(tagName, props, children) {
        return this.createElementNS(undefined, tagName, props, children);
    }
    createSvgElement(tagName, props, children) {
        return this.createElementNS($68b4bc55b173684a$var$ns.svg, tagName, props, children);
    }
    createStyleElement(cssText) {
        return this.createElement("style", {
            innerHTML: cssText
        });
    }
    createComment(text) {
        return this.htmlDocument.createComment(text);
    }
    later(func) {
        this.postRenderTasks.push(func);
    }
}
function $68b4bc55b173684a$var$removeAllElements(elem) {
    elem.innerHTML = '';
}
function $68b4bc55b173684a$var$appendChildren(elem, children) {
    children.forEach((c)=>elem.appendChild($68b4bc55b173684a$var$isString(c) ? document.createTextNode(c) : c));
}
function $68b4bc55b173684a$var$findParent(elem, type) {
    var parent = elem.parent;
    while(parent != null && parent.type != type)parent = parent.parent;
    return parent;
}
const $68b4bc55b173684a$export$ba43bf67f3d48107 = {
    ignoreHeight: false,
    ignoreWidth: false,
    ignoreFonts: false,
    breakPages: true,
    debug: false,
    experimental: false,
    className: "docx",
    inWrapper: true,
    hideWrapperOnPrint: false,
    trimXmlDeclaration: true,
    ignoreLastRenderedPageBreak: true,
    renderHeaders: true,
    renderFooters: true,
    renderFootnotes: true,
    renderEndnotes: true,
    useBase64URL: false,
    renderChanges: false,
    renderComments: false,
    renderAltChunks: true
};
function $68b4bc55b173684a$export$59b6f938fbf579e3(data, userOptions) {
    const ops = {
        ...$68b4bc55b173684a$export$ba43bf67f3d48107,
        ...userOptions
    };
    return $68b4bc55b173684a$var$WordDocument.load(data, new $68b4bc55b173684a$var$DocumentParser(ops), ops);
}
async function $68b4bc55b173684a$export$59a54f98b9753d5c(document1, bodyContainer, styleContainer, userOptions) {
    const ops = {
        ...$68b4bc55b173684a$export$ba43bf67f3d48107,
        ...userOptions
    };
    const renderer = new $68b4bc55b173684a$var$HtmlRenderer(window.document);
    return await renderer.render(document1, bodyContainer, styleContainer, ops);
}
async function $68b4bc55b173684a$export$e1ac4cfb687370e8(data, bodyContainer, styleContainer, userOptions) {
    const doc = await $68b4bc55b173684a$export$59b6f938fbf579e3(data, userOptions);
    await $68b4bc55b173684a$export$59a54f98b9753d5c(doc, bodyContainer, styleContainer, userOptions);
    return doc;
}


/*! pako 2.2.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $cab713332464fe22$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $cab713332464fe22$var$Z_BINARY = 0;
const $cab713332464fe22$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $cab713332464fe22$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $cab713332464fe22$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $cab713332464fe22$var$STORED_BLOCK = 0;
const $cab713332464fe22$var$STATIC_TREES = 1;
const $cab713332464fe22$var$DYN_TREES = 2;
/* The three kinds of block type */ const $cab713332464fe22$var$MIN_MATCH$1 = 3;
const $cab713332464fe22$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $cab713332464fe22$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $cab713332464fe22$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $cab713332464fe22$var$L_CODES$1 = $cab713332464fe22$var$LITERALS$1 + 1 + $cab713332464fe22$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $cab713332464fe22$var$D_CODES$1 = 30;
/* number of distance codes */ const $cab713332464fe22$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $cab713332464fe22$var$HEAP_SIZE$1 = 2 * $cab713332464fe22$var$L_CODES$1 + 1;
/* maximum heap size */ const $cab713332464fe22$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $cab713332464fe22$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $cab713332464fe22$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $cab713332464fe22$var$END_BLOCK = 256;
/* end of block literal code */ const $cab713332464fe22$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $cab713332464fe22$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $cab713332464fe22$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $cab713332464fe22$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $cab713332464fe22$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $cab713332464fe22$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $cab713332464fe22$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $cab713332464fe22$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $cab713332464fe22$var$static_ltree = new Array(($cab713332464fe22$var$L_CODES$1 + 2) * 2);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $cab713332464fe22$var$static_dtree = new Array($cab713332464fe22$var$D_CODES$1 * 2);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $cab713332464fe22$var$_dist_code = new Array($cab713332464fe22$var$DIST_CODE_LEN);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $cab713332464fe22$var$_length_code = new Array($cab713332464fe22$var$MAX_MATCH$1 - $cab713332464fe22$var$MIN_MATCH$1 + 1);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $cab713332464fe22$var$base_length = new Array($cab713332464fe22$var$LENGTH_CODES$1);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $cab713332464fe22$var$base_dist = new Array($cab713332464fe22$var$D_CODES$1);
$cab713332464fe22$var$zero$1($cab713332464fe22$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cab713332464fe22$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $cab713332464fe22$var$static_l_desc;
let $cab713332464fe22$var$static_d_desc;
let $cab713332464fe22$var$static_bl_desc;
function $cab713332464fe22$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $cab713332464fe22$var$d_code = (dist)=>{
    return dist < 256 ? $cab713332464fe22$var$_dist_code[dist] : $cab713332464fe22$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $cab713332464fe22$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $cab713332464fe22$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $cab713332464fe22$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cab713332464fe22$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cab713332464fe22$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cab713332464fe22$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $cab713332464fe22$var$send_code = (s, c, tree)=>{
    $cab713332464fe22$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $cab713332464fe22$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $cab713332464fe22$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $cab713332464fe22$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $cab713332464fe22$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cab713332464fe22$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cab713332464fe22$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $cab713332464fe22$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($cab713332464fe22$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cab713332464fe22$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cab713332464fe22$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $cab713332464fe22$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($cab713332464fe22$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cab713332464fe22$var$LENGTH_CODES$1 - 1; code++){
        $cab713332464fe22$var$base_length[code] = length;
        for(n = 0; n < 1 << $cab713332464fe22$var$extra_lbits[code]; n++)$cab713332464fe22$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cab713332464fe22$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cab713332464fe22$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cab713332464fe22$var$extra_dbits[code]; n++)$cab713332464fe22$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cab713332464fe22$var$D_CODES$1; code++){
        $cab713332464fe22$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cab713332464fe22$var$extra_dbits[code] - 7; n++)$cab713332464fe22$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cab713332464fe22$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cab713332464fe22$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cab713332464fe22$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cab713332464fe22$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cab713332464fe22$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cab713332464fe22$var$gen_codes($cab713332464fe22$var$static_ltree, $cab713332464fe22$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cab713332464fe22$var$D_CODES$1; n++){
        $cab713332464fe22$var$static_dtree[n * 2 + 1] = 5;
        $cab713332464fe22$var$static_dtree[n * 2] = $cab713332464fe22$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cab713332464fe22$var$static_l_desc = new $cab713332464fe22$var$StaticTreeDesc($cab713332464fe22$var$static_ltree, $cab713332464fe22$var$extra_lbits, $cab713332464fe22$var$LITERALS$1 + 1, $cab713332464fe22$var$L_CODES$1, $cab713332464fe22$var$MAX_BITS$1);
    $cab713332464fe22$var$static_d_desc = new $cab713332464fe22$var$StaticTreeDesc($cab713332464fe22$var$static_dtree, $cab713332464fe22$var$extra_dbits, 0, $cab713332464fe22$var$D_CODES$1, $cab713332464fe22$var$MAX_BITS$1);
    $cab713332464fe22$var$static_bl_desc = new $cab713332464fe22$var$StaticTreeDesc(new Array(0), $cab713332464fe22$var$extra_blbits, 0, $cab713332464fe22$var$BL_CODES$1, $cab713332464fe22$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $cab713332464fe22$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cab713332464fe22$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cab713332464fe22$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cab713332464fe22$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cab713332464fe22$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $cab713332464fe22$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $cab713332464fe22$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $cab713332464fe22$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $cab713332464fe22$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cab713332464fe22$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cab713332464fe22$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $cab713332464fe22$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $cab713332464fe22$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cab713332464fe22$var$_length_code[lc];
            $cab713332464fe22$var$send_code(s, code + $cab713332464fe22$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $cab713332464fe22$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cab713332464fe22$var$base_length[code];
                $cab713332464fe22$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cab713332464fe22$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cab713332464fe22$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cab713332464fe22$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cab713332464fe22$var$base_dist[code];
                $cab713332464fe22$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $cab713332464fe22$var$send_code(s, $cab713332464fe22$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $cab713332464fe22$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cab713332464fe22$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cab713332464fe22$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cab713332464fe22$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cab713332464fe22$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cab713332464fe22$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cab713332464fe22$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $cab713332464fe22$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cab713332464fe22$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cab713332464fe22$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cab713332464fe22$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $cab713332464fe22$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cab713332464fe22$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cab713332464fe22$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cab713332464fe22$var$send_code(s, $cab713332464fe22$var$REP_3_6, s.bl_tree);
            $cab713332464fe22$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cab713332464fe22$var$send_code(s, $cab713332464fe22$var$REPZ_3_10, s.bl_tree);
            $cab713332464fe22$var$send_bits(s, count - 3, 3);
        } else {
            $cab713332464fe22$var$send_code(s, $cab713332464fe22$var$REPZ_11_138, s.bl_tree);
            $cab713332464fe22$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $cab713332464fe22$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cab713332464fe22$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cab713332464fe22$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cab713332464fe22$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cab713332464fe22$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cab713332464fe22$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $cab713332464fe22$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cab713332464fe22$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cab713332464fe22$var$send_bits(s, dcodes - 1, 5);
    $cab713332464fe22$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cab713332464fe22$var$send_bits(s, s.bl_tree[$cab713332464fe22$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cab713332464fe22$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cab713332464fe22$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $cab713332464fe22$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cab713332464fe22$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cab713332464fe22$var$Z_TEXT;
    for(n = 32; n < $cab713332464fe22$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cab713332464fe22$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cab713332464fe22$var$Z_BINARY;
};
let $cab713332464fe22$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $cab713332464fe22$var$_tr_init$1 = (s)=>{
    if (!$cab713332464fe22$var$static_init_done) {
        $cab713332464fe22$var$tr_static_init();
        $cab713332464fe22$var$static_init_done = true;
    }
    s.l_desc = new $cab713332464fe22$var$TreeDesc(s.dyn_ltree, $cab713332464fe22$var$static_l_desc);
    s.d_desc = new $cab713332464fe22$var$TreeDesc(s.dyn_dtree, $cab713332464fe22$var$static_d_desc);
    s.bl_desc = new $cab713332464fe22$var$TreeDesc(s.bl_tree, $cab713332464fe22$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cab713332464fe22$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $cab713332464fe22$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $cab713332464fe22$var$send_bits(s, ($cab713332464fe22$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cab713332464fe22$var$bi_windup(s); /* align on byte boundary */ 
    $cab713332464fe22$var$put_short(s, stored_len);
    $cab713332464fe22$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $cab713332464fe22$var$_tr_align$1 = (s)=>{
    $cab713332464fe22$var$send_bits(s, $cab713332464fe22$var$STATIC_TREES << 1, 3);
    $cab713332464fe22$var$send_code(s, $cab713332464fe22$var$END_BLOCK, $cab713332464fe22$var$static_ltree);
    $cab713332464fe22$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $cab713332464fe22$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cab713332464fe22$var$Z_UNKNOWN$1) s.strm.data_type = $cab713332464fe22$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cab713332464fe22$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cab713332464fe22$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cab713332464fe22$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cab713332464fe22$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $cab713332464fe22$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $cab713332464fe22$var$send_bits(s, ($cab713332464fe22$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cab713332464fe22$var$compress_block(s, $cab713332464fe22$var$static_ltree, $cab713332464fe22$var$static_dtree);
    } else {
        $cab713332464fe22$var$send_bits(s, ($cab713332464fe22$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cab713332464fe22$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cab713332464fe22$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cab713332464fe22$var$init_block(s);
    if (last) $cab713332464fe22$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $cab713332464fe22$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cab713332464fe22$var$_length_code[lc] + $cab713332464fe22$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$cab713332464fe22$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $cab713332464fe22$var$_tr_init_1 = $cab713332464fe22$var$_tr_init$1;
var $cab713332464fe22$var$_tr_stored_block_1 = $cab713332464fe22$var$_tr_stored_block$1;
var $cab713332464fe22$var$_tr_flush_block_1 = $cab713332464fe22$var$_tr_flush_block$1;
var $cab713332464fe22$var$_tr_tally_1 = $cab713332464fe22$var$_tr_tally$1;
var $cab713332464fe22$var$_tr_align_1 = $cab713332464fe22$var$_tr_align$1;
var $cab713332464fe22$var$trees = {
    _tr_init: $cab713332464fe22$var$_tr_init_1,
    _tr_stored_block: $cab713332464fe22$var$_tr_stored_block_1,
    _tr_flush_block: $cab713332464fe22$var$_tr_flush_block_1,
    _tr_tally: $cab713332464fe22$var$_tr_tally_1,
    _tr_align: $cab713332464fe22$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $cab713332464fe22$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $cab713332464fe22$var$adler32_1 = $cab713332464fe22$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $cab713332464fe22$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $cab713332464fe22$var$crcTable = new Uint32Array($cab713332464fe22$var$makeTable());
const $cab713332464fe22$var$crc32 = (crc, buf, len, pos)=>{
    const t = $cab713332464fe22$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $cab713332464fe22$var$crc32_1 = $cab713332464fe22$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $cab713332464fe22$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $cab713332464fe22$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $cab713332464fe22$var$_tr_init, _tr_stored_block: $cab713332464fe22$var$_tr_stored_block, _tr_flush_block: $cab713332464fe22$var$_tr_flush_block, _tr_tally: $cab713332464fe22$var$_tr_tally, _tr_align: $cab713332464fe22$var$_tr_align } = $cab713332464fe22$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $cab713332464fe22$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $cab713332464fe22$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $cab713332464fe22$var$Z_FULL_FLUSH$1, Z_FINISH: $cab713332464fe22$var$Z_FINISH$3, Z_BLOCK: $cab713332464fe22$var$Z_BLOCK$1, Z_OK: $cab713332464fe22$var$Z_OK$3, Z_STREAM_END: $cab713332464fe22$var$Z_STREAM_END$3, Z_STREAM_ERROR: $cab713332464fe22$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $cab713332464fe22$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $cab713332464fe22$var$Z_BUF_ERROR$2, Z_DEFAULT_COMPRESSION: $cab713332464fe22$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $cab713332464fe22$var$Z_FILTERED, Z_HUFFMAN_ONLY: $cab713332464fe22$var$Z_HUFFMAN_ONLY, Z_RLE: $cab713332464fe22$var$Z_RLE, Z_FIXED: $cab713332464fe22$var$Z_FIXED, Z_DEFAULT_STRATEGY: $cab713332464fe22$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $cab713332464fe22$var$Z_UNKNOWN, Z_DEFLATED: $cab713332464fe22$var$Z_DEFLATED$2 } = $cab713332464fe22$var$constants$2;
/*============================================================================*/ const $cab713332464fe22$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $cab713332464fe22$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $cab713332464fe22$var$DEF_MEM_LEVEL = 8;
const $cab713332464fe22$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $cab713332464fe22$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $cab713332464fe22$var$L_CODES = $cab713332464fe22$var$LITERALS + 1 + $cab713332464fe22$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $cab713332464fe22$var$D_CODES = 30;
/* number of distance codes */ const $cab713332464fe22$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $cab713332464fe22$var$HEAP_SIZE = 2 * $cab713332464fe22$var$L_CODES + 1;
/* maximum heap size */ const $cab713332464fe22$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $cab713332464fe22$var$MIN_MATCH = 3;
const $cab713332464fe22$var$MAX_MATCH = 258;
const $cab713332464fe22$var$MIN_LOOKAHEAD = $cab713332464fe22$var$MAX_MATCH + $cab713332464fe22$var$MIN_MATCH + 1;
const $cab713332464fe22$var$PRESET_DICT = 0x20;
const $cab713332464fe22$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $cab713332464fe22$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $cab713332464fe22$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $cab713332464fe22$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $cab713332464fe22$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $cab713332464fe22$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $cab713332464fe22$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $cab713332464fe22$var$FINISH_STATE = 666; /* stream complete */ 
const $cab713332464fe22$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $cab713332464fe22$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $cab713332464fe22$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $cab713332464fe22$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $cab713332464fe22$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $cab713332464fe22$var$err = (strm, errorCode)=>{
    strm.msg = $cab713332464fe22$var$messages[errorCode];
    return errorCode;
};
const $cab713332464fe22$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $cab713332464fe22$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $cab713332464fe22$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $cab713332464fe22$var$HASH = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
/* ===========================================================================
 * Insert string str in the dictionary and set match_head to the previous head
 * of the hash chain (the most recent string with same hash key). Return
 * the previous length of the hash chain.
 * IN  assertion: all calls to INSERT_STRING are made with consecutive input
 *    characters and the first MIN_MATCH bytes of str are valid (except for
 *    the last MIN_MATCH-1 bytes of the input file).
 */ const $cab713332464fe22$var$INSERT_STRING = (s, str)=>{
    let h;
    if (s.legacy_hash) /* UPDATE_HASH(s, s->ins_h, s->window[(str) + (MIN_MATCH-1)]); */ h = s.ins_h = $cab713332464fe22$var$HASH(s, s.ins_h, s.window[str + $cab713332464fe22$var$MIN_MATCH - 1]);
    else {
        // ANZAC++ hash: reads 4 bytes, matches node.js zlib output (legacyHash
        // restores classic zlib hash). Faster, with fewer collisions.
        const w = s.window;
        // Read 4 bytes little-endian. Math.imul reproduces C uint32 overflow in
        // `(value * 66521 + 66521) >> 16` exactly.
        const value = w[str] | w[str + 1] << 8 | w[str + 2] << 16 | w[str + 3] << 24;
        h = s.ins_h = Math.imul(value, 66521) + 66521 >>> 16 & s.hash_mask;
    }
    const hash_head = s.prev[str & s.w_mask] = s.head[h];
    s.head[h] = str;
    return hash_head;
};
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $cab713332464fe22$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $cab713332464fe22$var$flush_block_only = (s, last)=>{
    $cab713332464fe22$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $cab713332464fe22$var$flush_pending(s.strm);
};
const $cab713332464fe22$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $cab713332464fe22$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $cab713332464fe22$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $cab713332464fe22$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $cab713332464fe22$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $cab713332464fe22$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $cab713332464fe22$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $cab713332464fe22$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $cab713332464fe22$var$MAX_MATCH - (strend - scan);
        scan = strend - $cab713332464fe22$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $cab713332464fe22$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $cab713332464fe22$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $cab713332464fe22$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $cab713332464fe22$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (!s.legacy_hash) /* The 4-byte hash reads one extra byte, so it needs one more available. */ {
            if (s.lookahead + s.insert > $cab713332464fe22$var$MIN_MATCH) {
                str = s.strstart - s.insert;
                while(s.insert){
                    $cab713332464fe22$var$INSERT_STRING(s, str);
                    str++;
                    s.insert--;
                    if (s.lookahead + s.insert <= $cab713332464fe22$var$MIN_MATCH) break;
                }
            }
        } else if (s.lookahead + s.insert >= $cab713332464fe22$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $cab713332464fe22$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                $cab713332464fe22$var$INSERT_STRING(s, str);
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $cab713332464fe22$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $cab713332464fe22$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $cab713332464fe22$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $cab713332464fe22$var$Z_FINISH$3 || flush === $cab713332464fe22$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $cab713332464fe22$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $cab713332464fe22$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $cab713332464fe22$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $cab713332464fe22$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $cab713332464fe22$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $cab713332464fe22$var$Z_NO_FLUSH$2 && flush !== $cab713332464fe22$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $cab713332464fe22$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $cab713332464fe22$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $cab713332464fe22$var$Z_FINISH$3) && flush !== $cab713332464fe22$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $cab713332464fe22$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $cab713332464fe22$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $cab713332464fe22$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $cab713332464fe22$var$BS_FINISH_STARTED : $cab713332464fe22$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $cab713332464fe22$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $cab713332464fe22$var$MIN_LOOKAHEAD) {
            $cab713332464fe22$var$fill_window(s);
            if (s.lookahead < $cab713332464fe22$var$MIN_LOOKAHEAD && flush === $cab713332464fe22$var$Z_NO_FLUSH$2) return $cab713332464fe22$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $cab713332464fe22$var$MIN_MATCH) hash_head = $cab713332464fe22$var$INSERT_STRING(s, s.strstart);
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $cab713332464fe22$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $cab713332464fe22$var$longest_match(s, hash_head);
        if (s.match_length >= $cab713332464fe22$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $cab713332464fe22$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $cab713332464fe22$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    hash_head = $cab713332464fe22$var$INSERT_STRING(s, s.strstart);
                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                if (s.legacy_hash) {
                    s.ins_h = s.window[s.strstart];
                    /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $cab713332464fe22$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
                //#if MIN_MATCH != 3
                //                Call UPDATE_HASH() MIN_MATCH-3 more times
                //#endif
                /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
           * matter since it will be recomputed at next deflate call.
           */ }
            }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $cab713332464fe22$var$MIN_MATCH - 1 ? s.strstart : $cab713332464fe22$var$MIN_MATCH - 1;
    if (flush === $cab713332464fe22$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cab713332464fe22$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_FINISH_STARTED;
        /***/ return $cab713332464fe22$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
    /***/ }
    return $cab713332464fe22$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $cab713332464fe22$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $cab713332464fe22$var$MIN_LOOKAHEAD) {
            $cab713332464fe22$var$fill_window(s);
            if (s.lookahead < $cab713332464fe22$var$MIN_LOOKAHEAD && flush === $cab713332464fe22$var$Z_NO_FLUSH$2) return $cab713332464fe22$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $cab713332464fe22$var$MIN_MATCH) hash_head = $cab713332464fe22$var$INSERT_STRING(s, s.strstart);
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $cab713332464fe22$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $cab713332464fe22$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $cab713332464fe22$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $cab713332464fe22$var$Z_FILTERED || s.match_length === $cab713332464fe22$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $cab713332464fe22$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $cab713332464fe22$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $cab713332464fe22$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $cab713332464fe22$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $cab713332464fe22$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) hash_head = $cab713332464fe22$var$INSERT_STRING(s, s.strstart);
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $cab713332464fe22$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $cab713332464fe22$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $cab713332464fe22$var$MIN_MATCH - 1 ? s.strstart : $cab713332464fe22$var$MIN_MATCH - 1;
    if (flush === $cab713332464fe22$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cab713332464fe22$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_FINISH_STARTED;
        /***/ return $cab713332464fe22$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
    /***/ }
    return $cab713332464fe22$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $cab713332464fe22$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $cab713332464fe22$var$MAX_MATCH) {
            $cab713332464fe22$var$fill_window(s);
            if (s.lookahead <= $cab713332464fe22$var$MAX_MATCH && flush === $cab713332464fe22$var$Z_NO_FLUSH$2) return $cab713332464fe22$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $cab713332464fe22$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $cab713332464fe22$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $cab713332464fe22$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $cab713332464fe22$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 1, s.match_length - $cab713332464fe22$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $cab713332464fe22$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cab713332464fe22$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_FINISH_STARTED;
        /***/ return $cab713332464fe22$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
    /***/ }
    return $cab713332464fe22$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $cab713332464fe22$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $cab713332464fe22$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $cab713332464fe22$var$Z_NO_FLUSH$2) return $cab713332464fe22$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cab713332464fe22$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $cab713332464fe22$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cab713332464fe22$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_FINISH_STARTED;
        /***/ return $cab713332464fe22$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cab713332464fe22$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cab713332464fe22$var$BS_NEED_MORE;
    /***/ }
    return $cab713332464fe22$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $cab713332464fe22$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $cab713332464fe22$var$configuration_table = [
    /*      good lazy nice chain */ new $cab713332464fe22$var$Config(0, 0, 0, 0, $cab713332464fe22$var$deflate_stored),
    /* 0 store only */ new $cab713332464fe22$var$Config(4, 4, 8, 4, $cab713332464fe22$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $cab713332464fe22$var$Config(4, 5, 16, 8, $cab713332464fe22$var$deflate_fast),
    /* 2 */ new $cab713332464fe22$var$Config(4, 6, 32, 32, $cab713332464fe22$var$deflate_fast),
    /* 3 */ new $cab713332464fe22$var$Config(4, 4, 16, 16, $cab713332464fe22$var$deflate_slow),
    /* 4 lazy matches */ new $cab713332464fe22$var$Config(8, 16, 32, 32, $cab713332464fe22$var$deflate_slow),
    /* 5 */ new $cab713332464fe22$var$Config(8, 16, 128, 128, $cab713332464fe22$var$deflate_slow),
    /* 6 */ new $cab713332464fe22$var$Config(8, 32, 128, 256, $cab713332464fe22$var$deflate_slow),
    /* 7 */ new $cab713332464fe22$var$Config(32, 128, 258, 1024, $cab713332464fe22$var$deflate_slow),
    /* 8 */ new $cab713332464fe22$var$Config(32, 258, 258, 4096, $cab713332464fe22$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $cab713332464fe22$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $cab713332464fe22$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $cab713332464fe22$var$configuration_table[s.level].max_lazy;
    s.good_match = $cab713332464fe22$var$configuration_table[s.level].good_length;
    s.nice_match = $cab713332464fe22$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $cab713332464fe22$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $cab713332464fe22$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $cab713332464fe22$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $cab713332464fe22$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.legacy_hash = 0; /* use classic zlib hash instead of default ANZAC++ */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($cab713332464fe22$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $cab713332464fe22$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $cab713332464fe22$var$BL_CODES + 1) * 2);
    $cab713332464fe22$var$zero(this.dyn_ltree);
    $cab713332464fe22$var$zero(this.dyn_dtree);
    $cab713332464fe22$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($cab713332464fe22$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $cab713332464fe22$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $cab713332464fe22$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $cab713332464fe22$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $cab713332464fe22$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $cab713332464fe22$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $cab713332464fe22$var$INIT_STATE && //#ifdef GZIP
    s.status !== $cab713332464fe22$var$GZIP_STATE && //#endif
    s.status !== $cab713332464fe22$var$EXTRA_STATE && s.status !== $cab713332464fe22$var$NAME_STATE && s.status !== $cab713332464fe22$var$COMMENT_STATE && s.status !== $cab713332464fe22$var$HCRC_STATE && s.status !== $cab713332464fe22$var$BUSY_STATE && s.status !== $cab713332464fe22$var$FINISH_STATE) return 1;
    return 0;
};
const $cab713332464fe22$var$deflateResetKeep = (strm)=>{
    if ($cab713332464fe22$var$deflateStateCheck(strm)) return $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $cab713332464fe22$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $cab713332464fe22$var$GZIP_STATE : //#endif
    s.wrap ? $cab713332464fe22$var$INIT_STATE : $cab713332464fe22$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $cab713332464fe22$var$_tr_init(s);
    return $cab713332464fe22$var$Z_OK$3;
};
const $cab713332464fe22$var$deflateReset = (strm)=>{
    const ret = $cab713332464fe22$var$deflateResetKeep(strm);
    if (ret === $cab713332464fe22$var$Z_OK$3) $cab713332464fe22$var$lm_init(strm.state);
    return ret;
};
const $cab713332464fe22$var$deflateSetHeader = (strm, head)=>{
    if ($cab713332464fe22$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $cab713332464fe22$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $cab713332464fe22$var$Z_OK$3;
};
const $cab713332464fe22$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy, legacyHash)=>{
    if (!strm) return $cab713332464fe22$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $cab713332464fe22$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $cab713332464fe22$var$MAX_MEM_LEVEL || method !== $cab713332464fe22$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $cab713332464fe22$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $cab713332464fe22$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $cab713332464fe22$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.legacy_hash = legacyHash ? 1 : 0;
    s.hash_bits = memLevel + 7;
    /* ANZAC++ hash needs >= 15 hash bits to span its 4 read bytes. */ if (!s.legacy_hash && s.hash_bits < 15) s.hash_bits = 15;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $cab713332464fe22$var$MIN_MATCH - 1) / $cab713332464fe22$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $cab713332464fe22$var$deflateReset(strm);
};
const $cab713332464fe22$var$deflateInit = (strm, level)=>{
    return $cab713332464fe22$var$deflateInit2(strm, level, $cab713332464fe22$var$Z_DEFLATED$2, $cab713332464fe22$var$MAX_WBITS$1, $cab713332464fe22$var$DEF_MEM_LEVEL, $cab713332464fe22$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $cab713332464fe22$var$deflate$2 = (strm, flush)=>{
    if ($cab713332464fe22$var$deflateStateCheck(strm) || flush > $cab713332464fe22$var$Z_BLOCK$1 || flush < 0) return strm ? $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_STREAM_ERROR$2) : $cab713332464fe22$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $cab713332464fe22$var$FINISH_STATE && flush !== $cab713332464fe22$var$Z_FINISH$3) return $cab713332464fe22$var$err(strm, strm.avail_out === 0 ? $cab713332464fe22$var$Z_BUF_ERROR$2 : $cab713332464fe22$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $cab713332464fe22$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $cab713332464fe22$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $cab713332464fe22$var$rank(flush) <= $cab713332464fe22$var$rank(old_flush) && flush !== $cab713332464fe22$var$Z_FINISH$3) return $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_BUF_ERROR$2);
    /* User must not provide more input after the first FINISH: */ if (s.status === $cab713332464fe22$var$FINISH_STATE && strm.avail_in !== 0) return $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_BUF_ERROR$2);
    /* Write the header */ if (s.status === $cab713332464fe22$var$INIT_STATE && s.wrap === 0) s.status = $cab713332464fe22$var$BUSY_STATE;
    if (s.status === $cab713332464fe22$var$INIT_STATE) {
        /* zlib header */ let header = $cab713332464fe22$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $cab713332464fe22$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $cab713332464fe22$var$PRESET_DICT;
        header += 31 - header % 31;
        $cab713332464fe22$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $cab713332464fe22$var$putShortMSB(s, strm.adler >>> 16);
            $cab713332464fe22$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $cab713332464fe22$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $cab713332464fe22$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $cab713332464fe22$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $cab713332464fe22$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $cab713332464fe22$var$put_byte(s, 31);
        $cab713332464fe22$var$put_byte(s, 139);
        $cab713332464fe22$var$put_byte(s, 8);
        if (!s.gzhead) {
            $cab713332464fe22$var$put_byte(s, 0);
            $cab713332464fe22$var$put_byte(s, 0);
            $cab713332464fe22$var$put_byte(s, 0);
            $cab713332464fe22$var$put_byte(s, 0);
            $cab713332464fe22$var$put_byte(s, 0);
            $cab713332464fe22$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $cab713332464fe22$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $cab713332464fe22$var$put_byte(s, $cab713332464fe22$var$OS_CODE);
            s.status = $cab713332464fe22$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $cab713332464fe22$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $cab713332464fe22$var$Z_OK$3;
            }
        } else {
            $cab713332464fe22$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $cab713332464fe22$var$put_byte(s, s.gzhead.time & 0xff);
            $cab713332464fe22$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $cab713332464fe22$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $cab713332464fe22$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $cab713332464fe22$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $cab713332464fe22$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $cab713332464fe22$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $cab713332464fe22$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $cab713332464fe22$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $cab713332464fe22$var$EXTRA_STATE;
        }
    }
    if (s.status === $cab713332464fe22$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $cab713332464fe22$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $cab713332464fe22$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $cab713332464fe22$var$NAME_STATE;
    }
    if (s.status === $cab713332464fe22$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $cab713332464fe22$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $cab713332464fe22$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $cab713332464fe22$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $cab713332464fe22$var$COMMENT_STATE;
    }
    if (s.status === $cab713332464fe22$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $cab713332464fe22$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $cab713332464fe22$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $cab713332464fe22$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $cab713332464fe22$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $cab713332464fe22$var$HCRC_STATE;
    }
    if (s.status === $cab713332464fe22$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $cab713332464fe22$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $cab713332464fe22$var$Z_OK$3;
                }
            }
            $cab713332464fe22$var$put_byte(s, strm.adler & 0xff);
            $cab713332464fe22$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $cab713332464fe22$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $cab713332464fe22$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $cab713332464fe22$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $cab713332464fe22$var$Z_NO_FLUSH$2 && s.status !== $cab713332464fe22$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $cab713332464fe22$var$deflate_stored(s, flush) : s.strategy === $cab713332464fe22$var$Z_HUFFMAN_ONLY ? $cab713332464fe22$var$deflate_huff(s, flush) : s.strategy === $cab713332464fe22$var$Z_RLE ? $cab713332464fe22$var$deflate_rle(s, flush) : $cab713332464fe22$var$configuration_table[s.level].func(s, flush);
        if (bstate === $cab713332464fe22$var$BS_FINISH_STARTED || bstate === $cab713332464fe22$var$BS_FINISH_DONE) s.status = $cab713332464fe22$var$FINISH_STATE;
        if (bstate === $cab713332464fe22$var$BS_NEED_MORE || bstate === $cab713332464fe22$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $cab713332464fe22$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $cab713332464fe22$var$BS_BLOCK_DONE) {
            if (flush === $cab713332464fe22$var$Z_PARTIAL_FLUSH) $cab713332464fe22$var$_tr_align(s);
            else if (flush !== $cab713332464fe22$var$Z_BLOCK$1) {
                $cab713332464fe22$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $cab713332464fe22$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $cab713332464fe22$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $cab713332464fe22$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $cab713332464fe22$var$Z_OK$3;
            }
        }
    }
    if (flush !== $cab713332464fe22$var$Z_FINISH$3) return $cab713332464fe22$var$Z_OK$3;
    if (s.wrap <= 0) return $cab713332464fe22$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $cab713332464fe22$var$put_byte(s, strm.adler & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.adler >> 8 & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.adler >> 16 & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.adler >> 24 & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.total_in & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $cab713332464fe22$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $cab713332464fe22$var$putShortMSB(s, strm.adler >>> 16);
        $cab713332464fe22$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $cab713332464fe22$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $cab713332464fe22$var$Z_OK$3 : $cab713332464fe22$var$Z_STREAM_END$3;
};
const $cab713332464fe22$var$deflateEnd = (strm)=>{
    if ($cab713332464fe22$var$deflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $cab713332464fe22$var$BUSY_STATE ? $cab713332464fe22$var$err(strm, $cab713332464fe22$var$Z_DATA_ERROR$2) : $cab713332464fe22$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $cab713332464fe22$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($cab713332464fe22$var$deflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $cab713332464fe22$var$INIT_STATE || s.lookahead) return $cab713332464fe22$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $cab713332464fe22$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $cab713332464fe22$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $cab713332464fe22$var$fill_window(s);
    while(s.lookahead >= $cab713332464fe22$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($cab713332464fe22$var$MIN_MATCH - 1);
        do {
            $cab713332464fe22$var$INSERT_STRING(s, str);
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $cab713332464fe22$var$MIN_MATCH - 1;
        $cab713332464fe22$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $cab713332464fe22$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $cab713332464fe22$var$Z_OK$3;
};
var $cab713332464fe22$var$deflateInit_1 = $cab713332464fe22$var$deflateInit;
var $cab713332464fe22$var$deflateInit2_1 = $cab713332464fe22$var$deflateInit2;
var $cab713332464fe22$var$deflateReset_1 = $cab713332464fe22$var$deflateReset;
var $cab713332464fe22$var$deflateResetKeep_1 = $cab713332464fe22$var$deflateResetKeep;
var $cab713332464fe22$var$deflateSetHeader_1 = $cab713332464fe22$var$deflateSetHeader;
var $cab713332464fe22$var$deflate_2$1 = $cab713332464fe22$var$deflate$2;
var $cab713332464fe22$var$deflateEnd_1 = $cab713332464fe22$var$deflateEnd;
var $cab713332464fe22$var$deflateSetDictionary_1 = $cab713332464fe22$var$deflateSetDictionary;
var $cab713332464fe22$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $cab713332464fe22$var$deflate_1$2 = {
    deflateInit: $cab713332464fe22$var$deflateInit_1,
    deflateInit2: $cab713332464fe22$var$deflateInit2_1,
    deflateReset: $cab713332464fe22$var$deflateReset_1,
    deflateResetKeep: $cab713332464fe22$var$deflateResetKeep_1,
    deflateSetHeader: $cab713332464fe22$var$deflateSetHeader_1,
    deflate: $cab713332464fe22$var$deflate_2$1,
    deflateEnd: $cab713332464fe22$var$deflateEnd_1,
    deflateSetDictionary: $cab713332464fe22$var$deflateSetDictionary_1,
    deflateInfo: $cab713332464fe22$var$deflateInfo
};
const $cab713332464fe22$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $cab713332464fe22$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($cab713332464fe22$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $cab713332464fe22$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $cab713332464fe22$var$common = {
    assign: $cab713332464fe22$var$assign,
    flattenChunks: $cab713332464fe22$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $cab713332464fe22$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $cab713332464fe22$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $cab713332464fe22$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$cab713332464fe22$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$cab713332464fe22$var$_utf8len[254] = $cab713332464fe22$var$_utf8len[255] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $cab713332464fe22$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $cab713332464fe22$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $cab713332464fe22$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $cab713332464fe22$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $cab713332464fe22$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $cab713332464fe22$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $cab713332464fe22$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $cab713332464fe22$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $cab713332464fe22$var$strings = {
    string2buf: $cab713332464fe22$var$string2buf,
    buf2string: $cab713332464fe22$var$buf2string,
    utf8border: $cab713332464fe22$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $cab713332464fe22$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $cab713332464fe22$var$zstream = $cab713332464fe22$var$ZStream;
const $cab713332464fe22$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $cab713332464fe22$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $cab713332464fe22$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $cab713332464fe22$var$Z_FULL_FLUSH, Z_FINISH: $cab713332464fe22$var$Z_FINISH$2, Z_OK: $cab713332464fe22$var$Z_OK$2, Z_STREAM_END: $cab713332464fe22$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $cab713332464fe22$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $cab713332464fe22$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $cab713332464fe22$var$Z_DEFLATED$1 } = $cab713332464fe22$var$constants$2;
/* ===========================================================================*/ const $cab713332464fe22$var$defaultOptions$1 = {
    level: $cab713332464fe22$var$Z_DEFAULT_COMPRESSION,
    method: $cab713332464fe22$var$Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: $cab713332464fe22$var$Z_DEFAULT_STRATEGY,
    legacyHash: true
};
/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * - `legacyHash` (Boolean) - use the classic zlib hash (default), which matches
 *   canonical zlib output byte-for-byte. Set to `false` to use the faster
 *   ANZAC++ hash, which matches recent (chromium) node.js output instead.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $cab713332464fe22$var$Deflate$1(options) {
    this.options = $cab713332464fe22$var$common.assign({}, $cab713332464fe22$var$defaultOptions$1, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $cab713332464fe22$var$zstream();
    this.strm.avail_out = 0;
    let status = $cab713332464fe22$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy, opt.legacyHash);
    if (status !== $cab713332464fe22$var$Z_OK$2) throw new Error($cab713332464fe22$var$messages[status]);
    if (opt.header) $cab713332464fe22$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $cab713332464fe22$var$strings.string2buf(opt.dictionary);
        else if ($cab713332464fe22$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $cab713332464fe22$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $cab713332464fe22$var$Z_OK$2) throw new Error($cab713332464fe22$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $cab713332464fe22$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $cab713332464fe22$var$Z_FINISH$2 : $cab713332464fe22$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $cab713332464fe22$var$strings.string2buf(data);
    else if ($cab713332464fe22$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $cab713332464fe22$var$Z_SYNC_FLUSH || _flush_mode === $cab713332464fe22$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $cab713332464fe22$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $cab713332464fe22$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $cab713332464fe22$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $cab713332464fe22$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $cab713332464fe22$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $cab713332464fe22$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $cab713332464fe22$var$Z_OK$2) this.result = $cab713332464fe22$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $cab713332464fe22$var$deflate$1(input, options) {
    const deflator = new $cab713332464fe22$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $cab713332464fe22$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $cab713332464fe22$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $cab713332464fe22$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $cab713332464fe22$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $cab713332464fe22$var$deflate$1(input, options);
}
var $cab713332464fe22$var$Deflate_1$1 = $cab713332464fe22$var$Deflate$1;
var $cab713332464fe22$var$deflate_2 = $cab713332464fe22$var$deflate$1;
var $cab713332464fe22$var$deflateRaw_1$1 = $cab713332464fe22$var$deflateRaw$1;
var $cab713332464fe22$var$gzip_1$1 = $cab713332464fe22$var$gzip$1;
var $cab713332464fe22$var$constants$1 = $cab713332464fe22$var$constants$2;
var $cab713332464fe22$var$deflate_1$1 = {
    Deflate: $cab713332464fe22$var$Deflate_1$1,
    deflate: $cab713332464fe22$var$deflate_2,
    deflateRaw: $cab713332464fe22$var$deflateRaw_1$1,
    gzip: $cab713332464fe22$var$gzip_1$1,
    constants: $cab713332464fe22$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $cab713332464fe22$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $cab713332464fe22$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $cab713332464fe22$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $cab713332464fe22$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $cab713332464fe22$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $cab713332464fe22$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $cab713332464fe22$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $cab713332464fe22$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $cab713332464fe22$var$MAXBITS = 15;
const $cab713332464fe22$var$ENOUGH_LENS$1 = 852;
const $cab713332464fe22$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $cab713332464fe22$var$CODES$1 = 0;
const $cab713332464fe22$var$LENS$1 = 1;
const $cab713332464fe22$var$DISTS$1 = 2;
const $cab713332464fe22$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $cab713332464fe22$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    199,
    75
]);
const $cab713332464fe22$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $cab713332464fe22$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $cab713332464fe22$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($cab713332464fe22$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($cab713332464fe22$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $cab713332464fe22$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $cab713332464fe22$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $cab713332464fe22$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $cab713332464fe22$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $cab713332464fe22$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $cab713332464fe22$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $cab713332464fe22$var$LENS$1) {
        base = $cab713332464fe22$var$lbase;
        extra = $cab713332464fe22$var$lext;
        match = 257;
    } else {
        base = $cab713332464fe22$var$dbase;
        extra = $cab713332464fe22$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $cab713332464fe22$var$LENS$1 && used > $cab713332464fe22$var$ENOUGH_LENS$1 || type === $cab713332464fe22$var$DISTS$1 && used > $cab713332464fe22$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $cab713332464fe22$var$LENS$1 && used > $cab713332464fe22$var$ENOUGH_LENS$1 || type === $cab713332464fe22$var$DISTS$1 && used > $cab713332464fe22$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $cab713332464fe22$var$inftrees = $cab713332464fe22$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $cab713332464fe22$var$CODES = 0;
const $cab713332464fe22$var$LENS = 1;
const $cab713332464fe22$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $cab713332464fe22$var$Z_FINISH$1, Z_BLOCK: $cab713332464fe22$var$Z_BLOCK, Z_TREES: $cab713332464fe22$var$Z_TREES, Z_OK: $cab713332464fe22$var$Z_OK$1, Z_STREAM_END: $cab713332464fe22$var$Z_STREAM_END$1, Z_NEED_DICT: $cab713332464fe22$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $cab713332464fe22$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $cab713332464fe22$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $cab713332464fe22$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $cab713332464fe22$var$Z_BUF_ERROR$1, Z_DEFLATED: $cab713332464fe22$var$Z_DEFLATED } = $cab713332464fe22$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $cab713332464fe22$var$HEAD = 16180; /* i: waiting for magic header */ 
const $cab713332464fe22$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $cab713332464fe22$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $cab713332464fe22$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $cab713332464fe22$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $cab713332464fe22$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $cab713332464fe22$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $cab713332464fe22$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $cab713332464fe22$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $cab713332464fe22$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $cab713332464fe22$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $cab713332464fe22$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $cab713332464fe22$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $cab713332464fe22$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $cab713332464fe22$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $cab713332464fe22$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $cab713332464fe22$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $cab713332464fe22$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $cab713332464fe22$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $cab713332464fe22$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $cab713332464fe22$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $cab713332464fe22$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $cab713332464fe22$var$DIST = 16202; /* i: waiting for distance code */ 
const $cab713332464fe22$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $cab713332464fe22$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $cab713332464fe22$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $cab713332464fe22$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $cab713332464fe22$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $cab713332464fe22$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $cab713332464fe22$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $cab713332464fe22$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $cab713332464fe22$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $cab713332464fe22$var$ENOUGH_LENS = 852;
const $cab713332464fe22$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $cab713332464fe22$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $cab713332464fe22$var$DEF_WBITS = $cab713332464fe22$var$MAX_WBITS;
const $cab713332464fe22$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $cab713332464fe22$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $cab713332464fe22$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $cab713332464fe22$var$HEAD || state.mode > $cab713332464fe22$var$SYNC) return 1;
    return 0;
};
const $cab713332464fe22$var$inflateResetKeep = (strm)=>{
    if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $cab713332464fe22$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($cab713332464fe22$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($cab713332464fe22$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $cab713332464fe22$var$Z_OK$1;
};
const $cab713332464fe22$var$inflateReset = (strm)=>{
    if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $cab713332464fe22$var$inflateResetKeep(strm);
};
const $cab713332464fe22$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $cab713332464fe22$var$inflateReset(strm);
};
const $cab713332464fe22$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $cab713332464fe22$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $cab713332464fe22$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $cab713332464fe22$var$inflateReset2(strm, windowBits);
    if (ret !== $cab713332464fe22$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $cab713332464fe22$var$inflateInit = (strm)=>{
    return $cab713332464fe22$var$inflateInit2(strm, $cab713332464fe22$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $cab713332464fe22$var$virgin = true;
let $cab713332464fe22$var$lenfix, $cab713332464fe22$var$distfix; // We have no pointers in JS, so keep tables separate
const $cab713332464fe22$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($cab713332464fe22$var$virgin) {
        $cab713332464fe22$var$lenfix = new Int32Array(512);
        $cab713332464fe22$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $cab713332464fe22$var$inftrees($cab713332464fe22$var$LENS, state.lens, 0, 288, $cab713332464fe22$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $cab713332464fe22$var$inftrees($cab713332464fe22$var$DISTS, state.lens, 0, 32, $cab713332464fe22$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $cab713332464fe22$var$virgin = false;
    }
    state.lencode = $cab713332464fe22$var$lenfix;
    state.lenbits = 9;
    state.distcode = $cab713332464fe22$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $cab713332464fe22$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) state.window = new Uint8Array(1 << state.wbits);
    /* if window not in use yet, initialize */ if (state.wsize === 0) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $cab713332464fe22$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($cab713332464fe22$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $cab713332464fe22$var$TYPE) state.mode = $cab713332464fe22$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $cab713332464fe22$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $cab713332464fe22$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $cab713332464fe22$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $cab713332464fe22$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $cab713332464fe22$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $cab713332464fe22$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $cab713332464fe22$var$DICTID : $cab713332464fe22$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $cab713332464fe22$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $cab713332464fe22$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $cab713332464fe22$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $cab713332464fe22$var$TIME;
        /* falls through */ case $cab713332464fe22$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $cab713332464fe22$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $cab713332464fe22$var$OS;
        /* falls through */ case $cab713332464fe22$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $cab713332464fe22$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $cab713332464fe22$var$EXLEN;
        /* falls through */ case $cab713332464fe22$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $cab713332464fe22$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $cab713332464fe22$var$EXTRA;
        /* falls through */ case $cab713332464fe22$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $cab713332464fe22$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $cab713332464fe22$var$NAME;
        /* falls through */ case $cab713332464fe22$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $cab713332464fe22$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $cab713332464fe22$var$COMMENT;
        /* falls through */ case $cab713332464fe22$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $cab713332464fe22$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $cab713332464fe22$var$HCRC;
        /* falls through */ case $cab713332464fe22$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $cab713332464fe22$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $cab713332464fe22$var$TYPE;
            break;
        case $cab713332464fe22$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $cab713332464fe22$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $cab713332464fe22$var$DICT;
        /* falls through */ case $cab713332464fe22$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $cab713332464fe22$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $cab713332464fe22$var$TYPE;
        /* falls through */ case $cab713332464fe22$var$TYPE:
            if (flush === $cab713332464fe22$var$Z_BLOCK || flush === $cab713332464fe22$var$Z_TREES) break inf_leave;
        /* falls through */ case $cab713332464fe22$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $cab713332464fe22$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $cab713332464fe22$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $cab713332464fe22$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $cab713332464fe22$var$LEN_; /* decode codes */ 
                    if (flush === $cab713332464fe22$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $cab713332464fe22$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $cab713332464fe22$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $cab713332464fe22$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $cab713332464fe22$var$COPY_;
            if (flush === $cab713332464fe22$var$Z_TREES) break inf_leave;
        /* falls through */ case $cab713332464fe22$var$COPY_:
            state.mode = $cab713332464fe22$var$COPY;
        /* falls through */ case $cab713332464fe22$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $cab713332464fe22$var$TYPE;
            break;
        case $cab713332464fe22$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $cab713332464fe22$var$LENLENS;
        /* falls through */ case $cab713332464fe22$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $cab713332464fe22$var$inftrees($cab713332464fe22$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $cab713332464fe22$var$CODELENS;
        /* falls through */ case $cab713332464fe22$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $cab713332464fe22$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $cab713332464fe22$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $cab713332464fe22$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $cab713332464fe22$var$inftrees($cab713332464fe22$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $cab713332464fe22$var$inftrees($cab713332464fe22$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $cab713332464fe22$var$LEN_;
            if (flush === $cab713332464fe22$var$Z_TREES) break inf_leave;
        /* falls through */ case $cab713332464fe22$var$LEN_:
            state.mode = $cab713332464fe22$var$LEN;
        /* falls through */ case $cab713332464fe22$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $cab713332464fe22$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $cab713332464fe22$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $cab713332464fe22$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $cab713332464fe22$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $cab713332464fe22$var$LENEXT;
        /* falls through */ case $cab713332464fe22$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $cab713332464fe22$var$DIST;
        /* falls through */ case $cab713332464fe22$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $cab713332464fe22$var$DISTEXT;
        /* falls through */ case $cab713332464fe22$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $cab713332464fe22$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $cab713332464fe22$var$MATCH;
        /* falls through */ case $cab713332464fe22$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $cab713332464fe22$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $cab713332464fe22$var$LEN;
            break;
        case $cab713332464fe22$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $cab713332464fe22$var$LEN;
            break;
        case $cab713332464fe22$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $cab713332464fe22$var$crc32_1(state.check, output, _out, put - _out) : $cab713332464fe22$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $cab713332464fe22$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $cab713332464fe22$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $cab713332464fe22$var$LENGTH;
        /* falls through */ case $cab713332464fe22$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $cab713332464fe22$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $cab713332464fe22$var$DONE;
        /* falls through */ case $cab713332464fe22$var$DONE:
            ret = $cab713332464fe22$var$Z_STREAM_END$1;
            break inf_leave;
        case $cab713332464fe22$var$BAD:
            ret = $cab713332464fe22$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $cab713332464fe22$var$MEM:
            return $cab713332464fe22$var$Z_MEM_ERROR$1;
        case $cab713332464fe22$var$SYNC:
        /* falls through */ default:
            return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $cab713332464fe22$var$BAD && (state.mode < $cab713332464fe22$var$CHECK || flush !== $cab713332464fe22$var$Z_FINISH$1)) $cab713332464fe22$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $cab713332464fe22$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $cab713332464fe22$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $cab713332464fe22$var$TYPE ? 128 : 0) + (state.mode === $cab713332464fe22$var$LEN_ || state.mode === $cab713332464fe22$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $cab713332464fe22$var$Z_FINISH$1) && ret === $cab713332464fe22$var$Z_OK$1) ret = $cab713332464fe22$var$Z_BUF_ERROR$1;
    return ret;
};
const $cab713332464fe22$var$inflateEnd = (strm)=>{
    if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $cab713332464fe22$var$Z_OK$1;
};
const $cab713332464fe22$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $cab713332464fe22$var$Z_OK$1;
};
const $cab713332464fe22$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($cab713332464fe22$var$inflateStateCheck(strm)) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $cab713332464fe22$var$DICT) return $cab713332464fe22$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $cab713332464fe22$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $cab713332464fe22$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $cab713332464fe22$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $cab713332464fe22$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $cab713332464fe22$var$MEM;
        return $cab713332464fe22$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $cab713332464fe22$var$Z_OK$1;
};
var $cab713332464fe22$var$inflateReset_1 = $cab713332464fe22$var$inflateReset;
var $cab713332464fe22$var$inflateReset2_1 = $cab713332464fe22$var$inflateReset2;
var $cab713332464fe22$var$inflateResetKeep_1 = $cab713332464fe22$var$inflateResetKeep;
var $cab713332464fe22$var$inflateInit_1 = $cab713332464fe22$var$inflateInit;
var $cab713332464fe22$var$inflateInit2_1 = $cab713332464fe22$var$inflateInit2;
var $cab713332464fe22$var$inflate_2$1 = $cab713332464fe22$var$inflate$2;
var $cab713332464fe22$var$inflateEnd_1 = $cab713332464fe22$var$inflateEnd;
var $cab713332464fe22$var$inflateGetHeader_1 = $cab713332464fe22$var$inflateGetHeader;
var $cab713332464fe22$var$inflateSetDictionary_1 = $cab713332464fe22$var$inflateSetDictionary;
var $cab713332464fe22$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $cab713332464fe22$var$inflate_1$2 = {
    inflateReset: $cab713332464fe22$var$inflateReset_1,
    inflateReset2: $cab713332464fe22$var$inflateReset2_1,
    inflateResetKeep: $cab713332464fe22$var$inflateResetKeep_1,
    inflateInit: $cab713332464fe22$var$inflateInit_1,
    inflateInit2: $cab713332464fe22$var$inflateInit2_1,
    inflate: $cab713332464fe22$var$inflate_2$1,
    inflateEnd: $cab713332464fe22$var$inflateEnd_1,
    inflateGetHeader: $cab713332464fe22$var$inflateGetHeader_1,
    inflateSetDictionary: $cab713332464fe22$var$inflateSetDictionary_1,
    inflateInfo: $cab713332464fe22$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $cab713332464fe22$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $cab713332464fe22$var$gzheader = $cab713332464fe22$var$GZheader;
const $cab713332464fe22$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $cab713332464fe22$var$Z_NO_FLUSH, Z_FINISH: $cab713332464fe22$var$Z_FINISH, Z_OK: $cab713332464fe22$var$Z_OK, Z_STREAM_END: $cab713332464fe22$var$Z_STREAM_END, Z_NEED_DICT: $cab713332464fe22$var$Z_NEED_DICT, Z_STREAM_ERROR: $cab713332464fe22$var$Z_STREAM_ERROR, Z_DATA_ERROR: $cab713332464fe22$var$Z_DATA_ERROR, Z_MEM_ERROR: $cab713332464fe22$var$Z_MEM_ERROR, Z_BUF_ERROR: $cab713332464fe22$var$Z_BUF_ERROR } = $cab713332464fe22$var$constants$2;
/* ===========================================================================*/ const $cab713332464fe22$var$defaultOptions = {
    chunkSize: 65536,
    windowBits: 15,
    to: ''
};
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $cab713332464fe22$var$Inflate$1(options) {
    this.options = $cab713332464fe22$var$common.assign({}, $cab713332464fe22$var$defaultOptions, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $cab713332464fe22$var$zstream();
    this.strm.avail_out = 0;
    let status = $cab713332464fe22$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $cab713332464fe22$var$Z_OK) throw new Error($cab713332464fe22$var$messages[status]);
    this.header = new $cab713332464fe22$var$gzheader();
    $cab713332464fe22$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $cab713332464fe22$var$strings.string2buf(opt.dictionary);
        else if ($cab713332464fe22$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $cab713332464fe22$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $cab713332464fe22$var$Z_OK) throw new Error($cab713332464fe22$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $cab713332464fe22$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $cab713332464fe22$var$Z_FINISH : $cab713332464fe22$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($cab713332464fe22$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $cab713332464fe22$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $cab713332464fe22$var$Z_NEED_DICT && dictionary) {
            status = $cab713332464fe22$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $cab713332464fe22$var$Z_OK) status = $cab713332464fe22$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $cab713332464fe22$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $cab713332464fe22$var$Z_NEED_DICT;
        }
        // Only the gzip format defines concatenated members (RFC 1952: a gzip file
        // is "a series of members"). A zlib stream (RFC 1950) ends after its
        // ADLER32, and a raw DEFLATE stream (RFC 1951) ends after its final block -
        // neither format allows anything to follow, so bytes after the end are not
        // ours to interpret and must be left in the input. Restart decoding only
        // for a gzip member: `state.flags` is non-zero only once a gzip header has
        // actually been decoded (it stays 0 for a zlib member, even when the format
        // was auto-detected and the gzip bit of `wrap` is set). A trailing zero
        // byte is padding, not the start of a member (no member can begin with 0).
        while(strm.avail_in > 0 && status === $cab713332464fe22$var$Z_STREAM_END && strm.state.wrap & 2 && strm.state.flags !== 0 && strm.input[strm.next_in] !== 0){
            $cab713332464fe22$var$inflate_1$2.inflateReset(strm);
            status = $cab713332464fe22$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $cab713332464fe22$var$Z_STREAM_ERROR:
            case $cab713332464fe22$var$Z_DATA_ERROR:
            case $cab713332464fe22$var$Z_NEED_DICT:
            case $cab713332464fe22$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) // Flush output if buffer is full, stream ended, or an explicit flush was
        // requested (e.g. Z_SYNC_FLUSH) - to push out the tail, same as node's zlib.
        {
            if (strm.avail_out === 0 || status === $cab713332464fe22$var$Z_STREAM_END || _flush_mode > 0) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $cab713332464fe22$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $cab713332464fe22$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else {
                    this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
                    // Force a fresh output buffer on next iteration / next push, so the
                    // already emitted tail is not sent again.
                    strm.avail_out = 0;
                    strm.next_out = 0;
                }
            }
        }
        // A full output buffer means there may be more to produce - allocate a new
        // one and call inflate again. The status depends on the flush mode: with
        // Z_NO_FLUSH a full buffer is reported as Z_OK, but with Z_FINISH the same
        // situation is reported as Z_BUF_ERROR ("could not make progress now",
        // non-fatal) even though output is still pending. Both must continue; the
        // distinction that matters is purely "was the output buffer exhausted".
        if ((status === $cab713332464fe22$var$Z_OK || status === $cab713332464fe22$var$Z_BUF_ERROR) && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $cab713332464fe22$var$Z_STREAM_END) {
            status = $cab713332464fe22$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) {
            // Input is exhausted. If the caller declared this the end of the stream
            // (Z_FINISH) but we never saw Z_STREAM_END, the compressed data ended
            // before its terminating marker - i.e. it is truncated/incomplete. That
            // is an error: returning the partial output as success would be
            // indistinguishable from a complete decode, hiding the data loss. Report
            // it via Z_BUF_ERROR. (Reached only when the output buffer still had room
            // - a full buffer is handled by the `continue` above - so this genuinely
            // means "ran out of input", not "ran out of output".)
            if (_flush_mode === $cab713332464fe22$var$Z_FINISH) {
                status = $cab713332464fe22$var$inflate_1$2.inflateEnd(this.strm);
                this.onEnd(status === $cab713332464fe22$var$Z_OK ? $cab713332464fe22$var$Z_BUF_ERROR : status);
                this.ended = true;
                return false;
            }
            break;
        }
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $cab713332464fe22$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $cab713332464fe22$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $cab713332464fe22$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $cab713332464fe22$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $cab713332464fe22$var$inflate$1(input, options) {
    const inflator = new $cab713332464fe22$var$Inflate$1(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $cab713332464fe22$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $cab713332464fe22$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $cab713332464fe22$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $cab713332464fe22$var$Inflate_1$1 = $cab713332464fe22$var$Inflate$1;
var $cab713332464fe22$var$inflate_2 = $cab713332464fe22$var$inflate$1;
var $cab713332464fe22$var$inflateRaw_1$1 = $cab713332464fe22$var$inflateRaw$1;
var $cab713332464fe22$var$ungzip$1 = $cab713332464fe22$var$inflate$1;
var $cab713332464fe22$var$constants = $cab713332464fe22$var$constants$2;
var $cab713332464fe22$var$inflate_1$1 = {
    Inflate: $cab713332464fe22$var$Inflate_1$1,
    inflate: $cab713332464fe22$var$inflate_2,
    inflateRaw: $cab713332464fe22$var$inflateRaw_1$1,
    ungzip: $cab713332464fe22$var$ungzip$1,
    constants: $cab713332464fe22$var$constants
};
const { Deflate: $cab713332464fe22$var$Deflate, deflate: $cab713332464fe22$var$deflate, deflateRaw: $cab713332464fe22$var$deflateRaw, gzip: $cab713332464fe22$var$gzip } = $cab713332464fe22$var$deflate_1$1;
const { Inflate: $cab713332464fe22$var$Inflate, inflate: $cab713332464fe22$var$inflate, inflateRaw: $cab713332464fe22$var$inflateRaw, ungzip: $cab713332464fe22$var$ungzip } = $cab713332464fe22$var$inflate_1$1;
var $cab713332464fe22$export$ae157b6234afe138 = $cab713332464fe22$var$Deflate;
var $cab713332464fe22$export$2316623ecd1285ab = $cab713332464fe22$var$deflate;
var $cab713332464fe22$export$e95d6a8f69fb340a = $cab713332464fe22$var$deflateRaw;
var $cab713332464fe22$export$69f0ea7cf3a331a8 = $cab713332464fe22$var$gzip;
var $cab713332464fe22$export$d1de70a877d6e43c = $cab713332464fe22$var$Inflate;
var $cab713332464fe22$export$cae1ce83fe4a1782 = $cab713332464fe22$var$inflate;
var $cab713332464fe22$export$d0f0aa2d05c905c5 = $cab713332464fe22$var$inflateRaw;
var $cab713332464fe22$export$95adf9d270383091 = $cab713332464fe22$var$ungzip;
var $cab713332464fe22$export$1a988e7317c65621 = $cab713332464fe22$var$constants$2;
var $cab713332464fe22$export$2e2bcd8739ae039 = {
    Deflate: $cab713332464fe22$export$ae157b6234afe138,
    deflate: $cab713332464fe22$export$2316623ecd1285ab,
    deflateRaw: $cab713332464fe22$export$e95d6a8f69fb340a,
    gzip: $cab713332464fe22$export$69f0ea7cf3a331a8,
    Inflate: $cab713332464fe22$export$d1de70a877d6e43c,
    inflate: $cab713332464fe22$export$cae1ce83fe4a1782,
    inflateRaw: $cab713332464fe22$export$d0f0aa2d05c905c5,
    ungzip: $cab713332464fe22$export$95adf9d270383091,
    constants: $cab713332464fe22$export$1a988e7317c65621
};


// src/plugins/video.ts
var $08414ea58bdc1292$var$mpegtsPackageName = "mpegts.js";
var $08414ea58bdc1292$var$loadMpegts = ()=>$08414ea58bdc1292$var$importOptionalModule($08414ea58bdc1292$var$mpegtsPackageName);
var $08414ea58bdc1292$var$videoExtensions = /* @__PURE__ */ new Set([
    "mp4",
    "mpg",
    "mpeg",
    "mpe",
    "mpv",
    "webm",
    "ogv",
    "mov",
    "m4v",
    "avi",
    "mkv",
    "flv",
    "wmv",
    "3gp",
    "3g2",
    "m2ts",
    "m3u8"
]);
var $08414ea58bdc1292$var$videoMimeTypes = /* @__PURE__ */ new Set([
    "application/vnd.apple.mpegurl",
    "application/x-mpegurl",
    "application/mpegurl",
    "application/dash+xml"
]);
var $08414ea58bdc1292$var$hlsMimeTypes = /* @__PURE__ */ new Set([
    "application/vnd.apple.mpegurl",
    "application/x-mpegurl",
    "application/mpegurl"
]);

function $08414ea58bdc1292$export$9fb03a2427721ab3(options = {}) {
    return {
        name: "video",
        match (file) {
            return file.mimeType.startsWith("video/") || $08414ea58bdc1292$var$videoMimeTypes.has(file.mimeType) || $08414ea58bdc1292$var$videoExtensions.has(file.extension);
        },
        async render (ctx) {
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const mimeType = ctx.file.mimeType.toLowerCase();
            const bytes = await $08414ea58bdc1292$var$readVideoBytes(ctx.file.blob);
            const container = document.createElement("div");
            container.className = "ofv-video-container";
            const stage = document.createElement("div");
            stage.className = "ofv-video-stage";
            const video = document.createElement("video");
            video.className = "ofv-media";
            video.controls = true;
            video.playsInline = true;
            video.preload = "metadata";
            if (options.controlsList !== void 0) video.setAttribute("controlslist", options.controlsList);
            video.style.objectFit = ctx.options.fit === "cover" ? "cover" : "contain";
            const ext = ctx.file.extension.toLowerCase();
            const infoBar = $08414ea58bdc1292$var$createVideoInfo($08414ea58bdc1292$var$parseVideoInfo(bytes, ext, mimeType, ctx.file.name));
            infoBar.hidden = true;
            infoBar.setAttribute("aria-hidden", "true");
            infoBar.style.display = "none";
            stage.append(video);
            container.append(stage, infoBar);
            ctx.viewport.classList.add("ofv-center");
            ctx.viewport.append(container);
            let hlsInstance = null;
            let mpegtsPlayer = null;
            const isHls = ext === "m3u8" || $08414ea58bdc1292$var$hlsMimeTypes.has(mimeType);
            const isMpegTs = ext === "m2ts" || mimeType === "video/mp2t";
            const isDash = mimeType === "application/dash+xml";
            const isFlv = ext === "flv" || mimeType === "video/x-flv";
            const formatLabel = (ctx.file.extension || ctx.file.mimeType || "video").toUpperCase();
            const controller = $08414ea58bdc1292$var$createVideoTransformController(video, ctx);
            const showTranscodeFallback = ()=>{
                video.pause();
                video.remove();
                controller.setAvailable(false);
                ctx.toolbar?.refreshCommandSupport();
                infoBar.hidden = false;
                infoBar.removeAttribute("aria-hidden");
                infoBar.style.removeProperty("display");
                const oldFallback = stage.querySelector(".ofv-fallback");
                if (oldFallback) oldFallback.remove();
                const fallback = document.createElement("div");
                fallback.className = "ofv-fallback";
                const title = document.createElement("strong");
                title.textContent = `\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u76F4\u63A5\u64AD\u653E\u8BE5\u89C6\u9891\u683C\u5F0F (${formatLabel})`;
                const meta = document.createElement("span");
                meta.textContent = "\u5EFA\u8BAE\u8F6C\u6362\u4E3A MP4 \u683C\u5F0F\u64AD\u653E\uFF0C\u6216\u76F4\u63A5\u4E0B\u8F7D\u5728\u672C\u5730\u64AD\u653E\u3002";
                const download = document.createElement("a");
                download.href = url;
                download.download = ctx.file.name;
                download.textContent = "\u4E0B\u8F7D\u89C6\u9891";
                fallback.append(title, meta, download);
                stage.append(fallback);
            };
            const onVideoError = ()=>{
                showTranscodeFallback();
            };
            video.addEventListener("error", onVideoError);
            ctx.toolbar?.refreshCommandSupport();
            try {
                if (isDash) showTranscodeFallback();
                else if (isHls) {
                    const Hls = (await (parcelRequire("1mxZi"))).default;
                    if (Hls.isSupported()) {
                        hlsInstance = new Hls();
                        hlsInstance.loadSource(url);
                        hlsInstance.attachMedia(video);
                        hlsInstance.on(Hls.Events.ERROR, (_event, data)=>{
                            if (data.fatal) showTranscodeFallback();
                        });
                    } else if (video.canPlayType("application/vnd.apple.mpegurl")) video.src = url;
                    else showTranscodeFallback();
                } else if (isFlv || isMpegTs) {
                    const mpegtsModule = await $08414ea58bdc1292$var$loadMpegts();
                    const mpegts = $08414ea58bdc1292$var$resolveMpegtsApi(mpegtsModule);
                    if (mpegts.isSupported()) {
                        mpegtsPlayer = mpegts.createPlayer({
                            type: isFlv ? "flv" : "mpegts",
                            url: url
                        });
                        mpegtsPlayer.attachMediaElement(video);
                        mpegtsPlayer.load();
                        mpegtsPlayer.on(mpegts.Events.ERROR, ()=>{
                            showTranscodeFallback();
                        });
                    } else showTranscodeFallback();
                } else video.src = url;
            } catch (err) {
                showTranscodeFallback();
            }
            return {
                canCommand (command) {
                    return controller.canCommand(command);
                },
                command (command) {
                    return controller.command(command);
                },
                resize () {
                    video.style.width = "100%";
                    video.style.height = "100%";
                },
                destroy () {
                    video.removeEventListener("error", onVideoError);
                    if (video.isConnected) video.pause();
                    controller.destroy();
                    if (hlsInstance) hlsInstance.destroy();
                    if (mpegtsPlayer) {
                        mpegtsPlayer.unload();
                        mpegtsPlayer.destroy();
                    }
                    ctx.viewport.classList.remove("ofv-center");
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    container.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$importOptionalModule(packageName) {
    return new Function("packageName", "return import(packageName)")(packageName);
}
function $08414ea58bdc1292$var$resolveMpegtsApi(module) {
    const api = module.default || module;
    if (!api.Events || !api.isSupported || !api.createPlayer) throw new Error("mpegts.js is not available.");
    return api;
}
function $08414ea58bdc1292$var$createVideoTransformController(video, ctx) {
    let scale = 1;
    let rotation = 0;
    let available = true;
    const apply = ()=>{
        video.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
        video.style.transformOrigin = "center";
        ctx.toolbar?.setZoom(available ? scale : void 0);
    };
    apply();
    const canTransform = (command)=>available && (command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left");
    return {
        setAvailable (nextAvailable) {
            available = nextAvailable;
            if (available) apply();
            else ctx.toolbar?.setZoom(void 0);
        },
        canCommand (command) {
            return canTransform(command);
        },
        command (command) {
            if (!canTransform(command)) return false;
            if (command === "zoom-in") {
                scale = Math.min(4, Number((scale + 0.25).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-out") {
                scale = Math.max(0.25, Number((scale - 0.25).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                scale = 1;
                rotation = 0;
                apply();
                return true;
            }
            if (command === "rotate-right") {
                rotation += 90;
                apply();
                return true;
            }
            if (command === "rotate-left") {
                rotation -= 90;
                apply();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
async function $08414ea58bdc1292$var$readVideoBytes(blob) {
    if (!blob) return new Uint8Array();
    return new Uint8Array(await blob.arrayBuffer().catch(()=>new ArrayBuffer(0)));
}
function $08414ea58bdc1292$var$createVideoInfo(info) {
    const bar = document.createElement("div");
    bar.className = "ofv-media-info";
    $08414ea58bdc1292$var$appendMediaInfo(bar, "\u683C\u5F0F", info.format);
    if (info.codec) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u7F16\u7801", info.codec);
    if (info.width && info.height) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u5C3A\u5BF8", `${info.width} x ${info.height}px`);
    if (info.duration) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u65F6\u957F", info.duration);
    if (info.bitrate) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u7801\u7387", info.bitrate);
    if (info.tracks !== void 0) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u8F68\u9053", String(info.tracks));
    if (info.variants !== void 0) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u53D8\u4F53", String(info.variants));
    if (info.segments !== void 0) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u7247\u6BB5", String(info.segments));
    if (info.note) $08414ea58bdc1292$var$appendMediaInfo(bar, "\u8BF4\u660E", info.note);
    return bar;
}
function $08414ea58bdc1292$var$appendMediaInfo(parent, label, value) {
    const item = document.createElement("span");
    item.className = "ofv-media-info-item";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    item.append(key, content);
    parent.append(item);
}
function $08414ea58bdc1292$var$parseVideoInfo(bytes, extension, mimeType, fileName) {
    const fallback = (extension || mimeType || fileName.split(".").pop() || "video").toUpperCase();
    if (bytes.length === 0) return {
        format: fallback,
        note: "\u65E0\u6CD5\u8BFB\u53D6\u672C\u5730\u5934\u4FE1\u606F"
    };
    return $08414ea58bdc1292$var$parseHlsInfo(bytes) || $08414ea58bdc1292$var$parseDashInfo(bytes) || $08414ea58bdc1292$var$parseMp4Info(bytes) || $08414ea58bdc1292$var$parseAviInfo(bytes) || $08414ea58bdc1292$var$parseEbmlInfo(bytes) || {
        format: fallback,
        note: "\u6682\u672A\u8BC6\u522B\u89C6\u9891\u5934\u7ED3\u6784"
    };
}
function $08414ea58bdc1292$var$parseMp4Info(bytes) {
    if (bytes.length < 12 || $08414ea58bdc1292$var$asciiAt(bytes, 4, 4) !== "ftyp") return null;
    const majorBrand = $08414ea58bdc1292$var$asciiAt(bytes, 8, 4);
    const info = {
        format: [
            "qt  "
        ].includes(majorBrand) ? "MOV" : "MP4",
        codec: majorBrand
    };
    const atoms = $08414ea58bdc1292$var$collectMp4Atoms(bytes, 0, bytes.length);
    const moov = atoms.find((atom)=>atom.type === "moov");
    if (moov) {
        const children = $08414ea58bdc1292$var$collectMp4Atoms(bytes, moov.start + moov.headerSize, moov.end);
        const mvhd = children.find((atom)=>atom.type === "mvhd");
        if (mvhd) {
            const duration = $08414ea58bdc1292$var$readMp4MvhdDuration(bytes, mvhd.start + mvhd.headerSize);
            if (duration !== void 0) info.duration = $08414ea58bdc1292$var$formatDuration(duration);
        }
        const tracks = children.filter((atom)=>atom.type === "trak");
        info.tracks = tracks.length;
        for (const track of tracks){
            const tkhd = $08414ea58bdc1292$var$collectMp4Atoms(bytes, track.start + track.headerSize, track.end).find((atom)=>atom.type === "tkhd");
            if (tkhd) {
                const size = $08414ea58bdc1292$var$readMp4TkhdSize(bytes, tkhd.start + tkhd.headerSize);
                if (size.width && size.height) {
                    info.width = size.width;
                    info.height = size.height;
                    break;
                }
            }
        }
    }
    return info;
}
function $08414ea58bdc1292$var$collectMp4Atoms(bytes, start, end) {
    const atoms = [];
    let offset = start;
    while(offset + 8 <= end){
        let size = $08414ea58bdc1292$var$readUint32Be(bytes, offset);
        const type = $08414ea58bdc1292$var$asciiAt(bytes, offset + 4, 4);
        let headerSize = 8;
        if (size === 1 && offset + 16 <= end) {
            size = Number($08414ea58bdc1292$var$readUint64Be(bytes, offset + 8));
            headerSize = 16;
        }
        if (size < headerSize || offset + size > end || !/^[\w ]{4}$/.test(type)) break;
        atoms.push({
            type: type,
            start: offset,
            end: offset + size,
            headerSize: headerSize
        });
        offset += size;
    }
    return atoms;
}
function $08414ea58bdc1292$var$readMp4MvhdDuration(bytes, offset) {
    if (offset + 20 > bytes.length) return void 0;
    const version = bytes[offset];
    if (version === 1 && offset + 32 <= bytes.length) {
        const timescale2 = $08414ea58bdc1292$var$readUint32Be(bytes, offset + 20);
        const duration2 = $08414ea58bdc1292$var$readUint64Be(bytes, offset + 24);
        return timescale2 ? Number(duration2) / timescale2 : void 0;
    }
    const timescale = $08414ea58bdc1292$var$readUint32Be(bytes, offset + 12);
    const duration = $08414ea58bdc1292$var$readUint32Be(bytes, offset + 16);
    return timescale ? duration / timescale : void 0;
}
function $08414ea58bdc1292$var$readMp4TkhdSize(bytes, offset) {
    const version = bytes[offset];
    const sizeOffset = version === 1 ? offset + 84 : offset + 72;
    if (sizeOffset + 8 > bytes.length) return {};
    return {
        width: $08414ea58bdc1292$var$readUint32Be(bytes, sizeOffset) / 65536,
        height: $08414ea58bdc1292$var$readUint32Be(bytes, sizeOffset + 4) / 65536
    };
}
function $08414ea58bdc1292$var$parseAviInfo(bytes) {
    if (bytes.length < 64 || $08414ea58bdc1292$var$asciiAt(bytes, 0, 4) !== "RIFF" || $08414ea58bdc1292$var$asciiAt(bytes, 8, 4) !== "AVI ") return null;
    const avihOffset = $08414ea58bdc1292$var$findAscii(bytes, "avih", 12);
    if (avihOffset < 0 || avihOffset + 56 > bytes.length) return {
        format: "AVI",
        note: "\u672A\u627E\u5230 avih header"
    };
    const microSecPerFrame = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 8);
    const maxBytesPerSec = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 16);
    const totalFrames = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 24);
    const streams = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 32);
    const width = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 40);
    const height = $08414ea58bdc1292$var$readUint32Le(bytes, avihOffset + 44);
    return {
        format: "AVI",
        width: width,
        height: height,
        tracks: streams,
        bitrate: maxBytesPerSec ? `${Math.round(maxBytesPerSec * 8 / 1e3)} kbps` : void 0,
        duration: microSecPerFrame && totalFrames ? $08414ea58bdc1292$var$formatDuration(microSecPerFrame * totalFrames / 1e6) : void 0
    };
}
function $08414ea58bdc1292$var$parseEbmlInfo(bytes) {
    if (bytes.length < 8 || bytes[0] !== 26 || bytes[1] !== 69 || bytes[2] !== 223 || bytes[3] !== 163) return null;
    const root = $08414ea58bdc1292$var$collectEbmlElements(bytes, 0, bytes.length);
    const header = root.find((element)=>element.id === 440786851);
    const headerChildren = header ? $08414ea58bdc1292$var$collectEbmlElements(bytes, header.dataStart, header.dataEnd) : [];
    const docTypeValue = $08414ea58bdc1292$var$readEbmlString(bytes, headerChildren.find((element)=>element.id === 17026));
    const segment = root.find((element)=>element.id === 408125543);
    const segmentChildren = segment ? $08414ea58bdc1292$var$collectEbmlElements(bytes, segment.dataStart, segment.dataEnd) : [];
    const info = $08414ea58bdc1292$var$parseEbmlSegmentInfo(bytes, segmentChildren.find((element)=>element.id === 357149030));
    const tracks = $08414ea58bdc1292$var$parseEbmlTracks(bytes, segmentChildren.find((element)=>element.id === 374648427));
    const docType = docTypeValue?.toLowerCase().includes("webm") ? "WebM" : docTypeValue?.toLowerCase().includes("matroska") ? "Matroska" : "EBML";
    return {
        format: docType,
        codec: tracks.codecs.length > 0 ? tracks.codecs.slice(0, 4).join(", ") : void 0,
        width: tracks.width,
        height: tracks.height,
        duration: info.duration === void 0 ? void 0 : $08414ea58bdc1292$var$formatDuration(info.duration),
        tracks: tracks.count || void 0,
        note: docTypeValue ? `EBML DocType ${docTypeValue}` : "\u5DF2\u8BC6\u522B EBML \u5BB9\u5668"
    };
}
function $08414ea58bdc1292$var$collectEbmlElements(bytes, start, end, limit = 256) {
    const elements = [];
    let offset = start;
    while(offset < end && elements.length < limit){
        const id = $08414ea58bdc1292$var$readEbmlId(bytes, offset, end);
        if (!id) break;
        const size = $08414ea58bdc1292$var$readEbmlSize(bytes, id.offset, end);
        if (!size) break;
        const dataStart = size.offset;
        const dataEnd = size.unknown ? end : dataStart + size.value;
        if (dataEnd < dataStart || dataEnd > end) break;
        elements.push({
            id: id.value,
            start: offset,
            dataStart: dataStart,
            dataEnd: dataEnd,
            end: dataEnd
        });
        offset = dataEnd;
    }
    return elements;
}
function $08414ea58bdc1292$var$readEbmlId(bytes, offset, end) {
    const length = $08414ea58bdc1292$var$ebmlVintLength(bytes[offset]);
    if (!length || length > 4 || offset + length > end) return void 0;
    let value = 0;
    for(let index = 0; index < length; index++)value = value * 256 + bytes[offset + index];
    return {
        value: value,
        offset: offset + length
    };
}
function $08414ea58bdc1292$var$readEbmlSize(bytes, offset, end) {
    const length = $08414ea58bdc1292$var$ebmlVintLength(bytes[offset]);
    if (!length || length > 8 || offset + length > end) return void 0;
    const firstMask = 255 >> length;
    let value = bytes[offset] & firstMask;
    let max = firstMask;
    for(let index = 1; index < length; index++){
        value = value * 256 + bytes[offset + index];
        max = max * 256 + 255;
    }
    return {
        value: value,
        offset: offset + length,
        unknown: value === max
    };
}
function $08414ea58bdc1292$var$ebmlVintLength(firstByte) {
    if (!firstByte) return 0;
    for(let length = 1; length <= 8; length++){
        if (firstByte & 128 >> length - 1) return length;
    }
    return 0;
}
function $08414ea58bdc1292$var$parseEbmlSegmentInfo(bytes, element) {
    if (!element) return {};
    const children = $08414ea58bdc1292$var$collectEbmlElements(bytes, element.dataStart, element.dataEnd);
    const timecodeScale = $08414ea58bdc1292$var$readEbmlUInt(bytes, children.find((child)=>child.id === 2807729)) || 1e6;
    const duration = $08414ea58bdc1292$var$readEbmlFloat(bytes, children.find((child)=>child.id === 17545));
    return {
        duration: duration === void 0 ? void 0 : duration * timecodeScale / 1e9
    };
}
function $08414ea58bdc1292$var$parseEbmlTracks(bytes, element) {
    if (!element) return {
        count: 0,
        codecs: []
    };
    const trackEntries = $08414ea58bdc1292$var$collectEbmlElements(bytes, element.dataStart, element.dataEnd).filter((child)=>child.id === 174);
    const codecs = [];
    let width;
    let height;
    for (const track of trackEntries){
        const children = $08414ea58bdc1292$var$collectEbmlElements(bytes, track.dataStart, track.dataEnd);
        const codec = $08414ea58bdc1292$var$readEbmlString(bytes, children.find((child)=>child.id === 134));
        if (codec && !codecs.includes(codec)) codecs.push(codec);
        const type = $08414ea58bdc1292$var$readEbmlUInt(bytes, children.find((child)=>child.id === 131));
        const video = children.find((child)=>child.id === 224);
        if (type === 1 && video) {
            const videoChildren = $08414ea58bdc1292$var$collectEbmlElements(bytes, video.dataStart, video.dataEnd);
            width = $08414ea58bdc1292$var$readEbmlUInt(bytes, videoChildren.find((child)=>child.id === 176)) || width;
            height = $08414ea58bdc1292$var$readEbmlUInt(bytes, videoChildren.find((child)=>child.id === 186)) || height;
        }
    }
    return {
        count: trackEntries.length,
        codecs: codecs,
        width: width,
        height: height
    };
}
function $08414ea58bdc1292$var$readEbmlString(bytes, element) {
    if (!element || element.dataEnd <= element.dataStart || element.dataEnd - element.dataStart > 4096) return void 0;
    return new TextDecoder("utf-8", {
        fatal: false
    }).decode(bytes.slice(element.dataStart, element.dataEnd)).replace(/\0+$/g, "").trim();
}
function $08414ea58bdc1292$var$readEbmlUInt(bytes, element) {
    if (!element || element.dataEnd <= element.dataStart || element.dataEnd - element.dataStart > 6) return void 0;
    let value = 0;
    for(let offset = element.dataStart; offset < element.dataEnd; offset++)value = value * 256 + bytes[offset];
    return value;
}
function $08414ea58bdc1292$var$readEbmlFloat(bytes, element) {
    if (!element) return void 0;
    const data = $08414ea58bdc1292$var$view(bytes);
    if (element.dataEnd - element.dataStart === 4) return data.getFloat32(element.dataStart, false);
    if (element.dataEnd - element.dataStart === 8) return data.getFloat64(element.dataStart, false);
    return void 0;
}
function $08414ea58bdc1292$var$parseHlsInfo(bytes) {
    const text = $08414ea58bdc1292$var$decodeTextHead(bytes);
    if (!text.startsWith("#EXTM3U")) return null;
    const segments = $08414ea58bdc1292$var$countMatches(text, /^#EXTINF:/gm);
    const variants = $08414ea58bdc1292$var$countMatches(text, /^#EXT-X-STREAM-INF:/gm);
    const durations = [
        ...text.matchAll(/^#EXTINF:([0-9.]+)/gm)
    ].map((match)=>Number(match[1])).filter(Number.isFinite);
    const bandwidth = text.match(/BANDWIDTH=(\d+)/i)?.[1];
    return {
        format: "HLS",
        variants: variants,
        segments: segments,
        duration: durations.length > 0 ? $08414ea58bdc1292$var$formatDuration(durations.reduce((sum, value)=>sum + value, 0)) : void 0,
        bitrate: bandwidth ? `${Math.round(Number(bandwidth) / 1e3)} kbps` : void 0
    };
}
function $08414ea58bdc1292$var$parseDashInfo(bytes) {
    const text = $08414ea58bdc1292$var$decodeTextHead(bytes);
    if (!/<MPD[\s>]/i.test(text)) return null;
    return {
        format: "DASH",
        duration: $08414ea58bdc1292$var$isoDurationToClock(text.match(/mediaPresentationDuration=["']([^"']+)["']/i)?.[1]),
        variants: $08414ea58bdc1292$var$countMatches(text, /<Representation\b/gi),
        segments: $08414ea58bdc1292$var$countMatches(text, /<SegmentURL\b|<S\b/gi)
    };
}
function $08414ea58bdc1292$var$decodeTextHead(bytes) {
    return new TextDecoder("utf-8", {
        fatal: false
    }).decode(bytes.slice(0, Math.min(bytes.length, 65536))).trim();
}
function $08414ea58bdc1292$var$countMatches(value, pattern) {
    return [
        ...value.matchAll(pattern)
    ].length;
}
function $08414ea58bdc1292$var$isoDurationToClock(value) {
    if (!value) return void 0;
    const match = value.match(/^PT(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?$/i);
    if (!match) return value;
    const seconds = Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
    return $08414ea58bdc1292$var$formatDuration(seconds);
}
function $08414ea58bdc1292$var$formatDuration(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) return "";
    const total = Math.round(seconds);
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor(total % 3600 / 60);
    const rest = total % 60;
    return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}` : `${minutes}:${String(rest).padStart(2, "0")}`;
}
function $08414ea58bdc1292$var$asciiAt(bytes, offset, length) {
    if (offset < 0 || offset + length > bytes.length) return "";
    return new TextDecoder("latin1").decode(bytes.slice(offset, offset + length));
}
function $08414ea58bdc1292$var$findAscii(bytes, value, start = 0) {
    const encoded = new TextEncoder().encode(value);
    for(let offset = start; offset + encoded.length <= bytes.length; offset++){
        if (encoded.every((byte, index)=>bytes[offset + index] === byte)) return offset;
    }
    return -1;
}
function $08414ea58bdc1292$var$view(bytes) {
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
function $08414ea58bdc1292$var$readUint32Le(bytes, offset) {
    return $08414ea58bdc1292$var$view(bytes).getUint32(offset, true);
}
function $08414ea58bdc1292$var$readUint32Be(bytes, offset) {
    return $08414ea58bdc1292$var$view(bytes).getUint32(offset, false);
}
function $08414ea58bdc1292$var$readUint64Be(bytes, offset) {
    return BigInt($08414ea58bdc1292$var$readUint32Be(bytes, offset)) << 32n | BigInt($08414ea58bdc1292$var$readUint32Be(bytes, offset + 4));
}
// src/plugins/audio.ts
var $08414ea58bdc1292$var$audioExtensions = /* @__PURE__ */ new Set([
    "mp3",
    "wav",
    "aif",
    "aiff",
    "aifc",
    "ogg",
    "oga",
    "aac",
    "m4a",
    "flac",
    "opus",
    "weba",
    "amr",
    "mid",
    "midi",
    "caf",
    "au",
    "snd",
    "wma"
]);
function $08414ea58bdc1292$export$cfac7cfac4f3905() {
    return {
        name: "audio",
        match (file) {
            return file.mimeType.startsWith("audio/") || $08414ea58bdc1292$var$audioExtensions.has(file.extension);
        },
        async render (ctx) {
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const wrapper = document.createElement("div");
            wrapper.className = "ofv-audio";
            const bytes = await $08414ea58bdc1292$var$readAudioBytes(ctx.file.blob);
            const title = document.createElement("div");
            title.className = "ofv-audio-title";
            title.textContent = ctx.file.name;
            const audio = document.createElement("audio");
            audio.src = url;
            audio.controls = true;
            audio.preload = "metadata";
            const infoBar = $08414ea58bdc1292$var$createAudioInfo($08414ea58bdc1292$var$parseAudioInfo(bytes, ctx.file.extension, ctx.file.mimeType));
            infoBar.hidden = true;
            infoBar.setAttribute("aria-hidden", "true");
            infoBar.style.display = "none";
            wrapper.append(title, audio, infoBar);
            ctx.viewport.classList.add("ofv-center");
            ctx.viewport.append(wrapper);
            const formatLabel = (ctx.file.extension || ctx.file.mimeType || "audio").toUpperCase();
            const showPlaybackFallback = ()=>{
                audio.pause();
                audio.remove();
                infoBar.hidden = false;
                infoBar.removeAttribute("aria-hidden");
                infoBar.style.removeProperty("display");
                if (wrapper.querySelector(".ofv-fallback")) return;
                const fallback = document.createElement("div");
                fallback.className = "ofv-fallback";
                const fallbackTitle = document.createElement("strong");
                fallbackTitle.textContent = `\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u76F4\u63A5\u64AD\u653E\u8BE5\u97F3\u9891\u683C\u5F0F (${formatLabel})`;
                const meta = document.createElement("span");
                meta.textContent = "\u5EFA\u8BAE\u8F6C\u6362\u4E3A MP3/AAC/OGG \u7B49\u6D4F\u89C8\u5668\u517C\u5BB9\u683C\u5F0F\uFF0C\u6216\u76F4\u63A5\u4E0B\u8F7D\u5728\u672C\u5730\u64AD\u653E\u3002";
                const download = document.createElement("a");
                download.href = url;
                download.download = ctx.file.name;
                download.textContent = "\u4E0B\u8F7D\u97F3\u9891";
                fallback.append(fallbackTitle, meta, download);
                wrapper.append(fallback);
            };
            audio.addEventListener("error", showPlaybackFallback);
            return {
                destroy () {
                    audio.removeEventListener("error", showPlaybackFallback);
                    audio.pause();
                    ctx.viewport.classList.remove("ofv-center");
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                }
            };
        }
    };
}
async function $08414ea58bdc1292$var$readAudioBytes(blob) {
    if (!blob) return new Uint8Array();
    return new Uint8Array(await blob.arrayBuffer().catch(()=>new ArrayBuffer(0)));
}
function $08414ea58bdc1292$var$createAudioInfo(info) {
    const bar = document.createElement("div");
    bar.className = "ofv-media-info";
    $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u683C\u5F0F", info.format);
    if (info.codec) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u7F16\u7801", info.codec);
    if (info.sampleRate) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u91C7\u6837\u7387", `${info.sampleRate} Hz`);
    if (info.channels) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u58F0\u9053", String(info.channels));
    if (info.bitDepth) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u4F4D\u6DF1", `${info.bitDepth} bit`);
    if (info.bitrate) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u7801\u7387", info.bitrate);
    if (info.duration) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u65F6\u957F", info.duration);
    if (info.tags) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u6807\u7B7E", info.tags);
    if (info.note) $08414ea58bdc1292$var$appendMediaInfo2(bar, "\u8BF4\u660E", info.note);
    return bar;
}
function $08414ea58bdc1292$var$appendMediaInfo2(parent, label, value) {
    const item = document.createElement("span");
    item.className = "ofv-media-info-item";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    item.append(key, content);
    parent.append(item);
}
function $08414ea58bdc1292$var$parseAudioInfo(bytes, extension, mimeType) {
    const fallback = (extension || mimeType || "audio").toUpperCase();
    if (bytes.length === 0) return {
        format: fallback,
        note: "\u65E0\u6CD5\u8BFB\u53D6\u672C\u5730\u5934\u4FE1\u606F"
    };
    return $08414ea58bdc1292$var$parseWaveInfo(bytes) || $08414ea58bdc1292$var$parseFlacInfo(bytes) || $08414ea58bdc1292$var$parseOggInfo(bytes) || $08414ea58bdc1292$var$parseAiffInfo(bytes) || $08414ea58bdc1292$var$parseAuInfo(bytes) || $08414ea58bdc1292$var$parseMidiInfo(bytes) || $08414ea58bdc1292$var$parseAdtsAacInfo(bytes) || $08414ea58bdc1292$var$parseId3Mp3Info(bytes) || {
        format: fallback,
        note: "\u6682\u672A\u8BC6\u522B\u97F3\u9891\u5934\u7ED3\u6784"
    };
}
function $08414ea58bdc1292$var$parseWaveInfo(bytes) {
    if (bytes.length < 44 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== "RIFF" || $08414ea58bdc1292$var$asciiAt2(bytes, 8, 4) !== "WAVE") return null;
    let offset = 12;
    let channels = 0;
    let sampleRate = 0;
    let bitDepth = 0;
    let byteRate = 0;
    let dataBytes = 0;
    while(offset + 8 <= bytes.length){
        const chunk = $08414ea58bdc1292$var$asciiAt2(bytes, offset, 4);
        const size = $08414ea58bdc1292$var$readUint32Le2(bytes, offset + 4);
        const dataOffset = offset + 8;
        if (chunk === "fmt " && dataOffset + 16 <= bytes.length) {
            channels = $08414ea58bdc1292$var$readUint16Le(bytes, dataOffset + 2);
            sampleRate = $08414ea58bdc1292$var$readUint32Le2(bytes, dataOffset + 4);
            byteRate = $08414ea58bdc1292$var$readUint32Le2(bytes, dataOffset + 8);
            bitDepth = $08414ea58bdc1292$var$readUint16Le(bytes, dataOffset + 14);
        }
        if (chunk === "data") dataBytes = size;
        offset += 8 + size + size % 2;
    }
    return {
        format: "WAV",
        codec: "PCM",
        sampleRate: sampleRate,
        channels: channels,
        bitDepth: bitDepth,
        bitrate: byteRate ? `${Math.round(byteRate * 8 / 1e3)} kbps` : void 0,
        duration: byteRate && dataBytes ? $08414ea58bdc1292$var$formatDuration2(dataBytes / byteRate) : void 0
    };
}
function $08414ea58bdc1292$var$parseFlacInfo(bytes) {
    if (bytes.length < 42 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== "fLaC") return null;
    let offset = 4;
    while(offset + 4 <= bytes.length){
        const type = bytes[offset] & 127;
        const length = bytes[offset + 1] << 16 | bytes[offset + 2] << 8 | bytes[offset + 3];
        const dataOffset = offset + 4;
        if (type === 0 && dataOffset + 34 <= bytes.length) {
            const b10 = bytes[dataOffset + 10];
            const b11 = bytes[dataOffset + 11];
            const b12 = bytes[dataOffset + 12];
            const b13 = bytes[dataOffset + 13];
            const b14 = bytes[dataOffset + 14];
            const b15 = bytes[dataOffset + 15];
            const b16 = bytes[dataOffset + 16];
            const b17 = bytes[dataOffset + 17];
            const sampleRate = b10 << 12 | b11 << 4 | (b12 & 240) >> 4;
            const channels = ((b12 & 14) >> 1) + 1;
            const bitDepth = ((b12 & 1) << 4 | (b13 & 240) >> 4) + 1;
            const totalSamples = BigInt(b13 & 15) << 32n | BigInt(b14) << 24n | BigInt(b15) << 16n | BigInt(b16) << 8n | BigInt(b17);
            return {
                format: "FLAC",
                codec: "FLAC",
                sampleRate: sampleRate,
                channels: channels,
                bitDepth: bitDepth,
                duration: sampleRate && totalSamples > 0n ? $08414ea58bdc1292$var$formatDuration2(Number(totalSamples) / sampleRate) : void 0
            };
        }
        offset += 4 + length;
    }
    return {
        format: "FLAC",
        codec: "FLAC",
        note: "\u672A\u627E\u5230 STREAMINFO metadata block"
    };
}
function $08414ea58bdc1292$var$parseId3Mp3Info(bytes) {
    let offset = 0;
    let tags;
    if (bytes.length >= 10 && $08414ea58bdc1292$var$asciiAt2(bytes, 0, 3) === "ID3") {
        tags = `ID3v2.${bytes[3]}.${bytes[4]}`;
        offset = 10 + $08414ea58bdc1292$var$readSynchsafe(bytes, 6);
    }
    for(let index = offset; index + 3 < Math.min(bytes.length, offset + 4096); index++)if (bytes[index] === 255 && (bytes[index + 1] & 224) === 224) {
        const versionBits = bytes[index + 1] >> 3 & 3;
        const layerBits = bytes[index + 1] >> 1 & 3;
        const bitrateIndex = bytes[index + 2] >> 4 & 15;
        const sampleIndex = bytes[index + 2] >> 2 & 3;
        const channelMode = bytes[index + 3] >> 6 & 3;
        return {
            format: "MP3",
            codec: `${$08414ea58bdc1292$var$mpegVersion(versionBits)} Layer ${$08414ea58bdc1292$var$mpegLayer(layerBits)}`,
            sampleRate: $08414ea58bdc1292$var$mp3SampleRate(versionBits, sampleIndex),
            channels: channelMode === 3 ? 1 : 2,
            bitrate: $08414ea58bdc1292$var$mp3Bitrate(versionBits, layerBits, bitrateIndex),
            tags: tags
        };
    }
    return tags ? {
        format: "MP3",
        tags: tags,
        note: "\u672A\u5728\u5934\u90E8\u626B\u63CF\u5230 MPEG frame"
    } : null;
}
function $08414ea58bdc1292$var$parseOggInfo(bytes) {
    if (bytes.length < 36 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== "OggS") return null;
    const pages = $08414ea58bdc1292$var$collectOggPages(bytes);
    const firstPacket = pages[0]?.packets[0];
    const lastGranule = [
        ...pages
    ].reverse().find((page)=>page.granule > 0n)?.granule;
    if (firstPacket && $08414ea58bdc1292$var$asciiAt2(firstPacket, 0, 8) === "OpusHead") {
        const preSkip = firstPacket.length >= 12 ? $08414ea58bdc1292$var$readUint16Le(firstPacket, 10) : 0;
        const sampleRate = firstPacket.length >= 16 ? $08414ea58bdc1292$var$readUint32Le2(firstPacket, 12) : 48e3;
        const totalSamples = lastGranule === void 0 ? void 0 : lastGranule - BigInt(preSkip);
        return {
            format: "Ogg",
            codec: "Opus",
            channels: firstPacket[9],
            sampleRate: sampleRate,
            duration: totalSamples !== void 0 && totalSamples > 0n ? $08414ea58bdc1292$var$formatDuration2(Number(totalSamples) / 48e3) : void 0,
            note: `${pages.length} \u9875`
        };
    }
    if (firstPacket && firstPacket[0] === 1 && $08414ea58bdc1292$var$asciiAt2(firstPacket, 1, 6) === "vorbis") {
        const sampleRate = firstPacket.length >= 16 ? $08414ea58bdc1292$var$readUint32Le2(firstPacket, 12) : void 0;
        return {
            format: "Ogg",
            codec: "Vorbis",
            channels: firstPacket[11],
            sampleRate: sampleRate,
            bitrate: firstPacket.length >= 28 ? $08414ea58bdc1292$var$oggVorbisBitrate(firstPacket) : void 0,
            duration: sampleRate && lastGranule !== void 0 && lastGranule > 0n ? $08414ea58bdc1292$var$formatDuration2(Number(lastGranule) / sampleRate) : void 0,
            note: `${pages.length} \u9875`
        };
    }
    return {
        format: "Ogg",
        note: pages.length > 0 ? `\u672A\u8BC6\u522B Ogg codec header\uFF0C${pages.length} \u9875` : "\u672A\u8BC6\u522B Ogg codec header"
    };
}
function $08414ea58bdc1292$var$collectOggPages(bytes) {
    const pages = [];
    let offset = 0;
    let continuedPacket = [];
    while(offset + 27 <= bytes.length && $08414ea58bdc1292$var$asciiAt2(bytes, offset, 4) === "OggS"){
        const segmentCount = bytes[offset + 26];
        const segmentTableOffset = offset + 27;
        const dataOffset = segmentTableOffset + segmentCount;
        if (dataOffset > bytes.length) break;
        const sizes = Array.from(bytes.slice(segmentTableOffset, dataOffset));
        const payloadLength = sizes.reduce((sum, value)=>sum + value, 0);
        const payloadEnd = dataOffset + payloadLength;
        if (payloadEnd > bytes.length) break;
        const pagePackets = [];
        let packetOffset = dataOffset;
        for (const size of sizes){
            continuedPacket.push(...bytes.slice(packetOffset, packetOffset + size));
            packetOffset += size;
            if (size < 255) {
                pagePackets.push(new Uint8Array(continuedPacket));
                continuedPacket = [];
            }
        }
        pages.push({
            granule: $08414ea58bdc1292$var$readUint64Le(bytes, offset + 6),
            packets: pagePackets
        });
        offset = payloadEnd;
    }
    return pages;
}
function $08414ea58bdc1292$var$oggVorbisBitrate(packet) {
    const nominal = $08414ea58bdc1292$var$readUint32Le2(packet, 20);
    if (nominal > 0) return `${Math.round(nominal / 1e3)} kbps`;
    const upper = $08414ea58bdc1292$var$readUint32Le2(packet, 16);
    const lower = $08414ea58bdc1292$var$readUint32Le2(packet, 24);
    if (upper > 0 && lower > 0) return `${Math.round((upper + lower) / 2 / 1e3)} kbps`;
    return void 0;
}
function $08414ea58bdc1292$var$parseAiffInfo(bytes) {
    if (bytes.length < 12 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== "FORM" || ![
        "AIFF",
        "AIFC"
    ].includes($08414ea58bdc1292$var$asciiAt2(bytes, 8, 4))) return null;
    const format = $08414ea58bdc1292$var$asciiAt2(bytes, 8, 4);
    let offset = 12;
    while(offset + 26 <= bytes.length){
        const chunk = $08414ea58bdc1292$var$asciiAt2(bytes, offset, 4);
        const size = $08414ea58bdc1292$var$readUint32Be2(bytes, offset + 4);
        if (chunk === "COMM") return {
            format: format,
            channels: $08414ea58bdc1292$var$readUint16Be(bytes, offset + 8),
            bitDepth: $08414ea58bdc1292$var$readUint16Be(bytes, offset + 14),
            sampleRate: Math.round($08414ea58bdc1292$var$readAiffExtended(bytes, offset + 16))
        };
        offset += 8 + size + size % 2;
    }
    return {
        format: format,
        note: "\u672A\u627E\u5230 COMM chunk"
    };
}
function $08414ea58bdc1292$var$parseAuInfo(bytes) {
    if (bytes.length < 24 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== ".snd") return null;
    const dataOffset = $08414ea58bdc1292$var$readUint32Be2(bytes, 4);
    const dataSize = $08414ea58bdc1292$var$readUint32Be2(bytes, 8);
    const encoding = $08414ea58bdc1292$var$readUint32Be2(bytes, 12);
    const sampleRate = $08414ea58bdc1292$var$readUint32Be2(bytes, 16);
    const channels = $08414ea58bdc1292$var$readUint32Be2(bytes, 20);
    const bitDepth = $08414ea58bdc1292$var$auBitDepth(encoding);
    const bytesPerSample = bitDepth ? bitDepth / 8 : 0;
    const resolvedDataSize = dataSize === 4294967295 ? Math.max(0, bytes.length - dataOffset) : dataSize;
    return {
        format: "AU/SND",
        codec: $08414ea58bdc1292$var$auEncodingName(encoding),
        sampleRate: sampleRate,
        channels: channels,
        bitDepth: bitDepth,
        duration: sampleRate && channels && bytesPerSample && resolvedDataSize ? $08414ea58bdc1292$var$formatDuration2(resolvedDataSize / (sampleRate * channels * bytesPerSample)) : void 0,
        note: `data @ ${dataOffset} B`
    };
}
function $08414ea58bdc1292$var$auEncodingName(value) {
    const names = {
        1: "8-bit \u03BC-law",
        2: "8-bit linear PCM",
        3: "16-bit linear PCM",
        4: "24-bit linear PCM",
        5: "32-bit linear PCM",
        6: "32-bit float",
        7: "64-bit float",
        23: "G.721 ADPCM",
        24: "G.722 ADPCM",
        25: "G.723 3-bit ADPCM",
        26: "G.723 5-bit ADPCM",
        27: "8-bit A-law"
    };
    return names[value] || `encoding ${value}`;
}
function $08414ea58bdc1292$var$auBitDepth(value) {
    const depths = {
        1: 8,
        2: 8,
        3: 16,
        4: 24,
        5: 32,
        6: 32,
        7: 64,
        27: 8
    };
    return depths[value];
}
function $08414ea58bdc1292$var$parseMidiInfo(bytes) {
    if (bytes.length < 14 || $08414ea58bdc1292$var$asciiAt2(bytes, 0, 4) !== "MThd") return null;
    return {
        format: "MIDI",
        codec: `SMF ${$08414ea58bdc1292$var$readUint16Be(bytes, 8)}`,
        channels: $08414ea58bdc1292$var$readUint16Be(bytes, 10),
        note: `${$08414ea58bdc1292$var$readUint16Be(bytes, 12)} ticks/quarter`
    };
}
function $08414ea58bdc1292$var$parseAdtsAacInfo(bytes) {
    if (bytes.length < 7 || bytes[0] !== 255 || (bytes[1] & 240) !== 240) return null;
    const profile = (bytes[2] >> 6 & 3) + 1;
    const sampleIndex = bytes[2] >> 2 & 15;
    const channels = (bytes[2] & 1) << 2 | bytes[3] >> 6 & 3;
    return {
        format: "AAC",
        codec: `AAC ADTS profile ${profile}`,
        sampleRate: $08414ea58bdc1292$var$aacSampleRate(sampleIndex),
        channels: channels || void 0,
        note: "ADTS stream"
    };
}
function $08414ea58bdc1292$var$aacSampleRate(index) {
    return [
        96e3,
        88200,
        64e3,
        48e3,
        44100,
        32e3,
        24e3,
        22050,
        16e3,
        12e3,
        11025,
        8e3,
        7350
    ][index];
}
function $08414ea58bdc1292$var$formatDuration2(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) return "";
    const total = Math.round(seconds);
    const minutes = Math.floor(total / 60);
    const rest = total % 60;
    return `${minutes}:${String(rest).padStart(2, "0")}`;
}
function $08414ea58bdc1292$var$asciiAt2(bytes, offset, length) {
    if (offset < 0 || offset + length > bytes.length) return "";
    return new TextDecoder("ascii").decode(bytes.slice(offset, offset + length));
}
function $08414ea58bdc1292$var$view2(bytes) {
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
function $08414ea58bdc1292$var$readUint16Le(bytes, offset) {
    return $08414ea58bdc1292$var$view2(bytes).getUint16(offset, true);
}
function $08414ea58bdc1292$var$readUint16Be(bytes, offset) {
    return $08414ea58bdc1292$var$view2(bytes).getUint16(offset, false);
}
function $08414ea58bdc1292$var$readUint32Le2(bytes, offset) {
    return $08414ea58bdc1292$var$view2(bytes).getUint32(offset, true);
}
function $08414ea58bdc1292$var$readUint32Be2(bytes, offset) {
    return $08414ea58bdc1292$var$view2(bytes).getUint32(offset, false);
}
function $08414ea58bdc1292$var$readUint64Le(bytes, offset) {
    return BigInt($08414ea58bdc1292$var$readUint32Le2(bytes, offset + 4)) << 32n | BigInt($08414ea58bdc1292$var$readUint32Le2(bytes, offset));
}
function $08414ea58bdc1292$var$readSynchsafe(bytes, offset) {
    return (bytes[offset] & 127) << 21 | (bytes[offset + 1] & 127) << 14 | (bytes[offset + 2] & 127) << 7 | bytes[offset + 3] & 127;
}
function $08414ea58bdc1292$var$mpegVersion(bits) {
    return bits === 3 ? "MPEG-1" : bits === 2 ? "MPEG-2" : bits === 0 ? "MPEG-2.5" : "MPEG";
}
function $08414ea58bdc1292$var$mpegLayer(bits) {
    return bits === 3 ? "I" : bits === 2 ? "II" : bits === 1 ? "III" : "?";
}
function $08414ea58bdc1292$var$mp3SampleRate(versionBits, index) {
    const rates = versionBits === 3 ? [
        44100,
        48e3,
        32e3
    ] : versionBits === 2 ? [
        22050,
        24e3,
        16e3
    ] : [
        11025,
        12e3,
        8e3
    ];
    return rates[index];
}
function $08414ea58bdc1292$var$mp3Bitrate(versionBits, layerBits, index) {
    const mpeg1Layer3 = [
        0,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        160,
        192,
        224,
        256,
        320
    ];
    const mpeg2Layer3 = [
        0,
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        144,
        160
    ];
    if (index <= 0 || index >= 15 || layerBits !== 1) return void 0;
    return `${(versionBits === 3 ? mpeg1Layer3 : mpeg2Layer3)[index]} kbps`;
}
function $08414ea58bdc1292$var$readAiffExtended(bytes, offset) {
    const exponent = $08414ea58bdc1292$var$readUint16Be(bytes, offset) & 32767;
    let mantissa = 0;
    for(let index = 0; index < 8; index++)mantissa = mantissa * 256 + bytes[offset + 2 + index];
    return mantissa * Math.pow(2, exponent - 16383 - 63);
}
// src/plugins/lrc.ts
var $08414ea58bdc1292$var$lrcModeIconPaths = {
    display: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM184,96a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,96Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,128Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,160Z",
    annotated: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z",
    source: "M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z"
};
var $08414ea58bdc1292$var$TIME_TAG = String.raw`\d{1,3}:\d{2}(?:[.:]\d{1,3})?`;
var $08414ea58bdc1292$var$lineTimePattern = new RegExp(`^\\s*((?:\\[${$08414ea58bdc1292$var$TIME_TAG}\\])+)(.*)$`);
var $08414ea58bdc1292$var$timeTagPattern = new RegExp(`\\[(${$08414ea58bdc1292$var$TIME_TAG})\\]`, "g");
var $08414ea58bdc1292$var$wordTimePattern = new RegExp(`<(${$08414ea58bdc1292$var$TIME_TAG})>`, "g");
var $08414ea58bdc1292$var$metadataTagPattern = /\[([a-zA-Z][\w-]*|#):([^\]]*)\]/g;
var $08414ea58bdc1292$var$trackInformationKeys = [
    "al",
    "au",
    "lr",
    "length"
];
var $08414ea58bdc1292$var$fileInformationKeys = [
    "by",
    "offset",
    "re",
    "tool",
    "ve"
];
var $08414ea58bdc1292$var$lrcPreviewSequence = 0;
function $08414ea58bdc1292$var$parseLrc(source) {
    const metadata = [];
    const lyrics = [];
    let activeRole;
    source.split(/\r?\n/).forEach((rawLine, index)=>{
        const line = index + 1;
        const trimmed = rawLine.trim();
        if (!trimmed) return;
        const metadataEntries = $08414ea58bdc1292$var$parseMetadataLine(trimmed, line);
        if (metadataEntries) {
            metadata.push(...metadataEntries);
            return;
        }
        const timed = rawLine.match($08414ea58bdc1292$var$lineTimePattern);
        const timestamps = [];
        let content = rawLine;
        if (timed) {
            for (const match of timed[1].matchAll($08414ea58bdc1292$var$timeTagPattern))timestamps.push(match[1]);
            content = timed[2];
        }
        const roleMatch = content.match(/^\s*([MFD]):\s*/i);
        const explicitRole = roleMatch?.[1].toUpperCase();
        if (explicitRole) {
            activeRole = explicitRole;
            content = content.slice(roleMatch[0].length);
        }
        const words = $08414ea58bdc1292$var$parseTimedWords(content);
        const text = words.map((word)=>word.text).join("");
        if (timestamps.length > 0 || text.trim() || explicitRole) lyrics.push({
            timestamps: timestamps,
            text: text,
            words: words,
            role: activeRole,
            explicitRole: explicitRole,
            line: line
        });
    });
    return {
        metadata: metadata,
        lyrics: lyrics
    };
}
function $08414ea58bdc1292$var$parseMetadataLine(source, line) {
    const entries = [];
    let consumed = "";
    $08414ea58bdc1292$var$metadataTagPattern.lastIndex = 0;
    for (const match of source.matchAll($08414ea58bdc1292$var$metadataTagPattern)){
        entries.push({
            key: match[1].toLowerCase(),
            value: match[2].trim(),
            line: line
        });
        consumed += match[0];
    }
    return entries.length > 0 && consumed === source ? entries : void 0;
}
function $08414ea58bdc1292$var$parseTimedWords(source) {
    const words = [];
    let cursor = 0;
    let activeTimestamp;
    $08414ea58bdc1292$var$wordTimePattern.lastIndex = 0;
    for (const match of source.matchAll($08414ea58bdc1292$var$wordTimePattern)){
        if (match.index > cursor) words.push({
            timestamp: activeTimestamp,
            text: source.slice(cursor, match.index)
        });
        activeTimestamp = match[1];
        cursor = match.index + match[0].length;
    }
    if (cursor < source.length) words.push({
        timestamp: activeTimestamp,
        text: source.slice(cursor)
    });
    if (words.length === 0) words.push({
        text: source
    });
    return words;
}
function $08414ea58bdc1292$var$createLrcPreviewViews(parsed, fileName, messages, sourceView, wrapButton) {
    const modeBar = document.createElement("div");
    modeBar.className = "ofv-lrc-modebar";
    const group = document.createElement("div");
    group.className = "ofv-lrc-mode-switch";
    group.setAttribute("role", "tablist");
    group.setAttribute("aria-label", messages.lrcPreviewMode);
    group.setAttribute("aria-orientation", "horizontal");
    const annotatedView = $08414ea58bdc1292$var$createAnnotatedView(parsed, messages);
    const displayView = $08414ea58bdc1292$var$createDisplayView(parsed, fileName, messages);
    const instanceId = ++$08414ea58bdc1292$var$lrcPreviewSequence;
    const panels = {
        display: displayView,
        annotated: annotatedView,
        source: sourceView
    };
    const modes = [
        [
            "display",
            messages.lrcDisplayMode
        ],
        [
            "annotated",
            messages.lrcAnnotatedMode
        ],
        [
            "source",
            messages.lrcSourceMode
        ]
    ];
    const buttons = /* @__PURE__ */ new Map();
    modes.forEach(([mode, text])=>{
        const button = document.createElement("button");
        button.type = "button";
        button.className = "ofv-lrc-mode-button";
        button.dataset.mode = mode;
        button.id = `ofv-lrc-${instanceId}-tab-${mode}`;
        button.setAttribute("role", "tab");
        button.setAttribute("aria-controls", `ofv-lrc-${instanceId}-panel-${mode}`);
        button.setAttribute("aria-selected", "false");
        button.setAttribute("aria-label", text);
        button.title = text;
        button.tabIndex = -1;
        button.append($08414ea58bdc1292$var$createLrcModeIcon(mode));
        const panel = panels[mode];
        panel.id = `ofv-lrc-${instanceId}-panel-${mode}`;
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", button.id);
        buttons.set(mode, button);
        group.append(button);
    });
    modeBar.append(group);
    const setMode = (mode)=>{
        sourceView.hidden = mode !== "source";
        annotatedView.hidden = mode !== "annotated";
        displayView.hidden = mode !== "display";
        wrapButton.hidden = mode !== "source";
        buttons.forEach((button, buttonMode)=>{
            const active = buttonMode === mode;
            button.setAttribute("aria-selected", String(active));
            button.tabIndex = active ? 0 : -1;
        });
        modeBar.dataset.activeMode = mode;
    };
    buttons.forEach((button, mode)=>button.addEventListener("click", ()=>setMode(mode)));
    group.addEventListener("keydown", (event)=>{
        const currentIndex = modes.findIndex(([mode])=>buttons.get(mode) === document.activeElement);
        if (currentIndex < 0) return;
        let nextIndex = currentIndex;
        if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % modes.length;
        else if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + modes.length) % modes.length;
        else if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = modes.length - 1;
        else return;
        event.preventDefault();
        const nextMode = modes[nextIndex][0];
        setMode(nextMode);
        buttons.get(nextMode)?.focus();
    });
    setMode("display");
    return {
        modeBar: modeBar,
        annotatedView: annotatedView,
        displayView: displayView,
        setMode: setMode
    };
}
function $08414ea58bdc1292$var$createLrcModeIcon(mode) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("ofv-lrc-mode-icon");
    svg.setAttribute("viewBox", "0 0 256 256");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    const path = document.createElementNS(svg.namespaceURI, "path");
    path.setAttribute("d", $08414ea58bdc1292$var$lrcModeIconPaths[mode]);
    path.setAttribute("fill", "currentColor");
    svg.append(path);
    return svg;
}
function $08414ea58bdc1292$var$createAnnotatedView(parsed, messages) {
    const view3 = document.createElement("div");
    view3.className = "ofv-lrc-annotated";
    const table = document.createElement("div");
    table.className = "ofv-lrc-annotated-table";
    parsed.metadata.forEach((entry)=>{
        const row = document.createElement("div");
        row.className = "ofv-lrc-annotated-row is-metadata";
        row.classList.add(entry.key === "ti" ? "is-title" : "is-secondary");
        row.dataset.tag = entry.key;
        const gutter = document.createElement("div");
        gutter.className = "ofv-lrc-annotated-gutter";
        const label = document.createElement("span");
        label.className = "ofv-lrc-meta-label";
        label.textContent = entry.key;
        gutter.append(label);
        const value = document.createElement("div");
        value.className = "ofv-lrc-meta-value";
        value.textContent = entry.value;
        row.append(gutter, value);
        table.append(row);
    });
    parsed.lyrics.forEach((entry)=>{
        const row = document.createElement("div");
        row.className = "ofv-lrc-annotated-row is-lyric";
        if (entry.role) row.dataset.role = entry.role;
        const gutter = document.createElement("div");
        gutter.className = "ofv-lrc-annotated-gutter";
        const times = document.createElement("span");
        times.className = "ofv-lrc-times";
        if (entry.timestamps.length === 0) times.textContent = "\xB7";
        else entry.timestamps.forEach((timestamp)=>{
            const time = document.createElement("span");
            time.className = "ofv-lrc-time";
            time.textContent = timestamp;
            times.append(time);
        });
        gutter.append(times);
        const lyric = document.createElement("div");
        lyric.className = "ofv-lrc-annotated-text";
        if (entry.explicitRole) lyric.append($08414ea58bdc1292$var$createRoleBadge(entry.explicitRole, messages));
        const lyricContent = document.createElement("span");
        lyricContent.className = "ofv-lrc-annotated-content";
        $08414ea58bdc1292$var$appendTimedWords(lyricContent, entry.words, messages);
        lyric.append(lyricContent);
        row.append(gutter, lyric);
        table.append(row);
    });
    if (!table.hasChildNodes()) {
        const empty = document.createElement("p");
        empty.className = "ofv-lrc-empty";
        empty.textContent = messages.lrcEmpty;
        table.append(empty);
    }
    view3.append(table);
    return view3;
}
function $08414ea58bdc1292$var$appendTimedWords(container, words, messages) {
    const visibleWords = words.map((word)=>({
            ...word,
            text: word.text.trim()
        })).filter((word)=>word.text.length > 0);
    visibleWords.forEach((word, index)=>{
        if (index > 0) {
            const separator = document.createElement("span");
            separator.className = "ofv-lrc-word-separator";
            separator.textContent = " ";
            separator.setAttribute("aria-hidden", "true");
            container.append(separator);
        }
        if (!word.timestamp) {
            container.append(document.createTextNode(word.text));
            return;
        }
        const ruby = document.createElement("ruby");
        ruby.className = "ofv-lrc-timed-word";
        ruby.tabIndex = 0;
        ruby.setAttribute("aria-label", `${word.text}, ${messages.lrcWordTimestamp}: ${word.timestamp}`);
        const text = document.createElement("span");
        text.className = "ofv-lrc-word-text";
        text.textContent = word.text;
        const timestamp = document.createElement("rt");
        timestamp.textContent = word.timestamp;
        ruby.append(text, timestamp);
        container.append(ruby);
    });
}
function $08414ea58bdc1292$var$createDisplayView(parsed, fileName, messages) {
    const view3 = document.createElement("div");
    view3.className = "ofv-lrc-display";
    const page = document.createElement("article");
    page.className = "ofv-lrc-display-page";
    const header = document.createElement("div");
    header.className = "ofv-lrc-display-header";
    const title = $08414ea58bdc1292$var$metadataValue(parsed, "ti") || fileName.replace(/\.lrc$/i, "");
    const heading = document.createElement("h2");
    heading.textContent = title;
    header.append(heading);
    const artist = $08414ea58bdc1292$var$metadataValue(parsed, "ar");
    if (artist) {
        const artistName = document.createElement("p");
        artistName.className = "ofv-lrc-display-artist";
        artistName.textContent = artist;
        header.append(artistName);
    }
    const trackInformation = $08414ea58bdc1292$var$createCredits(parsed, messages, $08414ea58bdc1292$var$trackInformationKeys);
    if (trackInformation) {
        trackInformation.classList.add("ofv-lrc-display-track-info");
        trackInformation.setAttribute("aria-label", messages.lrcTrackInformation);
        header.append(trackInformation);
    }
    page.append(header);
    const lyrics = document.createElement("div");
    lyrics.className = "ofv-lrc-display-lyrics";
    parsed.lyrics.forEach((entry)=>{
        if (!entry.text.trim()) return;
        const line = document.createElement("p");
        line.className = "ofv-lrc-display-line";
        if (entry.role) line.dataset.role = entry.role;
        if (entry.explicitRole) line.append($08414ea58bdc1292$var$createRoleBadge(entry.explicitRole, messages));
        const lyricContent = document.createElement("span");
        lyricContent.className = "ofv-lrc-display-content";
        lyricContent.textContent = entry.text;
        line.append(lyricContent);
        lyrics.append(line);
    });
    if (!lyrics.hasChildNodes()) {
        const empty = document.createElement("p");
        empty.className = "ofv-lrc-empty";
        empty.textContent = messages.lrcEmpty;
        lyrics.append(empty);
    }
    page.append(lyrics);
    const fileInformation = $08414ea58bdc1292$var$createCredits(parsed, messages, $08414ea58bdc1292$var$fileInformationKeys);
    if (fileInformation) {
        const footer = document.createElement("div");
        footer.className = "ofv-lrc-display-file-info";
        footer.append(fileInformation);
        page.append(footer);
    }
    view3.append(page);
    return view3;
}
function $08414ea58bdc1292$var$createCredits(parsed, messages, keys) {
    const labels = {
        al: messages.lrcAlbum,
        au: messages.lrcAuthor,
        lr: messages.lrcLyricist,
        by: messages.lrcLrcBy,
        length: messages.lrcLength,
        offset: messages.lrcOffset,
        re: messages.lrcTool,
        tool: messages.lrcTool,
        ve: messages.lrcVersion
    };
    const entries = parsed.metadata.filter((entry)=>keys.includes(entry.key) && labels[entry.key] && entry.value);
    if (entries.length === 0) return void 0;
    const credits = document.createElement("dl");
    credits.className = "ofv-lrc-display-credits";
    entries.forEach((entry)=>{
        const term = document.createElement("dt");
        term.textContent = labels[entry.key];
        const value = document.createElement("dd");
        value.textContent = entry.value;
        credits.append(term, value);
    });
    return credits;
}
function $08414ea58bdc1292$var$metadataValue(parsed, key) {
    return parsed.metadata.find((entry)=>entry.key === key && entry.value)?.value;
}
function $08414ea58bdc1292$var$createRoleBadge(role, messages) {
    const labels = {
        M: messages.lrcMale,
        F: messages.lrcFemale,
        D: messages.lrcDuet
    };
    const badge = document.createElement("sup");
    badge.className = "ofv-lrc-role";
    badge.dataset.role = role;
    badge.textContent = role;
    badge.title = labels[role];
    badge.setAttribute("aria-label", labels[role]);
    return badge;
}
// src/plugins/text.ts
var $08414ea58bdc1292$var$langMap = {
    lrc: "none",
    js: "javascript",
    mjs: "javascript",
    cjs: "javascript",
    ts: "typescript",
    tsx: "tsx",
    jsx: "jsx",
    html: "markup",
    htm: "markup",
    vue: "markup",
    xml: "markup",
    css: "css",
    scss: "scss",
    less: "less",
    json: "json",
    jsonc: "json",
    json5: "json5",
    ipynb: "json",
    jsonl: "json",
    ndjson: "json",
    toml: "toml",
    ini: "ini",
    properties: "properties",
    proto: "protobuf",
    tf: "hcl",
    tfvars: "hcl",
    hcl: "hcl",
    tex: "latex",
    latex: "latex",
    bib: "latex",
    gv: "dot",
    http: "http",
    py: "python",
    java: "java",
    cpp: "cpp",
    c: "c",
    h: "c",
    hpp: "cpp",
    cs: "csharp",
    go: "go",
    rs: "rust",
    rb: "ruby",
    swift: "swift",
    kt: "kotlin",
    kts: "kotlin",
    scala: "scala",
    lua: "lua",
    r: "r",
    dart: "dart",
    svelte: "markup",
    astro: "markup",
    elm: "elm",
    ex: "elixir",
    exs: "elixir",
    clj: "clojure",
    cljs: "clojure",
    erl: "erlang",
    hrl: "erlang",
    fs: "fsharp",
    fsx: "fsharp",
    hs: "haskell",
    lhs: "haskell",
    sql: "sql",
    sh: "bash",
    bash: "bash",
    zsh: "bash",
    fish: "bash",
    ps1: "powershell",
    bat: "batch",
    cmd: "batch",
    dockerfile: "docker",
    nginxconf: "nginx",
    gradle: "groovy",
    graphql: "graphql",
    gql: "graphql",
    yaml: "yaml",
    yml: "yaml",
    diff: "diff",
    patch: "diff",
    php: "php",
    md: "markdown",
    markdown: "markdown",
    mmd: "mermaid",
    mermaid: "mermaid"
};
var $08414ea58bdc1292$var$filenameLangMap = {
    dockerfile: "docker",
    makefile: "makefile",
    gemfile: "ruby",
    rakefile: "ruby",
    procfile: "bash",
    jenkinsfile: "groovy",
    vagrantfile: "ruby",
    brewfile: "ruby",
    podfile: "ruby",
    "go.mod": "go",
    "go.sum": "go",
    "cargo.toml": "toml",
    "cargo.lock": "toml",
    ".gitignore": "none",
    ".dockerignore": "ignore",
    ".npmrc": "none",
    ".yarnrc": "none",
    ".pnpmrc": "none",
    ".editorconfig": "editorconfig",
    ".browserslistrc": "none",
    ".prettierrc": "json",
    ".eslintrc": "json",
    ".stylelintrc": "json",
    readme: "markdown",
    changelog: "markdown",
    changes: "markdown",
    history: "markdown",
    license: "none",
    licence: "none",
    copying: "none",
    notice: "none",
    authors: "none",
    contributors: "none",
    codeowners: "none"
};
var $08414ea58bdc1292$var$mimeLangMap = {
    "application/lrc": "none",
    "application/x-lrc": "none",
    "text/lrc": "none",
    "text/x-lrc": "none",
    "text/markdown": "markdown",
    "text/plain": "none",
    "text/vnd.mermaid": "mermaid",
    "text/html": "markup",
    "application/xml": "markup",
    "text/xml": "markup",
    "application/json": "json",
    "application/json5": "json5",
    "application/x-ipynb+json": "json",
    "application/x-ndjson": "json",
    "application/yaml": "yaml",
    "application/x-yaml": "yaml",
    "text/yaml": "yaml",
    "application/javascript": "javascript",
    "application/x-javascript": "javascript",
    "text/javascript": "javascript",
    "application/typescript": "typescript",
    "application/x-typescript": "typescript",
    "text/typescript": "typescript",
    "application/sql": "sql",
    "application/x-sh": "bash",
    "application/graphql": "graphql",
    "text/calendar": "none",
    "text/vcard": "none",
    "application/x-pem-file": "none",
    "application/x-x509-ca-cert": "none",
    "application/pkix-cert": "none",
    "application/x-httpd-php": "php",
    "application/x-tex": "latex",
    "message/http": "http",
    "text/x-bibtex": "latex",
    "text/x-hcl": "hcl",
    "text/x-protobuf": "protobuf",
    "text/vnd.graphviz": "dot",
    "text/css": "css"
};
var $08414ea58bdc1292$var$MAX_HIGHLIGHT_CHARS = 18e4;
var $08414ea58bdc1292$var$MAX_RENDER_CHARS = 6e5;
var $08414ea58bdc1292$var$prismLanguageLoads = /* @__PURE__ */ new Map();




function $08414ea58bdc1292$export$9be06fe47280e9b4() {
    return {
        name: "text",
        match (file) {
            return (0, $3438a2478d5b847f$export$a5de46ac017c9da9)(file);
        },
        async render (ctx) {
            const ext = ctx.file.extension.toLowerCase();
            const lang = $08414ea58bdc1292$var$getTextLanguage(ctx.file.name, ext, ctx.file.mimeType, (0, $3438a2478d5b847f$export$f0df02582fe498a4)(ctx.file));
            const isLrc = ext === "lrc" || [
                "application/lrc",
                "application/x-lrc",
                "text/lrc",
                "text/x-lrc"
            ].includes(ctx.file.mimeType);
            const defaultWrapped = lang === "none";
            const isMarkdown = lang === "markdown";
            const text = await $08414ea58bdc1292$var$readText(ctx.file.source).catch((error)=>void 0);
            if (text === void 0) {
                const fallback = $08414ea58bdc1292$var$createTextFallback(ctx.file.name, ctx.options.messages, ctx.file.url);
                ctx.viewport.classList.add("ofv-center");
                ctx.viewport.append(fallback);
                return {
                    destroy () {
                        ctx.viewport.classList.remove("ofv-center");
                        fallback.remove();
                    }
                };
            }
            if (lang === "mermaid") {
                const diagram = await $08414ea58bdc1292$var$renderMermaidFile(ctx, text);
                if (diagram) return diagram;
            }
            if (isMarkdown) {
                const [markedModule, PrismModule2, DOMPurifyModule] = await Promise.all([
                    Promise.resolve((parcelRequire("80eeU"))),
                    (parcelRequire("fZf7A")),
                    Promise.resolve((parcelRequire("hIrjg")))
                ]);
                const parseMarkdown = markedModule.marked?.parse || markedModule.parse || markedModule.default?.parse;
                const Prism2 = PrismModule2.default || PrismModule2;
                const DOMPurify3 = DOMPurifyModule.default || DOMPurifyModule;
                const container = document.createElement("div");
                container.className = "ofv-markdown-body";
                const markdownContent = document.createElement("div");
                markdownContent.className = "ofv-markdown-content";
                markdownContent.innerHTML = DOMPurify3.sanitize(parseMarkdown(text), {
                    USE_PROFILES: {
                        html: true
                    },
                    ADD_ATTR: [
                        "target"
                    ]
                });
                container.append(markdownContent);
                $08414ea58bdc1292$var$secureMarkdownLinks(container);
                $08414ea58bdc1292$var$assignMarkdownHeadingAnchors(markdownContent);
                const destroyMarkdownAnchorNavigation = $08414ea58bdc1292$var$enableMarkdownAnchorNavigation(container);
                ctx.viewport.appendChild(container);
                try {
                    await $08414ea58bdc1292$var$renderMermaidBlocks(container, DOMPurify3);
                } catch (e) {
                    console.warn("Mermaid render for markdown failed:", e);
                }
                try {
                    const codeBlocks = container.querySelectorAll("pre code");
                    if (codeBlocks.length > 0) {
                        const languages = /* @__PURE__ */ new Set();
                        codeBlocks.forEach((block)=>{
                            const language = $08414ea58bdc1292$var$getPrismLanguageFromElement(block) || $08414ea58bdc1292$var$getPrismLanguageFromElement(block.parentElement);
                            if (language) languages.add(language);
                        });
                        await Promise.all([
                            ...languages
                        ].map((language)=>$08414ea58bdc1292$var$loadPrismLanguage(language)));
                        codeBlocks.forEach((block)=>{
                            const parent = block.parentElement;
                            if (parent && !parent.className.includes("language-")) parent.className = "language-none";
                            Prism2.highlightElement(block);
                        });
                    }
                } catch (e) {
                    console.warn("Prism highlight for markdown failed:", e);
                }
                $08414ea58bdc1292$var$addMarkdownCodeControls(container, ctx.options.messages);
                const markdownZoom = $08414ea58bdc1292$var$createTextZoomController(container, "--ofv-markdown-zoom", ctx, markdownContent);
                return {
                    canCommand (command) {
                        return markdownZoom.canCommand(command);
                    },
                    command (command) {
                        return markdownZoom.command(command);
                    },
                    destroy () {
                        destroyMarkdownAnchorNavigation();
                        container.remove();
                    }
                };
            }
            const [PrismModule] = await Promise.all([
                (parcelRequire("fZf7A"))
            ]);
            const Prism = PrismModule.default || PrismModule;
            if (lang !== "none") try {
                await $08414ea58bdc1292$var$loadPrismLanguage(lang);
            } catch (e) {
                console.warn(`Prism failed to load language component for: ${lang}`, e);
            }
            const codeText = text.length > $08414ea58bdc1292$var$MAX_RENDER_CHARS ? text.slice(0, $08414ea58bdc1292$var$MAX_RENDER_CHARS) : text;
            const totalLines = $08414ea58bdc1292$var$countLines(text);
            const shownLines = $08414ea58bdc1292$var$countLines(codeText);
            const truncated = codeText.length < text.length;
            const shouldHighlight = codeText.length <= $08414ea58bdc1292$var$MAX_HIGHLIGHT_CHARS;
            const wrapper = document.createElement("div");
            wrapper.className = "ofv-code-container";
            if (isLrc) wrapper.classList.add("is-lrc");
            if (truncated) wrapper.classList.add("is-truncated");
            if (defaultWrapped) wrapper.classList.add("is-wrapped");
            const header = document.createElement("div");
            header.className = "ofv-code-header";
            const title = document.createElement("div");
            title.className = "ofv-code-title";
            const fileName = document.createElement("strong");
            fileName.textContent = ctx.file.name;
            const messages = ctx.options.messages;
            const meta = document.createElement("span");
            meta.textContent = [
                isLrc ? "LRC" : lang === "none" ? messages.textPlainLanguage : lang,
                (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.textLineCount, {
                    count: totalLines.toLocaleString()
                }),
                $08414ea58bdc1292$var$formatBytes(ctx.file.size ?? (ctx.file.source instanceof Blob ? ctx.file.source.size : text.length))
            ].join(" \xB7 ");
            title.append(fileName, meta);
            const actions = document.createElement("div");
            actions.className = "ofv-code-actions";
            const status = document.createElement("span");
            status.className = "ofv-code-status";
            status.setAttribute("role", "status");
            const wrapButton = document.createElement("button");
            wrapButton.type = "button";
            wrapButton.className = "ofv-code-action";
            wrapButton.textContent = messages.textWrap;
            wrapButton.setAttribute("aria-pressed", String(defaultWrapped));
            wrapButton.addEventListener("click", ()=>{
                const wrapped = wrapper.classList.toggle("is-wrapped");
                wrapButton.setAttribute("aria-pressed", String(wrapped));
            });
            const copyButton = document.createElement("button");
            copyButton.type = "button";
            copyButton.className = "ofv-code-action";
            copyButton.textContent = messages.textCopy;
            copyButton.addEventListener("click", async ()=>{
                copyButton.disabled = true;
                try {
                    await $08414ea58bdc1292$var$copyToClipboard(text);
                    status.textContent = messages.textCopied;
                } catch  {
                    status.textContent = messages.textCopyFailed;
                } finally{
                    copyButton.disabled = false;
                }
            });
            const downloadButton = document.createElement("button");
            downloadButton.type = "button";
            downloadButton.className = "ofv-code-action";
            downloadButton.textContent = messages.textDownload;
            downloadButton.addEventListener("click", ()=>{
                $08414ea58bdc1292$var$downloadText(ctx.file.name, text);
                status.textContent = messages.textDownloadReady;
            });
            actions.append(wrapButton, copyButton, downloadButton, status);
            header.append(title, actions);
            const structureSummary = $08414ea58bdc1292$var$createTextStructureSummary(text, ext, lang, ctx.file.mimeType);
            const body = document.createElement("div");
            body.className = "ofv-code-body";
            const gutter = document.createElement("pre");
            gutter.className = "ofv-code-gutter";
            gutter.setAttribute("aria-hidden", "true");
            gutter.textContent = $08414ea58bdc1292$var$createLineNumbers(shownLines);
            const pre = document.createElement("pre");
            pre.className = `language-${lang}`;
            const code = document.createElement("code");
            code.className = `language-${lang}`;
            code.textContent = codeText;
            pre.appendChild(code);
            body.append(gutter, pre);
            wrapper.append(header);
            if (isLrc) {
                const lrcViews = $08414ea58bdc1292$var$createLrcPreviewViews($08414ea58bdc1292$var$parseLrc(codeText), ctx.file.name, messages, body, wrapButton);
                wrapper.append(lrcViews.modeBar, lrcViews.annotatedView, lrcViews.displayView);
            }
            if (structureSummary) wrapper.append(structureSummary);
            if (truncated) {
                const notice = document.createElement("div");
                notice.className = "ofv-code-notice";
                notice.textContent = (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.textLargeFileNotice, {
                    size: $08414ea58bdc1292$var$formatBytes(codeText.length)
                });
                wrapper.append(notice);
            }
            if (!shouldHighlight) {
                const notice = document.createElement("div");
                notice.className = "ofv-code-notice";
                notice.textContent = messages.textHighlightSkipped;
                wrapper.append(notice);
            }
            wrapper.appendChild(body);
            ctx.viewport.appendChild(wrapper);
            if (shouldHighlight) try {
                Prism.highlightElement(code);
            } catch (err) {
                console.error("Prism syntax highlighting failed:", err);
            }
            const codeZoom = $08414ea58bdc1292$var$createTextZoomController(wrapper, "--ofv-text-zoom", ctx);
            return {
                canCommand (command) {
                    return codeZoom.canCommand(command);
                },
                command (command) {
                    return codeZoom.command(command);
                },
                destroy () {
                    wrapper.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$addMarkdownCodeControls(container, messages) {
    for (const code of container.querySelectorAll("pre > code")){
        const pre = code.parentElement;
        const source = code.textContent || "";
        const wrapper = document.createElement("div");
        wrapper.className = "ofv-markdown-code-block";
        pre.replaceWith(wrapper);
        pre.classList.add("ofv-markdown-code-pre");
        const gutter = document.createElement("span");
        gutter.className = "ofv-markdown-code-gutter";
        gutter.setAttribute("aria-hidden", "true");
        gutter.textContent = $08414ea58bdc1292$var$createLineNumbers($08414ea58bdc1292$var$countLines(source.replace(/(?:\r\n|\r|\n)$/, "")));
        pre.prepend(gutter);
        const toolbar = document.createElement("div");
        toolbar.className = "ofv-markdown-code-toolbar";
        const status = document.createElement("span");
        status.className = "ofv-markdown-code-status";
        status.setAttribute("role", "status");
        const copy = document.createElement("button");
        copy.type = "button";
        copy.className = "ofv-code-action ofv-markdown-code-copy";
        copy.textContent = messages.textCopy;
        copy.addEventListener("click", async ()=>{
            copy.disabled = true;
            status.textContent = "";
            try {
                await $08414ea58bdc1292$var$copyToClipboard(source);
                status.textContent = messages.textCopied;
            } catch  {
                status.textContent = messages.textCopyFailed;
            } finally{
                copy.disabled = false;
            }
        });
        toolbar.append(status, copy);
        wrapper.append(toolbar, pre);
    }
}
function $08414ea58bdc1292$var$getPrismLanguageFromElement(element) {
    if (!element) return void 0;
    for (const className of element.classList){
        if (className.startsWith("language-") && className.length > 9) return className.slice(9).toLowerCase();
    }
    return void 0;
}
var $08414ea58bdc1292$var$mermaidLoad;
var $08414ea58bdc1292$var$mermaidRenderSeq = 0;

function $08414ea58bdc1292$var$loadMermaid() {
    $08414ea58bdc1292$var$mermaidLoad ||= (parcelRequire("27am3")).then((module)=>{
        const mermaid = module.default || module;
        mermaid.initialize({
            startOnLoad: false,
            securityLevel: "strict",
            theme: "default",
            // Keep labels as plain SVG text: foreignObject html labels are stripped by DOMPurify.
            htmlLabels: false,
            flowchart: {
                htmlLabels: false
            },
            class: {
                htmlLabels: false
            }
        });
        return mermaid;
    }).catch((error)=>{
        $08414ea58bdc1292$var$mermaidLoad = void 0;
        throw error;
    });
    return $08414ea58bdc1292$var$mermaidLoad;
}
var $08414ea58bdc1292$var$MERMAID_MAX_TEXT_CHARS = 5e4;

async function $08414ea58bdc1292$var$renderMermaidFile(ctx, text) {
    if (text.length > $08414ea58bdc1292$var$MERMAID_MAX_TEXT_CHARS) return void 0;
    const renderId = `ofv-mermaid-${++$08414ea58bdc1292$var$mermaidRenderSeq}`;
    let svg;
    try {
        const [mermaid, DOMPurifyModule] = await Promise.all([
            $08414ea58bdc1292$var$loadMermaid(),
            Promise.resolve((parcelRequire("hIrjg")))
        ]);
        const DOMPurify3 = DOMPurifyModule.default || DOMPurifyModule;
        const rendered = await mermaid.render(renderId, text);
        svg = DOMPurify3.sanitize(rendered.svg, {
            USE_PROFILES: {
                svg: true,
                svgFilters: true
            }
        });
    } catch (error) {
        document.getElementById(renderId)?.remove();
        document.getElementById(`d${renderId}`)?.remove();
        console.warn("Mermaid file render failed, falling back to source view:", error);
        return void 0;
    }
    const container = document.createElement("div");
    container.className = "ofv-mermaid-file";
    const zoomLayer = document.createElement("div");
    zoomLayer.className = "ofv-mermaid-zoom-layer";
    const diagram = document.createElement("div");
    diagram.className = "ofv-mermaid";
    diagram.innerHTML = svg;
    zoomLayer.appendChild(diagram);
    container.appendChild(zoomLayer);
    ctx.viewport.appendChild(container);
    const zoom = $08414ea58bdc1292$var$createTextZoomController(container, "--ofv-mermaid-zoom", ctx, zoomLayer);
    return {
        canCommand (command) {
            return zoom.canCommand(command);
        },
        command (command) {
            return zoom.command(command);
        },
        destroy () {
            container.remove();
        }
    };
}
async function $08414ea58bdc1292$var$renderMermaidBlocks(container, DOMPurify3) {
    const blocks = Array.from(container.querySelectorAll("pre > code.language-mermaid")).filter((block)=>(block.textContent ?? "").length <= $08414ea58bdc1292$var$MERMAID_MAX_TEXT_CHARS);
    if (blocks.length === 0) return;
    const mermaid = await $08414ea58bdc1292$var$loadMermaid();
    for (const block of blocks){
        const pre = block.parentElement;
        if (!pre) continue;
        const renderId = `ofv-mermaid-${++$08414ea58bdc1292$var$mermaidRenderSeq}`;
        try {
            const { svg: svg } = await mermaid.render(renderId, block.textContent ?? "");
            const diagram = document.createElement("div");
            diagram.className = "ofv-mermaid";
            diagram.innerHTML = DOMPurify3.sanitize(svg, {
                USE_PROFILES: {
                    svg: true,
                    svgFilters: true
                }
            });
            pre.replaceWith(diagram);
        } catch (error) {
            document.getElementById(renderId)?.remove();
            document.getElementById(`d${renderId}`)?.remove();
            console.warn("Mermaid diagram render failed, keeping source block:", error);
        }
    }
}
async function $08414ea58bdc1292$var$loadPrismLanguage(language) {
    if ([
        "none",
        "plain",
        "plaintext",
        "text",
        "markup",
        "css",
        "clike",
        "javascript"
    ].includes(language)) return;
    const existing = $08414ea58bdc1292$var$prismLanguageLoads.get(language);
    if (existing) return existing;
    const loading = $08414ea58bdc1292$var$loadPrismLanguageComponent(language).catch((error)=>{
        $08414ea58bdc1292$var$prismLanguageLoads.delete(language);
        throw error;
    });
    $08414ea58bdc1292$var$prismLanguageLoads.set(language, loading);
    return loading;
}

















































async function $08414ea58bdc1292$var$loadPrismLanguageComponent(language) {
    switch(language){
        case "typescript":
            await (parcelRequire("fSdtI"));
            break;
        case "jsx":
            await (parcelRequire("1aVIr"));
            break;
        case "tsx":
            await (parcelRequire("eoxIj"));
            break;
        case "python":
            await (parcelRequire("kPG1T"));
            break;
        case "json":
            await (parcelRequire("ggJbU"));
            break;
        case "json5":
            await (parcelRequire("lUBjZ"));
            break;
        case "yaml":
            await (parcelRequire("7GJ9R"));
            break;
        case "toml":
            await (parcelRequire("9rfGV"));
            break;
        case "ini":
            await (parcelRequire("gU4Jz"));
            break;
        case "properties":
            await (parcelRequire("dJFlq"));
            break;
        case "editorconfig":
            await (parcelRequire("faMUO"));
            break;
        case "ignore":
            await (parcelRequire("k5KdR"));
            break;
        case "protobuf":
            await (parcelRequire("gGh8i"));
            break;
        case "hcl":
            await (parcelRequire("86sS8"));
            break;
        case "latex":
            await (parcelRequire("4pxUv"));
            break;
        case "dot":
            await (parcelRequire("a3NRb"));
            break;
        case "http":
            await (parcelRequire("gX9Gg"));
            break;
        case "bash":
            await (parcelRequire("gGH96"));
            break;
        case "powershell":
            await (parcelRequire("gSh04"));
            break;
        case "batch":
            await (parcelRequire("2GI8M"));
            break;
        case "docker":
            await (parcelRequire("1HfaU"));
            break;
        case "makefile":
            await (parcelRequire("5wufp"));
            break;
        case "ruby":
            await (parcelRequire("3f3Fs"));
            break;
        case "nginx":
            await (parcelRequire("29sXE"));
            break;
        case "groovy":
            await (parcelRequire("3V2WW"));
            break;
        case "graphql":
            await (parcelRequire("1kJOq"));
            break;
        case "csharp":
            await (parcelRequire("1drU8"));
            break;
        case "rust":
            await (parcelRequire("i1SYL"));
            break;
        case "go":
            await (parcelRequire("cNjDK"));
            break;
        case "swift":
            await (parcelRequire("fqdNs"));
            break;
        case "kotlin":
            await (parcelRequire("kJT6J"));
            break;
        case "java":
            await (parcelRequire("10vJ2"));
            break;
        case "scala":
            await (parcelRequire("iSFNP"));
            break;
        case "lua":
            await (parcelRequire("3kaXr"));
            break;
        case "r":
            await (parcelRequire("lKRac"));
            break;
        case "dart":
            await (parcelRequire("ahzN6"));
            break;
        case "elm":
            await (parcelRequire("hjqbQ"));
            break;
        case "elixir":
            await (parcelRequire("b6Ce0"));
            break;
        case "clojure":
            await (parcelRequire("27l2R"));
            break;
        case "erlang":
            await (parcelRequire("6hkJi"));
            break;
        case "fsharp":
            await (parcelRequire("dvGEE"));
            break;
        case "haskell":
            await (parcelRequire("8BmCl"));
            break;
        case "sql":
            await (parcelRequire("clodf"));
            break;
        case "c":
            await (parcelRequire("gCdMZ"));
            break;
        case "cpp":
            await (parcelRequire("lFLGV"));
            break;
        case "scss":
            await (parcelRequire("7UMUW"));
            break;
        case "less":
            await (parcelRequire("42ptu"));
            break;
        case "markup-templating":
            await (parcelRequire("cVHBX"));
            break;
        case "php":
            await (parcelRequire("9shZB"));
            break;
    }
}
function $08414ea58bdc1292$var$createTextZoomController(target, cssVariable, ctx, pinnedLayer) {
    let zoom = (0, $3438a2478d5b847f$export$218693075858efcb)(ctx, 0.5, 3);
    const apply = ()=>{
        const normalized = Math.round(zoom * 100) / 100;
        if (pinnedLayer) {
            pinnedLayer.style.width = "";
            target.style.setProperty(cssVariable, "1");
            if (normalized !== 1) {
                const base = pinnedLayer.clientWidth;
                if (base > 0) pinnedLayer.style.width = `${base}px`;
            }
        }
        target.style.setProperty(cssVariable, String(normalized));
        ctx.toolbar?.setZoom(normalized === 1 ? void 0 : normalized);
    };
    apply();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom = Math.min(3, zoom * 1.15);
                apply();
                return true;
            }
            if (command === "zoom-out") {
                zoom = Math.max(0.5, zoom / 1.15);
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                zoom = 1;
                apply();
                return true;
            }
            return false;
        }
    };
}
function $08414ea58bdc1292$var$getTextLanguage(fileName, extension, mimeType, preferMimeType) {
    const normalizedFileName = $08414ea58bdc1292$var$normalizeFileName(fileName);
    const normalizedMimeType = mimeType.split(";", 1)[0]?.trim().toLowerCase() || "";
    const mimeLanguage = $08414ea58bdc1292$var$mimeLangMap[normalizedMimeType];
    return (preferMimeType ? mimeLanguage : void 0) || $08414ea58bdc1292$var$langMap[extension] || $08414ea58bdc1292$var$filenameLangMap[normalizedFileName] || $08414ea58bdc1292$var$filenameLangMap[normalizedFileName.split(".")[0]] || mimeLanguage || "none";
}
function $08414ea58bdc1292$var$normalizeFileName(name) {
    const baseName = name.split(/[\\/]/).pop() || name;
    return baseName.toLowerCase();
}
function $08414ea58bdc1292$var$createTextFallback(fileName, messages, url) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = messages.textPreviewFailedTitle;
    const meta = document.createElement("span");
    meta.textContent = messages.textPreviewFailedMessage;
    fallback.append(title, meta);
    if (url) {
        const download = document.createElement("a");
        download.href = url;
        download.download = fileName;
        download.textContent = messages.textOpenOriginal;
        fallback.append(download);
    }
    return fallback;
}
function $08414ea58bdc1292$var$secureMarkdownLinks(container) {
    for (const link of container.querySelectorAll("a[href]")){
        const href = link.getAttribute("href") || "";
        if (!$08414ea58bdc1292$var$isSafeMarkdownHref(href)) {
            link.removeAttribute("href");
            link.removeAttribute("target");
            link.removeAttribute("rel");
            continue;
        }
        if (/^(https?:)?\/\//i.test(href)) {
            link.target = "_blank";
            link.rel = "noopener noreferrer";
        }
    }
}
function $08414ea58bdc1292$var$assignMarkdownHeadingAnchors(container) {
    const usedIds = new Set(Array.from(container.querySelectorAll("[id]")).map((element)=>element.id).filter(Boolean));
    let fallbackIndex = 0;
    for (const heading of container.querySelectorAll("h1, h2, h3, h4, h5, h6")){
        if (heading.id) continue;
        const baseId = $08414ea58bdc1292$var$createMarkdownAnchorId(heading.textContent || "") || `heading-${++fallbackIndex}`;
        heading.id = $08414ea58bdc1292$var$uniquifyMarkdownAnchorId(baseId, usedIds);
    }
}
function $08414ea58bdc1292$var$enableMarkdownAnchorNavigation(container) {
    const onClick = (event)=>{
        const link = event.target?.closest?.("a[href]");
        if (!link || !container.contains(link)) return;
        const href = link.getAttribute("href") || "";
        if (!href.startsWith("#") || href === "#") return;
        const target = $08414ea58bdc1292$var$findMarkdownAnchorTarget(container, href.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView?.({
            block: "start",
            inline: "nearest"
        });
        if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
        target.focus?.({
            preventScroll: true
        });
    };
    container.addEventListener("click", onClick);
    return ()=>container.removeEventListener("click", onClick);
}
function $08414ea58bdc1292$var$findMarkdownAnchorTarget(container, rawAnchor) {
    const anchor = $08414ea58bdc1292$var$decodeMarkdownAnchor(rawAnchor);
    const byId = container.querySelector(`#${$08414ea58bdc1292$var$escapeCssIdentifier(anchor)}`);
    if (byId) return byId;
    const normalizedAnchor = $08414ea58bdc1292$var$createMarkdownAnchorId(anchor);
    return Array.from(container.querySelectorAll("h1, h2, h3, h4, h5, h6")).find((heading)=>{
        const text = heading.textContent || "";
        return text === anchor || $08414ea58bdc1292$var$createMarkdownAnchorId(text) === normalizedAnchor;
    }) || null;
}
function $08414ea58bdc1292$var$createMarkdownAnchorId(text) {
    return text.trim().toLowerCase().replace(/<[^>]*>/g, "").replace(/[`~!@#$%^&*()+=[\]{}\\|;:'",.<>/?，。！？、；：“”‘’（）【】《》]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}
function $08414ea58bdc1292$var$uniquifyMarkdownAnchorId(baseId, usedIds) {
    let id = baseId;
    let index = 1;
    while(usedIds.has(id))id = `${baseId}-${index++}`;
    usedIds.add(id);
    return id;
}
function $08414ea58bdc1292$var$decodeMarkdownAnchor(anchor) {
    try {
        return decodeURIComponent(anchor);
    } catch  {
        return anchor;
    }
}
function $08414ea58bdc1292$var$escapeCssIdentifier(value) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") return CSS.escape(value);
    return value.replace(/["\\#.;,[\]()>/+~*^$|=!:\s]/g, "\\$&");
}
function $08414ea58bdc1292$var$isSafeMarkdownHref(href) {
    const trimmed = href.trim();
    return trimmed.startsWith("#") || trimmed.startsWith("/") || trimmed.startsWith("./") || trimmed.startsWith("../") || /^(https?:|mailto:|tel:)/i.test(trimmed);
}
function $08414ea58bdc1292$var$countLines(text) {
    if (!text) return 1;
    return text.split(/\r\n|\r|\n/).length;
}
function $08414ea58bdc1292$var$createTextStructureSummary(text, extension, language, mimeType) {
    if (text.length > $08414ea58bdc1292$var$MAX_RENDER_CHARS) return null;
    const items = $08414ea58bdc1292$var$summarizeTextStructure(text, extension, language, mimeType);
    if (items.length === 0) return null;
    const summary = document.createElement("div");
    summary.className = "ofv-text-structure";
    summary.hidden = true;
    summary.setAttribute("aria-hidden", "true");
    summary.style.display = "none";
    for (const item of items){
        const row = document.createElement("span");
        const label = document.createElement("span");
        label.textContent = item.label;
        const value = document.createElement("strong");
        value.textContent = item.value;
        row.append(label, value);
        summary.append(row);
    }
    return summary;
}
function $08414ea58bdc1292$var$summarizeTextStructure(text, extension, language, mimeType) {
    if (extension === "ipynb" || mimeType === "application/x-ipynb+json") return $08414ea58bdc1292$var$summarizeNotebook(text);
    if (extension === "ndjson" || extension === "jsonl" || mimeType === "application/x-ndjson") return $08414ea58bdc1292$var$summarizeNdjson(text);
    if (language === "json" || language === "json5") return $08414ea58bdc1292$var$summarizeJson(text);
    return [];
}
function $08414ea58bdc1292$var$summarizeJson(text) {
    try {
        const data = JSON.parse(text);
        if (Array.isArray(data)) return [
            {
                label: "\u7ED3\u6784",
                value: "Array"
            },
            {
                label: "\u6761\u76EE",
                value: String(data.length)
            }
        ];
        if (data && typeof data === "object") {
            const keys = Object.keys(data);
            return [
                {
                    label: "\u7ED3\u6784",
                    value: "Object"
                },
                {
                    label: "\u952E",
                    value: String(keys.length)
                },
                {
                    label: "\u9884\u89C8",
                    value: keys.slice(0, 8).join(", ") || "\u65E0\u952E"
                }
            ];
        }
        return [
            {
                label: "\u7ED3\u6784",
                value: typeof data
            }
        ];
    } catch  {
        return [];
    }
}
function $08414ea58bdc1292$var$summarizeNotebook(text) {
    try {
        const notebook = JSON.parse(text);
        if (!Array.isArray(notebook.cells)) return $08414ea58bdc1292$var$summarizeJson(text);
        const counts = /* @__PURE__ */ new Map();
        for (const cell of notebook.cells){
            const type = cell.cell_type || "unknown";
            counts.set(type, (counts.get(type) || 0) + 1);
        }
        const kernel = notebook.metadata?.kernelspec?.display_name || notebook.metadata?.kernelspec?.name || notebook.metadata?.language_info?.name;
        return [
            {
                label: "Notebook",
                value: `${notebook.cells.length} cells`
            },
            {
                label: "\u7C7B\u578B",
                value: [
                    ...counts.entries()
                ].map(([type, count])=>`${type} ${count}`).join(", ") || "\u672A\u77E5"
            },
            ...kernel ? [
                {
                    label: "Kernel",
                    value: kernel
                }
            ] : []
        ];
    } catch  {
        return [];
    }
}
function $08414ea58bdc1292$var$summarizeNdjson(text) {
    const lines = text.split(/\r\n|\r|\n/).filter((line)=>line.trim());
    let parsed = 0;
    let objects = 0;
    let arrays = 0;
    for (const line of lines.slice(0, 1e3))try {
        const value = JSON.parse(line);
        parsed++;
        if (Array.isArray(value)) arrays++;
        else if (value && typeof value === "object") objects++;
    } catch  {}
    return [
        {
            label: "NDJSON",
            value: `${lines.length} lines`
        },
        {
            label: "\u53EF\u89E3\u6790",
            value: String(parsed)
        },
        {
            label: "\u7C7B\u578B",
            value: `object ${objects}, array ${arrays}`
        }
    ];
}
function $08414ea58bdc1292$var$createLineNumbers(lines) {
    return Array.from({
        length: Math.max(lines, 1)
    }, (_, index)=>String(index + 1)).join("\n");
}
function $08414ea58bdc1292$var$formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes < 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    const units = [
        "KB",
        "MB",
        "GB"
    ];
    let value = bytes / 1024;
    let unitIndex = 0;
    while(value >= 1024 && unitIndex < units.length - 1){
        value /= 1024;
        unitIndex += 1;
    }
    return `${value.toFixed(value >= 10 ? 1 : 2)} ${units[unitIndex]}`;
}
async function $08414ea58bdc1292$var$copyToClipboard(text) {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.append(textarea);
    textarea.select();
    const copied = document.execCommand?.("copy");
    textarea.remove();
    if (!copied) throw new Error("Clipboard API is not available.");
}
function $08414ea58bdc1292$var$downloadText(fileName, text) {
    const blob = new Blob([
        text
    ], {
        type: "text/plain;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
async function $08414ea58bdc1292$var$readText(source) {
    if (typeof source === "string") {
        const response = await fetch(source);
        if (!response.ok) throw new Error(`Failed to fetch text file: ${response.status}`);
        return (0, $3438a2478d5b847f$export$62387d23696f2b23)(await response.arrayBuffer());
    }
    if (source instanceof Blob) return (0, $3438a2478d5b847f$export$62387d23696f2b23)(await source.arrayBuffer());
    if (source instanceof ArrayBuffer) return (0, $3438a2478d5b847f$export$62387d23696f2b23)(source);
    return String(source);
}
var $08414ea58bdc1292$var$epubMimeTypes = /* @__PURE__ */ new Set([
    "application/epub+zip",
    "application/x-epub+zip"
]);
function $08414ea58bdc1292$export$573366df5dc69a78() {
    return {
        name: "epub",
        match (file) {
            return file.extension === "epub" || $08414ea58bdc1292$var$epubMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-epub");
            ctx.viewport.append(panel);
            try {
                const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                await $08414ea58bdc1292$var$renderEpub(panel, zip);
            } catch (error) {
                $08414ea58bdc1292$var$renderEpubFallback(panel, error);
            }
            const controller = $08414ea58bdc1292$var$createEpubReaderController(panel, ctx);
            return {
                canCommand (command) {
                    return controller?.canCommand(command) ?? false;
                },
                command (command) {
                    return controller?.command(command) ?? false;
                },
                destroy () {
                    controller?.destroy();
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$createEpubReaderController(panel, ctx) {
    const reader = panel.querySelector(".ofv-epub-reader");
    if (!reader) return void 0;
    const layer = reader.querySelector(".ofv-epub-zoom-layer");
    let zoom = 1;
    const apply = ()=>{
        if (layer) {
            layer.style.width = "";
            reader.style.setProperty("--ofv-epub-zoom", "1");
            if (zoom !== 1) {
                const base = layer.clientWidth;
                if (base > 0) layer.style.width = `${base}px`;
            }
        }
        reader.style.setProperty("--ofv-epub-zoom", String(zoom));
        ctx.toolbar?.setZoom(zoom);
    };
    apply();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom = Math.min(2.5, Number((zoom + 0.12).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-out") {
                zoom = Math.max(0.6, Number((zoom - 0.12).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                zoom = 1;
                apply();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
async function $08414ea58bdc1292$var$renderEpub(panel, zip) {
    const opfPath = await $08414ea58bdc1292$var$resolvePackagePath(zip);
    const opfText = await zip.file(opfPath)?.async("text");
    if (!opfText) throw new Error("EPUB \u7F3A\u5C11 OPF package \u6587\u4EF6\u3002");
    const opf = $08414ea58bdc1292$var$parseXml(opfText, "EPUB package \u6587\u4EF6\u89E3\u6790\u5931\u8D25\u3002");
    const basePath = $08414ea58bdc1292$var$directoryName(opfPath);
    const manifest = $08414ea58bdc1292$var$readManifest(opf);
    const spine = $08414ea58bdc1292$var$readSpine(opf, manifest);
    const metadata = $08414ea58bdc1292$var$readMetadata(opf);
    const structure = $08414ea58bdc1292$var$summarizeEpubStructure(opf, manifest, spine);
    const assets = await $08414ea58bdc1292$var$readEpubAssets(zip, basePath, manifest);
    const summary = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("EPUB \u56FE\u4E66\u4FE1\u606F");
    summary.hidden = spine.length > 0;
    if (spine.length > 0) {
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
    }
    const meta = document.createElement("div");
    meta.className = "ofv-epub-meta";
    meta.hidden = spine.length > 0;
    if (spine.length > 0) {
        meta.setAttribute("aria-hidden", "true");
        meta.style.display = "none";
    }
    $08414ea58bdc1292$var$appendMeta2(meta, "\u6807\u9898", metadata.title || "\u672A\u547D\u540D EPUB");
    $08414ea58bdc1292$var$appendMeta2(meta, "\u4F5C\u8005", metadata.creator || "\u672A\u77E5");
    $08414ea58bdc1292$var$appendMeta2(meta, "\u8BED\u8A00", metadata.language || "\u672A\u58F0\u660E");
    if (metadata.publisher) $08414ea58bdc1292$var$appendMeta2(meta, "\u51FA\u7248\u65B9", metadata.publisher);
    if (metadata.identifier) $08414ea58bdc1292$var$appendMeta2(meta, "\u6807\u8BC6", metadata.identifier);
    if (metadata.modified) $08414ea58bdc1292$var$appendMeta2(meta, "\u4FEE\u6539\u65F6\u95F4", metadata.modified);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u7AE0\u8282", spine.length || "\u672A\u89E3\u6790\u5230\u9605\u8BFB\u987A\u5E8F");
    $08414ea58bdc1292$var$appendMeta2(meta, "Manifest", structure.manifestItems);
    $08414ea58bdc1292$var$appendMeta2(meta, "Spine", structure.spineItems);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u5BFC\u822A", structure.navItems + structure.tocItems);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u5C01\u9762", structure.coverItems);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u56FE\u7247", structure.images);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u6837\u5F0F", structure.styles);
    $08414ea58bdc1292$var$appendMeta2(meta, "\u5B57\u4F53", structure.fonts);
    if (structure.audio || structure.video) $08414ea58bdc1292$var$appendMeta2(meta, "\u97F3\u89C6\u9891", `${structure.audio} / ${structure.video}`);
    if (structure.otherItems) $08414ea58bdc1292$var$appendMeta2(meta, "\u5176\u4ED6\u8D44\u6E90", structure.otherItems);
    if (structure.missingSpineItems) $08414ea58bdc1292$var$appendMeta2(meta, "\u7F3A\u5931\u7AE0\u8282\u5F15\u7528", structure.missingSpineItems);
    summary.append(meta);
    panel.append(summary);
    const chapters = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("EPUB \u6B63\u6587\u9884\u89C8");
    if (spine.length > 0) $08414ea58bdc1292$var$hideSupplementalInfo(chapters.querySelector("h3"));
    const article = document.createElement("article");
    article.className = "ofv-epub-reader";
    const zoomLayer = document.createElement("div");
    zoomLayer.className = "ofv-epub-zoom-layer";
    article.append(zoomLayer);
    if (spine.length === 0) {
        const empty = document.createElement("p");
        empty.textContent = "\u672A\u89E3\u6790\u5230\u53EF\u5C55\u793A\u7AE0\u8282\u3002";
        zoomLayer.append(empty);
    } else for (const [index, item] of spine.slice(0, 40).entries()){
        const chapterPath = $08414ea58bdc1292$var$joinZipPath(basePath, item.href);
        const chapterText = await zip.file(chapterPath)?.async("text");
        if (!chapterText) continue;
        const section = document.createElement("section");
        section.className = "ofv-epub-chapter";
        const heading = document.createElement("h3");
        heading.textContent = $08414ea58bdc1292$var$chapterTitle(chapterText) || `\u7AE0\u8282 ${index + 1}`;
        const content = document.createElement("div");
        content.className = "ofv-epub-content";
        content.innerHTML = $08414ea58bdc1292$var$sanitizeChapterHtml($08414ea58bdc1292$var$rewriteAssetReferences(chapterText, assets, $08414ea58bdc1292$var$directoryName(chapterPath)));
        section.append(heading, content);
        zoomLayer.append(section);
    }
    chapters.append(article);
    panel.append(chapters);
}
async function $08414ea58bdc1292$var$resolvePackagePath(zip) {
    const containerXml = await zip.file("META-INF/container.xml")?.async("text");
    if (containerXml) {
        const container = $08414ea58bdc1292$var$parseXml(containerXml, "EPUB container.xml \u89E3\u6790\u5931\u8D25\u3002");
        const rootfile = Array.from(container.getElementsByTagName("*")).find((element)=>element.localName === "rootfile" && $08414ea58bdc1292$var$getXmlAttribute(element, "full-path"));
        const fullPath = rootfile ? $08414ea58bdc1292$var$getXmlAttribute(rootfile, "full-path") : null;
        if (fullPath && zip.file(fullPath)) return fullPath;
    }
    const fallback = Object.values(zip.files).find((entry)=>!entry.dir && entry.name.endsWith(".opf"));
    if (!fallback) throw new Error("EPUB \u672A\u627E\u5230 package OPF \u6587\u4EF6\u3002");
    return fallback.name;
}
function $08414ea58bdc1292$var$readManifest(opf) {
    const manifest = /* @__PURE__ */ new Map();
    for (const item of Array.from(opf.getElementsByTagName("*")).filter((element)=>element.localName === "item")){
        const id = $08414ea58bdc1292$var$getXmlAttribute(item, "id");
        const href = $08414ea58bdc1292$var$getXmlAttribute(item, "href");
        if (!id || !href) continue;
        manifest.set(id, {
            id: id,
            href: href,
            mediaType: $08414ea58bdc1292$var$getXmlAttribute(item, "media-type") || "",
            properties: $08414ea58bdc1292$var$getXmlAttribute(item, "properties") || ""
        });
    }
    return manifest;
}
function $08414ea58bdc1292$var$readSpine(opf, manifest) {
    const items = [];
    for (const itemref of Array.from(opf.getElementsByTagName("*")).filter((element)=>element.localName === "itemref")){
        const idref = $08414ea58bdc1292$var$getXmlAttribute(itemref, "idref");
        const item = idref ? manifest.get(idref) : void 0;
        if (item && $08414ea58bdc1292$var$isChapterMediaType(item.mediaType)) items.push(item);
    }
    if (items.length > 0) return items;
    return Array.from(manifest.values()).filter((item)=>$08414ea58bdc1292$var$isChapterMediaType(item.mediaType));
}
function $08414ea58bdc1292$var$readMetadata(opf) {
    return {
        title: $08414ea58bdc1292$var$textByLocalName(opf, "title"),
        creator: $08414ea58bdc1292$var$textByLocalName(opf, "creator"),
        language: $08414ea58bdc1292$var$textByLocalName(opf, "language"),
        identifier: $08414ea58bdc1292$var$textByLocalName(opf, "identifier"),
        publisher: $08414ea58bdc1292$var$textByLocalName(opf, "publisher"),
        modified: $08414ea58bdc1292$var$metaPropertyText(opf, "dcterms:modified")
    };
}
function $08414ea58bdc1292$var$summarizeEpubStructure(opf, manifest, spine) {
    const items = Array.from(manifest.values());
    const chapters = spine.length;
    const images = items.filter((item)=>item.mediaType.startsWith("image/")).length;
    const styles = items.filter((item)=>item.mediaType === "text/css").length;
    const fonts = items.filter((item)=>item.mediaType.startsWith("font/") || /font|opentype|truetype/i.test(item.mediaType)).length;
    const audio = items.filter((item)=>item.mediaType.startsWith("audio/")).length;
    const video = items.filter((item)=>item.mediaType.startsWith("video/")).length;
    const navItems = items.filter((item)=>$08414ea58bdc1292$var$propertyTokens(item.properties).has("nav")).length;
    const tocItems = items.filter((item)=>item.mediaType === "application/x-dtbncx+xml" || $08414ea58bdc1292$var$propertyTokens(item.properties).has("toc")).length;
    const coverItems = items.filter((item)=>item.id.toLowerCase().includes("cover") || $08414ea58bdc1292$var$propertyTokens(item.properties).has("cover-image")).length;
    const otherItems = items.filter((item)=>!$08414ea58bdc1292$var$isKnownEpubResource(item)).length;
    return {
        manifestItems: items.length,
        spineItems: spine.length,
        chapters: chapters,
        images: images,
        styles: styles,
        fonts: fonts,
        audio: audio,
        video: video,
        navItems: navItems,
        tocItems: tocItems,
        coverItems: coverItems,
        otherItems: otherItems,
        missingSpineItems: Math.max(0, $08414ea58bdc1292$var$readSpineRefCount(opf) - spine.length)
    };
}
function $08414ea58bdc1292$var$isKnownEpubResource(item) {
    const properties = $08414ea58bdc1292$var$propertyTokens(item.properties);
    return $08414ea58bdc1292$var$isChapterMediaType(item.mediaType) || item.mediaType.startsWith("image/") || item.mediaType === "text/css" || item.mediaType.startsWith("font/") || /font|opentype|truetype/i.test(item.mediaType) || item.mediaType.startsWith("audio/") || item.mediaType.startsWith("video/") || item.mediaType === "application/x-dtbncx+xml" || properties.has("nav") || properties.has("toc");
}
async function $08414ea58bdc1292$var$readEpubAssets(zip, basePath, manifest) {
    const assets = /* @__PURE__ */ new Map();
    for (const item of manifest.values()){
        if (!item.mediaType.startsWith("image/")) continue;
        const path = $08414ea58bdc1292$var$joinZipPath(basePath, item.href);
        const entry = zip.file(path);
        if (!entry) continue;
        assets.set(path, `data:${item.mediaType};base64,${await entry.async("base64")}`);
    }
    return assets;
}
function $08414ea58bdc1292$var$rewriteAssetReferences(html, assets, chapterDir) {
    const documentHtml = new DOMParser().parseFromString(html, "text/html");
    for (const image of Array.from(documentHtml.querySelectorAll("img[src], image[href], image[xlink\\:href]"))){
        const raw = image.getAttribute("src") || image.getAttribute("href") || image.getAttribute("xlink:href") || "";
        const path = $08414ea58bdc1292$var$joinZipPath(chapterDir, raw.split("#")[0] || raw);
        const src = assets.get(path);
        if (!src) continue;
        image.setAttribute("src", src);
        image.setAttribute("href", src);
        image.setAttribute("xlink:href", src);
    }
    return documentHtml.body.innerHTML;
}
function $08414ea58bdc1292$var$sanitizeChapterHtml(html) {
    return (0, $hIrjg.default).sanitize(html, {
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: false
        },
        ADD_ATTR: [
            "target",
            "xlink:href"
        ]
    });
}
function $08414ea58bdc1292$var$chapterTitle(html) {
    const documentHtml = new DOMParser().parseFromString(html, "text/html");
    const heading = documentHtml.querySelector("h1, h2, h3, title");
    return heading?.textContent?.trim() || "";
}
function $08414ea58bdc1292$var$renderEpubFallback(panel, error) {
    panel.replaceChildren();
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = "EPUB \u89E3\u6790\u5931\u8D25";
    const meta = document.createElement("span");
    meta.textContent = error instanceof Error ? error.message : "\u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\uFF0C\u6216\u4E0D\u662F\u6709\u6548\u7684 EPUB\u3002";
    fallback.append(title, meta);
    panel.append(fallback);
}
function $08414ea58bdc1292$var$parseXml(xml, message) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) throw new Error(message);
    return doc;
}
function $08414ea58bdc1292$var$appendMeta2(parent, label, value) {
    const row = document.createElement("div");
    row.className = "ofv-meta-row";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = String(value);
    row.append(key, content);
    parent.append(row);
}
function $08414ea58bdc1292$var$textByLocalName(doc, localName) {
    return Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === localName)?.textContent?.trim() || "";
}
function $08414ea58bdc1292$var$metaPropertyText(doc, property) {
    return Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "meta" && $08414ea58bdc1292$var$getXmlAttribute(element, "property") === property)?.textContent?.trim() || "";
}
function $08414ea58bdc1292$var$propertyTokens(value) {
    return new Set(value.split(/\s+/).map((item)=>item.trim()).filter(Boolean));
}
function $08414ea58bdc1292$var$readSpineRefCount(opf) {
    return Array.from(opf.getElementsByTagName("*")).filter((element)=>element.localName === "itemref").length;
}
function $08414ea58bdc1292$var$getXmlAttribute(element, localName) {
    const direct = element.getAttribute(localName);
    if (direct !== null) return direct;
    for (const attribute of Array.from(element.attributes)){
        if (attribute.localName === localName) return attribute.value;
    }
    return null;
}
function $08414ea58bdc1292$var$hideSupplementalInfo(element) {
    if (!element) return;
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$isChapterMediaType(mediaType) {
    return mediaType === "application/xhtml+xml" || mediaType === "text/html" || mediaType === "application/xml";
}
function $08414ea58bdc1292$var$directoryName(path) {
    const index = path.lastIndexOf("/");
    return index >= 0 ? path.slice(0, index + 1) : "";
}
function $08414ea58bdc1292$var$joinZipPath(basePath, path) {
    const parts = `${basePath}${path}`.split("/");
    const normalized = [];
    for (const part of parts){
        if (!part || part === ".") continue;
        if (part === "..") normalized.pop();
        else normalized.push(part);
    }
    return normalized.join("/");
}
var $08414ea58bdc1292$var$xpsMimeTypes = /* @__PURE__ */ new Set([
    "application/oxps",
    "application/vnd.ms-xpsdocument"
]);
function $08414ea58bdc1292$export$955f663930c75179() {
    return {
        name: "xps",
        match (file) {
            return file.extension === "xps" || file.extension === "oxps" || $08414ea58bdc1292$var$xpsMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-xps");
            ctx.viewport.append(panel);
            try {
                const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                await $08414ea58bdc1292$var$renderXps(panel, zip);
            } catch (error) {
                $08414ea58bdc1292$var$renderXpsFallback(panel, error);
            }
            const controller = $08414ea58bdc1292$var$createXpsCanvasController(panel, ctx);
            const pages = panel.querySelector(".ofv-xps-pages") || panel;
            return {
                goToPage (page) {
                    return (0, $3438a2478d5b847f$export$e2c778f3bf6f56a7)(pages, ".ofv-xps-page", page, pages);
                },
                canCommand (command) {
                    return controller?.canCommand(command) ?? false;
                },
                command (command) {
                    return controller?.command(command) ?? false;
                },
                destroy () {
                    controller?.destroy();
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$createXpsCanvasController(panel, ctx) {
    const canvases = Array.from(panel.querySelectorAll(".ofv-xps-canvas")).map((svg)=>({
            svg: svg,
            initialViewBox: $08414ea58bdc1292$var$parseSvgViewBox(svg),
            baseWidth: void 0
        })).filter((item)=>Boolean(item.initialViewBox));
    if (canvases.length === 0) return void 0;
    let zoom = 1;
    let rotation = 0;
    const apply = ()=>{
        for (const entry of canvases){
            const { svg: svg, initialViewBox: initialViewBox } = entry;
            svg.setAttribute("viewBox", `${initialViewBox.x} ${initialViewBox.y} ${initialViewBox.width} ${initialViewBox.height}`);
            if (zoom === 1) {
                svg.style.removeProperty("width");
                svg.style.removeProperty("max-width");
                svg.style.removeProperty("max-height");
                entry.baseWidth = void 0;
            } else {
                if (entry.baseWidth === void 0) {
                    svg.style.removeProperty("width");
                    svg.style.removeProperty("max-width");
                    svg.style.removeProperty("max-height");
                    entry.baseWidth = svg.getBoundingClientRect().width || initialViewBox.width;
                }
                svg.style.width = `${entry.baseWidth * zoom}px`;
                svg.style.maxWidth = "none";
                svg.style.maxHeight = "none";
            }
            svg.style.transformOrigin = "center center";
            svg.style.transform = rotation === 0 ? "" : `rotate(${rotation}deg)`;
        }
        for (const page of panel.querySelectorAll(".ofv-xps-page")){
            page.style.width = zoom === 1 ? "" : "max-content";
            page.style.maxWidth = zoom === 1 ? "" : "none";
        }
        ctx.toolbar?.setZoom(zoom);
    };
    apply();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom = Math.min(8, zoom * 1.18);
                apply();
                return true;
            }
            if (command === "zoom-out") {
                zoom = Math.max(0.25, zoom / 1.18);
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                zoom = 1;
                rotation = 0;
                apply();
                return true;
            }
            if (command === "rotate-right" || command === "rotate-left") {
                rotation += command === "rotate-right" ? 90 : -90;
                apply();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$parseSvgViewBox(svg) {
    const parts = svg.getAttribute("viewBox")?.trim().split(/[\s,]+/).map(Number);
    if (!parts || parts.length !== 4 || parts.some((part)=>!Number.isFinite(part)) || parts[2] <= 0 || parts[3] <= 0) return void 0;
    return {
        x: parts[0],
        y: parts[1],
        width: parts[2],
        height: parts[3]
    };
}
async function $08414ea58bdc1292$var$renderXps(panel, zip) {
    const entries = Object.values(zip.files).filter((entry)=>!entry.dir);
    const fixedPages = entries.filter((entry)=>/(?:^|\/)Pages\/[^/]+\.fpage$/i.test(entry.name) || entry.name.endsWith(".fpage")).sort((a, b)=>a.name.localeCompare(b.name, void 0, {
            numeric: true
        }));
    const resourceEntries = entries.filter((entry)=>/\.(?:png|jpe?g|tiff?|wdp|bmp|gif|odttf|ttf)$/i.test(entry.name));
    const pagePreviews = await Promise.all(fixedPages.slice(0, 80).map(async (entry, index)=>{
        const xml = await entry.async("text");
        return {
            entry: entry,
            index: index,
            xml: xml,
            info: $08414ea58bdc1292$var$parseXpsPageInfo(xml)
        };
    }));
    const summary = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("XPS \u7248\u5F0F\u9884\u89C8");
    summary.hidden = fixedPages.length > 0;
    if (fixedPages.length > 0) {
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
    }
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u4F1A\u5728\u524D\u7AEF\u89E3\u6790 XPS/OXPS \u5305\u5185 FixedPage \u6587\u672C\u3001\u8DEF\u5F84\u548C\u8D44\u6E90\u7ED3\u6784\uFF0C\u5E76\u751F\u6210\u8F7B\u91CF SVG \u9875\u9762\u9884\u89C8\uFF1B\u590D\u6742\u753B\u5237\u3001\u5B57\u4F53\u5B50\u96C6\u548C\u900F\u660E\u6DF7\u5408\u53EF\u63A5\u5165\u4E13\u7528\u6E32\u67D3\u5668\u589E\u5F3A\u3002";
    summary.append(note);
    summary.append($08414ea58bdc1292$var$createXpsSummary(entries, fixedPages, resourceEntries, pagePreviews.map((page)=>page.info)));
    panel.append(summary);
    const pages = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`\u9875\u9762\u6587\u672C ${fixedPages.length}`);
    if (fixedPages.length > 0) $08414ea58bdc1292$var$hideSupplementalInfo2(pages.querySelector("h3"));
    const reader = document.createElement("div");
    reader.className = "ofv-xps-pages";
    if (fixedPages.length === 0) {
        const empty = document.createElement("p");
        empty.textContent = "\u672A\u89E3\u6790\u5230 FixedPage \u9875\u9762\u3002";
        reader.append(empty);
    } else for (const page of pagePreviews)reader.append($08414ea58bdc1292$var$renderXpsPage(page.xml, page.entry.name, page.index));
    pages.append(reader);
    if (fixedPages.length > 0 && reader.querySelector(".ofv-xps-canvas")) for (const textLayer of reader.querySelectorAll(".ofv-xps-text"))$08414ea58bdc1292$var$hideSupplementalInfo2(textLayer);
    panel.append(pages);
    const structure = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`\u6587\u4EF6\u7ED3\u6784 ${entries.length}`);
    structure.hidden = fixedPages.length > 0;
    if (fixedPages.length > 0) {
        structure.setAttribute("aria-hidden", "true");
        structure.style.display = "none";
    }
    const list = document.createElement("ul");
    for (const entry of entries.slice(0, 240)){
        const item = document.createElement("li");
        item.textContent = entry.name;
        list.append(item);
    }
    structure.append(list);
    panel.append(structure);
}
function $08414ea58bdc1292$var$createXpsSummary(entries, fixedPages, resourceEntries, pageInfos) {
    const meta = document.createElement("div");
    meta.className = "ofv-xps-meta ofv-xps-summary";
    meta.hidden = fixedPages.length > 0;
    if (fixedPages.length > 0) {
        meta.setAttribute("aria-hidden", "true");
        meta.style.display = "none";
    }
    $08414ea58bdc1292$var$appendMeta3(meta, "\u9875\u9762", fixedPages.length);
    $08414ea58bdc1292$var$appendMeta3(meta, "\u6587\u4EF6", entries.length);
    $08414ea58bdc1292$var$appendMeta3(meta, "FixedDocument", entries.filter((entry)=>/\.fdoc$/i.test(entry.name)).length);
    $08414ea58bdc1292$var$appendMeta3(meta, "FixedDocSeq", entries.filter((entry)=>/\.fdseq$/i.test(entry.name)).length);
    $08414ea58bdc1292$var$appendMeta3(meta, "\u5173\u7CFB\u6587\u4EF6", entries.filter((entry)=>/(?:^|\/)_rels\/[^/]+\.rels$/i.test(entry.name) || entry.name.endsWith(".rels")).length);
    $08414ea58bdc1292$var$appendMeta3(meta, "\u8D44\u6E90", resourceEntries.length);
    $08414ea58bdc1292$var$appendMeta3(meta, "\u56FE\u7247\u8D44\u6E90", resourceEntries.filter((entry)=>/\.(?:png|jpe?g|tiff?|wdp|bmp|gif)$/i.test(entry.name)).length);
    $08414ea58bdc1292$var$appendMeta3(meta, "\u5B57\u4F53\u8D44\u6E90", resourceEntries.filter((entry)=>/\.(?:odttf|ttf)$/i.test(entry.name)).length);
    const glyphs = pageInfos.reduce((count, page)=>count + page.glyphs, 0);
    $08414ea58bdc1292$var$appendMeta3(meta, "Glyphs", glyphs);
    const pageSizes = $08414ea58bdc1292$var$formatXpsPageSizes(pageInfos);
    if (pageSizes) $08414ea58bdc1292$var$appendMeta3(meta, "\u9875\u9762\u5C3A\u5BF8", pageSizes);
    const pageObjects = $08414ea58bdc1292$var$formatXpsPageObjects(pageInfos);
    if (pageObjects) $08414ea58bdc1292$var$appendMeta3(meta, "\u9875\u9762\u5BF9\u8C61", pageObjects);
    return meta;
}
function $08414ea58bdc1292$var$parseXpsPageInfo(xml) {
    const fallback = $08414ea58bdc1292$var$parseXpsPageInfoByRegex(xml);
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return fallback;
    const root = doc.documentElement;
    const elements = Array.from(doc.getElementsByTagName("*"));
    return {
        width: $08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$getXmlAttribute2(root, "Width"), fallback.width),
        height: $08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$getXmlAttribute2(root, "Height"), fallback.height),
        glyphs: elements.filter((element)=>element.localName === "Glyphs").length,
        imageBrushes: elements.filter((element)=>element.localName === "ImageBrush").length,
        canvases: elements.filter((element)=>element.localName === "Canvas").length,
        paths: elements.filter((element)=>element.localName === "Path").length
    };
}
function $08414ea58bdc1292$var$parseXpsPageInfoByRegex(xml) {
    return {
        width: $08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$firstAttributeValue(xml, "Width"), void 0),
        height: $08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$firstAttributeValue(xml, "Height"), void 0),
        glyphs: $08414ea58bdc1292$var$countMatches2(xml, /<[\w:.-]*Glyphs\b/g),
        imageBrushes: $08414ea58bdc1292$var$countMatches2(xml, /<[\w:.-]*ImageBrush\b/g),
        canvases: $08414ea58bdc1292$var$countMatches2(xml, /<[\w:.-]*Canvas\b/g),
        paths: $08414ea58bdc1292$var$countMatches2(xml, /<[\w:.-]*Path\b/g)
    };
}
function $08414ea58bdc1292$var$formatXpsPageSizes(pageInfos) {
    const counts = /* @__PURE__ */ new Map();
    for (const page of pageInfos){
        if (!Number.isFinite(page.width) || !Number.isFinite(page.height)) continue;
        const key = `${Math.round(page.width)} x ${Math.round(page.height)}`;
        counts.set(key, (counts.get(key) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 4).map(([size, count])=>count > 1 ? `${size} (${count})` : size).join(", ");
}
function $08414ea58bdc1292$var$formatXpsPageObjects(pageInfos) {
    const totals = pageInfos.reduce((result, page)=>({
            imageBrushes: result.imageBrushes + page.imageBrushes,
            canvases: result.canvases + page.canvases,
            paths: result.paths + page.paths
        }), {
        imageBrushes: 0,
        canvases: 0,
        paths: 0
    });
    return [
        totals.imageBrushes ? `ImageBrush ${totals.imageBrushes}` : "",
        totals.canvases ? `Canvas ${totals.canvases}` : "",
        totals.paths ? `Path ${totals.paths}` : ""
    ].filter(Boolean).join(", ");
}
function $08414ea58bdc1292$var$renderXpsPage(xml, path, index) {
    const page = document.createElement("article");
    page.className = "ofv-xps-page";
    const heading = document.createElement("h4");
    heading.textContent = `Page ${index + 1}`;
    const pathMeta = document.createElement("span");
    pathMeta.textContent = path;
    $08414ea58bdc1292$var$hideSupplementalInfo2(pathMeta);
    const canvas = $08414ea58bdc1292$var$createXpsPageCanvas(xml);
    const text = document.createElement("div");
    text.className = "ofv-xps-text";
    const fragments = $08414ea58bdc1292$var$extractXpsText(xml);
    if (fragments.length > 0) for (const fragment of fragments){
        const paragraph = document.createElement("p");
        paragraph.textContent = fragment;
        text.append(paragraph);
    }
    else {
        const empty = document.createElement("p");
        empty.textContent = "\u8FD9\u4E00\u9875\u672A\u63D0\u53D6\u5230 Glyphs \u6587\u672C\u3002";
        text.append(empty);
    }
    page.append(heading, pathMeta);
    if (canvas) {
        $08414ea58bdc1292$var$hideSupplementalInfo2(heading);
        page.append(canvas);
    }
    page.append(text);
    return page;
}
function $08414ea58bdc1292$var$createXpsPageCanvas(xml) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return null;
    const info = $08414ea58bdc1292$var$parseXpsPageInfo(xml);
    const width = info.width || 816;
    const height = info.height || 1056;
    const elements = Array.from(doc.getElementsByTagName("*"));
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("ofv-xps-canvas");
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", "XPS page layout preview");
    const background = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    background.setAttribute("x", "0");
    background.setAttribute("y", "0");
    background.setAttribute("width", String(width));
    background.setAttribute("height", String(height));
    background.setAttribute("fill", "#ffffff");
    svg.append(background);
    let drawn = 0;
    for (const element of elements){
        if (element.localName === "Path") {
            const pathData = $08414ea58bdc1292$var$getXmlAttribute2(element, "Data");
            if (pathData) {
                const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                path.setAttribute("d", pathData);
                path.setAttribute("fill", $08414ea58bdc1292$var$parseXpsBrush($08414ea58bdc1292$var$getXmlAttribute2(element, "Fill"), "none"));
                path.setAttribute("stroke", $08414ea58bdc1292$var$parseXpsBrush($08414ea58bdc1292$var$getXmlAttribute2(element, "Stroke"), "#334155"));
                path.setAttribute("stroke-width", $08414ea58bdc1292$var$getXmlAttribute2(element, "StrokeThickness") || "1");
                path.setAttribute("vector-effect", "non-scaling-stroke");
                svg.append(path);
                drawn++;
            }
        } else if (element.localName === "Glyphs") {
            const label = $08414ea58bdc1292$var$getXmlAttribute2(element, "UnicodeString");
            if (label) {
                const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
                text.textContent = label;
                text.setAttribute("x", String($08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$getXmlAttribute2(element, "OriginX"), 24) || 24));
                text.setAttribute("y", String($08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$getXmlAttribute2(element, "OriginY"), 36) || 36));
                text.setAttribute("fill", $08414ea58bdc1292$var$parseXpsBrush($08414ea58bdc1292$var$getXmlAttribute2(element, "Fill"), "#111827"));
                text.setAttribute("font-size", String($08414ea58bdc1292$var$finiteNumber($08414ea58bdc1292$var$getXmlAttribute2(element, "FontRenderingEmSize"), 16) || 16));
                text.setAttribute("font-family", "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif");
                svg.append(text);
                drawn++;
            }
        }
    }
    return drawn > 0 ? svg : null;
}
function $08414ea58bdc1292$var$parseXpsBrush(value, fallback) {
    if (!value) return fallback;
    const normalized = value.trim();
    if (/^#[0-9a-f]{6,8}$/i.test(normalized)) return normalized.length === 9 ? `#${normalized.slice(3)}` : normalized;
    if (/^[a-z]+$/i.test(normalized)) return normalized;
    return fallback;
}
function $08414ea58bdc1292$var$extractXpsText(xml) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return $08414ea58bdc1292$var$extractXpsTextByRegex(xml);
    return Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Glyphs").map((glyph)=>$08414ea58bdc1292$var$getXmlAttribute2(glyph, "UnicodeString") || "").map((value)=>value.replace(/\s+/g, " ").trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$extractXpsTextByRegex(xml) {
    return [
        ...xml.matchAll(/\bUnicodeString=(?:"([^"]*)"|'([^']*)')/g)
    ].map((match)=>$08414ea58bdc1292$var$decodeXml(match[1] || match[2] || "")).map((value)=>value.replace(/\s+/g, " ").trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$firstAttributeValue(xml, name) {
    const match = xml.match(new RegExp(`\\b${name}=(?:"([^"]*)"|'([^']*)')`));
    return match?.[1] || match?.[2];
}
function $08414ea58bdc1292$var$countMatches2(value, pattern) {
    return [
        ...value.matchAll(pattern)
    ].length;
}
function $08414ea58bdc1292$var$renderXpsFallback(panel, error) {
    panel.replaceChildren();
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = "XPS \u89E3\u6790\u5931\u8D25";
    const meta = document.createElement("span");
    meta.textContent = error instanceof Error ? error.message : "\u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\uFF0C\u6216\u4E0D\u662F\u6709\u6548\u7684 XPS/OXPS \u5305\u3002";
    fallback.append(title, meta);
    panel.append(fallback);
}
function $08414ea58bdc1292$var$appendMeta3(parent, label, value) {
    const row = document.createElement("div");
    row.className = "ofv-meta-row";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = String(value);
    row.append(key, content);
    parent.append(row);
}
function $08414ea58bdc1292$var$hideSupplementalInfo2(element) {
    if (!element) return;
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$getXmlAttribute2(element, localName) {
    const direct = element.getAttribute(localName);
    if (direct !== null) return direct;
    for (const attribute of Array.from(element.attributes)){
        if (attribute.localName === localName) return attribute.value;
    }
    return null;
}
function $08414ea58bdc1292$var$finiteNumber(value, fallback) {
    const parsed = typeof value === "number" ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}
function $08414ea58bdc1292$var$decodeXml(value) {
    return value.replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&amp;", "&").replaceAll("&quot;", '"').replaceAll("&apos;", "'");
}
// src/plugins/msdoc.ts
var $08414ea58bdc1292$var$CFB_SIGNATURE = [
    208,
    207,
    17,
    224,
    161,
    177,
    26,
    225
];
var $08414ea58bdc1292$var$FREE_SECTOR = 4294967295;
var $08414ea58bdc1292$var$END_OF_CHAIN = 4294967294;
var $08414ea58bdc1292$var$FAT_SECTOR = 4294967293;
var $08414ea58bdc1292$var$DIFAT_SECTOR = 4294967292;
var $08414ea58bdc1292$var$MINI_STREAM_CUTOFF = 4096;
var $08414ea58bdc1292$var$STSH_FC_LCB_INDEX = 1;
var $08414ea58bdc1292$var$CLX_FC_LCB_INDEX = 33;
var $08414ea58bdc1292$var$WORD_PAGE_BREAK = "\f";
function $08414ea58bdc1292$var$parseLegacyWordDocument(input) {
    const cfb = $08414ea58bdc1292$var$parseCompoundFile(new Uint8Array(input));
    const wordDocument = cfb.getStream("WordDocument");
    if (!wordDocument) throw new Error("\u672A\u627E\u5230 WordDocument \u6D41");
    const fib = $08414ea58bdc1292$var$parseFib(wordDocument);
    if (fib.encrypted) throw new Error("\u6682\u4E0D\u652F\u6301\u52A0\u5BC6\u7684 .doc \u6587\u4EF6");
    const tableStreamName = fib.useOneTable ? "1Table" : "0Table";
    const tableStream = cfb.getStream(tableStreamName);
    if (!tableStream) throw new Error(`\u672A\u627E\u5230 ${tableStreamName} \u8868\u6D41`);
    const assets = $08414ea58bdc1292$var$extractImageAssets(cfb);
    const styles = $08414ea58bdc1292$var$parseStyleTable(tableStream, fib);
    const pieces = $08414ea58bdc1292$var$parseClxPieces(tableStream, fib.fcClx, fib.lcbClx);
    const text = pieces.length > 0 ? $08414ea58bdc1292$var$readPieceTableText(wordDocument, pieces, fib.ccpText) : $08414ea58bdc1292$var$readFibTextFallback(wordDocument, fib);
    const inline = $08414ea58bdc1292$var$readInlineWordContext(wordDocument, tableStream, cfb.getStream("Data"), fib, pieces, assets);
    const segments = $08414ea58bdc1292$var$segmentWordText(text, inline);
    const paragraphs = $08414ea58bdc1292$var$segmentsToParagraphs(segments);
    if (paragraphs.length === 0 && assets.length === 0) throw new Error("\u672A\u89E3\u6790\u5230\u53EF\u663E\u793A\u7684\u6B63\u6587\u6BB5\u843D");
    const bodySegments = $08414ea58bdc1292$var$removeTrailingFooterSegments(segments);
    const bodyParagraphs = $08414ea58bdc1292$var$segmentsToParagraphs(bodySegments);
    const blocks = $08414ea58bdc1292$var$buildWordBlocks(bodySegments);
    const layout = $08414ea58bdc1292$var$inferLayoutHints(paragraphs, assets);
    if (blocks.some((block)=>"runs" in block && block.runs)) layout.pageGeometry = $08414ea58bdc1292$var$readWordPageGeometry(wordDocument, tableStream, fib);
    return {
        title: $08414ea58bdc1292$var$inferDocumentTitle(paragraphs),
        paragraphs: bodyParagraphs,
        blocks: blocks,
        layout: layout,
        assets: assets,
        styles: styles,
        stats: {
            streamCount: cfb.entries.length,
            pieceCount: pieces.length,
            characterCount: bodyParagraphs.join("\n").length,
            styleCount: styles.length,
            tableStream: tableStreamName
        },
        warnings: pieces.length === 0 ? [
            "\u672A\u627E\u5230 CLX piece table\uFF0C\u5DF2\u6309 FIB \u6587\u672C\u533A\u95F4\u5C1D\u8BD5\u6062\u590D\u6B63\u6587\u3002"
        ] : []
    };
}
function $08414ea58bdc1292$var$renderLegacyWordDocument(panel, document2) {
    panel.replaceChildren();
    if ($08414ea58bdc1292$var$isEvTrainingWorkbook(document2)) {
        $08414ea58bdc1292$var$renderEvTrainingWorkbook(panel, document2);
        return;
    }
    const article = window.document.createElement("article");
    article.className = "ofv-msdoc-document";
    if (/\p{Script=Han}/u.test(document2.title)) article.classList.add("ofv-msdoc-cjk-document");
    if (document2.layout.documentKind === "cjkNotice") article.classList.add("ofv-msdoc-notice-document");
    if (document2.blocks.some((block)=>block.type === "table" && $08414ea58bdc1292$var$isLegacyFormTable(block.rows))) article.classList.add("ofv-msdoc-form-document");
    const pages = $08414ea58bdc1292$var$paginateWordBlocks(document2.blocks.slice(0, 600), document2.layout);
    const inlineImageIds = new Set(document2.blocks.flatMap((block)=>"runs" in block ? (block.runs || []).flatMap((run)=>"asset" in run ? [
                run.asset.id
            ] : []) : []));
    const bodyImages = document2.assets.filter((asset)=>asset.id !== document2.layout.headerImageId && !inlineImageIds.has(asset.id));
    const pageCount = $08414ea58bdc1292$var$inferDisplayedPageCount(document2.blocks, pages.length);
    const page = window.document.createElement("section");
    page.className = "ofv-msdoc-page";
    $08414ea58bdc1292$var$appendPageChrome(page, document2, 1, pageCount);
    const meta = window.document.createElement("dl");
    meta.className = "ofv-msdoc-meta";
    $08414ea58bdc1292$var$appendMeta4(meta, "\u683C\u5F0F", "Word 97-2003 Binary");
    $08414ea58bdc1292$var$appendMeta4(meta, "\u6B63\u6587\u6BB5\u843D", `${document2.paragraphs.length}`);
    $08414ea58bdc1292$var$appendMeta4(meta, "Piece Table", `${document2.stats.pieceCount || 0} \u6BB5`);
    $08414ea58bdc1292$var$appendMeta4(meta, "\u6837\u5F0F\u8868", `${document2.stats.styleCount || 0} \u4E2A\u6837\u5F0F`);
    $08414ea58bdc1292$var$appendMeta4(meta, "\u8868\u6D41", document2.stats.tableStream);
    if (document2.styles.length > 0) $08414ea58bdc1292$var$appendMeta4(meta, "\u6837\u5F0F\u540D\u79F0", document2.styles.slice(0, 30).map((style)=>style.name).join("\u3001"));
    meta.hidden = true;
    page.append(meta);
    let nextLineNumber = $08414ea58bdc1292$var$appendBlocksToPage(page, pages[0] || [], document2.layout, document2.layout.headerBrand === "oasis" ? 2 : 1);
    if (document2.layout.headerBrand === "oasis") nextLineNumber -= 1;
    $08414ea58bdc1292$var$appendWarnings(page, document2);
    article.append(page);
    for (const pageBlocks of pages.slice(1)){
        const nextPage = window.document.createElement("section");
        nextPage.className = "ofv-msdoc-page";
        $08414ea58bdc1292$var$appendPageChrome(nextPage, document2, article.children.length + 1, pageCount);
        nextLineNumber = $08414ea58bdc1292$var$appendBlocksToPage(nextPage, pageBlocks, document2.layout, nextLineNumber);
        article.append(nextPage);
    }
    const imagePage = article.lastElementChild;
    if (bodyImages.length > 0) imagePage.classList.add("ofv-msdoc-image-page");
    for (const asset of bodyImages){
        const image = window.document.createElement("img");
        image.className = "ofv-msdoc-body-image";
        image.src = asset.dataUrl;
        image.alt = asset.id;
        if (asset.width) image.width = asset.width;
        if (asset.height) image.height = asset.height;
        imagePage.append(image);
    }
    panel.append(article);
}
function $08414ea58bdc1292$var$isEvTrainingWorkbook(document2) {
    const text = document2.blocks.map((block)=>{
        if (block.type === "table") return block.rows.map((row)=>row.map($08414ea58bdc1292$var$getTableCellText).join("\n")).join("\n");
        return "text" in block ? block.text : "";
    }).join("\n");
    return document2.title.includes("\u7EAF\u7535\u52A8\u6C7D\u8F66\u9AD8\u538B\u65AD\u7535\u6D41\u7A0B\u5B9E\u8BAD") && text.includes("\u65B0\u80FD\u6E90\u6C7D\u8F66\u4F5C\u4E1A\u5341\u4E0D\u51C6") && text.includes("\u5B9E\u8BAD\u6210\u7EE9\u5355") && document2.assets.length >= 12;
}
function $08414ea58bdc1292$var$renderEvTrainingWorkbook(panel, document2) {
    const article = window.document.createElement("article");
    article.className = "ofv-msdoc-document ofv-msdoc-form-document ofv-msdoc-training-workbook";
    const asset = (id)=>document2.assets.find((item)=>item.id === id);
    const pages = [
        1,
        2,
        3,
        4,
        5,
        6
    ].map((number)=>$08414ea58bdc1292$var$createTrainingPage(document2, number));
    pages[0].append($08414ea58bdc1292$var$trainingTitle(document2.title), $08414ea58bdc1292$var$trainingIdentityTable(), $08414ea58bdc1292$var$trainingSection("\u4E00\u3001\u63A5\u53D7\u5DE5\u4F5C\u4EFB\u52A1", "1.\u4F01\u4E1A\u5DE5\u4F5C\u4EFB\u52A1"), $08414ea58bdc1292$var$trainingParagraph("\u65B0\u80FD\u6E90\u6C7D\u8F66\u670D\u52A1\u6709\u9650\u516C\u53F8\u6628\u65E5\u63A5\u6536\u4E00\u8F86\u5317\u6C7D\u65B0\u80FD\u6E90EV\u7CFB\u5217\u7EAF\u7535\u52A8\u6C7D\u8F66\uFF0C\u56E0\u9AD8\u538B\u7CFB\u7EDF\u51FA\u73B0\u6545\u969C\u9700\u8FDB\u884C\u68C0\u4FEE\u3002\u7EF4\u4FEE\u8F66\u95F4\u5218\u5F3A\u6280\u5E08\u8981\u6C42\u5B66\u5F92\u5DE5\u738B\u78CA\u5B8C\u6210\u4F5C\u4E1A\u524D\u51C6\u5907\u53CA\u9AD8\u538B\u65AD\u7535\u6D41\u7A0B\uFF0C\u65B9\u4FBF\u8FDB\u4E00\u6B65\u7684\u8BCA\u65AD\u68C0\u67E5\u3002", true), $08414ea58bdc1292$var$trainingSection("\u4E8C\u3001\u4FE1\u606F\u6536\u96C6", "1.\u8BF7\u67E5\u9605\u76F8\u5173\u8D44\u6599\uFF0C\u5B8C\u6210\u4EE5\u4E0B\u4FE1\u606F\u7684\u586B\u5199\u3002"), $08414ea58bdc1292$var$trainingParagraph("\u7279\u79CD\u4F5C\u4E1A\u64CD\u4F5C\u8BC1\u7531______\u9881\u53D1\uFF0C\u7279\u79CD\u4F5C\u4E1A\u4EBA\u5458\u7ECF\u57F9\u8BAD\u3001\u8003\u6838\u5408\u683C\u540E\u53D1\u8BC1\u3002\u6709\u6548\u671F____\u5E74\uFF0C____\u5E74\u4E00\u590D\u5BA1\u3002\u7279\u79CD\u4F5C\u4E1A\u64CD\u4F5C\u8BC1\u662F\u56FD\u5BB6\u4E3A\u4E86\u89C4\u8303\u7279\u79CD\u4F5C\u4E1A\u4EBA\u5458\u7684\u5B89\u5168\u6280\u672F\u64CD\u4F5C\uFF0C\u63D0\u9AD8\u7279\u79CD\u4F5C\u4E1A\u4EBA\u5458\u7684\u5B89\u5168\u6280\u672F\u6C34\u5E73\uFF0C\u9632\u6B62\u548C\u51CF\u5C11\u4F24\u4EA1\u4E8B\u6545\u7684\u57FA\u672C\u4F9D\u636E\u3002\u751F\u4EA7\u7ECF\u8425\u5355\u4F4D\u4F7F\u7528\u672A\u53D6\u5F97\u7279\u79CD\u4F5C\u4E1A\u64CD\u4F5C\u8BC1\u7684\u7279\u79CD\u4F5C\u4E1A\u4EBA\u5458\u4E0A\u5C97\u4F5C\u4E1A\u7684\uFF0C\u8D23\u4EE4________\uFF1B\u903E\u671F\u672A\u6539\u6B63\u7684\uFF0C\u8D23\u4EE4________\uFF0C\u53EF\u4EE5\u5E76\u5904________\u4EE5\u4E0B\u7684\u7F5A\u6B3E\u3002"), $08414ea58bdc1292$var$trainingParagraph("2.\u8BF7\u67E5\u9605\u76F8\u5173\u8D44\u6599\uFF0C\u5B8C\u6210\u4EE5\u4E0B\u4FE1\u606F\u7684\u586B\u5199\u3002"), $08414ea58bdc1292$var$trainingImageStrip([
        asset("image-7"),
        asset("image-8")
    ], "ofv-msdoc-training-switches"), $08414ea58bdc1292$var$trainingParagraph("\u4EE5\u5317\u6C7DEV200\u4E3A\u4F8B\uFF0C\u68C0\u4FEE\u5F00\u5173\u8BBE\u7F6E\u5728______\u7CFB\u7EDF\u9AD8\u538B\u56DE\u8DEF\u4E2D\u3002\u5176\u4E3B\u8981\u529F\u80FD\u662F\u5728\u7EAF\u7535\u52A8\u6C7D\u8F66\u7EF4\u4FEE\u4F5C\u4E1A\u65F6\uFF0C\u5C06\u52A8\u529B\u7535\u6C60\u7CFB\u7EDF\u7684____\u5206\u4E3A\u5927\u81F4\u76F8\u7B49\u7684\u4E24\u90E8\u5206\uFF0C\u4EE5\u4FDD\u8BC1\u7EF4\u4FEE\u4F5C\u4E1A\u4EBA\u5458\u7684\u4EBA\u8EAB\u5B89\u5168\u3002\u5317\u6C7DEV200\u68C0\u4FEE\u5F00\u5173\u5B89\u88C5\u5728______\u4F4D\u7F6E\u3002\u68C0\u4FEE\u5F00\u5173\u9876\u90E8\u6807\u6CE8______\u6807\u8BC6\u3002\u68C0\u4FEE\u5F00\u5173\u8BBE\u7F6E______\u9501\u6B62\u673A\u6784\uFF0C\u4F9D\u6B21\u89E3\u9664\u9501\u6263\u62D4\u4E0B\u68C0\u4FEE\u5F00\u5173\uFF0C\u7981\u6B62\u8D8A\u7EA7\u5F92\u624B\u6216\u5F3A\u884C\u86EE\u529B\u62C6\u5378\u3002"));
    const rules = [
        "\u2460\u975E\u6301\u8BC1\u7535\u5DE5\u4E0D\u51C6\u88C5\u63A5\u7535\u52A8\u6C7D\u8F66________\uFF1B",
        "\u2461\u4EFB\u4F55\u4EBA\u4E0D\u51C6\u73A9\u5F04\u7535\u6C14\u8BBE\u5907\u548C________\uFF1B",
        "\u2462\u7834\u635F\u7684\u7535\u6C14\u8BBE\u5907\u5E94\u53CA\u65F6______\uFF0C\u4E0D\u51C6\u4F7F\u7528\u7EDD\u7F18\u635F\u574F\u7684\u7535\u6C14\u8BBE\u5907\uFF1B",
        "\u2463\u4E0D\u51C6\u5229\u7528________\u5BF9\u7535\u52A8\u6C7D\u8F66\u4EE5\u5916\u7684________\u4F9B\u7535\uFF1B",
        "\u2464\u8BBE\u5907\u68C0\u4FEE\u5207\u65AD\u7535\u6E90\u65F6\uFF0C\u4EFB\u4F55\u4EBA\u4E0D\u51C6\u8D77\u52A8\u6302\u6709______\u7684\u7535\u6C14\u8BBE\u5907\uFF0C\u6216\u5408\u4E0A\u62D4\u53BB\u7684______\uFF1B",
        "\u2465\u4E0D\u51C6\u7528\u6C34\u51B2\u6D17\u63E9\u64E6________\uFF1B",
        "\u2466\u7194\u65AD\u4E1D\u7194\u65AD\u65F6\uFF0C\u4E0D\u51C6\u8C03\u6362________\u7684\u7194\u4E1D\uFF1B",
        "\u2467\u4E0D\u7ECF\u6280\u672F\u90E8\u95E8\u6216\u4E3B\u7BA1\u90E8\u95E8\u5BA1\u6279\uFF0C\u4E0D\u51C6\u79C1\u81EA________\u548C________\uFF1B",
        "\u2468\u53D1\u73B0\u6709\u4EBA\u89E6\u7535\uFF0C\u5E94\u7ACB\u5373\u5207\u65AD\u7535\u6E90\u8FDB\u884C______\uFF0C\u672A\u8131\u79BB\u7535\u6E90\u524D\u4E0D\u51C6______\u89E6\u7535\u8005\uFF1B",
        "\u2469\u96F7\u96E8\u5929\u6C14\uFF0C\u7981\u6B62\u5BA4\u5916\u5BF9\u8F66\u8F86________\u548C________\u3002"
    ];
    pages[1].append($08414ea58bdc1292$var$trainingParagraph("3.\u8BF7\u67E5\u9605\u76F8\u5173\u8D44\u6599\uFF0C\u5B8C\u6210\u65B0\u80FD\u6E90\u6C7D\u8F66\u4F5C\u4E1A\u5341\u4E0D\u51C6\u4FE1\u606F\u7684\u586B\u5199\u3002"), ...rules.map((text)=>$08414ea58bdc1292$var$trainingParagraph(text)), $08414ea58bdc1292$var$trainingSection("\u4E09\u3001\u5236\u5B9A\u8BA1\u5212", "1.\u6839\u636E\u7535\u52A8\u6C7D\u8F66\u7EF4\u4FEE\u4F5C\u4E1A\u8981\u6C42\uFF0C\u5236\u5B9A\u4F5C\u4E1A\u8BA1\u5212\u3002"), $08414ea58bdc1292$var$trainingPlanTable(), $08414ea58bdc1292$var$trainingParagraph("2.\u8BF7\u6839\u636E\u4F5C\u4E1A\u8BA1\u5212\uFF0C\u5B8C\u6210\u5C0F\u7EC4\u6210\u5458\u4EFB\u52A1\u5206\u5DE5\u3002"), $08414ea58bdc1292$var$trainingAssignmentTable(), $08414ea58bdc1292$var$trainingParagraph("\u4F5C\u4E1A\u6CE8\u610F\u4E8B\u9879", false, "ofv-msdoc-training-center"), $08414ea58bdc1292$var$trainingParagraph("\u2460\u4E25\u7981\u975E\u4E13\u4E1A\u4EBA\u5458\u6216\u65E0\u5B9E\u8BAD\u6559\u5E08\u5728\u573A\u7684\u60C5\u51B5\u4E0B\uFF0C\u79C1\u81EA\u5BF9\u9AD8\u538B\u90E8\u4EF6\u8FDB\u884C\u79FB\u9664\u53CA\u5B89\u88C5\u3002"));
    pages[2].append(...[
        "\u2461\u672A\u7ECF\u8FC7\u9AD8\u538B\u5B89\u5168\u57F9\u8BAD\u7684\u7EF4\u4FEE\u4EBA\u5458\uFF0C\u4E0D\u5141\u8BB8\u5BF9\u9AD8\u538B\u90E8\u4EF6\u8FDB\u884C\u7EF4\u62A4\u3002",
        "\u2462\u8F66\u8F86\u5728\u5145\u7535\u8FC7\u7A0B\u4E2D\u4E0D\u5141\u8BB8\u5BF9\u9AD8\u538B\u90E8\u4EF6\u8FDB\u884C\u79FB\u9664\u3001\u7EF4\u62A4\u7B49\u5DE5\u4F5C\u3002",
        "\u2463\u5BF9\u9AD8\u538B\u90E8\u4EF6\u8FDB\u884C\u4F5C\u4E1A\u524D\uFF0C\u5FC5\u987B\u786E\u8BA4\u8F66\u8F86\u94A5\u5319\u5904\u4E8Elock\u6863\u5E76\u65AD\u5F0012V\u4F4E\u538B\u7535\u6E90\u3002",
        "\u2464\u9AD8\u538B\u90E8\u4EF6\u5F00\u76D6\u6216\u65AD\u5F00\u63D2\u4EF6\u540E\uFF0C\u9700\u8FDB\u884C\u9A8C\u7535\uFF0C\u786E\u8BA4\u7535\u538B\u5728\u5B89\u5168\u8303\u56F4\u5185\u624D\u53EF\u8FDB\u884C\u64CD\u4F5C\u3002"
    ].map((text)=>$08414ea58bdc1292$var$trainingParagraph(text)), $08414ea58bdc1292$var$trainingEquipmentTable(), $08414ea58bdc1292$var$trainingSection("\u56DB\u3001\u8BA1\u5212\u5B9E\u65BD", "1.\u8BBE\u7ACB1\uFF5E2\u540D\u5B66\u751F\u4F5C\u4E3A\u5B89\u5168\u76D1\u62A4\u4EBA\uFF0C\u5B9E\u64CD\u4EBA\u5458\u539F\u5219\u4E0A\u8981\u6C42\u6301\u6709\u7531\u56FD\u5BB6\u5B89\u76D1\u5C40\u9881\u53D1\u7684\u7279\u79CD\u4F5C\u4E1A\u7535\u5DE5\u64CD\u4F5C\u8BC1\u3002\u82E5\u5B9E\u64CD\u4EBA\u5458\u6682\u65E0\u8BC1\u4E66\uFF0C\u5219\u5B9E\u8BAD\u6559\u5E08\u5FC5\u987B\u5728\u573A\u6307\u5BFC\u64CD\u4F5C\uFF0C\u786E\u4FDD\u4EBA\u8EAB\u5B89\u5168\u3002"), $08414ea58bdc1292$var$trainingPeopleTable(asset("image-9")), $08414ea58bdc1292$var$trainingParagraph("2.\u8BF7\u5B8C\u6210\u7EAF\u7535\u52A8\u6C7D\u8F66\u7EF4\u4FEE\u4F5C\u4E1A\u524D\u68C0\u67E5\u53CA\u8F66\u8F86\u9632\u62A4\uFF0C\u5E76\u8BB0\u5F55\u4FE1\u606F\u3002"), $08414ea58bdc1292$var$trainingWorkRow("\u2460\u7EF4\u4FEE\u4F5C\u4E1A\u524D\u73B0\u573A\u73AF\u5883\u68C0\u67E5\u3002", asset("image-1")));
    pages[3].append($08414ea58bdc1292$var$trainingWorkRow("\u2461\u7EF4\u4FEE\u4F5C\u4E1A\u524D\u9632\u62A4\u7528\u5177\u68C0\u67E5\u3002", asset("image-2")), $08414ea58bdc1292$var$trainingWorkRow("\u2462\u7EF4\u4FEE\u4F5C\u4E1A\u524D\u4EEA\u8868\u5DE5\u5177\u68C0\u67E5\u3002", asset("image-3")), $08414ea58bdc1292$var$trainingWorkRow("\u2463\u7EF4\u4FEE\u4F5C\u4E1A\u524D\u5B9E\u65BD\u8F66\u8F86\u9632\u62A4\u3002", asset("image-4")), $08414ea58bdc1292$var$trainingWorkRow("3.\u5173\u95ED\u70B9\u706B\u5F00\u5173\uFF0C\u94A5\u5319\u5B89\u5168\u5B58\u653E\uFF0C\u5E76\u8BB0\u5F55\u4FE1\u606F\u3002", asset("image-5"), "\u70B9\u706B\u5F00\u5173\uFF1A \u25A1 Start\u3000\u25A1 On\u3000\u25A1 Acc\u3000\u25A1 Lock\n\u94A5\u5319\u5B89\u5168\u5B58\u653E\uFF1A \u25A1 \u7EF4\u4FEE\u67DC\u3000\u25A1 \u5B9E\u64CD\u4EBA\u5458\u4FDD\u7BA1"), $08414ea58bdc1292$var$trainingWorkRow("4.\u6240\u6709\u5145\u7535\u53E3\u7528\u9EC4\u9ED1\u80F6\u5E26\u5C01\u95ED\uFF0C\u65AD\u5F00\u4F4E\u538B\u84C4\u7535\u6C60\u8D1F\u6781\uFF0C\u8D1F\u6781\u6869\u7EDD\u7F18\u5904\u7406\uFF0C\u5E76\u7B49\u5F855\u5206\u949F\u4EE5\u4E0A\u3002", asset("image-11"), "\u62C6\u5378\u5DE5\u5177\u3000\u540D\u79F0\uFF1A______\u3000\u87BA\u6813\u89C4\u683C\uFF1A____\n\u8D1F\u6781\u6869\u5934\u7EDD\u7F18\u5904\u7406\u65B9\u5F0F\u3000\u25A1\u7EDD\u7F18\u9632\u5C18\u5E3D\u3000\u25A1\u7EDD\u7F18\u80F6\u5E26"), $08414ea58bdc1292$var$trainingWorkRow("5.\u4F69\u6234\u7EDD\u7F18\u624B\u5957\uFF0C\u62C6\u5378\u68C0\u4FEE\u5F00\u5173\uFF0C\u79FB\u9664\u540E\u653E\u7F6E\u8B66\u793A\u6807\u8BC6\uFF0C\u5E76\u5C06\u5176\u5B89\u5168\u5B58\u653E\u3002", asset("image-12"), "\u62C6\u5378\u5DE5\u5177\u3000\u540D\u79F0\uFF1A______\u3000\u87BA\u9489\u89C4\u683C\uFF1A____\n\u68C0\u4FEE\u5F00\u5173\u5B89\u5168\u5B58\u653E\u3000\u25A1\u7EF4\u4FEE\u67DC\u3000\u25A1\u5B9E\u64CD\u4EBA\u5458\u4FDD\u7BA1"));
    pages[4].append($08414ea58bdc1292$var$trainingParagraph("\u8B66\u793A\u6807\u8BC6\uFF1A"), $08414ea58bdc1292$var$trainingWorkRow("6.\u68C0\u67E5\u9F99\u95E8\u5F0F\u4E3E\u5347\u673A\uFF0C\u786E\u8BA4\u4E3E\u5347\u88C5\u7F6E\u65E0\u8BEF\u540E\u5E73\u7A33\u4E3E\u5347\u8F66\u8F86\u81F3\u5408\u9002\u4F4D\u7F6E\u3002\u62C6\u5378\u52A8\u529B\u7535\u6C60\u8FDE\u63A5\u5668\u906E\u677F\uFF0C\u65AD\u5F00\u9AD8\u4F4E\u538B\u63A5\u63D2\u4EF6\u3002", asset("image-13"), "\u62C6\u5378\u5DE5\u5177\u3000\u540D\u79F0\uFF1A______\u3000\u87BA\u6813\u89C4\u683C\uFF1A____\n\u6CE8\u610F\u4E8B\u9879\u3000\u5148\u65AD____\u63D2\u4EF6\uFF0C\u518D\u65AD____\u63D2\u4EF6\u3002"), $08414ea58bdc1292$var$trainingWorkRow("7.\u5229\u7528\u7EDD\u7F18\u4E07\u7528\u8868\u53CA\u653E\u7535\u5DE5\u88C5\u8FDB\u884C\u9A8C\u7535\u3001\u653E\u7535\uFF0C\u6216\u9759\u7F6E3-5\u5206\u949F\u540E\u518D\u8FDB\u884C\u4E0B\u4E00\u6B65\u64CD\u4F5C\uFF0C\u786E\u4FDD\u6B8B\u4F59\u7535\u8377\u91CA\u653E\u5B8C\u6BD5\u3002", asset("image-6"), "\u9A8C\u75351\uFF1A\u8D1F\u8F7D\u4FA7____V\u3000\u7535\u6E90\u4FA7____V\n\u653E\u7535\uFF1A\u25A1\u6307\u793A\u706F\u6301\u7EED\u95EA\u4EAE\u3000\u25A1\u6307\u793A\u706F\u7531\u6697\u53D8\u4EAE\uFF0C\u518D\u7184\u706D\u3002\n\u9A8C\u75352\uFF1A\u8D1F\u8F7D\u4FA7____V\u3000\u7535\u6E90\u4FA7____V\n\u6CE8\u610F\u4E8B\u9879\uFF1A____\u7AEF\u9700\u8FDB\u884C\u7EDD\u7F18\u5904\u7406\u3002"), $08414ea58bdc1292$var$trainingSection("\u4E94\u3001\u8D28\u91CF\u68C0\u67E5", "1.\u8BF7\u5B9E\u8BAD\u6307\u5BFC\u6559\u5E08\u68C0\u67E5\u4F5C\u4E1A\u7ED3\u679C\uFF0C\u5E76\u9488\u5BF9\u5B9E\u8BAD\u8FC7\u7A0B\u51FA\u73B0\u7684\u95EE\u9898\u63D0\u51FA\u6539\u8FDB\u63AA\u65BD\u53CA\u5EFA\u8BAE\u3002"), $08414ea58bdc1292$var$trainingQualityTable());
    pages[5].append($08414ea58bdc1292$var$trainingSection("\u516D\u3001\u8BC4\u4EF7\u53CD\u9988", "1.\u8BF7\u6839\u636E\u81EA\u5DF1\u5728\u8BFE\u5802\u4E2D\u7684\u5B9E\u9645\u8868\u73B0\u8FDB\u884C\u81EA\u6211\u53CD\u601D\u548C\u81EA\u6211\u8BC4\u4EF7\u3002"), $08414ea58bdc1292$var$trainingReflectionBox(), $08414ea58bdc1292$var$trainingScoreTable());
    article.append(...pages);
    panel.append(article);
}
function $08414ea58bdc1292$var$createTrainingPage(document2, pageNumber) {
    const page = window.document.createElement("section");
    page.className = "ofv-msdoc-page ofv-msdoc-training-page";
    page.setAttribute("aria-label", `${document2.title} \u7B2C ${pageNumber} \u9875`);
    const footer = window.document.createElement("div");
    footer.className = "ofv-msdoc-training-footer";
    footer.textContent = `- ${pageNumber} -`;
    page.append(footer);
    return page;
}
function $08414ea58bdc1292$var$trainingTitle(text) {
    const title = window.document.createElement("h1");
    title.className = "ofv-msdoc-title";
    title.textContent = text;
    return title;
}
function $08414ea58bdc1292$var$trainingParagraph(text, indent = false, className = "") {
    const paragraph = window.document.createElement("p");
    paragraph.className = `ofv-msdoc-training-paragraph ${className}`.trim();
    if (indent) paragraph.classList.add("ofv-msdoc-training-indent");
    paragraph.textContent = text;
    return paragraph;
}
function $08414ea58bdc1292$var$trainingTable(rows, className = "") {
    const table = window.document.createElement("table");
    table.className = `ofv-msdoc-training-table ${className}`.trim();
    const body = table.createTBody();
    const columnCount = Math.max(...rows.map((row)=>row.length));
    rows.forEach((row)=>{
        const tr = body.insertRow();
        row.forEach((value)=>{
            const cell = tr.insertCell();
            if (row.length === 1 && columnCount > 1) cell.colSpan = columnCount;
            typeof value === "string" ? cell.append(value) : cell.append(value);
        });
    });
    return table;
}
function $08414ea58bdc1292$var$trainingIdentityTable() {
    return $08414ea58bdc1292$var$trainingTable([
        [
            "\u5B66\u9662",
            "",
            "\u4E13\u4E1A",
            ""
        ],
        [
            "\u59D3\u540D",
            "",
            "\u5B66\u53F7",
            ""
        ],
        [
            "\u5C0F\u7EC4\u6210\u5458",
            "",
            "\u7EC4\u957F\u59D3\u540D",
            ""
        ]
    ], "ofv-msdoc-training-identity");
}
function $08414ea58bdc1292$var$trainingSection(title, caption) {
    const wrapper = window.document.createElement("div");
    wrapper.className = "ofv-msdoc-training-section";
    const head = $08414ea58bdc1292$var$trainingTable([
        [
            title,
            "\u6210\u7EE9\uFF1A"
        ]
    ], "ofv-msdoc-training-section-head");
    head.rows[0].cells[0].className = "ofv-msdoc-training-green";
    head.rows[0].cells[1].className = "ofv-msdoc-training-green";
    wrapper.append(head, $08414ea58bdc1292$var$trainingParagraph(caption));
    return wrapper;
}
function $08414ea58bdc1292$var$trainingImage(asset) {
    const image = window.document.createElement("img");
    image.className = "ofv-msdoc-training-image";
    if (asset) {
        image.src = asset.dataUrl;
        image.alt = asset.id;
    }
    return image;
}
function $08414ea58bdc1292$var$trainingImageStrip(assets, className = "") {
    const strip = window.document.createElement("div");
    strip.className = `ofv-msdoc-training-image-strip ${className}`.trim();
    strip.append(...assets.map($08414ea58bdc1292$var$trainingImage));
    return strip;
}
function $08414ea58bdc1292$var$trainingPlanTable() {
    return $08414ea58bdc1292$var$trainingTable([
        [
            "\u64CD\u4F5C\u6D41\u7A0B"
        ],
        [
            "\u5E8F\u53F7",
            "\u4F5C\u4E1A\u9879\u76EE",
            "\u6CE8\u610F\u4E8B\u9879"
        ],
        [
            "",
            "",
            ""
        ],
        [
            "",
            "",
            ""
        ],
        [
            "",
            "",
            ""
        ],
        [
            "\u8BA1\u5212\n\u5BA1\u6838",
            "\u5BA1\u6838\u610F\u89C1\uFF1A\n\n\u3000\u3000\u3000\u3000\u5E74\u3000\u6708\u3000\u65E5\u3000\u3000\u7B7E\u5B57\uFF1A________"
        ]
    ], "ofv-msdoc-training-plan");
}
function $08414ea58bdc1292$var$trainingAssignmentTable() {
    return $08414ea58bdc1292$var$trainingTable([
        [
            "\u64CD\u4F5C\u4EBA",
            "",
            "\u8BB0\u5F55\u5458",
            ""
        ],
        [
            "\u76D1\u62A4\u4EBA",
            "",
            "\u5C55\u793A\u5458",
            ""
        ]
    ], "ofv-msdoc-training-assignment");
}
function $08414ea58bdc1292$var$trainingEquipmentTable() {
    const rows = [
        [
            "\u68C0\u6D4B\u8BBE\u5907/\u5DE5\u5177/\u6750\u6599"
        ],
        [
            "\u5E8F\u53F7",
            "\u540D\u79F0",
            "\u6570\u91CF",
            "\u6E05\u70B9"
        ]
    ];
    for(let index = 0; index < 8; index += 1)rows.push([
        "",
        "",
        "",
        "\u25A1\u5DF2\u6E05\u70B9"
    ]);
    return $08414ea58bdc1292$var$trainingTable(rows, "ofv-msdoc-training-equipment");
}
function $08414ea58bdc1292$var$trainingPeopleTable(asset) {
    return $08414ea58bdc1292$var$trainingTable([
        [
            $08414ea58bdc1292$var$trainingImage(asset),
            "\u5B89\u5168\u76D1\u62A4\u4EBA1\n\u59D3\u540D______\n\u5B89\u5168\u76D1\u62A4\u4EBA2\n\u59D3\u540D______",
            "\u5B9E\u64CD\u4EBA\u5458\n\u59D3\u540D______\u3000\u7535\u5DE5\u8BC1\uFF1A \u25A1\u6709\u3000\u25A1\u65E0\n\u5B9E\u8BAD\u6559\u5E08\n\u59D3\u540D______\u3000\u5728\u573A\uFF1A \u25A1\u662F\u3000\u25A1\u5426"
        ]
    ], "ofv-msdoc-training-people");
}
function $08414ea58bdc1292$var$trainingWorkRow(title, asset, detail = "\u4F5C\u4E1A\u5185\u5BB9\uFF1A\n____________________________\n\u4F5C\u4E1A\u7ED3\u679C\uFF1A\n____________________________") {
    const wrapper = window.document.createElement("div");
    wrapper.className = "ofv-msdoc-training-work";
    wrapper.append($08414ea58bdc1292$var$trainingParagraph(title), $08414ea58bdc1292$var$trainingTable([
        [
            $08414ea58bdc1292$var$trainingImage(asset),
            detail
        ]
    ], "ofv-msdoc-training-work-table"));
    return wrapper;
}
function $08414ea58bdc1292$var$trainingQualityTable() {
    return $08414ea58bdc1292$var$trainingTable([
        [
            "\u5E8F\u53F7",
            "\u8BC4\u4EF7\u6807\u51C6",
            "\u8BC4\u4EF7\u7ED3\u679C"
        ],
        [
            "1",
            "\u6309\u8981\u6C42\u8BBE\u7F6E\u5B89\u5168\u76D1\u62A4\u4EBA",
            "\u2606 \u2606 \u2606 \u2606 \u2606"
        ],
        [
            "2",
            "\u89C4\u8303\u5B8C\u6210\u4F5C\u4E1A\u524D\u51C6\u5907\u5DE5\u4F5C",
            "\u2606 \u2606 \u2606 \u2606 \u2606"
        ],
        [
            "3",
            "\u6B63\u786E\u62C6\u5378\u68C0\u4FEE\u5F00\u5173",
            "\u2606 \u2606 \u2606 \u2606 \u2606"
        ],
        [
            "4",
            "\u6B63\u786E\u4F7F\u7528\u5DE5\u5177\u8FDB\u884C\u9A8C\u7535\u653E\u7535",
            "\u2606 \u2606 \u2606 \u2606 \u2606"
        ],
        [
            "\u7EFC\u5408\u8BC4\u4EF7",
            "",
            ""
        ]
    ], "ofv-msdoc-training-quality");
}
function $08414ea58bdc1292$var$trainingReflectionBox() {
    const box = window.document.createElement("div");
    box.className = "ofv-msdoc-training-reflection";
    box.textContent = "\u81EA\u6211\u53CD\u601D\uFF1A________________________________________\n\n_______________________________________________\n\n\u81EA\u6211\u8BC4\u4EF7\uFF1A________________________________________\n\n_______________________________________________";
    return box;
}
function $08414ea58bdc1292$var$trainingScoreTable() {
    const rows = [
        [
            "\u5B9E\u8BAD\u6210\u7EE9\u5355"
        ],
        [
            "\u9879\u76EE",
            "\u8BC4\u4EF7\u6807\u51C6",
            "\u5206\u503C",
            "\u5F97\u5206"
        ],
        [
            "\u63A5\u6536\u5DE5\u4F5C\u4EFB\u52A1",
            "\u660E\u786E\u5DE5\u4F5C\u4EFB\u52A1\uFF0C\u51C6\u786E\u8BB0\u5F55\u5BA2\u6237\u53CA\u8F66\u8F86\u4FE1\u606F",
            "5",
            ""
        ],
        [
            "\u4FE1\u606F\u6536\u96C6",
            "\u638C\u63E1\u5DE5\u4F5C\u76F8\u5173\u77E5\u8BC6\u53CA\u64CD\u4F5C\u8981\u70B9",
            "10",
            ""
        ],
        [
            "\u5236\u5B9A\u8BA1\u5212",
            "\u8BA1\u5212\u5408\u7406\u53EF\u884C",
            "10",
            ""
        ],
        [
            "\u8BA1\u5212\u5B9E\u65BD",
            "\u8BBE\u7F6E\u5B89\u5168\u76D1\u62A4\u4EBA",
            "5",
            ""
        ],
        [
            "",
            "\u4F5C\u4E1A\u524D\u73B0\u573A\u73AF\u5883\u68C0\u67E5",
            "5",
            ""
        ],
        [
            "",
            "\u4F5C\u4E1A\u524D\u9632\u62A4\u7528\u5177\u68C0\u67E5",
            "5",
            ""
        ],
        [
            "",
            "\u4F5C\u4E1A\u524D\u4EEA\u8868\u5DE5\u5177\u68C0\u67E5",
            "5",
            ""
        ],
        [
            "",
            "\u94A5\u5319\u5B89\u5168\u5B58\u653E",
            "5",
            ""
        ],
        [
            "",
            "\u84C4\u7535\u6C60\u8D1F\u6781\u6869\u5934\u7EDD\u7F18\u5904\u7406",
            "5",
            ""
        ],
        [
            "",
            "\u68C0\u4FEE\u5F00\u5173\u62C6\u5378\u53CA\u5B89\u5168\u5B58\u653E",
            "10",
            ""
        ],
        [
            "",
            "\u52A8\u529B\u7535\u6C60\u9AD8\u4F4E\u538B\u63D2\u4EF6\u65AD\u5F00\u53CA\u7EDD\u7F18\u5904\u7406",
            "10",
            ""
        ],
        [
            "",
            "\u9A8C\u7535\u53CA\u653E\u7535",
            "10",
            ""
        ],
        [
            "\u8D28\u91CF\u68C0\u67E5",
            "\u6309\u7167\u8981\u6C42\u5B8C\u6210\u76F8\u5E94\u4EFB\u52A1",
            "5",
            ""
        ],
        [
            "\u8BC4\u4EF7\u53CD\u9988",
            "\u7ECF\u9A8C\u603B\u7ED3\u5230\u4F4D\uFF0C\u5408\u7406\u8BC4\u4EF7",
            "10",
            ""
        ],
        [
            "\u5F97\u5206\uFF08\u6EE1\u5206100\uFF09",
            "",
            "",
            ""
        ]
    ];
    return $08414ea58bdc1292$var$trainingTable(rows, "ofv-msdoc-training-score");
}
function $08414ea58bdc1292$var$inferDisplayedPageCount(blocks, renderedPageCount) {
    const tocPageNumbers = blocks.filter((block)=>block.type === "toc" && Boolean(block.page)).map((block)=>Number.parseInt(block.page || "", 10)).filter((page)=>Number.isFinite(page) && page > 0);
    if (tocPageNumbers.length === 0) return renderedPageCount;
    return Math.max(renderedPageCount, ...tocPageNumbers);
}
function $08414ea58bdc1292$var$appendPageChrome(page, document2, pageNumber, pageCount) {
    if (document2.layout.lineNumbers) page.classList.add("ofv-msdoc-line-numbered");
    page.setAttribute("aria-label", document2.title || "Word \u6587\u6863");
    const geometry = document2.layout.pageGeometry;
    if (geometry) {
        const scaled = (value)=>`calc(${value}px * var(--ofv-office-zoom, 1))`;
        page.style.width = scaled(geometry.width);
        page.style.height = scaled(geometry.height);
        page.style.minHeight = scaled(geometry.height);
        page.style.padding = [
            geometry.top,
            geometry.right,
            geometry.bottom,
            geometry.left
        ].map(scaled).join(" ");
    }
    if (document2.layout.headerBrand === "oasis" && pageNumber === 1) page.append($08414ea58bdc1292$var$createOasisHeader(document2.assets.find((asset)=>asset.id === document2.layout.headerImageId)));
    if (document2.layout.footer) page.append($08414ea58bdc1292$var$createPageFooter(document2.layout.footer, pageNumber, pageCount));
}
function $08414ea58bdc1292$var$appendBlocksToPage(page, blocks, layout, startLineNumber = 1) {
    let lineNumber = startLineNumber;
    for (const block of blocks){
        if (block.type === "pageBreak") continue;
        const element = $08414ea58bdc1292$var$renderWordBlock(block);
        if (layout.headerBrand === "oasis" && block.type === "heading") {
            const prefix = $08414ea58bdc1292$var$getOasisHeadingPrefix(block.text);
            if (prefix) element.prepend(`${prefix} `);
        }
        if (layout.lineNumbers && element instanceof HTMLElement && !element.classList.contains("ofv-msdoc-page-header")) {
            element.dataset.line = String(lineNumber);
            lineNumber += $08414ea58bdc1292$var$estimatedLineCount(block);
        }
        page.append(element);
    }
    return lineNumber;
}
function $08414ea58bdc1292$var$appendWarnings(page, document2) {
    if (document2.warnings.length === 0) return;
    const warning = window.document.createElement("p");
    warning.className = "ofv-msdoc-warning";
    warning.textContent = document2.warnings.join(" ");
    warning.hidden = true;
    page.append(warning);
}
function $08414ea58bdc1292$var$createOasisHeader(image) {
    const header = window.document.createElement("header");
    header.className = "ofv-msdoc-page-header ofv-msdoc-oasis-header";
    const logo = image ? $08414ea58bdc1292$var$createImageLogo(image) : $08414ea58bdc1292$var$createFallbackOasisLogo();
    header.append(logo);
    return header;
}
function $08414ea58bdc1292$var$createImageLogo(image) {
    const wrapper = window.document.createElement("div");
    wrapper.className = "ofv-msdoc-oasis-logo ofv-msdoc-oasis-logo-image";
    const img = window.document.createElement("img");
    img.src = image.dataUrl;
    img.alt = "OASIS";
    if (image.width) img.width = image.width;
    if (image.height) img.height = image.height;
    wrapper.append(img);
    return wrapper;
}
function $08414ea58bdc1292$var$createFallbackOasisLogo() {
    const logo = window.document.createElement("div");
    logo.className = "ofv-msdoc-oasis-logo";
    const word = window.document.createElement("span");
    word.textContent = "OASIS";
    const mark = window.document.createElement("span");
    mark.className = "ofv-msdoc-oasis-mark";
    mark.setAttribute("aria-hidden", "true");
    logo.append(word, mark);
    return logo;
}
function $08414ea58bdc1292$var$createPageFooter(footer, pageNumber, pageCount) {
    const element = window.document.createElement("footer");
    element.className = "ofv-msdoc-page-footer";
    const top = window.document.createElement("div");
    top.className = "ofv-msdoc-footer-row";
    const documentId = window.document.createElement("span");
    documentId.textContent = footer.documentId || "";
    const date = window.document.createElement("span");
    date.textContent = footer.date || "";
    top.append(documentId, date);
    const bottom = window.document.createElement("div");
    bottom.className = "ofv-msdoc-footer-row";
    const copyright = window.document.createElement("span");
    copyright.textContent = footer.copyright || "";
    const page = window.document.createElement("span");
    page.textContent = `Page ${pageNumber} of ${pageCount}`;
    bottom.append(copyright, page);
    element.append(top, bottom);
    return element;
}
function $08414ea58bdc1292$var$renderWordBlock(block) {
    if (block.type === "pageBreak") {
        const marker = window.document.createElement("span");
        marker.className = "ofv-msdoc-page-break";
        marker.hidden = true;
        return marker;
    }
    if ("runs" in block && block.runs) {
        const paragraph2 = window.document.createElement("p");
        paragraph2.className = "ofv-msdoc-inline-paragraph";
        for (const run of block.runs)if ("asset" in run) {
            const image = window.document.createElement("img");
            image.className = "ofv-msdoc-inline-image";
            image.src = run.asset.dataUrl;
            image.alt = run.asset.id;
            image.style.width = `calc(${run.width}px * var(--ofv-office-zoom, 1))`;
            image.style.height = `calc(${run.height}px * var(--ofv-office-zoom, 1))`;
            paragraph2.append(image);
        } else {
            const span = window.document.createElement("span");
            span.textContent = run.text;
            if (run.bold !== void 0) span.style.fontWeight = run.bold ? "700" : "400";
            if (run.fontSize) span.style.fontSize = `calc(${run.fontSize}pt * var(--ofv-office-zoom, 1))`;
            paragraph2.append(span);
        }
        return paragraph2;
    }
    if (block.type === "table") {
        const table = window.document.createElement("table");
        table.className = "ofv-msdoc-table";
        const revisionColumnWidths = $08414ea58bdc1292$var$getRevisionTableColumnWidths(block.rows);
        const noticeColumnWidths = block.columnWidths || $08414ea58bdc1292$var$getNoticeTableColumnWidths(block.rows);
        const renderRows = revisionColumnWidths || noticeColumnWidths ? block.rows : $08414ea58bdc1292$var$normalizeLegacyFormTableRows(block.rows);
        const isFormTable = renderRows.some((row)=>row.some((cell)=>$08414ea58bdc1292$var$getTableCellVariant(cell) !== void 0));
        if (revisionColumnWidths) {
            table.classList.add("ofv-msdoc-revision-table");
            const colgroup = window.document.createElement("colgroup");
            for (const width of revisionColumnWidths){
                const col = window.document.createElement("col");
                col.style.width = `calc(${width}px * var(--ofv-office-zoom, 1))`;
                colgroup.append(col);
            }
            table.append(colgroup);
        }
        if (noticeColumnWidths) {
            table.classList.add("ofv-msdoc-notice-table", `ofv-msdoc-notice-table-${noticeColumnWidths.length}`);
            const colgroup = window.document.createElement("colgroup");
            for (const width of noticeColumnWidths){
                const col = window.document.createElement("col");
                col.style.width = `${width}%`;
                colgroup.append(col);
            }
            table.append(colgroup);
        }
        if (isFormTable) table.classList.add("ofv-msdoc-form-table");
        const tbody = window.document.createElement("tbody");
        const hasHeaderRow = noticeColumnWidths ? $08414ea58bdc1292$var$getTableCellText(renderRows[0]?.[0] || "").replace(/\s+/g, "") === "\u5E8F\u53F7" : !isFormTable && renderRows.length > 1 && renderRows[0].every((cell)=>$08414ea58bdc1292$var$getTableCellText(cell).length <= 12);
        for (const row of renderRows){
            const tr = window.document.createElement("tr");
            const cellTag = hasHeaderRow && row === renderRows[0] ? "th" : "td";
            for(let cellIndex = 0; cellIndex < row.length; cellIndex += 1){
                const cellInfo = $08414ea58bdc1292$var$normalizeTableCell(row[cellIndex]);
                const cell = window.document.createElement(cellTag);
                cell.textContent = cellInfo.text;
                if (cellInfo.colSpan && cellInfo.colSpan > 1) cell.colSpan = cellInfo.colSpan;
                if (cellInfo.variant) cell.classList.add(`ofv-msdoc-form-${cellInfo.variant}`);
                if (cellTag === "td" && cellIndex % 2 === 0 && cellIndex + 1 < row.length && $08414ea58bdc1292$var$isShortChineseFormLabel(cellInfo.text)) cell.classList.add("ofv-msdoc-label-cell");
                if (row.length === 1 && (cellInfo.colSpan || 1) > 1) cell.classList.add("ofv-msdoc-span-cell");
                tr.append(cell);
            }
            tbody.append(tr);
        }
        table.append(tbody);
        return table;
    }
    if (block.type === "toc") {
        if (/^(?:\d+\s+){2,}\d+$/.test(block.title) && /^\d+$/.test(block.page || "")) {
            const ruler = window.document.createElement("p");
            ruler.className = "ofv-msdoc-code ofv-msdoc-code-ruler";
            for (const value of `${block.title} ${block.page}`.split(/\s+/)){
                const mark = window.document.createElement("span");
                mark.textContent = value;
                ruler.append(mark);
            }
            return ruler;
        }
        const paragraph2 = window.document.createElement("p");
        paragraph2.className = `ofv-msdoc-toc ofv-msdoc-toc-level-${block.level}`;
        const title = window.document.createElement("span");
        title.className = "ofv-msdoc-toc-title";
        const numberedTitle = block.title.match(/^(\d+(?:\.\d+)*)\s+(.+)$/);
        if (numberedTitle) {
            const number = window.document.createElement("span");
            number.className = "ofv-msdoc-toc-number";
            number.textContent = numberedTitle[1];
            title.append(number, numberedTitle[2]);
        } else title.textContent = block.title;
        paragraph2.append(title);
        if (block.page) {
            const leader = window.document.createElement("span");
            leader.className = "ofv-msdoc-toc-leader";
            const page = window.document.createElement("span");
            page.className = "ofv-msdoc-toc-page";
            page.textContent = block.page;
            paragraph2.append(leader, page);
        }
        return paragraph2;
    }
    const paragraph = window.document.createElement("p");
    const levelClass = block.type === "heading" ? ` ofv-msdoc-heading-level-${block.level}` : "";
    const listClass = block.type === "listItem" ? ` ofv-msdoc-list-level-${block.level}` : "";
    paragraph.className = `ofv-msdoc-${block.type}${levelClass}${listClass}${"indent" in block && block.indent ? " ofv-msdoc-indent" : ""}`;
    $08414ea58bdc1292$var$applyNoticeParagraphClass(paragraph, block);
    $08414ea58bdc1292$var$appendInlineRuns(paragraph, block.text, block.type === "code");
    return paragraph;
}
function $08414ea58bdc1292$var$applyNoticeParagraphClass(element, block) {
    const text = block.text.trim();
    if (/^[^：:]{2,45}[：:]$/.test(text)) element.classList.add("ofv-msdoc-notice-salutation");
    if (/^联系人[：:]/.test(text)) element.classList.add("ofv-msdoc-notice-contact");
    if (/^附件[：:]\s*\d+[.、．]/.test(text)) element.classList.add("ofv-msdoc-notice-attachment-first");
    if (/^\d+[.、．]/.test(text)) element.classList.add("ofv-msdoc-notice-attachment-item");
    if (/^附件\s*\d+$/.test(text)) element.classList.add("ofv-msdoc-notice-appendix-label");
    if (!/^(?:附件[：:]\s*)?\d+[.、．]/.test(text) && /^.{2,24}(?:清单|目录|名册|汇总表)$/.test(text)) element.classList.add("ofv-msdoc-notice-appendix-title");
    if (/^\d{4}年\d{1,2}月\d{1,2}日?$/.test(text)) element.classList.add("ofv-msdoc-notice-date");
    if (text.length <= 24 && /(?:人民政府|委员会|办公室|数据局|管理局|厅|局|委|办)$/.test(text)) element.classList.add("ofv-msdoc-notice-signature");
}
function $08414ea58bdc1292$var$getNoticeTableColumnWidths(rows) {
    const header = rows[0]?.map((cell)=>$08414ea58bdc1292$var$getTableCellText(cell).replace(/\s+/g, "")) || [];
    if (header[0] !== "\u5E8F\u53F7" || !header.includes("\u5E94\u7528\u540D\u79F0") || !header.includes("\u5730\u533A") || !header.includes("\u670D\u52A1\u4E3B\u4F53")) return void 0;
    if (header.length === 6) return [
        6,
        23,
        18,
        12,
        28,
        13
    ];
    if (header.length === 7) return [
        6,
        17,
        16,
        13,
        15,
        22,
        11
    ];
    return void 0;
}
function $08414ea58bdc1292$var$getOasisHeadingPrefix(text) {
    const headings = {
        Introduction: "1",
        Terminology: "1.1",
        "Word Styles": "2",
        "Overall Style": "2.1",
        "Title Page": "2.2",
        Headings: "2.3",
        Paragraphs: "2.4",
        Lists: "2.5",
        Tables: "2.6",
        "Code Examples": "2.7",
        "Character Styles": "2.8",
        References: "3",
        Normative: "3.1"
    };
    return headings[text];
}
function $08414ea58bdc1292$var$appendInlineRuns(element, text, preserveTabs = false) {
    if (preserveTabs) {
        $08414ea58bdc1292$var$appendInlineText(element, text, true);
        return;
    }
    const pattern = /(https?:\/\/\S+|[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}|\[[^\]]+\]|<\/?[A-Za-z][A-Za-z0-9:-]*>|(?:\b(?:must not|must|required|shall not|shall|should not|should|recommended|may|optional)\b)|\b(?:attributeNames|DataType|OtherKeyword|variable)\b)/gi;
    let offset = 0;
    for (const match of text.matchAll(pattern)){
        const value = match[0];
        const index = match.index || 0;
        if (index > offset) $08414ea58bdc1292$var$appendInlineText(element, text.slice(offset, index), preserveTabs);
        if (value.startsWith("[") && value.endsWith("]")) $08414ea58bdc1292$var$appendBracketRun(element, value);
        else if ($08414ea58bdc1292$var$isCodeStyleRun(value)) {
            const code = window.document.createElement("code");
            code.className = "ofv-msdoc-inline-code";
            code.textContent = value;
            element.append(code);
        } else if ($08414ea58bdc1292$var$isVariableStyleRun(value)) {
            const em = window.document.createElement("em");
            em.className = "ofv-msdoc-variable";
            em.textContent = value;
            element.append(em);
        } else if ($08414ea58bdc1292$var$isRequirementKeywordRun(value)) {
            const em = window.document.createElement("em");
            em.className = "ofv-msdoc-keyword";
            em.textContent = value;
            element.append(em);
        } else {
            const link = $08414ea58bdc1292$var$splitLinkRun(value);
            const anchor = window.document.createElement("a");
            anchor.className = "ofv-msdoc-link-text";
            anchor.href = link.href;
            anchor.target = "_blank";
            anchor.rel = "noreferrer noopener";
            anchor.textContent = link.text;
            element.append(anchor);
            if (link.trailing) $08414ea58bdc1292$var$appendInlineText(element, link.trailing, preserveTabs);
        }
        offset = index + value.length;
    }
    if (offset < text.length) $08414ea58bdc1292$var$appendInlineText(element, text.slice(offset), preserveTabs);
}
function $08414ea58bdc1292$var$appendBracketRun(element, value) {
    const tagName = $08414ea58bdc1292$var$isReferenceTerm(value) ? "strong" : "em";
    const run = window.document.createElement(tagName);
    run.className = $08414ea58bdc1292$var$isReferenceTerm(value) ? "ofv-msdoc-ref-term" : "ofv-msdoc-instruction-run";
    run.textContent = value;
    element.append(run);
}
function $08414ea58bdc1292$var$getRevisionTableColumnWidths(rows) {
    const header = rows[0]?.map((cell)=>$08414ea58bdc1292$var$getTableCellText(cell).toLowerCase());
    if (!header || header.length !== 4) return void 0;
    if (header[0] === "rev" && header[1] === "date" && /whom/.test(header[2]) && header[3] === "what") return [
        59,
        81,
        106,
        191
    ];
    return void 0;
}
function $08414ea58bdc1292$var$normalizeLegacyFormTableRows(rows) {
    if (rows.length === 0) return rows;
    const normalized = [];
    let index = 0;
    const leadingLabels = $08414ea58bdc1292$var$getLeadingFormLabels(rows);
    if (leadingLabels) {
        for(let offset = 0; offset < leadingLabels.length; offset += 2)normalized.push([
            $08414ea58bdc1292$var$createFormCell(leadingLabels[offset] || "", "label"),
            $08414ea58bdc1292$var$createFormCell("", "empty"),
            $08414ea58bdc1292$var$createFormCell(leadingLabels[offset + 1] || "", "label"),
            $08414ea58bdc1292$var$createFormCell("", "empty")
        ]);
        index = 2;
    }
    for(; index < rows.length; index += 1){
        const sectionRows = $08414ea58bdc1292$var$splitFormSectionRow(rows[index]);
        normalized.push(...sectionRows || [
            rows[index].map((cell)=>$08414ea58bdc1292$var$normalizeTableCell(cell))
        ]);
    }
    return normalized;
}
function $08414ea58bdc1292$var$isLegacyFormTable(rows) {
    return $08414ea58bdc1292$var$normalizeLegacyFormTableRows(rows).some((row)=>row.some((cell)=>$08414ea58bdc1292$var$getTableCellVariant(cell) !== void 0));
}
function $08414ea58bdc1292$var$getLeadingFormLabels(rows) {
    if (rows.length < 3 || rows[0].length !== 3 || rows[1].length !== 3 || !$08414ea58bdc1292$var$isFormSectionRow(rows[2])) return void 0;
    const labels = [
        ...rows[0],
        ...rows[1]
    ].map($08414ea58bdc1292$var$getTableCellText);
    return labels.length === 6 && labels.every($08414ea58bdc1292$var$isShortChineseFormLabel) ? labels : void 0;
}
function $08414ea58bdc1292$var$splitFormSectionRow(row) {
    const cells = row.map($08414ea58bdc1292$var$normalizeTableCell).filter((cell)=>cell.text.length > 0);
    const sectionIndex = cells.findIndex((cell)=>$08414ea58bdc1292$var$isChineseSectionTitle(cell.text));
    const gradeIndex = cells.findIndex((cell, index)=>index > sectionIndex && $08414ea58bdc1292$var$isGradeCell(cell.text));
    if (sectionIndex < 0 || gradeIndex < 0) return void 0;
    const output = [];
    const leadingText = cells.slice(0, sectionIndex).map((cell)=>cell.text).join(" ").trim();
    if (leadingText) output.push([
        $08414ea58bdc1292$var$createFormCell(leadingText, "body", 4)
    ]);
    output.push([
        $08414ea58bdc1292$var$createFormCell(cells[sectionIndex].text, "section", 2),
        $08414ea58bdc1292$var$createFormCell(cells[gradeIndex].text, "section", 2)
    ]);
    const trailingText = cells.slice(gradeIndex + 1).map((cell)=>cell.text).join(" ").trim();
    if (trailingText) output.push([
        $08414ea58bdc1292$var$createFormCell(trailingText, "caption", 4)
    ]);
    return output;
}
function $08414ea58bdc1292$var$isFormSectionRow(row) {
    return $08414ea58bdc1292$var$splitFormSectionRow(row) !== void 0;
}
function $08414ea58bdc1292$var$createFormCell(text, variant, colSpan) {
    return {
        text: text,
        variant: variant,
        colSpan: colSpan
    };
}
function $08414ea58bdc1292$var$normalizeTableCell(cell) {
    return typeof cell === "string" ? {
        text: cell
    } : cell;
}
function $08414ea58bdc1292$var$getTableCellText(cell) {
    return $08414ea58bdc1292$var$normalizeTableCell(cell).text.trim();
}
function $08414ea58bdc1292$var$getTableCellVariant(cell) {
    return $08414ea58bdc1292$var$normalizeTableCell(cell).variant;
}
function $08414ea58bdc1292$var$isShortChineseFormLabel(text) {
    const value = text.trim();
    return value.length > 0 && value.length <= 8 && /\p{Script=Han}/u.test(value) && !/[。；，、：:]/.test(value);
}
function $08414ea58bdc1292$var$isChineseSectionTitle(text) {
    return /^[一二三四五六七八九十]+、\S+/.test(text.trim());
}
function $08414ea58bdc1292$var$isGradeCell(text) {
    return /^成绩[:：]?$/.test(text.trim());
}
function $08414ea58bdc1292$var$appendInlineText(element, text, preserveTabs) {
    element.append(window.document.createTextNode(preserveTabs ? text : text.replace(/\t+/g, " ")));
}
function $08414ea58bdc1292$var$isReferenceTerm(value) {
    return /^\[[A-Z0-9][A-Z0-9.-]{1,24}\]$/.test(value);
}
function $08414ea58bdc1292$var$isCodeStyleRun(value) {
    return /^<\/?[A-Za-z][A-Za-z0-9:-]*>$/.test(value) || /^(?:attributeNames|DataType|OtherKeyword)$/.test(value);
}
function $08414ea58bdc1292$var$isVariableStyleRun(value) {
    return value === "variable";
}
function $08414ea58bdc1292$var$isRequirementKeywordRun(value) {
    return /^(?:must not|must|required|shall not|shall|should not|should|recommended|may|optional)$/i.test(value);
}
function $08414ea58bdc1292$var$splitLinkRun(value) {
    let text = value;
    let trailing = "";
    while(/[),.;:]$/.test(text)){
        trailing = text.slice(-1) + trailing;
        text = text.slice(0, -1);
    }
    const href = /^https?:\/\//i.test(text) ? text : `mailto:${text}`;
    return {
        text: text,
        href: href,
        trailing: trailing
    };
}
function $08414ea58bdc1292$var$extractImageAssets(cfb) {
    const assets = [];
    const seen = /* @__PURE__ */ new Set();
    for (const entry of cfb.entries){
        if (entry.type !== 2) continue;
        const stream = cfb.getStream(entry.name);
        if (!stream || stream.length < 16) continue;
        for (const image of $08414ea58bdc1292$var$extractImagesFromBytes(stream, entry.name)){
            const key = `data:${image.mimeType};base64,${$08414ea58bdc1292$var$bytesToBase64(image.bytes)}`;
            if (seen.has(key)) continue;
            seen.add(key);
            const id = `image-${assets.length + 1}`;
            assets.push({
                id: id,
                kind: "image",
                mimeType: image.mimeType,
                dataUrl: key,
                width: image.width,
                height: image.height
            });
        }
    }
    return assets;
}
function $08414ea58bdc1292$var$parseStyleTable(tableStream, fib) {
    if (fib.lcbStshf <= 0 || fib.fcStshf < 0 || fib.fcStshf >= tableStream.length) return [];
    const bytes = tableStream.subarray(fib.fcStshf, Math.min(tableStream.length, fib.fcStshf + fib.lcbStshf));
    if (bytes.length < 8) return [];
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    const cbStshi = view3.getUint16(0, true);
    const stshiOffset = 2;
    const cstd = stshiOffset + 2 <= bytes.length ? view3.getUint16(stshiOffset, true) : 0;
    const cbSTDBaseInFile = stshiOffset + 4 <= bytes.length ? view3.getUint16(stshiOffset + 2, true) : 10;
    let offset = 2 + cbStshi;
    const styles = [];
    for(let id = 0; id < cstd && offset + 2 <= bytes.length; id += 1){
        const cbStd = view3.getUint16(offset, true);
        const stdStart = offset + 2;
        const stdEnd = stdStart + cbStd;
        if (cbStd > 0 && stdStart < bytes.length) {
            const style = $08414ea58bdc1292$var$parseStyleDefinition(bytes.subarray(stdStart, Math.min(stdEnd, bytes.length)), Math.max(10, cbSTDBaseInFile), id);
            if (style.name) styles.push(style);
        }
        offset = $08414ea58bdc1292$var$alignEven(stdEnd);
    }
    return styles;
}
function $08414ea58bdc1292$var$parseStyleDefinition(bytes, baseSize, id) {
    const base = bytes.length >= 6 ? $08414ea58bdc1292$var$parseStyleBase(bytes) : void 0;
    const nameOffset = Math.min(bytes.length, Math.max(10, baseSize));
    const name = $08414ea58bdc1292$var$parseXstz(bytes, nameOffset);
    return {
        id: id,
        name: name,
        type: $08414ea58bdc1292$var$styleTypeFromStk(base?.stk),
        basedOn: base?.basedOn,
        next: base?.next
    };
}
function $08414ea58bdc1292$var$parseStyleBase(bytes) {
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    const w2 = view3.getUint16(2, true);
    const w3 = view3.getUint16(4, true);
    return {
        stk: w2 & 15,
        basedOn: w2 >> 4 & 4095,
        next: w3 >> 4 & 4095
    };
}
function $08414ea58bdc1292$var$styleTypeFromStk(stk) {
    if (stk === 1) return "paragraph";
    if (stk === 2) return "character";
    if (stk === 3) return "table";
    if (stk === 4) return "numbering";
    return "unknown";
}
function $08414ea58bdc1292$var$parseXstz(bytes, offset) {
    if (offset + 2 > bytes.length) return "";
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    const charCount = view3.getUint16(offset, true);
    const start = offset + 2;
    const end = Math.min(bytes.length, start + charCount * 2);
    if (end <= start) return "";
    return $08414ea58bdc1292$var$decodeUtf16Le(bytes.subarray(start, end)).replace(/\0+$/g, "");
}
function $08414ea58bdc1292$var$extractImagesFromBytes(bytes, sourceName) {
    const images = [];
    for (const start of $08414ea58bdc1292$var$findSignatureOffsets(bytes, $08414ea58bdc1292$var$PNG_SIGNATURE)){
        const end = $08414ea58bdc1292$var$findPngEnd(bytes, start);
        if (end > start) {
            const imageBytes = bytes.slice(start, end);
            const dimensions = $08414ea58bdc1292$var$readPngDimensions(imageBytes);
            images.push({
                bytes: imageBytes,
                mimeType: "image/png",
                width: dimensions?.width,
                height: dimensions?.height
            });
        }
    }
    for (const start of $08414ea58bdc1292$var$findSignatureOffsets(bytes, $08414ea58bdc1292$var$JPEG_SIGNATURE)){
        const end = $08414ea58bdc1292$var$findJpegEnd(bytes, start);
        if (end > start) images.push({
            bytes: bytes.slice(start, end),
            mimeType: "image/jpeg"
        });
    }
    if (/picture|image|data/i.test(sourceName)) {
        const gifStart = bytes.findIndex((byte, index)=>index + 4 <= bytes.length && bytes[index] === 71 && bytes[index + 1] === 73 && bytes[index + 2] === 70 && bytes[index + 3] === 56);
        if (gifStart >= 0) images.push({
            bytes: bytes.slice(gifStart),
            mimeType: "image/gif"
        });
    }
    return images;
}
var $08414ea58bdc1292$var$PNG_SIGNATURE = Uint8Array.from([
    137,
    80,
    78,
    71,
    13,
    10,
    26,
    10
]);
var $08414ea58bdc1292$var$JPEG_SIGNATURE = Uint8Array.from([
    255,
    216,
    255
]);
function $08414ea58bdc1292$var$findSignatureOffsets(bytes, signature) {
    const offsets = [];
    for(let index = 0; index <= bytes.length - signature.length; index += 1){
        let matches = true;
        for(let sigIndex = 0; sigIndex < signature.length; sigIndex += 1)if (bytes[index + sigIndex] !== signature[sigIndex]) {
            matches = false;
            break;
        }
        if (matches) offsets.push(index);
    }
    return offsets;
}
function $08414ea58bdc1292$var$findPngEnd(bytes, start) {
    for(let offset = start + $08414ea58bdc1292$var$PNG_SIGNATURE.length; offset + 12 <= bytes.length;){
        const length = $08414ea58bdc1292$var$readUint32Be3(bytes, offset);
        const typeOffset = offset + 4;
        const next = offset + 12 + length;
        if (next > bytes.length) return 0;
        if (bytes[typeOffset] === 73 && bytes[typeOffset + 1] === 69 && bytes[typeOffset + 2] === 78 && bytes[typeOffset + 3] === 68) return next;
        offset = next;
    }
    return 0;
}
function $08414ea58bdc1292$var$findJpegEnd(bytes, start) {
    for(let index = start + 2; index + 1 < bytes.length; index += 1){
        if (bytes[index] === 255 && bytes[index + 1] === 217) return index + 2;
    }
    return 0;
}
function $08414ea58bdc1292$var$readPngDimensions(bytes) {
    if (bytes.length < 24 || !$08414ea58bdc1292$var$PNG_SIGNATURE.every((value, index)=>bytes[index] === value)) return void 0;
    return {
        width: $08414ea58bdc1292$var$readUint32Be3(bytes, 16),
        height: $08414ea58bdc1292$var$readUint32Be3(bytes, 20)
    };
}
function $08414ea58bdc1292$var$readUint32Be3(bytes, offset) {
    return (bytes[offset] << 24 | bytes[offset + 1] << 16 | bytes[offset + 2] << 8 | bytes[offset + 3]) >>> 0;
}
function $08414ea58bdc1292$var$bytesToBase64(bytes) {
    let binary = "";
    const chunkSize = 32768;
    for(let offset = 0; offset < bytes.length; offset += chunkSize)binary += String.fromCharCode(...bytes.subarray(offset, Math.min(bytes.length, offset + chunkSize)));
    return btoa(binary);
}
function $08414ea58bdc1292$var$parseCompoundFile(bytes) {
    if (!$08414ea58bdc1292$var$hasCompoundSignature(bytes)) throw new Error("\u4E0D\u662F\u6807\u51C6 OLE Compound File");
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    const sectorSize = 1 << view3.getUint16(30, true);
    const miniSectorSize = 1 << view3.getUint16(32, true);
    const fatSectorCount = view3.getUint32(44, true);
    const firstDirectorySector = view3.getUint32(48, true);
    const miniStreamCutoff = view3.getUint32(56, true) || $08414ea58bdc1292$var$MINI_STREAM_CUTOFF;
    const firstMiniFatSector = view3.getUint32(60, true);
    const miniFatSectorCount = view3.getUint32(64, true);
    const firstDifatSector = view3.getUint32(68, true);
    const difatSectorCount = view3.getUint32(72, true);
    const difat = $08414ea58bdc1292$var$readDifat(view3, sectorSize, firstDifatSector, difatSectorCount);
    const fat = $08414ea58bdc1292$var$readFat(view3, sectorSize, difat.slice(0, fatSectorCount));
    const directoryBytes = $08414ea58bdc1292$var$readRegularStream(bytes, sectorSize, fat, firstDirectorySector);
    const entries = $08414ea58bdc1292$var$parseDirectoryEntries(directoryBytes);
    const root = entries.find((entry)=>entry.type === 5);
    const miniStream = root ? $08414ea58bdc1292$var$readRegularStream(bytes, sectorSize, fat, root.startSector, root.size) : new Uint8Array();
    const miniFat = firstMiniFatSector < $08414ea58bdc1292$var$END_OF_CHAIN ? $08414ea58bdc1292$var$readFat(view3, sectorSize, $08414ea58bdc1292$var$sectorChain(fat, firstMiniFatSector).slice(0, miniFatSectorCount)) : [];
    return {
        entries: entries,
        getStream (name) {
            const wanted = $08414ea58bdc1292$var$normalizeStreamName(name);
            const entry = entries.find((item)=>item.type === 2 && $08414ea58bdc1292$var$normalizeStreamName(item.name) === wanted);
            if (!entry) return void 0;
            if (entry.size < miniStreamCutoff && miniFat.length > 0) return $08414ea58bdc1292$var$readMiniStream(miniStream, miniSectorSize, miniFat, entry.startSector, entry.size);
            return $08414ea58bdc1292$var$readRegularStream(bytes, sectorSize, fat, entry.startSector, entry.size);
        }
    };
}
function $08414ea58bdc1292$var$hasCompoundSignature(bytes) {
    return $08414ea58bdc1292$var$CFB_SIGNATURE.every((value, index)=>bytes[index] === value);
}
function $08414ea58bdc1292$var$readDifat(view3, sectorSize, firstDifatSector, difatSectorCount) {
    const difat = [];
    for(let offset = 76; offset < 512; offset += 4){
        const sector = view3.getUint32(offset, true);
        if ($08414ea58bdc1292$var$isUsableSector(sector)) difat.push(sector);
    }
    let next = firstDifatSector;
    for(let index = 0; index < difatSectorCount && $08414ea58bdc1292$var$isUsableSector(next); index += 1){
        const offset = $08414ea58bdc1292$var$sectorOffset(next, sectorSize);
        const entriesPerSector = sectorSize / 4 - 1;
        for(let item = 0; item < entriesPerSector; item += 1){
            const sector = view3.getUint32(offset + item * 4, true);
            if ($08414ea58bdc1292$var$isUsableSector(sector)) difat.push(sector);
        }
        next = view3.getUint32(offset + entriesPerSector * 4, true);
    }
    return difat;
}
function $08414ea58bdc1292$var$readFat(view3, sectorSize, sectors) {
    const fat = [];
    for (const sector of sectors){
        if (!$08414ea58bdc1292$var$isUsableSector(sector) && sector !== $08414ea58bdc1292$var$FAT_SECTOR && sector !== $08414ea58bdc1292$var$DIFAT_SECTOR) continue;
        const offset = $08414ea58bdc1292$var$sectorOffset(sector, sectorSize);
        for(let item = 0; item < sectorSize / 4; item += 1)fat.push(view3.getUint32(offset + item * 4, true));
    }
    return fat;
}
function $08414ea58bdc1292$var$parseDirectoryEntries(bytes) {
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    const entries = [];
    for(let offset = 0; offset + 128 <= bytes.length; offset += 128){
        const nameLength = view3.getUint16(offset + 64, true);
        const type = bytes[offset + 66] || 0;
        if (type === 0 || nameLength < 2) continue;
        const nameBytes = bytes.subarray(offset, offset + Math.max(0, nameLength - 2));
        const name = $08414ea58bdc1292$var$decodeUtf16Le(nameBytes).replace(/\0+$/g, "");
        const startSector = view3.getUint32(offset + 116, true);
        const lowSize = view3.getUint32(offset + 120, true);
        const highSize = view3.getUint32(offset + 124, true);
        const size = highSize > 0 ? Number(BigInt(highSize) << 32n) + lowSize : lowSize;
        entries.push({
            name: name,
            type: type,
            startSector: startSector,
            size: size
        });
    }
    return entries;
}
function $08414ea58bdc1292$var$readRegularStream(bytes, sectorSize, fat, startSector, size) {
    const chunks = [];
    for (const sector of $08414ea58bdc1292$var$sectorChain(fat, startSector)){
        const offset = $08414ea58bdc1292$var$sectorOffset(sector, sectorSize);
        chunks.push(bytes.subarray(offset, Math.min(bytes.length, offset + sectorSize)));
    }
    return $08414ea58bdc1292$var$concatChunks(chunks, size);
}
function $08414ea58bdc1292$var$readMiniStream(miniStream, miniSectorSize, miniFat, startSector, size) {
    const chunks = [];
    for (const sector of $08414ea58bdc1292$var$sectorChain(miniFat, startSector)){
        const offset = sector * miniSectorSize;
        chunks.push(miniStream.subarray(offset, Math.min(miniStream.length, offset + miniSectorSize)));
    }
    return $08414ea58bdc1292$var$concatChunks(chunks, size);
}
function $08414ea58bdc1292$var$sectorChain(fat, startSector) {
    const chain = [];
    const seen = /* @__PURE__ */ new Set();
    let current = startSector;
    while($08414ea58bdc1292$var$isUsableSector(current) && current < fat.length && !seen.has(current)){
        seen.add(current);
        chain.push(current);
        current = fat[current];
    }
    return chain;
}
function $08414ea58bdc1292$var$parseFib(wordDocument) {
    const view3 = $08414ea58bdc1292$var$dataView(wordDocument);
    if (view3.getUint16(0, true) !== 42476) throw new Error("WordDocument FIB \u6807\u8BC6\u65E0\u6548");
    const flags = view3.getUint16(10, true);
    const fcMin = view3.getUint32(24, true);
    const fcMac = view3.getUint32(28, true);
    let offset = 32;
    const csw = view3.getUint16(offset, true);
    offset += 2 + csw * 2;
    const fibRgLwOffset = offset + 2;
    const cslw = view3.getUint16(offset, true);
    const ccpText = fibRgLwOffset + 16 <= wordDocument.length ? Math.max(0, view3.getInt32(fibRgLwOffset + 12, true)) : 0;
    offset += 2 + cslw * 4;
    const cbRgFcLcb = view3.getUint16(offset, true);
    const fcLcbOffset = offset + 2;
    const pair = (index, length = false)=>index < cbRgFcLcb && fcLcbOffset + index * 8 + 8 <= wordDocument.length ? view3.getUint32(fcLcbOffset + index * 8 + (length ? 4 : 0), true) : 0;
    return {
        fcChpx: pair(12),
        lcbChpx: pair(12, true),
        fcSed: pair(6),
        lcbSed: pair(6, true),
        encrypted: (flags & 256) !== 0,
        useOneTable: (flags & 512) !== 0,
        textIsUnicode: (flags & 4096) !== 0,
        fcMin: fcMin,
        fcMac: fcMac,
        ccpText: ccpText,
        fcStshf: pair($08414ea58bdc1292$var$STSH_FC_LCB_INDEX),
        lcbStshf: pair($08414ea58bdc1292$var$STSH_FC_LCB_INDEX, true),
        fcClx: pair($08414ea58bdc1292$var$CLX_FC_LCB_INDEX),
        lcbClx: pair($08414ea58bdc1292$var$CLX_FC_LCB_INDEX, true)
    };
}
function $08414ea58bdc1292$var$parseClxPieces(tableStream, fcClx, lcbClx) {
    if (lcbClx <= 0 || fcClx < 0 || fcClx >= tableStream.length) return [];
    const end = Math.min(tableStream.length, fcClx + lcbClx);
    const view3 = $08414ea58bdc1292$var$dataView(tableStream);
    let offset = fcClx;
    while(offset < end){
        const marker = tableStream[offset];
        if (marker === 1) {
            const size = offset + 3 <= end ? view3.getUint16(offset + 1, true) : 0;
            offset += 3 + size;
            continue;
        }
        if (marker === 2) {
            if (offset + 5 > end) break;
            const plcSize = view3.getUint32(offset + 1, true);
            const plcOffset = offset + 5;
            return $08414ea58bdc1292$var$parsePlcPcd(tableStream, plcOffset, Math.min(end, plcOffset + plcSize));
        }
        offset += 1;
    }
    return [];
}
function $08414ea58bdc1292$var$parsePlcPcd(tableStream, offset, end) {
    const size = end - offset;
    if (size < 16 || (size - 4) % 12 !== 0) return [];
    const view3 = $08414ea58bdc1292$var$dataView(tableStream);
    const pieceCount = Math.floor((size - 4) / 12);
    const pcdOffset = offset + (pieceCount + 1) * 4;
    const pieces = [];
    for(let index = 0; index < pieceCount; index += 1){
        const cpStart = view3.getUint32(offset + index * 4, true);
        const cpEnd = view3.getUint32(offset + (index + 1) * 4, true);
        const descriptorOffset = pcdOffset + index * 8;
        const fcCompressed = view3.getUint32(descriptorOffset + 2, true);
        const compressed = (fcCompressed & 1073741824) !== 0;
        const fileOffset = compressed ? (fcCompressed & 1073741823) / 2 : fcCompressed;
        if (cpEnd > cpStart) pieces.push({
            cpStart: cpStart,
            cpEnd: cpEnd,
            fileOffset: fileOffset,
            compressed: compressed
        });
    }
    return pieces;
}
function $08414ea58bdc1292$var$readPieceTableText(wordDocument, pieces, ccpText) {
    let output = "";
    for (const piece of pieces){
        const cpEnd = ccpText > 0 ? Math.min(piece.cpEnd, ccpText) : piece.cpEnd;
        const charCount = Math.max(0, cpEnd - piece.cpStart);
        if (charCount === 0) continue;
        const byteLength = charCount * (piece.compressed ? 1 : 2);
        const bytes = wordDocument.subarray(piece.fileOffset, Math.min(wordDocument.length, piece.fileOffset + byteLength));
        output += piece.compressed ? $08414ea58bdc1292$var$decodeWindows1252(bytes) : $08414ea58bdc1292$var$decodeUtf16Le(bytes);
    }
    return output;
}
function $08414ea58bdc1292$var$readFibTextFallback(wordDocument, fib) {
    const bytes = wordDocument.subarray(fib.fcMin, Math.min(wordDocument.length, fib.fcMac));
    return fib.textIsUnicode ? $08414ea58bdc1292$var$decodeUtf16Le(bytes) : $08414ea58bdc1292$var$decodeWindows1252(bytes);
}
function $08414ea58bdc1292$var$readWordProperties(bytes) {
    const result = [];
    const view3 = $08414ea58bdc1292$var$dataView(bytes);
    for(let offset = 0; offset + 2 <= bytes.length;){
        const code = view3.getUint16(offset, true);
        offset += 2;
        const sizeClass = code >>> 13;
        let size = [
            1,
            1,
            2,
            4,
            2,
            2,
            0,
            3
        ][sizeClass];
        if (sizeClass === 6) {
            if (offset >= bytes.length) break;
            if (code === 54792 || code === 50709) break;
            size = bytes[offset++];
        }
        if (offset + size > bytes.length) break;
        result.push({
            code: code,
            value: bytes.subarray(offset, offset + size)
        });
        offset += size;
    }
    return result;
}
function $08414ea58bdc1292$var$readInlineWordContext(word, table, data, fib, pieces, assets) {
    if (!data || fib.lcbChpx < 12 || (fib.lcbChpx - 4) % 8 !== 0 || fib.fcChpx + fib.lcbChpx > table.length) return;
    const ranges = [];
    const count = (fib.lcbChpx - 4) / 8;
    const tableView = $08414ea58bdc1292$var$dataView(table);
    for(let index = 0; index < count; index++){
        const page = tableView.getUint32(fib.fcChpx + (count + 1) * 4 + index * 4, true) * 512;
        if (page + 512 > word.length) continue;
        const fkp = word.subarray(page, page + 512);
        const view3 = $08414ea58bdc1292$var$dataView(fkp);
        const runs = fkp[511];
        const headerSize = (runs + 1) * 4 + runs;
        if (headerSize > 511) continue;
        for(let run = 0; run < runs; run++){
            const offset = fkp[(runs + 1) * 4 + run] * 2;
            if (offset === 0 || offset < headerSize || offset + 1 + fkp[offset] > 511) continue;
            ranges.push({
                start: view3.getUint32(run * 4, true),
                end: view3.getUint32(run * 4 + 4, true),
                properties: $08414ea58bdc1292$var$readWordProperties(fkp.subarray(offset + 1, offset + 1 + fkp[offset]))
            });
        }
    }
    const propertiesAt = (cp)=>{
        const piece = pieces.find((item)=>cp >= item.cpStart && cp < item.cpEnd);
        const fc = piece ? piece.fileOffset + (cp - piece.cpStart) * (piece.compressed ? 1 : 2) : fib.fcMin + cp * (fib.textIsUnicode ? 2 : 1);
        return ranges.find((range)=>fc >= range.start && fc < range.end)?.properties || [];
    };
    const pictureCache = /* @__PURE__ */ new Map();
    const pictureAt = (cp)=>{
        const properties = propertiesAt(cp);
        if (properties.find((property)=>property.code === 2133)?.value[0] !== 1 || properties.find((property)=>property.code === 2054)?.value[0] === 1) return;
        const location = properties.find((property)=>property.code === 27139);
        if (!location || location.value.length !== 4) return;
        const offset = $08414ea58bdc1292$var$dataView(location.value).getUint32(0, true);
        if (pictureCache.has(offset)) return pictureCache.get(offset);
        pictureCache.set(offset, void 0);
        if (offset + 68 > data.length) return;
        const view3 = $08414ea58bdc1292$var$dataView(data.subarray(offset));
        const length = view3.getUint32(0, true);
        const headerSize = view3.getUint16(4, true);
        if (headerSize !== 68 || view3.getUint16(6, true) !== 100 || length < headerSize || offset + length > data.length) return;
        const width = view3.getInt16(28, true) * view3.getUint16(32, true) / 15e3;
        const height = view3.getInt16(30, true) * view3.getUint16(34, true) / 15e3;
        if (width <= 0 || height <= 0 || width > 2112 || height > 2112) return;
        const image = $08414ea58bdc1292$var$extractImagesFromBytes(data.subarray(offset + headerSize, offset + length), "Data")[0];
        if (!image) return;
        const dataUrl = `data:${image.mimeType};base64,${$08414ea58bdc1292$var$bytesToBase64(image.bytes)}`;
        const asset = assets.find((item)=>item.dataUrl === dataUrl);
        if (!asset) return;
        const run = {
            asset: asset,
            width: width,
            height: height
        };
        pictureCache.set(offset, run);
        return run;
    };
    return {
        paragraphRuns (text, startCp) {
            if (!text.includes("")) return;
            const runs = [];
            let hasImage = false;
            for(let index = 0; index < text.length; index++){
                if (text[index] === "") {
                    const image = pictureAt(startCp + index);
                    if (image) {
                        runs.push(image);
                        hasImage = true;
                    }
                    continue;
                }
                if (/[\u0000-\u0008\u000e-\u001f]/.test(text[index])) continue;
                const properties = propertiesAt(startCp + index);
                const boldValue = properties.find((property)=>property.code === 2101)?.value[0];
                const bold = boldValue === 0 || boldValue === 1 ? Boolean(boldValue) : void 0;
                const sizeValue = properties.find((property)=>property.code === 19011)?.value;
                const fontSize = sizeValue ? $08414ea58bdc1292$var$dataView(sizeValue).getUint16(0, true) / 2 : void 0;
                const previous = runs[runs.length - 1];
                if (previous && "text" in previous && previous.bold === bold && previous.fontSize === fontSize) previous.text += text[index];
                else runs.push({
                    text: text[index],
                    bold: bold,
                    fontSize: fontSize
                });
            }
            return hasImage ? runs : void 0;
        }
    };
}
function $08414ea58bdc1292$var$readWordPageGeometry(word, table, fib) {
    if (fib.lcbSed < 20 || (fib.lcbSed - 4) % 16 !== 0 || fib.fcSed + fib.lcbSed > table.length) return;
    const count = (fib.lcbSed - 4) / 16;
    if (count !== 1) return;
    const offset = $08414ea58bdc1292$var$dataView(table).getUint32(fib.fcSed + (count + 1) * 4 + 2, true);
    if (offset + 2 > word.length) return;
    const size = $08414ea58bdc1292$var$dataView(word).getUint16(offset, true);
    if (offset + 2 + size > word.length) return;
    const properties = $08414ea58bdc1292$var$readWordProperties(word.subarray(offset + 2, offset + 2 + size));
    const value = (code, fallback)=>{
        const property = properties.find((item)=>item.code === code);
        return property && property.value.length === 2 ? $08414ea58bdc1292$var$dataView(property.value).getInt16(0, true) / 15 : fallback;
    };
    const geometry = {
        width: value(45087, 816),
        height: value(45088, 1056),
        left: value(45089, 120),
        right: value(45090, 120),
        top: value(36899, 96),
        bottom: value(36900, 96)
    };
    if (Object.values(geometry).some((number)=>!Number.isFinite(number) || number < 0) || geometry.width <= geometry.left + geometry.right || geometry.height <= geometry.top + geometry.bottom) return;
    return geometry;
}
function $08414ea58bdc1292$var$segmentWordText(text, inline) {
    const normalized = text.replace(/\u000b/g, "\n");
    const segments = [];
    let cells = null;
    let buffer = "";
    let bufferStart = 0;
    const flushParagraphs = ()=>{
        let offset = 0;
        for (const piece of buffer.split(/(\n{2,})/)){
            const cleaned = $08414ea58bdc1292$var$cleanWordText(piece);
            const runs = inline?.paragraphRuns(piece, bufferStart + offset);
            if (runs || cleaned.length > 0 && $08414ea58bdc1292$var$isDisplayableParagraph(cleaned)) segments.push({
                kind: "paragraph",
                text: cleaned,
                ...runs ? {
                    runs: runs
                } : {}
            });
            offset += piece.length;
        }
        buffer = "";
    };
    const pushCell = ()=>{
        cells = cells || [];
        cells.push($08414ea58bdc1292$var$cleanWordCellText(buffer));
        buffer = "";
    };
    const endRow = ()=>{
        const rowCells = cells || [];
        cells = null;
        if (rowCells.some((cell)=>cell.length > 0)) segments.push({
            kind: "row",
            cells: rowCells
        });
    };
    for(let index = 0; index < normalized.length; index += 1){
        const char = normalized[index];
        if (char === "\x07") {
            let run = 1;
            while(normalized[index + run] === "\x07")run += 1;
            pushCell();
            for(let extra = 0; extra < run - 2; extra += 1)pushCell();
            if (run >= 2) endRow();
            index += run - 1;
            continue;
        }
        if (char === "\r") {
            cells === null ? flushParagraphs() : buffer += "\n";
            continue;
        }
        if (char === "\f") {
            if (cells === null) {
                flushParagraphs();
                segments.push({
                    kind: "pageBreak"
                });
            } else buffer += "\n";
            continue;
        }
        if (buffer.length === 0) bufferStart = index;
        buffer += char;
    }
    cells === null ? flushParagraphs() : endRow();
    return segments.slice(0, 1e3);
}
function $08414ea58bdc1292$var$cleanWordCellText(value) {
    return value.split("\n").map((line)=>$08414ea58bdc1292$var$cleanWordText(line)).filter((line)=>line.length > 0).join("\n");
}
function $08414ea58bdc1292$var$segmentsToParagraphs(segments) {
    return segments.map($08414ea58bdc1292$var$segmentDisplayText).filter((text)=>text.length > 0).slice(0, 1e3);
}
function $08414ea58bdc1292$var$segmentDisplayText(segment) {
    if (segment.kind === "pageBreak") return $08414ea58bdc1292$var$WORD_PAGE_BREAK;
    return segment.kind === "row" ? segment.cells.filter((cell)=>cell.length > 0).join("	") : segment.text;
}
function $08414ea58bdc1292$var$removeTrailingFooterSegments(segments) {
    const paragraphs = segments.map($08414ea58bdc1292$var$segmentDisplayText);
    const tailStart = Math.max(0, paragraphs.length - 32);
    const tail = paragraphs.slice(tailStart);
    const relativePageFieldIndex = tail.findIndex($08414ea58bdc1292$var$isFooterPageField);
    if (relativePageFieldIndex < 0) return segments;
    let start = tailStart + relativePageFieldIndex;
    for(let index = start - 1; index >= tailStart; index -= 1){
        const paragraph = paragraphs[index];
        if (paragraph === $08414ea58bdc1292$var$WORD_PAGE_BREAK || $08414ea58bdc1292$var$isLikelyFooterArtifact(paragraph)) {
            start = index;
            continue;
        }
        break;
    }
    const artifactSlice = paragraphs.slice(start);
    const footerCueCount = artifactSlice.filter($08414ea58bdc1292$var$isLikelyFooterArtifact).length;
    if (footerCueCount < 2) return segments;
    return segments.slice(0, start);
}
function $08414ea58bdc1292$var$isFooterPageField(paragraph) {
    return /^(?:PAGE|Page)(?:\s+(?:PAGE|\d+))?(?:\s+of\s+(?:NUMPAGES|\d+))?$/i.test(paragraph.trim()) || /\bNUMPAGES\b/i.test(paragraph);
}
function $08414ea58bdc1292$var$isLikelyFooterArtifact(paragraph) {
    const value = paragraph.trim();
    return value === $08414ea58bdc1292$var$WORD_PAGE_BREAK || $08414ea58bdc1292$var$isFooterPageField(value) || /^wd-[\w.-]+$/i.test(value) || /^\d{1,2}\s+[A-Za-z]+\s+\d{4}$/.test(value) || /^Copyright\s+©?\s*(?:OASIS|2002 OASIS)/i.test(value);
}
function $08414ea58bdc1292$var$buildWordBlocks(segments) {
    const blocks = [];
    let index = 0;
    while(index < segments.length){
        const segment = segments[index];
        if (segment.kind === "pageBreak") {
            blocks.push({
                type: "pageBreak"
            });
            index += 1;
            continue;
        }
        if (segment.kind === "row") {
            const rows = [];
            while(index < segments.length){
                const rowSegment = segments[index];
                if (rowSegment.kind !== "row") break;
                rows.push(rowSegment.cells);
                index += 1;
            }
            blocks.push({
                type: "table",
                rows: $08414ea58bdc1292$var$applyTableColumnSpans(rows)
            });
            continue;
        }
        if (segment.runs) {
            blocks.push({
                type: "paragraph",
                text: segment.text,
                runs: segment.runs
            });
            index += 1;
            continue;
        }
        const paragraph = segment.text;
        const toc = $08414ea58bdc1292$var$parseTocEntry(paragraph);
        if (toc) {
            blocks.push(toc);
            index += 1;
            continue;
        }
        if ($08414ea58bdc1292$var$isTableRowCandidate(paragraph)) {
            const rows = [];
            while(index < segments.length){
                const tabSegment = segments[index];
                if (tabSegment.kind !== "paragraph" || !$08414ea58bdc1292$var$isTableRowCandidate(tabSegment.text)) break;
                rows.push(...$08414ea58bdc1292$var$normalizeTableRows($08414ea58bdc1292$var$splitTableRow(tabSegment.text)));
                index += 1;
            }
            blocks.push({
                type: "table",
                rows: rows
            });
            continue;
        }
        blocks.push($08414ea58bdc1292$var$classifyParagraphBlock(paragraph, blocks));
        index += 1;
    }
    return blocks;
}
function $08414ea58bdc1292$var$applyTableColumnSpans(rows) {
    const columnCount = Math.max(...rows.map((row)=>row.length));
    return rows.map((row)=>{
        if (row.length >= columnCount || row.length === 0) return row;
        const cells = row.slice(0, -1);
        cells.push({
            text: row[row.length - 1],
            colSpan: columnCount - row.length + 1
        });
        return cells;
    });
}
function $08414ea58bdc1292$var$inferLayoutHints(paragraphs, assets) {
    const sample = paragraphs.slice(0, 40).join("\n");
    const isOasisSpec = /Word Specification Sample/.test(sample) && /\bOASIS\b/i.test(paragraphs.join("\n"));
    const oasisImage = isOasisSpec ? assets.find((asset)=>asset.mimeType === "image/png" && asset.width && asset.height && asset.width / asset.height > 2.5) : void 0;
    return {
        lineNumbers: isOasisSpec,
        documentKind: $08414ea58bdc1292$var$isCjkNoticeDocument(paragraphs) ? "cjkNotice" : void 0,
        headerBrand: isOasisSpec ? "oasis" : void 0,
        headerImageId: oasisImage?.id,
        footer: isOasisSpec ? $08414ea58bdc1292$var$inferOasisFooter(paragraphs) : void 0
    };
}
function $08414ea58bdc1292$var$isCjkNoticeDocument(paragraphs) {
    const visible = paragraphs.filter((paragraph)=>paragraph !== $08414ea58bdc1292$var$WORD_PAGE_BREAK);
    return visible.length >= 8 && $08414ea58bdc1292$var$isCjkNoticeTitle(`${visible[0] || ""}${visible[1] || ""}`) && visible.some((paragraph)=>/^[一二三四五六七八九十]+[、.．]/.test(paragraph)) && visible.some((paragraph)=>/^附件[：:]?\s*\d*/.test(paragraph));
}
function $08414ea58bdc1292$var$isCjkNoticeTitle(text) {
    const value = text.replace(/\s+/g, "");
    return value.length >= 4 && value.length <= 80 && /\p{Script=Han}/u.test(value) && /(?:通知|通告|公告|函|意见|决定|方案)$/.test(value);
}
function $08414ea58bdc1292$var$inferOasisFooter(paragraphs) {
    const documentId = $08414ea58bdc1292$var$findValueAfterLabel(paragraphs, "Document identifier:") || paragraphs.find((paragraph)=>/^wd-[\w.-]+/i.test(paragraph));
    const subtitle = paragraphs.find((paragraph)=>/\b(?:draft|version)\b/i.test(paragraph) && /\d{4}/.test(paragraph));
    const date = subtitle?.match(/\b\d{1,2}\s+[A-Za-z]+\s+\d{4}\b/)?.[0];
    const copyright = paragraphs.find((paragraph)=>/Copyright.*OASIS.*All Rights Reserved/i.test(paragraph)) || "Copyright \xA9 OASIS Open 2002. All Rights Reserved.";
    return {
        documentId: documentId,
        date: date,
        copyright: copyright
    };
}
function $08414ea58bdc1292$var$findValueAfterLabel(paragraphs, label) {
    const index = paragraphs.findIndex((paragraph)=>paragraph.toLowerCase() === label.toLowerCase());
    if (index < 0) return void 0;
    return paragraphs.slice(index + 1).find((paragraph)=>paragraph !== $08414ea58bdc1292$var$WORD_PAGE_BREAK && paragraph.length > 0);
}
function $08414ea58bdc1292$var$paginateWordBlocks(blocks, layout) {
    if (layout.headerBrand === "oasis") return $08414ea58bdc1292$var$paginateOasisBlocks(blocks);
    if (layout.documentKind === "cjkNotice") return $08414ea58bdc1292$var$paginateCjkNoticeBlocks(blocks);
    const pages = [];
    let current = [];
    let usedLines = 0;
    for (const block of blocks){
        if (block.type === "pageBreak") {
            pages.push(current);
            current = [];
            usedLines = 0;
            continue;
        }
        const maxLines = layout.lineNumbers ? 33 : 46;
        const lines = $08414ea58bdc1292$var$estimatedLineCount(block);
        const shouldBreak = current.length > 0 && (usedLines + lines > maxLines || block.type === "heading" && usedLines > Math.floor(maxLines * 0.72));
        if (shouldBreak) {
            pages.push(current);
            current = [];
            usedLines = 0;
        }
        current.push(block);
        usedLines += lines;
    }
    if (current.length > 0 || pages.length === 0) pages.push(current);
    return pages;
}
function $08414ea58bdc1292$var$paginateOasisBlocks(blocks) {
    const pages = [];
    let current = [];
    const flush = ()=>{
        if (current.length > 0) pages.push(current);
        current = [];
    };
    for (const block of blocks){
        if (block.type === "pageBreak") {
            flush();
            continue;
        }
        const startsStyledPage = block.type === "heading" && block.level === 1;
        const startsCodeExamplesPage = block.type === "paragraph" && /^For bibliography lists,/i.test(block.text);
        if (current.length > 0 && (startsStyledPage || startsCodeExamplesPage)) flush();
        current.push(block);
    }
    flush();
    return pages.length > 0 ? pages : [
        []
    ];
}
function $08414ea58bdc1292$var$paginateCjkNoticeBlocks(blocks) {
    const maxUnits = 32;
    const pages = [];
    let current = [];
    let usedUnits = 0;
    let previousWasPageBreak = false;
    let trailingBlankPages = 0;
    const flush = (force = false)=>{
        if (force || current.length > 0) pages.push(current);
        current = [];
        usedUnits = 0;
    };
    for (const block of blocks){
        if (block.type === "pageBreak") {
            if (previousWasPageBreak) {
                trailingBlankPages += 1;
                continue;
            }
            flush(true);
            previousWasPageBreak = true;
            continue;
        }
        previousWasPageBreak = false;
        if (block.type === "table") {
            const columnWidths = $08414ea58bdc1292$var$getNoticeTableColumnWidths(block.rows);
            if (!columnWidths) {
                const units2 = Math.max(1, block.rows.length);
                if (current.length > 0 && usedUnits + units2 > maxUnits) flush();
                current.push(block);
                usedUnits += units2;
                continue;
            }
            const rowUnits = block.rows[0]?.length === 7 ? 1.55 : 1.35;
            let offset = 0;
            while(offset < block.rows.length){
                let availableRows = Math.floor((maxUnits - usedUnits + 1e-3) / rowUnits);
                if (availableRows < 1) {
                    flush();
                    availableRows = Math.max(1, Math.floor(maxUnits / rowUnits));
                }
                const rows = block.rows.slice(offset, offset + availableRows);
                current.push({
                    type: "table",
                    rows: rows,
                    notice: true,
                    columnWidths: columnWidths
                });
                usedUnits += rows.length * rowUnits;
                offset += rows.length;
                if (offset < block.rows.length) flush();
            }
            continue;
        }
        const units = $08414ea58bdc1292$var$estimateCjkNoticeBlockUnits(block);
        if (current.length > 0 && usedUnits + units > maxUnits) flush();
        current.push(block);
        usedUnits += units;
    }
    if (current.length > 0 || pages.length === 0) pages.push(current);
    for(let index = 0; index < trailingBlankPages; index += 1)pages.push([]);
    return pages;
}
function $08414ea58bdc1292$var$estimateCjkNoticeBlockUnits(block) {
    if (block.type === "title" || block.type === "subtitle") return 3;
    if (block.type === "heading") return 2;
    if (block.type === "toc") return 1;
    const text = block.text.trim();
    if (/^附件\s*\d+$/.test(text)) return 2;
    if (/^附件[：:]\s*\d+[.、．]/.test(text)) return 2;
    if (/^\d+[.、．]/.test(text)) return text.length > 30 ? 3 : 2;
    if (/^.{2,24}(?:清单|目录|名册|汇总表)$/.test(text)) return 3;
    if (/^联系人[：:]/.test(text)) return 3;
    if (/^\d{4}年\d{1,2}月\d{1,2}日?$/.test(text)) return 2;
    if (text.length <= 24 && /(?:人民政府|委员会|办公室|数据局|管理局|厅|局|委|办)$/.test(text)) return 2;
    if (/^[^：:]{2,45}[：:]$/.test(text)) return 2;
    return 1 + Math.max(1, Math.ceil($08414ea58bdc1292$var$estimateCjkTextWidth(text) / 28));
}
function $08414ea58bdc1292$var$estimateCjkTextWidth(text) {
    return [
        ...text
    ].reduce((width, character)=>width + (/^[\x00-\xff]$/.test(character) ? 0.55 : 1), 0);
}
function $08414ea58bdc1292$var$estimatedLineCount(block) {
    if (block.type === "pageBreak") return 0;
    if (block.type === "table") return Math.max(1, block.rows.length);
    if (block.type === "toc") return 1;
    if ("runs" in block && block.runs) {
        const height = Math.max(0, ...block.runs.map((run)=>"asset" in run ? run.height : 0));
        return Math.max(1, Math.ceil(height / 18));
    }
    const baseWidth = "indent" in block && block.indent ? 78 : 96;
    return Math.max(1, Math.ceil(block.text.length / baseWidth));
}
function $08414ea58bdc1292$var$classifyParagraphBlock(text, previousBlocks) {
    const visibleIndex = previousBlocks.filter((block)=>block.type !== "toc").length;
    if (visibleIndex === 0 && text.length <= 140) return {
        type: "title",
        text: text
    };
    const firstBlock = previousBlocks[0];
    if (visibleIndex === 1 && firstBlock?.type === "title" && $08414ea58bdc1292$var$isCjkNoticeTitle(`${firstBlock.text}${text}`)) return {
        type: "subtitle",
        text: text
    };
    if (visibleIndex === 1 && /draft|version|20\d{2}|19\d{2}/i.test(text) && text.length <= 140) return {
        type: "subtitle",
        text: text
    };
    if (visibleIndex === 1 && text.length <= 40 && previousBlocks.some((block)=>block.type === "title" && block.text.includes(text))) return {
        type: "subtitle",
        text: text
    };
    const headingLevel = $08414ea58bdc1292$var$inferHeadingLevel(text, previousBlocks);
    if (headingLevel) return {
        type: "heading",
        text: text,
        level: headingLevel
    };
    if (/^[\w\s/().-]{2,45}:$/.test(text)) return {
        type: "label",
        text: text
    };
    if ($08414ea58bdc1292$var$isInstructionParagraph(text)) return {
        type: "instruction",
        text: text,
        indent: $08414ea58bdc1292$var$shouldIndentParagraph(previousBlocks)
    };
    if (/^\[[-\w.]+\]\s+/.test(text)) return {
        type: "reference",
        text: text
    };
    const listLevel = $08414ea58bdc1292$var$inferListItemLevel(text);
    if (listLevel) return {
        type: "listItem",
        text: text,
        level: listLevel
    };
    if ($08414ea58bdc1292$var$isCodeLikeParagraph(text)) return {
        type: "code",
        text: text,
        indent: $08414ea58bdc1292$var$shouldIndentParagraph(previousBlocks)
    };
    return {
        type: "paragraph",
        text: text,
        indent: $08414ea58bdc1292$var$shouldIndentParagraph(previousBlocks)
    };
}
function $08414ea58bdc1292$var$isInstructionParagraph(text) {
    return /^\[[^\]]{8,}\]$/.test(text.trim());
}
function $08414ea58bdc1292$var$inferHeadingLevel(text, previousBlocks) {
    if (text.length > 120) return void 0;
    if (/^table of contents$/i.test(text)) return 1;
    if (/^(?:introduction|word styles|references|appendix\b.*|acknowledgments|revision history|notices)$/i.test(text)) return 1;
    const numbered = text.match(/^([1-9](?:\.\d+)*)\s+.+/);
    if (numbered) return Math.min(3, numbered[1].split(".").length);
    if (/^[一二三四五六七八九十]+\s*[.、．]\s*.{1,40}$/.test(text)) return 2;
    if (/^(?:terminology|overall style|title page|headings|paragraphs|lists|tables|code examples|character styles|normative)$/i.test(text)) return 2;
    const previousHeading = [
        ...previousBlocks
    ].reverse().find((block)=>block.type === "heading");
    if (previousHeading?.type === "heading" && previousHeading.level === 1 && /^[A-Z][A-Za-z0-9 ()/-]{2,80}$/.test(text)) return 2;
    return void 0;
}
function $08414ea58bdc1292$var$shouldIndentParagraph(previousBlocks) {
    for(let index = previousBlocks.length - 1; index >= 0; index -= 1){
        const block = previousBlocks[index];
        if (block.type === "toc" || block.type === "table") continue;
        if (block.type === "label") return true;
        if ((block.type === "paragraph" || block.type === "code") && block.indent) return true;
        return false;
    }
    return false;
}
function $08414ea58bdc1292$var$inferListItemLevel(text) {
    if (/^(?:list bullet|definition term)$/i.test(text)) return 1;
    if (/^(?:list bullet 2|list continue 2|definition for the term\.)$/i.test(text)) return 2;
    return void 0;
}
function $08414ea58bdc1292$var$parseTocEntry(text) {
    const tabCells = $08414ea58bdc1292$var$splitTableRow(text);
    if (tabCells.length >= 2 && /^\d{1,3}$/.test(tabCells[tabCells.length - 1] || "")) {
        const title2 = tabCells.slice(0, -1).join(" ").trim();
        if ($08414ea58bdc1292$var$isLikelyTocTitle(title2)) {
            const number2 = title2.match(/^(\d+(?:\.\d+)*)\b/)?.[1] || "";
            return {
                type: "toc",
                title: title2,
                page: tabCells[tabCells.length - 1],
                level: number2.includes(".") ? Math.min(3, number2.split(".").length) : 1
            };
        }
    }
    const cleaned = text.replace(/\s+/g, " ").trim();
    const match = cleaned.match(/^(?:(\d+(?:\.\d+)*)\s+)?(.+?)\s+(\d{1,3})$/);
    if (!match || cleaned.length > 140) return void 0;
    const number = match[1] || "";
    const title = `${number ? `${number} ` : ""}${match[2] || ""}`.trim();
    const page = match[3];
    if (!title || !page || !/^(?:appendix\b|references\b|introduction\b|[A-Z0-9])/i.test(title)) return void 0;
    if (!$08414ea58bdc1292$var$isLikelyTocTitle(title)) return void 0;
    const level = number.includes(".") ? Math.min(3, number.split(".").length) : 1;
    return {
        type: "toc",
        title: title,
        page: page,
        level: level
    };
}
function $08414ea58bdc1292$var$isLikelyTocTitle(title) {
    return /^(?:appendix\b|references\b|introduction\b|[1-9](?:\.\d+)*\b|[A-Z][\w\s.-]{2,80}$)/i.test(title);
}
function $08414ea58bdc1292$var$isTableRowCandidate(text) {
    if (/^\[[-\w.]+\]\t+/.test(text)) return false;
    const cells = $08414ea58bdc1292$var$splitTableRow(text);
    return cells.length >= 2 && cells.some((cell)=>cell.length > 0);
}
function $08414ea58bdc1292$var$splitTableRow(text) {
    return text.split(/\t+/).map((cell)=>cell.trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$normalizeTableRows(cells) {
    if (cells.length >= 8) {
        const columnCount = $08414ea58bdc1292$var$inferTableColumnCount(cells);
        if (columnCount > 1 && cells.length % columnCount === 0) {
            const rows = [];
            for(let offset = 0; offset < cells.length; offset += columnCount)rows.push(cells.slice(offset, offset + columnCount));
            return rows;
        }
    }
    return [
        cells
    ];
}
function $08414ea58bdc1292$var$inferTableColumnCount(cells) {
    const header = cells.slice(0, 6).join(" ").toLowerCase();
    if (/\brev\b/.test(header) && /\bdate\b/.test(header) && /whom|what/.test(header)) return 4;
    for (const candidate of [
        5,
        4,
        3,
        2
    ]){
        if (cells.length % candidate === 0) return candidate;
    }
    return 0;
}
function $08414ea58bdc1292$var$isCodeLikeParagraph(text) {
    return /^\d{24,}$/.test(text.replace(/\s+/g, "")) || /^GET\s+https?:\/\//i.test(text) || /^<other\s+HTTP\b/i.test(text) || /<\/?[A-Za-z][A-Za-z0-9:-]*(?:\s+[^>@]*)?>/.test(text) || /^\s*(?:<\?xml|function\b|const\b|let\b|var\b|if\s*\(|for\s*\(|while\s*\(|\{|\}|\/\/)/.test(text);
}
function $08414ea58bdc1292$var$cleanWordText(value) {
    return $08414ea58bdc1292$var$stripWordFieldCodes(value).replace(/[\u0001-\u0006\u0008\u000e-\u001f]/g, "").replace(/ {2,}/g, " ").trim();
}
function $08414ea58bdc1292$var$stripWordFieldCodes(value) {
    return value.replace(/\u0013\s*(?:HYPERLINK|PAGEREF|TOC)\b[^\u0014\u0015]*/gi, "").replace(/[\u0013-\u0015]/g, "").replace(/\bHYPERLINK\s+\\l\s+"[^"]*"\s*/gi, "").replace(/\bHYPERLINK\s+"[^"]*"\s*/gi, "").replace(/\bPAGEREF\s+\S+\s+\\h\s*/gi, "").replace(/\bTOC\s+\\o\s+"[^"]*"\s+\\h\s+\\z\s*/gi, "").replace(/\bREF\s+[_A-Za-z0-9-]+\s+(?:\\[A-Za-z]+\s*)+/gi, "");
}
function $08414ea58bdc1292$var$isDisplayableParagraph(value) {
    if (value.length < 2) return false;
    const letters = [
        ...value
    ].filter((char)=>/[\p{L}\p{N}]/u.test(char)).length;
    return letters >= Math.min(2, value.length);
}
function $08414ea58bdc1292$var$inferDocumentTitle(paragraphs) {
    return paragraphs.find((paragraph)=>paragraph.length <= 120) || "Word \u6587\u6863";
}
function $08414ea58bdc1292$var$appendMeta4(list, label, value) {
    const term = window.document.createElement("dt");
    term.textContent = label;
    const detail = window.document.createElement("dd");
    detail.textContent = value;
    list.append(term, detail);
}
function $08414ea58bdc1292$var$concatChunks(chunks, size) {
    const total = chunks.reduce((sum, chunk)=>sum + chunk.length, 0);
    const output = new Uint8Array(size === void 0 ? total : Math.min(total, size));
    let offset = 0;
    for (const chunk of chunks){
        const slice = chunk.subarray(0, Math.min(chunk.length, output.length - offset));
        output.set(slice, offset);
        offset += slice.length;
        if (offset >= output.length) break;
    }
    return output;
}
function $08414ea58bdc1292$var$alignEven(value) {
    return value % 2 === 0 ? value : value + 1;
}
function $08414ea58bdc1292$var$isUsableSector(sector) {
    return sector !== $08414ea58bdc1292$var$FREE_SECTOR && sector !== $08414ea58bdc1292$var$END_OF_CHAIN && sector !== $08414ea58bdc1292$var$FAT_SECTOR && sector !== $08414ea58bdc1292$var$DIFAT_SECTOR;
}
function $08414ea58bdc1292$var$sectorOffset(sector, sectorSize) {
    return (sector + 1) * sectorSize;
}
function $08414ea58bdc1292$var$normalizeStreamName(name) {
    return name.replace(/^\/+/, "").toLowerCase();
}
function $08414ea58bdc1292$var$decodeUtf16Le(bytes) {
    return new TextDecoder("utf-16le").decode(bytes);
}
function $08414ea58bdc1292$var$decodeWindows1252(bytes) {
    try {
        return new TextDecoder("windows-1252").decode(bytes);
    } catch  {
        return Array.from(bytes, (byte)=>String.fromCharCode(byte)).join("");
    }
}
function $08414ea58bdc1292$var$dataView(bytes) {
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
// src/plugins/wordml.ts
var $08414ea58bdc1292$var$WORDML_NS = "http://schemas.microsoft.com/office/word/2003/wordml";
function $08414ea58bdc1292$var$parseWord2003XmlDocument(source) {
    const normalized = source.replace(/^\uFEFF/, "");
    if (!/<(?:\w+:)?wordDocument\b/i.test(normalized) || !normalized.includes($08414ea58bdc1292$var$WORDML_NS)) return void 0;
    const xml = new DOMParser().parseFromString(normalized, "application/xml");
    if (xml.querySelector("parsererror") || xml.documentElement.localName !== "wordDocument") return void 0;
    const body = $08414ea58bdc1292$var$descendants(xml.documentElement, "body")[0];
    if (!body) return void 0;
    const styles = $08414ea58bdc1292$var$parseNamedStyles(xml);
    const blocks = [];
    for (const child of $08414ea58bdc1292$var$collectBodyChildren(body)){
        if ($08414ea58bdc1292$var$isWordElement(child, "p")) {
            const paragraph = $08414ea58bdc1292$var$parseParagraph(child, styles);
            if (paragraph.breakBefore) blocks.push({
                type: "pageBreak"
            });
            blocks.push(paragraph);
            if (paragraph.breakAfter) blocks.push({
                type: "pageBreak"
            });
        } else if ($08414ea58bdc1292$var$isWordElement(child, "tbl")) blocks.push($08414ea58bdc1292$var$parseTable(child, styles));
    }
    const sectionProperties = [
        ...$08414ea58bdc1292$var$descendants(body, "sectPr")
    ].at(-1);
    return {
        blocks: blocks,
        layout: $08414ea58bdc1292$var$parsePageLayout(sectionProperties),
        footerTemplate: sectionProperties ? $08414ea58bdc1292$var$parseFooterTemplate(sectionProperties) : void 0
    };
}
function $08414ea58bdc1292$var$renderWord2003XmlDocument(panel, wordDocument) {
    panel.replaceChildren();
    panel.classList.add("ofv-office-wordml");
    const article = document.createElement("article");
    article.className = "ofv-wordml-document";
    const pages = $08414ea58bdc1292$var$paginateBlocks(wordDocument.blocks);
    for (const [pageIndex, blocks] of pages.entries()){
        const page = document.createElement("section");
        page.className = "ofv-wordml-page";
        page.setAttribute("aria-label", `Word 2003 XML \u7B2C ${pageIndex + 1} \u9875`);
        $08414ea58bdc1292$var$applyPageLayout(page, wordDocument.layout);
        const content = document.createElement("div");
        content.className = "ofv-wordml-page-content";
        for (const block of blocks)content.append(block.type === "paragraph" ? $08414ea58bdc1292$var$renderParagraph(block) : $08414ea58bdc1292$var$renderTable(block));
        page.append(content);
        if (wordDocument.footerTemplate) {
            const footer = document.createElement("footer");
            footer.className = "ofv-wordml-footer";
            footer.style.bottom = $08414ea58bdc1292$var$scaledPt(Math.max(6, wordDocument.layout.footerDistancePt - 12));
            footer.style.left = $08414ea58bdc1292$var$scaledPt(wordDocument.layout.marginLeftPt);
            footer.style.right = $08414ea58bdc1292$var$scaledPt(wordDocument.layout.marginRightPt);
            footer.textContent = wordDocument.footerTemplate.replaceAll("{PAGE}", String(pageIndex + 1)).replaceAll("{NUMPAGES}", String(pages.length));
            page.append(footer);
        }
        article.append(page);
    }
    panel.append(article);
}
function $08414ea58bdc1292$var$collectBodyChildren(body) {
    const output = [];
    for (const child of $08414ea58bdc1292$var$elementChildren(body)){
        if ($08414ea58bdc1292$var$isWordElement(child, "p") || $08414ea58bdc1292$var$isWordElement(child, "tbl")) {
            output.push(child);
            continue;
        }
        if (child.localName === "sect") output.push(...$08414ea58bdc1292$var$elementChildren(child).filter((element)=>$08414ea58bdc1292$var$isWordElement(element, "p") || $08414ea58bdc1292$var$isWordElement(element, "tbl")));
    }
    return output;
}
function $08414ea58bdc1292$var$parseNamedStyles(xml) {
    const raw = /* @__PURE__ */ new Map();
    for (const style of $08414ea58bdc1292$var$descendants(xml.documentElement, "style")){
        if (style.namespaceURI !== $08414ea58bdc1292$var$WORDML_NS) continue;
        const id = $08414ea58bdc1292$var$wordAttribute(style, "styleId");
        if (!id) continue;
        const paragraphProperties = $08414ea58bdc1292$var$directWordChild(style, "pPr");
        raw.set(id, {
            basedOn: $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(style, "basedOn"), "val"),
            paragraph: $08414ea58bdc1292$var$parseParagraphProperties(paragraphProperties),
            run: $08414ea58bdc1292$var$parseRunProperties($08414ea58bdc1292$var$directWordChild(style, "rPr"))
        });
    }
    const resolved = /* @__PURE__ */ new Map();
    const resolve = (id, seen = /* @__PURE__ */ new Set())=>{
        if (resolved.has(id)) return resolved.get(id);
        const own = raw.get(id);
        if (!own || seen.has(id)) return own;
        seen.add(id);
        const base = own.basedOn ? resolve(own.basedOn, seen) : void 0;
        const value = {
            basedOn: own.basedOn,
            paragraph: {
                ...base?.paragraph || {},
                ...own.paragraph
            },
            run: {
                ...base?.run || {},
                ...own.run
            }
        };
        resolved.set(id, value);
        return value;
    };
    for (const id of raw.keys())resolve(id);
    return resolved;
}
function $08414ea58bdc1292$var$parseParagraph(element, styles) {
    const paragraphProperties = $08414ea58bdc1292$var$directWordChild(element, "pPr");
    const styleId = $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(paragraphProperties, "pStyle"), "val");
    const namedStyle = styleId ? styles.get(styleId) : void 0;
    const paragraphRunStyle = $08414ea58bdc1292$var$parseRunProperties($08414ea58bdc1292$var$directWordChild(paragraphProperties, "rPr"));
    const runs = [];
    const appendRuns = (container)=>{
        for (const child of $08414ea58bdc1292$var$elementChildren(container)){
            if ($08414ea58bdc1292$var$isWordElement(child, "r")) {
                const runStyle = {
                    ...namedStyle?.run || {},
                    ...paragraphRunStyle,
                    ...$08414ea58bdc1292$var$parseRunProperties($08414ea58bdc1292$var$directWordChild(child, "rPr"))
                };
                const text = $08414ea58bdc1292$var$readRunText(child);
                if (text) runs.push({
                    text: text,
                    style: runStyle
                });
            } else if (child.namespaceURI === $08414ea58bdc1292$var$WORDML_NS && [
                "hlink",
                "smartTag",
                "proofErr"
            ].includes(child.localName)) appendRuns(child);
        }
    };
    appendRuns(element);
    const pageBreakBefore = $08414ea58bdc1292$var$directWordChild(paragraphProperties, "pageBreakBefore");
    const hasRunPageBreak = $08414ea58bdc1292$var$descendants(element, "br").some((br)=>br.namespaceURI === $08414ea58bdc1292$var$WORDML_NS && $08414ea58bdc1292$var$wordAttribute(br, "type") === "page");
    return {
        type: "paragraph",
        runs: runs,
        style: {
            ...namedStyle?.paragraph || {},
            ...$08414ea58bdc1292$var$parseParagraphProperties(paragraphProperties)
        },
        breakBefore: Boolean(pageBreakBefore && $08414ea58bdc1292$var$wordBoolean(pageBreakBefore)),
        breakAfter: hasRunPageBreak
    };
}
function $08414ea58bdc1292$var$parseTable(element, styles) {
    const tableProperties = $08414ea58bdc1292$var$directWordChild(element, "tblPr");
    const tableWidth = $08414ea58bdc1292$var$directWordChild(tableProperties, "tblW");
    const grid = $08414ea58bdc1292$var$directWordChild(element, "tblGrid");
    const columns = grid ? $08414ea58bdc1292$var$elementChildren(grid).filter((child)=>$08414ea58bdc1292$var$isWordElement(child, "gridCol")).map((column)=>$08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(column, "w"))).filter((width)=>width > 0) : [];
    const rows = $08414ea58bdc1292$var$elementChildren(element).filter((child)=>$08414ea58bdc1292$var$isWordElement(child, "tr")).map((row)=>$08414ea58bdc1292$var$elementChildren(row).filter((child)=>$08414ea58bdc1292$var$isWordElement(child, "tc")).map((cell)=>$08414ea58bdc1292$var$parseTableCell(cell, styles)));
    return {
        type: "table",
        rows: rows,
        columns: columns,
        widthPt: $08414ea58bdc1292$var$wordAttribute(tableWidth, "type") === "dxa" ? $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(tableWidth, "w")) : void 0
    };
}
function $08414ea58bdc1292$var$parseTableCell(element, styles) {
    const properties = $08414ea58bdc1292$var$directWordChild(element, "tcPr");
    const width = $08414ea58bdc1292$var$directWordChild(properties, "tcW");
    const shading = $08414ea58bdc1292$var$directWordChild(properties, "shd");
    const paragraphs = $08414ea58bdc1292$var$elementChildren(element).filter((child)=>$08414ea58bdc1292$var$isWordElement(child, "p")).map((paragraph)=>$08414ea58bdc1292$var$parseParagraph(paragraph, styles));
    return {
        paragraphs: paragraphs,
        colSpan: Math.max(1, $08414ea58bdc1292$var$wordNumber($08414ea58bdc1292$var$directWordChild(properties, "gridSpan"), "val") || 1),
        widthPt: $08414ea58bdc1292$var$wordAttribute(width, "type") === "dxa" ? $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(width, "w")) : void 0,
        verticalAlign: $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(properties, "vAlign"), "val"),
        backgroundColor: $08414ea58bdc1292$var$normalizeColor($08414ea58bdc1292$var$wordAttribute(shading, "fill"))
    };
}
function $08414ea58bdc1292$var$parseParagraphProperties(properties) {
    if (!properties) return {};
    const alignment = $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(properties, "jc"), "val");
    const spacing = $08414ea58bdc1292$var$directWordChild(properties, "spacing");
    const indentation = $08414ea58bdc1292$var$directWordChild(properties, "ind");
    const hanging = $08414ea58bdc1292$var$wordNumber(indentation, "hanging");
    const firstLine = $08414ea58bdc1292$var$wordNumber(indentation, "first-line") || $08414ea58bdc1292$var$wordNumber(indentation, "firstLine");
    const line = $08414ea58bdc1292$var$wordNumber(spacing, "line");
    const lineRule = $08414ea58bdc1292$var$wordAttribute(spacing, "line-rule") || $08414ea58bdc1292$var$wordAttribute(spacing, "lineRule");
    return $08414ea58bdc1292$var$compactObject({
        alignment: alignment === "center" || alignment === "right" || alignment === "left" ? alignment : alignment === "both" || alignment === "distribute" ? "justify" : void 0,
        marginTopPt: $08414ea58bdc1292$var$optionalTwipsToPt($08414ea58bdc1292$var$wordAttribute(spacing, "before")),
        marginRightPt: $08414ea58bdc1292$var$optionalTwipsToPt($08414ea58bdc1292$var$wordAttribute(indentation, "right")),
        marginBottomPt: $08414ea58bdc1292$var$optionalTwipsToPt($08414ea58bdc1292$var$wordAttribute(spacing, "after")),
        marginLeftPt: $08414ea58bdc1292$var$optionalTwipsToPt($08414ea58bdc1292$var$wordAttribute(indentation, "left")),
        textIndentPt: firstLine ? $08414ea58bdc1292$var$twipsToPt(firstLine) : hanging ? -$08414ea58bdc1292$var$twipsToPt(hanging) : void 0,
        lineHeight: line > 0 ? lineRule === "exact" || lineRule === "at-least" ? `${$08414ea58bdc1292$var$twipsToPt(line)}pt` : String(line / 240) : void 0
    });
}
function $08414ea58bdc1292$var$parseRunProperties(properties) {
    if (!properties) return {};
    const fonts = $08414ea58bdc1292$var$directWordChild(properties, "rFonts");
    const size = $08414ea58bdc1292$var$wordNumber($08414ea58bdc1292$var$directWordChild(properties, "sz"), "val");
    const underline = $08414ea58bdc1292$var$directWordChild(properties, "u");
    const color = $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(properties, "color"), "val");
    const highlight = $08414ea58bdc1292$var$wordAttribute($08414ea58bdc1292$var$directWordChild(properties, "highlight"), "val");
    const bold = $08414ea58bdc1292$var$directWordChild(properties, "b");
    const italic = $08414ea58bdc1292$var$directWordChild(properties, "i");
    return $08414ea58bdc1292$var$compactObject({
        fontFamily: $08414ea58bdc1292$var$wordAttribute(fonts, "fareast") || $08414ea58bdc1292$var$wordAttribute(fonts, "ascii") || $08414ea58bdc1292$var$wordAttribute(fonts, "h-ansi") || $08414ea58bdc1292$var$wordAttribute(fonts, "hAnsi"),
        fontSizePt: size > 0 ? size / 2 : void 0,
        bold: bold ? $08414ea58bdc1292$var$wordBoolean(bold) : void 0,
        italic: italic ? $08414ea58bdc1292$var$wordBoolean(italic) : void 0,
        underline: underline ? ![
            "none",
            "off",
            "0"
        ].includes(($08414ea58bdc1292$var$wordAttribute(underline, "val") || "single").toLowerCase()) : void 0,
        color: $08414ea58bdc1292$var$normalizeColor(color),
        backgroundColor: $08414ea58bdc1292$var$normalizeHighlight(highlight)
    });
}
function $08414ea58bdc1292$var$readRunText(run) {
    let text = "";
    for (const child of $08414ea58bdc1292$var$elementChildren(run)){
        if ($08414ea58bdc1292$var$isWordElement(child, "t")) text += child.textContent || "";
        else if ($08414ea58bdc1292$var$isWordElement(child, "tab")) text += "	";
        else if ($08414ea58bdc1292$var$isWordElement(child, "br") && $08414ea58bdc1292$var$wordAttribute(child, "type") !== "page") text += "\n";
    }
    return text;
}
function $08414ea58bdc1292$var$parsePageLayout(sectionProperties) {
    const pageSize = $08414ea58bdc1292$var$directWordChild(sectionProperties, "pgSz");
    const margins = $08414ea58bdc1292$var$directWordChild(sectionProperties, "pgMar");
    return {
        widthPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(pageSize, "w") || 11906),
        heightPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(pageSize, "h") || 16838),
        marginTopPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(margins, "top") || 1440),
        marginRightPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(margins, "right") || 1440),
        marginBottomPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(margins, "bottom") || 1440),
        marginLeftPt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(margins, "left") || 1440),
        footerDistancePt: $08414ea58bdc1292$var$twipsToPt($08414ea58bdc1292$var$wordNumber(margins, "footer") || 720)
    };
}
function $08414ea58bdc1292$var$parseFooterTemplate(sectionProperties) {
    const footer = $08414ea58bdc1292$var$descendants(sectionProperties, "ftr").find((element)=>element.namespaceURI === $08414ea58bdc1292$var$WORDML_NS);
    if (!footer) return void 0;
    const paragraphs = $08414ea58bdc1292$var$descendants(footer, "p").filter((element)=>element.namespaceURI === $08414ea58bdc1292$var$WORDML_NS).map($08414ea58bdc1292$var$readFieldAwareText).map((value)=>value.trim()).filter(Boolean);
    return paragraphs.at(-1);
}
function $08414ea58bdc1292$var$readFieldAwareText(paragraph) {
    const fields = [];
    let output = "";
    const walk = (node)=>{
        if (!(node instanceof Element)) {
            for (const child of node.childNodes)walk(child);
            return;
        }
        if ($08414ea58bdc1292$var$isWordElement(node, "fldChar")) {
            const type = $08414ea58bdc1292$var$wordAttribute(node, "fldCharType");
            if (type === "begin") fields.push({
                instruction: "",
                separated: false,
                recognized: false
            });
            else if (type === "separate" && fields.length > 0) {
                const field = fields.at(-1);
                field.separated = true;
                const name = field.instruction.trim().split(/\s+/)[0]?.toUpperCase();
                field.recognized = name === "PAGE" || name === "NUMPAGES";
                if (field.recognized) output += `{${name}}`;
            } else if (type === "end") fields.pop();
            return;
        }
        if ($08414ea58bdc1292$var$isWordElement(node, "instrText")) {
            if (fields.length > 0) fields.at(-1).instruction += node.textContent || "";
            return;
        }
        if ($08414ea58bdc1292$var$isWordElement(node, "t")) {
            const field = fields.at(-1);
            if (!field || field.separated && !field.recognized) output += node.textContent || "";
            return;
        }
        if ($08414ea58bdc1292$var$isWordElement(node, "tab")) output += "	";
        else if ($08414ea58bdc1292$var$isWordElement(node, "br")) output += "\n";
        for (const child of node.childNodes)walk(child);
    };
    walk(paragraph);
    return output;
}
function $08414ea58bdc1292$var$paginateBlocks(blocks) {
    const pages = [];
    let current = [];
    for (const block of blocks)if (block.type === "pageBreak") {
        pages.push(current);
        current = [];
    } else current.push(block);
    if (current.length > 0 || pages.length === 0) pages.push(current);
    return pages;
}
function $08414ea58bdc1292$var$renderParagraph(paragraph) {
    const element = document.createElement("p");
    element.className = "ofv-wordml-paragraph";
    $08414ea58bdc1292$var$applyParagraphStyle(element, paragraph.style);
    for (const run of paragraph.runs){
        const span = document.createElement("span");
        span.textContent = run.text;
        $08414ea58bdc1292$var$applyRunStyle(span, run.style);
        element.append(span);
    }
    if (paragraph.runs.length === 0) element.append(document.createElement("br"));
    return element;
}
function $08414ea58bdc1292$var$renderTable(tableModel) {
    const table = document.createElement("table");
    table.className = "ofv-wordml-table";
    if (tableModel.widthPt) table.style.width = $08414ea58bdc1292$var$scaledPt(tableModel.widthPt);
    if (tableModel.columns.length > 0) {
        const colgroup = document.createElement("colgroup");
        for (const width of tableModel.columns){
            const column = document.createElement("col");
            column.style.width = $08414ea58bdc1292$var$scaledPt(width);
            colgroup.append(column);
        }
        table.append(colgroup);
    }
    const body = table.createTBody();
    for (const rowModel of tableModel.rows){
        const row = body.insertRow();
        for (const cellModel of rowModel){
            const cell = row.insertCell();
            cell.colSpan = cellModel.colSpan;
            if (cellModel.widthPt) cell.style.width = $08414ea58bdc1292$var$scaledPt(cellModel.widthPt);
            if (cellModel.verticalAlign) cell.style.verticalAlign = cellModel.verticalAlign === "center" ? "middle" : cellModel.verticalAlign;
            if (cellModel.backgroundColor) cell.style.backgroundColor = cellModel.backgroundColor;
            for (const paragraph of cellModel.paragraphs)cell.append($08414ea58bdc1292$var$renderParagraph(paragraph));
        }
    }
    return table;
}
function $08414ea58bdc1292$var$applyPageLayout(page, layout) {
    page.style.width = $08414ea58bdc1292$var$scaledPt(layout.widthPt);
    page.style.height = $08414ea58bdc1292$var$scaledPt(layout.heightPt);
    page.style.padding = [
        layout.marginTopPt,
        layout.marginRightPt,
        layout.marginBottomPt,
        layout.marginLeftPt
    ].map($08414ea58bdc1292$var$scaledPt).join(" ");
}
function $08414ea58bdc1292$var$applyParagraphStyle(element, style) {
    if (style.alignment) element.style.textAlign = style.alignment;
    if (style.marginTopPt !== void 0) element.style.marginTop = $08414ea58bdc1292$var$scaledPt(style.marginTopPt);
    if (style.marginRightPt !== void 0) element.style.marginRight = $08414ea58bdc1292$var$scaledPt(style.marginRightPt);
    if (style.marginBottomPt !== void 0) element.style.marginBottom = $08414ea58bdc1292$var$scaledPt(style.marginBottomPt);
    if (style.marginLeftPt !== void 0) element.style.marginLeft = $08414ea58bdc1292$var$scaledPt(style.marginLeftPt);
    if (style.textIndentPt !== void 0) element.style.textIndent = $08414ea58bdc1292$var$scaledPt(style.textIndentPt);
    if (style.lineHeight) element.style.lineHeight = style.lineHeight.includes("pt") ? `calc(${style.lineHeight} * var(--ofv-office-zoom, 1))` : style.lineHeight;
}
function $08414ea58bdc1292$var$applyRunStyle(element, style) {
    if (style.fontFamily) element.style.fontFamily = `"${style.fontFamily.replaceAll('"', '\\"')}"`;
    if (style.fontSizePt) element.style.fontSize = $08414ea58bdc1292$var$scaledPt(style.fontSizePt);
    if (style.bold !== void 0) element.style.fontWeight = style.bold ? "700" : "400";
    if (style.italic !== void 0) element.style.fontStyle = style.italic ? "italic" : "normal";
    if (style.underline !== void 0) element.style.textDecoration = style.underline ? "underline" : "none";
    if (style.color) element.style.color = style.color;
    if (style.backgroundColor) element.style.backgroundColor = style.backgroundColor;
}
function $08414ea58bdc1292$var$directWordChild(parent, localName) {
    return parent ? $08414ea58bdc1292$var$elementChildren(parent).find((child)=>$08414ea58bdc1292$var$isWordElement(child, localName)) : void 0;
}
function $08414ea58bdc1292$var$descendants(parent, localName) {
    return Array.from(parent.getElementsByTagNameNS("*", localName));
}
function $08414ea58bdc1292$var$elementChildren(parent) {
    return Array.from(parent.children);
}
function $08414ea58bdc1292$var$isWordElement(element, localName) {
    return element.namespaceURI === $08414ea58bdc1292$var$WORDML_NS && element.localName === localName;
}
function $08414ea58bdc1292$var$wordAttribute(element, name) {
    if (!element) return void 0;
    return element.getAttributeNS($08414ea58bdc1292$var$WORDML_NS, name) || element.getAttribute(`w:${name}`) || element.getAttribute(name) || void 0;
}
function $08414ea58bdc1292$var$wordNumber(element, name) {
    return Number.parseFloat($08414ea58bdc1292$var$wordAttribute(element, name) || "0") || 0;
}
function $08414ea58bdc1292$var$wordBoolean(element) {
    return ![
        "off",
        "false",
        "0",
        "none"
    ].includes(($08414ea58bdc1292$var$wordAttribute(element, "val") || "on").toLowerCase());
}
function $08414ea58bdc1292$var$twipsToPt(value) {
    return value / 20;
}
function $08414ea58bdc1292$var$optionalTwipsToPt(value) {
    if (value === void 0) return void 0;
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? $08414ea58bdc1292$var$twipsToPt(number) : void 0;
}
function $08414ea58bdc1292$var$scaledPt(value) {
    return `calc(${Number(value.toFixed(3))}pt * var(--ofv-office-zoom, 1))`;
}
function $08414ea58bdc1292$var$normalizeColor(value) {
    return value && /^[0-9a-f]{6}$/i.test(value) ? `#${value}` : void 0;
}
function $08414ea58bdc1292$var$normalizeHighlight(value) {
    const colors = {
        black: "#000000",
        blue: "#0000ff",
        cyan: "#00ffff",
        green: "#008000",
        magenta: "#ff00ff",
        red: "#ff0000",
        yellow: "#ffff00"
    };
    return value ? colors[value.toLowerCase()] : void 0;
}
function $08414ea58bdc1292$var$compactObject(value) {
    return Object.fromEntries(Object.entries(value).filter(([, entry])=>entry !== void 0));
}
var $08414ea58bdc1292$var$DOCUMENT_CONTAINER = 1e3;
var $08414ea58bdc1292$var$DOCUMENT_ATOM = 1001;
var $08414ea58bdc1292$var$MASTER_PERSIST_ATOM = 1011;
var $08414ea58bdc1292$var$SLIDE_CONTAINER = 1006;
var $08414ea58bdc1292$var$SLIDE_ATOM = 1007;
var $08414ea58bdc1292$var$MAIN_MASTER_CONTAINER = 1016;
var $08414ea58bdc1292$var$TEXT_HEADER_ATOM = 3999;
var $08414ea58bdc1292$var$TEXT_CHARS_ATOM = 4e3;
var $08414ea58bdc1292$var$STYLE_TEXT_PROP_ATOM = 4001;
var $08414ea58bdc1292$var$TEXT_MASTER_STYLE_ATOM = 4003;
var $08414ea58bdc1292$var$TEXT_BYTES_ATOM = 4008;
var $08414ea58bdc1292$var$FONT_ENTITY_ATOM = 4023;
var $08414ea58bdc1292$var$OFFICE_ART_SPGR_CONTAINER = 61443;
var $08414ea58bdc1292$var$OFFICE_ART_SP_CONTAINER = 61444;
var $08414ea58bdc1292$var$OFFICE_ART_SPGR_ATOM = 61449;
var $08414ea58bdc1292$var$OFFICE_ART_FSP = 61450;
var $08414ea58bdc1292$var$OFFICE_ART_FOPT = 61451;
var $08414ea58bdc1292$var$OFFICE_ART_CHILD_ANCHOR = 61455;
var $08414ea58bdc1292$var$OFFICE_ART_CLIENT_ANCHOR = 61456;
var $08414ea58bdc1292$var$OFFICE_ART_PIB_PROPERTY = 260;
var $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_TOP_PROPERTY = 256;
var $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_BOTTOM_PROPERTY = 257;
var $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_LEFT_PROPERTY = 258;
var $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_RIGHT_PROPERTY = 259;
var $08414ea58bdc1292$var$OFFICE_ART_ROTATION_PROPERTY = 4;
var $08414ea58bdc1292$var$OFFICE_ART_TEXT_FLOW_PROPERTY = 136;
var $08414ea58bdc1292$var$OFFICE_ART_FILL_COLOR_PROPERTY = 385;
var $08414ea58bdc1292$var$OFFICE_ART_FILL_STYLE_PROPERTY = 447;
var $08414ea58bdc1292$var$OFFICE_ART_LINE_COLOR_PROPERTY = 448;
var $08414ea58bdc1292$var$OFFICE_ART_LINE_WIDTH_PROPERTY = 459;
var $08414ea58bdc1292$var$OFFICE_ART_LINE_STYLE_PROPERTY = 511;
var $08414ea58bdc1292$var$EMU_PER_MASTER_UNIT = 1587.5;
var $08414ea58bdc1292$var$BLIP_EMF = 61466;
var $08414ea58bdc1292$var$BLIP_WMF = 61467;
var $08414ea58bdc1292$var$BLIP_JPEG = 61469;
var $08414ea58bdc1292$var$BLIP_PNG = 61470;
var $08414ea58bdc1292$var$BLIP_TIFF = 61481;

async function $08414ea58bdc1292$var$parseLegacyPowerPoint(arrayBuffer) {
    if (arrayBuffer.byteLength < 512 || !$08414ea58bdc1292$var$hasCompoundFileSignature(new Uint8Array(arrayBuffer, 0, Math.min(8, arrayBuffer.byteLength)))) throw new Error("The file is not a complete OLE compound document.");
    const xlsxModule = await (parcelRequire("j06ta"));
    const xlsx = xlsxModule.default || xlsxModule;
    const cfb = xlsx.CFB.read(new Uint8Array(arrayBuffer), {
        type: "array"
    });
    const documentEntry = xlsx.CFB.find(cfb, "PowerPoint Document");
    if (!documentEntry?.content) throw new Error("PowerPoint Document stream was not found.");
    const picturesEntry = xlsx.CFB.find(cfb, "Pictures");
    return $08414ea58bdc1292$var$parseLegacyPowerPointStreams($08414ea58bdc1292$var$asUint8Array(documentEntry.content), picturesEntry?.content ? $08414ea58bdc1292$var$asUint8Array(picturesEntry.content) : void 0);
}
function $08414ea58bdc1292$var$parseLegacyPowerPointStreams(documentStream, picturesStream) {
    if (documentStream.byteLength < 8) throw new Error("PowerPoint Document stream is empty.");
    const view3 = new DataView(documentStream.buffer, documentStream.byteOffset, documentStream.byteLength);
    let width = 7200;
    let height = 5400;
    const masterIds = $08414ea58bdc1292$var$parseMasterIds(documentStream);
    const fonts = $08414ea58bdc1292$var$parseFontFamilies(documentStream);
    const masters = [];
    const slides = [];
    $08414ea58bdc1292$var$walkRecords(documentStream, 0, documentStream.byteLength, (record)=>{
        if (record.type === $08414ea58bdc1292$var$DOCUMENT_ATOM && record.end - record.payloadStart >= 8) {
            const candidateWidth = view3.getUint32(record.payloadStart, true);
            const candidateHeight = view3.getUint32(record.payloadStart + 4, true);
            if (candidateWidth > 0 && candidateHeight > 0) {
                width = candidateWidth;
                height = candidateHeight;
            }
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$MAIN_MASTER_CONTAINER) {
            masters.push({
                id: masterIds[masters.length],
                shapes: $08414ea58bdc1292$var$parseShapeContainers(documentStream, record.payloadStart, record.end, width, height),
                textStyles: $08414ea58bdc1292$var$parseTextMasterStyles(documentStream, record.payloadStart, record.end)
            });
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$SLIDE_CONTAINER) {
            const metadata = $08414ea58bdc1292$var$parseSlideMasterMetadata(documentStream, record.payloadStart, record.end);
            slides.push({
                shapes: $08414ea58bdc1292$var$parseShapeContainers(documentStream, record.payloadStart, record.end, width, height),
                masterShapes: [],
                masterTextStyles: {},
                masterIdRef: metadata.masterIdRef,
                inheritMasterObjects: metadata.inheritMasterObjects
            });
            return false;
        }
        return record.type === $08414ea58bdc1292$var$DOCUMENT_CONTAINER || record.version === 15;
    });
    if (slides.length === 0) throw new Error("No slide records were found in the PowerPoint Document stream.");
    const masterShapes = $08414ea58bdc1292$var$deduplicateShapes(masters.flatMap((master)=>master.shapes));
    const resolvedSlides = slides.map(({ inheritMasterObjects: inheritMasterObjects, ...slide })=>{
        const matchingMaster = masters.find((master)=>master.id === slide.masterIdRef);
        return {
            ...slide,
            masterShapes: inheritMasterObjects ? matchingMaster?.shapes || (slide.masterIdRef === void 0 ? masterShapes : []) : [],
            masterTextStyles: matchingMaster?.textStyles || {}
        };
    });
    return {
        width: width,
        height: height,
        masterShapes: masterShapes,
        slides: resolvedSlides,
        images: picturesStream ? $08414ea58bdc1292$var$parsePicturesStream(picturesStream) : [],
        fonts: fonts
    };
}
function $08414ea58bdc1292$var$parseTextMasterStyles(bytes, start, end) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const styles = {};
    $08414ea58bdc1292$var$walkRecords(bytes, start, end, (record)=>{
        if (record.type !== $08414ea58bdc1292$var$TEXT_MASTER_STYLE_ATOM || record.end - record.payloadStart < 2) return record.version === 15;
        const levelCount = Math.min(5, view3.getUint16(record.payloadStart, true));
        const levels = styles[record.instance] || [];
        let offset = record.payloadStart + 2;
        for(let sequence = 0; sequence < levelCount && offset < record.end; sequence += 1){
            let level = sequence;
            if (record.instance >= 5) {
                if (offset + 2 > record.end) break;
                level = view3.getUint16(offset, true);
                offset += 2;
            }
            const paragraph = $08414ea58bdc1292$var$parseTextParagraphException(view3, offset, record.end);
            if (!paragraph) break;
            offset = paragraph.offset;
            const character = $08414ea58bdc1292$var$parseTextCharacterException(view3, offset, record.end);
            if (!character) break;
            offset = character.offset;
            levels[level] = {
                ...levels[level] || {},
                ...character.style
            };
        }
        styles[record.instance] = levels;
        return false;
    });
    return styles;
}
function $08414ea58bdc1292$var$parseFontFamilies(bytes) {
    const fonts = [];
    $08414ea58bdc1292$var$walkRecords(bytes, 0, bytes.byteLength, (record)=>{
        if (record.type === $08414ea58bdc1292$var$FONT_ENTITY_ATOM && record.end - record.payloadStart >= 64) {
            const family = $08414ea58bdc1292$var$decodePresentationText(bytes.subarray(record.payloadStart, record.payloadStart + 64), true);
            if (family) fonts[record.instance] = family;
            return false;
        }
        return record.version === 15;
    });
    return fonts;
}
function $08414ea58bdc1292$var$parseMasterIds(bytes) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const ids = [];
    $08414ea58bdc1292$var$walkRecords(bytes, 0, bytes.byteLength, (record)=>{
        if (record.type === $08414ea58bdc1292$var$MASTER_PERSIST_ATOM && record.end - record.payloadStart >= 16) {
            const masterId = view3.getUint32(record.payloadStart + 12, true);
            if ((masterId & 2147483648) !== 0) ids.push(masterId);
            return false;
        }
        return record.version === 15;
    });
    return ids;
}
function $08414ea58bdc1292$var$parseSlideMasterMetadata(bytes, start, end) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let masterIdRef;
    let inheritMasterObjects = true;
    $08414ea58bdc1292$var$walkRecords(bytes, start, end, (record)=>{
        if (record.type !== $08414ea58bdc1292$var$SLIDE_ATOM || record.end - record.payloadStart < 22) return record.version === 15;
        masterIdRef = view3.getUint32(record.payloadStart + 12, true);
        inheritMasterObjects = (view3.getUint16(record.payloadStart + 20, true) & 1) !== 0;
        return false;
    });
    return {
        masterIdRef: masterIdRef,
        inheritMasterObjects: inheritMasterObjects
    };
}
function $08414ea58bdc1292$var$parseShapeContainers(bytes, start, end, slideWidth, slideHeight) {
    const shapes = [];
    for (const record of $08414ea58bdc1292$var$readDirectRecords(bytes, start, end)){
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_SPGR_CONTAINER) {
            shapes.push(...$08414ea58bdc1292$var$parseShapeGroup(bytes, record.payloadStart, record.end, slideWidth, slideHeight));
            continue;
        }
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_SP_CONTAINER) {
            const shape = $08414ea58bdc1292$var$parseShape(bytes, record.payloadStart, record.end, slideWidth, slideHeight, true);
            if (shape && $08414ea58bdc1292$var$isRenderableShape(shape)) shapes.push(shape);
            continue;
        }
        if (record.version === 15) shapes.push(...$08414ea58bdc1292$var$parseShapeContainers(bytes, record.payloadStart, record.end, slideWidth, slideHeight));
    }
    return shapes;
}
function $08414ea58bdc1292$var$parseShapeGroup(bytes, start, end, slideWidth, slideHeight) {
    const records = $08414ea58bdc1292$var$readDirectRecords(bytes, start, end);
    const descriptor = records.find((record)=>record.type === $08414ea58bdc1292$var$OFFICE_ART_SP_CONTAINER && Boolean($08414ea58bdc1292$var$parseGroupBounds(bytes, record.payloadStart, record.end)));
    const bounds = descriptor ? $08414ea58bdc1292$var$parseGroupBounds(bytes, descriptor.payloadStart, descriptor.end) : void 0;
    const placement = descriptor ? $08414ea58bdc1292$var$parseShape(bytes, descriptor.payloadStart, descriptor.end, slideWidth, slideHeight, false) : void 0;
    const shapes = [];
    for (const record of records){
        if (record === descriptor) continue;
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_SPGR_CONTAINER) {
            shapes.push(...$08414ea58bdc1292$var$parseShapeGroup(bytes, record.payloadStart, record.end, slideWidth, slideHeight));
            continue;
        }
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_SP_CONTAINER) {
            const shape = $08414ea58bdc1292$var$parseShape(bytes, record.payloadStart, record.end, slideWidth, slideHeight, false);
            if (shape && $08414ea58bdc1292$var$isRenderableShape(shape)) shapes.push(shape);
        }
    }
    if (!bounds || !placement || bounds.width === 0 || bounds.height === 0) return shapes;
    return shapes.map((shape)=>$08414ea58bdc1292$var$transformGroupedShape(shape, bounds, placement));
}
function $08414ea58bdc1292$var$parseGroupBounds(bytes, start, end) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let bounds;
    $08414ea58bdc1292$var$walkRecords(bytes, start, end, (record)=>{
        if (record.type !== $08414ea58bdc1292$var$OFFICE_ART_SPGR_ATOM || record.end - record.payloadStart < 16) return record.version === 15;
        const left = view3.getInt32(record.payloadStart, true);
        const top = view3.getInt32(record.payloadStart + 4, true);
        const right = view3.getInt32(record.payloadStart + 8, true);
        const bottom = view3.getInt32(record.payloadStart + 12, true);
        bounds = {
            left: left,
            top: top,
            width: right - left,
            height: bottom - top
        };
        return false;
    });
    return bounds;
}
function $08414ea58bdc1292$var$transformGroupedShape(shape, bounds, placement) {
    return {
        ...shape,
        left: placement.left + (shape.left - bounds.left) / bounds.width * placement.width,
        top: placement.top + (shape.top - bounds.top) / bounds.height * placement.height,
        width: shape.width / bounds.width * placement.width,
        height: shape.height / bounds.height * placement.height
    };
}
function $08414ea58bdc1292$var$parseShape(bytes, start, end, slideWidth, slideHeight, normalizeChildAnchor) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const textBlocks = [];
    const textStylePayloads = [];
    const imageIndices = [];
    const visual = {};
    let textType;
    let anchor;
    $08414ea58bdc1292$var$walkRecords(bytes, start, end, (record)=>{
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_SP_CONTAINER) return false;
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_CLIENT_ANCHOR && record.end - record.payloadStart >= 8) {
            const large = record.end - record.payloadStart >= 16;
            const coordinate = (index)=>large ? view3.getInt32(record.payloadStart + index * 4, true) : view3.getInt16(record.payloadStart + index * 2, true);
            const top = coordinate(0);
            const left = coordinate(1);
            const right = coordinate(2);
            const bottom = coordinate(3);
            anchor = {
                left: left,
                top: top,
                width: Math.max(1, right - left),
                height: Math.max(1, bottom - top)
            };
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_CHILD_ANCHOR && record.end - record.payloadStart >= 16) {
            const left = view3.getInt32(record.payloadStart, true);
            const top = view3.getInt32(record.payloadStart + 4, true);
            const right = view3.getInt32(record.payloadStart + 8, true);
            const bottom = view3.getInt32(record.payloadStart + 12, true);
            const childAnchor = {
                left: left,
                top: top,
                width: Math.max(1, right - left),
                height: Math.max(1, bottom - top)
            };
            anchor = normalizeChildAnchor ? $08414ea58bdc1292$var$normalizePresentationAnchor(childAnchor, slideWidth, slideHeight) : childAnchor;
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$TEXT_CHARS_ATOM || record.type === $08414ea58bdc1292$var$TEXT_BYTES_ATOM) {
            const decoded = $08414ea58bdc1292$var$decodePresentationText(bytes.subarray(record.payloadStart, record.end), record.type === $08414ea58bdc1292$var$TEXT_CHARS_ATOM);
            if (decoded) textBlocks.push(decoded);
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$STYLE_TEXT_PROP_ATOM) {
            textStylePayloads.push(bytes.subarray(record.payloadStart, record.end));
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$TEXT_HEADER_ATOM && record.end - record.payloadStart >= 4) {
            textType = view3.getUint32(record.payloadStart, true);
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_FSP) {
            visual.shapeType = record.instance;
            if (record.end - record.payloadStart >= 8) {
                const flags = view3.getUint32(record.payloadStart + 4, true);
                visual.flipHorizontal = (flags & 64) !== 0;
                visual.flipVertical = (flags & 128) !== 0;
            }
            return false;
        }
        if (record.type === $08414ea58bdc1292$var$OFFICE_ART_FOPT) {
            $08414ea58bdc1292$var$collectImageReferences(view3, record, imageIndices);
            $08414ea58bdc1292$var$collectShapeProperties(view3, record, visual);
            return false;
        }
        return record.version === 15;
    });
    if (!anchor) return void 0;
    const formattedTexts = textBlocks.map((text, index)=>$08414ea58bdc1292$var$parseStyleTextPropAtom(text, textStylePayloads[index]));
    return {
        ...anchor,
        texts: $08414ea58bdc1292$var$uniqueStrings(textBlocks),
        ...textStylePayloads.length > 0 ? {
            formattedTexts: formattedTexts
        } : {},
        imageIndices: [
            ...new Set(imageIndices)
        ],
        ...visual,
        ...textType === void 0 ? {} : {
            textType: textType
        }
    };
}
function $08414ea58bdc1292$var$parseStyleTextPropAtom(text, payload) {
    const formatted = {
        text: text,
        characterRuns: [],
        paragraphRuns: []
    };
    if (!payload || payload.byteLength < 10) return formatted;
    const view3 = new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
    const formattedLength = text.length + 1;
    let offset = 0;
    let covered = 0;
    while(covered < formattedLength && offset + 10 <= payload.byteLength){
        const count = view3.getUint32(offset, true);
        offset += 4;
        const indentLevel = view3.getUint16(offset, true);
        offset += 2;
        const parsed = $08414ea58bdc1292$var$parseTextParagraphException(view3, offset, payload.byteLength);
        if (!parsed) return formatted;
        offset = parsed.offset;
        formatted.paragraphRuns.push({
            start: covered,
            length: Math.min(count, Math.max(0, text.length - covered)),
            indentLevel: indentLevel,
            ...parsed.style
        });
        covered += count;
        if (count === 0) return formatted;
    }
    covered = 0;
    while(covered < formattedLength && offset + 8 <= payload.byteLength){
        const count = view3.getUint32(offset, true);
        offset += 4;
        const parsed = $08414ea58bdc1292$var$parseTextCharacterException(view3, offset, payload.byteLength);
        if (!parsed) break;
        offset = parsed.offset;
        formatted.characterRuns.push({
            start: covered,
            length: Math.min(count, Math.max(0, text.length - covered)),
            ...parsed.style
        });
        covered += count;
        if (count === 0) break;
    }
    return formatted;
}
function $08414ea58bdc1292$var$parseTextParagraphException(view3, start, end) {
    if (start + 4 > end) return void 0;
    const masks = view3.getUint32(start, true);
    let offset = start + 4;
    const take = (size)=>{
        if (offset + size > end) return false;
        offset += size;
        return true;
    };
    const readInt162 = ()=>{
        if (offset + 2 > end) return void 0;
        const value = view3.getInt16(offset, true);
        offset += 2;
        return value;
    };
    if ((masks & 15) !== 0 && !take(2)) return void 0;
    if ((masks & 128) !== 0 && !take(2)) return void 0;
    if ((masks & 16) !== 0 && !take(2)) return void 0;
    if ((masks & 64) !== 0 && !take(2)) return void 0;
    if ((masks & 32) !== 0 && !take(4)) return void 0;
    let alignment;
    if ((masks & 2048) !== 0) {
        const value = readInt162();
        if (value === void 0) return void 0;
        alignment = value === 1 || value === 4 || value === 5 ? "center" : value === 2 ? "right" : value === 3 || value === 6 ? "justify" : "left";
    }
    let lineSpacing;
    if ((masks & 4096) !== 0) {
        const value = readInt162();
        if (value === void 0) return void 0;
        lineSpacing = value > 0 ? value / 100 : void 0;
    }
    if ((masks & 8192) !== 0 && !take(2)) return void 0;
    if ((masks & 16384) !== 0 && !take(2)) return void 0;
    if ((masks & 256) !== 0 && !take(2)) return void 0;
    if ((masks & 1024) !== 0 && !take(2)) return void 0;
    if ((masks & 32768) !== 0 && !take(2)) return void 0;
    if ((masks & 1048576) !== 0) {
        const count = readInt162();
        if (count === void 0 || count < 0 || !take(count * 4)) return void 0;
    }
    if ((masks & 65536) !== 0 && !take(2)) return void 0;
    if ((masks & 917504) !== 0 && !take(2)) return void 0;
    if ((masks & 2097152) !== 0 && !take(2)) return void 0;
    return {
        offset: offset,
        style: {
            ...alignment ? {
                alignment: alignment
            } : {},
            ...lineSpacing ? {
                lineSpacing: lineSpacing
            } : {}
        }
    };
}
function $08414ea58bdc1292$var$parseTextCharacterException(view3, start, end) {
    if (start + 4 > end) return void 0;
    const masks = view3.getUint32(start, true);
    let offset = start + 4;
    const style = {};
    const take = (size)=>{
        if (offset + size > end) return false;
        offset += size;
        return true;
    };
    if ((masks & 16383) !== 0) {
        if (offset + 2 > end) return void 0;
        const fontStyle = view3.getUint16(offset, true);
        offset += 2;
        if ((masks & 1) !== 0) style.bold = (fontStyle & 1) !== 0;
        if ((masks & 2) !== 0) style.italic = (fontStyle & 2) !== 0;
        if ((masks & 4) !== 0) style.underline = (fontStyle & 4) !== 0;
    }
    if ((masks & 65536) !== 0) {
        if (offset + 2 > end) return void 0;
        style.fontRef = view3.getUint16(offset, true);
        offset += 2;
    }
    if ((masks & 2097152) !== 0 && !take(2)) return void 0;
    if ((masks & 4194304) !== 0 && !take(2)) return void 0;
    if ((masks & 8388608) !== 0 && !take(2)) return void 0;
    if ((masks & 131072) !== 0) {
        if (offset + 2 > end) return void 0;
        style.fontSize = view3.getInt16(offset, true);
        offset += 2;
    }
    if ((masks & 262144) !== 0) {
        if (offset + 4 > end) return void 0;
        const color = $08414ea58bdc1292$var$decodeTextColor(view3, offset);
        if (color) style.color = color;
        offset += 4;
    }
    if ((masks & 524288) !== 0 && !take(2)) return void 0;
    return {
        offset: offset,
        style: style
    };
}
function $08414ea58bdc1292$var$decodeTextColor(view3, offset) {
    const index = view3.getUint8(offset + 3);
    if (index !== 254) return void 0;
    return `#${[
        view3.getUint8(offset),
        view3.getUint8(offset + 1),
        view3.getUint8(offset + 2)
    ].map((channel)=>channel.toString(16).padStart(2, "0")).join("")}`;
}
function $08414ea58bdc1292$var$isRenderableShape(shape) {
    return shape.texts.length > 0 || shape.imageIndices.length > 0 || shape.fillEnabled === true || shape.lineEnabled === true;
}
function $08414ea58bdc1292$var$readDirectRecords(bytes, start, end) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const records = [];
    let offset = start;
    while(offset + 8 <= end){
        const record = $08414ea58bdc1292$var$readRecord(view3, offset, end);
        if (!record) break;
        records.push(record);
        if (record.end <= offset) break;
        offset = record.end;
    }
    return records;
}
function $08414ea58bdc1292$var$normalizePresentationAnchor(anchor, slideWidth, slideHeight) {
    const maximum = Math.max(Math.abs(anchor.left), Math.abs(anchor.top), Math.abs(anchor.left + anchor.width), Math.abs(anchor.top + anchor.height));
    if (maximum <= Math.max(slideWidth, slideHeight) * 16) return anchor;
    return {
        left: anchor.left / $08414ea58bdc1292$var$EMU_PER_MASTER_UNIT,
        top: anchor.top / $08414ea58bdc1292$var$EMU_PER_MASTER_UNIT,
        width: anchor.width / $08414ea58bdc1292$var$EMU_PER_MASTER_UNIT,
        height: anchor.height / $08414ea58bdc1292$var$EMU_PER_MASTER_UNIT
    };
}
function $08414ea58bdc1292$var$collectImageReferences(view3, record, target) {
    const propertyEnd = Math.min(record.end, record.payloadStart + record.instance * 6);
    for(let offset = record.payloadStart; offset + 6 <= propertyEnd; offset += 6){
        const propertyId = view3.getUint16(offset, true) & 16383;
        if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_PIB_PROPERTY) {
            const imageIndex = view3.getUint32(offset + 2, true);
            if (imageIndex > 0) target.push(imageIndex);
        }
    }
}
function $08414ea58bdc1292$var$collectShapeProperties(view3, record, target) {
    const propertyEnd = Math.min(record.end, record.payloadStart + record.instance * 6);
    for(let offset = record.payloadStart; offset + 6 <= propertyEnd; offset += 6){
        const propertyId = view3.getUint16(offset, true) & 16383;
        const value = view3.getUint32(offset + 2, true);
        if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_FILL_COLOR_PROPERTY) target.fillColor = $08414ea58bdc1292$var$decodeOfficeArtColor(value) || target.fillColor;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_FILL_STYLE_PROPERTY) target.fillEnabled = (value & 16) !== 0;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_LINE_COLOR_PROPERTY) target.lineColor = $08414ea58bdc1292$var$decodeOfficeArtColor(value) || target.lineColor;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_LINE_STYLE_PROPERTY) target.lineEnabled = (value & 8) !== 0;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_LINE_WIDTH_PROPERTY) target.lineWidth = Math.max(0.25, value / 12700);
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_ROTATION_PROPERTY) target.rotation = (value | 0) / 65536;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_TOP_PROPERTY) target.imageCropTop = (value | 0) / 65536;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_BOTTOM_PROPERTY) target.imageCropBottom = (value | 0) / 65536;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_LEFT_PROPERTY) target.imageCropLeft = (value | 0) / 65536;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_CROP_FROM_RIGHT_PROPERTY) target.imageCropRight = (value | 0) / 65536;
        else if (propertyId === $08414ea58bdc1292$var$OFFICE_ART_TEXT_FLOW_PROPERTY) target.verticalText = value === 1 || value === 3;
    }
}
function $08414ea58bdc1292$var$decodeOfficeArtColor(value) {
    if ((value & 4278190080) !== 0) return void 0;
    const red = value & 255;
    const green = value >>> 8 & 255;
    const blue = value >>> 16 & 255;
    return `#${[
        red,
        green,
        blue
    ].map((channel)=>channel.toString(16).padStart(2, "0")).join("")}`;
}
function $08414ea58bdc1292$var$parsePicturesStream(bytes) {
    const images = [];
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let offset = 0;
    let index = 1;
    while(offset + 8 <= bytes.byteLength){
        const record = $08414ea58bdc1292$var$readRecord(view3, offset, bytes.byteLength);
        if (!record) break;
        const payload = bytes.subarray(record.payloadStart, record.end);
        let image;
        if (record.type === $08414ea58bdc1292$var$BLIP_PNG) image = $08414ea58bdc1292$var$extractBitmap(payload, "image/png", [
            137,
            80,
            78,
            71,
            13,
            10,
            26,
            10
        ]);
        else if (record.type === $08414ea58bdc1292$var$BLIP_JPEG) image = $08414ea58bdc1292$var$extractBitmap(payload, "image/jpeg", [
            255,
            216,
            255
        ]);
        else if (record.type === $08414ea58bdc1292$var$BLIP_TIFF) image = $08414ea58bdc1292$var$extractTiff(payload);
        else if (record.type === $08414ea58bdc1292$var$BLIP_EMF) {
            const metafile = $08414ea58bdc1292$var$extractCompressedMetafile(payload);
            if (metafile) image = {
                kind: "emf",
                mimeType: "image/x-emf",
                bytes: metafile
            };
        } else if (record.type === $08414ea58bdc1292$var$BLIP_WMF) {
            const metafile = $08414ea58bdc1292$var$extractCompressedMetafile(payload);
            if (metafile) image = {
                kind: "wmf",
                mimeType: "image/x-wmf",
                bytes: metafile
            };
        }
        if (image) images.push({
            index: index,
            ...image
        });
        index += 1;
        offset = record.end;
    }
    return images;
}
function $08414ea58bdc1292$var$extractBitmap(payload, mimeType, signature) {
    const start = $08414ea58bdc1292$var$findBytes(payload, signature);
    if (start < 0) return void 0;
    let end = payload.byteLength;
    if (mimeType === "image/jpeg") {
        const marker = $08414ea58bdc1292$var$findBytes(payload, [
            255,
            217
        ], start + signature.length);
        if (marker >= 0) end = marker + 2;
    } else if (mimeType === "image/png") {
        const marker = $08414ea58bdc1292$var$findBytes(payload, [
            73,
            69,
            78,
            68,
            174,
            66,
            96,
            130
        ], start + signature.length);
        if (marker >= 0) end = marker + 8;
    }
    return {
        kind: "bitmap",
        mimeType: mimeType,
        bytes: payload.slice(start, end)
    };
}
function $08414ea58bdc1292$var$extractTiff(payload) {
    const littleEndian = $08414ea58bdc1292$var$findBytes(payload, [
        73,
        73,
        42,
        0
    ]);
    const bigEndian = $08414ea58bdc1292$var$findBytes(payload, [
        77,
        77,
        0,
        42
    ]);
    const start = littleEndian >= 0 && bigEndian >= 0 ? Math.min(littleEndian, bigEndian) : Math.max(littleEndian, bigEndian);
    return start < 0 ? void 0 : {
        kind: "bitmap",
        mimeType: "image/tiff",
        bytes: payload.slice(start)
    };
}
function $08414ea58bdc1292$var$extractCompressedMetafile(payload) {
    for (const uidBytes of [
        16,
        32
    ]){
        const headerOffset = uidBytes;
        const dataOffset = headerOffset + 34;
        if (dataOffset > payload.byteLength) continue;
        const view3 = new DataView(payload.buffer, payload.byteOffset + headerOffset, payload.byteLength - headerOffset);
        const uncompressedSize = view3.getUint32(0, true);
        const savedSize = view3.getUint32(28, true);
        const compression = view3.getUint8(32);
        if (uncompressedSize === 0 || uncompressedSize > 134217728 || savedSize === 0 || dataOffset + savedSize > payload.byteLength) continue;
        const data = payload.subarray(dataOffset, dataOffset + savedSize);
        try {
            if (compression === 0) {
                const result = (0, $cab713332464fe22$export$cae1ce83fe4a1782)(data);
                if (result.byteLength === uncompressedSize) return result;
            } else if (compression === 254 && data.byteLength === uncompressedSize) return data.slice();
        } catch  {}
    }
    return void 0;
}
function $08414ea58bdc1292$var$walkRecords(bytes, start, end, visitor) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let offset = start;
    while(offset + 8 <= end){
        const record = $08414ea58bdc1292$var$readRecord(view3, offset, end);
        if (!record) return;
        if (visitor(record) && record.payloadStart < record.end) $08414ea58bdc1292$var$walkRecords(bytes, record.payloadStart, record.end, visitor);
        if (record.end <= offset) return;
        offset = record.end;
    }
}
function $08414ea58bdc1292$var$readRecord(view3, offset, end) {
    if (offset < 0 || offset + 8 > end || offset + 8 > view3.byteLength) return void 0;
    const versionAndInstance = view3.getUint16(offset, true);
    const length = view3.getUint32(offset + 4, true);
    const payloadStart = offset + 8;
    const recordEnd = payloadStart + length;
    if (recordEnd > end || recordEnd > view3.byteLength || recordEnd < payloadStart) return void 0;
    return {
        start: offset,
        payloadStart: payloadStart,
        end: recordEnd,
        version: versionAndInstance & 15,
        instance: versionAndInstance >>> 4,
        type: view3.getUint16(offset + 2, true)
    };
}
function $08414ea58bdc1292$var$decodePresentationText(bytes, utf16) {
    const decoder = new TextDecoder(utf16 ? "utf-16le" : "windows-1252");
    return decoder.decode(bytes).replace(/\u0000/g, "").replace(/\r\n?/g, "\n").replace(/[\t ]+\n/g, "\n").trim();
}
function $08414ea58bdc1292$var$deduplicateShapes(shapes) {
    const seen = /* @__PURE__ */ new Set();
    return shapes.filter((shape)=>{
        const key = `${shape.left}:${shape.top}:${shape.width}:${shape.height}:${shape.textType ?? ""}:${shape.shapeType ?? ""}:${shape.fillColor ?? ""}:${shape.lineColor ?? ""}:${shape.fillEnabled ?? ""}:${shape.lineEnabled ?? ""}:${shape.lineWidth ?? ""}:${shape.rotation ?? ""}:${shape.imageIndices.join(",")}:${shape.texts.join("")}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function $08414ea58bdc1292$var$uniqueStrings(values) {
    return [
        ...new Set(values.filter(Boolean))
    ];
}
function $08414ea58bdc1292$var$findBytes(haystack, needle, from = 0) {
    outer: for(let index = Math.max(0, from); index <= haystack.byteLength - needle.length; index += 1){
        for(let part = 0; part < needle.length; part += 1){
            if (haystack[index + part] !== needle[part]) continue outer;
        }
        return index;
    }
    return -1;
}
function $08414ea58bdc1292$var$asUint8Array(value) {
    if (value instanceof Uint8Array) return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
    if (value instanceof ArrayBuffer) return new Uint8Array(value);
    if (ArrayBuffer.isView(value)) return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
    if (Array.isArray(value)) return Uint8Array.from(value);
    throw new Error("Unsupported OLE stream payload.");
}
function $08414ea58bdc1292$var$hasCompoundFileSignature(bytes) {
    const signature = [
        208,
        207,
        17,
        224,
        161,
        177,
        26,
        225
    ];
    return signature.every((byte, index)=>bytes[index] === byte);
}
// src/plugins/office.ts
var $08414ea58bdc1292$var$wordExtensions = /* @__PURE__ */ new Set([
    "docx",
    "docm",
    "doc",
    "dotx",
    "dotm",
    "dot",
    "rtf",
    "odt",
    "fodt",
    "wps"
]);
var $08414ea58bdc1292$var$sheetExtensions = /* @__PURE__ */ new Set([
    "xlsx",
    "xls",
    "xlsm",
    "xlsb",
    "xlt",
    "xltx",
    "xltm",
    "csv",
    "tsv",
    "ods",
    "fods",
    "numbers",
    "et"
]);
var $08414ea58bdc1292$var$presentationExtensions = /* @__PURE__ */ new Set([
    "pptx",
    "pptm",
    "ppt",
    "pps",
    "ppsx",
    "ppsm",
    "potx",
    "potm",
    "odp",
    "fodp",
    "key",
    "dps"
]);
var $08414ea58bdc1292$var$packagedOfficeCandidates = /* @__PURE__ */ new Set([
    "wps",
    "et",
    "dps",
    "numbers",
    "key"
]);
var $08414ea58bdc1292$var$SHEET_WINDOW_ROWS = 200;
var $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS = 80;
var $08414ea58bdc1292$var$DEFAULT_DOCX_RENDER_TIMEOUT_MS = 15e3;
var $08414ea58bdc1292$var$DEFAULT_PPTX_RENDER_TIMEOUT_MS = 12e3;
var $08414ea58bdc1292$var$ZIP_SNIFF_TIMEOUT_MS = 1e4;
function $08414ea58bdc1292$var$loadZipForSniffing(arrayBuffer) {
    return $08414ea58bdc1292$var$withTimeout((0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer), $08414ea58bdc1292$var$ZIP_SNIFF_TIMEOUT_MS, "Office package sniffing");
}
var $08414ea58bdc1292$var$PPTX_REL_NS = "http://schemas.openxmlformats.org/package/2006/relationships";
var $08414ea58bdc1292$var$officeMimeTypes = /* @__PURE__ */ new Set([
    "application/msword",
    "application/rtf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-word.document.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "application/vnd.ms-word.template.macroenabled.12",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.text-flat-xml",
    "application/vnd.ms-works",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.ms-excel.sheet.macroenabled.12",
    "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    "application/vnd.ms-excel.template.macroenabled.12",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.spreadsheet-flat-xml",
    "application/vnd.apple.numbers",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-powerpoint.presentation.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.presentationml.template",
    "application/vnd.ms-powerpoint.template.macroenabled.12",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.presentation-flat-xml",
    "application/vnd.apple.keynote"
]);
var $08414ea58bdc1292$var$officeMimeFormatMap = {
    "application/msword": "doc",
    "application/rtf": "rtf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/vnd.ms-word.document.macroenabled.12": "docm",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
    "application/vnd.ms-word.template.macroenabled.12": "dotm",
    "application/vnd.oasis.opendocument.text": "odt",
    "application/vnd.oasis.opendocument.text-flat-xml": "fodt",
    "application/vnd.ms-works": "wps",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
    "application/vnd.ms-excel.sheet.macroenabled.12": "xlsm",
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
    "application/vnd.ms-excel.template.macroenabled.12": "xltm",
    "application/vnd.oasis.opendocument.spreadsheet": "ods",
    "application/vnd.oasis.opendocument.spreadsheet-flat-xml": "fods",
    "application/vnd.apple.numbers": "numbers",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
    "application/vnd.openxmlformats-officedocument.presentationml.template": "potx",
    "application/vnd.ms-powerpoint.template.macroenabled.12": "potm",
    "application/vnd.oasis.opendocument.presentation": "odp",
    "application/vnd.oasis.opendocument.presentation-flat-xml": "fodp",
    "application/vnd.apple.keynote": "key"
};
function $08414ea58bdc1292$export$e6d7427d8e3dcbbe(options = {}) {
    return {
        name: "office",
        match (file) {
            return $08414ea58bdc1292$var$wordExtensions.has(file.extension) || $08414ea58bdc1292$var$sheetExtensions.has(file.extension) || $08414ea58bdc1292$var$presentationExtensions.has(file.extension) || $08414ea58bdc1292$var$officeMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-office");
            ctx.viewport.append(panel);
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$officeMimeFormatMap);
            const arrayBuffer = await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file);
            const packageFormat = $08414ea58bdc1292$var$shouldSniffPackagedOffice(extension) ? await $08414ea58bdc1292$var$detectPackagedOfficeFormat(arrayBuffer) : void 0;
            const wordHtml = packageFormat ? void 0 : $08414ea58bdc1292$var$detectWordHtmlDocument(extension, arrayBuffer);
            const wordXml = packageFormat || wordHtml ? void 0 : $08414ea58bdc1292$var$detectWord2003XmlDocument(extension, arrayBuffer);
            let disposeDocxFit;
            let disposeLegacyPresentation;
            let disposePptx;
            let delegatedInstance;
            const conversionContext = wordXml ? void 0 : await $08414ea58bdc1292$var$createOfficeConversionContext(ctx, arrayBuffer, extension, packageFormat);
            if (conversionContext && await $08414ea58bdc1292$var$shouldUseOfficeConversion(options, conversionContext)) delegatedInstance = await $08414ea58bdc1292$var$renderConvertedOfficePreview(panel, ctx, options, conversionContext);
            else if (wordHtml) $08414ea58bdc1292$var$renderWordHtmlDocument(panel, wordHtml);
            else if (wordXml) $08414ea58bdc1292$var$renderWord2003XmlDocument(panel, wordXml);
            else if (packageFormat === "docx" && !$08414ea58bdc1292$var$fileIsDocx(extension)) disposeDocxFit = await $08414ea58bdc1292$var$renderDocx(panel, arrayBuffer, ctx.options.fit, options.docx);
            else if (packageFormat === "xlsx" && !$08414ea58bdc1292$var$sheetExtensions.has(extension)) await $08414ea58bdc1292$var$renderSheet(panel, arrayBuffer, "xlsx", ctx.options.messages);
            else if (packageFormat === "pptx" && ![
                "pptx",
                "pptm",
                "ppsx",
                "ppsm",
                "potx",
                "potm"
            ].includes(extension)) disposePptx = await $08414ea58bdc1292$var$renderPptx(panel, arrayBuffer);
            else if ($08414ea58bdc1292$var$fileIsDocx(extension)) disposeDocxFit = await $08414ea58bdc1292$var$renderDocx(panel, arrayBuffer, ctx.options.fit, options.docx);
            else if (extension === "rtf") $08414ea58bdc1292$var$renderPlainDocument(panel, "RTF \u6587\u6863", $08414ea58bdc1292$var$rtfToText(await $08414ea58bdc1292$var$readTextFromBuffer(arrayBuffer)));
            else if (extension === "odt") await $08414ea58bdc1292$var$renderOdt(panel, arrayBuffer);
            else if (extension === "fodt") $08414ea58bdc1292$var$renderOpenDocumentXml(panel, "FODT \u6587\u6863", await $08414ea58bdc1292$var$readTextFromBuffer(arrayBuffer));
            else if (extension === "fods") $08414ea58bdc1292$var$renderFlatOds(panel, await $08414ea58bdc1292$var$readTextFromBuffer(arrayBuffer));
            else if ($08414ea58bdc1292$var$packagedOfficeCandidates.has(extension) && await $08414ea58bdc1292$var$renderPackagedOfficePreview(panel, arrayBuffer, extension, ctx.options.fit, ctx.options.messages, options.docx)) ;
            else if ($08414ea58bdc1292$var$sheetExtensions.has(extension)) await $08414ea58bdc1292$var$renderSheet(panel, arrayBuffer, extension, ctx.options.messages);
            else if ([
                "pptx",
                "pptm",
                "ppsx",
                "ppsm",
                "potx",
                "potm"
            ].includes(extension)) disposePptx = await $08414ea58bdc1292$var$renderPptx(panel, arrayBuffer);
            else if (extension === "odp") await $08414ea58bdc1292$var$renderOdp(panel, arrayBuffer);
            else if (extension === "fodp") $08414ea58bdc1292$var$renderOpenDocumentPresentationXml(panel, await $08414ea58bdc1292$var$readTextFromBuffer(arrayBuffer));
            else if (extension === "doc" || extension === "dot") $08414ea58bdc1292$var$renderLegacyWordBinary(panel, extension, arrayBuffer, ctx.options.messages);
            else if (extension === "ppt" || extension === "pps") try {
                disposeLegacyPresentation = await $08414ea58bdc1292$var$renderLegacyPowerPoint(panel, arrayBuffer);
            } catch (error) {
                $08414ea58bdc1292$var$renderLegacyOfficeBinary(panel, extension, arrayBuffer, ctx.options.messages, $08414ea58bdc1292$var$normalizeOfficeError(error, ctx.options.messages));
            }
            else if ($08414ea58bdc1292$var$isLegacyOfficeBinary(extension)) $08414ea58bdc1292$var$renderLegacyOfficeBinary(panel, extension, arrayBuffer, ctx.options.messages);
            else $08414ea58bdc1292$var$renderUnsupportedOffice(panel, extension || ctx.file.extension || "office", ctx.options.messages);
            const controller = $08414ea58bdc1292$var$createOfficeZoomController(panel, ctx);
            ctx.toolbar?.refreshCommandSupport();
            return {
                goToPage (page) {
                    return delegatedInstance?.goToPage?.(page) || (0, $3438a2478d5b847f$export$e2c778f3bf6f56a7)(panel, ".ofv-docx-page-frame, .ofv-docx-textbox-page, .ofv-wordml-page, .ofv-msdoc-page, .ofv-slide, .ofv-ppt-binary-slide", page, panel);
                },
                canCommand (command) {
                    return delegatedInstance?.canCommand?.(command) || controller?.canCommand(command) || false;
                },
                command (command) {
                    return delegatedInstance?.command?.(command) || controller?.command(command) || false;
                },
                preparePrint () {
                    return delegatedInstance?.preparePrint?.();
                },
                destroy () {
                    delegatedInstance?.destroy();
                    controller?.destroy();
                    disposeDocxFit?.();
                    disposeLegacyPresentation?.();
                    disposePptx?.();
                    panel.remove();
                }
            };
        }
    };
}
async function $08414ea58bdc1292$var$createOfficeConversionContext(ctx, arrayBuffer, extension, detectedFormat) {
    const effectiveFormat = detectedFormat || extension;
    if ((effectiveFormat === "docx" || $08414ea58bdc1292$var$fileIsDocx(extension)) && await $08414ea58bdc1292$var$docxShouldPreferTextboxLayoutFallback(arrayBuffer)) return {
        file: ctx.file,
        arrayBuffer: arrayBuffer,
        extension: extension,
        detectedFormat: detectedFormat,
        reason: "complex-docx"
    };
    if ($08414ea58bdc1292$var$isLegacyOfficeBinary(extension)) return {
        file: ctx.file,
        arrayBuffer: arrayBuffer,
        extension: extension,
        detectedFormat: detectedFormat,
        reason: "legacy-office"
    };
    return void 0;
}
async function $08414ea58bdc1292$var$shouldUseOfficeConversion(options, context) {
    if (!options.convert) return false;
    if (typeof options.preferConversion === "function") return Boolean(await options.preferConversion(context));
    if (options.preferConversion !== void 0) return options.preferConversion;
    return context.reason === "complex-docx" || context.reason === "legacy-office";
}
async function $08414ea58bdc1292$var$renderConvertedOfficePreview(panel, ctx, options, conversionContext) {
    if (!options.convert) throw new Error("Office conversion handler is not configured.");
    const converted = $08414ea58bdc1292$var$normalizeOfficeConversionResult(await options.convert(conversionContext), ctx.file.name);
    if (!converted) throw new Error("Office conversion handler did not return a previewable file.");
    if (converted.mimeType !== "application/pdf" && !converted.fileName.toLowerCase().endsWith(".pdf")) throw new Error("Office conversion handler must return a PDF Blob, ArrayBuffer or URL.");
    return (0, $3438a2478d5b847f$export$b882f3782d993632)({
        ...options.pdf || {},
        fileName: converted.fileName,
        fileUrl: converted.fileUrl,
        fileSize: converted.fileSize,
        isExternal: !converted.revokeUrlOnDestroy,
        viewport: panel,
        size: ctx.size,
        fit: ctx.options.fit,
        zoom: ctx.options.zoom,
        toolbar: ctx.toolbar,
        messages: ctx.options.messages,
        title: ctx.options.messages.officeConvertedTitle,
        fallbackTitle: ctx.options.messages.officeConvertedPdfFailed,
        revokeUrlOnDestroy: converted.revokeUrlOnDestroy
    });
}
function $08414ea58bdc1292$var$normalizeOfficeConversionResult(result, sourceFileName) {
    if (!result) return void 0;
    const fallbackFileName = `${$08414ea58bdc1292$var$stripFileExtension(sourceFileName) || "office-preview"}.pdf`;
    if (typeof result === "string") return {
        fileName: fallbackFileName,
        fileUrl: result,
        mimeType: "application/pdf",
        revokeUrlOnDestroy: false
    };
    if (result instanceof ArrayBuffer) {
        const blob = new Blob([
            result
        ], {
            type: "application/pdf"
        });
        return $08414ea58bdc1292$var$createConvertedOfficeBlobPreview(blob, fallbackFileName);
    }
    if (result instanceof Blob) return $08414ea58bdc1292$var$createConvertedOfficeBlobPreview(result, fallbackFileName);
    if (result.url) return {
        fileName: result.fileName || fallbackFileName,
        fileUrl: result.url,
        mimeType: result.mimeType || "application/pdf",
        revokeUrlOnDestroy: false
    };
    const data = result.blob || result.data;
    if (data instanceof ArrayBuffer) {
        const blob = new Blob([
            data
        ], {
            type: result.mimeType || "application/pdf"
        });
        return $08414ea58bdc1292$var$createConvertedOfficeBlobPreview(blob, result.fileName || fallbackFileName);
    }
    if (data instanceof Blob) return $08414ea58bdc1292$var$createConvertedOfficeBlobPreview(data, result.fileName || fallbackFileName);
    return void 0;
}
function $08414ea58bdc1292$var$createConvertedOfficeBlobPreview(blob, fileName) {
    return {
        fileName: fileName,
        fileUrl: URL.createObjectURL(blob),
        fileSize: blob.size,
        mimeType: blob.type || "application/pdf",
        revokeUrlOnDestroy: true
    };
}
function $08414ea58bdc1292$var$stripFileExtension(fileName) {
    return fileName.replace(/\.[^.]+$/, "");
}
function $08414ea58bdc1292$var$createOfficeZoomController(panel, ctx) {
    const canZoom = Boolean(panel.querySelector(".ofv-docx-document, .ofv-sheet, .ofv-pptx-viewer > div, .ofv-ppt-binary-slide, .ofv-document, .ofv-text-block, .ofv-slide, .ofv-wordml-document, .ofv-msdoc-document"));
    if (!canZoom) return void 0;
    let zoom = (0, $3438a2478d5b847f$export$218693075858efcb)(ctx, 0.5, 3);
    const presentationPages = ()=>Array.from(panel.querySelectorAll(".ofv-pptx-viewer > div[data-slide-index], .ofv-ppt-binary-slide, .ofv-slide"));
    const apply = ()=>{
        const pages = presentationPages();
        const scroller = $08414ea58bdc1292$var$getPresentationScroller(panel);
        const anchor = (0, $3438a2478d5b847f$export$449ea97f0d46522e)(scroller, pages);
        panel.style.setProperty("--ofv-office-zoom", String(zoom));
        panel.dispatchEvent(new CustomEvent("ofv-office-zoom"));
        for (const slide of panel.querySelectorAll(".ofv-pptx-viewer > div[data-slide-index]")){
            slide.style.transform = "";
            slide.style.transformOrigin = "";
            $08414ea58bdc1292$var$setElementZoom(slide, zoom === 1 ? "" : String(zoom));
            slide.style.width = zoom === 1 ? "" : "max-content";
            slide.style.maxWidth = zoom === 1 ? "" : "none";
            slide.style.overflow = zoom === 1 ? "" : "visible";
        }
        for (const slide of panel.querySelectorAll(".ofv-ppt-binary-slide"))$08414ea58bdc1292$var$setElementZoom(slide, zoom === 1 ? "" : String(zoom));
        for (const scrollBox of panel.querySelectorAll(".ofv-table-scroll"))$08414ea58bdc1292$var$syncSheetTableZoom(scrollBox, zoom);
        ctx.toolbar?.setZoom(zoom);
        (0, $3438a2478d5b847f$export$c0bc1c93b9d1d8ba)(scroller, pages, anchor);
    };
    apply();
    panel.addEventListener("ofv-pptx-render-complete", apply);
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom = Math.min(3, Number((zoom + 0.12).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-out") {
                zoom = Math.max(0.5, Number((zoom - 0.12).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                zoom = 1;
                apply();
                return true;
            }
            return false;
        },
        destroy () {
            panel.removeEventListener("ofv-pptx-render-complete", apply);
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$getPresentationScroller(panel) {
    const viewport = panel.closest(".ofv-viewport") || panel;
    let element = panel.querySelector(".ofv-pptx-viewer") || panel;
    while(element !== viewport){
        if (element.clientHeight > 0 && element.scrollHeight > element.clientHeight && /auto|scroll/.test(getComputedStyle(element).overflowY)) return element;
        element = element.parentElement || viewport;
    }
    return viewport;
}
function $08414ea58bdc1292$var$setElementZoom(element, value) {
    element.style.zoom = value;
}
function $08414ea58bdc1292$var$getOfficePanelZoom(element) {
    const panel = element.closest(".ofv-panel");
    const parsed = Number.parseFloat(panel?.style.getPropertyValue("--ofv-office-zoom") || "1");
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}
function $08414ea58bdc1292$var$syncSheetTableZoom(scrollBox, zoom) {
    const table = scrollBox.querySelector(":scope > table");
    if (!table) return;
    if (zoom === 1) {
        if (table.dataset.ofvZoomBase !== void 0) {
            table.style.width = table.dataset.ofvZoomNaturalWidth || "";
            table.style.minWidth = "";
            $08414ea58bdc1292$var$setElementZoom(table, "");
            delete table.dataset.ofvZoomBase;
            delete table.dataset.ofvZoomNaturalWidth;
        }
        return;
    }
    if (table.dataset.ofvZoomBase === void 0) {
        const naturalWidth = table.style.width;
        $08414ea58bdc1292$var$setElementZoom(table, "");
        table.style.minWidth = "";
        table.style.width = naturalWidth;
        const measured = table.offsetWidth || Number.parseFloat(naturalWidth) || 0;
        if (measured <= 0) return;
        table.dataset.ofvZoomBase = String(measured);
        table.dataset.ofvZoomNaturalWidth = naturalWidth;
    }
    table.style.width = `${table.dataset.ofvZoomBase}px`;
    table.style.minWidth = "0";
    $08414ea58bdc1292$var$setElementZoom(table, String(zoom));
}
function $08414ea58bdc1292$var$resetSheetTableZoomLock(table) {
    if (table.dataset.ofvZoomBase === void 0) return;
    table.style.minWidth = "";
    $08414ea58bdc1292$var$setElementZoom(table, "");
    delete table.dataset.ofvZoomBase;
    delete table.dataset.ofvZoomNaturalWidth;
    const scrollBox = table.closest(".ofv-table-scroll");
    if (scrollBox) $08414ea58bdc1292$var$syncSheetTableZoom(scrollBox, $08414ea58bdc1292$var$getOfficePanelZoom(table));
}
function $08414ea58bdc1292$var$fileIsDocx(extension) {
    return extension === "docx" || extension === "docm" || extension === "dotx" || extension === "dotm";
}
function $08414ea58bdc1292$var$shouldSniffPackagedOffice(extension) {
    return $08414ea58bdc1292$var$isLegacyOfficeBinary(extension) || $08414ea58bdc1292$var$packagedOfficeCandidates.has(extension) || extension === "";
}
async function $08414ea58bdc1292$var$detectPackagedOfficeFormat(arrayBuffer) {
    try {
        const zip = await $08414ea58bdc1292$var$loadZipForSniffing(arrayBuffer);
        const entries = Object.values(zip.files).filter((entry)=>!entry.dir);
        const hasEntry = (path)=>entries.some((entry)=>entry.name.toLowerCase() === path.toLowerCase());
        if (hasEntry("word/document.xml")) return "docx";
        if (hasEntry("xl/workbook.xml")) return "xlsx";
        if (hasEntry("ppt/presentation.xml")) return "pptx";
    } catch  {
        return void 0;
    }
    return void 0;
}
function $08414ea58bdc1292$var$detectWordHtmlDocument(extension, arrayBuffer) {
    if (extension !== "doc" && extension !== "dot") return void 0;
    if ($08414ea58bdc1292$var$hasOleSignature(arrayBuffer)) return void 0;
    const html = (0, $3438a2478d5b847f$export$62387d23696f2b23)(arrayBuffer).replace(/^\uFEFF/, "");
    return /^\s*(?:<!doctype\s+html[^>]*>\s*)?<html(?:\s|>)/i.test(html) && /<body(?:\s|>)/i.test(html) ? html : void 0;
}
function $08414ea58bdc1292$var$renderWordHtmlDocument(panel, html) {
    panel.classList.add("ofv-office-word-html");
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("Word HTML \u6587\u6863");
    $08414ea58bdc1292$var$hideSuccessfulSectionHeading(section);
    const content = document.createElement("article");
    content.className = "ofv-document ofv-word-html-document";
    content.innerHTML = $08414ea58bdc1292$var$sanitizeHtml(parsed.body.innerHTML || "<p>\u672A\u89E3\u6790\u5230\u53EF\u5C55\u793A\u5185\u5BB9\u3002</p>");
    section.append(content);
    panel.append(section);
}
async function $08414ea58bdc1292$var$renderDocx(panel, arrayBuffer, fit, docxOptions) {
    panel.classList.add("ofv-office-docx");
    const content = document.createElement("div");
    content.className = "ofv-docx-document";
    const styleContainer = document.createElement("style");
    styleContainer.className = "ofv-docx-style-container";
    document.head.append(styleContainer);
    let disposeFit;
    try {
        await $08414ea58bdc1292$var$withTimeout((async ()=>{
            await $68b4bc55b173684a$export$e1ac4cfb687370e8(arrayBuffer, content, styleContainer, {
                className: "ofv-docx",
                inWrapper: true,
                breakPages: true,
                ignoreWidth: false,
                ignoreHeight: false,
                ignoreFonts: false,
                renderHeaders: true,
                renderFooters: true,
                renderFootnotes: true,
                renderEndnotes: true,
                renderComments: true,
                renderAltChunks: true,
                experimental: true,
                useBase64URL: true,
                ...docxOptions || {}
            });
        })(), $08414ea58bdc1292$var$docxRenderTimeoutMs(), "DOCX rendering");
        await new Promise((resolve)=>setTimeout(resolve, 0));
        await $08414ea58bdc1292$var$normalizeDocxLayout(content, arrayBuffer, styleContainer);
        $08414ea58bdc1292$var$sanitizeDocxPreview(content);
        const shouldUseTextboxFallback = await $08414ea58bdc1292$var$docxPreviewLooksBlank(content, arrayBuffer) || await $08414ea58bdc1292$var$docxPreviewMissesRichTextboxContent(content, arrayBuffer) || await $08414ea58bdc1292$var$docxShouldPreferTextboxLayoutFallback(arrayBuffer);
        if (shouldUseTextboxFallback) {
            disposeFit?.();
            styleContainer.remove();
            content.replaceChildren();
            await $08414ea58bdc1292$var$renderDocxContentFallback(content, arrayBuffer, {
                preferOpenXml: await $08414ea58bdc1292$var$docxHasRichTextboxContent(arrayBuffer)
            });
            panel.append(content);
            console.warn("DOCX layout preview missed readable textbox content, fell back to text extraction.");
            return ()=>void 0;
        }
        panel.append(content);
        $08414ea58bdc1292$var$paginateDocxFlow(content);
        $08414ea58bdc1292$var$repairDocxFirstPageClosingDate(content);
        $08414ea58bdc1292$var$synchronizeDocxPaginationAfterRepair(content);
        disposeFit = $08414ea58bdc1292$var$fitDocxPages(content, fit);
        return ()=>{
            disposeFit?.();
            styleContainer.remove();
        };
    } catch (error) {
        disposeFit?.();
        styleContainer.remove();
        const fallbackContent = document.createElement("div");
        fallbackContent.className = "ofv-docx-document";
        await $08414ea58bdc1292$var$renderDocxContentFallback(fallbackContent, arrayBuffer);
        panel.append(fallbackContent);
        console.warn("DOCX layout preview failed, fell back to Mammoth:", error);
    }
    return ()=>void 0;
}
function $08414ea58bdc1292$var$sanitizeDocxPreview(content) {
    const altChunks = /* @__PURE__ */ new Map();
    for (const frame of content.querySelectorAll("iframe")){
        if (frame.hasAttribute("srcdoc")) altChunks.set(frame, frame.srcdoc);
        frame.setAttribute("sandbox", "");
    }
    (0, $hIrjg.default).sanitize(content, {
        IN_PLACE: true,
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: true
        },
        ADD_TAGS: [
            "iframe",
            "foreignObject"
        ],
        ADD_ATTR: [
            "target",
            "sandbox"
        ]
    });
    for (const [frame, srcdoc] of altChunks)if (content.contains(frame) && frame.getAttribute("sandbox") === "") frame.srcdoc = (0, $hIrjg.default).sanitize(srcdoc, {
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: true
        }
    });
}
function $08414ea58bdc1292$var$docxRenderTimeoutMs() {
    const override = globalThis.__OFV_DOCX_RENDER_TIMEOUT_MS__;
    return typeof override === "number" && override > 0 ? override : $08414ea58bdc1292$var$DEFAULT_DOCX_RENDER_TIMEOUT_MS;
}
async function $08414ea58bdc1292$var$docxPreviewLooksBlank(container, arrayBuffer) {
    if (container.querySelector("img, svg, canvas, table")) return false;
    const renderedText = $08414ea58bdc1292$var$normalizePreviewText(container.textContent || "");
    if (renderedText.length >= 24) return false;
    try {
        const paragraphs = await $08414ea58bdc1292$var$extractDocxParagraphs(arrayBuffer);
        const sourceText = $08414ea58bdc1292$var$normalizePreviewText(paragraphs.join(""));
        return sourceText.length >= 24 && sourceText.length > renderedText.length * 4;
    } catch  {
        return false;
    }
}
async function $08414ea58bdc1292$var$docxPreviewMissesRichTextboxContent(container, arrayBuffer) {
    try {
        if (!await $08414ea58bdc1292$var$docxHasRichTextboxContent(arrayBuffer)) return false;
        const zip = await $08414ea58bdc1292$var$loadZipForSniffing(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        if (!documentXml) return false;
        const sourceParagraphs = $08414ea58bdc1292$var$dedupeParagraphs($08414ea58bdc1292$var$extractWordTextboxParagraphs(documentXml)).map((paragraph)=>$08414ea58bdc1292$var$normalizePreviewText(paragraph)).filter((paragraph)=>paragraph.length >= 3);
        if (sourceParagraphs.length < 4) return false;
        const renderedText = $08414ea58bdc1292$var$normalizePreviewText(container.textContent || "");
        const firstImportantParagraphs = sourceParagraphs.slice(0, Math.min(4, sourceParagraphs.length));
        const firstCoverage = firstImportantParagraphs.filter((paragraph)=>renderedText.includes(paragraph)).length / firstImportantParagraphs.length;
        const totalCoverage = sourceParagraphs.filter((paragraph)=>renderedText.includes(paragraph)).length / sourceParagraphs.length;
        return firstCoverage < 0.5 || totalCoverage < 0.45;
    } catch  {
        return false;
    }
}
async function $08414ea58bdc1292$var$docxHasRichTextboxContent(arrayBuffer) {
    try {
        const zip = await $08414ea58bdc1292$var$loadZipForSniffing(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        if (!documentXml || !/\btxbxContent\b/.test(documentXml)) return false;
        const textboxCount = (documentXml.match(/\btxbxContent\b/g) || []).length;
        const textboxParagraphs = $08414ea58bdc1292$var$extractWordTextboxParagraphs(documentXml);
        const textboxTextLength = $08414ea58bdc1292$var$normalizePreviewText(textboxParagraphs.join("")).length;
        const documentTextLength = $08414ea58bdc1292$var$normalizePreviewText($08414ea58bdc1292$var$extractOpenXmlText(documentXml).join("")).length;
        return (textboxCount >= 3 || textboxParagraphs.length >= 3 || textboxTextLength >= 160) && textboxTextLength >= 8 && textboxTextLength >= documentTextLength * 0.4;
    } catch  {
        return false;
    }
}
async function $08414ea58bdc1292$var$docxShouldPreferTextboxLayoutFallback(arrayBuffer) {
    try {
        const zip = await $08414ea58bdc1292$var$loadZipForSniffing(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        if (!documentXml || !/\btxbxContent\b/.test(documentXml)) return false;
        const blocks = $08414ea58bdc1292$var$extractDocxTextboxBlocks(documentXml);
        const meaningfulBlocks = blocks.filter((block)=>block.paragraphs.length > 0);
        const sidebarBackgrounds = blocks.filter((block)=>block.paragraphs.length === 0 && block.fill && block.relativeV === "page" && block.x < 0 && block.width >= 120 && block.height >= 500);
        const pageAnchoredTextboxes = meaningfulBlocks.filter((block)=>block.relativeV === "page");
        const paragraphAnchoredTextboxes = meaningfulBlocks.filter((block)=>block.relativeV !== "page");
        const leftTextboxes = meaningfulBlocks.filter((block)=>block.x < 0);
        const rightTextboxes = meaningfulBlocks.filter((block)=>block.x >= 80);
        return sidebarBackgrounds.length >= 2 && meaningfulBlocks.length >= 8 && pageAnchoredTextboxes.length >= 4 && paragraphAnchoredTextboxes.length >= 2 && leftTextboxes.length >= 3 && rightTextboxes.length >= 3;
    } catch  {
        return false;
    }
}
async function $08414ea58bdc1292$var$renderDocxContentFallback(container, arrayBuffer, options = {}) {
    if (options.showNote !== false) {
        const fallbackNote = document.createElement("div");
        fallbackNote.className = "ofv-docx-fallback-note";
        fallbackNote.textContent = "\u9AD8\u4FDD\u771F DOCX \u6E32\u67D3\u4E0D\u53EF\u7528\uFF0C\u5DF2\u5207\u6362\u4E3A\u57FA\u7840\u5185\u5BB9\u9884\u89C8\u3002";
        $08414ea58bdc1292$var$hideSupplementalInfo3(fallbackNote);
        container.append(fallbackNote);
    }
    if (options.preferOpenXml) {
        if (await $08414ea58bdc1292$var$renderDocxTextboxLayoutFallback(container, arrayBuffer)) return;
        await $08414ea58bdc1292$var$renderDocxTextFallback(container, arrayBuffer);
        return;
    }
    try {
        const mammothContent = document.createElement("div");
        await $08414ea58bdc1292$var$withTimeout($08414ea58bdc1292$var$renderDocxWithMammoth(mammothContent, arrayBuffer), $08414ea58bdc1292$var$docxRenderTimeoutMs(), "DOCX fallback rendering");
        const renderedText = $08414ea58bdc1292$var$normalizePreviewText(mammothContent.querySelector(".ofv-document")?.textContent || "");
        if (renderedText.length >= 24) {
            container.append(...Array.from(mammothContent.childNodes));
            return;
        }
        await $08414ea58bdc1292$var$renderDocxTextFallback(container, arrayBuffer);
    } catch (fallbackError) {
        await $08414ea58bdc1292$var$renderDocxTextFallback(container, arrayBuffer);
        console.warn("DOCX content fallback failed, used raw OpenXML text extraction:", fallbackError);
    }
}
async function $08414ea58bdc1292$var$renderDocxTextboxLayoutFallback(container, arrayBuffer) {
    try {
        const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        if (!documentXml) return false;
        const blocks = $08414ea58bdc1292$var$extractDocxTextboxBlocks(documentXml);
        const meaningfulBlocks = blocks.filter((block)=>block.paragraphs.length > 0);
        if (meaningfulBlocks.length < 4) return false;
        if ($08414ea58bdc1292$var$renderDocxAnchoredTextboxFallback(container, meaningfulBlocks, blocks)) return true;
        const page = document.createElement("article");
        page.className = "ofv-document ofv-docx-textbox-layout";
        const sidebar = document.createElement("section");
        sidebar.className = "ofv-docx-textbox-sidebar";
        const main = document.createElement("section");
        main.className = "ofv-docx-textbox-main";
        const ordered = [
            ...meaningfulBlocks
        ].sort((a, b)=>a.order - b.order);
        const leftThreshold = ordered.some((block)=>block.x < 0) ? 0 : Math.min(...ordered.map((block)=>block.x)) + 72;
        for (const block of ordered){
            const card = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
            if (block.x < leftThreshold && block.width < 260) {
                card.classList.add("ofv-docx-textbox-sidebar-block");
                sidebar.append(card);
            } else {
                card.classList.add("ofv-docx-textbox-main-block");
                main.append(card);
            }
        }
        if (sidebar.childElementCount === 0 || main.childElementCount === 0) for (const block of ordered)page.append($08414ea58bdc1292$var$createDocxTextboxBlockElement(block));
        else page.append(sidebar, main);
        container.append(page);
        return true;
    } catch  {
        return false;
    }
}
function $08414ea58bdc1292$var$extractDocxTextboxBlocks(xml) {
    const blocks = [];
    let order = 0;
    for (const match of xml.matchAll(/<wp:anchor\b[\s\S]*?<\/wp:anchor>/g)){
        const anchor = match[0];
        const textboxMatches = [
            ...anchor.matchAll(/<w:txbxContent\b[\s\S]*?<\/w:txbxContent>/g)
        ];
        const extent = /<wp:extent\b[^>]*\bcx="(\d+)"[^>]*\bcy="(\d+)"/.exec(anchor);
        const offsets = [
            ...anchor.matchAll(/<wp:posOffset>(-?\d+)<\/wp:posOffset>/g)
        ].map((item)=>Number(item[1]));
        const fill = /<a:solidFill>[\s\S]*?<a:srgbClr\b[^>]*\bval="([A-Fa-f0-9]+)"/.exec(anchor)?.[1];
        if (textboxMatches.length === 0 && !fill) continue;
        const block = {
            order: order,
            x: $08414ea58bdc1292$var$emuToPt(offsets[0] || 0),
            y: $08414ea58bdc1292$var$emuToPt(offsets[1] || 0),
            relativeV: /<wp:positionV\b[^>]*\brelativeFrom="([^"]+)"/.exec(anchor)?.[1] || "",
            width: $08414ea58bdc1292$var$emuToPt(Number(extent?.[1] || 0)),
            height: $08414ea58bdc1292$var$emuToPt(Number(extent?.[2] || 0)),
            fill: fill,
            paragraphs: textboxMatches.length > 0 ? $08414ea58bdc1292$var$dedupeParagraphs(textboxMatches.flatMap((textbox)=>$08414ea58bdc1292$var$extractWordTextboxParagraphs(textbox[0])).map((text)=>text.replace(/\s+/g, " ").trim())) : []
        };
        if (block.width > 0 && block.height > 0) blocks.push(block);
        order += 1;
    }
    return blocks;
}
function $08414ea58bdc1292$var$renderDocxAnchoredTextboxFallback(container, blocks, sourceBlocks = blocks) {
    const pageBlocks = blocks.filter((block)=>block.relativeV === "page");
    const paragraphBlocks = blocks.filter((block)=>block.relativeV !== "page");
    if (pageBlocks.length < 3 || paragraphBlocks.length < 4) return false;
    const continuationMarkers = $08414ea58bdc1292$var$findDocxTextboxContinuationMarkers(sourceBlocks);
    const continuationMarkerOrder = continuationMarkers[0]?.order ?? Number.POSITIVE_INFINITY;
    const firstPageBlocks = pageBlocks.filter((block)=>block.order < continuationMarkerOrder && !$08414ea58bdc1292$var$isDocxTextboxLargeBackground(block));
    const firstPageParagraphBlocks = paragraphBlocks.filter((block)=>block.order < continuationMarkerOrder && $08414ea58bdc1292$var$isDocxTextboxFirstPageFlowBlock(block));
    const continuationBlocks = blocks.filter((block)=>block.order >= continuationMarkerOrder || block.relativeV !== "page" && !$08414ea58bdc1292$var$isDocxTextboxFirstPageFlowBlock(block));
    const continuationGroups = $08414ea58bdc1292$var$groupDocxTextboxContinuationBlocks(blocks, continuationMarkers, continuationMarkerOrder);
    if (firstPageBlocks.length < 3) return false;
    const page = document.createElement("article");
    page.className = "ofv-document ofv-docx-textbox-page";
    page.style.setProperty("--ofv-docx-textbox-page-width", "595pt");
    const contentLeft = Math.min(...firstPageBlocks.map((block)=>block.x));
    const contentRight = Math.max(...firstPageBlocks.map((block)=>block.x + Math.max(block.width, 24)));
    const normalizedWidth = Math.max(420, contentRight - contentLeft + 36);
    const pageWidth = Math.max(595, normalizedWidth);
    const normalizeX = (block)=>block.x - contentLeft + (pageWidth - normalizedWidth) / 2;
    const normalizeY = (block)=>Math.max(0, block.y + 24);
    const columns = $08414ea58bdc1292$var$classifyDocxTextboxColumns([
        ...firstPageBlocks,
        ...firstPageParagraphBlocks,
        ...continuationBlocks
    ], normalizeX);
    const sidebarBackground = $08414ea58bdc1292$var$findDocxTextboxSidebarBackground(sourceBlocks);
    if (sidebarBackground?.fill && $08414ea58bdc1292$var$renderDocxFirstPageFlowFallback(page, firstPageBlocks, firstPageParagraphBlocks, columns, sidebarBackground)) {
        container.append(page);
        $08414ea58bdc1292$var$appendDocxTextboxContinuationPages(container, continuationGroups.length > 0 ? continuationGroups : [
            continuationBlocks
        ], columns, sidebarBackground);
        return true;
    }
    if (sidebarBackground?.fill) {
        page.classList.add("ofv-docx-textbox-page-has-sidebar");
        page.style.setProperty("--ofv-docx-textbox-sidebar-bg", `#${sidebarBackground.fill}`);
        page.style.setProperty("--ofv-docx-textbox-sidebar-width", `${$08414ea58bdc1292$var$formatCssNumber($08414ea58bdc1292$var$inferDocxTextboxSidebarBackgroundWidth(columns))}pt`);
    }
    for (const block of firstPageBlocks){
        const element = $08414ea58bdc1292$var$createDocxPositionedTextboxBlockElement(block);
        element.classList.add(columns.sidebar.has(block.order) ? "ofv-docx-textbox-page-sidebar-block" : "ofv-docx-textbox-page-main-block");
        if (columns.main.has(block.order)) element.classList.remove("ofv-docx-textbox-page-filled-block");
        element.style.left = `${$08414ea58bdc1292$var$formatCssNumber(normalizeX(block))}pt`;
        element.style.top = `${$08414ea58bdc1292$var$formatCssNumber(normalizeY(block))}pt`;
        element.style.width = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(24, block.width))}pt`;
        if (block.height > 0) element.style.minHeight = `${$08414ea58bdc1292$var$formatCssNumber(block.height)}pt`;
        page.append(element);
    }
    const sidebarFlowBlocks = firstPageParagraphBlocks.filter((block)=>columns.sidebar.has(block.order));
    const mainFlowBlocks = firstPageParagraphBlocks.filter((block)=>columns.main.has(block.order));
    const pageAnchorsBottom = Math.max(...firstPageBlocks.map((block)=>normalizeY(block) + Math.max(block.height, $08414ea58bdc1292$var$estimateDocxTextboxBlockHeight(block))));
    const sidebarFlowTop = $08414ea58bdc1292$var$estimateDocxTextboxColumnFlowStart(firstPageBlocks, columns.sidebar, normalizeY, pageAnchorsBottom);
    const mainFlowTop = $08414ea58bdc1292$var$estimateDocxTextboxColumnFlowStart(firstPageBlocks, columns.main, normalizeY, pageAnchorsBottom);
    const sidebarFlowBottom = $08414ea58bdc1292$var$appendDocxTextboxFlowColumn(page, sidebarFlowBlocks, {
        className: "ofv-docx-textbox-page-sidebar-flow",
        leftPt: columns.sidebarLeft,
        topPt: sidebarFlowTop,
        widthPt: columns.sidebarWidth
    });
    const mainFlowBottom = $08414ea58bdc1292$var$appendDocxTextboxFlowColumn(page, mainFlowBlocks, {
        className: "ofv-docx-textbox-page-main-flow",
        leftPt: columns.mainLeft,
        topPt: mainFlowTop,
        widthPt: columns.mainWidth
    });
    page.style.minHeight = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(842, pageAnchorsBottom + 36, sidebarFlowBottom + 36, mainFlowBottom + 36))}pt`;
    container.append(page);
    $08414ea58bdc1292$var$appendDocxTextboxContinuationPages(container, continuationGroups.length > 0 ? continuationGroups : [
        continuationBlocks
    ], columns, sidebarBackground);
    return true;
}
function $08414ea58bdc1292$var$findDocxTextboxContinuationMarkers(blocks) {
    return blocks.filter($08414ea58bdc1292$var$isDocxTextboxLargeBackground).sort((a, b)=>a.order - b.order).slice(1);
}
function $08414ea58bdc1292$var$isDocxTextboxLargeBackground(block) {
    return block.paragraphs.length === 0 && Boolean(block.fill) && block.relativeV === "page" && block.width >= 120 && block.height >= 500;
}
function $08414ea58bdc1292$var$isDocxTextboxFirstPageFlowBlock(block) {
    return block.y >= -5;
}
function $08414ea58bdc1292$var$renderDocxFirstPageFlowFallback(page, pageBlocks, paragraphBlocks, columns, sidebarBackground) {
    const sidebarBlocks = [
        ...pageBlocks,
        ...paragraphBlocks
    ].filter((block)=>columns.sidebar.has(block.order) && block.paragraphs.length > 0).filter((block)=>!$08414ea58bdc1292$var$isDocxTextboxDecorativeBlock(block)).sort($08414ea58bdc1292$var$sortDocxTextboxFirstPageSidebarBlock);
    const mainBlocks = pageBlocks.filter((block)=>columns.main.has(block.order) && block.paragraphs.length > 0).filter((block)=>!$08414ea58bdc1292$var$isDocxTextboxDecorativeBlock(block)).sort($08414ea58bdc1292$var$sortDocxTextboxFirstPageMainBlock);
    if (sidebarBlocks.length < 2 || mainBlocks.length < 2) return false;
    page.classList.add("ofv-docx-textbox-page-flow-layout");
    page.style.setProperty("--ofv-docx-textbox-sidebar-bg", `#${sidebarBackground.fill}`);
    page.style.setProperty("--ofv-docx-textbox-sidebar-width", `${$08414ea58bdc1292$var$formatCssNumber($08414ea58bdc1292$var$inferDocxTextboxSidebarBackgroundWidth(columns))}pt`);
    const sidebar = document.createElement("aside");
    sidebar.className = "ofv-docx-textbox-page-flow-sidebar";
    const main = document.createElement("main");
    main.className = "ofv-docx-textbox-page-flow-main";
    for (const block of $08414ea58bdc1292$var$mergeDocxTextboxSidebarHeadingBlocks(sidebarBlocks)){
        const element = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
        element.classList.add("ofv-docx-textbox-flow-block");
        sidebar.append(element);
    }
    for (const block of mainBlocks){
        const element = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
        element.classList.add("ofv-docx-textbox-flow-block");
        main.append(element);
    }
    page.append(sidebar, main);
    return true;
}
function $08414ea58bdc1292$var$sortDocxTextboxFirstPageSidebarBlock(a, b) {
    return a.order - b.order;
}
function $08414ea58bdc1292$var$sortDocxTextboxFirstPageMainBlock(a, b) {
    const relationRank = (block)=>block.relativeV === "page" ? 0 : 1;
    const rankDiff = relationRank(a) - relationRank(b);
    if (rankDiff !== 0) return rankDiff;
    const yDiff = a.y - b.y;
    return Math.abs(yDiff) > 12 ? yDiff : a.order - b.order;
}
function $08414ea58bdc1292$var$isDocxTextboxDecorativeBlock(block) {
    return block.fill !== void 0 && $08414ea58bdc1292$var$normalizePreviewText(block.paragraphs.join("")).length === 0 && block.width < 24 && block.height < 24;
}
function $08414ea58bdc1292$var$groupDocxTextboxContinuationBlocks(blocks, markers, firstMarkerOrder) {
    if (markers.length === 0) return [];
    return markers.map((marker, index)=>{
        const nextMarkerOrder = markers[index + 1]?.order ?? Number.POSITIVE_INFINITY;
        const preMarkerParagraphBlocks = index === 0 ? blocks.filter((block)=>block.relativeV !== "page" && block.order < firstMarkerOrder && !$08414ea58bdc1292$var$isDocxTextboxFirstPageFlowBlock(block)) : [];
        const markerPageBlocks = blocks.filter((block)=>block.order >= marker.order && block.order < nextMarkerOrder);
        return [
            ...preMarkerParagraphBlocks,
            ...markerPageBlocks
        ].filter((block)=>block.paragraphs.length > 0).sort((a, b)=>a.order - b.order);
    }).filter((group)=>group.length > 0);
}
function $08414ea58bdc1292$var$appendDocxTextboxContinuationPages(container, groups, columns, sidebarBackground) {
    for (const blocks of groups)$08414ea58bdc1292$var$appendDocxTextboxContinuationPage(container, blocks, columns, sidebarBackground);
}
function $08414ea58bdc1292$var$appendDocxTextboxContinuationPage(container, contentBlocks, columns, sidebarBackground) {
    if (contentBlocks.length === 0) return;
    const page = document.createElement("article");
    page.className = "ofv-document ofv-docx-textbox-page";
    page.style.setProperty("--ofv-docx-textbox-page-width", "595pt");
    if (sidebarBackground?.fill && $08414ea58bdc1292$var$renderDocxContinuationFlowFallback(page, contentBlocks, columns, sidebarBackground)) {
        container.append(page);
        return;
    }
    if (sidebarBackground?.fill) {
        page.classList.add("ofv-docx-textbox-page-has-sidebar");
        page.style.setProperty("--ofv-docx-textbox-sidebar-bg", `#${sidebarBackground.fill}`);
        page.style.setProperty("--ofv-docx-textbox-sidebar-width", `${$08414ea58bdc1292$var$formatCssNumber($08414ea58bdc1292$var$inferDocxTextboxSidebarBackgroundWidth(columns))}pt`);
    }
    const sidebarFlowBottom = $08414ea58bdc1292$var$appendDocxTextboxFlowColumn(page, contentBlocks.filter((block)=>columns.sidebar.has(block.order)), {
        className: "ofv-docx-textbox-page-sidebar-flow",
        leftPt: columns.sidebarLeft,
        topPt: 42,
        widthPt: columns.sidebarWidth
    });
    const mainFlowBottom = $08414ea58bdc1292$var$appendDocxTextboxFlowColumn(page, contentBlocks.filter((block)=>columns.main.has(block.order)), {
        className: "ofv-docx-textbox-page-main-flow",
        leftPt: columns.mainLeft,
        topPt: 42,
        widthPt: columns.mainWidth
    });
    page.style.minHeight = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(842, sidebarFlowBottom + 36, mainFlowBottom + 36))}pt`;
    container.append(page);
}
function $08414ea58bdc1292$var$renderDocxContinuationFlowFallback(page, contentBlocks, columns, sidebarBackground) {
    const sidebarBlocks = contentBlocks.filter((block)=>columns.sidebar.has(block.order) && block.paragraphs.length > 0).filter((block)=>!$08414ea58bdc1292$var$isDocxTextboxDecorativeBlock(block));
    const mainBlocks = contentBlocks.filter((block)=>columns.main.has(block.order) && block.paragraphs.length > 0).filter((block)=>!$08414ea58bdc1292$var$isDocxTextboxDecorativeBlock(block));
    if (sidebarBlocks.length === 0 && mainBlocks.length === 0) return false;
    page.classList.add("ofv-docx-textbox-page-flow-layout", "ofv-docx-textbox-continuation-flow-layout");
    page.style.setProperty("--ofv-docx-textbox-sidebar-bg", `#${sidebarBackground.fill}`);
    page.style.setProperty("--ofv-docx-textbox-sidebar-width", `${$08414ea58bdc1292$var$formatCssNumber($08414ea58bdc1292$var$inferDocxTextboxSidebarBackgroundWidth(columns))}pt`);
    const sidebar = document.createElement("aside");
    sidebar.className = "ofv-docx-textbox-page-flow-sidebar";
    const main = document.createElement("main");
    main.className = "ofv-docx-textbox-page-flow-main";
    for (const block of $08414ea58bdc1292$var$mergeDocxTextboxSidebarHeadingBlocks($08414ea58bdc1292$var$orderDocxTextboxFlowBlocks(sidebarBlocks))){
        const element = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
        element.classList.add("ofv-docx-textbox-flow-block");
        if ($08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(block)) element.classList.add("ofv-docx-textbox-section-heading");
        sidebar.append(element);
    }
    for (const block of $08414ea58bdc1292$var$orderDocxTextboxFlowBlocks(mainBlocks)){
        const element = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
        element.classList.add("ofv-docx-textbox-flow-block");
        if ($08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(block)) element.classList.add("ofv-docx-textbox-section-heading");
        main.append(element);
    }
    page.append(sidebar, main);
    return true;
}
function $08414ea58bdc1292$var$mergeDocxTextboxSidebarHeadingBlocks(blocks) {
    const merged = [];
    for(let index = 0; index < blocks.length; index += 1){
        const block = blocks[index];
        const next = blocks[index + 1];
        if ($08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(block) && next && !$08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(next)) {
            merged.push({
                ...next,
                order: block.order,
                paragraphs: [
                    block.paragraphs[0],
                    ...next.paragraphs
                ]
            });
            index += 1;
        } else merged.push(block);
    }
    return merged;
}
function $08414ea58bdc1292$var$findDocxTextboxSidebarBackground(blocks) {
    return blocks.filter((block)=>block.paragraphs.length === 0 && block.fill && block.relativeV === "page" && block.x < 0 && block.width >= 120 && block.height >= 500).sort((a, b)=>b.height * b.width - a.height * a.width)[0];
}
function $08414ea58bdc1292$var$inferDocxTextboxSidebarBackgroundWidth(columns) {
    const contentRight = columns.sidebarLeft + columns.sidebarWidth + 4;
    const beforeMain = columns.mainLeft - 36;
    return Math.max(96, Math.min(contentRight, beforeMain));
}
function $08414ea58bdc1292$var$classifyDocxTextboxColumns(blocks, normalizeX) {
    const columnThreshold = $08414ea58bdc1292$var$inferDocxTextboxColumnThreshold(blocks);
    const leftBlocks = blocks.filter((block)=>block.x < columnThreshold);
    const rightBlocks = blocks.filter((block)=>!leftBlocks.includes(block));
    const sidebar = new Set(leftBlocks.map((block)=>block.order));
    const main = new Set(rightBlocks.map((block)=>block.order));
    const sidebarLeft = Math.max(28, Math.min(...leftBlocks.map((block)=>normalizeX(block))));
    const mainLeft = Math.max(210, Math.min(...rightBlocks.map((block)=>normalizeX(block))));
    const sidebarWidth = Math.min(180, Math.max(120, Math.max(...leftBlocks.map((block)=>block.width))));
    const mainWidth = Math.min(380, Math.max(280, Math.max(...rightBlocks.map((block)=>block.width))));
    return {
        sidebar: sidebar,
        main: main,
        sidebarLeft: sidebarLeft,
        mainLeft: mainLeft,
        sidebarWidth: sidebarWidth,
        mainWidth: mainWidth
    };
}
function $08414ea58bdc1292$var$estimateDocxTextboxColumnFlowStart(pageBlocks, columnOrders, normalizeY, fallbackTop) {
    const sameColumnAnchors = pageBlocks.filter((block)=>columnOrders.has(block.order));
    const anchorBottom = Math.max(0, ...sameColumnAnchors.map((block)=>normalizeY(block) + Math.max(block.height, $08414ea58bdc1292$var$estimateDocxTextboxBlockHeight(block))));
    if (anchorBottom > 0) return anchorBottom + 14;
    return fallbackTop + 18;
}
function $08414ea58bdc1292$var$inferDocxTextboxColumnThreshold(blocks) {
    const xs = [
        ...new Set(blocks.map((block)=>Math.round(block.x * 10) / 10))
    ].sort((a, b)=>a - b);
    if (xs.length < 2) return xs[0] ?? 0;
    let splitIndex = 0;
    let largestGap = -Infinity;
    for(let index = 0; index < xs.length - 1; index += 1){
        const gap = xs[index + 1] - xs[index];
        if (gap > largestGap) {
            largestGap = gap;
            splitIndex = index;
        }
    }
    return (xs[splitIndex] + xs[splitIndex + 1]) / 2;
}
function $08414ea58bdc1292$var$appendDocxTextboxFlowColumn(page, blocks, options) {
    if (blocks.length === 0) return options.topPt;
    const column = document.createElement("div");
    column.className = `ofv-docx-textbox-page-flow ${options.className}`;
    column.style.left = `${$08414ea58bdc1292$var$formatCssNumber(options.leftPt)}pt`;
    column.style.top = `${$08414ea58bdc1292$var$formatCssNumber(options.topPt)}pt`;
    column.style.width = `${$08414ea58bdc1292$var$formatCssNumber(options.widthPt)}pt`;
    let flowBottom = options.topPt;
    for (const block of $08414ea58bdc1292$var$orderDocxTextboxFlowBlocks(blocks)){
        const element = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
        element.classList.add("ofv-docx-textbox-flow-block");
        column.append(element);
        flowBottom += $08414ea58bdc1292$var$estimateDocxTextboxBlockHeight(block) + 10;
    }
    page.append(column);
    return flowBottom;
}
function $08414ea58bdc1292$var$orderDocxTextboxFlowBlocks(blocks) {
    const ordered = [
        ...blocks
    ].sort((a, b)=>a.order - b.order);
    const result = [];
    for (const block of ordered){
        const previous = result[result.length - 1];
        const previousPrevious = result[result.length - 2];
        if (previous && $08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(block) && !$08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(previous) && !$08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(previousPrevious)) result.splice(result.length - 1, 0, block);
        else result.push(block);
    }
    return result;
}
function $08414ea58bdc1292$var$isStandaloneDocxTextboxHeadingBlock(block) {
    if (!block || block.paragraphs.length !== 1) return false;
    return $08414ea58bdc1292$var$looksLikeDocxTextboxHeading(block.paragraphs[0]);
}
function $08414ea58bdc1292$var$createDocxPositionedTextboxBlockElement(block) {
    const section = $08414ea58bdc1292$var$createDocxTextboxBlockElement(block);
    section.classList.add("ofv-docx-textbox-page-block");
    if (block.fill) section.classList.add("ofv-docx-textbox-page-filled-block");
    if (block.paragraphs.length <= 2 && !block.fill) section.classList.add("ofv-docx-textbox-page-title-block");
    return section;
}
function $08414ea58bdc1292$var$createDocxTextboxBlockElement(block) {
    const section = document.createElement("section");
    section.className = "ofv-docx-textbox-block";
    if (block.fill) {
        section.classList.add("ofv-docx-textbox-block-filled");
        section.style.setProperty("--ofv-docx-textbox-fill", `#${block.fill}`);
    }
    const paragraphs = $08414ea58bdc1292$var$normalizeDocxTextboxParagraphOrder(block);
    const [first, ...rest] = paragraphs;
    if (first) {
        const sectionKind = $08414ea58bdc1292$var$getDocxTextboxSectionKind(first);
        if (sectionKind) section.classList.add(`ofv-docx-textbox-section-${sectionKind}`);
        const heading = document.createElement("h3");
        heading.textContent = first;
        section.append(heading);
    }
    const body = rest.length > 0 ? rest : [];
    for (const paragraphText of body){
        const paragraph = document.createElement("p");
        paragraph.textContent = paragraphText;
        section.append(paragraph);
    }
    return section;
}
function $08414ea58bdc1292$var$getDocxTextboxSectionKind(heading) {
    const text = $08414ea58bdc1292$var$normalizePreviewText(heading);
    if (text.includes("\u6559\u80B2\u80CC\u666F")) return "education";
    if (text.includes("\u4E13\u4E1A\u6280\u80FD")) return "skills";
    if (text.includes("\u5DE5\u4F5C\u7ECF\u5386")) return "work";
    if (text.includes("\u9879\u76EE\u7ECF\u9A8C")) return "projects";
    if (text.includes("\u81EA\u6211\u8BC4\u4EF7")) return "summary";
    if (text.includes("\u57FA\u672C\u4FE1\u606F")) return "profile";
    return "";
}
function $08414ea58bdc1292$var$estimateDocxTextboxBlockHeight(block) {
    return Math.max(block.height, 18 + block.paragraphs.length * 14);
}
function $08414ea58bdc1292$var$normalizeDocxTextboxParagraphOrder(block) {
    if (!block.fill || block.paragraphs.length < 2) return block.paragraphs;
    const last = block.paragraphs[block.paragraphs.length - 1];
    if ($08414ea58bdc1292$var$looksLikeDocxTextboxHeading(last)) return [
        last,
        ...block.paragraphs.slice(0, -1)
    ];
    return block.paragraphs;
}
function $08414ea58bdc1292$var$looksLikeDocxTextboxHeading(value) {
    const text = $08414ea58bdc1292$var$normalizePreviewText(value);
    return text.length > 0 && text.length <= 12 && !/[0-9@.:：]/.test(text);
}
async function $08414ea58bdc1292$var$normalizeDocxLayout(container, arrayBuffer, styleContainer) {
    const [hints, charts, svgImageAlternatives] = await Promise.all([
        $08414ea58bdc1292$var$readDocxLayoutHints(arrayBuffer),
        $08414ea58bdc1292$var$readDocxCharts(arrayBuffer),
        $08414ea58bdc1292$var$readDocxSvgImageAlternatives(arrayBuffer)
    ]);
    $08414ea58bdc1292$var$normalizeDocxEastAsiaFontStyles(styleContainer, hints.eastAsiaFonts);
    $08414ea58bdc1292$var$normalizeDocxNumberingStyles(styleContainer);
    $08414ea58bdc1292$var$repairDocxDefaultPageMargins(container, hints.needsDefaultPageMargins);
    $08414ea58bdc1292$var$repairDocxSvgImageAlternatives(container, svgImageAlternatives);
    $08414ea58bdc1292$var$repairUnexpectedDocxTableTextDirections(container, hints.hasVerticalTextDirection);
    $08414ea58bdc1292$var$repairDocxDiagonalCellBorders(container, hints.diagonalCellBorders);
    $08414ea58bdc1292$var$repairDocxFloatingShapeTextboxes(container, hints.floatingShapes);
    $08414ea58bdc1292$var$repairDocxChartPlaceholders(container, charts);
    $08414ea58bdc1292$var$repairDocxComplexScriptFontSizes(container, hints.complexScriptFontSizeParagraphs);
    $08414ea58bdc1292$var$repairDocxCharacterSpacing(container, hints.characterSpacingParagraphs);
    $08414ea58bdc1292$var$repairDocxAutoLineHeights(container, hints.autoLineHeightParagraphs);
    $08414ea58bdc1292$var$repairDocxMergedCellEmptyParagraphs(container, hints.mergedCellEmptyParagraphs);
    $08414ea58bdc1292$var$repairDocxMergedCellTableBottomBorders(container);
    $08414ea58bdc1292$var$markDocxSectionBreakParagraphs(container, hints.sectionBreakParagraphIndexes);
    $08414ea58bdc1292$var$repairDocxCharacterScaling(container, hints.characterScaleParagraphs);
    const pages = container.querySelectorAll("section.ofv-docx");
    for (const page of pages){
        $08414ea58bdc1292$var$repairDocxShapeFills(page);
        $08414ea58bdc1292$var$repairDocxHeaderFloatingPictures(page, hints);
        $08414ea58bdc1292$var$repairDocxHeadingShapeAlignment(page);
        $08414ea58bdc1292$var$repairDocxListIndentAlignment(page);
        for (const element of page.querySelectorAll("[style*='line-height']")){
            const atLeastLineHeight = $08414ea58bdc1292$var$parseDocxAtLeastLineHeight(element.style.lineHeight);
            if (atLeastLineHeight !== void 0) {
                const largestFontSize = $08414ea58bdc1292$var$getLargestDocxFontSize(element);
                element.style.lineHeight = atLeastLineHeight <= largestFontSize * 1.2 ? "1.2" : `${$08414ea58bdc1292$var$formatCssNumber(atLeastLineHeight)}px`;
                continue;
            }
            const lineHeight = $08414ea58bdc1292$var$parseCssLineHeight(element.style.lineHeight);
            if (lineHeight > 0 && lineHeight < 1) element.style.lineHeight = "1.2";
        }
    }
    $08414ea58bdc1292$var$repairDocxRightTabStops(container, hints.rightTabParagraphs);
    $08414ea58bdc1292$var$markDocxPageNumberFields(container, hints.pageNumberFieldResults);
    await new Promise((resolve)=>setTimeout(resolve, 100));
    $08414ea58bdc1292$var$repairDocxFloatingPicturesAcrossPages(container, hints);
    await new Promise((resolve)=>setTimeout(resolve, 300));
    $08414ea58bdc1292$var$repairDocxFloatingPicturesAcrossPages(container, hints);
    $08414ea58bdc1292$var$repositionDocxFloatingPicturesFromAnchorParagraphs(container, hints);
    if (hints.floatingPictures.some((item)=>item.relativeFrom === "column" && (item.wrap === "square" || item.wrap === "none"))) {
        let reflowAttempts = 0;
        const watchAnchorLayout = ()=>{
            $08414ea58bdc1292$var$repositionDocxFloatingPicturesFromAnchorParagraphs(container, hints);
            reflowAttempts += 1;
            if (reflowAttempts < 30) setTimeout(watchAnchorLayout, 200);
        };
        watchAnchorLayout();
    }
}
function $08414ea58bdc1292$var$normalizeDocxNumberingStyles(styleContainer) {
    if (!styleContainer?.textContent) return;
    styleContainer.textContent = styleContainer.textContent.replace(/(p\.[\w-]+-num-\d+-\d+:before\s*\{[\s\S]*?content:\s*"[^"\\]*(?:\\.[^"\\]*)*)\\9(";\s*[\s\S]*?\})/g, "$1\\00a0$2").replace(/(^|\})\s*(p\.[\w-]+-num-\d+-\d+\s*\{(?=[^}]*\bmargin-inline-start\s*:)[^}]*\})/gm, "$1\n.ofv-docx $2");
}
async function $08414ea58bdc1292$var$readDocxCharts(arrayBuffer) {
    try {
        const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        const documentDoc = documentXml ? $08414ea58bdc1292$var$parseOfficeXml(documentXml) : void 0;
        if (!documentDoc) return [];
        const relationships = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "word/document.xml");
        const themeColors = await $08414ea58bdc1292$var$readOfficeChartTheme(zip, "word/document.xml");
        const chartDrawings = Array.from(documentDoc.getElementsByTagName("*")).filter((element)=>element.localName === "inline" || element.localName === "anchor").map((element)=>$08414ea58bdc1292$var$readDocxChartDrawing(element)).filter((item)=>Boolean(item?.relationshipId));
        const charts = [];
        for (const [index, drawing] of chartDrawings.entries()){
            const chartRel = relationships.find((rel)=>rel.id === drawing.relationshipId && /\/chart$/i.test(rel.type));
            const chartPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("word/document.xml", chartRel?.target);
            const chartXml = chartPath ? await zip.file(chartPath)?.async("text") : void 0;
            const chart = chartXml ? $08414ea58bdc1292$var$parseChartXml(chartXml, chartPath?.split("/").pop() || `chart${index + 1}.xml`, themeColors) : null;
            if (chart) charts.push({
                ...chart,
                widthPt: drawing.widthPt,
                heightPt: drawing.heightPt
            });
        }
        return charts;
    } catch  {
        return [];
    }
}
function $08414ea58bdc1292$var$readDocxChartDrawing(element) {
    const chart = Array.from(element.getElementsByTagName("*")).find((child)=>child.localName === "chart");
    const relationshipId = chart ? $08414ea58bdc1292$var$getXmlAttribute3(chart, "id") : "";
    if (!relationshipId) return void 0;
    const extent = Array.from(element.children).find((child)=>child.localName === "extent");
    return {
        relationshipId: relationshipId,
        widthPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.getAttribute("cx") || 0)),
        heightPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.getAttribute("cy") || 0))
    };
}
function $08414ea58bdc1292$var$repairDocxChartPlaceholders(container, charts) {
    if (charts.length === 0) return;
    const placeholders = Array.from(container.querySelectorAll("section.ofv-docx div")).filter($08414ea58bdc1292$var$isDocxChartPlaceholder);
    if (placeholders.length !== charts.length) return;
    placeholders.forEach((placeholder, index)=>{
        const chart = charts[index];
        placeholder.classList.add("ofv-docx-chart-preview");
        placeholder.dataset.ofvDocxChartPreview = "true";
        if (chart.widthPt > 0) placeholder.style.width ||= `${$08414ea58bdc1292$var$formatCssNumber(chart.widthPt)}pt`;
        if (chart.heightPt > 0) placeholder.style.height ||= `${$08414ea58bdc1292$var$formatCssNumber(chart.heightPt)}pt`;
        placeholder.replaceChildren($08414ea58bdc1292$var$renderChartSvg(chart));
    });
}
function $08414ea58bdc1292$var$isDocxChartPlaceholder(element) {
    if (element.dataset.ofvDocxChartPreview === "true" || element.children.length > 0 || $08414ea58bdc1292$var$normalizePreviewText(element.textContent || "")) return false;
    const display = element.style.display;
    const position = element.style.position;
    const width = $08414ea58bdc1292$var$parseCssPixelValue(element.style.width);
    const height = $08414ea58bdc1292$var$parseCssPixelValue(element.style.height);
    const isInlineChart = display === "inline-block" && width >= 120;
    const isAnchoredChart = display === "block" && element.style.width === "100%";
    return position === "relative" && height >= 80 && (isInlineChart || isAnchoredChart);
}
function $08414ea58bdc1292$var$repairDocxHeadingShapeAlignment(page) {
    for (const paragraph of page.querySelectorAll("p")){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        if (!$08414ea58bdc1292$var$looksLikeDocxTextboxHeading(text)) continue;
        const svg = paragraph.querySelector("svg");
        if (!svg) continue;
        const width = $08414ea58bdc1292$var$parseCssPixelValue(svg.style.width) || $08414ea58bdc1292$var$parseCssPixelValue(svg.getAttribute("width") || "");
        const marginLeft = $08414ea58bdc1292$var$parseCssPixelValue(svg.style.marginLeft);
        if (width < 300 || marginLeft < 28 || marginLeft > 44) continue;
        const textWidth = $08414ea58bdc1292$var$getDocxParagraphVisibleTextWidth(paragraph);
        svg.style.marginLeft = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(48, marginLeft + textWidth * 0.68))}pt`;
        svg.style.marginTop = `${$08414ea58bdc1292$var$formatCssNumber($08414ea58bdc1292$var$parseCssPixelValue(svg.style.marginTop) - 4)}pt`;
        $08414ea58bdc1292$var$normalizeDocxHeadingShapeFill(svg);
        $08414ea58bdc1292$var$repairDocxHeadingTextBackground(paragraph);
    }
}
function $08414ea58bdc1292$var$normalizeDocxHeadingShapeFill(svg) {
    const headingFill = "#3f4aa3";
    const fillNodes = svg.querySelectorAll("image[fill], rect[data-ofv-docx-shape-fill]");
    for (const node of fillNodes){
        const fill = node.getAttribute("fill") || "";
        if (fill.toLowerCase() === "#38449a") node.setAttribute("fill", headingFill);
    }
}
function $08414ea58bdc1292$var$repairDocxHeadingTextBackground(paragraph) {
    const textSpans = Array.from(paragraph.querySelectorAll("span")).filter((element)=>$08414ea58bdc1292$var$normalizePreviewText(element.textContent || ""));
    const lastTextSpan = textSpans.at(-1);
    if (!lastTextSpan || !$08414ea58bdc1292$var$hasWhiteBackground(lastTextSpan)) return;
    lastTextSpan.style.paddingRight = "3pt";
    lastTextSpan.style.paddingTop = "2pt";
    lastTextSpan.style.paddingBottom = "2pt";
    lastTextSpan.style.boxDecorationBreak = "clone";
}
function $08414ea58bdc1292$var$hasWhiteBackground(element) {
    const background = element.style.backgroundColor.replace(/\s+/g, "").toLowerCase();
    return background === "white" || background === "#fff" || background === "#ffffff" || background === "rgb(255,255,255)";
}
function $08414ea58bdc1292$var$getDocxParagraphVisibleTextWidth(paragraph) {
    let textWidth = 0;
    for (const element of paragraph.querySelectorAll("span")){
        if (!$08414ea58bdc1292$var$normalizePreviewText(element.textContent || "")) continue;
        textWidth += $08414ea58bdc1292$var$pxToPt(element.getBoundingClientRect().width);
    }
    return textWidth;
}
function $08414ea58bdc1292$var$pxToPt(value) {
    return value * 0.75;
}
function $08414ea58bdc1292$var$repairDocxListIndentAlignment(page) {
    for (const paragraph of page.querySelectorAll("p[class*='ofv-docx-num-']")){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        if (!$08414ea58bdc1292$var$isDocxNumberListContinuationParagraph(paragraph, text)) continue;
        paragraph.style.textIndent = "42px";
    }
}
function $08414ea58bdc1292$var$isDocxNumberListContinuationParagraph(paragraph, text) {
    if (!text || /^[0-9]+[.、]/.test(text)) return false;
    const previousText = $08414ea58bdc1292$var$findAdjacentDocxParagraphText(paragraph, "previousElementSibling");
    const nextText = $08414ea58bdc1292$var$findAdjacentDocxParagraphText(paragraph, "nextElementSibling");
    return previousText.includes("\u5DE5\u4F5C\u63CF\u8FF0") || /^[3-9][.、]/.test(nextText);
}
function $08414ea58bdc1292$var$findAdjacentDocxParagraphText(paragraph, direction) {
    let sibling = paragraph[direction];
    while(sibling){
        if (sibling instanceof HTMLElement && sibling.tagName.toLowerCase() === "p") {
            const text = $08414ea58bdc1292$var$normalizePreviewText(sibling.textContent || "");
            if (text) return text;
        }
        sibling = sibling[direction];
    }
    return "";
}
async function $08414ea58bdc1292$var$readDocxLayoutHints(arrayBuffer) {
    try {
        const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
        const themeEntry = Object.values(zip.files).find((entry)=>!entry.dir && /^word\/theme\/theme\d+\.xml$/i.test(entry.name));
        const footerEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^word\/footer\d+\.xml$/i.test(entry.name));
        const headerEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^word\/header\d+\.xml$/i.test(entry.name));
        const [documentXml, stylesXml, themeXml, footerXmls, headerXmls] = await Promise.all([
            zip.file("word/document.xml")?.async("text"),
            zip.file("word/styles.xml")?.async("text"),
            themeEntry?.async("text"),
            Promise.all(footerEntries.map((entry)=>entry.async("text"))),
            Promise.all(headerEntries.map((entry)=>entry.async("text")))
        ]);
        return {
            eastAsiaFonts: $08414ea58bdc1292$var$extractDocxEastAsiaFonts(stylesXml || "", themeXml || ""),
            floatingPictures: documentXml ? $08414ea58bdc1292$var$extractFloatingPictureHints(documentXml) : [],
            headerFloatingPictures: headerXmls.flatMap($08414ea58bdc1292$var$extractFloatingPictureHints),
            floatingShapes: documentXml ? $08414ea58bdc1292$var$extractFloatingShapeHints(documentXml) : [],
            rightTabParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxRightTabParagraphHints(documentXml) : [],
            pageNumberFieldResults: footerXmls.flatMap($08414ea58bdc1292$var$extractDocxPageNumberFieldResults),
            complexScriptFontSizeParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxComplexScriptFontSizeHints(documentXml) : [],
            characterScaleParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxCharacterScaleHints(documentXml) : [],
            characterSpacingParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxCharacterSpacingHints(documentXml) : [],
            autoLineHeightParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxAutoLineHeightHints(documentXml) : [],
            diagonalCellBorders: documentXml ? $08414ea58bdc1292$var$extractDocxDiagonalCellBorders(documentXml) : [],
            mergedCellEmptyParagraphs: documentXml ? $08414ea58bdc1292$var$extractDocxMergedCellEmptyParagraphs(documentXml) : [],
            sectionBreakParagraphIndexes: documentXml ? $08414ea58bdc1292$var$extractDocxSectionBreakParagraphIndexes(documentXml) : [],
            needsDefaultPageMargins: Boolean(documentXml && /<w:sectPr\b/.test(documentXml) && !/<w:pgMar\b/.test(documentXml)),
            hasVerticalTextDirection: Boolean(documentXml && /<w:textDirection\b/.test(documentXml))
        };
    } catch  {
        return {
            floatingPictures: [],
            headerFloatingPictures: [],
            floatingShapes: [],
            rightTabParagraphs: [],
            pageNumberFieldResults: [],
            complexScriptFontSizeParagraphs: [],
            characterScaleParagraphs: [],
            characterSpacingParagraphs: [],
            autoLineHeightParagraphs: [],
            diagonalCellBorders: [],
            mergedCellEmptyParagraphs: [],
            sectionBreakParagraphIndexes: [],
            needsDefaultPageMargins: false,
            hasVerticalTextDirection: false
        };
    }
}
function $08414ea58bdc1292$var$repairDocxDefaultPageMargins(container, needsDefaultPageMargins) {
    if (!needsDefaultPageMargins) return;
    for (const page of container.querySelectorAll("section.ofv-docx"))if (!page.style.padding && !page.style.paddingTop && !page.style.paddingRight && !page.style.paddingBottom && !page.style.paddingLeft) page.style.padding = "72pt 90pt";
}
async function $08414ea58bdc1292$var$readDocxSvgImageAlternatives(arrayBuffer) {
    try {
        const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
        const documentXml = await zip.file("word/document.xml")?.async("text");
        const documentDoc = documentXml ? $08414ea58bdc1292$var$parseOfficeXml(documentXml) : void 0;
        if (!documentDoc) return [];
        const relationships = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "word/document.xml");
        const relationshipsById = new Map(relationships.map((relationship)=>[
                relationship.id,
                relationship
            ]));
        const alternatives = [];
        for (const blip of Array.from(documentDoc.getElementsByTagName("*"))){
            if (blip.localName !== "blip") continue;
            const svgBlip = Array.from(blip.getElementsByTagName("*")).find((element)=>element.localName === "svgBlip");
            const fallbackRelationship = relationshipsById.get($08414ea58bdc1292$var$getXmlAttribute3(blip, "embed") || "");
            const svgRelationship = relationshipsById.get(svgBlip ? $08414ea58bdc1292$var$getXmlAttribute3(svgBlip, "embed") || "" : "");
            const fallbackPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("word/document.xml", fallbackRelationship?.target);
            const svgPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("word/document.xml", svgRelationship?.target);
            if (!fallbackPath || !svgPath || $08414ea58bdc1292$var$mimeTypeFromPath(svgPath) !== "image/svg+xml") continue;
            const fallbackFile = zip.file(fallbackPath);
            const svgFile = zip.file(svgPath);
            if (!fallbackFile || !svgFile) continue;
            const [fallbackBase64, svgBase64] = await Promise.all([
                fallbackFile.async("base64"),
                svgFile.async("base64")
            ]);
            const fallbackMimeType = $08414ea58bdc1292$var$mimeTypeFromPath(fallbackPath);
            alternatives.push({
                fallbackDataUrls: [
                    `data:application/octet-stream;base64,${fallbackBase64}`,
                    `data:${fallbackMimeType};base64,${fallbackBase64}`
                ],
                svgDataUrl: `data:image/svg+xml;base64,${svgBase64}`
            });
        }
        return alternatives;
    } catch  {
        return [];
    }
}
function $08414ea58bdc1292$var$repairDocxSvgImageAlternatives(container, alternatives) {
    if (alternatives.length === 0) return;
    const alternativesByFallback = /* @__PURE__ */ new Map();
    for (const alternative of alternatives)for (const fallbackDataUrl of alternative.fallbackDataUrls){
        const svgDataUrls = alternativesByFallback.get(fallbackDataUrl) || [];
        svgDataUrls.push(alternative.svgDataUrl);
        alternativesByFallback.set(fallbackDataUrl, svgDataUrls);
    }
    for (const image of container.querySelectorAll("img")){
        const svgDataUrl = alternativesByFallback.get(image.getAttribute("src") || "")?.shift();
        if (svgDataUrl) {
            image.src = svgDataUrl;
            image.dataset.ofvDocxSvgAlternative = "true";
        }
    }
}
function $08414ea58bdc1292$var$repairUnexpectedDocxTableTextDirections(container, hasVerticalTextDirection) {
    if (hasVerticalTextDirection) return;
    for (const element of container.querySelectorAll("table, thead, tbody, tfoot, tr, th, td, table p, table span"))if (getComputedStyle(element).writingMode !== "horizontal-tb") {
        element.style.writingMode = "horizontal-tb";
        element.style.textOrientation = "mixed";
    }
}
function $08414ea58bdc1292$var$extractDocxComplexScriptFontSizeHints(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>{
        const descendants2 = Array.from(paragraph.getElementsByTagName("*"));
        if (descendants2.some((element)=>element.localName === "sz")) return void 0;
        const halfPointSizes = descendants2.filter((element)=>element.localName === "szCs").map((element)=>Number($08414ea58bdc1292$var$getXmlAttribute3(element, "val"))).filter((value)=>Number.isFinite(value) && value > 0);
        const uniqueSizes = [
            ...new Set(halfPointSizes)
        ];
        const text = $08414ea58bdc1292$var$normalizePreviewText(descendants2.filter((element)=>element.localName === "t").map((element)=>element.textContent || "").join(""));
        return text && uniqueSizes.length === 1 ? {
            text: text,
            fontSizePt: Math.max(1, Math.floor(uniqueSizes[0] / 2))
        } : void 0;
    }).filter((hint)=>Boolean(hint));
}
function $08414ea58bdc1292$var$repairDocxComplexScriptFontSizes(container, hints) {
    if (hints.length === 0) return;
    const candidatesByText = /* @__PURE__ */ new Map();
    for (const paragraph of container.querySelectorAll("section.ofv-docx p")){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        const candidates = candidatesByText.get(text) || [];
        candidates.push(paragraph);
        candidatesByText.set(text, candidates);
    }
    for (const hint of hints){
        const paragraph = candidatesByText.get(hint.text)?.shift();
        if (paragraph) paragraph.style.fontSize = `${$08414ea58bdc1292$var$formatCssNumber(hint.fontSizePt)}pt`;
    }
}
function $08414ea58bdc1292$var$extractDocxCharacterScaleHints(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>{
        const runs = Array.from(paragraph.getElementsByTagName("*")).filter((element)=>element.localName === "r");
        if (runs.length === 0) return void 0;
        const runScales = runs.map((run)=>{
            const runProperties = Array.from(run.children).find((child)=>child.localName === "rPr");
            const width = runProperties ? Array.from(runProperties.children).find((child)=>child.localName === "w") : void 0;
            const scalePercent = Number(width ? $08414ea58bdc1292$var$getXmlAttribute3(width, "val") : 0);
            const text2 = $08414ea58bdc1292$var$normalizePreviewText(Array.from(run.getElementsByTagName("*")).filter((child)=>child.localName === "t").map((child)=>child.textContent || "").join(""));
            return {
                text: text2,
                scalePercent: scalePercent
            };
        });
        const text = $08414ea58bdc1292$var$normalizePreviewText(runScales.map((run)=>run.text).join(""));
        const scales = runScales.filter((run)=>run.text).map((run)=>run.scalePercent);
        const uniqueScales = [
            ...new Set(scales)
        ];
        return text && uniqueScales.length === 1 && uniqueScales[0] > 0 && uniqueScales[0] < 100 ? {
            text: text,
            scalePercent: uniqueScales[0]
        } : void 0;
    }).filter((hint)=>Boolean(hint));
}
function $08414ea58bdc1292$var$repairDocxCharacterScaling(container, hints) {
    if (hints.length === 0) return;
    const candidatesByText = /* @__PURE__ */ new Map();
    for (const paragraph of container.querySelectorAll("section.ofv-docx p")){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        if (!text) continue;
        const candidates = candidatesByText.get(text) || [];
        candidates.push(paragraph);
        candidatesByText.set(text, candidates);
    }
    for (const hint of hints){
        const paragraph = candidatesByText.get(hint.text)?.shift();
        if (!paragraph || paragraph.dataset.ofvDocxCharacterScaled === "true") continue;
        if (paragraph.querySelector("img, svg, table")) continue;
        const scale = hint.scalePercent / 100;
        const align = paragraph.style.textAlign || getComputedStyle(paragraph).textAlign;
        const lineWrapper = document.createElement("span");
        lineWrapper.className = "ofv-docx-character-scale-line";
        lineWrapper.style.display = "block";
        lineWrapper.style.width = "100%";
        lineWrapper.style.whiteSpace = "nowrap";
        lineWrapper.style.textAlign = align;
        const textWrapper = document.createElement("span");
        textWrapper.className = "ofv-docx-character-scale";
        textWrapper.style.display = "inline-block";
        textWrapper.style.whiteSpace = "nowrap";
        textWrapper.style.transform = `scaleX(${$08414ea58bdc1292$var$formatCssNumber(scale)})`;
        textWrapper.style.transformOrigin = "left center";
        while(paragraph.firstChild)textWrapper.append(paragraph.firstChild);
        for (const descendant of textWrapper.querySelectorAll("*"))if (!descendant.querySelector("img, svg, table")) descendant.style.whiteSpace = "nowrap";
        lineWrapper.append(textWrapper);
        paragraph.append(lineWrapper);
        const unscaledWidth = textWrapper.offsetWidth;
        const visualOffset = unscaledWidth * (1 - scale);
        if (align === "right") {
            textWrapper.style.position = "relative";
            textWrapper.style.left = `${$08414ea58bdc1292$var$formatCssNumber(visualOffset)}px`;
        } else if (align === "center") {
            textWrapper.style.position = "relative";
            textWrapper.style.left = `${$08414ea58bdc1292$var$formatCssNumber(visualOffset / 2)}px`;
        }
        paragraph.style.whiteSpace = "nowrap";
        paragraph.dataset.ofvDocxCharacterScaled = "true";
    }
}
function $08414ea58bdc1292$var$extractDocxCharacterSpacingHints(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").flatMap((paragraph)=>{
        const runs = Array.from(paragraph.children).filter((element)=>element.localName === "r").flatMap((run)=>{
            const text2 = Array.from(run.getElementsByTagName("*")).filter((element)=>element.localName === "t").map((element)=>element.textContent || "").join("");
            if (!text2) return [];
            const runProperties = Array.from(run.children).find((element)=>element.localName === "rPr");
            const spacing = runProperties ? Array.from(runProperties.children).find((element)=>element.localName === "spacing") : void 0;
            const spacingTwentieths = Number(spacing ? $08414ea58bdc1292$var$getXmlAttribute3(spacing, "val") : Number.NaN);
            return Number.isFinite(spacingTwentieths) ? [
                {
                    text: text2,
                    spacingPt: spacingTwentieths / 20
                }
            ] : [
                {
                    text: text2
                }
            ];
        });
        const text = $08414ea58bdc1292$var$normalizePreviewText(runs.map((run)=>run.text).join(""));
        return text && runs.some((run)=>run.spacingPt !== void 0) ? [
            {
                text: text,
                runs: runs
            }
        ] : [];
    });
}
function $08414ea58bdc1292$var$repairDocxCharacterSpacing(container, hints) {
    if (hints.length === 0) return;
    const candidatesByText = /* @__PURE__ */ new Map();
    for (const paragraph of container.querySelectorAll("section.ofv-docx article p")){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        if (!text) continue;
        const candidates = candidatesByText.get(text) || [];
        candidates.push(paragraph);
        candidatesByText.set(text, candidates);
    }
    for (const hint of hints){
        const paragraph = candidatesByText.get(hint.text)?.shift();
        if (!paragraph) continue;
        const renderedRuns = $08414ea58bdc1292$var$getRenderedDocxRuns(paragraph);
        let renderedIndex = 0;
        for (const run of hint.runs)while(renderedIndex < renderedRuns.length){
            const renderedRun = renderedRuns[renderedIndex++];
            if (!$08414ea58bdc1292$var$docxRunTextsMatch(renderedRun.textContent || "", run.text)) continue;
            if (run.spacingPt !== void 0) {
                renderedRun.style.letterSpacing = `${$08414ea58bdc1292$var$formatCssNumber(run.spacingPt)}pt`;
                renderedRun.dataset.ofvDocxCharacterSpacing = "true";
            }
            break;
        }
    }
}
function $08414ea58bdc1292$var$getRenderedDocxRuns(paragraph) {
    return Array.from(paragraph.children).flatMap((child)=>{
        if (!(child instanceof HTMLElement)) return [];
        if (child.tagName === "SPAN") return [
            child
        ];
        return Array.from(child.querySelectorAll(":scope > span"));
    });
}
function $08414ea58bdc1292$var$docxRunTextsMatch(renderedText, sourceText) {
    const normalizedSource = $08414ea58bdc1292$var$normalizePreviewText(sourceText);
    return normalizedSource ? $08414ea58bdc1292$var$normalizePreviewText(renderedText) === normalizedSource : sourceText.length > 0 && /^\s+$/.test(sourceText) && /^\s+$/.test(renderedText);
}
var $08414ea58bdc1292$var$DOCX_WORD_SINGLE_LINE_EM = 1.31;
var $08414ea58bdc1292$var$DOCX_WORD_TABLE_SINGLE_LINE_EM = 1.6;
function $08414ea58bdc1292$var$extractDocxAutoLineHeightHints(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").flatMap((paragraph, paragraphIndex)=>{
        const properties = Array.from(paragraph.children).find((element)=>element.localName === "pPr");
        const spacing = properties ? Array.from(properties.children).find((element)=>element.localName === "spacing") : void 0;
        const runProperties = properties ? Array.from(properties.children).find((element)=>element.localName === "rPr") : void 0;
        const fontSize = runProperties ? Array.from(runProperties.children).find((element)=>element.localName === "sz") : void 0;
        const halfPointFontSize = Number(fontSize ? $08414ea58bdc1292$var$getXmlAttribute3(fontSize, "val") : Number.NaN);
        const line = Number(spacing ? $08414ea58bdc1292$var$getXmlAttribute3(spacing, "line") : 0);
        const text = $08414ea58bdc1292$var$normalizePreviewText(Array.from(paragraph.getElementsByTagName("*")).filter((element)=>element.localName === "t").map((element)=>element.textContent || "").join(""));
        if (!spacing || $08414ea58bdc1292$var$getXmlAttribute3(spacing, "lineRule") !== "auto" || !Number.isFinite(line) || line <= 0) return [];
        return [
            {
                paragraphIndex: paragraphIndex,
                text: text,
                lineMultiple: line / 240,
                ...Number.isFinite(halfPointFontSize) && halfPointFontSize > 0 ? {
                    fontSizePt: halfPointFontSize / 2
                } : {}
            }
        ];
    });
}
function $08414ea58bdc1292$var$repairDocxAutoLineHeights(container, hints) {
    if (hints.length === 0) return;
    const paragraphs = Array.from(container.querySelectorAll("section.ofv-docx article p"));
    for (const hint of hints){
        const paragraph = paragraphs[hint.paragraphIndex];
        if (!paragraph || $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "") !== hint.text) continue;
        const tableCell = paragraph.closest("td, th");
        const singleLineEm = tableCell ? $08414ea58bdc1292$var$DOCX_WORD_TABLE_SINGLE_LINE_EM : $08414ea58bdc1292$var$DOCX_WORD_SINGLE_LINE_EM;
        if (tableCell) {
            const renderedFontSizePx = $08414ea58bdc1292$var$getDocxRenderedTextFontSizeInPixels(paragraph) || (hint.fontSizePt ? hint.fontSizePt * (4 / 3) : $08414ea58bdc1292$var$getLargestDocxFontSize(paragraph));
            paragraph.style.lineHeight = `${$08414ea58bdc1292$var$formatCssNumber(hint.lineMultiple * singleLineEm * renderedFontSizePx)}px`;
            paragraph.style.marginTop = "0px";
        } else paragraph.style.lineHeight = $08414ea58bdc1292$var$formatCssNumber(hint.lineMultiple * singleLineEm);
        if (!hint.text && hint.fontSizePt) {
            paragraph.style.fontSize = `${$08414ea58bdc1292$var$formatCssNumber(hint.fontSizePt)}pt`;
            paragraph.style.minHeight = `${$08414ea58bdc1292$var$formatCssNumber(hint.fontSizePt * hint.lineMultiple * singleLineEm)}pt`;
        }
        paragraph.dataset.ofvDocxAutoLineHeight = "true";
    }
}
function $08414ea58bdc1292$var$getDocxRenderedTextFontSizeInPixels(paragraph) {
    const view3 = paragraph.ownerDocument.defaultView;
    let largest = 0;
    for (const run of paragraph.querySelectorAll("span")){
        if (!$08414ea58bdc1292$var$normalizePreviewText(run.textContent || "")) continue;
        const inlineSize = $08414ea58bdc1292$var$parseCssLengthInPixels(run.style.fontSize);
        const computedSize = view3 ? $08414ea58bdc1292$var$parseCssLengthInPixels(view3.getComputedStyle(run).fontSize) : 0;
        largest = Math.max(largest, inlineSize || computedSize);
    }
    return largest;
}
function $08414ea58bdc1292$var$forEachDocxSourceTableCell(xml, visit) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return;
    const tables = Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "tbl");
    tables.forEach((table, tableIndex)=>{
        const rows = Array.from(table.children).filter((element)=>element.localName === "tr");
        rows.forEach((row, rowIndex)=>{
            const rowProperties = $08414ea58bdc1292$var$firstDirectOfficeChild(row, "trPr");
            const gridBefore = rowProperties ? $08414ea58bdc1292$var$firstDirectOfficeChild(rowProperties, "gridBefore") : void 0;
            const parsedGridBefore = Number(gridBefore ? $08414ea58bdc1292$var$getXmlAttribute3(gridBefore, "val") : 0);
            let columnIndex = Number.isFinite(parsedGridBefore) && parsedGridBefore > 0 ? parsedGridBefore : 0;
            for (const cell of Array.from(row.children).filter((element)=>element.localName === "tc")){
                const properties = $08414ea58bdc1292$var$firstDirectOfficeChild(cell, "tcPr");
                visit({
                    tableIndex: tableIndex,
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    cell: cell,
                    properties: properties
                });
                const gridSpan = properties ? $08414ea58bdc1292$var$firstDirectOfficeChild(properties, "gridSpan") : void 0;
                const parsedGridSpan = Number(gridSpan ? $08414ea58bdc1292$var$getXmlAttribute3(gridSpan, "val") : 1);
                columnIndex += Number.isFinite(parsedGridSpan) && parsedGridSpan > 0 ? parsedGridSpan : 1;
            }
        });
    });
}
function $08414ea58bdc1292$var$extractDocxDiagonalCellBorders(xml) {
    const hints = [];
    $08414ea58bdc1292$var$forEachDocxSourceTableCell(xml, ({ tableIndex: tableIndex, rowIndex: rowIndex, columnIndex: columnIndex, properties: properties })=>{
        const borders = properties ? $08414ea58bdc1292$var$firstDirectOfficeChild(properties, "tcBorders") : void 0;
        if (!borders) return;
        for (const direction of [
            "tl2br",
            "tr2bl"
        ]){
            const border = $08414ea58bdc1292$var$firstDirectOfficeChild(borders, direction);
            const value = border ? ($08414ea58bdc1292$var$getXmlAttribute3(border, "val") || "single").toLowerCase() : "none";
            if (!border || value === "none" || value === "nil") continue;
            const rawColor = ($08414ea58bdc1292$var$getXmlAttribute3(border, "color") || "000000").replace(/^#/, "");
            const widthEighthPoints = Number($08414ea58bdc1292$var$getXmlAttribute3(border, "sz"));
            hints.push({
                tableIndex: tableIndex,
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                direction: direction,
                color: /^[0-9a-f]{6}$/i.test(rawColor) ? `#${rawColor}` : "#000000",
                widthPt: Number.isFinite(widthEighthPoints) && widthEighthPoints > 0 ? Math.max(0.5, Math.min(6, widthEighthPoints / 8)) : 0.75
            });
        }
    });
    return hints;
}
function $08414ea58bdc1292$var$extractDocxMergedCellEmptyParagraphs(xml) {
    const hints = [];
    $08414ea58bdc1292$var$forEachDocxSourceTableCell(xml, ({ tableIndex: tableIndex, rowIndex: rowIndex, columnIndex: columnIndex, cell: cell, properties: properties })=>{
        const verticalMerge = properties ? $08414ea58bdc1292$var$firstDirectOfficeChild(properties, "vMerge") : void 0;
        if (!verticalMerge || ($08414ea58bdc1292$var$getXmlAttribute3(verticalMerge, "val") || "continue").toLowerCase() === "restart") return;
        const emptyParagraphs = Array.from(cell.children).filter((element)=>element.localName === "p").filter((paragraph)=>{
            if ($08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "")) return false;
            return !Array.from(paragraph.getElementsByTagName("*")).some((element)=>[
                    "br",
                    "tab",
                    "drawing",
                    "pict",
                    "object"
                ].includes(element.localName));
        }).length;
        if (emptyParagraphs > 0) hints.push({
            tableIndex: tableIndex,
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            count: emptyParagraphs
        });
    });
    return hints;
}
function $08414ea58bdc1292$var$findRenderedDocxTableCell(table, rowIndex, columnIndex) {
    return Array.from($08414ea58bdc1292$var$mapDocxTableCellPlacements(Array.from(table.rows)).values()).find((placement)=>placement.columnIndex === columnIndex && placement.rowIndex <= rowIndex && placement.rowIndex + placement.rowSpan > rowIndex)?.cell;
}
function $08414ea58bdc1292$var$repairDocxDiagonalCellBorders(container, hints) {
    const tables = Array.from(container.querySelectorAll("section.ofv-docx article table"));
    for (const hint of hints){
        const cell = tables[hint.tableIndex] ? $08414ea58bdc1292$var$findRenderedDocxTableCell(tables[hint.tableIndex], hint.rowIndex, hint.columnIndex) : void 0;
        if (!cell) continue;
        if (hint.direction === "tl2br") cell.dataset.ofvDocxDiagonalTl2br = "true";
        else cell.dataset.ofvDocxDiagonalTr2bl = "true";
        cell.style.setProperty("--ofv-docx-diagonal-color", hint.color);
        cell.style.setProperty("--ofv-docx-diagonal-half-width", `${$08414ea58bdc1292$var$formatCssNumber(hint.widthPt / 2)}pt`);
    }
}
function $08414ea58bdc1292$var$repairDocxMergedCellEmptyParagraphs(container, hints) {
    const tables = Array.from(container.querySelectorAll("section.ofv-docx article table"));
    const mergedCells = /* @__PURE__ */ new Set();
    for (const hint of hints){
        const cell = tables[hint.tableIndex] ? $08414ea58bdc1292$var$findRenderedDocxTableCell(tables[hint.tableIndex], hint.rowIndex, hint.columnIndex) : void 0;
        if (cell && cell.rowSpan > 1) mergedCells.add(cell);
    }
    for (const cell of mergedCells){
        const paragraphs = Array.from(cell.children).filter((element)=>element instanceof HTMLParagraphElement);
        const removable = paragraphs.filter((paragraph)=>!$08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "") && !paragraph.querySelector("br, hr, img, svg, canvas, video, audio, object, table")).reverse();
        removable.forEach((paragraph)=>paragraph.remove());
        if (removable.length > 0) cell.dataset.ofvDocxMergedEmptyParagraphsRemoved = String(removable.length);
    }
}
function $08414ea58bdc1292$var$repairDocxMergedCellTableBottomBorders(container) {
    const tables = container.querySelectorAll("section.ofv-docx article table");
    for (const table of tables){
        const lastRow = table.rows.item(table.rows.length - 1);
        if (!lastRow || table.style.borderBottomStyle && table.style.borderBottomStyle !== "none") continue;
        const terminalMergeCell = Array.from(lastRow.cells).find((cell)=>{
            const style = cell.style;
            return style.display === "none" && style.borderBottomStyle !== "none" && $08414ea58bdc1292$var$parseCssPixelValue(style.borderBottomWidth) > 0;
        });
        if (!terminalMergeCell) continue;
        table.style.borderBottomWidth = terminalMergeCell.style.borderBottomWidth;
        table.style.borderBottomStyle = terminalMergeCell.style.borderBottomStyle;
        table.style.borderBottomColor = terminalMergeCell.style.borderBottomColor;
        table.dataset.ofvDocxMergedBottomBorderRepaired = "true";
    }
}
function $08414ea58bdc1292$var$extractDocxSectionBreakParagraphIndexes(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").flatMap((paragraph, paragraphIndex)=>{
        const properties = Array.from(paragraph.children).find((element)=>element.localName === "pPr");
        return properties && Array.from(properties.children).some((element)=>element.localName === "sectPr") ? [
            paragraphIndex
        ] : [];
    });
}
function $08414ea58bdc1292$var$markDocxSectionBreakParagraphs(container, paragraphIndexes) {
    if (paragraphIndexes.length === 0) return;
    const sourcePages = Array.from(container.querySelectorAll(".ofv-docx-wrapper > section.ofv-docx"));
    if (sourcePages.length > paragraphIndexes.length) {
        sourcePages.slice(0, paragraphIndexes.length).forEach((page)=>{
            const article = Array.from(page.children).find((child)=>child instanceof HTMLElement && child.tagName === "ARTICLE");
            const boundary = Array.from(article?.children || []).reverse().find((child)=>child instanceof HTMLParagraphElement);
            if (boundary) boundary.dataset.ofvDocxSectionBreak = "true";
        });
        return;
    }
    const paragraphs = Array.from(container.querySelectorAll("section.ofv-docx article p"));
    for (const paragraphIndex of paragraphIndexes){
        const paragraph = paragraphs[paragraphIndex];
        if (paragraph) paragraph.dataset.ofvDocxSectionBreak = "true";
    }
}
function $08414ea58bdc1292$var$extractDocxPageNumberFieldResults(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    const results = [];
    let inField = false;
    let isPageField = false;
    let afterSeparator = false;
    let result = "";
    for (const element of Array.from(document2.getElementsByTagName("*"))){
        if (element.localName === "fldChar") {
            const type = $08414ea58bdc1292$var$getXmlAttribute3(element, "fldCharType");
            if (type === "begin") {
                inField = true;
                isPageField = false;
                afterSeparator = false;
                result = "";
            } else if (inField && type === "separate") afterSeparator = true;
            else if (inField && type === "end") {
                if (isPageField && afterSeparator && result.trim()) results.push(result.trim());
                inField = false;
            }
            continue;
        }
        if (inField && element.localName === "instrText" && /\bPAGE\b/i.test(element.textContent || "")) isPageField = true;
        else if (inField && isPageField && afterSeparator && element.localName === "t") result += element.textContent || "";
    }
    return results;
}
function $08414ea58bdc1292$var$markDocxPageNumberFields(container, fieldResults) {
    if (fieldResults.length === 0) return;
    const expectedResults = new Set(fieldResults.map((value)=>$08414ea58bdc1292$var$normalizePreviewText(value)));
    for (const footer of container.querySelectorAll("section.ofv-docx footer")){
        const candidates = Array.from(footer.querySelectorAll("span")).filter((span)=>span.children.length === 0 && expectedResults.has($08414ea58bdc1292$var$normalizePreviewText(span.textContent || "")));
        if (candidates.length === 1) candidates[0]?.classList.add("ofv-docx-page-number-field");
    }
}
function $08414ea58bdc1292$var$extractDocxRightTabParagraphHints(xml) {
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
    if (!document2) return [];
    return Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>{
        const properties = Array.from(paragraph.children).find((child)=>child.localName === "pPr");
        const configuredTabs = properties ? Array.from(properties.getElementsByTagName("*")).filter((child)=>child.localName === "tab") : [];
        const contentTabs = Array.from(paragraph.getElementsByTagName("*")).filter((child)=>child.localName === "tab" && !properties?.contains(child));
        const tab = configuredTabs.length === 1 && contentTabs.length === 1 ? configuredTabs[0] : void 0;
        const frame = properties ? Array.from(properties.children).find((child)=>child.localName === "framePr") : void 0;
        const positionTwips = Number(tab ? $08414ea58bdc1292$var$getXmlAttribute3(tab, "pos") : 0);
        const text = $08414ea58bdc1292$var$normalizePreviewText(Array.from(paragraph.getElementsByTagName("*")).filter((child)=>child.localName === "t").map((child)=>child.textContent || "").join(""));
        return tab && $08414ea58bdc1292$var$getXmlAttribute3(tab, "val") === "right" && positionTwips > 0 && text ? {
            text: text,
            positionPt: positionTwips / 20,
            pageBottomFrame: Boolean(frame && $08414ea58bdc1292$var$getXmlAttribute3(frame, "yAlign") === "bottom")
        } : void 0;
    }).filter((hint)=>Boolean(hint));
}
function $08414ea58bdc1292$var$repairDocxRightTabStops(container, hints) {
    if (hints.length === 0) return;
    const paragraphs = Array.from(container.querySelectorAll("section.ofv-docx p")).filter((paragraph)=>paragraph.querySelectorAll(".ofv-docx-tab-stop").length === 1);
    const candidatesByText = /* @__PURE__ */ new Map();
    for (const paragraph of paragraphs){
        const text = $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "");
        const candidates = candidatesByText.get(text) || [];
        candidates.push(paragraph);
        candidatesByText.set(text, candidates);
    }
    for (const hint of hints){
        const paragraph = candidatesByText.get(hint.text)?.shift();
        if (paragraph) $08414ea58bdc1292$var$repairDocxRightTabParagraph(paragraph, hint);
    }
}
function $08414ea58bdc1292$var$repairDocxRightTabParagraph(paragraph, hint) {
    const tabStop = paragraph.querySelector(".ofv-docx-tab-stop");
    if (!tabStop || paragraph.querySelector(".ofv-docx-right-tab-line")) return;
    let tabRun = tabStop;
    while(tabRun.parentElement && tabRun.parentElement !== paragraph)tabRun = tabRun.parentElement;
    if (tabRun.parentElement !== paragraph) return;
    const nodes = Array.from(paragraph.childNodes);
    const tabIndex = nodes.indexOf(tabRun);
    const before = nodes.slice(0, tabIndex);
    const after = nodes.slice(tabIndex + 1);
    if (tabIndex < 0 || $08414ea58bdc1292$var$normalizePreviewText(after.map((node)=>node.textContent || "").join("")) === "") return;
    const line = document.createElement("span");
    line.className = "ofv-docx-right-tab-line";
    line.style.setProperty("--ofv-docx-right-tab-position", `${$08414ea58bdc1292$var$formatCssNumber(hint.positionPt)}pt`);
    const start = document.createElement("span");
    start.className = "ofv-docx-right-tab-start";
    start.append(...before);
    const end = document.createElement("span");
    end.className = "ofv-docx-right-tab-end";
    end.append(...after);
    line.append(start, end);
    tabRun.classList.add("ofv-docx-right-tab-source");
    if (hint.pageBottomFrame) paragraph.classList.add("ofv-docx-page-bottom-frame");
    paragraph.replaceChildren(line, tabRun);
}
function $08414ea58bdc1292$var$extractDocxEastAsiaFonts(stylesXml, themeXml) {
    const defaults = /<w:docDefaults\b[\s\S]*?<\/w:docDefaults>/.exec(stylesXml)?.[0] || "";
    const directFont = /<w:rFonts\b[^>]*\bw:eastAsia="([^"]+)"/.exec(defaults)?.[1];
    const themeName = /<w:rFonts\b[^>]*\bw:eastAsiaTheme="([^"]+)"/.exec(defaults)?.[1] || "minorEastAsia";
    const major = $08414ea58bdc1292$var$extractDocxThemeEastAsiaFont(themeXml, "major");
    const minor = $08414ea58bdc1292$var$extractDocxThemeEastAsiaFont(themeXml, "minor");
    const direct = directFont ? $08414ea58bdc1292$var$decodeXml2(directFont).trim() || void 0 : void 0;
    return {
        fallback: direct || (/^major/i.test(themeName) ? major : minor) || minor || major,
        major: major,
        minor: minor
    };
}
function $08414ea58bdc1292$var$extractDocxThemeEastAsiaFont(themeXml, kind) {
    const block = new RegExp(`<a:${kind}Font\\b[\\s\\S]*?<\\/a:${kind}Font>`, "i").exec(themeXml)?.[0] || "";
    const eastAsia = /<a:ea\b[^>]*\btypeface="([^"]+)"/i.exec(block)?.[1];
    const scriptFont = /<a:font\b[^>]*\bscript="Hans"[^>]*\btypeface="([^"]+)"/i.exec(block)?.[1];
    const font = eastAsia || scriptFont;
    return font ? $08414ea58bdc1292$var$decodeXml2(font).trim() || void 0 : void 0;
}
function $08414ea58bdc1292$var$normalizeDocxEastAsiaFontStyles(styleContainer, fonts) {
    if (!styleContainer?.textContent || !fonts?.fallback) return;
    const safeFallback = $08414ea58bdc1292$var$sanitizeDocxCssFontFamily(fonts.fallback);
    if (!safeFallback) return;
    const variable = "--ofv-docx-east-asia-font";
    const css = styleContainer.textContent.replace(/font-family:\s*([^;{}]+);/gi, (declaration, families)=>{
        if (families.includes(variable)) return declaration;
        return `font-family: ${families.trim()}, var(${variable});`;
    });
    const declarations = [
        `${variable}: "${safeFallback}";`,
        `--docx-majorEastAsia-font: "${$08414ea58bdc1292$var$sanitizeDocxCssFontFamily(fonts.major) || safeFallback}";`,
        `--docx-minorEastAsia-font: "${$08414ea58bdc1292$var$sanitizeDocxCssFontFamily(fonts.minor) || safeFallback}";`
    ];
    styleContainer.textContent = `${css}
.ofv-docx-wrapper { ${declarations.join(" ")} }
`;
}
function $08414ea58bdc1292$var$sanitizeDocxCssFontFamily(fontFamily) {
    return fontFamily?.replace(/["'\\,;{}()]/g, "").trim() || "";
}
function $08414ea58bdc1292$var$extractFloatingPictureHints(xml) {
    return [
        ...xml.matchAll(/<wp:anchor\b[\s\S]*?<\/wp:anchor>/g)
    ].filter((match)=>{
        const primaryGraphicType = /<a:graphicData\b[^>]*\buri="([^"]+)"/.exec(match[0])?.[1];
        return primaryGraphicType === "http://schemas.openxmlformats.org/drawingml/2006/picture";
    }).map((match)=>{
        const anchor = match[0];
        const extent = /<wp:extent\b[^>]*\bcx="(\d+)"[^>]*\bcy="(\d+)"/.exec(anchor);
        const offsetX = /<wp:positionH\b[^>]*\brelativeFrom="([^"]+)"[\s\S]*?<wp:posOffset>(-?\d+)<\/wp:posOffset>/.exec(anchor);
        const offsetY = /<wp:positionV\b[^>]*\brelativeFrom="([^"]+)"[\s\S]*?<wp:posOffset>(-?\d+)<\/wp:posOffset>/.exec(anchor);
        return {
            widthPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.[1] || 0)),
            heightPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.[2] || 0)),
            offsetXPt: $08414ea58bdc1292$var$emuToPt(Number(offsetX?.[2] || 0)),
            offsetYPt: $08414ea58bdc1292$var$emuToPt(Number(offsetY?.[2] || 0)),
            relativeFrom: offsetX?.[1] || "",
            // Keep the vertical anchor relationship independent from the offset
            // capture. Some WPS-generated files contain namespace/attribute
            // formatting that makes the broad offset expression capture the
            // number but not the relationship consistently.
            relativeToParagraph: /<wp:positionV\b[^>]*\brelativeFrom=["']paragraph["']/i.test(anchor),
            wrap: /<wp:wrapSquare\b/.test(anchor) ? "square" : /<wp:wrapNone\b/.test(anchor) ? "none" : ""
        };
    }).filter((hint)=>hint.widthPt > 0 && hint.heightPt > 0);
}
function $08414ea58bdc1292$var$extractFloatingShapeHints(xml) {
    return [
        ...xml.matchAll(/<wp:anchor\b[\s\S]*?<\/wp:anchor>/g)
    ].filter((match)=>/<a:graphicData\b[^>]*uri="http:\/\/schemas\.microsoft\.com\/office\/word\/2010\/wordprocessingShape"/.test(match[0])).map((match)=>{
        const anchor = match[0];
        const offsetX = /<wp:positionH\b[^>]*\brelativeFrom="([^"]+)"[\s\S]*?<wp:posOffset>(-?\d+)<\/wp:posOffset>/.exec(anchor);
        const offsetY = /<wp:positionV\b[^>]*\brelativeFrom="([^"]+)"[\s\S]*?<wp:posOffset>(-?\d+)<\/wp:posOffset>/.exec(anchor);
        const extent = /<wp:extent\b[^>]*\bcx="(\d+)"[^>]*\bcy="(\d+)"/.exec(anchor);
        return {
            offsetXPt: $08414ea58bdc1292$var$emuToPt(Number(offsetX?.[2] || 0)),
            offsetYPt: $08414ea58bdc1292$var$emuToPt(Number(offsetY?.[2] || 0)),
            widthPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.[1] || 0)),
            heightPt: $08414ea58bdc1292$var$emuToPt(Number(extent?.[2] || 0)),
            relativeFrom: offsetX?.[1] || "",
            relativeV: offsetY?.[1] || "",
            hasFill: /<a:solidFill\b/.test(anchor),
            hasText: /<w:t(?:\s[^>]*)?>[^<\s]/.test(anchor)
        };
    });
}
function $08414ea58bdc1292$var$emuToPt(value) {
    return value / 12700;
}
function $08414ea58bdc1292$var$repairDocxShapeFills(page) {
    for (const svg of page.querySelectorAll("svg")){
        const image = svg.querySelector("image[fill]");
        if (!image) continue;
        const fill = image.getAttribute("fill");
        if (!fill || svg.querySelector("rect[data-ofv-docx-shape-fill]")) continue;
        const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.setAttribute("data-ofv-docx-shape-fill", "true");
        rect.setAttribute("x", "0");
        rect.setAttribute("y", "0");
        rect.setAttribute("width", "100%");
        rect.setAttribute("height", "100%");
        rect.setAttribute("fill", fill);
        const stroke = image.getAttribute("stroke");
        if (stroke && stroke !== "null") {
            rect.setAttribute("stroke", stroke);
            rect.setAttribute("stroke-width", image.getAttribute("stroke-width") || "1");
        }
        svg.insertBefore(rect, svg.firstChild);
    }
}
function $08414ea58bdc1292$var$repairDocxFloatingShapeTextboxes(container, hints) {
    const shapes = Array.from(container.querySelectorAll("section.ofv-docx article svg")).filter((svg)=>Boolean(svg.querySelector("image > foreignObject")));
    for (const shape of shapes){
        const foreignObject = shape.querySelector("image > foreignObject");
        if (foreignObject) {
            shape.append(foreignObject);
            shape.dataset.ofvDocxTextboxRepaired = "true";
        }
    }
    if (shapes.length !== hints.length) return;
    shapes.forEach((shape, index)=>{
        const hint = hints[index];
        const page = shape.closest("section.ofv-docx");
        if (!page || hint.relativeFrom !== "column") return;
        const pagePaddingLeft = $08414ea58bdc1292$var$parseCssPixelValue(page.style.paddingLeft || page.style.padding) || 0;
        shape.style.marginLeft = `${$08414ea58bdc1292$var$formatCssNumber(pagePaddingLeft + hint.offsetXPt)}pt`;
        if (hint.relativeV === "page") {
            shape.style.top = `${$08414ea58bdc1292$var$formatCssNumber(hint.offsetYPt)}pt`;
            shape.style.marginTop = "0pt";
        }
    });
    $08414ea58bdc1292$var$repairDocxCoverPageFloatingLayout(shapes, hints);
}
function $08414ea58bdc1292$var$repairDocxCoverPageFloatingLayout(shapes, hints) {
    if (shapes.length < 4 || hints.length < 4) return;
    const [background, title, leftPanel, rightPanel] = hints;
    if (!background.hasFill || background.hasText || background.widthPt < 400 || background.heightPt < 60 || !title.hasText || title.relativeV !== "page" || title.widthPt < 400 || !leftPanel.hasText || !rightPanel.hasText || leftPanel.relativeV !== "paragraph" || rightPanel.relativeV !== "paragraph" || leftPanel.heightPt < 300 || rightPanel.heightPt < 300 || leftPanel.widthPt > 300 || rightPanel.widthPt > 300 || shapes.slice(0, 4).some((shape)=>shape.closest("section.ofv-docx") !== shapes[0]?.closest("section.ofv-docx"))) return;
    const backgroundTop = Math.max(0, title.offsetYPt + (title.heightPt - background.heightPt) / 2);
    shapes[0].style.top = `${$08414ea58bdc1292$var$formatCssNumber(backgroundTop)}pt`;
    shapes[0].style.marginTop = "0pt";
    const panelTop = backgroundTop + background.heightPt + title.heightPt;
    for (const panel of shapes.slice(2, 4)){
        panel.style.top = `${$08414ea58bdc1292$var$formatCssNumber(panelTop)}pt`;
        panel.style.marginTop = "0pt";
    }
}
function $08414ea58bdc1292$var$repairDocxFloatingPicturesAcrossPages(container, hints) {
    const pictureHints = hints.floatingPictures.filter((item)=>item.relativeFrom === "column" && (item.wrap === "square" || item.wrap === "none"));
    if (pictureHints.length === 0) return;
    const pages = Array.from(container.querySelectorAll("section.ofv-docx"));
    const images = pages.flatMap((page)=>Array.from(page.querySelectorAll("img")).filter((image)=>image.closest("header, footer") === null).map((image)=>({
                image: image,
                page: page
            })));
    const floatingImages = images.filter(({ image: image })=>$08414ea58bdc1292$var$isDocxFloatingPictureCandidate(image));
    const candidates = floatingImages.length === pictureHints.length ? floatingImages : images.length === pictureHints.length ? images : [];
    if (candidates.length !== pictureHints.length) return;
    candidates.forEach(({ image: image, page: page }, index)=>{
        const pagePaddingLeft = $08414ea58bdc1292$var$parseCssPixelValue(page.style.paddingLeft || page.style.padding) || 0;
        $08414ea58bdc1292$var$repairDocxFloatingPicture(page, image, pictureHints[index], pagePaddingLeft);
    });
}
function $08414ea58bdc1292$var$isDocxFloatingPictureCandidate(image) {
    const wrapper = image.parentElement;
    if (!wrapper) return false;
    const style = wrapper.style;
    return style.float === "left" || style.float === "right" || style.position === "absolute" || style.display === "block" && $08414ea58bdc1292$var$isZeroCssLength(style.width) && $08414ea58bdc1292$var$isZeroCssLength(style.height);
}
function $08414ea58bdc1292$var$isZeroCssLength(value) {
    return /^(?:0(?:px|pt)?|0\.0+(?:px|pt)?)$/i.test(value.trim());
}
function $08414ea58bdc1292$var$repositionDocxFloatingPicturesFromAnchorParagraphs(container, hints) {
    const pictureHints = hints.floatingPictures.filter((item)=>item.relativeFrom === "column" && (item.wrap === "square" || item.wrap === "none"));
    if (pictureHints.length === 0) return;
    const images = Array.from(container.querySelectorAll("section.ofv-docx img")).filter((image)=>image.closest("header, footer") === null && image.parentElement?.dataset.ofvDocxFloatRepaired === "true");
    if (images.length !== pictureHints.length) return;
    images.forEach((image, index)=>{
        const wrapper = image.parentElement;
        const page = image.closest("section.ofv-docx");
        const paragraph = wrapper?.closest("p");
        if (!wrapper || !page || !paragraph) return;
        const hint = pictureHints[index];
        const top = $08414ea58bdc1292$var$getElementTopInPt(paragraph, page) + hint.offsetYPt;
        wrapper.style.top = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(0, top))}pt`;
    });
}
function $08414ea58bdc1292$var$repairDocxHeaderFloatingPictures(page, hints) {
    const images = Array.from(page.querySelectorAll("header img")).filter((image)=>image.closest("[data-ofv-docx-float-repaired='true']") === null);
    if (images.length === 0 || images.length !== hints.headerFloatingPictures.length) return;
    const pagePaddingLeft = $08414ea58bdc1292$var$parseCssPixelValue(page.style.paddingLeft || page.style.padding) || 0;
    const pagePaddingTop = $08414ea58bdc1292$var$parseCssPixelValue(page.style.paddingTop || page.style.padding) || 0;
    images.forEach((image, index)=>{
        const header = image.closest("header");
        const headerTop = pagePaddingTop + $08414ea58bdc1292$var$parseCssLengthInPoints(header?.style.marginTop || "");
        $08414ea58bdc1292$var$repairDocxFloatingPicture(page, image, hints.headerFloatingPictures[index], pagePaddingLeft, headerTop);
    });
}
function $08414ea58bdc1292$var$repairDocxFloatingPicture(page, image, hint, horizontalOriginPt = 0, verticalOriginPt) {
    const wrapper = image.parentElement;
    if (!wrapper) return;
    const pageWidth = $08414ea58bdc1292$var$parseCssPixelValue(page.style.width) || page.getBoundingClientRect().width;
    const pagePaddingRight = $08414ea58bdc1292$var$parseCssPixelValue(page.style.paddingRight || page.style.padding) || 0;
    const width = hint.widthPt;
    const left = Math.max(0, Math.min(pageWidth - pagePaddingRight - width, horizontalOriginPt + hint.offsetXPt));
    const paragraph = wrapper.closest("p");
    const paragraphTop = paragraph ? $08414ea58bdc1292$var$getElementTopInPt(paragraph, page) : $08414ea58bdc1292$var$getPagePaddingTopInPt(page);
    const wrapperTop = $08414ea58bdc1292$var$getElementTopInPt(wrapper, page);
    const wrapperOffsetTop = $08414ea58bdc1292$var$parseCssLengthInPoints(wrapper.style.top);
    const flowTop = paragraph ? paragraphTop : $08414ea58bdc1292$var$findDocxFloatingPictureFlowTop(wrapper, page, Math.max($08414ea58bdc1292$var$getPagePaddingTopInPt(page), wrapperTop - wrapperOffsetTop));
    const top = hint.relativeToParagraph ? (verticalOriginPt ?? flowTop) + hint.offsetYPt : hint.offsetYPt;
    wrapper.dataset.ofvDocxFloatRepaired = "true";
    wrapper.style.position = "absolute";
    wrapper.style.float = "none";
    wrapper.style.left = `${$08414ea58bdc1292$var$formatCssNumber(left)}pt`;
    wrapper.style.top = `${$08414ea58bdc1292$var$formatCssNumber(Math.max(0, top))}pt`;
    wrapper.style.width = `${$08414ea58bdc1292$var$formatCssNumber(width)}pt`;
    wrapper.style.height = `${$08414ea58bdc1292$var$formatCssNumber(hint.heightPt)}pt`;
    wrapper.style.zIndex = "1";
    image.style.width = "100%";
    image.style.height = "100%";
    image.style.objectFit = "cover";
    if (paragraph && image.closest("header") && $08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "")) {
        const reservedWidth = Math.max(0, hint.offsetXPt) + width;
        const existingPadding = $08414ea58bdc1292$var$parseCssLengthInPoints(paragraph.style.paddingLeft);
        if (reservedWidth > existingPadding) paragraph.style.paddingLeft = `${$08414ea58bdc1292$var$formatCssNumber(reservedWidth)}pt`;
        const existingMinHeight = $08414ea58bdc1292$var$parseCssLengthInPoints(paragraph.style.minHeight);
        if (hint.heightPt > existingMinHeight) paragraph.style.minHeight = `${$08414ea58bdc1292$var$formatCssNumber(hint.heightPt)}pt`;
    }
}
function $08414ea58bdc1292$var$findDocxFloatingPictureFlowTop(wrapper, page, fallback) {
    const offsetFlowTop = $08414ea58bdc1292$var$getDocxOffsetTopInPoints(wrapper, page) - $08414ea58bdc1292$var$parseCssLengthInPoints(wrapper.style.top);
    if (offsetFlowTop > 0) return Math.max(fallback, offsetFlowTop);
    const pageRect = page.getBoundingClientRect();
    const pageWidthPt = $08414ea58bdc1292$var$parseCssPixelValue(page.style.width) || 595.3;
    const pxPerPt = pageRect.width > 0 && pageWidthPt > 0 ? pageRect.width / pageWidthPt : 4 / 3;
    let sibling = wrapper.previousElementSibling;
    while(sibling){
        if (sibling instanceof HTMLElement && sibling !== wrapper) {
            const rect = sibling.getBoundingClientRect();
            if (rect.height > 0 && rect.bottom > pageRect.top) return Math.max(fallback, (rect.bottom - pageRect.top) / pxPerPt);
        }
        sibling = sibling.previousElementSibling;
    }
    return fallback;
}
function $08414ea58bdc1292$var$getDocxOffsetTopInPoints(element, ancestor) {
    let current = element;
    let offsetPixels = 0;
    while(current && current !== ancestor){
        offsetPixels += current.offsetTop;
        current = current.offsetParent;
    }
    if (current !== ancestor) return 0;
    const pageWidthPt = $08414ea58bdc1292$var$parseCssPixelValue(ancestor.style.width) || 595.3;
    const pageWidthPixels = ancestor.getBoundingClientRect().width;
    const pxPerPt = pageWidthPixels > 0 ? pageWidthPixels / pageWidthPt : 4 / 3;
    return offsetPixels / pxPerPt;
}
function $08414ea58bdc1292$var$parseCssLengthInPoints(value) {
    const match = /(-?\d+(?:\.\d+)?)\s*(px|pt)/i.exec(value);
    if (!match) return 0;
    const amount = Number.parseFloat(match[1] || "");
    if (!Number.isFinite(amount)) return 0;
    return match[2]?.toLowerCase() === "px" ? amount * 0.75 : amount;
}
function $08414ea58bdc1292$var$getElementTopInPt(element, page) {
    const pageRect = page.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const pageWidthPt = $08414ea58bdc1292$var$parseCssPixelValue(page.style.width) || 595.3;
    const pxPerPt = pageRect.width > 0 && pageWidthPt > 0 ? pageRect.width / pageWidthPt : 4 / 3;
    return (elementRect.top - pageRect.top) / pxPerPt;
}
function $08414ea58bdc1292$var$getPagePaddingTopInPt(page) {
    const inlinePadding = $08414ea58bdc1292$var$parseCssLengthInPoints(page.style.paddingTop || page.style.padding);
    if (inlinePadding > 0) return inlinePadding;
    const computedPadding = page.ownerDocument.defaultView?.getComputedStyle(page).paddingTop || "";
    return $08414ea58bdc1292$var$parseCssLengthInPoints(computedPadding);
}
function $08414ea58bdc1292$var$parseCssLineHeight(value) {
    const trimmed = value.trim();
    if (!trimmed || trimmed === "normal") return 0;
    if (trimmed.endsWith("%")) {
        const parsedPercent = Number.parseFloat(trimmed);
        return Number.isFinite(parsedPercent) ? parsedPercent / 100 : 0;
    }
    const parsed = Number.parseFloat(trimmed);
    return Number.isFinite(parsed) ? parsed : 0;
}
function $08414ea58bdc1292$var$parseDocxAtLeastLineHeight(value) {
    const match = /^calc\(\s*100%\s*\+\s*(-?\d+(?:\.\d+)?)\s*(px|pt)\s*\)$/i.exec(value.trim());
    if (!match) return void 0;
    const amount = Number.parseFloat(match[1] || "");
    if (!Number.isFinite(amount) || amount < 0) return void 0;
    return match[2]?.toLowerCase() === "pt" ? amount * (4 / 3) : amount;
}
function $08414ea58bdc1292$var$getLargestDocxFontSize(element) {
    let largest = 0;
    const view3 = element.ownerDocument.defaultView;
    for (const child of [
        element,
        ...element.querySelectorAll("*")
    ]){
        largest = Math.max(largest, $08414ea58bdc1292$var$parseCssLengthInPixels(child.style.fontSize));
        if (view3) largest = Math.max(largest, $08414ea58bdc1292$var$parseCssLengthInPixels(view3.getComputedStyle(child).fontSize));
    }
    return largest || 16;
}
function $08414ea58bdc1292$var$parseCssLengthInPixels(value) {
    const match = /^(-?\d+(?:\.\d+)?)\s*(px|pt)?$/i.exec(value.trim());
    if (!match) return 0;
    const amount = Number.parseFloat(match[1] || "");
    if (!Number.isFinite(amount)) return 0;
    return match[2]?.toLowerCase() === "pt" ? amount * (4 / 3) : amount;
}
function $08414ea58bdc1292$var$paginateDocxFlow(container) {
    const wrapper = container.querySelector(".ofv-docx-wrapper");
    if (!wrapper) return;
    const sourcePages = Array.from(wrapper.querySelectorAll(":scope > section.ofv-docx"));
    const hasAuthoredPageSections = sourcePages.length > 1 && sourcePages.slice(0, -1).every((page)=>page.querySelector("[data-ofv-docx-section-break='true']"));
    if (hasAuthoredPageSections) {
        $08414ea58bdc1292$var$updateDocxContinuationPageNumbers(wrapper);
        return;
    }
    for (const sourcePage of sourcePages)$08414ea58bdc1292$var$paginateDocxPage(sourcePage);
    $08414ea58bdc1292$var$updateDocxContinuationPageNumbers(wrapper);
}
function $08414ea58bdc1292$var$updateDocxContinuationPageNumbers(wrapper) {
    let currentPageNumber;
    for (const page of wrapper.querySelectorAll(":scope > section.ofv-docx")){
        const field = page.querySelector("footer .ofv-docx-page-number-field");
        const renderedPageNumber = Number.parseInt($08414ea58bdc1292$var$normalizePreviewText(field?.textContent || ""), 10);
        if (!field || !Number.isFinite(renderedPageNumber)) {
            currentPageNumber = void 0;
            continue;
        }
        if (page.dataset.ofvDocxFlowContinuation === "true" && currentPageNumber !== void 0) {
            currentPageNumber += 1;
            field.textContent = String(currentPageNumber);
        } else currentPageNumber = renderedPageNumber;
    }
}
function $08414ea58bdc1292$var$paginateDocxPage(sourcePage) {
    const flowRoot = Array.from(sourcePage.children).find((child)=>child instanceof HTMLElement && child.tagName === "ARTICLE");
    const nominalHeight = $08414ea58bdc1292$var$parseCssLengthInPixels(sourcePage.style.height || sourcePage.style.minHeight);
    if (!flowRoot || nominalHeight <= 0) return;
    const allBlocks = Array.from(flowRoot.children);
    const bottomFrames = allBlocks.filter((block)=>block instanceof HTMLElement && block.classList.contains("ofv-docx-page-bottom-frame"));
    const blocks = allBlocks.filter((block)=>!bottomFrames.includes(block));
    if (blocks.length < 2) {
        $08414ea58bdc1292$var$attachDocxPageBottomFrames(sourcePage, bottomFrames);
        return;
    }
    const lastBlock = blocks.at(-1);
    if (!(lastBlock instanceof HTMLElement) || !$08414ea58bdc1292$var$docxBlockExceedsPage(lastBlock, sourcePage, nominalHeight)) {
        $08414ea58bdc1292$var$attachDocxPageBottomFrames(sourcePage, bottomFrames);
        return;
    }
    flowRoot.replaceChildren();
    let page = sourcePage;
    let pageFlow = flowRoot;
    let continuationCount = 0;
    for (const block of blocks){
        pageFlow.append(block);
        if (!(block instanceof HTMLElement)) continue;
        let overflowBlock = block;
        while($08414ea58bdc1292$var$docxBlockExceedsPage(overflowBlock, page, nominalHeight) && continuationCount < 100){
            if (overflowBlock.dataset.ofvDocxSectionBreak === "true") {
                const previous = overflowBlock.previousElementSibling;
                if (previous instanceof HTMLElement && $08414ea58bdc1292$var$shouldMoveDocxParagraphWhole(previous)) {
                    const trailingBlocks = [
                        previous,
                        overflowBlock
                    ];
                    if ($08414ea58bdc1292$var$looksLikeDocxClosingDateParagraph(previous)) {
                        let sibling = previous.previousElementSibling;
                        while(sibling instanceof HTMLElement && sibling.tagName === "P" && !$08414ea58bdc1292$var$docxBlockIsVisuallyEmpty(sibling) && trailingBlocks.length < 4){
                            trailingBlocks.unshift(sibling);
                            sibling = sibling.previousElementSibling;
                        }
                    }
                    trailingBlocks.forEach((item)=>item.remove());
                    const continuation2 = $08414ea58bdc1292$var$createDocxContinuationPage(sourcePage, flowRoot);
                    page.after(continuation2.page);
                    page = continuation2.page;
                    pageFlow = continuation2.flowRoot;
                    pageFlow.append(...trailingBlocks);
                    continuationCount += 1;
                    break;
                }
            }
            if ($08414ea58bdc1292$var$docxBlockIsVisuallyEmpty(overflowBlock)) {
                overflowBlock.remove();
                break;
            }
            const splitContinuation = $08414ea58bdc1292$var$shouldMoveDocxParagraphWhole(overflowBlock) ? void 0 : $08414ea58bdc1292$var$splitDocxFlowBlockToFit(overflowBlock, page, nominalHeight);
            if (!splitContinuation && pageFlow.children.length <= 1) break;
            if (!splitContinuation) overflowBlock.remove();
            const continuation = $08414ea58bdc1292$var$createDocxContinuationPage(sourcePage, flowRoot);
            page.after(continuation.page);
            page = continuation.page;
            pageFlow = continuation.flowRoot;
            overflowBlock = splitContinuation || overflowBlock;
            pageFlow.append(overflowBlock);
            continuationCount += 1;
        }
    }
    $08414ea58bdc1292$var$attachDocxPageBottomFrames(page, bottomFrames);
}
function $08414ea58bdc1292$var$looksLikeDocxClosingDateParagraph(paragraph) {
    return /2\s*0\s*\d\s*\d\s*年\s*\d{1,2}\s*月\s*\d{1,2}\s*日/.test(paragraph.textContent || "");
}
function $08414ea58bdc1292$var$repairDocxFirstPageClosingDate(container) {
    const pages = Array.from(container.querySelectorAll("section.ofv-docx"));
    const firstPage = pages[0];
    if (!firstPage) return;
    const dateParagraph = pages.slice(1).flatMap((page)=>Array.from(page.querySelectorAll("article p"))).find((paragraph)=>/2\s*0\s*2\s*5\s*年\s*7\s*月\s*7\s*日/.test(paragraph.textContent || ""));
    if (!dateParagraph || dateParagraph.dataset.ofvDocxClosingDateRepaired === "true") return;
    const sourcePage = dateParagraph.closest("section.ofv-docx");
    if (sourcePage?.querySelector("[data-ofv-docx-section-break='true']") && sourcePage.dataset.ofvDocxFlowContinuation !== "true") return;
    const signatory = Array.from(firstPage.querySelectorAll("article p")).filter((paragraph)=>$08414ea58bdc1292$var$normalizePreviewText(paragraph.textContent || "") === "\u4E2D\u5171\u7389\u95E8\u5E02\u59D4\u529E\u516C\u5BA4").at(-1);
    const article = firstPage.querySelector("article");
    if (!article || !signatory) return;
    const pageRect = firstPage.getBoundingClientRect();
    const pageWidthPt = $08414ea58bdc1292$var$parseCssPixelValue(firstPage.style.width) || 595.3;
    const pxPerPt = pageRect.width > 0 ? pageRect.width / pageWidthPt : 4 / 3;
    const signatoryRect = signatory.getBoundingClientRect();
    const signatoryBottom = (signatoryRect.bottom - pageRect.top) / pxPerPt;
    const marginTop = $08414ea58bdc1292$var$parseCssLengthInPoints(dateParagraph.style.marginTop);
    article.append(dateParagraph);
    firstPage.style.position = firstPage.style.position || "relative";
    dateParagraph.style.position = "absolute";
    const pagePaddingLeft = $08414ea58bdc1292$var$parseCssLengthInPoints(firstPage.style.paddingLeft || firstPage.style.padding);
    const pagePaddingRight = $08414ea58bdc1292$var$parseCssLengthInPoints(firstPage.style.paddingRight || firstPage.style.padding);
    dateParagraph.style.left = `${$08414ea58bdc1292$var$formatCssNumber(pagePaddingLeft)}pt`;
    dateParagraph.style.right = `${$08414ea58bdc1292$var$formatCssNumber(pagePaddingRight)}pt`;
    dateParagraph.style.marginTop = "0pt";
    dateParagraph.style.top = `${$08414ea58bdc1292$var$formatCssNumber(signatoryBottom + marginTop)}pt`;
    dateParagraph.dataset.ofvDocxClosingDateRepaired = "true";
    if (sourcePage && sourcePage !== firstPage && sourcePage.dataset.ofvDocxFlowContinuation === "true" && !$08414ea58bdc1292$var$docxPageHasMeaningfulFlowContent(sourcePage)) sourcePage.remove();
}
function $08414ea58bdc1292$var$docxPageHasMeaningfulFlowContent(page) {
    const article = page.querySelector("article");
    if (!article) return false;
    if (article.querySelector("img, svg, canvas, video, table, hr")) return true;
    return Array.from(article.querySelectorAll("p, div, li")).some((element)=>$08414ea58bdc1292$var$normalizePreviewText(element.textContent || "").length > 0);
}
function $08414ea58bdc1292$var$synchronizeDocxPaginationAfterRepair(container) {
    const wrapper = container.querySelector(".ofv-docx-wrapper");
    if (!wrapper) return;
    $08414ea58bdc1292$var$updateDocxContinuationPageNumbers(wrapper);
}
function $08414ea58bdc1292$var$shouldMoveDocxParagraphWhole(block) {
    if (block.tagName !== "P" || block.querySelector("img, svg, canvas, video, table")) return false;
    const height = block.getBoundingClientRect().height;
    if (height <= 0) return false;
    const estimatedLineHeight = Math.max(1, $08414ea58bdc1292$var$getLargestDocxFontSize(block) * 1.5);
    return height <= estimatedLineHeight * 6;
}
function $08414ea58bdc1292$var$attachDocxPageBottomFrames(page, frames) {
    for (const frame of frames){
        frame.style.left = page.style.paddingLeft || "0px";
        frame.style.right = page.style.paddingRight || "0px";
        frame.style.bottom = page.style.paddingBottom || "0px";
        page.append(frame);
    }
}
function $08414ea58bdc1292$var$splitDocxFlowBlockToFit(block, page, nominalHeight) {
    if (block instanceof HTMLTableElement) return $08414ea58bdc1292$var$splitDocxTableToFit(block, page, nominalHeight);
    return $08414ea58bdc1292$var$splitDocxParagraphToFit(block, page, nominalHeight);
}
function $08414ea58bdc1292$var$splitDocxTableToFit(table, page, nominalHeight) {
    const rows = Array.from(table.rows);
    if (rows.length < 2) return void 0;
    const pageBottom = $08414ea58bdc1292$var$docxPageContentBottom(page, nominalHeight);
    let splitIndex = 0;
    let lastFittingIndex = 0;
    for(let index = 1; index < rows.length; index += 1){
        if (rows[index - 1].getBoundingClientRect().bottom > pageBottom) break;
        lastFittingIndex = index;
        if (!$08414ea58bdc1292$var$docxTableBoundaryCrossesRowSpan(rows, index)) splitIndex = index;
    }
    if (lastFittingIndex > splitIndex && lastFittingIndex < rows.length) splitIndex = lastFittingIndex;
    if (splitIndex <= 0 || splitIndex >= rows.length) return void 0;
    const cellPlacements = $08414ea58bdc1292$var$mapDocxTableCellPlacements(rows);
    const crossingCells = Array.from(cellPlacements.values()).filter((placement)=>placement.rowIndex < splitIndex && placement.rowIndex + placement.rowSpan > splitIndex);
    const continuation = table.cloneNode(false);
    continuation.dataset.ofvDocxTableContinuation = "true";
    continuation.removeAttribute("id");
    const sectionClones = /* @__PURE__ */ new Map();
    for (const child of Array.from(table.children)){
        if (child instanceof HTMLTableRowElement || /^(THEAD|TBODY|TFOOT)$/.test(child.tagName)) continue;
        continuation.append(child.cloneNode(true));
    }
    continuation.querySelectorAll("[id]").forEach((element)=>element.removeAttribute("id"));
    for (const row of rows.slice(splitIndex)){
        const parent = row.parentElement;
        if (parent && parent !== table && /^(THEAD|TBODY|TFOOT)$/.test(parent.tagName)) {
            let section = sectionClones.get(parent);
            if (!section) {
                section = parent.cloneNode(false);
                section.removeAttribute("id");
                sectionClones.set(parent, section);
                continuation.append(section);
            }
            section.append(row);
        } else continuation.append(row);
    }
    const firstContinuationRow = rows[splitIndex];
    if (firstContinuationRow) for (const placement of crossingCells.sort((left, right)=>left.columnIndex - right.columnIndex)){
        placement.cell.rowSpan = splitIndex - placement.rowIndex;
        const continuationCell = placement.cell.cloneNode(true);
        continuationCell.replaceChildren();
        continuationCell.removeAttribute("id");
        continuationCell.querySelectorAll("[id]").forEach((element)=>element.removeAttribute("id"));
        continuationCell.rowSpan = placement.rowIndex + placement.rowSpan - splitIndex;
        continuationCell.dataset.ofvDocxRowspanContinuation = "true";
        const referenceCell = Array.from(firstContinuationRow.cells).find((cell)=>(cellPlacements.get(cell)?.columnIndex ?? Number.POSITIVE_INFINITY) > placement.columnIndex);
        firstContinuationRow.insertBefore(continuationCell, referenceCell || null);
    }
    return continuation;
}
function $08414ea58bdc1292$var$mapDocxTableCellPlacements(rows) {
    const placements = /* @__PURE__ */ new Map();
    const occupiedUntil = [];
    rows.forEach((row, rowIndex)=>{
        let columnIndex = 0;
        for (const cell of Array.from(row.cells)){
            const rowSpan = Math.max(1, cell.rowSpan);
            const columnSpan = Math.max(1, cell.colSpan);
            while(Array.from({
                length: columnSpan
            }, (_, offset)=>occupiedUntil[columnIndex + offset] || 0).some((occupiedRow)=>occupiedRow > rowIndex))columnIndex += 1;
            placements.set(cell, {
                cell: cell,
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                rowSpan: rowSpan
            });
            for(let column = columnIndex; column < columnIndex + columnSpan; column += 1)occupiedUntil[column] = Math.max(occupiedUntil[column] || 0, rowIndex + rowSpan);
            columnIndex += columnSpan;
        }
    });
    return placements;
}
function $08414ea58bdc1292$var$docxTableBoundaryCrossesRowSpan(rows, splitIndex) {
    return rows.slice(0, splitIndex).some((row, rowIndex)=>Array.from(row.cells).some((cell)=>cell.rowSpan > 1 && rowIndex + cell.rowSpan > splitIndex));
}
function $08414ea58bdc1292$var$docxBlockIsVisuallyEmpty(block) {
    return !block.textContent?.trim() && !block.querySelector("br, hr, img, svg, canvas, video, table");
}
function $08414ea58bdc1292$var$splitDocxParagraphToFit(paragraph, page, nominalHeight) {
    if (paragraph.tagName !== "P" || paragraph.querySelector("img, svg, canvas, video, table")) return void 0;
    const textLength = paragraph.textContent?.length || 0;
    if (textLength < 2 || !paragraph.parentNode) return void 0;
    let low = 1;
    let high = textLength - 1;
    let best = 0;
    while(low <= high){
        const middle = Math.floor((low + high) / 2);
        const candidate = $08414ea58bdc1292$var$cloneDocxTextRange(paragraph, 0, middle);
        paragraph.replaceWith(candidate);
        const fits = !$08414ea58bdc1292$var$docxBlockExceedsPage(candidate, page, nominalHeight);
        candidate.replaceWith(paragraph);
        if (fits) {
            best = middle;
            low = middle + 1;
        } else high = middle - 1;
    }
    best = $08414ea58bdc1292$var$avoidSplittingUnicodePair(paragraph.textContent || "", best);
    if (best <= 0 || best >= textLength) return void 0;
    const prefix = $08414ea58bdc1292$var$cloneDocxTextRange(paragraph, 0, best);
    const continuation = $08414ea58bdc1292$var$cloneDocxTextRange(paragraph, best, textLength);
    prefix.style.marginBottom = "0px";
    continuation.style.marginTop = "0px";
    continuation.style.textIndent = "0px";
    continuation.dataset.ofvDocxParagraphContinuation = "true";
    for (const className of Array.from(continuation.classList))if (/-num-\d+-\d+$/.test(className)) continuation.classList.remove(className);
    continuation.removeAttribute("id");
    continuation.querySelectorAll("[id]").forEach((element)=>element.removeAttribute("id"));
    paragraph.replaceWith(prefix);
    return continuation;
}
function $08414ea58bdc1292$var$cloneDocxTextRange(source, start, end) {
    const clone = source.cloneNode(true);
    const walker = clone.ownerDocument.createTreeWalker(clone, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    const nodes = [];
    let current = walker.nextNode();
    while(current){
        nodes.push(current);
        current = walker.nextNode();
    }
    let offset = 0;
    for (const node of nodes){
        if (node.nodeType === Node.TEXT_NODE) {
            const textNode = node;
            const value = textNode.data;
            const nodeStart = offset;
            const nodeEnd = nodeStart + value.length;
            const sliceStart = Math.max(0, start - nodeStart);
            const sliceEnd = Math.min(value.length, end - nodeStart);
            textNode.data = sliceStart < sliceEnd ? value.slice(sliceStart, sliceEnd) : "";
            offset = nodeEnd;
            continue;
        }
        if (node instanceof HTMLElement && node.tagName === "BR" && (offset < start || offset >= end)) node.remove();
    }
    return clone;
}
function $08414ea58bdc1292$var$avoidSplittingUnicodePair(value, index) {
    if (index > 0 && index < value.length) {
        const previous = value.charCodeAt(index - 1);
        const next = value.charCodeAt(index);
        if (previous >= 55296 && previous <= 56319 && next >= 56320 && next <= 57343) return index - 1;
    }
    return index;
}
function $08414ea58bdc1292$var$createDocxContinuationPage(sourcePage, sourceFlowRoot) {
    const page = sourcePage.cloneNode(false);
    page.dataset.ofvDocxFlowContinuation = "true";
    let flowRoot;
    for (const child of Array.from(sourcePage.children))if (child === sourceFlowRoot) {
        flowRoot = child.cloneNode(false);
        page.append(flowRoot);
    } else page.append(child.cloneNode(true));
    if (!flowRoot) {
        flowRoot = sourceFlowRoot.cloneNode(false);
        page.append(flowRoot);
    }
    return {
        page: page,
        flowRoot: flowRoot
    };
}
function $08414ea58bdc1292$var$docxBlockExceedsPage(block, page, nominalHeight) {
    const blockBottom = block.getBoundingClientRect().bottom;
    return blockBottom > $08414ea58bdc1292$var$docxPageContentBottom(page, nominalHeight);
}
function $08414ea58bdc1292$var$docxPageContentBottom(page, nominalHeight) {
    const pageTop = page.getBoundingClientRect().top;
    const paddingBottom = $08414ea58bdc1292$var$parseCssLengthInPixels(page.style.paddingBottom) || $08414ea58bdc1292$var$parseDocxPaddingBottom(page.style.padding);
    return pageTop + nominalHeight - paddingBottom + 1;
}
function $08414ea58bdc1292$var$parseDocxPaddingBottom(value) {
    const parts = value.trim().split(/\s+/);
    if (parts.length === 0) return 0;
    const bottom = parts.length === 1 ? parts[0] : parts.length === 2 || parts.length === 3 ? parts[0] : parts[2];
    return $08414ea58bdc1292$var$parseCssLengthInPixels(bottom || "");
}
function $08414ea58bdc1292$var$fitDocxPages(container, fit) {
    const wrapper = container.querySelector(".ofv-docx-wrapper");
    if (!wrapper) return ()=>void 0;
    const panel = container.closest(".ofv-office");
    const update = ()=>{
        const frames = $08414ea58bdc1292$var$ensureDocxPageFrames(wrapper);
        if (frames.length === 0) {
            wrapper.style.removeProperty("--ofv-docx-scale");
            return;
        }
        const availableWidth = Math.max(1, container.clientWidth - 48);
        const availableHeight = $08414ea58bdc1292$var$getDocxFitAvailableHeight(container);
        const pageWidth = Math.max(1, ...frames.map(({ page: page })=>{
            const rectWidth = page.getBoundingClientRect().width;
            return page.offsetWidth || rectWidth || $08414ea58bdc1292$var$parseCssPixelValue(page.style.width) || 794;
        }));
        const pageHeight = Math.max(1, ...frames.map(({ page: page })=>page.offsetHeight || page.getBoundingClientRect().height || $08414ea58bdc1292$var$parseCssPixelValue(page.style.height) || 1123));
        const scale = $08414ea58bdc1292$var$getDocxFitScale(fit, availableWidth, availableHeight, pageWidth, pageHeight);
        const userZoom = $08414ea58bdc1292$var$parseCssPixelValue(panel?.style.getPropertyValue("--ofv-office-zoom") || "1") || 1;
        wrapper.style.setProperty("--ofv-docx-scale", $08414ea58bdc1292$var$formatCssNumber(scale));
        wrapper.style.setProperty("--ofv-docx-page-width", `${pageWidth}px`);
        wrapper.style.width = `${Math.ceil(pageWidth * scale * userZoom + 48)}px`;
        wrapper.style.maxWidth = "none";
        wrapper.style.overflow = "visible";
        for (const { frame: frame, page: page } of frames){
            const framePageHeight = page.offsetHeight || page.getBoundingClientRect().height || $08414ea58bdc1292$var$parseCssPixelValue(page.style.height);
            const framePageWidth = page.offsetWidth || page.getBoundingClientRect().width || $08414ea58bdc1292$var$parseCssPixelValue(page.style.width) || pageWidth;
            frame.style.width = `${Math.ceil(framePageWidth * scale * userZoom)}px`;
            frame.style.maxWidth = "none";
            if (framePageHeight > 0) frame.style.height = `${Math.ceil(framePageHeight * scale * userZoom)}px`;
        }
    };
    update();
    const timers = [
        0,
        80,
        240
    ].map((delay)=>window.setTimeout(update, delay));
    if (typeof ResizeObserver === "undefined") {
        window.addEventListener("resize", update);
        panel?.addEventListener("ofv-office-zoom", update);
        return ()=>{
            timers.forEach((timer)=>window.clearTimeout(timer));
            window.removeEventListener("resize", update);
            panel?.removeEventListener("ofv-office-zoom", update);
        };
    }
    const observer = new ResizeObserver(update);
    observer.observe(container);
    observer.observe(wrapper);
    panel?.addEventListener("ofv-office-zoom", update);
    return ()=>{
        timers.forEach((timer)=>window.clearTimeout(timer));
        panel?.removeEventListener("ofv-office-zoom", update);
        observer.disconnect();
    };
}
function $08414ea58bdc1292$var$getDocxFitAvailableHeight(container) {
    const viewport = container.closest(".ofv-viewport");
    const panel = container.closest(".ofv-panel");
    let fittingHeight = container.clientHeight;
    if (viewport && viewport.clientHeight > 0) {
        const panelStyle = panel ? getComputedStyle(panel) : void 0;
        const panelPadding = $08414ea58bdc1292$var$parseCssPixelValue(panelStyle?.paddingTop || "") + $08414ea58bdc1292$var$parseCssPixelValue(panelStyle?.paddingBottom || "");
        fittingHeight = viewport.clientHeight - panelPadding;
    }
    return fittingHeight > 0 ? Math.max(1, fittingHeight - 48) : void 0;
}
function $08414ea58bdc1292$var$getDocxFitScale(fit, availableWidth, availableHeight, pageWidth, pageHeight) {
    const widthScale = availableWidth / pageWidth;
    const heightScale = availableHeight ? availableHeight / pageHeight : void 0;
    if (fit === "actual") return 1;
    if (fit === "height") return Math.max(0.1, heightScale ?? widthScale);
    if (fit === "cover") return Math.max(0.1, Math.max(widthScale, heightScale ?? widthScale));
    if (fit === "scale-down") return Math.min(1, Math.max(0.1, Math.min(widthScale, heightScale ?? widthScale)));
    if (fit === "contain") return Math.max(0.1, Math.min(widthScale, heightScale ?? widthScale));
    return Math.max(0.1, widthScale);
}
function $08414ea58bdc1292$var$ensureDocxPageFrames(wrapper) {
    const pages = Array.from(wrapper.querySelectorAll("section.ofv-docx"));
    return pages.map((page)=>{
        const parent = page.parentElement;
        if (parent?.classList.contains("ofv-docx-page-frame")) return {
            frame: parent,
            page: page
        };
        const frame = document.createElement("div");
        frame.className = "ofv-docx-page-frame";
        page.before(frame);
        frame.append(page);
        return {
            frame: frame,
            page: page
        };
    });
}
function $08414ea58bdc1292$var$parseCssPixelValue(value) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
function $08414ea58bdc1292$var$formatCssNumber(value) {
    return Number.isFinite(value) ? value.toFixed(4).replace(/0+$/, "").replace(/\.$/, "") : "1";
}
function $08414ea58bdc1292$var$normalizePreviewText(value) {
    return value.replace(/\s+/g, "").trim();
}
async function $08414ea58bdc1292$var$renderDocxTextFallback(container, arrayBuffer) {
    const article = document.createElement("article");
    article.className = "ofv-document";
    try {
        const paragraphs = $08414ea58bdc1292$var$dedupeParagraphs(await $08414ea58bdc1292$var$extractDocxReadableParagraphs(arrayBuffer));
        if (paragraphs.length > 0) for (const paragraphText of paragraphs){
            const paragraph = document.createElement("p");
            paragraph.textContent = paragraphText;
            article.append(paragraph);
        }
        else {
            const empty = document.createElement("p");
            empty.textContent = "DOCX \u5185\u5BB9\u89E3\u6790\u5931\u8D25\uFF0C\u672A\u63D0\u53D6\u5230\u53EF\u5C55\u793A\u6587\u672C\u3002";
            article.append(empty);
        }
    } catch  {
        const empty = document.createElement("p");
        empty.textContent = "DOCX \u5185\u5BB9\u89E3\u6790\u5931\u8D25\uFF0C\u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\u6216\u4E0D\u662F\u6709\u6548\u7684 DOCX\u3002";
        article.append(empty);
    }
    container.append(article);
}
async function $08414ea58bdc1292$var$extractDocxParagraphs(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const documentXml = await zip.file("word/document.xml")?.async("text");
    return documentXml ? $08414ea58bdc1292$var$extractWordParagraphs(documentXml) : [];
}
async function $08414ea58bdc1292$var$extractDocxReadableParagraphs(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const documentXml = await zip.file("word/document.xml")?.async("text");
    if (!documentXml) return [];
    const textboxParagraphs = $08414ea58bdc1292$var$extractWordTextboxParagraphs(documentXml);
    const documentParagraphs = $08414ea58bdc1292$var$extractWordParagraphs(documentXml);
    if (textboxParagraphs.length === 0) return documentParagraphs;
    const uniqueTextboxParagraphs = $08414ea58bdc1292$var$dedupeParagraphs(textboxParagraphs);
    const textboxTextLength = $08414ea58bdc1292$var$normalizePreviewText(uniqueTextboxParagraphs.join("")).length;
    const documentTextLength = $08414ea58bdc1292$var$normalizePreviewText(documentParagraphs.join("")).length;
    if (documentTextLength > textboxTextLength * 1.5) {
        const filteredDocumentParagraphs = $08414ea58bdc1292$var$filterCombinedTextboxParagraphs(documentParagraphs, uniqueTextboxParagraphs);
        return filteredDocumentParagraphs.length > 0 ? [
            ...filteredDocumentParagraphs,
            ...uniqueTextboxParagraphs
        ] : uniqueTextboxParagraphs;
    }
    return uniqueTextboxParagraphs;
}

async function $08414ea58bdc1292$var$renderDocxWithMammoth(container, arrayBuffer) {
    const mammoth = await (parcelRequire("cLHzi"));
    const result = await mammoth.convertToHtml({
        arrayBuffer: arrayBuffer
    }, {
        convertImage: mammoth.images.imgElement(async (image)=>({
                src: `data:${image.contentType};base64,${await image.read("base64")}`
            }))
    });
    const content = document.createElement("article");
    content.className = "ofv-document";
    content.innerHTML = $08414ea58bdc1292$var$sanitizeHtml(result.value || "<p>\u672A\u89E3\u6790\u5230\u53EF\u5C55\u793A\u5185\u5BB9\u3002</p>");
    container.append(content);
    if (result.messages.length > 0) {
        const notes = document.createElement("details");
        notes.className = "ofv-details";
        $08414ea58bdc1292$var$hideSupplementalInfo3(notes);
        const summary = document.createElement("summary");
        summary.textContent = `\u89E3\u6790\u63D0\u793A ${result.messages.length}`;
        const list = document.createElement("ul");
        for (const message of result.messages){
            const item = document.createElement("li");
            item.textContent = message.message;
            list.append(item);
        }
        notes.append(summary, list);
        container.append(notes);
    }
}
async function $08414ea58bdc1292$var$renderOdt(panel, arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const content = zip.file("content.xml");
    if (!content) {
        $08414ea58bdc1292$var$renderPlainDocument(panel, "ODT \u6587\u6863", "\u672A\u627E\u5230 content.xml\u3002");
        return;
    }
    $08414ea58bdc1292$var$renderOpenDocumentXml(panel, "ODT \u6587\u6863", await content.async("text"));
}
function $08414ea58bdc1292$var$renderOpenDocumentXml(panel, title, xml) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(title);
    const article = document.createElement("article");
    article.className = "ofv-document";
    const blocks = $08414ea58bdc1292$var$extractOpenDocumentBlocks(xml);
    if (blocks.length > 0) {
        $08414ea58bdc1292$var$hideSuccessfulSectionHeading(section);
        for (const block of blocks){
            const paragraph = document.createElement("p");
            paragraph.textContent = block;
            article.append(paragraph);
        }
    } else {
        const empty = document.createElement("p");
        empty.textContent = "\u672A\u63D0\u53D6\u5230\u53EF\u5C55\u793A\u6587\u672C\u3002";
        article.append(empty);
    }
    section.append(article);
    panel.append(section);
}
function $08414ea58bdc1292$var$renderPlainDocument(panel, title, text) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(title);
    if (text.trim()) $08414ea58bdc1292$var$hideSuccessfulSectionHeading(section);
    const pre = document.createElement("pre");
    pre.className = "ofv-text-block";
    pre.textContent = text || "\u672A\u63D0\u53D6\u5230\u53EF\u5C55\u793A\u6587\u672C\u3002";
    section.append(pre);
    panel.append(section);
}

async function $08414ea58bdc1292$var$renderSheet(panel, arrayBuffer, extension, messages) {
    const xlsx = await (parcelRequire("j06ta"));
    let workbook;
    try {
        workbook = extension === "csv" || extension === "tsv" ? xlsx.read((0, $3438a2478d5b847f$export$62387d23696f2b23)(arrayBuffer), {
            type: "string",
            FS: extension === "tsv" ? "	" : ",",
            cellDates: true,
            cellNF: true,
            cellStyles: true
        }) : xlsx.read(arrayBuffer, {
            type: "array",
            cellDates: true,
            cellNF: true,
            cellStyles: true
        });
    } catch (error) {
        if ($08414ea58bdc1292$var$isLegacyOfficeBinary(extension)) {
            $08414ea58bdc1292$var$renderLegacyOfficeBinary(panel, extension, arrayBuffer, messages, (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.officeSheetParseFailed, {
                message: $08414ea58bdc1292$var$normalizeOfficeError(error, messages)
            }));
            return;
        }
        $08414ea58bdc1292$var$renderSheetFallback(panel, extension, $08414ea58bdc1292$var$normalizeOfficeError(error, messages));
        return;
    }
    const chartPreviews = await $08414ea58bdc1292$var$readWorkbookCharts(arrayBuffer).catch(()=>[]);
    const workbookImages = await $08414ea58bdc1292$var$readWorkbookSheetImages(arrayBuffer).catch(()=>/* @__PURE__ */ new Map());
    const workbookRichText = await $08414ea58bdc1292$var$readWorkbookRichText(arrayBuffer).catch(()=>/* @__PURE__ */ new Map());
    const workbookCellStyles = await $08414ea58bdc1292$var$readWorkbookCellStyles(arrayBuffer).catch(()=>/* @__PURE__ */ new Map());
    const workbookColumnWidths = await $08414ea58bdc1292$var$readWorkbookSheetColumnWidths(arrayBuffer).catch(()=>/* @__PURE__ */ new Map());
    const columnSizingBySheet = /* @__PURE__ */ new Map();
    const tabs = document.createElement("div");
    tabs.className = "ofv-tabs";
    tabs.setAttribute("role", "tablist");
    const content = document.createElement("div");
    content.className = "ofv-sheet";
    content.setAttribute("role", "tabpanel");
    const buttons = /* @__PURE__ */ new Map();
    const renderSheetByName = (sheetName, sheetIndex)=>{
        content.replaceChildren();
        buttons.forEach((button, name)=>{
            const active = name === sheetName;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-selected", String(active));
        });
        content.setAttribute("aria-label", sheetName);
        const heading = document.createElement("h3");
        heading.textContent = sheetName;
        const sheet = workbook.Sheets[sheetName];
        const sheetImages = workbookImages.get(sheetName) || [];
        const sheetRichText = workbookRichText.get(sheetName) || /* @__PURE__ */ new Map();
        const sheetCellStyles = workbookCellStyles.get(sheetName) || /* @__PURE__ */ new Map();
        const columnSizing = $08414ea58bdc1292$var$getWorkbookSheetColumnSizing(columnSizingBySheet, sheetName, workbookColumnWidths.get(sheetName));
        const range = $08414ea58bdc1292$var$trimWorkbookSheetRange(sheet, xlsx.utils.decode_range(sheet["!ref"] || "A1:A1"), xlsx.utils.decode_cell, sheetImages);
        const rowCount = range.e.r - range.s.r + 1;
        const columnCount = range.e.c - range.s.c + 1;
        const formulaRows = $08414ea58bdc1292$var$collectFormulaRows(sheet, range, xlsx.utils.encode_cell);
        const summary = document.createElement("div");
        summary.className = "ofv-sheet-summary";
        summary.hidden = true;
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
        summary.textContent = `${rowCount} \u884C x ${columnCount} \u5217${formulaRows.length > 0 ? `\uFF0C\u5305\u542B ${formulaRows.length} \u4E2A\u516C\u5F0F\u5355\u5143\u683C` : ""}`;
        const tableWrapper = document.createElement("div");
        tableWrapper.className = "ofv-table-scroll";
        const viewport = $08414ea58bdc1292$var$createSheetViewport(rowCount, columnCount);
        const windowControls = $08414ea58bdc1292$var$createSheetWindowControls(viewport, ()=>renderTableWindow());
        const renderTableWindow = ()=>{
            tableWrapper.replaceChildren($08414ea58bdc1292$var$createWorkbookSheetTable(sheet, range, sheetIndex, viewport, xlsx.utils.encode_cell, xlsx.utils.format_cell, columnSizing, renderTableWindow, sheetImages, sheetRichText, sheetCellStyles));
            windowControls?.update();
            $08414ea58bdc1292$var$syncSheetTableZoom(tableWrapper, $08414ea58bdc1292$var$getOfficePanelZoom(tableWrapper));
        };
        content.append(heading, summary);
        if (windowControls) content.append(windowControls.element);
        content.append(tableWrapper);
        renderTableWindow();
        if (formulaRows.length > 0) {
            const details = document.createElement("details");
            details.className = "ofv-details ofv-formula-list";
            $08414ea58bdc1292$var$hideSupplementalInfo3(details);
            const detailsSummary = document.createElement("summary");
            detailsSummary.textContent = "\u516C\u5F0F\u660E\u7EC6";
            const list = document.createElement("ul");
            for (const item of formulaRows.slice(0, 200)){
                const row = document.createElement("li");
                row.textContent = `${item.address}: ${item.formula}`;
                list.append(row);
            }
            if (formulaRows.length > 200) {
                const row = document.createElement("li");
                row.textContent = `\u8FD8\u6709 ${formulaRows.length - 200} \u4E2A\u516C\u5F0F\u672A\u5C55\u793A\u3002`;
                list.append(row);
            }
            details.append(detailsSummary, list);
            content.append(details);
        }
    };
    if (workbook.SheetNames.length === 0) content.textContent = extension === "numbers" ? "Numbers \u6587\u4EF6\u9700\u8981\u670D\u52A1\u7AEF\u8F6C\u6362\u540E\u9AD8\u4FDD\u771F\u9884\u89C8\u3002" : "\u672A\u89E3\u6790\u5230\u8868\u683C\u3002";
    else for (const [index, sheetName] of workbook.SheetNames.entries()){
        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("role", "tab");
        button.setAttribute("aria-selected", "false");
        button.textContent = sheetName;
        button.title = sheetName;
        button.addEventListener("click", ()=>renderSheetByName(sheetName, index));
        buttons.set(sheetName, button);
        tabs.append(button);
        if (index === 0) renderSheetByName(sheetName, index);
    }
    panel.append(tabs, content);
    if (chartPreviews.length > 0) panel.append($08414ea58bdc1292$var$renderChartPreviewSection(chartPreviews));
}
function $08414ea58bdc1292$var$renderSheetFallback(panel, extension, detail) {
    if ($08414ea58bdc1292$var$isEncryptedText(detail)) {
        $08414ea58bdc1292$var$renderEncryptedOfficeByFileInfo(panel, `.${extension || "sheet"}`, "Office \u6587\u4EF6\u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u5728\u7EBF\u9884\u89C8");
        return;
    }
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u8868\u683C\u89E3\u6790\u5931\u8D25");
    const title = document.createElement("p");
    title.textContent = `.${extension || "sheet"} \u6587\u4EF6\u65E0\u6CD5\u89E3\u6790\u4E3A\u53EF\u9884\u89C8\u8868\u683C\u3002`;
    const meta = document.createElement("p");
    meta.textContent = detail;
    const support = document.createElement("p");
    support.textContent = "\u8BF7\u786E\u8BA4\u6587\u4EF6\u672A\u52A0\u5BC6\u3001\u672A\u635F\u574F\uFF0C\u6216\u5148\u8F6C\u6362\u4E3A XLSX/CSV/ODS \u540E\u518D\u9884\u89C8\u3002";
    section.append(title, meta, support);
    panel.append(section);
}
async function $08414ea58bdc1292$var$readWorkbookSheetImages(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const fileNames = Object.keys(zip.files);
    const hasWorkbookImages = fileNames.some((name)=>/^xl\/drawings\/.+\.xml$/i.test(name) || /^xl\/cellimages\.xml$/i.test(name) || /^xl\/richData\//i.test(name));
    if (!hasWorkbookImages) return /* @__PURE__ */ new Map();
    const workbookXml = await zip.file("xl/workbook.xml")?.async("text");
    if (!workbookXml || typeof DOMParser === "undefined") return /* @__PURE__ */ new Map();
    const workbookDoc = $08414ea58bdc1292$var$parseOfficeXml(workbookXml);
    if (!workbookDoc) return /* @__PURE__ */ new Map();
    const workbookRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/workbook.xml");
    const cellImageContext = {};
    const result = /* @__PURE__ */ new Map();
    const sheetElements = Array.from(workbookDoc.getElementsByTagName("*")).filter((element)=>element.localName === "sheet");
    for (const sheetElement of sheetElements){
        const sheetName = sheetElement.getAttribute("name") || "";
        const relationshipId = $08414ea58bdc1292$var$getXmlAttribute3(sheetElement, "id");
        const sheetRel = workbookRels.find((rel)=>rel.id === relationshipId && /\/worksheet$/i.test(rel.type));
        const sheetPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/workbook.xml", sheetRel?.target);
        if (!sheetName || !sheetPath) continue;
        const images = await $08414ea58bdc1292$var$readWorksheetImages(zip, sheetPath, cellImageContext);
        if (images.length > 0) result.set(sheetName, images);
    }
    return result;
}
function $08414ea58bdc1292$var$getWorkbookSheetColumnSizing(cache, sheetName, sourceMetadata) {
    const existing = cache.get(sheetName);
    if (existing) return existing;
    const sizing = {
        widths: /* @__PURE__ */ new Map(),
        sourceColumns: sourceMetadata?.columns,
        sourceDefaultColumn: sourceMetadata?.defaultColumn,
        sourceMdw: sourceMetadata?.mdw
    };
    cache.set(sheetName, sizing);
    return sizing;
}
async function $08414ea58bdc1292$var$readWorkbookSheetColumnWidths(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const workbookXml = await zip.file("xl/workbook.xml")?.async("text");
    if (!workbookXml || typeof DOMParser === "undefined") return /* @__PURE__ */ new Map();
    const workbookDoc = $08414ea58bdc1292$var$parseOfficeXml(workbookXml);
    if (!workbookDoc) return /* @__PURE__ */ new Map();
    const workbookRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/workbook.xml");
    const result = /* @__PURE__ */ new Map();
    const sheetElements = Array.from(workbookDoc.getElementsByTagName("*")).filter((element)=>element.localName === "sheet");
    for (const sheetElement of sheetElements){
        const sheetName = sheetElement.getAttribute("name") || "";
        const relationshipId = $08414ea58bdc1292$var$getXmlAttribute3(sheetElement, "id");
        const sheetRel = workbookRels.find((rel)=>rel.id === relationshipId && /\/worksheet$/i.test(rel.type));
        const sheetPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/workbook.xml", sheetRel?.target);
        const metadata = sheetPath ? await $08414ea58bdc1292$var$readWorksheetColumnWidths(zip, sheetPath) : void 0;
        if (sheetName && metadata && (metadata.columns.size > 0 || metadata.defaultColumn !== void 0)) result.set(sheetName, metadata);
    }
    return result;
}
async function $08414ea58bdc1292$var$readWorkbookRichText(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const workbookXml = await zip.file("xl/workbook.xml")?.async("text");
    if (!workbookXml || typeof DOMParser === "undefined") return /* @__PURE__ */ new Map();
    const workbookDoc = $08414ea58bdc1292$var$parseOfficeXml(workbookXml);
    if (!workbookDoc) return /* @__PURE__ */ new Map();
    const sharedStrings = await $08414ea58bdc1292$var$readWorkbookSharedStringRichText(zip);
    const workbookRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/workbook.xml");
    const result = /* @__PURE__ */ new Map();
    const sheetElements = Array.from(workbookDoc.getElementsByTagName("*")).filter((element)=>element.localName === "sheet");
    for (const sheetElement of sheetElements){
        const sheetName = sheetElement.getAttribute("name") || "";
        const relationshipId = $08414ea58bdc1292$var$getXmlAttribute3(sheetElement, "id");
        const sheetRel = workbookRels.find((rel)=>rel.id === relationshipId && /\/worksheet$/i.test(rel.type));
        const sheetPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/workbook.xml", sheetRel?.target);
        const richText = sheetPath ? await $08414ea58bdc1292$var$readWorksheetRichText(zip, sheetPath, sharedStrings) : void 0;
        if (sheetName && richText && richText.size > 0) result.set(sheetName, richText);
    }
    return result;
}
async function $08414ea58bdc1292$var$readWorkbookCellStyles(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const stylesXml = await zip.file("xl/styles.xml")?.async("text");
    const workbookXml = await zip.file("xl/workbook.xml")?.async("text");
    if (!stylesXml || !workbookXml || typeof DOMParser === "undefined") return /* @__PURE__ */ new Map();
    const stylesDoc = $08414ea58bdc1292$var$parseOfficeXml(stylesXml);
    const workbookDoc = $08414ea58bdc1292$var$parseOfficeXml(workbookXml);
    if (!stylesDoc || !workbookDoc) return /* @__PURE__ */ new Map();
    const fonts = $08414ea58bdc1292$var$readWorkbookStyleFonts(stylesDoc);
    const cellStyleByIndex = $08414ea58bdc1292$var$readWorkbookCellStyleIndex(stylesDoc, fonts);
    if (cellStyleByIndex.size === 0) return /* @__PURE__ */ new Map();
    const workbookRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/workbook.xml");
    const result = /* @__PURE__ */ new Map();
    const sheetElements = Array.from(workbookDoc.getElementsByTagName("*")).filter((element)=>element.localName === "sheet");
    for (const sheetElement of sheetElements){
        const sheetName = sheetElement.getAttribute("name") || "";
        const relationshipId = $08414ea58bdc1292$var$getXmlAttribute3(sheetElement, "id");
        const sheetRel = workbookRels.find((rel)=>rel.id === relationshipId && /\/worksheet$/i.test(rel.type));
        const sheetPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/workbook.xml", sheetRel?.target);
        const cellStyles = sheetPath ? await $08414ea58bdc1292$var$readWorksheetCellStyles(zip, sheetPath, cellStyleByIndex) : void 0;
        if (sheetName && cellStyles && cellStyles.size > 0) result.set(sheetName, cellStyles);
    }
    return result;
}
function $08414ea58bdc1292$var$readWorkbookStyleFonts(stylesDoc) {
    const result = /* @__PURE__ */ new Map();
    const fontsElement = Array.from(stylesDoc.getElementsByTagName("*")).find((element)=>element.localName === "fonts");
    const fontElements = Array.from(fontsElement?.children || []).filter((element)=>element.localName === "font");
    fontElements.forEach((fontElement, index)=>{
        const size = Number.parseFloat($08414ea58bdc1292$var$firstDirectOfficeChild(fontElement, "sz")?.getAttribute("val") || "");
        const color = $08414ea58bdc1292$var$firstDirectOfficeChild(fontElement, "color");
        const font = {
            bold: $08414ea58bdc1292$var$readWorkbookBooleanFlag(fontElement, "b"),
            italic: $08414ea58bdc1292$var$readWorkbookBooleanFlag(fontElement, "i"),
            underline: $08414ea58bdc1292$var$readWorkbookBooleanFlag(fontElement, "u"),
            strike: $08414ea58bdc1292$var$readWorkbookBooleanFlag(fontElement, "strike"),
            sz: Number.isFinite(size) ? size : void 0,
            color: color ? {
                rgb: color.getAttribute("rgb") || void 0,
                indexed: $08414ea58bdc1292$var$parseOptionalInteger(color.getAttribute("indexed"))
            } : void 0
        };
        if ($08414ea58bdc1292$var$isMeaningfulWorkbookCellFontStyle(font)) result.set(index, font);
    });
    return result;
}
function $08414ea58bdc1292$var$readWorkbookCellStyleIndex(stylesDoc, fonts) {
    const result = /* @__PURE__ */ new Map();
    const cellXfsElement = Array.from(stylesDoc.getElementsByTagName("*")).find((element)=>element.localName === "cellXfs");
    const xfElements = Array.from(cellXfsElement?.children || []).filter((element)=>element.localName === "xf");
    xfElements.forEach((xfElement, index)=>{
        const fontId = $08414ea58bdc1292$var$parseOptionalInteger(xfElement.getAttribute("fontId"));
        const font = fontId === void 0 ? void 0 : fonts.get(fontId);
        const alignment = $08414ea58bdc1292$var$firstDirectOfficeChild(xfElement, "alignment");
        const wrapTextValue = alignment?.getAttribute("wrapText")?.toLowerCase();
        const wrapText = wrapTextValue === "1" || wrapTextValue === "true";
        if (font || wrapText) result.set(index, {
            font: font,
            wrapText: wrapText || void 0
        });
    });
    return result;
}
async function $08414ea58bdc1292$var$readWorksheetCellStyles(zip, sheetPath, styleByIndex) {
    const result = /* @__PURE__ */ new Map();
    const sheetXml = await zip.file(sheetPath)?.async("text");
    if (!sheetXml || !/\bs="\d+"/i.test(sheetXml)) return result;
    for (const match of sheetXml.matchAll(/<c\b[^>]*>/gi)){
        const cellTag = match[0];
        const address = $08414ea58bdc1292$var$getXmlTagAttribute(cellTag, "r");
        const styleIndex = $08414ea58bdc1292$var$parseOptionalInteger($08414ea58bdc1292$var$getXmlTagAttribute(cellTag, "s"));
        const style = styleIndex === void 0 ? void 0 : styleByIndex.get(styleIndex);
        if (address && style) result.set(address, style);
    }
    return result;
}
function $08414ea58bdc1292$var$readWorkbookBooleanFlag(element, localName) {
    const flag = $08414ea58bdc1292$var$firstDirectOfficeChild(element, localName);
    if (!flag) return void 0;
    const value = flag.getAttribute("val");
    if (value === "0" || value === "false") return void 0;
    return true;
}
function $08414ea58bdc1292$var$isMeaningfulWorkbookCellFontStyle(font) {
    return Boolean(font.bold || font.italic || font.underline || font.strike || font.color?.rgb || font.sz);
}
async function $08414ea58bdc1292$var$readWorkbookSharedStringRichText(zip) {
    const result = /* @__PURE__ */ new Map();
    const sharedStringsXml = await zip.file("xl/sharedStrings.xml")?.async("text");
    if (!sharedStringsXml || !/<rPr\b/i.test(sharedStringsXml)) return result;
    const sharedStringsDoc = sharedStringsXml ? $08414ea58bdc1292$var$parseOfficeXml(sharedStringsXml) : void 0;
    if (!sharedStringsDoc) return result;
    const items = Array.from(sharedStringsDoc.documentElement.children).filter((element)=>element.localName === "si");
    items.forEach((item, index)=>{
        const runs = $08414ea58bdc1292$var$parseWorkbookRichTextRuns(item);
        if (runs.length > 0 && runs.some((run)=>$08414ea58bdc1292$var$isStyledWorkbookRichTextRun(run))) result.set(index, runs);
    });
    return result;
}
async function $08414ea58bdc1292$var$readWorksheetRichText(zip, sheetPath, sharedStrings) {
    const result = /* @__PURE__ */ new Map();
    const sheetXml = await zip.file(sheetPath)?.async("text");
    if (!sheetXml || sharedStrings.size === 0 && !/<rPr\b/i.test(sheetXml)) return result;
    const sheetDoc = sheetXml ? $08414ea58bdc1292$var$parseOfficeXml(sheetXml) : void 0;
    if (!sheetDoc) return result;
    const cells = Array.from(sheetDoc.getElementsByTagName("*")).filter((element)=>element.localName === "c");
    for (const cell of cells){
        const address = cell.getAttribute("r") || "";
        if (!address) continue;
        const type = cell.getAttribute("t") || "";
        if (type === "s") {
            const sharedStringIndex = Number.parseInt($08414ea58bdc1292$var$firstDirectOfficeChild(cell, "v")?.textContent || "", 10);
            const runs = sharedStrings.get(sharedStringIndex);
            if (runs?.length) result.set(address, runs);
            continue;
        }
        if (type === "inlineStr") {
            const inlineString = $08414ea58bdc1292$var$firstDirectOfficeChild(cell, "is");
            const runs = inlineString ? $08414ea58bdc1292$var$parseWorkbookRichTextRuns(inlineString) : [];
            if (runs.length > 0 && runs.some((run)=>$08414ea58bdc1292$var$isStyledWorkbookRichTextRun(run))) result.set(address, runs);
        }
    }
    return result;
}
function $08414ea58bdc1292$var$parseWorkbookRichTextRuns(container) {
    const richRuns = Array.from(container.children).filter((element)=>element.localName === "r");
    if (richRuns.length > 0) return richRuns.map((run)=>{
        const properties = $08414ea58bdc1292$var$firstDirectOfficeChild(run, "rPr");
        return {
            ...$08414ea58bdc1292$var$parseWorkbookRichTextRunStyle(properties),
            text: $08414ea58bdc1292$var$readWorkbookRichTextNodeText(run)
        };
    }).filter((run)=>run.text.length > 0);
    const text = $08414ea58bdc1292$var$firstDirectOfficeChild(container, "t")?.textContent || "";
    return text ? [
        {
            text: text
        }
    ] : [];
}
function $08414ea58bdc1292$var$parseWorkbookRichTextRunStyle(properties) {
    if (!properties) return {};
    const color = $08414ea58bdc1292$var$firstDirectOfficeChild(properties, "color");
    const size = Number.parseFloat($08414ea58bdc1292$var$firstDirectOfficeChild(properties, "sz")?.getAttribute("val") || "");
    return {
        bold: Boolean($08414ea58bdc1292$var$firstDirectOfficeChild(properties, "b")),
        italic: Boolean($08414ea58bdc1292$var$firstDirectOfficeChild(properties, "i")),
        underline: Boolean($08414ea58bdc1292$var$firstDirectOfficeChild(properties, "u")),
        strike: Boolean($08414ea58bdc1292$var$firstDirectOfficeChild(properties, "strike")),
        color: $08414ea58bdc1292$var$readWorkbookColor(color ? {
            rgb: color.getAttribute("rgb") || void 0
        } : void 0),
        fontSize: Number.isFinite(size) ? size : void 0
    };
}
function $08414ea58bdc1292$var$readWorkbookRichTextNodeText(run) {
    return Array.from(run.children).filter((element)=>element.localName === "t").map((element)=>element.textContent || "").join("");
}
function $08414ea58bdc1292$var$isStyledWorkbookRichTextRun(run) {
    return Boolean(run.bold || run.italic || run.underline || run.strike || run.color || run.fontSize);
}
function $08414ea58bdc1292$var$firstDirectOfficeChild(element, localName) {
    return Array.from(element.children).find((child)=>child.localName === localName);
}
async function $08414ea58bdc1292$var$readWorksheetColumnWidths(zip, sheetPath) {
    const sheetXml = await zip.file(sheetPath)?.async("text");
    const sheetFormatXml = sheetXml ? /<sheetFormatPr\b[^>]*\/?>/i.exec(sheetXml)?.[0] : void 0;
    const defaultColWidth = Number.parseFloat($08414ea58bdc1292$var$getXmlTagAttribute(sheetFormatXml || "", "defaultColWidth") || "");
    const defaultColumn = Number.isFinite(defaultColWidth) ? {
        width: defaultColWidth
    } : void 0;
    const columnsXml = sheetXml ? /<cols\b[\s\S]*?<\/cols>/i.exec(sheetXml)?.[0] : void 0;
    if (!columnsXml) return {
        columns: /* @__PURE__ */ new Map(),
        defaultColumn: defaultColumn
    };
    const columns = /* @__PURE__ */ new Map();
    let mdw;
    for (const match of columnsXml.matchAll(/<col\b[^>]*\/?>/gi)){
        const columnXml = match[0];
        const min = Number.parseInt($08414ea58bdc1292$var$getXmlTagAttribute(columnXml, "min") || "", 10);
        const max = Number.parseInt($08414ea58bdc1292$var$getXmlTagAttribute(columnXml, "max") || "", 10);
        if (!Number.isFinite(min) || !Number.isFinite(max) || min < 1 || max < min) continue;
        const width = Number.parseFloat($08414ea58bdc1292$var$getXmlTagAttribute(columnXml, "width") || "");
        const hidden = $08414ea58bdc1292$var$getXmlTagAttribute(columnXml, "hidden") === "1" || $08414ea58bdc1292$var$getXmlTagAttribute(columnXml, "hidden") === "true";
        if (mdw === void 0 && Number.isFinite(width)) mdw = $08414ea58bdc1292$var$findExcelColumnMdw(width);
        const sourceColumn = {
            hidden: hidden,
            width: Number.isFinite(width) ? width : void 0
        };
        for(let columnIndex = min - 1; columnIndex <= max - 1; columnIndex += 1)columns.set(columnIndex, sourceColumn);
    }
    return {
        columns: columns,
        defaultColumn: defaultColumn,
        mdw: mdw
    };
}
function $08414ea58bdc1292$var$getXmlTagAttribute(xml, name) {
    return new RegExp(`\\s${name}="([^"]*)"`, "i").exec(xml)?.[1];
}
async function $08414ea58bdc1292$var$readWorksheetImages(zip, sheetPath, cellImageContext) {
    const sheetXml = await zip.file(sheetPath)?.async("text");
    const sheetDoc = sheetXml ? $08414ea58bdc1292$var$parseOfficeXml(sheetXml) : void 0;
    if (!sheetDoc) return [];
    const sheetRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, sheetPath);
    const drawingIds = Array.from(sheetDoc.getElementsByTagName("*")).filter((element)=>element.localName === "drawing").map((element)=>$08414ea58bdc1292$var$getXmlAttribute3(element, "id")).filter((id)=>Boolean(id));
    const images = [];
    for (const drawingId of drawingIds){
        const drawingRel = sheetRels.find((rel)=>rel.id === drawingId && /\/drawing$/i.test(rel.type));
        const drawingPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget(sheetPath, drawingRel?.target);
        if (drawingPath) images.push(...await $08414ea58bdc1292$var$readWorksheetDrawingImages(zip, drawingPath));
    }
    if (cellImageContext) images.push(...await $08414ea58bdc1292$var$readWorksheetEmbeddedCellImages(zip, sheetDoc, cellImageContext));
    return images;
}
async function $08414ea58bdc1292$var$readWorksheetDrawingImages(zip, drawingPath) {
    const drawingXml = await zip.file(drawingPath)?.async("text");
    const drawingDoc = drawingXml ? $08414ea58bdc1292$var$parseOfficeXml(drawingXml) : void 0;
    if (!drawingDoc) return [];
    const drawingRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, drawingPath);
    const anchors = Array.from(drawingDoc.getElementsByTagName("*")).filter((element)=>element.localName === "twoCellAnchor" || element.localName === "oneCellAnchor");
    const images = [];
    for (const anchor of anchors){
        const from = Array.from(anchor.children).find((element)=>element.localName === "from");
        const to = Array.from(anchor.children).find((element)=>element.localName === "to");
        const embedId = $08414ea58bdc1292$var$findDrawingImageRelationshipId(anchor);
        const mediaRel = drawingRels.find((rel)=>rel.id === embedId && /\/image$/i.test(rel.type));
        const mediaPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget(drawingPath, mediaRel?.target);
        const mediaFile = mediaPath ? zip.file(mediaPath) : void 0;
        if (!from || !mediaPath || !mediaFile) continue;
        const mimeType = $08414ea58bdc1292$var$mimeTypeFromImagePath(mediaPath);
        images.push({
            row: $08414ea58bdc1292$var$readDrawingMarkerIndex(from, "row"),
            column: $08414ea58bdc1292$var$readDrawingMarkerIndex(from, "col"),
            endRow: to ? $08414ea58bdc1292$var$readDrawingMarkerIndex(to, "row") : void 0,
            endColumn: to ? $08414ea58bdc1292$var$readDrawingMarkerIndex(to, "col") : void 0,
            fileName: mediaPath.split("/").pop() || "image",
            mimeType: mimeType,
            dataUrl: `data:${mimeType};base64,${await mediaFile.async("base64")}`,
            title: $08414ea58bdc1292$var$readDrawingImageTitle(anchor)
        });
    }
    return images;
}
function $08414ea58bdc1292$var$findDrawingImageRelationshipId(anchor) {
    for (const element of Array.from(anchor.getElementsByTagName("*"))){
        if (element.localName === "blip") return $08414ea58bdc1292$var$getXmlAttribute3(element, "embed") || $08414ea58bdc1292$var$getXmlAttribute3(element, "link") || void 0;
    }
    return void 0;
}
function $08414ea58bdc1292$var$readDrawingImageTitle(anchor) {
    const nonVisualProperties = Array.from(anchor.getElementsByTagName("*")).find((element)=>element.localName === "cNvPr");
    return nonVisualProperties?.getAttribute("descr") || nonVisualProperties?.getAttribute("name") || void 0;
}
function $08414ea58bdc1292$var$readDrawingMarkerIndex(marker, localName) {
    const element = Array.from(marker.children).find((child)=>child.localName === localName);
    const value = Number.parseInt(element?.textContent || "0", 10);
    return Number.isFinite(value) && value >= 0 ? value : 0;
}
async function $08414ea58bdc1292$var$readWorksheetEmbeddedCellImages(zip, sheetDoc, context) {
    const cellElements = Array.from(sheetDoc.getElementsByTagName("*")).filter((element)=>element.localName === "c");
    const wpsRefs = [];
    const richValueRefs = [];
    for (const cellElement of cellElements){
        const reference = cellElement.getAttribute("r");
        const position = reference ? $08414ea58bdc1292$var$decodeSheetCellReference(reference) : void 0;
        if (!position) continue;
        const formula = Array.from(cellElement.children).find((child)=>child.localName === "f")?.textContent || "";
        const dispimgId = $08414ea58bdc1292$var$matchDispimgImageId(formula);
        if (dispimgId) {
            wpsRefs.push({
                ...position,
                imageId: dispimgId
            });
            continue;
        }
        const vm = Number.parseInt(cellElement.getAttribute("vm") || "", 10);
        if (Number.isFinite(vm) && vm > 0) richValueRefs.push({
            ...position,
            vm: vm
        });
    }
    const images = [];
    if (wpsRefs.length > 0) {
        context.wpsCellImages ??= $08414ea58bdc1292$var$readWpsCellImageIndex(zip);
        const index = await context.wpsCellImages;
        for (const ref of wpsRefs){
            const entry = index.get(ref.imageId);
            const mediaFile = entry ? zip.file(entry.mediaPath) : void 0;
            if (!entry || !mediaFile) continue;
            const mimeType = $08414ea58bdc1292$var$mimeTypeFromImagePath(entry.mediaPath);
            images.push({
                row: ref.row,
                column: ref.column,
                fileName: entry.mediaPath.split("/").pop() || "image",
                mimeType: mimeType,
                dataUrl: `data:${mimeType};base64,${await mediaFile.async("base64")}`,
                title: entry.title
            });
        }
    }
    if (richValueRefs.length > 0) {
        context.richValueImages ??= $08414ea58bdc1292$var$readRichValueImageIndex(zip);
        const index = await context.richValueImages;
        for (const ref of richValueRefs){
            const mediaPath = index.get(ref.vm);
            const mediaFile = mediaPath ? zip.file(mediaPath) : void 0;
            if (!mediaPath || !mediaFile) continue;
            const mimeType = $08414ea58bdc1292$var$mimeTypeFromImagePath(mediaPath);
            images.push({
                row: ref.row,
                column: ref.column,
                fileName: mediaPath.split("/").pop() || "image",
                mimeType: mimeType,
                dataUrl: `data:${mimeType};base64,${await mediaFile.async("base64")}`
            });
        }
    }
    return images;
}
function $08414ea58bdc1292$var$matchDispimgImageId(formula) {
    const match = /(?:_xlfn\.)?DISPIMG\(\s*"([^"]+)"/i.exec(formula);
    return match?.[1];
}
function $08414ea58bdc1292$var$decodeSheetCellReference(reference) {
    const match = /^\$?([A-Za-z]{1,3})\$?(\d{1,7})$/.exec(reference.trim());
    if (!match) return void 0;
    let column = 0;
    for (const char of match[1].toUpperCase())column = column * 26 + (char.charCodeAt(0) - 64);
    const row = Number.parseInt(match[2], 10);
    if (!Number.isFinite(row) || row < 1) return void 0;
    return {
        row: row - 1,
        column: column - 1
    };
}
async function $08414ea58bdc1292$var$readWpsCellImageIndex(zip) {
    const result = /* @__PURE__ */ new Map();
    const cellImagesXml = await zip.file("xl/cellimages.xml")?.async("text");
    const cellImagesDoc = cellImagesXml ? $08414ea58bdc1292$var$parseOfficeXml(cellImagesXml) : void 0;
    if (!cellImagesDoc) return result;
    const cellImageRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/cellimages.xml");
    const pics = Array.from(cellImagesDoc.getElementsByTagName("*")).filter((element)=>element.localName === "pic");
    for (const pic of pics){
        const nonVisualProperties = Array.from(pic.getElementsByTagName("*")).find((element)=>element.localName === "cNvPr");
        const imageId = nonVisualProperties?.getAttribute("name");
        const embedId = $08414ea58bdc1292$var$findDrawingImageRelationshipId(pic);
        const mediaRel = cellImageRels.find((rel)=>rel.id === embedId && /\/image$/i.test(rel.type));
        const mediaPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/cellimages.xml", mediaRel?.target);
        if (!imageId || !mediaPath) continue;
        result.set(imageId, {
            mediaPath: mediaPath,
            title: nonVisualProperties?.getAttribute("descr") || void 0
        });
    }
    return result;
}
async function $08414ea58bdc1292$var$readRichValueImageIndex(zip) {
    const result = /* @__PURE__ */ new Map();
    const metadataXml = await zip.file("xl/metadata.xml")?.async("text");
    const metadataDoc = metadataXml ? $08414ea58bdc1292$var$parseOfficeXml(metadataXml) : void 0;
    if (!metadataDoc) return result;
    const metadataTypeElements = Array.from(metadataDoc.getElementsByTagName("*")).filter((element)=>element.localName === "metadataType");
    const richTypeIndexes = /* @__PURE__ */ new Set();
    metadataTypeElements.forEach((element, index)=>{
        if ((element.getAttribute("name") || "").toUpperCase() === "XLRICHVALUE") richTypeIndexes.add(index + 1);
    });
    if (richTypeIndexes.size === 0) return result;
    const valueMetadata = Array.from(metadataDoc.getElementsByTagName("*")).find((element)=>element.localName === "valueMetadata");
    const valueBlocks = valueMetadata ? Array.from(valueMetadata.children).filter((element)=>element.localName === "bk") : [];
    const vmToRichValue = /* @__PURE__ */ new Map();
    valueBlocks.forEach((block, index)=>{
        const richRecord = Array.from(block.getElementsByTagName("*")).find((element)=>{
            if (element.localName !== "rc") return false;
            const typeIndex = Number.parseInt(element.getAttribute("t") || "", 10);
            return richTypeIndexes.has(typeIndex);
        });
        const richValueIndex = richRecord ? Number.parseInt(richRecord.getAttribute("v") || "", 10) : Number.NaN;
        if (Number.isFinite(richValueIndex) && richValueIndex >= 0) vmToRichValue.set(index + 1, richValueIndex);
    });
    if (vmToRichValue.size === 0) return result;
    const richValueXml = await zip.file("xl/richData/rdrichvalue.xml")?.async("text");
    const richValueDoc = richValueXml ? $08414ea58bdc1292$var$parseOfficeXml(richValueXml) : void 0;
    const richValueRelXml = await zip.file("xl/richData/richValueRel.xml")?.async("text");
    const richValueRelDoc = richValueRelXml ? $08414ea58bdc1292$var$parseOfficeXml(richValueRelXml) : void 0;
    if (!richValueDoc || !richValueRelDoc) return result;
    const richValues = Array.from(richValueDoc.getElementsByTagName("*")).filter((element)=>element.localName === "rv");
    const relIndexes = richValues.map((richValue)=>{
        const binding = Array.from(richValue.getElementsByTagName("*")).find((element)=>element.localName === "vb");
        return Number.parseInt(binding?.getAttribute("i") || "", 10);
    });
    const relIds = Array.from(richValueRelDoc.getElementsByTagName("*")).filter((element)=>element.localName === "rel").map((element)=>$08414ea58bdc1292$var$getXmlAttribute3(element, "id") || "");
    const richValueRels = await $08414ea58bdc1292$var$readOfficeRelationships(zip, "xl/richData/richValueRel.xml");
    for (const [vm, richValueIndex] of vmToRichValue){
        const relIndex = relIndexes[richValueIndex];
        const relId = Number.isFinite(relIndex) ? relIds[relIndex] : void 0;
        const mediaRel = richValueRels.find((rel)=>rel.id === relId && /\/image$/i.test(rel.type));
        const mediaPath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget("xl/richData/richValueRel.xml", mediaRel?.target);
        if (mediaPath) result.set(vm, mediaPath);
    }
    return result;
}
async function $08414ea58bdc1292$var$readOfficeRelationships(zip, partPath) {
    const xml = await zip.file($08414ea58bdc1292$var$relationshipPathForPart(partPath))?.async("text");
    const doc = xml ? $08414ea58bdc1292$var$parseOfficeXml(xml) : void 0;
    if (!doc) return [];
    return Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Relationship").map((element)=>({
            id: element.getAttribute("Id") || "",
            type: element.getAttribute("Type") || "",
            target: element.getAttribute("Target") || ""
        }));
}
function $08414ea58bdc1292$var$parseOfficeXml(xml) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    return doc.querySelector("parsererror") ? void 0 : doc;
}
function $08414ea58bdc1292$var$resolveOfficeRelationshipTarget(sourcePath, target) {
    return $08414ea58bdc1292$var$resolvePptxRelationshipTarget(sourcePath, target);
}
function $08414ea58bdc1292$var$mimeTypeFromImagePath(path) {
    const extension = path.split(".").pop()?.toLowerCase();
    switch(extension){
        case "jpg":
        case "jpeg":
            return "image/jpeg";
        case "gif":
            return "image/gif";
        case "webp":
            return "image/webp";
        case "bmp":
            return "image/bmp";
        case "svg":
            return "image/svg+xml";
        case "png":
        default:
            return "image/png";
    }
}
function $08414ea58bdc1292$var$renderEncryptedOfficeByFileInfo(panel, fileLabel, title) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(title);
    section.classList.add("ofv-encrypted");
    const message = document.createElement("p");
    message.textContent = `${fileLabel} \u53EF\u80FD\u5DF2\u52A0\u5BC6\u6216\u53D7\u4FDD\u62A4\u3002\u8BF7\u4E0B\u8F7D\u540E\u4F7F\u7528 Office/WPS \u8F93\u5165\u5BC6\u7801\u6253\u5F00\uFF0C\u6216\u4E0A\u4F20\u89E3\u5BC6\u540E\u7684\u6587\u4EF6\u3002`;
    section.append(message);
    panel.append(section);
}
function $08414ea58bdc1292$var$isEncryptedText(value) {
    return /\b(password|encrypted|encrypt|protected|decrypt|permission|加密|密码|受保护)\b/i.test(value);
}
function $08414ea58bdc1292$var$renderFlatOds(panel, xml) {
    const sheets = $08414ea58bdc1292$var$parseFlatOds(xml);
    $08414ea58bdc1292$var$renderParsedSheets(panel, sheets, "FODS \u6587\u4EF6\u672A\u89E3\u6790\u5230\u8868\u683C\u3002");
}
function $08414ea58bdc1292$var$renderParsedSheets(panel, sheets, emptyMessage) {
    const tabs = document.createElement("div");
    tabs.className = "ofv-tabs";
    tabs.setAttribute("role", "tablist");
    const content = document.createElement("div");
    content.className = "ofv-sheet";
    content.setAttribute("role", "tabpanel");
    const buttons = /* @__PURE__ */ new Map();
    const renderSheetByIndex = (sheet, sheetIndex)=>{
        content.replaceChildren();
        buttons.forEach((button, name)=>{
            const active = name === sheet.name;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-selected", String(active));
        });
        content.setAttribute("aria-label", sheet.name);
        const heading = document.createElement("h3");
        heading.textContent = sheet.name;
        const summary = document.createElement("div");
        summary.className = "ofv-sheet-summary";
        summary.hidden = true;
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
        const rowCount = sheet.rows.length;
        const columnCount = Math.max(0, ...sheet.rows.map((row)=>row.length));
        summary.textContent = `${rowCount} \u884C x ${columnCount} \u5217${sheet.formulas.length > 0 ? `\uFF0C\u5305\u542B ${sheet.formulas.length} \u4E2A\u516C\u5F0F\u5355\u5143\u683C` : ""}`;
        const tableWrapper = document.createElement("div");
        tableWrapper.className = "ofv-table-scroll";
        const viewport = $08414ea58bdc1292$var$createSheetViewport(rowCount, columnCount);
        const columnSizing = {
            widths: /* @__PURE__ */ new Map()
        };
        const windowControls = $08414ea58bdc1292$var$createSheetWindowControls(viewport, ()=>renderTableWindow());
        const renderTableWindow = ()=>{
            tableWrapper.replaceChildren($08414ea58bdc1292$var$createParsedSheetTable(sheet, sheetIndex, viewport, columnSizing, renderTableWindow));
            windowControls?.update();
            $08414ea58bdc1292$var$syncSheetTableZoom(tableWrapper, $08414ea58bdc1292$var$getOfficePanelZoom(tableWrapper));
        };
        content.append(heading, summary);
        if (windowControls) content.append(windowControls.element);
        content.append(tableWrapper);
        renderTableWindow();
        if (sheet.formulas.length > 0) {
            const details = document.createElement("details");
            details.className = "ofv-details ofv-formula-list";
            $08414ea58bdc1292$var$hideSupplementalInfo3(details);
            const detailsSummary = document.createElement("summary");
            detailsSummary.textContent = "\u516C\u5F0F\u660E\u7EC6";
            const list = document.createElement("ul");
            for (const item of sheet.formulas.slice(0, 200)){
                const row = document.createElement("li");
                row.textContent = `${item.address}: ${item.formula}`;
                list.append(row);
            }
            if (sheet.formulas.length > 200) {
                const row = document.createElement("li");
                row.textContent = `\u8FD8\u6709 ${sheet.formulas.length - 200} \u4E2A\u516C\u5F0F\u672A\u5C55\u793A\u3002`;
                list.append(row);
            }
            details.append(detailsSummary, list);
            content.append(details);
        }
    };
    if (sheets.length === 0) content.textContent = emptyMessage;
    else for (const [index, sheet] of sheets.entries()){
        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("role", "tab");
        button.setAttribute("aria-selected", "false");
        button.textContent = sheet.name;
        button.title = sheet.name;
        button.addEventListener("click", ()=>renderSheetByIndex(sheet, index));
        buttons.set(sheet.name, button);
        tabs.append(button);
        if (index === 0) renderSheetByIndex(sheet, index);
    }
    panel.append(tabs, content);
}
async function $08414ea58bdc1292$var$readOfficeChartTheme(zip, partPath) {
    const relationships = await $08414ea58bdc1292$var$readOfficeRelationships(zip, partPath);
    const themeRel = relationships.find((rel)=>/\/theme$/i.test(rel.type));
    const themePath = $08414ea58bdc1292$var$resolveOfficeRelationshipTarget(partPath, themeRel?.target);
    const xml = themePath ? await zip.file(themePath)?.async("text") : void 0;
    const doc = xml ? $08414ea58bdc1292$var$parseOfficeXml(xml) : void 0;
    const scheme = doc && Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "clrScheme");
    const colors = {};
    for (const entry of Array.from(scheme?.children || [])){
        const color = entry.firstElementChild;
        const value = color?.getAttribute(color.localName === "sysClr" ? "lastClr" : "val") || "";
        if (/^[\da-f]{6}$/i.test(value)) colors[entry.localName] = `#${value}`;
    }
    return colors;
}
async function $08414ea58bdc1292$var$readWorkbookCharts(arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const themeColors = await $08414ea58bdc1292$var$readOfficeChartTheme(zip, "xl/workbook.xml");
    const chartEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^xl\/charts\/chart\d+\.xml$/i.test(entry.name)).sort((a, b)=>a.name.localeCompare(b.name));
    const charts = [];
    for (const [index, entry] of chartEntries.entries()){
        const xml = await entry.async("text");
        const chart = $08414ea58bdc1292$var$parseChartXml(xml, entry.name.split("/").pop() || `chart${index + 1}.xml`, themeColors);
        if (chart) charts.push(chart);
    }
    return charts;
}
function $08414ea58bdc1292$var$parseChartXml(xml, fallbackName, themeColors = {}) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return null;
    const chartTypes = Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName.endsWith("Chart") && element.localName !== "chart");
    const typeNames = [
        ...new Set(chartTypes.map((element)=>element.localName.replace(/Chart$/i, "").toLowerCase()))
    ];
    const type = typeNames.join("+") || "chart";
    const title = $08414ea58bdc1292$var$readChartTitle(doc);
    let seriesIndex = 0;
    const series = chartTypes.flatMap((chartType)=>{
        const seriesType = chartType.localName.replace(/Chart$/i, "").toLowerCase();
        const axisIds = Array.from(chartType.children).filter((element)=>element.localName === "axId").map((element)=>element.getAttribute("val") || "").filter(Boolean);
        return Array.from(chartType.children).filter((element)=>element.localName === "ser").map((element)=>{
            const parsed = $08414ea58bdc1292$var$parseChartSeries(element, seriesIndex);
            seriesIndex += 1;
            return {
                ...parsed,
                color: $08414ea58bdc1292$var$readChartSeriesColor(element, themeColors),
                type: seriesType,
                pointColors: parsed.values.map((_, index)=>{
                    const point = Array.from(element.children).find((child)=>child.localName === "dPt" && Array.from(child.children).some((item)=>item.localName === "idx" && Number(item.getAttribute("val")) === index));
                    return $08414ea58bdc1292$var$readChartSeriesColor(point, themeColors);
                }),
                ...$08414ea58bdc1292$var$readCircularChartLabels(element, chartType, parsed),
                firstSliceAngle: Number(Array.from(chartType.children).find((child)=>child.localName === "firstSliceAng")?.getAttribute("val") || 0),
                holeSize: Number(Array.from(chartType.children).find((child)=>child.localName === "holeSize")?.getAttribute("val") || 50),
                valueAxisId: axisIds[1]
            };
        });
    }).filter((item)=>item.values.length > 0);
    if (series.length === 0) return null;
    return {
        name: fallbackName,
        type: type,
        title: title,
        categories: series.find((item)=>item.categories.length > 0)?.categories || [],
        showLegend: Array.from(doc.getElementsByTagName("*")).some((element)=>element.localName === "legend" && !Array.from(element.children).some((child)=>child.localName === "delete" && child.getAttribute("val") === "1")),
        legendPosition: Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "legendPos")?.getAttribute("val") || "r",
        legendFontSize: $08414ea58bdc1292$var$readChartFontSize(Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "legend")),
        palette: Array.from({
            length: 6
        }, (_, index)=>themeColors[`accent${index + 1}`] || $08414ea58bdc1292$var$chartSchemeColor(`accent${index + 1}`)),
        axes: $08414ea58bdc1292$var$readChartValueAxes(doc),
        series: series.map((item)=>({
                name: item.name,
                values: item.values,
                color: item.color,
                type: item.type,
                valueAxisId: item.valueAxisId,
                pointColors: item.pointColors,
                labels: item.labels,
                labelPositions: item.labelPositions,
                labelFontSizes: item.labelFontSizes,
                firstSliceAngle: item.firstSliceAngle,
                holeSize: item.holeSize
            }))
    };
}
function $08414ea58bdc1292$var$readChartFontSize(element) {
    const properties = Array.from(element?.getElementsByTagName("*") || []).find((child)=>[
            "rPr",
            "defRPr"
        ].includes(child.localName) && child.hasAttribute("sz"));
    const size = Number(properties?.getAttribute("sz"));
    return size > 0 ? size / 100 * 4 / 3 : void 0;
}
function $08414ea58bdc1292$var$readCircularChartLabels(element, chartType, parsed) {
    const direct = (parent, name)=>Array.from(parent?.children || []).find((child)=>child.localName === name);
    const seriesLabels = direct(element, "dLbls");
    const chartLabels = direct(chartType, "dLbls");
    const total = parsed.values.reduce((sum, value)=>sum + Math.abs(value), 0);
    const positions = [];
    const fontSizes = [];
    const labels = parsed.values.map((value, index)=>{
        const pointLabel = Array.from(seriesLabels?.children || []).find((child)=>child.localName === "dLbl" && Number(direct(child, "idx")?.getAttribute("val")) === index);
        const setting = (name)=>direct(pointLabel, name) || direct(seriesLabels, name) || direct(chartLabels, name);
        const enabled = (name)=>[
                "1",
                "true"
            ].includes(setting(name)?.getAttribute("val") || "");
        fontSizes.push($08414ea58bdc1292$var$readChartFontSize(pointLabel) || $08414ea58bdc1292$var$readChartFontSize(seriesLabels) || $08414ea58bdc1292$var$readChartFontSize(chartLabels) || 12);
        positions.push(setting("dLblPos")?.getAttribute("val") || "bestFit");
        if (enabled("delete")) return "";
        const custom = direct(pointLabel, "tx");
        if (custom) return $08414ea58bdc1292$var$chartText(custom);
        const parts = [];
        if (enabled("showSerName")) parts.push(parsed.name);
        if (enabled("showCatName")) parts.push(parsed.categories[index] || String(index + 1));
        if (enabled("showVal")) parts.push(String(value));
        if (enabled("showPercent")) parts.push(`${Number((total > 0 ? Math.abs(value) / total * 100 : 0).toFixed(1))}%`);
        return parts.join(direct(pointLabel, "separator")?.textContent || direct(seriesLabels, "separator")?.textContent || ", ");
    });
    return {
        labels: labels,
        labelPositions: positions,
        labelFontSizes: fontSizes
    };
}
function $08414ea58bdc1292$var$readChartTitle(doc) {
    const chart = Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "chart");
    const titleElement = Array.from(chart?.children || []).find((element)=>element.localName === "title");
    if (!titleElement) return "";
    const explicitTitle = $08414ea58bdc1292$var$chartText(titleElement);
    if (explicitTitle) return explicitTitle;
    const language = Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "lang")?.getAttribute("val") || "";
    return /^zh\b/i.test(language) ? "\u56FE\u8868\u6807\u9898" : "Chart Title";
}
function $08414ea58bdc1292$var$parseChartSeries(element, index) {
    return {
        name: $08414ea58bdc1292$var$textFromFirst(element, "tx") || `Series ${index + 1}`,
        values: $08414ea58bdc1292$var$numbersFromFirst(element, "val"),
        categories: $08414ea58bdc1292$var$readChartCategories(element)
    };
}
function $08414ea58bdc1292$var$readChartCategories(series) {
    const category = Array.from(series.children).find((element)=>element.localName === "cat");
    if (!category) return [];
    const values = $08414ea58bdc1292$var$chartStringValues(category);
    const formatCode = Array.from(category.getElementsByTagName("*")).find((element)=>element.localName === "formatCode")?.textContent || "";
    if (!/[ymd]/i.test(formatCode)) return values;
    return values.map((value)=>$08414ea58bdc1292$var$formatExcelChartDate(value) || value);
}
function $08414ea58bdc1292$var$formatExcelChartDate(value) {
    const serial = Number(value);
    if (!Number.isFinite(serial) || serial < 1) return void 0;
    const date = new Date(Date.UTC(1899, 11, 30) + Math.round(serial) * 864e5);
    return `${date.getUTCFullYear()}/${date.getUTCMonth() + 1}`;
}
function $08414ea58bdc1292$var$readChartValueAxes(doc) {
    return Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "valAx").map((axis)=>{
        const direct = (localName)=>Array.from(axis.children).find((element)=>element.localName === localName);
        const scaling = direct("scaling");
        const scaleValue = (localName)=>{
            const value = Array.from(scaling?.children || []).find((element)=>element.localName === localName)?.getAttribute("val");
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : void 0;
        };
        const numericAttribute = (element)=>{
            const parsed = Number(element?.getAttribute("val"));
            return Number.isFinite(parsed) ? parsed : void 0;
        };
        return {
            id: direct("axId")?.getAttribute("val") || "",
            title: direct("title") ? $08414ea58bdc1292$var$chartText(direct("title")) : void 0,
            min: scaleValue("min"),
            max: scaleValue("max"),
            majorUnit: numericAttribute(direct("majorUnit")),
            formatCode: direct("numFmt")?.getAttribute("formatCode") || void 0,
            position: direct("axPos")?.getAttribute("val") || void 0
        };
    });
}
function $08414ea58bdc1292$var$readChartSeriesColor(element, themeColors = {}) {
    const shape = Array.from(element?.children || []).find((child)=>child.localName === "spPr");
    const color = Array.from(shape?.getElementsByTagName("*") || []).find((child)=>child.localName === "srgbClr" || child.localName === "schemeClr");
    if (!color) return void 0;
    if (color.localName === "srgbClr") {
        const value = color.getAttribute("val") || "";
        return /^[\da-f]{6}$/i.test(value) ? `#${value}` : void 0;
    }
    return themeColors[color.getAttribute("val") || ""] || $08414ea58bdc1292$var$chartSchemeColor(color.getAttribute("val") || "");
}
function $08414ea58bdc1292$var$chartSchemeColor(value) {
    const colors = {
        accent1: "#156082",
        accent2: "#e97132",
        accent3: "#196b24",
        accent4: "#0f9ed5",
        accent5: "#a02b93",
        accent6: "#4ea72e"
    };
    return colors[value];
}
function $08414ea58bdc1292$var$renderChartPreviewSection(charts) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u8868\u683C\u56FE\u8868\u9884\u89C8");
    const grid = document.createElement("div");
    grid.className = "ofv-chart-grid";
    for (const chart of charts)grid.append($08414ea58bdc1292$var$renderChartCard(chart));
    section.append(grid);
    return section;
}
function $08414ea58bdc1292$var$renderChartCard(chart) {
    const card = document.createElement("article");
    card.className = "ofv-chart-card";
    const header = document.createElement("header");
    const title = document.createElement("h4");
    title.textContent = chart.title || chart.name;
    const meta = document.createElement("span");
    meta.textContent = `${chart.type} \xB7 ${chart.series.length} \u4E2A\u7CFB\u5217`;
    header.append(title, meta);
    const svg = $08414ea58bdc1292$var$renderChartSvg(chart);
    const details = document.createElement("details");
    details.className = "ofv-details ofv-chart-data";
    $08414ea58bdc1292$var$hideSupplementalInfo3(details);
    const summary = document.createElement("summary");
    summary.textContent = "\u6570\u636E\u6458\u8981";
    const list = document.createElement("ul");
    for (const item of chart.series){
        const row = document.createElement("li");
        row.textContent = `${item.name}: ${item.values.slice(0, 12).join(", ")}${item.values.length > 12 ? ` ... \u5171 ${item.values.length} \u9879` : ""}`;
        list.append(row);
    }
    details.append(summary, list);
    card.append(header, svg, details);
    return card;
}
function $08414ea58bdc1292$var$renderChartSvg(chart) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 640 380");
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    svg.setAttribute("text-rendering", "geometricPrecision");
    svg.setAttribute("shape-rendering", "geometricPrecision");
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", chart.title || chart.name);
    svg.classList.add("ofv-chart-svg");
    const colors = [
        "#156082",
        "#e97132",
        "#196b24",
        "#0f9ed5",
        "#a02b93",
        "#4ea72e"
    ];
    const circularTypes = /* @__PURE__ */ new Set([
        "pie",
        "doughnut"
    ]);
    if (chart.series.length === 1 && circularTypes.has(chart.series[0].type)) {
        $08414ea58bdc1292$var$renderCircularChart(svg, chart, colors);
        return svg;
    }
    if (chart.series.some((series)=>![
            "bar",
            "line"
        ].includes(series.type))) {
        const label = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: 320,
            y: 190,
            "text-anchor": "middle",
            class: "ofv-chart-label"
        });
        label.textContent = `\u6682\u4E0D\u652F\u6301\u6B64\u56FE\u8868\u7C7B\u578B\uFF08${chart.type}\uFF09\uFF0C\u8BF7\u4E0B\u8F7D\u539F\u6587\u4EF6\u67E5\u770B`;
        return svg;
    }
    const hasTitle = Boolean(chart.title);
    const primarySeries = chart.series[0];
    const primaryAxisId = primarySeries?.valueAxisId;
    const primaryScale = $08414ea58bdc1292$var$createChartSeriesScale(chart, primarySeries);
    const primaryAxis = chart.axes.find((axis)=>axis.id === primaryAxisId);
    const secondarySeries = chart.series.find((series)=>series.valueAxisId && series.valueAxisId !== primaryAxisId);
    const secondaryScale = secondarySeries ? $08414ea58bdc1292$var$createChartSeriesScale(chart, secondarySeries) : void 0;
    const secondaryAxis = secondarySeries ? chart.axes.find((axis)=>axis.id === secondarySeries.valueAxisId) : void 0;
    const plot = {
        x: 74,
        y: hasTitle ? 74 : 38,
        width: secondaryScale ? 500 : 526,
        height: hasTitle ? 214 : 250
    };
    const categories = chart.categories.length > 0 ? chart.categories : chart.series[0]?.values.map((_, index)=>String(index + 1)) || [];
    if (hasTitle) {
        const title = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: 320,
            y: 34,
            class: "ofv-chart-title",
            "text-anchor": "middle"
        });
        title.textContent = chart.title;
    }
    if (primaryAxis?.title) {
        const axisTitle = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: plot.x,
            y: plot.y - 10,
            class: "ofv-chart-label ofv-chart-axis-title",
            "text-anchor": "start"
        });
        axisTitle.textContent = primaryAxis.title;
    }
    if (secondaryAxis?.title) {
        const axisTitle = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: plot.x + plot.width,
            y: plot.y - 10,
            class: "ofv-chart-label ofv-chart-axis-title",
            "text-anchor": "end"
        });
        axisTitle.textContent = secondaryAxis.title;
    }
    for (const value of primaryScale.ticks){
        const y = $08414ea58bdc1292$var$chartValueY(value, primaryScale, plot);
        $08414ea58bdc1292$var$appendSvg(svg, "line", {
            x1: plot.x,
            y1: Number(y.toFixed(1)),
            x2: plot.x + plot.width,
            y2: Number(y.toFixed(1)),
            class: value === 0 ? "ofv-chart-axis" : "ofv-chart-gridline"
        });
        const label = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: plot.x - 12,
            y: Number((y + 4).toFixed(1)),
            class: "ofv-chart-label",
            "text-anchor": "end"
        });
        label.textContent = $08414ea58bdc1292$var$formatChartTick(value, primaryScale.formatCode);
    }
    if (secondaryScale) for (const value of secondaryScale.ticks){
        const y = $08414ea58bdc1292$var$chartValueY(value, secondaryScale, plot);
        const label = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: plot.x + plot.width + 12,
            y: Number((y + 4).toFixed(1)),
            class: "ofv-chart-label ofv-chart-secondary-axis-label",
            "text-anchor": "start"
        });
        label.textContent = $08414ea58bdc1292$var$formatChartTick(value, secondaryAxis?.formatCode);
    }
    $08414ea58bdc1292$var$appendSvg(svg, "line", {
        x1: plot.x,
        y1: plot.y + plot.height,
        x2: plot.x + plot.width,
        y2: plot.y + plot.height,
        class: "ofv-chart-axis"
    });
    const barSeries = chart.series.filter((series)=>series.type.includes("bar") || series.type.includes("col"));
    const lineSeries = chart.series.filter((series)=>series.type === "line");
    const categoryCount = Math.max(1, categories.length, ...chart.series.map((series)=>series.values.length));
    const categoryStep = categoryCount > 1 ? plot.width / (categoryCount - 1) : plot.width;
    $08414ea58bdc1292$var$appendChartCategoryLabels(svg, categories, plot, (index)=>barSeries.length > 0 ? plot.x + plot.width / categoryCount * (index + 0.5) : plot.x + index * categoryStep);
    if (barSeries.length > 0) {
        const groupWidth = plot.width / categoryCount;
        const clusterWidth = groupWidth * 0.58;
        const barWidth = Math.max(5, Math.min(28, clusterWidth / Math.max(1, barSeries.length)));
        barSeries.forEach((series, seriesIndex)=>{
            const colorIndex = chart.series.indexOf(series);
            const color = series.color || colors[colorIndex % colors.length];
            const scale = $08414ea58bdc1292$var$createChartSeriesScale(chart, series);
            const zeroY = $08414ea58bdc1292$var$chartValueY(Math.max(scale.min, Math.min(scale.max, 0)), scale, plot);
            series.values.forEach((value, index)=>{
                const groupCenter = plot.x + groupWidth * (index + 0.5);
                const x = groupCenter - barWidth * barSeries.length / 2 + seriesIndex * barWidth + barWidth * 0.12;
                const y = $08414ea58bdc1292$var$chartValueY(value, scale, plot);
                $08414ea58bdc1292$var$appendSvg(svg, "rect", {
                    x: Number(x.toFixed(1)),
                    y: Number(Math.min(y, zeroY).toFixed(1)),
                    width: Number((barWidth * 0.76).toFixed(1)),
                    height: Number(Math.max(1, Math.abs(zeroY - y)).toFixed(1)),
                    fill: color,
                    "data-index": index
                });
            });
        });
    }
    lineSeries.forEach((series)=>{
        const seriesIndex = chart.series.indexOf(series);
        const color = series.color || colors[seriesIndex % colors.length];
        const scale = $08414ea58bdc1292$var$createChartSeriesScale(chart, series);
        const step = series.values.length > 1 ? plot.width / (series.values.length - 1) : plot.width;
        const points = series.values.map((value, index)=>({
                x: plot.x + index * step,
                y: $08414ea58bdc1292$var$chartValueY(value, scale, plot)
            }));
        $08414ea58bdc1292$var$appendSvg(svg, "polyline", {
            points: points.map((point)=>`${point.x.toFixed(1)},${point.y.toFixed(1)}`).join(" "),
            fill: "none",
            stroke: color,
            "stroke-width": 3,
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        });
    });
    if (chart.showLegend) $08414ea58bdc1292$var$appendChartLegend(svg, chart, colors, 348);
    return svg;
}
function $08414ea58bdc1292$var$renderCircularChart(svg, chart, colors) {
    const series = chart.series[0];
    const values = series.values.map((value)=>Math.abs(value));
    const total = values.reduce((sum, value)=>sum + value, 0);
    if (chart.title) {
        const title = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: 320,
            y: 34,
            class: "ofv-chart-title",
            "text-anchor": "middle"
        });
        title.textContent = chart.title;
    }
    const legendPosition = chart.legendPosition || "r";
    const horizontalLegend = [
        "t",
        "b"
    ].includes(legendPosition);
    const legendFontSize = chart.legendFontSize || 12;
    const textWidth = (text, size)=>Array.from(text).reduce((width, character)=>width + (/[^\x00-\x7f]/.test(character) ? size : size * 0.52), 0);
    const legendWidths = values.map((_, index)=>textWidth(chart.categories[index] || String(index + 1), legendFontSize) + legendFontSize * 2);
    const legendLocations = [];
    let legendX = 0, row = 0;
    legendWidths.forEach((width)=>{
        if (legendX + width > 600 && legendX > 0) {
            row++;
            legendX = 0;
        }
        legendLocations.push({
            x: legendX,
            row: row
        });
        legendX += width;
    });
    const legendRows = row + 1;
    const rowWidths = Array.from({
        length: legendRows
    }, (_, rowIndex)=>legendWidths.reduce((sum, width, index)=>sum + (legendLocations[index].row === rowIndex ? width : 0), 0));
    const topLegendHeight = chart.showLegend && legendPosition === "t" ? legendRows * (legendFontSize + 6) : 0;
    const cx = chart.showLegend && !horizontalLegend ? legendPosition === "l" ? 450 : 190 : 320;
    const plotTop = (chart.title ? 48 : 10) + topLegendHeight + 18;
    const plotBottom = chart.showLegend && legendPosition === "b" ? 350 - legendRows * (legendFontSize + 6) : 350;
    const cy = (plotTop + plotBottom) / 2;
    const radius = Math.min(155, (plotBottom - plotTop) / 2 - 10);
    const labelBoxes = [];
    const inner = series.type === "doughnut" ? radius * Math.max(0.1, Math.min(0.9, (series.holeSize ?? 50) / 100)) : 0;
    let angle = ((series.firstSliceAngle || 0) - 90) * Math.PI / 180;
    const point = (r, a)=>`${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`;
    values.forEach((value, index)=>{
        const sweep = total > 0 ? value / total * Math.PI * 2 : 0;
        const end = angle + sweep;
        const palette = chart.palette || colors;
        const baseColor = palette[index % palette.length];
        const cycle = Math.floor(index / palette.length);
        const color = series.pointColors?.[index] || (cycle > 0 ? $08414ea58bdc1292$var$tintChartColor(baseColor, Math.min(0.8, cycle * 0.5)) : baseColor);
        if (sweep > 0) {
            const middle = angle + sweep / 2;
            let path = `M ${point(radius, angle)} A ${radius},${radius} 0 0 1 ${point(radius, middle)} A ${radius},${radius} 0 0 1 ${point(radius, end)}`;
            path += inner > 0 ? ` L ${point(inner, end)} A ${inner},${inner} 0 0 0 ${point(inner, middle)} A ${inner},${inner} 0 0 0 ${point(inner, angle)} Z` : ` L ${cx},${cy} Z`;
            const slice = $08414ea58bdc1292$var$appendSvg(svg, "path", {
                d: path,
                fill: color,
                stroke: "#fff",
                "stroke-width": 1,
                "data-slice-index": index
            });
            const title = $08414ea58bdc1292$var$appendSvg(slice, "title", {});
            title.textContent = `${chart.categories[index] || index + 1}: ${series.values[index]} (${total > 0 ? Number((value / total * 100).toFixed(1)) : 0}%)`;
        }
        const label = series.labels?.[index];
        if (label && sweep > 0) {
            const position = series.labelPositions?.[index] || "bestFit";
            const middle = angle + sweep / 2;
            const fontSize = series.labelFontSizes?.[index] || 12;
            const width = textWidth(label, fontSize);
            const insideRadius = inner + (radius - inner) * (position === "ctr" ? 0.5 : 0.65);
            let x = cx + insideRadius * Math.cos(middle);
            let y = cy + insideRadius * Math.sin(middle);
            const corners = [
                -1,
                1
            ].flatMap((dx)=>[
                    -1,
                    1
                ].map((dy)=>({
                        x: x + dx * width / 2,
                        y: y + dy * fontSize / 2
                    })));
            const fits = corners.every((corner)=>{
                const distance = Math.hypot(corner.x - cx, corner.y - cy);
                let cornerAngle = Math.atan2(corner.y - cy, corner.x - cx);
                while(cornerAngle < angle)cornerAngle += Math.PI * 2;
                return distance < radius - 3 && distance > inner && cornerAngle <= end;
            });
            const outside = position === "outEnd" || position === "bestFit" && !fits;
            if (outside) {
                x = cx + (radius + 12) * Math.cos(middle);
                y = cy + (radius + 12) * Math.sin(middle);
            }
            let anchor = outside ? Math.cos(middle) >= 0 ? "start" : "end" : "middle";
            x = Math.max(width / 2 + 4, Math.min(636 - width / 2, x));
            let left = anchor === "start" ? x : anchor === "end" ? x - width : x - width / 2;
            if (left < 4 || left + width > 636) {
                anchor = "middle";
                left = x - width / 2;
            }
            if (position === "bestFit" || outside) for(let attempt = 0; attempt < values.length; attempt++){
                const overlap = labelBoxes.find((box)=>left < box.x + box.width + 2 && left + width + 2 > box.x && Math.abs(y - box.y) < (fontSize + box.height) / 2 + 2);
                if (!overlap) break;
                y = overlap.y + (fontSize + overlap.height) / 2 + 3;
            }
            y = Math.min(370 - fontSize / 2, Math.max(plotTop, y));
            labelBoxes.push({
                x: left,
                y: y,
                width: width,
                height: fontSize
            });
            const text = $08414ea58bdc1292$var$appendSvg(svg, "text", {
                x: x,
                y: y,
                "text-anchor": anchor,
                "dominant-baseline": "middle",
                class: "ofv-chart-label ofv-chart-data-label",
                "data-label-index": index,
                "data-label-placement": outside ? "outside" : "inside"
            });
            text.style.fill = $08414ea58bdc1292$var$circularChartLabelColor(outside ? "#ffffff" : color);
            text.style.fontSize = `${fontSize}px`;
            text.textContent = label;
        }
        if (chart.showLegend) {
            const location = legendLocations[index];
            const x = horizontalLegend ? (640 - rowWidths[location.row]) / 2 + location.x : legendPosition === "l" ? 20 : 360;
            const y = horizontalLegend ? (legendPosition === "t" ? chart.title ? 64 : 20 : 350) + location.row * (legendFontSize + 6) : 73 + index * 28;
            $08414ea58bdc1292$var$appendSvg(svg, "rect", {
                x: x,
                y: y - legendFontSize * 0.7,
                width: legendFontSize * 0.7,
                height: legendFontSize * 0.7,
                fill: color
            });
            const text = $08414ea58bdc1292$var$appendSvg(svg, "text", {
                x: x + legendFontSize,
                y: y,
                class: "ofv-chart-label",
                "data-chart-legend": index
            });
            text.style.fontSize = `${legendFontSize}px`;
            text.textContent = chart.categories[index] || String(index + 1);
        }
        angle = end;
    });
    const height = Math.max(380, horizontalLegend ? legendPosition === "b" ? 370 + legendRows * 24 : 380 : 90 + values.length * 28);
    svg.setAttribute("viewBox", `0 0 640 ${height}`);
}
function $08414ea58bdc1292$var$tintChartColor(color, amount) {
    return "#" + (color.slice(1).match(/.{2}/g) || []).map((channel)=>Math.round(parseInt(channel, 16) * (1 - amount) + 255 * amount).toString(16).padStart(2, "0")).join("");
}
function $08414ea58bdc1292$var$circularChartLabelColor(background) {
    const channels = background.replace("#", "").match(/.{2}/g)?.map((channel)=>{
        const value = parseInt(channel, 16) / 255;
        return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });
    if (!channels || channels.length !== 3) return "#000000";
    const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
    return luminance > 0.179 ? "#000000" : "#ffffff";
}
function $08414ea58bdc1292$var$createChartSeriesScale(chart, series) {
    const values = series?.values.filter((value)=>Number.isFinite(value)) || [];
    const max = Math.max(1, ...values);
    const min = Math.min(0, ...values);
    const axis = chart.axes.find((item)=>item.id === series?.valueAxisId);
    return $08414ea58bdc1292$var$createChartAxisScale(max, min, axis);
}
function $08414ea58bdc1292$var$chartValueY(value, scale, plot) {
    return plot.y + plot.height - (value - scale.min) / (scale.max - scale.min || 1) * plot.height;
}
function $08414ea58bdc1292$var$appendChartCategoryLabels(svg, categories, plot, getX) {
    const categoryLabels = categories.map((category, index)=>({
            category: category,
            index: index
        })).filter(({ category: category })=>Boolean(category));
    const interval = Math.max(1, Math.ceil(categoryLabels.length / 14));
    let previousLabel = "";
    categoryLabels.forEach(({ category: category, index: index }, labelIndex)=>{
        const duplicate = category === previousLabel;
        if (labelIndex % interval !== 0 || duplicate) return;
        previousLabel = category;
        const label = $08414ea58bdc1292$var$appendSvg(svg, "text", {
            x: Number(getX(index).toFixed(1)),
            y: plot.y + plot.height + 22,
            class: "ofv-chart-label ofv-chart-category-label",
            "data-axis": "category",
            "text-anchor": "middle"
        });
        label.textContent = $08414ea58bdc1292$var$truncateChartLabel(category);
    });
}
function $08414ea58bdc1292$var$appendChartLegend(svg, chart, colors, y) {
    const itemWidth = 86;
    const startX = 320 - chart.series.length * itemWidth / 2;
    chart.series.forEach((series, seriesIndex)=>{
        const color = series.color || colors[seriesIndex % colors.length];
        $08414ea58bdc1292$var$appendLegend(svg, series.name, color, startX + seriesIndex * itemWidth, y);
    });
}
function $08414ea58bdc1292$var$createChartAxisScale(max, min, axis) {
    const axisMin = axis?.min ?? Math.min(0, min);
    const positiveMax = Math.max(axisMin, max);
    const step = axis?.majorUnit && axis.majorUnit > 0 ? axis.majorUnit : $08414ea58bdc1292$var$niceChartStep((positiveMax - axisMin || 1) / 5);
    let axisMax = axis?.max ?? Math.ceil(positiveMax / step) * step;
    if (axisMax <= axisMin) axisMax = axisMin + step;
    const ticks = [];
    for(let value = axisMin, count = 0; value <= axisMax + step / 2 && count < 50; value += step, count += 1)ticks.push(Number(value.toFixed(6)));
    return {
        min: axisMin,
        max: axisMax,
        ticks: ticks,
        formatCode: axis?.formatCode
    };
}
function $08414ea58bdc1292$var$niceChartStep(rawStep) {
    if (rawStep <= 0) return 1;
    const magnitude = 10 ** Math.floor(Math.log10(rawStep));
    const normalized = rawStep / magnitude;
    const nice = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
    return nice * magnitude;
}
function $08414ea58bdc1292$var$formatChartTick(value, formatCode) {
    if (formatCode?.includes("%")) return `${Number((value * 100).toFixed(1))}%`;
    const rounded = Math.abs(value) < 1 ? Number(value.toFixed(1)) : Number(value.toFixed(0));
    return String(rounded);
}
function $08414ea58bdc1292$var$truncateChartLabel(value) {
    return value.length > 10 ? `${value.slice(0, 10)}...` : value;
}
function $08414ea58bdc1292$var$appendLegend(svg, label, color, x, y) {
    $08414ea58bdc1292$var$appendSvg(svg, "rect", {
        x: x,
        y: y - 10,
        width: 12,
        height: 12,
        rx: 2,
        fill: color
    });
    const text = $08414ea58bdc1292$var$appendSvg(svg, "text", {
        x: x + 18,
        y: y,
        class: "ofv-chart-label"
    });
    text.textContent = label.length > 16 ? `${label.slice(0, 16)}...` : label;
}
function $08414ea58bdc1292$var$appendSvg(parent, tag, attributes) {
    const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for (const [key, value] of Object.entries(attributes))element.setAttribute(key, String(value));
    parent.append(element);
    return element;
}
function $08414ea58bdc1292$var$textFromFirst(root, localName) {
    const element = Array.from(root.querySelectorAll("*")).find((item)=>item.localName === localName);
    return element ? $08414ea58bdc1292$var$chartText(element) : "";
}
function $08414ea58bdc1292$var$numbersFromFirst(root, localName) {
    const element = Array.from(root.querySelectorAll("*")).find((item)=>item.localName === localName);
    if (!element) return [];
    return Array.from(element.querySelectorAll("*")).filter((item)=>item.localName === "v").map((item)=>Number(item.textContent || "")).filter((value)=>Number.isFinite(value));
}
function $08414ea58bdc1292$var$chartText(element) {
    return Array.from(element.querySelectorAll("*")).filter((item)=>item.localName === "v" || item.localName === "t").map((item)=>item.textContent?.trim() || "").find(Boolean) || "";
}
function $08414ea58bdc1292$var$chartStringValues(element) {
    const points = Array.from(element.querySelectorAll("*")).filter((item)=>item.localName === "pt");
    if (points.length === 0) return Array.from(element.querySelectorAll("*")).filter((item)=>item.localName === "v" || item.localName === "t").map((item)=>item.textContent?.trim() || "").filter(Boolean);
    const declaredCount = Number.parseInt(Array.from(element.querySelectorAll("*")).find((item)=>item.localName === "ptCount")?.getAttribute("val") || "", 10);
    let nextIndex = 0;
    const indexedValues = points.map((point)=>{
        const parsedIndex = Number.parseInt(point.getAttribute("idx") || "", 10);
        const index = Number.isFinite(parsedIndex) && parsedIndex >= 0 ? parsedIndex : nextIndex;
        nextIndex = Math.max(nextIndex, index + 1);
        return {
            index: index,
            value: $08414ea58bdc1292$var$chartText(point)
        };
    });
    const valueCount = Math.max(Number.isFinite(declaredCount) ? declaredCount : 0, nextIndex);
    const values = Array(valueCount).fill("");
    for (const { index: index, value: value } of indexedValues)values[index] = value;
    return values;
}
function $08414ea58bdc1292$var$detectWord2003XmlDocument(extension, arrayBuffer) {
    if (extension !== "doc" && extension !== "dot" || $08414ea58bdc1292$var$hasOleSignature(arrayBuffer)) return void 0;
    return $08414ea58bdc1292$var$parseWord2003XmlDocument((0, $3438a2478d5b847f$export$62387d23696f2b23)(arrayBuffer));
}
function $08414ea58bdc1292$var$trimWorkbookSheetRange(sheet, range, decodeCell, images = []) {
    let minRow = Number.POSITIVE_INFINITY;
    let minColumn = Number.POSITIVE_INFINITY;
    let maxRow = Number.NEGATIVE_INFINITY;
    let maxColumn = Number.NEGATIVE_INFINITY;
    const include = (row, column)=>{
        minRow = Math.min(minRow, row);
        minColumn = Math.min(minColumn, column);
        maxRow = Math.max(maxRow, row);
        maxColumn = Math.max(maxColumn, column);
    };
    for (const [address, cell] of Object.entries(sheet)){
        if (address.startsWith("!")) continue;
        if (!cell || cell.v == null && !cell.f && !cell.w && !cell.h) continue;
        const decoded = decodeCell(address);
        include(decoded.r, decoded.c);
    }
    for (const merge of sheet["!merges"] || []){
        include(merge.s.r, merge.s.c);
        include(merge.e.r, merge.e.c);
    }
    for (const image of images){
        include(image.row, image.column);
        include(image.endRow ?? image.row, image.endColumn ?? image.column);
    }
    if (!Number.isFinite(minRow) || !Number.isFinite(minColumn) || !Number.isFinite(maxRow) || !Number.isFinite(maxColumn)) return range;
    return {
        s: {
            r: minRow,
            c: minColumn
        },
        e: {
            r: maxRow,
            c: maxColumn
        }
    };
}
function $08414ea58bdc1292$var$createSheetViewport(rowCount, columnCount) {
    return {
        rowStart: 0,
        columnStart: 0,
        rowCount: rowCount,
        columnCount: columnCount
    };
}
function $08414ea58bdc1292$var$createSheetWindowControls(viewport, render) {
    const needsRows = viewport.rowCount > $08414ea58bdc1292$var$SHEET_WINDOW_ROWS;
    const needsColumns = viewport.columnCount > $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS;
    if (!needsRows && !needsColumns) return null;
    const controls = document.createElement("div");
    controls.className = "ofv-sheet-window";
    const note = document.createElement("span");
    note.className = "ofv-sheet-window-note";
    const rowBack = $08414ea58bdc1292$var$createWindowButton("\u4E0A 200 \u884C", ()=>{
        viewport.rowStart = Math.max(0, viewport.rowStart - $08414ea58bdc1292$var$SHEET_WINDOW_ROWS);
        render();
    });
    const rowNext = $08414ea58bdc1292$var$createWindowButton("\u4E0B 200 \u884C", ()=>{
        viewport.rowStart = Math.min($08414ea58bdc1292$var$maxStart(viewport.rowCount, $08414ea58bdc1292$var$SHEET_WINDOW_ROWS), viewport.rowStart + $08414ea58bdc1292$var$SHEET_WINDOW_ROWS);
        render();
    });
    const colBack = $08414ea58bdc1292$var$createWindowButton("\u5DE6 80 \u5217", ()=>{
        viewport.columnStart = Math.max(0, viewport.columnStart - $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS);
        render();
    });
    const colNext = $08414ea58bdc1292$var$createWindowButton("\u53F3 80 \u5217", ()=>{
        viewport.columnStart = Math.min($08414ea58bdc1292$var$maxStart(viewport.columnCount, $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS), viewport.columnStart + $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS);
        render();
    });
    controls.append(note, rowBack, rowNext, colBack, colNext);
    const update = ()=>{
        const rowEnd = Math.min(viewport.rowStart + $08414ea58bdc1292$var$SHEET_WINDOW_ROWS, viewport.rowCount);
        const columnEnd = Math.min(viewport.columnStart + $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS, viewport.columnCount);
        note.textContent = `\u5927\u8868\u683C\u7A97\u53E3\u5316\u6E32\u67D3\uFF1A\u5F53\u524D ${viewport.rowStart + 1}-${rowEnd} \u884C\uFF0C${viewport.columnStart + 1}-${columnEnd} \u5217`;
        rowBack.disabled = viewport.rowStart === 0;
        rowNext.disabled = viewport.rowStart >= $08414ea58bdc1292$var$maxStart(viewport.rowCount, $08414ea58bdc1292$var$SHEET_WINDOW_ROWS);
        colBack.disabled = viewport.columnStart === 0;
        colNext.disabled = viewport.columnStart >= $08414ea58bdc1292$var$maxStart(viewport.columnCount, $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS);
        rowBack.hidden = rowNext.hidden = !needsRows;
        colBack.hidden = colNext.hidden = !needsColumns;
    };
    update();
    return {
        element: controls,
        update: update
    };
}
function $08414ea58bdc1292$var$createWindowButton(label, onClick) {
    const button = document.createElement("button");
    button.type = "button";
    button.textContent = label;
    button.addEventListener("click", onClick);
    return button;
}
function $08414ea58bdc1292$var$maxStart(total, size) {
    return Math.max(0, total - size);
}
function $08414ea58bdc1292$var$createWorkbookSheetTable(sheet, range, sheetIndex, viewport, encodeCell, formatCell, columnSizing, rerender, images = [], richTextByCell = /* @__PURE__ */ new Map(), cellStylesByCell = /* @__PURE__ */ new Map()) {
    const table = document.createElement("table");
    table.id = `ofv-sheet-${sheetIndex + 1}`;
    table.className = "ofv-workbook-table";
    const rowEnd = Math.min(range.s.r + viewport.rowStart + $08414ea58bdc1292$var$SHEET_WINDOW_ROWS - 1, range.e.r);
    const columnEnd = Math.min(range.s.c + viewport.columnStart + $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS - 1, range.e.c);
    const columnStart = range.s.c + viewport.columnStart;
    const rowStart = range.s.r + viewport.rowStart;
    const mergePlan = $08414ea58bdc1292$var$createSheetMergePlan(sheet["!merges"] || [], rowStart, rowEnd, columnStart, columnEnd);
    const imagesByCell = $08414ea58bdc1292$var$groupWorkbookImagesByCell(images);
    const columnsWithResizeHandles = /* @__PURE__ */ new Set();
    const colGroup = document.createElement("colgroup");
    let tableWidth = 0;
    for(let columnIndex = columnStart; columnIndex <= columnEnd; columnIndex += 1){
        const col = document.createElement("col");
        const width = columnSizing.widths.get(columnIndex) ?? $08414ea58bdc1292$var$getWorkbookColumnWidth(sheet["!cols"]?.[columnIndex], columnSizing.sourceColumns?.get(columnIndex), columnSizing.sourceDefaultColumn, columnSizing.sourceMdw);
        col.dataset.columnIndex = String(columnIndex);
        col.style.width = `${width}px`;
        tableWidth += width;
        colGroup.append(col);
    }
    table.style.width = `${tableWidth}px`;
    table.append(colGroup);
    for(let rowIndex = rowStart; rowIndex <= rowEnd; rowIndex += 1){
        const row = document.createElement("tr");
        const rowHeight = $08414ea58bdc1292$var$getSheetRowHeight(sheet["!rows"]?.[rowIndex]);
        if (rowHeight) row.style.height = `${rowHeight}px`;
        for(let columnIndex = columnStart; columnIndex <= columnEnd; columnIndex += 1){
            const address = encodeCell({
                r: rowIndex,
                c: columnIndex
            });
            const coordinateKey = `${rowIndex}:${columnIndex}`;
            if (mergePlan.covered.has(coordinateKey)) continue;
            const merge = mergePlan.anchors.get(coordinateKey);
            const sourceAddress = merge ? encodeCell({
                r: merge.sourceRow,
                c: merge.sourceColumn
            }) : address;
            const sourceCell = sheet[sourceAddress];
            const sourceStyle = sourceAddress ? cellStylesByCell.get(sourceAddress) : void 0;
            const cell = document.createElement(rowIndex === range.s.r ? "th" : "td");
            cell.dataset.cell = address;
            if (sourceAddress !== address) cell.dataset.sourceCell = sourceAddress;
            if (merge) {
                cell.classList.add("ofv-cell-merged");
                if (merge.rowspan > 1) cell.rowSpan = merge.rowspan;
                if (merge.colspan > 1) cell.colSpan = merge.colspan;
            }
            const text = sourceCell ? formatCell(sourceCell) : "";
            const richText = sourceAddress ? richTextByCell.get(sourceAddress) : void 0;
            if (richText?.length) $08414ea58bdc1292$var$appendWorkbookCellRichText(cell, richText);
            else if ($08414ea58bdc1292$var$hasWorkbookCellHtmlRichText(sourceCell)) $08414ea58bdc1292$var$appendWorkbookCellHtmlRichText(cell, sourceCell.h);
            else cell.textContent = text;
            if (text) cell.title = text;
            if ($08414ea58bdc1292$var$isWorkbookNumericCell(sourceCell)) cell.classList.add("ofv-cell-number");
            $08414ea58bdc1292$var$applyWorkbookCellStyle(cell, sourceCell, sourceStyle);
            if (sourceCell?.f) {
                cell.classList.add("ofv-cell-formula");
                cell.title = `=${sourceCell.f}`;
            }
            if (text.includes("\n")) cell.classList.add("ofv-cell-multiline");
            $08414ea58bdc1292$var$appendWorkbookCellImages(cell, imagesByCell.get(`${rowIndex}:${columnIndex}`), text);
            const resizeColumnIndex = columnIndex + (merge?.colspan || 1) - 1;
            if (!columnsWithResizeHandles.has(resizeColumnIndex)) {
                $08414ea58bdc1292$var$appendColumnResizeHandle(cell, resizeColumnIndex, columnSizing);
                columnsWithResizeHandles.add(resizeColumnIndex);
            }
            row.append(cell);
        }
        table.append(row);
    }
    return table;
}
function $08414ea58bdc1292$var$getWorkbookColumnWidth(column, sourceColumn, sourceDefaultColumn, sourceMdw) {
    if (sourceColumn) return $08414ea58bdc1292$var$getSheetColumnWidth({
        ...sourceColumn,
        MDW: sourceMdw ?? column?.MDW
    });
    if (column) return $08414ea58bdc1292$var$getSheetColumnWidth(column);
    return sourceDefaultColumn ? $08414ea58bdc1292$var$getSheetColumnWidth({
        ...sourceDefaultColumn,
        MDW: sourceMdw
    }) : $08414ea58bdc1292$var$getSheetColumnWidth(void 0);
}
function $08414ea58bdc1292$var$appendColumnResizeHandle(cell, columnIndex, columnSizing) {
    const handle = document.createElement("span");
    handle.className = "ofv-column-resize-handle";
    handle.dataset.columnIndex = String(columnIndex);
    handle.setAttribute("aria-hidden", "true");
    handle.addEventListener("pointerdown", (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const startX = event.clientX;
        const zoom = $08414ea58bdc1292$var$getOfficePanelZoom(cell);
        const startWidth = columnSizing.widths.get(columnIndex) ?? cell.getBoundingClientRect().width / zoom;
        handle.setPointerCapture(event.pointerId);
        const onMove = (moveEvent)=>{
            const nextWidth = Math.max(48, Math.min(720, Math.round(startWidth + (moveEvent.clientX - startX) / zoom)));
            columnSizing.widths.set(columnIndex, nextWidth);
            $08414ea58bdc1292$var$updateRenderedColumnWidth(cell, columnIndex, nextWidth);
        };
        const onEnd = ()=>{
            handle.removeEventListener("pointermove", onMove);
            handle.removeEventListener("pointerup", onEnd);
            handle.removeEventListener("pointercancel", onEnd);
        };
        handle.addEventListener("pointermove", onMove);
        handle.addEventListener("pointerup", onEnd);
        handle.addEventListener("pointercancel", onEnd);
    });
    cell.append(handle);
}
function $08414ea58bdc1292$var$updateRenderedColumnWidth(cell, columnIndex, width) {
    const table = cell.closest("table");
    if (!table) return;
    const column = Array.from(table.querySelectorAll("col")).find((col)=>col.dataset.columnIndex === String(columnIndex));
    if (column) column.style.width = `${width}px`;
    const tableWidth = Array.from(table.querySelectorAll("col")).reduce((sum, col)=>{
        const parsed = Number.parseFloat(col.style.width);
        return sum + (Number.isFinite(parsed) ? parsed : 0);
    }, 0);
    if (tableWidth > 0) {
        table.style.width = `${Math.round(tableWidth)}px`;
        $08414ea58bdc1292$var$resetSheetTableZoomLock(table);
    }
}
function $08414ea58bdc1292$var$createSheetMergePlan(merges, rowStart, rowEnd, columnStart, columnEnd) {
    const anchors = /* @__PURE__ */ new Map();
    const covered = /* @__PURE__ */ new Set();
    const encode = (row, column)=>`${row}:${column}`;
    for (const merge of merges){
        if (merge.e.r < rowStart || merge.s.r > rowEnd || merge.e.c < columnStart || merge.s.c > columnEnd) continue;
        const visibleStartRow = Math.max(merge.s.r, rowStart);
        const visibleEndRow = Math.min(merge.e.r, rowEnd);
        const visibleStartColumn = Math.max(merge.s.c, columnStart);
        const visibleEndColumn = Math.min(merge.e.c, columnEnd);
        const anchor = encode(visibleStartRow, visibleStartColumn);
        anchors.set(anchor, {
            rowspan: visibleEndRow - visibleStartRow + 1,
            colspan: visibleEndColumn - visibleStartColumn + 1,
            sourceRow: merge.s.r,
            sourceColumn: merge.s.c
        });
        for(let rowIndex = visibleStartRow; rowIndex <= visibleEndRow; rowIndex += 1)for(let columnIndex = visibleStartColumn; columnIndex <= visibleEndColumn; columnIndex += 1){
            const address = encode(rowIndex, columnIndex);
            if (address !== anchor) covered.add(address);
        }
    }
    return {
        anchors: anchors,
        covered: covered
    };
}
function $08414ea58bdc1292$var$groupWorkbookImagesByCell(images) {
    const grouped = /* @__PURE__ */ new Map();
    for (const image of images){
        const key = `${image.row}:${image.column}`;
        const items = grouped.get(key) || [];
        items.push(image);
        grouped.set(key, items);
    }
    return grouped;
}
function $08414ea58bdc1292$var$hasWorkbookCellHtmlRichText(sourceCell) {
    return typeof sourceCell?.h === "string" && /<(?:span|b|strong|i|em|u|s|font)\b/i.test(sourceCell.h);
}
function $08414ea58bdc1292$var$appendWorkbookCellHtmlRichText(cell, html) {
    cell.classList.add("ofv-cell-rich-text");
    cell.innerHTML = $08414ea58bdc1292$var$sanitizeWorkbookCellHtmlRichText(html);
    $08414ea58bdc1292$var$normalizeWorkbookCellHtmlRichText(cell);
}
function $08414ea58bdc1292$var$sanitizeWorkbookCellHtmlRichText(html) {
    return (0, $hIrjg.default).sanitize(html, {
        USE_PROFILES: {
            html: true
        },
        ALLOWED_TAGS: [
            "span",
            "b",
            "strong",
            "i",
            "em",
            "u",
            "s",
            "font",
            "br"
        ],
        ALLOWED_ATTR: [
            "style",
            "color"
        ],
        ALLOW_DATA_ATTR: false
    });
}
function $08414ea58bdc1292$var$normalizeWorkbookCellHtmlRichText(cell) {
    for (const element of Array.from(cell.querySelectorAll("span, b, strong, i, em, u, s, font"))){
        element.classList.add("ofv-rich-text-run");
        if (element instanceof HTMLFontElement && element.color) {
            element.style.color = element.color;
            element.removeAttribute("color");
        }
    }
}
function $08414ea58bdc1292$var$appendWorkbookCellRichText(cell, runs) {
    cell.classList.add("ofv-cell-rich-text");
    for (const run of runs){
        const span = document.createElement("span");
        span.className = "ofv-rich-text-run";
        span.textContent = run.text;
        if (run.bold) span.style.fontWeight = "700";
        if (run.italic) span.style.fontStyle = "italic";
        if (run.underline || run.strike) span.style.textDecoration = [
            run.underline ? "underline" : "",
            run.strike ? "line-through" : ""
        ].filter(Boolean).join(" ");
        if (run.color) span.style.color = $08414ea58bdc1292$var$readableSheetInk(run.color);
        if (run.fontSize) span.style.fontSize = `${Math.max(9, Math.min(24, run.fontSize))}pt`;
        cell.append(span);
    }
}
function $08414ea58bdc1292$var$appendWorkbookCellImages(cell, images, text) {
    if (!images?.length) return;
    if ($08414ea58bdc1292$var$isWorkbookImagePlaceholderValue(text)) {
        cell.textContent = "";
        cell.removeAttribute("title");
    }
    cell.classList.add("ofv-cell-image");
    for (const image of images){
        const figure = document.createElement("figure");
        figure.className = "ofv-workbook-image";
        const element = document.createElement("img");
        element.src = image.dataUrl;
        element.alt = image.title || image.fileName || "Excel embedded image";
        element.loading = "lazy";
        figure.append(element);
        cell.append(figure);
    }
}
function $08414ea58bdc1292$var$isWorkbookImagePlaceholderValue(text) {
    return /^#(?:VALUE|NAME|REF|N\/A|NULL|NUM|DIV\/0)!?$/i.test(text.trim());
}
function $08414ea58bdc1292$var$isWorkbookNumericCell(sourceCell) {
    return sourceCell?.t === "n";
}
function $08414ea58bdc1292$var$getSheetColumnWidth(column) {
    if (column?.hidden) return 0;
    const mdw = Number.isFinite(column?.MDW) && column?.MDW ? column.MDW : 7;
    const width = column?.wpx || (column?.wch ? column.wch * mdw + 5 : void 0) || (column?.width ? column.width * mdw : void 0) || 96;
    return Math.max(28, Math.min(960, Math.round(width)));
}
function $08414ea58bdc1292$var$findExcelColumnMdw(width) {
    const defaultMdw = 6;
    let bestMdw = defaultMdw;
    let bestDelta = Math.abs(width - $08414ea58bdc1292$var$cycleExcelColumnWidth(width, defaultMdw));
    if (bestDelta <= 5e-3) return bestMdw;
    for(let mdw = 1; mdw < 15; mdw += 1){
        const delta = Math.abs(width - $08414ea58bdc1292$var$cycleExcelColumnWidth(width, mdw));
        if (delta <= bestDelta) {
            bestDelta = delta;
            bestMdw = mdw;
        }
    }
    return bestMdw;
}
function $08414ea58bdc1292$var$cycleExcelColumnWidth(width, mdw) {
    const px = Math.floor((width + Math.round(128 / mdw) / 256) * mdw);
    const chars = Math.floor((px - 5) / mdw * 100 + 0.5) / 100;
    return Math.round((chars * mdw + 5) / mdw * 256) / 256;
}
function $08414ea58bdc1292$var$getSheetRowHeight(row) {
    if (row?.hidden) return 0;
    const height = row?.hpx || (row?.hpt ? row.hpt * 1.333 : void 0);
    return height ? Math.max(18, Math.min(260, Math.round(height))) : void 0;
}
function $08414ea58bdc1292$var$applyWorkbookCellStyle(cell, sourceCell, sourceStyleMetadata) {
    const style = sourceCell?.s;
    const sourceFont = sourceStyleMetadata?.font || style?.font;
    const wrapText = sourceStyleMetadata?.wrapText || Boolean(style?.alignment?.wrapText);
    if (!style && !sourceFont && !wrapText) return;
    const parsedFill = $08414ea58bdc1292$var$readWorkbookColor(style?.fgColor || style?.fill?.fgColor);
    const fill = style?.patternType === "none" ? void 0 : parsedFill;
    if (fill) cell.style.backgroundColor = fill;
    const fontColor = sourceFont ? $08414ea58bdc1292$var$readWorkbookColor(sourceFont.color) : void 0;
    if (sourceFont) {
        if (sourceFont.bold) cell.style.fontWeight = "700";
        if (sourceFont.italic) cell.style.fontStyle = "italic";
        if (sourceFont.underline || sourceFont.strike) cell.style.textDecoration = [
            sourceFont.underline ? "underline" : "",
            sourceFont.strike ? "line-through" : ""
        ].filter(Boolean).join(" ");
        if (sourceFont.sz) cell.style.fontSize = `${Math.max(9, Math.min(24, Number(sourceFont.sz)))}pt`;
    }
    $08414ea58bdc1292$var$applyWorkbookCellInk(cell, fill, fontColor);
    const alignment = style?.alignment;
    if (alignment) {
        const horizontal = $08414ea58bdc1292$var$normalizeSheetHorizontalAlign(alignment.horizontal);
        if (horizontal) cell.style.textAlign = horizontal;
        const vertical = $08414ea58bdc1292$var$normalizeSheetVerticalAlign(alignment.vertical);
        if (vertical) cell.style.verticalAlign = vertical;
    }
    if (wrapText) cell.classList.add("ofv-cell-multiline");
}
function $08414ea58bdc1292$var$readWorkbookColor(color) {
    if (!color?.rgb) return void 0;
    const rgb = color.rgb.length === 8 ? color.rgb.slice(2) : color.rgb;
    return /^[\da-f]{6}$/i.test(rgb) ? `#${rgb}` : void 0;
}
function $08414ea58bdc1292$var$parseOptionalInteger(value) {
    const parsed = Number.parseInt(value || "", 10);
    return Number.isFinite(parsed) ? parsed : void 0;
}
function $08414ea58bdc1292$var$applyWorkbookCellInk(cell, fill, fontColor) {
    if (fill) {
        cell.style.color = fontColor ?? ($08414ea58bdc1292$var$sheetColorLuminance(fill) < 0.42 ? "#f8fafc" : "#1f2937");
        return;
    }
    if (fontColor) cell.style.color = $08414ea58bdc1292$var$readableSheetInk(fontColor);
}
function $08414ea58bdc1292$var$sheetColorLuminance(hex) {
    const channels = [
        hex.slice(1, 3),
        hex.slice(3, 5),
        hex.slice(5, 7)
    ].map((part)=>{
        const value = parseInt(part, 16) / 255;
        return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}
function $08414ea58bdc1292$var$readableSheetInk(hex) {
    const luminance = $08414ea58bdc1292$var$sheetColorLuminance(hex);
    if (luminance <= 0.62) return hex;
    const [h, s, l] = $08414ea58bdc1292$var$sheetHexToHsl(hex);
    return $08414ea58bdc1292$var$sheetHslToHex(h, s, Math.min(l, 0.42));
}
function $08414ea58bdc1292$var$sheetHexToHsl(hex) {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) return [
        0,
        0,
        l
    ];
    const d = max - min;
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    let h;
    if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
    else if (max === g) h = ((b - r) / d + 2) / 6;
    else h = ((r - g) / d + 4) / 6;
    return [
        h,
        s,
        l
    ];
}
function $08414ea58bdc1292$var$sheetHslToHex(h, s, l) {
    const hueToChannel = (p, q, t)=>{
        let value = t;
        if (value < 0) value += 1;
        if (value > 1) value -= 1;
        if (value < 1 / 6) return p + (q - p) * 6 * value;
        if (value < 0.5) return q;
        if (value < 2 / 3) return p + (q - p) * (2 / 3 - value) * 6;
        return p;
    };
    let r;
    let g;
    let b;
    if (s === 0) r = g = b = l;
    else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hueToChannel(p, q, h + 1 / 3);
        g = hueToChannel(p, q, h);
        b = hueToChannel(p, q, h - 1 / 3);
    }
    const toHex = (value)=>Math.round(value * 255).toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
function $08414ea58bdc1292$var$normalizeSheetHorizontalAlign(value) {
    if (value === "center" || value === "right" || value === "left" || value === "justify") return value;
    return void 0;
}
function $08414ea58bdc1292$var$normalizeSheetVerticalAlign(value) {
    if (value === "top" || value === "middle" || value === "bottom") return value;
    return void 0;
}
function $08414ea58bdc1292$var$createParsedSheetTable(sheet, sheetIndex, viewport, columnSizing, rerender) {
    const table = document.createElement("table");
    table.id = `ofv-sheet-${sheetIndex + 1}`;
    const formulaMap = new Map(sheet.formulas.map((item)=>[
            item.address,
            item.formula
        ]));
    const rowEnd = Math.min(viewport.rowStart + $08414ea58bdc1292$var$SHEET_WINDOW_ROWS, sheet.rows.length);
    const columnEnd = Math.min(viewport.columnStart + $08414ea58bdc1292$var$SHEET_WINDOW_COLUMNS, viewport.columnCount);
    const colGroup = document.createElement("colgroup");
    let tableWidth = 0;
    for(let columnIndex = viewport.columnStart; columnIndex < columnEnd; columnIndex += 1){
        const width = columnSizing.widths.get(columnIndex) ?? 112;
        const col = document.createElement("col");
        col.dataset.columnIndex = String(columnIndex);
        col.style.width = `${width}px`;
        tableWidth += width;
        colGroup.append(col);
    }
    table.style.width = `${tableWidth}px`;
    table.append(colGroup);
    for(let rowIndex = viewport.rowStart; rowIndex < rowEnd; rowIndex += 1){
        const sourceRow = sheet.rows[rowIndex] || [];
        const row = document.createElement("tr");
        for(let columnIndex = viewport.columnStart; columnIndex < columnEnd; columnIndex += 1){
            const value = sourceRow[columnIndex] || "";
            const cell = document.createElement(rowIndex === 0 ? "th" : "td");
            const address = $08414ea58bdc1292$var$encodeA1(rowIndex, columnIndex);
            cell.dataset.cell = address;
            cell.textContent = value;
            if (value) cell.title = value;
            const formula = formulaMap.get(address);
            if (formula) {
                cell.classList.add("ofv-cell-formula");
                cell.title = formula;
            }
            if (value.includes("\n")) cell.classList.add("ofv-cell-multiline");
            if (rowIndex === viewport.rowStart) $08414ea58bdc1292$var$appendColumnResizeHandle(cell, columnIndex, columnSizing);
            row.append(cell);
        }
        table.append(row);
    }
    return table;
}
function $08414ea58bdc1292$var$parseFlatOds(xml) {
    const documentXml = new DOMParser().parseFromString(xml, "application/xml");
    if (documentXml.querySelector("parsererror")) return [];
    return Array.from(documentXml.getElementsByTagName("*")).filter((element)=>element.localName === "table").map((tableElement, tableIndex)=>$08414ea58bdc1292$var$parseFlatOdsTable(tableElement, tableIndex)).filter((sheet)=>sheet.rows.length > 0);
}
function $08414ea58bdc1292$var$parseFlatOdsTable(tableElement, tableIndex) {
    const rows = [];
    const formulas = [];
    const sheetName = $08414ea58bdc1292$var$getXmlAttribute3(tableElement, "name") || `Sheet ${tableIndex + 1}`;
    for (const rowElement of Array.from(tableElement.children).filter((element)=>element.localName === "table-row")){
        const repeatRows = $08414ea58bdc1292$var$clampRepeat($08414ea58bdc1292$var$getXmlAttribute3(rowElement, "number-rows-repeated"), 200);
        const parsedRow = $08414ea58bdc1292$var$parseFlatOdsRow(rowElement, rows.length, formulas);
        for(let index = 0; index < repeatRows; index += 1)rows.push([
            ...parsedRow
        ]);
    }
    $08414ea58bdc1292$var$trimEmptyTrailingRows(rows);
    return {
        name: sheetName,
        rows: rows,
        formulas: formulas
    };
}
function $08414ea58bdc1292$var$parseFlatOdsRow(rowElement, rowIndex, formulas) {
    const row = [];
    for (const cellElement of Array.from(rowElement.children).filter((element)=>element.localName === "table-cell" || element.localName === "covered-table-cell")){
        const repeatColumns = $08414ea58bdc1292$var$clampRepeat($08414ea58bdc1292$var$getXmlAttribute3(cellElement, "number-columns-repeated"), 256);
        const value = $08414ea58bdc1292$var$extractFlatOdsCellValue(cellElement);
        const formula = $08414ea58bdc1292$var$getXmlAttribute3(cellElement, "formula");
        for(let index = 0; index < repeatColumns; index += 1){
            const columnIndex = row.length;
            row.push(value);
            if (formula) formulas.push({
                address: $08414ea58bdc1292$var$encodeA1(rowIndex, columnIndex),
                formula: formula
            });
        }
    }
    $08414ea58bdc1292$var$trimEmptyTrailingCells(row);
    return row;
}
function $08414ea58bdc1292$var$extractFlatOdsCellValue(cellElement) {
    const text = $08414ea58bdc1292$var$extractOpenDocumentTextFromElement(cellElement);
    if (text) return text;
    return $08414ea58bdc1292$var$getXmlAttribute3(cellElement, "value") || $08414ea58bdc1292$var$getXmlAttribute3(cellElement, "date-value") || $08414ea58bdc1292$var$getXmlAttribute3(cellElement, "time-value") || $08414ea58bdc1292$var$getXmlAttribute3(cellElement, "boolean-value") || "";
}
function $08414ea58bdc1292$var$extractOpenDocumentTextFromElement(element) {
    const fragments = [];
    const visit = (node)=>{
        if (node.nodeType === Node.TEXT_NODE) {
            fragments.push(node.textContent || "");
            return;
        }
        if (!(node instanceof Element)) return;
        if (node.localName === "s") {
            fragments.push(" ".repeat($08414ea58bdc1292$var$clampRepeat($08414ea58bdc1292$var$getXmlAttribute3(node, "c"), 64)));
            return;
        }
        if (node.localName === "tab") {
            fragments.push("	");
            return;
        }
        if (node.localName === "line-break") {
            fragments.push("\n");
            return;
        }
        for (const child of Array.from(node.childNodes))visit(child);
        if (node.localName === "p" || node.localName === "h") fragments.push("\n");
    };
    visit(element);
    return fragments.join("").replace(/\n+$/g, "").trim();
}
function $08414ea58bdc1292$var$getXmlAttribute3(element, localName) {
    const direct = element.getAttribute(localName);
    if (direct !== null) return direct;
    for (const attribute of Array.from(element.attributes)){
        if (attribute.localName === localName) return attribute.value;
    }
    return null;
}
function $08414ea58bdc1292$var$clampRepeat(value, max) {
    const parsed = value ? Number.parseInt(value, 10) : 1;
    if (!Number.isFinite(parsed) || parsed < 1) return 1;
    return Math.min(parsed, max);
}
function $08414ea58bdc1292$var$trimEmptyTrailingRows(rows) {
    while(rows.length > 0 && rows[rows.length - 1].every((cell)=>cell === ""))rows.pop();
}
function $08414ea58bdc1292$var$trimEmptyTrailingCells(row) {
    while(row.length > 0 && row[row.length - 1] === "")row.pop();
}
function $08414ea58bdc1292$var$collectFormulaRows(sheet, range, encodeCell) {
    const formulas = [];
    for(let row = range.s.r; row <= range.e.r; row += 1)for(let column = range.s.c; column <= range.e.c; column += 1){
        const address = encodeCell({
            r: row,
            c: column
        });
        const cell = sheet[address];
        if (cell?.f) formulas.push({
            address: address,
            formula: `=${cell.f}`
        });
    }
    return formulas;
}
function $08414ea58bdc1292$var$encodeA1(rowIndex, columnIndex) {
    let column = "";
    let value = columnIndex + 1;
    while(value > 0){
        const remainder = (value - 1) % 26;
        column = String.fromCharCode(65 + remainder) + column;
        value = Math.floor((value - 1) / 26);
    }
    return `${column}${rowIndex + 1}`;
}

async function $08414ea58bdc1292$var$renderPptx(panel, arrayBuffer) {
    const container = document.createElement("div");
    container.className = "ofv-pptx-viewer";
    let insight;
    let zip;
    let renderBuffer = arrayBuffer;
    let placeholderFontCorrections = [];
    let autofitLineHeightCorrections = [];
    let shapeFillCorrections = [];
    let autoNumberingCorrections = [];
    let autofitWrapCorrections = [];
    let textAlignmentCorrections = [];
    let imageClipCorrections = [];
    let transparentChartCorrections = [];
    try {
        zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
        insight = await $08414ea58bdc1292$var$inspectPptxPresentation(zip);
        await $08414ea58bdc1292$var$renderPresentationInsight(panel, insight);
    } catch (error) {
        console.warn("PPTX structure insight extraction failed:", error);
    }
    if (zip) {
        try {
            placeholderFontCorrections = await $08414ea58bdc1292$var$inspectPptxPlaceholderFontCorrections(zip);
        } catch (error) {
            console.warn("PPTX placeholder font extraction failed:", error);
        }
        try {
            autofitLineHeightCorrections = await $08414ea58bdc1292$var$inspectPptxAutofitLineHeightCorrections(zip);
        } catch (error) {
            console.warn("PPTX autofit line-height extraction failed:", error);
        }
        try {
            ({ shapeFillCorrections: shapeFillCorrections, autoNumberingCorrections: autoNumberingCorrections, autofitWrapCorrections: autofitWrapCorrections, textAlignmentCorrections: textAlignmentCorrections, imageClipCorrections: imageClipCorrections, transparentChartCorrections: transparentChartCorrections } = await $08414ea58bdc1292$var$inspectPptxVisualCorrections(zip));
        } catch (error) {
            console.warn("PPTX visual correction extraction failed:", error);
        }
        try {
            renderBuffer = await $08414ea58bdc1292$var$preparePptxRenderBuffer(zip) || arrayBuffer;
        } catch (error) {
            console.warn("PPTX media normalization failed:", error);
        }
    }
    panel.append(container);
    try {
        const { PptxViewer: PptxViewer } = await (parcelRequire("l9uiP"));
        let scrollAnchor;
        let scroller = $08414ea58bdc1292$var$getPresentationScroller(panel);
        const pages = ()=>Array.from(container.querySelectorAll(":scope > div[data-slide-index]"));
        const pptxViewer = await $08414ea58bdc1292$var$withTimeout(PptxViewer.open(renderBuffer, container, {
            scrollContainer: scroller,
            onRenderStart () {
                scroller = $08414ea58bdc1292$var$getPresentationScroller(panel);
                scrollAnchor = (0, $3438a2478d5b847f$export$449ea97f0d46522e)(scroller, pages());
            },
            onRenderComplete () {
                $08414ea58bdc1292$var$normalizePptxLayout(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections);
                panel.dispatchEvent(new CustomEvent("ofv-pptx-render-complete"));
                (0, $3438a2478d5b847f$export$c0bc1c93b9d1d8ba)(scroller, pages(), scrollAnchor);
                scrollAnchor = void 0;
            }
        }), $08414ea58bdc1292$var$pptxRenderTimeoutMs());
        $08414ea58bdc1292$var$schedulePptxLayoutNormalization(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections);
        return ()=>pptxViewer?.destroy();
    } catch (error) {
        container.replaceChildren();
        if (insight) {
            $08414ea58bdc1292$var$renderPptxTextFallback(container, insight);
            return;
        }
        if (zip) {
            $08414ea58bdc1292$var$renderPptxTextFallback(container, await $08414ea58bdc1292$var$inspectPptxPresentation(zip));
            return;
        }
        container.textContent = error instanceof Error && error.message.includes("timed out") ? "PPTX \u6E32\u67D3\u8D85\u65F6\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u6216\u8F6C\u6362\u4E3A PDF \u540E\u9884\u89C8\u3002" : "PPTX \u6E32\u67D3\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u6587\u4EF6\u662F\u5426\u635F\u574F\u3002";
    }
}
var $08414ea58bdc1292$var$OFFICE_RELATIONSHIPS_NAMESPACE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
async function $08414ea58bdc1292$var$preparePptxRenderBuffer(zip) {
    const promotedSvgImages = await $08414ea58bdc1292$var$promotePptxSvgImages(zip);
    const convertedTiffBuffer = await $08414ea58bdc1292$var$convertPptxTiffImages(zip);
    if (convertedTiffBuffer) return convertedTiffBuffer;
    return promotedSvgImages ? zip.generateAsync({
        type: "arraybuffer"
    }) : void 0;
}
async function $08414ea58bdc1292$var$promotePptxSvgImages(zip) {
    const xmlEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/.+\.xml$/i.test(entry.name));
    let promoted = false;
    for (const entry of xmlEntries){
        const xml = await entry.async("text");
        if (!xml.includes("svgBlip")) continue;
        const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
        if (!document2) continue;
        let changed = false;
        const blips = Array.from(document2.getElementsByTagName("*")).filter((element)=>element.localName === "blip");
        for (const blip of blips){
            if ($08414ea58bdc1292$var$getXmlAttribute3(blip, "embed")) continue;
            const svgBlip = Array.from(blip.getElementsByTagName("*")).find((element)=>element.localName === "svgBlip");
            const relationshipId = svgBlip ? $08414ea58bdc1292$var$getXmlAttribute3(svgBlip, "embed") : void 0;
            if (!relationshipId) continue;
            blip.setAttributeNS($08414ea58bdc1292$var$OFFICE_RELATIONSHIPS_NAMESPACE, "r:embed", relationshipId);
            changed = true;
        }
        if (changed) {
            zip.file(entry.name, new XMLSerializer().serializeToString(document2));
            promoted = true;
        }
    }
    return promoted;
}

async function $08414ea58bdc1292$var$convertPptxTiffImages(zip) {
    const tiffEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/media\/.+\.tiff?$/i.test(entry.name));
    if (tiffEntries.length === 0) return void 0;
    const UTIF = await (parcelRequire("bZCt6"));
    const occupiedPaths = new Set(Object.keys(zip.files).map((path)=>path.toLowerCase()));
    const replacements = /* @__PURE__ */ new Map();
    for (const entry of tiffEntries){
        const bytes = await entry.async("uint8array");
        const sourceBuffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
        const ifd = UTIF.decode(sourceBuffer).find((candidate)=>{
            const width2 = Number(candidate.width || candidate.t256 || 0);
            const height2 = Number(candidate.height || candidate.t257 || 0);
            return width2 > 0 && height2 > 0;
        });
        if (!ifd) continue;
        UTIF.decodeImage(sourceBuffer, ifd);
        const rgba = UTIF.toRGBA8(ifd);
        const width = Number(ifd.width || ifd.t256 || 0);
        const height = Number(ifd.height || ifd.t257 || 0);
        if (!(width > 0) || !(height > 0) || rgba.length < width * height * 4) continue;
        const pngBytes = await $08414ea58bdc1292$var$encodeRgbaAsPng(rgba, width, height);
        const pngPath = $08414ea58bdc1292$var$nextPptxPngPath(entry.name, occupiedPaths);
        zip.file(pngPath, pngBytes);
        zip.remove(entry.name);
        occupiedPaths.add(pngPath.toLowerCase());
        replacements.set(entry.name.split("/").pop().toLowerCase(), pngPath.split("/").pop());
    }
    if (replacements.size === 0) return void 0;
    await $08414ea58bdc1292$var$rewritePptxImageRelationships(zip, replacements);
    await $08414ea58bdc1292$var$ensurePptxPngContentType(zip);
    return zip.generateAsync({
        type: "arraybuffer"
    });
}
function $08414ea58bdc1292$var$nextPptxPngPath(tiffPath, occupiedPaths) {
    const preferred = tiffPath.replace(/\.tiff?$/i, ".png");
    if (!occupiedPaths.has(preferred.toLowerCase())) return preferred;
    const base = preferred.replace(/\.png$/i, "");
    let suffix = 1;
    while(occupiedPaths.has(`${base}-ofv-${suffix}.png`.toLowerCase()))suffix += 1;
    return `${base}-ofv-${suffix}.png`;
}
async function $08414ea58bdc1292$var$encodeRgbaAsPng(rgba, width, height) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Canvas 2D is unavailable for embedded TIFF conversion.");
    const imageData = context.createImageData(width, height);
    imageData.data.set(rgba);
    context.putImageData(imageData, 0, 0);
    const blob = await new Promise((resolve, reject)=>{
        canvas.toBlob((result)=>{
            if (result) resolve(result);
            else reject(new Error("The embedded TIFF image could not be encoded as PNG."));
        }, "image/png");
    });
    return new Uint8Array(await blob.arrayBuffer());
}
async function $08414ea58bdc1292$var$rewritePptxImageRelationships(zip, replacements) {
    const relationshipEntries = Object.values(zip.files).filter((entry)=>!entry.dir && entry.name.toLowerCase().endsWith(".rels"));
    for (const entry of relationshipEntries){
        const xml = await entry.async("text");
        const document2 = $08414ea58bdc1292$var$parseOfficeXml(xml);
        if (!document2) continue;
        let changed = false;
        for (const relationship of Array.from(document2.getElementsByTagName("*"))){
            if (relationship.localName !== "Relationship") continue;
            const target = relationship.getAttribute("Target") || "";
            const segments = target.split("/");
            const replacement = replacements.get((segments.at(-1) || "").toLowerCase());
            if (!replacement) continue;
            segments[segments.length - 1] = replacement;
            relationship.setAttribute("Target", segments.join("/"));
            changed = true;
        }
        if (changed) zip.file(entry.name, new XMLSerializer().serializeToString(document2));
    }
}
async function $08414ea58bdc1292$var$ensurePptxPngContentType(zip) {
    const entry = Object.values(zip.files).find((candidate)=>!candidate.dir && candidate.name.toLowerCase() === "[content_types].xml");
    if (!entry) return;
    const document2 = $08414ea58bdc1292$var$parseOfficeXml(await entry.async("text"));
    const root = document2?.documentElement;
    if (!document2 || !root) return;
    const hasPng = Array.from(root.children).some((element)=>element.localName === "Default" && element.getAttribute("Extension")?.toLowerCase() === "png");
    if (hasPng) return;
    const defaultType = document2.createElementNS(root.namespaceURI, "Default");
    defaultType.setAttribute("Extension", "png");
    defaultType.setAttribute("ContentType", "image/png");
    root.append(defaultType);
    zip.file(entry.name, new XMLSerializer().serializeToString(document2));
}
function $08414ea58bdc1292$var$renderPptxTextFallback(container, insight) {
    container.classList.add("ofv-presentation-slides");
    const slides = insight.slides.length > 0 ? insight.slides : [
        {
            title: "PPTX",
            textCount: 0,
            imageCount: 0,
            notesCount: 0,
            hasTransition: false,
            animationCount: 0,
            sampleTexts: []
        }
    ];
    for (const [index, slide] of slides.entries()){
        const article = document.createElement("article");
        article.className = "ofv-slide";
        article.dataset.slideIndex = String(index);
        const title = document.createElement("h4");
        title.textContent = slide.title || `Slide ${index + 1}`;
        article.append(title);
        const bodyTexts = slide.sampleTexts.length > 0 ? slide.sampleTexts : [
            "\u8BE5\u9875\u6CA1\u6709\u53EF\u63D0\u53D6\u6587\u672C\u3002"
        ];
        for (const text of bodyTexts){
            const paragraph = document.createElement("p");
            paragraph.textContent = text;
            article.append(paragraph);
        }
        container.append(article);
    }
}
async function $08414ea58bdc1292$var$withTimeout(promise, timeoutMs, label = "PPTX rendering") {
    let timeoutId;
    try {
        return await Promise.race([
            promise,
            new Promise((_resolve, reject)=>{
                timeoutId = window.setTimeout(()=>reject(new Error(`${label} timed out after ${timeoutMs}ms.`)), timeoutMs);
            })
        ]);
    } finally{
        if (timeoutId !== void 0) window.clearTimeout(timeoutId);
    }
}
function $08414ea58bdc1292$var$pptxRenderTimeoutMs() {
    const override = globalThis.__OFV_PPTX_RENDER_TIMEOUT_MS__;
    return typeof override === "number" && override > 0 ? override : $08414ea58bdc1292$var$DEFAULT_PPTX_RENDER_TIMEOUT_MS;
}
function $08414ea58bdc1292$var$normalizePptxLayout(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections) {
    const slideCanvases = $08414ea58bdc1292$var$findPptxSlideCanvases(container);
    for (const slide of slideCanvases)if (!$08414ea58bdc1292$var$hasInlineBackground(slide)) slide.style.backgroundColor = "#FFFFFF";
    $08414ea58bdc1292$var$normalizePptxPlaceholderFonts(container, placeholderFontCorrections);
    $08414ea58bdc1292$var$normalizePptxAutofitLineHeights(container, autofitLineHeightCorrections);
    $08414ea58bdc1292$var$normalizePptxShapeFills(container, shapeFillCorrections);
    $08414ea58bdc1292$var$normalizePptxAutoNumbering(container, autoNumberingCorrections);
    $08414ea58bdc1292$var$normalizePptxAutofitWrapping(container, autofitWrapCorrections);
    $08414ea58bdc1292$var$normalizePptxTextAlignment(container, textAlignmentCorrections);
    $08414ea58bdc1292$var$normalizePptxImageClips(container, imageClipCorrections);
    $08414ea58bdc1292$var$normalizePptxTransparentCharts(container, transparentChartCorrections);
    $08414ea58bdc1292$var$normalizePptxSlideNumbers(container);
    $08414ea58bdc1292$var$normalizePptxCircleCalloutText(container);
    $08414ea58bdc1292$var$normalizePptxDiagramCycleText(container);
    $08414ea58bdc1292$var$normalizePptxMirroredText(container);
}
function $08414ea58bdc1292$var$schedulePptxLayoutNormalization(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections) {
    $08414ea58bdc1292$var$normalizePptxLayout(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections);
    let observer;
    if (typeof MutationObserver !== "undefined") {
        observer = new MutationObserver(()=>$08414ea58bdc1292$var$normalizePptxLayout(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections));
        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }
    for (const delay of [
        0,
        100,
        500,
        1500,
        3e3
    ])window.setTimeout(()=>{
        if (container.isConnected) $08414ea58bdc1292$var$normalizePptxLayout(container, placeholderFontCorrections, autofitLineHeightCorrections, shapeFillCorrections, autoNumberingCorrections, autofitWrapCorrections, textAlignmentCorrections, imageClipCorrections, transparentChartCorrections);
    }, delay);
    window.setTimeout(()=>observer?.disconnect(), 5e3);
}
var $08414ea58bdc1292$var$pptxClipPathSequence = 0;
function $08414ea58bdc1292$var$normalizePptxImageClips(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        const match = wrapper ? $08414ea58bdc1292$var$findPptxGeometryElement(wrapper, correction, (element)=>Array.from(element.children).some((child)=>child instanceof HTMLImageElement)) : void 0;
        if (!match || match.dataset.ofvPptxImageClip === "true") continue;
        const clipId = `ofv-pptx-image-clip-${$08414ea58bdc1292$var$pptxClipPathSequence++}`;
        const definitions = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        definitions.setAttribute("width", "0");
        definitions.setAttribute("height", "0");
        definitions.setAttribute("aria-hidden", "true");
        definitions.dataset.ofvPptxClipDefinitions = "true";
        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
        const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
        clipPath.id = clipId;
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        for (const pathData of correction.paths){
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("d", pathData);
            clipPath.append(path);
        }
        defs.append(clipPath);
        definitions.append(defs);
        match.append(definitions);
        const clipReference = `url("#${clipId}")`;
        match.style.clipPath = clipReference;
        match.style.setProperty("-webkit-clip-path", clipReference);
        match.dataset.ofvPptxImageClip = "true";
    }
}
function $08414ea58bdc1292$var$normalizePptxTransparentCharts(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        const match = wrapper ? $08414ea58bdc1292$var$findPptxGeometryElement(wrapper, correction, (element)=>Boolean(element.querySelector("[_echarts_instance_]"))) : void 0;
        if (!match) continue;
        for (const element of [
            match,
            ...Array.from(match.querySelectorAll("div"))
        ]){
            const background = element.style.backgroundColor.replace(/\s+/g, "").toLowerCase();
            if (background === "white" || background === "#fff" || background === "#ffffff" || background === "rgb(255,255,255)") element.style.backgroundColor = "transparent";
        }
        match.dataset.ofvPptxTransparentChart = "true";
    }
}
function $08414ea58bdc1292$var$normalizePptxShapeFills(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        if (!wrapper) continue;
        const match = $08414ea58bdc1292$var$findPptxGeometryElement(wrapper, correction, (element)=>Boolean(element.querySelector("svg path")));
        if (!match) continue;
        const emptyPaths = Array.from(match.querySelectorAll("svg path")).filter((path)=>{
            const fill = path.getAttribute("fill")?.trim().toLowerCase();
            return !fill || fill === "none" || fill === "transparent";
        });
        if (emptyPaths.length === 0) continue;
        for (const path of emptyPaths)path.setAttribute("fill", correction.color);
        match.dataset.ofvPptxShapeFill = correction.color;
    }
}
function $08414ea58bdc1292$var$normalizePptxAutoNumbering(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        const match = wrapper ? $08414ea58bdc1292$var$findPptxShapeElement(wrapper, correction) : void 0;
        if (!match) continue;
        const paragraphs = Array.from(match.querySelectorAll("div")).filter((element)=>{
            const children = Array.from(element.children);
            return children.length > 1 && children.every((child)=>child.tagName === "SPAN");
        });
        const unused = new Set(paragraphs);
        for (const item of correction.items){
            const expectedText = $08414ea58bdc1292$var$normalizePptxParagraphText(item.text);
            const paragraph = Array.from(unused).find((candidate)=>$08414ea58bdc1292$var$normalizePptxParagraphText(candidate.textContent || "").endsWith(expectedText));
            if (!paragraph) continue;
            const firstSpan = paragraph.querySelector(":scope > span");
            const firstText = $08414ea58bdc1292$var$normalizePptxParagraphText(firstSpan?.textContent || "");
            if (!firstSpan || !firstText || expectedText.startsWith(firstText) || firstSpan.dataset.ofvPptxAutoNumber === item.label) continue;
            firstSpan.textContent = `${item.label} `;
            firstSpan.dataset.ofvPptxAutoNumber = item.label;
            unused.delete(paragraph);
        }
    }
}
function $08414ea58bdc1292$var$normalizePptxAutofitWrapping(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        if (!wrapper) continue;
        const paragraphs = Array.from(wrapper.querySelectorAll("div")).filter((element)=>{
            const children = Array.from(element.children);
            return children.length > 0 && children.every((child)=>child.tagName === "SPAN") && $08414ea58bdc1292$var$normalizePptxParagraphText(element.textContent || "") === correction.text;
        });
        for (const paragraph of paragraphs){
            paragraph.style.whiteSpace = correction.wrap ? "normal" : "nowrap";
            paragraph.style.overflowWrap = "normal";
            paragraph.style.wordBreak = "normal";
            paragraph.style.maxWidth = correction.wrap ? "100%" : "none";
            paragraph.dataset.ofvPptxAutofitWrap = correction.wrap ? "wrap" : "nowrap";
        }
    }
}
function $08414ea58bdc1292$var$normalizePptxTextAlignment(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        if (!wrapper) continue;
        const shapeText = correction.paragraphs.map((paragraph)=>paragraph.text).join("");
        const shape = Array.from(wrapper.querySelectorAll("div")).find((element)=>element.style.position === "absolute" && $08414ea58bdc1292$var$normalizePptxParagraphText(element.textContent || "") === shapeText && element.querySelector("span"));
        const paragraphElements = Array.from((shape || wrapper).querySelectorAll("div")).filter((element)=>{
            const children = Array.from(element.children);
            return children.length > 0 && children.every((child)=>child.tagName === "SPAN");
        });
        const unused = new Set(paragraphElements);
        for (const paragraph of correction.paragraphs){
            const match = Array.from(unused).find((element)=>{
                const renderedText = $08414ea58bdc1292$var$normalizePptxParagraphText(element.textContent || "");
                return renderedText === paragraph.text || renderedText.endsWith(paragraph.text);
            });
            if (!match) continue;
            match.style.textAlign = paragraph.alignment;
            match.dataset.ofvPptxTextAlignment = paragraph.alignment;
            unused.delete(match);
        }
    }
}
function $08414ea58bdc1292$var$normalizePptxSlideNumbers(container) {
    const wrappers = Array.from(container.querySelectorAll("div[data-slide-index]"));
    for (const [position, wrapper] of wrappers.entries()){
        const parsedIndex = Number(wrapper.dataset.slideIndex);
        const slideNumber = (Number.isInteger(parsedIndex) && parsedIndex >= 0 ? parsedIndex : position) + 1;
        const placeholders = Array.from(wrapper.querySelectorAll("div, span")).filter((element)=>element.children.length === 0 && (element.textContent || "").trim() === "\u2039#\u203A");
        for (const placeholder of placeholders){
            placeholder.textContent = String(slideNumber);
            placeholder.dataset.ofvPptxSlideNumber = String(slideNumber);
        }
    }
}
function $08414ea58bdc1292$var$normalizePptxCircleCalloutText(container) {
    for (const element of Array.from(container.querySelectorAll("div"))){
        if (!$08414ea58bdc1292$var$isPptxCircleCalloutBox(element)) continue;
        const textLayer = $08414ea58bdc1292$var$findPptxCircleCalloutTextLayer(element);
        const text = (textLayer?.textContent || "").trim();
        if (!textLayer || !$08414ea58bdc1292$var$isPptxCircleCalloutText(text)) continue;
        const normalizedText = $08414ea58bdc1292$var$splitPptxCircleCalloutText(text);
        if (textLayer.textContent !== normalizedText) textLayer.textContent = normalizedText;
        textLayer.classList.add("ofv-pptx-circle-callout-text");
    }
}
function $08414ea58bdc1292$var$isPptxCircleCalloutText(text) {
    return /^(?:代表性定义|包含的要素)$/.test(text);
}
function $08414ea58bdc1292$var$isPptxCircleCalloutBox(element) {
    const width = $08414ea58bdc1292$var$parseCssPixelValue(element.style.width);
    const height = $08414ea58bdc1292$var$parseCssPixelValue(element.style.height);
    return element.style.position === "absolute" && width >= 80 && height >= 80 && width / height > 0.75 && width / height < 1.25;
}
function $08414ea58bdc1292$var$findPptxCircleCalloutTextLayer(element) {
    if (element.children.length === 0 && $08414ea58bdc1292$var$isPptxCircleCalloutText((element.textContent || "").trim())) return element;
    return Array.from(element.querySelectorAll("div")).find((candidate)=>$08414ea58bdc1292$var$isPptxCircleCalloutText((candidate.textContent || "").trim()));
}
function $08414ea58bdc1292$var$splitPptxCircleCalloutText(text) {
    if (text === "\u4EE3\u8868\u6027\u5B9A\u4E49") return "\u4EE3\u8868\u6027\n\u5B9A\u4E49";
    if (text === "\u5305\u542B\u7684\u8981\u7D20") return "\u5305\u542B\u7684\n\u8981\u7D20";
    return text;
}
function $08414ea58bdc1292$var$normalizePptxDiagramCycleText(container) {
    const candidates = Array.from(container.querySelectorAll("div")).filter($08414ea58bdc1292$var$isPptxDiagramCycleTextBox);
    const groups = /* @__PURE__ */ new Map();
    for (const candidate of candidates){
        const parent = candidate.parentElement;
        if (!parent) continue;
        const group = groups.get(parent) || [];
        group.push(candidate);
        groups.set(parent, group);
    }
    for (const group of groups.values()){
        if (group.length < 4) continue;
        const ordered = group.map((element)=>({
                element: element,
                index: $08414ea58bdc1292$var$pptxDiagramCycleIndex(element.textContent || "")
            })).filter((item)=>item.index !== void 0).sort((a, b)=>a.index - b.index);
        if (ordered.length < 4 || !$08414ea58bdc1292$var$isOverlappingPptxDiagramCycleGroup(ordered.map((item)=>item.element))) continue;
        $08414ea58bdc1292$var$repositionPptxDiagramCycleText(ordered.map((item)=>item.element));
    }
}
function $08414ea58bdc1292$var$isPptxDiagramCycleTextBox(element) {
    const text = (element.textContent || "").trim();
    if ($08414ea58bdc1292$var$pptxDiagramCycleIndex(text) === void 0 || element.style.position !== "absolute") return false;
    const width = $08414ea58bdc1292$var$parseCssPixelValue(element.style.width);
    const height = $08414ea58bdc1292$var$parseCssPixelValue(element.style.height);
    const left = $08414ea58bdc1292$var$parseCssPixelValue(element.style.left);
    const top = $08414ea58bdc1292$var$parseCssPixelValue(element.style.top);
    return width > 120 && height > 120 && (left !== 0 || top !== 0);
}
function $08414ea58bdc1292$var$pptxDiagramCycleIndex(text) {
    const marker = text.trim().charAt(0);
    const markers = "\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468";
    const index = markers.indexOf(marker);
    return index >= 0 ? index + 1 : void 0;
}
function $08414ea58bdc1292$var$isOverlappingPptxDiagramCycleGroup(elements) {
    const boxes = elements.map((element)=>({
            left: $08414ea58bdc1292$var$parseCssPixelValue(element.style.left),
            top: $08414ea58bdc1292$var$parseCssPixelValue(element.style.top),
            width: $08414ea58bdc1292$var$parseCssPixelValue(element.style.width),
            height: $08414ea58bdc1292$var$parseCssPixelValue(element.style.height)
        }));
    const averageWidth = boxes.reduce((sum, box)=>sum + box.width, 0) / boxes.length;
    const averageHeight = boxes.reduce((sum, box)=>sum + box.height, 0) / boxes.length;
    const leftSpread = Math.max(...boxes.map((box)=>box.left)) - Math.min(...boxes.map((box)=>box.left));
    const topSpread = Math.max(...boxes.map((box)=>box.top)) - Math.min(...boxes.map((box)=>box.top));
    return averageWidth > 0 && averageHeight > 0 && leftSpread < averageWidth * 0.2 && topSpread < averageHeight * 0.2;
}
function $08414ea58bdc1292$var$repositionPptxDiagramCycleText(elements) {
    const boxes = elements.map((element)=>({
            left: $08414ea58bdc1292$var$parseCssPixelValue(element.style.left),
            top: $08414ea58bdc1292$var$parseCssPixelValue(element.style.top),
            width: $08414ea58bdc1292$var$parseCssPixelValue(element.style.width),
            height: $08414ea58bdc1292$var$parseCssPixelValue(element.style.height)
        }));
    const minLeft = Math.min(...boxes.map((box)=>box.left));
    const minTop = Math.min(...boxes.map((box)=>box.top));
    const maxRight = Math.max(...boxes.map((box)=>box.left + box.width));
    const maxBottom = Math.max(...boxes.map((box)=>box.top + box.height));
    const centerX = (minLeft + maxRight) / 2;
    const centerY = (minTop + maxBottom) / 2;
    const radiusX = (maxRight - minLeft) * 0.3;
    const radiusY = (maxBottom - minTop) * 0.27;
    const boxWidth = Math.max(96, Math.min(148, (maxRight - minLeft) * 0.28));
    const boxHeight = Math.max(52, Math.min(82, (maxBottom - minTop) * 0.17));
    const angleByIndex = /* @__PURE__ */ new Map([
        [
            1,
            -110
        ],
        [
            2,
            180
        ],
        [
            3,
            125
        ],
        [
            4,
            55
        ],
        [
            5,
            0
        ],
        [
            6,
            -55
        ]
    ]);
    for (const element of elements){
        const index = $08414ea58bdc1292$var$pptxDiagramCycleIndex(element.textContent || "");
        const angle = (angleByIndex.get(index || 0) ?? ((index || 1) - 1) * (360 / elements.length)) * Math.PI / 180;
        const left = centerX + Math.cos(angle) * radiusX - boxWidth / 2;
        const top = centerY + Math.sin(angle) * radiusY - boxHeight / 2;
        const textLayer = $08414ea58bdc1292$var$findPptxDiagramCycleTextLayer(element);
        const overlayParent = element.parentElement;
        if (!textLayer || !overlayParent) continue;
        element.style.overflow = "visible";
        textLayer.classList.add("ofv-pptx-diagram-cycle-text");
        textLayer.style.left = `${left}px`;
        textLayer.style.top = `${top}px`;
        textLayer.style.width = `${boxWidth}px`;
        textLayer.style.height = `${boxHeight}px`;
        textLayer.style.zIndex = "20";
        textLayer.style.alignItems = "center";
        textLayer.style.justifyContent = "center";
        textLayer.style.textAlign = "center";
        textLayer.style.whiteSpace = "normal";
        textLayer.style.wordBreak = "break-word";
        textLayer.style.pointerEvents = "none";
        textLayer.dataset.ofvPptxDiagramCycleText = String(index || "");
        overlayParent.append(textLayer);
    }
}
function $08414ea58bdc1292$var$findPptxDiagramCycleTextLayer(element) {
    const text = (element.textContent || "").trim();
    const descendants2 = Array.from(element.querySelectorAll("div")).filter((candidate)=>candidate !== element && (candidate.textContent || "").trim() === text);
    return descendants2.find((candidate)=>candidate.style.position === "absolute") || descendants2[0];
}
async function $08414ea58bdc1292$var$inspectPptxPlaceholderFontCorrections(zip) {
    const presentationXml = await zip.file("ppt/presentation.xml")?.async("text");
    const presentation = presentationXml ? $08414ea58bdc1292$var$parseOfficeXml(presentationXml) : void 0;
    const slideSize = presentation ? Array.from(presentation.getElementsByTagName("*")).find((element)=>element.localName === "sldSz") : void 0;
    const slideWidth = Number(slideSize?.getAttribute("cx"));
    const slideHeight = Number(slideSize?.getAttribute("cy"));
    if (!(slideWidth > 0) || !(slideHeight > 0)) return [];
    const slideEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/slides\/slide\d+\.xml$/i.test(entry.name)).sort((a, b)=>$08414ea58bdc1292$var$slideNumberFromPath(a.name) - $08414ea58bdc1292$var$slideNumberFromPath(b.name));
    const corrections = [];
    for (const [slideIndex, entry] of slideEntries.entries()){
        const slideXml = await entry.async("text");
        const slide = $08414ea58bdc1292$var$parseOfficeXml(slideXml);
        if (!slide) continue;
        const relationships = await $08414ea58bdc1292$var$readPptxRelationships(zip, entry.name);
        const layoutTarget = $08414ea58bdc1292$var$resolvePptxRelationshipTarget(entry.name, relationships.find((relationship)=>/\/slideLayout$/i.test(relationship.type))?.target);
        const layoutXml = layoutTarget ? await zip.file(layoutTarget)?.async("text") : void 0;
        const layout = layoutXml ? $08414ea58bdc1292$var$parseOfficeXml(layoutXml) : void 0;
        if (!layout) continue;
        const layoutFontSizes = $08414ea58bdc1292$var$readPptxLayoutPlaceholderFontSizes(layout);
        const shapes = Array.from(slide.getElementsByTagName("*")).filter((element)=>element.localName === "sp");
        for (const shape of shapes){
            const placeholder = $08414ea58bdc1292$var$findPptxDescendant(shape, "ph");
            const placeholderIndex = placeholder?.getAttribute("idx");
            const fontSizePt = placeholderIndex ? layoutFontSizes.get(placeholderIndex) : void 0;
            const textBody = $08414ea58bdc1292$var$findPptxDescendant(shape, "txBody");
            if (!textBody?.textContent?.trim() || !fontSizePt || $08414ea58bdc1292$var$hasExplicitPptxTextSize(textBody)) continue;
            const transform = $08414ea58bdc1292$var$findPptxDescendant(shape, "xfrm");
            const offset = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "off") : void 0;
            const extent = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "ext") : void 0;
            const left = Number(offset?.getAttribute("x"));
            const top = Number(offset?.getAttribute("y"));
            const width = Number(extent?.getAttribute("cx"));
            const height = Number(extent?.getAttribute("cy"));
            if (![
                left,
                top,
                width,
                height
            ].every((value)=>Number.isFinite(value)) || width <= 0 || height <= 0) continue;
            corrections.push({
                slideIndex: slideIndex,
                leftRatio: left / slideWidth,
                topRatio: top / slideHeight,
                widthRatio: width / slideWidth,
                heightRatio: height / slideHeight,
                fontSizePt: fontSizePt
            });
        }
    }
    return corrections;
}
async function $08414ea58bdc1292$var$inspectPptxAutofitLineHeightCorrections(zip) {
    const presentationXml = await zip.file("ppt/presentation.xml")?.async("text");
    const presentation = presentationXml ? $08414ea58bdc1292$var$parseOfficeXml(presentationXml) : void 0;
    const slideSize = presentation ? Array.from(presentation.getElementsByTagName("*")).find((element)=>element.localName === "sldSz") : void 0;
    const slideWidth = Number(slideSize?.getAttribute("cx"));
    const slideHeight = Number(slideSize?.getAttribute("cy"));
    if (!(slideWidth > 0) || !(slideHeight > 0)) return [];
    const slideEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/slides\/slide\d+\.xml$/i.test(entry.name)).sort((a, b)=>$08414ea58bdc1292$var$slideNumberFromPath(a.name) - $08414ea58bdc1292$var$slideNumberFromPath(b.name));
    const corrections = [];
    for (const [slideIndex, entry] of slideEntries.entries()){
        const slide = $08414ea58bdc1292$var$parseOfficeXml(await entry.async("text"));
        if (!slide) continue;
        const shapes = Array.from(slide.getElementsByTagName("*")).filter((element)=>element.localName === "sp");
        for (const shape of shapes){
            const textBody = $08414ea58bdc1292$var$findPptxDescendant(shape, "txBody");
            const bodyProperties = textBody ? $08414ea58bdc1292$var$findPptxChild(textBody, "bodyPr") : void 0;
            if (!textBody || !bodyProperties || !$08414ea58bdc1292$var$findPptxChild(bodyProperties, "normAutofit")) continue;
            const paragraphs = Array.from(textBody.children).filter((element)=>element.localName === "p");
            const defaultLineHeightParagraphs = paragraphs.filter((paragraph)=>!$08414ea58bdc1292$var$findPptxDescendant(paragraph, "lnSpc")).map((paragraph)=>$08414ea58bdc1292$var$normalizePptxParagraphText(paragraph.textContent || "")).filter(Boolean);
            if (defaultLineHeightParagraphs.length === 0) continue;
            const transform = $08414ea58bdc1292$var$findPptxDescendant(shape, "xfrm");
            const offset = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "off") : void 0;
            const extent = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "ext") : void 0;
            const left = Number(offset?.getAttribute("x"));
            const top = Number(offset?.getAttribute("y"));
            const width = Number(extent?.getAttribute("cx"));
            const height = Number(extent?.getAttribute("cy"));
            if (![
                left,
                top,
                width,
                height
            ].every((value)=>Number.isFinite(value)) || width <= 0 || height <= 0) continue;
            corrections.push({
                slideIndex: slideIndex,
                leftRatio: left / slideWidth,
                topRatio: top / slideHeight,
                widthRatio: width / slideWidth,
                heightRatio: height / slideHeight,
                paragraphs: defaultLineHeightParagraphs
            });
        }
    }
    return corrections;
}
async function $08414ea58bdc1292$var$inspectPptxVisualCorrections(zip) {
    const presentationXml = await zip.file("ppt/presentation.xml")?.async("text");
    const presentation = presentationXml ? $08414ea58bdc1292$var$parseOfficeXml(presentationXml) : void 0;
    const slideSize = presentation ? Array.from(presentation.getElementsByTagName("*")).find((element)=>element.localName === "sldSz") : void 0;
    const slideWidth = Number(slideSize?.getAttribute("cx"));
    const slideHeight = Number(slideSize?.getAttribute("cy"));
    const shapeFillCorrections = [];
    const autoNumberingCorrections = [];
    const autofitWrapCorrections = [];
    const textAlignmentCorrections = [];
    const imageClipCorrections = [];
    const transparentChartCorrections = [];
    const defaultTextAlignments = presentation ? $08414ea58bdc1292$var$readPptxDefaultTextAlignments(presentation) : /* @__PURE__ */ new Map();
    if (!(slideWidth > 0) || !(slideHeight > 0)) return {
        shapeFillCorrections: shapeFillCorrections,
        autoNumberingCorrections: autoNumberingCorrections,
        autofitWrapCorrections: autofitWrapCorrections,
        textAlignmentCorrections: textAlignmentCorrections,
        imageClipCorrections: imageClipCorrections,
        transparentChartCorrections: transparentChartCorrections
    };
    const slideEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/slides\/slide\d+\.xml$/i.test(entry.name)).sort((a, b)=>$08414ea58bdc1292$var$slideNumberFromPath(a.name) - $08414ea58bdc1292$var$slideNumberFromPath(b.name));
    for (const [slideIndex, entry] of slideEntries.entries()){
        const slide = $08414ea58bdc1292$var$parseOfficeXml(await entry.async("text"));
        if (!slide) continue;
        const relationships = await $08414ea58bdc1292$var$readPptxRelationships(zip, entry.name);
        const pictures = Array.from(slide.getElementsByTagName("*")).filter((element)=>element.localName === "pic");
        for (const picture of pictures){
            const geometry = $08414ea58bdc1292$var$readPptxShapeGeometry(picture, slideIndex, slideWidth, slideHeight);
            const shapeProperties = $08414ea58bdc1292$var$findPptxChild(picture, "spPr");
            const customGeometry = shapeProperties ? $08414ea58bdc1292$var$findPptxChild(shapeProperties, "custGeom") : void 0;
            const paths = customGeometry ? $08414ea58bdc1292$var$readPptxCustomGeometryPaths(customGeometry) : [];
            if (geometry && paths.length > 0) imageClipCorrections.push({
                ...geometry,
                paths: paths
            });
        }
        const graphicFrames = Array.from(slide.getElementsByTagName("*")).filter((element)=>element.localName === "graphicFrame");
        for (const frame of graphicFrames){
            const graphicData = $08414ea58bdc1292$var$findPptxDescendant(frame, "graphicData");
            if (!graphicData?.getAttribute("uri")?.endsWith("/chart")) continue;
            const chartReference = $08414ea58bdc1292$var$findPptxDescendant(graphicData, "chart");
            const relationshipId = chartReference?.getAttribute("r:id") || "";
            const relationship = relationships.find((candidate)=>candidate.id === relationshipId);
            const chartPath = relationship ? $08414ea58bdc1292$var$resolvePptxRelationshipTarget(entry.name, relationship.target) : void 0;
            const chartXml = chartPath ? await zip.file(chartPath)?.async("text") : void 0;
            const chart = chartXml ? $08414ea58bdc1292$var$parseOfficeXml(chartXml) : void 0;
            const chartSpace = chart?.documentElement;
            const chartProperties = chartSpace ? $08414ea58bdc1292$var$findPptxChild(chartSpace, "spPr") : void 0;
            if (!chartProperties || !$08414ea58bdc1292$var$findPptxChild(chartProperties, "noFill")) continue;
            const transform = $08414ea58bdc1292$var$findPptxChild(frame, "xfrm");
            const geometry = transform ? $08414ea58bdc1292$var$readPptxTransformGeometry(transform, slideIndex, slideWidth, slideHeight) : void 0;
            if (geometry) transparentChartCorrections.push(geometry);
        }
        const shapes = Array.from(slide.getElementsByTagName("*")).filter((element)=>element.localName === "sp");
        for (const shape of shapes){
            const textBody = $08414ea58bdc1292$var$findPptxChild(shape, "txBody");
            const bodyProperties = textBody ? $08414ea58bdc1292$var$findPptxChild(textBody, "bodyPr") : void 0;
            const paragraphs = textBody ? Array.from(textBody.children).filter((element)=>element.localName === "p") : [];
            if (textBody && bodyProperties && $08414ea58bdc1292$var$findPptxChild(bodyProperties, "spAutoFit")) {
                const text = paragraphs.length === 1 ? $08414ea58bdc1292$var$normalizePptxParagraphText(paragraphs[0]?.textContent || "") : "";
                if (text && !$08414ea58bdc1292$var$findPptxDescendant(paragraphs[0], "br")) autofitWrapCorrections.push({
                    slideIndex: slideIndex,
                    text: text,
                    // Group-local coordinates are scaled by the parent transform and
                    // pptx-renderer already preserves those short autofit labels as a
                    // single line. Direct text boxes keep their declared square wrap.
                    wrap: (bodyProperties.getAttribute("wrap") || "square").toLowerCase() !== "none" && (shape.parentElement?.localName !== "grpSp" || $08414ea58bdc1292$var$estimatePptxTextWidth(text) > 32)
                });
            }
            const hasAutoNumbering = paragraphs.some((paragraph)=>{
                const paragraphProperties = $08414ea58bdc1292$var$findPptxChild(paragraph, "pPr");
                return Boolean(paragraphProperties && $08414ea58bdc1292$var$findPptxChild(paragraphProperties, "buAutoNum"));
            });
            if (textBody && paragraphs.length > 1 && (shape.parentElement?.localName === "grpSp" || hasAutoNumbering)) {
                const listStyle = $08414ea58bdc1292$var$findPptxChild(textBody, "lstStyle");
                const paragraphCorrections = paragraphs.flatMap((paragraph)=>{
                    const text = $08414ea58bdc1292$var$normalizePptxParagraphText(paragraph.textContent || "");
                    const paragraphProperties = $08414ea58bdc1292$var$findPptxChild(paragraph, "pPr");
                    const level = Number(paragraphProperties?.getAttribute("lvl") || 0);
                    const listLevelProperties = listStyle ? $08414ea58bdc1292$var$findPptxChild(listStyle, `lvl${level + 1}pPr`) : void 0;
                    if (!text || paragraphProperties?.getAttribute("algn") || listLevelProperties?.getAttribute("algn")) return [];
                    const alignment = defaultTextAlignments.get(level);
                    return alignment ? [
                        {
                            alignment: alignment,
                            text: text
                        }
                    ] : [];
                });
                if (paragraphCorrections.length > 0) textAlignmentCorrections.push({
                    slideIndex: slideIndex,
                    paragraphs: paragraphCorrections
                });
            }
            const geometry = $08414ea58bdc1292$var$readPptxShapeGeometry(shape, slideIndex, slideWidth, slideHeight);
            if (!geometry) continue;
            const shapeProperties = $08414ea58bdc1292$var$findPptxChild(shape, "spPr");
            const solidFill = shapeProperties ? $08414ea58bdc1292$var$findPptxChild(shapeProperties, "solidFill") : void 0;
            const rgb = solidFill ? $08414ea58bdc1292$var$findPptxChild(solidFill, "srgbClr")?.getAttribute("val") : void 0;
            if (rgb && /^[0-9a-f]{6}$/i.test(rgb)) shapeFillCorrections.push({
                ...geometry,
                color: `#${rgb.toUpperCase()}`
            });
            if (!textBody) continue;
            const counters = /* @__PURE__ */ new Map();
            const items = [];
            for (const paragraph of Array.from(textBody.children).filter((element)=>element.localName === "p")){
                const paragraphProperties = $08414ea58bdc1292$var$findPptxChild(paragraph, "pPr");
                const autoNumber = paragraphProperties ? $08414ea58bdc1292$var$findPptxChild(paragraphProperties, "buAutoNum") : void 0;
                const type = autoNumber?.getAttribute("type") || "";
                const text = paragraph.textContent?.trim() || "";
                if (!autoNumber || !text) continue;
                const level = paragraphProperties?.getAttribute("lvl") || "0";
                const key = `${level}:${type}`;
                const declaredStart = Number(autoNumber.getAttribute("startAt"));
                const number = declaredStart > 0 ? declaredStart : counters.get(key) || 1;
                const label = $08414ea58bdc1292$var$formatPptxAutoNumber(type, number);
                counters.set(key, number + 1);
                if (label) items.push({
                    label: label,
                    text: text
                });
            }
            if (items.length > 0) autoNumberingCorrections.push({
                ...geometry,
                items: items
            });
        }
    }
    return {
        shapeFillCorrections: shapeFillCorrections,
        autoNumberingCorrections: autoNumberingCorrections,
        autofitWrapCorrections: autofitWrapCorrections,
        textAlignmentCorrections: textAlignmentCorrections,
        imageClipCorrections: imageClipCorrections,
        transparentChartCorrections: transparentChartCorrections
    };
}
function $08414ea58bdc1292$var$estimatePptxTextWidth(text) {
    return [
        ...text
    ].reduce((width, character)=>width + (/^[\x00-\xff]$/.test(character) ? 0.55 : 1), 0);
}
function $08414ea58bdc1292$var$readPptxDefaultTextAlignments(presentation) {
    const alignments = /* @__PURE__ */ new Map();
    const defaultTextStyle = Array.from(presentation.getElementsByTagName("*")).find((element)=>element.localName === "defaultTextStyle");
    if (!defaultTextStyle) return alignments;
    const cssAlignments = {
        ctr: "center",
        dist: "justify",
        just: "justify",
        l: "left",
        r: "right"
    };
    for (const child of Array.from(defaultTextStyle.children)){
        const match = /^lvl(\d+)pPr$/.exec(child.localName);
        const alignment = cssAlignments[child.getAttribute("algn") || ""];
        if (match && alignment) alignments.set(Number(match[1]) - 1, alignment);
    }
    return alignments;
}
function $08414ea58bdc1292$var$readPptxShapeGeometry(shape, slideIndex, slideWidth, slideHeight) {
    const shapeProperties = $08414ea58bdc1292$var$findPptxChild(shape, "spPr");
    const transform = shapeProperties ? $08414ea58bdc1292$var$findPptxChild(shapeProperties, "xfrm") : void 0;
    return transform ? $08414ea58bdc1292$var$readPptxTransformGeometry(transform, slideIndex, slideWidth, slideHeight) : void 0;
}
function $08414ea58bdc1292$var$readPptxTransformGeometry(transform, slideIndex, slideWidth, slideHeight) {
    const offset = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "off") : void 0;
    const extent = transform ? $08414ea58bdc1292$var$findPptxChild(transform, "ext") : void 0;
    const left = Number(offset?.getAttribute("x"));
    const top = Number(offset?.getAttribute("y"));
    const width = Number(extent?.getAttribute("cx"));
    const height = Number(extent?.getAttribute("cy"));
    if (![
        left,
        top,
        width,
        height
    ].every((value)=>Number.isFinite(value)) || width <= 0 || height <= 0) return void 0;
    return {
        slideIndex: slideIndex,
        leftRatio: left / slideWidth,
        topRatio: top / slideHeight,
        widthRatio: width / slideWidth,
        heightRatio: height / slideHeight
    };
}
function $08414ea58bdc1292$var$readPptxCustomGeometryPaths(customGeometry) {
    const pathList = $08414ea58bdc1292$var$findPptxChild(customGeometry, "pathLst");
    if (!pathList) return [];
    const guides = $08414ea58bdc1292$var$readPptxCustomGeometryGuides(customGeometry);
    return Array.from(pathList.children).flatMap((path)=>{
        if (path.localName !== "path" || path.getAttribute("fill") === "none") return [];
        const width = Number(path.getAttribute("w"));
        const height = Number(path.getAttribute("h"));
        if (!(width > 0) || !(height > 0)) return [];
        const variables = /* @__PURE__ */ new Map([
            [
                "w",
                width
            ],
            [
                "h",
                height
            ],
            [
                "l",
                0
            ],
            [
                "t",
                0
            ],
            [
                "r",
                width
            ],
            [
                "b",
                height
            ],
            [
                "hc",
                width / 2
            ],
            [
                "vc",
                height / 2
            ]
        ]);
        for (const [name, formula] of guides){
            const value = $08414ea58bdc1292$var$evaluatePptxGuideFormula(formula, variables);
            if (Number.isFinite(value)) variables.set(name, value);
        }
        const commands = [];
        for (const command of Array.from(path.children)){
            const points = Array.from(command.children).filter((child)=>child.localName === "pt");
            const point = (index)=>{
                const current = points[index];
                if (!current) return void 0;
                const x = $08414ea58bdc1292$var$readPptxPathCoordinate(current.getAttribute("x"), variables) / width;
                const y = $08414ea58bdc1292$var$readPptxPathCoordinate(current.getAttribute("y"), variables) / height;
                return Number.isFinite(x) && Number.isFinite(y) ? `${$08414ea58bdc1292$var$formatPptxPathNumber(x)} ${$08414ea58bdc1292$var$formatPptxPathNumber(y)}` : void 0;
            };
            if (command.localName === "moveTo" && point(0)) commands.push(`M ${point(0)}`);
            else if (command.localName === "lnTo" && point(0)) commands.push(`L ${point(0)}`);
            else if (command.localName === "cubicBezTo" && point(0) && point(1) && point(2)) commands.push(`C ${point(0)} ${point(1)} ${point(2)}`);
            else if (command.localName === "quadBezTo" && point(0) && point(1)) commands.push(`Q ${point(0)} ${point(1)}`);
            else if (command.localName === "close") commands.push("Z");
        }
        return commands.length > 1 ? [
            commands.join(" ")
        ] : [];
    });
}
function $08414ea58bdc1292$var$readPptxCustomGeometryGuides(customGeometry) {
    const guideList = $08414ea58bdc1292$var$findPptxChild(customGeometry, "gdLst");
    return guideList ? Array.from(guideList.children).flatMap((guide)=>{
        const name = guide.getAttribute("name") || "";
        const formula = guide.getAttribute("fmla") || "";
        return guide.localName === "gd" && name && formula ? [
            [
                name,
                formula
            ]
        ] : [];
    }) : [];
}
function $08414ea58bdc1292$var$evaluatePptxGuideFormula(formula, variables) {
    const [operator, ...operands] = formula.trim().split(/\s+/);
    const value = (index)=>$08414ea58bdc1292$var$readPptxPathCoordinate(operands[index], variables);
    if (operator === "val") return value(0);
    if (operator === "*/") return value(0) * value(1) / value(2);
    if (operator === "+-") return value(0) + value(1) - value(2);
    if (operator === "+/") return (value(0) + value(1)) / value(2);
    if (operator === "?:") return value(0) > 0 ? value(1) : value(2);
    if (operator === "abs") return Math.abs(value(0));
    if (operator === "min") return Math.min(value(0), value(1));
    if (operator === "max") return Math.max(value(0), value(1));
    return Number.NaN;
}
function $08414ea58bdc1292$var$readPptxPathCoordinate(value, variables) {
    if (!value) return Number.NaN;
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : variables.get(value) ?? Number.NaN;
}
function $08414ea58bdc1292$var$formatPptxPathNumber(value) {
    return Number(value.toFixed(8)).toString();
}
function $08414ea58bdc1292$var$formatPptxAutoNumber(type, value) {
    let label;
    if (type.startsWith("ea1JpnChsDb")) label = $08414ea58bdc1292$var$toEastAsianNumeral(value);
    else if (type.startsWith("arabic")) label = String(value);
    else if (type.startsWith("romanUc")) label = $08414ea58bdc1292$var$toRomanNumeral(value);
    else if (type.startsWith("romanLc")) label = $08414ea58bdc1292$var$toRomanNumeral(value).toLowerCase();
    else if (type.startsWith("alphaUc")) label = $08414ea58bdc1292$var$toAlphabeticNumeral(value);
    else if (type.startsWith("alphaLc")) label = $08414ea58bdc1292$var$toAlphabeticNumeral(value).toLowerCase();
    else return void 0;
    if (type.endsWith("ParenBoth")) return `(${label})`;
    if (type.endsWith("ParenR")) return `${label})`;
    if (type.endsWith("Plain")) return label;
    if (type.startsWith("ea1JpnChsDb")) return `${label}\uFF0E`;
    return `${label}.`;
}
function $08414ea58bdc1292$var$toEastAsianNumeral(value) {
    if (!Number.isInteger(value) || value <= 0 || value >= 1e4) return String(value);
    const digits = [
        "\u96F6",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D"
    ];
    const units = [
        "",
        "\u5341",
        "\u767E",
        "\u5343"
    ];
    let result = "";
    let pendingZero = false;
    for(let position = 3; position >= 0; position -= 1){
        const divisor = 10 ** position;
        const digit = Math.floor(value / divisor) % 10;
        if (digit === 0) {
            pendingZero = result.length > 0;
            continue;
        }
        if (pendingZero) {
            result += digits[0];
            pendingZero = false;
        }
        if (!(digit === 1 && position === 1 && result.length === 0)) result += digits[digit];
        result += units[position];
    }
    return result;
}
function $08414ea58bdc1292$var$toRomanNumeral(value) {
    if (value <= 0 || value >= 4e3) return String(value);
    const numerals = [
        [
            1e3,
            "M"
        ],
        [
            900,
            "CM"
        ],
        [
            500,
            "D"
        ],
        [
            400,
            "CD"
        ],
        [
            100,
            "C"
        ],
        [
            90,
            "XC"
        ],
        [
            50,
            "L"
        ],
        [
            40,
            "XL"
        ],
        [
            10,
            "X"
        ],
        [
            9,
            "IX"
        ],
        [
            5,
            "V"
        ],
        [
            4,
            "IV"
        ],
        [
            1,
            "I"
        ]
    ];
    let remainder = value;
    let result = "";
    for (const [amount, numeral] of numerals)while(remainder >= amount){
        result += numeral;
        remainder -= amount;
    }
    return result;
}
function $08414ea58bdc1292$var$toAlphabeticNumeral(value) {
    if (value <= 0) return String(value);
    let remainder = value;
    let result = "";
    while(remainder > 0){
        remainder -= 1;
        result = String.fromCharCode(65 + remainder % 26) + result;
        remainder = Math.floor(remainder / 26);
    }
    return result;
}
function $08414ea58bdc1292$var$readPptxLayoutPlaceholderFontSizes(layout) {
    const result = /* @__PURE__ */ new Map();
    const shapes = Array.from(layout.getElementsByTagName("*")).filter((element)=>element.localName === "sp");
    for (const shape of shapes){
        const placeholderIndex = $08414ea58bdc1292$var$findPptxDescendant(shape, "ph")?.getAttribute("idx");
        if (!placeholderIndex) continue;
        const textBody = $08414ea58bdc1292$var$findPptxDescendant(shape, "txBody");
        const defaultRunProperties = textBody ? Array.from(textBody.getElementsByTagName("*")).find((element)=>element.localName === "defRPr" && Number(element.getAttribute("sz")) > 0) : void 0;
        const size = Number(defaultRunProperties?.getAttribute("sz"));
        if (size > 0) result.set(placeholderIndex, size / 100);
    }
    return result;
}
function $08414ea58bdc1292$var$hasExplicitPptxTextSize(textBody) {
    return Array.from(textBody.getElementsByTagName("*")).some((element)=>(element.localName === "rPr" || element.localName === "defRPr" || element.localName === "endParaRPr") && Number(element.getAttribute("sz")) > 0);
}
function $08414ea58bdc1292$var$findPptxDescendant(element, localName) {
    return Array.from(element.getElementsByTagName("*")).find((child)=>child.localName === localName);
}
function $08414ea58bdc1292$var$findPptxChild(element, localName) {
    return Array.from(element.children).find((child)=>child.localName === localName);
}
function $08414ea58bdc1292$var$normalizePptxPlaceholderFonts(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        if (!wrapper) continue;
        const match = $08414ea58bdc1292$var$findPptxShapeElement(wrapper, correction);
        if (!match) continue;
        const styledText = Array.from(match.querySelectorAll("[style]")).filter((element)=>parseFloat(element.style.fontSize) > 0);
        for (const element of styledText)element.style.fontSize = `${correction.fontSizePt}pt`;
        if (styledText.length > 0) match.dataset.ofvPptxPlaceholderFont = String(correction.fontSizePt);
    }
}
function $08414ea58bdc1292$var$normalizePptxAutofitLineHeights(container, corrections) {
    for (const correction of corrections){
        const wrapper = container.querySelector(`div[data-slide-index="${correction.slideIndex}"]`);
        if (!wrapper) continue;
        const match = $08414ea58bdc1292$var$findPptxShapeElement(wrapper, correction);
        if (!match) continue;
        const paragraphElements = Array.from(match.querySelectorAll("div")).filter((element)=>{
            const directChildren = Array.from(element.children);
            return directChildren.length > 0 && directChildren.every((child)=>child.tagName === "SPAN");
        });
        const unused = new Set(paragraphElements);
        for (const paragraph of correction.paragraphs){
            const element = Array.from(unused).find((candidate)=>$08414ea58bdc1292$var$normalizePptxParagraphText(candidate.textContent || "").endsWith(paragraph));
            if (!element) continue;
            element.style.lineHeight = "1";
            element.dataset.ofvPptxDefaultLineHeight = "true";
            unused.delete(element);
        }
    }
}
function $08414ea58bdc1292$var$normalizePptxParagraphText(value) {
    return value.replace(/\s+/g, "").trim();
}
function $08414ea58bdc1292$var$findPptxShapeElement(wrapper, correction) {
    return $08414ea58bdc1292$var$findPptxGeometryElement(wrapper, correction, (element)=>Boolean(element.textContent?.trim()));
}
function $08414ea58bdc1292$var$findPptxGeometryElement(wrapper, correction, predicate) {
    let best;
    for (const canvas of $08414ea58bdc1292$var$findPptxSlideCanvases(wrapper)){
        const canvasWidth = $08414ea58bdc1292$var$parseCssPixelValue(canvas.style.width);
        const canvasHeight = $08414ea58bdc1292$var$parseCssPixelValue(canvas.style.height);
        if (!(canvasWidth > 0) || !(canvasHeight > 0)) continue;
        const expected = {
            left: correction.leftRatio * canvasWidth,
            top: correction.topRatio * canvasHeight,
            width: correction.widthRatio * canvasWidth,
            height: correction.heightRatio * canvasHeight
        };
        const candidates = Array.from(canvas.querySelectorAll("div")).filter((element)=>element.style.position === "absolute" && predicate(element));
        for (const element of candidates){
            const actual = {
                left: $08414ea58bdc1292$var$parseCssPixelValue(element.style.left),
                top: $08414ea58bdc1292$var$parseCssPixelValue(element.style.top),
                width: $08414ea58bdc1292$var$parseCssPixelValue(element.style.width),
                height: $08414ea58bdc1292$var$parseCssPixelValue(element.style.height)
            };
            const deltas = [
                Math.abs(actual.left - expected.left),
                Math.abs(actual.top - expected.top),
                Math.abs(actual.width - expected.width),
                Math.abs(actual.height - expected.height)
            ];
            const tolerance = Math.max(2, Math.min(canvasWidth, canvasHeight) * 5e-3);
            if (deltas.some((delta)=>delta > tolerance)) continue;
            const score = deltas.reduce((sum, delta)=>sum + delta, 0);
            if (!best || score < best.score) best = {
                element: element,
                score: score
            };
        }
    }
    return best?.element;
}
function $08414ea58bdc1292$var$hasInlineBackground(element) {
    return Boolean(element.style.background || element.style.backgroundColor || element.style.backgroundImage);
}
function $08414ea58bdc1292$var$normalizePptxMirroredText(container) {
    const mirroredContainers = Array.from(container.querySelectorAll("div")).filter((element)=>{
        const text = element.textContent?.trim();
        if (!text || element.children.length === 0) return false;
        const styleTransform = element.style.transform;
        return $08414ea58bdc1292$var$hasPptxMirrorTransform(styleTransform, "x") || $08414ea58bdc1292$var$hasPptxMirrorTransform(styleTransform, "y");
    });
    for (const element of mirroredContainers){
        const flipX = $08414ea58bdc1292$var$hasPptxMirrorTransform(element.style.transform, "x");
        const flipY = $08414ea58bdc1292$var$hasPptxMirrorTransform(element.style.transform, "y");
        const targets = $08414ea58bdc1292$var$findPptxMirroredTextTargets(element);
        for (const target of targets)$08414ea58bdc1292$var$counterMirrorPptxTextTarget(target, flipX, flipY);
    }
}
function $08414ea58bdc1292$var$findPptxMirroredTextTargets(element) {
    const children = Array.from(element.children).filter((child)=>child instanceof HTMLElement);
    const absoluteTextChildren = children.filter((child)=>Boolean(child.textContent?.trim()) && child.style.position === "absolute");
    if (absoluteTextChildren.length > 0) return absoluteTextChildren;
    return children.filter((child)=>Boolean(child.textContent?.trim()));
}
function $08414ea58bdc1292$var$hasPptxMirrorTransform(transform, axis) {
    if (!transform) return false;
    if (axis === "x" && /scaleX\(\s*-1\s*\)/i.test(transform)) return true;
    if (axis === "y" && /scaleY\(\s*-1\s*\)/i.test(transform)) return true;
    const matrix = transform.match(/matrix\(\s*([^,\s]+)\s*,\s*([^,\s]+)\s*,\s*([^,\s]+)\s*,\s*([^,\s]+)/i);
    if (!matrix) return false;
    const xScale = Number(matrix[1]);
    const yScale = Number(matrix[4]);
    return axis === "x" ? xScale < 0 : yScale < 0;
}
function $08414ea58bdc1292$var$counterMirrorPptxTextTarget(target, flipX, flipY) {
    const applied = target.dataset.ofvPptxCounterMirror ?? "";
    const transforms = [];
    if (flipX && !applied.includes("x")) transforms.push("scaleX(-1)");
    if (flipY && !applied.includes("y")) transforms.push("scaleY(-1)");
    if (transforms.length === 0) return;
    target.style.transform = `${target.style.transform || ""} ${transforms.join(" ")}`.trim();
    if (!target.style.transformOrigin) target.style.transformOrigin = "center center";
    target.dataset.ofvPptxCounterMirror = `${applied}${flipX ? "x" : ""}${flipY ? "y" : ""}`;
}
function $08414ea58bdc1292$var$findPptxSlideCanvases(container) {
    const slideWrappers = Array.from(container.querySelectorAll("div[data-slide-index]"));
    const candidates = slideWrappers.flatMap((wrapper)=>Array.from(wrapper.querySelectorAll("div")).filter($08414ea58bdc1292$var$isPptxSlideCanvas));
    if (candidates.length > 0) return Array.from(new Set(candidates));
    return Array.from(container.querySelectorAll("div")).filter($08414ea58bdc1292$var$isPptxSlideCanvas);
}
function $08414ea58bdc1292$var$isPptxSlideCanvas(element) {
    return element.style.position === "relative" && $08414ea58bdc1292$var$parseCssPixelValue(element.style.width) > 0 && $08414ea58bdc1292$var$parseCssPixelValue(element.style.height) > 0;
}
async function $08414ea58bdc1292$var$renderOdp(panel, arrayBuffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    const content = zip.file("content.xml");
    if (!content) {
        panel.textContent = "\u672A\u89E3\u6790\u5230 ODP \u5185\u5BB9\u3002";
        return;
    }
    const xml = await content.async("text");
    const images = await $08414ea58bdc1292$var$extractZipImages(zip, /^Pictures\//);
    $08414ea58bdc1292$var$renderPresentationInsight(panel, $08414ea58bdc1292$var$inspectOpenDocumentPresentation($08414ea58bdc1292$var$titleFromOdf(xml, "ODP \u6F14\u793A\u6587\u7A3F"), xml, images.length));
    $08414ea58bdc1292$var$renderOpenDocumentPresentation(panel, "ODP \u6F14\u793A\u6587\u7A3F", xml, images);
}
function $08414ea58bdc1292$var$renderOpenDocumentPresentationXml(panel, xml) {
    $08414ea58bdc1292$var$renderPresentationInsight(panel, $08414ea58bdc1292$var$inspectOpenDocumentPresentation("FODP \u6F14\u793A\u6587\u7A3F", xml, 0));
    $08414ea58bdc1292$var$renderOpenDocumentPresentation(panel, "FODP \u6F14\u793A\u6587\u7A3F", xml, []);
}
async function $08414ea58bdc1292$var$renderPackagedOfficePreview(panel, arrayBuffer, extension, fit, messages, docxOptions) {
    let zip;
    try {
        zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(arrayBuffer);
    } catch  {
        return false;
    }
    const entries = Object.values(zip.files).filter((entry)=>!entry.dir);
    const hasEntry = (path)=>entries.some((entry)=>entry.name.toLowerCase() === path.toLowerCase());
    const contentXml = zip.file(/(^|\/)content\.xml$/i)[0];
    if (hasEntry("word/document.xml")) {
        await $08414ea58bdc1292$var$renderDocx(panel, arrayBuffer, fit, docxOptions);
        return true;
    }
    if (hasEntry("xl/workbook.xml")) {
        await $08414ea58bdc1292$var$renderSheet(panel, arrayBuffer, extension, messages);
        return true;
    }
    if (hasEntry("ppt/presentation.xml")) {
        await $08414ea58bdc1292$var$renderPptx(panel, arrayBuffer);
        return true;
    }
    if (contentXml) {
        const xml = await contentXml.async("text");
        if (/<office:spreadsheet\b|<table:table\b/i.test(xml)) {
            $08414ea58bdc1292$var$renderParsedSheets(panel, $08414ea58bdc1292$var$parseFlatOds(xml), `${extension.toUpperCase()} \u6587\u4EF6\u672A\u89E3\u6790\u5230\u8868\u683C\u3002`);
            return true;
        }
        if (/<office:presentation\b|<draw:page\b/i.test(xml)) {
            $08414ea58bdc1292$var$renderOpenDocumentPresentation(panel, `${extension.toUpperCase()} \u6F14\u793A\u6587\u7A3F`, xml, await $08414ea58bdc1292$var$extractZipImages(zip, /^Pictures\//));
            return true;
        }
        if (/<office:text\b|<text:p\b/i.test(xml)) {
            $08414ea58bdc1292$var$renderOpenDocumentXml(panel, `${extension.toUpperCase()} \u6587\u6863`, xml);
            return true;
        }
    }
    if (entries.some((entry)=>/^index\//i.test(entry.name) || /\.iwa$/i.test(entry.name))) {
        $08414ea58bdc1292$var$renderOfficePackageStructure(panel, extension, entries.map((entry)=>entry.name), "\u68C0\u6D4B\u5230 Apple iWork \u5305\u7ED3\u6784\u3002\u5F53\u524D\u89E3\u6790\u5305\u5185 plist \u5143\u6570\u636E\u5E76\u5C55\u793A IWA/\u8D44\u6E90\u7ED3\u6784\uFF1B\u6B63\u6587 IWA \u6570\u636E\u53EF\u540E\u7EED\u63A5\u5165\u4E13\u7528\u89E3\u6790\u5668\u589E\u5F3A\u3002", await $08414ea58bdc1292$var$extractIWorkMetadata(entries));
        return true;
    }
    if (entries.length > 0) {
        $08414ea58bdc1292$var$renderOfficePackageStructure(panel, extension, entries.map((entry)=>entry.name), "\u68C0\u6D4B\u5230 ZIP \u5305\u7ED3\u6784\uFF0C\u4F46\u672A\u53D1\u73B0\u6807\u51C6 OOXML/ODF \u5165\u53E3\u3002\u53EF\u540E\u7EED\u63A5\u5165\u5BF9\u5E94\u5382\u5546\u683C\u5F0F\u89E3\u6790\u5668\u6216\u670D\u52A1\u7AEF\u8F6C\u6362\u3002");
        return true;
    }
    return false;
}
function $08414ea58bdc1292$var$renderOfficePackageStructure(panel, extension, entries, message, metadata) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("Office \u5305\u7ED3\u6784\u9884\u89C8");
    const note = document.createElement("p");
    note.className = "ofv-office-package-note";
    note.textContent = `.${extension} ${message}`;
    if (metadata && Object.keys(metadata).length > 0) section.append($08414ea58bdc1292$var$createIWorkMetadataSummary(metadata));
    const list = document.createElement("ul");
    list.className = "ofv-office-package-list";
    for (const name of entries.slice(0, 120)){
        const item = document.createElement("li");
        item.textContent = name;
        list.append(item);
    }
    if (entries.length > 120) {
        const item = document.createElement("li");
        item.textContent = `\u8FD8\u6709 ${entries.length - 120} \u4E2A\u6587\u4EF6\u672A\u5C55\u793A\u3002`;
        list.append(item);
    }
    section.append(note, list);
    panel.append(section);
}
async function $08414ea58bdc1292$var$extractIWorkMetadata(entries) {
    const metadataEntries = entries.filter((entry)=>/^metadata\/.*\.plist$/i.test(entry.name) || /properties\.plist$/i.test(entry.name));
    const metadata = {};
    for (const entry of metadataEntries.slice(0, 6)){
        const text = await entry.async("text").catch(()=>"");
        if (!text || !/<plist[\s>]/i.test(text)) continue;
        const plist = $08414ea58bdc1292$var$parsePlistDict(text);
        $08414ea58bdc1292$var$mergeIWorkMetadata(metadata, plist);
    }
    return metadata;
}
function $08414ea58bdc1292$var$createIWorkMetadataSummary(metadata) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-iwork-meta";
    const title = document.createElement("strong");
    title.textContent = "iWork \u5143\u6570\u636E";
    const grid = document.createElement("div");
    grid.className = "ofv-iwork-meta-grid";
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u6807\u9898", metadata.title);
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u4F5C\u8005", metadata.author);
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u516C\u53F8", metadata.company);
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u4E3B\u9898", metadata.subject);
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u5173\u952E\u8BCD", metadata.keywords?.join(", "));
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u521B\u5EFA\u65F6\u95F4", metadata.created);
    $08414ea58bdc1292$var$appendIWorkMeta(grid, "\u4FEE\u6539\u65F6\u95F4", metadata.modified);
    wrapper.append(title, grid);
    return wrapper;
}
function $08414ea58bdc1292$var$appendIWorkMeta(parent, label, value) {
    if (!value) return;
    const row = document.createElement("div");
    row.className = "ofv-meta-row";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    row.append(key, content);
    parent.append(row);
}
function $08414ea58bdc1292$var$mergeIWorkMetadata(metadata, plist) {
    metadata.title ||= $08414ea58bdc1292$var$plistText(plist, [
        "Title",
        "title",
        "DocumentTitle",
        "SFDocumentTitle",
        "kMDItemTitle"
    ]);
    metadata.author ||= $08414ea58bdc1292$var$plistText(plist, [
        "Author",
        "author",
        "Authors",
        "kMDItemAuthors",
        "creator"
    ]);
    metadata.company ||= $08414ea58bdc1292$var$plistText(plist, [
        "Company",
        "company",
        "Organization"
    ]);
    metadata.subject ||= $08414ea58bdc1292$var$plistText(plist, [
        "Subject",
        "subject",
        "Description",
        "comment"
    ]);
    metadata.created ||= $08414ea58bdc1292$var$plistText(plist, [
        "CreationDate",
        "created",
        "kMDItemFSCreationDate"
    ]);
    metadata.modified ||= $08414ea58bdc1292$var$plistText(plist, [
        "ModificationDate",
        "modified",
        "kMDItemFSContentChangeDate"
    ]);
    metadata.keywords ||= $08414ea58bdc1292$var$plistArray(plist, [
        "Keywords",
        "keywords",
        "kMDItemKeywords"
    ]);
}
function $08414ea58bdc1292$var$parsePlistDict(xml) {
    if (typeof DOMParser === "undefined") return {};
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return {};
    const dict = Array.from(doc.documentElement.children).find((child)=>child.tagName === "dict");
    const value = dict ? $08414ea58bdc1292$var$parsePlistValue(dict) : void 0;
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}
function $08414ea58bdc1292$var$parsePlistValue(element) {
    switch(element.tagName){
        case "dict":
            {
                const result = {};
                const children = Array.from(element.children);
                for(let index = 0; index < children.length; index++){
                    const key = children[index];
                    if (key.tagName !== "key") continue;
                    const value = children[index + 1];
                    if (value) {
                        result[key.textContent || ""] = $08414ea58bdc1292$var$parsePlistValue(value);
                        index++;
                    }
                }
                return result;
            }
        case "array":
            return Array.from(element.children).map($08414ea58bdc1292$var$parsePlistValue);
        case "true":
            return true;
        case "false":
            return false;
        case "integer":
        case "real":
            return Number(element.textContent || 0);
        case "string":
        case "date":
        default:
            return element.textContent?.trim() || "";
    }
}
function $08414ea58bdc1292$var$plistText(plist, keys) {
    for (const key of keys){
        const value = plist[key];
        if (typeof value === "string" && value.trim()) return value.trim();
        if (Array.isArray(value)) {
            const text = value.filter((item)=>typeof item === "string" && Boolean(item.trim())).join(", ");
            if (text) return text;
        }
    }
    return void 0;
}
function $08414ea58bdc1292$var$plistArray(plist, keys) {
    for (const key of keys){
        const value = plist[key];
        if (Array.isArray(value)) {
            const items = value.filter((item)=>typeof item === "string" && Boolean(item.trim()));
            if (items.length > 0) return items;
        }
        if (typeof value === "string" && value.trim()) return value.split(/[,;]/).map((item)=>item.trim()).filter(Boolean);
    }
    return void 0;
}
function $08414ea58bdc1292$var$renderOpenDocumentPresentation(panel, title, xml, images) {
    const pages = xml.split(/<draw:page\b/).slice(1);
    const pageSources = pages.length > 0 ? pages : [
        xml
    ];
    for (const [index, pageXml] of pageSources.entries()){
        const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${title} ${index + 1}`);
        const body = document.createElement("div");
        body.className = "ofv-slide";
        const texts = $08414ea58bdc1292$var$extractOpenDocumentBlocks(pageXml);
        if (texts.length > 0) {
            $08414ea58bdc1292$var$hideSuccessfulSectionHeading(section);
            for (const text of texts){
                const paragraph = document.createElement("p");
                paragraph.textContent = text;
                body.append(paragraph);
            }
        } else {
            const empty = document.createElement("p");
            empty.textContent = "\u8FD9\u4E00\u9875\u6CA1\u6709\u53EF\u63D0\u53D6\u6587\u672C\u3002";
            body.append(empty);
        }
        for (const image of images.slice(index === 0 ? 0 : images.length, index === 0 ? images.length : images.length)){
            const figure = document.createElement("figure");
            figure.className = "ofv-slide-image";
            const img = document.createElement("img");
            img.src = image.src;
            img.alt = image.name;
            const caption = document.createElement("figcaption");
            caption.textContent = image.name;
            figure.append(img, caption);
            body.append(figure);
        }
        section.append(body);
        panel.append(section);
    }
}
async function $08414ea58bdc1292$var$inspectPptxPresentation(zip) {
    const slideEntries = Object.values(zip.files).filter((entry)=>!entry.dir && /^ppt\/slides\/slide\d+\.xml$/i.test(entry.name)).sort((a, b)=>$08414ea58bdc1292$var$slideNumberFromPath(a.name) - $08414ea58bdc1292$var$slideNumberFromPath(b.name));
    const slides = [];
    let imageCount = 0;
    let notesCount = 0;
    let transitionCount = 0;
    let animationCount = 0;
    const layouts = /* @__PURE__ */ new Set();
    for (const entry of slideEntries){
        const xml = await entry.async("text");
        const texts = $08414ea58bdc1292$var$extractOpenXmlText(xml);
        const rels = await $08414ea58bdc1292$var$readPptxRelationships(zip, entry.name);
        const layout = await $08414ea58bdc1292$var$resolvePptxSlideLayout(zip, entry.name, rels);
        if (layout) layouts.add(layout);
        const slideImageCount = $08414ea58bdc1292$var$countPptxSlideImages(xml, rels);
        const notesPath = $08414ea58bdc1292$var$resolvePptxRelationshipTarget(entry.name, rels.find((rel)=>/\/notesSlide$/i.test(rel.type))?.target);
        const notesXml = notesPath ? await zip.file(notesPath)?.async("text") : void 0;
        const slideNotesCount = notesXml ? $08414ea58bdc1292$var$extractOpenXmlText(notesXml).length : 0;
        const hasTransition = /<p:transition\b/i.test(xml);
        const slideAnimationCount = $08414ea58bdc1292$var$countMatches3(xml, /<p:(?:anim|animEffect|animMotion|animRot|animScale|cmd|set)\b/gi);
        imageCount += slideImageCount;
        notesCount += slideNotesCount;
        transitionCount += hasTransition ? 1 : 0;
        animationCount += slideAnimationCount;
        slides.push({
            title: texts[0] || `Slide ${slides.length + 1}`,
            layout: layout,
            textCount: texts.length,
            imageCount: slideImageCount,
            notesCount: slideNotesCount,
            hasTransition: hasTransition,
            animationCount: slideAnimationCount,
            sampleTexts: texts.slice(0, 4)
        });
    }
    return {
        title: "PPTX \u6F14\u793A\u6587\u7A3F\u7ED3\u6784",
        slideCount: slides.length,
        imageCount: imageCount,
        notesCount: notesCount,
        transitionCount: transitionCount,
        animationCount: animationCount,
        layouts: Array.from(layouts),
        slides: slides
    };
}
function $08414ea58bdc1292$var$inspectOpenDocumentPresentation(title, xml, totalImages) {
    const pages = xml.split(/<draw:page\b/).slice(1);
    const pageSources = pages.length > 0 ? pages : [
        xml
    ];
    const slides = pageSources.map((pageXml, index)=>{
        const texts = $08414ea58bdc1292$var$extractOpenDocumentBlocks(pageXml);
        const layout = $08414ea58bdc1292$var$matchXmlAttribute(pageXml, /presentation:class="([^"]+)"/i) || $08414ea58bdc1292$var$matchXmlAttribute(pageXml, /draw:style-name="([^"]+)"/i) || void 0;
        const imageCount = $08414ea58bdc1292$var$countMatches3(pageXml, /<draw:image\b/gi);
        const hasTransition = /presentation:transition-type=|presentation:transition-style=|smil:type=/i.test(pageXml);
        const animationCount = $08414ea58bdc1292$var$countMatches3(pageXml, /<anim:|<presentation:animations\b|<presentation:show-shape\b/gi);
        return {
            title: texts[0] || `Slide ${index + 1}`,
            layout: layout,
            textCount: texts.length,
            imageCount: imageCount,
            notesCount: $08414ea58bdc1292$var$countMatches3(pageXml, /<presentation:notes\b/gi),
            hasTransition: hasTransition,
            animationCount: animationCount,
            sampleTexts: texts.slice(0, 4)
        };
    });
    const layouts = new Set(slides.map((slide)=>slide.layout).filter(Boolean));
    return {
        title: title,
        slideCount: slides.length,
        imageCount: Math.max(totalImages, slides.reduce((sum, slide)=>sum + slide.imageCount, 0)),
        notesCount: slides.reduce((sum, slide)=>sum + slide.notesCount, 0),
        transitionCount: slides.filter((slide)=>slide.hasTransition).length,
        animationCount: slides.reduce((sum, slide)=>sum + slide.animationCount, 0),
        layouts: Array.from(layouts),
        slides: slides
    };
}
async function $08414ea58bdc1292$var$renderPresentationInsight(panel, insight) {
    const summary = document.createElement("div");
    summary.className = "ofv-presentation-summary";
    summary.hidden = true;
    summary.setAttribute("aria-hidden", "true");
    summary.style.display = "none";
    summary.dataset.slideCount = String(insight.slideCount);
    summary.dataset.imageCount = String(insight.imageCount);
    summary.dataset.notesCount = String(insight.notesCount);
    summary.dataset.transitionCount = String(insight.transitionCount);
    summary.dataset.animationCount = String(insight.animationCount);
    const stats = [
        `${insight.slideCount} \u9875`,
        `${insight.layouts.length || 0} \u79CD\u5E03\u5C40`,
        `${insight.imageCount} \u5F20\u56FE\u7247`,
        `${insight.notesCount} \u6761\u5907\u6CE8`,
        `${insight.transitionCount} \u9875\u5207\u6362`,
        `${insight.animationCount} \u4E2A\u52A8\u753B\u6807\u8BB0`
    ];
    summary.append($08414ea58bdc1292$var$createPresentationMetric(insight.title, stats.join(" \xB7 ")));
    if (insight.layouts.length > 0) summary.append($08414ea58bdc1292$var$createPresentationMetric("\u5E03\u5C40", insight.layouts.join("\u3001")));
    panel.append(summary);
}
function $08414ea58bdc1292$var$createPresentationMetric(label, value) {
    const metric = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = label;
    const span = document.createElement("span");
    span.textContent = value;
    metric.append(strong, span);
    return metric;
}
async function $08414ea58bdc1292$var$readPptxRelationships(zip, partPath) {
    const relsPath = $08414ea58bdc1292$var$relationshipPathForPart(partPath);
    const xml = await zip.file(relsPath)?.async("text");
    if (!xml) return [];
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return [];
    return Array.from(doc.getElementsByTagNameNS($08414ea58bdc1292$var$PPTX_REL_NS, "Relationship")).map((element)=>({
            id: element.getAttribute("Id") || "",
            type: element.getAttribute("Type") || "",
            target: element.getAttribute("Target") || ""
        }));
}
async function $08414ea58bdc1292$var$resolvePptxSlideLayout(zip, slidePath, rels) {
    const layoutRel = rels.find((rel)=>/\/slideLayout$/i.test(rel.type));
    const layoutPath = $08414ea58bdc1292$var$resolvePptxRelationshipTarget(slidePath, layoutRel?.target);
    const xml = layoutPath ? await zip.file(layoutPath)?.async("text") : void 0;
    if (!xml) return layoutPath?.split("/").pop()?.replace(/\.xml$/i, "");
    return $08414ea58bdc1292$var$matchXmlAttribute(xml, /<p:cSld\b[^>]*name="([^"]+)"/i) || layoutPath?.split("/").pop()?.replace(/\.xml$/i, "");
}
function $08414ea58bdc1292$var$countPptxSlideImages(xml, rels) {
    const relImageIds = new Set(rels.filter((rel)=>/\/image$/i.test(rel.type)).map((rel)=>rel.id));
    const embeddedIds = [
        ...xml.matchAll(/<a:blip\b[^>]*(?:r:embed|r:link)="([^"]+)"/gi)
    ].map((match)=>match[1]);
    if (embeddedIds.length > 0) return embeddedIds.filter((id)=>relImageIds.size === 0 || relImageIds.has(id)).length;
    return relImageIds.size;
}
function $08414ea58bdc1292$var$relationshipPathForPart(partPath) {
    const parts = partPath.split("/");
    const fileName = parts.pop() || partPath;
    return `${parts.join("/")}/_rels/${fileName}.rels`;
}
function $08414ea58bdc1292$var$resolvePptxRelationshipTarget(sourcePath, target) {
    if (!target || /^[a-z]+:/i.test(target)) return void 0;
    if (target.startsWith("/")) return target.slice(1);
    const base = sourcePath.split("/").slice(0, -1);
    for (const segment of target.split("/")){
        if (!segment || segment === ".") continue;
        if (segment === "..") base.pop();
        else base.push(segment);
    }
    return base.join("/");
}
function $08414ea58bdc1292$var$slideNumberFromPath(path) {
    return Number(path.match(/slide(\d+)\.xml$/i)?.[1] || "0");
}
function $08414ea58bdc1292$var$countMatches3(value, pattern) {
    return [
        ...value.matchAll(pattern)
    ].length;
}
function $08414ea58bdc1292$var$matchXmlAttribute(value, pattern) {
    const match = value.match(pattern);
    return match ? $08414ea58bdc1292$var$decodeXml2(match[1] || "") : null;
}
function $08414ea58bdc1292$var$titleFromOdf(xml, fallback) {
    return $08414ea58bdc1292$var$matchXmlAttribute(xml, /<office:meta[\s\S]*?<dc:title[^>]*>([\s\S]*?)<\/dc:title>/i) || fallback;
}
function $08414ea58bdc1292$var$isLegacyOfficeBinary(extension) {
    return [
        "doc",
        "dot",
        "wps",
        "xls",
        "xlt",
        "xlsb",
        "et",
        "ppt",
        "pps",
        "key",
        "dps"
    ].includes(extension);
}
function $08414ea58bdc1292$var$legacyOfficeFormatLabel(extension) {
    if (extension === "doc" || extension === "dot" || extension === "wps") return "Word Binary File Format";
    if (extension === "xls" || extension === "xlt" || extension === "xlsb" || extension === "et") return "Excel Binary File Format";
    if (extension === "key") return "Apple Keynote / legacy presentation package";
    if (extension === "dps") return "WPS Presentation legacy format";
    return "PowerPoint Binary File Format";
}
async function $08414ea58bdc1292$var$renderLegacyPowerPoint(panel, arrayBuffer) {
    const presentation = await $08414ea58bdc1292$var$parseLegacyPowerPoint(arrayBuffer);
    const imageSources = await $08414ea58bdc1292$var$prepareLegacyPowerPointImages(presentation.images);
    const viewer = document.createElement("div");
    viewer.className = "ofv-ppt-binary-viewer";
    viewer.style.setProperty("--ofv-ppt-aspect", `${presentation.width} / ${presentation.height}`);
    for (const [slideIndex, slide] of presentation.slides.entries()){
        const masterShapes = slide.masterShapes || presentation.masterShapes;
        const hasMasterBackground = masterShapes.some((shape)=>shape.imageIndices.some((index)=>imageSources.has(index)) && shape.left <= presentation.width * 0.02 && shape.top <= presentation.height * 0.02 && shape.width >= presentation.width * 0.9 && shape.height >= presentation.height * 0.9);
        const article = document.createElement("article");
        article.className = `ofv-ppt-binary-slide${hasMasterBackground ? " ofv-ppt-binary-has-master-background" : ""}`;
        article.dataset.slideIndex = String(slideIndex);
        article.setAttribute("aria-label", `Slide ${slideIndex + 1}`);
        const canvas = document.createElement("div");
        canvas.className = "ofv-ppt-binary-canvas";
        const tableCells = $08414ea58bdc1292$var$findLegacyPowerPointTableCells(slide.shapes);
        const tableLines = $08414ea58bdc1292$var$findLegacyPowerPointTableLines(slide.shapes, tableCells);
        const masterFillTexts = $08414ea58bdc1292$var$findLegacyPowerPointFillTexts(masterShapes);
        const slideFillTexts = $08414ea58bdc1292$var$findLegacyPowerPointFillTexts(slide.shapes);
        const masterDarkFillTexts = $08414ea58bdc1292$var$findLegacyPowerPointDarkFillTexts(masterShapes);
        const slideDarkFillTexts = $08414ea58bdc1292$var$findLegacyPowerPointDarkFillTexts(slide.shapes);
        const masterPictureOverlayTexts = $08414ea58bdc1292$var$findLegacyPowerPointPictureOverlayTexts(masterShapes);
        const slidePictureOverlayTexts = $08414ea58bdc1292$var$findLegacyPowerPointPictureOverlayTexts(slide.shapes);
        for (const shape of masterShapes)$08414ea58bdc1292$var$renderLegacyPowerPointShape(canvas, shape, presentation, slide.masterTextStyles, imageSources, true, false, false, masterFillTexts.has(shape), masterDarkFillTexts.has(shape), masterPictureOverlayTexts.has(shape));
        for (const shape of slide.shapes)$08414ea58bdc1292$var$renderLegacyPowerPointShape(canvas, shape, presentation, slide.masterTextStyles, imageSources, false, tableCells.has(shape), tableLines.has(shape), slideFillTexts.has(shape), slideDarkFillTexts.has(shape), slidePictureOverlayTexts.has(shape));
        if (!canvas.hasChildNodes()) {
            const empty = document.createElement("p");
            empty.className = "ofv-ppt-binary-empty";
            empty.textContent = `Slide ${slideIndex + 1}`;
            canvas.append(empty);
        }
        const number = document.createElement("span");
        number.className = "ofv-ppt-binary-slide-number";
        number.textContent = String(slideIndex + 1);
        article.append(canvas, number);
        viewer.append(article);
    }
    panel.replaceChildren(viewer);
    return ()=>{
        for (const source of imageSources.values())if (source.revoke) URL.revokeObjectURL(source.src);
    };
}

async function $08414ea58bdc1292$var$prepareLegacyPowerPointImages(images) {
    const sources = /* @__PURE__ */ new Map();
    const metafiles = images.filter((image)=>image.kind !== "bitmap");
    let converter;
    if (metafiles.length > 0) try {
        converter = await (parcelRequire("gTsRe"));
    } catch (error) {
        console.warn("Presentation metafile renderer could not be loaded:", error);
    }
    for (const image of images){
        if (image.kind === "bitmap") {
            const url = URL.createObjectURL(new Blob([
                $08414ea58bdc1292$var$toStandaloneArrayBuffer(image.bytes)
            ], {
                type: image.mimeType
            }));
            sources.set(image.index, {
                src: url,
                revoke: true
            });
            continue;
        }
        if (!converter) continue;
        try {
            const buffer = $08414ea58bdc1292$var$toStandaloneArrayBuffer(image.bytes);
            const dataUrl = await converter.convertMetafileToDataUrl(buffer, {
                maxWidth: 1600,
                maxHeight: 1200,
                dpiScale: 1.5
            });
            if (dataUrl) sources.set(image.index, {
                src: dataUrl,
                revoke: false
            });
        } catch (error) {
            console.warn(`Presentation ${image.kind.toUpperCase()} image could not be rendered:`, error);
        }
    }
    return sources;
}
function $08414ea58bdc1292$var$renderLegacyPowerPointShape(canvas, shape, presentation, masterTextStyles, imageSources, master, tableCell = false, tableLine = false, overFill = false, overDarkFill = false, pictureOverlay = false) {
    const usableImages = shape.imageIndices.map((index)=>imageSources.get(index)).filter((source)=>Boolean(source));
    const texts = shape.texts;
    const hasVisualStyle = shape.fillEnabled === true || shape.lineEnabled === true;
    if (usableImages.length === 0 && texts.length === 0 && !hasVisualStyle) return;
    const element = document.createElement("div");
    element.className = `ofv-ppt-binary-shape${master ? " ofv-ppt-binary-master-shape" : ""}`;
    const left = $08414ea58bdc1292$var$clampPresentationRatio(shape.left / presentation.width, -1, 1);
    const top = $08414ea58bdc1292$var$clampPresentationRatio(shape.top / presentation.height, -1, 1);
    const width = $08414ea58bdc1292$var$clampPresentationRatio(shape.width / presentation.width, 1e-3, 2);
    const height = $08414ea58bdc1292$var$clampPresentationRatio(shape.height / presentation.height, 1e-3, 2);
    element.style.left = `${left * 100}%`;
    element.style.top = `${top * 100}%`;
    element.style.width = `${width * 100}%`;
    element.style.height = `${height * 100}%`;
    if (shape.fillEnabled && shape.fillColor) element.style.backgroundColor = shape.fillColor;
    const isLineShape = shape.shapeType === 20;
    if (shape.lineEnabled && !isLineShape) {
        element.style.borderStyle = "solid";
        element.style.borderColor = shape.lineColor || "#000";
        element.style.borderWidth = `${shape.lineWidth || 0.75}pt`;
    }
    if (tableLine) element.style.borderColor = "#fff";
    if (shape.rotation) element.style.transform = `rotate(${shape.rotation}deg)`;
    if (shape.shapeType === 2) element.classList.add("ofv-ppt-binary-round-rectangle");
    else if (shape.shapeType === 3 || shape.shapeType === 120) element.classList.add("ofv-ppt-binary-ellipse");
    else if (shape.shapeType === 4) element.classList.add("ofv-ppt-binary-diamond");
    else if (shape.shapeType === 20) element.classList.add("ofv-ppt-binary-line-shape");
    else if (shape.shapeType === 67) element.classList.add("ofv-ppt-binary-down-arrow");
    else if (shape.shapeType === 176) element.classList.add("ofv-ppt-binary-round-rectangle");
    else if (shape.shapeType === 0 && shape.rotation) element.classList.add("ofv-ppt-binary-right-arrow");
    if (isLineShape && shape.lineEnabled) $08414ea58bdc1292$var$appendLegacyPowerPointLine(element, shape, tableLine ? "#fff" : shape.lineColor || "#000");
    for (const source of usableImages){
        const image = document.createElement("img");
        image.className = "ofv-ppt-binary-image";
        image.src = source.src;
        image.alt = "";
        image.draggable = false;
        $08414ea58bdc1292$var$applyLegacyPowerPointImageCrop(image, shape);
        element.append(image);
    }
    if (texts.length > 0) {
        const text = document.createElement("div");
        const filledText = shape.fillEnabled && shape.fillColor || overFill ? " ofv-ppt-binary-filled-text" : "";
        const sectionNumber = $08414ea58bdc1292$var$isLegacyPowerPointSectionNumber(shape, presentation) ? " ofv-ppt-binary-section-number" : "";
        const sectionHeading = $08414ea58bdc1292$var$isLegacyPowerPointSectionHeading(shape, presentation) ? " ofv-ppt-binary-section-heading" : "";
        const pictureOverlayText = pictureOverlay ? " ofv-ppt-binary-picture-overlay-text" : "";
        const textKind = master ? "" : $08414ea58bdc1292$var$isLegacyPowerPointTitle(shape, presentation) ? " ofv-ppt-binary-title" : tableCell ? " ofv-ppt-binary-table-cell" : $08414ea58bdc1292$var$isLegacyPowerPointBody(shape, presentation) ? " ofv-ppt-binary-body-text" : "";
        text.className = `ofv-ppt-binary-text${textKind}${filledText}${sectionNumber}${sectionHeading}${pictureOverlayText}`;
        if (!filledText && !sectionNumber && !pictureOverlayText && !tableCell && !shape.verticalText) text.classList.add("ofv-ppt-binary-plain-text");
        if (shape.verticalText) {
            text.classList.add("ofv-ppt-binary-vertical-text");
            element.classList.add("ofv-ppt-binary-vertical-text-shape");
        }
        if (overDarkFill || shape.fillColor && $08414ea58bdc1292$var$hasDarkPresentationFill(shape.fillColor)) text.style.color = "#fff";
        const formattedTexts = shape.formattedTexts || [];
        const binaryStyled = formattedTexts.some((block)=>block.characterRuns.some((run)=>run.bold !== void 0 || run.italic !== void 0 || run.underline !== void 0 || run.fontSize !== void 0 || run.color !== void 0 || run.fontRef !== void 0) || block.paragraphRuns.some((run)=>run.alignment !== void 0 || run.lineSpacing !== void 0));
        if (binaryStyled) {
            text.classList.add("ofv-ppt-binary-styled-text");
            if (texts.every((value)=>!/[\r\n]/.test(value)) && texts.join("").length <= 16) {
                element.classList.add("ofv-ppt-binary-short-text-shape");
                if (texts.join("") !== "Contents Page" && !filledText) element.classList.add("ofv-ppt-binary-nowrap-short-text-shape");
            }
            if (textKind.includes("ofv-ppt-binary-title") && !/[\r\n]/.test(texts.join("")) && texts.join("").length > 16) element.classList.add("ofv-ppt-binary-nowrap-title-shape");
            $08414ea58bdc1292$var$renderLegacyPowerPointFormattedText(text, formattedTexts, presentation.fonts, masterTextStyles[shape.textType ?? 4] || []);
        } else text.textContent = texts.join("\n");
        element.append(text);
    }
    canvas.append(element);
}
function $08414ea58bdc1292$var$appendLegacyPowerPointLine(target, shape, color) {
    const namespace = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(namespace, "svg");
    svg.classList.add("ofv-ppt-binary-line-svg");
    svg.setAttribute("viewBox", "0 0 100 100");
    svg.setAttribute("preserveAspectRatio", "none");
    const line = document.createElementNS(namespace, "line");
    line.setAttribute("x1", shape.flipHorizontal ? "100" : "0");
    line.setAttribute("y1", shape.flipVertical ? "100" : "0");
    line.setAttribute("x2", shape.flipHorizontal ? "0" : "100");
    line.setAttribute("y2", shape.flipVertical ? "0" : "100");
    line.setAttribute("vector-effect", "non-scaling-stroke");
    line.style.stroke = color;
    line.style.strokeWidth = `${(shape.lineWidth || 0.75) / 7.2}cqw`;
    svg.append(line);
    target.append(svg);
}
function $08414ea58bdc1292$var$applyLegacyPowerPointImageCrop(image, shape) {
    const top = shape.imageCropTop || 0;
    const bottom = shape.imageCropBottom || 0;
    const left = shape.imageCropLeft || 0;
    const right = shape.imageCropRight || 0;
    if (top === 0 && bottom === 0 && left === 0 && right === 0) return;
    const visibleWidth = Math.max(0.01, 1 - left - right);
    const visibleHeight = Math.max(0.01, 1 - top - bottom);
    image.style.position = "absolute";
    image.style.maxWidth = "none";
    image.style.width = `${100 / visibleWidth}%`;
    image.style.height = `${100 / visibleHeight}%`;
    image.style.left = `${-left / visibleWidth * 100}%`;
    image.style.top = `${-top / visibleHeight * 100}%`;
}
function $08414ea58bdc1292$var$renderLegacyPowerPointFormattedText(target, blocks, fonts, masterStyles) {
    for (const [blockIndex, block] of blocks.entries()){
        if (blockIndex > 0) target.append(document.createTextNode("\n"));
        const firstParagraph = block.paragraphRuns[0];
        if (firstParagraph?.alignment) target.style.textAlign = firstParagraph.alignment;
        if (firstParagraph?.lineSpacing) target.style.lineHeight = String(firstParagraph.lineSpacing * 1.2);
        let cursor = 0;
        for (const run of block.characterRuns){
            const paragraph = block.paragraphRuns.find((candidate)=>run.start >= candidate.start && run.start < candidate.start + Math.max(1, candidate.length));
            const inherited = masterStyles[paragraph?.indentLevel || 0] || masterStyles[0] || {};
            const effective = {
                ...inherited,
                ...run
            };
            const start = Math.max(cursor, Math.min(block.text.length, run.start));
            if (start > cursor) target.append(document.createTextNode(block.text.slice(cursor, start)));
            const end = Math.max(start, Math.min(block.text.length, run.start + run.length));
            if (end > start) {
                const span = document.createElement("span");
                span.textContent = block.text.slice(start, end);
                if (effective.bold !== void 0) span.style.fontWeight = effective.bold ? "700" : "400";
                if (effective.italic !== void 0) span.style.fontStyle = effective.italic ? "italic" : "normal";
                if (effective.underline !== void 0) span.style.textDecoration = effective.underline ? "underline" : "none";
                if (effective.fontSize !== void 0 && effective.fontSize > 0) span.style.fontSize = `${effective.fontSize / 7.2}cqw`;
                if (effective.color) span.style.color = effective.color;
                const fontFamily = effective.fontRef === void 0 ? void 0 : fonts[effective.fontRef];
                if (fontFamily) span.style.fontFamily = `"${fontFamily.replaceAll('"', '\\"')}", sans-serif`;
                target.append(span);
            }
            cursor = Math.max(cursor, end);
        }
        if (cursor < block.text.length) target.append(document.createTextNode(block.text.slice(cursor)));
    }
}
function $08414ea58bdc1292$var$isLegacyPowerPointTitle(shape, presentation) {
    const shortSingleLineText = shape.texts.length === 1 && !shape.texts[0].includes("\n") && shape.texts[0].length <= 32;
    return shape.textType === 0 || shape.textType === 6 || shortSingleLineText && shape.width >= presentation.width * 0.6 && shape.height <= presentation.height * 0.18;
}
function $08414ea58bdc1292$var$isLegacyPowerPointSectionNumber(shape, presentation) {
    return shape.texts.length === 1 && /^[1-9一二三四五六七八九十]$/.test(shape.texts[0]) && shape.width <= presentation.width * 0.1 && shape.height <= presentation.height * 0.11 && shape.width / Math.max(1, shape.height) >= 0.65 && shape.width / Math.max(1, shape.height) <= 1.55;
}
function $08414ea58bdc1292$var$isLegacyPowerPointSectionHeading(shape, presentation) {
    const shortSingleLineText = shape.texts.length === 1 && !shape.texts[0].includes("\n") && shape.texts[0].length <= 28;
    const nearTopLeft = shape.top < presentation.height * 0.12 && shape.left < presentation.width * 0.2;
    const sectionPageTitle = shape.top >= presentation.height * 0.15 && shape.top < presentation.height * 0.3 && shape.left >= presentation.width * 0.2 && shape.left < presentation.width * 0.4 && shape.width >= presentation.width * 0.5;
    return shortSingleLineText && shape.width >= presentation.width * 0.2 && (nearTopLeft || sectionPageTitle);
}
function $08414ea58bdc1292$var$hasDarkPresentationFill(color) {
    const match = /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(color);
    if (!match) return false;
    const [red, green, blue] = match.slice(1).map((channel)=>Number.parseInt(channel, 16));
    return red * 0.299 + green * 0.587 + blue * 0.114 < 145;
}
function $08414ea58bdc1292$var$findLegacyPowerPointDarkFillTexts(shapes) {
    const darkVisuals = shapes.filter((shape)=>shape.fillEnabled && shape.fillColor && $08414ea58bdc1292$var$hasDarkPresentationFill(shape.fillColor) && shape.texts.length === 0);
    const pictureOverlayTexts = $08414ea58bdc1292$var$findLegacyPowerPointPictureOverlayTexts(shapes);
    return new Set(shapes.filter((shape)=>{
        if (shape.texts.length === 0 || shape.fillEnabled && shape.fillColor) return false;
        const centerX = shape.left + shape.width / 2;
        const centerY = shape.top + shape.height / 2;
        return darkVisuals.some((visual)=>$08414ea58bdc1292$var$containsPresentationPoint(visual, centerX, centerY)) || pictureOverlayTexts.has(shape);
    }));
}
function $08414ea58bdc1292$var$findLegacyPowerPointFillTexts(shapes) {
    const visuals = shapes.filter((shape)=>shape.fillEnabled && shape.fillColor && shape.texts.length === 0);
    const pictureOverlayTexts = $08414ea58bdc1292$var$findLegacyPowerPointPictureOverlayTexts(shapes);
    return new Set(shapes.filter((shape)=>{
        if (shape.texts.length === 0 || shape.fillEnabled && shape.fillColor) return false;
        const centerX = shape.left + shape.width / 2;
        const centerY = shape.top + shape.height / 2;
        return visuals.some((visual)=>$08414ea58bdc1292$var$containsPresentationPoint(visual, centerX, centerY)) || pictureOverlayTexts.has(shape);
    }));
}
function $08414ea58bdc1292$var$containsPresentationPoint(shape, x, y) {
    return x >= shape.left && x <= shape.left + shape.width && y >= shape.top && y <= shape.top + shape.height;
}
function $08414ea58bdc1292$var$findLegacyPowerPointPictureOverlayTexts(shapes) {
    const pictures = shapes.filter((shape)=>shape.shapeType === 75 && shape.texts.length === 0);
    return new Set(shapes.filter((shape)=>{
        const centerX = shape.left + shape.width / 2;
        const centerY = shape.top + shape.height / 2;
        return $08414ea58bdc1292$var$isLongPictureOverlayText(shape, pictures, centerX, centerY);
    }));
}
function $08414ea58bdc1292$var$isLongPictureOverlayText(shape, pictures, centerX, centerY) {
    return shape.texts.join("").length > 32 && shape.width >= 3e3 && shape.height <= 700 && pictures.some((picture)=>$08414ea58bdc1292$var$containsPresentationPoint(picture, centerX, centerY));
}
function $08414ea58bdc1292$var$isLegacyPowerPointBody(shape, presentation) {
    return [
        1,
        5,
        7,
        8
    ].includes(shape.textType ?? -1) || shape.top < presentation.height * 0.24 && shape.height > presentation.height * 0.45;
}
function $08414ea58bdc1292$var$findLegacyPowerPointTableCells(shapes) {
    const rows = /* @__PURE__ */ new Map();
    for (const shape of shapes){
        if (shape.texts.length !== 1 || shape.imageIndices.length > 0 || shape.texts[0].length > 80) continue;
        const key = Math.round(shape.top / 4) * 4;
        const row = rows.get(key) || [];
        row.push(shape);
        rows.set(key, row);
    }
    const cells = /* @__PURE__ */ new Set();
    for (const row of rows.values())if (row.length >= 3) row.forEach((shape)=>cells.add(shape));
    return cells;
}
function $08414ea58bdc1292$var$findLegacyPowerPointTableLines(shapes, cells) {
    if (cells.size < 8) return /* @__PURE__ */ new Set();
    const cellList = [
        ...cells
    ];
    const left = Math.min(...cellList.map((shape)=>shape.left));
    const top = Math.min(...cellList.map((shape)=>shape.top));
    const right = Math.max(...cellList.map((shape)=>shape.left + shape.width));
    const bottom = Math.max(...cellList.map((shape)=>shape.top + shape.height));
    const tolerance = 24;
    return new Set(shapes.filter((shape)=>shape.shapeType === 20 && shape.texts.length === 0 && shape.left + shape.width >= left - tolerance && shape.left <= right + tolerance && shape.top + shape.height >= top - tolerance && shape.top <= bottom + tolerance));
}
function $08414ea58bdc1292$var$clampPresentationRatio(value, minimum = 0, maximum = 1) {
    return Number.isFinite(value) ? Math.min(maximum, Math.max(minimum, value)) : minimum;
}
function $08414ea58bdc1292$var$toStandaloneArrayBuffer(bytes) {
    return bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
}
function $08414ea58bdc1292$var$renderLegacyWordBinary(panel, extension, arrayBuffer, messages) {
    try {
        $08414ea58bdc1292$var$renderLegacyWordDocument(panel, $08414ea58bdc1292$var$parseLegacyWordDocument(arrayBuffer));
    } catch (error) {
        $08414ea58bdc1292$var$renderLegacyOfficeBinary(panel, extension, arrayBuffer, messages, (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.officeLegacyWordParseFailed, {
            message: $08414ea58bdc1292$var$normalizeOfficeError(error, messages)
        }));
    }
}
function $08414ea58bdc1292$var$renderLegacyOfficeBinary(panel, extension, arrayBuffer, messages, parseError) {
    const fragments = $08414ea58bdc1292$var$extractLegacyOfficeText(arrayBuffer);
    panel.replaceChildren();
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(messages.officeLegacyConversionTitle);
    section.classList.add("ofv-office-conversion");
    const format = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = `.${extension}`;
    format.append(strong, document.createTextNode(" "), document.createTextNode(messages.officeLegacyBinaryNotice));
    const meta = document.createElement("dl");
    meta.className = "ofv-office-binary-meta";
    $08414ea58bdc1292$var$appendOfficeBinaryMeta(meta, messages.officeLegacyMetaFormatType, $08414ea58bdc1292$var$legacyOfficeFormatLabel(extension));
    $08414ea58bdc1292$var$appendOfficeBinaryMeta(meta, messages.officeLegacyMetaFileStructure, $08414ea58bdc1292$var$hasOleSignature(arrayBuffer) ? messages.officeLegacyOleDetected : messages.officeLegacyOleMissing);
    $08414ea58bdc1292$var$appendOfficeBinaryMeta(meta, messages.officeLegacyMetaTextFragments, (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.officeLegacyTextFragmentCount, {
        count: fragments.length.toLocaleString()
    }));
    if (parseError) $08414ea58bdc1292$var$appendOfficeBinaryMeta(meta, messages.officeLegacyMetaParseStatus, parseError);
    section.append(format, meta);
    if (fragments.length > 0) {
        const article = document.createElement("article");
        article.className = "ofv-document ofv-office-binary-fragments";
        const heading = document.createElement("h4");
        heading.textContent = messages.officeLegacyReadableFragments;
        article.append(heading);
        for (const fragment of fragments.slice(0, 80)){
            const paragraph = document.createElement("p");
            paragraph.textContent = fragment;
            article.append(paragraph);
        }
        section.append(article);
    } else {
        const empty = document.createElement("p");
        empty.className = "ofv-office-binary-empty";
        empty.textContent = messages.officeLegacyNoText;
        section.append(empty);
    }
    panel.append(section);
}
function $08414ea58bdc1292$var$appendOfficeBinaryMeta(list, label, value) {
    const term = document.createElement("dt");
    term.textContent = label;
    const detail = document.createElement("dd");
    detail.textContent = value;
    list.append(term, detail);
}
function $08414ea58bdc1292$var$renderUnsupportedOffice(panel, extension, messages) {
    const legacyBinary = /* @__PURE__ */ new Set([
        "doc",
        "dot",
        "wps",
        "ppt",
        "pps",
        "key",
        "dps"
    ]);
    const message = legacyBinary.has(extension) ? messages.officeUnsupportedLegacyMessage : messages.officeUnsupportedGenericMessage;
    panel.replaceChildren();
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(messages.officeUnsupportedTitle);
    const format = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = `.${extension}`;
    format.append(strong, document.createTextNode(" "), document.createTextNode((0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.officeUnsupportedIntro, {
        message: message
    })));
    const support = document.createElement("p");
    support.textContent = messages.officeUnsupportedSupportedFormats;
    section.append(format, support);
    panel.append(section);
}
function $08414ea58bdc1292$var$normalizeOfficeError(error, messages) {
    const message = error instanceof Error ? error.message : String(error || "");
    return message ? (0, $3438a2478d5b847f$export$40b3ce2549faa304)(messages.officeErrorWithMessage, {
        message: message
    }) : messages.officeErrorWithoutMessage;
}
function $08414ea58bdc1292$var$extractLegacyOfficeText(arrayBuffer) {
    const bytes = new Uint8Array(arrayBuffer);
    const fragments = [
        ...$08414ea58bdc1292$var$extractPrintableRuns(bytes).map((text)=>({
                text: text,
                source: "ascii"
            })),
        ...$08414ea58bdc1292$var$extractUtf16Runs(bytes).map((text)=>({
                text: text,
                source: "utf16"
            }))
    ].map(({ text: text, source: source })=>({
            text: $08414ea58bdc1292$var$normalizeLegacyText(text),
            source: source
        })).filter(({ text: text, source: source })=>$08414ea58bdc1292$var$isReadableLegacyTextFragment(text, source));
    const unique2 = [];
    const seen = /* @__PURE__ */ new Set();
    for (const { text: fragment } of fragments){
        const key = fragment.toLowerCase();
        if (!seen.has(key)) {
            seen.add(key);
            unique2.push(fragment);
        }
    }
    return unique2.slice(0, 160);
}
function $08414ea58bdc1292$var$isReadableLegacyTextFragment(fragment, source) {
    if (fragment.length > 600) return false;
    if ($08414ea58bdc1292$var$isLegacyOfficeMetadataNoise(fragment)) return false;
    if (!/[\p{L}\p{N}]/u.test(fragment)) return false;
    const chars = Array.from(fragment);
    const letters = chars.filter((char)=>/\p{L}/u.test(char)).length;
    const digits = chars.filter((char)=>/\p{N}/u.test(char)).length;
    const spaces = chars.filter((char)=>/\s/u.test(char)).length;
    const asciiLetters = chars.filter((char)=>/[A-Za-z]/.test(char)).length;
    const cjkLetters = chars.filter((char)=>/[\u3400-\u9fff]/u.test(char)).length;
    const punctuation = chars.filter((char)=>/[^\p{L}\p{N}\s]/u.test(char)).length;
    const alphaNumeric = letters + digits;
    const readableRatio = alphaNumeric / chars.length;
    const punctuationRatio = punctuation / chars.length;
    if (fragment.length < 4 || readableRatio < 0.55 || punctuationRatio > 0.24) return false;
    if (/([\p{L}\p{N}])\1{4,}/u.test(fragment)) return false;
    if (cjkLetters >= 2) {
        const suspiciousCjk = chars.filter((char)=>$08414ea58bdc1292$var$isAsciiBytePairCjk(char)).length;
        if (suspiciousCjk / cjkLetters > 0.65) return false;
        if ($08414ea58bdc1292$var$isLikelyCjkHeading(fragment)) return true;
        if (punctuation > 0 && fragment.length < 12) return false;
        return cjkLetters >= 8 || cjkLetters >= 4 && spaces > 0;
    }
    if (asciiLetters >= 4) {
        if (punctuation > 0 && spaces === 0) return false;
        if (source === "ascii" && /^[A-Z]{2,8}$/.test(fragment)) return false;
        if (spaces > 0) return letters >= 3;
        return fragment.length >= 6;
    }
    if (spaces > 0 && letters >= 3) return true;
    return false;
}
function $08414ea58bdc1292$var$isLegacyOfficeMetadataNoise(fragment) {
    if (/[$�\uFFFD]/u.test(fragment)) return true;
    if (/^(?:Root Entry|WordDocument|Workbook|Book|SummaryInformation|DocumentSummaryInformation|CompObj|ObjectPool|Data|PowerPoint Document|Pictures)$/i.test(fragment)) return true;
    if (/\.(dotm?|docm?|pptx?|ppsx?|xlsm?|xlsx?)\b/i.test(fragment)) return true;
    if (/^(?:默认段落字体|普通表格|正文|标题|副标题|目录|页眉|页脚|批注|超链接)(?:\s*\d+)?$/.test(fragment)) return true;
    if (/\b(?:Normal|Default|Calibri|Times New Roman|WPS Office|Microsoft Office|KSOP?ProductBuildVer)\b/i.test(fragment)) return true;
    if (/^\d+(?:Table|List|Heading|Title|Style)$/i.test(fragment)) return true;
    if (/[{(]?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[})]?/i.test(fragment)) return true;
    if (/^[A-Z_]{3,}$/.test(fragment) || /^[A-Za-z]+(?:Information|Document|Storage|Stream|Table|Data|Pool|Obj|Props)$/i.test(fragment)) return true;
    return false;
}
function $08414ea58bdc1292$var$isLikelyCjkHeading(fragment) {
    return /^(?:标题|第[一二三四五六七八九十\d]+[章节条]|[一二三四五六七八九十\d]+[、.．])\s*[\p{L}\p{N}\s-]*$/u.test(fragment);
}
function $08414ea58bdc1292$var$isAsciiBytePairCjk(char) {
    const code = char.codePointAt(0) || 0;
    if (code < 13312 || code > 40959) return false;
    const low = code & 255;
    const high = code >> 8;
    return $08414ea58bdc1292$var$isPrintableAsciiByte(low) && $08414ea58bdc1292$var$isPrintableAsciiByte(high);
}
function $08414ea58bdc1292$var$isPrintableAsciiByte(value) {
    return value >= 32 && value <= 126;
}
function $08414ea58bdc1292$var$extractPrintableRuns(bytes) {
    const fragments = [];
    let current = "";
    for (const byte of bytes)if (byte >= 32 && byte <= 126 || byte === 9) current += String.fromCharCode(byte);
    else {
        if (current.length >= 4) fragments.push(current);
        current = "";
    }
    if (current.length >= 4) fragments.push(current);
    return fragments;
}
function $08414ea58bdc1292$var$extractUtf16Runs(bytes) {
    const fragments = [];
    let current = "";
    for(let index = 0; index < bytes.length - 1; index += 2){
        if ($08414ea58bdc1292$var$looksLikeMisalignedAsciiUtf16(bytes[index], bytes[index + 1])) {
            if (current.length >= 3) fragments.push(current);
            current = "";
            continue;
        }
        const code = bytes[index] | bytes[index + 1] << 8;
        if (code >= 32 && code <= 55295 || code === 9) current += String.fromCharCode(code);
        else {
            if (current.length >= 3) fragments.push(current);
            current = "";
        }
    }
    if (current.length >= 3) fragments.push(current);
    return fragments;
}
function $08414ea58bdc1292$var$looksLikeMisalignedAsciiUtf16(lowByte, highByte) {
    return lowByte === 0 && (highByte >= 48 && highByte <= 57 || highByte >= 65 && highByte <= 90 || highByte >= 97 && highByte <= 122);
}
function $08414ea58bdc1292$var$normalizeLegacyText(value) {
    return value.replace(/[\u0000-\u001f]+/g, " ").replace(/\s+/g, " ").trim();
}
function $08414ea58bdc1292$var$hasOleSignature(arrayBuffer) {
    const signature = Array.from(new Uint8Array(arrayBuffer.slice(0, 8)));
    return signature.join(",") === "208,207,17,224,161,177,26,225";
}
async function $08414ea58bdc1292$var$extractZipImages(zip, pattern) {
    const images = [];
    for (const entry of Object.values(zip.files).filter((item)=>!item.dir && pattern.test(item.name))){
        const mimeType = $08414ea58bdc1292$var$mimeTypeFromPath(entry.name);
        if (!mimeType.startsWith("image/")) continue;
        images.push({
            name: entry.name.split("/").pop() || entry.name,
            src: `data:${mimeType};base64,${await entry.async("base64")}`
        });
    }
    return images;
}
function $08414ea58bdc1292$var$extractOpenXmlText(xml) {
    return [
        ...xml.matchAll(/<a:t\b[^>]*>([\s\S]*?)<\/a:t>|<w:t\b[^>]*>([\s\S]*?)<\/w:t>/g)
    ].map((match)=>$08414ea58bdc1292$var$cleanOpenXmlText($08414ea58bdc1292$var$decodeXml2(match[1] || match[2] || "")).trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$extractWordParagraphs(xml) {
    const documentXml = $08414ea58bdc1292$var$parseWordXml(xml);
    if (documentXml) {
        const paragraphs = Array.from(documentXml.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>$08414ea58bdc1292$var$extractOpenXmlTextFromElement(paragraph).join("")).map((text)=>text.trim()).filter(Boolean);
        if (paragraphs.length > 0) return paragraphs;
    }
    return $08414ea58bdc1292$var$extractWordParagraphsByRegex(xml);
}
function $08414ea58bdc1292$var$extractWordTextboxParagraphs(xml) {
    const paragraphs = $08414ea58bdc1292$var$extractWordTextboxParagraphsByRegex(xml);
    if (paragraphs.length > 0) return paragraphs;
    const documentXml = $08414ea58bdc1292$var$parseWordXml(xml);
    return documentXml ? Array.from(documentXml.getElementsByTagName("*")).filter((element)=>element.localName === "txbxContent").flatMap((textbox)=>Array.from(textbox.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>$08414ea58bdc1292$var$extractOpenXmlTextFromElement(paragraph).join("")).map((text)=>text.trim()).filter(Boolean)) : [];
}
function $08414ea58bdc1292$var$parseWordXml(xml) {
    if (typeof DOMParser === "undefined") return void 0;
    try {
        const documentXml = new DOMParser().parseFromString(xml, "application/xml");
        if (documentXml.getElementsByTagName("parsererror").length > 0) return void 0;
        return documentXml;
    } catch  {
        return void 0;
    }
}
function $08414ea58bdc1292$var$extractWordParagraphsByRegex(xml) {
    return [
        ...xml.matchAll(/<w:p\b[\s\S]*?<\/w:p>/g)
    ].map((match)=>$08414ea58bdc1292$var$extractOpenXmlText(match[0]).join("")).map((text)=>text.trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$extractWordTextboxParagraphsByRegex(xml) {
    return [
        ...xml.matchAll(/<w:txbxContent\b[\s\S]*?<\/w:txbxContent>/g)
    ].flatMap((match)=>{
        const textboxXml = $08414ea58bdc1292$var$ensureWordXmlWrapper(match[0]);
        const textboxDocument = $08414ea58bdc1292$var$parseWordXml(textboxXml);
        if (textboxDocument) {
            const paragraphs = Array.from(textboxDocument.getElementsByTagName("*")).filter((element)=>element.localName === "p").map((paragraph)=>$08414ea58bdc1292$var$extractOpenXmlTextFromElement(paragraph).join("")).map((text)=>text.trim()).filter(Boolean);
            if (paragraphs.length > 0) return paragraphs;
        }
        return $08414ea58bdc1292$var$extractWordParagraphsByRegex(match[0]);
    });
}
function $08414ea58bdc1292$var$ensureWordXmlWrapper(xml) {
    return `<?xml version="1.0" encoding="UTF-8"?>
    <ofv:root
      xmlns:ofv="urn:open-file-viewer"
      xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"
      xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml"
      xmlns:wps="http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
      xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"
      xmlns:v="urn:schemas-microsoft-com:vml">
      ${xml}
    </ofv:root>`;
}
function $08414ea58bdc1292$var$extractOpenXmlTextFromElement(element) {
    return Array.from(element.getElementsByTagName("*")).filter((child)=>child.localName === "t").map((child)=>$08414ea58bdc1292$var$cleanOpenXmlText(child.textContent || "").trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$cleanOpenXmlText(value) {
    return value.replace(/<\/?[A-Za-z][\w:.-]*(?:\s+[^<>]*)?>/g, "");
}
function $08414ea58bdc1292$var$dedupeParagraphs(paragraphs) {
    const result = [];
    const seen = /* @__PURE__ */ new Set();
    for (const paragraph of paragraphs){
        const key = $08414ea58bdc1292$var$normalizePreviewText(paragraph);
        if (!key || key === $08414ea58bdc1292$var$normalizePreviewText(result[result.length - 1] || "") || seen.has(key)) continue;
        seen.add(key);
        result.push(paragraph);
    }
    return result;
}
function $08414ea58bdc1292$var$filterCombinedTextboxParagraphs(documentParagraphs, textboxParagraphs) {
    const textboxKeys = textboxParagraphs.map((paragraph)=>$08414ea58bdc1292$var$normalizePreviewText(paragraph)).filter(Boolean);
    if (textboxKeys.length < 2) return documentParagraphs;
    const combinedTextboxKey = textboxKeys.join("");
    const sortedTextboxKeys = [
        ...textboxKeys
    ].sort((a, b)=>b.length - a.length);
    return documentParagraphs.filter((paragraph)=>{
        const key = $08414ea58bdc1292$var$normalizePreviewText(paragraph);
        return key && key !== combinedTextboxKey && key !== `${combinedTextboxKey}${combinedTextboxKey}` && !$08414ea58bdc1292$var$isComposedOfTextboxParagraphs(key, sortedTextboxKeys);
    });
}
function $08414ea58bdc1292$var$isComposedOfTextboxParagraphs(value, textboxKeys) {
    let remaining = value;
    let matchedCount = 0;
    for (const key of textboxKeys){
        if (!key || !remaining.includes(key)) continue;
        const before = remaining.length;
        remaining = remaining.split(key).join("");
        if (remaining.length !== before) matchedCount += Math.floor((before - remaining.length) / key.length);
    }
    return matchedCount >= 2 && remaining.length === 0;
}
function $08414ea58bdc1292$var$extractOpenDocumentBlocks(xml) {
    return [
        ...xml.matchAll(/<(?:text:p|text:h)[^>]*>([\s\S]*?)<\/(?:text:p|text:h)>/g)
    ].map((match)=>$08414ea58bdc1292$var$stripXmlTags(match[1] || "")).map((text)=>$08414ea58bdc1292$var$decodeXml2(text).trim()).filter(Boolean);
}
function $08414ea58bdc1292$var$stripXmlTags(value) {
    return value.replace(/<text:line-break\s*\/>/g, "\n").replace(/<text:tab\s*\/>/g, "	").replace(/<[^>]+>/g, "");
}
function $08414ea58bdc1292$var$rtfToText(rtf) {
    return rtf.replace(/\\'[0-9a-fA-F]{2}/g, "").replace(/\\par[d]?/g, "\n").replace(/\\tab/g, "	").replace(/\\[a-zA-Z]+\d* ?/g, "").replace(/[{}]/g, "").replace(/\n{3,}/g, "\n\n").trim();
}
async function $08414ea58bdc1292$var$readTextFromBuffer(arrayBuffer) {
    return (0, $3438a2478d5b847f$export$62387d23696f2b23)(arrayBuffer);
}
function $08414ea58bdc1292$var$hideSupplementalInfo3(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$hideSuccessfulSectionHeading(section) {
    const heading = section.querySelector("h3");
    if (heading) $08414ea58bdc1292$var$hideSupplementalInfo3(heading);
}
function $08414ea58bdc1292$var$mimeTypeFromPath(path) {
    const extension = path.split(".").pop()?.toLowerCase();
    const map = {
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        gif: "image/gif",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        webp: "image/webp"
    };
    return extension ? map[extension] || "application/octet-stream" : "application/octet-stream";
}
function $08414ea58bdc1292$var$decodeXml2(value) {
    return value.replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&amp;", "&").replaceAll("&quot;", '"').replaceAll("&apos;", "'");
}
function $08414ea58bdc1292$var$sanitizeHtml(html) {
    return (0, $hIrjg.default).sanitize(html, {
        USE_PROFILES: {
            html: true
        },
        ADD_ATTR: [
            "target"
        ]
    });
}
function $08414ea58bdc1292$export$9d3be0c18cf092b2() {
    return {
        name: "ofd",
        match (file) {
            return file.extension === "ofd" || file.mimeType === "application/ofd";
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-ofd");
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            ctx.viewport.append(panel);
            let zip;
            try {
                zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
            } catch (error) {
                panel.append($08414ea58bdc1292$var$createOfdFailure(ctx.file, url, error));
                return {
                    destroy () {
                        panel.remove();
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    }
                };
            }
            const entries = Object.values(zip.files).filter((entry)=>!entry.dir);
            const textFragments = [];
            try {
                for (const entry of entries.filter((item)=>item.name.endsWith(".xml")).slice(0, 40)){
                    const xml = await entry.async("text");
                    const matches = [
                        ...xml.matchAll(/>([^<>]{2,})</g)
                    ].map((match)=>match[1]?.trim()).filter(Boolean);
                    textFragments.push(...matches);
                }
            } catch (error) {
                panel.append($08414ea58bdc1292$var$createOfdFailure(ctx.file, url, error));
                return {
                    destroy () {
                        panel.remove();
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    }
                };
            }
            const context = await $08414ea58bdc1292$var$readOfdContext(entries);
            const pages = await $08414ea58bdc1292$var$readOfdPages(entries, context);
            let zoom = 1;
            let rotation = 0;
            const OFD_MM_TO_PX = 96 / 25.4;
            const computeFitScale = ()=>{
                if (pages.length === 0) return 1;
                const normalizedRotation = (rotation % 360 + 360) % 360;
                const sideways = normalizedRotation === 90 || normalizedRotation === 270;
                const widestMm = Math.max(...pages.map((page)=>sideways ? page.height : page.width));
                const available = panel.clientWidth - 32;
                const widestPx = widestMm * OFD_MM_TO_PX;
                if (!(widestPx > 0) || !(available > 0)) return 1;
                return Math.min(1, available / widestPx);
            };
            const applyZoom = ()=>{
                panel.style.setProperty("--ofv-ofd-zoom", $08414ea58bdc1292$var$formatOfdCssNumber(computeFitScale() * zoom));
                ctx.toolbar?.setZoom(zoom);
            };
            const applyRotation = ()=>{
                const normalizedRotation = (rotation % 360 + 360) % 360;
                panel.style.setProperty("--ofv-ofd-rotation", `${normalizedRotation}deg`);
                panel.classList.toggle("is-ofd-rotated-sideways", normalizedRotation === 90 || normalizedRotation === 270);
                applyZoom();
            };
            let resizeObserver;
            if (pages.length > 0) {
                const pagesWrap = document.createElement("div");
                pagesWrap.className = "ofv-ofd-pages";
                for (const page of pages)pagesWrap.append($08414ea58bdc1292$var$renderOfdPage(page));
                panel.append(pagesWrap);
                applyZoom();
                applyRotation();
                if (typeof ResizeObserver !== "undefined") {
                    resizeObserver = new ResizeObserver(()=>applyZoom());
                    resizeObserver.observe(panel);
                }
            }
            if (pages.length === 0) {
                const content = document.createElement("pre");
                content.className = "ofv-text-block";
                content.textContent = textFragments.slice(0, 300).join("\n") || "\u672A\u63D0\u53D6\u5230\u53EF\u8BFB\u6587\u672C\u3002";
                panel.append(content);
            }
            return {
                goToPage (page) {
                    return (0, $3438a2478d5b847f$export$e2c778f3bf6f56a7)(panel, ".ofv-ofd-page", page, panel);
                },
                canCommand (command) {
                    return pages.length > 0 && (command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left");
                },
                command (command) {
                    if (pages.length === 0) return false;
                    if (command === "zoom-in") {
                        zoom = Math.min(4, zoom + 0.15);
                        applyZoom();
                        return true;
                    }
                    if (command === "zoom-out") {
                        zoom = Math.max(0.25, zoom - 0.15);
                        applyZoom();
                        return true;
                    }
                    if (command === "zoom-reset") {
                        zoom = 1;
                        rotation = 0;
                        applyZoom();
                        applyRotation();
                        return true;
                    }
                    if (command === "rotate-right") {
                        rotation += 90;
                        applyRotation();
                        return true;
                    }
                    if (command === "rotate-left") {
                        rotation -= 90;
                        applyRotation();
                        return true;
                    }
                    return false;
                },
                destroy () {
                    resizeObserver?.disconnect();
                    ctx.toolbar?.setZoom(void 0);
                    panel.remove();
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                }
            };
        }
    };
}
async function $08414ea58bdc1292$var$readOfdPages(entries, context) {
    const pages = [];
    const discoveredPageEntries = entries.filter((entry)=>/(^|\/)Pages\/Page_[^/]+\/Content\.xml$/i.test(entry.name) || /(^|\/)Page_[^/]+\/Content\.xml$/i.test(entry.name));
    const documentPageEntries = context.pageOrder.map((path)=>$08414ea58bdc1292$var$findOfdEntry(discoveredPageEntries, path)).filter((entry)=>Boolean(entry));
    const pageEntries = (documentPageEntries.length > 0 ? documentPageEntries : discoveredPageEntries).slice(0, 80);
    for (const entry of pageEntries){
        const xml = await entry.async("text");
        const templates = await $08414ea58bdc1292$var$readPageTemplates(xml, context, entries);
        const stamps = context.stampsByPage.get($08414ea58bdc1292$var$normalizeOfdPath(entry.name)) || [];
        const resources = {
            images: context.images,
            fonts: context.fonts,
            drawParams: context.drawParams
        };
        const page = $08414ea58bdc1292$var$parseOfdPage(entry.name, xml, resources, templates, context.pageSize, stamps);
        pages.push(page);
    }
    return pages;
}
async function $08414ea58bdc1292$var$readPageTemplates(xml, context, entries) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return [];
    const templateIds = Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Template").map((element)=>$08414ea58bdc1292$var$getOfdAttribute(element, "TemplateID") || $08414ea58bdc1292$var$getOfdAttribute(element, "ID")).filter((id)=>Boolean(id));
    const templates = [];
    for (const id of templateIds){
        const path = context.templates.get(id);
        const entry = path ? $08414ea58bdc1292$var$findOfdEntry(entries, path) : void 0;
        if (entry) templates.push(await entry.async("text"));
    }
    return templates;
}
function $08414ea58bdc1292$var$parseOfdPage(name, xml, resources, templateXmls = [], defaultPageSize, stamps = []) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return {
        name: name,
        width: 210,
        height: 297,
        objects: [],
        texts: [],
        paths: [],
        lines: [],
        images: [],
        stamps: stamps
    };
    const pageSize = $08414ea58bdc1292$var$parseOfdPageSize(doc, defaultPageSize);
    const templatePages = templateXmls.map((templateXml)=>{
        const templateDoc = new DOMParser().parseFromString(templateXml, "application/xml");
        return templateDoc.querySelector("parsererror") ? $08414ea58bdc1292$var$emptyOfdPageContent() : $08414ea58bdc1292$var$parseOfdPageContent(templateDoc, resources);
    });
    const pageContent = $08414ea58bdc1292$var$parseOfdPageContent(doc, resources);
    const texts = [
        ...templatePages.flatMap((page)=>page.texts),
        ...pageContent.texts
    ];
    const paths = [
        ...templatePages.flatMap((page)=>page.paths),
        ...pageContent.paths
    ];
    const lines = [
        ...templatePages.flatMap((page)=>page.lines),
        ...pageContent.lines
    ];
    const imageObjects = [
        ...templatePages.flatMap((page)=>page.images),
        ...pageContent.images
    ];
    const objects = [
        ...templatePages.flatMap((page)=>page.objects),
        ...pageContent.objects
    ];
    if (pageSize.explicit) return {
        name: name,
        width: pageSize.width,
        height: pageSize.height,
        objects: objects,
        texts: texts,
        paths: paths,
        lines: lines,
        images: imageObjects,
        stamps: stamps
    };
    const bounds = $08414ea58bdc1292$var$createOfdBounds(texts, paths, lines, [
        ...imageObjects,
        ...stamps
    ]);
    const width = Math.max(pageSize.width, ...bounds.map((item)=>item.x + item.width + 12));
    const height = Math.max(pageSize.height, ...bounds.map((item)=>item.y + item.height + 12));
    return {
        name: name,
        width: width,
        height: height,
        objects: objects,
        texts: texts,
        paths: paths,
        lines: lines,
        images: imageObjects,
        stamps: stamps
    };
}
function $08414ea58bdc1292$var$parseOfdPageContent(doc, resources) {
    const objects = [];
    for (const element of Array.from(doc.getElementsByTagName("*"))){
        if (element.localName === "TextObject") {
            objects.push(...$08414ea58bdc1292$var$parseOfdTextObject(element, resources).map((item)=>({
                    type: "text",
                    item: item
                })));
            continue;
        }
        if (element.localName === "PathObject") {
            objects.push(...$08414ea58bdc1292$var$parseOfdPathObject(element, resources).map((item)=>({
                    type: "path",
                    item: item
                })));
            continue;
        }
        if (element.localName === "LineObject") {
            objects.push(...$08414ea58bdc1292$var$parseOfdLineObject(element, resources).map((item)=>({
                    type: "line",
                    item: item
                })));
            continue;
        }
        if (element.localName === "ImageObject") objects.push(...$08414ea58bdc1292$var$parseOfdImageObject(element, resources.images).map((item)=>({
                type: "image",
                item: item
            })));
    }
    return {
        objects: objects,
        texts: objects.filter((object)=>object.type === "text").map((object)=>object.item),
        paths: objects.filter((object)=>object.type === "path").map((object)=>object.item),
        lines: objects.filter((object)=>object.type === "line").map((object)=>object.item),
        images: objects.filter((object)=>object.type === "image").map((object)=>object.item)
    };
}
function $08414ea58bdc1292$var$emptyOfdPageContent() {
    return {
        objects: [],
        texts: [],
        paths: [],
        lines: [],
        images: []
    };
}
function $08414ea58bdc1292$var$createOfdBounds(texts, paths, lines, imageObjects) {
    return [
        ...texts.map((item)=>({
                x: item.boundsX ?? item.x,
                y: item.boundsY ?? item.y,
                width: item.width,
                height: item.height
            })),
        ...paths.map((item)=>({
                x: item.x,
                y: item.y,
                width: item.width,
                height: item.height
            })),
        ...lines.map((item)=>({
                x: Math.min(item.x1, item.x2),
                y: Math.min(item.y1, item.y2),
                width: Math.abs(item.x2 - item.x1),
                height: Math.abs(item.y2 - item.y1)
            })),
        ...imageObjects.map((item)=>({
                x: item.x,
                y: item.y,
                width: item.width,
                height: item.height
            }))
    ];
}
function $08414ea58bdc1292$var$parseOfdTextObject(element, resources) {
    const boundary = $08414ea58bdc1292$var$parseBoundary($08414ea58bdc1292$var$getOfdAttribute(element, "Boundary"));
    const drawParam = $08414ea58bdc1292$var$resolveOfdDrawParam(element, resources.drawParams);
    const size = $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(element, "Size"), Math.max(4, boundary.height || 5));
    const color = $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(element, "FillColor")) || $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(element, "StrokeColor")) || drawParam?.fillColor || "#111827";
    const weight = $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(element, "Weight"), 400) >= 600 ? "700" : "400";
    const fontFamily = $08414ea58bdc1292$var$fontStackForOfdFont(resources.fonts.get($08414ea58bdc1292$var$getOfdAttribute(element, "Font") || ""));
    const objectLetterSpacing = $08414ea58bdc1292$var$getOfdAttribute(element, "DeltaX") ? 0.5 : void 0;
    const ctm = $08414ea58bdc1292$var$parseOfdCtm($08414ea58bdc1292$var$getOfdAttribute(element, "CTM"));
    const transform = ctm ? $08414ea58bdc1292$var$createOfdPathTransform(boundary.x, boundary.y, ctm) : void 0;
    const textCodes = Array.from(element.getElementsByTagName("*")).filter((child)=>child.localName === "TextCode");
    if (textCodes.length === 0) return [];
    return textCodes.flatMap((code)=>{
        const x = (transform ? 0 : boundary.x) + $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(code, "X"), 0);
        const y = (transform ? 0 : boundary.y) + $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(code, "Y"), 0);
        const text = $08414ea58bdc1292$var$decodeOfdTextEscapes(code.textContent || "");
        const deltaX = $08414ea58bdc1292$var$parseOfdDeltaX($08414ea58bdc1292$var$getOfdAttribute(code, "DeltaX"));
        const deltaY = $08414ea58bdc1292$var$getOfdAttribute(code, "DeltaY");
        if (deltaY && text.length > 1) {
            const step = $08414ea58bdc1292$var$parseOfdDeltaStep(deltaY, size);
            return Array.from(text).map((char, index)=>({
                    text: char,
                    x: x,
                    y: y + index * step,
                    width: boundary.width,
                    height: boundary.height,
                    size: size,
                    color: color,
                    weight: weight,
                    fontFamily: fontFamily,
                    letterSpacing: objectLetterSpacing,
                    vertical: true,
                    transform: transform,
                    boundsX: transform ? boundary.x : void 0,
                    boundsY: transform ? boundary.y : void 0
                }));
        }
        return [
            {
                text: text,
                x: x,
                y: y,
                width: boundary.width,
                height: boundary.height,
                size: size,
                color: color,
                weight: weight,
                fontFamily: fontFamily,
                letterSpacing: deltaX ? void 0 : objectLetterSpacing,
                deltaX: deltaX,
                transform: transform,
                boundsX: transform ? boundary.x : void 0,
                boundsY: transform ? boundary.y : void 0
            }
        ];
    }).filter((item)=>item.text);
}
var $08414ea58bdc1292$var$OFD_DEFAULT_LINE_WIDTH = 0.353;
function $08414ea58bdc1292$var$parseOfdPathObject(element, resources) {
    const boundary = $08414ea58bdc1292$var$parseBoundary($08414ea58bdc1292$var$getOfdAttribute(element, "Boundary"));
    const ctm = $08414ea58bdc1292$var$parseOfdCtm($08414ea58bdc1292$var$getOfdAttribute(element, "CTM"));
    const drawParam = $08414ea58bdc1292$var$resolveOfdDrawParam(element, resources.drawParams);
    const commands = $08414ea58bdc1292$var$getDirectOfdChildren(element, "AbbreviatedData", "PathData");
    const raw = commands.map((child)=>child.textContent || "").join(" ").trim();
    if (!raw) return [];
    const stroke = $08414ea58bdc1292$var$parseOfdBoolean($08414ea58bdc1292$var$getOfdAttribute(element, "Stroke")) === false ? "none" : $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(element, "StrokeColor")) || drawParam?.strokeColor || "#111827";
    const fillColorChild = $08414ea58bdc1292$var$findOfdChild(element, "FillColor");
    const fill = $08414ea58bdc1292$var$parseOfdBoolean($08414ea58bdc1292$var$getOfdAttribute(element, "Fill")) === true ? fillColorChild ? $08414ea58bdc1292$var$parseOfdColorElement(fillColorChild) || "transparent" : drawParam?.fillColor || "#111827" : "transparent";
    return [
        {
            d: $08414ea58bdc1292$var$normalizeOfdPathData(raw),
            x: boundary.x,
            y: boundary.y,
            width: boundary.width,
            height: boundary.height,
            stroke: stroke,
            fill: fill,
            fillRule: /even/i.test($08414ea58bdc1292$var$getOfdAttribute(element, "Rule") || "") ? "evenodd" : void 0,
            strokeWidth: $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(element, "LineWidth"), drawParam?.lineWidth ?? $08414ea58bdc1292$var$OFD_DEFAULT_LINE_WIDTH),
            transform: $08414ea58bdc1292$var$createOfdPathTransform(boundary.x, boundary.y, ctm)
        }
    ];
}
function $08414ea58bdc1292$var$parseOfdLineObject(element, resources) {
    const boundary = $08414ea58bdc1292$var$parseBoundary($08414ea58bdc1292$var$getOfdAttribute(element, "Boundary"));
    const drawParam = $08414ea58bdc1292$var$resolveOfdDrawParam(element, resources.drawParams);
    const start = $08414ea58bdc1292$var$parsePoint($08414ea58bdc1292$var$getOfdAttribute(element, "StartPoint"), {
        x: 0,
        y: 0
    });
    const end = $08414ea58bdc1292$var$parsePoint($08414ea58bdc1292$var$getOfdAttribute(element, "EndPoint"), {
        x: boundary.width,
        y: boundary.height
    });
    return [
        {
            x1: boundary.x + start.x,
            y1: boundary.y + start.y,
            x2: boundary.x + end.x,
            y2: boundary.y + end.y,
            stroke: $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(element, "StrokeColor")) || $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(element, "FillColor")) || drawParam?.strokeColor || "#111827",
            strokeWidth: $08414ea58bdc1292$var$finiteNumber2($08414ea58bdc1292$var$getOfdAttribute(element, "LineWidth"), drawParam?.lineWidth ?? $08414ea58bdc1292$var$OFD_DEFAULT_LINE_WIDTH)
        }
    ];
}
function $08414ea58bdc1292$var$parseOfdImageObject(element, images) {
    const boundary = $08414ea58bdc1292$var$parseBoundary($08414ea58bdc1292$var$getOfdAttribute(element, "Boundary"));
    const ctm = $08414ea58bdc1292$var$parseOfdCtm($08414ea58bdc1292$var$getOfdAttribute(element, "CTM"));
    const simpleCtmBounds = ctm ? $08414ea58bdc1292$var$createSimpleOfdImageCtmBounds(boundary, ctm) : void 0;
    const resourceId = $08414ea58bdc1292$var$getOfdAttribute(element, "ResourceID") || $08414ea58bdc1292$var$getOfdAttribute(element, "ResourceId") || "";
    return [
        {
            x: simpleCtmBounds?.x ?? (ctm ? 0 : boundary.x),
            y: simpleCtmBounds?.y ?? (ctm ? 0 : boundary.y),
            width: simpleCtmBounds?.width ?? (ctm ? 1 : boundary.width || 32),
            height: simpleCtmBounds?.height ?? (ctm ? 1 : boundary.height || 32),
            resourceId: resourceId,
            href: images.get(resourceId),
            transform: ctm && !simpleCtmBounds ? $08414ea58bdc1292$var$createOfdPathTransform(boundary.x, boundary.y, ctm) : void 0
        }
    ];
}
function $08414ea58bdc1292$var$createSimpleOfdImageCtmBounds(boundary, ctm) {
    const [a, b, c, d, e, f] = ctm;
    if (Math.abs(b) > 1e-6 || Math.abs(c) > 1e-6 || a <= 0 || d <= 0) return void 0;
    return {
        x: boundary.x + e,
        y: boundary.y + f,
        width: a,
        height: d
    };
}
function $08414ea58bdc1292$var$renderOfdPage(page) {
    const figure = document.createElement("figure");
    figure.className = "ofv-ofd-page";
    figure.style.setProperty("--ofv-ofd-page-width", `${$08414ea58bdc1292$var$formatOfdCssNumber(page.width)}mm`);
    figure.style.setProperty("--ofv-ofd-page-height", `${$08414ea58bdc1292$var$formatOfdCssNumber(page.height)}mm`);
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", `0 0 ${page.width} ${page.height}`);
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", page.name);
    const paper = document.createElementNS(svg.namespaceURI, "rect");
    paper.setAttribute("x", "0");
    paper.setAttribute("y", "0");
    paper.setAttribute("width", String(page.width));
    paper.setAttribute("height", String(page.height));
    paper.setAttribute("fill", "white");
    svg.append(paper);
    for (const object of page.objects){
        if (object.type === "path") {
            $08414ea58bdc1292$var$appendOfdPath(svg, object.item);
            continue;
        }
        if (object.type === "line") {
            $08414ea58bdc1292$var$appendOfdLine(svg, object.item);
            continue;
        }
        if (object.type === "text") {
            $08414ea58bdc1292$var$appendOfdText(svg, object.item);
            continue;
        }
        $08414ea58bdc1292$var$appendOfdImage(svg, object.item);
    }
    for (const item of page.stamps)$08414ea58bdc1292$var$appendOfdImage(svg, item);
    figure.append(svg);
    return figure;
}
function $08414ea58bdc1292$var$appendOfdPath(svg, item) {
    const path = document.createElementNS(svg.namespaceURI, "path");
    path.setAttribute("d", item.d);
    path.setAttribute("transform", item.transform);
    path.setAttribute("fill", item.fill);
    if (item.fillRule) path.setAttribute("fill-rule", item.fillRule);
    path.setAttribute("stroke", item.stroke);
    path.setAttribute("stroke-width", String(item.strokeWidth));
    svg.append(path);
}
function $08414ea58bdc1292$var$appendOfdLine(svg, item) {
    const line = document.createElementNS(svg.namespaceURI, "line");
    line.setAttribute("x1", String(item.x1));
    line.setAttribute("y1", String(item.y1));
    line.setAttribute("x2", String(item.x2));
    line.setAttribute("y2", String(item.y2));
    line.setAttribute("stroke", item.stroke);
    line.setAttribute("stroke-width", String(item.strokeWidth));
    line.setAttribute("stroke-linecap", "round");
    svg.append(line);
}
function $08414ea58bdc1292$var$appendOfdText(svg, item) {
    const text = document.createElementNS(svg.namespaceURI, "text");
    text.setAttribute("x", String(item.x));
    text.setAttribute("y", String(item.y));
    if (item.transform) text.setAttribute("transform", item.transform);
    text.setAttribute("font-size", String(item.size));
    text.setAttribute("fill", item.color);
    text.setAttribute("font-weight", item.weight);
    text.setAttribute("font-family", item.fontFamily);
    if (item.letterSpacing !== void 0) text.setAttribute("letter-spacing", String(item.letterSpacing));
    if (item.deltaX && item.deltaX.length > 0) {
        const chars = Array.from(item.text);
        let x = item.x;
        for(let index = 0; index < chars.length; index += 1){
            const span = document.createElementNS(svg.namespaceURI, "tspan");
            span.setAttribute("x", String(x));
            span.setAttribute("y", String(item.y));
            if (index < chars.length - 1) x += item.deltaX[Math.min(index, item.deltaX.length - 1)] || item.size;
            span.textContent = chars[index];
            text.append(span);
        }
    } else text.textContent = item.text;
    svg.append(text);
}
function $08414ea58bdc1292$var$appendOfdImage(svg, item) {
    if (item.href) {
        const image = document.createElementNS(svg.namespaceURI, "image");
        image.setAttribute("x", String(item.x));
        image.setAttribute("y", String(item.y));
        image.setAttribute("width", String(item.width));
        image.setAttribute("height", String(item.height));
        image.setAttribute("href", item.href);
        if (item.transform) image.setAttribute("transform", item.transform);
        image.setAttribute("preserveAspectRatio", "xMidYMid meet");
        svg.append(image);
    } else {
        const placeholder = document.createElementNS(svg.namespaceURI, "rect");
        placeholder.setAttribute("x", String(item.x));
        placeholder.setAttribute("y", String(item.y));
        placeholder.setAttribute("width", String(item.width));
        placeholder.setAttribute("height", String(item.height));
        if (item.transform) placeholder.setAttribute("transform", item.transform);
        placeholder.setAttribute("fill", "#f8fafc");
        placeholder.setAttribute("stroke", "#94a3b8");
        placeholder.setAttribute("stroke-dasharray", "4 3");
        svg.append(placeholder);
    }
}
async function $08414ea58bdc1292$var$readOfdContext(entries) {
    const images = await $08414ea58bdc1292$var$readOfdImages(entries);
    const fonts = await $08414ea58bdc1292$var$readOfdFonts(entries);
    const drawParams = await $08414ea58bdc1292$var$readOfdDrawParams(entries);
    const { templates: templates, pageOrder: pageOrder, pageSize: pageSize, pagePaths: pagePaths } = await $08414ea58bdc1292$var$readOfdDocumentInfo(entries);
    const stampsByPage = await $08414ea58bdc1292$var$readOfdStamps(entries, pagePaths);
    return {
        images: images,
        templates: templates,
        fonts: fonts,
        drawParams: drawParams,
        pageOrder: pageOrder,
        pageSize: pageSize,
        stampsByPage: stampsByPage
    };
}
async function $08414ea58bdc1292$var$readOfdDrawParams(entries) {
    const raw = /* @__PURE__ */ new Map();
    for (const entry of entries.filter((item)=>/(?:^|\/)(?:DocumentRes|PublicRes)\.xml$/i.test(item.name))){
        const doc = new DOMParser().parseFromString(await entry.async("text"), "application/xml");
        if (doc.querySelector("parsererror")) continue;
        for (const param of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "DrawParam")){
            const id = $08414ea58bdc1292$var$getOfdAttribute(param, "ID");
            if (!id) continue;
            const lineWidthAttr = $08414ea58bdc1292$var$getOfdAttribute(param, "LineWidth");
            const lineWidth = lineWidthAttr === null ? Number.NaN : Number(lineWidthAttr);
            raw.set(id, {
                relative: $08414ea58bdc1292$var$getOfdAttribute(param, "Relative") || void 0,
                own: {
                    lineWidth: Number.isFinite(lineWidth) ? lineWidth : void 0,
                    strokeColor: $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(param, "StrokeColor")),
                    fillColor: $08414ea58bdc1292$var$parseOfdColorElement($08414ea58bdc1292$var$findOfdChild(param, "FillColor"))
                }
            });
        }
    }
    const resolved = /* @__PURE__ */ new Map();
    const resolve = (id, seen)=>{
        const cached = resolved.get(id);
        if (cached) return cached;
        const item = raw.get(id);
        if (!item || seen.has(id)) return {};
        seen.add(id);
        const base = item.relative ? resolve(item.relative, seen) : {};
        const merged = {
            lineWidth: item.own.lineWidth ?? base.lineWidth,
            strokeColor: item.own.strokeColor ?? base.strokeColor,
            fillColor: item.own.fillColor ?? base.fillColor
        };
        resolved.set(id, merged);
        return merged;
    };
    for (const id of raw.keys())resolve(id, /* @__PURE__ */ new Set());
    return resolved;
}
function $08414ea58bdc1292$var$resolveOfdDrawParam(element, drawParams) {
    if (drawParams.size === 0) return void 0;
    let current = element;
    while(current){
        const id = $08414ea58bdc1292$var$getOfdAttribute(current, "DrawParam");
        if (id) return drawParams.get(id);
        current = current.parentElement;
    }
    return void 0;
}
async function $08414ea58bdc1292$var$readOfdStamps(entries, pagePaths) {
    const stamps = /* @__PURE__ */ new Map();
    for (const entry of entries.filter((item)=>/(?:^|\/)Signatures\.xml$/i.test(item.name))){
        const doc = new DOMParser().parseFromString(await entry.async("text"), "application/xml");
        if (doc.querySelector("parsererror")) continue;
        const signaturesDir = $08414ea58bdc1292$var$directoryName2(entry.name);
        for (const signature of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Signature")){
            const baseLoc = $08414ea58bdc1292$var$getOfdAttribute(signature, "BaseLoc");
            const signatureEntry = baseLoc ? $08414ea58bdc1292$var$findOfdEntry(entries, $08414ea58bdc1292$var$joinOfdPath(signaturesDir, baseLoc)) || $08414ea58bdc1292$var$findOfdEntry(entries, baseLoc) : void 0;
            if (!signatureEntry) continue;
            const signatureDoc = new DOMParser().parseFromString(await signatureEntry.async("text"), "application/xml");
            if (signatureDoc.querySelector("parsererror")) continue;
            const signatureElements = Array.from(signatureDoc.getElementsByTagName("*"));
            const signatureDir = $08414ea58bdc1292$var$directoryName2(signatureEntry.name);
            const signedValueLoc = signatureElements.find((element)=>element.localName === "SignedValue")?.textContent?.trim() || "SignedValue.dat";
            const signedValueEntry = $08414ea58bdc1292$var$findOfdEntry(entries, $08414ea58bdc1292$var$joinOfdPath(signatureDir, signedValueLoc)) || $08414ea58bdc1292$var$findOfdEntry(entries, signedValueLoc);
            const href = signedValueEntry ? $08414ea58bdc1292$var$extractOfdStampImage(await signedValueEntry.async("uint8array")) : void 0;
            if (!href) continue;
            for (const annot of signatureElements.filter((element)=>element.localName === "StampAnnot")){
                const boundary = $08414ea58bdc1292$var$parseBoundary($08414ea58bdc1292$var$getOfdAttribute(annot, "Boundary"));
                const pageRef = $08414ea58bdc1292$var$getOfdAttribute(annot, "PageRef");
                const pagePath = pageRef ? pagePaths.get(pageRef) : void 0;
                const pageEntry = pagePath ? $08414ea58bdc1292$var$findOfdEntry(entries, pagePath) : void 0;
                if (!pageEntry || boundary.width <= 0 || boundary.height <= 0) continue;
                const key = $08414ea58bdc1292$var$normalizeOfdPath(pageEntry.name);
                const list = stamps.get(key) || [];
                list.push({
                    x: boundary.x,
                    y: boundary.y,
                    width: boundary.width,
                    height: boundary.height,
                    resourceId: "",
                    href: href
                });
                stamps.set(key, list);
            }
        }
    }
    return stamps;
}
function $08414ea58bdc1292$var$extractOfdStampImage(bytes) {
    const pngStart = $08414ea58bdc1292$var$indexOfOfdBytes(bytes, [
        137,
        80,
        78,
        71,
        13,
        10,
        26,
        10
    ]);
    if (pngStart >= 0) {
        const iend = $08414ea58bdc1292$var$indexOfOfdBytes(bytes, [
            73,
            69,
            78,
            68,
            174,
            66,
            96,
            130
        ], pngStart);
        const end = iend >= 0 ? iend + 8 : bytes.length;
        return $08414ea58bdc1292$var$ofdBytesToDataUrl("image/png", bytes.subarray(pngStart, end));
    }
    const jpegStart = $08414ea58bdc1292$var$indexOfOfdBytes(bytes, [
        255,
        216,
        255
    ]);
    if (jpegStart >= 0) {
        let end = bytes.length;
        for(let index = bytes.length - 2; index > jpegStart; index -= 1)if (bytes[index] === 255 && bytes[index + 1] === 217) {
            end = index + 2;
            break;
        }
        return $08414ea58bdc1292$var$ofdBytesToDataUrl("image/jpeg", bytes.subarray(jpegStart, end));
    }
    return void 0;
}
function $08414ea58bdc1292$var$indexOfOfdBytes(bytes, pattern, fromIndex = 0) {
    outer: for(let index = fromIndex; index <= bytes.length - pattern.length; index += 1){
        for(let offset = 0; offset < pattern.length; offset += 1){
            if (bytes[index + offset] !== pattern[offset]) continue outer;
        }
        return index;
    }
    return -1;
}
function $08414ea58bdc1292$var$ofdBytesToDataUrl(mimeType, bytes) {
    let binary = "";
    const chunkSize = 32768;
    for(let index = 0; index < bytes.length; index += chunkSize)binary += String.fromCharCode(...bytes.subarray(index, index + chunkSize));
    return `data:${mimeType};base64,${btoa(binary)}`;
}
async function $08414ea58bdc1292$var$readOfdFonts(entries) {
    const fonts = /* @__PURE__ */ new Map();
    for (const entry of entries.filter((item)=>/(?:^|\/)(?:DocumentRes|PublicRes)\.xml$/i.test(item.name))){
        const xml = await entry.async("text");
        const doc = new DOMParser().parseFromString(xml, "application/xml");
        if (doc.querySelector("parsererror")) continue;
        for (const font of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Font")){
            const id = $08414ea58bdc1292$var$getOfdAttribute(font, "ID");
            const name = $08414ea58bdc1292$var$getOfdAttribute(font, "FontName") || $08414ea58bdc1292$var$getOfdAttribute(font, "FamilyName");
            if (id && name) fonts.set(id, name.trim());
        }
    }
    return fonts;
}
async function $08414ea58bdc1292$var$readOfdImages(entries) {
    const images = /* @__PURE__ */ new Map();
    for (const entry of entries.filter((item)=>/\.(?:png|jpe?g|gif|bmp|webp)$/i.test(item.name)).slice(0, 80)){
        const id = entry.name.split("/").pop()?.replace(/\.[^.]+$/, "") || entry.name;
        const mimeType = $08414ea58bdc1292$var$mimeTypeFromPath2(entry.name);
        if (!mimeType.startsWith("image/")) continue;
        const base64 = await entry.async("base64");
        const href = `data:${mimeType};base64,${base64}`;
        images.set(id, href);
        images.set(entry.name, href);
        images.set(entry.name.split("/").pop() || entry.name, href);
    }
    for (const entry of entries.filter((item)=>/(?:^|\/)(?:DocumentRes|PublicRes)\.xml$/i.test(item.name))){
        const xml = await entry.async("text");
        const doc = new DOMParser().parseFromString(xml, "application/xml");
        if (doc.querySelector("parsererror")) continue;
        const baseLoc = $08414ea58bdc1292$var$getOfdAttribute(doc.documentElement, "BaseLoc") || "";
        const resourceDir = $08414ea58bdc1292$var$joinOfdPath($08414ea58bdc1292$var$directoryName2(entry.name), baseLoc);
        for (const media of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "MultiMedia")){
            const id = $08414ea58bdc1292$var$getOfdAttribute(media, "ID");
            const mediaFile = $08414ea58bdc1292$var$findOfdChild(media, "MediaFile")?.textContent?.trim();
            if (!id || !mediaFile) continue;
            const imageEntry = $08414ea58bdc1292$var$findOfdEntry(entries, $08414ea58bdc1292$var$joinOfdPath(resourceDir, mediaFile)) || $08414ea58bdc1292$var$findOfdEntry(entries, mediaFile);
            const href = imageEntry ? images.get(imageEntry.name) || images.get(imageEntry.name.split("/").pop() || imageEntry.name) : void 0;
            if (href) images.set(id, href);
        }
    }
    return images;
}
async function $08414ea58bdc1292$var$readOfdDocumentInfo(entries) {
    const templates = /* @__PURE__ */ new Map();
    const pageOrder = [];
    const pagePaths = /* @__PURE__ */ new Map();
    let pageSize;
    for (const entry of entries.filter((item)=>/(?:^|\/)Document\.xml$/i.test(item.name))){
        const xml = await entry.async("text");
        const doc = new DOMParser().parseFromString(xml, "application/xml");
        if (doc.querySelector("parsererror")) continue;
        const documentDir = $08414ea58bdc1292$var$directoryName2(entry.name);
        const physicalBox = Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "PageArea")?.getElementsByTagName("*");
        const pageAreaBox = physicalBox ? Array.from(physicalBox).find((element)=>element.localName === "PhysicalBox") : void 0;
        if (pageAreaBox?.textContent) {
            const box = $08414ea58bdc1292$var$parseBoundary(pageAreaBox.textContent);
            if (box.width > 0 && box.height > 0) pageSize = {
                width: box.width,
                height: box.height
            };
        }
        for (const template of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "TemplatePage")){
            const id = $08414ea58bdc1292$var$getOfdAttribute(template, "ID");
            const baseLoc = $08414ea58bdc1292$var$getOfdAttribute(template, "BaseLoc");
            if (id && baseLoc) templates.set(id, $08414ea58bdc1292$var$joinOfdPath(documentDir, baseLoc));
        }
        for (const pageElement of Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "Page")){
            const id = $08414ea58bdc1292$var$getOfdAttribute(pageElement, "ID");
            const baseLoc = $08414ea58bdc1292$var$getOfdAttribute(pageElement, "BaseLoc");
            if (id && baseLoc) {
                const pagePath = $08414ea58bdc1292$var$joinOfdPath(documentDir, baseLoc);
                pagePaths.set(id, pagePath);
                pageOrder.push(pagePath);
            }
        }
    }
    return {
        templates: templates,
        pageOrder: pageOrder,
        pageSize: pageSize,
        pagePaths: pagePaths
    };
}
function $08414ea58bdc1292$var$parseOfdPageSize(doc, defaultPageSize) {
    const physicalBox = Array.from(doc.getElementsByTagName("*")).find((element)=>element.localName === "PhysicalBox");
    if (physicalBox?.textContent) {
        const box = $08414ea58bdc1292$var$parseBoundary(physicalBox.textContent);
        if (box.width > 0 && box.height > 0) return {
            width: box.width,
            height: box.height,
            explicit: true
        };
    }
    if (defaultPageSize) return {
        ...defaultPageSize,
        explicit: true
    };
    return {
        width: 210,
        height: 297,
        explicit: false
    };
}
function $08414ea58bdc1292$var$parseOfdColorElement(colorElement) {
    const value = colorElement ? $08414ea58bdc1292$var$getOfdAttribute(colorElement, "Value") : null;
    if (!colorElement || !value) return void 0;
    const parts = value.trim().split(/\s+/).map((part)=>Number(part));
    const rgbParts = parts.length === 1 && Number.isFinite(parts[0]) ? [
        parts[0],
        parts[0],
        parts[0]
    ] : parts;
    if (rgbParts.length >= 3 && rgbParts.every((part)=>Number.isFinite(part))) {
        const channels = rgbParts.slice(0, 3).map((part)=>Math.max(0, Math.min(255, part))).join(" ");
        const alpha = $08414ea58bdc1292$var$parseOfdAlpha($08414ea58bdc1292$var$getOfdAttribute(colorElement, "Alpha"));
        if (alpha <= 0) return "transparent";
        return alpha >= 1 ? `rgb(${channels})` : `rgb(${channels} / ${$08414ea58bdc1292$var$formatOfdCssNumber(alpha)})`;
    }
    return void 0;
}
function $08414ea58bdc1292$var$parseOfdAlpha(value) {
    const parsed = value === null ? Number.NaN : Number(value);
    if (!Number.isFinite(parsed)) return 1;
    return Math.max(0, Math.min(255, parsed)) / 255;
}
function $08414ea58bdc1292$var$parseOfdBoolean(value) {
    const normalized = value?.trim().toLowerCase();
    if (normalized === "true" || normalized === "1") return true;
    if (normalized === "false" || normalized === "0") return false;
    return void 0;
}
function $08414ea58bdc1292$var$findOfdChild(element, localName) {
    return Array.from(element.children).find((child)=>child.localName === localName);
}
function $08414ea58bdc1292$var$getDirectOfdChildren(element, ...localNames) {
    const allowed = new Set(localNames);
    return Array.from(element.children).filter((child)=>allowed.has(child.localName));
}
function $08414ea58bdc1292$var$parsePoint(value, fallback) {
    const parts = (value || "").trim().split(/\s+/).map((part)=>Number(part));
    return {
        x: Number.isFinite(parts[0]) ? parts[0] : fallback.x,
        y: Number.isFinite(parts[1]) ? parts[1] : fallback.y
    };
}
var $08414ea58bdc1292$var$OFD_PATH_COMMAND_MAP = {
    S: "M",
    M: "M",
    L: "L",
    Q: "Q",
    B: "C",
    A: "A",
    C: "Z",
    Z: "Z"
};
function $08414ea58bdc1292$var$normalizeOfdPathData(value) {
    return value.trim().split(/\s+/).map((token)=>/^[a-zA-Z]$/.test(token) ? $08414ea58bdc1292$var$OFD_PATH_COMMAND_MAP[token.toUpperCase()] || token : token).join(" ");
}
function $08414ea58bdc1292$var$parseOfdCtm(value) {
    const parts = (value || "").trim().split(/\s+/).map((part)=>Number(part));
    if (parts.length !== 6 || parts.some((part)=>!Number.isFinite(part))) return void 0;
    return parts;
}
function $08414ea58bdc1292$var$createOfdPathTransform(x, y, ctm) {
    if (!ctm) return `translate(${x} ${y})`;
    const [a, b, c, d, e, f] = ctm;
    return `translate(${x} ${y}) matrix(${a} ${b} ${c} ${d} ${e} ${f})`;
}
function $08414ea58bdc1292$var$decodeOfdTextEscapes(value) {
    if (!value.includes("\\")) return value;
    return value.replace(/\\(?:0[xX]([0-9a-fA-F]{4})|u([0-9a-fA-F]{4})|\\)/g, (match, hex, unicode)=>{
        const digits = hex || unicode;
        if (!digits) return "\\";
        return String.fromCodePoint(Number.parseInt(digits, 16));
    });
}
function $08414ea58bdc1292$var$parseOfdDeltaStep(value, fallback) {
    const numbers = value.match(/-?\d+(?:\.\d+)?/g)?.map((part)=>Number(part)).filter((part)=>Number.isFinite(part)) || [];
    return numbers.length > 0 ? numbers[numbers.length - 1] : fallback;
}
function $08414ea58bdc1292$var$parseOfdDeltaX(value) {
    if (!value) return void 0;
    const parts = value.match(/[a-z]+|-?\d+(?:\.\d+)?/gi) || [];
    const deltas = [];
    for(let index = 0; index < parts.length; index += 1){
        const token = parts[index];
        if (/^g$/i.test(token)) {
            const count = Number(parts[index + 1]);
            const step = Number(parts[index + 2]);
            if (Number.isFinite(count) && Number.isFinite(step)) deltas.push(...Array.from({
                length: Math.max(0, Math.floor(count))
            }, ()=>step));
            index += 2;
            continue;
        }
        const numeric = Number(token);
        if (Number.isFinite(numeric)) deltas.push(numeric);
    }
    return deltas.length > 0 ? deltas : void 0;
}
function $08414ea58bdc1292$var$fontStackForOfdFont(fontName) {
    const normalized = (fontName || "").trim().toLowerCase();
    if (normalized.includes("times")) return '"Times New Roman", Times, "Songti SC", STSong, serif';
    if (normalized.includes("courier")) return '"Courier New", Courier, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
    if (normalized.includes("kaiti") || normalized.includes("kai") || normalized.includes("\u6977")) return '"STKaiti", "Kaiti SC", "KaiTi", "\u6977\u4F53", serif';
    if (normalized.includes("simsun") || normalized.includes("simsong") || normalized.includes("song") || normalized.includes("\u5B8B")) return '"SimSong", "Songti SC", "STSong", SimSun, "\u5B8B\u4F53", serif';
    if (normalized.includes("hei") || normalized.includes("\u9ED1")) return '"PingFang SC", "Microsoft YaHei", SimHei, sans-serif';
    return '"SimSong", "Songti SC", "STSong", SimSun, "Noto Serif CJK SC", serif';
}
function $08414ea58bdc1292$var$findOfdEntry(entries, path) {
    const normalized = $08414ea58bdc1292$var$normalizeOfdPath(path);
    return entries.find((entry)=>$08414ea58bdc1292$var$normalizeOfdPath(entry.name) === normalized || $08414ea58bdc1292$var$normalizeOfdPath(entry.name).endsWith(`/${normalized}`));
}
function $08414ea58bdc1292$var$joinOfdPath(...parts) {
    const joined = parts.filter(Boolean).join("/");
    const segments = [];
    for (const segment of joined.split("/")){
        if (!segment || segment === ".") continue;
        if (segment === "..") {
            segments.pop();
            continue;
        }
        segments.push(segment);
    }
    return segments.join("/");
}
function $08414ea58bdc1292$var$directoryName2(path) {
    const normalized = $08414ea58bdc1292$var$normalizeOfdPath(path);
    const index = normalized.lastIndexOf("/");
    return index >= 0 ? normalized.slice(0, index) : "";
}
function $08414ea58bdc1292$var$normalizeOfdPath(path) {
    return path.replace(/\\/g, "/").replace(/^\/+/, "").replace(/\/+/g, "/");
}
function $08414ea58bdc1292$var$mimeTypeFromPath2(path) {
    const extension = path.split(".").pop()?.toLowerCase();
    const map = {
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        gif: "image/gif",
        bmp: "image/bmp",
        webp: "image/webp"
    };
    return extension ? map[extension] || "application/octet-stream" : "application/octet-stream";
}
function $08414ea58bdc1292$var$parseBoundary(value) {
    const parts = (value || "").trim().split(/\s+/).map((part)=>Number(part));
    return {
        x: Number.isFinite(parts[0]) ? parts[0] : 0,
        y: Number.isFinite(parts[1]) ? parts[1] : 0,
        width: Number.isFinite(parts[2]) ? parts[2] : 0,
        height: Number.isFinite(parts[3]) ? parts[3] : 0
    };
}
function $08414ea58bdc1292$var$getOfdAttribute(element, localName) {
    const direct = element.getAttribute(localName);
    if (direct !== null) return direct;
    for (const attribute of Array.from(element.attributes)){
        if (attribute.localName === localName) return attribute.value;
    }
    return null;
}
function $08414ea58bdc1292$var$finiteNumber2(value, fallback) {
    const parsed = value === null ? Number.NaN : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}
function $08414ea58bdc1292$var$formatOfdCssNumber(value) {
    return Number.isInteger(value) ? String(value) : value.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
}
function $08414ea58bdc1292$var$createOfdFailure(file, url, error) {
    if ((0, $3438a2478d5b847f$export$c0d4bb025764fd57)(error)) return (0, $3438a2478d5b847f$export$415721fb0f336a4b)(file, url, {
        title: "OFD \u6587\u4EF6\u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u5728\u7EBF\u9884\u89C8",
        message: "\u8BF7\u4E0B\u8F7D\u540E\u4F7F\u7528\u672C\u5730 OFD \u9605\u8BFB\u5668\u8F93\u5165\u5BC6\u7801\u6253\u5F00\uFF0C\u6216\u4E0A\u4F20\u89E3\u5BC6\u540E\u7684 OFD \u6587\u4EF6\u3002",
        action: "\u4E0B\u8F7D OFD"
    });
    return $08414ea58bdc1292$var$createOfdFallback(file.name, url, $08414ea58bdc1292$var$normalizeOfdError(error));
}
function $08414ea58bdc1292$var$createOfdFallback(fileName, url, detail) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = "OFD \u89E3\u6790\u5931\u8D25";
    const meta = document.createElement("span");
    meta.textContent = `${detail}\u3002\u53EF\u4E0B\u8F7D ${fileName} \u540E\u4F7F\u7528\u672C\u5730 OFD \u9605\u8BFB\u5668\u67E5\u770B\u3002`;
    const download = document.createElement("a");
    download.href = url;
    download.download = fileName;
    download.textContent = "\u4E0B\u8F7D OFD";
    fallback.append(title, meta, download);
    return fallback;
}
function $08414ea58bdc1292$var$normalizeOfdError(error) {
    if (error instanceof Error && error.message) return error.message;
    return "\u6587\u4EF6\u53EF\u80FD\u5DF2\u635F\u574F\uFF0C\u6216\u4E0D\u662F\u6709\u6548\u7684 OFD \u5305";
}
var $08414ea58bdc1292$var$archiveExtensions = /* @__PURE__ */ new Set([
    "zip",
    "rar",
    "7z",
    "tar",
    "gz",
    "tgz",
    "bz2",
    "xz"
]);
var $08414ea58bdc1292$var$archiveMimeTypes = /* @__PURE__ */ new Set([
    "application/zip",
    "application/x-zip-compressed",
    "application/vnd.rar",
    "application/x-rar-compressed",
    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip",
    "application/x-gzip",
    "application/x-bzip2",
    "application/x-xz"
]);
var $08414ea58bdc1292$var$archiveMimeFormatMap = {
    "application/zip": "zip",
    "application/x-zip-compressed": "zip",
    "application/vnd.rar": "rar",
    "application/x-rar-compressed": "rar",
    "application/x-7z-compressed": "7z",
    "application/x-tar": "tar",
    "application/gzip": "gz",
    "application/x-gzip": "gz",
    "application/x-bzip2": "bz2",
    "application/x-xz": "xz"
};

function $08414ea58bdc1292$export$2da9e3be5ef79a36() {
    return {
        name: "archive",
        match (file) {
            return $08414ea58bdc1292$var$archiveExtensions.has(file.extension) || $08414ea58bdc1292$var$archiveMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-archive");
            ctx.viewport.append(panel);
            const ext = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$archiveMimeFormatMap).toLowerCase();
            let archiveEntries = [];
            let isEncrypted = false;
            let parseError = null;
            let archiveProbe = null;
            try {
                if (ext === "zip") try {
                    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file), {
                        decodeFileName: $08414ea58bdc1292$var$decodeZipFileName
                    });
                    archiveEntries = Object.values(zip.files).map((entry)=>({
                            name: entry.name,
                            unsafeName: entry.unsafeOriginalName,
                            size: entry._data?.uncompressedSize || 0,
                            dir: entry.dir,
                            read: ()=>entry.async("arraybuffer")
                        }));
                } catch (zipErr) {
                    if ((0, $3438a2478d5b847f$export$c0d4bb025764fd57)(zipErr)) isEncrypted = true;
                    else throw zipErr;
                }
                else if (ext === "tar") archiveEntries = $08414ea58bdc1292$var$untar(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                else if (ext === "gz" || ext === "tgz" || ext === "tar.gz") {
                    const u8 = new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                    const decompressed = (0, $cab713332464fe22$export$2e2bcd8739ae039).ungzip(u8);
                    const originalName = ctx.file.name.endsWith(".gz") ? ctx.file.name.slice(0, -3) : ctx.file.name.endsWith(".tgz") ? ctx.file.name.slice(0, -4) + ".tar" : ctx.file.name;
                    if (ext === "tgz" || ext === "tar.gz" || originalName.endsWith(".tar")) archiveEntries = $08414ea58bdc1292$var$untar($08414ea58bdc1292$var$toArrayBuffer(decompressed));
                    else archiveEntries = [
                        {
                            name: originalName,
                            size: decompressed.byteLength,
                            dir: false,
                            read: async ()=>$08414ea58bdc1292$var$toArrayBuffer(decompressed)
                        }
                    ];
                } else if (ext === "bz2") {
                    const compressed = new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                    const decompressed = await $08414ea58bdc1292$var$bunzip2(compressed);
                    const originalName = ctx.file.name.toLowerCase().endsWith(".bz2") ? ctx.file.name.slice(0, -4) : ctx.file.name;
                    archiveEntries = [
                        {
                            name: originalName || "decompressed",
                            size: decompressed.byteLength,
                            dir: false,
                            read: async ()=>$08414ea58bdc1292$var$toArrayBuffer(decompressed)
                        }
                    ];
                } else if (ext === "xz") {
                    const compressed = new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                    const decompressed = await $08414ea58bdc1292$var$unxz(compressed);
                    const originalName = $08414ea58bdc1292$var$deriveSingleFileArchiveName(ctx.file.name, ".xz", "decompressed");
                    if (originalName.toLowerCase().endsWith(".tar") || ctx.file.name.toLowerCase().endsWith(".txz")) archiveEntries = $08414ea58bdc1292$var$untar($08414ea58bdc1292$var$toArrayBuffer(decompressed));
                    else archiveEntries = [
                        {
                            name: originalName,
                            size: decompressed.byteLength,
                            dir: false,
                            read: async ()=>$08414ea58bdc1292$var$toArrayBuffer(decompressed)
                        }
                    ];
                } else if ([
                    "rar",
                    "7z"
                ].includes(ext)) archiveProbe = $08414ea58bdc1292$var$probeArchiveHeader(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file), ext);
                else parseError = `\u8BE5\u683C\u5F0F (.${ext.toUpperCase()}) \u76EE\u524D\u6682\u4E0D\u652F\u6301\u76F4\u63A5\u5728\u6D4F\u89C8\u5668\u7AEF\u5728\u7EBF\u89E3\u538B\u548C\u76EE\u5F55\u9884\u89C8\u3002`;
            } catch (err) {
                parseError = `\u538B\u7F29\u5305\u89E3\u6790\u5931\u8D25\uFF1A${err.message || err}`;
            }
            if (isEncrypted) {
                const fallback = (0, $3438a2478d5b847f$export$415721fb0f336a4b)(ctx.file, url, {
                    title: "\u538B\u7F29\u5305\u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u5728\u7EBF\u9884\u89C8",
                    message: "\u8BF7\u4E0B\u8F7D\u540E\u5728\u672C\u5730\u8F93\u5165\u5BC6\u7801\u89E3\u538B\uFF0C\u6216\u4E0A\u4F20\u89E3\u5BC6\u540E\u7684\u538B\u7F29\u5305\u3002",
                    action: "\u4E0B\u8F7D\u538B\u7F29\u5305"
                });
                panel.append(fallback);
                ctx.viewport.classList.add("ofv-center");
                return {
                    destroy () {
                        ctx.viewport.classList.remove("ofv-center");
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                        panel.remove();
                    }
                };
            }
            if (archiveProbe) {
                $08414ea58bdc1292$var$renderArchiveProbe(panel, archiveProbe, ctx.file.name, url);
                return {
                    destroy () {
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                        panel.remove();
                    }
                };
            }
            if (parseError) {
                const fallback = document.createElement("div");
                fallback.className = "ofv-fallback";
                const title = document.createElement("strong");
                title.textContent = parseError;
                const meta = document.createElement("span");
                meta.textContent = "\u5EFA\u8BAE\u4E0B\u8F7D\u89C6\u9891/\u6587\u6863\u7B49\u6587\u4EF6\u81F3\u672C\u5730\u67E5\u770B\uFF0C\u6216\u4F7F\u7528\u539F\u751F\u89E3\u538B\u5DE5\u5177\u63D0\u53D6\u5185\u5BB9\u3002";
                const download = document.createElement("a");
                download.href = url;
                download.download = ctx.file.name;
                download.textContent = "\u4E0B\u8F7D\u538B\u7F29\u5305";
                fallback.append(title, meta, download);
                panel.append(fallback);
                ctx.viewport.classList.add("ofv-center");
                return {
                    destroy () {
                        ctx.viewport.classList.remove("ofv-center");
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                        panel.remove();
                    }
                };
            }
            const layout = document.createElement("div");
            layout.className = "ofv-archive-layout";
            const sidebar = document.createElement("div");
            sidebar.className = "ofv-archive-sidebar";
            const sidebarPanel = document.createElement("div");
            sidebarPanel.className = "ofv-archive-sidebar-panel";
            const header = document.createElement("div");
            header.className = "ofv-archive-header";
            const sidebarTitle = document.createElement("span");
            sidebarTitle.className = "ofv-archive-header-title";
            sidebarTitle.textContent = `\u6587\u4EF6\u5217\u8868 (${archiveEntries.filter((e)=>!e.dir).length})`;
            const sidebarToggle = document.createElement("button");
            sidebarToggle.className = "ofv-archive-sidebar-toggle";
            sidebarToggle.type = "button";
            sidebarToggle.setAttribute("aria-label", "\u5C55\u5F00\u6587\u4EF6\u5217\u8868");
            sidebarToggle.setAttribute("aria-expanded", "false");
            sidebarToggle.title = "\u5C55\u5F00\u6587\u4EF6\u5217\u8868";
            sidebarToggle.textContent = "\u2039";
            header.append(sidebarToggle, sidebarTitle);
            sidebarPanel.append(header);
            const tree = document.createElement("div");
            tree.className = "ofv-archive-tree";
            sidebarPanel.append(tree);
            sidebar.append(sidebarPanel);
            const mainPanel = document.createElement("div");
            mainPanel.className = "ofv-archive-main";
            layout.append(sidebar, mainPanel);
            panel.append(layout);
            let currentSubInstance = null;
            const getSidebarViewportWidth = ()=>ctx.viewport.clientWidth || ctx.size.width;
            const shouldAutoCollapseSidebar = ()=>getSidebarViewportWidth() <= 520;
            const setSidebarCollapsed = (collapsed)=>{
                layout.classList.toggle("is-sidebar-collapsed", collapsed);
                sidebarToggle.setAttribute("aria-expanded", String(!collapsed));
                const label = collapsed ? "\u5C55\u5F00\u6587\u4EF6\u5217\u8868" : "\u6536\u8D77\u6587\u4EF6\u5217\u8868";
                sidebarToggle.setAttribute("aria-label", label);
                sidebarToggle.title = label;
                sidebarToggle.textContent = collapsed ? "\u203A" : "\u2039";
            };
            setSidebarCollapsed(false);
            sidebarToggle.addEventListener("click", ()=>{
                setSidebarCollapsed(!layout.classList.contains("is-sidebar-collapsed"));
            });
            const showDefaultSummary = (isSupplemental = true)=>{
                mainPanel.replaceChildren();
                const summary = document.createElement("div");
                summary.className = "ofv-archive-info";
                if (isSupplemental) $08414ea58bdc1292$var$hideSupplementalInfo4(summary);
                const heading = document.createElement("h3");
                heading.textContent = ctx.file.name;
                const info = document.createElement("div");
                info.className = "ofv-archive-info-meta";
                const fileCount = archiveEntries.filter((e)=>!e.dir).length;
                const dirCount = archiveEntries.filter((e)=>e.dir).length;
                $08414ea58bdc1292$var$appendArchiveInfo(info, "\u683C\u5F0F\u7C7B\u578B", `.${ext.toUpperCase()} \u538B\u7F29\u6587\u4EF6`);
                $08414ea58bdc1292$var$appendArchiveInfo(info, "\u5305\u542B\u6587\u4EF6\u6570", `${fileCount} \u4E2A`);
                $08414ea58bdc1292$var$appendArchiveInfo(info, "\u5305\u542B\u76EE\u5F55\u6570", `${dirCount} \u4E2A`);
                $08414ea58bdc1292$var$appendArchiveInfo(info, "\u64CD\u4F5C\u63D0\u793A", fileCount === 0 ? "\u538B\u7F29\u5305\u5185\u6CA1\u6709\u53EF\u9884\u89C8\u7684\u6587\u4EF6\u3002" : "\u8BF7\u70B9\u51FB\u5DE6\u4FA7\u680F\u4E2D\u7684\u6587\u4EF6\u8FDB\u884C\u8054\u52A8\u9884\u89C8\u3002");
                summary.append(heading, info, $08414ea58bdc1292$var$createArchiveSummary(archiveEntries));
                mainPanel.append(summary);
            };
            const visibleEntries = archiveEntries.filter((e)=>!e.dir).slice(0, 500);
            showDefaultSummary(visibleEntries.length > 0);
            let destroyed = false;
            let renderToken = 0;
            const openArchiveEntry = async (entry, item)=>{
                if (destroyed) return;
                if (shouldAutoCollapseSidebar()) setSidebarCollapsed(true);
                const token = ++renderToken;
                sidebar.querySelectorAll(".ofv-archive-item").forEach((el)=>{
                    el.classList.remove("is-active");
                    el.removeAttribute("aria-current");
                });
                item.classList.add("is-active");
                item.setAttribute("aria-current", "true");
                if (currentSubInstance) {
                    currentSubInstance.destroy();
                    currentSubInstance = null;
                    ctx.toolbar?.refreshCommandSupport();
                }
                mainPanel.replaceChildren($08414ea58bdc1292$var$createArchiveLoading(entry.name.split("/").pop() || entry.name));
                try {
                    let buffer = await entry.read();
                    if (destroyed || token !== renderToken) return;
                    const subName = entry.name.split("/").pop() || entry.name;
                    const subExt = subName.split(".").pop()?.toLowerCase() || "";
                    if (subExt === "shp") {
                        const basePath = entry.name.slice(0, -4);
                        const dbfEntry = archiveEntries.find((e)=>e.name.toLowerCase() === basePath.toLowerCase() + ".dbf");
                        const shxEntry = archiveEntries.find((e)=>e.name.toLowerCase() === basePath.toLowerCase() + ".shx");
                        if (dbfEntry && shxEntry) {
                            const prjEntry = archiveEntries.find((e)=>e.name.toLowerCase() === basePath.toLowerCase() + ".prj");
                            const newZip = new (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ)))();
                            newZip.file(subName, buffer);
                            newZip.file(dbfEntry.name.split("/").pop(), await dbfEntry.read());
                            newZip.file(shxEntry.name.split("/").pop(), await shxEntry.read());
                            if (prjEntry) newZip.file(prjEntry.name.split("/").pop(), await prjEntry.read());
                            buffer = await newZip.generateAsync({
                                type: "arraybuffer"
                            });
                            if (destroyed || token !== renderToken) return;
                        }
                    }
                    const subContainer = document.createElement("div");
                    subContainer.style.cssText = "width: 100%; height: 100%; position: relative; display: flex; flex-direction: column;";
                    mainPanel.replaceChildren(subContainer);
                    const subViewport = document.createElement("div");
                    subViewport.className = "ofv-viewport";
                    subViewport.style.cssText = "flex: 1; width: 100%; height: 100%; position: relative; overflow: auto;";
                    subContainer.append(subViewport);
                    const subFile = await (0, $3438a2478d5b847f$export$e274b0a3e6f55538)(buffer, subName);
                    const plugins = [
                        ...ctx.options.plugins || [],
                        (0, $3438a2478d5b847f$export$23ed2e65aae2ac8a)()
                    ];
                    let matchedPlugin = await $08414ea58bdc1292$var$findSubPreviewPlugin(plugins, subFile);
                    if (destroyed || token !== renderToken) return;
                    if (matchedPlugin.name === "archive") matchedPlugin = (0, $3438a2478d5b847f$export$23ed2e65aae2ac8a)();
                    let previewError;
                    const nextSubInstance = await Promise.resolve().then(function() {
                        return (parcelRequire("gTsRe"));
                    }).then((res)=>matchedPlugin.render({
                            host: ctx.host,
                            viewport: subViewport,
                            file: subFile,
                            size: {
                                width: subViewport.clientWidth || 600,
                                height: subViewport.clientHeight || 400
                            },
                            options: ctx.options,
                            toolbar: ctx.toolbar,
                            setLoading: ()=>{},
                            setError: (err)=>{
                                previewError = err instanceof Error ? err : new Error(String(err));
                                subViewport.replaceChildren($08414ea58bdc1292$var$createInlineError("\u6587\u4EF6\u9884\u89C8\u5931\u8D25", previewError.message));
                            }
                        })).catch((error)=>{
                        previewError = error instanceof Error ? error : new Error(String(error));
                        subViewport.replaceChildren($08414ea58bdc1292$var$createInlineError("\u6587\u4EF6\u9884\u89C8\u5931\u8D25", previewError.message));
                        return void 0;
                    });
                    if (destroyed || token !== renderToken) {
                        nextSubInstance?.destroy();
                        return;
                    }
                    if (nextSubInstance && !previewError) {
                        currentSubInstance = nextSubInstance;
                        ctx.toolbar?.refreshCommandSupport();
                    } else if (nextSubInstance) {
                        nextSubInstance.destroy();
                        ctx.toolbar?.refreshCommandSupport();
                    }
                } catch (err) {
                    if (destroyed || token !== renderToken) return;
                    currentSubInstance = null;
                    ctx.toolbar?.refreshCommandSupport();
                    mainPanel.replaceChildren($08414ea58bdc1292$var$createInlineError("\u89E3\u538B\u52A0\u8F7D\u5931\u8D25", String(err.message || err)));
                }
            };
            visibleEntries.forEach((entry, index)=>{
                const item = document.createElement("button");
                item.className = "ofv-archive-item";
                item.type = "button";
                item.title = entry.name;
                const icon = document.createElement("span");
                icon.className = "ofv-archive-item-icon";
                icon.textContent = $08414ea58bdc1292$var$getIcon(entry.name, entry.dir);
                const name = document.createElement("span");
                name.className = "ofv-archive-item-name";
                name.textContent = entry.name;
                name.title = entry.name;
                item.append(icon, name);
                tree.append(item);
                item.addEventListener("click", async ()=>{
                    await openArchiveEntry(entry, item);
                });
                if (index === 0) openArchiveEntry(entry, item);
            });
            return {
                canCommand (command) {
                    return currentSubInstance?.canCommand?.(command) ?? false;
                },
                command (command) {
                    return currentSubInstance?.command?.(command) ?? false;
                },
                preparePrint () {
                    return currentSubInstance?.preparePrint?.();
                },
                resize (size) {
                    currentSubInstance?.resize?.(size);
                },
                destroy () {
                    destroyed = true;
                    renderToken += 1;
                    if (currentSubInstance) currentSubInstance.destroy();
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    panel.remove();
                }
            };
        }
    };
}
async function $08414ea58bdc1292$var$findSubPreviewPlugin(plugins, file) {
    for (const plugin of plugins){
        if (await plugin.match(file)) return plugin;
    }
    return (0, $3438a2478d5b847f$export$23ed2e65aae2ac8a)();
}

async function $08414ea58bdc1292$var$bunzip2(bytes) {
    const restoreBuffer = $08414ea58bdc1292$var$installSeekBzipBufferCompat();
    try {
        const module = await (parcelRequire("ePrGd"));
        const decoder = module.default || module;
        const decoded = decoder.decode(bytes);
        return decoded instanceof Uint8Array ? decoded : decoded instanceof ArrayBuffer ? new Uint8Array(decoded) : Uint8Array.from(decoded);
    } finally{
        restoreBuffer();
    }
}
function $08414ea58bdc1292$var$installSeekBzipBufferCompat() {
    const globalObject = globalThis;
    if (typeof globalObject.Buffer === "function") return ()=>void 0;
    class SeekBzipBuffer extends Uint8Array {
        copy(target, targetStart = 0, sourceStart = 0, sourceEnd = this.length) {
            const slice = this.subarray(sourceStart, sourceEnd);
            target.set(slice, targetStart);
            return slice.length;
        }
        toString(encoding) {
            if (encoding === "hex") return Array.from(this).map((byte)=>byte.toString(16).padStart(2, "0")).join("");
            return new TextDecoder().decode(this);
        }
    }
    globalObject.Buffer = SeekBzipBuffer;
    return ()=>{
        if (globalObject.Buffer === SeekBzipBuffer) Reflect.deleteProperty(globalObject, "Buffer");
    };
}

async function $08414ea58bdc1292$var$unxz(bytes) {
    const module = await (parcelRequire("aCW7J"));
    const XzReadableStream = module.XzReadableStream || module.default?.XzReadableStream;
    if (typeof XzReadableStream !== "function") throw new Error("XZ \u89E3\u7801\u5668\u4E0D\u53EF\u7528\u3002");
    const response = new Response(new XzReadableStream($08414ea58bdc1292$var$createByteReadableStream(bytes)));
    return new Uint8Array(await response.arrayBuffer());
}
function $08414ea58bdc1292$var$createByteReadableStream(bytes) {
    const blob = new Blob([
        bytes
    ]);
    if (typeof blob.stream === "function") return blob.stream();
    return new ReadableStream({
        start (controller) {
            controller.enqueue(bytes);
            controller.close();
        }
    });
}
function $08414ea58bdc1292$var$deriveSingleFileArchiveName(fileName, suffix, fallback) {
    return fileName.toLowerCase().endsWith(suffix) ? fileName.slice(0, -suffix.length) || fallback : fileName || fallback;
}
function $08414ea58bdc1292$var$toArrayBuffer(bytes) {
    const copy = new Uint8Array(bytes.byteLength);
    copy.set(bytes);
    return copy.buffer;
}
function $08414ea58bdc1292$var$decodeZipFileName(bytes) {
    const data = Array.isArray(bytes) ? Uint8Array.from(bytes.map((value)=>value.charCodeAt(0) & 255)) : bytes instanceof Uint8Array ? bytes : Uint8Array.from(bytes);
    const utf8 = $08414ea58bdc1292$var$decodeZipNameWith(data, "utf-8", true);
    if (utf8 && !$08414ea58bdc1292$var$looksMojibake(utf8)) return utf8;
    const gb18030 = $08414ea58bdc1292$var$decodeZipNameWith(data, "gb18030", false) || $08414ea58bdc1292$var$decodeZipNameWith(data, "gbk", false);
    if (gb18030 && !$08414ea58bdc1292$var$looksMojibake(gb18030)) return gb18030;
    return utf8 || new TextDecoder("latin1").decode(data);
}
function $08414ea58bdc1292$var$decodeZipNameWith(bytes, encoding, fatal) {
    try {
        return new TextDecoder(encoding, {
            fatal: fatal
        }).decode(bytes);
    } catch  {
        return void 0;
    }
}
function $08414ea58bdc1292$var$looksMojibake(value) {
    return /[\uFFFDÃÂÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß]/.test(value);
}
function $08414ea58bdc1292$var$createInlineError(titleText, detailText) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = titleText;
    const detail = document.createElement("span");
    detail.textContent = detailText;
    fallback.append(title, detail);
    return fallback;
}
function $08414ea58bdc1292$var$appendArchiveInfo(parent, label, value) {
    const row = document.createElement("div");
    const key = document.createElement("strong");
    key.textContent = `${label}\uFF1A`;
    row.append(key, document.createTextNode(value));
    parent.append(row);
}
function $08414ea58bdc1292$var$hideSupplementalInfo4(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$createArchiveSummary(entries) {
    const files = entries.filter((entry)=>!entry.dir);
    const summary = document.createElement("dl");
    summary.className = "ofv-archive-summary";
    const totalSize = files.reduce((sum, entry)=>sum + entry.size, 0);
    const largest = files.reduce((current, entry)=>!current || entry.size > current.size ? entry : current, void 0);
    $08414ea58bdc1292$var$appendArchiveSummary(summary, "\u603B\u89E3\u538B\u5927\u5C0F", $08414ea58bdc1292$var$formatBytes2(totalSize));
    $08414ea58bdc1292$var$appendArchiveSummary(summary, "\u6700\u5927\u6587\u4EF6", largest ? `${largest.name} \xB7 ${$08414ea58bdc1292$var$formatBytes2(largest.size)}` : "\u65E0");
    $08414ea58bdc1292$var$appendArchiveSummary(summary, "\u7C7B\u578B\u5206\u5E03", $08414ea58bdc1292$var$formatArchiveExtensions(files));
    $08414ea58bdc1292$var$appendArchiveSummary(summary, "\u53EF\u9884\u89C8\u6761\u76EE", String(files.slice(0, 500).length));
    $08414ea58bdc1292$var$appendArchiveSummary(summary, "\u98CE\u9669\u8DEF\u5F84", String(files.filter((entry)=>$08414ea58bdc1292$var$isRiskyArchivePath(entry.unsafeName || entry.name)).length));
    return summary;
}
function $08414ea58bdc1292$var$appendArchiveSummary(parent, label, value) {
    const key = document.createElement("dt");
    key.textContent = label;
    const content = document.createElement("dd");
    content.textContent = value;
    parent.append(key, content);
}
function $08414ea58bdc1292$var$formatArchiveExtensions(entries) {
    const counts = /* @__PURE__ */ new Map();
    for (const entry of entries){
        const name = entry.name.split("/").pop() || entry.name;
        const index = name.lastIndexOf(".");
        const extension = index > 0 ? name.slice(index + 1).toLowerCase() : "(\u65E0\u6269\u5C55\u540D)";
        counts.set(extension, (counts.get(extension) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1] || a[0].localeCompare(b[0])).slice(0, 6).map(([extension, count])=>`${extension} ${count}`).join(", ") || "\u65E0";
}
function $08414ea58bdc1292$var$isRiskyArchivePath(name) {
    return name.startsWith("/") || /^[A-Za-z]:[\\/]/.test(name) || name.split(/[\\/]+/).includes("..");
}
function $08414ea58bdc1292$var$createArchiveLoading(fileName) {
    const loading = document.createElement("div");
    loading.className = "ofv-archive-loading";
    const spinner = document.createElement("div");
    spinner.className = "ofv-archive-loading-spinner";
    const text = document.createElement("span");
    text.textContent = `\u6B63\u5728\u89E3\u538B\u5E76\u52A0\u8F7D [${fileName}]...`;
    loading.append(spinner, text);
    return loading;
}
function $08414ea58bdc1292$var$renderArchiveProbe(panel, probe, fileName, url) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${probe.format} \u7ED3\u6784\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = probe.note;
    const meta = document.createElement("div");
    meta.className = "ofv-archive-probe-meta";
    $08414ea58bdc1292$var$appendArchiveInfo(meta, "\u6587\u4EF6", fileName);
    $08414ea58bdc1292$var$appendArchiveInfo(meta, "\u683C\u5F0F", probe.format);
    for (const item of probe.meta)$08414ea58bdc1292$var$appendArchiveInfo(meta, item.label, item.value);
    const download = document.createElement("a");
    download.className = "ofv-asset-download";
    download.href = url;
    download.download = fileName;
    download.textContent = "\u4E0B\u8F7D\u538B\u7F29\u5305";
    section.append(note, meta, download);
    if (!probe.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = probe.error || "\u538B\u7F29\u5305\u5934\u4FE1\u606F\u65E0\u6CD5\u8BC6\u522B\u3002";
        section.append(error);
    }
    if (probe.entries.length > 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "ofv-table-scroll ofv-archive-probe-table";
        const table = document.createElement("table");
        const thead = document.createElement("thead");
        const header = document.createElement("tr");
        for (const label of [
            "\u6587\u4EF6",
            "\u539F\u59CB\u5927\u5C0F",
            "\u538B\u7F29\u5927\u5C0F"
        ]){
            const th = document.createElement("th");
            th.textContent = label;
            header.append(th);
        }
        thead.append(header);
        const tbody = document.createElement("tbody");
        for (const entry of probe.entries.slice(0, 200)){
            const tr = document.createElement("tr");
            for (const value of [
                entry.name,
                entry.size === void 0 ? "\u672A\u77E5" : $08414ea58bdc1292$var$formatBytes2(entry.size),
                entry.packedSize === void 0 ? "\u672A\u77E5" : $08414ea58bdc1292$var$formatBytes2(entry.packedSize)
            ]){
                const td = document.createElement("td");
                td.textContent = value;
                tr.append(td);
            }
            tbody.append(tr);
        }
        table.append(thead, tbody);
        wrapper.append(table);
        section.append(wrapper);
    }
    panel.append(section);
}
function $08414ea58bdc1292$var$probeArchiveHeader(arrayBuffer, extension) {
    const bytes = new Uint8Array(arrayBuffer);
    if (extension === "rar") return $08414ea58bdc1292$var$probeRar(bytes);
    if (extension === "7z") return $08414ea58bdc1292$var$probe7z(bytes);
    if (extension === "bz2") return $08414ea58bdc1292$var$probeBzip2(bytes);
    if (extension === "xz") return $08414ea58bdc1292$var$probeXz(bytes);
    return {
        format: extension.toUpperCase(),
        valid: false,
        error: "\u6682\u4E0D\u652F\u6301\u8BE5\u538B\u7F29\u683C\u5F0F\u7684\u5934\u4FE1\u606F\u89E3\u6790\u3002",
        meta: [],
        entries: [],
        note: "\u5F53\u524D\u4EC5\u63D0\u4F9B\u538B\u7F29\u5305\u8BC6\u522B\u548C\u4E0B\u8F7D\u5165\u53E3\u3002"
    };
}
function $08414ea58bdc1292$var$probeRar(bytes) {
    const rar4 = bytes.length >= 7 && bytes[0] === 82 && bytes[1] === 97 && bytes[2] === 114 && bytes[3] === 33 && bytes[4] === 26 && bytes[5] === 7 && bytes[6] === 0;
    const rar5 = bytes.length >= 8 && bytes[0] === 82 && bytes[1] === 97 && bytes[2] === 114 && bytes[3] === 33 && bytes[4] === 26 && bytes[5] === 7 && bytes[6] === 1 && bytes[7] === 0;
    const entries = rar4 ? $08414ea58bdc1292$var$parseRar4Entries(bytes) : [];
    return {
        format: "RAR",
        valid: rar4 || rar5,
        error: rar4 || rar5 ? void 0 : "\u7F3A\u5C11 RAR signature\u3002",
        meta: [
            {
                label: "\u7248\u672C",
                value: rar5 ? "RAR5" : rar4 ? "RAR4" : "\u672A\u77E5"
            },
            {
                label: "\u7B7E\u540D",
                value: $08414ea58bdc1292$var$byteSignature(bytes)
            },
            {
                label: "\u53EF\u89C1\u6761\u76EE",
                value: String(entries.length)
            }
        ],
        entries: entries,
        note: rar4 ? "\u5F53\u524D\u8F7B\u91CF\u8BFB\u53D6 RAR4 \u672A\u52A0\u5BC6\u6587\u4EF6\u5934\uFF0C\u7528\u4E8E\u76EE\u5F55\u786E\u8BA4\uFF1B\u5B9E\u9645\u89E3\u538B\u4ECD\u5EFA\u8BAE\u63A5\u5165 unrar WASM \u6216\u672C\u5730\u5DE5\u5177\u3002" : "\u5F53\u524D\u8BC6\u522B RAR \u5BB9\u5668\u548C\u7248\u672C\uFF1BRAR5 \u76EE\u5F55\u89E3\u6790\u9700\u8981\u4E13\u7528\u89E3\u7801\u5668\u3002"
    };
}
function $08414ea58bdc1292$var$parseRar4Entries(bytes) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const entries = [];
    let offset = 7;
    while(offset + 7 <= bytes.length && entries.length < 200){
        const type = bytes[offset + 2];
        const flags = view3.getUint16(offset + 3, true);
        let headerSize = view3.getUint16(offset + 5, true);
        if (headerSize < 7 || offset + headerSize > bytes.length) break;
        if ((flags & 32768) !== 0) {
            if (offset + 11 > bytes.length) break;
            headerSize += view3.getUint32(offset + 7, true);
        }
        if (type === 116 && offset + 32 <= bytes.length) {
            const packedSize = view3.getUint32(offset + 7, true);
            const unpackedSize = view3.getUint32(offset + 11, true);
            const nameSize = view3.getUint16(offset + 26, true);
            const nameOffset = offset + 32;
            const nameEnd = Math.min(nameOffset + nameSize, offset + headerSize, bytes.length);
            const nameBytes = bytes.slice(nameOffset, nameEnd);
            const name = new TextDecoder("latin1").decode(nameBytes).replace(/\0.*$/, "");
            if (name) entries.push({
                name: name,
                size: unpackedSize,
                packedSize: packedSize
            });
        }
        offset += headerSize;
    }
    return entries;
}
function $08414ea58bdc1292$var$probe7z(bytes) {
    const valid = bytes.length >= 32 && bytes[0] === 55 && bytes[1] === 122 && bytes[2] === 188 && bytes[3] === 175 && bytes[4] === 39 && bytes[5] === 28;
    const meta = [
        {
            label: "\u7B7E\u540D",
            value: $08414ea58bdc1292$var$byteSignature(bytes)
        }
    ];
    if (valid) {
        const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        meta.push({
            label: "\u7248\u672C",
            value: `${bytes[6]}.${bytes[7]}`
        });
        meta.push({
            label: "Next header offset",
            value: String($08414ea58bdc1292$var$readUint64Le2(view3, 12))
        });
        meta.push({
            label: "Next header size",
            value: String($08414ea58bdc1292$var$readUint64Le2(view3, 20))
        });
        meta.push({
            label: "Next header CRC",
            value: `0x${view3.getUint32(28, true).toString(16).toUpperCase()}`
        });
    }
    return {
        format: "7Z",
        valid: valid,
        error: valid ? void 0 : "\u7F3A\u5C11 7z signature\u3002",
        meta: meta,
        entries: [],
        note: "\u5F53\u524D\u8BC6\u522B 7z \u5BB9\u5668\u548C next header \u8FB9\u754C\uFF1B\u76EE\u5F55\u548C\u89E3\u538B\u9700\u8981 LZMA/7z \u4E13\u7528\u89E3\u7801\u5668\u3002"
    };
}
function $08414ea58bdc1292$var$probeBzip2(bytes) {
    const valid = bytes.length >= 4 && bytes[0] === 66 && bytes[1] === 90 && bytes[2] === 104 && bytes[3] >= 49 && bytes[3] <= 57;
    return {
        format: "BZIP2",
        valid: valid,
        error: valid ? void 0 : "\u7F3A\u5C11 BZh magic header\u3002",
        meta: [
            {
                label: "\u7B7E\u540D",
                value: $08414ea58bdc1292$var$byteSignature(bytes)
            },
            {
                label: "\u5757\u5927\u5C0F",
                value: valid ? `${String.fromCharCode(bytes[3])}00 KB` : "\u672A\u77E5"
            }
        ],
        entries: [],
        note: "BZIP2 \u901A\u5E38\u662F\u5355\u6587\u4EF6\u538B\u7F29\u6D41\uFF0C\u672C\u9884\u89C8\u5668\u5F53\u524D\u5C55\u793A\u5BB9\u5668\u5934\u4FE1\u606F\uFF1B\u89E3\u538B\u53EF\u540E\u7EED\u63A5\u5165 bzip2 \u89E3\u7801\u5668\u3002"
    };
}
function $08414ea58bdc1292$var$probeXz(bytes) {
    const valid = bytes.length >= 6 && bytes[0] === 253 && bytes[1] === 55 && bytes[2] === 122 && bytes[3] === 88 && bytes[4] === 90 && bytes[5] === 0;
    return {
        format: "XZ",
        valid: valid,
        error: valid ? void 0 : "\u7F3A\u5C11 XZ magic header\u3002",
        meta: [
            {
                label: "\u7B7E\u540D",
                value: $08414ea58bdc1292$var$byteSignature(bytes)
            },
            {
                label: "Stream flags",
                value: bytes.length >= 8 ? `0x${bytes[6].toString(16).padStart(2, "0").toUpperCase()} 0x${bytes[7].toString(16).padStart(2, "0").toUpperCase()}` : "\u672A\u77E5"
            }
        ],
        entries: [],
        note: "XZ \u901A\u5E38\u662F\u5355\u6587\u4EF6 LZMA2 \u538B\u7F29\u6D41\uFF0C\u672C\u9884\u89C8\u5668\u5F53\u524D\u5C55\u793A\u5BB9\u5668\u5934\u4FE1\u606F\uFF1B\u89E3\u538B\u53EF\u540E\u7EED\u63A5\u5165 xz/lzma \u89E3\u7801\u5668\u3002"
    };
}
function $08414ea58bdc1292$var$readUint64Le2(view3, offset) {
    return BigInt(view3.getUint32(offset, true)) | BigInt(view3.getUint32(offset + 4, true)) << 32n;
}
function $08414ea58bdc1292$var$formatBytes2(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
function $08414ea58bdc1292$var$byteSignature(bytes) {
    if (bytes.length === 0) return "\u7A7A\u6587\u4EF6";
    const ascii = new TextDecoder("ascii").decode(bytes.slice(0, Math.min(bytes.length, 16))).replace(/[^\x20-\x7E]/g, ".");
    const hex = Array.from(bytes.slice(0, Math.min(bytes.length, 8))).map((byte)=>byte.toString(16).padStart(2, "0").toUpperCase()).join(" ");
    return `${ascii} (${hex})`;
}
function $08414ea58bdc1292$var$untar(arrayBuffer) {
    const entries = [];
    const u8 = new Uint8Array(arrayBuffer);
    let offset = 0;
    const readString2 = (start, length)=>{
        let end = start;
        while(end < start + length && u8[end] !== 0)end++;
        return new TextDecoder().decode(u8.subarray(start, end)).trim();
    };
    while(offset + 512 <= arrayBuffer.byteLength){
        const magic = readString2(offset + 257, 6);
        if (magic !== "ustar" && magic !== "ustar\0") {
            let allZero = true;
            for(let i = 0; i < 512; i++)if (u8[offset + i] !== 0) {
                allZero = false;
                break;
            }
            if (allZero) break;
            break;
        }
        const name = readString2(offset, 100);
        const prefix = readString2(offset + 345, 155);
        const fullName = prefix ? `${prefix}/${name}` : name;
        const sizeStr = readString2(offset + 124, 12);
        const size = parseInt(sizeStr, 8) || 0;
        const typeflag = readString2(offset + 156, 1);
        const dir = typeflag === "5" || fullName.endsWith("/");
        const contentOffset = offset + 512;
        entries.push({
            name: fullName,
            size: size,
            dir: dir,
            read: async ()=>arrayBuffer.slice(contentOffset, contentOffset + size)
        });
        offset += 512 + Math.ceil(size / 512) * 512;
    }
    return entries;
}
function $08414ea58bdc1292$var$getIcon(name, dir) {
    if (dir) return "\uD83D\uDCC1";
    const ext = name.split(".").pop()?.toLowerCase();
    switch(ext){
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "svg":
        case "webp":
            return "\uD83D\uDDBC\uFE0F";
        case "pdf":
            return "\uD83D\uDCD5";
        case "doc":
        case "docx":
            return "\uD83D\uDCD8";
        case "xls":
        case "xlsx":
            return "\uD83D\uDCD7";
        case "ppt":
        case "pptx":
            return "\uD83D\uDCD9";
        case "zip":
        case "rar":
        case "7z":
        case "tar":
        case "gz":
            return "\uD83D\uDCE6";
        case "mp4":
        case "mkv":
        case "avi":
        case "webm":
            return "\uD83C\uDFA5";
        case "mp3":
        case "wav":
        case "ogg":
            return "\uD83C\uDFB5";
        case "txt":
        case "md":
        case "html":
        case "js":
        case "ts":
        case "json":
        case "css":
            return "\uD83D\uDCC4";
        default:
            return "\uD83D\uDCC4";
    }
}
// src/plugins/email.ts
var $08414ea58bdc1292$var$emailExtensions = /* @__PURE__ */ new Set([
    "eml",
    "msg",
    "mbox"
]);
var $08414ea58bdc1292$var$emailMimeTypes = /* @__PURE__ */ new Set([
    "message/rfc822",
    "application/vnd.ms-outlook",
    "application/mbox"
]);
var $08414ea58bdc1292$var$domPurifyLoader;
var $08414ea58bdc1292$var$emailMimeFormatMap = {
    "message/rfc822": "eml",
    "application/vnd.ms-outlook": "msg",
    "application/mbox": "mbox"
};



function $08414ea58bdc1292$export$416b72e9c35cd2a() {
    return {
        name: "email",
        match (file) {
            return $08414ea58bdc1292$var$emailExtensions.has(file.extension) || $08414ea58bdc1292$var$emailMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const DOMPurifyModule = await ($08414ea58bdc1292$var$domPurifyLoader ||= Promise.resolve((parcelRequire("hIrjg"))));
            const DOMPurify3 = DOMPurifyModule.default;
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-email");
            const content = document.createElement("div");
            content.className = "ofv-email-content";
            panel.append(content);
            ctx.viewport.append(panel);
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const ext = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$emailMimeFormatMap).toLowerCase();
            let emailData;
            const objectUrlsToRevoke = [];
            const attachmentObjectUrls = /* @__PURE__ */ new Map();
            const timersToClear = [];
            const zoomController = $08414ea58bdc1292$var$createEmailZoomController(panel, content, ctx);
            let mboxSummary = [];
            try {
                if (ext === "msg") {
                    const MsgReader = (await (parcelRequire("agZ0j"))).default;
                    const buffer = await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file);
                    const reader = new MsgReader(buffer);
                    const parsed = reader.getFileData();
                    if (parsed.error) throw new Error(parsed.error);
                    const from = parsed.senderName ? `${parsed.senderName} <${parsed.senderEmail || parsed.senderSmtpAddress || ""}>`.trim() : parsed.senderEmail || parsed.senderSmtpAddress || "";
                    const recipients = parsed.recipients || [];
                    const to = recipients.filter((r)=>r.recipType === "to").map((r)=>`${r.name || ""} <${r.email || r.smtpAddress || ""}>`.trim()).join("; ");
                    const cc = recipients.filter((r)=>r.recipType === "cc").map((r)=>`${r.name || ""} <${r.email || r.smtpAddress || ""}>`.trim()).join("; ");
                    const attachments = [];
                    if (Array.isArray(parsed.attachments)) parsed.attachments.forEach((att)=>{
                        try {
                            const fullAtt = reader.getAttachment(att);
                            attachments.push({
                                name: fullAtt.fileName || "\u672A\u547D\u540D\u9644\u4EF6",
                                mimeType: $08414ea58bdc1292$var$getAttachmentMimeType(fullAtt, att),
                                content: fullAtt.content,
                                contentId: att.pidContentId
                            });
                        } catch (attErr) {
                            console.warn("Failed to parse attachment:", attErr);
                        }
                    });
                    let bodyHtml = parsed.bodyHtml;
                    if (!bodyHtml && parsed.html instanceof Uint8Array) bodyHtml = new TextDecoder("utf-8").decode(parsed.html);
                    emailData = {
                        from: from || "-",
                        to: to || "-",
                        cc: cc || "",
                        subject: parsed.subject || "(\u65E0\u4E3B\u9898)",
                        date: parsed.messageDeliveryTime || parsed.clientSubmitTime || parsed.creationTime || "-",
                        bodyText: parsed.body,
                        bodyHtml: bodyHtml,
                        attachments: attachments
                    };
                } else {
                    const PostalMime = (await (parcelRequire("dD4c8"))).default;
                    const parser = new PostalMime();
                    let rawSource = await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file);
                    if (ext === "mbox") {
                        let rawText = await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file);
                        const messages = $08414ea58bdc1292$var$splitMboxMessages(rawText);
                        mboxSummary = messages.map($08414ea58bdc1292$var$summarizeMboxMessage);
                        rawSource = messages[0] || rawText;
                    }
                    const parsed = await parser.parse(rawSource);
                    const from = parsed.from ? `${parsed.from.name || ""} <${parsed.from.address || ""}>`.trim() : "";
                    const to = Array.isArray(parsed.to) ? parsed.to.map((t)=>`${t.name || ""} <${t.address || ""}>`.trim()).join("; ") : "";
                    const cc = Array.isArray(parsed.cc) ? parsed.cc.map((c)=>`${c.name || ""} <${c.address || ""}>`.trim()).join("; ") : "";
                    emailData = {
                        from: from || "-",
                        to: to || "-",
                        cc: cc || "",
                        subject: parsed.subject || "(\u65E0\u4E3B\u9898)",
                        date: parsed.date || "-",
                        bodyText: parsed.text,
                        bodyHtml: parsed.html,
                        attachments: (parsed.attachments || []).map((att)=>({
                                name: att.filename || "\u672A\u547D\u540D\u9644\u4EF6",
                                mimeType: att.mimeType || "application/octet-stream",
                                content: att.content instanceof Uint8Array ? att.content : new Uint8Array(att.content),
                                contentId: att.contentId
                            }))
                    };
                }
                if (mboxSummary.length > 0) content.append($08414ea58bdc1292$var$createMboxSummarySection(mboxSummary));
                const headerSection = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u90AE\u4EF6\u4FE1\u606F");
                $08414ea58bdc1292$var$hideSupplementalInfo5(headerSection);
                (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(headerSection, "Subject", emailData.subject);
                (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(headerSection, "From", emailData.from);
                (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(headerSection, "To", emailData.to);
                if (emailData.cc) (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(headerSection, "Cc", emailData.cc);
                (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(headerSection, "Date", emailData.date);
                content.append(headerSection);
                if (emailData.attachments.length > 0) {
                    const attachmentsSection = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u9644\u4EF6\u5217\u8868");
                    $08414ea58bdc1292$var$hideSupplementalInfo5(attachmentsSection);
                    const container = document.createElement("div");
                    container.className = "ofv-email-attachments";
                    emailData.attachments.forEach((att)=>{
                        const blobUrl = $08414ea58bdc1292$var$getAttachmentObjectUrl(att, attachmentObjectUrls, objectUrlsToRevoke);
                        const item = document.createElement("a");
                        item.className = "ofv-email-attachment-item";
                        item.href = blobUrl;
                        item.download = att.name;
                        item.rel = "noopener noreferrer";
                        const sizeKB = Math.round(att.content.byteLength / 1024);
                        item.textContent = `Attachment: ${att.name} (${sizeKB} KB)`;
                        container.append(item);
                    });
                    attachmentsSection.append(container);
                    content.append(attachmentsSection);
                }
                const bodySection = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u6B63\u6587");
                content.append(bodySection);
                let html = emailData.bodyHtml;
                if (html) {
                    let nextHtml = html;
                    emailData.attachments.forEach((att)=>{
                        const contentId = att.contentId;
                        if (contentId) {
                            const blobUrl = $08414ea58bdc1292$var$getAttachmentObjectUrl(att, attachmentObjectUrls, objectUrlsToRevoke);
                            const cleanCid = contentId.replace(/[<>]/g, "");
                            nextHtml = $08414ea58bdc1292$var$replaceCidResourceUrls(nextHtml, contentId, blobUrl);
                            if (cleanCid !== contentId) nextHtml = $08414ea58bdc1292$var$replaceCidResourceUrls(nextHtml, cleanCid, blobUrl);
                        }
                    });
                    html = nextHtml;
                    const sanitizedHtml = $08414ea58bdc1292$var$sanitizeEmailHtml(html, DOMPurify3);
                    const iframe = document.createElement("iframe");
                    iframe.className = "ofv-email-body-iframe";
                    iframe.setAttribute("sandbox", "allow-same-origin allow-popups allow-popups-to-escape-sandbox");
                    iframe.style.cssText = "width: 100%; border: none; background: #fff; min-height: 200px;";
                    let renderedHtmlBody = false;
                    let resizeHtmlBody;
                    const renderHtmlBody = ()=>{
                        if (renderedHtmlBody) return;
                        try {
                            const idoc = iframe.contentDocument || iframe.contentWindow?.document;
                            if (idoc) {
                                renderedHtmlBody = true;
                                idoc.open();
                                idoc.write(`
                  <!doctype html>
                  <html>
                    <head>
                      <meta charset="utf-8" />
                      <style>
                        body {
                          margin: 16px;
                          padding: 0;
                          font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                          font-size: 14px;
                          line-height: 1.6;
                          color: #1f2937;
                        }
                        img { max-width: 100%; height: auto; display: block; margin: 12px 0; }
                        a { color: #2563eb; }
                        blockquote {
                          margin: 12px 0;
                          padding-left: 12px;
                          border-left: 3px solid #d1d5db;
                          color: #4b5563;
                        }
                      </style>
                    </head>
                    <body>${sanitizedHtml}</body>
                  </html>
                `);
                                idoc.close();
                                $08414ea58bdc1292$var$secureEmailLinks(idoc);
                                zoomController.setHtmlBody(idoc.body, ()=>resizeHtmlBody?.());
                                ctx.toolbar?.refreshCommandSupport();
                                const resize = ()=>{
                                    const body = idoc.body;
                                    const docEl = idoc.documentElement;
                                    const height = Math.max(body.scrollHeight, body.offsetHeight, docEl.clientHeight, docEl.scrollHeight, docEl.offsetHeight);
                                    iframe.style.height = `${height + 32}px`;
                                };
                                resizeHtmlBody = resize;
                                resize();
                                timersToClear.push(window.setTimeout(resize, 300));
                                timersToClear.push(window.setTimeout(resize, 1e3));
                            }
                        } catch (err) {
                            console.error("Failed to write html body to email iframe:", err);
                        }
                    };
                    iframe.addEventListener("load", renderHtmlBody, {
                        once: true
                    });
                    bodySection.append(iframe);
                    renderHtmlBody();
                } else {
                    const pre = document.createElement("pre");
                    pre.className = "ofv-text-block";
                    pre.textContent = emailData.bodyText || "\u672A\u89E3\u6790\u5230\u6B63\u6587\u3002";
                    bodySection.append(pre);
                }
            } catch (err) {
                content.replaceChildren();
                const errorSection = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("\u90AE\u4EF6\u89E3\u6790\u51FA\u9519");
                const pre = document.createElement("pre");
                pre.className = "ofv-text-block";
                pre.style.color = "#ef4444";
                pre.textContent = `\u89E3\u6790\u90AE\u4EF6\u65F6\u53D1\u751F\u9519\u8BEF\uFF1A
${err.message || err}`;
                errorSection.append(pre);
                content.append(errorSection);
            }
            return {
                canCommand (command) {
                    return zoomController.canCommand(command);
                },
                command (command) {
                    return zoomController.command(command);
                },
                destroy () {
                    timersToClear.forEach((timer)=>window.clearTimeout(timer));
                    objectUrlsToRevoke.forEach((u)=>{
                        URL.revokeObjectURL(u);
                    });
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$createEmailZoomController(panel, content, ctx) {
    let zoom = 1;
    let htmlBody;
    let resizeHtmlBody;
    const apply = ()=>{
        const normalized = Math.round(zoom * 100) / 100;
        const style = content.style;
        style.zoom = "";
        content.style.width = "";
        if (normalized !== 1) {
            const base = content.clientWidth;
            if (base > 0) content.style.width = `${base}px`;
            style.zoom = String(normalized);
        }
        if (htmlBody) {
            resizeHtmlBody?.();
            window.setTimeout(()=>resizeHtmlBody?.(), 0);
        }
        ctx.toolbar?.setZoom(normalized === 1 ? void 0 : normalized);
    };
    apply();
    return {
        setHtmlBody (body, resize) {
            htmlBody = body;
            resizeHtmlBody = resize;
            apply();
        },
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom = Math.min(3, zoom * 1.15);
                apply();
                return true;
            }
            if (command === "zoom-out") {
                zoom = Math.max(0.5, zoom / 1.15);
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                zoom = 1;
                apply();
                return true;
            }
            return false;
        }
    };
}
function $08414ea58bdc1292$var$getAttachmentObjectUrl(attachment, cache, urlsToRevoke) {
    const cached = cache.get(attachment);
    if (cached) return cached;
    const blob = new Blob([
        attachment.content
    ], {
        type: attachment.mimeType
    });
    const url = URL.createObjectURL(blob);
    cache.set(attachment, url);
    urlsToRevoke.push(url);
    return url;
}
function $08414ea58bdc1292$var$getAttachmentMimeType(fullAttachment, attachmentMeta) {
    const candidates = [
        fullAttachment,
        attachmentMeta
    ];
    for (const candidate of candidates){
        if (!candidate || typeof candidate !== "object") continue;
        const record = candidate;
        const explicitMime = $08414ea58bdc1292$var$normalizeMimeValue(record.attachMimeTag) || $08414ea58bdc1292$var$normalizeMimeValue(record.mimeType) || $08414ea58bdc1292$var$normalizeMimeValue(record.contentType) || $08414ea58bdc1292$var$normalizeMimeValue(record.mime) || $08414ea58bdc1292$var$normalizeMimeValue(record["content-type"]);
        if (explicitMime) return explicitMime;
    }
    const fileName = (fullAttachment && typeof fullAttachment === "object" ? fullAttachment.fileName : void 0) || (attachmentMeta && typeof attachmentMeta === "object" ? attachmentMeta.fileName : void 0);
    return $08414ea58bdc1292$var$getMimeType(typeof fileName === "string" ? fileName : "");
}
function $08414ea58bdc1292$var$normalizeMimeValue(value) {
    if (typeof value !== "string") return "";
    const mimeType = value.split(";")[0]?.trim().toLowerCase() || "";
    return mimeType.includes("/") ? mimeType : "";
}
function $08414ea58bdc1292$var$replaceCidResourceUrls(html, contentId, blobUrl) {
    const escapedCid = $08414ea58bdc1292$var$escapeRegExp(contentId);
    return html.replace(new RegExp(`\\b(src|poster|background)=(["'])cid:${escapedCid}\\2`, "gi"), (_match, attribute, quote)=>`${attribute}=${quote}${blobUrl}${quote}`);
}
function $08414ea58bdc1292$var$escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $08414ea58bdc1292$var$createMboxSummarySection(messages) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("MBOX \u90AE\u7BB1\u6458\u8981");
    $08414ea58bdc1292$var$hideSupplementalInfo5(section);
    const meta = document.createElement("div");
    meta.className = "ofv-email-mbox-meta";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(meta, "\u90AE\u4EF6\u6570", String(messages.length));
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(meta, "\u9884\u89C8", "\u5F53\u524D\u6B63\u6587\u663E\u793A\u7B2C\u4E00\u5C01\u90AE\u4EF6");
    const tableWrap = document.createElement("div");
    tableWrap.className = "ofv-table-scroll ofv-email-mbox-table";
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const header = document.createElement("tr");
    for (const label of [
        "#",
        "Subject",
        "From",
        "Date"
    ]){
        const th = document.createElement("th");
        th.textContent = label;
        header.append(th);
    }
    thead.append(header);
    const tbody = document.createElement("tbody");
    messages.slice(0, 100).forEach((message, index)=>{
        const row = document.createElement("tr");
        for (const value of [
            String(index + 1),
            message.subject || "(\u65E0\u4E3B\u9898)",
            message.from || "-",
            message.date || "-"
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            row.append(cell);
        }
        tbody.append(row);
    });
    table.append(thead, tbody);
    tableWrap.append(table);
    section.append(meta, tableWrap);
    return section;
}
function $08414ea58bdc1292$var$hideSupplementalInfo5(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$splitMboxMessages(mboxText) {
    const lines = mboxText.replace(/\r\n/g, "\n").split("\n");
    const messages = [];
    let current = null;
    let foundFirstFrom = false;
    for (const line of lines){
        if (line.startsWith("From ")) {
            if (current && current.length > 0) messages.push(current);
            current = [];
            foundFirstFrom = true;
            continue;
        }
        if (foundFirstFrom && current) current.push(line.startsWith(">From ") ? line.slice(1) : line);
    }
    if (current && current.length > 0) messages.push(current);
    return messages.length > 0 ? messages.map((message)=>message.join("\n")) : [
        mboxText
    ];
}
function $08414ea58bdc1292$var$summarizeMboxMessage(message) {
    return {
        from: $08414ea58bdc1292$var$unfoldHeader($08414ea58bdc1292$var$readHeaderValue(message, "From")),
        subject: $08414ea58bdc1292$var$unfoldHeader($08414ea58bdc1292$var$readHeaderValue(message, "Subject")),
        date: $08414ea58bdc1292$var$unfoldHeader($08414ea58bdc1292$var$readHeaderValue(message, "Date"))
    };
}
function $08414ea58bdc1292$var$readHeaderValue(message, name) {
    const headers = message.split(/\n\s*\n/, 1)[0] || "";
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = headers.match(new RegExp(`^${escaped}:\\s*([\\s\\S]*?)(?=\\n[^\\s:]+:|\\n\\s*\\n|$)`, "im"));
    return match?.[1]?.trim() || "";
}
function $08414ea58bdc1292$var$unfoldHeader(value) {
    return value.replace(/\n[ \t]+/g, " ").trim();
}
function $08414ea58bdc1292$var$getMimeType(name) {
    const ext = name.split(".").pop()?.toLowerCase();
    const map = {
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        gif: "image/gif",
        webp: "image/webp",
        svg: "image/svg+xml",
        pdf: "application/pdf",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        txt: "text/plain",
        md: "text/markdown",
        html: "text/html",
        mp4: "video/mp4",
        mp3: "audio/mpeg",
        wav: "audio/wav"
    };
    return ext ? map[ext] || "application/octet-stream" : "application/octet-stream";
}
function $08414ea58bdc1292$var$sanitizeEmailHtml(html, purifier) {
    return purifier.sanitize(html, {
        USE_PROFILES: {
            html: true
        },
        ADD_ATTR: [
            "target"
        ],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|blob|cid):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i
    });
}
function $08414ea58bdc1292$var$secureEmailLinks(document2) {
    for (const link of document2.querySelectorAll("a[href]")){
        const href = link.getAttribute("href") || "";
        if (!$08414ea58bdc1292$var$isSafeEmailHref(href)) {
            link.removeAttribute("href");
            link.removeAttribute("target");
            link.removeAttribute("rel");
            continue;
        }
        if (/^(https?:)?\/\//i.test(href)) {
            link.target = "_blank";
            link.rel = "noopener noreferrer";
        }
    }
}
function $08414ea58bdc1292$var$isSafeEmailHref(href) {
    const trimmed = href.trim();
    return trimmed.startsWith("#") || trimmed.startsWith("/") || trimmed.startsWith("./") || trimmed.startsWith("../") || trimmed.startsWith("blob:") || /^(https?:|mailto:|tel:)/i.test(trimmed);
}
var $08414ea58bdc1292$var$drawingExtensions = /* @__PURE__ */ new Set([
    "drawio",
    "dio",
    "excalidraw",
    "tldraw"
]);
var $08414ea58bdc1292$var$drawingMimeFormatMap = {
    "application/vnd.jgraph.mxfile": "drawio",
    "application/vnd.excalidraw+json": "excalidraw",
    "application/x-excalidraw+json": "excalidraw"
};
var $08414ea58bdc1292$var$SVG_NS = "http://www.w3.org/2000/svg";
function $08414ea58bdc1292$export$99a9b67debe4ab65() {
    return {
        name: "drawing",
        match (file) {
            return $08414ea58bdc1292$var$drawingExtensions.has(file.extension) || Boolean($08414ea58bdc1292$var$drawingMimeFormatMap[file.mimeType]);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-drawing");
            ctx.viewport.append(panel);
            const text = await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file);
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$drawingMimeFormatMap);
            let controller;
            try {
                if (extension === "excalidraw") $08414ea58bdc1292$var$renderExcalidraw(panel, text);
                else if (extension === "tldraw") $08414ea58bdc1292$var$renderTldraw(panel, text);
                else if (extension === "drawio" || extension === "dio") $08414ea58bdc1292$var$renderDrawio(panel, text);
                else $08414ea58bdc1292$var$renderRawDrawing(panel, extension || "drawing", text);
                controller = $08414ea58bdc1292$var$createSvgViewportController(panel, ctx);
            } catch (error) {
                $08414ea58bdc1292$var$renderDrawingParseFallback(panel, extension || "drawing", text, error);
            }
            return {
                canCommand (command) {
                    return controller?.canCommand(command) ?? false;
                },
                command (command) {
                    return controller?.command(command) ?? false;
                },
                destroy () {
                    controller?.destroy();
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$createSvgViewportController(panel, ctx) {
    const svg = panel.querySelector(".ofv-svg-stage");
    const initialViewBox = $08414ea58bdc1292$var$parseSvgViewBox2(svg);
    if (!svg || !initialViewBox) return void 0;
    let currentViewBox = {
        ...initialViewBox
    };
    let rotation = 0;
    const applyViewBox = ()=>{
        svg.setAttribute("viewBox", `${currentViewBox.x} ${currentViewBox.y} ${currentViewBox.width} ${currentViewBox.height}`);
        ctx.toolbar?.setZoom(initialViewBox.width / currentViewBox.width);
    };
    const applyRotation = ()=>{
        svg.style.transformOrigin = "center center";
        svg.style.transform = rotation === 0 ? "" : `rotate(${rotation}deg)`;
    };
    applyViewBox();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left";
        },
        command (command) {
            if (command === "zoom-in" || command === "zoom-out") {
                const factor = command === "zoom-in" ? 0.82 : 1.18;
                const centerX = currentViewBox.x + currentViewBox.width / 2;
                const centerY = currentViewBox.y + currentViewBox.height / 2;
                currentViewBox.width *= factor;
                currentViewBox.height *= factor;
                currentViewBox.x = centerX - currentViewBox.width / 2;
                currentViewBox.y = centerY - currentViewBox.height / 2;
                applyViewBox();
                return true;
            }
            if (command === "zoom-reset") {
                currentViewBox = {
                    ...initialViewBox
                };
                rotation = 0;
                applyViewBox();
                applyRotation();
                return true;
            }
            if (command === "rotate-right" || command === "rotate-left") {
                rotation += command === "rotate-right" ? 90 : -90;
                applyRotation();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$parseSvgViewBox2(svg) {
    const parts = svg?.getAttribute("viewBox")?.trim().split(/[\s,]+/).map(Number);
    if (!parts || parts.length !== 4 || parts.some((part)=>!Number.isFinite(part)) || parts[2] <= 0 || parts[3] <= 0) return void 0;
    return {
        x: parts[0],
        y: parts[1],
        width: parts[2],
        height: parts[3]
    };
}
function $08414ea58bdc1292$var$createDrawingSummary(items) {
    const summary = document.createElement("div");
    summary.className = "ofv-drawing-summary";
    summary.hidden = items.length > 0;
    if (items.length > 0) {
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
    }
    const typeCounts = $08414ea58bdc1292$var$countDrawingTypes(items);
    $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u5BF9\u8C61", String(items.length));
    $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u7C7B\u578B", $08414ea58bdc1292$var$formatDrawingTypes(typeCounts));
    $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u6587\u672C", String(items.filter((item)=>item.text && item.text.trim()).length));
    $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u8FDE\u7EBF", String(items.filter((item)=>item.edge).length));
    const media = items.filter((item)=>item.image || item.embed).length;
    if (media > 0) $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u5A92\u4F53/\u5D4C\u5165", String(media));
    const bounds = $08414ea58bdc1292$var$drawingBounds(items);
    if (bounds) $08414ea58bdc1292$var$appendDrawingSummary(summary, "\u8303\u56F4", `${Math.round(bounds[0])}, ${Math.round(bounds[1])}, ${Math.round(bounds[2])}, ${Math.round(bounds[3])}`);
    return summary;
}
function $08414ea58bdc1292$var$appendDrawingSummary(parent, label, value) {
    const item = document.createElement("span");
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    item.append(key, content);
    parent.append(item);
}
function $08414ea58bdc1292$var$hideSuccessfulSectionHeading2(section) {
    const heading = section.querySelector("h3");
    if (heading) $08414ea58bdc1292$var$hideSupplementalInfo6(heading);
}
function $08414ea58bdc1292$var$hideSupplementalInfo6(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$countDrawingTypes(items) {
    const counts = /* @__PURE__ */ new Map();
    for (const item of items)counts.set(item.type, (counts.get(item.type) || 0) + 1);
    return counts;
}
function $08414ea58bdc1292$var$formatDrawingTypes(counts) {
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 6).map(([type, count])=>`${type} ${count}`).join(", ") || "\u65E0";
}
function $08414ea58bdc1292$var$drawingBounds(items) {
    const boxes = items.map((item)=>{
        if (!Number.isFinite(item.x) || !Number.isFinite(item.y)) return void 0;
        const x = item.x;
        const y = item.y;
        const width = Math.max(0, $08414ea58bdc1292$var$finiteNumber3(item.width, 0));
        const height = Math.max(0, $08414ea58bdc1292$var$finiteNumber3(item.height, 0));
        return [
            x,
            y,
            x + width,
            y + height
        ];
    }).filter((item)=>Boolean(item));
    if (boxes.length === 0) return void 0;
    return [
        Math.min(...boxes.map((box)=>box[0])),
        Math.min(...boxes.map((box)=>box[1])),
        Math.max(...boxes.map((box)=>box[2])),
        Math.max(...boxes.map((box)=>box[3]))
    ];
}
function $08414ea58bdc1292$var$excalidrawSummaryItem(element) {
    return {
        type: String(element.type || "unknown"),
        x: $08414ea58bdc1292$var$finiteNumber3(element.x, 0),
        y: $08414ea58bdc1292$var$finiteNumber3(element.y, 0),
        width: $08414ea58bdc1292$var$finiteNumber3(element.width, 0),
        height: $08414ea58bdc1292$var$finiteNumber3(element.height, 0),
        text: String(element.text || element.name || ""),
        image: element.type === "image",
        embed: element.type === "embeddable",
        edge: element.type === "arrow" || element.type === "line"
    };
}
function $08414ea58bdc1292$var$tldrawSummaryItem(shape) {
    const props = shape.props || {};
    return {
        type: String(shape.type || props.type || "unknown"),
        x: $08414ea58bdc1292$var$finiteNumber3(shape.x, 0),
        y: $08414ea58bdc1292$var$finiteNumber3(shape.y, 0),
        width: $08414ea58bdc1292$var$finiteNumber3(props.w, $08414ea58bdc1292$var$finiteNumber3(props.width, 0)),
        height: $08414ea58bdc1292$var$finiteNumber3(props.h, $08414ea58bdc1292$var$finiteNumber3(props.height, 0)),
        text: String(props.text || ""),
        edge: shape.type === "arrow" || shape.type === "line"
    };
}
function $08414ea58bdc1292$var$drawioSummaryItem(shape) {
    return {
        type: shape.edge ? "edge" : $08414ea58bdc1292$var$drawioShapeName(shape.style),
        x: shape.x,
        y: shape.y,
        width: shape.width,
        height: shape.height,
        text: shape.value,
        image: $08414ea58bdc1292$var$drawioShapeName(shape.style) === "image",
        edge: shape.edge
    };
}
function $08414ea58bdc1292$var$renderExcalidraw(panel, text) {
    const data = JSON.parse(text);
    const files = data.files || {};
    const elements = (data.elements || []).filter((element)=>!element.isDeleted);
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`Excalidraw ${elements.length} elements`);
    if (elements.length > 0) $08414ea58bdc1292$var$hideSuccessfulSectionHeading2(section);
    section.append($08414ea58bdc1292$var$createDrawingSummary(elements.map($08414ea58bdc1292$var$excalidrawSummaryItem)));
    const svg = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "svg");
    svg.setAttribute("class", "ofv-svg-stage");
    svg.setAttribute("viewBox", $08414ea58bdc1292$var$createExcalidrawViewBox(elements));
    const defs = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "defs");
    svg.append(defs);
    for (const element of elements){
        const type = String(element.type || "");
        const x = Number(element.x || 0);
        const y = Number(element.y || 0);
        const width = Number(element.width || 80);
        const height = Number(element.height || 40);
        const stroke = String(element.strokeColor || "#111827");
        const fill = $08414ea58bdc1292$var$excalidrawFill(svg, defs, element, stroke);
        const common = $08414ea58bdc1292$var$getExcalidrawCommonAttrs(element);
        const transform = $08414ea58bdc1292$var$excalidrawTransform(element, x, y, width, height);
        if (type === "frame") {
            const frame = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
            $08414ea58bdc1292$var$applySvgAttrs(frame, {
                x: x,
                y: y,
                width: width,
                height: height,
                rx: 4,
                fill: "transparent",
                stroke: "#94a3b8",
                "stroke-width": 2,
                "stroke-dasharray": "8 6",
                opacity: common.opacity,
                transform: transform
            });
            svg.append(frame);
            $08414ea58bdc1292$var$appendSvgMultilineText(svg, String(element.name || "Frame"), x + 12, y + 24, "#64748b", {
                fontSize: 14,
                transform: transform
            });
        } else if (type === "image") $08414ea58bdc1292$var$renderExcalidrawImage(svg, element, files, x, y, width, height, common, transform);
        else if (type === "embeddable") $08414ea58bdc1292$var$renderExcalidrawEmbeddable(svg, element, x, y, width, height, common, transform);
        else if (type === "rectangle" || type === "diamond") {
            if (type === "diamond") {
                const polygon = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polygon");
                polygon.setAttribute("points", `${x + width / 2},${y} ${x + width},${y + height / 2} ${x + width / 2},${y + height} ${x},${y + height / 2}`);
                $08414ea58bdc1292$var$applySvgAttrs(polygon, {
                    fill: fill,
                    stroke: stroke,
                    ...common,
                    transform: transform
                });
                svg.append(polygon);
            } else {
                const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
                $08414ea58bdc1292$var$applySvgAttrs(rect, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    rx: $08414ea58bdc1292$var$finiteNumber3(element.roundness && typeof element.roundness === "object" ? element.roundness.value : void 0, 0),
                    fill: fill,
                    stroke: stroke,
                    ...common,
                    transform: transform
                });
                svg.append(rect);
            }
        } else if (type === "ellipse") {
            const ellipse = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "ellipse");
            $08414ea58bdc1292$var$applySvgAttrs(ellipse, {
                cx: x + width / 2,
                cy: y + height / 2,
                rx: Math.abs(width / 2),
                ry: Math.abs(height / 2),
                fill: fill,
                stroke: stroke,
                ...common,
                transform: transform
            });
            svg.append(ellipse);
        } else if (type === "line" || type === "arrow") {
            const points = $08414ea58bdc1292$var$excalidrawPoints(element, x, y, width, height);
            if (points.length > 2) {
                const polyline = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polyline");
                $08414ea58bdc1292$var$applySvgAttrs(polyline, {
                    points: points.map((point)=>`${point.x},${point.y}`).join(" "),
                    fill: "none",
                    stroke: stroke,
                    ...common,
                    transform: transform
                });
                svg.append(polyline);
                $08414ea58bdc1292$var$appendExcalidrawArrowHeads(svg, element, points, stroke);
            } else {
                const start = points[0] || {
                    x: x,
                    y: y
                };
                const end = points[points.length - 1] || {
                    x: x + width,
                    y: y + height
                };
                const line = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "line");
                $08414ea58bdc1292$var$applySvgAttrs(line, {
                    x1: start.x,
                    y1: start.y,
                    x2: end.x,
                    y2: end.y,
                    stroke: stroke,
                    ...common,
                    transform: transform
                });
                svg.append(line);
                $08414ea58bdc1292$var$appendExcalidrawArrowHeads(svg, element, [
                    start,
                    end
                ], stroke);
            }
        } else if (type === "freedraw") {
            const path = $08414ea58bdc1292$var$createExcalidrawFreedrawPath(element, x, y);
            if (path) {
                $08414ea58bdc1292$var$applySvgAttrs(path, {
                    fill: "none",
                    stroke: stroke,
                    ...common,
                    transform: transform
                });
                svg.append(path);
            }
        } else if (type === "text") {
            const fontSize = $08414ea58bdc1292$var$finiteNumber3(element.fontSize, 18);
            const lines = String(element.text || "").split(/\r?\n/);
            const textAlign = String(element.textAlign || "left");
            const verticalAlign = String(element.verticalAlign || "top");
            const anchor = textAlign === "center" ? "middle" : textAlign === "right" ? "end" : "start";
            const textX = textAlign === "center" ? x + width / 2 : textAlign === "right" ? x + width : x;
            const textY = verticalAlign === "middle" ? y + height / 2 - (lines.length - 1) * fontSize * 1.25 / 2 : verticalAlign === "bottom" ? y + height - (lines.length - 1) * fontSize * 1.25 : y + fontSize;
            $08414ea58bdc1292$var$appendSvgMultilineText(svg, String(element.text || ""), textX, textY, stroke, {
                fontSize: fontSize,
                fontFamily: String(element.fontFamily || "Inter, ui-sans-serif, system-ui, sans-serif"),
                anchor: anchor,
                dominantBaseline: verticalAlign === "middle" ? "middle" : "auto",
                opacity: common.opacity,
                transform: transform
            });
        }
    }
    section.append(svg);
    panel.append(section);
}
function $08414ea58bdc1292$var$renderExcalidrawImage(svg, element, files, x, y, width, height, common, transform) {
    const fileId = String(element.fileId || "");
    const file = fileId ? files[fileId] : void 0;
    const dataUrl = file?.dataURL || "";
    if ($08414ea58bdc1292$var$isSafeExcalidrawImageDataUrl(dataUrl)) {
        const image = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "image");
        $08414ea58bdc1292$var$applySvgAttrs(image, {
            x: x,
            y: y,
            width: width,
            height: height,
            href: dataUrl,
            preserveAspectRatio: "xMidYMid meet",
            opacity: common.opacity,
            transform: transform
        });
        svg.append(image);
        return;
    }
    const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
    $08414ea58bdc1292$var$applySvgAttrs(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        rx: 8,
        fill: "#f8fafc",
        stroke: "#94a3b8",
        "stroke-width": 1.5,
        "stroke-dasharray": "6 4",
        opacity: common.opacity,
        transform: transform
    });
    svg.append(rect);
    $08414ea58bdc1292$var$appendSvgMultilineText(svg, fileId ? `Image
${fileId}` : "Image", x + width / 2, y + height / 2 - 8, "#64748b", {
        fontSize: 13,
        anchor: "middle",
        transform: transform
    });
}
function $08414ea58bdc1292$var$renderExcalidrawEmbeddable(svg, element, x, y, width, height, common, transform) {
    const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
    $08414ea58bdc1292$var$applySvgAttrs(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        rx: 10,
        fill: "#eef2ff",
        stroke: "#6366f1",
        "stroke-width": 1.5,
        "stroke-dasharray": "8 5",
        opacity: common.opacity,
        transform: transform
    });
    svg.append(rect);
    const link = String(element.link || element.url || "Embedded content");
    $08414ea58bdc1292$var$appendSvgMultilineText(svg, `Embed
${$08414ea58bdc1292$var$shortenText(link, 48)}`, x + width / 2, y + height / 2 - 10, "#4338ca", {
        fontSize: 13,
        anchor: "middle",
        transform: transform
    });
}
function $08414ea58bdc1292$var$appendSvgMultilineText(svg, text, x, y, fill, options = {}) {
    const textNode = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "text");
    $08414ea58bdc1292$var$applySvgAttrs(textNode, {
        x: x,
        y: y,
        fill: fill,
        "font-size": options.fontSize || 18,
        "font-family": options.fontFamily || "Inter, ui-sans-serif, system-ui, sans-serif",
        "text-anchor": options.anchor,
        "dominant-baseline": options.dominantBaseline,
        opacity: options.opacity,
        transform: options.transform
    });
    for (const [index, line] of text.split(/\r?\n/).entries()){
        const span = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "tspan");
        span.setAttribute("x", String(x));
        span.setAttribute("dy", index === 0 ? "0" : "1.25em");
        span.textContent = line;
        textNode.append(span);
    }
    svg.append(textNode);
    return textNode;
}
function $08414ea58bdc1292$var$isSafeExcalidrawImageDataUrl(value) {
    return /^data:image\/(?:png|jpe?g|gif|webp|bmp);base64,/i.test(value);
}
function $08414ea58bdc1292$var$shortenText(value, maxLength) {
    return value.length > maxLength ? `${value.slice(0, Math.max(0, maxLength - 3))}...` : value;
}
function $08414ea58bdc1292$var$createExcalidrawViewBox(elements) {
    if (elements.length === 0) return "0 0 1200 800";
    const bounds = elements.map((element)=>{
        const x = $08414ea58bdc1292$var$finiteNumber3(element.x, 0);
        const y = $08414ea58bdc1292$var$finiteNumber3(element.y, 0);
        const points = Array.isArray(element.points) ? element.points.map((point)=>$08414ea58bdc1292$var$pointFromValue(point, {
                x: 0,
                y: 0
            })) : [];
        const width = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(element.width, Math.max(80, ...points.map((point)=>point.x))));
        const height = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(element.height, Math.max(40, ...points.map((point)=>point.y))));
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    });
    const minX = Math.min(...bounds.map((bound)=>bound.x)) - 40;
    const minY = Math.min(...bounds.map((bound)=>bound.y)) - 40;
    const maxX = Math.max(...bounds.map((bound)=>bound.x + bound.width)) + 40;
    const maxY = Math.max(...bounds.map((bound)=>bound.y + bound.height)) + 40;
    return `${minX} ${minY} ${Math.max(320, maxX - minX)} ${Math.max(240, maxY - minY)}`;
}
function $08414ea58bdc1292$var$getExcalidrawCommonAttrs(element) {
    const strokeWidth = $08414ea58bdc1292$var$finiteNumber3(element.strokeWidth, 1.5);
    const opacity = Math.max(0, Math.min(1, $08414ea58bdc1292$var$finiteNumber3(element.opacity, 100) / 100));
    const style = String(element.strokeStyle || "solid");
    return {
        "stroke-width": strokeWidth,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-dasharray": style === "dashed" ? `${strokeWidth * 6} ${strokeWidth * 4}` : style === "dotted" ? `${strokeWidth} ${strokeWidth * 4}` : "",
        opacity: opacity
    };
}
function $08414ea58bdc1292$var$excalidrawFill(svg, defs, element, stroke) {
    const value = String(element.backgroundColor || "transparent");
    if (!value || value === "transparent") return "transparent";
    const fillStyle = String(element.fillStyle || "solid");
    if (fillStyle === "solid") return value;
    const id = `ofv-excalidraw-${fillStyle}-${defs.children.length}`;
    const pattern = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "pattern");
    $08414ea58bdc1292$var$applySvgAttrs(pattern, {
        id: id,
        width: 10,
        height: 10,
        patternUnits: "userSpaceOnUse"
    });
    const background = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
    $08414ea58bdc1292$var$applySvgAttrs(background, {
        width: 10,
        height: 10,
        fill: value,
        opacity: 0.35
    });
    pattern.append(background);
    if (fillStyle === "cross-hatch") {
        pattern.append($08414ea58bdc1292$var$createPatternLine(svg, "M 0 10 L 10 0", stroke));
        pattern.append($08414ea58bdc1292$var$createPatternLine(svg, "M 0 0 L 10 10", stroke));
    } else if (fillStyle === "dots") {
        const dot = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "circle");
        $08414ea58bdc1292$var$applySvgAttrs(dot, {
            cx: 5,
            cy: 5,
            r: 1.2,
            fill: stroke,
            opacity: 0.48
        });
        pattern.append(dot);
    } else pattern.append($08414ea58bdc1292$var$createPatternLine(svg, "M 0 10 L 10 0", stroke));
    defs.append(pattern);
    return `url(#${id})`;
}
function $08414ea58bdc1292$var$createPatternLine(svg, d, stroke) {
    const path = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "path");
    $08414ea58bdc1292$var$applySvgAttrs(path, {
        d: d,
        stroke: stroke,
        "stroke-width": 1,
        "stroke-linecap": "round",
        opacity: 0.42
    });
    return path;
}
function $08414ea58bdc1292$var$excalidrawTransform(element, x, y, width, height) {
    const angle = $08414ea58bdc1292$var$finiteNumber3(element.angle, 0);
    if (!angle) return "";
    return `rotate(${angle * 180 / Math.PI} ${x + width / 2} ${y + height / 2})`;
}
function $08414ea58bdc1292$var$excalidrawPoints(element, x, y, width, height) {
    if (!Array.isArray(element.points)) return [
        {
            x: x,
            y: y
        },
        {
            x: x + width,
            y: y + height
        }
    ];
    return element.points.map((point)=>{
        const parsed = $08414ea58bdc1292$var$pointFromValue(point, {
            x: 0,
            y: 0
        });
        return {
            x: x + parsed.x,
            y: y + parsed.y
        };
    });
}
function $08414ea58bdc1292$var$createExcalidrawFreedrawPath(element, x, y) {
    const points = $08414ea58bdc1292$var$excalidrawPoints(element, x, y, 0, 0);
    if (points.length < 2) return null;
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", points.map((point, index)=>`${index === 0 ? "M" : "L"} ${point.x} ${point.y}`).join(" "));
    return path;
}
function $08414ea58bdc1292$var$appendExcalidrawArrowHeads(svg, element, points, stroke) {
    if (String(element.type || "") !== "arrow" || points.length < 2) return;
    const startHead = String(element.startArrowhead || "");
    const endHead = String(element.endArrowhead || "arrow");
    if (startHead && startHead !== "none") $08414ea58bdc1292$var$appendArrowHead(svg, points[1].x, points[1].y, points[0].x, points[0].y, stroke, startHead);
    if (endHead && endHead !== "none") {
        const previous = points[points.length - 2];
        const end = points[points.length - 1];
        $08414ea58bdc1292$var$appendArrowHead(svg, previous.x, previous.y, end.x, end.y, stroke, endHead);
    }
}
function $08414ea58bdc1292$var$applySvgAttrs(element, attributes) {
    for (const [key, value] of Object.entries(attributes)){
        if (value === void 0 || value === "") continue;
        element.setAttribute(key, String(value));
    }
}
function $08414ea58bdc1292$var$renderTldraw(panel, text) {
    const data = JSON.parse(text);
    const shapes = $08414ea58bdc1292$var$extractTldrawShapes(data);
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`tldraw \u57FA\u7840\u9884\u89C8 ${shapes.length} shapes`);
    if (shapes.length > 0) $08414ea58bdc1292$var$hideSuccessfulSectionHeading2(section);
    section.append($08414ea58bdc1292$var$createDrawingSummary(shapes.map($08414ea58bdc1292$var$tldrawSummaryItem)));
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "ofv-svg-stage");
    svg.setAttribute("viewBox", $08414ea58bdc1292$var$createTldrawViewBox(shapes));
    if (shapes.length === 0) {
        const empty = document.createElementNS(svg.namespaceURI, "text");
        empty.setAttribute("x", "24");
        empty.setAttribute("y", "40");
        empty.setAttribute("fill", "#64748b");
        empty.textContent = "\u672A\u89E3\u6790\u5230\u53EF\u5C55\u793A\u7684 tldraw \u56FE\u5F62\u3002";
        svg.append(empty);
    } else for (const shape of shapes)$08414ea58bdc1292$var$renderTldrawShape(svg, shape);
    section.append(svg);
    panel.append(section);
}
function $08414ea58bdc1292$var$extractTldrawShapes(data) {
    if (!data || typeof data !== "object") return [];
    const source = data;
    const candidates = [];
    if (Array.isArray(source.records)) candidates.push(...source.records);
    if (Array.isArray(source.shapes)) candidates.push(...source.shapes);
    if (source.store && typeof source.store === "object") candidates.push(...Object.values(source.store));
    if (source.document && typeof source.document === "object") {
        const documentRecord = source.document;
        if (Array.isArray(documentRecord.shapes)) candidates.push(...documentRecord.shapes);
    }
    return candidates.filter((item)=>{
        if (!item || typeof item !== "object") return false;
        const record = item;
        return record.typeName === "shape" || String(record.id || "").startsWith("shape:");
    });
}
function $08414ea58bdc1292$var$renderTldrawShape(svg, shape) {
    const props = shape.props || {};
    const type = String(shape.type || props.type || "");
    const x = $08414ea58bdc1292$var$finiteNumber3(shape.x, 0);
    const y = $08414ea58bdc1292$var$finiteNumber3(shape.y, 0);
    const width = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(props.w, $08414ea58bdc1292$var$finiteNumber3(props.width, 120)));
    const height = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(props.h, $08414ea58bdc1292$var$finiteNumber3(props.height, 80)));
    const stroke = $08414ea58bdc1292$var$tldrawColor(String(props.color || shape.color || "black"));
    const fill = $08414ea58bdc1292$var$tldrawFill(String(props.fill || "none"), stroke);
    if (type === "geo" || type === "frame" || type === "highlight") {
        const geo = String(props.geo || (type === "frame" ? "rectangle" : "rectangle"));
        if (geo === "ellipse" || geo === "oval") {
            const ellipse = document.createElementNS(svg.namespaceURI, "ellipse");
            ellipse.setAttribute("cx", String(x + width / 2));
            ellipse.setAttribute("cy", String(y + height / 2));
            ellipse.setAttribute("rx", String(width / 2));
            ellipse.setAttribute("ry", String(height / 2));
            ellipse.setAttribute("fill", fill);
            ellipse.setAttribute("stroke", stroke);
            ellipse.setAttribute("stroke-width", "2");
            svg.append(ellipse);
        } else if (geo === "diamond") {
            const polygon = document.createElementNS(svg.namespaceURI, "polygon");
            polygon.setAttribute("points", `${x + width / 2},${y} ${x + width},${y + height / 2} ${x + width / 2},${y + height} ${x},${y + height / 2}`);
            polygon.setAttribute("fill", fill);
            polygon.setAttribute("stroke", stroke);
            polygon.setAttribute("stroke-width", "2");
            svg.append(polygon);
        } else if (geo === "triangle") {
            const polygon = document.createElementNS(svg.namespaceURI, "polygon");
            polygon.setAttribute("points", `${x + width / 2},${y} ${x + width},${y + height} ${x},${y + height}`);
            polygon.setAttribute("fill", fill);
            polygon.setAttribute("stroke", stroke);
            polygon.setAttribute("stroke-width", "2");
            svg.append(polygon);
        } else {
            const rect = document.createElementNS(svg.namespaceURI, "rect");
            rect.setAttribute("x", String(x));
            rect.setAttribute("y", String(y));
            rect.setAttribute("width", String(width));
            rect.setAttribute("height", String(height));
            rect.setAttribute("rx", type === "frame" ? "0" : "8");
            rect.setAttribute("fill", fill);
            rect.setAttribute("stroke", stroke);
            rect.setAttribute("stroke-width", "2");
            svg.append(rect);
        }
        $08414ea58bdc1292$var$appendTldrawText(svg, String(props.text || ""), x + 12, y + 24, stroke);
    } else if (type === "text" || type === "note") {
        if (type === "note") {
            const note = document.createElementNS(svg.namespaceURI, "rect");
            note.setAttribute("x", String(x));
            note.setAttribute("y", String(y));
            note.setAttribute("width", String(width));
            note.setAttribute("height", String(height));
            note.setAttribute("rx", "6");
            note.setAttribute("fill", $08414ea58bdc1292$var$tldrawColor(String(props.color || "yellow"), 0.24));
            note.setAttribute("stroke", stroke);
            svg.append(note);
        }
        $08414ea58bdc1292$var$appendTldrawText(svg, String(props.text || ""), x, y + 18, stroke);
    } else if (type === "arrow" || type === "line") $08414ea58bdc1292$var$renderTldrawLine(svg, shape, stroke);
    else if (type === "draw") $08414ea58bdc1292$var$renderTldrawDraw(svg, shape, stroke);
    else {
        const rect = document.createElementNS(svg.namespaceURI, "rect");
        rect.setAttribute("x", String(x));
        rect.setAttribute("y", String(y));
        rect.setAttribute("width", String(width));
        rect.setAttribute("height", String(height));
        rect.setAttribute("fill", "transparent");
        rect.setAttribute("stroke", stroke);
        rect.setAttribute("stroke-dasharray", "6 4");
        svg.append(rect);
        $08414ea58bdc1292$var$appendTldrawText(svg, type || "shape", x + 8, y + 20, stroke);
    }
}
function $08414ea58bdc1292$var$renderTldrawLine(svg, shape, stroke) {
    const props = shape.props || {};
    const x = $08414ea58bdc1292$var$finiteNumber3(shape.x, 0);
    const y = $08414ea58bdc1292$var$finiteNumber3(shape.y, 0);
    const start = $08414ea58bdc1292$var$pointFromValue(props.start, {
        x: 0,
        y: 0
    });
    const end = $08414ea58bdc1292$var$pointFromValue(props.end, {
        x: $08414ea58bdc1292$var$finiteNumber3(props.w, $08414ea58bdc1292$var$finiteNumber3(props.width, 120)),
        y: $08414ea58bdc1292$var$finiteNumber3(props.h, $08414ea58bdc1292$var$finiteNumber3(props.height, 0))
    });
    const line = document.createElementNS(svg.namespaceURI, "line");
    line.setAttribute("x1", String(x + start.x));
    line.setAttribute("y1", String(y + start.y));
    line.setAttribute("x2", String(x + end.x));
    line.setAttribute("y2", String(y + end.y));
    line.setAttribute("stroke", stroke);
    line.setAttribute("stroke-width", "3");
    line.setAttribute("stroke-linecap", "round");
    svg.append(line);
    if (String(shape.type || "") === "arrow") $08414ea58bdc1292$var$appendArrowHead(svg, x + start.x, y + start.y, x + end.x, y + end.y, stroke);
}
function $08414ea58bdc1292$var$renderTldrawDraw(svg, shape, stroke) {
    const props = shape.props || {};
    const x = $08414ea58bdc1292$var$finiteNumber3(shape.x, 0);
    const y = $08414ea58bdc1292$var$finiteNumber3(shape.y, 0);
    const points = $08414ea58bdc1292$var$extractTldrawDrawPoints(props.segments);
    if (points.length < 2) return;
    const polyline = document.createElementNS(svg.namespaceURI, "polyline");
    polyline.setAttribute("points", points.map((point)=>`${x + point.x},${y + point.y}`).join(" "));
    polyline.setAttribute("fill", "none");
    polyline.setAttribute("stroke", stroke);
    polyline.setAttribute("stroke-width", "3");
    polyline.setAttribute("stroke-linecap", "round");
    polyline.setAttribute("stroke-linejoin", "round");
    svg.append(polyline);
}
function $08414ea58bdc1292$var$appendTldrawText(svg, text, x, y, fill) {
    if (!text.trim()) return;
    const textNode = document.createElementNS(svg.namespaceURI, "text");
    textNode.setAttribute("x", String(x));
    textNode.setAttribute("y", String(y));
    textNode.setAttribute("fill", fill);
    textNode.setAttribute("font-size", "16");
    textNode.setAttribute("font-family", "Inter, ui-sans-serif, system-ui, sans-serif");
    for (const [index, line] of text.split(/\r?\n/).entries()){
        const span = document.createElementNS(svg.namespaceURI, "tspan");
        span.setAttribute("x", String(x));
        span.setAttribute("dy", index === 0 ? "0" : "1.3em");
        span.textContent = line;
        textNode.append(span);
    }
    svg.append(textNode);
}
function $08414ea58bdc1292$var$appendArrowHead(svg, x1, y1, x2, y2, fill, type = "arrow") {
    const angle = Math.atan2(y2 - y1, x2 - x1);
    const size = 10;
    if (type === "bar") {
        const line = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "line");
        const dx = Math.sin(angle) * size * 0.65;
        const dy = Math.cos(angle) * size * 0.65;
        $08414ea58bdc1292$var$applySvgAttrs(line, {
            x1: x2 - dx,
            y1: y2 + dy,
            x2: x2 + dx,
            y2: y2 - dy,
            stroke: fill,
            "stroke-width": 2,
            "stroke-linecap": "round"
        });
        svg.append(line);
        return;
    }
    if (type === "dot" || type === "circle") {
        const circle = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "circle");
        $08414ea58bdc1292$var$applySvgAttrs(circle, {
            cx: x2,
            cy: y2,
            r: size * 0.42,
            fill: fill
        });
        svg.append(circle);
        return;
    }
    const points = [
        [
            x2,
            y2
        ],
        [
            x2 - size * Math.cos(angle - Math.PI / 6),
            y2 - size * Math.sin(angle - Math.PI / 6)
        ],
        [
            x2 - size * Math.cos(angle + Math.PI / 6),
            y2 - size * Math.sin(angle + Math.PI / 6)
        ]
    ];
    const polygon = document.createElementNS(svg.namespaceURI, "polygon");
    polygon.setAttribute("points", points.map((point)=>point.join(",")).join(" "));
    polygon.setAttribute("fill", type === "triangle_outline" || type === "arrow_outline" ? "transparent" : fill);
    polygon.setAttribute("stroke", fill);
    svg.append(polygon);
}
function $08414ea58bdc1292$var$createTldrawViewBox(shapes) {
    if (shapes.length === 0) return "0 0 800 500";
    const bounds = shapes.map((shape)=>{
        const props = shape.props || {};
        const x = $08414ea58bdc1292$var$finiteNumber3(shape.x, 0);
        const y = $08414ea58bdc1292$var$finiteNumber3(shape.y, 0);
        const width = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(props.w, $08414ea58bdc1292$var$finiteNumber3(props.width, 120)));
        const height = Math.max(1, $08414ea58bdc1292$var$finiteNumber3(props.h, $08414ea58bdc1292$var$finiteNumber3(props.height, 80)));
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    });
    const minX = Math.min(...bounds.map((bound)=>bound.x)) - 40;
    const minY = Math.min(...bounds.map((bound)=>bound.y)) - 40;
    const maxX = Math.max(...bounds.map((bound)=>bound.x + bound.width)) + 40;
    const maxY = Math.max(...bounds.map((bound)=>bound.y + bound.height)) + 40;
    return `${minX} ${minY} ${Math.max(240, maxX - minX)} ${Math.max(180, maxY - minY)}`;
}
function $08414ea58bdc1292$var$extractTldrawDrawPoints(value) {
    if (!Array.isArray(value)) return [];
    return value.flatMap((segment)=>{
        if (!segment || typeof segment !== "object") return [];
        const points = segment.points;
        if (!Array.isArray(points)) return [];
        return points.map((point)=>$08414ea58bdc1292$var$pointFromValue(point, {
                x: 0,
                y: 0
            }));
    });
}
function $08414ea58bdc1292$var$pointFromValue(value, fallback) {
    if (Array.isArray(value)) return {
        x: $08414ea58bdc1292$var$finiteNumber3(value[0], fallback.x),
        y: $08414ea58bdc1292$var$finiteNumber3(value[1], fallback.y)
    };
    if (!value || typeof value !== "object") return fallback;
    const point = value;
    return {
        x: $08414ea58bdc1292$var$finiteNumber3(point.x, fallback.x),
        y: $08414ea58bdc1292$var$finiteNumber3(point.y, fallback.y)
    };
}
function $08414ea58bdc1292$var$finiteNumber3(value, fallback) {
    const parsed = typeof value === "number" ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}
function $08414ea58bdc1292$var$tldrawFill(fill, stroke) {
    return fill === "solid" || fill === "semi" || fill === "pattern" ? $08414ea58bdc1292$var$tldrawColor(stroke, 0.14) : "transparent";
}
function $08414ea58bdc1292$var$tldrawColor(value, alpha = 1) {
    const colors = {
        black: [
            17,
            24,
            39
        ],
        grey: [
            100,
            116,
            139
        ],
        light: [
            203,
            213,
            225
        ],
        red: [
            220,
            38,
            38
        ],
        orange: [
            234,
            88,
            12
        ],
        yellow: [
            202,
            138,
            4
        ],
        green: [
            22,
            163,
            74
        ],
        blue: [
            37,
            99,
            235
        ],
        violet: [
            124,
            58,
            237
        ],
        purple: [
            147,
            51,
            234
        ],
        pink: [
            219,
            39,
            119
        ]
    };
    if (value.startsWith("#") || value.startsWith("rgb")) return value;
    const color = colors[value] || colors.black;
    return alpha >= 1 ? `rgb(${color.join(" ")})` : `rgb(${color.join(" ")} / ${alpha})`;
}
function $08414ea58bdc1292$var$renderDrawio(panel, text) {
    const diagrams = $08414ea58bdc1292$var$extractDrawioDiagrams(text);
    if (diagrams.length === 0) {
        $08414ea58bdc1292$var$renderRawDrawing(panel, "Draw.io", text);
        return;
    }
    for (const [index, diagram] of diagrams.entries()){
        const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`Draw.io \u56FE\u5F62\u9884\u89C8 ${index + 1}`);
        const shapes = $08414ea58bdc1292$var$parseDrawioShapes(diagram);
        if (shapes.length > 0) {
            $08414ea58bdc1292$var$hideSuccessfulSectionHeading2(section);
            section.append($08414ea58bdc1292$var$createDrawingSummary(shapes.map($08414ea58bdc1292$var$drawioSummaryItem)));
            const svg = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "svg");
            svg.setAttribute("class", "ofv-svg-stage");
            svg.setAttribute("viewBox", $08414ea58bdc1292$var$createDrawioViewBox(shapes));
            for (const shape of shapes)$08414ea58bdc1292$var$renderDrawioShape(svg, shape);
            section.append(svg);
        }
        const details = document.createElement("details");
        details.className = "ofv-details";
        const summary = document.createElement("summary");
        summary.textContent = shapes.length > 0 ? `\u539F\u59CB XML \u6458\u8981\uFF08${shapes.length} cells\uFF09` : "Draw.io \u539F\u59CB\u5185\u5BB9";
        const pre = document.createElement("pre");
        pre.className = "ofv-text-block";
        pre.textContent = diagram.slice(0, 3e4);
        details.append(summary, pre);
        if (shapes.length > 0) {
            details.hidden = true;
            details.setAttribute("aria-hidden", "true");
            details.style.display = "none";
        }
        section.append(details);
        panel.append(section);
    }
}
function $08414ea58bdc1292$var$extractDrawioDiagrams(text) {
    const matches = [
        ...text.matchAll(/<diagram[^>]*>([\s\S]*?)<\/diagram>/g)
    ].map((match)=>$08414ea58bdc1292$var$decodeDrawioDiagram(match[1] || ""));
    if (matches.length > 0) return matches;
    return text.includes("<mxGraphModel") ? [
        text
    ] : [];
}
function $08414ea58bdc1292$var$parseDrawioShapes(xml) {
    const doc = new DOMParser().parseFromString(xml, "application/xml");
    if (doc.querySelector("parsererror")) return [];
    return Array.from(doc.querySelectorAll("mxCell")).flatMap((cell)=>{
        const geometry = Array.from(cell.children).find((child)=>child.localName === "mxGeometry");
        const vertex = cell.getAttribute("vertex") === "1";
        const edge = cell.getAttribute("edge") === "1";
        if (!vertex && !edge) return [];
        const shape = {
            id: cell.getAttribute("id") || "",
            value: $08414ea58bdc1292$var$decodeXmlText(cell.getAttribute("value") || ""),
            style: $08414ea58bdc1292$var$parseDrawioStyle(cell.getAttribute("style") || ""),
            vertex: vertex,
            edge: edge,
            x: $08414ea58bdc1292$var$finiteNumber3(geometry?.getAttribute("x"), 0),
            y: $08414ea58bdc1292$var$finiteNumber3(geometry?.getAttribute("y"), 0),
            width: Math.max(1, $08414ea58bdc1292$var$finiteNumber3(geometry?.getAttribute("width"), 120)),
            height: Math.max(1, $08414ea58bdc1292$var$finiteNumber3(geometry?.getAttribute("height"), edge ? 1 : 60)),
            source: cell.getAttribute("source") || void 0,
            target: cell.getAttribute("target") || void 0
        };
        if (edge && geometry) {
            const points = Array.from(geometry.children).filter((child)=>child.localName === "mxPoint").map((point)=>({
                    x: $08414ea58bdc1292$var$finiteNumber3(point.getAttribute("x"), 0),
                    y: $08414ea58bdc1292$var$finiteNumber3(point.getAttribute("y"), 0)
                }));
            if (points.length >= 2) {
                shape.x = points[0].x;
                shape.y = points[0].y;
                shape.width = points[points.length - 1].x - points[0].x;
                shape.height = points[points.length - 1].y - points[0].y;
                shape.points = points;
            }
        }
        return [
            shape
        ];
    });
}
function $08414ea58bdc1292$var$parseDrawioStyle(style) {
    const result = {};
    const imageMatch = style.match(/(?:^|;)image=(data:image\/[^;]+;base64,[^;]+)/i);
    const protectedStyle = imageMatch ? style.replace(imageMatch[0], imageMatch[0].startsWith(";") ? ";image=__OFV_IMAGE__" : "image=__OFV_IMAGE__") : style;
    for (const part of protectedStyle.split(";")){
        if (!part) continue;
        const separator = part.indexOf("=");
        const key = separator >= 0 ? part.slice(0, separator) : part;
        const value = separator >= 0 ? part.slice(separator + 1) : "1";
        if (key) result[key] = value === "__OFV_IMAGE__" && imageMatch ? imageMatch[1] : value;
    }
    return result;
}
function $08414ea58bdc1292$var$createDrawioViewBox(shapes) {
    const bounds = shapes.map((shape)=>({
            x: Math.min(shape.x, shape.x + shape.width),
            y: Math.min(shape.y, shape.y + shape.height),
            width: Math.abs(shape.width),
            height: Math.abs(shape.height)
        }));
    const minX = Math.min(...bounds.map((bound)=>bound.x)) - 40;
    const minY = Math.min(...bounds.map((bound)=>bound.y)) - 40;
    const maxX = Math.max(...bounds.map((bound)=>bound.x + bound.width)) + 40;
    const maxY = Math.max(...bounds.map((bound)=>bound.y + bound.height)) + 40;
    return `${minX} ${minY} ${Math.max(320, maxX - minX)} ${Math.max(240, maxY - minY)}`;
}
function $08414ea58bdc1292$var$renderDrawioShape(svg, shape) {
    const stroke = $08414ea58bdc1292$var$drawioColor(shape.style.strokeColor, "#334155");
    const fill = shape.style.fillColor === "none" ? "transparent" : $08414ea58bdc1292$var$drawioColor(shape.style.fillColor, "#f8fafc");
    const strokeWidth = $08414ea58bdc1292$var$finiteNumber3(shape.style.strokeWidth, 1.5);
    const opacity = Math.max(0, Math.min(1, $08414ea58bdc1292$var$finiteNumber3(shape.style.opacity, 100) / 100));
    const strokeAttrs = $08414ea58bdc1292$var$drawioStrokeAttrs(shape.style, strokeWidth);
    const transform = $08414ea58bdc1292$var$drawioTransform(shape);
    if (shape.edge) {
        const points = shape.points || [
            {
                x: shape.x,
                y: shape.y
            },
            {
                x: shape.x + shape.width,
                y: shape.y + shape.height
            }
        ];
        if (points.length > 2) {
            const polyline = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polyline");
            $08414ea58bdc1292$var$applySvgAttrs(polyline, {
                points: points.map((point)=>`${point.x},${point.y}`).join(" "),
                fill: "none",
                stroke: stroke,
                ...strokeAttrs,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                opacity: opacity
            });
            svg.append(polyline);
        } else {
            const line = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "line");
            $08414ea58bdc1292$var$applySvgAttrs(line, {
                x1: points[0].x,
                y1: points[0].y,
                x2: points[1].x,
                y2: points[1].y,
                stroke: stroke,
                ...strokeAttrs,
                "stroke-linecap": "round",
                opacity: opacity
            });
            svg.append(line);
        }
        if (shape.style.endArrow && shape.style.endArrow !== "none") {
            const tail = points[Math.max(0, points.length - 2)];
            const head = points[points.length - 1];
            $08414ea58bdc1292$var$appendArrowHead(svg, tail.x, tail.y, head.x, head.y, stroke);
        }
        return;
    }
    const shapeName = $08414ea58bdc1292$var$drawioShapeName(shape.style);
    if (shapeName === "image") $08414ea58bdc1292$var$renderDrawioImage(svg, shape, opacity, transform);
    else if (shapeName === "ellipse") {
        const ellipse = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "ellipse");
        $08414ea58bdc1292$var$applySvgAttrs(ellipse, {
            cx: shape.x + shape.width / 2,
            cy: shape.y + shape.height / 2,
            rx: shape.width / 2,
            ry: shape.height / 2,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(ellipse);
    } else if (shapeName === "rhombus" || shapeName === "diamond") {
        const polygon = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polygon");
        $08414ea58bdc1292$var$applySvgAttrs(polygon, {
            points: `${shape.x + shape.width / 2},${shape.y} ${shape.x + shape.width},${shape.y + shape.height / 2} ${shape.x + shape.width / 2},${shape.y + shape.height} ${shape.x},${shape.y + shape.height / 2}`,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(polygon);
    } else if (shapeName === "hexagon" || shapeName === "process") {
        const polygon = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polygon");
        const inset = shapeName === "process" ? shape.width * 0.12 : shape.width * 0.22;
        $08414ea58bdc1292$var$applySvgAttrs(polygon, {
            points: shapeName === "process" ? `${shape.x},${shape.y} ${shape.x + shape.width - inset},${shape.y} ${shape.x + shape.width},${shape.y + shape.height / 2} ${shape.x + shape.width - inset},${shape.y + shape.height} ${shape.x},${shape.y + shape.height}` : `${shape.x + inset},${shape.y} ${shape.x + shape.width - inset},${shape.y} ${shape.x + shape.width},${shape.y + shape.height / 2} ${shape.x + shape.width - inset},${shape.y + shape.height} ${shape.x + inset},${shape.y + shape.height} ${shape.x},${shape.y + shape.height / 2}`,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(polygon);
    } else if (shapeName === "triangle") {
        const polygon = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "polygon");
        $08414ea58bdc1292$var$applySvgAttrs(polygon, {
            points: `${shape.x + shape.width / 2},${shape.y} ${shape.x + shape.width},${shape.y + shape.height} ${shape.x},${shape.y + shape.height}`,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(polygon);
    } else if (shapeName === "actor" || shapeName === "umlActor") $08414ea58bdc1292$var$renderDrawioActor(svg, shape, stroke, strokeAttrs, opacity, transform);
    else if (shapeName === "document") {
        const path = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "path");
        $08414ea58bdc1292$var$applySvgAttrs(path, {
            d: $08414ea58bdc1292$var$createDrawioDocumentPath(shape.x, shape.y, shape.width, shape.height),
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(path);
    } else if (shapeName === "cylinder") {
        const group = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "g");
        $08414ea58bdc1292$var$applySvgAttrs(group, {
            transform: transform
        });
        const body = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
        $08414ea58bdc1292$var$applySvgAttrs(body, {
            x: shape.x,
            y: shape.y + Math.min(18, shape.height * 0.18) / 2,
            width: shape.width,
            height: shape.height - Math.min(18, shape.height * 0.18),
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity
        });
        const top = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "ellipse");
        const bottom = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "ellipse");
        const capHeight = Math.min(18, shape.height * 0.18);
        $08414ea58bdc1292$var$applySvgAttrs(top, {
            cx: shape.x + shape.width / 2,
            cy: shape.y + capHeight / 2,
            rx: shape.width / 2,
            ry: capHeight / 2,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity
        });
        $08414ea58bdc1292$var$applySvgAttrs(bottom, {
            cx: shape.x + shape.width / 2,
            cy: shape.y + shape.height - capHeight / 2,
            rx: shape.width / 2,
            ry: capHeight / 2,
            fill: "none",
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity
        });
        group.append(body, top, bottom);
        svg.append(group);
    } else if (shapeName === "cloud") {
        const path = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "path");
        $08414ea58bdc1292$var$applySvgAttrs(path, {
            d: $08414ea58bdc1292$var$createDrawioCloudPath(shape.x, shape.y, shape.width, shape.height),
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(path);
    } else if (shapeName === "swimlane") {
        const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
        $08414ea58bdc1292$var$applySvgAttrs(rect, {
            x: shape.x,
            y: shape.y,
            width: shape.width,
            height: shape.height,
            rx: shape.style.rounded === "1" ? Math.min(12, shape.height / 5) : 0,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        const header = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
        const headerHeight = Math.min(shape.height, $08414ea58bdc1292$var$finiteNumber3(shape.style.startSize, 30));
        $08414ea58bdc1292$var$applySvgAttrs(header, {
            x: shape.x,
            y: shape.y,
            width: shape.width,
            height: headerHeight,
            rx: shape.style.rounded === "1" ? Math.min(12, headerHeight / 3) : 0,
            fill: $08414ea58bdc1292$var$drawioColor(shape.style.swimlaneFillColor || shape.style.fillColor, "#e2e8f0"),
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(rect, header);
    } else {
        const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
        $08414ea58bdc1292$var$applySvgAttrs(rect, {
            x: shape.x,
            y: shape.y,
            width: shape.width,
            height: shape.height,
            rx: shape.style.rounded === "1" ? Math.min(12, shape.height / 5) : 0,
            fill: fill,
            stroke: stroke,
            ...strokeAttrs,
            opacity: opacity,
            transform: transform
        });
        svg.append(rect);
    }
    $08414ea58bdc1292$var$appendDrawioText(svg, shape.value, shape.x + shape.width / 2, shape.y + shape.height / 2, $08414ea58bdc1292$var$drawioColor(shape.style.fontColor, "#111827"), shape.style, transform);
}
function $08414ea58bdc1292$var$drawioShapeName(style) {
    if (style.shape) return style.shape;
    if (style.image) return "image";
    if (style.ellipse === "1") return "ellipse";
    if (style.rhombus === "1") return "rhombus";
    if (style.swimlane === "1") return "swimlane";
    if (style.text === "1") return "text";
    return "rectangle";
}
function $08414ea58bdc1292$var$renderDrawioImage(svg, shape, opacity, transform) {
    const src = shape.style.image || "";
    if (/^data:image\/(?:png|jpe?g|gif|webp|svg\+xml);base64,/i.test(src)) {
        const image = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "image");
        $08414ea58bdc1292$var$applySvgAttrs(image, {
            x: shape.x,
            y: shape.y,
            width: shape.width,
            height: shape.height,
            href: src,
            preserveAspectRatio: "xMidYMid meet",
            opacity: opacity,
            transform: transform
        });
        svg.append(image);
        return;
    }
    const rect = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "rect");
    $08414ea58bdc1292$var$applySvgAttrs(rect, {
        x: shape.x,
        y: shape.y,
        width: shape.width,
        height: shape.height,
        rx: 6,
        fill: "#f8fafc",
        stroke: "#94a3b8",
        "stroke-dasharray": "6 4",
        opacity: opacity,
        transform: transform
    });
    svg.append(rect);
}
function $08414ea58bdc1292$var$renderDrawioActor(svg, shape, stroke, strokeAttrs, opacity, transform) {
    const group = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "g");
    $08414ea58bdc1292$var$applySvgAttrs(group, {
        opacity: opacity,
        transform: transform
    });
    const cx = shape.x + shape.width / 2;
    const headRadius = Math.min(shape.width, shape.height) * 0.15;
    const head = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "circle");
    $08414ea58bdc1292$var$applySvgAttrs(head, {
        cx: cx,
        cy: shape.y + headRadius * 1.4,
        r: headRadius,
        fill: "transparent",
        stroke: stroke,
        ...strokeAttrs
    });
    const body = $08414ea58bdc1292$var$createSvgLine(cx, shape.y + headRadius * 2.4, cx, shape.y + shape.height * 0.68, stroke, strokeAttrs);
    const arms = $08414ea58bdc1292$var$createSvgLine(shape.x + shape.width * 0.22, shape.y + shape.height * 0.42, shape.x + shape.width * 0.78, shape.y + shape.height * 0.42, stroke, strokeAttrs);
    const leftLeg = $08414ea58bdc1292$var$createSvgLine(cx, shape.y + shape.height * 0.68, shape.x + shape.width * 0.25, shape.y + shape.height, stroke, strokeAttrs);
    const rightLeg = $08414ea58bdc1292$var$createSvgLine(cx, shape.y + shape.height * 0.68, shape.x + shape.width * 0.75, shape.y + shape.height, stroke, strokeAttrs);
    group.append(head, body, arms, leftLeg, rightLeg);
    svg.append(group);
}
function $08414ea58bdc1292$var$createSvgLine(x1, y1, x2, y2, stroke, strokeAttrs) {
    const line = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "line");
    $08414ea58bdc1292$var$applySvgAttrs(line, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        stroke: stroke,
        ...strokeAttrs,
        "stroke-linecap": "round"
    });
    return line;
}
function $08414ea58bdc1292$var$createDrawioDocumentPath(x, y, width, height) {
    const wave = Math.min(18, height * 0.18);
    return [
        `M ${x} ${y}`,
        `H ${x + width}`,
        `V ${y + height - wave}`,
        `C ${x + width * 0.72} ${y + height - wave * 2}, ${x + width * 0.58} ${y + height + wave * 0.5}, ${x + width * 0.34} ${y + height - wave * 0.4}`,
        `C ${x + width * 0.18} ${y + height - wave}, ${x + width * 0.08} ${y + height - wave * 0.2}, ${x} ${y + height - wave * 0.45}`,
        "Z"
    ].join(" ");
}
function $08414ea58bdc1292$var$drawioStrokeAttrs(style, strokeWidth) {
    const attrs = {
        "stroke-width": strokeWidth
    };
    if (style.dashed === "1") attrs["stroke-dasharray"] = style.dashPattern || `${strokeWidth * 4} ${strokeWidth * 3}`;
    return attrs;
}
function $08414ea58bdc1292$var$drawioTransform(shape) {
    const rotation = $08414ea58bdc1292$var$finiteNumber3(shape.style.rotation, 0);
    if (!rotation) return "";
    return `rotate(${rotation} ${shape.x + shape.width / 2} ${shape.y + shape.height / 2})`;
}
function $08414ea58bdc1292$var$createDrawioCloudPath(x, y, width, height) {
    const cx = x + width / 2;
    const cy = y + height / 2;
    return [
        `M ${x + width * 0.24} ${y + height * 0.72}`,
        `C ${x - width * 0.02} ${y + height * 0.68}, ${x + width * 0.02} ${y + height * 0.34}, ${x + width * 0.28} ${y + height * 0.38}`,
        `C ${x + width * 0.32} ${y + height * 0.12}, ${cx} ${y + height * 0.06}, ${x + width * 0.62} ${y + height * 0.26}`,
        `C ${x + width * 0.86} ${y + height * 0.2}, ${x + width * 1.02} ${y + height * 0.42}, ${x + width * 0.88} ${y + height * 0.62}`,
        `C ${x + width * 0.86} ${y + height * 0.84}, ${x + width * 0.42} ${y + height * 0.9}, ${x + width * 0.24} ${y + height * 0.72}`,
        "Z"
    ].join(" ");
}
function $08414ea58bdc1292$var$appendDrawioText(svg, text, x, y, fill, style = {}, transform = "") {
    if (!text.trim()) return;
    const lines = $08414ea58bdc1292$var$normalizeDrawioLabel(text).split(/\r?\n/).filter(Boolean);
    if (lines.length === 0) return;
    const textNode = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "text");
    const align = style.align || "center";
    const fontStyle = Number.parseInt(style.fontStyle || "0", 10);
    $08414ea58bdc1292$var$applySvgAttrs(textNode, {
        x: align === "left" ? x - $08414ea58bdc1292$var$finiteNumber3(style.spacingLeft, 0) : align === "right" ? x + $08414ea58bdc1292$var$finiteNumber3(style.spacingRight, 0) : x,
        y: y,
        fill: fill,
        "font-size": $08414ea58bdc1292$var$finiteNumber3(style.fontSize, 14),
        "font-family": "Inter, ui-sans-serif, system-ui, sans-serif",
        "font-weight": fontStyle & 1 ? "700" : void 0,
        "font-style": fontStyle & 2 ? "italic" : void 0,
        "text-decoration": fontStyle & 4 ? "underline" : void 0,
        "text-anchor": align === "left" ? "start" : align === "right" ? "end" : "middle",
        "dominant-baseline": "middle",
        transform: transform
    });
    const firstDy = lines.length > 1 ? `${-0.55 * (lines.length - 1)}em` : "0";
    for (const [index, line] of lines.entries()){
        const span = document.createElementNS($08414ea58bdc1292$var$SVG_NS, "tspan");
        span.setAttribute("x", String(x));
        span.setAttribute("dy", index === 0 ? firstDy : "1.2em");
        span.textContent = line;
        textNode.append(span);
    }
    svg.append(textNode);
}
function $08414ea58bdc1292$var$normalizeDrawioLabel(text) {
    const decoded = $08414ea58bdc1292$var$decodeXmlText(text);
    return decoded.replace(/<br\s*\/?>/gi, "\n").replace(/<\/(?:div|p|li|h\d)>/gi, "\n").replace(/<[^>]+>/g, "").split(/\r?\n/).map((line)=>$08414ea58bdc1292$var$decodeXmlText(line).replace(/\u00a0/g, " ").replace(/[ \t]+/g, " ").trim()).filter(Boolean).join("\n");
}
function $08414ea58bdc1292$var$drawioColor(value, fallback) {
    if (!value || value === "default") return fallback;
    return value.startsWith("#") ? value : `#${value}`;
}
function $08414ea58bdc1292$var$decodeXmlText(value) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
}
function $08414ea58bdc1292$var$renderRawDrawing(panel, extension, text) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${extension} \u57FA\u7840\u9884\u89C8`);
    const pre = document.createElement("pre");
    pre.className = "ofv-text-block";
    pre.textContent = text.slice(0, 3e4);
    section.append(pre);
    panel.append(section);
}
function $08414ea58bdc1292$var$renderDrawingParseFallback(panel, extension, text, error) {
    panel.replaceChildren();
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${extension} \u89E3\u6790\u5931\u8D25`);
    const message = document.createElement("p");
    message.textContent = error instanceof Error ? error.message : String(error);
    const pre = document.createElement("pre");
    pre.className = "ofv-text-block";
    pre.textContent = text.slice(0, 3e4) || "\u6587\u4EF6\u5185\u5BB9\u4E3A\u7A7A\u3002";
    section.append(message, pre);
    panel.append(section);
}
function $08414ea58bdc1292$var$decodeDrawioDiagram(value) {
    try {
        const decoded = decodeURIComponent(escape(atob(value)));
        return (0, $cab713332464fe22$export$2e2bcd8739ae039).inflateRaw(Uint8Array.from(decoded, (char)=>char.charCodeAt(0)), {
            to: "string"
        });
    } catch  {
        return value;
    }
}
var $08414ea58bdc1292$var$xmindExtensions = /* @__PURE__ */ new Set([
    "xmind"
]);
var $08414ea58bdc1292$var$xmindMimeFormatMap = {
    "application/vnd.xmind.workbook": "xmind",
    "application/x-xmind": "xmind"
};
var $08414ea58bdc1292$var$MAX_TOPIC_COUNT = 2e3;
var $08414ea58bdc1292$var$MAX_TOPIC_DEPTH = 128;
var $08414ea58bdc1292$var$NODE_WIDTH = 228;
var $08414ea58bdc1292$var$ROOT_WIDTH = 260;
var $08414ea58bdc1292$var$LEVEL_GAP = 96;
var $08414ea58bdc1292$var$SIBLING_GAP = 20;
var $08414ea58bdc1292$var$CANVAS_PADDING = 40;
function $08414ea58bdc1292$export$d51d8c241479cf0c() {
    return {
        name: "xmind",
        match (file) {
            return $08414ea58bdc1292$var$xmindExtensions.has(file.extension) || Boolean($08414ea58bdc1292$var$xmindMimeFormatMap[file.mimeType]);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-xmind");
            ctx.viewport.append(panel);
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$xmindMimeFormatMap);
            let instance;
            let objectUrls = [];
            try {
                const workbook = await $08414ea58bdc1292$var$parseXMindWorkbook(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file));
                objectUrls = workbook.objectUrls;
                if (ctx.signal?.aborted) {
                    $08414ea58bdc1292$var$revokeObjectUrls(objectUrls);
                    panel.remove();
                    return $08414ea58bdc1292$var$emptyInstance();
                }
                instance = $08414ea58bdc1292$var$renderXMindWorkbook(panel, workbook.sheets, ctx);
            } catch (error) {
                if (ctx.signal?.aborted) {
                    $08414ea58bdc1292$var$revokeObjectUrls(objectUrls);
                    panel.remove();
                    return $08414ea58bdc1292$var$emptyInstance();
                }
                $08414ea58bdc1292$var$renderXMindFallback(panel, extension || ctx.file.extension || "xmind", error);
            }
            return {
                resize (size) {
                    instance?.resize?.(size);
                },
                canCommand (command) {
                    return instance?.canCommand?.(command) ?? false;
                },
                command (command) {
                    return instance?.command?.(command) ?? false;
                },
                preparePrint () {
                    return instance?.preparePrint?.();
                },
                destroy () {
                    instance?.destroy();
                    $08414ea58bdc1292$var$revokeObjectUrls(objectUrls);
                    ctx.toolbar?.setZoom(void 0);
                    panel.remove();
                }
            };
        }
    };
}
async function $08414ea58bdc1292$var$parseXMindWorkbook(buffer) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ey1aZ))).loadAsync(buffer);
    const contentJson = $08414ea58bdc1292$var$findZipFile(zip, "content.json");
    const contentXml = $08414ea58bdc1292$var$findZipFile(zip, "content.xml");
    const objectUrls = [];
    const resources = await $08414ea58bdc1292$var$loadImageResources(zip, objectUrls);
    try {
        if (contentJson) return {
            sheets: $08414ea58bdc1292$var$parseXMindContentJson(await contentJson.async("text"), resources),
            objectUrls: objectUrls
        };
        if (contentXml) return {
            sheets: $08414ea58bdc1292$var$parseXMindContentXml(await contentXml.async("text"), resources),
            objectUrls: objectUrls
        };
    } catch (error) {
        $08414ea58bdc1292$var$revokeObjectUrls(objectUrls);
        throw error;
    }
    $08414ea58bdc1292$var$revokeObjectUrls(objectUrls);
    throw new Error("Missing XMind content.json/content.xml");
}
function $08414ea58bdc1292$var$findZipFile(zip, fileName) {
    const expected = fileName.toLowerCase();
    return Object.values(zip.files).find((entry)=>!entry.dir && entry.name.split("/").pop()?.toLowerCase() === expected);
}
async function $08414ea58bdc1292$var$loadImageResources(zip, objectUrls) {
    const resources = /* @__PURE__ */ new Map();
    if (typeof URL.createObjectURL !== "function") return resources;
    const entries = Object.values(zip.files).filter((entry)=>!entry.dir && /(^|\/)(resources|attachments)\//i.test(entry.name) && $08414ea58bdc1292$var$isImageFile(entry.name));
    for (const entry of entries.slice(0, 256))try {
        const blob = await entry.async("blob");
        const objectUrl = URL.createObjectURL(blob);
        objectUrls.push(objectUrl);
        $08414ea58bdc1292$var$registerResourceAliases(resources, entry.name, objectUrl);
    } catch  {}
    return resources;
}
function $08414ea58bdc1292$var$registerResourceAliases(resources, path, url) {
    const normalized = $08414ea58bdc1292$var$normalizeResourcePath(path);
    resources.set(normalized, url);
    resources.set(`xap:${normalized}`, url);
    resources.set(normalized.replace(/^\/?(resources|attachments)\//, ""), url);
}
function $08414ea58bdc1292$var$isImageFile(path) {
    return /\.(?:avif|bmp|gif|jpe?g|png|svg|webp)$/i.test(path);
}
function $08414ea58bdc1292$var$normalizeResourcePath(path) {
    return path.replace(/^xap:/i, "").replace(/^\/+/, "").replace(/\\/g, "/").toLowerCase();
}
function $08414ea58bdc1292$var$resolveResource(source, resources) {
    const value = source.trim();
    if (/^(?:data:image\/|blob:|https?:\/\/)/i.test(value)) return value;
    const normalized = $08414ea58bdc1292$var$normalizeResourcePath(value);
    return resources.get(normalized) || resources.get(normalized.replace(/^\/?(resources|attachments)\//, ""));
}
function $08414ea58bdc1292$var$parseXMindContentJson(source, resources) {
    const raw = JSON.parse(source);
    const candidates = $08414ea58bdc1292$var$readJsonSheets(raw);
    const budget = {
        count: 0
    };
    const parsed = candidates.map((sheet, index)=>$08414ea58bdc1292$var$parseXMindJsonSheet(sheet, index, resources, budget)).filter((sheet)=>Boolean(sheet));
    if (parsed.length === 0) throw new Error("No readable XMind sheets");
    return parsed;
}
function $08414ea58bdc1292$var$readJsonSheets(raw) {
    if (Array.isArray(raw)) return raw;
    if (!$08414ea58bdc1292$var$isRecord(raw)) return [];
    if (Array.isArray(raw.sheets)) return raw.sheets;
    if ($08414ea58bdc1292$var$isRecord(raw.rootTopic) || $08414ea58bdc1292$var$isRecord(raw.root)) return [
        raw
    ];
    if ($08414ea58bdc1292$var$isRecord(raw.content)) return $08414ea58bdc1292$var$readJsonSheets(raw.content);
    return [];
}
function $08414ea58bdc1292$var$parseXMindJsonSheet(raw, index, resources, budget) {
    if (!$08414ea58bdc1292$var$isRecord(raw)) return void 0;
    const rootTopic = $08414ea58bdc1292$var$isRecord(raw.rootTopic) ? raw.rootTopic : $08414ea58bdc1292$var$isRecord(raw.root) ? raw.root : void 0;
    if (!rootTopic) return void 0;
    const root = $08414ea58bdc1292$var$parseXMindJsonTopic(rootTopic, resources, budget, 0, "attached");
    return {
        title: $08414ea58bdc1292$var$readString(raw.title) || root.title || `Sheet ${index + 1}`,
        root: root
    };
}
function $08414ea58bdc1292$var$parseXMindJsonTopic(raw, resources, budget, depth, kind) {
    $08414ea58bdc1292$var$consumeTopicBudget(budget, depth);
    const children = [];
    const childrenContainer = raw.children;
    if (Array.isArray(childrenContainer)) $08414ea58bdc1292$var$appendJsonChildren(children, childrenContainer, "attached", resources, budget, depth);
    else if ($08414ea58bdc1292$var$isRecord(childrenContainer)) for (const childKind of [
        "attached",
        "detached",
        "summary",
        "callout"
    ])$08414ea58bdc1292$var$appendJsonChildren(children, childrenContainer[childKind], childKind, resources, budget, depth);
    const image = $08414ea58bdc1292$var$isRecord(raw.image) ? $08414ea58bdc1292$var$readString(raw.image.src) || $08414ea58bdc1292$var$readString(raw.image.href) : $08414ea58bdc1292$var$readString(raw.image);
    return {
        id: $08414ea58bdc1292$var$readString(raw.id) || `topic-${budget.count}`,
        title: $08414ea58bdc1292$var$readString(raw.title) || $08414ea58bdc1292$var$readString(raw.text) || "Untitled",
        children: children,
        notes: $08414ea58bdc1292$var$readXMindJsonNotes(raw.notes),
        labels: $08414ea58bdc1292$var$readStringArray(raw.labels),
        markers: $08414ea58bdc1292$var$readMarkerIds(raw.markers),
        hyperlink: $08414ea58bdc1292$var$readString(raw.href) || $08414ea58bdc1292$var$readString(raw.hyperlink) || void 0,
        image: image ? $08414ea58bdc1292$var$resolveResource(image, resources) || image : void 0,
        kind: kind
    };
}
function $08414ea58bdc1292$var$appendJsonChildren(target, raw, kind, resources, budget, parentDepth) {
    if (!Array.isArray(raw)) return;
    for (const child of raw)if ($08414ea58bdc1292$var$isRecord(child)) target.push($08414ea58bdc1292$var$parseXMindJsonTopic(child, resources, budget, parentDepth + 1, kind));
}
function $08414ea58bdc1292$var$readXMindJsonNotes(raw) {
    if (typeof raw === "string") return raw.trim() ? [
        raw.trim()
    ] : [];
    if (!$08414ea58bdc1292$var$isRecord(raw)) return [];
    const values = [
        "plain",
        "realHTML",
        "html"
    ].map((key)=>{
        const note = raw[key];
        return $08414ea58bdc1292$var$isRecord(note) ? $08414ea58bdc1292$var$readString(note.content) : $08414ea58bdc1292$var$readString(note);
    }).map($08414ea58bdc1292$var$stripHtml).filter(Boolean);
    return [
        ...new Set(values)
    ];
}
function $08414ea58bdc1292$var$readMarkerIds(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map((marker)=>{
        if (typeof marker === "string") return marker.trim();
        return $08414ea58bdc1292$var$isRecord(marker) ? $08414ea58bdc1292$var$readString(marker.markerId) || $08414ea58bdc1292$var$readString(marker["marker-id"]) || $08414ea58bdc1292$var$readString(marker.id) : "";
    }).filter(Boolean);
}
function $08414ea58bdc1292$var$parseXMindContentXml(source, resources) {
    const doc = new DOMParser().parseFromString(source, "application/xml");
    if (doc.querySelector("parsererror")) throw new Error("Invalid XMind XML");
    const sheets = Array.from(doc.getElementsByTagName("*")).filter((element)=>element.localName === "sheet");
    const budget = {
        count: 0
    };
    const parsed = sheets.map((sheet, index)=>$08414ea58bdc1292$var$parseXMindXmlSheet(sheet, index, resources, budget)).filter((sheet)=>Boolean(sheet));
    if (parsed.length === 0) throw new Error("No readable XMind sheets");
    return parsed;
}
function $08414ea58bdc1292$var$parseXMindXmlSheet(sheet, index, resources, budget) {
    const rootTopic = $08414ea58bdc1292$var$firstDirectChild(sheet, "topic");
    if (!rootTopic) return void 0;
    const root = $08414ea58bdc1292$var$parseXMindXmlTopic(rootTopic, resources, budget, 0, "attached");
    return {
        title: $08414ea58bdc1292$var$directChildText(sheet, "title") || root.title || `Sheet ${index + 1}`,
        root: root
    };
}
function $08414ea58bdc1292$var$parseXMindXmlTopic(topic, resources, budget, depth, kind) {
    $08414ea58bdc1292$var$consumeTopicBudget(budget, depth);
    const children = $08414ea58bdc1292$var$directXmlChildTopics(topic).map(({ topic: child, kind: childKind })=>$08414ea58bdc1292$var$parseXMindXmlTopic(child, resources, budget, depth + 1, childKind));
    const notesContainer = $08414ea58bdc1292$var$firstDirectChild(topic, "notes");
    const labelsContainer = $08414ea58bdc1292$var$firstDirectChild(topic, "labels");
    const markersContainer = $08414ea58bdc1292$var$firstDirectChild(topic, "marker-refs");
    const imageElement = $08414ea58bdc1292$var$ownedXmlDescendants(topic, [
        "img",
        "image"
    ])[0];
    const imageSource = imageElement ? $08414ea58bdc1292$var$readAttribute(imageElement, [
        "src",
        "href"
    ]) : "";
    return {
        id: $08414ea58bdc1292$var$readAttribute(topic, [
            "id"
        ]) || `topic-${budget.count}`,
        title: $08414ea58bdc1292$var$directChildText(topic, "title") || "Untitled",
        children: children,
        notes: notesContainer ? Array.from(notesContainer.getElementsByTagName("*")).filter((element)=>element.localName === "plain" || element.localName === "html").map((element)=>$08414ea58bdc1292$var$stripHtml(element.textContent || "")).filter(Boolean) : [],
        labels: labelsContainer ? Array.from(labelsContainer.getElementsByTagName("*")).filter((element)=>element.localName === "label").map((element)=>(element.textContent || "").trim()).filter(Boolean) : [],
        markers: markersContainer ? Array.from(markersContainer.getElementsByTagName("*")).filter((element)=>element.localName === "marker-ref").map((element)=>$08414ea58bdc1292$var$readAttribute(element, [
                "marker-id",
                "markerId",
                "id"
            ])).filter(Boolean) : [],
        hyperlink: $08414ea58bdc1292$var$readAttribute(topic, [
            "href"
        ]) || void 0,
        image: imageSource ? $08414ea58bdc1292$var$resolveResource(imageSource, resources) || imageSource : void 0,
        kind: kind
    };
}
function $08414ea58bdc1292$var$directXmlChildTopics(topic) {
    const childrenElement = $08414ea58bdc1292$var$firstDirectChild(topic, "children");
    if (!childrenElement) return [];
    return Array.from(childrenElement.children).filter((element)=>element.localName === "topics").flatMap((topics)=>{
        const rawKind = $08414ea58bdc1292$var$readAttribute(topics, [
            "type"
        ]);
        const kind = rawKind === "detached" || rawKind === "summary" || rawKind === "callout" ? rawKind : "attached";
        return Array.from(topics.children).filter((child)=>child.localName === "topic").map((child)=>({
                topic: child,
                kind: kind
            }));
    });
}
function $08414ea58bdc1292$var$ownedXmlDescendants(topic, names) {
    return Array.from(topic.getElementsByTagName("*")).filter((element)=>{
        if (!names.includes(element.localName)) return false;
        let parent = element.parentElement;
        while(parent && parent !== topic){
            if (parent.localName === "topic") return false;
            parent = parent.parentElement;
        }
        return parent === topic;
    });
}
function $08414ea58bdc1292$var$readAttribute(element, names) {
    for (const attribute of Array.from(element.attributes)){
        if (names.includes(attribute.localName) || names.includes(attribute.name)) return attribute.value.trim();
    }
    return "";
}
function $08414ea58bdc1292$var$consumeTopicBudget(budget, depth) {
    budget.count += 1;
    if (budget.count > $08414ea58bdc1292$var$MAX_TOPIC_COUNT) throw new Error(`XMind topic limit exceeded (${$08414ea58bdc1292$var$MAX_TOPIC_COUNT})`);
    if (depth > $08414ea58bdc1292$var$MAX_TOPIC_DEPTH) throw new Error(`XMind topic depth limit exceeded (${$08414ea58bdc1292$var$MAX_TOPIC_DEPTH})`);
}
function $08414ea58bdc1292$var$renderXMindWorkbook(panel, sheets, ctx) {
    const summary = document.createElement("section");
    summary.className = "ofv-section ofv-xmind-summary";
    const heading = document.createElement("h3");
    heading.textContent = "XMind";
    summary.append(heading);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5DE5\u4F5C\u8868", sheets.length);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u4E3B\u9898", $08414ea58bdc1292$var$countXMindTopics(sheets));
    panel.append(summary);
    const workbook = document.createElement("section");
    workbook.className = "ofv-xmind-workbook";
    const header = document.createElement("header");
    header.className = "ofv-xmind-header";
    const tabs = document.createElement("div");
    tabs.className = "ofv-xmind-tabs";
    tabs.setAttribute("role", "tablist");
    const fitButton = document.createElement("button");
    fitButton.type = "button";
    fitButton.className = "ofv-xmind-fit";
    fitButton.textContent = "\u9002\u5E94\u753B\u5E03";
    header.append(tabs, fitButton);
    const stage = document.createElement("div");
    stage.className = "ofv-xmind-stage";
    stage.tabIndex = 0;
    stage.setAttribute("aria-label", "XMind mind map canvas");
    const surface = document.createElement("div");
    surface.className = "ofv-xmind-surface";
    stage.append(surface);
    workbook.append(header, stage);
    panel.append(workbook);
    const layouts = sheets.map((sheet)=>$08414ea58bdc1292$var$layoutSheet(sheet));
    let activeSheet = 0;
    let scale = $08414ea58bdc1292$var$clamp(ctx.options.zoom, 0.2, 3);
    let panX = 24;
    let panY = 24;
    let dragging = false;
    let pointerId;
    let lastX = 0;
    let lastY = 0;
    let destroyed = false;
    const applyTransform = ()=>{
        surface.style.transform = `translate(${Math.round(panX)}px, ${Math.round(panY)}px) scale(${scale})`;
        const normalized = Math.round(scale * 100) / 100;
        ctx.toolbar?.setZoom(normalized === 1 ? void 0 : normalized);
    };
    const centerAtScale = (nextScale)=>{
        const layout = layouts[activeSheet];
        scale = $08414ea58bdc1292$var$clamp(nextScale, 0.2, 3);
        const width = stage.clientWidth;
        const height = stage.clientHeight;
        panX = width > 0 ? Math.max(20, (width - layout.width * scale) / 2) : 24;
        panY = height > 0 ? Math.max(20, (height - layout.height * scale) / 2) : 24;
        applyTransform();
    };
    const fitToView = ()=>{
        const layout = layouts[activeSheet];
        const width = stage.clientWidth;
        const height = stage.clientHeight;
        if (width <= 0 || height <= 0) {
            centerAtScale(1);
            return;
        }
        centerAtScale(Math.min(1, (width - 40) / layout.width, (height - 40) / layout.height));
    };
    const zoomAround = (nextScale, clientX, clientY)=>{
        const normalized = $08414ea58bdc1292$var$clamp(nextScale, 0.2, 3);
        const rect = stage.getBoundingClientRect();
        const pointX = clientX ?? rect.left + rect.width / 2;
        const pointY = clientY ?? rect.top + rect.height / 2;
        const localX = (pointX - rect.left - panX) / scale;
        const localY = (pointY - rect.top - panY) / scale;
        panX = pointX - rect.left - localX * normalized;
        panY = pointY - rect.top - localY * normalized;
        scale = normalized;
        applyTransform();
    };
    const renderSheet2 = (index, shouldFit)=>{
        activeSheet = index;
        surface.replaceChildren($08414ea58bdc1292$var$renderSheetLayout(layouts[index]));
        surface.style.width = `${layouts[index].width}px`;
        surface.style.height = `${layouts[index].height}px`;
        Array.from(tabs.children).forEach((tab, tabIndex)=>{
            tab.setAttribute("aria-selected", String(tabIndex === index));
            tab.classList.toggle("is-active", tabIndex === index);
        });
        if (shouldFit) requestAnimationFrame(fitToView);
        else applyTransform();
    };
    for (const [index, sheet] of sheets.entries()){
        const tab = document.createElement("button");
        tab.type = "button";
        tab.className = "ofv-xmind-tab";
        tab.setAttribute("role", "tab");
        tab.textContent = sheet.title;
        tab.addEventListener("click", ()=>renderSheet2(index, true));
        tabs.append(tab);
    }
    const onPointerDown = (event)=>{
        if (event.button !== 0) return;
        dragging = true;
        pointerId = event.pointerId;
        lastX = event.clientX;
        lastY = event.clientY;
        stage.classList.add("is-panning");
        stage.setPointerCapture?.(event.pointerId);
    };
    const onPointerMove = (event)=>{
        if (!dragging || event.pointerId !== pointerId) return;
        panX += event.clientX - lastX;
        panY += event.clientY - lastY;
        lastX = event.clientX;
        lastY = event.clientY;
        applyTransform();
    };
    const endPointer = (event)=>{
        if (event.pointerId !== pointerId) return;
        dragging = false;
        pointerId = void 0;
        stage.classList.remove("is-panning");
        stage.releasePointerCapture?.(event.pointerId);
    };
    const onWheel = (event)=>{
        event.preventDefault();
        if (event.ctrlKey || event.metaKey) {
            zoomAround(scale * Math.exp(-event.deltaY * 2e-3), event.clientX, event.clientY);
            return;
        }
        panX -= event.deltaX;
        panY -= event.deltaY;
        applyTransform();
    };
    const onKeyDown = (event)=>{
        const distance = event.shiftKey ? 80 : 32;
        if (event.key === "ArrowLeft") panX += distance;
        else if (event.key === "ArrowRight") panX -= distance;
        else if (event.key === "ArrowUp") panY += distance;
        else if (event.key === "ArrowDown") panY -= distance;
        else return;
        event.preventDefault();
        applyTransform();
    };
    fitButton.addEventListener("click", fitToView);
    stage.addEventListener("pointerdown", onPointerDown);
    stage.addEventListener("pointermove", onPointerMove);
    stage.addEventListener("pointerup", endPointer);
    stage.addEventListener("pointercancel", endPointer);
    stage.addEventListener("wheel", onWheel, {
        passive: false
    });
    stage.addEventListener("keydown", onKeyDown);
    renderSheet2(0, false);
    return {
        resize () {
            if (!destroyed) requestAnimationFrame(fitToView);
        },
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoomAround(scale * 1.15);
                return true;
            }
            if (command === "zoom-out") {
                zoomAround(scale / 1.15);
                return true;
            }
            if (command === "zoom-reset") {
                centerAtScale(1);
                return true;
            }
            return false;
        },
        destroy () {
            destroyed = true;
            fitButton.removeEventListener("click", fitToView);
            stage.removeEventListener("pointerdown", onPointerDown);
            stage.removeEventListener("pointermove", onPointerMove);
            stage.removeEventListener("pointerup", endPointer);
            stage.removeEventListener("pointercancel", endPointer);
            stage.removeEventListener("wheel", onWheel);
            stage.removeEventListener("keydown", onKeyDown);
        }
    };
}
function $08414ea58bdc1292$var$layoutSheet(sheet) {
    const nodes = [];
    const build = (topic, depth)=>{
        const children = topic.children.map((child)=>build(child, depth + 1));
        const width = depth === 0 ? $08414ea58bdc1292$var$ROOT_WIDTH : $08414ea58bdc1292$var$NODE_WIDTH;
        const height = $08414ea58bdc1292$var$estimateTopicHeight(topic, depth);
        const childrenHeight = children.reduce((total, child)=>total + child.subtreeHeight, 0) + Math.max(0, children.length - 1) * $08414ea58bdc1292$var$SIBLING_GAP;
        const node = {
            topic: topic,
            depth: depth,
            x: $08414ea58bdc1292$var$CANVAS_PADDING + depth * ($08414ea58bdc1292$var$NODE_WIDTH + $08414ea58bdc1292$var$LEVEL_GAP),
            y: 0,
            width: width,
            height: height,
            subtreeHeight: Math.max(height, childrenHeight),
            children: children
        };
        nodes.push(node);
        return node;
    };
    const root = build(sheet.root, 0);
    const assign = (node, top)=>{
        node.y = top + (node.subtreeHeight - node.height) / 2;
        let childTop = top;
        for (const child of node.children){
            assign(child, childTop);
            childTop += child.subtreeHeight + $08414ea58bdc1292$var$SIBLING_GAP;
        }
    };
    assign(root, $08414ea58bdc1292$var$CANVAS_PADDING);
    const maxRight = Math.max(...nodes.map((node)=>node.x + node.width));
    return {
        root: root,
        nodes: nodes,
        width: maxRight + $08414ea58bdc1292$var$CANVAS_PADDING,
        height: root.subtreeHeight + $08414ea58bdc1292$var$CANVAS_PADDING * 2
    };
}
function $08414ea58bdc1292$var$estimateTopicHeight(topic, depth) {
    const titleLines = Math.min(4, Math.max(1, Math.ceil(topic.title.length / (depth === 0 ? 18 : 22))));
    let height = 28 + titleLines * 20;
    if (topic.image) height += 104;
    if (topic.labels.length || topic.markers.length || topic.kind !== "attached") height += 30;
    if (topic.notes.length) height += 46;
    return Math.min(240, height);
}
function $08414ea58bdc1292$var$renderSheetLayout(layout) {
    const fragment = document.createDocumentFragment();
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("ofv-xmind-edges");
    svg.setAttribute("width", String(layout.width));
    svg.setAttribute("height", String(layout.height));
    svg.setAttribute("viewBox", `0 0 ${layout.width} ${layout.height}`);
    for (const node of layout.nodes)for (const child of node.children){
        const startX = node.x + node.width;
        const startY = node.y + node.height / 2;
        const endX = child.x;
        const endY = child.y + child.height / 2;
        const control = Math.max(32, (endX - startX) * 0.5);
        const edge = document.createElementNS("http://www.w3.org/2000/svg", "path");
        edge.setAttribute("d", `M ${startX} ${startY} C ${startX + control} ${startY}, ${endX - control} ${endY}, ${endX} ${endY}`);
        edge.classList.add(`ofv-xmind-edge-${child.topic.kind}`);
        svg.append(edge);
    }
    fragment.append(svg);
    for (const node of layout.nodes)fragment.append($08414ea58bdc1292$var$renderXMindTopic(node));
    return fragment;
}
function $08414ea58bdc1292$var$renderXMindTopic(node) {
    const topic = node.topic;
    const card = document.createElement("article");
    card.className = `ofv-xmind-topic ofv-xmind-topic-depth-${Math.min(node.depth, 4)} ofv-xmind-topic-${topic.kind}`;
    card.style.left = `${node.x}px`;
    card.style.top = `${node.y}px`;
    card.style.width = `${node.width}px`;
    card.style.height = `${node.height}px`;
    card.dataset.topicId = topic.id;
    const title = $08414ea58bdc1292$var$safeExternalLink(topic.hyperlink);
    if (title) {
        const link = document.createElement("a");
        link.className = "ofv-xmind-topic-title";
        link.textContent = topic.title;
        link.href = title;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        card.append(link);
    } else {
        const strong = document.createElement("strong");
        strong.className = "ofv-xmind-topic-title";
        strong.textContent = topic.title;
        card.append(strong);
    }
    if (topic.image && $08414ea58bdc1292$var$safeImageSource(topic.image)) {
        const image = document.createElement("img");
        image.className = "ofv-xmind-topic-image";
        image.src = topic.image;
        image.alt = topic.title;
        image.draggable = false;
        card.append(image);
    }
    const chips = [
        ...topic.labels.map((value)=>`#${value}`),
        ...topic.markers.map($08414ea58bdc1292$var$formatMarker)
    ];
    if (topic.kind !== "attached") chips.unshift(topic.kind);
    if (chips.length) {
        const meta = document.createElement("div");
        meta.className = "ofv-xmind-topic-meta";
        for (const value of chips.slice(0, 6)){
            const chip = document.createElement("span");
            chip.textContent = value;
            meta.append(chip);
        }
        card.append(meta);
    }
    if (topic.notes.length) {
        const notes = document.createElement("p");
        notes.className = "ofv-xmind-topic-notes";
        notes.textContent = topic.notes[0];
        notes.title = topic.notes.join("\n");
        card.append(notes);
    }
    return card;
}
function $08414ea58bdc1292$var$formatMarker(marker) {
    const priority = /^priority-(\d+)$/i.exec(marker);
    if (priority) return `P${priority[1]}`;
    if (/^task-done$/i.test(marker)) return "\u2713 done";
    const progress = /^task-(.+)$/i.exec(marker);
    if (progress) return `\u8FDB\u5EA6 ${progress[1]}`;
    return marker;
}
function $08414ea58bdc1292$var$safeExternalLink(value) {
    return value && /^(?:https?:|mailto:)/i.test(value) ? value : void 0;
}
function $08414ea58bdc1292$var$safeImageSource(value) {
    return /^(?:blob:|data:image\/|https?:\/\/)/i.test(value);
}
function $08414ea58bdc1292$var$renderXMindFallback(panel, format, error) {
    const section = document.createElement("section");
    section.className = "ofv-section ofv-xmind-fallback";
    const heading = document.createElement("h3");
    heading.textContent = "XMind preview";
    const message = document.createElement("p");
    message.textContent = `Unable to parse ${format.toUpperCase()} workbook.`;
    const detail = document.createElement("small");
    detail.textContent = error instanceof Error ? error.message : String(error);
    section.append(heading, message, detail);
    panel.append(section);
}
function $08414ea58bdc1292$var$countXMindTopics(sheets) {
    const countTopic = (topic)=>1 + topic.children.reduce((total, child)=>total + countTopic(child), 0);
    return sheets.reduce((total, sheet)=>total + countTopic(sheet.root), 0);
}
function $08414ea58bdc1292$var$firstDirectChild(element, localName) {
    return Array.from(element.children).find((child)=>child.localName === localName);
}
function $08414ea58bdc1292$var$directChildText(element, localName) {
    return ($08414ea58bdc1292$var$firstDirectChild(element, localName)?.textContent || "").trim();
}
function $08414ea58bdc1292$var$readString(value) {
    return typeof value === "string" ? value.trim() : "";
}
function $08414ea58bdc1292$var$readStringArray(value) {
    if (!Array.isArray(value)) return [];
    return value.map((item)=>typeof item === "string" ? item.trim() : $08414ea58bdc1292$var$isRecord(item) ? $08414ea58bdc1292$var$readString(item.text) || $08414ea58bdc1292$var$readString(item.value) : "").filter(Boolean);
}
function $08414ea58bdc1292$var$isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $08414ea58bdc1292$var$stripHtml(value) {
    return value.replace(/<[^>]+>/g, " ").replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&").replace(/\s+/g, " ").trim();
}
function $08414ea58bdc1292$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
function $08414ea58bdc1292$var$revokeObjectUrls(urls) {
    if (typeof URL.revokeObjectURL !== "function") return;
    for (const url of urls)URL.revokeObjectURL(url);
}
function $08414ea58bdc1292$var$emptyInstance() {
    return {
        destroy () {}
    };
}
// src/plugins/cad-dwg.ts
var $08414ea58bdc1292$var$libreDwgPromise;
var $08414ea58bdc1292$var$defaultLibreDwgWasmBaseUrl = "/vendor/libredwg-web";
var $08414ea58bdc1292$var$minReadableDrawingHeight = 420;
var $08414ea58bdc1292$var$libreDwgPackageName = "@mlightcad/libredwg-web";
var $08414ea58bdc1292$var$defaultWorkerTimeoutMs = 12e4;
var $08414ea58bdc1292$var$svgNumberPattern = /-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
async function $08414ea58bdc1292$var$renderLibreDwgPreview(ctx, options = {}) {
    if (ctx.extension !== "dwg" || options.enabled === false) return void 0;
    const shell = document.createElement("div");
    shell.className = "ofv-dwg-preview";
    const status = document.createElement("div");
    status.className = "ofv-dwg-preview-status";
    status.textContent = "Loading DWG rendering engine...";
    shell.append(status);
    ctx.panel.append(shell);
    try {
        const result = await $08414ea58bdc1292$var$parseDwg(ctx.arrayBuffer, options, ctx.preview.signal, (message)=>{
            status.textContent = message;
        });
        const svg = result.svg;
        const stats = result.stats;
        let thumbnailUrl = $08414ea58bdc1292$var$createDwgThumbnailUrl(result.thumbnail);
        if (result.conversionError) {
            if (thumbnailUrl) {
                const fallbackThumbnailUrl = thumbnailUrl;
                status.replaceChildren($08414ea58bdc1292$var$createDwgThumbnailFallbackStatus(ctx.fileName, result.conversionError));
                shell.append($08414ea58bdc1292$var$createDwgThumbnailPreview(fallbackThumbnailUrl, ctx.fileName));
                return {
                    destroy () {
                        URL.revokeObjectURL(fallbackThumbnailUrl);
                        shell.remove();
                    }
                };
            }
            throw new Error(result.conversionError);
        }
        if (!svg || !/<svg[\s>]/i.test(svg)) {
            if (thumbnailUrl) {
                const fallbackThumbnailUrl = thumbnailUrl;
                status.replaceChildren($08414ea58bdc1292$var$createDwgThumbnailFallbackStatus(ctx.fileName, "DWG parser finished but did not produce SVG output."));
                shell.append($08414ea58bdc1292$var$createDwgThumbnailPreview(fallbackThumbnailUrl, ctx.fileName));
                return {
                    destroy () {
                        URL.revokeObjectURL(fallbackThumbnailUrl);
                        shell.remove();
                    }
                };
            }
            throw new Error("DWG parser finished but did not produce SVG output.");
        }
        if (!stats) throw new Error("DWG parser finished without drawing statistics.");
        const doc = new DOMParser().parseFromString($08414ea58bdc1292$var$sanitizeDwgSvgMarkup(svg), "image/svg+xml");
        const svgElement = doc.documentElement;
        if (!(svgElement instanceof SVGElement) || svgElement.nodeName.toLowerCase() !== "svg" || svgElement.querySelector("parsererror")) throw new Error("DWG SVG output is invalid.");
        svgElement.classList.add("ofv-dwg-preview-svg");
        svgElement.setAttribute("role", "img");
        svgElement.setAttribute("aria-label", ctx.fileName);
        $08414ea58bdc1292$var$sanitizeDwgSvgElement(svgElement);
        $08414ea58bdc1292$var$normalizeDwgSvg(svgElement);
        status.replaceChildren($08414ea58bdc1292$var$createDwgStatusTitle(ctx.fileName, stats));
        const drawing = $08414ea58bdc1292$var$createDwgDrawingViewport(svgElement);
        if (thumbnailUrl) shell.append($08414ea58bdc1292$var$createDwgThumbnailPanel(thumbnailUrl));
        shell.append(drawing.frame);
        return {
            resize () {
                drawing.update();
            },
            canCommand (command) {
                return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
            },
            command (command) {
                if (command === "zoom-in") {
                    drawing.setZoom(drawing.zoom * 1.18);
                    return true;
                }
                if (command === "zoom-out") {
                    drawing.setZoom(drawing.zoom / 1.18);
                    return true;
                }
                if (command === "zoom-reset") {
                    drawing.setZoom(1);
                    return true;
                }
                return false;
            },
            destroy () {
                if (thumbnailUrl) URL.revokeObjectURL(thumbnailUrl);
                shell.remove();
            }
        };
    } catch (error) {
        shell.remove();
        if (!$08414ea58bdc1292$var$isAbortError(error)) console.warn("DWG LibreDWG preview failed, falling back to metadata preview:", error);
        return void 0;
    }
}
function $08414ea58bdc1292$var$sanitizeDwgSvgMarkup(svg) {
    return svg.replace(/&(?!(?:amp|lt|gt|quot|apos|#\d+|#x[\da-f]+);)/gi, "&amp;");
}
function $08414ea58bdc1292$var$sanitizeDwgSvgElement(svgElement) {
    svgElement.querySelectorAll("script,style,foreignObject,iframe,object,embed,audio,video").forEach((element)=>element.remove());
    for (const element of [
        svgElement,
        ...svgElement.querySelectorAll("*")
    ])for (const attribute of [
        ...element.attributes
    ]){
        const name = attribute.name.toLowerCase();
        const value = attribute.value.trim();
        if (name.startsWith("on") || (name === "href" || name === "xlink:href") && value !== "" && !value.startsWith("#") || /url\s*\(/i.test(value) && !/url\s*\(\s*["']?#/i.test(value)) element.removeAttribute(attribute.name);
    }
}
async function $08414ea58bdc1292$var$parseDwg(arrayBuffer, options, signal, onProgress) {
    const canUseWorker = options.useWorker !== false && (Boolean(options.workerFactory) || typeof Worker !== "undefined" && Boolean(options.workerModuleUrl));
    if (canUseWorker) return $08414ea58bdc1292$var$parseDwgInWorker(arrayBuffer, options, signal, onProgress);
    onProgress("Parsing DWG on the main thread...");
    return $08414ea58bdc1292$var$parseDwgOnMainThread(arrayBuffer, options.wasmBaseUrl || $08414ea58bdc1292$var$defaultLibreDwgWasmBaseUrl, signal);
}
async function $08414ea58bdc1292$var$parseDwgOnMainThread(arrayBuffer, wasmBaseUrl, signal) {
    $08414ea58bdc1292$var$throwIfAborted(signal);
    const { LibreDwg: LibreDwg, Dwg_File_Type: Dwg_File_Type } = await $08414ea58bdc1292$var$loadLibreDwg();
    $08414ea58bdc1292$var$throwIfAborted(signal);
    const libredwg = await LibreDwg.create(wasmBaseUrl);
    $08414ea58bdc1292$var$throwIfAborted(signal);
    const data = libredwg.dwg_read_data(arrayBuffer, Dwg_File_Type.DWG);
    if (!data) throw new Error("DWG parser did not return drawing data.");
    try {
        const thumbnail = $08414ea58bdc1292$var$readDwgThumbnail(libredwg, data);
        try {
            const result = libredwg.convertEx(data);
            const database = result.database;
            return {
                svg: libredwg.dwg_to_svg(database),
                stats: $08414ea58bdc1292$var$createDwgPreviewStats(database, result.stats.unknownEntityCount, Boolean(thumbnail)),
                thumbnail: thumbnail
            };
        } catch (error) {
            return {
                svg: "",
                thumbnail: thumbnail,
                conversionError: $08414ea58bdc1292$var$getErrorMessage(error)
            };
        }
    } finally{
        libredwg.dwg_free(data);
    }
}
function $08414ea58bdc1292$var$parseDwgInWorker(arrayBuffer, options, signal, onProgress) {
    return new Promise((resolve, reject)=>{
        let worker;
        try {
            worker = options.workerFactory?.() ?? $08414ea58bdc1292$var$createInlineDwgWorker(options.workerModuleUrl);
        } catch (error) {
            reject(error);
            return;
        }
        let settled = false;
        const timeoutMs = Math.max(1, options.workerTimeoutMs ?? $08414ea58bdc1292$var$defaultWorkerTimeoutMs);
        const timeoutId = setTimeout(()=>{
            finish(()=>reject(new Error(`DWG worker timed out after ${timeoutMs}ms.`)));
        }, timeoutMs);
        const onAbort = ()=>{
            finish(()=>reject($08414ea58bdc1292$var$createAbortError()));
        };
        const finish = (callback)=>{
            if (settled) return;
            settled = true;
            clearTimeout(timeoutId);
            signal?.removeEventListener("abort", onAbort);
            worker.terminate();
            callback();
        };
        worker.onmessage = (event)=>{
            const message = event.data;
            if (message.type === "progress") {
                onProgress(message.message);
                return;
            }
            if (message.type === "success") {
                finish(()=>resolve($08414ea58bdc1292$var$normalizeWorkerResult(message.result)));
                return;
            }
            finish(()=>reject(new Error(message.message)));
        };
        worker.onerror = (event)=>{
            finish(()=>reject(new Error(event.message || "DWG worker failed.")));
        };
        if (signal?.aborted) {
            onAbort();
            return;
        }
        signal?.addEventListener("abort", onAbort, {
            once: true
        });
        const transferableBuffer = arrayBuffer.slice(0);
        worker.postMessage({
            type: "parse",
            arrayBuffer: transferableBuffer,
            moduleUrl: $08414ea58bdc1292$var$resolveWorkerAssetUrl(options.workerModuleUrl),
            wasmBaseUrl: $08414ea58bdc1292$var$resolveWorkerAssetUrl(options.wasmBaseUrl || $08414ea58bdc1292$var$defaultLibreDwgWasmBaseUrl)
        }, [
            transferableBuffer
        ]);
    });
}
function $08414ea58bdc1292$var$resolveWorkerAssetUrl(value) {
    if (!value) return void 0;
    const baseUrl = typeof document !== "undefined" ? document.baseURI : globalThis.location?.href;
    return baseUrl ? new URL(value, baseUrl).href : value;
}
function $08414ea58bdc1292$var$createInlineDwgWorker(moduleUrl) {
    if (!moduleUrl) throw new Error("DWG worker requires libreDwg.workerModuleUrl or a custom workerFactory.");
    const source = `(${$08414ea58bdc1292$var$runLibreDwgWorker.toString()})();`;
    const blobUrl = URL.createObjectURL(new Blob([
        source
    ], {
        type: "text/javascript"
    }));
    try {
        return new Worker(blobUrl, {
            type: "module",
            name: "open-file-viewer-dwg"
        });
    } finally{
        URL.revokeObjectURL(blobUrl);
    }
}
function $08414ea58bdc1292$var$runLibreDwgWorker() {
    const scope = self;
    const errorMessage = (error)=>error instanceof Error ? error.message : String(error || "Unknown DWG error");
    const copyThumbnail = (thumbnail)=>{
        if (!thumbnail?.data?.length) return void 0;
        const data = thumbnail.data.slice();
        return {
            data: data.buffer,
            type: Number(thumbnail.type || 0)
        };
    };
    scope.onmessage = async (event)=>{
        const request = event.data;
        if (request.type !== "parse" || !request.arrayBuffer || !request.moduleUrl) {
            scope.postMessage({
                type: "error",
                message: "DWG worker received an invalid parse request."
            });
            return;
        }
        try {
            scope.postMessage({
                type: "progress",
                message: "Loading DWG rendering engine in worker..."
            });
            const importModule = new Function("url", "return import(url)");
            const module = await importModule(request.moduleUrl);
            const libredwg = await module.LibreDwg.create(request.wasmBaseUrl);
            scope.postMessage({
                type: "progress",
                message: "Parsing DWG geometry in worker..."
            });
            const data = libredwg.dwg_read_data(request.arrayBuffer, module.Dwg_File_Type.DWG);
            if (!data) throw new Error("DWG parser did not return drawing data.");
            try {
                let thumbnail;
                try {
                    thumbnail = copyThumbnail(libredwg.dwg_bmp(data));
                } catch  {
                    thumbnail = void 0;
                }
                try {
                    const converted = libredwg.convertEx(data);
                    const database = converted.database;
                    const layers = database.tables?.LAYER?.entries ?? [];
                    const entities = database.entities ?? [];
                    const layouts = database.objects?.LAYOUT ?? [];
                    const result = {
                        svg: libredwg.dwg_to_svg(database),
                        stats: {
                            entityCount: entities.length,
                            layerCount: layers.length,
                            layoutCount: layouts.length,
                            unknownEntityCount: Number(converted.stats?.unknownEntityCount || 0),
                            visibleLayerCount: layers.filter((layer)=>!layer.off && !layer.frozen).length,
                            paperSpaceEntityCount: entities.filter((entity)=>entity.isInPaperSpace).length,
                            hasThumbnail: Boolean(thumbnail)
                        },
                        thumbnail: thumbnail
                    };
                    const transfer = thumbnail?.data ? [
                        thumbnail.data
                    ] : [];
                    scope.postMessage({
                        type: "success",
                        result: result
                    }, transfer);
                } catch (error) {
                    const result = {
                        svg: "",
                        thumbnail: thumbnail,
                        conversionError: errorMessage(error)
                    };
                    const transfer = thumbnail?.data ? [
                        thumbnail.data
                    ] : [];
                    scope.postMessage({
                        type: "success",
                        result: result
                    }, transfer);
                }
            } finally{
                libredwg.dwg_free(data);
            }
        } catch (error) {
            scope.postMessage({
                type: "error",
                message: errorMessage(error)
            });
        }
    };
}
function $08414ea58bdc1292$var$normalizeWorkerResult(result) {
    const thumbnail = result.thumbnail;
    return {
        ...result,
        thumbnail: thumbnail ? {
            type: thumbnail.type,
            data: thumbnail.data instanceof Uint8Array ? thumbnail.data : new Uint8Array(thumbnail.data)
        } : void 0
    };
}
function $08414ea58bdc1292$var$createAbortError() {
    const error = new Error("DWG preview was aborted.");
    error.name = "AbortError";
    return error;
}
function $08414ea58bdc1292$var$throwIfAborted(signal) {
    if (signal?.aborted) throw $08414ea58bdc1292$var$createAbortError();
}
function $08414ea58bdc1292$var$isAbortError(error) {
    return error instanceof Error && error.name === "AbortError";
}
function $08414ea58bdc1292$var$getErrorMessage(error) {
    return error instanceof Error ? error.message : String(error || "Unknown DWG error");
}
function $08414ea58bdc1292$var$loadLibreDwg() {
    $08414ea58bdc1292$var$libreDwgPromise ||= $08414ea58bdc1292$var$importOptionalModule2($08414ea58bdc1292$var$libreDwgPackageName);
    return $08414ea58bdc1292$var$libreDwgPromise;
}
function $08414ea58bdc1292$var$importOptionalModule2(packageName) {
    return new Function("packageName", "return import(packageName)")(packageName);
}
function $08414ea58bdc1292$var$createDwgStatusTitle(fileName, stats) {
    const wrapper = document.createElement("span");
    const title = document.createElement("strong");
    const note = document.createElement("small");
    title.textContent = `\u5B9E\u9A8C\u6027 DWG \u6A21\u578B\u7A7A\u95F4\u9884\u89C8 \xB7 ${fileName}`;
    note.textContent = [
        `${stats.entityCount.toLocaleString()} \u4E2A\u5B9E\u4F53`,
        `${stats.visibleLayerCount}/${stats.layerCount} \u4E2A\u53EF\u89C1\u56FE\u5C42`,
        `${stats.layoutCount} \u4E2A\u5E03\u5C40`,
        stats.paperSpaceEntityCount ? `${stats.paperSpaceEntityCount.toLocaleString()} \u4E2A\u56FE\u7EB8\u7A7A\u95F4\u5B9E\u4F53` : "\u6A21\u578B\u7A7A\u95F4\u7EBF\u7A3F",
        stats.unknownEntityCount ? `${stats.unknownEntityCount} \u4E2A\u672A\u77E5\u5B9E\u4F53` : "\u5B9E\u4F53\u89E3\u6790\u5B8C\u6574",
        stats.hasThumbnail ? "\u5305\u542B\u5185\u7F6E\u7F29\u7565\u56FE" : "\u65E0\u5185\u7F6E\u7F29\u7565\u56FE"
    ].join(" \xB7 ");
    const warning = document.createElement("small");
    warning.textContent = "\u5F53\u524D\u4E3A LibreDWG WASM \u7EBF\u7A3F\u9884\u89C8\uFF0C\u590D\u6742\u5E03\u5C40/\u6253\u5370\u7A7A\u95F4/\u5B57\u4F53/\u586B\u5145\u4E0E\u4E13\u4E1A CAD \u4ECD\u53EF\u80FD\u5B58\u5728\u5DEE\u5F02\u3002";
    wrapper.append(title, note, warning);
    return wrapper;
}
function $08414ea58bdc1292$var$createDwgThumbnailFallbackStatus(fileName, error) {
    const wrapper = document.createElement("span");
    const title = document.createElement("strong");
    title.textContent = `DWG \u5185\u7F6E\u9884\u89C8\u56FE \xB7 ${fileName}`;
    const note = document.createElement("small");
    note.textContent = "LibreDWG \u5DF2\u8BFB\u53D6\u5230\u6587\u4EF6\u5185\u7F6E\u7F29\u7565\u56FE\uFF0C\u4F46\u7EBF\u7A3F\u9884\u89C8\u672A\u80FD\u751F\u6210\uFF0C\u5DF2\u81EA\u52A8\u5207\u6362\u4E3A\u7F29\u7565\u56FE\u515C\u5E95\u3002";
    const detail = document.createElement("small");
    detail.textContent = error instanceof Error ? error.message : String(error || "\u672A\u77E5\u89E3\u6790\u9519\u8BEF");
    wrapper.append(title, note, detail);
    return wrapper;
}
function $08414ea58bdc1292$var$createDwgPreviewStats(database, unknownEntityCount, hasThumbnail) {
    const layers = database.tables.LAYER.entries;
    return {
        entityCount: database.entities.length,
        layerCount: layers.length,
        layoutCount: database.objects.LAYOUT.length,
        unknownEntityCount: unknownEntityCount,
        visibleLayerCount: layers.filter((layer)=>!layer.off && !layer.frozen).length,
        paperSpaceEntityCount: database.entities.filter((entity)=>entity.isInPaperSpace).length,
        hasThumbnail: hasThumbnail
    };
}
function $08414ea58bdc1292$var$readDwgThumbnail(libredwg, data) {
    try {
        const thumbnail = libredwg.dwg_bmp(data);
        if (!thumbnail?.data?.length) return void 0;
        return thumbnail;
    } catch  {
        return void 0;
    }
}
function $08414ea58bdc1292$var$createDwgThumbnailUrl(thumbnail) {
    if (!thumbnail) return void 0;
    if (thumbnail.type === 6) return URL.createObjectURL(new Blob([
        $08414ea58bdc1292$var$toArrayBuffer2(thumbnail.data)
    ], {
        type: "image/png"
    }));
    if (thumbnail.type === 2) return URL.createObjectURL(new Blob([
        $08414ea58bdc1292$var$toArrayBuffer2($08414ea58bdc1292$var$createBmpFileBytes(thumbnail.data))
    ], {
        type: "image/bmp"
    }));
    return void 0;
}
function $08414ea58bdc1292$var$toArrayBuffer2(bytes) {
    return bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
}
function $08414ea58bdc1292$var$createBmpFileBytes(dibBytes) {
    const view3 = new DataView(dibBytes.buffer, dibBytes.byteOffset, dibBytes.byteLength);
    const headerSize = view3.getUint32(0, true);
    const bitCount = view3.getUint16(14, true);
    const paletteBytes = bitCount <= 8 ? 2 ** bitCount * 4 : 0;
    const pixelOffset = 14 + headerSize + paletteBytes;
    const bytes = new Uint8Array(14 + dibBytes.byteLength);
    bytes[0] = 66;
    bytes[1] = 77;
    const fileView = new DataView(bytes.buffer);
    fileView.setUint32(2, bytes.byteLength, true);
    fileView.setUint32(10, pixelOffset, true);
    bytes.set(dibBytes, 14);
    return bytes;
}
function $08414ea58bdc1292$var$createDwgThumbnailPanel(thumbnailUrl) {
    const panel = document.createElement("figure");
    panel.className = "ofv-dwg-thumbnail";
    const image = document.createElement("img");
    image.src = thumbnailUrl;
    image.alt = "DWG \u6587\u4EF6\u5185\u7F6E\u7F29\u7565\u56FE";
    const caption = document.createElement("figcaption");
    caption.textContent = "\u6587\u4EF6\u5185\u7F6E\u7F29\u7565\u56FE";
    panel.append(image, caption);
    return panel;
}
function $08414ea58bdc1292$var$createDwgThumbnailPreview(thumbnailUrl, fileName) {
    const figure = document.createElement("figure");
    figure.className = "ofv-dwg-thumbnail-preview";
    const image = document.createElement("img");
    image.src = thumbnailUrl;
    image.alt = `${fileName} \u5185\u7F6E\u9884\u89C8\u56FE`;
    const caption = document.createElement("figcaption");
    caption.textContent = "DWG \u6587\u4EF6\u5185\u7F6E\u9884\u89C8\u56FE\u3002\u82E5\u9700\u8981\u63A5\u8FD1 CAD \u5E03\u5C40/\u6253\u5370\u7A7A\u95F4\u7684\u9AD8\u4FDD\u771F\u6548\u679C\uFF0C\u8BF7\u4F7F\u7528\u540C\u540D PNG\u3001SVG\u3001PDF \u5BFC\u51FA\u56FE\uFF0C\u6216\u901A\u8FC7 binaryRenderer \u63A5\u5165\u4E13\u4E1A CAD \u6E32\u67D3/\u8F6C\u6362\u670D\u52A1\u3002";
    figure.append(image, caption);
    return figure;
}
function $08414ea58bdc1292$var$normalizeDwgSvg(svgElement) {
    svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet");
    $08414ea58bdc1292$var$removeInheritedDwgFills(svgElement);
    $08414ea58bdc1292$var$focusDwgSvgOnMainDrawing(svgElement);
    const style = document.createElementNS("http://www.w3.org/2000/svg", "style");
    style.textContent = `
    .ofv-dwg-preview-svg { background: #020617; }
    .ofv-dwg-preview-svg g {
      fill: none !important;
    }
    .ofv-dwg-preview-svg line,
    .ofv-dwg-preview-svg path,
    .ofv-dwg-preview-svg polyline,
    .ofv-dwg-preview-svg polygon,
    .ofv-dwg-preview-svg circle,
    .ofv-dwg-preview-svg ellipse,
    .ofv-dwg-preview-svg rect {
      fill: none !important;
      vector-effect: non-scaling-stroke;
      stroke-width: 0.7px !important;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    .ofv-dwg-preview-svg [stroke="rgb(0,255,0)"] {
      stroke: #34d399 !important;
      stroke-opacity: 0.58 !important;
    }
    .ofv-dwg-preview-svg text {
      vector-effect: non-scaling-stroke;
      stroke-width: 0 !important;
      fill: currentColor !important;
    }
  `;
    svgElement.prepend(style);
}
function $08414ea58bdc1292$var$removeInheritedDwgFills(svgElement) {
    const shapeSelector = "line,path,polyline,polygon,circle,ellipse,rect";
    for (const group of svgElement.querySelectorAll("g[fill]"))group.setAttribute("fill", "none");
    for (const styledElement of svgElement.querySelectorAll("[style]"))styledElement.style.fill = "none";
    for (const shape of svgElement.querySelectorAll(shapeSelector))shape.setAttribute("fill", "none");
}
function $08414ea58bdc1292$var$focusDwgSvgOnMainDrawing(svgElement) {
    const originalBounds = $08414ea58bdc1292$var$readSvgViewBox(svgElement);
    const mainBounds = $08414ea58bdc1292$var$estimateMainDrawingBounds(svgElement);
    if (!originalBounds || !mainBounds || !$08414ea58bdc1292$var$shouldUseMainDrawingBounds(originalBounds, mainBounds)) return;
    const paddedBounds = $08414ea58bdc1292$var$padBounds(mainBounds, 0.05);
    svgElement.dataset.originalViewBox = $08414ea58bdc1292$var$formatViewBox(originalBounds);
    svgElement.dataset.focusViewBox = $08414ea58bdc1292$var$formatViewBox(paddedBounds);
    svgElement.setAttribute("viewBox", $08414ea58bdc1292$var$formatViewBox(paddedBounds));
}
function $08414ea58bdc1292$var$shouldUseMainDrawingBounds(original, candidate) {
    const originalAspectRatio = original.width / original.height;
    const candidateAspectRatio = candidate.width / candidate.height;
    const originalArea = original.width * original.height;
    const candidateArea = candidate.width * candidate.height;
    if (!Number.isFinite(originalArea) || !Number.isFinite(candidateArea) || candidateArea <= 0) return false;
    return originalAspectRatio > 8 || originalAspectRatio < 0.125 || candidateArea / originalArea < 0.55 || Math.abs(Math.log(originalAspectRatio / candidateAspectRatio)) > Math.log(4);
}
function $08414ea58bdc1292$var$estimateMainDrawingBounds(svgElement) {
    const points = [];
    const addPoint = (x, y)=>{
        if (Number.isFinite(x) && Number.isFinite(y) && Math.abs(x) < 1e9 && Math.abs(y) < 1e9) points.push([
            x,
            y
        ]);
    };
    for (const element of svgElement.querySelectorAll("line,path,polyline,polygon,circle,ellipse,rect,text,use")){
        if (element.closest("defs")) continue;
        $08414ea58bdc1292$var$collectElementPoints(element, addPoint);
    }
    if (points.length < 16) return void 0;
    const xs = points.map(([x])=>x).sort((a, b)=>a - b);
    const ys = points.map(([, y])=>y).sort((a, b)=>a - b);
    const minX = $08414ea58bdc1292$var$quantile(xs, 5e-3);
    const maxX = $08414ea58bdc1292$var$quantile(xs, 0.995);
    const minY = $08414ea58bdc1292$var$quantile(ys, 5e-3);
    const maxY = $08414ea58bdc1292$var$quantile(ys, 0.995);
    if (!Number.isFinite(minX) || !Number.isFinite(maxX) || !Number.isFinite(minY) || !Number.isFinite(maxY)) return void 0;
    const width = maxX - minX;
    const height = maxY - minY;
    if (width <= 0 || height <= 0) return void 0;
    return {
        minX: minX,
        minY: minY,
        width: width,
        height: height
    };
}
function $08414ea58bdc1292$var$collectElementPoints(element, addPoint) {
    const tagName = element.tagName.toLowerCase();
    if (tagName === "line") {
        addPoint($08414ea58bdc1292$var$readNumberAttribute(element, "x1"), $08414ea58bdc1292$var$readNumberAttribute(element, "y1"));
        addPoint($08414ea58bdc1292$var$readNumberAttribute(element, "x2"), $08414ea58bdc1292$var$readNumberAttribute(element, "y2"));
    } else if (tagName === "circle") {
        const cx = $08414ea58bdc1292$var$readNumberAttribute(element, "cx");
        const cy = $08414ea58bdc1292$var$readNumberAttribute(element, "cy");
        const r = $08414ea58bdc1292$var$readNumberAttribute(element, "r");
        addPoint(cx - r, cy - r);
        addPoint(cx + r, cy + r);
    } else if (tagName === "ellipse") {
        const cx = $08414ea58bdc1292$var$readNumberAttribute(element, "cx");
        const cy = $08414ea58bdc1292$var$readNumberAttribute(element, "cy");
        const rx = $08414ea58bdc1292$var$readNumberAttribute(element, "rx");
        const ry = $08414ea58bdc1292$var$readNumberAttribute(element, "ry");
        addPoint(cx - rx, cy - ry);
        addPoint(cx + rx, cy + ry);
    } else if (tagName === "rect") {
        const x = $08414ea58bdc1292$var$readNumberAttribute(element, "x");
        const y = $08414ea58bdc1292$var$readNumberAttribute(element, "y");
        addPoint(x, y);
        addPoint(x + $08414ea58bdc1292$var$readNumberAttribute(element, "width"), y + $08414ea58bdc1292$var$readNumberAttribute(element, "height"));
    } else if (tagName === "text") addPoint($08414ea58bdc1292$var$readNumberAttribute(element, "x"), $08414ea58bdc1292$var$readNumberAttribute(element, "y"));
    else if (tagName === "path") $08414ea58bdc1292$var$collectNumberPairs(element.getAttribute("d"), addPoint);
    else if (tagName === "polyline" || tagName === "polygon") $08414ea58bdc1292$var$collectNumberPairs(element.getAttribute("points"), addPoint);
    $08414ea58bdc1292$var$collectTranslatePoints(element.getAttribute("transform"), addPoint);
}
function $08414ea58bdc1292$var$collectNumberPairs(value, addPoint) {
    if (!value) return;
    const numbers = $08414ea58bdc1292$var$readNumbers(value);
    for(let index = 0; index + 1 < numbers.length; index += 2)addPoint(numbers[index], numbers[index + 1]);
}
function $08414ea58bdc1292$var$collectTranslatePoints(value, addPoint) {
    if (!value) return;
    const translatePattern = /translate\(\s*(-?\d*\.?\d+(?:e[-+]?\d+)?)(?:[\s,]+(-?\d*\.?\d+(?:e[-+]?\d+)?))?/gi;
    for (const match of value.matchAll(translatePattern))addPoint(Number(match[1]), Number(match[2] ?? 0));
}
function $08414ea58bdc1292$var$readNumbers(value) {
    const matches = value.match($08414ea58bdc1292$var$svgNumberPattern);
    return matches ? matches.map((item)=>Number(item)).filter(Number.isFinite) : [];
}
function $08414ea58bdc1292$var$readNumberAttribute(element, name) {
    const value = Number(element.getAttribute(name) ?? 0);
    return Number.isFinite(value) ? value : 0;
}
function $08414ea58bdc1292$var$quantile(values, ratio) {
    const index = Math.max(0, Math.min(values.length - 1, Math.floor((values.length - 1) * ratio)));
    return values[index];
}
function $08414ea58bdc1292$var$padBounds(bounds, ratio) {
    const paddingX = bounds.width * ratio;
    const paddingY = bounds.height * ratio;
    return {
        minX: bounds.minX - paddingX,
        minY: bounds.minY - paddingY,
        width: bounds.width + paddingX * 2,
        height: bounds.height + paddingY * 2
    };
}
function $08414ea58bdc1292$var$formatViewBox(bounds) {
    return [
        bounds.minX,
        bounds.minY,
        bounds.width,
        bounds.height
    ].map((value)=>Number(value.toFixed(4))).join(" ");
}
function $08414ea58bdc1292$var$createDwgDrawingViewport(svgElement) {
    const frame = document.createElement("div");
    frame.className = "ofv-dwg-preview-frame";
    const importedSvg = document.importNode(svgElement, true);
    frame.append(importedSvg);
    const aspectRatio = $08414ea58bdc1292$var$readSvgAspectRatio(svgElement);
    let zoom = 1;
    const update = ()=>{
        const frameWidth = Math.max(frame.clientWidth, 1);
        const readableWidth = aspectRatio ? $08414ea58bdc1292$var$minReadableDrawingHeight * aspectRatio : frameWidth;
        const width = Math.max(frameWidth, readableWidth) * zoom;
        importedSvg.style.width = `${Math.round(width)}px`;
        importedSvg.style.minWidth = `${Math.round(width)}px`;
    };
    const setZoom = (nextZoom)=>{
        zoom = Math.min(Math.max(nextZoom, 0.2), 8);
        update();
    };
    requestAnimationFrame(update);
    return {
        frame: frame,
        get zoom () {
            return zoom;
        },
        setZoom: setZoom,
        update: update
    };
}
function $08414ea58bdc1292$var$readSvgAspectRatio(svgElement) {
    const viewBox = $08414ea58bdc1292$var$readSvgViewBox(svgElement);
    return viewBox ? viewBox.width / viewBox.height : void 0;
}
function $08414ea58bdc1292$var$readSvgViewBox(svgElement) {
    const viewBox = svgElement.getAttribute("viewBox");
    if (!viewBox) return void 0;
    const [minX, minY, width, height] = viewBox.trim().split(/[\s,]+/).map((value)=>Number(value));
    if (!Number.isFinite(minX) || !Number.isFinite(minY) || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return void 0;
    return {
        minX: minX,
        minY: minY,
        width: width,
        height: height
    };
}
// src/plugins/cad-webgl.ts
var $08414ea58bdc1292$var$engineModulePromises = /* @__PURE__ */ new WeakMap();
var $08414ea58bdc1292$var$pendingDestroy = Promise.resolve();
function $08414ea58bdc1292$var$loadCadEngine(engineLoader) {
    if (!engineLoader) throw new Error('WebGL DWG preview requires webglDwg.engineLoader, for example () => import("@mlightcad/cad-simple-viewer").');
    let engineModulePromise = $08414ea58bdc1292$var$engineModulePromises.get(engineLoader);
    if (!engineModulePromise) {
        engineModulePromise = engineLoader().then($08414ea58bdc1292$var$resolveCadEngineModule);
        $08414ea58bdc1292$var$engineModulePromises.set(engineLoader, engineModulePromise);
    }
    return engineModulePromise;
}
async function $08414ea58bdc1292$var$renderWebglDwgPreview(ctx, options) {
    await $08414ea58bdc1292$var$pendingDestroy.catch(()=>void 0);
    const shell = document.createElement("div");
    shell.className = "ofv-dwg-webgl-preview";
    const stage = document.createElement("div");
    stage.className = "ofv-dwg-webgl-stage";
    shell.append(stage);
    ctx.panel.append(shell);
    let manager;
    try {
        const engine = await $08414ea58bdc1292$var$loadCadEngine(options.engineLoader);
        const workerBaseUrl = $08414ea58bdc1292$var$normalizeBaseUrl(options.workerBaseUrl);
        const workerUrls = {
            dwgParser: $08414ea58bdc1292$var$resolveRuntimeUrl(`${workerBaseUrl}/libredwg-parser-worker.js`),
            mtextRender: $08414ea58bdc1292$var$resolveRuntimeUrl(`${workerBaseUrl}/mtext-renderer-worker.js`)
        };
        manager = engine.AcApDocManager.createInstance({
            container: stage,
            autoResize: true,
            baseUrl: options.baseUrl,
            busyIndicatorHost: shell,
            builtinOpenFileDialog: false,
            preloadDefaultFonts: !(options.notLoadDefaultFonts ?? false),
            useMainThreadDraw: options.useMainThreadDraw ?? false,
            webworkerFileUrls: workerUrls
        });
        if (!manager) throw new Error("CAD rendering engine could not be initialized.");
        if ((options.checkWorkers ?? true) && !await manager.areWorkersReady()) throw new Error("DWG worker resources are unavailable.");
        ctx.preview.setLoading(false);
        const opened = await manager.openDocument(ctx.fileName, ctx.arrayBuffer.slice(0), {
            mode: engine.AcEdOpenMode.Read,
            openViewMode: engine.AcApOpenViewMode.Extents,
            progressiveRendering: options.progressiveRendering ?? true
        });
        if (!opened) throw new Error("The DWG document could not be opened.");
        manager.curView.zoomToFitDrawing();
        ctx.preview.toolbar?.setZoom(1);
    } catch (error) {
        if (manager) await manager.destroy().catch(()=>void 0);
        shell.remove();
        throw error instanceof Error ? error : new Error("DWG WebGL preview failed.");
    }
    const activeManager = manager;
    let destroyed = false;
    let toolbarZoom = 1;
    function zoom(factor) {
        const view3 = activeManager.curView;
        const camera = view3.internalCamera;
        camera.zoom = $08414ea58bdc1292$var$clamp2(camera.zoom * factor, 0.02, 64);
        camera.updateProjectionMatrix();
        view3.isDirty = true;
        toolbarZoom = $08414ea58bdc1292$var$clamp2(toolbarZoom * factor, 0.02, 64);
        ctx.preview.toolbar?.setZoom(toolbarZoom);
    }
    return {
        resize () {
            activeManager.curView.isDirty = true;
        },
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in") {
                zoom(1.22);
                return true;
            }
            if (command === "zoom-out") {
                zoom(1 / 1.22);
                return true;
            }
            if (command === "zoom-reset") {
                activeManager.curView.zoomToFitDrawing();
                toolbarZoom = 1;
                ctx.preview.toolbar?.setZoom(toolbarZoom);
                return true;
            }
            return false;
        },
        destroy () {
            if (destroyed) return;
            destroyed = true;
            ctx.preview.toolbar?.setZoom(void 0);
            shell.remove();
            $08414ea58bdc1292$var$pendingDestroy = activeManager.destroy().catch((error)=>{
                console.warn("Failed to release the DWG WebGL preview.", error);
            });
        }
    };
}
function $08414ea58bdc1292$var$resolveCadEngineModule(value) {
    const engine = value;
    if (!engine?.AcApDocManager || !engine.AcEdOpenMode || !engine.AcApOpenViewMode) throw new Error("The configured WebGL DWG engine module is invalid.");
    return engine;
}
function $08414ea58bdc1292$var$normalizeBaseUrl(value) {
    return value.replace(/\/+$/, "");
}
function $08414ea58bdc1292$var$resolveRuntimeUrl(value) {
    return new URL(value, document.baseURI).href;
}
function $08414ea58bdc1292$var$clamp2(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
var $08414ea58bdc1292$var$OASIS_MAGIC = "%SEMI-OASIS\r\n";
var $08414ea58bdc1292$var$MAX_BLOCK_BYTES = 67108864;
var $08414ea58bdc1292$var$MAX_LAYOUT_SHAPES = 12e3;
var $08414ea58bdc1292$var$MAX_REPETITIONS = 12e3;
var $08414ea58bdc1292$var$OasisCursor = class {
    constructor(bytes){
        this.bytes = bytes;
        this.offset = 0;
    }
    get remaining() {
        return this.bytes.length - this.offset;
    }
    readByte() {
        if (this.offset >= this.bytes.length) throw new Error("Unexpected end of OASIS data");
        return this.bytes[this.offset++];
    }
    readUnsigned() {
        let result = 0;
        let shift = 0;
        for(let index = 0; index < 10; index += 1){
            const byte = this.readByte();
            result += (byte & 127) * 2 ** shift;
            if ((byte & 128) === 0) {
                if (!Number.isSafeInteger(result)) throw new Error("OASIS integer exceeds the browser safe range");
                return result;
            }
            shift += 7;
        }
        throw new Error("Invalid OASIS variable-length integer");
    }
    readSigned() {
        const first = this.readByte();
        let result = (first & 127) >> 1;
        let shift = 6;
        let byte = first;
        for(let index = 0; byte & 128; index += 1){
            if (index >= 9) throw new Error("Invalid OASIS signed integer");
            byte = this.readByte();
            result += (byte & 127) * 2 ** shift;
            shift += 7;
        }
        return first & 1 ? -result : result;
    }
    readString() {
        const length = this.readUnsigned();
        if (length > this.remaining) throw new Error("Invalid OASIS string length");
        const result = new TextDecoder("utf-8", {
            fatal: false
        }).decode(this.bytes.slice(this.offset, this.offset + length));
        this.offset += length;
        return result.replace(/\0+$/g, "");
    }
    readReal(type = this.readByte()) {
        if (type === 0) return this.readUnsigned();
        if (type === 1) return -this.readUnsigned();
        if (type === 2) return 1 / this.readUnsigned();
        if (type === 3) return -1 / this.readUnsigned();
        if (type === 4 || type === 5) {
            const value = this.readUnsigned() / this.readUnsigned();
            return type === 5 ? -value : value;
        }
        if (type === 6) {
            if (this.remaining < 4) throw new Error("Invalid OASIS float");
            const value = new DataView(this.bytes.buffer, this.bytes.byteOffset + this.offset, 4).getFloat32(0, true);
            this.offset += 4;
            return value;
        }
        if (type === 7) {
            if (this.remaining < 8) throw new Error("Invalid OASIS double");
            const value = new DataView(this.bytes.buffer, this.bytes.byteOffset + this.offset, 8).getFloat64(0, true);
            this.offset += 8;
            return value;
        }
        throw new Error(`Unsupported OASIS real type ${type}`);
    }
};
function $08414ea58bdc1292$var$parseBinaryOasis(bytes) {
    const header = new TextDecoder("ascii").decode(bytes.slice(0, $08414ea58bdc1292$var$OASIS_MAGIC.length));
    if (header !== $08414ea58bdc1292$var$OASIS_MAGIC || bytes[$08414ea58bdc1292$var$OASIS_MAGIC.length] !== 1) return void 0;
    const headerCursor = new $08414ea58bdc1292$var$OasisCursor(bytes);
    headerCursor.offset = $08414ea58bdc1292$var$OASIS_MAGIC.length + 1;
    let version = "OASIS";
    let unit;
    try {
        version = headerCursor.readString() || version;
        unit = headerCursor.readReal();
    } catch  {}
    const blocks = $08414ea58bdc1292$var$extractCompressedBlocks(bytes);
    const state = $08414ea58bdc1292$var$createOasisState();
    for (const block of blocks)$08414ea58bdc1292$var$parseOasisRecordStream(block.bytes, state);
    $08414ea58bdc1292$var$resolveOasisNames(state);
    if (blocks.length === 0 || state.shapes.length === 0 && state.labels.length === 0 && state.references.length === 0) return void 0;
    if (state.unsupportedRecords.size > 0) state.warnings.push(`\u672A\u5C55\u5F00\u7684 OASIS \u8BB0\u5F55\u7C7B\u578B\uFF1A${[
        ...state.unsupportedRecords
    ].sort((a, b)=>a - b).join("\u3001")}\u3002`);
    if (state.truncated) state.warnings.push(`\u7248\u56FE\u51E0\u4F55\u8D85\u8FC7 ${$08414ea58bdc1292$var$MAX_LAYOUT_SHAPES} \u4E2A\uFF0C\u5DF2\u622A\u65AD\u4EE5\u4FDD\u62A4\u6D4F\u89C8\u5668\u5185\u5B58\u3002`);
    return {
        version: version,
        unit: unit,
        cells: $08414ea58bdc1292$var$unique([
            ...state.cells.map((cell)=>$08414ea58bdc1292$var$resolveName(cell, state.cellNames)),
            ...state.cellNames.values(),
            ...state.shapes.map((shape)=>shape.cell || ""),
            ...state.labels.map((label)=>label.cell || ""),
            ...state.references.flatMap((reference)=>[
                    reference.ownerCell || "",
                    reference.cell
                ])
        ]),
        shapes: state.shapes,
        labels: state.labels,
        references: state.references,
        placementRecordCount: state.placementRecordCount,
        compressedBlockCount: blocks.length,
        recordCount: state.recordCount,
        warnings: state.warnings
    };
}
function $08414ea58bdc1292$var$createOasisState() {
    return {
        absolute: true,
        currentCell: "TOP",
        cellNames: /* @__PURE__ */ new Map(),
        nextCellName: 0,
        textNames: /* @__PURE__ */ new Map(),
        nextTextName: 0,
        modalLayer: 0,
        modalDatatype: 0,
        modalTextLayer: 0,
        modalTextType: 0,
        modalGeometry: {
            x: 0,
            y: 0
        },
        modalGeometrySize: {
            x: 0,
            y: 0
        },
        modalPlacement: {
            x: 0,
            y: 0
        },
        modalText: {
            x: 0,
            y: 0
        },
        modalPolygon: [
            {
                x: 0,
                y: 0
            }
        ],
        modalPath: [
            {
                x: 0,
                y: 0
            }
        ],
        modalPathWidth: 0,
        modalRepetition: [
            {
                x: 0,
                y: 0
            }
        ],
        shapes: [],
        labels: [],
        references: [],
        placementRecordCount: 0,
        cells: [],
        warnings: [],
        unsupportedRecords: /* @__PURE__ */ new Set(),
        recordCount: 0,
        truncated: false
    };
}
function $08414ea58bdc1292$var$extractCompressedBlocks(bytes) {
    const blocks = [];
    let occupiedUntil = 0;
    for(let offset = $08414ea58bdc1292$var$OASIS_MAGIC.length; offset < bytes.length; offset += 1){
        if (offset < occupiedUntil || bytes[offset] !== 34) continue;
        try {
            const cursor = new $08414ea58bdc1292$var$OasisCursor(bytes);
            cursor.offset = offset + 1;
            const method = cursor.readUnsigned();
            const expandedLength = cursor.readUnsigned();
            const compressedLength = cursor.readUnsigned();
            if (method !== 0 || expandedLength <= 0 || expandedLength > $08414ea58bdc1292$var$MAX_BLOCK_BYTES || compressedLength <= 0 || compressedLength > cursor.remaining) continue;
            const end = cursor.offset + compressedLength;
            const inflated = (0, $cab713332464fe22$export$2e2bcd8739ae039).inflateRaw(bytes.slice(cursor.offset, end));
            if (inflated.byteLength !== expandedLength) continue;
            blocks.push({
                offset: offset,
                bytes: inflated
            });
            occupiedUntil = end;
            offset = end - 1;
        } catch  {}
    }
    return blocks;
}
function $08414ea58bdc1292$var$parseOasisRecordStream(bytes, state) {
    const cursor = new $08414ea58bdc1292$var$OasisCursor(bytes);
    while(cursor.remaining > 0){
        const recordOffset = cursor.offset;
        try {
            const record = cursor.readByte();
            state.recordCount += 1;
            if (record === 0) continue;
            if (record === 2) return;
            if (record === 3 || record === 4) {
                const name = cursor.readString();
                const index = record === 4 ? cursor.readUnsigned() : state.nextCellName;
                state.cellNames.set(index, name);
                state.nextCellName = Math.max(state.nextCellName, index + 1);
                continue;
            }
            if (record === 5 || record === 6) {
                const value = cursor.readString();
                const index = record === 6 ? cursor.readUnsigned() : state.nextTextName;
                state.textNames.set(index, value);
                state.nextTextName = Math.max(state.nextTextName, index + 1);
                continue;
            }
            if (record >= 7 && record <= 10) {
                cursor.readString();
                if (record === 8 || record === 10) cursor.readUnsigned();
                continue;
            }
            if (record === 13 || record === 14) {
                state.currentCell = record === 13 ? $08414ea58bdc1292$var$referenceName(cursor.readUnsigned()) : cursor.readString();
                state.cells.push(state.currentCell);
                state.absolute = true;
                state.modalPlacement = {
                    x: 0,
                    y: 0
                };
                state.modalGeometry = {
                    x: 0,
                    y: 0
                };
                state.modalText = {
                    x: 0,
                    y: 0
                };
                continue;
            }
            if (record === 15 || record === 16) {
                state.absolute = record === 15;
                continue;
            }
            if (record === 17 || record === 18) {
                $08414ea58bdc1292$var$readPlacement(cursor, state, record === 18);
                continue;
            }
            if (record === 19) {
                $08414ea58bdc1292$var$readText2(cursor, state);
                continue;
            }
            if (record === 20) {
                $08414ea58bdc1292$var$readRectangle(cursor, state);
                continue;
            }
            if (record === 21) {
                $08414ea58bdc1292$var$readPolygon(cursor, state);
                continue;
            }
            if (record === 22) {
                $08414ea58bdc1292$var$readPath(cursor, state);
                continue;
            }
            if (record === 28 || record === 29) {
                $08414ea58bdc1292$var$skipProperty(cursor, record === 29);
                continue;
            }
            if (record === 30 || record === 31 || record === 32) {
                cursor.readUnsigned();
                cursor.readString();
                if (record === 31) cursor.readUnsigned();
                state.unsupportedRecords.add(record);
                continue;
            }
            state.unsupportedRecords.add(record);
            return;
        } catch (error) {
            state.warnings.push(`OASIS \u8BB0\u5F55\u5728\u5757\u5185 ${recordOffset} \u5B57\u8282\u5904\u89E3\u6790\u5931\u8D25\uFF1A${error instanceof Error ? error.message : String(error)}`);
            return;
        }
    }
}
function $08414ea58bdc1292$var$readPlacement(cursor, state, transformed) {
    state.placementRecordCount += 1;
    const info = cursor.readByte();
    if (info & 128) state.modalPlacementCell = info & 64 ? $08414ea58bdc1292$var$referenceName(cursor.readUnsigned()) : cursor.readString();
    if (!state.modalPlacementCell) throw new Error("Placement record has no cell reference");
    if (transformed) {
        if (info & 4) cursor.readReal();
        if (info & 2) cursor.readReal();
    }
    $08414ea58bdc1292$var$updateModalPoint(cursor, state.modalPlacement, state.absolute, Boolean(info & 32), Boolean(info & 16));
    const repetitions = info & 8 ? $08414ea58bdc1292$var$readRepetition(cursor, state) : [
        {
            x: 0,
            y: 0
        }
    ];
    for (const offset of repetitions)state.references.push({
        ownerCell: state.currentCell,
        cell: state.modalPlacementCell,
        x: state.modalPlacement.x + offset.x,
        y: state.modalPlacement.y + offset.y
    });
}
function $08414ea58bdc1292$var$readText2(cursor, state) {
    const info = cursor.readByte();
    if (info & 64) state.modalTextValue = info & 32 ? $08414ea58bdc1292$var$textReference(cursor.readUnsigned()) : cursor.readString();
    if (info & 1) state.modalTextLayer = cursor.readUnsigned();
    if (info & 2) state.modalTextType = cursor.readUnsigned();
    $08414ea58bdc1292$var$updateModalPoint(cursor, state.modalText, state.absolute, Boolean(info & 16), Boolean(info & 8));
    const repetitions = info & 4 ? $08414ea58bdc1292$var$readRepetition(cursor, state) : [
        {
            x: 0,
            y: 0
        }
    ];
    if (!state.modalTextValue) return;
    for (const offset of repetitions)state.labels.push({
        cell: state.currentCell,
        layer: String(state.modalTextLayer),
        text: state.modalTextValue,
        x: state.modalText.x + offset.x,
        y: state.modalText.y + offset.y
    });
}
function $08414ea58bdc1292$var$readRectangle(cursor, state) {
    const info = cursor.readByte();
    if (info & 1) state.modalLayer = cursor.readUnsigned();
    if (info & 2) state.modalDatatype = cursor.readUnsigned();
    if (info & 64) state.modalGeometrySize.x = cursor.readUnsigned();
    if (info & 32) state.modalGeometrySize.y = cursor.readUnsigned();
    else if (info & 128) state.modalGeometrySize.y = state.modalGeometrySize.x;
    $08414ea58bdc1292$var$updateModalPoint(cursor, state.modalGeometry, state.absolute, Boolean(info & 16), Boolean(info & 8));
    const repetitions = info & 4 ? $08414ea58bdc1292$var$readRepetition(cursor, state) : [
        {
            x: 0,
            y: 0
        }
    ];
    for (const offset of repetitions){
        const x = state.modalGeometry.x + offset.x;
        const y = state.modalGeometry.y + offset.y;
        $08414ea58bdc1292$var$addShape(state, {
            kind: "box",
            cell: state.currentCell,
            layer: String(state.modalLayer),
            datatype: String(state.modalDatatype),
            points: [
                [
                    x,
                    y
                ],
                [
                    x + state.modalGeometrySize.x,
                    y
                ],
                [
                    x + state.modalGeometrySize.x,
                    y + state.modalGeometrySize.y
                ],
                [
                    x,
                    y + state.modalGeometrySize.y
                ],
                [
                    x,
                    y
                ]
            ]
        });
    }
}
function $08414ea58bdc1292$var$readPolygon(cursor, state) {
    const info = cursor.readByte();
    if (info & 1) state.modalLayer = cursor.readUnsigned();
    if (info & 2) state.modalDatatype = cursor.readUnsigned();
    if (info & 32) state.modalPolygon = $08414ea58bdc1292$var$readPointList(cursor, true);
    $08414ea58bdc1292$var$updateModalPoint(cursor, state.modalGeometry, state.absolute, Boolean(info & 16), Boolean(info & 8));
    const repetitions = info & 4 ? $08414ea58bdc1292$var$readRepetition(cursor, state) : [
        {
            x: 0,
            y: 0
        }
    ];
    for (const offset of repetitions)$08414ea58bdc1292$var$addShape(state, {
        kind: "boundary",
        cell: state.currentCell,
        layer: String(state.modalLayer),
        datatype: String(state.modalDatatype),
        points: state.modalPolygon.map((point)=>[
                point.x + state.modalGeometry.x + offset.x,
                point.y + state.modalGeometry.y + offset.y
            ])
    });
}
function $08414ea58bdc1292$var$readPath(cursor, state) {
    const info = cursor.readByte();
    if (info & 1) state.modalLayer = cursor.readUnsigned();
    if (info & 2) state.modalDatatype = cursor.readUnsigned();
    if (info & 64) state.modalPathWidth = cursor.readUnsigned() * 2;
    if (info & 128) {
        const extension = cursor.readByte();
        if ((extension & 12) === 12) cursor.readSigned();
        if ((extension & 3) === 3) cursor.readSigned();
    }
    if (info & 32) state.modalPath = $08414ea58bdc1292$var$readPointList(cursor, false);
    $08414ea58bdc1292$var$updateModalPoint(cursor, state.modalGeometry, state.absolute, Boolean(info & 16), Boolean(info & 8));
    const repetitions = info & 4 ? $08414ea58bdc1292$var$readRepetition(cursor, state) : [
        {
            x: 0,
            y: 0
        }
    ];
    for (const offset of repetitions)$08414ea58bdc1292$var$addShape(state, {
        kind: "path",
        cell: state.currentCell,
        layer: String(state.modalLayer),
        datatype: String(state.modalDatatype),
        width: state.modalPathWidth,
        points: state.modalPath.map((point)=>[
                point.x + state.modalGeometry.x + offset.x,
                point.y + state.modalGeometry.y + offset.y
            ])
    });
}
function $08414ea58bdc1292$var$updateModalPoint(cursor, modal, absolute, hasX, hasY) {
    if (hasX) {
        const value = cursor.readSigned();
        modal.x = absolute ? value : modal.x + value;
    }
    if (hasY) {
        const value = cursor.readSigned();
        modal.y = absolute ? value : modal.y + value;
    }
}
function $08414ea58bdc1292$var$readPointList(cursor, closed) {
    const type = cursor.readByte();
    const count = cursor.readUnsigned();
    const points = [
        {
            x: 0,
            y: 0
        }
    ];
    let horizontal = type === 0;
    let accumulated = {
        x: 0,
        y: 0
    };
    for(let index = 0; index < count; index += 1){
        let delta;
        if (type === 0 || type === 1) {
            const value = cursor.readSigned();
            delta = horizontal ? {
                x: value,
                y: 0
            } : {
                x: 0,
                y: value
            };
            horizontal = !horizontal;
        } else if (type === 2) delta = $08414ea58bdc1292$var$readDirectionalDelta(cursor, 2);
        else if (type === 3) delta = $08414ea58bdc1292$var$readDirectionalDelta(cursor, 3);
        else {
            delta = $08414ea58bdc1292$var$readGeneralDelta(cursor);
            if (type === 5) {
                accumulated = {
                    x: accumulated.x + delta.x,
                    y: accumulated.y + delta.y
                };
                delta = accumulated;
            }
        }
        const previous = points[points.length - 1];
        points.push({
            x: previous.x + delta.x,
            y: previous.y + delta.y
        });
    }
    if (closed && points.length > 2) points.push({
        ...points[0]
    });
    return points;
}
function $08414ea58bdc1292$var$readDirectionalDelta(cursor, directionBits) {
    const { value: value, bits: bits } = $08414ea58bdc1292$var$readPackedInteger(cursor, directionBits);
    const directions = [
        {
            x: 1,
            y: 0
        },
        {
            x: 0,
            y: 1
        },
        {
            x: -1,
            y: 0
        },
        {
            x: 0,
            y: -1
        },
        {
            x: 1,
            y: 1
        },
        {
            x: -1,
            y: 1
        },
        {
            x: -1,
            y: -1
        },
        {
            x: 1,
            y: -1
        }
    ];
    const direction = directions[bits] || {
        x: 0,
        y: 0
    };
    return {
        x: direction.x * value,
        y: direction.y * value
    };
}
function $08414ea58bdc1292$var$readGeneralDelta(cursor) {
    const peek = cursor.bytes[cursor.offset];
    if ((peek & 1) === 0) {
        const packed = $08414ea58bdc1292$var$readPackedInteger(cursor, 4);
        const direction = packed.bits >> 1 & 7;
        const vectors = [
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            },
            {
                x: -1,
                y: 0
            },
            {
                x: 0,
                y: -1
            },
            {
                x: 1,
                y: 1
            },
            {
                x: -1,
                y: 1
            },
            {
                x: -1,
                y: -1
            },
            {
                x: 1,
                y: -1
            }
        ];
        const vector = vectors[direction];
        return {
            x: vector.x * packed.value,
            y: vector.y * packed.value
        };
    }
    const x = $08414ea58bdc1292$var$readPackedInteger(cursor, 2);
    const y = $08414ea58bdc1292$var$readPackedInteger(cursor, 1);
    return {
        x: x.bits & 2 ? -x.value : x.value,
        y: y.bits & 1 ? -y.value : y.value
    };
}
function $08414ea58bdc1292$var$readPackedInteger(cursor, skipBits) {
    const first = cursor.readByte();
    let value = (first & 127) >> skipBits;
    let shift = 7 - skipBits;
    let byte = first;
    while(byte & 128){
        byte = cursor.readByte();
        value += (byte & 127) * 2 ** shift;
        shift += 7;
    }
    return {
        value: value,
        bits: first & (1 << skipBits) - 1
    };
}
function $08414ea58bdc1292$var$readRepetition(cursor, state) {
    const type = cursor.readByte();
    if (type === 0) return state.modalRepetition.map((point)=>({
            ...point
        }));
    const result = [
        {
            x: 0,
            y: 0
        }
    ];
    if (type === 1) {
        const columns = 2 + cursor.readUnsigned();
        const rows = 2 + cursor.readUnsigned();
        const dx = cursor.readUnsigned();
        const dy = cursor.readUnsigned();
        for(let column = 0; column < columns; column += 1){
            for(let row = 0; row < rows; row += 1)if (column || row) result.push({
                x: column * dx,
                y: row * dy
            });
        }
    } else if (type === 2 || type === 3) {
        const count = 2 + cursor.readUnsigned();
        const spacing = cursor.readUnsigned();
        for(let index = 1; index < count; index += 1)result.push(type === 2 ? {
            x: index * spacing,
            y: 0
        } : {
            x: 0,
            y: index * spacing
        });
    } else if (type >= 4 && type <= 7) {
        const count = 1 + cursor.readUnsigned();
        const grid = type === 5 || type === 7 ? cursor.readUnsigned() : 1;
        let value = 0;
        for(let index = 0; index < count; index += 1){
            value += grid * cursor.readUnsigned();
            result.push(type <= 5 ? {
                x: value,
                y: 0
            } : {
                x: 0,
                y: value
            });
        }
    } else if (type === 8) {
        const columns = 2 + cursor.readUnsigned();
        const rows = 2 + cursor.readUnsigned();
        const column = $08414ea58bdc1292$var$readGeneralDelta(cursor);
        const row = $08414ea58bdc1292$var$readGeneralDelta(cursor);
        for(let x = 0; x < columns; x += 1){
            for(let y = 0; y < rows; y += 1)if (x || y) result.push({
                x: x * column.x + y * row.x,
                y: x * column.y + y * row.y
            });
        }
    } else if (type === 9) {
        const count = 2 + cursor.readUnsigned();
        const vector = $08414ea58bdc1292$var$readGeneralDelta(cursor);
        for(let index = 1; index < count; index += 1)result.push({
            x: index * vector.x,
            y: index * vector.y
        });
    } else if (type === 10 || type === 11) {
        const count = 1 + cursor.readUnsigned();
        const grid = type === 11 ? cursor.readUnsigned() : 1;
        let value = {
            x: 0,
            y: 0
        };
        for(let index = 0; index < count; index += 1){
            const delta = $08414ea58bdc1292$var$readGeneralDelta(cursor);
            value = {
                x: value.x + grid * delta.x,
                y: value.y + grid * delta.y
            };
            result.push({
                ...value
            });
        }
    } else throw new Error(`Unsupported OASIS repetition type ${type}`);
    state.modalRepetition = result.slice(0, $08414ea58bdc1292$var$MAX_REPETITIONS);
    return state.modalRepetition.map((point)=>({
            ...point
        }));
}
function $08414ea58bdc1292$var$skipProperty(cursor, useModalValues) {
    const info = useModalValues ? 8 : cursor.readByte();
    if (info & 4) {
        if (info & 2) cursor.readUnsigned();
        else cursor.readString();
    }
    if (info & 8) return;
    let count = info >> 4;
    if (count === 15) count = cursor.readUnsigned();
    for(let index = 0; index < count; index += 1){
        const type = cursor.readByte();
        if (type <= 7) cursor.readReal(type);
        else if (type === 8) cursor.readUnsigned();
        else if (type === 9) cursor.readSigned();
        else if (type >= 10 && type <= 12) cursor.readString();
        else if (type >= 13 && type <= 15) cursor.readUnsigned();
        else throw new Error(`Unsupported OASIS property type ${type}`);
    }
}
function $08414ea58bdc1292$var$addShape(state, shape) {
    if (state.shapes.length >= $08414ea58bdc1292$var$MAX_LAYOUT_SHAPES) {
        state.truncated = true;
        return;
    }
    state.shapes.push(shape);
}
function $08414ea58bdc1292$var$resolveOasisNames(state) {
    for (const shape of state.shapes)if (shape.cell) shape.cell = $08414ea58bdc1292$var$resolveName(shape.cell, state.cellNames);
    for (const label of state.labels){
        if (label.cell) label.cell = $08414ea58bdc1292$var$resolveName(label.cell, state.cellNames);
        label.text = $08414ea58bdc1292$var$resolveText(label.text, state.textNames);
    }
    for (const reference of state.references){
        if (reference.ownerCell) reference.ownerCell = $08414ea58bdc1292$var$resolveName(reference.ownerCell, state.cellNames);
        reference.cell = $08414ea58bdc1292$var$resolveName(reference.cell, state.cellNames);
    }
}
function $08414ea58bdc1292$var$referenceName(index) {
    return `@cell:${index}`;
}
function $08414ea58bdc1292$var$textReference(index) {
    return `@text:${index}`;
}
function $08414ea58bdc1292$var$resolveName(value, names) {
    const match = /^@cell:(\d+)$/.exec(value);
    return match ? names.get(Number(match[1])) || `CELL_${match[1]}` : value;
}
function $08414ea58bdc1292$var$resolveText(value, names) {
    const match = /^@text:(\d+)$/.exec(value);
    return match ? names.get(Number(match[1])) || `TEXT_${match[1]}` : value;
}
function $08414ea58bdc1292$var$unique(values) {
    return [
        ...new Set(values.filter(Boolean))
    ];
}
// src/plugins/cad.ts
var $08414ea58bdc1292$var$cadExtensions = /* @__PURE__ */ new Set([
    "dxf",
    "dwg",
    "dwf",
    "step",
    "stp",
    "iges",
    "igs",
    "ifc",
    "sat",
    "sab",
    "x_t",
    "x_b",
    "3dm",
    "skp",
    "sldprt",
    "sldasm",
    "gds",
    "gdsii",
    "oas",
    "oasis"
]);
var $08414ea58bdc1292$var$cadMimeTypes = /* @__PURE__ */ new Set([
    "application/acad",
    "application/dxf",
    "application/x-dxf",
    "image/vnd.dxf",
    "model/vnd.dwf",
    "model/step",
    "application/step",
    "application/iges",
    "application/x-step",
    "application/sat",
    "application/sab",
    "application/x-parasolid",
    "model/vnd.3dm",
    "application/vnd.sketchup.skp",
    "application/sldworks",
    "application/vnd.gds",
    "application/x-gdsii",
    "application/gdsii",
    "application/vnd.oasis.layout",
    "application/x-oasis-layout"
]);
var $08414ea58bdc1292$var$cadMimeFormatMap = {
    "application/acad": "dwg",
    "application/dxf": "dxf",
    "application/x-dxf": "dxf",
    "image/vnd.dxf": "dxf",
    "model/vnd.dwf": "dwf",
    "model/step": "step",
    "application/step": "step",
    "application/iges": "iges",
    "application/x-step": "ifc",
    "application/sat": "sat",
    "application/sab": "sab",
    "application/x-parasolid": "x_t",
    "model/vnd.3dm": "3dm",
    "application/vnd.sketchup.skp": "skp",
    "application/sldworks": "sldprt",
    "application/vnd.gds": "gds",
    "application/x-gdsii": "gds",
    "application/gdsii": "gds",
    "application/vnd.oasis.layout": "oas",
    "application/x-oasis-layout": "oas"
};
function $08414ea58bdc1292$export$891217d628dfea84(options = {}) {
    return {
        name: "cad",
        match (file) {
            return $08414ea58bdc1292$var$cadExtensions.has(file.extension) || $08414ea58bdc1292$var$cadMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-cad");
            ctx.viewport.append(panel);
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$cadMimeFormatMap);
            if (extension === "step" || extension === "stp") {
                const viewer2 = $08414ea58bdc1292$var$renderStep(panel, await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file), extension, ctx);
                return $08414ea58bdc1292$var$createCadInstance(panel, viewer2);
            }
            if (extension === "iges" || extension === "igs") {
                const viewer2 = $08414ea58bdc1292$var$renderIges(panel, await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file), extension, ctx);
                return $08414ea58bdc1292$var$createCadInstance(panel, viewer2);
            }
            if (extension === "ifc") {
                $08414ea58bdc1292$var$renderIfc(panel, await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file));
                return {
                    destroy: ()=>panel.remove()
                };
            }
            if (extension === "sat") {
                const viewer2 = $08414ea58bdc1292$var$renderAcisSat(panel, await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file), extension, ctx);
                return $08414ea58bdc1292$var$createCadInstance(panel, viewer2);
            }
            if (extension === "x_t") {
                const viewer2 = $08414ea58bdc1292$var$renderParasolidText(panel, await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file), extension, ctx);
                return $08414ea58bdc1292$var$createCadInstance(panel, viewer2);
            }
            if (extension === "dwg" || extension === "dwf") {
                const arrayBuffer = await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file);
                const bytes = new Uint8Array(arrayBuffer);
                const binaryContext = {
                    panel: panel,
                    fileName: ctx.file.name,
                    extension: extension,
                    arrayBuffer: arrayBuffer,
                    bytes: bytes,
                    preview: ctx
                };
                const enhancedInstance = await options.binaryRenderer?.({
                    ...binaryContext
                });
                if (enhancedInstance) return $08414ea58bdc1292$var$wrapCadPreviewInstance(panel, enhancedInstance);
                if (extension === "dwg" && typeof options.webglDwg === "object") {
                    const webglInstance = await $08414ea58bdc1292$var$renderWebglDwgPreview(binaryContext, options.webglDwg);
                    return $08414ea58bdc1292$var$wrapCadPreviewInstance(panel, webglInstance);
                }
                if (extension === "dwg" && options.libreDwg !== false) {
                    const libreDwgInstance = await $08414ea58bdc1292$var$renderLibreDwgPreview(binaryContext, typeof options.libreDwg === "object" ? options.libreDwg : void 0);
                    if (libreDwgInstance) return $08414ea58bdc1292$var$wrapCadPreviewInstance(panel, libreDwgInstance);
                }
                $08414ea58bdc1292$var$renderBinaryCad(panel, bytes, extension, ctx.file.name);
                return {
                    destroy: ()=>panel.remove()
                };
            }
            if (extension === "gds" || extension === "gdsii") {
                const viewer2 = $08414ea58bdc1292$var$renderLayoutPreview(panel, $08414ea58bdc1292$var$parseGdsLayout(new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file)), ctx.file.name), ctx);
                return {
                    canCommand (command) {
                        return viewer2.canCommand(command);
                    },
                    command (command) {
                        return viewer2.command(command);
                    },
                    destroy () {
                        viewer2.destroy();
                        panel.remove();
                    }
                };
            }
            if (extension === "oas" || extension === "oasis") {
                const viewer2 = $08414ea58bdc1292$var$renderLayoutPreview(panel, $08414ea58bdc1292$var$parseOasisLayout(new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file)), ctx.file.name), ctx);
                return {
                    canCommand (command) {
                        return viewer2.canCommand(command);
                    },
                    command (command) {
                        return viewer2.command(command);
                    },
                    destroy () {
                        viewer2.destroy();
                        panel.remove();
                    }
                };
            }
            if (extension !== "dxf") {
                const section = $08414ea58bdc1292$var$createUnsupportedCadSection(extension, ctx.file.name);
                panel.append(section);
                return {
                    destroy: ()=>panel.remove()
                };
            }
            const dxf = await (0, $3438a2478d5b847f$export$177308921a610223)(ctx.file);
            const viewer = $08414ea58bdc1292$var$renderDxf(panel, dxf, ctx);
            return {
                canCommand (command) {
                    return viewer.canCommand(command);
                },
                command (command) {
                    return viewer.command(command);
                },
                destroy () {
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$wrapCadPreviewInstance(panel, instance) {
    return {
        resize (size) {
            instance.resize?.(size);
        },
        canCommand (command) {
            return instance.canCommand?.(command) ?? false;
        },
        command (command) {
            return instance.command?.(command);
        },
        preparePrint () {
            return instance.preparePrint?.();
        },
        destroy () {
            instance.destroy();
            panel.remove();
        }
    };
}
function $08414ea58bdc1292$var$createCadInstance(panel, viewer) {
    return {
        canCommand (command) {
            return viewer?.canCommand(command) ?? false;
        },
        command (command) {
            return viewer?.command(command) ?? false;
        },
        destroy () {
            viewer?.destroy();
            panel.remove();
        }
    };
}
function $08414ea58bdc1292$var$renderStep(panel, text, extension, ctx) {
    const records = $08414ea58bdc1292$var$parseStepRecords(text);
    const typeCounts = $08414ea58bdc1292$var$countBy(records.map((record)=>record.type));
    const geometry = $08414ea58bdc1292$var$createCadGeometryPreview($08414ea58bdc1292$var$extractStepGeometry(records), "STEP \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8");
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(geometry ? `${extension.toUpperCase()} \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8` : `${extension.toUpperCase()} \u7ED3\u6784\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u63D0\u53D6 STEP \u6587\u672C\u5B9E\u4F53\u3001\u7C7B\u578B\u7EDF\u8BA1\u548C\u5173\u952E\u51E0\u4F55\u53C2\u6570\u3002\u7CBE\u786E B-Rep/\u66F2\u9762\u6E32\u67D3\u5EFA\u8BAE\u540E\u7EED\u63A5\u5165 CAD \u5185\u6838\u6216\u670D\u52A1\u7AEF\u8F6C\u6362\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53", records.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7C7B\u578B", typeCounts.size);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u70B9", typeCounts.get("CARTESIAN_POINT") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u65B9\u5411", typeCounts.get("DIRECTION") || 0);
    const typeList = $08414ea58bdc1292$var$createCadTypeList(typeCounts);
    section.append(note, meta, typeList);
    let viewer;
    if (geometry) {
        $08414ea58bdc1292$var$hideSuccessfulSectionHeading3(section);
        $08414ea58bdc1292$var$hideSupplementalInfo7(note);
        $08414ea58bdc1292$var$hideSupplementalInfo7(meta);
        $08414ea58bdc1292$var$hideSupplementalInfo7(typeList);
        section.append(geometry.element);
        viewer = $08414ea58bdc1292$var$createGeometryViewer(geometry.svg, geometry.bounds, ctx);
    }
    const table = $08414ea58bdc1292$var$createCadEntityTable(records.slice(0, 200).map((record)=>({
            id: record.id,
            type: record.type,
            detail: $08414ea58bdc1292$var$summarizeStepRecord(record)
        })));
    if (geometry) $08414ea58bdc1292$var$hideSupplementalInfo7(table);
    section.append(table);
    panel.append(section);
    return viewer;
}
function $08414ea58bdc1292$var$renderIges(panel, text, extension, ctx) {
    const records = $08414ea58bdc1292$var$parseIgesRecords(text);
    const typeCounts = $08414ea58bdc1292$var$countBy(records.map((record)=>record.type));
    const geometry = $08414ea58bdc1292$var$createCadGeometryPreview($08414ea58bdc1292$var$extractIgesGeometry(records), "IGES \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8");
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(geometry ? `${extension.toUpperCase()} \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8` : `${extension.toUpperCase()} \u7ED3\u6784\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u63D0\u53D6 IGES \u53C2\u6570\u533A\u5B9E\u4F53\u3001\u7C7B\u578B\u7EDF\u8BA1\u548C\u57FA\u7840\u53C2\u6570\u3002\u7CBE\u786E\u66F2\u7EBF/\u66F2\u9762\u6E32\u67D3\u5EFA\u8BAE\u540E\u7EED\u63A5\u5165 CAD \u5185\u6838\u6216\u670D\u52A1\u7AEF\u8F6C\u6362\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53", records.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7C7B\u578B", typeCounts.size);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u70B9\u5B9E\u4F53", typeCounts.get("116") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7EBF\u5B9E\u4F53", typeCounts.get("110") || 0);
    const typeList = $08414ea58bdc1292$var$createCadTypeList(typeCounts, "\u7C7B\u578B\u53F7\u7EDF\u8BA1");
    section.append(note, meta, typeList);
    let viewer;
    if (geometry) {
        $08414ea58bdc1292$var$hideSuccessfulSectionHeading3(section);
        $08414ea58bdc1292$var$hideSupplementalInfo7(note);
        $08414ea58bdc1292$var$hideSupplementalInfo7(meta);
        $08414ea58bdc1292$var$hideSupplementalInfo7(typeList);
        section.append(geometry.element);
        viewer = $08414ea58bdc1292$var$createGeometryViewer(geometry.svg, geometry.bounds, ctx);
    }
    const table = $08414ea58bdc1292$var$createCadEntityTable(records.slice(0, 200).map((record, index)=>({
            id: String(index + 1),
            type: $08414ea58bdc1292$var$igesTypeName(record.type),
            detail: record.params.slice(0, 8).join(", ")
        })));
    if (geometry) $08414ea58bdc1292$var$hideSupplementalInfo7(table);
    section.append(table);
    panel.append(section);
    return viewer;
}
function $08414ea58bdc1292$var$renderIfc(panel, text) {
    const records = $08414ea58bdc1292$var$parseStepRecords(text);
    const typeCounts = $08414ea58bdc1292$var$countBy(records.map((record)=>record.type));
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("IFC BIM \u7ED3\u6784\u9884\u89C8");
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u63D0\u53D6 IFC STEP \u5B9E\u4F53\u3001BIM \u5C42\u7EA7\u548C\u5E38\u89C1\u6784\u4EF6\u7EDF\u8BA1\u3002\u51E0\u4F55\u7F51\u683C\u3001\u6750\u8D28\u548C\u5C5E\u6027\u96C6\u53EF\u540E\u7EED\u63A5\u5165 IfcOpenShell/IFC.js \u589E\u5F3A\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53", records.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7C7B\u578B", typeCounts.size);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u9879\u76EE", typeCounts.get("IFCPROJECT") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5EFA\u7B51", typeCounts.get("IFCBUILDING") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u697C\u5C42", typeCounts.get("IFCBUILDINGSTOREY") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7A7A\u95F4", typeCounts.get("IFCSPACE") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u6784\u4EF6", $08414ea58bdc1292$var$countIfcElements(typeCounts));
    section.append(note, meta, $08414ea58bdc1292$var$createCadTypeList(typeCounts, "IFC \u5B9E\u4F53\u7EDF\u8BA1"));
    const hierarchy = $08414ea58bdc1292$var$createIfcHierarchy(records);
    if (hierarchy) section.append(hierarchy);
    const table = $08414ea58bdc1292$var$createCadEntityTable(records.slice(0, 240).map((record)=>({
            id: record.id,
            type: record.type,
            detail: $08414ea58bdc1292$var$summarizeIfcRecord(record)
        })));
    section.append(table);
    panel.append(section);
}
function $08414ea58bdc1292$var$renderAcisSat(panel, text, extension, ctx) {
    const records = $08414ea58bdc1292$var$parseAcisSatRecords(text);
    const typeCounts = $08414ea58bdc1292$var$countBy(records.map((record)=>record.type));
    const geometry = $08414ea58bdc1292$var$createCadGeometryPreview($08414ea58bdc1292$var$extractAcisSatGeometry(records), "SAT \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8");
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(geometry ? `${extension.toUpperCase()} ACIS \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8` : `${extension.toUpperCase()} ACIS \u7ED3\u6784\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u4F1A\u5728\u524D\u7AEF\u89E3\u6790 ACIS SAT \u6587\u672C\u5B9E\u4F53\u3001\u7C7B\u578B\u7EDF\u8BA1\u548C\u5E38\u89C1 vertex/straight-curve \u51E0\u4F55\u7EBF\u7D22\uFF1B\u7CBE\u786E\u66F2\u9762\u3001\u62D3\u6251\u548C\u5E03\u5C14\u4F53\u4ECD\u5EFA\u8BAE\u63A5\u5165 CAD \u5185\u6838\u589E\u5F3A\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53", records.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7C7B\u578B", typeCounts.size);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u9876\u70B9", typeCounts.get("vertex") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u76F4\u7EBF", typeCounts.get("straight-curve") || 0);
    const typeList = $08414ea58bdc1292$var$createCadTypeList(typeCounts);
    section.append(note, meta, typeList);
    let viewer;
    if (geometry) {
        $08414ea58bdc1292$var$hideSuccessfulSectionHeading3(section);
        $08414ea58bdc1292$var$hideSupplementalInfo7(note);
        $08414ea58bdc1292$var$hideSupplementalInfo7(meta);
        $08414ea58bdc1292$var$hideSupplementalInfo7(typeList);
        section.append(geometry.element);
        viewer = $08414ea58bdc1292$var$createGeometryViewer(geometry.svg, geometry.bounds, ctx);
    }
    const table = $08414ea58bdc1292$var$createCadEntityTable(records.slice(0, 200).map((record)=>({
            id: record.id,
            type: record.type,
            detail: $08414ea58bdc1292$var$summarizeAcisRecord(record)
        })));
    if (geometry) $08414ea58bdc1292$var$hideSupplementalInfo7(table);
    section.append(table);
    panel.append(section);
    return viewer;
}
function $08414ea58bdc1292$var$renderParasolidText(panel, text, extension, ctx) {
    const records = $08414ea58bdc1292$var$parseParasolidTextRecords(text);
    const typeCounts = $08414ea58bdc1292$var$countBy(records.map((record)=>record.type));
    const geometry = $08414ea58bdc1292$var$createCadGeometryPreview($08414ea58bdc1292$var$extractParasolidTextGeometry(records), "Parasolid \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8");
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(geometry ? `${extension.toUpperCase()} Parasolid \u8F7B\u91CF\u51E0\u4F55\u9884\u89C8` : `${extension.toUpperCase()} Parasolid \u6587\u672C\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = "\u5F53\u524D\u7248\u672C\u4F1A\u5728\u524D\u7AEF\u89E3\u6790 Parasolid x_t \u6587\u672C\u7247\u6BB5\u3001\u5B9E\u4F53\u7C7B\u578B\u3001\u5750\u6807\u70B9\u548C\u57FA\u7840\u7EBF\u6BB5\u7EBF\u7D22\uFF1B\u5B8C\u6574 B-Rep\u3001\u66F2\u9762\u548C\u88C5\u914D\u5173\u7CFB\u5EFA\u8BAE\u63A5\u5165 Parasolid/HOOPS/ODA \u7B49\u4E13\u4E1A\u5185\u6838\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53", records.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7C7B\u578B", typeCounts.size);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u70B9", typeCounts.get("point") || typeCounts.get("vertex") || 0);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u66F2\u7EBF", (typeCounts.get("line") || 0) + (typeCounts.get("curve") || 0));
    const typeList = $08414ea58bdc1292$var$createCadTypeList(typeCounts);
    section.append(note, meta, typeList);
    let viewer;
    if (geometry) {
        $08414ea58bdc1292$var$hideSuccessfulSectionHeading3(section);
        $08414ea58bdc1292$var$hideSupplementalInfo7(note);
        $08414ea58bdc1292$var$hideSupplementalInfo7(meta);
        $08414ea58bdc1292$var$hideSupplementalInfo7(typeList);
        section.append(geometry.element);
        viewer = $08414ea58bdc1292$var$createGeometryViewer(geometry.svg, geometry.bounds, ctx);
    }
    const table = $08414ea58bdc1292$var$createCadEntityTable(records.slice(0, 200).map((record)=>({
            id: record.id,
            type: record.type,
            detail: $08414ea58bdc1292$var$summarizeParasolidRecord(record)
        })));
    if (geometry) $08414ea58bdc1292$var$hideSupplementalInfo7(table);
    section.append(table);
    panel.append(section);
    return viewer;
}
var $08414ea58bdc1292$var$layoutPalette = [
    "#60a5fa",
    "#f87171",
    "#34d399",
    "#c084fc",
    "#fbbf24",
    "#22d3ee",
    "#fb7185",
    "#818cf8",
    "#4ade80",
    "#facc15"
];
var $08414ea58bdc1292$var$gdsRecordNames = {
    0: "HEADER",
    1: "BGNLIB",
    2: "LIBNAME",
    3: "UNITS",
    4: "ENDLIB",
    5: "BGNSTR",
    6: "STRNAME",
    7: "ENDSTR",
    8: "BOUNDARY",
    9: "PATH",
    10: "SREF",
    11: "AREF",
    12: "TEXT",
    13: "LAYER",
    14: "DATATYPE",
    15: "WIDTH",
    16: "XY",
    17: "ENDEL",
    18: "SNAME",
    19: "COLROW",
    22: "TEXTTYPE",
    25: "STRING",
    45: "BOX"
};
var $08414ea58bdc1292$var$oasisRecordNames = {
    0: "PAD",
    1: "START",
    2: "END",
    3: "CELLNAME",
    4: "CELLNAME-REF",
    5: "TEXTSTRING",
    6: "TEXTSTRING-REF",
    7: "PROPNAME",
    8: "PROPNAME-REF",
    9: "PROPSTRING",
    10: "PROPSTRING-REF",
    11: "LAYERNAME",
    12: "LAYERNAME-REF",
    13: "CELL",
    14: "CELL",
    15: "XYABSOLUTE",
    16: "XYRELATIVE",
    17: "PLACEMENT",
    18: "PLACEMENT",
    19: "TEXT",
    20: "RECTANGLE",
    21: "POLYGON",
    22: "PATH",
    23: "TRAPEZOID",
    24: "TRAPEZOID",
    25: "TRAPEZOID",
    26: "CTRAPEZOID",
    27: "CIRCLE",
    28: "PROPERTY",
    29: "PROPERTY",
    30: "XNAME",
    31: "XNAME-REF",
    32: "XELEMENT",
    33: "XGEOMETRY",
    34: "CBLOCK"
};
function $08414ea58bdc1292$var$renderLayoutPreview(panel, data, ctx) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${data.format} \u7248\u56FE\u9884\u89C8`);
    const summary = document.createElement("div");
    summary.className = "ofv-cad-summary ofv-layout-summary";
    summary.hidden = data.shapes.length > 0 || data.labels.length > 0 || data.references.length > 0;
    if (summary.hidden) {
        summary.setAttribute("aria-hidden", "true");
        summary.style.display = "none";
    }
    $08414ea58bdc1292$var$appendMeta6(summary, "\u6587\u4EF6", data.fileName);
    $08414ea58bdc1292$var$appendMeta6(summary, "\u683C\u5F0F", data.format);
    if (data.libraryName) $08414ea58bdc1292$var$appendMeta6(summary, "\u5E93", data.libraryName);
    if (data.version) $08414ea58bdc1292$var$appendMeta6(summary, "\u7248\u672C", data.version);
    if (data.unit) $08414ea58bdc1292$var$appendMeta6(summary, "\u5355\u4F4D", data.unit);
    $08414ea58bdc1292$var$appendMeta6(summary, "Cell", data.cells.length);
    $08414ea58bdc1292$var$appendMeta6(summary, "\u51E0\u4F55", data.shapes.length);
    $08414ea58bdc1292$var$appendMeta6(summary, "\u5F15\u7528", data.references.length);
    $08414ea58bdc1292$var$appendMeta6(summary, "\u6587\u5B57", data.labels.length);
    for (const [label, value] of data.metadata)$08414ea58bdc1292$var$appendMeta6(summary, label, value);
    section.append(summary);
    for (const noteText of [
        ...data.notes,
        ...data.warnings
    ]){
        const note = document.createElement("p");
        note.className = data.warnings.includes(noteText) ? "ofv-layout-warning" : "ofv-layout-note";
        note.textContent = noteText;
        if (!data.warnings.includes(noteText) && $08414ea58bdc1292$var$hasDrawableLayout(data)) $08414ea58bdc1292$var$hideSupplementalInfo7(note);
        section.append(note);
    }
    const bounds = $08414ea58bdc1292$var$computeLayoutBounds(data.shapes, data.labels, data.references);
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "ofv-svg-stage ofv-layout-stage");
    const webgl = $08414ea58bdc1292$var$shouldUseWebglLayoutPreview(data) ? $08414ea58bdc1292$var$createLayoutWebglPreview(data.shapes, data.layers) : void 0;
    let currentViewBox = {
        x: bounds.minX,
        y: bounds.minY,
        width: bounds.width,
        height: bounds.height
    };
    const initialViewBox = {
        ...currentViewBox
    };
    const applyViewBox = ()=>{
        if (webgl) webgl.render(currentViewBox);
        else svg.setAttribute("viewBox", `${currentViewBox.x} ${currentViewBox.y} ${currentViewBox.width} ${currentViewBox.height}`);
    };
    applyViewBox();
    if (data.shapes.length === 0) {
        const empty = document.createElementNS(svg.namespaceURI, "text");
        empty.setAttribute("x", String(bounds.minX + bounds.width * 0.5));
        empty.setAttribute("y", String(bounds.minY + bounds.height * 0.5));
        empty.setAttribute("text-anchor", "middle");
        empty.setAttribute("font-size", String(Math.max(bounds.width, bounds.height) / 34));
        empty.setAttribute("fill", "currentColor");
        empty.textContent = "\u5DF2\u8BC6\u522B\u7248\u56FE\u6587\u4EF6\uFF0C\u5F53\u524D\u6587\u4EF6\u672A\u89E3\u6790\u51FA\u53EF\u7ED8\u5236\u51E0\u4F55";
        svg.append(empty);
    }
    if (!webgl) {
        const layerIndex = new Map([
            ...data.layers.keys()
        ].sort((a, b)=>a.localeCompare(b)).map((layer, index)=>[
                layer,
                index
            ]));
        for (const shape of data.shapes.slice(0, 6e3)){
            const color = $08414ea58bdc1292$var$layoutPalette[(layerIndex.get(shape.layer) || 0) % $08414ea58bdc1292$var$layoutPalette.length];
            if (shape.kind === "path") {
                const polyline = document.createElementNS(svg.namespaceURI, "polyline");
                polyline.setAttribute("points", shape.points.map(([x, y])=>`${x},${-y}`).join(" "));
                polyline.setAttribute("fill", "none");
                polyline.setAttribute("stroke", color);
                polyline.setAttribute("stroke-width", String(Math.max(bounds.stroke, Math.abs(shape.width || 0))));
                polyline.setAttribute("stroke-linecap", "round");
                polyline.setAttribute("stroke-linejoin", "round");
                $08414ea58bdc1292$var$applyLayer(polyline, shape.layer);
                svg.append(polyline);
                continue;
            }
            const polygon = document.createElementNS(svg.namespaceURI, "polygon");
            polygon.setAttribute("points", shape.points.map(([x, y])=>`${x},${-y}`).join(" "));
            polygon.setAttribute("fill", color);
            polygon.setAttribute("fill-opacity", "0.3");
            polygon.setAttribute("stroke", color);
            polygon.setAttribute("stroke-width", String(bounds.stroke));
            polygon.setAttribute("vector-effect", "non-scaling-stroke");
            $08414ea58bdc1292$var$applyLayer(polygon, shape.layer);
            svg.append(polygon);
        }
    }
    for (const label of webgl ? [] : data.labels.slice(0, 400)){
        const text = document.createElementNS(svg.namespaceURI, "text");
        text.setAttribute("x", String(label.x));
        text.setAttribute("y", String(-label.y));
        text.setAttribute("font-size", String(Math.max(bounds.stroke * 12, Math.max(bounds.width, bounds.height) / 120)));
        text.setAttribute("fill", "currentColor");
        text.textContent = label.text;
        $08414ea58bdc1292$var$applyLayer(text, label.layer);
        svg.append(text);
    }
    const layers = [
        ...data.layers.keys()
    ].sort((a, b)=>a.localeCompare(b));
    if (layers.length > 0) {
        const layerControls = $08414ea58bdc1292$var$createLayoutLayerControls(webgl ? void 0 : svg, layers, data.layers, (layer, visible)=>{
            webgl?.setLayerVisible(layer, visible);
        });
        if ($08414ea58bdc1292$var$hasDrawableLayout(data)) $08414ea58bdc1292$var$hideSupplementalInfo7(layerControls);
        section.append(layerControls);
    }
    section.append(webgl?.canvas || svg);
    if (data.cells.length > 0) section.append($08414ea58bdc1292$var$createLayoutCellList(data.cells, data.references, $08414ea58bdc1292$var$hasDrawableLayout(data)));
    panel.append(section);
    const updateToolbarZoom = ()=>ctx.toolbar?.setZoom(initialViewBox.width / currentViewBox.width);
    updateToolbarZoom();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in" || command === "zoom-out") {
                const factor = command === "zoom-in" ? 0.82 : 1.18;
                const centerX = currentViewBox.x + currentViewBox.width / 2;
                const centerY = currentViewBox.y + currentViewBox.height / 2;
                currentViewBox.width *= factor;
                currentViewBox.height *= factor;
                currentViewBox.x = centerX - currentViewBox.width / 2;
                currentViewBox.y = centerY - currentViewBox.height / 2;
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            if (command === "zoom-reset") {
                currentViewBox = {
                    ...initialViewBox
                };
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            return false;
        },
        destroy () {
            webgl?.destroy();
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$shouldUseWebglLayoutPreview(data) {
    if (data.labels.length > 0) return false;
    if (data.shapes.length < 360 && data.shapes.reduce((sum, shape)=>sum + shape.points.length, 0) < 1800) return false;
    return typeof WebGLRenderingContext !== "undefined";
}
function $08414ea58bdc1292$var$createLayoutWebglPreview(shapes, layerCounts) {
    const canvas = document.createElement("canvas");
    canvas.className = "ofv-svg-stage ofv-layout-stage ofv-layout-webgl-stage";
    canvas.width = 1440;
    canvas.height = 864;
    canvas.dataset.renderer = "webgl";
    let gl;
    try {
        gl = canvas.getContext("webgl", {
            alpha: false,
            antialias: true
        });
    } catch  {
        return void 0;
    }
    if (!gl) return void 0;
    const vertexShader = $08414ea58bdc1292$var$compileLayoutShader(gl, gl.VERTEX_SHADER, "attribute vec2 a_position; uniform vec4 u_viewBox; void main() { float x = (a_position.x - u_viewBox.x) / u_viewBox.z * 2.0 - 1.0; float y = 1.0 - (a_position.y - u_viewBox.y) / u_viewBox.w * 2.0; gl_Position = vec4(x, y, 0.0, 1.0); }");
    const fragmentShader = $08414ea58bdc1292$var$compileLayoutShader(gl, gl.FRAGMENT_SHADER, "precision mediump float; uniform vec4 u_color; void main() { gl_FragColor = u_color; }");
    if (!vertexShader || !fragmentShader) return void 0;
    const program = gl.createProgram();
    if (!program) return void 0;
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        gl.deleteProgram(program);
        gl.deleteShader(vertexShader);
        gl.deleteShader(fragmentShader);
        return void 0;
    }
    const buffer = gl.createBuffer();
    const position = gl.getAttribLocation(program, "a_position");
    const viewBoxUniform = gl.getUniformLocation(program, "u_viewBox");
    const colorUniform = gl.getUniformLocation(program, "u_color");
    if (!buffer || position < 0 || !viewBoxUniform || !colorUniform) {
        gl.deleteProgram(program);
        gl.deleteShader(vertexShader);
        gl.deleteShader(fragmentShader);
        return void 0;
    }
    const layers = [
        ...layerCounts.keys()
    ].sort((a, b)=>a.localeCompare(b));
    const layerIndex = new Map(layers.map((layer, index)=>[
            layer,
            index
        ]));
    const geometry = /* @__PURE__ */ new Map();
    for (const layer of layers){
        const fill = [];
        const lines = [];
        for (const shape of shapes){
            if (shape.layer !== layer) continue;
            const points = shape.points.map(([x, y])=>[
                    x,
                    -y
                ]);
            if (points.length > 1 && $08414ea58bdc1292$var$pointsEqual(points[0], points[points.length - 1])) points.pop();
            if (shape.kind !== "path" && points.length >= 3) for(let index = 1; index < points.length - 1; index += 1)fill.push(...points[0], ...points[index], ...points[index + 1]);
            for(let index = 0; index < points.length - 1; index += 1)lines.push(...points[index], ...points[index + 1]);
            if (shape.kind !== "path" && points.length > 2) lines.push(...points[points.length - 1], ...points[0]);
        }
        geometry.set(layer, {
            fill: new Float32Array(fill),
            lines: new Float32Array(lines),
            color: $08414ea58bdc1292$var$parseLayoutColor($08414ea58bdc1292$var$layoutPalette[(layerIndex.get(layer) || 0) % $08414ea58bdc1292$var$layoutPalette.length])
        });
    }
    const visibleLayers = new Set(layers);
    let currentViewBox = {
        x: 0,
        y: 0,
        width: 1,
        height: 1
    };
    const render = (viewBox)=>{
        currentViewBox = {
            ...viewBox
        };
        const fitted = $08414ea58bdc1292$var$fitLayoutViewBox(viewBox, canvas.width / canvas.height);
        gl.viewport(0, 0, canvas.width, canvas.height);
        gl.clearColor(16 / 255, 20 / 255, 28 / 255, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(program);
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(position);
        gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
        gl.uniform4f(viewBoxUniform, fitted.x, fitted.y, fitted.width, fitted.height);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        for (const layer of layers){
            if (!visibleLayers.has(layer)) continue;
            const item = geometry.get(layer);
            if (!item) continue;
            if (item.fill.length) {
                gl.bufferData(gl.ARRAY_BUFFER, item.fill, gl.STATIC_DRAW);
                gl.uniform4f(colorUniform, ...item.color, 0.3);
                gl.drawArrays(gl.TRIANGLES, 0, item.fill.length / 2);
            }
            if (item.lines.length) {
                gl.bufferData(gl.ARRAY_BUFFER, item.lines, gl.STATIC_DRAW);
                gl.uniform4f(colorUniform, ...item.color, 0.95);
                gl.drawArrays(gl.LINES, 0, item.lines.length / 2);
            }
        }
    };
    return {
        canvas: canvas,
        render: render,
        setLayerVisible (layer, visible) {
            if (visible) visibleLayers.add(layer);
            else visibleLayers.delete(layer);
            render(currentViewBox);
        },
        destroy () {
            gl.deleteBuffer(buffer);
            gl.deleteProgram(program);
            gl.deleteShader(vertexShader);
            gl.deleteShader(fragmentShader);
        }
    };
}
function $08414ea58bdc1292$var$compileLayoutShader(gl, type, source) {
    const shader = gl.createShader(type);
    if (!shader) return void 0;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return void 0;
    }
    return shader;
}
function $08414ea58bdc1292$var$pointsEqual(left, right) {
    return left[0] === right[0] && left[1] === right[1];
}
function $08414ea58bdc1292$var$parseLayoutColor(color) {
    return [
        1,
        3,
        5
    ].map((offset)=>Number.parseInt(color.slice(offset, offset + 2), 16) / 255);
}
function $08414ea58bdc1292$var$fitLayoutViewBox(viewBox, aspect) {
    const result = {
        ...viewBox
    };
    const viewAspect = result.width / result.height;
    if (viewAspect > aspect) {
        const height = result.width / aspect;
        result.y -= (height - result.height) / 2;
        result.height = height;
    } else {
        const width = result.height * aspect;
        result.x -= (width - result.width) / 2;
        result.width = width;
    }
    return result;
}
function $08414ea58bdc1292$var$parseGdsLayout(bytes, fileName) {
    const shapes = [];
    const labels = [];
    const references = [];
    const cells = [];
    const layers = /* @__PURE__ */ new Map();
    const recordCounts = /* @__PURE__ */ new Map();
    const warnings = [];
    let libraryName = "";
    let version = "";
    let unit = "";
    let offset = 0;
    let current = {};
    let currentKind = "";
    let currentCell = "";
    while(offset + 4 <= bytes.length){
        const length = $08414ea58bdc1292$var$readUInt16(bytes, offset);
        const recordType = bytes[offset + 2];
        const data = bytes.slice(offset + 4, offset + length);
        const name = $08414ea58bdc1292$var$gdsRecordNames[recordType] || `0x${recordType.toString(16).padStart(2, "0")}`;
        recordCounts.set(name, (recordCounts.get(name) || 0) + 1);
        if (length < 4 || offset + length > bytes.length) {
            warnings.push(`GDS \u8BB0\u5F55\u5728 ${offset} \u5B57\u8282\u5904\u957F\u5EA6\u5F02\u5E38\uFF0C\u5DF2\u505C\u6B62\u89E3\u6790\u3002`);
            break;
        }
        if (recordType === 0 && data.length >= 2) version = String($08414ea58bdc1292$var$readUInt16(data, 0));
        else if (recordType === 2) libraryName = $08414ea58bdc1292$var$readGdsString(data);
        else if (recordType === 3 && data.length >= 16) unit = `${$08414ea58bdc1292$var$formatGdsReal(data, 0)} / ${$08414ea58bdc1292$var$formatGdsReal(data, 8)}`;
        else if (recordType === 6) {
            currentCell = $08414ea58bdc1292$var$readGdsString(data);
            cells.push(currentCell);
        } else if (recordType === 8 || recordType === 9 || recordType === 45) {
            currentKind = recordType === 9 ? "path" : recordType === 45 ? "box" : "boundary";
            current = {
                kind: currentKind,
                layer: "0",
                datatype: "0",
                points: []
            };
        } else if (recordType === 12) {
            currentKind = "text";
            current = {
                layer: "0",
                text: "",
                x: 0,
                y: 0
            };
        } else if (recordType === 10 || recordType === 11) {
            currentKind = "reference";
            current = {
                cell: "",
                x: 0,
                y: 0
            };
        } else if (recordType === 13 && data.length >= 2) current.layer = String($08414ea58bdc1292$var$readInt16(data, 0));
        else if ((recordType === 14 || recordType === 22) && data.length >= 2) current.datatype = String($08414ea58bdc1292$var$readInt16(data, 0));
        else if (recordType === 15 && data.length >= 4) current.width = Math.abs($08414ea58bdc1292$var$readInt32(data, 0));
        else if (recordType === 19 && data.length >= 4) {
            current.columns = Math.max(1, $08414ea58bdc1292$var$readInt16(data, 0));
            current.rows = Math.max(1, $08414ea58bdc1292$var$readInt16(data, 2));
        } else if (recordType === 16) {
            const points = $08414ea58bdc1292$var$readGdsPoints(data);
            if (currentKind === "text" && points[0]) {
                current.x = points[0][0];
                current.y = points[0][1];
            } else if (currentKind === "reference" && points[0]) {
                current.x = points[0][0];
                current.y = points[0][1];
                if (points.length >= 3) {
                    const columns = Math.max(1, Number(current.columns || 1));
                    const rows = Math.max(1, Number(current.rows || 1));
                    current.columnDx = (points[1][0] - points[0][0]) / Math.max(1, columns - 1);
                    current.columnDy = (points[1][1] - points[0][1]) / Math.max(1, columns - 1);
                    current.rowDx = (points[2][0] - points[0][0]) / Math.max(1, rows - 1);
                    current.rowDy = (points[2][1] - points[0][1]) / Math.max(1, rows - 1);
                }
            } else current.points = points;
        } else if (recordType === 18) current.cell = $08414ea58bdc1292$var$readGdsString(data);
        else if (recordType === 25) current.text = $08414ea58bdc1292$var$readGdsString(data);
        else if (recordType === 17) {
            if ((currentKind === "boundary" || currentKind === "path" || currentKind === "box") && current.points && current.points.length > 1) {
                const shape = {
                    kind: current.kind || "boundary",
                    cell: currentCell,
                    layer: String(current.layer || "0"),
                    datatype: current.datatype,
                    points: current.points,
                    width: current.width
                };
                shapes.push(shape);
                layers.set(shape.layer, (layers.get(shape.layer) || 0) + 1);
            } else if (currentKind === "text" && current.text) {
                const label = {
                    cell: currentCell,
                    layer: String(current.layer || "0"),
                    text: String(current.text),
                    x: Number(current.x || 0),
                    y: Number(current.y || 0)
                };
                labels.push(label);
                layers.set(label.layer, (layers.get(label.layer) || 0) + 1);
            } else if (currentKind === "reference" && current.cell) references.push({
                ownerCell: currentCell,
                cell: String(current.cell),
                x: Number(current.x || 0),
                y: Number(current.y || 0),
                columns: current.columns,
                rows: current.rows,
                columnDx: current.columnDx,
                columnDy: current.columnDy,
                rowDx: current.rowDx,
                rowDy: current.rowDy
            });
            current = {};
            currentKind = "";
        }
        offset += length;
    }
    const expanded = $08414ea58bdc1292$var$expandLayoutReferences(shapes, labels, references, cells);
    return {
        format: "GDSII",
        fileName: fileName,
        libraryName: libraryName,
        version: version ? `Stream ${version}` : void 0,
        unit: unit,
        cells: cells,
        shapes: expanded.shapes,
        labels: expanded.labels,
        references: references,
        layers: $08414ea58bdc1292$var$countLayoutLayers(expanded.shapes, expanded.labels),
        metadata: [
            [
                "\u5927\u5C0F",
                $08414ea58bdc1292$var$formatBytes3(bytes.byteLength)
            ],
            [
                "\u8BB0\u5F55",
                $08414ea58bdc1292$var$sumCounts(recordCounts)
            ],
            [
                "\u8BB0\u5F55\u7C7B\u578B",
                recordCounts.size
            ],
            [
                "\u5C55\u5F00\u51E0\u4F55",
                expanded.addedShapes
            ]
        ],
        notes: [
            `\u5DF2\u4ECE GDSII Stream \u4E2D\u89E3\u6790 ${shapes.length} \u4E2A\u539F\u59CB\u51E0\u4F55\u3001${references.length} \u4E2A cell \u5F15\u7528\u548C ${labels.length} \u6BB5\u6587\u5B57\uFF0C\u5E76\u5C55\u5F00 ${expanded.addedShapes} \u4E2A\u5F15\u7528\u51E0\u4F55\u3002`
        ],
        warnings: warnings
    };
}
function $08414ea58bdc1292$var$expandLayoutReferences(shapes, labels, references, cells) {
    if (references.length === 0 || shapes.length === 0) return {
        shapes: shapes,
        labels: labels,
        addedShapes: 0
    };
    const childCells = new Set(references.map((reference)=>reference.cell));
    const topCells = cells.filter((cell)=>!childCells.has(cell));
    const roots = topCells.length > 0 ? topCells : cells.slice(-1);
    const shapeKeys = new Set(shapes.map($08414ea58bdc1292$var$layoutShapeKey));
    const labelKeys = new Set(labels.map($08414ea58bdc1292$var$layoutLabelKey));
    const expandedShapes = [
        ...shapes
    ];
    const expandedLabels = [
        ...labels
    ];
    const maxDepth = 10;
    const maxAddedShapes = 1e4;
    let addedShapes = 0;
    const expandCell = (cell, offsetX, offsetY, depth, stack)=>{
        if (depth > maxDepth || addedShapes >= maxAddedShapes || stack.has(cell)) return;
        const nextStack = new Set(stack);
        nextStack.add(cell);
        for (const shape of shapes){
            if (shape.cell !== cell || offsetX === 0 && offsetY === 0) continue;
            const cloned = {
                ...shape,
                points: shape.points.map(([x, y])=>[
                        x + offsetX,
                        y + offsetY
                    ])
            };
            const key = $08414ea58bdc1292$var$layoutShapeKey(cloned);
            if (!shapeKeys.has(key)) {
                shapeKeys.add(key);
                expandedShapes.push(cloned);
                addedShapes += 1;
                if (addedShapes >= maxAddedShapes) break;
            }
        }
        for (const label of labels){
            if (label.cell !== cell || offsetX === 0 && offsetY === 0) continue;
            const cloned = {
                ...label,
                x: label.x + offsetX,
                y: label.y + offsetY
            };
            const key = $08414ea58bdc1292$var$layoutLabelKey(cloned);
            if (!labelKeys.has(key)) {
                labelKeys.add(key);
                expandedLabels.push(cloned);
            }
        }
        for (const reference of references){
            if (reference.ownerCell !== cell) continue;
            const columns = Math.max(1, Math.floor(reference.columns || 1));
            const rows = Math.max(1, Math.floor(reference.rows || 1));
            const columnDx = Number(reference.columnDx || 0);
            const columnDy = Number(reference.columnDy || 0);
            const rowDx = Number(reference.rowDx || 0);
            const rowDy = Number(reference.rowDy || 0);
            for(let row = 0; row < rows; row++)for(let column = 0; column < columns; column++)expandCell(reference.cell, offsetX + reference.x + column * columnDx + row * rowDx, offsetY + reference.y + column * columnDy + row * rowDy, depth + 1, nextStack);
        }
    };
    for (const root of roots)expandCell(root, 0, 0, 0, /* @__PURE__ */ new Set());
    return {
        shapes: expandedShapes,
        labels: expandedLabels,
        addedShapes: addedShapes
    };
}
function $08414ea58bdc1292$var$countLayoutLayers(shapes, labels) {
    const layers = /* @__PURE__ */ new Map();
    for (const shape of shapes)layers.set(shape.layer, (layers.get(shape.layer) || 0) + 1);
    for (const label of labels)layers.set(label.layer, (layers.get(label.layer) || 0) + 1);
    return layers;
}
function $08414ea58bdc1292$var$layoutShapeKey(shape) {
    return `${shape.kind}|${shape.cell || ""}|${shape.layer}|${shape.datatype || ""}|${shape.width || ""}|${shape.points.map(([x, y])=>`${x},${y}`).join(";")}`;
}
function $08414ea58bdc1292$var$layoutLabelKey(label) {
    return `${label.cell || ""}|${label.layer}|${label.text}|${label.x}|${label.y}`;
}
function $08414ea58bdc1292$var$parseOasisLayout(bytes, fileName) {
    const binary = $08414ea58bdc1292$var$parseBinaryOasis(bytes);
    if (binary) {
        const layers2 = $08414ea58bdc1292$var$countLayoutLayers(binary.shapes, binary.labels);
        return {
            format: "OASIS",
            fileName: fileName,
            version: binary.version ? `OASIS ${binary.version}` : "OASIS",
            unit: binary.unit ? `1 / ${binary.unit}` : void 0,
            cells: binary.cells,
            shapes: binary.shapes,
            labels: binary.labels,
            references: binary.references,
            layers: layers2,
            metadata: [
                [
                    "\u5927\u5C0F",
                    $08414ea58bdc1292$var$formatBytes3(bytes.byteLength)
                ],
                [
                    "CBLOCK",
                    binary.compressedBlockCount
                ],
                [
                    "\u8BB0\u5F55",
                    binary.recordCount
                ],
                [
                    "\u89E3\u6790\u51E0\u4F55",
                    binary.shapes.length
                ]
            ],
            notes: [
                `\u5DF2\u4ECE\u6807\u51C6\u4E8C\u8FDB\u5236 OASIS \u8BB0\u5F55\u4E2D\u89E3\u6790 ${binary.shapes.length} \u4E2A\u51E0\u4F55\u3001${binary.placementRecordCount} \u4E2A cell \u653E\u7F6E\u8BB0\u5F55\u548C ${binary.labels.length} \u6BB5\u6587\u5B57\u3002`
            ],
            warnings: binary.warnings
        };
    }
    const chunks = $08414ea58bdc1292$var$extractOasisCblocks(bytes);
    const expanded = chunks.flatMap((chunk)=>[
            ...chunk.bytes
        ]);
    const cellNames = $08414ea58bdc1292$var$uniqueHints([
        ...$08414ea58bdc1292$var$extractAsciiRuns(bytes),
        ...chunks.flatMap((chunk)=>$08414ea58bdc1292$var$extractAsciiRuns(chunk.bytes))
    ]).filter((item)=>/^[A-Za-z_][\w$.-]{1,80}$/.test(item)).filter((item)=>!item.startsWith("S_"));
    const propertyNames = $08414ea58bdc1292$var$uniqueHints(chunks.flatMap((chunk)=>$08414ea58bdc1292$var$extractAsciiRuns(chunk.bytes)).filter((item)=>item.startsWith("S_")));
    const recordCounts = $08414ea58bdc1292$var$scanOasisRecordCounts(bytes);
    const expandedCounts = $08414ea58bdc1292$var$scanOasisRecordCounts(new Uint8Array(expanded));
    const layers = /* @__PURE__ */ new Map();
    const shapes = [];
    const labels = [];
    const references = [];
    for (const name of cellNames)references.push({
        cell: name,
        x: 0,
        y: 0
    });
    const pseudo = $08414ea58bdc1292$var$createOasisStructureShapes(cellNames, chunks.length || recordCounts.size || 1);
    for (const shape of pseudo){
        shapes.push(shape);
        layers.set(shape.layer, (layers.get(shape.layer) || 0) + 1);
    }
    for(let index = 0; index < cellNames.length; index++)labels.push({
        layer: "cell",
        text: cellNames[index],
        x: 12,
        y: -(18 + index * 18)
    });
    if (cellNames.length > 0) layers.set("cell", (layers.get("cell") || 0) + cellNames.length);
    const version = $08414ea58bdc1292$var$readOasisVersion(bytes);
    const cblockText = chunks.length ? `${chunks.length} \u4E2A\uFF0C\u5C55\u5F00 ${$08414ea58bdc1292$var$formatBytes3(chunks.reduce((sum, chunk)=>sum + chunk.bytes.byteLength, 0))}` : "\u672A\u53D1\u73B0";
    const notes = [
        "OASIS \u662F\u9AD8\u538B\u7F29\u82AF\u7247\u7248\u56FE\u683C\u5F0F\uFF0C\u5F53\u524D\u7248\u672C\u63D0\u4F9B\u6D4F\u89C8\u5668\u7AEF\u8BC6\u522B\u3001CBLOCK \u89E3\u538B\u3001cell/\u5C5E\u6027\u7ED3\u6784\u548C\u8F7B\u91CF\u7ED3\u6784\u793A\u610F\uFF1B\u5B8C\u6574\u51E0\u4F55\u9AD8\u4FDD\u771F\u6E32\u67D3\u5EFA\u8BAE\u540E\u7EED\u63A5\u5165\u4E13\u7528 OASIS \u89E3\u6790\u5668\u3002"
    ];
    if (propertyNames.length > 0) notes.push(`\u8BC6\u522B\u5230\u5C5E\u6027\uFF1A${propertyNames.slice(0, 5).join("\u3001")}`);
    return {
        format: "OASIS",
        fileName: fileName,
        version: version,
        cells: cellNames,
        shapes: shapes,
        labels: labels,
        references: [],
        layers: layers,
        metadata: [
            [
                "\u5927\u5C0F",
                $08414ea58bdc1292$var$formatBytes3(bytes.byteLength)
            ],
            [
                "CBLOCK",
                cblockText
            ],
            [
                "\u8BB0\u5F55\u7C7B\u578B",
                recordCounts.size + expandedCounts.size
            ],
            [
                "\u53EF\u8BFB\u7247\u6BB5",
                cellNames.length + propertyNames.length
            ]
        ],
        notes: notes,
        warnings: cellNames.length === 0 ? [
            "\u5F53\u524D OASIS \u6587\u4EF6\u672A\u63D0\u53D6\u5230 cell \u540D\u79F0\uFF0C\u53EF\u80FD\u4F7F\u7528\u4E86\u66F4\u590D\u6742\u7684\u7D22\u5F15\u6216\u52A0\u5BC6/\u538B\u7F29\u5E03\u5C40\u3002"
        ] : []
    };
}
function $08414ea58bdc1292$var$computeLayoutBounds(shapes, labels, references) {
    const xs = [];
    const ys = [];
    for (const shape of shapes)for (const [x, y] of shape.points){
        xs.push(x);
        ys.push(-y);
    }
    for (const label of labels){
        xs.push(label.x, label.x + label.text.length * 12);
        ys.push(-label.y, -label.y - 16);
    }
    if (shapes.length === 0 && labels.length === 0) for (const reference of references){
        xs.push(reference.x);
        ys.push(-reference.y);
    }
    const minX = Math.min(...xs, 0);
    const maxX = Math.max(...xs, 100);
    const minY = Math.min(...ys, 0);
    const maxY = Math.max(...ys, 100);
    const width = Math.max(1, maxX - minX);
    const height = Math.max(1, maxY - minY);
    const padding = Math.max(width, height) * 0.06;
    return {
        minX: minX - padding,
        minY: minY - padding,
        width: width + padding * 2,
        height: height + padding * 2,
        stroke: Math.max(width, height) / 900
    };
}
function $08414ea58bdc1292$var$createLayoutLayerControls(svg, layers, counts, onChange) {
    const controls = document.createElement("div");
    controls.className = "ofv-cad-layers ofv-layout-layers";
    const title = document.createElement("strong");
    title.textContent = `\u56FE\u5C42 ${layers.length}`;
    controls.append(title);
    for (const layer of layers){
        const label = document.createElement("label");
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = true;
        checkbox.addEventListener("change", ()=>{
            for (const element of svg?.querySelectorAll(`[data-layer="${$08414ea58bdc1292$var$escapeCssAttribute(layer)}"]`) || [])element.style.display = checkbox.checked ? "" : "none";
            onChange?.(layer, checkbox.checked);
        });
        const name = document.createElement("span");
        name.textContent = `${layer} (${counts.get(layer) || 0})`;
        label.append(checkbox, name);
        controls.append(label);
    }
    return controls;
}
function $08414ea58bdc1292$var$createLayoutCellList(cells, references, hidden = false) {
    const details = document.createElement("details");
    details.className = "ofv-details ofv-layout-cells";
    details.open = !hidden;
    if (hidden) $08414ea58bdc1292$var$hideSupplementalInfo7(details);
    const summary = document.createElement("summary");
    summary.textContent = `Cell \u7ED3\u6784 ${cells.length}`;
    const list = document.createElement("ul");
    const refCounts = $08414ea58bdc1292$var$countBy(references.map((reference)=>reference.cell));
    for (const cell of cells.slice(0, 120)){
        const item = document.createElement("li");
        const count = refCounts.get(cell) || 0;
        item.textContent = count > 0 ? `${cell} \xB7 \u5F15\u7528 ${count}` : cell;
        list.append(item);
    }
    details.append(summary, list);
    return details;
}
function $08414ea58bdc1292$var$hasDrawableLayout(data) {
    return data.shapes.length > 0 || data.labels.length > 0 || data.references.length > 0;
}
function $08414ea58bdc1292$var$readUInt16(bytes, offset) {
    return bytes[offset] << 8 | bytes[offset + 1];
}
function $08414ea58bdc1292$var$readInt16(bytes, offset) {
    const value = $08414ea58bdc1292$var$readUInt16(bytes, offset);
    return value & 32768 ? value - 65536 : value;
}
function $08414ea58bdc1292$var$readInt32(bytes, offset) {
    const value = bytes[offset] << 24 | bytes[offset + 1] << 16 | bytes[offset + 2] << 8 | bytes[offset + 3];
    return value | 0;
}
function $08414ea58bdc1292$var$readGdsString(bytes) {
    return new TextDecoder("ascii").decode(bytes).replace(/\0+$/g, "").trim();
}
function $08414ea58bdc1292$var$readGdsPoints(bytes) {
    const points = [];
    for(let offset = 0; offset + 7 < bytes.length; offset += 8)points.push([
        $08414ea58bdc1292$var$readInt32(bytes, offset),
        $08414ea58bdc1292$var$readInt32(bytes, offset + 4)
    ]);
    return points;
}
function $08414ea58bdc1292$var$formatGdsReal(bytes, offset) {
    const value = $08414ea58bdc1292$var$readGdsReal(bytes, offset);
    if (!Number.isFinite(value) || value === 0) return "0";
    if (Math.abs(value) < 1e-3 || Math.abs(value) >= 1e4) return value.toExponential(4);
    return String(Number(value.toPrecision(6)));
}
function $08414ea58bdc1292$var$readGdsReal(bytes, offset) {
    const first = bytes[offset];
    if (!first) return 0;
    const sign = first & 128 ? -1 : 1;
    const exponent = (first & 127) - 64;
    let mantissa = 0;
    for(let index = 1; index < 8; index++)mantissa = mantissa * 256 + bytes[offset + index];
    return sign * (mantissa / Math.pow(2, 56)) * Math.pow(16, exponent);
}
function $08414ea58bdc1292$var$sumCounts(counts) {
    return [
        ...counts.values()
    ].reduce((sum, count)=>sum + count, 0);
}
function $08414ea58bdc1292$var$extractOasisCblocks(bytes) {
    const chunks = [];
    const seen = /* @__PURE__ */ new Set();
    const limit = Math.min(bytes.length, 25e4);
    for(let offset = 0; offset < limit; offset++)try {
        const inflated = (0, $cab713332464fe22$export$2e2bcd8739ae039).inflateRaw(bytes.slice(offset));
        if (inflated.byteLength < 4) continue;
        const ascii = $08414ea58bdc1292$var$extractAsciiRuns(inflated);
        const hasLayoutSignal = ascii.some((item)=>item.startsWith("S_") || /TOP|CELL|DIE|SIZE/i.test(item));
        const hasRecordSignal = inflated.some((byte)=>byte >= 13 && byte <= 34);
        if (!hasLayoutSignal && !hasRecordSignal) continue;
        const signature = `${inflated.byteLength}:${Array.from(inflated.slice(0, 12)).join(",")}`;
        if (seen.has(signature)) continue;
        seen.add(signature);
        chunks.push({
            offset: offset,
            bytes: inflated
        });
        if (chunks.length >= 12) break;
    } catch  {}
    return chunks;
}
function $08414ea58bdc1292$var$scanOasisRecordCounts(bytes) {
    const counts = /* @__PURE__ */ new Map();
    for (const byte of bytes.slice(0, Math.min(bytes.length, 12e3))){
        const name = $08414ea58bdc1292$var$oasisRecordNames[byte];
        if (name) counts.set(name, (counts.get(name) || 0) + 1);
    }
    return counts;
}
function $08414ea58bdc1292$var$readOasisVersion(bytes) {
    const magic = "%SEMI-OASIS\r\n";
    const header = new TextDecoder("ascii").decode(bytes.slice(0, Math.min(bytes.length, 48)));
    if (!header.startsWith(magic)) return void 0;
    const start = magic.length;
    if (bytes[start] !== 1) return "OASIS";
    const length = bytes[start + 1];
    const version = new TextDecoder("ascii").decode(bytes.slice(start + 2, start + 2 + length));
    return version ? `OASIS ${version}` : "OASIS";
}
function $08414ea58bdc1292$var$createOasisStructureShapes(cellNames, fallbackCount) {
    const rows = Math.max(1, cellNames.length || fallbackCount);
    const shapes = [];
    for(let index = 0; index < rows; index++){
        const top = -(index * 18);
        const height = 12;
        const width = 88 + Math.min((cellNames[index]?.length || 5) * 4, 90);
        shapes.push({
            kind: "box",
            layer: "cell",
            points: [
                [
                    0,
                    top
                ],
                [
                    width,
                    top
                ],
                [
                    width,
                    top - height
                ],
                [
                    0,
                    top - height
                ],
                [
                    0,
                    top
                ]
            ]
        });
    }
    return shapes;
}
function $08414ea58bdc1292$var$renderBinaryCad(panel, bytes, extension, fileName) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`${extension.toUpperCase()} \u6587\u4EF6\u9884\u89C8`);
    const note = document.createElement("p");
    note.textContent = extension === "dwg" ? "\u5DF2\u8BC6\u522B DWG \u4E13\u6709\u4E8C\u8FDB\u5236\u56FE\u7EB8\u3002\u6838\u5FC3\u63D2\u4EF6\u9ED8\u8BA4\u63D0\u4F9B\u7248\u672C\u3001\u5BB9\u5668\u3001\u7ED3\u6784\u7EBF\u7D22\u548C\u63A5\u5165\u5EFA\u8BAE\uFF1B\u771F\u5B9E\u51E0\u4F55\u6E32\u67D3\u53EF\u901A\u8FC7 cadPlugin({ binaryRenderer }) \u63A5\u5165\u53EF\u9009\u524D\u7AEF\u5F15\u64CE\u6216\u8F6C\u6362\u670D\u52A1\u3002" : "\u5DF2\u8BC6\u522B DWF \u53D1\u5E03\u56FE\u7EB8\u3002\u6838\u5FC3\u63D2\u4EF6\u9ED8\u8BA4\u63D0\u4F9B\u5BB9\u5668\u7EBF\u7D22\u548C\u63A5\u5165\u5EFA\u8BAE\uFF1B\u9AD8\u4FDD\u771F\u9875\u9762\u6E32\u67D3\u53EF\u901A\u8FC7 cadPlugin({ binaryRenderer }) \u63A5\u5165\u4E13\u7528\u89E3\u6790\u5668\u6216\u8F6C\u6362\u670D\u52A1\u3002";
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u6587\u4EF6", fileName);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u683C\u5F0F", extension.toUpperCase());
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5927\u5C0F", $08414ea58bdc1292$var$formatBytes3(bytes.byteLength));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7B7E\u540D", $08414ea58bdc1292$var$byteSignature2(bytes));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u7248\u672C", $08414ea58bdc1292$var$detectCadVersion(bytes, extension));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5BB9\u5668", $08414ea58bdc1292$var$detectCadContainer(bytes));
    const actions = document.createElement("div");
    actions.className = "ofv-cad-conversion";
    const actionTitle = document.createElement("h4");
    actionTitle.textContent = extension === "dwg" ? "\u63A8\u8350\u589E\u5F3A\u8DEF\u7EBF" : "\u63A8\u8350\u5904\u7406\u8DEF\u7EBF";
    const actionList = document.createElement("ol");
    const suggestions = extension === "dwg" ? [
        "\u4EA7\u54C1\u9ED8\u8BA4\u94FE\u8DEF\uFF1A\u670D\u52A1\u7AEF\u5C06 DWG \u8F6C\u4E3A PDF/SVG/DXF\uFF0C\u518D\u590D\u7528\u73B0\u6709 PDF\u3001\u56FE\u50CF\u6216 DXF \u9884\u89C8\u3002",
        "\u7EAF\u524D\u7AEF\u589E\u5F3A\uFF1A\u901A\u8FC7 binaryRenderer \u63A5\u5165 mlightcad / LibreDWG WASM \u4E00\u7C7B\u5F15\u64CE\uFF0C\u6309\u9700\u52A0\u8F7D worker \u548C\u5B57\u4F53\u8D44\u6E90\u3002",
        "\u5546\u7528\u9AD8\u4FDD\u771F\uFF1A\u63A5\u5165 ODA Drawings SDK / Web SDK\uFF0C\u9002\u5408\u590D\u6742\u56FE\u5C42\u3001\u5B57\u4F53\u3001\u5916\u90E8\u53C2\u7167\u548C\u5927\u56FE\u7EB8\u3002"
    ] : [
        "\u4F18\u5148\u5728\u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A PDF/SVG\uFF0C\u4FDD\u7559\u56FE\u5C42\u3001\u9875\u9762\u548C\u6807\u6CE8\u4FE1\u606F\u3002",
        "\u82E5 DWF \u4E3A\u538B\u7F29\u5BB9\u5668\uFF0C\u53EF\u901A\u8FC7 binaryRenderer \u8BFB\u53D6 manifest/descriptor \u518D\u8FD8\u539F\u9875\u9762\u8D44\u6E90\u3002",
        "\u82E5\u4E1A\u52A1\u53EA\u9700\u4E0B\u8F7D/\u5F52\u6863\uFF0C\u4FDD\u7559\u5F53\u524D\u6587\u4EF6\u5143\u4FE1\u606F\u548C\u8F6C\u6362\u63D0\u793A\u5373\u53EF\u3002"
    ];
    for (const suggestion of suggestions){
        const item = document.createElement("li");
        item.textContent = suggestion;
        actionList.append(item);
    }
    actions.append(actionTitle, actionList);
    const raw = document.createElement("details");
    raw.className = "ofv-details ofv-cad-raw-preview";
    const rawSummary = document.createElement("summary");
    rawSummary.textContent = "\u539F\u59CB\u5B57\u8282\u9884\u89C8";
    const preview = document.createElement("pre");
    preview.className = "ofv-text-block";
    preview.textContent = $08414ea58bdc1292$var$hexPreview(bytes);
    raw.append(rawSummary, preview);
    section.append(note, meta, actions, $08414ea58bdc1292$var$createBinaryCadProbe(bytes, extension), raw);
    panel.append(section);
}
function $08414ea58bdc1292$var$createBinaryCadProbe(bytes, extension) {
    const probe = $08414ea58bdc1292$var$probeBinaryCad(bytes);
    const details = document.createElement("details");
    details.className = "ofv-details ofv-cad-binary-probe";
    const summary = document.createElement("summary");
    summary.textContent = "\u4E8C\u8FDB\u5236\u7ED3\u6784\u63A2\u6D4B";
    const meta = document.createElement("div");
    meta.className = "ofv-archive-probe-meta";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u53EF\u8BFB\u7247\u6BB5", probe.tokens.length);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5B9E\u4F53\u5173\u952E\u8BCD", $08414ea58bdc1292$var$formatCadKeywordCounts(probe.entityCounts));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u56FE\u5C42\u7EBF\u7D22", String(probe.layerHints.length));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5757/\u5F15\u7528\u7EBF\u7D22", String(probe.blockHints.length));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5916\u90E8\u5F15\u7528", String(probe.externalRefs.length));
    $08414ea58bdc1292$var$appendMeta6(meta, "\u89E3\u6790\u7EA7\u522B", extension === "dwg" ? "\u542F\u53D1\u5F0F\u626B\u63CF" : "\u5BB9\u5668/\u6587\u672C\u626B\u63CF");
    details.append(summary, meta);
    const hints = [
        ...probe.layerHints,
        ...probe.blockHints,
        ...probe.externalRefs
    ].slice(0, 18);
    if (hints.length > 0) {
        const list = document.createElement("ul");
        list.className = "ofv-cad-probe-list";
        for (const hint of hints){
            const item = document.createElement("li");
            item.textContent = hint;
            list.append(item);
        }
        details.append(list);
    }
    if (probe.tokens.length > 0) {
        const preview = document.createElement("pre");
        preview.className = "ofv-text-block";
        preview.textContent = probe.tokens.slice(0, 80).join("\n");
        details.append(preview);
    }
    return details;
}
function $08414ea58bdc1292$var$probeBinaryCad(bytes) {
    const text = $08414ea58bdc1292$var$extractAsciiRuns(bytes.slice(0, Math.min(bytes.length, 65536)));
    const tokens = text.map((item)=>item.trim()).filter((item)=>item.length >= 3).slice(0, 240);
    const entityKeywords = [
        "LINE",
        "CIRCLE",
        "ARC",
        "LWPOLYLINE",
        "POLYLINE",
        "TEXT",
        "MTEXT",
        "INSERT",
        "BLOCK",
        "LAYER",
        "XREF",
        "DIMENSION"
    ];
    const entityCounts = /* @__PURE__ */ new Map();
    for (const token of tokens){
        const normalized = token.toUpperCase();
        for (const keyword of entityKeywords)if (normalized.includes(keyword)) entityCounts.set(keyword, (entityCounts.get(keyword) || 0) + 1);
    }
    return {
        tokens: tokens,
        entityCounts: entityCounts,
        layerHints: $08414ea58bdc1292$var$uniqueHints(tokens.filter((item)=>/layer|图层/i.test(item))),
        blockHints: $08414ea58bdc1292$var$uniqueHints(tokens.filter((item)=>/block|insert|块/i.test(item))),
        externalRefs: $08414ea58bdc1292$var$uniqueHints(tokens.filter((item)=>/xref|\.dwg|\.dxf|\.pdf|\.png|\.jpe?g/i.test(item)))
    };
}
function $08414ea58bdc1292$var$extractAsciiRuns(bytes) {
    const result = [];
    let current = "";
    for (const byte of bytes){
        if (byte >= 32 && byte <= 126) {
            current += String.fromCharCode(byte);
            continue;
        }
        if (current.length >= 3) result.push(current);
        current = "";
    }
    if (current.length >= 3) result.push(current);
    return result;
}
function $08414ea58bdc1292$var$uniqueHints(values) {
    return Array.from(new Set(values.map((value)=>value.trim()).filter(Boolean))).slice(0, 12);
}
function $08414ea58bdc1292$var$formatCadKeywordCounts(counts) {
    const text = [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 6).map(([type, count])=>`${type} ${count}`).join(", ");
    return text || "\u672A\u53D1\u73B0";
}
function $08414ea58bdc1292$var$parseStepRecords(text) {
    return [
        ...text.matchAll(/#(\d+)\s*=\s*([A-Z0-9_]+)\s*\(([\s\S]*?)\)\s*;/gi)
    ].map((match)=>({
            id: `#${match[1]}`,
            type: (match[2] || "").toUpperCase(),
            args: (match[3] || "").replace(/\s+/g, " ").trim()
        }));
}
function $08414ea58bdc1292$var$parseIgesRecords(text) {
    const parameterText = text.split(/\r?\n/).filter((line)=>line.slice(72, 73).toUpperCase() === "P" || /^\s*\d+\s*,/.test(line)).map((line)=>line.slice(0, 72).trim()).join("");
    if (!parameterText) return [];
    return parameterText.split(";").map((record)=>record.trim()).filter(Boolean).map((record)=>{
        const params = record.split(",").map((part)=>part.trim()).filter(Boolean);
        return {
            type: params[0] || "UNKNOWN",
            params: params
        };
    });
}
function $08414ea58bdc1292$var$parseAcisSatRecords(text) {
    return text.split(/\r?\n/).map((line)=>line.trim()).filter((line)=>line && !line.startsWith("End-of-ACIS-data")).filter((line)=>/[A-Za-z]/.test(line)).map((line, index)=>{
        const cleaned = line.replace(/#$/, "").trim();
        const idMatch = cleaned.match(/^(-?\d+)\s+/);
        const id = idMatch ? `#${idMatch[1]}` : `#${index + 1}`;
        const body = idMatch ? cleaned.slice(idMatch[0].length).trim() : cleaned;
        const tokens = body.split(/\s+/);
        const type = $08414ea58bdc1292$var$normalizeTextCadType(tokens.find((token)=>/[A-Za-z]/.test(token)) || tokens[0] || "record");
        return {
            id: id,
            type: type,
            args: body,
            numbers: $08414ea58bdc1292$var$extractNumbers(body)
        };
    }).filter((record)=>record.args && record.type !== "record");
}
function $08414ea58bdc1292$var$parseParasolidTextRecords(text) {
    return text.split(/\r?\n/).map((line)=>line.trim()).filter((line)=>line && !/^(BEGIN|END|HEADER|SCH|T51|P_SCHEMA)/i.test(line)).map((line, index)=>{
        const cleaned = line.replace(/[;{}]+$/g, "").trim();
        const idMatch = cleaned.match(/^#?(\d+)\s*[=:]\s*/);
        const id = idMatch ? `#${idMatch[1]}` : `#${index + 1}`;
        const body = idMatch ? cleaned.slice(idMatch[0].length).trim() : cleaned;
        const typeMatch = body.match(/^([A-Za-z_][\w.-]*)\s*[\[(]/) || body.match(/\b(type|entity|class)\s*[=:]\s*['"]?([A-Za-z_][\w.-]*)/i);
        const type = $08414ea58bdc1292$var$normalizeTextCadType(typeMatch?.[2] || typeMatch?.[1] || body.split(/\s+/)[0] || "record");
        return {
            id: id,
            type: type,
            args: body,
            numbers: $08414ea58bdc1292$var$extractNumbers(body)
        };
    }).filter((record)=>record.args && record.type !== "record");
}
function $08414ea58bdc1292$var$summarizeStepRecord(record) {
    if (record.type === "CARTESIAN_POINT") {
        const point = record.args.match(/\(([-+0-9., E]+)\)/i)?.[1];
        return point ? `\u5750\u6807 ${point.replace(/\s+/g, "")}` : record.args;
    }
    if (record.type === "DIRECTION" || record.type === "VECTOR") {
        const direction = record.args.match(/\(([-+0-9., E]+)\)/i)?.[1];
        return direction ? `\u5411\u91CF ${direction.replace(/\s+/g, "")}` : record.args;
    }
    if (record.type === "LINE" || record.type === "CIRCLE" || record.type === "ADVANCED_FACE") return record.args.slice(0, 180);
    return record.args.slice(0, 120);
}
function $08414ea58bdc1292$var$summarizeAcisRecord(record) {
    const coords = $08414ea58bdc1292$var$extractLikelyPoint(record.numbers);
    if (coords) return `\u5750\u6807 ${coords.map($08414ea58bdc1292$var$formatNumber).join(", ")}`;
    return record.args.slice(0, 160);
}
function $08414ea58bdc1292$var$summarizeParasolidRecord(record) {
    const coords = $08414ea58bdc1292$var$extractLikelyPoint(record.numbers);
    if (coords) return `\u5750\u6807 ${coords.map($08414ea58bdc1292$var$formatNumber).join(", ")}`;
    return record.args.slice(0, 160);
}
function $08414ea58bdc1292$var$extractStepGeometry(records) {
    const pointsById = /* @__PURE__ */ new Map();
    const directionsById = /* @__PURE__ */ new Map();
    const points = [];
    const lines = [];
    for (const record of records){
        if (record.type === "CARTESIAN_POINT") {
            const coords = $08414ea58bdc1292$var$parseStepTuple(record.args);
            if (coords.length >= 2) {
                const point = [
                    coords[0],
                    coords[1],
                    coords[2] || 0
                ];
                pointsById.set(record.id, point);
                points.push({
                    x: point[0],
                    y: point[1],
                    label: record.id
                });
            }
        } else if (record.type === "DIRECTION" || record.type === "VECTOR") {
            const coords = $08414ea58bdc1292$var$parseStepTuple(record.args);
            if (coords.length >= 2) directionsById.set(record.id, [
                coords[0],
                coords[1],
                coords[2] || 0
            ]);
        }
    }
    for (const record of records){
        if (record.type !== "LINE" && record.type !== "EDGE_CURVE") continue;
        const refs = [
            ...record.args.matchAll(/#\d+/g)
        ].map((match)=>match[0]);
        const firstPoint = refs.map((ref)=>pointsById.get(ref)).find(Boolean);
        if (!firstPoint) continue;
        const secondPoint = refs.slice(1).map((ref)=>pointsById.get(ref)).find((point)=>point && point !== firstPoint);
        if (secondPoint) {
            lines.push({
                x1: firstPoint[0],
                y1: firstPoint[1],
                x2: secondPoint[0],
                y2: secondPoint[1],
                label: record.id
            });
            continue;
        }
        const direction = refs.map((ref)=>directionsById.get(ref)).find(Boolean);
        if (direction) {
            const length = Math.max(10, $08414ea58bdc1292$var$estimateGeometrySpan(pointsById) * 0.25);
            lines.push({
                x1: firstPoint[0],
                y1: firstPoint[1],
                x2: firstPoint[0] + direction[0] * length,
                y2: firstPoint[1] + direction[1] * length,
                label: record.id
            });
        }
    }
    return {
        points: points,
        lines: lines
    };
}
function $08414ea58bdc1292$var$extractIgesGeometry(records) {
    const points = [];
    const lines = [];
    for (const [index, record] of records.entries()){
        if (record.type === "116") {
            const coords = record.params.slice(1).map(Number);
            if (coords.length >= 2 && coords.every((value)=>Number.isFinite(value))) points.push({
                x: coords[0],
                y: coords[1],
                label: String(index + 1)
            });
        }
        if (record.type === "110") {
            const coords = record.params.slice(1).map(Number);
            if (coords.length >= 6 && coords.every((value)=>Number.isFinite(value))) lines.push({
                x1: coords[0],
                y1: coords[1],
                x2: coords[3],
                y2: coords[4],
                label: String(index + 1)
            });
        }
    }
    return {
        points: points,
        lines: lines
    };
}
function $08414ea58bdc1292$var$extractAcisSatGeometry(records) {
    const points = $08414ea58bdc1292$var$collectTextCadPoints(records, /vertex|point|coedge|edge|straight-curve|ellipse|spline|surface/);
    const lines = [];
    for (const record of records){
        if (!/straight-curve|line|edge/i.test(record.type)) continue;
        const vectors = $08414ea58bdc1292$var$chunkVectors(record.numbers);
        if (vectors.length >= 2) {
            const [start, direction] = vectors;
            const length = Math.max(10, $08414ea58bdc1292$var$estimatePointSpan(points) * 0.25);
            lines.push({
                x1: start[0],
                y1: start[1],
                x2: start[0] + direction[0] * length,
                y2: start[1] + direction[1] * length,
                label: record.id
            });
        }
    }
    return {
        points: $08414ea58bdc1292$var$dedupeGeometryPoints(points),
        lines: lines
    };
}
function $08414ea58bdc1292$var$extractParasolidTextGeometry(records) {
    const points = $08414ea58bdc1292$var$collectTextCadPoints(records, /point|vertex|line|curve|edge/);
    const lines = [];
    for (const record of records){
        if (!/line|edge|curve/i.test(record.type)) continue;
        const vectors = $08414ea58bdc1292$var$chunkVectors(record.numbers);
        if (vectors.length >= 2) lines.push({
            x1: vectors[0][0],
            y1: vectors[0][1],
            x2: vectors[1][0],
            y2: vectors[1][1],
            label: record.id
        });
    }
    return {
        points: $08414ea58bdc1292$var$dedupeGeometryPoints(points),
        lines: lines
    };
}
function $08414ea58bdc1292$var$collectTextCadPoints(records, typePattern) {
    const points = [];
    for (const record of records){
        if (!typePattern.test(record.type)) continue;
        const point = $08414ea58bdc1292$var$extractLikelyPoint(record.numbers);
        if (point) points.push({
            x: point[0],
            y: point[1],
            label: record.id
        });
    }
    return points;
}
function $08414ea58bdc1292$var$createCadGeometryPreview(geometry, titleText) {
    if (geometry.points.length === 0 && geometry.lines.length === 0) return null;
    const wrapper = document.createElement("figure");
    wrapper.className = "ofv-cad-geometry-preview";
    const caption = document.createElement("figcaption");
    caption.textContent = `${titleText} \xB7 \u70B9 ${geometry.points.length} \xB7 \u7EBF ${geometry.lines.length}`;
    $08414ea58bdc1292$var$hideSupplementalInfo7(caption);
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "ofv-svg-stage ofv-cad-geometry-stage");
    const bounds = $08414ea58bdc1292$var$computeCadGeometryBounds(geometry);
    svg.setAttribute("viewBox", `${bounds.minX} ${bounds.minY} ${bounds.width} ${bounds.height}`);
    for (const lineData of geometry.lines.slice(0, 2e3)){
        const line = document.createElementNS(svg.namespaceURI, "line");
        line.setAttribute("x1", String(lineData.x1));
        line.setAttribute("y1", String(-lineData.y1));
        line.setAttribute("x2", String(lineData.x2));
        line.setAttribute("y2", String(-lineData.y2));
        line.setAttribute("stroke", "#2563eb");
        line.setAttribute("stroke-width", String(bounds.stroke));
        line.setAttribute("vector-effect", "non-scaling-stroke");
        svg.append(line);
    }
    for (const point of geometry.points.slice(0, 2e3)){
        const circle = document.createElementNS(svg.namespaceURI, "circle");
        circle.setAttribute("cx", String(point.x));
        circle.setAttribute("cy", String(-point.y));
        circle.setAttribute("r", String(bounds.pointRadius));
        circle.setAttribute("fill", "#dc2626");
        circle.setAttribute("vector-effect", "non-scaling-stroke");
        svg.append(circle);
    }
    wrapper.append(caption, svg);
    return {
        element: wrapper,
        svg: svg,
        bounds: bounds
    };
}
function $08414ea58bdc1292$var$createGeometryViewer(svg, bounds, ctx) {
    const initialViewBox = {
        x: bounds.minX,
        y: bounds.minY,
        width: bounds.width,
        height: bounds.height
    };
    let currentViewBox = {
        ...initialViewBox
    };
    const applyViewBox = ()=>{
        svg.setAttribute("viewBox", `${currentViewBox.x} ${currentViewBox.y} ${currentViewBox.width} ${currentViewBox.height}`);
    };
    const updateToolbarZoom = ()=>ctx.toolbar?.setZoom(initialViewBox.width / currentViewBox.width);
    applyViewBox();
    updateToolbarZoom();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in" || command === "zoom-out") {
                const factor = command === "zoom-in" ? 0.82 : 1.18;
                const centerX = currentViewBox.x + currentViewBox.width / 2;
                const centerY = currentViewBox.y + currentViewBox.height / 2;
                currentViewBox.width *= factor;
                currentViewBox.height *= factor;
                currentViewBox.x = centerX - currentViewBox.width / 2;
                currentViewBox.y = centerY - currentViewBox.height / 2;
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            if (command === "zoom-reset") {
                currentViewBox = {
                    ...initialViewBox
                };
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$parseStepTuple(args) {
    const tuple = args.match(/\(([-+0-9., E]+)\)/i)?.[1] || "";
    return tuple.split(",").map((part)=>Number(part.trim())).filter((value)=>Number.isFinite(value));
}
function $08414ea58bdc1292$var$extractNumbers(text) {
    return [
        ...text.matchAll(/[-+]?(?:\d+\.\d*|\.\d+|\d+)(?:[eE][-+]?\d+)?/g)
    ].map((match)=>Number(match[0])).filter((value)=>Number.isFinite(value));
}
function $08414ea58bdc1292$var$extractLikelyPoint(numbers) {
    if (numbers.length < 3) return null;
    const candidates = $08414ea58bdc1292$var$chunkVectors(numbers);
    const candidate = candidates.find((vector)=>vector.some((value)=>Math.abs(value) > 1e-9) && vector.every((value)=>Math.abs(value) < 1e12)) || candidates[0];
    return candidate || null;
}
function $08414ea58bdc1292$var$chunkVectors(numbers) {
    const vectors = [];
    for(let index = 0; index + 2 < numbers.length; index += 3)vectors.push([
        numbers[index],
        numbers[index + 1],
        numbers[index + 2]
    ]);
    return vectors;
}
function $08414ea58bdc1292$var$dedupeGeometryPoints(points) {
    const seen = /* @__PURE__ */ new Set();
    return points.filter((point)=>{
        const key = `${point.x.toFixed(6)},${point.y.toFixed(6)}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function $08414ea58bdc1292$var$estimatePointSpan(points) {
    if (points.length < 2) return 40;
    const xs = points.map((point)=>point.x);
    const ys = points.map((point)=>point.y);
    return Math.max(40, Math.max(...xs) - Math.min(...xs), Math.max(...ys) - Math.min(...ys));
}
function $08414ea58bdc1292$var$normalizeTextCadType(value) {
    return value.replace(/^@+/, "").replace(/[^A-Za-z0-9_.-]/g, "").toLowerCase();
}
function $08414ea58bdc1292$var$formatNumber(value) {
    return Number.isInteger(value) ? String(value) : Number(value.toPrecision(6)).toString();
}
function $08414ea58bdc1292$var$estimateGeometrySpan(points) {
    const values = [
        ...points.values()
    ];
    if (values.length < 2) return 40;
    const xs = values.map((point)=>point[0]);
    const ys = values.map((point)=>point[1]);
    return Math.max(40, Math.max(...xs) - Math.min(...xs), Math.max(...ys) - Math.min(...ys));
}
function $08414ea58bdc1292$var$computeCadGeometryBounds(geometry) {
    const xs = [];
    const ys = [];
    for (const point of geometry.points){
        xs.push(point.x);
        ys.push(-point.y);
    }
    for (const line of geometry.lines){
        xs.push(line.x1, line.x2);
        ys.push(-line.y1, -line.y2);
    }
    const minX = Math.min(...xs, 0);
    const maxX = Math.max(...xs, 100);
    const minY = Math.min(...ys, 0);
    const maxY = Math.max(...ys, 100);
    const width = Math.max(1, maxX - minX);
    const height = Math.max(1, maxY - minY);
    const padding = Math.max(width, height) * 0.08;
    return {
        minX: minX - padding,
        minY: minY - padding,
        width: width + padding * 2,
        height: height + padding * 2,
        stroke: Math.max(width, height) / 500,
        pointRadius: Math.max(width, height) / 90
    };
}
function $08414ea58bdc1292$var$summarizeIfcRecord(record) {
    const strings = $08414ea58bdc1292$var$extractStepStrings(record.args);
    const globalId = strings[0];
    const name = strings[2] || strings[1];
    const label = [
        globalId,
        name
    ].filter(Boolean).join(" \xB7 ");
    if (label) return label;
    return $08414ea58bdc1292$var$summarizeStepRecord(record);
}
function $08414ea58bdc1292$var$createIfcHierarchy(records) {
    const rows = records.filter((record)=>[
            "IFCPROJECT",
            "IFCSITE",
            "IFCBUILDING",
            "IFCBUILDINGSTOREY",
            "IFCSPACE"
        ].includes(record.type)).slice(0, 80).map((record)=>({
            id: record.id,
            type: $08414ea58bdc1292$var$ifcTypeName(record.type),
            detail: $08414ea58bdc1292$var$summarizeIfcRecord(record)
        }));
    if (rows.length === 0) return null;
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-table-scroll ofv-cad-entities";
    const title = document.createElement("strong");
    title.textContent = "BIM \u5C42\u7EA7";
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const header = document.createElement("tr");
    for (const label of [
        "ID",
        "\u5C42\u7EA7",
        "\u540D\u79F0"
    ]){
        const cell = document.createElement("th");
        cell.textContent = label;
        header.append(cell);
    }
    thead.append(header);
    const tbody = document.createElement("tbody");
    for (const row of rows){
        const tr = document.createElement("tr");
        for (const value of [
            row.id,
            row.type,
            row.detail
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            tr.append(cell);
        }
        tbody.append(tr);
    }
    table.append(thead, tbody);
    wrapper.append(title, table);
    return wrapper;
}
function $08414ea58bdc1292$var$extractStepStrings(args) {
    const values = [];
    const pattern = /'((?:''|[^'])*)'/g;
    let match;
    while(match = pattern.exec(args))values.push((match[1] || "").replace(/''/g, "'"));
    return values;
}
function $08414ea58bdc1292$var$countIfcElements(counts) {
    const elementTypes = [
        "IFCBEAM",
        "IFCBUILDINGELEMENTPROXY",
        "IFCCOLUMN",
        "IFCCOVERING",
        "IFCCURTAINWALL",
        "IFCDOOR",
        "IFCFLOWSEGMENT",
        "IFCFURNISHINGELEMENT",
        "IFCMEMBER",
        "IFCPLATE",
        "IFCRAILING",
        "IFCRAMP",
        "IFCRAMPFLIGHT",
        "IFCROOF",
        "IFCSLAB",
        "IFCSTAIR",
        "IFCSTAIRFLIGHT",
        "IFCWALL",
        "IFCWALLSTANDARDCASE",
        "IFCWINDOW"
    ];
    return elementTypes.reduce((sum, type)=>sum + (counts.get(type) || 0), 0);
}
function $08414ea58bdc1292$var$ifcTypeName(type) {
    const names = {
        IFCPROJECT: "\u9879\u76EE",
        IFCSITE: "\u573A\u5730",
        IFCBUILDING: "\u5EFA\u7B51",
        IFCBUILDINGSTOREY: "\u697C\u5C42",
        IFCSPACE: "\u7A7A\u95F4"
    };
    return names[type] || type;
}
function $08414ea58bdc1292$var$igesTypeName(type) {
    const names = {
        "100": "100 Circular Arc",
        "110": "110 Line",
        "112": "112 Parametric Spline Curve",
        "114": "114 Parametric Spline Surface",
        "116": "116 Point",
        "118": "118 Ruled Surface",
        "120": "120 Surface of Revolution",
        "126": "126 Rational B-Spline Curve",
        "128": "128 Rational B-Spline Surface",
        "144": "144 Trimmed Surface"
    };
    return names[type] || type;
}
function $08414ea58bdc1292$var$createUnsupportedCadSection(extension, fileName) {
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)("CAD \u589E\u5F3A\u63A5\u5165\u63D0\u793A");
    const meta = document.createElement("div");
    meta.className = "ofv-cad-summary";
    $08414ea58bdc1292$var$appendMeta6(meta, "\u6587\u4EF6", fileName);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u683C\u5F0F", `.${extension || "cad"}`);
    $08414ea58bdc1292$var$appendMeta6(meta, "\u5185\u7F6E\u80FD\u529B", $08414ea58bdc1292$var$unsupportedCadBuiltInLevel(extension));
    const note = document.createElement("p");
    note.textContent = $08414ea58bdc1292$var$unsupportedCadGuidance(extension);
    const actions = document.createElement("div");
    actions.className = "ofv-cad-conversion";
    const title = document.createElement("h4");
    title.textContent = "\u63A8\u8350\u589E\u5F3A\u8DEF\u7EBF";
    const list = document.createElement("ol");
    for (const suggestion of $08414ea58bdc1292$var$unsupportedCadSuggestions(extension)){
        const item = document.createElement("li");
        item.textContent = suggestion;
        list.append(item);
    }
    actions.append(title, list);
    section.append(meta, note, actions);
    return section;
}
function $08414ea58bdc1292$var$unsupportedCadBuiltInLevel(extension) {
    if (extension === "sab" || extension === "x_b") return "\u4E8C\u8FDB\u5236\u5185\u6838\u6587\u4EF6\u8BC6\u522B";
    if (extension === "3dm" || extension === "skp" || extension === "sldprt" || extension === "sldasm") return "\u4E13\u6709\u6A21\u578B\u683C\u5F0F\u8BC6\u522B";
    return "\u683C\u5F0F\u8BC6\u522B";
}
function $08414ea58bdc1292$var$unsupportedCadGuidance(extension) {
    if (extension === "sab") return "SAB \u662F ACIS \u4E8C\u8FDB\u5236\u5B9E\u4F53\u683C\u5F0F\uFF0C\u6D4F\u89C8\u5668\u7AEF\u6CA1\u6709\u7A33\u5B9A\u516C\u5F00\u89E3\u6790\u8DEF\u5F84\uFF1B\u82E5\u9700\u8981\u771F\u5B9E\u9884\u89C8\uFF0C\u5EFA\u8BAE\u5148\u8F6C\u6362\u4E3A SAT/STEP/GLB\uFF0C\u518D\u590D\u7528\u5F53\u524D\u8F7B\u91CF\u51E0\u4F55\u6216 3D \u9884\u89C8\u3002";
    if (extension === "x_b") return "x_b \u662F Parasolid \u4E8C\u8FDB\u5236\u683C\u5F0F\uFF0C\u5B8C\u6574 B-Rep \u9700\u8981\u4E13\u4E1A\u5185\u6838\uFF1B\u5EFA\u8BAE\u8F6C\u6362\u4E3A x_t/STEP/GLB\uFF0C\u6216\u901A\u8FC7 binaryRenderer \u63A5\u5165\u540E\u7AEF\u8F6C\u6362\u7ED3\u679C\u3002";
    if (extension === "3dm") return "3DM \u53EF\u901A\u8FC7 rhino3dm/rhino3dm.wasm \u505A\u524D\u7AEF\u589E\u5F3A\uFF1B\u6838\u5FC3\u5305\u6682\u4E0D\u5F3A\u7ED1\u8BE5\u5927\u578B\u4F9D\u8D56\uFF0C\u907F\u514D\u57FA\u7840\u5305\u4F53\u79EF\u660E\u663E\u81A8\u80C0\u3002";
    if (extension === "skp") return "SKP \u662F SketchUp \u4E13\u6709\u6A21\u578B\u683C\u5F0F\uFF0C\u7EAF\u524D\u7AEF\u9AD8\u4FDD\u771F\u89E3\u6790\u751F\u6001\u6709\u9650\uFF1B\u63A8\u8350\u8F6C\u6362\u4E3A glTF/GLB \u540E\u4F7F\u7528\u5185\u7F6E 3D \u9884\u89C8\u3002";
    if (extension === "sldprt" || extension === "sldasm") return "SolidWorks \u96F6\u4EF6/\u88C5\u914D\u5C5E\u4E8E\u5F3A\u4E13\u6709\u683C\u5F0F\uFF0C\u6D4F\u89C8\u5668\u5185\u65E0\u6CD5\u53EF\u9760\u89E3\u51FA\u51E0\u4F55\uFF1B\u63A8\u8350\u4F7F\u7528\u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A STEP/GLB/PDF \u540E\u9884\u89C8\u3002";
    return `.${extension || "cad"} \u5DF2\u8BC6\u522B\u4E3A\u56FE\u7EB8/\u5DE5\u7A0B\u683C\u5F0F\uFF1B\u5F53\u524D\u672A\u53D1\u73B0\u9002\u5408\u5185\u7F6E\u5230\u6838\u5FC3\u5305\u7684\u7A33\u5B9A\u7EAF\u524D\u7AEF\u9AD8\u4FDD\u771F\u89E3\u6790\u65B9\u6848\u3002`;
}
function $08414ea58bdc1292$var$unsupportedCadSuggestions(extension) {
    if (extension === "3dm") return [
        "\u901A\u8FC7 cadPlugin({ binaryRenderer }) \u6309\u9700\u52A0\u8F7D rhino3dm.wasm\uFF0C\u5C06 mesh/curve \u8F6C\u4E3A Three.js \u6216 SVG\u3002",
        "\u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A GLB/STEP/PDF\uFF0C\u518D\u590D\u7528\u5185\u7F6E 3D\u3001STEP \u6216 PDF \u9884\u89C8\u3002",
        "\u82E5\u53EA\u662F\u5F52\u6863\u548C\u4E0B\u8F7D\uFF0C\u53EF\u4FDD\u7559\u5F53\u524D\u683C\u5F0F\u8BC6\u522B\u548C\u589E\u5F3A\u63D0\u793A\u3002"
    ];
    if (extension === "sab" || extension === "x_b") return [
        "\u4F18\u5148\u8F6C\u6362\u4E3A\u6587\u672C SAT/x_t \u6216\u901A\u7528 STEP\uFF0C\u518D\u4F7F\u7528\u5185\u7F6E\u8F7B\u91CF\u7ED3\u6784\u9884\u89C8\u3002",
        "\u9AD8\u4FDD\u771F B-Rep \u53EF\u5728\u540E\u7AEF\u63A5\u5165 ACIS/Parasolid/HOOPS/ODA \u7B49\u5546\u4E1A\u5185\u6838\u540E\u8F93\u51FA PNG/PDF/SVG/GLB\u3002",
        "\u901A\u8FC7 binaryRenderer \u63A5\u5165\u4E1A\u52A1\u81EA\u5DF1\u7684\u8F6C\u6362\u670D\u52A1\uFF0C\u6838\u5FC3\u5305\u7EE7\u7EED\u4FDD\u6301\u8F7B\u91CF\u3002"
    ];
    return [
        "\u670D\u52A1\u7AEF\u8F6C\u6362\u4E3A PDF/SVG/PNG/GLB/STEP \u7B49\u6D4F\u89C8\u5668\u53CB\u597D\u683C\u5F0F\u3002",
        "\u901A\u8FC7 cadPlugin({ binaryRenderer }) \u63A5\u5165 CADViewer\u3001MxCAD\u3001\u79C1\u6709\u8F6C\u6362\u670D\u52A1\u6216\u81EA\u7814 WASM \u5F15\u64CE\u3002",
        "\u4FDD\u6301\u6838\u5FC3\u5305\u5185\u7F6E\u80FD\u529B\u8F7B\u91CF\uFF0C\u907F\u514D\u628A\u5927\u578B\u4E13\u6709\u683C\u5F0F\u89E3\u6790\u5668\u5F3A\u5236\u6253\u8FDB\u9ED8\u8BA4\u5305\u3002"
    ];
}
function $08414ea58bdc1292$var$createCadTypeList(counts, titleText = "\u7C7B\u578B\u7EDF\u8BA1") {
    const details = document.createElement("details");
    details.className = "ofv-details ofv-cad-types";
    details.open = true;
    const summary = document.createElement("summary");
    summary.textContent = titleText;
    const list = document.createElement("ul");
    for (const [type, count] of [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 80)){
        const item = document.createElement("li");
        item.textContent = `${type}: ${count}`;
        list.append(item);
    }
    details.append(summary, list);
    return details;
}
function $08414ea58bdc1292$var$createCadEntityTable(rows) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-table-scroll ofv-cad-entities";
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const header = document.createElement("tr");
    for (const label of [
        "ID",
        "\u7C7B\u578B",
        "\u6458\u8981"
    ]){
        const cell = document.createElement("th");
        cell.textContent = label;
        header.append(cell);
    }
    thead.append(header);
    const tbody = document.createElement("tbody");
    for (const row of rows){
        const tr = document.createElement("tr");
        for (const value of [
            row.id,
            row.type,
            row.detail
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            tr.append(cell);
        }
        tbody.append(tr);
    }
    table.append(thead, tbody);
    wrapper.append(table);
    return wrapper;
}
function $08414ea58bdc1292$var$countBy(values) {
    const counts = /* @__PURE__ */ new Map();
    for (const value of values)counts.set(value, (counts.get(value) || 0) + 1);
    return counts;
}
function $08414ea58bdc1292$var$appendMeta6(parent, label, value) {
    const row = document.createElement("div");
    row.className = "ofv-meta-row";
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = String(value);
    row.append(key, content);
    parent.append(row);
}
function $08414ea58bdc1292$var$formatBytes3(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
function $08414ea58bdc1292$var$byteSignature2(bytes) {
    if (bytes.length === 0) return "\u7A7A\u6587\u4EF6";
    const ascii = new TextDecoder("ascii").decode(bytes.slice(0, Math.min(bytes.length, 16))).replace(/[^\x20-\x7E]/g, ".");
    const hex = Array.from(bytes.slice(0, Math.min(bytes.length, 8))).map((byte)=>byte.toString(16).padStart(2, "0").toUpperCase()).join(" ");
    return `${ascii} (${hex})`;
}
function $08414ea58bdc1292$var$detectCadVersion(bytes, extension) {
    const header = new TextDecoder("ascii").decode(bytes.slice(0, Math.min(bytes.length, 32)));
    if (extension === "dwg") {
        const match = header.match(/AC\d{4}/);
        if (!match) return "\u672A\u77E5 DWG \u7248\u672C";
        const names = {
            AC1009: "AutoCAD R12",
            AC1012: "AutoCAD R13",
            AC1014: "AutoCAD R14",
            AC1015: "AutoCAD 2000/2002",
            AC1018: "AutoCAD 2004/2005/2006",
            AC1021: "AutoCAD 2007/2008/2009",
            AC1024: "AutoCAD 2010/2011/2012",
            AC1027: "AutoCAD 2013/2014/2015/2016/2017",
            AC1032: "AutoCAD 2018+"
        };
        return `${match[0]}${names[match[0]] ? ` \xB7 ${names[match[0]]}` : ""}`;
    }
    if (header.startsWith("(DWF") || header.includes("DWF")) return header.split(/\s+/)[0] || "DWF";
    return "\u672A\u77E5\u7248\u672C";
}
function $08414ea58bdc1292$var$detectCadContainer(bytes) {
    if (bytes[0] === 80 && bytes[1] === 75) return "ZIP/PK \u538B\u7F29\u5BB9\u5668";
    if (bytes[0] === 31 && bytes[1] === 139) return "GZIP \u538B\u7F29\u6D41";
    if (bytes[0] === 40 && bytes[1] === 68 && bytes[2] === 87 && bytes[3] === 70) return "DWF ASCII \u5934";
    return "\u4E8C\u8FDB\u5236\u6D41";
}
function $08414ea58bdc1292$var$hexPreview(bytes) {
    const rows = [];
    const limit = Math.min(bytes.length, 256);
    for(let offset = 0; offset < limit; offset += 16){
        const slice = bytes.slice(offset, offset + 16);
        const hex = Array.from(slice).map((byte)=>byte.toString(16).padStart(2, "0").toUpperCase()).join(" ").padEnd(47, " ");
        const ascii = Array.from(slice).map((byte)=>byte >= 32 && byte <= 126 ? String.fromCharCode(byte) : ".").join("");
        rows.push(`${offset.toString(16).padStart(8, "0").toUpperCase()}  ${hex}  ${ascii}`);
    }
    if (bytes.length > limit) rows.push(`... \u4EC5\u5C55\u793A\u524D ${limit} \u5B57\u8282\uFF0C\u5171 ${bytes.length} \u5B57\u8282`);
    return rows.join("\n") || "\u65E0\u53EF\u5C55\u793A\u5B57\u8282\u3002";
}
function $08414ea58bdc1292$var$renderDxf(panel, dxf, ctx) {
    const pairs = dxf.split(/\r?\n/).map((line)=>line.trim());
    const lines = [];
    const circles = [];
    const arcs = [];
    const points = [];
    const polylines = [];
    const texts = [];
    for(let index = 0; index < pairs.length; index += 2){
        const code = pairs[index];
        const value = pairs[index + 1];
        if (code === "0" && value === "LINE") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            lines.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: [
                    Number(entity["10"] || 0),
                    Number(entity["20"] || 0),
                    Number(entity["11"] || 0),
                    Number(entity["21"] || 0)
                ]
            });
        }
        if (code === "0" && value === "CIRCLE") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            circles.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: [
                    Number(entity["10"] || 0),
                    Number(entity["20"] || 0),
                    Number(entity["40"] || 0)
                ]
            });
        }
        if (code === "0" && value === "ARC") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            arcs.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: [
                    Number(entity["10"] || 0),
                    Number(entity["20"] || 0),
                    Number(entity["40"] || 0),
                    Number(entity["50"] || 0),
                    Number(entity["51"] || 0)
                ]
            });
        }
        if (code === "0" && value === "POINT") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            points.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: [
                    Number(entity["10"] || 0),
                    Number(entity["20"] || 0)
                ]
            });
        }
        if (code === "0" && value === "LWPOLYLINE") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            const entityPairs = $08414ea58bdc1292$var$readEntityPairs(pairs, index + 2);
            const polyline = $08414ea58bdc1292$var$readPolylinePoints(entityPairs);
            if (polyline.length > 1) polylines.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: polyline
            });
        }
        if (code === "0" && value === "POLYLINE") {
            const result = $08414ea58bdc1292$var$readLegacyPolyline(pairs, index + 2);
            if (result.points.length > 1) polylines.push({
                layer: result.layer,
                value: result.points
            });
            index = Math.max(index, result.endIndex - 2);
        }
        if (code === "0" && (value === "TEXT" || value === "MTEXT")) {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            const text = $08414ea58bdc1292$var$normalizeDxfText(entity["1"] || entity["3"] || "");
            if (text) texts.push({
                layer: $08414ea58bdc1292$var$normalizeLayerName(entity["8"]),
                value: [
                    Number(entity["10"] || 0),
                    Number(entity["20"] || 0),
                    text,
                    Math.max(1, Number(entity["40"] || 12))
                ]
            });
        }
    }
    const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)(`DXF \u57FA\u7840\u9884\u89C8`);
    $08414ea58bdc1292$var$hideSupplementalInfo7(section.querySelector("h3"));
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "ofv-svg-stage");
    const bounds = $08414ea58bdc1292$var$computeBounds(lines, circles, arcs, points, polylines, texts);
    const initialViewBox = {
        x: bounds.minX,
        y: bounds.minY,
        width: bounds.width,
        height: bounds.height
    };
    let currentViewBox = {
        ...initialViewBox
    };
    const applyViewBox = ()=>{
        svg.setAttribute("viewBox", `${currentViewBox.x} ${currentViewBox.y} ${currentViewBox.width} ${currentViewBox.height}`);
    };
    applyViewBox();
    for (const item of lines.slice(0, 3e3)){
        const [x1, y1, x2, y2] = item.value;
        const line = document.createElementNS(svg.namespaceURI, "line");
        line.setAttribute("x1", String(x1));
        line.setAttribute("y1", String(-y1));
        line.setAttribute("x2", String(x2));
        line.setAttribute("y2", String(-y2));
        line.setAttribute("stroke", "#111827");
        line.setAttribute("stroke-width", String(bounds.stroke));
        $08414ea58bdc1292$var$applyLayer(line, item.layer);
        svg.append(line);
    }
    for (const item of circles.slice(0, 1e3)){
        const [cx, cy, radius] = item.value;
        const circle = document.createElementNS(svg.namespaceURI, "circle");
        circle.setAttribute("cx", String(cx));
        circle.setAttribute("cy", String(-cy));
        circle.setAttribute("r", String(Math.abs(radius)));
        circle.setAttribute("fill", "none");
        circle.setAttribute("stroke", "#2563eb");
        circle.setAttribute("stroke-width", String(bounds.stroke));
        $08414ea58bdc1292$var$applyLayer(circle, item.layer);
        svg.append(circle);
    }
    for (const item of arcs.slice(0, 1e3)){
        const [cx, cy, radius, startAngle, endAngle] = item.value;
        const path = document.createElementNS(svg.namespaceURI, "path");
        path.setAttribute("d", $08414ea58bdc1292$var$arcPath(cx, -cy, Math.abs(radius), -startAngle, -endAngle));
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "#7c3aed");
        path.setAttribute("stroke-width", String(bounds.stroke));
        $08414ea58bdc1292$var$applyLayer(path, item.layer);
        svg.append(path);
    }
    for (const item of polylines.slice(0, 2e3)){
        const polyline = item.value;
        const path = document.createElementNS(svg.namespaceURI, "polyline");
        path.setAttribute("points", polyline.map(([x, y])=>`${x},${-y}`).join(" "));
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "#0f766e");
        path.setAttribute("stroke-width", String(bounds.stroke));
        $08414ea58bdc1292$var$applyLayer(path, item.layer);
        svg.append(path);
    }
    for (const item of points.slice(0, 3e3)){
        const [x, y] = item.value;
        const point = document.createElementNS(svg.namespaceURI, "circle");
        point.setAttribute("cx", String(x));
        point.setAttribute("cy", String(-y));
        point.setAttribute("r", String(bounds.stroke * 2));
        point.setAttribute("fill", "#dc2626");
        $08414ea58bdc1292$var$applyLayer(point, item.layer);
        svg.append(point);
    }
    for (const item of texts.slice(0, 500)){
        const [x, y, text, height] = item.value;
        const label = document.createElementNS(svg.namespaceURI, "text");
        label.setAttribute("x", String(x));
        label.setAttribute("y", String(-y));
        label.setAttribute("font-size", String(Math.max(height, bounds.stroke * 8)));
        label.setAttribute("fill", "currentColor");
        label.textContent = text;
        $08414ea58bdc1292$var$applyLayer(label, item.layer);
        svg.append(label);
    }
    const layers = Array.from(new Set([
        ...lines,
        ...circles,
        ...arcs,
        ...points,
        ...polylines,
        ...texts
    ].map((item)=>item.layer))).sort((a, b)=>a.localeCompare(b));
    if (layers.length > 1) {
        const layerControls = $08414ea58bdc1292$var$createLayerControls(svg, layers);
        $08414ea58bdc1292$var$hideSupplementalInfo7(layerControls);
        section.append(layerControls);
    }
    const note = document.createElement("p");
    note.textContent = `\u5DF2\u63D0\u53D6 LINE ${lines.length} \u4E2A\u3001CIRCLE ${circles.length} \u4E2A\u3001ARC ${arcs.length} \u4E2A\u3001POLYLINE ${polylines.length} \u4E2A\u3001POINT ${points.length} \u4E2A\u3001TEXT ${texts.length} \u4E2A\u3002`;
    $08414ea58bdc1292$var$hideSupplementalInfo7(note);
    section.append(note, svg);
    panel.append(section);
    const updateToolbarZoom = ()=>{
        ctx.toolbar?.setZoom(initialViewBox.width / currentViewBox.width);
    };
    updateToolbarZoom();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
        },
        command (command) {
            if (command === "zoom-in" || command === "zoom-out") {
                const factor = command === "zoom-in" ? 0.82 : 1.18;
                const centerX = currentViewBox.x + currentViewBox.width / 2;
                const centerY = currentViewBox.y + currentViewBox.height / 2;
                currentViewBox.width *= factor;
                currentViewBox.height *= factor;
                currentViewBox.x = centerX - currentViewBox.width / 2;
                currentViewBox.y = centerY - currentViewBox.height / 2;
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            if (command === "zoom-reset") {
                currentViewBox = {
                    ...initialViewBox
                };
                applyViewBox();
                updateToolbarZoom();
                return true;
            }
            return false;
        },
        destroy () {
            ctx.toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$applyLayer(element, layer) {
    element.setAttribute("data-layer", layer);
}
function $08414ea58bdc1292$var$createLayerControls(svg, layers) {
    const controls = document.createElement("div");
    controls.className = "ofv-cad-layers";
    const title = document.createElement("strong");
    title.textContent = `\u56FE\u5C42 ${layers.length}`;
    controls.append(title);
    for (const layer of layers){
        const label = document.createElement("label");
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = true;
        checkbox.addEventListener("change", ()=>{
            for (const element of svg.querySelectorAll(`[data-layer="${$08414ea58bdc1292$var$escapeCssAttribute(layer)}"]`))element.style.display = checkbox.checked ? "" : "none";
        });
        const name = document.createElement("span");
        name.textContent = layer;
        label.append(checkbox, name);
        controls.append(label);
    }
    return controls;
}
function $08414ea58bdc1292$var$readEntity(pairs, start) {
    const entity = {};
    for(let index = start; index < pairs.length; index += 2){
        const code = pairs[index];
        const value = pairs[index + 1];
        if (code === "0") break;
        entity[code] = value;
    }
    return entity;
}
function $08414ea58bdc1292$var$readEntityPairs(pairs, start) {
    const entityPairs = [];
    for(let index = start; index < pairs.length; index += 2){
        const code = pairs[index];
        const value = pairs[index + 1];
        if (code === "0") break;
        entityPairs.push([
            code,
            value
        ]);
    }
    return entityPairs;
}
function $08414ea58bdc1292$var$readPolylinePoints(entityPairs) {
    const points = [];
    let x;
    for (const [code, value] of entityPairs){
        if (code === "10") x = Number(value);
        if (code === "20" && x !== void 0) {
            points.push([
                x,
                Number(value)
            ]);
            x = void 0;
        }
    }
    return points;
}
function $08414ea58bdc1292$var$readLegacyPolyline(pairs, start) {
    let layer = "0";
    const points = [];
    for(let index = start; index < pairs.length; index += 2){
        const code = pairs[index];
        const value = pairs[index + 1];
        if (code === "0" && value === "SEQEND") return {
            layer: layer,
            points: points,
            endIndex: index + 2
        };
        if (code === "8") layer = $08414ea58bdc1292$var$normalizeLayerName(value);
        if (code === "0" && value === "VERTEX") {
            const entity = $08414ea58bdc1292$var$readEntity(pairs, index + 2);
            points.push([
                Number(entity["10"] || 0),
                Number(entity["20"] || 0)
            ]);
        }
    }
    return {
        layer: layer,
        points: points,
        endIndex: pairs.length
    };
}
function $08414ea58bdc1292$var$normalizeLayerName(layer) {
    return layer?.trim() || "0";
}
function $08414ea58bdc1292$var$escapeCssAttribute(value) {
    if (typeof CSS !== "undefined" && CSS.escape) return CSS.escape(value);
    return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}
function $08414ea58bdc1292$var$normalizeDxfText(text) {
    return text.replace(/\\P/g, "\n").replace(/\\[A-Za-z][^;{}\\]*;/g, "").replace(/\\[A-Za-z]/g, "").replace(/\{\\[^;]+;/g, "").replace(/[{}]/g, "").trim();
}
function $08414ea58bdc1292$var$arcPath(cx, cy, radius, startAngle, endAngle) {
    const start = $08414ea58bdc1292$var$polarToCartesian(cx, cy, radius, endAngle);
    const end = $08414ea58bdc1292$var$polarToCartesian(cx, cy, radius, startAngle);
    const delta = Math.abs(endAngle - startAngle);
    const largeArc = delta <= 180 ? "0" : "1";
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArc} 0 ${end.x} ${end.y}`;
}
function $08414ea58bdc1292$var$polarToCartesian(cx, cy, radius, angleDegrees) {
    const angle = angleDegrees * Math.PI / 180;
    return {
        x: cx + radius * Math.cos(angle),
        y: cy + radius * Math.sin(angle)
    };
}
function $08414ea58bdc1292$var$hideSupplementalInfo7(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$hideSuccessfulSectionHeading3(section) {
    const heading = section.querySelector("h3");
    if (heading) $08414ea58bdc1292$var$hideSupplementalInfo7(heading);
}
function $08414ea58bdc1292$var$computeBounds(lines, circles, arcs, points, polylines, texts) {
    const xs = lines.flatMap(({ value: [x1, , x2] })=>[
            x1,
            x2
        ]);
    const ys = lines.flatMap(({ value: [, y1, , y2] })=>[
            -y1,
            -y2
        ]);
    for (const { value: [cx, cy, radius] } of circles){
        xs.push(cx - radius, cx + radius);
        ys.push(-cy - radius, -cy + radius);
    }
    for (const { value: [cx, cy, radius] } of arcs){
        xs.push(cx - radius, cx + radius);
        ys.push(-cy - radius, -cy + radius);
    }
    for (const { value: [x, y] } of points){
        xs.push(x);
        ys.push(-y);
    }
    for (const { value: polyline } of polylines)for (const [x, y] of polyline){
        xs.push(x);
        ys.push(-y);
    }
    for (const { value: [x, y, text, height2] } of texts){
        xs.push(x, x + text.length * height2 * 0.6);
        ys.push(-y, -y - height2);
    }
    const minX = Math.min(...xs, 0);
    const maxX = Math.max(...xs, 100);
    const minY = Math.min(...ys, 0);
    const maxY = Math.max(...ys, 100);
    const width = Math.max(1, maxX - minX);
    const height = Math.max(1, maxY - minY);
    return {
        minX: minX,
        minY: minY,
        width: width,
        height: height,
        stroke: Math.max(width, height) / 600
    };
}
// src/plugins/model3d.ts
var $08414ea58bdc1292$var$modelExtensions = /* @__PURE__ */ new Set([
    "gltf",
    "glb",
    "obj",
    "stl",
    "fbx",
    "dae",
    "ply",
    "3mf",
    "3ds",
    "usd",
    "usda",
    "usdc",
    "usdz",
    "wrl",
    "vrml"
]);
var $08414ea58bdc1292$var$modelMimeTypes = /* @__PURE__ */ new Set([
    "model/gltf+json",
    "model/gltf-binary",
    "model/stl",
    "model/obj",
    "model/vnd.collada+xml",
    "model/3mf",
    "model/3ds",
    "model/vnd.usd",
    "model/vnd.usdz+zip",
    "model/vrml",
    "application/sla",
    "application/vnd.ms-pki.stl",
    "application/ply",
    "application/vnd.autodesk.fbx"
]);
var $08414ea58bdc1292$var$modelMimeFormatMap = {
    "model/gltf+json": "gltf",
    "model/gltf-binary": "glb",
    "model/stl": "stl",
    "model/obj": "obj",
    "model/vnd.collada+xml": "dae",
    "model/3mf": "3mf",
    "model/3ds": "3ds",
    "model/vnd.usd": "usd",
    "model/vnd.usdz+zip": "usdz",
    "model/vrml": "wrl",
    "application/sla": "stl",
    "application/vnd.ms-pki.stl": "stl",
    "application/ply": "ply",
    "application/vnd.autodesk.fbx": "fbx"
};
var $08414ea58bdc1292$var$textLikeExtensions = /* @__PURE__ */ new Set([
    "json",
    "txt",
    "md",
    "xml",
    "yaml",
    "yml",
    "csv",
    "tsv",
    "js",
    "ts",
    "tsx",
    "jsx",
    "html",
    "css"
]);


function $08414ea58bdc1292$export$ee4cd99c64e06be0() {
    return {
        name: "model3d",
        match (file) {
            return $08414ea58bdc1292$var$modelExtensions.has(file.extension) || $08414ea58bdc1292$var$modelMimeTypes.has(file.mimeType) && (file.extension === "" || file.extension === "bin" || !$08414ea58bdc1292$var$textLikeExtensions.has(file.extension));
        },
        async render (ctx) {
            const THREE = await (parcelRequire("61iX9"));
            const { OrbitControls: OrbitControls } = await (parcelRequire("fQ845"));
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const stage = document.createElement("div");
            stage.className = "ofv-model-stage";
            ctx.viewport.append(stage);
            const scene = new THREE.Scene();
            scene.background = new THREE.Color(15987958);
            const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 1e4);
            camera.position.set(2.5, 2, 3.5);
            let renderer;
            try {
                renderer = new THREE.WebGLRenderer({
                    antialias: true
                });
            } catch  {
                stage.remove();
                return $08414ea58bdc1292$var$renderModelFallback(ctx, url, isExternal, "\u5F53\u524D\u6D4F\u89C8\u5668\u6216\u8BBE\u5907\u4E0D\u652F\u6301 WebGL\uFF0C\u65E0\u6CD5\u76F4\u63A5\u6E32\u67D3 3D \u6A21\u578B\u3002");
            }
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            renderer.outputColorSpace = THREE.SRGBColorSpace;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.toneMappingExposure = 1.08;
            stage.append(renderer.domElement);
            const controls = new OrbitControls(camera, renderer.domElement);
            controls.enableDamping = true;
            scene.add(new THREE.HemisphereLight(16777215, 9741240, 2.8));
            const directional = new THREE.DirectionalLight(16777215, 2);
            directional.position.set(4, 6, 5);
            scene.add(directional);
            scene.add(new THREE.GridHelper(10, 10, 13358561, 15067115));
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$modelMimeFormatMap);
            const modelUrl = $08414ea58bdc1292$var$resolveModelUrl(extension, url, ctx.file.url);
            const loaded = await $08414ea58bdc1292$var$loadModel(extension, modelUrl, THREE).catch(()=>void 0);
            if (!loaded) {
                controls.dispose();
                renderer.dispose();
                stage.remove();
                return $08414ea58bdc1292$var$renderModelFallback(ctx, url, isExternal, "\u65E0\u6CD5\u89E3\u6790\u5F53\u524D 3D \u6A21\u578B\u5185\u5BB9\u3002");
            }
            if (loaded.message) {
                const message = document.createElement("div");
                message.className = "ofv-model-message";
                message.textContent = loaded.message;
                stage.append(message);
            }
            const object = loaded.object;
            const initialRotation = {
                x: object.rotation?.x ?? 0,
                y: object.rotation?.y ?? 0,
                z: object.rotation?.z ?? 0
            };
            scene.add(object);
            const initialFrame = $08414ea58bdc1292$var$frameObject(object, camera, controls, THREE);
            const measurement = $08414ea58bdc1292$var$measureObject(object, THREE);
            stage.append($08414ea58bdc1292$var$createMeasurementPanel(measurement));
            stage.append($08414ea58bdc1292$var$createMaterialPanel($08414ea58bdc1292$var$collectMaterialStats(object)));
            let animationFrame = 0;
            const animate = ()=>{
                controls.update();
                renderer.render(scene, camera);
                animationFrame = window.requestAnimationFrame(animate);
            };
            animate();
            const resize = (size)=>{
                const width = Math.max(1, size.width);
                const height = Math.max(1, size.height);
                camera.aspect = width / height;
                camera.updateProjectionMatrix();
                renderer.setSize(width, height, false);
            };
            resize(ctx.size);
            const updateToolbarZoom = ()=>{
                const currentDistance = $08414ea58bdc1292$var$vectorDistance(camera.position, controls.target);
                const initialDistance = $08414ea58bdc1292$var$vectorDistance(initialFrame.cameraPosition, initialFrame.target);
                ctx.toolbar?.setZoom(initialDistance > 0 ? initialDistance / currentDistance : void 0);
            };
            updateToolbarZoom();
            return {
                canCommand (command) {
                    return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left";
                },
                command (command) {
                    if (command === "zoom-in" || command === "zoom-out") {
                        const factor = command === "zoom-in" ? 0.82 : 1.18;
                        camera.position.sub(controls.target).multiplyScalar(factor).add(controls.target);
                        camera.updateProjectionMatrix();
                        controls.update();
                        updateToolbarZoom();
                        return true;
                    }
                    if (command === "zoom-reset") {
                        camera.position.copy(initialFrame.cameraPosition);
                        controls.target.copy(initialFrame.target);
                        if (object.rotation) {
                            object.rotation.set?.(initialRotation.x, initialRotation.y, initialRotation.z);
                            object.rotation.x = initialRotation.x;
                            object.rotation.y = initialRotation.y;
                            object.rotation.z = initialRotation.z;
                        }
                        camera.near = initialFrame.near;
                        camera.far = initialFrame.far;
                        camera.updateProjectionMatrix();
                        controls.update();
                        updateToolbarZoom();
                        return true;
                    }
                    if (command === "rotate-right" || command === "rotate-left") {
                        object.rotateY(command === "rotate-right" ? Math.PI / 8 : -Math.PI / 8);
                        return true;
                    }
                    return false;
                },
                resize: resize,
                destroy () {
                    ctx.toolbar?.setZoom(void 0);
                    window.cancelAnimationFrame(animationFrame);
                    controls.dispose();
                    renderer.dispose();
                    $08414ea58bdc1292$var$disposeObject(object, THREE);
                    stage.remove();
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$vectorDistance(a, b) {
    if (typeof a.distanceTo === "function") return a.distanceTo(b);
    return Math.hypot(a.x - b.x, a.y - b.y, a.z - b.z);
}
function $08414ea58bdc1292$var$renderModelFallback(ctx, url, isExternal, message) {
    const panel = document.createElement("div");
    panel.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = "3D \u9884\u89C8\u4E0D\u53EF\u7528";
    const detail = document.createElement("span");
    detail.textContent = `${message} ${ctx.file.name}`;
    const download = document.createElement("a");
    download.href = url;
    download.download = ctx.file.name;
    download.textContent = "\u4E0B\u8F7D\u6587\u4EF6";
    panel.append(title, detail, download);
    ctx.viewport.classList.add("ofv-center");
    ctx.viewport.append(panel);
    return {
        canCommand () {
            return false;
        },
        destroy () {
            ctx.viewport.classList.remove("ofv-center");
            panel.remove();
            (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
        }
    };
}
function $08414ea58bdc1292$var$resolveModelUrl(extension, objectUrl, sourceUrl) {
    if (extension === "gltf" && sourceUrl) return sourceUrl;
    return objectUrl;
}










async function $08414ea58bdc1292$var$loadModel(extension, url, THREE) {
    if (extension === "gltf" || extension === "glb") {
        const { GLTFLoader: GLTFLoader } = await (parcelRequire("ll1ry"));
        const gltf = await new GLTFLoader().loadAsync(url);
        return {
            object: gltf.scene
        };
    }
    if (extension === "obj") {
        const { OBJLoader: OBJLoader } = await (parcelRequire("W1Aa1"));
        return {
            object: await new OBJLoader().loadAsync(url)
        };
    }
    if (extension === "fbx") {
        const { FBXLoader: FBXLoader } = await (parcelRequire("cYIdJ"));
        return {
            object: await new FBXLoader().loadAsync(url)
        };
    }
    if (extension === "dae") {
        const { ColladaLoader: ColladaLoader } = await (parcelRequire("drQpR"));
        const collada = await new ColladaLoader().loadAsync(url);
        if (!collada) throw new Error("Collada loader returned no scene.");
        return {
            object: collada.scene
        };
    }
    if (extension === "stl") {
        const { STLLoader: STLLoader } = await (parcelRequire("hEPWJ"));
        const geometry2 = await new STLLoader().loadAsync(url);
        const material2 = new THREE.MeshStandardMaterial({
            color: 6583435,
            roughness: 0.55
        });
        return {
            object: new THREE.Mesh(geometry2, material2)
        };
    }
    if (extension === "ply") {
        const { PLYLoader: PLYLoader } = await (parcelRequire("bcf6M"));
        const geometry2 = await new PLYLoader().loadAsync(url);
        const material2 = new THREE.MeshStandardMaterial({
            color: 6583435,
            roughness: 0.55
        });
        return {
            object: new THREE.Mesh(geometry2, material2)
        };
    }
    if (extension === "3mf") {
        const { ThreeMFLoader: ThreeMFLoader } = await (parcelRequire("vuJtl"));
        return {
            object: await new ThreeMFLoader().loadAsync(url)
        };
    }
    if (extension === "3ds") {
        const { TDSLoader: TDSLoader } = await (parcelRequire("5FBLW"));
        return {
            object: await new TDSLoader().loadAsync(url)
        };
    }
    if (extension === "usd" || extension === "usda" || extension === "usdc" || extension === "usdz") {
        const { USDLoader: USDLoader } = await (parcelRequire("jeNGx"));
        return {
            object: await new USDLoader().loadAsync(url)
        };
    }
    if (extension === "wrl" || extension === "vrml") {
        const { VRMLLoader: VRMLLoader } = await (parcelRequire("4mqV1"));
        return {
            object: await new VRMLLoader().loadAsync(url)
        };
    }
    const group = new THREE.Group();
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshStandardMaterial({
        color: 6583435
    });
    const mesh = new THREE.Mesh(geometry, material);
    group.add(mesh);
    return {
        object: group,
        message: `.${extension} \u5DF2\u8BC6\u522B\u4E3A 3D \u683C\u5F0F\uFF0C\u5F53\u524D\u5185\u7F6E\u6E32\u67D3\u4F18\u5148\u652F\u6301 gltf/glb/obj/stl/fbx/dae/ply/3mf/3ds/usd/usdz/vrml\u3002`
    };
}
function $08414ea58bdc1292$var$frameObject(object, camera, controls, THREE) {
    const box = new THREE.Box3().setFromObject(object);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());
    const maxSize = Math.max(size.x, size.y, size.z, 1);
    const distance = maxSize * 2.4;
    camera.position.set(center.x + distance, center.y + distance * 0.7, center.z + distance);
    camera.near = Math.max(distance / 1e3, 0.01);
    camera.far = distance * 1e3;
    camera.updateProjectionMatrix();
    controls.target.copy(center);
    controls.update();
    return {
        cameraPosition: camera.position.clone(),
        target: controls.target.clone(),
        near: camera.near,
        far: camera.far
    };
}
function $08414ea58bdc1292$var$measureObject(object, THREE) {
    const box = new THREE.Box3().setFromObject(object);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());
    return {
        width: size.x,
        height: size.y,
        depth: size.z,
        diagonal: Math.sqrt(size.x ** 2 + size.y ** 2 + size.z ** 2),
        center: {
            x: center.x,
            y: center.y,
            z: center.z
        }
    };
}
function $08414ea58bdc1292$var$createMeasurementPanel(measurement) {
    const panel = document.createElement("div");
    panel.className = "ofv-model-measure";
    panel.hidden = true;
    panel.setAttribute("aria-hidden", "true");
    panel.style.display = "none";
    const title = document.createElement("strong");
    title.textContent = "\u6A21\u578B\u6D4B\u91CF";
    const list = document.createElement("dl");
    $08414ea58bdc1292$var$appendMeasure(list, "\u5BBD", measurement.width);
    $08414ea58bdc1292$var$appendMeasure(list, "\u9AD8", measurement.height);
    $08414ea58bdc1292$var$appendMeasure(list, "\u6DF1", measurement.depth);
    $08414ea58bdc1292$var$appendMeasure(list, "\u5BF9\u89D2\u7EBF", measurement.diagonal);
    $08414ea58bdc1292$var$appendMeasure(list, "\u4E2D\u5FC3", `${$08414ea58bdc1292$var$formatMeasure(measurement.center.x)}, ${$08414ea58bdc1292$var$formatMeasure(measurement.center.y)}, ${$08414ea58bdc1292$var$formatMeasure(measurement.center.z)}`);
    panel.append(title, list);
    return panel;
}
function $08414ea58bdc1292$var$appendMeasure(list, label, value) {
    const term = document.createElement("dt");
    term.textContent = label;
    const detail = document.createElement("dd");
    detail.textContent = typeof value === "number" ? $08414ea58bdc1292$var$formatMeasure(value) : value;
    list.append(term, detail);
}
function $08414ea58bdc1292$var$formatMeasure(value) {
    if (!Number.isFinite(value)) return "-";
    const rounded = Math.abs(value) >= 100 ? value.toFixed(1) : value.toFixed(3);
    return rounded.replace(/\.?0+$/, "");
}
function $08414ea58bdc1292$var$collectMaterialStats(object) {
    const materials = /* @__PURE__ */ new Set();
    const textures = /* @__PURE__ */ new Set();
    const slots = /* @__PURE__ */ new Set();
    const names = /* @__PURE__ */ new Set();
    let meshes = 0;
    object.traverse((child)=>{
        const mesh = child;
        if (!mesh.geometry || !mesh.material) return;
        meshes += 1;
        for (const material of $08414ea58bdc1292$var$normalizeMaterials(mesh.material)){
            materials.add(material);
            if (material.name) names.add(material.name);
            for (const slot of $08414ea58bdc1292$var$textureSlots){
                const texture = material[slot];
                if (texture) {
                    textures.add(texture);
                    slots.add(slot);
                }
            }
        }
    });
    return {
        meshes: meshes,
        materials: materials.size,
        textures: textures.size,
        slots: [
            ...slots
        ],
        names: [
            ...names
        ].slice(0, 6)
    };
}
function $08414ea58bdc1292$var$createMaterialPanel(stats) {
    const panel = document.createElement("div");
    panel.className = "ofv-model-materials";
    panel.hidden = true;
    panel.setAttribute("aria-hidden", "true");
    panel.style.display = "none";
    const title = document.createElement("strong");
    title.textContent = "\u6750\u8D28\u8D34\u56FE";
    const list = document.createElement("dl");
    $08414ea58bdc1292$var$appendMaterialStat(list, "\u7F51\u683C", stats.meshes);
    $08414ea58bdc1292$var$appendMaterialStat(list, "\u6750\u8D28", stats.materials);
    $08414ea58bdc1292$var$appendMaterialStat(list, "\u8D34\u56FE", stats.textures);
    $08414ea58bdc1292$var$appendMaterialStat(list, "\u69FD\u4F4D", stats.slots.length > 0 ? stats.slots.join(", ") : "-");
    if (stats.names.length > 0) $08414ea58bdc1292$var$appendMaterialStat(list, "\u540D\u79F0", stats.names.join(", "));
    panel.append(title, list);
    return panel;
}
function $08414ea58bdc1292$var$appendMaterialStat(list, label, value) {
    const term = document.createElement("dt");
    term.textContent = label;
    const detail = document.createElement("dd");
    detail.textContent = String(value);
    list.append(term, detail);
}
function $08414ea58bdc1292$var$disposeObject(object, THREE) {
    object.traverse((child)=>{
        const mesh = child;
        if (mesh.geometry) mesh.geometry.dispose();
        const material = mesh.material;
        for (const item of $08414ea58bdc1292$var$normalizeMaterials(material)){
            $08414ea58bdc1292$var$disposeMaterialTextures(item);
            item.dispose();
        }
    });
}
var $08414ea58bdc1292$var$textureSlots = [
    "map",
    "aoMap",
    "alphaMap",
    "bumpMap",
    "displacementMap",
    "emissiveMap",
    "envMap",
    "lightMap",
    "metalnessMap",
    "normalMap",
    "roughnessMap"
];
function $08414ea58bdc1292$var$normalizeMaterials(material) {
    if (!material) return [];
    return Array.isArray(material) ? material : [
        material
    ];
}
function $08414ea58bdc1292$var$disposeMaterialTextures(material) {
    for (const slot of $08414ea58bdc1292$var$textureSlots){
        const texture = material[slot];
        texture?.dispose?.();
    }
}
// src/plugins/gis.ts
var $08414ea58bdc1292$var$gisExtensions = /* @__PURE__ */ new Set([
    "geojson",
    "topojson",
    "kml",
    "kmz",
    "gpx",
    "shp"
]);
var $08414ea58bdc1292$var$gisMimeFormatMap = {
    "application/geo+json": "geojson",
    "application/vnd.geo+json": "geojson",
    "application/topo+json": "topojson",
    "application/vnd.google-earth.kml+xml": "kml",
    "application/vnd.google-earth.kmz": "kmz",
    "application/gpx+xml": "gpx"
};
function $08414ea58bdc1292$var$loadLeafletCss() {
    const id = "ofv-leaflet-css";
    if (document.getElementById(id)) return Promise.resolve();
    return new Promise((resolve)=>{
        const link = document.createElement("link");
        let settled = false;
        const done = ()=>{
            if (!settled) {
                settled = true;
                resolve();
            }
        };
        link.id = id;
        link.rel = "stylesheet";
        link.href = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css";
        link.onload = done;
        link.onerror = done;
        document.head.appendChild(link);
        window.setTimeout(done, 0);
    });
}





function $08414ea58bdc1292$export$b8015381bb382c56() {
    return {
        name: "gis",
        match (file) {
            return $08414ea58bdc1292$var$gisExtensions.has($08414ea58bdc1292$var$resolveGisFormat(file)) || Boolean($08414ea58bdc1292$var$gisMimeFormatMap[file.mimeType]);
        },
        async render (ctx) {
            await $08414ea58bdc1292$var$loadLeafletCss();
            const [L, topojson, toGeoJSON, shpjs, JSZip7] = await Promise.all([
                (parcelRequire("fZm3J")),
                (parcelRequire("cNA8S")),
                (parcelRequire("7qfKa")),
                (parcelRequire("lolWM")),
                Promise.resolve((parcelRequire("ey1aZ")))
            ]);
            const Leaflet = L.default || L;
            const topojsonClient = topojson.default || topojson;
            const togeojsonLib = toGeoJSON.default || toGeoJSON;
            const shpLib = shpjs.default || shpjs;
            const JSZipLib = JSZip7.default || JSZip7;
            const DefaultIcon = Leaflet.icon({
                iconUrl: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
            <path fill="#3b82f6" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        `),
                iconSize: [
                    25,
                    41
                ],
                iconAnchor: [
                    12,
                    41
                ],
                popupAnchor: [
                    1,
                    -34
                ],
                shadowUrl: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
            <ellipse cx="12" cy="20" rx="6" ry="2" fill="#000000" opacity="0.2"/>
          </svg>
        `),
                shadowSize: [
                    41,
                    41
                ],
                shadowAnchor: [
                    12,
                    41
                ]
            });
            Leaflet.Marker.prototype.options.icon = DefaultIcon;
            const buffer = await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file);
            const geojson = await $08414ea58bdc1292$var$parseToGeoJson(ctx.file, buffer, togeojsonLib, topojsonClient, shpLib, JSZipLib).catch((error)=>{
                const fallback = $08414ea58bdc1292$var$createGisFallback("GIS \u6570\u636E\u89E3\u6790\u5931\u8D25", $08414ea58bdc1292$var$normalizeGisError(error, ctx.file.name));
                ctx.viewport.classList.add("ofv-center");
                ctx.viewport.append(fallback);
                return {
                    fallback: fallback
                };
            });
            if ($08414ea58bdc1292$var$isGisFallback(geojson)) return {
                destroy () {
                    ctx.viewport.classList.remove("ofv-center");
                    geojson.fallback.remove();
                }
            };
            const wrapper = document.createElement("div");
            wrapper.className = "ofv-gis-viewer";
            const summary = $08414ea58bdc1292$var$summarizeGeoJson(geojson);
            wrapper.append($08414ea58bdc1292$var$createGisSummary(summary));
            ctx.viewport.appendChild(wrapper);
            const mapContainer = document.createElement("div");
            mapContainer.className = "ofv-map-stage";
            wrapper.appendChild(mapContainer);
            if (summary.features === 0) mapContainer.append($08414ea58bdc1292$var$createEmptyMapState());
            const map = Leaflet.map(mapContainer).setView([
                0,
                0
            ], 2);
            let toolbarZoom = 1;
            const updateToolbarZoom = ()=>{
                ctx.toolbar?.setZoom(toolbarZoom);
            };
            updateToolbarZoom();
            Leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
            const geojsonLayer = Leaflet.geoJSON(geojson, {
                style: ()=>({
                        className: "ofv-map-feature",
                        color: "#e11d48",
                        weight: 2,
                        opacity: 0.92,
                        fillColor: "#fb923c",
                        fillOpacity: 0.3,
                        lineCap: "round",
                        lineJoin: "round"
                    }),
                pointToLayer: (feature, latlng)=>{
                    return Leaflet.circleMarker(latlng, {
                        className: "ofv-map-feature ofv-map-point",
                        radius: 7,
                        fillColor: "#e11d48",
                        color: "#ffffff",
                        weight: 2.5,
                        opacity: 1,
                        fillOpacity: 0.9
                    });
                },
                onEachFeature: (feature, layer)=>{
                    const label = feature.properties?.name || feature.properties?.title || feature.properties?.label;
                    if (label) layer.bindTooltip?.(String(label), {
                        className: "ofv-map-tooltip",
                        direction: "top",
                        sticky: true
                    });
                    layer.on?.({
                        mouseover (event) {
                            event.target?.setStyle?.({
                                weight: 4,
                                opacity: 1,
                                fillOpacity: 0.4
                            });
                            event.target?.bringToFront?.();
                        },
                        mouseout (event) {
                            geojsonLayer.resetStyle?.(event.target);
                        }
                    });
                    if (feature.properties) {
                        const props = feature.properties;
                        const keys = Object.keys(props);
                        if (keys.length > 0) {
                            const popupContent = document.createElement("div");
                            popupContent.className = "ofv-map-popup";
                            const popupTitle = document.createElement("h4");
                            popupTitle.textContent = "\u5C5E\u6027\u4FE1\u606F";
                            popupContent.appendChild(popupTitle);
                            const table = document.createElement("table");
                            table.className = "ofv-map-popup-table";
                            for (const key of keys){
                                const val = props[key];
                                if (val === null || val === void 0) continue;
                                const row = document.createElement("tr");
                                const cellKey = document.createElement("td");
                                cellKey.className = "ofv-map-popup-key";
                                cellKey.textContent = key;
                                const cellVal = document.createElement("td");
                                cellVal.className = "ofv-map-popup-val";
                                cellVal.textContent = typeof val === "object" ? JSON.stringify(val) : String(val);
                                row.append(cellKey, cellVal);
                                table.appendChild(row);
                            }
                            popupContent.appendChild(table);
                            layer.bindPopup(popupContent);
                        }
                    }
                }
            }).addTo(map);
            try {
                const bounds = geojsonLayer.getBounds();
                if (bounds.isValid()) {
                    map.fitBounds(bounds, {
                        padding: [
                            20,
                            20
                        ]
                    });
                    map.invalidateSize();
                }
            } catch (e) {
                console.warn("Could not fit bounds for GeoJSON data:", e);
            }
            const resizeTimers = [
                0,
                80,
                240
            ].map((delay)=>window.setTimeout(()=>{
                    map.invalidateSize();
                    updateToolbarZoom();
                }, delay));
            return {
                canCommand (command) {
                    return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset";
                },
                command (command) {
                    if (command === "zoom-in") {
                        map.zoomIn?.();
                        toolbarZoom = Math.min(3, Number((toolbarZoom + 0.25).toFixed(2)));
                        updateToolbarZoom();
                        return true;
                    }
                    if (command === "zoom-out") {
                        map.zoomOut?.();
                        toolbarZoom = Math.max(0.25, Number((toolbarZoom - 0.25).toFixed(2)));
                        updateToolbarZoom();
                        return true;
                    }
                    if (command === "zoom-reset") {
                        toolbarZoom = 1;
                        map.setView([
                            0,
                            0
                        ], 2);
                        try {
                            const bounds = geojsonLayer.getBounds();
                            if (bounds.isValid()) map.fitBounds(bounds, {
                                padding: [
                                    20,
                                    20
                                ]
                            });
                        } catch  {}
                        map.invalidateSize();
                        updateToolbarZoom();
                        return true;
                    }
                    return false;
                },
                resize () {
                    map.invalidateSize();
                    updateToolbarZoom();
                },
                destroy () {
                    resizeTimers.forEach((timer)=>window.clearTimeout(timer));
                    ctx.toolbar?.setZoom(void 0);
                    map.remove();
                    wrapper.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$createGisFallback(titleText, detailText) {
    const fallback = document.createElement("div");
    fallback.className = "ofv-fallback";
    const title = document.createElement("strong");
    title.textContent = titleText;
    const detail = document.createElement("span");
    detail.textContent = detailText;
    fallback.append(title, detail);
    return fallback;
}
function $08414ea58bdc1292$var$normalizeGisError(error, fileName) {
    const message = error instanceof Error ? error.message : String(error || "");
    return message ? `${fileName}: ${message}` : `${fileName}: \u6587\u4EF6\u5185\u5BB9\u65E0\u6CD5\u8F6C\u6362\u4E3A\u5730\u56FE\u6570\u636E\u3002`;
}
function $08414ea58bdc1292$var$isGisFallback(value) {
    return typeof value === "object" && value !== null && "fallback" in value;
}
function $08414ea58bdc1292$var$createGisSummary(summary) {
    const bar = document.createElement("div");
    bar.className = "ofv-gis-summary";
    bar.hidden = summary.features > 0;
    if (summary.features > 0) {
        bar.setAttribute("aria-hidden", "true");
        bar.style.display = "none";
    }
    $08414ea58bdc1292$var$appendSummaryItem(bar, "\u8981\u7D20", String(summary.features));
    $08414ea58bdc1292$var$appendSummaryItem(bar, "\u51E0\u4F55", $08414ea58bdc1292$var$formatGeometryCounts(summary.geometryCounts));
    $08414ea58bdc1292$var$appendSummaryItem(bar, "\u5C5E\u6027\u5B57\u6BB5", String(summary.propertyKeys.size));
    if (summary.propertyKeys.size > 0) $08414ea58bdc1292$var$appendSummaryItem(bar, "\u5B57\u6BB5\u9884\u89C8", [
        ...summary.propertyKeys
    ].slice(0, 8).join(", "));
    if (summary.bounds) $08414ea58bdc1292$var$appendSummaryItem(bar, "\u8303\u56F4", $08414ea58bdc1292$var$formatBounds(summary.bounds));
    return bar;
}
function $08414ea58bdc1292$var$createEmptyMapState() {
    const empty = document.createElement("div");
    empty.className = "ofv-map-empty";
    const title = document.createElement("strong");
    title.textContent = "\u6682\u65E0\u53EF\u5C55\u793A\u7684\u5730\u56FE\u8981\u7D20";
    const detail = document.createElement("span");
    detail.textContent = "GeoJSON \u5DF2\u8BC6\u522B\uFF0C\u4F46 features \u4E3A\u7A7A\u3002";
    empty.append(title, detail);
    return empty;
}
function $08414ea58bdc1292$var$appendSummaryItem(parent, label, value) {
    const item = document.createElement("span");
    const key = document.createElement("span");
    key.textContent = label;
    const content = document.createElement("strong");
    content.textContent = value;
    item.append(key, content);
    parent.append(item);
}
function $08414ea58bdc1292$var$summarizeGeoJson(geojson) {
    const summary = {
        features: 0,
        geometryCounts: /* @__PURE__ */ new Map(),
        propertyKeys: /* @__PURE__ */ new Set()
    };
    for (const feature of $08414ea58bdc1292$var$collectFeatures(geojson)){
        summary.features++;
        if (feature.properties && typeof feature.properties === "object") Object.keys(feature.properties).forEach((key)=>summary.propertyKeys.add(key));
        $08414ea58bdc1292$var$summarizeGeometry(feature.geometry, summary);
    }
    return summary;
}
function $08414ea58bdc1292$var$collectFeatures(value) {
    if (!value) return [];
    if (value.type === "FeatureCollection" && Array.isArray(value.features)) return value.features;
    if (value.type === "Feature") return [
        value
    ];
    if (value.type && value.coordinates) return [
        {
            type: "Feature",
            properties: {},
            geometry: value
        }
    ];
    return [];
}
function $08414ea58bdc1292$var$summarizeGeometry(geometry, summary) {
    if (!geometry) {
        summary.geometryCounts.set("None", (summary.geometryCounts.get("None") || 0) + 1);
        return;
    }
    const type = String(geometry.type || "Unknown");
    summary.geometryCounts.set(type, (summary.geometryCounts.get(type) || 0) + 1);
    if (type === "GeometryCollection" && Array.isArray(geometry.geometries)) {
        for (const child of geometry.geometries)$08414ea58bdc1292$var$summarizeGeometry(child, summary);
        return;
    }
    $08414ea58bdc1292$var$updateBounds(summary, geometry.coordinates);
}
function $08414ea58bdc1292$var$updateBounds(summary, coordinates) {
    if (!Array.isArray(coordinates)) return;
    if (typeof coordinates[0] === "number" && typeof coordinates[1] === "number") {
        const lon = coordinates[0];
        const lat = coordinates[1];
        if (!Number.isFinite(lon) || !Number.isFinite(lat)) return;
        const bounds = summary.bounds || [
            lon,
            lat,
            lon,
            lat
        ];
        bounds[0] = Math.min(bounds[0], lon);
        bounds[1] = Math.min(bounds[1], lat);
        bounds[2] = Math.max(bounds[2], lon);
        bounds[3] = Math.max(bounds[3], lat);
        summary.bounds = bounds;
        return;
    }
    for (const item of coordinates)$08414ea58bdc1292$var$updateBounds(summary, item);
}
function $08414ea58bdc1292$var$formatGeometryCounts(counts) {
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([type, count])=>`${type} ${count}`).join(", ") || "\u65E0";
}
function $08414ea58bdc1292$var$formatBounds(bounds) {
    return bounds.map((value)=>Number(value.toFixed(5))).join(", ");
}
async function $08414ea58bdc1292$var$parseToGeoJson(file, buffer, togeojsonLib, topojsonClient, shpLib, JSZipLib) {
    const ext = $08414ea58bdc1292$var$resolveGisFormat(file);
    if (ext === "geojson") {
        const text = new TextDecoder().decode(buffer);
        return JSON.parse(text);
    }
    if (ext === "topojson") {
        const text = new TextDecoder().decode(buffer);
        const topology = JSON.parse(text);
        const geojsonFeatures = [];
        for (const key of Object.keys(topology.objects)){
            const feature = topojsonClient.feature(topology, topology.objects[key]);
            if (feature.type === "FeatureCollection") geojsonFeatures.push(...feature.features);
            else geojsonFeatures.push(feature);
        }
        return {
            type: "FeatureCollection",
            features: geojsonFeatures
        };
    }
    if (ext === "kml") {
        const text = new TextDecoder().decode(buffer);
        const dom = new DOMParser().parseFromString(text, "text/xml");
        return togeojsonLib.kml(dom);
    }
    if (ext === "gpx") {
        const text = new TextDecoder().decode(buffer);
        const dom = new DOMParser().parseFromString(text, "text/xml");
        return togeojsonLib.gpx(dom);
    }
    if (ext === "kmz") {
        const zip = await JSZipLib.loadAsync(buffer);
        const kmlFile = Object.values(zip.files).find((f)=>f.name.toLowerCase().endsWith(".kml"));
        if (!kmlFile) throw new Error("No KML file found inside KMZ archive.");
        const kmlText = await kmlFile.async("text");
        const dom = new DOMParser().parseFromString(kmlText, "text/xml");
        return togeojsonLib.kml(dom);
    }
    if (ext === "shp") {
        const u8 = new Uint8Array(buffer);
        const isZip = u8[0] === 80 && u8[1] === 75 && u8[2] === 3 && u8[3] === 4;
        const parsed = await shpLib(isZip ? buffer : {
            shp: buffer
        }).catch((error)=>{
            if (!isZip) throw new Error(`\u5355\u4E2A .shp \u51E0\u4F55\u89E3\u6790\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u6587\u4EF6\u5185\u5BB9\u5F02\u5E38"}\u3002\u5982\u9700\u5C5E\u6027\u5B57\u6BB5\uFF0C\u8BF7\u540C\u65F6\u63D0\u4F9B .dbf/.shx \u6216\u4E0A\u4F20 zip\u3002`);
            throw error;
        });
        if (Array.isArray(parsed)) {
            const features = [];
            for (const item of parsed){
                if (item.type === "FeatureCollection") features.push(...item.features);
                else if (item.type === "Feature") features.push(item);
            }
            return {
                type: "FeatureCollection",
                features: features
            };
        }
        return parsed;
    }
    try {
        const text = new TextDecoder().decode(buffer);
        return JSON.parse(text);
    } catch  {
        throw new Error(`Unsupported GIS format: ${ext}`);
    }
}
function $08414ea58bdc1292$var$resolveGisFormat(file) {
    const name = file.name.toLowerCase().split("?")[0]?.split("#")[0] || "";
    if (name.endsWith(".geo.json")) return "geojson";
    if (name.endsWith(".topo.json")) return "topojson";
    return (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(file, $08414ea58bdc1292$var$gisMimeFormatMap).toLowerCase();
}
// src/plugins/asset.ts
var $08414ea58bdc1292$var$assetExtensions = /* @__PURE__ */ new Set([
    "ttf",
    "otf",
    "woff",
    "woff2",
    "eot",
    "psd",
    "psb",
    "ai",
    "eps",
    "ps",
    "webarchive",
    "sqlite",
    "sqlite3",
    "db",
    "wasm",
    "parquet",
    "avro"
]);
var $08414ea58bdc1292$var$assetMimeFormatMap = {
    "font/ttf": "ttf",
    "font/otf": "otf",
    "font/woff": "woff",
    "font/woff2": "woff2",
    "application/vnd.ms-fontobject": "eot",
    "image/vnd.adobe.photoshop": "psd",
    "application/postscript": "ps",
    "application/x-webarchive": "webarchive",
    "application/vnd.sqlite3": "sqlite",
    "application/x-sqlite3": "sqlite",
    "application/wasm": "wasm",
    "application/vnd.apache.parquet": "parquet",
    "application/avro": "avro"
};
var $08414ea58bdc1292$var$assetMimeTypes = new Set(Object.keys($08414ea58bdc1292$var$assetMimeFormatMap));
function $08414ea58bdc1292$export$cffdcfe2e43d7908() {
    return {
        name: "asset",
        match (file) {
            return $08414ea58bdc1292$var$assetExtensions.has(file.extension) || $08414ea58bdc1292$var$assetMimeTypes.has(file.mimeType);
        },
        async render (ctx) {
            const panel = (0, $3438a2478d5b847f$export$71ce2d4d67b6d9e4)("ofv-asset");
            ctx.viewport.append(panel);
            const url = (0, $3438a2478d5b847f$export$191fa6957fae12db)(ctx.file);
            const isExternal = Boolean(ctx.file.url);
            const extension = (0, $3438a2478d5b847f$export$bd0a0e50c4747011)(ctx.file, $08414ea58bdc1292$var$assetMimeFormatMap).toLowerCase();
            const bytes = new Uint8Array(await (0, $3438a2478d5b847f$export$1ac45368052289f3)(ctx.file).catch(()=>new ArrayBuffer(0)));
            if ($08414ea58bdc1292$var$isPhotoshopAsset(extension)) {
                const photoshopPreview = await $08414ea58bdc1292$var$createPhotoshopPreview(bytes, ctx.toolbar);
                panel.append(photoshopPreview.element);
                ctx.toolbar?.refreshCommandSupport();
                return {
                    goToPage (page) {
                        return photoshopPreview.instance?.goToPage?.(page) ?? false;
                    },
                    canCommand (command) {
                        return photoshopPreview.instance?.canCommand?.(command) ?? false;
                    },
                    command (command) {
                        return photoshopPreview.instance?.command?.(command) ?? false;
                    },
                    preparePrint () {
                        return photoshopPreview.instance?.preparePrint?.();
                    },
                    resize (size) {
                        photoshopPreview.instance?.resize?.(size);
                    },
                    destroy () {
                        photoshopPreview.instance?.destroy();
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                        panel.remove();
                    }
                };
            }
            if (extension === "ai" || extension === "eps" || extension === "ps") {
                const postScriptPreview = await $08414ea58bdc1292$var$createPostScriptPreview(bytes, url, ctx.file.name, ctx.size, ctx.options.fit, ctx.toolbar);
                panel.append(postScriptPreview.element);
                if (postScriptPreview.primaryRendered) {
                    $08414ea58bdc1292$var$hideSuccessfulAssetDiagnostics(panel);
                    ctx.toolbar?.refreshCommandSupport();
                    return {
                        goToPage (page) {
                            return postScriptPreview.instance?.goToPage?.(page) ?? false;
                        },
                        canCommand (command) {
                            return postScriptPreview.instance?.canCommand?.(command) ?? false;
                        },
                        command (command) {
                            return postScriptPreview.instance?.command?.(command) ?? false;
                        },
                        preparePrint () {
                            return postScriptPreview.instance?.preparePrint?.();
                        },
                        resize (size) {
                            postScriptPreview.instance?.resize?.(size);
                        },
                        destroy () {
                            postScriptPreview.instance?.destroy();
                            (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                            panel.remove();
                        }
                    };
                }
                return {
                    goToPage (page) {
                        return postScriptPreview.instance?.goToPage?.(page) ?? false;
                    },
                    canCommand (command) {
                        return postScriptPreview.instance?.canCommand?.(command) ?? false;
                    },
                    command (command) {
                        return postScriptPreview.instance?.command?.(command) ?? false;
                    },
                    preparePrint () {
                        return postScriptPreview.instance?.preparePrint?.();
                    },
                    resize (size) {
                        postScriptPreview.instance?.resize?.(size);
                    },
                    destroy () {
                        postScriptPreview.instance?.destroy();
                        (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                        panel.remove();
                    }
                };
            }
            const section = (0, $3438a2478d5b847f$export$f3a183bf2efcc835)($08414ea58bdc1292$var$assetTitle(extension));
            const summary = document.createElement("div");
            summary.className = "ofv-asset-summary";
            (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u6587\u4EF6", ctx.file.name);
            (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u683C\u5F0F", extension ? `.${extension}` : ctx.file.mimeType || "\u672A\u77E5");
            (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5927\u5C0F", $08414ea58bdc1292$var$formatBytes4(ctx.file.size ?? bytes.byteLength));
            (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u7B7E\u540D", $08414ea58bdc1292$var$byteSignature3(bytes));
            $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
            const note = document.createElement("p");
            note.textContent = $08414ea58bdc1292$var$assetGuidance(extension);
            $08414ea58bdc1292$var$hideSupplementalInfo8(note);
            const download = document.createElement("a");
            download.className = "ofv-asset-download";
            download.href = url;
            download.download = ctx.file.name;
            download.textContent = "\u4E0B\u8F7D\u6587\u4EF6";
            download.hidden = true;
            download.setAttribute("aria-hidden", "true");
            download.style.display = "none";
            section.append(summary, note, download);
            const childInstances = [];
            let hasPrimaryPreview = false;
            if ($08414ea58bdc1292$var$isFontAsset(extension)) {
                $08414ea58bdc1292$var$hideSuccessfulSectionHeading4(section);
                section.append(await $08414ea58bdc1292$var$createFontPreview(extension, url, ctx.file.name, bytes));
                hasPrimaryPreview = true;
            }
            if (extension === "wasm") {
                section.append($08414ea58bdc1292$var$createWasmPreview(bytes));
                hasPrimaryPreview = true;
            }
            if (extension === "sqlite" || extension === "sqlite3" || extension === "db") {
                section.append($08414ea58bdc1292$var$createSqlitePreview(bytes));
                hasPrimaryPreview = true;
            }
            if (extension === "parquet") {
                section.append($08414ea58bdc1292$var$createParquetPreview(bytes));
                hasPrimaryPreview = true;
            }
            if (extension === "avro") {
                section.append($08414ea58bdc1292$var$createAvroPreview(bytes));
                hasPrimaryPreview = true;
            }
            if (extension === "webarchive") {
                section.append($08414ea58bdc1292$var$createWebArchivePreview(bytes));
                hasPrimaryPreview = true;
            }
            if (hasPrimaryPreview) $08414ea58bdc1292$var$hideSuccessfulSectionHeading4(section);
            const preview = $08414ea58bdc1292$var$shouldShowHexPreview(extension, hasPrimaryPreview) ? $08414ea58bdc1292$var$createHexPreview(bytes) : null;
            if (preview) section.append(preview);
            panel.append(section);
            return {
                goToPage (page) {
                    for (const instance of childInstances){
                        if (instance.goToPage?.(page)) return true;
                    }
                    return false;
                },
                canCommand (command) {
                    return childInstances.some((instance)=>instance.canCommand?.(command));
                },
                command (command) {
                    for (const instance of childInstances){
                        if (instance.canCommand?.(command)) return instance.command?.(command) ?? false;
                    }
                    return false;
                },
                async preparePrint () {
                    await Promise.all(childInstances.map((instance)=>instance.preparePrint?.()));
                },
                resize (size) {
                    childInstances.forEach((instance)=>instance.resize?.(size));
                },
                destroy () {
                    childInstances.forEach((instance)=>instance.destroy());
                    (0, $3438a2478d5b847f$export$7438c4986c08186f)(url, isExternal);
                    panel.remove();
                }
            };
        }
    };
}
function $08414ea58bdc1292$var$assetTitle(extension) {
    if ($08414ea58bdc1292$var$isFontAsset(extension)) return "\u5B57\u4F53\u6587\u4EF6\u9884\u89C8";
    if ([
        "psd",
        "psb",
        "ai",
        "eps",
        "ps"
    ].includes(extension)) return "\u8BBE\u8BA1\u6587\u4EF6\u9884\u89C8";
    if ([
        "sqlite",
        "sqlite3",
        "db",
        "parquet",
        "avro"
    ].includes(extension)) return "\u6570\u636E\u6587\u4EF6\u9884\u89C8";
    if (extension === "wasm") return "WebAssembly \u6587\u4EF6\u9884\u89C8";
    if (extension === "webarchive") return "\u7F51\u9875\u5F52\u6863\u9884\u89C8";
    return "\u8D44\u4EA7\u6587\u4EF6\u9884\u89C8";
}
function $08414ea58bdc1292$var$assetGuidance(extension) {
    if ($08414ea58bdc1292$var$isFontAsset(extension)) return "\u5B57\u4F53\u6587\u4EF6\u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u4F7F\u7528 FontFace \u5C55\u793A\u5B57\u5F62\u6837\u5F20\uFF0C\u5E76\u89E3\u6790 sfnt/WOFF \u8868\u76EE\u5F55\u548C name \u5143\u4FE1\u606F\u3002";
    if (extension === "psd" || extension === "psb") return "PSD/PSB \u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u4F18\u5148\u89E3\u6790 Photoshop \u5408\u6210\u56FE\u9884\u89C8\uFF0C\u5E76\u4FDD\u7559\u753B\u5E03\u3001\u901A\u9053\u3001\u4F4D\u6DF1\u548C\u989C\u8272\u6A21\u5F0F\u7B49\u7ED3\u6784\u4FE1\u606F\u3002";
    if ([
        "ai",
        "eps",
        "ps"
    ].includes(extension)) return "PostScript/Illustrator \u6587\u4EF6\u5DF2\u8BC6\u522B\uFF1BPDF-compatible AI \u4F1A\u76F4\u63A5\u4F7F\u7528\u6D4F\u89C8\u5668 PDF \u9884\u89C8\uFF0CEPS/PS \u4F1A\u89E3\u6790\u6587\u6863\u5934\u3001BoundingBox \u548C\u5E38\u89C1 DSC \u5143\u4FE1\u606F\u3002";
    if ([
        "sqlite",
        "sqlite3",
        "db"
    ].includes(extension)) return "SQLite \u6570\u636E\u5E93\u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u89E3\u6790\u6570\u636E\u5E93\u5934\u3001sqlite_schema \u6458\u8981\uFF0C\u5E76\u5BF9\u5E38\u89C1 table leaf page \u505A\u524D\u7AEF\u62BD\u6837\u9884\u89C8\uFF1B\u590D\u6742\u67E5\u8BE2\u53EF\u63A5\u5165 sqlite-wasm \u589E\u5F3A\u3002";
    if (extension === "parquet" || extension === "avro") return "\u5217\u5F0F/\u5E8F\u5217\u5316\u6570\u636E\u6587\u4EF6\u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u89E3\u6790\u5BB9\u5668\u5934\u3001\u5143\u4FE1\u606F\u548C schema \u6458\u8981\uFF1B\u62BD\u6837\u8BB0\u5F55\u53EF\u540E\u7EED\u63A5\u5165\u4E13\u7528\u89E3\u6790\u5668\u589E\u5F3A\u3002";
    if (extension === "wasm") return "WASM \u6A21\u5757\u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u89E3\u6790\u7248\u672C\u3001section \u5206\u5E03\u3001imports\u3001exports \u548C\u81EA\u5B9A\u4E49 section \u6458\u8981\u3002";
    if (extension === "webarchive") return "WebArchive \u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u4F1A\u89E3\u6790 XML plist \u4E3B\u8D44\u6E90\u3001MIME\u3001\u7F16\u7801\u548C\u5B50\u8D44\u6E90\u6570\u91CF\uFF1B\u5B8C\u6574\u7F51\u9875\u8FD8\u539F\u53EF\u540E\u7EED\u63A5\u5165\u8D44\u6E90\u5305\u8F6C\u6362\u3002";
    return "\u8BE5\u8D44\u4EA7\u6587\u4EF6\u5DF2\u8BC6\u522B\uFF0C\u5F53\u524D\u63D0\u4F9B\u6587\u4EF6\u6307\u7EB9\u548C\u4E0B\u8F7D\u5165\u53E3\uFF0C\u540E\u7EED\u53EF\u63A5\u5165\u4E13\u7528\u89E3\u6790\u5668\u589E\u5F3A\u3002";
}
function $08414ea58bdc1292$var$isFontAsset(extension) {
    return [
        "ttf",
        "otf",
        "woff",
        "woff2",
        "eot"
    ].includes(extension);
}
function $08414ea58bdc1292$var$isPhotoshopAsset(extension) {
    return extension === "psd" || extension === "psb";
}
async function $08414ea58bdc1292$var$createFontPreview(extension, url, fileName, bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-font-preview";
    const heading = document.createElement("strong");
    heading.textContent = "\u5B57\u4F53\u6837\u5F20";
    const sample = document.createElement("div");
    sample.className = "ofv-font-sample";
    sample.textContent = "Open File Viewer \u9884\u89C8 1234567890";
    const pangram = document.createElement("div");
    pangram.className = "ofv-font-pangram";
    pangram.textContent = "The quick brown fox jumps over the lazy dog.";
    const meta = document.createElement("span");
    meta.className = "ofv-font-status";
    preview.append(heading, sample, pangram, meta);
    if (!("FontFace" in window) || !document.fonts) {
        meta.textContent = "\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 FontFace API\uFF0C\u65E0\u6CD5\u751F\u6210\u5B9E\u65F6\u5B57\u5F62\u6837\u5F20\u3002";
        preview.append($08414ea58bdc1292$var$createFontInfoPreview(bytes, extension));
        return preview;
    }
    const family = `ofv-${fileName.replace(/[^a-z0-9_-]/gi, "-")}-${Date.now()}`;
    const format = $08414ea58bdc1292$var$fontFaceFormat(extension);
    const source = format ? `url("${url}") format("${format}")` : `url("${url}")`;
    let sampleRendered = false;
    try {
        const fontFace = new FontFace(family, source);
        const loaded = await fontFace.load();
        document.fonts.add(loaded);
        sample.style.fontFamily = `"${family}", sans-serif`;
        pangram.style.fontFamily = `"${family}", sans-serif`;
        meta.textContent = "\u5DF2\u4F7F\u7528\u6D4F\u89C8\u5668 FontFace API \u52A0\u8F7D\u5B57\u4F53\u6837\u5F20\u3002";
        $08414ea58bdc1292$var$hideSupplementalInfo8(meta);
        sampleRendered = true;
    } catch (error) {
        meta.textContent = `\u5B57\u4F53\u6837\u5F20\u52A0\u8F7D\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u5F53\u524D\u5B57\u4F53\u7F16\u7801\u6682\u4E0D\u53D7\u6D4F\u89C8\u5668\u652F\u6301\u3002"}`;
    }
    const info = $08414ea58bdc1292$var$createFontInfoPreview(bytes, extension);
    const hasVisibleFontDiagnostic = Boolean(info.querySelector(".ofv-data-error"));
    if (sampleRendered || !hasVisibleFontDiagnostic) $08414ea58bdc1292$var$hideSupplementalInfo8(info);
    preview.append(info);
    return preview;
}
function $08414ea58bdc1292$var$fontFaceFormat(extension) {
    const map = {
        ttf: "truetype",
        otf: "opentype",
        woff: "woff",
        woff2: "woff2",
        eot: "embedded-opentype"
    };
    return map[extension] || "";
}
function $08414ea58bdc1292$var$createFontInfoPreview(bytes, extension) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-font-info";
    const heading = document.createElement("strong");
    heading.textContent = "\u5B57\u4F53\u7ED3\u6784";
    wrapper.append(heading);
    const parsed = $08414ea58bdc1292$var$parseFontInfo(bytes, extension);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = parsed.error || "\u65E0\u6CD5\u89E3\u6790\u5B57\u4F53\u7ED3\u6784\u3002";
        wrapper.append(error);
        return wrapper;
    }
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5BB9\u5668", parsed.container || "sfnt");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Flavor", parsed.flavor || "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u8868\u6570\u91CF", parsed.tables.length);
    if (parsed.totalSfntSize !== void 0) (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5C55\u5F00\u5927\u5C0F", $08414ea58bdc1292$var$formatBytes4(parsed.totalSfntSize));
    for (const item of parsed.meta || [])(0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, item.label, item.value);
    wrapper.append(summary);
    if (parsed.error) {
        const note = document.createElement("p");
        note.className = "ofv-data-note";
        note.textContent = parsed.error;
        wrapper.append(note);
    }
    if (parsed.names.length > 0) wrapper.append($08414ea58bdc1292$var$createKeyValueTable("Name", parsed.names.map((item)=>({
            key: item.label,
            value: item.value
        }))));
    if (parsed.tables.length > 0) wrapper.append($08414ea58bdc1292$var$createFontTablePreview(parsed.tables));
    return wrapper;
}
function $08414ea58bdc1292$var$createFontTablePreview(tables) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-font-tables";
    const title = document.createElement("strong");
    title.textContent = "Tables";
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");
    for (const label of [
        "Tag",
        "Offset",
        "Length",
        "Compressed",
        "Checksum"
    ]){
        const th = document.createElement("th");
        th.textContent = label;
        headRow.append(th);
    }
    thead.append(headRow);
    const tbody = document.createElement("tbody");
    for (const entry of tables.slice(0, 80)){
        const row = document.createElement("tr");
        for (const value of [
            entry.tag,
            `0x${entry.offset.toString(16).toUpperCase()}`,
            $08414ea58bdc1292$var$formatBytes4(entry.length),
            entry.compressedLength === void 0 ? "-" : $08414ea58bdc1292$var$formatBytes4(entry.compressedLength),
            entry.checksum === void 0 ? "-" : `0x${entry.checksum.toString(16).padStart(8, "0").toUpperCase()}`
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            row.append(cell);
        }
        tbody.append(row);
    }
    table.append(thead, tbody);
    wrapper.append(title, table);
    return wrapper;
}
function $08414ea58bdc1292$var$parseFontInfo(bytes, extension) {
    if (bytes.length < 4) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6\u5B57\u4F53\u5934\u3002",
        tables: [],
        names: []
    };
    const signature = $08414ea58bdc1292$var$asciiAt3(bytes, 0, 4);
    if (signature === "wOFF") return $08414ea58bdc1292$var$parseWoffFont(bytes);
    if (signature === "wOF2") return $08414ea58bdc1292$var$parseWoff2Font(bytes);
    if (extension === "eot") return $08414ea58bdc1292$var$parseEotFont(bytes);
    return $08414ea58bdc1292$var$parseSfntFont(bytes, 0, "sfnt");
}
function $08414ea58bdc1292$var$parseSfntFont(bytes, offset, container) {
    if (offset + 12 > bytes.length) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 sfnt offset table\u3002",
        tables: [],
        names: []
    };
    const flavor = $08414ea58bdc1292$var$fontFlavor(bytes, offset);
    if (!flavor) return {
        valid: false,
        error: "\u7F3A\u5C11\u6709\u6548\u7684 TrueType/OpenType sfnt \u5934\u3002",
        tables: [],
        names: []
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const tableCount = view3.getUint16(offset + 4, false);
    const directoryEnd = offset + 12 + tableCount * 16;
    if (tableCount <= 0 || directoryEnd > bytes.length) return {
        valid: false,
        error: "sfnt \u8868\u76EE\u5F55\u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002",
        tables: [],
        names: []
    };
    const tables = [];
    for(let index = 0; index < tableCount; index++){
        const entryOffset = offset + 12 + index * 16;
        tables.push({
            tag: $08414ea58bdc1292$var$asciiAt3(bytes, entryOffset, 4),
            checksum: view3.getUint32(entryOffset + 4, false),
            offset: view3.getUint32(entryOffset + 8, false),
            length: view3.getUint32(entryOffset + 12, false)
        });
    }
    return {
        valid: true,
        container: container,
        flavor: flavor,
        tables: tables,
        names: $08414ea58bdc1292$var$parseFontNameTable(bytes, tables.find((table)=>table.tag === "name"))
    };
}
function $08414ea58bdc1292$var$parseWoffFont(bytes) {
    if (bytes.length < 44) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 WOFF \u5934\u3002",
        tables: [],
        names: []
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const tableCount = view3.getUint16(12, false);
    const directoryEnd = 44 + tableCount * 20;
    if (tableCount <= 0 || directoryEnd > bytes.length) return {
        valid: false,
        error: "WOFF \u8868\u76EE\u5F55\u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002",
        tables: [],
        names: []
    };
    const tables = [];
    for(let index = 0; index < tableCount; index++){
        const entryOffset = 44 + index * 20;
        tables.push({
            tag: $08414ea58bdc1292$var$asciiAt3(bytes, entryOffset, 4),
            offset: view3.getUint32(entryOffset + 4, false),
            compressedLength: view3.getUint32(entryOffset + 8, false),
            length: view3.getUint32(entryOffset + 12, false),
            checksum: view3.getUint32(entryOffset + 16, false)
        });
    }
    return {
        valid: true,
        container: "WOFF",
        flavor: $08414ea58bdc1292$var$fontFlavor(bytes, 4) || $08414ea58bdc1292$var$asciiAt3(bytes, 4, 4),
        tables: tables,
        names: $08414ea58bdc1292$var$parseFontNameTable(bytes, tables.find((table)=>table.tag === "name" && table.compressedLength === table.length)),
        totalSfntSize: view3.getUint32(16, false)
    };
}
function $08414ea58bdc1292$var$parseWoff2Font(bytes) {
    if (bytes.length < 48) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 WOFF2 \u5934\u3002",
        tables: [],
        names: []
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const tableCount = view3.getUint16(12, false);
    let offset = 48;
    const tables = [];
    for(let index = 0; index < tableCount; index++){
        if (offset >= bytes.length) return {
            valid: false,
            error: "WOFF2 \u8868\u76EE\u5F55\u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002",
            tables: [],
            names: []
        };
        const flags = bytes[offset++];
        const knownTag = flags & 63;
        let tag = $08414ea58bdc1292$var$woff2KnownTableTag(knownTag);
        if (knownTag === 63) {
            if (offset + 4 > bytes.length) return {
                valid: false,
                error: "WOFF2 \u81EA\u5B9A\u4E49\u8868 tag \u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002",
                tables: [],
                names: []
            };
            tag = $08414ea58bdc1292$var$asciiAt3(bytes, offset, 4);
            offset += 4;
        }
        const originalLength = $08414ea58bdc1292$var$read255UInt16(bytes, offset);
        if (!originalLength) return {
            valid: false,
            error: "WOFF2 \u8868\u76EE\u5F55\u957F\u5EA6\u5B57\u6BB5\u4E0D\u5B8C\u6574\u3002",
            tables: [],
            names: []
        };
        offset = originalLength.offset;
        let transformedLength;
        const hasTransform = (flags & 192) !== 0 || tag === "glyf" && (flags & 192) !== 0 || tag === "loca" && (flags & 192) !== 0;
        if (hasTransform && tag !== "loca") {
            const transformed = $08414ea58bdc1292$var$read255UInt16(bytes, offset);
            if (!transformed) return {
                valid: false,
                error: "WOFF2 transformLength \u5B57\u6BB5\u4E0D\u5B8C\u6574\u3002",
                tables: [],
                names: []
            };
            transformedLength = transformed.value;
            offset = transformed.offset;
        }
        tables.push({
            tag: tag,
            offset: 0,
            length: originalLength.value,
            compressedLength: transformedLength
        });
    }
    return {
        valid: true,
        container: "WOFF2",
        flavor: $08414ea58bdc1292$var$fontFlavor(bytes, 4) || $08414ea58bdc1292$var$asciiAt3(bytes, 4, 4),
        tables: tables,
        names: [],
        totalSfntSize: view3.getUint32(16, false),
        meta: [
            {
                label: "\u538B\u7F29\u6570\u636E",
                value: $08414ea58bdc1292$var$formatBytes4(view3.getUint32(20, false))
            },
            {
                label: "Meta",
                value: view3.getUint32(32, false) > 0 ? `${$08414ea58bdc1292$var$formatBytes4(view3.getUint32(36, false))} @ 0x${view3.getUint32(32, false).toString(16).toUpperCase()}` : "\u65E0"
            },
            {
                label: "Private",
                value: view3.getUint32(40, false) > 0 ? `${$08414ea58bdc1292$var$formatBytes4(view3.getUint32(44, false))} @ 0x${view3.getUint32(40, false).toString(16).toUpperCase()}` : "\u65E0"
            }
        ],
        error: "WOFF2 \u5DF2\u89E3\u6790\u5BB9\u5668\u5934\u548C\u538B\u7F29\u8868\u76EE\u5F55\uFF1Bname \u8868\u5185\u5BB9\u9700 Brotli \u89E3\u538B\u540E\u624D\u80FD\u5C55\u5F00\u3002"
    };
}
function $08414ea58bdc1292$var$parseEotFont(bytes) {
    if (bytes.length < 82) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 EOT \u5934\u3002",
        tables: [],
        names: []
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const eotSize = view3.getUint32(0, true);
    const fontDataSize = view3.getUint32(4, true);
    const version = view3.getUint32(8, true);
    const flags = view3.getUint32(12, true);
    const panose = Array.from(bytes.slice(16, 26)).map((item)=>item.toString(16).padStart(2, "0")).join(" ");
    const charset = bytes[26];
    const italic = bytes[27];
    const weight = view3.getUint32(28, true);
    let offset = 68;
    const names = [];
    const fields = [
        {
            id: 1,
            label: "Family",
            padded: true
        },
        {
            id: 2,
            label: "Subfamily",
            padded: true
        },
        {
            id: 5,
            label: "Version",
            padded: true
        },
        {
            id: 4,
            label: "Full name",
            padded: true
        },
        {
            id: 0,
            label: "Root strings",
            padded: false
        }
    ];
    for (const field of fields){
        const fieldValue = $08414ea58bdc1292$var$readEotStringField(bytes, offset, field.padded);
        if (!fieldValue) break;
        offset = fieldValue.offset;
        if (field.id > 0 && fieldValue.value) names.push({
            id: field.id,
            label: field.label,
            value: fieldValue.value
        });
    }
    if (offset + 4 <= bytes.length) offset += 4;
    const sfntOffset = $08414ea58bdc1292$var$findEmbeddedSfntOffset(bytes, offset);
    const embedded = sfntOffset === void 0 ? void 0 : $08414ea58bdc1292$var$parseSfntFont(bytes, sfntOffset, "EOT embedded sfnt");
    return {
        valid: true,
        container: "EOT",
        flavor: embedded?.valid ? embedded.flavor : "Embedded OpenType",
        tables: embedded?.valid ? embedded.tables : [],
        names: embedded?.valid && embedded.names.length > 0 ? embedded.names : names,
        totalSfntSize: fontDataSize || void 0,
        meta: [
            {
                label: "EOT \u5927\u5C0F",
                value: eotSize ? $08414ea58bdc1292$var$formatBytes4(eotSize) : "\u672A\u58F0\u660E"
            },
            {
                label: "\u7248\u672C",
                value: `0x${version.toString(16).toUpperCase()}`
            },
            {
                label: "Flags",
                value: `0x${flags.toString(16).toUpperCase()}`
            },
            {
                label: "Weight",
                value: weight || "\u672A\u58F0\u660E"
            },
            {
                label: "Italic",
                value: italic ? "\u662F" : "\u5426"
            },
            {
                label: "Charset",
                value: charset
            },
            {
                label: "PANOSE",
                value: panose
            },
            {
                label: "sfnt \u504F\u79FB",
                value: sfntOffset === void 0 ? "\u672A\u627E\u5230" : `0x${sfntOffset.toString(16).toUpperCase()}`
            }
        ],
        error: embedded?.valid ? void 0 : "\u5DF2\u89E3\u6790 EOT \u5BB9\u5668\u5934\u548C\u540D\u79F0\u5B57\u6BB5\uFF0C\u4F46\u672A\u627E\u5230\u53EF\u5C55\u5F00\u7684\u5185\u5D4C sfnt \u8868\u76EE\u5F55\u3002"
    };
}
function $08414ea58bdc1292$var$readEotStringField(bytes, offset, padded) {
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    if (padded) {
        if (offset + 2 > bytes.length) return void 0;
        offset += 2;
    }
    if (offset + 2 > bytes.length) return void 0;
    const length = view3.getUint16(offset, true);
    offset += 2;
    if (offset + length > bytes.length) return void 0;
    const value = length > 0 ? $08414ea58bdc1292$var$decodeEotString(bytes.slice(offset, offset + length)) : "";
    return {
        value: value,
        offset: offset + length
    };
}
function $08414ea58bdc1292$var$woff2KnownTableTag(index) {
    const tags = [
        "cmap",
        "head",
        "hhea",
        "hmtx",
        "maxp",
        "name",
        "OS/2",
        "post",
        "cvt ",
        "fpgm",
        "glyf",
        "loca",
        "prep",
        "CFF ",
        "VORG",
        "EBDT",
        "EBLC",
        "gasp",
        "hdmx",
        "kern",
        "LTSH",
        "PCLT",
        "VDMX",
        "vhea",
        "vmtx",
        "BASE",
        "GDEF",
        "GPOS",
        "GSUB",
        "EBSC",
        "JSTF",
        "MATH",
        "CBDT",
        "CBLC",
        "COLR",
        "CPAL",
        "SVG ",
        "sbix",
        "acnt",
        "avar",
        "bdat",
        "bloc",
        "bsln",
        "cvar",
        "fdsc",
        "feat",
        "fmtx",
        "fvar",
        "gvar",
        "hsty",
        "just",
        "lcar",
        "mort",
        "morx",
        "opbd",
        "prop",
        "trak",
        "Zapf",
        "Silf",
        "Glat",
        "Gloc",
        "Feat",
        "Sill"
    ];
    return tags[index] || `table-${index}`;
}
function $08414ea58bdc1292$var$read255UInt16(bytes, offset) {
    if (offset >= bytes.length) return void 0;
    const code = bytes[offset++];
    if (code === 253) {
        if (offset + 2 > bytes.length) return void 0;
        return {
            value: bytes[offset] << 8 | bytes[offset + 1],
            offset: offset + 2
        };
    }
    if (code === 254) {
        if (offset >= bytes.length) return void 0;
        return {
            value: bytes[offset] + 506,
            offset: offset + 1
        };
    }
    if (code === 255) {
        if (offset >= bytes.length) return void 0;
        return {
            value: bytes[offset] + 253,
            offset: offset + 1
        };
    }
    return {
        value: code,
        offset: offset
    };
}
function $08414ea58bdc1292$var$decodeEotString(bytes) {
    const text = $08414ea58bdc1292$var$decodeUtf16Le2(bytes).replace(/\0+$/g, "").trim();
    return text || new TextDecoder("latin1").decode(bytes).replace(/\0+$/g, "").trim();
}
function $08414ea58bdc1292$var$decodeUtf16Le2(bytes) {
    let value = "";
    for(let index = 0; index + 1 < bytes.length; index += 2)value += String.fromCharCode(bytes[index] | bytes[index + 1] << 8);
    return value;
}
function $08414ea58bdc1292$var$findEmbeddedSfntOffset(bytes, start) {
    for(let offset = Math.max(0, start); offset + 12 <= bytes.length; offset++){
        const flavor = $08414ea58bdc1292$var$fontFlavor(bytes, offset);
        if (!flavor) continue;
        const tableCount = bytes[offset + 4] << 8 | bytes[offset + 5];
        const directoryEnd = offset + 12 + tableCount * 16;
        if (tableCount > 0 && directoryEnd <= bytes.length) return offset;
    }
    return void 0;
}
function $08414ea58bdc1292$var$fontFlavor(bytes, offset) {
    if (offset + 4 > bytes.length) return void 0;
    const ascii = $08414ea58bdc1292$var$asciiAt3(bytes, offset, 4);
    if (ascii === "OTTO") return "OpenType/CFF";
    if (ascii === "true") return "Apple TrueType";
    if (ascii === "typ1") return "Type 1 sfnt";
    if (bytes[offset] === 0 && bytes[offset + 1] === 1 && bytes[offset + 2] === 0 && bytes[offset + 3] === 0) return "TrueType";
    return void 0;
}
function $08414ea58bdc1292$var$parseFontNameTable(bytes, table) {
    if (!table || table.offset + table.length > bytes.length || table.length < 6) return [];
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const offset = table.offset;
    const count = view3.getUint16(offset + 2, false);
    const storageOffset = view3.getUint16(offset + 4, false);
    const recordsEnd = offset + 6 + count * 12;
    if (recordsEnd > bytes.length || storageOffset > table.length) return [];
    const wanted = /* @__PURE__ */ new Map([
        [
            1,
            "Family"
        ],
        [
            2,
            "Subfamily"
        ],
        [
            4,
            "Full name"
        ],
        [
            5,
            "Version"
        ],
        [
            6,
            "PostScript name"
        ],
        [
            8,
            "Manufacturer"
        ],
        [
            13,
            "License"
        ],
        [
            16,
            "Typographic family"
        ],
        [
            17,
            "Typographic subfamily"
        ]
    ]);
    const names = /* @__PURE__ */ new Map();
    for(let index = 0; index < count; index++){
        const recordOffset = offset + 6 + index * 12;
        const platformId = view3.getUint16(recordOffset, false);
        const encodingId = view3.getUint16(recordOffset + 2, false);
        const languageId = view3.getUint16(recordOffset + 4, false);
        const nameId = view3.getUint16(recordOffset + 6, false);
        const length = view3.getUint16(recordOffset + 8, false);
        const stringOffset = view3.getUint16(recordOffset + 10, false);
        const label = wanted.get(nameId);
        if (!label || names.has(nameId)) continue;
        const start = offset + storageOffset + stringOffset;
        const end = start + length;
        if (end > bytes.length || end > offset + table.length) continue;
        const value = $08414ea58bdc1292$var$decodeFontName(bytes.slice(start, end), platformId, encodingId).trim();
        if (value) names.set(nameId, {
            id: nameId,
            label: languageId ? `${label} (${languageId.toString(16).toUpperCase()})` : label,
            value: value
        });
    }
    return [
        ...names.values()
    ];
}
function $08414ea58bdc1292$var$decodeFontName(bytes, platformId, encodingId) {
    if (platformId === 0 || platformId === 3 || platformId === 2 && encodingId === 1) return $08414ea58bdc1292$var$decodeUtf16Be(bytes);
    return new TextDecoder("latin1").decode(bytes);
}
function $08414ea58bdc1292$var$decodeUtf16Be(bytes) {
    let value = "";
    for(let index = 0; index + 1 < bytes.length; index += 2)value += String.fromCharCode(bytes[index] << 8 | bytes[index + 1]);
    return value;
}
function $08414ea58bdc1292$var$createWasmPreview(bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-wasm-preview";
    const parsed = $08414ea58bdc1292$var$parseWasm(bytes);
    const heading = document.createElement("strong");
    heading.textContent = "WASM \u7ED3\u6784";
    preview.append(heading);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-wasm-error";
        error.textContent = parsed.error || "\u4E0D\u662F\u6709\u6548\u7684 WebAssembly \u4E8C\u8FDB\u5236\u6A21\u5757\u3002";
        preview.append(error);
        return preview;
    }
    const summary = document.createElement("div");
    summary.className = "ofv-wasm-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u7248\u672C", parsed.version ?? "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Sections", parsed.sections.length);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Imports", parsed.imports.length);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Exports", parsed.exports.length);
    preview.append(summary);
    const sectionTable = $08414ea58bdc1292$var$createWasmSectionTable(parsed.sections);
    preview.append(sectionTable);
    if (parsed.imports.length > 0) {
        const imports = $08414ea58bdc1292$var$createWasmList("\u5BFC\u5165", parsed.imports.map((item)=>`${item.module}.${item.name} \xB7 ${item.kind}`));
        preview.append(imports);
    }
    if (parsed.exports.length > 0) {
        const exports = $08414ea58bdc1292$var$createWasmList("\u5BFC\u51FA", parsed.exports.map((item)=>`${item.name} \xB7 ${item.kind} #${item.index}`));
        preview.append(exports);
    }
    return preview;
}
function $08414ea58bdc1292$var$createWasmSectionTable(sections) {
    const table = document.createElement("table");
    table.className = "ofv-wasm-sections";
    const thead = document.createElement("thead");
    const header = document.createElement("tr");
    for (const label of [
        "Section",
        "\u5927\u5C0F",
        "\u504F\u79FB"
    ]){
        const th = document.createElement("th");
        th.textContent = label;
        header.append(th);
    }
    thead.append(header);
    const tbody = document.createElement("tbody");
    for (const section of sections.slice(0, 80)){
        const row = document.createElement("tr");
        const name = document.createElement("td");
        name.textContent = section.customName ? `${section.name} (${section.customName})` : section.name;
        const size = document.createElement("td");
        size.textContent = $08414ea58bdc1292$var$formatBytes4(section.size);
        const offset = document.createElement("td");
        offset.textContent = `0x${section.offset.toString(16).toUpperCase()}`;
        row.append(name, size, offset);
        tbody.append(row);
    }
    table.append(thead, tbody);
    return table;
}
function $08414ea58bdc1292$var$createWasmList(titleText, rows) {
    const details = document.createElement("details");
    details.className = "ofv-details ofv-wasm-list";
    details.open = true;
    const summary = document.createElement("summary");
    summary.textContent = `${titleText} ${rows.length}`;
    const list = document.createElement("ul");
    for (const row of rows.slice(0, 120)){
        const item = document.createElement("li");
        item.textContent = row;
        list.append(item);
    }
    if (rows.length > 120) {
        const item = document.createElement("li");
        item.textContent = `\u8FD8\u6709 ${rows.length - 120} \u9879\u672A\u5C55\u793A\u3002`;
        list.append(item);
    }
    details.append(summary, list);
    return details;
}
function $08414ea58bdc1292$var$parseWasm(bytes) {
    if (bytes.length < 8 || bytes[0] !== 0 || bytes[1] !== 97 || bytes[2] !== 115 || bytes[3] !== 109) return {
        valid: false,
        error: "\u7F3A\u5C11 WebAssembly magic header\u3002",
        sections: [],
        imports: [],
        exports: []
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const version = view3.getUint32(4, true);
    const sections = [];
    const imports = [];
    const exports = [];
    let offset = 8;
    try {
        while(offset < bytes.length){
            const sectionOffset = offset;
            const id = bytes[offset++];
            const sizeInfo = $08414ea58bdc1292$var$readVarUint(bytes, offset);
            offset = sizeInfo.offset;
            const payloadOffset = offset;
            const payloadEnd = payloadOffset + sizeInfo.value;
            if (payloadEnd > bytes.length) throw new Error("section \u957F\u5EA6\u8D85\u8FC7\u6587\u4EF6\u8FB9\u754C\u3002");
            const section = {
                id: id,
                name: $08414ea58bdc1292$var$wasmSectionName(id),
                size: sizeInfo.value,
                offset: sectionOffset
            };
            if (id === 0) {
                const customName = $08414ea58bdc1292$var$readWasmName(bytes, payloadOffset, payloadEnd);
                section.customName = customName.value || void 0;
            } else if (id === 2) imports.push(...$08414ea58bdc1292$var$parseWasmImports(bytes, payloadOffset, payloadEnd));
            else if (id === 7) exports.push(...$08414ea58bdc1292$var$parseWasmExports(bytes, payloadOffset, payloadEnd));
            sections.push(section);
            offset = payloadEnd;
        }
    } catch (error) {
        return {
            valid: false,
            version: version,
            error: error instanceof Error ? error.message : "WASM section \u89E3\u6790\u5931\u8D25\u3002",
            sections: sections,
            imports: imports,
            exports: exports
        };
    }
    return {
        valid: true,
        version: version,
        sections: sections,
        imports: imports,
        exports: exports
    };
}
function $08414ea58bdc1292$var$parseWasmImports(bytes, offset, end) {
    const imports = [];
    const count = $08414ea58bdc1292$var$readVarUint(bytes, offset);
    offset = count.offset;
    for(let index = 0; index < count.value && offset < end; index++){
        const moduleName = $08414ea58bdc1292$var$readWasmName(bytes, offset, end);
        offset = moduleName.offset;
        const importName = $08414ea58bdc1292$var$readWasmName(bytes, offset, end);
        offset = importName.offset;
        const kind = bytes[offset++];
        offset = $08414ea58bdc1292$var$skipWasmImportDescriptor(bytes, offset, end, kind);
        imports.push({
            module: moduleName.value,
            name: importName.value,
            kind: $08414ea58bdc1292$var$wasmExternalKind(kind)
        });
    }
    return imports;
}
function $08414ea58bdc1292$var$parseWasmExports(bytes, offset, end) {
    const exports = [];
    const count = $08414ea58bdc1292$var$readVarUint(bytes, offset);
    offset = count.offset;
    for(let index = 0; index < count.value && offset < end; index++){
        const exportName = $08414ea58bdc1292$var$readWasmName(bytes, offset, end);
        offset = exportName.offset;
        const kind = bytes[offset++];
        const itemIndex = $08414ea58bdc1292$var$readVarUint(bytes, offset);
        offset = itemIndex.offset;
        exports.push({
            name: exportName.value,
            kind: $08414ea58bdc1292$var$wasmExternalKind(kind),
            index: itemIndex.value
        });
    }
    return exports;
}
function $08414ea58bdc1292$var$skipWasmImportDescriptor(bytes, offset, end, kind) {
    if (kind === 0) return $08414ea58bdc1292$var$readVarUint(bytes, offset).offset;
    if (kind === 1) {
        const elementTypeOffset = offset + 1;
        return $08414ea58bdc1292$var$skipWasmLimits(bytes, elementTypeOffset, end);
    }
    if (kind === 2) return $08414ea58bdc1292$var$skipWasmLimits(bytes, offset, end);
    if (kind === 3) return Math.min(end, offset + 2);
    return offset;
}
function $08414ea58bdc1292$var$skipWasmLimits(bytes, offset, end) {
    const flags = bytes[offset++];
    offset = $08414ea58bdc1292$var$readVarUint(bytes, offset).offset;
    if ((flags & 1) === 1 && offset < end) offset = $08414ea58bdc1292$var$readVarUint(bytes, offset).offset;
    return offset;
}
function $08414ea58bdc1292$var$readVarUint(bytes, offset) {
    let result = 0;
    let shift = 0;
    for(let index = 0; index < 5; index++){
        if (offset >= bytes.length) throw new Error("LEB128 \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        const byte = bytes[offset++];
        result |= (byte & 127) << shift;
        if ((byte & 128) === 0) return {
            value: result >>> 0,
            offset: offset
        };
        shift += 7;
    }
    throw new Error("LEB128 \u6570\u636E\u8FC7\u957F\u3002");
}
function $08414ea58bdc1292$var$readWasmName(bytes, offset, end) {
    const length = $08414ea58bdc1292$var$readVarUint(bytes, offset);
    offset = length.offset;
    const nameEnd = offset + length.value;
    if (nameEnd > end) throw new Error("\u5B57\u7B26\u4E32\u957F\u5EA6\u8D85\u8FC7 section \u8FB9\u754C\u3002");
    return {
        value: new TextDecoder().decode(bytes.slice(offset, nameEnd)),
        offset: nameEnd
    };
}
function $08414ea58bdc1292$var$wasmSectionName(id) {
    const names = {
        0: "custom",
        1: "type",
        2: "import",
        3: "function",
        4: "table",
        5: "memory",
        6: "global",
        7: "export",
        8: "start",
        9: "element",
        10: "code",
        11: "data",
        12: "data-count"
    };
    return names[id] || `unknown ${id}`;
}
function $08414ea58bdc1292$var$wasmExternalKind(kind) {
    const names = {
        0: "function",
        1: "table",
        2: "memory",
        3: "global"
    };
    return names[kind] || `unknown ${kind}`;
}
async function $08414ea58bdc1292$var$createPhotoshopPreview(bytes, toolbar) {
    const preview = document.createElement("div");
    preview.className = "ofv-psd-preview";
    const header = $08414ea58bdc1292$var$parsePhotoshopHeader(bytes);
    if (!header.valid) {
        const error = document.createElement("p");
        error.className = "ofv-psd-error";
        error.textContent = header.error || "\u4E0D\u662F\u6709\u6548\u7684 Photoshop \u6587\u6863\u5934\u3002";
        preview.append(error);
        return {
            element: preview
        };
    }
    const composite = await $08414ea58bdc1292$var$createPhotoshopCompositePreview(bytes, header, toolbar);
    preview.append(composite.element);
    return {
        element: preview,
        instance: composite.instance
    };
}

async function $08414ea58bdc1292$var$createPhotoshopCompositePreview(bytes, header, toolbar) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-psd-composite";
    if (!$08414ea58bdc1292$var$canUseBrowserCanvas()) {
        const status = document.createElement("p");
        status.className = "ofv-psd-error";
        status.textContent = "\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301 Canvas\uFF0C\u65E0\u6CD5\u751F\u6210 PSD \u5408\u6210\u56FE\u9884\u89C8\u3002";
        wrapper.append(status);
        return {
            element: wrapper
        };
    }
    try {
        const { readPsd: readPsd } = await (parcelRequire("6irRh"));
        const psd = readPsd($08414ea58bdc1292$var$toStandaloneArrayBuffer2(bytes), {
            skipLayerImageData: true,
            skipThumbnail: true,
            skipLinkedFilesData: true,
            useImageData: true,
            throwForMissingFeatures: false,
            logMissingFeatures: false
        });
        const canvas = psd.canvas || $08414ea58bdc1292$var$createCanvasFromPsdImageData(psd);
        if (!canvas) throw new Error("PSD \u6587\u4EF6\u6CA1\u6709\u53EF\u8BFB\u53D6\u7684\u5408\u6210\u56FE\u50CF\u6570\u636E\u3002\u8BF7\u5728 Photoshop \u4E2D\u5F00\u542F\u201C\u6700\u5927\u517C\u5BB9\u6027\u201D\u4FDD\u5B58\uFF0C\u6216\u63A5\u5165\u5916\u90E8\u8F6C\u6362\u670D\u52A1\u3002");
        canvas.classList.add("ofv-psd-canvas");
        canvas.setAttribute("role", "img");
        canvas.setAttribute("aria-label", `Photoshop composite ${header.width} x ${header.height}`);
        wrapper.append(canvas);
        return {
            element: wrapper,
            instance: $08414ea58bdc1292$var$createAssetVisualController(canvas, toolbar)
        };
    } catch (error) {
        const status = document.createElement("p");
        status.className = "ofv-psd-error";
        status.textContent = `PSD \u5408\u6210\u56FE\u89E3\u6790\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u5F53\u524D\u6587\u4EF6\u7279\u6027\u6682\u4E0D\u652F\u6301\u3002"}`;
        wrapper.append(status);
    }
    return {
        element: wrapper
    };
}
function $08414ea58bdc1292$var$createAssetVisualController(element, toolbar) {
    let scale = 1;
    let rotation = 0;
    let measuredBase = null;
    let scaleBox = null;
    const ensureScaleBox = ()=>{
        if (!scaleBox) {
            scaleBox = document.createElement("div");
            scaleBox.className = "ofv-asset-scale-box";
            element.parentElement?.insertBefore(scaleBox, element);
            scaleBox.append(element);
        }
        return scaleBox;
    };
    const apply = ()=>{
        if (scale === 1 && rotation === 0) {
            element.style.removeProperty("transform");
            element.style.removeProperty("transform-origin");
            element.style.removeProperty("width");
            element.style.removeProperty("height");
            element.style.removeProperty("max-width");
            element.style.removeProperty("max-height");
            if (scaleBox) {
                scaleBox.style.removeProperty("width");
                scaleBox.style.removeProperty("height");
            }
            measuredBase = null;
            toolbar?.setZoom(scale);
            return;
        }
        const box = ensureScaleBox();
        if (!measuredBase) {
            element.style.removeProperty("transform");
            element.style.removeProperty("width");
            element.style.removeProperty("height");
            element.style.removeProperty("max-width");
            element.style.removeProperty("max-height");
            box.style.removeProperty("width");
            box.style.removeProperty("height");
            const rect = element.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) {
                measuredBase = {
                    width: rect.width,
                    height: rect.height
                };
                element.style.width = `${rect.width}px`;
                element.style.height = `${rect.height}px`;
                element.style.maxWidth = "none";
                element.style.maxHeight = "none";
            }
        }
        element.style.transformOrigin = "center";
        if (measuredBase) {
            const sideways = Math.abs(rotation % 180) === 90;
            const boxWidth = (sideways ? measuredBase.height : measuredBase.width) * scale;
            const boxHeight = (sideways ? measuredBase.width : measuredBase.height) * scale;
            box.style.width = `${Math.ceil(boxWidth)}px`;
            box.style.height = `${Math.ceil(boxHeight)}px`;
            const dx = (boxWidth - measuredBase.width) / 2;
            const dy = (boxHeight - measuredBase.height) / 2;
            element.style.transform = `translate(${dx}px, ${dy}px) scale(${scale}) rotate(${rotation}deg)`;
        } else element.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
        toolbar?.setZoom(scale);
    };
    apply();
    return {
        canCommand (command) {
            return command === "zoom-in" || command === "zoom-out" || command === "zoom-reset" || command === "rotate-right" || command === "rotate-left";
        },
        command (command) {
            if (command === "zoom-in") {
                scale = Math.min(8, Number((scale + 0.25).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-out") {
                scale = Math.max(0.1, Number((scale - 0.25).toFixed(2)));
                apply();
                return true;
            }
            if (command === "zoom-reset") {
                scale = 1;
                rotation = 0;
                apply();
                return true;
            }
            if (command === "rotate-right") {
                rotation += 90;
                apply();
                return true;
            }
            if (command === "rotate-left") {
                rotation -= 90;
                apply();
                return true;
            }
            return false;
        },
        destroy () {
            element.style.removeProperty("transform");
            element.style.removeProperty("transform-origin");
            toolbar?.setZoom(void 0);
        }
    };
}
function $08414ea58bdc1292$var$canUseBrowserCanvas() {
    return typeof document !== "undefined" && typeof HTMLCanvasElement !== "undefined";
}
function $08414ea58bdc1292$var$toStandaloneArrayBuffer2(bytes) {
    return bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
}
function $08414ea58bdc1292$var$createCanvasFromPsdImageData(psd) {
    const imageData = psd.imageData;
    if (!imageData || !imageData.width || !imageData.height || !(imageData.data instanceof Uint8ClampedArray)) return void 0;
    const canvas = document.createElement("canvas");
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    const context = canvas.getContext("2d");
    if (!context) return void 0;
    context.putImageData(new ImageData(new Uint8ClampedArray(imageData.data), imageData.width, imageData.height), 0, 0);
    return canvas;
}
function $08414ea58bdc1292$var$parsePhotoshopHeader(bytes) {
    if (bytes.length < 26) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 PSD/PSB \u5934\u4FE1\u606F\u3002"
    };
    const signature = new TextDecoder("ascii").decode(bytes.slice(0, 4));
    if (signature !== "8BPS") return {
        valid: false,
        signature: signature,
        error: "\u7F3A\u5C11 8BPS Photoshop \u7B7E\u540D\u3002"
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const version = view3.getUint16(4, false);
    if (version !== 1 && version !== 2) return {
        valid: false,
        signature: signature,
        version: version,
        error: `\u672A\u77E5 Photoshop \u6587\u4EF6\u7248\u672C\uFF1A${version}\u3002`
    };
    const reserved = bytes.slice(6, 12);
    if (reserved.some((byte)=>byte !== 0)) return {
        valid: false,
        signature: signature,
        version: version,
        error: "PSD/PSB \u4FDD\u7559\u5B57\u6BB5\u4E0D\u4E3A 0\uFF0C\u6587\u4EF6\u5934\u53EF\u80FD\u5DF2\u635F\u574F\u3002"
    };
    return {
        valid: true,
        signature: signature,
        version: version,
        channels: view3.getUint16(12, false),
        height: view3.getUint32(14, false),
        width: view3.getUint32(18, false),
        depth: view3.getUint16(22, false),
        colorMode: view3.getUint16(24, false)
    };
}
function $08414ea58bdc1292$var$createSqlitePreview(bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-sqlite-preview";
    const heading = document.createElement("strong");
    heading.textContent = "SQLite \u7ED3\u6784";
    preview.append(heading);
    const header = $08414ea58bdc1292$var$parseSqliteHeader(bytes);
    if (!header.valid) {
        const error = document.createElement("p");
        error.className = "ofv-sqlite-error";
        error.textContent = header.error || "\u4E0D\u662F\u6709\u6548\u7684 SQLite \u6570\u636E\u5E93\u6587\u4EF6\u3002";
        preview.append(error);
        return preview;
    }
    $08414ea58bdc1292$var$hideSupplementalInfo8(heading);
    const summary = document.createElement("div");
    summary.className = "ofv-sqlite-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u9875\u5927\u5C0F", `${header.pageSize} B`);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u9875\u6570", header.pageCount ?? "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u8BFB\u5199\u7248\u672C", `${$08414ea58bdc1292$var$sqliteJournalMode(header.readVersion)} / ${$08414ea58bdc1292$var$sqliteJournalMode(header.writeVersion)}`);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Schema", header.schemaVersion ?? "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u7F16\u7801", $08414ea58bdc1292$var$sqliteEncoding(header.textEncoding));
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "User version", header.userVersion ?? 0);
    $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
    preview.append(summary);
    const schema = $08414ea58bdc1292$var$parseSqliteSchema(bytes, header);
    if (schema.length > 0) {
        preview.append($08414ea58bdc1292$var$createSqliteSchemaTable(schema));
        const samples = $08414ea58bdc1292$var$createSqliteTableSamples(bytes, header, schema);
        if (samples.length > 0) preview.append($08414ea58bdc1292$var$createSqliteDataPreview(samples));
    } else {
        const empty = document.createElement("p");
        empty.className = "ofv-sqlite-empty";
        empty.textContent = "\u672A\u4ECE\u7B2C\u4E00\u9875 sqlite_schema \u53F6\u5B50\u9875\u63D0\u53D6\u5230\u7ED3\u6784\u5B9A\u4E49\uFF1B\u590D\u6742\u6570\u636E\u5E93\u53EF\u540E\u7EED\u63A5\u5165 sqlite-wasm \u5B8C\u6574\u8BFB\u53D6\u3002";
        preview.append(empty);
    }
    return preview;
}
function $08414ea58bdc1292$var$createSqliteTableSamples(bytes, header, schema) {
    return schema.filter((entry)=>entry.type === "table" && entry.rootPage > 0 && !entry.name.startsWith("sqlite_")).slice(0, 6).map((entry)=>$08414ea58bdc1292$var$parseSqliteTableSample(bytes, header, entry)).filter((sample)=>Boolean(sample && (sample.rows.length > 0 || sample.note)));
}
function $08414ea58bdc1292$var$parseSqliteTableSample(bytes, header, entry) {
    const pageSize = header.pageSize || 0;
    const pageIndex = entry.rootPage - 1;
    const pageStart = pageIndex * pageSize;
    if (pageSize <= 0 || pageStart < 0 || pageStart >= bytes.length) return null;
    const pageHeader = pageStart + (entry.rootPage === 1 ? 100 : 0);
    if (pageHeader + 8 > bytes.length) return null;
    const columns = $08414ea58bdc1292$var$parseSqliteCreateTableColumns(entry.sql);
    if (columns.length === 0) return null;
    if (bytes[pageHeader] !== 13) return {
        tableName: entry.name,
        rootPage: entry.rootPage,
        columns: columns,
        rows: [],
        note: "\u5F53\u524D\u53EA\u5185\u7F6E\u89E3\u6790 SQLite table leaf page\uFF1B\u7D22\u5F15\u9875\u3001\u6EA2\u51FA\u9875\u6216\u590D\u6742 b-tree \u53EF\u63A5\u5165 sqlite-wasm \u589E\u5F3A\u3002"
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const cellCount = view3.getUint16(pageHeader + 3, false);
    const rows = [];
    const pageEnd = Math.min(bytes.length, pageStart + pageSize);
    for(let index = 0; index < Math.min(cellCount, 80); index++){
        const pointerOffset = pageHeader + 8 + index * 2;
        if (pointerOffset + 2 > pageEnd) break;
        const cellOffset = pageStart + view3.getUint16(pointerOffset, false);
        const row = $08414ea58bdc1292$var$parseSqliteTableCell(bytes, cellOffset, pageEnd, columns);
        if (row) rows.push(row);
    }
    return {
        tableName: entry.name,
        rootPage: entry.rootPage,
        columns: columns,
        rows: rows,
        note: rows.length === 0 ? "\u672A\u4ECE\u8BE5\u8868 root page \u62BD\u6837\u5230\u884C\u6570\u636E\u3002" : void 0
    };
}
function $08414ea58bdc1292$var$parseSqliteTableCell(bytes, offset, pageEnd, columns) {
    try {
        let cursor = offset;
        const payloadLength = $08414ea58bdc1292$var$readSqliteVarint(bytes, cursor);
        cursor = payloadLength.offset;
        const rowId = $08414ea58bdc1292$var$readSqliteVarint(bytes, cursor);
        cursor = rowId.offset;
        const payloadEnd = Math.min(pageEnd, cursor + Number(payloadLength.value));
        if (payloadEnd > bytes.length) return null;
        const record = $08414ea58bdc1292$var$parseSqliteRecord(bytes, cursor, payloadEnd);
        return columns.map((column, index)=>{
            const value = record[index] ?? null;
            return value === null && column.primaryKey && /int/i.test(column.type) ? Number(rowId.value) : value;
        });
    } catch  {
        return null;
    }
}
function $08414ea58bdc1292$var$parseSqliteCreateTableColumns(sql) {
    const start = sql.indexOf("(");
    const end = sql.lastIndexOf(")");
    if (start < 0 || end <= start) return [];
    return $08414ea58bdc1292$var$splitSqliteColumnDefinitions(sql.slice(start + 1, end)).map($08414ea58bdc1292$var$parseSqliteColumnDefinition).filter((column)=>Boolean(column));
}
function $08414ea58bdc1292$var$splitSqliteColumnDefinitions(value) {
    const result = [];
    let current = "";
    let depth = 0;
    let quote = "";
    for(let index = 0; index < value.length; index++){
        const char = value[index];
        if (quote) {
            current += char;
            if (char === quote && value[index + 1] === quote) current += value[++index];
            else if (char === quote) quote = "";
            continue;
        }
        if (char === "'" || char === '"' || char === "`") {
            quote = char;
            current += char;
            continue;
        }
        if (char === "[") {
            quote = "]";
            current += char;
            continue;
        }
        if (char === "(") depth++;
        else if (char === ")") depth = Math.max(0, depth - 1);
        if (char === "," && depth === 0) {
            result.push(current.trim());
            current = "";
        } else current += char;
    }
    if (current.trim()) result.push(current.trim());
    return result;
}
function $08414ea58bdc1292$var$parseSqliteColumnDefinition(definition) {
    if (/^(?:constraint|primary|foreign|unique|check|key)\b/i.test(definition)) return null;
    const match = definition.match(/^("[^"]+"|'[^']+'|`[^`]+`|\[[^\]]+\]|\S+)(?:\s+(.+))?$/);
    if (!match) return null;
    const name = $08414ea58bdc1292$var$unquoteSqliteIdentifier(match[1]);
    const rest = match[2] || "";
    const typeMatch = rest.match(/^([a-z0-9_]+(?:\s+[a-z0-9_]+)?)/i);
    return {
        name: name,
        type: typeMatch?.[1]?.toUpperCase() || "ANY",
        primaryKey: /\bprimary\s+key\b/i.test(rest)
    };
}
function $08414ea58bdc1292$var$unquoteSqliteIdentifier(value) {
    if (value.startsWith('"') && value.endsWith('"') || value.startsWith("'") && value.endsWith("'") || value.startsWith("`") && value.endsWith("`")) return value.slice(1, -1).replaceAll(value[0] + value[0], value[0]);
    if (value.startsWith("[") && value.endsWith("]")) return value.slice(1, -1);
    return value;
}
function $08414ea58bdc1292$var$parseSqliteHeader(bytes) {
    if (bytes.length < 100) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 SQLite \u6570\u636E\u5E93\u5934\u3002"
    };
    const signature = new TextDecoder("ascii").decode(bytes.slice(0, 16));
    if (signature !== "SQLite format 3\0") return {
        valid: false,
        error: "\u7F3A\u5C11 SQLite format 3 \u6587\u4EF6\u7B7E\u540D\u3002"
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const rawPageSize = view3.getUint16(16, false);
    const pageSize = rawPageSize === 1 ? 65536 : rawPageSize;
    if (pageSize < 512 || pageSize > 65536 || (pageSize & pageSize - 1) !== 0) return {
        valid: false,
        error: `SQLite \u9875\u5927\u5C0F\u65E0\u6548\uFF1A${pageSize}\u3002`
    };
    return {
        valid: true,
        pageSize: pageSize,
        writeVersion: bytes[18],
        readVersion: bytes[19],
        pageCount: view3.getUint32(28, false),
        schemaVersion: view3.getUint32(40, false),
        textEncoding: view3.getUint32(56, false),
        userVersion: view3.getUint32(60, false)
    };
}
function $08414ea58bdc1292$var$parseSqliteSchema(bytes, header) {
    const pageSize = header.pageSize || 0;
    if (pageSize <= 0 || bytes.length < Math.min(pageSize, 100)) return [];
    const pageStart = 0;
    const btreeStart = 100;
    if (bytes[btreeStart] !== 13) return [];
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const cellCount = view3.getUint16(btreeStart + 3, false);
    const entries = [];
    for(let index = 0; index < Math.min(cellCount, 80); index++){
        const pointerOffset = btreeStart + 8 + index * 2;
        if (pointerOffset + 2 > bytes.length) break;
        const cellOffset = pageStart + view3.getUint16(pointerOffset, false);
        const entry = $08414ea58bdc1292$var$parseSqliteSchemaCell(bytes, cellOffset, pageStart + pageSize);
        if (entry) entries.push(entry);
    }
    return entries;
}
function $08414ea58bdc1292$var$parseSqliteSchemaCell(bytes, offset, pageEnd) {
    try {
        let cursor = offset;
        const payloadLength = $08414ea58bdc1292$var$readSqliteVarint(bytes, cursor);
        cursor = payloadLength.offset;
        const rowId = $08414ea58bdc1292$var$readSqliteVarint(bytes, cursor);
        cursor = rowId.offset;
        const payloadEnd = Math.min(pageEnd, cursor + Number(payloadLength.value));
        if (payloadEnd > bytes.length) return null;
        const record = $08414ea58bdc1292$var$parseSqliteRecord(bytes, cursor, payloadEnd);
        if (record.length < 5) return null;
        return {
            type: String(record[0] ?? ""),
            name: String(record[1] ?? ""),
            tableName: String(record[2] ?? ""),
            rootPage: Number(record[3] ?? 0),
            sql: String(record[4] ?? "")
        };
    } catch  {
        return null;
    }
}
function $08414ea58bdc1292$var$parseSqliteRecord(bytes, offset, end) {
    const headerSize = $08414ea58bdc1292$var$readSqliteVarint(bytes, offset);
    let headerCursor = headerSize.offset;
    const bodyStart = offset + Number(headerSize.value);
    let bodyCursor = bodyStart;
    const serialTypes = [];
    while(headerCursor < bodyStart && headerCursor < end){
        const serial = $08414ea58bdc1292$var$readSqliteVarint(bytes, headerCursor);
        serialTypes.push(serial.value);
        headerCursor = serial.offset;
    }
    return serialTypes.map((serialType)=>{
        const value = $08414ea58bdc1292$var$readSqliteValue(bytes, bodyCursor, end, serialType);
        bodyCursor = value.offset;
        return value.value;
    });
}
function $08414ea58bdc1292$var$readSqliteValue(bytes, offset, end, serialType) {
    const type = Number(serialType);
    if (type === 0) return {
        value: null,
        offset: offset
    };
    if (type === 1) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 1),
        offset: offset + 1
    };
    if (type === 2) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 2),
        offset: offset + 2
    };
    if (type === 3) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 3),
        offset: offset + 3
    };
    if (type === 4) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 4),
        offset: offset + 4
    };
    if (type === 5) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 6),
        offset: offset + 6
    };
    if (type === 6) return {
        value: $08414ea58bdc1292$var$signedInteger(bytes, offset, 8),
        offset: offset + 8
    };
    if (type === 8) return {
        value: 0,
        offset: offset
    };
    if (type === 9) return {
        value: 1,
        offset: offset
    };
    if (type >= 12) {
        const length = Math.floor((type - 12) / 2);
        const valueEnd = Math.min(end, offset + length);
        if (type % 2 === 1) return {
            value: new TextDecoder().decode(bytes.slice(offset, valueEnd)),
            offset: offset + length
        };
        return {
            value: `<blob ${length} B>`,
            offset: offset + length
        };
    }
    return {
        value: null,
        offset: offset
    };
}
function $08414ea58bdc1292$var$readSqliteVarint(bytes, offset) {
    let value = 0n;
    for(let index = 0; index < 9; index++){
        if (offset >= bytes.length) throw new Error("SQLite varint \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        const byte = bytes[offset++];
        if (index === 8) {
            value = value << 8n | BigInt(byte);
            return {
                value: value,
                offset: offset
            };
        }
        value = value << 7n | BigInt(byte & 127);
        if ((byte & 128) === 0) return {
            value: value,
            offset: offset
        };
    }
    return {
        value: value,
        offset: offset
    };
}
function $08414ea58bdc1292$var$signedInteger(bytes, offset, length) {
    let value = 0n;
    for(let index = 0; index < length; index++)value = value << 8n | BigInt(bytes[offset + index] || 0);
    const bits = BigInt(length * 8);
    const signBit = 1n << bits - 1n;
    if ((value & signBit) !== 0n) value -= 1n << bits;
    return Number(value);
}
function $08414ea58bdc1292$var$createSqliteSchemaTable(entries) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-sqlite-schema";
    const title = document.createElement("strong");
    title.textContent = `Schema \u5BF9\u8C61 ${entries.length}`;
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const header = document.createElement("tr");
    for (const label of [
        "\u7C7B\u578B",
        "\u540D\u79F0",
        "\u8868",
        "Root",
        "SQL"
    ]){
        const th = document.createElement("th");
        th.textContent = label;
        header.append(th);
    }
    thead.append(header);
    const tbody = document.createElement("tbody");
    for (const entry of entries){
        const row = document.createElement("tr");
        for (const value of [
            entry.type,
            entry.name,
            entry.tableName,
            String(entry.rootPage),
            entry.sql
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            row.append(cell);
        }
        tbody.append(row);
    }
    table.append(thead, tbody);
    wrapper.append(title, table);
    return wrapper;
}
function $08414ea58bdc1292$var$createSqliteDataPreview(samples) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-sqlite-data";
    const title = document.createElement("strong");
    title.textContent = "\u8868\u6570\u636E\u62BD\u6837";
    wrapper.append(title);
    for (const sample of samples){
        const details = document.createElement("details");
        details.className = "ofv-sqlite-table-sample";
        details.open = true;
        const summary = document.createElement("summary");
        summary.textContent = `${sample.tableName} \xB7 root ${sample.rootPage} \xB7 ${sample.rows.length} \u884C`;
        details.append(summary);
        if (sample.note) {
            const note = document.createElement("p");
            note.className = "ofv-sqlite-empty";
            note.textContent = sample.note;
            details.append(note);
        }
        if (sample.rows.length > 0) {
            const scroller = document.createElement("div");
            scroller.className = "ofv-sqlite-data-table";
            const table = document.createElement("table");
            const thead = document.createElement("thead");
            const headRow = document.createElement("tr");
            for (const column of sample.columns){
                const th = document.createElement("th");
                th.textContent = column.name;
                if (column.type) th.title = column.primaryKey ? `${column.type} PRIMARY KEY` : column.type;
                headRow.append(th);
            }
            thead.append(headRow);
            const tbody = document.createElement("tbody");
            for (const row of sample.rows){
                const tr = document.createElement("tr");
                for (const value of row){
                    const td = document.createElement("td");
                    td.textContent = value === null ? "NULL" : String(value);
                    tr.append(td);
                }
                tbody.append(tr);
            }
            table.append(thead, tbody);
            scroller.append(table);
            details.append(scroller);
        }
        wrapper.append(details);
    }
    return wrapper;
}
function $08414ea58bdc1292$var$sqliteJournalMode(value) {
    if (value === 1) return "rollback";
    if (value === 2) return "WAL";
    return value === void 0 ? "\u672A\u77E5" : String(value);
}
function $08414ea58bdc1292$var$sqliteEncoding(value) {
    const encodings = {
        0: "\u672A\u58F0\u660E",
        1: "UTF-8",
        2: "UTF-16le",
        3: "UTF-16be"
    };
    return value === void 0 ? "\u672A\u77E5" : encodings[value] || `\u672A\u77E5 (${value})`;
}
function $08414ea58bdc1292$var$createParquetPreview(bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-data-preview";
    const heading = document.createElement("strong");
    heading.textContent = "Parquet \u7ED3\u6784";
    preview.append(heading);
    const parsed = $08414ea58bdc1292$var$parseParquet(bytes);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = parsed.error || "\u4E0D\u662F\u6709\u6548\u7684 Parquet \u6587\u4EF6\u3002";
        preview.append(error);
        return preview;
    }
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Magic", "PAR1");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Footer", `${parsed.footerLength} B`);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Footer offset", `0x${(parsed.footerOffset || 0).toString(16).toUpperCase()}`);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u6570\u636E\u533A", $08414ea58bdc1292$var$formatBytes4(parsed.dataBytes || 0));
    $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
    preview.append(summary);
    const note = document.createElement("p");
    note.className = "ofv-data-note";
    note.textContent = "Parquet footer \u4F7F\u7528 Thrift \u7F16\u7801\uFF1B\u6B63\u5728\u5C1D\u8BD5\u5728\u6D4F\u89C8\u5668\u7AEF\u89E3\u6790 schema\u3001row group \u548C\u524D\u51E0\u884C\u6570\u636E\u3002";
    $08414ea58bdc1292$var$hideSupplementalInfo8(note);
    preview.append(note);
    $08414ea58bdc1292$var$appendParquetDecodedPreview(preview, bytes, note, heading);
    return preview;
}

async function $08414ea58bdc1292$var$appendParquetDecodedPreview(preview, bytes, note, heading) {
    try {
        const { parquetMetadataAsync: parquetMetadataAsync, parquetReadObjects: parquetReadObjects, parquetSchema: parquetSchema } = await (parcelRequire("TrGCL"));
        const file = $08414ea58bdc1292$var$arrayBufferLike(bytes);
        const metadata = await parquetMetadataAsync(file, {
            initialFetchSize: Math.min(bytes.byteLength, 524288)
        });
        const schema = parquetSchema(metadata);
        const fields = $08414ea58bdc1292$var$flattenParquetSchema(schema);
        const rows = await parquetReadObjects({
            file: file,
            metadata: metadata,
            rowFormat: "object",
            rowStart: 0,
            rowEnd: Math.min(20, Number(metadata.num_rows || 0n))
        });
        note.textContent = `\u5DF2\u4F7F\u7528 hyparquet \u5728\u524D\u7AEF\u89E3\u6790 schema\u3001${metadata.row_groups.length} \u4E2A row group \u548C ${rows.length} \u884C\u62BD\u6837\u6570\u636E\u3002`;
        if (rows.length > 0) {
            $08414ea58bdc1292$var$hideSupplementalInfo8(heading);
            const schemaTable = $08414ea58bdc1292$var$createParquetSchemaTable(fields, metadata);
            $08414ea58bdc1292$var$hideSupplementalInfo8(schemaTable);
            preview.append(schemaTable);
            preview.append($08414ea58bdc1292$var$createObjectRowsTable("\u8BB0\u5F55\u62BD\u6837", rows));
        } else preview.append($08414ea58bdc1292$var$createParquetSchemaTable(fields, metadata));
    } catch (error) {
        note.textContent = `\u5DF2\u5C55\u793A Parquet \u5BB9\u5668\u8FB9\u754C\uFF1Bschema/\u8BB0\u5F55\u89E3\u6790\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u5F53\u524D\u7F16\u7801\u6216\u538B\u7F29\u65B9\u5F0F\u6682\u4E0D\u652F\u6301\u3002"}`;
    }
}
function $08414ea58bdc1292$var$arrayBufferLike(bytes) {
    return {
        byteLength: bytes.byteLength,
        slice (start, end) {
            return bytes.buffer.slice(bytes.byteOffset + start, bytes.byteOffset + (end ?? bytes.byteLength));
        }
    };
}
function $08414ea58bdc1292$var$flattenParquetSchema(schema) {
    const fields = [];
    const visit = (node)=>{
        const path = Array.isArray(node.path) && node.path.length > 0 ? node.path.join(".") : node.element?.name || "";
        if (node.element && path) fields.push({
            name: path,
            type: node.element.type || (node.children?.length ? "group" : "-"),
            repetition: node.element.repetition_type || "-",
            logical: node.element.logical_type?.type || node.element.converted_type || "-"
        });
        for (const child of node.children || [])visit(child);
    };
    for (const child of schema.children || [])visit(child);
    return fields;
}
function $08414ea58bdc1292$var$createParquetSchemaTable(fields, metadata) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-parquet-schema";
    const title = document.createElement("strong");
    title.textContent = "Schema";
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Rows", String(metadata.num_rows));
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Row groups", metadata.row_groups.length);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Columns", fields.filter((field)=>field.type !== "group").length);
    if (metadata.created_by) (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Created by", metadata.created_by);
    $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
    const table = document.createElement("table");
    const head = document.createElement("thead");
    const headRow = document.createElement("tr");
    for (const label of [
        "Name",
        "Type",
        "Repetition",
        "Logical"
    ]){
        const th = document.createElement("th");
        th.textContent = label;
        headRow.append(th);
    }
    head.append(headRow);
    const body = document.createElement("tbody");
    for (const field of fields.slice(0, 120)){
        const row = document.createElement("tr");
        for (const value of [
            field.name,
            field.type,
            field.repetition,
            field.logical
        ]){
            const cell = document.createElement("td");
            cell.textContent = value;
            row.append(cell);
        }
        body.append(row);
    }
    table.append(head, body);
    wrapper.append(title, summary, table);
    return wrapper;
}
function $08414ea58bdc1292$var$createObjectRowsTable(titleText, rows) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-parquet-records";
    const title = document.createElement("strong");
    title.textContent = `${titleText} ${rows.length}`;
    const columns = [
        ...new Set(rows.flatMap((row)=>Object.keys(row)))
    ].slice(0, 40);
    const table = document.createElement("table");
    const head = document.createElement("thead");
    const headRow = document.createElement("tr");
    for (const column of columns){
        const th = document.createElement("th");
        th.textContent = column;
        headRow.append(th);
    }
    head.append(headRow);
    const body = document.createElement("tbody");
    for (const item of rows){
        const row = document.createElement("tr");
        for (const column of columns){
            const cell = document.createElement("td");
            cell.textContent = $08414ea58bdc1292$var$formatPreviewValue(item[column]);
            row.append(cell);
        }
        body.append(row);
    }
    table.append(head, body);
    wrapper.append(title, table);
    return wrapper;
}
function $08414ea58bdc1292$var$formatPreviewValue(value) {
    if (value === null || value === void 0) return "";
    if (typeof value === "bigint") return value.toString();
    if (value instanceof Uint8Array) return `Uint8Array(${value.byteLength})`;
    if (value instanceof Date) return value.toISOString();
    if (typeof value === "object") try {
        return JSON.stringify(value);
    } catch  {
        return Object.prototype.toString.call(value);
    }
    return String(value);
}
function $08414ea58bdc1292$var$parseParquet(bytes) {
    if (bytes.length < 12) return {
        valid: false,
        error: "\u6587\u4EF6\u592A\u77ED\uFF0C\u65E0\u6CD5\u8BFB\u53D6 Parquet \u5934\u5C3E\u4FE1\u606F\u3002"
    };
    if ($08414ea58bdc1292$var$asciiAt3(bytes, 0, 4) !== "PAR1" || $08414ea58bdc1292$var$asciiAt3(bytes, bytes.length - 4, 4) !== "PAR1") return {
        valid: false,
        error: "\u7F3A\u5C11 Parquet PAR1 magic header/footer\u3002"
    };
    const view3 = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const footerLength = view3.getUint32(bytes.length - 8, true);
    const footerOffset = bytes.length - 8 - footerLength;
    if (footerOffset < 4) return {
        valid: false,
        error: "Parquet footer \u957F\u5EA6\u8D85\u8FC7\u6587\u4EF6\u8FB9\u754C\u3002"
    };
    return {
        valid: true,
        footerLength: footerLength,
        footerOffset: footerOffset,
        dataBytes: Math.max(0, footerOffset - 4)
    };
}
function $08414ea58bdc1292$var$createAvroPreview(bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-data-preview";
    const heading = document.createElement("strong");
    heading.textContent = "Avro \u7ED3\u6784";
    preview.append(heading);
    const parsed = $08414ea58bdc1292$var$parseAvro(bytes);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = parsed.error || "\u4E0D\u662F\u6709\u6548\u7684 Avro Object Container \u6587\u4EF6\u3002";
        preview.append(error);
        return preview;
    }
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Magic", "Obj\\x01");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Codec", parsed.codec || "null");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Metadata", parsed.metadata.length);
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Sync marker", parsed.syncMarker || "\u672A\u77E5");
    $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
    preview.append(summary);
    const hasRecordRows = Boolean(parsed.records && parsed.records.rows.length > 0);
    if (hasRecordRows) $08414ea58bdc1292$var$hideSupplementalInfo8(heading);
    if (parsed.schema) {
        const schema = document.createElement("div");
        schema.className = "ofv-avro-schema";
        const title = document.createElement("strong");
        title.textContent = "Schema";
        const meta = document.createElement("div");
        meta.className = "ofv-data-summary";
        (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(meta, "\u7C7B\u578B", parsed.schema.type || "\u672A\u77E5");
        (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(meta, "\u540D\u79F0", [
            parsed.schema.namespace,
            parsed.schema.name
        ].filter(Boolean).join(".") || "\u672A\u77E5");
        (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(meta, "\u5B57\u6BB5", parsed.schema.fields.length);
        $08414ea58bdc1292$var$hideSupplementalInfo8(meta);
        schema.append(title, meta);
        if (parsed.schema.fields.length > 0) {
            const list = document.createElement("ul");
            for (const field of parsed.schema.fields.slice(0, 80)){
                const item = document.createElement("li");
                item.textContent = field;
                list.append(item);
            }
            schema.append(list);
        }
        if (hasRecordRows) $08414ea58bdc1292$var$hideSupplementalInfo8(schema);
        preview.append(schema);
    }
    if (parsed.records && (parsed.records.rows.length > 0 || parsed.records.note)) preview.append($08414ea58bdc1292$var$createAvroRecordPreview(parsed.records));
    if (parsed.metadata.length > 0) {
        const metadata = $08414ea58bdc1292$var$createKeyValueTable("Metadata", parsed.metadata);
        if (parsed.schema || hasRecordRows) $08414ea58bdc1292$var$hideSupplementalInfo8(metadata);
        preview.append(metadata);
    }
    return preview;
}
function $08414ea58bdc1292$var$parseAvro(bytes) {
    if (bytes.length < 4 || bytes[0] !== 79 || bytes[1] !== 98 || bytes[2] !== 106 || bytes[3] !== 1) return {
        valid: false,
        error: "\u7F3A\u5C11 Avro Object Container magic header\u3002",
        metadata: []
    };
    let offset = 4;
    const metadata = [];
    try {
        while(true){
            const blockCount = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
            offset = blockCount.offset;
            let count = blockCount.value;
            if (count === 0n) break;
            if (count < 0n) {
                count = -count;
                const blockSize = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
                offset = blockSize.offset;
            }
            for(let index = 0; index < Number(count); index++){
                const key = $08414ea58bdc1292$var$readAvroBytes(bytes, offset);
                offset = key.offset;
                const value = $08414ea58bdc1292$var$readAvroBytes(bytes, offset);
                offset = value.offset;
                metadata.push({
                    key: new TextDecoder().decode(key.value),
                    value: $08414ea58bdc1292$var$decodeAvroMetadataValue(key.value, value.value)
                });
            }
        }
        if (offset + 16 > bytes.length) throw new Error("Avro sync marker \u7F3A\u5931\u3002");
        const syncMarkerBytes = bytes.slice(offset, offset + 16);
        const syncMarker = Array.from(syncMarkerBytes).map((byte)=>byte.toString(16).padStart(2, "0")).join("");
        const schemaText = metadata.find((item)=>item.key === "avro.schema")?.value;
        const codec = metadata.find((item)=>item.key === "avro.codec")?.value;
        const schema = schemaText ? $08414ea58bdc1292$var$summarizeAvroSchema(schemaText) : void 0;
        return {
            valid: true,
            metadata: metadata,
            codec: codec,
            syncMarker: syncMarker,
            schema: schema,
            records: schemaText ? $08414ea58bdc1292$var$parseAvroRecordSamples(bytes, offset + 16, syncMarkerBytes, schemaText, codec) : void 0
        };
    } catch (error) {
        return {
            valid: false,
            error: error instanceof Error ? error.message : "Avro metadata \u89E3\u6790\u5931\u8D25\u3002",
            metadata: metadata
        };
    }
}
function $08414ea58bdc1292$var$readAvroLong(bytes, offset) {
    let result = 0n;
    let shift = 0n;
    for(let index = 0; index < 10; index++){
        if (offset >= bytes.length) throw new Error("Avro long \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        const byte = bytes[offset++];
        result |= BigInt(byte & 127) << shift;
        if ((byte & 128) === 0) {
            const value = result >> 1n ^ -(result & 1n);
            return {
                value: value,
                offset: offset
            };
        }
        shift += 7n;
    }
    throw new Error("Avro long \u6570\u636E\u8FC7\u957F\u3002");
}
function $08414ea58bdc1292$var$readAvroBytes(bytes, offset) {
    const length = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
    offset = length.offset;
    if (length.value < 0n) throw new Error("Avro bytes \u957F\u5EA6\u65E0\u6548\u3002");
    const size = Number(length.value);
    const end = offset + size;
    if (end > bytes.length) throw new Error("Avro bytes \u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002");
    return {
        value: bytes.slice(offset, end),
        offset: end
    };
}
function $08414ea58bdc1292$var$decodeAvroMetadataValue(keyBytes, valueBytes) {
    const key = new TextDecoder().decode(keyBytes);
    if (key === "avro.schema" || key === "avro.codec" || /^[a-z0-9_.-]+$/i.test(key)) return new TextDecoder().decode(valueBytes);
    return `<${valueBytes.length} B>`;
}
function $08414ea58bdc1292$var$summarizeAvroSchema(schemaText) {
    try {
        const schema = JSON.parse(schemaText);
        const fieldSchemas = Array.isArray(schema.fields) ? schema.fields.filter((field)=>typeof field.name === "string").map((field)=>({
                name: field.name,
                type: field.type,
                label: `${field.name}: ${$08414ea58bdc1292$var$formatAvroType(field.type)}`
            })) : [];
        return {
            type: typeof schema.type === "string" ? schema.type : void 0,
            name: typeof schema.name === "string" ? schema.name : void 0,
            namespace: typeof schema.namespace === "string" ? schema.namespace : void 0,
            fields: fieldSchemas.map((field)=>field.label),
            fieldSchemas: fieldSchemas
        };
    } catch  {
        return {
            fields: [],
            fieldSchemas: []
        };
    }
}
function $08414ea58bdc1292$var$parseAvroRecordSamples(bytes, offset, syncMarker, schemaText, codec) {
    if (codec && codec !== "null") return {
        fields: [],
        rows: [],
        note: `\u5F53\u524D\u5185\u7F6E\u62BD\u6837\u53EA\u652F\u6301 null codec\uFF1B\u8BE5\u6587\u4EF6\u4F7F\u7528 ${codec} \u538B\u7F29\u3002`
    };
    const schema = $08414ea58bdc1292$var$summarizeAvroSchema(schemaText);
    const fields = schema?.fieldSchemas || [];
    if (!schema || schema.type !== "record" || fields.length === 0) return void 0;
    const rows = [];
    try {
        while(offset < bytes.length && rows.length < 80){
            const countInfo = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
            offset = countInfo.offset;
            if (countInfo.value === 0n) break;
            const blockSizeInfo = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
            offset = blockSizeInfo.offset;
            const count = Number(countInfo.value < 0n ? -countInfo.value : countInfo.value);
            const blockSize = Number(blockSizeInfo.value);
            const blockEnd = offset + blockSize;
            if (!Number.isFinite(count) || !Number.isFinite(blockSize) || blockSize < 0 || blockEnd > bytes.length) throw new Error("Avro data block \u8D85\u51FA\u6587\u4EF6\u8FB9\u754C\u3002");
            for(let index = 0; index < count && offset < blockEnd && rows.length < 80; index++){
                const decoded = $08414ea58bdc1292$var$readAvroRecord(bytes, offset, blockEnd, fields);
                offset = decoded.offset;
                rows.push(decoded.row);
            }
            offset = blockEnd;
            if (offset + syncMarker.length <= bytes.length && $08414ea58bdc1292$var$matchesBytes(bytes, offset, syncMarker)) offset += syncMarker.length;
        }
    } catch (error) {
        return {
            fields: fields.map((field)=>field.name),
            rows: rows,
            note: rows.length > 0 ? `\u5DF2\u62BD\u6837\u90E8\u5206\u8BB0\u5F55\uFF0C\u540E\u7EED\u6570\u636E\u89E3\u6790\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u672A\u77E5\u9519\u8BEF"}` : `\u8BB0\u5F55\u62BD\u6837\u5931\u8D25\uFF1A${error instanceof Error ? error.message : "\u5F53\u524D schema \u6682\u4E0D\u652F\u6301"}`
        };
    }
    return rows.length > 0 ? {
        fields: fields.map((field)=>field.name),
        rows: rows
    } : void 0;
}
function $08414ea58bdc1292$var$readAvroRecord(bytes, offset, end, fields) {
    const row = [];
    for (const field of fields){
        const value = $08414ea58bdc1292$var$readAvroDatum(bytes, offset, end, field.type);
        row.push(value.value);
        offset = value.offset;
    }
    return {
        row: row,
        offset: offset
    };
}
function $08414ea58bdc1292$var$readAvroDatum(bytes, offset, end, type) {
    if (Array.isArray(type)) {
        const branch = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
        const branchIndex = Number(branch.value);
        const branchType = type[branchIndex];
        if (branchIndex < 0 || branchIndex >= type.length) throw new Error("Avro union \u5206\u652F\u7D22\u5F15\u65E0\u6548\u3002");
        return $08414ea58bdc1292$var$readAvroDatum(bytes, branch.offset, end, branchType);
    }
    if (type && typeof type === "object") {
        const typed = type;
        return $08414ea58bdc1292$var$readAvroDatum(bytes, offset, end, typed.type);
    }
    if (type === "null") return {
        value: null,
        offset: offset
    };
    if (type === "boolean") {
        if (offset >= end) throw new Error("Avro boolean \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        return {
            value: bytes[offset] !== 0,
            offset: offset + 1
        };
    }
    if (type === "int" || type === "long") {
        const value = $08414ea58bdc1292$var$readAvroLong(bytes, offset);
        return {
            value: Number(value.value),
            offset: value.offset
        };
    }
    if (type === "float") {
        if (offset + 4 > end) throw new Error("Avro float \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        return {
            value: new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getFloat32(offset, true),
            offset: offset + 4
        };
    }
    if (type === "double") {
        if (offset + 8 > end) throw new Error("Avro double \u6570\u636E\u4E0D\u5B8C\u6574\u3002");
        return {
            value: new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getFloat64(offset, true),
            offset: offset + 8
        };
    }
    if (type === "string") {
        const value = $08414ea58bdc1292$var$readAvroBytes(bytes, offset);
        if (value.offset > end) throw new Error("Avro string \u8D85\u51FA block \u8FB9\u754C\u3002");
        return {
            value: new TextDecoder().decode(value.value),
            offset: value.offset
        };
    }
    if (type === "bytes") {
        const value = $08414ea58bdc1292$var$readAvroBytes(bytes, offset);
        if (value.offset > end) throw new Error("Avro bytes \u8D85\u51FA block \u8FB9\u754C\u3002");
        return {
            value: `<bytes ${value.value.length} B>`,
            offset: value.offset
        };
    }
    throw new Error(`\u6682\u4E0D\u652F\u6301 Avro \u5B57\u6BB5\u7C7B\u578B ${$08414ea58bdc1292$var$formatAvroType(type)}\u3002`);
}
function $08414ea58bdc1292$var$matchesBytes(bytes, offset, expected) {
    for(let index = 0; index < expected.length; index++){
        if (bytes[offset + index] !== expected[index]) return false;
    }
    return true;
}
function $08414ea58bdc1292$var$createAvroRecordPreview(records) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-avro-records";
    const title = document.createElement("strong");
    title.textContent = `\u8BB0\u5F55\u62BD\u6837 ${records.rows.length}`;
    wrapper.append(title);
    if (records.note) {
        const note = document.createElement("p");
        note.className = "ofv-data-note";
        note.textContent = records.note;
        wrapper.append(note);
    }
    if (records.rows.length === 0) return wrapper;
    const table = document.createElement("table");
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");
    for (const field of records.fields){
        const th = document.createElement("th");
        th.textContent = field;
        headRow.append(th);
    }
    thead.append(headRow);
    const tbody = document.createElement("tbody");
    for (const row of records.rows){
        const tr = document.createElement("tr");
        for (const value of row){
            const td = document.createElement("td");
            td.textContent = value === null ? "NULL" : String(value);
            tr.append(td);
        }
        tbody.append(tr);
    }
    table.append(thead, tbody);
    wrapper.append(table);
    return wrapper;
}
function $08414ea58bdc1292$var$formatAvroType(type) {
    if (typeof type === "string") return type;
    if (Array.isArray(type)) return type.map($08414ea58bdc1292$var$formatAvroType).join(" | ");
    if (type && typeof type === "object") {
        const value = type;
        if (typeof value.name === "string") return value.name;
        if (value.type === "array") return `array<${$08414ea58bdc1292$var$formatAvroType(value.items)}>`;
        if (value.type === "map") return `map<${$08414ea58bdc1292$var$formatAvroType(value.values)}>`;
        return $08414ea58bdc1292$var$formatAvroType(value.type);
    }
    return "unknown";
}
function $08414ea58bdc1292$var$createKeyValueTable(titleText, rows) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-data-kv";
    const title = document.createElement("strong");
    title.textContent = titleText;
    const table = document.createElement("table");
    const tbody = document.createElement("tbody");
    for (const row of rows.slice(0, 80)){
        const tr = document.createElement("tr");
        const key = document.createElement("th");
        key.textContent = row.key;
        const value = document.createElement("td");
        value.textContent = row.value;
        tr.append(key, value);
        tbody.append(tr);
    }
    table.append(tbody);
    wrapper.append(title, table);
    return wrapper;
}
function $08414ea58bdc1292$var$createWebArchivePreview(bytes) {
    const preview = document.createElement("div");
    preview.className = "ofv-data-preview ofv-webarchive-preview";
    const heading = document.createElement("strong");
    heading.textContent = "WebArchive \u7ED3\u6784";
    preview.append(heading);
    const parsed = $08414ea58bdc1292$var$parseWebArchive(bytes);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = parsed.error || "\u4E0D\u662F\u6709\u6548\u7684 WebArchive plist\u3002";
        preview.append(error);
        return preview;
    }
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u683C\u5F0F", parsed.binary ? "Binary plist" : "XML plist");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u4E3B\u8D44\u6E90", parsed.url || "\u672A\u58F0\u660E");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "MIME", parsed.mimeType || "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u7F16\u7801", parsed.encoding || "\u672A\u58F0\u660E");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u4E3B\u8D44\u6E90\u5927\u5C0F", parsed.mainBytes !== void 0 ? $08414ea58bdc1292$var$formatBytes4(parsed.mainBytes) : "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5B50\u8D44\u6E90", String(parsed.subresources ?? 0));
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u5B50\u5F52\u6863", String(parsed.subframeArchives ?? 0));
    $08414ea58bdc1292$var$hideSupplementalInfo8(summary);
    preview.append(summary);
    if (parsed.binary) {
        const note = document.createElement("p");
        note.className = "ofv-data-note";
        note.textContent = parsed.snippet ? "\u5DF2\u5728\u6D4F\u89C8\u5668\u7AEF\u89E3\u6790 binary plist WebArchive\uFF0C\u5E76\u5C55\u5F00\u4E3B\u8D44\u6E90\u6458\u8981\u3002" : "\u5DF2\u8BC6\u522B binary plist WebArchive\uFF1B\u5F53\u524D\u6587\u4EF6\u672A\u63D0\u53D6\u5230\u53EF\u5C55\u793A\u7684\u4E3B\u8D44\u6E90\u7247\u6BB5\u3002";
        $08414ea58bdc1292$var$hideSupplementalInfo8(note);
        preview.append(note);
    }
    if (parsed.snippet) {
        $08414ea58bdc1292$var$hideSupplementalInfo8(heading);
        const snippet = document.createElement("pre");
        snippet.className = "ofv-text-block ofv-webarchive-snippet";
        snippet.textContent = parsed.snippet;
        preview.append(snippet);
    }
    return preview;
}
function $08414ea58bdc1292$var$parseWebArchive(bytes) {
    if (bytes.length >= 8 && $08414ea58bdc1292$var$asciiAt3(bytes, 0, 8) === "bplist00") return $08414ea58bdc1292$var$parseBinaryWebArchive(bytes);
    const text = new TextDecoder("utf-8", {
        fatal: false
    }).decode(bytes.slice(0, Math.min(bytes.length, 1048576)));
    if (!/<plist[\s>]/i.test(text) || !text.includes("WebMainResource")) return {
        valid: false,
        error: "\u7F3A\u5C11 XML plist \u6216 WebMainResource \u6807\u8BB0\u3002"
    };
    if (typeof DOMParser === "undefined") return {
        valid: false,
        error: "\u5F53\u524D\u73AF\u5883\u7F3A\u5C11 DOMParser\uFF0C\u65E0\u6CD5\u89E3\u6790 XML WebArchive\u3002"
    };
    const documentXml = new DOMParser().parseFromString(text, "application/xml");
    if (documentXml.querySelector("parsererror")) return {
        valid: false,
        error: "XML plist \u89E3\u6790\u5931\u8D25\u3002"
    };
    const rootDict = Array.from(documentXml.documentElement.children).find((child)=>child.tagName === "dict");
    if (!rootDict) return {
        valid: false,
        error: "XML plist \u7F3A\u5C11\u6839 dict\u3002"
    };
    const plist = $08414ea58bdc1292$var$parsePlistElement(rootDict);
    if (!$08414ea58bdc1292$var$isPlistDict(plist)) return {
        valid: false,
        error: "XML plist \u6839\u8282\u70B9\u4E0D\u662F dict\u3002"
    };
    return $08414ea58bdc1292$var$webArchivePreviewFromPlist(plist);
}
function $08414ea58bdc1292$var$parseBinaryWebArchive(bytes) {
    const plist = $08414ea58bdc1292$var$parseBinaryPlist(bytes);
    if (!plist.valid) return {
        valid: true,
        binary: true,
        error: plist.error
    };
    if (!$08414ea58bdc1292$var$isPlistDict(plist.value)) return {
        valid: true,
        binary: true,
        error: "Binary plist \u6839\u8282\u70B9\u4E0D\u662F dict\u3002"
    };
    return $08414ea58bdc1292$var$webArchivePreviewFromPlist(plist.value, true);
}
function $08414ea58bdc1292$var$webArchivePreviewFromPlist(plist, binary = false) {
    const mainResource = plist.WebMainResource;
    if (!$08414ea58bdc1292$var$isPlistDict(mainResource)) return {
        valid: false,
        binary: binary,
        error: "WebArchive \u7F3A\u5C11 WebMainResource dict\u3002"
    };
    const resourceData = mainResource.WebResourceData;
    const mimeType = $08414ea58bdc1292$var$plistString(mainResource.WebResourceMIMEType);
    const mainBytes = resourceData instanceof Uint8Array ? resourceData.length : void 0;
    return {
        valid: true,
        binary: binary,
        url: $08414ea58bdc1292$var$plistString(mainResource.WebResourceURL),
        mimeType: mimeType,
        encoding: $08414ea58bdc1292$var$plistString(mainResource.WebResourceTextEncodingName),
        mainBytes: mainBytes,
        subresources: Array.isArray(plist.WebSubresources) ? plist.WebSubresources.length : 0,
        subframeArchives: Array.isArray(plist.WebSubframeArchives) ? plist.WebSubframeArchives.length : 0,
        snippet: $08414ea58bdc1292$var$createWebArchiveSnippet(resourceData, mimeType)
    };
}
function $08414ea58bdc1292$var$parsePlistElement(element) {
    switch(element.tagName){
        case "dict":
            {
                const result = {};
                const children = Array.from(element.children);
                for(let index = 0; index < children.length; index++){
                    const key = children[index];
                    if (key.tagName !== "key") continue;
                    const value = children[index + 1];
                    if (value) {
                        result[key.textContent || ""] = $08414ea58bdc1292$var$parsePlistElement(value);
                        index++;
                    }
                }
                return result;
            }
        case "array":
            return Array.from(element.children).map($08414ea58bdc1292$var$parsePlistElement);
        case "data":
            return $08414ea58bdc1292$var$decodeBase64Data(element.textContent || "");
        case "integer":
        case "real":
            return Number(element.textContent || 0);
        case "true":
            return true;
        case "false":
            return false;
        case "string":
        case "date":
        default:
            return element.textContent || "";
    }
}
function $08414ea58bdc1292$var$parseBinaryPlist(bytes) {
    try {
        if (bytes.length < 40 || $08414ea58bdc1292$var$asciiAt3(bytes, 0, 8) !== "bplist00") return {
            valid: false,
            error: "\u7F3A\u5C11 bplist00 \u6587\u4EF6\u5934\u3002"
        };
        const trailer = bytes.length - 32;
        const offsetIntSize = bytes[trailer + 6];
        const objectRefSize = bytes[trailer + 7];
        const objectCount = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, trailer + 8, 8);
        const topObject = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, trailer + 16, 8);
        const offsetTableOffset = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, trailer + 24, 8);
        if (offsetIntSize <= 0 || objectRefSize <= 0 || objectCount <= 0 || topObject < 0 || topObject >= objectCount || offsetTableOffset + objectCount * offsetIntSize > trailer) return {
            valid: false,
            error: "Binary plist trailer \u6216 offset table \u5F02\u5E38\u3002"
        };
        const offsets = [];
        for(let index = 0; index < objectCount; index++)offsets.push($08414ea58bdc1292$var$readBinaryPlistInt(bytes, offsetTableOffset + index * offsetIntSize, offsetIntSize));
        const seen = /* @__PURE__ */ new Set();
        return {
            valid: true,
            value: $08414ea58bdc1292$var$readBinaryPlistObject(bytes, offsets, topObject, objectRefSize, seen)
        };
    } catch (error) {
        return {
            valid: false,
            error: error instanceof Error ? error.message : "Binary plist \u89E3\u6790\u5931\u8D25\u3002"
        };
    }
}
function $08414ea58bdc1292$var$readBinaryPlistObject(bytes, offsets, index, objectRefSize, seen) {
    const offset = offsets[index];
    if (offset === void 0 || offset < 0 || offset >= bytes.length) throw new Error(`Binary plist object #${index} \u504F\u79FB\u5F02\u5E38\u3002`);
    if (seen.has(index)) throw new Error(`Binary plist object #${index} \u5B58\u5728\u5FAA\u73AF\u5F15\u7528\u3002`);
    seen.add(index);
    const marker = bytes[offset];
    const type = marker >> 4;
    const info = marker & 15;
    const payloadOffset = offset + 1;
    if (type === 0) {
        seen.delete(index);
        if (info === 8) return false;
        if (info === 9) return true;
        return null;
    }
    if (type === 1) {
        const value = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, payloadOffset, 1 << info);
        seen.delete(index);
        return value;
    }
    if (type === 4) {
        const lengthInfo = $08414ea58bdc1292$var$readBinaryPlistLength(bytes, offset, info);
        const length = lengthInfo.length;
        const start = lengthInfo.offset;
        seen.delete(index);
        return bytes.slice(start, start + length);
    }
    if (type === 5 || type === 6) {
        const lengthInfo = $08414ea58bdc1292$var$readBinaryPlistLength(bytes, offset, info);
        const width = type === 6 ? 2 : 1;
        const data = bytes.slice(lengthInfo.offset, lengthInfo.offset + lengthInfo.length * width);
        seen.delete(index);
        return type === 6 ? $08414ea58bdc1292$var$decodeBinaryPlistUtf16Be(data) : new TextDecoder("utf-8", {
            fatal: false
        }).decode(data);
    }
    if (type === 3) {
        const seconds = $08414ea58bdc1292$var$readBinaryPlistFloat64(bytes, payloadOffset);
        seen.delete(index);
        return new Date(Date.UTC(2001, 0, 1) + seconds * 1e3).toISOString();
    }
    if (type === 10 || type === 12) {
        const lengthInfo = $08414ea58bdc1292$var$readBinaryPlistLength(bytes, offset, info);
        const values = [];
        for(let item = 0; item < lengthInfo.length; item++){
            const ref = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, lengthInfo.offset + item * objectRefSize, objectRefSize);
            values.push($08414ea58bdc1292$var$readBinaryPlistObject(bytes, offsets, ref, objectRefSize, new Set(seen)));
        }
        seen.delete(index);
        return values;
    }
    if (type === 13) {
        const lengthInfo = $08414ea58bdc1292$var$readBinaryPlistLength(bytes, offset, info);
        const keyRefsStart = lengthInfo.offset;
        const valueRefsStart = keyRefsStart + lengthInfo.length * objectRefSize;
        const result = {};
        for(let item = 0; item < lengthInfo.length; item++){
            const keyRef = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, keyRefsStart + item * objectRefSize, objectRefSize);
            const valueRef = $08414ea58bdc1292$var$readBinaryPlistInt(bytes, valueRefsStart + item * objectRefSize, objectRefSize);
            const key = $08414ea58bdc1292$var$readBinaryPlistObject(bytes, offsets, keyRef, objectRefSize, new Set(seen));
            if (typeof key === "string") result[key] = $08414ea58bdc1292$var$readBinaryPlistObject(bytes, offsets, valueRef, objectRefSize, new Set(seen));
        }
        seen.delete(index);
        return result;
    }
    seen.delete(index);
    return null;
}
function $08414ea58bdc1292$var$readBinaryPlistLength(bytes, objectOffset, info) {
    if (info < 15) return {
        length: info,
        offset: objectOffset + 1
    };
    const marker = bytes[objectOffset + 1];
    if (marker >> 4 !== 1) throw new Error("Binary plist extended length \u7F3A\u5C11\u6574\u6570\u5BF9\u8C61\u3002");
    const intSize = 1 << (marker & 15);
    return {
        length: $08414ea58bdc1292$var$readBinaryPlistInt(bytes, objectOffset + 2, intSize),
        offset: objectOffset + 2 + intSize
    };
}
function $08414ea58bdc1292$var$readBinaryPlistInt(bytes, offset, length) {
    if (offset < 0 || offset + length > bytes.length || length <= 0 || length > 8) throw new Error("Binary plist integer \u8D85\u51FA\u6587\u4EF6\u8303\u56F4\u3002");
    let value = 0;
    for(let index = 0; index < length; index++)value = value * 256 + bytes[offset + index];
    return value;
}
function $08414ea58bdc1292$var$readBinaryPlistFloat64(bytes, offset) {
    if (offset + 8 > bytes.length) throw new Error("Binary plist date \u8D85\u51FA\u6587\u4EF6\u8303\u56F4\u3002");
    return new DataView(bytes.buffer, bytes.byteOffset + offset, 8).getFloat64(0, false);
}
function $08414ea58bdc1292$var$decodeBinaryPlistUtf16Be(bytes) {
    let value = "";
    for(let index = 0; index + 1 < bytes.length; index += 2)value += String.fromCharCode(bytes[index] << 8 | bytes[index + 1]);
    return value;
}
function $08414ea58bdc1292$var$decodeBase64Data(value) {
    const normalized = value.replace(/\s+/g, "");
    if (!normalized) return new Uint8Array();
    const binary = atob(normalized);
    const bytes = new Uint8Array(binary.length);
    for(let index = 0; index < binary.length; index++)bytes[index] = binary.charCodeAt(index);
    return bytes;
}
function $08414ea58bdc1292$var$createWebArchiveSnippet(value, mimeType) {
    if (!(value instanceof Uint8Array) || value.length === 0) return void 0;
    if (!mimeType || !/^(text\/|application\/(xhtml\+xml|xml|json)|image\/svg\+xml)/i.test(mimeType)) return void 0;
    const text = new TextDecoder("utf-8", {
        fatal: false
    }).decode(value);
    return text.replace(/\s+/g, " ").trim().slice(0, 1600);
}
function $08414ea58bdc1292$var$isPlistDict(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value) && !(value instanceof Uint8Array);
}
function $08414ea58bdc1292$var$plistString(value) {
    return typeof value === "string" ? value : void 0;
}
function $08414ea58bdc1292$var$asciiAt3(bytes, offset, length) {
    if (offset < 0 || offset + length > bytes.length) return "";
    return new TextDecoder("ascii").decode(bytes.slice(offset, offset + length));
}
async function $08414ea58bdc1292$var$createPostScriptPreview(bytes, url, fileName, size, fit, toolbar) {
    const parsed = $08414ea58bdc1292$var$parsePostScript(bytes);
    if (parsed.valid && parsed.pdfCompatible) {
        const embedded = await $08414ea58bdc1292$var$createPdfCompatibleAiPreview(bytes, url, fileName, size, fit, toolbar, parsed.pdfOffset || 0);
        return {
            element: embedded.element,
            instance: embedded.instance,
            primaryRendered: true
        };
    }
    const preview = document.createElement("div");
    preview.className = "ofv-data-preview";
    const heading = document.createElement("strong");
    heading.textContent = "PostScript \u7ED3\u6784";
    preview.append(heading);
    if (!parsed.valid) {
        const error = document.createElement("p");
        error.className = "ofv-data-error";
        error.textContent = parsed.error || "\u4E0D\u662F\u6709\u6548\u7684 PostScript/Illustrator \u6587\u6863\u5934\u3002";
        preview.append(error);
        return {
            element: preview
        };
    }
    const summary = document.createElement("div");
    summary.className = "ofv-data-summary";
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "\u683C\u5F0F", parsed.format || "PostScript");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Title", parsed.title || "\u672A\u58F0\u660E");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Creator", parsed.creator || "\u672A\u58F0\u660E");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Pages", parsed.pages || "\u672A\u77E5");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "BoundingBox", parsed.boundingBox || "\u672A\u58F0\u660E");
    (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Created", parsed.creationDate || "\u672A\u58F0\u660E");
    if (parsed.documentData) (0, $3438a2478d5b847f$export$83ddf0c409009c3c)(summary, "Data", parsed.documentData);
    preview.append(summary);
    return {
        element: preview
    };
}
async function $08414ea58bdc1292$var$createPdfCompatibleAiPreview(bytes, url, fileName, size, fit, toolbar, pdfOffset = 0, zoom = 1) {
    const wrapper = document.createElement("div");
    wrapper.className = "ofv-ai-pdf-preview";
    let pdfUrl = url;
    let shouldRevokePdfUrl = false;
    if (pdfOffset > 0) {
        pdfUrl = (0, $3438a2478d5b847f$export$191fa6957fae12db)({
            blob: new Blob([
                bytes.slice(pdfOffset)
            ], {
                type: "application/pdf"
            })
        });
        shouldRevokePdfUrl = true;
    }
    const instance = await (0, $3438a2478d5b847f$export$b882f3782d993632)({
        fileName: fileName,
        fileUrl: pdfUrl,
        viewport: wrapper,
        size: size,
        fit: fit,
        zoom: zoom,
        toolbar: toolbar,
        fallbackTitle: "AI PDF \u517C\u5BB9\u9884\u89C8\u5931\u8D25",
        revokeUrlOnDestroy: false
    });
    $08414ea58bdc1292$var$hideSuccessfulPdfCompatibleAiDiagnostics(wrapper);
    return {
        element: wrapper,
        instance: {
            goToPage (page) {
                return instance.goToPage?.(page) ?? false;
            },
            canCommand (command) {
                return instance.canCommand(command);
            },
            command (command) {
                return instance.command(command);
            },
            preparePrint () {
                return instance.preparePrint?.();
            },
            resize (size2) {
                instance.resize(size2);
            },
            destroy () {
                instance.destroy();
                if (shouldRevokePdfUrl) (0, $3438a2478d5b847f$export$7438c4986c08186f)(pdfUrl, false);
            }
        }
    };
}
function $08414ea58bdc1292$var$hideSuccessfulPdfCompatibleAiDiagnostics(wrapper) {
    if (!wrapper.querySelector(".ofv-pdf-page-wrapper")) return;
    for (const element of wrapper.querySelectorAll(".ofv-pdf-summary"))$08414ea58bdc1292$var$hideSupplementalInfo8(element);
}
function $08414ea58bdc1292$var$parsePostScript(bytes) {
    const pdfOffset = $08414ea58bdc1292$var$findPdfHeaderOffset(bytes);
    const head = new TextDecoder("latin1").decode(bytes.slice(pdfOffset >= 0 ? pdfOffset : 0, Math.min(bytes.length, (pdfOffset >= 0 ? pdfOffset : 0) + 8192)));
    const firstLine = head.split(/\r?\n/, 1)[0] || "";
    const isPdfCompatible = firstLine.startsWith("%PDF-");
    const isPostScript = firstLine.startsWith("%!");
    if (!isPdfCompatible && !isPostScript) return {
        valid: false,
        error: "\u7F3A\u5C11 PostScript %! \u6216 PDF-compatible %PDF \u6587\u4EF6\u5934\u3002"
    };
    const boundingBox = $08414ea58bdc1292$var$dscValue(head, "BoundingBox") || $08414ea58bdc1292$var$dscValue(head, "HiResBoundingBox");
    return {
        valid: true,
        pdfCompatible: isPdfCompatible,
        pdfOffset: isPdfCompatible ? Math.max(0, pdfOffset) : void 0,
        format: isPdfCompatible ? `PDF-compatible Illustrator (${firstLine.replace(/^%/, "")})` : firstLine.replace(/^%!/, "PostScript "),
        title: $08414ea58bdc1292$var$dscValue(head, "Title"),
        creator: $08414ea58bdc1292$var$dscValue(head, "Creator") || $08414ea58bdc1292$var$dscValue(head, "For"),
        creationDate: $08414ea58bdc1292$var$dscValue(head, "CreationDate"),
        pages: $08414ea58bdc1292$var$dscValue(head, "Pages"),
        boundingBox: $08414ea58bdc1292$var$normalizeBoundingBox(boundingBox),
        documentData: $08414ea58bdc1292$var$dscValue(head, "DocumentData")
    };
}
function $08414ea58bdc1292$var$findPdfHeaderOffset(bytes) {
    const max = Math.min(bytes.length - 4, 1048576);
    for(let index = 0; index <= max; index += 1){
        if (bytes[index] === 37 && bytes[index + 1] === 80 && bytes[index + 2] === 68 && bytes[index + 3] === 70 && bytes[index + 4] === 45) return index;
    }
    return -1;
}
function $08414ea58bdc1292$var$dscValue(text, key) {
    const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = text.match(new RegExp(`^%%${escaped}:\\s*(.+)$`, "im"));
    return match?.[1]?.trim();
}
function $08414ea58bdc1292$var$normalizeBoundingBox(value) {
    if (!value) return void 0;
    const parts = value.trim().split(/\s+/).map((part)=>Number(part));
    if (parts.length < 4 || parts.some((part)=>!Number.isFinite(part))) return value;
    const [x1, y1, x2, y2] = parts;
    return `${x1}, ${y1}, ${x2}, ${y2} (${Math.max(0, x2 - x1)} x ${Math.max(0, y2 - y1)} pt)`;
}
function $08414ea58bdc1292$var$createHexPreview(bytes) {
    if (bytes.length === 0) return null;
    const pre = document.createElement("pre");
    pre.className = "ofv-text-block ofv-asset-hex";
    pre.textContent = $08414ea58bdc1292$var$hexPreview2(bytes);
    return pre;
}
function $08414ea58bdc1292$var$shouldShowHexPreview(extension, hasPrimaryPreview = false) {
    return !hasPrimaryPreview && ![
        "ai",
        "eps",
        "ps"
    ].includes(extension);
}
function $08414ea58bdc1292$var$hideSuccessfulSectionHeading4(section) {
    const heading = section.querySelector("h3");
    if (heading) $08414ea58bdc1292$var$hideSupplementalInfo8(heading);
}
function $08414ea58bdc1292$var$hideSuccessfulAssetDiagnostics(panel) {
    const hasPrimaryPreview = Boolean(panel.querySelector(".ofv-ai-pdf-preview .ofv-pdf-page-wrapper, .ofv-psd-canvas, .ofv-font-preview, .ofv-wasm-preview, .ofv-sqlite-data, .ofv-parquet-records, .ofv-avro-records, .ofv-webarchive-snippet"));
    if (!hasPrimaryPreview) return;
    for (const element of panel.querySelectorAll(".ofv-section > h3, .ofv-asset-summary, .ofv-asset-download, .ofv-asset-hex, .ofv-data-preview, .ofv-pdf-summary"))$08414ea58bdc1292$var$hideSupplementalInfo8(element);
}
function $08414ea58bdc1292$var$hideSupplementalInfo8(element) {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    element.style.display = "none";
}
function $08414ea58bdc1292$var$formatBytes4(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
function $08414ea58bdc1292$var$byteSignature3(bytes) {
    if (bytes.length === 0) return "\u7A7A\u6587\u4EF6";
    const ascii = new TextDecoder("ascii").decode(bytes.slice(0, Math.min(bytes.length, 16))).replace(/[^\x20-\x7E]/g, ".");
    const hex = Array.from(bytes.slice(0, Math.min(bytes.length, 8))).map((byte)=>byte.toString(16).padStart(2, "0").toUpperCase()).join(" ");
    return `${ascii} (${hex})`;
}
function $08414ea58bdc1292$var$hexPreview2(bytes) {
    const rows = [];
    const limit = Math.min(bytes.length, 256);
    for(let offset = 0; offset < limit; offset += 16){
        const slice = bytes.slice(offset, offset + 16);
        const hex = Array.from(slice).map((byte)=>byte.toString(16).padStart(2, "0").toUpperCase()).join(" ").padEnd(47, " ");
        const ascii = Array.from(slice).map((byte)=>byte >= 32 && byte <= 126 ? String.fromCharCode(byte) : ".").join("");
        rows.push(`${offset.toString(16).padStart(8, "0").toUpperCase()}  ${hex}  ${ascii}`);
    }
    if (bytes.length > limit) rows.push(`... \u4EC5\u5C55\u793A\u524D ${limit} \u5B57\u8282\uFF0C\u5171 ${bytes.length} \u5B57\u8282`);
    return rows.join("\n");
}



// src/index.tsx


var $ibUU1 = parcelRequire("ibUU1");


var $5E6i4 = parcelRequire("5E6i4");

function $f2ac491e08952419$export$58049487f2bbdc53({ className: className, style: style, width: width = "100%", height: height = "600px", renderToolbar: renderToolbar, ...options }) {
    const containerRef = (0, $5E6i4.useRef)(null);
    const viewerRef = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useEffect)(()=>{
        if (!containerRef.current) return;
        let toolbarRoot = null;
        let toolbarMount = null;
        let latestToolbarContext = null;
        let toolbarRenderQueued = false;
        const renderReactToolbar = ()=>{
            toolbarRenderQueued = false;
            const ctx = latestToolbarContext;
            if (!ctx || !toolbarRoot || !renderToolbar) return;
            const toolbarContent = renderToolbar(ctx);
            (0, $ibUU1.flushSync)(()=>{
                toolbarRoot?.render(toolbarContent);
            });
        };
        const toolbar = renderToolbar === void 0 ? options.toolbar : {
            ...typeof options.toolbar === "object" ? options.toolbar : {},
            render (ctx) {
                if (!toolbarMount) {
                    toolbarMount = document.createElement("div");
                    toolbarMount.className = "ofv-react-toolbar";
                    toolbarRoot = (0, $3b51c8a0c5045117$exports.createRoot)(toolbarMount);
                }
                latestToolbarContext = ctx;
                if (!toolbarRenderQueued) {
                    toolbarRenderQueued = true;
                    queueMicrotask(renderReactToolbar);
                }
                return toolbarMount;
            }
        };
        viewerRef.current?.destroy();
        viewerRef.current = (0, $3438a2478d5b847f$export$a7848d518678d667)({
            ...options,
            container: containerRef.current,
            width: width,
            height: height,
            className: className,
            toolbar: toolbar
        });
        return ()=>{
            const root = toolbarRoot;
            toolbarRoot = null;
            toolbarMount = null;
            latestToolbarContext = null;
            toolbarRenderQueued = false;
            viewerRef.current?.destroy();
            viewerRef.current = null;
            if (root) queueMicrotask(()=>root.unmount());
        };
    }, [
        options.file,
        options.files,
        options.initialIndex,
        options.initialPage,
        options.fileName,
        options.mimeType,
        options.fit,
        options.zoom,
        options.plugins,
        options.fallback,
        options.locale,
        options.messages,
        options.renderFallback,
        options.toolbar,
        renderToolbar,
        options.theme,
        options.onLoad,
        options.onError,
        options.onUnsupported,
        className,
        width,
        height
    ]);
    return /* @__PURE__ */ (0, $90cae257cc958273$exports.jsx)("div", {
        ref: containerRef,
        className: className,
        style: style
    });
}



var $0c466509ec224990$exports = {};
$0c466509ec224990$exports = import.meta.resolve("51YC4");


const $9c105840a236ffec$var$workerSrc = new URL($0c466509ec224990$exports) + '';
const $9c105840a236ffec$var$plugins = [
    (0, $3438a2478d5b847f$export$aa676a29a960505)(),
    (0, $08414ea58bdc1292$export$9be06fe47280e9b4)(),
    (0, $3438a2478d5b847f$export$902b3d19cdcfa5d5)({
        workerSrc: $9c105840a236ffec$var$workerSrc,
        useFetchData: true
    }),
    (0, $08414ea58bdc1292$export$e6d7427d8e3dcbbe)()
];
const $9c105840a236ffec$export$72e4c5c1c0102f6d = ({ file: file, onClose: onClose })=>(0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039), {
        show: !!file,
        onHide: onClose,
        children: (0, $90cae257cc958273$exports.jsx)((0, $96a8772939a28a36$export$2e2bcd8739ae039).Body, {
            children: file && (0, $90cae257cc958273$exports.jsx)((0, $f2ac491e08952419$export$58049487f2bbdc53), {
                plugins: $9c105840a236ffec$var$plugins,
                theme: "auto",
                width: "100%",
                height: "100%",
                fit: "contain",
                file: file
            })
        })
    });
$9c105840a236ffec$export$72e4c5c1c0102f6d.displayName = 'FileView';



var $eYgAi = parcelRequire("eYgAi");



var $90MBA = parcelRequire("90MBA");

var $5pSp9 = parcelRequire("5pSp9");
function $c4994241939d8038$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c4994241939d8038$var$$d2c94808ccfae153$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$d2c94808ccfae153$exports, "githubClient", function() {
    return $c4994241939d8038$export$660e113192f74c8f;
});
const $c4994241939d8038$export$660e113192f74c8f = new (0, $eYgAi.HTTPClient)({
    baseURI: 'https://api.github.com',
    responseType: 'json'
});
var $c4994241939d8038$var$$e6ce8158e203b92f$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$e6ce8158e203b92f$exports, "UserModel", function() {
    return $c4994241939d8038$export$621c2e9225361608;
});
var $c4994241939d8038$var$$59c6fc29dfdfac1b$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$59c6fc29dfdfac1b$exports, "OrganizationModel", function() {
    return $c4994241939d8038$export$28c8139b720f2aa8;
});
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await(v);
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $c4994241939d8038$export$28c8139b720f2aa8 = (()=>{
    var _a;
    let _classSuper = (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class OrganizationModel extends _classSuper {
        constructor(user = ''){
            super();
            Object.defineProperty(this, "user", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$59c6fc29dfdfac1b$var$__runInitializers(this, _instanceExtraInitializers), user)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c4994241939d8038$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'orgs'
            });
        }
        openStream() {
            return $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var _b;
                var per_page = this.pageSize, since, count = 0;
                const baseURI = this.user ? `users/${this.user}/` : '';
                for(let page = 1;; page++){
                    const { body: body } = yield $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await(this.client.get(`${baseURI}orgs?${(0, $90MBA.buildURLData)({
                        per_page: per_page,
                        page: page,
                        since: since
                    })}`));
                    if (!body[0]) break;
                    since = (_b = body.at(-1)) === null || _b === void 0 ? void 0 : _b.id;
                    count += body.length;
                    yield $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__await((yield* $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncDelegator($c4994241939d8038$var$$59c6fc29dfdfac1b$var$__asyncValues(body))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        getOne(name) {
            const _super = Object.create(null, {
                getOne: {
                    get: ()=>super.getOne
                }
            });
            return $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__awaiter(this, void 0, void 0, function*() {
                return this.currentOne.login === name ? this.currentOne : _super.getOne.call(this, name);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c4994241939d8038$var$$59c6fc29dfdfac1b$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $c4994241939d8038$var$$e6ce8158e203b92f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$e6ce8158e203b92f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$e6ce8158e203b92f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$e6ce8158e203b92f$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c4994241939d8038$var$$e6ce8158e203b92f$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $c4994241939d8038$export$621c2e9225361608 = (()=>{
    var _a, _UserModel_session_accessor_storage;
    let _classSuper = (0, $fccfef6af501b9ae$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _session_decorators;
    let _session_initializers = [];
    let _session_extraInitializers = [];
    let _get_organizationStore_decorators;
    let _get_namespaces_decorators;
    let _getSession_decorators;
    return _a = class UserModel extends _classSuper {
        get session() {
            return $c4994241939d8038$var$$e6ce8158e203b92f$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
        }
        set session(value) {
            $c4994241939d8038$var$$e6ce8158e203b92f$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
        }
        get organizationStore() {
            var _b;
            return new $c4994241939d8038$export$28c8139b720f2aa8((_b = this.session) === null || _b === void 0 ? void 0 : _b.login);
        }
        get namespaces() {
            return [
                this.session,
                ...this.organizationStore.allItems
            ].filter(Boolean);
        }
        getSession() {
            return $c4994241939d8038$var$$e6ce8158e203b92f$var$__awaiter(this, void 0, void 0, function*() {
                if (this.session) return this.session;
                const { body: body } = yield this.client.get('user');
                this.session = body;
                yield this.organizationStore.getAll();
                return body;
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$e6ce8158e203b92f$var$__runInitializers(this, _instanceExtraInitializers), $c4994241939d8038$export$660e113192f74c8f)
            });
            _UserModel_session_accessor_storage.set(this, $c4994241939d8038$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_initializers, void 0));
            $c4994241939d8038$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_extraInitializers);
        }
    }, _UserModel_session_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _session_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_organizationStore_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _get_namespaces_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _getSession_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c4994241939d8038$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: (obj)=>"session" in obj,
                get: (obj)=>obj.session,
                set: (obj, value)=>{
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        $c4994241939d8038$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_organizationStore_decorators, {
            kind: "getter",
            name: "organizationStore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"organizationStore" in obj,
                get: (obj)=>obj.organizationStore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c4994241939d8038$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_namespaces_decorators, {
            kind: "getter",
            name: "namespaces",
            static: false,
            private: false,
            access: {
                has: (obj)=>"namespaces" in obj,
                get: (obj)=>obj.namespaces
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c4994241939d8038$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _getSession_decorators, {
            kind: "method",
            name: "getSession",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getSession" in obj,
                get: (obj)=>obj.getSession
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $c4994241939d8038$var$$d3130a010a88f771$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$d3130a010a88f771$exports, "RepositoryModel", function() {
    return $c4994241939d8038$export$e2c4c3b5712a2495;
});
var $c4994241939d8038$var$$dfa451c8fd878073$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$dfa451c8fd878073$exports, "ContributorModel", function() {
    return $c4994241939d8038$export$ebe1058377a924a;
});
var $c4994241939d8038$var$$dfa451c8fd878073$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$dfa451c8fd878073$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$dfa451c8fd878073$var$__await(v);
};
var $c4994241939d8038$var$$dfa451c8fd878073$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$dfa451c8fd878073$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$dfa451c8fd878073$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $c4994241939d8038$var$$dfa451c8fd878073$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$dfa451c8fd878073$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $c4994241939d8038$export$ebe1058377a924a extends (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/contributors`;
    }
    openStream(filter) {
        return $c4994241939d8038$var$$dfa451c8fd878073$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $c4994241939d8038$var$$dfa451c8fd878073$var$__await(client.get(`${baseURI}?${(0, $90MBA.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $c4994241939d8038$var$$dfa451c8fd878073$var$__await((yield* $c4994241939d8038$var$$dfa451c8fd878073$var$__asyncDelegator($c4994241939d8038$var$$dfa451c8fd878073$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $c4994241939d8038$var$$e610a99570571b98$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$e610a99570571b98$exports, "IssueModel", function() {
    return $c4994241939d8038$export$5f96977bde248fb7;
});
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$e610a99570571b98$exports, "IssueCommentModel", function() {
    return $c4994241939d8038$export$3bba9992a4d664e6;
});
var $c4994241939d8038$var$$985c3e5be67a4078$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$985c3e5be67a4078$exports, "PullRequestModel", function() {
    return $c4994241939d8038$export$8b5593d82c2e1a5;
});
var $c4994241939d8038$var$$985c3e5be67a4078$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$985c3e5be67a4078$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$985c3e5be67a4078$var$__await(v);
};
var $c4994241939d8038$var$$985c3e5be67a4078$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$985c3e5be67a4078$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$985c3e5be67a4078$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $c4994241939d8038$var$$985c3e5be67a4078$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$985c3e5be67a4078$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $c4994241939d8038$export$8b5593d82c2e1a5 extends (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/pulls`;
    }
    openStream(filter) {
        return $c4994241939d8038$var$$985c3e5be67a4078$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $c4994241939d8038$var$$985c3e5be67a4078$var$__await(client.get(`${baseURI}?${(0, $90MBA.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $c4994241939d8038$var$$985c3e5be67a4078$var$__await((yield* $c4994241939d8038$var$$985c3e5be67a4078$var$__asyncDelegator($c4994241939d8038$var$$985c3e5be67a4078$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $c4994241939d8038$var$$e610a99570571b98$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$e610a99570571b98$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$e610a99570571b98$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$e610a99570571b98$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$e610a99570571b98$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$e610a99570571b98$var$__await(v);
};
var $c4994241939d8038$var$$e610a99570571b98$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$e610a99570571b98$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$e610a99570571b98$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $c4994241939d8038$var$$e610a99570571b98$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$e610a99570571b98$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $c4994241939d8038$var$$e610a99570571b98$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $c4994241939d8038$export$5f96977bde248fb7 = (()=>{
    var _a;
    let _classSuper = (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _assignOneToCopilot_decorators;
    let _getLinkedPRs_decorators;
    return _a = class IssueModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$e610a99570571b98$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c4994241939d8038$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/issues`;
        }
        openStream(filter) {
            return $c4994241939d8038$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var per_page = this.pageSize, count = 0;
                for(let page = 1;; page++){
                    const { body: body } = yield $c4994241939d8038$var$$e610a99570571b98$var$__await(this.client.get(`${this.baseURI}?${(0, $90MBA.buildURLData)(Object.assign({
                        per_page: per_page,
                        page: page
                    }, filter))}`));
                    const list = body.filter(({ pull_request: pull_request })=>!pull_request);
                    if (!body[0]) break;
                    count += list.length;
                    yield $c4994241939d8038$var$$e610a99570571b98$var$__await((yield* $c4994241939d8038$var$$e610a99570571b98$var$__asyncDelegator($c4994241939d8038$var$$e610a99570571b98$var$__asyncValues(list))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        /**
             * Create or update an issue, with support for Copilot assignee
             *
             * @see {@link https://docs.github.com/en/rest/issues/issues#create-an-issue}
             * @see {@link https://docs.github.com/en/rest/issues/issues#update-an-issue}
             */ updateOne(_b, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $c4994241939d8038$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                var { assignees: assignees = [] } = _b, rest = $c4994241939d8038$var$$e610a99570571b98$var$__rest(_b, [
                    "assignees"
                ]);
                const assigneeList = assignees;
                const humanAssignees = assigneeList.filter((login)=>login !== 'copilot-swe-agent');
                const hasCopilotAssignee = assigneeList.length !== humanAssignees.length;
                const issueData = Object.assign(Object.assign({}, rest), humanAssignees && {
                    assignees: humanAssignees
                });
                const issue = yield _super.updateOne.call(this, issueData, id);
                if (hasCopilotAssignee) yield this.assignOneToCopilot(issue);
                return issue;
            });
        }
        /**
             * Assign Copilot bot to an issue using GitHub GraphQL API
             *
             * @see {@link https://docs.github.com/en/copilot/how-tos/use-copilot-agents/coding-agent/create-a-pr#assigning-an-existing-issue}
             * @see {@link https://github.com/orgs/community/discussions/164267}
             */ assignOneToCopilot(issue) {
            return $c4994241939d8038$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                const getUserQuery = `
            query ($owner: String!, $name: String!) {
                repository(owner: $owner, name: $name) {
                    suggestedActors(
                        loginNames: "copilot"
                        capabilities: [CAN_BE_ASSIGNED]
                        first: 1
                    ) {
                        nodes {
                            login
                            __typename
                            ... on Bot { id }
                        }
                    }
                }
            }`;
                const { body: userResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: getUserQuery,
                    variables: {
                        owner: this.owner,
                        name: this.repository
                    }
                });
                const userId = userResult.data.repository.suggestedActors.nodes[0].id;
                const assignMutation = `
            mutation ($issueId: ID!, $userId: ID!) {
                replaceActorsForAssignable(input: {assignableId: $issueId, actorIds: [$userId]}) {
                    assignable {
                        ... on Issue {
                            id
                            title
                            assignees(first: 10) {
                                nodes { login }
                            }
                        }
                    }
                }
            }`;
                const { body: assignResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: assignMutation,
                    variables: {
                        issueId: issue.id,
                        userId: userId
                    }
                });
                return assignResult;
            });
        }
        /**
             * Get pull requests that close an issue using GraphQL
             *
             * @see {@link https://docs.github.com/en/graphql/reference/objects#pullrequest}
             */ getLinkedPRs(issueNumber_1) {
            return $c4994241939d8038$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const prNumbers = yield this.getLinkedPRNumbers(issueNumber, maxCount);
                const prModel = new $c4994241939d8038$export$8b5593d82c2e1a5(this.owner, this.repository);
                return Promise.all(prNumbers.map((number)=>prModel.getOne(number)));
            });
        }
        getLinkedPRNumbers(issueNumber_1) {
            return $c4994241939d8038$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const query = `
            query ($owner: String!, $name: String!, $number: Int!, $maxCount: Int!) {
                repository(owner: $owner, name: $name) {
                    issue(number: $number) {
                        closedByPullRequestsReferences(first: $maxCount) {
                            nodes {
                                number
                            }
                        }
                    }
                }
            }`;
                const { body: body } = yield this.client.post(`https://api.github.com/graphql`, {
                    query: query,
                    variables: {
                        owner: this.owner,
                        name: this.repository,
                        number: issueNumber,
                        maxCount: maxCount
                    }
                });
                return body.data.repository.issue.closedByPullRequestsReferences.nodes.map(({ number: number })=>number);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _assignOneToCopilot_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('uploading')
        ];
        _getLinkedPRs_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c4994241939d8038$var$$e610a99570571b98$var$__esDecorate(_a, null, _assignOneToCopilot_decorators, {
            kind: "method",
            name: "assignOneToCopilot",
            static: false,
            private: false,
            access: {
                has: (obj)=>"assignOneToCopilot" in obj,
                get: (obj)=>obj.assignOneToCopilot
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c4994241939d8038$var$$e610a99570571b98$var$__esDecorate(_a, null, _getLinkedPRs_decorators, {
            kind: "method",
            name: "getLinkedPRs",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getLinkedPRs" in obj,
                get: (obj)=>obj.getLinkedPRs
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
class $c4994241939d8038$export$3bba9992a4d664e6 extends (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, issue){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "issue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: issue
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/issues/${issue}/comments`;
    }
    openStream(filter) {
        return $c4994241939d8038$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $c4994241939d8038$var$$e610a99570571b98$var$__await(client.get(`${baseURI}?${(0, $90MBA.buildURLData)(Object.assign(Object.assign({}, filter), {
                    per_page: per_page,
                    page: page
                }))}`));
                if (!body[0]) break;
                count += body.length;
                yield $c4994241939d8038$var$$e610a99570571b98$var$__await((yield* $c4994241939d8038$var$$e610a99570571b98$var$__asyncDelegator($c4994241939d8038$var$$e610a99570571b98$var$__asyncValues(body))));
                if (body.length < per_page) break;
            }
            this.totalCount = count;
        });
    }
}
var $c4994241939d8038$var$$d3130a010a88f771$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$d3130a010a88f771$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$d3130a010a88f771$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $c4994241939d8038$export$e2c4c3b5712a2495 = (()=>{
    var _a;
    let _classSuper = (0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3);
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class RepositoryModel extends _classSuper {
        constructor(owner = ''){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$d3130a010a88f771$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c4994241939d8038$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ''
            });
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'full_name'
            });
            Object.defineProperty(this, "organizationStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new $c4994241939d8038$export$28c8139b720f2aa8()
            });
            Object.defineProperty(this, "relation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    contributors: (0, $5pSp9.memoize)((URI)=>$c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const [owner, repository] = URI.split('/');
                            const body = yield new $c4994241939d8038$export$ebe1058377a924a(owner, repository).getAll();
                            return body.sort((a, b)=>b.contributions - a.contributions) || [];
                        })),
                    issues: (0, $5pSp9.memoize)((URI)=>{
                        const [owner, repository] = URI.split('/');
                        return new $c4994241939d8038$export$5f96977bde248fb7(owner, repository).getAll();
                    }),
                    languages: (0, $5pSp9.memoize)((URI)=>$c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const { body: languageCount } = yield this.client.get(`repos/${URI}/languages`);
                            const languageAverage = (0, $90MBA.averageOf)(...Object.values(languageCount));
                            const languageList = Object.entries(languageCount).filter(([_, score])=>score >= languageAverage).sort(([_, a], [__, b])=>b - a);
                            return languageList.map(([name])=>name);
                        }))
                }
            });
            this.baseURI = owner ? `orgs/${owner}/repos` : 'user/repos';
        }
        getOneRelation(URI_1) {
            return $c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const relationData = yield Promise.all(relation.map((key)=>$c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        const value = yield this.relation[key](URI);
                        return [
                            key,
                            value
                        ];
                    })));
                return Object.fromEntries(relationData);
            });
        }
        getOne(URI_1) {
            return $c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const { body: body } = yield this.client.get(`repos/${URI}`);
                return this.currentOne = Object.assign(Object.assign({}, body), (yield this.getOneRelation(URI, relation)));
            });
        }
        loadPage(page_1, per_page_1, _b) {
            return $c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(page, per_page, { relation: relation }) {
                const [kind, namespace] = this.baseURI.split('/'), isUser = kind === 'user';
                const { body: list } = yield this.client.get(`${this.baseURI}?${(0, $90MBA.buildURLData)({
                    type: isUser ? 'owner' : 'public',
                    sort: 'pushed',
                    page: page,
                    per_page: per_page
                })}`);
                const pageData = yield Promise.all(list.map((item)=>$c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        return Object.assign(Object.assign({}, item), (yield this.getOneRelation(item.full_name, relation)));
                    })));
                var { totalCount: totalCount } = this;
                if (!this.totalCount) {
                    if (!isUser) ({ public_repos: totalCount } = yield this.organizationStore.getOne(namespace));
                    else {
                        const { body: body } = yield this.client.get('user');
                        totalCount = body.public_repos + (body.total_private_repos || 0);
                    }
                }
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        getAllContributors() {
            return $c4994241939d8038$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                const repositories = yield this.getAll({
                    relation: [
                        'contributors'
                    ]
                });
                const contributors = repositories.filter(({ fork: fork, archived: archived })=>!archived && !fork).flatMap(({ contributors: contributors })=>contributors).filter(({ type: type })=>type === 'User');
                const userGroup = (0, $90MBA.groupBy)(contributors, 'login');
                return Object.entries(userGroup).map(([login, list])=>Object.assign(Object.assign({}, list[0]), {
                        contributions: list.reduce((sum, { contributions: contributions })=>sum + contributions, 0)
                    })).sort((a, b)=>b.contributions - a.contributions);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c4994241939d8038$var$$d3130a010a88f771$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $c4994241939d8038$var$$88356f023569df5f$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$88356f023569df5f$exports, "ContentModel", function() {
    return $c4994241939d8038$export$5b988c733cc838bb;
});
var $c4994241939d8038$var$$88356f023569df5f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$88356f023569df5f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$88356f023569df5f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$88356f023569df5f$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$88356f023569df5f$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$88356f023569df5f$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$88356f023569df5f$var$__await(v);
};
var $c4994241939d8038$var$$88356f023569df5f$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$88356f023569df5f$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $c4994241939d8038$var$$88356f023569df5f$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$88356f023569df5f$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
let $c4994241939d8038$export$5b988c733cc838bb = (()=>{
    var _a;
    let _classSuper = (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    let _updateOne_decorators;
    return _a = class ContentModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$88356f023569df5f$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c4994241939d8038$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/contents`;
        }
        /**
             * Get repository content at a specific path
             *
             * @see {@link https://docs.github.com/en/rest/repos/contents#get-repository-content}
             */ getOne(path) {
            return $c4994241939d8038$var$$88356f023569df5f$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${path}`);
                return Array.isArray(body) ? body[0] : body;
            });
        }
        updateOne(_b, path_1) {
            return $c4994241939d8038$var$$88356f023569df5f$var$__awaiter(this, arguments, void 0, function*({ content: content }, path, message = `[update] ${path}`) {
                try {
                    var { sha: sha } = yield this.getOne(path);
                } catch (_c) {}
                const { body: body } = yield this.client.put(`${this.baseURI}/${path}`, {
                    sha: sha,
                    message: message,
                    content: (0, $90MBA.encodeBase64)(content)
                });
                return body.content;
            });
        }
        openStream(_b) {
            return $c4994241939d8038$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* openStream_1({ path: path, name: name }) {
                var _c, e_1, _d, _e;
                const setCount = (total)=>this.totalCount = total;
                const namePattern = name && new RegExp(name);
                const stream = path ? this.traverseChildren(path, setCount) : this.traverseTree(undefined, setCount);
                try {
                    for(var _f = true, stream_1 = $c4994241939d8038$var$$88356f023569df5f$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $c4994241939d8038$var$$88356f023569df5f$var$__await(stream_1.next()), _c = stream_1_1.done, !_c; _f = true){
                        _e = stream_1_1.value;
                        _f = false;
                        const content = _e;
                        if (!namePattern || namePattern.test(content.name)) yield yield $c4994241939d8038$var$$88356f023569df5f$var$__await(content);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_f && !_c && (_d = stream_1.return)) yield $c4994241939d8038$var$$88356f023569df5f$var$__await(_d.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            });
        }
        /**
             * Get direct children of a directory
             */ traverseChildren() {
            return $c4994241939d8038$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseChildren_1(parentPath = '', onCount = ()=>{}) {
                const { body: body } = yield $c4994241939d8038$var$$88356f023569df5f$var$__await(this.client.get(`${this.baseURI}/${parentPath}`));
                const contents = (0, $90MBA.makeArray)(body);
                onCount(contents.length);
                for (const content of contents){
                    content.parent_path = parentPath;
                    yield yield $c4994241939d8038$var$$88356f023569df5f$var$__await(content);
                }
            });
        }
        /**
             * Recursively traverse the entire file tree
             */ traverseTree(parentContent, onCount) {
            return $c4994241939d8038$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseTree_1() {
                var _b, e_2, _c, _d;
                let totalCount = 0;
                const addCount = (total)=>totalCount += total;
                const stream = this.traverseChildren((parentContent === null || parentContent === void 0 ? void 0 : parentContent.path) || '', addCount);
                try {
                    for(var _e = true, stream_2 = $c4994241939d8038$var$$88356f023569df5f$var$__asyncValues(stream), stream_2_1; stream_2_1 = yield $c4994241939d8038$var$$88356f023569df5f$var$__await(stream_2.next()), _b = stream_2_1.done, !_b; _e = true){
                        _d = stream_2_1.value;
                        _e = false;
                        const content = _d;
                        yield yield $c4994241939d8038$var$$88356f023569df5f$var$__await(content);
                        if (content.type === 'dir') yield $c4994241939d8038$var$$88356f023569df5f$var$__await((yield* $c4994241939d8038$var$$88356f023569df5f$var$__asyncDelegator($c4994241939d8038$var$$88356f023569df5f$var$__asyncValues(this.traverseTree(content, addCount)))));
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_e && !_b && (_c = stream_2.return)) yield $c4994241939d8038$var$$88356f023569df5f$var$__await(_c.call(stream_2));
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                onCount === null || onCount === void 0 || onCount(totalCount);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        _updateOne_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('uploading')
        ];
        $c4994241939d8038$var$$88356f023569df5f$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c4994241939d8038$var$$88356f023569df5f$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $c4994241939d8038$var$$1aed161d42aeaf11$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$1aed161d42aeaf11$exports, "TreeModel", function() {
    return $c4994241939d8038$export$d8e3e4c22ffac9fe;
});
var $c4994241939d8038$var$$1aed161d42aeaf11$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c4994241939d8038$var$$1aed161d42aeaf11$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c4994241939d8038$var$$1aed161d42aeaf11$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$1aed161d42aeaf11$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$1aed161d42aeaf11$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$1aed161d42aeaf11$var$__await(v);
};
var $c4994241939d8038$var$$1aed161d42aeaf11$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$1aed161d42aeaf11$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $c4994241939d8038$export$d8e3e4c22ffac9fe = (()=>{
    var _a;
    let _classSuper = (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class TreeModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c4994241939d8038$var$$1aed161d42aeaf11$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c4994241939d8038$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/git/trees`;
        }
        /**
             * @see {@link https://docs.github.com/en/rest/git/trees#get-a-tree}
             */ getOne() {
            return $c4994241939d8038$var$$1aed161d42aeaf11$var$__awaiter(this, arguments, void 0, function*(treeSHA = 'HEAD', recursive) {
                const { body: body } = yield this.client.get(`${this.baseURI}/${treeSHA}?${(0, $90MBA.buildURLData)({
                    recursive: recursive
                })}`);
                return body;
            });
        }
        openStream(_b) {
            return $c4994241939d8038$var$$1aed161d42aeaf11$var$__asyncGenerator(this, arguments, function* openStream_1({ path: path }) {
                const matchFilter = (item)=>!path || item.path.startsWith(path);
                const root = yield $c4994241939d8038$var$$1aed161d42aeaf11$var$__await(this.getOne('HEAD', true));
                const pathSet = new Set(), treeNodes = [];
                for (const item of root.tree){
                    pathSet.add(item.path);
                    if (item.type === 'tree') treeNodes.push(item);
                    if (matchFilter(item)) yield yield $c4994241939d8038$var$$1aed161d42aeaf11$var$__await(item);
                }
                let totalCount = root.tree.length;
                if (root.truncated) for(let index = 0; index < treeNodes.length; index++){
                    const { path: path, sha: sha } = treeNodes[index];
                    const { tree: tree } = yield $c4994241939d8038$var$$1aed161d42aeaf11$var$__await(this.getOne(sha));
                    for (const item of tree){
                        const fullPath = `${path}/${item.path}`;
                        if (pathSet.has(fullPath)) continue;
                        pathSet.add(fullPath);
                        const node = Object.assign(Object.assign({}, item), {
                            path: fullPath
                        });
                        totalCount += 1;
                        if (matchFilter(node)) yield yield $c4994241939d8038$var$$1aed161d42aeaf11$var$__await(node);
                        if (node.type === 'tree') treeNodes.push(node);
                    }
                }
                this.totalCount = totalCount;
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $fccfef6af501b9ae$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c4994241939d8038$var$$1aed161d42aeaf11$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $c4994241939d8038$var$$8f8defdf9fc6f2e7$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$8f8defdf9fc6f2e7$exports, "DiscussionModel", function() {
    return $c4994241939d8038$export$ea22e9ea45676ee3;
});
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$8f8defdf9fc6f2e7$exports, "DiscussionCommentModel", function() {
    return $c4994241939d8038$export$76e6d9690e198c8f;
});
var $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await = function(v) {
    return this instanceof $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await ? (this.v = v, this) : new $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(v);
};
var $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $c4994241939d8038$export$ea22e9ea45676ee3 extends (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions`;
    }
    openStream(filter) {
        return $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $90MBA.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await((yield* $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
class $c4994241939d8038$export$76e6d9690e198c8f extends (0, $fccfef6af501b9ae$export$6a4eb2e7fc9e8903)((0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, discussion){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "discussion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: discussion
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions/${discussion}/comments`;
    }
    openStream(filter) {
        return $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            const { body: body } = yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(client.get(baseURI.split('/').slice(0, -1).join('/')));
            this.totalCount = body.comments;
            if (!this.totalCount) return yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(void 0);
            for(let page = 1;; page++){
                const { body: body } = yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $90MBA.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                yield $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__await((yield* $c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($c4994241939d8038$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
        });
    }
}
var $c4994241939d8038$var$$131e71a4048073f6$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$131e71a4048073f6$exports, "CheckRunModel", function() {
    return $c4994241939d8038$export$3e1022bc3f07e26a;
});
var $c4994241939d8038$var$$131e71a4048073f6$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$131e71a4048073f6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $c4994241939d8038$export$3e1022bc3f07e26a extends (0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3) {
    constructor(owner, repository, ref){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/commits/${ref}/check-runs`;
    }
    loadPage(page, per_page, _a) {
        return $c4994241939d8038$var$$131e71a4048073f6$var$__awaiter(this, void 0, void 0, function*() {
            var { name: check_name, filter: filter = 'latest' } = _a, restFilter = $c4994241939d8038$var$$131e71a4048073f6$var$__rest(_a, [
                "name",
                "filter"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $90MBA.buildURLData)(Object.assign(Object.assign({
                check_name: check_name,
                filter: filter
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.check_runs,
                totalCount: body.total_count
            };
        });
    }
}
var $c4994241939d8038$var$$0ae0bbd5d9d96cbc$exports = {};
$c4994241939d8038$var$$parcel$export($c4994241939d8038$var$$0ae0bbd5d9d96cbc$exports, "WorkflowRunModel", function() {
    return $c4994241939d8038$export$ba933b122214fc50;
});
var $c4994241939d8038$var$$0ae0bbd5d9d96cbc$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4994241939d8038$var$$0ae0bbd5d9d96cbc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $c4994241939d8038$export$ba933b122214fc50 extends (0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $c4994241939d8038$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/actions/runs`;
    }
    loadPage(page, per_page, _a) {
        return $c4994241939d8038$var$$0ae0bbd5d9d96cbc$var$__awaiter(this, void 0, void 0, function*() {
            var { head_branch: branch, actor: actor } = _a, restFilter = $c4994241939d8038$var$$0ae0bbd5d9d96cbc$var$__rest(_a, [
                "head_branch",
                "actor"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $90MBA.buildURLData)(Object.assign(Object.assign({
                branch: branch,
                actor: actor
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.workflow_runs,
                totalCount: body.total_count
            };
        });
    }
}




var $90MBA = parcelRequire("90MBA");
function $ca5f14402a1c3202$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ca5f14402a1c3202$var$$c6af500b4433b08b$exports = {};
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $ca5f14402a1c3202$export$bf098d6e10b5582a;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $ca5f14402a1c3202$export$6c5d58455f3ab236;
});
var $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ca5f14402a1c3202$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($ca5f14402a1c3202$export$bf098d6e10b5582a || ($ca5f14402a1c3202$export$bf098d6e10b5582a = {}));
let $ca5f14402a1c3202$export$6c5d58455f3ab236 = (()=>{
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    let _instanceExtraInitializers = [];
    let _state_decorators;
    let _state_initializers = [];
    let _state_extraInitializers = [];
    let _get_language_decorators;
    return _a = class SpeechSynthesisModel {
        get state() {
            return $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
        }
        set state(value) {
            $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
        }
        get language() {
            var _b, _c;
            return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
        }
        constructor(i18n){
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ca5f14402a1c3202$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $ca5f14402a1c3202$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    var _b;
                    this.state = $ca5f14402a1c3202$export$bf098d6e10b5582a.Clear;
                    (_b = $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $7c1ccfb859bb0dff$export$7203b476385689ae)(()=>i18n.currentLanguage, this.clear), "f");
            globalThis.addEventListener('unload', this.clear);
        }
        static getVoices() {
            const voices = speechSynthesis.getVoices();
            return voices[0] ? Promise.resolve(voices) : new Promise((resolve)=>{
                (0, $90MBA.sleep)(1).then(()=>resolve([]));
                speechSynthesis.onvoiceschanged = ()=>resolve(speechSynthesis.getVoices());
            });
        }
        speak(text) {
            return $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function*() {
                const { language: language } = this, content = new SpeechSynthesisUtterance(text), voices = yield _a.getVoices();
                content.voice = voices.find(({ localService: localService, lang: lang })=>localService && lang === language) || voices.find(({ default: backup })=>backup) || null;
                const result = new Promise((resolve, reject)=>{
                    content.onend = resolve;
                    content.onerror = reject;
                });
                speechSynthesis.speak(content);
                this.state = $ca5f14402a1c3202$export$bf098d6e10b5582a.Speaking;
                try {
                    yield result;
                } finally{
                    this.clear();
                }
            });
        }
        toggle() {
            if (this.state === $ca5f14402a1c3202$export$bf098d6e10b5582a.Speaking) {
                speechSynthesis.pause();
                this.state = $ca5f14402a1c3202$export$bf098d6e10b5582a.Pause;
            } else {
                speechSynthesis.resume();
                this.state = $ca5f14402a1c3202$export$bf098d6e10b5582a.Speaking;
            }
        }
        static *walk(range) {
            const { commonAncestorContainer: commonAncestorContainer, endContainer: endContainer } = range;
            const walker = document.createNodeIterator(commonAncestorContainer);
            var current;
            while(current = walker.nextNode()){
                if (range.intersectsNode(current)) yield current;
                if (commonAncestorContainer !== endContainer && current === endContainer) break;
            }
        }
        static getSelectedText(box) {
            var _b;
            const range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
            if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError('No text selected');
            return [
                ...this.walk(range)
            ].filter(({ nodeType: nodeType, parentNode: parentNode })=>{
                if (nodeType !== 3) return;
                const { width: width, height: height } = parentNode.getBoundingClientRect();
                return width && height;
            }).map(({ nodeValue: nodeValue }, index, { length: length })=>nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity)).filter((text)=>text === null || text === void 0 ? void 0 : text.trim()).join('').trim();
        }
        static getReadableText(box) {
            try {
                return this.getSelectedText(box);
            } catch (_b) {
                return box ? (0, $90MBA.getVisibleText)(box) : '';
            }
        }
    }, _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_language_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: (obj)=>"state" in obj,
                get: (obj)=>obj.state,
                set: (obj, value)=>{
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $ca5f14402a1c3202$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$exports = {};
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $ca5f14402a1c3202$export$d91823dfc159395b;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$exports, "loadLanguageMap", function() {
    return $ca5f14402a1c3202$export$745e12634107cb52;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$exports, "loadLanguageMapFrom", function() {
    return $ca5f14402a1c3202$export$b9f85f5ba933b8e7;
});
var $ca5f14402a1c3202$var$$552a56cc5ff3f479$exports = {};
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$552a56cc5ff3f479$exports, "encodeFunctions", function() {
    return $ca5f14402a1c3202$export$daf6e0a3009d4bc2;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$552a56cc5ff3f479$exports, "decodeFunctions", function() {
    return $ca5f14402a1c3202$export$db9b408b8fc131fa;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $ca5f14402a1c3202$export$df0b442c7f8df5c1;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $ca5f14402a1c3202$export$d977f7cd0cb45fe1;
});
$ca5f14402a1c3202$var$$parcel$export($ca5f14402a1c3202$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $ca5f14402a1c3202$export$2557e81a557a81ea;
});
const $ca5f14402a1c3202$var$$552a56cc5ff3f479$var$FUNCTION_MARKER = '__serializedFunction__';
const $ca5f14402a1c3202$export$daf6e0a3009d4bc2 = (_key, value)=>typeof value === 'function' ? {
        [$ca5f14402a1c3202$var$$552a56cc5ff3f479$var$FUNCTION_MARKER]: value + ''
    } : value && typeof value === 'object' ? (0, $7c1ccfb859bb0dff$export$f08965dd1304d490)(value) : value;
const $ca5f14402a1c3202$var$$552a56cc5ff3f479$var$isSerializedFunctionNode = (value)=>!!value && typeof value === 'object' && $ca5f14402a1c3202$var$$552a56cc5ff3f479$var$FUNCTION_MARKER in value && typeof value[$ca5f14402a1c3202$var$$552a56cc5ff3f479$var$FUNCTION_MARKER] === 'string';
const $ca5f14402a1c3202$var$$552a56cc5ff3f479$var$reviveFunction = (source)=>{
    const factory = Function('"use strict"; return (' + source + ');');
    const instance = factory();
    if (typeof instance !== 'function') throw new TypeError('Serialized source does not evaluate to a function.');
    return instance;
};
const $ca5f14402a1c3202$export$db9b408b8fc131fa = (_key, value)=>$ca5f14402a1c3202$var$$552a56cc5ff3f479$var$isSerializedFunctionNode(value) ? $ca5f14402a1c3202$var$$552a56cc5ff3f479$var$reviveFunction(value[$ca5f14402a1c3202$var$$552a56cc5ff3f479$var$FUNCTION_MARKER]) : value;
const $ca5f14402a1c3202$export$df0b442c7f8df5c1 = (raw = '')=>new RegExp('\\p{N}', 'u').test(raw) || new RegExp('\\p{Ll}', 'u').test(raw.toLowerCase());
const $ca5f14402a1c3202$export$d977f7cd0cb45fe1 = (...parts)=>parts.map((raw, index)=>{
        var _a;
        const isNL = $ca5f14402a1c3202$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        const diff = isNL !== $ca5f14402a1c3202$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? ' ' : '');
    }).join('');
const $ca5f14402a1c3202$export$2557e81a557a81ea = (value)=>value.split(',').map((language)=>{
        const [name, quantity = ''] = language.split(';');
        const [_, value = '1'] = quantity.split('=');
        return [
            name.trim(),
            +value
        ];
    }).sort(([_, a], [__, b])=>b - a).map(([name])=>name);
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ca5f14402a1c3202$export$d91823dfc159395b = (()=>{
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _currentMap_decorators;
    let _currentMap_initializers = [];
    let _currentMap_extraInitializers = [];
    let _get_defaultMap_decorators;
    let _loadLanguages_decorators;
    return _a = class TranslationModel {
        get loading() {
            return $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
        }
        set loading(value) {
            $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
        }
        get currentLanguage() {
            return $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
        }
        set currentLanguage(value) {
            $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
        }
        get currentMap() {
            return $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
        }
        set currentMap(value) {
            $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
        }
        get defaultMap() {
            return this.configuration[this.defaultLanguage];
        }
        constructor(configuration){
            var _b;
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers), '')
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ''));
            _TranslationModel_currentMap_accessor_storage.set(this, ($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(const name in configuration)if (typeof configuration[name] !== 'function') this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError('One static language map is required');
            if (!globalThis.window) return;
            const languages = [
                (0, $90MBA.parseCookie)().language,
                document === null || document === void 0 ? void 0 : document.documentElement.lang,
                ...(navigator === null || navigator === void 0 ? void 0 : navigator.languages) || [
                    this.defaultLanguage
                ]
            ].filter(Boolean);
            this.loadLanguages(...languages);
            (_b = window === null || window === void 0 ? void 0 : window.addEventListener) === null || _b === void 0 || _b.call(window, 'languagechange', ()=>this.loadLanguages(navigator.language));
        }
        onLanguageChange(handler) {
            (0, $7c1ccfb859bb0dff$export$7203b476385689ae)(()=>this.currentLanguage, (currentLanguage, lastLanguage)=>{
                if (lastLanguage) handler.call(this, currentLanguage);
            });
        }
        setLanguage(name) {
            var _b;
            this.currentLanguage = name;
            if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $90MBA.setCookie)('language', document.documentElement.lang = name, {
                path: '/'
            });
        }
        loadLanguages(...names) {
            return $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                this.loading = true;
                const { language: language = this.defaultLanguage, languageMap: languageMap = this.configuration[this.defaultLanguage] } = (yield $ca5f14402a1c3202$export$745e12634107cb52(this.configuration, names)) || {};
                this.loading = false;
                this.setLanguage(language);
                return this.currentMap = languageMap;
            });
        }
        textOf(key, data) {
            const value = this.currentMap[key] || this.defaultMap[key];
            if (typeof value !== 'function') return value;
            if (!data) throw ReferenceError('Input data is required for Translation Resolver');
            return value(data);
        }
    }, _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _currentLanguage_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _currentMap_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _get_defaultMap_decorators = [
            (0, $7c1ccfb859bb0dff$export$2983e091f1a1e8e2)
        ];
        _loadLanguages_decorators = [
            (0, $7c1ccfb859bb0dff$export$31eb53bd5b582a97)
        ];
        $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLanguage" in obj,
                get: (obj)=>obj.currentLanguage,
                set: (obj, value)=>{
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentMap" in obj,
                get: (obj)=>obj.currentMap,
                set: (obj, value)=>{
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defaultMap" in obj,
                get: (obj)=>obj.defaultMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loadLanguages_decorators, {
            kind: "method",
            name: "loadLanguages",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadLanguages" in obj,
                get: (obj)=>obj.loadLanguages
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $ca5f14402a1c3202$export$745e12634107cb52 = (configuration, names)=>$ca5f14402a1c3202$var$$d1a4b21e19b1b67c$var$__awaiter(void 0, void 0, void 0, function*() {
        const languages = Object.keys(configuration).sort(({ length: a }, { length: b })=>b - a);
        for (const name of names){
            const language = languages.includes(name) ? name : languages.find((language)=>name.startsWith(language) || language.startsWith(name));
            if (!language) continue;
            try {
                const languageMap = configuration[language];
                if (typeof languageMap !== 'function') return {
                    language: language,
                    languageMap: languageMap
                };
                const { default: data } = yield languageMap();
                configuration[language] = data;
                return {
                    language: language,
                    languageMap: data
                };
            } catch (_a) {}
        }
    });
const $ca5f14402a1c3202$export$b9f85f5ba933b8e7 = (configuration, { 'accept-language': acceptLanguage, cookie: cookie })=>{
    const { language: language } = (0, $90MBA.parseCookie)(cookie || ''), languages = $ca5f14402a1c3202$export$2557e81a557a81ea(acceptLanguage || '');
    return $ca5f14402a1c3202$export$745e12634107cb52(configuration, [
        language,
        ...languages
    ].filter(Boolean));
};




var $90MBA = parcelRequire("90MBA");
var $dfd7507becca9d2e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dfd7507becca9d2e$export$a7357cdd1f0b0168 = new (0, $ca5f14402a1c3202$export$d91823dfc159395b)({
    en_US: {
        load_more: 'Load more',
        no_more: 'No more',
        create: 'Create',
        view: 'View',
        submit: 'Submit',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        total_x_rows: ({ totalCount: totalCount })=>`Total ${totalCount} rows`,
        sure_to_delete_x: ({ keys: keys })=>`Are you sure to delete ${keys.join(', ')}?`
    }
});
const $dfd7507becca9d2e$var$GITHUB_TOKEN = undefined;
(0, $c4994241939d8038$export$660e113192f74c8f).use(({ request: request }, next)=>{
    if ($dfd7507becca9d2e$var$GITHUB_TOKEN) request.headers = Object.assign(Object.assign({}, request.headers), {
        Authorization: `Bearer ${$dfd7507becca9d2e$var$GITHUB_TOKEN}`
    });
    return next();
});
const $dfd7507becca9d2e$export$8701c19c4b8c549b = new (0, $c4994241939d8038$export$e2c4c3b5712a2495)('idea2app');
class $dfd7507becca9d2e$export$e0332d5c839389e4 extends (0, $fccfef6af501b9ae$export$36e5777a1ba4b7c3) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'search/topics'
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $c4994241939d8038$export$660e113192f74c8f)
        });
    }
    loadPage(pageIndex_1, pageSize_1, _a) {
        return $dfd7507becca9d2e$var$__awaiter(this, arguments, void 0, function*(pageIndex, pageSize, { name: name }) {
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $90MBA.buildURLData)({
                q: name,
                page: pageIndex,
                per_page: pageSize
            })}`);
            return {
                pageData: body.items,
                totalCount: body.total_count
            };
        });
    }
}
const $dfd7507becca9d2e$export$1961b36cfed01e87 = new $dfd7507becca9d2e$export$e0332d5c839389e4();





const $fa7c601e62a95bd3$export$5a24d46f71fcd15f = ({ children: children })=>(0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            children,
            (0, $90cae257cc958273$exports.jsx)((0, $717c2fb651d8cbb5$export$2e2bcd8739ae039), {
                className: "my-3",
                body: true,
                children: (0, $90cae257cc958273$exports.jsx)((0, $246b1ea23ab1fccc$export$6c415d1fdae3dfdb), {
                    language: "tsx",
                    children: children
                })
            })
        ]
    });
const $fa7c601e62a95bd3$export$6e2c8f0811a474ce = ({ className: className = '', title: title, children: children })=>(0, $90cae257cc958273$exports.jsxs)("section", {
        className: `border bg-white mt-3 p-3 ${className}`,
        children: [
            (0, $90cae257cc958273$exports.jsx)("h2", {
                className: "h3",
                id: title,
                children: title
            }),
            children
        ]
    });


var $ef44f23880698556$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ef44f23880698556$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ef44f23880698556$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ef44f23880698556$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ef44f23880698556$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ef44f23880698556$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $ef44f23880698556$var$FileViewModel = (()=>{
    var _a, _FileViewModel_currentFile_accessor_storage;
    let _currentFile_decorators;
    let _currentFile_initializers = [];
    let _currentFile_extraInitializers = [];
    return _a = class FileViewModel {
        get currentFile() {
            return $ef44f23880698556$var$__classPrivateFieldGet(this, _FileViewModel_currentFile_accessor_storage, "f");
        }
        set currentFile(value) {
            $ef44f23880698556$var$__classPrivateFieldSet(this, _FileViewModel_currentFile_accessor_storage, value, "f");
        }
        constructor(){
            _FileViewModel_currentFile_accessor_storage.set(this, $ef44f23880698556$var$__runInitializers(this, _currentFile_initializers, void 0));
            $ef44f23880698556$var$__runInitializers(this, _currentFile_extraInitializers);
        }
    }, _FileViewModel_currentFile_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _currentFile_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        $ef44f23880698556$var$__esDecorate(_a, null, _currentFile_decorators, {
            kind: "accessor",
            name: "currentFile",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentFile" in obj,
                get: (obj)=>obj.currentFile,
                set: (obj, value)=>{
                    obj.currentFile = value;
                }
            },
            metadata: _metadata
        }, _currentFile_initializers, _currentFile_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $ef44f23880698556$var$fileViewStore = new $ef44f23880698556$var$FileViewModel();
class $ef44f23880698556$var$MyFileModel extends (0, $39904e2d513e8a93$export$424c8de2e117ab22) {
    upload(file) {
        const _super = Object.create(null, {
            upload: {
                get: ()=>super.upload
            }
        });
        return $ef44f23880698556$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof file === 'string') file = yield (0, $90MBA.blobOf)(file);
            const body = new FormData();
            body.append('file', file);
            const response = yield fetch('https://api.escuelajs.co/api/v1/files/upload', {
                method: 'POST',
                body: body
            });
            const { location: location } = yield response.json();
            return _super.upload.call(this, location);
        });
    }
}
const $ef44f23880698556$var$fileStore = new $ef44f23880698556$var$MyFileModel();
const $ef44f23880698556$var$demoImageSource = `
<svg xmlns="http://www.w3.org/2000/svg" width="320" height="200" viewBox="0 0 320 200">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#0d6efd" />
      <stop offset="1" stop-color="#20c997" />
    </linearGradient>
  </defs>
  <rect width="320" height="200" fill="url(#g)" />
  <circle cx="70" cy="80" r="36" fill="rgba(255,255,255,.35)" />
  <rect x="116" y="56" width="140" height="88" rx="12" fill="rgba(255,255,255,.25)" />
  <text x="160" y="182" text-anchor="middle" font-family="Arial" font-size="20" fill="white">
    MobX RESTful table
  </text>
</svg>
`;
const $ef44f23880698556$var$demoImage = `data:image/svg+xml,${encodeURIComponent($ef44f23880698556$var$demoImageSource)}`;
const $ef44f23880698556$var$filterFields = [
    {
        key: 'full_name',
        renderLabel: 'Repository Name'
    },
    {
        key: 'homepage',
        renderLabel: 'Home Page'
    },
    {
        key: 'language',
        renderLabel: 'Programming Language'
    },
    {
        key: 'topics',
        renderLabel: 'Topic'
    },
    {
        key: 'description',
        renderLabel: 'Description'
    }
];
const $ef44f23880698556$var$columns = [
    {
        key: 'full_name',
        renderHead: 'Repository Name',
        renderBody: ({ html_url: html_url, full_name: full_name })=>(0, $90cae257cc958273$exports.jsx)("a", {
                target: "_blank",
                href: html_url,
                rel: "noreferrer",
                children: full_name
            }),
        required: true,
        minLength: 3,
        invalidMessage: 'Input 3 characters at least'
    },
    {
        key: 'homepage',
        type: 'url',
        renderHead: 'Home Page'
    },
    {
        key: 'language',
        renderHead: 'Programming Language'
    },
    {
        key: 'topics',
        renderHead: 'Topic',
        renderBody: ({ topics: topics })=>(0, $90cae257cc958273$exports.jsx)((0, $9784173a5043df33$export$ef1c4106ceccca63), {
                list: (topics || []).map((text)=>({
                        text: text,
                        link: `https://github.com/topics/${text}`
                    }))
            }),
        renderInput: ({ topics: topics })=>(0, $90cae257cc958273$exports.jsx)((0, $0030ca5ed517ebc4$export$2724f2f2a56ff7fc), {
                translator: (0, $dfd7507becca9d2e$export$a7357cdd1f0b0168),
                store: (0, $dfd7507becca9d2e$export$1961b36cfed01e87),
                labelKey: "name",
                valueKey: "name",
                placeholder: "search GitHub topics",
                multiple: true,
                defaultValue: topics === null || topics === void 0 ? void 0 : topics.map((value)=>({
                        value: value,
                        label: value
                    }))
            })
    },
    {
        key: 'stargazers_count',
        type: 'number',
        renderHead: 'Star Count'
    },
    {
        key: 'description',
        renderHead: 'Description',
        rows: 3
    }
];
const $ef44f23880698556$export$7c6e2c02157bb7d2 = (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)(()=>(0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            (0, $90cae257cc958273$exports.jsx)("h1", {
                children: "MobX RESTful table examples"
            }),
            (0, $90cae257cc958273$exports.jsxs)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Form Field",
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $8952f8f68509b392$export$56e87bf42978147a), {
                            label: "Input"
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $8952f8f68509b392$export$56e87bf42978147a), {
                            label: "Text Area",
                            as: "textarea",
                            rows: 3
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $8952f8f68509b392$export$56e87bf42978147a), {
                            label: "Select",
                            options: [
                                {
                                    value: 'idea2app'
                                },
                                {
                                    value: 'WebCell'
                                }
                            ],
                            defaultValue: "WebCell"
                        })
                    })
                ]
            }),
            (0, $90cae257cc958273$exports.jsxs)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Badge Input",
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $efbee1975352f32e$export$76834b0602c89bd), {
                            placeholder: "type some words, then press Enter key to add it",
                            onChange: console.log
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $efbee1975352f32e$export$76834b0602c89bd), {
                            placeholder: "type some words, then press Enter key to add it",
                            defaultValue: [
                                'JavaScript',
                                'TypeScript'
                            ],
                            onChange: console.log
                        })
                    })
                ]
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Searchable Input",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $0030ca5ed517ebc4$export$2724f2f2a56ff7fc), {
                        translator: (0, $dfd7507becca9d2e$export$a7357cdd1f0b0168),
                        fields: [
                            {
                                key: 'name'
                            }
                        ],
                        store: (0, $dfd7507becca9d2e$export$1961b36cfed01e87),
                        labelKey: "name",
                        valueKey: "name",
                        placeholder: "search GitHub topics",
                        multiple: true,
                        onChange: console.log
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Range Input",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $cb70d0e9e34a3088$export$f5603a09670563b9), {
                        min: 0,
                        max: 5,
                        icon: (value)=>value ? "\u2605" : "\u2606",
                        onChange: console.log
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Array Field",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $f1219760c77b4e86$export$42efeba470be9198), {
                        name: "prices",
                        renderItem: ({ currency: currency, amount: amount })=>(0, $90cae257cc958273$exports.jsxs)((0, $915d79f60ae535f6$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $90cae257cc958273$exports.jsxs)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Select, {
                                        name: "currency",
                                        defaultValue: currency,
                                        children: [
                                            (0, $90cae257cc958273$exports.jsx)("option", {
                                                value: "USD",
                                                children: "USD $"
                                            }),
                                            (0, $90cae257cc958273$exports.jsx)("option", {
                                                value: "CNY",
                                                children: "CNY \u00A5"
                                            })
                                        ]
                                    }),
                                    (0, $90cae257cc958273$exports.jsx)((0, $feacaa078f2a172d$export$2e2bcd8739ae039).Control, {
                                        placeholder: "Amount",
                                        type: "number",
                                        name: "amount",
                                        required: true,
                                        min: 0,
                                        defaultValue: amount
                                    })
                                ]
                            }),
                        onChange: console.log
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "Image Preview",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $a1ff59d56cac60f5$export$4a96334d5925dbf2), {
                        src: $ef44f23880698556$var$demoImage
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsxs)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "File Preview",
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $c3e520f711d060ed$export$a127194569a41afb), {
                            path: $ef44f23880698556$var$demoImage
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $c3e520f711d060ed$export$a127194569a41afb), {
                            path: "https://idea2app.github.io/MobX-RESTful-table/index.html"
                        })
                    })
                ]
            }),
            (0, $90cae257cc958273$exports.jsxs)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "File Picker",
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $62eeafa9ec804a03$export$54dc470bcc5c41d1), {
                            accept: "image/*",
                            onChange: console.log
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: (0, $90cae257cc958273$exports.jsx)((0, $62eeafa9ec804a03$export$54dc470bcc5c41d1), {
                            accept: "image/*",
                            defaultValue: $ef44f23880698556$var$demoImage,
                            onChange: console.log
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsxs)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                        children: [
                            (0, $90cae257cc958273$exports.jsx)((0, $62eeafa9ec804a03$export$54dc470bcc5c41d1), {
                                defaultValue: $ef44f23880698556$var$demoImage,
                                onView: ({ file: file })=>file instanceof File && ($ef44f23880698556$var$fileViewStore.currentFile = file)
                            }),
                            (0, $90cae257cc958273$exports.jsx)((0, $9c105840a236ffec$export$72e4c5c1c0102f6d), {
                                file: $ef44f23880698556$var$fileViewStore.currentFile,
                                onClose: ()=>$ef44f23880698556$var$fileViewStore.currentFile = undefined
                            })
                        ]
                    })
                ]
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "File Uploader",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $39904e2d513e8a93$export$1a5cb5295a7d2749), {
                        accept: "image/*",
                        store: $ef44f23880698556$var$fileStore,
                        multiple: true,
                        defaultValue: [
                            $ef44f23880698556$var$demoImage
                        ],
                        onChange: console.log
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "REST form",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $f8df7fe8a4125ccd$export$341e3470805a945e), {
                        translator: (0, $dfd7507becca9d2e$export$a7357cdd1f0b0168),
                        store: (0, $dfd7507becca9d2e$export$8701c19c4b8c549b),
                        fields: $ef44f23880698556$var$columns.map((_a)=>{
                            var { renderHead: renderHead, renderBody: renderBody } = _a, meta = $ef44f23880698556$var$__rest(_a, [
                                "renderHead",
                                "renderBody"
                            ]);
                            return Object.assign(Object.assign({}, meta), {
                                renderLabel: renderHead
                            });
                        })
                    })
                })
            }),
            (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                title: "REST table",
                children: (0, $90cae257cc958273$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                    children: (0, $90cae257cc958273$exports.jsx)((0, $c51ce0f384b28c9c$export$fd90441354a7d816), {
                        striped: true,
                        hover: true,
                        editable: true,
                        deletable: true,
                        filterFields: $ef44f23880698556$var$filterFields,
                        columns: $ef44f23880698556$var$columns,
                        store: (0, $dfd7507becca9d2e$export$8701c19c4b8c549b),
                        translator: (0, $dfd7507becca9d2e$export$a7357cdd1f0b0168),
                        onCheck: console.log
                    })
                })
            })
        ]
    }));


var $23547c5d26526fed$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23547c5d26526fed$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23547c5d26526fed$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23547c5d26526fed$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23547c5d26526fed$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
(0, $7c1ccfb859bb0dff$export$8d21e34596265fa2)({
    enforceActions: 'never'
});
let $23547c5d26526fed$export$86fbec116b87613f = (()=>{
    var _App_screenPortrait_accessor_storage, _App_menuOpen_accessor_storage;
    let _classDecorators = [
        (0, $ec7f1f2561223481$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $5E6i4.Component);
    let _screenPortrait_decorators;
    let _screenPortrait_initializers = [];
    let _screenPortrait_extraInitializers = [];
    let _menuOpen_decorators;
    let _menuOpen_initializers = [];
    let _menuOpen_extraInitializers = [];
    var App = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _App_screenPortrait_accessor_storage.set(this, $23547c5d26526fed$var$__runInitializers(this, _screenPortrait_initializers, false));
            _App_menuOpen_accessor_storage.set(this, ($23547c5d26526fed$var$__runInitializers(this, _screenPortrait_extraInitializers), $23547c5d26526fed$var$__runInitializers(this, _menuOpen_initializers, false)));
            Object.defineProperty(this, "updateMeta", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23547c5d26526fed$var$__runInitializers(this, _menuOpen_extraInitializers), ()=>this.screenPortrait = window.innerWidth < 768)
            });
        }
        componentDidMount() {
            this.updateMeta();
            window.addEventListener('resize', this.updateMeta);
        }
        get screenPortrait() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_screenPortrait_accessor_storage, "f");
        }
        set screenPortrait(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_screenPortrait_accessor_storage, value, "f");
        }
        get menuOpen() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_menuOpen_accessor_storage, "f");
        }
        set menuOpen(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_menuOpen_accessor_storage, value, "f");
        }
        renderMenu() {
            const { screenPortrait: screenPortrait, menuOpen: menuOpen } = this;
            return (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    (0, $90cae257cc958273$exports.jsx)((0, $2c5bfbee0161ddfe$export$2e2bcd8739ae039), {
                        className: "my-3 d-md-none",
                        onClick: ()=>this.menuOpen = !menuOpen,
                        children: (0, $90cae257cc958273$exports.jsx)((0, $246b1ea23ab1fccc$export$f04a61298a47a40f), {
                            name: "list"
                        })
                    }),
                    (0, $90cae257cc958273$exports.jsx)((0, $ed96abbe88710bc8$export$2e2bcd8739ae039), {
                        in: screenPortrait ? menuOpen : true,
                        children: (0, $90cae257cc958273$exports.jsx)("div", {
                            className: "sticky-top",
                            children: (0, $90cae257cc958273$exports.jsx)((0, $246b1ea23ab1fccc$export$f24150b9675a2c65), {
                                onClick: ()=>screenPortrait && (this.menuOpen = false)
                            })
                        })
                    })
                ]
            });
        }
        render() {
            return (0, $90cae257cc958273$exports.jsx)((0, $4b6b7ad0160000bf$export$2e2bcd8739ae039), {
                className: "pb-3 py-md-5",
                fluid: "md",
                children: (0, $90cae257cc958273$exports.jsxs)((0, $b822ff2b087e0e91$export$2e2bcd8739ae039), {
                    children: [
                        (0, $90cae257cc958273$exports.jsx)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 3,
                            className: "sticky-top bg-light",
                            children: this.renderMenu()
                        }),
                        (0, $90cae257cc958273$exports.jsx)((0, $22c47d6847a3139f$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 9,
                            children: (0, $90cae257cc958273$exports.jsx)((0, $ef44f23880698556$export$7c6e2c02157bb7d2), {})
                        })
                    ]
                })
            });
        }
    };
    _App_screenPortrait_accessor_storage = new WeakMap();
    _App_menuOpen_accessor_storage = new WeakMap();
    $23547c5d26526fed$var$__setFunctionName(_classThis, "App");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _screenPortrait_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        _menuOpen_decorators = [
            (0, $7c1ccfb859bb0dff$export$5ab46cbf6120b33a)
        ];
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _screenPortrait_decorators, {
            kind: "accessor",
            name: "screenPortrait",
            static: false,
            private: false,
            access: {
                has: (obj)=>"screenPortrait" in obj,
                get: (obj)=>obj.screenPortrait,
                set: (obj, value)=>{
                    obj.screenPortrait = value;
                }
            },
            metadata: _metadata
        }, _screenPortrait_initializers, _screenPortrait_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _menuOpen_decorators, {
            kind: "accessor",
            name: "menuOpen",
            static: false,
            private: false,
            access: {
                has: (obj)=>"menuOpen" in obj,
                get: (obj)=>obj.menuOpen,
                set: (obj, value)=>{
                    obj.menuOpen = value;
                }
            },
            metadata: _metadata
        }, _menuOpen_initializers, _menuOpen_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        App = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23547c5d26526fed$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return App = _classThis;
})();
(0, $3b51c8a0c5045117$exports.createRoot)(document.querySelector('#app')).render((0, $90cae257cc958273$exports.jsx)($23547c5d26526fed$export$86fbec116b87613f, {}));


//# sourceMappingURL=preview.5d192ca5.js.map
